webpackJsonp([4],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLError; });
/* unused harmony export printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_location_mjs__ = __webpack_require__(303);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_printLocation_mjs__ = __webpack_require__(542);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }





/**
 * A GraphQLError describes an Error found during the parse, validate, or
 * execute phases of performing a GraphQL operation. In addition to a message
 * and stack trace, it also includes information about the locations in a
 * GraphQL document and/or execution result that correspond to the Error.
 */

var GraphQLError = /*#__PURE__*/function (_Error) {
  _inherits(GraphQLError, _Error);

  var _super = _createSuper(GraphQLError);

  /**
   * An array of { line, column } locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */

  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */

  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */

  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */

  /**
   * The original error thrown from a field resolver during execution.
   */

  /**
   * Extension fields to add to the formatted error.
   */
  function GraphQLError(message, nodes, source, positions, path, originalError, extensions) {
    var _nodeLocations, _nodeLocations2, _nodeLocations3;

    var _this;

    _classCallCheck(this, GraphQLError);

    _this = _super.call(this, message);
    _this.name = 'GraphQLError';
    _this.originalError = originalError !== null && originalError !== void 0 ? originalError : undefined; // Compute list of blame nodes.

    _this.nodes = undefinedIfEmpty(Array.isArray(nodes) ? nodes : nodes ? [nodes] : undefined);
    var nodeLocations = [];

    for (var _i2 = 0, _ref3 = (_this$nodes = _this.nodes) !== null && _this$nodes !== void 0 ? _this$nodes : []; _i2 < _ref3.length; _i2++) {
      var _this$nodes;

      var _ref4 = _ref3[_i2];
      var loc = _ref4.loc;

      if (loc != null) {
        nodeLocations.push(loc);
      }
    }

    nodeLocations = undefinedIfEmpty(nodeLocations); // Compute locations in the source for the given nodes/positions.

    _this.source = source !== null && source !== void 0 ? source : (_nodeLocations = nodeLocations) === null || _nodeLocations === void 0 ? void 0 : _nodeLocations[0].source;
    _this.positions = positions !== null && positions !== void 0 ? positions : (_nodeLocations2 = nodeLocations) === null || _nodeLocations2 === void 0 ? void 0 : _nodeLocations2.map(function (loc) {
      return loc.start;
    });
    _this.locations = positions && source ? positions.map(function (pos) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__language_location_mjs__["a" /* getLocation */])(source, pos);
    }) : (_nodeLocations3 = nodeLocations) === null || _nodeLocations3 === void 0 ? void 0 : _nodeLocations3.map(function (loc) {
      return Object(__WEBPACK_IMPORTED_MODULE_2__language_location_mjs__["a" /* getLocation */])(loc.source, loc.start);
    });
    _this.path = path !== null && path !== void 0 ? path : undefined;
    var originalExtensions = originalError === null || originalError === void 0 ? void 0 : originalError.extensions;

    if (extensions == null && Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_isObjectLike_mjs__["a" /* default */])(originalExtensions)) {
      _this.extensions = _objectSpread({}, originalExtensions);
    } else {
      _this.extensions = extensions !== null && extensions !== void 0 ? extensions : {};
    } // By being enumerable, JSON.stringify will include bellow properties in the resulting output.
    // This ensures that the simplest possible GraphQL service adheres to the spec.


    Object.defineProperties(_assertThisInitialized(_this), {
      message: {
        enumerable: true
      },
      locations: {
        enumerable: _this.locations != null
      },
      path: {
        enumerable: _this.path != null
      },
      extensions: {
        enumerable: _this.extensions != null && Object.keys(_this.extensions).length > 0
      },
      name: {
        enumerable: false
      },
      nodes: {
        enumerable: false
      },
      source: {
        enumerable: false
      },
      positions: {
        enumerable: false
      },
      originalError: {
        enumerable: false
      }
    }); // Include (non-enumerable) stack trace.

    if (originalError !== null && originalError !== void 0 && originalError.stack) {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: originalError.stack,
        writable: true,
        configurable: true
      });
      return _possibleConstructorReturn(_this);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')


    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_this), GraphQLError);
    } else {
      Object.defineProperty(_assertThisInitialized(_this), 'stack', {
        value: Error().stack,
        writable: true,
        configurable: true
      });
    }

    return _this;
  }

  _createClass(GraphQLError, [{
    key: "toString",
    value: function toString() {
      return printError(this);
    } // FIXME: workaround to not break chai comparisons, should be remove in v16
    // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet

  }, {
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'Object';
    }
  }]);

  return GraphQLError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

function undefinedIfEmpty(array) {
  return array === undefined || array.length === 0 ? undefined : array;
}
/**
 * Prints a GraphQLError to a string, representing useful location information
 * about the error's position in the source.
 */


function printError(error) {
  var output = error.message;

  if (error.nodes) {
    for (var _i4 = 0, _error$nodes2 = error.nodes; _i4 < _error$nodes2.length; _i4++) {
      var node = _error$nodes2[_i4];

      if (node.loc) {
        output += '\n\n' + Object(__WEBPACK_IMPORTED_MODULE_3__language_printLocation_mjs__["a" /* printLocation */])(node.loc);
      }
    }
  } else if (error.source && error.locations) {
    for (var _i6 = 0, _error$locations2 = error.locations; _i6 < _error$locations2.length; _i6++) {
      var location = _error$locations2[_i6];
      output += '\n\n' + Object(__WEBPACK_IMPORTED_MODULE_3__language_printLocation_mjs__["b" /* printSourceLocation */])(error.source, location);
    }
  }

  return output;
}


/***/ }),
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["D"] = isType;
/* unused harmony export assertType */
/* harmony export (immutable) */ __webpack_exports__["C"] = isScalarType;
/* unused harmony export assertScalarType */
/* harmony export (immutable) */ __webpack_exports__["y"] = isObjectType;
/* harmony export (immutable) */ __webpack_exports__["l"] = assertObjectType;
/* harmony export (immutable) */ __webpack_exports__["t"] = isInterfaceType;
/* harmony export (immutable) */ __webpack_exports__["j"] = assertInterfaceType;
/* harmony export (immutable) */ __webpack_exports__["E"] = isUnionType;
/* unused harmony export assertUnionType */
/* harmony export (immutable) */ __webpack_exports__["q"] = isEnumType;
/* unused harmony export assertEnumType */
/* harmony export (immutable) */ __webpack_exports__["r"] = isInputObjectType;
/* unused harmony export assertInputObjectType */
/* harmony export (immutable) */ __webpack_exports__["v"] = isListType;
/* unused harmony export assertListType */
/* harmony export (immutable) */ __webpack_exports__["x"] = isNonNullType;
/* unused harmony export assertNonNullType */
/* harmony export (immutable) */ __webpack_exports__["s"] = isInputType;
/* unused harmony export assertInputType */
/* harmony export (immutable) */ __webpack_exports__["z"] = isOutputType;
/* unused harmony export assertOutputType */
/* harmony export (immutable) */ __webpack_exports__["u"] = isLeafType;
/* unused harmony export assertLeafType */
/* harmony export (immutable) */ __webpack_exports__["p"] = isCompositeType;
/* unused harmony export assertCompositeType */
/* harmony export (immutable) */ __webpack_exports__["o"] = isAbstractType;
/* unused harmony export assertAbstractType */
/* harmony export (immutable) */ __webpack_exports__["d"] = GraphQLList;
/* harmony export (immutable) */ __webpack_exports__["e"] = GraphQLNonNull;
/* unused harmony export isWrappingType */
/* unused harmony export assertWrappingType */
/* unused harmony export isNullableType */
/* harmony export (immutable) */ __webpack_exports__["k"] = assertNullableType;
/* harmony export (immutable) */ __webpack_exports__["n"] = getNullableType;
/* harmony export (immutable) */ __webpack_exports__["w"] = isNamedType;
/* unused harmony export assertNamedType */
/* harmony export (immutable) */ __webpack_exports__["m"] = getNamedType;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return GraphQLScalarType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GraphQLObjectType; });
/* harmony export (immutable) */ __webpack_exports__["i"] = argsToArgsConfig;
/* harmony export (immutable) */ __webpack_exports__["A"] = isRequiredArgument;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLInterfaceType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return GraphQLUnionType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLEnumType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLInputObjectType; });
/* harmony export (immutable) */ __webpack_exports__["B"] = isRequiredInputField;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_mapValue_mjs__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_keyValMap_mjs__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__jsutils_identityFunc_mjs__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utilities_valueFromASTUntyped_mjs__ = __webpack_require__(546);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }



















function isType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type) || isListType(type) || isNonNullType(type);
}
function assertType(type) {
  if (!isType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL type."));
  }

  return type;
}
/**
 * There are predicates for each kind of GraphQL type.
 */

// eslint-disable-next-line no-redeclare
function isScalarType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLScalarType);
}
function assertScalarType(type) {
  if (!isScalarType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Scalar type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isObjectType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLObjectType);
}
function assertObjectType(type) {
  if (!isObjectType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Object type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isInterfaceType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLInterfaceType);
}
function assertInterfaceType(type) {
  if (!isInterfaceType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Interface type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isUnionType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLUnionType);
}
function assertUnionType(type) {
  if (!isUnionType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Union type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isEnumType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLEnumType);
}
function assertEnumType(type) {
  if (!isEnumType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Enum type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isInputObjectType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLInputObjectType);
}
function assertInputObjectType(type) {
  if (!isInputObjectType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Input Object type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isListType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLList);
}
function assertListType(type) {
  if (!isListType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL List type."));
  }

  return type;
}
// eslint-disable-next-line no-redeclare
function isNonNullType(type) {
  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_instanceOf_mjs__["a" /* default */])(type, GraphQLNonNull);
}
function assertNonNullType(type) {
  if (!isNonNullType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL Non-Null type."));
  }

  return type;
}
/**
 * These types may be used as input types for arguments and directives.
 */

function isInputType(type) {
  return isScalarType(type) || isEnumType(type) || isInputObjectType(type) || isWrappingType(type) && isInputType(type.ofType);
}
function assertInputType(type) {
  if (!isInputType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL input type."));
  }

  return type;
}
/**
 * These types may be used as output types as the result of fields.
 */

function isOutputType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isWrappingType(type) && isOutputType(type.ofType);
}
function assertOutputType(type) {
  if (!isOutputType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL output type."));
  }

  return type;
}
/**
 * These types may describe types which may be leaf values.
 */

function isLeafType(type) {
  return isScalarType(type) || isEnumType(type);
}
function assertLeafType(type) {
  if (!isLeafType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL leaf type."));
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isCompositeType(type) {
  return isObjectType(type) || isInterfaceType(type) || isUnionType(type);
}
function assertCompositeType(type) {
  if (!isCompositeType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL composite type."));
  }

  return type;
}
/**
 * These types may describe the parent context of a selection set.
 */

function isAbstractType(type) {
  return isInterfaceType(type) || isUnionType(type);
}
function assertAbstractType(type) {
  if (!isAbstractType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL abstract type."));
  }

  return type;
}
/**
 * List Type Wrapper
 *
 * A list is a wrapping type which points to another type.
 * Lists are often created within the context of defining the fields of
 * an object type.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         parents: { type: new GraphQLList(PersonType) },
 *         children: { type: new GraphQLList(PersonType) },
 *       })
 *     })
 *
 */
// FIXME: workaround to fix issue with Babel parser

/* ::
declare class GraphQLList<+T: GraphQLType> {
  +ofType: T;
  static <T>(ofType: T): GraphQLList<T>;
  // Note: constructors cannot be used for covariant types. Drop the "new".
  constructor(ofType: GraphQLType): void;
}
*/

function GraphQLList(ofType) {
  // istanbul ignore else (to be removed in v16.0.0)
  if (this instanceof GraphQLList) {
    this.ofType = assertType(ofType);
  } else {
    return new GraphQLList(ofType);
  }
} // Need to cast through any to alter the prototype.

GraphQLList.prototype.toString = function toString() {
  return '[' + String(this.ofType) + ']';
};

GraphQLList.prototype.toJSON = function toJSON() {
  return this.toString();
};

Object.defineProperty(GraphQLList.prototype, __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */], {
  get: function get() {
    return 'GraphQLList';
  }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLList);
/**
 * Non-Null Type Wrapper
 *
 * A non-null is a wrapping type which points to another type.
 * Non-null types enforce that their values are never null and can ensure
 * an error is raised if this ever occurs during a request. It is useful for
 * fields which you can make a strong guarantee on non-nullability, for example
 * usually the id field of a database row will never be null.
 *
 * Example:
 *
 *     const RowType = new GraphQLObjectType({
 *       name: 'Row',
 *       fields: () => ({
 *         id: { type: new GraphQLNonNull(GraphQLString) },
 *       })
 *     })
 *
 * Note: the enforcement of non-nullability occurs within the executor.
 */
// FIXME: workaround to fix issue with Babel parser

/* ::
declare class GraphQLNonNull<+T: GraphQLNullableType> {
  +ofType: T;
  static <T>(ofType: T): GraphQLNonNull<T>;
  // Note: constructors cannot be used for covariant types. Drop the "new".
  constructor(ofType: GraphQLType): void;
}
*/

function GraphQLNonNull(ofType) {
  // istanbul ignore else (to be removed in v16.0.0)
  if (this instanceof GraphQLNonNull) {
    this.ofType = assertNullableType(ofType);
  } else {
    return new GraphQLNonNull(ofType);
  }
} // Need to cast through any to alter the prototype.

GraphQLNonNull.prototype.toString = function toString() {
  return String(this.ofType) + '!';
};

GraphQLNonNull.prototype.toJSON = function toJSON() {
  return this.toString();
};

Object.defineProperty(GraphQLNonNull.prototype, __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */], {
  get: function get() {
    return 'GraphQLNonNull';
  }
}); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLNonNull);
/**
 * These types wrap and modify other types
 */

function isWrappingType(type) {
  return isListType(type) || isNonNullType(type);
}
function assertWrappingType(type) {
  if (!isWrappingType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL wrapping type."));
  }

  return type;
}
/**
 * These types can all accept null as a value.
 */

function isNullableType(type) {
  return isType(type) && !isNonNullType(type);
}
function assertNullableType(type) {
  if (!isNullableType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL nullable type."));
  }

  return type;
}
/* eslint-disable no-redeclare */

function getNullableType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    return isNonNullType(type) ? type.ofType : type;
  }
}
/**
 * These named types do not include modifiers like List or NonNull.
 */

function isNamedType(type) {
  return isScalarType(type) || isObjectType(type) || isInterfaceType(type) || isUnionType(type) || isEnumType(type) || isInputObjectType(type);
}
function assertNamedType(type) {
  if (!isNamedType(type)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " to be a GraphQL named type."));
  }

  return type;
}
/* eslint-disable no-redeclare */

function getNamedType(type) {
  /* eslint-enable no-redeclare */
  if (type) {
    var unwrappedType = type;

    while (isWrappingType(unwrappedType)) {
      unwrappedType = unwrappedType.ofType;
    }

    return unwrappedType;
  }
}
/**
 * Used while defining GraphQL types to allow for circular references in
 * otherwise immutable type definitions.
 */

function resolveThunk(thunk) {
  // $FlowFixMe[incompatible-use]
  return typeof thunk === 'function' ? thunk() : thunk;
}

function undefineIfEmpty(arr) {
  return arr && arr.length > 0 ? arr : undefined;
}
/**
 * Scalar Type Definition
 *
 * The leaf values of any request and input values to arguments are
 * Scalars (or Enums) and are defined with a name and a series of functions
 * used to parse input from ast or variables and to ensure validity.
 *
 * If a type's serialize function does not return a value (i.e. it returns
 * `undefined`) then an error will be raised and a `null` value will be returned
 * in the response. If the serialize function returns `null`, then no error will
 * be included in the response.
 *
 * Example:
 *
 *     const OddType = new GraphQLScalarType({
 *       name: 'Odd',
 *       serialize(value) {
 *         if (value % 2 === 1) {
 *           return value;
 *         }
 *       }
 *     });
 *
 */


var GraphQLScalarType = /*#__PURE__*/function () {
  function GraphQLScalarType(config) {
    var _config$parseValue, _config$serialize, _config$parseLiteral;

    var parseValue = (_config$parseValue = config.parseValue) !== null && _config$parseValue !== void 0 ? _config$parseValue : __WEBPACK_IMPORTED_MODULE_11__jsutils_identityFunc_mjs__["a" /* default */];
    this.name = config.name;
    this.description = config.description;
    this.specifiedByUrl = config.specifiedByUrl;
    this.serialize = (_config$serialize = config.serialize) !== null && _config$serialize !== void 0 ? _config$serialize : __WEBPACK_IMPORTED_MODULE_11__jsutils_identityFunc_mjs__["a" /* default */];
    this.parseValue = parseValue;
    this.parseLiteral = (_config$parseLiteral = config.parseLiteral) !== null && _config$parseLiteral !== void 0 ? _config$parseLiteral : function (node, variables) {
      return parseValue(Object(__WEBPACK_IMPORTED_MODULE_17__utilities_valueFromASTUntyped_mjs__["a" /* valueFromASTUntyped */])(node, variables));
    };
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
    config.specifiedByUrl == null || typeof config.specifiedByUrl === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide \"specifiedByUrl\" as a string, ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(config.specifiedByUrl), "."));
    config.serialize == null || typeof config.serialize === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide \"serialize\" function. If this custom Scalar is also used as an input type, ensure \"parseValue\" and \"parseLiteral\" functions are also provided."));

    if (config.parseLiteral) {
      typeof config.parseValue === 'function' && typeof config.parseLiteral === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide both \"parseValue\" and \"parseLiteral\" functions."));
    }
  }

  var _proto = GraphQLScalarType.prototype;

  _proto.toConfig = function toConfig() {
    var _this$extensionASTNod;

    return {
      name: this.name,
      description: this.description,
      specifiedByUrl: this.specifiedByUrl,
      serialize: this.serialize,
      parseValue: this.parseValue,
      parseLiteral: this.parseLiteral,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : []
    };
  };

  _proto.toString = function toString() {
    return this.name;
  };

  _proto.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLScalarType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLScalarType';
    }
  }]);

  return GraphQLScalarType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLScalarType);

/**
 * Object Type Definition
 *
 * Almost all of the GraphQL types you define will be object types. Object types
 * have a name, but most importantly describe their fields.
 *
 * Example:
 *
 *     const AddressType = new GraphQLObjectType({
 *       name: 'Address',
 *       fields: {
 *         street: { type: GraphQLString },
 *         number: { type: GraphQLInt },
 *         formatted: {
 *           type: GraphQLString,
 *           resolve(obj) {
 *             return obj.number + ' ' + obj.street
 *           }
 *         }
 *       }
 *     });
 *
 * When two types need to refer to each other, or a type needs to refer to
 * itself in a field, you can use a function expression (aka a closure or a
 * thunk) to supply the fields lazily.
 *
 * Example:
 *
 *     const PersonType = new GraphQLObjectType({
 *       name: 'Person',
 *       fields: () => ({
 *         name: { type: GraphQLString },
 *         bestFriend: { type: PersonType },
 *       })
 *     });
 *
 */
var GraphQLObjectType = /*#__PURE__*/function () {
  function GraphQLObjectType(config) {
    this.name = config.name;
    this.description = config.description;
    this.isTypeOf = config.isTypeOf;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
    config.isTypeOf == null || typeof config.isTypeOf === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide \"isTypeOf\" as a function, ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(config.isTypeOf), "."));
  }

  var _proto2 = GraphQLObjectType.prototype;

  _proto2.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto2.getInterfaces = function getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  };

  _proto2.toConfig = function toConfig() {
    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      isTypeOf: this.isTypeOf,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: this.extensionASTNodes || []
    };
  };

  _proto2.toString = function toString() {
    return this.name;
  };

  _proto2.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLObjectType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLObjectType';
    }
  }]);

  return GraphQLObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLObjectType);

function defineInterfaces(config) {
  var _resolveThunk;

  var interfaces = (_resolveThunk = resolveThunk(config.interfaces)) !== null && _resolveThunk !== void 0 ? _resolveThunk : [];
  Array.isArray(interfaces) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, " interfaces must be an Array or a function which returns an Array."));
  return interfaces;
}

function defineFieldMap(config) {
  var fieldMap = resolveThunk(config.fields);
  isPlainObj(fieldMap) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
  return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_mapValue_mjs__["a" /* default */])(fieldMap, function (fieldConfig, fieldName) {
    var _fieldConfig$args;

    isPlainObj(fieldConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, ".").concat(fieldName, " field config must be an object."));
    !('isDeprecated' in fieldConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, ".").concat(fieldName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
    fieldConfig.resolve == null || typeof fieldConfig.resolve === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, ".").concat(fieldName, " field resolver must be a function if ") + "provided, but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(fieldConfig.resolve), "."));
    var argsConfig = (_fieldConfig$args = fieldConfig.args) !== null && _fieldConfig$args !== void 0 ? _fieldConfig$args : {};
    isPlainObj(argsConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, ".").concat(fieldName, " args must be an object with argument names as keys."));
    var args = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__["a" /* default */])(argsConfig).map(function (_ref) {
      var argName = _ref[0],
          argConfig = _ref[1];
      return {
        name: argName,
        description: argConfig.description,
        type: argConfig.type,
        defaultValue: argConfig.defaultValue,
        deprecationReason: argConfig.deprecationReason,
        extensions: argConfig.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(argConfig.extensions),
        astNode: argConfig.astNode
      };
    });
    return {
      name: fieldName,
      description: fieldConfig.description,
      type: fieldConfig.type,
      args: args,
      resolve: fieldConfig.resolve,
      subscribe: fieldConfig.subscribe,
      isDeprecated: fieldConfig.deprecationReason != null,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: fieldConfig.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(fieldConfig.extensions),
      astNode: fieldConfig.astNode
    };
  });
}

function isPlainObj(obj) {
  return Object(__WEBPACK_IMPORTED_MODULE_10__jsutils_isObjectLike_mjs__["a" /* default */])(obj) && !Array.isArray(obj);
}

function fieldsToFieldsConfig(fields) {
  return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_mapValue_mjs__["a" /* default */])(fields, function (field) {
    return {
      description: field.description,
      type: field.type,
      args: argsToArgsConfig(field.args),
      resolve: field.resolve,
      subscribe: field.subscribe,
      deprecationReason: field.deprecationReason,
      extensions: field.extensions,
      astNode: field.astNode
    };
  });
}
/**
 * @internal
 */


function argsToArgsConfig(args) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_keyValMap_mjs__["a" /* default */])(args, function (arg) {
    return arg.name;
  }, function (arg) {
    return {
      description: arg.description,
      type: arg.type,
      defaultValue: arg.defaultValue,
      deprecationReason: arg.deprecationReason,
      extensions: arg.extensions,
      astNode: arg.astNode
    };
  });
}
function isRequiredArgument(arg) {
  return isNonNullType(arg.type) && arg.defaultValue === undefined;
}

/**
 * Interface Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Interface type
 * is used to describe what types are possible, what fields are in common across
 * all types, as well as a function to determine which type is actually used
 * when the field is resolved.
 *
 * Example:
 *
 *     const EntityType = new GraphQLInterfaceType({
 *       name: 'Entity',
 *       fields: {
 *         name: { type: GraphQLString }
 *       }
 *     });
 *
 */
var GraphQLInterfaceType = /*#__PURE__*/function () {
  function GraphQLInterfaceType(config) {
    this.name = config.name;
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    this._fields = defineFieldMap.bind(undefined, config);
    this._interfaces = defineInterfaces.bind(undefined, config);
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
    config.resolveType == null || typeof config.resolveType === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(config.resolveType), "."));
  }

  var _proto3 = GraphQLInterfaceType.prototype;

  _proto3.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto3.getInterfaces = function getInterfaces() {
    if (typeof this._interfaces === 'function') {
      this._interfaces = this._interfaces();
    }

    return this._interfaces;
  };

  _proto3.toConfig = function toConfig() {
    var _this$extensionASTNod2;

    return {
      name: this.name,
      description: this.description,
      interfaces: this.getInterfaces(),
      fields: fieldsToFieldsConfig(this.getFields()),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod2 = this.extensionASTNodes) !== null && _this$extensionASTNod2 !== void 0 ? _this$extensionASTNod2 : []
    };
  };

  _proto3.toString = function toString() {
    return this.name;
  };

  _proto3.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLInterfaceType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLInterfaceType';
    }
  }]);

  return GraphQLInterfaceType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLInterfaceType);

/**
 * Union Type Definition
 *
 * When a field can return one of a heterogeneous set of types, a Union type
 * is used to describe what types are possible as well as providing a function
 * to determine which type is actually used when the field is resolved.
 *
 * Example:
 *
 *     const PetType = new GraphQLUnionType({
 *       name: 'Pet',
 *       types: [ DogType, CatType ],
 *       resolveType(value) {
 *         if (value instanceof Dog) {
 *           return DogType;
 *         }
 *         if (value instanceof Cat) {
 *           return CatType;
 *         }
 *       }
 *     });
 *
 */
var GraphQLUnionType = /*#__PURE__*/function () {
  function GraphQLUnionType(config) {
    this.name = config.name;
    this.description = config.description;
    this.resolveType = config.resolveType;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    this._types = defineTypes.bind(undefined, config);
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
    config.resolveType == null || typeof config.resolveType === 'function' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(this.name, " must provide \"resolveType\" as a function, ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(config.resolveType), "."));
  }

  var _proto4 = GraphQLUnionType.prototype;

  _proto4.getTypes = function getTypes() {
    if (typeof this._types === 'function') {
      this._types = this._types();
    }

    return this._types;
  };

  _proto4.toConfig = function toConfig() {
    var _this$extensionASTNod3;

    return {
      name: this.name,
      description: this.description,
      types: this.getTypes(),
      resolveType: this.resolveType,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod3 = this.extensionASTNodes) !== null && _this$extensionASTNod3 !== void 0 ? _this$extensionASTNod3 : []
    };
  };

  _proto4.toString = function toString() {
    return this.name;
  };

  _proto4.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLUnionType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLUnionType';
    }
  }]);

  return GraphQLUnionType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLUnionType);

function defineTypes(config) {
  var types = resolveThunk(config.types);
  Array.isArray(types) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "Must provide Array of types or a function which returns such an array for Union ".concat(config.name, "."));
  return types;
}

/**
 * Enum Type Definition
 *
 * Some leaf values of requests and input values are Enums. GraphQL serializes
 * Enum values as strings, however internally Enums can be represented by any
 * kind of type, often integers.
 *
 * Example:
 *
 *     const RGBType = new GraphQLEnumType({
 *       name: 'RGB',
 *       values: {
 *         RED: { value: 0 },
 *         GREEN: { value: 1 },
 *         BLUE: { value: 2 }
 *       }
 *     });
 *
 * Note: If a value is not provided in a definition, the name of the enum value
 * will be used as its internal value.
 */
var GraphQLEnumType
/* <T> */
= /*#__PURE__*/function () {
  function GraphQLEnumType(config) {
    this.name = config.name;
    this.description = config.description;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    this._values = defineEnumValues(this.name, config.values);
    this._valueLookup = new Map(this._values.map(function (enumValue) {
      return [enumValue.value, enumValue];
    }));
    this._nameLookup = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyMap_mjs__["a" /* default */])(this._values, function (value) {
      return value.name;
    });
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
  }

  var _proto5 = GraphQLEnumType.prototype;

  _proto5.getValues = function getValues() {
    return this._values;
  };

  _proto5.getValue = function getValue(name) {
    return this._nameLookup[name];
  };

  _proto5.serialize = function serialize(outputValue) {
    var enumValue = this._valueLookup.get(outputValue);

    if (enumValue === undefined) {
      throw new __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__["a" /* GraphQLError */]("Enum \"".concat(this.name, "\" cannot represent value: ").concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(outputValue)));
    }

    return enumValue.name;
  };

  _proto5.parseValue = function parseValue(inputValue)
  /* T */
  {
    if (typeof inputValue !== 'string') {
      var valueStr = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue);
      throw new __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__["a" /* GraphQLError */]("Enum \"".concat(this.name, "\" cannot represent non-string value: ").concat(valueStr, ".") + didYouMeanEnumValue(this, valueStr));
    }

    var enumValue = this.getValue(inputValue);

    if (enumValue == null) {
      throw new __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__["a" /* GraphQLError */]("Value \"".concat(inputValue, "\" does not exist in \"").concat(this.name, "\" enum.") + didYouMeanEnumValue(this, inputValue));
    }

    return enumValue.value;
  };

  _proto5.parseLiteral = function parseLiteral(valueNode, _variables)
  /* T */
  {
    // Note: variables will be resolved to a value before calling this function.
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_15__language_kinds_mjs__["a" /* Kind */].ENUM) {
      var valueStr = Object(__WEBPACK_IMPORTED_MODULE_16__language_printer_mjs__["a" /* print */])(valueNode);
      throw new __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__["a" /* GraphQLError */]("Enum \"".concat(this.name, "\" cannot represent non-enum value: ").concat(valueStr, ".") + didYouMeanEnumValue(this, valueStr), valueNode);
    }

    var enumValue = this.getValue(valueNode.value);

    if (enumValue == null) {
      var _valueStr = Object(__WEBPACK_IMPORTED_MODULE_16__language_printer_mjs__["a" /* print */])(valueNode);

      throw new __WEBPACK_IMPORTED_MODULE_14__error_GraphQLError_mjs__["a" /* GraphQLError */]("Value \"".concat(_valueStr, "\" does not exist in \"").concat(this.name, "\" enum.") + didYouMeanEnumValue(this, _valueStr), valueNode);
    }

    return enumValue.value;
  };

  _proto5.toConfig = function toConfig() {
    var _this$extensionASTNod4;

    var values = Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_keyValMap_mjs__["a" /* default */])(this.getValues(), function (value) {
      return value.name;
    }, function (value) {
      return {
        description: value.description,
        value: value.value,
        deprecationReason: value.deprecationReason,
        extensions: value.extensions,
        astNode: value.astNode
      };
    });
    return {
      name: this.name,
      description: this.description,
      values: values,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod4 = this.extensionASTNodes) !== null && _this$extensionASTNod4 !== void 0 ? _this$extensionASTNod4 : []
    };
  };

  _proto5.toString = function toString() {
    return this.name;
  };

  _proto5.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLEnumType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLEnumType';
    }
  }]);

  return GraphQLEnumType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLEnumType);

function didYouMeanEnumValue(enumType, unknownValueStr) {
  var allNames = enumType.getValues().map(function (value) {
    return value.name;
  });
  var suggestedValues = Object(__WEBPACK_IMPORTED_MODULE_13__jsutils_suggestionList_mjs__["a" /* default */])(unknownValueStr, allNames);
  return Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_didYouMean_mjs__["a" /* default */])('the enum value', suggestedValues);
}

function defineEnumValues(typeName, valueMap) {
  isPlainObj(valueMap) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(typeName, " values must be an object with value names as keys."));
  return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__["a" /* default */])(valueMap).map(function (_ref2) {
    var valueName = _ref2[0],
        valueConfig = _ref2[1];
    isPlainObj(valueConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(typeName, ".").concat(valueName, " must refer to an object with a \"value\" key ") + "representing an internal value but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(valueConfig), "."));
    !('isDeprecated' in valueConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(typeName, ".").concat(valueName, " should provide \"deprecationReason\" instead of \"isDeprecated\"."));
    return {
      name: valueName,
      description: valueConfig.description,
      value: valueConfig.value !== undefined ? valueConfig.value : valueName,
      isDeprecated: valueConfig.deprecationReason != null,
      deprecationReason: valueConfig.deprecationReason,
      extensions: valueConfig.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(valueConfig.extensions),
      astNode: valueConfig.astNode
    };
  });
}

/**
 * Input Object Type Definition
 *
 * An input object defines a structured collection of fields which may be
 * supplied to a field argument.
 *
 * Using `NonNull` will ensure that a value must be provided by the query
 *
 * Example:
 *
 *     const GeoPoint = new GraphQLInputObjectType({
 *       name: 'GeoPoint',
 *       fields: {
 *         lat: { type: new GraphQLNonNull(GraphQLFloat) },
 *         lon: { type: new GraphQLNonNull(GraphQLFloat) },
 *         alt: { type: GraphQLFloat, defaultValue: 0 },
 *       }
 *     });
 *
 */
var GraphQLInputObjectType = /*#__PURE__*/function () {
  function GraphQLInputObjectType(config) {
    this.name = config.name;
    this.description = config.description;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = undefineIfEmpty(config.extensionASTNodes);
    this._fields = defineInputFieldMap.bind(undefined, config);
    typeof config.name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide name.');
  }

  var _proto6 = GraphQLInputObjectType.prototype;

  _proto6.getFields = function getFields() {
    if (typeof this._fields === 'function') {
      this._fields = this._fields();
    }

    return this._fields;
  };

  _proto6.toConfig = function toConfig() {
    var _this$extensionASTNod5;

    var fields = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_mapValue_mjs__["a" /* default */])(this.getFields(), function (field) {
      return {
        description: field.description,
        type: field.type,
        defaultValue: field.defaultValue,
        deprecationReason: field.deprecationReason,
        extensions: field.extensions,
        astNode: field.astNode
      };
    });
    return {
      name: this.name,
      description: this.description,
      fields: fields,
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod5 = this.extensionASTNodes) !== null && _this$extensionASTNod5 !== void 0 ? _this$extensionASTNod5 : []
    };
  };

  _proto6.toString = function toString() {
    return this.name;
  };

  _proto6.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLInputObjectType, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLInputObjectType';
    }
  }]);

  return GraphQLInputObjectType;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_12__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLInputObjectType);

function defineInputFieldMap(config) {
  var fieldMap = resolveThunk(config.fields);
  isPlainObj(fieldMap) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, " fields must be an object with field names as keys or a function which returns such an object."));
  return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_mapValue_mjs__["a" /* default */])(fieldMap, function (fieldConfig, fieldName) {
    !('resolve' in fieldConfig) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "".concat(config.name, ".").concat(fieldName, " field has a resolve property, but Input Types cannot define resolvers."));
    return {
      name: fieldName,
      description: fieldConfig.description,
      type: fieldConfig.type,
      defaultValue: fieldConfig.defaultValue,
      deprecationReason: fieldConfig.deprecationReason,
      extensions: fieldConfig.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(fieldConfig.extensions),
      astNode: fieldConfig.astNode
    };
  });
}

function isRequiredInputField(field) {
  return isNonNullType(field.type) && field.defaultValue === undefined;
}


/***/ }),
/* 21 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = inspect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nodejsCustomInspectSymbol_mjs__ = __webpack_require__(543);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/* eslint-disable flowtype/no-weak-types */

var MAX_ARRAY_LENGTH = 10;
var MAX_RECURSIVE_DEPTH = 2;
/**
 * Used to print values in error messages.
 */

function inspect(value) {
  return formatValue(value, []);
}

function formatValue(value, seenValues) {
  switch (_typeof(value)) {
    case 'string':
      return JSON.stringify(value);

    case 'function':
      return value.name ? "[function ".concat(value.name, "]") : '[function]';

    case 'object':
      if (value === null) {
        return 'null';
      }

      return formatObjectValue(value, seenValues);

    default:
      return String(value);
  }
}

function formatObjectValue(value, previouslySeenValues) {
  if (previouslySeenValues.indexOf(value) !== -1) {
    return '[Circular]';
  }

  var seenValues = [].concat(previouslySeenValues, [value]);
  var customInspectFn = getCustomFn(value);

  if (customInspectFn !== undefined) {
    var customValue = customInspectFn.call(value); // check for infinite recursion

    if (customValue !== value) {
      return typeof customValue === 'string' ? customValue : formatValue(customValue, seenValues);
    }
  } else if (Array.isArray(value)) {
    return formatArray(value, seenValues);
  }

  return formatObject(value, seenValues);
}

function formatObject(object, seenValues) {
  var keys = Object.keys(object);

  if (keys.length === 0) {
    return '{}';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[' + getObjectTag(object) + ']';
  }

  var properties = keys.map(function (key) {
    var value = formatValue(object[key], seenValues);
    return key + ': ' + value;
  });
  return '{ ' + properties.join(', ') + ' }';
}

function formatArray(array, seenValues) {
  if (array.length === 0) {
    return '[]';
  }

  if (seenValues.length > MAX_RECURSIVE_DEPTH) {
    return '[Array]';
  }

  var len = Math.min(MAX_ARRAY_LENGTH, array.length);
  var remaining = array.length - len;
  var items = [];

  for (var i = 0; i < len; ++i) {
    items.push(formatValue(array[i], seenValues));
  }

  if (remaining === 1) {
    items.push('... 1 more item');
  } else if (remaining > 1) {
    items.push("... ".concat(remaining, " more items"));
  }

  return '[' + items.join(', ') + ']';
}

function getCustomFn(object) {
  var customInspectFn = object[String(__WEBPACK_IMPORTED_MODULE_0__nodejsCustomInspectSymbol_mjs__["a" /* default */])];

  if (typeof customInspectFn === 'function') {
    return customInspectFn;
  }

  if (typeof object.inspect === 'function') {
    return object.inspect;
  }
}

function getObjectTag(object) {
  var tag = Object.prototype.toString.call(object).replace(/^\[object /, '').replace(/]$/, '');

  if (tag === 'Object' && typeof object.constructor === 'function') {
    var name = object.constructor.name;

    if (typeof name === 'string' && name !== '') {
      return name;
    }
  }

  return tag;
}


/***/ }),
/* 22 */,
/* 23 */,
/* 24 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Kind; });
/**
 * The set of allowed kind values for AST nodes.
 */
var Kind = Object.freeze({
  // Name
  NAME: 'Name',
  // Document
  DOCUMENT: 'Document',
  OPERATION_DEFINITION: 'OperationDefinition',
  VARIABLE_DEFINITION: 'VariableDefinition',
  SELECTION_SET: 'SelectionSet',
  FIELD: 'Field',
  ARGUMENT: 'Argument',
  // Fragments
  FRAGMENT_SPREAD: 'FragmentSpread',
  INLINE_FRAGMENT: 'InlineFragment',
  FRAGMENT_DEFINITION: 'FragmentDefinition',
  // Values
  VARIABLE: 'Variable',
  INT: 'IntValue',
  FLOAT: 'FloatValue',
  STRING: 'StringValue',
  BOOLEAN: 'BooleanValue',
  NULL: 'NullValue',
  ENUM: 'EnumValue',
  LIST: 'ListValue',
  OBJECT: 'ObjectValue',
  OBJECT_FIELD: 'ObjectField',
  // Directives
  DIRECTIVE: 'Directive',
  // Types
  NAMED_TYPE: 'NamedType',
  LIST_TYPE: 'ListType',
  NON_NULL_TYPE: 'NonNullType',
  // Type System Definitions
  SCHEMA_DEFINITION: 'SchemaDefinition',
  OPERATION_TYPE_DEFINITION: 'OperationTypeDefinition',
  // Type Definitions
  SCALAR_TYPE_DEFINITION: 'ScalarTypeDefinition',
  OBJECT_TYPE_DEFINITION: 'ObjectTypeDefinition',
  FIELD_DEFINITION: 'FieldDefinition',
  INPUT_VALUE_DEFINITION: 'InputValueDefinition',
  INTERFACE_TYPE_DEFINITION: 'InterfaceTypeDefinition',
  UNION_TYPE_DEFINITION: 'UnionTypeDefinition',
  ENUM_TYPE_DEFINITION: 'EnumTypeDefinition',
  ENUM_VALUE_DEFINITION: 'EnumValueDefinition',
  INPUT_OBJECT_TYPE_DEFINITION: 'InputObjectTypeDefinition',
  // Directive Definitions
  DIRECTIVE_DEFINITION: 'DirectiveDefinition',
  // Type System Extensions
  SCHEMA_EXTENSION: 'SchemaExtension',
  // Type Extensions
  SCALAR_TYPE_EXTENSION: 'ScalarTypeExtension',
  OBJECT_TYPE_EXTENSION: 'ObjectTypeExtension',
  INTERFACE_TYPE_EXTENSION: 'InterfaceTypeExtension',
  UNION_TYPE_EXTENSION: 'UnionTypeExtension',
  ENUM_TYPE_EXTENSION: 'EnumTypeExtension',
  INPUT_OBJECT_TYPE_EXTENSION: 'InputObjectTypeExtension'
});
/**
 * The enum type representing the possible kind values of AST nodes.
 */


/***/ }),
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = invariant;
function invariant(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message != null ? message : 'Unexpected invariant triggered.');
  }
}


/***/ }),
/* 41 */,
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noneligibleFeaturepop_vue__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9a52d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_noneligibleFeaturepop_vue__ = __webpack_require__(726);
function injectStyle (ssrContext) {
  __webpack_require__(724)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_noneligibleFeaturepop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0a9a52d4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_noneligibleFeaturepop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haandvaerker_vue__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b65d45b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_haandvaerker_vue__ = __webpack_require__(960);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_haandvaerker_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b65d45b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_haandvaerker_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_input_vue__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113c04cf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_input_vue__ = __webpack_require__(861);
function injectStyle (ssrContext) {
  __webpack_require__(857)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_input_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_113c04cf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_input_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 49 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__(1371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_654b054b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__(1372);
function injectStyle (ssrContext) {
  __webpack_require__(1370)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_654b054b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["g"] = isDirective;
/* unused harmony export assertDirective */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return GraphQLIncludeDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return GraphQLSkipDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_DEPRECATION_REASON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLDeprecatedDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return GraphQLSpecifiedByDirective; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return specifiedDirectives; });
/* harmony export (immutable) */ __webpack_exports__["h"] = isSpecifiedDirective;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_toObjMap_mjs__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_instanceOf_mjs__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_defineInspect_mjs__ = __webpack_require__(304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__definition_mjs__ = __webpack_require__(20);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }












/**
 * Test if the given value is a GraphQL directive.
 */

// eslint-disable-next-line no-redeclare
function isDirective(directive) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_instanceOf_mjs__["a" /* default */])(directive, GraphQLDirective);
}
function assertDirective(directive) {
  if (!isDirective(directive)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(directive), " to be a GraphQL directive."));
  }

  return directive;
}
/**
 * Directives are used by the GraphQL runtime as a way of modifying execution
 * behavior. Type system creators will usually not create these directly.
 */

var GraphQLDirective = /*#__PURE__*/function () {
  function GraphQLDirective(config) {
    var _config$isRepeatable, _config$args;

    this.name = config.name;
    this.description = config.description;
    this.locations = config.locations;
    this.isRepeatable = (_config$isRepeatable = config.isRepeatable) !== null && _config$isRepeatable !== void 0 ? _config$isRepeatable : false;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    config.name || Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_devAssert_mjs__["a" /* default */])(0, 'Directive must be named.');
    Array.isArray(config.locations) || Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_devAssert_mjs__["a" /* default */])(0, "@".concat(config.name, " locations must be an Array."));
    var args = (_config$args = config.args) !== null && _config$args !== void 0 ? _config$args : {};
    Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_isObjectLike_mjs__["a" /* default */])(args) && !Array.isArray(args) || Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_devAssert_mjs__["a" /* default */])(0, "@".concat(config.name, " args must be an object with argument names as keys."));
    this.args = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__["a" /* default */])(args).map(function (_ref) {
      var argName = _ref[0],
          argConfig = _ref[1];
      return {
        name: argName,
        description: argConfig.description,
        type: argConfig.type,
        defaultValue: argConfig.defaultValue,
        deprecationReason: argConfig.deprecationReason,
        extensions: argConfig.extensions && Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_toObjMap_mjs__["a" /* default */])(argConfig.extensions),
        astNode: argConfig.astNode
      };
    });
  }

  var _proto = GraphQLDirective.prototype;

  _proto.toConfig = function toConfig() {
    return {
      name: this.name,
      description: this.description,
      locations: this.locations,
      args: Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["i" /* argsToArgsConfig */])(this.args),
      isRepeatable: this.isRepeatable,
      extensions: this.extensions,
      astNode: this.astNode
    };
  };

  _proto.toString = function toString() {
    return '@' + this.name;
  };

  _proto.toJSON = function toJSON() {
    return this.toString();
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLDirective, [{
    key: __WEBPACK_IMPORTED_MODULE_1__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLDirective';
    }
  }]);

  return GraphQLDirective;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_defineInspect_mjs__["a" /* default */])(GraphQLDirective);

/**
 * Used to conditionally include fields or fragments.
 */
var GraphQLIncludeDirective = new GraphQLDirective({
  name: 'include',
  description: 'Directs the executor to include this field or fragment only when the `if` argument is true.',
  locations: [__WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_SPREAD, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INLINE_FRAGMENT],
  args: {
    if: {
      type: new __WEBPACK_IMPORTED_MODULE_10__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_9__scalars_mjs__["a" /* GraphQLBoolean */]),
      description: 'Included when true.'
    }
  }
});
/**
 * Used to conditionally skip (exclude) fields or fragments.
 */

var GraphQLSkipDirective = new GraphQLDirective({
  name: 'skip',
  description: 'Directs the executor to skip this field or fragment when the `if` argument is true.',
  locations: [__WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_SPREAD, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INLINE_FRAGMENT],
  args: {
    if: {
      type: new __WEBPACK_IMPORTED_MODULE_10__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_9__scalars_mjs__["a" /* GraphQLBoolean */]),
      description: 'Skipped when true.'
    }
  }
});
/**
 * Constant string used for default reason for a deprecation.
 */

var DEFAULT_DEPRECATION_REASON = 'No longer supported';
/**
 * Used to declare element of a GraphQL schema as deprecated.
 */

var GraphQLDeprecatedDirective = new GraphQLDirective({
  name: 'deprecated',
  description: 'Marks an element of a GraphQL schema as no longer supported.',
  locations: [__WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD_DEFINITION, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ARGUMENT_DEFINITION, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INPUT_FIELD_DEFINITION, __WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ENUM_VALUE],
  args: {
    reason: {
      type: __WEBPACK_IMPORTED_MODULE_9__scalars_mjs__["c" /* GraphQLString */],
      description: 'Explains why this element was deprecated, usually also including a suggestion for how to access supported similar data. Formatted using the Markdown syntax, as specified by [CommonMark](https://commonmark.org/).',
      defaultValue: DEFAULT_DEPRECATION_REASON
    }
  }
});
/**
 * Used to provide a URL for specifying the behaviour of custom scalar definitions.
 */

var GraphQLSpecifiedByDirective = new GraphQLDirective({
  name: 'specifiedBy',
  description: 'Exposes a URL that specifies the behaviour of this scalar.',
  locations: [__WEBPACK_IMPORTED_MODULE_8__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SCALAR],
  args: {
    url: {
      type: new __WEBPACK_IMPORTED_MODULE_10__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_9__scalars_mjs__["c" /* GraphQLString */]),
      description: 'The URL that specifies the behaviour of this scalar.'
    }
  }
});
/**
 * The full list of specified directives.
 */

var specifiedDirectives = Object.freeze([GraphQLIncludeDirective, GraphQLSkipDirective, GraphQLDeprecatedDirective, GraphQLSpecifiedByDirective]);
function isSpecifiedDirective(directive) {
  return specifiedDirectives.some(function (_ref2) {
    var name = _ref2.name;
    return name === directive.name;
  });
}


/***/ }),
/* 55 */,
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_updatebitrixpackagepermission_vue__ = __webpack_require__(791);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b42050_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_updatebitrixpackagepermission_vue__ = __webpack_require__(792);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_updatebitrixpackagepermission_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26b42050_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_updatebitrixpackagepermission_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 57 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var objectValues = Object.values || function (obj) {
  return Object.keys(obj).map(function (key) {
    return obj[key];
  });
};

/* harmony default export */ __webpack_exports__["a"] = (objectValues);


/***/ }),
/* 58 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = print;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__visitor_mjs__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__blockString_mjs__ = __webpack_require__(159);


/**
 * Converts an AST into a string, using one set of reasonable
 * formatting rules.
 */

function print(ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__visitor_mjs__["b" /* visit */])(ast, {
    leave: printDocASTReducer
  });
}
var MAX_LINE_LENGTH = 80; // TODO: provide better type coverage in future

var printDocASTReducer = {
  Name: function Name(node) {
    return node.value;
  },
  Variable: function Variable(node) {
    return '$' + node.name;
  },
  // Document
  Document: function Document(node) {
    return join(node.definitions, '\n\n') + '\n';
  },
  OperationDefinition: function OperationDefinition(node) {
    var op = node.operation;
    var name = node.name;
    var varDefs = wrap('(', join(node.variableDefinitions, ', '), ')');
    var directives = join(node.directives, ' ');
    var selectionSet = node.selectionSet; // Anonymous queries with no directives or variable definitions can use
    // the query short form.

    return !name && !directives && !varDefs && op === 'query' ? selectionSet : join([op, join([name, varDefs]), directives, selectionSet], ' ');
  },
  VariableDefinition: function VariableDefinition(_ref) {
    var variable = _ref.variable,
        type = _ref.type,
        defaultValue = _ref.defaultValue,
        directives = _ref.directives;
    return variable + ': ' + type + wrap(' = ', defaultValue) + wrap(' ', join(directives, ' '));
  },
  SelectionSet: function SelectionSet(_ref2) {
    var selections = _ref2.selections;
    return block(selections);
  },
  Field: function Field(_ref3) {
    var alias = _ref3.alias,
        name = _ref3.name,
        args = _ref3.arguments,
        directives = _ref3.directives,
        selectionSet = _ref3.selectionSet;
    var prefix = wrap('', alias, ': ') + name;
    var argsLine = prefix + wrap('(', join(args, ', '), ')');

    if (argsLine.length > MAX_LINE_LENGTH) {
      argsLine = prefix + wrap('(\n', indent(join(args, '\n')), '\n)');
    }

    return join([argsLine, join(directives, ' '), selectionSet], ' ');
  },
  Argument: function Argument(_ref4) {
    var name = _ref4.name,
        value = _ref4.value;
    return name + ': ' + value;
  },
  // Fragments
  FragmentSpread: function FragmentSpread(_ref5) {
    var name = _ref5.name,
        directives = _ref5.directives;
    return '...' + name + wrap(' ', join(directives, ' '));
  },
  InlineFragment: function InlineFragment(_ref6) {
    var typeCondition = _ref6.typeCondition,
        directives = _ref6.directives,
        selectionSet = _ref6.selectionSet;
    return join(['...', wrap('on ', typeCondition), join(directives, ' '), selectionSet], ' ');
  },
  FragmentDefinition: function FragmentDefinition(_ref7) {
    var name = _ref7.name,
        typeCondition = _ref7.typeCondition,
        variableDefinitions = _ref7.variableDefinitions,
        directives = _ref7.directives,
        selectionSet = _ref7.selectionSet;
    return (// Note: fragment variable definitions are experimental and may be changed
      // or removed in the future.
      "fragment ".concat(name).concat(wrap('(', join(variableDefinitions, ', '), ')'), " ") + "on ".concat(typeCondition, " ").concat(wrap('', join(directives, ' '), ' ')) + selectionSet
    );
  },
  // Value
  IntValue: function IntValue(_ref8) {
    var value = _ref8.value;
    return value;
  },
  FloatValue: function FloatValue(_ref9) {
    var value = _ref9.value;
    return value;
  },
  StringValue: function StringValue(_ref10, key) {
    var value = _ref10.value,
        isBlockString = _ref10.block;
    return isBlockString ? Object(__WEBPACK_IMPORTED_MODULE_1__blockString_mjs__["c" /* printBlockString */])(value, key === 'description' ? '' : '  ') : JSON.stringify(value);
  },
  BooleanValue: function BooleanValue(_ref11) {
    var value = _ref11.value;
    return value ? 'true' : 'false';
  },
  NullValue: function NullValue() {
    return 'null';
  },
  EnumValue: function EnumValue(_ref12) {
    var value = _ref12.value;
    return value;
  },
  ListValue: function ListValue(_ref13) {
    var values = _ref13.values;
    return '[' + join(values, ', ') + ']';
  },
  ObjectValue: function ObjectValue(_ref14) {
    var fields = _ref14.fields;
    return '{' + join(fields, ', ') + '}';
  },
  ObjectField: function ObjectField(_ref15) {
    var name = _ref15.name,
        value = _ref15.value;
    return name + ': ' + value;
  },
  // Directive
  Directive: function Directive(_ref16) {
    var name = _ref16.name,
        args = _ref16.arguments;
    return '@' + name + wrap('(', join(args, ', '), ')');
  },
  // Type
  NamedType: function NamedType(_ref17) {
    var name = _ref17.name;
    return name;
  },
  ListType: function ListType(_ref18) {
    var type = _ref18.type;
    return '[' + type + ']';
  },
  NonNullType: function NonNullType(_ref19) {
    var type = _ref19.type;
    return type + '!';
  },
  // Type System Definitions
  SchemaDefinition: addDescription(function (_ref20) {
    var directives = _ref20.directives,
        operationTypes = _ref20.operationTypes;
    return join(['schema', join(directives, ' '), block(operationTypes)], ' ');
  }),
  OperationTypeDefinition: function OperationTypeDefinition(_ref21) {
    var operation = _ref21.operation,
        type = _ref21.type;
    return operation + ': ' + type;
  },
  ScalarTypeDefinition: addDescription(function (_ref22) {
    var name = _ref22.name,
        directives = _ref22.directives;
    return join(['scalar', name, join(directives, ' ')], ' ');
  }),
  ObjectTypeDefinition: addDescription(function (_ref23) {
    var name = _ref23.name,
        interfaces = _ref23.interfaces,
        directives = _ref23.directives,
        fields = _ref23.fields;
    return join(['type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  FieldDefinition: addDescription(function (_ref24) {
    var name = _ref24.name,
        args = _ref24.arguments,
        type = _ref24.type,
        directives = _ref24.directives;
    return name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + ': ' + type + wrap(' ', join(directives, ' '));
  }),
  InputValueDefinition: addDescription(function (_ref25) {
    var name = _ref25.name,
        type = _ref25.type,
        defaultValue = _ref25.defaultValue,
        directives = _ref25.directives;
    return join([name + ': ' + type, wrap('= ', defaultValue), join(directives, ' ')], ' ');
  }),
  InterfaceTypeDefinition: addDescription(function (_ref26) {
    var name = _ref26.name,
        interfaces = _ref26.interfaces,
        directives = _ref26.directives,
        fields = _ref26.fields;
    return join(['interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  }),
  UnionTypeDefinition: addDescription(function (_ref27) {
    var name = _ref27.name,
        directives = _ref27.directives,
        types = _ref27.types;
    return join(['union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  }),
  EnumTypeDefinition: addDescription(function (_ref28) {
    var name = _ref28.name,
        directives = _ref28.directives,
        values = _ref28.values;
    return join(['enum', name, join(directives, ' '), block(values)], ' ');
  }),
  EnumValueDefinition: addDescription(function (_ref29) {
    var name = _ref29.name,
        directives = _ref29.directives;
    return join([name, join(directives, ' ')], ' ');
  }),
  InputObjectTypeDefinition: addDescription(function (_ref30) {
    var name = _ref30.name,
        directives = _ref30.directives,
        fields = _ref30.fields;
    return join(['input', name, join(directives, ' '), block(fields)], ' ');
  }),
  DirectiveDefinition: addDescription(function (_ref31) {
    var name = _ref31.name,
        args = _ref31.arguments,
        repeatable = _ref31.repeatable,
        locations = _ref31.locations;
    return 'directive @' + name + (hasMultilineItems(args) ? wrap('(\n', indent(join(args, '\n')), '\n)') : wrap('(', join(args, ', '), ')')) + (repeatable ? ' repeatable' : '') + ' on ' + join(locations, ' | ');
  }),
  SchemaExtension: function SchemaExtension(_ref32) {
    var directives = _ref32.directives,
        operationTypes = _ref32.operationTypes;
    return join(['extend schema', join(directives, ' '), block(operationTypes)], ' ');
  },
  ScalarTypeExtension: function ScalarTypeExtension(_ref33) {
    var name = _ref33.name,
        directives = _ref33.directives;
    return join(['extend scalar', name, join(directives, ' ')], ' ');
  },
  ObjectTypeExtension: function ObjectTypeExtension(_ref34) {
    var name = _ref34.name,
        interfaces = _ref34.interfaces,
        directives = _ref34.directives,
        fields = _ref34.fields;
    return join(['extend type', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  InterfaceTypeExtension: function InterfaceTypeExtension(_ref35) {
    var name = _ref35.name,
        interfaces = _ref35.interfaces,
        directives = _ref35.directives,
        fields = _ref35.fields;
    return join(['extend interface', name, wrap('implements ', join(interfaces, ' & ')), join(directives, ' '), block(fields)], ' ');
  },
  UnionTypeExtension: function UnionTypeExtension(_ref36) {
    var name = _ref36.name,
        directives = _ref36.directives,
        types = _ref36.types;
    return join(['extend union', name, join(directives, ' '), types && types.length !== 0 ? '= ' + join(types, ' | ') : ''], ' ');
  },
  EnumTypeExtension: function EnumTypeExtension(_ref37) {
    var name = _ref37.name,
        directives = _ref37.directives,
        values = _ref37.values;
    return join(['extend enum', name, join(directives, ' '), block(values)], ' ');
  },
  InputObjectTypeExtension: function InputObjectTypeExtension(_ref38) {
    var name = _ref38.name,
        directives = _ref38.directives,
        fields = _ref38.fields;
    return join(['extend input', name, join(directives, ' '), block(fields)], ' ');
  }
};

function addDescription(cb) {
  return function (node) {
    return join([node.description, cb(node)], '\n');
  };
}
/**
 * Given maybeArray, print an empty string if it is null or empty, otherwise
 * print all items together separated by separator if provided
 */


function join(maybeArray) {
  var _maybeArray$filter$jo;

  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  return (_maybeArray$filter$jo = maybeArray === null || maybeArray === void 0 ? void 0 : maybeArray.filter(function (x) {
    return x;
  }).join(separator)) !== null && _maybeArray$filter$jo !== void 0 ? _maybeArray$filter$jo : '';
}
/**
 * Given array, print each item on its own line, wrapped in an
 * indented "{ }" block.
 */


function block(array) {
  return wrap('{\n', indent(join(array, '\n')), '\n}');
}
/**
 * If maybeString is not null or empty, then wrap with start and end, otherwise print an empty string.
 */


function wrap(start, maybeString) {
  var end = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  return maybeString != null && maybeString !== '' ? start + maybeString + end : '';
}

function indent(str) {
  return wrap('  ', str.replace(/\n/g, '\n  '));
}

function isMultiline(str) {
  return str.indexOf('\n') !== -1;
}

function hasMultilineItems(maybeArray) {
  return maybeArray != null && maybeArray.some(isMultiline);
}


/***/ }),
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = devAssert;
function devAssert(condition, message) {
  var booleanCondition = Boolean(condition); // istanbul ignore else (See transformation done in './resources/inlineInvariant.js')

  if (!booleanCondition) {
    throw new Error(message);
  }
}


/***/ }),
/* 63 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __Schema; });
/* unused harmony export __Directive */
/* unused harmony export __DirectiveLocation */
/* unused harmony export __Type */
/* unused harmony export __Field */
/* unused harmony export __InputValue */
/* unused harmony export __EnumValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TypeKind; });
/* unused harmony export __TypeKind */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SchemaMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return TypeMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return TypeNameMetaFieldDef; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return introspectionTypes; });
/* harmony export (immutable) */ __webpack_exports__["g"] = isIntrospectionType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_astFromValue_mjs__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__definition_mjs__ = __webpack_require__(20);








var __Schema = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__Schema',
  description: 'A GraphQL Schema defines the capabilities of a GraphQL server. It exposes all available types and directives on the server, as well as the entry points for query, mutation, and subscription operations.',
  fields: function fields() {
    return {
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(schema) {
          return schema.description;
        }
      },
      types: {
        description: 'A list of all types supported by this server.',
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type))),
        resolve: function resolve(schema) {
          return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(schema.getTypeMap());
        }
      },
      queryType: {
        description: 'The type that query operations will be rooted at.',
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type),
        resolve: function resolve(schema) {
          return schema.getQueryType();
        }
      },
      mutationType: {
        description: 'If this server supports mutation, the type that mutation operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getMutationType();
        }
      },
      subscriptionType: {
        description: 'If this server support subscription, the type that subscription operations will be rooted at.',
        type: __Type,
        resolve: function resolve(schema) {
          return schema.getSubscriptionType();
        }
      },
      directives: {
        description: 'A list of all directives supported by this server.',
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Directive))),
        resolve: function resolve(schema) {
          return schema.getDirectives();
        }
      }
    };
  }
});
var __Directive = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__Directive',
  description: "A Directive provides a way to describe alternate runtime execution and type validation behavior in a GraphQL document.\n\nIn some cases, you need to provide options to alter GraphQL's execution behavior in ways field arguments will not suffice, such as conditionally including or skipping a field. Directives provide this by describing additional information to the executor.",
  fields: function fields() {
    return {
      name: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
        resolve: function resolve(directive) {
          return directive.name;
        }
      },
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(directive) {
          return directive.description;
        }
      },
      isRepeatable: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */]),
        resolve: function resolve(directive) {
          return directive.isRepeatable;
        }
      },
      locations: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__DirectiveLocation))),
        resolve: function resolve(directive) {
          return directive.locations;
        }
      },
      args: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__InputValue))),
        args: {
          includeDeprecated: {
            type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */],
            defaultValue: false
          }
        },
        resolve: function resolve(field, _ref) {
          var includeDeprecated = _ref.includeDeprecated;
          return includeDeprecated ? field.args : field.args.filter(function (arg) {
            return arg.deprecationReason == null;
          });
        }
      }
    };
  }
});
var __DirectiveLocation = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["a" /* GraphQLEnumType */]({
  name: '__DirectiveLocation',
  description: 'A Directive can be adjacent to many parts of the GraphQL language, a __DirectiveLocation describes one such possible adjacencies.',
  values: {
    QUERY: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].QUERY,
      description: 'Location adjacent to a query operation.'
    },
    MUTATION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].MUTATION,
      description: 'Location adjacent to a mutation operation.'
    },
    SUBSCRIPTION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SUBSCRIPTION,
      description: 'Location adjacent to a subscription operation.'
    },
    FIELD: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD,
      description: 'Location adjacent to a field.'
    },
    FRAGMENT_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION,
      description: 'Location adjacent to a fragment definition.'
    },
    FRAGMENT_SPREAD: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_SPREAD,
      description: 'Location adjacent to a fragment spread.'
    },
    INLINE_FRAGMENT: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INLINE_FRAGMENT,
      description: 'Location adjacent to an inline fragment.'
    },
    VARIABLE_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].VARIABLE_DEFINITION,
      description: 'Location adjacent to a variable definition.'
    },
    SCHEMA: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SCHEMA,
      description: 'Location adjacent to a schema definition.'
    },
    SCALAR: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SCALAR,
      description: 'Location adjacent to a scalar definition.'
    },
    OBJECT: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].OBJECT,
      description: 'Location adjacent to an object type definition.'
    },
    FIELD_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD_DEFINITION,
      description: 'Location adjacent to a field definition.'
    },
    ARGUMENT_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ARGUMENT_DEFINITION,
      description: 'Location adjacent to an argument definition.'
    },
    INTERFACE: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INTERFACE,
      description: 'Location adjacent to an interface definition.'
    },
    UNION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].UNION,
      description: 'Location adjacent to a union definition.'
    },
    ENUM: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ENUM,
      description: 'Location adjacent to an enum definition.'
    },
    ENUM_VALUE: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ENUM_VALUE,
      description: 'Location adjacent to an enum value definition.'
    },
    INPUT_OBJECT: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INPUT_OBJECT,
      description: 'Location adjacent to an input object type definition.'
    },
    INPUT_FIELD_DEFINITION: {
      value: __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INPUT_FIELD_DEFINITION,
      description: 'Location adjacent to an input object field definition.'
    }
  }
});
var __Type = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__Type',
  description: 'The fundamental unit of any GraphQL Schema is the type. There are many kinds of types in GraphQL as represented by the `__TypeKind` enum.\n\nDepending on the kind of a type, certain fields describe information about that type. Scalar types provide no information beyond a name, description and optional `specifiedByUrl`, while Enum types provide their values. Object and Interface types provide the fields they describe. Abstract types, Union and Interface, provide the Object types possible at runtime. List and NonNull types compose other types.',
  fields: function fields() {
    return {
      kind: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__TypeKind),
        resolve: function resolve(type) {
          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["C" /* isScalarType */])(type)) {
            return TypeKind.SCALAR;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["y" /* isObjectType */])(type)) {
            return TypeKind.OBJECT;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["t" /* isInterfaceType */])(type)) {
            return TypeKind.INTERFACE;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["E" /* isUnionType */])(type)) {
            return TypeKind.UNION;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["q" /* isEnumType */])(type)) {
            return TypeKind.ENUM;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["r" /* isInputObjectType */])(type)) {
            return TypeKind.INPUT_OBJECT;
          }

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["v" /* isListType */])(type)) {
            return TypeKind.LIST;
          } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["x" /* isNonNullType */])(type)) {
            return TypeKind.NON_NULL;
          } // istanbul ignore next (Not reachable. All possible types have been considered)


          false || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, "Unexpected type: \"".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type), "\"."));
        }
      },
      name: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(type) {
          return type.name !== undefined ? type.name : undefined;
        }
      },
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(type) {
          return type.description !== undefined ? type.description : undefined;
        }
      },
      specifiedByUrl: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(obj) {
          return obj.specifiedByUrl !== undefined ? obj.specifiedByUrl : undefined;
        }
      },
      fields: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Field)),
        args: {
          includeDeprecated: {
            type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */],
            defaultValue: false
          }
        },
        resolve: function resolve(type, _ref2) {
          var includeDeprecated = _ref2.includeDeprecated;

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["y" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["t" /* isInterfaceType */])(type)) {
            var fields = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields());
            return includeDeprecated ? fields : fields.filter(function (field) {
              return field.deprecationReason == null;
            });
          }
        }
      },
      interfaces: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type)),
        resolve: function resolve(type) {
          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["y" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["t" /* isInterfaceType */])(type)) {
            return type.getInterfaces();
          }
        }
      },
      possibleTypes: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type)),
        resolve: function resolve(type, _args, _context, _ref3) {
          var schema = _ref3.schema;

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["o" /* isAbstractType */])(type)) {
            return schema.getPossibleTypes(type);
          }
        }
      },
      enumValues: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__EnumValue)),
        args: {
          includeDeprecated: {
            type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */],
            defaultValue: false
          }
        },
        resolve: function resolve(type, _ref4) {
          var includeDeprecated = _ref4.includeDeprecated;

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["q" /* isEnumType */])(type)) {
            var values = type.getValues();
            return includeDeprecated ? values : values.filter(function (field) {
              return field.deprecationReason == null;
            });
          }
        }
      },
      inputFields: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__InputValue)),
        args: {
          includeDeprecated: {
            type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */],
            defaultValue: false
          }
        },
        resolve: function resolve(type, _ref5) {
          var includeDeprecated = _ref5.includeDeprecated;

          if (Object(__WEBPACK_IMPORTED_MODULE_7__definition_mjs__["r" /* isInputObjectType */])(type)) {
            var values = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields());
            return includeDeprecated ? values : values.filter(function (field) {
              return field.deprecationReason == null;
            });
          }
        }
      },
      ofType: {
        type: __Type,
        resolve: function resolve(type) {
          return type.ofType !== undefined ? type.ofType : undefined;
        }
      }
    };
  }
});
var __Field = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__Field',
  description: 'Object and Interface types are described by a list of Fields, each of which has a name, potentially a list of arguments, and a return type.',
  fields: function fields() {
    return {
      name: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
        resolve: function resolve(field) {
          return field.name;
        }
      },
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(field) {
          return field.description;
        }
      },
      args: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["d" /* GraphQLList */](new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__InputValue))),
        args: {
          includeDeprecated: {
            type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */],
            defaultValue: false
          }
        },
        resolve: function resolve(field, _ref6) {
          var includeDeprecated = _ref6.includeDeprecated;
          return includeDeprecated ? field.args : field.args.filter(function (arg) {
            return arg.deprecationReason == null;
          });
        }
      },
      type: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type),
        resolve: function resolve(field) {
          return field.type;
        }
      },
      isDeprecated: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */]),
        resolve: function resolve(field) {
          return field.deprecationReason != null;
        }
      },
      deprecationReason: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(field) {
          return field.deprecationReason;
        }
      }
    };
  }
});
var __InputValue = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__InputValue',
  description: 'Arguments provided to Fields or Directives and the input fields of an InputObject are represented as Input Values which describe their type and optionally a default value.',
  fields: function fields() {
    return {
      name: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
        resolve: function resolve(inputValue) {
          return inputValue.name;
        }
      },
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(inputValue) {
          return inputValue.description;
        }
      },
      type: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Type),
        resolve: function resolve(inputValue) {
          return inputValue.type;
        }
      },
      defaultValue: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        description: 'A GraphQL-formatted string representing the default value for this input value.',
        resolve: function resolve(inputValue) {
          var type = inputValue.type,
              defaultValue = inputValue.defaultValue;
          var valueAST = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_astFromValue_mjs__["a" /* astFromValue */])(defaultValue, type);
          return valueAST ? Object(__WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__["a" /* print */])(valueAST) : null;
        }
      },
      isDeprecated: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */]),
        resolve: function resolve(field) {
          return field.deprecationReason != null;
        }
      },
      deprecationReason: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(obj) {
          return obj.deprecationReason;
        }
      }
    };
  }
});
var __EnumValue = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["f" /* GraphQLObjectType */]({
  name: '__EnumValue',
  description: 'One possible value for a given Enum. Enum values are unique values, not a placeholder for a string or numeric value. However an Enum value is returned in a JSON response as a string.',
  fields: function fields() {
    return {
      name: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
        resolve: function resolve(enumValue) {
          return enumValue.name;
        }
      },
      description: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(enumValue) {
          return enumValue.description;
        }
      },
      isDeprecated: {
        type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["a" /* GraphQLBoolean */]),
        resolve: function resolve(enumValue) {
          return enumValue.deprecationReason != null;
        }
      },
      deprecationReason: {
        type: __WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */],
        resolve: function resolve(enumValue) {
          return enumValue.deprecationReason;
        }
      }
    };
  }
});
var TypeKind = Object.freeze({
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  INPUT_OBJECT: 'INPUT_OBJECT',
  LIST: 'LIST',
  NON_NULL: 'NON_NULL'
});
var __TypeKind = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["a" /* GraphQLEnumType */]({
  name: '__TypeKind',
  description: 'An enum describing what kind of type a given `__Type` is.',
  values: {
    SCALAR: {
      value: TypeKind.SCALAR,
      description: 'Indicates this type is a scalar.'
    },
    OBJECT: {
      value: TypeKind.OBJECT,
      description: 'Indicates this type is an object. `fields` and `interfaces` are valid fields.'
    },
    INTERFACE: {
      value: TypeKind.INTERFACE,
      description: 'Indicates this type is an interface. `fields`, `interfaces`, and `possibleTypes` are valid fields.'
    },
    UNION: {
      value: TypeKind.UNION,
      description: 'Indicates this type is a union. `possibleTypes` is a valid field.'
    },
    ENUM: {
      value: TypeKind.ENUM,
      description: 'Indicates this type is an enum. `enumValues` is a valid field.'
    },
    INPUT_OBJECT: {
      value: TypeKind.INPUT_OBJECT,
      description: 'Indicates this type is an input object. `inputFields` is a valid field.'
    },
    LIST: {
      value: TypeKind.LIST,
      description: 'Indicates this type is a list. `ofType` is a valid field.'
    },
    NON_NULL: {
      value: TypeKind.NON_NULL,
      description: 'Indicates this type is a non-null. `ofType` is a valid field.'
    }
  }
});
/**
 * Note that these are GraphQLField and not GraphQLFieldConfig,
 * so the format for args is different.
 */

var SchemaMetaFieldDef = {
  name: '__schema',
  type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__Schema),
  description: 'Access the current type schema of this server.',
  args: [],
  resolve: function resolve(_source, _args, _context, _ref7) {
    var schema = _ref7.schema;
    return schema;
  },
  isDeprecated: false,
  deprecationReason: undefined,
  extensions: undefined,
  astNode: undefined
};
var TypeMetaFieldDef = {
  name: '__type',
  type: __Type,
  description: 'Request the type information of a single type.',
  args: [{
    name: 'name',
    description: undefined,
    type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
    defaultValue: undefined,
    deprecationReason: undefined,
    extensions: undefined,
    astNode: undefined
  }],
  resolve: function resolve(_source, _ref8, _context, _ref9) {
    var name = _ref8.name;
    var schema = _ref9.schema;
    return schema.getType(name);
  },
  isDeprecated: false,
  deprecationReason: undefined,
  extensions: undefined,
  astNode: undefined
};
var TypeNameMetaFieldDef = {
  name: '__typename',
  type: new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["e" /* GraphQLNonNull */](__WEBPACK_IMPORTED_MODULE_6__scalars_mjs__["c" /* GraphQLString */]),
  description: 'The name of the current Object type at runtime.',
  args: [],
  resolve: function resolve(_source, _args, _context, _ref10) {
    var parentType = _ref10.parentType;
    return parentType.name;
  },
  isDeprecated: false,
  deprecationReason: undefined,
  extensions: undefined,
  astNode: undefined
};
var introspectionTypes = Object.freeze([__Schema, __Directive, __DirectiveLocation, __Type, __Field, __InputValue, __EnumValue, __TypeKind]);
function isIntrospectionType(type) {
  return introspectionTypes.some(function (_ref11) {
    var name = _ref11.name;
    return type.name === name;
  });
}


/***/ }),
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isObjectLike;
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

/**
 * Return true if `value` is object-like. A value is object-like if it's not
 * `null` and has a `typeof` result of "object".
 */
function isObjectLike(value) {
  return _typeof(value) == 'object' && value !== null;
}


/***/ }),
/* 87 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SYMBOL_ITERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SYMBOL_ASYNC_ITERATOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SYMBOL_TO_STRING_TAG; });
// In ES2015 (or a polyfilled) environment, this will be Symbol.iterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var SYMBOL_ITERATOR = typeof Symbol === 'function' && Symbol.iterator != null ? Symbol.iterator : '@@iterator'; // In ES2017 (or a polyfilled) environment, this will be Symbol.asyncIterator
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_ASYNC_ITERATOR = typeof Symbol === 'function' && Symbol.asyncIterator != null ? Symbol.asyncIterator : '@@asyncIterator'; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')

var SYMBOL_TO_STRING_TAG = typeof Symbol === 'function' && Symbol.toStringTag != null ? Symbol.toStringTag : '@@toStringTag';


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export GraphQLInt */
/* unused harmony export GraphQLFloat */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return GraphQLString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLBoolean; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return GraphQLID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return specifiedScalarTypes; });
/* harmony export (immutable) */ __webpack_exports__["d"] = isSpecifiedScalarType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_isInteger_mjs__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__definition_mjs__ = __webpack_require__(20);







 // As per the GraphQL Spec, Integers are only treated as valid when a valid
// 32-bit signed integer, providing the broadest support across platforms.
//
// n.b. JavaScript's integers are safe between -(2^53 - 1) and 2^53 - 1 because
// they are internally represented as IEEE 754 doubles.

var MAX_INT = 2147483647;
var MIN_INT = -2147483648;

function serializeInt(outputValue) {
  var coercedValue = serializeObject(outputValue);

  if (typeof coercedValue === 'boolean') {
    return coercedValue ? 1 : 0;
  }

  var num = coercedValue;

  if (typeof coercedValue === 'string' && coercedValue !== '') {
    num = Number(coercedValue);
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_isInteger_mjs__["a" /* default */])(num)) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Int cannot represent non-integer value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(coercedValue)));
  }

  if (num > MAX_INT || num < MIN_INT) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]('Int cannot represent non 32-bit signed integer value: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(coercedValue));
  }

  return num;
}

function coerceInt(inputValue) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_isInteger_mjs__["a" /* default */])(inputValue)) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Int cannot represent non-integer value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue)));
  }

  if (inputValue > MAX_INT || inputValue < MIN_INT) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Int cannot represent non 32-bit signed integer value: ".concat(inputValue));
  }

  return inputValue;
}

var GraphQLInt = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["g" /* GraphQLScalarType */]({
  name: 'Int',
  description: 'The `Int` scalar type represents non-fractional signed whole numeric values. Int can represent values between -(2^31) and 2^31 - 1.',
  serialize: serializeInt,
  parseValue: coerceInt,
  parseLiteral: function parseLiteral(valueNode) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].INT) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Int cannot represent non-integer value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(valueNode)), valueNode);
    }

    var num = parseInt(valueNode.value, 10);

    if (num > MAX_INT || num < MIN_INT) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Int cannot represent non 32-bit signed integer value: ".concat(valueNode.value), valueNode);
    }

    return num;
  }
});

function serializeFloat(outputValue) {
  var coercedValue = serializeObject(outputValue);

  if (typeof coercedValue === 'boolean') {
    return coercedValue ? 1 : 0;
  }

  var num = coercedValue;

  if (typeof coercedValue === 'string' && coercedValue !== '') {
    num = Number(coercedValue);
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__["a" /* default */])(num)) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Float cannot represent non numeric value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(coercedValue)));
  }

  return num;
}

function coerceFloat(inputValue) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__["a" /* default */])(inputValue)) {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Float cannot represent non numeric value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue)));
  }

  return inputValue;
}

var GraphQLFloat = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["g" /* GraphQLScalarType */]({
  name: 'Float',
  description: 'The `Float` scalar type represents signed double-precision fractional values as specified by [IEEE 754](https://en.wikipedia.org/wiki/IEEE_floating_point).',
  serialize: serializeFloat,
  parseValue: coerceFloat,
  parseLiteral: function parseLiteral(valueNode) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].FLOAT && valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].INT) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Float cannot represent non numeric value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(valueNode)), valueNode);
    }

    return parseFloat(valueNode.value);
  }
}); // Support serializing objects with custom valueOf() or toJSON() functions -
// a common way to represent a complex value which can be represented as
// a string (ex: MongoDB id objects).

function serializeObject(outputValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_isObjectLike_mjs__["a" /* default */])(outputValue)) {
    if (typeof outputValue.valueOf === 'function') {
      var valueOfResult = outputValue.valueOf();

      if (!Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_isObjectLike_mjs__["a" /* default */])(valueOfResult)) {
        return valueOfResult;
      }
    }

    if (typeof outputValue.toJSON === 'function') {
      // $FlowFixMe[incompatible-use]
      return outputValue.toJSON();
    }
  }

  return outputValue;
}

function serializeString(outputValue) {
  var coercedValue = serializeObject(outputValue); // Serialize string, boolean and number values to a string, but do not
  // attempt to coerce object, function, symbol, or other types as strings.

  if (typeof coercedValue === 'string') {
    return coercedValue;
  }

  if (typeof coercedValue === 'boolean') {
    return coercedValue ? 'true' : 'false';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__["a" /* default */])(coercedValue)) {
    return coercedValue.toString();
  }

  throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("String cannot represent value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(outputValue)));
}

function coerceString(inputValue) {
  if (typeof inputValue !== 'string') {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("String cannot represent a non string value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue)));
  }

  return inputValue;
}

var GraphQLString = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["g" /* GraphQLScalarType */]({
  name: 'String',
  description: 'The `String` scalar type represents textual data, represented as UTF-8 character sequences. The String type is most often used by GraphQL to represent free-form human-readable text.',
  serialize: serializeString,
  parseValue: coerceString,
  parseLiteral: function parseLiteral(valueNode) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].STRING) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("String cannot represent a non string value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(valueNode)), valueNode);
    }

    return valueNode.value;
  }
});

function serializeBoolean(outputValue) {
  var coercedValue = serializeObject(outputValue);

  if (typeof coercedValue === 'boolean') {
    return coercedValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__["a" /* default */])(coercedValue)) {
    return coercedValue !== 0;
  }

  throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Boolean cannot represent a non boolean value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(coercedValue)));
}

function coerceBoolean(inputValue) {
  if (typeof inputValue !== 'boolean') {
    throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Boolean cannot represent a non boolean value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue)));
  }

  return inputValue;
}

var GraphQLBoolean = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["g" /* GraphQLScalarType */]({
  name: 'Boolean',
  description: 'The `Boolean` scalar type represents `true` or `false`.',
  serialize: serializeBoolean,
  parseValue: coerceBoolean,
  parseLiteral: function parseLiteral(valueNode) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].BOOLEAN) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("Boolean cannot represent a non boolean value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(valueNode)), valueNode);
    }

    return valueNode.value;
  }
});

function serializeID(outputValue) {
  var coercedValue = serializeObject(outputValue);

  if (typeof coercedValue === 'string') {
    return coercedValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_isInteger_mjs__["a" /* default */])(coercedValue)) {
    return String(coercedValue);
  }

  throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("ID cannot represent value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(outputValue)));
}

function coerceID(inputValue) {
  if (typeof inputValue === 'string') {
    return inputValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_isInteger_mjs__["a" /* default */])(inputValue)) {
    return inputValue.toString();
  }

  throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]("ID cannot represent value: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(inputValue)));
}

var GraphQLID = new __WEBPACK_IMPORTED_MODULE_7__definition_mjs__["g" /* GraphQLScalarType */]({
  name: 'ID',
  description: 'The `ID` scalar type represents a unique identifier, often used to refetch an object or as key for a cache. The ID type appears in a JSON response as a String; however, it is not intended to be human-readable. When expected as an input type, any string (such as `"4"`) or integer (such as `4`) input value will be accepted as an ID.',
  serialize: serializeID,
  parseValue: coerceID,
  parseLiteral: function parseLiteral(valueNode) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].STRING && valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].INT) {
      throw new __WEBPACK_IMPORTED_MODULE_6__error_GraphQLError_mjs__["a" /* GraphQLError */]('ID cannot represent a non-string and non-integer value: ' + Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(valueNode), valueNode);
    }

    return valueNode.value;
  }
});
var specifiedScalarTypes = Object.freeze([GraphQLString, GraphQLInt, GraphQLFloat, GraphQLBoolean, GraphQLID]);
function isSpecifiedScalarType(type) {
  return specifiedScalarTypes.some(function (_ref) {
    var name = _ref.name;
    return type.name === name;
  });
}


/***/ }),
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = typeFromAST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__ = __webpack_require__(20);




/**
 * Given a Schema and an AST node describing a type, return a GraphQLType
 * definition which applies to that type. For example, if provided the parsed
 * AST node for `[User]`, a GraphQLList instance will be returned, containing
 * the type called "User" found in the schema. If a type called "User" is not
 * found in the schema, then undefined will be returned.
 */

/* eslint-disable no-redeclare */

function typeFromAST(schema, typeNode) {
  /* eslint-enable no-redeclare */
  var innerType;

  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__["a" /* Kind */].LIST_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && new __WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__["d" /* GraphQLList */](innerType);
  }

  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__["a" /* Kind */].NON_NULL_TYPE) {
    innerType = typeFromAST(schema, typeNode.type);
    return innerType && new __WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__["e" /* GraphQLNonNull */](innerType);
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (typeNode.kind === __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__["a" /* Kind */].NAMED_TYPE) {
    return schema.getType(typeNode.name.value);
  } // istanbul ignore next (Not reachable. All possible type nodes have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type node: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(typeNode));
}


/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveModal_vue__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e346beaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveModal_vue__ = __webpack_require__(790);
function injectStyle (ssrContext) {
  __webpack_require__(781)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-e346beaa"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchiveModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e346beaa_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ArchiveModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 101 */,
/* 102 */,
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imentor_vue__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17688a61_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imentor_vue__ = __webpack_require__(905);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imentor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17688a61_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imentor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4418a159_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__(1366);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4418a159_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export QueryDocumentKeys */
/* unused harmony export BREAK */
/* harmony export (immutable) */ __webpack_exports__["b"] = visit;
/* harmony export (immutable) */ __webpack_exports__["c"] = visitInParallel;
/* harmony export (immutable) */ __webpack_exports__["a"] = getVisitFn;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ast_mjs__ = __webpack_require__(156);


/**
 * A visitor is provided to visit, it contains the collection of
 * relevant functions to be called during the visitor's traversal.
 */

var QueryDocumentKeys = {
  Name: [],
  Document: ['definitions'],
  OperationDefinition: ['name', 'variableDefinitions', 'directives', 'selectionSet'],
  VariableDefinition: ['variable', 'type', 'defaultValue', 'directives'],
  Variable: ['name'],
  SelectionSet: ['selections'],
  Field: ['alias', 'name', 'arguments', 'directives', 'selectionSet'],
  Argument: ['name', 'value'],
  FragmentSpread: ['name', 'directives'],
  InlineFragment: ['typeCondition', 'directives', 'selectionSet'],
  FragmentDefinition: ['name', // Note: fragment variable definitions are experimental and may be changed
  // or removed in the future.
  'variableDefinitions', 'typeCondition', 'directives', 'selectionSet'],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ['values'],
  ObjectValue: ['fields'],
  ObjectField: ['name', 'value'],
  Directive: ['name', 'arguments'],
  NamedType: ['name'],
  ListType: ['type'],
  NonNullType: ['type'],
  SchemaDefinition: ['description', 'directives', 'operationTypes'],
  OperationTypeDefinition: ['type'],
  ScalarTypeDefinition: ['description', 'name', 'directives'],
  ObjectTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  FieldDefinition: ['description', 'name', 'arguments', 'type', 'directives'],
  InputValueDefinition: ['description', 'name', 'type', 'defaultValue', 'directives'],
  InterfaceTypeDefinition: ['description', 'name', 'interfaces', 'directives', 'fields'],
  UnionTypeDefinition: ['description', 'name', 'directives', 'types'],
  EnumTypeDefinition: ['description', 'name', 'directives', 'values'],
  EnumValueDefinition: ['description', 'name', 'directives'],
  InputObjectTypeDefinition: ['description', 'name', 'directives', 'fields'],
  DirectiveDefinition: ['description', 'name', 'arguments', 'locations'],
  SchemaExtension: ['directives', 'operationTypes'],
  ScalarTypeExtension: ['name', 'directives'],
  ObjectTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  InterfaceTypeExtension: ['name', 'interfaces', 'directives', 'fields'],
  UnionTypeExtension: ['name', 'directives', 'types'],
  EnumTypeExtension: ['name', 'directives', 'values'],
  InputObjectTypeExtension: ['name', 'directives', 'fields']
};
var BREAK = Object.freeze({});
/**
 * visit() will walk through an AST using a depth-first traversal, calling
 * the visitor's enter function at each node in the traversal, and calling the
 * leave function after visiting that node and all of its child nodes.
 *
 * By returning different values from the enter and leave functions, the
 * behavior of the visitor can be altered, including skipping over a sub-tree of
 * the AST (by returning false), editing the AST by returning a value or null
 * to remove the value, or to stop the whole traversal by returning BREAK.
 *
 * When using visit() to edit an AST, the original AST will not be modified, and
 * a new version of the AST with the changes applied will be returned from the
 * visit function.
 *
 *     const editedAST = visit(ast, {
 *       enter(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: skip visiting this node
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       },
 *       leave(node, key, parent, path, ancestors) {
 *         // @return
 *         //   undefined: no action
 *         //   false: no action
 *         //   visitor.BREAK: stop visiting altogether
 *         //   null: delete this node
 *         //   any value: replace this node with the returned value
 *       }
 *     });
 *
 * Alternatively to providing enter() and leave() functions, a visitor can
 * instead provide functions named the same as the kinds of AST nodes, or
 * enter/leave visitors at a named key, leading to four permutations of the
 * visitor API:
 *
 * 1) Named visitors triggered when entering a node of a specific kind.
 *
 *     visit(ast, {
 *       Kind(node) {
 *         // enter the "Kind" node
 *       }
 *     })
 *
 * 2) Named visitors that trigger upon entering and leaving a node of
 *    a specific kind.
 *
 *     visit(ast, {
 *       Kind: {
 *         enter(node) {
 *           // enter the "Kind" node
 *         }
 *         leave(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 *
 * 3) Generic visitors that trigger upon entering and leaving any node.
 *
 *     visit(ast, {
 *       enter(node) {
 *         // enter any node
 *       },
 *       leave(node) {
 *         // leave any node
 *       }
 *     })
 *
 * 4) Parallel visitors for entering and leaving nodes of a specific kind.
 *
 *     visit(ast, {
 *       enter: {
 *         Kind(node) {
 *           // enter the "Kind" node
 *         }
 *       },
 *       leave: {
 *         Kind(node) {
 *           // leave the "Kind" node
 *         }
 *       }
 *     })
 */

function visit(root, visitor) {
  var visitorKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : QueryDocumentKeys;

  /* eslint-disable no-undef-init */
  var stack = undefined;
  var inArray = Array.isArray(root);
  var keys = [root];
  var index = -1;
  var edits = [];
  var node = undefined;
  var key = undefined;
  var parent = undefined;
  var path = [];
  var ancestors = [];
  var newRoot = root;
  /* eslint-enable no-undef-init */

  do {
    index++;
    var isLeaving = index === keys.length;
    var isEdited = isLeaving && edits.length !== 0;

    if (isLeaving) {
      key = ancestors.length === 0 ? undefined : path[path.length - 1];
      node = parent;
      parent = ancestors.pop();

      if (isEdited) {
        if (inArray) {
          node = node.slice();
        } else {
          var clone = {};

          for (var _i2 = 0, _Object$keys2 = Object.keys(node); _i2 < _Object$keys2.length; _i2++) {
            var k = _Object$keys2[_i2];
            clone[k] = node[k];
          }

          node = clone;
        }

        var editOffset = 0;

        for (var ii = 0; ii < edits.length; ii++) {
          var editKey = edits[ii][0];
          var editValue = edits[ii][1];

          if (inArray) {
            editKey -= editOffset;
          }

          if (inArray && editValue === null) {
            node.splice(editKey, 1);
            editOffset++;
          } else {
            node[editKey] = editValue;
          }
        }
      }

      index = stack.index;
      keys = stack.keys;
      edits = stack.edits;
      inArray = stack.inArray;
      stack = stack.prev;
    } else {
      key = parent ? inArray ? index : keys[index] : undefined;
      node = parent ? parent[key] : newRoot;

      if (node === null || node === undefined) {
        continue;
      }

      if (parent) {
        path.push(key);
      }
    }

    var result = void 0;

    if (!Array.isArray(node)) {
      if (!Object(__WEBPACK_IMPORTED_MODULE_1__ast_mjs__["c" /* isNode */])(node)) {
        throw new Error("Invalid AST Node: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(node), "."));
      }

      var visitFn = getVisitFn(visitor, node.kind, isLeaving);

      if (visitFn) {
        result = visitFn.call(visitor, node, key, parent, path, ancestors);

        if (result === BREAK) {
          break;
        }

        if (result === false) {
          if (!isLeaving) {
            path.pop();
            continue;
          }
        } else if (result !== undefined) {
          edits.push([key, result]);

          if (!isLeaving) {
            if (Object(__WEBPACK_IMPORTED_MODULE_1__ast_mjs__["c" /* isNode */])(result)) {
              node = result;
            } else {
              path.pop();
              continue;
            }
          }
        }
      }
    }

    if (result === undefined && isEdited) {
      edits.push([key, node]);
    }

    if (isLeaving) {
      path.pop();
    } else {
      var _visitorKeys$node$kin;

      stack = {
        inArray: inArray,
        index: index,
        keys: keys,
        edits: edits,
        prev: stack
      };
      inArray = Array.isArray(node);
      keys = inArray ? node : (_visitorKeys$node$kin = visitorKeys[node.kind]) !== null && _visitorKeys$node$kin !== void 0 ? _visitorKeys$node$kin : [];
      index = -1;
      edits = [];

      if (parent) {
        ancestors.push(parent);
      }

      parent = node;
    }
  } while (stack !== undefined);

  if (edits.length !== 0) {
    newRoot = edits[edits.length - 1][1];
  }

  return newRoot;
}
/**
 * Creates a new visitor instance which delegates to many visitors to run in
 * parallel. Each visitor will be visited for each node before moving on.
 *
 * If a prior visitor edits a node, no following visitors will see that node.
 */

function visitInParallel(visitors) {
  var skipping = new Array(visitors.length);
  return {
    enter: function enter(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          false);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === false) {
              skipping[i] = node;
            } else if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined) {
              return result;
            }
          }
        }
      }
    },
    leave: function leave(node) {
      for (var i = 0; i < visitors.length; i++) {
        if (skipping[i] == null) {
          var fn = getVisitFn(visitors[i], node.kind,
          /* isLeaving */
          true);

          if (fn) {
            var result = fn.apply(visitors[i], arguments);

            if (result === BREAK) {
              skipping[i] = BREAK;
            } else if (result !== undefined && result !== false) {
              return result;
            }
          }
        } else if (skipping[i] === node) {
          skipping[i] = null;
        }
      }
    }
  };
}
/**
 * Given a visitor instance, if it is leaving or not, and a node kind, return
 * the function the visitor runtime should call.
 */

function getVisitFn(visitor, kind, isLeaving) {
  var kindVisitor = visitor[kind];

  if (kindVisitor) {
    if (!isLeaving && typeof kindVisitor === 'function') {
      // { Kind() {} }
      return kindVisitor;
    }

    var kindSpecificVisitor = isLeaving ? kindVisitor.leave : kindVisitor.enter;

    if (typeof kindSpecificVisitor === 'function') {
      // { Kind: { enter() {}, leave() {} } }
      return kindSpecificVisitor;
    }
  } else {
    var specificVisitor = isLeaving ? visitor.leave : visitor.enter;

    if (specificVisitor) {
      if (typeof specificVisitor === 'function') {
        // { enter() {}, leave() {} }
        return specificVisitor;
      }

      var specificKindVisitor = specificVisitor[kind];

      if (typeof specificKindVisitor === 'function') {
        // { enter: { Kind() {} }, leave: { Kind() {} } }
        return specificKindVisitor;
      }
    }
  }
}


/***/ }),
/* 117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyMap;
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * for each value in the array.
 *
 * This provides a convenient lookup for the array items if the key function
 * produces unique results.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: { name: 'Jon', num: '555-1234' },
 *     //   Jenny: { name: 'Jenny', num: '867-5309' } }
 *     const entriesByName = keyMap(
 *       phoneBook,
 *       entry => entry.name
 *     )
 *
 *     // { name: 'Jenny', num: '857-6309' }
 *     const jennyEntry = entriesByName['Jenny']
 *
 */
function keyMap(list, keyFn) {
  return list.reduce(function (map, item) {
    map[keyFn(item)] = item;
    return map;
  }, Object.create(null));
}


/***/ }),
/* 118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = didYouMean;
var MAX_SUGGESTIONS = 5;
/**
 * Given [ A, B, C ] return ' Did you mean A, B, or C?'.
 */

// eslint-disable-next-line no-redeclare
function didYouMean(firstArg, secondArg) {
  var _ref = typeof firstArg === 'string' ? [firstArg, secondArg] : [undefined, firstArg],
      subMessage = _ref[0],
      suggestionsArg = _ref[1];

  var message = ' Did you mean ';

  if (subMessage) {
    message += subMessage + ' ';
  }

  var suggestions = suggestionsArg.map(function (x) {
    return "\"".concat(x, "\"");
  });

  switch (suggestions.length) {
    case 0:
      return '';

    case 1:
      return message + suggestions[0] + '?';

    case 2:
      return message + suggestions[0] + ' or ' + suggestions[1] + '?';
  }

  var selected = suggestions.slice(0, MAX_SUGGESTIONS);
  var lastItem = selected.pop();
  return message + selected.join(', ') + ', or ' + lastItem + '?';
}


/***/ }),
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = suggestionList;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__naturalCompare_mjs__ = __webpack_require__(205);

/**
 * Given an invalid input string and a list of valid options, returns a filtered
 * list of valid options sorted based on their similarity with the input.
 */

function suggestionList(input, options) {
  var optionsByDistance = Object.create(null);
  var lexicalDistance = new LexicalDistance(input);
  var threshold = Math.floor(input.length * 0.4) + 1;

  for (var _i2 = 0; _i2 < options.length; _i2++) {
    var option = options[_i2];
    var distance = lexicalDistance.measure(option, threshold);

    if (distance !== undefined) {
      optionsByDistance[option] = distance;
    }
  }

  return Object.keys(optionsByDistance).sort(function (a, b) {
    var distanceDiff = optionsByDistance[a] - optionsByDistance[b];
    return distanceDiff !== 0 ? distanceDiff : Object(__WEBPACK_IMPORTED_MODULE_0__naturalCompare_mjs__["a" /* default */])(a, b);
  });
}
/**
 * Computes the lexical distance between strings A and B.
 *
 * The "distance" between two strings is given by counting the minimum number
 * of edits needed to transform string A into string B. An edit can be an
 * insertion, deletion, or substitution of a single character, or a swap of two
 * adjacent characters.
 *
 * Includes a custom alteration from Damerau-Levenshtein to treat case changes
 * as a single edit which helps identify mis-cased values with an edit distance
 * of 1.
 *
 * This distance can be useful for detecting typos in input or sorting
 */

var LexicalDistance = /*#__PURE__*/function () {
  function LexicalDistance(input) {
    this._input = input;
    this._inputLowerCase = input.toLowerCase();
    this._inputArray = stringToArray(this._inputLowerCase);
    this._rows = [new Array(input.length + 1).fill(0), new Array(input.length + 1).fill(0), new Array(input.length + 1).fill(0)];
  }

  var _proto = LexicalDistance.prototype;

  _proto.measure = function measure(option, threshold) {
    if (this._input === option) {
      return 0;
    }

    var optionLowerCase = option.toLowerCase(); // Any case change counts as a single edit

    if (this._inputLowerCase === optionLowerCase) {
      return 1;
    }

    var a = stringToArray(optionLowerCase);
    var b = this._inputArray;

    if (a.length < b.length) {
      var tmp = a;
      a = b;
      b = tmp;
    }

    var aLength = a.length;
    var bLength = b.length;

    if (aLength - bLength > threshold) {
      return undefined;
    }

    var rows = this._rows;

    for (var j = 0; j <= bLength; j++) {
      rows[0][j] = j;
    }

    for (var i = 1; i <= aLength; i++) {
      var upRow = rows[(i - 1) % 3];
      var currentRow = rows[i % 3];
      var smallestCell = currentRow[0] = i;

      for (var _j = 1; _j <= bLength; _j++) {
        var cost = a[i - 1] === b[_j - 1] ? 0 : 1;
        var currentCell = Math.min(upRow[_j] + 1, // delete
        currentRow[_j - 1] + 1, // insert
        upRow[_j - 1] + cost // substitute
        );

        if (i > 1 && _j > 1 && a[i - 1] === b[_j - 2] && a[i - 2] === b[_j - 1]) {
          // transposition
          var doubleDiagonalCell = rows[(i - 2) % 3][_j - 2];
          currentCell = Math.min(currentCell, doubleDiagonalCell + 1);
        }

        if (currentCell < smallestCell) {
          smallestCell = currentCell;
        }

        currentRow[_j] = currentCell;
      } // Early exit, since distance can't go smaller than smallest element of the previous row.


      if (smallestCell > threshold) {
        return undefined;
      }
    }

    var distance = rows[aLength % 3][bLength];
    return distance <= threshold ? distance : undefined;
  };

  return LexicalDistance;
}();

function stringToArray(str) {
  var strLength = str.length;
  var array = new Array(strLength);

  for (var i = 0; i < strLength; ++i) {
    array[i] = str.charCodeAt(i);
  }

  return array;
}


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */,
/* 123 */,
/* 124 */,
/* 125 */,
/* 126 */,
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isSchema */
/* harmony export (immutable) */ __webpack_exports__["b"] = assertSchema;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GraphQLSchema; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_arrayFrom_mjs__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polyfills_symbols_mjs__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__ = __webpack_require__(307);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_instanceOf_mjs__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__definition_mjs__ = __webpack_require__(20);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }













/**
 * Test if the given value is a GraphQL schema.
 */

// eslint-disable-next-line no-redeclare
function isSchema(schema) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_instanceOf_mjs__["a" /* default */])(schema, GraphQLSchema);
}
function assertSchema(schema) {
  if (!isSchema(schema)) {
    throw new Error("Expected ".concat(Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_inspect_mjs__["a" /* default */])(schema), " to be a GraphQL schema."));
  }

  return schema;
}
/**
 * Schema Definition
 *
 * A Schema is created by supplying the root types of each type of operation,
 * query and mutation (optional). A schema definition is then supplied to the
 * validator and executor.
 *
 * Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       query: MyAppQueryRootType,
 *       mutation: MyAppMutationRootType,
 *     })
 *
 * Note: When the schema is constructed, by default only the types that are
 * reachable by traversing the root types are included, other types must be
 * explicitly referenced.
 *
 * Example:
 *
 *     const characterInterface = new GraphQLInterfaceType({
 *       name: 'Character',
 *       ...
 *     });
 *
 *     const humanType = new GraphQLObjectType({
 *       name: 'Human',
 *       interfaces: [characterInterface],
 *       ...
 *     });
 *
 *     const droidType = new GraphQLObjectType({
 *       name: 'Droid',
 *       interfaces: [characterInterface],
 *       ...
 *     });
 *
 *     const schema = new GraphQLSchema({
 *       query: new GraphQLObjectType({
 *         name: 'Query',
 *         fields: {
 *           hero: { type: characterInterface, ... },
 *         }
 *       }),
 *       ...
 *       // Since this schema references only the `Character` interface it's
 *       // necessary to explicitly list the types that implement it if
 *       // you want them to be included in the final schema.
 *       types: [humanType, droidType],
 *     })
 *
 * Note: If an array of `directives` are provided to GraphQLSchema, that will be
 * the exact list of directives represented and allowed. If `directives` is not
 * provided then a default set of the specified directives (e.g. @include and
 * @skip) will be used. If you wish to provide *additional* directives to these
 * specified directives, you must explicitly declare them. Example:
 *
 *     const MyAppSchema = new GraphQLSchema({
 *       ...
 *       directives: specifiedDirectives.concat([ myCustomDirective ]),
 *     })
 *
 */

var GraphQLSchema = /*#__PURE__*/function () {
  // Used as a cache for validateSchema().
  function GraphQLSchema(config) {
    var _config$directives;

    // If this schema was built from a source known to be valid, then it may be
    // marked with assumeValid to avoid an additional type system validation.
    this.__validationErrors = config.assumeValid === true ? [] : undefined; // Check for common mistakes during construction to produce early errors.

    Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_isObjectLike_mjs__["a" /* default */])(config) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide configuration object.');
    !config.types || Array.isArray(config.types) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, "\"types\" must be Array if provided but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_inspect_mjs__["a" /* default */])(config.types), "."));
    !config.directives || Array.isArray(config.directives) || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, '"directives" must be Array if provided but got: ' + "".concat(Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_inspect_mjs__["a" /* default */])(config.directives), "."));
    this.description = config.description;
    this.extensions = config.extensions && Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_toObjMap_mjs__["a" /* default */])(config.extensions);
    this.astNode = config.astNode;
    this.extensionASTNodes = config.extensionASTNodes;
    this._queryType = config.query;
    this._mutationType = config.mutation;
    this._subscriptionType = config.subscription; // Provide specified directives (e.g. @include and @skip) by default.

    this._directives = (_config$directives = config.directives) !== null && _config$directives !== void 0 ? _config$directives : __WEBPACK_IMPORTED_MODULE_10__directives_mjs__["i" /* specifiedDirectives */]; // To preserve order of user-provided types, we add first to add them to
    // the set of "collected" types, so `collectReferencedTypes` ignore them.

    var allReferencedTypes = new Set(config.types);

    if (config.types != null) {
      for (var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++) {
        var type = _config$types2[_i2];
        // When we ready to process this type, we remove it from "collected" types
        // and then add it together with all dependent types in the correct position.
        allReferencedTypes.delete(type);
        collectReferencedTypes(type, allReferencedTypes);
      }
    }

    if (this._queryType != null) {
      collectReferencedTypes(this._queryType, allReferencedTypes);
    }

    if (this._mutationType != null) {
      collectReferencedTypes(this._mutationType, allReferencedTypes);
    }

    if (this._subscriptionType != null) {
      collectReferencedTypes(this._subscriptionType, allReferencedTypes);
    }

    for (var _i4 = 0, _this$_directives2 = this._directives; _i4 < _this$_directives2.length; _i4++) {
      var directive = _this$_directives2[_i4];

      // Directives are not validated until validateSchema() is called.
      if (Object(__WEBPACK_IMPORTED_MODULE_10__directives_mjs__["g" /* isDirective */])(directive)) {
        for (var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++) {
          var arg = _directive$args2[_i6];
          collectReferencedTypes(arg.type, allReferencedTypes);
        }
      }
    }

    collectReferencedTypes(__WEBPACK_IMPORTED_MODULE_9__introspection_mjs__["e" /* __Schema */], allReferencedTypes); // Storing the resulting map for reference by the schema.

    this._typeMap = Object.create(null);
    this._subTypeMap = Object.create(null); // Keep track of all implementations by interface name.

    this._implementationsMap = Object.create(null);

    for (var _i8 = 0, _arrayFrom2 = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_arrayFrom_mjs__["a" /* default */])(allReferencedTypes); _i8 < _arrayFrom2.length; _i8++) {
      var namedType = _arrayFrom2[_i8];

      if (namedType == null) {
        continue;
      }

      var typeName = namedType.name;
      typeName || Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_devAssert_mjs__["a" /* default */])(0, 'One of the provided types for building the Schema is missing a name.');

      if (this._typeMap[typeName] !== undefined) {
        throw new Error("Schema must contain uniquely named types but contains multiple types named \"".concat(typeName, "\"."));
      }

      this._typeMap[typeName] = namedType;

      if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["t" /* isInterfaceType */])(namedType)) {
        // Store implementations by interface.
        for (var _i10 = 0, _namedType$getInterfa2 = namedType.getInterfaces(); _i10 < _namedType$getInterfa2.length; _i10++) {
          var iface = _namedType$getInterfa2[_i10];

          if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["t" /* isInterfaceType */])(iface)) {
            var implementations = this._implementationsMap[iface.name];

            if (implementations === undefined) {
              implementations = this._implementationsMap[iface.name] = {
                objects: [],
                interfaces: []
              };
            }

            implementations.interfaces.push(namedType);
          }
        }
      } else if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["y" /* isObjectType */])(namedType)) {
        // Store implementations by objects.
        for (var _i12 = 0, _namedType$getInterfa4 = namedType.getInterfaces(); _i12 < _namedType$getInterfa4.length; _i12++) {
          var _iface = _namedType$getInterfa4[_i12];

          if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["t" /* isInterfaceType */])(_iface)) {
            var _implementations = this._implementationsMap[_iface.name];

            if (_implementations === undefined) {
              _implementations = this._implementationsMap[_iface.name] = {
                objects: [],
                interfaces: []
              };
            }

            _implementations.objects.push(namedType);
          }
        }
      }
    }
  }

  var _proto = GraphQLSchema.prototype;

  _proto.getQueryType = function getQueryType() {
    return this._queryType;
  };

  _proto.getMutationType = function getMutationType() {
    return this._mutationType;
  };

  _proto.getSubscriptionType = function getSubscriptionType() {
    return this._subscriptionType;
  };

  _proto.getTypeMap = function getTypeMap() {
    return this._typeMap;
  };

  _proto.getType = function getType(name) {
    return this.getTypeMap()[name];
  };

  _proto.getPossibleTypes = function getPossibleTypes(abstractType) {
    return Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["E" /* isUnionType */])(abstractType) ? abstractType.getTypes() : this.getImplementations(abstractType).objects;
  };

  _proto.getImplementations = function getImplementations(interfaceType) {
    var implementations = this._implementationsMap[interfaceType.name];
    return implementations !== null && implementations !== void 0 ? implementations : {
      objects: [],
      interfaces: []
    };
  } // @deprecated: use isSubType instead - will be removed in v16.
  ;

  _proto.isPossibleType = function isPossibleType(abstractType, possibleType) {
    return this.isSubType(abstractType, possibleType);
  };

  _proto.isSubType = function isSubType(abstractType, maybeSubType) {
    var map = this._subTypeMap[abstractType.name];

    if (map === undefined) {
      map = Object.create(null);

      if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["E" /* isUnionType */])(abstractType)) {
        for (var _i14 = 0, _abstractType$getType2 = abstractType.getTypes(); _i14 < _abstractType$getType2.length; _i14++) {
          var type = _abstractType$getType2[_i14];
          map[type.name] = true;
        }
      } else {
        var implementations = this.getImplementations(abstractType);

        for (var _i16 = 0, _implementations$obje2 = implementations.objects; _i16 < _implementations$obje2.length; _i16++) {
          var _type = _implementations$obje2[_i16];
          map[_type.name] = true;
        }

        for (var _i18 = 0, _implementations$inte2 = implementations.interfaces; _i18 < _implementations$inte2.length; _i18++) {
          var _type2 = _implementations$inte2[_i18];
          map[_type2.name] = true;
        }
      }

      this._subTypeMap[abstractType.name] = map;
    }

    return map[maybeSubType.name] !== undefined;
  };

  _proto.getDirectives = function getDirectives() {
    return this._directives;
  };

  _proto.getDirective = function getDirective(name) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(this.getDirectives(), function (directive) {
      return directive.name === name;
    });
  };

  _proto.toConfig = function toConfig() {
    var _this$extensionASTNod;

    return {
      description: this.description,
      query: this.getQueryType(),
      mutation: this.getMutationType(),
      subscription: this.getSubscriptionType(),
      types: Object(__WEBPACK_IMPORTED_MODULE_2__polyfills_objectValues_mjs__["a" /* default */])(this.getTypeMap()),
      directives: this.getDirectives().slice(),
      extensions: this.extensions,
      astNode: this.astNode,
      extensionASTNodes: (_this$extensionASTNod = this.extensionASTNodes) !== null && _this$extensionASTNod !== void 0 ? _this$extensionASTNod : [],
      assumeValid: this.__validationErrors !== undefined
    };
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet
  ;

  _createClass(GraphQLSchema, [{
    key: __WEBPACK_IMPORTED_MODULE_3__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'GraphQLSchema';
    }
  }]);

  return GraphQLSchema;
}();

function collectReferencedTypes(type, typeSet) {
  var namedType = Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["m" /* getNamedType */])(type);

  if (!typeSet.has(namedType)) {
    typeSet.add(namedType);

    if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["E" /* isUnionType */])(namedType)) {
      for (var _i20 = 0, _namedType$getTypes2 = namedType.getTypes(); _i20 < _namedType$getTypes2.length; _i20++) {
        var memberType = _namedType$getTypes2[_i20];
        collectReferencedTypes(memberType, typeSet);
      }
    } else if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["y" /* isObjectType */])(namedType) || Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["t" /* isInterfaceType */])(namedType)) {
      for (var _i22 = 0, _namedType$getInterfa6 = namedType.getInterfaces(); _i22 < _namedType$getInterfa6.length; _i22++) {
        var interfaceType = _namedType$getInterfa6[_i22];
        collectReferencedTypes(interfaceType, typeSet);
      }

      for (var _i24 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_2__polyfills_objectValues_mjs__["a" /* default */])(namedType.getFields()); _i24 < _objectValues2.length; _i24++) {
        var field = _objectValues2[_i24];
        collectReferencedTypes(field.type, typeSet);

        for (var _i26 = 0, _field$args2 = field.args; _i26 < _field$args2.length; _i26++) {
          var arg = _field$args2[_i26];
          collectReferencedTypes(arg.type, typeSet);
        }
      }
    } else if (Object(__WEBPACK_IMPORTED_MODULE_11__definition_mjs__["r" /* isInputObjectType */])(namedType)) {
      for (var _i28 = 0, _objectValues4 = Object(__WEBPACK_IMPORTED_MODULE_2__polyfills_objectValues_mjs__["a" /* default */])(namedType.getFields()); _i28 < _objectValues4.length; _i28++) {
        var _field = _objectValues4[_i28];
        collectReferencedTypes(_field.type, typeSet);
      }
    }
  }

  return typeSet;
}


/***/ }),
/* 134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isDefinitionNode */
/* harmony export (immutable) */ __webpack_exports__["a"] = isExecutableDefinitionNode;
/* unused harmony export isSelectionNode */
/* unused harmony export isValueNode */
/* unused harmony export isTypeNode */
/* harmony export (immutable) */ __webpack_exports__["d"] = isTypeSystemDefinitionNode;
/* harmony export (immutable) */ __webpack_exports__["b"] = isTypeDefinitionNode;
/* harmony export (immutable) */ __webpack_exports__["e"] = isTypeSystemExtensionNode;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTypeExtensionNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__ = __webpack_require__(24);

function isDefinitionNode(node) {
  return isExecutableDefinitionNode(node) || isTypeSystemDefinitionNode(node) || isTypeSystemExtensionNode(node);
}
function isExecutableDefinitionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION;
}
function isSelectionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].FIELD || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT;
}
function isValueNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].VARIABLE || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INT || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].FLOAT || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].STRING || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].BOOLEAN || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].NULL || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].ENUM || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].LIST || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].OBJECT;
}
function isTypeNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].NAMED_TYPE || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].LIST_TYPE || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].NON_NULL_TYPE;
}
function isTypeSystemDefinitionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION || isTypeDefinitionNode(node) || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION;
}
function isTypeDefinitionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].SCALAR_TYPE_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].OBJECT_TYPE_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].UNION_TYPE_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].ENUM_TYPE_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION;
}
function isTypeSystemExtensionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION || isTypeExtensionNode(node);
}
function isTypeExtensionNode(node) {
  return node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION || node.kind === __WEBPACK_IMPORTED_MODULE_0__kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION;
}


/***/ }),
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = parse;
/* harmony export (immutable) */ __webpack_exports__["b"] = parseValue;
/* unused harmony export parseType */
/* unused harmony export Parser */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ast_mjs__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__source_mjs__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__directiveLocation_mjs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__lexer_mjs__ = __webpack_require__(306);







/**
 * Configuration options to control parser behavior
 */

/**
 * Given a GraphQL source, parses it into a Document.
 * Throws GraphQLError if a syntax error is encountered.
 */
function parse(source, options) {
  var parser = new Parser(source, options);
  return parser.parseDocument();
}
/**
 * Given a string containing a GraphQL value (ex. `[42]`), parse the AST for
 * that value.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Values directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: valueFromAST().
 */

function parseValue(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].SOF);
  var value = parser.parseValueLiteral(false);
  parser.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EOF);
  return value;
}
/**
 * Given a string containing a GraphQL Type (ex. `[Int!]`), parse the AST for
 * that type.
 * Throws GraphQLError if a syntax error is encountered.
 *
 * This is useful within tools that operate upon GraphQL Types directly and
 * in isolation of complete GraphQL documents.
 *
 * Consider providing the results to the utility function: typeFromAST().
 */

function parseType(source, options) {
  var parser = new Parser(source, options);
  parser.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].SOF);
  var type = parser.parseTypeReference();
  parser.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EOF);
  return type;
}
/**
 * This class is exported only to assist people in implementing their own parsers
 * without duplicating too much code and should be used only as last resort for cases
 * such as experimental syntax or if certain features could not be contributed upstream.
 *
 * It is still part of the internal API and is versioned, so any changes to it are never
 * considered breaking changes. If you still need to support multiple versions of the
 * library, please use the `versionInfo` variable for version detection.
 *
 * @internal
 */

var Parser = /*#__PURE__*/function () {
  function Parser(source, options) {
    var sourceObj = Object(__WEBPACK_IMPORTED_MODULE_4__source_mjs__["b" /* isSource */])(source) ? source : new __WEBPACK_IMPORTED_MODULE_4__source_mjs__["a" /* Source */](source);
    this._lexer = new __WEBPACK_IMPORTED_MODULE_6__lexer_mjs__["a" /* Lexer */](sourceObj);
    this._options = options;
  }
  /**
   * Converts a name lex token into a name parse node.
   */


  var _proto = Parser.prototype;

  _proto.parseName = function parseName() {
    var token = this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].NAME,
      value: token.value,
      loc: this.loc(token)
    };
  } // Implements the parsing rules in the Document section.

  /**
   * Document : Definition+
   */
  ;

  _proto.parseDocument = function parseDocument() {
    var start = this._lexer.token;
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].DOCUMENT,
      definitions: this.many(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].SOF, this.parseDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EOF),
      loc: this.loc(start)
    };
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   */
  ;

  _proto.parseDefinition = function parseDefinition() {
    if (this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME)) {
      switch (this._lexer.token.value) {
        case 'query':
        case 'mutation':
        case 'subscription':
          return this.parseOperationDefinition();

        case 'fragment':
          return this.parseFragmentDefinition();

        case 'schema':
        case 'scalar':
        case 'type':
        case 'interface':
        case 'union':
        case 'enum':
        case 'input':
        case 'directive':
          return this.parseTypeSystemDefinition();

        case 'extend':
          return this.parseTypeSystemExtension();
      }
    } else if (this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L)) {
      return this.parseOperationDefinition();
    } else if (this.peekDescription()) {
      return this.parseTypeSystemDefinition();
    }

    throw this.unexpected();
  } // Implements the parsing rules in the Operations section.

  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  ;

  _proto.parseOperationDefinition = function parseOperationDefinition() {
    var start = this._lexer.token;

    if (this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L)) {
      return {
        kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION,
        operation: 'query',
        name: undefined,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    var operation = this.parseOperationType();
    var name;

    if (this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME)) {
      name = this.parseName();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION,
      operation: operation,
      name: name,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * OperationType : one of query mutation subscription
   */
  ;

  _proto.parseOperationType = function parseOperationType() {
    var operationToken = this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME);

    switch (operationToken.value) {
      case 'query':
        return 'query';

      case 'mutation':
        return 'mutation';

      case 'subscription':
        return 'subscription';
    }

    throw this.unexpected(operationToken);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  ;

  _proto.parseVariableDefinitions = function parseVariableDefinitions() {
    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_L, this.parseVariableDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_R);
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseVariableDefinition = function parseVariableDefinition() {
    var start = this._lexer.token;
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EQUALS) ? this.parseValueLiteral(true) : undefined,
      directives: this.parseDirectives(true),
      loc: this.loc(start)
    };
  }
  /**
   * Variable : $ Name
   */
  ;

  _proto.parseVariable = function parseVariable() {
    var start = this._lexer.token;
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].DOLLAR);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].VARIABLE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  }
  /**
   * SelectionSet : { Selection+ }
   */
  ;

  _proto.parseSelectionSet = function parseSelectionSet() {
    var start = this._lexer.token;
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].SELECTION_SET,
      selections: this.many(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseSelection, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  ;

  _proto.parseSelection = function parseSelection() {
    return this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  ;

  _proto.parseField = function parseField() {
    var start = this._lexer.token;
    var nameOrAlias = this.parseName();
    var alias;
    var name;

    if (this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON)) {
      alias = nameOrAlias;
      name = this.parseName();
    } else {
      name = nameOrAlias;
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FIELD,
      alias: alias,
      name: name,
      arguments: this.parseArguments(false),
      directives: this.parseDirectives(false),
      selectionSet: this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L) ? this.parseSelectionSet() : undefined,
      loc: this.loc(start)
    };
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  ;

  _proto.parseArguments = function parseArguments(isConst) {
    var item = isConst ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_L, item, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseArgument = function parseArgument() {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ARGUMENT,
      name: name,
      value: this.parseValueLiteral(false),
      loc: this.loc(start)
    };
  };

  _proto.parseConstArgument = function parseConstArgument() {
    var start = this._lexer.token;
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ARGUMENT,
      name: this.parseName(),
      value: (this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON), this.parseValueLiteral(true)),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Fragments section.

  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  ;

  _proto.parseFragment = function parseFragment() {
    var start = this._lexer.token;
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].SPREAD);
    var hasTypeCondition = this.expectOptionalKeyword('on');

    if (!hasTypeCondition && this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME)) {
      return {
        kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD,
        name: this.parseFragmentName(),
        directives: this.parseDirectives(false),
        loc: this.loc(start)
      };
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT,
      typeCondition: hasTypeCondition ? this.parseNamedType() : undefined,
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  ;

  _proto.parseFragmentDefinition = function parseFragmentDefinition() {
    var _this$_options;

    var start = this._lexer.token;
    this.expectKeyword('fragment'); // Experimental support for defining variables within fragments changes
    // the grammar of FragmentDefinition:
    //   - fragment FragmentName VariableDefinitions? on TypeCondition Directives? SelectionSet

    if (((_this$_options = this._options) === null || _this$_options === void 0 ? void 0 : _this$_options.experimentalFragmentVariables) === true) {
      return {
        kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION,
        name: this.parseFragmentName(),
        variableDefinitions: this.parseVariableDefinitions(),
        typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
        directives: this.parseDirectives(false),
        selectionSet: this.parseSelectionSet(),
        loc: this.loc(start)
      };
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword('on'), this.parseNamedType()),
      directives: this.parseDirectives(false),
      selectionSet: this.parseSelectionSet(),
      loc: this.loc(start)
    };
  }
  /**
   * FragmentName : Name but not `on`
   */
  ;

  _proto.parseFragmentName = function parseFragmentName() {
    if (this._lexer.token.value === 'on') {
      throw this.unexpected();
    }

    return this.parseName();
  } // Implements the parsing rules in the Values section.

  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  ;

  _proto.parseValueLiteral = function parseValueLiteral(isConst) {
    var token = this._lexer.token;

    switch (token.kind) {
      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACKET_L:
        return this.parseList(isConst);

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L:
        return this.parseObject(isConst);

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].INT:
        this._lexer.advance();

        return {
          kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INT,
          value: token.value,
          loc: this.loc(token)
        };

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].FLOAT:
        this._lexer.advance();

        return {
          kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FLOAT,
          value: token.value,
          loc: this.loc(token)
        };

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].STRING:
      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BLOCK_STRING:
        return this.parseStringLiteral();

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME:
        this._lexer.advance();

        switch (token.value) {
          case 'true':
            return {
              kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].BOOLEAN,
              value: true,
              loc: this.loc(token)
            };

          case 'false':
            return {
              kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].BOOLEAN,
              value: false,
              loc: this.loc(token)
            };

          case 'null':
            return {
              kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].NULL,
              loc: this.loc(token)
            };

          default:
            return {
              kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ENUM,
              value: token.value,
              loc: this.loc(token)
            };
        }

      case __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].DOLLAR:
        if (!isConst) {
          return this.parseVariable();
        }

        break;
    }

    throw this.unexpected();
  };

  _proto.parseStringLiteral = function parseStringLiteral() {
    var token = this._lexer.token;

    this._lexer.advance();

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].STRING,
      value: token.value,
      block: token.kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BLOCK_STRING,
      loc: this.loc(token)
    };
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  ;

  _proto.parseList = function parseList(isConst) {
    var _this = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this.parseValueLiteral(isConst);
    };

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].LIST,
      values: this.any(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACKET_L, item, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACKET_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   */
  ;

  _proto.parseObject = function parseObject(isConst) {
    var _this2 = this;

    var start = this._lexer.token;

    var item = function item() {
      return _this2.parseObjectField(isConst);
    };

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OBJECT,
      fields: this.any(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, item, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R),
      loc: this.loc(start)
    };
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  ;

  _proto.parseObjectField = function parseObjectField(isConst) {
    var start = this._lexer.token;
    var name = this.parseName();
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OBJECT_FIELD,
      name: name,
      value: this.parseValueLiteral(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Directives section.

  /**
   * Directives[Const] : Directive[?Const]+
   */
  ;

  _proto.parseDirectives = function parseDirectives(isConst) {
    var directives = [];

    while (this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AT)) {
      directives.push(this.parseDirective(isConst));
    }

    return directives;
  }
  /**
   * Directive[Const] : @ Name Arguments[?Const]?
   */
  ;

  _proto.parseDirective = function parseDirective(isConst) {
    var start = this._lexer.token;
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AT);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(isConst),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Types section.

  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  ;

  _proto.parseTypeReference = function parseTypeReference() {
    var start = this._lexer.token;
    var type;

    if (this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACKET_L)) {
      type = this.parseTypeReference();
      this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACKET_R);
      type = {
        kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].LIST_TYPE,
        type: type,
        loc: this.loc(start)
      };
    } else {
      type = this.parseNamedType();
    }

    if (this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BANG)) {
      return {
        kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].NON_NULL_TYPE,
        type: type,
        loc: this.loc(start)
      };
    }

    return type;
  }
  /**
   * NamedType : Name
   */
  ;

  _proto.parseNamedType = function parseNamedType() {
    var start = this._lexer.token;
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].NAMED_TYPE,
      name: this.parseName(),
      loc: this.loc(start)
    };
  } // Implements the parsing rules in the Type Definition section.

  /**
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemDefinition = function parseTypeSystemDefinition() {
    // Many definitions begin with a description and require a lookahead.
    var keywordToken = this.peekDescription() ? this._lexer.lookahead() : this._lexer.token;

    if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaDefinition();

        case 'scalar':
          return this.parseScalarTypeDefinition();

        case 'type':
          return this.parseObjectTypeDefinition();

        case 'interface':
          return this.parseInterfaceTypeDefinition();

        case 'union':
          return this.parseUnionTypeDefinition();

        case 'enum':
          return this.parseEnumTypeDefinition();

        case 'input':
          return this.parseInputObjectTypeDefinition();

        case 'directive':
          return this.parseDirectiveDefinition();
      }
    }

    throw this.unexpected(keywordToken);
  };

  _proto.peekDescription = function peekDescription() {
    return this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].STRING) || this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  ;

  _proto.parseDescription = function parseDescription() {
    if (this.peekDescription()) {
      return this.parseStringLiteral();
    }
  }
  /**
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   */
  ;

  _proto.parseSchemaDefinition = function parseSchemaDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.many(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION,
      description: description,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  ;

  _proto.parseOperationTypeDefinition = function parseOperationTypeDefinition() {
    var start = this._lexer.token;
    var operation = this.parseOperationType();
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON);
    var type = this.parseNamedType();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OPERATION_TYPE_DEFINITION,
      operation: operation,
      type: type,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  ;

  _proto.parseScalarTypeDefinition = function parseScalarTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].SCALAR_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseObjectTypeDefinition = function parseObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  ;

  _proto.parseImplementsInterfaces = function parseImplementsInterfaces() {
    var _this$_options2;

    if (!this.expectOptionalKeyword('implements')) {
      return [];
    }

    if (((_this$_options2 = this._options) === null || _this$_options2 === void 0 ? void 0 : _this$_options2.allowLegacySDLImplementsInterfaces) === true) {
      var types = []; // Optional leading ampersand

      this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AMP);

      do {
        types.push(this.parseNamedType());
      } while (this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AMP) || this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME));

      return types;
    }

    return this.delimitedMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AMP, this.parseNamedType);
  }
  /**
   * FieldsDefinition : { FieldDefinition+ }
   */
  ;

  _proto.parseFieldsDefinition = function parseFieldsDefinition() {
    var _this$_options3;

    // Legacy support for the SDL?
    if (((_this$_options3 = this._options) === null || _this$_options3 === void 0 ? void 0 : _this$_options3.allowLegacySDLEmptyFields) === true && this.peek(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L) && this._lexer.lookahead().kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R) {
      this._lexer.advance();

      this._lexer.advance();

      return [];
    }

    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseFieldDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R);
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  ;

  _proto.parseFieldDefinition = function parseFieldDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON);
    var type = this.parseTypeReference();
    var directives = this.parseDirectives(true);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].FIELD_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      type: type,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  ;

  _proto.parseArgumentDefs = function parseArgumentDefs() {
    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_L, this.parseInputValueDef, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PAREN_R);
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  ;

  _proto.parseInputValueDef = function parseInputValueDef() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].COLON);
    var type = this.parseTypeReference();
    var defaultValue;

    if (this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EQUALS)) {
      defaultValue = this.parseValueLiteral(true);
    }

    var directives = this.parseDirectives(true);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INPUT_VALUE_DEFINITION,
      description: description,
      name: name,
      type: type,
      defaultValue: defaultValue,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  ;

  _proto.parseInterfaceTypeDefinition = function parseInterfaceTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_DEFINITION,
      description: description,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  ;

  _proto.parseUnionTypeDefinition = function parseUnionTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].UNION_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  ;

  _proto.parseUnionMemberTypes = function parseUnionMemberTypes() {
    return this.expectOptionalToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].EQUALS) ? this.delimitedMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  ;

  _proto.parseEnumTypeDefinition = function parseEnumTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ENUM_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * EnumValuesDefinition : { EnumValueDefinition+ }
   */
  ;

  _proto.parseEnumValuesDefinition = function parseEnumValuesDefinition() {
    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseEnumValueDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R);
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   *
   * EnumValue : Name
   */
  ;

  _proto.parseEnumValueDefinition = function parseEnumValueDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ENUM_VALUE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  ;

  _proto.parseInputObjectTypeDefinition = function parseInputObjectTypeDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION,
      description: description,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InputFieldsDefinition : { InputValueDefinition+ }
   */
  ;

  _proto.parseInputFieldsDefinition = function parseInputFieldsDefinition() {
    return this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseInputValueDef, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R);
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  ;

  _proto.parseTypeSystemExtension = function parseTypeSystemExtension() {
    var keywordToken = this._lexer.lookahead();

    if (keywordToken.kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME) {
      switch (keywordToken.value) {
        case 'schema':
          return this.parseSchemaExtension();

        case 'scalar':
          return this.parseScalarTypeExtension();

        case 'type':
          return this.parseObjectTypeExtension();

        case 'interface':
          return this.parseInterfaceTypeExtension();

        case 'union':
          return this.parseUnionTypeExtension();

        case 'enum':
          return this.parseEnumTypeExtension();

        case 'input':
          return this.parseInputObjectTypeExtension();
      }
    }

    throw this.unexpected(keywordToken);
  }
  /**
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   */
  ;

  _proto.parseSchemaExtension = function parseSchemaExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('schema');
    var directives = this.parseDirectives(true);
    var operationTypes = this.optionalMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, this.parseOperationTypeDefinition, __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].BRACE_R);

    if (directives.length === 0 && operationTypes.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION,
      directives: directives,
      operationTypes: operationTypes,
      loc: this.loc(start)
    };
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  ;

  _proto.parseScalarTypeExtension = function parseScalarTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('scalar');
    var name = this.parseName();
    var directives = this.parseDirectives(true);

    if (directives.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION,
      name: name,
      directives: directives,
      loc: this.loc(start)
    };
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  ;

  _proto.parseObjectTypeExtension = function parseObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('type');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  ;

  _proto.parseInterfaceTypeExtension = function parseInterfaceTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('interface');
    var name = this.parseName();
    var interfaces = this.parseImplementsInterfaces();
    var directives = this.parseDirectives(true);
    var fields = this.parseFieldsDefinition();

    if (interfaces.length === 0 && directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION,
      name: name,
      interfaces: interfaces,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  ;

  _proto.parseUnionTypeExtension = function parseUnionTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('union');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var types = this.parseUnionMemberTypes();

    if (directives.length === 0 && types.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION,
      name: name,
      directives: directives,
      types: types,
      loc: this.loc(start)
    };
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  ;

  _proto.parseEnumTypeExtension = function parseEnumTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('enum');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var values = this.parseEnumValuesDefinition();

    if (directives.length === 0 && values.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION,
      name: name,
      directives: directives,
      values: values,
      loc: this.loc(start)
    };
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  ;

  _proto.parseInputObjectTypeExtension = function parseInputObjectTypeExtension() {
    var start = this._lexer.token;
    this.expectKeyword('extend');
    this.expectKeyword('input');
    var name = this.parseName();
    var directives = this.parseDirectives(true);
    var fields = this.parseInputFieldsDefinition();

    if (directives.length === 0 && fields.length === 0) {
      throw this.unexpected();
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION,
      name: name,
      directives: directives,
      fields: fields,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   */
  ;

  _proto.parseDirectiveDefinition = function parseDirectiveDefinition() {
    var start = this._lexer.token;
    var description = this.parseDescription();
    this.expectKeyword('directive');
    this.expectToken(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].AT);
    var name = this.parseName();
    var args = this.parseArgumentDefs();
    var repeatable = this.expectOptionalKeyword('repeatable');
    this.expectKeyword('on');
    var locations = this.parseDirectiveLocations();
    return {
      kind: __WEBPACK_IMPORTED_MODULE_1__kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION,
      description: description,
      name: name,
      arguments: args,
      repeatable: repeatable,
      locations: locations,
      loc: this.loc(start)
    };
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  ;

  _proto.parseDirectiveLocations = function parseDirectiveLocations() {
    return this.delimitedMany(__WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  ;

  _proto.parseDirectiveLocation = function parseDirectiveLocation() {
    var start = this._lexer.token;
    var name = this.parseName();

    if (__WEBPACK_IMPORTED_MODULE_5__directiveLocation_mjs__["a" /* DirectiveLocation */][name.value] !== undefined) {
      return name;
    }

    throw this.unexpected(start);
  } // Core parsing utility functions

  /**
   * Returns a location object, used to identify the place in the source that created a given parsed object.
   */
  ;

  _proto.loc = function loc(startToken) {
    var _this$_options4;

    if (((_this$_options4 = this._options) === null || _this$_options4 === void 0 ? void 0 : _this$_options4.noLocation) !== true) {
      return new __WEBPACK_IMPORTED_MODULE_2__ast_mjs__["a" /* Location */](startToken, this._lexer.lastToken, this._lexer.source);
    }
  }
  /**
   * Determines if the next token is of a given kind
   */
  ;

  _proto.peek = function peek(kind) {
    return this._lexer.token.kind === kind;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectToken = function expectToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(this._lexer.source, token.start, "Expected ".concat(getTokenKindDesc(kind), ", found ").concat(getTokenDesc(token), "."));
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and return undefined.
   */
  ;

  _proto.expectOptionalToken = function expectOptionalToken(kind) {
    var token = this._lexer.token;

    if (token.kind === kind) {
      this._lexer.advance();

      return token;
    }

    return undefined;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  ;

  _proto.expectKeyword = function expectKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME && token.value === value) {
      this._lexer.advance();
    } else {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(this._lexer.source, token.start, "Expected \"".concat(value, "\", found ").concat(getTokenDesc(token), "."));
    }
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  ;

  _proto.expectOptionalKeyword = function expectOptionalKeyword(value) {
    var token = this._lexer.token;

    if (token.kind === __WEBPACK_IMPORTED_MODULE_3__tokenKind_mjs__["a" /* TokenKind */].NAME && token.value === value) {
      this._lexer.advance();

      return true;
    }

    return false;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  ;

  _proto.unexpected = function unexpected(atToken) {
    var token = atToken !== null && atToken !== void 0 ? atToken : this._lexer.token;
    return Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(this._lexer.source, token.start, "Unexpected ".concat(getTokenDesc(token), "."));
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.any = function any(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    while (!this.expectOptionalToken(closeKind)) {
      nodes.push(parseFn.call(this));
    }

    return nodes;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.optionalMany = function optionalMany(openKind, parseFn, closeKind) {
    if (this.expectOptionalToken(openKind)) {
      var nodes = [];

      do {
        nodes.push(parseFn.call(this));
      } while (!this.expectOptionalToken(closeKind));

      return nodes;
    }

    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  ;

  _proto.many = function many(openKind, parseFn, closeKind) {
    this.expectToken(openKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (!this.expectOptionalToken(closeKind));

    return nodes;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  ;

  _proto.delimitedMany = function delimitedMany(delimiterKind, parseFn) {
    this.expectOptionalToken(delimiterKind);
    var nodes = [];

    do {
      nodes.push(parseFn.call(this));
    } while (this.expectOptionalToken(delimiterKind));

    return nodes;
  };

  return Parser;
}();
/**
 * A helper function to describe a token as a string for debugging.
 */

function getTokenDesc(token) {
  var value = token.value;
  return getTokenKindDesc(token.kind) + (value != null ? " \"".concat(value, "\"") : '');
}
/**
 * A helper function to describe a token kind as a string for debugging.
 */


function getTokenKindDesc(kind) {
  return Object(__WEBPACK_IMPORTED_MODULE_6__lexer_mjs__["b" /* isPunctuatorTokenKind */])(kind) ? "\"".concat(kind, "\"") : kind;
}


/***/ }),
/* 156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Location; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Token; });
/* harmony export (immutable) */ __webpack_exports__["c"] = isNode;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_defineInspect_mjs__ = __webpack_require__(304);


/**
 * Contains a range of UTF-8 character offsets and token references that
 * identify the region of the source from which the AST derived.
 */
var Location = /*#__PURE__*/function () {
  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The Token at which this Node begins.
   */

  /**
   * The Token at which this Node ends.
   */

  /**
   * The Source document the AST represents.
   */
  function Location(startToken, endToken, source) {
    this.start = startToken.start;
    this.end = endToken.end;
    this.startToken = startToken;
    this.endToken = endToken;
    this.source = source;
  }

  var _proto = Location.prototype;

  _proto.toJSON = function toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  };

  return Location;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_defineInspect_mjs__["a" /* default */])(Location);
/**
 * Represents a range of characters represented by a lexical token
 * within a Source.
 */

var Token = /*#__PURE__*/function () {
  /**
   * The kind of Token.
   */

  /**
   * The character offset at which this Node begins.
   */

  /**
   * The character offset at which this Node ends.
   */

  /**
   * The 1-indexed line number on which this Token appears.
   */

  /**
   * The 1-indexed column number at which this Token begins.
   */

  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   */

  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  function Token(kind, start, end, line, column, prev, value) {
    this.kind = kind;
    this.start = start;
    this.end = end;
    this.line = line;
    this.column = column;
    this.value = value;
    this.prev = prev;
    this.next = null;
  }

  var _proto2 = Token.prototype;

  _proto2.toJSON = function toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  };

  return Token;
}(); // Print a simplified form when appearing in `inspect` and `util.inspect`.

Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_defineInspect_mjs__["a" /* default */])(Token);
/**
 * @internal
 */

function isNode(maybeNode) {
  return maybeNode != null && typeof maybeNode.kind === 'string';
}
/**
 * The list of all possible AST node types.
 */


/***/ }),
/* 157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TokenKind; });
/**
 * An exported enum describing the different kinds of tokens that the
 * lexer emits.
 */
var TokenKind = Object.freeze({
  SOF: '<SOF>',
  EOF: '<EOF>',
  BANG: '!',
  DOLLAR: '$',
  AMP: '&',
  PAREN_L: '(',
  PAREN_R: ')',
  SPREAD: '...',
  COLON: ':',
  EQUALS: '=',
  AT: '@',
  BRACKET_L: '[',
  BRACKET_R: ']',
  BRACE_L: '{',
  PIPE: '|',
  BRACE_R: '}',
  NAME: 'Name',
  INT: 'Int',
  FLOAT: 'Float',
  STRING: 'String',
  BLOCK_STRING: 'BlockString',
  COMMENT: 'Comment'
});
/**
 * The enum type representing the token kinds values.
 */


/***/ }),
/* 158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DirectiveLocation; });
/**
 * The set of allowed directive location values.
 */
var DirectiveLocation = Object.freeze({
  // Request Definitions
  QUERY: 'QUERY',
  MUTATION: 'MUTATION',
  SUBSCRIPTION: 'SUBSCRIPTION',
  FIELD: 'FIELD',
  FRAGMENT_DEFINITION: 'FRAGMENT_DEFINITION',
  FRAGMENT_SPREAD: 'FRAGMENT_SPREAD',
  INLINE_FRAGMENT: 'INLINE_FRAGMENT',
  VARIABLE_DEFINITION: 'VARIABLE_DEFINITION',
  // Type System Definitions
  SCHEMA: 'SCHEMA',
  SCALAR: 'SCALAR',
  OBJECT: 'OBJECT',
  FIELD_DEFINITION: 'FIELD_DEFINITION',
  ARGUMENT_DEFINITION: 'ARGUMENT_DEFINITION',
  INTERFACE: 'INTERFACE',
  UNION: 'UNION',
  ENUM: 'ENUM',
  ENUM_VALUE: 'ENUM_VALUE',
  INPUT_OBJECT: 'INPUT_OBJECT',
  INPUT_FIELD_DEFINITION: 'INPUT_FIELD_DEFINITION'
});
/**
 * The enum type representing the directive location values.
 */


/***/ }),
/* 159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = dedentBlockStringValue;
/* harmony export (immutable) */ __webpack_exports__["b"] = getBlockStringIndentation;
/* harmony export (immutable) */ __webpack_exports__["c"] = printBlockString;
/**
 * Produces the value of a block string from its parsed raw value, similar to
 * CoffeeScript's block string, Python's docstring trim or Ruby's strip_heredoc.
 *
 * This implements the GraphQL spec's BlockStringValue() static algorithm.
 *
 * @internal
 */
function dedentBlockStringValue(rawString) {
  // Expand a block string's raw value into independent lines.
  var lines = rawString.split(/\r\n|[\n\r]/g); // Remove common indentation from all lines but first.

  var commonIndent = getBlockStringIndentation(rawString);

  if (commonIndent !== 0) {
    for (var i = 1; i < lines.length; i++) {
      lines[i] = lines[i].slice(commonIndent);
    }
  } // Remove leading and trailing blank lines.


  var startLine = 0;

  while (startLine < lines.length && isBlank(lines[startLine])) {
    ++startLine;
  }

  var endLine = lines.length;

  while (endLine > startLine && isBlank(lines[endLine - 1])) {
    --endLine;
  } // Return a string of the lines joined with U+000A.


  return lines.slice(startLine, endLine).join('\n');
}

function isBlank(str) {
  for (var i = 0; i < str.length; ++i) {
    if (str[i] !== ' ' && str[i] !== '\t') {
      return false;
    }
  }

  return true;
}
/**
 * @internal
 */


function getBlockStringIndentation(value) {
  var _commonIndent;

  var isFirstLine = true;
  var isEmptyLine = true;
  var indent = 0;
  var commonIndent = null;

  for (var i = 0; i < value.length; ++i) {
    switch (value.charCodeAt(i)) {
      case 13:
        //  \r
        if (value.charCodeAt(i + 1) === 10) {
          ++i; // skip \r\n as one symbol
        }

      // falls through

      case 10:
        //  \n
        isFirstLine = false;
        isEmptyLine = true;
        indent = 0;
        break;

      case 9: //   \t

      case 32:
        //  <space>
        ++indent;
        break;

      default:
        if (isEmptyLine && !isFirstLine && (commonIndent === null || indent < commonIndent)) {
          commonIndent = indent;
        }

        isEmptyLine = false;
    }
  }

  return (_commonIndent = commonIndent) !== null && _commonIndent !== void 0 ? _commonIndent : 0;
}
/**
 * Print a block string in the indented block form by adding a leading and
 * trailing blank line. However, if a block string starts with whitespace and is
 * a single-line, adding a leading blank line would strip that whitespace.
 *
 * @internal
 */

function printBlockString(value) {
  var indentation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var preferMultipleLines = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var isSingleLine = value.indexOf('\n') === -1;
  var hasLeadingSpace = value[0] === ' ' || value[0] === '\t';
  var hasTrailingQuote = value[value.length - 1] === '"';
  var hasTrailingSlash = value[value.length - 1] === '\\';
  var printAsMultipleLines = !isSingleLine || hasTrailingQuote || hasTrailingSlash || preferMultipleLines;
  var result = ''; // Format a multi-line block quote to account for leading space.

  if (printAsMultipleLines && !(isSingleLine && hasLeadingSpace)) {
    result += '\n' + indentation;
  }

  result += indentation ? value.replace(/\n/g, '\n' + indentation) : value;

  if (printAsMultipleLines) {
    result += '\n';
  }

  return '"""' + result.replace(/"""/g, '\\"""') + '"""';
}


/***/ }),
/* 160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = validate;
/* unused harmony export validateSDL */
/* harmony export (immutable) */ __webpack_exports__["a"] = assertValidSDL;
/* harmony export (immutable) */ __webpack_exports__["b"] = assertValidSDLExtension;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_visitor_mjs__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_validate_mjs__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_TypeInfo_mjs__ = __webpack_require__(309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__specifiedRules_mjs__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ValidationContext_mjs__ = __webpack_require__(583);







/**
 * Implements the "Validation" section of the spec.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the document is valid.
 *
 * A list of specific validation rules may be provided. If not provided, the
 * default list of rules defined by the GraphQL specification will be used.
 *
 * Each validation rules is a function which returns a visitor
 * (see the language/visitor API). Visitor methods are expected to return
 * GraphQLErrors, or Arrays of GraphQLErrors when invalid.
 *
 * Optionally a custom TypeInfo instance may be provided. If not provided, one
 * will be created from the provided schema.
 */

function validate(schema, documentAST) {
  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__specifiedRules_mjs__["a" /* specifiedRules */];
  var typeInfo = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : new __WEBPACK_IMPORTED_MODULE_4__utilities_TypeInfo_mjs__["a" /* TypeInfo */](schema);
  var options = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
    maxErrors: undefined
  };
  documentAST || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide document.'); // If the schema used for validation is invalid, throw an error.

  Object(__WEBPACK_IMPORTED_MODULE_3__type_validate_mjs__["a" /* assertValidSchema */])(schema);
  var abortObj = Object.freeze({});
  var errors = [];
  var context = new __WEBPACK_IMPORTED_MODULE_6__ValidationContext_mjs__["b" /* ValidationContext */](schema, documentAST, typeInfo, function (error) {
    if (options.maxErrors != null && errors.length >= options.maxErrors) {
      errors.push(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]('Too many validation errors, error limit reached. Validation aborted.'));
      throw abortObj;
    }

    errors.push(error);
  }); // This uses a specialized visitor which runs multiple visitors in parallel,
  // while maintaining the visitor skip and break API.

  var visitor = Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor_mjs__["c" /* visitInParallel */])(rules.map(function (rule) {
    return rule(context);
  })); // Visit the whole document with each instance of all provided rules.

  try {
    Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor_mjs__["b" /* visit */])(documentAST, Object(__WEBPACK_IMPORTED_MODULE_4__utilities_TypeInfo_mjs__["b" /* visitWithTypeInfo */])(typeInfo, visitor));
  } catch (e) {
    if (e !== abortObj) {
      throw e;
    }
  }

  return errors;
}
/**
 * @internal
 */

function validateSDL(documentAST, schemaToExtend) {
  var rules = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : __WEBPACK_IMPORTED_MODULE_5__specifiedRules_mjs__["b" /* specifiedSDLRules */];
  var errors = [];
  var context = new __WEBPACK_IMPORTED_MODULE_6__ValidationContext_mjs__["a" /* SDLValidationContext */](documentAST, schemaToExtend, function (error) {
    errors.push(error);
  });
  var visitors = rules.map(function (rule) {
    return rule(context);
  });
  Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor_mjs__["b" /* visit */])(documentAST, Object(__WEBPACK_IMPORTED_MODULE_2__language_visitor_mjs__["c" /* visitInParallel */])(visitors));
  return errors;
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDL(documentAST) {
  var errors = validateSDL(documentAST);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}
/**
 * Utility function which asserts a SDL document is valid by throwing an error
 * if it is invalid.
 *
 * @internal
 */

function assertValidSDLExtension(documentAST, schema) {
  var errors = validateSDL(documentAST, schema);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}


/***/ }),
/* 161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound]
var find = Array.prototype.find ? function (list, predicate) {
  return Array.prototype.find.call(list, predicate);
} : function (list, predicate) {
  for (var _i2 = 0; _i2 < list.length; _i2++) {
    var value = list[_i2];

    if (predicate(value)) {
      return value;
    }
  }
};
/* harmony default export */ __webpack_exports__["a"] = (find);


/***/ }),
/* 162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var objectEntries = Object.entries || function (obj) {
  return Object.keys(obj).map(function (key) {
    return [key, obj[key]];
  });
};

/* harmony default export */ __webpack_exports__["a"] = (objectEntries);


/***/ }),
/* 163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditcheckList_vue__ = __webpack_require__(1140);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607d4978_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreditcheckList_vue__ = __webpack_require__(1141);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditcheckList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_607d4978_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreditcheckList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__ = __webpack_require__(1254);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c90a5e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__ = __webpack_require__(1255);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Message_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53c90a5e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Message_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__inspect_mjs__ = __webpack_require__(21);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * A replacement for instanceof which includes an error warning when multi-realm
 * constructors are detected.
 */

// See: https://expressjs.com/en/advanced/best-practice-performance.html#set-node_env-to-production
// See: https://webpack.js.org/guides/production/
/* harmony default export */ __webpack_exports__["a"] = ( true ? // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
// eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  return value instanceof constructor;
} : // eslint-disable-next-line no-shadow
function instanceOf(value, constructor) {
  if (value instanceof constructor) {
    return true;
  }

  if (_typeof(value) === 'object' && value !== null) {
    var _value$constructor;

    var className = constructor.prototype[Symbol.toStringTag];
    var valueClassName = // We still need to support constructor's name to detect conflicts with older versions of this library.
    Symbol.toStringTag in value ? value[Symbol.toStringTag] : (_value$constructor = value.constructor) === null || _value$constructor === void 0 ? void 0 : _value$constructor.name;

    if (className === valueClassName) {
      var stringifiedValue = inspect(value);
      throw new Error("Cannot use ".concat(className, " \"").concat(stringifiedValue, "\" from another module or realm.\n\nEnsure that there is only one instance of \"graphql\" in the node_modules\ndirectory. If different versions of \"graphql\" are the dependencies of other\nrelied on modules, use \"resolutions\" to ensure only one version is installed.\n\nhttps://yarnpkg.com/en/docs/selective-version-resolutions\n\nDuplicate \"graphql\" modules cannot be used at the same time since different\nversions may have different capabilities and behavior. The data from one\nversion used in the function from another could produce confusing and\nspurious results."));
    }
  }

  return false;
});


/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = validateSchema;
/* harmony export (immutable) */ __webpack_exports__["a"] = assertValidSchema;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_locatedError_mjs__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_assertValidName_mjs__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utilities_typeComparators_mjs__ = __webpack_require__(203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__schema_mjs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__definition_mjs__ = __webpack_require__(20);











/**
 * Implements the "Type Validation" sub-sections of the specification's
 * "Type System" section.
 *
 * Validation runs synchronously, returning an array of encountered errors, or
 * an empty array if no errors were encountered and the Schema is valid.
 */

function validateSchema(schema) {
  // First check to ensure the provided value is in fact a GraphQLSchema.
  Object(__WEBPACK_IMPORTED_MODULE_7__schema_mjs__["b" /* assertSchema */])(schema); // If this Schema has already been validated, return the previous results.

  if (schema.__validationErrors) {
    return schema.__validationErrors;
  } // Validate the schema, producing a list of errors.


  var context = new SchemaValidationContext(schema);
  validateRootTypes(context);
  validateDirectives(context);
  validateTypes(context); // Persist the results of validation before returning to ensure validation
  // does not run multiple times for this schema.

  var errors = context.getErrors();
  schema.__validationErrors = errors;
  return errors;
}
/**
 * Utility function which asserts a schema is valid by throwing an error if
 * it is invalid.
 */

function assertValidSchema(schema) {
  var errors = validateSchema(schema);

  if (errors.length !== 0) {
    throw new Error(errors.map(function (error) {
      return error.message;
    }).join('\n\n'));
  }
}

var SchemaValidationContext = /*#__PURE__*/function () {
  function SchemaValidationContext(schema) {
    this._errors = [];
    this.schema = schema;
  }

  var _proto = SchemaValidationContext.prototype;

  _proto.reportError = function reportError(message, nodes) {
    var _nodes = Array.isArray(nodes) ? nodes.filter(Boolean) : nodes;

    this.addError(new __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__["a" /* GraphQLError */](message, _nodes));
  };

  _proto.addError = function addError(error) {
    this._errors.push(error);
  };

  _proto.getErrors = function getErrors() {
    return this._errors;
  };

  return SchemaValidationContext;
}();

function validateRootTypes(context) {
  var schema = context.schema;
  var queryType = schema.getQueryType();

  if (!queryType) {
    context.reportError('Query root type must be provided.', schema.astNode);
  } else if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["y" /* isObjectType */])(queryType)) {
    var _getOperationTypeNode;

    context.reportError("Query root type must be Object type, it cannot be ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(queryType), "."), (_getOperationTypeNode = getOperationTypeNode(schema, 'query')) !== null && _getOperationTypeNode !== void 0 ? _getOperationTypeNode : queryType.astNode);
  }

  var mutationType = schema.getMutationType();

  if (mutationType && !Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["y" /* isObjectType */])(mutationType)) {
    var _getOperationTypeNode2;

    context.reportError('Mutation root type must be Object type if provided, it cannot be ' + "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(mutationType), "."), (_getOperationTypeNode2 = getOperationTypeNode(schema, 'mutation')) !== null && _getOperationTypeNode2 !== void 0 ? _getOperationTypeNode2 : mutationType.astNode);
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && !Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["y" /* isObjectType */])(subscriptionType)) {
    var _getOperationTypeNode3;

    context.reportError('Subscription root type must be Object type if provided, it cannot be ' + "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(subscriptionType), "."), (_getOperationTypeNode3 = getOperationTypeNode(schema, 'subscription')) !== null && _getOperationTypeNode3 !== void 0 ? _getOperationTypeNode3 : subscriptionType.astNode);
  }
}

function getOperationTypeNode(schema, operation) {
  var operationNodes = getAllSubNodes(schema, function (node) {
    return node.operationTypes;
  });

  for (var _i2 = 0; _i2 < operationNodes.length; _i2++) {
    var node = operationNodes[_i2];

    if (node.operation === operation) {
      return node.type;
    }
  }

  return undefined;
}

function validateDirectives(context) {
  for (var _i4 = 0, _context$schema$getDi2 = context.schema.getDirectives(); _i4 < _context$schema$getDi2.length; _i4++) {
    var directive = _context$schema$getDi2[_i4];

    // Ensure all directives are in fact GraphQL directives.
    if (!Object(__WEBPACK_IMPORTED_MODULE_9__directives_mjs__["g" /* isDirective */])(directive)) {
      context.reportError("Expected directive but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(directive), "."), directive === null || directive === void 0 ? void 0 : directive.astNode);
      continue;
    } // Ensure they are named correctly.


    validateName(context, directive); // TODO: Ensure proper locations.
    // Ensure the arguments are valid.

    for (var _i6 = 0, _directive$args2 = directive.args; _i6 < _directive$args2.length; _i6++) {
      var arg = _directive$args2[_i6];
      // Ensure they are named correctly.
      validateName(context, arg); // Ensure the type is an input type.

      if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["s" /* isInputType */])(arg.type)) {
        context.reportError("The type of @".concat(directive.name, "(").concat(arg.name, ":) must be Input Type ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(arg.type), "."), arg.astNode);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["A" /* isRequiredArgument */])(arg) && arg.deprecationReason != null) {
        var _arg$astNode;

        context.reportError("Required argument @".concat(directive.name, "(").concat(arg.name, ":) cannot be deprecated."), [getDeprecatedDirectiveNode(arg.astNode), // istanbul ignore next (TODO need to write coverage tests)
        (_arg$astNode = arg.astNode) === null || _arg$astNode === void 0 ? void 0 : _arg$astNode.type]);
      }
    }
  }
}

function validateName(context, node) {
  // Ensure names are valid, however introspection types opt out.
  var error = Object(__WEBPACK_IMPORTED_MODULE_5__utilities_assertValidName_mjs__["a" /* isValidNameError */])(node.name);

  if (error) {
    context.addError(Object(__WEBPACK_IMPORTED_MODULE_4__error_locatedError_mjs__["a" /* locatedError */])(error, node.astNode));
  }
}

function validateTypes(context) {
  var validateInputObjectCircularRefs = createInputObjectCircularRefsValidator(context);
  var typeMap = context.schema.getTypeMap();

  for (var _i8 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(typeMap); _i8 < _objectValues2.length; _i8++) {
    var type = _objectValues2[_i8];

    // Ensure all provided types are in fact GraphQL type.
    if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["w" /* isNamedType */])(type)) {
      context.reportError("Expected GraphQL named type but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), "."), type.astNode);
      continue;
    } // Ensure it is named correctly (excluding introspection types).


    if (!Object(__WEBPACK_IMPORTED_MODULE_8__introspection_mjs__["g" /* isIntrospectionType */])(type)) {
      validateName(context, type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["y" /* isObjectType */])(type)) {
      // Ensure fields are valid
      validateFields(context, type); // Ensure objects implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["t" /* isInterfaceType */])(type)) {
      // Ensure fields are valid.
      validateFields(context, type); // Ensure interfaces implement the interfaces they claim to.

      validateInterfaces(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["E" /* isUnionType */])(type)) {
      // Ensure Unions include valid member types.
      validateUnionMembers(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["q" /* isEnumType */])(type)) {
      // Ensure Enums have valid values.
      validateEnumValues(context, type);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["r" /* isInputObjectType */])(type)) {
      // Ensure Input Object fields are valid.
      validateInputFields(context, type); // Ensure Input Objects do not contain non-nullable circular references

      validateInputObjectCircularRefs(type);
    }
  }
}

function validateFields(context, type) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()); // Objects and Interfaces both must define one or more fields.

  if (fields.length === 0) {
    context.reportError("Type ".concat(type.name, " must define one or more fields."), getAllNodes(type));
  }

  for (var _i10 = 0; _i10 < fields.length; _i10++) {
    var field = fields[_i10];
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an output type

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["z" /* isOutputType */])(field.type)) {
      var _field$astNode;

      context.reportError("The type of ".concat(type.name, ".").concat(field.name, " must be Output Type ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(field.type), "."), (_field$astNode = field.astNode) === null || _field$astNode === void 0 ? void 0 : _field$astNode.type);
    } // Ensure the arguments are valid


    for (var _i12 = 0, _field$args2 = field.args; _i12 < _field$args2.length; _i12++) {
      var arg = _field$args2[_i12];
      var argName = arg.name; // Ensure they are named correctly.

      validateName(context, arg); // Ensure the type is an input type

      if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["s" /* isInputType */])(arg.type)) {
        var _arg$astNode2;

        context.reportError("The type of ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) must be Input ") + "Type but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(arg.type), "."), (_arg$astNode2 = arg.astNode) === null || _arg$astNode2 === void 0 ? void 0 : _arg$astNode2.type);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["A" /* isRequiredArgument */])(arg) && arg.deprecationReason != null) {
        var _arg$astNode3;

        context.reportError("Required argument ".concat(type.name, ".").concat(field.name, "(").concat(argName, ":) cannot be deprecated."), [getDeprecatedDirectiveNode(arg.astNode), // istanbul ignore next (TODO need to write coverage tests)
        (_arg$astNode3 = arg.astNode) === null || _arg$astNode3 === void 0 ? void 0 : _arg$astNode3.type]);
      }
    }
  }
}

function validateInterfaces(context, type) {
  var ifaceTypeNames = Object.create(null);

  for (var _i14 = 0, _type$getInterfaces2 = type.getInterfaces(); _i14 < _type$getInterfaces2.length; _i14++) {
    var iface = _type$getInterfaces2[_i14];

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["t" /* isInterfaceType */])(iface)) {
      context.reportError("Type ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), " must only implement Interface types, ") + "it cannot implement ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(iface), "."), getAllImplementsInterfaceNodes(type, iface));
      continue;
    }

    if (type === iface) {
      context.reportError("Type ".concat(type.name, " cannot implement itself because it would create a circular reference."), getAllImplementsInterfaceNodes(type, iface));
      continue;
    }

    if (ifaceTypeNames[iface.name]) {
      context.reportError("Type ".concat(type.name, " can only implement ").concat(iface.name, " once."), getAllImplementsInterfaceNodes(type, iface));
      continue;
    }

    ifaceTypeNames[iface.name] = true;
    validateTypeImplementsAncestors(context, type, iface);
    validateTypeImplementsInterface(context, type, iface);
  }
}

function validateTypeImplementsInterface(context, type, iface) {
  var typeFieldMap = type.getFields(); // Assert each interface field is implemented.

  for (var _i16 = 0, _objectValues4 = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(iface.getFields()); _i16 < _objectValues4.length; _i16++) {
    var ifaceField = _objectValues4[_i16];
    var fieldName = ifaceField.name;
    var typeField = typeFieldMap[fieldName]; // Assert interface field exists on type.

    if (!typeField) {
      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expected but ").concat(type.name, " does not provide it."), [ifaceField.astNode].concat(getAllNodes(type)));
      continue;
    } // Assert interface field type is satisfied by type field type, by being
    // a valid subtype. (covariant)


    if (!Object(__WEBPACK_IMPORTED_MODULE_6__utilities_typeComparators_mjs__["c" /* isTypeSubTypeOf */])(context.schema, typeField.type, ifaceField.type)) {
      var _ifaceField$astNode, _typeField$astNode;

      context.reportError("Interface field ".concat(iface.name, ".").concat(fieldName, " expects type ") + "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(ifaceField.type), " but ").concat(type.name, ".").concat(fieldName, " ") + "is type ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(typeField.type), "."), [// istanbul ignore next (TODO need to write coverage tests)
      (_ifaceField$astNode = ifaceField.astNode) === null || _ifaceField$astNode === void 0 ? void 0 : _ifaceField$astNode.type, // istanbul ignore next (TODO need to write coverage tests)
      (_typeField$astNode = typeField.astNode) === null || _typeField$astNode === void 0 ? void 0 : _typeField$astNode.type]);
    } // Assert each interface field arg is implemented.


    var _loop = function _loop(_i18, _ifaceField$args2) {
      var ifaceArg = _ifaceField$args2[_i18];
      var argName = ifaceArg.name;
      var typeArg = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(typeField.args, function (arg) {
        return arg.name === argName;
      }); // Assert interface field arg exists on object field.

      if (!typeArg) {
        context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) expected but ").concat(type.name, ".").concat(fieldName, " does not provide it."), [ifaceArg.astNode, typeField.astNode]);
        return "continue";
      } // Assert interface field arg type matches object field arg type.
      // (invariant)
      // TODO: change to contravariant?


      if (!Object(__WEBPACK_IMPORTED_MODULE_6__utilities_typeComparators_mjs__["b" /* isEqualType */])(ifaceArg.type, typeArg.type)) {
        var _ifaceArg$astNode, _typeArg$astNode;

        context.reportError("Interface field argument ".concat(iface.name, ".").concat(fieldName, "(").concat(argName, ":) ") + "expects type ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(ifaceArg.type), " but ") + "".concat(type.name, ".").concat(fieldName, "(").concat(argName, ":) is type ") + "".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(typeArg.type), "."), [// istanbul ignore next (TODO need to write coverage tests)
        (_ifaceArg$astNode = ifaceArg.astNode) === null || _ifaceArg$astNode === void 0 ? void 0 : _ifaceArg$astNode.type, // istanbul ignore next (TODO need to write coverage tests)
        (_typeArg$astNode = typeArg.astNode) === null || _typeArg$astNode === void 0 ? void 0 : _typeArg$astNode.type]);
      } // TODO: validate default values?

    };

    for (var _i18 = 0, _ifaceField$args2 = ifaceField.args; _i18 < _ifaceField$args2.length; _i18++) {
      var _ret = _loop(_i18, _ifaceField$args2);

      if (_ret === "continue") continue;
    } // Assert additional arguments must not be required.


    var _loop2 = function _loop2(_i20, _typeField$args2) {
      var typeArg = _typeField$args2[_i20];
      var argName = typeArg.name;
      var ifaceArg = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(ifaceField.args, function (arg) {
        return arg.name === argName;
      });

      if (!ifaceArg && Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["A" /* isRequiredArgument */])(typeArg)) {
        context.reportError("Object field ".concat(type.name, ".").concat(fieldName, " includes required argument ").concat(argName, " that is missing from the Interface field ").concat(iface.name, ".").concat(fieldName, "."), [typeArg.astNode, ifaceField.astNode]);
      }
    };

    for (var _i20 = 0, _typeField$args2 = typeField.args; _i20 < _typeField$args2.length; _i20++) {
      _loop2(_i20, _typeField$args2);
    }
  }
}

function validateTypeImplementsAncestors(context, type, iface) {
  var ifaceInterfaces = type.getInterfaces();

  for (var _i22 = 0, _iface$getInterfaces2 = iface.getInterfaces(); _i22 < _iface$getInterfaces2.length; _i22++) {
    var transitive = _iface$getInterfaces2[_i22];

    if (ifaceInterfaces.indexOf(transitive) === -1) {
      context.reportError(transitive === type ? "Type ".concat(type.name, " cannot implement ").concat(iface.name, " because it would create a circular reference.") : "Type ".concat(type.name, " must implement ").concat(transitive.name, " because it is implemented by ").concat(iface.name, "."), [].concat(getAllImplementsInterfaceNodes(iface, transitive), getAllImplementsInterfaceNodes(type, iface)));
    }
  }
}

function validateUnionMembers(context, union) {
  var memberTypes = union.getTypes();

  if (memberTypes.length === 0) {
    context.reportError("Union type ".concat(union.name, " must define one or more member types."), getAllNodes(union));
  }

  var includedTypeNames = Object.create(null);

  for (var _i24 = 0; _i24 < memberTypes.length; _i24++) {
    var memberType = memberTypes[_i24];

    if (includedTypeNames[memberType.name]) {
      context.reportError("Union type ".concat(union.name, " can only include type ").concat(memberType.name, " once."), getUnionMemberTypeNodes(union, memberType.name));
      continue;
    }

    includedTypeNames[memberType.name] = true;

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["y" /* isObjectType */])(memberType)) {
      context.reportError("Union type ".concat(union.name, " can only include Object types, ") + "it cannot include ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(memberType), "."), getUnionMemberTypeNodes(union, String(memberType)));
    }
  }
}

function validateEnumValues(context, enumType) {
  var enumValues = enumType.getValues();

  if (enumValues.length === 0) {
    context.reportError("Enum type ".concat(enumType.name, " must define one or more values."), getAllNodes(enumType));
  }

  for (var _i26 = 0; _i26 < enumValues.length; _i26++) {
    var enumValue = enumValues[_i26];
    var valueName = enumValue.name; // Ensure valid name.

    validateName(context, enumValue);

    if (valueName === 'true' || valueName === 'false' || valueName === 'null') {
      context.reportError("Enum type ".concat(enumType.name, " cannot include value: ").concat(valueName, "."), enumValue.astNode);
    }
  }
}

function validateInputFields(context, inputObj) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(inputObj.getFields());

  if (fields.length === 0) {
    context.reportError("Input Object type ".concat(inputObj.name, " must define one or more fields."), getAllNodes(inputObj));
  } // Ensure the arguments are valid


  for (var _i28 = 0; _i28 < fields.length; _i28++) {
    var field = fields[_i28];
    // Ensure they are named correctly.
    validateName(context, field); // Ensure the type is an input type

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["s" /* isInputType */])(field.type)) {
      var _field$astNode2;

      context.reportError("The type of ".concat(inputObj.name, ".").concat(field.name, " must be Input Type ") + "but got: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(field.type), "."), (_field$astNode2 = field.astNode) === null || _field$astNode2 === void 0 ? void 0 : _field$astNode2.type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["B" /* isRequiredInputField */])(field) && field.deprecationReason != null) {
      var _field$astNode3;

      context.reportError("Required input field ".concat(inputObj.name, ".").concat(field.name, " cannot be deprecated."), [getDeprecatedDirectiveNode(field.astNode), // istanbul ignore next (TODO need to write coverage tests)
      (_field$astNode3 = field.astNode) === null || _field$astNode3 === void 0 ? void 0 : _field$astNode3.type]);
    }
  }
}

function createInputObjectCircularRefsValidator(context) {
  // Modified copy of algorithm from 'src/validation/rules/NoFragmentCycles.js'.
  // Tracks already visited types to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  var visitedTypes = Object.create(null); // Array of types nodes used to produce meaningful errors

  var fieldPath = []; // Position in the type path

  var fieldPathIndexByTypeName = Object.create(null);
  return detectCycleRecursive; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(inputObj) {
    if (visitedTypes[inputObj.name]) {
      return;
    }

    visitedTypes[inputObj.name] = true;
    fieldPathIndexByTypeName[inputObj.name] = fieldPath.length;
    var fields = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(inputObj.getFields());

    for (var _i30 = 0; _i30 < fields.length; _i30++) {
      var field = fields[_i30];

      if (Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["x" /* isNonNullType */])(field.type) && Object(__WEBPACK_IMPORTED_MODULE_10__definition_mjs__["r" /* isInputObjectType */])(field.type.ofType)) {
        var fieldType = field.type.ofType;
        var cycleIndex = fieldPathIndexByTypeName[fieldType.name];
        fieldPath.push(field);

        if (cycleIndex === undefined) {
          detectCycleRecursive(fieldType);
        } else {
          var cyclePath = fieldPath.slice(cycleIndex);
          var pathStr = cyclePath.map(function (fieldObj) {
            return fieldObj.name;
          }).join('.');
          context.reportError("Cannot reference Input Object \"".concat(fieldType.name, "\" within itself through a series of non-null fields: \"").concat(pathStr, "\"."), cyclePath.map(function (fieldObj) {
            return fieldObj.astNode;
          }));
        }

        fieldPath.pop();
      }
    }

    fieldPathIndexByTypeName[inputObj.name] = undefined;
  }
}

function getAllNodes(object) {
  var astNode = object.astNode,
      extensionASTNodes = object.extensionASTNodes;
  return astNode ? extensionASTNodes ? [astNode].concat(extensionASTNodes) : [astNode] : extensionASTNodes !== null && extensionASTNodes !== void 0 ? extensionASTNodes : [];
}

function getAllSubNodes(object, getter) {
  var subNodes = [];

  for (var _i32 = 0, _getAllNodes2 = getAllNodes(object); _i32 < _getAllNodes2.length; _i32++) {
    var _getter;

    var node = _getAllNodes2[_i32];
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    subNodes = subNodes.concat((_getter = getter(node)) !== null && _getter !== void 0 ? _getter : []);
  }

  return subNodes;
}

function getAllImplementsInterfaceNodes(type, iface) {
  return getAllSubNodes(type, function (typeNode) {
    return typeNode.interfaces;
  }).filter(function (ifaceNode) {
    return ifaceNode.name.value === iface.name;
  });
}

function getUnionMemberTypeNodes(union, typeName) {
  return getAllSubNodes(union, function (unionNode) {
    return unionNode.types;
  }).filter(function (typeNode) {
    return typeNode.name.value === typeName;
  });
}

function getDeprecatedDirectiveNode(definitionNode) {
  var _definitionNode$direc;

  // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
  return definitionNode === null || definitionNode === void 0 ? void 0 : (_definitionNode$direc = definitionNode.directives) === null || _definitionNode$direc === void 0 ? void 0 : _definitionNode$direc.find(function (node) {
    return node.name.value === __WEBPACK_IMPORTED_MODULE_9__directives_mjs__["b" /* GraphQLDeprecatedDirective */].name;
  });
}


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = locatedError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Given an arbitrary value, presumably thrown while attempting to execute a
 * GraphQL operation, produce a new GraphQLError aware of the location in the
 * document responsible for the original Error.
 */

function locatedError(rawOriginalError, nodes, path) {
  var _nodes;

  // Sometimes a non-error is thrown, wrap it as an Error instance to ensure a consistent Error interface.
  var originalError = rawOriginalError instanceof Error ? rawOriginalError : new Error('Unexpected error value: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(rawOriginalError)); // Note: this uses a brand-check to support GraphQL errors originating from other contexts.

  if (Array.isArray(originalError.path)) {
    return originalError;
  }

  return new __WEBPACK_IMPORTED_MODULE_1__GraphQLError_mjs__["a" /* GraphQLError */](originalError.message, (_nodes = originalError.nodes) !== null && _nodes !== void 0 ? _nodes : nodes, originalError.source, originalError.positions, path, originalError);
}


/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = isEqualType;
/* harmony export (immutable) */ __webpack_exports__["c"] = isTypeSubTypeOf;
/* harmony export (immutable) */ __webpack_exports__["a"] = doTypesOverlap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__ = __webpack_require__(20);

/**
 * Provided two types, return true if the types are equal (invariant).
 */

function isEqualType(typeA, typeB) {
  // Equivalent types are equal.
  if (typeA === typeB) {
    return true;
  } // If either type is non-null, the other must also be non-null.


  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["x" /* isNonNullType */])(typeA) && Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["x" /* isNonNullType */])(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // If either type is a list, the other must also be a list.


  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["v" /* isListType */])(typeA) && Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["v" /* isListType */])(typeB)) {
    return isEqualType(typeA.ofType, typeB.ofType);
  } // Otherwise the types are not equal.


  return false;
}
/**
 * Provided a type and a super type, return true if the first type is either
 * equal or a subset of the second super type (covariant).
 */

function isTypeSubTypeOf(schema, maybeSubType, superType) {
  // Equivalent type is a valid subtype
  if (maybeSubType === superType) {
    return true;
  } // If superType is non-null, maybeSubType must also be non-null.


  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["x" /* isNonNullType */])(superType)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["x" /* isNonNullType */])(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["x" /* isNonNullType */])(maybeSubType)) {
    // If superType is nullable, maybeSubType may be non-null or nullable.
    return isTypeSubTypeOf(schema, maybeSubType.ofType, superType);
  } // If superType type is a list, maybeSubType type must also be a list.


  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["v" /* isListType */])(superType)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["v" /* isListType */])(maybeSubType)) {
      return isTypeSubTypeOf(schema, maybeSubType.ofType, superType.ofType);
    }

    return false;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["v" /* isListType */])(maybeSubType)) {
    // If superType is not a list, maybeSubType must also be not a list.
    return false;
  } // If superType type is an abstract type, check if it is super type of maybeSubType.
  // Otherwise, the child type is not a valid subtype of the parent type.


  return Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["o" /* isAbstractType */])(superType) && (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["t" /* isInterfaceType */])(maybeSubType) || Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["y" /* isObjectType */])(maybeSubType)) && schema.isSubType(superType, maybeSubType);
}
/**
 * Provided two composite types, determine if they "overlap". Two composite
 * types overlap when the Sets of possible concrete types for each intersect.
 *
 * This is often used to determine if a fragment of a given type could possibly
 * be visited in a context of another type.
 *
 * This function is commutative.
 */

function doTypesOverlap(schema, typeA, typeB) {
  // Equivalent types overlap
  if (typeA === typeB) {
    return true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["o" /* isAbstractType */])(typeA)) {
    if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["o" /* isAbstractType */])(typeB)) {
      // If both types are abstract, then determine if there is any intersection
      // between possible concrete types of each.
      return schema.getPossibleTypes(typeA).some(function (type) {
        return schema.isSubType(typeB, type);
      });
    } // Determine if the latter type is a possible concrete type of the former.


    return schema.isSubType(typeA, typeB);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_0__type_definition_mjs__["o" /* isAbstractType */])(typeB)) {
    // Determine if the former type is a possible concrete type of the latter.
    return schema.isSubType(typeB, typeA);
  } // Otherwise the types do not overlap.


  return false;
}


/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = keyValMap;
/**
 * Creates a keyed JS object from an array, given a function to produce the keys
 * and a function to produce the values from each item in the array.
 *
 *     const phoneBook = [
 *       { name: 'Jon', num: '555-1234' },
 *       { name: 'Jenny', num: '867-5309' }
 *     ]
 *
 *     // { Jon: '555-1234', Jenny: '867-5309' }
 *     const phonesByName = keyValMap(
 *       phoneBook,
 *       entry => entry.name,
 *       entry => entry.num
 *     )
 *
 */
function keyValMap(list, keyFn, valFn) {
  return list.reduce(function (map, item) {
    map[keyFn(item)] = valFn(item);
    return map;
  }, Object.create(null));
}


/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = naturalCompare;
/**
 * Returns a number indicating whether a reference string comes before, or after,
 * or is the same as the given string in natural sort order.
 *
 * See: https://en.wikipedia.org/wiki/Natural_sort_order
 *
 */
function naturalCompare(aStr, bStr) {
  var aIdx = 0;
  var bIdx = 0;

  while (aIdx < aStr.length && bIdx < bStr.length) {
    var aChar = aStr.charCodeAt(aIdx);
    var bChar = bStr.charCodeAt(bIdx);

    if (isDigit(aChar) && isDigit(bChar)) {
      var aNum = 0;

      do {
        ++aIdx;
        aNum = aNum * 10 + aChar - DIGIT_0;
        aChar = aStr.charCodeAt(aIdx);
      } while (isDigit(aChar) && aNum > 0);

      var bNum = 0;

      do {
        ++bIdx;
        bNum = bNum * 10 + bChar - DIGIT_0;
        bChar = bStr.charCodeAt(bIdx);
      } while (isDigit(bChar) && bNum > 0);

      if (aNum < bNum) {
        return -1;
      }

      if (aNum > bNum) {
        return 1;
      }
    } else {
      if (aChar < bChar) {
        return -1;
      }

      if (aChar > bChar) {
        return 1;
      }

      ++aIdx;
      ++bIdx;
    }
  }

  return aStr.length - bStr.length;
}
var DIGIT_0 = 48;
var DIGIT_9 = 57;

function isDigit(code) {
  return !isNaN(code) && DIGIT_0 <= code && code <= DIGIT_9;
}


/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = astFromValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_safeArrayFrom_mjs__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__ = __webpack_require__(20);









/**
 * Produces a GraphQL Value AST given a JavaScript object.
 * Function will match JavaScript/JSON values to GraphQL AST schema format
 * by using suggested GraphQLInputType. For example:
 *
 *     astFromValue("value", GraphQLString)
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * JavaScript values.
 *
 * | JSON Value    | GraphQL Value        |
 * | ------------- | -------------------- |
 * | Object        | Input Object         |
 * | Array         | List                 |
 * | Boolean       | Boolean              |
 * | String        | String / Enum Value  |
 * | Number        | Int / Float          |
 * | Mixed         | Enum Value           |
 * | null          | NullValue            |
 *
 */

function astFromValue(value, type) {
  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(type)) {
    var astValue = astFromValue(value, type.ofType);

    if ((astValue === null || astValue === void 0 ? void 0 : astValue.kind) === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].NULL) {
      return null;
    }

    return astValue;
  } // only explicit null, not undefined, NaN


  if (value === null) {
    return {
      kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].NULL
    };
  } // undefined


  if (value === undefined) {
    return null;
  } // Convert JavaScript array to GraphQL list. If the GraphQLType is a list, but
  // the value is not an array, convert the value using the list's item type.


  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(type)) {
    var itemType = type.ofType;
    var items = Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_safeArrayFrom_mjs__["a" /* default */])(value);

    if (items != null) {
      var valuesNodes = [];

      for (var _i2 = 0; _i2 < items.length; _i2++) {
        var item = items[_i2];
        var itemNode = astFromValue(item, itemType);

        if (itemNode != null) {
          valuesNodes.push(itemNode);
        }
      }

      return {
        kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].LIST,
        values: valuesNodes
      };
    }

    return astFromValue(value, itemType);
  } // Populate the fields of the input object by creating ASTs from each value
  // in the JavaScript object according to the fields in the input type.


  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__["a" /* default */])(value)) {
      return null;
    }

    var fieldNodes = [];

    for (var _i4 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()); _i4 < _objectValues2.length; _i4++) {
      var field = _objectValues2[_i4];
      var fieldValue = astFromValue(value[field.name], field.type);

      if (fieldValue) {
        fieldNodes.push({
          kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].OBJECT_FIELD,
          name: {
            kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].NAME,
            value: field.name
          },
          value: fieldValue
        });
      }
    }

    return {
      kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].OBJECT,
      fields: fieldNodes
    };
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["u" /* isLeafType */])(type)) {
    // Since value is an internally represented value, it must be serialized
    // to an externally represented value before converting into an AST.
    var serialized = type.serialize(value);

    if (serialized == null) {
      return null;
    } // Others serialize based on their corresponding JavaScript scalar types.


    if (typeof serialized === 'boolean') {
      return {
        kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].BOOLEAN,
        value: serialized
      };
    } // JavaScript numbers can be Int or Float values.


    if (typeof serialized === 'number' && Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_isFinite_mjs__["a" /* default */])(serialized)) {
      var stringNum = String(serialized);
      return integerStringRegExp.test(stringNum) ? {
        kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].INT,
        value: stringNum
      } : {
        kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].FLOAT,
        value: stringNum
      };
    }

    if (typeof serialized === 'string') {
      // Enum types use Enum literals.
      if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(type)) {
        return {
          kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].ENUM,
          value: serialized
        };
      } // ID types can use Int literals.


      if (type === __WEBPACK_IMPORTED_MODULE_7__type_scalars_mjs__["b" /* GraphQLID */] && integerStringRegExp.test(serialized)) {
        return {
          kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].INT,
          value: serialized
        };
      }

      return {
        kind: __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].STRING,
        value: serialized
      };
    }

    throw new TypeError("Cannot convert value to AST: ".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(serialized), "."));
  } // istanbul ignore next (Not reachable. All possible input types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected input type: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type));
}
/**
 * IntValue:
 *   - NegativeSign? 0
 *   - NegativeSign? NonZeroDigit ( Digit+ )?
 */

var integerStringRegExp = /^-?(?:0|[1-9][0-9]*)$/;


/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = execute;
/* harmony export (immutable) */ __webpack_exports__["f"] = executeSync;
/* harmony export (immutable) */ __webpack_exports__["a"] = assertValidExecutionArguments;
/* harmony export (immutable) */ __webpack_exports__["b"] = buildExecutionContext;
/* harmony export (immutable) */ __webpack_exports__["d"] = collectFields;
/* harmony export (immutable) */ __webpack_exports__["c"] = buildResolveInfo;
/* unused harmony export defaultTypeResolver */
/* unused harmony export defaultFieldResolver */
/* harmony export (immutable) */ __webpack_exports__["g"] = getFieldDef;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_memoize3_mjs__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_safeArrayFrom_mjs__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_promiseReduce_mjs__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jsutils_promiseForObject_mjs__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__error_locatedError_mjs__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type_validate_mjs__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__utilities_typeFromAST_mjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utilities_getOperationRootType_mjs__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__values_mjs__ = __webpack_require__(209);




















/**
 * Terminology
 *
 * "Definitions" are the generic name for top-level statements in the document.
 * Examples of this include:
 * 1) Operations (such as a query)
 * 2) Fragments
 *
 * "Operations" are a generic name for requests in the document.
 * Examples of this include:
 * 1) query,
 * 2) mutation
 *
 * "Selections" are the definitions that can appear legally and at
 * single level of the query. These include:
 * 1) field references e.g "a"
 * 2) fragment "spreads" e.g. "...c"
 * 3) inline fragment "spreads" e.g. "...on Type { a }"
 */

/**
 * Data that must be available at all points during query execution.
 *
 * Namely, schema of the type system that is currently executing,
 * and the fragments defined in the query document
 */

function execute(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? executeImpl(argsOrSchema) : executeImpl({
    schema: argsOrSchema,
    document: document,
    rootValue: rootValue,
    contextValue: contextValue,
    variableValues: variableValues,
    operationName: operationName,
    fieldResolver: fieldResolver,
    typeResolver: typeResolver
  });
}
/**
 * Also implements the "Evaluating requests" section of the GraphQL specification.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function executeSync(args) {
  var result = executeImpl(args); // Assert that the execution was synchronous.

  if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function executeImpl(args) {
  var schema = args.schema,
      document = args.document,
      rootValue = args.rootValue,
      contextValue = args.contextValue,
      variableValues = args.variableValues,
      operationName = args.operationName,
      fieldResolver = args.fieldResolver,
      typeResolver = args.typeResolver; // If arguments are missing or incorrect, throw an error.

  assertValidExecutionArguments(schema, document, variableValues); // If a valid execution context cannot be created due to incorrect arguments,
  // a "Response" with only errors is returned.

  var exeContext = buildExecutionContext(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver); // Return early errors if execution context failed.

  if (Array.isArray(exeContext)) {
    return {
      errors: exeContext
    };
  } // Return a Promise that will eventually resolve to the data described by
  // The "Response" section of the GraphQL specification.
  //
  // If errors are encountered while executing a GraphQL field, only that
  // field and its descendants will be omitted, and sibling fields will still
  // be executed. An execution which encounters errors will still result in a
  // resolved Promise.


  var data = executeOperation(exeContext, exeContext.operation, rootValue);
  return buildResponse(exeContext, data);
}
/**
 * Given a completed execution context and data, build the { errors, data }
 * response defined by the "Response" section of the GraphQL specification.
 */


function buildResponse(exeContext, data) {
  if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(data)) {
    return data.then(function (resolved) {
      return buildResponse(exeContext, resolved);
    });
  }

  return exeContext.errors.length === 0 ? {
    data: data
  } : {
    errors: exeContext.errors,
    data: data
  };
}
/**
 * Essential assertions before executing to provide developer feedback for
 * improper use of the GraphQL library.
 *
 * @internal
 */


function assertValidExecutionArguments(schema, document, rawVariableValues) {
  document || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide document.'); // If the schema used for execution is invalid, throw an error.

  Object(__WEBPACK_IMPORTED_MODULE_13__type_validate_mjs__["a" /* assertValidSchema */])(schema); // Variables, if provided, must be an object.

  rawVariableValues == null || Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isObjectLike_mjs__["a" /* default */])(rawVariableValues) || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_devAssert_mjs__["a" /* default */])(0, 'Variables must be provided as an Object where each property is a variable value. Perhaps look to see if an unparsed JSON string was provided.');
}
/**
 * Constructs a ExecutionContext object from the arguments passed to
 * execute, which we will pass throughout the other execution methods.
 *
 * Throws a GraphQLError if a valid execution context cannot be created.
 *
 * @internal
 */

function buildExecutionContext(schema, document, rootValue, contextValue, rawVariableValues, operationName, fieldResolver, typeResolver) {
  var _definition$name, _operation$variableDe;

  var operation;
  var fragments = Object.create(null);

  for (var _i2 = 0, _document$definitions2 = document.definitions; _i2 < _document$definitions2.length; _i2++) {
    var definition = _document$definitions2[_i2];

    switch (definition.kind) {
      case __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION:
        if (operationName == null) {
          if (operation !== undefined) {
            return [new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]('Must provide operation name if query contains multiple operations.')];
          }

          operation = definition;
        } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) {
          operation = definition;
        }

        break;

      case __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION:
        fragments[definition.name.value] = definition;
        break;
    }
  }

  if (!operation) {
    if (operationName != null) {
      return [new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown operation named \"".concat(operationName, "\"."))];
    }

    return [new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]('Must provide an operation.')];
  } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')


  var variableDefinitions = (_operation$variableDe = operation.variableDefinitions) !== null && _operation$variableDe !== void 0 ? _operation$variableDe : [];
  var coercedVariableValues = Object(__WEBPACK_IMPORTED_MODULE_19__values_mjs__["c" /* getVariableValues */])(schema, variableDefinitions, rawVariableValues !== null && rawVariableValues !== void 0 ? rawVariableValues : {}, {
    maxErrors: 50
  });

  if (coercedVariableValues.errors) {
    return coercedVariableValues.errors;
  }

  return {
    schema: schema,
    fragments: fragments,
    rootValue: rootValue,
    contextValue: contextValue,
    operation: operation,
    variableValues: coercedVariableValues.coerced,
    fieldResolver: fieldResolver !== null && fieldResolver !== void 0 ? fieldResolver : defaultFieldResolver,
    typeResolver: typeResolver !== null && typeResolver !== void 0 ? typeResolver : defaultTypeResolver,
    errors: []
  };
}
/**
 * Implements the "Evaluating operations" section of the spec.
 */

function executeOperation(exeContext, operation, rootValue) {
  var type = Object(__WEBPACK_IMPORTED_MODULE_18__utilities_getOperationRootType_mjs__["a" /* getOperationRootType */])(exeContext.schema, operation);
  var fields = collectFields(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
  var path = undefined; // Errors from sub-fields of a NonNull type may propagate to the top level,
  // at which point we still log the error and null the parent field, which
  // in this case is the entire response.

  try {
    var result = operation.operation === 'mutation' ? executeFieldsSerially(exeContext, type, rootValue, path, fields) : executeFields(exeContext, type, rootValue, path, fields);

    if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(result)) {
      return result.then(undefined, function (error) {
        exeContext.errors.push(error);
        return Promise.resolve(null);
      });
    }

    return result;
  } catch (error) {
    exeContext.errors.push(error);
    return null;
  }
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "write" mode.
 */


function executeFieldsSerially(exeContext, parentType, sourceValue, path, fields) {
  return Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_promiseReduce_mjs__["a" /* default */])(Object.keys(fields), function (results, responseName) {
    var fieldNodes = fields[responseName];
    var fieldPath = Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["a" /* addPath */])(path, responseName, parentType.name);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);

    if (result === undefined) {
      return results;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(result)) {
      return result.then(function (resolvedResult) {
        results[responseName] = resolvedResult;
        return results;
      });
    }

    results[responseName] = result;
    return results;
  }, Object.create(null));
}
/**
 * Implements the "Evaluating selection sets" section of the spec
 * for "read" mode.
 */


function executeFields(exeContext, parentType, sourceValue, path, fields) {
  var results = Object.create(null);
  var containsPromise = false;

  for (var _i4 = 0, _Object$keys2 = Object.keys(fields); _i4 < _Object$keys2.length; _i4++) {
    var responseName = _Object$keys2[_i4];
    var fieldNodes = fields[responseName];
    var fieldPath = Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["a" /* addPath */])(path, responseName, parentType.name);
    var result = resolveField(exeContext, parentType, sourceValue, fieldNodes, fieldPath);

    if (result !== undefined) {
      results[responseName] = result;

      if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(result)) {
        containsPromise = true;
      }
    }
  } // If there are no promises, we can just return the object


  if (!containsPromise) {
    return results;
  } // Otherwise, results is a map from field name to the result of resolving that
  // field, which is possibly a promise. Return a promise that will return this
  // same map, but with any promises replaced with the values they resolved to.


  return Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_promiseForObject_mjs__["a" /* default */])(results);
}
/**
 * Given a selectionSet, adds all of the fields in that selection to
 * the passed in map of fields, and returns it at the end.
 *
 * CollectFields requires the "runtime type" of an object. For a field which
 * returns an Interface or Union type, the "runtime type" will be the actual
 * Object type returned by that field.
 *
 * @internal
 */


function collectFields(exeContext, runtimeType, selectionSet, fields, visitedFragmentNames) {
  for (var _i6 = 0, _selectionSet$selecti2 = selectionSet.selections; _i6 < _selectionSet$selecti2.length; _i6++) {
    var selection = _selectionSet$selecti2[_i6];

    switch (selection.kind) {
      case __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__["a" /* Kind */].FIELD:
        {
          if (!shouldIncludeNode(exeContext, selection)) {
            continue;
          }

          var name = getFieldEntryKey(selection);

          if (!fields[name]) {
            fields[name] = [];
          }

          fields[name].push(selection);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT:
        {
          if (!shouldIncludeNode(exeContext, selection) || !doesFragmentConditionMatch(exeContext, selection, runtimeType)) {
            continue;
          }

          collectFields(exeContext, runtimeType, selection.selectionSet, fields, visitedFragmentNames);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_12__language_kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD:
        {
          var fragName = selection.name.value;

          if (visitedFragmentNames[fragName] || !shouldIncludeNode(exeContext, selection)) {
            continue;
          }

          visitedFragmentNames[fragName] = true;
          var fragment = exeContext.fragments[fragName];

          if (!fragment || !doesFragmentConditionMatch(exeContext, fragment, runtimeType)) {
            continue;
          }

          collectFields(exeContext, runtimeType, fragment.selectionSet, fields, visitedFragmentNames);
          break;
        }
    }
  }

  return fields;
}
/**
 * Determines if a field should be included based on the @include and @skip
 * directives, where @skip has higher precedence than @include.
 */

function shouldIncludeNode(exeContext, node) {
  var skip = Object(__WEBPACK_IMPORTED_MODULE_19__values_mjs__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["e" /* GraphQLSkipDirective */], node, exeContext.variableValues);

  if ((skip === null || skip === void 0 ? void 0 : skip.if) === true) {
    return false;
  }

  var include = Object(__WEBPACK_IMPORTED_MODULE_19__values_mjs__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["d" /* GraphQLIncludeDirective */], node, exeContext.variableValues);

  if ((include === null || include === void 0 ? void 0 : include.if) === false) {
    return false;
  }

  return true;
}
/**
 * Determines if a fragment is applicable to the given type.
 */


function doesFragmentConditionMatch(exeContext, fragment, type) {
  var typeConditionNode = fragment.typeCondition;

  if (!typeConditionNode) {
    return true;
  }

  var conditionalType = Object(__WEBPACK_IMPORTED_MODULE_17__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(exeContext.schema, typeConditionNode);

  if (conditionalType === type) {
    return true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["o" /* isAbstractType */])(conditionalType)) {
    return exeContext.schema.isSubType(conditionalType, type);
  }

  return false;
}
/**
 * Implements the logic to compute the key of a given field's entry
 */


function getFieldEntryKey(node) {
  return node.alias ? node.alias.value : node.name.value;
}
/**
 * Resolves the field on the given source object. In particular, this
 * figures out the value that the field returns by calling its resolve function,
 * then calls completeValue to complete promises, serialize scalars, or execute
 * the sub-selection-set for objects.
 */


function resolveField(exeContext, parentType, source, fieldNodes, path) {
  var _fieldDef$resolve;

  var fieldNode = fieldNodes[0];
  var fieldName = fieldNode.name.value;
  var fieldDef = getFieldDef(exeContext.schema, parentType, fieldName);

  if (!fieldDef) {
    return;
  }

  var returnType = fieldDef.type;
  var resolveFn = (_fieldDef$resolve = fieldDef.resolve) !== null && _fieldDef$resolve !== void 0 ? _fieldDef$resolve : exeContext.fieldResolver;
  var info = buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path); // Get the resolve function, regardless of if its result is normal or abrupt (error).

  try {
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    // TODO: find a way to memoize, in case this field is within a List type.
    var args = Object(__WEBPACK_IMPORTED_MODULE_19__values_mjs__["a" /* getArgumentValues */])(fieldDef, fieldNodes[0], exeContext.variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    var _contextValue = exeContext.contextValue;
    var result = resolveFn(source, args, _contextValue, info);
    var completed;

    if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(result)) {
      completed = result.then(function (resolved) {
        return completeValue(exeContext, returnType, fieldNodes, info, path, resolved);
      });
    } else {
      completed = completeValue(exeContext, returnType, fieldNodes, info, path, result);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(completed)) {
      // Note: we don't rely on a `catch` method, but we do expect "thenable"
      // to take a second callback for the error case.
      return completed.then(undefined, function (rawError) {
        var error = Object(__WEBPACK_IMPORTED_MODULE_11__error_locatedError_mjs__["a" /* locatedError */])(rawError, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["b" /* pathToArray */])(path));
        return handleFieldError(error, returnType, exeContext);
      });
    }

    return completed;
  } catch (rawError) {
    var error = Object(__WEBPACK_IMPORTED_MODULE_11__error_locatedError_mjs__["a" /* locatedError */])(rawError, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["b" /* pathToArray */])(path));
    return handleFieldError(error, returnType, exeContext);
  }
}
/**
 * @internal
 */


function buildResolveInfo(exeContext, fieldDef, fieldNodes, parentType, path) {
  // The resolve function's optional fourth argument is a collection of
  // information about the current execution state.
  return {
    fieldName: fieldDef.name,
    fieldNodes: fieldNodes,
    returnType: fieldDef.type,
    parentType: parentType,
    path: path,
    schema: exeContext.schema,
    fragments: exeContext.fragments,
    rootValue: exeContext.rootValue,
    operation: exeContext.operation,
    variableValues: exeContext.variableValues
  };
}

function handleFieldError(error, returnType, exeContext) {
  // If the field type is non-nullable, then it is resolved without any
  // protection from errors, however it still properly locates the error.
  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["x" /* isNonNullType */])(returnType)) {
    throw error;
  } // Otherwise, error protection is applied, logging the error and resolving
  // a null value for this field if one is encountered.


  exeContext.errors.push(error);
  return null;
}
/**
 * Implements the instructions for completeValue as defined in the
 * "Field entries" section of the spec.
 *
 * If the field type is Non-Null, then this recursively completes the value
 * for the inner type. It throws a field error if that completion returns null,
 * as per the "Nullability" section of the spec.
 *
 * If the field type is a List, then this recursively completes the value
 * for the inner type on each item in the list.
 *
 * If the field type is a Scalar or Enum, ensures the completed value is a legal
 * value of the type by calling the `serialize` method of GraphQL type
 * definition.
 *
 * If the field is an abstract type, determine the runtime type of the value
 * and then complete based on that type
 *
 * Otherwise, the field type expects a sub-selection set, and will complete the
 * value by evaluating all sub-selections.
 */


function completeValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If result is an Error, throw a located error.
  if (result instanceof Error) {
    throw result;
  } // If field type is NonNull, complete for inner type, and throw field error
  // if result is null.


  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["x" /* isNonNullType */])(returnType)) {
    var completed = completeValue(exeContext, returnType.ofType, fieldNodes, info, path, result);

    if (completed === null) {
      throw new Error("Cannot return null for non-nullable field ".concat(info.parentType.name, ".").concat(info.fieldName, "."));
    }

    return completed;
  } // If result value is null or undefined then return null.


  if (result == null) {
    return null;
  } // If field type is List, complete each item in the list with the inner type


  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["v" /* isListType */])(returnType)) {
    return completeListValue(exeContext, returnType, fieldNodes, info, path, result);
  } // If field type is a leaf type, Scalar or Enum, serialize to a valid value,
  // returning null if serialization is not possible.


  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["u" /* isLeafType */])(returnType)) {
    return completeLeafValue(returnType, result);
  } // If field type is an abstract type, Interface or Union, determine the
  // runtime Object type and complete for that type.


  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["o" /* isAbstractType */])(returnType)) {
    return completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result);
  } // If field type is Object, execute and complete all sub-selections.
  // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["y" /* isObjectType */])(returnType)) {
    return completeObjectValue(exeContext, returnType, fieldNodes, info, path, result);
  } // istanbul ignore next (Not reachable. All possible output types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, 'Cannot complete value of unexpected output type: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(returnType));
}
/**
 * Complete a list value by completing each item in the list with the
 * inner type
 */


function completeListValue(exeContext, returnType, fieldNodes, info, path, result) {
  // This is specified as a simple map, however we're optimizing the path
  // where the list contains no Promises by avoiding creating another Promise.
  var itemType = returnType.ofType;
  var containsPromise = false;
  var completedResults = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_safeArrayFrom_mjs__["a" /* default */])(result, function (item, index) {
    // No need to modify the info object containing the path,
    // since from here on it is not ever accessed by resolver functions.
    var itemPath = Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["a" /* addPath */])(path, index, undefined);

    try {
      var completedItem;

      if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(item)) {
        completedItem = item.then(function (resolved) {
          return completeValue(exeContext, itemType, fieldNodes, info, itemPath, resolved);
        });
      } else {
        completedItem = completeValue(exeContext, itemType, fieldNodes, info, itemPath, item);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(completedItem)) {
        containsPromise = true; // Note: we don't rely on a `catch` method, but we do expect "thenable"
        // to take a second callback for the error case.

        return completedItem.then(undefined, function (rawError) {
          var error = Object(__WEBPACK_IMPORTED_MODULE_11__error_locatedError_mjs__["a" /* locatedError */])(rawError, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["b" /* pathToArray */])(itemPath));
          return handleFieldError(error, itemType, exeContext);
        });
      }

      return completedItem;
    } catch (rawError) {
      var error = Object(__WEBPACK_IMPORTED_MODULE_11__error_locatedError_mjs__["a" /* locatedError */])(rawError, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_9__jsutils_Path_mjs__["b" /* pathToArray */])(itemPath));
      return handleFieldError(error, itemType, exeContext);
    }
  });

  if (completedResults == null) {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected Iterable, but did not find one for field \"".concat(info.parentType.name, ".").concat(info.fieldName, "\"."));
  }

  return containsPromise ? Promise.all(completedResults) : completedResults;
}
/**
 * Complete a Scalar or Enum by serializing to a valid value, returning
 * null if serialization is not possible.
 */


function completeLeafValue(returnType, result) {
  var serializedResult = returnType.serialize(result);

  if (serializedResult === undefined) {
    throw new Error("Expected a value of type \"".concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(returnType), "\" but ") + "received: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(result)));
  }

  return serializedResult;
}
/**
 * Complete a value of an abstract type by determining the runtime object type
 * of that value, then complete the value for that type.
 */


function completeAbstractValue(exeContext, returnType, fieldNodes, info, path, result) {
  var _returnType$resolveTy;

  var resolveTypeFn = (_returnType$resolveTy = returnType.resolveType) !== null && _returnType$resolveTy !== void 0 ? _returnType$resolveTy : exeContext.typeResolver;
  var contextValue = exeContext.contextValue;
  var runtimeType = resolveTypeFn(result, contextValue, info, returnType);

  if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(runtimeType)) {
    return runtimeType.then(function (resolvedRuntimeType) {
      return completeObjectValue(exeContext, ensureValidRuntimeType(resolvedRuntimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
    });
  }

  return completeObjectValue(exeContext, ensureValidRuntimeType(runtimeType, exeContext, returnType, fieldNodes, info, result), fieldNodes, info, path, result);
}

function ensureValidRuntimeType(runtimeTypeOrName, exeContext, returnType, fieldNodes, info, result) {
  if (runtimeTypeOrName == null) {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\". Either the \"").concat(returnType.name, "\" type should provide a \"resolveType\" function or each possible type should provide an \"isTypeOf\" function."), fieldNodes);
  } // FIXME: temporary workaround until support for passing object types would be removed in v16.0.0


  var runtimeTypeName = Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["w" /* isNamedType */])(runtimeTypeOrName) ? runtimeTypeOrName.name : runtimeTypeOrName;

  if (typeof runtimeTypeName !== 'string') {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Abstract type \"".concat(returnType.name, "\" must resolve to an Object type at runtime for field \"").concat(info.parentType.name, ".").concat(info.fieldName, "\" with ") + "value ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(result), ", received \"").concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(runtimeTypeOrName), "\"."));
  }

  var runtimeType = exeContext.schema.getType(runtimeTypeName);

  if (runtimeType == null) {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Abstract type \"".concat(returnType.name, "\" was resolve to a type \"").concat(runtimeTypeName, "\" that does not exist inside schema."), fieldNodes);
  }

  if (!Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["y" /* isObjectType */])(runtimeType)) {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Abstract type \"".concat(returnType.name, "\" was resolve to a non-object type \"").concat(runtimeTypeName, "\"."), fieldNodes);
  }

  if (!exeContext.schema.isSubType(returnType, runtimeType)) {
    throw new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Runtime Object type \"".concat(runtimeType.name, "\" is not a possible type for \"").concat(returnType.name, "\"."), fieldNodes);
  }

  return runtimeType;
}
/**
 * Complete an Object value by executing all sub-selections.
 */


function completeObjectValue(exeContext, returnType, fieldNodes, info, path, result) {
  // If there is an isTypeOf predicate function, call it with the
  // current result. If isTypeOf returns false, then raise an error rather
  // than continuing execution.
  if (returnType.isTypeOf) {
    var isTypeOf = returnType.isTypeOf(result, exeContext.contextValue, info);

    if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(isTypeOf)) {
      return isTypeOf.then(function (resolvedIsTypeOf) {
        if (!resolvedIsTypeOf) {
          throw invalidReturnTypeError(returnType, result, fieldNodes);
        }

        return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
      });
    }

    if (!isTypeOf) {
      throw invalidReturnTypeError(returnType, result, fieldNodes);
    }
  }

  return collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result);
}

function invalidReturnTypeError(returnType, result, fieldNodes) {
  return new __WEBPACK_IMPORTED_MODULE_10__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected value of type \"".concat(returnType.name, "\" but got: ").concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(result), "."), fieldNodes);
}

function collectAndExecuteSubfields(exeContext, returnType, fieldNodes, path, result) {
  // Collect sub-fields to execute to complete this value.
  var subFieldNodes = collectSubfields(exeContext, returnType, fieldNodes);
  return executeFields(exeContext, returnType, result, path, subFieldNodes);
}
/**
 * A memoized collection of relevant subfields with regard to the return
 * type. Memoizing ensures the subfields are not repeatedly calculated, which
 * saves overhead when resolving lists of values.
 */


var collectSubfields = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_memoize3_mjs__["a" /* default */])(_collectSubfields);

function _collectSubfields(exeContext, returnType, fieldNodes) {
  var subFieldNodes = Object.create(null);
  var visitedFragmentNames = Object.create(null);

  for (var _i8 = 0; _i8 < fieldNodes.length; _i8++) {
    var node = fieldNodes[_i8];

    if (node.selectionSet) {
      subFieldNodes = collectFields(exeContext, returnType, node.selectionSet, subFieldNodes, visitedFragmentNames);
    }
  }

  return subFieldNodes;
}
/**
 * If a resolveType function is not given, then a default resolve behavior is
 * used which attempts two strategies:
 *
 * First, See if the provided value has a `__typename` field defined, if so, use
 * that value as name of the resolved type.
 *
 * Otherwise, test each possible type for the abstract type by calling
 * isTypeOf for the object being coerced, returning the first type that matches.
 */


var defaultTypeResolver = function defaultTypeResolver(value, contextValue, info, abstractType) {
  // First, look for `__typename`.
  if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isObjectLike_mjs__["a" /* default */])(value) && typeof value.__typename === 'string') {
    return value.__typename;
  } // Otherwise, test each possible type.


  var possibleTypes = info.schema.getPossibleTypes(abstractType);
  var promisedIsTypeOfResults = [];

  for (var i = 0; i < possibleTypes.length; i++) {
    var type = possibleTypes[i];

    if (type.isTypeOf) {
      var isTypeOfResult = type.isTypeOf(value, contextValue, info);

      if (Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isPromise_mjs__["a" /* default */])(isTypeOfResult)) {
        promisedIsTypeOfResults[i] = isTypeOfResult;
      } else if (isTypeOfResult) {
        return type.name;
      }
    }
  }

  if (promisedIsTypeOfResults.length) {
    return Promise.all(promisedIsTypeOfResults).then(function (isTypeOfResults) {
      for (var _i9 = 0; _i9 < isTypeOfResults.length; _i9++) {
        if (isTypeOfResults[_i9]) {
          return possibleTypes[_i9].name;
        }
      }
    });
  }
};
/**
 * If a resolve function is not given, then a default resolve behavior is used
 * which takes the property of the source object of the same name as the field
 * and returns it as the result, or if it's a function, returns the result
 * of calling that function while passing along args and context value.
 */

var defaultFieldResolver = function defaultFieldResolver(source, args, contextValue, info) {
  // ensure source is a value for which property access is acceptable.
  if (Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_isObjectLike_mjs__["a" /* default */])(source) || typeof source === 'function') {
    var property = source[info.fieldName];

    if (typeof property === 'function') {
      return source[info.fieldName](args, contextValue, info);
    }

    return property;
  }
};
/**
 * This method looks up the field on the given type definition.
 * It has special casing for the three introspection fields,
 * __schema, __type and __typename. __typename is special because
 * it can always be queried as a field, even in situations where no
 * other fields are allowed, like on a Union. __schema and __type
 * could get automatically added to the query type, but that would
 * require mutating type definitions, which would cause issues.
 *
 * @internal
 */

function getFieldDef(schema, parentType, fieldName) {
  if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["a" /* SchemaMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["a" /* SchemaMetaFieldDef */];
  } else if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["c" /* TypeMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["c" /* TypeMetaFieldDef */];
  } else if (fieldName === __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["d" /* TypeNameMetaFieldDef */].name) {
    return __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["d" /* TypeNameMetaFieldDef */];
  }

  return parentType.getFields()[fieldName];
}


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = addPath;
/* harmony export (immutable) */ __webpack_exports__["b"] = pathToArray;
/**
 * Given a Path and a key, return a new Path containing the new key.
 */
function addPath(prev, key, typename) {
  return {
    prev: prev,
    key: key,
    typename: typename
  };
}
/**
 * Given a Path, return an Array of the path keys.
 */

function pathToArray(path) {
  var flattened = [];
  var curr = path;

  while (curr) {
    flattened.push(curr.key);
    curr = curr.prev;
  }

  return flattened.reverse();
}


/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["c"] = getVariableValues;
/* harmony export (immutable) */ __webpack_exports__["a"] = getArgumentValues;
/* harmony export (immutable) */ __webpack_exports__["b"] = getDirectiveValues;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_printPathArray_mjs__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_typeFromAST_mjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utilities_valueFromAST_mjs__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utilities_coerceInputValue_mjs__ = __webpack_require__(585);












/**
 * Prepares an object map of variableValues of the correct type based on the
 * provided variable definitions and arbitrary input. If the input cannot be
 * parsed to match the variable definitions, a GraphQLError will be thrown.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 *
 * @internal
 */
function getVariableValues(schema, varDefNodes, inputs, options) {
  var errors = [];
  var maxErrors = options === null || options === void 0 ? void 0 : options.maxErrors;

  try {
    var coerced = coerceVariableValues(schema, varDefNodes, inputs, function (error) {
      if (maxErrors != null && errors.length >= maxErrors) {
        throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]('Too many errors processing variables, error limit reached. Execution aborted.');
      }

      errors.push(error);
    });

    if (errors.length === 0) {
      return {
        coerced: coerced
      };
    }
  } catch (error) {
    errors.push(error);
  }

  return {
    errors: errors
  };
}

function coerceVariableValues(schema, varDefNodes, inputs, onError) {
  var coercedValues = {};

  var _loop = function _loop(_i2) {
    var varDefNode = varDefNodes[_i2];
    var varName = varDefNode.variable.name.value;
    var varType = Object(__WEBPACK_IMPORTED_MODULE_8__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(schema, varDefNode.type);

    if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["s" /* isInputType */])(varType)) {
      // Must use input types for variables. This should be caught during
      // validation, however is checked again here for safety.
      var varTypeStr = Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(varDefNode.type);
      onError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Variable \"$".concat(varName, "\" expected value of type \"").concat(varTypeStr, "\" which cannot be used as an input type."), varDefNode.type));
      return "continue";
    }

    if (!hasOwnProperty(inputs, varName)) {
      if (varDefNode.defaultValue) {
        coercedValues[varName] = Object(__WEBPACK_IMPORTED_MODULE_9__utilities_valueFromAST_mjs__["a" /* valueFromAST */])(varDefNode.defaultValue, varType);
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(varType)) {
        var _varTypeStr = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(varType);

        onError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Variable \"$".concat(varName, "\" of required type \"").concat(_varTypeStr, "\" was not provided."), varDefNode));
      }

      return "continue";
    }

    var value = inputs[varName];

    if (value === null && Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(varType)) {
      var _varTypeStr2 = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(varType);

      onError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Variable \"$".concat(varName, "\" of non-null type \"").concat(_varTypeStr2, "\" must not be null."), varDefNode));
      return "continue";
    }

    coercedValues[varName] = Object(__WEBPACK_IMPORTED_MODULE_10__utilities_coerceInputValue_mjs__["a" /* coerceInputValue */])(value, varType, function (path, invalidValue, error) {
      var prefix = "Variable \"$".concat(varName, "\" got invalid value ") + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(invalidValue);

      if (path.length > 0) {
        prefix += " at \"".concat(varName).concat(Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_printPathArray_mjs__["a" /* default */])(path), "\"");
      }

      onError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */](prefix + '; ' + error.message, varDefNode, undefined, undefined, undefined, error.originalError));
    });
  };

  for (var _i2 = 0; _i2 < varDefNodes.length; _i2++) {
    var _ret = _loop(_i2);

    if (_ret === "continue") continue;
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a list of argument
 * definitions and list of argument AST nodes.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 *
 * @internal
 */


function getArgumentValues(def, node, variableValues) {
  var _node$arguments;

  var coercedValues = {}; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')

  var argumentNodes = (_node$arguments = node.arguments) !== null && _node$arguments !== void 0 ? _node$arguments : [];
  var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(argumentNodes, function (arg) {
    return arg.name.value;
  });

  for (var _i4 = 0, _def$args2 = def.args; _i4 < _def$args2.length; _i4++) {
    var argDef = _def$args2[_i4];
    var name = argDef.name;
    var argType = argDef.type;
    var argumentNode = argNodeMap[name];

    if (!argumentNode) {
      if (argDef.defaultValue !== undefined) {
        coercedValues[name] = argDef.defaultValue;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(argType)) {
        throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Argument \"".concat(name, "\" of required type \"").concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(argType), "\" ") + 'was not provided.', node);
      }

      continue;
    }

    var valueNode = argumentNode.value;
    var isNull = valueNode.kind === __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].NULL;

    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].VARIABLE) {
      var variableName = valueNode.name.value;

      if (variableValues == null || !hasOwnProperty(variableValues, variableName)) {
        if (argDef.defaultValue !== undefined) {
          coercedValues[name] = argDef.defaultValue;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(argType)) {
          throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Argument \"".concat(name, "\" of required type \"").concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(argType), "\" ") + "was provided the variable \"$".concat(variableName, "\" which was not provided a runtime value."), valueNode);
        }

        continue;
      }

      isNull = variableValues[variableName] == null;
    }

    if (isNull && Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(argType)) {
      throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Argument \"".concat(name, "\" of non-null type \"").concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(argType), "\" ") + 'must not be null.', valueNode);
    }

    var coercedValue = Object(__WEBPACK_IMPORTED_MODULE_9__utilities_valueFromAST_mjs__["a" /* valueFromAST */])(valueNode, argType, variableValues);

    if (coercedValue === undefined) {
      // Note: ValuesOfCorrectTypeRule validation should catch this before
      // execution. This is a runtime check to ensure execution does not
      // continue with an invalid argument value.
      throw new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Argument \"".concat(name, "\" has invalid value ").concat(Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(valueNode), "."), valueNode);
    }

    coercedValues[name] = coercedValue;
  }

  return coercedValues;
}
/**
 * Prepares an object map of argument values given a directive definition
 * and a AST node which may contain directives. Optionally also accepts a map
 * of variable values.
 *
 * If the directive does not exist on the node, returns undefined.
 *
 * Note: The returned value is a plain Object with a prototype, since it is
 * exposed to user code. Care should be taken to not pull values from the
 * Object prototype.
 */

function getDirectiveValues(directiveDef, node, variableValues) {
  var directiveNode = node.directives && Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(node.directives, function (directive) {
    return directive.name.value === directiveDef.name;
  });

  if (directiveNode) {
    return getArgumentValues(directiveDef, directiveNode, variableValues);
  }
}

function hasOwnProperty(obj, prop) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}


/***/ }),
/* 210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueFromAST;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__ = __webpack_require__(20);






/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * A GraphQL type must be provided, which will be used to interpret different
 * GraphQL Value literals.
 *
 * Returns `undefined` when the value could not be validly coerced according to
 * the provided type.
 *
 * | GraphQL Value        | JSON Value    |
 * | -------------------- | ------------- |
 * | Input Object         | Object        |
 * | List                 | Array         |
 * | Boolean              | Boolean       |
 * | String               | String        |
 * | Int / Float          | Number        |
 * | Enum Value           | Mixed         |
 * | NullValue            | null          |
 *
 */

function valueFromAST(valueNode, type, variables) {
  if (!valueNode) {
    // When there is no node, then there is also no value.
    // Importantly, this is different from returning the value null.
    return;
  }

  if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].VARIABLE) {
    var variableName = valueNode.name.value;

    if (variables == null || variables[variableName] === undefined) {
      // No valid return value.
      return;
    }

    var variableValue = variables[variableName];

    if (variableValue === null && Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["x" /* isNonNullType */])(type)) {
      return; // Invalid: intentionally return no value.
    } // Note: This does no further checking that this variable is correct.
    // This assumes that this query has been validated and the variable
    // usage here is of the correct type.


    return variableValue;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["x" /* isNonNullType */])(type)) {
    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].NULL) {
      return; // Invalid: intentionally return no value.
    }

    return valueFromAST(valueNode, type.ofType, variables);
  }

  if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].NULL) {
    // This is explicitly returning the value null.
    return null;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["v" /* isListType */])(type)) {
    var itemType = type.ofType;

    if (valueNode.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].LIST) {
      var coercedValues = [];

      for (var _i2 = 0, _valueNode$values2 = valueNode.values; _i2 < _valueNode$values2.length; _i2++) {
        var itemNode = _valueNode$values2[_i2];

        if (isMissingVariable(itemNode, variables)) {
          // If an array contains a missing variable, it is either coerced to
          // null or if the item type is non-null, it considered invalid.
          if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["x" /* isNonNullType */])(itemType)) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(null);
        } else {
          var itemValue = valueFromAST(itemNode, itemType, variables);

          if (itemValue === undefined) {
            return; // Invalid: intentionally return no value.
          }

          coercedValues.push(itemValue);
        }
      }

      return coercedValues;
    }

    var coercedValue = valueFromAST(valueNode, itemType, variables);

    if (coercedValue === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return [coercedValue];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    if (valueNode.kind !== __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].OBJECT) {
      return; // Invalid: intentionally return no value.
    }

    var coercedObj = Object.create(null);
    var fieldNodes = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(valueNode.fields, function (field) {
      return field.name.value;
    });

    for (var _i4 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()); _i4 < _objectValues2.length; _i4++) {
      var field = _objectValues2[_i4];
      var fieldNode = fieldNodes[field.name];

      if (!fieldNode || isMissingVariable(fieldNode.value, variables)) {
        if (field.defaultValue !== undefined) {
          coercedObj[field.name] = field.defaultValue;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["x" /* isNonNullType */])(field.type)) {
          return; // Invalid: intentionally return no value.
        }

        continue;
      }

      var fieldValue = valueFromAST(fieldNode.value, field.type, variables);

      if (fieldValue === undefined) {
        return; // Invalid: intentionally return no value.
      }

      coercedObj[field.name] = fieldValue;
    }

    return coercedObj;
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["u" /* isLeafType */])(type)) {
    // Scalars and Enums fulfill parsing a literal value via parseLiteral().
    // Invalid values represent a failure to parse correctly, in which case
    // no value is returned.
    var result;

    try {
      result = type.parseLiteral(valueNode, variables);
    } catch (_error) {
      return; // Invalid: intentionally return no value.
    }

    if (result === undefined) {
      return; // Invalid: intentionally return no value.
    }

    return result;
  } // istanbul ignore next (Not reachable. All possible input types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected input type: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type));
} // Returns true if the provided valueNode is a variable which is not defined
// in the set of variables.

function isMissingVariable(valueNode, variables) {
  return valueNode.kind === __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].VARIABLE && (variables == null || variables[valueNode.name.value] === undefined);
}


/***/ }),
/* 211 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotlineModal_vue__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_832f4ae8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_HotlineModal_vue__ = __webpack_require__(927);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_HotlineModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_832f4ae8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_HotlineModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratingWidget_vue__ = __webpack_require__(993);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def705a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ratingWidget_vue__ = __webpack_require__(995);
function injectStyle (ssrContext) {
  __webpack_require__(992)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ratingWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1def705a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ratingWidget_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commentWidget_vue__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ca9a8c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_commentWidget_vue__ = __webpack_require__(997);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_commentWidget_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ca9a8c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_commentWidget_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 214 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 215 */,
/* 216 */,
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectimages_vue__ = __webpack_require__(1202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da0e7cb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projectimages_vue__ = __webpack_require__(1203);
function injectStyle (ssrContext) {
  __webpack_require__(1201)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectimages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6da0e7cb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projectimages_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 218 */,
/* 219 */,
/* 220 */,
/* 221 */,
/* 222 */,
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */,
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */
/***/ (function(module, exports) {

module.exports = {"BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BA":"Bosnia and Herzegovina","BB":"Barbados","WF":"Wallis and Futuna","BL":"Saint Barthelemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BT":"Bhutan","JM":"Jamaica","BV":"Bouvet Island","BW":"Botswana","WS":"Samoa","BQ":"Bonaire, Saint Eustatius and Saba ","BR":"Brazil","BS":"Bahamas","JE":"Jersey","BY":"Belarus","BZ":"Belize","RU":"Russia","RW":"Rwanda","RS":"Serbia","TL":"East Timor","RE":"Reunion","TM":"Turkmenistan","TJ":"Tajikistan","RO":"Romania","TK":"Tokelau","GW":"Guinea-Bissau","GU":"Guam","GT":"Guatemala","GS":"South Georgia and the South Sandwich Islands","GR":"Greece","GQ":"Equatorial Guinea","GP":"Guadeloupe","JP":"Japan","GY":"Guyana","GG":"Guernsey","GF":"French Guiana","GE":"Georgia","GD":"Grenada","GB":"United Kingdom","GA":"Gabon","SV":"El Salvador","GN":"Guinea","GM":"Gambia","GL":"Greenland","GI":"Gibraltar","GH":"Ghana","OM":"Oman","TN":"Tunisia","JO":"Jordan","HR":"Croatia","HT":"Haiti","HU":"Hungary","HK":"Hong Kong","HN":"Honduras","HM":"Heard Island and McDonald Islands","VE":"Venezuela","PR":"Puerto Rico","PS":"Palestinian Territory","PW":"Palau","PT":"Portugal","SJ":"Svalbard and Jan Mayen","PY":"Paraguay","IQ":"Iraq","PA":"Panama","PF":"French Polynesia","PG":"Papua New Guinea","PE":"Peru","PK":"Pakistan","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PM":"Saint Pierre and Miquelon","ZM":"Zambia","EH":"Western Sahara","EE":"Estonia","EG":"Egypt","ZA":"South Africa","EC":"Ecuador","IT":"Italy","VN":"Vietnam","SB":"Solomon Islands","ET":"Ethiopia","SO":"Somalia","ZW":"Zimbabwe","SA":"Saudi Arabia","ES":"Spain","ER":"Eritrea","ME":"Montenegro","MD":"Moldova","MG":"Madagascar","MF":"Saint Martin","MA":"Morocco","MC":"Monaco","UZ":"Uzbekistan","MM":"Myanmar","ML":"Mali","MO":"Macao","MN":"Mongolia","MH":"Marshall Islands","MK":"Macedonia","MU":"Mauritius","MT":"Malta","MW":"Malawi","MV":"Maldives","MQ":"Martinique","MP":"Northern Mariana Islands","MS":"Montserrat","MR":"Mauritania","IM":"Isle of Man","UG":"Uganda","TZ":"Tanzania","MY":"Malaysia","MX":"Mexico","IL":"Israel","FR":"France","IO":"British Indian Ocean Territory","SH":"Saint Helena","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands","FM":"Micronesia","FO":"Faroe Islands","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NA":"Namibia","VU":"Vanuatu","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NZ":"New Zealand","NP":"Nepal","NR":"Nauru","NU":"Niue","CK":"Cook Islands","XK":"Kosovo","CI":"Ivory Coast","CH":"Switzerland","CO":"Colombia","CN":"China","CM":"Cameroon","CL":"Chile","CC":"Cocos Islands","CA":"Canada","CG":"Republic of the Congo","CF":"Central African Republic","CD":"Democratic Republic of the Congo","CZ":"Czech Republic","CY":"Cyprus","CX":"Christmas Island","CR":"Costa Rica","CW":"Curacao","CV":"Cape Verde","CU":"Cuba","SZ":"Swaziland","SY":"Syria","SX":"Sint Maarten","KG":"Kyrgyzstan","KE":"Kenya","SS":"South Sudan","SR":"Suriname","KI":"Kiribati","KH":"Cambodia","KN":"Saint Kitts and Nevis","KM":"Comoros","ST":"Sao Tome and Principe","SK":"Slovakia","KR":"South Korea","SI":"Slovenia","KP":"North Korea","KW":"Kuwait","SN":"Senegal","SM":"San Marino","SL":"Sierra Leone","SC":"Seychelles","KZ":"Kazakhstan","KY":"Cayman Islands","SG":"Singapore","SE":"Sweden","SD":"Sudan","DO":"Dominican Republic","DM":"Dominica","DJ":"Djibouti","DK":"Denmark","VG":"British Virgin Islands","DE":"Germany","YE":"Yemen","DZ":"Algeria","US":"United States","UY":"Uruguay","YT":"Mayotte","UM":"United States Minor Outlying Islands","LB":"Lebanon","LC":"Saint Lucia","LA":"Laos","TV":"Tuvalu","TW":"Taiwan","TT":"Trinidad and Tobago","TR":"Turkey","LK":"Sri Lanka","LI":"Liechtenstein","LV":"Latvia","TO":"Tonga","LT":"Lithuania","LU":"Luxembourg","LR":"Liberia","LS":"Lesotho","TH":"Thailand","TF":"French Southern Territories","TG":"Togo","TD":"Chad","TC":"Turks and Caicos Islands","LY":"Libya","VA":"Vatican","VC":"Saint Vincent and the Grenadines","AE":"United Arab Emirates","AD":"Andorra","AG":"Antigua and Barbuda","AF":"Afghanistan","AI":"Anguilla","VI":"U.S. Virgin Islands","IS":"Iceland","IR":"Iran","AM":"Armenia","AL":"Albania","AO":"Angola","AQ":"Antarctica","AS":"American Samoa","AR":"Argentina","AU":"Australia","AT":"Austria","AW":"Aruba","IN":"India","AX":"Aland Islands","AZ":"Azerbaijan","IE":"Ireland","ID":"Indonesia","UA":"Ukraine","QA":"Qatar","MZ":"Mozambique"}

/***/ }),
/* 298 */
/***/ (function(module, exports) {

module.exports = {"af":"Afrikaans","sq":"Albanian - shqip","am":"Amharic - አማርኛ","ar":"Arabic - العربية","an":"Aragonese - aragonés","hy":"Armenian - հայերեն","ast":"Asturian - asturianu","az":"Azerbaijani - azərbaycan dili","eu":"Basque - euskara","be":"Belarusian - беларуская","bn":"Bengali - বাংলা","bs":"Bosnian - bosanski","br":"Breton - brezhoneg","bg":"Bulgarian - български","ca":"Catalan - català","ckb":"Central Kurdish - کوردی (دەستنوسی عەرەبی)","zh":"Chinese - 中文","zh-HK":"Chinese (Hong Kong) - 中文（香港）","zh-CN":"Chinese (Simplified) - 中文（简体）","zh-TW":"Chinese (Traditional) - 中文（繁體）","co":"Corsican","hr":"Croatian - hrvatski","cs":"Czech - čeština","da":"Danish - dansk","nl":"Dutch - Nederlands","en":"English","en-AU":"English (Australia)","en-CA":"English (Canada)","en-IN":"English (India)","en-NZ":"English (New Zealand)","en-ZA":"English (South Africa)","en-GB":"English (United Kingdom)","en-US":"English (United States)","eo":"Esperanto - esperanto","et":"Estonian - eesti","fo":"Faroese - føroyskt","fil":"Filipino","fi":"Finnish - suomi","fr":"French - français","fr-CA":"French (Canada) - français (Canada)","fr-FR":"French (France) - français (France)","fr-CH":"French (Switzerland) - français (Suisse)","gl":"Galician - galego","ka":"Georgian - ქართული","de":"German - Deutsch","de-AT":"German (Austria) - Deutsch (Österreich)","de-DE":"German (Germany) - Deutsch (Deutschland)","de-LI":"German (Liechtenstein) - Deutsch (Liechtenstein)","de-CH":"German (Switzerland) - Deutsch (Schweiz)","el":"Greek - Ελληνικά","gn":"Guarani","gu":"Gujarati - ગુજરાતી","ha":"Hausa","haw":"Hawaiian - ʻŌlelo Hawaiʻi","he":"Hebrew - עברית","hi":"Hindi - हिन्दी","hu":"Hungarian - magyar","is":"Icelandic - íslenska","id":"Indonesian - Indonesia","ia":"Interlingua","ga":"Irish - Gaeilge","it":"Italian - italiano","it-IT":"Italian (Italy) - italiano (Italia)","it-CH":"Italian (Switzerland) - italiano (Svizzera)","ja":"Japanese - 日本語","kn":"Kannada - ಕನ್ನಡ","kk":"Kazakh - қазақ тілі","km":"Khmer - ខ្មែរ","ko":"Korean - 한국어","ku":"Kurdish - Kurdî","ky":"Kyrgyz - кыргызча","lo":"Lao - ລາວ","la":"Latin","lv":"Latvian - latviešu","ln":"Lingala - lingála","lt":"Lithuanian - lietuvių","mk":"Macedonian - македонски","ms":"Malay - Bahasa Melayu","ml":"Malayalam - മലയാളം","mt":"Maltese - Malti","mr":"Marathi - मराठी","mn":"Mongolian - монгол","ne":"Nepali - नेपाली","no":"Norwegian - norsk","nb":"Norwegian Bokmål - norsk bokmål","nn":"Norwegian Nynorsk - nynorsk","oc":"Occitan","or":"Oriya - ଓଡ଼ିଆ","om":"Oromo - Oromoo","ps":"Pashto - پښتو","fa":"Persian - فارسی","pl":"Polish - polski","pt":"Portuguese - português","pt-BR":"Portuguese (Brazil) - português (Brasil)","pt-PT":"Portuguese (Portugal) - português (Portugal)","pa":"Punjabi - ਪੰਜਾਬੀ","qu":"Quechua","ro":"Romanian - română","mo":"Romanian (Moldova) - română (Moldova)","rm":"Romansh - rumantsch","ru":"Russian - русский","gd":"Scottish Gaelic","sr":"Serbian - српски","sh":"Serbo-Croatian - Srpskohrvatski","sn":"Shona - chiShona","sd":"Sindhi","si":"Sinhala - සිංහල","sk":"Slovak - slovenčina","sl":"Slovenian - slovenščina","so":"Somali - Soomaali","st":"Southern Sotho","es":"Spanish - español","es-AR":"Spanish (Argentina) - español (Argentina)","es-419":"Spanish (Latin America) - español (Latinoamérica)","es-MX":"Spanish (Mexico) - español (México)","es-ES":"Spanish (Spain) - español (España)","es-US":"Spanish (United States) - español (Estados Unidos)","su":"Sundanese","sw":"Swahili - Kiswahili","sv":"Swedish - svenska","tg":"Tajik - тоҷикӣ","ta":"Tamil - தமிழ்","tt":"Tatar","te":"Telugu - తెలుగు","th":"Thai - ไทย","ti":"Tigrinya - ትግርኛ","to":"Tongan - lea fakatonga","tr":"Turkish - Türkçe","tk":"Turkmen","tw":"Twi","uk":"Ukrainian - українська","ur":"Urdu - اردو","ug":"Uyghur","uz":"Uzbek - o‘zbek","vi":"Vietnamese - Tiếng Việt","wa":"Walloon - wa","cy":"Welsh - Cymraeg","fy":"Western Frisian","xh":"Xhosa","yi":"Yiddish","yo":"Yoruba - Èdè Yorùbá","zu":"Zulu - isiZulu"}

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b10579e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__ = __webpack_require__(866);
function injectStyle (ssrContext) {
  __webpack_require__(862)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b10579e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown2_vue__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c9a5b51_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown2_vue__ = __webpack_require__(868);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Countdown2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c9a5b51_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Countdown2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPromise;
/**
 * Returns true if the value acts like a Promise, i.e. has a "then" function,
 * otherwise returns false.
 */
// eslint-disable-next-line no-redeclare
function isPromise(value) {
  return typeof (value === null || value === void 0 ? void 0 : value.then) === 'function';
}


/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = syntaxError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError_mjs__ = __webpack_require__(13);

/**
 * Produces a GraphQLError representing a syntax error, containing useful
 * descriptive information about the syntax error's position in the source.
 */

function syntaxError(source, position, description) {
  return new __WEBPACK_IMPORTED_MODULE_0__GraphQLError_mjs__["a" /* GraphQLError */]("Syntax Error: ".concat(description), undefined, source, [position]);
}


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getLocation;
/**
 * Represents a location in a Source.
 */

/**
 * Takes a Source and a UTF-8 character offset, and returns the corresponding
 * line and column as a SourceLocation.
 */
function getLocation(source, position) {
  var lineRegexp = /\r\n|[\n\r]/g;
  var line = 1;
  var column = position + 1;
  var match;

  while ((match = lineRegexp.exec(source.body)) && match.index < position) {
    line += 1;
    column = position + 1 - (match.index + match[0].length);
  }

  return {
    line: line,
    column: column
  };
}


/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = defineInspect;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__nodejsCustomInspectSymbol_mjs__ = __webpack_require__(543);


/**
 * The `defineInspect()` function defines `inspect()` prototype method as alias of `toJSON`
 */

function defineInspect(classObject) {
  var fn = classObject.prototype.toJSON;
  typeof fn === 'function' || Object(__WEBPACK_IMPORTED_MODULE_0__invariant_mjs__["a" /* default */])(0);
  classObject.prototype.inspect = fn; // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2317')

  if (__WEBPACK_IMPORTED_MODULE_1__nodejsCustomInspectSymbol_mjs__["a" /* default */]) {
    classObject.prototype[__WEBPACK_IMPORTED_MODULE_1__nodejsCustomInspectSymbol_mjs__["a" /* default */]] = fn;
  }
}


/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Source; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isSource;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_instanceOf_mjs__ = __webpack_require__(200);
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }






/**
 * A representation of source input to GraphQL. The `name` and `locationOffset` parameters are
 * optional, but they are useful for clients who store GraphQL documents in source files.
 * For example, if the GraphQL input starts at line 40 in a file named `Foo.graphql`, it might
 * be useful for `name` to be `"Foo.graphql"` and location to be `{ line: 40, column: 1 }`.
 * The `line` and `column` properties in `locationOffset` are 1-indexed.
 */
var Source = /*#__PURE__*/function () {
  function Source(body) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'GraphQL request';
    var locationOffset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
      line: 1,
      column: 1
    };
    typeof body === 'string' || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__["a" /* default */])(0, "Body must be a string. Received: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(body), "."));
    this.body = body;
    this.name = name;
    this.locationOffset = locationOffset;
    this.locationOffset.line > 0 || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__["a" /* default */])(0, 'line in locationOffset is 1-indexed and must be positive.');
    this.locationOffset.column > 0 || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__["a" /* default */])(0, 'column in locationOffset is 1-indexed and must be positive.');
  } // $FlowFixMe[unsupported-syntax] Flow doesn't support computed properties yet


  _createClass(Source, [{
    key: __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__["c" /* SYMBOL_TO_STRING_TAG */],
    get: function get() {
      return 'Source';
    }
  }]);

  return Source;
}();
/**
 * Test if the given value is a Source object.
 *
 * @internal
 */

// eslint-disable-next-line no-redeclare
function isSource(source) {
  return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_instanceOf_mjs__["a" /* default */])(source, Source);
}


/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Lexer; });
/* harmony export (immutable) */ __webpack_exports__["b"] = isPunctuatorTokenKind;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ast_mjs__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__blockString_mjs__ = __webpack_require__(159);




/**
 * Given a Source object, creates a Lexer for that source.
 * A Lexer is a stateful stream generator in that every time
 * it is advanced, it returns the next token in the Source. Assuming the
 * source lexes, the final Token emitted by the lexer will be of kind
 * EOF, after which the lexer will repeatedly return the same EOF token
 * whenever called.
 */

var Lexer = /*#__PURE__*/function () {
  /**
   * The previously focused non-ignored token.
   */

  /**
   * The currently focused non-ignored token.
   */

  /**
   * The (1-indexed) line containing the current token.
   */

  /**
   * The character offset at which the current line begins.
   */
  function Lexer(source) {
    var startOfFileToken = new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].SOF, 0, 0, 0, 0, null);
    this.source = source;
    this.lastToken = startOfFileToken;
    this.token = startOfFileToken;
    this.line = 1;
    this.lineStart = 0;
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */


  var _proto = Lexer.prototype;

  _proto.advance = function advance() {
    this.lastToken = this.token;
    var token = this.token = this.lookahead();
    return token;
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  ;

  _proto.lookahead = function lookahead() {
    var token = this.token;

    if (token.kind !== __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].EOF) {
      do {
        var _token$next;

        // Note: next is only mutable during parsing, so we cast to allow this.
        token = (_token$next = token.next) !== null && _token$next !== void 0 ? _token$next : token.next = readToken(this, token);
      } while (token.kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].COMMENT);
    }

    return token;
  };

  return Lexer;
}();
/**
 * @internal
 */

function isPunctuatorTokenKind(kind) {
  return kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BANG || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].DOLLAR || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].AMP || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PAREN_L || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PAREN_R || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].SPREAD || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].COLON || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].EQUALS || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].AT || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACKET_L || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACKET_R || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACE_L || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PIPE || kind === __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACE_R;
}

function printCharCode(code) {
  return (// NaN/undefined represents access beyond the end of the file.
    isNaN(code) ? __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].EOF : // Trust JSON for ASCII.
    code < 0x007f ? JSON.stringify(String.fromCharCode(code)) : // Otherwise print the escaped form.
    "\"\\u".concat(('00' + code.toString(16).toUpperCase()).slice(-4), "\"")
  );
}
/**
 * Gets the next token from the source starting at the given position.
 *
 * This skips over whitespace until it finds the next lexable token, then lexes
 * punctuators immediately or calls the appropriate helper function for more
 * complicated tokens.
 */


function readToken(lexer, prev) {
  var source = lexer.source;
  var body = source.body;
  var bodyLength = body.length;
  var pos = prev.end;

  while (pos < bodyLength) {
    var code = body.charCodeAt(pos);
    var _line = lexer.line;

    var _col = 1 + pos - lexer.lineStart; // SourceCharacter


    switch (code) {
      case 0xfeff: // <BOM>

      case 9: //   \t

      case 32: //  <space>

      case 44:
        //  ,
        ++pos;
        continue;

      case 10:
        //  \n
        ++pos;
        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 13:
        //  \r
        if (body.charCodeAt(pos + 1) === 10) {
          pos += 2;
        } else {
          ++pos;
        }

        ++lexer.line;
        lexer.lineStart = pos;
        continue;

      case 33:
        //  !
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BANG, pos, pos + 1, _line, _col, prev);

      case 35:
        //  #
        return readComment(source, pos, _line, _col, prev);

      case 36:
        //  $
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].DOLLAR, pos, pos + 1, _line, _col, prev);

      case 38:
        //  &
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].AMP, pos, pos + 1, _line, _col, prev);

      case 40:
        //  (
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PAREN_L, pos, pos + 1, _line, _col, prev);

      case 41:
        //  )
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PAREN_R, pos, pos + 1, _line, _col, prev);

      case 46:
        //  .
        if (body.charCodeAt(pos + 1) === 46 && body.charCodeAt(pos + 2) === 46) {
          return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].SPREAD, pos, pos + 3, _line, _col, prev);
        }

        break;

      case 58:
        //  :
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].COLON, pos, pos + 1, _line, _col, prev);

      case 61:
        //  =
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].EQUALS, pos, pos + 1, _line, _col, prev);

      case 64:
        //  @
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].AT, pos, pos + 1, _line, _col, prev);

      case 91:
        //  [
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACKET_L, pos, pos + 1, _line, _col, prev);

      case 93:
        //  ]
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACKET_R, pos, pos + 1, _line, _col, prev);

      case 123:
        // {
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACE_L, pos, pos + 1, _line, _col, prev);

      case 124:
        // |
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].PIPE, pos, pos + 1, _line, _col, prev);

      case 125:
        // }
        return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BRACE_R, pos, pos + 1, _line, _col, prev);

      case 34:
        //  "
        if (body.charCodeAt(pos + 1) === 34 && body.charCodeAt(pos + 2) === 34) {
          return readBlockString(source, pos, _line, _col, prev, lexer);
        }

        return readString(source, pos, _line, _col, prev);

      case 45: //  -

      case 48: //  0

      case 49: //  1

      case 50: //  2

      case 51: //  3

      case 52: //  4

      case 53: //  5

      case 54: //  6

      case 55: //  7

      case 56: //  8

      case 57:
        //  9
        return readNumber(source, pos, code, _line, _col, prev);

      case 65: //  A

      case 66: //  B

      case 67: //  C

      case 68: //  D

      case 69: //  E

      case 70: //  F

      case 71: //  G

      case 72: //  H

      case 73: //  I

      case 74: //  J

      case 75: //  K

      case 76: //  L

      case 77: //  M

      case 78: //  N

      case 79: //  O

      case 80: //  P

      case 81: //  Q

      case 82: //  R

      case 83: //  S

      case 84: //  T

      case 85: //  U

      case 86: //  V

      case 87: //  W

      case 88: //  X

      case 89: //  Y

      case 90: //  Z

      case 95: //  _

      case 97: //  a

      case 98: //  b

      case 99: //  c

      case 100: // d

      case 101: // e

      case 102: // f

      case 103: // g

      case 104: // h

      case 105: // i

      case 106: // j

      case 107: // k

      case 108: // l

      case 109: // m

      case 110: // n

      case 111: // o

      case 112: // p

      case 113: // q

      case 114: // r

      case 115: // s

      case 116: // t

      case 117: // u

      case 118: // v

      case 119: // w

      case 120: // x

      case 121: // y

      case 122:
        // z
        return readName(source, pos, _line, _col, prev);
    }

    throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, pos, unexpectedCharacterMessage(code));
  }

  var line = lexer.line;
  var col = 1 + pos - lexer.lineStart;
  return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].EOF, bodyLength, bodyLength, line, col, prev);
}
/**
 * Report a message that an unexpected character was encountered.
 */


function unexpectedCharacterMessage(code) {
  if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
    return "Cannot contain the invalid character ".concat(printCharCode(code), ".");
  }

  if (code === 39) {
    // '
    return 'Unexpected single quote character (\'), did you mean to use a double quote (")?';
  }

  return "Cannot parse the unexpected character ".concat(printCharCode(code), ".");
}
/**
 * Reads a comment token from the source file.
 *
 * #[\u0009\u0020-\uFFFF]*
 */


function readComment(source, start, line, col, prev) {
  var body = source.body;
  var code;
  var position = start;

  do {
    code = body.charCodeAt(++position);
  } while (!isNaN(code) && ( // SourceCharacter but not LineTerminator
  code > 0x001f || code === 0x0009));

  return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].COMMENT, start, position, line, col, prev, body.slice(start + 1, position));
}
/**
 * Reads a number token from the source file, either a float
 * or an int depending on whether a decimal point appears.
 *
 * Int:   -?(0|[1-9][0-9]*)
 * Float: -?(0|[1-9][0-9]*)(\.[0-9]+)?((E|e)(+|-)?[0-9]+)?
 */


function readNumber(source, start, firstCode, line, col, prev) {
  var body = source.body;
  var code = firstCode;
  var position = start;
  var isFloat = false;

  if (code === 45) {
    // -
    code = body.charCodeAt(++position);
  }

  if (code === 48) {
    // 0
    code = body.charCodeAt(++position);

    if (code >= 48 && code <= 57) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid number, unexpected digit after 0: ".concat(printCharCode(code), "."));
    }
  } else {
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 46) {
    // .
    isFloat = true;
    code = body.charCodeAt(++position);
    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  }

  if (code === 69 || code === 101) {
    // E e
    isFloat = true;
    code = body.charCodeAt(++position);

    if (code === 43 || code === 45) {
      // + -
      code = body.charCodeAt(++position);
    }

    position = readDigits(source, position, code);
    code = body.charCodeAt(position);
  } // Numbers cannot be followed by . or NameStart


  if (code === 46 || isNameStart(code)) {
    throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
  }

  return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](isFloat ? __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].FLOAT : __WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].INT, start, position, line, col, prev, body.slice(start, position));
}
/**
 * Returns the new position in the source after reading digits.
 */


function readDigits(source, start, firstCode) {
  var body = source.body;
  var position = start;
  var code = firstCode;

  if (code >= 48 && code <= 57) {
    // 0 - 9
    do {
      code = body.charCodeAt(++position);
    } while (code >= 48 && code <= 57); // 0 - 9


    return position;
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid number, expected digit but got: ".concat(printCharCode(code), "."));
}
/**
 * Reads a string token from the source file.
 *
 * "([^"\\\u000A\u000D]|(\\(u[0-9a-fA-F]{4}|["\\/bfnrt])))*"
 */


function readString(source, start, line, col, prev) {
  var body = source.body;
  var position = start + 1;
  var chunkStart = position;
  var code = 0;
  var value = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position)) && // not LineTerminator
  code !== 0x000a && code !== 0x000d) {
    // Closing Quote (")
    if (code === 34) {
      value += body.slice(chunkStart, position);
      return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].STRING, start, position + 1, line, col, prev, value);
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    ++position;

    if (code === 92) {
      // \
      value += body.slice(chunkStart, position - 1);
      code = body.charCodeAt(position);

      switch (code) {
        case 34:
          value += '"';
          break;

        case 47:
          value += '/';
          break;

        case 92:
          value += '\\';
          break;

        case 98:
          value += '\b';
          break;

        case 102:
          value += '\f';
          break;

        case 110:
          value += '\n';
          break;

        case 114:
          value += '\r';
          break;

        case 116:
          value += '\t';
          break;

        case 117:
          {
            // uXXXX
            var charCode = uniCharCode(body.charCodeAt(position + 1), body.charCodeAt(position + 2), body.charCodeAt(position + 3), body.charCodeAt(position + 4));

            if (charCode < 0) {
              var invalidSequence = body.slice(position + 1, position + 5);
              throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid character escape sequence: \\u".concat(invalidSequence, "."));
            }

            value += String.fromCharCode(charCode);
            position += 4;
            break;
          }

        default:
          throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid character escape sequence: \\".concat(String.fromCharCode(code), "."));
      }

      ++position;
      chunkStart = position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}
/**
 * Reads a block string token from the source file.
 *
 * """("?"?(\\"""|\\(?!=""")|[^"\\]))*"""
 */


function readBlockString(source, start, line, col, prev, lexer) {
  var body = source.body;
  var position = start + 3;
  var chunkStart = position;
  var code = 0;
  var rawValue = '';

  while (position < body.length && !isNaN(code = body.charCodeAt(position))) {
    // Closing Triple-Quote (""")
    if (code === 34 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34) {
      rawValue += body.slice(chunkStart, position);
      return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].BLOCK_STRING, start, position + 3, line, col, prev, Object(__WEBPACK_IMPORTED_MODULE_3__blockString_mjs__["a" /* dedentBlockStringValue */])(rawValue));
    } // SourceCharacter


    if (code < 0x0020 && code !== 0x0009 && code !== 0x000a && code !== 0x000d) {
      throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, "Invalid character within String: ".concat(printCharCode(code), "."));
    }

    if (code === 10) {
      // new line
      ++position;
      ++lexer.line;
      lexer.lineStart = position;
    } else if (code === 13) {
      // carriage return
      if (body.charCodeAt(position + 1) === 10) {
        position += 2;
      } else {
        ++position;
      }

      ++lexer.line;
      lexer.lineStart = position;
    } else if ( // Escape Triple-Quote (\""")
    code === 92 && body.charCodeAt(position + 1) === 34 && body.charCodeAt(position + 2) === 34 && body.charCodeAt(position + 3) === 34) {
      rawValue += body.slice(chunkStart, position) + '"""';
      position += 4;
      chunkStart = position;
    } else {
      ++position;
    }
  }

  throw Object(__WEBPACK_IMPORTED_MODULE_0__error_syntaxError_mjs__["a" /* syntaxError */])(source, position, 'Unterminated string.');
}
/**
 * Converts four hexadecimal chars to the integer that the
 * string represents. For example, uniCharCode('0','0','0','f')
 * will return 15, and uniCharCode('0','0','f','f') returns 255.
 *
 * Returns a negative number on error, if a char was invalid.
 *
 * This is implemented by noting that char2hex() returns -1 on error,
 * which means the result of ORing the char2hex() will also be negative.
 */


function uniCharCode(a, b, c, d) {
  return char2hex(a) << 12 | char2hex(b) << 8 | char2hex(c) << 4 | char2hex(d);
}
/**
 * Converts a hex character to its integer value.
 * '0' becomes 0, '9' becomes 9
 * 'A' becomes 10, 'F' becomes 15
 * 'a' becomes 10, 'f' becomes 15
 *
 * Returns -1 on error.
 */


function char2hex(a) {
  return a >= 48 && a <= 57 ? a - 48 // 0-9
  : a >= 65 && a <= 70 ? a - 55 // A-F
  : a >= 97 && a <= 102 ? a - 87 // a-f
  : -1;
}
/**
 * Reads an alphanumeric + underscore name from the source.
 *
 * [_A-Za-z][_0-9A-Za-z]*
 */


function readName(source, start, line, col, prev) {
  var body = source.body;
  var bodyLength = body.length;
  var position = start + 1;
  var code = 0;

  while (position !== bodyLength && !isNaN(code = body.charCodeAt(position)) && (code === 95 || // _
  code >= 48 && code <= 57 || // 0-9
  code >= 65 && code <= 90 || // A-Z
  code >= 97 && code <= 122) // a-z
  ) {
    ++position;
  }

  return new __WEBPACK_IMPORTED_MODULE_1__ast_mjs__["b" /* Token */](__WEBPACK_IMPORTED_MODULE_2__tokenKind_mjs__["a" /* TokenKind */].NAME, start, position, line, col, prev, body.slice(start, position));
} // _ A-Z a-z


function isNameStart(code) {
  return code === 95 || code >= 65 && code <= 90 || code >= 97 && code <= 122;
}


/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toObjMap;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__ = __webpack_require__(162);

function toObjMap(obj) {
  /* eslint-enable no-redeclare */
  if (Object.getPrototypeOf(obj) === null) {
    return obj;
  }

  var map = Object.create(null);

  for (var _i2 = 0, _objectEntries2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__["a" /* default */])(obj); _i2 < _objectEntries2.length; _i2++) {
    var _ref2 = _objectEntries2[_i2];
    var key = _ref2[0];
    var value = _ref2[1];
    map[key] = value;
  }

  return map;
}


/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = safeArrayFrom;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__ = __webpack_require__(87);
function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }


/**
 * Safer version of `Array.from` that return `null` if value isn't convertible to array.
 * Also protects against Array-like objects without items.
 *
 * @example
 *
 * safeArrayFrom([ 1, 2, 3 ]) // [1, 2, 3]
 * safeArrayFrom('ABC') // null
 * safeArrayFrom({ length: 1 }) // null
 * safeArrayFrom({ length: 1, 0: 'Alpha' }) // ['Alpha']
 * safeArrayFrom({ key: 'value' }) // null
 * safeArrayFrom(new Map()) // []
 *
 */

function safeArrayFrom(collection) {
  var mapFn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (item) {
    return item;
  };

  if (collection == null || _typeof(collection) !== 'object') {
    return null;
  }

  if (Array.isArray(collection)) {
    return collection.map(mapFn);
  } // Is Iterable?


  var iteratorMethod = collection[__WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__["b" /* SYMBOL_ITERATOR */]];

  if (typeof iteratorMethod === 'function') {
    // $FlowFixMe[incompatible-use]
    var iterator = iteratorMethod.call(collection);
    var result = [];
    var step;

    for (var i = 0; !(step = iterator.next()).done; ++i) {
      result.push(mapFn(step.value, i));
    }

    return result;
  } // Is Array like?


  var length = collection.length;

  if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
    var _result = [];

    for (var _i = 0; _i < length; ++_i) {
      if (!Object.prototype.hasOwnProperty.call(collection, _i)) {
        return null;
      }

      _result.push(mapFn(collection[String(_i)], _i));
    }

    return _result;
  }

  return null;
}


/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TypeInfo; });
/* harmony export (immutable) */ __webpack_exports__["b"] = visitWithTypeInfo;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_ast_mjs__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_visitor_mjs__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__typeFromAST_mjs__ = __webpack_require__(89);







/**
 * TypeInfo is a utility class which, given a GraphQL schema, can keep track
 * of the current field and type definitions at any point in a GraphQL document
 * AST during a recursive descent by calling `enter(node)` and `leave(node)`.
 */

var TypeInfo = /*#__PURE__*/function () {
  function TypeInfo(schema, // NOTE: this experimental optional second parameter is only needed in order
  // to support non-spec-compliant code bases. You should never need to use it.
  // It may disappear in the future.
  getFieldDefFn, // Initial type may be provided in rare cases to facilitate traversals
  // beginning somewhere other than documents.
  initialType) {
    this._schema = schema;
    this._typeStack = [];
    this._parentTypeStack = [];
    this._inputTypeStack = [];
    this._fieldDefStack = [];
    this._defaultValueStack = [];
    this._directive = null;
    this._argument = null;
    this._enumValue = null;
    this._getFieldDef = getFieldDefFn !== null && getFieldDefFn !== void 0 ? getFieldDefFn : getFieldDef;

    if (initialType) {
      if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["s" /* isInputType */])(initialType)) {
        this._inputTypeStack.push(initialType);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["p" /* isCompositeType */])(initialType)) {
        this._parentTypeStack.push(initialType);
      }

      if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["z" /* isOutputType */])(initialType)) {
        this._typeStack.push(initialType);
      }
    }
  }

  var _proto = TypeInfo.prototype;

  _proto.getType = function getType() {
    if (this._typeStack.length > 0) {
      return this._typeStack[this._typeStack.length - 1];
    }
  };

  _proto.getParentType = function getParentType() {
    if (this._parentTypeStack.length > 0) {
      return this._parentTypeStack[this._parentTypeStack.length - 1];
    }
  };

  _proto.getInputType = function getInputType() {
    if (this._inputTypeStack.length > 0) {
      return this._inputTypeStack[this._inputTypeStack.length - 1];
    }
  };

  _proto.getParentInputType = function getParentInputType() {
    if (this._inputTypeStack.length > 1) {
      return this._inputTypeStack[this._inputTypeStack.length - 2];
    }
  };

  _proto.getFieldDef = function getFieldDef() {
    if (this._fieldDefStack.length > 0) {
      return this._fieldDefStack[this._fieldDefStack.length - 1];
    }
  };

  _proto.getDefaultValue = function getDefaultValue() {
    if (this._defaultValueStack.length > 0) {
      return this._defaultValueStack[this._defaultValueStack.length - 1];
    }
  };

  _proto.getDirective = function getDirective() {
    return this._directive;
  };

  _proto.getArgument = function getArgument() {
    return this._argument;
  };

  _proto.getEnumValue = function getEnumValue() {
    return this._enumValue;
  };

  _proto.enter = function enter(node) {
    var schema = this._schema; // Note: many of the types below are explicitly typed as "mixed" to drop
    // any assumptions of a valid schema to ensure runtime types are properly
    // checked before continuing since TypeInfo is used as part of validation
    // which occurs before guarantees of schema and document validity.

    switch (node.kind) {
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SELECTION_SET:
        {
          var namedType = Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["m" /* getNamedType */])(this.getType());

          this._parentTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["p" /* isCompositeType */])(namedType) ? namedType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].FIELD:
        {
          var parentType = this.getParentType();
          var fieldDef;
          var fieldType;

          if (parentType) {
            fieldDef = this._getFieldDef(schema, parentType, node);

            if (fieldDef) {
              fieldType = fieldDef.type;
            }
          }

          this._fieldDefStack.push(fieldDef);

          this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["z" /* isOutputType */])(fieldType) ? fieldType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].DIRECTIVE:
        this._directive = schema.getDirective(node.name.value);
        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION:
        {
          var type;

          switch (node.operation) {
            case 'query':
              type = schema.getQueryType();
              break;

            case 'mutation':
              type = schema.getMutationType();
              break;

            case 'subscription':
              type = schema.getSubscriptionType();
              break;
          }

          this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["y" /* isObjectType */])(type) ? type : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT:
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION:
        {
          var typeConditionAST = node.typeCondition;
          var outputType = typeConditionAST ? Object(__WEBPACK_IMPORTED_MODULE_6__typeFromAST_mjs__["a" /* typeFromAST */])(schema, typeConditionAST) : Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["m" /* getNamedType */])(this.getType());

          this._typeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["z" /* isOutputType */])(outputType) ? outputType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].VARIABLE_DEFINITION:
        {
          var inputType = Object(__WEBPACK_IMPORTED_MODULE_6__typeFromAST_mjs__["a" /* typeFromAST */])(schema, node.type);

          this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["s" /* isInputType */])(inputType) ? inputType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].ARGUMENT:
        {
          var _this$getDirective;

          var argDef;
          var argType;
          var fieldOrDirective = (_this$getDirective = this.getDirective()) !== null && _this$getDirective !== void 0 ? _this$getDirective : this.getFieldDef();

          if (fieldOrDirective) {
            argDef = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(fieldOrDirective.args, function (arg) {
              return arg.name === node.name.value;
            });

            if (argDef) {
              argType = argDef.type;
            }
          }

          this._argument = argDef;

          this._defaultValueStack.push(argDef ? argDef.defaultValue : undefined);

          this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["s" /* isInputType */])(argType) ? argType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].LIST:
        {
          var listType = Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["n" /* getNullableType */])(this.getInputType());
          var itemType = Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["v" /* isListType */])(listType) ? listType.ofType : listType; // List positions never have a default value.

          this._defaultValueStack.push(undefined);

          this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["s" /* isInputType */])(itemType) ? itemType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].OBJECT_FIELD:
        {
          var objectType = Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["m" /* getNamedType */])(this.getInputType());
          var inputFieldType;
          var inputField;

          if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["r" /* isInputObjectType */])(objectType)) {
            inputField = objectType.getFields()[node.name.value];

            if (inputField) {
              inputFieldType = inputField.type;
            }
          }

          this._defaultValueStack.push(inputField ? inputField.defaultValue : undefined);

          this._inputTypeStack.push(Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["s" /* isInputType */])(inputFieldType) ? inputFieldType : undefined);

          break;
        }

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].ENUM:
        {
          var enumType = Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["m" /* getNamedType */])(this.getInputType());
          var enumValue;

          if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["q" /* isEnumType */])(enumType)) {
            enumValue = enumType.getValue(node.value);
          }

          this._enumValue = enumValue;
          break;
        }
    }
  };

  _proto.leave = function leave(node) {
    switch (node.kind) {
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SELECTION_SET:
        this._parentTypeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].FIELD:
        this._fieldDefStack.pop();

        this._typeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].DIRECTIVE:
        this._directive = null;
        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION:
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT:
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION:
        this._typeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].VARIABLE_DEFINITION:
        this._inputTypeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].ARGUMENT:
        this._argument = null;

        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].LIST:
      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].OBJECT_FIELD:
        this._defaultValueStack.pop();

        this._inputTypeStack.pop();

        break;

      case __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].ENUM:
        this._enumValue = null;
        break;
    }
  };

  return TypeInfo;
}();
/**
 * Not exactly the same as the executor's definition of getFieldDef, in this
 * statically evaluated environment we do not always have an Object type,
 * and need to handle Interface and Union types.
 */

function getFieldDef(schema, parentType, fieldNode) {
  var name = fieldNode.name.value;

  if (name === __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["a" /* SchemaMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["a" /* SchemaMetaFieldDef */];
  }

  if (name === __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["c" /* TypeMetaFieldDef */].name && schema.getQueryType() === parentType) {
    return __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["c" /* TypeMetaFieldDef */];
  }

  if (name === __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["d" /* TypeNameMetaFieldDef */].name && Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["p" /* isCompositeType */])(parentType)) {
    return __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["d" /* TypeNameMetaFieldDef */];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["y" /* isObjectType */])(parentType) || Object(__WEBPACK_IMPORTED_MODULE_4__type_definition_mjs__["t" /* isInterfaceType */])(parentType)) {
    return parentType.getFields()[name];
  }
}
/**
 * Creates a new visitor instance which maintains a provided TypeInfo instance
 * along with visiting visitor.
 */


function visitWithTypeInfo(typeInfo, visitor) {
  return {
    enter: function enter(node) {
      typeInfo.enter(node);
      var fn = Object(__WEBPACK_IMPORTED_MODULE_3__language_visitor_mjs__["a" /* getVisitFn */])(visitor, node.kind,
      /* isLeaving */
      false);

      if (fn) {
        var result = fn.apply(visitor, arguments);

        if (result !== undefined) {
          typeInfo.leave(node);

          if (Object(__WEBPACK_IMPORTED_MODULE_2__language_ast_mjs__["c" /* isNode */])(result)) {
            typeInfo.enter(result);
          }
        }

        return result;
      }
    },
    leave: function leave(node) {
      var fn = Object(__WEBPACK_IMPORTED_MODULE_3__language_visitor_mjs__["a" /* getVisitFn */])(visitor, node.kind,
      /* isLeaving */
      true);
      var result;

      if (fn) {
        result = fn.apply(visitor, arguments);
      }

      typeInfo.leave(node);
      return result;
    }
  };
}


/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getOperationRootType;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Extracts the root type of the operation from the schema.
 */
function getOperationRootType(schema, operation) {
  if (operation.operation === 'query') {
    var queryType = schema.getQueryType();

    if (!queryType) {
      throw new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Schema does not define the required query root type.', operation);
    }

    return queryType;
  }

  if (operation.operation === 'mutation') {
    var mutationType = schema.getMutationType();

    if (!mutationType) {
      throw new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Schema is not configured for mutations.', operation);
    }

    return mutationType;
  }

  if (operation.operation === 'subscription') {
    var subscriptionType = schema.getSubscriptionType();

    if (!subscriptionType) {
      throw new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Schema is not configured for subscriptions.', operation);
    }

    return subscriptionType;
  }

  throw new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Can only have query, mutation and subscription operations.', operation);
}


/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilsideinformation_vue__ = __webpack_require__(990);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea71660_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Profilsideinformation_vue__ = __webpack_require__(991);
function injectStyle (ssrContext) {
  __webpack_require__(989)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0ea71660"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilsideinformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ea71660_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Profilsideinformation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imagefolder_vue__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bedb03_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imagefolder_vue__ = __webpack_require__(1006);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_imagefolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_52bedb03_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_imagefolder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property__ = __webpack_require__(523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property__);






/* harmony default export */ __webpack_exports__["a"] = (typeof window !== 'undefined' ? function () {
    (function () {
        if (typeof window.CustomEvent === 'function') return false;

        function CustomEvent(event, params) {
            params = params || { bubbles: false, cancelable: false, detail: undefined };
            var evt = document.createEvent('CustomEvent');
            evt.initCustomEvent(event, params.bubbles, params.cancelable, params.detail);
            return evt;
        }

        CustomEvent.prototype = window.Event.prototype;

        window.CustomEvent = CustomEvent;
    })();

    var loadImage = function loadImage(file, callback, options) {
        var img = document.createElement('img');
        var url;
        var oUrl;
        img.onerror = callback;
        img.onload = function () {
            if (oUrl && !(options && options.noRevoke)) {
                loadImage.revokeObjectURL(oUrl);
            }
            if (callback) {
                callback(loadImage.scale(img, options));
            }
        };
        if (loadImage.isInstanceOf('Blob', file) || loadImage.isInstanceOf('File', file)) {
            url = oUrl = loadImage.createObjectURL(file);

            img._type = file.type;
        } else if (typeof file === 'string') {
            url = file;
            if (options && options.crossOrigin) {
                img.crossOrigin = options.crossOrigin;
            }
        } else {
            return false;
        }
        if (url) {
            img.src = url;
            return img;
        }
        return loadImage.readFile(file, function (e) {
            var target = e.target;
            if (target && target.result) {
                img.src = target.result;
            } else {
                if (callback) {
                    callback(e);
                }
            }
        });
    };

    var urlAPI = window.createObjectURL && window || window.URL && URL.revokeObjectURL && URL || window.webkitURL && webkitURL;

    loadImage.isInstanceOf = function (type, obj) {
        return Object.prototype.toString.call(obj) === '[object ' + type + ']';
    };

    loadImage.transformCoordinates = function () {
        return;
    };

    loadImage.getTransformedOptions = function (img, options) {
        var aspectRatio = options.aspectRatio;
        var newOptions;
        var i;
        var width;
        var height;
        if (!aspectRatio) {
            return options;
        }
        newOptions = {};
        for (i in options) {
            if (options.hasOwnProperty(i)) {
                newOptions[i] = options[i];
            }
        }
        newOptions.crop = true;
        width = img.naturalWidth || img.width;
        height = img.naturalHeight || img.height;
        if (width / height > aspectRatio) {
            newOptions.maxWidth = height * aspectRatio;
            newOptions.maxHeight = height;
        } else {
            newOptions.maxWidth = width;
            newOptions.maxHeight = width / aspectRatio;
        }
        return newOptions;
    };

    loadImage.renderImageToCanvas = function (canvas, img, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight) {
        canvas.getContext('2d').drawImage(img, sourceX, sourceY, sourceWidth, sourceHeight, destX, destY, destWidth, destHeight);
        return canvas;
    };

    loadImage.hasCanvasOption = function (options) {
        return options.canvas || options.crop || !!options.aspectRatio;
    };

    loadImage.scale = function (img, options) {
        options = options || {};
        var canvas = document.createElement('canvas');
        var useCanvas = img.getContext || loadImage.hasCanvasOption(options) && canvas.getContext;
        var width = img.naturalWidth || img.width;
        var height = img.naturalHeight || img.height;
        var destWidth = width;
        var destHeight = height;
        var maxWidth;
        var maxHeight;
        var minWidth;
        var minHeight;
        var sourceWidth;
        var sourceHeight;
        var sourceX;
        var sourceY;
        var pixelRatio;
        var downsamplingRatio;
        var tmp;
        function scaleUp() {
            var scale = Math.max((minWidth || destWidth) / destWidth, (minHeight || destHeight) / destHeight);
            if (scale > 1) {
                destWidth *= scale;
                destHeight *= scale;
            }
        }
        function scaleDown() {
            var scale = Math.min((maxWidth || destWidth) / destWidth, (maxHeight || destHeight) / destHeight);
            if (scale < 1) {
                destWidth *= scale;
                destHeight *= scale;
            }
        }
        if (useCanvas) {
            options = loadImage.getTransformedOptions(img, options);
            sourceX = options.left || 0;
            sourceY = options.top || 0;
            if (options.sourceWidth) {
                sourceWidth = options.sourceWidth;
                if (options.right !== undefined && options.left === undefined) {
                    sourceX = width - sourceWidth - options.right;
                }
            } else {
                sourceWidth = width - sourceX - (options.right || 0);
            }
            if (options.sourceHeight) {
                sourceHeight = options.sourceHeight;
                if (options.bottom !== undefined && options.top === undefined) {
                    sourceY = height - sourceHeight - options.bottom;
                }
            } else {
                sourceHeight = height - sourceY - (options.bottom || 0);
            }
            destWidth = sourceWidth;
            destHeight = sourceHeight;
        }
        maxWidth = options.maxWidth;
        maxHeight = options.maxHeight;
        minWidth = options.minWidth;
        minHeight = options.minHeight;
        if (useCanvas && maxWidth && maxHeight && options.crop) {
            destWidth = maxWidth;
            destHeight = maxHeight;
            tmp = sourceWidth / sourceHeight - maxWidth / maxHeight;
            if (tmp < 0) {
                sourceHeight = maxHeight * sourceWidth / maxWidth;
                if (options.top === undefined && options.bottom === undefined) {
                    sourceY = (height - sourceHeight) / 2;
                }
            } else if (tmp > 0) {
                sourceWidth = maxWidth * sourceHeight / maxHeight;
                if (options.left === undefined && options.right === undefined) {
                    sourceX = (width - sourceWidth) / 2;
                }
            }
        } else {
            if (options.contain || options.cover) {
                minWidth = maxWidth = maxWidth || minWidth;
                minHeight = maxHeight = maxHeight || minHeight;
            }
            if (options.cover) {
                scaleDown();
                scaleUp();
            } else {
                scaleUp();
                scaleDown();
            }
        }
        if (useCanvas) {
            pixelRatio = options.pixelRatio;
            if (pixelRatio > 1) {
                canvas.style.width = destWidth + 'px';
                canvas.style.height = destHeight + 'px';
                destWidth *= pixelRatio;
                destHeight *= pixelRatio;
                canvas.getContext('2d').scale(pixelRatio, pixelRatio);
            }
            downsamplingRatio = options.downsamplingRatio;
            if (downsamplingRatio > 0 && downsamplingRatio < 1 && destWidth < sourceWidth && destHeight < sourceHeight) {
                while (sourceWidth * downsamplingRatio > destWidth) {
                    canvas.width = sourceWidth * downsamplingRatio;
                    canvas.height = sourceHeight * downsamplingRatio;
                    loadImage.renderImageToCanvas(canvas, img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, canvas.width, canvas.height);
                    sourceWidth = canvas.width;
                    sourceHeight = canvas.height;
                    img = document.createElement('canvas');
                    img.width = sourceWidth;
                    img.height = sourceHeight;
                    loadImage.renderImageToCanvas(img, canvas, 0, 0, sourceWidth, sourceHeight, 0, 0, sourceWidth, sourceHeight);
                }
            }
            canvas.width = destWidth;
            canvas.height = destHeight;
            loadImage.transformCoordinates(canvas, options);
            return loadImage.renderImageToCanvas(canvas, img, sourceX, sourceY, sourceWidth, sourceHeight, 0, 0, destWidth, destHeight);
        }
        img.width = destWidth;
        img.height = destHeight;
        return img;
    };

    loadImage.createObjectURL = function (file) {
        return urlAPI ? urlAPI.createObjectURL(file) : false;
    };

    loadImage.revokeObjectURL = function (url) {
        return urlAPI ? urlAPI.revokeObjectURL(url) : false;
    };

    loadImage.readFile = function (file, callback, method) {
        if (window.FileReader) {
            var fileReader = new FileReader();
            fileReader.onload = fileReader.onerror = callback;
            method = method || 'readAsDataURL';
            if (fileReader[method]) {
                fileReader[method](file);
                return fileReader;
            }
        }
        return false;
    };

    var originalHasCanvasOption = loadImage.hasCanvasOption;
    var originalTransformCoordinates = loadImage.transformCoordinates;
    var originalGetTransformedOptions = loadImage.getTransformedOptions;

    loadImage.hasCanvasOption = function (options) {
        return !!options.orientation || originalHasCanvasOption.call(loadImage, options);
    };

    loadImage.transformCoordinates = function (canvas, options) {
        originalTransformCoordinates.call(loadImage, canvas, options);
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        var styleWidth = canvas.style.width;
        var styleHeight = canvas.style.height;
        var orientation = options.orientation;
        if (!orientation || orientation > 8) {
            return;
        }
        if (orientation > 4) {
            canvas.width = height;
            canvas.height = width;
            canvas.style.width = styleHeight;
            canvas.style.height = styleWidth;
        }
        switch (orientation) {
            case 2:
                ctx.translate(width, 0);
                ctx.scale(-1, 1);
                break;
            case 3:
                ctx.translate(width, height);
                ctx.rotate(Math.PI);
                break;
            case 4:
                ctx.translate(0, height);
                ctx.scale(1, -1);
                break;
            case 5:
                ctx.rotate(0.5 * Math.PI);
                ctx.scale(1, -1);
                break;
            case 6:
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(0, -height);
                break;
            case 7:
                ctx.rotate(0.5 * Math.PI);
                ctx.translate(width, -height);
                ctx.scale(-1, 1);
                break;
            case 8:
                ctx.rotate(-0.5 * Math.PI);
                ctx.translate(-width, 0);
                break;
        }
    };

    loadImage.getTransformedOptions = function (img, opts) {
        var options = originalGetTransformedOptions.call(loadImage, img, opts);
        var orientation = options.orientation;
        var newOptions;
        var i;
        if (!orientation || orientation > 8 || orientation === 1) {
            return options;
        }
        newOptions = {};
        for (i in options) {
            if (options.hasOwnProperty(i)) {
                newOptions[i] = options[i];
            }
        }
        switch (options.orientation) {
            case 2:
                newOptions.left = options.right;
                newOptions.right = options.left;
                break;
            case 3:
                newOptions.left = options.right;
                newOptions.top = options.bottom;
                newOptions.right = options.left;
                newOptions.bottom = options.top;
                break;
            case 4:
                newOptions.top = options.bottom;
                newOptions.bottom = options.top;
                break;
            case 5:
                newOptions.left = options.top;
                newOptions.top = options.left;
                newOptions.right = options.bottom;
                newOptions.bottom = options.right;
                break;
            case 6:
                newOptions.left = options.top;
                newOptions.top = options.right;
                newOptions.right = options.bottom;
                newOptions.bottom = options.left;
                break;
            case 7:
                newOptions.left = options.bottom;
                newOptions.top = options.right;
                newOptions.right = options.top;
                newOptions.bottom = options.left;
                break;
            case 8:
                newOptions.left = options.bottom;
                newOptions.top = options.left;
                newOptions.right = options.top;
                newOptions.bottom = options.right;
                break;
        }
        if (options.orientation > 4) {
            newOptions.maxWidth = options.maxHeight;
            newOptions.maxHeight = options.maxWidth;
            newOptions.minWidth = options.minHeight;
            newOptions.minHeight = options.minWidth;
            newOptions.sourceWidth = options.sourceHeight;
            newOptions.sourceHeight = options.sourceWidth;
        }
        return newOptions;
    };

    var hasblobSlice = window.Blob && (Blob.prototype.slice || Blob.prototype.webkitSlice || Blob.prototype.mozSlice);

    loadImage.blobSlice = hasblobSlice && function () {
        var slice = this.slice || this.webkitSlice || this.mozSlice;
        return slice.apply(this, arguments);
    };

    loadImage.metaDataParsers = {
        jpeg: {
            0xffe1: [] }
    };

    loadImage.parseMetaData = function (file, callback, options) {
        options = options || {};
        var that = this;

        var maxMetaDataSize = options.maxMetaDataSize || 262144;
        var data = {};
        var noMetaData = !(window.DataView && file && file.size >= 12 && file.type === 'image/jpeg' && loadImage.blobSlice);
        if (noMetaData || !loadImage.readFile(loadImage.blobSlice.call(file, 0, maxMetaDataSize), function (e) {
            if (e.target.error) {
                callback(data);
                return;
            }

            var buffer = e.target.result;
            var dataView = new DataView(buffer);
            var offset = 2;
            var maxOffset = dataView.byteLength - 4;
            var headLength = offset;
            var markerBytes;
            var markerLength;
            var parsers;
            var i;

            if (dataView.getUint16(0) === 0xffd8) {
                while (offset < maxOffset) {
                    markerBytes = dataView.getUint16(offset);

                    if (markerBytes >= 0xffe0 && markerBytes <= 0xffef || markerBytes === 0xfffe) {
                        markerLength = dataView.getUint16(offset + 2) + 2;
                        if (offset + markerLength > dataView.byteLength) {
                            break;
                        }
                        parsers = loadImage.metaDataParsers.jpeg[markerBytes];
                        if (parsers) {
                            for (i = 0; i < parsers.length; i += 1) {
                                parsers[i].call(that, dataView, offset, markerLength, data, options);
                            }
                        }
                        offset += markerLength;
                        headLength = offset;
                    } else {
                        break;
                    }
                }

                if (!options.disableImageHead && headLength > 6) {
                    if (buffer.slice) {
                        data.imageHead = buffer.slice(0, headLength);
                    } else {
                        data.imageHead = new Uint8Array(buffer).subarray(0, headLength);
                    }
                }
            } else {}
            callback(data);
        }, 'readAsArrayBuffer')) {
            callback(data);
        }
    };

    loadImage.ExifMap = function () {
        return this;
    };

    loadImage.ExifMap.prototype.map = {
        'Orientation': 0x0112
    };

    loadImage.ExifMap.prototype.get = function (id) {
        return this[id] || this[this.map[id]];
    };

    loadImage.getExifThumbnail = function (dataView, offset, length) {
        var hexData, i, b;
        if (!length || offset + length > dataView.byteLength) {
            return;
        }
        hexData = [];
        for (i = 0; i < length; i += 1) {
            b = dataView.getUint8(offset + i);
            hexData.push((b < 16 ? '0' : '') + b.toString(16));
        }
        return 'data:image/jpeg,%' + hexData.join('%');
    };

    loadImage.exifTagTypes = {
        1: {
            getValue: function getValue(dataView, dataOffset) {
                return dataView.getUint8(dataOffset);
            },
            size: 1
        },

        2: {
            getValue: function getValue(dataView, dataOffset) {
                return String.fromCharCode(dataView.getUint8(dataOffset));
            },
            size: 1,
            ascii: true
        },

        3: {
            getValue: function getValue(dataView, dataOffset, littleEndian) {
                return dataView.getUint16(dataOffset, littleEndian);
            },
            size: 2
        },

        4: {
            getValue: function getValue(dataView, dataOffset, littleEndian) {
                return dataView.getUint32(dataOffset, littleEndian);
            },
            size: 4
        },

        5: {
            getValue: function getValue(dataView, dataOffset, littleEndian) {
                return dataView.getUint32(dataOffset, littleEndian) / dataView.getUint32(dataOffset + 4, littleEndian);
            },
            size: 8
        },

        9: {
            getValue: function getValue(dataView, dataOffset, littleEndian) {
                return dataView.getInt32(dataOffset, littleEndian);
            },
            size: 4
        },

        10: {
            getValue: function getValue(dataView, dataOffset, littleEndian) {
                return dataView.getInt32(dataOffset, littleEndian) / dataView.getInt32(dataOffset + 4, littleEndian);
            },
            size: 8
        }
    };

    loadImage.exifTagTypes[7] = loadImage.exifTagTypes[1];

    loadImage.getExifValue = function (dataView, tiffOffset, offset, type, length, littleEndian) {
        var tagType = loadImage.exifTagTypes[type];
        var tagSize;
        var dataOffset;
        var values;
        var i;
        var str;
        var c;
        if (!tagType) {
            return;
        }
        tagSize = tagType.size * length;

        dataOffset = tagSize > 4 ? tiffOffset + dataView.getUint32(offset + 8, littleEndian) : offset + 8;
        if (dataOffset + tagSize > dataView.byteLength) {
            return;
        }
        if (length === 1) {
            return tagType.getValue(dataView, dataOffset, littleEndian);
        }
        values = [];
        for (i = 0; i < length; i += 1) {
            values[i] = tagType.getValue(dataView, dataOffset + i * tagType.size, littleEndian);
        }
        if (tagType.ascii) {
            str = '';

            for (i = 0; i < values.length; i += 1) {
                c = values[i];

                if (c === '\0') {
                    break;
                }
                str += c;
            }
            return str;
        }
        return values;
    };

    loadImage.parseExifTag = function (dataView, tiffOffset, offset, littleEndian, data) {
        var tag = dataView.getUint16(offset, littleEndian);
        data.exif[tag] = loadImage.getExifValue(dataView, tiffOffset, offset, dataView.getUint16(offset + 2, littleEndian), dataView.getUint32(offset + 4, littleEndian), littleEndian);
    };

    loadImage.parseExifTags = function (dataView, tiffOffset, dirOffset, littleEndian, data) {
        var tagsNumber, dirEndOffset, i;
        if (dirOffset + 6 > dataView.byteLength) {
            return;
        }
        tagsNumber = dataView.getUint16(dirOffset, littleEndian);
        dirEndOffset = dirOffset + 2 + 12 * tagsNumber;
        if (dirEndOffset + 4 > dataView.byteLength) {
            return;
        }
        for (i = 0; i < tagsNumber; i += 1) {
            this.parseExifTag(dataView, tiffOffset, dirOffset + 2 + 12 * i, littleEndian, data);
        }

        return dataView.getUint32(dirEndOffset, littleEndian);
    };

    loadImage.parseExifData = function (dataView, offset, length, data, options) {
        if (options.disableExif) {
            return;
        }
        var tiffOffset = offset + 10;
        var littleEndian;
        var dirOffset;
        var thumbnailData;

        if (dataView.getUint32(offset + 4) !== 0x45786966) {
            return;
        }
        if (tiffOffset + 8 > dataView.byteLength) {
            return;
        }

        if (dataView.getUint16(offset + 8) !== 0x0000) {
            return;
        }

        switch (dataView.getUint16(tiffOffset)) {
            case 0x4949:
                littleEndian = true;
                break;
            case 0x4D4D:
                littleEndian = false;
                break;
            default:
                return;
        }

        if (dataView.getUint16(tiffOffset + 2, littleEndian) !== 0x002A) {
            return;
        }

        dirOffset = dataView.getUint32(tiffOffset + 4, littleEndian);

        data.exif = new loadImage.ExifMap();

        dirOffset = loadImage.parseExifTags(dataView, tiffOffset, tiffOffset + dirOffset, littleEndian, data);
        if (dirOffset && !options.disableExifThumbnail) {
            thumbnailData = { exif: {} };
            dirOffset = loadImage.parseExifTags(dataView, tiffOffset, tiffOffset + dirOffset, littleEndian, thumbnailData);

            if (thumbnailData.exif[0x0201]) {
                data.exif.Thumbnail = loadImage.getExifThumbnail(dataView, tiffOffset + thumbnailData.exif[0x0201], thumbnailData.exif[0x0202]);
            }
        }

        if (data.exif[0x8769] && !options.disableExifSub) {
            loadImage.parseExifTags(dataView, tiffOffset, tiffOffset + data.exif[0x8769], littleEndian, data);
        }

        if (data.exif[0x8825] && !options.disableExifGps) {
            loadImage.parseExifTags(dataView, tiffOffset, tiffOffset + data.exif[0x8825], littleEndian, data);
        }
    };

    loadImage.metaDataParsers.jpeg[0xffe1].push(loadImage.parseExifData);
    var snabbt = function () {

        var tickRequests = [];
        var runningAnimations = [];
        var completedAnimations = [];
        var transformProperty = 'transform';

        var styles = window.getComputedStyle(document.documentElement, '');
        var vendorPrefix = (Array.prototype.slice.call(styles).join('').match(/-(moz|webkit|ms)-/) || styles.OLink === '' && ['', 'o'])[1];
        if (vendorPrefix === 'webkit') transformProperty = 'webkitTransform';

        var snabbt = function snabbt(arg1, arg2, arg3) {

            var elements = arg1;

            if (elements.length !== undefined) {
                var aggregateChainer = {
                    chainers: [],
                    then: function then(opts) {
                        return this.snabbt(opts);
                    },
                    snabbt: function snabbt(opts) {
                        var len = this.chainers.length;
                        this.chainers.forEach(function (chainer, index) {
                            chainer.snabbt(preprocessOptions(opts, index, len));
                        });
                        return aggregateChainer;
                    },
                    setValue: function setValue(value) {
                        this.chainers.forEach(function (chainer) {
                            chainer.setValue(value);
                        });
                        return aggregateChainer;
                    },
                    finish: function finish() {
                        this.chainers.forEach(function (chainer) {
                            chainer.finish();
                        });
                        return aggregateChainer;
                    },
                    rollback: function rollback() {
                        this.chainers.forEach(function (chainer) {
                            chainer.rollback();
                        });
                        return aggregateChainer;
                    }
                };

                for (var i = 0, len = elements.length; i < len; ++i) {
                    if (typeof arg2 == 'string') aggregateChainer.chainers.push(snabbtSingleElement(elements[i], arg2, preprocessOptions(arg3, i, len)));else aggregateChainer.chainers.push(snabbtSingleElement(elements[i], preprocessOptions(arg2, i, len), arg3));
                }
                return aggregateChainer;
            } else {
                if (typeof arg2 == 'string') return snabbtSingleElement(elements, arg2, preprocessOptions(arg3, 0, 1));else return snabbtSingleElement(elements, preprocessOptions(arg2, 0, 1), arg3);
            }
        };

        var preprocessOptions = function preprocessOptions(options, index, len) {
            if (!options) return options;
            var clone = cloneObject(options);

            if (isFunction(options.delay)) {
                clone.delay = options.delay(index, len);
            }

            if (isFunction(options.callback)) {
                clone.complete = function () {
                    options.callback.call(this, index, len);
                };
            }

            var hasAllDoneCallback = isFunction(options.allDone);
            var hasCompleteCallback = isFunction(options.complete);

            if (hasCompleteCallback || hasAllDoneCallback) {
                clone.complete = function () {
                    if (hasCompleteCallback) {
                        options.complete.call(this, index, len);
                    }
                    if (hasAllDoneCallback && index == len - 1) {
                        options.allDone();
                    }
                };
            }

            if (isFunction(options.valueFeeder)) {
                clone.valueFeeder = function (i, matrix) {
                    return options.valueFeeder(i, matrix, index, len);
                };
            }
            if (isFunction(options.easing)) {
                clone.easing = function (i) {
                    return options.easing(i, index, len);
                };
            }

            var properties = ['position', 'rotation', 'skew', 'rotationPost', 'scale', 'width', 'height', 'opacity', 'fromPosition', 'fromRotation', 'fromSkew', 'fromRotationPost', 'fromScale', 'fromWidth', 'fromHeight', 'fromOpacity', 'transformOrigin', 'duration', 'delay'];

            properties.forEach(function (property) {
                if (isFunction(options[property])) {
                    clone[property] = options[property](index, len);
                }
            });

            return clone;
        };

        var snabbtSingleElement = function snabbtSingleElement(element, arg2, arg3) {

            if (arg2 === 'attention') {
                return setupAttentionAnimation(element, arg3);
            }

            if (arg2 === 'stop') {
                return stopAnimation(element);
            }

            if (arg2 === 'detach') {
                return detachChildren(element);
            }

            var options = arg2;

            clearOphanedEndStates();

            var currentState = currentAnimationState(element);
            var start = currentState;

            start = stateFromOptions(options, start, true);
            var end = cloneObject(currentState);
            end = stateFromOptions(options, end);

            var animOptions = setupAnimationOptions(start, end, options);
            var animation = createAnimation(animOptions);

            runningAnimations.push([element, animation]);

            animation.updateElement(element, true);
            var queue = [];
            var chainer = {
                snabbt: function snabbt(opts) {
                    queue.unshift(preprocessOptions(opts, 0, 1));
                    return chainer;
                },
                then: function then(opts) {
                    return this.snabbt(opts);
                }
            };

            function tick(time) {
                animation.tick(time);
                animation.updateElement(element);
                if (animation.isStopped()) return;

                if (!animation.completed()) return queueTick(tick);

                if (options.loop > 1 && !animation.isStopped()) {
                    options.loop -= 1;
                    animation.restart();
                    queueTick(tick);
                } else {
                    if (options.complete) {
                        options.complete.call(element);
                    }

                    if (queue.length) {
                        options = queue.pop();

                        start = stateFromOptions(options, end, true);
                        end = stateFromOptions(options, cloneObject(end));
                        options = setupAnimationOptions(start, end, options);

                        animation = createAnimation(options);
                        runningAnimations.push([element, animation]);

                        animation.tick(time);
                        queueTick(tick);
                    }
                }
            }

            queueTick(tick);

            if (options.manual) return animation;
            return chainer;
        };

        var setupAttentionAnimation = function setupAttentionAnimation(element, options) {
            var movement = stateFromOptions(options, createState({}));
            options.movement = movement;
            var animation = createAttentionAnimation(options);

            runningAnimations.push([element, animation]);
            function tick(time) {
                animation.tick(time);
                animation.updateElement(element);
                if (!animation.completed()) {
                    queueTick(tick);
                } else {
                    if (options.callback) {
                        options.callback(element);
                    }
                    if (options.loop && options.loop > 1) {
                        options.loop--;
                        animation.restart();
                        queueTick(tick);
                    }
                }
            }
            queueTick(tick);
        };

        var stopAnimation = function stopAnimation(element) {
            for (var i = 0, len = runningAnimations.length; i < len; ++i) {
                var currentAnimation = runningAnimations[i];
                var animatedElement = currentAnimation[0];
                var animation = currentAnimation[1];

                if (animatedElement === element) {
                    animation.stop();
                }
            }
        };

        var indexOfElement = function indexOfElement(arr, element) {
            for (var i = 0, len = arr.length; i < len; ++i) {
                if (arr[i][0] === element) {
                    return i;
                }
            }
            return -1;
        };

        var detachChildren = function detachChildren(element) {

            var elements = [];
            var animations = runningAnimations.concat(completedAnimations);
            var el;
            var i;
            var len = animations.length;

            for (i = 0; i < len; ++i) {
                el = animations[i][0];
                if (element.contains(el) || element === el) {
                    elements.push(el);
                }
            }

            len = elements.length;
            for (i = 0; i < len; ++i) {
                detachElement(elements[i]);
            }
        };

        var detachElement = function detachElement(element) {
            stopAnimation(element);

            var index = indexOfElement(runningAnimations, element);
            if (index >= 0) {
                runningAnimations.splice(index, 1);
            }

            index = indexOfElement(completedAnimations, element);
            if (index >= 0) {
                completedAnimations.splice(index, 1);
            }
        };

        var findAnimationState = function findAnimationState(animationList, element) {
            for (var i = 0, len = animationList.length; i < len; ++i) {
                var currentAnimation = animationList[i];
                var animatedElement = currentAnimation[0];
                var animation = currentAnimation[1];

                if (animatedElement === element) {
                    var state = animation.getCurrentState();
                    animation.stop();
                    return state;
                }
            }
        };

        var clearOphanedEndStates = function clearOphanedEndStates() {
            completedAnimations = completedAnimations.filter(function (animation) {
                return findUltimateAncestor(animation[0]).body;
            });
        };

        var findUltimateAncestor = function findUltimateAncestor(node) {
            var ancestor = node;
            while (ancestor.parentNode) {
                ancestor = ancestor.parentNode;
            }
            return ancestor;
        };

        var currentAnimationState = function currentAnimationState(element) {
            var state = findAnimationState(runningAnimations, element);
            if (state) return state;

            return findAnimationState(completedAnimations, element);
        };

        var stateFromOptions = function stateFromOptions(options, state, useFromPrefix) {
            if (!state) {
                state = createState({
                    position: [0, 0, 0],
                    rotation: [0, 0, 0],
                    rotationPost: [0, 0, 0],
                    scale: [1, 1],
                    skew: [0, 0]
                });
            }
            var position = 'position';
            var rotation = 'rotation';
            var skew = 'skew';
            var rotationPost = 'rotationPost';
            var scale = 'scale';
            var scalePost = 'scalePost';
            var width = 'width';
            var height = 'height';
            var opacity = 'opacity';

            if (useFromPrefix) {
                position = 'fromPosition';
                rotation = 'fromRotation';
                skew = 'fromSkew';
                rotationPost = 'fromRotationPost';
                scale = 'fromScale';
                scalePost = 'fromScalePost';
                width = 'fromWidth';
                height = 'fromHeight';
                opacity = 'fromOpacity';
            }

            state.position = optionOrDefault(options[position], state.position);
            state.rotation = optionOrDefault(options[rotation], state.rotation);
            state.rotationPost = optionOrDefault(options[rotationPost], state.rotationPost);
            state.skew = optionOrDefault(options[skew], state.skew);
            state.scale = optionOrDefault(options[scale], state.scale);
            state.scalePost = optionOrDefault(options[scalePost], state.scalePost);
            state.opacity = options[opacity];
            state.width = options[width];
            state.height = options[height];

            return state;
        };

        var setupAnimationOptions = function setupAnimationOptions(start, end, options) {
            options.startState = start;
            options.endState = end;
            return options;
        };

        var polyFillrAF = window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
            return setTimeout(callback, 1000 / 60);
        };

        var queueTick = function queueTick(func) {
            if (tickRequests.length === 0) polyFillrAF(tickAnimations);
            tickRequests.push(func);
        };

        var tickAnimations = function tickAnimations(time) {
            var len = tickRequests.length;
            for (var i = 0; i < len; ++i) {
                tickRequests[i](time);
            }
            tickRequests.splice(0, len);

            var finishedAnimations = runningAnimations.filter(function (animation) {
                return animation[1].completed();
            });

            completedAnimations = completedAnimations.filter(function (animation) {
                for (var i = 0, len = finishedAnimations.length; i < len; ++i) {
                    if (animation[0] === finishedAnimations[i][0]) {
                        return false;
                    }
                }
                return true;
            });

            completedAnimations = completedAnimations.concat(finishedAnimations);

            runningAnimations = runningAnimations.filter(function (animation) {
                return !animation[1].completed();
            });

            if (tickRequests.length !== 0) polyFillrAF(tickAnimations);
        };

        var createAnimation = function createAnimation(options) {
            var startState = options.startState;
            var endState = options.endState;
            var duration = optionOrDefault(options.duration, 500);
            var delay = optionOrDefault(options.delay, 0);
            var perspective = options.perspective;
            var easing = createEaser(optionOrDefault(options.easing, 'linear'), options);
            var currentState = duration === 0 ? endState.clone() : startState.clone();
            var transformOrigin = options.transformOrigin;
            currentState.transformOrigin = options.transformOrigin;

            var startTime = 0;
            var currentTime = 0;
            var stopped = false;
            var started = false;

            var manual = options.manual;
            var manualValue = 0;
            var manualDelayFactor = delay / duration;
            var manualCallback;

            var tweener;

            if (options.valueFeeder) {
                tweener = createValueFeederTweener(options.valueFeeder, startState, endState, currentState);
            } else {
                tweener = createStateTweener(startState, endState, currentState);
            }

            return {
                stop: function stop() {
                    stopped = true;
                },
                isStopped: function isStopped() {
                    return stopped;
                },

                finish: function finish(callback) {
                    manual = false;
                    var manualDuration = duration * manualValue;
                    startTime = currentTime - manualDuration;
                    manualCallback = callback;
                    easing.resetFrom = manualValue;
                },

                rollback: function rollback(callback) {
                    manual = false;
                    tweener.setReverse();
                    var manualDuration = duration * (1 - manualValue);
                    startTime = currentTime - manualDuration;
                    manualCallback = callback;
                    easing.resetFrom = manualValue;
                },

                restart: function restart() {
                    startTime = undefined;
                    easing.resetFrom(0);
                },

                tick: function tick(time) {
                    if (stopped) return;

                    if (manual) {
                        currentTime = time;
                        this.updateCurrentTransform();
                        return;
                    }

                    if (!startTime) {
                        startTime = time;
                    }
                    if (time - startTime > delay) {
                        started = true;
                        currentTime = time - delay;

                        var curr = Math.min(Math.max(0.0, currentTime - startTime), duration);
                        easing.tick(curr / duration);
                        this.updateCurrentTransform();
                        if (this.completed() && manualCallback) {
                            manualCallback();
                        }
                    }
                },

                getCurrentState: function getCurrentState() {
                    return currentState;
                },

                setValue: function setValue(_manualValue) {
                    started = true;
                    manualValue = Math.min(Math.max(_manualValue, 0.0001), 1 + manualDelayFactor);
                },

                updateCurrentTransform: function updateCurrentTransform() {
                    var tweenValue = easing.getValue();
                    if (manual) {
                        var val = Math.max(0.00001, manualValue - manualDelayFactor);
                        easing.tick(val);
                        tweenValue = easing.getValue();
                    }
                    tweener.tween(tweenValue);
                },

                completed: function completed() {
                    if (stopped) return true;
                    if (startTime === 0) {
                        return false;
                    }
                    return easing.completed();
                },

                updateElement: function updateElement(element, forceUpdate) {
                    if (!started && !forceUpdate) return;
                    var matrix = tweener.asMatrix();
                    var properties = tweener.getProperties();
                    updateElementTransform(element, matrix, perspective);
                    updateElementProperties(element, properties);
                }
            };
        };

        var createAttentionAnimation = function createAttentionAnimation(options) {
            var movement = options.movement;
            options.initialVelocity = 0.1;
            options.equilibriumPosition = 0;
            var spring = createSpringEasing(options);
            var stopped = false;
            var tweenPosition = movement.position;
            var tweenRotation = movement.rotation;
            var tweenRotationPost = movement.rotationPost;
            var tweenScale = movement.scale;
            var tweenSkew = movement.skew;

            var currentMovement = createState({
                position: tweenPosition ? [0, 0, 0] : undefined,
                rotation: tweenRotation ? [0, 0, 0] : undefined,
                rotationPost: tweenRotationPost ? [0, 0, 0] : undefined,
                scale: tweenScale ? [0, 0] : undefined,
                skew: tweenSkew ? [0, 0] : undefined
            });

            return {
                stop: function stop() {
                    stopped = true;
                },

                isStopped: function isStopped(time) {
                    return stopped;
                },

                tick: function tick(time) {
                    if (stopped) return;
                    if (spring.equilibrium) return;
                    spring.tick();

                    this.updateMovement();
                },

                updateMovement: function updateMovement() {
                    var value = spring.getValue();
                    if (tweenPosition) {
                        currentMovement.position[0] = movement.position[0] * value;
                        currentMovement.position[1] = movement.position[1] * value;
                        currentMovement.position[2] = movement.position[2] * value;
                    }
                    if (tweenRotation) {
                        currentMovement.rotation[0] = movement.rotation[0] * value;
                        currentMovement.rotation[1] = movement.rotation[1] * value;
                        currentMovement.rotation[2] = movement.rotation[2] * value;
                    }
                    if (tweenRotationPost) {
                        currentMovement.rotationPost[0] = movement.rotationPost[0] * value;
                        currentMovement.rotationPost[1] = movement.rotationPost[1] * value;
                        currentMovement.rotationPost[2] = movement.rotationPost[2] * value;
                    }
                    if (tweenScale) {
                        currentMovement.scale[0] = 1 + movement.scale[0] * value;
                        currentMovement.scale[1] = 1 + movement.scale[1] * value;
                    }

                    if (tweenSkew) {
                        currentMovement.skew[0] = movement.skew[0] * value;
                        currentMovement.skew[1] = movement.skew[1] * value;
                    }
                },

                updateElement: function updateElement(element) {
                    updateElementTransform(element, currentMovement.asMatrix());
                    updateElementProperties(element, currentMovement.getProperties());
                },

                getCurrentState: function getCurrentState() {
                    return currentMovement;
                },

                completed: function completed() {
                    return spring.equilibrium || stopped;
                },

                restart: function restart() {
                    spring = createSpringEasing(options);
                }
            };
        };

        var linearEasing = function linearEasing(value) {
            return value;
        };

        var ease = function ease(value) {
            return (Math.cos(value * Math.PI + Math.PI) + 1) / 2;
        };

        var easeIn = function easeIn(value) {
            return value * value;
        };

        var easeOut = function easeOut(value) {
            return -Math.pow(value - 1, 2) + 1;
        };

        var createSpringEasing = function createSpringEasing(options) {
            var position = optionOrDefault(options.startPosition, 0);
            var equilibriumPosition = optionOrDefault(options.equilibriumPosition, 1);
            var velocity = optionOrDefault(options.initialVelocity, 0);
            var springConstant = optionOrDefault(options.springConstant, 0.8);
            var deceleration = optionOrDefault(options.springDeceleration, 0.9);
            var mass = optionOrDefault(options.springMass, 10);

            var equilibrium = false;

            return {

                tick: function tick(value) {
                    if (value === 0.0) return;
                    if (equilibrium) return;
                    var springForce = -(position - equilibriumPosition) * springConstant;

                    var a = springForce / mass;

                    velocity += a;
                    position += velocity;

                    velocity *= deceleration;

                    if (Math.abs(position - equilibriumPosition) < 0.001 && Math.abs(velocity) < 0.001) {
                        equilibrium = true;
                    }
                },

                resetFrom: function resetFrom(value) {
                    position = value;
                    velocity = 0;
                },

                getValue: function getValue() {
                    if (equilibrium) return equilibriumPosition;
                    return position;
                },

                completed: function completed() {
                    return equilibrium;
                }
            };
        };

        var EASING_FUNCS = {
            'linear': linearEasing,
            'ease': ease,
            'easeIn': easeIn,
            'easeOut': easeOut
        };

        var createEaser = function createEaser(easerName, options) {
            if (easerName == 'spring') {
                return createSpringEasing(options);
            }
            var easeFunction = easerName;
            if (!isFunction(easerName)) {
                easeFunction = EASING_FUNCS[easerName];
            }

            var easer = easeFunction;
            var value = 0;
            var lastValue;

            return {
                tick: function tick(v) {
                    value = easer(v);
                    lastValue = v;
                },

                resetFrom: function resetFrom(value) {
                    lastValue = 0;
                },

                getValue: function getValue() {
                    return value;
                },

                completed: function completed() {
                    if (lastValue >= 1) {
                        return lastValue;
                    }
                    return false;
                }
            };
        };

        var assignTranslate = function assignTranslate(matrix, x, y, z) {
            matrix[0] = 1;
            matrix[1] = 0;
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = 0;
            matrix[5] = 1;
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = 0;
            matrix[10] = 1;
            matrix[11] = 0;
            matrix[12] = x;
            matrix[13] = y;
            matrix[14] = z;
            matrix[15] = 1;
        };

        var assignRotateX = function assignRotateX(matrix, rad) {
            matrix[0] = 1;
            matrix[1] = 0;
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = 0;
            matrix[5] = Math.cos(rad);
            matrix[6] = -Math.sin(rad);
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = Math.sin(rad);
            matrix[10] = Math.cos(rad);
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var assignRotateY = function assignRotateY(matrix, rad) {
            matrix[0] = Math.cos(rad);
            matrix[1] = 0;
            matrix[2] = Math.sin(rad);
            matrix[3] = 0;
            matrix[4] = 0;
            matrix[5] = 1;
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = -Math.sin(rad);
            matrix[9] = 0;
            matrix[10] = Math.cos(rad);
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var assignRotateZ = function assignRotateZ(matrix, rad) {
            matrix[0] = Math.cos(rad);
            matrix[1] = -Math.sin(rad);
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = Math.sin(rad);
            matrix[5] = Math.cos(rad);
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = 0;
            matrix[10] = 1;
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var assignSkew = function assignSkew(matrix, ax, ay) {
            matrix[0] = 1;
            matrix[1] = Math.tan(ax);
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = Math.tan(ay);
            matrix[5] = 1;
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = 0;
            matrix[10] = 1;
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var assignScale = function assignScale(matrix, x, y) {
            matrix[0] = x;
            matrix[1] = 0;
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = 0;
            matrix[5] = y;
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = 0;
            matrix[10] = 1;
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var assignIdentity = function assignIdentity(matrix) {
            matrix[0] = 1;
            matrix[1] = 0;
            matrix[2] = 0;
            matrix[3] = 0;
            matrix[4] = 0;
            matrix[5] = 1;
            matrix[6] = 0;
            matrix[7] = 0;
            matrix[8] = 0;
            matrix[9] = 0;
            matrix[10] = 1;
            matrix[11] = 0;
            matrix[12] = 0;
            matrix[13] = 0;
            matrix[14] = 0;
            matrix[15] = 1;
        };

        var copyArray = function copyArray(a, b) {
            b[0] = a[0];
            b[1] = a[1];
            b[2] = a[2];
            b[3] = a[3];
            b[4] = a[4];
            b[5] = a[5];
            b[6] = a[6];
            b[7] = a[7];
            b[8] = a[8];
            b[9] = a[9];
            b[10] = a[10];
            b[11] = a[11];
            b[12] = a[12];
            b[13] = a[13];
            b[14] = a[14];
            b[15] = a[15];
        };

        var createMatrix = function createMatrix() {
            var data = new Float32Array(16);
            var a = new Float32Array(16);
            var b = new Float32Array(16);
            assignIdentity(data);

            return {
                data: data,

                asCSS: function asCSS() {
                    var css = 'matrix3d(';
                    for (var i = 0; i < 15; ++i) {
                        if (Math.abs(data[i]) < 0.0001) css += '0,';else css += data[i].toFixed(10) + ',';
                    }
                    if (Math.abs(data[15]) < 0.0001) css += '0)';else css += data[15].toFixed(10) + ')';
                    return css;
                },

                clear: function clear() {
                    assignIdentity(data);
                },

                translate: function translate(x, y, z) {
                    copyArray(data, a);
                    assignTranslate(b, x, y, z);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                },

                rotateX: function rotateX(radians) {
                    copyArray(data, a);
                    assignRotateX(b, radians);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                },

                rotateY: function rotateY(radians) {
                    copyArray(data, a);
                    assignRotateY(b, radians);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                },

                rotateZ: function rotateZ(radians) {
                    copyArray(data, a);
                    assignRotateZ(b, radians);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                },

                scale: function scale(x, y) {
                    copyArray(data, a);
                    assignScale(b, x, y);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                },

                skew: function skew(ax, ay) {
                    copyArray(data, a);
                    assignSkew(b, ax, ay);
                    assignedMatrixMultiplication(a, b, data);
                    return this;
                }
            };
        };

        var assignedMatrixMultiplication = function assignedMatrixMultiplication(a, b, res) {
            res[0] = a[0] * b[0] + a[1] * b[4] + a[2] * b[8] + a[3] * b[12];
            res[1] = a[0] * b[1] + a[1] * b[5] + a[2] * b[9] + a[3] * b[13];
            res[2] = a[0] * b[2] + a[1] * b[6] + a[2] * b[10] + a[3] * b[14];
            res[3] = a[0] * b[3] + a[1] * b[7] + a[2] * b[11] + a[3] * b[15];

            res[4] = a[4] * b[0] + a[5] * b[4] + a[6] * b[8] + a[7] * b[12];
            res[5] = a[4] * b[1] + a[5] * b[5] + a[6] * b[9] + a[7] * b[13];
            res[6] = a[4] * b[2] + a[5] * b[6] + a[6] * b[10] + a[7] * b[14];
            res[7] = a[4] * b[3] + a[5] * b[7] + a[6] * b[11] + a[7] * b[15];

            res[8] = a[8] * b[0] + a[9] * b[4] + a[10] * b[8] + a[11] * b[12];
            res[9] = a[8] * b[1] + a[9] * b[5] + a[10] * b[9] + a[11] * b[13];
            res[10] = a[8] * b[2] + a[9] * b[6] + a[10] * b[10] + a[11] * b[14];
            res[11] = a[8] * b[3] + a[9] * b[7] + a[10] * b[11] + a[11] * b[15];

            res[12] = a[12] * b[0] + a[13] * b[4] + a[14] * b[8] + a[15] * b[12];
            res[13] = a[12] * b[1] + a[13] * b[5] + a[14] * b[9] + a[15] * b[13];
            res[14] = a[12] * b[2] + a[13] * b[6] + a[14] * b[10] + a[15] * b[14];
            res[15] = a[12] * b[3] + a[13] * b[7] + a[14] * b[11] + a[15] * b[15];

            return res;
        };

        var createState = function createState(config) {
            var matrix = createMatrix();
            var properties = {
                opacity: undefined,
                width: undefined,
                height: undefined
            };

            return {
                position: config.position,
                rotation: config.rotation,
                rotationPost: config.rotationPost,
                skew: config.skew,
                scale: config.scale,
                scalePost: config.scalePost,
                opacity: config.opacity,
                width: config.width,
                height: config.height,

                clone: function clone() {
                    return createState({
                        position: this.position ? this.position.slice(0) : undefined,
                        rotation: this.rotation ? this.rotation.slice(0) : undefined,
                        rotationPost: this.rotationPost ? this.rotationPost.slice(0) : undefined,
                        skew: this.skew ? this.skew.slice(0) : undefined,
                        scale: this.scale ? this.scale.slice(0) : undefined,
                        scalePost: this.scalePost ? this.scalePost.slice(0) : undefined,
                        height: this.height,
                        width: this.width,
                        opacity: this.opacity
                    });
                },

                asMatrix: function asMatrix() {
                    var m = matrix;
                    m.clear();

                    if (this.transformOrigin) m.translate(-this.transformOrigin[0], -this.transformOrigin[1], -this.transformOrigin[2]);

                    if (this.scale) {
                        m.scale(this.scale[0], this.scale[1]);
                    }

                    if (this.skew) {
                        m.skew(this.skew[0], this.skew[1]);
                    }

                    if (this.rotation) {
                        m.rotateX(this.rotation[0]);
                        m.rotateY(this.rotation[1]);
                        m.rotateZ(this.rotation[2]);
                    }

                    if (this.position) {
                        m.translate(this.position[0], this.position[1], this.position[2]);
                    }

                    if (this.rotationPost) {
                        m.rotateX(this.rotationPost[0]);
                        m.rotateY(this.rotationPost[1]);
                        m.rotateZ(this.rotationPost[2]);
                    }

                    if (this.scalePost) {
                        m.scale(this.scalePost[0], this.scalePost[1]);
                    }

                    if (this.transformOrigin) m.translate(this.transformOrigin[0], this.transformOrigin[1], this.transformOrigin[2]);
                    return m;
                },

                getProperties: function getProperties() {
                    properties.opacity = this.opacity;
                    properties.width = this.width + 'px';
                    properties.height = this.height + 'px';
                    return properties;
                }
            };
        };


        var createStateTweener = function createStateTweener(startState, endState, resultState) {
            var start = startState;
            var end = endState;
            var result = resultState;

            var tweenPosition = end.position !== undefined;
            var tweenRotation = end.rotation !== undefined;
            var tweenRotationPost = end.rotationPost !== undefined;
            var tweenScale = end.scale !== undefined;
            var tweenSkew = end.skew !== undefined;
            var tweenWidth = end.width !== undefined;
            var tweenHeight = end.height !== undefined;
            var tweenOpacity = end.opacity !== undefined;

            return {

                tween: function tween(tweenValue) {

                    if (tweenPosition) {
                        var dX = end.position[0] - start.position[0];
                        var dY = end.position[1] - start.position[1];
                        var dZ = end.position[2] - start.position[2];
                        result.position[0] = start.position[0] + tweenValue * dX;
                        result.position[1] = start.position[1] + tweenValue * dY;
                        result.position[2] = start.position[2] + tweenValue * dZ;
                    }

                    if (tweenRotation) {
                        var dAX = end.rotation[0] - start.rotation[0];
                        var dAY = end.rotation[1] - start.rotation[1];
                        var dAZ = end.rotation[2] - start.rotation[2];
                        result.rotation[0] = start.rotation[0] + tweenValue * dAX;
                        result.rotation[1] = start.rotation[1] + tweenValue * dAY;
                        result.rotation[2] = start.rotation[2] + tweenValue * dAZ;
                    }

                    if (tweenRotationPost) {
                        var dBX = end.rotationPost[0] - start.rotationPost[0];
                        var dBY = end.rotationPost[1] - start.rotationPost[1];
                        var dBZ = end.rotationPost[2] - start.rotationPost[2];
                        result.rotationPost[0] = start.rotationPost[0] + tweenValue * dBX;
                        result.rotationPost[1] = start.rotationPost[1] + tweenValue * dBY;
                        result.rotationPost[2] = start.rotationPost[2] + tweenValue * dBZ;
                    }

                    if (tweenSkew) {
                        var dSX = end.scale[0] - start.scale[0];
                        var dSY = end.scale[1] - start.scale[1];

                        result.scale[0] = start.scale[0] + tweenValue * dSX;
                        result.scale[1] = start.scale[1] + tweenValue * dSY;
                    }

                    if (tweenScale) {
                        var dSkewX = end.skew[0] - start.skew[0];
                        var dSkewY = end.skew[1] - start.skew[1];

                        result.skew[0] = start.skew[0] + tweenValue * dSkewX;
                        result.skew[1] = start.skew[1] + tweenValue * dSkewY;
                    }

                    if (tweenWidth) {
                        var dWidth = end.width - start.width;
                        result.width = start.width + tweenValue * dWidth;
                    }

                    if (tweenHeight) {
                        var dHeight = end.height - start.height;
                        result.height = start.height + tweenValue * dHeight;
                    }

                    if (tweenOpacity) {
                        var dOpacity = end.opacity - start.opacity;
                        result.opacity = start.opacity + tweenValue * dOpacity;
                    }
                },

                asMatrix: function asMatrix() {
                    return result.asMatrix();
                },

                getProperties: function getProperties() {
                    return result.getProperties();
                },

                setReverse: function setReverse() {
                    var oldStart = start;
                    start = end;
                    end = oldStart;
                }
            };
        };

        var createValueFeederTweener = function createValueFeederTweener(valueFeeder, startState, endState, resultState) {
            var currentMatrix = valueFeeder(0, createMatrix());
            var start = startState;
            var end = endState;
            var result = resultState;
            var reverse = false;

            return {

                tween: function tween(tweenValue) {
                    if (reverse) tweenValue = 1 - tweenValue;
                    currentMatrix.clear();
                    currentMatrix = valueFeeder(tweenValue, currentMatrix);

                    var dWidth = end.width - start.width;
                    var dHeight = end.height - start.height;
                    var dOpacity = end.opacity - start.opacity;

                    if (end.width !== undefined) result.width = start.width + tweenValue * dWidth;
                    if (end.height !== undefined) result.height = start.height + tweenValue * dHeight;
                    if (end.opacity !== undefined) result.opacity = start.opacity + tweenValue * dOpacity;
                },

                asMatrix: function asMatrix() {
                    return currentMatrix;
                },

                getProperties: function getProperties() {
                    return result.getProperties();
                },

                setReverse: function setReverse() {
                    reverse = true;
                }

            };
        };

        var optionOrDefault = function optionOrDefault(option, def) {
            if (typeof option == 'undefined') {
                return def;
            }
            return option;
        };

        var updateElementTransform = function updateElementTransform(element, matrix, perspective) {
            var cssPerspective = '';
            if (perspective) {
                cssPerspective = 'perspective(' + perspective + 'px) ';
            }
            var cssMatrix = matrix.asCSS();
            element.style[transformProperty] = cssPerspective + cssMatrix;
        };

        var updateElementProperties = function updateElementProperties(element, properties) {
            for (var key in properties) {
                element.style[key] = properties[key];
            }
        };

        var isFunction = function isFunction(object) {
            return typeof object === "function";
        };

        var cloneObject = function cloneObject(object) {
            if (!object) return object;
            var clone = {};
            for (var key in object) {
                clone[key] = object[key];
            }
            return clone;
        };

        snabbt.createMatrix = createMatrix;
        snabbt.setElementTransform = updateElementTransform;
        return snabbt;
    }();
    var stackBlur = function () {

        var mul_table = [512, 512, 456, 512, 328, 456, 335, 512, 405, 328, 271, 456, 388, 335, 292, 512, 454, 405, 364, 328, 298, 271, 496, 456, 420, 388, 360, 335, 312, 292, 273, 512, 482, 454, 428, 405, 383, 364, 345, 328, 312, 298, 284, 271, 259, 496, 475, 456, 437, 420, 404, 388, 374, 360, 347, 335, 323, 312, 302, 292, 282, 273, 265, 512, 497, 482, 468, 454, 441, 428, 417, 405, 394, 383, 373, 364, 354, 345, 337, 328, 320, 312, 305, 298, 291, 284, 278, 271, 265, 259, 507, 496, 485, 475, 465, 456, 446, 437, 428, 420, 412, 404, 396, 388, 381, 374, 367, 360, 354, 347, 341, 335, 329, 323, 318, 312, 307, 302, 297, 292, 287, 282, 278, 273, 269, 265, 261, 512, 505, 497, 489, 482, 475, 468, 461, 454, 447, 441, 435, 428, 422, 417, 411, 405, 399, 394, 389, 383, 378, 373, 368, 364, 359, 354, 350, 345, 341, 337, 332, 328, 324, 320, 316, 312, 309, 305, 301, 298, 294, 291, 287, 284, 281, 278, 274, 271, 268, 265, 262, 259, 257, 507, 501, 496, 491, 485, 480, 475, 470, 465, 460, 456, 451, 446, 442, 437, 433, 428, 424, 420, 416, 412, 408, 404, 400, 396, 392, 388, 385, 381, 377, 374, 370, 367, 363, 360, 357, 354, 350, 347, 344, 341, 338, 335, 332, 329, 326, 323, 320, 318, 315, 312, 310, 307, 304, 302, 299, 297, 294, 292, 289, 287, 285, 282, 280, 278, 275, 273, 271, 269, 267, 265, 263, 261, 259];

        var shg_table = [9, 11, 12, 13, 13, 14, 14, 15, 15, 15, 15, 16, 16, 16, 16, 17, 17, 17, 17, 17, 17, 17, 18, 18, 18, 18, 18, 18, 18, 18, 18, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 19, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 21, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 22, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 23, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24, 24];

        function getImageDataFromCanvas(canvas, top_x, top_y, width, height) {
            if (typeof canvas == 'string') canvas = document.getElementById(canvas);else if (!canvas instanceof HTMLCanvasElement) return;

            var context = canvas.getContext('2d');
            var imageData;

            try {
                try {
                    imageData = context.getImageData(top_x, top_y, width, height);
                } catch (e) {
                    throw new Error("unable to access local image data: " + e);
                    return;
                }
            } catch (e) {
                throw new Error("unable to access image data: " + e);
            }

            return imageData;
        }

        function processCanvasRGBA(canvas, top_x, top_y, width, height, radius) {
            if (isNaN(radius) || radius < 1) return;
            radius |= 0;

            var imageData = getImageDataFromCanvas(canvas, top_x, top_y, width, height);

            imageData = processImageDataRGBA(imageData, top_x, top_y, width, height, radius);

            canvas.getContext('2d').putImageData(imageData, top_x, top_y);
        }

        function processImageDataRGBA(imageData, top_x, top_y, width, height, radius) {
            var pixels = imageData.data;

            var x, y, i, p, yp, yi, yw, r_sum, g_sum, b_sum, a_sum, r_out_sum, g_out_sum, b_out_sum, a_out_sum, r_in_sum, g_in_sum, b_in_sum, a_in_sum, pr, pg, pb, pa, rbs;

            var div = radius + radius + 1;
            var w4 = width << 2;
            var widthMinus1 = width - 1;
            var heightMinus1 = height - 1;
            var radiusPlus1 = radius + 1;
            var sumFactor = radiusPlus1 * (radiusPlus1 + 1) / 2;

            var stackStart = new BlurStack();
            var stack = stackStart;
            for (i = 1; i < div; i++) {
                stack = stack.next = new BlurStack();
                if (i == radiusPlus1) var stackEnd = stack;
            }
            stack.next = stackStart;
            var stackIn = null;
            var stackOut = null;

            yw = yi = 0;

            var mul_sum = mul_table[radius];
            var shg_sum = shg_table[radius];

            for (y = 0; y < height; y++) {
                r_in_sum = g_in_sum = b_in_sum = a_in_sum = r_sum = g_sum = b_sum = a_sum = 0;

                r_out_sum = radiusPlus1 * (pr = pixels[yi]);
                g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
                b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
                a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

                r_sum += sumFactor * pr;
                g_sum += sumFactor * pg;
                b_sum += sumFactor * pb;
                a_sum += sumFactor * pa;

                stack = stackStart;

                for (i = 0; i < radiusPlus1; i++) {
                    stack.r = pr;
                    stack.g = pg;
                    stack.b = pb;
                    stack.a = pa;
                    stack = stack.next;
                }

                for (i = 1; i < radiusPlus1; i++) {
                    p = yi + ((widthMinus1 < i ? widthMinus1 : i) << 2);
                    r_sum += (stack.r = pr = pixels[p]) * (rbs = radiusPlus1 - i);
                    g_sum += (stack.g = pg = pixels[p + 1]) * rbs;
                    b_sum += (stack.b = pb = pixels[p + 2]) * rbs;
                    a_sum += (stack.a = pa = pixels[p + 3]) * rbs;

                    r_in_sum += pr;
                    g_in_sum += pg;
                    b_in_sum += pb;
                    a_in_sum += pa;

                    stack = stack.next;
                }

                stackIn = stackStart;
                stackOut = stackEnd;
                for (x = 0; x < width; x++) {
                    pixels[yi + 3] = pa = a_sum * mul_sum >> shg_sum;
                    if (pa != 0) {
                        pa = 255 / pa;
                        pixels[yi] = (r_sum * mul_sum >> shg_sum) * pa;
                        pixels[yi + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                        pixels[yi + 2] = (b_sum * mul_sum >> shg_sum) * pa;
                    } else {
                        pixels[yi] = pixels[yi + 1] = pixels[yi + 2] = 0;
                    }

                    r_sum -= r_out_sum;
                    g_sum -= g_out_sum;
                    b_sum -= b_out_sum;
                    a_sum -= a_out_sum;

                    r_out_sum -= stackIn.r;
                    g_out_sum -= stackIn.g;
                    b_out_sum -= stackIn.b;
                    a_out_sum -= stackIn.a;

                    p = yw + ((p = x + radius + 1) < widthMinus1 ? p : widthMinus1) << 2;

                    r_in_sum += stackIn.r = pixels[p];
                    g_in_sum += stackIn.g = pixels[p + 1];
                    b_in_sum += stackIn.b = pixels[p + 2];
                    a_in_sum += stackIn.a = pixels[p + 3];

                    r_sum += r_in_sum;
                    g_sum += g_in_sum;
                    b_sum += b_in_sum;
                    a_sum += a_in_sum;

                    stackIn = stackIn.next;

                    r_out_sum += pr = stackOut.r;
                    g_out_sum += pg = stackOut.g;
                    b_out_sum += pb = stackOut.b;
                    a_out_sum += pa = stackOut.a;

                    r_in_sum -= pr;
                    g_in_sum -= pg;
                    b_in_sum -= pb;
                    a_in_sum -= pa;

                    stackOut = stackOut.next;

                    yi += 4;
                }
                yw += width;
            }

            for (x = 0; x < width; x++) {
                g_in_sum = b_in_sum = a_in_sum = r_in_sum = g_sum = b_sum = a_sum = r_sum = 0;

                yi = x << 2;
                r_out_sum = radiusPlus1 * (pr = pixels[yi]);
                g_out_sum = radiusPlus1 * (pg = pixels[yi + 1]);
                b_out_sum = radiusPlus1 * (pb = pixels[yi + 2]);
                a_out_sum = radiusPlus1 * (pa = pixels[yi + 3]);

                r_sum += sumFactor * pr;
                g_sum += sumFactor * pg;
                b_sum += sumFactor * pb;
                a_sum += sumFactor * pa;

                stack = stackStart;

                for (i = 0; i < radiusPlus1; i++) {
                    stack.r = pr;
                    stack.g = pg;
                    stack.b = pb;
                    stack.a = pa;
                    stack = stack.next;
                }

                yp = width;

                for (i = 1; i <= radius; i++) {
                    yi = yp + x << 2;

                    r_sum += (stack.r = pr = pixels[yi]) * (rbs = radiusPlus1 - i);
                    g_sum += (stack.g = pg = pixels[yi + 1]) * rbs;
                    b_sum += (stack.b = pb = pixels[yi + 2]) * rbs;
                    a_sum += (stack.a = pa = pixels[yi + 3]) * rbs;

                    r_in_sum += pr;
                    g_in_sum += pg;
                    b_in_sum += pb;
                    a_in_sum += pa;

                    stack = stack.next;

                    if (i < heightMinus1) {
                        yp += width;
                    }
                }

                yi = x;
                stackIn = stackStart;
                stackOut = stackEnd;
                for (y = 0; y < height; y++) {
                    p = yi << 2;
                    pixels[p + 3] = pa = a_sum * mul_sum >> shg_sum;
                    if (pa > 0) {
                        pa = 255 / pa;
                        pixels[p] = (r_sum * mul_sum >> shg_sum) * pa;
                        pixels[p + 1] = (g_sum * mul_sum >> shg_sum) * pa;
                        pixels[p + 2] = (b_sum * mul_sum >> shg_sum) * pa;
                    } else {
                        pixels[p] = pixels[p + 1] = pixels[p + 2] = 0;
                    }

                    r_sum -= r_out_sum;
                    g_sum -= g_out_sum;
                    b_sum -= b_out_sum;
                    a_sum -= a_out_sum;

                    r_out_sum -= stackIn.r;
                    g_out_sum -= stackIn.g;
                    b_out_sum -= stackIn.b;
                    a_out_sum -= stackIn.a;

                    p = x + ((p = y + radiusPlus1) < heightMinus1 ? p : heightMinus1) * width << 2;

                    r_sum += r_in_sum += stackIn.r = pixels[p];
                    g_sum += g_in_sum += stackIn.g = pixels[p + 1];
                    b_sum += b_in_sum += stackIn.b = pixels[p + 2];
                    a_sum += a_in_sum += stackIn.a = pixels[p + 3];

                    stackIn = stackIn.next;

                    r_out_sum += pr = stackOut.r;
                    g_out_sum += pg = stackOut.g;
                    b_out_sum += pb = stackOut.b;
                    a_out_sum += pa = stackOut.a;

                    r_in_sum -= pr;
                    g_in_sum -= pg;
                    b_in_sum -= pb;
                    a_in_sum -= pa;

                    stackOut = stackOut.next;

                    yi += width;
                }
            }
            return imageData;
        }

        function BlurStack() {
            this.r = 0;
            this.g = 0;
            this.b = 0;
            this.a = 0;
            this.next = null;
        }

        return processCanvasRGBA;
    }();

    if (!HTMLCanvasElement.prototype.toBlob) {
        Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
            value: function value(callback, type, quality) {

                var binStr = atob(this.toDataURL(type, quality).split(',')[1]),
                    len = binStr.length,
                    arr = new Uint8Array(len);

                for (var i = 0; i < len; i++) {
                    arr[i] = binStr.charCodeAt(i);
                }

                callback(new Blob([arr], { type: type || 'image/png' }));
            }
        });
    }
    'use strict';

    var _createClass = function () {
        function defineProperties(target, props) {
            for (var i = 0; i < props.length; i++) {
                var descriptor = props[i];descriptor.enumerable = descriptor.enumerable || false;descriptor.configurable = true;if ("value" in descriptor) descriptor.writable = true;__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_define_property___default()(target, descriptor.key, descriptor);
            }
        }return function (Constructor, protoProps, staticProps) {
            if (protoProps) defineProperties(Constructor.prototype, protoProps);if (staticProps) defineProperties(Constructor, staticProps);return Constructor;
        };
    }();

    var _arguments = arguments;

    var _typeof = typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_symbol_iterator___default.a) === "symbol" ? function (obj) {
        return typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj);
    } : function (obj) {
        return obj && typeof __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a === "function" && obj.constructor === __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a && obj !== __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_symbol___default.a.prototype ? "symbol" : typeof obj === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_typeof___default()(obj);
    };

    function _classCallCheck(instance, Constructor) {
        if (!(instance instanceof Constructor)) {
            throw new TypeError("Cannot call a class as a function");
        }
    }

    var lowMemory = null;
    var isLowMemoryDevice = function isLowMemoryDevice() {
        if (lowMemory === null) {
            lowMemory = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
        }
        return lowMemory;
    };

    var releaseCanvas = function releaseCanvas(canvas) {
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext('2d');
        ctx.fillRect(0, 0, 1, 1);
    };

    var copyString = function copyString(str) {
        return str + '';
    };

    var getDataset = function getDataset(el) {
        if (typeof el.dataset === 'undefined') {
            var res = {};
            var attr;
            var attrName;
            var attrs = el.attributes;
            for (attr in attrs) {
                if (attrs.hasOwnProperty(attr) && attrs[attr].name && /^data-[a-z_\-\d]*$/i.test(attrs[attr].name)) {
                    attrName = toCamelCase(attrs[attr].name.substr(5));
                    res[attrName] = attrs[attr].value;
                }
            }
            return res;
        }
        return el.dataset;
    };

    var toCamelCase = function toCamelCase(str) {
        return str.replace(/\-./g, function (substr) {
            return substr.charAt(1).toUpperCase();
        });
    };

    var getElementAttributes = function getElementAttributes(el) {
        var result = [];
        var attributes = Array.prototype.slice.call(el.attributes);
        var l = attributes.length;
        for (var i = 0; i < l; i++) {
            result.push({
                name: attributes[i].name,
                value: attributes[i].value
            });
        }
        return result;
    };

    var getOffsetByEvent = function getOffsetByEvent(e) {
        return {
            x: typeof e.offsetX === 'undefined' ? e.layerX : e.offsetX,
            y: typeof e.offsetY === 'undefined' ? e.layerY : e.offsetY
        };
    };

    var mergeOptions = function mergeOptions(base, additives) {
        var key;
        var options = {};
        var optionsToMerge = additives || {};

        for (key in base) {
            if (!base.hasOwnProperty(key)) {
                continue;
            }
            options[key] = typeof optionsToMerge[key] === 'undefined' ? base[key] : optionsToMerge[key];
        }

        return options;
    };

    var Key = {
        ESC: 27,
        RETURN: 13
    };

    var Events = {
        DOWN: ['touchstart', 'pointerdown', 'mousedown'],
        MOVE: ['touchmove', 'pointermove', 'mousemove'],
        UP: ['touchend', 'touchcancel', 'pointerup', 'mouseup']
    };

    var MimeTypes = {
        jpeg: 'image/jpeg',
        jpg: 'image/jpeg',
        jpe: 'image/jpeg',
        png: 'image/png',
        gif: 'image/gif',
        bmp: 'image/bmp'
    };

    var ImageExtensionsRegex = /(\.png|\.bmp|\.gif|\.jpg|\.jpe|\.jpg|\.jpeg)$/;

    var CanvasExportExtensions = /(jpe|jpg|jpeg|png)/;

    var create = function create(name, className) {
        var node = document.createElement(name);
        if (className) {
            node.className = className;
        }
        return node;
    };

    var addEvents = function addEvents(obj, events, scope) {
        events.forEach(function (event) {
            obj.addEventListener(event, scope, false);
        });
    };

    var removeEvents = function removeEvents(obj, events, scope) {
        events.forEach(function (event) {
            obj.removeEventListener(event, scope, false);
        });
    };

    var getEventOffset = function getEventOffset(e) {
        var event = e.changedTouches ? e.changedTouches[0] : e;

        if (!event) {
            return;
        }

        return {
            x: event.pageX,
            y: event.pageY
        };
    };

    var rotate = function rotate(rect, angle) {
        var cx = 0.5;
        var cy = 0.5;

        var radians = Math.PI / 180 * angle;
        var cos = Math.cos(radians);
        var sin = Math.sin(radians);

        var x1 = rect.x;
        var y1 = rect.y;
        var x2 = rect.x + rect.width;
        var y2 = rect.y + rect.height;

        var rx1 = cos * (x1 - cx) + sin * (y1 - cy) + cx;
        var ry1 = cos * (y1 - cy) - sin * (x1 - cx) + cy;

        var rx2 = cos * (x2 - cx) + sin * (y2 - cy) + cx;
        var ry2 = cos * (y2 - cy) - sin * (x2 - cx) + cy;

        if (rx1 <= rx2) {
            rect.x = rx1;
            rect.width = rx2 - rx1;
        } else {
            rect.x = rx2;
            rect.width = rx1 - rx2;
        }

        if (ry1 <= ry2) {
            rect.y = ry1;
            rect.height = ry2 - ry1;
        } else {
            rect.y = ry2;
            rect.height = ry1 - ry2;
        }
    };

    var getEventOffsetScroll = function getEventOffsetScroll(e) {
        var offset = getEventOffset(e);
        offset.x -= window.pageXOffset || document.documentElement.scrollLeft;
        offset.y -= window.pageYOffset || document.documentElement.scrollTop;
        return offset;
    };

    var lowercaseFirstLetter = function lowercaseFirstLetter(string) {
        return string.charAt(0).toLowerCase() + string.slice(1);
    };

    var capitalizeFirstLetter = function capitalizeFirstLetter(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    };

    var last = function last(array) {
        return array[array.length - 1];
    };

    var limit = function limit(value, min, max) {
        return Math.max(min, Math.min(max, value));
    };

    var inArray = function inArray(needle, arr) {
        if (!arr) {
            return false;
        }
        for (var i = 0; i < arr.length; i++) {
            if (arr[i] === needle) {
                return true;
            }
        }
        return false;
    };

    var send = function send(url) {
        var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'POST';
        var data = arguments[2];
        var requestDecorator = arguments[3];
        var progress = arguments[4];
        var success = arguments[5];
        var err = arguments[6];

        var xhr = new XMLHttpRequest();

        if (progress) {
            xhr.upload.addEventListener('progress', function (e) {
                progress(e.loaded, e.total);
            });
        }

        xhr.open(method, url, true);

        if (requestDecorator) {
            requestDecorator(xhr, data);
        }

        xhr.onreadystatechange = function () {
            if (xhr.readyState === 4 && xhr.status >= 200 && xhr.status < 300) {
                var text = xhr.responseText;

                if (!text.length) {
                    success();
                    return;
                }

                if (text.indexOf('Content-Length') !== -1) {
                    err('file-too-big');
                    return;
                }

                var obj = void 0;
                try {
                    obj = JSON.parse(xhr.responseText);
                } catch (e) {}

                if ((typeof obj === 'undefined' ? 'undefined' : _typeof(obj)) === 'object' && obj.status === 'failure') {
                    err(obj.message);
                    return;
                }

                success(obj || text);
            } else if (xhr.readyState === 4) {
                var _obj = void 0;
                try {
                    _obj = JSON.parse(xhr.responseText);
                } catch (e) {}

                if ((typeof _obj === 'undefined' ? 'undefined' : _typeof(_obj)) === 'object' && _obj.status === 'failure') {
                    err(_obj.message);
                    return;
                }

                err('fail');
            }
        };

        xhr.send(data);
    };

    var resetTransforms = function resetTransforms(element) {
        if (!element) {
            return;
        }
        element.style.webkitTransform = '';
        element.style.transform = '';
    };

    var bytesToMegaBytes = function bytesToMegaBytes(b) {
        return b / 1000000;
    };

    var megaBytesToBytes = function megaBytesToBytes(mb) {
        return mb * 1000000;
    };

    var getCommonMimeTypes = function getCommonMimeTypes() {
        var types = [];
        var type = void 0;
        var mimeType = void 0;
        for (type in MimeTypes) {
            if (!MimeTypes.hasOwnProperty(type)) {
                continue;
            }
            mimeType = MimeTypes[type];
            if (types.indexOf(mimeType) == -1) {
                types.push(mimeType);
            }
        }
        return types;
    };

    var isJPEGMimeType = function isJPEGMimeType(type) {
        return type === 'image/jpeg';
    };

    var getExtensionByMimeType = function getExtensionByMimeType(mimetype) {
        var type = void 0;
        for (type in MimeTypes) {
            if (!MimeTypes.hasOwnProperty(type)) {
                continue;
            }
            if (MimeTypes[type] === mimetype) {
                return type;
            }
        }
        return mimetype;
    };

    var getMimeTypeFromResponseType = function getMimeTypeFromResponseType(responseType) {
        var type = void 0;
        for (type in MimeTypes) {
            if (!MimeTypes.hasOwnProperty(type)) {
                continue;
            }
            if (responseType.indexOf(MimeTypes[type]) !== -1) {
                return MimeTypes[type];
            }
        }
        return null;
    };

    var getFileName = function getFileName(path) {
        return path.split('/').pop().split('?').shift();
    };

    var leftPad = function leftPad(value) {
        var padding = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        return (padding + value).slice(-padding.length);
    };

    var getDateString = function getDateString(date) {
        return date.getFullYear() + '-' + leftPad(date.getMonth() + 1, '00') + '-' + leftPad(date.getDate(), '00') + '_' + leftPad(date.getHours(), '00') + '-' + leftPad(date.getMinutes(), '00') + '-' + leftPad(date.getSeconds(), '00');
    };

    var getFileNameByFile = function getFileNameByFile(file) {
        if (typeof file.name === 'undefined') {
            return getDateString(new Date()) + '.' + getExtensionByMimeType(getFileTypeByFile(file));
        }
        return file.name;
    };

    var getFileTypeByFile = function getFileTypeByFile(file) {
        return file.type || 'image/jpeg';
    };

    var getFileNameWithoutExtension = function getFileNameWithoutExtension(path) {
        if (typeof path !== 'string') {
            return getDateString(new Date());
        }
        var name = getFileName(path);
        return name.split('.').shift();
    };

    var blobToFile = function blobToFile(blob, name) {
        var file = blob.slice(0, blob.size, blob.type);
        file.name = name;
        file.lastModified = Date.now();
        file.lastModifiedDate = file.lastModified;
        return file;
    };

    var resourceIsFetchURL = function resourceIsFetchURL(resource) {
        return (/^fetch\//.test(resource)
        );
    };

    var resourceIsBase64Data = function resourceIsBase64Data(resource) {
        return (/^data:image/.test(resource)
        );
    };

    var loadRemoteURL = function loadRemoteURL(fetcher, fetchRequestDecorator, loadRequestDecorator, url, err, cb) {
        fetcher = '' + fetcher + (fetcher.indexOf('?') !== -1 ? '&' : '?') + 'url=' + url;

        var xhr = new XMLHttpRequest();
        xhr.open('GET', fetcher, true);
        fetchRequestDecorator(xhr);
        xhr.responseType = 'json';
        xhr.onload = function () {
            if (this.response.status === 'failure') {
                err(this.response.message);
                return;
            }

            loadURL(this.response.body, loadRequestDecorator, cb);
        };

        xhr.send();
    };

    var loadURL = function loadURL(url, requestDecorator, cb, err) {

        var xhr = new XMLHttpRequest();
        xhr.open('GET', url, true);
        requestDecorator(xhr);
        xhr.responseType = 'blob';
        xhr.onload = function (e) {

            if (xhr.status >= 200 && xhr.status < 300 || xhr.status === 0 && this.response instanceof Blob) {
                var name = getFileName(url);
                var type = getMimeTypeFromResponseType(this.response.type);

                if (!ImageExtensionsRegex.test(name)) {
                    name += '.' + getExtensionByMimeType(type);
                }

                var file = blobToFile(this.response, name);

                cb(cloneFile(file, type));
            } else {
                err(xhr.status + ': ' + xhr.statusText);
            }
        };
        xhr.onerror = function () {
            err();
        };

        xhr.send();
    };

    var base64ToByteString = function base64ToByteString(dataURI) {
        var dataPart = dataURI.split(',')[1];

        var dataPartCleaned = dataPart.replace(/\s/g, '');

        return atob(dataPartCleaned);
    };

    var base64ToArrayBuffer = function base64ToArrayBuffer(dataURI) {
        var byteString = base64ToByteString(dataURI);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }
        return ab;
    };

    var base64ToBlob = function base64ToBlob(dataURI, filename) {
        var byteString = base64ToByteString(dataURI);
        var ab = new ArrayBuffer(byteString.length);
        var ia = new Uint8Array(ab);

        for (var i = 0; i < byteString.length; i++) {
            ia[i] = byteString.charCodeAt(i);
        }

        var mimeType = getMimeTypeFromDataURI(dataURI);

        if (typeof filename === 'undefined') {
            filename = getDateString(new Date()) + '.' + getExtensionByMimeType(mimeType);
        }

        return blobToFile(createBlob(ab, mimeType), filename);
    };

    var createBlob = function createBlob(data, mimeType) {
        var BB = window.BlobBuilder = window.BlobBuilder || window.WebKitBlobBuilder || window.MozBlobBuilder || window.MSBlobBuilder;

        if (BB) {
            var bb = new BB();
            bb.append(data);
            return bb.getBlob(mimeType);
        }

        return new Blob([data], {
            type: mimeType
        });
    };

    var arrayBufferConcat = function arrayBufferConcat(buffers) {
        var length = 0;
        var buffer = null;

        for (var i in buffers) {
            if (!_arguments.hasOwnProperty(i)) {
                continue;
            }
            buffer = buffers[i];
            length += buffer.byteLength;
        }

        var joined = new Uint8Array(length);
        var offset = 0;

        for (var _i in buffers) {
            if (!_arguments.hasOwnProperty(_i)) {
                continue;
            }
            buffer = buffers[_i];
            joined.set(new Uint8Array(buffer), offset);
            offset += buffer.byteLength;
        }

        return joined.buffer;
    };

    var getImageAsCanvas = function getImageAsCanvas(src, size, callback) {
        var crossOrigin = typeof src === 'string' ? src.indexOf('data:image') !== 0 : true;

        loadImage.parseMetaData(src, function (meta) {
            var options = {
                canvas: true,
                crossOrigin: crossOrigin
            };

            if (size) {
                options.maxWidth = size.width;
                options.maxHeight = size.height;
            }

            if (meta.exif) {
                options.orientation = meta.exif.get('Orientation');
            }

            loadImage(src, function (res) {
                if (res.type === 'error') {
                    callback();
                    return;
                }

                callback(res, meta);
            }, options);
        });
    };

    var getAutoCropRect = function getAutoCropRect(width, height, ratioOut) {
        var x,
            y,
            w,
            h,
            ratioIn = height / width;

        if (ratioIn < ratioOut) {
            h = height;
            w = h / ratioOut;
            x = (width - w) * 0.5;
            y = 0;
        } else {
            w = width;
            h = w * ratioOut;
            x = 0;
            y = (height - h) * 0.5;
        }

        return {
            x: x,
            y: y,
            height: h,
            width: w
        };
    };

    var transformCanvas = function transformCanvas(canvas) {
        var transforms = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var cb = arguments[2];

        var result = create('canvas');

        var rotation = transforms.rotation,
            crop = transforms.crop,
            size = transforms.size,
            filters = transforms.filters,
            minSize = transforms.minSize;

        if (crop) {
            var isTilted = rotation % 180 !== 0;
            var space = {
                width: isTilted ? canvas.height : canvas.width,
                height: isTilted ? canvas.width : canvas.height
            };

            if (crop.x < 0) {
                crop.x = 0;
            }

            if (crop.y < 0) {
                crop.y = 0;
            }

            if (crop.width > space.width) {
                crop.width = space.width;
            }

            if (crop.height > space.height) {
                crop.height = space.height;
            }

            if (crop.y + crop.height > space.height) {
                crop.y = Math.max(0, space.height - crop.height);
            }

            if (crop.x + crop.width > space.width) {
                crop.x = Math.max(0, space.width - crop.width);
            }

            var px = crop.x / space.width;
            var py = crop.y / space.height;
            var pw = crop.width / space.width;
            var ph = crop.height / space.height;

            result.width = Math.round(crop.width);
            result.height = Math.round(crop.height);

            var ctx = result.getContext('2d');

            if (rotation === 90) {
                ctx.translate(result.width * 0.5, result.height * 0.5);
                ctx.rotate(-90 * Math.PI / 180);
                ctx.drawImage(canvas, (1 - py) * canvas.width - canvas.width * ph, crop.x, crop.height, crop.width, -result.height * 0.5, -result.width * 0.5, result.height, result.width);
            } else if (rotation === 180) {
                ctx.translate(result.width * 0.5, result.height * 0.5);
                ctx.rotate(-180 * Math.PI / 180);
                ctx.drawImage(canvas, (1 - (px + pw)) * space.width, (1 - (py + ph)) * space.height, pw * space.width, ph * space.height, -result.width * 0.5, -result.height * 0.5, result.width, result.height);
            } else if (rotation === 270) {
                ctx.translate(result.width * 0.5, result.height * 0.5);
                ctx.rotate(-270 * Math.PI / 180);
                ctx.drawImage(canvas, crop.y, (1 - px) * canvas.height - canvas.height * pw, crop.height, crop.width, -result.height * 0.5, -result.width * 0.5, result.height, result.width);
            } else {
                ctx.drawImage(canvas, crop.x, crop.y, crop.width, crop.height, 0, 0, result.width, result.height);
            }
        }

        if (size) {
            var scalarX = size.width / result.width;
            var scalarY = size.height / result.height;

            var scalar = Math.min(scalarX, scalarY);

            scaleCanvas(result, scalar, size, minSize);

            if (filters.sharpen > 0) {
                filter(result, sharpen(filters.sharpen));
            }
        }

        cb(result);
    };

    function scaleCanvas(canvas, scalar, bounds, min) {
        if (scalar >= 1) {
            return;
        }

        var w = canvas.width;
        var h = canvas.height;

        var targetWidth = Math.max(min.width, Math.min(bounds.width, Math.round(canvas.width * scalar)));
        var targetHeight = Math.max(min.height, Math.min(bounds.height, Math.round(canvas.height * scalar)));

        var tmp = canvas;
        var ctx = null;

        while (w > targetWidth && h > targetHeight) {

            var c = document.createElement('canvas');
            w = Math.round(tmp.width * .5);
            h = Math.round(tmp.height * .5);

            if (w < targetWidth) {
                w = targetWidth;
            }

            if (h < targetHeight) {
                h = targetHeight;
            }

            c.width = w;
            c.height = h;

            ctx = c.getContext('2d');
            ctx.drawImage(tmp, 0, 0, w, h);

            releaseCanvas(tmp);

            tmp = c;
            c = null;
        }

        canvas.width = targetWidth;
        canvas.height = targetHeight;

        ctx = canvas.getContext('2d');
        ctx.drawImage(tmp, 0, 0, targetWidth, targetHeight);

        if (tmp !== canvas) {
            releaseCanvas(tmp);
        }
    }

    var getPixels = function getPixels(canvas) {
        var ctx = canvas.getContext('2d');
        return ctx.getImageData(0, 0, canvas.width, canvas.height);
    };

    var filter = function filter(canvas, _filter) {
        var ctx = canvas.getContext('2d');
        ctx.putImageData(_filter(getPixels(canvas), canvas.width, canvas.height), 0, 0);
    };

    var createImageData = function createImageData(w, h, pixels) {
        var c = document.createElement('canvas');
        c.width = w;
        c.height = h;
        var ctx = c.getContext('2d');
        var data = ctx.createImageData(c.width, c.height);
        if (pixels) {
            data.set(pixels.data);
        }
        return data;
    };

    var sharpen = function sharpen(mix) {
        return function (pixels, w, h) {
            var weights = [0, -1, 0, -1, 5, -1, 0, -1, 0],
                katet = Math.round(Math.sqrt(weights.length)),
                half = katet * 0.5 | 0,
                dstData = createImageData(w, h),
                dstBuff = dstData.data,
                srcBuff = pixels.data,
                y = h,
                x = void 0;

            while (y--) {
                x = w;

                while (x--) {
                    var sy = y,
                        sx = x,
                        dstOff = (y * w + x) * 4,
                        r = 0,
                        g = 0,
                        b = 0,
                        a = 0;

                    for (var cy = 0; cy < katet; cy++) {
                        for (var cx = 0; cx < katet; cx++) {
                            var scy = sy + cy - half;
                            var scx = sx + cx - half;

                            if (scy >= 0 && scy < h && scx >= 0 && scx < w) {
                                var srcOff = (scy * w + scx) * 4;
                                var wt = weights[cy * katet + cx];

                                r += srcBuff[srcOff] * wt;
                                g += srcBuff[srcOff + 1] * wt;
                                b += srcBuff[srcOff + 2] * wt;
                                a += srcBuff[srcOff + 3] * wt;
                            }
                        }
                    }

                    dstBuff[dstOff] = r * mix + srcBuff[dstOff] * (1 - mix);
                    dstBuff[dstOff + 1] = g * mix + srcBuff[dstOff + 1] * (1 - mix);
                    dstBuff[dstOff + 2] = b * mix + srcBuff[dstOff + 2] * (1 - mix);
                    dstBuff[dstOff + 3] = srcBuff[dstOff + 3];
                }
            }

            return dstData;
        };
    };

    var sizeDist = function sizeDist(rect, canvas) {
        var dx = Math.abs(rect.width - canvas.width);
        var dy = Math.abs(rect.height - canvas.height);

        return Math.max(dx, dy);
    };

    var cloneCanvas = function cloneCanvas(original) {
        if (!original) {
            return null;
        }
        var duplicate = document.createElement('canvas');
        var ctx = duplicate.getContext('2d');
        duplicate.width = original.width;
        duplicate.height = original.height;
        ctx.drawImage(original, 0, 0);
        return duplicate;
    };

    var cloneCanvasScaled = function cloneCanvasScaled(original, scalar) {
        if (!original) {
            return null;
        }

        var duplicate = document.createElement('canvas');
        var ctx = duplicate.getContext('2d');
        duplicate.width = original.width;
        duplicate.height = original.height;
        ctx.drawImage(original, 0, 0);
        if (scalar > 0 && scalar !== 1) {
            scaleCanvas(duplicate, scalar, {
                width: Math.round(original.width * scalar),
                height: Math.round(original.height * scalar)
            }, {
                width: 0,
                height: 0
            });
        }

        return duplicate;
    };

    var canvasHasDimensions = function canvasHasDimensions(canvas) {
        return canvas.width && canvas.height;
    };

    var copyCanvas = function copyCanvas(original, destination) {
        var ctx = destination.getContext('2d');
        if (canvasHasDimensions(destination)) {
            ctx.drawImage(original, 0, 0, destination.width, destination.height);
        } else {
            destination.width = original.width;
            destination.height = original.height;
            ctx.drawImage(original, 0, 0);
        }
    };

    var clearCanvas = function clearCanvas(canvas) {
        var ctx = canvas.getContext('2d');
        ctx.clearRect(0, 0, canvas.width, canvas.height);
    };

    var blurCanvas = function blurCanvas(canvas) {
        stackBlur(canvas, 0, 0, canvas.width, canvas.height, 3);
    };

    var covers = function covers(image, rect) {
        return parseInt(image.width, 10) >= rect.width && parseInt(image.height, 10) >= rect.height;
    };

    var scaleRect = function scaleRect(rect, w, h) {
        return {
            x: rect.x * w,
            y: rect.y * h,
            width: rect.width * w,
            height: rect.height * h
        };
    };

    var divideRect = function divideRect(rect, w, h) {
        return {
            x: rect.x / w,
            y: rect.y / h,
            width: rect.width / w,
            height: rect.height / h
        };
    };

    var resetFileInput = function resetFileInput(input) {
        if (!input || input.value === '') {
            return;
        }

        try {
            input.value = '';
        } catch (err) {}

        if (input.value) {
            var form = document.createElement('form');
            var parentNode = input.parentNode;
            var ref = input.nextSibling;
            form.appendChild(input);
            form.reset();

            if (ref) {
                parentNode.insertBefore(input, ref);
            } else {
                parentNode.appendChild(input);
            }
        }
    };

    var clone = function clone(obj) {
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && value !== null) {
            return JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(obj));
        }
        return obj;
    };

    var cloneFile = function cloneFile(file) {
        var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (!file) {
            return null;
        }
        var dupe = file.slice(0, file.size, type || file.type);
        dupe.name = file.name;
        dupe.lastModified = new Date(file.lastModified);
        return dupe;
    };

    var cloneData = function cloneData(obj) {
        var dupe = clone(obj);
        dupe.input.file = cloneFile(obj.input.file);
        dupe.output.image = obj.output.image;
        return dupe;
    };

    var toDataURL = function toDataURL(image, type, jpegCompression) {
        if (!image || !type) {
            return null;
        }
        var canvas = image;
        if (image.nodeName === 'IMG') {
            canvas = document.createElement('canvas');
            canvas.width = image.width;
            canvas.height = image.height;
            canvas.getContext('2d').drawImage(image, 0, 0);
        }
        return canvas.toDataURL(type, isJPEGMimeType(type) && typeof jpegCompression === 'number' ? jpegCompression / 100 : undefined);
    };

    var getMimeTypeFromDataURI = function getMimeTypeFromDataURI(dataUri) {
        if (!dataUri) {
            return null;
        }
        var matches = dataUri.substr(0, 16).match(/^.+;/);
        if (matches.length) {
            return matches[0].substring(5, matches[0].length - 1);
        }
        return null;
    };

    var flattenData = function flattenData(obj) {
        var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
        var jpegCompression = arguments[2];
        var forcedType = arguments[3];
        var async = arguments[4];

        var data = {
            server: clone(obj.server),
            meta: clone(obj.meta),
            input: {
                name: obj.input.name,
                type: obj.input.type,
                size: obj.input.size,
                width: obj.input.width,
                height: obj.input.height,
                field: obj.input.field
            }
        };

        if (inArray('input', props) && !async) {
            data.input.image = toDataURL(obj.input.image, obj.input.type);
        }

        if (inArray('output', props)) {
            data.output = {
                name: forcedType ? getFileNameWithoutExtension(obj.input.name) + '.' + forcedType : obj.input.name,
                type: MimeTypes[forcedType] || obj.input.type,
                width: obj.output.width,
                height: obj.output.height
            };

            data.output.image = toDataURL(obj.output.image, data.output.type, jpegCompression);
            data.output.type = getMimeTypeFromDataURI(data.output.image);

            if (data.output.type === 'image/png') {
                data.output.name = getFileNameWithoutExtension(data.input.name) + '.png';
            }
        }

        if (inArray('actions', props)) {
            data.actions = clone(obj.actions);
        }

        return data;
    };

    var downloadCanvas = function downloadCanvas(data, jpegCompression, forcedType) {
        var canvas = data.output.image;
        var filename = forcedType ? getFileNameWithoutExtension(data.input.name) + '.' + forcedType : data.input.name;
        var type = MimeTypes[forcedType] || data.input.type;

        if (type === 'image/png') {
            filename = getFileNameWithoutExtension(data.input.name) + '.png';
        }

        canvas.toBlob(function (blob) {
            if ('msSaveBlob' in window.navigator) {
                window.navigator.msSaveBlob(blob, filename);
                return;
            }

            var url = (window.URL || window.webkitURL).createObjectURL(blob);

            var link = create('a');
            link.style.display = 'none';
            link.download = filename;
            link.href = url;

            document.body.appendChild(link);

            link.click();

            setTimeout(function () {
                document.body.removeChild(link);
                (window.URL || window.webkitURL).revokeObjectURL(url);
            }, 0);
        }, type, typeof jpegCompression === 'number' ? jpegCompression / 100 : undefined);
    };

    var toggleDisplayBySelector = function toggleDisplayBySelector(selector, enabled, root) {
        var node = root.querySelector(selector);
        if (!node) {
            return;
        }
        node.style.display = enabled ? '' : 'none';
    };

    var nodeListToArray = function nodeListToArray(nl) {
        return Array.prototype.slice.call(nl);
    };

    var removeElement = function removeElement(el) {
        el.parentNode.removeChild(el);
    };

    var wrap = function wrap(element) {
        var wrapper = create('div');
        if (element.parentNode) {
            if (element.nextSibling) {
                element.parentNode.insertBefore(wrapper, element.nextSibling);
            } else {
                element.parentNode.appendChild(wrapper);
            }
        }
        wrapper.appendChild(element);
        return wrapper;
    };

    var polarToCartesian = function polarToCartesian(centerX, centerY, radius, angleInDegrees) {
        var angleInRadians = (angleInDegrees - 90) * Math.PI / 180.0;

        return {
            x: centerX + radius * Math.cos(angleInRadians),
            y: centerY + radius * Math.sin(angleInRadians)
        };
    };

    var describeArc = function describeArc(x, y, radius, startAngle, endAngle) {
        var start = polarToCartesian(x, y, radius, endAngle);
        var end = polarToCartesian(x, y, radius, startAngle);

        var arcSweep = endAngle - startAngle <= 180 ? '0' : '1';

        var d = ['M', start.x, start.y, 'A', radius, radius, 0, arcSweep, 0, end.x, end.y].join(' ');

        return d;
    };

    var percentageArc = function percentageArc(x, y, radius, p) {
        return describeArc(x, y, radius, 0, p * 360);
    };

    var CropArea = function () {
        var resizers = {
            n: function n(rect, offset, space, ratio) {
                var t, r, b, l, w, h, p, d;

                b = rect.y + rect.height;

                t = limit(offset.y, 0, b);

                if (b - t < space.min.height) {
                    t = b - space.min.height;
                }

                w = ratio ? (b - t) / ratio : rect.width;

                if (w < space.min.width) {
                    w = space.min.width;
                    t = b - w * ratio;
                }

                p = (w - rect.width) * 0.5;
                l = rect.x - p;
                r = rect.x + rect.width + p;

                if (l < 0 || Math.round(r) > Math.round(space.width)) {
                    d = Math.min(rect.x, space.width - (rect.x + rect.width));

                    l = rect.x - d;
                    r = rect.x + rect.width + d;

                    w = r - l;

                    h = w * ratio;

                    t = b - h;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            s: function s(rect, offset, space, ratio) {
                var t, r, b, l, w, h, p, d;

                t = rect.y;

                b = limit(offset.y, t, space.height);

                if (b - t < space.min.height) {
                    b = t + space.min.height;
                }

                w = ratio ? (b - t) / ratio : rect.width;

                if (w < space.min.width) {
                    w = space.min.width;
                    b = t + w * ratio;
                }

                p = (w - rect.width) * 0.5;
                l = rect.x - p;
                r = rect.x + rect.width + p;

                if (l < 0 || Math.round(r) > Math.round(space.width)) {
                    d = Math.min(rect.x, space.width - (rect.x + rect.width));

                    l = rect.x - d;
                    r = rect.x + rect.width + d;

                    w = r - l;

                    h = w * ratio;

                    b = t + h;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            e: function e(rect, offset, space, ratio) {
                var t, r, b, l, w, h, p, d;

                l = rect.x;

                r = limit(offset.x, l, space.width);

                if (r - l < space.min.width) {
                    r = l + space.min.width;
                }

                h = ratio ? (r - l) * ratio : rect.height;

                if (h < space.min.height) {
                    h = space.min.height;
                    r = l + h / ratio;
                }

                p = (h - rect.height) * 0.5;
                t = rect.y - p;
                b = rect.y + rect.height + p;

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    t = rect.y - d;
                    b = rect.y + rect.height + d;

                    h = b - t;

                    w = h / ratio;

                    r = l + w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            w: function w(rect, offset, space, ratio) {
                var t, r, b, l, w, h, p, d;

                r = rect.x + rect.width;

                l = limit(offset.x, 0, r);

                if (r - l < space.min.width) {
                    l = r - space.min.width;
                }

                h = ratio ? (r - l) * ratio : rect.height;

                if (h < space.min.height) {
                    h = space.min.height;
                    l = r - h / ratio;
                }

                p = (h - rect.height) * 0.5;
                t = rect.y - p;
                b = rect.y + rect.height + p;

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    t = rect.y - d;
                    b = rect.y + rect.height + d;

                    h = b - t;

                    w = h / ratio;

                    l = r - w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            ne: function ne(rect, offset, space, ratio) {
                var t, r, b, l, w, h, d;

                l = rect.x;
                b = rect.y + rect.height;

                r = limit(offset.x, l, space.width);

                if (r - l < space.min.width) {
                    r = l + space.min.width;
                }

                h = ratio ? (r - l) * ratio : limit(b - offset.y, space.min.height, b);

                if (h < space.min.height) {
                    h = space.min.height;
                    r = l + h / ratio;
                }

                t = rect.y - (h - rect.height);

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    t = rect.y - d;

                    h = b - t;

                    w = h / ratio;

                    r = l + w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            se: function se(rect, offset, space, ratio) {
                var t, r, b, l, w, h, d;

                l = rect.x;
                t = rect.y;

                r = limit(offset.x, l, space.width);

                if (r - l < space.min.width) {
                    r = l + space.min.width;
                }

                h = ratio ? (r - l) * ratio : limit(offset.y - rect.y, space.min.height, space.height - t);

                if (h < space.min.height) {
                    h = space.min.height;
                    r = l + h / ratio;
                }

                b = rect.y + rect.height + (h - rect.height);

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    b = rect.y + rect.height + d;

                    h = b - t;

                    w = h / ratio;

                    r = l + w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            sw: function sw(rect, offset, space, ratio) {
                var t, r, b, l, w, h, d;

                r = rect.x + rect.width;
                t = rect.y;

                l = limit(offset.x, 0, r);

                if (r - l < space.min.width) {
                    l = r - space.min.width;
                }

                h = ratio ? (r - l) * ratio : limit(offset.y - rect.y, space.min.height, space.height - t);

                if (h < space.min.height) {
                    h = space.min.height;
                    l = r - h / ratio;
                }

                b = rect.y + rect.height + (h - rect.height);

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    b = rect.y + rect.height + d;

                    h = b - t;

                    w = h / ratio;

                    l = r - w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            },
            nw: function nw(rect, offset, space, ratio) {
                var t, r, b, l, w, h, d;

                r = rect.x + rect.width;
                b = rect.y + rect.height;

                l = limit(offset.x, 0, r);

                if (r - l < space.min.width) {
                    l = r - space.min.width;
                }

                h = ratio ? (r - l) * ratio : limit(b - offset.y, space.min.height, b);

                if (h < space.min.height) {
                    h = space.min.height;
                    l = r - h / ratio;
                }

                t = rect.y - (h - rect.height);

                if (t < 0 || Math.round(b) > Math.round(space.height)) {
                    d = Math.min(rect.y, space.height - (rect.y + rect.height));

                    t = rect.y - d;

                    h = b - t;

                    w = h / ratio;

                    l = r - w;
                }

                return {
                    x: l,
                    y: t,
                    width: r - l,
                    height: b - t
                };
            }
        };

        return function () {
            function CropArea() {
                var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');

                _classCallCheck(this, CropArea);

                this._element = element;

                this._interaction = null;

                this._minWidth = 1;
                this._minHeight = 1;

                this._ratio = null;

                this._rect = {
                    x: 0,
                    y: 0,
                    width: 0,
                    height: 0
                };

                this._space = {
                    width: 0,
                    height: 0
                };

                this._rectChanged = false;

                this._init();
            }

            _createClass(CropArea, [{
                key: '_init',
                value: function _init() {
                    this._element.className = 'slim-crop-area';

                    var lines = create('div', 'grid');
                    this._element.appendChild(lines);

                    for (var handler in resizers) {
                        if (!resizers.hasOwnProperty(handler)) {
                            continue;
                        }
                        var _btn = create('button', handler);
                        this._element.appendChild(_btn);
                    }
                    var btn = create('button', 'c');
                    this._element.appendChild(btn);

                    addEvents(document, Events.DOWN, this);
                }
            }, {
                key: 'reset',
                value: function reset() {
                    this._interaction = null;

                    this._rect = {
                        x: 0,
                        y: 0,
                        width: 0,
                        height: 0
                    };

                    this._rectChanged = true;

                    this._redraw();

                    this._element.dispatchEvent(new CustomEvent('change'));
                }
            }, {
                key: 'rescale',
                value: function rescale(scale) {
                    if (scale === 1) {
                        return;
                    }

                    this._interaction = null;

                    this._rectChanged = true;

                    this._rect.x *= scale;
                    this._rect.y *= scale;
                    this._rect.width *= scale;
                    this._rect.height *= scale;

                    this._redraw();

                    this._element.dispatchEvent(new CustomEvent('change'));
                }
            }, {
                key: 'limit',
                value: function limit(width, height) {
                    this._space.width = width;
                    this._space.height = height;
                }
            }, {
                key: 'offset',
                value: function offset(x, y) {
                    this._space.x = x;
                    this._space.y = y;
                }
            }, {
                key: 'resize',
                value: function resize(x, y, width, height) {
                    this._interaction = null;

                    this._rect = {
                        x: limit(x, 0, this._space.width - this._minWidth),
                        y: limit(y, 0, this._space.height - this._minHeight),
                        width: limit(width, this._minWidth, this._space.width),
                        height: limit(height, this._minHeight, this._space.height)
                    };

                    this._rectChanged = true;

                    this._redraw();

                    this._element.dispatchEvent(new CustomEvent('change'));
                }
            }, {
                key: 'handleEvent',
                value: function handleEvent(e) {
                    switch (e.type) {
                        case 'touchstart':
                        case 'pointerdown':
                        case 'mousedown':
                            {
                                this._onStartDrag(e);
                            }
                            break;
                        case 'touchmove':
                        case 'pointermove':
                        case 'mousemove':
                            {
                                this._onDrag(e);
                            }
                            break;
                        case 'touchend':
                        case 'touchcancel':
                        case 'pointerup':
                        case 'mouseup':
                            {
                                this._onStopDrag(e);
                            }
                    }
                }
            }, {
                key: '_onStartDrag',
                value: function _onStartDrag(e) {
                    if (!this._element.contains(e.target)) {
                        return;
                    }

                    e.preventDefault();

                    addEvents(document, Events.MOVE, this);
                    addEvents(document, Events.UP, this);

                    this._interaction = {
                        type: e.target.className,
                        offset: getEventOffsetScroll(e)
                    };

                    this._interaction.offset.x -= this._rect.x;
                    this._interaction.offset.y -= this._rect.y;

                    this._element.setAttribute('data-dragging', 'true');

                    this._redraw();
                }
            }, {
                key: '_onDrag',
                value: function _onDrag(e) {
                    e.preventDefault();

                    var offset = getEventOffsetScroll(e);
                    var type = this._interaction.type;

                    if (type === 'c') {
                        this._rect.x = limit(offset.x - this._interaction.offset.x, 0, this._space.width - this._rect.width);
                        this._rect.y = limit(offset.y - this._interaction.offset.y, 0, this._space.height - this._rect.height);
                    } else if (resizers[type]) {
                        this._rect = resizers[type](this._rect, {
                            x: offset.x - this._space.x,
                            y: offset.y - this._space.y
                        }, {
                            x: 0,
                            y: 0,
                            width: this._space.width,
                            height: this._space.height,
                            min: {
                                width: this._minWidth,
                                height: this._minHeight
                            }
                        }, this._ratio);
                    }

                    this._rectChanged = true;

                    this._element.dispatchEvent(new CustomEvent('input'));
                }
            }, {
                key: '_onStopDrag',
                value: function _onStopDrag(e) {
                    e.preventDefault();

                    removeEvents(document, Events.MOVE, this);
                    removeEvents(document, Events.UP, this);

                    this._interaction = null;

                    this._element.setAttribute('data-dragging', 'false');

                    this._element.dispatchEvent(new CustomEvent('change'));
                }
            }, {
                key: '_redraw',
                value: function _redraw() {
                    var _this = this;

                    if (this._rectChanged) {
                        var transform = 'translate(' + this._rect.x + 'px,' + this._rect.y + 'px);';
                        this._element.style.cssText = '\n\t\t\t\t\t-webkit-transform: ' + transform + ';\n\t\t\t\t\ttransform: ' + transform + ';\n\t\t\t\t\twidth:' + this._rect.width + 'px;\n\t\t\t\t\theight:' + this._rect.height + 'px;\n\t\t\t\t';

                        this._rectChanged = false;
                    }

                    if (!this._interaction) {
                        return;
                    }

                    requestAnimationFrame(function () {
                        return _this._redraw();
                    });
                }
            }, {
                key: 'destroy',
                value: function destroy() {
                    this._interaction = false;
                    this._rectChanged = false;

                    removeEvents(document, Events.DOWN, this);
                    removeEvents(document, Events.MOVE, this);
                    removeEvents(document, Events.UP, this);

                    removeElement(this._element);
                }
            }, {
                key: 'element',
                get: function get() {
                    return this._element;
                }
            }, {
                key: 'space',
                get: function get() {
                    return this._space;
                }
            }, {
                key: 'area',
                get: function get() {
                    var x = this._rect.x / this._space.width;
                    var y = this._rect.y / this._space.height;
                    var width = this._rect.width / this._space.width;
                    var height = this._rect.height / this._space.height;

                    return {
                        x: x,
                        y: y,
                        width: width,
                        height: height
                    };
                }
            }, {
                key: 'dirty',
                get: function get() {
                    return this._rect.x !== 0 || this._rect.y !== 0 || this._rect.width !== 0 || this._rect.height !== 0;
                }
            }, {
                key: 'minWidth',
                set: function set(value) {
                    this._minWidth = Math.max(value, 1);
                }
            }, {
                key: 'minHeight',
                set: function set(value) {
                    this._minHeight = Math.max(value, 1);
                }
            }, {
                key: 'ratio',
                set: function set(value) {
                    this._ratio = value;
                }
            }]);

            return CropArea;
        }();
    }();

    var ImageEditor = function () {

        var CropAreaEvents = ['input', 'change'];

        var ImageEditor = function () {
            function ImageEditor() {
                var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

                _classCallCheck(this, ImageEditor);

                this._element = element;
                this._options = mergeOptions(ImageEditor.options(), options);

                this._ratio = null;
                this._output = null;
                this._rotating = false;

                this._input = null;

                this._preview = null;
                this._previewBlurred = null;

                this._blurredPreview = false;

                this._cropper = null;
                this._straightCrop = null;
                this._previewWrapper = null;
                this._currentWindowSize = {};

                this._btnGroup = null;
                this._maskFrame = null;

                this._dirty = false;

                this._wrapperRotation = 0;
                this._wrapperScale = 1.0;

                this._init();
            }

            _createClass(ImageEditor, [{
                key: '_init',
                value: function _init() {
                    var _this2 = this;

                    this._element.className = 'slim-image-editor';

                    this._container = create('div', 'slim-container');

                    this._wrapper = create('div', 'slim-wrapper');

                    this._stage = create('div', 'slim-stage');
                    this._container.appendChild(this._stage);

                    this._cropper = new CropArea();
                    CropAreaEvents.forEach(function (e) {
                        _this2._cropper.element.addEventListener(e, _this2);
                    });
                    this._stage.appendChild(this._cropper.element);

                    this._previewWrapper = create('div', 'slim-image-editor-preview slim-crop-preview');
                    this._previewBlurred = create('canvas', 'slim-crop-blur');
                    this._previewWrapper.appendChild(this._previewBlurred);
                    this._wrapper.appendChild(this._previewWrapper);

                    this._previewMask = create('div', 'slim-crop-mask');
                    this._preview = create('img');
                    this._previewMask.appendChild(this._preview);
                    this._cropper.element.appendChild(this._previewMask);

                    this._btnGroup = create('div', 'slim-editor-btn-group');
                    ImageEditor.Buttons.forEach(function (c) {
                        var prop = capitalizeFirstLetter(c);
                        var label = _this2._options['button' + prop + 'Label'];
                        var title = _this2._options['button' + prop + 'Title'];
                        var className = _this2._options['button' + prop + 'ClassName'];
                        var btn = create('button', 'slim-editor-btn slim-btn-' + c + (className ? ' ' + className : ''));
                        btn.innerHTML = label;
                        btn.title = title || label;
                        btn.type = 'button';
                        btn.setAttribute('data-action', c);
                        btn.addEventListener('click', _this2);
                        _this2._btnGroup.appendChild(btn);
                    });

                    this._utilsGroup = create('div', 'slim-editor-utils-group');

                    var btn = create('button', 'slim-editor-utils-btn slim-btn-rotate' + (this._options.buttonRotateClassName ? ' ' + this._options.buttonRotateClassName : ''));
                    btn.setAttribute('data-action', 'rotate');
                    btn.addEventListener('click', this);
                    btn.title = this._options.buttonRotateTitle;
                    this._utilsGroup.appendChild(btn);

                    this._container.appendChild(this._wrapper);

                    this._element.appendChild(this._container);
                    this._element.appendChild(this._utilsGroup);
                    this._element.appendChild(this._btnGroup);
                }
            }, {
                key: 'dirty',
                value: function dirty() {
                    this._dirty = true;
                }
            }, {
                key: 'handleEvent',
                value: function handleEvent(e) {
                    switch (e.type) {
                        case 'click':
                            this._onClick(e);
                            break;
                        case 'change':
                            this._onGridChange(e);
                            break;
                        case 'input':
                            this._onGridInput(e);
                            break;
                        case 'keydown':
                            this._onKeyDown(e);
                            break;
                        case 'resize':
                            this._onResize(e);
                            break;
                    }
                }
            }, {
                key: '_onKeyDown',
                value: function _onKeyDown(e) {
                    switch (e.keyCode) {
                        case Key.RETURN:
                            {
                                this._confirm();
                                break;
                            }
                        case Key.ESC:
                            {
                                this._cancel();
                                break;
                            }
                    }
                }
            }, {
                key: '_onClick',
                value: function _onClick(e) {
                    if (e.target.classList.contains('slim-btn-cancel')) {
                        this._cancel();
                    }

                    if (e.target.classList.contains('slim-btn-confirm')) {
                        this._confirm();
                    }

                    if (e.target.classList.contains('slim-btn-rotate')) {
                        this._rotate();
                    }
                }
            }, {
                key: '_onResize',
                value: function _onResize() {
                    this._currentWindowSize = {
                        width: window.innerWidth,
                        height: window.innerHeight
                    };

                    this._redraw();

                    this._redrawCropper(this._cropper.area);

                    this._updateWrapperScale();

                    this._redrawWrapper();
                }
            }, {
                key: '_redrawWrapper',
                value: function _redrawWrapper() {
                    var matrix = snabbt.createMatrix();
                    matrix.scale(this._wrapperScale, this._wrapperScale);
                    matrix.rotateZ(this._wrapperRotation * (Math.PI / 180));
                    snabbt.setElementTransform(this._previewWrapper, matrix);
                }
            }, {
                key: '_onGridInput',
                value: function _onGridInput() {
                    this._redrawCropMask();
                }
            }, {
                key: '_onGridChange',
                value: function _onGridChange() {
                    this._redrawCropMask();
                }
            }, {
                key: '_updateWrapperRotation',
                value: function _updateWrapperRotation() {
                    if (this._options.minSize.width > this._input.height || this._options.minSize.height > this._input.width) {
                        this._wrapperRotation += 180;
                    } else {
                        this._wrapperRotation += 90;
                    }
                }
            }, {
                key: '_updateWrapperScale',
                value: function _updateWrapperScale() {
                    var isTilted = this._wrapperRotation % 180 !== 0;

                    if (isTilted) {
                        var maxWidth = this._container.offsetWidth;
                        var maxHeight = this._container.offsetHeight;

                        var wrapperWidth = this._wrapper.offsetHeight;
                        var wrapperHeight = this._wrapper.offsetWidth;

                        var scalar = maxWidth / wrapperWidth;
                        if (scalar * wrapperHeight > maxHeight) {
                            scalar = maxHeight / wrapperHeight;
                        }

                        this._wrapperScale = scalar;
                    } else {
                        this._wrapperScale = 1.0;
                    }
                }

            }, {
                key: '_cancel',
                value: function _cancel() {
                    if (this._rotating) {
                        return;
                    }

                    this._element.dispatchEvent(new CustomEvent('cancel'));
                }
            }, {
                key: '_confirm',
                value: function _confirm() {
                    if (this._rotating) {
                        return;
                    }

                    var isTilted = this._wrapperRotation % 180 !== 0;
                    var area = this._cropper.area;

                    var result = scaleRect(area, isTilted ? this._input.height : this._input.width, isTilted ? this._input.width : this._input.height);

                    this._element.dispatchEvent(new CustomEvent('confirm', {
                        detail: {
                            rotation: this._wrapperRotation % 360,
                            crop: result
                        }
                    }));
                }
            }, {
                key: '_rotate',
                value: function _rotate() {
                    var _this3 = this;

                    if (this._rotating) {
                        return;
                    }

                    this._rotating = true;

                    this._updateWrapperRotation();

                    var rect = this.ratio === 1 || this._ratio === null ? this._cropper.area : null;
                    if (rect) {
                        rotate(rect, 90);
                    }

                    this._updateWrapperScale();

                    this._hideCropper();

                    snabbt(this._previewWrapper, {
                        rotation: [0, 0, this._wrapperRotation * (Math.PI / 180)],
                        scale: [this._wrapperScale, this._wrapperScale],
                        easing: 'spring',
                        springConstant: 0.8,
                        springDeceleration: 0.65,
                        complete: function complete() {
                            _this3._redrawCropper(rect);

                            _this3._showCropper();

                            _this3._rotating = false;
                        }
                    });
                }
            }, {
                key: '_showCropper',
                value: function _showCropper() {
                    snabbt(this._stage, {
                        easing: 'ease',
                        duration: 250,
                        fromOpacity: 0,
                        opacity: 1.0
                    });
                }
            }, {
                key: '_hideCropper',
                value: function _hideCropper() {
                    snabbt(this._stage, {
                        duration: 0,
                        fromOpacity: 0,
                        opacity: 0
                    });
                }
            }, {
                key: '_redrawCropMask',
                value: function _redrawCropMask() {
                    var _this4 = this;

                    var rotation = this._wrapperRotation % 360;

                    var scale = this._wrapperScale;

                    var canvas = {
                        width: this._wrapper.offsetWidth,
                        height: this._wrapper.offsetHeight
                    };

                    var mask = this._cropper.area;
                    var preview = {
                        x: 0,
                        y: 0
                    };

                    if (rotation === 0) {
                        preview.x = -mask.x;
                        preview.y = -mask.y;
                    } else if (rotation === 90) {
                        preview.x = -(1 - mask.y);
                        preview.y = -mask.x;
                    } else if (rotation === 180) {
                        preview.x = -(1 - mask.x);
                        preview.y = -(1 - mask.y);
                    } else if (rotation === 270) {
                        preview.x = -mask.y;
                        preview.y = -(1 - mask.x);
                    }

                    preview.x *= canvas.width;
                    preview.y *= canvas.height;

                    cancelAnimationFrame(this._maskFrame);
                    this._maskFrame = requestAnimationFrame(function () {
                        var transform = 'scale(' + scale + ') rotate(' + -rotation + 'deg) translate(' + preview.x + 'px, ' + preview.y + 'px);';
                        _this4._preview.style.cssText = '\n\t\t\t\t\twidth: ' + _this4._previewSize.width + 'px;\n\t\t\t\t\theight: ' + _this4._previewSize.height + 'px;\n\t\t\t\t\t-webkit-transform: ' + transform + ';\n\t\t\t\t\ttransform: ' + transform + ';\n\t\t\t\t';
                    });
                }
            }, {
                key: 'open',
                value: function open(image, ratio, crop, rotation, complete) {
                    var _this5 = this;

                    if (this._input && !this._dirty && this._ratio === ratio && this._wrapperRotation === rotation) {
                        complete();
                        return;
                    }

                    this._currentWindowSize = {
                        width: window.innerWidth,
                        height: window.innerHeight
                    };

                    this._dirty = false;

                    this._wrapperRotation = rotation || 0;

                    this._blurredPreview = false;

                    this._ratio = ratio;

                    this._previewSize = null;

                    this._element.style.opacity = '0';

                    this._input = image;

                    var tilted = this._wrapperRotation % 180 !== 0;
                    var relativeCrop = divideRect(crop, tilted ? image.height : image.width, tilted ? image.width : image.height);

                    this._preview.onload = function () {
                        _this5._preview.onload = null;

                        _this5._cropper.ratio = _this5.ratio;

                        _this5._redraw();

                        _this5._redrawCropper(relativeCrop);

                        complete();

                        _this5._element.style.opacity = '';
                    };

                    var previewCanvas = cloneCanvasScaled(this._input, Math.min(this._container.offsetWidth / this._input.width, this._container.offsetHeight / this._input.height) * this._options.devicePixelRatio);
                    this._preview.src = '';
                    this._preview.src = previewCanvas.toDataURL();
                    previewCanvas.width = 1;
                    previewCanvas.height = 1;
                    previewCanvas = null;
                }
            }, {
                key: '_redrawCropper',
                value: function _redrawCropper(rect) {
                    var isTilted = this._wrapperRotation % 180 !== 0;

                    var imageRatio = isTilted ? this._input.height / this._input.width : this._input.width / this._input.height;

                    var width = this._wrapper.offsetWidth;
                    var height = this._wrapper.offsetHeight;

                    var maxWidth = this._container.offsetWidth;
                    var maxHeight = this._container.offsetHeight;

                    this._updateWrapperScale();

                    var sw = this._wrapperScale * (isTilted ? height : width);
                    var sh = this._wrapperScale * (isTilted ? width : height);
                    var sx = isTilted ? (maxWidth - sw) * 0.5 : this._wrapper.offsetLeft;
                    var sy = isTilted ? (maxHeight - sh) * 0.5 : this._wrapper.offsetTop;

                    this._stage.style.cssText = '\n\t\t\t\tleft:' + sx + 'px;\n\t\t\t\ttop:' + sy + 'px;\n\t\t\t\twidth:' + sw + 'px;\n\t\t\t\theight:' + sh + 'px;\n\t\t\t';

                    this._cropper.limit(sw, sw / imageRatio);
                    this._cropper.offset(sx + this._element.offsetLeft, sy + this._element.offsetTop);

                    this._cropper.minWidth = this._wrapperScale * this._options.minSize.width * this.scalar;
                    this._cropper.minHeight = this._wrapperScale * this._options.minSize.height * this.scalar;

                    var crop = null;
                    if (rect) {
                        crop = {
                            x: rect.x * sw,
                            y: rect.y * sh,
                            width: rect.width * sw,
                            height: rect.height * sh
                        };
                    } else {
                        crop = getAutoCropRect(sw, sh, this._ratio || sh / sw);
                    }

                    this._cropper.resize(crop.x, crop.y, crop.width, crop.height);
                }
            }, {
                key: '_redraw',
                value: function _redraw() {
                    var ratio = this._input.height / this._input.width;

                    var maxWidth = this._container.clientWidth;
                    var maxHeight = this._container.clientHeight;

                    var width = maxWidth;
                    var height = width * ratio;

                    if (height > maxHeight) {
                        height = maxHeight;
                        width = height / ratio;
                    }

                    width = Math.round(width);
                    height = Math.round(height);

                    var x = (maxWidth - width) / 2;
                    var y = (maxHeight - height) / 2;

                    this._wrapper.style.cssText = '\n\t\t\t\tleft:' + x + 'px;\n\t\t\t\ttop:' + y + 'px;\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

                    this._previewBlurred.style.cssText = '\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

                    this._preview.style.cssText = '\n\t\t\t\twidth:' + width + 'px;\n\t\t\t\theight:' + height + 'px;\n\t\t\t';

                    this._previewSize = {
                        width: width,
                        height: height
                    };

                    if (!this._blurredPreview) {
                        this._previewBlurred.width = 300;
                        this._previewBlurred.height = this._previewBlurred.width * ratio;

                        copyCanvas(this._input, this._previewBlurred);

                        blurCanvas(this._previewBlurred, 3);

                        this._blurredPreview = true;
                    }
                }
            }, {
                key: 'show',
                value: function show() {
                    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                    if (this._currentWindowSize.width !== window.innerWidth || this._currentWindowSize.height !== window.innerHeight) {
                        this._redraw();

                        this._redrawCropper(this._cropper.area);
                    }

                    document.addEventListener('keydown', this);

                    window.addEventListener('resize', this);

                    var rotation = this._wrapperRotation * (Math.PI / 180);
                    snabbt(this._previewWrapper, {
                        fromRotation: [0, 0, rotation],
                        rotation: [0, 0, rotation],
                        fromPosition: [0, 0, 0],
                        position: [0, 0, 0],
                        fromOpacity: 0,
                        opacity: 1,
                        fromScale: [this._wrapperScale - 0.02, this._wrapperScale - 0.02],
                        scale: [this._wrapperScale, this._wrapperScale],
                        easing: 'spring',
                        springConstant: 0.3,
                        springDeceleration: 0.85,
                        delay: 450,
                        complete: function complete() {}
                    });

                    if (this._cropper.dirty) {
                        snabbt(this._stage, {
                            fromPosition: [0, 0, 0],
                            position: [0, 0, 0],
                            fromOpacity: 0,
                            opacity: 1,
                            duration: 250,
                            delay: 850,
                            complete: function complete() {
                                resetTransforms(this);
                                callback();
                            }
                        });
                    } else {
                        snabbt(this._stage, {
                            fromPosition: [0, 0, 0],
                            position: [0, 0, 0],
                            fromOpacity: 0,
                            opacity: 1,
                            duration: 250,
                            delay: 1000,
                            complete: function complete() {
                                resetTransforms(this);
                            }
                        });
                    }

                    snabbt(this._btnGroup.childNodes, {
                        fromScale: [0.9, 0.9],
                        scale: [1, 1],
                        fromOpacity: 0,
                        opacity: 1,
                        delay: function delay(i) {
                            return 1000 + i * 100;
                        },
                        easing: 'spring',
                        springConstant: 0.3,
                        springDeceleration: 0.85,
                        complete: function complete() {
                            resetTransforms(this);
                        }
                    });

                    snabbt(this._utilsGroup.childNodes, {
                        fromScale: [0.9, 0.9],
                        scale: [1, 1],
                        fromOpacity: 0,
                        opacity: 1,
                        easing: 'spring',
                        springConstant: 0.3,
                        springDeceleration: 0.85,
                        delay: 1250,
                        complete: function complete() {
                            resetTransforms(this);
                        }
                    });
                }
            }, {
                key: 'hide',
                value: function hide() {
                    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                    document.removeEventListener('keydown', this);

                    window.removeEventListener('resize', this);

                    snabbt(this._utilsGroup.childNodes, {
                        fromOpacity: 1,
                        opacity: 0,
                        duration: 250
                    });

                    snabbt(this._btnGroup.childNodes, {
                        fromOpacity: 1,
                        opacity: 0,
                        delay: 200,
                        duration: 350
                    });

                    snabbt([this._stage, this._previewWrapper], {
                        fromPosition: [0, 0, 0],
                        position: [0, -250, 0],
                        fromOpacity: 1,
                        opacity: 0,
                        easing: 'spring',
                        springConstant: 0.3,
                        springDeceleration: 0.75,
                        delay: 250,
                        allDone: function allDone() {
                            callback();
                        }
                    });
                }
            }, {
                key: 'destroy',
                value: function destroy() {
                    var _this6 = this;

                    nodeListToArray(this._btnGroup.children).forEach(function (btn) {
                        btn.removeEventListener('click', _this6);
                    });

                    CropAreaEvents.forEach(function (e) {
                        _this6._cropper.element.removeEventListener(e, _this6);
                    });

                    this._cropper.destroy();

                    if (this._previewBlurred) {
                        this._previewBlurred.width = 1;
                        this._previewBlurred.height = 1;
                    }

                    if (this._element.parentNode) {
                        removeElement(this._element);
                    }
                }
            }, {
                key: 'showRotateButton',
                set: function set(enabled) {
                    if (enabled) {
                        this._element.classList.remove('slim-rotation-disabled');
                    } else {
                        this._element.classList.add('slim-rotation-disabled');
                    }
                }
            }, {
                key: 'element',
                get: function get() {
                    return this._element;
                }
            }, {
                key: 'ratio',
                get: function get() {
                    if (this._ratio === 'input') {
                        return this._input.height / this._input.width;
                    }
                    return this._ratio;
                }
            }, {
                key: 'offset',
                get: function get() {
                    return this._element.getBoundingClientRect();
                }
            }, {
                key: 'original',
                get: function get() {
                    return this._input;
                }
            }, {
                key: 'scalar',
                get: function get() {
                    return this._previewSize.width / this._input.width;
                }
            }], [{
                key: 'options',
                value: function options() {
                    return {
                        buttonCancelClassName: null,
                        buttonConfirmClassName: null,
                        buttonCancelLabel: 'Cancel',
                        buttonConfirmLabel: 'Confirm',
                        buttonCancelTitle: null,
                        buttonConfirmTitle: null,

                        buttonRotateTitle: 'Rotate',
                        buttonRotateClassName: null,

                        devicePixelRatio: null,

                        minSize: {
                            width: 0,
                            height: 0
                        }
                    };
                }
            }]);

            return ImageEditor;
        }();

        ImageEditor.Buttons = ['cancel', 'confirm'];

        return ImageEditor;
    }(CropArea);

    var FileHopper = function () {
        var DragDropEvents = ['dragenter', 'dragover', 'dragleave', 'drop'];

        return function () {
            function FileHopper() {
                var element = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : document.createElement('div');

                _classCallCheck(this, FileHopper);

                this._element = element;
                this._accept = [];
                this._allowURLs = false;

                this._dragPath = null;

                this._init();
            }

            _createClass(FileHopper, [{
                key: 'isValidDataTransfer',
                value: function isValidDataTransfer(dataTransfer) {
                    if (dataTransfer.files && dataTransfer.files.length) {
                        return this.areValidDataTransferFiles(dataTransfer.files);
                    }

                    if (dataTransfer.items && dataTransfer.items.length) {
                        return this.areValidDataTransferItems(dataTransfer.items);
                    }

                    return null;
                }
            }, {
                key: 'areValidDataTransferFiles',
                value: function areValidDataTransferFiles(files) {
                    if (this._accept.length && files) {
                        return this._accept.indexOf(files[0].type) !== -1;
                    }
                    return true;
                }
            }, {
                key: 'areValidDataTransferItems',
                value: function areValidDataTransferItems(items) {
                    if (this._accept.length && items) {
                        if (this._allowURLs && items[0].kind === 'string') {
                            return null;
                        }

                        if (items[0].type && items[0].type.indexOf('application') === 0) {
                            return null;
                        }

                        return this._accept.indexOf(items[0].type) !== -1;
                    }

                    return true;
                }

            }, {
                key: 'reset',
                value: function reset() {
                    this._element.files = null;
                }

            }, {
                key: '_init',
                value: function _init() {
                    var _this7 = this;

                    this._element.className = 'slim-file-hopper';

                    DragDropEvents.forEach(function (e) {
                        _this7._element.addEventListener(e, _this7);
                    });
                }

            }, {
                key: 'handleEvent',
                value: function handleEvent(e) {
                    switch (e.type) {
                        case 'dragenter':
                        case 'dragover':
                            this._onDragOver(e);
                            break;
                        case 'dragleave':
                            this._onDragLeave(e);
                            break;
                        case 'drop':
                            this._onDrop(e);
                            break;
                    }
                }
            }, {
                key: '_onDrop',
                value: function _onDrop(e) {
                    e.preventDefault();

                    var remote = null;

                    if (this._allowURLs) {
                        var url = void 0;
                        var meta = void 0;
                        try {
                            url = e.dataTransfer.getData('url');
                            meta = e.dataTransfer.getData('text/html');
                        } catch (e) {}

                        if (meta && meta.length) {
                            var parsed = meta.match(/src\s*=\s*"(.+?)"/);
                            if (parsed) {
                                remote = parsed[1];
                            }
                        } else if (url && url.length) {
                            remote = url;
                        }
                    }

                    if (remote) {
                        this._element.files = [{ remote: remote }];
                    } else {
                        var filesValidity = this.isValidDataTransfer(e.dataTransfer);
                        if (!filesValidity) {
                            this._element.dispatchEvent(new CustomEvent('file-invalid-drop'));

                            this._dragPath = null;
                            return;
                        }

                        this._element.files = e.dataTransfer.files;
                    }

                    this._element.dispatchEvent(new CustomEvent('file-drop', {
                        detail: getOffsetByEvent(e)
                    }));

                    this._element.dispatchEvent(new CustomEvent('change'));

                    this._dragPath = null;
                }
            }, {
                key: '_onDragOver',
                value: function _onDragOver(e) {
                    e.preventDefault();

                    e.dataTransfer.dropEffect = 'copy';

                    var dataValidity = this.isValidDataTransfer(e.dataTransfer);

                    if (dataValidity !== null && !dataValidity) {
                        e.dataTransfer.dropEffect = 'none';

                        this._element.dispatchEvent(new CustomEvent('file-invalid'));
                        return;
                    }

                    if (!this._dragPath) {
                        this._dragPath = [];
                    }

                    this._dragPath.push(getOffsetByEvent(e));

                    this._element.dispatchEvent(new CustomEvent('file-over', {
                        detail: {
                            x: last(this._dragPath).x,
                            y: last(this._dragPath).y
                        }
                    }));
                }
            }, {
                key: '_onDragLeave',
                value: function _onDragLeave(e) {
                    this._element.dispatchEvent(new CustomEvent('file-out', {
                        detail: getOffsetByEvent(e)
                    }));

                    this._dragPath = null;
                }
            }, {
                key: 'destroy',
                value: function destroy() {
                    var _this8 = this;

                    DragDropEvents.forEach(function (e) {
                        _this8._element.removeEventListener(e, _this8);
                    });

                    removeElement(this._element);

                    this._element = null;
                    this._dragPath = null;
                    this._accept = null;
                }
            }, {
                key: 'element',
                get: function get() {
                    return this._element;
                }
            }, {
                key: 'dragPath',
                get: function get() {
                    return this._dragPath;
                }
            }, {
                key: 'enabled',
                get: function get() {
                    return this._element.style.display === '';
                },
                set: function set(value) {
                    this._element.style.display = value ? '' : 'none';
                }
            }, {
                key: 'allowURLs',
                set: function set(value) {
                    this._allowURLs = value;
                }
            }, {
                key: 'accept',
                set: function set(mimetypes) {
                    this._accept = mimetypes;
                },
                get: function get() {
                    return this._accept;
                }
            }]);

            return FileHopper;
        }();
    }();

    var Popover = function () {
        return function () {
            function Popover() {
                _classCallCheck(this, Popover);

                this._element = null;
                this._inner = null;

                this._init();
            }

            _createClass(Popover, [{
                key: '_init',
                value: function _init() {
                    this._element = create('div', 'slim-popover');
                    this._element.setAttribute('data-state', 'off');
                    document.body.appendChild(this._element);

                    this._element.addEventListener('touchmove', function (e) {
                        e.preventDefault();
                    }, true);
                }
            }, {
                key: 'show',
                value: function show() {
                    var _this9 = this;

                    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                    this._element.setAttribute('data-state', 'on');

                    snabbt(this._element, {
                        fromOpacity: 0,
                        opacity: 1,
                        duration: 350,
                        complete: function complete() {
                            resetTransforms(_this9._element);

                            callback();
                        }
                    });
                }
            }, {
                key: 'hide',
                value: function hide() {
                    var _this10 = this;

                    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};

                    snabbt(this._element, {
                        fromOpacity: 1,
                        opacity: 0,
                        duration: 500,
                        complete: function complete() {
                            resetTransforms(_this10._element);

                            _this10._element.setAttribute('data-state', 'off');

                            callback();
                        }
                    });
                }
            }, {
                key: 'destroy',
                value: function destroy() {
                    if (!this._element.parentNode) {
                        return;
                    }
                    this._element.parentNode.removeChild(this._element);
                    this._element = null;
                    this._inner = null;
                }
            }, {
                key: 'inner',
                set: function set(element) {
                    this._inner = element;
                    if (this._element.firstChild) {
                        this._element.removeChild(this._element.firstChild);
                    }
                    this._element.appendChild(this._inner);
                }
            }, {
                key: 'className',
                set: function set(value) {
                    this._element.className = 'slim-popover' + (value === null ? '' : ' ' + value);
                }
            }]);

            return Popover;
        }();
    }();

    var intSplit = function intSplit(v, c) {
        return v.split(c).map(function (v) {
            return parseInt(v, 10);
        });
    };

    var isWrapper = function isWrapper(element) {
        return element.nodeName === 'DIV' || element.nodeName === 'SPAN';
    };

    var CropType = {
        AUTO: 'auto',
        INITIAL: 'initial',
        MANUAL: 'manual'
    };

    var Rect = ['x', 'y', 'width', 'height'];

    var HopperEvents = ['file-invalid-drop', 'file-invalid', 'file-drop', 'file-over', 'file-out', 'click'];

    var ImageEditorEvents = ['cancel', 'confirm'];

    var SlimButtons = ['remove', 'edit', 'download', 'upload'];

    var SlimPopover = null;
    var SlimCount = 0;

    var SlimLoaderHTML = '\n<div class="slim-loader">\n\t<svg>\n\t\t<path class="slim-loader-background" fill="none" stroke-width="3" />\n\t\t<path class="slim-loader-foreground" fill="none" stroke-width="3" />\n\t</svg>\n</div>\n';

    var SlimUploadStatusHTML = '\n<div class="slim-upload-status"></div>\n';

    var stringToSize = function stringToSize(str) {
        var size = str.split(',');
        return {
            width: parseInt(size[0], 10),
            height: parseInt(size[1], 10)
        };
    };

    var removeTimer = function removeTimer(timers, timer) {
        var i = timers.indexOf(timer);
        timers.splice(i, 1);
    };

    var Slim = function () {
        function Slim(element) {
            var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

            _classCallCheck(this, Slim);

            if (!SlimPopover) {
                SlimPopover = new Popover();
            }

            this._uid = SlimCount++;

            this._options = mergeOptions(Slim.options(), options);

            if (this._options.forceSize) {
                if (typeof this._options.forceSize === 'string') {
                    this._options.forceSize = stringToSize(this._options.forceSize);
                }
                this._options.ratio = this._options.forceSize.width + ':' + this._options.forceSize.height;
                this._options.size = clone(this._options.forceSize);
            }

            if (typeof this._options.size === 'string') {
                this._options.size = stringToSize(this._options.size);
            }

            if (typeof this._options.minSize === 'string') {
                this._options.minSize = stringToSize(this._options.minSize);
            }

            if (typeof this._options.post === 'string') {
                this._options.post = this._options.post.split(',').map(function (part) {
                    return part.trim();
                });
            }

            this._originalElement = element;
            this._originalElementInner = element.innerHTML;
            this._originalElementAttributes = getElementAttributes(element);

            if (!isWrapper(element)) {
                this._element = wrap(element);
                this._element.className = element.className;
                element.className = '';

                this._element.setAttribute('data-ratio', this._options.ratio);
            } else {
                this._element = element;
            }
            this._element.classList.add('slim');
            this._element.setAttribute('data-state', 'init');

            this._state = [];

            this._timers = [];

            this._input = null;

            this._inputReference = null;

            this._output = null;

            this._ratio = null;

            this._isRequired = false;

            this._imageHopper = null;
            this._imageEditor = null;

            this._progressEnabled = true;

            this._data = {};
            this._resetData();

            this._drip = null;

            this._hasInitialImage = false;

            this._initialCrop = this._options.crop;

            this._initialRotation = this._options.rotation && this._options.rotation % 90 === 0 ? this._options.rotation : null;

            this._isBeingDestroyed = false;

            if (!Slim.supported) {
                this._fallback();
            } else {
                this._init();
            }
        }

        _createClass(Slim, [{
            key: 'setRotation',
            value: function setRotation(rotation, callback) {
                if (typeof rotation !== 'number' && rotation % 90 !== 0) {
                    return;
                }

                this._data.actions.rotation = rotation;
                var isTilted = this._data.actions.rotation % 180 !== 0;

                if (this._data.input.image) {
                    var w = isTilted ? this._data.input.image.height : this._data.input.image.width;
                    var h = isTilted ? this._data.input.image.width : this._data.input.image.height;
                    this._data.actions.crop = getAutoCropRect(w, h, this._ratio);
                    this._data.actions.crop.type = CropType.AUTO;
                }

                if (this._data.input.image && callback) {
                    this._manualTransform(callback);
                }
            }
        }, {
            key: 'setSize',
            value: function setSize(dimensions, callback) {
                if (typeof dimensions === 'string') {
                    dimensions = stringToSize(dimensions);
                }

                if (!dimensions || !dimensions.width || !dimensions.height) {
                    return;
                }

                this._options.size = clone(dimensions);
                this._data.actions.size = clone(dimensions);

                if (this._data.input.image && callback) {
                    this._manualTransform(callback);
                }
            }
        }, {
            key: 'setForceSize',
            value: function setForceSize(dimensions, callback) {
                if (typeof dimensions === 'string') {
                    dimensions = stringToSize(dimensions);
                }

                if (!dimensions || !dimensions.width || !dimensions.height) {
                    return;
                }

                this._options.size = clone(dimensions);
                this._options.forceSize = clone(dimensions);
                this._data.actions.size = clone(dimensions);

                this.setRatio(this._options.forceSize.width + ':' + this._options.forceSize.height, callback);
            }
        }, {
            key: 'setRatio',
            value: function setRatio(ratio, callback) {
                var _this11 = this;

                if (!ratio || typeof ratio !== 'string') {
                    return;
                }

                this._options.ratio = ratio;

                if (this._isFixedRatio()) {

                    var parts = intSplit(this._options.ratio, ':');
                    this._ratio = parts[1] / parts[0];

                    if (this._data.input.image && callback) {
                        this._cropAuto(function (data) {
                            _this11._scaleDropArea(_this11._ratio);
                            if (callback) {
                                callback(data);
                            }
                        });
                    } else {
                        if (this._data.input.image) {
                            this._data.actions.crop = getAutoCropRect(this._data.input.image.width, this._data.input.image.height, this._ratio);
                            this._data.actions.crop.type = CropType.AUTO;
                        }

                        this._scaleDropArea(this._ratio);

                        if (callback) {
                            callback(null);
                        }
                    }
                }
            }

        }, {
            key: 'isAttachedTo',
            value: function isAttachedTo(element) {
                return this._element === element || this._originalElement === element;
            }
        }, {
            key: 'isDetached',
            value: function isDetached() {
                return this._element.parentNode === null;
            }
        }, {
            key: 'load',
            value: function load(src) {
                var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var callback = arguments[2];

                if (typeof options === 'function') {
                    callback = options;
                } else {
                    this._options.crop = options.crop;

                    this._options.rotation = options.rotation;

                    this._initialRotation = options.rotation && options.rotation % 90 === 0 ? options.rotation : null;

                    this._initialCrop = this._options.crop;
                }

                this._load(src, callback, { blockPush: options.blockPush });
            }
        }, {
            key: 'upload',
            value: function upload(callback) {
                this._doUpload(callback);
            }
        }, {
            key: 'download',
            value: function download() {
                this._doDownload();
            }
        }, {
            key: 'remove',
            value: function remove() {
                return this._doRemove();
            }
        }, {
            key: 'destroy',
            value: function destroy() {
                this._doDestroy();
            }
        }, {
            key: 'edit',
            value: function edit() {
                this._doEdit();
            }
        }, {
            key: 'crop',
            value: function crop(rect, callback) {
                this._crop(rect.x, rect.y, rect.width, rect.height, callback);
            }
        }, {
            key: 'containsImage',
            value: function containsImage() {
                return this._data.input.name !== null;
            }

        }, {
            key: '_canInstantEdit',
            value: function _canInstantEdit() {
                return this._options.instantEdit && !this._isInitialising;
            }
        }, {
            key: '_getFileInput',
            value: function _getFileInput() {
                return this._element.querySelector('input[type=file]');
            }
        }, {
            key: '_getInitialImage',
            value: function _getInitialImage() {
                return this._element.querySelector('img');
            }
        }, {
            key: '_getInputElement',
            value: function _getInputElement() {
                return this._getFileInput() || this._getInitialImage();
            }
        }, {
            key: '_getRatioSpacerElement',
            value: function _getRatioSpacerElement() {
                return this._element.children[0];
            }
        }, {
            key: '_isImageOnly',
            value: function _isImageOnly() {
                return this._input.nodeName !== 'INPUT';
            }
        }, {
            key: '_isFixedRatio',
            value: function _isFixedRatio() {
                return this._options.ratio.indexOf(':') !== -1;
            }
        }, {
            key: '_isAutoCrop',
            value: function _isAutoCrop() {
                return this._data.actions.crop.type === CropType.AUTO;
            }
        }, {
            key: '_toggleButton',
            value: function _toggleButton(action, state) {
                toggleDisplayBySelector('.slim-btn[data-action="' + action + '"]', state, this._element);
            }
        }, {
            key: '_clearState',
            value: function _clearState() {
                this._state = [];
                this._updateState();
            }
        }, {
            key: '_removeState',
            value: function _removeState(state) {
                this._state = this._state.filter(function (item) {
                    return item !== state;
                });
                this._updateState();
            }
        }, {
            key: '_addState',
            value: function _addState(state) {
                if (inArray(state, this._state)) {
                    return;
                }
                this._state.push(state);
                this._updateState();
            }
        }, {
            key: '_updateState',
            value: function _updateState() {
                if (!this._element) {
                    return;
                }
                this._element.setAttribute('data-state', this._state.join(','));
            }
        }, {
            key: '_resetData',
            value: function _resetData() {

                if (this._data.input && this._data.output) {
                    var inputImage = this._data.input.image;
                    var outputImage = this._data.output.image;
                    if (inputImage && inputImage.nodeName === 'CANVAS') {
                        releaseCanvas(inputImage);
                    }
                    if (outputImage && outputImage.nodeName === 'CANVAS') {
                        releaseCanvas(outputImage);
                    }
                }

                this._data = {
                    server: null,
                    meta: clone(this._options.meta),
                    input: {
                        field: this._inputReference,
                        name: null,
                        type: null,
                        width: 0,
                        height: 0,
                        file: null
                    },
                    output: {
                        image: null,
                        width: 0,
                        height: 0
                    },
                    actions: {
                        rotation: null,
                        crop: null,
                        size: null
                    }
                };

                if (this._output) {
                    this._output.value = '';
                }

                resetFileInput(this._getFileInput());
            }

        }, {
            key: '_init',
            value: function _init() {
                var _this12 = this;

                this._isInitialising = true;

                this._addState('empty');

                if (inArray('input', this._options.post)) {
                    this._inputReference = 'slim_input_' + this._uid;
                }

                this._input = this._getInputElement();

                if (!this._input) {
                    this._input = create('input');
                    this._input.type = 'file';
                    this._element.appendChild(this._input);
                }

                this._isRequired = this._input.required === true;

                this._output = this._element.querySelector('input[type=hidden]');

                if (!this._output) {
                    this._output = create('input');
                    this._output.type = 'hidden';
                    this._output.name = this._input.name || this._options.defaultInputName;
                    this._element.appendChild(this._output);
                } else {
                    var initialData = null;
                    try {
                        initialData = JSON.parse(this._output.value);
                    } catch (e) {}
                    if (initialData) {
                        var img = new Image();
                        img.src = initialData.output.image;
                        img.setAttribute('data-filename', initialData.output.name);
                        this._element.insertBefore(img, this._element.firstChild);
                    }
                }

                this._input.removeAttribute('name');

                var area = create('div', 'slim-area');

                var initialImage = this._getInitialImage();
                var initialImageSrc = (initialImage || {}).src;
                var initialImageName = initialImage ? initialImage.getAttribute('data-filename') : null;

                if (initialImageSrc) {
                    this._hasInitialImage = true;
                } else {
                    this._initialCrop = null;
                    this._initialRotation = null;
                }

                var resultHTML = '\n\t\t<div class="slim-result">\n\t\t\t<img class="in" style="opacity:0" ' + (initialImageSrc ? 'src="' + initialImageSrc + '"' : '') + '><img><img style="opacity:0">\n\t\t</div>';

                if (this._isImageOnly()) {
                    area.innerHTML = '\n\t\t\t\t' + SlimLoaderHTML + '\n\t\t\t\t' + SlimUploadStatusHTML + '\n\t\t\t\t' + resultHTML + '\n\t\t\t\t<div class="slim-status"><div class="slim-label-loading">' + (this._options.labelLoading || '') + '</div></div>\n\t\t\t';
                } else {
                    if (inArray('input', this._options.post)) {
                        this._data.input.field = this._inputReference;

                        if (!this._options.service) {
                            this._input.name = this._inputReference;
                        }
                    }

                    var mimetypes = void 0;
                    if (!this._input.hasAttribute('accept') || this._input.getAttribute('accept') === 'image/*') {
                        mimetypes = getCommonMimeTypes();
                        this._input.setAttribute('accept', mimetypes.join(','));
                    } else {
                        mimetypes = this._input.accept.split(',').map(function (mimetype) {
                            return mimetype.trim();
                        }).filter(function (mimetype) {
                            return mimetype.length > 0;
                        });
                    }

                    this._imageHopper = new FileHopper();
                    this._imageHopper.accept = mimetypes;
                    this._imageHopper.allowURLs = typeof this._options.fetcher === 'string';
                    this._element.appendChild(this._imageHopper.element);
                    HopperEvents.forEach(function (e) {
                        _this12._imageHopper.element.addEventListener(e, _this12);
                    });

                    area.innerHTML = '\n\t\t\t\t' + SlimLoaderHTML + '\n\t\t\t\t' + SlimUploadStatusHTML + '\n\t\t\t\t<div class="slim-drip"><span><span></span></span></div>\n\t\t\t\t<div class="slim-status"><div class="slim-label">' + (this._options.label || '') + '</div><div class="slim-label-loading">' + (this._options.labelLoading || '') + '</div></div>\n\t\t\t\t' + resultHTML + '\n\t\t\t';

                    this._input.addEventListener('change', this);
                }

                this._element.appendChild(area);

                this._btnGroup = create('div', 'slim-btn-group');
                this._btnGroup.style.display = 'none';
                this._element.appendChild(this._btnGroup);
                SlimButtons.filter(function (c) {
                    return _this12._isButtonAllowed(c);
                }).forEach(function (c) {
                    var prop = capitalizeFirstLetter(c);
                    var label = _this12._options['button' + prop + 'Label'];
                    var title = _this12._options['button' + prop + 'Title'] || label;
                    var className = _this12._options['button' + prop + 'ClassName'];
                    var btn = create('button', 'slim-btn slim-btn-' + c + (className ? ' ' + className : ''));
                    btn.innerHTML = label;
                    btn.title = title;
                    btn.type = 'button';
                    btn.addEventListener('click', _this12);
                    btn.setAttribute('data-action', c);
                    _this12._btnGroup.appendChild(btn);
                });

                if (this._isFixedRatio()) {
                    var parts = intSplit(this._options.ratio, ':');
                    this._ratio = parts[1] / parts[0];
                    this._scaleDropArea(this._ratio);
                }

                this._updateProgress(0.5);

                if (initialImageSrc) {
                    this._load(initialImageSrc, function () {
                        _this12._onInit();
                    }, { name: initialImageName });
                } else {
                    this._onInit();
                }
            }
        }, {
            key: '_onInit',
            value: function _onInit() {
                var _this13 = this;

                this._isInitialising = false;

                var done = function done() {
                    var timer = setTimeout(function () {
                        removeTimer(_this13._timers, timer);
                        _this13._options.didInit.apply(_this13, [_this13.data, _this13]);
                    }, 0);
                    _this13._timers.push(timer);
                };

                if (this._options.saveInitialImage && this.containsImage()) {
                    if (!this._options.service) {
                        this._save(function () {
                            done();
                        }, false);
                    }
                } else {
                    if (this._options.service && this.containsImage()) {
                        this._toggleButton('upload', false);
                    }

                    done();
                }
            }
        }, {
            key: '_updateProgress',
            value: function _updateProgress(progress) {
                progress = Math.min(0.99999, progress);

                if (!this._element) {
                    return;
                }

                if (!this._progressEnabled) {
                    return;
                }

                var loader = this._element.querySelector('.slim-loader');
                if (!loader) {
                    return;
                }

                var size = loader.offsetWidth;
                var paths = loader.querySelectorAll('path');
                var ringWidth = parseInt(paths[0].getAttribute('stroke-width'), 10);

                if (size * .5 < ringWidth) {
                    return;
                }

                paths[0].setAttribute('d', percentageArc(size * 0.5, size * 0.5, size * 0.5 - ringWidth, 0.9999));

                paths[1].setAttribute('d', percentageArc(size * 0.5, size * 0.5, size * 0.5 - ringWidth, progress));
            }
        }, {
            key: '_startProgress',
            value: function _startProgress(cb) {
                var _this14 = this;

                if (!this._element) {
                    return;
                }

                this._progressEnabled = false;

                var loader = this._element.querySelector('.slim-loader');
                if (!loader) {
                    return;
                }
                var ring = loader.children[0];

                this._stopProgressLoop(function () {
                    loader.removeAttribute('style');
                    ring.removeAttribute('style');

                    _this14._progressEnabled = true;

                    _this14._updateProgress(0);

                    _this14._progressEnabled = false;

                    snabbt(ring, {
                        fromOpacity: 0,
                        opacity: 1,
                        duration: 250,
                        complete: function complete() {
                            _this14._progressEnabled = true;
                            if (cb) {
                                cb();
                            }
                        }
                    });
                });
            }
        }, {
            key: '_stopProgress',
            value: function _stopProgress() {
                var _this15 = this;

                if (!this._element) {
                    return;
                }

                var loader = this._element.querySelector('.slim-loader');
                if (!loader) {
                    return;
                }
                var ring = loader.children[0];

                this._updateProgress(1);

                snabbt(ring, {
                    fromOpacity: 1,
                    opacity: 0,
                    duration: 250,
                    complete: function complete() {
                        loader.removeAttribute('style');
                        ring.removeAttribute('style');

                        _this15._updateProgress(0.5);

                        _this15._progressEnabled = false;
                    }
                });
            }
        }, {
            key: '_startProgressLoop',
            value: function _startProgressLoop() {
                if (!this._element) {
                    return;
                }

                var loader = this._element.querySelector('.slim-loader');
                if (!loader) {
                    return;
                }

                var ring = loader.children[0];
                loader.removeAttribute('style');
                ring.removeAttribute('style');

                this._updateProgress(0.5);

                var repeat = 1000;

                snabbt(loader, 'stop');

                snabbt(loader, {
                    rotation: [0, 0, -(Math.PI * 2) * repeat],
                    easing: 'linear',
                    duration: repeat * 1000
                });

                snabbt(ring, {
                    fromOpacity: 0,
                    opacity: 1,
                    duration: 250
                });
            }
        }, {
            key: '_stopProgressLoop',
            value: function _stopProgressLoop(callback) {
                if (!this._element) {
                    return;
                }

                var loader = this._element.querySelector('.slim-loader');
                if (!loader) {
                    return;
                }

                var ring = loader.children[0];

                snabbt(ring, {
                    fromOpacity: parseFloat(ring.style.opacity),
                    opacity: 0,
                    duration: 250,
                    complete: function complete() {
                        snabbt(loader, 'stop');

                        loader.removeAttribute('style');
                        ring.removeAttribute('style');

                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        }, {
            key: '_isButtonAllowed',
            value: function _isButtonAllowed(button) {
                if (button === 'edit') {
                    return this._options.edit;
                }

                if (button === 'download') {
                    return this._options.download;
                }

                if (button === 'upload') {
                    if (!this._options.service) {
                        return false;
                    }

                    if (this._options.push) {
                        return false;
                    }

                    return true;
                }

                if (button === 'remove') {
                    return !this._isImageOnly();
                }

                return true;
            }
        }, {
            key: '_fallback',
            value: function _fallback() {
                var area = create('div', 'slim-area');
                area.innerHTML = '\n\t\t\t<div class="slim-status"><div class="slim-label">' + (this._options.label || '') + '</div></div>\n\t\t';
                this._element.appendChild(area);

                this._throwError(this._options.statusNoSupport);
            }

        }, {
            key: 'handleEvent',
            value: function handleEvent(e) {
                switch (e.type) {
                    case 'click':
                        this._onClick(e);
                        break;
                    case 'change':
                        this._onChange(e);
                        break;
                    case 'cancel':
                        this._onCancel(e);
                        break;
                    case 'confirm':
                        this._onConfirm(e);
                        break;
                    case 'file-over':
                        this._onFileOver(e);
                        break;
                    case 'file-out':
                        this._onFileOut(e);
                        break;
                    case 'file-drop':
                        this._onDropFile(e);
                        break;
                    case 'file-invalid':
                        this._onInvalidFile(e);
                        break;
                    case 'file-invalid-drop':
                        this._onInvalidFileDrop(e);
                        break;
                }
            }
        }, {
            key: '_getIntro',
            value: function _getIntro() {
                return this._element.querySelector('.slim-result .in');
            }
        }, {
            key: '_getOutro',
            value: function _getOutro() {
                return this._element.querySelector('.slim-result .out');
            }
        }, {
            key: '_getInOut',
            value: function _getInOut() {
                return this._element.querySelectorAll('.slim-result img');
            }
        }, {
            key: '_getDrip',
            value: function _getDrip() {
                if (!this._drip) {
                    this._drip = this._element.querySelector('.slim-drip > span');
                }
                return this._drip;
            }

        }, {
            key: '_throwError',
            value: function _throwError(error) {
                this._addState('error');

                this._element.querySelector('.slim-label').style.display = 'none';

                var node = this._element.querySelector('.slim-error');
                if (!node) {
                    node = create('div', 'slim-error');
                    this._element.querySelector('.slim-status').appendChild(node);
                }

                node.innerHTML = error;

                this._options.didThrowError.apply(this, [error]);
            }
        }, {
            key: '_removeError',
            value: function _removeError() {
                this._removeState('error');
                this._element.querySelector('.slim-label').style.display = '';

                var error = this._element.querySelector('.slim-error');
                if (error) {
                    error.parentNode.removeChild(error);
                }
            }
        }, {
            key: '_openFileDialog',
            value: function _openFileDialog() {
                this._removeError();
                this._input.click();
            }

        }, {
            key: '_onClick',
            value: function _onClick(e) {
                var _this16 = this;

                var list = e.target.classList;
                var target = e.target;

                if (list.contains('slim-file-hopper')) {
                    e.preventDefault();
                    this._openFileDialog();
                    return;
                }

                switch (target.getAttribute('data-action')) {
                    case 'remove':
                        this._options.willRemove.apply(this, [this.data, function () {
                            _this16._doRemove();
                        }]);
                        break;
                    case 'edit':
                        this._doEdit();
                        break;
                    case 'download':
                        this._doDownload();
                        break;
                    case 'upload':
                        this._doUpload();
                        break;
                }
            }
        }, {
            key: '_onInvalidFileDrop',
            value: function _onInvalidFileDrop() {
                this._onInvalidFile();

                this._removeState('file-over');

                var drip = this._getDrip();
                snabbt(drip.firstChild, {
                    fromScale: [0.5, 0.5],
                    scale: [0, 0],
                    fromOpacity: 0.5,
                    opacity: 0,
                    duration: 150,
                    complete: function complete() {
                        resetTransforms(drip.firstChild);
                    }
                });
            }
        }, {
            key: '_onInvalidFile',
            value: function _onInvalidFile() {
                var types = this._imageHopper.accept.map(getExtensionByMimeType);
                var error = this._options.statusFileType.replace('$0', types.join(', '));
                this._throwError(error);
            }
        }, {
            key: '_onImageTooSmall',
            value: function _onImageTooSmall() {
                var error = this._options.statusImageTooSmall.replace('$0', this._options.minSize.width + ' \xD7 ' + this._options.minSize.height);
                this._throwError(error);
            }
        }, {
            key: '_onOverWeightFile',
            value: function _onOverWeightFile() {
                var error = this._options.statusFileSize.replace('$0', this._options.maxFileSize);
                this._throwError(error);
            }
        }, {
            key: '_onLocalURLProblem',
            value: function _onLocalURLProblem(error) {
                this._throwError(this._options.statusLocalUrlProblem || error);
            }
        }, {
            key: '_onRemoteURLProblem',
            value: function _onRemoteURLProblem(error) {
                this._throwError(error);
            }
        }, {
            key: '_onFileOver',
            value: function _onFileOver(e) {
                this._addState('file-over');
                this._removeError();

                var drip = this._getDrip();

                var matrix = snabbt.createMatrix();
                matrix.translate(e.detail.x, e.detail.y, 0);
                snabbt.setElementTransform(drip, matrix);

                if (this._imageHopper.dragPath.length == 1) {
                    drip.style.opacity = 1;

                    snabbt(drip.firstChild, {
                        fromOpacity: 0,
                        opacity: 0.5,
                        fromScale: [0, 0],
                        scale: [0.5, 0.5],
                        duration: 150
                    });
                }
            }
        }, {
            key: '_onFileOut',
            value: function _onFileOut(e) {
                this._removeState('file-over');
                this._removeState('file-invalid');
                this._removeError();

                var drip = this._getDrip();
                var matrix = snabbt.createMatrix();
                matrix.translate(e.detail.x, e.detail.y, 0);
                snabbt.setElementTransform(drip, matrix);

                snabbt(drip.firstChild, {
                    fromScale: [0.5, 0.5],
                    scale: [0, 0],
                    fromOpacity: 0.5,
                    opacity: 0,
                    duration: 150,
                    complete: function complete() {
                        resetTransforms(drip.firstChild);
                    }
                });
            }

        }, {
            key: '_onDropFile',
            value: function _onDropFile(e) {
                var _this17 = this;

                this._removeState('file-over');

                var drip = this._getDrip();
                var matrix = snabbt.createMatrix();
                matrix.translate(e.detail.x, e.detail.y, 0);
                snabbt.setElementTransform(drip, matrix);

                var l = this._imageHopper.dragPath.length;
                var jump = this._imageHopper.dragPath[l - Math.min(10, l)];

                var dx = e.detail.x - jump.x;
                var dy = e.detail.y - jump.y;

                snabbt(drip, {
                    fromPosition: [e.detail.x, e.detail.y, 0],
                    position: [e.detail.x + dx, e.detail.y + dy, 0],
                    duration: 200
                });

                snabbt(drip.firstChild, {
                    fromScale: [0.5, 0.5],
                    scale: [2, 2],
                    fromOpacity: 1,
                    opacity: 0,
                    duration: 200,

                    complete: function complete() {
                        resetTransforms(drip.firstChild);

                        _this17._load(e.target.files[0]);
                    }
                });
            }

        }, {
            key: '_onChange',
            value: function _onChange(e) {
                if (e.target.files.length) {
                    this._load(e.target.files[0]);
                }
            }

        }, {
            key: '_load',
            value: function _load(resource, callback) {
                var _this18 = this;

                var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

                if (this._isBeingDestroyed) {
                    return;
                }

                if (this.containsImage()) {
                    clearTimeout(this._replaceTimeout);

                    this._doRemove(function () {
                        _this18._replaceTimeout = setTimeout(function () {
                            _this18._load(resource, callback, options);
                        }, 100);
                    });

                    return;
                }

                this._removeState('empty');
                this._addState('busy');

                this._startProgressLoop();

                if (this._imageHopper) {
                    this._imageHopper.enabled = false;
                }

                clearTimeout(this._loadTimeout);
                var load = function load() {
                    clearTimeout(_this18._loadTimeout);
                    _this18._loadTimeout = setTimeout(function () {
                        if (_this18._isBeingDestroyed) {
                            return;
                        }

                        _this18._addState('loading');

                        snabbt(_this18._element.querySelector('.slim-label-loading'), {
                            fromOpacity: 0,
                            opacity: 1,
                            duration: 250
                        });
                    }, 500);
                };

                var exit = function exit() {
                    if (_this18._imageHopper) {
                        _this18._imageHopper.enabled = true;
                    }
                    _this18._removeState('loading');
                    _this18._removeState('busy');
                    _this18._addState('empty');
                    _this18._stopProgressLoop();
                };

                if (typeof resource === 'string') {
                    if (resourceIsBase64Data(resource)) {
                        this._load(base64ToBlob(resource), callback, options);
                    } else {
                        load();

                        loadURL(resource, this._options.willLoad, function (file) {
                            _this18._load(file, callback, options);
                        }, function (error) {

                            setTimeout(function () {

                                exit();

                                _this18._onLocalURLProblem('<p>' + error + '</p>');

                                if (callback) {
                                    callback.apply(_this18, ['local-url-problem']);
                                }
                            }, 500);
                        });
                    }

                    return;
                } else if (typeof resource.remote !== 'undefined') {
                    if (resourceIsBase64Data(resource.remote)) {
                        this._load(base64ToBlob(resource.remote), callback, options);
                        return;
                    }

                    if (this._options.fetcher) {
                        loadRemoteURL(this._options.fetcher, this._options.willFetch, this._options.willLoad, resource.remote, function (error) {
                            exit();

                            _this18._onRemoteURLProblem('<p>' + error + '</p>');

                            if (callback) {
                                callback.apply(_this18, ['remote-url-problem']);
                            }
                        }, function (file) {
                            _this18._load(file, callback, options);
                        });
                    }

                    return;
                }

                var file = resource;

                if (this._imageHopper && this._imageHopper.accept.indexOf(file.type) === -1) {
                    exit();

                    this._onInvalidFile();
                    if (callback) {
                        callback.apply(this, ['file-invalid']);
                    }
                    return;
                }

                if (file.size && this._options.maxFileSize && bytesToMegaBytes(file.size) > this._options.maxFileSize) {
                    exit();

                    this._onOverWeightFile();
                    if (callback) {
                        callback.apply(this, ['file-too-big']);
                    }
                    return;
                }

                if (this._imageEditor) {
                    this._imageEditor.dirty();
                }

                this._data.input.name = options && options.name ? options.name : getFileNameByFile(file);
                this._data.input.type = getFileTypeByFile(file);
                this._data.input.size = file.size;
                this._data.input.file = file;

                var internalCanvasSize = this._options.internalCanvasSize;
                if (isLowMemoryDevice()) {
                    internalCanvasSize = this._options.internalCanvasSizeLowMemory;
                }

                getImageAsCanvas(file, internalCanvasSize, function (image, meta) {

                    var rewind = function rewind() {
                        if (_this18._imageHopper) {
                            _this18._imageHopper.enabled = true;
                        }

                        _this18._removeState('loading');
                        _this18._removeState('busy');
                        _this18._addState('empty');
                        _this18._stopProgressLoop();
                        _this18._resetData();
                    };

                    if (!image) {
                        rewind();

                        if (callback) {
                            callback.apply(_this18, ['file-not-found']);
                        }

                        return;
                    }

                    if (!covers(image, _this18._options.minSize)) {
                        rewind();

                        _this18._onImageTooSmall();

                        if (callback) {
                            callback.apply(_this18, ['image-too-small']);
                        }

                        return;
                    }

                    var status = _this18._options.didLoad.apply(_this18, [file, image, meta, _this18]);

                    if (status !== true) {
                        rewind();

                        if (status !== false) {
                            _this18._throwError(status);
                        }

                        if (callback) {
                            callback.apply(_this18, [status]);
                        }

                        return;
                    }

                    _this18._removeState('loading');

                    var revealCanvas = function revealCanvas(done) {
                        if (_this18._imageHopper && _this18._options.dropReplace) {
                            _this18._imageHopper.enabled = true;
                        }

                        var intro = _this18._getIntro();

                        var animation = {
                            fromScale: [1.25, 1.25],
                            scale: [1, 1],
                            fromOpacity: 0,
                            opacity: 1,
                            complete: function complete() {
                                resetTransforms(intro);

                                intro.style.opacity = 1;

                                done();
                            }
                        };

                        if (_this18.isDetached()) {
                            animation.duration = 1;
                        } else {
                            animation.easing = 'spring';
                            animation.springConstant = 0.3;
                            animation.springDeceleration = 0.7;
                        }

                        if (_this18._canInstantEdit()) {
                            animation.delay = 500;
                            animation.duration = 1;

                            _this18._doEdit();
                        }

                        snabbt(intro, animation);
                    };

                    _this18._options.willLoadCanvas.apply(_this18, [image, function (imageOut) {
                        _this18._loadCanvas(imageOut, function (isUploading) {
                            _this18._addState('preview');

                            revealCanvas(function () {
                                if (!_this18._canInstantEdit() && !isUploading) {
                                    _this18._showButtons();
                                }

                                if (!isUploading) {
                                    _this18._stopProgressLoop();
                                    _this18._removeState('busy');
                                }

                                if (callback) {
                                    callback.apply(_this18, [null, _this18.data]);
                                }
                            });
                        }, function () {
                            if (!_this18._canInstantEdit()) {
                                _this18._showButtons();
                            }

                            _this18._removeState('busy');
                        }, {
                            blockPush: options.blockPush
                        });
                    }, _this18]);
                });
            }
        }, {
            key: '_loadCanvas',
            value: function _loadCanvas(image, ready, complete, options) {
                var _this19 = this;

                if (!options) {
                    options = {};
                }

                if (this._isBeingDestroyed) {
                    return;
                }

                if (isLowMemoryDevice()) {
                    this._data.input.image = new Image();
                    this._data.input.image.src = image.toDataURL();
                } else {
                    this._data.input.image = image;
                }
                this._data.input.width = image.width;
                this._data.input.height = image.height;

                if (this._initialRotation) {
                    this._data.actions.rotation = this._initialRotation;
                    this._initialRotation = null;
                }

                var isTilted = this._data.actions.rotation % 180 !== 0;

                if (!this._isFixedRatio()) {
                    if (this._initialCrop) {
                        this._ratio = this._initialCrop.height / this._initialCrop.width;
                    } else {
                        this._ratio = isTilted ? image.width / image.height : image.height / image.width;
                    }
                    this._scaleDropArea(this._ratio);
                }

                var applyTransforms = function applyTransforms() {
                    if (_this19._options.size) {
                        _this19._data.actions.size = {
                            width: _this19._options.size.width,
                            height: _this19._options.size.height
                        };
                    }

                    _this19._applyTransforms(image, function (transformedImage) {

                        var intro = _this19._getIntro();
                        var scalar = intro.offsetWidth / transformedImage.width;

                        var willUpload = false;

                        if (_this19._options.service && _this19._options.push && !options.blockPush) {
                            if (!_this19._hasInitialImage && !_this19._canInstantEdit()) {
                                willUpload = true;
                                _this19._stopProgressLoop(function () {
                                    _this19._startProgress(function () {
                                        _this19._updateProgress(0.1);
                                    });
                                });
                            }
                        }

                        if (!_this19._canInstantEdit()) {
                            _this19._save(function () {
                                if (_this19._isBeingDestroyed) {
                                    return;
                                }
                                if (willUpload) {
                                    _this19._stopProgress();
                                    complete();
                                }
                            }, willUpload);
                        }

                        var ratio = _this19._options.devicePixelRatio === 'auto' ? window.devicePixelRatio : _this19._options.devicePixelRatio;

                        var introCanvas = cloneCanvasScaled(transformedImage, scalar * ratio);
                        intro.src = '';
                        intro.src = introCanvas.toDataURL();
                        releaseCanvas(introCanvas);
                        introCanvas = null;
                        intro.onload = function () {
                            intro.onload = null;

                            if (_this19._isBeingDestroyed) {
                                return;
                            }

                            if (ready) {
                                ready(willUpload);
                            }
                        };
                    });
                };

                if (this._initialCrop) {
                    this._data.actions.crop = clone(this._initialCrop);
                    this._data.actions.crop.type = CropType.INITIAL;

                    this._initialCrop = null;

                    applyTransforms();
                } else {

                    this._options.willCropInitial.apply(this, [this.data, function (rect) {

                        if (rect) {
                            _this19._data.actions.crop = rect;
                            _this19._data.actions.crop.type = CropType.INITIAL;
                        } else {
                            _this19._data.actions.crop = getAutoCropRect(isTilted ? image.height : image.width, isTilted ? image.width : image.height, _this19._ratio);
                            _this19._data.actions.crop.type = CropType.AUTO;
                        }

                        applyTransforms();
                    }, this]);
                }
            }
        }, {
            key: '_applyTransforms',
            value: function _applyTransforms(image, ready) {
                var _this20 = this;

                if (this._data.output.image) {
                    releaseCanvas(this._data.output.image);
                }

                var actions = clone(this._data.actions);
                actions.filters = {
                    sharpen: this._options.filterSharpen / 100
                };

                if (this._options.forceMinSize) {
                    actions.minSize = this._options.minSize;
                } else {
                    actions.minSize = {
                        width: 0,
                        height: 0
                    };
                }

                transformCanvas(image, actions, function (transformedImage) {
                    var outputImage = transformedImage;

                    if (_this20._options.forceSize || _this20._options.size && sizeDist(_this20._options.size, transformedImage) == 1) {
                        outputImage = create('canvas');
                        outputImage.width = _this20._options.size.width;
                        outputImage.height = _this20._options.size.height;
                        var ctx = outputImage.getContext('2d');
                        ctx.drawImage(transformedImage, 0, 0, _this20._options.size.width, _this20._options.size.height);

                        releaseCanvas(transformedImage);
                    }

                    if (_this20._options.forceMinSize && _this20._options.size && _this20._options.minSize.width === _this20._options.size.width && _this20._options.minSize.height === _this20._options.size.height && (outputImage.width < _this20._options.minSize.width || outputImage.height < _this20._options.minSize.height)) {
                        var w = Math.max(outputImage.width, _this20._options.minSize.width);
                        var h = Math.max(outputImage.height, _this20._options.minSize.height);
                        outputImage = create('canvas');
                        outputImage.width = w;
                        outputImage.height = h;
                        var _ctx = outputImage.getContext('2d');
                        _ctx.drawImage(transformedImage, 0, 0, w, h);

                        releaseCanvas(transformedImage);
                    }

                    if (_this20._options.forceMinSize && _this20._ratio === 1 && (outputImage.width < _this20._options.minSize.width || outputImage.height < _this20._options.minSize.height)) {
                        outputImage = create('canvas');
                        outputImage.width = _this20._options.minSize.width;
                        outputImage.height = _this20._options.minSize.height;
                        var _ctx2 = outputImage.getContext('2d');
                        _ctx2.drawImage(transformedImage, 0, 0, outputImage.width, outputImage.height);

                        releaseCanvas(transformedImage);
                    }

                    _this20._data.output.width = outputImage.width;
                    _this20._data.output.height = outputImage.height;
                    _this20._data.output.image = outputImage;

                    _this20._onTransformCanvas(function (transformedData) {
                        _this20._data = transformedData;
                        _this20._options.didTransform.apply(_this20, [_this20.data, _this20]);
                        ready(_this20._data.output.image);
                    });
                });
            }
        }, {
            key: '_onTransformCanvas',
            value: function _onTransformCanvas(ready) {
                this._options.willTransform.apply(this, [this.data, ready, this]);
            }

        }, {
            key: '_appendEditor',
            value: function _appendEditor() {
                var _this21 = this;

                if (this._imageEditor) {
                    return;
                }

                this._imageEditor = new ImageEditor(create('div'), {
                    minSize: this._options.minSize,
                    devicePixelRatio: this._options.devicePixelRatio,

                    buttonConfirmClassName: this._options.buttonConfirmClassName,
                    buttonCancelClassName: this._options.buttonCancelClassName,
                    buttonRotateClassName: this._options.buttonRotateClassName,

                    buttonConfirmLabel: this._options.buttonConfirmLabel,
                    buttonCancelLabel: this._options.buttonCancelLabel,
                    buttonRotateLabel: this._options.buttonRotateLabel,

                    buttonConfirmTitle: this._options.buttonConfirmTitle,
                    buttonCancelTitle: this._options.buttonCancelTitle,
                    buttonRotateTitle: this._options.buttonRotateTitle
                });

                ImageEditorEvents.forEach(function (e) {
                    _this21._imageEditor.element.addEventListener(e, _this21);
                });
            }
        }, {
            key: '_scaleDropArea',
            value: function _scaleDropArea(ratio) {
                var node = this._getRatioSpacerElement();
                if (!node || !this._element) {
                    return;
                }
                node.style.marginBottom = ratio * 100 + '%';
                this._element.setAttribute('data-ratio', '1:' + ratio);
            }

        }, {
            key: '_onCancel',
            value: function _onCancel(e) {
                this._removeState('editor');

                this._options.didCancel.apply(this, [this]);

                this._showButtons();

                this._hideEditor();

                if (this._options.instantEdit && !this._hasInitialImage && this._isAutoCrop()) {
                    this._doRemove();
                }
            }

        }, {
            key: '_onConfirm',
            value: function _onConfirm(e) {
                var _this22 = this;

                var willUpload = this._options.service && this._options.push;
                if (willUpload) {
                    this._startProgress(function () {
                        _this22._updateProgress(0.1);
                    });
                } else {
                    this._startProgressLoop();
                }

                this._removeState('editor');

                this._addState('busy');

                this._output.value = '';

                this._data.actions.rotation = e.detail.rotation;
                this._data.actions.crop = e.detail.crop;
                this._data.actions.crop.type = CropType.MANUAL;

                this._applyTransforms(this._data.input.image, function (transformedImage) {
                    _this22._options.didConfirm.apply(_this22, [_this22.data, _this22]);

                    var images = _this22._getInOut();
                    var intro = images[0].className === 'out' ? images[0] : images[1];
                    var outro = intro === images[0] ? images[1] : images[0];

                    intro.className = 'in';
                    intro.style.opacity = '0';
                    intro.style.zIndex = '2';
                    outro.className = 'out';
                    outro.style.zIndex = '1';

                    var ratio = _this22._options.devicePixelRatio === 'auto' ? window.devicePixelRatio : _this22._options.devicePixelRatio;

                    var introCanvas = cloneCanvasScaled(transformedImage, intro.offsetWidth / transformedImage.width * ratio);
                    intro.src = '';
                    intro.src = introCanvas.toDataURL();
                    releaseCanvas(introCanvas);
                    introCanvas = null;
                    intro.onload = function () {
                        intro.onload = null;

                        if (_this22._options.ratio === 'free') {
                            _this22._ratio = intro.naturalHeight / intro.naturalWidth;
                            _this22._scaleDropArea(_this22._ratio);
                        }

                        _this22._hideEditor();

                        var timer = setTimeout(function () {

                            removeTimer(_this22._timers, timer);

                            _this22._showPreview(intro, function () {
                                _this22._save(function (err, data, res) {
                                    _this22._toggleButton('upload', true);

                                    if (willUpload) {
                                        _this22._stopProgress();
                                    } else {
                                        _this22._stopProgressLoop();
                                    }

                                    _this22._removeState('busy');

                                    _this22._showButtons();
                                }, willUpload);
                            });
                        }, 250);

                        _this22._timers.push(timer);
                    };
                });
            }
        }, {
            key: '_cropAuto',
            value: function _cropAuto() {
                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function (data) {};

                var isTilted = this._data.actions.rotation % 180 !== 0;

                var rect = getAutoCropRect(isTilted ? this._data.input.image.height : this._data.input.image.width, isTilted ? this._data.input.image.width : this._data.input.image.height, this._ratio);

                this._crop(rect.x, rect.y, rect.width, rect.height, callback, CropType.AUTO);
            }
        }, {
            key: '_crop',
            value: function _crop(x, y, width, height) {
                var callback = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function (data) {};
                var cropType = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : CropType.MANUAL;

                this._output.value = '';

                this._data.actions.crop = {
                    x: x,
                    y: y,
                    width: width,
                    height: height
                };
                this._data.actions.crop.type = cropType;

                this._manualTransform(callback);
            }
        }, {
            key: '_manualTransform',
            value: function _manualTransform(callback) {
                var _this23 = this;

                this._startProgressLoop();
                this._addState('busy');

                this._applyTransforms(this._data.input.image, function (transformedImage) {
                    var images = _this23._getInOut();
                    var intro = images[0].className === 'out' ? images[0] : images[1];
                    var outro = intro === images[0] ? images[1] : images[0];

                    intro.className = 'in';
                    intro.style.opacity = '1';
                    intro.style.zIndex = '2';
                    outro.className = 'out';
                    outro.style.zIndex = '0';

                    var pixelRatio = _this23._options.devicePixelRatio === 'auto' ? window.devicePixelRatio : _this23._options.devicePixelRatio;

                    var introCanvas = cloneCanvasScaled(transformedImage, intro.offsetWidth / transformedImage.width * pixelRatio);
                    intro.src = '';
                    intro.src = introCanvas.toDataURL();
                    releaseCanvas(introCanvas);
                    introCanvas = null;
                    intro.onload = function () {
                        intro.onload = null;

                        if (_this23._options.ratio === 'free') {
                            _this23._ratio = intro.naturalHeight / intro.naturalWidth;
                            _this23._scaleDropArea(_this23._ratio);
                        }

                        var willUpload = _this23._options.service && _this23._options.push;

                        var save = function save() {
                            _this23._save(function (err, data, res) {
                                if (!willUpload) {
                                    _this23._stopProgressLoop();
                                }

                                _this23._removeState('busy');

                                callback.apply(_this23, [_this23.data]);
                            }, willUpload);
                        };

                        if (willUpload) {
                            _this23._startProgress(save);
                        } else {
                            save();
                        }
                    };
                });
            }
        }, {
            key: '_save',
            value: function _save() {
                var _this24 = this;

                var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
                var allowUpload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

                if (this._isBeingDestroyed) {
                    return;
                }

                var data = this.dataBase64;

                if (!this._options.service && !(this._isInitialising && !this._isImageOnly())) {
                    this._options.willSave.apply(this, [data, function (data) {
                        _this24._store(data);

                        _this24._options.didSave.apply(_this24, [data, _this24]);
                    }, this]);
                }

                if (this._isBeingDestroyed) {
                    return;
                }

                if (this._options.service && allowUpload) {
                    this._options.willSave.apply(this, [data, function (data) {
                        _this24._addState('upload');

                        if (_this24._imageHopper && _this24._options.dropReplace) {
                            _this24._imageHopper.enabled = false;
                        }

                        _this24._upload(data, function (err, res) {
                            if (_this24._imageHopper && _this24._options.dropReplace) {
                                _this24._imageHopper.enabled = true;
                            }

                            if (!err) {
                                _this24._storeServerResponse(res);
                            }

                            _this24._options.didUpload.apply(_this24, [err, data, res, _this24]);

                            _this24._removeState('upload');

                            callback(err, data, res);
                        });
                    }, this]);
                }

                if (!this._options.service || !allowUpload) {
                    callback();
                }
            }

        }, {
            key: '_storeServerResponse',
            value: function _storeServerResponse(data) {
                if (this._isRequired) {
                    this._input.required = false;
                }

                this._data.server = data;

                this._output.value = (typeof data === 'undefined' ? 'undefined' : _typeof(data)) === 'object' ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this._data.server) : data;
            }

        }, {
            key: '_store',
            value: function _store(data) {
                if (this._isRequired) {
                    this._input.required = false;
                }

                this._output.value = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
            }

        }, {
            key: '_upload',
            value: function _upload(data, callback) {
                var _this25 = this;

                this.requestOutput(function (fileData, formData) {
                    var statusNode = _this25._element.querySelector('.slim-upload-status');

                    var requestDecorator = _this25._options.willRequest;

                    var onProgress = function onProgress(loaded, total) {
                        _this25._updateProgress(Math.max(0.1, loaded / total));
                    };

                    var onSuccess = function onSuccess(obj) {
                        var timer = setTimeout(function () {

                            removeTimer(_this25._timers, timer);

                            if (_this25._isBeingDestroyed) {
                                return;
                            }

                            statusNode.innerHTML = _this25._options.statusUploadSuccess;
                            statusNode.setAttribute('data-state', 'success');
                            statusNode.style.opacity = 1;

                            var timer = setTimeout(function () {
                                removeTimer(_this25._timers, timer);
                                statusNode.style.opacity = 0;
                            }, 2000);

                            _this25._timers.push(timer);
                        }, 250);

                        _this25._timers.push(timer);

                        callback(null, obj);
                    };

                    var onError = function onError(status) {
                        var html = '';
                        if (status === 'file-too-big') {
                            html = _this25._options.statusContentLength;
                        } else {
                            html = _this25._options.didReceiveServerError.apply(_this25, [status, _this25._options.statusUnknownResponse, _this25]);
                        }

                        var timer = setTimeout(function () {

                            removeTimer(_this25._timers, timer);

                            statusNode.innerHTML = html;
                            statusNode.setAttribute('data-state', 'error');
                            statusNode.style.opacity = 1;
                        }, 250);

                        _this25._timers.push(timer);

                        callback(status);
                    };

                    if (typeof _this25._options.service === 'string') {
                        send(_this25._options.service, _this25._options.uploadMethod, formData, requestDecorator, onProgress, onSuccess, onError);
                    } else if (typeof _this25._options.service === 'function') {
                        _this25._options.service.apply(_this25, [_this25._options.serviceFormat === 'file' ? fileData : formData, onProgress, onSuccess, onError, _this25]);
                    }
                }, data);
            }
        }, {
            key: 'requestOutput',
            value: function requestOutput(cb, data) {
                var _this26 = this;

                if (!this._data.input.file) {
                    cb(null, null);
                    return;
                }

                if (!data) {
                    data = this.dataBase64;
                }

                loadImage.parseMetaData(this._data.input.file, function (imageData) {
                    var fileData = [];
                    var formData = new FormData();

                    if (inArray('input', _this26._options.post)) {
                        fileData.push(_this26._data.input.file);

                        formData.append(_this26._inputReference, _this26._data.input.file, _this26._data.input.file.name);
                    }

                    if (inArray('output', _this26._options.post) && _this26._data.output.image !== null && _this26._options.uploadBase64 === false) {
                        var output = base64ToBlob(data.output.image, data.output.name);

                        if (imageData.imageHead && _this26._options.copyImageHead) {

                            try {
                                output = new Blob([imageData.imageHead, loadImage.blobSlice.call(output, 20)], {
                                    type: getMimeTypeFromDataURI(data.output.image)
                                });

                                output = blobToFile(output, data.output.name);
                            } catch (e) {}
                        }

                        fileData.push(output);

                        var field = 'slim_output_' + _this26._uid;
                        data.output.image = null;
                        data.output.field = field;

                        formData.append(field, output, data.output.name);
                    }

                    formData.append(_this26._output.name, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data));

                    cb(fileData, formData);
                }, {
                    maxMetaDataSize: 262144,
                    disableImageHead: false
                });
            }
        }, {
            key: '_showEditor',
            value: function _showEditor() {
                SlimPopover.className = this._options.popoverClassName;

                SlimPopover.show();

                this._imageEditor.show();
            }
        }, {
            key: '_hideEditor',
            value: function _hideEditor() {
                var _this27 = this;

                this._imageEditor.hide();

                var timer = setTimeout(function () {
                    removeTimer(_this27._timers, timer);
                    SlimPopover.hide();
                }, 250);

                this._timers.push(timer);
            }

        }, {
            key: '_showPreview',
            value: function _showPreview(intro, callback) {
                snabbt(intro, {
                    fromPosition: [0, 50, 0],
                    position: [0, 0, 0],

                    fromScale: [1.5, 1.5],
                    scale: [1, 1],

                    fromOpacity: 0,
                    opacity: 1,

                    easing: 'spring',
                    springConstant: 0.3,
                    springDeceleration: 0.7,

                    complete: function complete() {
                        resetTransforms(intro);

                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        }, {
            key: '_hideResult',
            value: function _hideResult(callback) {
                var intro = this._getIntro();
                if (!intro) {
                    return;
                }

                snabbt(intro, {
                    fromScale: [1, 1],
                    scale: [0.5, 0.5],

                    fromOpacity: 1,
                    opacity: 0,

                    easing: 'spring',
                    springConstant: 0.3,
                    springDeceleration: 0.75,

                    complete: function complete() {
                        resetTransforms(intro);
                        if (callback) {
                            callback();
                        }
                    }
                });
            }
        }, {
            key: '_showButtons',
            value: function _showButtons(callback) {
                if (!this._btnGroup) {
                    return;
                }

                this._btnGroup.style.display = '';

                var animation = {
                    fromScale: [0.5, 0.5],
                    scale: [1, 1],
                    fromPosition: [0, 10, 0],
                    position: [0, 0, 0],
                    fromOpacity: 0,
                    opacity: 1,
                    complete: function complete() {
                        resetTransforms(this);
                    },
                    allDone: function allDone() {
                        if (callback) {
                            callback();
                        }
                    }
                };

                if (this.isDetached()) {
                    animation.duration = 1;
                } else {
                    animation.delay = function (i) {
                        return 250 + i * 50;
                    };
                    animation.easing = 'spring';
                    animation.springConstant = 0.3;
                    animation.springDeceleration = 0.85;
                }

                snabbt(this._btnGroup.childNodes, animation);
            }
        }, {
            key: '_hideButtons',
            value: function _hideButtons(callback) {
                var _this28 = this;

                if (!this._btnGroup) {
                    return;
                }

                var animation = {
                    fromScale: [1, 1],
                    scale: [0.85, 0.85],
                    fromOpacity: 1,
                    opacity: 0,
                    allDone: function allDone() {
                        _this28._btnGroup.style.display = 'none';
                        if (callback) {
                            callback();
                        }
                    }
                };

                if (this.isDetached()) {
                    animation.duration = 1;
                } else {
                    animation.easing = 'spring';
                    animation.springConstant = 0.3;
                    animation.springDeceleration = 0.75;
                }

                snabbt(this._btnGroup.childNodes, animation);
            }
        }, {
            key: '_hideStatus',
            value: function _hideStatus() {
                var statusNode = this._element.querySelector('.slim-upload-status');
                statusNode.style.opacity = 0;
            }
        }, {
            key: '_doEdit',
            value: function _doEdit() {
                var _this29 = this;

                if (!this._data.input.image) {
                    return;
                }

                this._addState('editor');

                if (!this._imageEditor) {
                    this._appendEditor();
                }

                this._imageEditor.showRotateButton = this._options.rotateButton;

                SlimPopover.inner = this._imageEditor.element;

                this._imageEditor.open(this._data.input.image, this._options.ratio === 'free' ? null : this._ratio, this._data.actions.crop, this._data.actions.rotation, function () {
                    _this29._showEditor();

                    _this29._hideButtons();

                    _this29._hideStatus();
                });
            }
        }, {
            key: '_doRemove',
            value: function _doRemove(done) {
                var _this30 = this;

                if (this._isImageOnly()) {
                    return;
                }

                this._clearState();
                this._addState('empty');

                this._hasInitialImage = false;
                if (this._imageHopper) {
                    this._imageHopper.enabled = true;
                }

                if (this._isRequired) {
                    this._input.required = true;
                }

                var out = this._getOutro();
                if (out) {
                    out.style.opacity = '0';
                }

                var data = this.data;

                this._resetData();

                var timer = setTimeout(function () {
                    removeTimer(_this30._timers, timer);
                    if (_this30._isBeingDestroyed) {
                        return;
                    }

                    _this30._hideButtons(function () {
                        _this30._toggleButton('upload', true);
                    });

                    _this30._hideStatus();

                    _this30._hideResult();

                    _this30._options.didRemove.apply(_this30, [data, _this30]);

                    if (done) {
                        done();
                    }
                }, this.isDetached() ? 0 : 250);

                this._timers.push(timer);

                return data;
            }
        }, {
            key: '_doUpload',
            value: function _doUpload(callback) {
                var _this31 = this;

                if (!this._data.input.image) {
                    return;
                }

                this._addState('upload');
                this._startProgress();

                this._hideButtons(function () {
                    _this31._toggleButton('upload', false);

                    _this31._save(function (err, data, res) {
                        _this31._removeState('upload');
                        _this31._stopProgress();

                        if (callback) {
                            callback.apply(_this31, [err, data, res]);
                        }

                        if (err) {
                            _this31._toggleButton('upload', true);
                        }

                        _this31._showButtons();
                    });
                });
            }
        }, {
            key: '_doDownload',
            value: function _doDownload() {
                var image = this._data.output.image;
                if (!image) {
                    return;
                }

                downloadCanvas(this._data, this._options.jpegCompression, this._options.forceType);
            }
        }, {
            key: '_doDestroy',
            value: function _doDestroy() {
                var _this32 = this;

                this._isBeingDestroyed = true;

                this._timers.forEach(function (timer) {
                    clearTimeout(timer);
                });
                this._timers = [];

                snabbt(this._element, 'detach');

                if (this._imageHopper) {
                    HopperEvents.forEach(function (e) {
                        _this32._imageHopper.element.removeEventListener(e, _this32);
                    });
                    this._imageHopper.destroy();
                    this._imageHopper = null;
                }

                if (this._imageEditor) {
                    ImageEditorEvents.forEach(function (e) {
                        _this32._imageEditor.element.removeEventListener(e, _this32);
                    });
                    this._imageEditor.destroy();
                    this._imageEditor = null;
                }

                nodeListToArray(this._btnGroup.children).forEach(function (btn) {
                    btn.removeEventListener('click', _this32);
                });

                this._input.removeEventListener('change', this);

                if (this._element !== this._originalElement && this._element.parentNode) {
                    this._element.parentNode.replaceChild(this._originalElement, this._element);
                }

                this._originalElement.innerHTML = this._originalElementInner;

                function matchesAttributeInList(a, attributes) {
                    return attributes.filter(function (attr) {
                        return a.name === attr.name && a.value === attr.value;
                    }).length !== 0;
                }

                var attributes = getElementAttributes(this._originalElement);
                attributes.forEach(function (attribute) {
                    if (matchesAttributeInList(attribute, _this32._originalElementAttributes)) {
                        return;
                    }

                    _this32._originalElement.removeAttribute(attribute.name);
                });

                this._originalElementAttributes.forEach(function (attribute) {
                    if (matchesAttributeInList(attribute, attributes)) {
                        return;
                    }

                    _this32._originalElement.setAttribute(attribute.name, attribute.value);
                });

                SlimCount = Math.max(0, SlimCount - 1);

                if (SlimPopover && SlimCount === 0) {
                    SlimPopover.destroy();
                    SlimPopover = null;
                }

                var inputImage = this._data.input.image;
                var outputImage = this._data.output.image;
                if (inputImage && inputImage.nodeName === 'CANVAS') {
                    releaseCanvas(inputImage);
                }
                if (outputImage && outputImage.nodeName === 'CANVAS') {
                    releaseCanvas(outputImage);
                }

                this._originalElement = null;
                this._element = null;
                this._input = null;
                this._output = null;
                this._btnGroup = null;
                this._options = null;
            }
        }, {
            key: 'dataBase64',

            get: function get() {
                return flattenData(this._data, this._options.post, this._options.jpegCompression, this._options.forceType, this._options.service !== null);
            }
        }, {
            key: 'data',
            get: function get() {
                return cloneData(this._data);
            }
        }, {
            key: 'element',
            get: function get() {
                return this._element;
            }
        }, {
            key: 'service',
            set: function set(service) {
                this._options.service = service;
            }
        }, {
            key: 'size',
            set: function set(dimensions) {
                this.setSize(dimensions, null);
            }
        }, {
            key: 'rotation',
            set: function set(rotation) {
                this.setRotation(rotation, null);
            }
        }, {
            key: 'forceSize',
            set: function set(dimensions) {
                this.setForceSize(dimensions, null);
            }
        }, {
            key: 'ratio',
            set: function set(ratio) {
                this.setRatio(ratio, null);
            }
        }], [{
            key: 'options',
            value: function options() {
                var defaults = {
                    edit: true,

                    instantEdit: false,

                    uploadBase64: false,

                    meta: {},

                    ratio: 'free',

                    devicePixelRatio: 1,
                    size: null,

                    rotation: null,

                    crop: null,

                    post: ['output', 'actions'],

                    service: null,
                    serviceFormat: null,

                    filterSharpen: 0,

                    push: false,

                    defaultInputName: 'slim[]',

                    minSize: {
                        width: 0,
                        height: 0
                    },

                    maxFileSize: null,

                    jpegCompression: null,

                    uploadMethod: 'POST',

                    download: false,

                    saveInitialImage: false,

                    forceType: false,

                    forceSize: null,

                    forceMinSize: true,

                    dropReplace: true,

                    fetcher: null,

                    internalCanvasSize: {
                        width: 4096,
                        height: 4096
                    },

                    internalCanvasSizeLowMemory: {
                        width: 4096,
                        height: 4096
                    },

                    copyImageHead: false,

                    rotateButton: true,

                    popoverClassName: null,

                    label: '<p>Drop your image here</p>',
                    labelLoading: '<p>Loading image...</p>',

                    statusFileType: '<p>Invalid file type, expects: $0.</p>',
                    statusFileSize: '<p>File is too big, maximum file size: $0 MB.</p>',
                    statusNoSupport: '<p>Your browser does not support image cropping.</p>',
                    statusImageTooSmall: '<p>Image is too small, minimum size is: $0 pixels.</p>',
                    statusContentLength: '<span class="slim-upload-status-icon"></span> The file is probably too big',
                    statusUnknownResponse: '<span class="slim-upload-status-icon"></span> An unknown error occurred',
                    statusUploadSuccess: '<span class="slim-upload-status-icon"></span> Saved',
                    statusLocalUrlProblem: null,

                    didInit: function didInit(data) {},
                    didLoad: function didLoad(file, image, meta) {
                        return true;
                    },
                    didSave: function didSave(data) {},
                    didUpload: function didUpload(err, data, res) {},
                    didReceiveServerError: function didReceiveServerError(err, defaultError) {
                        return defaultError;
                    },
                    didRemove: function didRemove(data) {},
                    didTransform: function didTransform(data) {},
                    didConfirm: function didConfirm(data) {},
                    didCancel: function didCancel() {},
                    didThrowError: function didThrowError() {},
                    willLoadCanvas: function willLoadCanvas(image, cb) {
                        cb(image);
                    },
                    willCropInitial: function willCropInitial(file, cb) {
                        cb(null);
                    },
                    willTransform: function willTransform(data, cb) {
                        cb(data);
                    },
                    willSave: function willSave(data, cb) {
                        cb(data);
                    },
                    willRemove: function willRemove(data, cb) {
                        cb();
                    },
                    willRequest: function willRequest(xhr, data) {},
                    willFetch: function willFetch(xhr) {},
                    willLoad: function willLoad(xhr) {}
                };

                SlimButtons.concat(ImageEditor.Buttons).concat('rotate').forEach(function (btn) {
                    var capitalized = capitalizeFirstLetter(btn);
                    defaults['button' + capitalized + 'ClassName'] = null;
                    defaults['button' + capitalized + 'Label'] = capitalized;
                    defaults['button' + capitalized + 'Title'] = capitalized;
                });

                return defaults;
            }
        }]);

        return Slim;
    }();

    (function () {
        var instances = [];

        var indexOfElement = function indexOfElement(element) {
            var i = 0;
            var l = instances.length;
            for (; i < l; i++) {
                if (instances[i].isAttachedTo(element)) {
                    return i;
                }
            }
            return -1;
        };

        function toLabel(v) {
            if (v) {
                return '<p>' + v + '</p>';
            }

            return null;
        }

        function toFunctionReference(name) {
            var ref = window;
            var levels = name.split('.');
            levels.forEach(function (level, index) {
                if (!ref[levels[index]]) {
                    return;
                }
                ref = ref[levels[index]];
            });
            return ref !== window ? ref : null;
        }

        var passThrough = function passThrough(v) {
            return v;
        };
        var defaultFalse = function defaultFalse(v) {
            return v === 'true';
        };
        var defaultTrue = function defaultTrue(v) {
            return v ? v === 'true' : true;
        };
        var defaultLabel = function defaultLabel(v) {
            return toLabel(v);
        };
        var defaultFunction = function defaultFunction(v) {
            return v ? toFunctionReference(v) : null;
        };
        var defaultSize = function defaultSize(v) {
            if (!v) {
                return null;
            }
            var parts = intSplit(v, ',');
            return {
                width: parts[0],
                height: parts[1]
            };
        };

        var toFloat = function toFloat(v) {
            if (!v) {
                return null;
            }
            return parseFloat(v);
        };

        var toInt = function toInt(v) {
            if (!v) {
                return null;
            }
            return parseInt(v, 10);
        };

        var toRect = function toRect(v) {
            if (!v) {
                return null;
            }
            var obj = {};
            v.split(',').map(function (p) {
                return parseInt(p, 10);
            }).forEach(function (v, i) {
                obj[Rect[i]] = v;
            });
            return obj;
        };

        var defaults = {
            download: defaultFalse,

            edit: defaultTrue,

            instantEdit: defaultFalse,

            minSize: defaultSize,

            size: defaultSize,

            forceSize: defaultSize,

            forceMinSize: defaultTrue,

            internalCanvasSize: defaultSize,
            internalCanvasSizeLowMemory: defaultSize,

            service: function service(v) {
                if (typeof v === 'undefined') {
                    return null;
                }
                var fn = toFunctionReference(v);
                if (fn) {
                    return fn;
                }
                return v;
            },

            serviceFormat: function serviceFormat(v) {
                return typeof v === 'undefined' ? null : v;
            },

            fetcher: function fetcher(v) {
                return typeof v === 'undefined' ? null : v;
            },

            push: defaultFalse,

            rotation: function rotation(v) {
                return typeof v === 'undefined' ? null : parseInt(v, 10);
            },

            crop: toRect,

            post: function post(v) {
                if (!v) {
                    return null;
                }
                return v.split(',').map(function (item) {
                    return item.trim();
                });
            },

            defaultInputName: passThrough,

            ratio: function ratio(v) {
                if (!v) {
                    return null;
                }
                return v;
            },

            maxFileSize: toFloat,

            filterSharpen: toInt,

            jpegCompression: toInt,

            uploadBase64: defaultFalse,

            forceType: passThrough,

            dropReplace: defaultTrue,

            saveInitialImage: defaultFalse,

            copyImageHead: defaultFalse,

            rotateButton: defaultTrue,

            label: defaultLabel,
            labelLoading: defaultLabel,

            popoverClassName: passThrough,

            devicePixelRatio: passThrough,

            uploadMethod: passThrough
        };

        ['FileSize', 'FileType', 'NoSupport', 'ImageTooSmall'].forEach(function (status) {
            defaults['status' + status] = defaultLabel;
        });

        ['ContentLength', 'UnknownResponse', 'UploadSuccess', 'LocalUrlProblem'].forEach(function (status) {
            defaults['status' + status] = passThrough;
        });

        ['Init', 'Load', 'Save', 'Upload', 'Remove', 'Transform', 'ReceiveServerError', 'Confirm', 'Cancel', 'ThrowError'].forEach(function (cb) {
            defaults['did' + cb] = defaultFunction;
        });

        ['LoadCanvas', 'CropInitial', 'Transform', 'Save', 'Remove', 'Request', 'Load', 'Fetch'].forEach(function (cb) {
            defaults['will' + cb] = defaultFunction;
        });

        var buttonOptions = ['ClassName', 'Label', 'Title'];
        SlimButtons.concat(ImageEditor.Buttons).concat('rotate').forEach(function (btn) {
            var capitalized = capitalizeFirstLetter(btn);
            buttonOptions.forEach(function (opt) {
                defaults['button' + capitalized + opt] = passThrough;
            });
        });

        Slim.supported = function () {
            return !(Object.prototype.toString.call(window.operamini) === '[object OperaMini]' || typeof window.addEventListener === 'undefined' || typeof window.FileReader === 'undefined' || !('slice' in Blob.prototype) || typeof window.URL === 'undefined' || typeof window.URL.createObjectURL === 'undefined');
        }();

        Slim.parse = function (context) {
            var elements;
            var element;
            var i;
            var croppers = [];

            elements = context.querySelectorAll('.slim:not([data-state])');
            i = elements.length;

            while (i--) {
                element = elements[i];
                croppers.push(Slim.create(element, Slim.getOptionsFromAttributes(element)));
            }

            return croppers;
        };

        Slim.getOptionsFromAttributes = function (element) {
            var dataset = getDataset(element);

            var options = {
                meta: {}
            };

            for (var prop in dataset) {
                var valueTransformer = defaults[prop];
                var _value = dataset[prop];

                if (valueTransformer) {
                    _value = valueTransformer(_value);
                    _value = _value === null ? clone(Slim.options()[prop]) : _value;
                    options[prop] = _value;
                } else if (prop.indexOf('meta') === 0) {
                    options['meta'][lowercaseFirstLetter(prop.substr(4))] = _value;
                }
            }

            return options;
        };

        Slim.find = function (element) {
            var result = instances.filter(function (instance) {
                return instance.isAttachedTo(element);
            });
            return result ? result[0] : null;
        };

        Slim.create = function (element, options) {
            if (Slim.find(element)) {
                return;
            }

            if (!options) {
                options = Slim.getOptionsFromAttributes(element);
            }

            var slim = new Slim(element, options);

            instances.push(slim);

            return slim;
        };

        Slim.destroy = function (element) {
            var index = indexOfElement(element);

            if (index < 0) {
                return false;
            }

            instances[index].destroy();
            instances.splice(index, 1);

            return true;
        };
    })();
    return Slim;
}() : null);

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c24571c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__ = __webpack_require__(1044);
function injectStyle (ssrContext) {
  __webpack_require__(1042)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reviews_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c24571c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Reviews_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 318 */,
/* 319 */,
/* 320 */,
/* 321 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_standardTilbud_vue__ = __webpack_require__(1304);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf4f670_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_standardTilbud_vue__ = __webpack_require__(1308);
function injectStyle (ssrContext) {
  __webpack_require__(1303)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_standardTilbud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1cf4f670_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_standardTilbud_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 322 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_input_pdfonly_vue__ = __webpack_require__(1306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653ef820_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_input_pdfonly_vue__ = __webpack_require__(1307);
function injectStyle (ssrContext) {
  __webpack_require__(1305)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_input_pdfonly_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_653ef820_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_input_pdfonly_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */,
/* 458 */,
/* 459 */,
/* 460 */,
/* 461 */,
/* 462 */,
/* 463 */,
/* 464 */,
/* 465 */,
/* 466 */,
/* 467 */,
/* 468 */,
/* 469 */,
/* 470 */,
/* 471 */,
/* 472 */,
/* 473 */,
/* 474 */,
/* 475 */,
/* 476 */,
/* 477 */,
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__(729);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c049f886_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__(738);
function injectStyle (ssrContext) {
  __webpack_require__(728)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c049f886_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 518 */,
/* 519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentreminderpopup_vue__ = __webpack_require__(736);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19531278_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_paymentreminderpopup_vue__ = __webpack_require__(737);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_paymentreminderpopup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19531278_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_paymentreminderpopup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 520 */,
/* 521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marketplace_vue__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c5c9bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Marketplace_vue__ = __webpack_require__(811);
function injectStyle (ssrContext) {
  __webpack_require__(769)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marketplace_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_19c5c9bc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Marketplace_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketArchive_vue__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd587f06_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MarketArchive_vue__ = __webpack_require__(789);
function injectStyle (ssrContext) {
  __webpack_require__(783)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-fd587f06"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketArchive_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fd587f06_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MarketArchive_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KundeModal_vue__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7cfe9f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_KundeModal_vue__ = __webpack_require__(815);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KundeModal_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d7cfe9f0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_KundeModal_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KundeMap_vue__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b9f1310_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_KundeMap_vue__ = __webpack_require__(814);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_KundeMap_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b9f1310_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_KundeMap_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkpayproff_vue__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f8cca6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checkpayproff_vue__ = __webpack_require__(856);
function injectStyle (ssrContext) {
  __webpack_require__(854)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkpayproff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_10f8cca6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checkpayproff_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_progress_vue__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd865890_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_progress_vue__ = __webpack_require__(860);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_file_upload_progress_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cd865890_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_file_upload_progress_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 541 */,
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printLocation;
/* harmony export (immutable) */ __webpack_exports__["b"] = printSourceLocation;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__location_mjs__ = __webpack_require__(303);

/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printLocation(location) {
  return printSourceLocation(location.source, Object(__WEBPACK_IMPORTED_MODULE_0__location_mjs__["a" /* getLocation */])(location.source, location.start));
}
/**
 * Render a helpful description of the location in the GraphQL Source document.
 */

function printSourceLocation(source, sourceLocation) {
  var firstLineColumnOffset = source.locationOffset.column - 1;
  var body = whitespace(firstLineColumnOffset) + source.body;
  var lineIndex = sourceLocation.line - 1;
  var lineOffset = source.locationOffset.line - 1;
  var lineNum = sourceLocation.line + lineOffset;
  var columnOffset = sourceLocation.line === 1 ? firstLineColumnOffset : 0;
  var columnNum = sourceLocation.column + columnOffset;
  var locationStr = "".concat(source.name, ":").concat(lineNum, ":").concat(columnNum, "\n");
  var lines = body.split(/\r\n|[\n\r]/g);
  var locationLine = lines[lineIndex]; // Special case for minified documents

  if (locationLine.length > 120) {
    var subLineIndex = Math.floor(columnNum / 80);
    var subLineColumnNum = columnNum % 80;
    var subLines = [];

    for (var i = 0; i < locationLine.length; i += 80) {
      subLines.push(locationLine.slice(i, i + 80));
    }

    return locationStr + printPrefixedLines([["".concat(lineNum), subLines[0]]].concat(subLines.slice(1, subLineIndex + 1).map(function (subLine) {
      return ['', subLine];
    }), [[' ', whitespace(subLineColumnNum - 1) + '^'], ['', subLines[subLineIndex + 1]]]));
  }

  return locationStr + printPrefixedLines([// Lines specified like this: ["prefix", "string"],
  ["".concat(lineNum - 1), lines[lineIndex - 1]], ["".concat(lineNum), locationLine], ['', whitespace(columnNum - 1) + '^'], ["".concat(lineNum + 1), lines[lineIndex + 1]]]);
}

function printPrefixedLines(lines) {
  var existingLines = lines.filter(function (_ref) {
    var _ = _ref[0],
        line = _ref[1];
    return line !== undefined;
  });
  var padLen = Math.max.apply(Math, existingLines.map(function (_ref2) {
    var prefix = _ref2[0];
    return prefix.length;
  }));
  return existingLines.map(function (_ref3) {
    var prefix = _ref3[0],
        line = _ref3[1];
    return leftPad(padLen, prefix) + (line ? ' | ' + line : ' |');
  }).join('\n');
}

function whitespace(len) {
  return Array(len + 1).join(' ');
}

function leftPad(len, str) {
  return whitespace(len - str.length) + str;
}


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2317')
var nodejsCustomInspectSymbol = typeof Symbol === 'function' && typeof Symbol.for === 'function' ? Symbol.for('nodejs.util.inspect.custom') : undefined;
/* harmony default export */ __webpack_exports__["a"] = (nodejsCustomInspectSymbol);


/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export assertValidName */
/* harmony export (immutable) */ __webpack_exports__["a"] = isValidNameError;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);


var NAME_RX = /^[_a-zA-Z][_a-zA-Z0-9]*$/;
/**
 * Upholds the spec rules about naming.
 */

function assertValidName(name) {
  var error = isValidNameError(name);

  if (error) {
    throw error;
  }

  return name;
}
/**
 * Returns an Error if a name is invalid.
 */

function isValidNameError(name) {
  typeof name === 'string' || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__["a" /* default */])(0, 'Expected name to be a string.');

  if (name.length > 1 && name[0] === '_' && name[1] === '_') {
    return new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Name \"".concat(name, "\" must not begin with \"__\", which is reserved by GraphQL introspection."));
  }

  if (!NAME_RX.test(name)) {
    return new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Names must match /^[_a-zA-Z][_a-zA-Z0-9]*$/ but \"".concat(name, "\" does not."));
  }
}


/***/ }),
/* 545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__ = __webpack_require__(162);


/**
 * Creates an object map with the same keys as `map` and values generated by
 * running each value of `map` thru `fn`.
 */
function mapValue(map, fn) {
  var result = Object.create(null);

  for (var _i2 = 0, _objectEntries2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectEntries_mjs__["a" /* default */])(map); _i2 < _objectEntries2.length; _i2++) {
    var _ref2 = _objectEntries2[_i2];
    var _key = _ref2[0];
    var _value = _ref2[1];
    result[_key] = fn(_value, _key);
  }

  return result;
}


/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = valueFromASTUntyped;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap_mjs__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__ = __webpack_require__(24);





/**
 * Produces a JavaScript value given a GraphQL Value AST.
 *
 * Unlike `valueFromAST()`, no type is provided. The resulting JavaScript value
 * will reflect the provided GraphQL value AST.
 *
 * | GraphQL Value        | JavaScript Value |
 * | -------------------- | ---------------- |
 * | Input Object         | Object           |
 * | List                 | Array            |
 * | Boolean              | Boolean          |
 * | String / Enum        | String           |
 * | Int / Float          | Number           |
 * | Null                 | null             |
 *
 */
function valueFromASTUntyped(valueNode, variables) {
  switch (valueNode.kind) {
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].NULL:
      return null;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INT:
      return parseInt(valueNode.value, 10);

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].FLOAT:
      return parseFloat(valueNode.value);

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].STRING:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].ENUM:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].BOOLEAN:
      return valueNode.value;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].LIST:
      return valueNode.values.map(function (node) {
        return valueFromASTUntyped(node, variables);
      });

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].OBJECT:
      return Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_keyValMap_mjs__["a" /* default */])(valueNode.fields, function (field) {
        return field.name.value;
      }, function (field) {
        return valueFromASTUntyped(field.value, variables);
      });

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].VARIABLE:
      return variables === null || variables === void 0 ? void 0 : variables[valueNode.name.value];
  } // istanbul ignore next (Not reachable. All possible value nodes have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected value node: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(valueNode));
}


/***/ }),
/* 547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__symbols_mjs__ = __webpack_require__(87);


/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound]
var arrayFrom = Array.from || function (obj, mapFn, thisArg) {
  if (obj == null) {
    throw new TypeError('Array.from requires an array-like object - not null or undefined');
  } // Is Iterable?


  var iteratorMethod = obj[__WEBPACK_IMPORTED_MODULE_0__symbols_mjs__["b" /* SYMBOL_ITERATOR */]];

  if (typeof iteratorMethod === 'function') {
    var iterator = iteratorMethod.call(obj);
    var result = [];
    var step;

    for (var i = 0; !(step = iterator.next()).done; ++i) {
      result.push(mapFn.call(thisArg, step.value, i)); // Infinite Iterators could cause forEach to run forever.
      // After a very large number of iterations, produce an error.
      // istanbul ignore if (Too big to actually test)

      if (i > 9999999) {
        throw new TypeError('Near-infinite iteration.');
      }
    }

    return result;
  } // Is Array like?


  var length = obj.length;

  if (typeof length === 'number' && length >= 0 && length % 1 === 0) {
    var _result = [];

    for (var _i = 0; _i < length; ++_i) {
      if (Object.prototype.hasOwnProperty.call(obj, _i)) {
        _result.push(mapFn.call(thisArg, obj[_i], _i));
      }
    }

    return _result;
  }

  return [];
};

/* harmony default export */ __webpack_exports__["a"] = (arrayFrom);


/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var isFinitePolyfill = Number.isFinite || function (value) {
  return typeof value === 'number' && isFinite(value);
};

/* harmony default export */ __webpack_exports__["a"] = (isFinitePolyfill);


/***/ }),
/* 549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return specifiedRules; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return specifiedSDLRules; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__rules_ExecutableDefinitionsRule_mjs__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__rules_UniqueOperationNamesRule_mjs__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__rules_LoneAnonymousOperationRule_mjs__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_SingleFieldSubscriptionsRule_mjs__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_KnownTypeNamesRule_mjs__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_FragmentsOnCompositeTypesRule_mjs__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_VariablesAreInputTypesRule_mjs__ = __webpack_require__(556);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_ScalarLeafsRule_mjs__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_FieldsOnCorrectTypeRule_mjs__ = __webpack_require__(558);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_UniqueFragmentNamesRule_mjs__ = __webpack_require__(559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_KnownFragmentNamesRule_mjs__ = __webpack_require__(560);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_NoUnusedFragmentsRule_mjs__ = __webpack_require__(561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rules_PossibleFragmentSpreadsRule_mjs__ = __webpack_require__(562);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_NoFragmentCyclesRule_mjs__ = __webpack_require__(563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_UniqueVariableNamesRule_mjs__ = __webpack_require__(564);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_NoUndefinedVariablesRule_mjs__ = __webpack_require__(565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_NoUnusedVariablesRule_mjs__ = __webpack_require__(566);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_KnownDirectivesRule_mjs__ = __webpack_require__(567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_UniqueDirectivesPerLocationRule_mjs__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_KnownArgumentNamesRule_mjs__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNamesRule_mjs__ = __webpack_require__(570);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__rules_ValuesOfCorrectTypeRule_mjs__ = __webpack_require__(571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__rules_ProvidedRequiredArgumentsRule_mjs__ = __webpack_require__(572);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rules_VariablesInAllowedPositionRule_mjs__ = __webpack_require__(573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__rules_OverlappingFieldsCanBeMergedRule_mjs__ = __webpack_require__(574);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rules_UniqueInputFieldNamesRule_mjs__ = __webpack_require__(575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rules_LoneSchemaDefinitionRule_mjs__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__rules_UniqueOperationTypesRule_mjs__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__rules_UniqueTypeNamesRule_mjs__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__rules_UniqueEnumValueNamesRule_mjs__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__rules_UniqueFieldDefinitionNamesRule_mjs__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__rules_UniqueDirectiveNamesRule_mjs__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__rules_PossibleTypeExtensionsRule_mjs__ = __webpack_require__(582);
// Spec Section: "Executable Definitions"
 // Spec Section: "Operation Name Uniqueness"

 // Spec Section: "Lone Anonymous Operation"

 // Spec Section: "Subscriptions with Single Root Field"

 // Spec Section: "Fragment Spread Type Existence"

 // Spec Section: "Fragments on Composite Types"

 // Spec Section: "Variables are Input Types"

 // Spec Section: "Leaf Field Selections"

 // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"

 // Spec Section: "Fragment Name Uniqueness"

 // Spec Section: "Fragment spread target defined"

 // Spec Section: "Fragments must be used"

 // Spec Section: "Fragment spread is possible"

 // Spec Section: "Fragments must not form cycles"

 // Spec Section: "Variable Uniqueness"

 // Spec Section: "All Variable Used Defined"

 // Spec Section: "All Variables Used"

 // Spec Section: "Directives Are Defined"

 // Spec Section: "Directives Are Unique Per Location"

 // Spec Section: "Argument Names"

 // Spec Section: "Argument Uniqueness"

 // Spec Section: "Value Type Correctness"

 // Spec Section: "Argument Optionality"

 // Spec Section: "All Variable Usages Are Allowed"

 // Spec Section: "Field Selection Merging"

 // Spec Section: "Input Object Field Uniqueness"

 // SDL-specific validation rules








/**
 * This set includes all validation rules defined by the GraphQL spec.
 *
 * The order of the rules in this list has been adjusted to lead to the
 * most clear output when encountering multiple validation errors.
 */

var specifiedRules = Object.freeze([__WEBPACK_IMPORTED_MODULE_0__rules_ExecutableDefinitionsRule_mjs__["a" /* ExecutableDefinitionsRule */], __WEBPACK_IMPORTED_MODULE_1__rules_UniqueOperationNamesRule_mjs__["a" /* UniqueOperationNamesRule */], __WEBPACK_IMPORTED_MODULE_2__rules_LoneAnonymousOperationRule_mjs__["a" /* LoneAnonymousOperationRule */], __WEBPACK_IMPORTED_MODULE_3__rules_SingleFieldSubscriptionsRule_mjs__["a" /* SingleFieldSubscriptionsRule */], __WEBPACK_IMPORTED_MODULE_4__rules_KnownTypeNamesRule_mjs__["a" /* KnownTypeNamesRule */], __WEBPACK_IMPORTED_MODULE_5__rules_FragmentsOnCompositeTypesRule_mjs__["a" /* FragmentsOnCompositeTypesRule */], __WEBPACK_IMPORTED_MODULE_6__rules_VariablesAreInputTypesRule_mjs__["a" /* VariablesAreInputTypesRule */], __WEBPACK_IMPORTED_MODULE_7__rules_ScalarLeafsRule_mjs__["a" /* ScalarLeafsRule */], __WEBPACK_IMPORTED_MODULE_8__rules_FieldsOnCorrectTypeRule_mjs__["a" /* FieldsOnCorrectTypeRule */], __WEBPACK_IMPORTED_MODULE_9__rules_UniqueFragmentNamesRule_mjs__["a" /* UniqueFragmentNamesRule */], __WEBPACK_IMPORTED_MODULE_10__rules_KnownFragmentNamesRule_mjs__["a" /* KnownFragmentNamesRule */], __WEBPACK_IMPORTED_MODULE_11__rules_NoUnusedFragmentsRule_mjs__["a" /* NoUnusedFragmentsRule */], __WEBPACK_IMPORTED_MODULE_12__rules_PossibleFragmentSpreadsRule_mjs__["a" /* PossibleFragmentSpreadsRule */], __WEBPACK_IMPORTED_MODULE_13__rules_NoFragmentCyclesRule_mjs__["a" /* NoFragmentCyclesRule */], __WEBPACK_IMPORTED_MODULE_14__rules_UniqueVariableNamesRule_mjs__["a" /* UniqueVariableNamesRule */], __WEBPACK_IMPORTED_MODULE_15__rules_NoUndefinedVariablesRule_mjs__["a" /* NoUndefinedVariablesRule */], __WEBPACK_IMPORTED_MODULE_16__rules_NoUnusedVariablesRule_mjs__["a" /* NoUnusedVariablesRule */], __WEBPACK_IMPORTED_MODULE_17__rules_KnownDirectivesRule_mjs__["a" /* KnownDirectivesRule */], __WEBPACK_IMPORTED_MODULE_18__rules_UniqueDirectivesPerLocationRule_mjs__["a" /* UniqueDirectivesPerLocationRule */], __WEBPACK_IMPORTED_MODULE_19__rules_KnownArgumentNamesRule_mjs__["b" /* KnownArgumentNamesRule */], __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNamesRule_mjs__["a" /* UniqueArgumentNamesRule */], __WEBPACK_IMPORTED_MODULE_21__rules_ValuesOfCorrectTypeRule_mjs__["a" /* ValuesOfCorrectTypeRule */], __WEBPACK_IMPORTED_MODULE_22__rules_ProvidedRequiredArgumentsRule_mjs__["b" /* ProvidedRequiredArgumentsRule */], __WEBPACK_IMPORTED_MODULE_23__rules_VariablesInAllowedPositionRule_mjs__["a" /* VariablesInAllowedPositionRule */], __WEBPACK_IMPORTED_MODULE_24__rules_OverlappingFieldsCanBeMergedRule_mjs__["a" /* OverlappingFieldsCanBeMergedRule */], __WEBPACK_IMPORTED_MODULE_25__rules_UniqueInputFieldNamesRule_mjs__["a" /* UniqueInputFieldNamesRule */]]);
/**
 * @internal
 */

var specifiedSDLRules = Object.freeze([__WEBPACK_IMPORTED_MODULE_26__rules_LoneSchemaDefinitionRule_mjs__["a" /* LoneSchemaDefinitionRule */], __WEBPACK_IMPORTED_MODULE_27__rules_UniqueOperationTypesRule_mjs__["a" /* UniqueOperationTypesRule */], __WEBPACK_IMPORTED_MODULE_28__rules_UniqueTypeNamesRule_mjs__["a" /* UniqueTypeNamesRule */], __WEBPACK_IMPORTED_MODULE_29__rules_UniqueEnumValueNamesRule_mjs__["a" /* UniqueEnumValueNamesRule */], __WEBPACK_IMPORTED_MODULE_30__rules_UniqueFieldDefinitionNamesRule_mjs__["a" /* UniqueFieldDefinitionNamesRule */], __WEBPACK_IMPORTED_MODULE_31__rules_UniqueDirectiveNamesRule_mjs__["a" /* UniqueDirectiveNamesRule */], __WEBPACK_IMPORTED_MODULE_4__rules_KnownTypeNamesRule_mjs__["a" /* KnownTypeNamesRule */], __WEBPACK_IMPORTED_MODULE_17__rules_KnownDirectivesRule_mjs__["a" /* KnownDirectivesRule */], __WEBPACK_IMPORTED_MODULE_18__rules_UniqueDirectivesPerLocationRule_mjs__["a" /* UniqueDirectivesPerLocationRule */], __WEBPACK_IMPORTED_MODULE_32__rules_PossibleTypeExtensionsRule_mjs__["a" /* PossibleTypeExtensionsRule */], __WEBPACK_IMPORTED_MODULE_19__rules_KnownArgumentNamesRule_mjs__["a" /* KnownArgumentNamesOnDirectivesRule */], __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNamesRule_mjs__["a" /* UniqueArgumentNamesRule */], __WEBPACK_IMPORTED_MODULE_25__rules_UniqueInputFieldNamesRule_mjs__["a" /* UniqueInputFieldNamesRule */], __WEBPACK_IMPORTED_MODULE_22__rules_ProvidedRequiredArgumentsRule_mjs__["a" /* ProvidedRequiredArgumentsOnDirectivesRule */]]);


/***/ }),
/* 550 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ExecutableDefinitionsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_predicates_mjs__ = __webpack_require__(134);




/**
 * Executable definitions
 *
 * A GraphQL document is only valid for execution if all definitions are either
 * operation or fragment definitions.
 */
function ExecutableDefinitionsRule(context) {
  return {
    Document: function Document(node) {
      for (var _i2 = 0, _node$definitions2 = node.definitions; _i2 < _node$definitions2.length; _i2++) {
        var definition = _node$definitions2[_i2];

        if (!Object(__WEBPACK_IMPORTED_MODULE_2__language_predicates_mjs__["a" /* isExecutableDefinitionNode */])(definition)) {
          var defName = definition.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION || definition.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION ? 'schema' : '"' + definition.name.value + '"';
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("The ".concat(defName, " definition is not executable."), definition));
        }
      }

      return false;
    }
  };
}


/***/ }),
/* 551 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueOperationNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique operation names
 *
 * A GraphQL document is only valid if all defined operations have unique names.
 */
function UniqueOperationNamesRule(context) {
  var knownOperationNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition(node) {
      var operationName = node.name;

      if (operationName) {
        if (knownOperationNames[operationName.value]) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one operation named \"".concat(operationName.value, "\"."), [knownOperationNames[operationName.value], operationName]));
        } else {
          knownOperationNames[operationName.value] = operationName;
        }
      }

      return false;
    },
    FragmentDefinition: function FragmentDefinition() {
      return false;
    }
  };
}


/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LoneAnonymousOperationRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__ = __webpack_require__(24);



/**
 * Lone anonymous operation
 *
 * A GraphQL document is only valid if when it contains an anonymous operation
 * (the query short-hand) that it contains only that one operation definition.
 */
function LoneAnonymousOperationRule(context) {
  var operationCount = 0;
  return {
    Document: function Document(node) {
      operationCount = node.definitions.filter(function (definition) {
        return definition.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION;
      }).length;
    },
    OperationDefinition: function OperationDefinition(node) {
      if (!node.name && operationCount > 1) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('This anonymous operation must be the only defined operation.', node));
      }
    }
  };
}


/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = SingleFieldSubscriptionsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Subscriptions must only include one field.
 *
 * A GraphQL subscription is valid only if it contains a single root field.
 */
function SingleFieldSubscriptionsRule(context) {
  return {
    OperationDefinition: function OperationDefinition(node) {
      if (node.operation === 'subscription') {
        if (node.selectionSet.selections.length !== 1) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */](node.name ? "Subscription \"".concat(node.name.value, "\" must select only one top level field.") : 'Anonymous Subscription must select only one top level field.', node.selectionSet.selections.slice(1)));
        }
      }
    }
  };
}


/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownTypeNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_predicates_mjs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__ = __webpack_require__(63);







/**
 * Known type names
 *
 * A GraphQL document is only valid if referenced types (specifically
 * variable definitions and fragment conditions) are defined by the type schema.
 */
function KnownTypeNamesRule(context) {
  var schema = context.getSchema();
  var existingTypesMap = schema ? schema.getTypeMap() : Object.create(null);
  var definedTypes = Object.create(null);

  for (var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++) {
    var def = _context$getDocument$2[_i2];

    if (Object(__WEBPACK_IMPORTED_MODULE_3__language_predicates_mjs__["b" /* isTypeDefinitionNode */])(def)) {
      definedTypes[def.name.value] = true;
    }
  }

  var typeNames = Object.keys(existingTypesMap).concat(Object.keys(definedTypes));
  return {
    NamedType: function NamedType(node, _1, parent, _2, ancestors) {
      var typeName = node.name.value;

      if (!existingTypesMap[typeName] && !definedTypes[typeName]) {
        var _ancestors$;

        var definitionNode = (_ancestors$ = ancestors[2]) !== null && _ancestors$ !== void 0 ? _ancestors$ : parent;
        var isSDL = definitionNode != null && isSDLNode(definitionNode);

        if (isSDL && isStandardTypeName(typeName)) {
          return;
        }

        var suggestedTypes = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList_mjs__["a" /* default */])(typeName, isSDL ? standardTypeNames.concat(typeNames) : typeNames);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown type \"".concat(typeName, "\".") + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_didYouMean_mjs__["a" /* default */])(suggestedTypes), node));
      }
    }
  };
}
var standardTypeNames = [].concat(__WEBPACK_IMPORTED_MODULE_4__type_scalars_mjs__["e" /* specifiedScalarTypes */], __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["f" /* introspectionTypes */]).map(function (type) {
  return type.name;
});

function isStandardTypeName(typeName) {
  return standardTypeNames.indexOf(typeName) !== -1;
}

function isSDLNode(value) {
  return !Array.isArray(value) && (Object(__WEBPACK_IMPORTED_MODULE_3__language_predicates_mjs__["d" /* isTypeSystemDefinitionNode */])(value) || Object(__WEBPACK_IMPORTED_MODULE_3__language_predicates_mjs__["e" /* isTypeSystemExtensionNode */])(value));
}


/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FragmentsOnCompositeTypesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__ = __webpack_require__(89);





/**
 * Fragments on composite type
 *
 * Fragments use a type condition to determine if they apply, since fragments
 * can only be spread into a composite type (object, interface, or union), the
 * type condition must also be a composite type.
 */
function FragmentsOnCompositeTypesRule(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var typeCondition = node.typeCondition;

      if (typeCondition) {
        var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), typeCondition);

        if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["p" /* isCompositeType */])(type)) {
          var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__language_printer_mjs__["a" /* print */])(typeCondition);
          context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fragment cannot condition on non composite type \"".concat(typeStr, "\"."), typeCondition));
        }
      }
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), node.typeCondition);

      if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["p" /* isCompositeType */])(type)) {
        var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__language_printer_mjs__["a" /* print */])(node.typeCondition);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fragment \"".concat(node.name.value, "\" cannot condition on non composite type \"").concat(typeStr, "\"."), node.typeCondition));
      }
    }
  };
}


/***/ }),
/* 556 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VariablesAreInputTypesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__ = __webpack_require__(89);





/**
 * Variables are input types
 *
 * A GraphQL operation is only valid if all the variables it defines are of
 * input types (scalar, enum, or input object).
 */
function VariablesAreInputTypesRule(context) {
  return {
    VariableDefinition: function VariableDefinition(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), node.type);

      if (type && !Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["s" /* isInputType */])(type)) {
        var variableName = node.variable.name.value;
        var typeName = Object(__WEBPACK_IMPORTED_MODULE_1__language_printer_mjs__["a" /* print */])(node.type);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Variable \"$".concat(variableName, "\" cannot be non-input type \"").concat(typeName, "\"."), node.type));
      }
    }
  };
}


/***/ }),
/* 557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ScalarLeafsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__ = __webpack_require__(20);




/**
 * Scalar leafs
 *
 * A GraphQL document is valid only if all leaf fields (fields without
 * sub selections) are of scalar or enum types.
 */
function ScalarLeafsRule(context) {
  return {
    Field: function Field(node) {
      var type = context.getType();
      var selectionSet = node.selectionSet;

      if (type) {
        if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["u" /* isLeafType */])(Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["m" /* getNamedType */])(type))) {
          if (selectionSet) {
            var fieldName = node.name.value;
            var typeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(type);
            context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(fieldName, "\" must not have a selection since type \"").concat(typeStr, "\" has no subfields."), selectionSet));
          }
        } else if (!selectionSet) {
          var _fieldName = node.name.value;

          var _typeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(type);

          context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(_fieldName, "\" of type \"").concat(_typeStr, "\" must have a selection of subfields. Did you mean \"").concat(_fieldName, " { ... }\"?"), node));
        }
      }
    }
  };
}


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = FieldsOnCorrectTypeRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_arrayFrom_mjs__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_naturalCompare_mjs__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__ = __webpack_require__(20);







/**
 * Fields on correct type
 *
 * A GraphQL document is only valid if all fields selected are defined by the
 * parent type, or are an allowed meta field such as __typename.
 */
function FieldsOnCorrectTypeRule(context) {
  return {
    Field: function Field(node) {
      var type = context.getParentType();

      if (type) {
        var fieldDef = context.getFieldDef();

        if (!fieldDef) {
          // This field doesn't exist, lets look for suggestions.
          var schema = context.getSchema();
          var fieldName = node.name.value; // First determine if there are any suggested types to condition on.

          var suggestion = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_didYouMean_mjs__["a" /* default */])('to use an inline fragment on', getSuggestedTypeNames(schema, type, fieldName)); // If there are no suggested types, then perhaps this was a typo?

          if (suggestion === '') {
            suggestion = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_didYouMean_mjs__["a" /* default */])(getSuggestedFieldNames(type, fieldName));
          } // Report an error, including helpful suggestions.


          context.reportError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Cannot query field \"".concat(fieldName, "\" on type \"").concat(type.name, "\".") + suggestion, node));
        }
      }
    }
  };
}
/**
 * Go through all of the implementations of type, as well as the interfaces that
 * they implement. If any of those types include the provided field, suggest them,
 * sorted by how often the type is referenced.
 */

function getSuggestedTypeNames(schema, type, fieldName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["o" /* isAbstractType */])(type)) {
    // Must be an Object type, which does not have possible fields.
    return [];
  }

  var suggestedTypes = new Set();
  var usageCount = Object.create(null);

  for (var _i2 = 0, _schema$getPossibleTy2 = schema.getPossibleTypes(type); _i2 < _schema$getPossibleTy2.length; _i2++) {
    var possibleType = _schema$getPossibleTy2[_i2];

    if (!possibleType.getFields()[fieldName]) {
      continue;
    } // This object type defines this field.


    suggestedTypes.add(possibleType);
    usageCount[possibleType.name] = 1;

    for (var _i4 = 0, _possibleType$getInte2 = possibleType.getInterfaces(); _i4 < _possibleType$getInte2.length; _i4++) {
      var _usageCount$possibleI;

      var possibleInterface = _possibleType$getInte2[_i4];

      if (!possibleInterface.getFields()[fieldName]) {
        continue;
      } // This interface type defines this field.


      suggestedTypes.add(possibleInterface);
      usageCount[possibleInterface.name] = ((_usageCount$possibleI = usageCount[possibleInterface.name]) !== null && _usageCount$possibleI !== void 0 ? _usageCount$possibleI : 0) + 1;
    }
  }

  return Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_arrayFrom_mjs__["a" /* default */])(suggestedTypes).sort(function (typeA, typeB) {
    // Suggest both interface and object types based on how common they are.
    var usageCountDiff = usageCount[typeB.name] - usageCount[typeA.name];

    if (usageCountDiff !== 0) {
      return usageCountDiff;
    } // Suggest super types first followed by subtypes


    if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["t" /* isInterfaceType */])(typeA) && schema.isSubType(typeA, typeB)) {
      return -1;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["t" /* isInterfaceType */])(typeB) && schema.isSubType(typeB, typeA)) {
      return 1;
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_naturalCompare_mjs__["a" /* default */])(typeA.name, typeB.name);
  }).map(function (x) {
    return x.name;
  });
}
/**
 * For the field name provided, determine if there are any similar field names
 * that may be the result of a typo.
 */


function getSuggestedFieldNames(type, fieldName) {
  if (Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["y" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_5__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
    var possibleFieldNames = Object.keys(type.getFields());
    return Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_suggestionList_mjs__["a" /* default */])(fieldName, possibleFieldNames);
  } // Otherwise, must be a Union type, which does not define fields.


  return [];
}


/***/ }),
/* 559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueFragmentNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique fragment names
 *
 * A GraphQL document is only valid if all defined fragments have unique names.
 */
function UniqueFragmentNamesRule(context) {
  var knownFragmentNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      var fragmentName = node.name.value;

      if (knownFragmentNames[fragmentName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one fragment named \"".concat(fragmentName, "\"."), [knownFragmentNames[fragmentName], node.name]));
      } else {
        knownFragmentNames[fragmentName] = node.name;
      }

      return false;
    }
  };
}


/***/ }),
/* 560 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownFragmentNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Known fragment names
 *
 * A GraphQL document is only valid if all `...Fragment` fragment spreads refer
 * to fragments defined in the same document.
 */
function KnownFragmentNamesRule(context) {
  return {
    FragmentSpread: function FragmentSpread(node) {
      var fragmentName = node.name.value;
      var fragment = context.getFragment(fragmentName);

      if (!fragment) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown fragment \"".concat(fragmentName, "\"."), node.name));
      }
    }
  };
}


/***/ }),
/* 561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUnusedFragmentsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * No unused fragments
 *
 * A GraphQL document is only valid if all fragment definitions are spread
 * within operations, or spread within other fragments spread within operations.
 */
function NoUnusedFragmentsRule(context) {
  var operationDefs = [];
  var fragmentDefs = [];
  return {
    OperationDefinition: function OperationDefinition(node) {
      operationDefs.push(node);
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      fragmentDefs.push(node);
      return false;
    },
    Document: {
      leave: function leave() {
        var fragmentNameUsed = Object.create(null);

        for (var _i2 = 0; _i2 < operationDefs.length; _i2++) {
          var operation = operationDefs[_i2];

          for (var _i4 = 0, _context$getRecursive2 = context.getRecursivelyReferencedFragments(operation); _i4 < _context$getRecursive2.length; _i4++) {
            var fragment = _context$getRecursive2[_i4];
            fragmentNameUsed[fragment.name.value] = true;
          }
        }

        for (var _i6 = 0; _i6 < fragmentDefs.length; _i6++) {
          var fragmentDef = fragmentDefs[_i6];
          var fragName = fragmentDef.name.value;

          if (fragmentNameUsed[fragName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fragment \"".concat(fragName, "\" is never used."), fragmentDef));
          }
        }
      }
    }
  };
}


/***/ }),
/* 562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PossibleFragmentSpreadsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_typeComparators_mjs__ = __webpack_require__(203);






/**
 * Possible fragment spread
 *
 * A fragment spread is only valid if the type condition could ever possibly
 * be true: if there is a non-empty intersection of the possible parent types,
 * and possible types which pass the type condition.
 */
function PossibleFragmentSpreadsRule(context) {
  return {
    InlineFragment: function InlineFragment(node) {
      var fragType = context.getType();
      var parentType = context.getParentType();

      if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["p" /* isCompositeType */])(fragType) && Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["p" /* isCompositeType */])(parentType) && !Object(__WEBPACK_IMPORTED_MODULE_4__utilities_typeComparators_mjs__["a" /* doTypesOverlap */])(context.getSchema(), fragType, parentType)) {
        var parentTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(parentType);
        var fragTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(fragType);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fragment cannot be spread here as objects of type \"".concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
      }
    },
    FragmentSpread: function FragmentSpread(node) {
      var fragName = node.name.value;
      var fragType = getFragmentType(context, fragName);
      var parentType = context.getParentType();

      if (fragType && parentType && !Object(__WEBPACK_IMPORTED_MODULE_4__utilities_typeComparators_mjs__["a" /* doTypesOverlap */])(context.getSchema(), fragType, parentType)) {
        var parentTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(parentType);
        var fragTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(fragType);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fragment \"".concat(fragName, "\" cannot be spread here as objects of type \"").concat(parentTypeStr, "\" can never be of type \"").concat(fragTypeStr, "\"."), node));
      }
    }
  };
}

function getFragmentType(context, name) {
  var frag = context.getFragment(name);

  if (frag) {
    var type = Object(__WEBPACK_IMPORTED_MODULE_3__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), frag.typeCondition);

    if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["p" /* isCompositeType */])(type)) {
      return type;
    }
  }
}


/***/ }),
/* 563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoFragmentCyclesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);

function NoFragmentCyclesRule(context) {
  // Tracks already visited fragments to maintain O(N) and to ensure that cycles
  // are not redundantly reported.
  var visitedFrags = Object.create(null); // Array of AST nodes used to produce meaningful errors

  var spreadPath = []; // Position in the spread path

  var spreadPathIndexByName = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      return false;
    },
    FragmentDefinition: function FragmentDefinition(node) {
      detectCycleRecursive(node);
      return false;
    }
  }; // This does a straight-forward DFS to find cycles.
  // It does not terminate when a cycle was found but continues to explore
  // the graph to find all possible cycles.

  function detectCycleRecursive(fragment) {
    if (visitedFrags[fragment.name.value]) {
      return;
    }

    var fragmentName = fragment.name.value;
    visitedFrags[fragmentName] = true;
    var spreadNodes = context.getFragmentSpreads(fragment.selectionSet);

    if (spreadNodes.length === 0) {
      return;
    }

    spreadPathIndexByName[fragmentName] = spreadPath.length;

    for (var _i2 = 0; _i2 < spreadNodes.length; _i2++) {
      var spreadNode = spreadNodes[_i2];
      var spreadName = spreadNode.name.value;
      var cycleIndex = spreadPathIndexByName[spreadName];
      spreadPath.push(spreadNode);

      if (cycleIndex === undefined) {
        var spreadFragment = context.getFragment(spreadName);

        if (spreadFragment) {
          detectCycleRecursive(spreadFragment);
        }
      } else {
        var cyclePath = spreadPath.slice(cycleIndex);
        var viaPath = cyclePath.slice(0, -1).map(function (s) {
          return '"' + s.name.value + '"';
        }).join(', ');
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Cannot spread fragment \"".concat(spreadName, "\" within itself") + (viaPath !== '' ? " via ".concat(viaPath, ".") : '.'), cyclePath));
      }

      spreadPath.pop();
    }

    spreadPathIndexByName[fragmentName] = undefined;
  }
}


/***/ }),
/* 564 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueVariableNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique variable names
 *
 * A GraphQL operation is only valid if all its variables are uniquely named.
 */
function UniqueVariableNamesRule(context) {
  var knownVariableNames = Object.create(null);
  return {
    OperationDefinition: function OperationDefinition() {
      knownVariableNames = Object.create(null);
    },
    VariableDefinition: function VariableDefinition(node) {
      var variableName = node.variable.name.value;

      if (knownVariableNames[variableName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one variable named \"$".concat(variableName, "\"."), [knownVariableNames[variableName], node.variable.name]));
      } else {
        knownVariableNames[variableName] = node.variable.name;
      }
    }
  };
}


/***/ }),
/* 565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUndefinedVariablesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * No undefined variables
 *
 * A GraphQL operation is only valid if all variables encountered, both directly
 * and via fragment spreads, are defined by that operation.
 */
function NoUndefinedVariablesRule(context) {
  var variableNameDefined = Object.create(null);
  return {
    OperationDefinition: {
      enter: function enter() {
        variableNameDefined = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);

        for (var _i2 = 0; _i2 < usages.length; _i2++) {
          var _ref2 = usages[_i2];
          var node = _ref2.node;
          var varName = node.name.value;

          if (variableNameDefined[varName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */](operation.name ? "Variable \"$".concat(varName, "\" is not defined by operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(varName, "\" is not defined."), [node, operation]));
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      variableNameDefined[node.variable.name.value] = true;
    }
  };
}


/***/ }),
/* 566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoUnusedVariablesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * No unused variables
 *
 * A GraphQL operation is only valid if all variables defined by an operation
 * are used, either directly or within a spread fragment.
 */
function NoUnusedVariablesRule(context) {
  var variableDefs = [];
  return {
    OperationDefinition: {
      enter: function enter() {
        variableDefs = [];
      },
      leave: function leave(operation) {
        var variableNameUsed = Object.create(null);
        var usages = context.getRecursiveVariableUsages(operation);

        for (var _i2 = 0; _i2 < usages.length; _i2++) {
          var _ref2 = usages[_i2];
          var node = _ref2.node;
          variableNameUsed[node.name.value] = true;
        }

        for (var _i4 = 0, _variableDefs2 = variableDefs; _i4 < _variableDefs2.length; _i4++) {
          var variableDef = _variableDefs2[_i4];
          var variableName = variableDef.variable.name.value;

          if (variableNameUsed[variableName] !== true) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */](operation.name ? "Variable \"$".concat(variableName, "\" is never used in operation \"").concat(operation.name.value, "\".") : "Variable \"$".concat(variableName, "\" is never used."), variableDef));
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(def) {
      variableDefs.push(def);
    }
  };
}


/***/ }),
/* 567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownDirectivesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__ = __webpack_require__(54);







/**
 * Known directives
 *
 * A GraphQL document is only valid if all `@directives` are known by the
 * schema and legally positioned.
 */
function KnownDirectivesRule(context) {
  var locationsMap = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__["i" /* specifiedDirectives */];

  for (var _i2 = 0; _i2 < definedDirectives.length; _i2++) {
    var directive = definedDirectives[_i2];
    locationsMap[directive.name] = directive.locations;
  }

  var astDefinitions = context.getDocument().definitions;

  for (var _i4 = 0; _i4 < astDefinitions.length; _i4++) {
    var def = astDefinitions[_i4];

    if (def.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION) {
      locationsMap[def.name.value] = def.locations.map(function (name) {
        return name.value;
      });
    }
  }

  return {
    Directive: function Directive(node, _key, _parent, _path, ancestors) {
      var name = node.name.value;
      var locations = locationsMap[name];

      if (!locations) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown directive \"@".concat(name, "\"."), node));
        return;
      }

      var candidateLocation = getDirectiveLocationForASTPath(ancestors);

      if (candidateLocation && locations.indexOf(candidateLocation) === -1) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Directive \"@".concat(name, "\" may not be used on ").concat(candidateLocation, "."), node));
      }
    }
  };
}

function getDirectiveLocationForASTPath(ancestors) {
  var appliedTo = ancestors[ancestors.length - 1];
  !Array.isArray(appliedTo) || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0);

  switch (appliedTo.kind) {
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION:
      return getDirectiveLocationForOperation(appliedTo.operation);

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].FIELD:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_SPREAD;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INLINE_FRAGMENT;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FRAGMENT_DEFINITION;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].VARIABLE_DEFINITION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].VARIABLE_DEFINITION;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SCHEMA;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SCALAR;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].OBJECT;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].FIELD_DEFINITION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].FIELD_DEFINITION;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INTERFACE;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].UNION;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ENUM;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].ENUM_VALUE_DEFINITION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ENUM_VALUE;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION:
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INPUT_OBJECT;

    case __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INPUT_VALUE_DEFINITION:
      {
        var parentNode = ancestors[ancestors.length - 3];
        return parentNode.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION ? __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].INPUT_FIELD_DEFINITION : __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].ARGUMENT_DEFINITION;
      }
  }
}

function getDirectiveLocationForOperation(operation) {
  switch (operation) {
    case 'query':
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].QUERY;

    case 'mutation':
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].MUTATION;

    case 'subscription':
      return __WEBPACK_IMPORTED_MODULE_4__language_directiveLocation_mjs__["a" /* DirectiveLocation */].SUBSCRIPTION;
  } // istanbul ignore next (Not reachable. All possible types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected operation: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(operation));
}


/***/ }),
/* 568 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueDirectivesPerLocationRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_predicates_mjs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_directives_mjs__ = __webpack_require__(54);





/**
 * Unique directive names per location
 *
 * A GraphQL document is only valid if all non-repeatable directives at
 * a given location are uniquely named.
 */
function UniqueDirectivesPerLocationRule(context) {
  var uniqueDirectiveMap = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : __WEBPACK_IMPORTED_MODULE_3__type_directives_mjs__["i" /* specifiedDirectives */];

  for (var _i2 = 0; _i2 < definedDirectives.length; _i2++) {
    var directive = definedDirectives[_i2];
    uniqueDirectiveMap[directive.name] = !directive.isRepeatable;
  }

  var astDefinitions = context.getDocument().definitions;

  for (var _i4 = 0; _i4 < astDefinitions.length; _i4++) {
    var def = astDefinitions[_i4];

    if (def.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION) {
      uniqueDirectiveMap[def.name.value] = !def.repeatable;
    }
  }

  var schemaDirectives = Object.create(null);
  var typeDirectivesMap = Object.create(null);
  return {
    // Many different AST nodes may contain directives. Rather than listing
    // them all, just listen for entering any node, and check to see if it
    // defines any directives.
    enter: function enter(node) {
      if (node.directives == null) {
        return;
      }

      var seenDirectives;

      if (node.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION || node.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION) {
        seenDirectives = schemaDirectives;
      } else if (Object(__WEBPACK_IMPORTED_MODULE_2__language_predicates_mjs__["b" /* isTypeDefinitionNode */])(node) || Object(__WEBPACK_IMPORTED_MODULE_2__language_predicates_mjs__["c" /* isTypeExtensionNode */])(node)) {
        var typeName = node.name.value;
        seenDirectives = typeDirectivesMap[typeName];

        if (seenDirectives === undefined) {
          typeDirectivesMap[typeName] = seenDirectives = Object.create(null);
        }
      } else {
        seenDirectives = Object.create(null);
      }

      for (var _i6 = 0, _node$directives2 = node.directives; _i6 < _node$directives2.length; _i6++) {
        var _directive = _node$directives2[_i6];
        var directiveName = _directive.name.value;

        if (uniqueDirectiveMap[directiveName]) {
          if (seenDirectives[directiveName]) {
            context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("The directive \"@".concat(directiveName, "\" can only be used once at this location."), [seenDirectives[directiveName], _directive]));
          } else {
            seenDirectives[directiveName] = _directive;
          }
        }
      }
    }
  };
}


/***/ }),
/* 569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = KnownArgumentNamesRule;
/* harmony export (immutable) */ __webpack_exports__["a"] = KnownArgumentNamesOnDirectivesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_directives_mjs__ = __webpack_require__(54);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }







/**
 * Known argument names
 *
 * A GraphQL field is only valid if all supplied arguments are defined by
 * that field.
 */
function KnownArgumentNamesRule(context) {
  return _objectSpread(_objectSpread({}, KnownArgumentNamesOnDirectivesRule(context)), {}, {
    Argument: function Argument(argNode) {
      var argDef = context.getArgument();
      var fieldDef = context.getFieldDef();
      var parentType = context.getParentType();

      if (!argDef && fieldDef && parentType) {
        var argName = argNode.name.value;
        var knownArgsNames = fieldDef.args.map(function (arg) {
          return arg.name;
        });
        var suggestions = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList_mjs__["a" /* default */])(argName, knownArgsNames);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown argument \"".concat(argName, "\" on field \"").concat(parentType.name, ".").concat(fieldDef.name, "\".") + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_didYouMean_mjs__["a" /* default */])(suggestions), argNode));
      }
    }
  });
}
/**
 * @internal
 */

function KnownArgumentNamesOnDirectivesRule(context) {
  var directiveArgs = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : __WEBPACK_IMPORTED_MODULE_4__type_directives_mjs__["i" /* specifiedDirectives */];

  for (var _i2 = 0; _i2 < definedDirectives.length; _i2++) {
    var directive = definedDirectives[_i2];
    directiveArgs[directive.name] = directive.args.map(function (arg) {
      return arg.name;
    });
  }

  var astDefinitions = context.getDocument().definitions;

  for (var _i4 = 0; _i4 < astDefinitions.length; _i4++) {
    var def = astDefinitions[_i4];

    if (def.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var argsNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
      directiveArgs[def.name.value] = argsNodes.map(function (arg) {
        return arg.name.value;
      });
    }
  }

  return {
    Directive: function Directive(directiveNode) {
      var directiveName = directiveNode.name.value;
      var knownArgs = directiveArgs[directiveName];

      if (directiveNode.arguments && knownArgs) {
        for (var _i6 = 0, _directiveNode$argume2 = directiveNode.arguments; _i6 < _directiveNode$argume2.length; _i6++) {
          var argNode = _directiveNode$argume2[_i6];
          var argName = argNode.name.value;

          if (knownArgs.indexOf(argName) === -1) {
            var suggestions = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_suggestionList_mjs__["a" /* default */])(argName, knownArgs);
            context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Unknown argument \"".concat(argName, "\" on directive \"@").concat(directiveName, "\".") + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_didYouMean_mjs__["a" /* default */])(suggestions), argNode));
          }
        }
      }

      return false;
    }
  };
}


/***/ }),
/* 570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueArgumentNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique argument names
 *
 * A GraphQL field or directive is only valid if all supplied arguments are
 * uniquely named.
 */
function UniqueArgumentNamesRule(context) {
  var knownArgNames = Object.create(null);
  return {
    Field: function Field() {
      knownArgNames = Object.create(null);
    },
    Directive: function Directive() {
      knownArgNames = Object.create(null);
    },
    Argument: function Argument(node) {
      var argName = node.name.value;

      if (knownArgNames[argName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one argument named \"".concat(argName, "\"."), [knownArgNames[argName], node.name]));
      } else {
        knownArgNames[argName] = node.name;
      }

      return false;
    }
  };
}


/***/ }),
/* 571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = ValuesOfCorrectTypeRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__ = __webpack_require__(20);









/**
 * Value literals of correct type
 *
 * A GraphQL document is only valid if all value literals are of the type
 * expected at their position.
 */
function ValuesOfCorrectTypeRule(context) {
  return {
    ListValue: function ListValue(node) {
      // Note: TypeInfo will traverse into a list's item type, so look to the
      // parent input type to check if it is a list.
      var type = Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["n" /* getNullableType */])(context.getParentInputType());

      if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["v" /* isListType */])(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      }
    },
    ObjectValue: function ObjectValue(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["m" /* getNamedType */])(context.getInputType());

      if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
        isValidValueNode(context, node);
        return false; // Don't traverse further.
      } // Ensure every required field exists.


      var fieldNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(node.fields, function (field) {
        return field.name.value;
      });

      for (var _i2 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()); _i2 < _objectValues2.length; _i2++) {
        var fieldDef = _objectValues2[_i2];
        var fieldNode = fieldNodeMap[fieldDef.name];

        if (!fieldNode && Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["B" /* isRequiredInputField */])(fieldDef)) {
          var typeStr = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(fieldDef.type);
          context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(type.name, ".").concat(fieldDef.name, "\" of required type \"").concat(typeStr, "\" was not provided."), node));
        }
      }
    },
    ObjectField: function ObjectField(node) {
      var parentType = Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["m" /* getNamedType */])(context.getParentInputType());
      var fieldType = context.getInputType();

      if (!fieldType && Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["r" /* isInputObjectType */])(parentType)) {
        var suggestions = Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_suggestionList_mjs__["a" /* default */])(node.name.value, Object.keys(parentType.getFields()));
        context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(node.name.value, "\" is not defined by type \"").concat(parentType.name, "\".") + Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_didYouMean_mjs__["a" /* default */])(suggestions), node));
      }
    },
    NullValue: function NullValue(node) {
      var type = context.getInputType();

      if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["x" /* isNonNullType */])(type)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected value of type \"".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type), "\", found ").concat(Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(node), "."), node));
      }
    },
    EnumValue: function EnumValue(node) {
      return isValidValueNode(context, node);
    },
    IntValue: function IntValue(node) {
      return isValidValueNode(context, node);
    },
    FloatValue: function FloatValue(node) {
      return isValidValueNode(context, node);
    },
    StringValue: function StringValue(node) {
      return isValidValueNode(context, node);
    },
    BooleanValue: function BooleanValue(node) {
      return isValidValueNode(context, node);
    }
  };
}
/**
 * Any value literal may be a valid representation of a Scalar, depending on
 * that scalar type.
 */

function isValidValueNode(context, node) {
  // Report any error at the full type expected by the location.
  var locationType = context.getInputType();

  if (!locationType) {
    return;
  }

  var type = Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["m" /* getNamedType */])(locationType);

  if (!Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["u" /* isLeafType */])(type)) {
    var typeStr = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(locationType);
    context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected value of type \"".concat(typeStr, "\", found ").concat(Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(node), "."), node));
    return;
  } // Scalars and Enums determine if a literal value is valid via parseLiteral(),
  // which may throw or return an invalid value to indicate failure.


  try {
    var parseResult = type.parseLiteral(node, undefined
    /* variables */
    );

    if (parseResult === undefined) {
      var _typeStr = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(locationType);

      context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected value of type \"".concat(_typeStr, "\", found ").concat(Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(node), "."), node));
    }
  } catch (error) {
    var _typeStr2 = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(locationType);

    if (error instanceof __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]) {
      context.reportError(error);
    } else {
      context.reportError(new __WEBPACK_IMPORTED_MODULE_5__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected value of type \"".concat(_typeStr2, "\", found ").concat(Object(__WEBPACK_IMPORTED_MODULE_6__language_printer_mjs__["a" /* print */])(node), "; ") + error.message, node, undefined, undefined, undefined, error));
    }
  }
}


/***/ }),
/* 572 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["b"] = ProvidedRequiredArgumentsRule;
/* harmony export (immutable) */ __webpack_exports__["a"] = ProvidedRequiredArgumentsOnDirectivesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__ = __webpack_require__(20);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }









/**
 * Provided required arguments
 *
 * A field or directive is only valid if all required (non-null without a
 * default value) field arguments have been provided.
 */
function ProvidedRequiredArgumentsRule(context) {
  return _objectSpread(_objectSpread({}, ProvidedRequiredArgumentsOnDirectivesRule(context)), {}, {
    Field: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(fieldNode) {
        var _fieldNode$arguments;

        var fieldDef = context.getFieldDef();

        if (!fieldDef) {
          return false;
        } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')


        var argNodes = (_fieldNode$arguments = fieldNode.arguments) !== null && _fieldNode$arguments !== void 0 ? _fieldNode$arguments : [];
        var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(argNodes, function (arg) {
          return arg.name.value;
        });

        for (var _i2 = 0, _fieldDef$args2 = fieldDef.args; _i2 < _fieldDef$args2.length; _i2++) {
          var argDef = _fieldDef$args2[_i2];
          var argNode = argNodeMap[argDef.name];

          if (!argNode && Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["A" /* isRequiredArgument */])(argDef)) {
            var argTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(argDef.type);
            context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), fieldNode));
          }
        }
      }
    }
  });
}
/**
 * @internal
 */

function ProvidedRequiredArgumentsOnDirectivesRule(context) {
  var requiredArgsMap = Object.create(null);
  var schema = context.getSchema();
  var definedDirectives = schema ? schema.getDirectives() : __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__["i" /* specifiedDirectives */];

  for (var _i4 = 0; _i4 < definedDirectives.length; _i4++) {
    var directive = definedDirectives[_i4];
    requiredArgsMap[directive.name] = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(directive.args.filter(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["A" /* isRequiredArgument */]), function (arg) {
      return arg.name;
    });
  }

  var astDefinitions = context.getDocument().definitions;

  for (var _i6 = 0; _i6 < astDefinitions.length; _i6++) {
    var def = astDefinitions[_i6];

    if (def.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION) {
      var _def$arguments;

      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var argNodes = (_def$arguments = def.arguments) !== null && _def$arguments !== void 0 ? _def$arguments : [];
      requiredArgsMap[def.name.value] = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(argNodes.filter(isRequiredArgumentNode), function (arg) {
        return arg.name.value;
      });
    }
  }

  return {
    Directive: {
      // Validate on leave to allow for deeper errors to appear first.
      leave: function leave(directiveNode) {
        var directiveName = directiveNode.name.value;
        var requiredArgs = requiredArgsMap[directiveName];

        if (requiredArgs) {
          var _directiveNode$argume;

          // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
          var _argNodes = (_directiveNode$argume = directiveNode.arguments) !== null && _directiveNode$argume !== void 0 ? _directiveNode$argume : [];

          var argNodeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(_argNodes, function (arg) {
            return arg.name.value;
          });

          for (var _i8 = 0, _Object$keys2 = Object.keys(requiredArgs); _i8 < _Object$keys2.length; _i8++) {
            var argName = _Object$keys2[_i8];

            if (!argNodeMap[argName]) {
              var argType = requiredArgs[argName].type;
              var argTypeStr = Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["D" /* isType */])(argType) ? Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(argType) : Object(__WEBPACK_IMPORTED_MODULE_4__language_printer_mjs__["a" /* print */])(argType);
              context.reportError(new __WEBPACK_IMPORTED_MODULE_2__error_GraphQLError_mjs__["a" /* GraphQLError */]("Directive \"@".concat(directiveName, "\" argument \"").concat(argName, "\" of type \"").concat(argTypeStr, "\" is required, but it was not provided."), directiveNode));
            }
          }
        }
      }
    }
  };
}

function isRequiredArgumentNode(arg) {
  return arg.type.kind === __WEBPACK_IMPORTED_MODULE_3__language_kinds_mjs__["a" /* Kind */].NON_NULL_TYPE && arg.defaultValue == null;
}


/***/ }),
/* 573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = VariablesInAllowedPositionRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utilities_typeFromAST_mjs__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utilities_typeComparators_mjs__ = __webpack_require__(203);







/**
 * Variables passed to field arguments conform to type
 */
function VariablesInAllowedPositionRule(context) {
  var varDefMap = Object.create(null);
  return {
    OperationDefinition: {
      enter: function enter() {
        varDefMap = Object.create(null);
      },
      leave: function leave(operation) {
        var usages = context.getRecursiveVariableUsages(operation);

        for (var _i2 = 0; _i2 < usages.length; _i2++) {
          var _ref2 = usages[_i2];
          var node = _ref2.node;
          var type = _ref2.type;
          var defaultValue = _ref2.defaultValue;
          var varName = node.name.value;
          var varDef = varDefMap[varName];

          if (varDef && type) {
            // A var type is allowed if it is the same or more strict (e.g. is
            // a subtype of) than the expected type. It can be more strict if
            // the variable type is non-null when the expected type is nullable.
            // If both are list types, the variable item type can be more strict
            // than the expected item type (contravariant).
            var schema = context.getSchema();
            var varType = Object(__WEBPACK_IMPORTED_MODULE_4__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(schema, varDef.type);

            if (varType && !allowedVariableUsage(schema, varType, varDef.defaultValue, type, defaultValue)) {
              var varTypeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(varType);
              var typeStr = Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(type);
              context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Variable \"$".concat(varName, "\" of type \"").concat(varTypeStr, "\" used in position expecting type \"").concat(typeStr, "\"."), [varDef, node]));
            }
          }
        }
      }
    },
    VariableDefinition: function VariableDefinition(node) {
      varDefMap[node.variable.name.value] = node;
    }
  };
}
/**
 * Returns true if the variable is allowed in the location it was found,
 * which includes considering if default values exist for either the variable
 * or the location at which it is located.
 */

function allowedVariableUsage(schema, varType, varDefaultValue, locationType, locationDefaultValue) {
  if (Object(__WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__["x" /* isNonNullType */])(locationType) && !Object(__WEBPACK_IMPORTED_MODULE_3__type_definition_mjs__["x" /* isNonNullType */])(varType)) {
    var hasNonNullVariableDefaultValue = varDefaultValue != null && varDefaultValue.kind !== __WEBPACK_IMPORTED_MODULE_2__language_kinds_mjs__["a" /* Kind */].NULL;
    var hasLocationDefaultValue = locationDefaultValue !== undefined;

    if (!hasNonNullVariableDefaultValue && !hasLocationDefaultValue) {
      return false;
    }

    var nullableLocationType = locationType.ofType;
    return Object(__WEBPACK_IMPORTED_MODULE_5__utilities_typeComparators_mjs__["c" /* isTypeSubTypeOf */])(schema, varType, nullableLocationType);
  }

  return Object(__WEBPACK_IMPORTED_MODULE_5__utilities_typeComparators_mjs__["c" /* isTypeSubTypeOf */])(schema, varType, locationType);
}


/***/ }),
/* 574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = OverlappingFieldsCanBeMergedRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfills_objectEntries_mjs__ = __webpack_require__(162);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_typeFromAST_mjs__ = __webpack_require__(89);









function reasonMessage(reason) {
  if (Array.isArray(reason)) {
    return reason.map(function (_ref) {
      var responseName = _ref[0],
          subReason = _ref[1];
      return "subfields \"".concat(responseName, "\" conflict because ") + reasonMessage(subReason);
    }).join(' and ');
  }

  return reason;
}
/**
 * Overlapping fields can be merged
 *
 * A selection set is only valid if all fields (including spreading any
 * fragments) either correspond to distinct response names or can be merged
 * without ambiguity.
 */


function OverlappingFieldsCanBeMergedRule(context) {
  // A memoization for when two fragments are compared "between" each other for
  // conflicts. Two fragments may be compared many times, so memoizing this can
  // dramatically improve the performance of this validator.
  var comparedFragmentPairs = new PairSet(); // A cache for the "field map" and list of fragment names found in any given
  // selection set. Selection sets may be asked for this information multiple
  // times, so this improves the performance of this validator.

  var cachedFieldsAndFragmentNames = new Map();
  return {
    SelectionSet: function SelectionSet(selectionSet) {
      var conflicts = findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, context.getParentType(), selectionSet);

      for (var _i2 = 0; _i2 < conflicts.length; _i2++) {
        var _ref3 = conflicts[_i2];
        var _ref2$ = _ref3[0];
        var responseName = _ref2$[0];
        var reason = _ref2$[1];
        var fields1 = _ref3[1];
        var fields2 = _ref3[2];
        var reasonMsg = reasonMessage(reason);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__["a" /* GraphQLError */]("Fields \"".concat(responseName, "\" conflict because ").concat(reasonMsg, ". Use different aliases on the fields to fetch both if this was intentional."), fields1.concat(fields2)));
      }
    }
  };
}

/**
 * Algorithm:
 *
 * Conflicts occur when two fields exist in a query which will produce the same
 * response name, but represent differing values, thus creating a conflict.
 * The algorithm below finds all conflicts via making a series of comparisons
 * between fields. In order to compare as few fields as possible, this makes
 * a series of comparisons "within" sets of fields and "between" sets of fields.
 *
 * Given any selection set, a collection produces both a set of fields by
 * also including all inline fragments, as well as a list of fragments
 * referenced by fragment spreads.
 *
 * A) Each selection set represented in the document first compares "within" its
 * collected set of fields, finding any conflicts between every pair of
 * overlapping fields.
 * Note: This is the *only time* that a the fields "within" a set are compared
 * to each other. After this only fields "between" sets are compared.
 *
 * B) Also, if any fragment is referenced in a selection set, then a
 * comparison is made "between" the original set of fields and the
 * referenced fragment.
 *
 * C) Also, if multiple fragments are referenced, then comparisons
 * are made "between" each referenced fragment.
 *
 * D) When comparing "between" a set of fields and a referenced fragment, first
 * a comparison is made between each field in the original set of fields and
 * each field in the the referenced set of fields.
 *
 * E) Also, if any fragment is referenced in the referenced selection set,
 * then a comparison is made "between" the original set of fields and the
 * referenced fragment (recursively referring to step D).
 *
 * F) When comparing "between" two fragments, first a comparison is made between
 * each field in the first referenced set of fields and each field in the the
 * second referenced set of fields.
 *
 * G) Also, any fragments referenced by the first must be compared to the
 * second, and any fragments referenced by the second must be compared to the
 * first (recursively referring to step F).
 *
 * H) When comparing two fields, if both have selection sets, then a comparison
 * is made "between" both selection sets, first comparing the set of fields in
 * the first selection set with the set of fields in the second.
 *
 * I) Also, if any fragment is referenced in either selection set, then a
 * comparison is made "between" the other set of fields and the
 * referenced fragment.
 *
 * J) Also, if two fragments are referenced in both selection sets, then a
 * comparison is made "between" the two fragments.
 *
 */
// Find all conflicts found "within" a selection set, including those found
// via spreading in fragments. Called when visiting each SelectionSet in the
// GraphQL Document.
function findConflictsWithinSelectionSet(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentType, selectionSet) {
  var conflicts = [];

  var _getFieldsAndFragment = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet),
      fieldMap = _getFieldsAndFragment[0],
      fragmentNames = _getFieldsAndFragment[1]; // (A) Find find all conflicts "within" the fields of this selection set.
  // Note: this is the *only place* `collectConflictsWithin` is called.


  collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap);

  if (fragmentNames.length !== 0) {
    // (B) Then collect conflicts between these fields and those represented by
    // each spread fragment name found.
    for (var i = 0; i < fragmentNames.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fieldMap, fragmentNames[i]); // (C) Then compare this fragment with all other fragments found in this
      // selection set to collect conflicts between fragments spread together.
      // This compares each item in the list of fragment names to every other
      // item in that same list (except for itself).

      for (var j = i + 1; j < fragmentNames.length; j++) {
        collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, fragmentNames[i], fragmentNames[j]);
      }
    }
  }

  return conflicts;
} // Collect all conflicts found between a set of fields and a fragment reference
// including via spreading in any nested fragments.


function collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentName) {
  var fragment = context.getFragment(fragmentName);

  if (!fragment) {
    return;
  }

  var _getReferencedFieldsA = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment),
      fieldMap2 = _getReferencedFieldsA[0],
      fragmentNames2 = _getReferencedFieldsA[1]; // Do not compare a fragment's fieldMap to itself.


  if (fieldMap === fieldMap2) {
    return;
  } // (D) First collect any conflicts between the provided collection of fields
  // and the collection of fields represented by the given fragment.


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fieldMap2); // (E) Then collect any conflicts between the provided collection of fields
  // and any fragment names found in the given fragment.

  for (var i = 0; i < fragmentNames2.length; i++) {
    collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap, fragmentNames2[i]);
  }
} // Collect all conflicts found between two fragments, including via spreading in
// any nested fragments.


function collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentName2) {
  // No need to compare a fragment to itself.
  if (fragmentName1 === fragmentName2) {
    return;
  } // Memoize so two fragments are not compared for conflicts more than once.


  if (comparedFragmentPairs.has(fragmentName1, fragmentName2, areMutuallyExclusive)) {
    return;
  }

  comparedFragmentPairs.add(fragmentName1, fragmentName2, areMutuallyExclusive);
  var fragment1 = context.getFragment(fragmentName1);
  var fragment2 = context.getFragment(fragmentName2);

  if (!fragment1 || !fragment2) {
    return;
  }

  var _getReferencedFieldsA2 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment1),
      fieldMap1 = _getReferencedFieldsA2[0],
      fragmentNames1 = _getReferencedFieldsA2[1];

  var _getReferencedFieldsA3 = getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment2),
      fieldMap2 = _getReferencedFieldsA3[0],
      fragmentNames2 = _getReferencedFieldsA3[1]; // (F) First, collect all conflicts between these two collections of fields
  // (not including any nested fragments).


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (G) Then collect conflicts between the first fragment and any nested
  // fragments spread in the second fragment.

  for (var j = 0; j < fragmentNames2.length; j++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentName1, fragmentNames2[j]);
  } // (G) Then collect conflicts between the second fragment and any nested
  // fragments spread in the first fragment.


  for (var i = 0; i < fragmentNames1.length; i++) {
    collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[i], fragmentName2);
  }
} // Find all conflicts found between two selection sets, including those found
// via spreading in fragments. Called when determining if conflicts exist
// between the sub-fields of two overlapping fields.


function findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, parentType1, selectionSet1, parentType2, selectionSet2) {
  var conflicts = [];

  var _getFieldsAndFragment2 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType1, selectionSet1),
      fieldMap1 = _getFieldsAndFragment2[0],
      fragmentNames1 = _getFieldsAndFragment2[1];

  var _getFieldsAndFragment3 = getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType2, selectionSet2),
      fieldMap2 = _getFieldsAndFragment3[0],
      fragmentNames2 = _getFieldsAndFragment3[1]; // (H) First, collect all conflicts between these two collections of field.


  collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fieldMap2); // (I) Then collect conflicts between the first collection of fields and
  // those referenced by each fragment name associated with the second.

  if (fragmentNames2.length !== 0) {
    for (var j = 0; j < fragmentNames2.length; j++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap1, fragmentNames2[j]);
    }
  } // (I) Then collect conflicts between the second collection of fields and
  // those referenced by each fragment name associated with the first.


  if (fragmentNames1.length !== 0) {
    for (var i = 0; i < fragmentNames1.length; i++) {
      collectConflictsBetweenFieldsAndFragment(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fieldMap2, fragmentNames1[i]);
    }
  } // (J) Also collect conflicts between any fragment names by the first and
  // fragment names by the second. This compares each item in the first set of
  // names to each item in the second set of names.


  for (var _i3 = 0; _i3 < fragmentNames1.length; _i3++) {
    for (var _j = 0; _j < fragmentNames2.length; _j++) {
      collectConflictsBetweenFragments(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, fragmentNames1[_i3], fragmentNames2[_j]);
    }
  }

  return conflicts;
} // Collect all Conflicts "within" one collection of fields.


function collectConflictsWithin(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, fieldMap) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For every response name, if there are multiple fields, they
  // must be compared to find a potential conflict.
  for (var _i5 = 0, _objectEntries2 = Object(__WEBPACK_IMPORTED_MODULE_1__polyfills_objectEntries_mjs__["a" /* default */])(fieldMap); _i5 < _objectEntries2.length; _i5++) {
    var _ref5 = _objectEntries2[_i5];
    var responseName = _ref5[0];
    var fields = _ref5[1];

    // This compares every field in the list to every other field in this list
    // (except to itself). If the list only has one item, nothing needs to
    // be compared.
    if (fields.length > 1) {
      for (var i = 0; i < fields.length; i++) {
        for (var j = i + 1; j < fields.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, false, // within one collection is never mutually exclusive
          responseName, fields[i], fields[j]);

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Collect all Conflicts between two collections of fields. This is similar to,
// but different from the `collectConflictsWithin` function above. This check
// assumes that `collectConflictsWithin` has already been called on each
// provided collection of fields. This is true because this validator traverses
// each individual selection set.


function collectConflictsBetween(context, conflicts, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, fieldMap1, fieldMap2) {
  // A field map is a keyed collection, where each key represents a response
  // name and the value at that key is a list of all fields which provide that
  // response name. For any response name which appears in both provided field
  // maps, each field from the first field map must be compared to every field
  // in the second field map to find potential conflicts.
  for (var _i7 = 0, _Object$keys2 = Object.keys(fieldMap1); _i7 < _Object$keys2.length; _i7++) {
    var responseName = _Object$keys2[_i7];
    var fields2 = fieldMap2[responseName];

    if (fields2) {
      var fields1 = fieldMap1[responseName];

      for (var i = 0; i < fields1.length; i++) {
        for (var j = 0; j < fields2.length; j++) {
          var conflict = findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, fields1[i], fields2[j]);

          if (conflict) {
            conflicts.push(conflict);
          }
        }
      }
    }
  }
} // Determines if there is a conflict between two particular fields, including
// comparing their sub-fields.


function findConflict(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, parentFieldsAreMutuallyExclusive, responseName, field1, field2) {
  var parentType1 = field1[0],
      node1 = field1[1],
      def1 = field1[2];
  var parentType2 = field2[0],
      node2 = field2[1],
      def2 = field2[2]; // If it is known that two fields could not possibly apply at the same
  // time, due to the parent types, then it is safe to permit them to diverge
  // in aliased field or arguments used as they will not present any ambiguity
  // by differing.
  // It is known that two parent types could never overlap if they are
  // different Object types. Interface or Union types might overlap - if not
  // in the current state of the schema, then perhaps in some future version,
  // thus may not safely diverge.

  var areMutuallyExclusive = parentFieldsAreMutuallyExclusive || parentType1 !== parentType2 && Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["y" /* isObjectType */])(parentType1) && Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["y" /* isObjectType */])(parentType2);

  if (!areMutuallyExclusive) {
    var _node1$arguments, _node2$arguments;

    // Two aliases must refer to the same field.
    var name1 = node1.name.value;
    var name2 = node2.name.value;

    if (name1 !== name2) {
      return [[responseName, "\"".concat(name1, "\" and \"").concat(name2, "\" are different fields")], [node1], [node2]];
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')


    var args1 = (_node1$arguments = node1.arguments) !== null && _node1$arguments !== void 0 ? _node1$arguments : []; // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')

    var args2 = (_node2$arguments = node2.arguments) !== null && _node2$arguments !== void 0 ? _node2$arguments : []; // Two field calls must have the same arguments.

    if (!sameArguments(args1, args2)) {
      return [[responseName, 'they have differing arguments'], [node1], [node2]];
    }
  } // The return type for each field.


  var type1 = def1 === null || def1 === void 0 ? void 0 : def1.type;
  var type2 = def2 === null || def2 === void 0 ? void 0 : def2.type;

  if (type1 && type2 && doTypesConflict(type1, type2)) {
    return [[responseName, "they return conflicting types \"".concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type1), "\" and \"").concat(Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type2), "\"")], [node1], [node2]];
  } // Collect and compare sub-fields. Use the same "visited fragment names" list
  // for both collections so fields in a fragment reference are never
  // compared to themselves.


  var selectionSet1 = node1.selectionSet;
  var selectionSet2 = node2.selectionSet;

  if (selectionSet1 && selectionSet2) {
    var conflicts = findConflictsBetweenSubSelectionSets(context, cachedFieldsAndFragmentNames, comparedFragmentPairs, areMutuallyExclusive, Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["m" /* getNamedType */])(type1), selectionSet1, Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["m" /* getNamedType */])(type2), selectionSet2);
    return subfieldConflicts(conflicts, responseName, node1, node2);
  }
}

function sameArguments(arguments1, arguments2) {
  if (arguments1.length !== arguments2.length) {
    return false;
  }

  return arguments1.every(function (argument1) {
    var argument2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_find_mjs__["a" /* default */])(arguments2, function (argument) {
      return argument.name.value === argument1.name.value;
    });

    if (!argument2) {
      return false;
    }

    return sameValue(argument1.value, argument2.value);
  });
}

function sameValue(value1, value2) {
  return Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(value1) === Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(value2);
} // Two types conflict if both types could not apply to a value simultaneously.
// Composite types are ignored as their individual field types will be compared
// later recursively. However List and Non-Null types must match.


function doTypesConflict(type1, type2) {
  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["v" /* isListType */])(type1)) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["v" /* isListType */])(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["v" /* isListType */])(type2)) {
    return true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["x" /* isNonNullType */])(type1)) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["x" /* isNonNullType */])(type2) ? doTypesConflict(type1.ofType, type2.ofType) : true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["x" /* isNonNullType */])(type2)) {
    return true;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["u" /* isLeafType */])(type1) || Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["u" /* isLeafType */])(type2)) {
    return type1 !== type2;
  }

  return false;
} // Given a selection set, return the collection of fields (a mapping of response
// name to field nodes and definitions) as well as a list of fragment names
// referenced via fragment spreads.


function getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, parentType, selectionSet) {
  var cached = cachedFieldsAndFragmentNames.get(selectionSet);

  if (!cached) {
    var nodeAndDefs = Object.create(null);
    var fragmentNames = Object.create(null);

    _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames);

    cached = [nodeAndDefs, Object.keys(fragmentNames)];
    cachedFieldsAndFragmentNames.set(selectionSet, cached);
  }

  return cached;
} // Given a reference to a fragment, return the represented collection of fields
// as well as a list of nested fragment names referenced via fragment spreads.


function getReferencedFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragment) {
  // Short-circuit building a type from the node if possible.
  var cached = cachedFieldsAndFragmentNames.get(fragment.selectionSet);

  if (cached) {
    return cached;
  }

  var fragmentType = Object(__WEBPACK_IMPORTED_MODULE_7__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), fragment.typeCondition);
  return getFieldsAndFragmentNames(context, cachedFieldsAndFragmentNames, fragmentType, fragment.selectionSet);
}

function _collectFieldsAndFragmentNames(context, parentType, selectionSet, nodeAndDefs, fragmentNames) {
  for (var _i9 = 0, _selectionSet$selecti2 = selectionSet.selections; _i9 < _selectionSet$selecti2.length; _i9++) {
    var selection = _selectionSet$selecti2[_i9];

    switch (selection.kind) {
      case __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].FIELD:
        {
          var fieldName = selection.name.value;
          var fieldDef = void 0;

          if (Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["y" /* isObjectType */])(parentType) || Object(__WEBPACK_IMPORTED_MODULE_6__type_definition_mjs__["t" /* isInterfaceType */])(parentType)) {
            fieldDef = parentType.getFields()[fieldName];
          }

          var responseName = selection.alias ? selection.alias.value : fieldName;

          if (!nodeAndDefs[responseName]) {
            nodeAndDefs[responseName] = [];
          }

          nodeAndDefs[responseName].push([parentType, selection, fieldDef]);
          break;
        }

      case __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD:
        fragmentNames[selection.name.value] = true;
        break;

      case __WEBPACK_IMPORTED_MODULE_4__language_kinds_mjs__["a" /* Kind */].INLINE_FRAGMENT:
        {
          var typeCondition = selection.typeCondition;
          var inlineFragmentType = typeCondition ? Object(__WEBPACK_IMPORTED_MODULE_7__utilities_typeFromAST_mjs__["a" /* typeFromAST */])(context.getSchema(), typeCondition) : parentType;

          _collectFieldsAndFragmentNames(context, inlineFragmentType, selection.selectionSet, nodeAndDefs, fragmentNames);

          break;
        }
    }
  }
} // Given a series of Conflicts which occurred between two sub-fields, generate
// a single Conflict.


function subfieldConflicts(conflicts, responseName, node1, node2) {
  if (conflicts.length > 0) {
    return [[responseName, conflicts.map(function (_ref6) {
      var reason = _ref6[0];
      return reason;
    })], conflicts.reduce(function (allFields, _ref7) {
      var fields1 = _ref7[1];
      return allFields.concat(fields1);
    }, [node1]), conflicts.reduce(function (allFields, _ref8) {
      var fields2 = _ref8[2];
      return allFields.concat(fields2);
    }, [node2])];
  }
}
/**
 * A way to keep track of pairs of things when the ordering of the pair does
 * not matter. We do this by maintaining a sort of double adjacency sets.
 */


var PairSet = /*#__PURE__*/function () {
  function PairSet() {
    this._data = Object.create(null);
  }

  var _proto = PairSet.prototype;

  _proto.has = function has(a, b, areMutuallyExclusive) {
    var first = this._data[a];
    var result = first && first[b];

    if (result === undefined) {
      return false;
    } // areMutuallyExclusive being false is a superset of being true,
    // hence if we want to know if this PairSet "has" these two with no
    // exclusivity, we have to ensure it was added as such.


    if (areMutuallyExclusive === false) {
      return result === false;
    }

    return true;
  };

  _proto.add = function add(a, b, areMutuallyExclusive) {
    this._pairSetAdd(a, b, areMutuallyExclusive);

    this._pairSetAdd(b, a, areMutuallyExclusive);
  };

  _proto._pairSetAdd = function _pairSetAdd(a, b, areMutuallyExclusive) {
    var map = this._data[a];

    if (!map) {
      map = Object.create(null);
      this._data[a] = map;
    }

    map[b] = areMutuallyExclusive;
  };

  return PairSet;
}();


/***/ }),
/* 575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueInputFieldNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique input field names
 *
 * A GraphQL input object value is only valid if all supplied fields are
 * uniquely named.
 */
function UniqueInputFieldNamesRule(context) {
  var knownNameStack = [];
  var knownNames = Object.create(null);
  return {
    ObjectValue: {
      enter: function enter() {
        knownNameStack.push(knownNames);
        knownNames = Object.create(null);
      },
      leave: function leave() {
        knownNames = knownNameStack.pop();
      }
    },
    ObjectField: function ObjectField(node) {
      var fieldName = node.name.value;

      if (knownNames[fieldName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one input field named \"".concat(fieldName, "\"."), [knownNames[fieldName], node.name]));
      } else {
        knownNames[fieldName] = node.name;
      }
    }
  };
}


/***/ }),
/* 576 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = LoneSchemaDefinitionRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Lone Schema definition
 *
 * A GraphQL document is only valid if it contains only one schema definition.
 */
function LoneSchemaDefinitionRule(context) {
  var _ref, _ref2, _oldSchema$astNode;

  var oldSchema = context.getSchema();
  var alreadyDefined = (_ref = (_ref2 = (_oldSchema$astNode = oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.astNode) !== null && _oldSchema$astNode !== void 0 ? _oldSchema$astNode : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getQueryType()) !== null && _ref2 !== void 0 ? _ref2 : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getMutationType()) !== null && _ref !== void 0 ? _ref : oldSchema === null || oldSchema === void 0 ? void 0 : oldSchema.getSubscriptionType();
  var schemaDefinitionsCount = 0;
  return {
    SchemaDefinition: function SchemaDefinition(node) {
      if (alreadyDefined) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Cannot define a new schema within a schema extension.', node));
        return;
      }

      if (schemaDefinitionsCount > 0) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]('Must provide only one schema definition.', node));
      }

      ++schemaDefinitionsCount;
    }
  };
}


/***/ }),
/* 577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueOperationTypesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique operation types
 *
 * A GraphQL document is only valid if it has only one type per operation.
 */
function UniqueOperationTypesRule(context) {
  var schema = context.getSchema();
  var definedOperationTypes = Object.create(null);
  var existingOperationTypes = schema ? {
    query: schema.getQueryType(),
    mutation: schema.getMutationType(),
    subscription: schema.getSubscriptionType()
  } : {};
  return {
    SchemaDefinition: checkOperationTypes,
    SchemaExtension: checkOperationTypes
  };

  function checkOperationTypes(node) {
    var _node$operationTypes;

    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];

    for (var _i2 = 0; _i2 < operationTypesNodes.length; _i2++) {
      var operationType = operationTypesNodes[_i2];
      var operation = operationType.operation;
      var alreadyDefinedOperationType = definedOperationTypes[operation];

      if (existingOperationTypes[operation]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Type for ".concat(operation, " already defined in the schema. It cannot be redefined."), operationType));
      } else if (alreadyDefinedOperationType) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one ".concat(operation, " type in schema."), [alreadyDefinedOperationType, operationType]));
      } else {
        definedOperationTypes[operation] = operationType;
      }
    }

    return false;
  }
}


/***/ }),
/* 578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueTypeNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique type names
 *
 * A GraphQL document is only valid if all defined types have unique names.
 */
function UniqueTypeNamesRule(context) {
  var knownTypeNames = Object.create(null);
  var schema = context.getSchema();
  return {
    ScalarTypeDefinition: checkTypeName,
    ObjectTypeDefinition: checkTypeName,
    InterfaceTypeDefinition: checkTypeName,
    UnionTypeDefinition: checkTypeName,
    EnumTypeDefinition: checkTypeName,
    InputObjectTypeDefinition: checkTypeName
  };

  function checkTypeName(node) {
    var typeName = node.name.value;

    if (schema !== null && schema !== void 0 && schema.getType(typeName)) {
      context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Type \"".concat(typeName, "\" already exists in the schema. It cannot also be defined in this type definition."), node.name));
      return;
    }

    if (knownTypeNames[typeName]) {
      context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one type named \"".concat(typeName, "\"."), [knownTypeNames[typeName], node.name]));
    } else {
      knownTypeNames[typeName] = node.name;
    }

    return false;
  }
}


/***/ }),
/* 579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueEnumValueNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__ = __webpack_require__(20);



/**
 * Unique enum value names
 *
 * A GraphQL enum type is only valid if all its values are uniquely named.
 */
function UniqueEnumValueNamesRule(context) {
  var schema = context.getSchema();
  var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  var knownValueNames = Object.create(null);
  return {
    EnumTypeDefinition: checkValueUniqueness,
    EnumTypeExtension: checkValueUniqueness
  };

  function checkValueUniqueness(node) {
    var _node$values;

    var typeName = node.name.value;

    if (!knownValueNames[typeName]) {
      knownValueNames[typeName] = Object.create(null);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')


    var valueNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];
    var valueNames = knownValueNames[typeName];

    for (var _i2 = 0; _i2 < valueNodes.length; _i2++) {
      var valueDef = valueNodes[_i2];
      var valueName = valueDef.name.value;
      var existingType = existingTypeMap[typeName];

      if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__["q" /* isEnumType */])(existingType) && existingType.getValue(valueName)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Enum value \"".concat(typeName, ".").concat(valueName, "\" already exists in the schema. It cannot also be defined in this type extension."), valueDef.name));
      } else if (valueNames[valueName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Enum value \"".concat(typeName, ".").concat(valueName, "\" can only be defined once."), [valueNames[valueName], valueDef.name]));
      } else {
        valueNames[valueName] = valueDef.name;
      }
    }

    return false;
  }
}


/***/ }),
/* 580 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueFieldDefinitionNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__ = __webpack_require__(20);



/**
 * Unique field definition names
 *
 * A GraphQL complex type is only valid if all its fields are uniquely named.
 */
function UniqueFieldDefinitionNamesRule(context) {
  var schema = context.getSchema();
  var existingTypeMap = schema ? schema.getTypeMap() : Object.create(null);
  var knownFieldNames = Object.create(null);
  return {
    InputObjectTypeDefinition: checkFieldUniqueness,
    InputObjectTypeExtension: checkFieldUniqueness,
    InterfaceTypeDefinition: checkFieldUniqueness,
    InterfaceTypeExtension: checkFieldUniqueness,
    ObjectTypeDefinition: checkFieldUniqueness,
    ObjectTypeExtension: checkFieldUniqueness
  };

  function checkFieldUniqueness(node) {
    var _node$fields;

    var typeName = node.name.value;

    if (!knownFieldNames[typeName]) {
      knownFieldNames[typeName] = Object.create(null);
    } // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')


    var fieldNodes = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];
    var fieldNames = knownFieldNames[typeName];

    for (var _i2 = 0; _i2 < fieldNodes.length; _i2++) {
      var fieldDef = fieldNodes[_i2];
      var fieldName = fieldDef.name.value;

      if (hasField(existingTypeMap[typeName], fieldName)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(typeName, ".").concat(fieldName, "\" already exists in the schema. It cannot also be defined in this type extension."), fieldDef.name));
      } else if (fieldNames[fieldName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(typeName, ".").concat(fieldName, "\" can only be defined once."), [fieldNames[fieldName], fieldDef.name]));
      } else {
        fieldNames[fieldName] = fieldDef.name;
      }
    }

    return false;
  }
}

function hasField(type, fieldName) {
  if (Object(__WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__["y" /* isObjectType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__["t" /* isInterfaceType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    return type.getFields()[fieldName] != null;
  }

  return false;
}


/***/ }),
/* 581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = UniqueDirectiveNamesRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);


/**
 * Unique directive names
 *
 * A GraphQL document is only valid if all defined directives have unique names.
 */
function UniqueDirectiveNamesRule(context) {
  var knownDirectiveNames = Object.create(null);
  var schema = context.getSchema();
  return {
    DirectiveDefinition: function DirectiveDefinition(node) {
      var directiveName = node.name.value;

      if (schema !== null && schema !== void 0 && schema.getDirective(directiveName)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("Directive \"@".concat(directiveName, "\" already exists in the schema. It cannot be redefined."), node.name));
        return;
      }

      if (knownDirectiveNames[directiveName]) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("There can be only one directive named \"@".concat(directiveName, "\"."), [knownDirectiveNames[directiveName], node.name]));
      } else {
        knownDirectiveNames[directiveName] = node.name;
      }

      return false;
    }
  };
}


/***/ }),
/* 582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = PossibleTypeExtensionsRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_predicates_mjs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__ = __webpack_require__(20);
var _defKindToExtKind;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










/**
 * Possible type extension
 *
 * A type extension is only valid if the type is defined and has the same kind.
 */
function PossibleTypeExtensionsRule(context) {
  var schema = context.getSchema();
  var definedTypes = Object.create(null);

  for (var _i2 = 0, _context$getDocument$2 = context.getDocument().definitions; _i2 < _context$getDocument$2.length; _i2++) {
    var def = _context$getDocument$2[_i2];

    if (Object(__WEBPACK_IMPORTED_MODULE_6__language_predicates_mjs__["b" /* isTypeDefinitionNode */])(def)) {
      definedTypes[def.name.value] = def;
    }
  }

  return {
    ScalarTypeExtension: checkExtension,
    ObjectTypeExtension: checkExtension,
    InterfaceTypeExtension: checkExtension,
    UnionTypeExtension: checkExtension,
    EnumTypeExtension: checkExtension,
    InputObjectTypeExtension: checkExtension
  };

  function checkExtension(node) {
    var typeName = node.name.value;
    var defNode = definedTypes[typeName];
    var existingType = schema === null || schema === void 0 ? void 0 : schema.getType(typeName);
    var expectedKind;

    if (defNode) {
      expectedKind = defKindToExtKind[defNode.kind];
    } else if (existingType) {
      expectedKind = typeToExtKind(existingType);
    }

    if (expectedKind) {
      if (expectedKind !== node.kind) {
        var kindStr = extensionKindToTypeName(node.kind);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Cannot extend non-".concat(kindStr, " type \"").concat(typeName, "\"."), defNode ? [defNode, node] : node));
      }
    } else {
      var allTypeNames = Object.keys(definedTypes);

      if (schema) {
        allTypeNames = allTypeNames.concat(Object.keys(schema.getTypeMap()));
      }

      var suggestedTypes = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_suggestionList_mjs__["a" /* default */])(typeName, allTypeNames);
      context.reportError(new __WEBPACK_IMPORTED_MODULE_4__error_GraphQLError_mjs__["a" /* GraphQLError */]("Cannot extend type \"".concat(typeName, "\" because it is not defined.") + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_didYouMean_mjs__["a" /* default */])(suggestedTypes), node.name));
    }
  }
}
var defKindToExtKind = (_defKindToExtKind = {}, _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION), _defineProperty(_defKindToExtKind, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION, __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION), _defKindToExtKind);

function typeToExtKind(type) {
  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["C" /* isScalarType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["y" /* isObjectType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["E" /* isUnionType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["q" /* isEnumType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION;
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_7__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    return __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION;
  } // istanbul ignore next (Not reachable. All possible types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(type));
}

function extensionKindToTypeName(kind) {
  switch (kind) {
    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_EXTENSION:
      return 'scalar';

    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_EXTENSION:
      return 'object';

    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_EXTENSION:
      return 'interface';

    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_EXTENSION:
      return 'union';

    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_EXTENSION:
      return 'enum';

    case __WEBPACK_IMPORTED_MODULE_5__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_EXTENSION:
      return 'input object';
  } // istanbul ignore next (Not reachable. All possible types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected kind: ' + Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(kind));
}


/***/ }),
/* 583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ASTValidationContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SDLValidationContext; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ValidationContext; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_visitor_mjs__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utilities_TypeInfo_mjs__ = __webpack_require__(309);
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }





/**
 * An instance of this class is passed as the "this" context to all validators,
 * allowing access to commonly useful contextual information from within a
 * validation rule.
 */
var ASTValidationContext = /*#__PURE__*/function () {
  function ASTValidationContext(ast, onError) {
    this._ast = ast;
    this._fragments = undefined;
    this._fragmentSpreads = new Map();
    this._recursivelyReferencedFragments = new Map();
    this._onError = onError;
  }

  var _proto = ASTValidationContext.prototype;

  _proto.reportError = function reportError(error) {
    this._onError(error);
  };

  _proto.getDocument = function getDocument() {
    return this._ast;
  };

  _proto.getFragment = function getFragment(name) {
    var fragments = this._fragments;

    if (!fragments) {
      this._fragments = fragments = this.getDocument().definitions.reduce(function (frags, statement) {
        if (statement.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION) {
          frags[statement.name.value] = statement;
        }

        return frags;
      }, Object.create(null));
    }

    return fragments[name];
  };

  _proto.getFragmentSpreads = function getFragmentSpreads(node) {
    var spreads = this._fragmentSpreads.get(node);

    if (!spreads) {
      spreads = [];
      var setsToVisit = [node];

      while (setsToVisit.length !== 0) {
        var set = setsToVisit.pop();

        for (var _i2 = 0, _set$selections2 = set.selections; _i2 < _set$selections2.length; _i2++) {
          var selection = _set$selections2[_i2];

          if (selection.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].FRAGMENT_SPREAD) {
            spreads.push(selection);
          } else if (selection.selectionSet) {
            setsToVisit.push(selection.selectionSet);
          }
        }
      }

      this._fragmentSpreads.set(node, spreads);
    }

    return spreads;
  };

  _proto.getRecursivelyReferencedFragments = function getRecursivelyReferencedFragments(operation) {
    var fragments = this._recursivelyReferencedFragments.get(operation);

    if (!fragments) {
      fragments = [];
      var collectedNames = Object.create(null);
      var nodesToVisit = [operation.selectionSet];

      while (nodesToVisit.length !== 0) {
        var node = nodesToVisit.pop();

        for (var _i4 = 0, _this$getFragmentSpre2 = this.getFragmentSpreads(node); _i4 < _this$getFragmentSpre2.length; _i4++) {
          var spread = _this$getFragmentSpre2[_i4];
          var fragName = spread.name.value;

          if (collectedNames[fragName] !== true) {
            collectedNames[fragName] = true;
            var fragment = this.getFragment(fragName);

            if (fragment) {
              fragments.push(fragment);
              nodesToVisit.push(fragment.selectionSet);
            }
          }
        }
      }

      this._recursivelyReferencedFragments.set(operation, fragments);
    }

    return fragments;
  };

  return ASTValidationContext;
}();
var SDLValidationContext = /*#__PURE__*/function (_ASTValidationContext) {
  _inheritsLoose(SDLValidationContext, _ASTValidationContext);

  function SDLValidationContext(ast, schema, onError) {
    var _this;

    _this = _ASTValidationContext.call(this, ast, onError) || this;
    _this._schema = schema;
    return _this;
  }

  var _proto2 = SDLValidationContext.prototype;

  _proto2.getSchema = function getSchema() {
    return this._schema;
  };

  return SDLValidationContext;
}(ASTValidationContext);
var ValidationContext = /*#__PURE__*/function (_ASTValidationContext2) {
  _inheritsLoose(ValidationContext, _ASTValidationContext2);

  function ValidationContext(schema, ast, typeInfo, onError) {
    var _this2;

    _this2 = _ASTValidationContext2.call(this, ast, onError) || this;
    _this2._schema = schema;
    _this2._typeInfo = typeInfo;
    _this2._variableUsages = new Map();
    _this2._recursiveVariableUsages = new Map();
    return _this2;
  }

  var _proto3 = ValidationContext.prototype;

  _proto3.getSchema = function getSchema() {
    return this._schema;
  };

  _proto3.getVariableUsages = function getVariableUsages(node) {
    var usages = this._variableUsages.get(node);

    if (!usages) {
      var newUsages = [];
      var typeInfo = new __WEBPACK_IMPORTED_MODULE_2__utilities_TypeInfo_mjs__["a" /* TypeInfo */](this._schema);
      Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor_mjs__["b" /* visit */])(node, Object(__WEBPACK_IMPORTED_MODULE_2__utilities_TypeInfo_mjs__["b" /* visitWithTypeInfo */])(typeInfo, {
        VariableDefinition: function VariableDefinition() {
          return false;
        },
        Variable: function Variable(variable) {
          newUsages.push({
            node: variable,
            type: typeInfo.getInputType(),
            defaultValue: typeInfo.getDefaultValue()
          });
        }
      }));
      usages = newUsages;

      this._variableUsages.set(node, usages);
    }

    return usages;
  };

  _proto3.getRecursiveVariableUsages = function getRecursiveVariableUsages(operation) {
    var usages = this._recursiveVariableUsages.get(operation);

    if (!usages) {
      usages = this.getVariableUsages(operation);

      for (var _i6 = 0, _this$getRecursivelyR2 = this.getRecursivelyReferencedFragments(operation); _i6 < _this$getRecursivelyR2.length; _i6++) {
        var frag = _this$getRecursivelyR2[_i6];
        usages = usages.concat(this.getVariableUsages(frag));
      }

      this._recursiveVariableUsages.set(operation, usages);
    }

    return usages;
  };

  _proto3.getType = function getType() {
    return this._typeInfo.getType();
  };

  _proto3.getParentType = function getParentType() {
    return this._typeInfo.getParentType();
  };

  _proto3.getInputType = function getInputType() {
    return this._typeInfo.getInputType();
  };

  _proto3.getParentInputType = function getParentInputType() {
    return this._typeInfo.getParentInputType();
  };

  _proto3.getFieldDef = function getFieldDef() {
    return this._typeInfo.getFieldDef();
  };

  _proto3.getDirective = function getDirective() {
    return this._typeInfo.getDirective();
  };

  _proto3.getArgument = function getArgument() {
    return this._typeInfo.getArgument();
  };

  _proto3.getEnumValue = function getEnumValue() {
    return this._typeInfo.getEnumValue();
  };

  return ValidationContext;
}(ASTValidationContext);


/***/ }),
/* 584 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = printPathArray;
/**
 * Build a string describing the path.
 */
function printPathArray(path) {
  return path.map(function (key) {
    return typeof key === 'number' ? '[' + key.toString() + ']' : '.' + key;
  }).join('');
}


/***/ }),
/* 585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = coerceInputValue;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_didYouMean_mjs__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_safeArrayFrom_mjs__ = __webpack_require__(308);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__jsutils_suggestionList_mjs__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__jsutils_printPathArray_mjs__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__ = __webpack_require__(20);












/**
 * Coerces a JavaScript value given a GraphQL Input Type.
 */
function coerceInputValue(inputValue, type) {
  var onError = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : defaultOnError;
  return coerceInputValueImpl(inputValue, type, onError);
}

function defaultOnError(path, invalidValue, error) {
  var errorPrefix = 'Invalid value ' + Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(invalidValue);

  if (path.length > 0) {
    errorPrefix += " at \"value".concat(Object(__WEBPACK_IMPORTED_MODULE_7__jsutils_printPathArray_mjs__["a" /* default */])(path), "\"");
  }

  error.message = errorPrefix + ': ' + error.message;
  throw error;
}

function coerceInputValueImpl(inputValue, type, onError, path) {
  if (Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["x" /* isNonNullType */])(type)) {
    if (inputValue != null) {
      return coerceInputValueImpl(inputValue, type.ofType, onError, path);
    }

    onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected non-nullable type \"".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type), "\" not to be null.")));
    return;
  }

  if (inputValue == null) {
    // Explicitly return the value null.
    return null;
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["v" /* isListType */])(type)) {
    var itemType = type.ofType;
    var coercedList = Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_safeArrayFrom_mjs__["a" /* default */])(inputValue, function (itemValue, index) {
      var itemPath = Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["a" /* addPath */])(path, index, undefined);
      return coerceInputValueImpl(itemValue, itemType, onError, itemPath);
    });

    if (coercedList != null) {
      return coercedList;
    } // Lists accept a non-list value as a list of one.


    return [coerceInputValueImpl(inputValue, itemType, onError, path)];
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    if (!Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__["a" /* default */])(inputValue)) {
      onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected type \"".concat(type.name, "\" to be an object.")));
      return;
    }

    var coercedValue = {};
    var fieldDefs = type.getFields();

    for (var _i2 = 0, _objectValues2 = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(fieldDefs); _i2 < _objectValues2.length; _i2++) {
      var field = _objectValues2[_i2];
      var fieldValue = inputValue[field.name];

      if (fieldValue === undefined) {
        if (field.defaultValue !== undefined) {
          coercedValue[field.name] = field.defaultValue;
        } else if (Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["x" /* isNonNullType */])(field.type)) {
          var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(field.type);
          onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(field.name, "\" of required type \"").concat(typeStr, "\" was not provided.")));
        }

        continue;
      }

      coercedValue[field.name] = coerceInputValueImpl(fieldValue, field.type, onError, Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["a" /* addPath */])(path, field.name, type.name));
    } // Ensure every provided field is defined.


    for (var _i4 = 0, _Object$keys2 = Object.keys(inputValue); _i4 < _Object$keys2.length; _i4++) {
      var fieldName = _Object$keys2[_i4];

      if (!fieldDefs[fieldName]) {
        var suggestions = Object(__WEBPACK_IMPORTED_MODULE_6__jsutils_suggestionList_mjs__["a" /* default */])(fieldName, Object.keys(type.getFields()));
        onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(fieldName, "\" is not defined by type \"").concat(type.name, "\".") + Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_didYouMean_mjs__["a" /* default */])(suggestions)));
      }
    }

    return coercedValue;
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["u" /* isLeafType */])(type)) {
    var parseResult; // Scalars and Enums determine if a input value is valid via parseValue(),
    // which can throw to indicate failure. If it throws, maintain a reference
    // to the original error.

    try {
      parseResult = type.parseValue(inputValue);
    } catch (error) {
      if (error instanceof __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]) {
        onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, error);
      } else {
        onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected type \"".concat(type.name, "\". ") + error.message, undefined, undefined, undefined, undefined, error));
      }

      return;
    }

    if (parseResult === undefined) {
      onError(Object(__WEBPACK_IMPORTED_MODULE_8__jsutils_Path_mjs__["b" /* pathToArray */])(path), inputValue, new __WEBPACK_IMPORTED_MODULE_9__error_GraphQLError_mjs__["a" /* GraphQLError */]("Expected type \"".concat(type.name, "\".")));
    }

    return parseResult;
  } // istanbul ignore next (Not reachable. All possible input types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected input type: ' + Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type));
}


/***/ }),
/* 586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = NoDeprecatedCustomRule;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__ = __webpack_require__(20);




/**
 * No deprecated
 *
 * A GraphQL document is only valid if all selected fields and all used enum values have not been
 * deprecated.
 *
 * Note: This rule is optional and is not part of the Validation section of the GraphQL
 * Specification. The main purpose of this rule is detection of deprecated usages and not
 * necessarily to forbid their use when querying a service.
 */
function NoDeprecatedCustomRule(context) {
  return {
    Field: function Field(node) {
      var fieldDef = context.getFieldDef();
      var deprecationReason = fieldDef === null || fieldDef === void 0 ? void 0 : fieldDef.deprecationReason;

      if (fieldDef && deprecationReason != null) {
        var parentType = context.getParentType();
        parentType != null || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__["a" /* default */])(0);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("The field ".concat(parentType.name, ".").concat(fieldDef.name, " is deprecated. ").concat(deprecationReason), node));
      }
    },
    Argument: function Argument(node) {
      var argDef = context.getArgument();
      var deprecationReason = argDef === null || argDef === void 0 ? void 0 : argDef.deprecationReason;

      if (argDef && deprecationReason != null) {
        var directiveDef = context.getDirective();

        if (directiveDef != null) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Directive \"@".concat(directiveDef.name, "\" argument \"").concat(argDef.name, "\" is deprecated. ").concat(deprecationReason), node));
        } else {
          var parentType = context.getParentType();
          var fieldDef = context.getFieldDef();
          parentType != null && fieldDef != null || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__["a" /* default */])(0);
          context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("Field \"".concat(parentType.name, ".").concat(fieldDef.name, "\" argument \"").concat(argDef.name, "\" is deprecated. ").concat(deprecationReason), node));
        }
      }
    },
    ObjectField: function ObjectField(node) {
      var inputObjectDef = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["m" /* getNamedType */])(context.getParentInputType());

      if (Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["r" /* isInputObjectType */])(inputObjectDef)) {
        var inputFieldDef = inputObjectDef.getFields()[node.name.value]; // flowlint-next-line unnecessary-optional-chain:off

        var deprecationReason = inputFieldDef === null || inputFieldDef === void 0 ? void 0 : inputFieldDef.deprecationReason;

        if (deprecationReason != null) {
          context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("The input field ".concat(inputObjectDef.name, ".").concat(inputFieldDef.name, " is deprecated. ").concat(deprecationReason), node));
        }
      }
    },
    EnumValue: function EnumValue(node) {
      var enumValueDef = context.getEnumValue();
      var deprecationReason = enumValueDef === null || enumValueDef === void 0 ? void 0 : enumValueDef.deprecationReason;

      if (enumValueDef && deprecationReason != null) {
        var enumTypeDef = Object(__WEBPACK_IMPORTED_MODULE_2__type_definition_mjs__["m" /* getNamedType */])(context.getInputType());
        enumTypeDef != null || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__["a" /* default */])(0);
        context.reportError(new __WEBPACK_IMPORTED_MODULE_1__error_GraphQLError_mjs__["a" /* GraphQLError */]("The enum value \"".concat(enumTypeDef.name, ".").concat(enumValueDef.name, "\" is deprecated. ").concat(deprecationReason), node));
      }
    }
  };
}


/***/ }),
/* 587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = getIntrospectionQuery;
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getIntrospectionQuery(options) {
  var optionsWithDefault = _objectSpread({
    descriptions: true,
    specifiedByUrl: false,
    directiveIsRepeatable: false,
    schemaDescription: false,
    inputValueDeprecation: false
  }, options);

  var descriptions = optionsWithDefault.descriptions ? 'description' : '';
  var specifiedByUrl = optionsWithDefault.specifiedByUrl ? 'specifiedByUrl' : '';
  var directiveIsRepeatable = optionsWithDefault.directiveIsRepeatable ? 'isRepeatable' : '';
  var schemaDescription = optionsWithDefault.schemaDescription ? descriptions : '';

  function inputDeprecation(str) {
    return optionsWithDefault.inputValueDeprecation ? str : '';
  }

  return "\n    query IntrospectionQuery {\n      __schema {\n        ".concat(schemaDescription, "\n        queryType { name }\n        mutationType { name }\n        subscriptionType { name }\n        types {\n          ...FullType\n        }\n        directives {\n          name\n          ").concat(descriptions, "\n          ").concat(directiveIsRepeatable, "\n          locations\n          args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n            ...InputValue\n          }\n        }\n      }\n    }\n\n    fragment FullType on __Type {\n      kind\n      name\n      ").concat(descriptions, "\n      ").concat(specifiedByUrl, "\n      fields(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        args").concat(inputDeprecation('(includeDeprecated: true)'), " {\n          ...InputValue\n        }\n        type {\n          ...TypeRef\n        }\n        isDeprecated\n        deprecationReason\n      }\n      inputFields").concat(inputDeprecation('(includeDeprecated: true)'), " {\n        ...InputValue\n      }\n      interfaces {\n        ...TypeRef\n      }\n      enumValues(includeDeprecated: true) {\n        name\n        ").concat(descriptions, "\n        isDeprecated\n        deprecationReason\n      }\n      possibleTypes {\n        ...TypeRef\n      }\n    }\n\n    fragment InputValue on __InputValue {\n      name\n      ").concat(descriptions, "\n      type { ...TypeRef }\n      defaultValue\n      ").concat(inputDeprecation('isDeprecated'), "\n      ").concat(inputDeprecation('deprecationReason'), "\n    }\n\n    fragment TypeRef on __Type {\n      kind\n      name\n      ofType {\n        kind\n        name\n        ofType {\n          kind\n          name\n          ofType {\n            kind\n            name\n            ofType {\n              kind\n              name\n              ofType {\n                kind\n                name\n                ofType {\n                  kind\n                  name\n                  ofType {\n                    kind\n                    name\n                  }\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  ");
}


/***/ }),
/* 588 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export extendSchema */
/* harmony export (immutable) */ __webpack_exports__["a"] = extendSchemaImpl;
/* unused harmony export getDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__language_tokenKind_mjs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__language_blockString_mjs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__language_predicates_mjs__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__validation_validate_mjs__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__execution_values_mjs__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__type_schema_mjs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__valueFromAST_mjs__ = __webpack_require__(210);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }




















/**
 * Produces a new schema given an existing schema and a document which may
 * contain GraphQL type extensions and definitions. The original schema will
 * remain unaltered.
 *
 * Because a schema represents a graph of references, a schema cannot be
 * extended without effectively making an entire copy. We do not know until it's
 * too late if subgraphs remain unchanged.
 *
 * This algorithm copies the provided schema, applying extensions while
 * producing the copy. The original schema remains unaltered.
 *
 * Accepts options as a third argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function extendSchema(schema, documentAST, options) {
  Object(__WEBPACK_IMPORTED_MODULE_12__type_schema_mjs__["b" /* assertSchema */])(schema);
  documentAST != null && documentAST.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].DOCUMENT || Object(__WEBPACK_IMPORTED_MODULE_5__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide valid Document AST.');

  if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) {
    Object(__WEBPACK_IMPORTED_MODULE_10__validation_validate_mjs__["b" /* assertValidSDLExtension */])(documentAST, schema);
  }

  var schemaConfig = schema.toConfig();
  var extendedConfig = extendSchemaImpl(schemaConfig, documentAST, options);
  return schemaConfig === extendedConfig ? schema : new __WEBPACK_IMPORTED_MODULE_12__type_schema_mjs__["a" /* GraphQLSchema */](extendedConfig);
}
/**
 * @internal
 */

function extendSchemaImpl(schemaConfig, documentAST, options) {
  var _schemaDef, _schemaDef$descriptio, _schemaDef2, _options$assumeValid;

  // Collect the type definitions and extensions found in the document.
  var typeDefs = [];
  var typeExtensionsMap = Object.create(null); // New directives and types are separate because a directives and types can
  // have the same name. For example, a type named "skip".

  var directiveDefs = [];
  var schemaDef; // Schema extensions are collected which may add additional operation types.

  var schemaExtensions = [];

  for (var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++) {
    var def = _documentAST$definiti2[_i2];

    if (def.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].SCHEMA_DEFINITION) {
      schemaDef = def;
    } else if (def.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].SCHEMA_EXTENSION) {
      schemaExtensions.push(def);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_9__language_predicates_mjs__["b" /* isTypeDefinitionNode */])(def)) {
      typeDefs.push(def);
    } else if (Object(__WEBPACK_IMPORTED_MODULE_9__language_predicates_mjs__["c" /* isTypeExtensionNode */])(def)) {
      var extendedTypeName = def.name.value;
      var existingTypeExtensions = typeExtensionsMap[extendedTypeName];
      typeExtensionsMap[extendedTypeName] = existingTypeExtensions ? existingTypeExtensions.concat([def]) : [def];
    } else if (def.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].DIRECTIVE_DEFINITION) {
      directiveDefs.push(def);
    }
  } // If this document contains no new types, extensions, or directives then
  // return the same unmodified GraphQLSchema instance.


  if (Object.keys(typeExtensionsMap).length === 0 && typeDefs.length === 0 && directiveDefs.length === 0 && schemaExtensions.length === 0 && schemaDef == null) {
    return schemaConfig;
  }

  var typeMap = Object.create(null);

  for (var _i4 = 0, _schemaConfig$types2 = schemaConfig.types; _i4 < _schemaConfig$types2.length; _i4++) {
    var existingType = _schemaConfig$types2[_i4];
    typeMap[existingType.name] = extendNamedType(existingType);
  }

  for (var _i6 = 0; _i6 < typeDefs.length; _i6++) {
    var _stdTypeMap$name;

    var typeNode = typeDefs[_i6];
    var name = typeNode.name.value;
    typeMap[name] = (_stdTypeMap$name = stdTypeMap[name]) !== null && _stdTypeMap$name !== void 0 ? _stdTypeMap$name : buildType(typeNode);
  }

  var operationTypes = _objectSpread(_objectSpread({
    // Get the extended root operation types.
    query: schemaConfig.query && replaceNamedType(schemaConfig.query),
    mutation: schemaConfig.mutation && replaceNamedType(schemaConfig.mutation),
    subscription: schemaConfig.subscription && replaceNamedType(schemaConfig.subscription)
  }, schemaDef && getOperationTypes([schemaDef])), getOperationTypes(schemaExtensions)); // Then produce and return a Schema config with these types.


  return _objectSpread(_objectSpread({
    description: (_schemaDef = schemaDef) === null || _schemaDef === void 0 ? void 0 : (_schemaDef$descriptio = _schemaDef.description) === null || _schemaDef$descriptio === void 0 ? void 0 : _schemaDef$descriptio.value
  }, operationTypes), {}, {
    types: Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(typeMap),
    directives: [].concat(schemaConfig.directives.map(replaceDirective), directiveDefs.map(buildDirective)),
    extensions: undefined,
    astNode: (_schemaDef2 = schemaDef) !== null && _schemaDef2 !== void 0 ? _schemaDef2 : schemaConfig.astNode,
    extensionASTNodes: schemaConfig.extensionASTNodes.concat(schemaExtensions),
    assumeValid: (_options$assumeValid = options === null || options === void 0 ? void 0 : options.assumeValid) !== null && _options$assumeValid !== void 0 ? _options$assumeValid : false
  }); // Below are functions used for producing this schema that have closed over
  // this scope and have access to the schema, cache, and newly defined types.

  function replaceType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["v" /* isListType */])(type)) {
      // $FlowFixMe[incompatible-return]
      return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["d" /* GraphQLList */](replaceType(type.ofType));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["x" /* isNonNullType */])(type)) {
      // $FlowFixMe[incompatible-return]
      return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["e" /* GraphQLNonNull */](replaceType(type.ofType));
    }

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    // Note: While this could make early assertions to get the correctly
    // typed values, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.
    return typeMap[type.name];
  }

  function replaceDirective(directive) {
    var config = directive.toConfig();
    return new __WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["c" /* GraphQLDirective */](_objectSpread(_objectSpread({}, config), {}, {
      args: Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__["a" /* default */])(config.args, extendArg)
    }));
  }

  function extendNamedType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["g" /* isIntrospectionType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_13__type_scalars_mjs__["d" /* isSpecifiedScalarType */])(type)) {
      // Builtin types are not extended.
      return type;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["C" /* isScalarType */])(type)) {
      return extendScalarType(type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["y" /* isObjectType */])(type)) {
      return extendObjectType(type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
      return extendInterfaceType(type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["E" /* isUnionType */])(type)) {
      return extendUnionType(type);
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["q" /* isEnumType */])(type)) {
      return extendEnumType(type);
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


    if (Object(__WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
      return extendInputObjectType(type);
    } // istanbul ignore next (Not reachable. All possible types have been considered)


    false || Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type));
  }

  function extendInputObjectType(type) {
    var _typeExtensionsMap$co;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$co = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co !== void 0 ? _typeExtensionsMap$co : [];
    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["b" /* GraphQLInputObjectType */](_objectSpread(_objectSpread({}, config), {}, {
      fields: function fields() {
        return _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__["a" /* default */])(config.fields, function (field) {
          return _objectSpread(_objectSpread({}, field), {}, {
            type: replaceType(field.type)
          });
        })), buildInputFieldMap(extensions));
      },
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendEnumType(type) {
    var _typeExtensionsMap$ty;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$ty = typeExtensionsMap[type.name]) !== null && _typeExtensionsMap$ty !== void 0 ? _typeExtensionsMap$ty : [];
    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["a" /* GraphQLEnumType */](_objectSpread(_objectSpread({}, config), {}, {
      values: _objectSpread(_objectSpread({}, config.values), buildEnumValueMap(extensions)),
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendScalarType(type) {
    var _typeExtensionsMap$co2;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$co2 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co2 !== void 0 ? _typeExtensionsMap$co2 : [];
    var specifiedByUrl = config.specifiedByUrl;

    for (var _i8 = 0; _i8 < extensions.length; _i8++) {
      var _getSpecifiedByUrl;

      var extensionNode = extensions[_i8];
      specifiedByUrl = (_getSpecifiedByUrl = getSpecifiedByUrl(extensionNode)) !== null && _getSpecifiedByUrl !== void 0 ? _getSpecifiedByUrl : specifiedByUrl;
    }

    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["g" /* GraphQLScalarType */](_objectSpread(_objectSpread({}, config), {}, {
      specifiedByUrl: specifiedByUrl,
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendObjectType(type) {
    var _typeExtensionsMap$co3;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$co3 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co3 !== void 0 ? _typeExtensionsMap$co3 : [];
    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["f" /* GraphQLObjectType */](_objectSpread(_objectSpread({}, config), {}, {
      interfaces: function interfaces() {
        return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
      },
      fields: function fields() {
        return _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__["a" /* default */])(config.fields, extendField)), buildFieldMap(extensions));
      },
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendInterfaceType(type) {
    var _typeExtensionsMap$co4;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$co4 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co4 !== void 0 ? _typeExtensionsMap$co4 : [];
    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["c" /* GraphQLInterfaceType */](_objectSpread(_objectSpread({}, config), {}, {
      interfaces: function interfaces() {
        return [].concat(type.getInterfaces().map(replaceNamedType), buildInterfaces(extensions));
      },
      fields: function fields() {
        return _objectSpread(_objectSpread({}, Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__["a" /* default */])(config.fields, extendField)), buildFieldMap(extensions));
      },
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendUnionType(type) {
    var _typeExtensionsMap$co5;

    var config = type.toConfig();
    var extensions = (_typeExtensionsMap$co5 = typeExtensionsMap[config.name]) !== null && _typeExtensionsMap$co5 !== void 0 ? _typeExtensionsMap$co5 : [];
    return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["h" /* GraphQLUnionType */](_objectSpread(_objectSpread({}, config), {}, {
      types: function types() {
        return [].concat(type.getTypes().map(replaceNamedType), buildUnionTypes(extensions));
      },
      extensionASTNodes: config.extensionASTNodes.concat(extensions)
    }));
  }

  function extendField(field) {
    return _objectSpread(_objectSpread({}, field), {}, {
      type: replaceType(field.type),
      // $FlowFixMe[incompatible-call]
      args: Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_mapValue_mjs__["a" /* default */])(field.args, extendArg)
    });
  }

  function extendArg(arg) {
    return _objectSpread(_objectSpread({}, arg), {}, {
      type: replaceType(arg.type)
    });
  }

  function getOperationTypes(nodes) {
    var opTypes = {};

    for (var _i10 = 0; _i10 < nodes.length; _i10++) {
      var _node$operationTypes;

      var node = nodes[_i10];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var operationTypesNodes = (_node$operationTypes = node.operationTypes) !== null && _node$operationTypes !== void 0 ? _node$operationTypes : [];

      for (var _i12 = 0; _i12 < operationTypesNodes.length; _i12++) {
        var operationType = operationTypesNodes[_i12];
        opTypes[operationType.operation] = getNamedType(operationType.type);
      }
    } // Note: While this could make early assertions to get the correctly
    // typed values below, that would throw immediately while type system
    // validation with validateSchema() will produce more actionable results.


    return opTypes;
  }

  function getNamedType(node) {
    var _stdTypeMap$name2;

    var name = node.name.value;
    var type = (_stdTypeMap$name2 = stdTypeMap[name]) !== null && _stdTypeMap$name2 !== void 0 ? _stdTypeMap$name2 : typeMap[name];

    if (type === undefined) {
      throw new Error("Unknown type: \"".concat(name, "\"."));
    }

    return type;
  }

  function getWrappedType(node) {
    if (node.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].LIST_TYPE) {
      return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["d" /* GraphQLList */](getWrappedType(node.type));
    }

    if (node.kind === __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].NON_NULL_TYPE) {
      return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["e" /* GraphQLNonNull */](getWrappedType(node.type));
    }

    return getNamedType(node);
  }

  function buildDirective(node) {
    var locations = node.locations.map(function (_ref) {
      var value = _ref.value;
      return value;
    });
    return new __WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["c" /* GraphQLDirective */]({
      name: node.name.value,
      description: getDescription(node, options),
      locations: locations,
      isRepeatable: node.repeatable,
      args: buildArgumentMap(node.arguments),
      astNode: node
    });
  }

  function buildFieldMap(nodes) {
    var fieldConfigMap = Object.create(null);

    for (var _i14 = 0; _i14 < nodes.length; _i14++) {
      var _node$fields;

      var node = nodes[_i14];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var nodeFields = (_node$fields = node.fields) !== null && _node$fields !== void 0 ? _node$fields : [];

      for (var _i16 = 0; _i16 < nodeFields.length; _i16++) {
        var field = nodeFields[_i16];
        fieldConfigMap[field.name.value] = {
          // Note: While this could make assertions to get the correctly typed
          // value, that would throw immediately while type system validation
          // with validateSchema() will produce more actionable results.
          type: getWrappedType(field.type),
          description: getDescription(field, options),
          args: buildArgumentMap(field.arguments),
          deprecationReason: getDeprecationReason(field),
          astNode: field
        };
      }
    }

    return fieldConfigMap;
  }

  function buildArgumentMap(args) {
    // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
    var argsNodes = args !== null && args !== void 0 ? args : [];
    var argConfigMap = Object.create(null);

    for (var _i18 = 0; _i18 < argsNodes.length; _i18++) {
      var arg = argsNodes[_i18];
      // Note: While this could make assertions to get the correctly typed
      // value, that would throw immediately while type system validation
      // with validateSchema() will produce more actionable results.
      var type = getWrappedType(arg.type);
      argConfigMap[arg.name.value] = {
        type: type,
        description: getDescription(arg, options),
        defaultValue: Object(__WEBPACK_IMPORTED_MODULE_17__valueFromAST_mjs__["a" /* valueFromAST */])(arg.defaultValue, type),
        deprecationReason: getDeprecationReason(arg),
        astNode: arg
      };
    }

    return argConfigMap;
  }

  function buildInputFieldMap(nodes) {
    var inputFieldMap = Object.create(null);

    for (var _i20 = 0; _i20 < nodes.length; _i20++) {
      var _node$fields2;

      var node = nodes[_i20];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var fieldsNodes = (_node$fields2 = node.fields) !== null && _node$fields2 !== void 0 ? _node$fields2 : [];

      for (var _i22 = 0; _i22 < fieldsNodes.length; _i22++) {
        var field = fieldsNodes[_i22];
        // Note: While this could make assertions to get the correctly typed
        // value, that would throw immediately while type system validation
        // with validateSchema() will produce more actionable results.
        var type = getWrappedType(field.type);
        inputFieldMap[field.name.value] = {
          type: type,
          description: getDescription(field, options),
          defaultValue: Object(__WEBPACK_IMPORTED_MODULE_17__valueFromAST_mjs__["a" /* valueFromAST */])(field.defaultValue, type),
          deprecationReason: getDeprecationReason(field),
          astNode: field
        };
      }
    }

    return inputFieldMap;
  }

  function buildEnumValueMap(nodes) {
    var enumValueMap = Object.create(null);

    for (var _i24 = 0; _i24 < nodes.length; _i24++) {
      var _node$values;

      var node = nodes[_i24];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var valuesNodes = (_node$values = node.values) !== null && _node$values !== void 0 ? _node$values : [];

      for (var _i26 = 0; _i26 < valuesNodes.length; _i26++) {
        var value = valuesNodes[_i26];
        enumValueMap[value.name.value] = {
          description: getDescription(value, options),
          deprecationReason: getDeprecationReason(value),
          astNode: value
        };
      }
    }

    return enumValueMap;
  }

  function buildInterfaces(nodes) {
    var interfaces = [];

    for (var _i28 = 0; _i28 < nodes.length; _i28++) {
      var _node$interfaces;

      var node = nodes[_i28];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var interfacesNodes = (_node$interfaces = node.interfaces) !== null && _node$interfaces !== void 0 ? _node$interfaces : [];

      for (var _i30 = 0; _i30 < interfacesNodes.length; _i30++) {
        var type = interfacesNodes[_i30];
        // Note: While this could make assertions to get the correctly typed
        // values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable
        // results.
        interfaces.push(getNamedType(type));
      }
    }

    return interfaces;
  }

  function buildUnionTypes(nodes) {
    var types = [];

    for (var _i32 = 0; _i32 < nodes.length; _i32++) {
      var _node$types;

      var node = nodes[_i32];
      // istanbul ignore next (See: 'https://github.com/graphql/graphql-js/issues/2203')
      var typeNodes = (_node$types = node.types) !== null && _node$types !== void 0 ? _node$types : [];

      for (var _i34 = 0; _i34 < typeNodes.length; _i34++) {
        var type = typeNodes[_i34];
        // Note: While this could make assertions to get the correctly typed
        // values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable
        // results.
        types.push(getNamedType(type));
      }
    }

    return types;
  }

  function buildType(astNode) {
    var _typeExtensionsMap$na;

    var name = astNode.name.value;
    var description = getDescription(astNode, options);
    var extensionNodes = (_typeExtensionsMap$na = typeExtensionsMap[name]) !== null && _typeExtensionsMap$na !== void 0 ? _typeExtensionsMap$na : [];

    switch (astNode.kind) {
      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].OBJECT_TYPE_DEFINITION:
        {
          var extensionASTNodes = extensionNodes;
          var allNodes = [astNode].concat(extensionASTNodes);
          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["f" /* GraphQLObjectType */]({
            name: name,
            description: description,
            interfaces: function interfaces() {
              return buildInterfaces(allNodes);
            },
            fields: function fields() {
              return buildFieldMap(allNodes);
            },
            astNode: astNode,
            extensionASTNodes: extensionASTNodes
          });
        }

      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].INTERFACE_TYPE_DEFINITION:
        {
          var _extensionASTNodes = extensionNodes;

          var _allNodes = [astNode].concat(_extensionASTNodes);

          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["c" /* GraphQLInterfaceType */]({
            name: name,
            description: description,
            interfaces: function interfaces() {
              return buildInterfaces(_allNodes);
            },
            fields: function fields() {
              return buildFieldMap(_allNodes);
            },
            astNode: astNode,
            extensionASTNodes: _extensionASTNodes
          });
        }

      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].ENUM_TYPE_DEFINITION:
        {
          var _extensionASTNodes2 = extensionNodes;

          var _allNodes2 = [astNode].concat(_extensionASTNodes2);

          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["a" /* GraphQLEnumType */]({
            name: name,
            description: description,
            values: buildEnumValueMap(_allNodes2),
            astNode: astNode,
            extensionASTNodes: _extensionASTNodes2
          });
        }

      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].UNION_TYPE_DEFINITION:
        {
          var _extensionASTNodes3 = extensionNodes;

          var _allNodes3 = [astNode].concat(_extensionASTNodes3);

          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["h" /* GraphQLUnionType */]({
            name: name,
            description: description,
            types: function types() {
              return buildUnionTypes(_allNodes3);
            },
            astNode: astNode,
            extensionASTNodes: _extensionASTNodes3
          });
        }

      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].SCALAR_TYPE_DEFINITION:
        {
          var _extensionASTNodes4 = extensionNodes;
          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["g" /* GraphQLScalarType */]({
            name: name,
            description: description,
            specifiedByUrl: getSpecifiedByUrl(astNode),
            astNode: astNode,
            extensionASTNodes: _extensionASTNodes4
          });
        }

      case __WEBPACK_IMPORTED_MODULE_6__language_kinds_mjs__["a" /* Kind */].INPUT_OBJECT_TYPE_DEFINITION:
        {
          var _extensionASTNodes5 = extensionNodes;

          var _allNodes4 = [astNode].concat(_extensionASTNodes5);

          return new __WEBPACK_IMPORTED_MODULE_16__type_definition_mjs__["b" /* GraphQLInputObjectType */]({
            name: name,
            description: description,
            fields: function fields() {
              return buildInputFieldMap(_allNodes4);
            },
            astNode: astNode,
            extensionASTNodes: _extensionASTNodes5
          });
        }
    } // istanbul ignore next (Not reachable. All possible type definition nodes have been considered)


    false || Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type definition node: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(astNode));
  }
}
var stdTypeMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_13__type_scalars_mjs__["e" /* specifiedScalarTypes */].concat(__WEBPACK_IMPORTED_MODULE_14__type_introspection_mjs__["f" /* introspectionTypes */]), function (type) {
  return type.name;
});
/**
 * Given a field or enum value node, returns the string value for the
 * deprecation reason.
 */

function getDeprecationReason(node) {
  var deprecated = Object(__WEBPACK_IMPORTED_MODULE_11__execution_values_mjs__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["b" /* GraphQLDeprecatedDirective */], node);
  return deprecated === null || deprecated === void 0 ? void 0 : deprecated.reason;
}
/**
 * Given a scalar node, returns the string value for the specifiedByUrl.
 */


function getSpecifiedByUrl(node) {
  var specifiedBy = Object(__WEBPACK_IMPORTED_MODULE_11__execution_values_mjs__["b" /* getDirectiveValues */])(__WEBPACK_IMPORTED_MODULE_15__type_directives_mjs__["f" /* GraphQLSpecifiedByDirective */], node);
  return specifiedBy === null || specifiedBy === void 0 ? void 0 : specifiedBy.url;
}
/**
 * Given an ast node, returns its string description.
 * @deprecated: provided to ease adoption and will be removed in v16.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */


function getDescription(node, options) {
  if (node.description) {
    return node.description.value;
  }

  if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
    var rawValue = getLeadingCommentBlock(node);

    if (rawValue !== undefined) {
      return Object(__WEBPACK_IMPORTED_MODULE_8__language_blockString_mjs__["a" /* dedentBlockStringValue */])('\n' + rawValue);
    }
  }
}

function getLeadingCommentBlock(node) {
  var loc = node.loc;

  if (!loc) {
    return;
  }

  var comments = [];
  var token = loc.startToken.prev;

  while (token != null && token.kind === __WEBPACK_IMPORTED_MODULE_7__language_tokenKind_mjs__["a" /* TokenKind */].COMMENT && token.next && token.prev && token.line + 1 === token.next.line && token.line !== token.prev.line) {
    var value = String(token.value);
    comments.push(value);
    token = token.prev;
  }

  return comments.length > 0 ? comments.reverse().join('\n') : undefined;
}


/***/ }),
/* 589 */,
/* 590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textCreditcard_vue__ = __webpack_require__(935);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f101ef_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_textCreditcard_vue__ = __webpack_require__(936);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textCreditcard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63f101ef_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_textCreditcard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCreditCard_vue__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e65f768_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EditCreditCard_vue__ = __webpack_require__(950);
function injectStyle (ssrContext) {
  __webpack_require__(948)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditCreditCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e65f768_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EditCreditCard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectReview_vue__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6062d28e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CollectReview_vue__ = __webpack_require__(1046);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CollectReview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6062d28e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CollectReview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 598 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signupv2_vue__ = __webpack_require__(1085);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ae5094_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_signupv2_vue__ = __webpack_require__(1086);
function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signupv2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f9ae5094_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_signupv2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demov2_vue__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24238a7e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_demov2_vue__ = __webpack_require__(1103);
function injectStyle (ssrContext) {
  __webpack_require__(1101)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_demov2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24238a7e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_demov2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__ = __webpack_require__(371);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(708);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui__ = __webpack_require__(1620);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_element_ui___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_element_ui__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_wysiwyg_dist_vueWysiwyg_css__ = __webpack_require__(1668);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_wysiwyg_dist_vueWysiwyg_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_wysiwyg_dist_vueWysiwyg_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_resource__ = __webpack_require__(1669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_password__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vee_validate__ = __webpack_require__(1671);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_numeric__ = __webpack_require__(1672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_numeric___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_numeric__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_autosize__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_autosize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_button_spinner__ = __webpack_require__(1674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_vue_button_spinner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_vue_button_spinner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_hsy_vue_dropdown__ = __webpack_require__(1675);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_hsy_vue_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_hsy_vue_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_form_wizard_dist_vue_form_wizard_min_css__ = __webpack_require__(1676);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_vue_form_wizard_dist_vue_form_wizard_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_vue_form_wizard_dist_vue_form_wizard_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__ = __webpack_require__(1677);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_facebook_login_component__ = __webpack_require__(1811);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_vue_facebook_login_component___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_vue_facebook_login_component__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__deveodk_vue_toastr__ = __webpack_require__(1812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__deveodk_vue_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__deveodk_vue_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__ = __webpack_require__(1813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__deveodk_vue_toastr_dist_deveodk_vue_toastr_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__deveodk_vue_toastr_dist_deveodk_vue_toastr_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_select_dist_vue_select_css__ = __webpack_require__(1814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_vue_select_dist_vue_select_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27_vue_select_dist_vue_select_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_index_css__ = __webpack_require__(1815);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_element_ui_lib_theme_chalk_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29_vue_read_more__ = __webpack_require__(1816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_ctk_date_time_picker__ = __webpack_require__(1821);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30_vue_ctk_date_time_picker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_30_vue_ctk_date_time_picker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__ = __webpack_require__(1822);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31_vue_ctk_date_time_picker_dist_vue_ctk_date_time_picker_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_quill_editor__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33_apollo_boost__ = __webpack_require__(1823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34_vue_apollo__ = __webpack_require__(1841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_35_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_vue_bootstrap_slider__ = __webpack_require__(1842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css__ = __webpack_require__(1846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_vue_datetime_dist_vue_datetime_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_nestable2_jquery_nestable_scss__ = __webpack_require__(1847);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_nestable2_jquery_nestable_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_nestable2_jquery_nestable_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bootstrap_slider_dist_css_bootstrap_slider_css__ = __webpack_require__(1848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_bootstrap_slider_dist_css_bootstrap_slider_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_40_bootstrap_slider_dist_css_bootstrap_slider_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_js_toggle_button__ = __webpack_require__(1849);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_41_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vuejs_dialog__ = __webpack_require__(1850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_vuejs_dialog___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_42_vuejs_dialog__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuejs_dialog_dist_vuejs_dialog_min_css__ = __webpack_require__(1851);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_vuejs_dialog_dist_vuejs_dialog_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_43_vuejs_dialog_dist_vuejs_dialog_min_css__);

















































__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_42_vuejs_dialog___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_35_vue_bootstrap_datetimepicker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_36_vue_bootstrap_slider__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_37_vue_datetime__["Datetime"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_41_vue_js_toggle_button___default.a);

global.jQuery = __webpack_require__(197);
__webpack_require__(1852);
var $ = global.jQuery;
window.$ = $;

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_bootstrap_vue__["c" /* default */]);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_10_vue_resource__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_autosize___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_24_vue_facebook_login_component___default.a, __WEBPACK_IMPORTED_MODULE_24_vue_facebook_login_component__["vueFacebookLoginComponent"]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_full_loading___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_12_vue2_simplert___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_14_vue_numeric___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component(__WEBPACK_IMPORTED_MODULE_11_vue_password___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_17_vue_button_spinner___default.a);

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('star-rating', __WEBPACK_IMPORTED_MODULE_9_vue_star_rating___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].component('VueCtkDateTimePicker', __WEBPACK_IMPORTED_MODULE_30_vue_ctk_date_time_picker___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_hsy_vue_dropdown___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_19_vue_form_wizard___default.a);
__WEBPACK_IMPORTED_MODULE_20_vue_clipboard2___default.a.config.autoSetContainer = true;
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_20_vue_clipboard2___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_select___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_29_vue_read_more__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_25__deveodk_vue_toastr___default.a, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_23_vue2_google_maps__, {
  load: {
    key: 'AIzaSyDbABuU2mTBWi4mUR7q3FDdt6zl4xVnf_w',
    libraries: 'places'
  }
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_wysiwyg___default.a, {
  hideModules: {
    'justifyRight': true,
    'justifyCenter': true,
    'code': true,
    'table': true,
    'italic': true,
    'removeFormat': true
  },
  'forcePlainTextOnPaste': true
});
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_32_vue_quill_editor___default.a);

__WEBPACK_IMPORTED_MODULE_6_moment___default.a.locale('da');
var config = {
  errorBagName: 'validationerrors',
  fieldsBagName: 'fields',
  delay: 0,
  locale: 'en',
  dictionary: null,
  strict: true,
  classes: false,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'valid',
    invalid: 'invalid',
    pristine: 'pristine',
    dirty: 'dirty' },
  events: 'input|blur',
  inject: true,
  validity: false,
  aria: true
};
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_element_ui___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vee_validate__["a" /* default */], config);
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.moment = __WEBPACK_IMPORTED_MODULE_6_moment___default.a;
var apolloClient = new __WEBPACK_IMPORTED_MODULE_33_apollo_boost__["a" /* default */]({
  uri: 'https://graphql.ordrestyring.dk/graphiql'
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_34_vue_apollo__["a" /* default */]);
var apolloProvider = new __WEBPACK_IMPORTED_MODULE_34_vue_apollo__["a" /* default */]({
  defaultClient: apolloClient
});

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$bitrixapi = "https://bitrixapi.haandvaerker.dk/v1/";
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.options.root = 'https://www.kundematch.dk/partnerService.php';
__WEBPACK_IMPORTED_MODULE_1_vue__["default"].http.headers.common['X-Requested-With'] = 'XMLHttpRequest';
new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  apolloProvider: apolloProvider,
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App__["a" /* default */]
  }
});

var filter = function filter(text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
};

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].filter('truncate', filter);
document.querySelectorAll('.grid-list').forEach(function (button) {
  return button.addEventListener('click', toggle);
});
function toggle() {
  var btn = this;
  btn.classList.add('animation');
  btn.classList.toggle('active');
  var newElem = btn.cloneNode(true);
  btn.parentNode.replaceChild(newElem, btn);
  newElem.addEventListener('click', toggle);
}

__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$maskibanNumber = function (value) {
  var val = value.replace(/\D/g, '');
  var stringValue = '';
  var formattedValue = '';
  var firstTexts = 'DK';
  var space = ' ';
  stringValue = firstTexts + val.toString();
  var valueCharData = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(stringValue);
  valueCharData.forEach(function (prop, index) {
    if (index === 3 || index === 7 || index === 11 || index === 15) {
      formattedValue += prop + space;
    } else {
      formattedValue += prop;
    }
  });
  return formattedValue;
};

if (document.querySelector('#dropWebshop') !== null) {
  setTimeout(function () {
    var webshopMenu = document.querySelector('#dropWebshop');
    webshopMenu.addEventListener('click', function () {
      window.location.replace('#/webshop/overview');
    });
  }, 500);
}

if (true) {
  setTimeout(function () {
    if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard') !== null) {
      document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard').classList.add('hide');
    }
  }, 300);
}

if (document.querySelector('#dropMarkedsplads') !== null) {
  setTimeout(function () {
    var maketplace = document.querySelector('#dropMarkedsplads');
    maketplace.addEventListener('click', function () {
      window.location.replace('#/markedsplads');
    });
  }, 500);
}

if (localStorage.getItem('isshop') === 'false') {
  if (document.getElementById('dropWebshop') !== null) {
    setTimeout(function () {
      document.getElementById('dropWebshop').classList.add('hide');
    }, 500);
  }
}
var anbefalingerSammendrag = document.getElementById('anbefalinger-sammendrag');
if (anbefalingerSammendrag) {
  if (__WEBPACK_IMPORTED_MODULE_1_vue__["default"].prototype.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
    setTimeout(function () {
      anbefalingerSammendrag.classList.add('hide');
    }, 300);
  }
}

var opgaveInvitationer = document.getElementById('opgaveinvitationer');
if (opgaveInvitationer) {
  if (localStorage.getItem('isjobInvited') === 'false' || localStorage.getItem('showAddendum') !== 'true') {
    setTimeout(function () {
      opgaveInvitationer.classList.add('hide');
    }, 500);
  }
}

var offentligeUdbud = document.getElementById('offentlige-udbud');
if (offentligeUdbud) {
  if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
    setTimeout(function () {
      document.getElementById('offentlige-udbud').classList.add('hide');
    }, 500);
  }
}


if (typeof document.getElementById('js-licensing') !== 'undefined' && document.getElementById('js-licensing') !== null) {
  setInterval(function () {
    var x = document.getElementById('js-licensing');
    x.style.display = 'none';
    console.log(x.style.display);
  }, 500);
}

var badgeNavItem = document.querySelector('a[href="#/badges"]');
if (badgeNavItem) {
  if (localStorage.getItem('showbadgewebshop') === 'yes') {
    badgeNavItem.classList.remove('hide');
  } else {
    badgeNavItem.classList.add('hide');
  }
}

var Addendum = document.querySelector('#dropArbejdsseddel');
if (Addendum) {
  if (localStorage.getItem('showAddendum') === 'true') {
    Addendum.classList.remove('hide');
  } else {
    Addendum.classList.add('hide');
  }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(51)))

/***/ }),
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */,
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151d6a90_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(707);
function injectStyle (ssrContext) {
  __webpack_require__(703)
  __webpack_require__(705)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_151d6a90_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */,
/* 705 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 706 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ }),
/* 707 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(709);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers_Full__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_portal_Start__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_portal_udbud__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_portal_ted_udbud__ = __webpack_require__(827);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_portal_NewMeetings__ = __webpack_require__(831);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_portal_AllMeetings__ = __webpack_require__(841);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_portal_AllMeetings_minbolig__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_portal_MainPage__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_portal_Balance__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_portal_ProfileSettings__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_portal_integrationSettings__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_portal_leverandoerservice__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_portal_Opgavetyper__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_portal_Ferieperioder__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_portal_ekstraphone__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_portal_Profilside__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_portal_confirm_description__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_portal_Opgaveoversigt__ = __webpack_require__(1032);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_portal_Anbefalinger__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_portal_Anbefaling__ = __webpack_require__(1048);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_portal_EditCreditCard__ = __webpack_require__(591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__views_portal_EditvisitKort__ = __webpack_require__(1052);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__views_portal_ExpireSubscription__ = __webpack_require__(1056);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_portal_ExpireSubscriptionForm__ = __webpack_require__(1060);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_ProjectLogin__ = __webpack_require__(1064);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__views_Security__ = __webpack_require__(1068);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_micrositesv1_invo__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_micrositesv1_package__ = __webpack_require__(1076);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_micrositesv1_singupcvr__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_micrositesv1_signupv2__ = __webpack_require__(598);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_micrositesv1_signup_AI_text__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_micrositesv1_inviterepartner__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_micrositesv1_contract_viewer__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_micrositesv1_demov2__ = __webpack_require__(599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__views_micrositesv1_mobilepay__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__views_micrositesv1_callme__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38__views_micrositesv1_unsubscribe__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39__views_Password__ = __webpack_require__(1116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40__views_portal_Finansiering__ = __webpack_require__(1125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41__views_portal_CreditCheck__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42__views_portal_NewProjectStatus__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43__views_portal_NewHaandvaerkerProjectStatus__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44__views_portal_NewHaandvaerkerProjectStatus2__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45__views_portal_CustomerProjects__ = __webpack_require__(1170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46__views_portal_Purchase__ = __webpack_require__(1174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47__views_portal_anbefalktohomeowners__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48__views_portal_Marketplace__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49__views_portal_Marketplace2__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50__views_portal_MarketplaceMinbolig2__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51__views_portal_OpretProjektNew__ = __webpack_require__(1194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52__views_portal_opretprojektnew_CreateProjectNew__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53__views_portal_opretprojektnew_CreateProject_Tak__ = __webpack_require__(1210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54__views_portal_opretprojektnew_CreateProject_edit__ = __webpack_require__(1214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55__views_portal_opretprojektnew_uploadimage__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_56__views_portal_AddProjects__ = __webpack_require__(1222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_57__views_portal_Website__ = __webpack_require__(1230);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_58__views_portal_WriteSupport__ = __webpack_require__(1250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_59__views_portal_Inbox__ = __webpack_require__(1251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_60__views_portal_email__ = __webpack_require__(1257);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_61__views_portal_Chat__ = __webpack_require__(1264);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_62__views_portal_jule__ = __webpack_require__(1267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_63__views_portal_invite__ = __webpack_require__(1271);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_64__views_ForgotPassword__ = __webpack_require__(1275);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_65__views_portal_Newsfeed__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_66__views_PartnerSetup__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_67__views_portal_userTilbud__ = __webpack_require__(1288);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_68__views_portal_StandardTilbudhistory__ = __webpack_require__(1299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_69__views_portal_standardTilbud__ = __webpack_require__(321);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_70__views_portal_standardTilbudProduct__ = __webpack_require__(1309);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_71__views_portal_MesterArbejdskraft__ = __webpack_require__(1326);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_72__views_portal_MesterOpgaver__ = __webpack_require__(1330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_73__views_portal_IndhentAnbefalinger__ = __webpack_require__(1334);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_74__views_portal_ReadAnbefalinger__ = __webpack_require__(1337);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_75__views_portal_Widgets__ = __webpack_require__(1345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_76__views_portal_AllSettings__ = __webpack_require__(1348);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_77__views_portal_InviterKollega__ = __webpack_require__(1352);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_78__views_portal_stamoplysninger__ = __webpack_require__(1355);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_79__views_portal_medlemsfordele__ = __webpack_require__(1359);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_80__views_portal_webshop_overview__ = __webpack_require__(1363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_81__views_portal_webshop_products__ = __webpack_require__(1375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_82__views_portal_webshop_product__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_83__views_portal_webshop_cart__ = __webpack_require__(1400);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_84__views_portal_webshop_checkout__ = __webpack_require__(1404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_85__views_portal_webshop_orders__ = __webpack_require__(1408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_86__views_portal_webshop_order__ = __webpack_require__(1412);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_87__views_portal_webshop_wishlist__ = __webpack_require__(1416);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_88__views_portal_webshop_FbAds__ = __webpack_require__(1420);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_89__views_portal_webshop_GoogleAds__ = __webpack_require__(1424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_90__views_portal_webshop_BoostProfilside__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_91__views_portal_webshop_BoostProjekt__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_92__views_portal_webshop_BoostEnAnbefaling__ = __webpack_require__(1435);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_93__views_portal_webshop_TermsAndConditions__ = __webpack_require__(1439);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_94__views_portal_badges__ = __webpack_require__(1443);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_95__views_portal_press_article__ = __webpack_require__(1448);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_96__views_portal_klima_klima__ = __webpack_require__(1452);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_97__views_portal_klima_checklist__ = __webpack_require__(1457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_98__views_portal_klima_survey__ = __webpack_require__(1461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_99__views_portal_klima_editsurvey__ = __webpack_require__(1465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_100__views_portal_klima_registration__ = __webpack_require__(1469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_101__views_portal_klima_dokumentation__ = __webpack_require__(1473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_102__views_portal_recommend__ = __webpack_require__(1477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_103__views_portal_faq__ = __webpack_require__(1481);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_104__views_portal_ordrestyring__ = __webpack_require__(1485);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_105__views_portal_approval__ = __webpack_require__(1489);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_106__views_portal_nps__ = __webpack_require__(1493);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_107__views_portal_UddanelseBevis__ = __webpack_require__(1497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_108__views_Questionnaire__ = __webpack_require__(1501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_109__views_QuestionnaireThankyou__ = __webpack_require__(1505);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_110__views_portal_contracts__ = __webpack_require__(1507);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_111__views_portal_messages_inbox__ = __webpack_require__(1514);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_112__views_portal_messages_sent__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_113__views_portal_customerprojects_timeline__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_114__views_portal_customerprojects_ProjectDashboard__ = __webpack_require__(1538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_115__views_portal_customerprojects_ApprovedProjects__ = __webpack_require__(1542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_116__views_portal_customerprojects_contract__ = __webpack_require__(1546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_117__views_portal_customerprojects_calendar__ = __webpack_require__(1547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_118__views_portal_customerprojects_contract_manager__ = __webpack_require__(1555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_119__views_portal_customerprojects_contract_main__ = __webpack_require__(1559);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_120__views_portal_customerprojects_contract_main_tak__ = __webpack_require__(1563);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_121__views_portal_customerprojects_contract_mainv2__ = __webpack_require__(1567);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_122__views_portal_customerprojects_contract_draft__ = __webpack_require__(1571);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_123__views_portal_customerprojects_contract_extrawork_addon__ = __webpack_require__(1575);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_124__views_portal_customerprojects_extraworklist__ = __webpack_require__(1579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_125__views_portal_customerprojects_projekt_billeder__ = __webpack_require__(1583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_126__views_portal_customerprojects_payment_management__ = __webpack_require__(1587);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_127__views_portal_customerprojects_mangel_list__ = __webpack_require__(1591);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_128__views_portal_PropertyOwner__ = __webpack_require__(1595);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_129__views_portal_payproff__ = __webpack_require__(1597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_130__views_portal_version__ = __webpack_require__(1601);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_131__views_portal_customerprojects_documents__ = __webpack_require__(1604);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_132__views_portal_customerprojects_tenderFolder__ = __webpack_require__(1608);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_133__views_portal_addendum__ = __webpack_require__(1612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_134__views_portal_worksheet__ = __webpack_require__(1616);





















































































































































__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);
/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
    mode: 'hash',
    linkActiveClass: 'active',
    scrollBehavior: function scrollBehavior() {
        return {
            y: 0
        };
    },
    routes: [{
        path: '/login',
        name: 'ProjectLogin',
        component: __WEBPACK_IMPORTED_MODULE_26__views_ProjectLogin__["a" /* default */]
    }, {
        path: '/invo/*',
        name: 'Invo',
        component: __WEBPACK_IMPORTED_MODULE_28__views_micrositesv1_invo__["a" /* default */]
    }, {
        path: '/package/*',
        name: 'Package',
        component: __WEBPACK_IMPORTED_MODULE_29__views_micrositesv1_package__["a" /* default */]
    }, {
        path: '/singupcvr/*',
        name: 'Singupcvr',
        component: __WEBPACK_IMPORTED_MODULE_30__views_micrositesv1_singupcvr__["a" /* default */]
    }, {
        path: '/signup/*',
        name: 'Signup',
        component: __WEBPACK_IMPORTED_MODULE_31__views_micrositesv1_signupv2__["a" /* default */] }, {
        path: '/upgrade/*',
        name: 'SignupAIText',
        component: __WEBPACK_IMPORTED_MODULE_32__views_micrositesv1_signup_AI_text__["a" /* default */] }, {
        path: '/signupv2/*',
        name: 'Signupv2',
        component: __WEBPACK_IMPORTED_MODULE_31__views_micrositesv1_signupv2__["a" /* default */]
    }, {
        path: '/inviterepartner/*',
        name: 'Inviterepartner',
        component: __WEBPACK_IMPORTED_MODULE_33__views_micrositesv1_inviterepartner__["a" /* default */]
    }, {
        path: '/contract-viewer/*',
        name: 'Contractviewer',
        component: __WEBPACK_IMPORTED_MODULE_34__views_micrositesv1_contract_viewer__["a" /* default */]
    }, {
        path: '/demo/*',
        name: 'Demo',
        component: __WEBPACK_IMPORTED_MODULE_35__views_micrositesv1_demov2__["a" /* default */] }, {
        path: '/demov2/*',
        name: 'Demov2',
        component: __WEBPACK_IMPORTED_MODULE_35__views_micrositesv1_demov2__["a" /* default */]
    }, {
        path: '/mobilepay/*',
        name: 'Acceptancemobilepay',
        component: __WEBPACK_IMPORTED_MODULE_36__views_micrositesv1_mobilepay__["a" /* default */]
    }, {
        path: '/kontakt/*',
        name: 'Callme',
        component: __WEBPACK_IMPORTED_MODULE_37__views_micrositesv1_callme__["a" /* default */]
    }, {
        path: '/unsubscribe/*',
        name: 'Unsubscribe',
        component: __WEBPACK_IMPORTED_MODULE_38__views_micrositesv1_unsubscribe__["a" /* default */]
    }, {
        path: '/security',
        name: 'Security',
        component: __WEBPACK_IMPORTED_MODULE_27__views_Security__["a" /* default */]
    }, {
        path: '/glemte-password',
        name: 'Glemte Password',
        component: __WEBPACK_IMPORTED_MODULE_64__views_ForgotPassword__["a" /* default */]
    }, {
        path: '/partnerfri-setup',
        name: 'PartnerSetup',
        component: __WEBPACK_IMPORTED_MODULE_66__views_PartnerSetup__["a" /* default */]
    }, {
        path: '/',
        redirect: '/newsfeed',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/newsfeed',
            name: 'Newsfeed',
            component: __WEBPACK_IMPORTED_MODULE_65__views_portal_Newsfeed__["a" /* default */]
        }, {
            path: '/recommend',
            name: 'Anbefal os',
            component: __WEBPACK_IMPORTED_MODULE_102__views_portal_recommend__["a" /* default */]
        }, {
            path: '/skriv-til-support',
            name: 'Skriv til support',
            component: __WEBPACK_IMPORTED_MODULE_58__views_portal_WriteSupport__["a" /* default */]
        }, {
            path: '/hjemmeside',
            name: 'Hjemmeside',
            component: __WEBPACK_IMPORTED_MODULE_57__views_portal_Website__["a" /* default */]
        }, {
            path: '/tilfoej-projekter',
            name: 'Tilføj Projekter',
            component: __WEBPACK_IMPORTED_MODULE_56__views_portal_AddProjects__["a" /* default */]
        }, {
            path: '/indhent-anbefalinger',
            name: 'Indhent Anbefalinger',
            component: __WEBPACK_IMPORTED_MODULE_73__views_portal_IndhentAnbefalinger__["a" /* default */]
        }, {
            path: '/laes-og-besvar-anbefalinger',
            name: 'Læs og besvar',
            component: __WEBPACK_IMPORTED_MODULE_74__views_portal_ReadAnbefalinger__["a" /* default */]
        }, {
            path: '/opret-projekt-new',
            name: 'Create',
            component: __WEBPACK_IMPORTED_MODULE_51__views_portal_OpretProjektNew__["a" /* default */]
        }, {
            path: '/opret-projekt-new/wizard',
            name: 'CreateProjectNewv2',
            component: __WEBPACK_IMPORTED_MODULE_52__views_portal_opretprojektnew_CreateProjectNew__["a" /* default */]
        }, {
            path: '/opret-projekt-new/tak',
            name: 'CreateProjectNewv2tak',
            component: __WEBPACK_IMPORTED_MODULE_53__views_portal_opretprojektnew_CreateProject_Tak__["a" /* default */]
        }, {
            path: '/opret-projekt-new/rediger_projekt',
            name: 'CreateProjectNewvEditPage',
            component: __WEBPACK_IMPORTED_MODULE_54__views_portal_opretprojektnew_CreateProject_edit__["a" /* default */]
        }, {
            path: '/opret-projekt-new/billeder',
            name: 'CreateProjectNewuploadbilleder',
            component: __WEBPACK_IMPORTED_MODULE_55__views_portal_opretprojektnew_uploadimage__["a" /* default */]

        }, {
            path: '/markedsplads',
            name: 'PrivatMarkedsplads',
            component: __WEBPACK_IMPORTED_MODULE_48__views_portal_Marketplace__["a" /* default */]
        }, {
            path: '/anbefaling-boligejere',
            name: 'anbefalktohomeowners',
            component: __WEBPACK_IMPORTED_MODULE_47__views_portal_anbefalktohomeowners__["a" /* default */]
        }, {
            path: '/anbefalinger-sammendrag',
            name: 'Anbefaling',
            component: __WEBPACK_IMPORTED_MODULE_21__views_portal_Anbefaling__["a" /* default */]
        }, {
            path: '/koeb-projekter',
            name: 'Purchase',
            component: __WEBPACK_IMPORTED_MODULE_46__views_portal_Purchase__["a" /* default */]
        }, {
            path: '/status-haandvaerker',
            name: 'Haandvaerker - Status',
            component: __WEBPACK_IMPORTED_MODULE_43__views_portal_NewHaandvaerkerProjectStatus__["a" /* default */]
        }, {
            path: '/status-haandvaerker-new',
            name: 'Projekter',
            component: __WEBPACK_IMPORTED_MODULE_44__views_portal_NewHaandvaerkerProjectStatus2__["a" /* default */]
        }, {
            path: '/customer-projects',
            name: 'CustomerProjects',
            component: __WEBPACK_IMPORTED_MODULE_45__views_portal_CustomerProjects__["a" /* default */]
        }, {
            path: '/status-producenter',
            name: 'Producenter - Status',
            component: __WEBPACK_IMPORTED_MODULE_42__views_portal_NewProjectStatus__["a" /* default */]
        }, {
            path: '/ted_status',
            name: 'TedUdbud',
            component: __WEBPACK_IMPORTED_MODULE_5__views_portal_ted_udbud__["a" /* default */]
        }, {
            path: '/new-meetings',
            name: 'New Meetings',
            component: __WEBPACK_IMPORTED_MODULE_6__views_portal_NewMeetings__["a" /* default */]
        }, {
            path: '/mester-arbejdskraft',
            name: 'Arbejdskraft',
            component: __WEBPACK_IMPORTED_MODULE_71__views_portal_MesterArbejdskraft__["a" /* default */]
        }, {
            path: '/mester-opgaver',
            name: 'Opgaver',
            component: __WEBPACK_IMPORTED_MODULE_72__views_portal_MesterOpgaver__["a" /* default */]
        }, {
            path: '/settings',
            name: 'Settings',
            component: __WEBPACK_IMPORTED_MODULE_76__views_portal_AllSettings__["a" /* default */]
        }, {
            path: '/alle-moeder',
            name: 'Alle møder',
            component: __WEBPACK_IMPORTED_MODULE_7__views_portal_AllMeetings__["a" /* default */]
        }, {
            path: '/alle-moeder-minbolig',
            name: 'Alle møder-minbolig',
            component: __WEBPACK_IMPORTED_MODULE_8__views_portal_AllMeetings_minbolig__["a" /* default */]
        }, {
            path: '/userTilbud',
            name: 'Tilbud',
            component: __WEBPACK_IMPORTED_MODULE_67__views_portal_userTilbud__["a" /* default */]
        }, {
            path: '/oversigt',
            name: 'Oversigt',
            component: __WEBPACK_IMPORTED_MODULE_9__views_portal_MainPage__["a" /* default */]
        }, {
            path: '/balance',
            name: 'Balance',
            component: __WEBPACK_IMPORTED_MODULE_10__views_portal_Balance__["a" /* default */]
        }, {
            path: '/dine-indstillinger',
            name: 'Dine Indstillinger',
            component: __WEBPACK_IMPORTED_MODULE_11__views_portal_ProfileSettings__["a" /* default */]
        }, {
            path: '/faq',
            name: 'Ofte stillede spørgsmål',
            component: __WEBPACK_IMPORTED_MODULE_103__views_portal_faq__["a" /* default */]
        }, {
            path: '/auto-anbefalinger',
            name: 'Dine Integrationer',
            component: __WEBPACK_IMPORTED_MODULE_12__views_portal_integrationSettings__["a" /* default */]
        }, {
            path: '/widgets',
            name: 'Widgets',
            component: __WEBPACK_IMPORTED_MODULE_75__views_portal_Widgets__["a" /* default */]
        }, {
            path: '/leverandoerservice',
            name: 'Tilmeld Betalingsaftale',
            component: __WEBPACK_IMPORTED_MODULE_13__views_portal_leverandoerservice__["a" /* default */]
        }, {
            path: '/dine-opgavetyper',
            name: 'Dine Opgavetyper',
            component: __WEBPACK_IMPORTED_MODULE_14__views_portal_Opgavetyper__["a" /* default */]
        }, {
            path: '/dine-ferieperioder',
            name: 'Dine Ferieperioder',
            component: __WEBPACK_IMPORTED_MODULE_15__views_portal_Ferieperioder__["a" /* default */]
        }, {
            path: '/klima',
            name: 'Klima',
            component: __WEBPACK_IMPORTED_MODULE_96__views_portal_klima_klima__["a" /* default */]
        }, {
            path: '/ekstraphone',
            name: 'Ekstra phone',
            component: __WEBPACK_IMPORTED_MODULE_16__views_portal_ekstraphone__["a" /* default */]
        }, {
            path: '/profilside',
            name: 'Din profilside',
            component: __WEBPACK_IMPORTED_MODULE_17__views_portal_Profilside__["a" /* default */]
        }, {
            path: '/confirm-description',
            name: 'ConfirmDescription',
            component: __WEBPACK_IMPORTED_MODULE_18__views_portal_confirm_description__["a" /* default */]
        }, {
            path: '/anbefalinger',
            name: 'Anbefalinger',
            component: __WEBPACK_IMPORTED_MODULE_20__views_portal_Anbefalinger__["a" /* default */]
        }, {
            path: '/kundeoversigt',
            name: 'Opgaveoversigt',
            component: __WEBPACK_IMPORTED_MODULE_19__views_portal_Opgaveoversigt__["a" /* default */]
        }, {
            path: '/rediger-kreditkort-oplysninger',
            name: 'Rediger kreditkort oplysninger',
            component: __WEBPACK_IMPORTED_MODULE_22__views_portal_EditCreditCard__["a" /* default */]
        }, {
            path: '/visitkort',
            name: 'Køb streamers og visitkort',
            component: __WEBPACK_IMPORTED_MODULE_23__views_portal_EditvisitKort__["a" /* default */]
        }, {
            path: '/expire-subscription',
            name: 'Abommanet',
            component: __WEBPACK_IMPORTED_MODULE_24__views_portal_ExpireSubscription__["a" /* default */]
        }, {
            path: '/expire-subscription-form',
            name: 'Abonnement',
            component: __WEBPACK_IMPORTED_MODULE_25__views_portal_ExpireSubscriptionForm__["a" /* default */]
        }, {
            path: '/finansiering',
            name: 'Finansiering',
            component: __WEBPACK_IMPORTED_MODULE_40__views_portal_Finansiering__["a" /* default */]
        }, {
            path: '/kredit-tjek',
            name: 'Kredittjek',
            component: __WEBPACK_IMPORTED_MODULE_41__views_portal_CreditCheck__["a" /* default */]
        }, {
            path: '/inbox',
            name: 'Inbox',
            component: __WEBPACK_IMPORTED_MODULE_59__views_portal_Inbox__["a" /* default */]
        }, {
            path: '/email',
            name: 'Email',
            component: __WEBPACK_IMPORTED_MODULE_60__views_portal_email__["a" /* default */]
        }, {
            path: '/chat',
            name: 'Chat',
            component: __WEBPACK_IMPORTED_MODULE_61__views_portal_Chat__["a" /* default */]
        }, {
            path: '/stamoplysninger',
            name: 'Din stamoplysninger',
            component: __WEBPACK_IMPORTED_MODULE_78__views_portal_stamoplysninger__["a" /* default */]
        }, {
            path: '/jule',
            name: 'Jule',
            component: __WEBPACK_IMPORTED_MODULE_62__views_portal_jule__["a" /* default */]
        }, {
            path: '/invitation',
            name: 'Invitation',
            component: __WEBPACK_IMPORTED_MODULE_63__views_portal_invite__["a" /* default */]
        }, {
            path: '/inviter-en-kollega',
            name: 'Inviter en kollega',
            component: __WEBPACK_IMPORTED_MODULE_77__views_portal_InviterKollega__["a" /* default */]
        }, {
            path: '/password',
            name: 'Password',
            component: __WEBPACK_IMPORTED_MODULE_39__views_Password__["a" /* default */]
        }, {
            path: '/medlemsfordele',
            name: 'Medlemsfordele',
            component: __WEBPACK_IMPORTED_MODULE_79__views_portal_medlemsfordele__["a" /* default */]
        }, {
            path: '/badges',
            name: 'Digitale præmier',
            component: __WEBPACK_IMPORTED_MODULE_94__views_portal_badges__["a" /* default */]
        }, {
            path: '/Artikel',
            name: 'pressArticle',
            component: __WEBPACK_IMPORTED_MODULE_95__views_portal_press_article__["a" /* default */]
        }, {
            path: '/ordrestyring',
            name: 'Ordrestyring',
            component: __WEBPACK_IMPORTED_MODULE_104__views_portal_ordrestyring__["a" /* default */]
        }, {
            path: '/approval',
            name: 'Kundebekræftelse',
            component: __WEBPACK_IMPORTED_MODULE_105__views_portal_approval__["a" /* default */]
        }, {
            path: '/approval/nps',
            name: 'NPS',
            component: __WEBPACK_IMPORTED_MODULE_106__views_portal_nps__["a" /* default */]
        }, {
            path: '/uddannelsesbevis',
            name: 'UddanelseBevis',
            component: __WEBPACK_IMPORTED_MODULE_107__views_portal_UddanelseBevis__["a" /* default */]
        }, {
            path: '/contracts',
            name: 'Contracts',
            component: __WEBPACK_IMPORTED_MODULE_110__views_portal_contracts__["a" /* default */]
        }, {
            path: '/version',
            name: 'Version',
            component: __WEBPACK_IMPORTED_MODULE_130__views_portal_version__["a" /* default */]
        }, {
            path: '/property-owner',
            name: 'Property owner',
            component: __WEBPACK_IMPORTED_MODULE_128__views_portal_PropertyOwner__["a" /* default */]
        }, {
            path: '/konto-update',
            name: 'PayproffUpdate',
            component: __WEBPACK_IMPORTED_MODULE_129__views_portal_payproff__["a" /* default */]
        }, {
            path: '/addendum',
            name: 'Addendum',
            component: __WEBPACK_IMPORTED_MODULE_133__views_portal_addendum__["a" /* default */]
        }, {
            path: '/worksheet',
            name: 'Worksheet',
            component: __WEBPACK_IMPORTED_MODULE_134__views_portal_worksheet__["a" /* default */]
        }]
    }, {
        path: '/markedsplads',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/privat-udbud',
            name: 'Privat Udbud',
            component: __WEBPACK_IMPORTED_MODULE_48__views_portal_Marketplace__["a" /* default */]
        }, {
            path: '/privat-udbud-bitrix',
            name: 'Privat Udbud2',
            component: __WEBPACK_IMPORTED_MODULE_49__views_portal_Marketplace2__["a" /* default */]
        }, {
            path: '/offentlige-udbud',
            name: 'Offentlige Udbud',
            component: __WEBPACK_IMPORTED_MODULE_4__views_portal_udbud__["a" /* default */]
        }, {
            path: '/opgaveinvitationer',
            name: 'Openminbolig2job',
            component: __WEBPACK_IMPORTED_MODULE_50__views_portal_MarketplaceMinbolig2__["a" /* default */]
        }]
    }, {
        path: '/tilbud',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/tilbud/tilbud-historie',
            name: 'Tilbudshistorie',
            component: __WEBPACK_IMPORTED_MODULE_68__views_portal_StandardTilbudhistory__["a" /* default */]
        }, {
            path: '/tilbud/standardTilbud',
            name: 'StandardTilbud',
            component: __WEBPACK_IMPORTED_MODULE_69__views_portal_standardTilbud__["a" /* default */]
        }, {
            path: '/tilbud/hurtigt-tilbud',
            name: 'HurtigtTilbud',
            component: __WEBPACK_IMPORTED_MODULE_69__views_portal_standardTilbud__["a" /* default */]
        }, {
            path: '/tilbud/upload-tilbud',
            name: 'UploadTilbud',
            component: __WEBPACK_IMPORTED_MODULE_69__views_portal_standardTilbud__["a" /* default */]
        }, {
            path: '/tilbud/standardTilbudProduct',
            name: 'StandardTilbudProduct',
            component: __WEBPACK_IMPORTED_MODULE_70__views_portal_standardTilbudProduct__["a" /* default */]
        }]
    }, {
        path: '/webshop',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/webshop/overview',
            name: 'WebShop Oversigt',
            component: __WEBPACK_IMPORTED_MODULE_80__views_portal_webshop_overview__["a" /* default */]
        }, {
            path: '/webshop/product',
            name: 'Product',
            component: __WEBPACK_IMPORTED_MODULE_82__views_portal_webshop_product__["a" /* default */]
        }, {
            path: '/webshop/products',
            name: 'Products',
            component: __WEBPACK_IMPORTED_MODULE_81__views_portal_webshop_products__["a" /* default */]
        }, {
            path: '/webshop/cart',
            name: 'Cart',
            component: __WEBPACK_IMPORTED_MODULE_83__views_portal_webshop_cart__["a" /* default */]
        }, {
            path: '/webshop/checkout',
            name: 'Checkout',
            component: __WEBPACK_IMPORTED_MODULE_84__views_portal_webshop_checkout__["a" /* default */]
        }, {
            path: '/webshop/orders',
            name: 'Orders',
            component: __WEBPACK_IMPORTED_MODULE_85__views_portal_webshop_orders__["a" /* default */]
        }, {
            path: '/webshop/order',
            name: 'Order',
            component: __WEBPACK_IMPORTED_MODULE_86__views_portal_webshop_order__["a" /* default */]
        }, {
            path: '/webshop/wishlist',
            name: 'Wish List',
            component: __WEBPACK_IMPORTED_MODULE_87__views_portal_webshop_wishlist__["a" /* default */]
        }, {
            path: '/webshop/fb-ads',
            name: 'Fb Ads',
            component: __WEBPACK_IMPORTED_MODULE_88__views_portal_webshop_FbAds__["a" /* default */]
        }, {
            path: '/webshop/google-ads',
            name: 'Google Ads',
            component: __WEBPACK_IMPORTED_MODULE_89__views_portal_webshop_GoogleAds__["a" /* default */]
        }, {
            path: '/webshop/boost-profilside',
            name: 'Boost profileside',
            component: __WEBPACK_IMPORTED_MODULE_90__views_portal_webshop_BoostProfilside__["a" /* default */]
        }, {
            path: '/webshop/boost-projekt',
            name: 'Boost projekt',
            component: __WEBPACK_IMPORTED_MODULE_91__views_portal_webshop_BoostProjekt__["a" /* default */]
        }, {
            path: '/webshop/boost-en-anbefaling',
            name: 'Boost anbefale',
            component: __WEBPACK_IMPORTED_MODULE_92__views_portal_webshop_BoostEnAnbefaling__["a" /* default */]
        }, {
            path: '/webshop/terms-and-conditions',
            name: 'Terms and Conditions',
            component: __WEBPACK_IMPORTED_MODULE_93__views_portal_webshop_TermsAndConditions__["a" /* default */]
        }]
    }, {
        path: '/klima',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/klima/klima',
            name: 'Klima Plan',
            component: __WEBPACK_IMPORTED_MODULE_96__views_portal_klima_klima__["a" /* default */]
        }, {
            path: '/klima/checklist',
            name: 'Klima Checklist',
            component: __WEBPACK_IMPORTED_MODULE_97__views_portal_klima_checklist__["a" /* default */]
        }, {
            path: '/klima/survey',
            name: 'Klima - Customer Checklist',
            component: __WEBPACK_IMPORTED_MODULE_98__views_portal_klima_survey__["a" /* default */]
        }, {
            path: '/klima/editsurvey',
            name: 'Klima - Edit Checklist',
            component: __WEBPACK_IMPORTED_MODULE_99__views_portal_klima_editsurvey__["a" /* default */]
        }, {
            path: '/klima/registration',
            name: 'Klima - Register Fag',
            component: __WEBPACK_IMPORTED_MODULE_100__views_portal_klima_registration__["a" /* default */]
        }, {
            path: '/klima/documentation',
            name: 'Documentation',
            component: __WEBPACK_IMPORTED_MODULE_101__views_portal_klima_dokumentation__["a" /* default */]
        }]
    }, {
        path: '/questionnaire',
        name: 'Questionnaire',
        component: __WEBPACK_IMPORTED_MODULE_108__views_Questionnaire__["a" /* default */]
    }, {
        path: '/questionnaire-thankyou',
        name: 'Questionnaire Thankyou',
        component: __WEBPACK_IMPORTED_MODULE_109__views_QuestionnaireThankyou__["a" /* default */]
    }, {
        path: '/messages/inbox',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/messages/inbox',
            name: 'Indbakke',
            component: __WEBPACK_IMPORTED_MODULE_111__views_portal_messages_inbox__["a" /* default */]
        }, {
            path: '/messages/sent',
            name: 'Sendt',
            component: __WEBPACK_IMPORTED_MODULE_112__views_portal_messages_sent__["a" /* default */]
        }]
    }, {
        path: '/',
        name: '',
        component: __WEBPACK_IMPORTED_MODULE_2__containers_Full__["a" /* default */],
        children: [{
            path: '/customer-projects/timeline',
            name: 'Timeline',
            component: __WEBPACK_IMPORTED_MODULE_113__views_portal_customerprojects_timeline__["a" /* default */]
        }, {
            path: '/customer-projects/project-dashboard',
            name: 'ProjectsDashboard',
            component: __WEBPACK_IMPORTED_MODULE_114__views_portal_customerprojects_ProjectDashboard__["a" /* default */]
        }, {
            path: '/customer-projects/approved-projects',
            name: 'ApprovedProjects',
            component: __WEBPACK_IMPORTED_MODULE_115__views_portal_customerprojects_ApprovedProjects__["a" /* default */]
        }, {
            path: '/customer-projects/contract',
            name: 'Contract',
            component: __WEBPACK_IMPORTED_MODULE_116__views_portal_customerprojects_contract__["a" /* default */]
        }, {
            path: '/customer-projects/calendar',
            name: 'Calendar',
            component: __WEBPACK_IMPORTED_MODULE_117__views_portal_customerprojects_calendar__["a" /* default */]
        }, {
            path: '/customer-projects/contract-manager',
            name: 'ContractManager',
            component: __WEBPACK_IMPORTED_MODULE_118__views_portal_customerprojects_contract_manager__["a" /* default */]
        }, {
            path: '/customer-projects/contract-main',
            name: 'ContractMain',
            component: __WEBPACK_IMPORTED_MODULE_119__views_portal_customerprojects_contract_main__["a" /* default */]
        }, {
            path: '/customer-projects/contract-main-tak',
            name: 'ContractMainTak',
            component: __WEBPACK_IMPORTED_MODULE_120__views_portal_customerprojects_contract_main_tak__["a" /* default */]
        }, {
            path: '/customer-projects/contract-mainv2',
            name: 'ContractMainv2',
            component: __WEBPACK_IMPORTED_MODULE_121__views_portal_customerprojects_contract_mainv2__["a" /* default */]
        }, {
            path: '/customer-projects/contract-draft',
            name: 'draftContract',
            component: __WEBPACK_IMPORTED_MODULE_122__views_portal_customerprojects_contract_draft__["a" /* default */]
        }, {
            path: '/customer-projects/contract-addon',
            name: 'draftContractXtrawork',
            component: __WEBPACK_IMPORTED_MODULE_123__views_portal_customerprojects_contract_extrawork_addon__["a" /* default */]
        }, {
            path: '/customer-projects/addon-liste',
            name: 'Extraworklist',
            component: __WEBPACK_IMPORTED_MODULE_124__views_portal_customerprojects_extraworklist__["a" /* default */]
        }, {
            path: '/customer-projects/payment-management',
            name: 'Paymentmanagement',
            component: __WEBPACK_IMPORTED_MODULE_126__views_portal_customerprojects_payment_management__["a" /* default */]
        }, {
            path: '/customer-projects/mangel-liste',
            name: 'MangelList',
            component: __WEBPACK_IMPORTED_MODULE_127__views_portal_customerprojects_mangel_list__["a" /* default */]
        }, {
            path: '/customer-projects/projekt-billeder',
            name: 'ProjectImages',
            component: __WEBPACK_IMPORTED_MODULE_125__views_portal_customerprojects_projekt_billeder__["a" /* default */]
        }, {
            path: '/customer-projects/documents',
            name: 'Documents',
            component: __WEBPACK_IMPORTED_MODULE_131__views_portal_customerprojects_documents__["a" /* default */]
        }, {
            path: '/customer-projects/tender',
            name: 'Documents-Tender',
            component: __WEBPACK_IMPORTED_MODULE_132__views_portal_customerprojects_tenderFolder__["a" /* default */]
        }]
    }]
}));

/***/ }),
/* 709 */,
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__ = __webpack_require__(711);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476e7343_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__ = __webpack_require__(765);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Full_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_476e7343_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Full_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__nav__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components___ = __webpack_require__(713);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'full',
  components: {
    AppHeader: __WEBPACK_IMPORTED_MODULE_1__components___["b" /* Header */],
    Sidebar: __WEBPACK_IMPORTED_MODULE_1__components___["c" /* Sidebar */],

    AppFooter: __WEBPACK_IMPORTED_MODULE_1__components___["a" /* Footer */]
  },
  watch: {
    '$route': function $route(to, from) {
      document.body.classList.remove('sidebar-mobile-show');
    }
  },
  created: function created() {
    this.projectPerson = localStorage.getItem('id_token_portal');
    if (this.projectPerson === null) {
      this.$router.push('/login');
    }
    if (localStorage.getItem('email') !== 'simon@imentor.dk' && localStorage.getItem('email') !== 'hossygf@gmail.com' && localStorage.getItem('email') !== 'pn@elternativet.dk' && localStorage.getItem('email') !== 'info@murermesterk.dk' && localStorage.getItem('email') !== 'info@friskmalerservice.dk') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a');
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i];
          console.log(el.href);
          if (el.href.includes('#/visitkort')) {
            els[i].style.display = 'none';
            els[i].href = '#';
          }
          if (el.href.includes('#/inviter-en-kollega')) {
            els[i].style.display = 'none';
            els[i].href = '#';
          }
        }
      }, 500);
    }

    if (localStorage.getItem('inhouse') === '1') {
      window.addEventListener('storage', this.storageHandler, false);
    }
    if (localStorage.getItem('isshop') !== 'true') {
      setTimeout(function () {
        var element = document.getElementById('dropWebshop');
        element.style.display = 'none';
      }, 500);
    }
    if (localStorage.getItem('climate') !== 'true') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a');
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i];
          if (el.href.includes('#/klima')) {
            els[i].style.display = 'none';
            els[i].href = '#';
          }
        }
      }, 500);
    }
    if (localStorage.getItem('isadmin') === 'false') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a');
        var pers = JSON.parse(localStorage.getItem('permission'));
        for (var i = 0, l = els.length; i < l; i++) {
          var el = els[i];
          var permission = null;
          if (el.href.includes('#/newsfeed')) {
            for (var j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'newsfeed' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/markedsplads')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'marketplace' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/mester-arbejdskraft')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'm2m' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/mester-opgaver')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'm2m' && permission.value === '0') {
                var menu = document.getElementById('dropMester-til-Mester');
                menu.style.display = 'none';
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/settings')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'settings' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/alle-moeder')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'your_client' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/inbox')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'message' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/indhent-anbefalinger') || el.href.includes('#/laes-og-besvar-anbefalinger') || el.href.includes('#/auto-anbefalinger') || el.href.includes('#/widgets')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'recommendations' && permission.value === '0') {
                var menua = document.getElementById('dropAnbefalinger');
                menua.style.display = 'none';
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/opret-projekt-new')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'projects' && permission.value === '0') {
                var menup = document.getElementById('dropDine projekter');
                menup.style.display = 'none';
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/status-haandvaerker-new')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'projects' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/chat')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'chat' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/offer')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'make_an_offer' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
          if (el.href.includes('#/contact_us')) {
            for (j = 0, z = pers.length; j < z; j++) {
              permission = pers[j];
              if (permission.module === 'contact_us' && permission.value === '0') {
                els[i].style.display = 'none';
                els[i].href = '#';
              }
            }
          }
        }
      }, 500);
    }
    if (localStorage.getItem('onlycredit') === '1') {
      setTimeout(function () {
        var els = document.getElementsByTagName('a');
        for (var e = 0, r = els.length; e < r; e++) {
          if (!els[e].href.includes('#/login') && !els[e].href.includes('kredit') && !els[e].href.includes('kreditkort')) {
            els[e].style.display = 'none';
            els[e].href = '#';
          }
        }
        var element = document.getElementById('dropAnbefalinger');
        element.style.display = 'none';
        element = document.getElementById('dropDine projekter');
        element.style.display = 'none';
        element = document.getElementById('dropMester-til-Mester');
        element.style.display = 'none';
        element = document.getElementById('dropWebshop');
        element.style.display = 'none';
        element = document.getElementById('dropOpret tilbud');
        element.style.display = 'none';
      }, 500);
    }
  },
  data: function data() {
    return {
      nav: __WEBPACK_IMPORTED_MODULE_0__nav__["a" /* default */].items
    };
  },

  methods: {
    storageHandler: function storageHandler(evt) {
      if (evt.key === 'id_token_portal') {
        this.$router.push('/security');
      }
    }
  },
  computed: {
    name: function name() {
      return this.$route.name;
    },
    list: function list() {
      return this.$route.matched;
    }
  }
});

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    items: [{
        name: 'Forside',
        url: '/newsfeed',
        class: 'darkblue gibson h5 semi-bold capitalletter',
        icon: 'el-icon-house ml1 darkblue'
    }, {
        name: 'Anbefalinger',
        url: '/anbefalinger',
        class: 'darkblue gibson h5 mr2 regular',
        icon: 'el-icon-star-off mr2 darkblue',
        children: [{
            name: 'Indhent anbefalinger',
            class: 'darkblue gibson h5 regular',
            url: '/indhent-anbefalinger'
        }, {
            name: 'Læs og besvar',
            class: 'darkblue gibson h5 regular',
            url: '/laes-og-besvar-anbefalinger'
        }, {
            name: 'Anbefaling',
            class: 'darkblue gibson h5 regular ',
            url: '/anbefalinger-sammendrag'
        }, {
            name: 'Sæt anbefalinger på Auto-pilot',
            class: 'darkblue gibson h5 regular pl1',
            url: '/auto-anbefalinger'
        }, {
            name: 'Widgets',
            class: 'darkblue gibson h5 regular',
            url: '/widgets'
        }]
    }, {
        name: 'Mine kunder',
        url: '/alle-moeder',
        class: 'darkblue gibson h5 semi-bold',
        icon: 'el-icon-files mr2 darkblue'
    }, {
        name: 'Dine projekter',
        url: '/',
        class: 'darkblue gibson h5 regular',
        icon: 'el-icon-picture-outline mr2 darkblue',
        children: [{
            name: 'Opret projekt',
            url: '/opret-projekt-new',
            class: 'darkblue gibson h5 regular'
        }, {
            name: 'Mine projekter',
            url: '/status-haandvaerker-new',
            class: 'darkblue gibson h5 regular'
        }, {
            name: 'Vundne kundeprojekter',
            url: '/customer-projects/project-dashboard',
            class: 'darkblue gibson h5 regular'
        }]
    }, {
        name: 'Markedsplads',
        url: '/markedsplads',
        class: 'darkblue gibson h5 semi-bold',
        icon: 'el-icon-money mr2 darkblue',
        children: [{
            name: 'Offentlig udbud',
            url: '/offentlige-udbud',
            class: 'darkblue gibson h5 regular'
        }]
    }, {
        name: 'Mester-til-Mester',
        url: '/',
        class: 'darkblue gibson h5 regular',
        icon: 'el-icon-share mr2 darkblue',
        children: [{
            name: 'Arbejdskraft',
            url: '/mester-arbejdskraft',
            class: 'darkblue gibson h5 regular'
        }, {
            name: 'Opgaver',
            url: '/mester-opgaver',
            class: 'darkblue gibson h5 regular'
        }]
    }, {
        name: 'Tilbudshistorie',
        url: '/tilbud/tilbud-historie',
        class: 'darkblue gibson h5 semi-bold',
        icon: 'el-icon-document mr2 darkblue'
    }, {
        name: 'Inviter en kollega',
        url: '/inviter-en-kollega',
        class: 'darkblue gibson h5 regular hide',
        icon: 'el-icon-present mr2 darkblue'
    }, {
        name: 'Gratis hjemmeside',
        url: '/hjemmeside',
        class: 'darkblue gibson h5 semi-bold nav-dropdown-toggle ',
        icon: 'el-icon-monitor mr2 darkblue'
    }, {
        name: 'Medlemsfordele',
        url: '/medlemsfordele',
        class: 'darkblue gibson h5 regular',
        icon: 'el-icon-present mr2 darkblue'
    }, {
        name: 'Webshop',
        url: '/',
        class: 'darkblue gibson h5 regular',
        icon: 'el-icon-shopping-cart-2 mr2 darkblue',
        children: [{
            name: 'Alle produkter',
            url: '/webshop/products',
            class: 'darkblue gibson h5 regular'
        }]
    }, {
        name: 'Digital pakke',
        url: '/badges',
        class: 'darkblue gibson h5 semi-bold',
        icon: 'el-icon-present mr2 darkblue'
    }, {
        name: 'Arbejdsseddel',
        url: '/',
        class: 'darkblue gibson h5 regular',
        icon: 'el-icon-share mr2 darkblue',
        children: [{
            name: 'Ny Arbejdsseddel',
            url: '/addendum',
            class: 'darkblue gibson h5 semi-bold'
        }, {
            name: 'Arbejdsseddeler',
            url: '/worksheet',
            class: 'darkblue gibson h5 semi-bold'
        }]
    }, {
        name: 'Indstillinger',
        url: '/settings',
        icon: 'el-icon-setting mr2 darkblue',
        class: 'darkblue gibson h5 semi-bold'
    }, {
        name: 'Ofte stillede spørgsmål',
        url: '/faq',
        icon: 'el-icon-question mr2 darkblue',
        class: 'darkblue gibson h5 regular'
    }, {
        name: 'Log ud',
        url: '/login',
        class: 'darkblue gibson h5 regular pt3',
        icon: 'el-icon-back mr2 darkblue'
    }]
});

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Callout_vue__ = __webpack_require__(714);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Footer_vue__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Header_vue__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__ = __webpack_require__(739);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Switch_vue__ = __webpack_require__(762);
/* unused harmony reexport Callout */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__Footer_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Header_vue__["a"]; });
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_3__Sidebar_vue__["a"]; });
/* unused harmony reexport Switch */









/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8f0b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__ = __webpack_require__(716);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Callout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59b8f0b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Callout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    variant: {
      type: String
    }
  },
  computed: {
    classList: function classList() {
      return ['callout', this.calloutVariant];
    },
    calloutVariant: function calloutVariant() {
      return this.variant ? 'callout-' + this.variant : '';
    }
  }
});

/***/ }),
/* 716 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea89fcb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(718)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea89fcb_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 718 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__views_portal_FindWork__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__views_portal_noneligibleFeaturepop__ = __webpack_require__(43);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appFooter',
  components: {
    findworkmodal: __WEBPACK_IMPORTED_MODULE_0__views_portal_FindWork__["a" /* default */],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_1__views_portal_noneligibleFeaturepop__["a" /* default */]
  },
  data: function data() {
    return {
      modalShow: false,
      chat: true,
      contact: true,
      mester: true,
      eligible: ''
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('OfferCreator');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (!localStorage.getItem('ads')) {
      this.modalShow = true;
      localStorage.setItem('ads', 'true');
    }
    var permission = null;
    if (localStorage.getItem('isadmin') === 'false') {
      var pers = JSON.parse(localStorage.getItem('permission'));
      for (var j = 0, z = pers.length; j < z; j++) {
        permission = pers[j];
        if (permission.module === 'chat' && permission.value === '0') {
          this.chat = false;
        }
        if (permission.module === 'contact_us' && permission.value === '0') {
          this.contact = false;
        }
        if (permission.module === 'm2m' && permission.value === '0') {
          this.mester = false;
        }
      }
    }
  },

  watch: {},
  methods: {
    getdataigibility: function getdataigibility() {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible);
      } else {
        this.$refs.quickandstandard.show();
      }
    },
    hideModal: function hideModal() {
      this.$refs['csModal'].hide();
    },
    hideModalquickandstandard: function hideModalquickandstandard() {
      this.$refs['quickandstandard'].hide();
    },
    showChat: function showChat() {
      window.bitrixChat();
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FindWork_vue__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6dcea3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_FindWork_vue__ = __webpack_require__(723);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f6dcea3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FindWork_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f6dcea3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_FindWork_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'findworkmodal',
  data: function data() {
    return {
      findworkShow: false
    };
  },

  methods: {
    closeFindWorkModal: function closeFindWorkModal() {
      this.$refs.findworkModal.hide();
    },
    OpenUrl: function OpenUrl(url) {
      this.$router.push(url);
      this.$refs.findworkModal.hide();
    }
  }
});

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{staticClass:"darkblue no-hover pointer",on:{"click":function($event){_vm.findworkShow = !_vm.findworkShow}}},[_c('div',{staticClass:"col-12 center"},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M269.2 285.3c-0.5-0.5-1-0.9-1.5-1.2 -0.5-0.4-1.1-0.7-1.7-0.9 -0.6-0.2-1.2-0.4-1.9-0.6 -3.2-0.6-6.7 0.4-9 2.7 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 0.7 0 1.3-0.1 2-0.2 0.6-0.1 1.3-0.3 1.9-0.6 0.6-0.2 1.2-0.6 1.7-0.9 0.6-0.4 1.1-0.8 1.5-1.2 1.9-1.9 2.9-4.4 2.9-7.1C272.2 289.7 271.1 287.1 269.2 285.3z"}}),_c('path',{attrs:{"d":"M509.1 154.4l-81-81c-3.9-3.9-10.2-3.9-14.1 0l-45.4 45.4c-2.2 2.2-3.2 5.2-2.9 8 -6.4 1.6-13.8 3.3-20.6 4.6h0c-12.4 2.3-16.1 2-16.7 1.9 -24.2-3.5-49 4.8-66.3 22.1l-0.7 0.7c-18.5-14.3-43.7-21.7-65.8-18.5 -5.7 0.8-25.4-3.2-40.7-7.1 0.5-3-0.5-6.3-2.8-8.6l-48.5-48.5c-3.9-3.9-10.2-3.9-14.1 0l-86.5 86.5c-3.9 3.9-3.9 10.2 0 14.1l48.5 48.5c2 2 4.5 2.9 7.1 2.9 0.6 0 1.2-0.1 1.8-0.2l3.7 20.8c5.9 33.2 20.9 63.3 43.6 86.9 0.8 0.8 1.6 1.7 2.5 2.5l96.9 96.9c5.9 5.9 13.8 9.2 22.2 9.2 8.4 0 16.2-3.3 22.2-9.2 2.8-2.8 5-6.1 6.5-9.5l8.2 8.2c5.9 5.9 13.8 9.2 22.2 9.2 8.4 0 16.2-3.3 22.2-9.2 2.8-2.8 5-6 6.5-9.5l2 2c12.2 12.2 32.1 12.2 44.3 0 10.4-10.4 11.9-26.3 4.7-38.4 3.9-1.6 7.4-3.9 10.4-6.9 5.9-5.9 9.2-13.8 9.2-22.2 0-4.3-0.9-8.4-2.5-12.3l24-24c0.8-0.8 1.6-1.6 2.3-2.4 21.3-22.2 35.5-50.4 41-81.7l3.3-18.8c0.4 0 0.8 0.1 1.2 0.1 2.6 0 5.1-1 7.1-2.9l45.4-45.4C513 164.6 513 158.3 509.1 154.4zM58.5 201.3l-34.4-34.4 72.3-72.3 34.4 34.4L58.5 201.3zM364 364c-2.1 2.1-5 3.3-8 3.3 -3 0-5.9-1.2-8-3.3l-56.5-56.5c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l71.6 71.6c4.4 4.4 4.4 11.6 0 16 -4.4 4.4-11.6 4.4-16 0l-109.8-109.8c-3.9-3.9-10.2-3.9-14.1 0 -2 2-2.9 4.5-2.9 7.1 0 2.6 1 5.1 2.9 7.1l87.2 87.2c2.1 2.1 3.3 5 3.3 8 0 3-1.2 5.9-3.3 8 -2.1 2.1-5 3.3-8 3.3 -3 0-5.9-1.2-8-3.3l-90.1-90.1c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l61.3 61.3c0.1 0.1 0.1 0.1 0.2 0.1 4.3 4.4 4.2 11.5-0.1 15.9 -2.1 2.1-5 3.3-8 3.3 -3 0-5.9-1.2-8-3.3l-96.9-96.9c-0.7-0.7-1.5-1.5-2.2-2.2 -19.9-20.7-33.1-47.2-38.3-76.5l-5.7-32.4 62.8-62.8c13.7 3.9 45.2 11.9 57.6 10.1 15.9-2.3 34.6 3 48.7 13l-57.9 57.9c-0.4 0.4-0.7 0.7-1.1 1.1 0 0.1-0.1 0.1-0.1 0.2 -0.3 0.3-0.6 0.7-0.9 1 0 0 0 0 0 0 -4.3 5.3-6.7 11.9-6.7 18.9s2.4 13.6 6.7 18.9c0 0 0 0 0 0 0.3 0.3 0.6 0.7 0.9 1 0 0.1 0.1 0.1 0.1 0.2 0.3 0.4 0.7 0.7 1.1 1.1s0.7 0.7 1.1 1.1c0.1 0 0.1 0.1 0.2 0.1 0.3 0.3 0.7 0.6 1 0.9 0 0 0 0 0 0 5.3 4.3 11.9 6.7 18.9 6.7 7.5 0 14.5-2.7 20-7.7 0 0 0.1 0 0.1-0.1 0.4-0.3 0.8-0.7 1.1-1.1l19.5-19.5 8.1-8.1L364 348c0 0 0 0 0 0 0.1 0.1 0.2 0.3 0.4 0.4 0.1 0.1 0.2 0.2 0.2 0.3 0.1 0.1 0.1 0.1 0.2 0.2 1.6 2 2.5 4.5 2.5 7.1C367.3 359 366.1 361.9 364 364zM432.4 232.2c-4.8 27.3-17.2 52-35.7 71.3 -0.7 0.7-1.3 1.4-2 2.1l-22.4 22.4 -5.3-5.3 -93.7-93.7 24.9-24.9c3.9-3.9 3.9-10.2 0-14.1 -3.9-3.9-10.2-3.9-14.1 0l-66.7 66.7c-0.2 0.2-0.5 0.5-0.8 0.7 0 0 0 0 0 0 -3.6 2.9-8.8 3-12.5 0.1 0 0-0.1 0-0.1-0.1 -0.3-0.2-0.5-0.4-0.8-0.7s-0.5-0.5-0.7-0.8c0 0 0-0.1-0.1-0.1 -0.2-0.2-0.4-0.5-0.5-0.7 0 0 0 0 0 0 -2.2-3.3-2.2-7.7 0-11 0 0 0 0 0 0 0.2-0.2 0.3-0.5 0.5-0.7 0 0 0-0.1 0.1-0.1 0.2-0.3 0.4-0.5 0.7-0.8l72.9-72.9c12.9-12.9 31.3-19 49.3-16.4 3 0.4 8.7 0.7 23.3-2.1h0c11-2.1 22.8-5.1 30.6-7.3l22.2 22.2 -27.5 27.5c-12.6 12.6-33.2 12.6-45.9 0l-0.9-0.9c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l0.9 0.9c9.9 9.9 23.1 15.4 37.1 15.4 14 0 27.2-5.5 37.1-15.4l27.5-27.5 21.9 21.9L432.4 232.2zM456.6 192.8l-1.1-1.1c0 0 0 0 0 0l-65.8-65.8 31.3-31.3 66.8 66.8L456.6 192.8z"}})]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue"},[_vm._v("Mester til Mester")])])]),_vm._v(" "),_c('b-modal',{ref:"findworkModal",attrs:{"lazy":"","centered":"","hide-header-close":"","hide-footer":"","id":"modal-center","lazy":""},model:{value:(_vm.findworkShow),callback:function ($$v) {_vm.findworkShow=$$v},expression:"findworkShow"}},[_c('div',{staticClass:"clearfix p2"},[_c('div',[_c('div',{staticClass:"col-12 flex flex-wrap"},[_c('div',{staticClass:"col-6 flex flex-column justify-center items-center border-right mediumgrey-border border-bottom pointer",staticStyle:{"height":"200px"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads')}}},[_c('div',[_c('svg',{attrs:{"fill":"#0091b9","width":"80","height":"80","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m502 80h-442v-70c0-5.523438-4.476562-10-10-10-27.570312 0-50 22.429688-50 50v412c0 27.570312 22.429688 50 50 50h452c5.523438 0 10-4.476562 10-10v-412c0-5.523438-4.476562-10-10-10zm-462-58.285156v391.292968c-7.386719 1.503907-14.183594 4.640626-20 9.019532v-372.027344c0-13.039062 8.359375-24.160156 20-28.285156zm452 470.285156h-442c-16.542969 0-30-13.457031-30-30s13.457031-30 30-30c5.523438 0 10-4.476562 10-10v-322h432zm0 0"}}),_c('path',{attrs:{"d":"m116.761719 289.828125c1.546875 3.734375 5.191406 6.171875 9.238281 6.171875h22v142c0 5.523438 4.476562 10 10 10h192c5.523438 0 10-4.476562 10-10v-142h22c4.042969 0 7.691406-2.4375 9.238281-6.171875 1.546875-3.738281.691407-8.039063-2.167969-10.898437l-128-128c-3.902343-3.90625-10.234374-3.90625-14.140624 0l-128 128c-2.859376 2.859374-3.714844 7.160156-2.167969 10.898437zm119.238281 138.171875v-76h36v76zm104 0h-48v-86c0-5.523438-4.476562-10-10-10h-56c-5.523438 0-10 4.476562-10 10v86h-48v-132h172zm-86-255.859375 103.859375 103.859375h-207.71875zm0 0"}}),_c('path',{attrs:{"d":"m426 333c-5.523438 0-10 4.476562-10 10v85h-18c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h28c5.523438 0 10-4.476562 10-10v-95c0-5.523438-4.476562-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m350 168h66v85c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-95c0-5.523438-4.476562-10-10-10h-76c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m426 288c-2.628906 0-5.210938 1.070312-7.070312 2.929688-1.859376 1.859374-2.929688 4.441406-2.929688 7.070312s1.070312 5.210938 2.929688 7.070312c1.859374 1.859376 4.441406 2.929688 7.070312 2.929688s5.210938-1.070312 7.070312-2.929688c1.859376-1.859374 2.929688-4.441406 2.929688-7.070312s-1.070312-5.210938-2.929688-7.070312c-1.859374-1.859376-4.441406-2.929688-7.070312-2.929688zm0 0"}})])]),_vm._v(" "),_c('a',{staticClass:"text-decoration-none",staticStyle:{"color":"#0091b9"}},[_c('p',{staticClass:"h5 line-height-1 m0"},[_vm._v("\n                Find opgave\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 flex flex-column justify-center items-center mediumgrey-border border-bottom pointer",staticStyle:{"height":"200px"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads?mode=job')}}},[_c('div',[_c('svg',{attrs:{"fill":"#0091b9","width":"80","height":"80","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M460.9 268.5c4.5-6.7 7.2-14.8 7.2-23.5v-8c0-23.2-18.9-42.1-42.1-42.1 -11.6 0-22.1 4.7-29.7 12.3C376.6 148.6 321.2 106.3 256 106.3s-120.6 42.3-140.3 100.9c-7.6-7.6-18.1-12.3-29.7-12.3 -23.2 0-42.1 18.9-42.1 42.1v8c0 8.7 2.6 16.8 7.2 23.5C21.9 274.6 0 300.5 0 331.5v20.1c0 5.5 4.5 10 10 10h52c5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10H20v-10.1c0-24.5 19.9-44.3 44.3-44.3h47.3c3.8 16.9 10.6 32.7 19.6 46.8L17.2 448c-14.6 14.6-14.6 38.4 0 53 7.3 7.3 16.9 11 26.5 11 9.6 0 19.2-3.7 26.5-11l62.9-62.9c3.9-3.9 3.9-10.2 0-14.1 -3.9-3.9-10.2-3.9-14.1 0L56.1 486.9c-6.8 6.8-17.9 6.8-24.7 0 -6.8-6.8-6.8-17.9 0-24.7L143.4 350.2c27.2 31.9 67.6 52.1 112.6 52.1 70.3 0 129.4-49.3 144.3-115.2h47.3c24.5 0 44.3 19.9 44.3 44.3v10.1h-94c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h104c5.5 0 10-4.5 10-10v-20.1C512 300.5 490.1 274.6 460.9 268.5zM108.1 245c0 12.2-9.9 22.1-22.1 22.1s-22.1-9.9-22.1-22.1v-8c0-12.2 9.9-22.1 22.1-22.1 12.2 0 22.1 9.9 22.1 22.1V245zM256 382.3c-70.6 0-128-57.4-128-128s57.4-128 128-128 128 57.4 128 128S326.6 382.3 256 382.3zM448.1 245c0 12.2-9.9 22.1-22.1 22.1 -12.2 0-22.1-9.9-22.1-22.1v-8c0-12.2 9.9-22.1 22.1-22.1 12.2 0 22.1 9.9 22.1 22.1V245z"}}),_c('path',{attrs:{"d":"M256 146.3c-59.6 0-108 48.4-108 108 0 30.9 13.1 58.8 33.9 78.5 0.4 0.4 0.7 0.8 1.2 1.1 19.2 17.6 44.8 28.4 72.9 28.4s53.7-10.8 72.9-28.4c0.4-0.3 0.8-0.7 1.2-1.1C350.9 313.1 364 285.2 364 254.3 364 194.7 315.6 146.3 256 146.3zM256 342.3c-20.6 0-39.5-7.1-54.5-19 10.6-20.1 31.3-32.8 54.5-32.8s43.9 12.6 54.5 32.8C295.5 335.2 276.6 342.3 256 342.3zM234.9 249.5v-7.8c0-11.6 9.5-21.1 21.1-21.1s21.1 9.5 21.1 21.1v7.8c0 11.6-9.5 21.1-21.1 21.1S234.9 261.1 234.9 249.5zM325.1 308.7c-9.2-14.6-22.6-25.8-38.3-32.1 6.3-7.2 10.2-16.7 10.2-27.1v-7.8c0-22.6-18.4-41.1-41.1-41.1 -22.6 0-41.1 18.4-41.1 41.1v7.8c0 10.4 3.9 19.8 10.2 27.1 -15.7 6.4-29.1 17.5-38.3 32.1C175.1 293.7 168 274.8 168 254.3c0-48.5 39.5-88 88-88s88 39.5 88 88C344 274.8 336.9 293.7 325.1 308.7z"}}),_c('path',{attrs:{"d":"M159.9 397.2c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1s1.1 5.2 2.9 7.1c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S161.7 399.1 159.9 397.2z"}}),_c('path',{attrs:{"d":"M256.2 0c-5.5 0-10 4.5-10 10v34c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V10C266.2 4.5 261.7 0 256.2 0z"}}),_c('path',{attrs:{"d":"M263.3 69.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C266.2 74.4 265.1 71.8 263.3 69.9z"}}),_c('path',{attrs:{"d":"M341 39.2c-3.9-3.9-10.2-3.9-14.1 0L309.3 56.8c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l17.6-17.6C344.9 49.5 344.9 43.1 341 39.2z"}}),_c('path',{attrs:{"d":"M202.9 56.9l-17.7-17.7c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l17.7 17.7c2 2 4.5 2.9 7.1 2.9 2.6 0 5.1-1 7.1-2.9C206.8 67.2 206.8 60.8 202.9 56.9z"}})])]),_vm._v(" "),_c('a',{staticClass:"text-decoration-none",staticStyle:{"color":"#0091b9"}},[_c('p',{staticClass:"h5 line-height-1 m0"},[_vm._v("\n                Find arbejdskraft\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-wrap"},[_c('div',{staticClass:"col-6 flex flex-column justify-center items-center border-right mediumgrey-border pointer",staticStyle:{"height":"200px"},on:{"click":function($event){return _vm.OpenUrl('/mester-arbejdskraft')}}},[_c('div',[_c('svg',{attrs:{"fill":"#0091b9","width":"80","height":"80","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('a',{staticClass:"text-decoration-none",staticStyle:{"color":"#0091b9"}},[_c('p',{staticClass:"h5 line-height-1 m0"},[_vm._v("\n                Opslå opgave\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 flex flex-column justify-center items-center pointer",staticStyle:{"height":"200px"},on:{"click":function($event){return _vm.OpenUrl('/mester-opgaver')}}},[_c('div',[_c('svg',{attrs:{"fill":"#0091b9","width":"80","height":"80","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('a',{staticClass:"text-decoration-none",staticStyle:{"color":"#0091b9"}},[_c('p',{staticClass:"h5 line-height-1 m0"},[_vm._v("\n                Opslå arbejdskraft\n              ")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center pb3 px2"},[_c('button',{staticClass:"h5 outlined-disabled-button flex justify-center items-center line-height-1 p2 gibson not-rounded",attrs:{"type":"reset"},on:{"click":_vm.closeFindWorkModal}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 724 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'noneligibleFeaturepop',
  props: ['eligibilitydata'],
  data: function data() {
    return {
      partnername: '',
      partnerData: [],
      salesPerson: '',
      haaid: '',
      packagehandle: '',
      partneremail: '',
      partnertelephone: '',
      actualfeaturecode: [],
      wheretogo: '',
      loading: false,
      buttondisabled: true
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaid = localStorage.getItem('haaid');
    this.packagehandle = localStorage.getItem('PartnerPackageHandle');
    this.getPartner();
  },

  methods: {
    showmodel: function showmodel(iseligible) {
      var directto = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var featurecode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      this.partnerData['eligible'] = iseligible;
      if (directto !== '') {
        this.partnerData['linkreferer'] = directto;
      } else {
        this.partnerData['linkreferer'] = this.$router.history.current.fullPath;
      }
      this.actualfeaturecode.push(featurecode);
      this.$refs.noneligeble.show();
    },
    hidemodal: function hidemodal() {
      var togohide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.$refs.noneligeble.hide();
      if (togohide === '') {
        this.goto();
      }
    },
    hidemodaltak: function hidemodaltak() {
      var togohide = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.$refs.successrequestfeature.hide();
      if (togohide === '') {
        this.goto();
      }
    },
    goto: function goto() {
      this.$router.push(this.partnerData['linkreferer']);
    },
    getPartner: function getPartner() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.partnertelephone = res.Telefon;
        _this.partnername = res.Firma;
        _this.partneremail = res.Email;
        _this.buttondisabled = false;
        if (typeof _this.packagehandle === 'undefined' || _this.packagehandle === null) {
          _this.getbitrixinfo();
        }
      }, function (response) {
        alert('error ');
      });
    },
    getbitrixinfo: function getbitrixinfo() {
      var _this2 = this;

      this.haaId = localStorage.getItem('haaid');
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getPackage/' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.packagehandle = res.data.PACKAGE_HANDLE;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    requestBitrixFeatures: function requestBitrixFeatures() {
      var _this3 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {
        company_id: this.haaid,
        company_name: this.partnername,
        name: this.partnername,
        email: this.partneremail,
        phone: this.partnertelephone,
        features: this.actualfeaturecode,
        package_name: this.packagehandle,
        requestFrom: 'Web'
      };
      this.$http.post(this.$bitrixapi + 'bitrix/requestBitrixFeatures', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.hidemodal('success');
          _this3.$refs.successrequestfeature.show();
          _this3.wheretogo = 'success';
          _this3.loading = false;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 726 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"noneligibleFeaturepop"}},[_c('b-modal',{ref:"noneligeble",attrs:{"centered":"","hide-footer":"","id":"noneligeble","no-close-on-backdrop":true}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodal()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-close"})])])])]}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix "},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Vi sender en besked til vores support team")])])]):_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"h3 my2 darkblue mx-auto Bold"},[_vm._v("Hej "+_vm._s(_vm.partnername)+" !")]),_vm._v(" "),_c('p',{staticClass:"h5 my1  darkblue mx-auto semi-bold"},[_vm._v("Denne funktion er ikke i dit abonnement.Få det nu for en bedre brugeroplevelse!")]),_vm._v(" "),_c('p',{staticClass:"h6 my4  darkblue mx-auto center "},[_vm._v("Hvis du har kobt denne funktion, skal du ga til forsiden og tilbage til denne side.")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-around my2 p0"},[_c('button',{staticClass:"col-6 mr1 darkblue-background no-border white p2 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.buttondisabled},on:{"click":function($event){return _vm.hidemodal('')}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_vm._v("Glem det")])]),_vm._v(" "),_c('button',{staticClass:"col-6 darkblue-background no-border p2 white h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.buttondisabled},on:{"click":function($event){return _vm.requestBitrixFeatures()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Få det")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])],2),_vm._v(" "),_c('b-modal',{ref:"successrequestfeature",attrs:{"centered":"","hide-footer":"","id":"successrequestfeature","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din henvendelse,")]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("Vi ringer til dig hurtigst muligt")]),_vm._v(" "),_c('button',{staticClass:" my2 col-4 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){return _vm.hidemodaltak('')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.showMobile)?_c('footer',{staticClass:"fixed right-0 bottom-0 mb3 mr3 z4",staticStyle:{"z-index":"100"}},[_c('div',{staticClass:"flex justify-end items-center py2 white-background gibson muted-border border shadow"},[(_vm.mester)?_c('div',{staticClass:"px2"},[_c('findworkmodal')],1):_vm._e(),_vm._v(" "),(_vm.chat)?_c('div',{staticClass:"px3",on:{"click":_vm.showChat}},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"}}),_c('path',{attrs:{"d":"M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"}}),_c('path',{attrs:{"d":"M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"}}),_c('path',{attrs:{"d":"M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"}}),_c('path',{attrs:{"d":"M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"}}),_c('path',{attrs:{"d":"M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"}}),_c('path',{attrs:{"d":"M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"}})]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue"},[_vm._v("Chat")])]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"csModal",attrs:{"centered":"","hide-footer":"","id":"contactCS"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end items-center col-12 px0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",on:{"click":_vm.hideModal}},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"30","height":"30","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix py4"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('div',{staticClass:"col-12 left-align"},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"fill":"currentColor","width":"30","height":"30","viewBox":"0 0 512.00007 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m72.464844 62.214844c5.519531 0 10-4.476563 10-9.996094s-4.480469-10-10-10c-5.519532 0-10 4.480469-10 10s4.480468 9.996094 10 9.996094zm0 0"}}),_c('path',{attrs:{"d":"m292.011719 30v119.992188c0 16.539062 13.457031 29.996093 30 29.996093h10v30c0 3.789063 2.136719 7.25 5.527343 8.941407 3.378907 1.691406 7.433594 1.335937 10.46875-.941407l50.660157-38h83.332031c16.542969 0 30-13.457031 30-29.996093v-119.992188c0-16.542969-13.457031-30-30-30h-159.988281c-16.542969 0-30 13.457031-30 30zm199.988281 0v119.992188c0 5.511718-4.484375 10-10 10h-86.664062c-2.164063 0-4.269532.699218-6 2l-37.328126 27.996093v-19.996093c0-5.523438-4.476562-10-10-10h-19.996093c-5.515625 0-10-4.488282-10-10v-119.992188c0-5.515625 4.484375-10 10-10h159.988281c5.515625 0 10 4.484375 10 10zm0 0"}}),_c('path',{attrs:{"d":"m143.109375 368.886719c70.453125 70.449219 157.261719 119.125 251.039063 140.769531 40.992187 9.460938 82.238281-10.453125 100.738281-47.441406l11.828125-23.664063c11.613281-23.21875 3.269531-51.875-19-65.238281l-75.351563-45.203125c-23.691406-14.222656-54.378906-6.558594-68.585937 17.144531l-13.09375 21.800782c-2.535156 4.234374-7.707032 5.972656-12.289063 4.140624-78.253906-31.296874-146.304687-99.347656-177.597656-177.59375-1.835937-4.582031-.09375-9.746093 4.140625-12.285156 29.867188-17.9375 19.566406-11.75 21.796875-13.089844 23.695313-14.203124 31.378906-44.886718 17.148437-68.585937l-45.207031-75.355469c-13.359375-22.269531-42.015625-30.613281-65.230469-19l-23.671874 11.828125c-37.3125 18.664063-56.820313 60.085938-47.441407 100.738281 21.644531 93.777344 70.324219 180.582032 140.777344 251.035157zm258.960937-23.632813 75.355469 45.207032c13.363281 8.019531 18.371094 25.210937 11.398438 39.144531l-5.25 10.503906-127.488281-76.511719 4.839843-8.058594c8.523438-14.214843 26.925781-18.820312 41.144531-10.285156zm-343.355468-310.25 23.671875-11.832031c13.84375-6.925781 31.070312-2.046875 39.140625 11.398437l45.210937 75.359376c8.527344 14.207031 3.9375 32.613281-10.296875 41.148437l-8.070312 4.847656-45.273438-75.496093c-2.839844-4.734376-8.976562-6.273438-13.714844-3.429688-4.738281 2.839844-6.273437 8.980469-3.4375 13.71875l45.414063 75.722656c-10.273437 8.15625-14.132813 22.101563-9.132813 34.589844 16.238282 40.597656 42.433594 79.667969 75.75 112.984375 33.316407 33.316406 72.390626 59.507813 112.988282 75.746094 12.503906 5.003906 26.457031 1.132812 34.605468-9.148438l128.855469 77.328125c-15.511719 25.949219-45.914062 39.113282-75.78125 32.226563-183.128906-42.261719-334.5625-193.691407-376.824219-376.8125-7.296874-31.617188 7.878907-63.839844 36.894532-78.351563zm0 0"}}),_c('path',{attrs:{"d":"m362.007812 79.996094h79.996094c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-79.996094c-5.519531 0-10 4.476562-10 10 0 5.523437 4.476563 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m362.007812 119.992188h79.996094c5.523438 0 10-4.476563 10-10 0-5.519532-4.476562-9.996094-10-9.996094h-79.996094c-5.519531 0-10 4.476562-10 9.996094 0 5.523437 4.476563 10 10 10zm0 0"}})]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue mt1"},[_vm._v("Ring")]),_vm._v(" "),_c('p',{staticClass:"h5 darklblue regular line-height-4 mb2"},[_vm._v("\n              Customer Success har åbent mandag til fredag 8-16\n              "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"tel:70228014"}},[_vm._v("Ring 7022 8014")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 left-align mt4"},[_c('img',{attrs:{"src":"/static/svg/mail-blue.svg","alt":"","height":"30"}}),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue mt1"},[_vm._v("Skriv")]),_vm._v(" "),_c('p',{staticClass:"h5 darklblue regular line-height-4 mb2"},[_vm._v("\n              Fang os på chatten mellem 8-16 eller send en mail, og vi vender tilbage indenfor 24 timer.\n              "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#/inbox?send=support"}},[_vm._v("Send os en mail")])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"col-12 flex justify-between items-center"},[_c('button',{staticClass:"col-6 outlined-disabled-button p3 h4 not-rounded gibson flex justify-center items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),_c('button',{staticClass:"col-6 action-button p3 h4 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mx2"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])],2),_vm._v(" "),_c('b-modal',{ref:"mesterModal",attrs:{"size":"sm","centered":"","hide-footer":"","id":"mesterModal"}},[_c('div',{staticClass:"py2"},[_c('a',{staticClass:"block col-12 action-button p2 h5 regular gibson flex line-height-1 justify-center items-center not-rounded no-hover white",attrs:{"href":"#/mester-opgaver"}},[_c('span',{staticClass:"white"},[_vm._v("Opgaver")]),_vm._v(" "),_c('span',{staticClass:"mx2 white"},[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 standard-button p2 h5 regular gibson flexc line-height-1 justify-center items-center not-rounded"},[_c('span',[_vm._v("Arbejdskraft")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","centered":"","hide-footer":"","id":"findwork"}},[_c('h1',[_vm._v("findwork")])])],1):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('footer',[[_c('div',{staticClass:"clearfix fixed bottom-0 left-0 right-0 justify-around py2 white-background flex  items-center z2"},[(_vm.mester)?_c('div',{staticClass:"col-4 p1"},[_c('findworkmodal')],1):_vm._e(),_vm._v(" "),(_vm.chat)?_c('div',{staticClass:"col-4 p1 ",on:{"click":_vm.showChat}},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"}}),_c('path',{attrs:{"d":"M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"}}),_c('path',{attrs:{"d":"M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"}}),_c('path',{attrs:{"d":"M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"}}),_c('path',{attrs:{"d":"M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"}}),_c('path',{attrs:{"d":"M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"}}),_c('path',{attrs:{"d":"M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"}})]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue"},[_vm._v("Chat")])]):_vm._e()])],_vm._v(" "),_c('b-modal',{ref:"csModal",attrs:{"centered":"","hide-footer":"","id":"contactCS"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end items-center col-12 px0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",on:{"click":_vm.hideModal}},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"30","height":"30","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix py4"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('div',{staticClass:"col-12 left-align"},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"fill":"currentColor","width":"30","height":"30","viewBox":"0 0 512.00007 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m72.464844 62.214844c5.519531 0 10-4.476563 10-9.996094s-4.480469-10-10-10c-5.519532 0-10 4.480469-10 10s4.480468 9.996094 10 9.996094zm0 0"}}),_c('path',{attrs:{"d":"m292.011719 30v119.992188c0 16.539062 13.457031 29.996093 30 29.996093h10v30c0 3.789063 2.136719 7.25 5.527343 8.941407 3.378907 1.691406 7.433594 1.335937 10.46875-.941407l50.660157-38h83.332031c16.542969 0 30-13.457031 30-29.996093v-119.992188c0-16.542969-13.457031-30-30-30h-159.988281c-16.542969 0-30 13.457031-30 30zm199.988281 0v119.992188c0 5.511718-4.484375 10-10 10h-86.664062c-2.164063 0-4.269532.699218-6 2l-37.328126 27.996093v-19.996093c0-5.523438-4.476562-10-10-10h-19.996093c-5.515625 0-10-4.488282-10-10v-119.992188c0-5.515625 4.484375-10 10-10h159.988281c5.515625 0 10 4.484375 10 10zm0 0"}}),_c('path',{attrs:{"d":"m143.109375 368.886719c70.453125 70.449219 157.261719 119.125 251.039063 140.769531 40.992187 9.460938 82.238281-10.453125 100.738281-47.441406l11.828125-23.664063c11.613281-23.21875 3.269531-51.875-19-65.238281l-75.351563-45.203125c-23.691406-14.222656-54.378906-6.558594-68.585937 17.144531l-13.09375 21.800782c-2.535156 4.234374-7.707032 5.972656-12.289063 4.140624-78.253906-31.296874-146.304687-99.347656-177.597656-177.59375-1.835937-4.582031-.09375-9.746093 4.140625-12.285156 29.867188-17.9375 19.566406-11.75 21.796875-13.089844 23.695313-14.203124 31.378906-44.886718 17.148437-68.585937l-45.207031-75.355469c-13.359375-22.269531-42.015625-30.613281-65.230469-19l-23.671874 11.828125c-37.3125 18.664063-56.820313 60.085938-47.441407 100.738281 21.644531 93.777344 70.324219 180.582032 140.777344 251.035157zm258.960937-23.632813 75.355469 45.207032c13.363281 8.019531 18.371094 25.210937 11.398438 39.144531l-5.25 10.503906-127.488281-76.511719 4.839843-8.058594c8.523438-14.214843 26.925781-18.820312 41.144531-10.285156zm-343.355468-310.25 23.671875-11.832031c13.84375-6.925781 31.070312-2.046875 39.140625 11.398437l45.210937 75.359376c8.527344 14.207031 3.9375 32.613281-10.296875 41.148437l-8.070312 4.847656-45.273438-75.496093c-2.839844-4.734376-8.976562-6.273438-13.714844-3.429688-4.738281 2.839844-6.273437 8.980469-3.4375 13.71875l45.414063 75.722656c-10.273437 8.15625-14.132813 22.101563-9.132813 34.589844 16.238282 40.597656 42.433594 79.667969 75.75 112.984375 33.316407 33.316406 72.390626 59.507813 112.988282 75.746094 12.503906 5.003906 26.457031 1.132812 34.605468-9.148438l128.855469 77.328125c-15.511719 25.949219-45.914062 39.113282-75.78125 32.226563-183.128906-42.261719-334.5625-193.691407-376.824219-376.8125-7.296874-31.617188 7.878907-63.839844 36.894532-78.351563zm0 0"}}),_c('path',{attrs:{"d":"m362.007812 79.996094h79.996094c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-79.996094c-5.519531 0-10 4.476562-10 10 0 5.523437 4.476563 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m362.007812 119.992188h79.996094c5.523438 0 10-4.476563 10-10 0-5.519532-4.476562-9.996094-10-9.996094h-79.996094c-5.519531 0-10 4.476562-10 9.996094 0 5.523437 4.476563 10 10 10zm0 0"}})]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue mt1"},[_vm._v("Ring")]),_vm._v(" "),_c('p',{staticClass:"h5 darklblue regular line-height-4 mb2"},[_vm._v("\n              Customer Success har åbent mandag til fredag 8-16\n              "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"tel:70228014"}},[_vm._v("Ring 7022 8014")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 left-align mt4"},[_c('img',{attrs:{"src":"/static/svg/mail-blue.svg","alt":"","height":"30"}}),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue mt1"},[_vm._v("Skriv")]),_vm._v(" "),_c('p',{staticClass:"h5 darklblue regular line-height-4 mb2"},[_vm._v("\n              Fang os på chatten mellem 8-16 eller send en mail, og vi vender tilbage indenfor 24 timer.\n              "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#/inbox?send=support"}},[_vm._v("Send os en mail")])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"col-12 flex justify-between items-center"},[_c('button',{staticClass:"col-6 outlined-disabled-button p3 h4 not-rounded gibson flex justify-center items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),_c('button',{staticClass:"col-6 action-button p3 h4 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mx2"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])],2)],2):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"quickandstandard",attrs:{"centered":"","hide-footer":"","id":"quickandstandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModalquickandstandard()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-close"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background px2 m2"},[_c('div',{staticClass:"flex flex-column items-center gibson"},[_c('p',{staticClass:"h5 my1 semi-bold"},[_vm._v("Vælg venligst")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between col-12"},[_c('a',{staticClass:"mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":"#/tilbud/upload-tilbud"},on:{"click":function($event){return _vm.hideModalquickandstandard()}}},[_c('span',{staticClass:"mr1"},[_vm._v("Upload Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-position"})])]),_vm._v(" "),_c('a',{staticClass:"mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":"#/tilbud/hurtigt-tilbud"},on:{"click":function($event){return _vm.hideModalquickandstandard()}}},[_c('span',{staticClass:"mr1"},[_vm._v("Hurtigt Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-d-arrow-right"})])]),_vm._v(" "),_c('a',{staticClass:" col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":"#/tilbud/standardTilbud"},on:{"click":function($event){return _vm.hideModalquickandstandard()}}},[_c('span',{staticClass:"mr1"},[_vm._v("Standard Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-s-custom"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",staticStyle:{"height":"50px"},attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 729 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__paymentreminderpopup__ = __webpack_require__(519);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'appHeader',
  components: {
    paymentreminderpopup: __WEBPACK_IMPORTED_MODULE_2__paymentreminderpopup__["a" /* default */]
  },
  data: function data() {
    return {
      partnerName: '',
      message: 0,
      chat: 0,
      modalShow: false,
      isSeen: false,
      nopaymentmethodbool: '',
      dashdata: ''
    };
  },
  created: function created() {
    this.partnerName = localStorage.getItem('name');
    this.message = parseInt(localStorage.getItem('inbox'));
    this.dashdata = this.$route.query.dashdata;
    var m = this;
    if (!localStorage.getItem('ads9')) {
      setTimeout(function () {
        m.modalShow = false;
      }, 1500);
      localStorage.setItem('ads9', 'true');
    }
  },
  mounted: function mounted() {
    this.decode();
  },

  watch: {
    'nopaymentmethodbool': function nopaymentmethodbool(newVal, oldVal) {
      if (newVal === 'true') {
        this.Nopaymentmethod();
      }
      if (newVal === 'false') {
        this.$refs.paymentreminderpopup.hidemodalinitial();
        this.$refs.paymentreminderpopup.hidemodal();
        var reminderbar = document.getElementById('reminderbarmain');
        reminderbar.classList.add('hide');
        var bar = document.getElementById('mainbar');
        bar.style.marginTop = '0px';
      }
    }
  },
  methods: {
    decode: function decode() {
      var _this = this;

      console.log('window.location.hostname', window.location.hostname);
      if (window.location.hostname !== 'oldpartner.haandvaerker.dk') {
        var pid = localStorage.getItem('haaid');
        this.$http.get(this.$bitrixapi + 'helper/encode/' + pid, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var query = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.$route.query);
            var allquery = '';
            __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(query).forEach(function (querys) {
              console.log('querys', querys);
              allquery += '&' + querys + '=' + query[querys];
            });
            window.location.href = 'https://partner.haandvaerker.dk/#/login?code=' + res.data + allquery;
          }
        }, function (response) {
          var error = response.body;
          _this.$message({
            type: 'error',
            message: error.message
          });
        });
      }
    },
    Nopaymentmethod: function Nopaymentmethod(method) {
      this.nopaymentmethodbool = method;
      console.log('Nopaymentmethod', this.nopaymentmethodbool);
      if (this.nopaymentmethodbool === 'true') {
        this.openpaymentreminder();
      }
    },
    openpaymentreminder: function openpaymentreminder() {
      this.$refs.paymentreminderpopup.showmodalinitial();
      this.setwarning();
    },
    closebanner: function closebanner() {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner');
      checkpayproffbanner.classList.add('hide');
      this.addorangepayproffbanner();
    },
    sidebarToggle: function sidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-hidden');
      document.body.classList.toggle('sidebar-mobile-show');
    },
    sidebarMinimize: function sidebarMinimize(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-minimized');
      document.body.classList.toggle('sidebar-mobile-show');
    },
    mobileSidebarToggle: function mobileSidebarToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('sidebar-mobile-show');
    },
    mailSupport: function mailSupport() {
      this.$router.push('/skriv-tl-support');
    },
    gotoPayproff: function gotoPayproff() {
      var m = this;
      this.$router.push('/konto-update?dashdata=' + m.dashdata);
    },
    addorangepayproffbanner: function addorangepayproffbanner() {
      var payproffnotification = document.getElementById('payproffnotification');
      payproffnotification.classList.remove('hide');
    },
    setwarning: function setwarning() {
      if (this.nopaymentmethodbool) {
        var reminderbar = document.getElementById('reminderbarmain');
        reminderbar.style.marginTop = '0px';
        reminderbar.style.position = 'fixed';
        reminderbar.style.zIndex = '1026';
        reminderbar.classList.remove('hide');
        var navbar = document.getElementById('mainheader');
        navbar.style.borderBottom = '0px';
        navbar.style.position = 'none';
        navbar.classList.remove('navbar');
        navbar.classList.remove('app-header');
        var bar = document.getElementById('mainbar');
        bar.style.position = 'fixed';
        bar.style.zIndex = '1026';
        bar.style.backgroundColor = '#fff';
        bar.style.marginTop = '26px';
        bar.style.borderBottom = '1px solid #d1d4d7';
      }
    }
  }
});

/***/ }),
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'paymentreminderpopup',
  props: ['eligibilitydata'],
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      showreminder: '',
      partnername: '',
      hasleveran: '',
      regnr: '',
      bankkonto: '',
      help: '',
      cvr: '',
      bank: '',
      consent: '',
      levandorupdate: '',
      options: [],
      rp: '',
      showsessionnewcreditpro: '',
      shownewcreditpro: false,
      dunninginvoice: '',
      perndinginvoice: '',
      datamethod: '',
      leverandordate: ''
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.partnername = localStorage.getItem('CompanyName');
  },

  computed: {
    regState: function regState() {
      return this.regnr.length === 4;
    },
    bankState: function bankState() {
      return this.bankkonto.length === 10;
    }
  },
  methods: {
    showmodal: function showmodal() {
      this.$refs.paymentmethods.show();
    },
    showmodalinitial: function showmodalinitial() {
      this.$refs.initialreminder.show();
    },
    hidemodal: function hidemodal() {
      this.$refs.paymentmethods.hide();
    },
    hidemodalinitial: function hidemodalinitial() {
      this.$refs.initialreminder.hide();
    },
    hidemodalsuccess: function hidemodalsuccess() {
      this.$refs.sendingsuccess.hide();
    },
    goto: function goto() {
      this.$router.push(this.partnerData['linkreferer']);
    },
    limitbankno: function limitbankno(e) {
      return String(e).substring(0, 10);
    },
    limitbankregis: function limitbankregis(e) {
      return String(e).substring(0, 4);
    },
    checkleveranpartner: function checkleveranpartner() {
      var _this = this;

      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.cvr = res.cvr;
        if (res.levandorupdate === '') {
          _this.hasleveran = false;
          _this.levandorupdate = res.levandorupdate;
        } else {
          _this.hasleveran = true;
        }
        if (_this.haaId === '40035' || _this.haaId === '10247') {
          _this.hasleveran = false;
          _this.levandorupdate = '';
        }
        _this.regnr = res.levandorregnr;
        _this.bankkonto = res.levandorbankkonto;
        _this.options = res.bankOptions;
        _this.leverandordate = res.levandorupdate;
        _this.getpartnerinvoicedue();
      }, function (response) {
        alert('error');
      });
    },
    processingperiod: function processingperiod() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var datenow = new Date();
      var processingstart = new Date(a);
      var processingend = new Date(a);
      processingend.setDate(processingstart.getDate() + 5);
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    service_levendor: function service_levendor() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'service_levendor', salesPerson: this.salesPerson, regnr: this.regnr, bankkonto: this.bankkonto, levid: this.haaId, cvr: this.cvr, bank: this.bank };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    partnerinfo: function partnerinfo() {
      var _this3 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInfo/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.partnername = res.data.company;
          _this3.dunninginvoice = res.data.dunning_invoices;
          _this3.perndinginvoice = res.data.pending_invoices;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getpartnerinvoice: function getpartnerinvoice() {
      var _this4 = this;

      this.haaId = localStorage.getItem('haaid');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var checkinvoices = res.data.content;
          var dunninginvoices = [];
          var pendinginvoices = [];
          dunninginvoices = checkinvoices.filter(function (item) {
            return item.state === 'pending';
          });
          pendinginvoices = checkinvoices.filter(function (item) {
            return item.state === 'dunning';
          });
          _this4.dunninginvoice = dunninginvoices.length;
          _this4.perndinginvoice = pendinginvoices.length;
          if (_this4.dunninginvoice > 0 || _this4.perndinginvoice > 0) {
            _this4.showreminder = 'true';
            _this4.$emit('Nopaymentmethod', _this4.showreminder);
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getpartnerinvoicedue: function getpartnerinvoicedue() {
      var _this5 = this;

      if (this.check4hour()) {
        this.haaId = localStorage.getItem('haaid');
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        };
        if (this.haaId === '40035' && (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/' || this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/')) {
          this.haaId = '140035';
        }
        this.$http.get(this.$bitrixapi + 'reepay/getPartnerInvoiceDue/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var checkinvoices = res.data.content;
            var dunninginvoices = [];
            var pendinginvoices = [];
            dunninginvoices = checkinvoices.filter(function (item) {
              return item.state === 'dunning';
            });
            pendinginvoices = checkinvoices.filter(function (item) {
              return item.state === 'pending';
            });
            _this5.dunninginvoice = dunninginvoices.length;
            _this5.perndinginvoice = pendinginvoices.length;
            if ((_this5.dunninginvoice >= 1 || _this5.perndinginvoice) && _this5.processingperiod(_this5.leverandordate)) {
              _this5.showreminder = 'true';
              _this5.$emit('Nopaymentmethod', _this5.showreminder);
            }
          }
        }, function (response) {
          console.log('Error: ', response);
        });
      }
    },
    getpartnerinvoicebystatus: function getpartnerinvoicebystatus() {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.haaId + '?status=dunning', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {}
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getpartnerpaymentmethod: function getpartnerpaymentmethod() {
      var _this6 = this;

      if (this.check4hour()) {
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        };
        this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerPaymentMethod/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            if (!_this6.hasleveran) {
              var cards = res.data.cards;
              var activecards = [];
              activecards = cards.filter(function (item) {
                return item.state === 'active';
              });
              if (activecards.length === 0) {
                _this6.showreminder = 'true';
                _this6.$emit('Nopaymentmethod', _this6.showreminder);
              }
            }
            if (_this6.dunninginvoice > 0 || _this6.perndinginvoice > 0) {
              _this6.showreminder = 'true';
              _this6.$emit('Nopaymentmethod', _this6.showreminder);
            }
          } else {
            console.log('something is wrong with getting payment card ');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
      }
    },
    getpartnersubsciption: function getpartnersubsciption() {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerSubsciption/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {}
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    shownewcredit: function shownewcredit() {
      var _this7 = this;

      var data = {
        operation: 'newcredit',
        salesPerson: this.salesPerson
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        _this7.shownewcreditpro = true;
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this8 = this;

      this.$http.post(this.$bitrixapi + 'reepay/recurringSession?partnerId=' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this8.$router.push('/login');
        }
        if (res.success) {
          var data = res.data;
          _this8.showsessionnewcreditpro = data.id;
          _this8.showpopupreepay();
        } else {
          console.log('Error in showing session');
        }
      });
    },
    showpopupreepay: function showpopupreepay() {
      var m = this;
      this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.datamethod = data.payment_method;
        console.log('done adding card', data);
        setTimeout(function () {
          m.wait4hourreminder();
        }, 5000);
      });
    },
    destroyrd: function destroyrd() {
      this.rp.destroy(this.showsessionnewcreditpro);
    },
    preloadrp: function preloadrp() {
      this.rp = new window.Reepay.EmbeddedCheckout(null, { html_element: 'rp_container', showReceipt: true });
    },
    showrp: function showrp() {
      this.rp.show(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
    },
    wait4hourreminder: function wait4hourreminder() {
      var timenow = new Date();
      var timeafter4hour = new Date();
      timeafter4hour.setHours(timenow.getHours() + 4);
      localStorage.removeItem('timeaddedcard');
      localStorage.removeItem('timeaddedcardexpiry');
      localStorage.setItem('timeaddedcard', timenow);
      localStorage.setItem('timeaddedcardexpiry', timeafter4hour);
      this.$emit('Nopaymentmethod', 'false');
    },
    check4hour: function check4hour() {
      var timeaccessnow = new Date();
      var togettime = localStorage.getItem('timeaddedcard');
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry');
      var togettimenew = new Date(togettime);
      var togettimeexpirynew = new Date(togettimeexpiry);
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
  }
});

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"paymentreminderpopup"}},[_c('b-modal',{ref:"paymentmethods",attrs:{"centered":"","hide-footer":"","id":"paymentmethods","no-close-on-backdrop":true}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end mt1"},[_c('button',{staticClass:"h4 white-button no-border not-rounded gibson p0 m0 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodal()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex col-12 m0 p0 flex-wrap "},[_c('b-tabs',{staticClass:"col-12 p0 m0 darkblue ",attrs:{"vertical":"","card":""}},[_c('div',{staticClass:" clearfix white-background  m0 p0"},[_c('div',{staticClass:"flex flex-column gibson col-12 p0"},[_c('div',{staticClass:"flex flex-column col-lg-10 col-md-10 col-sm-12 mx-auto"},[_c('p',{staticClass:"h3 darkblue "},[_vm._v("Hej "+_vm._s(_vm.partnername.replace('&\#039\;','\''))+"!")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue "},[_vm._v("Betalingsmetoder")])]),_vm._v(" "),_c('div',{staticClass:"col-10  mx-auto flex flex-column justify-around my2 p0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reepay",modifiers:{"reepay":true}}],staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center collapsed",attrs:{"role":"tablist"}},[_c('span',{staticClass:"mx2 h5"},[_vm._v("Reepay")])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background",attrs:{"id":"reepay","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"462px"},attrs:{"id":"rp_container"}})]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.leveran",modifiers:{"leveran":true}}],staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center",attrs:{"role":"tablist"}},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Leverandørservice")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background",attrs:{"id":"leveran","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"col-12 p0"},[(_vm.levandorupdate !== '')?_c('b-alert',{staticClass:"my2",attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                              ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('b-form',{staticClass:"py-2 p0",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_levendor.apply(null, arguments)}}},[_c('div',{staticClass:" col-12 flex flex-wrap mt2 p0"},[_c('b-form-group',{staticClass:"col-lg-6 col-md-6 col-sm-12",attrs:{"id":"nameInput","label":"Din Bank","label-for":"konto"}},[_c('b-form-select',{attrs:{"options":_vm.options,"required":""},model:{value:(_vm.bank),callback:function ($$v) {_vm.bank=$$v},expression:"bank"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                                      Hvis din bank ikke er på listen, kan du ikke oprette forbindelse til leverandørservice\n                                    ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-lg-6 col-md-6 col-sm-12",attrs:{"id":"nameInput","label":"Registreringsnr.","label-for":"konto"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"konto","type":"number","aria-describedby":"input-live-help input-live-feedback","formatter":_vm.limitbankregis,"state":_vm.regState,"required":"","placeholder":"","size":"4","maxlength":4,"autocomplete":"off"},model:{value:(_vm.regnr),callback:function ($$v) {_vm.regnr=$$v},expression:"regnr"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                                      Indsæt venligst din Registreringsnr (4 kar)\n                                    ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-lg-6 col-md-6 col-sm-12",attrs:{"id":"emailInput","label":"Bankkonto","label-for":"account"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"account","type":"number","required":"","placeholder":"","formatter":_vm.limitbankno,"state":_vm.bankState,"size":"10","maxlength":"10","autocomplete":"off"},model:{value:(_vm.bankkonto),callback:function ($$v) {_vm.bankkonto=$$v},expression:"bankkonto"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                                      Indsæt venligst din Bankkonto (10 kar)\n                                    ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-lg-6 col-md-6 col-sm-12",attrs:{"id":"emailInput","label":"CVR-nummer","label-for":"cvr"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"cvr","type":"number","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.cvr),callback:function ($$v) {_vm.cvr=$$v},expression:"cvr"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},model:{value:(_vm.consent),callback:function ($$v) {_vm.consent=$$v},expression:"consent"}},[_c('span',{staticClass:"text-secondary open-sans"},[_vm._v("Jeg acceptere LeverandørService "),_c('a',{attrs:{"target":"_blank","href":"https://www.nets.eu/dk-da/SiteCollectionDocuments/leverandoerservice/LS_Regler_DB_debitor_regler_DK.pdf"}},[_vm._v("reglerne")])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-row',[(_vm.levandorupdate === '')?_c('b-col',[_c('b-button',{attrs:{"type":"submit","variant":"success not-rounded flex col-lg-4 col-md-4 col-sm-12 justify-center items-center"}},[_c('span',{staticClass:"mr2"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_c('span',{staticClass:"semi-bold h5 m0"},[_vm._v("Gem")])])],1):_vm._e(),_vm._v(" "),(_vm.levandorupdate !== '')?_c('b-col',[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"el-icon-success text-success"}),_vm._v(" Sidste opdatering : "+_vm._s(_vm.levandorupdate))]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('span',{staticClass:"el-icon-success text-success"}),_vm._v(" Du kan opdaterer dine bankoplysninger 4 dage fra sidste gang du har gemt dem")])])])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])],2),_vm._v(" "),_c('b-modal',{ref:"initialreminder",attrs:{"centered":"","hide-footer":"","id":"initialreminder","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background col-12 "},[_c('div',{staticClass:" muted-border border shadow col-lg-8 col-md-8 col-sm-12 mx-auto my2 "},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end my2"},[_c('button',{staticClass:"h3 white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodalinitial()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-start gibson col-12 p3"},[_c('p',{staticClass:"my2 darkblue"},[_c('span',{attrs:{"clas":""}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"130","height":"130","viewBox":"0 0 116.96 92.339"}},[_c('path',{attrs:{"id":"Path_5","data-name":"Path 5","d":"M12.879,79.46A43.971,43.971,0,0,1,43.971,4.4,43.477,43.477,0,0,1,64.058,9.244,44.327,44.327,0,0,1,79.3,22.183a2.633,2.633,0,0,1,2.429.222L85.919,25.1l4.062-2.311a2.637,2.637,0,0,1,3.941,2.292V69.358A2.637,2.637,0,0,1,89.9,71.6L85.884,69.12l-4.125,2.735a2.631,2.631,0,0,1-.845.367A43.976,43.976,0,0,1,12.879,79.46Zm3.729-58.455A38.694,38.694,0,1,0,71.33,75.728a39.161,39.161,0,0,0,4.711-5.689l-1.371-.89-4.03,2.7a2.641,2.641,0,0,1-2.884.035L63.45,69.149l-3.919,2.685A2.637,2.637,0,0,1,55.4,69.659V24.624a2.638,2.638,0,0,1,4.1-2.2l3.948,2.625,4.337-2.675a2.65,2.65,0,0,1,2.821.035l4.059,2.64,4.23-2.659-4.1,2.577a39.28,39.28,0,0,0-3.467-3.964,38.7,38.7,0,0,0-54.722,0ZM80.255,72.3a2.668,2.668,0,0,1-1.39-.424A2.644,2.644,0,0,0,80.255,72.3ZM64.809,63.761l4.325,2.748L73.176,63.8a2.641,2.641,0,0,1,2.906-.019l4.2,2.726,4.093-2.713a2.638,2.638,0,0,1,2.846-.044l1.425.88V29.617l-1.507.858a2.633,2.633,0,0,1-2.732-.073l-4.125-2.65-4.233,2.662a2.623,2.623,0,0,1-1.406.405,2.652,2.652,0,0,1-1.437-.424l-4.074-2.65L64.78,30.427a2.639,2.639,0,0,1-2.846-.047l-1.254-.836V64.65l1.222-.839a2.649,2.649,0,0,1,1.494-.462A2.616,2.616,0,0,1,64.809,63.761Zm-33.362-1.1a1.972,1.972,0,1,1,1.969,1.972A1.97,1.97,0,0,1,31.447,62.665Zm33.631-5.5a1.76,1.76,0,1,1,0-3.52H75.629a1.76,1.76,0,0,1,0,3.52ZM31.69,54.776l-1.232-19.72a2.959,2.959,0,0,1,5.917,0l-1.295,19.72c0,1.634-.8,2.219-1.665,2.219S31.69,56.409,31.69,54.776Zm42.182-6.408a1.759,1.759,0,1,1,1.757,1.757A1.758,1.758,0,0,1,73.872,48.368Zm-8.795,1.757a1.759,1.759,0,1,1,0-3.517h3.517a1.759,1.759,0,1,1,0,3.517Zm0-7.035a1.759,1.759,0,1,1,0-3.517H79.147a1.759,1.759,0,1,1,0,3.517ZM103.771,29.9a2.637,2.637,0,1,1,0-5.274h10.552a2.637,2.637,0,0,1,0,5.274ZM98.386,18.574a2.639,2.639,0,0,1,0-3.729L108.941,4.29a2.638,2.638,0,0,1,3.729,3.733L102.118,18.574a2.641,2.641,0,0,1-3.733,0ZM87.061,13.192V2.637a2.639,2.639,0,0,1,5.278,0V13.192a2.639,2.639,0,0,1-5.278,0Z","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h4 darkblue pt1 "},[_vm._v("Hovsa! Din betaling til "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk","target":"_blank"}},[_vm._v("Håndværker.dk")]),_vm._v(" mislykkedes.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 "},[_vm._v("Vi kunne ikke behandle din sidste betaling. Din konto forbliver aktiv, men opdater venligst dine kreditkortoplysninger for at undgå suspendering.")]),_vm._v(" "),_c('button',{staticClass:" mb2 mt3  py1 col-lg-4 col-md-4 col-sm-12 button green-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){_vm.showmodal(),_vm.hidemodalinitial(),_vm.showsessionnewcredit()}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdater kreditkort")])]),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap p0"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så\n                "),_c('a',{staticClass:"no-underlined",attrs:{"href":"tel:+45#4570228014"}},[_vm._v("ring")]),_vm._v("\n                eller\n                "),_c('a',{staticClass:"no-underlined ",attrs:{"href":"mailto:support@haandvaerker.dk"}},[_vm._v("e-mail")]),_vm._v("\n                support.")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-footer":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din henvendelse,")]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("Vi ringer til dig hurtigst muligt")]),_vm._v(" "),_c('button',{staticClass:" my2 col-lg-4 col-md-4 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){return _vm.hidemodaltak('')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar ",attrs:{"id":"mainheader"}},[_c('div',{staticClass:"flex flex-column col-12 p0 m0"},[_c('div',{staticClass:"col-12 flex justify-center items-center hide xs-hide sm-hide alert alert-danger m0 p0",attrs:{"id":"reminderbarmain"}},[_c('p',{staticClass:"m0"},[_vm._v("Vi kunne ikke behandle din sidste betaling.")]),_c('p',{staticClass:"semi-bold m0 pointer",on:{"click":function($event){return _vm.openpaymentreminder()}}},[_vm._v(" Opdater din betaling")])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center hide items-center payproffnotif highlights m0 p0",attrs:{"id":"payproffnotification"}},[_c('p',{staticClass:"m0 p0 py1"},[_vm._v("Verificer din "),_c('span',{staticClass:"semi-bold pointer",on:{"click":function($event){return _vm.gotoPayproff()}}},[_vm._v("Payproff")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start items-center md-hide lg-hide px0",attrs:{"id":"mainbarmobile"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex flex-auto justify-end items-center pr2",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:"pr2 pointer mr1 relative"},[_c('a',{staticClass:"primarycolor no-hover block",attrs:{"href":"#/messages/inbox"}},[_c('span',{staticClass:"relative block",staticStyle:{"top":"3px"}},[(_vm.message !== 0)?_c('span',{staticClass:"badge badge-pill badge-danger absolute",staticStyle:{"right":"-10px","top":"5px"},attrs:{"id":"totalInbox"}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"}}),_c('path',{attrs:{"d":"M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"}}),_c('path',{attrs:{"d":"M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler primarycolor",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('svg',{attrs:{"fill":"currentColor","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 120 120"}},[_c('path',{attrs:{"d":"M76 24.6H7c-3.8 0.1-6.9-3.1-7-7 -0.1-3.9 3-7.1 6.8-7.2 0.1 0 0.1 0 0.2 0h69c3.8-0.1 6.9 3.1 7 7 0.1 3.9-3 7.1-6.8 7.2C76.1 24.6 76 24.6 76 24.6z"}}),_c('path',{attrs:{"d":"M76 109.6H7c-3.8 0.1-6.9-3.1-7-7 -0.1-3.9 3-7.1 6.8-7.2 0.1 0 0.1 0 0.2 0h69c3.8-0.1 6.9 3.1 7 7 0.1 3.9-3 7.1-6.8 7.2C76.1 109.6 76 109.6 76 109.6z"}}),_c('path',{attrs:{"d":"M114.5 67.1H5.5c-3 0-5.5-3.2-5.4-7.1 0-3.9 2.4-7.1 5.4-7.1h109c3 0 5.5 3.2 5.5 7.1C120 63.9 117.6 67.1 114.5 67.1 114.5 67.1 114.5 67.1 114.5 67.1z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center xs-hide sm-hide",attrs:{"id":"mainbar"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto justify-end items-center ",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:"px2 pointer mr1 relative"},[_c('a',{staticClass:"primarycolor no-hover block",attrs:{"href":"#/messages/inbox"}},[_c('span',{staticClass:"relative block"},[(_vm.message !== 0)?_c('span',{staticClass:"badge badge-pill badge-danger absolute",staticStyle:{"right":"-10px","top":"5px"},attrs:{"id":"totalInbox"}},[_vm._v(_vm._s(_vm.message))]):_vm._e(),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"}}),_c('path',{attrs:{"d":"M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"}}),_c('path',{attrs:{"d":"M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"}})])])])]),_vm._v(" "),_c('button',{staticClass:"navbar-toggler sidebar-toggler pl2",attrs:{"type":"button"},on:{"click":_vm.sidebarToggle}},[_c('span',{staticClass:"pb1"},[_c('svg',{attrs:{"viewBox":"0 0 100 80","width":"28","height":"28"}},[_c('rect',{attrs:{"width":"100","height":"12"}}),_vm._v(" "),_c('rect',{attrs:{"y":"30","width":"100","height":"12"}}),_vm._v(" "),_c('rect',{attrs:{"y":"60","width":"100","height":"12"}})])])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"p2",attrs:{"centered":"","ok-only":""},model:{value:(_vm.modalShow),callback:function ($$v) {_vm.modalShow=$$v},expression:"modalShow"}},[_c('p',{staticClass:" left-align darklblue regular line-height-4 mb2 p2"},[_c('br'),_vm._v("\n      Hej,\n      "),_c('br'),_vm._v("\n      Husk at registrere dine telefonnumre inden mandag d. 16/11-2020\n      "),_c('br'),_c('br'),_vm._v("\n      Hos Håndværker.dk vil vi give dine kunder en tryg og sikker oplevelse. Derfor beder vi dig registrere, hvis dit firma bruger mere end ét telefonnummer. Det er en ekstra service til dine kunder, så de ved, når du ringer.\n      "),_c('br'),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#/ekstraphone"},on:{"click":function($event){_vm.modalShow = false}}},[_vm._v(" Klik venligst her og indtast dine telefonnumre ")])])]),_vm._v(" "),_c('paymentreminderpopup',{ref:"paymentreminderpopup",on:{"Nopaymentmethod":_vm.Nopaymentmethod}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pl2 flex-none"},[_c('a',{staticClass:"no-hover inline-block flex justify-start items-center",attrs:{"href":"#/newsfeed"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"24"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold line-height-1"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('a',{staticClass:"no-hover inline-block flex justify-start items-center",attrs:{"href":"#/newsfeed"}},[_c('img',{staticStyle:{"height":"28px!important"},attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d45448_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__ = __webpack_require__(761);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Sidebar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d45448_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Sidebar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarForm__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__ = __webpack_require__(747);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__ = __webpack_require__(751);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__ = __webpack_require__(758);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar',
  props: {
    navItems: {
      type: Array,
      required: true,
      default: function _default() {
        return [];
      }
    }
  },
  components: {
    SidebarFooter: __WEBPACK_IMPORTED_MODULE_0__SidebarFooter__["a" /* default */],
    SidebarForm: __WEBPACK_IMPORTED_MODULE_1__SidebarForm__["a" /* default */],

    SidebarNavDropdown: __WEBPACK_IMPORTED_MODULE_2__SidebarNavDropdown__["a" /* default */],
    SidebarNavLink: __WEBPACK_IMPORTED_MODULE_3__SidebarNavLink__["a" /* default */],
    SidebarNavTitle: __WEBPACK_IMPORTED_MODULE_4__SidebarNavTitle__["a" /* default */],
    SidebarNavItem: __WEBPACK_IMPORTED_MODULE_5__SidebarNavItem__["a" /* default */]
  },
  data: function data() {
    return {
      haaid: 0
    };
  },
  created: function created() {
    this.haaid = localStorage.getItem('haaid');
  },

  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    },
    check: function check(nav) {
      return nav;
    }
  }
});

/***/ }),
/* 741 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5324c1d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__ = __webpack_require__(743);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarFooter_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5324c1d2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarFooter_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-footer'
});

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787902c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__ = __webpack_require__(746);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_787902c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-form'
});

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f6edf0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__ = __webpack_require__(750);
function injectStyle (ssrContext) {
  __webpack_require__(748)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a2f6edf0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavDropdown_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 748 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleClick: function handleClick(e) {
      e.preventDefault();
      e.target.parentElement.classList.toggle('open');
    }
  }
});

/***/ }),
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"nav-item nav-dropdown",attrs:{"tag":"li","to":_vm.url}},[_c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":'drop'+_vm.name},on:{"click":_vm.handleClick}},[_c('i',{class:_vm.icon}),_c('i'),_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cfc01e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__ = __webpack_require__(754);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavLink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35cfc01e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavLink_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_is_url_external___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_is_url_external__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-link',
  props: {
    name: {
      type: String,
      default: ''
    },
    url: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: Object,
      default: function _default() {}
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-link', this.linkVariant];
    },
    linkVariant: function linkVariant() {
      return this.variant ? 'nav-link-' + this.variant : '';
    },
    linkExternal: function linkExternal() {
      return __WEBPACK_IMPORTED_MODULE_0_is_url_external___default()(this.url);
    }
  }
});

/***/ }),
/* 753 */,
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.linkExternal)?_c('div',[_c('a',{class:_vm.classList,attrs:{"href":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "+_vm._s(_vm.name)+"\n    "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)]):_c('div',[_c('router-link',{class:_vm.classList,attrs:{"to":_vm.url}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v(_vm._s(_vm.name)+" ")]),_vm._v(" "),(_vm.badge && _vm.badge.text)?_c('b-badge',{attrs:{"variant":_vm.badge.variant}},[_vm._v(_vm._s(_vm.badge.text))]):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbe02b1e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__ = __webpack_require__(757);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavTitle_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bbe02b1e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavTitle_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    name: {
      type: String,
      default: ''
    },
    classes: {
      type: String,
      default: ''
    },
    wrapper: {
      type: Object,
      default: function _default() {}
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-title'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[(_vm.wrapper && _vm.wrapper.element)?[_c(_vm.wrapper.element,_vm._b({tag:"component"},'component',_vm.wrapper.attributes,false),[_vm._v("\n      "+_vm._s(_vm.name)+"\n    ")])]:[_vm._v("\n    "+_vm._s(_vm.name)+"\n  ")]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cc92ec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__ = __webpack_require__(760);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarNavItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37cc92ec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarNavItem_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'sidebar-nav-item',
  props: {
    classes: {
      type: String,
      default: ''
    }
  },
  computed: {
    classList: function classList() {
      return ['nav-item'].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(this.itemClasses));
    },
    itemClasses: function itemClasses() {
      return this.classes ? this.classes.split(' ') : '';
    }
  }
});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{class:_vm.classList},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('SidebarForm'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_vm._l((_vm.check(_vm.navItems)),function(item,index){return [(item.title)?[_c('SidebarNavTitle',{attrs:{"name":item.name,"classes":item.class,"wrapper":item.wrapper}})]:(item.divider)?[_c('li',{staticClass:"divider"})]:[(item.children)?[_c('SidebarNavDropdown',{attrs:{"name":item.name,"url":item.url,"icon":item.icon}},[_vm._l((item.children),function(childL1,index){return [(childL1.children)?[_c('SidebarNavDropdown',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon}},_vm._l((childL1.children),function(childL2,index){return _c('li',{staticClass:"nav-item"},[_c('SidebarNavLink',{attrs:{"name":childL2.name,"url":childL2.url,"icon":childL2.icon,"badge":childL2.badge,"variant":item.variant}})],1)}),0)]:[_c('SidebarNavItem',{attrs:{"id":childL1.url.replace('/', ''),"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":childL1.name,"url":childL1.url,"icon":childL1.icon,"badge":childL1.badge,"variant":item.variant}})],1)]]})],2)]:[_c('SidebarNavItem',{attrs:{"classes":item.class}},[_c('SidebarNavLink',{attrs:{"name":item.name,"url":item.url,"icon":item.icon,"badge":item.badge,"variant":item.variant}})],1)]]]})],2),_vm._v(" "),_vm._t("default")],2),_vm._v(" "),_c('SidebarFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15492ce4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__ = __webpack_require__(764);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Switch_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15492ce4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Switch_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  model: {
    prop: 'checked',
    event: 'change'
  },
  props: {
    value: {
      default: true
    },
    uncheckedValue: {
      default: false
    },
    checked: {
      default: false
    },
    type: {
      type: String,
      default: 'default'
    },
    variant: {
      type: String,
      default: ''
    },
    pill: {
      type: Boolean,
      default: false
    },
    on: {
      type: String,
      default: null
    },
    off: {
      type: String,
      default: null
    },
    size: {
      type: String,
      default: null
    }
  },
  computed: {
    classList: function classList() {
      return ['switch', this.switchType, this.switchVariant, this.switchPill, this.switchSize];
    },
    switchType: function switchType() {
      return this.type ? 'switch-' + this.type : 'switch-default';
    },
    switchVariant: function switchVariant() {
      return this.variant ? 'switch-' + this.variant : 'switch-secondary';
    },
    switchPill: function switchPill() {
      return !this.pill ? null : 'switch-pill';
    },
    switchSize: function switchSize() {
      return this.size ? 'switch-' + this.size : '';
    },
    isChecked: function isChecked() {
      return this.checked === this.value;
    },
    isOn: function isOn() {
      return !this.on ? null : true;
    }
  },
  methods: {
    handleChange: function handleChange(_ref) {
      var checked = _ref.target.checked;

      this.$emit('change', checked ? this.value : this.uncheckedValue);
    }
  }
});

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{class:_vm.classList},[_c('input',{staticClass:"switch-input",attrs:{"type":"checkbox"},domProps:{"value":_vm.value,"checked":_vm.isChecked},on:{"change":_vm.handleChange}}),_vm._v(" "),(_vm.isOn)?[_c('span',{staticClass:"switch-label",attrs:{"data-on":_vm.on,"data-off":_vm.off}})]:[_c('span',{staticClass:"switch-label"})],_vm._v(" "),_c('span',{staticClass:"switch-handle"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app"},[_c('AppHeader'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('Sidebar',{attrs:{"navItems":_vm.nav}}),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1),_vm._v(" "),_c('AppFooter')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58aaecf9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__(816);
function injectStyle (ssrContext) {
  __webpack_require__(767)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58aaecf9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* unused harmony default export */ var _unused_webpack_default_export = (Component.exports);


/***/ }),
/* 767 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Marketplace__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__MarketArchive__ = __webpack_require__(525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_KundeModal__ = __webpack_require__(534);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'market',
  components: {
    marketarchive: __WEBPACK_IMPORTED_MODULE_1__MarketArchive__["a" /* default */],
    marketplace: __WEBPACK_IMPORTED_MODULE_0__Marketplace__["a" /* default */],

    archivemodal: __WEBPACK_IMPORTED_MODULE_2__modals_ArchiveModal__["a" /* default */],
    kundemodal: __WEBPACK_IMPORTED_MODULE_3__modals_KundeModal__["a" /* default */]
  },
  mounted: function mounted() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },
  data: function data() {
    return {
      showMobile: false,
      items: ''
    };
  },

  methods: {}
});

/***/ }),
/* 769 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_paymentreminderpopup__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_axios__);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketplace',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default.a,
    archivemodal: __WEBPACK_IMPORTED_MODULE_4__modals_ArchiveModal__["a" /* default */],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_5__noneligibleFeaturepop__["a" /* default */],
    paymentreminderpopup: __WEBPACK_IMPORTED_MODULE_7__components_paymentreminderpopup__["a" /* default */],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_8__components_updatebitrixpackagepermission__["a" /* default */]
  },
  created: function created() {
    this.marketplacebitrixnummode = localStorage.getItem('PartnerloginMesterMesterReserve-nummode');
    this.marketplacebitrixsize = localStorage.getItem('PartnerloginMesterMesterReserve-size');
    this.mesterbitrixnummode = localStorage.getItem('PartnerLoginMarketplaceReserve-nummode');
    this.mesterbitrixsize = localStorage.getItem('PartnerLoginMarketplaceReserve-size');
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    if (this.$route.query.projectid) {
      this.openprojectdirect(this.$route.query.projectid);
    }
    this.getpackage();
    this.getallwizardproduct();
    this.gettaskbitrix();
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.getenterprise();
    if (localStorage.getItem('basic') === '1') {
      this.basic = true;
    }
    if (this.$route.query.mode === 'job') {
      this.job = true;
    }
    this.partnerName = localStorage.getItem('name');
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      sendingsuccess: false,
      bookingwizardurl: '',
      bookingwizardurlstep: '',
      haaId: '',
      salesPerson: '',
      packagetypebitrix: '',
      endcode: '',
      eligible: '',
      eligiblereserve: '',
      eligiblereservemester: '',
      joballbranche: [],
      taskallbranche: [],
      joballlocation: [],
      taskalllocation: [],
      localtionfilter: [],
      branchefilter: [],
      localtionjobfilter: [],
      branchejobfilter: [],
      SearchItem: [],
      SearchItemMester: [],
      items: [],
      itemMester: [],
      itemreserved: [],
      show: false,
      job: false,
      isLoadingReserve: false,
      label: 'Loading...',
      overlay: 1,
      nopaymentmethodbool: false,
      basic: false,
      partnerName: '',
      canReserve: '',
      reservesize: '',
      priceereservce: '',
      usershorturl: '',
      isLoadingMail: false,
      step: 1,
      nummode: '',
      reserve_size: '',
      maxreserve_size: '',
      partnerinvoice: 0,
      itemSelect: [],
      itemShow: false,
      itemShowMester: false,
      loading: true,
      BuyMoreReserve: true,
      marketplacebitrixnummode: '',
      marketplacebitrixsize: '',
      mesterbitrixnummode: '',
      mesterbitrixsize: '',
      sampleItem: {
        type: 'newtype',
        estimate: '',
        city: '',
        dato: '',
        postnummer: ''
      },
      itemloading: false,
      cantbuyreserve: false,
      filteredItems: [],
      openjobs: [],
      salesPersonbitrix: '',
      productlistforpricearr: [],
      productlistnotforpricearr: [],
      primaryproductindustryname: {},
      itemsjobindustry: {},
      loadingreserve: false,
      lastpage: 1,
      enterprisename: '',
      currentpage: 1,
      reservafailedchecklimitbitrix: false,
      selectedPersonalInformation: {},
      slotpris: 0,
      disablekatak: false,
      permittedtobuy: false,
      totalitems: 0,
      perPage: 25,
      paginationLoading: false
    };
  },

  watch: {
    'branchefilter': function branchefilter(newVal, oldVal) {
      var _this = this;

      setTimeout(function () {
        _this.updateSearch(_this.localtionfilter, _this.branchefilter, 'task');
      }, 200);
    },
    'localtionfilter': function localtionfilter(newVal, oldVal) {
      var _this2 = this;

      setTimeout(function () {
        _this2.updateSearch(_this2.localtionfilter, _this2.branchefilter, 'task');
      }, 200);
    },
    'localtionjobfilter': function localtionjobfilter(newVal, oldVal) {
      var _this3 = this;

      setTimeout(function () {
        _this3.updateSearch(_this3.localtionjobfilter, _this3.branchejobfilter, 'job');
      }, 200);
    },
    'branchejobfilter': function branchejobfilter(newVal, oldVal) {
      var _this4 = this;

      setTimeout(function () {
        _this4.updateSearch(_this4.localtionjobfilter, _this4.branchejobfilter, 'job');
      }, 200);
    }
  },
  methods: {
    Nopaymentmethod: function Nopaymentmethod(method) {
      this.nopaymentmethodbool = method;
    },
    checkimage: function checkimage(key) {
      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = 'static/img/0.jpg';
    },
    openprojectdirect: function openprojectdirect(id) {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var itemObj = [];
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects/marketplaceV2?page=1&size=100', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.items;
        if (response.body.success) {
          itemObj = res.filter(function (l) {
            return l.ID === Number(id);
          });
          if (itemObj.length > 0) {
            _this5.showItemDetailsjobs(itemObj[0]);
          }
        }
      }, function (response) {
        _this5.loading = false;
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    paginationChanged: function paginationChanged(curPage) {
      this.paginationLoading = true;
      this.openjobs = [];
      this.currentpage = curPage;
      this.openallpublicjobs('all');
    },
    openallpublicjobs: function openallpublicjobs() {
      var _this6 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Fagentreprise';
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var addtype = '&type=' + type;
      if (type === 'all') {
        addtype = '';
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects/marketplaceV2?page=' + this.currentpage + '&size=' + this.perPage + '' + addtype, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.items;
        _this6.totalitems = response.body.data.total;
        _this6.perPage = response.body.data.perPage;
        _this6.lastpage = response.body.data.last_page;
        if (response.body.success) {
          _this6.filteredItems = [];
          _this6.openjobs = res;
          _this6.loading = false;
        } else {
          _this6.loading = false;
          _this6.filteredItems = [];
          _this6.openjobs = [];
        }
      }, function (response) {
        _this6.loading = false;
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    openNoReserveslot: function openNoReserveslot(id) {
      this.reservafailedchecklimitbitrix = true;
    },
    showItemDetailsjobs: function showItemDetailsjobs(item) {
      this.loadingreserve = true;
      this.selectedPersonalInformation = {};
      this.productlistforpricearr = [];
      this.productlistnotforpricearr = [];
      this.itemSelect = {};
      var selectedInforPernal = {};
      this.itemSelect = item;
      this.itemSelect['zip'] = item.ADDRESS.ZIP;
      this.itemSelect['city'] = item.ADDRESS.CITY;
      this.itemSelect['addressimage'] = item.ADDRESS.IMAGE;
      this.itemSelect['postnummber'] = item.ADDRESS.POST_NUMBER;
      this.itemSelect['road'] = item.ADDRESS.ROAD;
      item.PERSONAL_INFORMATION.forEach(function (i) {
        for (var key in i) {
          selectedInforPernal[key] = i[key];
        }
      });
      this.selectedPersonalInformation = selectedInforPernal;
      this.itemSelect['type'] = 'marketjobs';
      if (this.itemSelect.PARENT_ID !== 0 && this.itemSelect.PARENT_ID !== null) {
        this.getProductList(this.itemSelect.PARENT_ID, item['HOMEOWNER']['ID'], 'subproject', this.itemSelect.JOB_INDUSTRY, this.itemSelect.JOBS_LIST);
      } else {
        this.getProductList(item.ID, item['HOMEOWNER']['ID']);
      }
      this.$refs.itemModalbitrix.show();
    },
    getenterprise: function getenterprise() {
      var _this7 = this;

      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE);
          _this7.enterprisename = _this7.enterpriseid === 1 ? 'Hovedentreprise' : _this7.enterpriseid === 3 ? 'all' : 'Fagentreprise';
          if (_this7.enterpriseid === 2) {
            _this7.openallpublicjobs('Fagentreprise');
          } else if (_this7.enterpriseid === 3) {
            _this7.openallpublicjobs('all');
          } else {
            _this7.openallpublicjobs('Hovedentreprise');
          }
          _this7.Reload();
        }
      }, function (response) {
        _this7.loading = false;
        var error = response.body.message;
        _this7.$message({
          type: 'error',
          message: error
        });
      });
    },
    saveJobsView: function saveJobsView(projectId) {
      var _this8 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        projectId: projectId
      };
      this.$http.post(this.$bitrixapi + 'partner/jobsView', data, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {
        var error = response.body.message;
        _this8.$message({
          type: 'error',
          message: error
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this9 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this9.itemsjobindustry = industryname;
        }
      }, function (response) {
        var error = response.body.message;
        _this9.$message({
          type: 'error',
          message: error
        });
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this10 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this10.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this10.$message.error(error);
      });
    },
    getProductList: function getProductList(projectid, contractid) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'parentproject';

      var _this11 = this;

      var jobindustrysub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var joblist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var submittedIndustries = [];
      if (type !== 'parentproject') {
        joblist.forEach(function (k) {
          if (Array.isArray(k)) {
            k.forEach(function (k) {
              var jobindustry = k.split(':')[0];
              submittedIndustries.push(jobindustry);
            });
          } else {
            var jobindustry = k.split(':')[0];
            submittedIndustries.push(jobindustry);
          }
        });
      }
      this.productlistforpricearr = [];
      this.productlistnotforpricearr = [];
      this.haaId = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + projectid + '&contact_id=' + contractid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        for (var index in res) {
          var enterpiserdata = {};
          var noenterpiserdata = {};
          enterpiserdata['industryid'] = index;
          enterpiserdata['industrydetails'] = {};
          noenterpiserdata['industryid'] = index;
          noenterpiserdata['industrydetails'] = {};
          for (var jobindustry in res[index]) {
            if (Number(jobindustry) !== 1062) {
              if (type === 'subproject' && (Number(jobindustrysub) === Number(jobindustry) || submittedIndustries.includes(jobindustry))) {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              } else if (type !== 'parentproject' && Number(jobindustrysub) !== Number(jobindustry)) {
                noenterpiserdata['jobindustry'] = jobindustry;
                noenterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
              if (type === 'parentproject') {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
            } else {
              enterpiserdata['jobindustry'] = jobindustry;
              enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
            }
          }
          _this11.productlistforpricearr.push(enterpiserdata);
          if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(noenterpiserdata['industrydetails']).length > 0) {
            _this11.productlistnotforpricearr.push(noenterpiserdata);
          }
          _this11.loadingreserve = false;
        }
      }, function (response) {
        _this11.loadingreserve = false;
        var error = response.body;
        _this11.$refs.errorMsg.showMsg(error);
      });
    },
    savereserve: function savereserve() {
      var _this12 = this;

      this.loadingreserve = true;
      this.$confirm('Vil du reservere dette job?', {
        confirmButtonText: 'Ja tak',
        cancelButtonText: 'Nej tak',
        type: 'warning'
      }).then(function () {
        _this12.$http.get(_this12.$bitrixapi + 'bitrix/getPackage/' + _this12.haaId, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this12.nummode = res.data.nummode;
            _this12.maxreserve_size = Number(res.data.reserve_size);
            _this12.reserve_size = parseInt(_this12.maxreserve_size - _this12.nummode);
            _this12.packagetypebitrix = res.data.PACKAGE_HANDLE;
            _this12.endcode = res.data.booking;
            _this12.eligiblereserve = _this12.eligible = localStorage.getItem('PartnerLoginMarketplaceReserve');
            if (_this12.eligiblereserve === 'false') {
              _this12.$refs.noneligibleFeaturepop.showmodel(_this12.eligible, '/newsfeed', 'PartnerloginMesterMesterReserve');
              _this12.itemloading = false;
              return;
            }
            if (_this12.reserve_size < 1) {
              _this12.itemloading = false;
              _this12.checkbuyreserveadditionalbitrix();
              _this12.openNoReserveslot();
              _this12.closemodalbitrix();
              return;
            }

            _this12.haaId = localStorage.getItem('haaid');
            _this12.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
            var headers = {
              Authorization: 'Bearer ' + _this12.salesPersonbitrix
            };
            var data = {};
            _this12.$http.post(_this12.$bitrixapi + 'partner/project/' + parseInt(_this12.itemSelect.ID) + '/reserve', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              if (res.success) {
                _this12.loadingreserve = false;
                var obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                };
                _this12.$refs.simplert.openSimplert(obj);
                _this12.openallpublicjobs();
                _this12.closemodalbitrix();
                _this12.$router.push('/alle-moeder?fromMarketplace=1');
              }
            }, function (response) {
              _this12.closemodalbitrix();
              _this12.$message({
                type: 'error',
                message: response.body.message
              });
            });
          }
        }, function (response) {
          _this12.$message({
            type: 'error',
            message: response.body.message
          });
        });
      }).catch(function () {});
    },
    savereservedirectly: function savereservedirectly() {
      var _this13 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/project/' + parseInt(this.itemSelect.ID) + '/reserveMore', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this13.loadingreserve = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this13.$refs.simplert.openSimplert(obj);
          setTimeout(function () {
            _this13.$router.push('/alle-moeder?fromMarketplace=1');
          }, 2000);
        }
      }, function (response) {
        _this13.closemodalbitrix();
        _this13.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    closemodalbitrix: function closemodalbitrix() {
      this.projectid = null;
      this.$refs.itemModalbitrix.hide();
    },
    showItemDetails: function showItemDetails(item) {
      if (this.packagetypebitrix === 'freemium' && this.reserve_size === '0') {
        this.$refs.freemuimopartner.show();
        return;
      }

      if (item.reserved === 1) {
        return;
      }
      if (this.basic && item.mester !== '1') {
        return;
      }

      this.itemSelect = item;
      this.usershorturl = this.itemSelect.shorturl;
      this.chechifcanreserve();
      this.itemShow = !this.itemShow;
      this.loading = false;
      this.step = 1;
    },
    showItemDetailsMester: function showItemDetailsMester(item) {
      if (this.packagetypebitrix === 'freemium' && this.reserve_size === '0') {
        this.$refs.freemuimopartner.show();
        return;
      }

      if (item.reserved === 1) {
        return;
      }

      this.itemSelect = item;
      this.usershorturl = this.itemSelect.shorturl;
      this.chechifcanreserve();
      this.itemShowMester = !this.itemShowMester;
      this.loading = false;
      this.step = 1;
    },
    closefreemiumpopup: function closefreemiumpopup() {
      this.$refs.freemuimopartner.hide();
    },
    reservedItem: function reservedItem() {
      var _this14 = this;

      this.itemloading = true;
      var id = this.haaId;
      var token = this.salesPerson;
      var headers = {
        Authorization: 'Bearer ' + token
      };

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + id, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this14.nummode = res.data.nummode;
          _this14.maxreserve_size = Number(res.data.reserve_size);
          _this14.reserve_size = parseInt(_this14.maxreserve_size - _this14.nummode);
          _this14.packagetypebitrix = res.data.PACKAGE_HANDLE;
          _this14.endcode = res.data.booking;
          _this14.eligiblereserve = _this14.eligible = localStorage.getItem('PartnerLoginMarketplaceReserve');
          if (_this14.eligiblereserve === 'false') {
            _this14.$refs.noneligibleFeaturepop.showmodel(_this14.eligible, '/newsfeed', 'PartnerloginMesterMesterReserve');
            _this14.itemloading = false;
            return;
          }
          if (_this14.reserve_size < 1) {
            _this14.showchecklimit();
            _this14.itemloading = false;
            return;
          }
          if (_this14.partnerinvoice !== 0) {
            var obj = {
              title: '',
              message: 'Du kan desværre ikke reservere dette møde, da vi ikke har modtaget din abonnementsbetaling. Klik her for at logge ind og opdatere kreditkortinfo: <a  href=/#/rediger-kreditkort-oplysninger >partnerprofil</a>',
              type: 'error'
            };
            _this14.$refs.simplert.openSimplert(obj);
            _this14.itemShow = false;
            _this14.itemloading = false;
            return;
          }
          var r = confirm(' Bekræft din reservation \n Bekræft at du gerne vil have opgaven ?');
          if (r === true) {
            _this14.isLoadingReserve = true;
            _this14.salesPerson = localStorage.getItem('id_token_portal');
            var dataPartner = { operation: 'reservedbook', salesPerson: _this14.salesPerson, short: _this14.itemSelect.shorturl };
            _this14.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              _this14.isLoadingReserve = false;
              _this14.show = false;
              _this14.loading = false;
              _this14.itemloading = false;
              if (res.login === false) {
                _this14.$router.push('/login');
              }
              if (res.success) {
                if (res.result.app === 2) {
                  _this14.itemShow = false;
                  var _obj = {
                    title: 'Gennemført!',
                    message: 'Du har nu reserveret opgaven! Kundens oplysninger kan du nu finde under “Mine kunder” på din profil.',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  };
                  _this14.$refs.simplert.openSimplert(_obj);
                  _this14.itemSelect.reserved = 1;
                } else {
                  if (res.result.texterror !== undefined) {
                    alert(res.result.texterror);
                  } else {
                    alert('Error .....!!!');
                  }
                }
                _this14.getpackage();
              } else {
                alert(res.message);
              }
            }, function (response) {
              _this14.itemloading = false;
              alert('error');
            });
          } else {
            _this14.itemloading = false;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    reservedItemTilbud: function reservedItemTilbud() {
      var _this15 = this;

      this.itemloading = true;
      var id = this.haaId;
      var token = this.salesPerson;
      var headers = {
        Authorization: 'Bearer ' + token
      };

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + id, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this15.nummode = res.data.nummode;
          _this15.maxreserve_size = Number(res.data.reserve_size);
          _this15.reserve_size = parseInt(_this15.maxreserve_size - _this15.nummode);
          _this15.packagetypebitrix = res.data.PACKAGE_HANDLE;
          _this15.endcode = res.data.booking;
          _this15.eligiblereserve = _this15.eligible = localStorage.getItem('PartnerLoginMarketplaceReserve');
          if (_this15.eligiblereserve === 'false') {
            _this15.$refs.noneligibleFeaturepop.showmodel(_this15.eligible, '/newsfeed', 'PartnerloginMesterMesterReserve');
            _this15.itemloading = false;
            return;
          }
          if (_this15.reserve_size < 1) {
            _this15.itemloading = false;
            _this15.showchecklimit();
            return;
          }
          if (_this15.partnerinvoice !== 0) {
            var obj = {
              title: '',
              message: 'Du kan desværre ikke reservere dette møde, da vi ikke har modtaget din abonnementsbetaling. Klik her for at logge ind og opdatere kreditkortinfo: <a  href=/#/rediger-kreditkort-oplysninger >partnerprofil</a>',
              type: 'error'
            };
            _this15.$refs.simplert.openSimplert(obj);
            _this15.itemShow = false;
            _this15.itemloading = false;
            return;
          }
          var r = '';
          if (_this15.itemSelect.mailingzip >= 60000 && _this15.itemSelect.mailingzip < 99990) {
            r = confirm('Bekræft at du gerne vil have mødet ?\n' + 'OBS: COVID-19-restriktioner i Nordjylland\n' + 'Pga. de af regeringen indførte lokale restriktioner i Nordjylland skal du være opmærksom på kundens adresse. Læs mere om de gældende regler vedr. geografisk mobilitet på Coronasmitte.dk her: https://coronasmitte.dk/restriktioner-i-nordjylland\n' + '\n' + 'Det er alene dit ansvar at overholde de gældende regler.');
          } else {
            r = confirm(' Bekræft din reservation \n Bekræft at du gerne vil have opgaven ?');
          }
          if (r === true) {
            _this15.isLoadingReserve = true;
            _this15.salesPerson = localStorage.getItem('id_token_portal');
            var dataPartner = { operation: 'reservedbooktilbud', salesPerson: _this15.salesPerson, short: _this15.itemSelect.shorturl };
            _this15.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              _this15.isLoadingReserve = false;
              _this15.show = false;
              _this15.loading = false;
              _this15.itemloading = false;
              if (res.login === false) {
                _this15.$router.push('/login');
              }
              if (res.success) {
                if (res.result.app === 2) {
                  _this15.itemShow = false;
                  var _obj2 = {
                    title: 'Gennemført!',
                    message: 'Du har nu reserveret opgaven! Kundens oplysninger kan du nu finde under “Mine kunder” på din profil.',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  };
                  _this15.$refs.simplert.openSimplert(_obj2);
                  _this15.itemSelect.reserved = 1;
                } else {
                  if (res.result.texterror !== undefined) {
                    alert(res.result.texterror);
                  } else {
                    _this15.chechifcanreserve();
                  }
                }
                _this15.getpackage();
              } else {
                _this15.itemloading = false;
                alert(res.message);
              }
            }, function (response) {
              _this15.itemloading = false;
              alert('error');
            });
          } else {
            _this15.itemloading = false;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    reservedItemTilbudMester: function reservedItemTilbudMester() {
      var _this16 = this;

      this.itemloading = true;
      var id = this.haaId;
      var token = this.salesPerson;
      var headers = {
        Authorization: 'Bearer ' + token
      };

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + id, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this16.nummode = res.data.nummode;
          _this16.maxreserve_size = Number(res.data.reserve_size);
          _this16.reserve_size = parseInt(_this16.maxreserve_size - _this16.nummode);
          _this16.packagetypebitrix = res.data.PACKAGE_HANDLE;
          _this16.endcode = res.data.booking;
          _this16.eligiblereservemester = _this16.eligible = localStorage.getItem('PartnerloginMesterMesterReserve');
          if (_this16.eligiblereservemester === 'false') {
            _this16.itemloading = false;
            _this16.$refs.noneligibleFeaturepop.showmodel(_this16.eligible, '/newsfeed', 'PartnerloginMesterMesterReserve');
            return;
          }
          if (_this16.reserve_size < 1) {
            _this16.itemloading = false;
            _this16.showchecklimit();
            return;
          }
          if (_this16.partnerinvoice !== 0) {
            var obj = {
              title: '',
              message: 'Du kan desværre ikke reservere dette møde, da vi ikke har modtaget din abonnementsbetaling. Klik her for at logge ind og opdatere kreditkortinfo: <a  href=/#/rediger-kreditkort-oplysninger >partnerprofil</a>',
              type: 'error'
            };
            _this16.$refs.simplert.openSimplert(obj);
            _this16.itemShow = false;
            _this16.itemloading = false;
            return;
          }
          var r = confirm(' Bekræft din reservation \n Bekræft at du gerne vil have opgaven ?');
          if (r === true) {
            _this16.isLoadingReserve = true;
            _this16.salesPerson = localStorage.getItem('id_token_portal');
            var dataPartner = { operation: 'reservedbooktilbudmester', salesPerson: _this16.salesPerson, tilbudid: _this16.itemSelect.id, short: _this16.itemSelect.urlshort };
            _this16.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              _this16.isLoadingReserve = false;
              _this16.show = false;
              _this16.loading = false;
              _this16.itemloading = false;
              if (res.login === false) {
                _this16.$router.push('/login');
              }
              if (res.success) {
                if (res.result.app === 2) {
                  _this16.itemShowMester = false;
                  var _obj3 = {
                    title: 'Gennemført!',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  };
                  _this16.$refs.simplert.openSimplert(_obj3);
                  _this16.itemSelect.reserved = 1;
                  _this16.itemSelect.reservedName = res.result.name;
                  _this16.itemSelect.reservedPhone = res.result.phone;
                } else {
                  alert('Error .....!!!');
                }
                _this16.getpackage();
              } else {
                _this16.itemloading = false;
                alert(res.message);
              }
            }, function (response) {
              _this16.itemloading = false;
              alert('error');
            });
          } else {
            _this16.itemloading = false;
          }
        }
      }, function (response) {
        _this16.itemloading = false;
        console.log('Error: ', response);
      });
    },
    openconfirmationdialog: function openconfirmationdialog(value, item) {
      var buttonRecommendation = document.getElementById('marketplacereserve');
      buttonRecommendation.click();
    },
    confirmRecommendreservation: function confirmRecommendreservation(answer) {
      var _this17 = this;

      if (answer === 'yes') {
        return function (dialog) {
          return _this17.sendreservation();
        };
      } else {
        return function (dialog) {
          return _this17.dontsendreservation();
        };
      }
    },
    sendreservation: function sendreservation() {
      if (this.itemSelect.henttilbud !== 1 && this.step === 1) {
        this.reservedItem();
      }
      if (this.itemSelect.henttilbud === 1 && this.step === 1) {
        this.reservedItemTilbud();
      }
    },
    dontsendreservation: function dontsendreservation() {
      var a = 1;
      console.log(a);
    },
    openidreserve: function openidreserve() {
      var shorturlmain = this.usershorturl;
      var datetime = this.currentandexpiryDateTime();
      __WEBPACK_IMPORTED_MODULE_10_axios___default()({
        method: 'GET',
        url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=openpidreserved&short=' + shorturlmain + '&timeo=' + datetime
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          return true;
        }
      });
    },
    chechifcanreserve: function chechifcanreserve() {
      var _this18 = this;

      this.openidreserve();
      var shorturlmain = this.usershorturl;
      var datetime = this.currentandexpiryDateTime();
      __WEBPACK_IMPORTED_MODULE_10_axios___default()({
        method: 'GET',
        url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checktotalpidreserved&short=' + shorturlmain + '&timeo=' + datetime
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this18.canReserve = res.result.canReserve;

          _this18.priceereservce = res.result.price;
          _this18.BuyMoreReserve = res.result.BuyMoreReserve;
        }
      });
    },
    buyreserveadditional: function buyreserveadditional() {
      var _this19 = this;

      if (!this.BuyMoreReserve) {
        this.showcantbuyreserve();
        this.hideModalreservafailedchecklimit();
        return;
      }
      var shorturlmain = this.usershorturl;
      var datetime = this.currentandexpiryDateTime();
      __WEBPACK_IMPORTED_MODULE_10_axios___default()({
        method: 'GET',
        url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=addpidreserved&short=' + shorturlmain + '&timeo=' + datetime
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this19.showdonepaidextension();
          _this19.hideModalreservafailedchecklimit();
        } else {
          alert(res.success);
        }
      });
    },
    buyreserveadditionalbitrix: function buyreserveadditionalbitrix(id) {
      var _this20 = this;

      this.disablekatak = true;
      if (!this.permittedtobuy) {
        this.cantbuyreserve = true;
        this.reservafailedchecklimitbitrix = false;
        return false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        partnerId: this.haaId
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + parseInt(this.itemSelect.ID) + '/reserveMore', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this20.reservafailedchecklimitbitrix = false;
        _this20.loadingreserve = false;
        var obj = {
          title: 'Gennemført!, Du har tilføjet 1 reservation med succes. Tak!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this20.$refs.simplert.openSimplert(obj);
        setTimeout(function () {
          _this20.$router.push('/alle-moeder?fromMarketplace=1');
        }, 2000);
      }, function (response) {
        _this20.cantbuyreserve = true;
        _this20.disablekatak = false;
        _this20.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    checkbuyreserveadditionalbitrix: function checkbuyreserveadditionalbitrix(id) {
      var _this21 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        partnerId: this.haaId
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + parseInt(this.itemSelect.ID) + '/marketplace/checkReserveMore', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this21.slotpris = res.price;
        _this21.permittedtobuy = res.success;
        _this21.disablekatak = false;
      }, function (response) {
        _this21.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    showchecklimit: function showchecklimit() {
      this.$refs['reservafailedchecklimit'].show();
      this.closemodalbitrix();
    },
    showcantbuyreserve: function showcantbuyreserve() {
      this.$refs['cantbuyreserve'].show();
    },
    hidecantbuyreserve: function hidecantbuyreserve() {
      this.$refs['cantbuyreserve'].hide();
    },
    showdonepaidextension: function showdonepaidextension() {
      this.$refs['reservafailedpaidadditional'].show();
    },
    hideModalreservafailedchecklimit: function hideModalreservafailedchecklimit() {
      this.$refs['reservafailedchecklimit'].hide();
    },
    hideModalreservafailedpaidadditional: function hideModalreservafailedpaidadditional() {
      this.$refs['reservafailedpaidadditional'].hide();
    },
    currentandexpiryDateTime: function currentandexpiryDateTime() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var current = new Date();
      if (a !== null) {
        current.setDate(current.getDate() + 30);
      }
      var date = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate();
      var time = current.getHours() + ':' + current.getMinutes() + ':' + current.getSeconds();
      var dateTime = date + ' ' + time;
      return dateTime;
    },
    handleSubmitMail: function handleSubmitMail() {
      var _this22 = this;

      this.isLoadingMail = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'basicemail_partner_profile', salesPerson: this.salesPerson, textReason: 'MarketPlace' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this22.$router.push('/login');
        }
        if (res.success) {
          var obj = {
            title: 'Vi kontakter dig snarest muligt!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this22.$refs.simplert.openSimplert(obj);
          _this22.isLoadingMail = false;
          _this22.textReason = '';
        } else {
          alert(res.message);
          _this22.isLoadingMail = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    reservedItemConfirm1: function reservedItemConfirm1() {},

    mesersort: function mesersort(arr) {
      return arr.slice().sort(function (a, b) {
        return a.mester > b.mester;
      });
    },
    Reload: function Reload() {
      var _this23 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner_mester', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this23.$router.push('/login');
        }
        _this23.itemMester = res;
        _this23.SearchItemMester = res;
        var varthis = _this23;
        _this23.itemMester.forEach(function (item) {
          varthis.joballbranche.push(item.productname);
          varthis.joballlocation.push(item.postnumbercity2);
        });
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this23.joballbranche = _this23.joballbranche.filter(unique);
        _this23.joballlocation = _this23.joballlocation.filter(unique);
      }, function (response) {
        alert('error');
      });
    },
    updateSearch: function updateSearch() {
      var loc = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var branc = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'task';

      var itemsbra = [];
      var itemsloc = [];
      var itemsjobbra = [];
      var itemsjobloc = [];

      if (type === 'task') {
        if (loc.length > 0) {
          this.items.filter(function (a) {
            loc.forEach(function (item) {
              if (item === a.mailingcity) {
                itemsloc.push(a);
              }
            });
          });
        }
        if (branc.length > 0) {
          this.items.filter(function (b) {
            branc.forEach(function (itembr) {
              if (itembr === b.producttitle) {
                itemsbra.push(b);
              }
            });
          });
        }
        if (loc.length > 0 || branc.length > 0) {
          this.SearchItem = itemsbra.concat(itemsloc);
        } else {
          this.SearchItem = this.items;
        }
      }

      if (type === 'job') {
        if (loc.length > 0) {
          this.itemMester.filter(function (a) {
            loc.forEach(function (itemj) {
              if (itemj === a.postnumbercity2) {
                itemsjobloc.push(a);
              }
            });
          });
        }
        if (branc.length > 0) {
          this.itemMester.filter(function (b) {
            branc.forEach(function (itembrj) {
              if (itembrj === b.productname) {
                itemsjobbra.push(b);
              }
            });
          });
        }
        if (loc.length > 0 || branc.length > 0) {
          this.SearchItemMester = itemsjobbra.concat(itemsjobloc);
        } else {
          this.SearchItemMester = this.itemMester;
        }
      }
    },
    formatCurrency: function formatCurrency(total) {
      var neg = false;
      if (total < 0) {
        neg = true;
        total = Math.abs(total);
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString();
    },
    hideModal: function hideModal() {
      this.$refs.itemModal.hide();
    },
    changeJob: function changeJob(cond) {
      this.job = cond;
    },
    nextStep: function nextStep() {
      this.step = 2;
    },
    getpackage: function getpackage() {
      var _this24 = this;

      this.haaId = localStorage.getItem('haaid');
      var id = this.haaId;
      var token = this.salesPerson;
      var headers = {
        Authorization: 'Bearer ' + token
      };

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + id, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this24.nummode = res.data.nummode;
          _this24.maxreserve_size = Number(res.data.reserve_size);
          _this24.reserve_size = parseInt(_this24.maxreserve_size - _this24.nummode);
          _this24.packagetypebitrix = res.data.PACKAGE_HANDLE;
          _this24.endcode = res.data.booking;
          _this24.bookingwizardurl = res.onboarding.url;
          _this24.bookingwizardurlstep = Number(res.onboarding.step);
          if (_this24.bookingwizardurl && _this24.bookingwizardurlstep && _this24.packagetypebitrix === 'Trialjobsfree' && _this24.bookingwizardurlstep < 7) {
            _this24.sendingsuccess = true;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    setCookies: function setCookies() {
      var cookieStorage = {
        getItem: function getItem(key) {
          var cookies = document.cookie.split(';').map(function (cookie) {
            return cookie.split('=');
          }).reduce(function (acc, _ref) {
            var _ref2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, key.trim(), value));
          }, {});
          return cookies[key];
        },
        setItem: function setItem(key, value, expires) {
          document.cookie = key + '=' + value + '; ' + 'expires' + '=' + expires;
        }
      };
      var date = new Date();
      var nextYear = date.getFullYear() + 1;
      var expiryDate = date.toGMTString().toString().replace(date.getFullYear(), nextYear);
      cookieStorage.setItem('branchefilter', this.branchefilter, expiryDate);
      cookieStorage.setItem('localtionfilter', this.localtionfilter, expiryDate);
      cookieStorage.setItem('localtionjobfilter', this.localtionjobfilter, expiryDate);
      cookieStorage.setItem('branchejobfilter', this.branchejobfilter, expiryDate);
    }
  }
});

/***/ }),
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MarketArchive__ = __webpack_require__(525);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'archivemodal',
  components: {
    marketarchive: __WEBPACK_IMPORTED_MODULE_0__MarketArchive__["a" /* default */]
  },
  data: function data() {
    return {
      archiveShow: false
    };
  },

  methods: {
    closeArchiveModal: function closeArchiveModal() {
      this.$refs.archiveModal.hide();
    }
  }
});

/***/ }),
/* 783 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketarchive',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  created: function created() {
    var _this = this;

    this.salesPerson = localStorage.getItem('id_token_portal');
    this.show = true;
    var data = { operation: 'openjob_partner_old', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
      _this.items = res.openjobold;
      _this.show = false;
    }, function (response) {
      alert('error');
    });
  },

  methods: {
    formatCurrency: function formatCurrency(total) {
      var neg = false;
      if (total < 0) {
        neg = true;
        total = Math.abs(total);
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString();
    }
  },
  data: function data() {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      overlay: 1
    };
  }
});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0652b14e_hasScoped_true_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(788);
function injectStyle (ssrContext) {
  __webpack_require__(786)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0652b14e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_0652b14e_hasScoped_true_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 786 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
    props: {
        label: {
            default: 'Loading...'
        },
        show: {
            default: false
        },
        overlay: {
            default: true
        },
        loaderClass: {
            default: 'loader-wrapper'
        },
        overlayClass: {
            default: 'white-overlay'
        },

        eventBus: {
            default: null
        },
        eventShow: {
            default: 'show-full-loading'
        },
        eventHide: {
            default: 'hide-full-loading'
        }
    },
    data: function data() {
        return {
            showing: false
        };
    },

    watch: {
        show: function show(val) {
            this.showing = val;
        }
    },
    methods: {
        showMe: function showMe() {
            this.showing = true;
        },
        hideMe: function hideMe() {
            this.showing = false;
        },
        registerBusMethods: function registerBusMethods() {
            this.eventBus.$on(this.eventShow, this.showMe);
            this.eventBus.$on(this.eventHide, this.hideMe);
        }
    },
    mounted: function mounted() {
        if (this.eventBus) this.registerBusMethods();
    }
});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"enter-active-class":"animated fadeIn","leave-active-class":"animated fadeOut"}},[(_vm.showing)?_c('div',{class:( _obj = {}, _obj[_vm.overlayClass] = _vm.overlay, _obj )},[_vm._t("loading-container",function(){return [_c('div',{class:_vm.loaderClass},[_vm._t("loading-text",function(){return [_c('div',{staticClass:"pulled-left",domProps:{"innerHTML":_vm._s(_vm.label)}})]}),_vm._v(" "),_vm._t("loading-spinner",function(){return [_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-layer spinner-layer--blue"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--red"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--yellow"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])]),_vm._v(" "),_c('div',{staticClass:"spinner-layer spinner-layer--green"},[_c('div',{staticClass:"spinner-clipper spinner-clipper--left"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner--patch"},[_c('div',{staticClass:"spinner-circle"})]),_vm._v(" "),_c('div',{staticClass:"spinner-clipper spinner-clipper--right"},[_c('div',{staticClass:"spinner-circle"})])])])])]})],2)]})],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_vm._l((_vm.items),function(item){return _c('div',{key:0,staticClass:"clearfix muted-border border shadow mb3 px0"},[_c('div',{key:item.id,staticStyle:{"height":"128px","overflow":"hidden"}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"src":item.image,"alt":""}}),_vm._v(" "),_vm._m(0,true)]),_vm._v(" "),_c('div',{staticClass:"col col-8 pl2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-2 pt2"},[_c('span',[_vm._v(_vm._s(item.producttitle))])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1"},[_vm._v("\n            "+_vm._s(_vm.formatCurrency(item.amount))+" kr.\n          ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson regular m0 line-height-2 flex justify-start items-start"},[_c('span',{staticClass:"inline-block"},[_c('span',{staticClass:"mediumgrey block"},[_vm._v("\n                Markedspladsen dato\n              ")]),_vm._v(" "),_c('span',[_vm._v("\n                "+_vm._s(_vm.moment(item.timeadd).locale('da').format('LL'))),_c('br'),_vm._v(" "+_vm._s(_vm.moment(item.solddate).locale('da').format('LL'))+"\n              ")])])])])])])])}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute top-0 right-0 left-0 lightgrey-background p1",staticStyle:{"background":"#535c68"}},[_c('span',{staticClass:"h6 m0 p0 regular white gibson line-height-1"},[_vm._v("Solgt")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"col-12 p2 outlined-dark-button h5 gibson mb0 not-rounded",on:{"click":function($event){_vm.archiveShow = !_vm.archiveShow}}},[_c('span',{staticClass:"regular"},[_vm._v("Se listen")])]),_vm._v(" "),_c('b-modal',{ref:"archiveModal",attrs:{"lazy":"","centered":"","hide-header-close":"","id":"modal-center","lazy":""},model:{value:(_vm.archiveShow),callback:function ($$v) {_vm.archiveShow=$$v},expression:"archiveShow"}},[_c('div',{staticClass:"clearfix p2"},[_c('div',{staticClass:"flex justify-between items-center",attrs:{"slot":"modal-title"},slot:"modal-title"},[_c('div',[_c('p',{staticClass:"h5 darkblue m0 gibson line-height-3"},[_vm._v("\n            Archived kundehenvendelser\n            ")])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"outlined-delete-button p1",on:{"click":_vm.closeArchiveModal}},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix px2"},[_c('marketarchive')],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix px2 py3"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-12 h5 standard-button p2 gibson border-none not-rounded",attrs:{"slot":"modal-cancel","type":"reset"},on:{"click":_vm.closeArchiveModal},slot:"modal-cancel"},[_c('span',[_vm._v("Luk")])])])])])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'updatebitrixpackagepermission',
  props: ['eligibilitydata'],
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      partnername: '',
      defaultpackage: []
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.partnername = localStorage.getItem('CompanyName');
  },
  mounted: function mounted() {
    this.getInitialPackageValue();
  },

  methods: {
    wait1hourreminder: function wait1hourreminder() {
      var timenow = new Date();
      var timeafter1hour = new Date();
      timeafter1hour.setTime(timenow.getTime() + 1 * 60 * 60 * 1000);
      localStorage.setItem('timeaddedcard', timenow);
      localStorage.setItem('timeaddedcardexpiry', timeafter1hour);
      this.$emit('Nopaymentmethod', 'false');
    },
    check1hour: function check1hour() {
      var timeaccessnow = new Date();
      var togettime = localStorage.getItem('timeaddedcard');
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry');
      var togettimenew = new Date(togettime);
      var togettimeexpirynew = new Date(togettimeexpiry);
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    getInitialPackageValue: function getInitialPackageValue() {
      this.defaultpackage[0] = 'ClimatePartner';
      this.defaultpackage[1] = 'FBPostRecommendation';
      this.defaultpackage[2] = 'PartnerAccountingInteg';
      this.defaultpackage[3] = 'ExtraReservation';
      this.defaultpackage[4] = 'ExternalProWebsite';
      this.defaultpackage[5] = 'OfferCreator';
      this.defaultpackage[6] = 'PartnerloginMesterMesterReserve';
      this.defaultpackage[7] = 'PartnerLoginUdbudJobs';
      this.defaultpackage[8] = 'PartnerLoginMarketplaceReserve';
      this.defaultpackage[9] = 'PartnerloginMesterMesterPost';
      this.defaultpackage[10] = 'PartnerLoginMarketplaceViewer';
      this.defaultpackage[11] = 'PersonalPartnerLogin';
      this.defaultpackage[12] = 'AccessVideoProProfile';
      this.defaultpackage[13] = 'AccessDescriptionText';
      this.defaultpackage.forEach(function (elementfeature) {
        localStorage.setItem(elementfeature, false);
      });
      this.getpackage();
    },
    getpackage: function getpackage() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var boughtfeature = [];

          var packagedatafeature = res.data.PACKAGE_FEATURES;
          var packagedatafeatureeach = res.data.ACTIVE;

          if (packagedatafeatureeach && packagedatafeature) {
            packagedatafeature.forEach(function (element) {
              boughtfeature.push(element.SHORT_CODE + '-' + element.LIMITATION);
            });
            boughtfeature.forEach(function (elements) {
              var elementsname = elements.split('-')[0];
              var elementslimitations = elements.split('-')[1];
              if (_this.defaultpackage.includes(elementsname)) {
                if (elementslimitations !== null && elementslimitations !== 'null') {
                  localStorage.setItem(elementsname, true);
                  localStorage.setItem(elementsname + 'limit', elementslimitations);
                } else {
                  localStorage.setItem(elementsname, true);
                }
                if (localStorage.getItem('PartnerLoginMarketplaceReserve') || localStorage.getItem('PartnerloginMesterMesterReserve')) {
                  localStorage.setItem('PartnerLoginMarketplaceViewer', true);
                }
              }
            });
          }
          localStorage.setItem('PartnerloginMesterMesterReserve-nummode', res.data.nummode);
          localStorage.setItem('PartnerloginMesterMesterReserve-size', res.data.reserve_size);
          localStorage.setItem('PartnerLoginMarketplaceReserve-nummode', res.data.nummode);
          localStorage.setItem('PartnerLoginMarketplaceReserve-size', res.data.reserve_size);
          localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE);
          if (localStorage.getItem('PartnerLoginUdbudJobs')) {
            setTimeout(function () {
              document.getElementById('offentlige-udbud').classList.remove('hide');
            }, 500);
          }
          if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
            setTimeout(function () {
              document.getElementById('offentlige-udbud').classList.add('hide');
            }, 500);
          }

          console.log('this.$bitrixapi', _this.$bitrixapi);
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"updatebitrixpackagepermission"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */
/***/ (function(module, exports) {

module.exports = {"_from":"axios@^0.21.1","_id":"axios@0.21.4","_inBundle":false,"_integrity":"sha512-ut5vewkiu8jjGBdqpM44XxjuCjq9LAKeHVmoVfHVzy8eHgxxq8SbAVQNovDA8mVi05kP0Ea/n/UzcSHcTJQfNg==","_location":"/axios","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"axios@^0.21.1","name":"axios","escapedName":"axios","rawSpec":"^0.21.1","saveSpec":null,"fetchSpec":"^0.21.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/axios/-/axios-0.21.4.tgz","_shasum":"c67b90dc0568e5c1cf2b0b858c43ba28e2eda575","_spec":"axios@^0.21.1","_where":"D:\\Kundematch\\portal-solution","author":{"name":"Matt Zabriskie"},"browser":{"./lib/adapters/http.js":"./lib/adapters/xhr.js"},"bugs":{"url":"https://github.com/axios/axios/issues"},"bundleDependencies":false,"bundlesize":[{"path":"./dist/axios.min.js","threshold":"5kB"}],"dependencies":{"follow-redirects":"^1.14.0"},"deprecated":false,"description":"Promise based HTTP client for the browser and node.js","devDependencies":{"coveralls":"^3.0.0","es6-promise":"^4.2.4","grunt":"^1.3.0","grunt-banner":"^0.6.0","grunt-cli":"^1.2.0","grunt-contrib-clean":"^1.1.0","grunt-contrib-watch":"^1.0.0","grunt-eslint":"^23.0.0","grunt-karma":"^4.0.0","grunt-mocha-test":"^0.13.3","grunt-ts":"^6.0.0-beta.19","grunt-webpack":"^4.0.2","istanbul-instrumenter-loader":"^1.0.0","jasmine-core":"^2.4.1","karma":"^6.3.2","karma-chrome-launcher":"^3.1.0","karma-firefox-launcher":"^2.1.0","karma-jasmine":"^1.1.1","karma-jasmine-ajax":"^0.1.13","karma-safari-launcher":"^1.0.0","karma-sauce-launcher":"^4.3.6","karma-sinon":"^1.0.5","karma-sourcemap-loader":"^0.3.8","karma-webpack":"^4.0.2","load-grunt-tasks":"^3.5.2","minimist":"^1.2.0","mocha":"^8.2.1","sinon":"^4.5.0","terser-webpack-plugin":"^4.2.3","typescript":"^4.0.5","url-search-params":"^0.10.0","webpack":"^4.44.2","webpack-dev-server":"^3.11.0"},"homepage":"https://axios-http.com","jsdelivr":"dist/axios.min.js","keywords":["xhr","http","ajax","promise","node"],"license":"MIT","main":"index.js","name":"axios","repository":{"type":"git","url":"git+https://github.com/axios/axios.git"},"scripts":{"build":"NODE_ENV=production grunt build","coveralls":"cat coverage/lcov.info | ./node_modules/coveralls/bin/coveralls.js","examples":"node ./examples/server.js","fix":"eslint --fix lib/**/*.js","postversion":"git push && git push --tags","preversion":"npm test","start":"node ./sandbox/server.js","test":"grunt test","version":"npm run build && grunt version && git add -A dist && git add CHANGELOG.md bower.json package.json"},"typings":"./index.d.ts","unpkg":"dist/axios.min.js","version":"0.21.4"}

/***/ }),
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"marketplacepage"}},[(_vm.job)?[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0 marketplaceItems mb3"},[_c('div',{staticClass:"clearfix pb3"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Arbejdskraft\n              ")]),_vm._v(" "),_c('div',{staticClass:"border green-border p1"},[(_vm.job)?_c('button',{staticClass:"  border-none white-button",on:{"click":function($event){return _vm.changeJob(false)}}},[_vm._m(0)]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"  border-none white-button",on:{"click":function($event){return _vm.changeJob(true)}}},[_vm._m(1)]):_vm._e()])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjob",modifiers:{"webCustomersmarketjob":true}}],staticClass:" col-12 white darkblue-background gibson p2 h4 not-rounded px5 mr2 my2"},[_c('span',[_vm._v("\n                  Filter\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('b-collapse',{attrs:{"id":"webCustomersmarketjob"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                      Filtrer resultatet\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjob",modifiers:{"webCustomersmarketjob":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2 p0"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto mb2 p0"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Branche")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.joballbranche),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-6 p0 m0",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.branchejobfilter),callback:function ($$v) {_vm.branchejobfilter=$$v},expression:"branchejobfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 mx-auto p0"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Beliggenhed")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.joballlocation),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-5 p0 m0",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.localtionjobfilter),callback:function ($$v) {_vm.localtionjobfilter=$$v},expression:"localtionjobfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])])])])],1)]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(2)]):_vm._l((_vm.SearchItemMester),function(item){return _c('div',{key:item.ID,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetailsMester(item)}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"data-key":item.id,"src":typeof item.productimage !== 'undefined' && item.productimage !== null ? item.productimage : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(item.id)}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                "+_vm._s(item.postnumber2)+"\n              ")]),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                "+_vm._s(item.postnumbercity2)+"\n              ")])])])]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.productname))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1"},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.desc2.replace('\/', ''),150, '...'))+"\n                  ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1 line-height-2 mb1 flex flex-column"},[(item.reservedName !== '')?_c('span',{staticClass:"semi-bold"},[_vm._v("Navn : "+_vm._s(item.reservedName))]):_vm._e(),_vm._v(" "),(item.reservedPhone !== '')?_c('span',{staticClass:"block pt2"},[_vm._v("\n                Mobil: "),_c('a',{attrs:{"href":'tel:'+item.reservedPhone}},[_vm._v("  "+_vm._s(item.reservedPhone)+" ")]),_c('br')]):_vm._e()])]],2)])])})],2)]):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix marketplaceItems"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center"},[_c('div',{staticClass:"col-4 p0"},[(_vm.job)?_c('button',{staticClass:"col-12 outlined-standard-button gibson p2 px6 h5 not-rounded flex justify-center items-center line-height-1 my2",on:{"click":function($event){return _vm.changeJob(false)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                  Se opgaver\n                ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"col-12 outlined-standard-button gibson p2 h4 not-rounded flex justify-center items-center line-height-1 my2",on:{"click":function($event){return _vm.changeJob(true)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                  Se ledige arbejdskraft\n                ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('div',{staticClass:"col-12 darkblue-background gibson p1 px3 h5 not-rounded flex justify-center my2 m2"},[_c('p',{staticClass:" white h5 regular center line-height-golden mb0 gibson p2"},[_vm._v("\n                  Antal reservationer: "),_c('span',{staticClass:"semi-bold pl1 "},[_vm._v(_vm._s(_vm.nummode))]),_c('span',{staticClass:"pl1"},[_vm._v("ud af")]),_vm._v(" "),_c('span',{staticClass:"semi-bold pl1"},[_vm._v(_vm._s(_vm.maxreserve_size))])])])]),_vm._v(" "),_c('div',{staticClass:"col-4"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjob",modifiers:{"webCustomersmarketjob":true}}],staticClass:"col-9 darkblue-background gibson p1 px3 h5 not-rounded flex justify-center my2 m2",staticStyle:{"border":"0"}},[_c('p',{staticClass:"white h5 regular center line-height-golden mb0 gibson p2"},[_vm._v("\n                  Filter\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-collapse',{attrs:{"id":"webCustomersmarketjob"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                      Filtrer resultatet\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjob",modifiers:{"webCustomersmarketjob":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto mb2"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Branche")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.joballbranche),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.branchejobfilter),callback:function ($$v) {_vm.branchejobfilter=$$v},expression:"branchejobfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Beliggenhed")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.joballlocation),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.localtionjobfilter),callback:function ($$v) {_vm.localtionjobfilter=$$v},expression:"localtionjobfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(4)]):_c('div',{staticClass:"flex flex-wrap justify-start"},_vm._l((_vm.SearchItemMester),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"width":"275px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetailsMester(item)}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"data-key":item.id,"src":typeof item.productimage !== 'undefined' && item.productimage !== null ? item.productimage : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(item.id)}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.postnumber2)+"  "+_vm._s(item.postnumbercity2)+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.productname))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1"},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.desc2,180, '...'))+"\n                  ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1 line-height-2 mb1 flex flex-column"},[(item.reservedName !== '')?_c('span',{staticClass:"semi-bold"},[_vm._v("Navn : "+_vm._s(item.reservedName))]):_vm._e(),_vm._v(" "),(item.reservedPhone !== '')?_c('span',{staticClass:"block pt2"},[_vm._v("\n                      Mobil: "),_c('a',{attrs:{"href":'tel:'+item.reservedPhone}},[_vm._v("  "+_vm._s(item.reservedPhone)+" ")]),_c('br')]):_vm._e()])]],2)])])}),0)]):_vm._e()]:_vm._e(),_vm._v(" "),(!_vm.job)?[_c('div',{staticClass:"clearfix marketplaceItems xs-px2"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center xs-flex-column"},[_c('div',{staticClass:"md-col-4 sm-col-4 lg-col-4 xs-col-12 p0"},[(_vm.job)?_c('button',{staticClass:"col-12 outlined-standard-button  p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2",on:{"click":function($event){return _vm.changeJob(false)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                  Se opgaver\n                ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"col-12 outlined-standard-button  p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2",on:{"click":function($event){return _vm.changeJob(true)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                  Se ledige arbejdskraft\n                ")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"md-col-4 sm-col-4 lg-col-4 xs-col-12"},[_c('div',{staticClass:"darkblue-background  p1 px3 h5 not-rounded flex justify-center my2 m2 xs-mx0"},[_c('p',{staticClass:" white h5 regular center line-height-golden mb0  p2"},[_vm._v("\n                  Antal reservationer: "),_c('span',{staticClass:"semi-bold pl1"},[_vm._v(_vm._s(_vm.nummode))]),_c('span',{staticClass:"pl1"},[_vm._v("ud af")]),_vm._v(" "),_c('span',{staticClass:"semi-bold pl1"},[_vm._v(_vm._s(_vm.maxreserve_size))])])])]),_vm._v(" "),_c('div',{staticClass:"md-col-4 sm-col-4 lg-col-4 xs-col-12"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarket",modifiers:{"webCustomersmarket":true}}],staticClass:"xs-col-12 md-col-11 lg-col-11 sm-col-11 darkblue-background  p1 px3 h5 not-rounded flex justify-center my2 m2 xs-mx0",staticStyle:{"border":"0"}},[_c('p',{staticClass:"white h5 regular center line-height-golden mb0  p2"},[_vm._v("\n                  Filter\n                ")])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-collapse',{attrs:{"id":"webCustomersmarket"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue  line-height-3"},[_vm._v("\n                      Filtrer resultatet\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarket",modifiers:{"webCustomersmarket":true}}],staticClass:"white-button border-none not-rounded "},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2 z0"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto mb2"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Branche")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.taskallbranche),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.branchefilter),callback:function ($$v) {_vm.branchefilter=$$v},expression:"branchefilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Beliggenhed")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.taskalllocation),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.localtionfilter),callback:function ($$v) {_vm.localtionfilter=$$v},expression:"localtionfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])])])])],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.totalitems > 0)?_c('div',{staticClass:"flex justify-start p0 xs-px2"},[_c('el-pagination',{attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":this.totalitems},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(6)]):_c('div',[_c('div',{staticClass:"clearfix flex flex-wrap justify-start xs-justify-center p0"},[_vm._l((_vm.openjobs),function(item){return _c('div',{key:item.ID,staticClass:"muted-border border shadow px0 mr2 mb2",staticStyle:{"width":"275px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){_vm.showItemDetailsjobs(item), _vm.saveJobsView(item.ID)}}},[(item.ADDRESS !== null)?_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"data-key":item.ID,"src":typeof item.ADDRESS.IMAGE !== 'undefined' && item.ADDRESS.IMAGE !== null ? item.ADDRESS.IMAGE.includes('staticmap') ? item.ADDRESS.IMAGE : item.ADDRESS.IMAGE + '?width=300' : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(item.ID)}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('div',{staticClass:"mintgreen-background py1 line-height-1 block px2 flex relative"},[_c('div',{staticClass:"h6 m0 p0 white semi-bold block mr-auto flex flex-column"},[(item.ADDRESS.ZIP)?_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s(item.ADDRESS.ZIP)+" "+_vm._s(item.ADDRESS.CITY))]):_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s('Project ID ' + item.ID))]),_vm._v(" "),_c('span',{staticClass:"small darkblue"},[_vm._v(_vm._s(item.MATCHING + '% Match'))])]),_vm._v(" "),_vm._m(7,true)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px1"},[_c('div',{staticClass:"flex flex-column"},[(item.CONTRACT_TYPE === 'Fagentreprise')?_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_c('div',{staticClass:"font14 semi-bold m0 darkblue  line-height-2 pt1 flex flex-wrap justify-between items-center"},[(item.JOBS_LIST.length > 1)?_c('p',{staticClass:"p0 m0"},[_vm._v("Mange Enterprise")]):(item.JOBS_LIST.length === 1)?_c('p',{staticClass:"p0 m0"},[(_vm.itemsjobindustry[item.JOB_INDUSTRY].length > 21)?_c('el-tooltip',{attrs:{"content":_vm.itemsjobindustry[item.JOB_INDUSTRY],"placement":"top","effect":"light"}},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(_vm.itemsjobindustry[item.JOB_INDUSTRY],22, '...'))+" Enterprise ")])]):_c('span',[_vm._v(_vm._s(_vm.itemsjobindustry[item.JOB_INDUSTRY])+" Enterprise ")])],1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue  line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(item.NAME,63, '...')))])])]):_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_vm._m(8,true),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue  line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(item.NAME,63, '...')))])])]),_vm._v(" "),[(item.STATUS !== 'accepted')?_c('p',{staticClass:"font14 darkblue regular line-height-2 mb2",staticStyle:{"height":"60px"}},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.DESCRIPTION,130, '...'))+"\n                    ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1  mb1 flex flex-column"},[_c('span',{staticClass:"block center"},[_vm._v("\n                        ACCEPTERET\n                      ")])])],_vm._v(" "),_vm._m(9,true)],2)])])}),_vm._v(" "),_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer!important","width":"275px"},on:{"click":function($event){return _vm.showItemDetails(item)}}},[(_vm.basic && item.mester !== '1')?_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2"},[_c('div',[_vm._m(10,true),_vm._v(" "),_c('button',{staticClass:"p2 my2 white-button flex justify-center items-center  h5 not-rounded border-none line-height-1",attrs:{"disabled":_vm.isLoadingMail},on:{"click":_vm.handleSubmitMail}},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_vm._m(11,true)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image},on:{"error":function($event){return _vm.checkimage(item.appid + 'd')}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingzip)+"\n                    ")]),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingcity)+"\n                    ")])]),_vm._v(" "),(item.gratis1 === '1')?[_vm._m(12,true)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue  line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.producttitle))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1"},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.comment_to_partner,80, '...'))+"\n                    ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1 line-height-2 mb1 flex flex-column"},[(item.reservedName !== '')?_c('span',{staticClass:"semi-bold"},[_vm._v("Navn : "+_vm._s(item.reservedName))]):_vm._e(),_vm._v(" "),(item.reservedPhone !== '')?_c('span',{staticClass:"block py2"},[_vm._v("\n                        Mobil: "),_c('a',{attrs:{"href":'tel:'+item.reservedPhone}},[_vm._v(_vm._s(item.reservedPhone))])]):_vm._e()])],_vm._v(" "),_c('p',{staticClass:"darkblue  semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud !== 1)?_c('span',{staticClass:"h6 semi-bold"},[_vm._v(_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(item.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold mintgreen mt2 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()],2)])])})],2)])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('b-modal',{ref:"itemModalbitrix",attrs:{"hide-header":"","lazy":"","size":"lg","no-close-on-backdrop":true,"id":"minboligjobs"}},[_c('div',{staticClass:"flex items-center justify-end col-12 p0 m0"},[_c('div',{staticClass:"pointer p2",on:{"click":function($event){return _vm.closemodalbitrix()}}},[_c('i',{staticClass:"el-icon-close h5 "})])]),_vm._v(" "),(_vm.loadingreserve)?_c('div',{staticClass:"clearfix mx-auto"},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])]):_c('div',{staticClass:"modal-body-marketplace"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"Se detaljer"}},[_c('div',{staticClass:"relative p2"},[_c('img',{staticClass:"fit block",staticStyle:{"height":"300px","width":"100%","object-fit":"none"},attrs:{"data-key":_vm.itemSelect.ID,"src":typeof _vm.itemSelect.addressimage !== 'undefined' && _vm.itemSelect.addressimage !== null ? _vm.itemSelect.addressimage.includes('staticmap') ? _vm.itemSelect.addressimage : _vm.itemSelect.addressimage + '?width=300' : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.ID)}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 m2 mx4 darkblue-background opacity-50 p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.zip)+" "+_vm._s(_vm.itemSelect.city))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2 px2 mx2"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n                "+_vm._s(_vm.itemSelect.NAME)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.DATE_UPDATED).locale('da').format('LL')))])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.DESCRIPTION))])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Job beskrivelse"}},[_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Din Jobbeskrivelse")])]),_vm._v(" "),_c('div',{staticClass:"bordercece pb3 pt2 px1"},_vm._l((_vm.productlistforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start not-collapsed"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))]),_vm._v(" "),_c('span',{staticClass:"when-closed ml-auto"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened ml-auto"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('div',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark col-1"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 line-height-golden graymuteddark font14 "},[_vm._v(_vm._s(desc.replace('- ', ' ').trim()))])])])}),0)],1)})],2):_vm._e()}),0)]),_vm._v(" "),(_vm.itemSelect.CONTRACT_TYPE !== 'Hovedentreprise')?_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[(_vm.productlistnotforpricearr.length > 0 )?_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Andre entrepriser i projektet")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bordercece  pb3 pt2 px1"},_vm._l((_vm.productlistnotforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))]),_vm._v(" "),_c('span',{staticClass:"when-closed ml-auto"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened ml-auto"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('div',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark col-1"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 h6 line-height-golden graymuteddark "},[_vm._v(_vm._s(desc.replace('- ', ' ').trim()))])])])}),0)],1)})],2):_vm._e()}),0)]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h6 semi-bold primarycolor line-height-1 pl2"},[_vm._v("\n            Vigtig information:\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex gap-17 flex-wrap col-12 mx-auto"},[_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"33.823","height":"32.486","viewBox":"0 0 33.823 32.486"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1403","data-name":"Rectangle 1403","width":"33.823","height":"32.486","fill":"none"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"clock_ic","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4007","data-name":"Path 4007","d":"M0,15.257a.97.97,0,0,1,.92-.439c2.19.011,4.381,0,6.572.011a.428.428,0,0,0,.479-.316c.265-.649.579-1.278.874-1.915.04-.087.085-.171.151-.305H7.781c-.837,0-1.673,0-2.51,0-.484,0-.777-.258-.774-.663s.311-.66.783-.66c1.453,0,2.906,0,4.359-.007a.566.566,0,0,0,.393-.152,13.386,13.386,0,0,1,7.33-4.65c.052-.013.1-.031.174-.053,0-.5.014-1-.012-1.488,0-.092-.154-.209-.262-.257a2.188,2.188,0,0,1-1.4-1.849A2.086,2.086,0,0,1,16.973.33a2.684,2.684,0,0,1,1.19-.31C19.682-.015,21.2,0,22.72.007a2.272,2.272,0,0,1,2.353,1.931,2.271,2.271,0,0,1-1.546,2.471l-.126.045v1.66A12.823,12.823,0,0,1,27.644,7.88a13.1,13.1,0,0,1,6.04,9.443,13.085,13.085,0,0,1-1.933,8.962.7.7,0,0,1-.73.4.555.555,0,0,1-.525-.471,1.075,1.075,0,0,1,.142-.643,11.466,11.466,0,0,0,1.628-4.181,11.791,11.791,0,0,0-3.817-11.219,11.486,11.486,0,0,0-8.572-3.025A12,12,0,0,0,17.751,30.82a11.79,11.79,0,0,0,9.067-1.477,1.552,1.552,0,0,1,.442-.209.656.656,0,0,1,.442,1.221,21.413,21.413,0,0,1-2.161,1.123A13.332,13.332,0,0,1,8.147,24.229a.472.472,0,0,0-.529-.348c-1.387.016-2.774.009-4.161.006-.464,0-.758-.215-.81-.567-.067-.452.258-.778.793-.78,1.233,0,2.466,0,3.7,0h.386l-.4-2.527c-.942,0-1.887,0-2.833,0a.66.66,0,1,1-.033-1.316c.826-.006,1.651,0,2.477,0H7.1l.325-2.523H7.056c-2.048,0-4.095-.007-6.142.006A.959.959,0,0,1,0,15.719ZM20.473,3.176c.769,0,1.539,0,2.308,0a.928.928,0,0,0,.982-.9.9.9,0,0,0-.916-.928q-2.374-.03-4.748,0a.9.9,0,0,0-.928.945.924.924,0,0,0,.994.88c.769,0,1.539,0,2.308,0m-1.58,2.665h3.145v-1.3H18.894Z","transform":"translate(0 0)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4008","data-name":"Path 4008","d":"M0,255.958c.186-.252.388-.488.744-.43a.633.633,0,0,1,.568.556.617.617,0,0,1-.375.7.628.628,0,0,1-.775-.166c-.057-.062-.108-.131-.162-.2v-.462","transform":"translate(0 -232.973)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4009","data-name":"Path 4009","d":"M126.211,100.656a10.253,10.253,0,1,1-10.247,10.235,10.258,10.258,0,0,1,10.247-10.235m8.915,10.253a8.919,8.919,0,1,0-8.917,8.928,8.916,8.916,0,0,0,8.917-8.928","transform":"translate(-105.732 -91.774)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4010","data-name":"Path 4010","d":"M326.256,311.593a.666.666,0,0,1,.648-.651.668.668,0,1,1,0,1.336.666.666,0,0,1-.648-.685","transform":"translate(-297.468 -283.505)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4011","data-name":"Path 4011","d":"M193.814,162.1a1.672,1.672,0,0,1,.092-.495.476.476,0,0,0-.164-.643c-.38-.35-.738-.724-1.1-1.093a.679.679,0,0,1-.071-1.018.692.692,0,0,1,1.019.086c.384.378.769.755,1.141,1.145a.482.482,0,0,0,.5.142,4.33,4.33,0,0,1,1.292,0,.461.461,0,0,0,.477-.134c.975-.984,1.95-1.969,2.944-2.934a1.01,1.01,0,0,1,.622-.3.647.647,0,0,1,.473,1.047,2.335,2.335,0,0,1-.245.267c-.948.949-1.894,1.9-2.848,2.843a.419.419,0,0,0-.132.5,1.945,1.945,0,0,1-.6,2.18,1.917,1.917,0,0,1-2.18.326,2.027,2.027,0,0,1-1.225-1.931m2.787.063a.727.727,0,0,0-1.454,0,.727.727,0,0,0,1.454,0","transform":"translate(-175.399 -143.025)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4012","data-name":"Path 4012","d":"M145.449,210.573a3.212,3.212,0,0,1-.483-.068.626.626,0,0,1-.458-.675.6.6,0,0,1,.527-.585,3.527,3.527,0,0,1,.785-.017.635.635,0,0,1,.618.643.664.664,0,0,1-.624.679,3.22,3.22,0,0,1-.361,0l0,.021","transform":"translate(-131.753 -190.754)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4013","data-name":"Path 4013","d":"M225.832,130.4c0,.12.008.242,0,.361a.629.629,0,0,1-.623.6.638.638,0,0,1-.684-.571,4.134,4.134,0,0,1,0-.787.634.634,0,0,1,.69-.562.626.626,0,0,1,.616.6c.009.12,0,.241,0,.361","transform":"translate(-204.695 -118.011)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4014","data-name":"Path 4014","d":"M225.787,283.376a3.194,3.194,0,0,1,0,.361.684.684,0,0,1-.675.6.663.663,0,0,1-.636-.631c-.012-.219-.011-.439,0-.657a.668.668,0,0,1,.639-.664.683.683,0,0,1,.679.664c.006.109,0,.219,0,.329h0","transform":"translate(-204.659 -257.466)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4015","data-name":"Path 4015","d":"M298.685,209.515c.1,0,.2,0,.3,0a.645.645,0,0,1,.645.648.659.659,0,0,1-.632.668,5.575,5.575,0,0,1-.657,0,.652.652,0,0,1-.643-.688.643.643,0,0,1,.662-.631c.109-.005.219,0,.329,0","transform":"translate(-271.427 -191.026)","fill":"#1a1818"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352787] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Opgaven haster! Skal laves inden for 1 mdr.")]):_vm._e(),_vm._v(" "),(_vm.selectedPersonalInformation[352788] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Der er god tid til at løse opgaven")]):_vm._e(),_vm._v(" "),(_vm.selectedPersonalInformation[352789] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Meget tid!")]):_vm._e(),_vm._v(" "),(!_vm.selectedPersonalInformation[352789] && !_vm.selectedPersonalInformation[352788] && !_vm.selectedPersonalInformation[352787])?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Ingen information tilgængelig")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"29.959","height":"30.094","viewBox":"0 0 29.959 30.094"}},[_c('path',{attrs:{"id":"Path_4016","data-name":"Path 4016","d":"M6009.333-289.345h-10.664a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583h9.738a15.132,15.132,0,0,1-.821-1.283,9.78,9.78,0,0,1-1.239-5.327.582.582,0,0,1,.532-.568,5.021,5.021,0,0,0,1.363-.336,9.3,9.3,0,0,0-2.738-1.968,5.672,5.672,0,0,1-1.634,4.073.583.583,0,0,1-.418.21h-.031a.586.586,0,0,1-.408-.165l-3.288-3.2-3.287,3.2a.584.584,0,0,1-.437.164.582.582,0,0,1-.418-.21,5.666,5.666,0,0,1-1.637-4.075,10.733,10.733,0,0,0-5.658,7.758c-.165.745-.165,1.228,0,1.434s.588.291,1.286.291h3.815a.584.584,0,0,1,.583.583.584.584,0,0,1-.583.583h-3.815a2.731,2.731,0,0,1-2.195-.728,2.893,2.893,0,0,1-.229-2.416,13.61,13.61,0,0,1,2.539-5.566,10.526,10.526,0,0,1,4.758-3.407.692.692,0,0,1,.075-.027c.128-.046.259-.089.392-.13a7.594,7.594,0,0,1-2.416-5.032v-.916a1.933,1.933,0,0,1-1.164-1.771,1.93,1.93,0,0,1,1.245-1.8,7.211,7.211,0,0,1,1.713-3.953,7.239,7.239,0,0,1,3.6-2.254.874.874,0,0,1,.845-.653h2.113a.876.876,0,0,1,.855.694,7.193,7.193,0,0,1,5.167,6.166,1.929,1.929,0,0,1,1.244,1.8,1.93,1.93,0,0,1-1.162,1.769v.917a7.592,7.592,0,0,1-2.415,5.032c.136.042.27.088.4.135a.463.463,0,0,1,.045.016,10.524,10.524,0,0,1,4.348,2.909,8.822,8.822,0,0,0,1.893-1.5.581.581,0,0,1,.421-.181h0a.587.587,0,0,1,.422.181,7.5,7.5,0,0,0,4.35,2.375.581.581,0,0,1,.531.568,9.814,9.814,0,0,1-1.239,5.327c-.021.039-2.169,3.888-4.066,3.888A3.632,3.632,0,0,1,6009.333-289.345Zm.171-7.973c-.023.013-.044.024-.066.035a7.4,7.4,0,0,1-1.929.682,8.425,8.425,0,0,0,1.1,4.254c.69,1.289,2.305,3.273,3.037,3.273s2.349-1.985,3.038-3.272a8.453,8.453,0,0,0,1.1-4.255,8.78,8.78,0,0,1-4.142-2.241A9.8,9.8,0,0,1,6009.5-297.318Zm-14.325-3.162a3.972,3.972,0,0,0,.9,3.325l2.388-2.323c-.2-.053-.4-.118-.615-.2a7.811,7.811,0,0,1-1.879-1.032C5995.7-300.638,5995.437-300.562,5995.18-300.48Zm6.405.807c-.208.078-.41.143-.607.2l2.39,2.321a3.968,3.968,0,0,0,.9-3.324c-.26-.085-.525-.159-.8-.226A7.8,7.8,0,0,1,6001.585-299.673Zm-7.921-6.978c0,2.219,2.149,4.968,4.6,5.883a3.691,3.691,0,0,0,2.915,0c2.455-.912,4.61-3.661,4.61-5.885v-.757h-12.125Zm-1.164-2.686a.765.765,0,0,0,.764.763h12.924a.764.764,0,0,0,.761-.763.763.763,0,0,0-.761-.762h-8.928c-.028.031-.061.028-.1,0h-3.9A.764.764,0,0,0,5992.5-309.337Zm1.27-1.928h3.347a12.738,12.738,0,0,0,.741-4.857A6.11,6.11,0,0,0,5993.77-311.265Zm8.7,0h3.21a6.026,6.026,0,0,0-3.954-4.808A12.6,12.6,0,0,0,6002.473-311.266Zm-4.115,0h2.873a15.942,15.942,0,0,1-.671-5.568h-1.531A15.955,15.955,0,0,1,5998.358-311.266Zm-2.328,21.921a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583.585.585,0,0,1,.584.583.582.582,0,0,1-.582.583Zm15.023-2.975-1-.762a.581.581,0,0,1-.11-.816.583.583,0,0,1,.818-.11l.57.436,1.544-1.706a.582.582,0,0,1,.823-.041.583.583,0,0,1,.042.824l-1.9,2.1a.584.584,0,0,1-.433.191A.574.574,0,0,1,6011.053-292.32Z","transform":"translate(-5987 318)"}})])]),_vm._v(" "),(_vm.selectedPersonalInformation[352785] !== 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Garantiordning er ikke et krav")]):(_vm.selectedPersonalInformation[352785] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Skal være medlem af Garantiordning")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30.519","height":"30.518","viewBox":"0 0 30.519 30.518"}},[_c('path',{attrs:{"id":"Path_4017","data-name":"Path 4017","d":"M6002.974-294.754c0-.2.009-.4.026-.6h-12.8a.6.6,0,0,1-.6-.6v-9.949l-.243.178a.6.6,0,0,1-.354.116.735.735,0,0,1-.09-.006.6.6,0,0,1-.39-.237l-1.407-1.918a.6.6,0,0,1,.128-.833l4.392-3.231a.6.6,0,0,1,.833.127.6.6,0,0,1-.127.833l-3.912,2.878.7.958,10.736-7.9a.592.592,0,0,1,.706,0l10.737,7.9.7-.958-11.792-8.675-4.039,2.97a.6.6,0,0,1-.833-.126.6.6,0,0,1,.127-.833l4.392-3.232a.6.6,0,0,1,.706,0L6013.2-308.6a.6.6,0,0,1,.127.833l-1.406,1.918a.594.594,0,0,1-.391.236.591.591,0,0,1-.443-.109l-.243-.179V-302a7.282,7.282,0,0,1,6.676,7.247,7.28,7.28,0,0,1-7.273,7.273A7.281,7.281,0,0,1,6002.974-294.754Zm2.467-4.67a.6.6,0,0,1,.086.839,6.086,6.086,0,0,0-1.36,3.831,6.087,6.087,0,0,0,6.08,6.081,6.087,6.087,0,0,0,6.08-6.081,6.086,6.086,0,0,0-6.08-6.079,6.092,6.092,0,0,0-.96.075.6.6,0,0,1-.682-.5.6.6,0,0,1,.5-.683c.183-.028.366-.051.55-.065v-4.771l-9.429-6.938-9.431,6.938v10.23h5.379v-8.344a1.194,1.194,0,0,1,1.191-1.193h5.72a1.194,1.194,0,0,1,1.193,1.193v5.986c.1-.149.213-.3.328-.437a.6.6,0,0,1,.464-.221A.6.6,0,0,1,6005.44-299.425Zm-8.08,2.883h5.72v-8.344h-5.72Zm12.29,4.769v-.2a1.581,1.581,0,0,1-.673-.4.6.6,0,0,1,0-.843.6.6,0,0,1,.843,0,.4.4,0,0,0,.28.117.4.4,0,0,0,.282-.117.39.39,0,0,0,.115-.28.4.4,0,0,0-.115-.281l-1.114-1.114a1.592,1.592,0,0,1,0-2.248,1.559,1.559,0,0,1,.383-.283v-.315a.6.6,0,0,1,.6-.6.6.6,0,0,1,.595.6v.2a1.6,1.6,0,0,1,.674.4.6.6,0,0,1,0,.843.6.6,0,0,1-.843,0,.4.4,0,0,0-.562,0,.4.4,0,0,0,0,.562l1.114,1.114a1.592,1.592,0,0,1,0,2.248,1.6,1.6,0,0,1-.382.283v.315a.6.6,0,0,1-.6.6A.6.6,0,0,1,6009.65-291.773Zm-3.259-8.466a.6.6,0,0,1,.223-.814.6.6,0,0,1,.813.222.6.6,0,0,1-.222.814.6.6,0,0,1-.295.078A.6.6,0,0,1,6006.391-300.239Zm-5.1-.475a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6A.6.6,0,0,1,6001.292-300.715Zm-7.856-11.681a.6.6,0,0,1,.11-.836.6.6,0,0,1,.836.109.6.6,0,0,1-.11.836.588.588,0,0,1-.363.123A.6.6,0,0,1,5993.436-312.4Z","transform":"translate(-5987 318)"}})])]),_vm._v(" "),(_vm.selectedPersonalInformation[352795] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en skarp pris")]):(_vm.selectedPersonalInformation[352796] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker luksus standard")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Ingen information tilgængelig")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[(_vm.itemSelect.MAXIMUM_OFFER === 1)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 24.5 29.865"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.583-288.134a.585.585,0,0,1-.583-.583v-3.676a6.61,6.61,0,0,1,1.073-3.6,6.564,6.564,0,0,1,2.614-2.345.58.58,0,0,1,.332-.152,6.08,6.08,0,0,1,2.4-.49h1.75v-1.54c-.156-.14-.314-.286-.46-.437a6.674,6.674,0,0,1-1.632-2.865h-.24a2.332,2.332,0,0,1-2.333-2.333,2.307,2.307,0,0,1,.619-1.581,1.742,1.742,0,0,1-.619-1.336,1.734,1.734,0,0,1,.514-1.237,1.837,1.837,0,0,1,.676-.42,6.434,6.434,0,0,1,4.679-5.692,1.856,1.856,0,0,1,1.714-1.575h2.333a1.867,1.867,0,0,1,1.721,1.575,6.432,6.432,0,0,1,4.678,5.692,1.747,1.747,0,0,1,1.184,1.657,1.74,1.74,0,0,1-.512,1.237c-.036.035-.07.07-.106.1a2.307,2.307,0,0,1,.618,1.581,2.332,2.332,0,0,1-2.333,2.333h-.239a6.688,6.688,0,0,1-2.095,3.3v1.54h1.75a6.072,6.072,0,0,1,2.4.49.571.571,0,0,1,.333.152,6.6,6.6,0,0,1,2.613,2.345,6.6,6.6,0,0,1,1.073,3.6v3.676a.585.585,0,0,1-.584.583ZM6008-289.3h2.333v-3.092a5.578,5.578,0,0,0-2.333-4.486Zm-2.333-1.341v1.341h1.166v-8.2a4.8,4.8,0,0,0-1.166-.286v3.64a.586.586,0,0,1-.584.584.586.586,0,0,1-.583-.584v-3.675H6003l-3.168,3.325v5.191h4.666v-1.341a.586.586,0,0,1,.583-.584A.586.586,0,0,1,6005.667-290.642Zm-11.667,0v1.341h4.667v-5.191l-3.167-3.325H5994v3.675a.585.585,0,0,1-.583.584.585.585,0,0,1-.583-.584v-3.64a5.127,5.127,0,0,0-1.167.286v8.2h1.167v-1.341a.585.585,0,0,1,.583-.584A.585.585,0,0,1,5994-290.642Zm-5.832-1.751v3.092h2.333v-7.577A5.582,5.582,0,0,0,5988.167-292.393Zm8.166-6.241,2.917,3.063,2.917-3.063v-1.085a6.108,6.108,0,0,1-2.917.735,6.107,6.107,0,0,1-2.917-.735ZM5994-305.576a5.656,5.656,0,0,0,.1,1.045.018.018,0,0,1,.006.017,5.559,5.559,0,0,0,1.44,2.748,5.179,5.179,0,0,0,.589.531,5.052,5.052,0,0,0,3.115,1.085,5.021,5.021,0,0,0,3.109-1.085,5.518,5.518,0,0,0,2.03-3.279.02.02,0,0,0,.006-.017,5.305,5.305,0,0,0,.1-1.045v-1.75H5994Zm11.667,0c0,.193-.012.391-.029.584h.029a1.169,1.169,0,0,0,1.166-1.167,1.169,1.169,0,0,0-1.166-1.167Zm-14-.583a1.171,1.171,0,0,0,1.167,1.167h.029c-.019-.193-.029-.391-.029-.584v-1.75A1.171,1.171,0,0,0,5991.667-306.159Zm.169-3.331a.576.576,0,0,0-.169.414.586.586,0,0,0,.583.584h14a.575.575,0,0,0,.414-.17.573.573,0,0,0,.168-.414.584.584,0,0,0-.583-.583h-14A.578.578,0,0,0,5991.836-309.489Zm1.033-1.336h12.762a5.259,5.259,0,0,0-3.465-4.368v2.619a.585.585,0,0,1-.584.583.584.584,0,0,1-.582-.583v-3.5c0-.362-.3-.759-.584-.759h-2.333c-.28,0-.583.4-.583.759v3.5a.585.585,0,0,1-.584.583.584.584,0,0,1-.583-.583v-2.619A5.272,5.272,0,0,0,5992.869-310.825Zm11.63,18.432a.586.586,0,0,1,.583-.583.586.586,0,0,1,.584.583.586.586,0,0,1-.584.584A.586.586,0,0,1,6004.5-292.393Zm-11.666,0a.585.585,0,0,1,.583-.583.585.585,0,0,1,.583.583.586.586,0,0,1-.583.584A.585.585,0,0,1,5992.833-292.393Z","transform":"translate(-5987 318)"}})]):(_vm.itemSelect.MAXIMUM_OFFER === 2)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 62.759 35.057"}},[_c('g',{attrs:{"id":"_2","data-name":"2","transform":"translate(-2767.87 -1603.5)"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3219.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4028","data-name":"Path 4028","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3185.13 1921.5)"}})])]):(_vm.itemSelect.MAXIMUM_OFFER === 3)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 62.759 71.115"}},[_c('g',{attrs:{"id":"_3","data-name":"3","transform":"translate(-2767.87 -1567.443)"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3219.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4028","data-name":"Path 4028","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3185.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4029","data-name":"Path 4029","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3202.75 1885.442)"}})])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker "+_vm._s(_vm.itemSelect.MAXIMUM_OFFER)+" tilbud på opgaven")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 1)?_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]):(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 0)?_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]):(_vm.selectedPersonalInformation[352798] === 0 && _vm.selectedPersonalInformation[352800] === 1)?_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]):_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler dansk og engelsk")]):(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 0)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun dansk")]):(_vm.selectedPersonalInformation[352798] === 0 && _vm.selectedPersonalInformation[352800] === 0)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun engelsk")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun dansk")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.selectedPersonalInformation[352801] === 1)?_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1605_"}},[_c('g',{attrs:{"id":"XMLID_137_"}},[_c('path',{attrs:{"id":"XMLID_139_","d":"m278.661 230.088c3.905-3.905 3.905-10.237 0-14.143s-10.237-3.905-14.143 0c-4.696 4.697-12.34 4.697-17.036 0-3.905-3.905-10.237-3.905-14.143 0s-3.905 10.237 0 14.143c6.248 6.247 14.454 9.371 22.661 9.371s16.413-3.124 22.661-9.371z"}}),_c('path',{attrs:{"id":"XMLID_418_","d":"m256.131 55.126c-16.913 0-30.672 13.76-30.672 30.672s13.76 30.672 30.672 30.672 30.672-13.76 30.672-30.672-13.759-30.672-30.672-30.672zm0 41.345c-5.885 0-10.672-4.788-10.672-10.672s4.788-10.672 10.672-10.672 10.672 4.788 10.672 10.672-4.787 10.672-10.672 10.672z"}}),_c('path',{attrs:{"id":"XMLID_419_","d":"m256 492c-2.63 0-5.21 1.069-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.07-2.931c1.86-1.859 2.93-4.439 2.93-7.069s-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93z"}}),_c('path',{attrs:{"id":"XMLID_422_","d":"m356.956 301.815h-49.611v-29.317c24.906-16.635 41.344-44.997 41.344-77.13v-37.554h85.093c5.523 0 10-4.477 10-10s-4.477-10-10-10h-76.824v-64.42c0-32.871-26.742-59.613-59.613-59.613h-31.345v-3.781c0-5.523-4.477-10-10-10s-10 4.477-10 10v3.782h-31.345c-32.871 0-59.613 26.742-59.613 59.613v74.42c0 4.931 3.573 9.019 8.269 9.84v37.714c0 32.133 16.438 60.495 41.344 77.13v29.317h-49.611c-61.007 0-110.641 49.633-110.641 110.64v89.544c0 5.522 4.477 10 10 10h156.597c5.523 0 10-4.478 10-10s-4.477-10-10-10h-85v-60h20v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h92v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h20v60h-85c-5.523 0-10 4.478-10 10s4.477 10 10 10h156.596c5.523 0 10-4.478 10-10v-89.545c0-61.007-49.633-110.64-110.64-110.64zm-181.914-228.42c0-21.843 17.771-39.613 39.613-39.613h82.689c21.843 0 39.613 17.771 39.613 39.613v64.42h-161.915zm8.269 121.974v-37.554h145.378v37.554c0 40.081-32.608 72.689-72.689 72.689s-72.689-32.608-72.689-72.689zm72.689 92.69c10.997 0 21.55-1.929 31.345-5.46v25.786c0 17.283-14.061 31.345-31.345 31.345s-31.345-14.062-31.345-31.345v-25.786c9.795 3.53 20.348 5.46 31.345 5.46zm-140 123.941c-5.523 0-10 4.478-10 10v70h-41.596v-79.545c0-46.926 35.847-85.636 81.596-90.189v89.734zm74 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm20-28v-80.841c8.408 16.914 25.865 28.571 46 28.571s37.592-11.656 46-28.571v80.841zm136 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm101.596 52h-41.596v-70c0-5.522-4.477-10-10-10h-30v-89.734c45.749 4.553 81.596 43.263 81.596 90.189z"}})])])])]):(_vm.selectedPersonalInformation[352803] === 1)?_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M293.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S293.5 243.1 293.5 250z"}}),_c('path',{attrs:{"d":"M193.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S193.5 243.1 193.5 250z"}}),_c('path',{attrs:{"d":"M191 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C180.1 225.1 186.2 226.8 191 224z"}}),_c('path',{attrs:{"d":"M291 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C280.1 225.1 286.2 226.8 291 224z"}}),_c('path',{attrs:{"d":"M258 120.8l0.2 0c0.2 0 0.4 0 0.7 0 5.2 0 9.6-4.1 10-9.3 0.4-5.5-3.8-10.3-9.3-10.6 -0.2 0-0.4 0-0.6 0 -5.5-0.3-10.2 4-10.4 9.6C248.2 115.9 252.5 120.6 258 120.8z"}}),_c('path',{attrs:{"d":"M502 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10H502c5.5 0 10-4.5 10-10C512 496.5 507.5 492 502 492z"}}),_c('path',{attrs:{"d":"M10.2 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.2c5.5 0 10-4.5 10-10C20.2 496.5 15.8 492 10.2 492z"}}),_c('path',{attrs:{"d":"M473 492h-7.3c-3.3-70-41.4-133.5-101.7-169.8 12.1-18.1 19.8-39.3 21.5-62.2h0.4c22.1 0 40-17.9 40-40 0-18.6-12.8-34.3-30-38.7v-27.7c33-12.1 54.9-30.7 63.7-54.4 0 0 0 0 0 0 0.1-0.3 0.2-0.6 0.3-0.9 0 0 0 0 0 0 0.1-0.2 0.1-0.5 0.2-0.7 0-0.1 0-0.2 0.1-0.2 0-0.3 0.1-0.5 0.1-0.8 0-0.1 0-0.2 0-0.2 0-0.2 0-0.4 0-0.6 0-0.1 0-0.3 0-0.4 0-0.1 0-0.2 0-0.3 -0.1-1.4-0.5-2.8-1.2-4 -0.6-1.1-1.4-2.1-2.3-2.9 -0.1-0.1-0.2-0.2-0.4-0.3 -0.1-0.1-0.1-0.1-0.2-0.1 -0.2-0.1-0.4-0.3-0.6-0.4 0 0-0.1 0-0.1-0.1 -0.2-0.1-0.5-0.3-0.8-0.4 0 0-0.1 0-0.1-0.1 -0.3-0.1-0.5-0.2-0.8-0.3 0 0 0 0 0 0 -0.1-0.1-0.3-0.1-0.4-0.1 -0.2-0.1-0.3-0.1-0.5-0.2 -20.6-5.5-36-17.8-53.9-32.1C367.4 28.6 331.5 0 256 0c-31.9 0-61.4 10.8-85 28.8 -0.7 0.4-1.3 0.9-1.9 1.4 -11.9 9.4-22.2 20.7-30.5 33.4 -0.5 0.6-0.9 1.2-1.2 1.8 -13.6 21.6-21.5 47.1-21.5 74.5v41.3C98.8 185.7 86 201.4 86 220c0 22.1 17.9 40 40 40h0.4c1.7 22.9 9.4 44.1 21.5 62.2 -60.3 36.4-98.3 99.9-101.7 169.8h-7.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h16.9c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h109.5c0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0h109.5c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h16.9c5.5 0 10-4.5 10-10C483 496.5 478.6 492 473 492zM106 492H66.3c2.1-39.2 16.2-76.2 39.7-106.4V492zM170.1 56.3c4.8 19.5 16.5 48 56.7 59.6 0.9 0.3 1.9 0.4 2.8 0.4 4.3 0 8.3-2.9 9.6-7.2 1.5-5.3-1.5-10.8-6.8-12.4C196.3 86.3 191.1 60 187.6 42.6c-0.1-0.3-0.1-0.6-0.2-1C206.8 28 230.5 20 256 20c68.5 0 100.1 25.2 130.6 49.5 15.7 12.6 30.8 24.5 49.7 32 -11.4 17.7-35.2 31.6-68.4 39.7 -66.2 16.1-156.9 5.9-186.9-21 -6.6-6.5-18.3-18.2-23.9-47.9C160.9 66.6 165.3 61.2 170.1 56.3zM376 159.7v20.3c-8.2 0-14.8-5.4-19.7-16 5.6-1 11-2.1 16.3-3.4C373.7 160.3 374.9 160 376 159.7zM136 140c0-14.6 2.6-28.7 7.5-41.6 6.3 17 14.4 26.8 20.3 32.9 -2.4 24.2-11.8 48.7-27.8 48.7V140zM146 250c0-5.5-4.5-10-10-10h-10c-11 0-20-9-20-20 0-11 9-20 20-20h10c10.3 0 24.9-4.2 35.8-24.2 5.3-9.7 8.4-20.6 10.2-30.6 18.1 10.1 43.8 17.5 74.7 21.2 26.1 3.1 53.5 3.2 79.1 0.4 10.9 28.6 29.5 33.1 40.2 33.1h10c11 0 20 9 20 20 0 11-9 20-20 20h-10c-5.5 0-10 4.5-10 10 0 25.7-8.8 49.3-23.6 68 -0.3 0.2-0.5 0.5-0.7 0.8 0 0 0 0-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -0.2 0.2-0.3 0.4-0.5 0.6 0 0 0 0.1-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -9.8 11.9-22.1 21.6-36 28.5 -0.6 0.2-1.1 0.5-1.6 0.8 -14.3 6.8-30.3 10.7-47.2 10.7 -16.9 0-32.9-3.8-47.2-10.6 -0.5-0.3-1.1-0.6-1.6-0.8 -13.9-6.9-26.1-16.7-36-28.5 -0.1-0.1-0.1-0.2-0.2-0.3 0 0 0 0 0 0 -0.2-0.3-0.4-0.5-0.6-0.8 0 0 0 0 0 0 -0.2-0.2-0.4-0.4-0.6-0.6 -0.1-0.1-0.1-0.1-0.2-0.2C154.8 299.3 146 275.7 146 250zM291.5 375.1l-10.2 27.9 -10.4-23.9C278 378.3 284.8 377 291.5 375.1zM241.1 379.1l-10.4 23.9 -10.2-27.9C227.2 377 234 378.3 241.1 379.1zM126 492V363.7h0c9-8.5 18.9-16.1 29.6-22.8l15.4 77.7 -22.8 24.4c-1.9 2.1-2.9 4.9-2.6 7.7 0.3 2.8 1.7 5.4 4 7.1l45.9 34.2H126zM228.9 492l-58.4-43.6 18.6-20c2.2-2.4 3.1-5.6 2.5-8.8l-12.9-65.2c5.3 4 11 7.5 16.9 10.6l46.2 126.9H228.9zM256 472.7l-15.4-42.4 15.4-35.3 15.4 35.3L256 472.7zM283.1 492h-12.8l46.2-126.9c5.9-3.1 11.5-6.7 16.9-10.6l-12.9 65.2c-0.6 3.2 0.3 6.4 2.5 8.8l18.6 20L283.1 492zM386 492h-69.5l45.9-34.2c2.3-1.7 3.7-4.3 4-7.1 0.3-2.8-0.7-5.6-2.6-7.7l-22.8-24.4 15.4-77.7c10.7 6.7 20.6 14.3 29.6 22.8V492zM406 492V385.6c23.5 30.2 37.7 67.2 39.7 106.4H406z"}}),_c('path',{attrs:{"d":"M218.4 329.4c9.7 0 20.6-2.6 30.6-7.3 2.6-1.2 4.9-2.7 7-4.4 2 1.7 4.3 3.2 7 4.4 10 4.7 20.9 7.3 30.6 7.3 0 0 0 0 0 0 21.7 0 37.3-11.9 44.1-33.6 1.2-4-0.1-8.3-3.4-10.9 -3.3-2.6-7.8-2.8-11.3-0.7 -0.1 0-5.6 3.2-13.1 3.2 0 0 0 0 0 0 -6.8 0-13.2-2.7-18.9-7.9 -7.5-6.9-14.8-8.4-19.5-8.4 -5.8 0-11.2 2.1-15.5 5.7 -4.3-3.6-9.7-5.7-15.5-5.7 -4.7 0-12 1.5-19.5 8.4 -5.7 5.3-12.1 7.9-18.9 7.9 -7.5 0-13.1-3.2-13.1-3.2 -3.5-2.2-8-2-11.3 0.6 -3.3 2.6-4.6 7-3.4 11C181.1 317.4 196.8 329.4 218.4 329.4zM266.6 296c0.5-2.4 2.5-5 4.9-5 1.7 0 3.8 1.1 6 3.1 8.1 7.5 17.6 11.9 27.6 12.9 -3.3 1.5-7.2 2.3-11.5 2.3 -6.9 0-14.7-1.9-22.1-5.4C267.5 302.1 265.8 299.4 266.6 296zM234.5 294.2c2.2-2 4.3-3.1 6-3.1 2.5 0 4.4 2.6 4.9 5 0.8 3.4-0.9 6.1-4.9 8 -7.4 3.5-15.3 5.4-22.1 5.4 -4.4 0-8.2-0.8-11.5-2.3C216.9 306 226.4 301.6 234.5 294.2z"}})])]):_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352801] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en ung fagmand")]):(_vm.selectedPersonalInformation[352803] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en erfaren fagmand")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Erfaringsniveau har ingen betydning")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.itemSelect.CONTRACT_TYPE === 'Fagentreprise')?_c('svg',{attrs:{"id":"Fagenterprise","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"51.727","height":"45.283","viewBox":"0 0 51.727 45.283"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1376","data-name":"Rectangle 1376","width":"45.726","height":"39.283","transform":"translate(0 0)","fill":"#003645"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Fagenterprise","transform":"translate(0 0)"}},[_c('g',{attrs:{"id":"Group_7612","data-name":"Group 7612","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4521","data-name":"Path 4521","d":"M.71,37.872l-.156-.06A.834.834,0,0,1,0,37.022a3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327.005l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137V37.35a.3.3,0,0,0,.011.052h.9V33.868c0-.1,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.1.428-.194.643-.289l.149-.065a5.159,5.159,0,0,1-1.424-4.245H1.755a.855.855,0,0,1-.93-.771.977.977,0,0,1,0-.153A1.8,1.8,0,0,1,.849,27.3a.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.233.233,0,1,1,.371.281c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248h8.084a4,4,0,0,0-2.663-3.157c-.1.412-.207.82-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139A3.943,3.943,0,0,0,3.718,24c-.034.023-.065.05-.1.071a.232.232,0,0,1-.323-.051l0,0a.224.224,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28A6.377,6.377,0,0,1,9.9,31a3.955,3.955,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.749,3.749,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062Zm8.952-9.221H8.785c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.758a.358.358,0,0,0,.388-.316,2.561,2.561,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.334,1.334,0,0,0-.2-.01H1.8a1.619,1.619,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5H7.48a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.028,1.028,0,0,1-.184.01H2.549a.629.629,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.6-1.775,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.387.387,0,0,0-.4.049,3.211,3.211,0,0,1-3.8.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.983.983,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H3.268v1.1H8.956v-1.1H5.719c-.2,0-.3-.079-.3-.227s.1-.232.3-.232H8.966M6.115,25.026c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506M9.445,37.4h.892a.464.464,0,0,0,.011-.065V34.349c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.395.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16ZM1.389,34.679a3.363,3.363,0,0,0-.923,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4522","data-name":"Path 4522","d":"M20.423,45.283l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327,0l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137v3.007a.3.3,0,0,0,.011.052h.9V41.28c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065a5.159,5.159,0,0,1-1.424-4.245H21.47a.856.856,0,0,1-.93-.923,1.8,1.8,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.238.238,0,0,1,.329-.048.235.235,0,0,1,.042.329c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248H29.86A4,4,0,0,0,27.2,30.891c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.943,3.943,0,0,0-1.01.524c-.034.023-.065.05-.1.071a.232.232,0,0,1-.323-.051l0,0a.224.224,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28a6.377,6.377,0,0,1-.246,2.06,3.956,3.956,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.748,3.748,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062Zm8.952-9.221H28.5c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.752a.358.358,0,0,0,.388-.316,2.561,2.561,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.333,1.333,0,0,0-.2-.01H21.513a1.618,1.618,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5h5.688a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.028,1.028,0,0,1-.184.01h-4.92a.63.63,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.592-1.779,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.387.387,0,0,0-.405.049,3.211,3.211,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.983.983,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H22.981v1.1h5.688v-1.1H25.432c-.2,0-.3-.079-.3-.227s.1-.232.3-.232h3.254M25.83,32.439c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.464.464,0,0,0,.011-.065V41.762c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.4.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16ZM21.1,42.092a3.362,3.362,0,0,0-.924,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4523","data-name":"Path 4523","d":"M40.193,38.219l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327.005l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137V37.7a.3.3,0,0,0,.011.052h.9V34.217c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065A5.159,5.159,0,0,1,41.553,29H41.24a.856.856,0,0,1-.93-.923,1.8,1.8,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.233.233,0,1,1,.371.281c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248H49.63a4,4,0,0,0-2.663-3.157c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.943,3.943,0,0,0-1.01.524c-.034.023-.065.05-.1.07a.232.232,0,0,1-.323-.051l0,0a.225.225,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28a6.374,6.374,0,0,1-.246,2.06,3.955,3.955,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.749,3.749,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062ZM49.145,29h-.877c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.752a.358.358,0,0,0,.388-.316,2.56,2.56,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.333,1.333,0,0,0-.2-.01H41.278a1.618,1.618,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5H46.96a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.033,1.033,0,0,1-.184.01H42.028a.629.629,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.592-1.779,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2V34.3c0-.461,0-.455-.44-.621a.387.387,0,0,0-.405.049,3.211,3.211,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.982.982,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H42.736v1.1h5.688v-1.1H45.193c-.2,0-.3-.079-.3-.227s.1-.232.295-.232h3.254M45.593,25.373c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.464.464,0,0,0,.011-.065V34.7c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.4.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16Zm-9.442-2.726a3.363,3.363,0,0,0-.923,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4524","data-name":"Path 4524","d":"M27.134,26.865a.811.811,0,0,1-.465-.856c.016-.259,0-.521,0-.813H13.642a1.117,1.117,0,0,1-1.216-.855,2,2,0,0,1-.026-.572c.043-.7.1-1.395.149-2.092a.4.4,0,0,1,.4-.4.387.387,0,0,1,.387.387.419.419,0,0,1,0,.05c-.037.7-.079,1.4-.136,2.092-.04.493.042.6.526.6h2.763V22.279c0-.3.162-.479.407-.471s.379.175.381.468v2.112c.094.007.169.018.245.018H20.09a.289.289,0,0,0,.328-.212q.629-1.621,1.281-3.234a.306.306,0,0,0-.049-.354c-.334-.415-.655-.84-1-1.284-.153.11-.3.217-.445.319a.638.638,0,0,1-1.051-.423c-.182-.978-.347-1.958-.52-2.937-.01-.059-.027-.117-.049-.207-.466.1-.922.2-1.378.3l-2.322.522a1.558,1.558,0,0,0-1.305,1.44c-.047.452-.065.906-.1,1.359a3.412,3.412,0,0,1-.043.391.361.361,0,0,1-.394.323l-.015,0a.346.346,0,0,1-.365-.326.308.308,0,0,1,0-.043,13.6,13.6,0,0,1,.233-2.287,2.224,2.224,0,0,1,1.835-1.637q1.888-.423,3.777-.845a1.93,1.93,0,0,0,.867-.645c.132-.126.011-.606-.135-.73a4.761,4.761,0,0,1-1.721-3.164c-.008-.069-.024-.138-.038-.217-.15-.035-.3-.062-.451-.107a1.855,1.855,0,0,1-.865-2.974.52.52,0,0,0,.108-.34c-.063-.7-.151-1.406-.22-2.11-.03-.3.11-.5.35-.517s.409.168.44.476c.064.633.14,1.265.211,1.9.433-.041.406.056.484-.43a4.749,4.749,0,0,1,2.255-3.4.683.683,0,0,1,.846.071,10.238,10.238,0,0,0,3.634,1.754,16.336,16.336,0,0,0,1.7.312c.533.076.693.189.831.713a5.192,5.192,0,0,1,.113.538c.062.4.059.4.479.445a13.327,13.327,0,0,0,.173-2.757A3.82,3.82,0,0,0,24.22.851a27.151,27.151,0,0,0-3.952,0,3.646,3.646,0,0,0-3.115,2.323c-.033.071-.058.146-.093.217a.383.383,0,0,1-.483.246l-.027-.01a.389.389,0,0,1-.238-.5c0-.014.011-.027.017-.04A4.654,4.654,0,0,1,19.053.319,4.533,4.533,0,0,1,20.791,0c1,.007,1.994,0,2.99,0a4.7,4.7,0,0,1,4.564,3.938,8.562,8.562,0,0,1-.084,2.3c-.035.312-.084.623-.11.936a.354.354,0,0,0,.092.223,1.844,1.844,0,0,1-1.08,3.07.251.251,0,0,0-.239.262v0a4.72,4.72,0,0,1-1.671,3.13.7.7,0,0,0-.022.919,1.95,1.95,0,0,0,1.079.573c1.1.223,2.193.5,3.292.734A.462.462,0,0,0,29.945,16c.631-.526,1.251-1.066,1.871-1.6a1.612,1.612,0,0,1,2.28-.021l.01.01c.191.162.381.325.609.52.007-.149.01-.249.016-.349a.634.634,0,0,1,.629-.639h0c.454-.013.91-.014,1.364,0a.643.643,0,0,1,.636.65c0,.014,0,.029,0,.043,0,.787.007,1.574,0,2.361a.431.431,0,0,0,.175.377c.278.226.537.476.818.7a2.35,2.35,0,0,1,.9,1.213v.63a1.4,1.4,0,0,0-.062.137A1.586,1.586,0,0,1,37.6,21.157h-.243c0,.272.01.516,0,.759a.392.392,0,0,1-.784-.01,2.457,2.457,0,0,1,0-.5,1.1,1.1,0,0,0-.488-1.107c-1.054-.862-2.071-1.771-3.106-2.664a.935.935,0,0,0-.1.063c-1.132.976-2.265,1.951-3.391,2.936a.432.432,0,0,0-.109.3c-.008.962,0,1.924,0,2.885v.575h1.59V21.43a.761.761,0,0,1,.656-.853.774.774,0,0,1,.2,0h2.256c.593,0,.869.271.87.86V24.39h1.613v-.646c0-.346.149-.538.4-.53s.387.2.389.523v.673c.279,0,.531.015.781,0a1,1,0,0,1,1.111.68V26.4l-.42.472ZM20.159,3.713A3.843,3.843,0,0,0,18.325,6.7c-.075,1.088-.039,2.184-.044,3.277a4.876,4.876,0,0,0,.049.81,3.928,3.928,0,0,0,7.805-.21c.056-1.169.034-2.342.029-3.514a8.868,8.868,0,0,0-.1-.882c-.019-.188-.133-.227-.3-.256-.609-.109-1.223-.2-1.82-.358A11.2,11.2,0,0,1,20.156,3.71M27.178,24.4V22.274c0-.306.155-.48.4-.473s.385.186.387.468v2.117h.588V21.148H28.2a1.574,1.574,0,0,1-1.49-1.277,1.59,1.59,0,0,1,.592-1.584c.568-.487,1.133-.977,1.742-1.5l-3.181-.719c-.021.1-.037.154-.047.213-.173.979-.34,1.959-.52,2.937a.64.64,0,0,1-1.069.415l-.43-.306c-.357.46-.7.9-1.037,1.347a.287.287,0,0,0-.027.234q.658,1.68,1.337,3.354a.252.252,0,0,0,.179.138c.961.009,1.922.006,2.926.006m.244-4.881.064.039a.764.764,0,0,0,.562.762.87.87,0,0,0,.88-.265q1.825-1.583,3.652-3.161c.335-.289.452-.283.787.006q1.875,1.62,3.754,3.236a.8.8,0,0,0,1.153-1.109.811.811,0,0,0-.093-.083q-2.326-2.021-4.666-4.026a.787.787,0,0,0-1.1,0q-2.327,2-4.64,4.015a2.315,2.315,0,0,0-.356.574M38.463,26.06v-.513c0-.355,0-.355-.361-.355H27.823a.632.632,0,0,0-.208.008c-.053.02-.124.083-.127.129-.013.24-.006.481-.006.73ZM34.14,21.368H31.788v3.018h2.356ZM20.2,14.569c.623.858,1.328,1.648,2.014,2.477.672-.778,1.324-1.529,1.97-2.285a1.034,1.034,0,0,0,.1-.263,5.029,5.029,0,0,1-4.085.071m4.484.835L22.8,17.592l1.755,1.289c.167-.957.328-1.865.482-2.773.073-.429.054-.454-.352-.7m-3.05,2.187-1.865-2.2c-.425.322-.429.323-.347.8.1.549.2,1.1.294,1.646.06.336.118.673.183,1.047L21.633,17.6m.59,4.192-1.033,2.6h2.066l-1.034-2.6m-.009-3.631-.929.69.939,1.21.934-1.207-.943-.694M17.473,7.623a1,1,0,0,0-.944,1.05.977.977,0,0,0,.944.984Zm9.512,2.045a1.027,1.027,0,0,0,0-2.047Zm8.559,5.057c-.063.526-.085,1.006.458,1.3a3.709,3.709,0,0,1,.553.463V14.725Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4525","data-name":"Path 4525","d":"M38.834,26.864l.42-.472v.472Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4526","data-name":"Path 4526","d":"M22.2,12.415c-.356-.086-.714-.156-1.061-.262a.374.374,0,0,1-.274-.452.423.423,0,0,1,.485-.314.373.373,0,0,1,.056.02,2.347,2.347,0,0,0,1.635,0,.387.387,0,0,1,.515.185.364.364,0,0,1,.026.072.379.379,0,0,1-.3.494c-.349.1-.709.165-1.081.249","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4527","data-name":"Path 4527","d":"M24.669,8.476c0,.1.007.21,0,.314a.39.39,0,0,1-.779.012,4.388,4.388,0,0,1,0-.628.381.381,0,0,1,.4-.366h.005a.374.374,0,0,1,.382.366v.014c.007.1,0,.192,0,.288","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4528","data-name":"Path 4528","d":"M19.788,8.482c0-.1-.007-.21,0-.314a.39.39,0,0,1,.775-.026,2.856,2.856,0,0,1,0,.679.39.39,0,0,1-.775-.028c-.007-.1,0-.209,0-.314","fill":"#003645"}})])])]):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"49.487","height":"48.776","viewBox":"0 0 49.487 48.776"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1375","data-name":"Rectangle 1375","width":"49.487","height":"48.776","transform":"translate(0 0.003)","fill":"#003645"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Hovedentreprenør","transform":"translate(0 -0.003)"}},[_c('g',{attrs:{"id":"Group_7610","data-name":"Group 7610","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4517","data-name":"Path 4517","d":"M.68,41.689l-.149-.058A.8.8,0,0,1,0,40.876a3.635,3.635,0,0,1,1.591-3.048.221.221,0,0,1,.313.005l.014.016c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131V41.19a.278.278,0,0,0,.011.05h.858V37.859c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062a4.936,4.936,0,0,1-1.362-4.061h-.3a.818.818,0,0,1-.89-.737.9.9,0,0,1,0-.147,1.751,1.751,0,0,1,.023-.409.767.767,0,0,1,.587-.595.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194H9.7a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.194,1.194,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.74,3.74,0,0,0-.966.5.916.916,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.214.214,0,0,1,.045-.3l.015-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092A4.363,4.363,0,0,1,9.974,30.17a5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793H9.7v.268A6.137,6.137,0,0,1,9.468,35.1a3.786,3.786,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06Zm8.564-8.822H8.409c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.216,1.216,0,0,0-.191-.009H1.722a1.472,1.472,0,0,0-.176.007.345.345,0,0,0-.308.321c0,.068,0,.137,0,.2,0,.372.11.482.479.482H7.156a.789.789,0,0,1,.175.011.219.219,0,0,1-.011.431,1.033,1.033,0,0,1-.176.009H2.439a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157A3.768,3.768,0,0,0,4.294,37.1a2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.084m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.367.367,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.195v1.967a.883.883,0,0,0,.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051H8.568V40.191h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222H8.578M5.851,29.4c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484M9.032,41.242H9.89A.423.423,0,0,0,9.9,41.18V38.318c0-.036-.009-.09-.034-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394V40.83a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153ZM1.325,38.634A3.22,3.22,0,0,0,.445,40.9a.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4518","data-name":"Path 4518","d":"M19.54,48.78l-.149-.058a.8.8,0,0,1-.531-.755,3.635,3.635,0,0,1,1.591-3.048.222.222,0,0,1,.313,0l.014.017c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131v2.877a.278.278,0,0,0,.011.05h.858V44.95c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062a4.936,4.936,0,0,1-1.362-4.061h-.3a.817.817,0,0,1-.889-.737.8.8,0,0,1,0-.147,1.751,1.751,0,0,1,.023-.409.767.767,0,0,1,.587-.6.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194h7.734a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.952.952,0,0,1-.913.754,1.2,1.2,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.756,3.756,0,0,0-.966.5,1.087,1.087,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.213.213,0,0,1,.046-.3l.014-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092a4.363,4.363,0,0,1,2.639,2.683,5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.777.777,0,0,1,.6.669,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793h-.368v.268a6.137,6.137,0,0,1-.236,1.971,3.786,3.786,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06ZM28.1,39.958h-.839c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.35,1.35,0,0,0-.191-.01H20.577a1.471,1.471,0,0,0-.176.008.345.345,0,0,0-.308.321c-.005.068,0,.137,0,.2,0,.372.11.482.479.482h5.442a.789.789,0,0,1,.175.011.219.219,0,0,1-.011.431,1.033,1.033,0,0,1-.176.009H21.3a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157a3.768,3.768,0,0,0,1.821,2.974,2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.367.367,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.195v1.967a.883.883,0,0,0,.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441V47.286h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113M24.7,36.494c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.423.423,0,0,0,.011-.062V45.414c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394v-.018a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153ZM20.172,45.73a3.22,3.22,0,0,0-.884,2.263.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4519","data-name":"Path 4519","d":"M38.451,42.023l-.149-.058a.8.8,0,0,1-.531-.755,3.635,3.635,0,0,1,1.591-3.048.222.222,0,0,1,.313,0l.014.017c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131v2.877a.279.279,0,0,0,.011.05h.858V38.193c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062A4.936,4.936,0,0,1,39.75,33.2h-.3a.817.817,0,0,1-.889-.737.8.8,0,0,1,0-.147,1.75,1.75,0,0,1,.023-.409.767.767,0,0,1,.587-.6.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194h7.731a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.194,1.194,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.74,3.74,0,0,0-.966.5.916.916,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.214.214,0,0,1,.045-.3l.015-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.89.89,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092A4.363,4.363,0,0,1,47.747,30.5a5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793h-.368v.268a6.137,6.137,0,0,1-.236,1.971A3.786,3.786,0,0,1,46.2,37.169c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06ZM47.015,33.2h-.838c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.216,1.216,0,0,0-.191-.009H39.493a1.471,1.471,0,0,0-.176.007.345.345,0,0,0-.308.321c0,.068,0,.137,0,.2,0,.372.11.482.479.482H44.93a.789.789,0,0,1,.175.011.218.218,0,0,1-.01.43,1.033,1.033,0,0,1-.176.009H40.213a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157a3.771,3.771,0,0,0,1.821,2.974,2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.369.369,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.2V39.95a.883.883,0,0,0,.008.139H42c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441V40.523h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113M43.612,29.731c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.423.423,0,0,0,.011-.062V38.651c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394v-.018a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153Zm-9.033-2.608A3.22,3.22,0,0,0,38.2,41.23a.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4520","data-name":"Path 4520","d":"M33.364,29.552v-.865h1.543a.92.92,0,0,0,1.056-.76.931.931,0,0,0,0-.3v-.776c-.1-.006-.195-.013-.286-.015a1.289,1.289,0,0,1-1.27-1.275q-.012-2.221,0-4.443a1.279,1.279,0,0,1,1.172-1.275c.114-.012.228-.017.362-.027V18.73a3.1,3.1,0,0,1-1.586.2H14.674c-.4,0-.791-.071-1.2-.111v.964a3.74,3.74,0,0,1,.507.041,1.3,1.3,0,0,1,1.027,1.29q.006,2.15,0,4.3A1.3,1.3,0,0,1,13.8,26.8c-.043,0-.085,0-.128,0-.065,0-.13.011-.215.019,0,.377-.027.742.007,1.1a.861.861,0,0,0,.841.766c.1.006.192,0,.289,0H30.767v.865h-16.8a4.756,4.756,0,0,1-.59-.281,1.64,1.64,0,0,1-.792-1.421c-.007-.336,0-.672,0-1.019a7.007,7.007,0,0,1-.776-.1,2.133,2.133,0,0,1-1.646-2.1V22.064a2.157,2.157,0,0,1,2.049-2.26c.063,0,.127,0,.19,0a1.584,1.584,0,0,0,.184-.009V17.2a1.716,1.716,0,0,1,1.7-1.729H14.3c.827-.006,1.654,0,2.482,0,.028,0,.056.006.117.013v2.564h3.62V15.564a.318.318,0,0,0-.1-.2,6.182,6.182,0,0,1-1.846-3.912c-.219-.025-.439-.037-.652-.078A1.256,1.256,0,0,1,16.838,10.2a7.655,7.655,0,0,1,.011-1.123,1.115,1.115,0,0,1,.6-.931.428.428,0,0,0,.242-.456,7.6,7.6,0,0,1,.387-2.924c.186-.49.427-.959.664-1.485l.777.51a6.4,6.4,0,0,0-.924,4.119h3.038V7.522a1.271,1.271,0,0,1,1.23-1.31h.058q1.79-.031,3.578,0A1.272,1.272,0,0,1,27.78,7.472c0,.019,0,.039,0,.058v.386H30.8c.541-2.656-1.677-6.168-3.879-6.106V4.549h-.879V1.4c0-.357-.153-.521-.5-.525q-.837-.011-1.674,0a.437.437,0,0,0-.492.376.429.429,0,0,0,0,.124V4.54h-.867V1.778A4.214,4.214,0,0,0,20,3.161l-.648-.575a4.806,4.806,0,0,1,1.746-1.3A8.385,8.385,0,0,1,22.307.924a.5.5,0,0,0,.37-.262A1.211,1.211,0,0,1,23.784,0C24.39,0,25,0,25.6,0a1.3,1.3,0,0,1,1.162.676.469.469,0,0,0,.263.212,5.53,5.53,0,0,1,4.306,3.862,7.67,7.67,0,0,1,.388,2.953.409.409,0,0,0,.235.432,1.122,1.122,0,0,1,.6.927,7.246,7.246,0,0,1,.014,1.122,1.321,1.321,0,0,1-1.329,1.228c-.124.009-.249,0-.375,0-.084.414-.14.811-.246,1.2a6.1,6.1,0,0,1-1.543,2.665c-.077.079-.18.182-.182.275-.014.825-.008,1.651-.008,2.5H32.48v-2.56c.1-.009.177-.022.25-.022.789,0,1.578,0,2.367,0a1.718,1.718,0,0,1,1.724,1.712v.009c.005.847,0,1.693,0,2.539a.289.289,0,0,0,.016.066,7.186,7.186,0,0,1,.786.113,2.134,2.134,0,0,1,1.616,2.066c.007.875,0,1.75,0,2.626a2.162,2.162,0,0,1-2.088,2.233c-.041,0-.083,0-.124,0a2.263,2.263,0,0,0-.229.01c.131,1.193,0,2.276-1.366,2.7Zm-3.424-18.1a42.957,42.957,0,0,1-10.459.006,5.251,5.251,0,0,0,10.459-.006m-5.2-2.634H18.22c-.37,0-.5.135-.511.5v.519c0,.57.086.665.65.715.1.008.192.008.288.014,1.342.089,2.683.182,4.026.267a21.269,21.269,0,0,0,2.243.112c1.708-.074,3.413-.211,5.119-.325.422-.028.843-.057,1.264-.1a.413.413,0,0,0,.4-.424.314.314,0,0,0,0-.044V9.423c0-.483-.111-.593-.59-.593h-6.37M14.138,21.8c0-.241.005-.433,0-.624a.461.461,0,0,0-.4-.512.473.473,0,0,0-.119,0c-.413-.005-.827-.006-1.24,0a1.3,1.3,0,0,0-1.336,1.262c0,.013,0,.025,0,.038q-.029,1.341,0,2.683a1.275,1.275,0,0,0,1.207,1.271c.481.014.962,0,1.442,0a.408.408,0,0,0,.441-.373v-.027a6.675,6.675,0,0,0,0-.693H13.3v-.881h.842V22.673h-.848V21.8Zm21.135,3.03v.623a.461.461,0,0,0,.4.515.526.526,0,0,0,.119,0c.423.006.847.01,1.269,0a1.291,1.291,0,0,0,1.312-1.27v-.025q.03-1.341,0-2.682a1.277,1.277,0,0,0-1.274-1.28l-.073,0h-1.3a.406.406,0,0,0-.443.367c0,.011,0,.022,0,.033a6.711,6.711,0,0,0,0,.695h.837v.883h-.824v1.274h.829v.871Zm-13.85-6.781h6.566V16.18a6.2,6.2,0,0,1-6.566,0Zm-5.4.017V16.342c-.6,0-1.173-.018-1.747.006a.867.867,0,0,0-.83.87.881.881,0,0,0,.881.85c.557.009,1.114,0,1.7,0m17.349,0c.61,0,1.2.017,1.78-.006a.867.867,0,0,0,.8-.835.847.847,0,0,0-.763-.868c-.6-.038-1.2-.009-1.82-.009ZM26.907,7.924c0-.164.009-.3,0-.43a.386.386,0,0,0-.371-.4H26.5q-1.788-.007-3.576,0a.387.387,0,0,0-.408.363v.037c-.012.139,0,.281,0,.433Z","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1372","data-name":"Rectangle 1372","width":"0.866","height":"0.845","transform":"translate(31.632 28.707)","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1373","data-name":"Rectangle 1373","width":"0.826","height":"0.832","transform":"translate(30.789 19.82)","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1374","data-name":"Rectangle 1374","width":"0.826","height":"0.832","transform":"translate(32.515 19.815)","fill":"#003645"}})])])]),_vm._v(" "),(_vm.itemSelect.CONTRACT_TYPE === 'Fagentreprise')?_c('p',{staticClass:"p0 m0 font12"},[_vm._v("Fagentreprise")]):_c('p',{staticClass:"p0 m0 font12"},[_vm._v("Hovedentreprise")])])])])],1),_vm._v(" "),_c('div',{staticClass:"mx2",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[(_vm.itemSelect.type === 'marketjobs')?_c('button',{staticClass:"col-12 action-button no-border py2 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":Number(_vm.itemSelect.TOTAL_OFFERS) >= Number(_vm.itemSelect.MAXIMUM_OFFER)},on:{"click":function($event){return _vm.savereserve()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])]),_vm._v(" "),(_vm.showMobile)?_c('b-modal',{ref:"itemModal",attrs:{"lazy":""},model:{value:(_vm.itemShow),callback:function ($$v) {_vm.itemShow=$$v},expression:"itemShow"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"relative"},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"data-key":_vm.itemSelect.id + 'd',"src":_vm.itemSelect.image,"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.id + 'd')}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.mailingzip)+" "+_vm._s(_vm.itemSelect.mailingcity))]),_vm._v(" "),(_vm.itemSelect.match != '')?_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.match))]),_vm._v(" %")]):_vm._e()])]),_vm._v(" "),(_vm.itemSelect.gratis1 === '1')?_c('div',{staticClass:"col-12 white-background mintgreen p2 line-height-1 gibson semi-bold h6 flex items-center"},[_vm._v("\n          Gratis møde\n        ")]):_vm._e()]}),_vm._v(" "),_c('div',{staticClass:"modal-body-marketplace"},[_c('div',{staticClass:"clearfix px2"},[_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('p',{staticClass:"h3 darkblue gibson regular mb1 p0 line-height-2"},[_vm._v("\n              "+_vm._s(_vm.itemSelect.producttitle)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(_vm.itemSelect.henttilbud !== 1)?_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud === 1)?_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(_vm.itemSelect.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()])]),_vm._v(" "),(_vm.step ===1)?_c('div',[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.comments",modifiers:{"comments":true}}],staticClass:"col-12 outlined-dark-button p2 gibson h5 not-rounded flex justify-between items-center"},[_c('span',[_vm._v("Se beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details",modifiers:{"details":true}}],staticClass:"col-12 outlined-dark-button p2 gibson h5 not-rounded flex justify-between items-center"},[_c('span',[_vm._v("Se detaljer")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-collapse',{attrs:{"id":"details"}},[_c('div',{staticClass:"clearfix flex flex-column mb3 px2"},[_c('div',[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1"},[_vm._v("Opgavens detaljer")])]),_vm._v(" "),_c('div',_vm._l((_vm.itemSelect.product),function(item){return _c('b-row',{key:item.productid,staticClass:"my1 pb2"},[_c('b-col',{staticClass:"regular h5 gibson",attrs:{"cols":"9"}},[_vm._v(_vm._s(item.productname))]),_vm._v(" "),_c('b-col',{staticClass:"semi-bold h5 gibson"},[_vm._v(_vm._s(item.quantity))])],1)}),1)])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"comments"}},[(_vm.itemSelect.henttilbud === 1)?_c('div',{staticClass:"clearfix flex flex-column mb3 px2"},[_c('div',[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1"},[_vm._v("Kommentar")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n                    "+_vm._s(_vm.itemSelect.comment_to_partner)+"\n                  ")])])]):_c('div',{staticClass:"clearfix flex flex-column mb3"},[_c('div',[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1"},[_vm._v("Note")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n                    "+_vm._s(_vm.itemSelect.comment_to_partner)+"\n                  ")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-center py3"},[_c('p',{staticClass:"h4 semi-bold primarycolor gibson line-height-1"},[_vm._v("\n                Vigtig info om kunden og opgaven\n              ")])])]),_vm._v(" "),(_vm.itemSelect.mester !== '1')?_c('div',{staticClass:"clearfix flex flex-wrap my3"},[_c('div',{staticClass:"col col-6 gibson py1 border-right mediumgrey-border border-bottom",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center"},[[(_vm.itemSelect.other352787 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M478.2 194l15-15c4.3-4.3 6.7-10.1 6.7-16.2s-2.4-11.9-6.7-16.2l-17.2-17.2c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-15 15c-19.8-13.6-42.3-23.7-66.4-29.1V93.1h9.1c12.4 0 22.4-10.1 22.4-22.4V39.5c0-12.4-10.1-22.4-22.4-22.4H268.1c-12.4 0-22.4 10.1-22.4 22.4v31.2c0 12.4 10.1 22.4 22.4 22.4h9.1v22.2c-24.1 5.5-46.4 15.5-66.1 29.1l-15-15c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-17.2 17.2c-8.9 9-8.9 23.5 0 32.5l2.7 2.7H78.2c-5.5 0-10 4.5-10 10s4.5 10 10 10h78.2c-7.5 12-13.6 24.9-18.3 38.4H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h122.4c-2.8 12.4-4.4 25.3-4.7 38.4H64c-5.5 0-10 4.5-10 10s4.5 10 10 10h64.2c1.1 13.2 3.5 26.1 7.1 38.4H50c-5.5 0-10 4.5-10 10s4.5 10 10 10h92.5c29.1 69.2 97.6 118 177.3 118 106 0 192.2-86.2 192.2-192.2C512 262.4 499.5 224.9 478.2 194zM457.7 143.5c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l17.2 17.2c0.7 0.7 0.9 1.5 0.9 2.1s-0.1 1.4-0.9 2.1l-13.1 13.1c-6.6-7.7-13.7-14.8-21.4-21.4L457.7 143.5zM265.6 70.6V39.5c0-1.3 1.1-2.4 2.4-2.4h103.2c1.3 0 2.4 1.1 2.4 2.4v31.2c0 1.3-1.1 2.4-2.4 2.4h-19.1 -64.9 -19.1C266.7 73.1 265.6 72 265.6 70.6zM297.2 93.1h44.9v18.8c-7.3-0.9-14.8-1.3-22.3-1.3 -7.6 0-15.2 0.5-22.6 1.3V93.1zM160.5 160.7l17.2-17.2c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l13.1 13.1c-7.7 6.6-14.8 13.7-21.4 21.4l-13.1-13.1C159.4 163.7 159.4 161.8 160.5 160.7zM319.8 474.9c-95 0-172.2-77.3-172.2-172.2s77.3-172.2 172.2-172.2 172.2 77.3 172.2 172.2S414.7 474.9 319.8 474.9z"}}),_c('path',{attrs:{"d":"M385.8 222.6l-47.3 47.3c-5.5-3.2-11.9-5-18.7-5 -20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9c0-6.8-1.8-13.2-5-18.7l47.3-47.3c3.9-3.9 3.9-10.2 0-14.1C396 218.7 389.7 218.7 385.8 222.6zM319.8 320.6c-9.8 0-17.9-8-17.9-17.9s8-17.9 17.9-17.9 17.9 8 17.9 17.9S329.6 320.6 319.8 320.6z"}}),_c('path',{attrs:{"d":"M319.8 173.1c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1 -1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9 -2.9 4.4-2.9 7.1c0 2.6 1.1 5.2 2.9 7.1S317.2 173.1 319.8 173.1z"}}),_c('path',{attrs:{"d":"M319.8 432.4c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1s-1.1-5.2-2.9-7.1C325 433.5 322.4 432.4 319.8 432.4z"}}),_c('path',{attrs:{"d":"M221 194c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 195.1 223.7 194 221 194z"}}),_c('path',{attrs:{"d":"M418.5 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C423.8 392.6 421.2 391.5 418.5 391.5z"}}),_c('path',{attrs:{"d":"M221 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1s4.4 2.9 7.1 2.9 5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 392.6 223.7 391.5 221 391.5z"}}),_c('path',{attrs:{"d":"M180.1 292.7c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C185.4 293.8 182.8 292.7 180.1 292.7z"}}),_c('path',{attrs:{"d":"M466.5 295.7c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9 2.9-4.4 2.9-7.1C469.4 300.1 468.4 297.5 466.5 295.7z"}}),_c('path',{attrs:{"d":"M10 357c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C15.2 358 12.6 357 10 357z"}}),_c('path',{attrs:{"d":"M456.5 272.4c5.3-1.6 8.3-7.1 6.7-12.4 -7.1-23.7-20.1-45.6-37.7-63.1 -17.6-17.6-39.5-30.6-63.2-37.6 -5.3-1.6-10.9 1.5-12.4 6.8s1.5 10.9 6.8 12.4c42.2 12.5 74.9 45.1 87.5 87.3 1.3 4.3 5.3 7.1 9.6 7.1C454.6 272.8 455.5 272.7 456.5 272.4z"}})])]),_vm._v(" "),_c('p',{attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Opgaven haster! Skal laves inden for 1 mdr.")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352788 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","height":"40","width":"40","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_c('p',{attrs:{"classs":"h6 darkblue gibson center mb0"}},[_vm._v("Der er god tid"),_c('br'),_vm._v(" til at løse opgaven")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352789 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"40","height":"40"}},[_c('path',{attrs:{"d":"M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"}}),_c('path',{attrs:{"d":"M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"}}),_c('path',{attrs:{"d":"M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"}}),_c('path',{attrs:{"d":"M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"}})])]),_vm._v(" "),_c('p',{attrs:{"classs":"h6 darkblue gibson center mb0"}},[_vm._v("Meget tid!")])]):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py1 border-bottom mediumgrey-border",staticStyle:{"height":"140px"}},[[(_vm.itemSelect.other352785 !== '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[_c('span',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{attrs:{"classs":"h6 darkblue gibson center mb0 block"}},[_vm._v("Garantiordning er"),_c('br'),_vm._v(" ikke et krav")])]):(_vm.itemSelect.other352785 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Skal være medlem"),_c('br'),_vm._v("af Garantiordning")])]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py1 border-right mediumgrey-border",staticStyle:{"height":"140px"}},[[(_vm.itemSelect.other352795 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","viewBox":"0 0 512 512.0005","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m400 268.410156v-65.335937l4.074219 3c2.136719 1.570312 4.816406 2.230469 7.4375 1.828125 2.625-.402344 4.980469-1.832032 6.550781-3.972656l23.59375-32.1875c3.261719-4.449219 2.304688-10.699219-2.136719-13.96875l-211.796875-155.828126c-3.523437-2.59375-8.328125-2.59375-11.851562 0l-73.683594 54.214844c-4.449219 3.269532-5.402344 9.53125-2.128906 13.980469 3.273437 4.445313 9.535156 5.398437 13.980468 2.125l67.757813-49.851563 197.828125 145.554688-11.769531 16.058594-180.132813-132.535156c-3.523437-2.59375-8.328125-2.59375-11.851562 0l-180.132813 132.535156-11.773437-16.058594 65.636718-48.289062c4.449219-3.273438 5.402344-9.535157 2.128907-13.980469-3.273438-4.449219-9.535157-5.402344-13.980469-2.128907l-73.675781 54.207032c-4.441407 3.269531-5.398438 9.515625-2.136719 13.964844l23.59375 32.191406c1.566406 2.140625 3.925781 3.566406 6.550781 3.972656.503907.074219 1.007813.113281 1.511719.113281 2.121094 0 4.199219-.675781 5.929688-1.945312l4.070312-2.996094v166.921875c0 5.519531 4.480469 10 10 10h214.820312c-.277343 3.316406-.417968 6.652344-.417968 9.996094 0 67.273437 54.730468 122.003906 122.003906 122.003906 67.269531 0 122-54.730469 122-122.003906 0-63.902344-49.390625-116.484375-112-121.585938zm-226.183594 91.589844v-140h95.960938v140zm216.183594 132c-56.246094 0-102.003906-45.757812-102.003906-102.003906 0-23.359375 8.101562-46.1875 22.8125-64.28125 3.484375-4.289063 2.832031-10.585938-1.449219-14.070313-4.285156-3.480469-10.585937-2.832031-14.070313 1.453125-1.933593 2.378906-3.769531 4.835938-5.511718 7.347656v-100.445312c0-11.027344-8.972656-20-20-20h-95.960938c-11.027344 0-20 8.972656-20 20v140h-90.222656v-171.640625l158.203125-116.398437 158.203125 116.398437v80.050781c-3.101562.253906-6.1875.617188-9.246094 1.101563-5.453125.867187-9.171875 5.988281-8.308594 11.445312.863282 5.453125 5.976563 9.171875 11.441407 8.308594 5.3125-.84375 10.730469-1.269531 16.109375-1.269531 56.246094 0 102.003906 45.757812 102.003906 102 0 56.246094-45.757812 102.003906-102 102.003906zm0 0"}}),_c('path',{attrs:{"d":"m249.773438 280h-.003907c-5.523437 0-9.996093 4.476562-9.996093 10 0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m115.898438 97.921875c2.128906 0 4.273437-.675781 6.089843-2.074219l.007813-.003906c4.375-3.367188 5.191406-9.644531 1.824218-14.023438-3.367187-4.375-9.644531-5.191406-14.023437-1.824218-4.378906 3.367187-5.199219 9.644531-1.832031 14.019531 1.96875 2.5625 4.9375 3.90625 7.933594 3.90625zm0 0"}}),_c('path',{attrs:{"d":"m329.035156 284.320312-.003906.003907c-4.796875 2.738281-6.460938 8.84375-3.71875 13.640625 1.84375 3.230468 5.21875 5.039062 8.691406 5.039062 1.683594 0 3.386719-.425781 4.953125-1.320312 4.796875-2.738282 6.460938-8.847656 3.722657-13.644532-2.738282-4.792968-8.847657-6.457031-13.644532-3.71875zm0 0"}}),_c('path',{attrs:{"d":"m397.152344 364.15625c3.90625 3.902344 10.234375 3.902344 14.144531 0 3.902344-3.90625 3.902344-10.238281 0-14.144531-3.261719-3.257813-7.160156-5.496094-11.296875-6.710938v-3.304687c0-5.519532-4.480469-10-10-10-5.523438 0-10 4.480468-10 10v5.28125c-2.3125 1.21875-4.476562 2.792968-6.417969 4.734375-10.398437 10.394531-10.398437 27.3125 0 37.710937l18.6875 18.6875c1.261719 1.261719 1.953125 2.9375 1.953125 4.714844 0 1.78125-.691406 3.457031-1.953125 4.714844-1.257812 1.261718-2.933593 1.953125-4.714843 1.953125-1.777344 0-3.453126-.691407-4.710938-1.953125-3.90625-3.902344-10.238281-3.902344-14.144531 0-3.90625 3.90625-3.90625 10.238281 0 14.144531 3.257812 3.257813 7.160156 5.492187 11.296875 6.710937v3.300782c0 5.523437 4.480468 10 10 10 5.523437 0 10-4.476563 10-10v-5.28125c2.308594-1.21875 4.476562-2.792969 6.414062-4.734375 10.398438-10.394531 10.398438-27.3125 0-37.710938l-18.6875-18.6875c-2.597656-2.601562-2.597656-6.828125 0-9.429687 2.601563-2.597656 6.832032-2.597656 9.429688.003906zm0 0"}})])]),_vm._v(" "),_c('p',{attrs:{"classs":"h6 darkblue gibson line-height-1 center mt1"}},[_vm._v("Kunden ønsker"),_c('br'),_vm._v(" en skarp pris")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352796 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M465.7 67.4h-64.4v-56C401.3 5.1 396.2 0 389.9 0H122.1c-6.3 0-11.4 5.1-11.4 11.4v56H46.3c-6.3 0-11.4 5.1-11.4 11.4 0 52.3 31.7 99.5 79.5 119.6 12.2 52.6 53.2 94.4 105.3 107.8 2.1 26.5-15.7 51.4-42.3 57.4 -0.1 0-0.2 0.1-0.3 0.1 -0.2 0.1-0.5 0.1-0.7 0.2 -0.2 0.1-0.3 0.1-0.5 0.2 -0.2 0.1-0.4 0.1-0.6 0.2 -0.2 0.1-0.4 0.2-0.5 0.3 -0.1 0.1-0.3 0.1-0.4 0.2 -0.2 0.1-0.4 0.2-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.1-0.4 0.3-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.2-0.4 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.2 0.2-0.3 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.1 0.2-0.3 0.3-0.4 0.5 -0.1 0.1-0.2 0.3-0.3 0.4 -0.1 0.2-0.2 0.3-0.3 0.5 -0.1 0.1-0.2 0.3-0.2 0.4 -0.1 0.2-0.2 0.4-0.3 0.5 -0.1 0.2-0.1 0.3-0.2 0.5 -0.1 0.2-0.2 0.4-0.2 0.6 0 0.1-0.1 0.3-0.1 0.4 -0.1 0.2-0.1 0.5-0.2 0.7 0 0.1-0.1 0.2-0.1 0.3 -0.1 0.3-0.1 0.6-0.1 0.9 0 0.1 0 0.2 0 0.2 0 0.3 0 0.6 0 1 0 0 0 0.1 0 0.1v0.1c0 0.1 0 0.1 0 0.2v34h-32c-6.3 0-11.4 5.1-11.4 11.4v80c0 6.3 5.1 11.4 11.4 11.4h240c6.3 0 11.4-5.1 11.4-11.4v-80c0-6.3-5.1-11.4-11.4-11.4h-32v-34.3c0-3-1.2-5.8-3.1-7.8 0 0 0 0 0 0 -0.2-0.2-0.5-0.5-0.7-0.7 0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.5-0.4-0.7-0.6 -0.1 0-0.1-0.1-0.2-0.1 -0.2-0.2-0.5-0.3-0.8-0.5 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.2-0.6-0.3-0.8-0.4 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.1-0.6-0.3-0.9-0.4 0 0-0.1 0-0.1 0 -0.3-0.1-0.7-0.2-1-0.3 0 0-0.1 0-0.1 0 -26.8-6-44.5-31.1-42.3-57.7 51.6-13.7 92-55.2 104.2-107.5 47.8-20.1 79.6-67.4 79.6-119.6C477.1 72.5 472 67.4 465.7 67.4zM58.4 90.3h52.2v75.6c0 0 0 0.1 0 0.1 0 1.7 0 3.4 0.1 5.1C81.7 154.1 62 124.1 58.4 90.3zM365.1 432v57.1H148V432H365.1zM321.7 386.3v22.9H191.4v-22.9H321.7zM221.9 363.4c3.2-3.4 6.1-7.1 8.7-11.2 8.1-12.7 12.3-27.2 12.2-42 4.3 0.4 8.7 0.6 13.2 0.6 4.8 0 9.6-0.2 14.3-0.7 -0.1 20 7.7 39.1 21 53.3H221.9zM378.4 165.5c0 67.5-54.9 122.5-122.5 122.5s-122.5-54.9-122.5-122.5V22.9h245V165.5zM401.2 171.2c0.1-1.7 0.1-3.4 0.1-5.1 0 0 0-0.1 0-0.1V90.3h52.3C450 124.1 430.3 154.2 401.2 171.2z"}}),_c('path',{attrs:{"d":"M292 449.1H221.1c-6.3 0-11.4 5.1-11.4 11.4S214.8 472 221.1 472h70.9c6.3 0 11.4-5.1 11.4-11.4S298.3 449.1 292 449.1z"}}),_c('path',{attrs:{"d":"M325.2 125.3c-1.3-4.1-4.9-7.2-9.2-7.8l-34-4.9 -15.2-30.8c-1.9-3.9-5.9-6.4-10.2-6.4 -4.4 0-8.3 2.5-10.2 6.4l-15.2 30.8 -34 4.9c-4.3 0.6-7.9 3.6-9.2 7.8 -1.3 4.1-0.2 8.7 2.9 11.7l24.6 24 -5.8 33.8c-0.7 4.3 1 8.6 4.5 11.2 3.5 2.6 8.2 2.9 12 0.9l30.4-16 30.4 16c1.7 0.9 3.5 1.3 5.3 1.3 2.4 0 4.7-0.7 6.7-2.2 3.5-2.6 5.3-6.9 4.5-11.2l-5.8-33.8 24.6-24C325.4 134 326.5 129.4 325.2 125.3zM277.4 148.8c-2.7 2.6-3.9 6.4-3.3 10.1l2.9 16.9 -15.2-8c-1.7-0.9-3.5-1.3-5.3-1.3s-3.7 0.4-5.3 1.3l-15.2 8 2.9-16.9c0.6-3.7-0.6-7.5-3.3-10.1l-12.3-12 17-2.5c3.7-0.5 6.9-2.9 8.6-6.3l7.6-15.4 7.6 15.4c1.7 3.4 4.9 5.7 8.6 6.3l17 2.5L277.4 148.8z"}})])]),_vm._v(" "),_c('p',{attrs:{"classs":"h6 darkblue gibson line-height-1 center mt1"}},[_vm._v("Kunden ønsker"),_c('br'),_vm._v("luksus standard")])]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py1",staticStyle:{"height":"140px"}},[(_vm.itemSelect.numpartner)?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[[(_vm.itemSelect.numpartner === '1')?_c('div',[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{attrs:{"classs":"h6 darkblue gibson center mb0 block"}},[_vm._v("\n                     Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven\n                    ")])]):(_vm.itemSelect.numpartner === '2')?_c('div',[_c('span',{staticClass:"block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{attrs:{"classs":"h6 darkblue gibson center mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '3')?_c('div',[_c('div',{staticClass:"block flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block flex justify-center items-center center"},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]),_vm._v(" "),_c('span',{attrs:{"classs":"h6 darkblue gibson center mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):_c('div',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]],2):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v("1")]),_vm._v(" tilbud på opgaven")])])]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py1 border-top mediumgrey-border",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[[(_vm.itemSelect.other352798 === '1' && _vm.itemSelect.other352800 === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center"},[_vm._v("Kunden taler "),_c('br'),_vm._v("dansk og engelsk")])]):(_vm.itemSelect.other352798 === '1' && _vm.itemSelect.other352800 === '0')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center"},[_vm._v("Kunden taler kun dansk")])]):(_vm.itemSelect.other352798 === '0' && _vm.itemSelect.other352800 === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center"},[_vm._v("Kunden taler kun engelsk")])]):_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center"},[_vm._v("Kunden taler "),_c('br'),_vm._v("kun dansk")])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py1 border-left border-top mediumgrey-border",staticStyle:{"height":"140px"}},[[(_vm.itemSelect.other352801 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1605_"}},[_c('g',{attrs:{"id":"XMLID_137_"}},[_c('path',{attrs:{"id":"XMLID_139_","d":"m278.661 230.088c3.905-3.905 3.905-10.237 0-14.143s-10.237-3.905-14.143 0c-4.696 4.697-12.34 4.697-17.036 0-3.905-3.905-10.237-3.905-14.143 0s-3.905 10.237 0 14.143c6.248 6.247 14.454 9.371 22.661 9.371s16.413-3.124 22.661-9.371z"}}),_c('path',{attrs:{"id":"XMLID_418_","d":"m256.131 55.126c-16.913 0-30.672 13.76-30.672 30.672s13.76 30.672 30.672 30.672 30.672-13.76 30.672-30.672-13.759-30.672-30.672-30.672zm0 41.345c-5.885 0-10.672-4.788-10.672-10.672s4.788-10.672 10.672-10.672 10.672 4.788 10.672 10.672-4.787 10.672-10.672 10.672z"}}),_c('path',{attrs:{"id":"XMLID_419_","d":"m256 492c-2.63 0-5.21 1.069-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.07-2.931c1.86-1.859 2.93-4.439 2.93-7.069s-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93z"}}),_c('path',{attrs:{"id":"XMLID_422_","d":"m356.956 301.815h-49.611v-29.317c24.906-16.635 41.344-44.997 41.344-77.13v-37.554h85.093c5.523 0 10-4.477 10-10s-4.477-10-10-10h-76.824v-64.42c0-32.871-26.742-59.613-59.613-59.613h-31.345v-3.781c0-5.523-4.477-10-10-10s-10 4.477-10 10v3.782h-31.345c-32.871 0-59.613 26.742-59.613 59.613v74.42c0 4.931 3.573 9.019 8.269 9.84v37.714c0 32.133 16.438 60.495 41.344 77.13v29.317h-49.611c-61.007 0-110.641 49.633-110.641 110.64v89.544c0 5.522 4.477 10 10 10h156.597c5.523 0 10-4.478 10-10s-4.477-10-10-10h-85v-60h20v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h92v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h20v60h-85c-5.523 0-10 4.478-10 10s4.477 10 10 10h156.596c5.523 0 10-4.478 10-10v-89.545c0-61.007-49.633-110.64-110.64-110.64zm-181.914-228.42c0-21.843 17.771-39.613 39.613-39.613h82.689c21.843 0 39.613 17.771 39.613 39.613v64.42h-161.915zm8.269 121.974v-37.554h145.378v37.554c0 40.081-32.608 72.689-72.689 72.689s-72.689-32.608-72.689-72.689zm72.689 92.69c10.997 0 21.55-1.929 31.345-5.46v25.786c0 17.283-14.061 31.345-31.345 31.345s-31.345-14.062-31.345-31.345v-25.786c9.795 3.53 20.348 5.46 31.345 5.46zm-140 123.941c-5.523 0-10 4.478-10 10v70h-41.596v-79.545c0-46.926 35.847-85.636 81.596-90.189v89.734zm74 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm20-28v-80.841c8.408 16.914 25.865 28.571 46 28.571s37.592-11.656 46-28.571v80.841zm136 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm101.596 52h-41.596v-70c0-5.522-4.477-10-10-10h-30v-89.734c45.749 4.553 81.596 43.263 81.596 90.189z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2"},[_vm._v("Kunden ønsker en ung fagmand")])]):(_vm.itemSelect.other352803 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M293.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S293.5 243.1 293.5 250z"}}),_c('path',{attrs:{"d":"M193.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S193.5 243.1 193.5 250z"}}),_c('path',{attrs:{"d":"M191 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C180.1 225.1 186.2 226.8 191 224z"}}),_c('path',{attrs:{"d":"M291 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C280.1 225.1 286.2 226.8 291 224z"}}),_c('path',{attrs:{"d":"M258 120.8l0.2 0c0.2 0 0.4 0 0.7 0 5.2 0 9.6-4.1 10-9.3 0.4-5.5-3.8-10.3-9.3-10.6 -0.2 0-0.4 0-0.6 0 -5.5-0.3-10.2 4-10.4 9.6C248.2 115.9 252.5 120.6 258 120.8z"}}),_c('path',{attrs:{"d":"M502 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10H502c5.5 0 10-4.5 10-10C512 496.5 507.5 492 502 492z"}}),_c('path',{attrs:{"d":"M10.2 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.2c5.5 0 10-4.5 10-10C20.2 496.5 15.8 492 10.2 492z"}}),_c('path',{attrs:{"d":"M473 492h-7.3c-3.3-70-41.4-133.5-101.7-169.8 12.1-18.1 19.8-39.3 21.5-62.2h0.4c22.1 0 40-17.9 40-40 0-18.6-12.8-34.3-30-38.7v-27.7c33-12.1 54.9-30.7 63.7-54.4 0 0 0 0 0 0 0.1-0.3 0.2-0.6 0.3-0.9 0 0 0 0 0 0 0.1-0.2 0.1-0.5 0.2-0.7 0-0.1 0-0.2 0.1-0.2 0-0.3 0.1-0.5 0.1-0.8 0-0.1 0-0.2 0-0.2 0-0.2 0-0.4 0-0.6 0-0.1 0-0.3 0-0.4 0-0.1 0-0.2 0-0.3 -0.1-1.4-0.5-2.8-1.2-4 -0.6-1.1-1.4-2.1-2.3-2.9 -0.1-0.1-0.2-0.2-0.4-0.3 -0.1-0.1-0.1-0.1-0.2-0.1 -0.2-0.1-0.4-0.3-0.6-0.4 0 0-0.1 0-0.1-0.1 -0.2-0.1-0.5-0.3-0.8-0.4 0 0-0.1 0-0.1-0.1 -0.3-0.1-0.5-0.2-0.8-0.3 0 0 0 0 0 0 -0.1-0.1-0.3-0.1-0.4-0.1 -0.2-0.1-0.3-0.1-0.5-0.2 -20.6-5.5-36-17.8-53.9-32.1C367.4 28.6 331.5 0 256 0c-31.9 0-61.4 10.8-85 28.8 -0.7 0.4-1.3 0.9-1.9 1.4 -11.9 9.4-22.2 20.7-30.5 33.4 -0.5 0.6-0.9 1.2-1.2 1.8 -13.6 21.6-21.5 47.1-21.5 74.5v41.3C98.8 185.7 86 201.4 86 220c0 22.1 17.9 40 40 40h0.4c1.7 22.9 9.4 44.1 21.5 62.2 -60.3 36.4-98.3 99.9-101.7 169.8h-7.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h16.9c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h109.5c0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0h109.5c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h16.9c5.5 0 10-4.5 10-10C483 496.5 478.6 492 473 492zM106 492H66.3c2.1-39.2 16.2-76.2 39.7-106.4V492zM170.1 56.3c4.8 19.5 16.5 48 56.7 59.6 0.9 0.3 1.9 0.4 2.8 0.4 4.3 0 8.3-2.9 9.6-7.2 1.5-5.3-1.5-10.8-6.8-12.4C196.3 86.3 191.1 60 187.6 42.6c-0.1-0.3-0.1-0.6-0.2-1C206.8 28 230.5 20 256 20c68.5 0 100.1 25.2 130.6 49.5 15.7 12.6 30.8 24.5 49.7 32 -11.4 17.7-35.2 31.6-68.4 39.7 -66.2 16.1-156.9 5.9-186.9-21 -6.6-6.5-18.3-18.2-23.9-47.9C160.9 66.6 165.3 61.2 170.1 56.3zM376 159.7v20.3c-8.2 0-14.8-5.4-19.7-16 5.6-1 11-2.1 16.3-3.4C373.7 160.3 374.9 160 376 159.7zM136 140c0-14.6 2.6-28.7 7.5-41.6 6.3 17 14.4 26.8 20.3 32.9 -2.4 24.2-11.8 48.7-27.8 48.7V140zM146 250c0-5.5-4.5-10-10-10h-10c-11 0-20-9-20-20 0-11 9-20 20-20h10c10.3 0 24.9-4.2 35.8-24.2 5.3-9.7 8.4-20.6 10.2-30.6 18.1 10.1 43.8 17.5 74.7 21.2 26.1 3.1 53.5 3.2 79.1 0.4 10.9 28.6 29.5 33.1 40.2 33.1h10c11 0 20 9 20 20 0 11-9 20-20 20h-10c-5.5 0-10 4.5-10 10 0 25.7-8.8 49.3-23.6 68 -0.3 0.2-0.5 0.5-0.7 0.8 0 0 0 0-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -0.2 0.2-0.3 0.4-0.5 0.6 0 0 0 0.1-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -9.8 11.9-22.1 21.6-36 28.5 -0.6 0.2-1.1 0.5-1.6 0.8 -14.3 6.8-30.3 10.7-47.2 10.7 -16.9 0-32.9-3.8-47.2-10.6 -0.5-0.3-1.1-0.6-1.6-0.8 -13.9-6.9-26.1-16.7-36-28.5 -0.1-0.1-0.1-0.2-0.2-0.3 0 0 0 0 0 0 -0.2-0.3-0.4-0.5-0.6-0.8 0 0 0 0 0 0 -0.2-0.2-0.4-0.4-0.6-0.6 -0.1-0.1-0.1-0.1-0.2-0.2C154.8 299.3 146 275.7 146 250zM291.5 375.1l-10.2 27.9 -10.4-23.9C278 378.3 284.8 377 291.5 375.1zM241.1 379.1l-10.4 23.9 -10.2-27.9C227.2 377 234 378.3 241.1 379.1zM126 492V363.7h0c9-8.5 18.9-16.1 29.6-22.8l15.4 77.7 -22.8 24.4c-1.9 2.1-2.9 4.9-2.6 7.7 0.3 2.8 1.7 5.4 4 7.1l45.9 34.2H126zM228.9 492l-58.4-43.6 18.6-20c2.2-2.4 3.1-5.6 2.5-8.8l-12.9-65.2c5.3 4 11 7.5 16.9 10.6l46.2 126.9H228.9zM256 472.7l-15.4-42.4 15.4-35.3 15.4 35.3L256 472.7zM283.1 492h-12.8l46.2-126.9c5.9-3.1 11.5-6.7 16.9-10.6l-12.9 65.2c-0.6 3.2 0.3 6.4 2.5 8.8l18.6 20L283.1 492zM386 492h-69.5l45.9-34.2c2.3-1.7 3.7-4.3 4-7.1 0.3-2.8-0.7-5.6-2.6-7.7l-22.8-24.4 15.4-77.7c10.7 6.7 20.6 14.3 29.6 22.8V492zM406 492V385.6c23.5 30.2 37.7 67.2 39.7 106.4H406z"}}),_c('path',{attrs:{"d":"M218.4 329.4c9.7 0 20.6-2.6 30.6-7.3 2.6-1.2 4.9-2.7 7-4.4 2 1.7 4.3 3.2 7 4.4 10 4.7 20.9 7.3 30.6 7.3 0 0 0 0 0 0 21.7 0 37.3-11.9 44.1-33.6 1.2-4-0.1-8.3-3.4-10.9 -3.3-2.6-7.8-2.8-11.3-0.7 -0.1 0-5.6 3.2-13.1 3.2 0 0 0 0 0 0 -6.8 0-13.2-2.7-18.9-7.9 -7.5-6.9-14.8-8.4-19.5-8.4 -5.8 0-11.2 2.1-15.5 5.7 -4.3-3.6-9.7-5.7-15.5-5.7 -4.7 0-12 1.5-19.5 8.4 -5.7 5.3-12.1 7.9-18.9 7.9 -7.5 0-13.1-3.2-13.1-3.2 -3.5-2.2-8-2-11.3 0.6 -3.3 2.6-4.6 7-3.4 11C181.1 317.4 196.8 329.4 218.4 329.4zM266.6 296c0.5-2.4 2.5-5 4.9-5 1.7 0 3.8 1.1 6 3.1 8.1 7.5 17.6 11.9 27.6 12.9 -3.3 1.5-7.2 2.3-11.5 2.3 -6.9 0-14.7-1.9-22.1-5.4C267.5 302.1 265.8 299.4 266.6 296zM234.5 294.2c2.2-2 4.3-3.1 6-3.1 2.5 0 4.4 2.6 4.9 5 0.8 3.4-0.9 6.1-4.9 8 -7.4 3.5-15.3 5.4-22.1 5.4 -4.4 0-8.2-0.8-11.5-2.3C216.9 306 226.4 301.6 234.5 294.2z"}})])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2"},[_vm._v("Kunden ønsker"),_c('br'),_vm._v("en erfaren fagmand")])]):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2",staticStyle:{"font-size":"12.5px"}},[_vm._v("Erfaringsniveau "),_c('br'),_vm._v("har ingen betydning")])])]],2)]):_vm._e(),_vm._v(" "),(_vm.itemSelect.mester === '1')?_c('div',{staticClass:"clearfix flex flex-wrap my3"},[_c('div',{staticClass:"col col-6 gibson py3 border-right mediumgrey-border ",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center"},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"}}),_c('path',{attrs:{"d":"M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"}}),_c('path',{attrs:{"d":"M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"}}),_c('path',{attrs:{"d":"M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Opstartsdato: "),_c('br'),_vm._v(_vm._s(_vm.moment(_vm.itemSelect.mesterinfo.startdate1).locale('da').format('LL')))])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3  mediumgrey-border",staticStyle:{"height":"140px"}},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"M478.2 194l15-15c4.3-4.3 6.7-10.1 6.7-16.2s-2.4-11.9-6.7-16.2l-17.2-17.2c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-15 15c-19.8-13.6-42.3-23.7-66.4-29.1V93.1h9.1c12.4 0 22.4-10.1 22.4-22.4V39.5c0-12.4-10.1-22.4-22.4-22.4H268.1c-12.4 0-22.4 10.1-22.4 22.4v31.2c0 12.4 10.1 22.4 22.4 22.4h9.1v22.2c-24.1 5.5-46.4 15.5-66.1 29.1l-15-15c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-17.2 17.2c-8.9 9-8.9 23.5 0 32.5l2.7 2.7H78.2c-5.5 0-10 4.5-10 10s4.5 10 10 10h78.2c-7.5 12-13.6 24.9-18.3 38.4H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h122.4c-2.8 12.4-4.4 25.3-4.7 38.4H64c-5.5 0-10 4.5-10 10s4.5 10 10 10h64.2c1.1 13.2 3.5 26.1 7.1 38.4H50c-5.5 0-10 4.5-10 10s4.5 10 10 10h92.5c29.1 69.2 97.6 118 177.3 118 106 0 192.2-86.2 192.2-192.2C512 262.4 499.5 224.9 478.2 194zM457.7 143.5c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l17.2 17.2c0.7 0.7 0.9 1.5 0.9 2.1s-0.1 1.4-0.9 2.1l-13.1 13.1c-6.6-7.7-13.7-14.8-21.4-21.4L457.7 143.5zM265.6 70.6V39.5c0-1.3 1.1-2.4 2.4-2.4h103.2c1.3 0 2.4 1.1 2.4 2.4v31.2c0 1.3-1.1 2.4-2.4 2.4h-19.1 -64.9 -19.1C266.7 73.1 265.6 72 265.6 70.6zM297.2 93.1h44.9v18.8c-7.3-0.9-14.8-1.3-22.3-1.3 -7.6 0-15.2 0.5-22.6 1.3V93.1zM160.5 160.7l17.2-17.2c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l13.1 13.1c-7.7 6.6-14.8 13.7-21.4 21.4l-13.1-13.1C159.4 163.7 159.4 161.8 160.5 160.7zM319.8 474.9c-95 0-172.2-77.3-172.2-172.2s77.3-172.2 172.2-172.2 172.2 77.3 172.2 172.2S414.7 474.9 319.8 474.9z"}}),_c('path',{attrs:{"d":"M385.8 222.6l-47.3 47.3c-5.5-3.2-11.9-5-18.7-5 -20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9c0-6.8-1.8-13.2-5-18.7l47.3-47.3c3.9-3.9 3.9-10.2 0-14.1C396 218.7 389.7 218.7 385.8 222.6zM319.8 320.6c-9.8 0-17.9-8-17.9-17.9s8-17.9 17.9-17.9 17.9 8 17.9 17.9S329.6 320.6 319.8 320.6z"}}),_c('path',{attrs:{"d":"M319.8 173.1c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1 -1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9 -2.9 4.4-2.9 7.1c0 2.6 1.1 5.2 2.9 7.1S317.2 173.1 319.8 173.1z"}}),_c('path',{attrs:{"d":"M319.8 432.4c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1s-1.1-5.2-2.9-7.1C325 433.5 322.4 432.4 319.8 432.4z"}}),_c('path',{attrs:{"d":"M221 194c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 195.1 223.7 194 221 194z"}}),_c('path',{attrs:{"d":"M418.5 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C423.8 392.6 421.2 391.5 418.5 391.5z"}}),_c('path',{attrs:{"d":"M221 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1s4.4 2.9 7.1 2.9 5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 392.6 223.7 391.5 221 391.5z"}}),_c('path',{attrs:{"d":"M180.1 292.7c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C185.4 293.8 182.8 292.7 180.1 292.7z"}}),_c('path',{attrs:{"d":"M466.5 295.7c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9 2.9-4.4 2.9-7.1C469.4 300.1 468.4 297.5 466.5 295.7z"}}),_c('path',{attrs:{"d":"M10 357c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C15.2 358 12.6 357 10 357z"}}),_c('path',{attrs:{"d":"M456.5 272.4c5.3-1.6 8.3-7.1 6.7-12.4 -7.1-23.7-20.1-45.6-37.7-63.1 -17.6-17.6-39.5-30.6-63.2-37.6 -5.3-1.6-10.9 1.5-12.4 6.8s1.5 10.9 6.8 12.4c42.2 12.5 74.9 45.1 87.5 87.3 1.3 4.3 5.3 7.1 9.6 7.1C454.6 272.8 455.5 272.7 456.5 272.4z"}})])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Varighed: "+_vm._s(_vm.itemSelect.mesterinfo.duration1.replace('d',' dage').replace('t',' timer'))+" ")])])]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-right border-top mediumgrey-border",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[[(_vm.itemSelect.mesterinfo.en === '1' && _vm.itemSelect.mesterinfo.dk === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler "),_c('br'),_vm._v("dansk og engelsk")])]):(_vm.itemSelect.mesterinfo.en === '0' && _vm.itemSelect.mesterinfo.dk === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])]):(_vm.itemSelect.mesterinfo.en === '1' && _vm.itemSelect.mesterinfo.dk === '0')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun engelsk")])]):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-top mediumgrey-border",staticStyle:{"height":"140px"}},[(_vm.itemSelect.numpartner)?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[[(_vm.itemSelect.numpartner === '1')?_c('div',[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '2')?_c('div',[_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '3')?_c('div',[_c('div',{staticClass:"block flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block flex justify-center items-center center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])])]):_c('div',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]],2):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v("1")]),_vm._v(" tilbud på opgaven")])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step ===2)?_c('div',{staticClass:"mt-4"},[(_vm.itemSelect.monthlyp !== '1' && _vm.itemSelect.appointment_free >= 0)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"p2 flex justify-center items-center"},[_c('p',{staticClass:"h5 primarycolor line-height-1 mb0"},[_vm._v("\n                Du har "+_vm._s(_vm.itemSelect.appointment_free)+" gratis møde til gode\n              ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 p0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center border-top",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[_c('button',{staticClass:"col-6 outlined-disabled-button no-border p3 h4 not-rounded gibson flex justify-center items-center",staticStyle:{"border":"0!important"},on:{"click":function($event){_vm.itemShow = false}}},[_c('span',[_vm._v("←")]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),(_vm.step === 2)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h4 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":_vm.nextStep}},[_c('span',{staticClass:"mx2"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud !== 1 && _vm.step === 1)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h4 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){return _vm.reservedItem()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud === 1 && _vm.step === 1)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h4 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){return _vm.reservedItemTilbud()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])],2):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('b-modal',{ref:"itemModal",attrs:{"lazy":"","id":"itemModalweb"},model:{value:(_vm.itemShow),callback:function ($$v) {_vm.itemShow=$$v},expression:"itemShow"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"relative"},[_c('img',{staticClass:"fit block",staticStyle:{"height":"150px","width":"100%","object-fit":"none"},attrs:{"data-key":_vm.itemSelect.id + 'd',"src":_vm.itemSelect.image,"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.id + 'd')}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.mailingzip)+" "+_vm._s(_vm.itemSelect.mailingcity))]),_vm._v(" "),(_vm.itemSelect.match)?_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.match))]),_vm._v(" %")]):_vm._e()])]),_vm._v(" "),(_vm.itemSelect.gratis1 === '1')?_c('div',{staticClass:"white-background mintgreen p2 line-height-1 gibson semi-bold h6 flex items-center"},[_vm._v("\n          Gratis møde\n        ")]):_vm._e()]}),_vm._v(" "),_c('div',[_c('div',{staticClass:"modal-body-marketplace"},[_c('div',{staticClass:"clearfix px2"},[_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n              "+_vm._s(_vm.itemSelect.producttitle)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(_vm.itemSelect.henttilbud !== 1)?_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud === 1)?_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(_vm.itemSelect.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()])]),_vm._v(" "),(_vm.step ===1)?_c('div',[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.comments",modifiers:{"comments":true}}],staticClass:"col-12 outlined-dark-button p2 gibson h6 not-rounded flex justify-between items-center"},[_c('span',[_vm._v("Se beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details",modifiers:{"details":true}}],staticClass:"col-12 outlined-dark-button p2 gibson h6 not-rounded flex justify-between items-center"},[_c('span',[_vm._v("Se detaljer")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-collapse',{attrs:{"id":"details"}},[_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[_c('div',[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-1"},[_vm._v("Opgavens detaljer")])]),_vm._v(" "),_c('div',_vm._l((_vm.itemSelect.product),function(item){return _c('b-row',{key:item.productid,staticClass:"my1 pb2"},[_c('b-col',{staticClass:"regular h6 gibson",attrs:{"cols":"9"}},[_vm._v(_vm._s(item.productname))]),_vm._v(" "),_c('b-col',{staticClass:"semi-bold h6 gibson"},[_vm._v(_vm._s(item.quantity))])],1)}),1)])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"comments"}},[(_vm.itemSelect.henttilbud === 1)?_c('div',{staticClass:"clearfix flex flex-column mb3 px2"},[_c('div',[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-1"},[_vm._v("Kommentar")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h6 darkblue regular gibson line-height-golden"},[_vm._v("\n                    "+_vm._s(_vm.itemSelect.comment_to_partner)+"\n                  ")])])]):_c('div',{staticClass:"clearfix flex flex-column mb3"},[_c('div',[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1"},[_vm._v("Notes")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n                    "+_vm._s(_vm.itemSelect.comment_to_partner)+"\n                  ")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-center py1"},[_c('p',{staticClass:"h5 semi-bold primarycolor gibson line-height-1"},[_vm._v("\n                Vigtig info om kunden og opgaven\n              ")])])]),_vm._v(" "),(_vm.itemSelect.mester !== '1')?_c('div',{staticClass:"clearfix flex flex-wrap my1"},[_c('div',{staticClass:"col col-6 gibson py3 border-right mediumgrey-border border-bottom",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center"},[[(_vm.itemSelect.other352787 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M478.2 194l15-15c4.3-4.3 6.7-10.1 6.7-16.2s-2.4-11.9-6.7-16.2l-17.2-17.2c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-15 15c-19.8-13.6-42.3-23.7-66.4-29.1V93.1h9.1c12.4 0 22.4-10.1 22.4-22.4V39.5c0-12.4-10.1-22.4-22.4-22.4H268.1c-12.4 0-22.4 10.1-22.4 22.4v31.2c0 12.4 10.1 22.4 22.4 22.4h9.1v22.2c-24.1 5.5-46.4 15.5-66.1 29.1l-15-15c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-17.2 17.2c-8.9 9-8.9 23.5 0 32.5l2.7 2.7H78.2c-5.5 0-10 4.5-10 10s4.5 10 10 10h78.2c-7.5 12-13.6 24.9-18.3 38.4H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h122.4c-2.8 12.4-4.4 25.3-4.7 38.4H64c-5.5 0-10 4.5-10 10s4.5 10 10 10h64.2c1.1 13.2 3.5 26.1 7.1 38.4H50c-5.5 0-10 4.5-10 10s4.5 10 10 10h92.5c29.1 69.2 97.6 118 177.3 118 106 0 192.2-86.2 192.2-192.2C512 262.4 499.5 224.9 478.2 194zM457.7 143.5c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l17.2 17.2c0.7 0.7 0.9 1.5 0.9 2.1s-0.1 1.4-0.9 2.1l-13.1 13.1c-6.6-7.7-13.7-14.8-21.4-21.4L457.7 143.5zM265.6 70.6V39.5c0-1.3 1.1-2.4 2.4-2.4h103.2c1.3 0 2.4 1.1 2.4 2.4v31.2c0 1.3-1.1 2.4-2.4 2.4h-19.1 -64.9 -19.1C266.7 73.1 265.6 72 265.6 70.6zM297.2 93.1h44.9v18.8c-7.3-0.9-14.8-1.3-22.3-1.3 -7.6 0-15.2 0.5-22.6 1.3V93.1zM160.5 160.7l17.2-17.2c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l13.1 13.1c-7.7 6.6-14.8 13.7-21.4 21.4l-13.1-13.1C159.4 163.7 159.4 161.8 160.5 160.7zM319.8 474.9c-95 0-172.2-77.3-172.2-172.2s77.3-172.2 172.2-172.2 172.2 77.3 172.2 172.2S414.7 474.9 319.8 474.9z"}}),_c('path',{attrs:{"d":"M385.8 222.6l-47.3 47.3c-5.5-3.2-11.9-5-18.7-5 -20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9c0-6.8-1.8-13.2-5-18.7l47.3-47.3c3.9-3.9 3.9-10.2 0-14.1C396 218.7 389.7 218.7 385.8 222.6zM319.8 320.6c-9.8 0-17.9-8-17.9-17.9s8-17.9 17.9-17.9 17.9 8 17.9 17.9S329.6 320.6 319.8 320.6z"}}),_c('path',{attrs:{"d":"M319.8 173.1c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1 -1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9 -2.9 4.4-2.9 7.1c0 2.6 1.1 5.2 2.9 7.1S317.2 173.1 319.8 173.1z"}}),_c('path',{attrs:{"d":"M319.8 432.4c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1s-1.1-5.2-2.9-7.1C325 433.5 322.4 432.4 319.8 432.4z"}}),_c('path',{attrs:{"d":"M221 194c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 195.1 223.7 194 221 194z"}}),_c('path',{attrs:{"d":"M418.5 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C423.8 392.6 421.2 391.5 418.5 391.5z"}}),_c('path',{attrs:{"d":"M221 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1s4.4 2.9 7.1 2.9 5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 392.6 223.7 391.5 221 391.5z"}}),_c('path',{attrs:{"d":"M180.1 292.7c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C185.4 293.8 182.8 292.7 180.1 292.7z"}}),_c('path',{attrs:{"d":"M466.5 295.7c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9 2.9-4.4 2.9-7.1C469.4 300.1 468.4 297.5 466.5 295.7z"}}),_c('path',{attrs:{"d":"M10 357c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C15.2 358 12.6 357 10 357z"}}),_c('path',{attrs:{"d":"M456.5 272.4c5.3-1.6 8.3-7.1 6.7-12.4 -7.1-23.7-20.1-45.6-37.7-63.1 -17.6-17.6-39.5-30.6-63.2-37.6 -5.3-1.6-10.9 1.5-12.4 6.8s1.5 10.9 6.8 12.4c42.2 12.5 74.9 45.1 87.5 87.3 1.3 4.3 5.3 7.1 9.6 7.1C454.6 272.8 455.5 272.7 456.5 272.4z"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Opgaven haster! "),_c('br'),_vm._v("Skal laves inden for 1 mdr.")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352788 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","height":"40","width":"40","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0"}},[_vm._v("Der er god tid "),_c('br'),_vm._v("til at løse opgaven")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352789 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512","width":"40","height":"40"}},[_c('path',{attrs:{"d":"M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"}}),_c('path',{attrs:{"d":"M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"}}),_c('path',{attrs:{"d":"M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"}}),_c('path',{attrs:{"d":"M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0"}},[_vm._v("Meget tid!")])]):_vm._e()]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-bottom mediumgrey-border",staticStyle:{"height":"140px"}},[[(_vm.itemSelect.other352785 !== '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[_c('span',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block"}},[_vm._v("Garantiordning er "),_c('br'),_vm._v("ikke et krav")])]):(_vm.itemSelect.other352785 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Skal være medlem"),_c('br'),_vm._v(" af Garantiordning")])]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-right mediumgrey-border",staticStyle:{"height":"140px"}},[_c('div',[(_vm.itemSelect.other352795 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","viewBox":"0 0 512 512.0005","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m400 268.410156v-65.335937l4.074219 3c2.136719 1.570312 4.816406 2.230469 7.4375 1.828125 2.625-.402344 4.980469-1.832032 6.550781-3.972656l23.59375-32.1875c3.261719-4.449219 2.304688-10.699219-2.136719-13.96875l-211.796875-155.828126c-3.523437-2.59375-8.328125-2.59375-11.851562 0l-73.683594 54.214844c-4.449219 3.269532-5.402344 9.53125-2.128906 13.980469 3.273437 4.445313 9.535156 5.398437 13.980468 2.125l67.757813-49.851563 197.828125 145.554688-11.769531 16.058594-180.132813-132.535156c-3.523437-2.59375-8.328125-2.59375-11.851562 0l-180.132813 132.535156-11.773437-16.058594 65.636718-48.289062c4.449219-3.273438 5.402344-9.535157 2.128907-13.980469-3.273438-4.449219-9.535157-5.402344-13.980469-2.128907l-73.675781 54.207032c-4.441407 3.269531-5.398438 9.515625-2.136719 13.964844l23.59375 32.191406c1.566406 2.140625 3.925781 3.566406 6.550781 3.972656.503907.074219 1.007813.113281 1.511719.113281 2.121094 0 4.199219-.675781 5.929688-1.945312l4.070312-2.996094v166.921875c0 5.519531 4.480469 10 10 10h214.820312c-.277343 3.316406-.417968 6.652344-.417968 9.996094 0 67.273437 54.730468 122.003906 122.003906 122.003906 67.269531 0 122-54.730469 122-122.003906 0-63.902344-49.390625-116.484375-112-121.585938zm-226.183594 91.589844v-140h95.960938v140zm216.183594 132c-56.246094 0-102.003906-45.757812-102.003906-102.003906 0-23.359375 8.101562-46.1875 22.8125-64.28125 3.484375-4.289063 2.832031-10.585938-1.449219-14.070313-4.285156-3.480469-10.585937-2.832031-14.070313 1.453125-1.933593 2.378906-3.769531 4.835938-5.511718 7.347656v-100.445312c0-11.027344-8.972656-20-20-20h-95.960938c-11.027344 0-20 8.972656-20 20v140h-90.222656v-171.640625l158.203125-116.398437 158.203125 116.398437v80.050781c-3.101562.253906-6.1875.617188-9.246094 1.101563-5.453125.867187-9.171875 5.988281-8.308594 11.445312.863282 5.453125 5.976563 9.171875 11.441407 8.308594 5.3125-.84375 10.730469-1.269531 16.109375-1.269531 56.246094 0 102.003906 45.757812 102.003906 102 0 56.246094-45.757812 102.003906-102 102.003906zm0 0"}}),_c('path',{attrs:{"d":"m249.773438 280h-.003907c-5.523437 0-9.996093 4.476562-9.996093 10 0 5.519531 4.476562 10 10 10 5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m115.898438 97.921875c2.128906 0 4.273437-.675781 6.089843-2.074219l.007813-.003906c4.375-3.367188 5.191406-9.644531 1.824218-14.023438-3.367187-4.375-9.644531-5.191406-14.023437-1.824218-4.378906 3.367187-5.199219 9.644531-1.832031 14.019531 1.96875 2.5625 4.9375 3.90625 7.933594 3.90625zm0 0"}}),_c('path',{attrs:{"d":"m329.035156 284.320312-.003906.003907c-4.796875 2.738281-6.460938 8.84375-3.71875 13.640625 1.84375 3.230468 5.21875 5.039062 8.691406 5.039062 1.683594 0 3.386719-.425781 4.953125-1.320312 4.796875-2.738282 6.460938-8.847656 3.722657-13.644532-2.738282-4.792968-8.847657-6.457031-13.644532-3.71875zm0 0"}}),_c('path',{attrs:{"d":"m397.152344 364.15625c3.90625 3.902344 10.234375 3.902344 14.144531 0 3.902344-3.90625 3.902344-10.238281 0-14.144531-3.261719-3.257813-7.160156-5.496094-11.296875-6.710938v-3.304687c0-5.519532-4.480469-10-10-10-5.523438 0-10 4.480468-10 10v5.28125c-2.3125 1.21875-4.476562 2.792968-6.417969 4.734375-10.398437 10.394531-10.398437 27.3125 0 37.710937l18.6875 18.6875c1.261719 1.261719 1.953125 2.9375 1.953125 4.714844 0 1.78125-.691406 3.457031-1.953125 4.714844-1.257812 1.261718-2.933593 1.953125-4.714843 1.953125-1.777344 0-3.453126-.691407-4.710938-1.953125-3.90625-3.902344-10.238281-3.902344-14.144531 0-3.90625 3.90625-3.90625 10.238281 0 14.144531 3.257812 3.257813 7.160156 5.492187 11.296875 6.710937v3.300782c0 5.523437 4.480468 10 10 10 5.523437 0 10-4.476563 10-10v-5.28125c2.308594-1.21875 4.476562-2.792969 6.414062-4.734375 10.398438-10.394531 10.398438-27.3125 0-37.710938l-18.6875-18.6875c-2.597656-2.601562-2.597656-6.828125 0-9.429687 2.601563-2.597656 6.832032-2.597656 9.429688.003906zm0 0"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Kunden ønsker "),_c('br'),_vm._v("en skarp pris")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352796 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M465.7 67.4h-64.4v-56C401.3 5.1 396.2 0 389.9 0H122.1c-6.3 0-11.4 5.1-11.4 11.4v56H46.3c-6.3 0-11.4 5.1-11.4 11.4 0 52.3 31.7 99.5 79.5 119.6 12.2 52.6 53.2 94.4 105.3 107.8 2.1 26.5-15.7 51.4-42.3 57.4 -0.1 0-0.2 0.1-0.3 0.1 -0.2 0.1-0.5 0.1-0.7 0.2 -0.2 0.1-0.3 0.1-0.5 0.2 -0.2 0.1-0.4 0.1-0.6 0.2 -0.2 0.1-0.4 0.2-0.5 0.3 -0.1 0.1-0.3 0.1-0.4 0.2 -0.2 0.1-0.4 0.2-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.1-0.4 0.3-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.2-0.4 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.2 0.2-0.3 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.1 0.2-0.3 0.3-0.4 0.5 -0.1 0.1-0.2 0.3-0.3 0.4 -0.1 0.2-0.2 0.3-0.3 0.5 -0.1 0.1-0.2 0.3-0.2 0.4 -0.1 0.2-0.2 0.4-0.3 0.5 -0.1 0.2-0.1 0.3-0.2 0.5 -0.1 0.2-0.2 0.4-0.2 0.6 0 0.1-0.1 0.3-0.1 0.4 -0.1 0.2-0.1 0.5-0.2 0.7 0 0.1-0.1 0.2-0.1 0.3 -0.1 0.3-0.1 0.6-0.1 0.9 0 0.1 0 0.2 0 0.2 0 0.3 0 0.6 0 1 0 0 0 0.1 0 0.1v0.1c0 0.1 0 0.1 0 0.2v34h-32c-6.3 0-11.4 5.1-11.4 11.4v80c0 6.3 5.1 11.4 11.4 11.4h240c6.3 0 11.4-5.1 11.4-11.4v-80c0-6.3-5.1-11.4-11.4-11.4h-32v-34.3c0-3-1.2-5.8-3.1-7.8 0 0 0 0 0 0 -0.2-0.2-0.5-0.5-0.7-0.7 0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.5-0.4-0.7-0.6 -0.1 0-0.1-0.1-0.2-0.1 -0.2-0.2-0.5-0.3-0.8-0.5 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.2-0.6-0.3-0.8-0.4 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.1-0.6-0.3-0.9-0.4 0 0-0.1 0-0.1 0 -0.3-0.1-0.7-0.2-1-0.3 0 0-0.1 0-0.1 0 -26.8-6-44.5-31.1-42.3-57.7 51.6-13.7 92-55.2 104.2-107.5 47.8-20.1 79.6-67.4 79.6-119.6C477.1 72.5 472 67.4 465.7 67.4zM58.4 90.3h52.2v75.6c0 0 0 0.1 0 0.1 0 1.7 0 3.4 0.1 5.1C81.7 154.1 62 124.1 58.4 90.3zM365.1 432v57.1H148V432H365.1zM321.7 386.3v22.9H191.4v-22.9H321.7zM221.9 363.4c3.2-3.4 6.1-7.1 8.7-11.2 8.1-12.7 12.3-27.2 12.2-42 4.3 0.4 8.7 0.6 13.2 0.6 4.8 0 9.6-0.2 14.3-0.7 -0.1 20 7.7 39.1 21 53.3H221.9zM378.4 165.5c0 67.5-54.9 122.5-122.5 122.5s-122.5-54.9-122.5-122.5V22.9h245V165.5zM401.2 171.2c0.1-1.7 0.1-3.4 0.1-5.1 0 0 0-0.1 0-0.1V90.3h52.3C450 124.1 430.3 154.2 401.2 171.2z"}}),_c('path',{attrs:{"d":"M292 449.1H221.1c-6.3 0-11.4 5.1-11.4 11.4S214.8 472 221.1 472h70.9c6.3 0 11.4-5.1 11.4-11.4S298.3 449.1 292 449.1z"}}),_c('path',{attrs:{"d":"M325.2 125.3c-1.3-4.1-4.9-7.2-9.2-7.8l-34-4.9 -15.2-30.8c-1.9-3.9-5.9-6.4-10.2-6.4 -4.4 0-8.3 2.5-10.2 6.4l-15.2 30.8 -34 4.9c-4.3 0.6-7.9 3.6-9.2 7.8 -1.3 4.1-0.2 8.7 2.9 11.7l24.6 24 -5.8 33.8c-0.7 4.3 1 8.6 4.5 11.2 3.5 2.6 8.2 2.9 12 0.9l30.4-16 30.4 16c1.7 0.9 3.5 1.3 5.3 1.3 2.4 0 4.7-0.7 6.7-2.2 3.5-2.6 5.3-6.9 4.5-11.2l-5.8-33.8 24.6-24C325.4 134 326.5 129.4 325.2 125.3zM277.4 148.8c-2.7 2.6-3.9 6.4-3.3 10.1l2.9 16.9 -15.2-8c-1.7-0.9-3.5-1.3-5.3-1.3s-3.7 0.4-5.3 1.3l-15.2 8 2.9-16.9c0.6-3.7-0.6-7.5-3.3-10.1l-12.3-12 17-2.5c3.7-0.5 6.9-2.9 8.6-6.3l7.6-15.4 7.6 15.4c1.7 3.4 4.9 5.7 8.6 6.3l17 2.5L277.4 148.8z"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Kunden ønsker "),_c('br'),_vm._v("luksus standard")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3",staticStyle:{"height":"140px"}},[(_vm.itemSelect.numpartner)?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[[(_vm.itemSelect.numpartner === '1')?_c('div',[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '2')?_c('div',[_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '3')?_c('div',[_c('div',{staticClass:"block flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block flex justify-center items-center center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])])]):_c('div',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]],2):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v("1")]),_vm._v(" tilbud på opgaven")])])]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-top mediumgrey-border",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[[(_vm.itemSelect.other352798 === '1' && _vm.itemSelect.other352800 === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler "),_c('br'),_vm._v("dansk og engelsk")])]):(_vm.itemSelect.other352798 === '1' && _vm.itemSelect.other352800 === '0')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])]):(_vm.itemSelect.other352798 === '0' && _vm.itemSelect.other352800 === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun engelsk")])]):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-left border-top mediumgrey-border",staticStyle:{"height":"140px"}},[[(_vm.itemSelect.other352801 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1605_"}},[_c('g',{attrs:{"id":"XMLID_137_"}},[_c('path',{attrs:{"id":"XMLID_139_","d":"m278.661 230.088c3.905-3.905 3.905-10.237 0-14.143s-10.237-3.905-14.143 0c-4.696 4.697-12.34 4.697-17.036 0-3.905-3.905-10.237-3.905-14.143 0s-3.905 10.237 0 14.143c6.248 6.247 14.454 9.371 22.661 9.371s16.413-3.124 22.661-9.371z"}}),_c('path',{attrs:{"id":"XMLID_418_","d":"m256.131 55.126c-16.913 0-30.672 13.76-30.672 30.672s13.76 30.672 30.672 30.672 30.672-13.76 30.672-30.672-13.759-30.672-30.672-30.672zm0 41.345c-5.885 0-10.672-4.788-10.672-10.672s4.788-10.672 10.672-10.672 10.672 4.788 10.672 10.672-4.787 10.672-10.672 10.672z"}}),_c('path',{attrs:{"id":"XMLID_419_","d":"m256 492c-2.63 0-5.21 1.069-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.07-2.931c1.86-1.859 2.93-4.439 2.93-7.069s-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93z"}}),_c('path',{attrs:{"id":"XMLID_422_","d":"m356.956 301.815h-49.611v-29.317c24.906-16.635 41.344-44.997 41.344-77.13v-37.554h85.093c5.523 0 10-4.477 10-10s-4.477-10-10-10h-76.824v-64.42c0-32.871-26.742-59.613-59.613-59.613h-31.345v-3.781c0-5.523-4.477-10-10-10s-10 4.477-10 10v3.782h-31.345c-32.871 0-59.613 26.742-59.613 59.613v74.42c0 4.931 3.573 9.019 8.269 9.84v37.714c0 32.133 16.438 60.495 41.344 77.13v29.317h-49.611c-61.007 0-110.641 49.633-110.641 110.64v89.544c0 5.522 4.477 10 10 10h156.597c5.523 0 10-4.478 10-10s-4.477-10-10-10h-85v-60h20v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h92v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h20v60h-85c-5.523 0-10 4.478-10 10s4.477 10 10 10h156.596c5.523 0 10-4.478 10-10v-89.545c0-61.007-49.633-110.64-110.64-110.64zm-181.914-228.42c0-21.843 17.771-39.613 39.613-39.613h82.689c21.843 0 39.613 17.771 39.613 39.613v64.42h-161.915zm8.269 121.974v-37.554h145.378v37.554c0 40.081-32.608 72.689-72.689 72.689s-72.689-32.608-72.689-72.689zm72.689 92.69c10.997 0 21.55-1.929 31.345-5.46v25.786c0 17.283-14.061 31.345-31.345 31.345s-31.345-14.062-31.345-31.345v-25.786c9.795 3.53 20.348 5.46 31.345 5.46zm-140 123.941c-5.523 0-10 4.478-10 10v70h-41.596v-79.545c0-46.926 35.847-85.636 81.596-90.189v89.734zm74 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm20-28v-80.841c8.408 16.914 25.865 28.571 46 28.571s37.592-11.656 46-28.571v80.841zm136 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm101.596 52h-41.596v-70c0-5.522-4.477-10-10-10h-30v-89.734c45.749 4.553 81.596 43.263 81.596 90.189z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden ønsker en ung fagmand")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.other352803 === '1')?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M293.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S293.5 243.1 293.5 250z"}}),_c('path',{attrs:{"d":"M193.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S193.5 243.1 193.5 250z"}}),_c('path',{attrs:{"d":"M191 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C180.1 225.1 186.2 226.8 191 224z"}}),_c('path',{attrs:{"d":"M291 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C280.1 225.1 286.2 226.8 291 224z"}}),_c('path',{attrs:{"d":"M258 120.8l0.2 0c0.2 0 0.4 0 0.7 0 5.2 0 9.6-4.1 10-9.3 0.4-5.5-3.8-10.3-9.3-10.6 -0.2 0-0.4 0-0.6 0 -5.5-0.3-10.2 4-10.4 9.6C248.2 115.9 252.5 120.6 258 120.8z"}}),_c('path',{attrs:{"d":"M502 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10H502c5.5 0 10-4.5 10-10C512 496.5 507.5 492 502 492z"}}),_c('path',{attrs:{"d":"M10.2 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.2c5.5 0 10-4.5 10-10C20.2 496.5 15.8 492 10.2 492z"}}),_c('path',{attrs:{"d":"M473 492h-7.3c-3.3-70-41.4-133.5-101.7-169.8 12.1-18.1 19.8-39.3 21.5-62.2h0.4c22.1 0 40-17.9 40-40 0-18.6-12.8-34.3-30-38.7v-27.7c33-12.1 54.9-30.7 63.7-54.4 0 0 0 0 0 0 0.1-0.3 0.2-0.6 0.3-0.9 0 0 0 0 0 0 0.1-0.2 0.1-0.5 0.2-0.7 0-0.1 0-0.2 0.1-0.2 0-0.3 0.1-0.5 0.1-0.8 0-0.1 0-0.2 0-0.2 0-0.2 0-0.4 0-0.6 0-0.1 0-0.3 0-0.4 0-0.1 0-0.2 0-0.3 -0.1-1.4-0.5-2.8-1.2-4 -0.6-1.1-1.4-2.1-2.3-2.9 -0.1-0.1-0.2-0.2-0.4-0.3 -0.1-0.1-0.1-0.1-0.2-0.1 -0.2-0.1-0.4-0.3-0.6-0.4 0 0-0.1 0-0.1-0.1 -0.2-0.1-0.5-0.3-0.8-0.4 0 0-0.1 0-0.1-0.1 -0.3-0.1-0.5-0.2-0.8-0.3 0 0 0 0 0 0 -0.1-0.1-0.3-0.1-0.4-0.1 -0.2-0.1-0.3-0.1-0.5-0.2 -20.6-5.5-36-17.8-53.9-32.1C367.4 28.6 331.5 0 256 0c-31.9 0-61.4 10.8-85 28.8 -0.7 0.4-1.3 0.9-1.9 1.4 -11.9 9.4-22.2 20.7-30.5 33.4 -0.5 0.6-0.9 1.2-1.2 1.8 -13.6 21.6-21.5 47.1-21.5 74.5v41.3C98.8 185.7 86 201.4 86 220c0 22.1 17.9 40 40 40h0.4c1.7 22.9 9.4 44.1 21.5 62.2 -60.3 36.4-98.3 99.9-101.7 169.8h-7.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h16.9c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h109.5c0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0h109.5c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h16.9c5.5 0 10-4.5 10-10C483 496.5 478.6 492 473 492zM106 492H66.3c2.1-39.2 16.2-76.2 39.7-106.4V492zM170.1 56.3c4.8 19.5 16.5 48 56.7 59.6 0.9 0.3 1.9 0.4 2.8 0.4 4.3 0 8.3-2.9 9.6-7.2 1.5-5.3-1.5-10.8-6.8-12.4C196.3 86.3 191.1 60 187.6 42.6c-0.1-0.3-0.1-0.6-0.2-1C206.8 28 230.5 20 256 20c68.5 0 100.1 25.2 130.6 49.5 15.7 12.6 30.8 24.5 49.7 32 -11.4 17.7-35.2 31.6-68.4 39.7 -66.2 16.1-156.9 5.9-186.9-21 -6.6-6.5-18.3-18.2-23.9-47.9C160.9 66.6 165.3 61.2 170.1 56.3zM376 159.7v20.3c-8.2 0-14.8-5.4-19.7-16 5.6-1 11-2.1 16.3-3.4C373.7 160.3 374.9 160 376 159.7zM136 140c0-14.6 2.6-28.7 7.5-41.6 6.3 17 14.4 26.8 20.3 32.9 -2.4 24.2-11.8 48.7-27.8 48.7V140zM146 250c0-5.5-4.5-10-10-10h-10c-11 0-20-9-20-20 0-11 9-20 20-20h10c10.3 0 24.9-4.2 35.8-24.2 5.3-9.7 8.4-20.6 10.2-30.6 18.1 10.1 43.8 17.5 74.7 21.2 26.1 3.1 53.5 3.2 79.1 0.4 10.9 28.6 29.5 33.1 40.2 33.1h10c11 0 20 9 20 20 0 11-9 20-20 20h-10c-5.5 0-10 4.5-10 10 0 25.7-8.8 49.3-23.6 68 -0.3 0.2-0.5 0.5-0.7 0.8 0 0 0 0-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -0.2 0.2-0.3 0.4-0.5 0.6 0 0 0 0.1-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -9.8 11.9-22.1 21.6-36 28.5 -0.6 0.2-1.1 0.5-1.6 0.8 -14.3 6.8-30.3 10.7-47.2 10.7 -16.9 0-32.9-3.8-47.2-10.6 -0.5-0.3-1.1-0.6-1.6-0.8 -13.9-6.9-26.1-16.7-36-28.5 -0.1-0.1-0.1-0.2-0.2-0.3 0 0 0 0 0 0 -0.2-0.3-0.4-0.5-0.6-0.8 0 0 0 0 0 0 -0.2-0.2-0.4-0.4-0.6-0.6 -0.1-0.1-0.1-0.1-0.2-0.2C154.8 299.3 146 275.7 146 250zM291.5 375.1l-10.2 27.9 -10.4-23.9C278 378.3 284.8 377 291.5 375.1zM241.1 379.1l-10.4 23.9 -10.2-27.9C227.2 377 234 378.3 241.1 379.1zM126 492V363.7h0c9-8.5 18.9-16.1 29.6-22.8l15.4 77.7 -22.8 24.4c-1.9 2.1-2.9 4.9-2.6 7.7 0.3 2.8 1.7 5.4 4 7.1l45.9 34.2H126zM228.9 492l-58.4-43.6 18.6-20c2.2-2.4 3.1-5.6 2.5-8.8l-12.9-65.2c5.3 4 11 7.5 16.9 10.6l46.2 126.9H228.9zM256 472.7l-15.4-42.4 15.4-35.3 15.4 35.3L256 472.7zM283.1 492h-12.8l46.2-126.9c5.9-3.1 11.5-6.7 16.9-10.6l-12.9 65.2c-0.6 3.2 0.3 6.4 2.5 8.8l18.6 20L283.1 492zM386 492h-69.5l45.9-34.2c2.3-1.7 3.7-4.3 4-7.1 0.3-2.8-0.7-5.6-2.6-7.7l-22.8-24.4 15.4-77.7c10.7 6.7 20.6 14.3 29.6 22.8V492zM406 492V385.6c23.5 30.2 37.7 67.2 39.7 106.4H406z"}}),_c('path',{attrs:{"d":"M218.4 329.4c9.7 0 20.6-2.6 30.6-7.3 2.6-1.2 4.9-2.7 7-4.4 2 1.7 4.3 3.2 7 4.4 10 4.7 20.9 7.3 30.6 7.3 0 0 0 0 0 0 21.7 0 37.3-11.9 44.1-33.6 1.2-4-0.1-8.3-3.4-10.9 -3.3-2.6-7.8-2.8-11.3-0.7 -0.1 0-5.6 3.2-13.1 3.2 0 0 0 0 0 0 -6.8 0-13.2-2.7-18.9-7.9 -7.5-6.9-14.8-8.4-19.5-8.4 -5.8 0-11.2 2.1-15.5 5.7 -4.3-3.6-9.7-5.7-15.5-5.7 -4.7 0-12 1.5-19.5 8.4 -5.7 5.3-12.1 7.9-18.9 7.9 -7.5 0-13.1-3.2-13.1-3.2 -3.5-2.2-8-2-11.3 0.6 -3.3 2.6-4.6 7-3.4 11C181.1 317.4 196.8 329.4 218.4 329.4zM266.6 296c0.5-2.4 2.5-5 4.9-5 1.7 0 3.8 1.1 6 3.1 8.1 7.5 17.6 11.9 27.6 12.9 -3.3 1.5-7.2 2.3-11.5 2.3 -6.9 0-14.7-1.9-22.1-5.4C267.5 302.1 265.8 299.4 266.6 296zM234.5 294.2c2.2-2 4.3-3.1 6-3.1 2.5 0 4.4 2.6 4.9 5 0.8 3.4-0.9 6.1-4.9 8 -7.4 3.5-15.3 5.4-22.1 5.4 -4.4 0-8.2-0.8-11.5-2.3C216.9 306 226.4 301.6 234.5 294.2z"}})])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden ønsker"),_c('br'),_vm._v("en erfaren fagmand")])]):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',{staticClass:"darkblue gibson center line-height-2",staticStyle:{"font-size":"12.5px"}},[_vm._v("Erfaringsniveau "),_c('br'),_vm._v("har ingen betydning")])])]],2)]):_vm._e(),_vm._v(" "),(_vm.itemSelect.mester === '1')?_c('div',{staticClass:"clearfix flex flex-wrap my1"},[_c('div',{staticClass:"col col-6 gibson py3 border-right mediumgrey-border ",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center"},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"}}),_c('path',{attrs:{"d":"M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"}}),_c('path',{attrs:{"d":"M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"}}),_c('path',{attrs:{"d":"M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Opstartsdato: "),_c('br'),_vm._v(_vm._s(_vm.moment(_vm.itemSelect.mesterinfo.startdate1).locale('da').format('LL')))])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3  mediumgrey-border",staticStyle:{"height":"140px"}},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"M478.2 194l15-15c4.3-4.3 6.7-10.1 6.7-16.2s-2.4-11.9-6.7-16.2l-17.2-17.2c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-15 15c-19.8-13.6-42.3-23.7-66.4-29.1V93.1h9.1c12.4 0 22.4-10.1 22.4-22.4V39.5c0-12.4-10.1-22.4-22.4-22.4H268.1c-12.4 0-22.4 10.1-22.4 22.4v31.2c0 12.4 10.1 22.4 22.4 22.4h9.1v22.2c-24.1 5.5-46.4 15.5-66.1 29.1l-15-15c-4.3-4.3-10.1-6.7-16.2-6.7 -6.1 0-11.9 2.4-16.2 6.7l-17.2 17.2c-8.9 9-8.9 23.5 0 32.5l2.7 2.7H78.2c-5.5 0-10 4.5-10 10s4.5 10 10 10h78.2c-7.5 12-13.6 24.9-18.3 38.4H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h122.4c-2.8 12.4-4.4 25.3-4.7 38.4H64c-5.5 0-10 4.5-10 10s4.5 10 10 10h64.2c1.1 13.2 3.5 26.1 7.1 38.4H50c-5.5 0-10 4.5-10 10s4.5 10 10 10h92.5c29.1 69.2 97.6 118 177.3 118 106 0 192.2-86.2 192.2-192.2C512 262.4 499.5 224.9 478.2 194zM457.7 143.5c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l17.2 17.2c0.7 0.7 0.9 1.5 0.9 2.1s-0.1 1.4-0.9 2.1l-13.1 13.1c-6.6-7.7-13.7-14.8-21.4-21.4L457.7 143.5zM265.6 70.6V39.5c0-1.3 1.1-2.4 2.4-2.4h103.2c1.3 0 2.4 1.1 2.4 2.4v31.2c0 1.3-1.1 2.4-2.4 2.4h-19.1 -64.9 -19.1C266.7 73.1 265.6 72 265.6 70.6zM297.2 93.1h44.9v18.8c-7.3-0.9-14.8-1.3-22.3-1.3 -7.6 0-15.2 0.5-22.6 1.3V93.1zM160.5 160.7l17.2-17.2c0.7-0.7 1.5-0.9 2.1-0.9 0.6 0 1.4 0.2 2.1 0.9l13.1 13.1c-7.7 6.6-14.8 13.7-21.4 21.4l-13.1-13.1C159.4 163.7 159.4 161.8 160.5 160.7zM319.8 474.9c-95 0-172.2-77.3-172.2-172.2s77.3-172.2 172.2-172.2 172.2 77.3 172.2 172.2S414.7 474.9 319.8 474.9z"}}),_c('path',{attrs:{"d":"M385.8 222.6l-47.3 47.3c-5.5-3.2-11.9-5-18.7-5 -20.9 0-37.9 17-37.9 37.9 0 20.9 17 37.9 37.9 37.9s37.9-17 37.9-37.9c0-6.8-1.8-13.2-5-18.7l47.3-47.3c3.9-3.9 3.9-10.2 0-14.1C396 218.7 389.7 218.7 385.8 222.6zM319.8 320.6c-9.8 0-17.9-8-17.9-17.9s8-17.9 17.9-17.9 17.9 8 17.9 17.9S329.6 320.6 319.8 320.6z"}}),_c('path',{attrs:{"d":"M319.8 173.1c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1 -1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9 -2.9 4.4-2.9 7.1c0 2.6 1.1 5.2 2.9 7.1S317.2 173.1 319.8 173.1z"}}),_c('path',{attrs:{"d":"M319.8 432.4c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1s-1.1-5.2-2.9-7.1C325 433.5 322.4 432.4 319.8 432.4z"}}),_c('path',{attrs:{"d":"M221 194c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 195.1 223.7 194 221 194z"}}),_c('path',{attrs:{"d":"M418.5 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C423.8 392.6 421.2 391.5 418.5 391.5z"}}),_c('path',{attrs:{"d":"M221 391.5c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1s4.4 2.9 7.1 2.9 5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C226.3 392.6 223.7 391.5 221 391.5z"}}),_c('path',{attrs:{"d":"M180.1 292.7c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C185.4 293.8 182.8 292.7 180.1 292.7z"}}),_c('path',{attrs:{"d":"M466.5 295.7c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9 2.9-4.4 2.9-7.1C469.4 300.1 468.4 297.5 466.5 295.7z"}}),_c('path',{attrs:{"d":"M10 357c-2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1 0-2.6-1.1-5.2-2.9-7.1C15.2 358 12.6 357 10 357z"}}),_c('path',{attrs:{"d":"M456.5 272.4c5.3-1.6 8.3-7.1 6.7-12.4 -7.1-23.7-20.1-45.6-37.7-63.1 -17.6-17.6-39.5-30.6-63.2-37.6 -5.3-1.6-10.9 1.5-12.4 6.8s1.5 10.9 6.8 12.4c42.2 12.5 74.9 45.1 87.5 87.3 1.3 4.3 5.3 7.1 9.6 7.1C454.6 272.8 455.5 272.7 456.5 272.4z"}})])])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Varighed: "+_vm._s(_vm.itemSelect.mesterinfo.duration1.replace('d',' dage').replace('t',' timer'))+" ")])])]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-right border-top mediumgrey-border",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[[(_vm.itemSelect.mesterinfo.en === '1' && _vm.itemSelect.mesterinfo.dk === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler "),_c('br'),_vm._v("dansk og engelsk")])]):(_vm.itemSelect.mesterinfo.en === '0' && _vm.itemSelect.mesterinfo.dk === '1')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])]):(_vm.itemSelect.mesterinfo.en === '1' && _vm.itemSelect.mesterinfo.dk === '0')?_c('div',[_c('span',{staticClass:"darkblue inline-block",staticStyle:{"height":"88px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun engelsk")])]):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2 center"},[_c('div',[_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson center",staticStyle:{"font-size":"12.5px"}},[_vm._v("Kunden taler kun dansk")])])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-top mediumgrey-border",staticStyle:{"height":"140px"}},[(_vm.itemSelect.numpartner)?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[[(_vm.itemSelect.numpartner === '1')?_c('div',[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '2')?_c('div',[_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])]):(_vm.itemSelect.numpartner === '3')?_c('div',[_c('div',{staticClass:"block flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block flex justify-center items-center center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v(_vm._s(_vm.itemSelect.numpartner))]),_vm._v(" tilbud på opgaven")])])]):_c('div',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]],2):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v("1")]),_vm._v(" tilbud på opgaven")])])])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.step ===2)?_c('div',{staticClass:"mt-4"},[(_vm.itemSelect.monthlyp !== '1' && _vm.itemSelect.appointment_free >= 0)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"p2 flex justify-center items-center"},[_c('p',{staticClass:"h5 primarycolor line-height-1 mb0"},[_vm._v("\n                Du har "+_vm._s(_vm.itemSelect.appointment_free)+" gratis møde til gode\n              ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 p0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center border-top",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[_c('button',{staticClass:"col-6 outlined-disabled-button no-border p3 h5 not-rounded gibson flex justify-center items-center",staticStyle:{"border":"0!important"},on:{"click":function($event){_vm.itemShow = false}}},[_c('span',[_vm._v("←")]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),(_vm.step === 2)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":_vm.nextStep}},[_c('span',{staticClass:"mx2"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud !== 1 && _vm.step === 1)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve || _vm.itemloading},on:{"click":function($event){return _vm.reservedItem()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud === 1 && _vm.step === 1)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve || _vm.itemloading},on:{"click":function($event){return _vm.reservedItemTilbud()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])]),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ ok: _vm.confirmRecommendreservation('yes'), cancel: _vm.confirmRecommendreservation('no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}),expression:"{ ok: confirmRecommendreservation('yes'), cancel: confirmRecommendreservation('no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}"}],staticClass:"hide",attrs:{"type":"button","id":"marketplacereserve"}},[_vm._v("Recommend Invitation")])],2):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"itemModal",attrs:{"centered":"","lazy":""},model:{value:(_vm.itemShowMester),callback:function ($$v) {_vm.itemShowMester=$$v},expression:"itemShowMester"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"relative"},[_c('img',{staticClass:"fit block",staticStyle:{"height":"150px","width":"100%","object-fit":"none"},attrs:{"data-key":_vm.itemSelect.id + 'd',"src":_vm.itemSelect.productimage,"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.id + 'd')}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.postnumber2)+" "+_vm._s(_vm.itemSelect.postnumbercity2))]),_vm._v(" "),(_vm.itemSelect.match)?_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.match))]),_vm._v(" %")]):_vm._e()])])]}),_vm._v(" "),_c('div',{staticClass:"modal-body-marketplace"},[_c('div',{staticClass:"clearfix px2"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center mt3 mb2"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n              "+_vm._s(_vm.itemSelect.productname)+"\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson mb1 p0 line-height-1"},[_vm._v("Arbejdskraft")])])]),_vm._v(" "),(_vm.step ===1)?_c('div',[_c('div',{staticClass:"clearfix mb1"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.comments",modifiers:{"comments":true}}],staticClass:"col-12 outlined-dark-button p2 gibson h5 not-rounded flex justify-between items-center"},[_c('span',[_vm._v("Se beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-collapse',{attrs:{"id":"comments"}},[_c('div',{staticClass:"clearfix flex flex-column p2"},[_c('div',[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1"},[_vm._v("Notes")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n                    "+_vm._s(_vm.itemSelect.desc2)+"\n                  ")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-center pt2"},[_c('div',[_c('p',{staticClass:"h5 semi-bold primarycolor gibson line-height-1"},[_vm._v("\n                  Vigtig info om kunden og opgaven\n                ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap mt2 mb3"},[_c('div',{staticClass:"col col-6 gibson py3 border-right mediumgrey-border ",staticStyle:{"height":"140px"}},[_c('div',{staticClass:"flex flex-column justify-center items-center"},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_c('p',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson line-height-1 center mb0"}},[_vm._v("Opstartsdato : "),_c('br'),_vm._v(_vm._s(_vm.moment(_vm.itemSelect.startdate2).locale('da').format('LL')))])])]],2)]),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3  mediumgrey-border",staticStyle:{"height":"140px"}},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"height":"40pt","viewBox":"-76 -21 681 681.33468","width":"70pt","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m261.761719 331.40625c91.34375 0 165.65625-74.3125 165.65625-165.660156 0-91.34375-74.3125-165.6640628-165.65625-165.6640628-26.539063 0-51.898438 6.0937498-75.367188 18.1015628-6.144531 3.140625-8.574219 10.671875-5.433593 16.8125 3.144531 6.144531 10.671874 8.570312 16.8125 5.433594 19.917968-10.191407 41.445312-15.355469 63.988281-15.355469 77.5625 0 140.671875 63.101562 140.671875 140.671875 0 77.566406-63.109375 140.671875-140.671875 140.671875-77.570313 0-140.679688-63.105469-140.679688-140.671875 0-21.316406 4.640625-41.777344 13.792969-60.832032 2.992188-6.21875.371094-13.6875-5.847656-16.671874-6.222656-2.988282-13.683594-.367188-16.675782 5.851562-10.785156 22.457031-16.257812 46.5625-16.257812 71.652344.003906 91.34375 74.316406 165.660156 165.667969 165.660156zm0 0"}}),_c('path',{attrs:{"d":"m165.902344 224.25 34.957031 34.957031c5.183594 5.183594 12.082031 8.039063 19.414063 8.039063 7.332031 0 14.226562-2.855469 19.410156-8.035156l103.519531-103.519532c5.84375-5.847656 8.726563-13.921875 7.90625-22.148437l-2.183594-21.792969c-1.054687-10.503906-7.851562-19.3125-17.746093-22.996094-9.890626-3.679687-20.796876-1.453125-28.457032 5.808594l-77.613281 73.582031c-.984375.929688-2.542969.890625-3.480469-.089843-5.210937-5.460938-12.507812-8.535157-20.082031-8.5-7.554687.066406-14.824219 3.28125-19.953125 8.832031l-16.449219 17.832031c-10.035156 10.867188-9.699219 27.574219.757813 38.03125zm17.601562-21.082031 16.453125-17.832031c.601563-.648438 1.308594-.789063 1.792969-.792969h.027344c.480468 0 1.175781.136719 1.777344.765625 10.417968 10.914062 27.800781 11.347656 38.746093.96875l77.617188-73.582032c.738281-.703124 1.597656-.878906 2.554687-.523437.953125.359375 1.492188 1.050781 1.59375 2.0625l2.175782 21.792969c.074218.742187-.183594 1.46875-.703126 1.988281l-103.519531 103.523437c-.601562.59375-1.277343.722657-1.746093.722657-.460938 0-1.144532-.128907-1.738282-.722657l-34.960937-34.960937c-.941407-.933594-.96875-2.4375-.070313-3.410156zm0 0"}}),_c('path',{attrs:{"d":"m147.0625 71.128906.386719.292969c2.253906 1.710937 4.90625 2.535156 7.539062 2.535156 3.777344 0 7.507813-1.707031 9.964844-4.945312 4.167969-5.496094 3.089844-13.339844-2.414063-17.503907l-.382812-.289062c-5.492188-4.171875-13.332031-3.089844-17.5 2.40625-4.171875 5.496094-3.089844 13.339844 2.40625 17.503906zm0 0"}}),_c('path',{attrs:{"d":"m510.550781 539.585938c-8.089843-12.550782-20.71875-21.023438-35.007812-23.886719 2.800781-5.683594 4.378906-12.074219 4.378906-18.828125v-25.550782c0-.242187-.011719-.484374-.019531-.722656 0-.078125.011718-.148437.011718-.226562-.003906-.367188-.03125-.722656-.042968-1.089844-.007813-.074219-.007813-.152344-.011719-.230469-1.046875-22.457031-19.800781-40.511719-42.421875-40.511719h-2.558594c-4.980468 0-9.753906.867188-14.199218 2.445313.832031-3.332031 1.269531-6.792969 1.28125-10.320313l.074218-25.558593c0-.242188-.015625-.480469-.019531-.71875 0-.078125.011719-.152344.011719-.230469-.003906-.355469-.027344-.710938-.042969-1.070312-.003906-.085938-.003906-.171876-.007813-.253907-.992187-22.457031-19.691406-40.5625-42.3125-40.625h-.28125c-.003906 0-.011718 0-.015624 0h-.929688l-1.332031-.003906c-.039063 0-.078125 0-.121094 0-22.753906 0-41.398437 17.992187-42.4375 40.519531-.003906.09375-.003906.1875-.007813.277344-.019531.523438-.039062 1.050781-.042968 1.574219v.070312c0 .074219-.007813.144531-.007813.21875l-.070312 25.554688c-.019531 6.695312 1.507812 13.035156 4.25 18.695312-12.367188 2.269531-23.53125 8.757813-31.679688 18.433594-.320312-.046875-.640625-.109375-.964843-.15625 4.507812-7.519531 7.105468-16.304687 7.105468-25.695313v-31.765624c0-.285157-.011718-.574219-.019531-.855469 0-.09375.015625-.1875.011719-.277344-.003906-.441406-.035156-.875-.054688-1.308594 0-.066406-.003906-.128906-.003906-.191406-1.203125-26.332031-23.1875-47.507813-49.707031-47.507813h-3.179688c-27.449219 0-49.785156 22.332032-49.785156 49.785157v.066406c0 .097656-.007813.191406-.007813.289063v31.765624c0 9.34375 2.570313 18.085938 7.039063 25.578126-.585937.074218-1.164063.167968-1.746094.253906-8.15625-9.675782-19.328125-16.160156-31.703125-18.417969 2.746094-5.683594 4.203125-11.957031 4.222656-18.453125l.066407-25.550781c0-.246094-.007813-.484375-.015625-.734375 0-.074219.011718-.140625.011718-.214844-.003906-.316406-.023437-.628906-.035156-.945312-.003906-.121094-.007812-.242188-.015625-.367188-.976562-22.460938-19.683593-40.574219-42.308593-40.636719h-.28125c-.007813 0-.011719 0-.015626 0l-.929687-.003906-1.332031-.003906c-.039063 0-.078125 0-.121094 0-11.300781 0-21.941406 4.390625-29.957031 12.363281-8.050781 8.003906-12.5 18.664062-12.527344 30.011719v.019531c-.007813.089844-.011719.183594-.011719.269531l-.074218 25.550781c-.007813 3.519532.40625 6.96875 1.21875 10.296876-4.222657-1.421876-8.730469-2.203126-13.40625-2.203126h-2.558594c-23.429688 0-42.488282 19.058594-42.488282 42.492188v.046875c0 .078125-.003906.160156-.003906.238281v25.554688c0 6.699218 1.546875 13.039062 4.300782 18.6875-14.574219 2.71875-27.488282 11.269531-35.710938 24.027344-10.136719 15.730468-15.492188 33.933593-15.492188 52.648437v33.4375c0 6.902344 5.59375 12.496094 12.496094 12.496094 24.515625 0 50.71875.078125 76.066406.152343 26.199219.078126 53.292969.160157 79.507813.160157 33.375 0 61.859375.089843 92.015625.183593 30.945312.097657 62.941406.203126 101.378906.203126 1.40625 0 2.746094-.246094 4.003906-.667969 21.507813.003906 43.253907.070312 66.195313.140625 26.960937.082031 54.839844.164062 85.378906.164062 6.898438 0 12.492188-5.59375 12.492188-12.488281v-33.75c0-18.710937-5.355469-36.917969-15.492188-52.648437zm-75.394531-86.058594h1.984375c5.683594 0 10.734375 2.6875 13.992187 6.835937-7.335937.734375-14.359374 3.425781-21.21875 6.070313-1.625.621094-3.285156 1.261718-4.972656 1.882812-.023437.011719-1.921875.578125-7.269531-.203125 1.515625-8.285156 8.773437-14.585937 17.484375-14.585937zm-17.785156 39.691406c1.820312.175781 3.566406.273438 5.214844.273438 4.214843 0 7.859374-.574219 10.976562-1.722657 1.820312-.667969 3.59375-1.351562 5.324219-2.015625 6.359375-2.449218 11.976562-4.597656 16.046875-4.578125v11.695313c0 9.550781-7.570313 17.34375-17.023438 17.753906h-3.523437c-9.449219-.410156-17.015625-8.203125-17.015625-17.753906zm-52.648438-110.851562c3.359375-3.335938 7.808594-5.175782 12.550782-5.175782h1.0625l.972656.007813c5.679687.011719 10.722656 2.710937 13.96875 6.875-7.339844.707031-14.367188 3.386719-21.238282 6.007812-1.628906.621094-3.289062 1.253907-4.972656 1.867188-.027344.007812-1.933594.574219-7.28125-.222657.648438-3.53125 2.339844-6.777343 4.9375-9.359374zm-5.304687 34.5c1.859375.183593 3.632812.292968 5.304687.292968 4.152344 0 7.75-.582031 10.898438-1.730468 1.816406-.664063 3.585937-1.339844 5.320312-2.003907 6.371094-2.425781 11.988282-4.566406 16.0625-4.53125l-.035156 11.695313c-.011719 4.75-1.875 9.214844-5.242188 12.566406-3.175781 3.160156-7.339843 4.953125-11.789062 5.136719l-3.570312-.007813c-9.445313-.441406-16.984376-8.25-16.960938-17.796875zm-123.917969-19.378907c.003906-.070312.007812-.144531.019531-.21875 1.332031-12.621093 12.035157-22.488281 25.003907-22.488281h2.464843c10 0 18.632813 5.875 22.6875 14.351562-10.503906-.117187-20.699219 3.757813-30.582031 7.558594-2.03125.785156-4.113281 1.582032-6.242188 2.367188-1.476562.546875-5.722656.820312-13.402343-.597656.015625-.324219.015625-.65625.050781-.972657zm-.128906 26.265625c3.417968.464844 6.59375.71875 9.511718.71875 4.867188 0 9.054688-.65625 12.609376-1.96875 2.246093-.824218 4.433593-1.667968 6.574218-2.488281 9.683594-3.730469 18.050782-6.945313 24.078125-5.578125v17.257812c0 13.542969-10.769531 24.59375-24.191406 25.105469h-4.390625c-13.421875-.511719-24.191406-11.558593-24.191406-25.105469zm-104.414063-41.386718c3.359375-3.335938 7.808594-5.175782 12.542969-5.175782h1.066406l.976563.007813c.527343 0 1.042969.03125 1.558593.078125.074219.007812.152344.007812.226563.011718 4.070313.414063 7.84375 2.207032 10.773437 5.152344.511719.515625.972657 1.066406 1.417969 1.632813-7.34375.707031-14.371093 3.382812-21.253906 6.007812-1.621094.621094-3.289063 1.253907-4.96875 1.867188-.023437.007812-1.929687.574219-7.277344-.222657.648438-3.53125 2.339844-6.777343 4.9375-9.359374zm-5.308593 34.5c1.863281.183593 3.636718.292968 5.3125.292968 4.148437 0 7.746093-.582031 10.894531-1.730468 1.816406-.664063 3.585937-1.339844 5.320312-2 6.363281-2.429688 11.988281-4.570313 16.0625-4.535157l-.03125 11.695313c-.011719 4.753906-1.878906 9.214844-5.246093 12.566406-3.128907 3.109375-7.207032 4.898438-11.578126 5.128906l-3.617187.007813c-4.519531-.164063-8.742187-1.988281-11.949219-5.214844-3.347656-3.367187-5.1875-7.839844-5.175781-12.589844zm-39.460938 36.632812h1.980469c5.679687 0 10.734375 2.683594 13.992187 6.835938-7.339844.730468-14.359375 3.425781-21.226562 6.066406-1.625.628906-3.285156 1.269531-4.960938 1.882812-.023437.007813-1.929687.574219-7.277344-.207031 1.519532-8.277344 8.777344-14.578125 17.492188-14.578125zm-17.792969 39.71875c1.816407.183594 3.546875.28125 5.183594.28125 4.203125 0 7.835937-.589844 11.015625-1.761719 1.8125-.667969 3.582031-1.34375 5.304688-2.011719 6.367187-2.445312 11.984374-4.601562 16.058593-4.574218v11.6875c0 9.554687-7.566406 17.351562-17.015625 17.753906h-3.523437c-9.457031-.402344-17.023438-8.199219-17.023438-17.753906zm83.6875 120.234375c-22.230469-.019531-44.902343-.085937-66.9375-.148437-21.109375-.066407-42.808593-.132813-63.652343-.148438v-20.949219c0-13.902343 3.984374-27.425781 11.515624-39.113281 5.449219-8.460938 14.714844-13.507812 24.78125-13.507812h26.855469c.511719.019531 1.023438.039062 1.542969.039062h1.980469c.519531 0 1.03125-.023438 1.542969-.039062h26.082031c10.0625 0 19.324219 5.046874 24.777343 13.507812 7.53125 11.6875 11.511719 25.210938 11.511719 39.113281zm1.746094-83.367187c-7.503906-7.34375-16.945313-12.347657-27.261719-14.414063 2.800782-5.6875 4.378906-12.074219 4.378906-18.832031v-25.554688c0-.234375-.011718-.46875-.019531-.699218 0-.085938.015625-.164063.015625-.246094-.003906-.390625-.03125-.773438-.046875-1.160156 0-.042969-.003906-.085938-.003906-.128907-.089844-1.945312-.3125-3.859375-.660156-5.734375l11.980469-.03125c.367187.007813.734374.027344 1.105468.027344l1.976563.003906h.128906c.679687 0 1.363281-.011718 2.039063-.046875l26.546874-.074219h.082032c5.554687 0 10.863281 1.546876 15.429687 4.347657-7.335937 4.863281-13.71875 11.226562-18.65625 18.898437-8.605469 13.347656-14.355469 28.171875-17.035156 43.644532zm191.652344 62.148437v21.609375c-32.960938-.019531-61.296875-.113281-88.808594-.199219-26.34375-.082031-51.421875-.160156-79.597656-.179687v-63.222656c0-17.863282 5.117187-35.246094 14.792969-50.261719 5.136718-7.976563 12.804687-13.695313 21.585937-16.410157.535156-.117187 1.0625-.261718 1.578125-.453124 3.28125-.867188 6.699219-1.324219 10.191406-1.324219h24.042969v42.171875c0 6.902344 5.59375 12.496094 12.496094 12.496094 6.894531 0 12.488281-5.59375 12.488281-12.496094v-42.171875h23.074219c13.554687 0 26.019531 6.796875 33.359375 18.1875 9.679687 15.015625 14.796875 32.398437 14.796875 50.261719zm6.207031-105.792969c-4.925781-7.644531-11.285156-13.996094-18.589844-18.855468 4.574219-2.832032 9.910156-4.390626 15.496094-4.390626h.082031l26.851563.078126c.515625.019531 1.035156.039062 1.554687.042968l1.972657.007813h.128906c.476562 0 .949218-.019531 1.425781-.039063l12.488281.039063c-.460937 2.5-.714844 5.070312-.714844 7.707031v.046875c0 .082031-.003906.160156-.003906.242187v25.550782c0 6.699218 1.550782 13.039062 4.304688 18.6875-10.589844 1.976562-20.285156 7.046875-27.960938 14.558594-2.671875-15.488282-8.425781-30.316407-17.035156-43.675782zm149.367188 127.042969c-25.6875-.019531-49.585938-.09375-72.804688-.160156-19.953125-.066407-39.003906-.125-57.78125-.136719v-20.953125c0-13.902344 3.976562-27.425781 11.511719-39.109375 5.449219-8.460938 14.710937-13.511719 24.78125-13.511719h26.859375c.511718.015625 1.023437.039063 1.535156.039063h1.984375c.515625 0 1.027344-.023438 1.539063-.039063h26.082031c10.070312 0 19.332031 5.050781 24.78125 13.511719 7.535156 11.683594 11.511719 25.207031 11.511719 39.109375zm0 0"}}),_c('path',{attrs:{"d":"m268.550781 563.472656-.386719-.285156c-5.496093-4.171875-13.332031-3.089844-17.503906 2.40625-4.167968 5.503906-3.089844 13.339844 2.410156 17.503906l.386719.292969c2.257813 1.710937 4.90625 2.539063 7.535157 2.539063 3.777343 0 7.507812-1.707032 9.96875-4.949219 4.167968-5.5 3.089843-13.339844-2.410157-17.507813zm0 0"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Antal ledige mænd : "+_vm._s(_vm.itemSelect.numofman2)+" ")])])]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-right border-top mediumgrey-border",staticStyle:{"height":"140px"}},[[_c('div',{staticClass:"flex flex-column justify-center items-center darkblue center line-height-2"},[_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"60","height":"60","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m256 446c104.765625 0 190-85.234375 190-190s-85.234375-190-190-190c-90.132812 0-166.148438 63.273438-185.332031 148.03125-1.222657 5.386719 2.15625 10.742188 7.542969 11.960938 5.386718 1.214843 10.742187-2.15625 11.960937-7.542969 17.375-76.746094 87.113281-132.449219 165.828125-132.449219 93.738281 0 170 76.261719 170 170s-76.261719 170-170 170c-78.714844 0-148.453125-55.703125-165.828125-132.449219-1.21875-5.386719-6.566406-8.761719-11.960937-7.542969-5.386719 1.21875-8.765626 6.574219-7.542969 11.960938 19.199219 84.816406 95.265625 148.03125 185.332031 148.03125zm0 0"}}),_c('path',{attrs:{"d":"m256 512c137.519531 0 256-117.722656 256-256 0-137.890625-118.117188-256-256-256-137.519531 0-256 117.722656-256 256 0 137.890625 118.117188 256 256 256zm0-492c125.71875 0 236 110.28125 236 236s-110.28125 236-236 236-236-110.28125-236-236 110.28125-236 236-236zm0 0"}}),_c('path',{attrs:{"d":"m176 146c-5.523438 0-10 4.476562-10 10v200c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-89.273438c33.878906 4.867188 60 34.070313 60 69.273438v20c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-20c0-34.761719-19.808594-64.984375-48.734375-79.96875 8.152344-4.21875 15.695313-9.714844 22.378906-16.394531 16.996094-17.007813 26.355469-39.605469 26.355469-63.636719v-20c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v20c0 18.691406-7.28125 36.269531-20.496094 49.496094-10.84375 10.832031-24.605468 17.671875-39.503906 19.789062v-89.285156c0-5.523438-4.476562-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m296 206c-5.523438 0-10 4.476562-10 10v140c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-80c0-16.542969 13.457031-30 30-30h20c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-20c-11.246094 0-21.636719 3.734375-30 10.027344v-20.027344c0-5.523438-4.476562-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m86 256c0-5.519531-4.480469-10-10-10s-10 4.480469-10 10 4.480469 10 10 10 10-4.480469 10-10zm0 0"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"h6 darkblue gibson center mb0 block line-height-2"}},[_vm._v("Timepris inkl. alt (ex. moms) : "+_vm._s(_vm.itemSelect.timepris2)+" ")])])]],2),_vm._v(" "),_c('div',{staticClass:"col col-6 gibson py3 border-top mediumgrey-border",staticStyle:{"height":"140px"}},[(_vm.itemSelect.offer2)?_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[[(_vm.itemSelect.offer2 === '1')?_c('div',[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.offer2)+" bydende  ")]),_vm._v("på opgaven")])]):(_vm.itemSelect.offer2 === '2')?_c('div',[_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.offer2)+" bydende  ")]),_vm._v("på opgaven")])]):(_vm.itemSelect.offer2 === '3')?_c('div',[_c('div',{staticClass:"block flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block flex justify-center items-center center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticClass:"block flex justify-around items-center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.offer2)+" bydende  ")]),_vm._v("på opgaven")])])]):_c('div',{staticClass:"muted-color"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])])]],2):_c('div',{staticClass:"flex flex-column justify-center items-center line-height-2"},[_c('span',{staticClass:"block center"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"12.5px"},attrs:{"classs":"darkblue gibson center mt2 mb0 block"}},[_vm._v("Kunden ønsker "),_c('span',[_vm._v("1")]),_vm._v(" tilbud på opgaven")])])])])]):_vm._e(),_vm._v(" "),(_vm.step ===2)?_c('div',{staticClass:"mt-4"},[(_vm.itemSelect.monthlyp !== '1' && _vm.itemSelect.appointment_free >= 0)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"p2 flex justify-center items-center"},[_c('p',{staticClass:"h5 primarycolor line-height-1 mb0"},[_vm._v("\n                Du har "+_vm._s(_vm.itemSelect.appointment_free)+" gratis møde til gode\n              ")])])]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center border-top",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[_c('button',{staticClass:"col-6 outlined-disabled-button no-border p3 h5 not-rounded gibson flex justify-center items-center",staticStyle:{"border":"0!important"},on:{"click":function($event){_vm.itemShowMester = false}}},[_c('span',[_vm._v("←")]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),(_vm.step === 2)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":_vm.nextStep}},[_c('span',{staticClass:"mx2"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){return _vm.reservedItemTilbudMester()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reserver")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])],2),_vm._v(" "),_c('b-modal',{ref:"reservafailedchecklimit",attrs:{"centered":"","hide-footer":"","id":"reservafailedchecklimit"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-11 flex justify-end pt1 p0 mx-auto "},[_c('button',{staticClass:"right h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.hideModalreservafailedchecklimit()}}},[_c('i',{staticClass:"el-icon-circle-close"})])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background flex flex-column justify-center items-center"},[_c('div',{staticClass:" gibson px3"},[_c('p',{staticClass:"h4 my2 semi-bold center"},[_vm._v("Hej "+_vm._s(_vm.partnerName))]),_vm._v(" "),_c('p',{staticClass:"h5 mt3 mb2 center  dg-content"},[_vm._v("Du har desværre opbrugt dine reservationer.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"h5 mt1 mb2 center dg-content"},[_vm._v("Du har mulighed for at øge dit reservations-max til "+_vm._s(parseInt(_vm.reservesize + 1))+", for kun "+_vm._s(_vm.priceereservce)+" kr mere pr. mdr. ")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"col-12 center darkblue h5 mb2 dg-content"},[_vm._v(" så du kan reservere opgave du har kigget på!")])]),_vm._v(" "),_c('button',{staticClass:"col-6 action-button pointer no-border p2 my3 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.buyreserveadditional()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Ja Tak")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"reservafailedchecklimitbitrix",attrs:{"centered":"","hide-footer":"","id":"reservafailedchecklimitbitrix"},model:{value:(_vm.reservafailedchecklimitbitrix),callback:function ($$v) {_vm.reservafailedchecklimitbitrix=$$v},expression:"reservafailedchecklimitbitrix"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-11 flex justify-end pt1 p0 mx-auto "},[_c('button',{staticClass:"right h4 p0 primary-white-button pointer",on:{"click":function($event){_vm.reservafailedchecklimitbitrix = false}}},[_c('i',{staticClass:"el-icon-circle-close"})])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background flex flex-column justify-center items-center"},[_c('div',{staticClass:" gibson px3"},[_c('p',{staticClass:"h4 my2 semi-bold center"},[_vm._v("Hej "+_vm._s(_vm.partnerName))]),_vm._v(" "),_c('p',{staticClass:"h5 mt3 mb2 center  dg-content"},[_vm._v("Du har desværre opbrugt dine reservationer.")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',{staticClass:"h5 mt1 mb2 center dg-content"},[_vm._v("Du har mulighed for at øge dine reservationer, for kun "+_vm._s(_vm.slotpris)+" kr. mere pr. måned, så du kan reservere den opgaver du har kigget på. ")]),_c('br'),_vm._v(" "),_c('p',{staticClass:"col-12 center darkblue h5 mb2 dg-content"},[_vm._v(" OBS: Hvis du ønsker at nedjustere dine reservationer igen, kan det kun ske med en løbende + en måneds varsel.")])]),_vm._v(" "),_c('button',{staticClass:"col-6 action-button pointer no-border p2 my3 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","disabled":_vm.disablekatak},on:{"click":function($event){return _vm.buyreserveadditionalbitrix()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Ja Tak")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"cantbuyreserve",attrs:{"centered":"","hide-footer":"","size":"lg","id":"cantbuyreserve"},model:{value:(_vm.cantbuyreserve),callback:function ($$v) {_vm.cantbuyreserve=$$v},expression:"cantbuyreserve"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-11 flex justify-end pt1 p0 mx-auto "},[_c('button',{staticClass:"right h4 p0 primary-white-button pointer",on:{"click":function($event){return _vm.hidecantbuyreserve()}}},[_c('i',{staticClass:"el-icon-circle-close"})])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background flex flex-column justify-center items-center"},[_c('div',{staticClass:" gibson px3 mb3"},[_c('p',{staticClass:"h4 semi-bold center"},[_vm._v("Hej "+_vm._s(_vm.partnerName))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"h5 mt1 mb2 dg-content"},[_c('p',{staticClass:"col-12 darkblue h5 mb2 dg-content p0"},[_vm._v("Du har desværre opbrugt dine reservationer.")]),_vm._v(" "),_c('p',{staticClass:"col-12 darkblue h5 mb2 dg-content p0"},[_vm._v("Du har mulighed for at øge dine reservationer, for kun "+_vm._s(_vm.slotpris)+" kr. mere pr. måned, så du kan reservere den opgaver du har kigget på.")]),_vm._v(" "),_c('p',{staticClass:"col-12 darkblue h5 mb2 dg-content p0"},[_vm._v("OBS: Hvis du ønsker at nedjustere dine reservationer igen, kan det kun ske med en løbende + en måneds varsel.")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"reservafailedpaidadditional",attrs:{"centered":"","hide-footer":"","id":"reservafailedpaidadditional"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModalreservafailedpaidadditional()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background flex flex-column justify-center items-center"},[_c('div',{staticClass:"gibson"},[_c('p',{staticClass:"h4 my2 semi-bold center"},[_vm._v("Sådan!")]),_vm._v(" "),_c('p',{staticClass:"h4 my2 semi-bold center"},[_vm._v("🙌")]),_vm._v(" "),_c('p',{staticClass:"h5 mt1 mb2 center dg-content "},[_vm._v("Nu er dit reservations-max ændret til "+_vm._s(parseInt(_vm.reservesize + 1))+" samtidige reservationer.")]),_vm._v(" "),_c('br'),_vm._v(" - "),_c('br'),_vm._v(" "),_c('p',{staticClass:"h5 mt1 mb2 center  dg-content "},[_vm._v("Ønsker du at reservere opgaven du kiggede på?")])]),_vm._v(" "),(_vm.itemSelect.henttilbud !== 1 && _vm.step === 1)?_c('button',{staticClass:"col-6 greenblue-button no-border p2 my2 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){_vm.reservedItem(),_vm.hideModalreservafailedpaidadditional()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Ja Tak")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.henttilbud === 1 && _vm.step === 1)?_c('button',{staticClass:" col-6 greenblue-button no-border p2 my2 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){_vm.reservedItemTilbud(),_vm.hideModalreservafailedpaidadditional()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Ja Tak")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"freemuimopartner",attrs:{"centered":"","hide-footer":"","id":"freemuimopartner","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closefreemiumpopup()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-close"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"}),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("Du skal være betalende medlem af Håndværker.dk for at byde på opgaver.")]),_vm._v(" "),_c('a',{staticClass:" my2 p2 mx-auto col-10 button darkblue-background white no-underline no-border not-rounded gibson flex justify-center",attrs:{"type":"button","target":"_blank","href":_vm.endcode}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opgrader dit medlemskab")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])],2),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-header":"","size":"lg","id":"sendingsuccess","no-close-on-backdrop":true},model:{value:(_vm.sendingsuccess),callback:function ($$v) {_vm.sendingsuccess=$$v},expression:"sendingsuccess"}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("Din prøveperiode aktiveret! \n                Du mangler blot at opdatere din virksomhedsprofil, før vi kan låse op for opgaverne på markedspladsen.\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Din plan er aktiv, og du kan begynde at byde på ledige opgaver, så snart du har opdateret din virksomhedsprofil.")]),_vm._v(" "),_c('a',{staticClass:"center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto dark-button no-underlined white no-border not-rounded flex justify-center items-center",attrs:{"type":"button","href":_vm.bookingwizardurl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdateret virksomhedsprofil")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('paymentreminderpopup',{ref:"paymentreminderpopup",on:{"Nopaymentmethod":_vm.Nopaymentmethod}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('span',{staticClass:"h5 green regular gibson m0"},[_vm._v("Se opgaver")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('span',{staticClass:"h5 green regular gibson m0"},[_vm._v("Se arbejdskraft")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Arbejdskraft\n              ")])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex flex-column justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Markedsplads\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n                Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background circle p0 m0 absolute top-0 right-0 m1",staticStyle:{"padding":"3px"}},[_c('i',{staticClass:"primarycolor el-icon-star-on"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font14 semi-bold m0 darkblue  line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v("Hovedentreprise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h6 primarycolor center semi-bold my1 line-height-1"},[_c('span',{},[_vm._v("Se detaljer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h4  regular white line-height-golden"},[_vm._v("Som basismedlem har du desværre ikke adgang til denne del af partner-login."),_c('br'),_vm._v("\n                    Opgrader din løsning, hvis du vil have adgang.\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 mintgreen semi-bold block"},[_vm._v("\n                        Gratis møde\n                      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KundeMap__ = __webpack_require__(535);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kundemodal',
  components: {
    kundekort: __WEBPACK_IMPORTED_MODULE_0__KundeMap__["a" /* default */]
  },
  data: function data() {
    return {
      kundeShow: false,
      form: {
        text: ''
      }
    };
  },

  methods: {
    closeKundeModal: function closeKundeModal() {
      this.$refs.kundeModal.hide();
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kundekort',
  data: function data() {
    return {
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoWinOpen: false,
      place: null,
      center: {
        lat: 55.6680529,
        lng: 12.5417883
      },
      infoContent: '',
      infoWindowPos: {
        lat: 0,
        lng: 0
      }
    };
  },
  created: function created() {
    var _this = this;

    this.salesPerson = localStorage.getItem('id_token_portal');
    var data = { operation: 'openjob_partner_map', salesPerson: this.salesPerson };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
      _this.center = res.location;
      _this.markers = res.geocodes;
    }, function (response) {
      alert('error');
    });
  },

  description: '',
  methods: {
    setDescription: function setDescription(description) {
      this.description = description;
    },
    setPlace: function setPlace(place) {
      this.place = place;
    },
    usePlace: function usePlace(place) {
      if (this.place) {
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          }
        });
        this.place = null;
      }
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = marker.infoText;
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
});

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('GmapMap',{staticStyle:{"width":"100%","height":"240px"},attrs:{"zoom":11,"center":_vm.center}},[_c('GmapCluster',[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_vm._v("\n        "+_vm._s(_vm.infoContent)+"\n      ")]),_vm._v(" "),_vm._l((_vm.markers),function(marker,index){return _c('GmapMarker',{key:index,attrs:{"position":marker.position,"clickable":true,"draggable":true},on:{"click":function($event){return _vm.toggleInfoWindow(marker,index)}}})}),_vm._v(" "),(this.place)?_c('GmapMarker',{attrs:{"label":"★","position":{lat: this.place.geometry.location.lat(),lng: this.place.geometry.location.lng(),}}}):_vm._e()],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 815 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-card',{attrs:{"border-variant":"light"}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-flex flex-row justify-content-between line-height-golden"},[_c('span',{staticClass:"h6 font-weight-bold text-dark"},[_vm._v("Kundehenvendelser")])]),_vm._v(" "),_c('span',{staticClass:"d-block mt-4"},[_c('b-btn',{staticClass:"rounded",attrs:{"variant":"info"},on:{"click":function($event){_vm.kundeShow = !_vm.kundeShow}}},[_vm._v("Se kort")])],1),_vm._v(" "),_c('b-modal',{ref:"kundeModal",attrs:{"lazy":"","centered":"","id":"modal-center","lazy":"","title":"Kundehenvendelser","size":"lg"},model:{value:(_vm.kundeShow),callback:function ($$v) {_vm.kundeShow=$$v},expression:"kundeShow"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"d-flex flex-row justify-content-between py-2"},[_c('p',{staticClass:"h5 font-weight-bold pt-2 open-sans text-dark"},[_vm._v("Kort over kundehenvendelser")]),_vm._v(" "),_c('b-btn',{staticClass:"border-0",attrs:{"variant":"outline-dark"},on:{"click":_vm.closeKundeModal}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])],1),_vm._v(" "),_c('div',{staticClass:"h6 pt-2 open-sans line-height-golden"},[_vm._v("Her kan du se en oversigt over de henvendelser fra potentielle kunder, som vi endnu ikke har haft mulighed for at kontakte. Klik på en af markørerne for at læse om opgaven.")])]),_vm._v(" "),_c('b-container',{attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"py-3"},[_c('kundekort')],1)],1)],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-row',{staticClass:"pt-0 pr-2 pb-4 pl-2"},[_c('b-col',[_c('b-btn',{staticClass:"rounded",attrs:{"slot":"modal-cancel","type":"reset","variant":"outline-info","size":"lg"},on:{"click":_vm.closeKundeModal},slot:"modal-cancel"},[_vm._v("Luk")])],1)],1)],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4",attrs:{"id":"marketplace"}},[_c('div',{staticClass:"clearfix gibson px2 pt2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_c('div',[_c('marketplace')],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix ml4"},[_c('div',[_c('marketplace')],1)]):_vm._e()])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_udbud_vue__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765bab8e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_udbud_vue__ = __webpack_require__(826);
function injectStyle (ssrContext) {
  __webpack_require__(818)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_udbud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_765bab8e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_udbud_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 818 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_updatebitrixpackagepermission__ = __webpack_require__(56);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketplace',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    archivemodal: __WEBPACK_IMPORTED_MODULE_0__modals_ArchiveModal__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_4__noneligibleFeaturepop__["a" /* default */],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_5__components_updatebitrixpackagepermission__["a" /* default */]
  },
  watch: {
    'search': function search(newVal, oldVal) {
      var _this = this;

      if (newVal.length >= 3) {
        setTimeout(function () {
          _this.updateSearch();
        }, 200);
      } else {
        this.combinedUdbud = this.mainCombineUdbud;
      }
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
      this.showXXL = true;
    }
    this.reloadudbudtest();
    if (localStorage.getItem('basic') === '1') {
      this.basic = true;
    }
    this.partnerName = localStorage.getItem('name');
  },
  data: function data() {
    return {
      items: [],
      itemreserved: [],
      show: false,
      search: '',
      isLoadingReserve: false,
      label: 'Loading...',
      overlay: 1,
      basic: false,
      SearchItem: [],
      statusfilter: [],
      statusDate: [],
      citiesfilter: [],
      countriesfilter: [],
      categoryfilter: [],
      partnerName: '',
      usershorturl: '',
      isLoadingMail: false,
      step: 1,
      partnerinvoice: 0,
      itemSelect: [],
      itemShow: false,
      itemShowMester: false,
      loading: true,
      itemMester: [],
      newUdbuddata: [],
      combinedUdbud: [],
      allCity: [],
      mainCombineUdbud: []
    };
  },
  mounted: function mounted() {
    this.getdataigibility();
  },

  methods: {
    getdataigibility: function getdataigibility() {
      var _this2 = this;

      setTimeout(function () {
        _this2.eligible = localStorage.getItem('PartnerLoginUdbudJobs');
        console.log('eligible', _this2.eligible);
        if (_this2.eligible === 'false') {
          _this2.$refs.noneligibleFeaturepop.showmodel(_this2.eligible, '/newsfeed', 'PartnerLoginUdbudJobs');
        }
      }, 2000);
    },
    checkimage: function checkimage(key) {
      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = 'static/img/0.jpg';
    },
    showItemDetails: function showItemDetails(item) {
      if (item.reserved === 1) {
        return;
      }
      if (this.basic && item.mester !== '1') {
        return;
      }
      this.itemShow = !this.itemShow;
      this.itemSelect = item;
      this.usershorturl = this.itemSelect.shorturl;
      this.loading = false;
      this.step = 1;
    },
    showItemDetailsMester: function showItemDetailsMester(item) {
      if (item.UF_DESCRIPTION_URL) {
        window.open(item.UF_DESCRIPTION_URL, '_blank');
      } else {
        this.itemShow = !this.itemShow;
        this.itemSelect = item;
        this.loading = false;
        this.step = 1;
      }
    },
    reloadudbud: function reloadudbud() {},
    isCorrectDate: function isCorrectDate(date) {
      var options = { year: 'numeric', month: 'long', day: 'numeric' };
      var optionmonth = { month: 'long' };
      if (isFinite(date instanceof Date ? date : new Date(date))) {
        return new Date(date).toLocaleDateString('da-DK', options);
      } else {
        return date.split('/')[0] + '.' + new Date(date.split('/')[1]).toLocaleDateString('da-DK', optionmonth) + ' ' + date.split('/')[2];
      }
    },
    reloadudbudtest: function reloadudbudtest() {
      var _this3 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'bitrix/getUdbudJobs', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        _this3.itemMester = res.data;
        var m = _this3;
        var result = res.data;
        result.forEach(function (e, index) {
          m.itemMester[index]['UF_CITY'] = e.CITY;
          m.itemMester[index]['UF_COUNTRY'] = '';
          m.itemMester[index]['UDBUD_TYPE'] = 1;
          if (e.TENDER_DEADLINE) {
            m.itemMester[index]['TENDER_DEADLINE'] = _this3.isCorrectDate(e.TENDER_DEADLINE.split(' ')[0]);
          } else {
            m.itemMester[index]['TENDER_DEADLINE'] = 'ingen dato tilgængelig';
          }
        });
        _this3.reloadnewdbud();
      }, function (response) {
        console.log('error in loading all udbud');
      });
    },
    reloadnewdbud: function reloadnewdbud() {
      var _this4 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'bitrix/getValidTed', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var oldCity = [];
        var categorywork = [];
        var country = [];
        var m = _this4;
        var data = res.data;
        _this4.newUdbuddata = data;
        data.forEach(function (e, index) {
          m.newUdbuddata[index]['CATEGORY'] = e.BRANCHE;
          m.newUdbuddata[index]['DATE_CREATED'] = _this4.formatDate(e.UF_PUBLISHED_DATE);
          m.newUdbuddata[index]['DATE_EDITED'] = e.UF_PUBLISHED_DATE;
          m.newUdbuddata[index]['TENDER_DEADLINE'] = _this4.isCorrectDate(e.UF_DEADLINE_DATE.split(' ')[0]);
          m.newUdbuddata[index]['CITY'] = e.UF_CITY;
          m.newUdbuddata[index]['PROCUREMENT_DESCRIPTION'] = e.UF_DESCRIPTION;
          m.newUdbuddata[index]['TENDER_TITLE'] = e.UF_TITLE;
          m.newUdbuddata[index]['UDBUD_TYPE'] = 2;
          country.push(e.UF_COUNTRY);
        });
        if (_this4.search !== '') {
          _this4.updateSearch();
        }
        _this4.combinedUdbud = _this4.itemMester.concat(_this4.newUdbuddata);
        _this4.mainCombineUdbud = _this4.itemMester.concat(_this4.newUdbuddata);

        _this4.combinedUdbud.forEach(function (index) {
          oldCity.push(index.CITY);
        });
        _this4.allCity = oldCity;
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this4.citiesfilter = _this4.allCity.filter(unique).sort();

        _this4.countriesfilter = country.filter(unique).sort();

        _this4.mainCombineUdbud.forEach(function (element) {
          var catitem = element.CATEGORY !== null ? element.CATEGORY : 'Empty';
          var catitemclean = catitem.split(',');
          if (catitemclean.length > 1) {
            catitemclean.forEach(function (item) {
              categorywork.push(item.trim());
            });
          } else {
            categorywork.push(catitem);
          }
        });
        var uniquecategory = function uniquecategory(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this4.categoryfilter = categorywork.filter(uniquecategory);
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [year, month, day].join('/');
    },
    filterSearch: function filterSearch(item) {
      return item;
    },
    toggleFilter: function toggleFilter(status) {
      var items = [];
      var filtered = [];
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          items = this.mainCombineUdbud.filter(function (item) {
            return item.CATEGORY.includes(status[i]) || item.CITY.includes(status[i]) || item.UF_COUNTRY.includes(status[i]);
          });
          items.forEach(function (value) {
            filtered.push(value);
          });
        }
        this.combinedUdbud = this.filterSearch(filtered);
      } else {
        this.combinedUdbud = this.filterSearch(this.itemMester);
      }
    },
    toggleSort: function toggleSort(statusDate) {
      var items = [];
      var order;
      if (statusDate === '2') {
        order = this.oldestFirst ? 1 : -1;
        items = this.mainCombineUdbud.sort(function (a, b) {
          a = new Date(a.DATE_CREATED);
          b = new Date(b.DATE_CREATED);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.combinedUdbud = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '1') {
        order = this.ascending ? 1 : -1;
        items = this.mainCombineUdbud.sort(function (a, b) {
          a = a.CITY;
          b = b.CITY;
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.combinedUdbud = this.filterSearch(items);
        this.ascending = !this.ascending;
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1;
        items = this.mainCombineUdbud.sort(function (a, b) {
          a = new Date(a.DATE_EDITED);
          b = new Date(b.DATE_EDITED);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.combinedUdbud = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1;
        items = this.mainCombineUdbud.sort(function (a, b) {
          a = new Date(a.TENDER_DEADLINE);
          b = new Date(b.TENDER_DEADLINE);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.combinedUdbud = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      }
    },
    updateSearch: function updateSearch() {
      var _this5 = this;

      var items = [];
      items = this.combinedUdbud.filter(function (item) {
        return item.TENDER_TITLE.toLowerCase().includes(_this5.search.toLowerCase()) || item.CITY.toLowerCase().includes(_this5.search.toLowerCase()) || item.CITY.toLowerCase().includes(_this5.search.toLowerCase());
      });
      this.combinedUdbud = this.filterSearch(items);
    },
    formatCurrency: function formatCurrency(total) {
      var neg = false;
      if (total < 0) {
        neg = true;
        total = Math.abs(total);
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString();
    },
    hideModal: function hideModal() {
      this.itemShow = false;
      this.$refs.itemModal.hide();
    }
  }
});

/***/ }),
/* 820 */,
/* 821 */
/***/ (function(module, exports) {

module.exports = {"_from":"weekstart@^1.0.1","_id":"weekstart@1.1.0","_inBundle":false,"_integrity":"sha512-ZO3I7c7J9nwGN1PZKZeBYAsuwWEsCOZi5T68cQoVNYrzrpp5Br0Bgi0OF4l8kH/Ez7nKfxa5mSsXjsgris3+qg==","_location":"/weekstart","_phantomChildren":{},"_requested":{"type":"range","registry":true,"raw":"weekstart@^1.0.1","name":"weekstart","escapedName":"weekstart","rawSpec":"^1.0.1","saveSpec":null,"fetchSpec":"^1.0.1"},"_requiredBy":["/"],"_resolved":"https://registry.npmjs.org/weekstart/-/weekstart-1.1.0.tgz","_shasum":"af642eb10dc24b1af9d4dcc0415056edc087b897","_spec":"weekstart@^1.0.1","_where":"D:\\Kundematch\\portal-solution","author":{"name":"Denis Sikuler"},"bugs":{"url":"https://github.com/gamtiq/weekstart/issues"},"bundleDependencies":false,"deprecated":false,"description":"Library to get first day of week.","devDependencies":{"@babel/preset-env":"^7.13.10","eslint":"^7.22.0","eslint-config-guard":"^2.0.1","ink-docstrap":"1.3.2","jest":"^26.6.3","jsdoc":"^3.6.6","jsdoc-file":"^1.0.1","microbundle":"0.4.4","version-bump-prompt":"^6.1.0"},"files":["dist","full.js","full.d.ts","index.d.ts","src","History.md"],"homepage":"https://github.com/gamtiq/weekstart","keywords":["week","start","first","day","locale","country","region"],"license":"MIT","main":"dist/commonjs/main.js","module":"dist/es-module/main.js","name":"weekstart","repository":{"type":"git","url":"git://github.com/gamtiq/weekstart.git"},"scripts":{"all":"npm run check-all && npm run doc && npm run build","build":"npm run build-umd && npm run build-commonjs && npm run build-esm && npm run build-umd-min","build-commonjs":"microbundle build \"src/!(*.test).js\" --output dist/commonjs --format cjs --strict --no-compress","build-esm":"microbundle build \"src/!(*.test).js\" --output dist/es-module --format es --no-compress","build-umd":"microbundle build src/main.js src/full.js --output dist --format umd --strict --no-compress","build-umd-min":"microbundle build src/main.js src/full.js --output dist/min --format umd --strict","check":"npm run lint && npm test","check-all":"npm run lint-all && npm test","doc":"jsdoc -c jsdoc-conf.js","lint":"eslint --cache --max-warnings 0 \"**/*.js\"","lint-all":"eslint --max-warnings 0 \"**/*.js\"","lint-all-error":"eslint \"**/*.js\"","lint-error":"eslint --cache \"**/*.js\"","release":"bump patch --commit --tag --all --push package.json package-lock.json bower.json component.json","release-major":"bump major --commit --tag --all --push package.json package-lock.json bower.json component.json","release-minor":"bump minor --commit --tag --all --push package.json package-lock.json bower.json component.json","test":"jest"},"types":"./index.d.ts","umd:main":"dist/main.js","version":"1.1.0"}

/***/ }),
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"udbudpage"}},[[_c('div',{staticClass:"clearfix marketplaceItems col-11"},[_c('div',{staticClass:"col-12 px0 mx3"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n                        Udbud.dk giver et overblik over danske myndigheders indkøb. Udbud.dk viser både nationale udbud, EU-udbud og myndighedernes indkøbsplaner. Siden opdateres med nye udbud. EU-udbud vies på udbud.dk med tilladelse fra EU's Publikationskontor.\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0",staticStyle:{"background":"transparent","border":"0px!important"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"flex col-12 ml3",attrs:{"id":"m2m"}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',[_vm._v("Kategori")]),_vm._v(" "),_c('div',_vm._l((_vm.categoryfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.statusfilter),callback:function ($$v) {_vm.statusfilter=$$v},expression:"statusfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',[_vm._v("Byer")]),_vm._v(" "),_c('div',_vm._l((_vm.citiesfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.statusfilter),callback:function ($$v) {_vm.statusfilter=$$v},expression:"statusfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',[_vm._v("Land")]),_vm._v(" "),_c('div',_vm._l((_vm.countriesfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.statusfilter),callback:function ($$v) {_vm.statusfilter=$$v},expression:"statusfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"my1 col-12 mb3 mx-auto "},[_c('button',{staticClass:"col-3 action-button p2 gibson not-rounded ",on:{"click":function($event){return _vm.toggleFilter(_vm.statusfilter)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"})]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6",attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix m3"},[_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"Sortbyalphacity","aria-describedby":ariaDescribedby,"name":"Sortbyalphacity","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter by")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydatecreated","aria-describedby":ariaDescribedby,"name":"Sortbydatecreated","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter oprettet dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydateedited","aria-describedby":ariaDescribedby,"name":"Sortbydateedited","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter redigeringsdato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydatedeadline","aria-describedby":ariaDescribedby,"name":"Sortbydatedeadline","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter dato deadline")])])],1)]}}])}),_vm._v(" "),_c('div',{staticClass:"pb5"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded",on:{"click":function($event){return _vm.toggleSort(_vm.statusDate)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"ml2 flex flex-wrap col-12 justify-start"},[_vm._l((_vm.combinedUdbud),function(item){return (_vm.showXXL)?_c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mx1 mb3 pointer relative",staticStyle:{"width":"320px","overflow":"hidden"},on:{"click":function($event){return _vm.showItemDetailsMester(item)}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:"flex justify-center items-center pt4",staticStyle:{"height":"216px"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"src":item.PICTURE_URL,"alt":"Udbud Logo"}})]),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p2 line-height-1 block px2"},[((item.UDBUD_TYPE === 2))?_c('span',{staticClass:"h6 m0 p0 white semi-bold block flex"},[_c('span',[_vm._v(_vm._s(item.UF_CITY)+" ")]),_vm._v(" "),_c('span',{staticClass:"ml-auto",staticStyle:{"font-size":"12px"}},[_vm._v("Ted Europe")])]):_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                          "+_vm._s(item.POSTAL_CODE)+"  "+_vm._s(item.CITY)+"\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 mt2 flex justify-between items-center"},[(!item.UF_TITLE)?_c('span',[_vm._v(_vm._s(item.TENDER_TITLE))]):_c('span',[_vm._v(_vm._s(item.UF_TITLE))])]),_vm._v(" "),[_c('p',{staticClass:"h6 darkblue regular line-height-2 mb3"},[_vm._v("\n                          "+_vm._s(_vm._f("truncate")(item.PROCUREMENT_DESCRIPTION,100, '...'))+"\n                        ")]),_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0 line-height-1 py2 absolute bottom-0"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',[_vm._v("Deadline : "+_vm._s(item.TENDER_DEADLINE)+" ")])])]],2)])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.itemMester),function(item,index){return (_vm.showMobile)?_c('div',{key:index,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetailsMester(item)}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block absolute bottom-0 left-0 right-0",staticStyle:{"top":"50%","left":"5%","height":"25px","width":"95%"},attrs:{"src":"static/img/udbud_og.webp","alt":"Udbud Logo"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background flex justify-around p1 line-height-1 block px1",staticStyle:{"font-size":".7em"}},[_c('span',{staticClass:" m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.POSTAL_CODE)+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.CITY)+"\n                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.TENDER_TITLE))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1"},[_vm._v("\n                        "+_vm._s(_vm._f("truncate")(item.PROCUREMENT_DESCRIPTION,50, '...'))+"\n                      ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1 line-height-2 mb1 flex flex-column"},[(item.reservedName !== '')?_c('span',{staticClass:"semi-bold"},[_vm._v("Navn : "+_vm._s(item.reservedName))]):_vm._e(),_vm._v(" "),(item.reservedPhone !== '')?_c('span',{staticClass:"block pt2"},[_vm._v("\n                    Mobil: "),_c('a',{attrs:{"href":'tel:'+item.reservedPhone}},[_vm._v("  "+_vm._s(item.reservedPhone)+" ")]),_c('br')]):_vm._e()])]],2)])]):_vm._e()})],2)],1)],_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('b-modal',{ref:"itemModal",staticStyle:{"transform":"none!important"},attrs:{"lazy":""},model:{value:(_vm.itemShow),callback:function ($$v) {_vm.itemShow=$$v},expression:"itemShow"}},[_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"z3 white-button border-none not-rounded gibson pointer",on:{"click":function($event){return _vm.hideModal()}}},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_vm._t("modal-header",function(){return [_c('div',{staticClass:"relative"},[_c('div',{staticStyle:{"height":"180px"}},[_c('img',{staticClass:"fit block mx-auto",staticStyle:{"height":"90px","width":"90%"},attrs:{"src":"static/img/udbud_og_big.webp","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.POSTAL_CODE)+"  "+_vm._s(_vm.itemSelect.CITY))])])])]}),_vm._v(" "),_c('div',{staticClass:"modal-body-marketplace"},[_c('div',{staticClass:"clearfix "},[_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n              "+_vm._s(_vm.itemSelect.producttitle)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"h6 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"flex justify-start items-center mb3 col-12"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})]),_vm._v(" "),_c('p',{staticClass:"m0 p0 h6 darkblue sime-bold"},[_vm._v("Ring og aftal møde-dato")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Publiceret:")]),_c('p',[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.appointment_date).locale('da').format('LL')))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Deadline:")]),(_vm.itemSelect.TENDER_DEADLINE !== null )?_c('p',[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.TENDER_DEADLINE).locale('da').format('LL'))+" "),_c('br'),_vm._v("See time under tender details")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Sted:")]),_c('p',[_vm._v(_vm._s(_vm.itemSelect.POSTAL_CODE)+"  "+_vm._s(_vm.itemSelect.CITY))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Titel:")]),_c('p',[_vm._v(_vm._s(_vm.itemSelect.PROCUREMENT_TITLE))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Beskrivelse:")]),_c('p',{staticClass:"line-height-2",staticStyle:{"width":"65%"},domProps:{"innerHTML":_vm._s(_vm.itemSelect.PROCUREMENT_DESCRIPTION )}})])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center border-top",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[_c('a',{staticClass:" col-12 green-background p3 white sime-bold gibson mx-auto m0 no-underline ",attrs:{"type":"button","href":_vm.itemSelect.FORM_URL_ID,"target":"_blank","disabled":_vm.isLoadingReserve}},[_c('span',{staticClass:"mx2"},[_vm._v("Se mere på udbud.dk")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                          Udbud\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 827 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ted_udbud_vue__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438f818d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ted_udbud_vue__ = __webpack_require__(830);
function injectStyle (ssrContext) {
  __webpack_require__(828)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ted_udbud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438f818d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ted_udbud_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 828 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 829 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_updatebitrixpackagepermission__ = __webpack_require__(56);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ted udbud',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    archivemodal: __WEBPACK_IMPORTED_MODULE_0__modals_ArchiveModal__["a" /* default */],
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_4__noneligibleFeaturepop__["a" /* default */],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_5__components_updatebitrixpackagepermission__["a" /* default */]
  },
  watch: {
    'search': function search(newVal, oldVal) {
      var _this = this;

      setTimeout(function () {
        _this.updateSearch();
      }, 200);
      this.SearchItem = [];
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
      this.showXXL = true;
    }
    this.reloadudbudtest();
    if (localStorage.getItem('basic') === '1') {
      this.basic = true;
    }
    this.partnerName = localStorage.getItem('name');
  },
  data: function data() {
    return {
      items: [],
      itemMester: [],
      itemreserved: [],
      show: false,
      search: '',
      isLoadingReserve: false,
      label: 'Loading...',
      overlay: 1,
      basic: false,
      SearchItem: [],
      statusfilter: [],
      statusDate: [],
      citiesfilter: [],
      categoryfilter: [],
      partnerName: '',
      usershorturl: '',
      isLoadingMail: false,
      step: 1,
      partnerinvoice: 0,
      itemSelect: [],
      itemShow: false,
      itemShowMester: false,
      loading: true
    };
  },
  mounted: function mounted() {},

  methods: {
    getdataigibility: function getdataigibility() {
      var _this2 = this;

      setTimeout(function () {
        _this2.eligible = localStorage.getItem('PartnerLoginUdbudJobs');
        console.log('eligible', _this2.eligible);
        if (_this2.eligible === 'false') {
          _this2.$refs.noneligibleFeaturepop.showmodel(_this2.eligible, '/newsfeed', 'PartnerLoginUdbudJobs');
        }
      }, 2000);
    },
    checkimage: function checkimage(key) {
      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = 'static/img/0.jpg';
    },
    showItemDetails: function showItemDetails(item) {
      if (item.reserved === 1) {
        return;
      }
      if (this.basic && item.mester !== '1') {
        return;
      }
      this.itemShow = !this.itemShow;
      this.itemSelect = item;
      this.usershorturl = this.itemSelect.shorturl;
      this.loading = false;
      this.step = 1;
    },
    showItemDetailsMester: function showItemDetailsMester(item) {
      this.itemShow = !this.itemShow;
      this.itemSelect = item;
      this.loading = false;
      this.step = 1;
    },
    showGotoUrl: function showGotoUrl(item) {
      window.open(item.UF_DESCRIPTION_URL, '_blank');
    },
    reloadudbud: function reloadudbud() {},
    reloadudbudtest: function reloadudbudtest() {
      var _this3 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'bitrix/getValidTed', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var cities = [];
        var categorywork = [];
        _this3.itemMester = res.data.filter(function (a) {
          return a.ACTIVE_TENDER !== 'Yess';
        });

        res.data.forEach(function (element) {
          cities.push(element.CITY);
        });
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this3.citiesfilter = cities.filter(unique);

        res.data.forEach(function (element) {
          var catitem = element.CATEGORY !== null ? element.CATEGORY : 'Empty';
          var catitemclean = catitem.split(',');
          if (catitemclean.length > 1) {
            catitemclean.forEach(function (item) {
              categorywork.push(item.trim());
            });
          } else {
            categorywork.push(catitem);
          }
        });
        var uniquecategory = function uniquecategory(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this3.categoryfilter = categorywork.filter(uniquecategory);
        if (_this3.search !== '') {
          _this3.updateSearch();
        } else {
          _this3.SearchItem = _this3.itemMester;
        }
      }, function (response) {
        console.log('error in loading all udbud');
      });
    },
    filterSearch: function filterSearch(item) {
      return item;
    },
    toggleFilter: function toggleFilter(status) {
      var items = [];
      var filtered = [];
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          items = this.itemMester.filter(function (item) {
            return item.CATEGORY.trim().includes(status[i]) || item.CITY.includes(status[i]);
          });
          items.forEach(function (value) {
            filtered.push(value);
          });
        }
        this.SearchItem = this.filterSearch(filtered);
      } else {
        this.SearchItem = this.filterSearch(this.itemMester);
      }
    },
    toggleSort: function toggleSort(statusDate) {
      var items = [];
      var order;
      if (statusDate === '2') {
        order = this.oldestFirst ? 1 : -1;
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.DATE_CREATED);
          b = new Date(b.DATE_CREATED);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '1') {
        order = this.ascending ? 1 : -1;
        items = this.itemMester.sort(function (a, b) {
          a = a.CITY;
          b = b.CITY;
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.ascending = !this.ascending;
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1;
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.DATE_EDITED);
          b = new Date(b.DATE_EDITED);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1;
        items = this.itemMester.sort(function (a, b) {
          a = new Date(a.TENDER_DEADLINE);
          b = new Date(b.TENDER_DEADLINE);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      }
    },
    updateSearch: function updateSearch() {
      var _this4 = this;

      var items = [];
      items = this.itemMester.filter(function (item) {
        return item.TENDER_TITLE.toLowerCase().includes(_this4.search.toLowerCase()) || item.DATE_CREATED.toLowerCase().includes(_this4.search.toLowerCase()) || item.PROCUREMENT_TITLE.toLowerCase().includes(_this4.search.toLowerCase()) || item.CITY.toLowerCase().includes(_this4.search.toLowerCase()) || item.POSTAL_CODE.toLowerCase().includes(_this4.search.toLowerCase());
      });
      this.SearchItem = this.filterSearch(items);
    },
    formatCurrency: function formatCurrency(total) {
      var neg = false;
      if (total < 0) {
        neg = true;
        total = Math.abs(total);
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString();
    },
    hideModal: function hideModal() {
      this.itemShow = false;
      this.$refs.itemModal.hide();
    }
  }
});

/***/ }),
/* 830 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"udbudpage"}},[[_c('div',{staticClass:"clearfix marketplaceItems col-11"},[_c('div',{staticClass:"col-12 px0 mx3"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n                        Udbud.dk giver et overblik over danske myndigheders indkøb. Udbud.dk viser både nationale udbud, EU-udbud og myndighedernes indkøbsplaner. Siden opdateres med nye udbud. EU-udbud vies på udbud.dk med tilladelse fra EU's Publikationskontor.\n                      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0",staticStyle:{"background":"transparent","border":"0px!important"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"flex col-12 ml3",attrs:{"id":"m2m"}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',[_vm._v("Category")]),_vm._v(" "),_c('div',_vm._l((_vm.categoryfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.statusfilter),callback:function ($$v) {_vm.statusfilter=$$v},expression:"statusfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto"},[_c('p',[_vm._v("Byer")]),_vm._v(" "),_c('div',_vm._l((_vm.citiesfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-2",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.statusfilter),callback:function ($$v) {_vm.statusfilter=$$v},expression:"statusfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])]),_vm._v(" "),_c('div',{staticClass:"my1 col-12 mb3 mx-auto "},[_c('button',{staticClass:"col-3 action-button p2 gibson not-rounded ",on:{"click":function($event){return _vm.toggleFilter(_vm.statusfilter)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"})]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6",attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix m3"},[_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"Sortbyalphacity","aria-describedby":ariaDescribedby,"name":"Sortbyalphacity","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter by")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydatecreated","aria-describedby":ariaDescribedby,"name":"Sortbydatecreated","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter oprettet dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydateedited","aria-describedby":ariaDescribedby,"name":"Sortbydateedited","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter redigeringsdato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"Sortbydatedeadline","aria-describedby":ariaDescribedby,"name":"Sortbydatedeadline","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter dato deadline")])])],1)]}}])}),_vm._v(" "),_c('div',{staticClass:"pb5"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded",on:{"click":function($event){return _vm.toggleSort(_vm.statusDate)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap justify-start",staticStyle:{"padding":"2em"}},_vm._l((_vm.itemMester),function(item,index){return _c('div',{key:index,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer !important","width":"275px"},on:{"click":function($event){return _vm.showGotoUrl(item)}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[(item.PICTURE_URL)?_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"src":item.PICTURE_URL,"alt":"Udbud Logo"}}):_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"src":"https://www.haandvaerker.dk/uploads/00.webp","alt":"Udbud Logo"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                          "+_vm._s(item.UF_CITY)+"\n                        ")]),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block "})])])]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.UF_TITLE))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()])])])])}),0)],1)],_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('b-modal',{ref:"itemModal",staticStyle:{"transform":"none!important"},attrs:{"lazy":""},model:{value:(_vm.itemShow),callback:function ($$v) {_vm.itemShow=$$v},expression:"itemShow"}},[_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"z3 white-button border-none not-rounded gibson pointer",on:{"click":function($event){return _vm.hideModal()}}},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_vm._t("modal-header",function(){return [_c('div',{staticClass:"relative"},[_c('div',{staticStyle:{"height":"180px"}},[_c('img',{staticClass:"fit block mx-auto",staticStyle:{"height":"90px","width":"90%"},attrs:{"src":"static/img/udbud_og_big.webp","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 mintgreen-background p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.POSTAL_CODE)+"  "+_vm._s(_vm.itemSelect.CITY))])])])]}),_vm._v(" "),_c('div',{staticClass:"modal-body-marketplace"},[_c('div',{staticClass:"clearfix "},[_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n              "+_vm._s(_vm.itemSelect.producttitle)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"h6 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"flex justify-start items-center mb3 col-12"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})]),_vm._v(" "),_c('p',{staticClass:"m0 p0 h6 darkblue sime-bold"},[_vm._v("Ring og aftal møde-dato")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Publiceret:")]),_c('p',[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.appointment_date).locale('da').format('LL')))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Deadline:")]),(_vm.itemSelect.TENDER_DEADLINE !== null )?_c('p',[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.TENDER_DEADLINE).locale('da').format('LL'))+" "),_c('br'),_vm._v("See time under tender details")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Sted:")]),_c('p',[_vm._v(_vm._s(_vm.itemSelect.POSTAL_CODE)+"  "+_vm._s(_vm.itemSelect.CITY))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Titel:")]),_c('p',[_vm._v(_vm._s(_vm.itemSelect.PROCUREMENT_TITLE))])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"col-3"},[_vm._v("Beskrivelse:")]),_c('p',{staticClass:"line-height-2",staticStyle:{"width":"65%"},domProps:{"innerHTML":_vm._s(_vm.itemSelect.PROCUREMENT_DESCRIPTION )}})])])])])]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center border-top",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[_c('a',{staticClass:" col-12 green-background p3 white sime-bold gibson mx-auto m0 no-underline ",attrs:{"type":"button","href":_vm.itemSelect.FORM_URL_ID,"target":"_blank","disabled":_vm.isLoadingReserve}},[_c('span',{staticClass:"mx2"},[_vm._v("Se mere på udbud.dk")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                          Udbud\n                        ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 831 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMeetings_vue__ = __webpack_require__(833);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1697adaf_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewMeetings_vue__ = __webpack_require__(840);
function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1697adaf"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewMeetings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1697adaf_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewMeetings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 832 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 833 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MeetingsTable__ = __webpack_require__(834);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    newmeetings: __WEBPACK_IMPORTED_MODULE_0__MeetingsTable__["a" /* default */]
  }
});

/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetingsTable_vue__ = __webpack_require__(836);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104b66a6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MeetingsTable_vue__ = __webpack_require__(839);
function injectStyle (ssrContext) {
  __webpack_require__(835)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-104b66a6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MeetingsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_104b66a6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MeetingsTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 835 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 836 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'newmeetings',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default.a
  },
  created: function created() {
    this.Reload();
  },
  data: function data() {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      AflyseText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: true,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      salesPerson: '',
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      }
    };
  },

  computed: {
    TopItem: function TopItem() {}
  },
  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res.array;
      }, function (response) {
        alert('error');
      });
    },
    handleSubmitDato: function handleSubmitDato() {
      var _this2 = this;

      this.isLoadingDato = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var emailpartner = 1;
      var idTime = $('#select_time').val();
      var time = $('#select_time :selected').text();
      var emailcustomer = this.send_email ? 1 : 0;
      var data = { operation: 'change_date', salesPerson: this.salesPerson, appointmentid: this.Datoeid.id_appointment, changedesc: this.textDatoReason, emailcustomer: emailcustomer, datechooseqbook: this.dateDato, id_time: idTime, time: time, emailpartner: emailpartner };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.Datoeid.appointment_date = _this2.dateDato;
          _this2.dateDato = '';
          _this2.Datoeid.id_times = time;
        } else {
          alert(res.message);
          _this2.isLoadingDato = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    handleSubmitAflyse: function handleSubmitAflyse() {
      var _this3 = this;

      this.isLoadingAflyse = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'aflyse', salesPerson: this.salesPerson, appointmentid: this.Aflyseid.id_appointment, aflysedesc: this.textAflyseReason, ticket: 1 };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowAflyse = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.Aflyseid.id_appointment_status_support = '1';
          _this3.Aflyseid.ticketsolution = '';
          _this3.Aflyseid.ticketstatus = 'Afventer behandling';
          _this3.Aflyseid.ticketcategory = 'Aflysning';
        } else {
          alert(res.message);
          _this3.isLoadingAflyse = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    showMeetingDetailsAflysetext: function showMeetingDetailsAflysetext(item) {
      this.modalShowAflyseText = true;
      this.AflyseText = item.ticketsolution;
      this.AflyseTexttitle = item.ticketstatus;
    },
    showMeetingDetailsDate: function showMeetingDetailsDate(item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname;
      this.modalShowDato = true;
      this.Datoeid = item;
      this.textDatoReason = '';
      this.isLoadingDato = false;
      var select = document.getElementById('select_time');
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i];
        if (option.text === item.id_times) {
          this.timeDato = option.value;
        }
      }
    },
    showMeetingDetailsAflyse: function showMeetingDetailsAflyse(item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?';
      this.modalShowAflyse = true;
      this.Aflyseid = item;
      this.textAflyseReason = '';
      this.isLoadingAflyse = false;
    },
    filterItem: function filterItem(items) {
      var newItem = [];
      for (var iteme in items) {
        newItem.push(items[iteme]);
      }
      return newItem;
    },
    showMeetingDetails: function showMeetingDetails(item) {
      this.meetingShow = !this.meetingShow;
      this.sampleMeeting.id = item.id;
      this.sampleMeeting.type = item.type;
      this.sampleMeeting.estimate = item.estimate;
      this.sampleMeeting.city = item.city;
      this.sampleMeeting.postnummer = item.postnummer;
      this.sampleMeeting.price = item.price;
      this.sampleMeeting.date = item.date;
    },
    hideModal: function hideModal() {
      this.$refs.meetingModal.hide();
    }
  }
});

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./da": 536,
	"./da.js": 536
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 837;

/***/ }),
/* 838 */,
/* 839 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[(_vm.loading)?_c('div',[_c('b-alert',{staticClass:"text-center",attrs:{"show":"","lg":"12","md":"12","sm":"12","variant":"light"}},[_c('div',{staticClass:"loader"})])],1):_vm._e()])],1),_vm._v(" "),_c('b-row',[_vm._l((_vm.items),function(item){return (item.appnew === 1)?_c('b-col',{key:item.id,attrs:{"lg":"4","md":"6","sm":"12"}},[_c('b-card',{staticClass:"border-0 p-0 sm-p-0 rounded one-edge-shadow",attrs:{"bg-variant":item.id_appointment_status_support === '1' ? 'light' : 'secondary'}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"border-danger text-danger p-2 rounded text-small"},[_c('span',{staticClass:"el-icon-date mr-2"}),_vm._v(" "),_c('div',{staticClass:"d-inline-block"},[_vm._v(_vm._s(_vm.moment(item.appointment_date).format('DD/MM/YY'))+" "+_vm._s(item.id_times))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-dark p-2 text-small"},[_c('div',{staticClass:"font-weight-bold"},[_vm._v("Kunde: ")]),_vm._v(" "),_c('div',{},[_vm._v(_vm._s(item.firstname)+_vm._s(item.lastname))]),_vm._v(" "),_c('span',{staticClass:"text-small d-inline-block"},[_vm._v(_vm._s(item.mailingstreet)+" "+_vm._s(item.mailingcity)+" "+_vm._s(item.mailingzip))]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(item.potentialnameurl !== '')?_c('b-button',{staticClass:"my-3 rounded",attrs:{"variant":"dark","href":item.potentialnameurl,"target":"_blank"}},[_c('span',{staticClass:"mr1"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"}})])]),_vm._v("Prisoverslag")]):_vm._e()],1)])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"pl-2"},[(item.id_appointment_status_support === '0' && item.changedate === '1')?_c('b-btn',{staticClass:"rounded mr-3 border-0",attrs:{"variant":"info"},on:{"click":function($event){return _vm.showMeetingDetailsDate(item)}}},[_c('span',{staticClass:"el-icon-refresh-left mr1"}),_vm._v("\n                  Skift dato\n                ")]):_vm._e(),_vm._v(" "),(item.id_appointment_status_support === '0')?_c('b-btn',{staticClass:"rounded border-0",attrs:{"variant":"danger"},on:{"click":function($event){return _vm.showMeetingDetailsAflyse(item)}}},[_c('span',{staticClass:"el-icon-error mr-1"}),_vm._v("\n                  Aflyse\n                ")]):_vm._e()],1)])],1)],1)],1):_vm._e()}),_vm._v(" "),_c('b-modal',{ref:"meetingModal",attrs:{"centered":"","lazy":"","size":"sm"},model:{value:(_vm.meetingShow),callback:function ($$v) {_vm.meetingShow=$$v},expression:"meetingShow"}},[_c('div',{staticClass:"w-100 pb-0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"py-1"}),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.type))])])]),_vm._v(" "),_c('div',{staticClass:"modal-content p-0 border-0"},[_c('div',[_c('span',{staticClass:"text-secondary"},[_vm._v("By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.city))]),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.postnummer))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("Overslagspris eksl. moms")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold text-red"},[_vm._v(_vm._s(_vm.sampleMeeting.estimate))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("Dato")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.date))]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"py-4 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',[_c('b-btn',{attrs:{"variant":"outline-dark"},on:{"click":_vm.hideModal}},[_vm._v("Close")])],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"hide-footer":"","title":_vm.AflyseTexttitle},model:{value:(_vm.modalShowAflyseText),callback:function ($$v) {_vm.modalShowAflyseText=$$v},expression:"modalShowAflyseText"}},[_vm._v("\n        "+_vm._s(_vm.AflyseText)+"\n      ")]),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"id":"modalPrevent","hide-footer":"","title":_vm.Aflysetitle},model:{value:(_vm.modalShowAflyse),callback:function ($$v) {_vm.modalShowAflyse=$$v},expression:"modalShowAflyse"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"d-flex flex-row justify-content-between py-2 text-small"},[_c('p',{staticClass:"h6 font-weight-bold pt-2 text-dark"},[_vm._v(_vm._s(_vm.Aflysetitle))]),_vm._v(" "),_c('b-btn',{staticClass:"border-0",attrs:{"slot":"modal-close","variant":"outline-dark","type":"button"},slot:"modal-close"},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])],1),_vm._v(" "),_c('div',{staticClass:"pt-2 open-sans line-height-golden"},[_vm._v("Hvad skyldes aflysningen af mødet? VIGTIGT: Kunden vil blive kontaktet telefonisk.")])]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitAflyse.apply(null, arguments)}}},[_c('b-form-textarea',{staticClass:"textarea rounded border-0",attrs:{"rows":6,"max-rows":9,"required":""},model:{value:(_vm.textAflyseReason),callback:function ($$v) {_vm.textAflyseReason=$$v},expression:"textAflyseReason"}}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-button',{staticClass:"mt-3 rounded float-right",attrs:{"variant":"danger","type":"submit","disabled":_vm.isLoadingAflyse,"size":"lg"}},[_vm._v("Submit")]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)]),_vm._v(" "),_c('b-modal',{ref:"modal",attrs:{"id":"modalPrevent","hide-footer":"","size":"lg","title":_vm.Datosetitle},model:{value:(_vm.modalShowDato),callback:function ($$v) {_vm.modalShowDato=$$v},expression:"modalShowDato"}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitDato.apply(null, arguments)}}},[_c('b-form-row',[_c('b-col',{attrs:{"md":"12"}},[_c('b-form-group',{attrs:{"id":"dateStart","label":"Dato","label-for":"dateStart"}},[_c('date-picker',{attrs:{"id":"dateStart","required":"","config":_vm.config},model:{value:(_vm.dateDato),callback:function ($$v) {_vm.dateDato=$$v},expression:"dateDato"}})],1),_vm._v(" "),_c('b-form-group',{attrs:{"label":"Vælg tidspunkt","label-for":"timeStart"}},[_c('b-form-select',{attrs:{"id":"select_time","required":""},model:{value:(_vm.timeDato),callback:function ($$v) {_vm.timeDato=$$v},expression:"timeDato"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("00:00")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("00:30")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("01:00")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("01:30")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("02:00")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("02:30")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("03:00")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("03:30")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("04:00")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("04:30")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("05:00")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("05:30")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("06:00")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("06:30")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("07:00")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("07:30")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("08:00")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("08:30")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("09:00")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("09:30")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("10:00")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("10:30")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("11:00")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("11:30")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("12:00")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("12:30")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("13:00")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("13:30")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("14:00")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("14:30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("15:00")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("15:30")]),_vm._v(" "),_c('option',{attrs:{"value":"33"}},[_vm._v("16:00")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("16:30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("17:00")]),_vm._v(" "),_c('option',{attrs:{"value":"36"}},[_vm._v("17:30")]),_vm._v(" "),_c('option',{attrs:{"value":"37"}},[_vm._v("18:00")]),_vm._v(" "),_c('option',{attrs:{"value":"38"}},[_vm._v("18:30")]),_vm._v(" "),_c('option',{attrs:{"value":"39"}},[_vm._v("19:00")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("19:30")]),_vm._v(" "),_c('option',{attrs:{"value":"41"}},[_vm._v("20:00")]),_vm._v(" "),_c('option',{attrs:{"value":"42"}},[_vm._v("20:30")]),_vm._v(" "),_c('option',{attrs:{"value":"43"}},[_vm._v("21:00")]),_vm._v(" "),_c('option',{attrs:{"value":"44"}},[_vm._v("21:30")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("22:00")]),_vm._v(" "),_c('option',{attrs:{"value":"46"}},[_vm._v("22:30")]),_vm._v(" "),_c('option',{attrs:{"value":"47"}},[_vm._v("23:00")]),_vm._v(" "),_c('option',{attrs:{"value":"48"}},[_vm._v("23:30")])])],1)],1)],1),_vm._v(" "),_c('b-form-textarea',{attrs:{"rows":6,"max-rows":9,"placeholder":"Kommentar"},model:{value:(_vm.textDatoReason),callback:function ($$v) {_vm.textDatoReason=$$v},expression:"textDatoReason"}}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-form-group',{attrs:{"id":"dateStart","label":"Send e-mail","label-for":"Send Email"}},[_c('toggle-button',{attrs:{"name":"send_email","sync":true,"labels":true},model:{value:(_vm.send_email),callback:function ($$v) {_vm.send_email=$$v},expression:"send_email"}})],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-button',{staticClass:"mt-3 rounded",attrs:{"variant":"info","block":"","type":"submit","disabled":_vm.isLoadingDato}},[_vm._v("Submit")]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 840 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M18 24l-6-5.269-6 5.269v-24h12v24z"}})])]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Kommende aftaler")])])])]),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('p',{staticClass:"h6 open-sans line-height-golden py-4"},[_vm._v("Vi har været i gang med at opdatere din partnerprofil med en ny feature: markedspladsen!\n\t\t\t\t\t\t\tI menuen til venstre kan du nu klikke dig ind på vores "),_c('a',{attrs:{"variant":"link","href":"#/markedsplads"}},[_vm._v("online markedsplads")]),_vm._v(", hvor du kan få adgang til alle møderne, der matcher din profil,\n\t\t\t\t\t\t\tog købe møder udenom SMS-køen. Vær opmærksom på, at vi løbende kommer til at optimere markedspladsen.")])])]),_vm._v(" "),_c('b-card',{staticClass:"pt-0 pr-2 pb-0 border-0"},[_c('div',{staticClass:"card-text"},[_c('newmeetings')],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 841 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetings_vue__ = __webpack_require__(843);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e28430_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetings_vue__ = __webpack_require__(906);
function injectStyle (ssrContext) {
  __webpack_require__(842)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73e28430_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 842 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AllMeetingsTable__ = __webpack_require__(844);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imentor__ = __webpack_require__(103);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_1__imentor__["a" /* default */],
    allmeetings: __WEBPACK_IMPORTED_MODULE_0__AllMeetingsTable__["a" /* default */]
  },
  data: function data() {
    return {
      status: 'not_accepted'
    };
  }
});

/***/ }),
/* 844 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetingsTable_vue__ = __webpack_require__(846);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ac36a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetingsTable_vue__ = __webpack_require__(903);
function injectStyle (ssrContext) {
  __webpack_require__(845)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetingsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_47ac36a4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetingsTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 845 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_checkpayproff__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Countdown__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Countdown2__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_graphql_tag__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_vue_rate_it__);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query {\n          customers {\n            name,\n            phoneNumber,\n            email\n          }\n        }'], ['query {\n          customers {\n            name,\n            phoneNumber,\n            email\n          }\n        }']);














var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'allmeetings',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Loading: Loading,
    Countdown: __WEBPACK_IMPORTED_MODULE_8__components_Countdown__["a" /* default */],
    Countdown2: __WEBPACK_IMPORTED_MODULE_9__components_Countdown2__["a" /* default */],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__["a" /* default */],
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_6_vue_gallery_slideshow___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_7_vue_datetime__["Datetime"],
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_12__noneligibleFeaturepop__["a" /* default */],
    StarRating: __WEBPACK_IMPORTED_MODULE_13_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_14_vue_rate_it__["ImageRating"],
    ErrorHandler: ErrorHandler,
    checkpayproff: __WEBPACK_IMPORTED_MODULE_4__components_checkpayproff__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.gettaskbitrix();
    this.getallwizardproduct();
    var mobile = this.$route.query.mobile;
    if (this.$route.query.fromMarketplace) {
      this.quickVideoTutorialModalVisible = true;
    }
    if (mobile !== undefined) {
      this.search = mobile;
      this.$router.push('/alle-moeder');
    }
    this.env = "https://bitrixapi.haandvaerker.dk/v1/";
    this.contactID = this.$route.query.contactID;
    this.projectID = this.$route.query.projectID;
    this.klimaprofil = localStorage.getItem('ClimatePartner');
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');

    this.Reload();
    this.getPartnerImage();
    this.getSurveyId();
    this.getbrowser();
  },
  data: function data() {
    return {
      contactID: null,
      projectID: null,
      disableStatusSelection: false,
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      browserName: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      urlpris: '',
      datereminder: null,
      label: 'Loading...',
      service_reminder: '',
      AflyseText: '',
      search: '',
      CommentText: '',
      CommentCustomText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      showMobile: false,
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowkomment: false,
      textKomment: '',
      modalShowFeedback: false,
      textFeedback: '',
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPerson: '',
      haaId: '',
      oldestFirst: false,
      ascending: true,
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      },
      customer: {
        id: 5,
        firstName: '',
        lastName: '',
        email: ''
      },
      apollo: {
        customers: Object(__WEBPACK_IMPORTED_MODULE_10_graphql_tag__["a" /* default */])(_templateObject)
      },
      partnerImg: '',
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      surveySteps: {
        active: 0
      },
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      surveyId: '',
      priceFeedBackData: {
        priceManualChecked: false,
        price: 0,
        priceManualDisabled: true,
        steps: 1,
        nps: 0,
        note: ''
      },
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      optionikke: '',
      alloptionikke: [{ value: 0, text: 'Vælg venligst en mulighed' }, { value: 101, text: 'Kunden skal ikke have det lavet' }, { value: 102, text: 'Jeg har for travlt og kan ikke varetage opgaven alligevel' }, { value: 103, text: 'Projektet skal først laves langt ude i fremtiden' }, { value: 104, text: 'Kunden ønsker først et tilbud langt ude i fremtiden' }, { value: 105, text: 'Kunden har fået opgaven udført af en anden håndværker' }],
      alloptionikkebitrix: [{ value: 0, text: 'Vælg venligst en mulighed' }],
      showwikkeerror: false,
      salesPersonbitrix: '',
      env: '',
      itemsdetails: [],
      reviewsloading: false,
      customerdetails: {
        name: '',
        email: '',
        mobile: '',
        address: '',
        image: '',
        email_verified: '',
        payproffv2_account_id: ''
      },
      allreviewsbycid: [],
      contractIds: [],
      valuestatus: {},
      valuestatuscancel: {},
      SearchItembitrix: [],
      projectIds: [],

      selectedId: '',
      seeselectedoffer: false,
      totaloffer: 0,
      subtotaloffer: 0,
      innerloading: false,
      selectedArr: {},
      primaryproductindustryname: {},
      itemsjobindustry: {},
      standardnote: '',
      projectDescription: false,
      selectedprojecttitle: '',
      selectedprojectdesc: '',
      companyName: localStorage.getItem('CompanyName'),
      totalImageSize: '',
      limitUpload: 50,
      modalSurveyikkebitrix: false,
      notedescription: '',
      fileList: [],
      selectedjobid: '',
      selectedjobidcancel: null,
      formData: [],
      composenoteLoading: false,
      viewNote: false,
      partnernotesArr: [],
      addingnote: false,
      gallerystagenew: false,
      modalimageloading: false,
      photos: [],
      typegallery: 'none',
      activestagephoto: 0,
      optionikkebitrix: null,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() - -86400000 < Date.now();
        }
      },
      cancelreminderdate: null,
      totalitems: 0,
      perPage: 20,
      lastpage: 1,
      currentpage: null,
      quickVideoTutorialModalVisible: false
    };
  },

  filters: {
    truncate: function truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    }
  },
  watch: {
    'search': function search(newVal, oldVal) {
      var _this = this;

      setTimeout(function () {
        if (newVal.length > 2 && newVal !== '' && newVal !== null) {
          _this.getbitrixcustomers(1, newVal);
          _this.SearchItem = [];
        }
        if (newVal.length === 0) {
          _this.getbitrixcustomers(1, '');
          _this.SearchItem = [];
        }
      }, 400);
    }
  },
  computed: {},
  mounted: function mounted() {
    this.getyearsarray();
  },

  methods: {
    getbitrixcustomers: function getbitrixcustomers() {
      var _this2 = this;

      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var searchquery = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      var searpara = '';
      if (searchquery !== '') {
        searpara = '&search=' + searchquery;
      }
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/jobsV3?page=' + page + '&size=' + this.perPage + searpara, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (_this2.projectID && _this2.contactID) {
            _this2.SearchItembitrix = res.data.data.filter(function (p) {
              return Number(p.PROJECT_ID) === Number(_this2.projectID) && Number(p.CUSTOMER_ID) === Number(_this2.contactID);
            });
            _this2.loading = false;
            setTimeout(function () {
              document.getElementById('createoffer').click();
            }, 1000);
          } else {
            _this2.SearchItembitrix = res.data.data;
            _this2.totalitems = res.data.total;
            _this2.lastpage = res.data.last_page;
          }
          if (_this2.SearchItembitrix.length > 0) {
            _this2.SearchItembitrix[0].CANCEL_STATUS.forEach(function (p) {
              var cancelstatuseaac = {};
              cancelstatuseaac = {
                value: p.ID,
                text: p.TITLE_DK
              };
              _this2.alloptionikkebitrix.push(cancelstatuseaac);
            });
          }
          _this2.SearchItembitrix.forEach(function (j, index) {
            j.STATUS.forEach(function (f) {
              if (f.IS_SELECTED) {
                _this2.SearchItembitrix[index]['tilbudstatus'] = f.ID;
                _this2.SearchItembitrix[index]['tilbudstatus_text'] = f.TITLE_DK;
                _this2.valuestatus[index] = f.ID;
              }
            });
          });

          _this2.loading = false;
        } else {
          _this2.loading = false;
          _this2.$message({
            type: 'error',
            message: response.body.message
          });
        }
      }, function (response) {
        _this2.loading = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this2.refreshtoken();
          setTimeout(function () {
            _this2.Reload();
          }, 1000);
        } else {
          _this2.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    paginationChanged: function paginationChanged(curPage) {
      this.currentpage = curPage;
      this.SearchItembitrix = [];
      this.getbitrixcustomers(curPage);
    },
    getAcceptedOfferPrice: function getAcceptedOfferPrice(offerid, projectid, contactid, contractType, parentid) {
      var _this3 = this;

      var calculationid = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
      var joblist = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : [];

      var submittedIndustries = [];
      joblist.forEach(function (k) {
        if (Array.isArray(k)) {
          k.forEach(function (k) {
            var jobindustry = k.split(':')[0];
            submittedIndustries.push(jobindustry);
          });
        } else {
          var jobindustry = k.split(':')[0];
          submittedIndustries.push(jobindustry);
        }
      });
      var useprojid = contractType === 'Fagentreprise' || submittedIndustries.length === 1 && submittedIndustries[0] === '1062' ? parentid : projectid;
      this.selectedArr = {};
      this.totaloffer = 0;
      this.subtotaloffer = 0;
      this.standardnote = '';
      this.seeselectedoffer = true;
      this.innerloading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?project_id=' + useprojid + '&contact_id=' + Number(contactid) + '&calculation_id=' + calculationid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        var filteredresult = {};
        var result = res.result.filter(function (l) {
          if (Number(l.JOB_INDUSTRY) !== 1062) {
            return Number(l.PARTNER_ID) === Number(_this3.haaId) && submittedIndustries.includes(l.JOB_INDUSTRY);
          } else if (Number(l.JOB_INDUSTRY) === 1062 && submittedIndustries.length === 1) {
            return Number(l.PARTNER_ID) === Number(_this3.haaId) && submittedIndustries.includes(l.JOB_INDUSTRY);
          }
        });
        result.forEach(function (y) {
          if (!filteredresult[y.JOB_INDUSTRY]) {
            filteredresult[y.JOB_INDUSTRY] = [];
            filteredresult[y.JOB_INDUSTRY].push(y);
          } else {
            filteredresult[y.JOB_INDUSTRY].push(y);
          }
          _this3.subtotaloffer += Number(y.TOTAL);
          _this3.totaloffer += Number(y.TOTALVAT);
          _this3.standardnote = y.NOTE;
        });
        _this3.selectedArr = filteredresult;
        _this3.innerloading = false;
      }, function (response) {
        _this3.innerloading = false;
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this4 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this4.itemsjobindustry = industryname;
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this5.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this5.$message({
          type: 'error',
          message: error
        });
      });
    },
    getcontractlist: function getcontractlist() {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contracts/contacts', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var itemsId = [];
          var itemsIdpid = [];
          res.data.forEach(function (a) {
            itemsId.push(a.ID);
            itemsIdpid.push(parseInt(a.PROJECT_ID));
          });
          _this6.contractIds = itemsId;
          _this6.projectIds = itemsIdpid;
          _this6.Reload();
        } else {
          _this6.Reload();
          _this6.$message({
            type: 'error',
            message: response.bodymessage
          });
        }
      }, function (response) {
        _this6.Reload();
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this6.refreshtoken();
        } else {
          _this6.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this7 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this7.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this7.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this7.$router.push('/login');
      });
    },
    getReviewIdbycustomerId: function getReviewIdbycustomerId(id) {
      var _this8 = this;

      this.$refs.customerreviewsbypartners.show();
      this.reviewsloading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/GetAllReviewsDoneByHomeOwners?customerId=' + id, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          _this8.customerdetails.name = response.body.data.NAME;
          _this8.customerdetails.email = response.body.data.EMAIL;
          _this8.customerdetails.address = response.body.data.ADDRESS;
          _this8.customerdetails.mobile = response.body.data.MOBILE;
          _this8.customerdetails.image = response.body.data.PICTURE;
          _this8.customerdetails.email_verified = response.body.data.EMAIL_VERIFIED;
          _this8.customerdetails.payproffv2_account_id = response.body.data.IS_PAYPROFF_VERIFIED;
          _this8.allreviewsbycid = response.body.data.REVIEWS;
          _this8.reviewsloading = false;
        } else {
          _this8.$message({
            type: 'error',
            message: response.body.messag
          });
          _this8.reviewsloading = false;
        }
      }, function (response) {
        _this8.reviewsloading = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this8.refreshtoken();
        } else {
          _this8.$message({
            type: 'error',
            message: response.body.messag
          });
        }
      });
    },
    seeTenderFile: function seeTenderFile(item) {
      this.$router.push('/customer-projects/tender?projectID=' + item.PROJECT_ID + '&parentprojectID=' + item.PARENT_PROJECT.ID + '&tenderFolderID=' + (item.CONTRACT_TYPE === 'Hovedentreprise' ? item.PROJECT_TENDER_FOLDER_ID : item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID) + '&title=' + encodeURI(item.PROJECT_NAME.replaceAll('#', '')) + '&address=' + encodeURI(item.PROJECT_ADDRESS.replaceAll('#', '')) + '&contact_id=' + item.CUSTOMER_ID + '&parent_tenderID=' + (item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID ? item.PARENT_PROJECT.PROJECT_TENDER_FOLDER_ID : item.PROJECT_TENDER_FOLDER_ID) + '&tenderfiles=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.TENDER_FILES) + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUB_PROJECTS) + '&joblist=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.JOBS_LIST) + '&contracttype=' + item.CONTRACT_TYPE + '&offerstatus=' + item.OFFER_STATUS);
    },
    updateJobsStatus: function updateJobsStatus(jobid, statusindex) {
      var _this9 = this;

      if (this.valuestatus[statusindex] === 4) {
        this.modalSurveyikkebitrix = true;
        this.selectedjobidcancel = jobid;
        return false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        statusId: this.valuestatus[statusindex],
        jobId: jobid
      };
      this.$http.post(this.$bitrixapi + 'partner/updateJobStatus', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this9.$refs.simplert.openSimplert(obj);
        _this9.getbitrixcustomers();
      }, function (response) {
        var error = response.body.message;
        _this9.$message({
          type: 'error',
          message: error
        });
      });
    },
    showMeetingTilbudbitrix: function showMeetingTilbudbitrix(item) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (type === 'bitrixCustomers') {
        this.selectedId = item.CUSTOMER_ID + '&projectId=' + item.PROJECT_ID + '&contactId=' + item.CUSTOMER_ID + '&name=' + item.CUSTOMER_NAME + '&email=' + item.CUSTOMER_EMAIL + '&mobile=' + item.CUSTOMER_MOBILE + '&address=' + item.PROJECT_ADDRESS;
      } else if (type === 'bitrixCustomersBookingwizard') {
        this.$router.push('/tilbud/standardTilbudProduct?projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&industryID=' + item.ENTERPRISE_INDUSTRY + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUB_PROJECTS) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUBMITTED_JOB_INDUSTRY_IDS) + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME + '&joblist=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.JOBS_LIST) + '&createdfrom=' + item.CREATED_FROM);
      } else {
        this.selectedId = item.contactid;
      }
      this.$refs.quickandstandard.show();
    },
    hideModalquickandstandard: function hideModalquickandstandard() {
      this.$refs['quickandstandard'].hide();
    },
    showMeetingTilbudcreate: function showMeetingTilbudcreate(item) {
      this.$router.push('/tilbud/standardTilbud?app=' + item.contactid);
    },
    showtilbudhistory: function showtilbudhistory(item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.CUSTOMER_ID + '&from=minboligv2&projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&joblist=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.JOBS_LIST) + '&createdfrom=' + item.CREATED_FROM + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUB_PROJECTS) + '&offerid=' + item.OFFER_ID);
    },
    seeMessages: function seeMessages(id) {
      var projectid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      this.$router.push('/messages/inbox?customerId=' + id + '&projectId=' + projectid);
    },
    edittilbud: function edittilbud(item) {
      this.$router.push('/tilbud/standardTilbudProduct?projectID=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&offerID=' + item.OFFER_ID + '&mode=edit&contracttype=' + item.CONTRACT_TYPE + '&joblist=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.JOBS_LIST) + '&parentID=' + item.PARENT_PROJECT.ID + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUB_PROJECTS));
    },
    dataText: function dataText(key, status) {
      for (var i = 0; i < status.length; i++) {
        if (status[i].value === key) {
          return status[i].text;
        }
      }
      return '';
    },
    getbrowser: function getbrowser() {
      var userAgent = navigator.userAgent;
      if (userAgent.match(/chrome|chromium|crios/i)) {
        this.browserName = 'chrome';
      } else if (userAgent.match(/firefox|fxios/i)) {
        this.browserName = 'firefox';
      } else if (userAgent.match(/safari/i)) {
        this.browserName = 'safari';
        this.status = 9;
        console.log('browserName', this.browserName);
      } else if (userAgent.match(/opr\//i)) {
        this.browserName = 'opera';
      } else if (userAgent.match(/edg/i)) {
        this.browserName = 'edge';
      } else {
        this.browserName = 'No browser detection';
      }
    },
    getyearsarray: function getyearsarray() {
      var initialyear = 2018;
      var latestyear = new Date().getFullYear();
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear);
        initialyear++;
      }
      this.allyear.reverse();
    },
    filteryear: function filteryear(year) {
      var _this10 = this;

      this.activeyear = year;

      var itemsyear = [];
      var filteredyear = [];
      itemsyear = this.items.filter(function (item) {
        var createditemyear = new Date(item.createdtime).getFullYear();
        if (_this10.activeyear === 2023) {
          if (createditemyear === year) {
            return item.createdtime;
          }
        } else {
          if (createditemyear === year) {
            return item.createdtime;
          }
        }
      });
      itemsyear.forEach(function (value) {
        filteredyear.push(value);
      });
      this.SearchItem = this.filterSearch(filteredyear);
    },
    getdataigibility: function getdataigibility(appid, contactid) {
      if (this.klimaprofil === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.klimaprofil, '', 'ClimatePartner');
      } else {
        this.gotoKlima(appid, contactid);
      }
    },
    gotoKlima: function gotoKlima(appointmentId, contactId) {
      this.$router.push('/klima/checklist?appointmentId=' + appointmentId + '&contactId=' + contactId);
    },
    Reload: function Reload() {
      var _this11 = this;

      if (screen.width <= 640) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
      var cid = this.$route.query.id;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this11.$router.push('/login');
        }
        _this11.items = res.array;
        if (_this11.search !== '') {
          _this11.updateSearch();
        } else {
          _this11.SearchItem = _this11.filterSearch(_this11.items);
        }
        var latestyear = new Date().getFullYear();
        if (_this11.activeyear === '' && _this11.browserName !== 'safari') {
          _this11.filteryear(latestyear);
        }
        _this11.disableStatusSelection = false;
        _this11.getbitrixcustomers();
      }, function (response) {
        _this11.getbitrixcustomers();
        _this11.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getcontract: function getcontract(cid) {
      if (screen.width <= 640) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        cid: cid
      };
      this.$http.get(this.$bitrixapi + 'partner/contracts', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success && res.data.length > 0) {
          return true;
        } else {
          return false;
        }
      }, function (response) {
        console.log(response);
      });
    },
    onClick: function onClick(item, i) {
      item.index = i;
    },
    filterSearch: function filterSearch(item) {
      return item;
    },
    updateSearch: function updateSearch() {
      var _this12 = this;

      var items = [];
      items = this.items.filter(function (item) {
        return item.firstname.toLowerCase().includes(_this12.search.toLowerCase()) || item.lastname.toLowerCase().includes(_this12.search.toLowerCase()) || item.mailingstreet.toLowerCase().includes(_this12.search.toLowerCase()) || item.mailingzip.toLowerCase().includes(_this12.search.toLowerCase()) || item.mailingcity.toLowerCase().includes(_this12.search.toLowerCase()) || item.email.toLowerCase().includes(_this12.search.toLowerCase()) || item.comment_to_partner.toLowerCase().includes(_this12.search.toLowerCase()) || item.comment_to_customer.toLowerCase().includes(_this12.search.toLowerCase()) || item.mobile.toLowerCase().includes(_this12.search.toLowerCase());
      });
      this.SearchItem = this.filterSearch(items);
    },
    toggleSort: function toggleSort(statusDate) {
      var items = [];
      var order;
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times);
          b = new Date(b.appointment_date + ' ' + b.id_times);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status;
          b = b.id_appointment_status;
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.ascending = !this.ascending;
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date);
          b = new Date(b.tilbud_date);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve);
          b = new Date(b.datereserve);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else {}
    },
    toggleFilter: function toggleFilter(status) {
      var items = [];
      var filtered = [];
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('1');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '10') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('0');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i]);
            items = this.items.filter(function (item) {
              return item.tilbudstatus === statuscatcher;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '8') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length > 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '7') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length < 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '12') {
            items = this.items.filter(function (item) {
              return item.tilbudstatus === 6;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
        }
        this.SearchItem = this.filterSearch(filtered);
      } else {
        this.SearchItem = this.filterSearch(this.items);
      }
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
    },
    projectdesctionopen: function projectdesctionopen(textdesc, texttitle) {
      this.selectedprojectdesc = '';
      this.selectedprojecttitle = '';
      this.selectedprojectdesc = textdesc;
      this.selectedprojecttitle = texttitle;
      this.projectDescription = true;
    },
    opennotes: function opennotes(notes, id) {
      this.selectedjobid = id;
      this.partnernotesArr = notes;
      this.viewNote = true;
    },
    submitNoteBitrix: function submitNoteBitrix() {
      var _this13 = this;

      if (this.fileList.length < 1) {
        this.formData = new FormData();
      }
      this.composenoteLoading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.formData.append('jobId', this.selectedjobid);
      this.formData.append('note', this.notedescription);
      this.$http.post(this.$bitrixapi + 'partner/job/addNotes', this.formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this13.$refs.simplert.openSimplert(obj);
        _this13.composenoteLoading = false;
        _this13.formData = {};
        _this13.notedescription = '';
        _this13.addingnote = false;
        _this13.closenote();
        _this13.getbitrixcustomers();
      }, function (response) {
        _this13.composenoteLoading = false;
        var error = response.body.message;
        _this13.$message({
          type: 'error',
          message: error
        });
      });
    },
    handleFileChange: function handleFileChange(file, fileList) {
      var isLt1M = file.size / 1000 / 1000 < 7;
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        });
        var index = this.fileList.indexOf(file.key);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var _index = this.fileList.indexOf(file);
        this.fileList.splice(_index, 1);
        return false;
      }
      this.fileList = fileList.slice(0);
      this.formData = new FormData();
      for (var image in fileList) {
        this.formData.append('files[]', fileList[image].raw);
      }
    },
    closenote: function closenote() {
      this.partnernotesArr = [];
      this.fileList = [];
      this.formData = {};
      this.addingnote = false;
      this.viewNote = false;
      this.selectedjobid = null;
    },
    deletenote: function deletenote(noteid) {
      var _this14 = this;

      this.$confirm('Er du sikker på, at du vil slette denne note?', {
        confirmButtonText: 'Ja tak',
        cancelButtonText: 'Nej tak',
        type: 'warning'
      }).then(function () {
        _this14.composenoteLoading = true;
        _this14.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this14.salesPersonbitrix
        };
        _this14.$http.post(_this14.$bitrixapi + 'partner/job/' + _this14.selectedjobid + '/deleteNotes/' + noteid, _this14.formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this14.$refs.simplert.openSimplert(obj);
          _this14.composenoteLoading = false;
          _this14.addingnote = false;
          _this14.closenote();
          _this14.getbitrixcustomers();
        }, function (response) {
          _this14.composenoteLoading = false;
          var error = response.body.message;
          _this14.$message({
            type: 'error',
            message: error
          });
        });
      });
    },
    checkimage: function checkimage(index) {
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp';
      var getimage = document.getElementById('imagedivreview' + index);
      getimage.src = image2;
    },
    closengallery: function closengallery() {
      this.photos = [];
      this.gallerystagenew = false;
    },
    opengallery: function opengallery(images) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var index2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      this.photos = [];
      this.photos = images;
      this.gallerystagenew = true;
      this.typegallery = this.showMobile ? 'none' : 'card';
      setTimeout(function () {
        document.getElementById('gallerystagenew___BV_modal_body_').style.width = window.innerWidth + 'px';
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px';
        document.getElementById('gallerystagenew___BV_modal_body_').style.padding = 0 + 'px';
      }, 200);
    },
    prisUrlOpen: function prisUrlOpen(item) {
      this.modalShowPris = true;
      this.urlpris = item.potentialnameurl;
    },
    prisUrlOpendato: function prisUrlOpendato(item) {
      this.modalShowPris = true;
      this.urlpris = item.changedateurl;
    },
    prisUrlOpenFile: function prisUrlOpenFile(item) {
      this.modalShowPris = true;
      this.urlpris = item.potentialnameurl + '&file=1';
    },
    handleSletReminder: function handleSletReminder(item, type) {
      var _this15 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'delete_reminder_meeting', salesPerson: this.salesPerson, appointmentid: item.id_appointment, type: type };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this15.$router.push('/login');
        }
        _this15.show = false;
        if (res.success) {
          _this15.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this15.Reload();
          _this15.$refs.simplert.openSimplert(obj);
          _this15.datereminder = null;
        } else {
          alert(res.message);
          _this15.isLoadingDato = false;
        }
      }, function (response) {
        _this15.show = false;
        alert('error');
      });
    },
    handleSubmitReminder: function handleSubmitReminder(item) {
      var _this16 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var smsemail = item.remiderappid.smsemail;
      var dateReminder = this.datereminder;
      var descp = item.remiderappid.descp;
      if (dateReminder === '' || dateReminder === null) {
        var obj = {
          title: 'Påmindelse Dato ?',
          message: '',
          type: 'error'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      var data = { operation: 'change_reminder_meeting', salesPerson: this.salesPerson, smsemail: smsemail, appointmentid: item.id_appointment, date_reminder: dateReminder, descp: descp };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this16.$router.push('/login');
        }
        _this16.show = false;
        if (res.success) {
          _this16.modalShowDato = false;
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this16.Reload();
          document.getElementById('setReminderb' + item.id_appointment).click();
          _this16.$refs.simplert.openSimplert(_obj);
          _this16.datereminder = null;
        } else {
          alert(res.message);
          _this16.isLoadingDato = false;
        }
      }, function (response) {
        _this16.show = false;
        alert('error');
      });
    },
    handleSubmitDato: function handleSubmitDato() {
      var _this17 = this;

      this.isLoadingDato = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var emailpartner = 1;
      var idTime = $('#select_time').val();
      var time = $('#select_time :selected').text();
      var emailcustomer = this.send_email ? 1 : 0;
      var data = { operation: 'change_date', salesPerson: this.salesPerson, appointmentid: this.Datoeid.id_appointment, changedesc: this.textDatoReason, emailcustomer: emailcustomer, datechooseqbook: this.dateDato, id_time: idTime, time: time, emailpartner: emailpartner };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this17.$router.push('/login');
        }
        if (res.success) {
          _this17.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this17.$refs.simplert.openSimplert(obj);
          _this17.Datoeid.appointment_date = _this17.dateDato;
          _this17.dateDato = '';
          _this17.Datoeid.id_times = time;
          _this17.isLoadingDato = false;
        } else {
          alert(res.message);
          _this17.isLoadingDato = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    handleSubmitAflyse: function handleSubmitAflyse() {
      var _this18 = this;

      this.isLoadingAflyse = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'aflyse', salesPerson: this.salesPerson, appointmentid: this.Aflyseid.id_appointment, aflysedesc: this.textAflyseReason, ticket: 2 };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this18.$router.push('/login');
        }
        if (res.success) {
          _this18.modalShowAflyse = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this18.$refs.simplert.openSimplert(obj);
          _this18.Aflyseid.id_appointment_status_support = '1';
          _this18.Aflyseid.ticketsolution = '';
          _this18.Aflyseid.ticketstatus = 'Afventer behandling';
          _this18.Aflyseid.ticketcategory = 'Reklamation';
        } else {
          alert(res.message);
          _this18.isLoadingAflyse = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    handleSubmitFeedback: function handleSubmitFeedback() {
      var _this19 = this;

      this.isLoadingAflyse = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'addfeedback', salesPerson: this.salesPerson, feedback: this.textFeedback, id_appointment: this.kundeitem.id_appointment };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this19.$router.push('/login');
        }
        if (res.success) {
          _this19.$toastr('success', 'Gennemført');
          _this19.textFeedback = '';
          _this19.isLoadingAflyse = false;
          _this19.modalShowFeedback = false;
        } else {
          alert(res.message);
          _this19.isLoadingAflyse = false;
        }
      }, function (response) {
        alert('error');
        _this19.isLoadingAflyse = false;
      });
    },
    handleSubmitComment: function handleSubmitComment() {
      var _this20 = this;

      this.loading = true;
      this.modalShowkomment = false;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'addcomment', salesPerson: this.salesPerson, files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files), comment: this.textKomment, cid: this.kundeitem.contactid, commentId: this.commentId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this20.$router.push('/login');
        }
        if (res.success) {
          _this20.$toastr('success', 'Gennemført');
          _this20.textKomment = '';
          _this20.commentId = '';
          _this20.files = [];
          _this20.loadComment();
          _this20.Reload();
          _this20.isLoadingAflyse = false;
        } else {
          alert(res.message);
          _this20.isLoadingAflyse = false;
        }
      }, function (response) {
        alert('error');
        _this20.isLoadingAflyse = false;
      });
    },
    loadComment: function loadComment() {
      var _this21 = this;

      this.loading = true;
      var data = { operation: 'loadcomment', salesPerson: this.salesPerson, cid: this.kundeitem.contactid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this21.$router.push('/login');
        }
        _this21.komments = res;
        _this21.loading = false;
      }, function (response) {
        alert('error');
        _this21.loading = false;
      });
    },
    showMeetingTilbud: function showMeetingTilbud(item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.contactid);
    },
    showprojectdash: function showprojectdash(item) {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + item.PROJECT_ID + '&contactID=' + item.CUSTOMER_ID + '&parentID=' + item.PARENT_PROJECT.ID + '&industryID=' + item.ENTERPRISE_INDUSTRY + '&offertype=' + item.PROJECT_OFFER_TYPE + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUB_PROJECTS) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.SUBMITTED_JOB_INDUSTRY_IDS) + '&contracttype=' + item.CONTRACT_TYPE + '&projecttitle=' + item.PROJECT_NAME);
    },
    showMeetingDetailsAflysetext: function showMeetingDetailsAflysetext(item) {
      this.modalShowAflyseText = true;
      this.AflyseText = item.ticketsolution;
      this.AflyseTexttitle = item.ticketstatus;
    },
    showMeetingDetailsCommenttext: function showMeetingDetailsCommenttext(item) {
      this.modalShowCommentText = true;
      this.CommentText = item.comment_to_partner;
    },
    showMeetingDetailsCommentCustomertext: function showMeetingDetailsCommentCustomertext(item) {
      this.modalShowCommentCustomerText = true;
      this.CommentCustomerText = item.comment_to_customer;
    },
    showMeetingDetailsDate: function showMeetingDetailsDate(item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname;
      this.modalShowDato = true;
      this.Datoeid = item;
      this.textDatoReason = '';
      this.isLoadingDato = false;
      var select = document.getElementById('select_time');
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i];
        if (option.text === item.id_times) {
          this.timeDato = option.value;
        }
      }
    },
    showikkeform: function showikkeform() {
      this.$refs.modalSurveyikke.show();
    },
    closeSurveyModalikke: function closeSurveyModalikke() {
      this.$refs.modalSurveyikke.hide();
    },
    changeStatus: function changeStatus(value, item) {
      this.statusValue = value;
      this.statusItem = item;
      this.disableStatusSelection = true;

      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true;
          this.showPriceFeedBackModal();
        } else {
          this.updateStatus(value, item);
        }
      } else if (value === '5' || value === '6') {
        this.feedbackLoading = true;
        this.showSurveyModal();
      } else if (value === '100') {
        this.showikkeform();
      } else {
        this.updateStatus(value, item);
      }
    },
    updateStatusOther: function updateStatusOther() {
      var _this22 = this;

      var item = this.statusItem;
      var valueid = this.optionikke;
      var dataPartner = {
        operation: 'customer_other_status_henttilbud',
        salesPerson: this.salesPerson,
        status: valueid,
        cid: item.id_appointment
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        _this22.updateStatus(100, item);
        _this22.closeSurveyModalikke();
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this22.$refs.simplert.openSimplert(obj);
      }, function (response) {
        console.log('Error in updateStatus()', response);
      });
    },
    updateStatusOtherbitrix: function updateStatusOtherbitrix() {
      var _this23 = this;

      var jobid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      if (this.optionikkebitrix === null || this.optionikkebitrix === 0) {
        this.$message({
          type: 'error',
          message: 'Vælg venligst fra de fremhævede datoer'
        });
        return false;
      }
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        cancelStatusId: this.optionikkebitrix,
        jobId: this.selectedjobidcancel
      };
      if (this.cancelreminderdate !== null) {
        data.reminderDate = this.cancelreminderdate;
      }
      this.$http.post(this.$bitrixapi + 'partner/job/cancel', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this23.$refs.simplert.openSimplert(obj);
        _this23.closesurveyikkebitrix();
        _this23.getbitrixcustomers();
      }, function (response) {
        _this23.loading = false;
        var error = response.body.message;
        _this23.$message({
          type: 'error',
          message: error
        });
      });
    },
    closesurveyikkebitrix: function closesurveyikkebitrix() {
      this.modalSurveyikkebitrix = false;
      this.selectedjobidcancel = null;
    },
    updateStatus: function updateStatus(value, item) {
      var _this24 = this;

      this.modalPriceFeedback = false;
      this.modalSurvey = false;
      this.isLoadingReview = true;
      var dataPartner = { operation: 'customer_status_henttilbud', salesPerson: this.salesPerson, status: value, cid: item.id_appointment, descp: this.surveyDescription };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this24.show = false;
        if (res.login === false) {
          _this24.$router.push('/login');
        }
        _this24.isLoadingReview = false;
        _this24.surveyDescription = '';
        var infoType = '';
        if (res.success) {
          infoType = 'success';
        } else {
          infoType = 'info';
        }
        var obj = {
          title: res.message,
          message: '',
          type: infoType,
          customCloseBtnText: 'Luk'
        };
        _this24.$refs.simplert.openSimplert(obj);
        _this24.Reload();
      }, function (response) {
        console.log('Error in updateStatus()', response);
      });
    },
    submitSurveyDescription: function submitSurveyDescription() {
      if (this.surveyDescription !== '') {
        var value = this.statusValue;
        var item = this.statusItem;
        if (value === '100') {
          this.modalSurvey = false;
          var thisVar = this;
          setTimeout(function () {
            thisVar.statusConfirmation = true;
          }, 1000);
        } else {
          this.updateStatus(value, item);
        }
      } else {
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    feedbackLoaded: function feedbackLoaded() {},
    priceManualChanged: function priceManualChanged() {
      if (this.priceFeedBackData.priceManualChecked) {
        this.priceFeedBackData.priceManualDisabled = false;
      } else {
        this.priceFeedBackData.priceManualDisabled = true;
      }
    },
    getSurveyId: function getSurveyId() {
      var _this25 = this;

      var data = { operation: 'partner_survey', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this25.surveyId = res.url;
      }, function (response) {
        console.log('Error in getSurveyId()', response);
      });
    },
    showPriceFeedBackModal: function showPriceFeedBackModal() {
      this.modalPriceFeedback = true;
      var thisVar = this;
      setTimeout(function () {
        thisVar.feedbackLoading = false;
      }, 1000);
    },
    closePriceFeedBackModal: function closePriceFeedBackModal() {
      var value = this.statusValue;
      var item = this.statusItem;
      if (value === '4') {
        setTimeout(function () {
          var buttonRecommendation = document.getElementById('recommendInvitation-' + item.id_appointment);
          buttonRecommendation.click();
        }, 1000);
      } else {
        this.updateStatus(value, item);
      }
      this.modalPriceFeedback = false;
      this.priceFeedBackData.priceManualChecked = false;
      this.priceFeedBackData.price = 0;
      this.priceFeedBackData.priceManualDisabled = true;
      this.priceFeedBackData.steps = 1;
      this.priceFeedBackData.nps = 0;
      this.priceFeedBackData.note = '';
    },
    showSurveyModal: function showSurveyModal() {
      this.modalSurvey = true;
      var thisVar = this;
      setTimeout(function () {
        thisVar.feedbackLoading = false;
        document.querySelector('#surveyPopup').classList.remove('hide');
      }, 1000);
    },
    closeSurveyModal: function closeSurveyModal() {
      this.surveyDescription = '';
      this.Reload();
      this.modalSurvey = false;
    },
    closereviewsmodal: function closereviewsmodal() {
      this.$refs.customerreviewsbypartners.hide();
    },
    getPartnerImage: function getPartnerImage() {
      var _this26 = this;

      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.resultImages.length !== 0) {
          _this26.partnerImg = res.resultImages[0].FileLocation;
        }
      }, function (response) {
        alert('error');
      });
    },
    confirmRecommendInvitation: function confirmRecommendInvitation(value, item, answer) {
      var _this27 = this;

      if (answer === 'yes') {
        return function (dialog) {
          return _this27.sendRecommendInvitation(value, item);
        };
      } else {
        return function (dialog) {
          return _this27.dontSendRecommendInvitation(value, item);
        };
      }
    },
    confirmRecommendInvitationnew: function confirmRecommendInvitationnew() {
      var value = this.statusValue;
      var item = this.statusItem;
      this.statusConfirmation = false;
      this.updateStatus(value, item);
    },
    cancelRecommendInvitationnew: function cancelRecommendInvitationnew() {
      this.Reload();
      this.surveyDescription = '';
      this.statusConfirmation = false;
    },
    sendRecommendInvitation: function sendRecommendInvitation(value, item) {
      var _this28 = this;

      var customers = [];
      customers.push({
        name: item.firstname + ' ' + item.lastname,
        email: item.email,
        mobile: item.mobile
      });
      var data = {
        operation: 'service_invite_action',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(customers),
        imgPicked: this.partnerImg,
        bcc: '0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this28.updateStatus(value, item);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    dontSendRecommendInvitation: function dontSendRecommendInvitation(value, item) {
      this.updateStatus(value, item);
    },
    cancelDidNotWinTask: function cancelDidNotWinTask() {
      this.Reload();
      this.modalSurvey = false;
    },
    showMeetingDetailsAflyse: function showMeetingDetailsAflyse(item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?';
      this.modalShowAflyse = true;
      this.Aflyseid = item;
      this.textAflyseReason = '';
      this.isLoadingAflyse = false;
    },
    filterItem: function filterItem(items) {
      var newItem = [];
      for (var iteme in items) {
        newItem.push(items[iteme]);
      }
      return newItem;
    },
    showMeetingDetails: function showMeetingDetails(item) {
      this.meetingShow = !this.meetingShow;
      this.sampleMeeting.id = item.id;
      this.sampleMeeting.type = item.type;
      this.sampleMeeting.estimate = item.estimate;
      this.sampleMeeting.city = item.city;
      this.sampleMeeting.postnummer = item.postnummer;
      this.sampleMeeting.price = item.price;
      this.sampleMeeting.date = item.date;
    },
    hideModal: function hideModal() {
      this.$refs.meetingModal.hide();
    },
    mailSupport: function mailSupport(cid) {
      this.$router.push('/inbox?cid=' + cid);
    },
    openFeedback: function openFeedback(item) {
      this.kundeitem = item;
      this.loadComment();
      this.isLoadingAflyse = false;
      this.modalShowFeedback = true;
    },
    openComment: function openComment(item) {
      this.kundeitem = item;
      this.loadComment();
      this.isLoadingAflyse = false;
      this.modalShowkomment = true;
      this.commentId = '';
      this.textKomment = '';
    },
    editComment: function editComment(item) {
      this.commentId = item.id;
      this.textKomment = item.note;
    },
    CanceleditComment: function CanceleditComment() {
      this.commentId = '';
      this.textKomment = '';
    },
    hideReminderModal: function hideReminderModal() {
      this.$refs.reminderModal.hide();
    },
    priceFeedBackPriceChanged: function priceFeedBackPriceChanged() {
      var price = document.querySelector('#priceFeedBackPrice input').value;
      if (!price.includes('kr')) {
        document.querySelector('#priceFeedBackPrice input').value = parseFloat(price).toLocaleString('da-DK', { style: 'currency', currency: 'DKK' });
      }
    },
    priceFeedBackStep: function priceFeedBackStep(option) {
      if (option === 'back') {
        if (this.priceFeedBackData.steps > 0) {
          this.priceFeedBackData.steps--;
        }
      } else if (option === 'next') {
        if (this.priceFeedBackData.price > 0) {
          if (this.priceFeedBackData.steps < 2) {
            this.priceFeedBackData.steps++;
          }
        } else {
          this.$toastr('error', 'Indtast venligst beløb');
        }
      } else {
        if (this.priceFeedBackData.nps > 0) {
          this.feedbackLoading = true;
          this.saveFeedBackPrice();
        } else {
          this.$toastr('error', 'Felter påkrævet');
        }
      }
    },
    saveFeedBackPrice: function saveFeedBackPrice() {
      var _this29 = this;

      var shortUrl = this.statusItem.urlshort;
      var url = 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savefeedback&short=' + shortUrl;
      var potentialId = this.statusItem.potential_id;
      var price = this.priceFeedBackData.price;
      var data = {
        potential_id: potentialId,
        price: price
      };
      this.$http.post(url, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this29.saveFeedBackNps();
        } else {
          _this29.feedbackLoading = false;
          console.log('Error in saveFeedBackPrice()', response);
        }
      }, function (response) {
        _this29.feedbackLoading = false;
        console.log('Error in saveFeedBackPrice()', response);
      });
    },
    saveFeedBackNps: function saveFeedBackNps() {
      var _this30 = this;

      var shortUrl = this.statusItem.urlshort;
      var url = 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savefeedbacknps&short=' + shortUrl;
      var potentialId = this.statusItem.potential_id;
      var note = this.priceFeedBackData.note;
      var nps = this.priceFeedBackData.nps;
      var data = {
        potential_id: potentialId,
        note: note,
        nps: nps
      };
      this.$http.post(url, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this30.priceFeedBackData.steps = 3;
          _this30.feedbackLoading = false;
        } else {
          _this30.feedbackLoading = false;
          console.log('Error in saveFeedBackNps()', response);
        }
      }, function (response) {
        _this30.feedbackLoading = false;
        console.log('Error in saveFeedBackNps()', response);
      });
    },
    closemodaloffer: function closemodaloffer() {
      this.selectedArr = {};
      this.totaloffer = 0;
      this.seeselectedoffer = false;
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      var isLt1M = file.size / 1000 / 1000 < 17;
      this.checkImageSizes();
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          });
          return false;
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var index = this.fileList.indexOf(file);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        });
        var _index2 = this.fileList.indexOf(file.key);
        this.fileList.splice(_index2, 1);
        return false;
      }
      return isIMAGE && isLt1M;
    },
    checkImageSizes: function checkImageSizes() {
      var fileSize = 0;
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size);
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length;
      } else {
        this.limitUpload = 50;
      }
      this.totalImageSize = fileSize;
    },
    removeImage: function removeImage(file, fileList) {
      var index = fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      var index2 = fileList.indexOf(file.raw);
      if (index2 > -1) {
        this.images.splice(index2, 1);
      }
    }
  }
});

/***/ }),
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countries_json__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages_json__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__languages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__languages_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__ = __webpack_require__(102);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'checkpayproff',
  components: {
    datepicker: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    da: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker_dist_locale__["da"]
  },
  data: function data() {
    return {
      salesPersonbitrixbitrix: '',
      haaId: '',
      partnername: '',
      defaultpackage: [],
      haspayproff: false,
      ispartnerpayproffverified: false,
      isverified: false,
      verifylink: '',
      payproffform: false,
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: localStorage.getItem('address'),
        zipcode: localStorage.getItem('zipcode'),
        by: localStorage.getItem('city'),
        stat: 'Denmark',
        land: 'DK',
        email: localStorage.getItem('email'),
        telefonnummer: Number(localStorage.getItem('PartnerTelefon')),
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: localStorage.getItem('Cvrnr'),
        companyName: localStorage.getItem('CompanyName')
      },
      activeNames: [],
      payprofformfules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fødelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      confirmPayproff: false,
      countryData: __WEBPACK_IMPORTED_MODULE_2__countries_json___default.a,
      languagesData: __WEBPACK_IMPORTED_MODULE_3__languages_json___default.a,
      isPep: true,
      partnerwallet: {},
      partneriban: '',
      ibanmessage: null
    };
  },
  created: function created() {
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.haaId = localStorage.getItem('haaid');
    this.partnername = localStorage.getItem('CompanyName');
  },
  mounted: function mounted() {},

  methods: {
    showlink: function showlink() {
      window.open(this.verifylink, '_blank').focus();
    },
    verifypartner: function verifypartner() {
      var _this = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.haaId = localStorage.getItem('haaid');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this.verifylink = res.url;
        _this.isverified = true;
      }, function (response) {});
    },
    getwalletinfo: function getwalletinfo() {
      var _this2 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/payproff/wallet', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this2.partnerwallet = res;
      }, function (response) {
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    updateiban: function updateiban() {
      var _this3 = this;

      if (!this.partnerwallet) {
        this.$message({
          type: 'error',
          message: 'Din tegnebog er konfigureret korrekt, kontakt venligst support for yderligere hjælp'
        });
        return false;
      }
      if (!this.partneriban) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst dit Iban-nummer'
        });
        return false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        iban: this.partneriban,
        walletid: this.partnerwallet['WALLET_ID']
      };
      this.$http.put(this.$bitrixapi + 'partner/payproff/wallet', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this3.$refs.simplert.openSimplert(obj);
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    verifyIban: function verifyIban(ibantext) {
      var _this4 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/validateIban/' + this.partneriban.replace(/ /g, ''), { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data.valid) {
          if (ibantext === '') {
            _this4.registerpayproff();
          }
          _this4.ibanmessage = null;
        } else {
          var messagearr = '';
          res.data.messages.forEach(function (t) {
            messagearr += t + ', ';
          });
          _this4.ibanmessage = messagearr;
          _this4.$message({
            type: 'error',
            message: messagearr
          });
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getPayproffacc: function getPayproffacc() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.haspayproff = res.data.exists;
        _this5.ispartnerpayproffverified = res.data.payproff_verified;
        _this5.verifylink = res.data.payproff_url;
        _this5.payprofftatus = res.data.status;
        if (!_this5.haspayproff) {
          _this5.payproffform = true;
        } else if (!_this5.verifylink && _this5.haspayproff && !_this5.ispartnerpayproffverified) {
          _this5.verifypartner();
        } else if (_this5.haspayproff && _this5.verifylink && !_this5.ispartnerpayproffverified && _this5.payprofftatus === null) {
          _this5.isverified = true;
        }
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    updateStatus: function updateStatus(buttonstatus) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };

      var data = {
        status: buttonstatus
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/updateStatus', data, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    closeconfirmPayproff: function closeconfirmPayproff() {
      this.confirmPayproff = false;
    },
    openpayproffform: function openpayproffform() {
      this.payproffform = true;
    },
    closepayproffform: function closepayproffform() {
      this.payproffform = false;
      this.ConfirmVisible = false;
    },
    openconfirmPayproff: function openconfirmPayproff() {
      if (!this.partneriban) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst dit Iban-nummer'
        });
        return false;
      }
      var isnumber = /^\d+$/.test(this.payprofform.cprnummer);
      if (!isnumber) {
        this.$message({
          type: 'error',
          message: 'Indtast kun tal på cpr-nummeret'
        });
        return false;
      }
      var error = 0;
      this.$refs['payprofform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.closepayproffform();
      this.confirmPayproff = true;
    },
    validateCreatePayproffFirstTab: function validateCreatePayproffFirstTab() {
      return true;
    },
    getNemIdUrl: function getNemIdUrl() {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        window.open(res.data.URL, '_blank').focus();
      }, function (err) {
        _this6.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    registerpayproff: function registerpayproff() {
      var _this7 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: Number(this.payprofform.cprnummer),
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName,
        iban: this.partneriban.replace(/ /g, '')
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.closeconfirmPayproff();
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this7.$refs.simplert.openSimplert(obj);
          _this7.getNemIdUrl();
        } else {
          _this7.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this7.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    setmaskinput: function setmaskinput() {
      this.partneriban = this.$maskibanNumber(this.partneriban);

      if (this.partneriban.length > 21) {
        this.verifyIban('checkiban');
      }
    }
  },
  watch: {
    'partneriban': function partneriban(newVal, oldVal) {
      var _this8 = this;

      setTimeout(function () {
        if (newVal.length > 1) {
          _this8.setmaskinput(newVal);
        }
      }, 300);
    }
  }
});

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"checkpayproff"}},[_c('b-modal',{ref:"isverified",attrs:{"centered":"","hide-footer":"","id":"isverified","no-close-on-backdrop":true},model:{value:(_vm.isverified),callback:function ($$v) {_vm.isverified=$$v},expression:"isverified"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background  p2"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.isverified = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"semi-bold h4 darkblue pt1 mx-auto"},[_vm._v("Valider din Payproff konto ")]),_vm._v(" "),_c('button',{staticClass:" my2 col-8 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){_vm.showlink(), _vm.updateStatus('clicked')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Valider konto")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])]),_vm._v(" "),_c('b-modal',{ref:"payproffform",attrs:{"centered":"","hide-footer":"","id":"payproffform","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.payproffform),callback:function ($$v) {_vm.payproffform=$$v},expression:"payproffform"}},[_c('div',{staticClass:"col-11 flex justify-between items-center pt1 p0 mx-auto my2"},[_c('div',{staticClass:"col-5"},[_c('p',{staticClass:"mr-auto h5 cyprus semi-bold line-height-1 m0 p0"},[_vm._v("Payproff Form\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 ml-auto flex justify-end h4 p0 primary-white-button pointer close m0",on:{"click":function($event){return _vm.closepayproffform()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"hide"},[_c('div',{staticClass:"flex flex-column "},[_c('span',{},[_c('i',{staticClass:"el-icon-loading"})]),_vm._v(" "),_c('p',{staticClass:"h6 regular small"},[_vm._v("Godkendt af Finanstilsynet")]),_vm._v(" "),_c('p',{staticClass:"p0 m0"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('span',{},[_vm._v("Information")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"darkblue notosans",attrs:{"id":"payproff"}},[_c('el-form',{ref:"payprofform",staticClass:"md-col-12 lg-col-12 sm-col-12 mx-auto p1",attrs:{"id":"cvrfrom","model":_vm.payprofform,"rules":_vm.payprofformfules,"label-position":"top"}},[_c('form-wizard',{ref:"createPayproffFormWiz",attrs:{"shape":"tab","color":"#ffffff"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"col-12 p0 flex",class:props.isLastStep ? 'justify-between' : 'justify-end'},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-primary-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){props.isLastStep ? _vm.openconfirmPayproff() : props.nextTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(props.isLastStep ? 'Indsend' : 'Næste'))]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])]}}])},[_c('tab-content',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"mb2 flex flex-column items-start p0"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"152.26","height":"35.735","viewBox":"0 0 152.26 35.735"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1428","data-name":"Rectangle 1428","width":"152.26","height":"35.735","fill":"#2265fc"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Payproff_logo","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4272","data-name":"Path 4272","d":"M820.931,52.36v0Z","transform":"translate(-668.671 -41.591)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4273","data-name":"Path 4273","d":"M820.931,78.36v0Z","transform":"translate(-668.671 -62.769)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4274","data-name":"Path 4274","d":"M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072","transform":"translate(0 0)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4275","data-name":"Path 4275","d":"M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016","transform":"translate(-381.958 -44.465)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4276","data-name":"Path 4276","d":"M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021","transform":"translate(-179.766 -44.315)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4277","data-name":"Path 4277","d":"M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022","transform":"translate(-249.978 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4278","data-name":"Path 4278","d":"M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0","transform":"translate(-507.012 -60.278)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4279","data-name":"Path 4279","d":"M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0","transform":"translate(-572.504 -39.143)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4280","data-name":"Path 4280","d":"M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012","transform":"translate(-624.503 -39.14)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4281","data-name":"Path 4281","d":"M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z","transform":"translate(-331.26 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4282","data-name":"Path 4282","d":"M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276","transform":"translate(-456.523 -60.325)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4283","data-name":"Path 4283","d":"M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117","transform":"translate(-314.339 -60.317)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4284","data-name":"Path 4284","d":"M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175","transform":"translate(-589.263 -60.244)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4285","data-name":"Path 4285","d":"M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469","transform":"translate(-641.245 -60.253)","fill":"#2265fc"}})])]),_vm._v(" "),_c('span',[_vm._v("Godkendt af Finanstilsynet")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center cyprus"},[_c('span',[_c('svg',{staticClass:"block",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"}})])]),_vm._v(" "),_c('p',{staticClass:"h5 line-height-1 m0 ml1 p0"},[_vm._v("Information")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix pr3 mb2"},[_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  "),_c('a',{staticClass:"semi-bold",attrs:{"href":"https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186","target":"_blank"}},[_vm._v("her")]),_vm._v(", og læse mere om de godkendelser, de har fået\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("\n                  PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.")])]),_vm._v(" "),_c('div',[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor har du brug for mine bankoplysninger?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("Vi har brug for dine bankoplysninger for at sende dig pengene eller for at\n                        refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver\n                        at dele dine bankoplysninger med din kontraktpartner.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvordan overfører jeg pengene til PayProff?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,\n                        Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de\n                        bankoplysninger og referencenummer, du skal bruge input, når du foretager\n                        overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte\n                        referencenummer Der kan opstå forsinkelser, da vores system ikke vil være\n                        i stand til at afstemme din betaling med det samme.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("For at overholde lovmæssige krav skal vi muligvis stille dig et par\n                        ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,\n                        hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper\n                        økonomisk kriminalitet.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi\n                        en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du\n                        er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.\n                        Flere muligheder om identitetsbekræftelse både for private enkeltpersoner\n                        og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.")])],2)],1)],1)])]),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateCreatePayproffFirstTab}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fornavn","prop":"fornavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"fornavn","clearable":""},model:{value:(_vm.payprofform.fornavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "fornavn", $$v)},expression:"payprofform.fornavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Efternavn","id":"efternavn","prop":"efternavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"efternavn","clearable":""},model:{value:(_vm.payprofform.efternavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "efternavn", $$v)},expression:"payprofform.efternavn"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Mellemnavn","prop":"mellemnavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"mellemnavn","clearable":""},model:{value:(_vm.payprofform.mellemnavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "mellemnavn", $$v)},expression:"payprofform.mellemnavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 ml-auto",attrs:{"label":"Fødelsdag","id":"fodelsdag","prop":"fodelsdag"}},[_c('datepicker',{staticClass:"col-12 m0 p0",attrs:{"id":"datepickeroffer2","bootstrapStyling":false,"placeholder":"Fødelsdag","language":_vm.da},model:{value:(_vm.payprofform.fodelsdag),callback:function ($$v) {_vm.$set(_vm.payprofform, "fodelsdag", $$v)},expression:"payprofform.fodelsdag"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Adresse","prop":"Adresse"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"Strandlodsvej 6, 1. sal","clearable":""},model:{value:(_vm.payprofform.Adresse),callback:function ($$v) {_vm.$set(_vm.payprofform, "Adresse", $$v)},expression:"payprofform.Adresse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"zipcode","id":"zipcode","prop":"zipcode"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"2300","clearable":""},model:{value:(_vm.payprofform.zipcode),callback:function ($$v) {_vm.$set(_vm.payprofform, "zipcode", $$v)},expression:"payprofform.zipcode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"By","prop":"by"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"København s","clearable":""},model:{value:(_vm.payprofform.by),callback:function ($$v) {_vm.$set(_vm.payprofform, "by", $$v)},expression:"payprofform.by"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Stat","id":"stat","prop":"stat"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"stat","clearable":""},model:{value:(_vm.payprofform.stat),callback:function ($$v) {_vm.$set(_vm.payprofform, "stat", $$v)},expression:"payprofform.stat"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"E-mail","clearable":""},model:{value:(_vm.payprofform.email),callback:function ($$v) {_vm.$set(_vm.payprofform, "email", $$v)},expression:"payprofform.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Land","id":"land","prop":"land"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"Country"},model:{value:(_vm.payprofform.land),callback:function ($$v) {_vm.$set(_vm.payprofform, "land", $$v)},expression:"payprofform.land"}},_vm._l((_vm.countryData),function(country,index){return _c('el-option',{key:index,attrs:{"label":country,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"telefonnummer","prop":"telefonnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"8","placeholder":"Tel.(8 cifre)","clearable":""},model:{value:(_vm.payprofform.telefonnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "telefonnummer", _vm._n($$v))},expression:"payprofform.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefon contry code","id":"telcountrycode","prop":"telcountrycode"}},[_c('el-input',{staticClass:"white-background",attrs:{"placeholder":"+45","clearable":""},model:{value:(_vm.payprofform.telcountrycode),callback:function ($$v) {_vm.$set(_vm.payprofform, "telcountrycode", _vm._n($$v))},expression:"payprofform.telcountrycode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"CPR nummer","id":"cprnummer","prop":"cprnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"10","placeholder":"XXXXXXXXXX","clearable":""},model:{value:(_vm.payprofform.cprnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "cprnummer", $$v)},expression:"payprofform.cprnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Sprog","id":"sprog","prop":"sprog"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","placeholder":"sprog","clearable":""},model:{value:(_vm.payprofform.sprog),callback:function ($$v) {_vm.$set(_vm.payprofform, "sprog", $$v)},expression:"payprofform.sprog"}},_vm._l((_vm.languagesData),function(language,index){return _c('el-option',{key:index,attrs:{"label":language,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Betalingsmiddel","id":"currency","prop":"currency"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"DKK"},model:{value:(_vm.payprofform.currency),callback:function ($$v) {_vm.$set(_vm.payprofform, "currency", $$v)},expression:"payprofform.currency"}},[_c('el-option',{attrs:{"vlabel":"DKK","value":"DKK"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Iban","id":"partneriban","prop":"partneriban"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"22","placeholder":"DKXXXXXXXXXXXXXXXXXX","clearable":""},model:{value:(_vm.partneriban),callback:function ($$v) {_vm.partneriban=$$v},expression:"partneriban"}})],1),_vm._v(" "),(_vm.ibanmessage)?_c('label',{staticClass:"error red h5 small"},[_vm._v(_vm._s(_vm.ibanmessage))]):_vm._e()],1)])])],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"confirmPayproff",attrs:{"centered":"","hide-footer":"","id":"confirmPayproff","no-close-on-backdrop":true,"size":"lg"},model:{value:(_vm.confirmPayproff),callback:function ($$v) {_vm.confirmPayproff=$$v},expression:"confirmPayproff"}},[_c('div',{staticClass:"col-12 flex justify-end items-center pt1 p0 mx-auto modal-header"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer",on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background"},[_c('div',{staticClass:"flex flex-column items-start col-12 pb3 pt1 px3"},[_c('p',{staticClass:"muted-color h6 pt1"},[_vm._v("Er du en politisk udsat person? (PEP)")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold py1 mt1"},[_vm._v("Hvad er en politisk eksponeret person?")]),_vm._v(" "),_c('p',{staticClass:"h6 mt1 center"},[_vm._v("Jeg bekræfter og siger sandfærdigt, som om jeg var under ed, at:")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start my2"},[[_c('el-radio',{attrs:{"label":true},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Ja")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Nej")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"flex "},[_c('button',{staticClass:" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-back pr1"}),_vm._v("Tilbage\n          ")]),_vm._v(" "),_c('button',{staticClass:"mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.verifyIban('')}}},[_vm._v("Send "),_c('i',{staticClass:"pl1 el-icon-right"})])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 857 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_upload_progress_vue__ = __webpack_require__(540);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { fileUploadProgress: __WEBPACK_IMPORTED_MODULE_0__file_upload_progress_vue__["a" /* default */] },
  props: {
    buttonText: {
      default: 'Choose File'
    },
    token: {
      required: true
    },
    module: {
      required: true
    },
    moduleId: {
      default: ''
    },
    clearFile: {
      default: false
    }
  },
  directives: {
    uploader: {
      bind: function bind(el, binding, vnode) {
        el.addEventListener('change', function (e) {
          vnode.context.file = e.target.files[0];
        });
      }
    }
  },
  watch: {
    file: function file(_file) {
      var _this = this;

      localStorage.setItem('uploadFinish', false);

      var fileExtension = _file.name.substr(_file.name.lastIndexOf('.') + 1).toLowerCase();
      if (this.allowed_file_extensions.indexOf(fileExtension) === -1) {
        this.progress = 0;
        this.isUploadDisabled = false;
        this.$toastr('error', 'Fil ikke tilladt');
      } else if (_file.size > 42000000) {
        this.progress = 0;
        this.isUploadDisabled = false;
        this.$toastr('error', 'Filstørrelsesgrænsen overskredet');
      } else {
        this.progress = 10;
        this.salesPerson = localStorage.getItem('id_token_portal');
        var formData = new FormData();
        formData.append('operation', 'userInboxUpload');
        formData.append('file', _file);
        formData.append('salesPerson', this.salesPerson);
        formData.append('id', this.moduleId);

        this.$http.post('', formData, { emulateJSON: true,

          onUploadProgress: function (progressEvent) {
            this.progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (response) {
          var res = response.body;
          if (res.login === false) {
            _this.$router.push('/login');
          }
          if (res.file) {
            _this.$toastr('success', 'Gennemført');
            localStorage.setItem('uploadFinish', true);
            localStorage.removeItem('uploadFinish');
            _this.uploadedFiles.push(res.file);
            _this.$emit('UpdateTilbud', _this.uploadedFiles);
          }
          _this.progress = 100;
          _this.isUploadDisabled = false;
        }, function (response) {
          alert('error');
          _this.progress = 0;
          _this.isUploadDisabled = false;
        });
      }
    },
    clearFile: function clearFile(val) {
      this.uploadedFiles = [];
      this.$emit('UpdateTilbud', this.uploadedFiles);
    },
    moduleId: function moduleId(val) {
      if (val) this.fetchUploads();
    }
  },
  mounted: function mounted() {
    if (this.moduleId) this.fetchUploads();
    this.allowed_file_extensions = ['jpg', 'png', 'jpeg', 'pdf', 'doc', 'docx', 'xls', 'xlsx', 'txt', 'csv'];
  },

  computed: {
    authToken: function authToken() {
      return localStorage.getItem('auth_token');
    },
    isFileSelected: function isFileSelected() {
      return this.isUploadDisabled;
    }
  },
  methods: {
    launchFilePicker: function launchFilePicker() {
      this.isUploadDisabled = false;
      this.$refs.file.click();
    },
    reload: function reload() {
      var _this2 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'userExtention', salesPerson: localStorage.getItem('id_token_portal') };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.allowed_file_extensions = res;
      }, function (response) {
        alert('error');
      });
    },
    cancelUpload: function cancelUpload() {
      if (this.request) {
        this.request.abort();
      }
      this.isUploadDisabled = false;
    },
    arrayRemove: function arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele !== value;
      });
    },
    confirmDelete: function confirmDelete(uploadedFile) {
      var _this3 = this;

      return function (dialog) {
        return _this3.deleteUpload(uploadedFile);
      };
    },
    deleteUpload: function deleteUpload(uploadedFile) {
      this.uploadedFiles = this.arrayRemove(this.uploadedFiles, uploadedFile);
      this.$emit('UpdateTilbud', this.uploadedFiles);
    },
    fetchUploads: function fetchUploads() {}
  },
  data: function data() {
    return {
      file: '',
      index: null,
      isUploadDisabled: false,
      progress: 0,
      uploadedFiles: [],
      allowed_file_extensions: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1900) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  }
});

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    progress: {
      default: 0,
      type: Number
    },
    showProgressText: {
      default: true,
      type: Boolean
    }
  },
  computed: {
    getProgress: function getProgress() {
      return Math.round(this.progress) + '%';
    }
  },
  watch: {
    progress: function progress(_progress) {
      this.currentProgress = _progress;
    }
  },
  data: function data() {
    return {
      currentProgress: 0
    };
  }
});

/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.progress !== 0 && _vm.progress < 100 )?_c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-info progress-bar-striped",style:({width: _vm.getProgress}),attrs:{"role":"progressbar"}},[(_vm.progress < 101 && _vm.showProgressText)?_c('span',[_vm._v("\n      "+_vm._s(_vm.getProgress)+"\n    ")]):_vm._e()])]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-group"},[_c('button',{staticClass:"col-12 primarycolor white-background p2 py4 flex line-height-1 justify-center items-center h5 not-rounded gibson",staticStyle:{"border":"3px dashed rgb(25, 163, 192)"},attrs:{"type":"button","disabled":_vm.isUploadDisabled},on:{"click":_vm.launchFilePicker}},[_c('span',{staticClass:"mx2 relative"},[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M406 195.1c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 167.7 0 222.1 0 289S54.4 410.3 121.3 410.3h84.7c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5 0-54.9 44.6-99.5 99.5-99.5 2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.2 4.9-0.4 7.5l-0.1 1.1c-0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.4 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-89.1c-6 0-10.9 4.9-10.9 10.9 0 6 4.9 10.9 10.9 10.9h89.1c59.3 0 107.6-48.3 107.6-107.6C512 243.9 464.6 196 406 195.1z"}}),_c('path',{attrs:{"d":"M262.8 105.2c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 0.5 0.1 1 0.1 1.5 0.1 5.4 0 10.1-4 10.8-9.4 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 110.1 268.8 105.2 262.8 105.2z"}}),_c('path',{attrs:{"d":"M312.4 320.1l-39.7-35.5c-6.8-6.1-17.2-6.1-24 0l-39.7 35.5c-4.5 4-4.9 10.9-0.9 15.4 4 4.5 10.9 4.9 15.4 0.9l26.3-23.5v134.3c0 6 4.9 10.9 10.9 10.9 6 0 10.9-4.9 10.9-10.9V312.9l26.3 23.5c2.1 1.9 4.7 2.8 7.3 2.8 3 0 6-1.2 8.1-3.6C317.3 331 316.9 324.1 312.4 320.1z"}})])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v("Vælg fil")])])]),_vm._v(" "),_c('input',{directives:[{name:"uploader",rawName:"v-uploader"}],ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"}}),_vm._v(" "),_c('file-upload-progress',{attrs:{"progress":_vm.progress}}),_vm._v(" "),(_vm.uploadedFiles)?_c('ul',{staticClass:"upload-file-list my2 pl0"},_vm._l((_vm.uploadedFiles),function(uploaded_file){return _c('li',{key:uploaded_file.id,staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"h5 gibson regular darkblue line-height-1 mr3",staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(uploaded_file))]),_vm._v(" "),(_vm.index !== 0)?_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(uploaded_file)}),expression:"{ok: confirmDelete(uploaded_file)}"}],key:uploaded_file,staticClass:"not-rounded delete-button p1 border-none",attrs:{"tooltip":"Slet"}},[_vm._m(0,true)]):_vm._e()])}),0):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-delete"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 862 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);



var interval = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuejsCountDown',
  props: {
    deadline: {
      type: String
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000),
      date: null,
      diff: 0
    };
  },
  created: function created() {
    var _this = this;

    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'");
    }
    var endTime = this.deadline ? this.deadline : this.end;
    this.date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(endTime.replace(/-/g, '/')) / 1000);
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'");
    }
    interval = setInterval(function () {
      _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    }, 1000);
  },

  computed: {
    seconds: function seconds() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff) % 60;
    },
    minutes: function minutes() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60) % 60;
    },
    hours: function hours() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60) % 24;
    },
    days: function days() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60 / 24);
    }
  },
  watch: {
    now: function now(value) {
      this.diff = this.date - this.now;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;

        clearInterval(interval);
      }
    }
  },
  filters: {
    twoDigits: function twoDigits(value) {
      if (value.toString().length <= 1) {
        return '0' + value.toString();
      }
      return value.toString();
    }
  },
  destroyed: function destroyed() {
    clearInterval(interval);
  }
});

/***/ }),
/* 864 */,
/* 865 */,
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"vuejs-countdown"},[(_vm.days >= 0)?_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.days)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.days > 1 ? 'Dage' : 'Dag'))])]):_vm._e(),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.hours)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v(_vm._s(_vm.hours > 1 ? 'timer' : 'time'))])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.minutes)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("minutter")])]),_vm._v(" "),_c('li',[_c('p',{staticClass:"digit"},[_vm._v(_vm._s(_vm._f("twoDigits")(_vm.seconds)))]),_vm._v(" "),_c('p',{staticClass:"text"},[_vm._v("sekunder")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);



var interval = null;
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'vuejsCountDown2',
  props: {
    deadline: {
      type: String
    },
    end: {
      type: String
    },
    stop: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      now: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000),
      date: null,
      diff: 0
    };
  },
  created: function created() {
    var _this = this;

    if (!this.deadline && !this.end) {
      throw new Error("Missing props 'deadline' or 'end'");
    }
    var endTime = this.deadline ? this.deadline : this.end;
    this.date = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(Date.parse(endTime.replace(/-/g, '/')) / 1000);
    if (!this.date) {
      throw new Error("Invalid props value, correct the 'deadline' or 'end'");
    }
    interval = setInterval(function () {
      _this.now = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(new Date().getTime() / 1000);
    }, 1000);
  },

  computed: {
    seconds: function seconds() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff) % 60;
    },
    minutes: function minutes() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60) % 60;
    },
    hours: function hours() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60) % 24;
    },
    days: function days() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(this.diff / 60 / 60 / 24);
    }
  },
  watch: {
    now: function now(value) {
      this.diff = this.date - this.now;
      if (this.diff <= 0 || this.stop) {
        this.diff = 0;

        clearInterval(interval);
      }
    }
  },
  filters: {
    twoDigits: function twoDigits(value) {
      return value.toString();
    }
  },
  destroyed: function destroyed() {
    clearInterval(interval);
  }
});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(" "+_vm._s(_vm._f("twoDigits")(_vm.days)))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 869 */,
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__version_mjs__ = __webpack_require__(871);
/* unused harmony reexport version */
/* unused harmony reexport versionInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__graphql_mjs__ = __webpack_require__(872);
/* unused harmony reexport graphql */
/* unused harmony reexport graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_index_mjs__ = __webpack_require__(878);
/* unused harmony reexport GraphQLSchema */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport GraphQLSpecifiedByDirective */
/* unused harmony reexport TypeKind */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* unused harmony reexport isSchema */
/* unused harmony reexport isDirective */
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport assertSchema */
/* unused harmony reexport assertDirective */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_index_mjs__ = __webpack_require__(879);
/* unused harmony reexport Token */
/* unused harmony reexport Source */
/* unused harmony reexport Location */
/* unused harmony reexport getLocation */
/* unused harmony reexport printLocation */
/* unused harmony reexport printSourceLocation */
/* unused harmony reexport Lexer */
/* unused harmony reexport TokenKind */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_3__language_index_mjs__["a"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* unused harmony reexport print */
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport BREAK */
/* unused harmony reexport Kind */
/* unused harmony reexport DirectiveLocation */
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution_index_mjs__ = __webpack_require__(880);
/* unused harmony reexport execute */
/* unused harmony reexport executeSync */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport defaultTypeResolver */
/* unused harmony reexport responsePathAsArray */
/* unused harmony reexport getDirectiveValues */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__subscription_index_mjs__ = __webpack_require__(881);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__validation_index_mjs__ = __webpack_require__(885);
/* unused harmony reexport validate */
/* unused harmony reexport ValidationContext */
/* unused harmony reexport specifiedRules */
/* unused harmony reexport ExecutableDefinitionsRule */
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* unused harmony reexport KnownArgumentNamesRule */
/* unused harmony reexport KnownDirectivesRule */
/* unused harmony reexport KnownFragmentNamesRule */
/* unused harmony reexport KnownTypeNamesRule */
/* unused harmony reexport LoneAnonymousOperationRule */
/* unused harmony reexport NoFragmentCyclesRule */
/* unused harmony reexport NoUndefinedVariablesRule */
/* unused harmony reexport NoUnusedFragmentsRule */
/* unused harmony reexport NoUnusedVariablesRule */
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* unused harmony reexport ScalarLeafsRule */
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* unused harmony reexport UniqueArgumentNamesRule */
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* unused harmony reexport UniqueFragmentNamesRule */
/* unused harmony reexport UniqueInputFieldNamesRule */
/* unused harmony reexport UniqueOperationNamesRule */
/* unused harmony reexport UniqueVariableNamesRule */
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* unused harmony reexport VariablesAreInputTypesRule */
/* unused harmony reexport VariablesInAllowedPositionRule */
/* unused harmony reexport LoneSchemaDefinitionRule */
/* unused harmony reexport UniqueOperationTypesRule */
/* unused harmony reexport UniqueTypeNamesRule */
/* unused harmony reexport UniqueEnumValueNamesRule */
/* unused harmony reexport UniqueFieldDefinitionNamesRule */
/* unused harmony reexport UniqueDirectiveNamesRule */
/* unused harmony reexport PossibleTypeExtensionsRule */
/* unused harmony reexport NoDeprecatedCustomRule */
/* unused harmony reexport NoSchemaIntrospectionCustomRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__error_index_mjs__ = __webpack_require__(887);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport syntaxError */
/* unused harmony reexport locatedError */
/* unused harmony reexport printError */
/* unused harmony reexport formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utilities_index_mjs__ = __webpack_require__(889);
/* unused harmony reexport getIntrospectionQuery */
/* unused harmony reexport getOperationAST */
/* unused harmony reexport getOperationRootType */
/* unused harmony reexport introspectionFromSchema */
/* unused harmony reexport buildClientSchema */
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* unused harmony reexport getDescription */
/* unused harmony reexport extendSchema */
/* unused harmony reexport lexicographicSortSchema */
/* unused harmony reexport printSchema */
/* unused harmony reexport printType */
/* unused harmony reexport printIntrospectionSchema */
/* unused harmony reexport typeFromAST */
/* unused harmony reexport valueFromAST */
/* unused harmony reexport valueFromASTUntyped */
/* unused harmony reexport astFromValue */
/* unused harmony reexport TypeInfo */
/* unused harmony reexport visitWithTypeInfo */
/* unused harmony reexport coerceInputValue */
/* unused harmony reexport concatAST */
/* unused harmony reexport separateOperations */
/* unused harmony reexport stripIgnoredCharacters */
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* unused harmony reexport findDeprecatedUsages */
/**
 * GraphQL.js provides a reference implementation for the GraphQL specification
 * but is also a useful utility for operating on GraphQL files and building
 * sophisticated tools.
 *
 * This primary module exports a general purpose function for fulfilling all
 * steps of the GraphQL specification in a single operation, but also includes
 * utilities for every part of the GraphQL specification:
 *
 *   - Parsing the GraphQL language.
 *   - Building a GraphQL type schema.
 *   - Validating a GraphQL request against a type schema.
 *   - Executing a GraphQL request against a type schema.
 *
 * This also includes utility functions for operating on GraphQL types and
 * GraphQL documents to facilitate building tools.
 *
 * You may also import from each sub-directory directly. For example, the
 * following two import statements are equivalent:
 *
 *     import { parse } from 'graphql';
 *     import { parse } from 'graphql/language';
 */
// The GraphQL.js version info.
 // The primary entry point into fulfilling a GraphQL request.

 // Create and operate on GraphQL type definitions and schema.


// Parse and operate on GraphQL language source files.

// Execute GraphQL queries.


// Validate GraphQL documents.

// Create, format, and print GraphQL errors.

// Utilities for operating on GraphQL type schema and parsed sources.



/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export version */
/* unused harmony export versionInfo */
/**
 * Note: This file is autogenerated using "resources/gen-version.js" script and
 * automatically updated by "npm version" command.
 */

/**
 * A string containing the version of the GraphQL.js library
 */
var version = '15.8.0';
/**
 * An object containing the components of the GraphQL.js version string
 */

var versionInfo = Object.freeze({
  major: 15,
  minor: 8,
  patch: 0,
  preReleaseTag: null
});


/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export graphql */
/* unused harmony export graphqlSync */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_isPromise_mjs__ = __webpack_require__(301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_parser_mjs__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__validation_validate_mjs__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__type_validate_mjs__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__execution_execute_mjs__ = __webpack_require__(207);





/**
 * This is the primary entry point function for fulfilling GraphQL operations
 * by parsing, validating, and executing a GraphQL document along side a
 * GraphQL schema.
 *
 * More sophisticated GraphQL servers, such as those which persist queries,
 * may wish to separate the validation and execution phases to a static time
 * tooling step, and a server runtime step.
 *
 * Accepts either an object with named arguments, or individual arguments:
 *
 * schema:
 *    The GraphQL type system to use when validating and executing a query.
 * source:
 *    A GraphQL language formatted string representing the requested operation.
 * rootValue:
 *    The value provided as the first argument to resolver functions on the top
 *    level type (e.g. the query object type).
 * contextValue:
 *    The context value is provided as an argument to resolver functions after
 *    field arguments. It is used to pass shared information useful at any point
 *    during executing this query, for example the currently logged in user and
 *    connections to databases or other services.
 * variableValues:
 *    A mapping of variable name to runtime value to use for all variables
 *    defined in the requestString.
 * operationName:
 *    The name of the operation to use if requestString contains multiple
 *    possible operations. Can be omitted if requestString contains only
 *    one operation.
 * fieldResolver:
 *    A resolver function to use when one is not provided by the schema.
 *    If not provided, the default field resolver is used (which looks for a
 *    value or method on the source value with the field's name).
 * typeResolver:
 *    A type resolver function to use when none is provided by the schema.
 *    If not provided, the default type resolver is used (which looks for a
 *    `__typename` field or alternatively calls the `isTypeOf` method).
 */

function graphql(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
  var _arguments = arguments;

  /* eslint-enable no-redeclare */
  // Always return a Promise for a consistent API.
  return new Promise(function (resolve) {
    return resolve( // Extract arguments from object args if provided.
    _arguments.length === 1 ? graphqlImpl(argsOrSchema) : graphqlImpl({
      schema: argsOrSchema,
      source: source,
      rootValue: rootValue,
      contextValue: contextValue,
      variableValues: variableValues,
      operationName: operationName,
      fieldResolver: fieldResolver,
      typeResolver: typeResolver
    }));
  });
}
/**
 * The graphqlSync function also fulfills GraphQL operations by parsing,
 * validating, and executing a GraphQL document along side a GraphQL schema.
 * However, it guarantees to complete synchronously (or throw an error) assuming
 * that all field resolvers are also synchronous.
 */

function graphqlSync(argsOrSchema, source, rootValue, contextValue, variableValues, operationName, fieldResolver, typeResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  var result = arguments.length === 1 ? graphqlImpl(argsOrSchema) : graphqlImpl({
    schema: argsOrSchema,
    source: source,
    rootValue: rootValue,
    contextValue: contextValue,
    variableValues: variableValues,
    operationName: operationName,
    fieldResolver: fieldResolver,
    typeResolver: typeResolver
  }); // Assert that the execution was synchronous.

  if (Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_isPromise_mjs__["a" /* default */])(result)) {
    throw new Error('GraphQL execution failed to complete synchronously.');
  }

  return result;
}

function graphqlImpl(args) {
  var schema = args.schema,
      source = args.source,
      rootValue = args.rootValue,
      contextValue = args.contextValue,
      variableValues = args.variableValues,
      operationName = args.operationName,
      fieldResolver = args.fieldResolver,
      typeResolver = args.typeResolver; // Validate Schema

  var schemaValidationErrors = Object(__WEBPACK_IMPORTED_MODULE_3__type_validate_mjs__["b" /* validateSchema */])(schema);

  if (schemaValidationErrors.length > 0) {
    return {
      errors: schemaValidationErrors
    };
  } // Parse


  var document;

  try {
    document = Object(__WEBPACK_IMPORTED_MODULE_1__language_parser_mjs__["a" /* parse */])(source);
  } catch (syntaxError) {
    return {
      errors: [syntaxError]
    };
  } // Validate


  var validationErrors = Object(__WEBPACK_IMPORTED_MODULE_2__validation_validate_mjs__["c" /* validate */])(schema, document);

  if (validationErrors.length > 0) {
    return {
      errors: validationErrors
    };
  } // Execute


  return Object(__WEBPACK_IMPORTED_MODULE_4__execution_execute_mjs__["e" /* execute */])({
    schema: schema,
    document: document,
    rootValue: rootValue,
    contextValue: contextValue,
    variableValues: variableValues,
    operationName: operationName,
    fieldResolver: fieldResolver,
    typeResolver: typeResolver
  });
}


/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = identityFunc;
/**
 * Returns the first argument it receives.
 */
function identityFunc(x) {
  return x;
}


/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* eslint-disable no-redeclare */
// $FlowFixMe[name-already-bound] workaround for: https://github.com/facebook/flow/issues/4441
var isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

/* harmony default export */ __webpack_exports__["a"] = (isInteger);


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = memoize3;
/**
 * Memoizes the provided three-argument function.
 */
function memoize3(fn) {
  var cache0;
  return function memoized(a1, a2, a3) {
    if (!cache0) {
      cache0 = new WeakMap();
    }

    var cache1 = cache0.get(a1);
    var cache2;

    if (cache1) {
      cache2 = cache1.get(a2);

      if (cache2) {
        var cachedValue = cache2.get(a3);

        if (cachedValue !== undefined) {
          return cachedValue;
        }
      }
    } else {
      cache1 = new WeakMap();
      cache0.set(a1, cache1);
    }

    if (!cache2) {
      cache2 = new WeakMap();
      cache1.set(a2, cache2);
    }

    var newValue = fn(a1, a2, a3);
    cache2.set(a3, newValue);
    return newValue;
  };
}


/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseReduce;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPromise_mjs__ = __webpack_require__(301);

/**
 * Similar to Array.prototype.reduce(), however the reducing callback may return
 * a Promise, in which case reduction will continue after each promise resolves.
 *
 * If the callback does not return a Promise, then this function will also not
 * return a Promise.
 */

function promiseReduce(values, callback, initialValue) {
  return values.reduce(function (previous, value) {
    return Object(__WEBPACK_IMPORTED_MODULE_0__isPromise_mjs__["a" /* default */])(previous) ? previous.then(function (resolved) {
      return callback(resolved, value);
    }) : callback(previous, value);
  }, initialValue);
}


/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = promiseForObject;
/**
 * This function transforms a JS object `ObjMap<Promise<T>>` into
 * a `Promise<ObjMap<T>>`
 *
 * This is akin to bluebird's `Promise.props`, but implemented only using
 * `Promise.all` so it will work with any implementation of ES6 promises.
 */
function promiseForObject(object) {
  var keys = Object.keys(object);
  var valuesAndPromises = keys.map(function (name) {
    return object[name];
  });
  return Promise.all(valuesAndPromises).then(function (values) {
    return values.reduce(function (resolvedObject, value, i) {
      resolvedObject[keys[i]] = value;
      return resolvedObject;
    }, Object.create(null));
  });
}


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__schema_mjs__ = __webpack_require__(133);
/* unused harmony reexport isSchema */
/* unused harmony reexport assertSchema */
/* unused harmony reexport GraphQLSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__definition_mjs__ = __webpack_require__(20);
/* unused harmony reexport isType */
/* unused harmony reexport isScalarType */
/* unused harmony reexport isObjectType */
/* unused harmony reexport isInterfaceType */
/* unused harmony reexport isUnionType */
/* unused harmony reexport isEnumType */
/* unused harmony reexport isInputObjectType */
/* unused harmony reexport isListType */
/* unused harmony reexport isNonNullType */
/* unused harmony reexport isInputType */
/* unused harmony reexport isOutputType */
/* unused harmony reexport isLeafType */
/* unused harmony reexport isCompositeType */
/* unused harmony reexport isAbstractType */
/* unused harmony reexport isWrappingType */
/* unused harmony reexport isNullableType */
/* unused harmony reexport isNamedType */
/* unused harmony reexport isRequiredArgument */
/* unused harmony reexport isRequiredInputField */
/* unused harmony reexport assertType */
/* unused harmony reexport assertScalarType */
/* unused harmony reexport assertObjectType */
/* unused harmony reexport assertInterfaceType */
/* unused harmony reexport assertUnionType */
/* unused harmony reexport assertEnumType */
/* unused harmony reexport assertInputObjectType */
/* unused harmony reexport assertListType */
/* unused harmony reexport assertNonNullType */
/* unused harmony reexport assertInputType */
/* unused harmony reexport assertOutputType */
/* unused harmony reexport assertLeafType */
/* unused harmony reexport assertCompositeType */
/* unused harmony reexport assertAbstractType */
/* unused harmony reexport assertWrappingType */
/* unused harmony reexport assertNullableType */
/* unused harmony reexport assertNamedType */
/* unused harmony reexport getNullableType */
/* unused harmony reexport getNamedType */
/* unused harmony reexport GraphQLScalarType */
/* unused harmony reexport GraphQLObjectType */
/* unused harmony reexport GraphQLInterfaceType */
/* unused harmony reexport GraphQLUnionType */
/* unused harmony reexport GraphQLEnumType */
/* unused harmony reexport GraphQLInputObjectType */
/* unused harmony reexport GraphQLList */
/* unused harmony reexport GraphQLNonNull */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__directives_mjs__ = __webpack_require__(54);
/* unused harmony reexport isDirective */
/* unused harmony reexport assertDirective */
/* unused harmony reexport GraphQLDirective */
/* unused harmony reexport isSpecifiedDirective */
/* unused harmony reexport specifiedDirectives */
/* unused harmony reexport GraphQLIncludeDirective */
/* unused harmony reexport GraphQLSkipDirective */
/* unused harmony reexport GraphQLDeprecatedDirective */
/* unused harmony reexport GraphQLSpecifiedByDirective */
/* unused harmony reexport DEFAULT_DEPRECATION_REASON */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__scalars_mjs__ = __webpack_require__(88);
/* unused harmony reexport isSpecifiedScalarType */
/* unused harmony reexport specifiedScalarTypes */
/* unused harmony reexport GraphQLInt */
/* unused harmony reexport GraphQLFloat */
/* unused harmony reexport GraphQLString */
/* unused harmony reexport GraphQLBoolean */
/* unused harmony reexport GraphQLID */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__introspection_mjs__ = __webpack_require__(63);
/* unused harmony reexport isIntrospectionType */
/* unused harmony reexport introspectionTypes */
/* unused harmony reexport __Schema */
/* unused harmony reexport __Directive */
/* unused harmony reexport __DirectiveLocation */
/* unused harmony reexport __Type */
/* unused harmony reexport __Field */
/* unused harmony reexport __InputValue */
/* unused harmony reexport __EnumValue */
/* unused harmony reexport __TypeKind */
/* unused harmony reexport TypeKind */
/* unused harmony reexport SchemaMetaFieldDef */
/* unused harmony reexport TypeMetaFieldDef */
/* unused harmony reexport TypeNameMetaFieldDef */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__validate_mjs__ = __webpack_require__(201);
/* unused harmony reexport validateSchema */
/* unused harmony reexport assertValidSchema */



// Common built-in scalar instances.


// Validate GraphQL schema.



/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__source_mjs__ = __webpack_require__(305);
/* unused harmony reexport Source */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__location_mjs__ = __webpack_require__(303);
/* unused harmony reexport getLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__printLocation_mjs__ = __webpack_require__(542);
/* unused harmony reexport printLocation */
/* unused harmony reexport printSourceLocation */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__kinds_mjs__ = __webpack_require__(24);
/* unused harmony reexport Kind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tokenKind_mjs__ = __webpack_require__(157);
/* unused harmony reexport TokenKind */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__lexer_mjs__ = __webpack_require__(306);
/* unused harmony reexport Lexer */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__parser_mjs__ = __webpack_require__(155);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_6__parser_mjs__["a"]; });
/* unused harmony reexport parseValue */
/* unused harmony reexport parseType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__printer_mjs__ = __webpack_require__(58);
/* unused harmony reexport print */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__visitor_mjs__ = __webpack_require__(116);
/* unused harmony reexport visit */
/* unused harmony reexport visitInParallel */
/* unused harmony reexport getVisitFn */
/* unused harmony reexport BREAK */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ast_mjs__ = __webpack_require__(156);
/* unused harmony reexport Location */
/* unused harmony reexport Token */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__predicates_mjs__ = __webpack_require__(134);
/* unused harmony reexport isDefinitionNode */
/* unused harmony reexport isExecutableDefinitionNode */
/* unused harmony reexport isSelectionNode */
/* unused harmony reexport isValueNode */
/* unused harmony reexport isTypeNode */
/* unused harmony reexport isTypeSystemDefinitionNode */
/* unused harmony reexport isTypeDefinitionNode */
/* unused harmony reexport isTypeSystemExtensionNode */
/* unused harmony reexport isTypeExtensionNode */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__directiveLocation_mjs__ = __webpack_require__(158);
/* unused harmony reexport DirectiveLocation */














/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_Path_mjs__ = __webpack_require__(208);
/* unused harmony reexport responsePathAsArray */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__execute_mjs__ = __webpack_require__(207);
/* unused harmony reexport execute */
/* unused harmony reexport executeSync */
/* unused harmony reexport defaultFieldResolver */
/* unused harmony reexport defaultTypeResolver */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__values_mjs__ = __webpack_require__(209);
/* unused harmony reexport getDirectiveValues */





/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__subscribe_mjs__ = __webpack_require__(882);
/* unused harmony reexport subscribe */
/* unused harmony reexport createSourceEventStream */



/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export subscribe */
/* unused harmony export createSourceEventStream */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_isAsyncIterable_mjs__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_Path_mjs__ = __webpack_require__(208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_locatedError_mjs__ = __webpack_require__(202);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__execution_values_mjs__ = __webpack_require__(209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utilities_getOperationRootType_mjs__ = __webpack_require__(310);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__mapAsyncIterator_mjs__ = __webpack_require__(884);









function subscribe(argsOrSchema, document, rootValue, contextValue, variableValues, operationName, fieldResolver, subscribeFieldResolver) {
  /* eslint-enable no-redeclare */
  // Extract arguments from object args if provided.
  return arguments.length === 1 ? subscribeImpl(argsOrSchema) : subscribeImpl({
    schema: argsOrSchema,
    document: document,
    rootValue: rootValue,
    contextValue: contextValue,
    variableValues: variableValues,
    operationName: operationName,
    fieldResolver: fieldResolver,
    subscribeFieldResolver: subscribeFieldResolver
  });
}
/**
 * This function checks if the error is a GraphQLError. If it is, report it as
 * an ExecutionResult, containing only errors and no data. Otherwise treat the
 * error as a system-class error and re-throw it.
 */

function reportGraphQLError(error) {
  if (error instanceof __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__["a" /* GraphQLError */]) {
    return {
      errors: [error]
    };
  }

  throw error;
}

function subscribeImpl(args) {
  var schema = args.schema,
      document = args.document,
      rootValue = args.rootValue,
      contextValue = args.contextValue,
      variableValues = args.variableValues,
      operationName = args.operationName,
      fieldResolver = args.fieldResolver,
      subscribeFieldResolver = args.subscribeFieldResolver;
  var sourcePromise = createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, subscribeFieldResolver); // For each payload yielded from a subscription, map it over the normal
  // GraphQL `execute` function, with `payload` as the rootValue.
  // This implements the "MapSourceToResponseEvent" algorithm described in
  // the GraphQL specification. The `execute` function provides the
  // "ExecuteSubscriptionEvent" algorithm, as it is nearly identical to the
  // "ExecuteQuery" algorithm, for which `execute` is also used.

  var mapSourceToResponse = function mapSourceToResponse(payload) {
    return Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["e" /* execute */])({
      schema: schema,
      document: document,
      rootValue: payload,
      contextValue: contextValue,
      variableValues: variableValues,
      operationName: operationName,
      fieldResolver: fieldResolver
    });
  }; // Resolve the Source Stream, then map every source value to a
  // ExecutionResult value as described above.


  return sourcePromise.then(function (resultOrStream) {
    return (// Note: Flow can't refine isAsyncIterable, so explicit casts are used.
      Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isAsyncIterable_mjs__["a" /* default */])(resultOrStream) ? Object(__WEBPACK_IMPORTED_MODULE_8__mapAsyncIterator_mjs__["a" /* default */])(resultOrStream, mapSourceToResponse, reportGraphQLError) : resultOrStream
    );
  });
}
/**
 * Implements the "CreateSourceEventStream" algorithm described in the
 * GraphQL specification, resolving the subscription source event stream.
 *
 * Returns a Promise which resolves to either an AsyncIterable (if successful)
 * or an ExecutionResult (error). The promise will be rejected if the schema or
 * other arguments to this function are invalid, or if the resolved event stream
 * is not an async iterable.
 *
 * If the client-provided arguments to this function do not result in a
 * compliant subscription, a GraphQL Response (ExecutionResult) with
 * descriptive errors and no data will be returned.
 *
 * If the the source stream could not be created due to faulty subscription
 * resolver logic or underlying systems, the promise will resolve to a single
 * ExecutionResult containing `errors` and no `data`.
 *
 * If the operation succeeded, the promise resolves to the AsyncIterable for the
 * event stream returned by the resolver.
 *
 * A Source Event Stream represents a sequence of events, each of which triggers
 * a GraphQL execution for that event.
 *
 * This may be useful when hosting the stateful subscription service in a
 * different process or machine than the stateless GraphQL execution engine,
 * or otherwise separating these two steps. For more on this, see the
 * "Supporting Subscriptions at Scale" information in the GraphQL specification.
 */


function createSourceEventStream(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver) {
  // If arguments are missing or incorrectly typed, this is an internal
  // developer mistake which should throw an early error.
  Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["a" /* assertValidExecutionArguments */])(schema, document, variableValues);
  return new Promise(function (resolve) {
    // If a valid context cannot be created due to incorrect arguments,
    // this will throw an error.
    var exeContext = Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["b" /* buildExecutionContext */])(schema, document, rootValue, contextValue, variableValues, operationName, fieldResolver);
    resolve( // Return early errors if execution context failed.
    Array.isArray(exeContext) ? {
      errors: exeContext
    } : executeSubscription(exeContext));
  }).catch(reportGraphQLError);
}

function executeSubscription(exeContext) {
  var schema = exeContext.schema,
      operation = exeContext.operation,
      variableValues = exeContext.variableValues,
      rootValue = exeContext.rootValue;
  var type = Object(__WEBPACK_IMPORTED_MODULE_7__utilities_getOperationRootType_mjs__["a" /* getOperationRootType */])(schema, operation);
  var fields = Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["d" /* collectFields */])(exeContext, type, operation.selectionSet, Object.create(null), Object.create(null));
  var responseNames = Object.keys(fields);
  var responseName = responseNames[0];
  var fieldNodes = fields[responseName];
  var fieldNode = fieldNodes[0];
  var fieldName = fieldNode.name.value;
  var fieldDef = Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["g" /* getFieldDef */])(schema, type, fieldName);

  if (!fieldDef) {
    throw new __WEBPACK_IMPORTED_MODULE_3__error_GraphQLError_mjs__["a" /* GraphQLError */]("The subscription field \"".concat(fieldName, "\" is not defined."), fieldNodes);
  }

  var path = Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_Path_mjs__["a" /* addPath */])(undefined, responseName, type.name);
  var info = Object(__WEBPACK_IMPORTED_MODULE_6__execution_execute_mjs__["c" /* buildResolveInfo */])(exeContext, fieldDef, fieldNodes, type, path); // Coerce to Promise for easier error handling and consistent return type.

  return new Promise(function (resolveResult) {
    var _fieldDef$subscribe;

    // Implements the "ResolveFieldEventStream" algorithm from GraphQL specification.
    // It differs from "ResolveFieldValue" due to providing a different `resolveFn`.
    // Build a JS object of arguments from the field.arguments AST, using the
    // variables scope to fulfill any variable references.
    var args = Object(__WEBPACK_IMPORTED_MODULE_5__execution_values_mjs__["a" /* getArgumentValues */])(fieldDef, fieldNodes[0], variableValues); // The resolve function's optional third argument is a context value that
    // is provided to every resolve function within an execution. It is commonly
    // used to represent an authenticated user, or request-specific caches.

    var contextValue = exeContext.contextValue; // Call the `subscribe()` resolver or the default resolver to produce an
    // AsyncIterable yielding raw payloads.

    var resolveFn = (_fieldDef$subscribe = fieldDef.subscribe) !== null && _fieldDef$subscribe !== void 0 ? _fieldDef$subscribe : exeContext.fieldResolver;
    resolveResult(resolveFn(rootValue, args, contextValue, info));
  }).then(function (eventStream) {
    if (eventStream instanceof Error) {
      throw Object(__WEBPACK_IMPORTED_MODULE_4__error_locatedError_mjs__["a" /* locatedError */])(eventStream, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_Path_mjs__["b" /* pathToArray */])(path));
    } // Assert field returned an event stream, otherwise yield an error.


    if (!Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_isAsyncIterable_mjs__["a" /* default */])(eventStream)) {
      throw new Error('Subscription field must return Async Iterable. ' + "Received: ".concat(Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_inspect_mjs__["a" /* default */])(eventStream), "."));
    }

    return eventStream;
  }, function (error) {
    throw Object(__WEBPACK_IMPORTED_MODULE_4__error_locatedError_mjs__["a" /* locatedError */])(error, fieldNodes, Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_Path_mjs__["b" /* pathToArray */])(path));
  });
}


/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isAsyncIterable;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__ = __webpack_require__(87);

/**
 * Returns true if the provided object implements the AsyncIterator protocol via
 * either implementing a `Symbol.asyncIterator` or `"@@asyncIterator"` method.
 */

// eslint-disable-next-line no-redeclare
function isAsyncIterable(maybeAsyncIterable) {
  return typeof (maybeAsyncIterable === null || maybeAsyncIterable === void 0 ? void 0 : maybeAsyncIterable[__WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__["a" /* SYMBOL_ASYNC_ITERATOR */]]) === 'function';
}


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = mapAsyncIterator;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__ = __webpack_require__(87);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



/**
 * Given an AsyncIterable and a callback function, return an AsyncIterator
 * which produces values mapped via calling the callback function.
 */
function mapAsyncIterator(iterable, callback, rejectCallback) {
  // $FlowFixMe[prop-missing]
  var iteratorMethod = iterable[__WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__["a" /* SYMBOL_ASYNC_ITERATOR */]];
  var iterator = iteratorMethod.call(iterable);
  var $return;
  var abruptClose;

  if (typeof iterator.return === 'function') {
    $return = iterator.return;

    abruptClose = function abruptClose(error) {
      var rethrow = function rethrow() {
        return Promise.reject(error);
      };

      return $return.call(iterator).then(rethrow, rethrow);
    };
  }

  function mapResult(result) {
    return result.done ? result : asyncMapValue(result.value, callback).then(iteratorResult, abruptClose);
  }

  var mapReject;

  if (rejectCallback) {
    // Capture rejectCallback to ensure it cannot be null.
    var reject = rejectCallback;

    mapReject = function mapReject(error) {
      return asyncMapValue(error, reject).then(iteratorResult, abruptClose);
    };
  }
  /* TODO: Flow doesn't support symbols as keys:
     https://github.com/facebook/flow/issues/3258 */


  return _defineProperty({
    next: function next() {
      return iterator.next().then(mapResult, mapReject);
    },
    return: function _return() {
      return $return ? $return.call(iterator).then(mapResult, mapReject) : Promise.resolve({
        value: undefined,
        done: true
      });
    },
    throw: function _throw(error) {
      if (typeof iterator.throw === 'function') {
        return iterator.throw(error).then(mapResult, mapReject);
      }

      return Promise.reject(error).catch(abruptClose);
    }
  }, __WEBPACK_IMPORTED_MODULE_0__polyfills_symbols_mjs__["a" /* SYMBOL_ASYNC_ITERATOR */], function () {
    return this;
  });
}

function asyncMapValue(value, callback) {
  return new Promise(function (resolve) {
    return resolve(callback(value));
  });
}

function iteratorResult(value) {
  return {
    value: value,
    done: false
  };
}


/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validate_mjs__ = __webpack_require__(160);
/* unused harmony reexport validate */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ValidationContext_mjs__ = __webpack_require__(583);
/* unused harmony reexport ValidationContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__specifiedRules_mjs__ = __webpack_require__(549);
/* unused harmony reexport specifiedRules */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__rules_ExecutableDefinitionsRule_mjs__ = __webpack_require__(550);
/* unused harmony reexport ExecutableDefinitionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__rules_FieldsOnCorrectTypeRule_mjs__ = __webpack_require__(558);
/* unused harmony reexport FieldsOnCorrectTypeRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__rules_FragmentsOnCompositeTypesRule_mjs__ = __webpack_require__(555);
/* unused harmony reexport FragmentsOnCompositeTypesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__rules_KnownArgumentNamesRule_mjs__ = __webpack_require__(569);
/* unused harmony reexport KnownArgumentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__rules_KnownDirectivesRule_mjs__ = __webpack_require__(567);
/* unused harmony reexport KnownDirectivesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__rules_KnownFragmentNamesRule_mjs__ = __webpack_require__(560);
/* unused harmony reexport KnownFragmentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__rules_KnownTypeNamesRule_mjs__ = __webpack_require__(554);
/* unused harmony reexport KnownTypeNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__rules_LoneAnonymousOperationRule_mjs__ = __webpack_require__(552);
/* unused harmony reexport LoneAnonymousOperationRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__rules_NoFragmentCyclesRule_mjs__ = __webpack_require__(563);
/* unused harmony reexport NoFragmentCyclesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__rules_NoUndefinedVariablesRule_mjs__ = __webpack_require__(565);
/* unused harmony reexport NoUndefinedVariablesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__rules_NoUnusedFragmentsRule_mjs__ = __webpack_require__(561);
/* unused harmony reexport NoUnusedFragmentsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__rules_NoUnusedVariablesRule_mjs__ = __webpack_require__(566);
/* unused harmony reexport NoUnusedVariablesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__rules_OverlappingFieldsCanBeMergedRule_mjs__ = __webpack_require__(574);
/* unused harmony reexport OverlappingFieldsCanBeMergedRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__rules_PossibleFragmentSpreadsRule_mjs__ = __webpack_require__(562);
/* unused harmony reexport PossibleFragmentSpreadsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__rules_ProvidedRequiredArgumentsRule_mjs__ = __webpack_require__(572);
/* unused harmony reexport ProvidedRequiredArgumentsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__rules_ScalarLeafsRule_mjs__ = __webpack_require__(557);
/* unused harmony reexport ScalarLeafsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__rules_SingleFieldSubscriptionsRule_mjs__ = __webpack_require__(553);
/* unused harmony reexport SingleFieldSubscriptionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__rules_UniqueArgumentNamesRule_mjs__ = __webpack_require__(570);
/* unused harmony reexport UniqueArgumentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__rules_UniqueDirectivesPerLocationRule_mjs__ = __webpack_require__(568);
/* unused harmony reexport UniqueDirectivesPerLocationRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__rules_UniqueFragmentNamesRule_mjs__ = __webpack_require__(559);
/* unused harmony reexport UniqueFragmentNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__rules_UniqueInputFieldNamesRule_mjs__ = __webpack_require__(575);
/* unused harmony reexport UniqueInputFieldNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__rules_UniqueOperationNamesRule_mjs__ = __webpack_require__(551);
/* unused harmony reexport UniqueOperationNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__rules_UniqueVariableNamesRule_mjs__ = __webpack_require__(564);
/* unused harmony reexport UniqueVariableNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__rules_ValuesOfCorrectTypeRule_mjs__ = __webpack_require__(571);
/* unused harmony reexport ValuesOfCorrectTypeRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__rules_VariablesAreInputTypesRule_mjs__ = __webpack_require__(556);
/* unused harmony reexport VariablesAreInputTypesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__rules_VariablesInAllowedPositionRule_mjs__ = __webpack_require__(573);
/* unused harmony reexport VariablesInAllowedPositionRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__rules_LoneSchemaDefinitionRule_mjs__ = __webpack_require__(576);
/* unused harmony reexport LoneSchemaDefinitionRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__rules_UniqueOperationTypesRule_mjs__ = __webpack_require__(577);
/* unused harmony reexport UniqueOperationTypesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__rules_UniqueTypeNamesRule_mjs__ = __webpack_require__(578);
/* unused harmony reexport UniqueTypeNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__rules_UniqueEnumValueNamesRule_mjs__ = __webpack_require__(579);
/* unused harmony reexport UniqueEnumValueNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__rules_UniqueFieldDefinitionNamesRule_mjs__ = __webpack_require__(580);
/* unused harmony reexport UniqueFieldDefinitionNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__rules_UniqueDirectiveNamesRule_mjs__ = __webpack_require__(581);
/* unused harmony reexport UniqueDirectiveNamesRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__rules_PossibleTypeExtensionsRule_mjs__ = __webpack_require__(582);
/* unused harmony reexport PossibleTypeExtensionsRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36__rules_custom_NoDeprecatedCustomRule_mjs__ = __webpack_require__(586);
/* unused harmony reexport NoDeprecatedCustomRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37__rules_custom_NoSchemaIntrospectionCustomRule_mjs__ = __webpack_require__(886);
/* unused harmony reexport NoSchemaIntrospectionCustomRule */


// All validation rules in the GraphQL Specification.
 // Spec Section: "Executable Definitions"

 // Spec Section: "Field Selections on Objects, Interfaces, and Unions Types"

 // Spec Section: "Fragments on Composite Types"

 // Spec Section: "Argument Names"

 // Spec Section: "Directives Are Defined"

 // Spec Section: "Fragment spread target defined"

 // Spec Section: "Fragment Spread Type Existence"

 // Spec Section: "Lone Anonymous Operation"

 // Spec Section: "Fragments must not form cycles"

 // Spec Section: "All Variable Used Defined"

 // Spec Section: "Fragments must be used"

 // Spec Section: "All Variables Used"

 // Spec Section: "Field Selection Merging"

 // Spec Section: "Fragment spread is possible"

 // Spec Section: "Argument Optionality"

 // Spec Section: "Leaf Field Selections"

 // Spec Section: "Subscriptions with Single Root Field"

 // Spec Section: "Argument Uniqueness"

 // Spec Section: "Directives Are Unique Per Location"

 // Spec Section: "Fragment Name Uniqueness"

 // Spec Section: "Input Object Field Uniqueness"

 // Spec Section: "Operation Name Uniqueness"

 // Spec Section: "Variable Uniqueness"

 // Spec Section: "Values Type Correctness"

 // Spec Section: "Variables are Input Types"

 // Spec Section: "All Variable Usages Are Allowed"

 // SDL-specific validation rules







 // Optional rules not defined by the GraphQL Specification





/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export NoSchemaIntrospectionCustomRule */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__type_introspection_mjs__ = __webpack_require__(63);




/**
 * Prohibit introspection queries
 *
 * A GraphQL document is only valid if all fields selected are not fields that
 * return an introspection type.
 *
 * Note: This rule is optional and is not part of the Validation section of the
 * GraphQL Specification. This rule effectively disables introspection, which
 * does not reflect best practices and should only be done if absolutely necessary.
 */
function NoSchemaIntrospectionCustomRule(context) {
  return {
    Field: function Field(node) {
      var type = Object(__WEBPACK_IMPORTED_MODULE_1__type_definition_mjs__["m" /* getNamedType */])(context.getType());

      if (type && Object(__WEBPACK_IMPORTED_MODULE_2__type_introspection_mjs__["g" /* isIntrospectionType */])(type)) {
        context.reportError(new __WEBPACK_IMPORTED_MODULE_0__error_GraphQLError_mjs__["a" /* GraphQLError */]("GraphQL introspection has been disabled, but the requested query contained the field \"".concat(node.name.value, "\"."), node));
      }
    }
  };
}


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__GraphQLError_mjs__ = __webpack_require__(13);
/* unused harmony reexport GraphQLError */
/* unused harmony reexport printError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__syntaxError_mjs__ = __webpack_require__(302);
/* unused harmony reexport syntaxError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locatedError_mjs__ = __webpack_require__(202);
/* unused harmony reexport locatedError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__formatError_mjs__ = __webpack_require__(888);
/* unused harmony reexport formatError */






/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__ = __webpack_require__(62);


/**
 * Given a GraphQLError, format it according to the rules described by the
 * Response Format, Errors section of the GraphQL Specification.
 */
function formatError(error) {
  var _error$message;

  error || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__["a" /* default */])(0, 'Received null or undefined error.');
  var message = (_error$message = error.message) !== null && _error$message !== void 0 ? _error$message : 'An unknown error occurred.';
  var locations = error.locations;
  var path = error.path;
  var extensions = error.extensions;
  return extensions && Object.keys(extensions).length > 0 ? {
    message: message,
    locations: locations,
    path: path,
    extensions: extensions
  } : {
    message: message,
    locations: locations,
    path: path
  };
}
/**
 * @see https://github.com/graphql/graphql-spec/blob/master/spec/Section%207%20--%20Response.md#errors
 */


/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__getIntrospectionQuery_mjs__ = __webpack_require__(587);
/* unused harmony reexport getIntrospectionQuery */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__getOperationAST_mjs__ = __webpack_require__(890);
/* unused harmony reexport getOperationAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__getOperationRootType_mjs__ = __webpack_require__(310);
/* unused harmony reexport getOperationRootType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__introspectionFromSchema_mjs__ = __webpack_require__(891);
/* unused harmony reexport introspectionFromSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__buildClientSchema_mjs__ = __webpack_require__(892);
/* unused harmony reexport buildClientSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__buildASTSchema_mjs__ = __webpack_require__(893);
/* unused harmony reexport buildASTSchema */
/* unused harmony reexport buildSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extendSchema_mjs__ = __webpack_require__(588);
/* unused harmony reexport extendSchema */
/* unused harmony reexport getDescription */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__lexicographicSortSchema_mjs__ = __webpack_require__(894);
/* unused harmony reexport lexicographicSortSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__printSchema_mjs__ = __webpack_require__(895);
/* unused harmony reexport printSchema */
/* unused harmony reexport printType */
/* unused harmony reexport printIntrospectionSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__typeFromAST_mjs__ = __webpack_require__(89);
/* unused harmony reexport typeFromAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__valueFromAST_mjs__ = __webpack_require__(210);
/* unused harmony reexport valueFromAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__valueFromASTUntyped_mjs__ = __webpack_require__(546);
/* unused harmony reexport valueFromASTUntyped */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__astFromValue_mjs__ = __webpack_require__(206);
/* unused harmony reexport astFromValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__TypeInfo_mjs__ = __webpack_require__(309);
/* unused harmony reexport TypeInfo */
/* unused harmony reexport visitWithTypeInfo */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__coerceInputValue_mjs__ = __webpack_require__(585);
/* unused harmony reexport coerceInputValue */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__concatAST_mjs__ = __webpack_require__(896);
/* unused harmony reexport concatAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__separateOperations_mjs__ = __webpack_require__(897);
/* unused harmony reexport separateOperations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__stripIgnoredCharacters_mjs__ = __webpack_require__(898);
/* unused harmony reexport stripIgnoredCharacters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__typeComparators_mjs__ = __webpack_require__(203);
/* unused harmony reexport isEqualType */
/* unused harmony reexport isTypeSubTypeOf */
/* unused harmony reexport doTypesOverlap */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__assertValidName_mjs__ = __webpack_require__(544);
/* unused harmony reexport assertValidName */
/* unused harmony reexport isValidNameError */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__findBreakingChanges_mjs__ = __webpack_require__(899);
/* unused harmony reexport BreakingChangeType */
/* unused harmony reexport DangerousChangeType */
/* unused harmony reexport findBreakingChanges */
/* unused harmony reexport findDangerousChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__findDeprecatedUsages_mjs__ = __webpack_require__(900);
/* unused harmony reexport findDeprecatedUsages */
// Produce the GraphQL query recommended for a full schema introspection.
// Accepts optional IntrospectionOptions.

// Gets the target Operation from a Document.
 // Gets the Type for the target Operation AST.

 // Convert a GraphQLSchema to an IntrospectionQuery.

 // Build a GraphQLSchema from an introspection result.

 // Build a GraphQLSchema from GraphQL Schema language.


// Extends an existing GraphQLSchema from a parsed GraphQL Schema language AST.
 // Sort a GraphQLSchema.

 // Print a GraphQLSchema to GraphQL Schema language.

 // Create a GraphQLType from a GraphQL language AST.

 // Create a JavaScript value from a GraphQL language AST with a type.

 // Create a JavaScript value from a GraphQL language AST without a type.

 // Create a GraphQL language AST from a JavaScript value.

 // A helper to use within recursive-descent visitors which need to be aware of
// the GraphQL type system.

 // Coerces a JavaScript value to a GraphQL type, or produces errors.

 // Concatenates multiple AST together.

 // Separates an AST into an AST per Operation.

 // Strips characters that are not significant to the validity or execution
// of a GraphQL document.

 // Comparators for types

 // Asserts that a string is a valid GraphQL name

 // Compares two GraphQLSchemas and detects breaking changes.


// @deprecated: Report all deprecated usage within a GraphQL document.



/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export getOperationAST */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__ = __webpack_require__(24);

/**
 * Returns an operation AST given a document AST and optionally an operation
 * name. If a name is not provided, an operation is only returned if only one is
 * provided in the document.
 */

function getOperationAST(documentAST, operationName) {
  var operation = null;

  for (var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++) {
    var definition = _documentAST$definiti2[_i2];

    if (definition.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION) {
      var _definition$name;

      if (operationName == null) {
        // If no operation name was provided, only return an Operation if there
        // is one defined in the document. Upon encountering the second, return
        // null.
        if (operation) {
          return null;
        }

        operation = definition;
      } else if (((_definition$name = definition.name) === null || _definition$name === void 0 ? void 0 : _definition$name.value) === operationName) {
        return definition;
      }
    }
  }

  return operation;
}


/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export introspectionFromSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_parser_mjs__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__execution_execute_mjs__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__getIntrospectionQuery_mjs__ = __webpack_require__(587);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }





/**
 * Build an IntrospectionQuery from a GraphQLSchema
 *
 * IntrospectionQuery is useful for utilities that care about type and field
 * relationships, but do not need to traverse through those relationships.
 *
 * This is the inverse of buildClientSchema. The primary use case is outside
 * of the server context, for instance when doing schema comparisons.
 */

function introspectionFromSchema(schema, options) {
  var optionsWithDefaults = _objectSpread({
    specifiedByUrl: true,
    directiveIsRepeatable: true,
    schemaDescription: true,
    inputValueDeprecation: true
  }, options);

  var document = Object(__WEBPACK_IMPORTED_MODULE_1__language_parser_mjs__["a" /* parse */])(Object(__WEBPACK_IMPORTED_MODULE_3__getIntrospectionQuery_mjs__["a" /* getIntrospectionQuery */])(optionsWithDefaults));
  var result = Object(__WEBPACK_IMPORTED_MODULE_2__execution_execute_mjs__["f" /* executeSync */])({
    schema: schema,
    document: document
  });
  !result.errors && result.data || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_invariant_mjs__["a" /* default */])(0);
  return result.data;
}


/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildClientSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__ = __webpack_require__(86);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_parser_mjs__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_schema_mjs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__valueFromAST_mjs__ = __webpack_require__(210);












/**
 * Build a GraphQLSchema for use by client tools.
 *
 * Given the result of a client running the introspection query, creates and
 * returns a GraphQLSchema instance which can be then used with all graphql-js
 * tools, but cannot be used to execute a query, as introspection does not
 * represent the "resolver", "parse" or "serialize" functions or any other
 * server-internal mechanisms.
 *
 * This function expects a complete introspection result. Don't forget to check
 * the "errors" field of a server response before calling this function.
 */

function buildClientSchema(introspection, options) {
  Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__["a" /* default */])(introspection) && Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_isObjectLike_mjs__["a" /* default */])(introspection.__schema) || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_devAssert_mjs__["a" /* default */])(0, "Invalid or incomplete introspection result. Ensure that you are passing \"data\" property of introspection response and no \"errors\" was returned alongside: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(introspection), ".")); // Get the schema from the introspection result.

  var schemaIntrospection = introspection.__schema; // Iterate through all types, getting the type definition for each.

  var typeMap = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__["a" /* default */])(schemaIntrospection.types, function (typeIntrospection) {
    return typeIntrospection.name;
  }, function (typeIntrospection) {
    return buildType(typeIntrospection);
  }); // Include standard types only if they are used.

  for (var _i2 = 0, _ref2 = [].concat(__WEBPACK_IMPORTED_MODULE_8__type_scalars_mjs__["e" /* specifiedScalarTypes */], __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["f" /* introspectionTypes */]); _i2 < _ref2.length; _i2++) {
    var stdType = _ref2[_i2];

    if (typeMap[stdType.name]) {
      typeMap[stdType.name] = stdType;
    }
  } // Get the root Query, Mutation, and Subscription types.


  var queryType = schemaIntrospection.queryType ? getObjectType(schemaIntrospection.queryType) : null;
  var mutationType = schemaIntrospection.mutationType ? getObjectType(schemaIntrospection.mutationType) : null;
  var subscriptionType = schemaIntrospection.subscriptionType ? getObjectType(schemaIntrospection.subscriptionType) : null; // Get the directives supported by Introspection, assuming empty-set if
  // directives were not queried for.

  var directives = schemaIntrospection.directives ? schemaIntrospection.directives.map(buildDirective) : []; // Then produce and return a Schema with these types.

  return new __WEBPACK_IMPORTED_MODULE_6__type_schema_mjs__["a" /* GraphQLSchema */]({
    description: schemaIntrospection.description,
    query: queryType,
    mutation: mutationType,
    subscription: subscriptionType,
    types: Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(typeMap),
    directives: directives,
    assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
  }); // Given a type reference in introspection, return the GraphQLType instance.
  // preferring cached instances before building new instances.

  function getType(typeRef) {
    if (typeRef.kind === __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].LIST) {
      var itemRef = typeRef.ofType;

      if (!itemRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["d" /* GraphQLList */](getType(itemRef));
    }

    if (typeRef.kind === __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].NON_NULL) {
      var nullableRef = typeRef.ofType;

      if (!nullableRef) {
        throw new Error('Decorated type deeper than introspection query.');
      }

      var nullableType = getType(nullableRef);
      return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["e" /* GraphQLNonNull */](Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["k" /* assertNullableType */])(nullableType));
    }

    return getNamedType(typeRef);
  }

  function getNamedType(typeRef) {
    var typeName = typeRef.name;

    if (!typeName) {
      throw new Error("Unknown type reference: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(typeRef), "."));
    }

    var type = typeMap[typeName];

    if (!type) {
      throw new Error("Invalid or incomplete schema, unknown type: ".concat(typeName, ". Ensure that a full introspection query is used in order to build a client schema."));
    }

    return type;
  }

  function getObjectType(typeRef) {
    return Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["l" /* assertObjectType */])(getNamedType(typeRef));
  }

  function getInterfaceType(typeRef) {
    return Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["j" /* assertInterfaceType */])(getNamedType(typeRef));
  } // Given a type's introspection result, construct the correct
  // GraphQLType instance.


  function buildType(type) {
    if (type != null && type.name != null && type.kind != null) {
      switch (type.kind) {
        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].SCALAR:
          return buildScalarDef(type);

        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].OBJECT:
          return buildObjectDef(type);

        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].INTERFACE:
          return buildInterfaceDef(type);

        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].UNION:
          return buildUnionDef(type);

        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].ENUM:
          return buildEnumDef(type);

        case __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].INPUT_OBJECT:
          return buildInputObjectDef(type);
      }
    }

    var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type);
    throw new Error("Invalid or incomplete introspection result. Ensure that a full introspection query is used in order to build a client schema: ".concat(typeStr, "."));
  }

  function buildScalarDef(scalarIntrospection) {
    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["g" /* GraphQLScalarType */]({
      name: scalarIntrospection.name,
      description: scalarIntrospection.description,
      specifiedByUrl: scalarIntrospection.specifiedByUrl
    });
  }

  function buildImplementationsList(implementingIntrospection) {
    // TODO: Temporary workaround until GraphQL ecosystem will fully support
    // 'interfaces' on interface types.
    if (implementingIntrospection.interfaces === null && implementingIntrospection.kind === __WEBPACK_IMPORTED_MODULE_9__type_introspection_mjs__["b" /* TypeKind */].INTERFACE) {
      return [];
    }

    if (!implementingIntrospection.interfaces) {
      var implementingIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(implementingIntrospection);
      throw new Error("Introspection result missing interfaces: ".concat(implementingIntrospectionStr, "."));
    }

    return implementingIntrospection.interfaces.map(getInterfaceType);
  }

  function buildObjectDef(objectIntrospection) {
    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["f" /* GraphQLObjectType */]({
      name: objectIntrospection.name,
      description: objectIntrospection.description,
      interfaces: function interfaces() {
        return buildImplementationsList(objectIntrospection);
      },
      fields: function fields() {
        return buildFieldDefMap(objectIntrospection);
      }
    });
  }

  function buildInterfaceDef(interfaceIntrospection) {
    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["c" /* GraphQLInterfaceType */]({
      name: interfaceIntrospection.name,
      description: interfaceIntrospection.description,
      interfaces: function interfaces() {
        return buildImplementationsList(interfaceIntrospection);
      },
      fields: function fields() {
        return buildFieldDefMap(interfaceIntrospection);
      }
    });
  }

  function buildUnionDef(unionIntrospection) {
    if (!unionIntrospection.possibleTypes) {
      var unionIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(unionIntrospection);
      throw new Error("Introspection result missing possibleTypes: ".concat(unionIntrospectionStr, "."));
    }

    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["h" /* GraphQLUnionType */]({
      name: unionIntrospection.name,
      description: unionIntrospection.description,
      types: function types() {
        return unionIntrospection.possibleTypes.map(getObjectType);
      }
    });
  }

  function buildEnumDef(enumIntrospection) {
    if (!enumIntrospection.enumValues) {
      var enumIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(enumIntrospection);
      throw new Error("Introspection result missing enumValues: ".concat(enumIntrospectionStr, "."));
    }

    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["a" /* GraphQLEnumType */]({
      name: enumIntrospection.name,
      description: enumIntrospection.description,
      values: Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__["a" /* default */])(enumIntrospection.enumValues, function (valueIntrospection) {
        return valueIntrospection.name;
      }, function (valueIntrospection) {
        return {
          description: valueIntrospection.description,
          deprecationReason: valueIntrospection.deprecationReason
        };
      })
    });
  }

  function buildInputObjectDef(inputObjectIntrospection) {
    if (!inputObjectIntrospection.inputFields) {
      var inputObjectIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(inputObjectIntrospection);
      throw new Error("Introspection result missing inputFields: ".concat(inputObjectIntrospectionStr, "."));
    }

    return new __WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["b" /* GraphQLInputObjectType */]({
      name: inputObjectIntrospection.name,
      description: inputObjectIntrospection.description,
      fields: function fields() {
        return buildInputValueDefMap(inputObjectIntrospection.inputFields);
      }
    });
  }

  function buildFieldDefMap(typeIntrospection) {
    if (!typeIntrospection.fields) {
      throw new Error("Introspection result missing fields: ".concat(Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(typeIntrospection), "."));
    }

    return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__["a" /* default */])(typeIntrospection.fields, function (fieldIntrospection) {
      return fieldIntrospection.name;
    }, buildField);
  }

  function buildField(fieldIntrospection) {
    var type = getType(fieldIntrospection.type);

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["z" /* isOutputType */])(type)) {
      var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type);
      throw new Error("Introspection must provide output type for fields, but received: ".concat(typeStr, "."));
    }

    if (!fieldIntrospection.args) {
      var fieldIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(fieldIntrospection);
      throw new Error("Introspection result missing field args: ".concat(fieldIntrospectionStr, "."));
    }

    return {
      description: fieldIntrospection.description,
      deprecationReason: fieldIntrospection.deprecationReason,
      type: type,
      args: buildInputValueDefMap(fieldIntrospection.args)
    };
  }

  function buildInputValueDefMap(inputValueIntrospections) {
    return Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__["a" /* default */])(inputValueIntrospections, function (inputValue) {
      return inputValue.name;
    }, buildInputValue);
  }

  function buildInputValue(inputValueIntrospection) {
    var type = getType(inputValueIntrospection.type);

    if (!Object(__WEBPACK_IMPORTED_MODULE_10__type_definition_mjs__["s" /* isInputType */])(type)) {
      var typeStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type);
      throw new Error("Introspection must provide input type for arguments, but received: ".concat(typeStr, "."));
    }

    var defaultValue = inputValueIntrospection.defaultValue != null ? Object(__WEBPACK_IMPORTED_MODULE_11__valueFromAST_mjs__["a" /* valueFromAST */])(Object(__WEBPACK_IMPORTED_MODULE_5__language_parser_mjs__["b" /* parseValue */])(inputValueIntrospection.defaultValue), type) : undefined;
    return {
      description: inputValueIntrospection.description,
      type: type,
      defaultValue: defaultValue,
      deprecationReason: inputValueIntrospection.deprecationReason
    };
  }

  function buildDirective(directiveIntrospection) {
    if (!directiveIntrospection.args) {
      var directiveIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(directiveIntrospection);
      throw new Error("Introspection result missing directive args: ".concat(directiveIntrospectionStr, "."));
    }

    if (!directiveIntrospection.locations) {
      var _directiveIntrospectionStr = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(directiveIntrospection);

      throw new Error("Introspection result missing directive locations: ".concat(_directiveIntrospectionStr, "."));
    }

    return new __WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__["c" /* GraphQLDirective */]({
      name: directiveIntrospection.name,
      description: directiveIntrospection.description,
      isRepeatable: directiveIntrospection.isRepeatable,
      locations: directiveIntrospection.locations.slice(),
      args: buildInputValueDefMap(directiveIntrospection.args)
    });
  }
}


/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export buildASTSchema */
/* unused harmony export buildSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__ = __webpack_require__(62);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_parser_mjs__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__validation_validate_mjs__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__type_schema_mjs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__extendSchema_mjs__ = __webpack_require__(588);








/**
 * This takes the ast of a schema document produced by the parse function in
 * src/language/parser.js.
 *
 * If no schema definition is provided, then it will look for types named Query
 * and Mutation.
 *
 * Given that AST it constructs a GraphQLSchema. The resulting schema
 * has no resolve methods, so execution will use default resolvers.
 *
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function buildASTSchema(documentAST, options) {
  documentAST != null && documentAST.kind === __WEBPACK_IMPORTED_MODULE_1__language_kinds_mjs__["a" /* Kind */].DOCUMENT || Object(__WEBPACK_IMPORTED_MODULE_0__jsutils_devAssert_mjs__["a" /* default */])(0, 'Must provide valid Document AST.');

  if ((options === null || options === void 0 ? void 0 : options.assumeValid) !== true && (options === null || options === void 0 ? void 0 : options.assumeValidSDL) !== true) {
    Object(__WEBPACK_IMPORTED_MODULE_3__validation_validate_mjs__["a" /* assertValidSDL */])(documentAST);
  }

  var emptySchemaConfig = {
    description: undefined,
    types: [],
    directives: [],
    extensions: undefined,
    extensionASTNodes: [],
    assumeValid: false
  };
  var config = Object(__WEBPACK_IMPORTED_MODULE_6__extendSchema_mjs__["a" /* extendSchemaImpl */])(emptySchemaConfig, documentAST, options);

  if (config.astNode == null) {
    for (var _i2 = 0, _config$types2 = config.types; _i2 < _config$types2.length; _i2++) {
      var type = _config$types2[_i2];

      switch (type.name) {
        // Note: While this could make early assertions to get the correctly
        // typed values below, that would throw immediately while type system
        // validation with validateSchema() will produce more actionable results.
        case 'Query':
          config.query = type;
          break;

        case 'Mutation':
          config.mutation = type;
          break;

        case 'Subscription':
          config.subscription = type;
          break;
      }
    }
  }

  var directives = config.directives; // If specified directives were not explicitly declared, add them.

  var _loop = function _loop(_i4) {
    var stdDirective = __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__["i" /* specifiedDirectives */][_i4];

    if (directives.every(function (directive) {
      return directive.name !== stdDirective.name;
    })) {
      directives.push(stdDirective);
    }
  };

  for (var _i4 = 0; _i4 < __WEBPACK_IMPORTED_MODULE_5__type_directives_mjs__["i" /* specifiedDirectives */].length; _i4++) {
    _loop(_i4);
  }

  return new __WEBPACK_IMPORTED_MODULE_4__type_schema_mjs__["a" /* GraphQLSchema */](config);
}
/**
 * A helper function to build a GraphQLSchema directly from a source
 * document.
 */

function buildSchema(source, options) {
  var document = Object(__WEBPACK_IMPORTED_MODULE_2__language_parser_mjs__["a" /* parse */])(source, {
    noLocation: options === null || options === void 0 ? void 0 : options.noLocation,
    allowLegacySDLEmptyFields: options === null || options === void 0 ? void 0 : options.allowLegacySDLEmptyFields,
    allowLegacySDLImplementsInterfaces: options === null || options === void 0 ? void 0 : options.allowLegacySDLImplementsInterfaces,
    experimentalFragmentVariables: options === null || options === void 0 ? void 0 : options.experimentalFragmentVariables
  });
  return buildASTSchema(document, {
    commentDescriptions: options === null || options === void 0 ? void 0 : options.commentDescriptions,
    assumeValidSDL: options === null || options === void 0 ? void 0 : options.assumeValidSDL,
    assumeValid: options === null || options === void 0 ? void 0 : options.assumeValid
  });
}


/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export lexicographicSortSchema */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__ = __webpack_require__(204);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_naturalCompare_mjs__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_schema_mjs__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__ = __webpack_require__(20);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }










/**
 * Sort GraphQLSchema.
 *
 * This function returns a sorted copy of the given GraphQLSchema.
 */

function lexicographicSortSchema(schema) {
  var schemaConfig = schema.toConfig();
  var typeMap = Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_keyValMap_mjs__["a" /* default */])(sortByName(schemaConfig.types), function (type) {
    return type.name;
  }, sortNamedType);
  return new __WEBPACK_IMPORTED_MODULE_5__type_schema_mjs__["a" /* GraphQLSchema */](_objectSpread(_objectSpread({}, schemaConfig), {}, {
    types: Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(typeMap),
    directives: sortByName(schemaConfig.directives).map(sortDirective),
    query: replaceMaybeType(schemaConfig.query),
    mutation: replaceMaybeType(schemaConfig.mutation),
    subscription: replaceMaybeType(schemaConfig.subscription)
  }));

  function replaceType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(type)) {
      // $FlowFixMe[incompatible-return]
      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["d" /* GraphQLList */](replaceType(type.ofType));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(type)) {
      // $FlowFixMe[incompatible-return]
      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["e" /* GraphQLNonNull */](replaceType(type.ofType));
    }

    return replaceNamedType(type);
  }

  function replaceNamedType(type) {
    return typeMap[type.name];
  }

  function replaceMaybeType(maybeType) {
    return maybeType && replaceNamedType(maybeType);
  }

  function sortDirective(directive) {
    var config = directive.toConfig();
    return new __WEBPACK_IMPORTED_MODULE_6__type_directives_mjs__["c" /* GraphQLDirective */](_objectSpread(_objectSpread({}, config), {}, {
      locations: sortBy(config.locations, function (x) {
        return x;
      }),
      args: sortArgs(config.args)
    }));
  }

  function sortArgs(args) {
    return sortObjMap(args, function (arg) {
      return _objectSpread(_objectSpread({}, arg), {}, {
        type: replaceType(arg.type)
      });
    });
  }

  function sortFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return _objectSpread(_objectSpread({}, field), {}, {
        type: replaceType(field.type),
        args: sortArgs(field.args)
      });
    });
  }

  function sortInputFields(fieldsMap) {
    return sortObjMap(fieldsMap, function (field) {
      return _objectSpread(_objectSpread({}, field), {}, {
        type: replaceType(field.type)
      });
    });
  }

  function sortTypes(arr) {
    return sortByName(arr).map(replaceNamedType);
  }

  function sortNamedType(type) {
    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["C" /* isScalarType */])(type) || Object(__WEBPACK_IMPORTED_MODULE_7__type_introspection_mjs__["g" /* isIntrospectionType */])(type)) {
      return type;
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["y" /* isObjectType */])(type)) {
      var config = type.toConfig();
      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["f" /* GraphQLObjectType */](_objectSpread(_objectSpread({}, config), {}, {
        interfaces: function interfaces() {
          return sortTypes(config.interfaces);
        },
        fields: function fields() {
          return sortFields(config.fields);
        }
      }));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
      var _config = type.toConfig();

      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["c" /* GraphQLInterfaceType */](_objectSpread(_objectSpread({}, _config), {}, {
        interfaces: function interfaces() {
          return sortTypes(_config.interfaces);
        },
        fields: function fields() {
          return sortFields(_config.fields);
        }
      }));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["E" /* isUnionType */])(type)) {
      var _config2 = type.toConfig();

      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["h" /* GraphQLUnionType */](_objectSpread(_objectSpread({}, _config2), {}, {
        types: function types() {
          return sortTypes(_config2.types);
        }
      }));
    }

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(type)) {
      var _config3 = type.toConfig();

      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["a" /* GraphQLEnumType */](_objectSpread(_objectSpread({}, _config3), {}, {
        values: sortObjMap(_config3.values)
      }));
    } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
      var _config4 = type.toConfig();

      return new __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["b" /* GraphQLInputObjectType */](_objectSpread(_objectSpread({}, _config4), {}, {
        fields: function fields() {
          return sortInputFields(_config4.fields);
        }
      }));
    } // istanbul ignore next (Not reachable. All possible types have been considered)


    false || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type: ' + Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type));
  }
}

function sortObjMap(map, sortValueFn) {
  var sortedMap = Object.create(null);
  var sortedKeys = sortBy(Object.keys(map), function (x) {
    return x;
  });

  for (var _i2 = 0; _i2 < sortedKeys.length; _i2++) {
    var key = sortedKeys[_i2];
    var value = map[key];
    sortedMap[key] = sortValueFn ? sortValueFn(value) : value;
  }

  return sortedMap;
}

function sortByName(array) {
  return sortBy(array, function (obj) {
    return obj.name;
  });
}

function sortBy(array, mapToKey) {
  return array.slice().sort(function (obj1, obj2) {
    var key1 = mapToKey(obj1);
    var key2 = mapToKey(obj2);
    return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_naturalCompare_mjs__["a" /* default */])(key1, key2);
  });
}


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export printSchema */
/* unused harmony export printIntrospectionSchema */
/* unused harmony export printType */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__language_blockString_mjs__ = __webpack_require__(159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__ = __webpack_require__(206);











/**
 * Accepts options as a second argument:
 *
 *    - commentDescriptions:
 *        Provide true to use preceding comments as the description.
 *
 */
function printSchema(schema, options) {
  return printFilteredSchema(schema, function (n) {
    return !Object(__WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__["h" /* isSpecifiedDirective */])(n);
  }, isDefinedType, options);
}
function printIntrospectionSchema(schema, options) {
  return printFilteredSchema(schema, __WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__["h" /* isSpecifiedDirective */], __WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["g" /* isIntrospectionType */], options);
}

function isDefinedType(type) {
  return !Object(__WEBPACK_IMPORTED_MODULE_6__type_scalars_mjs__["d" /* isSpecifiedScalarType */])(type) && !Object(__WEBPACK_IMPORTED_MODULE_5__type_introspection_mjs__["g" /* isIntrospectionType */])(type);
}

function printFilteredSchema(schema, directiveFilter, typeFilter, options) {
  var directives = schema.getDirectives().filter(directiveFilter);
  var types = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(schema.getTypeMap()).filter(typeFilter);
  return [printSchemaDefinition(schema)].concat(directives.map(function (directive) {
    return printDirective(directive, options);
  }), types.map(function (type) {
    return printType(type, options);
  })).filter(Boolean).join('\n\n') + '\n';
}

function printSchemaDefinition(schema) {
  if (schema.description == null && isSchemaOfCommonNames(schema)) {
    return;
  }

  var operationTypes = [];
  var queryType = schema.getQueryType();

  if (queryType) {
    operationTypes.push("  query: ".concat(queryType.name));
  }

  var mutationType = schema.getMutationType();

  if (mutationType) {
    operationTypes.push("  mutation: ".concat(mutationType.name));
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType) {
    operationTypes.push("  subscription: ".concat(subscriptionType.name));
  }

  return printDescription({}, schema) + "schema {\n".concat(operationTypes.join('\n'), "\n}");
}
/**
 * GraphQL schema define root types for each type of operation. These types are
 * the same as any other type and can be named in any manner, however there is
 * a common naming convention:
 *
 *   schema {
 *     query: Query
 *     mutation: Mutation
 *   }
 *
 * When using this naming convention, the schema description can be omitted.
 */


function isSchemaOfCommonNames(schema) {
  var queryType = schema.getQueryType();

  if (queryType && queryType.name !== 'Query') {
    return false;
  }

  var mutationType = schema.getMutationType();

  if (mutationType && mutationType.name !== 'Mutation') {
    return false;
  }

  var subscriptionType = schema.getSubscriptionType();

  if (subscriptionType && subscriptionType.name !== 'Subscription') {
    return false;
  }

  return true;
}

function printType(type, options) {
  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["C" /* isScalarType */])(type)) {
    return printScalar(type, options);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["y" /* isObjectType */])(type)) {
    return printObject(type, options);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
    return printInterface(type, options);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["E" /* isUnionType */])(type)) {
    return printUnion(type, options);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(type)) {
    return printEnum(type, options);
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    return printInputObject(type, options);
  } // istanbul ignore next (Not reachable. All possible types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type: ' + Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_inspect_mjs__["a" /* default */])(type));
}

function printScalar(type, options) {
  return printDescription(options, type) + "scalar ".concat(type.name) + printSpecifiedByUrl(type);
}

function printImplementedInterfaces(type) {
  var interfaces = type.getInterfaces();
  return interfaces.length ? ' implements ' + interfaces.map(function (i) {
    return i.name;
  }).join(' & ') : '';
}

function printObject(type, options) {
  return printDescription(options, type) + "type ".concat(type.name) + printImplementedInterfaces(type) + printFields(options, type);
}

function printInterface(type, options) {
  return printDescription(options, type) + "interface ".concat(type.name) + printImplementedInterfaces(type) + printFields(options, type);
}

function printUnion(type, options) {
  var types = type.getTypes();
  var possibleTypes = types.length ? ' = ' + types.join(' | ') : '';
  return printDescription(options, type) + 'union ' + type.name + possibleTypes;
}

function printEnum(type, options) {
  var values = type.getValues().map(function (value, i) {
    return printDescription(options, value, '  ', !i) + '  ' + value.name + printDeprecated(value.deprecationReason);
  });
  return printDescription(options, type) + "enum ".concat(type.name) + printBlock(values);
}

function printInputObject(type, options) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()).map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + printInputValue(f);
  });
  return printDescription(options, type) + "input ".concat(type.name) + printBlock(fields);
}

function printFields(options, type) {
  var fields = Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(type.getFields()).map(function (f, i) {
    return printDescription(options, f, '  ', !i) + '  ' + f.name + printArgs(options, f.args, '  ') + ': ' + String(f.type) + printDeprecated(f.deprecationReason);
  });
  return printBlock(fields);
}

function printBlock(items) {
  return items.length !== 0 ? ' {\n' + items.join('\n') + '\n}' : '';
}

function printArgs(options, args) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (args.length === 0) {
    return '';
  } // If every arg does not have a description, print them on one line.


  if (args.every(function (arg) {
    return !arg.description;
  })) {
    return '(' + args.map(printInputValue).join(', ') + ')';
  }

  return '(\n' + args.map(function (arg, i) {
    return printDescription(options, arg, '  ' + indentation, !i) + '  ' + indentation + printInputValue(arg);
  }).join('\n') + '\n' + indentation + ')';
}

function printInputValue(arg) {
  var defaultAST = Object(__WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__["a" /* astFromValue */])(arg.defaultValue, arg.type);
  var argDecl = arg.name + ': ' + String(arg.type);

  if (defaultAST) {
    argDecl += " = ".concat(Object(__WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__["a" /* print */])(defaultAST));
  }

  return argDecl + printDeprecated(arg.deprecationReason);
}

function printDirective(directive, options) {
  return printDescription(options, directive) + 'directive @' + directive.name + printArgs(options, directive.args) + (directive.isRepeatable ? ' repeatable' : '') + ' on ' + directive.locations.join(' | ');
}

function printDeprecated(reason) {
  if (reason == null) {
    return '';
  }

  var reasonAST = Object(__WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__["a" /* astFromValue */])(reason, __WEBPACK_IMPORTED_MODULE_6__type_scalars_mjs__["c" /* GraphQLString */]);

  if (reasonAST && reason !== __WEBPACK_IMPORTED_MODULE_7__type_directives_mjs__["a" /* DEFAULT_DEPRECATION_REASON */]) {
    return ' @deprecated(reason: ' + Object(__WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__["a" /* print */])(reasonAST) + ')';
  }

  return ' @deprecated';
}

function printSpecifiedByUrl(scalar) {
  if (scalar.specifiedByUrl == null) {
    return '';
  }

  var url = scalar.specifiedByUrl;
  var urlAST = Object(__WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__["a" /* astFromValue */])(url, __WEBPACK_IMPORTED_MODULE_6__type_scalars_mjs__["c" /* GraphQLString */]);
  urlAST || Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected null value returned from `astFromValue` for specifiedByUrl');
  return ' @specifiedBy(url: ' + Object(__WEBPACK_IMPORTED_MODULE_3__language_printer_mjs__["a" /* print */])(urlAST) + ')';
}

function printDescription(options, def) {
  var indentation = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var firstInBlock = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var description = def.description;

  if (description == null) {
    return '';
  }

  if ((options === null || options === void 0 ? void 0 : options.commentDescriptions) === true) {
    return printDescriptionWithComments(description, indentation, firstInBlock);
  }

  var preferMultipleLines = description.length > 70;
  var blockString = Object(__WEBPACK_IMPORTED_MODULE_4__language_blockString_mjs__["c" /* printBlockString */])(description, '', preferMultipleLines);
  var prefix = indentation && !firstInBlock ? '\n' + indentation : indentation;
  return prefix + blockString.replace(/\n/g, '\n' + indentation) + '\n';
}

function printDescriptionWithComments(description, indentation, firstInBlock) {
  var prefix = indentation && !firstInBlock ? '\n' : '';
  var comment = description.split('\n').map(function (line) {
    return indentation + (line !== '' ? '# ' + line : '#');
  }).join('\n');
  return prefix + comment + '\n';
}


/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export concatAST */
/**
 * Provided a collection of ASTs, presumably each from different files,
 * concatenate the ASTs together into batched AST, useful for validating many
 * GraphQL source files which together represent one conceptual application.
 */
function concatAST(documents) {
  var definitions = [];

  for (var _i2 = 0; _i2 < documents.length; _i2++) {
    var doc = documents[_i2];
    definitions = definitions.concat(doc.definitions);
  }

  return {
    kind: 'Document',
    definitions: definitions
  };
}


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export separateOperations */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_visitor_mjs__ = __webpack_require__(116);


/**
 * separateOperations accepts a single AST document which may contain many
 * operations and fragments and returns a collection of AST documents each of
 * which contains a single operation as well the fragment definitions it
 * refers to.
 */

function separateOperations(documentAST) {
  var operations = [];
  var depGraph = Object.create(null); // Populate metadata and build a dependency graph.

  for (var _i2 = 0, _documentAST$definiti2 = documentAST.definitions; _i2 < _documentAST$definiti2.length; _i2++) {
    var definitionNode = _documentAST$definiti2[_i2];

    switch (definitionNode.kind) {
      case __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].OPERATION_DEFINITION:
        operations.push(definitionNode);
        break;

      case __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION:
        depGraph[definitionNode.name.value] = collectDependencies(definitionNode.selectionSet);
        break;
    }
  } // For each operation, produce a new synthesized AST which includes only what
  // is necessary for completing that operation.


  var separatedDocumentASTs = Object.create(null);

  var _loop = function _loop(_i4) {
    var operation = operations[_i4];
    var dependencies = new Set();

    for (var _i6 = 0, _collectDependencies2 = collectDependencies(operation.selectionSet); _i6 < _collectDependencies2.length; _i6++) {
      var fragmentName = _collectDependencies2[_i6];
      collectTransitiveDependencies(dependencies, depGraph, fragmentName);
    } // Provides the empty string for anonymous operations.


    var operationName = operation.name ? operation.name.value : ''; // The list of definition nodes to be included for this operation, sorted
    // to retain the same order as the original document.

    separatedDocumentASTs[operationName] = {
      kind: __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].DOCUMENT,
      definitions: documentAST.definitions.filter(function (node) {
        return node === operation || node.kind === __WEBPACK_IMPORTED_MODULE_0__language_kinds_mjs__["a" /* Kind */].FRAGMENT_DEFINITION && dependencies.has(node.name.value);
      })
    };
  };

  for (var _i4 = 0; _i4 < operations.length; _i4++) {
    _loop(_i4);
  }

  return separatedDocumentASTs;
}

// From a dependency graph, collects a list of transitive dependencies by
// recursing through a dependency graph.
function collectTransitiveDependencies(collected, depGraph, fromName) {
  if (!collected.has(fromName)) {
    collected.add(fromName);
    var immediateDeps = depGraph[fromName];

    if (immediateDeps !== undefined) {
      for (var _i8 = 0; _i8 < immediateDeps.length; _i8++) {
        var toName = immediateDeps[_i8];
        collectTransitiveDependencies(collected, depGraph, toName);
      }
    }
  }
}

function collectDependencies(selectionSet) {
  var dependencies = [];
  Object(__WEBPACK_IMPORTED_MODULE_1__language_visitor_mjs__["b" /* visit */])(selectionSet, {
    FragmentSpread: function FragmentSpread(node) {
      dependencies.push(node.name.value);
    }
  });
  return dependencies;
}


/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export stripIgnoredCharacters */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__language_source_mjs__ = __webpack_require__(305);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language_tokenKind_mjs__ = __webpack_require__(157);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__language_lexer_mjs__ = __webpack_require__(306);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__language_blockString_mjs__ = __webpack_require__(159);




/**
 * Strips characters that are not significant to the validity or execution
 * of a GraphQL document:
 *   - UnicodeBOM
 *   - WhiteSpace
 *   - LineTerminator
 *   - Comment
 *   - Comma
 *   - BlockString indentation
 *
 * Note: It is required to have a delimiter character between neighboring
 * non-punctuator tokens and this function always uses single space as delimiter.
 *
 * It is guaranteed that both input and output documents if parsed would result
 * in the exact same AST except for nodes location.
 *
 * Warning: It is guaranteed that this function will always produce stable results.
 * However, it's not guaranteed that it will stay the same between different
 * releases due to bugfixes or changes in the GraphQL specification.
 *
 * Query example:
 *
 * query SomeQuery($foo: String!, $bar: String) {
 *   someField(foo: $foo, bar: $bar) {
 *     a
 *     b {
 *       c
 *       d
 *     }
 *   }
 * }
 *
 * Becomes:
 *
 * query SomeQuery($foo:String!$bar:String){someField(foo:$foo bar:$bar){a b{c d}}}
 *
 * SDL example:
 *
 * """
 * Type description
 * """
 * type Foo {
 *   """
 *   Field description
 *   """
 *   bar: String
 * }
 *
 * Becomes:
 *
 * """Type description""" type Foo{"""Field description""" bar:String}
 */

function stripIgnoredCharacters(source) {
  var sourceObj = Object(__WEBPACK_IMPORTED_MODULE_0__language_source_mjs__["b" /* isSource */])(source) ? source : new __WEBPACK_IMPORTED_MODULE_0__language_source_mjs__["a" /* Source */](source);
  var body = sourceObj.body;
  var lexer = new __WEBPACK_IMPORTED_MODULE_2__language_lexer_mjs__["a" /* Lexer */](sourceObj);
  var strippedBody = '';
  var wasLastAddedTokenNonPunctuator = false;

  while (lexer.advance().kind !== __WEBPACK_IMPORTED_MODULE_1__language_tokenKind_mjs__["a" /* TokenKind */].EOF) {
    var currentToken = lexer.token;
    var tokenKind = currentToken.kind;
    /**
     * Every two non-punctuator tokens should have space between them.
     * Also prevent case of non-punctuator token following by spread resulting
     * in invalid token (e.g. `1...` is invalid Float token).
     */

    var isNonPunctuator = !Object(__WEBPACK_IMPORTED_MODULE_2__language_lexer_mjs__["b" /* isPunctuatorTokenKind */])(currentToken.kind);

    if (wasLastAddedTokenNonPunctuator) {
      if (isNonPunctuator || currentToken.kind === __WEBPACK_IMPORTED_MODULE_1__language_tokenKind_mjs__["a" /* TokenKind */].SPREAD) {
        strippedBody += ' ';
      }
    }

    var tokenBody = body.slice(currentToken.start, currentToken.end);

    if (tokenKind === __WEBPACK_IMPORTED_MODULE_1__language_tokenKind_mjs__["a" /* TokenKind */].BLOCK_STRING) {
      strippedBody += dedentBlockString(tokenBody);
    } else {
      strippedBody += tokenBody;
    }

    wasLastAddedTokenNonPunctuator = isNonPunctuator;
  }

  return strippedBody;
}

function dedentBlockString(blockStr) {
  // skip leading and trailing triple quotations
  var rawStr = blockStr.slice(3, -3);
  var body = Object(__WEBPACK_IMPORTED_MODULE_3__language_blockString_mjs__["a" /* dedentBlockStringValue */])(rawStr);

  if (Object(__WEBPACK_IMPORTED_MODULE_3__language_blockString_mjs__["b" /* getBlockStringIndentation */])(body) > 0) {
    body = '\n' + body;
  }

  var lastChar = body[body.length - 1];
  var hasTrailingQuote = lastChar === '"' && body.slice(-4) !== '\\"""';

  if (hasTrailingQuote || lastChar === '\\') {
    body += '\n';
  }

  return '"""' + body + '"""';
}


/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export BreakingChangeType */
/* unused harmony export DangerousChangeType */
/* unused harmony export findBreakingChanges */
/* unused harmony export findDangerousChanges */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__ = __webpack_require__(117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__jsutils_naturalCompare_mjs__ = __webpack_require__(205);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__language_visitor_mjs__ = __webpack_require__(116);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__type_scalars_mjs__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__ = __webpack_require__(206);
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }











var BreakingChangeType = Object.freeze({
  TYPE_REMOVED: 'TYPE_REMOVED',
  TYPE_CHANGED_KIND: 'TYPE_CHANGED_KIND',
  TYPE_REMOVED_FROM_UNION: 'TYPE_REMOVED_FROM_UNION',
  VALUE_REMOVED_FROM_ENUM: 'VALUE_REMOVED_FROM_ENUM',
  REQUIRED_INPUT_FIELD_ADDED: 'REQUIRED_INPUT_FIELD_ADDED',
  IMPLEMENTED_INTERFACE_REMOVED: 'IMPLEMENTED_INTERFACE_REMOVED',
  FIELD_REMOVED: 'FIELD_REMOVED',
  FIELD_CHANGED_KIND: 'FIELD_CHANGED_KIND',
  REQUIRED_ARG_ADDED: 'REQUIRED_ARG_ADDED',
  ARG_REMOVED: 'ARG_REMOVED',
  ARG_CHANGED_KIND: 'ARG_CHANGED_KIND',
  DIRECTIVE_REMOVED: 'DIRECTIVE_REMOVED',
  DIRECTIVE_ARG_REMOVED: 'DIRECTIVE_ARG_REMOVED',
  REQUIRED_DIRECTIVE_ARG_ADDED: 'REQUIRED_DIRECTIVE_ARG_ADDED',
  DIRECTIVE_REPEATABLE_REMOVED: 'DIRECTIVE_REPEATABLE_REMOVED',
  DIRECTIVE_LOCATION_REMOVED: 'DIRECTIVE_LOCATION_REMOVED'
});
var DangerousChangeType = Object.freeze({
  VALUE_ADDED_TO_ENUM: 'VALUE_ADDED_TO_ENUM',
  TYPE_ADDED_TO_UNION: 'TYPE_ADDED_TO_UNION',
  OPTIONAL_INPUT_FIELD_ADDED: 'OPTIONAL_INPUT_FIELD_ADDED',
  OPTIONAL_ARG_ADDED: 'OPTIONAL_ARG_ADDED',
  IMPLEMENTED_INTERFACE_ADDED: 'IMPLEMENTED_INTERFACE_ADDED',
  ARG_DEFAULT_VALUE_CHANGE: 'ARG_DEFAULT_VALUE_CHANGE'
});

/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of breaking changes covered by the other functions down below.
 */
function findBreakingChanges(oldSchema, newSchema) {
  var breakingChanges = findSchemaChanges(oldSchema, newSchema).filter(function (change) {
    return change.type in BreakingChangeType;
  });
  return breakingChanges;
}
/**
 * Given two schemas, returns an Array containing descriptions of all the types
 * of potentially dangerous changes covered by the other functions down below.
 */

function findDangerousChanges(oldSchema, newSchema) {
  var dangerousChanges = findSchemaChanges(oldSchema, newSchema).filter(function (change) {
    return change.type in DangerousChangeType;
  });
  return dangerousChanges;
}

function findSchemaChanges(oldSchema, newSchema) {
  return [].concat(findTypeChanges(oldSchema, newSchema), findDirectiveChanges(oldSchema, newSchema));
}

function findDirectiveChanges(oldSchema, newSchema) {
  var schemaChanges = [];
  var directivesDiff = diff(oldSchema.getDirectives(), newSchema.getDirectives());

  for (var _i2 = 0, _directivesDiff$remov2 = directivesDiff.removed; _i2 < _directivesDiff$remov2.length; _i2++) {
    var oldDirective = _directivesDiff$remov2[_i2];
    schemaChanges.push({
      type: BreakingChangeType.DIRECTIVE_REMOVED,
      description: "".concat(oldDirective.name, " was removed.")
    });
  }

  for (var _i4 = 0, _directivesDiff$persi2 = directivesDiff.persisted; _i4 < _directivesDiff$persi2.length; _i4++) {
    var _ref2 = _directivesDiff$persi2[_i4];
    var _oldDirective = _ref2[0];
    var newDirective = _ref2[1];
    var argsDiff = diff(_oldDirective.args, newDirective.args);

    for (var _i6 = 0, _argsDiff$added2 = argsDiff.added; _i6 < _argsDiff$added2.length; _i6++) {
      var newArg = _argsDiff$added2[_i6];

      if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["A" /* isRequiredArgument */])(newArg)) {
        schemaChanges.push({
          type: BreakingChangeType.REQUIRED_DIRECTIVE_ARG_ADDED,
          description: "A required arg ".concat(newArg.name, " on directive ").concat(_oldDirective.name, " was added.")
        });
      }
    }

    for (var _i8 = 0, _argsDiff$removed2 = argsDiff.removed; _i8 < _argsDiff$removed2.length; _i8++) {
      var oldArg = _argsDiff$removed2[_i8];
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_ARG_REMOVED,
        description: "".concat(oldArg.name, " was removed from ").concat(_oldDirective.name, ".")
      });
    }

    if (_oldDirective.isRepeatable && !newDirective.isRepeatable) {
      schemaChanges.push({
        type: BreakingChangeType.DIRECTIVE_REPEATABLE_REMOVED,
        description: "Repeatable flag was removed from ".concat(_oldDirective.name, ".")
      });
    }

    for (var _i10 = 0, _oldDirective$locatio2 = _oldDirective.locations; _i10 < _oldDirective$locatio2.length; _i10++) {
      var location = _oldDirective$locatio2[_i10];

      if (newDirective.locations.indexOf(location) === -1) {
        schemaChanges.push({
          type: BreakingChangeType.DIRECTIVE_LOCATION_REMOVED,
          description: "".concat(location, " was removed from ").concat(_oldDirective.name, ".")
        });
      }
    }
  }

  return schemaChanges;
}

function findTypeChanges(oldSchema, newSchema) {
  var schemaChanges = [];
  var typesDiff = diff(Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(oldSchema.getTypeMap()), Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(newSchema.getTypeMap()));

  for (var _i12 = 0, _typesDiff$removed2 = typesDiff.removed; _i12 < _typesDiff$removed2.length; _i12++) {
    var oldType = _typesDiff$removed2[_i12];
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED,
      description: Object(__WEBPACK_IMPORTED_MODULE_7__type_scalars_mjs__["d" /* isSpecifiedScalarType */])(oldType) ? "Standard scalar ".concat(oldType.name, " was removed because it is not referenced anymore.") : "".concat(oldType.name, " was removed.")
    });
  }

  for (var _i14 = 0, _typesDiff$persisted2 = typesDiff.persisted; _i14 < _typesDiff$persisted2.length; _i14++) {
    var _ref4 = _typesDiff$persisted2[_i14];
    var _oldType = _ref4[0];
    var newType = _ref4[1];

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(_oldType) && Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(newType)) {
      schemaChanges.push.apply(schemaChanges, findEnumTypeChanges(_oldType, newType));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["E" /* isUnionType */])(_oldType) && Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["E" /* isUnionType */])(newType)) {
      schemaChanges.push.apply(schemaChanges, findUnionTypeChanges(_oldType, newType));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(_oldType) && Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(newType)) {
      schemaChanges.push.apply(schemaChanges, findInputObjectTypeChanges(_oldType, newType));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["y" /* isObjectType */])(_oldType) && Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["y" /* isObjectType */])(newType)) {
      schemaChanges.push.apply(schemaChanges, findFieldChanges(_oldType, newType).concat(findImplementedInterfacesChanges(_oldType, newType)));
    } else if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["t" /* isInterfaceType */])(_oldType) && Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["t" /* isInterfaceType */])(newType)) {
      schemaChanges.push.apply(schemaChanges, findFieldChanges(_oldType, newType).concat(findImplementedInterfacesChanges(_oldType, newType)));
    } else if (_oldType.constructor !== newType.constructor) {
      schemaChanges.push({
        type: BreakingChangeType.TYPE_CHANGED_KIND,
        description: "".concat(_oldType.name, " changed from ") + "".concat(typeKindName(_oldType), " to ").concat(typeKindName(newType), ".")
      });
    }
  }

  return schemaChanges;
}

function findInputObjectTypeChanges(oldType, newType) {
  var schemaChanges = [];
  var fieldsDiff = diff(Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(oldType.getFields()), Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(newType.getFields()));

  for (var _i16 = 0, _fieldsDiff$added2 = fieldsDiff.added; _i16 < _fieldsDiff$added2.length; _i16++) {
    var newField = _fieldsDiff$added2[_i16];

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["B" /* isRequiredInputField */])(newField)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_INPUT_FIELD_ADDED,
        description: "A required field ".concat(newField.name, " on input type ").concat(oldType.name, " was added.")
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_INPUT_FIELD_ADDED,
        description: "An optional field ".concat(newField.name, " on input type ").concat(oldType.name, " was added.")
      });
    }
  }

  for (var _i18 = 0, _fieldsDiff$removed2 = fieldsDiff.removed; _i18 < _fieldsDiff$removed2.length; _i18++) {
    var oldField = _fieldsDiff$removed2[_i18];
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: "".concat(oldType.name, ".").concat(oldField.name, " was removed.")
    });
  }

  for (var _i20 = 0, _fieldsDiff$persisted2 = fieldsDiff.persisted; _i20 < _fieldsDiff$persisted2.length; _i20++) {
    var _ref6 = _fieldsDiff$persisted2[_i20];
    var _oldField = _ref6[0];
    var _newField = _ref6[1];
    var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(_oldField.type, _newField.type);

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description: "".concat(oldType.name, ".").concat(_oldField.name, " changed type from ") + "".concat(String(_oldField.type), " to ").concat(String(_newField.type), ".")
      });
    }
  }

  return schemaChanges;
}

function findUnionTypeChanges(oldType, newType) {
  var schemaChanges = [];
  var possibleTypesDiff = diff(oldType.getTypes(), newType.getTypes());

  for (var _i22 = 0, _possibleTypesDiff$ad2 = possibleTypesDiff.added; _i22 < _possibleTypesDiff$ad2.length; _i22++) {
    var newPossibleType = _possibleTypesDiff$ad2[_i22];
    schemaChanges.push({
      type: DangerousChangeType.TYPE_ADDED_TO_UNION,
      description: "".concat(newPossibleType.name, " was added to union type ").concat(oldType.name, ".")
    });
  }

  for (var _i24 = 0, _possibleTypesDiff$re2 = possibleTypesDiff.removed; _i24 < _possibleTypesDiff$re2.length; _i24++) {
    var oldPossibleType = _possibleTypesDiff$re2[_i24];
    schemaChanges.push({
      type: BreakingChangeType.TYPE_REMOVED_FROM_UNION,
      description: "".concat(oldPossibleType.name, " was removed from union type ").concat(oldType.name, ".")
    });
  }

  return schemaChanges;
}

function findEnumTypeChanges(oldType, newType) {
  var schemaChanges = [];
  var valuesDiff = diff(oldType.getValues(), newType.getValues());

  for (var _i26 = 0, _valuesDiff$added2 = valuesDiff.added; _i26 < _valuesDiff$added2.length; _i26++) {
    var newValue = _valuesDiff$added2[_i26];
    schemaChanges.push({
      type: DangerousChangeType.VALUE_ADDED_TO_ENUM,
      description: "".concat(newValue.name, " was added to enum type ").concat(oldType.name, ".")
    });
  }

  for (var _i28 = 0, _valuesDiff$removed2 = valuesDiff.removed; _i28 < _valuesDiff$removed2.length; _i28++) {
    var oldValue = _valuesDiff$removed2[_i28];
    schemaChanges.push({
      type: BreakingChangeType.VALUE_REMOVED_FROM_ENUM,
      description: "".concat(oldValue.name, " was removed from enum type ").concat(oldType.name, ".")
    });
  }

  return schemaChanges;
}

function findImplementedInterfacesChanges(oldType, newType) {
  var schemaChanges = [];
  var interfacesDiff = diff(oldType.getInterfaces(), newType.getInterfaces());

  for (var _i30 = 0, _interfacesDiff$added2 = interfacesDiff.added; _i30 < _interfacesDiff$added2.length; _i30++) {
    var newInterface = _interfacesDiff$added2[_i30];
    schemaChanges.push({
      type: DangerousChangeType.IMPLEMENTED_INTERFACE_ADDED,
      description: "".concat(newInterface.name, " added to interfaces implemented by ").concat(oldType.name, ".")
    });
  }

  for (var _i32 = 0, _interfacesDiff$remov2 = interfacesDiff.removed; _i32 < _interfacesDiff$remov2.length; _i32++) {
    var oldInterface = _interfacesDiff$remov2[_i32];
    schemaChanges.push({
      type: BreakingChangeType.IMPLEMENTED_INTERFACE_REMOVED,
      description: "".concat(oldType.name, " no longer implements interface ").concat(oldInterface.name, ".")
    });
  }

  return schemaChanges;
}

function findFieldChanges(oldType, newType) {
  var schemaChanges = [];
  var fieldsDiff = diff(Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(oldType.getFields()), Object(__WEBPACK_IMPORTED_MODULE_0__polyfills_objectValues_mjs__["a" /* default */])(newType.getFields()));

  for (var _i34 = 0, _fieldsDiff$removed4 = fieldsDiff.removed; _i34 < _fieldsDiff$removed4.length; _i34++) {
    var oldField = _fieldsDiff$removed4[_i34];
    schemaChanges.push({
      type: BreakingChangeType.FIELD_REMOVED,
      description: "".concat(oldType.name, ".").concat(oldField.name, " was removed.")
    });
  }

  for (var _i36 = 0, _fieldsDiff$persisted4 = fieldsDiff.persisted; _i36 < _fieldsDiff$persisted4.length; _i36++) {
    var _ref8 = _fieldsDiff$persisted4[_i36];
    var _oldField2 = _ref8[0];
    var newField = _ref8[1];
    schemaChanges.push.apply(schemaChanges, findArgChanges(oldType, _oldField2, newField));
    var isSafe = isChangeSafeForObjectOrInterfaceField(_oldField2.type, newField.type);

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.FIELD_CHANGED_KIND,
        description: "".concat(oldType.name, ".").concat(_oldField2.name, " changed type from ") + "".concat(String(_oldField2.type), " to ").concat(String(newField.type), ".")
      });
    }
  }

  return schemaChanges;
}

function findArgChanges(oldType, oldField, newField) {
  var schemaChanges = [];
  var argsDiff = diff(oldField.args, newField.args);

  for (var _i38 = 0, _argsDiff$removed4 = argsDiff.removed; _i38 < _argsDiff$removed4.length; _i38++) {
    var oldArg = _argsDiff$removed4[_i38];
    schemaChanges.push({
      type: BreakingChangeType.ARG_REMOVED,
      description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(oldArg.name, " was removed.")
    });
  }

  for (var _i40 = 0, _argsDiff$persisted2 = argsDiff.persisted; _i40 < _argsDiff$persisted2.length; _i40++) {
    var _ref10 = _argsDiff$persisted2[_i40];
    var _oldArg = _ref10[0];
    var newArg = _ref10[1];
    var isSafe = isChangeSafeForInputObjectFieldOrFieldArg(_oldArg.type, newArg.type);

    if (!isSafe) {
      schemaChanges.push({
        type: BreakingChangeType.ARG_CHANGED_KIND,
        description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " has changed type from ") + "".concat(String(_oldArg.type), " to ").concat(String(newArg.type), ".")
      });
    } else if (_oldArg.defaultValue !== undefined) {
      if (newArg.defaultValue === undefined) {
        schemaChanges.push({
          type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
          description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " defaultValue was removed.")
        });
      } else {
        // Since we looking only for client's observable changes we should
        // compare default values in the same representation as they are
        // represented inside introspection.
        var oldValueStr = stringifyValue(_oldArg.defaultValue, _oldArg.type);
        var newValueStr = stringifyValue(newArg.defaultValue, newArg.type);

        if (oldValueStr !== newValueStr) {
          schemaChanges.push({
            type: DangerousChangeType.ARG_DEFAULT_VALUE_CHANGE,
            description: "".concat(oldType.name, ".").concat(oldField.name, " arg ").concat(_oldArg.name, " has changed defaultValue from ").concat(oldValueStr, " to ").concat(newValueStr, ".")
          });
        }
      }
    }
  }

  for (var _i42 = 0, _argsDiff$added4 = argsDiff.added; _i42 < _argsDiff$added4.length; _i42++) {
    var _newArg = _argsDiff$added4[_i42];

    if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["A" /* isRequiredArgument */])(_newArg)) {
      schemaChanges.push({
        type: BreakingChangeType.REQUIRED_ARG_ADDED,
        description: "A required arg ".concat(_newArg.name, " on ").concat(oldType.name, ".").concat(oldField.name, " was added.")
      });
    } else {
      schemaChanges.push({
        type: DangerousChangeType.OPTIONAL_ARG_ADDED,
        description: "An optional arg ".concat(_newArg.name, " on ").concat(oldType.name, ".").concat(oldField.name, " was added.")
      });
    }
  }

  return schemaChanges;
}

function isChangeSafeForObjectOrInterfaceField(oldType, newType) {
  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(oldType)) {
    return (// if they're both lists, make sure the underlying types are compatible
      Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType) || // moving from nullable to non-null of the same underlying type is safe
      Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
    );
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(oldType)) {
    // if they're both non-null, make sure the underlying types are compatible
    return Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType.ofType, newType.ofType);
  }

  return (// if they're both named types, see if their names are equivalent
    Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["w" /* isNamedType */])(newType) && oldType.name === newType.name || // moving from nullable to non-null of the same underlying type is safe
    Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(newType) && isChangeSafeForObjectOrInterfaceField(oldType, newType.ofType)
  );
}

function isChangeSafeForInputObjectFieldOrFieldArg(oldType, newType) {
  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(oldType)) {
    // if they're both lists, make sure the underlying types are compatible
    return Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["v" /* isListType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType);
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(oldType)) {
    return (// if they're both non-null, make sure the underlying types are
      // compatible
      Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType.ofType) || // moving from non-null to nullable of the same underlying type is safe
      !Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["x" /* isNonNullType */])(newType) && isChangeSafeForInputObjectFieldOrFieldArg(oldType.ofType, newType)
    );
  } // if they're both named types, see if their names are equivalent


  return Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["w" /* isNamedType */])(newType) && oldType.name === newType.name;
}

function typeKindName(type) {
  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["C" /* isScalarType */])(type)) {
    return 'a Scalar type';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["y" /* isObjectType */])(type)) {
    return 'an Object type';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["t" /* isInterfaceType */])(type)) {
    return 'an Interface type';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["E" /* isUnionType */])(type)) {
    return 'a Union type';
  }

  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["q" /* isEnumType */])(type)) {
    return 'an Enum type';
  } // istanbul ignore else (See: 'https://github.com/graphql/graphql-js/issues/2618')


  if (Object(__WEBPACK_IMPORTED_MODULE_8__type_definition_mjs__["r" /* isInputObjectType */])(type)) {
    return 'an Input type';
  } // istanbul ignore next (Not reachable. All possible named types have been considered)


  false || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__["a" /* default */])(0, 'Unexpected type: ' + Object(__WEBPACK_IMPORTED_MODULE_2__jsutils_inspect_mjs__["a" /* default */])(type));
}

function stringifyValue(value, type) {
  var ast = Object(__WEBPACK_IMPORTED_MODULE_9__astFromValue_mjs__["a" /* astFromValue */])(value, type);
  ast != null || Object(__WEBPACK_IMPORTED_MODULE_3__jsutils_invariant_mjs__["a" /* default */])(0);
  var sortedAST = Object(__WEBPACK_IMPORTED_MODULE_6__language_visitor_mjs__["b" /* visit */])(ast, {
    ObjectValue: function ObjectValue(objectNode) {
      // Make a copy since sort mutates array
      var fields = [].concat(objectNode.fields);
      fields.sort(function (fieldA, fieldB) {
        return Object(__WEBPACK_IMPORTED_MODULE_4__jsutils_naturalCompare_mjs__["a" /* default */])(fieldA.name.value, fieldB.name.value);
      });
      return _objectSpread(_objectSpread({}, objectNode), {}, {
        fields: fields
      });
    }
  });
  return Object(__WEBPACK_IMPORTED_MODULE_5__language_printer_mjs__["a" /* print */])(sortedAST);
}

function diff(oldArray, newArray) {
  var added = [];
  var removed = [];
  var persisted = [];
  var oldMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(oldArray, function (_ref11) {
    var name = _ref11.name;
    return name;
  });
  var newMap = Object(__WEBPACK_IMPORTED_MODULE_1__jsutils_keyMap_mjs__["a" /* default */])(newArray, function (_ref12) {
    var name = _ref12.name;
    return name;
  });

  for (var _i44 = 0; _i44 < oldArray.length; _i44++) {
    var oldItem = oldArray[_i44];
    var newItem = newMap[oldItem.name];

    if (newItem === undefined) {
      removed.push(oldItem);
    } else {
      persisted.push([oldItem, newItem]);
    }
  }

  for (var _i46 = 0; _i46 < newArray.length; _i46++) {
    var _newItem = newArray[_i46];

    if (oldMap[_newItem.name] === undefined) {
      added.push(_newItem);
    }
  }

  return {
    added: added,
    persisted: persisted,
    removed: removed
  };
}


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export findDeprecatedUsages */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__validation_validate_mjs__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__validation_rules_custom_NoDeprecatedCustomRule_mjs__ = __webpack_require__(586);


/**
 * A validation rule which reports deprecated usages.
 *
 * Returns a list of GraphQLError instances describing each deprecated use.
 *
 * @deprecated Please use `validate` with `NoDeprecatedCustomRule` instead:
 *
 * ```
 * import { validate, NoDeprecatedCustomRule } from 'graphql'
 *
 * const errors = validate(schema, document, [NoDeprecatedCustomRule])
 * ```
 */

function findDeprecatedUsages(schema, ast) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__validation_validate_mjs__["c" /* validate */])(schema, ast, [__WEBPACK_IMPORTED_MODULE_1__validation_rules_custom_NoDeprecatedCustomRule_mjs__["a" /* NoDeprecatedCustomRule */]]);
}


/***/ }),
/* 901 */,
/* 902 */,
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"mycustomer"}},[_c('div',{staticClass:"clearfix gibson mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix py3"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine kunder")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 pl0",staticStyle:{"background":"transparent"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 gibson dark-button not-rounded flex justify-center items-center line-height-1"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 gibson dark-button not-rounded flex justify-center items-center line-height-1"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"m2m"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                    Vælg\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2"},[_c('div',[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortByStatus","name":"sortByStatus","value":"10"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Mester til Mester")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortByHaveWork","name":"sortByHaveWork","value":"9"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("private")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"8"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Med Tilbud")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"7"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Uden Tilbud")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('hr')]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortByStatus","name":"sortByStatus","value":"0"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Ny opgave")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortByHaveWork","name":"sortByHaveWork","value":"1"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("I dialog")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"2"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Tilbud er sendt")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"3"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Vandt opgaven")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"4"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Opgaven er udført")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"5"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Vandt ikke opgaven")])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"sortByquickoffer","name":"sortByquickoffer","value":"100"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Kan ikke afgive tilbud")])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"line-height-1 mb2",attrs:{"id":"ikkerelevant","name":"ikkerelevant","value":"12"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml0 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("ikke relevant")])])],1)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 gibson not-rounded flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.toggleFilter(_vm.status)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                    Tilpas rækkefølgen\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{staticClass:"line-height-2 mb2",attrs:{"id":"sortByDate","aria-describedby":ariaDescribedby,"name":"sortByDate","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Sorter efter mødedato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{staticClass:"line-height-2 mb2",attrs:{"id":"sortByStatus","aria-describedby":ariaDescribedby,"name":"sortByStatus","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Sorter efter status")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{staticClass:"line-height-2 mb2",attrs:{"id":"offerSent","aria-describedby":ariaDescribedby,"name":"offerSent","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Sorter efter sendt tilbud dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{staticClass:"line-height-2 mb2",attrs:{"id":"followUp","aria-describedby":ariaDescribedby,"name":"followUp","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h5 regular relative m0"},[_vm._v("Sorter efter opfølgningsdato")])])],1)]}}],null,false,1389701097)}),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 gibson not-rounded line-height-1",on:{"click":function($event){return _vm.toggleSort(_vm.statusDate)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),(_vm.browserName !== 'safari')?_c('div',{staticClass:"flex flex-column col-12 p0 m0 my2"},[_c('p',{staticClass:"col-12 h5 semi-bold darkblue center p0"},[_vm._v("Oversigt over dine kunder om åretss")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start",staticStyle:{"overflow":"auto","white-space":"nowrap"}},_vm._l((_vm.allyear),function(item,index){return _c('button',{key:index,staticClass:"primary-button-green pointer regular h5 white p2 mr1",staticStyle:{"width":"100%"},attrs:{"id":'yearfilter-' + item},on:{"click":function($event){return _vm.filteryear(item)}}},[_vm._v(_vm._s(item)+"\n              ")])}),0)]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 p0 m0"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 pl0",staticStyle:{"background":"transparent"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6 right",attrs:{"id":"m2m"}},[_c('div',{staticClass:" my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\n                    Vælg\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2"},[_c('div',{staticClass:"col-6 px0"},[_c('b-form-checkbox',{attrs:{"id":"sortByStatusxxl1","name":"sortByStatusxxl1","value":"10"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Mester til Mester")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWorkxxl1","name":"sortByHaveWorkxxl1","value":"9"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("private")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl1","name":"sortByNeedeWorkxxl1","value":"8"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Med Tilbud")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl2","name":"sortByNeedeWorkxxl2","value":"7"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Uden Tilbud")])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByquickofferl2","name":"sortByquickofferl2","value":"100"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Kan ikke afgive tilbud")])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"ikkerelevant","name":"ikkerelevant","value":"12"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("ikke relevant")])])],1),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByStatusxxl2","name":"sortByStatusxxl2","value":"0"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Ny opgave")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWorkxxl2","name":"sortByHaveWorkxxl2","value":"1"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("I dialog")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl3","name":"sortByNeedeWorkxxl3","value":"2"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Tilbud er sendt")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl4","name":"sortByNeedeWorkxxl4","value":"3"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Vandt opgaven")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl5","name":"sortByNeedeWorkxxl5","value":"4"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Opgaven er udført")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl6","name":"sortByNeedeWorkxxl6","value":"5"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml0 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Vandt ikke opgaven")])])],1)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.toggleFilter(_vm.status)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6",attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\n                    Tilpas rækkefølgen\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"sortByDatexxl","aria-describedby":ariaDescribedby,"name":"sortByDatexxl","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter mødedato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sortByStatusxxl","aria-describedby":ariaDescribedby,"name":"sortByStatusxxl","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter status")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"offerSentxxl","aria-describedby":ariaDescribedby,"name":"offerSentxxl","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter sendt tilbud dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"followUpxxl","aria-describedby":ariaDescribedby,"name":"followUpxxl","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter opfølgningsdato")])])],1)]}}],null,false,3558414313)}),_vm._v(" "),_c('div',{staticClass:"pb5"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded",on:{"click":function($event){return _vm.toggleSort(_vm.statusDate)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),(_vm.browserName !== 'safari')?_c('div',{staticClass:"flex col-12 p0 m0 my2"},[_c('p',{staticClass:"h5 semi-bold darkblue p0 pr2"},[_vm._v("Oversigt over dine kunder om året")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[[_c('el-select',{attrs:{"id":'yearfilter-' + _vm.activeyear,"placeholder":"Select"},on:{"change":function($event){return _vm.filteryear(_vm.activeyear)}},model:{value:(_vm.activeyear),callback:function ($$v) {_vm.activeyear=$$v},expression:"activeyear"}},_vm._l((_vm.allyear),function(item,index){return _c('el-option',{key:index,attrs:{"label":item,"value":item}})}),1)]],2)]):_vm._e()],1):_vm._e()])])]),_vm._v(" "),(_vm.totalitems > 0)?_c('div',{staticClass:"flex justify-start p0 mb1"},[_c('el-pagination',{staticClass:"m0 p0",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":_vm.totalitems},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(2)]):_c('div',[_c('div',{staticClass:" flex flex-wrap justify-start",staticStyle:{"gap":"1.5em"}},[_vm._l((_vm.SearchItembitrix),function(itemb,index){return (itemb.PROJECT_ID > 6000 && ((itemb.CONTRACT_TYPE === 'Fagentreprise' && itemb.PARENT_PROJECT.ID !== null) || (itemb.CONTRACT_TYPE === 'Hovedentreprise' && itemb.JOBS_LIST && itemb.JOBS_LIST.length > 0)) )?_c('div',{key:itemb.ID,staticClass:"flex items-stretch relative ",staticStyle:{"width":"350px"}},[_c('div',{staticClass:"col-12 border muted-border p2 shadow"},[_c('div',{staticClass:"clearfix mb1"},[_c('div',{staticClass:"col-12 p0 darkblue flex flex-column justify-start items-start mb1"},[_c('div',{staticClass:"flex flex-row col-12 p0 "},[_c('div',{staticClass:"col-6 mr-auto p0"},[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_c('div',{staticClass:"col-6 p0 flex items-center"},[_c('el-select',{staticClass:" col-12 px0 white-background border-none darkblue semi-bold not-rounded",attrs:{"placeholder":"Vælg"},on:{"change":function($event){return _vm.updateJobsStatus(itemb.ID, index)}},model:{value:(_vm.valuestatus[index]),callback:function ($$v) {_vm.$set(_vm.valuestatus, index, $$v)},expression:"valuestatus[index]"}},_vm._l((itemb.STATUS),function(items){return _c('el-option',{key:items.ID,attrs:{"label":items.TITLE_DK,"value":items.ID}})}),1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"darkblue mb1 flex col-12 p0 pointer"},[_c('div',{staticClass:"col-11 m0 p0 flex flex-column"},[_c('p',{staticClass:"h5 darkblue semi-bold m0 line-height-golden"},[_vm._v("\n                    "+_vm._s(itemb.CUSTOMER_NAME)+"\n                  ")]),_vm._v(" "),(itemb.PROJECT_ADDRESS.length > 0)?_c('div',{staticClass:"darkblue semi-bold flex p0 m0 mt1"},[_vm._m(3,true),_vm._v(" "),(itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null)?_c('span',{staticClass:"font13 darkblue no-underline regular",staticStyle:{"max-lines":"2"},attrs:{"target":"_blank"}},[_vm._v("\n                      "+_vm._s((itemb.PROJECT_ZIP ? itemb.PROJECT_ZIP : ''))+" "+_vm._s(' ' + (itemb.PROJECT_CITY ? itemb.PROJECT_CITY : ''))+"\n                    ")]):_c('a',{staticClass:"font13 darkblue no-underline regular",staticStyle:{"max-lines":"2"},attrs:{"target":"_blank","href":'https://www.google.com/maps/search/?api=1&query=' + itemb.PROJECT_ADDRESS}},[_vm._v("\n                      "+_vm._s(itemb.PROJECT_ADDRESS)+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[(itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null)?_c('a',{staticClass:"font13 regular no-underline mb1",attrs:{"type":"button","href":'mailto:'}},[_c('span',{staticClass:"font13 primarycolor flex items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"10","viewBox":"0 0 24.337 15.571"}},[_c('path',{attrs:{"id":"Beskeder","d":"M-919.1-96.429a1.854,1.854,0,0,1-1.9-1.8V-110.2a1.854,1.854,0,0,1,1.9-1.8h2.519a.463.463,0,0,1,.476.45.463.463,0,0,1-.476.45H-919.1c-.025,0-.049,0-.073,0l8.9,8.429a2.114,2.114,0,0,0,2.871,0l6.626-6.272h-5.25a.463.463,0,0,1-.476-.45.464.464,0,0,1,.476-.451h6.2l1.328-1.257c-.024,0-.049,0-.073,0h-13.781a.463.463,0,0,1-.475-.45.463.463,0,0,1,.475-.45h13.781a1.854,1.854,0,0,1,1.9,1.8v11.972a1.854,1.854,0,0,1-1.9,1.8Zm-.245-.931a.988.988,0,0,0,.245.032h20.534a.98.98,0,0,0,.245-.032l-6.668-6.314-1.736,1.643a3.059,3.059,0,0,1-2.107.825,3.062,3.062,0,0,1-2.109-.825l-1.735-1.643Zm15.029-6.95L-897.647-98a.839.839,0,0,0,.033-.232V-110.2a.86.86,0,0,0-.086-.372ZM-920.05-110.2v11.972a.846.846,0,0,0,.033.232l6.669-6.313-6.616-6.263A.847.847,0,0,0-920.05-110.2Zm12.026,2.039a.565.565,0,0,1-.565-.564.564.564,0,0,1,.565-.564h.008a.564.564,0,0,1,.565.564.565.565,0,0,1-.565.564Zm-6.4-2.71a.564.564,0,0,1-.564-.564.564.564,0,0,1,.564-.563h.007a.563.563,0,0,1,.564.563.564.564,0,0,1-.564.564Z","transform":"translate(921 112)","fill":"#19a3c0"}})]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v(_vm._s(_vm.hideemail(itemb.CUSTOMER_EMAIL)))])])]):_c('a',{staticClass:"font13 regular no-underline mb1",attrs:{"type":"button","href":'mailto:'+ itemb.CUSTOMER_EMAIL}},[_c('span',{staticClass:"font13 primarycolor flex items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"10","viewBox":"0 0 24.337 15.571"}},[_c('path',{attrs:{"id":"Beskeder","d":"M-919.1-96.429a1.854,1.854,0,0,1-1.9-1.8V-110.2a1.854,1.854,0,0,1,1.9-1.8h2.519a.463.463,0,0,1,.476.45.463.463,0,0,1-.476.45H-919.1c-.025,0-.049,0-.073,0l8.9,8.429a2.114,2.114,0,0,0,2.871,0l6.626-6.272h-5.25a.463.463,0,0,1-.476-.45.464.464,0,0,1,.476-.451h6.2l1.328-1.257c-.024,0-.049,0-.073,0h-13.781a.463.463,0,0,1-.475-.45.463.463,0,0,1,.475-.45h13.781a1.854,1.854,0,0,1,1.9,1.8v11.972a1.854,1.854,0,0,1-1.9,1.8Zm-.245-.931a.988.988,0,0,0,.245.032h20.534a.98.98,0,0,0,.245-.032l-6.668-6.314-1.736,1.643a3.059,3.059,0,0,1-2.107.825,3.062,3.062,0,0,1-2.109-.825l-1.735-1.643Zm15.029-6.95L-897.647-98a.839.839,0,0,0,.033-.232V-110.2a.86.86,0,0,0-.086-.372ZM-920.05-110.2v11.972a.846.846,0,0,0,.033.232l6.669-6.313-6.616-6.263A.847.847,0,0,0-920.05-110.2Zm12.026,2.039a.565.565,0,0,1-.565-.564.564.564,0,0,1,.565-.564h.008a.564.564,0,0,1,.565.564.565.565,0,0,1-.565.564Zm-6.4-2.71a.564.564,0,0,1-.564-.564.564.564,0,0,1,.564-.563h.007a.563.563,0,0,1,.564.563.564.564,0,0,1-.564.564Z","transform":"translate(921 112)","fill":"#19a3c0"}})]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v(_vm._s(itemb.CUSTOMER_EMAIL))])])]),_vm._v(" "),(itemb.CONTACT_FAKE_PHONE !== null && itemb.CONTACT_FAKE_PHONE !== '' && itemb.CALL_DATE === null)?_c('a',{staticClass:"font13 regular no-underline",attrs:{"type":"button","href":'tel:' + itemb.CONTACT_FAKE_PHONE}},[_c('span',{staticClass:"font13 primarycolor"},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"fill":"currentColor","height":"14","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v("+45 "+_vm._s(itemb.CONTACT_FAKE_PHONE))])]):_c('a',{staticClass:"font13 regular no-underline",attrs:{"type":"button","href":'tel:' + itemb.CUSTOMER_MOBILE}},[_c('span',{staticClass:"font13 primarycolor"},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"fill":"currentColor","height":"14","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v("+45 "+_vm._s(itemb.CUSTOMER_MOBILE))])])]),_vm._v(" "),_c('a',{staticClass:"primarycolor h6 regular pointer mt1",attrs:{"type":"button"},on:{"click":function($event){return _vm.projectdesctionopen(itemb.PROJECT_DESCRIPTION, itemb.PROJECT_NAME)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","height":"14","viewBox":"0 0 41.182 47.344"}},[_c('g',{attrs:{"id":"description","transform":"translate(0)"}},[_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M72.982,6.426,67.29.734A2.491,2.491,0,0,0,65.518,0h-18.4a2.509,2.509,0,0,0-2.507,2.507v5.52H35.041a2.509,2.509,0,0,0-2.507,2.507V26.606a.948.948,0,0,0,1.894,0V10.533a.614.614,0,0,1,.613-.613H53.034v4.233a2.51,2.51,0,0,0,2.507,2.507h4.2V44.837a.614.614,0,0,1-.613.613H35.041a.614.614,0,0,1-.613-.613V34.359a.948.948,0,0,0-1.894,0V44.837a2.509,2.509,0,0,0,2.507,2.507H59.128a2.509,2.509,0,0,0,2.507-2.507v-5.52H71.21a2.509,2.509,0,0,0,2.507-2.507V8.2a2.491,2.491,0,0,0-.734-1.773Zm-2.365.314H67.623a.614.614,0,0,1-.613-.613V3.132Zm-15.69,7.414V11.159l3.608,3.608H55.541A.614.614,0,0,1,54.928,14.153ZM71.21,37.423H61.634v-21.2a2.49,2.49,0,0,0-.734-1.773L55.208,8.761a2.491,2.491,0,0,0-1.773-.734H46.51V2.507a.614.614,0,0,1,.613-.613H65.116V6.127a2.51,2.51,0,0,0,2.507,2.507h4.2V36.81a.614.614,0,0,1-.613.613Z","transform":"translate(-32.534 0)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M90.687,195.221h6.54a.948.948,0,0,0,0-1.894h-6.54a.948.948,0,0,0,0,1.894Z","transform":"translate(-84.354 -175.02)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_397","data-name":"Path 397","d":"M90.687,237.113h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,237.113Z","transform":"translate(-84.354 -212.946)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_398","data-name":"Path 398","d":"M90.687,281.611h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,281.611Z","transform":"translate(-84.354 -253.23)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_399","data-name":"Path 399","d":"M90.687,324.8h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,324.8Z","transform":"translate(-84.354 -292.334)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_400","data-name":"Path 400","d":"M90.687,368h16.331a.948.948,0,0,0,0-1.894H90.687A.948.948,0,0,0,90.687,368Z","transform":"translate(-84.354 -331.438)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_401","data-name":"Path 401","d":"M33.558,313.686a.947.947,0,1,0-.653-1.632.957.957,0,0,0,.653,1.632Z","transform":"translate(-32.611 -282.275)","fill":"#19a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v(" Se beskrivels")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0 flex items-center relative",staticStyle:{"height":"53px"}},[(itemb.PROJECT_NAME.length  > 109)?_c('el-tooltip',{attrs:{"content":"","id":"projectTitle","placement":"top","effect":"light"}},[_c('template',{slot:"content"},[_c('div',{},[_vm._v("\n                  "+_vm._s(itemb.PROJECT_NAME)+"\n                ")])]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold darkblue"},[_vm._v(_vm._s(_vm._f("truncate")(itemb.PROJECT_NAME,110, '...')))])],2):_c('p',{staticClass:"h6 semi-bold darkblue"},[_vm._v(_vm._s(itemb.PROJECT_NAME))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0 mb2 pb2 darkblue flex border border-top-0 border-left-0 border-right-0 muted-border"},[_c('button',{staticClass:"px2 px1 col-5 outlined-standard-button flex items-center rounded",on:{"click":function($event){return _vm.opennotes(itemb.NOTES, itemb.ID)}}},[_c('span',{staticClass:"pr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"18.582","height":"16.082","viewBox":"0 0 34.021 34.02"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1452","data-name":"Rectangle 1452","width":"34.021","height":"34.02","transform":"translate(0 0)","fill":"#134553"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"note","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4217","data-name":"Path 4217","d":"M12.359,0h.8a1.506,1.506,0,0,0,.183.066,2.711,2.711,0,0,1,1.7,1.124.482.482,0,0,0,.465.227c.7-.009,1.395-.009,2.092,0a2.166,2.166,0,0,1,2.044,1.231A.474.474,0,0,0,20,2.832c1.052.015,2.1,0,3.155.011a3.081,3.081,0,0,1,.724.064A2.1,2.1,0,0,1,25.512,5.05c.007,1.627,0,3.255,0,4.882v.33l.1.038c.734-.752,1.44-1.536,2.21-2.25a3.708,3.708,0,0,1,5.021,5.457q-3.526,3.543-7.072,7.066a.808.808,0,0,0-.269.632q.014,5.281,0,10.561a2.124,2.124,0,0,1-2.219,2.251q-10.545.008-21.09-.008a2.759,2.759,0,0,1-1.05-.25A2.161,2.161,0,0,1,0,32.226V4.652C.542,3.194,1.051,2.841,2.609,2.841c.962,0,1.923-.006,2.885,0a.4.4,0,0,0,.428-.261A1.941,1.941,0,0,1,7.561,1.451a16.44,16.44,0,0,1,1.888-.029A1.273,1.273,0,0,0,10.74.889,2.626,2.626,0,0,1,12.359,0M24.1,22.272c-.16.152-.248.234-.333.319-1.315,1.315-2.623,2.638-3.952,3.939a1.808,1.808,0,0,1-.759.434c-1.216.33-2.44.631-3.665.925a12.71,12.71,0,0,1-2.168.447c-1.247.074-2.5.021-3.752.02-.62,0-.965-.259-.962-.717s.344-.709.97-.71c1.041,0,2.082-.008,3.122.006.247,0,.34-.076.4-.315.264-1.119.55-2.232.828-3.348.047-.187.091-.374.144-.6h-.415c-1.406,0-2.812,0-4.218,0-.507,0-.834-.292-.828-.71s.332-.692.844-.7c.077,0,.155,0,.233,0,1.572,0,3.144.006,4.717-.009a.765.765,0,0,0,.482-.2c1.278-1.258,2.543-2.53,3.811-3.8.064-.064.118-.138.21-.245H9.518c-.1,0-.2,0-.3,0a.7.7,0,1,1,.02-1.4c.088-.006.177,0,.266,0H19.569a1.331,1.331,0,0,1,.4.022.348.348,0,0,0,.4-.128c1.179-1.186,2.366-2.362,3.538-3.555a.77.77,0,0,0,.193-.487c.015-1.417.009-2.834.009-4.251,0-.7.007-1.4,0-2.093a.753.753,0,0,0-.862-.852c-1.041,0-2.081,0-3.122,0-.084,0-.168.015-.269.025,0,.234.015.446,0,.654a.715.715,0,0,1-.775.731c-.188.007-.376,0-.565,0q-5.962,0-11.925,0c-.651,0-.9-.255-.913-.9,0-.162,0-.324,0-.513H2.409c-.759,0-1,.234-1,.986q0,13.187,0,26.373c0,.755.239.994.993.994H23.1c.772,0,1-.235,1-1.017q0-4.451,0-8.9v-.416m5.269-7.4-3.159-3.157-9.9,9.9a5.961,5.961,0,0,1,3.166,3.151l9.888-9.889M7.133,4.235H18.422c0-.159,0-.3,0-.441,0-.729-.224-.952-.949-.954-.841,0-1.682-.008-2.524,0a.884.884,0,0,1-.912-.57,1.391,1.391,0,0,0-2.559,0,.885.885,0,0,1-.91.573c-.752-.011-1.506.024-2.258-.009-1.225-.055-1.268.4-1.2,1.353,0,.009.01.018.027.048m23.381,9.629c.542-.567,1.139-1.117,1.646-1.74a2.276,2.276,0,0,0-3.15-3.2c-.636.505-1.19,1.114-1.763,1.659l3.267,3.279M18.325,25.694a4.6,4.6,0,0,0-2.914-2.909l-.969,3.882,3.883-.973","transform":"translate(0 -0.001)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4218","data-name":"Path 4218","d":"M109.374,119.175q3.021,0,6.042,0a2.283,2.283,0,0,1,.493.046.688.688,0,0,1,0,1.331,1.9,1.9,0,0,1-.427.046q-6.125,0-12.25,0c-.622,0-.965-.256-.965-.713s.343-.713.965-.713h6.142","transform":"translate(-93.758 -109.258)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4219","data-name":"Path 4219","d":"M34.188,104.336a2.12,2.12,0,1,1,2.117,2.139,2.126,2.126,0,0,1-2.117-2.139m2.812.03a.7.7,0,0,0-.673-.714.717.717,0,0,0-.726.7.724.724,0,0,0,.7.7.7.7,0,0,0,.7-.688","transform":"translate(-31.343 -93.72)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4220","data-name":"Path 4220","d":"M34.187,308.737a2.12,2.12,0,1,1,2.117,2.14,2.126,2.126,0,0,1-2.117-2.14m2.812.018a.7.7,0,0,0-.686-.7.7.7,0,1,0,0,1.4.7.7,0,0,0,.69-.7","transform":"translate(-31.342 -281.112)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4221","data-name":"Path 4221","d":"M36.313,174.585a2.121,2.121,0,0,1-.021-4.242,2.121,2.121,0,1,1,.021,4.242m0-2.812a.709.709,0,0,0-.715.676.727.727,0,0,0,.708.724.71.71,0,0,0,.692-.7.69.69,0,0,0-.685-.7","transform":"translate(-31.342 -156.168)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4222","data-name":"Path 4222","d":"M34.179,240.689a2.121,2.121,0,0,1,4.241.014,2.121,2.121,0,1,1-4.241-.014m2.814,0a.711.711,0,0,0-.7-.7.73.73,0,0,0-.706.694.709.709,0,0,0,.72.705.69.69,0,0,0,.682-.7","transform":"translate(-31.335 -218.725)","fill":"#134553"}})])])]),_vm._v(" "),_c('p',{staticClass:"regular small h6 p0 m0"},[_vm._v("DINE NOTATER")])]),_vm._v(" "),_c('button',{staticClass:"px2 py1 ml-auto col-6 primary-button flex items-center rounded justify-center",on:{"click":function($event){return _vm.seeTenderFile(itemb)}}},[_c('span',{staticClass:"pr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18.582","height":"16.082","viewBox":"0 0 18.582 16.082"}},[_c('path',{attrs:{"id":"tender_folder_ic","d":"M3.324,15.531a.351.351,0,1,1,.351.351A.351.351,0,0,1,3.324,15.531Zm12.78.245c-4.205,0-6.492,0-10.7,0-.146,0-.279-.02-.344-.172a.259.259,0,0,1,.195-.356,1.211,1.211,0,0,1,.214-.01l10.518.006c.366,0,.426-.06.426-.429V4.676a.639.639,0,0,0-.1-.427.519.519,0,0,0-.448-.177H13.711c-1.964,0-3.926-.008-5.894,0A1.724,1.724,0,0,1,6.21,3.214a1.335,1.335,0,0,0-1.283-.683q-1.744.034-3.486,0C.827,2.519.5,2.741.5,3.462q.006,5.56.006,11.12c0,.473.172.643.651.643h.9c.216,0,.331.1.331.269s-.112.268-.33.268q-.5,0-.988,0c-.556,0-1.071-.238-1.071-.8L.029,2.956a1.106,1.106,0,0,1,1.219-.95c.123,0,.147-.046.147-.157a3.522,3.522,0,0,1,.026-.77A1.335,1.335,0,0,1,2.731.01Q4.666-.01,6.6.01A1.617,1.617,0,0,1,7.97.766c.058.084.112.169.17.253a1.142,1.142,0,0,0,.988.519h2.208a.874.874,0,0,1,.162,0,.257.257,0,0,1,.233.273.253.253,0,0,1-.248.259,1.19,1.19,0,0,1-.126,0c-.958,0-1.214-.006-2.173,0A1.693,1.693,0,0,1,7.649,1.25,1.342,1.342,0,0,0,6.882.589a1.624,1.624,0,0,0-.426-.05H2.862a.828.828,0,0,0-.929.928c0,.126.012.245,0,.377S1.975,2,2.1,2c.426,0,.854,0,1.282,0,.555,0,1.11,0,1.666,0a1.676,1.676,0,0,1,1.56.843,1.376,1.376,0,0,0,1.313.7c2.646-.014,5.295-.006,7.942-.006a1.008,1.008,0,0,1,1.063.732,1.547,1.547,0,0,1,.038.427q0,4.179,0,8.358c0,.159.038.209.2.193.13-.012.264,0,.4,0,.2,0,.288-.1.294-.3V2.677c0-.442-.159-.6-.607-.6H14.69a1.247,1.247,0,0,1-.179,0,.266.266,0,0,1-.027-.524.71.71,0,0,1,.179-.009h2.473c.739,0,1.246.11,1.246.822v10.8c0,.3-.188.618-1.013.619-.43,0-.414,0-.414.415,0,.243,0,.49,0,.735a.8.8,0,0,1-.8.845ZM12.67,2.154a.408.408,0,0,1-.351-.357.408.408,0,0,1,.351-.357h.681a.388.388,0,0,1,.33.357.388.388,0,0,1-.33.357Z","transform":"translate(0.1 0.1)","fill":"#fff","stroke":"#fff","stroke-width":"0.2"}})])]),_vm._v(" "),_c('p',{staticClass:"regular small h6 p0 m0"},[_vm._v("UDBUDSMATERIALE")])])]),_vm._v(" "),(itemb.OFFER_STATUS === 'accepted')?_c('div',{staticClass:"col-12 mb1 p0"},[_c('button',{staticClass:"kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1 rounded",on:{"click":function($event){return _vm.showprojectdash(itemb)}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"18","viewBox":"0 0 13.366 13.228"}},[_c('path',{attrs:{"id":"Styr_Projekt","data-name":"Projekt admin","d":"M9.651,13.131a1.646,1.646,0,0,1-.557.1H1.654A1.656,1.656,0,0,1,0,11.574V1.655A1.656,1.656,0,0,1,1.654,0H6.633a.417.417,0,0,1,.289.135l3.706,3.706.019.02a.414.414,0,0,1,.1.273V8.649a4,4,0,0,1,2.574,2.089.414.414,0,0,1,0,.371c-.043.086-1.081,2.119-2.97,2.119A2.584,2.584,0,0,1,9.651,13.131ZM8.23,10.922A2.813,2.813,0,0,0,10.352,12.4a2.8,2.8,0,0,0,2.123-1.476,2.812,2.812,0,0,0-2.123-1.478A2.8,2.8,0,0,0,8.23,10.922ZM.828,1.655v9.92a.827.827,0,0,0,.826.826H8.381a4.868,4.868,0,0,1-1-1.291.418.418,0,0,1,0-.371,3.99,3.99,0,0,1,2.6-2.093l-.063.01V4.548H6.615A.415.415,0,0,1,6.2,4.134V.828H1.654A.828.828,0,0,0,.828,1.655ZM10,8.643h0Zm.454-.022h0Zm-.022,0h0Zm-.023,0h0Zm-.023,0h0Zm-.061,0h0Zm.032,0h0ZM7.029,3.72H9.335L7.029,1.413Zm2.2,7.2a1.123,1.123,0,1,1,1.123,1.123A1.124,1.124,0,0,1,9.23,10.924Zm.828,0a.3.3,0,1,0,.295-.3A.3.3,0,0,0,10.058,10.924ZM2.9,9.8a.414.414,0,1,1,0-.828H5.657a.414.414,0,1,1,0,.828Zm0-2.069a.414.414,0,1,1,0-.828H7.727a.414.414,0,0,1,0,.828Zm0-2.559a.414.414,0,1,1,0-.828h1.24a.414.414,0,1,1,0,.828Z","fill":"#19a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start"},[_vm._v("Projektadministration")])])]):(itemb.OFFER_STATUS === null)?_c('div',{staticClass:"col-12 mb1 p0"},[_c('button',{staticClass:"kundebutton dark-button col-12 outlined-action-button p1 flex justify-center rounded items-center gibson line-height-1",attrs:{"id":"createoffer"},on:{"click":function($event){return _vm.showMeetingTilbudbitrix(itemb, 'bitrixCustomersBookingwizard')}}},[_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold center"},[_vm._v("AFGIV TILBUD")])])]):(itemb.OFFER_STATUS === 'pending'  || itemb.OFFER_STATUS === 'Failed' || itemb.OFFER_STATUS === 'failed')?_c('div',{staticClass:"col-12 mb1 p0 flex"},[_c('button',{staticClass:"kundebutton dark-button col-6 outlined-action-button p1 flex justify-center items-center gibson line-height-1 rounded",on:{"click":function($event){return _vm.getAcceptedOfferPrice(itemb.OFFER_ID, itemb.PROJECT_ID, itemb.CUSTOMER_ID, itemb.CONTRACT_TYPE, itemb.PROJECT_PARENT_ID, 0, itemb.JOBS_LIST)}}},[_c('span',{staticClass:"font14 mb0 line-height-1 semi-bold center"},[_vm._v("SE TILBUD")])]),_vm._v(" "),_c('button',{staticClass:"rounded kundebutton dark-button col-6 outlined-action-button p1 flex justify-center items-center gibson line-height-1",on:{"click":function($event){return _vm.edittilbud(itemb)}}},[_c('span',{staticClass:"font14 mb0 line-height-1 semi-bold center"},[_vm._v("REDIGER TILBUD")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 mb1 p0 flex"},[_c('button',{staticClass:"rounded kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1 rounded",on:{"click":function($event){return _vm.seeMessages(itemb.CUSTOMER_ID, itemb.ID)}}},[_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold center"},[_vm._v("Besked")])])])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.SearchItem),function(item){return ((item.id_appointment_status_support === '0' && _vm.lastpage === _vm.currentpage) || (item.id_appointment_status_support === '0' && _vm.SearchItembitrix.length < 1))?_c('div',{key:item.id,staticClass:"flex items-stretch relative ",staticStyle:{"width":"350px"}},[_c('div',{staticClass:"col-12 border muted-border p2 shadow"},[(item.henttilbud !== 1)?_c('div',{staticClass:"clearfix mb2 mt2"},[_c('div',{staticClass:"col-12 gibson darkblue flex"},[_c('div',{staticClass:"pr2 mr-auto"},[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_c('div',{staticClass:"ml-auto flex flex-column items-end"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0",staticStyle:{"margin-bottom":"5px"}},[_vm._v("\n                  "+_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL'))+"\n                ")]),_vm._v(" "),_c('p',{staticClass:"regular line-height-1 mb0"},[_vm._v("\n                  kl. "+_vm._s(item.id_times)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-8 p0 m0 flex justify-end ml-auto"},[_c('b-form-select',{staticClass:"px0 darkblue semi-bold not-rounded",attrs:{"disabled":_vm.disableStatusSelection,"id":"statusSelect2","options":item.dataStatus},on:{"change":function($event){return _vm.changeStatus($event,item)}},model:{value:(item.tilbudstatus),callback:function ($$v) {_vm.$set(item, "tilbudstatus", $$v)},expression:"item.tilbudstatus"}}),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ ok: _vm.confirmRecommendInvitation('4', item, 'yes'), cancel: _vm.confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}),expression:"{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}"}],staticClass:"hide",attrs:{"type":"button","id":'recommendInvitation-' + item.id_appointment}},[_vm._v("Recommend Invitation")])],1)]):_c('div',{staticClass:"clearfix mb1"},[_c('div',{staticClass:"col-12 p0 darkblue flex flex-column justify-start items-start mb1"},[_c('div',{staticClass:"flex flex-row col-12 p0"},[_c('div',{staticClass:"col-4 mr-auto p0 flex flex-column m0"},[_c('svg',{attrs:{"fill":"currentColor","width":"60","height":"52","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_vm._v(" "),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})]),_vm._v(" "),_c('p',{staticClass:"small m0",staticStyle:{"font-size":"9px"}},[_vm._v(_vm._s(_vm.moment(item.datereserve.split(' ')[0]).locale('da').format('LL')))])]),_vm._v(" "),_c('div',{staticClass:"col-8 p0 flex items-center justify-center flex-column"},[_c('div',{staticClass:"m0 p0 small"},[(item.newcontact != '0' || item.newcontact_pro != '0')?_c('span',{staticClass:"regular"},[_c('em',[_vm._v("Direkte fra din profilside")])]):_c('span',{staticClass:"regular"},[_c('em',[_vm._v("Reserveret fra markedspladsen")])])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":'tilbudstatusval-' + item.id_appointment},domProps:{"value":item.tilbudstatus}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0 flex justify-end"},[_c('b-form-select',{staticClass:"px0 darkblue semi-bold not-rounded",attrs:{"disabled":_vm.disableStatusSelection,"id":"statusSelect2","options":item.dataStatus},on:{"change":function($event){return _vm.changeStatus($event,item)}},model:{value:(item.tilbudstatus),callback:function ($$v) {_vm.$set(item, "tilbudstatus", $$v)},expression:"item.tilbudstatus"}}),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ ok: _vm.confirmRecommendInvitation('4', item, 'yes'), cancel: _vm.confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}),expression:"{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}"}],staticClass:"hide",attrs:{"type":"button","id":'recommendInvitation-' + item.id_appointment}},[_vm._v("Recommend Invitation")])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"darkblue mb1 flex col-12 p0 pointer",on:{"click":function($event){return _vm.getReviewIdbycustomerId(_vm.itemb.CUSTOMER_ID)}}},[_c('div',{staticClass:"col-12 m0 p0 flex flex-column"},[_c('p',{staticClass:"h5 darkblue semi-bold m0 line-height-golden"},[_vm._v("\n                    "+_vm._s(item.firstname.replace('ø', 'ø').replace('å', 'å').replace('æ;', 'æ'))+" "+_vm._s(item.lastname.replace('ø', 'ø').replace('å', 'å').replace('æ;', 'æ'))+"\n                  ")]),_vm._v(" "),(item.mailingstreet && item.mailingzip && item.mailingcity !== '0')?_c('div',{staticClass:"darkblue semi-bold flex p0 m0 mt1"},[_vm._m(4,true),_vm._v(" "),_c('a',{staticClass:"font13 darkblue no-underline regular no-hover",staticStyle:{"max-lines":"2"},attrs:{"target":"_blank","href":'https://www.google.com/maps/search/?api=1&query=' + item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity}},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")((item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity),45, '...'))+"\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[(item.mobile != null)?_c('a',{staticClass:"font13 regular no-hover",attrs:{"type":"button","href":'tel:' + item.mobile}},[_c('span',{staticClass:"font13 primarycolor"},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"fill":"currentColor","height":"14","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"}}),_vm._v(" "),_c('path',{attrs:{"d":"M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"pl1 font13 darkblue regular"},[_vm._v("+45 "+_vm._s(item.mobile))])]):_vm._e()])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 gibson "},[_c('p',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('optionsCollapse'+item.id_appointment),expression:"'optionsCollapse'+item.id_appointment"}],staticClass:"h6 primarycolor regular line-height-1 my2 flex justify-between items-center"},[_c('span',[_vm._v("Se mere information om kunden")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-6.172l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414L10 11.828z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'optionsCollapse'+item.id_appointment}},[(item.henttilbud !== 1)?_c('div',{staticClass:"col-12 px0 gibson"},[_c('div',{staticClass:"col-12 px0 flex flex-column"},[_c('a',{staticClass:"h5 darkblue semi-bold line-height-3 flex col-12 justify-start items-center px2 no-hover",attrs:{"href":'mailto:' + item.email}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"3px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"}}),_c('path',{attrs:{"d":"M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"}}),_c('path',{attrs:{"d":"M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0"},[_vm._v(_vm._s(item.email))])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[(item.potentialnameurl !== '')?_c('button',{staticClass:"mb1 outlined-button border-none px1 py2 not-rounded flex justify-start items-center",on:{"click":function($event){return _vm.prisUrlOpen(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M85.7 49c-20.2 0-36.7 16.5-36.7 36.7s16.5 36.7 36.7 36.7c20.2 0 36.7-16.5 36.7-36.7S105.9 49 85.7 49zM85.7 102c-9 0-16.3-7.3-16.3-16.3 0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3C102 94.7 94.7 102 85.7 102z"}}),_c('path',{attrs:{"d":"M499.2 265.2L279.6 45.6c-6.5-6.5-14.8-10.8-23.9-12.2L50.5 0.6C36.5-1.7 22.8 2.8 12.8 12.8 2.8 22.8-1.7 36.5 0.6 50.5l32.8 205.2c1.5 9.1 5.7 17.4 12.2 23.9l219.6 219.6c8.2 8.2 19.2 12.8 30.8 12.8 11.6 0 22.6-4.5 30.8-12.8l172.4-172.4C516.2 309.8 516.2 282.2 499.2 265.2zM484.8 312.4L312.4 484.8c-9 9-23.8 9-32.8 0L60 265.2c-3.5-3.5-5.7-7.9-6.5-12.7L20.7 47.3c-1.2-7.4 1.2-14.7 6.5-20.1 4.4-4.4 10.2-6.8 16.3-6.8 1.2 0 2.5 0.1 3.8 0.3l205.2 32.8c4.9 0.8 9.3 3 12.7 6.5l219.6 219.6v0C493.9 288.7 493.9 303.4 484.8 312.4z"}}),_c('path',{attrs:{"d":"M323.4 188.6c-4-4-10.4-4-14.4 0L188.6 309c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3L323.4 203C327.4 199.1 327.4 192.6 323.4 188.6z"}}),_c('path',{attrs:{"d":"M364.2 229.4c-4-4-10.4-4-14.4 0l-3.1 3.1c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l3.1-3.1C368.2 239.9 368.2 233.4 364.2 229.4z"}}),_c('path',{attrs:{"d":"M337.7 255.9c-4-4-10.4-4-14.4 0l-93.8 93.8c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l93.8-93.8C341.7 266.4 341.7 259.9 337.7 255.9z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0",staticStyle:{"font-weight":"600!important"}},[_vm._v("Prisoverslag")])]):_vm._e(),_vm._v(" "),(item.potentialnameurl !== '' && item.numoffile > 0)?_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.prisUrlOpenFile(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","viewBox":"-40 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m402 0h-280c-16.542969 0-30 13.457031-30 30v26h-62c-16.542969 0-30 13.457031-30 30v338.589844c.0078125.007812.015625.015625.0234375.019531.0039063 2.59375.9960935 5.144531 2.9062505 7.050781l77.40625 77.410156c1.914062 1.914063 4.472656 2.929688 7.074218 2.929688h.011719 222.578125c16.542969 0 30-13.457031 30-30v-26h62c16.542969 0 30-13.457031 30-30v-125c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v125c0 5.515625-4.484375 10-10 10h-62v-57.863281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-35.992188h29.539062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-29.539062v-36.019531h29.539062c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-29.539062v-35.988281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-36.023438h29.539062c5.523438 0 10-4.476562 10-10 0-5.519531-4.476562-10-10-10h-29.539062v-48.113281c0-3.507812-.609375-6.871094-1.71875-10h73.71875v135c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-181c0-16.542969-13.457031-30-30-30zm-324.589844 477.859375-43.269531-43.269531h29.203125c7.753906 0 14.066406 6.3125 14.066406 14.066406zm242.589844 4.140625c0 5.515625-4.484375 10-10 10h-212.589844v-43.34375c0-18.785156-15.28125-34.066406-34.066406-34.066406h-43.34375v-282.589844h300v12.105469.011719.007812 56 .011719.007812 55.972657.011718.007813 56 .011719.007812zm0-396v26h-300v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10zm-10-30h-198v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10v26zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 358.019531h-216c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h216c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 414.011719h-100.589844c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h100.589844c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m61.589844 322h153.042968c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-153.042968c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 246.011719h-216c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h216c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m61.589844 209.988281h75.519531c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10h-75.519531c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 189.988281h-88.832032c-5.523437 0-10 4.480469-10 10 0 5.523438 4.476563 10 10 10h88.832032c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 302h-16.390625c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h16.390625c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m422 246c-2.628906 0-5.210938 1.070312-7.070312 2.929688-1.859376 1.859374-2.929688 4.441406-2.929688 7.070312s1.070312 5.210938 2.929688 7.070312c1.859374 1.859376 4.441406 2.929688 7.070312 2.929688s5.210938-1.070312 7.070312-2.929688c1.859376-1.859374 2.929688-4.441406 2.929688-7.070312s-1.070312-5.210938-2.929688-7.070312c-1.859374-1.859376-4.441406-2.929688-7.070312-2.929688zm0 0"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Filer")])]):_vm._e(),_vm._v(" "),(item.comment_to_partner !== '')?_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.showMeetingDetailsCommenttext(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"}}),_c('path',{attrs:{"d":"M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"}}),_c('path',{attrs:{"d":"M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"}}),_c('path',{attrs:{"d":"M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"}}),_c('path',{attrs:{"d":"M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"}}),_c('path',{attrs:{"d":"M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"}}),_c('path',{attrs:{"d":"M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 line-height-1 mb0"},[_vm._v("Kommentar")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.showMeetingTilbud(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"}}),_c('path',{attrs:{"d":"M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"}}),_c('path',{attrs:{"d":"M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"}}),_c('path',{attrs:{"d":"M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"}}),_c('path',{attrs:{"d":"M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"}}),_c('path',{attrs:{"d":"M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"}}),_c('path',{attrs:{"d":"M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"}}),_c('path',{attrs:{"d":"M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"}}),_c('path',{attrs:{"d":"M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 ml1"},[_vm._v("Se tilbud")])]),_vm._v(" "),(item.id_appointment_status_support === '0' && item.reklamationb === 1)?_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.showMeetingDetailsAflyse(item)}}},[_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Reklamation")])]):_vm._e(),_vm._v(" "),(item.id_appointment_status_support === '0' && item.changedate === '1' && item.aflyseb === 1)?_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.showMeetingDetailsDate(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M502 56h-51.6v-6.1c0-19.3-15.7-35-35-35s-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-41v-6.1c0-19.3-15.7-35-35-35 -19.3 0-35 15.7-35 35v6.1h-51.6c-5.5 0-10 4.5-10 10v78.6 102.6C41.4 260.7 0 310.8 0 370.4c0 53.3 33.7 101.3 83.9 119.3 1.1 0.4 2.3 0.6 3.4 0.6 4.1 0 7.9-2.5 9.4-6.6 1.9-5.2-0.8-10.9-6-12.8C48.4 455.7 20 415.3 20 370.4c0-52.8 38.6-96.8 89-105.2 16.2-2.7 35-0.9 51.2 4 10.5 3.2 20.3 8.3 29.1 14.9 8.8 6.6 16.8 14.4 23.5 23.1 6.7 8.7 11.9 18.5 15 29 3.4 11.5 4.4 23.5 5.2 35.4 0.6 10.3-1.6 20.7-4.4 30.6 -2.1 7.7-5.3 15-9.5 21.8 -4.1 6.7-8.9 13-14.1 18.9 -5.3 5.9-11.3 11.3-17.9 15.8 -6.8 4.5-14.1 8-21.6 11.2 -0.9 0.4-1.8 0.8-2.7 1.2 -5.2 1.9-7.9 7.6-6 12.8 1.9 5.2 7.6 7.9 12.8 6 40.6-14.6 70.4-48.7 80.3-89.5H462c5.5 0 10-4.5 10-10s-4.5-10-10-10H253c0.4 0 0.2-14.4 0.1-15.6 -1-22.1-7.7-44.2-19.7-62.8 -10.5-16.4-25.3-30.2-41.9-40.3 -16.1-9.8-33.9-15.4-52.6-17.2 -1.6-0.2-22.1-1.3-22.1-0.3v-89.5H492v195.6c0 5.5 4.5 10 10 10s10-4.5 10-10V144.6 66C512 60.5 507.5 56 502 56zM400.4 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15 -8.3 0-15-6.7-15-15V49.9zM289.5 49.9c0-8.3 6.7-15 15-15s15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM178.5 49.9c0-8.3 6.7-15 15-15 8.3 0 15 6.7 15 15v32.2c0 8.3-6.7 15-15 15h0c-8.3 0-15-6.7-15-15V49.9zM116.9 134.6V76h41.6v6.1c0 19.3 15.7 35 35 35 19.3 0 35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1h41v6.1c0 19.3 15.7 35 35 35s35-15.7 35-35v-6.1H492v58.6H116.9z"}}),_c('path',{attrs:{"d":"M126.7 294.7c-5.5 0-10 4.5-10 10v55.7H83.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h43.6c5.5 0 10-4.5 10-10v-65.7C136.7 299.1 132.2 294.7 126.7 294.7z"}}),_c('path',{attrs:{"d":"M126.7 477.1c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C136.7 481.6 132.2 477.1 126.7 477.1z"}}),_c('path',{attrs:{"d":"M502 380.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C512 384.7 507.5 380.2 502 380.2z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Skift dato")])]):_vm._e(),_vm._v(" "),(item.id_appointment_status_support === '0' && item.aflyseb === 1)?_c('button',{staticClass:"mb1 outlined-button border-none p2 not-rounded h6 flex justify-start items-center",on:{"click":function($event){return _vm.showMeetingDetailsAflyse(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M437 75C388.7 26.6 324.4 0 256 0S123.3 26.6 75 75C26.6 123.3 0 187.6 0 256s26.6 132.7 75 181C123.3 485.4 187.6 512 256 512s132.7-26.6 181-75C485.4 388.7 512 324.4 512 256S485.4 123.3 437 75zM256 491.6c-129.9 0-235.6-105.7-235.6-235.6S126.1 20.4 256 20.4 491.6 126.1 491.6 256 385.9 491.6 256 491.6z"}}),_c('path',{attrs:{"d":"M318 256l84.8-84.7c4-4 4-10.4 0-14.4l-47.6-47.6c-4-4-10.4-4-14.4 0L256 194l-84.7-84.7c-4-4-10.4-4-14.4 0l-47.6 47.6c-4 4-4 10.4 0 14.4L194 256l-84.7 84.7c-4 4-4 10.4 0 14.4l47.6 47.6c4 4 10.4 4 14.4 0L256 318l84.8 84.7c2 2 4.6 3 7.2 3s5.2-1 7.2-3l47.6-47.6c4-4 4-10.4 0-14.4L318 256zM348 381.1l-84.7-84.7c-2-2-4.6-3-7.2-3s-5.2 1-7.2 3l-84.7 84.8 -33.2-33.2 84.8-84.7c4-4 4-10.4 0-14.4l-84.7-84.7 33.2-33.2 84.7 84.8c4 4 10.4 4 14.4 0l84.7-84.7 33.2 33.2 -84.7 84.7c-4 4-4 10.4 0 14.4l84.8 84.7L348 381.1z"}}),_c('path',{attrs:{"d":"M476.7 238.9c-0.4-5.6-5.3-9.8-11-9.4 -5.6 0.4-9.8 5.3-9.4 11 2.2 28.5-1.8 57.7-11.5 84.5 -1.9 5.3 0.8 11.1 6.1 13.1 1.2 0.4 2.3 0.6 3.5 0.6 4.2 0 8.1-2.6 9.6-6.7C474.7 302.4 479.1 270.3 476.7 238.9z"}}),_c('path',{attrs:{"d":"M469.4 197.2c-0.9-3.2-1.9-6.5-2.9-9.6 -1.7-5.4-7.5-8.3-12.8-6.6 -5.4 1.7-8.3 7.5-6.6 12.8 0.9 2.9 1.8 5.8 2.6 8.7 1.2 4.5 5.3 7.5 9.8 7.5 0.9 0 1.8-0.1 2.7-0.4C467.7 208.2 470.9 202.6 469.4 197.2z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Aflyse")])]):_vm._e()])]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('div',{staticClass:"col-12 px0 gibson"},[_c('a',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center no-hover",attrs:{"href":'mailto:' + item.email}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"3px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"}}),_c('path',{attrs:{"d":"M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"}}),_c('path',{attrs:{"d":"M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0"},[_vm._v(_vm._s(item.email))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[(item.potentialnameurl !== '')?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.prisUrlOpen(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M85.7 49c-20.2 0-36.7 16.5-36.7 36.7s16.5 36.7 36.7 36.7c20.2 0 36.7-16.5 36.7-36.7S105.9 49 85.7 49zM85.7 102c-9 0-16.3-7.3-16.3-16.3 0-9 7.3-16.3 16.3-16.3s16.3 7.3 16.3 16.3C102 94.7 94.7 102 85.7 102z"}}),_c('path',{attrs:{"d":"M499.2 265.2L279.6 45.6c-6.5-6.5-14.8-10.8-23.9-12.2L50.5 0.6C36.5-1.7 22.8 2.8 12.8 12.8 2.8 22.8-1.7 36.5 0.6 50.5l32.8 205.2c1.5 9.1 5.7 17.4 12.2 23.9l219.6 219.6c8.2 8.2 19.2 12.8 30.8 12.8 11.6 0 22.6-4.5 30.8-12.8l172.4-172.4C516.2 309.8 516.2 282.2 499.2 265.2zM484.8 312.4L312.4 484.8c-9 9-23.8 9-32.8 0L60 265.2c-3.5-3.5-5.7-7.9-6.5-12.7L20.7 47.3c-1.2-7.4 1.2-14.7 6.5-20.1 4.4-4.4 10.2-6.8 16.3-6.8 1.2 0 2.5 0.1 3.8 0.3l205.2 32.8c4.9 0.8 9.3 3 12.7 6.5l219.6 219.6v0C493.9 288.7 493.9 303.4 484.8 312.4z"}}),_c('path',{attrs:{"d":"M323.4 188.6c-4-4-10.4-4-14.4 0L188.6 309c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3L323.4 203C327.4 199.1 327.4 192.6 323.4 188.6z"}}),_c('path',{attrs:{"d":"M364.2 229.4c-4-4-10.4-4-14.4 0l-3.1 3.1c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l3.1-3.1C368.2 239.9 368.2 233.4 364.2 229.4z"}}),_c('path',{attrs:{"d":"M337.7 255.9c-4-4-10.4-4-14.4 0l-93.8 93.8c-4 4-4 10.4 0 14.4 2 2 4.6 3 7.2 3 2.6 0 5.2-1 7.2-3l93.8-93.8C341.7 266.4 341.7 259.9 337.7 255.9z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0",staticStyle:{"font-weight":"600!important"}},[_vm._v("Prisoverslag")])]):_vm._e(),_vm._v(" "),_c('a',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center no-hover",on:{"click":function($event){return _vm.getdataigibility(item.id_appointment, item.contact_id)}}},[_c('span',{staticClass:"mr2 relative"},[_c('img',{attrs:{"src":"static/svg/globe.svg","width":"70%"}})]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0"},[_vm._v("Klima profil")])]),_vm._v(" "),(item.potentialnameurl !== '' && item.numoffile > 0)?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.prisUrlOpenFile(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","viewBox":"-40 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m402 0h-280c-16.542969 0-30 13.457031-30 30v26h-62c-16.542969 0-30 13.457031-30 30v338.589844c.0078125.007812.015625.015625.0234375.019531.0039063 2.59375.9960935 5.144531 2.9062505 7.050781l77.40625 77.410156c1.914062 1.914063 4.472656 2.929688 7.074218 2.929688h.011719 222.578125c16.542969 0 30-13.457031 30-30v-26h62c16.542969 0 30-13.457031 30-30v-125c0-5.523438-4.476562-10-10-10s-10 4.476562-10 10v125c0 5.515625-4.484375 10-10 10h-62v-57.863281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-35.992188h29.539062c5.523438 0 10-4.476562 10-10 0-5.523437-4.476562-10-10-10h-29.539062v-36.019531h29.539062c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-29.539062v-35.988281h29.539062c5.523438 0 10-4.480469 10-10 0-5.523438-4.476562-10-10-10h-29.539062v-36.023438h29.539062c5.523438 0 10-4.476562 10-10 0-5.519531-4.476562-10-10-10h-29.539062v-48.113281c0-3.507812-.609375-6.871094-1.71875-10h73.71875v135c0 5.523438 4.476562 10 10 10s10-4.476562 10-10v-181c0-16.542969-13.457031-30-30-30zm-324.589844 477.859375-43.269531-43.269531h29.203125c7.753906 0 14.066406 6.3125 14.066406 14.066406zm242.589844 4.140625c0 5.515625-4.484375 10-10 10h-212.589844v-43.34375c0-18.785156-15.28125-34.066406-34.066406-34.066406h-43.34375v-282.589844h300v12.105469.011719.007812 56 .011719.007812 55.972657.011718.007813 56 .011719.007812zm0-396v26h-300v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10zm-10-30h-198v-26c0-5.515625 4.484375-10 10-10h280c5.515625 0 10 4.484375 10 10v26zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 358.019531h-216c-5.523438 0-10 4.476563-10 10 0 5.523438 4.476562 10 10 10h216c5.523437 0 10-4.476562 10-10 0-5.523437-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 414.011719h-100.589844c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h100.589844c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m61.589844 322h153.042968c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-153.042968c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 246.011719h-216c-5.523438 0-10 4.476562-10 10 0 5.519531 4.476562 10 10 10h216c5.523437 0 10-4.480469 10-10 0-5.523438-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m61.589844 209.988281h75.519531c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10h-75.519531c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 189.988281h-88.832032c-5.523437 0-10 4.480469-10 10 0 5.523438 4.476563 10 10 10h88.832032c5.523437 0 10-4.476562 10-10 0-5.519531-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m277.589844 302h-16.390625c-5.523438 0-10 4.476562-10 10s4.476562 10 10 10h16.390625c5.523437 0 10-4.476562 10-10s-4.476563-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m422 246c-2.628906 0-5.210938 1.070312-7.070312 2.929688-1.859376 1.859374-2.929688 4.441406-2.929688 7.070312s1.070312 5.210938 2.929688 7.070312c1.859374 1.859376 4.441406 2.929688 7.070312 2.929688s5.210938-1.070312 7.070312-2.929688c1.859376-1.859374 2.929688-4.441406 2.929688-7.070312s-1.070312-5.210938-2.929688-7.070312c-1.859374-1.859376-4.441406-2.929688-7.070312-2.929688zm0 0"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Filer")])]):_vm._e(),_vm._v(" "),(item.comment_to_customer !== '')?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.showMeetingDetailsCommentCustomertext(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500 500"}},[_c('path',{attrs:{"d":"m459.7 67.9-60.1-60.1c-5-5-11.6-7.8-18.7-7.8h-194.3c-14.6 0-26.5 11.9-26.5 26.5v58.3h-101.1c-14.6 0-26.5 11.9-26.5 26.5v169.7c0 12.9 20 12.8 20 0v-169.7c0-3.6 2.9-6.5 6.5-6.5h190v44.7c0 14.6 11.9 26.5 26.5 26.5h44.4v297.6c0 3.6-2.9 6.5-6.5 6.5h-254.4c-3.6 0-6.5-2.9-6.5-6.5v-110.7c0-12.9-20-12.8-20 0v110.7c0 14.6 11.9 26.5 26.5 26.5h254.4c14.6 0 26.5-11.9 26.5-26.5v-58.3h101.1c14.6 0 26.5-11.9 26.5-26.5v-302.2c0-7.1-2.8-13.7-7.8-18.7zm-25 3.3h-31.6c-3.6 0-6.5-2.9-6.5-6.5v-31.6zm-165.7 78.3v-31.6l38.1 38.1h-31.6c-3.6 0-6.5-2.9-6.5-6.5zm171.9 245.7h-101.1v-223.9c0-7.1-2.8-13.7-7.8-18.7l-60.1-60.1c-5-5-11.6-7.8-18.7-7.8h-73.1v-58.3c0-3.6 2.9-6.5 6.5-6.5h190v44.7c0 14.6 11.9 26.5 26.5 26.5h44.4v297.6c0 3.6-2.9 6.5-6.5 6.5z"}}),_c('path',{attrs:{"d":"m99.4 213.3h69.1c12.8 0 12.9-20 0-20h-69.1c-12.8 0-12.9 20 0 20z"}}),_c('path',{attrs:{"d":"m99.4 255.2h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"}}),_c('path',{attrs:{"d":"m99.4 299.7h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"}}),_c('path',{attrs:{"d":"m99.4 342.9h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"}}),_c('path',{attrs:{"d":"m99.4 386.1h172.5c12.8 0 12.9-20 0-20h-172.5c-12.8 0-12.9 20 0 20z"}}),_c('path',{attrs:{"d":"m42.5 331.7c4.9 0 9.2-3.7 9.9-8.5 1.4-9.2-10.1-15.1-16.8-8.7-6.4 6.1-1.9 17.2 6.9 17.2z"}})])]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"18.5px","font-weight":"600"}},[_vm._v("Opgavens indhold")])]):_vm._e(),_vm._v(" "),(item.comment_to_partner !== '')?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.showMeetingDetailsCommenttext(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"}}),_c('path',{attrs:{"d":"M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"}}),_c('path',{attrs:{"d":"M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"}}),_c('path',{attrs:{"d":"M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"}}),_c('path',{attrs:{"d":"M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"}}),_c('path',{attrs:{"d":"M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"}}),_c('path',{attrs:{"d":"M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0"},[_vm._v("Kommentarer")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.showMeetingTilbud(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"}}),_c('path',{attrs:{"d":"M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"}}),_c('path',{attrs:{"d":"M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"}}),_c('path',{attrs:{"d":"M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"}}),_c('path',{attrs:{"d":"M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"}}),_c('path',{attrs:{"d":"M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"}}),_c('path',{attrs:{"d":"M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"}}),_c('path',{attrs:{"d":"M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"}}),_c('path',{attrs:{"d":"M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 ml1"},[_vm._v("Se tilbud")])]),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.showMeetingTilbudbitrix(item, 'kundematch')}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M446 0h-280c-5.5 0-10 4.5-10 10s4.5 10 10 10h280c5.5 0 10 4.5 10 10v452c0 5.5-4.5 10-10 10h-380c-5.5 0-10-4.5-10-10V30c0-5.5 4.5-10 10-10h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20c-16.5 0-30 13.5-30 30v452c0 16.5 13.5 30 30 30h380c16.5 0 30-13.5 30-30V30C476 13.5 462.5 0 446 0z"}}),_c('path',{attrs:{"d":"M436 50c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v80c0 5.5 4.5 10 10 10h340c5.5 0 10-4.5 10-10V50zM416 120h-320V60h320V120z"}}),_c('path',{attrs:{"d":"M381 472h45c5.5 0 10-4.5 10-10V170c0-5.5-4.5-10-10-10h-340c-5.5 0-10 4.5-10 10v292c0 5.5 4.5 10 10 10h215c5.5 0 10-4.5 10-10s-4.5-10-10-10h-35V326h150v126h-35c-5.5 0-10 4.5-10 10S375.5 472 381 472zM246 180v126h-150V180H246zM246 452h-150V326h150V452zM266 306V180h150v126H266z"}}),_c('path',{attrs:{"d":"M141 253h20v20c0 5.5 4.5 10 10 10s10-4.5 10-10v-20h20c5.5 0 10-4.5 10-10s-4.5-10-10-10h-20v-20c0-5.5-4.5-10-10-10s-10 4.5-10 10v20h-20c-5.5 0-10 4.5-10 10S135.5 253 141 253z"}}),_c('path',{attrs:{"d":"M142.7 417.3c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l42.4-42.4c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-42.4 42.4C138.8 407 138.8 413.4 142.7 417.3z"}}),_c('path',{attrs:{"d":"M371 233h-60c-5.5 0-10 4.5-10 10s4.5 10 10 10h60c5.5 0 10-4.5 10-10S376.5 233 371 233z"}}),_c('path',{attrs:{"d":"M362.2 420.2c2.6 0 5.1-1 7.1-2.9 3.9-3.9 3.9-10.2 0-14.1l-14.1-14.1 14.1-14.1c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0l-14.1 14.1 -14.1-14.1c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l14.1 14.1 -14.1 14.1c-3.9 3.9-3.9 10.2 0 14.1 2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l14.1-14.1 14.1 14.1C357.1 419.2 359.7 420.2 362.2 420.2z"}}),_c('path',{attrs:{"d":"M126 20c5.5 0 10-4.5 10-10s-4.5-10-10-10h0c-5.5 0-10 4.5-10 10S120.5 20 126 20z"}}),_c('path',{attrs:{"d":"M341 452c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10 -4.5-10-10-10H341z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 ml1"},[_vm._v("Opret tilbud")])]),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.openFeedback(item)}}},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"30","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M372.3 50.8H28.8C12.9 50.8 0 63.7 0 79.6v206.1c0 15.9 12.9 28.8 28.8 28.8h22.3v76.7c0 4.9 2.9 9.3 7.5 11.2 1.5 0.6 3.1 0.9 4.6 0.9 3.1 0 6.2-1.2 8.5-3.5l85.3-85.2h17.1c6.7 0 12.1-5.4 12.1-12.1 0-6.7-5.4-12.1-12.1-12.1 0 0-22.7 0-22.9 0 -2.8 0.2-5.6 1.3-7.7 3.5l-68.2 68.2c0 0 0-60.4-0.1-60.7 -0.5-6.2-5.7-11-12-11H28.8c-2.6 0-4.7-2.1-4.7-4.7V79.6c0-2.6 2.1-4.7 4.7-4.7H372.3c2.6 0 4.7 2.1 4.7 4.7v79.1c0 6.7 5.4 12.1 12.1 12.1s12.1-5.4 12.1-12.1V79.6C401.1 63.7 388.2 50.8 372.3 50.8z"}}),_c('path',{attrs:{"d":"M483.2 198.5H242.8c-15.9 0-28.8 12.9-28.8 28.8v140.6c0 15.9 12.9 28.8 28.8 28.8h150.5l61 61c2.3 2.3 5.4 3.5 8.5 3.5 1.6 0 3.1-0.3 4.6-0.9 4.5-1.9 7.5-6.3 7.5-11.2v-52.4h8.3c15.9 0 28.8-12.9 28.8-28.8V227.3C512 211.4 499.1 198.5 483.2 198.5zM487.8 367.9c0 2.6-2.1 4.7-4.7 4.7h-20.4c-6.4 0-11.6 4.9-12 11.1 0 0.3-0.1 36.3-0.1 36.3l-43.9-43.9c0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.3-0.3-0.5-0.4 -2.1-1.9-4.9-3-8-3H242.8c-2.6 0-4.7-2.1-4.7-4.7v-140.6c0-2.6 2.1-4.7 4.7-4.7h240.4c2.6 0 4.7 2.1 4.7 4.7V367.9z"}}),_c('path',{attrs:{"d":"M363 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C375 290.9 369.6 285.5 363 285.5z"}}),_c('path',{attrs:{"d":"M310.5 130.6c0 0-219.8 0-219.8 0 -6.7 0-12.1 5.4-12.1 12.1s5.4 12.1 12.1 12.1h219.8c6.7 0 12.1-5.4 12.1-12.1S317.1 130.6 310.5 130.6z"}}),_c('path',{attrs:{"d":"M174.1 210.5H90.7c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1h83.4c6.7 0 12.1-5.4 12.1-12.1S180.7 210.5 174.1 210.5z"}}),_c('path',{attrs:{"d":"M306.8 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C318.9 290.9 313.5 285.5 306.8 285.5z"}}),_c('path',{attrs:{"d":"M419.1 285.5c-6.7 0-12.1 5.4-12.1 12.1 0 6.7 5.4 12.1 12.1 12.1 6.7 0 12.1-5.4 12.1-12.1C431.2 290.9 425.7 285.5 419.1 285.5z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0"},[_vm._v("Giv os Feedback")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0 gibson"},[(item.ticketsolution !== '' && item.id_appointment_status_support === '1')?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.showMeetingDetailsAflysetext(item)}}},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"1 -26 512 511"}},[_c('path',{attrs:{"d":"m451.5 459.9h-390.9c-21.8 0-41.4-11.3-52.3-30.2-10.9-18.9-10.9-41.5 0-60.4l195.5-338.6c10.9-18.9 30.5-30.2 52.3-30.2 21.8 0 41.4 11.3 52.3 30.2l81.5 141.2c2.8 4.8 1.1 10.9-3.7 13.7-4.8 2.8-10.9 1.1-13.7-3.7l-81.5-141.2c-7.3-12.7-20.4-20.2-35-20.2s-27.7 7.6-35 20.2l-195.5 338.6c-7.3 12.7-7.3 27.8 0 40.4 7.3 12.7 20.4 20.2 35 20.2h390.9c14.6 0 27.7-7.6 35-20.2 7.3-12.7 7.3-27.8 0-40.4l-68.9-119.4c-2.8-4.8-1.1-10.9 3.7-13.7 4.8-2.8 10.9-1.1 13.7 3.7l68.9 119.4c10.9 18.9 10.9 41.5 0 60.4-10.9 18.9-30.5 30.2-52.3 30.2zm0 0"}}),_c('path',{attrs:{"d":"m403.7 225.9c-2.6 0-5.2-1.1-7.1-2.9-1.9-1.9-2.9-4.4-2.9-7.1 0-2.6 1.1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9 2.6 0 5.2 1.1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1 0 2.6-1.1 5.2-2.9 7.1-1.9 1.9-4.4 2.9-7.1 2.9zm0 0"}}),_c('path',{attrs:{"d":"m256 375.8c-18.7 0-34-15.2-34-34 0-18.7 15.3-34 34-34s34 15.3 34 34c0 18.7-15.2 34-34 34zm0-48c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 0"}}),_c('path',{attrs:{"d":"m256 282.1c-18.7 0-34-15.2-34-34v-84.2c0-18.7 15.3-34 34-34s34 15.3 34 34v84.2c0 18.8-15.2 34-34 34zm0-132.2c-7.7 0-14 6.3-14 14v84.2c0 7.7 6.3 14 14 14s14-6.3 14-14v-84.2c0-7.7-6.3-14-14-14zm0 0"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ticketcategory)+" "+_vm._s(item.ticketstatus))])]):_vm._e(),_vm._v(" "),(item.ticketsolution === '')?_c('p',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton not-rounded flex justify-center items-center"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"2px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"18","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"1 -26 512 511"}},[_c('path',{attrs:{"d":"m451.5 459.9h-390.9c-21.8 0-41.4-11.3-52.3-30.2-10.9-18.9-10.9-41.5 0-60.4l195.5-338.6c10.9-18.9 30.5-30.2 52.3-30.2 21.8 0 41.4 11.3 52.3 30.2l81.5 141.2c2.8 4.8 1.1 10.9-3.7 13.7-4.8 2.8-10.9 1.1-13.7-3.7l-81.5-141.2c-7.3-12.7-20.4-20.2-35-20.2s-27.7 7.6-35 20.2l-195.5 338.6c-7.3 12.7-7.3 27.8 0 40.4 7.3 12.7 20.4 20.2 35 20.2h390.9c14.6 0 27.7-7.6 35-20.2 7.3-12.7 7.3-27.8 0-40.4l-68.9-119.4c-2.8-4.8-1.1-10.9 3.7-13.7 4.8-2.8 10.9-1.1 13.7 3.7l68.9 119.4c10.9 18.9 10.9 41.5 0 60.4-10.9 18.9-30.5 30.2-52.3 30.2zm0 0"}}),_c('path',{attrs:{"d":"m403.7 225.9c-2.6 0-5.2-1.1-7.1-2.9-1.9-1.9-2.9-4.4-2.9-7.1 0-2.6 1.1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9 2.6 0 5.2 1.1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1 0 2.6-1.1 5.2-2.9 7.1-1.9 1.9-4.4 2.9-7.1 2.9zm0 0"}}),_c('path',{attrs:{"d":"m256 375.8c-18.7 0-34-15.2-34-34 0-18.7 15.3-34 34-34s34 15.3 34 34c0 18.7-15.2 34-34 34zm0-48c-7.7 0-14 6.3-14 14s6.3 14 14 14 14-6.3 14-14-6.3-14-14-14zm0 0"}}),_c('path',{attrs:{"d":"m256 282.1c-18.7 0-34-15.2-34-34v-84.2c0-18.7 15.3-34 34-34s34 15.3 34 34v84.2c0 18.8-15.2 34-34 34zm0-132.2c-7.7 0-14 6.3-14 14v84.2c0 7.7 6.3 14 14 14s14-6.3 14-14v-84.2c0-7.7-6.3-14-14-14zm0 0"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.ticketstatus))])]):_vm._e()]),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button px2 col-12 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.mailSupport(item.contactid)}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2 "},[_c('svg',{attrs:{"fill":"currentColor","width":"30","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M501.8 139.9H171.3c-5.6 0-10.2 4.6-10.2 10.2v19.2h-97.2c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h97.2v132.5h-58.1c-5.6 0-10.2 4.6-10.2 10.2s4.6 10.2 10.2 10.2h58.1v19.2c0 5.6 4.6 10.2 10.2 10.2h330.5c5.6 0 10.2-4.6 10.2-10.2V150.1C512 144.5 507.4 139.9 501.8 139.9zM476.6 160.3l-140.1 115L197.1 160.3H476.6zM491.6 351.7h-310.1v-177.8l148.6 122.5c1.9 1.6 4.2 2.3 6.5 2.3 2.3 0 4.6-0.8 6.5-2.3L491.6 174.5V351.7z"}}),_c('path',{attrs:{"d":"M119.7 244.8H10.2C4.6 244.8 0 249.3 0 255c0 5.6 4.6 10.2 10.2 10.2h109.5c5.6 0 10.2-4.6 10.2-10.2C129.9 249.3 125.3 244.8 119.7 244.8z"}}),_c('path',{attrs:{"d":"M69.4 322.2h-5.5c-5.6 0-10.2 4.6-10.2 10.2 0 5.6 4.6 10.2 10.2 10.2h5.5c5.6 0 10.2-4.6 10.2-10.2C79.6 326.8 75 322.2 69.4 322.2z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start"},[_vm._v("Skriv til kunden")])]),_vm._v(" "),_c('button',{staticClass:"mb1 outlined-button px2 col-12 py1 white-background collapsebutton not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.openComment(item)}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2"},[_c('svg',{staticClass:"jam jam-document",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"28","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M3 0h10a3 3 0 0 1 3 3v14a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3zm0 2a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1H3zm2 1h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2zm0 12h2a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-4h6a1 1 0 0 1 0 2H5a1 1 0 0 1 0-2zm0-4h6a1 1 0 0 1 0 2H5a1 1 0 1 1 0-2z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 mb0 semi-bold col-8 p0 flex justify-start"},[_vm._v("Dine notater "),_c('span',{staticClass:"badge badge-pill regular relative primarycolor-background ml1",staticStyle:{"top":"-2px"}},[_vm._v(_vm._s(item.notat))])])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'+item.id_appointment),expression:"'setReminder'+item.id_appointment"}],staticClass:"mb1 outlined-button px2 py1 white-background col-12 collapsebutton not-rounded flex justify-center items-center",attrs:{"id":'setReminderb'+item.id_appointment}},[[_c('div',{staticClass:"flex justify-start items-center regular"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"2px"}},[_c('svg',{staticClass:"jam jam-bell",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z"}})])]),_vm._v(" "),(item.remidercount !== 0)?_c('span',{staticClass:"mb0 semi-bold",staticStyle:{"font-size":"18.5px"}},[_vm._v("\n                      "+_vm._s(_vm.moment(item.remiderappid.date).format('ll'))+"\n                    ")]):_vm._e(),_vm._v(" "),(item.remidercount === 0)?_c('span',{staticClass:"mb0 semi-bold",staticStyle:{"font-size":"18.5px"}},[_vm._v("\n                      Tilføj påmindelse\n                    ")]):_vm._e()])]],2),_vm._v(" "),(item.remidercount !== 0 && item.remiderappid.done !== '1')?_c('button',{staticClass:"p1 outlined-action-button flex justify-center items-center border-none gibson line-height-1",on:{"click":function($event){return _vm.handleSletReminder(item,1)}}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-check"})])]):_vm._e(),_vm._v(" "),(item.remidercount !== 0)?_c('button',{staticClass:"mb1 outlined-button px2 py1 white-background collapsebutton col-12 not-rounded flex justify-center items-center",on:{"click":function($event){return _vm.handleSletReminder(item,2)}}},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"reminderModal",refInFor:true,staticClass:"col-12",attrs:{"id":'setReminder'+item.id_appointment}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitReminder(item)}}},[_c('div',{staticClass:"clearfix mb3"},[_c('div',{staticClass:"flex flex-column my2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Type")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(item.remiderappid.smsemail),expression:"item.remiderappid.smsemail"}],staticClass:"muted-background p1 darkblue not-rounded border-none gibson mb1",staticStyle:{"font-size":"16.5px","height":"38px"},attrs:{"id":"reminderSelect","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(item.remiderappid, "smsemail", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("SMS og email")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("SMS")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Email")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("None")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Dato")]),_vm._v(" "),_c('VueCtkDateTimePicker',{staticClass:"darkblue not-rounded border-none gibson mb1 muted-background",attrs:{"id":"reminderDate","locale":"da","label":"Påmindelse Dato","required":"","placeholder":"Påmindelse Dato"},model:{value:(_vm.datereminder),callback:function ($$v) {_vm.datereminder=$$v},expression:"datereminder"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Noter")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(item.remiderappid.descp),expression:"item.remiderappid.descp"}],staticClass:"p2 muted-background darkblue gibson line-height-3 border-none not-rounded",staticStyle:{"font-size":"13.5px"},attrs:{"name":"note","id":"note","cols":"30","rows":"5","required":"","placeholder":""},domProps:{"value":(item.remiderappid.descp)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(item.remiderappid, "descp", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-column items-center"},[_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.newclass",modifiers:{"newclass":true}}],staticClass:"col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson"},[_c('span',{staticClass:"semi-bold",staticStyle:{"font-size":"16.5px"}},[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'+item.id_appointment),expression:"'setReminder'+item.id_appointment"}],staticClass:"col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded",attrs:{"type":"button"}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16.5px"}},[_vm._v("Luk påmindelse")])])])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 mb1"},[_c('button',{staticClass:"kundebutton dark-button col-12 outlined-action-button p1 flex justify-center items-center gibson line-height-1",on:{"click":function($event){return _vm.showMeetingTilbudbitrix(item, 'kundematch')}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2 "}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start"},[_vm._v("OPRET TILBUD")])])])]),_vm._v(" "),(item.kundeconfirms === '0')?_c('div',{staticClass:"absolute top-0 right-0 left-0 z3 flex justify-center items-center",staticStyle:{"background-color":"rgba(178, 190, 195, 0.75)","height":"95%"}},[_c('div',{staticClass:"darkblue text-shadow flex flex-column justify-center items-center"},[_c('div',[_c('svg',{staticClass:"jam jam-alert",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"48","height":"48","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"}})])]),_vm._v(" "),_c('div',{staticClass:"m2 py2"},[_c('p',{staticClass:"h6 semi-bold p5 line-height-2 center"},[_vm._v("Kunden har "),_c('Countdown2',{attrs:{"deadline":item.countdown}}),_vm._v(" dage til at godkende, at de stadig vil videre med opgaven, med dit firma.")],1)]),_vm._v(" "),_c('Countdown',{attrs:{"deadline":item.countdown}}),_vm._v(" "),_c('div',{staticClass:"col-6 py2 gibson"},[_c('p',{staticClass:"darkblue regular line-height-3 break-word",staticStyle:{"font-size":"18.5px","max-lines":"2"}},[_vm._v("\n                  "+_vm._s(item.mailingzip)+" "+_vm._s(item.mailingcity)+"\n                ")])]),_vm._v(" "),_c('p',{staticClass:"text-left p2 semi-bold"},[_vm._v(_vm._s(_vm._f("truncate")(item.comment_to_partner,300, '...')))])],1)]):_vm._e(),_vm._v(" "),(item.kundeconfirms === '2')?_c('div',{staticClass:"absolute top-0 right-0 left-0 z3 flex justify-center items-center",staticStyle:{"background-color":"rgba(255,255,255,.8)","height":"95%"}},[(item.rejectshow === '1')?[_c('div',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover.top",value:(item.rejecttext),expression:"item.rejecttext",modifiers:{"hover":true,"top":true}}],staticClass:"darkblue text-shadow flex flex-column justify-center items-center"},[_c('div',[_c('svg',{staticClass:"jam jam-alert",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"48","height":"48","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"}})])]),_vm._v(" "),_vm._m(5,true),_vm._v(" "),_c('div',{staticClass:"col-12 gibson"},[_c('p',{staticClass:"darkblue regular line-height-3 break-word",staticStyle:{"font-size":"18.5px","max-lines":"2"}},[_vm._v("\n                "+_vm._s(item.mailingzip)+" "+_vm._s(item.mailingcity)+"\n              ")])])])]:_vm._e(),_vm._v(" "),(item.rejectshow !== '1')?[_c('div',{staticClass:"darkblue text-shadow flex flex-column justify-center items-center"},[_c('div',[_c('svg',{staticClass:"jam jam-alert",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"48","height":"48","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"}})])]),_vm._v(" "),_vm._m(6,true),_vm._v(" "),_c('div',{staticClass:"col-12 gibson"},[_c('p',{staticClass:"darkblue regular line-height-3 break-word",staticStyle:{"font-size":"18.5px","max-lines":"2"}},[_vm._v("\n                "+_vm._s(item.mailingzip)+" "+_vm._s(item.mailingcity)+"\n              ")])])])]:_vm._e()],2):_vm._e()]):_vm._e()})],2),_vm._v(" "),_c('div',{staticClass:"py4"})]),_vm._v(" "),_c('b-modal',{ref:"meetingModal",staticClass:"p3",attrs:{"centered":"","lazy":"","size":"sm"},model:{value:(_vm.meetingShow),callback:function ($$v) {_vm.meetingShow=$$v},expression:"meetingShow"}},[_c('div',{staticClass:"clearfix px2 pt2 gibson",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h5 semi-bold darkblue line-height-4"},[_vm._v(_vm._s(_vm.sampleMeeting.type))])])]),_vm._v(" "),_c('div',{staticClass:"modal-content p-0 border-0 gibson"},[_c('div',[_c('span',{staticClass:"text-secondary"},[_vm._v("By")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.city))]),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.postnummer))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("Overslagspris eksl. moms")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold text-red"},[_vm._v(_vm._s(_vm.sampleMeeting.estimate))]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-secondary"},[_vm._v("Dato")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 font-weight-bold"},[_vm._v(_vm._s(_vm.sampleMeeting.date))]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"gibson py-4 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',[_c('b-btn',{attrs:{"variant":"outline-dark"},on:{"click":_vm.hideModal}},[_vm._v("Close")])],1)])]),_vm._v(" "),_c('b-modal',{staticClass:"p3",attrs:{"hide-footer":"","title":_vm.AflyseTexttitle},model:{value:(_vm.modalShowAflyseText),callback:function ($$v) {_vm.modalShowAflyseText=$$v},expression:"modalShowAflyseText"}},[_c('div',{staticClass:"py2"},[_vm._v("\n      "+_vm._s(_vm.AflyseText)+"\n    ")])]),_vm._v(" "),_c('b-modal',{staticClass:"prisverslag",attrs:{"centered":"","id":"modalPopover","title":"Prisverslag","ok-only":""},model:{value:(_vm.modalShowPris),callback:function ($$v) {_vm.modalShowPris=$$v},expression:"modalShowPris"}},[_c('a',{staticClass:"h4 bold col-right pointer mt2 mr2 no-hover",on:{"click":function($event){_vm.modalShowPris = false}}},[_vm._v("X")]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('h2',[_vm._v("Prisoverslag")])]),_vm._v(" "),_c('b-embed',{attrs:{"type":"iframe","scrolling":"yes","src":_vm.urlpris+'&frame=1',"aspect":"1by1","allowfullscreen":""}}),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start items-center px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],1),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"centered":""},model:{value:(_vm.modalShowCommentText),callback:function ($$v) {_vm.modalShowCommentText=$$v},expression:"modalShowCommentText"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb3"},[_vm._v("\n      Kommentar\n    ")]),_vm._v(" "),_c('p',{staticClass:"regular line-height-golden gibson",staticStyle:{"font-size":"16.6px"}},[_vm._v("\n      "+_vm._s(_vm.CommentText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"col-3 outlined-dark-button gibson line-height-1 not-rounded p2 flex justify-start items-center",on:{"click":function($event){_vm.modalShowCommentText = false}}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"mb0 semi-bold"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"p3",attrs:{"centered":""},model:{value:(_vm.modalShowCommentCustomerText),callback:function ($$v) {_vm.modalShowCommentCustomerText=$$v},expression:"modalShowCommentCustomerText"}},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 mb3 gibson"},[_vm._v("\n      Opgavens indhold\n    ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue line-height-4 regular gibson"},[_vm._v("\n      "+_vm._s(_vm.CommentCustomerText)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center col-12 px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"p2 outlined-dark-button gibson h5 line-height1 flex justify-center items-center",attrs:{"type":"reset"},on:{"click":function($event){_vm.modalShowCommentCustomerText = false}}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" "),_c('span',[_vm._v("Luk")])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"no-close-on-backdrop":"","centered":""},model:{value:(_vm.modalShowFeedback),callback:function ($$v) {_vm.modalShowFeedback=$$v},expression:"modalShowFeedback"}},[_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 my3 gibson"},[_vm._v("\n        Giv os uddybende feedback om kunden : "+_vm._s(_vm.kundeitem.firstname)+" "+_vm._s(_vm.kundeitem.lastname)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitFeedback.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-textarea',{staticClass:"bg-light border-0",attrs:{"rows":6,"max-rows":6,"placeholder":"Tilføj din feedback her...","required":""},model:{value:(_vm.textFeedback),callback:function ($$v) {_vm.textFeedback=$$v},expression:"textFeedback"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 my1"},[_c('div',{staticClass:"col col-12 p0"},[_c('button',{staticClass:"col-12 p0 gibson action-button p2 h5 semi-bold not-rounded",attrs:{"type":"submit","disabled":_vm.isLoadingAflyse}},[_c('span',[_vm._v("Feedback")])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center col-12 px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"col-4 p2 border-none disabled-button gibson h6 line-height1 flex justify-center items-center left",attrs:{"type":"reset"},on:{"click":function($event){_vm.modalShowFeedback = false}}},[_c('span',[_vm._v("Luk")])])])]),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"dineNotater","no-close-on-backdrop":"","centered":""},model:{value:(_vm.modalShowkomment),callback:function ($$v) {_vm.modalShowkomment=$$v},expression:"modalShowkomment"}},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold p0 p2 border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){_vm.modalShowkomment = false}}},[_vm._v("\n        X\n      ")])]),_vm._v(" "),_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 my3 gibson"},[_vm._v("\n        Dine notater : "+_vm._s(_vm.kundeitem.firstname)+" "+_vm._s(_vm.kundeitem.lastname)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"clearfix"},_vm._l((_vm.komments),function(item){return _c('div',{key:item.id,staticClass:"col-12 px1 mb2 border-bottom mediumgrey-border"},[_c('p',{staticClass:"h7 semi-bold line-height-2 mb0 gibson"},[_vm._v(_vm._s(item.date)+" :\n            "),_c('button',{staticClass:"not-rounded outlined-action-button p1 border-none",on:{"click":function($event){return _vm.editComment(item)}}},[_c('span',[_c('i',{staticClass:"el-icon-edit"})])])]),_vm._v(" "),_c('p',{staticClass:"h7 regular darkblue line-height-4 gibson"},[_vm._v(_vm._s(item.note))]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(item.images.length !== 0)?_c('div',{staticClass:"col-12 px0"},[_vm._l((item.images),function(image,i){return _c('img',{key:image.id,staticClass:"image",attrs:{"src":image},on:{"click":function($event){return _vm.onClick(item,i)}}})}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":item.images,"index":item.index},on:{"close":function($event){item.index = null}}})],2):_vm._e(),_vm._v(" "),(item.doc.length !== 0)?_c('div',{staticClass:"col-12 px0"},_vm._l((item.doc),function(attachment){return _c('li',{key:attachment.id,staticClass:"py-1"},[_c('a',{attrs:{"href":attachment,"target":"_blank"}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0):_vm._e()])])}),0),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitComment.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-textarea',{staticClass:"bg-light border-0",attrs:{"rows":6,"max-rows":6,"placeholder":"Tilføj din kommentar her...","required":""},model:{value:(_vm.textKomment),callback:function ($$v) {_vm.textKomment=$$v},expression:"textKomment"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 my1"},[(_vm.commentId === '')?_c('div',{staticClass:"col col-12 p0"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col col-12 p0"},[(_vm.commentId === '')?_c('button',{staticClass:"col-12 gibson action-button p2 h5 semi-bold not-rounded",attrs:{"type":"submit","disabled":_vm.isLoadingAflyse}},[_c('span',[_vm._v("Gem")])]):_vm._e(),_vm._v(" "),(_vm.commentId !== '')?_c('button',{staticClass:"col-12 gibson btn btn-warning p2 h5 semi-bold not-rounded",attrs:{"type":"submit","disabled":_vm.isLoadingAflyse}},[_c('span',[_vm._v("Rediger")])]):_vm._e(),_vm._v(" "),_c('div',[(_vm.commentId !== '')?_c('b-link',{on:{"click":function($event){return _vm.CanceleditComment()}}},[_vm._v("Nulstil")]):_vm._e()],1)])])])],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center col-12 px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"})]),_vm._v(" "),_c('b-modal',{ref:"modal",staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"modalPrevent","centered":""},model:{value:(_vm.modalShowAflyse),callback:function ($$v) {_vm.modalShowAflyse=$$v},expression:"modalShowAflyse"}},[_c('div',{staticClass:"hide",attrs:{"slot":"modal-title"},domProps:{"innerHTML":_vm._s(_vm.Aflysetitle)},slot:"modal-title"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue semi-bold gibson line-height-3 mb1",staticStyle:{"font-size":"18.5px"}},[_vm._v("Hvad skyldes reklamationen?")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitAflyse.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-textarea',{staticClass:"border-none p2 not-rounded darkblue h5 muted-background",attrs:{"rows":6,"max-rows":9,"required":""},model:{value:(_vm.textAflyseReason),callback:function ($$v) {_vm.textAflyseReason=$$v},expression:"textAflyseReason"}})],1)])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"outlined-dark-button gibson line-height-1 not-rounded p2 h5 flex justify-start items-center",on:{"click":function($event){_vm.modalShowAflyse = false}}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"mb0 semi-bold"},[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"gibson action-button p2 h5 semi-bold not-rounded",attrs:{"type":"submit","disabled":_vm.isLoadingAflyse}},[_c('span',{staticClass:"mb0 semi-bold"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])]),_vm._v(" "),_c('b-modal',{ref:"modal",staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"modalPrevent","hide-footer":"","centered":""},model:{value:(_vm.modalShowDato),callback:function ($$v) {_vm.modalShowDato=$$v},expression:"modalShowDato"}},[_c('form',{staticClass:"p2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitDato.apply(null, arguments)}}},[_c('div',{staticClass:"h6 darkblue semi-bold gibson line-height-2 mb0 py2",domProps:{"innerHTML":_vm._s(_vm.Datosetitle)}}),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"mb1 darkblue semi-bold",staticStyle:{"font-size":"16.5px","letter-spacing":"-0.5px"},attrs:{"id":"dateStart","label":"Dato","label-for":"dateStart"}},[_c('date-picker',{staticClass:"muted-background px2 py1 border-none h6 semi-bold not-rounded",staticStyle:{"font-size":"15px"},attrs:{"id":"dateStart","required":"","config":_vm.config},model:{value:(_vm.dateDato),callback:function ($$v) {_vm.dateDato=$$v},expression:"dateDato"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{staticClass:"mb1 darkblue semi-bold",staticStyle:{"font-size":"16.5px","letter-spacing":"-0.5px"},attrs:{"label":"Vælg tidspunkt","label-for":"timeStart"}},[_c('b-form-select',{staticClass:"muted-background px2 py1 darkblue h6 semi-bold border-none",staticStyle:{"font-size":"15px"},attrs:{"id":"select_time","required":""},model:{value:(_vm.timeDato),callback:function ($$v) {_vm.timeDato=$$v},expression:"timeDato"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("00:00")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("00:30")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("01:00")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("01:30")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("02:00")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("02:30")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("03:00")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("03:30")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("04:00")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("04:30")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("05:00")]),_vm._v(" "),_c('option',{attrs:{"value":"12"}},[_vm._v("05:30")]),_vm._v(" "),_c('option',{attrs:{"value":"13"}},[_vm._v("06:00")]),_vm._v(" "),_c('option',{attrs:{"value":"14"}},[_vm._v("06:30")]),_vm._v(" "),_c('option',{attrs:{"value":"15"}},[_vm._v("07:00")]),_vm._v(" "),_c('option',{attrs:{"value":"16"}},[_vm._v("07:30")]),_vm._v(" "),_c('option',{attrs:{"value":"17"}},[_vm._v("08:00")]),_vm._v(" "),_c('option',{attrs:{"value":"18"}},[_vm._v("08:30")]),_vm._v(" "),_c('option',{attrs:{"value":"19"}},[_vm._v("09:00")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("09:30")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("10:00")]),_vm._v(" "),_c('option',{attrs:{"value":"22"}},[_vm._v("10:30")]),_vm._v(" "),_c('option',{attrs:{"value":"23"}},[_vm._v("11:00")]),_vm._v(" "),_c('option',{attrs:{"value":"24"}},[_vm._v("11:30")]),_vm._v(" "),_c('option',{attrs:{"value":"25"}},[_vm._v("12:00")]),_vm._v(" "),_c('option',{attrs:{"value":"26"}},[_vm._v("12:30")]),_vm._v(" "),_c('option',{attrs:{"value":"27"}},[_vm._v("13:00")]),_vm._v(" "),_c('option',{attrs:{"value":"28"}},[_vm._v("13:30")]),_vm._v(" "),_c('option',{attrs:{"value":"29"}},[_vm._v("14:00")]),_vm._v(" "),_c('option',{attrs:{"value":"30"}},[_vm._v("14:30")]),_vm._v(" "),_c('option',{attrs:{"value":"31"}},[_vm._v("15:00")]),_vm._v(" "),_c('option',{attrs:{"value":"32"}},[_vm._v("15:30")]),_vm._v(" "),_c('option',{attrs:{"value":"33"}},[_vm._v("16:00")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("16:30")]),_vm._v(" "),_c('option',{attrs:{"value":"35"}},[_vm._v("17:00")]),_vm._v(" "),_c('option',{attrs:{"value":"36"}},[_vm._v("17:30")]),_vm._v(" "),_c('option',{attrs:{"value":"37"}},[_vm._v("18:00")]),_vm._v(" "),_c('option',{attrs:{"value":"38"}},[_vm._v("18:30")]),_vm._v(" "),_c('option',{attrs:{"value":"39"}},[_vm._v("19:00")]),_vm._v(" "),_c('option',{attrs:{"value":"40"}},[_vm._v("19:30")]),_vm._v(" "),_c('option',{attrs:{"value":"41"}},[_vm._v("20:00")]),_vm._v(" "),_c('option',{attrs:{"value":"42"}},[_vm._v("20:30")]),_vm._v(" "),_c('option',{attrs:{"value":"43"}},[_vm._v("21:00")]),_vm._v(" "),_c('option',{attrs:{"value":"44"}},[_vm._v("21:30")]),_vm._v(" "),_c('option',{attrs:{"value":"45"}},[_vm._v("22:00")]),_vm._v(" "),_c('option',{attrs:{"value":"46"}},[_vm._v("22:30")]),_vm._v(" "),_c('option',{attrs:{"value":"47"}},[_vm._v("23:00")]),_vm._v(" "),_c('option',{attrs:{"value":"48"}},[_vm._v("23:30")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('b-form-textarea',{staticClass:"muted-background p2 darkblue semi-bold border-none gibson line-height-golden",staticStyle:{"font-size":"15px"},attrs:{"rows":6,"max-rows":9,"placeholder":"Kommentarer"},model:{value:(_vm.textDatoReason),callback:function ($$v) {_vm.textDatoReason=$$v},expression:"textDatoReason"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"mb1 darkblue semi-bold",staticStyle:{"font-size":"16.5px","letter-spacing":"-0.5px"},attrs:{"id":"dateStart","label":"Send e-mail","label-for":"Send Email"}},[_c('toggle-button',{attrs:{"name":"send_email","sync":true,"labels":true},model:{value:(_vm.send_email),callback:function ($$v) {_vm.send_email=$$v},expression:"send_email"}})],1)],1),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"col-3 outlined-dark-button gibson line-height-1 not-rounded p2 flex justify-start items-center",attrs:{"type":"reset"},on:{"click":function($event){_vm.modalShowDato = false}}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"mb0 semi-bold"},[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"p2 action-button flex justfiy-center items-center line-height-1 border-none not-rounded gibson",attrs:{"type":"submit","disabled":_vm.isLoadingDato}},[_c('span',{staticClass:"mb0"},[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"priceFeedBack","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalPriceFeedback),callback:function ($$v) {_vm.modalPriceFeedback=$$v},expression:"modalPriceFeedback"}},[_c('div',{staticClass:"p2"},[_c('div',{staticClass:"flex justify-between items-center col-12 mt1 mb3 px0"},[_c('p',{staticClass:"h4 darkblue semi-bold line-height-1 gibson"},[_vm._v("\n          Feedback\n        ")]),_vm._v(" "),_c('button',{staticClass:"h4 bold border-none transparent p0",attrs:{"type":"reset"},on:{"click":function($event){return _vm.closePriceFeedBackModal()}}},[_c('i',{staticClass:"el-icon-close"})])]),_vm._v(" "),(_vm.feedbackLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',{staticClass:"clearfix pb3"},[(_vm.priceFeedBackData.steps != 3)?_c('div',{staticClass:"col-12 px0 flex justify-start"},[_c('h1',{staticClass:"semi-bold h6 primarycolor"},[_vm._v(_vm._s(_vm.statusItem.firstname)+" "+_vm._s(_vm.statusItem.lastname))]),_vm._v(" "),(_vm.statusItem.mailingzip != '')?_c('p',{staticClass:"primarycolor regular mb1"},[_vm._v(_vm._s(_vm.statusItem.mailingzip)+" "+_vm._s(_vm.statusItem.mailingcity))]):_c('p',{staticClass:"primarycolor semi-bold mb1 invisible"},[_vm._v(".")])]):_vm._e(),_vm._v(" "),(_vm.priceFeedBackData.steps == 1)?_c('div',[_c('h3',{staticClass:"h3 darkblue semi-bold gibson mt1 mb3"},[_vm._v("Hvad var det endelige tilbud?")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson line-height-1 gibson"},[_vm._v("Budgetprisen var:")]),_vm._v(" "),_c('el-checkbox',{staticClass:"col-12 flex justify-start items-center p0 mb2 gibson",on:{"change":function($event){return _vm.priceManualChanged()}},model:{value:(_vm.priceFeedBackData.priceManualChecked),callback:function ($$v) {_vm.$set(_vm.priceFeedBackData, "priceManualChecked", $$v)},expression:"priceFeedBackData.priceManualChecked"}},[_c('span',{staticClass:"darkblue h6 m0 line-height-1 inline-block"},[_vm._v("Indtast priskorrektion manuelt")])]),_vm._v(" "),_c('el-input-number',{staticClass:"primarycolor-border col-12 p0 mb3 gibson",attrs:{"id":"priceFeedBackPrice","placeholder":"Pris","controls":false,"min":0,"max":500000,"disabled":_vm.priceFeedBackData.priceManualDisabled},on:{"blur":function($event){return _vm.priceFeedBackPriceChanged()}},model:{value:(_vm.priceFeedBackData.price),callback:function ($$v) {_vm.$set(_vm.priceFeedBackData, "price", $$v)},expression:"priceFeedBackData.price"}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold mb3 gibson"},[_vm._v("Juster prisen her")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular italic mb3 gibson"},[_vm._v("\"Så kan vi blive bedre til at budgettere\"")]),_vm._v(" "),_c('el-slider',{staticClass:"col-10 p0 mx-auto mb2",attrs:{"min":0,"max":500000,"step":1},on:{"change":function($event){return _vm.priceFeedBackPriceChanged()}},model:{value:(_vm.priceFeedBackData.price),callback:function ($$v) {_vm.$set(_vm.priceFeedBackData, "price", $$v)},expression:"priceFeedBackData.price"}}),_vm._v(" "),_c('div',{staticClass:"flex justify-between mb3"},[_c('p',{staticClass:"h5 primarycolor semi-bold"},[_vm._v("Lavere")]),_vm._v(" "),_c('p',{staticClass:"h5 primarycolor semi-bold"},[_vm._v("Højere")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-end"},[_c('button',{staticClass:"gibson action-button py2 px3 h5 semi-bold not-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.priceFeedBackStep('next')}}},[_c('span',[_vm._v("Næste")]),_vm._v(" "),_c('i',{staticClass:"el-icon-right"})])])],1):(_vm.priceFeedBackData.steps == 2)?_c('div',[_c('span',{staticClass:"block h3 darkblue semi-bold gibson mt1 mb3"},[_vm._v("Hvordan var din oplevelse af kunden?")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between mb1"},[_c('p',{staticClass:"h5 darkblue regular gibson"},[_vm._v("Dårligt")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular gibson"},[_vm._v("Godt")])]),_vm._v(" "),_c('el-radio-group',{staticClass:"mb2 gibson",attrs:{"fill":"#ff0000"},model:{value:(_vm.priceFeedBackData.nps),callback:function ($$v) {_vm.$set(_vm.priceFeedBackData, "nps", $$v)},expression:"priceFeedBackData.nps"}},_vm._l((10),function(radio,index){return _c('el-radio-button',{key:index,attrs:{"label":index + 1}})}),1),_vm._v(" "),_c('el-input',{staticClass:"h5 mb3",attrs:{"type":"textarea","rows":5,"placeholder":"Bemærk"},model:{value:(_vm.priceFeedBackData.note),callback:function ($$v) {_vm.$set(_vm.priceFeedBackData, "note", $$v)},expression:"priceFeedBackData.note"}}),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center px0"},[_c('button',{staticClass:"gibson muted-button py2 px3 h5 semi-bold not-rounded mr2",attrs:{"type":"button"},on:{"click":function($event){return _vm.priceFeedBackStep('back')}}},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),_c('button',{staticClass:"gibson action-button py2 px3 h5 semi-bold not-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.priceFeedBackStep('save')}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('i',{staticClass:"el-icon-right"})])])],1):_c('div',{staticClass:"custom-saved mt4"},[_c('h2',{staticClass:"semi-bold"},[_vm._v("Gemt.")])])])])]),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalSurvey),callback:function ($$v) {_vm.modalSurvey=$$v},expression:"modalSurvey"}},[_c('div',{staticClass:"center p2"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){return _vm.closeSurveyModal()}}},[_vm._v("\n          X\n        ")])]),_vm._v(" "),_c('p',{staticClass:"h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson"},[_vm._v("\n       Survey\n      ")]),_vm._v(" "),(_vm.feedbackLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('div',{staticClass:"clearfix pb3 hide",attrs:{"id":"surveyPopup"}},[_c('div',{staticClass:"col col-12 p0 mb4"},[_c('el-input',{attrs:{"type":"textarea","rows":5,"placeholder":"Beskrivelse"},model:{value:(_vm.surveyDescription),callback:function ($$v) {_vm.surveyDescription=$$v},expression:"surveyDescription"}})],1),_vm._v(" "),(_vm.statusValue == 5)?_c('div',[_c('div',{staticClass:"clearfix pb3"},[_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"darkblue bold m0"},[_vm._v("Ønsker du at slette kunden?")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('b-button',{staticClass:"primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeSurveyModal('no')}}},[_vm._v("\n              Nej\n            ")]),_vm._v(" "),_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitSurveyDescription()}}},[_vm._v("\n              Ja\n            ")])],1)]):_vm._e(),_vm._v(" "),(_vm.statusValue == 6 || _vm.statusValue == 100)?_c('div',[_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitSurveyDescription()}}},[_vm._v("\n            Sende\n          ")])],1):_vm._e()])])]),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.statusConfirmation),callback:function ($$v) {_vm.statusConfirmation=$$v},expression:"statusConfirmation"}},[_c('div',{staticClass:"center p3"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){return _vm.cancelRecommendInvitationnew()}}},[_vm._v("\n          X\n        ")])]),_vm._v(" "),_c('p',{staticClass:"h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson"}),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('div',{staticClass:"clearfix pb3"},[_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"darkblue bold m0"},[_vm._v("Du har valgt, at du ikke kan afgive tilbud på opgaven. "),_c('br'),_c('br'),_vm._v("Vi vil automatisk informere kunden pr. mail, samt opgaven vil blive sendt retur til markedspladsen, så sandre kan hjælpe kunden.")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center"},[_c('b-button',{staticClass:"action-button  py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmRecommendInvitationnew()}}},[_vm._v("\n          Bekræft\n        ")])],1)])]),_vm._v(" "),_c('b-modal',{ref:"modalSurveyikke",staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"modalSurveyikke","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""}},[_c('div',{staticClass:"center p2"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){return _vm.closeSurveyModalikke()}}},[_vm._v("\n          X\n        ")])]),_vm._v(" "),_c('p',{staticClass:"h5 primarycolor semi-bold line-height-1 mt3 mb2 gibson"},[_vm._v("\n        Survey\n      ")]),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('div',{staticClass:"clearfix pb3 ",attrs:{"id":"surveyPopup"}},[_c('div',{staticClass:"col col-12 p0 mb4"},[_c('div',{staticClass:" col-12 flex mt2 p0 ",attrs:{"id":"ikkeoption"}},[_c('b-form-group',{staticClass:"col-12 white-background p0",attrs:{"id":"nameInput","label":"Vælg venligst årsagen til, hvorfor et tilbud ikke er tilgængeligt?","label-for":"optionikke"}},[_c('b-form-select',{staticClass:"border wizard-border col-12",attrs:{"options":_vm.alloptionikke,"required":""},model:{value:(_vm.optionikke),callback:function ($$v) {_vm.optionikke=$$v},expression:"optionikke"}})],1),_vm._v(" "),(_vm.showwikkeerror)?_c('el-alert',{attrs:{"title":"Vælg venligst fra de fremhævede datoer","type":"error","effect":"light","show-icon":""}}):_vm._e()],1)]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateStatusOther()}}},[_vm._v("\n            Sende\n          ")])],1)])])]),_vm._v(" "),_c('b-modal',{ref:"customerreviewsbypartners",attrs:{"id":"Reviews","hide-header":"","hide-footer":"","centered":""}},[(_vm.reviewsloading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"center p2"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){return _vm.closereviewsmodal()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),(_vm.allreviewsbycid.length > 0)?_c('div',[_c('div',{staticClass:"flex justify-around mobile-flex-column darkblue"},[_c('div',{staticClass:"xs-col-12 sm-col-3 lg-col-3 md-col-3 highlights flex flex-column mmb3"},[_c('div',{staticClass:"my2"},[_c('img',{staticClass:"rounded-circle border",attrs:{"src":_vm.customerdetails.image,"width":"80","height":"80"}})]),_vm._v(" "),_c('div',{staticClass:"center pt2 sm-hide lg-hide md-hide"},[_c('p',{staticClass:"semi-bold h4"},[_vm._v("Hej, jeg er "+_vm._s(_vm.customerdetails.name))]),_vm._v(" "),_c('p',{staticClass:"h6"},[_vm._v(_vm._s(_vm.customerdetails.zip))])]),_vm._v(" "),_c('div',{staticClass:" py3 border border-top-0 border-left-0 border-right-0"},[_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"id":"ratings_star","data-name":"ratings star","xmlns":"http://www.w3.org/2000/svg","width":"13.599","height":"14.137","viewBox":"0 0 13.599 14.137"}},[_c('path',{attrs:{"id":"Rectangle","d":"M284.537,378.051l6.8-4.363,6.8,4.363v9.775h-13.6Z","transform":"translate(-284.537 -373.688)","fill":"#19a3c0"}}),_c('path',{attrs:{"id":"Path_4010","data-name":"Path 4010","d":"M298.363,389.159l.992,2.663h2.55l-2.153,1.615,1.048,2.692-2.436-1.813-2.437,1.813,1.048-2.692-2.153-1.615h2.55Z","transform":"translate(-291.563 -384.258)","fill":"#fff"}})])]),_vm._v(" "+_vm._s(_vm.allreviewsbycid.length)+" reviews")]),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"verified","width":"11.479","height":"14.137","viewBox":"0 0 11.479 14.137"}},[_c('path',{attrs:{"id":"Path_1126","data-name":"Path 1126","d":"M5.551,14.093A14.449,14.449,0,0,1,2.8,12.2,9.771,9.771,0,0,1,.893,10.01,5.584,5.584,0,0,1,0,7.068V2.416a.422.422,0,0,1,.274-.4L5.591.027a.42.42,0,0,1,.3,0L11.2,2.021a.422.422,0,0,1,.274.4V7.068a5.584,5.584,0,0,1-.893,2.942A9.771,9.771,0,0,1,8.676,12.2a14.436,14.436,0,0,1-2.748,1.888.423.423,0,0,1-.377,0Z","transform":"translate(0 0)","fill":"#4dcf55"}}),_c('path',{attrs:{"id":"Icon_feather-check","data-name":"Icon feather-check","d":"M6.8,11.872a.421.421,0,0,1-.3-.124L5.124,10.372a.422.422,0,0,1,.6-.6L6.8,10.853,9.528,8.124a.422.422,0,0,1,.6.6L7.1,11.749A.421.421,0,0,1,6.8,11.872Z","transform":"translate(-1.885 -3.355)","fill":"#fff"}})])]),_vm._v(" Identified Verified")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.payproffv2_account_id)?_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},[_c('g',{attrs:{"id":"payproff","transform":"translate(-743 -333)"}},[_c('rect',{attrs:{"id":"Rectangle_738","data-name":"Rectangle 738","width":"14","height":"14","transform":"translate(743 333)","fill":"#2265fc"}}),_c('path',{attrs:{"id":"Path_4030","data-name":"Path 4030","d":"M-1813.8,992.119h7.174a2.932,2.932,0,0,1,2.316,2.682c.092,2.235-2.316,2.8-2.316,2.8h-4.188l-1.948,1.85v-4.22h4.36l-1.4,1.391h1.4l2.478-2.42h-7.877v7.78l3.344-3.342h3.831a3.841,3.841,0,0,0,2.527-1.325,3.719,3.719,0,0,0,.9-2.516,3.854,3.854,0,0,0-.9-2.382,4.043,4.043,0,0,0-2.527-1.325h-7.174Z","transform":"translate(2558.496 -656.539)","fill":"#fff"}})])])]),_vm._v(" Payproff Verified")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start mt3 px3 xs-col-8 mx-auto md-col-12 lg-col-12 sm-col-12"},[_c('p',{staticClass:"semi-bold h5 mb2"},[_vm._v(_vm._s(_vm.customerdetails.name)+" confirmed")]),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"regular font14 mb1"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Identified")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"regular font14 mb1"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Email Address")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.mobile)?_c('p',{staticClass:"regular font14"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Phone Number")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"xs-col-12 sm-col-8 lg-col-8 md-col-8 highlights p0"},[_c('div',{staticClass:"py2 mx2 border border-top-0 border-left-0 border-right-0 flex flex-column justify-start items-start xs-hide "},[_c('p',{staticClass:"semi-bold h4"},[_vm._v("Hej, jeg er "+_vm._s(_vm.customerdetails.name))]),_vm._v(" "),_c('p',{staticClass:"h6"},[_vm._v(_vm._s(_vm.customerdetails.address))])]),_vm._v(" "),_c('p',{staticClass:"my2 flex col-12 justify-start"},[_vm._v(_vm._s(_vm.allreviewsbycid.length)+" reviews")]),_vm._v(" "),_c('div',{staticClass:"px0 flex flex-column justify-start col-12"},_vm._l((_vm.allreviewsbycid),function(review){return _c('div',{key:review.id,staticClass:"p2 flex flex-column items-start m0 p0"},[_c('p',{staticClass:"font12 graylightcolor m0"},[_vm._v(_vm._s(_vm.moment(new Date(review.UF_REVIEW_DATE)).format('D MMMM YYYY')))]),_vm._v(" "),_c('p',{staticClass:"darkble h6 regular"},[_vm._v(_vm._s(review.UF_COMMENT))]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-start"},[_c('span',[_c('img',{staticClass:"rounded-circle border",attrs:{"src":"https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png","width":"40","height":"40"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column p0 m0 items-start pl1"},[_c('p',{staticClass:"darkble font13 regular m0"},[_vm._v(_vm._s(review.COMPANY_NAME))]),_vm._v(" "),_c('p',{staticClass:"graylightcolor font12 regular m0"},[_vm._v(_vm._s(review.COMPANY_ADDRESS))])])])])}),0)])])]):_c('div',{staticClass:"my4"},[_vm._v("\n        Ingen anmeldelser\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"quickandstandard",attrs:{"centered":"","hide-footer":"","id":"quickandstandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModalquickandstandard()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-close"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background px2 m2"},[_c('div',{staticClass:"flex flex-column items-center gibson"},[_c('p',{staticClass:"h5 my1 semi-bold"},[_vm._v("Vælg venligst")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between col-12"},[_c('a',{staticClass:"mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":'#/tilbud/upload-tilbud?app='+_vm.selectedId}},[_c('span',{staticClass:"mr1"},[_vm._v("Upload Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-position"})])]),_vm._v(" "),_c('a',{staticClass:"mr1 col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":'#/tilbud/hurtigt-tilbud?app='+_vm.selectedId}},[_c('span',{staticClass:"mr1"},[_vm._v("Hurtigt Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-d-arrow-right"})])]),_vm._v(" "),_c('a',{staticClass:" col-4 dark-button p2 h6 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":'#/tilbud/standardTilbud?app='+_vm.selectedId}},[_c('span',{staticClass:"mr1"},[_vm._v("Standard Tilbud")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-s-custom"})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",staticStyle:{"height":"50px"},attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"seeselectedoffer",attrs:{"hide-footer":"","size":"lg","centered":"","id":"seeselectedoffer","title":"Hent vejledning her"},model:{value:(_vm.seeselectedoffer),callback:function ($$v) {_vm.seeselectedoffer=$$v},expression:"seeselectedoffer"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closemodaloffer()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),(_vm.innerloading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h4 semi-bold py2 m0 "},[_vm._v("Tilbudsliste")]),_vm._v(" "),_c('div',{staticClass:"overflow-auto p2",staticStyle:{"height":"600px"}},[_vm._l((Object.keys(_vm.selectedArr)),function(industryfields,index){return _c('div',{key:index,staticClass:"flex flex-column mb2 pr2"},[_c('p',{staticClass:"m0 p0 h4 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '. ')+_vm._s(_vm.itemsjobindustry[industryfields]))]),_vm._v(" "),_vm._l((_vm.selectedArr[industryfields]),function(jobitem,index2){return _c('div',{key:index2},[_c('div',{staticClass:"flex items-center"},[_c('p',{staticClass:"m0 pl3 h4 xs-pl1 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '.')+_vm._s(index2 + 1 + ' ')+_vm._s(_vm.primaryproductindustryname[jobitem['INDUSTRY']]))]),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto "},[_c('p',[_vm._v(_vm._s((parseInt(jobitem['TOTAL'])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])]),_vm._v(" "),(jobitem.SERIES !== null)?_c('div',_vm._l((Object.values(jobitem.SERIES)),function(itemfields,index3){return _c('div',{key:index3},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-11 mr-auto"},[_c('div',{staticClass:"m0 pl4 xs-pl2 flex col-12"},[_c('div',{staticClass:"col-1 mr2"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)))]),_vm._v(" "),_c('div',{staticClass:"pl1"},[_vm._v(_vm._s(itemfields.replace('- ', '')))])])])])}),0):_vm._l((jobitem.SERIES_ORIGINAL),function(itemfields,index3){return _c('div',{key:index3},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-11 mr-auto"},[_c('div',{staticClass:"m0 pl4 xs-pl2 flex col-12"},[_c('div',{staticClass:"col-1 mr2"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)))]),_vm._v(" "),_c('div',{staticClass:"pl1"},[_vm._v(_vm._s(itemfields.replace('- ', '')))])])])])})],2)})],2)}),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"m0 p0 mt2"},[_vm._v("Haandvaerker's Standard tekst")]),_vm._v(" "),_c('div',{staticClass:"border round p2"},[_vm._v("\n                "+_vm._s(_vm.standardnote)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-11 px0 mx-auto border muted-border border-bottom-0 my3 border-left-0  border-right-0 pl2"},[_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Samlet pris ekskl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseInt(_vm.subtotaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Samlet pris inkl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseInt(_vm.totaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])])],2)])]),_vm._v(" "),_c('b-modal',{ref:"projectDescription",staticClass:"p3",attrs:{"hide-footer":"","size":"lg","centered":"","id":"projectDescription","title":"Project description"},model:{value:(_vm.projectDescription),callback:function ($$v) {_vm.projectDescription=$$v},expression:"projectDescription"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 p2"},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.projectDescription = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"semi-bold px3 mt2 h5"},[_vm._v("Job titel")]),_vm._v(" "),_c('div',{staticClass:"py2 px3"},[_c('p',{staticClass:"line-height-golden h5 regular"},[_vm._v(_vm._s(_vm.selectedprojecttitle))])])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"semi-bold px3 mt2 h5"},[_vm._v("Job beskrivelse")]),_vm._v(" "),_c('div',{staticClass:"py2 px3"},[_c('p',{staticClass:"line-height-golden h5 regular"},[_vm._v(_vm._s(_vm.selectedprojectdesc))])])])]),_vm._v(" "),_c('b-modal',{ref:"viewNote",staticClass:"p3 notosans",attrs:{"hide-header":"","hide-footer":"","size":"md","scrollable":"","centered":"","id":"viewNote","title":"Project description"},on:{"hide":function($event){return _vm.closenote()}},model:{value:(_vm.viewNote),callback:function ($$v) {_vm.viewNote=$$v},expression:"viewNote"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0"},[_c('button',{staticClass:"white-button no-border not-rounded",attrs:{"type":"button"},on:{"click":function($event){return _vm.closenote()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"p2"},[_c('div',{staticClass:"flex col-12 m0 p0 items-center mb2"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 m0"},[_vm._v("\n            "+_vm._s(_vm.companyName)+" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"p0 font14 regular m0"},[_vm._v("Liste Dine notater : ")])]),_vm._v(" "),_c('button',{staticClass:"dark-button p1 flex items-center justify-center ml-auto",on:{"click":function($event){_vm.addingnote = true}}},[_c('i',{staticClass:"h5 m0 el-icon-circle-plus-outline"}),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Tilføj note")])])]),_vm._v(" "),(_vm.partnernotesArr.length > 0)?_c('div',{staticClass:"flex flex-column m0 p0 col-12"},_vm._l((_vm.partnernotesArr),function(note,index){return _c('div',{key:index,staticClass:"border light-highlights my1 px2 py1 relative"},[_c('div',{staticClass:"absolute top-0 right-0 m1 pointer flex justify-around col-2 p0"},[_c('p',{staticClass:"px1 p0 m0 primarycolor-background",on:{"click":function($event){return _vm.deletenote(note.ID)}}},[_c('i',{staticClass:"white el-icon-delete"})])]),_vm._v(" "),_c('p',{staticClass:"p0 m0 pt3"},[_vm._v(_vm._s(note.NOTE))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap",staticStyle:{"gap":"10px"}},_vm._l((note.FILES),function(image,index2){return _c('img',{key:index2,staticClass:"rounded cover pointer",attrs:{"src":image.FILE_URL,"id":'imagedivreview' + index2,"width":"60px","height":"60px","alt":"notes images"},on:{"click":function($event){return _vm.opengallery(note.FILES)},"error":function($event){return _vm.checkimage(index2)}}})}),0)])}),0):_c('div',{staticClass:"py3"},[_c('p',{staticClass:"center"},[_vm._v("Ingen noter fundet")])])]),_vm._v(" "),(_vm.composenoteLoading)?_c('div',[_c('Loading')],1):_vm._e(),_vm._v(" "),(_vm.addingnote && !_vm.composenoteLoading)?_c('div',{staticClass:"p2"},[_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 4, maxRows: 6},"placeholder":"Tilføj din note her"},model:{value:(_vm.notedescription),callback:function ($$v) {_vm.notedescription=$$v},expression:"notedescription"}}),_vm._v(" "),_c('div',{staticClass:"mx-auto center pb2 pt3 mt2",staticStyle:{"border":"3px dashed rgb(25, 163, 192)"}},[_c('el-upload',{staticClass:"px3",attrs:{"action":"#","on-change":_vm.handleFileChange,"on-remove":_vm.removeImage,"before-upload":_vm.beforeFileUpload,"auto-upload":false,"accept":".jpg, .jpeg, .png, .webp","file-list":_vm.fileList,"list-type":"picture","limit":_vm.limitUpload,"multiple":true}},[_c('div',{staticClass:"flex items-center justify-center p0"},[_c('span',{staticClass:"mx2 relative"},[_c('svg',{attrs:{"fill":"#003645","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M406 195.1c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 167.7 0 222.1 0 289S54.4 410.3 121.3 410.3h84.7c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5 0-54.9 44.6-99.5 99.5-99.5 2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.2 4.9-0.4 7.5l-0.1 1.1c-0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.4 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-89.1c-6 0-10.9 4.9-10.9 10.9 0 6 4.9 10.9 10.9 10.9h89.1c59.3 0 107.6-48.3 107.6-107.6C512 243.9 464.6 196 406 195.1z"}}),_c('path',{attrs:{"d":"M262.8 105.2c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 0.5 0.1 1 0.1 1.5 0.1 5.4 0 10.1-4 10.8-9.4 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 110.1 268.8 105.2 262.8 105.2z"}}),_c('path',{attrs:{"d":"M312.4 320.1l-39.7-35.5c-6.8-6.1-17.2-6.1-24 0l-39.7 35.5c-4.5 4-4.9 10.9-0.9 15.4 4 4.5 10.9 4.9 15.4 0.9l26.3-23.5v134.3c0 6 4.9 10.9 10.9 10.9 6 0 10.9-4.9 10.9-10.9V312.9l26.3 23.5c2.1 1.9 4.7 2.8 7.3 2.8 3 0 6-1.2 8.1-3.6C317.3 331 316.9 324.1 312.4 320.1z"}})])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v("Vælg fil")])])])],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end col-12 m0 p0 py1"},[_c('button',{staticClass:"action-button px2 py1 h6 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitNoteBitrix()}}},[_c('span',{staticClass:"mb0"},[_vm._v("Gemme")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])],1):_vm._e()])]),_vm._v(" "),_c('b-modal',{ref:"gallerystagenew",staticClass:"m0 p0",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"gallerystagenew","hide-backdrop":"","width":"100%","size":"xl"},model:{value:(_vm.gallerystagenew),callback:function ($$v) {_vm.gallerystagenew=$$v},expression:"gallerystagenew"}},[_c('div',{staticClass:"lg-col-8 md-col-10 xs-p0 xs-col-12 flex justify-between items-center p0 mx-auto absolute p2 z4"},[_c('button',{staticClass:"mr-auto p0 border-none transparent pointer",on:{"click":function($event){return _vm.closengallery()}}},[_c('i',{staticClass:"el-icon-back h1 white"})])]),_vm._v(" "),(_vm.modalimageloading)?_c('div',{staticClass:"mx-auto"},[_c('Loading')],1):_c('div',{staticClass:"flex flex-row justify-center col-12 m0 p0 height-full"},[_c('div',{staticClass:"p0 m0 col-10 mt4 pt3"},[_c('el-carousel',{ref:"galleryonenew",attrs:{"interval":4000,"trigger":"click","setActiveItem":_vm.activestagephoto,"autoplay":false,"type":_vm.typegallery,"id":"galleryonenew","width":"100%","indicator-position":"outside"}},_vm._l((_vm.photos),function(item,index){return _c('el-carousel-item',{key:index,attrs:{"name":index.toString()}},[_c('img',{staticClass:"cover pointer",attrs:{"id":"imagedivreview","height":"100%","src":item.FILE_URL,"width":"100%","alt":""}})])}),1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"modalSurveyikkebitrix",staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"modalSurveyikkebitrix","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalSurveyikkebitrix),callback:function ($$v) {_vm.modalSurveyikkebitrix=$$v},expression:"modalSurveyikkebitrix"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2"},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closesurveyikkebitrix()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h5 center primarycolor semi-bold line-height-1 mt3 mb2"},[_vm._v("\n        Undersøgelse\n      ")]),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('div',{staticClass:"clearfix pb3 ",attrs:{"id":"surveyPopup"}},[_c('div',{staticClass:"col col-12 p0 mb4"},[_c('div',{staticClass:" col-12 flex mt2 p0 ",attrs:{"id":"ikkeoption"}},[_c('b-form-group',{staticClass:"col-12 white-background p0",attrs:{"id":"nameInput","label":"Vælg venligst årsagen til, at du ikke kan afgive tilbud","label-for":"optionikke"}},[_c('b-form-select',{staticClass:"border wizard-border col-12",attrs:{"options":_vm.alloptionikkebitrix,"required":""},model:{value:(_vm.optionikkebitrix),callback:function ($$v) {_vm.optionikkebitrix=$$v},expression:"optionikkebitrix"}})],1)],1),_vm._v(" "),(_vm.optionikkebitrix === 3)?_c('div',{staticClass:"col-12 flex mt2 p0 flex flex-column"},[_c('p',{staticClass:"m0 p0 regular"},[_vm._v("Dato for at minde dig om dette kundejob")]),_vm._v(" "),_c('el-date-picker',{staticClass:"px0 white-background rounded",attrs:{"size":"large","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","type":"date","placeholder":"start","picker-options":_vm.pickerOptions},model:{value:(_vm.cancelreminderdate),callback:function ($$v) {_vm.cancelreminderdate=$$v},expression:"cancelreminderdate"}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateStatusOtherbitrix()}}},[_vm._v("\n            Indsend\n          ")])],1)])])]),_vm._v(" "),_c('b-modal',{attrs:{"centered":"","hide-footer":"","hide-header":"","id":"quickVideoTutorialModal","size":"lg"},model:{value:(_vm.quickVideoTutorialModalVisible),callback:function ($$v) {_vm.quickVideoTutorialModalVisible=$$v},expression:"quickVideoTutorialModalVisible"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2"},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.quickVideoTutorialModalVisible = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('video',{attrs:{"poster":"https://www.haandvaerker.dk/imgs/afgiv_tilbud.jpg","width":"100%","height":"auto","controls":"","playsinline":"","loop":"","autoplay":"","muted":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"https://www.haandvaerker.dk/video/afgiv_tilbud.webm","type":"video/mp4"}}),_vm._v(" "),_c('source',{attrs:{"src":"https://www.haandvaerker.dk/video/afgiv_tilbud.mp4","type":"video/webm"}})])])]),_vm._v(" "),_c('checkpayproff',{ref:"checkpayproff",attrs:{"id":"checkpayproff"}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue gibson line-height-golden mb3"},[_vm._v("\n              Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester."),_c('br'),_c('br'),_vm._v("\n              Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine kunder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue gibson line-height-golden mb3 col-12 px0"},[_vm._v("\n                    Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester."),_c('br'),_c('br'),_vm._v("\n                    Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pr1 m0"},[_c('i',{staticClass:"el-icon-location-information primarycolor h6"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pr1 m0"},[_c('i',{staticClass:"el-icon-location-information primarycolor h6"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"h3 semi-bold line-height-1"},[_vm._v("Afvist")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"h3 semi-bold line-height-1"},[_vm._v("Afvist")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imentor',
  props: [],
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (localStorage.getItem('imentor') === '0') {
      this.show = true;
    }
  },

  methods: {}
});

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('div',{staticClass:"clearfix p2 darkblue-background white darkblue gibson mb2"},[_vm._m(0)]):_vm._e()}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p2"},[_c('p',{staticClass:"h4 semi-bold gibson white"},[_vm._v("\n      Opgrader dit abonnement\n    ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson white line-height-golden my2"},[_vm._v("\n      Ønsker du at modtage kvalificerede kundehenvendelser? Så kan du tilkøbe adgang til dette.\n    ")]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('button',{staticClass:"col-12 white-ghost-button p2 gibson h5 semi-bold not-rounded",attrs:{"href":"#/inbox?send=support&default=imentor"}},[_c('span',[_vm._v("Kontakt os her")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('allmeetings')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetings_minbolig_vue__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0e2c6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetings_minbolig_vue__ = __webpack_require__(914);
function injectStyle (ssrContext) {
  __webpack_require__(908)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetings_minbolig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b0e2c6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetings_minbolig_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 908 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__AllMeetingsTable_minbolig__ = __webpack_require__(910);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imentor__ = __webpack_require__(103);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_1__imentor__["a" /* default */],
    allmeetings: __WEBPACK_IMPORTED_MODULE_0__AllMeetingsTable_minbolig__["a" /* default */]
  },
  data: function data() {
    return {
      status: 'not_accepted'
    };
  }
});

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetingsTable_minbolig_vue__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093879ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetingsTable_minbolig_vue__ = __webpack_require__(913);
function injectStyle (ssrContext) {
  __webpack_require__(911)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllMeetingsTable_minbolig_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_093879ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_AllMeetingsTable_minbolig_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 911 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery_slideshow__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Countdown__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Countdown2__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_graphql_tag__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__noneligibleFeaturepop__ = __webpack_require__(43);



var _templateObject = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_taggedTemplateLiteral___default()(['query {\n          customers {\n            name,\n            phoneNumber,\n            email\n          }\n        }'], ['query {\n          customers {\n            name,\n            phoneNumber,\n            email\n          }\n        }']);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'allmeetings',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Countdown: __WEBPACK_IMPORTED_MODULE_7__components_Countdown__["a" /* default */],
    Countdown2: __WEBPACK_IMPORTED_MODULE_8__components_Countdown2__["a" /* default */],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__["a" /* default */],
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_5_vue_gallery_slideshow___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_6_vue_datetime__["Datetime"],
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_11_vue_bootstrap_datetimepicker___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_12__noneligibleFeaturepop__["a" /* default */],
    ImageRating: __WEBPACK_IMPORTED_MODULE_10_vue_rate_it__["ImageRating"]
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    var mobile = this.$route.query.mobile;
    if (mobile !== undefined) {
      this.search = mobile;
      this.$router.push('/alle-moeder');
    }
    this.klimaprofil = localStorage.getItem('ClimatePartner');
    this.salesPersonbitrix = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.Reload();
  },
  data: function data() {
    return {
      disableStatusSelection: false,
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      browserName: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      urlpris: '',
      datereminder: null,
      label: 'Loading...',
      service_reminder: '',
      AflyseText: '',
      search: '',
      CommentText: '',
      CommentCustomText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      showMobile: false,
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowkomment: false,
      textKomment: '',
      modalShowFeedback: false,
      textFeedback: '',
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPersonbitrix: '',
      haaId: '',
      oldestFirst: false,
      ascending: true,
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      },
      customer: {
        id: 5,
        firstName: '',
        lastName: '',
        email: ''
      },
      apollo: {
        customers: Object(__WEBPACK_IMPORTED_MODULE_9_graphql_tag__["a" /* default */])(_templateObject)
      },
      partnerImg: '',
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      surveySteps: {
        active: 0
      },
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      surveyId: '',
      priceFeedBackData: {
        priceManualChecked: false,
        price: 0,
        priceManualDisabled: true,
        steps: 1,
        nps: 0,
        note: ''
      },
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      optionikke: '',
      alloptionikke: [{ value: 0, text: 'Vælg venligst en mulighed' }, { value: 101, text: 'Kunden skal ikke have det lavet' }, { value: 102, text: 'Jeg har for travlt og kan ikke varetage opgaven alligevel' }, { value: 103, text: 'Projektet skal først laves langt ude i fremtiden' }, { value: 104, text: 'Kunden ønsker først et tilbud langt ude i fremtiden' }, { value: 105, text: 'Kunden har fået opgaven udført af en anden håndværker' }],
      showwikkeerror: false,

      allreviewsbycid: [],
      customerdetails: {
        name: '',
        email: '',
        mobile: '',
        image: '',
        address: '',
        email_verified: '',
        payproffv2_account_id: ''
      },
      reviewsloading: false
    };
  },

  filters: {
    truncate: function truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    }
  },
  watch: {},
  computed: {},
  mounted: function mounted() {
    this.getyearsarray();
  },

  methods: {
    getbrowser: function getbrowser() {
      var userAgent = navigator.userAgent;
      if (userAgent.match(/chrome|chromium|crios/i)) {
        this.browserName = 'chrome';
      } else if (userAgent.match(/firefox|fxios/i)) {
        this.browserName = 'firefox';
      } else if (userAgent.match(/safari/i)) {
        this.browserName = 'safari';
        this.status = 9;
        console.log('browserName', this.browserName);
      } else if (userAgent.match(/opr\//i)) {
        this.browserName = 'opera';
      } else if (userAgent.match(/edg/i)) {
        this.browserName = 'edge';
      } else {
        this.browserName = 'No browser detection';
      }
    },
    getyearsarray: function getyearsarray() {
      var initialyear = 2018;
      var latestyear = new Date().getFullYear();
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear);
        initialyear++;
      }
      this.allyear.reverse();
    },
    filteryear: function filteryear(year) {
      if (this.activeyear !== '') {
        var oldyear = this.activeyear;
        document.getElementById('yearfilter-' + oldyear).classList.add('primary-button-green');
        document.getElementById('yearfilter-' + oldyear).classList.remove('green-background');
      }
      this.activeyear = year;
      document.getElementById('yearfilter-' + year).classList.add('green-background');
      document.getElementById('yearfilter-' + year).classList.remove('primary-button-green');
      var itemsyear = [];
      var filteredyear = [];
      itemsyear = this.items.filter(function (item) {
        var createditemyear = new Date(item.createdtime).getFullYear();
        if (createditemyear === year) {
          return item.createdtime;
        }
      });
      itemsyear.forEach(function (value) {
        filteredyear.push(value);
      });
      this.SearchItem = this.filterSearch(filteredyear);
    },
    getdataigibility: function getdataigibility(appid, contactid) {
      if (this.klimaprofil === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.klimaprofil, '', 'ClimatePartner');
      } else {
        this.gotoKlima(appid, contactid);
      }
    },
    gotoKlima: function gotoKlima(appointmentId, contactId) {
      this.$router.push('/klima/checklist?appointmentId=' + appointmentId + '&contactId=' + contactId);
    },
    showprojectdash: function showprojectdash() {
      this.$router.push('/customer-projects/project-dashboard');
    },
    Reload: function Reload() {
      var _this = this;

      if (screen.width <= 640) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/jobs', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.items = res.data;
        if (_this.search !== '') {
          _this.updateSearch();
        } else {
          _this.SearchItem = _this.items;
        }

        _this.disableStatusSelection = false;
        _this.loading = false;
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this.refreshtoken();
          setTimeout(function () {
            _this.Reload();
          }, 1000);
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this2.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this2.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this2.$router.push('/login');
      });
    },
    closereviewsmodal: function closereviewsmodal() {
      this.$refs.customerreviewsbypartners.hide();
    },
    getReviewIdbycustomerId: function getReviewIdbycustomerId(id) {
      var _this3 = this;

      this.$refs.customerreviewsbypartners.show();
      this.reviewsloading = true;
      this.salesPersonbitrixbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrixbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/GetAllReviewsDoneByHomeOwners?customerId=' + id, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          _this3.customerdetails.name = response.body.data.NAME;
          _this3.customerdetails.email = response.body.data.EMAIL;
          _this3.customerdetails.address = response.body.data.ADDRESS;
          _this3.customerdetails.mobile = response.body.data.MOBILE;
          _this3.customerdetails.image = response.body.data.PICTURE;
          _this3.customerdetails.email_verified = response.body.data.EMAIL_VERIFIED;
          _this3.customerdetails.payproffv2_account_id = response.body.data.IS_PAYPROFF_VERIFIED;
          _this3.allreviewsbycid = response.body.data.REVIEWS;
          _this3.reviewsloading = false;
        } else {
          _this3.reviewsloading = false;
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this3.refreshtoken();
          setTimeout(function () {
            _this3.getReviewIdbycustomerId();
          }, 1000);
        }
      });
    },
    onClick: function onClick(item, i) {
      item.index = i;
    },
    filterSearch: function filterSearch(item) {
      return item;
    },
    updateSearch: function updateSearch() {
      var _this4 = this;

      var items = [];
      items = this.items.filter(function (item) {
        return item.firstname.toLowerCase().includes(_this4.search.toLowerCase()) || item.lastname.toLowerCase().includes(_this4.search.toLowerCase()) || item.mailingstreet.toLowerCase().includes(_this4.search.toLowerCase()) || item.mailingzip.toLowerCase().includes(_this4.search.toLowerCase()) || item.mailingcity.toLowerCase().includes(_this4.search.toLowerCase()) || item.email.toLowerCase().includes(_this4.search.toLowerCase()) || item.comment_to_partner.toLowerCase().includes(_this4.search.toLowerCase()) || item.comment_to_customer.toLowerCase().includes(_this4.search.toLowerCase()) || item.mobile.toLowerCase().includes(_this4.search.toLowerCase());
      });
      this.SearchItem = this.filterSearch(items);
    },
    toggleSort: function toggleSort(statusDate) {
      var items = [];
      var order;
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times);
          b = new Date(b.appointment_date + ' ' + b.id_times);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status;
          b = b.id_appointment_status;
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.ascending = !this.ascending;
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date);
          b = new Date(b.tilbud_date);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve);
          b = new Date(b.datereserve);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else {}
    },
    toggleFilter: function toggleFilter(status) {
      var items = [];
      var filtered = [];
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('1');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '10') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('0');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i]);
            items = this.items.filter(function (item) {
              return item.tilbudstatus === statuscatcher;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '8') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length > 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '7') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length < 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '12') {
            items = this.items.filter(function (item) {
              return item.tilbudstatus === 6;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
        }
        this.SearchItem = this.filterSearch(filtered);
      } else {
        this.SearchItem = this.filterSearch(this.items);
      }
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
    },
    prisUrlOpen: function prisUrlOpen(item) {
      this.modalShowPris = true;
      this.urlpris = item.potentialnameurl;
    },
    prisUrlOpendato: function prisUrlOpendato(item) {
      this.modalShowPris = true;
      this.urlpris = item.changedateurl;
    },
    prisUrlOpenFile: function prisUrlOpenFile(item) {
      this.modalShowPris = true;
      this.urlpris = item.potentialnameurl + '&file=1';
    },
    changeStatus: function changeStatus(value, item) {
      this.statusValue = value;
      this.statusItem = item;
      this.disableStatusSelection = true;

      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true;
          this.showPriceFeedBackModal();
        } else {
          this.updateStatus(value, item);
        }
      } else if (value === '5' || value === '6') {
        this.feedbackLoading = true;
        this.showSurveyModal();
      } else if (value === '100') {
        this.showikkeform();
      } else {
        this.updateStatus(value, item);
      }
    },
    updateStatusOther: function updateStatusOther() {
      var _this5 = this;

      var item = this.statusItem;
      var valueid = this.optionikke;
      var dataPartner = {
        operation: 'customer_other_status_henttilbud',
        salesPersonbitrix: this.salesPersonbitrix,
        status: valueid,
        cid: item.id_appointment
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        _this5.updateStatus(100, item);
        _this5.closeSurveyModalikke();
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this5.$refs.simplert.openSimplert(obj);
      }, function (response) {
        console.log('Error in updateStatus()', response);
      });
    },
    updateStatus: function updateStatus(value, item) {
      var _this6 = this;

      this.modalPriceFeedback = false;
      this.modalSurvey = false;
      this.isLoadingReview = true;
      var dataPartner = { operation: 'customer_status_henttilbud', salesPersonbitrix: this.salesPersonbitrix, status: value, cid: item.id_appointment, descp: this.surveyDescription };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        _this6.isLoadingReview = false;
        _this6.surveyDescription = '';
        var infoType = '';
        if (res.success) {
          infoType = 'success';
        } else {
          infoType = 'info';
        }
        var obj = {
          title: res.message,
          message: '',
          type: infoType,
          customCloseBtnText: 'Luk'
        };
        _this6.$refs.simplert.openSimplert(obj);
        _this6.Reload();
      }, function (response) {
        console.log('Error in updateStatus()', response);
      });
    },
    submitSurveyDescription: function submitSurveyDescription() {
      if (this.surveyDescription !== '') {
        var value = this.statusValue;
        var item = this.statusItem;
        if (value === '100') {
          this.modalSurvey = false;
          var thisVar = this;
          setTimeout(function () {
            thisVar.statusConfirmation = true;
          }, 1000);
        } else {
          this.updateStatus(value, item);
        }
      } else {
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    feedbackLoaded: function feedbackLoaded() {},
    priceManualChanged: function priceManualChanged() {
      if (this.priceFeedBackData.priceManualChecked) {
        this.priceFeedBackData.priceManualDisabled = false;
      } else {
        this.priceFeedBackData.priceManualDisabled = true;
      }
    },
    getSurveyId: function getSurveyId() {
      var _this7 = this;

      var data = { operation: 'partner_survey', salesPersonbitrix: this.salesPersonbitrix };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.surveyId = res.url;
      }, function (response) {
        console.log('Error in getSurveyId()', response);
      });
    },
    showPriceFeedBackModal: function showPriceFeedBackModal() {
      this.modalPriceFeedback = true;
      var thisVar = this;
      setTimeout(function () {
        thisVar.feedbackLoading = false;
      }, 1000);
    },
    closePriceFeedBackModal: function closePriceFeedBackModal() {
      var value = this.statusValue;
      var item = this.statusItem;
      if (value === '4') {
        setTimeout(function () {
          var buttonRecommendation = document.getElementById('recommendInvitation-' + item.id_appointment);
          buttonRecommendation.click();
        }, 1000);
      } else {
        this.updateStatus(value, item);
      }
      this.modalPriceFeedback = false;
      this.priceFeedBackData.priceManualChecked = false;
      this.priceFeedBackData.price = 0;
      this.priceFeedBackData.priceManualDisabled = true;
      this.priceFeedBackData.steps = 1;
      this.priceFeedBackData.nps = 0;
      this.priceFeedBackData.note = '';
    },
    showSurveyModal: function showSurveyModal() {
      this.modalSurvey = true;
      var thisVar = this;
      setTimeout(function () {
        thisVar.feedbackLoading = false;
        document.querySelector('#surveyPopup').classList.remove('hide');
      }, 1000);
    },
    closeSurveyModal: function closeSurveyModal() {
      this.surveyDescription = '';
      this.Reload();
      this.modalSurvey = false;
    },
    getPartnerImage: function getPartnerImage() {
      var _this8 = this;

      var data = { operation: 'oversigt_partner_haa', salesPersonbitrix: this.salesPersonbitrix, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.resultImages.length !== 0) {
          _this8.partnerImg = res.resultImages[0].FileLocation;
        }
      }, function (response) {
        alert('error');
      });
    },
    confirmRecommendInvitation: function confirmRecommendInvitation(value, item, answer) {
      var _this9 = this;

      if (answer === 'yes') {
        return function (dialog) {
          return _this9.sendRecommendInvitation(value, item);
        };
      } else {
        return function (dialog) {
          return _this9.dontSendRecommendInvitation(value, item);
        };
      }
    },
    confirmRecommendInvitationnew: function confirmRecommendInvitationnew() {
      var value = this.statusValue;
      var item = this.statusItem;
      this.statusConfirmation = false;
      this.updateStatus(value, item);
    },
    cancelRecommendInvitationnew: function cancelRecommendInvitationnew() {
      this.Reload();
      this.surveyDescription = '';
      this.statusConfirmation = false;
    },
    showMeetingTilbudcreate: function showMeetingTilbudcreate(item) {
      this.$router.push('/tilbud/standardTilbud?app=' + item.CUSTOMER_ID + '&projectId=' + item.PROJECT_ID + '&contactId=' + item.CUSTOMER_ID + '&name=' + item.CUSTOMER_NAME + '&email=' + item.CUSTOMER_EMAIL + '&mobile=' + item.CUSTOMER_MOBILE + '&address=' + item.PROJECT_ADDRESS);
    },
    sendRecommendInvitation: function sendRecommendInvitation(value, item) {
      var _this10 = this;

      var customers = [];
      customers.push({
        name: item.firstname + ' ' + item.lastname,
        email: item.email,
        mobile: item.mobile
      });
      var data = {
        operation: 'service_invite_action',
        salesPersonbitrix: this.salesPersonbitrix,
        levid: this.haaId,
        customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(customers),
        imgPicked: this.partnerImg,
        bcc: '0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.updateStatus(value, item);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    dontSendRecommendInvitation: function dontSendRecommendInvitation(value, item) {
      this.updateStatus(value, item);
    },
    cancelDidNotWinTask: function cancelDidNotWinTask() {
      this.Reload();
      this.modalSurvey = false;
    },
    showMeetingDetailsAflyse: function showMeetingDetailsAflyse(item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?';
      this.modalShowAflyse = true;
      this.Aflyseid = item;
      this.textAflyseReason = '';
      this.isLoadingAflyse = false;
    },
    filterItem: function filterItem(items) {
      var newItem = [];
      for (var iteme in items) {
        newItem.push(items[iteme]);
      }
      return newItem;
    },
    showMeetingDetails: function showMeetingDetails(item) {
      this.meetingShow = !this.meetingShow;
      this.sampleMeeting.id = item.id;
      this.sampleMeeting.type = item.type;
      this.sampleMeeting.estimate = item.estimate;
      this.sampleMeeting.city = item.city;
      this.sampleMeeting.postnummer = item.postnummer;
      this.sampleMeeting.price = item.price;
      this.sampleMeeting.date = item.date;
    },
    hideModal: function hideModal() {
      this.$refs.meetingModal.hide();
    }
  }
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"mycustomerbolig"}},[_c('div',{staticClass:"clearfix gibson mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix py3"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 p0 m0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 pl0",staticStyle:{"background":"transparent"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6 right",attrs:{"id":"m2m"}},[_c('div',{staticClass:" my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\n                    Vælg\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2"},[_c('div',{staticClass:"col-6 px0"},[_c('b-form-checkbox',{attrs:{"id":"sortByStatusxxl1","name":"sortByStatusxxl1","value":"10"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Mester til Mester")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWorkxxl1","name":"sortByHaveWorkxxl1","value":"9"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("private")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl1","name":"sortByNeedeWorkxxl1","value":"8"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Med Tilbud")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl2","name":"sortByNeedeWorkxxl2","value":"7"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Uden Tilbud")])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByquickofferl2","name":"sortByquickofferl2","value":"100"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Kan ikke afgive tilbud")])]),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"ikkerelevant","name":"ikkerelevant","value":"12"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("ikke relevant")])])],1),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByStatusxxl2","name":"sortByStatusxxl2","value":"0"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Ny opgave")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWorkxxl2","name":"sortByHaveWorkxxl2","value":"1"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("I dialog")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl3","name":"sortByNeedeWorkxxl3","value":"2"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Tilbud er sendt")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl4","name":"sortByNeedeWorkxxl4","value":"3"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Vandt opgaven")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl5","name":"sortByNeedeWorkxxl5","value":"4"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Opgaven er udført")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByNeedeWorkxxl6","name":"sortByNeedeWorkxxl6","value":"5"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml0 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Vandt ikke opgaven")])])],1)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.toggleFilter(_vm.status)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6",attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\n                    Tilpas rækkefølgen\n                  ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"sortByDatexxl","aria-describedby":ariaDescribedby,"name":"sortByDatexxl","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter mødedato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sortByStatusxxl","aria-describedby":ariaDescribedby,"name":"sortByStatusxxl","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter status")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"offerSentxxl","aria-describedby":ariaDescribedby,"name":"offerSentxxl","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter sendt tilbud dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"followUpxxl","aria-describedby":ariaDescribedby,"name":"followUpxxl","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter opfølgningsdato")])])],1)]}}])}),_vm._v(" "),_c('div',{staticClass:"pb5"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-6 action-button p2 gibson not-rounded",on:{"click":function($event){return _vm.toggleSort(_vm.statusDate)}}},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),(_vm.browserName !== 'safari')?_c('div',{staticClass:"flex flex-column col-12 p0 m0 my2"},[_c('p',{staticClass:"col-12 h5 semi-bold darkblue p0"},[_vm._v("Oversigt over dine kunder om året")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.allyear),function(item,index){return _c('button',{key:index,staticClass:"primary-button-green pointer regular h5 white p2 mr1",staticStyle:{"width":"120px"},attrs:{"id":'yearfilter-' + item},on:{"click":function($event){return _vm.filteryear(item)}}},[_vm._v(_vm._s(item)+"\n              ")])}),0)]):_vm._e()],1)])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:" flex flex-wrap justify-start items-stretch"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"flex items-stretch relative lg-col-3 md-col-4"},[_c('div',{staticClass:"col-12 border muted-border p2 py3 shadow mb3"},[_c('div',{staticClass:"col-12 text-right"},[_c('div',[_c('el-tooltip',{attrs:{"placement":"bottom","effect":"light"}},[_c('img',{attrs:{"src":"static/svg/check-mark.svg","rel":"preload","width":"12%"}})])],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 mt2"},[_c('div',{staticClass:"col-12 gibson darkblue flex"},[_c('div',{staticClass:"pr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"m116 166c-5.5 0-10 4.5-10 10s4.5 10 10 10 10-4.5 10-10-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m30 512h452c16.5 0 30-13.5 30-30v-412c0-16.5-13.5-30-30-30h-16v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-60v-10c0-16.5-13.5-30-30-30s-30 13.5-30 30v10h-16c-16.5 0-30 13.5-30 30v412c0 16.5 13.5 30 30 30zm452-20h-452c-5.5 0-10-4.5-10-10v-336h472v336c0 5.5-4.5 10-10 10zm-56-462c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-120 0c0-5.5 4.5-10 10-10s10 4.5 10 10v10h-20zm-36 30h16v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h100v13c0 16.5 13.5 30 30 30 5.5 0 10-4.5 10-10s-4.5-10-10-10c-5.5 0-10-4.5-10-10v-13h56c5.5 0 10 4.5 10 10v56h-472v-56c0-5.5 4.5-10 10-10zm0 0"}}),_c('path',{attrs:{"d":"m396 166h-240c-5.5 0-10 4.5-10 10s4.5 10 10 10h240c5.5 0 10-4.5 10-10s-4.5-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m256 226c-60.7 0-110 49.3-110 110s49.3 110 110 110 110-49.3 110-110-49.3-110-110-110zm0 200c-49.6 0-90-40.4-90-90s40.4-90 90-90 90 40.4 90 90-40.4 90-90 90zm0 0"}}),_c('path',{attrs:{"d":"m288.9 308.9-42.9 42.9-22.9-22.9c-3.9-3.9-10.2-3.9-14.1 0s-3.9 10.2 0 14.1l30 30c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l50-50c3.9-3.9 3.9-10.2 0-14.1s-10.2-3.9-14.1 0zm0 0"}})])]),_vm._v(" "),_vm._m(1,true)])]),_vm._v(" "),_c('div',{staticClass:"col-12 gibson"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"darkblue mb1"},[_c('div',{staticClass:"flex justify-start items-center",staticStyle:{"visibility":"hidden"}},[_c('div',[_c('svg',{staticClass:"relative jam jam-user-circle",staticStyle:{"top":"3px"},attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2zM5.91 16.876a8.033 8.033 0 0 1-1.58-1.232 5.57 5.57 0 0 1 2.204-1.574 1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.652 3.652 0 0 0-1.41-.964 1 1 0 1 1 .712-1.868 5.65 5.65 0 0 1 2.284 1.607 8.032 8.032 0 0 1-1.586 1.225z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 m0 ml1 p0"})])])])]),_vm._v(" "),_c('div',{staticClass:"darkblue mb1 flex col-12 p0 pointer",on:{"click":function($event){return _vm.getReviewIdbycustomerId(item.CUSTOMER_ID)}}},[_c('div',{staticClass:"flex justify-start items-center mr-auto"},[_c('div',[_c('svg',{staticClass:"relative jam jam-user-circle",staticStyle:{"top":"3px"},attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-14a4 4 0 0 1 4 4v2a4 4 0 1 1-8 0V8a4 4 0 0 1 4-4zm0 2a2 2 0 0 0-2 2v2a2 2 0 1 0 4 0V8a2 2 0 0 0-2-2zM5.91 16.876a8.033 8.033 0 0 1-1.58-1.232 5.57 5.57 0 0 1 2.204-1.574 1 1 0 1 1 .733 1.86c-.532.21-.993.538-1.358.946zm8.144.022a3.652 3.652 0 0 0-1.41-.964 1 1 0 1 1 .712-1.868 5.65 5.65 0 0 1 2.284 1.607 8.032 8.032 0 0 1-1.586 1.225z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 m0 ml1 p0"},[_vm._v("Egne kunder")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto flex items-center"},[_c('image-rating',{attrs:{"rating":5,"src":"/static/svg/single-house-blue.svg","max-rating":5,"increment":0.5,"item-size":15,"spacing":1,"show-rating":false,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-start"},[_c('p',{staticClass:"h4 darkblue semi-bold line-height-3"},[_vm._v("\n            "+_vm._s(item.CUSTOMER_NAME)+"\n          ")])]),_vm._v(" "),[_c('div',{staticClass:"col-12 gibson"},[_c('span',[_vm._v("Minbolig Customer ID: "+_vm._s(item.CUSTOMER_ID))])])],_vm._v(" "),_c('div',{staticClass:"col-12 gibson mt3"},[_c('p',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('optionsCollapse'),expression:"'optionsCollapse'"}],staticClass:"h5 primarycolor regular line-height-1 mb0 flex justify-between items-start"},[_c('span',[_vm._v("Se mere information om kunden")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-6.172l3.536-3.535a1 1 0 0 1 1.414 1.414l-4.243 4.243a1 1 0 0 1-1.414 0L5.05 9.707a1 1 0 0 1 1.414-1.414L10 11.828z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"})]),_vm._v(" "),_c('div',{staticClass:"col-12 mb1"},[_c('button',{staticClass:"kundebutton col-12 outlined-action-button p1 flex justify-center items-center gibson line-height-1",on:{"click":function($event){return _vm.showMeetingTilbudcreate(item)}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2 "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"18","viewBox":"0 0 21.805 13.414"}},[_c('path',{attrs:{"id":"opret_tilbud","data-name":"opret tilbud","d":"M.476,13.414A.477.477,0,0,1,0,12.938V3.99a.477.477,0,0,1,.476-.476H1.49L2.337.352A.476.476,0,0,1,2.778,0H2.8a.507.507,0,0,1,.12.015L15.261,3.322a.475.475,0,0,1,.348.395l.317,2.233a2.79,2.79,0,0,1,2.308,1.676,2.819,2.819,0,0,1,.134.385A5.351,5.351,0,0,1,19,7.988h.411a2.374,2.374,0,0,1,1.692.7,2.4,2.4,0,0,1,.7,1.692.476.476,0,1,1-.951,0A1.443,1.443,0,0,0,19.413,8.94c-.15,0-.289,0-.423.007-.113,0-.221.006-.319.006-.078,0-.15,0-.216-.006a2.8,2.8,0,0,1-3.749,2.41l-1.039,1.818a.476.476,0,0,1-.413.24Zm.475-.952H12.978l.9-1.581a2.809,2.809,0,0,1-.875-1.3A1.434,1.434,0,1,1,14,9.2a1.723,1.723,0,0,0,.421.737l.839-1.468-2.285-4H.951Zm14.717-2a1.73,1.73,0,0,0,.414-3.409l.179,1.259a.483.483,0,0,1-.037.388l-.977,1.709A1.722,1.722,0,0,0,15.668,10.462ZM12.55,8.145a.476.476,0,0,0,.328.457,2.8,2.8,0,0,1,.207-.935l-.055,0A.476.476,0,0,0,12.55,8.145Zm2.429-2.1-.268-1.89L13.752,3.9ZM12.3,3.514,3.133,1.058,2.474,3.514Z","fill":"#4dcf55"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start"},[_vm._v("tilbud - PID "+_vm._s(item.PROJECT_ID))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb1"},[_c('button',{staticClass:"kundebutton col-12 outlined-primary-button p1 flex justify-center items-center gibson line-height-1",on:{"click":function($event){return _vm.showprojectdash()}}},[_c('span',{staticClass:"relative col-4 flex justify-end pr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"18","viewBox":"0 0 13.366 13.228"}},[_c('path',{attrs:{"id":"Styr_Projekt","data-name":"Styr Projekt","d":"M9.651,13.131a1.646,1.646,0,0,1-.557.1H1.654A1.656,1.656,0,0,1,0,11.574V1.655A1.656,1.656,0,0,1,1.654,0H6.633a.417.417,0,0,1,.289.135l3.706,3.706.019.02a.414.414,0,0,1,.1.273V8.649a4,4,0,0,1,2.574,2.089.414.414,0,0,1,0,.371c-.043.086-1.081,2.119-2.97,2.119A2.584,2.584,0,0,1,9.651,13.131ZM8.23,10.922A2.813,2.813,0,0,0,10.352,12.4a2.8,2.8,0,0,0,2.123-1.476,2.812,2.812,0,0,0-2.123-1.478A2.8,2.8,0,0,0,8.23,10.922ZM.828,1.655v9.92a.827.827,0,0,0,.826.826H8.381a4.868,4.868,0,0,1-1-1.291.418.418,0,0,1,0-.371,3.99,3.99,0,0,1,2.6-2.093l-.063.01V4.548H6.615A.415.415,0,0,1,6.2,4.134V.828H1.654A.828.828,0,0,0,.828,1.655ZM10,8.643h0Zm.454-.022h0Zm-.022,0h0Zm-.023,0h0Zm-.023,0h0Zm-.061,0h0Zm.032,0h0ZM7.029,3.72H9.335L7.029,1.413Zm2.2,7.2a1.123,1.123,0,1,1,1.123,1.123A1.124,1.124,0,0,1,9.23,10.924Zm.828,0a.3.3,0,1,0,.295-.3A.3.3,0,0,0,10.058,10.924ZM2.9,9.8a.414.414,0,1,1,0-.828H5.657a.414.414,0,1,1,0,.828Zm0-2.069a.414.414,0,1,1,0-.828H7.727a.414.414,0,0,1,0,.828Zm0-2.559a.414.414,0,1,1,0-.828h1.24a.414.414,0,1,1,0,.828Z","fill":"#19a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 mb0 line-height-1 semi-bold col-8 p0 flex justify-start"},[_vm._v("Styr projekt - "+_vm._s(item.PROJECT_ID))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb1"},_vm._l((item.STATUS),function(itemitem,index){return (itemitem.IS_SELECTED)?_c('div',{key:index,staticClass:"col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0 flex justify-center items-center",staticStyle:{"height":"48px","font-size":"18.5px!important"}},[[_vm._v("\n              "+_vm._s(itemitem.TITLE_DK)+"\n            ")]],2):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"clearfix mb1"},[_c('input',{attrs:{"type":"hidden","id":'tilbudstatusval-'}}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ ok: _vm.confirmRecommendInvitation('4', item, 'yes'), cancel: _vm.confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}),expression:"{ ok: confirmRecommendInvitation('4', item, 'yes'), cancel: confirmRecommendInvitation('4', item, 'no'), message: 'Vil du sende en invitation til en anbefaling?', okText: 'Ja', cancelText: 'Nej',}"}],staticClass:"hide",attrs:{"type":"button","id":'recommendInvitation-'}},[_vm._v("Recommend Invitation")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start items-center mt2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'),expression:"'setReminder'"}],staticClass:"p1 flex-auto gibson outlined-standard-button not-rounded border-none justify-start items-center",attrs:{"id":'setReminderb'}},[[_c('div',{staticClass:"flex justify-start items-center regular"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"2px"}},[_c('svg',{staticClass:"jam jam-bell",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z"}})])]),_vm._v(" "),_c('span',{staticClass:"mb0 semi-bold",staticStyle:{"font-size":"18.5px"}},[_vm._v("\n                  Tilføj påmindelse\n                ")])])]],2),_vm._v(" "),_vm._m(2,true)])],2)])}),0),_vm._v(" "),_c('b-modal',{ref:"customerreviewsbypartners",attrs:{"id":"Reviews","hide-header":"","hide-footer":"","centered":""}},[(_vm.reviewsloading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"center p2"},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold border-none transparent",attrs:{"type":"reset"},on:{"click":function($event){return _vm.closereviewsmodal()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),(_vm.allreviewsbycid.length > 0)?_c('div',[_c('div',{staticClass:"flex justify-around mobile-flex-column darkblue"},[_c('div',{staticClass:"xs-col-12 sm-col-3 lg-col-3 md-col-3 highlights flex flex-column mmb3"},[_c('div',{staticClass:"my2"},[_c('img',{staticClass:"rounded-circle border",attrs:{"src":_vm.customerdetails.image,"width":"80","height":"80"}})]),_vm._v(" "),_c('div',{staticClass:"center pt2 sm-hide lg-hide md-hide"},[_c('p',{staticClass:"semi-bold h4"},[_vm._v("Hej, jeg er "+_vm._s(_vm.customerdetails.name))]),_vm._v(" "),_c('p',{staticClass:"h6"},[_vm._v(_vm._s(_vm.customerdetails.zip))])]),_vm._v(" "),_c('div',{staticClass:" py3 border border-top-0 border-left-0 border-right-0 mx2"},[_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"id":"ratings_star","data-name":"ratings star","xmlns":"http://www.w3.org/2000/svg","width":"13.599","height":"14.137","viewBox":"0 0 13.599 14.137"}},[_c('path',{attrs:{"id":"Rectangle","d":"M284.537,378.051l6.8-4.363,6.8,4.363v9.775h-13.6Z","transform":"translate(-284.537 -373.688)","fill":"#19a3c0"}}),_c('path',{attrs:{"id":"Path_4010","data-name":"Path 4010","d":"M298.363,389.159l.992,2.663h2.55l-2.153,1.615,1.048,2.692-2.436-1.813-2.437,1.813,1.048-2.692-2.153-1.615h2.55Z","transform":"translate(-291.563 -384.258)","fill":"#fff"}})])]),_vm._v(" "+_vm._s(_vm.allreviewsbycid.length)+" reviews")]),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"verified","width":"11.479","height":"14.137","viewBox":"0 0 11.479 14.137"}},[_c('path',{attrs:{"id":"Path_1126","data-name":"Path 1126","d":"M5.551,14.093A14.449,14.449,0,0,1,2.8,12.2,9.771,9.771,0,0,1,.893,10.01,5.584,5.584,0,0,1,0,7.068V2.416a.422.422,0,0,1,.274-.4L5.591.027a.42.42,0,0,1,.3,0L11.2,2.021a.422.422,0,0,1,.274.4V7.068a5.584,5.584,0,0,1-.893,2.942A9.771,9.771,0,0,1,8.676,12.2a14.436,14.436,0,0,1-2.748,1.888.423.423,0,0,1-.377,0Z","transform":"translate(0 0)","fill":"#4dcf55"}}),_c('path',{attrs:{"id":"Icon_feather-check","data-name":"Icon feather-check","d":"M6.8,11.872a.421.421,0,0,1-.3-.124L5.124,10.372a.422.422,0,0,1,.6-.6L6.8,10.853,9.528,8.124a.422.422,0,0,1,.6.6L7.1,11.749A.421.421,0,0,1,6.8,11.872Z","transform":"translate(-1.885 -3.355)","fill":"#fff"}})])]),_vm._v(" Identified Verified")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.payproffv2_account_id)?_c('p',{staticClass:"my2 h6"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 14 14"}},[_c('g',{attrs:{"id":"payproff","transform":"translate(-743 -333)"}},[_c('rect',{attrs:{"id":"Rectangle_738","data-name":"Rectangle 738","width":"14","height":"14","transform":"translate(743 333)","fill":"#2265fc"}}),_c('path',{attrs:{"id":"Path_4030","data-name":"Path 4030","d":"M-1813.8,992.119h7.174a2.932,2.932,0,0,1,2.316,2.682c.092,2.235-2.316,2.8-2.316,2.8h-4.188l-1.948,1.85v-4.22h4.36l-1.4,1.391h1.4l2.478-2.42h-7.877v7.78l3.344-3.342h3.831a3.841,3.841,0,0,0,2.527-1.325,3.719,3.719,0,0,0,.9-2.516,3.854,3.854,0,0,0-.9-2.382,4.043,4.043,0,0,0-2.527-1.325h-7.174Z","transform":"translate(2558.496 -656.539)","fill":"#fff"}})])])]),_vm._v(" Payproff Verified")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start mt3 px3 xs-col-8 mx-auto md-col-12 lg-col-12 sm-col-12"},[_c('p',{staticClass:"semi-bold h5 mb2"},[_vm._v(_vm._s(_vm.customerdetails.name)+" confirmed")]),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"regular font14 mb1"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Identified")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.email_verified)?_c('p',{staticClass:"regular font14 mb1"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Email Address")]):_vm._e(),_vm._v(" "),(_vm.customerdetails.mobile)?_c('p',{staticClass:"regular font14"},[_c('i',{staticClass:"green el-icon-check"}),_vm._v(" Phone Number")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"xs-col-12 sm-col-8 lg-col-8 md-col-8 highlights p0"},[_c('div',{staticClass:"py2 mx2 border border-top-0 border-left-0 border-right-0 flex flex-column justify-start items-start xs-hide "},[_c('p',{staticClass:"semi-bold h4"},[_vm._v("Hej, jeg er "+_vm._s(_vm.customerdetails.name))]),_vm._v(" "),_c('p',{staticClass:"h6"},[_vm._v(_vm._s(_vm.customerdetails.address))])]),_vm._v(" "),_c('p',{staticClass:"my2 flex col-12 justify-start"},[_vm._v(_vm._s(_vm.allreviewsbycid.length)+" reviews")]),_vm._v(" "),_c('div',{staticClass:"px0 flex flex-column justify-start col-12"},_vm._l((_vm.allreviewsbycid),function(review){return _c('div',{key:review.id,staticClass:"p2 flex flex-column items-start m0 p0"},[_c('p',{staticClass:"font12 graylightcolor m0"},[_vm._v(_vm._s(_vm.moment(new Date(review.UF_REVIEW_DATE)).format('D MMMM YYYY')))]),_vm._v(" "),_c('p',{staticClass:"darkble h6 regular"},[_vm._v(_vm._s(review.UF_COMMENT))]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-start"},[_c('span',[_c('img',{staticClass:"rounded-circle border",attrs:{"src":"https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png","width":"40","height":"40"}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column p0 m0 items-start pl1"},[_c('p',{staticClass:"darkble font13 regular m0"},[_vm._v(_vm._s(review.COMPANY_NAME))]),_vm._v(" "),_c('p',{staticClass:"graylightcolor font12 regular m0"},[_vm._v(_vm._s(review.COMPANY_ADDRESS))])])])])}),0)])])]):_c('div',{staticClass:"my4"},[_vm._v("\n        Ingen anmeldelser\n      ")])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine kunder Minbolig")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue gibson line-height-golden mb3 col-12 px0"},[_vm._v("\n                    Dit samlede overblik over alle dine kunder - både fra Markedspladsen, din profil-side og Mester til Mester."),_c('br'),_c('br'),_vm._v("\n                    Se historik, information og send tilbud til kunden med det samme herfra - hurtigt og enkelt.\n                  ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('p',{staticClass:"regular line-height-1 mb0",staticStyle:{"font-size":"18.5px"}},[_vm._v("\n                kl. 1000\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p1 delete-button flex justify-center items-start gibson line-height-1"},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('allmeetings')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44878b21_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__ = __webpack_require__(937);
function injectStyle (ssrContext) {
  __webpack_require__(916)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-44878b21"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MainPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44878b21_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_MainPage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 916 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__KundeMap__ = __webpack_require__(535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CancellationsTable__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__textVejledning__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modals_HotlineModal__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modals_KundeModal__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ProfileSetup__ = __webpack_require__(928);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__textCreditcard__ = __webpack_require__(590);












/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mainpage',
  components: {
    kundemap: __WEBPACK_IMPORTED_MODULE_0__KundeMap__["a" /* default */],
    cancellations: __WEBPACK_IMPORTED_MODULE_1__CancellationsTable__["a" /* default */],

    textvejledning: __WEBPACK_IMPORTED_MODULE_2__textVejledning__["a" /* default */],
    hotlinemodal: __WEBPACK_IMPORTED_MODULE_3__modals_HotlineModal__["a" /* default */],
    kundemodal: __WEBPACK_IMPORTED_MODULE_5__modals_KundeModal__["a" /* default */],
    archivemodal: __WEBPACK_IMPORTED_MODULE_4__modals_ArchiveModal__["a" /* default */],
    profilesetup: __WEBPACK_IMPORTED_MODULE_6__ProfileSetup__["a" /* default */],
    textcreditcard: __WEBPACK_IMPORTED_MODULE_7__textCreditcard__["a" /* default */]
  },
  created: function created() {
    this.Reload();
  },
  data: function data() {
    return {
      text: '',
      i1: '',
      i2: '',
      i3: '',
      i6: '',
      i7: '',
      i8: '',
      res: [],
      form: {
        message: ''
      }
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.i1 = res['1'];
        _this.i2 = res['2'];
        _this.i3 = res['3'];
        _this.i6 = res['6'];
        _this.i7 = res['7'];
        _this.i8 = res['8'];
      }, function (response) {
        alert('error');
      });
      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.res = res;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancellationsTable_vue__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e54c8d7_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CancellationsTable_vue__ = __webpack_require__(921);
function injectStyle (ssrContext) {
  __webpack_require__(919)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e54c8d7"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CancellationsTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e54c8d7_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CancellationsTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 919 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'cancellation',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  created: function created() {
    this.Reload();
  },
  data: function data() {
    return {
      items: [],
      show: false,
      label: 'Loading...',
      AflyseText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: true,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      salesPerson: '',
      sampleMeeting: {
        id: '',
        type: '',
        estimate: '',
        city: '',
        postnummer: '',
        price: '',
        date: ''
      },
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      },
      configTime: {
        format: 'HH:mm',
        minDate: new Date(),
        sideBySide: true,
        useCurrent: false,

        showClear: false,
        showClose: false
      }
    };
  },

  computed: {
    TopItem: function TopItem() {}
  },
  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '2' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res.array;
      }, function (response) {
        alert('error');
      });
    },
    showMeetingDetailsAflysetext: function showMeetingDetailsAflysetext(item) {
      this.modalShowAflyseText = true;
      this.AflyseText = item.ticketsolution;
      this.AflyseTexttitle = item.ticketstatus;
    },
    hideModal: function hideModal() {
      this.$refs.meetingModal.hide();
    }
  }
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-container',{staticClass:"p-0",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('p',{staticClass:"h6 open-sans line-height-golden py-4"},[_vm._v("Her kan du se en oversigt over dine aflyste møder.")])])],1),_vm._v(" "),_c('b-row',[_vm._l((_vm.items),function(item){return (item.id_appointment_status_support === '1')?_c('b-col',{key:item.id,attrs:{"lg":"4","md":"6","sm":"12"}},[_c('b-card',{staticClass:"border-dark p-0 sm-p-0 rounded",staticStyle:{"min-height":"250px"},attrs:{"bg-variant":item.id_appointment_status_support === '1' ? 'white' : 'outline-danger'}},[_c('b-row',[_c('b-col',[_c('div',{staticClass:"border-danger text-danger p-2 rounded text-small"},[_c('span',{staticClass:"el-icon-date mr-2"}),_vm._v(" "),_c('div',{staticClass:"d-inline-block"},[_vm._v(_vm._s(_vm.moment(item.appointment_date).format('DD/MM/YY'))+" "+_vm._s(item.id_times))])]),_vm._v(" "),(item.id_appointment_status_support === '1')?_c('div',{staticClass:"line-height-golden pl-2"},[(item.ticketsolution !== '')?_c('b-button',{staticClass:"p-0 font-weight-bold text-success",attrs:{"variant":"link"},on:{"click":function($event){return _vm.showMeetingDetailsAflysetext(item)}}},[_c('span',{staticClass:"el-icon-warning-outline float-left mr-2",staticStyle:{"font-size":"16px"}}),_vm._v("\n                  "+_vm._s(item.ticketcategory)+": "+_vm._s(item.ticketstatus)+"\n                ")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"line-height-golden pl-2"},[(item.ticketsolution === '')?_c('p',{staticClass:"font-weight-bold mb-0"},[_c('span',{staticClass:"el-icon-warning-outline float-left mr-2",staticStyle:{"font-size":"16px"}}),_vm._v(_vm._s(item.ticketcategory)+": "+_vm._s(item.ticketstatus))]):_vm._e()])])],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"text-dark p-2 text-small"},[_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v("Kunde: ")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block"},[_vm._v(_vm._s(item.firstname)+_vm._s(item.lastname))])]),_vm._v(" "),_c('div',{staticClass:"text-dark pl-2 pb-2"},[_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v("Sted: ")]),_vm._v(" "),_c('span',{staticClass:"text-small d-inline-block"},[_vm._v(_vm._s(item.mailingstreet)+" "+_vm._s(item.mailingcity)+" "+_vm._s(item.mailingzip))])])])],1),_vm._v(" "),_c('b-row',[_c('b-col')],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('div',{staticClass:"p-2"},[(item.potentialnameurl !== '')?_c('b-button',{staticClass:"rounded font-weight-bold",attrs:{"href":item.potentialnameurl,"target":"_blank","variant":"dark"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"}})])]),_vm._v("Prisoverslag\n                ")]):_vm._e()],1)])],1)],1)],1):_vm._e()}),_vm._v(" "),_c('b-modal',{attrs:{"centered":"","hide-footer":"","title":_vm.AflyseTexttitle},model:{value:(_vm.modalShowAflyseText),callback:function ($$v) {_vm.modalShowAflyseText=$$v},expression:"modalShowAflyseText"}},[_c('div',{attrs:{"slot":"modal-header-close"},slot:"modal-header-close"},[_c('span',{staticClass:"el-icon-error"})]),_vm._v(" "),_c('div',{staticClass:"open-sans line-height-golden h6"},[_vm._v("\n          "+_vm._s(_vm.AflyseText)+"\n        ")])])],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textVejledning_vue__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb327ac_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_textVejledning_vue__ = __webpack_require__(925);
function injectStyle (ssrContext) {
  __webpack_require__(923)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4bb327ac"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_textVejledning_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4bb327ac_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_textVejledning_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 923 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'textvejledning',
  data: function data() {
    return {
      guideShow: false
    };
  },

  methods: {
    closeGuideModal: function closeGuideModal() {
      this.$refs.guideModal.hide();
    }
  }
});

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-card',{attrs:{"border-variant":"light"}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-block"},[_c('span',{staticClass:"h6 font-weight-bold"},[_vm._v("Råd og vejledning")])]),_vm._v(" "),_c('span',{staticClass:"d-block mt-4"},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":function($event){_vm.guideShow = !_vm.legalShow}}},[_vm._v("Åbn dokumentet")])],1),_vm._v(" "),_c('b-modal',{ref:"guideModal",attrs:{"id":"modal-center","lazy":"","header":"Råd og vejledning","size":"lg"},model:{value:(_vm.guideShow),callback:function ($$v) {_vm.guideShow=$$v},expression:"guideShow"}},[_c('div',{staticClass:"pb-0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"h5 pt-2 pb-2 pl-2 font-weight-bold"},[_vm._v("Råd og vejledning")])]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_vm._v("\n          For at sikre at du som partner får mest muligt ud af dit partnerskab, har vi her udarbejdet en vejledning til din brug af vores service.\n          "),_c('br'),_c('br'),_vm._v("\n          Vejledningen forklarer den generelle brug af vores service. Vejledningen indeholder også en rådgivning om, hvordan kontakten med kunden bør foregå for at få det bedste resultat og størst udbytte ud af vores service.\n          "),_c('br'),_c('br'),_vm._v("\n          Når du følger denne vejledning, øges chancerne betydeligt for, at et kundemøde bliver til en ordre.\n          "),_c('br'),_c('br')]),_vm._v(" "),_c('p',{staticClass:"h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold"},[_vm._v("Kundemøder")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_vm._v("\n          For at sikre at du som partner får mest muligt ud af dit partnerskab, har vi her udarbejdet en vejledning til din brug af vores service.\n          "),_c('br'),_c('br'),_vm._v("\n          Vejledningen forklarer den generelle brug af vores service. Vejledningen indeholder også en rådgivning om, hvordan kontakten med kunden bør foregå for at få det bedste resultat og størst udbytte ud af vores service.\n          "),_c('br'),_c('br'),_vm._v("\n          Når du følger denne vejledning, øges chancerne betydeligt for, at et kundemøde bliver til en ordre.\n          "),_c('br'),_c('br')]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('ul',{staticClass:"pl-4"},[_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Ring kunden op: ")]),_vm._v("Sørg altid for at ringe til kunden umiddelbart efter, at du har modtaget kontaktoplysninger og opgavebeskrivelse, for at præsentere dig selv. Det giver kunden et godt førstehåndsindtryk og en følelse af tryghed i processen. Det giver også jer begge en mulighed for at forberede jer på mødet og afstemme forventninger.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Giv besked: ")]),_vm._v("Giv altid kunden personlig besked, hvis du bliver forhindret eller forsinket.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Spørg ind og lyt: ")]),_vm._v("Husk at spørge grundigt ind til kundens behov, og lyt godt efter, når kunden forklarer - det får kunden til at føle sig godt tilpas, og det fører samtidig til de mest præcise tilbud.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Vis eksempler: ")]),_vm._v("Vis gerne eksempler på tidligere/lignende opgaver, du har løst - vi oplever generelt, at billedeksempler i høj grad øger chancerne for at få ordren hjem.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Sammensæt et godt tilbud: ")]),_vm._v("Send kunden et godt, seriøst og gennemarbejdet skriftligt tilbud, der er konkurrencedygtigt.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Send tilbuddet hurtigst muligt: ")]),_vm._v("Send tilbuddet hurtigst muligt og senest en uge efter mødet.\n            ")])])]),_vm._v(" "),_c('p',{staticClass:"h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold"},[_vm._v("Opfølgning efter mødet")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_vm._v("\n          Vi oplever, at en vis andel af kunder, ikke selv ringer tilbage for at følge op på tilbuddet. Oftest betyder dette ikke nødvendigvis, at de er afvisende overfor tilbuddet - mange kunder vil derimod typisk vente på, at du selv tager kontakt til dem igen.\n          "),_c('br'),_c('br'),_vm._v("\n          Vi anbefaler derfor, at du selv følger op på mødet og tilbuddet på følgende måde:\n          "),_c('br'),_c('br')]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pr-4 pb-0 pl-4 line-height-golden"},[_c('ul',{staticClass:"pl-4"},[_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Ring til kunden dagen efter, du har sendt tilbuddet.")]),_vm._v("Du kan evt. forklare, at du ringer for at sikre dig, at kunden har modtaget tilbuddet. Tilbyd evt. også at gennemgå tilbuddet skridt for skridt sammen med kunden for at klargøre indholdet.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Ring til kunden igen en uge efter, du har sendt tilbuddet, for at følge op på det")]),_vm._v("- evt. ved at spørge, hvad kunden synes om tilbuddet, og om han/hun har nogen spørgsmål.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Spørg ind og lyt: ")]),_vm._v("Husk at spørge grundigt ind til kundens behov, og lyt godt efter, når kunden forklarer - det får kunden til at føle sig godt tilpas, og det fører samtidig til de mest præcise tilbud.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Vis eksempler: ")]),_vm._v("Vis gerne eksempler på tidligere/lignende opgaver, du har løst - vi oplever generelt, at billedeksempler i høj grad øger chancerne for at få ordren hjem.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Sammensæt et godt tilbud: ")]),_vm._v("Send kunden et godt, seriøst og gennemarbejdet skriftligt tilbud, der er konkurrencedygtigt.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Send tilbuddet hurtigst muligt: ")]),_vm._v("Send tilbuddet hurtigst muligt og senest en uge efter mødet.\n            ")])])]),_vm._v(" "),_c('p',{staticClass:"h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold"},[_vm._v("Accept af tilbud og aftaler med kunden")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pr-4 pb-0 pl-4 line-height-golden"},[_c('ul',{staticClass:"pl-4"},[_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Få altid en skriftlig accept fra kunden inden arbejdet startes.")]),_vm._v(" Den skriftlige aftale bør som minimum omfatte prisen på opgaven og en klar beskrivelse af opgavens omfang.\n            ")]),_vm._v(" "),_c('li',{staticClass:"pb-3"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Få en økonomisk sikkerhedsstillelse fra kunden umiddelbart efter ordrens accept.")])])])]),_vm._v(" "),_c('p',{staticClass:"h5 text-dark pt-2 pb-2 pl-2 line-height-golden font-weight-bold"},[_vm._v("Generelt om din brug af vores service")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Partnerlogin:")]),_vm._v(" "),_c('br'),_vm._v("Prisberegning.dk's partnerside på prisberegning.dk skal benyttes til at administrere dit partnerskab. Det vil bl.a. sige, at alle aflysninger og reklamationer skal ske gennem din personlige partnerprofil. Du modtager en mail med loginoplysninger til partnerprofilen ved oprettelsen.\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Ferie:")]),_vm._v(" "),_c('br'),_vm._v("Holder du ferie/lukket, så skal dette indberettes til iMentor, hvis dit partnerskab skal sættes i bero (ikke relevant, hvis du udelukkende er SMS-partner). Hvis der allerede er booket et møde ind til afholdelse i din ferieperiode, så skal du selv sørge for at flytte det. Dit partnerskab kan sættes i bero i 6 uger årligt.\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Aflysninger:")]),_vm._v(" "),_c('br'),_vm._v("Aflysninger skal indberettes senest på det planlagte afholdelsestidspunkt via din partnerprofil.\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Reklamationer:")]),_vm._v(" "),_c('br'),_vm._v("Reklamationer skal indberettes senest dagen efter mødets afholdelse via din partnerprofil.\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Din balance på partnerprofilen:")]),_vm._v(" "),_c('br'),_vm._v("Når aflysningen/reklamationen er behandlet og godkendt, så tilbageføres betalingen for mødet automatisk til din balance. Betalingen for dit næste møde trækkes fra denne balance. Du kan få overblik over din balance på din personlige partnerprofil.\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 text-dark open-sans pt-2 pb-2 pl-2 line-height-golden"},[_c('strong',{staticClass:"text-dark font-weight-bold headerfont"},[_vm._v("Flytning af møde:")]),_vm._v(" "),_c('br'),_vm._v("Hvis du aftaler med kunden at flytte mødet til et andet tidspunkt, skal du indberette dette via din partnerprofil, da mødetidspunktet har indflydelse på tidsfrister for aflysninger og reklamationer.\n        ")]),_vm._v(" "),_c('div',{staticClass:"w-100 mt-0 pt-0 pr-4 pb-4 pl-4",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-right",attrs:{"slot":"modal-cancel","type":"reset","variant":"primary","size":"lg"},on:{"click":_vm.closeGuideModal},slot:"modal-cancel"},[_c('span',{staticClass:"el-icon-error mr-2"}),_vm._v("Luk")])],1)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'hotlinemodal',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a
  },
  data: function data() {
    return {
      legalShow: false,
      isLoadingHotline: false,
      form: {
        text: ''
      }
    };
  },

  methods: {
    onSubmitMessageHotline: function onSubmitMessageHotline(evt) {
      var _this = this;

      this.isLoadingHotline = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'calllawyer', salesPerson: this.salesPerson, calllawyertext: this.form.text };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.legalShow = false;
          var obj = {
            title: 'udført med succes',
            message: '',
            type: 'success'
          };
          _this.isLoadingHotline = false;
          _this.$refs.simplert.openSimplert(obj);
          _this.form.text = '';
        } else {
          alert(res.message);
          _this.isLoadingHotline = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();

      this.form.message = '';
    },
    closeLegalModal: function closeLegalModal() {
      this.$refs.legalModal.hide();
    }
  }
});

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-card',{attrs:{"border-variant":"light"}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-flex flex-row justify-content-between line-height-golden"},[_c('span',{staticClass:"h6 font-weight-bold text-dark"},[_vm._v("Juridisk Hotline")])]),_vm._v(" "),_c('span',{staticClass:"d-block mt-4"},[_c('b-btn',{staticClass:"rounded",attrs:{"variant":"info"},on:{"click":function($event){_vm.legalShow = !_vm.legalShow}}},[_vm._v("Skriv til advokaten")])],1),_vm._v(" "),_c('b-modal',{ref:"legalModal",attrs:{"lazy":"","centered":"","id":"modal-center","lazy":""},model:{value:(_vm.legalShow),callback:function ($$v) {_vm.legalShow=$$v},expression:"legalShow"}},[_c('div',{staticClass:"modal-header pt-0 w-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"h5 pt-2 font-weight-bold text-dark"},[_vm._v("Juridisk rådgivning")]),_vm._v(" "),_c('div',{staticClass:"right"},[_c('b-btn',{staticClass:"border-0",attrs:{"variant":"outline-dark"},on:{"click":_vm.closeLegalModal}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])],1)]),_vm._v(" "),_c('div',{staticClass:"d-flex justify-content-center"},[_c('div',{staticClass:"pr-4"},[_c('b-img',{staticClass:"rounded-circle",attrs:{"src":"../static/img/mst.jpg","alt":"","width":"100","height":"100"}})],1),_vm._v(" "),_c('div',{staticClass:"h6 pt-2 open-sans pr-2 pb-0 line-height-golden"},[_vm._v("Som partner kan du få gratis juridisk rådgivning pr. telefon ifm. byggesager (entrepriseret) af vores samarbejdspartner advokat Michael Stæhr.\n          ")])]),_vm._v(" "),_c('div',{staticClass:"w-100 mt-0 pt-0 pr-2 pb-4 pl-2",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.onSubmitMessageHotline.apply(null, arguments)},"reset":_vm.resetForm}},[_c('b-form-row',{staticClass:"pb-4"},[_c('b-col',[_c('b-form-textarea',{ref:"focusLegalMessage",attrs:{"id":"textarea1","placeholder":"Beskriv din problemstilling kort","rows":10,"max-rows":18,"required":""},model:{value:(_vm.form.text),callback:function ($$v) {_vm.$set(_vm.form, "text", $$v)},expression:"form.text"}})],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-left rounded",attrs:{"slot":"modal-cancel","type":"reset","variant":"secondary","size":"lg"},on:{"click":_vm.closeLegalModal},slot:"modal-cancel"},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M0 12c0 6.627 5.373 12 12 12s12-5.373 12-12-5.373-12-12-12-12 5.373-12 12zm7.58 0l5.988-5.995 1.414 1.416-4.574 4.579 4.574 4.59-1.414 1.416-5.988-6.006z"}})])]),_vm._v("Luk\n                ")])],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-right rounded",attrs:{"slot":"modal-ok","type":"submit","variant":"success","size":"lg","disabled":_vm.isLoadingHotline},slot:"modal-ok"},[_vm._v("\n                  Send besked\n                  "),_c('span',{staticClass:"ml2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-1.218 19l-1.782-1.75 5.25-5.25-5.25-5.25 1.782-1.75 6.968 7-6.968 7z"}})])])])],1)],1)],1)],1)])],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSetup_vue__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0d470d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSetup_vue__ = __webpack_require__(934);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7e0d470d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSetup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProfileInformation__ = __webpack_require__(930);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilesetup',
  components: {
    profileinformation: __WEBPACK_IMPORTED_MODULE_0__ProfileInformation__["a" /* default */]
  }
});

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileInformation_vue__ = __webpack_require__(932);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd8583c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileInformation_vue__ = __webpack_require__(933);
function injectStyle (ssrContext) {
  __webpack_require__(931)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0cd8583c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileInformation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0cd8583c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileInformation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 931 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileinformation',
  props: ['res'],
  data: function data() {
    return {
      resInfo: '',
      form: {
        contactPerson: '',
        companyName: '',
        address: '',
        telephone: '',
        email: '',
        cvr: '',
        klippekort: '',
        pbs: '',
        download: '',
        contractend: '',
        name: ''
      }
    };
  },
  created: function created() {
    this.resInfo = this.res;
  },

  methods: {
    onSubmitInformation: function onSubmitInformation(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.form));
    },
    onReset: function onReset(evt) {
      evt.preventDefault();

      this.form.contactPerson = '';
      this.form.companyName = '';
      this.form.address = '';
      this.form.email = '';
      this.form.telephone = '';
      this.form.cvr = '';
      this.form.klippekort = '';
      this.form.pbs = '';
      this.form.contractend = '';
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-form',[_c('fieldset',[_c('b-form',[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"kontaktGroup","label":"Kontaktperson","label-for":"contactPerson"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"contactPerson","type":"text","required":"","placeholder":""},model:{value:(_vm.res.name),callback:function ($$v) {_vm.$set(_vm.res, "name", $$v)},expression:"res.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"firmaGroup","label":"Firmanavn","label-for":"companyName"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"companyName","type":"text","required":"","placeholder":""},model:{value:(_vm.res.company),callback:function ($$v) {_vm.$set(_vm.res, "company", $$v)},expression:"res.company"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"addressGroup","label":"Adresse","label-for":"address"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"address","type":"text","required":"","placeholder":""},model:{value:(_vm.res.address),callback:function ($$v) {_vm.$set(_vm.res, "address", $$v)},expression:"res.address"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"telGroup","label":"Telefon","label-for":"telephone"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"telephone","type":"text","required":"","placeholder":""},model:{value:(_vm.res.telephone),callback:function ($$v) {_vm.$set(_vm.res, "telephone", $$v)},expression:"res.telephone"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"telGroup","label":"Mobil","label-for":"mobile"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"mobile","type":"text","required":"","placeholder":""},model:{value:(_vm.res.mobile),callback:function ($$v) {_vm.$set(_vm.res, "mobile", $$v)},expression:"res.mobile"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"emailGroup","label":"Email","label-for":"email"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"email","type":"text","required":"","placeholder":""},model:{value:(_vm.res.email),callback:function ($$v) {_vm.$set(_vm.res, "email", $$v)},expression:"res.email"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"cvrGroup","label":"CVR","label-for":"cvr"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"cvr","type":"text","required":"","placeholder":""},model:{value:(_vm.res.cvr),callback:function ($$v) {_vm.$set(_vm.res, "cvr", $$v)},expression:"res.cvr"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{attrs:{"id":"pbsGroup","label":"PBS","label-for":"pbs"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"pbs","type":"text","required":"","placeholder":""},model:{value:(_vm.res.isPBS),callback:function ($$v) {_vm.$set(_vm.res, "isPBS", $$v)},expression:"res.isPBS"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-btn',{staticClass:"text-dark",attrs:{"variant":"link","href":_vm.res.aftaleurl,"target":"_blank","text-variant":"dark"}},[_c('span',{staticClass:"mr1"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.479 10.092c-.212-3.951-3.473-7.092-7.479-7.092-4.005 0-7.267 3.141-7.479 7.092-2.57.463-4.521 2.706-4.521 5.408 0 3.037 2.463 5.5 5.5 5.5h13c3.037 0 5.5-2.463 5.5-5.5 0-2.702-1.951-4.945-4.521-5.408zm-7.479 6.908l-4-4h3v-4h2v4h3l-4 4z"}})])]),_vm._v(" partneraftalen\n            ")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(_vm.res.ophoer !== '')?_c('p',[_vm._v("\n               Aftalens ophør: "+_vm._s(_vm.res.ophoer)+"\n            ")]):_vm._e()],1)],1)],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('profileinformation')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'textcreditcard',
  data: function data() {
    return {
      creditShow: false
    };
  },

  methods: {
    closeCreditModal: function closeCreditModal() {
      this.$refs.creditModal.hide();
    }
  }
});

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-card',{attrs:{"border-variant":"light"}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-block"},[_c('span',{staticClass:"h6 font-weight-bold"},[_vm._v("Redigering af betalingskortoplysninger")])]),_vm._v(" "),_c('span',{staticClass:"d-block mt-4"},[_c('b-btn',{attrs:{"variant":"dark"},on:{"click":function($event){_vm.creditShow = !_vm.creditShow}}},[_vm._v("Se kortoplysninger")])],1),_vm._v(" "),_c('b-modal',{ref:"creditModal",attrs:{"centered":"","id":"modal-center","lazy":"","title":"Redigering af betalingskortoplysninger"},model:{value:(_vm.creditShow),callback:function ($$v) {_vm.creditShow=$$v},expression:"creditShow"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"h5 pt-4 pb-0 font-weight-bold"},[_vm._v("Redigering af betalingskortoplysninger")])]),_vm._v(" "),_c('div',{staticClass:"h6 pt-2 open-sans pb-0 line-height-golden"},[_vm._v("\n          Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.\n          "),_c('br'),_c('br'),_vm._v("\n          Vi gør hermed opmærksom på at det er epay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:\n        ")]),_vm._v(" "),_c('div',{staticClass:"py-4 line-height-golden"},[_c('b-btn',{staticClass:"font-weight-bold",attrs:{"variant":"dark","href":"http://profile.start/index.php?action=index&module=kreditkort#"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"}})])]),_vm._v(" "),_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"}})])]),_vm._v("\n          Klik her for at redigere dine kreditkortoplysninger")])],1),_vm._v(" "),_c('div',{staticClass:"h6 pt-2 open-sans pb-0 line-height-golden"},[_vm._v("\n          Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på 70 22 80 14 eller skriv til "),_c('a',[_vm._v("info@imentor.dk")]),_vm._v(".\n          "),_c('br'),_c('br'),_vm._v("Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige møder. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på "),_c('a',[_vm._v("70 22 80 14")]),_vm._v(".\n        ")]),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-row',{staticClass:"pt-0 pb-4"},[_c('b-col',[_c('b-btn',{attrs:{"slot":"modal-cancel","type":"reset","variant":"outline-dark","size":"lg"},on:{"click":_vm.closeCreditModal},slot:"modal-cancel"},[_vm._v("Luk")])],1)],1)],1)])],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-location"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Oversigt")])])])])],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"12"}},[_c('b-card-group')],1)],1),_vm._v(" "),_c('b-row',[_c('b-col',[_c('b-card',{attrs:{"border-variant":"light"}},[_c('div',{staticClass:"h5 pl-0 font-weight-bold"},[_vm._v("Kontakt- og firmaoplysninger")]),_vm._v(" "),_c('div',{})])],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"4","sm":"12"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balance_vue__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f906b3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Balance_vue__ = __webpack_require__(951);
function injectStyle (ssrContext) {
  __webpack_require__(939)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Balance_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69f906b3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Balance_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 939 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BalanceTable__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__BalanceTableOther__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__textCreditcard__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__EditCreditCard__ = __webpack_require__(591);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Kreditkort: __WEBPACK_IMPORTED_MODULE_3__EditCreditCard__["a" /* default */],
    balancetable: __WEBPACK_IMPORTED_MODULE_0__BalanceTable__["a" /* default */],
    balancetableOther: __WEBPACK_IMPORTED_MODULE_1__BalanceTableOther__["a" /* default */],
    textcreditcard: __WEBPACK_IMPORTED_MODULE_2__textCreditcard__["a" /* default */]
  },
  data: function data() {
    return {
      status: 0,
      name: '',
      monthlyp: '',
      items: [],
      itemsfi: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'balance_partner', salesPerson: this.salesPerson, typeMeeting: '1', vat: this.status };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res.array;
        _this.itemsfi = res.arrayinvoice;
        _this.monthlyp = res.monthlyp;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceTable_vue__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4107ea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceTable_vue__ = __webpack_require__(944);
function injectStyle (ssrContext) {
  __webpack_require__(942)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceTable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d4107ea_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceTable_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 942 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'balancetable',
  props: ['items'],
  data: function data() {
    return {
      fields: [{
        label: 'Dato',
        key: 'invoicedate',
        sortable: true
      }, {
        label: 'Beløb',
        key: 'total',
        sortable: true,
        variant: 'success'
      }, {
        key: 'status',
        label: 'Status',
        sortable: true
      }, {
        key: 'invoice_desc',
        label: 'Beskrivelse',
        sortable: true,
        variant: 'success'
      }, {
        key: 'downloadurl1',
        label: 'Se faktura',
        sortable: true
      }]
    };
  }
});

/***/ }),
/* 944 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-table',{attrs:{"responsive":"","striped":"","hover":"","items":_vm.items,"fields":_vm.fields},scopedSlots:_vm._u([{key:"cell(downloadurl1)",fn:function(data){return [_c('a',{attrs:{"target":"_blank","href":data.value}},[_vm._v("Faktura")])]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceTableOther_vue__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596f6ff5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceTableOther_vue__ = __webpack_require__(947);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BalanceTableOther_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_596f6ff5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BalanceTableOther_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'balancetableOther',
  props: ['items'],
  data: function data() {
    return {
      fields: [{
        label: 'Dato',
        key: 'date_to',
        sortable: true
      }, {
        label: 'Beløb',
        key: 'amount',
        sortable: true
      }, {
        key: 'contactname',
        label: 'Møder',
        sortable: true
      }, {
        key: 'note',
        label: 'Info',
        sortable: true
      }]
    };
  }
});

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-table',{attrs:{"responsive":"","striped":"","hover":"","items":_vm.items,"fields":_vm.fields}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 948 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kreditkort',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    axios: __WEBPACK_IMPORTED_MODULE_3_axios___default.a,
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      show: false,
      shownewcreditpro: false,
      showsessionnewcreditpro: [],
      datamethod: '',
      rp: '',
      demopopup: false,
      mobile: '',
      label: 'Loading...',
      overlay: 1,
      basic: false,
      haaCredit: false,
      showimentor: true,
      showDismissibleAlertMobil: false,
      showDismissibleAlertMobilf: false,
      showDismissibleAlert: false,
      isLoadingReserve: false,
      showMobilePay: false,
      email: '',
      haaId: '',
      levid: '',
      invoiceEmailData: {
        emailData: [],
        idData: []
      },
      invoiceEmailMessage: ''
    };
  },

  watch: {
    'datamethod': function datamethod(newVal, oldVal) {
      this.givedatatoserver(newVal);
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.haaId = localStorage.getItem('haaid');
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true;
      if (localStorage.getItem('demoreserve')) {
        this.demopopup = true;
      }
    }
    if (this.$route.query.credit === 'mobilepay') {
      this.showDismissibleAlertMobil = true;
      if (localStorage.getItem('demoreserve')) {
        this.demopopup = true;
      }
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    console.log('initialval', this.datamethod);
    this.displayMobileAndEmail();
    this.shownewcredit();
    this.showsessionnewcredit();
    setTimeout(function () {
      if (document.querySelector('#dropMarkedsplads') !== null) {
        setTimeout(function () {
          var maketplace = document.querySelector('#dropMarkedsplads');
          maketplace.addEventListener('click', function () {
            window.location.replace('#/markedsplads');
          });
        }, 500);
      }
    }, 300);
  },

  methods: {
    shownewcredit: function shownewcredit() {
      var _this = this;

      var data = {
        operation: 'newcredit',
        salesPerson: this.salesPerson
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.shownewcreditpro = true;
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this2 = this;

      var data = {
        operation: 'reepaysession',
        salesPerson: this.salesPerson,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          var data = res.data;
          _this2.showsessionnewcreditpro = data.id;
        } else {
          console.log('Error in showing session');
        }
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      this.levid = this.haaId;
      var data = {
        UF_CRM_COMPANY_PAYMENT_METHOD_UPDATED: 1
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    showpopupreepay: function showpopupreepay() {
      var m = this;
      this.rp = new window.Reepay.ModalCheckout(this.showsessionnewcreditpro);
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.updateprofilepayment();
        m.datamethod = data.payment_method;
      });
    },
    givedatatoserver: function givedatatoserver(paymentmethod) {
      var _this3 = this;

      console.log('beforedata', paymentmethod);
      var data = {
        operation: 'savereepay',
        salesPerson: this.salesPerson,
        payment: paymentmethod,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res) {
          console.log('success add new credit card', res);
        } else {
          console.log('Error in showing epay');
        }
      });
    },
    displayMobileAndEmail: function displayMobileAndEmail() {
      var _this4 = this;

      var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.mobile = res.mobile;
        _this4.invoiceEmailData.emailData = [];
        _this4.invoiceEmailData.idData = [];
        if (!res.invoiceemail.length) {
          _this4.invoiceEmailMessage = 'Du har ikke en faktura-e-mail';
        } else {
          _this4.invoiceEmailMessage = '';
        }
        for (var i = 0; i < res.invoiceemail.length; i++) {
          _this4.invoiceEmailData.emailData.push(res.invoiceemail[i].email);
          _this4.invoiceEmailData.idData.push(res.invoiceemail[i].id);
        }
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        _this4.haaCredit = res.haacredit;
        if (_this4.$route.query.credit === 'mobilepaycall') {
          _this4.registerMobilepay();
        }
        if (_this4.$route.query.credit === 'creditcall') {
          setTimeout(function () {
            var button = document.getElementById('kreditcard');
            button.click();
          }, 1000);
        }
      }, function (response) {
        alert('error');
      });
    },
    registerMobilepay: function registerMobilepay() {
      var _this5 = this;

      this.isLoadingReserve = true;
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'registerMobilepay', salesPerson: this.salesPerson, mobile: this.mobile, mobilev: 0 };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          window.location.href = res.url;
        } else {
          _this5.isLoadingReserve = false;
          _this5.show = false;
          _this5.loading = false;
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    closeDemoreserve: function closeDemoreserve() {
      this.demopopup = false;
      localStorage.removeItem('demoreserve');
    },
    saveDemoreserve: function saveDemoreserve() {
      var _this6 = this;

      var data = {
        operation: 'adddemoreserve',
        salesPerson: this.salesPerson,
        demoreserve: localStorage.getItem('demoreserve')
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.show = false;
          var obj = {
            title: 'Reserveret!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this6.$refs.simplert.openSimplert(obj);
          _this6.demopopup = false;
          localStorage.removeItem('demoreserve');
        } else {
          alert('Ikke Gennemført');
          _this6.show = false;
          console.log('Error in addEmail()');
        }
      }, function (response) {
        console.log('Error in addEmail()');
      });
    },
    addEmail: function addEmail() {
      var _this7 = this;

      event.preventDefault();
      if (this.email !== '') {
        this.show = true;
        var data = {
          operation: 'addInvoiceEmail',
          salesPerson: this.salesPerson,
          email: this.email
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.login === false) {
            _this7.$router.push('/login');
          }
          if (res.success) {
            _this7.displayMobileAndEmail();
            _this7.show = false;
            var obj = {
              title: 'E-mail tilføjet!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this7.$refs.simplert.openSimplert(obj);
            _this7.email = '';
          } else {
            _this7.show = false;
            console.log('Error in addEmail()');
          }
        }, function (response) {
          console.log('Error in addEmail()');
        });
      } else {
        this.$toastr('error', 'Felt kræves');
      }
    },
    confirmRemoveInvoiceEmail: function confirmRemoveInvoiceEmail(id) {
      var _this8 = this;

      return function (dialog) {
        return _this8.removeInvoiceEmail(id);
      };
    },
    removeInvoiceEmail: function removeInvoiceEmail(id) {
      var _this9 = this;

      this.show = true;
      var data = {
        operation: 'removeInvoiceEmail',
        salesPerson: this.salesPerson,
        emailid: id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        if (res.success) {
          _this9.displayMobileAndEmail();
          _this9.$toastr('success', 'Fjernet');
          _this9.show = false;
        } else {
          _this9.show = false;
          console.log('Error in removeInvoiceEmail()');
        }
      }, function (response) {
        console.log('Error in removeInvoiceEmail()');
      });
    }
  }
});

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt3 pb4 mb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',[_c('div',{staticClass:"clearfix border muted-border p2 mb4 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold darkblue gibson line-height-2 my3"},[_vm._v("Rediger kreditkort oplysninger")]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_c('h5',[_vm._v("Dine betalingskortoplysninger er nu registreret og gemt i vores system")])]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlertMobil},on:{"dismissed":function($event){_vm.showDismissibleAlertMobil=false}}},[_c('h5',[_vm._v("Din Mobilepay er nu registreret og gemt i vores system")])]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.showDismissibleAlertMobilf},on:{"dismissed":function($event){_vm.showDismissibleAlertMobilf=false}}},[_c('h5',[_vm._v("Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('div',{},[_c('button',{staticClass:"not-rounded action-button gibson h5 regular no-hover flex justify-center items-center p2 line-height-1 mb0",attrs:{"type":"button","id":"kreditcard"},on:{"click":_vm.showpopupreepay}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"white h4 mb0"},[_vm._v("Tilmeld med kreditkort")])])]),_vm._v(" "),_c('div',{staticClass:"py1"})]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_vm._m(2)],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix border muted-border p2 mb4 shadow"},[_c('div',{staticClass:"col-12 px2 pb2"},[_c('p',{staticClass:"h4 semi-bold darkblue my3"},[_vm._v("Send dine fakturaer til en email")]),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-golden mb3"},[_vm._v("Indtast den eller de emailadresser du ønsker der automatisk skal modtage fakturaen, fx. en bogholder eller direkte til et regnskabsprogram.")]),_vm._v(" "),_c('b-form',{staticClass:"flex col-12 border lightgrey-border p1 items-center mb2",on:{"submit":function($event){return _vm.addEmail()}}},[_c('div',{staticClass:"col-9 p0"},[_c('b-form-input',{staticClass:"border-none p1",attrs:{"type":"email","placeholder":"Skriv e-mail her...","autocomplete":"off"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[_c('b-button',{staticClass:"col-12 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular",attrs:{"type":"submit"}},[_c('span',{staticClass:"h5"},[_vm._v("Gem")])])],1)]),_vm._v(" "),_c('span',{staticClass:"h5 regular gibson darkblue line-height-golden mb3"},[_vm._v("Dine mailadresser:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',_vm._l((_vm.invoiceEmailData.emailData),function(email,index){return _c('el-tag',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmRemoveInvoiceEmail(_vm.invoiceEmailData.idData[index])}),expression:"{ok: confirmRemoveInvoiceEmail(invoiceEmailData.idData[index])}"}],key:index,staticClass:"h6 regular darkblue block border-none transparent",staticStyle:{"width":"max-content"},attrs:{"disable-transitions":true,"closable":""}},[_vm._v("\n                "+_vm._s(email)+"\n              ")])}),1),_vm._v(" "),_c('div',[_c('span',{staticClass:"mediumgrey-text"},[_vm._v(_vm._s(_vm.invoiceEmailMessage))])])],1)])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix p2 ml4 mb4"},[_c('div',{staticClass:"lg-col-6 col-12 px2"},[_c('p',{staticClass:"h4 semi-bold darkblue gibson line-height-2 my3"},[_vm._v("Rediger kreditkort oplysninger")]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_c('h5',[_vm._v("Dine betalingskortoplysninger er nu registreret og gemt i vores system")])]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlertMobil},on:{"dismissed":function($event){_vm.showDismissibleAlertMobil=false}}},[_c('h5',[_vm._v("Din Mobilepay er nu registreret og gemt i vores system")])]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.showDismissibleAlertMobilf},on:{"dismissed":function($event){_vm.showDismissibleAlertMobilf=false}}},[_c('h5',[_vm._v("Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk")])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center"},[_c('div',{},[_c('a',{staticClass:"not-rounded action-button gibson h5 regular no-hover flex justify-start items-center p2 line-height-1 mb0",attrs:{"type":"button"},on:{"click":_vm.showpopupreepay}},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"white h5 mb0 pr2"},[_vm._v("Tilmeld med kreditkort")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('b-link',{attrs:{"href":"https://www.epay.dk/sikkerhed/pci-certificeret-betalingssystem.asp"}},[_c('br')])],1)]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('span',{staticClass:"h4 semi-bold darkblue"},[_vm._v("Send dine fakturaer til en email")]),_vm._v(" "),_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-golden mb3"},[_vm._v("Indtast den eller de emailadresser du ønsker der automatisk skal modtage fakturaen, fx. en bogholder eller direkte til et regnskabsprogram.")]),_vm._v(" "),_c('b-form',{staticClass:"flex col-8 border lightgrey-border p1 items-center mb2",on:{"submit":function($event){return _vm.addEmail()}}},[_c('div',{staticClass:"col-9 p0"},[_c('b-form-input',{staticClass:"border-none p1",attrs:{"type":"email","placeholder":"Skriv e-mail her...","autocomplete":"off"},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[_c('b-button',{staticClass:"col-12 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular",attrs:{"type":"submit"}},[_c('span',{staticClass:"h5"},[_vm._v("Gem")])])],1)]),_vm._v(" "),_c('span',{staticClass:"h5 regular gibson darkblue line-height-golden mb3"},[_vm._v("Dine mailadresser:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',_vm._l((_vm.invoiceEmailData.emailData),function(email,index){return _c('el-tag',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmRemoveInvoiceEmail(_vm.invoiceEmailData.idData[index])}),expression:"{ok: confirmRemoveInvoiceEmail(invoiceEmailData.idData[index])}"}],key:index,staticClass:"h6 regular darkblue block border-none transparent",staticStyle:{"width":"max-content"},attrs:{"disable-transitions":true,"closable":""}},[_vm._v("\n              "+_vm._s(email)+"\n            ")])}),1),_vm._v(" "),_c('div',[_c('span',{staticClass:"mediumgrey-text"},[_vm._v(_vm._s(_vm.invoiceEmailMessage))])])],1)]):_vm._e(),_vm._v(" "),_c('b-modal',{attrs:{"lazy":"","centered":"","no-close-on-backdrop":"","hide-footer":"","title":"Submit Your Name"},model:{value:(_vm.showMobilePay),callback:function ($$v) {_vm.showMobilePay=$$v},expression:"showMobilePay"}},[_c('div',{staticClass:"clearfix p2"},[_c('b-button',{staticClass:"mt-3 right",attrs:{"variant":"outline-primary"},on:{"click":function($event){_vm.showMobilePay = false}}},[_vm._v("X")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 justify-center items-center"},[_c('img',{staticClass:"mb2",attrs:{"src":"static/svg/mobilepay.svg","alt":""}}),_vm._v(" "),_c('form',{staticClass:"col-12",attrs:{"action":""}},[_c('div',{staticClass:"clearfix my3"},[_c('p',{staticClass:"h6 gibson line-height-1 mb1"},[_vm._v("Mobilnr.")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobile),expression:"mobile"}],staticClass:"col-12 lightgrey-background p2 border-none not-rounded",attrs:{"type":"tel"},domProps:{"value":(_vm.mobile)},on:{"input":function($event){if($event.target.composing){ return; }_vm.mobile=$event.target.value}}})])]),_vm._v(" "),_c('button',{staticClass:"col-6 p2 mx-auto not-rounded gibson line-height-1 h5 regular action-button",attrs:{"disabled":_vm.isLoadingReserve},on:{"click":function($event){return _vm.registerMobilepay()}}},[_c('span',[_vm._v("Tilmeld")])])])],1)]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1),_vm._v(" "),_c('b-modal',{staticClass:"pt3 pr3 pb1 pl3",attrs:{"id":"dineNotater","no-close-on-backdrop":"","centered":""},model:{value:(_vm.demopopup),callback:function ($$v) {_vm.demopopup=$$v},expression:"demopopup"}},[_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"h4 bold p0 p2 border-none transparent",attrs:{"type":"reset"},on:{"click":_vm.closeDemoreserve}},[_vm._v("\n          X\n        ")])]),_vm._v(" "),_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h5 darkblue center semi-bold line-height-1 mb3 gibson"},[_c('span',{staticClass:" items-center"},[_c('img',{attrs:{"width":"60","src":"static/img/thumbs-up-pngrepo-com.png"}})]),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          Sådan!\n        ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 my3 gibson"},[_vm._v("\n          Nu er dit abonnement opdateret og du kan fremadrettet reservere 2 opgaver af gangen.\n          "),_c('br'),_c('br'),_vm._v("\n          Ønsker du at reservere opgaven du kiggede på?\n\n        ")]),_c('div',{staticClass:"center p2"},[_c('b-button',{staticClass:"col-6 action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular",attrs:{"type":"button"},on:{"click":_vm.saveDemoreserve}},[_c('span',{staticClass:"h5"},[_vm._v("Ja tak "),_c('span',{staticClass:"el-icon-right mr-2"})])])],1),_vm._v(" "),_c('p')]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center col-12 px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"})])],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular gibson darkblue line-height-golden mb2"},[_vm._v("\n              Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.\n              "),_c('br'),_vm._v("\n              Vi gør hermed opmærksom på at det er reepay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-bank-card white",staticStyle:{"font-size":"30px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mt2 mb3"},[_vm._v("\n              Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{staticClass:"semi-bold",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{staticClass:"semi-bold",attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n              "),_c('br'),_vm._v("Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige betalinger. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på "),_c('a',{staticClass:"semi-bold",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(".\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular gibson darkblue line-height-golden mb2"},[_vm._v("\n            Hvis du har brug for at ændre dine kreditkortoplysninger, eksempelvis for at skifte et kort ud med et andet, så har du mulighed for at gøre det her.\n            "),_c('br'),_vm._v("\n            Vi gør hermed opmærksom på at det er reepay.dk (PBS) der varertager al sikkerhed omkring betalingskortoplysninger, læs mere her:\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-bank-card white",staticStyle:{"font-size":"30px"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden py2 mt2 mb3"},[_vm._v("\n            Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{staticClass:"semi-bold primarycolor",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{staticClass:"semi-bold primarycolor",attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n            "),_c('br'),_vm._v("Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige betalinger. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på "),_c('a',{staticClass:"semi-bold primarycolor",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(".\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt3 pb4 mb2"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix border muted-border p2 mb2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my3 gibson darkblue"},[_vm._v("Faktura")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('b-form',[_c('b-form-checkbox',{attrs:{"id":"checkbox1","value":"1","unchecked-value":"0","checked-value":"1"},on:{"change":_vm.Reload},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Vis beløb inkl. moms")])],1)]),_vm._v(" "),_c('b-card',{staticClass:"border-0 pt-4",attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},[(_vm.monthlyp === '0')?_c('b-tab',{attrs:{"title":"Abonnementsfaktura","active":""}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e(),_vm._v(" "),(_vm.monthlyp === '1')?_c('b-tab',{attrs:{"title":"SMS-Partner"}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.showXXL)?_c('div',{staticClass:"clearfix p2 mb2 ml4"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my3 gibson darkblue"},[_vm._v("Faktura")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('b-form',[_c('b-form-checkbox',{attrs:{"id":"checkbox1","value":"1","unchecked-value":"0","checked-value":"1"},on:{"change":_vm.Reload},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Vis beløb inkl. moms")])],1)]),_vm._v(" "),_c('b-card',{staticClass:"border-0 pt-4",attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},[(_vm.monthlyp === '0')?_c('b-tab',{attrs:{"title":"Abonnementsfaktura","active":""}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e(),_vm._v(" "),(_vm.monthlyp === '1')?_c('b-tab',{attrs:{"title":"SMS-Partner"}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix p2 mb2 ml4"},[_c('div',{staticClass:"col-6 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my3 gibson darkblue"},[_vm._v("Faktura")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('b-form',[_c('b-form-checkbox',{attrs:{"id":"checkbox1","value":"1","unchecked-value":"0","checked-value":"1"},on:{"change":_vm.Reload},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}})],1),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Vis beløb inkl. moms")])],1)]),_vm._v(" "),_c('div',{staticClass:"col-9 px2"},[_c('b-card',{staticClass:"border-0 pt-4",attrs:{"no-body":""}},[_c('b-tabs',{attrs:{"card":""}},[(_vm.monthlyp === '0')?_c('b-tab',{attrs:{"title":"Abonnementsfaktura","active":""}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e(),_vm._v(" "),(_vm.monthlyp === '1')?_c('b-tab',{attrs:{"title":"SMS-Partner"}},[_c('balancetable',{attrs:{"items":_vm.itemsfi}})],1):_vm._e()],1)],1)],1)]):_vm._e()])]),_vm._v(" "),_c('div',[_c('kreditkort')],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSettings_vue__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7551c3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSettings_vue__ = __webpack_require__(955);
function injectStyle (ssrContext) {
  __webpack_require__(953)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7f7551c3"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProfileSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7f7551c3_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProfileSettings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 953 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__imentor__ = __webpack_require__(103);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilesettings',
  data: function data() {
    return {
      service_reminder: '',
      items: [],
      optionsDistance: [],
      autobooking: '',
      partnertype: 'SMS-partner',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      inactivesms: '',
      sms_size: '',
      sms_distance: '',
      onebeforemeeting: '',
      onebefore_sms_email: '',
      twohourbeforemeeting: '',
      twohouraftermeeting: '',
      twodayaftermeeting: '',
      twodayafter_sms_email: '',
      twodayafter_days: '',
      tendayaftermeeting: '',
      tendayafter_sms_email: '',
      tendayafter_days: '',
      salesPerson: ''
    };
  },

  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_4__imentor__["a" /* default */],
    hotlinemodal: __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__["a" /* default */],
    archivemodal: __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  created: function created() {
    this.Reload();
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false;
    }
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.service_reminder = res.service_reminder;
        _this.partnertype = res.partnertype;
        _this.autobooking = res.autobooking;
        _this.inactivesms = res.inactivesms;
        _this.sms_size = res.sms_size;
        _this.sms_distance = res.id_distancesms;
        if (_this.sms_distance === '') {
          _this.sms_distance = res.partnerdistancesmsfirst;
        }
        _this.optionsDistance = res.smsdistanceList;
        _this.onebeforemeeting = res.onebeforemeeting;
        _this.onebefore_sms_email = res.onebefore_sms_email;
        _this.twohourbeforemeeting = res.twohourbeforemeeting;
        _this.twohouraftermeeting = res.twohouraftermeeting;
        _this.twodayaftermeeting = res.twodayaftermeeting;
        _this.twodayafter_sms_email = res.twodayafter_sms_email;
        _this.twodayafter_days = res.twodayafter_days;
        _this.tendayaftermeeting = res.tendayaftermeeting;
        _this.tendayafter_sms_email = res.tendayafter_sms_email;
        _this.tendayafter_days = res.tendayafter_days;
        _this.items = res.workflows;
      }, function (response) {
        alert('error');
      });
    },
    service_reminder_action: function service_reminder_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');

      var dataPartner = { operation: 'servicereminder', salesPerson: this.salesPerson, service_reminder: this.service_reminder };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_autobooking_action: function service_autobooking_action() {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'autobooking', salesPerson: this.salesPerson, autobooking: this.autobooking };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    inactivesms_action: function inactivesms_action() {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'inactivesms', salesPerson: this.salesPerson, inactivesms: this.inactivesms, sms_size: this.sms_size, sms_distance: this.sms_distance };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_other_reminder_action: function service_other_reminder_action() {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'servicereotherminder', salesPerson: this.salesPerson, onebeforemeeting: this.onebeforemeeting, onebefore_sms_email: this.onebefore_sms_email, twohourbeforemeeting: this.twohourbeforemeeting, twohouraftermeeting: this.twohouraftermeeting, twodayaftermeeting: this.twodayaftermeeting, twodayafter_sms_email: this.twodayafter_sms_email, twodayafter_days: this.twodayafter_days, tendayaftermeeting: this.tendayaftermeeting, tendayafter_sms_email: this.tendayafter_sms_email, tendayafter_days: this.tendayafter_days };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          _this5.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this5.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    workflow_action: function workflow_action(workflow) {
      var _this6 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var elementCheckBox = document.getElementById('option_' + workflow);
      var dataPartner = { operation: 'workflow_action', salesPerson: this.salesPerson, workflow_id: workflow, checked: elementCheckBox.checked };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this6.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 py3 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow"},[_vm._m(0),_vm._v(" "),(_vm.imentor)?_c('form',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix py1 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details1",modifiers:{"details1":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Generelle notifikationer\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details1"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Når du har aktiveret servicepåmindelser pr. SMS modtager du dagen efter en booking en SMS-besked med kundens navn og telefonnummer samt mødedatoen.\n                "),_c('br'),_c('br'),_vm._v("Du kan slå notifikationer til og fra her.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_reminder),expression:"service_reminder"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"1","true-value":"1","false-value":"0"},domProps:{"checked":Array.isArray(_vm.service_reminder)?_vm._i(_vm.service_reminder,"1")>-1:_vm._q(_vm.service_reminder,"1")},on:{"change":function($event){var $$a=_vm.service_reminder,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.service_reminder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.service_reminder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.service_reminder=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py1 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details3",modifiers:{"details3":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Deaktiver SMS-tilbud\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details3"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Har du i perioder ikke brug for at modtage SMS'er om nye potentielle kunder, så kan du slå SMS-notifikationerne til og fra her.\n                "),_c('br'),_c('br'),_vm._v("\n                Der vil gå ca. 24 timer, før vores system kan registrere deaktivering, og i denne periode kan du stadig opleve at modtage SMS'er.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inactivesms),expression:"inactivesms"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"1","true-value":"1","false-value":"0"},domProps:{"checked":Array.isArray(_vm.inactivesms)?_vm._i(_vm.inactivesms,"1")>-1:_vm._q(_vm.inactivesms,"1")},on:{"change":function($event){var $$a=_vm.inactivesms,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inactivesms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inactivesms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inactivesms=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.inactivesms_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py1 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details4",modifiers:{"details4":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Daglige SMS-tilbud\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details4"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Her kan du ændre indstillingerne for info-SMS'er om ledige kundemøder, som du kan købe.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms_size),expression:"sms_size"}],staticClass:"muted-background darkblue h5 gibson p2 border-none not-rounded",staticStyle:{"font-size":"1.25rem"},attrs:{"id":"sms_size","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sms_size=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((10),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-3 mt3 mb1"},[_vm._v("Radius for opgavens placering (fra din firmaadresse)")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background darkblue gibson px2 py1 border-none not-rounded",staticStyle:{"font-size":"1.25rem"},attrs:{"id":"sms_distance","required":"","options":_vm.optionsDistance},model:{value:(_vm.sms_distance),callback:function ($$v) {_vm.sms_distance=$$v},expression:"sms_distance"}})],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.inactivesms_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py1 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details5",modifiers:{"details5":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Servicepåmindelse\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details5"}},[_c('div',{staticClass:"white-background"},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("1 dag før mødet")]),_vm._v("\n                  Når du slår denne påmindelse til, får du en mail/SMS dagen før hvert møde.\n                ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onebeforemeeting),expression:"onebeforemeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.onebeforemeeting)?_vm._i(_vm.onebeforemeeting,"0")>-1:_vm._q(_vm.onebeforemeeting,"0")},on:{"change":function($event){var $$a=_vm.onebeforemeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.onebeforemeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.onebeforemeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.onebeforemeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]),_vm._v(" "),_c('p',{staticClass:"h6 gibson regular darkblue line-height-golden"},[_vm._v("Vælg metode")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background h6 gibson regular border-none not-rounded",staticStyle:{"font-size":"11.5px"},attrs:{"id":"onebefore_sms_email","required":""},model:{value:(_vm.onebefore_sms_email),callback:function ($$v) {_vm.onebefore_sms_email=$$v},expression:"onebefore_sms_email"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Både SMS og e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Kun e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Kun SMS")])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("2 timer før mødet")]),_vm._v("\n                    Når du slår denne påmindelse til, får du en SMS 2 timer før hvert møde.\n                  ")]),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twohourbeforemeeting),expression:"twohourbeforemeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.twohourbeforemeeting)?_vm._i(_vm.twohourbeforemeeting,"0")>-1:_vm._q(_vm.twohourbeforemeeting,"0")},on:{"change":function($event){var $$a=_vm.twohourbeforemeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.twohourbeforemeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.twohourbeforemeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.twohourbeforemeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])],1),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_other_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py1 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px2 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details6",modifiers:{"details6":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Bedømmelses-SMS\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details6"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("Aktiver bedømmelses-SMS (2 timer efter møde)")]),_vm._v("\n                Her får du en SMS, hvor du kan svare med en bedømmelse af kundemødet, du lige har afholdt. Bedømmelsen bruger vi til at optimere vores service til dig.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twohouraftermeeting),expression:"twohouraftermeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.twohouraftermeeting)?_vm._i(_vm.twohouraftermeeting,"0")>-1:_vm._q(_vm.twohouraftermeeting,"0")},on:{"change":function($event){var $$a=_vm.twohouraftermeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.twohouraftermeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.twohouraftermeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.twohouraftermeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_other_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-9 lg-col-9 px0"},[_c('div',{staticClass:"clearfix mb2"},_vm._l((_vm.items),function(item){return _c('div',{key:item.workflow_id,staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('details_'+ item.workflow_id),expression:"'details_'+ item.workflow_id"}],staticClass:"col-12 px0 simple-button border-none py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h6 semi-bold line-height-1 mb0 left-align"},[_vm._v("\n                    "+_vm._s(item.title)+"\n                  ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"gibson px2",attrs:{"id":'details_'+ item.workflow_id}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden mb0"},[_vm._v("\n                  "+_vm._s(item.note)+"\n                ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.select),expression:"item.select"}],staticClass:"switch-input",attrs:{"type":"checkbox","id":'option_' + item.workflow_id,"true-value":"1","false-value":"0"},domProps:{"value":item.select,"checked":Array.isArray(item.select)?_vm._i(item.select,item.select)>-1:_vm._q(item.select,"1")},on:{"change":function($event){var $$a=item.select,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=item.select,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "select", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "select", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "select", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.workflow_action(item.workflow_id)}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1)}),0)])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix ml4"},[_vm._m(1),_vm._v(" "),(_vm.imentor)?_c('form',{staticClass:"flex flex-wrap px0"},[_c('div',{staticClass:"col-4 mb2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details1",modifiers:{"details1":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Generelle notifikationer\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details1"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Når du har aktiveret servicepåmindelser pr. SMS modtager du dagen efter en booking en SMS-besked med kundens navn og telefonnummer samt mødedatoen.\n                "),_c('br'),_c('br'),_vm._v("Du kan slå notifikationer til og fra her.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.service_reminder),expression:"service_reminder"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"1","true-value":"1","false-value":"0"},domProps:{"checked":Array.isArray(_vm.service_reminder)?_vm._i(_vm.service_reminder,"1")>-1:_vm._q(_vm.service_reminder,"1")},on:{"change":function($event){var $$a=_vm.service_reminder,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.service_reminder=$$a.concat([$$v]))}else{$$i>-1&&(_vm.service_reminder=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.service_reminder=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details3",modifiers:{"details3":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Deaktiver SMS-tilbud\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details3"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Har du i perioder ikke brug for at modtage SMS'er om nye potentielle kunder, så kan du slå SMS-notifikationerne til og fra her.\n                "),_c('br'),_c('br'),_vm._v("\n                Der vil gå ca. 24 timer, før vores system kan registrere deaktivering, og i denne periode kan du stadig opleve at modtage SMS'er.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inactivesms),expression:"inactivesms"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"1","true-value":"1","false-value":"0"},domProps:{"checked":Array.isArray(_vm.inactivesms)?_vm._i(_vm.inactivesms,"1")>-1:_vm._q(_vm.inactivesms,"1")},on:{"change":function($event){var $$a=_vm.inactivesms,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inactivesms=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inactivesms=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inactivesms=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.inactivesms_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details4",modifiers:{"details4":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Daglige SMS-tilbud\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details4"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_vm._v("\n                Her kan du ændre indstillingerne for info-SMS'er om ledige kundemøder, som du kan købe.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.sms_size),expression:"sms_size"}],staticClass:"muted-background darkblue h5 gibson p2 border-none not-rounded",staticStyle:{"font-size":"1.25rem"},attrs:{"id":"sms_size","required":""},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.sms_size=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},_vm._l((10),function(n){return _c('option',{key:n,domProps:{"value":n}},[_vm._v(_vm._s(n))])}),0),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-3 mt3 mb1"},[_vm._v("Radius for opgavens placering (fra din firmaadresse)")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background darkblue gibson px2 py1 border-none not-rounded",staticStyle:{"font-size":"1.25rem"},attrs:{"id":"sms_distance","required":"","options":_vm.optionsDistance},model:{value:(_vm.sms_distance),callback:function ($$v) {_vm.sms_distance=$$v},expression:"sms_distance"}})],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.inactivesms_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details5",modifiers:{"details5":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Servicepåmindelse\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details5"}},[_c('div',{staticClass:"white-background"},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("1 dag før mødet")]),_vm._v("\n                  Når du slår denne påmindelse til, får du en mail/SMS dagen før hvert møde.\n                ")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.onebeforemeeting),expression:"onebeforemeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.onebeforemeeting)?_vm._i(_vm.onebeforemeeting,"0")>-1:_vm._q(_vm.onebeforemeeting,"0")},on:{"change":function($event){var $$a=_vm.onebeforemeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.onebeforemeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.onebeforemeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.onebeforemeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])]),_vm._v(" "),_c('p',{staticClass:"h6 gibson regular darkblue line-height-golden"},[_vm._v("Vælg metode")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background h6 gibson regular border-none not-rounded",staticStyle:{"font-size":"11.5px"},attrs:{"id":"onebefore_sms_email","required":""},model:{value:(_vm.onebefore_sms_email),callback:function ($$v) {_vm.onebefore_sms_email=$$v},expression:"onebefore_sms_email"}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Både SMS og e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Kun e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Kun SMS")])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("2 timer før mødet")]),_vm._v("\n                    Når du slår denne påmindelse til, får du en SMS 2 timer før hvert møde.\n                  ")]),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twohourbeforemeeting),expression:"twohourbeforemeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.twohourbeforemeeting)?_vm._i(_vm.twohourbeforemeeting,"0")>-1:_vm._q(_vm.twohourbeforemeeting,"0")},on:{"change":function($event){var $$a=_vm.twohourbeforemeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.twohourbeforemeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.twohourbeforemeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.twohourbeforemeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])],1),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_other_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-4 mb2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details6",modifiers:{"details6":true}}],staticClass:"col-12 px0 simple-button border-none px0 py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                  Bedømmelses-SMS\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"p2",attrs:{"id":"details6"}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden"},[_c('span',{staticClass:"block semi-bold mb1"},[_vm._v("Aktiver bedømmelses-SMS (2 timer efter møde)")]),_vm._v("\n                Her får du en SMS, hvor du kan svare med en bedømmelse af kundemødet, du lige har afholdt. Bedømmelsen bruger vi til at optimere vores service til dig.\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.twohouraftermeeting),expression:"twohouraftermeeting"}],staticClass:"switch-input",attrs:{"type":"checkbox","value":"0","true-value":"0","false-value":"1"},domProps:{"checked":Array.isArray(_vm.twohouraftermeeting)?_vm._i(_vm.twohouraftermeeting,"0")>-1:_vm._q(_vm.twohouraftermeeting,"0")},on:{"change":function($event){var $$a=_vm.twohouraftermeeting,$$el=$event.target,$$c=$$el.checked?("0"):("1");if(Array.isArray($$a)){var $$v="0",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.twohouraftermeeting=$$a.concat([$$v]))}else{$$i>-1&&(_vm.twohouraftermeeting=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.twohouraftermeeting=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.service_other_reminder_action()}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.items),function(item){return _c('div',{key:item.workflow_id,staticClass:"col-4 mb2"},[_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('details_'+ item.workflow_id),expression:"'details_'+ item.workflow_id"}],staticClass:"col-12 px0 simple-button border-none py2 flex justify-between items-center gibson"},[_c('p',{staticClass:"h6 semi-bold line-height-1 mb0 left-align"},[_vm._v("\n                  "+_vm._s(item.title)+"\n                ")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"gibson px2",attrs:{"id":'details_'+ item.workflow_id}},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-golden mb0"},[_vm._v("\n                "+_vm._s(item.note)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('div',{staticClass:"my2"},[_c('label',{staticClass:"switch switch-icon switch-success switch-pill switch-md"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(item.select),expression:"item.select"}],staticClass:"switch-input",attrs:{"type":"checkbox","id":'option_' + item.workflow_id,"true-value":"1","false-value":"0"},domProps:{"value":item.select,"checked":Array.isArray(item.select)?_vm._i(item.select,item.select)>-1:_vm._q(item.select,"1")},on:{"change":function($event){var $$a=item.select,$$el=$event.target,$$c=$$el.checked?("1"):("0");if(Array.isArray($$a)){var $$v=item.select,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(item, "select", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(item, "select", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(item, "select", $$c)}}}}),_vm._v(" "),_c('span',{staticClass:"switch-label",attrs:{"data-on":"","data-off":""}}),_vm._v(" "),_c('span',{staticClass:"switch-handle"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"button"},on:{"click":function($event){return _vm.workflow_action(item.workflow_id)}}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])],1)}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Notifikationer")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Se status på dine notifikationer og slå dem til eller fra.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Notifikationer")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Se status på dine notifikationer og slå dem til eller fra.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_integrationSettings_vue__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3adc460e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_integrationSettings_vue__ = __webpack_require__(961);
function injectStyle (ssrContext) {
  __webpack_require__(957)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3adc460e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_integrationSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3adc460e_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_integrationSettings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 957 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__imentor__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__noneligibleFeaturepop__ = __webpack_require__(43);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilesettings',
  data: function data() {
    return {
      apikey: '',
      apikeye: '',
      apikeyb: '',
      facebookpageid: '',
      help: '',
      pdf: '',
      dineroShow: false,
      facebookShow: true,
      facebookShowbox: true,
      items: [],
      loginOption: { scope: 'email,manage_pages,publish_pages' },
      optionsDistance: [],
      firmaid: '',
      partnertype: 'SMS-partner',
      dineroapiupdate: '',
      economicapiupdate: '',
      billyapiupdate: '',
      facebookapiupdate: '',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      haaId: '',
      url: '',
      salesPerson: '',
      eligible: ''
    };
  },

  computed: {
    facebookState: function facebookState() {
      return this.facebookpageid.length > 2;
    }
  },
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_5__imentor__["a" /* default */],
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_2__haandvaerker__["a" /* default */],
    hotlinemodal: __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__["a" /* default */],
    archivemodal: __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_6__noneligibleFeaturepop__["a" /* default */]
  },
  created: function created() {
    this.eligible = localStorage.getItem('PartnerAccountingInteg');
    this.eligiblefbrecommend = localStorage.getItem('FBPostRecommendation');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false;
    }
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.service_reminder = res.service_reminder;
        _this.partnertype = res.partnertype;
        _this.autobooking = res.autobooking;
        _this.inactivesms = res.inactivesms;
        _this.sms_size = res.sms_size;
        _this.dineroapiupdate = res.dineroapiupdate;
        _this.economicapiupdate = res.economicapiupdate;
        _this.billyapiupdate = res.billyapiupdate;
        _this.facebookapiupdate = res.facebookapiupdate;
        _this.firmaid = res.dinerofirma;
        _this.apikey = res.dineroapi;
        _this.apikeye = res.economicapi;
        _this.apikeyb = res.billyapi;
        _this.facebookpageid = res.facebookapi;
      }, function (response) {
        alert('error');
      });
    },
    openUrl: function openUrl(url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    getUserData: function getUserData(log) {
      var _this2 = this;

      console.log(log);
      if (log['authResponse']['accessToken']) {
        this.show = true;
        this.salesPerson = localStorage.getItem('id_token_portal');
        var dataPartner = { operation: 'service_facebook', salesPerson: this.salesPerson, token: log['authResponse']['accessToken'], userid: log['authResponse']['userID'], expire: log['authResponse']['data_access_expiration_time'], levid: this.haaId };
        this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          _this2.show = false;
          if (res.login === false) {
            _this2.$router.push('/login');
          }
          if (res.success) {
            _this2.modalShowDato = false;
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this2.$refs.simplert.openSimplert(obj);
            _this2.Reload();
          } else {
            alert(res.message);
          }
        }, function (response) {
          alert('error');
        });
      }
    },
    getConnectData: function getConnectData(log) {
      this.facebookShow = true;
    },
    service_dinero: function service_dinero() {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'service_dinero', salesPerson: this.salesPerson, firmaid: this.firmaid, apikey: this.apikey, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.service_bitrix('dinero', _this3.apikey, _this3.firmaid);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_economic: function service_economic() {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'service_economic', salesPerson: this.salesPerson, apikeye: this.apikeye, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.service_bitrix('e-conomic', _this4.apikeye);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_billy: function service_billy() {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'service_billy', salesPerson: this.salesPerson, apikeyb: this.apikeyb, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          _this5.service_bitrix('billy', _this5.apikeyb);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_bitrix: function service_bitrix() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var _this6 = this;

      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var firmaID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var data1 = {
        supplierId: this.haaId,
        accessKey: value,
        integration: type
      };
      var data2 = {
        supplierId: this.haaId,
        accessKey: value,
        integration: type,
        organizationId: this.firmaid
      };
      var datafirma = firmaID !== '' ? data2 : data1;
      this.$http.post(this.$bitrixapi + 'integration/saveSupplierIntegration', datafirma, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.modalShowDato = false;
          if (type !== 'facebook') {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this6.$refs.simplert.openSimplert(obj);
          }
          _this6.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    hideModal: function hideModal() {
      this.$refs.dinerowModal.hide();
    },
    showModal: function showModal(pdf) {
      this.pdf = pdf;
      this.url = pdf;
      this.$refs.dinerowModal.show();
    },
    getdataigibility: function getdataigibility(intetype) {
      var submitted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yes';

      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerAccountingInteg');
      } else {
        if (submitted === 'yes') {
          if (intetype === 'dinero') {
            this.service_dinero();
          } else if (intetype === 'economic') {
            this.service_economic();
          } else if (intetype === 'billy') {
            this.service_billy();
          }
        }
      }
    },
    getdataigibilityfb: function getdataigibilityfb(intetype) {
      var submitted = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'yes';
      var link = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      if (this.eligiblefbrecommend === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'FBPostRecommendation');
      } else {
        if (submitted === 'yes') {
          if (intetype === 'facebook') {
            window.open(link, '_blank');
          }
        }
      }
    }
  }
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'haandvaerker',
  props: [],
  data: function data() {
    return {
      show: false
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = true;
    }
  },

  methods: {}
});

/***/ }),
/* 960 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('b-card',{staticClass:"border-0 mh-100",attrs:{"bg-variant":"info"}},[_c('div',{staticClass:"font-weight-bold line-height-golden pl-1 h4"},[_vm._v("Opgrader dit abonnement")]),_vm._v(" "),_c('b-row',{staticClass:"py-2"},[_c('b-col',{attrs:{"lg":"9","md":"9","sm":"12"}},[_c('div',{staticClass:"open-sans line-height-golden py-3 py-lg-3 py-md-3 h5"},[_vm._v("\n              Vil du gerne modtage anbefalinger fra tidligere kunder og inspirere potentielle kunder? Så er et Håndværker.dk abonnement måske noget for dig.\n            ")]),_vm._v(" "),_c('b-btn',{staticClass:"rounded border-0 p-3 font-weight-bold",staticStyle:{"font-size":"14px"},attrs:{"variant":"warning","href":"#/inbox?send=support&default=haandvaerker"}},[_vm._v("\n              Kontakt os her for at høre nærmere\n            ")])],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('div',{staticClass:"col-12 px2 pt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Autopilot (integrationer)")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('b-img',{attrs:{"src":"static/img/photo1.png","alt":"","fluid-grow":""}})],1),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2 py2 flex justify-between items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details1",modifiers:{"details1":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('dinero', 'no')}}},[_c('img',{attrs:{"src":"static/svg/dinero1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"id":"details1"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt API-nøglen fra Dinero herunder.")]),_vm._v(" "),(_vm.dineroapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos Dinero er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra Dinero, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",attrs:{"type":"button"},on:{"click":function($event){return _vm.showModal('Dinero_vejledning.pdf')}}},[_c('span',{staticClass:"mr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button my2 p2 h5 flex justify-center items-center line-height-1 gibson",attrs:{"type":"button"},on:{"click":function($event){return _vm.openUrl('https://www.youtube.com/watch?v=kbznMBh-LTs&feature=youtu.be')}}},[_c('span',{staticClass:"semi-bold mr2"},[_vm._v("Se video-vejledning")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",attrs:{"type":"button"},on:{"click":function($event){return _vm.openUrl('https://dinero.dk/')}}},[_c('span',{staticClass:"semi-bold pr2"},[_vm._v("Åbn link til Dinero")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('dinero', 'no')}}},[_c('b-form-group',{staticClass:"h6 darkblue regular gibson",attrs:{"id":"nameInput","label":"API-nøgle","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikey),callback:function ($$v) {_vm.apikey=$$v},expression:"apikey"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst en gyldig API-nøgle\n                      ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"h6 darkblue regular gibson",attrs:{"id":"emailInput","label":"Firma ID","label-for":"email"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"email","type":"number","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.firmaid),callback:function ($$v) {_vm.firmaid=$$v},expression:"firmaid"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst et gyldigt firma ID\n                      ")])],1),_vm._v(" "),_c('button',{staticClass:"col-12 action-button p2 h5 semi-bold not-rounded border-none gibson line-height-1",attrs:{"type":"submit"}},[_c('span',{staticClass:"semi-bold pr2"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),(_vm.dineroapiupdate !== '')?_c('div',[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.dineroapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2 py2 flex justify-between items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details2",modifiers:{"details2":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('economic', 'no')}}},[_c('img',{attrs:{"src":"static/svg/visma1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"id":"details2"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt ID'et herunder.")]),_vm._v(" "),(_vm.economicapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos e-conomic er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra e-conomic, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",on:{"click":function($event){return _vm.showModal('Economic_vejledning.pdf')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 h5 gibson flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.openUrl('https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=WZr2juvCWXAt4gMuou0RTXvMR0BNFpfJHsnq3M2MQbw1')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Åbn link til E-conomic")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('economic', 'no')}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"ID","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikeye),callback:function ($$v) {_vm.apikeye=$$v},expression:"apikeye"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst et gyldigt ID\n                      ")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 my2 h4 flex justify-center items-center line-height-1 semi-bold not-rounded border-none",attrs:{"type":"submit"}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),(_vm.economicapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.economicapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2 py2 flex justify-between items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details3",modifiers:{"details3":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('billy', 'no')}}},[_c('img',{attrs:{"src":"static/svg/billy1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"id":"details3"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt ID'et herunder.")]),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos billy er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra Billy, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded",on:{"click":function($event){return _vm.showModal('Billy_vejledning.pdf')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded",on:{"click":function($event){return _vm.openUrl('https://www.billy.dk/')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Åbn link til Billy")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('billy', 'no')}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"API-nøgle","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikeyb),callback:function ($$v) {_vm.apikeyb=$$v},expression:"apikeyb"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst en gyldig API-nøgle\n                      ")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 my2 action-button p2 h4 semi-bold not-rounded border-none",attrs:{"type":"submit"}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.billyapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px2 pt3"},[_vm._m(2),_vm._v(" "),_c('b-img',{attrs:{"src":"static/img/photo2.jpg","fluid-grow":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2 py2 flex justify-between items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details4",modifiers:{"details4":true}}],staticClass:"pointer flex justify-start items-center"},[_c('img',{attrs:{"src":"static/svg/facebook.svg","width":"48"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"visible":"","id":"details4"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Facebook Integration")]),_vm._v(" "),(_vm.facebookapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din Facebook-konto er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Vi poster automatisk dine 4- og 5-stjernede anbefalinger på din Facebookside eller profil.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my2"},[_vm._v("t\n                    "),_c('button',{staticClass:"col-12 outlined-primary-button p2 gibson flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.showModal('htps://www.haandvaerker.dk/pdf/fb_integration.pdf#zoom=100')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_facebook.apply(null, arguments)}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"Facebook Page-ID","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.facebookpageid),callback:function ($$v) {_vm.facebookpageid=$$v},expression:"facebookpageid"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-button',{staticClass:"col-12 facebook-button p2 h6 semi-bold not-rounded border-none",attrs:{"type":"submit"},on:{"click":function($event){return _vm.getdataigibilityfb('facebook','yes','https://www.kundematch.dk/newpartner/facebook.php?id='+_vm.salesPerson+'&levid='+_vm.haaId+'&pageid='+_vm.facebookpageid)}}},[_c('span',{staticClass:"fab fa-facebook mr-2"}),_vm._v(" "),_c('span',[_vm._v("Tilknyt Facebook")])])],1),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.billyapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"col-8 p2 pl4"},[_c('div',{staticClass:"px2 pt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Autopilot (integrationer)")]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('b-img',{attrs:{"src":"static/img/photo1.png","alt":"","fluid-grow":""}}),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5)],1),_vm._v(" "),_c('div',{staticClass:"col-8 flex flex-column ml4",attrs:{"role":"tablist"}},[_c('div',{staticClass:"border muted-border shadow p2 flex mb2 justify-start items-center"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-start items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details1",modifiers:{"details1":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('dinero', 'no')}}},[_c('img',{attrs:{"src":"static/svg/dinero1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"id":"details1"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt API-nøglen fra Dinero herunder.")]),_vm._v(" "),(_vm.dineroapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos Dinero er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra Dinero, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",on:{"click":function($event){return _vm.showModal('Dinero_vejledning.pdf')}}},[_c('span',{staticClass:"mr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button my2 p2 h5 flex justify-center items-center line-height-1 gibson",on:{"click":function($event){return _vm.openUrl('https://www.youtube.com/watch?v=kbznMBh-LTs&feature=youtu.be')}}},[_c('span',{staticClass:"semi-bold mr2"},[_vm._v("Se video-vejledning")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",on:{"click":function($event){return _vm.openUrl('https://dinero.dk/')}}},[_c('span',{staticClass:"semi-bold pr2"},[_vm._v("Åbn link til Dinero")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('dinero')}}},[_c('b-form-group',{staticClass:"h6 darkblue regular gibson",attrs:{"id":"nameInput","label":"API-nøgle","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikey),callback:function ($$v) {_vm.apikey=$$v},expression:"apikey"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst en gyldig API-nøgle\n                      ")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"h6 darkblue regular gibson",attrs:{"id":"emailInput","label":"Firma ID","label-for":"email"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"email","type":"number","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.firmaid),callback:function ($$v) {_vm.firmaid=$$v},expression:"firmaid"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst et gyldigt firma ID\n                      ")])],1),_vm._v(" "),_c('button',{staticClass:"col-12 action-button p2 h5 semi-bold not-rounded border-none gibson line-height-1",attrs:{"type":"submit"}},[_c('span',{staticClass:"semi-bold pr2"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),(_vm.dineroapiupdate !== '')?_c('div',[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.dineroapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)])],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"border muted-border shadow p2 flex mb2 justify-start items-center"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-start items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details2",modifiers:{"details2":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('economic', 'no')}}},[_c('img',{attrs:{"src":"static/svg/visma1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"id":"details2"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt ID'et herunder.")]),_vm._v(" "),(_vm.economicapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos e-conomic er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra e-conomic, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button my1 p2 h5 flex justify-center items-center line-height-1 gibson",on:{"click":function($event){return _vm.showModal('Economic_vejledning.pdf')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 h5 gibson flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.openUrl('https://secure.e-conomic.com/secure/api1/requestaccess.aspx?appPublicToken=WZr2juvCWXAt4gMuou0RTXvMR0BNFpfJHsnq3M2MQbw1')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Åbn link til E-conomic")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('economic')}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"ID","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikeye),callback:function ($$v) {_vm.apikeye=$$v},expression:"apikeye"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst et gyldigt ID\n                      ")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 my2 h4 flex justify-center items-center line-height-1 semi-bold not-rounded border-none",attrs:{"type":"submit"}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),(_vm.economicapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.economicapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"bo1der muted-border shadow p2 flex mb2 justify-start items-center"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 flex justify-start items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details3",modifiers:{"details3":true}}],staticClass:"pointer flex justify-start items-center",on:{"click":function($event){return _vm.getdataigibility('billy', 'no')}}},[_c('img',{attrs:{"src":"static/svg/billy1.svg","width":"100%"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{staticClass:"col-12",attrs:{"id":"details3"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Indsæt ID'et herunder.")]),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din konto hos billy er nu integreret med Håndværker.dk.")]),_vm._v("\n                      Du vil få en SMS hver uge med dine kunder fra Billy, hvor du kan invitere dem til at skrive en anbefaling om din virksomhed.\n                    ")])]):_vm._e(),_vm._v(" "),_c('div',{},[_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded",on:{"click":function($event){return _vm.showModal('static/pdf/Integrate Billy_with_Håndværker.dk.pdf')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-primary-button p2 my1 gibson line-height-1 not-rounded",on:{"click":function($event){return _vm.openUrl('https://www.billy.dk/')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Åbn link til Billy")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.getdataigibility('billy')}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"API-nøgle","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.apikeyb),callback:function ($$v) {_vm.apikeyb=$$v},expression:"apikeyb"}}),_vm._v(" "),_c('b-form-text',{staticClass:"h6 darkblue regular gibson",staticStyle:{"font-size":"11.5px"},attrs:{"id":"password-help-block"}},[_vm._v("\n                        Indsæt venligst en gyldig API-nøgle\n                      ")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 my2 action-button p2 h4 semi-bold not-rounded border-none",attrs:{"type":"submit"}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                        "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.billyapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-6 px2 pt3 pl4"},[_vm._m(6),_vm._v(" "),_c('b-img',{attrs:{"src":"static/img/photo2.jpg","fluid-grow":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 pr0 pl4"},[(_vm.haaId !== '0')?_c('div',[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"col-12 px2 py2 flex justify-between items-center"},[_c('div',{directives:[{name:"b-toggle",rawName:"v-b-toggle.details4",modifiers:{"details4":true}}],staticClass:"pointer flex justify-start items-center"},[_c('img',{attrs:{"src":"static/svg/facebook.svg","width":"48"}})]),_vm._v(" "),(_vm.help !== '')?_c('button',{staticClass:"outlined-dark-button gibson h6 px2 py1"},[_c('span',[_vm._v("Hjælp")])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"clearfix pb2"},[_c('div',{staticClass:"col-12 px2"},[_c('b-collapse',{attrs:{"visible":"","id":"details4"}},[_c('p',{staticClass:"h semi-bold line-height-2 my2"},[_vm._v("Facebook Integration")]),_vm._v(" "),(_vm.facebookapiupdate !== '')?_c('div',{staticClass:"clearfix darkblue-background white p2 mb2",attrs:{"show":""}},[_c('p',{staticClass:"h5 gibson regular line-height-golden"},[_c('span',{staticClass:"semi-bold block mb2"},[_vm._v("Tak! Din Facebook-konto er nu integreret med Håndværker.dk.")]),_vm._v("\n                    Vi poster automatisk dine 4- og 5-stjernede anbefalinger på din Facebookside eller profil.\n                  ")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('button',{staticClass:"col-12 outlined-primary-button p2 gibson flex justify-center items-center line-height-1",on:{"click":function($event){return _vm.showModal('https://www.haandvaerker.dk/pdf/fb_integration.pdf#zoom=100')}}},[_c('span',{staticClass:"pr2 semi-bold"},[_vm._v("Hent vejledning her")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('b-form',{staticClass:"py2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_facebook.apply(null, arguments)}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"Facebook Page-ID","label-for":"navn"}},[_c('b-form-input',{staticClass:"muted-background px2 py1 border-none darkblue h6 not-rounded",attrs:{"id":"navn","type":"text","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.facebookpageid),callback:function ($$v) {_vm.facebookpageid=$$v},expression:"facebookpageid"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-button',{staticClass:"col-12 facebook-button p2 h6 semi-bold not-rounded border-none",attrs:{"type":"submit"},on:{"click":function($event){return _vm.getdataigibilityfb('facebook','yes','https://www.kundematch.dk/newpartner/facebook.php?id='+_vm.salesPerson+'&levid='+_vm.haaId+'&pageid='+_vm.facebookpageid)}}},[_c('span',{staticClass:"fab fa-facebook mr-2"}),_vm._v(" "),_c('span',[_vm._v("Tilknyt Facebook")])])],1),_vm._v(" "),(_vm.billyapiupdate !== '')?_c('div',{staticClass:"clearfix"},[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',[_vm._v("Sidste opdatering")]),_vm._v(":\n                      "),_c('span',[_vm._v(_vm._s(_vm.moment(_vm.billyapiupdate).locale('da').format('LL')))])])],1):_vm._e()],1)],1)],1)])]):_vm._e()])]):_vm._e()])]),_vm._v(" "),_c('b-modal',{ref:"dinerowModal",attrs:{"size":"lg","centered":"","id":"modalPopover","title":"Hent vejledning her","ok-only":""}},[_c('b-col',{staticClass:"h-100 d-inline-block",attrs:{"md":"12"}},[_c('b-embed',{attrs:{"type":"iframe","scrolling":"no","src":_vm.url,"aspect":"1by1","allowfullscreen":""}})],1),_vm._v(" "),_c('div',{staticClass:"py-4 px-4 d-flex justify-content-between w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"type":"reset","variant":"outline-dark","size":"lg"},on:{"click":_vm.hideModal}},[_vm._v("Luk\n        ")])],1)],1),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Spar tid med autopiloter")]),_vm._v("\n            Få dine systemer til at “snakke sammen”. Det sparer dig tid, sikrer flere anbefalinger og skaber opmærksomhed om din virksomhed.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 pt3"},[_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Regnskabs-autopilot")]),_vm._v("\n            Med autopiloten får du hver uge en SMS med dine kunder, hvor du hurtigt kan invitere dem til at skrive en anbefaling af din virksomhed. Hvis du vil gøre det selv, tryk på dit regnskabsprogram:\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Data og fortrolighed")]),_vm._v("\n            Din data bliver selvfølgelige behandlet fortroligt i henhold til vores databehandleraftale, og bliver alene brugt til at indhente dine anbefalinger samt statistikker, som du løbende vil modtage i fremtiden.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Facebook integration")]),_vm._v("\n            Med denne Facebook-integration bliver dine 4- og 5-stjernede anbefalinger automatisk postet på din Facebookside.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Spar tid med autopiloter")]),_vm._v("\n            Få dine systemer til at “snakke sammen”. Det sparer dig tid, sikrer flere anbefalinger og skaber opmærksomhed om din virksomhed.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Regnskabs-autopilot")]),_vm._v("\n            Med autopiloten får du hver uge en SMS med dine kunder, hvor du hurtigt kan invitere dem til at skrive en anbefaling af din virksomhed. Hvis du vil gøre det selv, tryk på dit regnskabsprogram:\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Data og fortrolighed")]),_vm._v("\n            Din data bliver selvfølgelige behandlet fortroligt i henhold til vores databehandleraftale, og bliver alene brugt til at indhente dine anbefalinger samt statistikker, som du løbende vil modtage i fremtiden.\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_c('span',{staticClass:"primarycolor block mb1"},[_vm._v("Facebook integration")]),_vm._v("\n          Med denne Facebook-integration bliver dine 4- og 5-stjernede anbefalinger automatisk postet på din Facebookside.\n        ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 962 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leverandoerservice_vue__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11edca7f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_leverandoerservice_vue__ = __webpack_require__(965);
function injectStyle (ssrContext) {
  __webpack_require__(963)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-11edca7f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_leverandoerservice_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_11edca7f_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_leverandoerservice_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 963 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__ = __webpack_require__(211);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__imentor__ = __webpack_require__(103);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilesettings',
  data: function data() {
    return {
      regnr: '',
      bankkonto: '',
      help: '',
      cvr: '',
      consent: '',
      dineroShow: false,
      items: [],
      bank: '',
      options: [],
      optionsDistance: [],
      firmaid: '',
      partnertype: 'SMS-partner',
      levandorupdate: '',
      show: false,
      imentor: true,
      label: 'Loading...',
      overlay: 1,
      haaId: '',
      salesPerson: ''
    };
  },

  computed: {
    regState: function regState() {
      return this.regnr.length > 3;
    },
    bankState: function bankState() {
      return this.bankkonto.length > 9;
    }
  },
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_6__imentor__["a" /* default */],
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_2__haandvaerker__["a" /* default */],
    hotlinemodal: __WEBPACK_IMPORTED_MODULE_0__modals_HotlineModal__["a" /* default */],
    archivemodal: __WEBPACK_IMPORTED_MODULE_1__modals_ArchiveModal__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a,
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__["a" /* default */]
  },
  created: function created() {
    this.Reload();
    if (localStorage.getItem('imentor') === '0') {
      this.imentor = false;
    }
  },

  methods: {
    limitbankno: function limitbankno(e) {
      return String(e).substring(0, 10);
    },
    limitbankregis: function limitbankregis(e) {
      return String(e).substring(0, 4);
    },
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.cvr = res.cvr;
        if (_this.haaId === '40035' || _this.haaId === '10247') {
          _this.levandorupdate = '';
        } else {
          _this.levandorupdate = res.levandorupdate;
        }
        _this.regnr = res.levandorregnr;
        _this.bankkonto = res.levandorbankkonto;
        _this.options = res.bankOptions;
      }, function (response) {
        alert('error');
      });
    },
    service_levendor: function service_levendor() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'service_levendor', salesPerson: this.salesPerson, regnr: this.regnr, bankkonto: this.bankkonto, levid: this.haaId, cvr: this.cvr, bank: this.bank };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    hideModal: function hideModal() {
      this.$refs.dinerowModal.hide();
    },
    showModal: function showModal() {
      this.$refs.dinerowModal.show();
    }
  }
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-document"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Tilmeld Betalingsaftale")])]),_vm._v(" "),_c('div',{staticClass:"pt-3 h6 open-sans line-height-golden"},[_vm._v("\n              Integrationer med leverandørservice.\n            ")])])])],1)],1)],1),_vm._v(" "),_c('b-form',[_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0 p-1"},[_c('div',{staticClass:"d-flex flex-row align-items-center justify-content-between"},[_c('div',{staticClass:"h6 text-dark"},[_c('b-img',{attrs:{"src":"../static/img/leverandoerservice.png","alt":""}})],1),_vm._v(" "),_c('div',[(_vm.help !== '')?_c('b-btn',{staticClass:"rounded",attrs:{"size":"lg","variant":"dark"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M21 13v10h-21v-19h12v2h-10v15h17v-8h2zm3-12h-10.988l4.035 4-6.977 7.07 2.828 2.828 6.977-7.07 4.125 4.172v-11z"}})])]),_vm._v("\n                Hjælp\n              ")]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"card-text pb-0"},[_c('div',[_c('b-collapse',{attrs:{"visible":"","id":"details1"}},[_c('div',{staticClass:"py-2 open-sans h6 line-height-golden"},[_vm._v("\n\n\n\n\n                  LeverandørService er en betalingsløsning til erhvervskunder, hvor fakturaer betales automatisk på betalingsdagen. Du modtager altid en advisering mindst 3 dage inden beløbet trækkes og din faktura vil du kunne hente via dit personlige login til vores platform.\n\n                ")]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[(_vm.levandorupdate !== '')?_c('b-alert',{attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                      ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('b-form',{staticClass:"py-2",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_levendor.apply(null, arguments)}}},[_c('b-form-group',{attrs:{"id":"nameInput","label":"Din Bank","label-for":"konto"}},[_c('b-form-select',{attrs:{"options":_vm.options,"required":""},model:{value:(_vm.bank),callback:function ($$v) {_vm.bank=$$v},expression:"bank"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                          Hvis din bank ikke er på listen, kan du ikke oprette forbindelse til leverandørservice\n                        ")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"nameInput","label":"Registreringsnr.","label-for":"konto"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"konto","type":"number","aria-describedby":"input-live-help input-live-feedback","formatter":_vm.limitbankregis,"state":_vm.regState,"required":"","placeholder":"","max":"9999","size":"4","autocomplete":"off"},model:{value:(_vm.regnr),callback:function ($$v) {_vm.regnr=$$v},expression:"regnr"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                          Indsæt venligst din Registreringsnr (4 kar)\n                        ")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"emailInput","label":"Bankkonto","label-for":"account"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"account","type":"number","required":"","placeholder":"","formatter":_vm.limitbankno,"state":_vm.bankState,"size":"10","max":"9999999999","autocomplete":"off"},model:{value:(_vm.bankkonto),callback:function ($$v) {_vm.bankkonto=$$v},expression:"bankkonto"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"password-help-block"}},[_vm._v("\n                          Indsæt venligst din Bankkonto (10 kar)\n                        ")])],1),_vm._v(" "),_c('b-form-group',{attrs:{"id":"emailInput","label":"CVR-nummer","label-for":"cvr"}},[_c('b-form-input',{staticClass:"bg-light rounded",attrs:{"id":"cvr","type":"number","required":"","placeholder":"","autocomplete":"off"},model:{value:(_vm.cvr),callback:function ($$v) {_vm.cvr=$$v},expression:"cvr"}})],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},model:{value:(_vm.consent),callback:function ($$v) {_vm.consent=$$v},expression:"consent"}},[_c('span',{staticClass:"text-secondary open-sans"},[_vm._v("Jeg acceptere LeverandørService "),_c('a',{attrs:{"target":"_blank","href":"https://www.nets.eu/dk-da/SiteCollectionDocuments/leverandoerservice/LS_Regler_DB_debitor_regler_DK.pdf"}},[_vm._v("reglerne")])])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-row',[(_vm.levandorupdate === '')?_c('b-col',[_c('b-button',{attrs:{"type":"submit","variant":"success rounded flex justify-center items-center","size":"lg"}},[_c('span',{staticClass:"mr2"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_vm._v("Gem\n                        ")])],1):_vm._e(),_vm._v(" "),(_vm.levandorupdate !== '')?_c('b-col',[_c('b-alert',{attrs:{"size":"lg","show":"","variant":"secondary"}},[_c('span',{staticClass:"el-icon-success text-success"}),_vm._v(" Sidste opdatering : "+_vm._s(_vm.levandorupdate)+" ")])],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"})])],1)]),_vm._v(" "),_c('div',{staticClass:"border-0",attrs:{"slot":"footer"},slot:"footer"})])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"dinerowModal",attrs:{"size":"lg","centered":"","id":"modalPopover","title":"Hent vejledning her","ok-only":""}},[_c('b-col',{staticClass:"h-100 d-inline-block",attrs:{"md":"12"}},[_c('b-embed',{attrs:{"type":"iframe","scrolling":"no","src":"","aspect":"1by1","allowfullscreen":""}})],1),_vm._v(" "),_c('div',{staticClass:"py-4 px-4 d-flex justify-content-between w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"type":"reset","variant":"outline-dark","size":"lg"},on:{"click":_vm.hideModal}},[_vm._v("Luk\n        ")])],1)],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 966 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opgavetyper_vue__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37ac0b6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Opgavetyper_vue__ = __webpack_require__(973);
function injectStyle (ssrContext) {
  __webpack_require__(967)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-c37ac0b6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opgavetyper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c37ac0b6_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Opgavetyper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 967 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 968 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DineOpgavetyper__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imentor__ = __webpack_require__(103);





var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'opgavetyper',
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_2__imentor__["a" /* default */],
    dineopgavetyper: __WEBPACK_IMPORTED_MODULE_0__DineOpgavetyper__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      enterpriseid: 2,
      enterpriseoption: [{ value: 1, text: 'Hovedentreprise' }, { value: 2, text: 'Fagentreprise' }],
      haaid: '',
      noenterprise: false,
      packagehandle: '',
      garantiHandle: true,
      confirmGarantee: false,
      regions: [],
      salesPersonbitrix: '',
      partnerregion: '',
      selectedregion: [],
      partnerregions: [],
      loading: false,
      ispartnerGuarantee: 0
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.partnerregion = localStorage.getItem('prisenRegion');
    this.haaid = localStorage.getItem('haaid');
    this.getAllRegion();
    this.getAllRegionbypartnerID();
    this.getguaranteeStatus();
    this.getenterprise();
  },

  methods: {
    showerror: function showerror(bool) {
      this.noenterprise = bool;
    },
    showpopupConfirmgarantee: function showpopupConfirmgarantee() {
      this.confirmGarantee = true;
    },
    confirmgarante: function confirmgarante() {
      if (this.regions.length > 0) {
        this.updatePartnerregion();
      } else {
        this.addregion();
      }
    },
    closeconfirmGarantee: function closeconfirmGarantee() {
      this.loading = true;
      this.regions = [];
      this.confirmGarantee = false;
      this.getAllRegion();
    },
    getenterprise: function getenterprise() {
      var _this = this;

      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE);
          if (_this.enterpriseid === 0 || _this.enterpriseid === null) {
            document.getElementById('selectedent2').checked = true;
            _this.updateenterprise(2, 'noshow');
          } else {
            _this.updatebutton(_this.enterpriseid);
          }
          _this.getpackagehandle();
        }
      }, function (response) {
        var error = response.body.message;
        _this.$message({
          type: 'error',
          message: error
        });
      });
    },
    getguaranteeStatus: function getguaranteeStatus() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'partner/guaranteeDistance', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.ispartnerGuarantee = res.data.guarantee;
        }
      }, function (response) {
        var error = response.body.message;
        _this2.$message({
          type: 'error',
          message: error
        });
      });
    },
    getAllRegion: function getAllRegion() {
      var _this3 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/regions/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.regions = res.data;
          _this3.regions.forEach(function (l) {
            if (_this3.partnerregion.trim() === l.NAME.replace('Region ', '').trim()) {
              if (!_this3.selectedregion.includes(l.ID)) {
                _this3.selectedregion.push(l.ID);
              }
            }
          });
        }
        _this3.loading = false;
      }, function (response) {
        var error = response.body.message;
        _this3.$message({
          type: 'error',
          message: error
        });
      });
    },
    getAllRegionbypartnerID: function getAllRegionbypartnerID() {
      var _this4 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/regions', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.partnerregions = res.data;
          _this4.partnerregions.forEach(function (l) {
            if (!_this4.selectedregion.includes(l.REGION_ID)) {
              _this4.selectedregion.push(l.REGION_ID);
            }
          });
        }
      }, function (response) {
        var error = response.body.message;
        _this4.$refs.errorMsg.showMsg(error);
      });
    },
    getpackagehandle: function getpackagehandle() {
      this.packagehandle = localStorage.getItem('PartnerPackageHandle');
      this.getbitrixinfo();
    },
    getbitrixinfo: function getbitrixinfo() {
      var _this5 = this;

      this.$http.get(this.$bitrixapi + 'bitrix/getPackage/' + this.haaid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE);
          _this5.packagehandle = res.data.PACKAGE_HANDLE;
        }
      }, function (response) {
        var error = response.body.message;
        _this5.$message({
          type: 'error',
          message: error
        });
      });
    },
    addregion: function addregion() {
      var _this6 = this;

      this.loading = true;
      this.closeconfirmGarantee();
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        regionIds: this.selectedregion
      };
      this.$http.post(this.$bitrixapi + 'partner/region/add', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.loading = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this6.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        _this6.loading = false;
        var error = response.body.message;
        _this6.$message({
          type: 'error',
          message: error
        });
      });
    },
    updatebutton: function updatebutton() {
      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      if (item === 3) {
        document.getElementById('selectedent2').checked = true;
        document.getElementById('selectedent1').checked = true;
      } else {
        var selectedEnt = document.getElementById('selectedent' + item);
        selectedEnt.checked = true;
      }
    },
    updatePartnerregion: function updatePartnerregion() {
      var _this7 = this;

      this.loading = true;
      this.closeconfirmGarantee();
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        regionIds: this.selectedregion
      };
      this.$http.post(this.$bitrixapi + 'partner/region/edit', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.loading = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this7.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        _this7.loading = false;
        var error = response.body.message;
        _this7.$message({
          type: 'error',
          message: error
        });
      });
    },
    updateenterprise: function updateenterprise() {
      var _this8 = this;

      var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;
      var noshow = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (this.packagehandle === 'vaekstopgavegaranti' || this.packagehandle === 'vaekstgaranti') {
        if (document.getElementById('selectedent2').checked) {
          document.getElementById('selectedent2').checked = true;
        } else {
          document.getElementById('selectedent2').checked = true;
          return;
        }
      }
      if (document.getElementById('selectedent2').checked && document.getElementById('selectedent1').checked) {
        this.enterpriseid = 3;
      } else if (document.getElementById('selectedent2').checked && !document.getElementById('selectedent1').checked) {
        this.enterpriseid = 2;
      } else if (document.getElementById('selectedent1').checked && !document.getElementById('selectedent2').checked) {
        this.enterpriseid = 1;
      } else {
        document.getElementById('selectedent' + item).checked = true;
        return false;
      }
      if (this.enterpriseid === '' || this.enterpriseid === null) {
        return false;
      }
      var data = {
        UF_CRM_COMPANY_ENTERPRISE: this.enterpriseid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.haaid, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this8.noenterprise = false;
          if (noshow !== 'noshow') {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this8.$refs.simplert.openSimplert(obj);
          }
          _this8.updatebutton(_this8.enterpriseid);
        }
      }, function (response) {
        var error = response.body.message;
        _this8.$message({
          type: 'error',
          message: error
        });
      });
    },
    updateregion: function updateregion() {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee();
      } else {
        this.confirmgarante();
      }
    }
  }
});

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DineOpgavetyper_vue__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315d88ee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DineOpgavetyper_vue__ = __webpack_require__(972);
function injectStyle (ssrContext) {
  __webpack_require__(970)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DineOpgavetyper_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_315d88ee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DineOpgavetyper_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 970 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dineopgavetyper',
  props: ['enterpriseid', 'ispartnerGuarantee'],
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.gettaskbitrix();
  },

  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  data: function data() {
    return {
      items: [],
      showimentor: true,
      show: false,
      label: 'Loading...',
      overlay: 1,
      selected: [],
      selectedinitial: [],
      loading: true,
      selectedtasktype: [],
      selectedtasktypeeach: [],
      parsingcheckbox: false,
      salesPersonbitrix: '',
      confirmGarantee: false,
      seletecteditem: {}
    };
  },

  methods: {
    toggleAlarmpris: function toggleAlarmpris(checked) {
      this.form.alarmpris.selected = checked ? this.form.alarmpris.choices.slice() : [];
    },
    clearAlloption: function clearAlloption() {
      this.selected = [];
      this.items.forEach(function (l) {
        document.getElementById('checkbox' + l.BRANCHE_ID).checked = false;
        document.getElementById('div' + l.BRANCHE_ID).style.display = 'none';
      });
    },
    showpopupConfirmgarantee: function showpopupConfirmgarantee(item, SUBCATEGORY_ID, type) {
      var _this = this;

      if (type === 'sub') {
        this.seletecteditem['item'] = item;
        this.seletecteditem['sub'] = SUBCATEGORY_ID;
        this.seletecteditem['type'] = type;
      } else if (type === 'main') {
        this.seletecteditem['item'] = item;
        this.seletecteditem['type'] = type;
      }
      setTimeout(function () {
        _this.confirmGarantee = true;
      }, 200);
    },
    closeconfirmGarantee: function closeconfirmGarantee() {
      this.loading = true;
      this.gettaskbitrix();
      this.confirmGarantee = false;
    },
    opgave_action: function opgave_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      if (this.selected.length === 0) {
        this.modalShowDato = false;

        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'danger'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      var dataPartner = { operation: 'producttask', salesPerson: this.salesPerson, category: this.selected };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;

        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;

          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    opgave_action1: function opgave_action1() {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      if (this.selected.length === 0) {
        this.modalShowDato = false;

        var _obj2 = {
          title: 'Vælg Opgavetyper!',
          message: '',
          type: 'danger'
        };
        this.$refs.simplert.openSimplert(_obj2);
        return;
      }
      var thisvar = this;
      var confirmFn = function confirmFn() {
        thisvar.saveselectedtaskbitrix();
      };
      var obj = {
        customClass: 'confirmDialog',
        message: 'Jeg bekræfter hermed, at jeg og/eller mine medarbejdere er uddannet til at udføre de valgte opgavetyper.',
        useConfirmBtn: true,
        customIconUrl: 'static/svg/warning-blue.svg',
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'action-button h5 regular p2 px3 mb2',
        customCloseBtnClass: 'standard-button h5 regular p2 px3 mb2',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    opgave_action2: function opgave_action2() {
      var _this3 = this;

      this.show = true;
      var serialize = [];
      this.selected.forEach(function (a, index) {
        var individ = {};
        individ['id'] = a;
        serialize.push(individ);
      });

      var dataPartner = {
        operation: 'newproducttask',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        category: this.selected,
        sort: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(serialize)
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;

        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
        } else {}
      }, function (response) {});
    },
    titleItem: function titleItem(item) {
      for (var Subitem in this.items) {
        for (var Subitem1 in this.items[Subitem].SubIndustries) {
          if (this.items[Subitem].SubIndustries[Subitem1].SUBCATEGORY_ID === parseInt(item)) {
            return this.items[Subitem].SubIndustries[Subitem1].SUBCATEGORY_NAME;
          }
        }
      }
    },
    toggletasksub: function toggletasksub(taskitem, mainId, subId, subName) {
      if (document.getElementById('checkboxtasktype' + taskitem.taskTypeId).checked) {
        var tasktypedetails = {};
        tasktypedetails['taskTypeId'] = taskitem.taskTypeId;
        tasktypedetails['taskTypeName'] = taskitem.name;
        tasktypedetails['subcategoryId'] = subId;
        tasktypedetails['subcategoryName'] = subName;
        tasktypedetails['mainIndustryId'] = mainId;
        this.selectedtasktype.push(tasktypedetails);
      } else {
        this.removetasktypefromsub(this.selectedtasktype, taskitem.taskTypeId);
      }
    },
    toggleAllsub: function toggleAllsub(suitem) {
      var _this4 = this;

      var mainTaskId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';

      if (document.getElementById(suitem.SUBCATEGORY_ID).checked) {
        document.getElementById('checkbox' + mainTaskId).checked = true;
        var thisvarmp = this;
        if (suitem.taskTypes) {
          if (suitem.taskTypes.length > 0) {
            suitem.taskTypes.forEach(function (a) {
              var tasktypedetails = {};
              tasktypedetails['taskTypeId'] = a.taskTypeId;
              tasktypedetails['taskTypeName'] = a.name;
              tasktypedetails['subcategoryId'] = suitem.SUBCATEGORY_ID;
              tasktypedetails['subcategoryName'] = suitem.SUBCATEGORY_NAME;
              tasktypedetails['mainIndustryId'] = mainTaskId;
              document.getElementById('tasktype' + a.taskTypeId).classList.remove('hide');
              document.getElementById('checkboxtasktype' + a.taskTypeId).checked = true;
              thisvarmp.selectedtasktype.push(tasktypedetails);
            });
          } else {
            var taskdetailed2 = {};
            taskdetailed2['taskTypeId'] = '';
            taskdetailed2['taskTypeName'] = '';
            taskdetailed2['subcategoryId'] = suitem.SUBCATEGORY_ID;
            taskdetailed2['subcategoryName'] = suitem.SUBCATEGORY_NAME;
            taskdetailed2['mainIndustryId'] = mainTaskId;
            thisvarmp.selectedtasktype.push(taskdetailed2);
          }
        } else {
          var taskdetails3 = {};
          taskdetails3['taskTypeId'] = '';
          taskdetails3['taskTypeName'] = '';
          taskdetails3['subcategoryId'] = suitem.SUBCATEGORY_ID;
          taskdetails3['subcategoryName'] = suitem.SUBCATEGORY_NAME;
          taskdetails3['mainIndustryId'] = mainTaskId;
          thisvarmp.selectedtasktype.push(taskdetails3);
        }
      } else {
        var varthis = this;
        if (suitem.taskTypes) {
          if (suitem.taskTypes.length > 0) {
            var unchosen = [];
            varthis.selectedtasktype.forEach(function (c) {
              unchosen.push(c.taskTypeId);
            });
            suitem.taskTypes.forEach(function (a) {
              document.getElementById('tasktype' + a.taskTypeId).classList.add('hide');
              document.getElementById('checkboxtasktype' + a.taskTypeId).checked = false;
              if (unchosen.includes(a.taskTypeId)) {
                _this4.removeallItemtasktosub(varthis.selectedtasktype, suitem.SUBCATEGORY_ID);
              }
            });
          } else {
            this.removeallItemtasktosub(this.selectedtasktype, suitem.SUBCATEGORY_ID);
          }
        } else {
          this.removeallItemtasktosub(this.selectedtasktype, suitem.SUBCATEGORY_ID);
        }
        var unchosenfiltered = [];
        unchosenfiltered = this.selectedtasktype.filter(function (a) {
          return a.mainIndustryId === mainTaskId;
        });
        if (unchosenfiltered.length === 0) {
          document.getElementById('checkbox' + mainTaskId).checked = false;
        }
      }
    },
    toggleAllIndustry: function toggleAllIndustry(item) {
      if ($('#checkbox' + item.IndustryId).is(':checked')) {
        $('#div' + item.IndustryId).show();
        for (var Subitem in item.SubIndustries) {
          this.selected.push(item.SubIndustries[Subitem].SUBCATEGORY_ID);
        }
      } else {
        for (var Subitem1 in item.SubIndustries) {
          this.removeItem(this.selected, item.SubIndustries[Subitem1].SUBCATEGORY_ID);
        }
      }
      this.confirmGarantee = false;
    },
    toggleAllSubIndustry: function toggleAllSubIndustry(item, SUBCATEGORY_ID) {
      if ($('#' + SUBCATEGORY_ID).is(':checked')) {
        for (var Subitem in item.SubIndustries) {
          if (item.SubIndustries[Subitem].PARENT_ID.toString() === SUBCATEGORY_ID.toString()) {
            this.selected.push(item.SubIndustries[Subitem].SUBCATEGORY_ID);
          }
        }
      } else {
        for (var SubitemDel in item.SubIndustries) {
          if (item.SubIndustries[SubitemDel].PARENT_ID.toString() === SUBCATEGORY_ID.toString()) {
            this.removeItem(this.selected, item.SubIndustries[SubitemDel].SUBCATEGORY_ID);
          }
        }
      }
      this.confirmGarantee = false;
    },
    updatewithguaranteeSub: function updatewithguaranteeSub(item, SUBCATEGORY_ID) {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee(item, SUBCATEGORY_ID, 'sub');
      } else {
        this.toggleAllSubIndustry(item, SUBCATEGORY_ID);
      }
    },
    updatewithguaranteemain: function updatewithguaranteemain(item) {
      if (this.ispartnerGuarantee === 1) {
        this.showpopupConfirmgarantee(item, '', 'main');
      } else {
        this.toggleAllIndustry(item);
      }
    },
    toggleAll: function toggleAll(item) {
      if ($('#checkbox' + item).is(':checked')) {
        $('#' + item).show();
        for (var Subitem in this.items) {
          if (this.items[Subitem].parent_id === item) {
            this.selected.push(this.items[Subitem].id);
          }
        }
      } else {
        $('#' + item).hide();
        for (var Subitem1 in this.items) {
          if (this.items[Subitem1].parent_id === item) {
            this.removeItem(this.selected, this.items[Subitem1].id);
          }
        }
      }
    },
    removeallItemtasktosub: function removeallItemtasktosub(arr, suitemid) {
      arr.splice(arr.findIndex(function (a) {
        return a.SUBCATEGORY_ID === suitemid;
      }), 1);
    },
    removetasktypefromsub: function removetasktypefromsub(arr, taskTypeId) {
      arr.splice(arr.findIndex(function (b) {
        return b.taskTypeId === taskTypeId;
      }), 1);
    },
    removeItem: function removeItem(array, item) {
      for (var i in array) {
        if (array[i] === item) {
          array.splice(i, 1);
          break;
        }
      }
    },
    firstSelected: function firstSelected() {
      var _this5 = this;

      var thisvar = this;
      this.items.forEach(function (a) {
        var mainid = a.BRANCHE_ID;
        a.SubIndustries.forEach(function (b) {
          var subid = b.SUBCATEGORY_ID;
          if (thisvar.selected.includes(b.SUBCATEGORY_ID)) {
            $('#div' + mainid).show();
            document.getElementById('checkbox' + mainid).checked = true;
            document.getElementById(subid).checked = true;
            if (b.taskTypes) {
              b.taskTypes.forEach(function (z) {
                if (thisvar.selectedinitial.includes(z.taskTypeId)) {
                  var tasktypedetails = {};
                  tasktypedetails['taskTypeId'] = z.taskTypeId;
                  tasktypedetails['taskTypeName'] = z.name;
                  tasktypedetails['subcategoryId'] = b.SUBCATEGORY_ID;
                  tasktypedetails['subcategoryName'] = b.SUBCATEGORY_NAME;
                  tasktypedetails['mainIndustryId'] = a.BRANCHE_ID;
                  document.getElementById('tasktype' + z.taskTypeId).classList.remove('hide');
                  document.getElementById('checkboxtasktype' + z.taskTypeId).checked = true;
                  var hasid = [];
                  hasid = _this5.selectedtasktype.filter(function (a) {
                    return a.taskTypeId === z.taskTypeId;
                  });
                  if (hasid.length < 1) {
                    _this5.selectedtasktype.push(tasktypedetails);
                  }
                }
              });
            }
          }
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this6 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');

      this.$http.get(this.$bitrixapi + 'industries/full/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.items = res.data;
          _this6.getselectedtaskbitrix();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getselectedtaskbitrix: function getselectedtaskbitrix() {
      var _this7 = this;

      this.haaId = localStorage.getItem('haaid');

      this.$http.get(this.$bitrixapi + 'supplier/GetSupplierProfileById/' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.loading = false;
          _this7.selected = res.data.c_partner_task_profile;
          if (typeof _this7.selected !== 'undefined') {
            setTimeout(function () {
              return _this7.firstSelected();
            }, 300);
          } else {
            _this7.loading = false;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        });
      }, 3500);
    },
    saveselectedtaskbitrix: function saveselectedtaskbitrix() {
      var _this8 = this;

      this.show = true;
      if (this.enterpriseid === 0) {
        this.$emit('noenterprise', true);
        return false;
      }
      this.loading = true;
      var serialize = [];
      this.selected.forEach(function (a, index) {
        var individ = {};
        individ['id'] = a;
        serialize.push(individ);
      });
      var data = {
        partnerId: this.haaId,
        category: this.selected,
        taskTypes: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedtasktype),
        sort: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(serialize)
      };
      this.$http.post(this.$bitrixapi + 'task/savePartnerTaskProfile', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this8.show = false;
        if (res.success) {
          _this8.getselectedtaskbitrix();
          _this8.modalShowDato = false;
          _this8.loading = false;
          _this8.show = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this8.$refs.simplert.openSimplert(obj);
        } else {
          alert('Error');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        });
      }, 3500);
    },
    Reload: function Reload() {
      var _this9 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this9.loading = false;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        _this9.items = res.lavproduct;
        if (res.newdataObjselect instanceof Array) {
          _this9.selected = res.newdataObjselect;
        }
        setTimeout(function () {
          return _this9.firstSelected();
        }, 500);
      }, function (response) {
        alert('error');
      });
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 1
        });
      }, 3500);
    },
    toggleElektrikerpris: function toggleElektrikerpris(checked) {
      this.form.elektrikerpris.selected = checked ? this.form.elektrikerpris.choices.slice() : [];
    },
    toggleGaragepris: function toggleGaragepris(checked) {
      this.form.garagepris.selected = checked ? this.form.garagepris.choices.slice() : [];
    },
    toggleGulvpris: function toggleGulvpris(checked) {
      this.form.gulvpris.selected = checked ? this.form.gulvpris.choices.slice() : [];
    },
    onReset: function onReset(evt) {
      evt.preventDefault();

      this.form.alarmprisTypes = '';
    }
  },
  watch: {
    alarmSelected: function alarmSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.alarmpris.indeterminate = true;
        this.form.alarmpris.allSelected = false;
      } else if (newVal.length === this.form.alarmpris.choices.length) {
        this.form.alarmpris.indeterminate = false;
        this.form.alarmpris.allSelected = true;
      } else {
        this.form.alarmpris.indeterminate = false;
        this.form.alarmpris.allSelected = false;
      }
    },
    elektrikerSelected: function elektrikerSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.elektrikerpris.indeterminate = true;
        this.form.elektrikerpris.allSelected = false;
      } else if (newVal.length === this.form.elektrikerpris.choices.length) {
        this.form.elektrikerpris.indeterminate = false;
        this.form.elektrikerpris.allSelected = true;
      } else {
        this.form.elektrikerpris.indeterminate = false;
        this.form.elektrikerpris.allSelected = false;
      }
    },
    garageSelected: function garageSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.garagepris.indeterminate = true;
        this.form.garagepris.allSelected = false;
      } else if (newVal.length === this.form.garagepris.choices.length) {
        this.form.garagepris.indeterminate = false;
        this.form.garagepris.allSelected = true;
      } else {
        this.form.garagepris.indeterminate = false;
        this.form.garagepris.allSelected = false;
      }
    },
    gulvSelected: function gulvSelected(newVal, oldVal) {
      if (newVal.length === 0) {
        this.form.gulvpris.indeterminate = true;
        this.form.gulvpris.allSelected = false;
      } else if (newVal.length === this.form.gulvpris.choices.length) {
        this.form.gulvpris.indeterminate = false;
        this.form.gulvpris.allSelected = true;
      } else {
        this.form.gulvpris.indeterminate = false;
        this.form.gulvpris.allSelected = false;
      }
    }
  }
});

/***/ }),
/* 972 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('form',[_c('fieldset',[(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.loading)?_c('div',{staticClass:"clearfix flex flex-column justify-start items-start notosans darkblue"},[(_vm.selected.length > 0)?_c('div',{staticClass:"col-12 px0 mb3"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"h5 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n              Mine opgavetyper\n            ")]),_vm._v(" "),_c('div',{staticClass:"ml-auto p0 m0"},[_c('button',{staticClass:"p1 px2 white-background border darkbue-border ",attrs:{"type":"button"},on:{"click":function($event){return _vm.clearAlloption()}}},[_c('span',{staticClass:"p0 h6 darkblue regular"},[_vm._v("Ryd filter")])])])]),_vm._v(" "),_c('div',{staticClass:"dd my2 col-12 px0",attrs:{"id":"nestable_list_1"}},[_c('ol',{staticClass:"dd-list border primarycolor-border p1"},_vm._l((_vm.selected),function(item){return _c('li',{key:item.id,staticClass:"dd-item inline-block pr1 rounded",attrs:{"data-id":item}},[_c('div',{staticClass:"p1 px2 darkblue-background white regular h6 line-height-3"},[_vm._v(_vm._s(_vm.titleItem(item)))])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 pl0 pr1 mt2"},[_c('p',{staticClass:"h5 semi-bold line-height-2 darkblue"},[_vm._v("\n            Vælg opgavetyper\n          ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.industryId,staticClass:"col-12 p0"},[_c('div',[_c('div',{staticClass:"flex flex-column mb1 muted-background p1"},[_c('div',{staticClass:"col-12 flex justify-between items-center"},[_c('div',[_c('input',{staticStyle:{"height":"18px","width":"18px"},attrs:{"type":"checkbox","id":'checkbox' + item.BRANCHE_ID,"unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.updatewithguaranteemain(item)}}}),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold ml1 line-height-1 m0 p0"},[_vm._v(_vm._s(item.BRANCHE))])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('div' + item.BRANCHE_ID),expression:"'div' + item.BRANCHE_ID"}],staticClass:"transparent-button border-none not-rounded p1 line-height-1",attrs:{"type":"button"}},[_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"18","height":"18","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"18","height":"18","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"clearfix pl2"},[_c('b-collapse',{staticClass:"col-12 my3 m0 subItemCollapse",attrs:{"id":'div' + item.BRANCHE_ID}},_vm._l((item.SubIndustries),function(subitem,index){return (subitem.PARENT_ID === 0)?_c('div',{key:index,staticClass:"flex flex-column justify-start items-center mb2"},[_c('div',{staticClass:"col-12 border border-green border-left-0 border-top-0 border-right-0 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","id":subitem.SUBCATEGORY_ID,"unchecked-value":"not_accepted"},domProps:{"value":subitem.SUBCATEGORY_ID,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,subitem.SUBCATEGORY_ID)>-1:(_vm.selected)},on:{"change":[function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=subitem.SUBCATEGORY_ID,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}},function($event){return _vm.updatewithguaranteeSub(item,subitem.SUBCATEGORY_ID)}]}}),_vm._v(" "),_c('span',{staticClass:"h5 darkblue regular inline-block ml1 mb0"},[_vm._v(_vm._s(subitem.SUBCATEGORY_NAME))])]),_vm._v(" "),_vm._l((item.SubIndustries),function(subitem_other,index){return (subitem_other.PARENT_ID === subitem.SUBCATEGORY_ID)?_c('div',{key:index,staticClass:"col-11 mt1"},[_c('div',{staticClass:"col-12 border border-green border-left-0 border-top-0 border-right-0 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","id":subitem_other.SUBCATEGORY_ID,"unchecked-value":"not_accepted"},domProps:{"value":subitem_other.SUBCATEGORY_ID,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,subitem_other.SUBCATEGORY_ID)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=subitem_other.SUBCATEGORY_ID,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:"h5 darkblue regular inline-block ml1 mb0"},[_vm._v(_vm._s(subitem_other.SUBCATEGORY_NAME))])])]):_vm._e()})],2):_vm._e()}),0)],1)])])])}),_vm._v(" "),_c('div',{staticClass:"px2"},[(_vm.showimentor)?_c('button',{staticClass:"h5 action-button gibson p2 px3 flex justify-center items-center not-rounded my3",attrs:{"type":"button"},on:{"click":function($event){return _vm.opgave_action1()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem opgavetyper")]),_vm._v(" "),_vm._m(0)]):_vm._e()])],2)]):_vm._e(),_vm._v(" "),(_vm.showMobile && !_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n            Vælg opgavetyper\n          ")]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.industryId,staticClass:"col-12 px0"},[_c('div',[_c('div',{staticClass:"flex flex-column mb1 muted-background p1 py2",attrs:{"id":"mobilecheckbox"}},[_c('div',{staticClass:"flex justify-start items-center"},[_c('div',[_c('input',{staticStyle:{"height":"18px","width":"18px"},attrs:{"type":"checkbox","id":'checkbox' + item.BRANCHE_ID,"unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.updatewithguaranteemain(item)}}}),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold ml1 line-height-1 m0 p0"},[_vm._v(_vm._s(item.BRANCHE))])]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('div' + item.BRANCHE_ID),expression:"'div' + item.BRANCHE_ID"}],staticClass:"transparent-button border-none not-rounded p1 line-height-1",attrs:{"type":"button"}},[_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"18","height":"18","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"18","height":"18","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"clearfix pl2"},[_c('b-collapse',{staticClass:"col-12 my2 m0 subItemCollapse",attrs:{"id":'div' + item.BRANCHE_ID}},_vm._l((item.SubIndustries),function(subitem,index){return (subitem.PARENT_ID === 0)?_c('div',{key:index,staticClass:" mb2"},[_c('div',{staticClass:"border border-green border-left-0 border-top-0 border-right-0 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","id":subitem.SUBCATEGORY_ID,"unchecked-value":"not_accepted"},domProps:{"value":subitem.SUBCATEGORY_ID,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,subitem.SUBCATEGORY_ID)>-1:(_vm.selected)},on:{"change":[function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=subitem.SUBCATEGORY_ID,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}},function($event){return _vm.updatewithguaranteeSub(item,subitem.SUBCATEGORY_ID)}]}}),_vm._v(" "),_c('span',{staticClass:" darkblue regular inline-block ml1 mb0"},[_vm._v(_vm._s(subitem.SUBCATEGORY_NAME))])]),_vm._v(" "),_vm._l((item.SubIndustries),function(subitem_other,index){return (subitem_other.PARENT_ID === subitem.SUBCATEGORY_ID)?_c('div',{key:index,staticClass:"col-11 mt1"},[_c('div',{staticClass:"border border-green border-left-0 border-top-0 border-right-0 "},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.selected),expression:"selected"}],staticStyle:{"width":"16px","height":"16px"},attrs:{"type":"checkbox","id":subitem_other.SUBCATEGORY_ID,"unchecked-value":"not_accepted"},domProps:{"value":subitem_other.SUBCATEGORY_ID,"checked":Array.isArray(_vm.selected)?_vm._i(_vm.selected,subitem_other.SUBCATEGORY_ID)>-1:(_vm.selected)},on:{"change":function($event){var $$a=_vm.selected,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=subitem_other.SUBCATEGORY_ID,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.selected=$$a.concat([$$v]))}else{$$i>-1&&(_vm.selected=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.selected=$$c}}}}),_vm._v(" "),_c('span',{staticClass:" darkblue regular inline-block ml1 mb0"},[_vm._v(_vm._s(subitem_other.SUBCATEGORY_NAME))])])]):_vm._e()})],2):_vm._e()}),0)],1)])])])}),_vm._v(" "),_c('div',{staticClass:"px2"},[(_vm.showimentor)?_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-8 lg-col-6 h5 action-button gibson p2 flex justify-center items-center not-rounded my3",attrs:{"type":"button","disabled":_vm.parsingcheckbox},on:{"click":function($event){return _vm.opgave_action1()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem opgavetyper")]),_vm._v(" "),_vm._m(1)]):_vm._e()])],2),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n            Valgte opgavetyper\n          ")]),_vm._v(" "),_c('div',{staticClass:"dd my2",attrs:{"id":"nestable_list_1"}},[_c('ol',{staticClass:"dd-list"},_vm._l((_vm.selected),function(item){return _c('li',{staticClass:"dd-item inline-block pr1",attrs:{"data-id":item}},[_c('div',{staticClass:"p1 px2 muted-background darkblue regular h6 line-height-3"},[_vm._v(_vm._s(_vm.titleItem(item)))])])}),0)])])]):_vm._e()])]),_vm._v(" "),_c('b-modal',{ref:"confirmGarantee",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmGarantee","no-close-on-backdrop":true,"size":"md","no-close-on-esc":""},model:{value:(_vm.confirmGarantee),callback:function ($$v) {_vm.confirmGarantee=$$v},expression:"confirmGarantee"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmGarantee()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background px2 "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Du ændrer din jobdefinition. Du mister din garanti fra os. Er du sikker på, at du vil fortsætte ?")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-around my2"},[_c('button',{staticClass:"center p2 px3 outlined-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmGarantee()}}},[_c('span',{staticClass:"h6 regular"},[_vm._v("Afbestille")])]),_vm._v(" "),(_vm.seletecteditem['type'] === 'sub')?_c('button',{staticClass:"center p2 px3 action-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleAllSubIndustry(_vm.seletecteditem['item'], _vm.seletecteditem['sub'])}}},[_c('span',{staticClass:"h6 regular"},[_vm._v("Blive ved")])]):(_vm.seletecteditem['type'] === 'main')?_c('button',{staticClass:"center p2 px3 action-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.toggleAllIndustry(_vm.seletecteditem['item'])}}},[_c('span',{staticClass:"h6 regular"},[_vm._v("Blive ved")])]):_vm._e()])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":false}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix gibson mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow md-hide lg-hide"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mb3 flex flex-column"},[_c('div',{staticClass:"flex flex-wrap gap-10 col-12 mb3 p0"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.regions),function(region,index){return _c('div',{key:index,staticClass:"lightgrey-background p1 px1 flex items-center",staticStyle:{"width":"300px"}},[_c('el-checkbox-group',{model:{value:(_vm.selectedregion),callback:function ($$v) {_vm.selectedregion=$$v},expression:"selectedregion"}},[_c('el-checkbox',{key:region.ID,staticStyle:{"height":"18px","width":"18px"},attrs:{"label":region.ID,"disabled":_vm.partnerregion.trim() === region.NAME.replace('Region ', '').trim(),"id":'selectregion' + region.ID},on:{"change":function($event){return _vm.updateregion()}}},[_vm._v("\n                  "+_vm._s(region.NAME.replace('Region ', ''))+"\n                ")])],1)],1)})],2),_vm._v(" "),_c('p',{staticClass:"col-12 h5 semi-bold line-height-2 px2 darkblue"},[_vm._v("Vælg hvilke entreprisetyper du laver ?")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column justify-start items-start p0"},_vm._l((_vm.enterpriseoption),function(item){return _c('div',{key:'selectedent' + item.value,staticClass:"mt1 mr1 flex lightgrey-background p1",staticStyle:{"width":"300px"},attrs:{"id":"enterprise"}},[_c('span',{staticClass:"h6 semi-bold ml1 line-height-1 m0 p0"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('input',{staticClass:"ml-auto",attrs:{"type":"checkbox","id":'selectedent' + item.value,"unchecked-value":"not_accepted"},domProps:{"value":item.value},on:{"change":function($event){return _vm.updateenterprise(item)}}})])}),0),_vm._v(" "),(_vm.noenterprise)?_c('el-alert',{staticClass:"line-height-1 mt2 col-12 mx-auto",attrs:{"title":"Vælg venligst din virksomhed","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1),_vm._v(" "),_c('dineopgavetyper',{attrs:{"enterpriseid":_vm.enterpriseid,"ispartnerGuarantee":_vm.ispartnerGuarantee},on:{"noenterprise":function($event){return _vm.showerror($event)}}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix p2 xs-hide sm-hide"},[_vm._m(2),_vm._v(" "),_c('dineopgavetyper',{attrs:{"enterpriseid":_vm.enterpriseid,"ispartnerGuarantee":_vm.ispartnerGuarantee},on:{"noenterprise":function($event){return _vm.showerror($event)}}})],1)])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix ml4"},[_vm._m(3),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"flex flex-wrap gap-10 col-7 mb3"},[_vm._m(4),_vm._v(" "),_vm._l((_vm.regions),function(region,index){return _c('div',{key:index,staticClass:"lightgrey-background p1 px1 flex items-center",staticStyle:{"width":"300px"}},[_c('el-checkbox-group',{model:{value:(_vm.selectedregion),callback:function ($$v) {_vm.selectedregion=$$v},expression:"selectedregion"}},[_c('el-checkbox',{key:region.ID,staticStyle:{"height":"18px","width":"18px"},attrs:{"label":region.ID,"disabled":_vm.partnerregion.trim() === region.NAME.replace('Region ', '').trim(),"id":'selectregion' + region.ID},on:{"change":function($event){return _vm.updateregion()}}},[_vm._v("\n                "+_vm._s(region.NAME.replace('Region ', ''))+"\n              ")])],1)],1)})],2),_vm._v(" "),_c('div',{staticClass:"mb3 flex flex-column mb3"},[_c('p',{staticClass:"col-7 h4 semi-bold line-height-2 p0 darkblue px2"},[_vm._v("Vælg hvilke entreprisetyper du laver ?")]),_vm._v(" "),_c('div',{staticClass:"col-7 flex justify-start items-center gap-10"},_vm._l((_vm.enterpriseoption),function(item){return _c('div',{key:'selectedent' + item.value,staticClass:"p1 lightgrey-background p1 px1 flex items-center",staticStyle:{"width":"300px"},attrs:{"id":"enterprise"}},[_c('span',{staticClass:"h6 ml1 line-height-1 m0 p0"},[_vm._v(_vm._s(item.text))]),_vm._v(" "),_c('input',{staticClass:"ml-auto",staticStyle:{"height":"18px","width":"18px"},attrs:{"type":"checkbox","id":'selectedent' + item.value,"unchecked-value":"not_accepted"},domProps:{"value":item.value},on:{"change":function($event){return _vm.updateenterprise(item.value)}}})])}),0),_vm._v(" "),(_vm.noenterprise)?_c('el-alert',{staticClass:"line-height-1 mt2 col-12 mx-auto",attrs:{"title":"Vælg venligst din virksomhed","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb4 px2"},[_c('dineopgavetyper',{attrs:{"enterpriseid":_vm.enterpriseid,"ispartnerGuarantee":_vm.ispartnerGuarantee},on:{"noenterprise":function($event){return _vm.showerror($event)}}})],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py2"})]),_vm._v(" "),_c('b-modal',{ref:"confirmGarantee",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmGarantee","no-close-on-backdrop":true,"size":"md","no-close-on-esc":""},model:{value:(_vm.confirmGarantee),callback:function ($$v) {_vm.confirmGarantee=$$v},expression:"confirmGarantee"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmGarantee()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background px2 "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Hvis du ændrer din job definition, vil du miste garantien fra os. Er du sikker på, at du ønsker at fortsætte?")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-around my2"},[_c('button',{staticClass:"center p2 px3 outlined-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmGarantee()}}},[_c('span',{staticClass:"h6 regular"},[_vm._v("Afbestille")])]),_vm._v(" "),_c('button',{staticClass:"center p2 px3 action-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmgarante()}}},[_c('span',{staticClass:"h6 regular"},[_vm._v("Blive ved")])])])]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Opgavetyper")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under \"valgte opgavetyper\", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 p0 mt2 mb1 gibson darkblue"},[_vm._v("Vælg Region")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 px2 gibson darkblue"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Opgavetyper")]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden mb3"},[_vm._v("Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under \"valgte opgavetyper\", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-7 p2 py3 mb2"},[_c('div',{staticClass:"clearfix px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 mt2 mb1 gibson darkblue"},[_vm._v("Opgavetyper")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-golden darkblue regular"},[_vm._v("Her kan du vælge de opgavetyper, som du beskæftiger dig med. Når du klikker på en kategori, kan du fjerne eller tilføje opgavetyper. Til højre under \"valgte opgavetyper\", kan du prioritere i de valgte opgaver. Det vil sige at du kan vælge de opgavetyper, som du helst vil beskæftige dig med i forhold til andre. Du prioriterer i opgavetyperne ved at trække i den opgavetype, som du ønsker at flytte op eller ned. Den øverste opgavetype er din 1. prioritet.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h4 semi-bold line-height-2 p0 mt2 mb1 gibson darkblue"},[_vm._v("Vælg Region")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 974 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ferieperioder_vue__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c959b34_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Ferieperioder_vue__ = __webpack_require__(979);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Ferieperioder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c959b34_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Ferieperioder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DineFerieperioder__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__imentor__ = __webpack_require__(103);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ferieperioder',
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_1__imentor__["a" /* default */],
    dineferieperioder: __WEBPACK_IMPORTED_MODULE_0__DineFerieperioder__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  }
});

/***/ }),
/* 976 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DineFerieperioder_vue__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6cce18_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DineFerieperioder_vue__ = __webpack_require__(978);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DineFerieperioder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4c6cce18_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_DineFerieperioder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker__);





var todayDate = new Date().getDate();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dineferieperioder',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_2_vue_bootstrap_datetimepicker___default.a
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },
  data: function data() {
    return {
      form: {
        ferieStart: '',
        ferieEnd: ''
      },
      inactivesms: '0',

      items: [],
      show: false,
      label: 'Loading...',
      overlay: 1,
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(new Date().setDate(todayDate - 1)),
        useCurrent: false,
        showClear: false,
        showClose: false
      }
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res.holiday;
        _this.inactivesms = res.inactivesms;
      }, function (response) {
        alert('error');
      });
    },
    sletHoliday: function sletHoliday(item) {
      var confirmFn = function confirmFn() {
        this.$parent.servicefree_remove(item);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne ferieperiode ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    servicefree_remove: function servicefree_remove(item) {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'servicefree_remove', salesPerson: this.salesPerson, holidayid: item };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_free_action: function service_free_action() {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'servicefree', salesPerson: this.salesPerson, datechooseqfreestart: this.form.ferieStart, datechooseqfreeend: this.form.ferieEnd };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.Reload();
          _this3.form.ferieStart = '';
          _this3.form.ferieEnd = '';
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 978 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[(_vm.inactivesms === '1')?_c('div',{staticClass:"clearfix border muted-border p4 flex justify-start items-center"},[_c('p',{staticClass:"h5 regular line-height-1 darkblue gibson mb0 flex justify-start items-center"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-alert",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm0-13a1 1 0 0 1 1 1v5a1 1 0 0 1-2 0V6a1 1 0 0 1 1-1zm0 10a1 1 0 1 1 0-2 1 1 0 0 1 0 2z"}})])]),_vm._v(" "),_c('span',[_vm._v("Du er deaktiveret")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix pb3"},[_c('p',{staticClass:"h5 semi-bold line-height-4 darkblue gibson mb2"},[_vm._v("\n      Vælg ny feriedato\n    ")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_free_action.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 my2 px0 flex justify-between items-start"},[_c('div',{staticClass:"pr1"},[_c('b-form-group',{staticClass:"h6 darkblue gibson mb1",attrs:{"id":"ferieStart","label":"Fra","label-for":"ferieStart"}},[_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieStart","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.form.ferieStart),callback:function ($$v) {_vm.$set(_vm.form, "ferieStart", $$v)},expression:"form.ferieStart"}})],1)],1),_vm._v(" "),_c('div',[_c('b-form-group',{staticClass:"h6 darkblue gibson mb1",attrs:{"id":"ferieEnd","label":"Til","label-for":"ferieEnd"}},[_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieEnd","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.form.ferieEnd),callback:function ($$v) {_vm.$set(_vm.form, "ferieEnd", $$v)},expression:"form.ferieEnd"}})],1)],1)]),_vm._v(" "),_c('div',[(_vm.showMobile)?_c('button',{staticClass:"col-12 action-button p2 h6 gibson semi-bold",attrs:{"type":"submit"}},[_c('span',[_vm._v("Gem")])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('button',{staticClass:"flex justify-center items-center action-button gibson h5 p2 semi-bold",attrs:{"type":"submit"}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('p',{staticClass:"h5 semi-bold line-height-4 darkblue gibson"},[_vm._v("\n              Dine ferieperioder\n            ")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center mt2"},[_c('span',{staticClass:"h6 inline-block col-4 px0"},[_vm._v("Fra")]),_vm._v(" "),_c('span',{staticClass:"h6 inline-block col-4 px0"},[_vm._v("Til")])]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"flex justify-start items-center py1"},[_c('span',{staticClass:"inline-block col-4 px0 h6"},[_vm._v(_vm._s(item.holiday_from))]),_vm._v(" "),_c('span',{staticClass:"inline-block col-4 px0 h6"},[_vm._v(_vm._s(item.holiday_to))]),_vm._v(" "),_c('button',{staticClass:"col-4 center relative not-rounded delete-button border-none",on:{"click":function($event){return _vm.sletHoliday(item.id_partner_holiday)}}},[_c('span',{staticClass:"relative right-0",staticStyle:{"top":"-3px"}},[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])])])})],2)])])],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[(_vm.showMobile)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix gibson px2"},[_c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"clearfix"},[_c('imentor')],1)])]),_vm._v(" "),_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('dineferieperioder')],1)])]),_vm._v(" "),_c('div',{staticClass:"py3"})]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"clearfix gibson px2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix p2 ml4"},[_c('div',{staticClass:"col-6 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Dine Ferieperioder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n              Her kan du registrere ferieperioder, hvor du ikke får SMS'er eller booket møder ind til afholdelse i perioden (inkl. automatiske erstatningsmøder). Du kan registrere ferieperioder på op til 3 uger i træk og højst 6 uger i alt om året. Har du brug for at registrere flere/længere ferieperioder, så kan du få hjælp til dette ved at ringe til partnerpleje på 70 22 80 14.\n            ")]),_vm._v(" "),_c('dineferieperioder')],1)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix gibson px2"},[_c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"clearfix"},[_c('imentor')],1)])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine Ferieperioder")]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden mb3"},[_vm._v("\n              Her kan du registrere ferieperioder, hvor du ikke får SMS'er eller booket møder ind til afholdelse i perioden (inkl. automatiske erstatningsmøder). Du kan registrere ferieperioder på op til 3 uger i træk og højst 6 uger i alt om året. Har du brug for at registrere flere/længere ferieperioder, så kan du få hjælp til dette ved at ringe til partnerpleje på 70 22 80 14.\n            ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 980 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ekstraphone_vue__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1c4faf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ekstraphone_vue__ = __webpack_require__(985);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ekstraphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c1c4faf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ekstraphone_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Dineekstraphone__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__imentor__ = __webpack_require__(103);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ekstraphone',
  components: {
    Imentor: __WEBPACK_IMPORTED_MODULE_2__imentor__["a" /* default */],
    dineekstraphone: __WEBPACK_IMPORTED_MODULE_0__Dineekstraphone__["a" /* default */],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_1__components_updatebitrixpackagepermission__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dineekstraphone_vue__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752aeb93_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dineekstraphone_vue__ = __webpack_require__(984);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dineekstraphone_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_752aeb93_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Dineekstraphone_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




var todayDate = new Date().getDate();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dineekstraphone',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },
  data: function data() {
    return {
      form: {
        telefon: ''
      },
      inactivesms: '0',

      items: [],
      show: false,
      label: 'Loading...',
      overlay: 1,
      config: {
        format: 'YYYY-MM-DD',
        minDate: new Date(new Date().setDate(todayDate - 1)),
        useCurrent: false,
        showClear: false,
        showClose: false
      }
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res.telefon;
        _this.inactivesms = res.inactivesms;
      }, function (response) {
        alert('error');
      });
    },
    sletPhone: function sletPhone(item) {
      var confirmFn = function confirmFn() {
        this.$parent.servicefree_remove(item);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne telefon ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    servicefree_remove: function servicefree_remove(item) {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'telefon_remove', salesPerson: this.salesPerson, phoneid: item };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    service_free_action: function service_free_action() {
      var _this3 = this;

      if (this.form.telefon.length !== 8) {
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'addTelefon', salesPerson: this.salesPerson, telefon: this.form.telefon };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.Reload();
          _this3.form.telefon = '';
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"col-12 px1"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_free_action.apply(null, arguments)}}},[_c('fieldset',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"clearfix mb1",attrs:{"id":"ferieStart"}},[_c('label',{staticClass:"h6 semi-bold darkblue gibson mt2 mb1 block",attrs:{"label-for":"telefon"}},[_c('span',{staticClass:"h5"},[_vm._v("Indtast telefonnummer")])]),_vm._v(" "),(!_vm.showMobile)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.telefon),expression:"form.telefon"}],staticClass:"px2 py1 col-7 mb2 px0 lightgrey-background darkblue border-none",attrs:{"placeholder":"skal indeholde 8 cifre","id":"telefon","type":"text"},domProps:{"value":(_vm.form.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "telefon", $event.target.value)}}}):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.telefon),expression:"form.telefon"}],staticClass:"p2 h4 regular col-12 lightgrey-background darkblue border-none",attrs:{"placeholder":"skal indeholde 8 cifre","id":"telefon","type":"text"},domProps:{"value":(_vm.form.telefon)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "telefon", $event.target.value)}}}):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.showMobile)?_c('button',{staticClass:"action-button p2 px3 h4 gibson regular",attrs:{"type":"submit"}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('button',{staticClass:"flex justify-center items-center action-button gibson h5 p2 regular",attrs:{"type":"submit"}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mt3"},[_c('p',{staticClass:"h5 semi-bold line-height-4 darkblue gibson"},[_vm._v("\n            Gemte telefonnumre\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt2"},[_c('span',{staticClass:"h6 darkblue semi-bold inline-block col-4 px0"},[_vm._v("Telefon")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue semi-bold inline-block col-4 px0"},[_vm._v("Dato")])]),_vm._v(" "),_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"col-12 px0 flex justify-start items-center py1"},[_c('span',{staticClass:"h6 inline-block col-4 px0 h6"},[_vm._v(_vm._s(item.phone))]),_vm._v(" "),_c('span',{staticClass:"h6 inline-block col-4 px0 h6"},[_vm._v(_vm._s(item.create))]),_vm._v(" "),(item.marketplace === '0')?_c('button',{staticClass:"not-rounded delete-button border-none",staticStyle:{"margin-left":"auto"},attrs:{"type":"button"},on:{"click":function($event){return _vm.sletPhone(item.id)}}},[_c('span',[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])]):_vm._e()])})],2)])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[(_vm.showMobile)?_c('div',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('dineekstraphone')],1)])]),_vm._v(" "),_c('div',{staticClass:"py3"})]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"flex flex-wrap justify-start gibson mt2 ml4 mb2"},[_c('div',{staticClass:"col-7 px0"},[_c('div',{staticClass:"col-12 pt3 pb3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold"},[_vm._v("Dine telefonnumre")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Her kan du tilføje de telefonnumre, som din virksomhed bruger. Vi\n            bruger telefonnumrene som en ekstra service til dine kunder, så de\n            ved, hvem der ringer til dem. Det skaber tryghed for kunden.\n          ")]),_vm._v(" "),_c('dineekstraphone')],1)]),_vm._v(" "),_c('div',[_c('imentor')],1)])]):_vm._e(),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine telefonnumre")]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden mb3"},[_vm._v("\n              Her kan du tilføje de telefonnumre, som din virksomhed bruger.\n              Vi bruger telefonnumrene som en ekstra service til dine kunder,\n              så de ved, hvem der ringer til dem. Det skaber tryghed for\n              kunden.\n            ")])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 986 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilside_vue__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90741e8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profilside_vue__ = __webpack_require__(1027);
function injectStyle (ssrContext) {
  __webpack_require__(987)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profilside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e90741e8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Profilside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 987 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 988 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Profilsideinformation__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ratingWidget__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commentWidget__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uploads_profileimages__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__uploads_profilevideo__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__uploads_imagefolder__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__slim_slim_module_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_quill_editor__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_quill_editor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__noneligibleFeaturepop__ = __webpack_require__(43);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfilSide',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_8__haandvaerker__["a" /* default */],
    ratingWidget: __WEBPACK_IMPORTED_MODULE_1__ratingWidget__["a" /* default */],
    commentWidget: __WEBPACK_IMPORTED_MODULE_2__commentWidget__["a" /* default */],
    VueQuillEditor: __WEBPACK_IMPORTED_MODULE_10_vue_quill_editor___default.a,
    Slim: __WEBPACK_IMPORTED_MODULE_9__slim_slim_module_js__["a" /* default */],
    profilsideinformation: __WEBPACK_IMPORTED_MODULE_0__Profilsideinformation__["a" /* default */],
    profileimages: __WEBPACK_IMPORTED_MODULE_3__uploads_profileimages__["a" /* default */],
    profilevideo: __WEBPACK_IMPORTED_MODULE_4__uploads_profilevideo__["a" /* default */],
    imagefolder: __WEBPACK_IMPORTED_MODULE_5__uploads_imagefolder__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_11__noneligibleFeaturepop__["a" /* default */]
  },
  data: function data() {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      FileLocation: '',
      instance: null,
      show: false,
      modalShowBillede: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      options: {
        hideModules: { 'link': true, 'code': true, 'justifyRight': true, 'justifyCenter': true, 'table': true, 'italic': true }
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {},
      slimOptions: {
        initialImage: this.FileLocation,
        service: this.slimService,
        didInit: this.slimInit,
        didConfirm: this.slimConfirm
      },
      haaId: '',
      imageId: '',
      items: [],
      videos: [],
      images: [],
      eligible: '',
      eliglbletextlimit: 'Ubegrænset',
      activeName: '',
      salesPersonbitrix: ''
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('AccessVideoProProfile');
    this.eliglbletextlimit = localStorage.getItem('AccessDescriptionTextlimit') === null ? 'Ubegrænset' : localStorage.getItem('AccessDescriptionTextlimit');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.Reload();
  },

  methods: {
    getdataigibility: function getdataigibility() {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'AccessVideoProProfile');
      } else {
        this.$refs.picDisplay.show = true;
      }
    },
    slimInit: function slimInit(data, slim) {
      console.log(slim);
      console.log(data);
      this.instance.edit();
      this.show = false;
    },
    openUrl: function openUrl() {
      var win = window.open(this.items.url, '_blank');
      win.focus();
    },
    slimConfirm: function slimConfirm(data, slim) {
      var _this = this;

      console.log();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'edit_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: this.imageId, image: this.instance.dataBase64.output.image };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    slimService: function slimService(formdata, progress, success, failure, slim) {
      console.log(slim);

      console.log(formdata);
      console.log(progress, success, failure);
    },
    Reload: function Reload() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.items = res;
        _this2.myHTML = res.Description;
        _this2.images = res.resultImages;
        _this2.videos = res.resultVideos;
        _this2.ratingwidget = res.ratingwidget;
        _this2.commentwidget = res.commentwidget;
      }, function (response) {
        alert('error');
      });
    },
    SaveDescription: function SaveDescription() {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_haa_desc', salesPerson: this.salesPerson, levid: this.haaId, description: this.myHTML };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.saveConfirmpermissionautomated();
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Tak for opdateringen :)<br />' + 'Din tekst kommer online på din profil så snart den er godkendt.<br />' + '<br />' + 'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    saveConfirmpermissionautomated: function saveConfirmpermissionautomated() {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'external/AutomatedOnboardingApprovedByCraftman?LEV_ID=' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    SaveProfile: function SaveProfile() {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_haa_profile', salesPerson: this.salesPerson, levid: this.haaId, items: this.items };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    edit_image: function edit_image(FileLocation, imageId) {
      this.imageId = imageId;
      FileLocation = FileLocation.split('?');
      if (this.instance) {
        this.show = true;
        this.img.src = FileLocation[0];
        this.instance = new __WEBPACK_IMPORTED_MODULE_9__slim_slim_module_js__["a" /* default */](this.$refs.containerImg, this.slimOptions);
      } else {
        this.show = true;
        this.FileLocation = FileLocation[0];
        this.img = document.createElement('img');
        this.img.setAttribute('alt', '');
        this.img.src = FileLocation[0];
        this.$refs.containerImg.appendChild(this.img);
        this.instance = new __WEBPACK_IMPORTED_MODULE_9__slim_slim_module_js__["a" /* default */](this.$refs.containerImg, this.slimOptions);
      }
    },
    delete_video: function delete_video(videoId) {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'delete_video', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        console.log('res', res);
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          _this5.videos = [];
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    delete_image: function delete_image(imageId) {
      var _this6 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'delete_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    SaveImage: function SaveImage(imageId, position) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'image_position', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId, position: position };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 989 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilsideinformation',
  props: ['items'],
  data: function data() {
    return {
      form: {
        contactPerson: '',
        companyName: '',
        address: '',
        telephone: '',
        email: '',
        cvr: '',
        klippekort: '',
        mobilnummer: '',
        name: '',
        hjemmeside: ''
      },
      showMobile: false
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    onSubmitInformation: function onSubmitInformation(evt) {
      evt.preventDefault();
      this.$emit('clicked');
    },
    onReset: function onReset(evt) {
      evt.preventDefault();

      this.form.contactPerson = '';
      this.form.companyName = '';
      this.form.address = '';
      this.form.email = '';
      this.form.telephone = '';
      this.form.cvr = '';
      this.form.klippekort = '';
      this.form.pbs = '';
      this.form.contractend = '';
      this.form.hjemmeside = '';
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.showMobile)?_c('form',{staticClass:"collectReviewForm",on:{"submit":_vm.onSubmitInformation,"reset":_vm.onReset}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"kontaktGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Kontaktperson\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"contactPerson","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Kontaktperson),callback:function ($$v) {_vm.$set(_vm.items, "Kontaktperson", $$v)},expression:"items.Kontaktperson"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 col-6"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Firmanavn\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 h5 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"companyName","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Firma),callback:function ($$v) {_vm.$set(_vm.items, "Firma", $$v)},expression:"items.Firma"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"addressGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Adresse\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 h5 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"address","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Adresse),callback:function ($$v) {_vm.$set(_vm.items, "Adresse", $$v)},expression:"items.Adresse"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"postGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Postnr\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"Postnr","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Postnr),callback:function ($$v) {_vm.$set(_vm.items, "Postnr", $$v)},expression:"items.Postnr"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"telGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Telefon\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"telephone","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Telefon),callback:function ($$v) {_vm.$set(_vm.items, "Telefon", $$v)},expression:"items.Telefon"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"mobilnummerGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Mobilnummer\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"mobilnummer","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Mobil),callback:function ($$v) {_vm.$set(_vm.items, "Mobil", $$v)},expression:"items.Mobil"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"emailGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Email\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"email","type":"text","required":"","placeholder":"","disabled":""},model:{value:(_vm.items.Email),callback:function ($$v) {_vm.$set(_vm.items, "Email", $$v)},expression:"items.Email"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"cvrGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        CVR\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"cvr","type":"text","required":"","placeholder":"","disabled":""},model:{value:(_vm.items.Cvrnr),callback:function ($$v) {_vm.$set(_vm.items, "Cvrnr", $$v)},expression:"items.Cvrnr"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"antalGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Antal medarbejdere\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"antal","type":"text","placeholder":""},model:{value:(_vm.items.AntalAnsatte),callback:function ($$v) {_vm.$set(_vm.items, "AntalAnsatte", $$v)},expression:"items.AntalAnsatte"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"yearGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Etableringsår\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"year","type":"text","placeholder":""},model:{value:(_vm.items.Etableringsaar),callback:function ($$v) {_vm.$set(_vm.items, "Etableringsaar", $$v)},expression:"items.Etableringsaar"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"clearfix mb2 col-6",attrs:{"id":"hjemmesideGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n        Hjemmeside\n      ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"hejmmeside","type":"text","placeholder":""},model:{value:(_vm.items.Web),callback:function ($$v) {_vm.$set(_vm.items, "Web", $$v)},expression:"items.Web"}})],1)]),_vm._v(" "),_vm._m(0)]):_c('form',{staticClass:"collectReviewForm",on:{"submit":_vm.onSubmitInformation,"reset":_vm.onReset}},[_c('div',{staticClass:"clearfix mb2",attrs:{"id":"kontaktGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      Kontaktperson\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"contactPerson","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Kontaktperson),callback:function ($$v) {_vm.$set(_vm.items, "Kontaktperson", $$v)},expression:"items.Kontaktperson"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      Firmanavn\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 h5 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"companyName","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Firma),callback:function ($$v) {_vm.$set(_vm.items, "Firma", $$v)},expression:"items.Firma"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 ",attrs:{"id":"addressGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n    Adresse\n  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 h5 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"address","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Adresse),callback:function ($$v) {_vm.$set(_vm.items, "Adresse", $$v)},expression:"items.Adresse"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"postGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n    Postnr\n  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"Postnr","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Postnr),callback:function ($$v) {_vm.$set(_vm.items, "Postnr", $$v)},expression:"items.Postnr"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"telGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n    Telefon\n  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"telephone","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Telefon),callback:function ($$v) {_vm.$set(_vm.items, "Telefon", $$v)},expression:"items.Telefon"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"mobilnummerGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n    Mobilnummer\n  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"mobilnummer","type":"text","required":"","placeholder":""},model:{value:(_vm.items.Mobil),callback:function ($$v) {_vm.$set(_vm.items, "Mobil", $$v)},expression:"items.Mobil"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"emailGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      Email\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"email","type":"text","required":"","placeholder":"","disabled":""},model:{value:(_vm.items.Email),callback:function ($$v) {_vm.$set(_vm.items, "Email", $$v)},expression:"items.Email"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"cvrGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      CVR\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"cvr","type":"text","required":"","placeholder":"","disabled":""},model:{value:(_vm.items.Cvrnr),callback:function ($$v) {_vm.$set(_vm.items, "Cvrnr", $$v)},expression:"items.Cvrnr"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"antalGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      Antal medarbejdere\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"antal","type":"text","placeholder":""},model:{value:(_vm.items.AntalAnsatte),callback:function ($$v) {_vm.$set(_vm.items, "AntalAnsatte", $$v)},expression:"items.AntalAnsatte"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"yearGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n      Etableringsår\n    ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"year","type":"text","placeholder":""},model:{value:(_vm.items.Etableringsaar),callback:function ($$v) {_vm.$set(_vm.items, "Etableringsaar", $$v)},expression:"items.Etableringsaar"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"hjemmesideGroup"}},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb1"},[_vm._v("\n    Hjemmeside\n  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background p2 border-none not-rounded darkblue gibson",staticStyle:{"font-size":"16px"},attrs:{"id":"hejmmeside","type":"text","placeholder":""},model:{value:(_vm.items.Web),callback:function ($$v) {_vm.$set(_vm.items, "Web", $$v)},expression:"items.Web"}})],1),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mb2"},[_c('button',{staticClass:"action-button p2 col-12 border-none not-rounded gibson semi-bold",attrs:{"type":"submit"}},[_c('span',{staticClass:"h5"},[_vm._v("\n        Gem ændringer\n      ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mb2"},[_c('button',{staticClass:"action-button p2 col-12 border-none not-rounded gibson semi-bold",attrs:{"type":"submit"}},[_c('span',{staticClass:"h5"},[_vm._v("\n        Gem ændringer\n      ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 992 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ratingWidget',
  components: {
    VueClipboard: __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  props: ['ratingwidget', 'items'],
  data: function data() {
    return {
      myHTML: '',
      url: '',
      haaId: '1',
      show: false,
      label: 'Loading...',
      overlay: 1
    };
  },
  created: function created() {
    this.Reload();
  },

  watch: {
    items: function items(newVal, oldVal) {
      this.url = 'https://www.kundematch.dk/newpartner/widgetr.php?id=' + this.haaId + '&company=' + this.items.urltag;
      this.show = true;
    }
  },
  methods: {
    Reload: function Reload() {
      this.haaId = localStorage.getItem('haaid');
    },
    copy_clipboard: function copy_clipboard() {
      this.$copyText(this.ratingwidget).then(function (e) {
        console.log(this.$el);
      }, function (e) {
        alert('Kan ikke kopiere');
      });
    },
    success: function success() {
      var obj = {
        title: 'Koden er nu kopieret og du kan sætte den ind i en mail til din webmaster',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onError: function onError() {
      alert('Kan ikke kopieres');
    }
  }
});

/***/ }),
/* 994 */,
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"border muted-border shadow col-12 flex justify-center items-center pb1"},[_c('b-embed',{staticClass:"col-12",attrs:{"type":"iframe","src":_vm.url,"aspect":"21by9","height":"120px"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"m0",attrs:{"id":"hjemmesideGroup"}},[_c('b-form-textarea',{staticClass:"regular gibson my2",staticStyle:{"font-size":"11.5px"},attrs:{"id":"textarea2","rows":6,"no-resize":true},model:{value:(_vm.ratingwidget),callback:function ($$v) {_vm.ratingwidget=$$v},expression:"ratingwidget"}})],1),_vm._v(" "),(_vm.show)?_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.ratingwidget),expression:"ratingwidget",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.success),expression:"success",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"col-12 outlined-action-button p2 mx-auto gibson flex justify-center items-center not-rounded"},[_c('span',{staticClass:"relative",staticStyle:{"top":"2px"}},[_c('svg',{staticClass:"jam jam-files",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3zm0-2V7a2 2 0 0 1 2-2h2V2H2v11h4zm8.172-6H8v11h8V8.828L14.172 7z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold ml1 mb0"},[_vm._v("Kopiér og send til webmaster")])]):_vm._e()],1)])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'commentWidget',
  components: {
    VueClipboard: __WEBPACK_IMPORTED_MODULE_0_vue_clipboard2___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  props: ['commentwidget', 'items'],
  data: function data() {
    return {
      myHTML: '',
      show: false,
      haaId: '1',
      label: 'Loading...',
      overlay: 1
    };
  },
  created: function created() {
    this.Reload();
  },

  watch: {
    items: function items(newVal, oldVal) {
      this.url = 'https://www.kundematch.dk/newpartner/widgetc.php?id=' + this.haaId + '&company=' + this.items.urltag;
      this.show = true;
    }
  },
  methods: {
    Reload: function Reload() {
      this.haaId = localStorage.getItem('haaid');
    },
    copy_clipboard: function copy_clipboard() {
      this.$copyText(this.commentWidget).then(function (e) {
        console.log(this.$el);
      }, function (e) {
        alert('Kan ikke kopiere');
      });
    },
    success: function success() {
      var obj = {
        title: 'Koden er nu kopieret og du kan sætte den ind i en mail til din webmaster',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onError: function onError() {
      alert('Kan ikke kopieres');
    }
  }
});

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('form',[_c('div',{staticClass:"clearfix px0"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"border muted-border shadow"},[_c('b-embed',{staticClass:"col-12",attrs:{"type":"iframe","scrolling":"no","src":_vm.url,"aspect":"21by9","height":"120px"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"my2",attrs:{"id":""}},[_c('b-form-textarea',{staticClass:"regular gibson",staticStyle:{"font-size":"12px"},attrs:{"id":"textarea2","rows":7,"no-resize":true},model:{value:(_vm.commentwidget),callback:function ($$v) {_vm.commentwidget=$$v},expression:"commentwidget"}})],1),_vm._v(" "),(_vm.show)?_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.commentwidget),expression:"commentwidget",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.success),expression:"success",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onError),expression:"onError",arg:"error"}],staticClass:"col-12 outlined-action-button p2 mx-auto gibson flex justify-center items-center"},[_c('span',{staticClass:"relative",staticStyle:{"top":"2px"}},[_c('svg',{staticClass:"jam jam-files",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3zm0-2V7a2 2 0 0 1 2-2h2V2H2v11h4zm8.172-6H8v11h8V8.828L14.172 7z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold ml1 mb0"},[_vm._v("Kopiér og send til webmaster")])]):_vm._e()],1)])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileimages_vue__ = __webpack_require__(1000);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0e325b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_profileimages_vue__ = __webpack_require__(1001);
function injectStyle (ssrContext) {
  __webpack_require__(999)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profileimages_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2c0e325b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_profileimages_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 999 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileimages',
  props: ['images'],
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1900) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        showMobile: false,
        maxFilesize: 17,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: 'image/*',
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    };
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  methods: {
    'showSuccess': function showSuccess(file) {
      this.$emit('Reload');
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    },
    change_position: function change_position(imageId, position) {
      this.$emit('moveImage', imageId, position);
    },
    delete_image: function delete_image(imageId) {
      this.$emit('delete_image', imageId);
    },
    edit_image: function edit_image(FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImages');
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"col-12 px0 flex flex-wrap imageArray"},[_vm._l((_vm.images),function(image){return (!_vm.showMobile && !_vm.showXXL)?_c('div',{key:image.ImageId,staticClass:"col-6 mb3 px1"},[_c('div',{staticClass:"col-12 px0",attrs:{"data-download":"true"}},[(image.FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":image.FileLocation.replace('/photos/', ''),"alt":"","fluid-grow":""}}):_c('b-img',{attrs:{"src":image.FileLocation,"alt":"","fluid-grow":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 my1 flex justify-between items-center"},[_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'first')}}},[_c('svg',{staticClass:"jam jam-chevron-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'left')}}},[_c('svg',{staticClass:"jam jam-chevrons-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4.5 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button"},[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'right')}}},[_c('svg',{staticClass:"jam jam-chevrons-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'last')}}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.edit_image(image.FileLocation,image.ImageId)}}},[_c('svg',{staticClass:"jam jam-pencil-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2.5 -2.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.delete_image(image.ImageId)}}},[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])])]):_vm._e()}),_vm._v(" "),_vm._l((_vm.images),function(image){return (_vm.showMobile)?_c('div',{key:image.ImageId,staticClass:"col-12 mb3 px0"},[_c('div',{staticClass:"col-12 px0",attrs:{"data-download":"true"}},[(image.FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":image.FileLocation.replace('/photos/', ''),"alt":"","fluid-grow":""}}):_c('b-img',{attrs:{"src":image.FileLocation,"alt":"","fluid-grow":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 my1 flex justify-between items-center"},[_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'first')}}},[_c('svg',{staticClass:"jam jam-chevron-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'left')}}},[_c('svg',{staticClass:"jam jam-chevrons-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4.5 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button"},[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'right')}}},[_c('svg',{staticClass:"jam jam-chevrons-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'last')}}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.edit_image(image.FileLocation,image.ImageId)}}},[_c('svg',{staticClass:"jam jam-pencil-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.delete_image(image.ImageId)}}},[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])])]):_vm._e()}),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix py2 px0 row"},_vm._l((_vm.images),function(image){return _c('div',{key:image.ImageId,staticClass:"col-3 mb3 px1"},[_c('div',{staticClass:"col-12 px0",attrs:{"data-download":"true"}},[(image.FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":image.FileLocation.replace('/photos/', ''),"alt":"","fluid-grow":""}}):_c('b-img',{attrs:{"src":image.FileLocation,"alt":"","fluid-grow":""}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 my1 flex justify-between items-center"},[_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'first')}}},[_c('svg',{staticClass:"jam jam-chevron-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M2.757 7l4.95 4.95a1 1 0 1 1-1.414 1.414L.636 7.707a1 1 0 0 1 0-1.414L6.293.636A1 1 0 0 1 7.707 2.05L2.757 7z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'left')}}},[_c('svg',{staticClass:"jam jam-chevrons-left",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4.5 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M8.828 7.071l4.95 4.95a1 1 0 1 1-1.414 1.414L6.707 7.778a1 1 0 0 1 0-1.414L12.364.707a1 1 0 0 1 1.414 1.414l-4.95 4.95zm-6 0l4.95 4.95a1 1 0 1 1-1.414 1.414L.707 7.778a1 1 0 0 1 0-1.414L6.364.707a1 1 0 1 1 1.414 1.414l-4.95 4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button"},[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'right')}}},[_c('svg',{staticClass:"jam jam-chevrons-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11.314 7.071l-4.95-4.95A1 1 0 0 1 7.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95zm-6 0l-4.95-4.95A1 1 0 1 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.change_position(image.ImageId,'last')}}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.edit_image(image.FileLocation,image.ImageId)}}},[_c('svg',{staticClass:"jam jam-pencil-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2.5 -2.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M16.318 6.11l-3.536-3.535 1.415-1.414c.63-.63 2.073-.755 2.828 0l.707.707c.755.755.631 2.198 0 2.829L16.318 6.11zm-1.414 1.415l-9.9 9.9-4.596 1.06 1.06-4.596 9.9-9.9 3.536 3.536z"}})])]),_vm._v(" "),_c('button',{staticClass:"border-none ghost-dark-button",on:{"click":function($event){return _vm.delete_image(image.ImageId)}}},[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])])])}),0):_vm._e(),_vm._v(" "),[_c('div',{staticClass:"clearfix"}),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix col-7 px0"},[(_vm.images[0])?_c('div',{key:_vm.images.ImageId,staticClass:"col col-6 px0"},[(_vm.images[0].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[0].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[0].FileLocation,"fluid-grow":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col col-6 px0"},[_c('div',{staticClass:"clearfix"},[(_vm.images[1])?_c('div',{key:_vm.images.ImageId,staticClass:"col col-6 px0"},[(_vm.images[1].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[1].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[1].FileLocation,"fluid-grow":""}},[_vm._v(">")])],1):_vm._e(),_vm._v(" "),(_vm.images[2])?_c('div',{key:_vm.images.ImageId,staticClass:"col col-6 px0"},[(_vm.images[2].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[2].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[2].FileLocation,"fluid-grow":""}},[_vm._v(">")])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.images[3])?_c('div',{key:_vm.images.ImageId,staticClass:"col col-6 px0"},[(_vm.images[3].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[3].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[3].FileLocation,"fluid-grow":""}},[_vm._v(">")])],1):_vm._e(),_vm._v(" "),(_vm.images[4])?_c('div',{key:_vm.images.ImageId,staticClass:"col col-6 px0"},[(_vm.images[4].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[4].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[4].FileLocation,"fluid-grow":""}})],1):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-column md-hide lg-hide"},[_c('div',{staticClass:"clearfix"},[(_vm.images[0])?_c('div',{staticClass:"col-12 px0"},[(_vm.images[0].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[0].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[0].FileLocation,"fluid-grow":""}})],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.images[2])?_c('div',{staticClass:"col col-6 px0"},[(_vm.images[1].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[1].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[1].FileLocation,"fluid-grow":""}})],1):_vm._e(),_vm._v(" "),(_vm.images[3])?_c('div',{staticClass:"col col-6 px0"},[(_vm.images[2].FileLocation.includes('https://imagedelivery.net'))?_c('b-img',{attrs:{"src":_vm.images[2].FileLocation.replace('/photos/', ''),"fluid-grow":""}}):_c('b-img',{attrs:{"src":_vm.images[2].FileLocation,"fluid-grow":""}})],1):_vm._e()])])]],2),_vm._v(" "),[(_vm.showXXL)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-7 py2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 py2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.showXXL)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-8 py2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)]):_vm._e()],_vm._v(" "),_c('div',{staticClass:"py2"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profilevideo_vue__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e957a30_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_profilevideo_vue__ = __webpack_require__(1004);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_profilevideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e957a30_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_profilevideo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profilevideo',
  props: ['videos'],
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 101,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: '.mp4,.avi,.mpeg4,.flv,.3gpp',
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="40" height="40" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:18px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:15px;">Du kan kun uploade filer som er mp4, avi, mpeg4, flv, 3gpp, max. 100 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    };
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  methods: {
    'showSuccess': function showSuccess(file) {
      this.$emit('Reload');
    },
    change_position: function change_position(imageId, position) {
      this.$emit('moveImage', imageId, position);
    },
    delete_video: function delete_video(videoId) {
      this.$emit('delete_video', videoId);
    },
    edit_image: function edit_image(FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadVideo');
    }
  }
});

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix imageArray"},[_vm._l((_vm.videos),function(video){return [_c('b-list-group-item',{key:video.id,staticClass:"no-hover border-none videoListItem mb3",attrs:{"href":video.VideoUrl}},[_c('button',{staticClass:"col-12 flex justify-between items-start gibson h6 line-height-2 border-none mx-auto white-background",on:{"click":function($event){return _vm.delete_video(video.id)}}},[_c('span',{staticClass:"left-align pr3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Path")]),_vm._v(" "),_c('span',{staticClass:"flex-auto left-align"},[_vm._v(_vm._s(video.VideoUrl))])]),_vm._v(" "),_c('span',{staticClass:"px2 red"},[_c('i',{staticClass:"el-icon-delete"})])])])]}),_vm._v(" "),_c('div',{staticClass:"col-12 videoDropZone"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'imagefolder',
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      dropzoneOptions: {
        url: 'https://api.haandvaerker.dk/Supplier/UploadProfileImages',
        thumbnailWidth: 150,
        maxFilesize: 0.5,
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        dictDefaultMessage: 'Træk filerne hertil eller klik for at vælge filer'
      }
    };
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  methods: {
    'showSuccess': function showSuccess(file) {
      console.log('A file was successfully uploaded');
    }
  }
});

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-0 pr-1 pb-4 pl-1 h6 open-sans line-height-golden"},[_vm._v("\n    Her har du mulighed for at vise kunderne de opgaver, du har løst. Du står stærkt, når du viser kunderne, hvad du kan.\n    "),_c('br'),_c('br'),_vm._v("Få hjælp til gode billeder af dine projekter – kontakt os for at høre mere.\n  ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1007 */,
/* 1008 */,
/* 1009 */,
/* 1010 */,
/* 1011 */,
/* 1012 */,
/* 1013 */,
/* 1014 */,
/* 1015 */,
/* 1016 */,
/* 1017 */,
/* 1018 */,
/* 1019 */,
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_editor_vue__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_423d9494_hasScoped_false_vue_loader_lib_selector_type_template_index_0_editor_vue__ = __webpack_require__(1026);
function injectStyle (ssrContext) {
  __webpack_require__(1021)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_editor_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_423d9494_hasScoped_false_vue_loader_lib_selector_type_template_index_0_editor_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1021 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


__webpack_require__(1023);
__webpack_require__(1024);
__webpack_require__(1025);
if (!window.Quill) {
  window.Quill = __webpack_require__(596);
}
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'quill-editor',
  data: function data() {
    return {
      _content: '',
      defaultModules: {
        toolbar: [['bold', 'italic', 'underline', 'strike'], ['blockquote', 'code-block'], [{ 'header': 1 }, { 'header': 2 }], [{ 'list': 'ordered' }, { 'list': 'bullet' }], [{ 'script': 'sub' }, { 'script': 'super' }], [{ 'indent': '-1' }, { 'indent': '+1' }], [{ 'direction': 'rtl' }], [{ 'size': ['small', false, 'large', 'huge'] }], [{ 'header': [1, 2, 3, 4, 5, 6, false] }], [{ 'color': [] }, { 'background': [] }], [{ 'font': [] }], [{ 'align': [] }], ['clean'], ['link', 'image', 'video']]
      }
    };
  },
  props: {
    content: String,
    value: String,
    disabled: Boolean,
    options: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    }
  },
  mounted: function mounted() {
    this.initialize();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
  },
  methods: {
    initialize: function initialize() {
      if (this.$el) {
        var self = this;
        self.options.theme = self.options.theme || 'snow';
        self.options.boundary = self.options.boundary || document.body;
        self.options.modules = self.options.modules || self.defaultModules;
        self.options.modules.toolbar = self.options.modules.toolbar !== undefined ? self.options.modules.toolbar : self.defaultModules.toolbar;
        self.options.placeholder = self.options.placeholder || 'Insert text here ...';
        self.options.readOnly = self.options.readOnly !== undefined ? self.options.readOnly : false;
        self.quill = new Quill(self.$refs.editor, self.options);

        if (self.value || self.content) {
          self.quill.pasteHTML(self.value || self.content);
        }

        self.quill.on('selection-change', function (range) {
          if (!range) {
            self.$emit('blur', self.quill);
          } else {
            self.$emit('focus', self.quill);
          }
        });

        self.quill.on('text-change', function (delta, oldDelta, source) {
          var html = self.$refs.editor.children[0].innerHTML;
          var text = self.quill.getText();
          if (html === '<p><br></p>') html = '';
          self._content = html;
          self.$emit('input', self._content);
          self.$emit('change', {
            editor: self.quill,
            html: html,
            text: text
          });
        });

        if (this.disabled) {
          this.quill.enable(false);
        }

        self.$emit('ready', self.quill);
      }
    }
  },
  watch: {
    content: function content(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    value: function value(newVal, oldVal) {
      if (this.quill) {
        if (!!newVal && newVal !== this._content) {
          this._content = newVal;
          this.quill.pasteHTML(newVal);
        } else if (!newVal) {
          this.quill.setText('');
        }
      }
    },
    disabled: function disabled(newVal, oldVal) {
      if (this.quill) {
        this.quill.enable(!newVal);
      }
    }
  }
});

/***/ }),
/* 1023 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1025 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quill-editor"},[_vm._t("toolbar"),_vm._v(" "),_c('div',{ref:"editor"})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[[(_vm.showMobile && _vm.haaID !== '0')?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 pb3 mb2 shadow"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-8 lg-col-10 p2"},[_c('p',{staticClass:"h5 semi-bold darkblue line-height-2 mt3 mb2 gibson"},[_vm._v("\n          Redigér i din profil-side på Håndværker.dk\n        ")]),_vm._v(" "),_c('button',{staticClass:"xs-col-12 sm-col-12 md-col-7 lg-col-7 standard-button p2 flex justify-center items-center my3 border-none not-rounded",attrs:{"target":"_blank"},on:{"click":_vm.openUrl}},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-arrow-square-up-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"}}),_c('path',{attrs:{"d":"M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z"}})])]),_vm._v(" "),_c('span',{staticClass:"h4 gibson regular pl1 mb0"},[_vm._v("Se min profilside")])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Din profilside på Håndværker.dk er dit professionelle udstillingsvindue, som skaffer flere kunder. Profilsiden giver potentielle kunder sikkerhed for, at du og kunden er det perfekte match.\n        ")]),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Ville du vælge dig selv på baggrund af det, der vises på din profil i dag? Kan du præsenteres endnu bedre? Har du nye projekter du vil vise? Vi kan hjælpe dig i dag!\n        ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.\n        ")])],1),_vm._v(" "),(_vm.haaId !== '0')?_c('el-collapse',{staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Informationer")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("Disse er de informationer, som vil blive vist på din\n                  profilside på Håndværker.dk.")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('profilsideinformation',{attrs:{"items":_vm.items},on:{"clicked":_vm.SaveProfile}})],2)],1):_vm._e(),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.profiletext",modifiers:{"profiletext":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profiltekst")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                  Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på\n                  Google.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:" flex col-12 justify-end p0 semi-bold "},[_c('p',{staticClass:"darkblue m0"},[_vm._v(_vm._s(_vm.eliglbletextlimit)+" Tekst")])]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorConfig},model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson",on:{"click":function($event){return _vm.SaveDescription()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem ændringer")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])],2)],1),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profilbilleder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                  Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver\n                  kunderne et\n                  godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre\n                  mere.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('profileimages',{attrs:{"images":_vm.images},on:{"moveImage":_vm.SaveImage,"Reload":_vm.Reload,"delete_image":_vm.delete_image,"edit_image":_vm.edit_image}})],2)],1),_vm._v(" "),_c('el-collapse',{staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profilvideo")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                  Upload en video til din profil. Video er det bedste medie til at give et godt indtryk.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{ref:"picDisplay",attrs:{"id":"profiletext"},on:{"click":function($event){return _vm.getdataigibility()}}},[_c('profilevideo',{attrs:{"videos":_vm.videos},on:{"Reload":_vm.Reload,"delete_video":_vm.delete_video}})],1)],2)],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile && _vm.haaId !== '0')?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix p2 pb3 mb2 ml4"},[_c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-6 flex justify-end"},[_c('button',{staticClass:"standard-button p2 flex justify-center items-center my3 border-none not-rounded",attrs:{"target":"_blank"},on:{"click":_vm.openUrl}},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-arrow-square-up-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"}}),_c('path',{attrs:{"d":"M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 gibson regular pl1 mb0"},[_vm._v("Se min profilside")])])])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Din profilside på Håndværker.dk er dit professionelle udstillingsvindue, som skaffer flere kunder. Profilsiden giver potentielle kunder sikkerhed for, at du og kunden er det perfekte match.\n        ")]),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Ville du vælge dig selv på baggrund af det, der vises på din profil i dag? Kan du præsenteres endnu bedre? Har du nye projekter du vil vise? Vi kan hjælpe dig i dag! Opdaterer du din profil eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i\n          løbet af 24 timer.\n        ")])],1),_vm._v(" "),(_vm.haaId !== '0')?_c('el-collapse',{staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Informationer")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("Disse er de informationer, som vil blive vist på din profilside på Håndværker.dk.")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('profilsideinformation',{attrs:{"items":_vm.items},on:{"clicked":_vm.SaveProfile}})],2)],1):_vm._e(),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.profiletext",modifiers:{"profiletext":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profiltekst")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:" flex col-12 justify-end p0 semi-bold "},[_c('p',{staticClass:"darkblue m0"},[_vm._v(_vm._s(_vm.eliglbletextlimit)+" Tekst")])]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorConfig},model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson",on:{"click":function($event){return _vm.SaveDescription()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem ændringer")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])],2)],1),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profilbilleder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                  Det første billede i listen vil blive vist for kunden i søgeresultatet. Vælg derfor et billede som giver kunderne et\n                  godt førstehåndsindtryk. Få hjælp til at få gode billeder af dig og dine medarbejdere – kontakt os for at høre mere.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('profileimages',{attrs:{"images":_vm.images},on:{"moveImage":_vm.SaveImage,"Reload":_vm.Reload,"delete_image":_vm.delete_image,"edit_image":_vm.edit_image}})],2)],1),_vm._v(" "),_c('el-collapse',{staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profilvideo")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                Upload en video til din profil. Video er det bedste medie til at give et godt indtryk.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{on:{"click":function($event){return _vm.getdataigibility()}}},[_c('profilevideo',{attrs:{"videos":_vm.videos},on:{"Reload":_vm.Reload,"delete_video":_vm.delete_video}})],1)],2)],1)],1)]):_vm._e(),_vm._v(" "),_vm._m(1)]],2),_vm._v(" "),_c('b-modal',{ref:"modal",staticClass:"p-2 pb-4",attrs:{"id":"modalPrevent","hide-footer":"","title":"Opdater billede"},model:{value:(_vm.modalShowBillede),callback:function ($$v) {_vm.modalShowBillede=$$v},expression:"modalShowBillede"}}),_vm._v(" "),_c('div',{ref:"containerImg"}),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 mt3 mb2 gibson"},[_vm._v("\n              Redigér i din profil-side på Håndværker.dk\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix relative gibson px2 mb2 hide"},[_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2"},[_c('div',[_c('p',{staticClass:"h4 gibson regular white line-height-golden"},[_vm._v("Som basismedlem har du desværre ikke adgang til denne del af partner-login."),_c('br'),_vm._v("\n          Opgrader din løsning, hvis du vil have adgang.\n        ")]),_vm._v(" "),_c('button',{staticClass:"p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1"},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_description_vue__ = __webpack_require__(1030);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec33466_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_description_vue__ = __webpack_require__(1031);
function injectStyle (ssrContext) {
  __webpack_require__(1029)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_confirm_description_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ec33466_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_confirm_description_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1029 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Profilsideinformation__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ratingWidget__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commentWidget__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__uploads_imagefolder__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__slim_slim_module_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_quill_editor__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProfilSide',
  components: {
    ratingWidget: __WEBPACK_IMPORTED_MODULE_1__ratingWidget__["a" /* default */],
    commentWidget: __WEBPACK_IMPORTED_MODULE_2__commentWidget__["a" /* default */],
    VueQuillEditor: __WEBPACK_IMPORTED_MODULE_7_vue_quill_editor___default.a,
    Slim: __WEBPACK_IMPORTED_MODULE_6__slim_slim_module_js__["a" /* default */],
    profilsideinformation: __WEBPACK_IMPORTED_MODULE_0__Profilsideinformation__["a" /* default */],
    imagefolder: __WEBPACK_IMPORTED_MODULE_3__uploads_imagefolder__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a
  },
  data: function data() {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      FileLocation: '',
      instance: null,
      show: false,
      modalShowBillede: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      options: {
        hideModules: { 'link': true, 'code': true, 'justifyRight': true, 'justifyCenter': true, 'table': true, 'italic': true }
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {},
      content: '\n        <h1 class="ql-align-center"><span class="ql-font-serif" style="background-color: rgb(240, 102, 102); color: rgb(255, 255, 255);"> I am snow example! </span></h1><p><br></p><p><span class="ql-font-serif">W Can a man still be brave if he\'s afraid? That is the only time a man can be brave. </span></p><p><br></p><p><strong class="ql-font-serif ql-size-large">Courage and folly is </strong><strong class="ql-font-serif ql-size-large" style="color: rgb(230, 0, 0);">always</strong><strong class="ql-font-serif ql-size-large"> just a fine line.</strong></p><p><br></p><p><u class="ql-font-serif">There is only one God, and his name is Death. And there is only one thing we say to Death: "Not today."</u></p><p><br></p><p><em class="ql-font-serif">Fear cuts deeper than swords.</em></p><p><br></p><pre class="ql-syntax" spellcheck="false"><span class="hljs-keyword">const</span> a = <span class="hljs-number">10</span>;\n        <span class="hljs-keyword">const</span> editorOption = { <span class="hljs-attr">highlight</span>: <span class="hljs-function"><span class="hljs-params">text</span> =&gt;</span> hljs.highlightAuto(text).value };</pre><p><br></p><p><span class="ql-font-serif">Every flight begins with a fall.</span></p><p><br></p><p><a href="https://surmon.me/" rel="noopener noreferrer" target="_blank" class="ql-font-serif ql-size-small" style="color: rgb(230, 0, 0);"><u>A ruler who hides behind paid executioners soon forgets what death is. </u></a></p><p><br></p><iframe class="ql-video ql-align-center" frameborder="0" allowfullscreen="true" src="https://www.youtube.com/embed/QHH3iSeDBLo?showinfo=0" height="238" width="560"></iframe><p><br></p><p><span class="ql-font-serif">Hear my words, and bear witness to my vow. Night gathers, and now my watch begins. It shall not end until my death. I shall take no wife, hold no lands, father no children. I shall wear no crowns and win no glory. I shall live and die at my post. I am the sword in the darkness. I am the watcher on the walls. I am the fire that burns against the cold, the light that brings the dawn, the horn that wakes the sleepers, the shield that guards the realms of men. I pledge my life and honor to the Night\xE2\x80\x99s Watch, for this night and all the nights to come.</span></p><p><br></p><p><span class="ql-font-serif">We are born to suffer, to suffer can make us strong.</span></p><p><br></p><p><span class="ql-font-serif">The things we love destroy us every time.</span></p>\n      ',
      slimOptions: {
        initialImage: this.FileLocation,
        service: this.slimService,
        didInit: this.slimInit,
        didConfirm: this.slimConfirm
      },
      haaId: '',
      imageId: '',
      items: [],
      videos: [],
      images: [],
      eligible: '',
      eliglbletextlimit: 'Ubegrænset',
      activeName: '2',
      salesPersonbitrix: '',
      spaId: '',
      profileText: '',
      spainfo: {}
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('AccessVideoProProfile');
    this.tokenfordecode = this.$route.query.token;
    this.decode(this.tokenfordecode);
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    getdataigibility: function getdataigibility() {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'AccessVideoProProfile');
      } else {
        this.$refs.picDisplay.show = true;
      }
    },
    slimInit: function slimInit(data, slim) {
      console.log(slim);
      console.log(data);
      this.instance.edit();
      this.show = false;
    },
    openUrl: function openUrl() {
      var win = window.open(this.items.url, '_blank');
      win.focus();
    },
    slimConfirm: function slimConfirm(data, slim) {
      var _this = this;

      console.log();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'edit_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: this.imageId, image: this.instance.dataBase64.output.image };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    slimService: function slimService(formdata, progress, success, failure, slim) {
      console.log(slim);

      console.log(formdata);
      console.log(progress, success, failure);
    },
    Reload: function Reload() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.items = res;
        _this2.myHTML = res.Description;
        _this2.images = res.resultImages;
        _this2.videos = res.resultVideos;
        _this2.ratingwidget = res.ratingwidget;
        _this2.commentwidget = res.commentwidget;
      }, function (response) {
        alert('error');
      });
    },
    SaveDescription: function SaveDescription() {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_haa_desc', salesPerson: this.salesPerson, levid: this.haaId, description: this.myHTML };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.saveConfirmpermissionautomated();
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Tak for opdateringen :)<br />' + 'Din tekst kommer online på din profil så snart den er godkendt.<br />' + '<br />' + 'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    saveConfirmpermissionautomated: function saveConfirmpermissionautomated() {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.post(this.$bitrixapi + 'external/AutomatedOnboardingApprovedByCraftman?LEV_ID=' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    SaveProfile: function SaveProfile() {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_haa_profile', salesPerson: this.salesPerson, levid: this.haaId, items: this.items };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    edit_image: function edit_image(FileLocation, imageId) {
      this.imageId = imageId;
      FileLocation = FileLocation.split('?');
      if (this.instance) {
        this.show = true;
        this.img.src = FileLocation[0];
        this.instance = new __WEBPACK_IMPORTED_MODULE_6__slim_slim_module_js__["a" /* default */](this.$refs.containerImg, this.slimOptions);
      } else {
        this.show = true;
        this.FileLocation = FileLocation[0];
        this.img = document.createElement('img');
        this.img.setAttribute('alt', '');
        this.img.src = FileLocation[0];
        this.$refs.containerImg.appendChild(this.img);
        this.instance = new __WEBPACK_IMPORTED_MODULE_6__slim_slim_module_js__["a" /* default */](this.$refs.containerImg, this.slimOptions);
      }
    },
    delete_video: function delete_video(videoId) {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'delete_video', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        console.log('res', res);
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          _this5.videos = [];
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    delete_image: function delete_image(imageId) {
      var _this6 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'delete_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    SaveImage: function SaveImage(imageId, position) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'image_position', salesPerson: this.salesPerson, levid: this.haaId, imageId: imageId, position: position };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    decodehtml: function decodehtml(text) {
      var textArea = document.createElement('textarea');
      textArea.innerHTML = text;
      return textArea.value;
    },
    savetextConfirm: function savetextConfirm() {
      var _this8 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        spaId: this.spaId,
        profileText: this.myHTML
      };
      this.$http.post(this.$bitrixapi + 'external/confirmProfileText', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: 'Tak for opdateringen :)<br />' + 'Din tekst kommer online på din profil så snart den er godkendt.<br />' + '<br />' + 'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this8.$refs.simplert.openSimplert(obj);
        setTimeout(function () {
          _this8.$router.push('/newsfeed');
        }, 2000);
      }, function (response) {
        _this8.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getsupplieriblockinfo: function getsupplieriblockinfo(id) {
      var _this9 = this;

      this.$http.get(this.$bitrixapi + 'external/getProfileText?spaId=' + id, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.profileText = res.data.PROFILE_TEXT;
          _this9.myHTML = _this9.profileText;
          _this9.spainfo = res.data;
        }
      }, function (response) {
        _this9.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    decode: function decode(token) {
      var _this10 = this;

      this.$http.get(this.$bitrixapi + 'helper/decode/' + token, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.spaId = res.data;
          if (_this10.spaId !== '') {
            _this10.getsupplieriblockinfo(_this10.spaId);
          }
        }
      }, function (response) {
        _this10.$message({
          type: 'error',
          message: response.body.message
        });
      });
    }
  }
});

/***/ }),
/* 1031 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[[(_vm.showMobile && _vm.haaID !== '0')?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 pb3 mb2 shadow"},[_vm._m(0),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.profiletext",modifiers:{"profiletext":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profiltekst")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                  Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på\n                  Google.\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:" flex col-12 justify-end p0 semi-bold "},[_c('p',{staticClass:"darkblue m0"},[_vm._v(_vm._s(_vm.eliglbletextlimit)+" Tekst")])]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorConfig},model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson",on:{"click":function($event){return _vm.savetextConfirm()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem ændringer")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])],2)],1)],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile && _vm.haaId !== '0')?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix p2 pb3 mb2 ml4"},[_vm._m(1),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.profiletext",modifiers:{"profiletext":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex flex-column items-start"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Profiltekst")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                Profilteksten er skrevet af vores tekstforfatter og er søgeordsoptimeret, så kunderne let finder dig på Google.\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:" flex col-12 justify-end p0 semi-bold "},[_c('p',{staticClass:"darkblue m0"},[_vm._v(_vm._s(_vm.eliglbletextlimit)+" Tekst")])]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorConfig},model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson",on:{"click":function($event){return _vm.savetextConfirm()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem ændringer")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])],2)],1)],1)]):_vm._e(),_vm._v(" "),_vm._m(2)]],2),_vm._v(" "),_c('div',{ref:"containerImg"}),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"xs-col-12 sm-col-12 md-col-8 lg-col-10 p2"},[_c('p',{staticClass:"h5 semi-bold darkblue line-height-2 mt3 mb2 gibson"},[_vm._v("\n          Redigér i din profil-side på Håndværker.dk\n        ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Bekræft venligst din profilbeskrivelse nedenfor.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-6"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 mt3 mb2 gibson"},[_vm._v("\n              Redigér i din profil-side på Håndværker.dk\n            ")])])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n          Bekræft venligst din profilbeskrivelse nedenfor.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix relative gibson px2 mb2 hide"},[_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2"},[_c('div',[_c('p',{staticClass:"h4 gibson regular white line-height-golden"},[_vm._v("Som basismedlem har du desværre ikke adgang til denne del af partner-login."),_c('br'),_vm._v("\n          Opgrader din løsning, hvis du vil have adgang.\n        ")]),_vm._v(" "),_c('button',{staticClass:"p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1"},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opgaveoversigt_vue__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5236a0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Opgaveoversigt_vue__ = __webpack_require__(1039);
function injectStyle (ssrContext) {
  __webpack_require__(1033)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Opgaveoversigt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e5236a0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Opgaveoversigt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1033 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1034 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Customers__ = __webpack_require__(1035);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haandvaerker__ = __webpack_require__(44);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_1__haandvaerker__["a" /* default */],
    customers: __WEBPACK_IMPORTED_MODULE_0__Customers__["a" /* default */]
  },
  data: function data() {
    return {
      customers: [],
      show: false
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = true;
    }
  }
});

/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba8c4828_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__ = __webpack_require__(1038);
function injectStyle (ssrContext) {
  __webpack_require__(1036)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ba8c4828_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Customers_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1037 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reviews',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  props: ['id'],
  data: function data() {
    return {
      rating: 0,
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1,
      customers: [],
      reviewShow: false,
      reviewslength: false,
      text: '',
      sampleCustomer: []
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false;
        return;
      }
      var data = { operation: 'customers', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.loading = false;
        _this.customers = res;
        _this.show = false;
        if (_this.customers.length === 0) {
          _this.reviewslength = true;
        }
      }, function (response) {
        alert('error');
      });
    },
    changeStatus: function changeStatus(value, item) {
      var _this2 = this;

      this.isLoadingReview = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'customer_status', salesPerson: this.salesPerson, levid: this.haaId, status: value, cid: item.Id };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.isLoadingReview = false;
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    review_service: function review_service(item) {
      var _this3 = this;

      this.isLoadingReview = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'customer_comment', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: item.SupplierRatingComment };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        _this3.isLoadingReview = false;
        if (res.success) {
          alert('Gennemført!');
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(customer) {
      this.reviewShow = !this.reviewShow;
      this.sampleCustomer = customer;
    },
    hideModal: function hideModal() {
      this.$refs.reviewModal.hide();
    },
    setRating: function setRating(rating) {
      this.sampleCustomer.rating = rating;
    }
  }
});

/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"clearfix"},[(_vm.loading)?_c('div',[_c('b-alert',{staticClass:"text-center",attrs:{"show":"","lg":"12","md":"12","sm":"12","variant":"light"}},[_c('div',{staticClass:"loader"})])],1):_vm._e(),_vm._v(" "),_vm._l((_vm.customers),function(customer){return _c('div',{key:customer.id,staticClass:"clearfix border muted-border p2 pb3 mb2 shadow"},[_c('div',{staticClass:"col-12 p2"},[_c('p',{staticClass:"h4 darkblue semi-bold line-height-3 gibson"},[_vm._v("\n          "+_vm._s(customer.Navn)+"\n        ")]),_vm._v(" "),_c('p',{staticClass:"h6 mediumgrey gibson line-height-1 mt2 mb1"},[_vm._v("\n          Status\n        ")]),_vm._v(" "),_c('b-form-select',{staticClass:" muted-background darkblue h6 gibson border-none not-rounded mb3",attrs:{"id":"statusSelect","options":customer.dataStatus},on:{"change":function($event){return _vm.changeStatus($event,customer)}},model:{value:(customer.Status),callback:function ($$v) {_vm.$set(customer, "Status", $$v)},expression:"customer.Status"}}),_vm._v(" "),_c('div',{staticClass:"my1"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('div',{staticClass:"my1"},[_c('p',{staticClass:"h6 mediumgrey gibson line-height-1 mb1"},[_vm._v("\n                Telefon\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson semi-bold"},[_vm._v("\n                "+_vm._s(customer.Telefon)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"my1"},[_c('p',{staticClass:"h6 mediumgrey gibson line-height-1 mb1"},[_vm._v("\n                Email\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson semi-bold"},[_vm._v("\n                "+_vm._s(customer.Email)+"\n              ")])])]),_vm._v(" "),_c('div',{staticClass:"my1"},[_c('p',{staticClass:"h6 mediumgrey gibson line-height-1 mb1"},[_vm._v("\n              Postnummer/By\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson semi-bold"},[_vm._v("\n              "+_vm._s(customer.ZipCode)+" "+_vm._s(customer.City)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('button',{staticClass:"col-12 not-rounded border-none gibson p2 primary-button h5",on:{"click":function($event){return _vm.showItemDetails(customer)}}},[_c('span',[_vm._v("Læs notat")])])])])],1)])}),_vm._v(" "),_c('b-modal',{ref:"reviewModal",staticClass:"p2 px3 pb4",attrs:{"centered":"","lazy":""},model:{value:(_vm.reviewShow),callback:function ($$v) {_vm.reviewShow=$$v},expression:"reviewShow"}},[_c('div',{staticClass:"p0",attrs:{"slot":"modal-header"},slot:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h5 semi-bold regular darkblue gibson line-height-3 mb2",staticStyle:{"font-weight":"600"}},[_vm._v("Notat:")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue gibson line-height-3 my2",domProps:{"innerHTML":_vm._s(_vm.sampleCustomer.Note)}})]),_vm._v(" "),_c('div',{staticClass:"px2 py3",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button p2 col-12 gibson border-none not-rounded",attrs:{"type":"reset"},on:{"click":_vm.hideModal}},[_c('span',[_vm._v("Luk")])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1039 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 pb3 mb2 shadow"},[_c('div',{staticClass:"col-12 p2"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson"},[_vm._v("\n            Opgaver fra Håndværker.dk\n          ")]),_vm._v(" "),[(!_vm.show)?_c('div',[_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nisi iure adipisci fugit aspernatur illo.")])]):_c('div',[_c('p',{staticClass:"h5 muted-background darkblue col-12 shadow mb2 line-height-3 gibson"},[_vm._v("\n                Ingen poster\n              ")])])]],2)]),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),(!_vm.show)?_c('customers'):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1040 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anbefalinger_vue__ = __webpack_require__(1041);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43509487_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Anbefalinger_vue__ = __webpack_require__(1047);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anbefalinger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43509487_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Anbefalinger_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Reviews__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CollectReview__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ratingWidget__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__commentWidget__ = __webpack_require__(213);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'anbefalinger',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_2__haandvaerker__["a" /* default */],
    ratingWidget: __WEBPACK_IMPORTED_MODULE_4__ratingWidget__["a" /* default */],
    commentWidget: __WEBPACK_IMPORTED_MODULE_5__commentWidget__["a" /* default */],
    reviews: __WEBPACK_IMPORTED_MODULE_0__Reviews__["a" /* default */],
    collectreviews: __WEBPACK_IMPORTED_MODULE_1__CollectReview__["a" /* default */],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      items: [],
      images: []
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.ratingwidget = res.ratingwidget;
        _this.commentwidget = res.commentwidget;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1043 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__ = __webpack_require__(48);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reviews',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__["ImageRating"],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__["a" /* default */]
  },
  props: ['id', 'ratingNocomment', 'premonth'],
  data: function data() {
    return {
      rating: 0,
      show: false,
      showMobile: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      sampleReviewcs: '',
      overlay: 1,
      reviews: [],
      reviewscat: [],
      reviewShow: false,
      reviewShowcs: false,
      reviewslength: false,
      text: '',
      industryValue: null,
      sampleReview: [],
      reportForm: '',
      report: null,
      reportOptions: [{
        value: null, text: 'Vælg indstilling', disabled: true
      }, {
        value: '1', text: 'Jeg udførte ikke arbejdet'
      }, {
        value: '2', text: 'Dårligt sprog'
      }, {
        value: '5', text: 'Forkert antal stjerner'
      }, {
        value: '3', text: 'Forkert kategori'
      }, {
        value: '4', text: 'Andre grunde'
      }],
      reportNote: '',
      fileUploadVisible: false,
      fileList: [],
      reviewsbitrix: [],
      haaId: '',
      salesPersonbitrix: '',
      salesPerson: '',
      totalitems: 0,
      lastpage: 1,
      perPage: 15,
      prisenJoboption: [],
      filterReviews: false,
      ratingVal: 'all',
      disable: false,
      endprisenpopup: false,
      openreportid: '',
      currentpage: 1
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.haaId = localStorage.getItem('haaid');

    this.getreviewsBitrix(1);
  },

  watch: {
    ratingVal: function ratingVal(newValue, oldValue) {
      this.getreviewsBitrix(1, '', newValue);
    },
    ratingNocomment: function ratingNocomment(newValue, oldValue) {
      console.log(newValue);
    }
  },
  computed: {
    getReviews: function getReviews() {
      var _this = this;

      var reviews = [];
      this.reviews.filter(function (item) {
        if (_this.ratingVal.length) {
          for (var id in _this.ratingVal) {
            var val = _this.ratingVal[id];
            if (Math.round(item.Rating) === parseInt(val)) {
              reviews.push(item);
            }
          }
        } else {
          reviews.push(item);
        }
      });
      var subreviews = [];
      reviews.filter(function (item) {
        if (_this.ratingNocomment) {
          if (item.SupplierCommentDate === null) {
            subreviews.push(item);
          }
        } else {
          subreviews.push(item);
        }
      });
      return subreviews.filter(function (e, i) {
        return subreviews.indexOf(e) >= i;
      });
    }
  },
  methods: {
    getreviewsBitrix: function getreviewsBitrix(page) {
      var _this2 = this;

      var searchitem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var ratingitem = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      var searchdata = '';
      searchdata = searchitem !== '' ? '&search=' + searchitem : '';
      var ratedata = '';
      ratedata = ratingitem !== '' && ratingitem !== 'all' ? '&rating=' + ratingitem : '';
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/rating/reviews?page=' + page + '&size=' + this.perPage + searchdata + ratedata, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.reviewsbitrix = res.data.items;
        _this2.totalitems = res.data.total;
        _this2.lastpage = res.data.last_page;
        _this2.loading = false;
        if (_this2.prisenJoboption.length < 1) {
          _this2.gettaskbitrix();
        }
      }, function (err) {
        _this2.loading = false;
        _this2.show = false;
        var error = err.body;
        _this2.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this3 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          res.data.forEach(function (l) {
            var industryname = {};
            industryname.text = l.BRANCHE;
            industryname.value = l.BRANCHE_ID;
            _this3.prisenJoboption.push(industryname);
          });
        }
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    paginationChanged: function paginationChanged(currpage) {
      this.loading = true;
      this.reviewsbitrix = [];
      this.currentpage = currpage;
      this.getreviewsBitrix(currpage);
    },
    reportreview: function reportreview(reviewdata) {
      var _this4 = this;

      var option = this.report;
      this.isLoadingReview = true;
      var fileList = this.fileList[0];
      this.haaId = localStorage.getItem('haaid');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var dataform = new FormData();
      dataform.append('DOCUMENTATIONCOMMENT', this.reportNote);
      dataform.append('TRADEMANCOMPLAINTHEADLINE', this.reportNote);
      dataform.append('TRADEMANCOMPLAINT', this.report);
      dataform.append('REVIEWID', reviewdata.ID);
      if (option === '3') {
        dataform.append('TRADEMANCOMPLAINTCATEGORY', Number(this.industryValue));
        dataform.append('file', fileList.raw);
      }
      this.$http.post(this.$bitrixapi + 'partner/rating/UploadReviewDocumentationv2', dataform, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          $('html,body').animate({ scrollTop: $('#row-' + reviewdata.ID).offset().top - 270 }, 'slow');
          document.querySelector('.flag-link' + reviewdata.ID).classList.add('hide');
          document.querySelector('.report-form' + reviewdata.ID).classList.add('hide');
          _this4.clearFieldsReportForm();
          var message = '';
          if (option !== '3') {
            message = '';
          } else {
            message = 'Tak for din anmodning om at flytte din anbefaling til en anden kategori. Vi kontrollerer løbende for at undgå snyd ifm. Håndværker.dk Prisen - derfor kan der ske afvisninger. Hvis din anmodning afvises, modtager du en mail inden for 7 dage. ';
          }
          var obj = {
            title: 'Rapport indsendt!',
            message: message,
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
          _this4.isLoadingReview = false;
          _this4.getreviewsBitrix(_this4.currentpage);
        } else {
          _this4.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this4.isLoadingReview = false;
        _this4.loading = false;
        var error = response.body;
        _this4.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    addeditcomment: function addeditcomment(item) {
      var _this5 = this;

      this.loading = true;
      this.isLoadingReview = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      var commentWithBreak = item.SupplierComment.replaceAll('\n', '\\n');
      var data = {
        SUPPLIERCOMMENT: commentWithBreak,
        Review_ID: item.id
      };
      this.$http.post(this.$bitrixapi + 'partner/EditSupplierComment', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.isLoadingReview = false;
        _this5.sampleReviewcs = '';
        item.SupplierCommentDate = 'Today';
        if (res.success) {
          _this5.getreviewsBitrix(_this5.currentpage);
          var obj = {
            title: 'Gennemført',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this5.$refs.simplert.openSimplert(obj);
          _this5.hideModal();
        } else {
          _this5.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this5.isLoadingReview = false;
        _this5.loading = false;
        var error = response.body;
        _this5.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    downloadreview: function downloadreview(review, share) {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.show = true;
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/rating/reviewImage/' + review.ID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.success) {
          if (share === 1) {
            window.open('https://www.facebook.com/sharer/sharer.php?u=' + res.data.url, '_blank');
          } else {
            var linkSource = 'data:image/jpg;base64,' + encodeURI(res.data.base64);
            var downloadLink = document.createElement('a');
            var fileName = 'anbefaling' + review.ID + '.jpg';
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        } else {
          _this6.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        var error = response.body;
        _this6.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    Reload: function Reload() {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false;
        return;
      }
      var data = { operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        _this7.reviews = res;
        _this7.show = false;
        _this7.loading = false;
        var z = 0;
        for (var id in _this7.reviews) {
          var review = _this7.reviews[id];
          var checkreview = _this7.moment(review.RatedDate, 'YYYY/MM/DD');
          var checkpremonth = _this7.moment(_this7.premonth, 'YYYY/MM/DD');
          var month1 = checkreview.format('M');
          var year1 = checkreview.format('YYYY');
          var month2 = checkpremonth.format('M');
          var year2 = checkpremonth.format('YYYY');
          if (month1 === month2 && year1 === year2) {
            z = z + 1;
          }
        }
        _this7.$emit('UpdateAnb', z);
        _this7.isLoadingReview = false;
        if (_this7.reviews.length === 0) {
          _this7.reviewslength = true;
        }
        _this7.reviewcat();
      }, function (response) {
        alert('error ');
      });
    },
    selectIndustry: function selectIndustry(industry) {
      if (industry === null) return 'Ingen';
      for (var id in this.reviewscat) {
        var cat = this.reviewscat[id];
        if (cat.value === industry) {
          return cat.text;
        }
      }
    },
    reviewcat: function reviewcat() {
      var _this8 = this;

      this.reviewscat = [];
      this.reviewscat.push({
        text: 'Vælg den fagkategori du vil ændre til',
        value: null,
        disabled: true
      });
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'anbefalingercat', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        for (var id in res) {
          var cat = res[id];
          _this8.reviewscat.push({
            text: cat.Title,
            value: cat.IndustryId
          });
        }
      }, function (response) {
        alert('error');
      });
    },
    review_service: function review_service(item) {
      var _this9 = this;

      this.isLoadingReview = true;
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var commentWithBreak = item.SupplierComment.replaceAll('\n', '\\n');
      var dataPartner = { operation: 'review_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: commentWithBreak };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this9.show = false;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        _this9.isLoadingReview = false;
        _this9.show = false;
        _this9.sampleReviewcs = '';
        item.SupplierCommentDate = 'Today';
        if (res.success) {
          _this9.Reload();
          var obj = {
            title: 'Gennemført',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this9.$refs.simplert.openSimplert(obj);
          _this9.hideModal();
        } else {
          console.log(response);
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    reviewcs_service_action: function reviewcs_service_action(item) {
      var _this10 = this;

      this.isLoadingReview = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'reviewcs_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: this.sampleReviewcs };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this10.show = false;
        if (res.login === false) {
          _this10.$router.push('/login');
        }
        _this10.isLoadingReview = false;
        if (res.success) {
          alert('Gennemført!');
          _this10.hideModal();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    reviewcs_service: function reviewcs_service() {
      this.reviewShow = false;
      this.reviewShowcs = true;
    },
    showItemDetailsold: function showItemDetailsold(review) {
      var _this11 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.show = true;
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'anbefalingerDetail', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this11.$router.push('/login');
        }
        _this11.show = false;
        _this11.reviewShow = !_this11.reviewShow;
        review.SupplierComment = review.SupplierComment.replaceAll('\\n', '\n');
        _this11.sampleReview = review;

        if (_this11.reviewShow) {
          setTimeout(function () {}, 5000);
        }
        _this11.sampleReview.time = parseFloat(res.ContactRating);
        _this11.sampleReview.listen = parseFloat(res.AgreementRating);
        _this11.sampleReview.bargain = parseFloat(res.PriceRating);
        _this11.sampleReview.clean = parseFloat(res.CleaningRating);
        _this11.sampleReview.quality = parseFloat(res.WorkRating);
        _this11.sampleReview.recommend = parseFloat(res.RecommendRating);
        _this11.sampleReview.total = parseFloat(res.Rating);
        _this11.sampleReview.RequesterName = res.RequesterName;
        _this11.sampleReview.RequesterComment = res.RequesterComment;
        _this11.sampleReview.Title = res.Title;
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(review) {
      this.sampleReview = {};
      this.sampleReview.time = parseFloat(review.CONTACT_RATING);
      this.sampleReview.listen = parseFloat(review.AGREEMENT_RATING);
      this.sampleReview.bargain = parseFloat(review.PRICE_RATING);
      this.sampleReview.clean = parseFloat(review.CLEANING_RATING);
      this.sampleReview.quality = parseFloat(review.WORK_RATING);
      this.sampleReview.recommend = parseFloat(review.RECOMMEND_RATING);
      this.sampleReview.total = parseFloat(review.RATING);
      this.sampleReview.RequesterName = review.CONTACT.NAME;
      this.sampleReview.SupplierComment = review.COMMENT;
      this.sampleReview.RequesterComment = review.DESCRIPTION.replaceAll('\\n', '\n');
      this.sampleReview.Title = review.TITLE;
      this.sampleReview.id = review.ID;
      this.reviewShow = true;
    },
    forceFileDownload: function forceFileDownload(response) {
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.png');
      document.body.appendChild(link);
      link.click();
    },
    downloadItemDetails: function downloadItemDetails(review, share) {
      var _this12 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.show = true;
      var data = { operation: 'anbefalingerDownload', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId, reviewPic: review.ProfilePicPath };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this12.show = false;
        if (res.login === false) {
          _this12.$router.push('/login');
        }
        if (res.success) {
          if (share === 1) {
            window.open('https://www.facebook.com/sharer/sharer.php?u=https://www.håndværker.dk/microsites/rating.php?id=' + review.ReviewId, '_blank');
          } else {
            var linkSource = 'data:image/jpg;base64,' + encodeURI(res.url);
            var downloadLink = document.createElement('a');
            var fileName = 'anbefaling' + review.ReviewId + '.jpg';
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        } else {
          alert('error');
        }
      }, function (response) {
        alert('error');
      });
    },
    hideModal: function hideModal() {
      this.reviewShow = false;
      this.reviewShowcs = false;
    },
    setRating: function setRating(rating) {
      this.sampleReview.rating = rating;
    },
    showReportForm: function showReportForm(reviewId) {
      this.clearFieldsReportForm();
      this.openreportid = reviewId;
      var reportForm = document.querySelector('.report-form' + reviewId);
      if (reportForm.classList.contains('hide')) {
        reportForm.classList.remove('hide');
      } else {
        reportForm.classList.add('hide');
      }
      this.reviewsbitrix.forEach(function (e) {
        if (e.ID !== Number(reviewId)) {
          setTimeout(function () {
            if (!document.querySelector('.report-form' + e.ID.toString()).classList.contains('hide')) {
              document.querySelector('.report-form' + e.ID.toString()).classList.add('hide');
            }
          }, 100);
        }
      });
    },
    reportOptionsChanged: function reportOptionsChanged(review) {
      var datenow = new Date(review.CREATED_ON_SHOW);
      var prisenstart = new Date('2022-08-16');
      var prisenend = new Date('2023-08-15');
      if (datenow.getTime() >= prisenstart.getTime() && datenow.getTime() <= prisenend.getTime()) {
        this.endprisenpopup = true;
        return false;
      } else {
        var option = this.report;
        if (option === '3') {
          this.fileUploadVisible = true;
          setTimeout(function () {
            var fileUploadText = document.querySelectorAll('.report-form button > span:nth-child(2)');
            for (var i = 0; i < fileUploadText.length; i++) {
              fileUploadText[i].innerText = 'Indsend dokumentation for opgavens reelle fagkategori';
            }
          }, 100);
        } else {
          this.fileUploadVisible = false;
        }
      }
    },
    handleFileUpload: function handleFileUpload(file, fileList) {
      this.fileList = fileList;
    },
    checkBeforeSubmit: function checkBeforeSubmit(reviewdata) {
      var datenow = new Date(reviewdata.CREATED_ON_SHOW);
      var prisenstart = new Date('2022-08-16');
      var prisenend = new Date('2023-08-15');
      if (datenow.getTime() >= prisenstart.getTime() && datenow.getTime() <= prisenend.getTime()) {
        this.endprisenpopup = true;
        return false;
      } else {
        var option = this.report;
        var fileList = this.fileList;
        var note = this.reportNote;
        var industryValue = this.industryValue;
        if (option !== '3') {
          if (option !== null && note !== '') {
            this.reportreview(reviewdata);
          } else {
            this.$toastr('error', 'Felter påkrævet');
          }
        } else {
          var uploadFinish = localStorage.getItem('uploadFinish');
          if (uploadFinish === true || uploadFinish === null) {
            if (option !== null && note !== '' && fileList && industryValue !== null) {
              this.reportreview(reviewdata);
            } else {
              if (fileList.length === 0) {
                this.$toastr('error', 'Indsend dokumentation for opgavens reelle fagkategori');
              } else {
                this.$toastr('error', 'Felter påkrævet');
              }
            }
          } else {
            this.$toastr('error', 'Uploader stadig');
          }
        }
      }
    },
    submitReport: function submitReport(id) {
      var _this13 = this;

      this.isLoadingReview = true;
      var reviewId = id;
      var option = this.report;
      var industryValue = this.industryValue;
      var fileList = this.fileList;
      var note = this.reportNote;
      var salesPerson = localStorage.getItem('id_token_portal');
      var files = [];
      if (fileList.length > 0) {
        for (var i = 0; i < fileList.length; i++) {
          files.push('https://www.kundematch.dk/HenttilbudImg.php?img=' + fileList[i]);
        }
      }
      var data = {
        operation: 'addreport',
        salesPerson: salesPerson,
        review_id: reviewId,
        option: option,
        industryValue: industryValue,
        files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(files),
        note: note
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this13.$router.push('/login');
        }
        if (res.success) {
          $('html,body').animate({ scrollTop: $('#row-' + reviewId).offset().top - 270 }, 'slow');
          document.querySelector('.flag-link' + id).classList.add('hide');
          document.querySelector('.report-form' + id).classList.add('hide');
          _this13.clearFieldsReportForm();
          var message = '';
          if (option !== '3') {
            message = '';
          } else {
            message = 'Tak for din anmodning om at flytte din anbefaling til en anden kategori. Vi kontrollerer løbende for at undgå snyd ifm. Håndværker.dk Prisen - derfor kan der ske afvisninger. Hvis din anmodning afvises, modtager du en mail inden for 7 dage. ';
          }
          var obj = {
            title: 'Rapport indsendt!',
            message: message,
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this13.$refs.simplert.openSimplert(obj);
          _this13.Reload();
          _this13.isLoadingReview = false;
        } else {
          _this13.isLoadingReview = false;
          _this13.show = false;
          alert('Error');
        }
      }, function (response) {
        _this13.isLoadingReview = false;
        console.log('Error in submitReport()');
      });
    },
    clearFieldsReportForm: function clearFieldsReportForm() {
      this.report = null;
      this.reportNote = '';
      this.fileList = [];
      this.fileUploadVisible = false;
    }
  }
});

/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"Reviewspage"}},[_c('div',{staticClass:"col-12 px0"},[(_vm.reviewslength)?_c('div',[_vm._m(0)]):_vm._e()]),_vm._v(" "),(_vm.totalitems > 0)?_c('div',{staticClass:"flex col-12 p0"},[_c('el-pagination',{staticClass:"p0 my2",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":this.totalitems},on:{"current-change":_vm.paginationChanged}}),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center ml-auto",on:{"click":function($event){_vm.filterReviews = true}}},[_c('span',{staticClass:"pointer"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"mx2 pointer"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","height":"29","viewBox":"0 0 32 29"}},[_c('path',{attrs:{"id":"Icon_feather-filter","data-name":"Icon feather-filter","d":"M33,4.5H3L15,18.69V28.5l6,3V18.69Z","transform":"translate(-2 -3.5)","fill":"none","stroke":"#707070","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])],1):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12 px0"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.reviews !== 0 && !_vm.loading)?_c('div',{staticClass:"col-12 flex flex-wrap px0"},_vm._l((_vm.reviewsbitrix),function(review){return _c('div',{key:review.ID,class:'col-12 mr2 mb2 border muted-border shadow p2 ' + review.STATUS,attrs:{"id":'row-' + review.ID}},[_c('div',{staticClass:"flex mt1 justify-start items-center"},[_c('div',{staticClass:"col-4 blur-part p0"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":22,"spacing":1,"show-rating":false,"read-only":true},model:{value:(review.RATING),callback:function ($$v) {_vm.$set(review, "RATING", $$v)},expression:"review.RATING"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 ml-auto flex justify-end p0 gap-10"},[_c('span',{staticClass:"green"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])]),_vm._v(" "),_vm._m(2,true)])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center mb2"},[_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"p0 col-2"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-golden m0"},[_vm._v(_vm._s(review.CONTACT.NAME))])]),_vm._v(" "),_c('span',{staticClass:"px2"},[_vm._v("|")]),_vm._v(" "),_c('div',{staticClass:"col-4 p0"},[_c('p',{staticClass:"darkblue semi-bold line-height-golden m0"},[_vm._v(" "+_vm._s(review.BRANCH))])])]),_vm._v(" "),_c('div',{staticClass:"p0"},[_c('p',{staticClass:"h6 darkblue mb0 relative"},[_vm._v(_vm._s(_vm.moment(review.DATE).format('LL')))])])]),_vm._v(" "),_c('div',{staticClass:"blur-part clearfix flex justify-between xs-flex-column gap-10"},[_c('div',{staticClass:"sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0"},[_c('button',{staticClass:"block buttonanbefal m0 outlined-primary-button col-12  p1 not-rounded gibson h5 flex justify-center items-center pointer no-hover",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showItemDetails(review)}}},[_c('span',{staticClass:"relative mr1"},[_c('svg',{attrs:{"fill":"currentColor","height":"36","viewBox":"0 -75 512 512","width":"36","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m446.019531 300.152344h-38c-5.519531 0-10-4.476563-10-10v-26.960938c0-6.78125-5.511719-12.292968-12.292969-12.292968h-6.53125v20.785156c0 7.183594-4.578124 13.527344-11.398437 15.789062-6.816406 2.253906-14.28125-.09375-18.570313-5.855468l-36.867187-49.503907c-4.960937-6.664062-4.960937-15.96875 0-22.628906l36.871094-49.507813c4.285156-5.757812 11.75-8.109374 18.566406-5.851562 6.820313 2.257812 11.398437 8.605469 11.398437 15.785156v22.984375h12.355469c35.550781 0 64.472657 28.921875 64.472657 64.472657v32.78125c-.003907 5.527343-4.480469 10.003906-10.003907 10.003906zm-28-20h18v-22.785156c0-24.519532-19.949219-44.46875-44.46875-44.46875h-18.929687c-7.402344 0-13.425782-6.023438-13.425782-13.429688v-19.394531l-30.328124 40.722656 30.328124 40.722656v-17.195312c0-7.402344 6.023438-13.425781 13.425782-13.425781h13.105468c17.808594 0 32.292969 14.484374 32.292969 32.292968zm0 0"}}),_c('path',{attrs:{"d":"m66.105469 153.820312c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10h.023437c5.523438 0 9.988282-4.476562 9.988282-10 0-5.519531-4.488282-10-10.011719-10zm0 0"}}),_c('path',{attrs:{"d":"m385.480469 108.523438c-3.675781 0-7.320313.15625-10.917969.46875v-67.351563c0-11.679687-4.835938-22.25-12.605469-29.820313-.121093-.125-.246093-.253906-.375-.375-7.773437-7.378906-17.953125-11.445312-28.660156-11.445312h-291.28125c-10.710937 0-20.886719 4.066406-28.664063 11.445312-.128906.125-.253906.25-.375.375-7.769531 7.570313-12.601562 18.140626-12.601562 29.820313v161.761719c0 10.492187 3.902344 20.089844 10.328125 27.417968.144531.183594.292969.363282.453125.539063 2.96875 3.273437 6.414062 6.023437 10.183594 8.175781 6.09375 3.503906 13.152344 5.507813 20.675781 5.507813h217.714844c5.113281 65.105469 59.730469 116.519531 126.125 116.519531 69.761719-.003906 126.519531-56.757812 126.519531-126.519531s-56.757812-126.519531-126.519531-126.519531zm-132.148438-13.785157-49.570312 43.707031c-4.699219 4.144532-10.589844 6.214844-16.480469 6.214844-4.511719 0-9.019531-1.210937-12.996094-3.640625-.242187-.148437-.484375-.300781-.722656-.460937-.402344-.261719-.792969-.539063-1.179688-.828125-.539062-.402344-1.070312-.832031-1.582031-1.285157l-49.570312-43.707031c-.003907 0-.003907 0-.003907 0l-84.203124-74.242187c1.488281-.324219 3.03125-.496094 4.617187-.496094h291.28125c1.582031 0 3.128906.171875 4.613281.496094l-84.164062 74.207031c-.011719.015625-.027344.023437-.039063.035156zm99.65625-61.203125c1.015625 2.503906 1.574219 5.242188 1.574219 8.105469v70.6875c-19.84375 4.96875-37.648438 14.519531-52.363281 27.386719l-28.542969-36.230469zm-311.648437 191.503906c-.015625 0-.03125 0-.042969 0-.085937 0-.171875-.003906-.257813-.003906-.015624 0-.027343-.003906-.046874-.003906-3.039063-.089844-6.003907-.824219-8.707032-2.121094l15.621094-19.824218c3.417969-4.339844 2.671875-10.625-1.667969-14.046876-4.335937-3.414062-10.625-2.667968-14.042969 1.667969l-12.039062 15.285157c-.101562-.847657-.15625-1.710938-.15625-2.589844v-161.761719c0-2.863281.558594-5.601563 1.574219-8.105469l79.332031 69.949219-16.78125 21.300781c-3.417969 4.339844-2.671875 10.625 1.667969 14.042969 4.339843 3.417969 10.625 2.675781 14.042969-1.664063l16.09375-20.433593 41.644531 36.71875c14.6875 12.949219 35.851562 14.667969 52.261719 5.152343 2.507812-1.453124 4.90625-3.171874 7.152343-5.152343l41.644531-36.71875 29.488282 37.433593c-6.953125 8.382813-12.832032 17.660157-17.445313 27.617188-.019531.039062-.035156.078125-.054687.117188-.03125.074218-.066406.144531-.101563.21875-6.195312 13.441406-9.992187 27.941406-11.164062 42.921874h-217.714844c-.101563.003907-.199219 0-.300781 0zm344.140625 116.519532c-58.734375 0-106.519531-47.78125-106.519531-106.519532 0-.214843.003906-.429687.003906-.644531 0-.070312 0-.144531 0-.214843.003906-.148438.003906-.292969.003906-.441407.003906-.070312.003906-.140625.003906-.210937 0-.011719 0-.019532 0-.027344.003906-.140625.003906-.285156.007813-.425781 0-.066407.003906-.136719.003906-.203125 0-.011719 0-.023438 0-.039063.003906-.136719.007813-.273437.007813-.410156.003906-.0625.003906-.121094.007812-.183594 0-.027343 0-.058593 0-.085937.003906-.136719.007812-.277344.011719-.417969.003906-.035156.003906-.074219.003906-.109375 0-.046875.003906-.089844.003906-.136719.003907-.160156.011719-.320312.015625-.480469 0-.007812.003906-.019531.003906-.027343 0-.042969 0-.085938.003907-.132813.007812-.191406.015625-.382812.023437-.574218 0-.015626 0-.035157.003906-.050782 2.527344-56.507812 49.289063-101.699218 106.410157-101.699218 58.734375 0 106.519531 47.78125 106.519531 106.515624 0 58.738282-47.785156 106.519532-106.519531 106.519532zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 line-height-1 pl1"},[_vm._v("Læs og besvar")])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0"},[_c('button',{staticClass:"block buttonanbefal outlined-dark-button p1 col-12  flex justify-center items-center gibson not-rounded pointer",attrs:{"type":"button"},on:{"click":function($event){return _vm.downloadreview(review,0)}}},[_c('span',{staticClass:"relative mr1"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M406 187.5c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 160 0 214.4 0 281.3s54.4 121.3 121.3 121.3h44.5c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5s44.6-99.5 99.5-99.5c2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.4 8.6-0.4 8.6 -0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.3 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-48.9c-6 0-10.9 4.9-10.9 10.9s4.9 10.9 10.9 10.9h48.9c59.3 0 107.6-48.3 107.6-107.6C512 236.3 464.6 188.3 406 187.5z"}}),_c('path',{attrs:{"d":"M262.8 97.5c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 6.4 0.9 11.5-3.9 12.3-9.3 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 102.4 268.8 97.5 262.8 97.5z"}}),_c('path',{attrs:{"d":"M313.3 410.3c-4-4.5-10.9-4.9-15.4-0.9l-26.3 23.5V298.5c0-6-4.9-10.9-10.9-10.9 -6 0-10.9 4.9-10.9 10.9v134.3l-26.3-23.5c-4.5-4-11.4-3.6-15.4 0.9 -4 4.5-3.6 11.4 0.9 15.4l39.7 35.5c3.4 3.1 7.7 4.6 12 4.6 4.3 0 8.6-1.5 12-4.6l39.7-35.5C316.9 421.7 317.3 414.8 313.3 410.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 line-height-1 ",staticStyle:{"color":"currentColor"}},[_vm._v("Gem billede af anbefalingen")])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0"},[_c('button',{staticClass:"buttonanbefal p0 outlined-facebook-button p1 col-12  pointer no-hover flex justify-center items-center ",attrs:{"type":"button"},on:{"click":function($event){return _vm.downloadreview(review,1)}}},[_vm._m(3,true),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 left-align "},[_vm._v("Del anbefaling på Facebook")])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p0 m0"},[(review.STAGE != 'Pending')?_c('button',{class:' flex justify-center buttonanbefal pointer report-facebook-button col-12 p0 items-center flag flag-link' + review.ID,attrs:{"type":"button","title":"Rapporter anbefaling"},on:{"click":function($event){return _vm.showReportForm(review.ID)}}},[_c('img',{staticClass:"mr2",attrs:{"src":"/static/svg/feather-flag.svg","alt":"","width":"20","height":"20"}}),_vm._v("\n          Rapporter anbefaling\n          ")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-8 mx-auto py1"},[_c('b-form',{class:'hide report-form report-form' + review.ID,model:{value:(_vm.reportForm),callback:function ($$v) {_vm.reportForm=$$v},expression:"reportForm"}},[_c('b-form-select',{staticClass:"col-12 mb2",attrs:{"options":_vm.reportOptions},on:{"change":function($event){return _vm.reportOptionsChanged(review)}},model:{value:(_vm.report),callback:function ($$v) {_vm.report=$$v},expression:"report"}}),_vm._v(" "),(_vm.fileUploadVisible)?_c('b-form-select',{staticClass:"col-12 mb2",attrs:{"options":_vm.prisenJoboption},model:{value:(_vm.industryValue),callback:function ($$v) {_vm.industryValue=$$v},expression:"industryValue"}}):_vm._e(),_vm._v(" "),_c('b-form-textarea',{staticClass:"mb2",attrs:{"id":"textarea","placeholder":"Skriv evt. kommentar"},model:{value:(_vm.reportNote),callback:function ($$v) {_vm.reportNote=$$v},expression:"reportNote"}}),_vm._v(" "),(_vm.fileUploadVisible)?_c('el-upload',{staticClass:"col-12 p0 mb2",attrs:{"action":"#","on-change":_vm.handleFileUpload,"auto-upload":false,"accept":".jpg, .jpeg, .png, .webp, .pdf, .doc, .docx","file-list":_vm.fileList,"list-type":"text","limit":1,"multiple":false,"disabled":_vm.disable}},[_c('div',{staticClass:" flex items-center justify-center ",staticStyle:{"border":"3px dashed rgb(25, 163, 192)"}},[_c('span',{staticClass:" relative"},[_vm._v("\n                    Indsend dokumentation for opgavens reelle fagkategori\n                  ")])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn rounded action-button btn-lg col-12",attrs:{"type":"button","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.checkBeforeSubmit(review)}}},[_vm._v("\n            Anmod om ændring\n          ")])],1)],1)])}),0):_vm._e(),_vm._v(" "),(_vm.reviewShow)?_c('b-modal',{ref:"reviewModal",model:{value:(_vm.reviewShow),callback:function ($$v) {_vm.reviewShow=$$v},expression:"reviewShow"}},[_c('div',{staticClass:"col-12 flex justify-end items-center px0 "},[_c('button',{staticClass:"white-background border-0 not-rounded",attrs:{"type":"button"},on:{"click":function($event){_vm.reviewShow = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close darkblue h5"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix px2 mb1"},[_c('div',{staticClass:"h5 darkblue semi-bold gibson pt2"},[_vm._v("\n        Din kunde "),_c('strong',[_vm._v(_vm._s(_vm.sampleReview.RequesterName))]),_vm._v(" har givet dig følgende vurdering\n      ")])]),_vm._v(" "),_c('div',{staticClass:"modal-content px2 gibson",staticStyle:{"border":"0"}},[_c('div',{staticClass:"flex justify-between items-center mt3 mb2"},[_c('span',{staticClass:"h5 semi-bold darkblue mb0"},[_vm._v("Samlet vurdering")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.total),callback:function ($$v) {_vm.$set(_vm.sampleReview, "total", $$v)},expression:"sampleReview.total"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0"},[_vm._v("Leverer kvalitetsarbejde")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.quality),callback:function ($$v) {_vm.$set(_vm.sampleReview, "quality", $$v)},expression:"sampleReview.quality"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0"},[_vm._v("Overholder budgettet")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.bargain),callback:function ($$v) {_vm.$set(_vm.sampleReview, "bargain", $$v)},expression:"sampleReview.bargain"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0"},[_vm._v("Rydder godt op efter sig")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.clean),callback:function ($$v) {_vm.$set(_vm.sampleReview, "clean", $$v)},expression:"sampleReview.clean"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0"},[_vm._v("Overholder aftaler")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.time),callback:function ($$v) {_vm.$set(_vm.sampleReview, "time", $$v)},expression:"sampleReview.time"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0"},[_vm._v("Er god til at lytte til kunden")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.listen),callback:function ($$v) {_vm.$set(_vm.sampleReview, "listen", $$v)},expression:"sampleReview.listen"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular gibson darkblue mb0"},[_vm._v("Vil du anbefale os")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":16,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.recommend),callback:function ($$v) {_vm.$set(_vm.sampleReview, "recommend", $$v)},expression:"sampleReview.recommend"}})],1)]),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('div',{staticClass:"h6 darkblue semi-bold mb2 gibson"},[_vm._v(_vm._s(_vm.sampleReview.Title))]),_vm._v(" "),_c('div',{staticClass:"darkblue line-height-1 h6 regular break-word",domProps:{"innerHTML":_vm._s(_vm.sampleReview.RequesterComment)}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"h6 darkblue semi-bold mb2 gibson"},[_vm._v("Kommentar")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sampleReview.SupplierComment),expression:"sampleReview.SupplierComment"}],staticClass:"darkblue lightgrey-background line-height-1 p2 h6 border-none not-rounded",attrs:{"id":"textarea1","placeholder":"Skriv en kommentar til anbefalingen her","rows":4,"max-rows":6},domProps:{"value":(_vm.sampleReview.SupplierComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sampleReview, "SupplierComment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column px0",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"col-12 px0 clearfix flex justify-between items-center gibson"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{staticClass:"col-12 p2 not-rounded outlined-disabled-button gibson h5 flex justify-center items-center",attrs:{"slot":"modal-cancel","type":"button"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold mb0"},[_vm._v("Luk")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{staticClass:"col-12 action-button p2 not-rounded gibson h5 line-height-1 flex justify-center items-center",attrs:{"slot":"modal-ok","type":"submit","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.addeditcomment(_vm.sampleReview)}},slot:"modal-ok"},[_c('span',{staticClass:"h6 semi-bold mb0"},[_vm._v("Gem kommentar")]),_vm._v(" "),_c('span',{staticClass:"pl2"},[_c('i',{staticClass:"el-icon-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col col-6 pr1 mt1 mb4 pl0"},[_c('button',{staticClass:"col-12 hide outlined-action-button p2 gibson h5 line-height-1 not-rounded",attrs:{"type":"button"}},[_c('span',{staticClass:"h6 semi-bold mb0",on:{"click":function($event){return _vm.reviewcs_service()}}},[_vm._v("Rappoter til Håndværker.dk")])])])])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"reviewShowcs",model:{value:(_vm.reviewShowcs),callback:function ($$v) {_vm.reviewShowcs=$$v},expression:"reviewShowcs"}},[_c('div',{staticClass:"clearfix px2 mb1"},[_c('div',{staticClass:"h6 darkblue semi-bold gibson pt2"},[_vm._v("\n        Rapporter om "),_c('strong',[_vm._v(_vm._s(_vm.sampleReview.RequesterName))]),_vm._v(" som givet dig følgende vurdering . (Review ID: "+_vm._s(_vm.sampleReview.ID)+" )\n      ")])]),_vm._v(" "),_c('div',{staticClass:"modal-content px2 gibson",staticStyle:{"border":"0"}},[_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sampleReviewcs),expression:"sampleReviewcs"}],staticClass:"darkblue lightgrey-background line-height-golden",staticStyle:{"border":"0","font-size":"1rem"},attrs:{"variant":"secondary","id":"textarea2","rows":4,"max-rows":8},domProps:{"value":(_vm.sampleReviewcs)},on:{"input":function($event){if($event.target.composing){ return; }_vm.sampleReviewcs=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center gibson pt2 pb3",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button px2 py1",attrs:{"slot":"modal-cancel","type":"button"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('span',{staticClass:"h6 semi-bold mb0"},[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"action-button px2 py1",attrs:{"slot":"modal-ok","type":"submit","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.reportreview(_vm.sampleReview)}},slot:"modal-ok"},[_c('span',{staticClass:"h6 semi-bold mb0"},[_vm._v("Rappoter")])])])]),_vm._v(" "),_c('b-modal',{ref:"filterReviewsModal",attrs:{"hide-footer":"","centered":"","size":"sm","id":"filterReviews"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 my2"},[_vm._v("\n                Filtrer\n              ")])]},proxy:true},{key:"modal-footer",fn:function(){return [_c('div',{staticClass:"col-12 flex justify-center px0"},[_c('button',{staticClass:"outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])])])]},proxy:true}]),model:{value:(_vm.filterReviews),callback:function ($$v) {_vm.filterReviews=$$v},expression:"filterReviews"}},[_vm._v(" "),_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"clearfix p2 mt2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h6 darkblue semi-bold gibson mb2"},[_vm._v("Antal stjerner")])]),_vm._v(" "),_c('el-radio-group',{model:{value:(_vm.ratingVal),callback:function ($$v) {_vm.ratingVal=$$v},expression:"ratingVal"}},[_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('el-radio',{staticClass:"flex",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"label":"all","value":"all"}},[_c('span',{staticClass:"h5 px1"},[_vm._v("All")])])],1),_vm._v(" "),_vm._l((5),function(num,index){return _c('div',{key:index,staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('el-radio',{staticClass:"flex",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"label":num,"value":num}},[_c('div',{staticClass:"px1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":num,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":5,"read-only":true}})],1)])],1)})],2)],1)])]),_vm._v(" "),_c('b-modal',{ref:"projectDescription",staticClass:"p3",attrs:{"hide-footer":"","size":"lg","centered":"","id":"projectDescription","title":"Project description"},model:{value:(_vm.endprisenpopup),callback:function ($$v) {_vm.endprisenpopup=$$v},expression:"endprisenpopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 p2"},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.endprisenpopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('div',{staticClass:"py2 px3"},[_c('p',{staticClass:"line-height-golden h4 regular"},[_vm._v("Anbefalinger lavet i perioden fra 16/8/2022 til og med 15/8/2023, kan ikke rettes mere pga. "),_c('a',{staticClass:"pointer",attrs:{"href":"https://www.haandvaerker.dk","target":"_blank","type":"button"}},[_vm._v("Håndværker.dk")]),_vm._v(" Prisen 2023")])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix p3 my3 lightgrey-background flex justify-start items-center"},[_c('p',{staticClass:"h5 darkblue mb0 line-height-golden"},[_vm._v("Ingen anbefalinger")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-setting h4"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1 relative"},[_c('img',{attrs:{"src":"/static/svg/facebook.svg","alt":"","width":"20","height":"20"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'collectreviews',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },
  data: function data() {
    return {
      form: {
        name: '',
        email: '',
        telefon: '',
        method: '1'
      },
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1
    };
  },

  methods: {
    service_invitation: function service_invitation() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      if (localStorage.getItem('haaid') === '0') {
        return;
      }
      var dataPartner = { operation: 'invitation', salesPerson: this.salesPerson, levid: this.haaId, email: this.form.email, requesterName: this.form.name, telephone: this.form.telefon, method: this.form.method };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
          _this.form.email = '';
          _this.form.name = '';
          _this.form.telefon = '';
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px0"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-7 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.moreReviews",modifiers:{"moreReviews":true}}],staticClass:"hide col-12 action-button p2 line-height-1 h5 flex justify-center items-center gibson",attrs:{"name":"moreReviews"}},[_c('span',{staticClass:"semi-bold mr2 mb0"},[_vm._v("Indhent flere anbefalinger")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix gibson pb3"},[_c('div',{staticClass:"col-12 px0 mt3"},[_c('b-form',{staticClass:"collectReviewForm",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_invitation.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1",attrs:{"id":"nameInput"}},[_vm._v("\n                Kundens navn\n              ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"navn","type":"text","required":"","placeholder":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"emailInput"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                Kundens email\n              ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"email","type":"email","required":"","placeholder":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"telInput"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                Kundens telefon\n              ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"tel","type":"tel","required":"","placeholder":""},model:{value:(_vm.form.telefon),callback:function ($$v) {_vm.$set(_vm.form, "telefon", $$v)},expression:"form.telefon"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb1",attrs:{"id":"method"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                Vælg metode\n              ")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background gibson darkblue border-none not-rounded h5",attrs:{"id":"method","required":""},model:{value:(_vm.form.method),callback:function ($$v) {_vm.$set(_vm.form, "method", $$v)},expression:"form.method"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Både SMS og e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Kun e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Kun SMS")])])],1),_vm._v(" "),_c('b-collapse',{attrs:{"id":"extraInvite"}},[_c('div',{staticClass:"clearfix my2 py2 border-top muted-border"},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1",attrs:{"id":"nameInput"}},[_vm._v("\n                  Kundens navn\n                ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"navn","type":"text","required":"","placeholder":""},model:{value:(_vm.form.name),callback:function ($$v) {_vm.$set(_vm.form, "name", $$v)},expression:"form.name"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"emailInput"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                  Kundens email\n                ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"email","type":"email","required":"","placeholder":""},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2",attrs:{"id":"telInput"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                  Kundens telefon\n                ")]),_vm._v(" "),_c('b-form-input',{attrs:{"clas":"muted-background gibson darkblue p2 border-none not-rounded h5","id":"tel","type":"tel","required":"","placeholder":""},model:{value:(_vm.form.telefon),callback:function ($$v) {_vm.$set(_vm.form, "telefon", $$v)},expression:"form.telefon"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb1",attrs:{"id":"method"}},[_c('p',{staticClass:"h5 darkblue regular gibson line-height-3 mb1"},[_vm._v("\n                  Vælg metode\n                ")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background gibson darkblue border-none not-rounded h5",attrs:{"id":"method","required":""},model:{value:(_vm.form.method),callback:function ($$v) {_vm.$set(_vm.form, "method", $$v)},expression:"form.method"}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Både SMS og e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Kun e-mail")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Kun SMS")])])],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mt2 mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.extraInvite",modifiers:{"extraInvite":true}}],staticClass:"hide outlined-action-button p2 px3 gibson flex justify-center items-center not-rounded"},[_c('span',{staticClass:"h5 semi-bold ml1 mb0"},[_vm._v("Tilføj flere")]),_vm._v(" "),_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-circle-plus-outline"})])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 px3 gibson flex justify-center items-center border-none not-rounded",attrs:{"type":"submit"}},[_c('span',{staticClass:"h5 semi-bold ml1 mb0"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)],1)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[_c('div',{staticClass:"clearfix gibson px3 mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('div',{staticClass:"col-12 px0 mt3"},[_c('haandvaerker'),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold line-height-2 mt3 mb2 px2"},[_vm._v("\n            Få et anbefalingsbanner på din hjemmeside og få flere fordele\n          ")]),_vm._v(" "),_vm._m(0)],1)]),_vm._v(" "),(_vm.haaId !== '0')?_c('div',{staticClass:"clearfix my2"},[_c('div',{staticClass:"col-12 mb2 px0"},[_c('div',{staticClass:"border muted-border p2 shadow"},[_c('div',{staticClass:"clearfix px0"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('b-collapse',{attrs:{"visible":"","id":"collapse5"}},[_c('ratingWidget',{attrs:{"items":_vm.items,"ratingwidget":_vm.ratingwidget}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb2 px0"},[_c('div',{staticClass:"border muted-border p2 shadow"},[_c('div',{staticClass:"clearfix px0"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 p2"},[_c('b-collapse',{staticClass:"mt2",attrs:{"visible":"","id":"collapse6"}},[_c('commentWidget',{attrs:{"items":_vm.items,"commentwidget":_vm.commentwidget}})],1)],1)])])])]):_vm._e()]),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb3 px2"},[_vm._v("\n            Dine kunder får mere tryghed omkring dig, når de kan se andre kunder også er tilfredse "),_c('br'),_vm._v("\n            Brug dine tilfredse kunder til at tiltrække nye "),_c('br'),_vm._v("\n            Bannerne kan hjælpe dig til at blive placeret bedre på Google "),_c('br'),_c('br'),_vm._v("\n            Sådan får du dit anbefalingsbanner på din egen hjemmeside. "),_c('br'),_vm._v(" "),_c('ul',{staticClass:"list-reset my2 px0",staticStyle:{"list-style-type":"square","list-style-position":"inside"}},[_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Tryk på den grønne knap herunder")]),_vm._v(" "),_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Højreklik på linket og send det til din webmaster(den person som har lavet hjemmesiden)")]),_vm._v(" "),_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Bed din webmaster om at indsætte dit nye anbefalingsbanner, der hvor du mener det skal sidde.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 mt3 mb2"},[_vm._v("Banner med anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden"},[_vm._v("\n                  Du kan indsætte dette banner som viser, hvor mange anbefalinger du har samt dit gennemsnit.\n                  "),_c('br'),_vm._v("\n                  Husk : dine kunder ønsker tryghed i rejsen når de skal finde en lokal håndværker.\n                ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 my2"},[_vm._v("Banner med udtalelser fra kunder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden"},[_vm._v("\n                  Du har også mulighed for at indsætte dette banner, som viser mere tekst fra dine tilfredse kunder.\n                  "),_c('br'),_vm._v("\n                  Du kan have begge bannere med på din hjemmeside, for at styrke troværdigheden yderligere.\n                ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anbefaling_vue__ = __webpack_require__(1050);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca82a24c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Anbefaling_vue__ = __webpack_require__(1051);
function injectStyle (ssrContext) {
  __webpack_require__(1049)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Anbefaling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ca82a24c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Anbefaling_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1049 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'anbefalinger',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__["ImageRating"],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      haaId: '',
      salesPerson: '',
      search: '',
      resultreviews: [],
      selectedReview: [],
      filteredItem: [],
      anbefalform: {
        reviewId: '',
        customerId: '',
        headline: '',
        comment: '',
        Kommunikation: 0,
        Overholdte: 0,
        Realistike: 0,
        Samarbejdsvillighed: 0,
        sikkerhed: 0,
        Adgang: 0
      },
      anbefalformrules: {
        headline: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en gyldig title',
          trigger: 'blur'
        }],
        comment: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit comment',
          trigger: 'blur'
        }]
      },
      answerselected: []
    };
  },
  created: function created() {
    this.Reload();
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get(this.$bitrixapi + 'partner/GetPartnersReviewsDoneOnClient', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.resultreviews = res.data;
          _this.filteredItem = _this.resultreviews;
        }
      }, function (response) {
        console.log('error in loading all Review');
      });
    },
    showanswer: function showanswer(item) {
      this.$refs['replyanswer'].show();
      this.answerselected = item;
    },
    closeanswer: function closeanswer() {
      this.$refs['replyanswer'].hide();
    },
    openreply: function openreply(item) {
      this.showanswer(item);
    },
    showformreditreview: function showformreditreview(item) {
      this.$refs['editReviewForm'].show();
      this.reviewSelect(item);
    },
    reviewSelect: function reviewSelect(item) {
      this.selectedReview = item;
      this.anbefalform.reviewId = item.ID;
      this.anbefalform.customerId = item.UF_CUSTOMER_ID;
      this.anbefalform.headline = item.UF_HEADLINE;
      this.anbefalform.comment = item.UF_COMMENT;
      this.anbefalform.Kommunikation = item.UF_RATING_COMMUNICATION;
      this.anbefalform.Overholdte = item.UF_RATING_TIME;
      this.anbefalform.Realistike = item.UF_RATING_REALISTIC_EXPECTATIONS;
      this.anbefalform.Samarbejdsvillighed = item.RECOMMEND_COMPANY_RATING;
      this.anbefalform.sikkerhed = item.UF_RATING_FINANCIAL_SECURITY;
      this.anbefalform.Adgang = item.UF_RATING_ACCESS;
    },
    updatereview: function updatereview() {
      var _this2 = this;

      var error = 0;
      this.$refs['mainanbefalform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.$confirm('Opdater din anmeldelse?', {
        confirmButtonText: 'Indsend',
        cancelButtonText: 'Annuller',
        type: 'warning'
      }).then(function () {
        _this2.haaid = localStorage.getItem('haaid');
        _this2.salesPerson = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this2.salesPerson
        };
        var data = {
          ID: _this2.anbefalform.reviewId,
          UF_HEADLINE: _this2.anbefalform.headline,
          UF_COMMENT: _this2.anbefalform.comment,
          UF_ENTERPRISE_SUM: 0,
          UF_CUSTOMER_ID: _this2.anbefalform.customerId,
          UF_RATING_COMMUNICATION: _this2.anbefalform.Kommunikation,
          UF_RATING_TIME: _this2.anbefalform.Overholdte,
          UF_RATING_ACCESS: _this2.anbefalform.Adgang,
          UF_RATING_REALISTIC_EXPECTATIONS: _this2.anbefalform.Realistike,
          UF_RATING_FINANCIAL_SECURITY: _this2.anbefalform.sikkerhed,
          UF_RATING_COLLABORATION: _this2.anbefalform.Samarbejdsvillighed
        };
        _this2.$http.post(_this2.$bitrixapi + 'partner/UpdateSavePartnerReviewonHomeowner', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this2.closeformreditreview();
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this2.$refs.simplert.openSimplert(obj);
            _this2.Reload();
          }
        }, function (response) {
          console.log('Error: ', response);
        });
      }).catch(function () {
        console.log('ok');
      });
    },
    closeformreditreview: function closeformreditreview() {
      this.$refs['editReviewForm'].hide();
    },
    deleteanbefal: function deleteanbefal(item) {
      var _this3 = this;

      this.$confirm('Bekræft sletning', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var headers = {
          Authorization: 'Bearer ' + _this3.salesPerson
        };
        var data = {
          ID: item.ID
        };
        _this3.$http.post(_this3.$bitrixapi + 'partner/deleteReviewById', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var obj = {
            title: 'Gennemført!',
            message: 'Success',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.Reload();
        }, function (err) {
          var error = err.body;
          console.log(error);
        });
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[[[_c('div',{staticClass:"clearfix col-11"},[_c('div',{staticClass:"col-12 px0 mx3"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n                      Når du har skrevet en anbefaling, kan du se den her.\n                    ")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex px0 mb2"},[_c('div',{staticClass:"col-9 flex justify-start items-center py1 border muted-border mediumgrey shadow"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0",staticStyle:{"background":"transparent","border":"0px!important"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-3 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:" col-12 p2 px2 py1 gibson border muted-border dark-button shadow not-rounded flex justify-center items-center",staticStyle:{"height":"76px"}},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"ml2 flex flex-column col-12 justify-start"},_vm._l((_vm.filteredItem),function(item,index){return (item.UF_STATUS !== 'DELETED')?_c('div',{key:index,staticClass:" p2 highlights border shakespeare-border--light mb2 col-12"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-2 flex p0 pr2 justify-center"},[(item.PHOTO !== null && item.PHOTO !== '')?_c('img',{staticClass:"cover",attrs:{"id":"imagedivreviewanbefaling","src":item.PHOTO,"width":"90%","alt":""}}):_c('img',{staticClass:"cover",attrs:{"id":"imagedivreviewanbefaling","src":"https://www.haandvaerker.dk/uploads/00.webp","width":"90%","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-7 p0 pr2"},[_c('div',{staticClass:"flex items-center mb1"},[_c('div',{staticClass:"pr2 flex items-center"},[_c('image-rating',{attrs:{"rating":parseInt(item.UF_RATING_OVERALL),"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true}})],1),_vm._v(" "),(item.HomeownerName)?_c('p',{staticClass:"cyprus semi-bold m0"},[_vm._v(_vm._s(item.HomeownerName.name))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"mb1 semi-bold"},[_c('div',{staticClass:"cyprus flex"},[_c('div',{staticClass:"headline easternblue mr1"},[_vm._v(_vm._s(item.UF_HEADLINE))]),_vm._v(" "),_c('div',{staticClass:"mr1"},[_vm._v("|")]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v(_vm._s(_vm.moment(new Date(item.UF_REVIEW_DATE)).format('D MMMM YYYY')))])])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"font14 mediumgrey mb0"},[_vm._v(_vm._s(item.UF_COMMENT))]),_vm._v(" "),(item.UF_ANSWER !== '')?_c('a',{staticClass:" no-underlined pointer font14",attrs:{"type":"button"},on:{"click":function($event){return _vm.openreply(item)}}},[_vm._v("... view reply")]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-2 flex ml-auto items-center p0"},[_c('div',{staticClass:"col-12 p0"},[_c('button',{staticClass:"flex col-12 justify-center items-center py1 outlined-primary-button button-padding  semi-bold font14 mb1",on:{"click":function($event){return _vm.showformreditreview(item)}}},[_c('i',{staticClass:"el-icon-edit mr1"}),_vm._v("Redigere\n                  ")]),_vm._v(" "),_c('button',{staticClass:"flex col-12 justify-center items-center py1 outlined-delete-button border red-border button-padding mb1 semi-bold font14",on:{"click":function($event){return _vm.deleteanbefal(item)}}},[_c('i',{staticClass:"el-icon-delete mr1"}),_vm._v("Slet\n                  ")])])])])]):_vm._e()}),0)]),_vm._v(" "),_c('b-modal',{ref:"editReviewForm",attrs:{"centered":"","hide-footer":"","id":"editReviewForm","no-close-on-esc":"","no-close-on-backdrop":""}},[_c('div',[_c('div',{staticClass:" col-12 flex justify-between items-center pt1 my2 px2 mx-auto"},[_c('p',{staticClass:"h4 cyprus line-height-1 semi-bold m0 p0 modal-title"},[_vm._v("Redigere Anbefal")]),_vm._v(" "),_c('button',{staticClass:"right h4 p0 primary-white-button close pointer",on:{"click":function($event){return _vm.closeformreditreview()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',[_c('el-form',{ref:"mainanbefalform",staticClass:"md-col-11 lg-col-11 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.anbefalform,"rules":_vm.anbefalformrules,"label-position":"top"}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none",attrs:{"label":"Headline","id":"Firmanavn","prop":"headline"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Navn Firma"},model:{value:(_vm.anbefalform.headline),callback:function ($$v) {_vm.$set(_vm.anbefalform, "headline", $$v)},expression:"anbefalform.headline"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none p0 ",attrs:{"label":"Comment","prop":"comment"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Hans Hansen"},model:{value:(_vm.anbefalform.comment),callback:function ($$v) {_vm.$set(_vm.anbefalform, "comment", $$v)},expression:"anbefalform.comment"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column mt2"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Kommunikation")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Kommunikation),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Kommunikation", $$v)},expression:"anbefalform.Kommunikation"}})],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Overholdte Tidplanerne")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Overholdte),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Overholdte", $$v)},expression:"anbefalform.Overholdte"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column mt2"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Realistike forventninger")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Realistike),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Realistike", $$v)},expression:"anbefalform.Realistike"}})],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Samarbejdsvillighed")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Samarbejdsvillighed),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Samarbejdsvillighed", $$v)},expression:"anbefalform.Samarbejdsvillighed"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column mt2"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Økomonisk sikkerhed")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.sikkerhed),callback:function ($$v) {_vm.$set(_vm.anbefalform, "sikkerhed", $$v)},expression:"anbefalform.sikkerhed"}})],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 sm-col-12"},[_c('label',[_vm._v("Adgang til arbejdet")]),_vm._v(" "),_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Adgang),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Adgang", $$v)},expression:"anbefalform.Adgang"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex mobile-flex-column my3 "},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover ml-auto p2 px2 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.updatereview()}}},[_vm._v("Gemme "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)])])]),_vm._v(" "),_c('b-modal',{ref:"replyanswer",attrs:{"centered":"","hide-footer":"","id":"replyanswer"}},[_c('div',[_c('div',{staticClass:"col-11 flex justify-end pt1 p0 mx-auto  my2"},[_c('button',{staticClass:"right h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closeanswer()}}},[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"md-col-11 lg-col-11 sm-col-12 mx-auto"},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12 mt2 border border-left-0 border-right-0 border-top-0 my1"},[_c('div',{staticClass:"col-12 fle flex-column p0"},[_c('div',{staticClass:"medium flex p0 m0 flex items-end"},[_c('image-rating',{attrs:{"rating":parseInt(_vm.answerselected.UF_RATING_TIME),"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true}}),_vm._v(" "),_c('span',{staticClass:"mediumgrey px1"},[_vm._v(" | ")]),_vm._v("\n                  "+_vm._s(_vm.moment(new Date(_vm.answerselected.UF_REVIEW_DATE)).format('D MMMM YYYY'))+"\n                  "),(_vm.answerselected.UF_STATUS === 'APPROVED')?_c('p',{staticClass:"flex items-center justify-start m0"},[_c('span',{staticClass:"pl1"},[_c('svg',{staticClass:"feather feather-info",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"14","height":"14","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12.01","y2":"8"}})])]),_vm._v(" "),_c('span',{staticClass:"easternblue",staticStyle:{"font-size":"10px"}},[_vm._v("Verificeret")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"headline h6 easternblue mx-auto m0"},[_vm._v(_vm._s(_vm.answerselected.UF_HEADLINE))]),_vm._v(" "),_c('p',{staticClass:"font14 darkblue mb0"},[_vm._v("\""+_vm._s(_vm.answerselected.UF_COMMENT)+"\"")])])])]),_vm._v(" "),(_vm.answerselected.UF_ANSWER)?_c('div',{staticClass:"flex flex-row mobile-flex-column mediumgrey-background mb2"},[_c('div',{staticClass:"flex flex-column items-center justify-center pl2 p2",staticStyle:{"width":"150px"}},[_c('span',[_c('img',{staticClass:"rounded-circle border",attrs:{"src":_vm.answerselected.HomeownerName.AVATAR ? _vm.answerselected.HomeownerName.AVATAR : 'https://www.haandvaerker.dk/content/3.0/img/supplier/rating/customer.png',"width":"50","height":"50"}})]),_vm._v(" "),_c('p',{staticClass:"font12  darkblue mb0"},[_vm._v(_vm._s(_vm.answerselected.HomeownerName.name))])]),_vm._v(" "),_c('div',{staticClass:"m0 mp0 lg-col-12 md-col-12 sm-col-12 py2 px1 "},[_c('p',{staticClass:"font12 semi-bold darkblue mb0"},[_vm._v(_vm._s(_vm.moment(new Date(_vm.answerselected.UF_ANSWER_TIMESTAMP)).format('D MMMM YYYY')))]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold darkblue mb0"},[_vm._v("\""+_vm._s(_vm.answerselected.UF_ANSWER)+"\"")])])]):_vm._e()])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],_vm._v(" "),_c('div',{staticClass:"py4"})]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                        Alle anbefalinger\n                      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1052 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditvisitKort_vue__ = __webpack_require__(1054);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97349a44_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EditvisitKort_vue__ = __webpack_require__(1055);
function injectStyle (ssrContext) {
  __webpack_require__(1053)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditvisitKort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_97349a44_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_EditvisitKort_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1053 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1054 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haandvaerker__ = __webpack_require__(44);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kreditkort',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_0__haandvaerker__["a" /* default */]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      haaCredit: false,
      showimentor: true,
      showDismissibleAlert: false
    };
  },
  created: function created() {
    var _this = this;

    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true;
    }
    if (localStorage.getItem('haaid') === '0') {
      this.showimentor = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
      _this.haaCredit = res.haacredit;
    }, function (response) {
      alert('error');
    });
  }
});

/***/ }),
/* 1055 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 gibson darkblue semi-bold line-height-2 my2"},[_vm._v("Brug dine tilfredse kunder - til at tiltrække nye")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n            Klik ind her og se hvordan du let kan få reklame på din varevogn og lave dit eget personlige visitkort med dine anbefalinger på.\n          ")]),_vm._v(" "),(_vm.showimentor)?_c('button',{staticClass:"col-12 primary-button p2 flex justify-center items-center not-rounded border-none my3",attrs:{"target":"_blank","href":("http://www.kundematch.dk/newpartner/BrandCentral.php?id=" + _vm.salesPerson)}},[_c('span',{staticClass:"gibson regular h5 mb0"},[_vm._v("Streamers og visitkort")])]):_vm._e(),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('haandvaerker')],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n            Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n            Vi gemmer via Nets dine kreditkortoplysninger til betaling af fremtidige møder. Vi gemmer oplysningerne indtil kortet skiftes. Ønsker du i fremtiden at benytte en anden form for betaling, så kontakt os venligst på "),_c('a',{attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(".\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpireSubscription_vue__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340b77d5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ExpireSubscription_vue__ = __webpack_require__(1059);
function injectStyle (ssrContext) {
  __webpack_require__(1057)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpireSubscription_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_340b77d5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ExpireSubscription_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1057 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1058 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_rate_it__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kreditkort',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_3_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      haaId: '',
      retentionStatus: '',
      retentionTitle: '',
      retentionMessage: '',
      dismissSecs: 10,
      dismissCountDown: 0,
      selected: '',
      salesPerson: '',
      modalShowMail: false,
      isLoadingMail: false,
      textReason: '',
      startend: '',
      lytid: '',
      finishend: '',
      message: '',
      haaCredit: false,
      opsige: false,
      opsigeother: false,
      opsigetext: '',
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      showRetentionPopup: false,
      retentionModal: false,
      stats: [{
        TotalSearch: '',
        TotalProfileView: '',
        TotalContactView: '',
        TotalRatingInTimePeriod: '',
        TotalAllTimeRating: '',
        TotalJobCreated: '',
        TotalHtJob: '',
        TotalProfileSave: '',
        TotalProjectSave: '',
        TotalProjectClick: '',
        TotalProjectView: '',
        TotalPhoneView: '',
        TotalGalleryView: '',
        TotalCommentView: '',
        Shared: ''
      }]
    };
  },

  methods: {
    showRetentionModal: function showRetentionModal() {
      this.retentionModal = true;
    },
    countDownChanged: function countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown;
    },
    showAlert: function showAlert() {
      this.dismissCountDown = this.dismissSecs;
    },
    cancelLeadIntegrationTrial: function cancelLeadIntegrationTrial() {
      this.haaId = localStorage.getItem('haaid');
      var data = {
        partnerId: this.haaId
      };
      this.$http.POST('https://bitrixapi.haandvaerker.dk/v1/bitrix/cancelLeadIntegrationTrial', { data: data }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {}
      }, function (response) {
        console.log('error in loading all udbud');
      });
    },
    openUrl: function openUrl(url) {
      var win = window.open(url, '_blank');
      win.focus();
    },
    opsig: function opsig() {
      var _this = this;

      if (this.opsige || this.opsigeother) {
        var confirmFn = function confirmFn() {
          this.$router.push('/expire-subscription-form');
        };
        var obj = {
          title: 'Vi er kede af at sige farvel...',
          message: '<h5>Og vi håber naturligvis at se dig igen! For at kunne forbedre vores service, vil du blive stillet nogle spørgsmål, inden din opsigelse er gennemført.</h5>',
          type: 'error',
          customCloseBtnText: 'Fortryd',
          customCloseBtnClass: 'btn btn-outline-info',
          customConfirmBtnText: 'Opsig abonnement',
          customConfirmBtnClass: 'btn btn-outline-danger',
          useConfirmBtn: true,
          onConfirm: confirmFn
        };
        this.$refs.simplert.openSimplert(obj);
      } else {
        var _obj = {
          title: 'Opsig!',
          message: '<h5>' + this.opsigetext + '</h5>',
          type: 'warning',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(_obj);
        this.salesPerson = localStorage.getItem('id_token_portal');
        var data = { operation: 'aftaleexit_partner_profile', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          _this.cancelLeadIntegrationTrial();
          if (res.login === false) {
            _this.$router.push('/login');
          }
        }, function (response) {
          alert('error');
        });
      }
    },
    showMeetingDetailsAflysetext: function showMeetingDetailsAflysetext() {
      this.modalShowMail = true;
    },
    handleSubmitMail: function handleSubmitMail() {
      var _this2 = this;

      this.isLoadingMail = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'aftalemail_partner_profile', salesPerson: this.salesPerson, textReason: this.textReason };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowMail = false;
          var obj = {
            title: 'Vi kontakter dig snarest muligt!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.isLoadingMail = false;
          _this2.textReason = '';
        } else {
          alert(res.message);
          _this2.isLoadingMail = false;
        }
      }, function (response) {
        alert('error');
      });
    }
  },
  created: function created() {
    var _this3 = this;

    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true;
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this3.$router.push('/login');
      }
      _this3.opsige = res.opsige;
      _this3.opsigeother = res.opsigeother;
      _this3.opsigetext = res.opsigetext;
      if (res.startend !== '') {
        _this3.message = 'Dit abonnement er desværre i binding, du kan opsige dit abonnement i denne periode: Fra d. ' + res.startend + ' til ' + res.finishend;
      } else {
        _this3.message = 'Dit abonnement er desværre i binding, du kan opsige dit abonnement';
      }
      _this3.opsigedone = res.opsigedone;
      _this3.lytid = res.lytid;
    }, function (response) {
      alert('error');
    });
  },
  mounted: function mounted() {
    var _this4 = this;

    try {
      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('https://newcrm.kundematch.dk/bitrix/components/hvdk/webapi/bitrix.php?operation=getRetentionPopup').then(function (res) {
        if (res.data.success === true) {
          var results = res.data.data[0];
          _this4.retentionTitle = results.NAME;
          _this4.retentionMessage = results.PROPERTY_POPUP_TEXT_VALUE.TEXT;
          console.log(res.data.data[0].NAME);
        }
      }).catch(function () {
        console.log('Error');
      });
      var retId = localStorage.getItem('haaid');

      var date = new Date();

      var newEndDate = __WEBPACK_IMPORTED_MODULE_2_moment___default()(date.setDate(date.getDate() + 1)).format('YYYY-MM-DD');

      __WEBPACK_IMPORTED_MODULE_1_axios___default.a.get('http://webapi.haandvaerker.dk/v1/activity/GetSupplierLogByData2?supplierid=' + retId + '&startdate=2010-01-01&enddate=' + newEndDate).then(function (res) {
        _this4.stats = res.data;
      }).catch(function () {
        console.log('Error');
      });
    } catch (e) {}
    this.retentionModal = false;
  },

  watch: {
    haaid: function haaid(newHaaid) {
      localStorage.haaid = newHaaid;
    }
  }
});

/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 py3 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow"},[_vm._m(0),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"col-12 flex flex-column my3"},[_c('p',{staticClass:"h2 gibson hide semi-bold darkblue line-height-1"},[_vm._v("\n            Total Stats\n          ")]),_vm._v(" "),_c('div',{staticClass:"clearfix px0 flex flex-column pt1 pb3 white gibson"},[(_vm.stats.TotalSearch > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalSearch)+" Søgeresultater")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProfileView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(2),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalProfileView)+" Profil visninger")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalContactView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(3),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalContactView)+" Kontaktoplysninger vist")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalRatingInTimePeriod > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_c('div',{staticClass:"my1 flex justify-center"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.1,"item-size":24,"spacing":1,"show-rating":false,"rating":3.2,"read-only":true}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalRatingInTimePeriod)+" Nye anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalAllTimeRating > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_c('div',{staticClass:"my1 flex justify-center"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.1,"item-size":24,"spacing":1,"show-rating":false,"rating":_vm.stats.TotalAllTimeRating,"read-only":true}})],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalAllTimeRating)+" Total rating")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalJobCreated > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(4),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalJobCreated)+" Opgaver")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalHtJob > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(5),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalHtJob)+" Opgave(r) fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProfileSave > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(6),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalProfileSave)+" Profil gemt")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectSave > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(7),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalProjectSave)+" Projekter gemt")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectClick > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(8),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalProjectClick)+" Klik på dine projekter")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(9),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.TotalProjectView)+" Projekt visninger")])]):_vm._e(),_vm._v(" "),(_vm.stats.PhoneView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(10),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.PhoneView)+" project clicks")])]):_vm._e(),_vm._v(" "),(_vm.stats.GalleryView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(11),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.GalleryView)+" project clicks")])]):_vm._e(),_vm._v(" "),(_vm.stats.CommentView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(12),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.stats.CommentView)+" Anbefalinger læst")])]):_vm._e(),_vm._v(" "),(_vm.stats.Shared > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(13),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.Shared))]),_vm._v(" Profil-delinger")])]):_vm._e(),_vm._v(" "),(_vm.stats.RatingGradeText != null)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue py3 flex flex-column justify-center items-center"},[_vm._m(14),_vm._v(" "),_c('p',{staticClass:"h6 line-height-4 darkblue gibson"},[_vm._v(_vm._s(_vm.stats.RatingGradeText))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_c('h5',[_vm._v("Abonnement")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 px2 mb3"},[_c('button',{staticClass:"primary-button p2 gibson flex justify-center items-center border-none not-rounded h5 line-height-1 mb2",on:{"click":function($event){return _vm.openUrl('downloada.php?id='+_vm.salesPerson)}}},[_c('span',[_vm._v("Dit abonnement")]),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Download aftale her")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px2 mb3"},[_c('button',{staticClass:"outlined-action-button p2 gibson flex justify-center items-center not-rounded h5 lin-eheight-1 mb2",on:{"click":function($event){return _vm.showMeetingDetailsAflysetext()}}},[_c('span',[_vm._v("Løsninger")]),_vm._v(" "),_vm._m(16)]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Klik her og bliv kontaktet vedr. din løsning")])]),_vm._v(" "),(!_vm.opsigedone)?_c('div',{staticClass:"col-12 px2 mb3"},[_c('button',{staticClass:"outlined-delete-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2",staticStyle:{"border":"color:currentColor"},on:{"click":function($event){return _vm.opsig()}}},[_c('span',[_vm._v("Opsig")]),_vm._v(" "),_vm._m(17)])]):_vm._e(),_vm._v(" "),(_vm.opsigedone)?_c('div',{staticClass:"col-12 px2 mb3"},[_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Du har allerede opsagt din aftale")])]):_vm._e(),_vm._v(" "),(_vm.lytid !== '')?_c('div',{staticClass:"px2"},[_c('button',{staticClass:"outlined-disabled-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2",on:{"click":function($event){return _vm.openUrl('audio.php?id='+_vm.lytid)}}},[_c('span',[_vm._v("Download lydfilen")]),_vm._v(" "),_vm._m(18)])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix p2 py3 ml4"},[(_vm.retentionStatus = true)?_c('b-alert',{attrs:{"variant":"light","show":_vm.dismissCountDown,"fade":"","dismissible":""},on:{"dismissed":function($event){_vm.dismissCountDown=0},"dismiss-count-down":_vm.countDownChanged}},[_c('span',{staticClass:"px2",attrs:{"slot":"dismiss"},slot:"dismiss"},[_c('i',{staticClass:"darkblue el-icon-close"})]),_vm._v(" "),_c('div',{attrs:{"slot":"default"},slot:"default"},[_c('div',{staticClass:"clearfix white-background darkblue"},[_c('div',{staticClass:"py2"},[_c('h4',{staticClass:"h4 line-height-1 gibson"},[_vm._v(_vm._s(_vm.retentionTitle))]),_vm._v(" "),_c('p',[_vm._v("\n                  "+_vm._s(_vm.retentionMessage)+" "+_vm._s(_vm.dismissCountDown)+" seconds...\n                ")])])])])]):_vm._e(),_vm._v(" "),_vm._m(19),_vm._v(" "),(!_vm.showeMobile)?_c('div',{staticClass:"col-12 flex flex-column my3"},[_c('p',{staticClass:"h2 gibson semi-bold darkblue line-height-1"},[_vm._v("\n            Total Stats\n          ")]),_vm._v(" "),_c('div',{staticClass:"clearfix px0 flex flex-wrap pt1 pb3 white gibson"},[(_vm.stats.TotalSearch > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(20),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalSearch))]),_c('span',[_vm._v("Søgeresultater")])])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProfileView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(21),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalProfileView))]),_vm._v(" Profil visninger")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalContactView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(22),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalContactView))]),_vm._v("contact views")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalRatingInTimePeriod > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_c('div',{staticClass:"mt1 flex justify-center"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.1,"item-size":24,"spacing":1,"show-rating":false,"rating":3.2,"read-only":true}})],1),_vm._v(" "),_c('span',{staticClass:"block mt2"},[_c('span',[_vm._v(_vm._s(_vm.stats.TotalRatingInTimePeriod))]),_vm._v(" Nye anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalAllTimeRating > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_c('div',{staticClass:"mt1 flex justify-center"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.1,"item-size":24,"spacing":1,"show-rating":false,"rating":_vm.stats.TotalAllTimeRating,"read-only":true}})],1),_vm._v(" "),_c('span',{staticClass:"block mt2"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalAllTimeRating))]),_vm._v("Total rating")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalJobCreated > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(23),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalJobCreated))]),_vm._v("Opgaver")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalHtJob > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(24),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalHtJob))]),_vm._v("Opgave(r) fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProfileSave > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(25),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalProfileSave))]),_vm._v("Profil gemt")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectSave > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(26),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalProjectSave))]),_vm._v(" Projekter gemt")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectClick > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(27),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalProjectClick))]),_vm._v(" Klik på dine projekter")])]):_vm._e(),_vm._v(" "),(_vm.stats.TotalProjectView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(28),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.TotalProjectView))]),_vm._v(" Projekt visninger")])]):_vm._e(),_vm._v(" "),(_vm.stats.PhoneView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(29),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.PhoneView))]),_vm._v("project clicks")])]):_vm._e(),_vm._v(" "),(_vm.stats.GalleryView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(30),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.GalleryView))]),_vm._v("project clicks")])]):_vm._e(),_vm._v(" "),(_vm.stats.CommentView > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(31),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.CommentView))]),_vm._v(" Anbefalinger læst")])]):_vm._e(),_vm._v(" "),(_vm.stats.Shared > 0)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(32),_vm._v(" "),_c('span',{staticClass:"block"},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(_vm.stats.Shared))]),_vm._v(" Profil-delinger")])]):_vm._e(),_vm._v(" "),(_vm.stats.RatingGradeText != null)?_c('span',{staticClass:"h4 mr2 mb2 lightgrey-background darkblue px4 py3 flex flex-column justify-center items-center"},[_vm._m(33),_vm._v(" "),_c('p',{staticClass:"h6 line-height-4 darkblue gibson"},[_vm._v(_vm._s(_vm.stats.RatingGradeText))])]):_vm._e()])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlert},on:{"dismissed":function($event){_vm.showDismissibleAlert=false}}},[_c('h5',[_vm._v("Abonnement")])])],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"mr1 px2 mb3"},[_c('button',{staticClass:"primary-button p2 gibson flex justify-center items-center border-none not-rounded h5 line-height-1 mb2",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.openUrl('downloada.php?id='+_vm.salesPerson)}}},[_c('span',[_vm._v("Dit abonnement")]),_vm._v(" "),_vm._m(34)]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Download aftale her")])]),_vm._v(" "),_c('div',{staticClass:"mr1 px2 mb3"},[_c('button',{staticClass:"outlined-action-button p2 gibson flex justify-center items-center not-rounded h5 lin-eheight-1 mb2",on:{"click":function($event){return _vm.showMeetingDetailsAflysetext()}}},[_c('span',[_vm._v("Løsninger")]),_vm._v(" "),_vm._m(35)]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Klik her og bliv kontaktet vedr. din løsning")])]),_vm._v(" "),(!_vm.opsigedone)?_c('div',{staticClass:"mr1 px2 mb3"},[_c('button',{staticClass:"outlined-delete-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2",staticStyle:{"border":"color:currentColor"},on:{"click":function($event){return _vm.opsig()}}},[_c('span',[_vm._v("Opsig")]),_vm._v(" "),_vm._m(36)])]):_vm._e(),_vm._v(" "),(_vm.opsigedone)?_c('div',{staticClass:"mr1 px2 mb3"},[_c('p',{staticClass:"h6 darkblue regular gibson line-height-1 mb2"},[_vm._v("Du har allerede opsagt din aftale")])]):_vm._e(),_vm._v(" "),(_vm.lytid !== '')?_c('div',{staticClass:"mr1 px2"},[_c('button',{staticClass:"outlined-disabled-button p2 gibson flex justify-center items-center not-rounded h5 line-height-1 mb2",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.openUrl('audio.php?id='+_vm.lytid)}}},[_c('span',[_vm._v("Download lydfilen")]),_vm._v(" "),_vm._m(37)])]):_vm._e()])],1):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"py3"}),_vm._v(" "),(_vm.showMobile)?_c('div',[( _vm.retentionStatus = true)?_c('el-dialog',{attrs:{"width":"80%","show-close":false,"visible":_vm.retentionModal},on:{"update:visible":function($event){_vm.retentionModal=$event}}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 darkblue gibson",attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.retentionTitle))]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-4"},[_vm._v(_vm._s(_vm.retentionMessage))]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('button',{staticClass:"muted-button mx-auto flex justify-center items-center p2 gibson h5 line-height-1 regular",on:{"click":function($event){_vm.retentionModal = false}}},[_c('span',[_vm._v("Luk")])])])]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',[(_vm.retentionStatus = true )?_c('el-dialog',{attrs:{"width":"50%","show-close":false,"visible":_vm.retentionModal},on:{"update:visible":function($event){_vm.retentionModal=$event}}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 darkblue gibson",attrs:{"slot":"title"},slot:"title"},[_vm._v(_vm._s(_vm.retentionTitle))]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-4"},[_vm._v(_vm._s(_vm.retentionMessage))]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('button',{staticClass:"muted-button mx-auto flex justify-center items-center p2 gibson h5 line-height-1 regular",on:{"click":function($event){_vm.retentionModal = false}}},[_c('span',[_vm._v("Luk")])])])]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"modal",staticClass:"p-2 pb-4",attrs:{"id":"modalPrevent","hide-footer":"","title":"Løsninger"},model:{value:(_vm.modalShowMail),callback:function ($$v) {_vm.modalShowMail=$$v},expression:"modalShowMail"}},[_c('div',{staticClass:"line-height-golden text-dark open-sans h6 py-lg-2 py-md-2 py-sm-4"},[_vm._v("Klik her og bliv kontaktet vedr. din løsning")]),_vm._v(" "),_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitMail.apply(null, arguments)}}},[_c('b-form-row',[_c('b-col',{staticClass:"py-2 py-lg-2 py-md-2 py-sm-2"},[_c('b-form-textarea',{staticClass:"bg-light border-0",attrs:{"rows":6,"max-rows":9},model:{value:(_vm.textReason),callback:function ($$v) {_vm.textReason=$$v},expression:"textReason"}})],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"py-lg-2 py-md-2 py-sm-2"},[_c('b-button',{staticClass:"mt-3 mt-lg-3 mt-md-3 mt-sm-3 rounded float-right",attrs:{"variant":"info","type":"submit","disabled":_vm.isLoadingMail,"size":"lg"}},[_vm._v("Send")])],1)],1)],1)],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Dit abonnement")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n             Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{staticClass:"primarycolor semi-bold",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{staticClass:"primarycolor semi-bold",attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-data-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-data-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-collection"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-collection"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-thumb"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Dit abonnement")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n             Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{staticClass:"primarycolor semi-bold",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{staticClass:"primarycolor semi-bold",attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-data-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-data-line"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-collection"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-collection"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-thumb"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h1 green"},[_c('i',{staticClass:"el-icon-view"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpireSubscriptionForm_vue__ = __webpack_require__(1062);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156b0039_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ExpireSubscriptionForm_vue__ = __webpack_require__(1063);
function injectStyle (ssrContext) {
  __webpack_require__(1061)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ExpireSubscriptionForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_156b0039_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ExpireSubscriptionForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1062 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'kreditkort',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      enddate: '',
      show: false,
      label: 'Loading...',
      overlay: 1,
      haaCredit: false,
      Canexpire: true,
      showimentor: true,
      opsige: false,
      opsigeother: false,
      showDismissibleAlert: false,
      s1: [],
      s2: '',
      s3: '',
      s4: '',
      s5: '',
      s6: '',
      options: [{ text: 'Jeg har ikke brug for at få flere ordrer hjem lige nu.', value: 1 }, { text: 'Markedspladsen var for svær at bruge.', value: 2 }, { text: 'Jeg har ikke fået vist nok opgaver på markedspladsen.', value: 3 }, { text: 'For mange af mine møder blev aflyst før afholdelse.', value: 4 }, { text: 'Kunderne var generelt ikke interesserede i mine tilbud.', value: 5 }, { text: 'For få tilbud blev til ordrer.', value: 6 }, { text: 'Jeg havde en dårlig oplevelse med en medarbejder.', value: 7 }, { text: 'Månedsprisen er for høj.', value: 8 }, { text: 'Andre', value: 9 }],
      options2: [{ text: '1', value: 1 }, { text: '2', value: 2 }, { text: '3', value: 3 }, { text: '4', value: 4 }, { text: '5', value: 5 }, { text: '6', value: 6 }, { text: '7', value: 7 }, { text: '8', value: 8 }, { text: '9', value: 9 }, { text: '10', value: 10 }]
    };
  },

  methods: {
    onSubmitInformation: function onSubmitInformation(evt) {
      var _this = this;

      evt.preventDefault();
      if (this.s6.length < 25) {
        var obj = {
          title: 'Hov, du mangler at skrive grunden til din opsigelse.',
          message: '',
          type: 'warning'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'expire_partner_profile', salesPerson: this.salesPerson, levid: this.haaId, s1: this.s1, s2: this.s2, s3: this.s3, s4: this.s4, s5: this.s5, s6: this.s6, opsige: this.opsige, opsigeother: this.opsigeother };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;
          _this.showDismissibleAlert = true;
          _this.enddate = res.enddate;
          var _obj = {
            title: 'Gennemført! Sidste dag for samarbejdet er ' + _this.enddate,
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(_obj);
          _this.showDismissibleAlert = true;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  },
  created: function created() {
    var _this2 = this;

    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true;
    }
    if (localStorage.getItem('imentor') === '0') {
      this.showimentor = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this2.$router.push('/login');
      }
      if (!res.opsige && !res.opsigeother) {
        _this2.$router.push('/expire-subscription');
      }
      _this2.opsige = res.opsige;
      _this2.opsigeother = res.opsigeother;
      _this2.haaCredit = res.haacredit;
    }, function (response) {
      alert('error');
    });
  }
});

/***/ }),
/* 1063 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-success headericon"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Dit Abonnement")])])])])],1)],1),_vm._v(" "),(_vm.showDismissibleAlert)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showDismissibleAlert}},[_c('h5',[_vm._v("Dit abonnement er hermed opsagt. Vi håber naturligvis at du vil benytte vores service en anden gang. Sidste dag for samarbejdet er "+_vm._s(_vm.enddate)+"\n        ")])])],1),_vm._v(" "),_c('b-col',[_c('b-card',{staticClass:"pt-0 pr-2 pb-0 border-0",attrs:{"no-body":""}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"h6 pt-2 open-sans pb-0 line-height-golden"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"h6 p-3 open-sans line-height-golden"},[_vm._v("\n                  Har du spørgsmål eller brug for support, så ring meget gerne til kundeservice på "),_c('a',{staticClass:"font-weight-bold",attrs:{"href":"tel:+4570228014"}},[_vm._v("70 22 80 14")]),_vm._v(" eller skriv til "),_c('a',{staticClass:"font-weight-bold",attrs:{"href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk")]),_vm._v(".\n\n                ")])])])])])],1)],1):_vm._e(),_vm._v(" "),(!_vm.showDismissibleAlert)?_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"pt-0 pr-2 pb-0 border-0",attrs:{"no-body":""}},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"h6 pt-2 open-sans pb-0 line-height-golden"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"h6 p-4 open-sans line-height-golden"},[_c('b-form',{on:{"submit":_vm.onSubmitInformation}},[_c('fieldset',[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('b-form-group',{attrs:{"id":"desc","label":"Vi er utrolig ked af, at du ønsker at opsige dit abonnement hos os! Det vil være en stor hjælp for os, hvis du vil give en uddybende begrundelse for din opsigelse.","label-for":"desc"}},[_c('b-form-textarea',{attrs:{"id":"textarea2","placeholder":"Beskriv med minimum 25 karakterer...","rows":6},model:{value:(_vm.s6),callback:function ($$v) {_vm.s6=$$v},expression:"s6"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"text-center my-4",attrs:{"sm":"12","md":"6","lg":"6"}},[_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('b-btn',{staticClass:"mx-auto rounded font-weight-bold",attrs:{"size":"lg","variant":"danger","type":"submit"}},[_c('span',[_vm._v("Bekræft opsigelse")])])],1)],1)],1)])],1)])])])])],1)],1):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectLogin_vue__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1041eb8a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectLogin_vue__ = __webpack_require__(1067);
function injectStyle (ssrContext) {
  __webpack_require__(1065)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectLogin_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1041eb8a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectLogin_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1065 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__ = __webpack_require__(522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(195);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__ = __webpack_require__(524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProjectLogin',
  components: {},
  data: function data() {
    return {
      haaId: '',
      salesPerson: '',
      form: {
        username: '',
        password: '',
        rememberMe: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      defaultpackage: [],
      show: false,
      label: 'asas',
      overlay: 1,
      eligible: ''
    };
  },
  created: function created() {
    localStorage.removeItem('id_token_portal');
    localStorage.removeItem('id_token_portalbitrix');
    localStorage.removeItem('haaid');
    localStorage.removeItem('inbox');
    localStorage.removeItem('email');
    localStorage.removeItem('imentor');
    localStorage.removeItem('basic');
    localStorage.removeItem('onlycredit');
    localStorage.setItem('isEmailLoggedIn', false);
    localStorage.removeItem('emailAccountId');
    localStorage.removeItem('ClimatePartner');
    localStorage.removeItem('FBPostRecommendation');
    localStorage.removeItem('PartnerAccountingInteg');
    localStorage.removeItem('ExtraReservation');
    localStorage.removeItem('ExternalProWebsite');
    localStorage.removeItem('OfferCreator');
    localStorage.removeItem('PartnerloginMesterMesterReserve');
    localStorage.removeItem('PartnerLoginUdbudJobs');
    localStorage.removeItem('PartnerLoginMarketplaceReserve');
    localStorage.removeItem('PartnerloginMesterMesterPost');
    localStorage.removeItem('PartnerLoginMarketplaceViewer');
    localStorage.removeItem('PersonalPartnerLogin');
    localStorage.removeItem('AccessVideoProProfile');
    localStorage.removeItem('AccessDescriptionText');
    localStorage.removeItem('AccessDescriptionTextlimit');
    localStorage.removeItem('PartnerloginMesterMesterReserve-nummode');
    localStorage.removeItem('PartnerloginMesterMesterReserve-size');
    localStorage.removeItem('PartnerLoginMarketplaceReserve-nummode');
    localStorage.removeItem('PartnerLoginMarketplaceReserve-size');
    localStorage.removeItem('PartnerPackageHandle');
    localStorage.removeItem('showbadgewebshop');
    localStorage.removeItem('showAddendum');
    if (this.$route.query.email !== undefined) {
      this.form.username = this.$route.query.email;
      this.form.password = this.$route.query.accountnumber;
      setTimeout(function () {
        $('#formLogin').click();
      }, 500);
    }
    if (this.$route.query.demoreserve !== undefined) {
      localStorage.setItem('demoreserve', this.$route.query.demoreserve);
    } else {
      localStorage.removeItem('demoreserve');
    }
    localStorage.removeItem('fullName');
    localStorage.removeItem('rule');
    var cookieStorage = {
      getItem: function getItem(key) {
        var cookies = document.cookie.split(';').map(function (cookie) {
          return cookie.split('=');
        }).reduce(function (acc, _ref) {
          var _ref2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
              key = _ref2[0],
              value = _ref2[1];

          return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key.trim(), value));
        }, {});
        return cookies[key];
      },
      setItem: function setItem(key, value, expires) {
        document.cookie = key + '=' + value + '; ' + 'expires' + '=' + expires;
      }
    };
    if (this.$route.query.email === undefined) {
      if (cookieStorage.getItem('email') !== '') {
        this.form.username = cookieStorage.getItem('email');
      }
      if (cookieStorage.getItem('password') !== '') {
        this.form.password = cookieStorage.getItem('password');
      }
    }
    if (cookieStorage.getItem('remember')) {
      this.form.rememberMe = true;
    }
    sessionStorage.removeItem('email');
    sessionStorage.removeItem('password');
    this.getInitialPackageValue();
  },
  mounted: function mounted() {
    if (window.location.hostname !== 'oldpartner.haandvaerker.dk' && (window.location.href === 'https://www.kundematch.dk/newpartner/#/login' || window.location.href === 'http://www.kundematch.dk/newpartner/#/login' || window.location.href === 'https://kundematch.dk/newpartner/#/login' || window.location.href === 'http://kundematch.dk/newpartner/#/login')) {
      window.location.href = 'https://partner.haandvaerker.dk/#/login';
    }
  },

  methods: {
    rememberMe: function rememberMe() {
      var cookieStorage = {
        getItem: function getItem(key) {
          var cookies = document.cookie.split(';').map(function (cookie) {
            return cookie.split('=');
          }).reduce(function (acc, _ref3) {
            var _ref4 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_slicedToArray___default()(_ref3, 2),
                key = _ref4[0],
                value = _ref4[1];

            return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, acc, __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_defineProperty___default()({}, key.trim(), value));
          }, {});
          return cookies[key];
        },
        setItem: function setItem(key, value, expires) {
          document.cookie = key + '=' + value + '; ' + 'expires' + '=' + expires;
        }
      };

      var checkBox = document.getElementById('remember');
      if (checkBox.checked === true) {
        var date = new Date();
        var nextYear = date.getFullYear() + 1;
        var expiryDate = date.toGMTString().toString().replace(date.getFullYear(), nextYear);
        cookieStorage.setItem('email', this.form.username, expiryDate);
        cookieStorage.setItem('password', this.form.password, expiryDate);
        cookieStorage.setItem('remember', true, expiryDate);
      } else {
        cookieStorage.setItem('email', this.form.username, 'Thu, 01 Jan 1970 00:00:00 GMT');
        cookieStorage.setItem('password', this.form.password, 'Thu, 01 Jan 1970 00:00:00 GMT');
        cookieStorage.setItem('remember', true, 'Thu, 01 Jan 1970 00:00:00 GMT');
      }
    },
    decode: function decode(pid) {
      var _this = this;

      if (window.location.hostname !== 'oldpartner.haandvaerker.dk') {
        this.$http.get(this.$bitrixapi + 'helper/encode/' + pid, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var query = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, _this.$route.query);
            var allquery = '';
            __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(query).forEach(function (querys) {
              console.log('querys', querys);
              allquery += '&' + querys + '=' + query[querys];
            });
            window.location.href = 'https://partner.haandvaerker.dk/#/login?code=' + res.data + allquery;
          }
        }, function (response) {
          var error = response.body;
          _this.$message({
            type: 'error',
            message: error.message
          });
        });
      }
    },
    onSubmit: function onSubmit(evt) {
      var _this2 = this;

      if (window.location.hostname === 'oldpartner.haandvaerker.dk') {
        this.onSubmit_old(evt);
      } else {
        evt.preventDefault();
        this.show = true;
        document.getElementById('loginform').classList.add('hide');

        var bitrixapi = '';
        if (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/') {
          bitrixapi = 'bitrixapidev';
        } else if (this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/') {
          bitrixapi = 'bitrixapimaster';
        } else {
          bitrixapi = 'bitrixapi';
        }
        var data = { operation: 'auth', userName: this.form.username, password: this.form.password, bitrixapi: bitrixapi };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this2.show = true;
            localStorage.setItem('id_token_portalbitrix', res.bitrix.token);
            localStorage.setItem('id_token_portal', res.key_portal);
            _this2.haaId = res.haaid;
            _this2.salesPerson = res.key_portal;
            localStorage.setItem('haaid', res.haaid);
            _this2.rememberMe();
            _this2.decode(res.haaid);
          } else {
            _this2.show = false;
            _this2.form.errorMessage = 'Det er en fejl med dit brugernavn eller din adgangskode, prøv igen';
            document.getElementById('loginform').classList.remove('hide');
          }
        }, function (response) {
          alert('error');
        });
      }
    },
    onSubmit_old: function onSubmit_old(evt) {
      var _this3 = this;

      evt.preventDefault();
      this.show = true;

      var bitrixapi = '';
      if (this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/') {
        bitrixapi = 'bitrixapidev';
      } else if (this.$bitrixapi === 'https://bitrixapimaster.haandvaerker.dk/v1/') {
        bitrixapi = 'bitrixapimaster';
      } else {
        bitrixapi = 'bitrixapi';
      }
      var data = { operation: 'auth', userName: this.form.username, password: this.form.password, bitrixapi: bitrixapi };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.show = true;
          localStorage.setItem('id_token_portalbitrix', res.bitrix.token);
          localStorage.setItem('id_token_portal', res.key_portal);
          _this3.haaId = res.haaid;
          _this3.salesPerson = res.key_portal;
          localStorage.setItem('haaid', res.haaid);
          localStorage.setItem('basic', res.basic);
          localStorage.setItem('CompanyName', res.companyName);
          localStorage.setItem('inhouse', res.inhouse);
          localStorage.setItem('email', _this3.form.username);
          if (res.name === '') {
            localStorage.setItem('name', res.companyName);
          } else {
            localStorage.setItem('name', res.name);
          }
          _this3.rememberMe();
          localStorage.setItem('haa', res.haa);
          localStorage.setItem('onlycredit', res.onlycredit);
          localStorage.setItem('imentor', res.imentor);
          localStorage.setItem('inbox', res.inbox);
          if (res.firstlogin === 0 && res.imentor !== 0) {}
          localStorage.setItem('isadmin', res.isadmin);
          localStorage.setItem('isshop', res.isshop);
          localStorage.setItem('climate', res.climate);
          localStorage.setItem('showbadgewebshop', 'no');
          localStorage.setItem('permission', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(res.permission));
          _this3.checkBadges(res.haaid, res.bitrix.token, res);
          _this3.onlycredit = res.onlycredit;
        } else {
          _this3.show = false;
          _this3.form.errorMessage = 'Det er en fejl med dit brugernavn eller din adgangskode, prøv igen';
        }
      }, function (response) {
        alert('error');
      });
    },
    forgotPassword: function forgotPassword(evt) {
      this.$router.push('/glemte-password');
    },
    checkBadges: function checkBadges(id, token, res) {
      var _this4 = this;

      var data = {};
      this.$http.get(this.$bitrixapi + 'supplier/GetSupplierProfileById/' + id, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var prisen = res.data.c_prisen_result;
        localStorage.setItem('industryname', res.data.c_primary_industry.BUSINESS);
        if (res.data.b_crm_company.UF_CRM_COMPANY_AREA_TEXT) {
          localStorage.setItem('prisenRegion', res.data.b_crm_company.UF_CRM_COMPANY_AREA_TEXT.replace('Region', ''));
        } else {
          localStorage.setItem('prisenRegion', 'Syddanmark');
        }
        if (prisen && prisen.length > 0) {
          localStorage.setItem('showbadgewebshop', 'yes');
        } else {
          localStorage.setItem('showbadgewebshop', 'no');
        }
        localStorage.setItem('partnerPrimaryIndustryv2', res.data.c_primary_industry['BRANCH_ID']);
        localStorage.setItem('partnerPrimaryIndustryText', res.data.c_primary_industry['BUSINESS']);
        localStorage.setItem('address', res.data.b_crm_company.UF_CRM_COMPANY_ADDRESS);
        localStorage.setItem('city', res.data.b_crm_company.UF_CRM_COMPANY_CITY);

        var partnerpackage = res.data.supplier_package;
        _this4.getpackage(id, token, res, partnerpackage);
      }, function (err) {
        _this4.getpackage(id, token, res);
        console.log('Error in checkBadges()', err);
      });
    },
    gotoroute: function gotoroute(res) {
      if (this.$route.query.page === 'credit') {
        this.$router.push('/rediger-kreditkort-oplysninger');
      } else if (this.$route.query.page === 'creditfast') {
        this.$router.push('/rediger-kreditkort-oplysninger?credit=creditcall');
      } else if (this.$route.query.page === 'projekt-job') {
        this.$router.push('/opgaveinvitationer?proid=' + this.$route.query.proId);
      } else if (this.$route.query.page === 'editDescription') {
        this.$router.push('/confirm-description?token=' + this.$route.query.token);
      } else if (this.$route.query.page === 'mobilepay') {
        this.$router.push('/rediger-kreditkort-oplysninger?credit=mobilepaycall');
      } else if (this.$route.query.page === 'invitedirectcontract') {
        this.$router.push('/opgaveinvitationer?proid=' + this.$route.query.proId);
      } else if (this.$route.query.page === 'directcontract') {
        this.$router.push('/customer-projects/contract-main?contractId=' + this.$route.query.contractId);
      } else if (this.$route.query.page === 'directextrawork') {
        this.$router.push('/customer-projects/addon-liste?contractId=' + this.$route.query.contractId + '&projectId=' + this.$route.query.projectId);
      } else if (this.$route.query.page === 'password') {
        this.$router.push('/password');
      } else if (this.$route.query.page === 'market') {
        this.$router.push('/markedsplads?projectid=' + this.$route.query.projectid);
      } else if (this.$route.query.page === 'signup') {
        this.$router.push('/signup');
      } else if (this.$route.query.page === 'minekunder') {
        this.$router.push('/alle-moeder?projectID=' + this.$route.query.projectID + '&contactID=' + this.$route.query.contactID);
      } else if (this.$route.query.page === 'projectdashboard') {
        this.$router.push('/customer-projects/project-dashboard?fromLogin=1&projectId=' + this.$route.query.projectID + '&contracttype=Fagentreprise');
      } else if (this.$route.query.page === 'jule') {
        this.$router.push('/jule');
      } else if (this.$route.query.page === 'ekstraphone') {
        this.$router.push('/ekstraphone');
      } else if (this.$route.query.page === 'anbefalinger') {
        this.$router.push('/anbefalinger');
      } else if (this.$route.query.page === 'leverandoer') {
        this.$router.push('/leverandoerservice');
      } else if (this.$route.query.page === 'boostenanbefaling') {
        if (this.$route.query.cid !== undefined) {
          this.$router.push('/boost-en-anbefaling?reviewId=' + this.$route.query.reviewId);
        } else {
          this.$router.push('/boost-en-anbefaling');
        }
      } else if (this.$route.query.page === 'inbox') {
        if (this.$route.query.cid !== undefined) {
          this.$router.push('/inbox?cid=' + this.$route.query.cid);
        } else {
          this.$router.push('/inbox');
        }
      } else {
        if (res.onlycredit === 1) {
          this.$router.push('/rediger-kreditkort-oplysninger');
        } else {
          this.$router.push('/newsfeed');
        }
      }
    },
    getInitialPackageValue: function getInitialPackageValue() {
      this.defaultpackage[0] = 'ClimatePartner';
      this.defaultpackage[1] = 'FBPostRecommendation';
      this.defaultpackage[2] = 'PartnerAccountingInteg';
      this.defaultpackage[3] = 'ExtraReservation';
      this.defaultpackage[4] = 'ExternalProWebsite';
      this.defaultpackage[5] = 'OfferCreator';
      this.defaultpackage[6] = 'PartnerloginMesterMesterReserve';
      this.defaultpackage[7] = 'PartnerLoginUdbudJobs';
      this.defaultpackage[8] = 'PartnerLoginMarketplaceReserve';
      this.defaultpackage[9] = 'PartnerloginMesterMesterPost';
      this.defaultpackage[10] = 'PartnerLoginMarketplaceViewer';
      this.defaultpackage[11] = 'PersonalPartnerLogin';
      this.defaultpackage[12] = 'AccessVideoProProfile';
      this.defaultpackage[13] = 'AccessDescriptionText';
      this.defaultpackage.forEach(function (elementfeature) {
        localStorage.setItem(elementfeature, false);
      });
    },
    getpackage: function getpackage(id, token, res) {
      var _this5 = this;

      var partnerpackage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];

      var mainpackage = partnerpackage;
      var boughtfeature = [];
      var packagedataaddon = mainpackage.PACKAGE_ADDONS;
      var packagedatafeature = mainpackage.PACKAGE_FEATURES;
      var packagedatafeatureeach = mainpackage.ACTIVE;

      if (packagedatafeatureeach && packagedatafeature) {
        packagedatafeature.forEach(function (element) {
          boughtfeature.push(element.SHORT_CODE + '-' + element.LIMITATION);
          if (element.SHORT_CODE === 'partnerV2') {
            localStorage.setItem('showAddendum', true);
            localStorage.setItem('showAddendum', true);
          }
        });
        packagedataaddon.forEach(function (element2) {
          boughtfeature.push(element2.SHORT_CODE + '-' + element2.LIMITATION);
        });
        boughtfeature.forEach(function (elements) {
          var elementsname = elements.split('-')[0];
          var elementslimitations = elements.split('-')[1];
          if (_this5.defaultpackage.includes(elementsname)) {
            if (elementslimitations !== null && elementslimitations !== 'null') {
              localStorage.setItem(elementsname, true);
              localStorage.setItem(elementsname + 'limit', elementslimitations);
            } else {
              localStorage.setItem(elementsname, true);
            }
            if (localStorage.getItem('PartnerLoginMarketplaceReserve') || localStorage.getItem('PartnerloginMesterMesterReserve')) {
              localStorage.setItem('PartnerLoginMarketplaceViewer', true);
            }
            localStorage.setItem('PartnerloginMesterMesterReserve-nummode', res.data.nummode);
            localStorage.setItem('PartnerloginMesterMesterReserve-size', res.data.reserve_size);
            localStorage.setItem('PartnerLoginMarketplaceReserve-nummode', res.data.nummode);
            localStorage.setItem('PartnerLoginMarketplaceReserve-size', res.data.reserve_size);
            localStorage.setItem('PartnerPackageHandle', res.data.PACKAGE_HANDLE);
          }
        });
      }
      this.displayProjects(token);
      this.gotoroute(res);
    },
    displayProjects: function displayProjects(token) {
      var _this6 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + token
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projectInvitations', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data.length && res.data.length > 0) {
            localStorage.setItem('is_jobInvited', true);
          } else {
            localStorage.setItem('is_jobInvited', false);
          }
        } else {
          localStorage.setItem('is_jobInvited', false);
        }
      }, function (response) {
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
        localStorage.setItem('is_jobInvited', false);
      });
    }
  }
});

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"max-width-1 mx-auto mt4"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 relative"},[_c('div',{staticClass:"lightgrey-background",staticStyle:{"padding":"0.3rem"},attrs:{"id":"loginform"}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"border white-background mediumgrey-border py2 px2"},[_c('div',[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights",attrs:{"id":"email","type":"email","required":"","autocomplete":"username"},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('label',[_vm._v("Kodeord")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.password),expression:"form.password"}],staticClass:"h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights",attrs:{"id":"password","type":"password","required":"","autocomplete":"current-password"},domProps:{"value":(_vm.form.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "password", $event.target.value)}}})]),_vm._v(" "),_c('div',[(_vm.form.rememberMe)?_c('input',{attrs:{"type":"checkbox","id":"remember","name":"remember","checked":""}}):_c('input',{attrs:{"type":"checkbox","id":"remember","name":"remember"}}),_vm._v(" "),_c('label',[_vm._v("Husk mig")])]),_vm._v(" "),(_vm.form.errorMessage)?_c('div',{staticClass:"red muted-background p2 my3"},[_c('p',{staticClass:"h6 gibson line-height-golden"},[_vm._v(_vm._s(_vm.form.errorMessage))])]):_vm._e()]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"absolute overlay top-0 lef-0 right-0 bottom-0 col-12 height-full white-backgroud",staticStyle:{"background":"white","opacity":"70%"}},[_c('div',{staticClass:"loader"})]):_vm._e()])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"inline-block",attrs:{"src":"/static/svg/h.svg","alt":"","height":"36"}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson line-height-1 pl2 mb0"},[_vm._v("Håndværker.dk")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h3 mt3 mb1 gibson line-height-golden semi-bold darkblue"},[_vm._v("Log på din konto")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my2 lightgrey-background flex justify-between center items-center px2"},[_c('a',{staticClass:"h6 gibson primarycolor right-align",attrs:{"href":"#/glemte-password"}},[_vm._v("Har du brug for hjælp?")]),_vm._v(" "),_c('button',{staticClass:"h5 action-button p2 col-6 gibson border-none not-rounded",attrs:{"type":"submit","id":"formLogin"}},[_c('span',[_vm._v("Log ind")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaab600c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__ = __webpack_require__(1071);
function injectStyle (ssrContext) {
  __webpack_require__(1069)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Security_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eaab600c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Security_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1069 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Security',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a
  },
  data: function data() {
    return {
      form: {
        username: '',
        password: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      show: false,
      label: '',
      overlay: false
    };
  }
});

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn absolute top-0 right-0 bottom-0 left-0"},[_c('div',{staticClass:"max-width-1 mx-auto relative center-y"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 center"},[_c('div',{staticClass:"flex justify-start items-start mb3"},[_c('b-img',{staticClass:"flex-none mr2",attrs:{"src":"../static/svg/padlock.svg","alt":"","width":"32","height":"32"}}),_vm._v(" "),_c('p',{staticClass:"gibson line-height-2 left-align"},[_vm._v("\n            Sikkerhedsproblem. Du er allerede logget ind som en anden bruger.\n          ")])],1),_vm._v(" "),_c('a',{staticClass:"action-button mx-auto inline-block px2 py1 font-weight-bold",attrs:{"href":"#/login"}},[_vm._v("Login igen")])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invo_vue__ = __webpack_require__(1074);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c113680_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_invo_vue__ = __webpack_require__(1075);
function injectStyle (ssrContext) {
  __webpack_require__(1073)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c113680_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_invo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1073 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invo',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a
  },
  data: function data() {
    return {
      pid: '',
      levid: '',
      pitems: [],
      status: '',
      statuschange: false,
      loading: false,
      statusarr: [],
      disablecheckbox: false,
      shownodata: false,
      stoploading: false,
      partnername: ''
    };
  },
  created: function created() {
    var pathArray = window.location.href.split('/');
    this.pid = pathArray[pathArray.length - 1];

    if (this.pid !== null) {
      this.getinfo(this.pid);
    }
  },

  methods: {
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    closepopuperror: function closepopuperror() {
      this.$refs['incorrecturl'].hide();
    },
    openconfirmchange: function openconfirmchange() {
      this.$refs['statuschange'].show();
    },
    closeconfirmchange: function closeconfirmchange() {
      this.$refs['statuschange'].hide();
    },
    decode: function decode() {
      var _this = this;

      this.$http.get(this.$bitrixapi + 'integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data === '') {
          _this.showpopuperror();
        }
        if (res.success) {
          _this.levid = res.data;
          _this.getinfo(_this.levid);
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    changestatus: function changestatus(item) {
      var _this2 = this;

      this.stoploading = true;
      this.disablecheckbox = true;
      var iditem = item.ID;
      if (item.IS_SEND_EMAIL === 1) {
        this.status = 0;
      } else {
        this.status = 1;
      }
      var data = {
        IS_SEND_EMAIL: this.status
      };
      this.$http.post(this.$bitrixapi + 'integration/udpateSupplierIntegrationInformation/' + iditem, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.$message({
            type: 'success',
            message: 'Succes med at ændre status'
          });
        }
        _this2.getinfo();
      }, function (response) {
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
        _this2.disablecheckbox = false;
        console.log('Error: ', response);
      });
    },
    getinfo: function getinfo() {
      var _this3 = this;

      if (!this.stoploading) {
        this.loading = true;
      }
      this.$http.get(this.$bitrixapi + 'integration/getSupplierIntegrationInformation/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.pitems = res.data.results;
          if (res.data.length < 1) {
            _this3.shownodata = true;
          }
          _this3.disablecheckbox = false;
          _this3.partnername = res.data.title;
          _this3.loading = false;
        } else {
          _this3.disablecheckbox = false;
        }
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn absolute top-0 right-0 bottom-0 left-0",attrs:{"id":"invomain"}},[_c('div',{staticClass:"center m2"},[_c('p',{staticClass:"darkblue h4 semi-bold my2 m0 p0"},[_vm._v(_vm._s(_vm.partnername))]),_vm._v(" "),_c('p',{staticClass:"p0 m0"},[_vm._v("Hermed liste over kunder der automatisk inviteres til at give din en anbefaling.")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(1)]):_c('div',{staticClass:"max-width-3 flex flex-column mx-auto justify-start items-center"},_vm._l((_vm.pitems),function(item,index){return _c('div',{key:index,staticClass:"flex mx-start p1 darkblue-background white regular h5 invoitem "},[_c('b-form-checkbox',{staticClass:"gibson darkblue",attrs:{"id":'checkbox-'+item.GUID,"name":'checkbox-'+item.GUID,"checked":item.IS_SEND_EMAIL === 1,"disabled":_vm.disablecheckbox,"unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changestatus(item)}}}),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v(_vm._s(item.NAME))])],1)}),0),_vm._v(" "),(_vm.shownodata)?_c('div',{staticClass:"max-width-3 flex flex-column mx-auto center justify-start items-center mt4"},[_c('p',{staticClass:"semi-bold"},[_vm._v("Ingen registreringer fundet ...")])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"statuschange",attrs:{"centered":"","hide-header":"","id":"statuschange"},model:{value:(_vm.statuschange),callback:function ($$v) {_vm.statuschange=$$v},expression:"statuschange"}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"white-button no-border not-rounded  ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmchange()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-circle-close"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.104","height":"122.269","viewBox":"0 0 92.104 122.269"}},[_c('g',{attrs:{"id":"Group_4292","data-name":"Group 4292","transform":"translate(-1901.896 -1841.384)"}},[_c('path',{attrs:{"id":"Path_2691","data-name":"Path 2691","d":"M2050.619,2063.713,2038,2057.206a.61.61,0,0,0-.2-.2c-.106-.06-10.945-6.476-13.783-15.262a131.483,131.483,0,0,0-8.62-20.592c.785-1.812,5.4-12.47,6.642-15.655,1.9-4.891.106-7.171-.83-7.971,3.533-7.186,3.08-8.831,2.159-9.466a1.467,1.467,0,0,0-1.132-.2c-.015,0-.03.015-.06.015a3.884,3.884,0,0,0-1.132-2.989,3.2,3.2,0,0,0-3.261-.2,3.64,3.64,0,0,0-1,.709,7.469,7.469,0,0,0-3.97-.74c-.528.015-2.144.076-8.711,8.348-2.627,3.306-5.133,6.793-6.114,8.348-.906-.951-1.464-1.555-1.495-1.585a.618.618,0,0,0-.725-.121c-.121.06-2.536,1.344-3.155,3.14a8.657,8.657,0,0,0-1.676-.921,1.091,1.091,0,0,0-1.117.121c-.377.272-.83.921-.709,3.276a3.489,3.489,0,0,0-1.193.06,3.189,3.189,0,0,0-1.374.694c-.121-.936-.272-1.812-.423-2.551-.679-3.216-3.412-4.967-7.5-4.8h-.091a.643.643,0,0,0-.468.211c-.317.362-.423.468,1.072,13.421.287,2.551.574,4.952.755,6.7.438,4.2,3.336,9.616,5.072,12.862a24.986,24.986,0,0,1,1.313,2.627c-.091.694-1.691,4.514-4.74,11.368-.242.528-.393.876-.468,1.072l-12.168,6.793a.654.654,0,0,0-.3.392.6.6,0,0,0,.091.483l14.719,20.788a.64.64,0,0,0,.468.257h.03a.566.566,0,0,0,.453-.211l10.628-12.319a.6.6,0,0,0,0-.785l-.06-.061,1.026-.785c.2.2.393.377.589.574,4.333,4.061,8.952,6.854,12.7,7.669,7.548,1.661,16.742,6.386,16.833,6.431a.594.594,0,0,0,.272.06c.06,0,.106-.015.151-.015l10.19,8.832Zm-29.695-58.65c-.876,2.234-3.412,8.167-5.118,12.122a.189.189,0,0,0-.091-.166c-.166-.106-.332-.2-.5-.3-.2-.121-.393-.242-.6-.362a2.474,2.474,0,0,1-.483-.408,2.742,2.742,0,0,0-.483-.438.2.2,0,1,0-.211.332,2.337,2.337,0,0,1,.408.362,2.626,2.626,0,0,0,.574.483l.589.362c.166.106.332.211.513.317a.218.218,0,0,0,.106.03.244.244,0,0,0,.136-.045c-.438,1-.8,1.857-1.072,2.491a19.218,19.218,0,0,0-2.355-3.321c-.3-.317-.694-.725-1.147-1.208,1.162-1.9,6.22-10.19,9.5-16.636C2021.347,1999.4,2022.4,2001.259,2020.924,2005.063Zm1.57-16c.045-.015.151-.03.181,0,.045.03,1.026.83-2.883,8.6-2.566,5.1-6.386,11.564-8.454,14.991a2.052,2.052,0,0,1-1.087-1.253.205.205,0,1,0-.408.045,2.438,2.438,0,0,0,1.283,1.555c-.347.574-.634,1.042-.845,1.374-1.042-1.1-2.295-2.431-3.623-3.834,4.574-7.775,11.836-18.9,15.081-21.12a.573.573,0,0,0,.2-.136A3.094,3.094,0,0,1,2022.494,1989.061Zm-4.3-3.231q1.427-.521,2.083,0c.679.558.725,1.947.664,2.687-1.359,1-3.91,3.668-8.816,11.036-2.823,4.242-5.374,8.469-6.341,10.084-1.4-1.479-2.838-3-4.151-4.393,5.978-7.654,12.651-15.761,15.413-18.478a.9.9,0,0,0,.226-.136.574.574,0,0,0,.136-.2A3.554,3.554,0,0,1,2018.192,1985.83Zm-13.119,7.926c5.9-7.443,7.518-7.865,7.79-7.88a7.254,7.254,0,0,1,2.989.423c-3.4,3.427-9.8,11.4-13.36,15.912a4.189,4.189,0,0,1-.408-.317,2.976,2.976,0,0,0-.634-.438.212.212,0,0,0-.211.03.187.187,0,0,0-.06.211c.045.151.091.3.151.468a.858.858,0,0,0,.06.181,2.289,2.289,0,0,1-.815-1.072.2.2,0,1,0-.392.03c.045.6,1.027,1.495,1.479,1.691a.136.136,0,0,0,.075.015.244.244,0,0,0,.136-.045.189.189,0,0,0,.06-.2c-.045-.211-.121-.408-.181-.619a.4.4,0,0,0,.091.075c.136.106.272.226.423.332-.574.725-1.057,1.344-1.434,1.827-.71-.755-1.374-1.464-1.963-2.083A99.467,99.467,0,0,1,2005.073,1993.756Zm-9.118,7.2c.347.362.951,1.011,1.736,1.842h0c.181.181.362.392.558.589a2.78,2.78,0,0,1-2.174,2.234q-1.291-1.2-2.355-2.038C1993.735,2002.557,1995.094,2001.485,1995.955,2000.957Zm-5.42,2.053a9.586,9.586,0,0,1,2.023,1.223.581.581,0,0,0,.528.407c.423.332.891.74,1.4,1.193a1.529,1.529,0,0,1-.106.619,2.345,2.345,0,0,1-1.042,1.147l-.015-.015a10.021,10.021,0,0,0-2.974-1.993A5.953,5.953,0,0,1,1990.535,2003.01Zm-2.31,3.5a2.809,2.809,0,0,1,1.389.106h.015a7.859,7.859,0,0,1,2.6,1.6,4.558,4.558,0,0,1-.362,2.853,3.41,3.41,0,0,1-1.963,1.57c-1.359-1.057-2.37-1.842-2.808-2.159,0-.076-.015-.136-.015-.211-.091-.891-.2-1.766-.287-2.612A2.2,2.2,0,0,1,1988.225,2006.512Zm-.951,5.616c.453.347,1.027.785,1.676,1.3a4.787,4.787,0,0,1-1.193,2.476C1987.576,2014.725,1987.425,2013.427,1987.274,2012.128Zm-8.167-12.258a10,10,0,0,1,1.721.136c.242,1.706.845,6.869-.5,8.469a1.609,1.609,0,0,1-.347.3C1979.545,2005,1979.137,2001.168,1979.107,1999.87Zm15.051,61.458-11.911-14.085c.106-.226.242-.543.408-.906,2.31-5.193,3.578-8.137,4.227-9.828.151.468.332.921.5,1.374l.106.272a.215.215,0,0,0,.2.136.137.137,0,0,0,.075-.015.208.208,0,0,0,.121-.257l-.106-.272c-.226-.589-.453-1.208-.649-1.842.151-.423.257-.74.317-.966.151.151.3.317.468.483a3.869,3.869,0,0,0,1.6,1.238c.015,0,.045.015.06.015a.215.215,0,0,0,.2-.136.21.21,0,0,0-.136-.257,3.415,3.415,0,0,1-1.419-1.117,7.37,7.37,0,0,0-.679-.694c0-.453-.377-1.177-1.449-3.185-1.691-3.155-4.514-8.439-4.937-12.409-.181-1.751-.453-4.167-.755-6.718-.106-.936-.226-1.947-.347-2.974a1.6,1.6,0,0,0,.6-.468c1.419-1.691.876-6.748.6-8.635a4.57,4.57,0,0,1,3.729,3.638c.362,1.706.619,4.121.891,6.673.528,4.876,1.011,9.465,2.325,10.99l.091.091a31.6,31.6,0,0,1,9.163,13.1,97.053,97.053,0,0,1,4,17.376l-8.152-8.273a.634.634,0,0,0-.211-.136c-.408-.151-4.046-1.449-5.737.272-1.042,1.057-1.042,2.944.015,5.616a35.774,35.774,0,0,0,7.745,11.187Zm.74-11.141a5.22,5.22,0,0,1-3.518,1.766,2.867,2.867,0,0,1-2.023-1.1c-.317-.634-.619-1.268-.86-1.887-.845-2.144-.951-3.638-.287-4.318.936-.951,3.336-.377,4.318-.03l3.08,3.125A3.758,3.758,0,0,1,1994.9,2050.187Zm1.63,10.145c-.015-.015-.015-.03-.03-.03a.429.429,0,0,0-.151-.136,39.544,39.544,0,0,1-6.476-8.3,2.451,2.451,0,0,0,1.389.528.618.618,0,0,0,.166-.015,5.7,5.7,0,0,0,3.789-1.932,3.966,3.966,0,0,0,.8-2.28l5.842,5.948a.6.6,0,0,0,.6.151c.242.377.453.74.649,1.117.091.181.166.377.257.574a2.84,2.84,0,0,0,.981,1.449.279.279,0,0,0,.106.03.19.19,0,0,0,.166-.091.194.194,0,0,0-.06-.272,2.314,2.314,0,0,1-.815-1.253,3.667,3.667,0,0,0-.272-.6,11.614,11.614,0,0,0-.679-1.163.683.683,0,0,0,.106-.423c0-.015-.015-.121-.045-.332a4.011,4.011,0,0,0,1.147,1.223.279.279,0,0,0,.106.03.174.174,0,0,0,.166-.091.194.194,0,0,0-.06-.272,3.964,3.964,0,0,1-1.072-1.162,6.52,6.52,0,0,0-.408-.559,99.352,99.352,0,0,0-4.151-18.267,32.383,32.383,0,0,0-9.511-13.617,11.165,11.165,0,0,1-1.253-4.2,4.553,4.553,0,0,0,1.479-2.642c4.453,3.517,12.288,10.039,14.3,13.843,2.823,5.359,3.17,8.545,3.17,8.575a.6.6,0,0,0,.6.543h.06a.609.609,0,0,0,.544-.664c-.015-.136-.347-3.427-3.306-9.028-2.1-3.97-9.843-10.462-14.4-14.055a3.7,3.7,0,0,0,1.947-1.676,4.658,4.658,0,0,0,.453-2.627c5.254,4.831,16.727,18.252,17.708,20.229a6.048,6.048,0,0,1,.725,3.4.6.6,0,0,0,.483.71c.045,0,.075.015.121.015a.585.585,0,0,0,.589-.5,7.05,7.05,0,0,0-.83-4.167c-1.132-2.28-12.59-15.564-17.8-20.41a2.606,2.606,0,0,0,1.117-1.3,4.045,4.045,0,0,0,.106-.408c3.276,3.019,8.3,8.56,15.957,18.463a2.615,2.615,0,0,1-.8.574.2.2,0,0,0-.136.257.209.209,0,0,0,.2.151.114.114,0,0,0,.06-.015,2.612,2.612,0,0,0,.951-.649c.181.242.362.468.543.71.332.438.589.755.725.936a.613.613,0,0,0,.966-.755c-.136-.181-.377-.483-.71-.921-6.778-8.816-12.2-15.172-16.2-18.991a3.125,3.125,0,0,0,2.159-2.219c3.925,4.167,10.628,11.277,12.862,13.617a21.308,21.308,0,0,1,2.748,4.046.61.61,0,0,0,.075.136,129.98,129.98,0,0,1,8.62,20.592c2.642,8.182,11.5,14.176,13.8,15.61l-10.507,17.074c-2.053-1.011-9.949-4.816-16.636-6.28C2005.556,2067.653,2000.68,2064.407,1996.528,2060.331Z","transform":"translate(-56.619 -121.392)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2692","data-name":"Path 2692","d":"M2176.331,2287.492a.2.2,0,0,0-.136-.377,3.274,3.274,0,0,0-1.042.8c-.362.362-.755.725-1.057.74a.2.2,0,0,0-.2.211.2.2,0,0,0,.2.2h.015c.453-.015.891-.438,1.328-.861A3.21,3.21,0,0,1,2176.331,2287.492Z","transform":"translate(-230.941 -378.428)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2693","data-name":"Path 2693","d":"M2179.4,2292.582a6.457,6.457,0,0,1-1.812,1.3.21.21,0,0,0-.136.257.2.2,0,0,0,.2.136.09.09,0,0,0,.06-.015,7.324,7.324,0,0,0,1.962-1.389.21.21,0,0,0,0-.287A.19.19,0,0,0,2179.4,2292.582Z","transform":"translate(-233.954 -383.035)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2694","data-name":"Path 2694","d":"M2221.841,2273.778a3.733,3.733,0,0,0-1.434.921.2.2,0,0,0,.271.3c.091-.091.181-.166.272-.242a1.458,1.458,0,0,0-.272.5.229.229,0,0,0,.045.2.194.194,0,0,0,.151.06h.045a2.066,2.066,0,0,0,.906-.513.2.2,0,0,0,.015-.287.206.206,0,0,0-.257-.045,2.361,2.361,0,0,0,.483-.6.21.21,0,0,0-.015-.211A.234.234,0,0,0,2221.841,2273.778Z","transform":"translate(-270.368 -367.115)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2695","data-name":"Path 2695","d":"M2248.8,2223.215a.2.2,0,0,0-.317-.257c-.347.438-1.268,1.313-1.615,1.344a.2.2,0,0,0-.181.211.2.2,0,0,0,.2.181h.015C2247.476,2224.649,2248.548,2223.532,2248.8,2223.215Z","transform":"translate(-292.742 -323.904)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2696","data-name":"Path 2696","d":"M2254.658,2226.084a6.774,6.774,0,0,0-.679.619,4.453,4.453,0,0,1-.921.77.217.217,0,0,0-.075.272.208.208,0,0,0,.166.091.279.279,0,0,0,.106-.03,5.385,5.385,0,0,0,1-.83,6.167,6.167,0,0,1,.649-.589.2.2,0,0,0,.03-.287A.226.226,0,0,0,2254.658,2226.084Z","transform":"translate(-298.068 -326.591)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2697","data-name":"Path 2697","d":"M2149.733,2444.678l.181-.166a.191.191,0,0,0,.015-.272.214.214,0,0,0-.257-.061,4.307,4.307,0,0,0-.845.725l-.287.287a3.361,3.361,0,0,1-1.1.574.2.2,0,0,0-.151.227.194.194,0,0,0,.2.166h.015a1.974,1.974,0,0,0,1.3-.664A9.273,9.273,0,0,0,2149.733,2444.678Z","transform":"translate(-208.344 -511.777)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2698","data-name":"Path 2698","d":"M2159.032,2452.257a2.59,2.59,0,0,1-1.736.875h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.211.2,2.981,2.981,0,0,0,2.023-1.011.21.21,0,0,0,0-.287A.272.272,0,0,0,2159.032,2452.257Z","transform":"translate(-216.677 -518.601)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2699","data-name":"Path 2699","d":"M2204.882,2119.6a7.162,7.162,0,0,1-2.778-2.566l-.076-.091a.205.205,0,1,0-.332.241l.075.091a7.585,7.585,0,0,0,2.929,2.687.191.191,0,0,0,.091.015.2.2,0,0,0,.181-.121A.176.176,0,0,0,2204.882,2119.6Z","transform":"translate(-254.51 -233.889)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2700","data-name":"Path 2700","d":"M2215.895,2123.347c-.075-.045-.136-.106-.211-.151a.205.205,0,0,0-.241.332,2.556,2.556,0,0,0,.211.151,4.854,4.854,0,0,1,.725.574.193.193,0,0,0,.151.06.245.245,0,0,0,.136-.045.21.21,0,0,0,.015-.287A4.807,4.807,0,0,0,2215.895,2123.347Z","transform":"translate(-266.142 -239.238)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2701","data-name":"Path 2701","d":"M1915.015,2106.408a.6.6,0,0,0,.03-1.208l-12.515-.6a.6.6,0,1,0-.06,1.208l12.515.6Z","transform":"translate(0 -223.476)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2702","data-name":"Path 2702","d":"M1981.406,2006.613l4.635,3.442a.651.651,0,0,0,.362.121.63.63,0,0,0,.483-.241.616.616,0,0,0-.121-.845l-4.635-3.442a.616.616,0,0,0-.845.121A.589.589,0,0,0,1981.406,2006.613Z","transform":"translate(-67.296 -139.366)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2703","data-name":"Path 2703","d":"M2070.719,1955.211a.6.6,0,0,0,.543.332.592.592,0,0,0,.272-.06.605.605,0,0,0,.272-.815l-4.484-8.862a.608.608,0,1,0-1.087.543Z","transform":"translate(-139.474 -88.372)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2704","data-name":"Path 2704","d":"M2170.788,1904h.045a.6.6,0,0,0,.558-.649l-.5-7.609a.59.59,0,0,0-.649-.559.6.6,0,0,0-.559.649l.5,7.609A.6.6,0,0,0,2170.788,1904Z","transform":"translate(-227.361 -45.678)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2705","data-name":"Path 2705","d":"M2295.645,1854.52h.045a.608.608,0,0,0,.6-.558l.966-11.926a.606.606,0,1,0-1.208-.091l-.966,11.926A.607.607,0,0,0,2295.645,1854.52Z","transform":"translate(-333.831)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2706","data-name":"Path 2706","d":"M2379.719,1937a.6.6,0,0,0,.423-.181l4.227-4.182a.608.608,0,0,0-.86-.86l-4.227,4.182a.6.6,0,0,0,0,.86A.63.63,0,0,0,2379.719,1937Z","transform":"translate(-405.163 -76.597)","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Skift Succes")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Hvis du har spørgsmål er du velkommen til at kontakte os.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])],2),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"p0 m0"},[_vm._v("VIGTIGT: Hvis du ikke ønsker, at sende en invitation, skal du fjerne fluebenet. "),_c('br'),_vm._v(" PS: Vi gemmer automatisk ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_package_vue__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a1f5d8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_package_vue__ = __webpack_require__(1079);
function injectStyle (ssrContext) {
  __webpack_require__(1077)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_package_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d4a1f5d8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_package_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1077 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'package',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a
  },
  data: function data() {
    return {
      mainalldatetimeweek: [],
      loading: false,
      loadingnext: false,
      loadingaddbook: false,
      blockidzigna: '',
      pid: '',
      allpackage: [],
      orderid: '',
      pitems: [],
      status: '',
      haaid: '',
      levid: '',
      partnerprofile: [],
      Adresse: '',
      Bygningsnr: '',
      partnername: '',
      zip: '',
      city: '',
      road: '',
      datebooking: '',
      step: 1,
      selecteddate: '',
      selectedtimestart: '',
      selectedtimeend: '',
      options: [],
      Searchvalue: '',
      optiontimes: [],
      optiondate: [],
      highlighted: {
        dates: []
      },
      showallinfo: true,
      fullurl: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      showwrongdate: false,
      showwrongtime: false,
      timearrayperdate: [],
      alldatetime: [],
      prol: [],
      weenew: [],
      selectedimeslot: '',
      disablecreateorder: false,
      timeout: null,
      description: '',
      waitfortext: true,
      productdetails: false,
      productname: '',
      price: '',
      photourl: '',
      priceformatted: '',
      showreminder: false,
      dunninginvoice: [],
      perndinginvoice: [],
      showsessionnewcreditpro: '',
      willcallyou: false,
      reviewId: '',
      productdesc: '',
      paymenthod: '',
      packagetype: ''
    };
  },
  created: function created() {
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    this.originalid = localStorage.getItem('yourid');
    this.pid = pathArray[pathArray.length - 1];
    if (this.pid !== null) {
      if (this.pid.split('-')[1]) {
        this.getPhotoPackageByIdonly(this.pid.split('-')[0]);
      } else {
        this.decode(this.pid);
      }
    }
  },
  mounted: function mounted() {
    if (typeof document.querySelector('.smartbanner') !== 'undefined') {
      setTimeout(function () {
        var hideinfo = document.querySelector('.smartbanner');
        hideinfo.style.display = 'none';
        document.getElementById('partnerloginapp').style.marginTop = 0;
      }, 3000);
    }
  },

  watch: {},
  methods: {
    showconfirmbooking: function showconfirmbooking(item, date) {
      this.selectedimeslot = item.title;
      this.selectedtimestart = item.start + ':00';
      this.selectedtimeend = item.end + ':00';
      this.selecteddate = date;
      this.$refs['confirmbooking'].show();
    },
    closeconfirmbooking: function closeconfirmbooking() {
      this.$refs['confirmbooking'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    closepopuperror: function closepopuperror() {
      this.$refs['incorrecturl'].hide();
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopup: function showpopup() {
      this.$refs['packageorder'].show();
    },
    closepopup: function closepopup() {
      this.$refs['packageorder'].hide();
    },
    showmodal: function showmodal() {
      this.$refs.paymentmethods.show();
    },
    showmodalinitial: function showmodalinitial() {
      this.$refs.initialreminder.show();
    },
    hidemodal: function hidemodal() {
      this.$refs.paymentmethods.hide();
    },
    hidemodalinitial: function hidemodalinitial() {
      this.updateprofileskip();
      this.$refs.initialreminder.hide();
    },
    hidemodalsuccess: function hidemodalsuccess() {
      this.$refs.sendingsuccess.hide();
    },
    nextstep: function nextstep() {
      this.step = this.step + 1;
      if (this.step === 1) {
        document.getElementById('formpackage').classList.remove('hide');
        document.getElementById('packageformdate').classList.add('hide');
      }
      if (this.step === 2) {
        document.getElementById('formpackage').classList.add('hide');
        document.getElementById('packageform').classList.remove('hide');
      }
      if (this.step === 3) {
        document.getElementById('packageform').classList.add('hide');
        document.getElementById('packageformdate').classList.remove('hide');
      }
    },
    focused: function focused() {
      window.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
        }
      });
    },
    callustask: function callustask() {
      var data = {
        partnerId: this.levid,
        photoPackageId: this.blockidzigna
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/createBitrixTask', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {}
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getaddress: function getaddress() {
      var qry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cb = arguments[1];

      var vm = this;
      if (qry !== '' && qry.length < 15) {
        var selettion = [];
        this.focused();
        this.Searchvalue = qry;
        this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bbr/getBbr?q=' + qry, { emulateJSON: true }).then(function (response) {
          if (response.data.success) {
            vm.addressResults = response.data.data;
            vm.addressResults.forEach(function (item) {
              var sample = [];
              sample['value'] = item.tekst;
              selettion.push(sample);
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(selettion);
      }, 1000 * Math.random());
    },
    getaddressinfo: function getaddressinfo(item) {
      var _this = this;

      this.disablecreateorder = true;
      this.Adresse = item.value;
      var addre = this.Adresse;
      if (addre.length < 15) {
        this.city = '';
        this.zip = '';
        this.road = '';
        this.Bygningsnr = '';
        return false;
      }
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bbr/getBbr?q=' + addre, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this.city = response.data.data[0]['adresse']['postnrnavn'];
          _this.zip = response.data.data[0]['adresse']['postnr'];
          _this.road = response.data.data[0]['adresse']['vejnavn'];
          _this.Bygningsnr = response.data.data[0]['adresse']['husnr'];
          _this.disablecreateorder = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    supplierprofile: function supplierprofile(id) {
      var _this2 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/supplier/getSupplierInfo/' + id, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.partnerprofile = res.data;
          _this2.partnertelephone = res.data.MOBILE;
          _this2.partnername = res.data.UF_CRM_COMPANY_CONTACT_PERSON;
          if (_this2.partnername === null) {
            _this2.partnername = res.data.TITLE;
          }
          _this2.partneremail = res.data.EMAIL;
          _this2.getPhotoPackageById();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getPhotoPackageByIdonly: function getPhotoPackageByIdonly(id) {
      var _this3 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/zigna/getPhotoPackageById/' + id, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this3.productname = response.data.data['NAME'];
          var formatter = new Intl.NumberFormat('da-DK', {
            style: 'currency',
            currency: 'DKK',
            minimumFractionDigits: 2
          });
          _this3.priceformatted = formatter.format(response.data.data['HVDK_PRICE']);
          _this3.price = response.data.data['HVDK_PRICE'];
          _this3.productId = response.data.data['ZIGNA_PACKAGE'];
          _this3.productdesc = response.data.data['NAME'];
          var testdesc = response.data.data['DESCRIPTION'];
          _this3.description = testdesc.replace(/(?:\r\n|\r|\n)/g, '<br>');
          _this3.photourl = response.data.data['PHOTO_URL'];
          if (response.data.data['SHOW_PRODUCT_DETAILS'] === '1') {
            _this3.productdetails = true;
          } else {
            _this3.productdetails = false;
          }
          _this3.getpartnerinvoice();
          setTimeout(function () {
            var formdiv = document.getElementById('formwelcome');
            var formpackagediv = document.getElementById('formpackage');
            var formpackagedivheight = formpackagediv.clientHeight;
            var formdivheight = _this3.productdetails ? formdiv.clientHeight / 2 : 0;
            formpackagediv.style.height = 100 + formdivheight + formpackagedivheight + 'px';
          }, 200);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getPhotoPackageById: function getPhotoPackageById() {
      var _this4 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/zigna/getPhotoPackageById/' + this.blockidzigna, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this4.productname = response.data.data['NAME'];
          var formatter = new Intl.NumberFormat('da-DK', {
            style: 'currency',
            currency: 'DKK',
            minimumFractionDigits: 2
          });
          _this4.priceformatted = formatter.format(response.data.data['HVDK_PRICE']);
          _this4.price = response.data.data['HVDK_PRICE'];
          _this4.packagetype = response.data.data['TYPE'];
          _this4.productId = response.data.data['ZIGNA_PACKAGE'];
          _this4.productdesc = response.data.data['NAME'];
          var testdesc = response.data.data['DESCRIPTION'];
          _this4.description = testdesc.replace(/(?:\r\n|\r|\n)/g, '<br>');
          _this4.photourl = response.data.data['PHOTO_URL'];
          if (response.data.data['SHOW_PRODUCT_DETAILS'] === '1') {
            _this4.productdetails = true;
          } else {
            _this4.productdetails = false;
          }
          _this4.getpartnerinvoice();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getbookingtime: function getbookingtime() {
      var _this5 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/zigna/getBookingTimeslots/' + this.orderid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.alldatetime = res.data;
          var allweekdate = [];
          res.data.forEach(function (a) {
            var dateactual = new Date(a.date);
            var oneJan = new Date(dateactual.getFullYear(), 0, 1);
            var numberOfDays = Math.floor((dateactual - oneJan) / (24 * 60 * 60 * 1000));
            var result = Math.ceil((dateactual.getDay() + 1 + numberOfDays) / 7);
            var sampleweek = {};
            sampleweek['date'] = a.date;
            sampleweek['timeslots'] = a.timeslots;
            sampleweek['weekno'] = result;
            allweekdate.push(sampleweek);
          });
          _this5.mainalldatetimeweek = allweekdate;
          _this5.getweekitems();
          _this5.loading = false;
          _this5.nextstep();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getweekitems: function getweekitems() {
      var alltime = this.mainalldatetimeweek;
      var weekallnew = [];
      var tempdates = {};
      this.mainalldatetimeweek.forEach(function (a) {
        weekallnew.push(a.weekno);
      });
      var unique = function unique(value, index, self) {
        return self.indexOf(value) === index;
      };
      weekallnew = weekallnew.filter(unique);
      if (this.showreminder) {
        weekallnew = weekallnew.slice(1, weekallnew[length - 1]);
      }
      this.weenew = weekallnew;
      weekallnew.forEach(function (b) {
        var tempdate = {};
        tempdate = alltime.filter(function (a) {
          return a.weekno === b;
        });
        tempdates[b] = tempdate;
      });
      this.mainalldatetimeweek = tempdates;
    },
    gettimefromdate: function gettimefromdate(date) {
      var datetime = this.formatDate(date);
      if (this.timearrayperdate[datetime] !== null && typeof this.timearrayperdate[datetime] !== 'undefined') {
        this.showwrongdate = false;
        this.optiontimes = this.timearrayperdate[datetime];
        document.getElementById('timeselection').classList.remove('hide');
      } else {
        this.showwrongdate = true;
        document.getElementById('timeselection').classList.add('hide');
        return false;
      }
    },
    getpartnerinvoice: function getpartnerinvoice() {
      var _this6 = this;

      if (this.check1hour()) {
        this.$http.get('https://bitrixapi.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.levid, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var checkinvoices = res.data.content;
            var dunninginvoices = [];
            var pendinginvoices = [];
            var timeaccessnow = new Date();
            dunninginvoices = checkinvoices.filter(function (item) {
              var togettimedue = new Date(item.due);
              return item.state === 'pending' && timeaccessnow.getTime() > togettimedue.getTime();
            });
            pendinginvoices = checkinvoices.filter(function (item) {
              var togettimedue2 = new Date(item.due);
              return item.state === 'dunning' && timeaccessnow.getTime() > togettimedue2.getTime();
            });
            _this6.dunninginvoice = dunninginvoices.length;
            _this6.perndinginvoice = pendinginvoices.length;
            if (_this6.dunninginvoice > 0 || _this6.perndinginvoice > 0) {
              _this6.showreminder = true;
              _this6.showmodalinitial();
              _this6.setwarning();
            }
            _this6.loading = false;
            _this6.waitfortext = false;
          }
        }, function (response) {
          _this6.waitfortext = false;
          console.log('Error: ', response);
        });
      } else {
        this.waitfortext = false;
        this.showreminder = false;
      }
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this7 = this;

      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          var data = res.data;
          _this7.showsessionnewcreditpro = data.id;
          _this7.showpopupreepay();
        } else {
          console.log('Error in showing session');
        }
      });
    },
    showpopupreepay: function showpopupreepay() {
      var m = this;
      this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.datamethod = data.payment_method;
        console.log('done adding card', data);
        setTimeout(function () {
          m.wait4hourreminder();
        }, 5000);
      });
    },
    wait4hourreminder: function wait4hourreminder() {
      this.loading = false;
      var timenow = new Date();
      var timeafter4hour = new Date();
      timeafter4hour.setHours(timenow.getHours() + 4);
      localStorage.removeItem('timeaddedcard');
      localStorage.removeItem('timeaddedcardexpiry');
      localStorage.setItem('timeaddedcard', timenow);
      localStorage.setItem('timeaddedcardexpiry', timeafter4hour);
      this.showreminder = false;
      this.setwarning();
      this.hidemodalinitial();
      this.hidemodal();
      this.paymenthod = 'reepay';
      this.updateprofilepayment();
    },
    check1hour: function check1hour() {
      var timeaccessnow = new Date();
      var togettime = localStorage.getItem('timeaddedcard');
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry');
      var togettimenew = new Date(togettime);
      var togettimeexpirynew = new Date(togettimeexpiry);
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    updateprofileskip: function updateprofileskip() {
      var data = {
        UF_CRM_COMPANY_SKIP_PAYMENT_REMINDER: 1
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      var data = {
        UF_CRM_COMPANY_PAYMENTS_METHOD: this.paymenthod,
        UF_CRM_COMPANY_PAYMENT_METHOD_UPDATED: 1
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [year, month, day].join('-');
    },
    sethighlighteddates: function sethighlighteddates() {
      this.highlighted.dates = this.optiondate;
    },
    limitbankregis: function limitbankregis(e) {
      return String(e).substring(0, 4);
    },
    addinvoicereepay: function addinvoicereepay() {
      var _this8 = this;

      var data = {
        partnerId: this.levid,
        price: this.price,
        description: this.productdesc
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/zigna/createInvoice', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this8.closeconfirmbooking();
          _this8.loadingnext = false;
          _this8.loadingaddbook = false;
          _this8.step = 0;
          _this8.nextstep();
          _this8.showpopup();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    addbooking: function addbooking() {
      var _this9 = this;

      this.loadingaddbook = true;
      var timestart = Number(this.selectedtimestart.split(':')[0]);
      var timeend = Number(this.selectedtimeend.split(':')[0]);
      this.loadingnext = true;
      var data = {
        partnerId: this.levid,
        orderNumber: this.orderid,
        date: this.selecteddate,
        start: timestart,
        end: timeend,
        type: this.packagetype
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/zigna/addBooking', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.addinvoicereepay();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    createrOrder: function createrOrder() {
      var _this10 = this;

      if (this.Adresse.length === 0 || this.Adresse === '') {
        return false;
      }
      this.loading = true;
      var data = {
        companyId: this.levid,
        name: this.partnername,
        email: this.partneremail,
        phone: this.partnertelephone,
        street: this.road,
        buildingNumber: this.Bygningsnr,
        zipCode: this.zip,
        city: this.city,
        productName: this.productname,
        price: this.price,
        productId: this.productId,
        reviewId: this.reviewId,
        type: this.packagetype
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/zigna/createOrder', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.orderid = res.data.ORDER_NUMBER;
          _this10.getbookingtime(_this10.orderid);
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    decode: function decode() {
      var _this11 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data === '') {
            _this11.showpopuperror();
          }
          var result = res.data.split('-');
          _this11.levid = result[0];
          _this11.blockidzigna = result[1];
          _this11.reviewId = result[2];
          if (_this11.levid !== '') {
            _this11.supplierprofile(_this11.levid);
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    setwarning: function setwarning() {
      if (this.showreminder) {
        var reminderbar = document.getElementById('reminderbar');
        reminderbar.style.position = 'fixed';
        reminderbar.style.zIndex = '1026';
        reminderbar.classList.remove('hide');
        var navbar = document.getElementById('mainbar');
        navbar.style.borderBottom = '0px';
        navbar.style.position = 'none';
        navbar.style.marginTop = '22px';
      } else {
        reminderbar = document.getElementById('reminderbar');
        reminderbar.classList.add('hide');
        navbar = document.getElementById('mainbar');
        navbar.style.marginTop = '0px';
      }
    }
  }
});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"packagemain"}},[_c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"m0"},[_vm._v("Vi kunne ikke behandle din sidste betaling.")]),_c('p',{staticClass:"semi-bold m0 pointer",on:{"click":function($event){return _vm.showmodalinitial()}}},[_vm._v(" Opdater din betaling")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center highlightsmorelesser",staticStyle:{"height":"64px"},attrs:{"id":"main2bar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex flex-wrap mx-auto "},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:" flex  flex-auto justify-end  items-center ",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:" flex flex-auto justify-end justify-center-mobile items-center truspilotmobile",staticStyle:{"height":"inherit"}},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"290px","alt":"Håndværker.dk logo","height":"23px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"center p2 mb4 ",attrs:{"id":"formpackage"}},[_c('div',{attrs:{"id":"formwelcome"}},[_c('div',{staticClass:" darkblue semi-bold lg-col-4 md-col-4 sm-col-12 mx-auto px1 py3 mb2"},[_c('div',{staticClass:"flex flex-column "},[_c('p',{staticClass:"mb2"},[_vm._v("Hej "+_vm._s(_vm.partnername)+" ")]),_vm._v(" "),_c('p',{staticStyle:{"font-weight":"500"},domProps:{"innerHTML":_vm._s(_vm.description)}})])]),_vm._v(" "),_c('div',{staticClass:"lg-col-4 md-col-4 sm-col-12 mx-auto "},[_c('button',{staticClass:"mt2 col-12 not-rounded action-button justify-center h5 regular no-hover flex justify-start items-center p2 line-height-1 mb0",attrs:{"type":"button","disabled":_vm.waitfortext},on:{"click":function($event){return _vm.nextstep()}}},[_vm._v("NÆSTE\n        ")])])])]),_vm._v(" "),_c('div',{staticClass:"lg-col-4 md-col-4 sm-col-12 mx-auto flex items-center hide py1 p2",staticStyle:{"height":"40vh"},attrs:{"id":"packageform"}},[(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_vm._m(2)]):_c('div',{staticClass:"col-12",staticStyle:{"border":"0px!important","box-shadow":"0px 0px 20px #0000000D"}},[_c('div',{staticClass:" col-12 flex flex-column mt2 p0"},[_c('p',{staticClass:"col-12 flex justify-start"},[_vm._v("Addresse")]),_vm._v(" "),_c('el-autocomplete',{staticClass:"col-lg-12 col-md-12 col-sm-12",attrs:{"id":"Adresse","autocomplete":"off","label":"ex.2300","fetch-suggestions":_vm.getaddress,"clearable":"","placeholder":"Indtast venligst"},on:{"select":_vm.getaddressinfo},model:{value:(_vm.Adresse),callback:function ($$v) {_vm.Adresse=$$v},expression:"Adresse"}})],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('div',{staticClass:" mx-auto px2 mb3"},[_c('button',{staticClass:" col-12 not-rounded action-button justify-center h5 regular no-hover flex justify-start items-center p2 line-height-1 mb0",attrs:{"type":"submit","disabled":_vm.disablecreateorder},on:{"click":_vm.createrOrder}},[_vm._v("SÆT DATO\n            ")])])])]),_vm._v(" "),_c('div',{staticClass:"lg-col-8 md-col-8 sm-col-12 mx-auto flex  mt2 my3 py3 p2 items-center hide",attrs:{"id":"packageformdate"}},[(_vm.loadingnext)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_vm._m(3)]):_c('div',{staticClass:"col-12 p0",staticStyle:{"border":"0px!important","box-shadow":"0px 0px 20px #0000000D"}},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"flex flex-row mt2 p0",staticStyle:{"overflow":"auto"},attrs:{"id":"datepicker","width":"600px"}},_vm._l((_vm.weenew),function(week,index){return _c('div',{key:index,staticClass:"flex flex-column p2 ml1",staticStyle:{"border":"1px solid #C5C5C5"}},[_c('p',{staticClass:"h4 p0  center darkblue"},[_vm._v("Week "+_vm._s(week))]),_vm._v(" "),_vm._l((_vm.mainalldatetimeweek[week]),function(itemsbra,key){return _c('div',{key:key,staticClass:"flex flex-column justify-start",staticStyle:{"width":"290px"}},[_c('div',{staticClass:"flex p0 mt3 "},[_c('p',{staticClass:"h5 mr-auto semi-bold"},[_vm._v(_vm._s(_vm.moment(new Date(itemsbra.date)).format('Do MMMM YYYY')))])]),_vm._v(" "),_vm._l((itemsbra.timeslots),function(times,indexs){return _c('div',{key:indexs,staticClass:"flex flex-row justify-start items-center py1",staticStyle:{"border-bottom":"1px solid","border-bottom-color":"lightgray"}},[_c('span',{staticClass:"darkblue px0 py2 h5 center",staticStyle:{"width":"150px"}},[_vm._v("\n                          "+_vm._s(times.start)+":00 - "+_vm._s(times.end)+":00\n                        ")]),_vm._v(" "),_c('button',{staticClass:"darkblue-background white gibson p2 h5 not-rounded px2 mobilepx3 m0",on:{"click":function($event){return _vm.showconfirmbooking(times,itemsbra.date)}}},[_vm._v("\n                          Book now\n                        ")])])})],2)})],2)}),0),_vm._v(" "),_c('div',{staticClass:"pt2"})])]),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"darkblue-background flex flex-column items-center justify-center",attrs:{"id":"footer1"}},[_c('p',{staticClass:"white h5 "},[_vm._v("Forbind med os")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center my2"},[_c('a',{attrs:{"target":"_new","href":"https://www.facebook.com/haandvaerkerdk?ref=pm"}},[_c('span',{staticClass:"lazyload mr2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","role":"img","aria-label":"icon-facebook","viewBox":"0 0 1024 1024"}},[_c('title',[_vm._v("Facebook")]),_c('path',{attrs:{"d":"M1024 512C1024 229.2 794.8 0 512 0S0 229.2 0 512c0 255.6 187.2 467.4 432 505.8V660H302V512h130V399.2C432 270.9 508.4 200 625.4 200c56 0 114.6 10 114.6 10v126h-64.6c-63.6 0-83.4 39.5-83.4 80v96h142l-22.7 148H592v357.8C836.8 979.4 1024 767.6 1024 512z","fill":"#1877F2"}}),_c('path',{attrs:{"d":"M711.3 660L734 512H592v-96c0-40.5 19.8-80 83.4-80H740V210c0 0-58.6-10-114.6-10 -117 0-193.4 70.9-193.4 199.2V512H302v148h130v357.8c26.1 4.1 52.8 6.2 80 6.2s53.9-2.1 80-6.2V660H711.3z","fill":"#FFF","role":"img","aria-label":"Facebook"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company/h%C3%A5ndv%C3%A6rker-dk?ref=pm","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 455.731 455.731"},attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","width":"32","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 455.731 455.731","xml:space":"preserve","aria-label":"Linkedin"}},[_c('g',[_c('rect',{staticStyle:{"fill":"#0084B1"},attrs:{"x":"0","y":"0","width":"455.731","height":"455.731"}}),_vm._v(" "),_c('g',[_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M107.255,69.215c20.873,0.017,38.088,17.257,38.043,38.234c-0.05,21.965-18.278,38.52-38.3,38.043    c-20.308,0.411-38.155-16.551-38.151-38.188C68.847,86.319,86.129,69.199,107.255,69.215z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M129.431,386.471H84.71c-5.804,0-10.509-4.705-10.509-10.509V185.18    c0-5.804,4.705-10.509,10.509-10.509h44.721c5.804,0,10.509,4.705,10.509,10.509v190.783    C139.939,381.766,135.235,386.471,129.431,386.471z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M386.884,241.682c0-39.996-32.423-72.42-72.42-72.42h-11.47c-21.882,0-41.214,10.918-52.842,27.606    c-1.268,1.819-2.442,3.708-3.52,5.658c-0.373-0.056-0.594-0.085-0.599-0.075v-23.418c0-2.409-1.953-4.363-4.363-4.363h-55.795    c-2.409,0-4.363,1.953-4.363,4.363V382.11c0,2.409,1.952,4.362,4.361,4.363l57.011,0.014c2.41,0.001,4.364-1.953,4.364-4.363    V264.801c0-20.28,16.175-37.119,36.454-37.348c10.352-0.117,19.737,4.031,26.501,10.799c6.675,6.671,10.802,15.895,10.802,26.079    v117.808c0,2.409,1.953,4.362,4.361,4.363l57.152,0.014c2.41,0.001,4.364-1.953,4.364-4.363V241.682z"}})])]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://trustpilot.com/review/h%C3%A5ndv%C3%A6rker.dk?ref=pm","title":"Trustpilot - Haandvaerker.dk","name":"Trustpilot - Haandvaerker.dk","rel":"nofollow","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"aria-label":"Trustpilot","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 128 128","enable-background":"new 0 0 128 128","xml:space":"preserve"}},[_c('image',{attrs:{"id":"image0","width":"128","height":"128","x":"0","y":"0","href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAQAAABpN6lAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQflCRUMGBqW6X0KAAAFXElEQVR42u2dW2gcZRiG32+bRu2BaG3UegiNtJQ2bSlGoSJqKRKJCEpB LdKClL2wBAR71wtBBL1QkrsSD6VgS6QKifWQ2oYk0CohbaOxkS3BUMSY1poES0ysJDb7epGwbrKH 7Gbm+782+78Qsjs7M/t8z/7/zOz8s7uC6bACUVShDMuwsDOGfrTgoMSm7goAsBh12IuINZvDxFGP fTIBCMBifIPt1kQGaUe1TEQA1BVk+cB21AHCCvQUVONPThybI4gWbPlABFFhDBusOQxzQTi64Hd8 2TImpDWDbQq3/3sBXoAX4AV4AV6AF+AFWANYxwuwBrCOF2ANYB0vwBrAOl6ANYB1vABrAOt4AdYA 1rEX8GNhC/gHewtbwAnpRF8hC2ic/jOL7dDYBO6SET6Mc3YIti2gVUYA6UJ/oQpomvW/wARM4ovp W4ZbAUsBp2R4+lYHrhSigMTrLnEcKzwBnFG0WSew2w12yGNJNorwB1ZYYNi1gBmvuVxPbBALRkDT HPcdxaoL/CCVMyfwFgxhuXsQqxaQstGTcXxtAXLDCIDRnsCmC8RkY+pELsEwbnONYtMC0m7w5BpO uEexEdCY53TFWHSBi7Im/QMswSCK3cJYtICMr7OMoM01jIWAbIc8zjuB+y4wgDLJ+JxciStY5BLH fQtokizKZRin3OIEawENOJ5pvRmX+U5+zbZKbsHGjA9mWusebJt3DQySOGvpeKudwl/Cz4KUEEwA SXZxTfAy5l3+o/wlGH5wAeQod5kUH+F+/hsUPgwBJPkxHX/0iqvYGgZ4WALIn/mQw/Kf4WA42OEJ IMf5OiV4cXMWX8xaxsOCDlMASTazVLn8tfw+TOCwBZCXqfhRbO7maLi44QsgJ/k2ixSKX84j4cNq CCDJDq4OufxK9mmAagkgr/KF0IoX7uO4DqaeAJL8kCGc42Mpj+shar8dvoCd8lOg8p/CEdyjB6j9 dngDznLe14GxiO+gRbN8VydEPscr8lfe5ZfjE2zVRnMjYBKrZCjP8l/CByjRR3NzRuh0fuVzCT/C URflAwoHLGmS16lObsZRrHfCBTctgPlcAMManHFXvpsW0CmXcix+BQ7hOXfFuxKQYwfgE2jA/ckT 0IMINinTqR4JTqU8B4pFfJPXE0v08X2+yJUAn9WG098NdsucZ4r4ABrwOIBLaEc72uS3xCPq143o d4E5OwCfx3voQQ3apXf2YzLOZuxcwAJ4K/bgDNZJPMvyqgK0twGxrM+9nj0kT/LuLPMs5TVNQO3j gCwjwYyiC5sAVOE8n840l/yNk6qEyi1gS4ZnLeGnM+aL810uzjDvLk1AXQEXM5S0Ne2A1lk+mEHW hB6ibhdIswFkhPvxLVanmfsRdPPl1MkyglZFRtUWkPJuPocBrUNcmrJUVA9RU8DA7HEiVuc0oNU7 e8vB0qSjxJCj2QVmXAvCYtaiGbmMG61DJ19LniBDOK1GqdgCnkx6lrXsynPpL3ln0vI1WpB6AgaZ uNhpngNaA9yWWMO94Q2HzoxeFzgmkwDAZTyMw/P64tb70Ma3pjTKZXTqYOoJaAQAVqIbuwPQvYFT LPt/fQpR6gBXuTi0Aa0/uQNg+c3VBb7C7WhGbShX/t6BRtbjd3RrgGoJGMF5VIe4vldxDr3BV5Ma /8XK1gDW8QKsAazjBVgDWMcLsAawjhdgDWAdL8AawDpegDWAdbwAawDreAHWANbxAqwBrOMFWANY xwvAmDWCacYill9oegOkP4IWawbTtPif3ZUY6q05zFIvMf/T24BMoBoHEA++xpsocRxA9fSPr0+F FYiiCmUL/leIx9CPFhyU6cu4/wM76BhE+f9iSAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wOS0y MVQwOToyNDoyNiswMzowMFrxEEMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDktMjFUMDk6MjQ6 MjYrMDM6MDArrKj/AAAAAElFTkSuQmCC"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/haandvaerker.dk?ref=pm","rel":"nofollow","title":"Instagram - Haandvaerker.dk","name":"Instagram - Haandvaerker.dk","id":"Instagram - Haandvaerker.dk","target":"_new"}},[_c('span',{staticClass:"mx2 lazyload",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.09 32.09","width":"32","height":"32"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"width":"32.09","height":"32.09"}})])]),_vm._v(" "),_c('g',{staticStyle:{"clip-path":"url(#clip-path)"}},[_c('image',{attrs:{"width":"134","height":"133","transform":"translate(-0.05 -0.26) scale(0.24 0.25)","xlink:href":"data:image/png;base64,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"}})]),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M23.84,3H8.25A5.27,5.27,0,0,0,3,8.25V23.84A5.26,5.26,0,0,0,8.25,29.1H23.84a5.25,5.25,0,0,0,5.26-5.26V8.25A5.26,5.26,0,0,0,23.84,3ZM27,23.13A3.91,3.91,0,0,1,23.13,27H9a3.92,3.92,0,0,1-3.91-3.91V9A3.92,3.92,0,0,1,9,5.05H23.13A3.92,3.92,0,0,1,27,9Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M21.5,8.72a1.4,1.4,0,1,0,1.4-1.4h0A1.4,1.4,0,0,0,21.5,8.72Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M16.11,9.75h-.06A6.27,6.27,0,0,0,9.75,16h0a6.3,6.3,0,1,0,6.36-6.23ZM16,20.39A4.34,4.34,0,0,1,11.7,16h0a4.33,4.33,0,0,1,4.35-4.3h0A4.35,4.35,0,0,1,16,20.39Z"}})])])])])]),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('b-modal',{ref:"packageorder",attrs:{"centered":"","hide-header":"","id":"packageorder","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end"},[_c('a',{staticClass:"white-button no-border not-rounded  ",attrs:{"type":"button","href":"https://www.haandvaerker.dk/business"}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.104","height":"122.269","viewBox":"0 0 92.104 122.269"}},[_c('g',{attrs:{"id":"Group_4292","data-name":"Group 4292","transform":"translate(-1901.896 -1841.384)"}},[_c('path',{attrs:{"id":"Path_2691","data-name":"Path 2691","d":"M2050.619,2063.713,2038,2057.206a.61.61,0,0,0-.2-.2c-.106-.06-10.945-6.476-13.783-15.262a131.483,131.483,0,0,0-8.62-20.592c.785-1.812,5.4-12.47,6.642-15.655,1.9-4.891.106-7.171-.83-7.971,3.533-7.186,3.08-8.831,2.159-9.466a1.467,1.467,0,0,0-1.132-.2c-.015,0-.03.015-.06.015a3.884,3.884,0,0,0-1.132-2.989,3.2,3.2,0,0,0-3.261-.2,3.64,3.64,0,0,0-1,.709,7.469,7.469,0,0,0-3.97-.74c-.528.015-2.144.076-8.711,8.348-2.627,3.306-5.133,6.793-6.114,8.348-.906-.951-1.464-1.555-1.495-1.585a.618.618,0,0,0-.725-.121c-.121.06-2.536,1.344-3.155,3.14a8.657,8.657,0,0,0-1.676-.921,1.091,1.091,0,0,0-1.117.121c-.377.272-.83.921-.709,3.276a3.489,3.489,0,0,0-1.193.06,3.189,3.189,0,0,0-1.374.694c-.121-.936-.272-1.812-.423-2.551-.679-3.216-3.412-4.967-7.5-4.8h-.091a.643.643,0,0,0-.468.211c-.317.362-.423.468,1.072,13.421.287,2.551.574,4.952.755,6.7.438,4.2,3.336,9.616,5.072,12.862a24.986,24.986,0,0,1,1.313,2.627c-.091.694-1.691,4.514-4.74,11.368-.242.528-.393.876-.468,1.072l-12.168,6.793a.654.654,0,0,0-.3.392.6.6,0,0,0,.091.483l14.719,20.788a.64.64,0,0,0,.468.257h.03a.566.566,0,0,0,.453-.211l10.628-12.319a.6.6,0,0,0,0-.785l-.06-.061,1.026-.785c.2.2.393.377.589.574,4.333,4.061,8.952,6.854,12.7,7.669,7.548,1.661,16.742,6.386,16.833,6.431a.594.594,0,0,0,.272.06c.06,0,.106-.015.151-.015l10.19,8.832Zm-29.695-58.65c-.876,2.234-3.412,8.167-5.118,12.122a.189.189,0,0,0-.091-.166c-.166-.106-.332-.2-.5-.3-.2-.121-.393-.242-.6-.362a2.474,2.474,0,0,1-.483-.408,2.742,2.742,0,0,0-.483-.438.2.2,0,1,0-.211.332,2.337,2.337,0,0,1,.408.362,2.626,2.626,0,0,0,.574.483l.589.362c.166.106.332.211.513.317a.218.218,0,0,0,.106.03.244.244,0,0,0,.136-.045c-.438,1-.8,1.857-1.072,2.491a19.218,19.218,0,0,0-2.355-3.321c-.3-.317-.694-.725-1.147-1.208,1.162-1.9,6.22-10.19,9.5-16.636C2021.347,1999.4,2022.4,2001.259,2020.924,2005.063Zm1.57-16c.045-.015.151-.03.181,0,.045.03,1.026.83-2.883,8.6-2.566,5.1-6.386,11.564-8.454,14.991a2.052,2.052,0,0,1-1.087-1.253.205.205,0,1,0-.408.045,2.438,2.438,0,0,0,1.283,1.555c-.347.574-.634,1.042-.845,1.374-1.042-1.1-2.295-2.431-3.623-3.834,4.574-7.775,11.836-18.9,15.081-21.12a.573.573,0,0,0,.2-.136A3.094,3.094,0,0,1,2022.494,1989.061Zm-4.3-3.231q1.427-.521,2.083,0c.679.558.725,1.947.664,2.687-1.359,1-3.91,3.668-8.816,11.036-2.823,4.242-5.374,8.469-6.341,10.084-1.4-1.479-2.838-3-4.151-4.393,5.978-7.654,12.651-15.761,15.413-18.478a.9.9,0,0,0,.226-.136.574.574,0,0,0,.136-.2A3.554,3.554,0,0,1,2018.192,1985.83Zm-13.119,7.926c5.9-7.443,7.518-7.865,7.79-7.88a7.254,7.254,0,0,1,2.989.423c-3.4,3.427-9.8,11.4-13.36,15.912a4.189,4.189,0,0,1-.408-.317,2.976,2.976,0,0,0-.634-.438.212.212,0,0,0-.211.03.187.187,0,0,0-.06.211c.045.151.091.3.151.468a.858.858,0,0,0,.06.181,2.289,2.289,0,0,1-.815-1.072.2.2,0,1,0-.392.03c.045.6,1.027,1.495,1.479,1.691a.136.136,0,0,0,.075.015.244.244,0,0,0,.136-.045.189.189,0,0,0,.06-.2c-.045-.211-.121-.408-.181-.619a.4.4,0,0,0,.091.075c.136.106.272.226.423.332-.574.725-1.057,1.344-1.434,1.827-.71-.755-1.374-1.464-1.963-2.083A99.467,99.467,0,0,1,2005.073,1993.756Zm-9.118,7.2c.347.362.951,1.011,1.736,1.842h0c.181.181.362.392.558.589a2.78,2.78,0,0,1-2.174,2.234q-1.291-1.2-2.355-2.038C1993.735,2002.557,1995.094,2001.485,1995.955,2000.957Zm-5.42,2.053a9.586,9.586,0,0,1,2.023,1.223.581.581,0,0,0,.528.407c.423.332.891.74,1.4,1.193a1.529,1.529,0,0,1-.106.619,2.345,2.345,0,0,1-1.042,1.147l-.015-.015a10.021,10.021,0,0,0-2.974-1.993A5.953,5.953,0,0,1,1990.535,2003.01Zm-2.31,3.5a2.809,2.809,0,0,1,1.389.106h.015a7.859,7.859,0,0,1,2.6,1.6,4.558,4.558,0,0,1-.362,2.853,3.41,3.41,0,0,1-1.963,1.57c-1.359-1.057-2.37-1.842-2.808-2.159,0-.076-.015-.136-.015-.211-.091-.891-.2-1.766-.287-2.612A2.2,2.2,0,0,1,1988.225,2006.512Zm-.951,5.616c.453.347,1.027.785,1.676,1.3a4.787,4.787,0,0,1-1.193,2.476C1987.576,2014.725,1987.425,2013.427,1987.274,2012.128Zm-8.167-12.258a10,10,0,0,1,1.721.136c.242,1.706.845,6.869-.5,8.469a1.609,1.609,0,0,1-.347.3C1979.545,2005,1979.137,2001.168,1979.107,1999.87Zm15.051,61.458-11.911-14.085c.106-.226.242-.543.408-.906,2.31-5.193,3.578-8.137,4.227-9.828.151.468.332.921.5,1.374l.106.272a.215.215,0,0,0,.2.136.137.137,0,0,0,.075-.015.208.208,0,0,0,.121-.257l-.106-.272c-.226-.589-.453-1.208-.649-1.842.151-.423.257-.74.317-.966.151.151.3.317.468.483a3.869,3.869,0,0,0,1.6,1.238c.015,0,.045.015.06.015a.215.215,0,0,0,.2-.136.21.21,0,0,0-.136-.257,3.415,3.415,0,0,1-1.419-1.117,7.37,7.37,0,0,0-.679-.694c0-.453-.377-1.177-1.449-3.185-1.691-3.155-4.514-8.439-4.937-12.409-.181-1.751-.453-4.167-.755-6.718-.106-.936-.226-1.947-.347-2.974a1.6,1.6,0,0,0,.6-.468c1.419-1.691.876-6.748.6-8.635a4.57,4.57,0,0,1,3.729,3.638c.362,1.706.619,4.121.891,6.673.528,4.876,1.011,9.465,2.325,10.99l.091.091a31.6,31.6,0,0,1,9.163,13.1,97.053,97.053,0,0,1,4,17.376l-8.152-8.273a.634.634,0,0,0-.211-.136c-.408-.151-4.046-1.449-5.737.272-1.042,1.057-1.042,2.944.015,5.616a35.774,35.774,0,0,0,7.745,11.187Zm.74-11.141a5.22,5.22,0,0,1-3.518,1.766,2.867,2.867,0,0,1-2.023-1.1c-.317-.634-.619-1.268-.86-1.887-.845-2.144-.951-3.638-.287-4.318.936-.951,3.336-.377,4.318-.03l3.08,3.125A3.758,3.758,0,0,1,1994.9,2050.187Zm1.63,10.145c-.015-.015-.015-.03-.03-.03a.429.429,0,0,0-.151-.136,39.544,39.544,0,0,1-6.476-8.3,2.451,2.451,0,0,0,1.389.528.618.618,0,0,0,.166-.015,5.7,5.7,0,0,0,3.789-1.932,3.966,3.966,0,0,0,.8-2.28l5.842,5.948a.6.6,0,0,0,.6.151c.242.377.453.74.649,1.117.091.181.166.377.257.574a2.84,2.84,0,0,0,.981,1.449.279.279,0,0,0,.106.03.19.19,0,0,0,.166-.091.194.194,0,0,0-.06-.272,2.314,2.314,0,0,1-.815-1.253,3.667,3.667,0,0,0-.272-.6,11.614,11.614,0,0,0-.679-1.163.683.683,0,0,0,.106-.423c0-.015-.015-.121-.045-.332a4.011,4.011,0,0,0,1.147,1.223.279.279,0,0,0,.106.03.174.174,0,0,0,.166-.091.194.194,0,0,0-.06-.272,3.964,3.964,0,0,1-1.072-1.162,6.52,6.52,0,0,0-.408-.559,99.352,99.352,0,0,0-4.151-18.267,32.383,32.383,0,0,0-9.511-13.617,11.165,11.165,0,0,1-1.253-4.2,4.553,4.553,0,0,0,1.479-2.642c4.453,3.517,12.288,10.039,14.3,13.843,2.823,5.359,3.17,8.545,3.17,8.575a.6.6,0,0,0,.6.543h.06a.609.609,0,0,0,.544-.664c-.015-.136-.347-3.427-3.306-9.028-2.1-3.97-9.843-10.462-14.4-14.055a3.7,3.7,0,0,0,1.947-1.676,4.658,4.658,0,0,0,.453-2.627c5.254,4.831,16.727,18.252,17.708,20.229a6.048,6.048,0,0,1,.725,3.4.6.6,0,0,0,.483.71c.045,0,.075.015.121.015a.585.585,0,0,0,.589-.5,7.05,7.05,0,0,0-.83-4.167c-1.132-2.28-12.59-15.564-17.8-20.41a2.606,2.606,0,0,0,1.117-1.3,4.045,4.045,0,0,0,.106-.408c3.276,3.019,8.3,8.56,15.957,18.463a2.615,2.615,0,0,1-.8.574.2.2,0,0,0-.136.257.209.209,0,0,0,.2.151.114.114,0,0,0,.06-.015,2.612,2.612,0,0,0,.951-.649c.181.242.362.468.543.71.332.438.589.755.725.936a.613.613,0,0,0,.966-.755c-.136-.181-.377-.483-.71-.921-6.778-8.816-12.2-15.172-16.2-18.991a3.125,3.125,0,0,0,2.159-2.219c3.925,4.167,10.628,11.277,12.862,13.617a21.308,21.308,0,0,1,2.748,4.046.61.61,0,0,0,.075.136,129.98,129.98,0,0,1,8.62,20.592c2.642,8.182,11.5,14.176,13.8,15.61l-10.507,17.074c-2.053-1.011-9.949-4.816-16.636-6.28C2005.556,2067.653,2000.68,2064.407,1996.528,2060.331Z","transform":"translate(-56.619 -121.392)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2692","data-name":"Path 2692","d":"M2176.331,2287.492a.2.2,0,0,0-.136-.377,3.274,3.274,0,0,0-1.042.8c-.362.362-.755.725-1.057.74a.2.2,0,0,0-.2.211.2.2,0,0,0,.2.2h.015c.453-.015.891-.438,1.328-.861A3.21,3.21,0,0,1,2176.331,2287.492Z","transform":"translate(-230.941 -378.428)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2693","data-name":"Path 2693","d":"M2179.4,2292.582a6.457,6.457,0,0,1-1.812,1.3.21.21,0,0,0-.136.257.2.2,0,0,0,.2.136.09.09,0,0,0,.06-.015,7.324,7.324,0,0,0,1.962-1.389.21.21,0,0,0,0-.287A.19.19,0,0,0,2179.4,2292.582Z","transform":"translate(-233.954 -383.035)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2694","data-name":"Path 2694","d":"M2221.841,2273.778a3.733,3.733,0,0,0-1.434.921.2.2,0,0,0,.271.3c.091-.091.181-.166.272-.242a1.458,1.458,0,0,0-.272.5.229.229,0,0,0,.045.2.194.194,0,0,0,.151.06h.045a2.066,2.066,0,0,0,.906-.513.2.2,0,0,0,.015-.287.206.206,0,0,0-.257-.045,2.361,2.361,0,0,0,.483-.6.21.21,0,0,0-.015-.211A.234.234,0,0,0,2221.841,2273.778Z","transform":"translate(-270.368 -367.115)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2695","data-name":"Path 2695","d":"M2248.8,2223.215a.2.2,0,0,0-.317-.257c-.347.438-1.268,1.313-1.615,1.344a.2.2,0,0,0-.181.211.2.2,0,0,0,.2.181h.015C2247.476,2224.649,2248.548,2223.532,2248.8,2223.215Z","transform":"translate(-292.742 -323.904)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2696","data-name":"Path 2696","d":"M2254.658,2226.084a6.774,6.774,0,0,0-.679.619,4.453,4.453,0,0,1-.921.77.217.217,0,0,0-.075.272.208.208,0,0,0,.166.091.279.279,0,0,0,.106-.03,5.385,5.385,0,0,0,1-.83,6.167,6.167,0,0,1,.649-.589.2.2,0,0,0,.03-.287A.226.226,0,0,0,2254.658,2226.084Z","transform":"translate(-298.068 -326.591)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2697","data-name":"Path 2697","d":"M2149.733,2444.678l.181-.166a.191.191,0,0,0,.015-.272.214.214,0,0,0-.257-.061,4.307,4.307,0,0,0-.845.725l-.287.287a3.361,3.361,0,0,1-1.1.574.2.2,0,0,0-.151.227.194.194,0,0,0,.2.166h.015a1.974,1.974,0,0,0,1.3-.664A9.273,9.273,0,0,0,2149.733,2444.678Z","transform":"translate(-208.344 -511.777)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2698","data-name":"Path 2698","d":"M2159.032,2452.257a2.59,2.59,0,0,1-1.736.875h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.211.2,2.981,2.981,0,0,0,2.023-1.011.21.21,0,0,0,0-.287A.272.272,0,0,0,2159.032,2452.257Z","transform":"translate(-216.677 -518.601)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2699","data-name":"Path 2699","d":"M2204.882,2119.6a7.162,7.162,0,0,1-2.778-2.566l-.076-.091a.205.205,0,1,0-.332.241l.075.091a7.585,7.585,0,0,0,2.929,2.687.191.191,0,0,0,.091.015.2.2,0,0,0,.181-.121A.176.176,0,0,0,2204.882,2119.6Z","transform":"translate(-254.51 -233.889)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2700","data-name":"Path 2700","d":"M2215.895,2123.347c-.075-.045-.136-.106-.211-.151a.205.205,0,0,0-.241.332,2.556,2.556,0,0,0,.211.151,4.854,4.854,0,0,1,.725.574.193.193,0,0,0,.151.06.245.245,0,0,0,.136-.045.21.21,0,0,0,.015-.287A4.807,4.807,0,0,0,2215.895,2123.347Z","transform":"translate(-266.142 -239.238)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2701","data-name":"Path 2701","d":"M1915.015,2106.408a.6.6,0,0,0,.03-1.208l-12.515-.6a.6.6,0,1,0-.06,1.208l12.515.6Z","transform":"translate(0 -223.476)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2702","data-name":"Path 2702","d":"M1981.406,2006.613l4.635,3.442a.651.651,0,0,0,.362.121.63.63,0,0,0,.483-.241.616.616,0,0,0-.121-.845l-4.635-3.442a.616.616,0,0,0-.845.121A.589.589,0,0,0,1981.406,2006.613Z","transform":"translate(-67.296 -139.366)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2703","data-name":"Path 2703","d":"M2070.719,1955.211a.6.6,0,0,0,.543.332.592.592,0,0,0,.272-.06.605.605,0,0,0,.272-.815l-4.484-8.862a.608.608,0,1,0-1.087.543Z","transform":"translate(-139.474 -88.372)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2704","data-name":"Path 2704","d":"M2170.788,1904h.045a.6.6,0,0,0,.558-.649l-.5-7.609a.59.59,0,0,0-.649-.559.6.6,0,0,0-.559.649l.5,7.609A.6.6,0,0,0,2170.788,1904Z","transform":"translate(-227.361 -45.678)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2705","data-name":"Path 2705","d":"M2295.645,1854.52h.045a.608.608,0,0,0,.6-.558l.966-11.926a.606.606,0,1,0-1.208-.091l-.966,11.926A.607.607,0,0,0,2295.645,1854.52Z","transform":"translate(-333.831)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2706","data-name":"Path 2706","d":"M2379.719,1937a.6.6,0,0,0,.423-.181l4.227-4.182a.608.608,0,0,0-.86-.86l-4.227,4.182a.6.6,0,0,0,0,.86A.63.63,0,0,0,2379.719,1937Z","transform":"translate(-405.163 -76.597)","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din bestilling")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Din aftale er den "+_vm._s(_vm.moment(new Date(_vm.selecteddate)).format('Do MMMM YYYY'))+" kl. "+_vm._s(_vm.selectedtimestart))]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mb2 mx-auto"},[_c('i',{staticClass:"el-icon-location-outline",staticStyle:{"color":"#19a3c0"}}),_vm._v(" "+_vm._s(' ' + _vm.Adresse))]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center",attrs:{"id":"packageordertext"}},[_vm._v("Hvis du har spørgsmål er du velkommen til at kontakte os.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center pr3 ",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])],2),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit url-link er udløbet.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"confirmbooking",attrs:{"centered":"","hide-header":"","id":"confirmbooking","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),(_vm.loadingaddbook)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"h3 py2 center "},[_vm._v("Du har valgt")]),_vm._v(" "),_c('span',{staticClass:"h4 semi-bold center"},[_vm._v(_vm._s(_vm.moment(new Date(_vm.selecteddate)).format('Do MMMM YYYY')))]),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold my3 center"},[_vm._v(_vm._s(_vm.selectedimeslot))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row justify-center"},[_c('div',{staticClass:"col-5 flex justify-center items-center py1 mx"},[_c('button',{staticClass:"col-12 regular p2 outline-button center not-rounded white-background",on:{"click":_vm.closeconfirmbooking}},[_vm._v(" Annuler ")])]),_vm._v(" "),_c('div',{staticClass:"col-5 flex justify-center items-center py1 mx"},[_c('button',{staticClass:"regular p2 col-12 action-button not-rounded center white",on:{"click":_vm.addbooking}},[_vm._v(" Bekræft")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center ",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"paymentmethods",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"paymentmethods","no-close-on-backdrop":true}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end mt1"},[_c('button',{staticClass:"h4 white-button no-border not-rounded gibson p0 m0 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodal()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex col-12 m0 p0 flex-wrap "},[_c('b-tabs',{staticClass:"col-12 p0 m0 darkblue ",attrs:{"vertical":"","card":""}},[_c('div',{staticClass:" clearfix white-background  m0 p0"},[_c('div',{staticClass:"flex flex-column gibson col-12 p0"},[_c('div',{staticClass:"flex flex-column col-lg-10 col-md-10 col-sm-12 mx-auto"},[_c('p',{staticClass:"h3 darkblue "},[_vm._v("Hej "+_vm._s(_vm.partnername.replace('&\#039\;','\''))+"!")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue "},[_vm._v("Betalingsmetoder")])]),_vm._v(" "),_c('div',{staticClass:"col-10  mx-auto flex flex-column justify-around my2 p0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reepay",modifiers:{"reepay":true}}],staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center collapsed",attrs:{"role":"tablist"}},[_c('span',{staticClass:"mx2 h5"},[_vm._v("Reepay")])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background",attrs:{"id":"reepay","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"462px"},attrs:{"id":"rp_container"}})])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])],2),_vm._v(" "),_c('b-modal',{ref:"initialreminder",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"initialreminder","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background col-12 "},[_c('div',{staticClass:" muted-border border shadow col-lg-8 col-md-8 col-sm-12 mx-auto my2 "},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end my2"},[_c('button',{staticClass:"h3 white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodalinitial()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-start gibson col-12 p3"},[_c('p',{staticClass:"my2 darkblue"},[_c('span',{attrs:{"clas":""}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"130","height":"130","viewBox":"0 0 116.96 92.339"}},[_c('path',{attrs:{"id":"Path_5","data-name":"Path 5","d":"M12.879,79.46A43.971,43.971,0,0,1,43.971,4.4,43.477,43.477,0,0,1,64.058,9.244,44.327,44.327,0,0,1,79.3,22.183a2.633,2.633,0,0,1,2.429.222L85.919,25.1l4.062-2.311a2.637,2.637,0,0,1,3.941,2.292V69.358A2.637,2.637,0,0,1,89.9,71.6L85.884,69.12l-4.125,2.735a2.631,2.631,0,0,1-.845.367A43.976,43.976,0,0,1,12.879,79.46Zm3.729-58.455A38.694,38.694,0,1,0,71.33,75.728a39.161,39.161,0,0,0,4.711-5.689l-1.371-.89-4.03,2.7a2.641,2.641,0,0,1-2.884.035L63.45,69.149l-3.919,2.685A2.637,2.637,0,0,1,55.4,69.659V24.624a2.638,2.638,0,0,1,4.1-2.2l3.948,2.625,4.337-2.675a2.65,2.65,0,0,1,2.821.035l4.059,2.64,4.23-2.659-4.1,2.577a39.28,39.28,0,0,0-3.467-3.964,38.7,38.7,0,0,0-54.722,0ZM80.255,72.3a2.668,2.668,0,0,1-1.39-.424A2.644,2.644,0,0,0,80.255,72.3ZM64.809,63.761l4.325,2.748L73.176,63.8a2.641,2.641,0,0,1,2.906-.019l4.2,2.726,4.093-2.713a2.638,2.638,0,0,1,2.846-.044l1.425.88V29.617l-1.507.858a2.633,2.633,0,0,1-2.732-.073l-4.125-2.65-4.233,2.662a2.623,2.623,0,0,1-1.406.405,2.652,2.652,0,0,1-1.437-.424l-4.074-2.65L64.78,30.427a2.639,2.639,0,0,1-2.846-.047l-1.254-.836V64.65l1.222-.839a2.649,2.649,0,0,1,1.494-.462A2.616,2.616,0,0,1,64.809,63.761Zm-33.362-1.1a1.972,1.972,0,1,1,1.969,1.972A1.97,1.97,0,0,1,31.447,62.665Zm33.631-5.5a1.76,1.76,0,1,1,0-3.52H75.629a1.76,1.76,0,0,1,0,3.52ZM31.69,54.776l-1.232-19.72a2.959,2.959,0,0,1,5.917,0l-1.295,19.72c0,1.634-.8,2.219-1.665,2.219S31.69,56.409,31.69,54.776Zm42.182-6.408a1.759,1.759,0,1,1,1.757,1.757A1.758,1.758,0,0,1,73.872,48.368Zm-8.795,1.757a1.759,1.759,0,1,1,0-3.517h3.517a1.759,1.759,0,1,1,0,3.517Zm0-7.035a1.759,1.759,0,1,1,0-3.517H79.147a1.759,1.759,0,1,1,0,3.517ZM103.771,29.9a2.637,2.637,0,1,1,0-5.274h10.552a2.637,2.637,0,0,1,0,5.274ZM98.386,18.574a2.639,2.639,0,0,1,0-3.729L108.941,4.29a2.638,2.638,0,0,1,3.729,3.733L102.118,18.574a2.641,2.641,0,0,1-3.733,0ZM87.061,13.192V2.637a2.639,2.639,0,0,1,5.278,0V13.192a2.639,2.639,0,0,1-5.278,0Z","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h4 darkblue pt1 "},[_vm._v("Hovsa! Din betaling til "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk","target":"_blank"}},[_vm._v("Håndværker.dk")]),_vm._v(" mislykkedes.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 "},[_vm._v("Vi kunne ikke behandle din sidste betaling. Din konto forbliver aktiv, men opdater venligst dine kreditkortoplysninger for at undgå suspendering.")]),_vm._v(" "),_c('button',{staticClass:" mb2 mt3  py1 col-lg-4 col-md-4 col-sm-12 button green-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){_vm.showmodal(),_vm.hidemodalinitial(),_vm.showsessionnewcredit()}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdater kreditkort")])]),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap p0"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så\n                "),_c('a',{staticClass:"no-underlined",attrs:{"href":"tel:+45#4570228014"}},[_vm._v("ring")]),_vm._v("\n                eller\n                "),_c('a',{staticClass:"no-underlined ",attrs:{"href":"mailto:support@haandvaerker.dk"}},[_vm._v("e-mail")]),_vm._v("\n                support.")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din henvendelse,")]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("Vi ringer til dig hurtigst muligt")]),_vm._v(" "),_c('button',{staticClass:" my2 col-lg-4 col-md-4 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){return _vm.hidemodaltak('')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-between items-center  mintgreen-background",staticStyle:{"height":"50px"},attrs:{"id":"mainbar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex mx-auto justify-end "},[_c('span',{staticClass:" darkblue mb0 h6"},[_vm._v("Ring 7022 8014")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center-mobile"},[_c('p',{staticClass:"no-hover flex justify-start items-center"},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1  darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 center mb3 mt2"},[_c('p',{staticClass:"h4"},[_vm._v("Vælg venligst tilgængelig tid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-background  flex items-center justify-center",attrs:{"id":"footer2"}},[_c('p',{staticClass:"white h6",staticStyle:{"height":"14px"}},[_vm._v("Copyright @ 2022 "),_c('a',{attrs:{"target":"_blank","href":"https://www.haandvaerker.dk/"}},[_vm._v("Håndværker.dk")]),_vm._v(". Alle rettigheder forbeholdes.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singupcvr_vue__ = __webpack_require__(1082);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7ccefa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_singupcvr_vue__ = __webpack_require__(1083);
function injectStyle (ssrContext) {
  __webpack_require__(1081)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_singupcvr_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e7ccefa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_singupcvr_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1081 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_moment__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invo',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker__["a" /* default */],
    moment: __WEBPACK_IMPORTED_MODULE_2_moment___default.a
  },
  data: function data() {
    return {
      mainalldatetimeweek: [],
      loading: false,
      loadingnext: false,
      pid: '',
      allpackage: [],
      orderid: '',
      pitems: [],
      status: '',
      haaid: '',
      levid: '',
      partnerprofile: [],
      Adresse: '',
      Bygningsnr: '',
      partnername: '',
      zip: '',
      city: '',
      road: '',
      datebooking: '',
      step: 1,
      selecteddate: '',
      selectedtimestart: '',
      selectedtimeend: '',
      options: [],
      Searchvalue: '',
      optiontimes: [],
      optiondate: [],
      highlighted: {
        dates: []
      },
      showallinfo: true,
      fullurl: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() < Date.now();
        }
      },
      showwrongdate: false,
      showwrongtime: false,
      timearrayperdate: [],
      alldatetime: [],
      prol: [],
      weenew: [],
      selectedimeslot: '',
      disablecreateorder: false,
      timeout: null,
      description: '',
      waitfortext: true,
      productdetails: false,
      productname: '',
      price: '',
      photourl: '',
      priceformatted: '',
      showreminder: false,
      dunninginvoice: [],
      perndinginvoice: [],
      showsessionnewcreditpro: '',
      form2: {
        name: '',
        email: '',
        telefonnummer: '',
        terms_conditions: '',
        cvr: ''
      },
      rulesform2: {
        name: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit navn',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt mobilnr.',
          trigger: 'blur'
        }],
        cvr: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste et gyldigt cvr.',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    this.originalid = localStorage.getItem('yourid');
    this.pid = pathArray[pathArray.length - 1];
    if (this.pid !== null) {
      this.decode(this.pid);
    }
  },
  mounted: function mounted() {
    if (typeof document.querySelector('.smartbanner') !== 'undefined') {
      setTimeout(function () {
        var hideinfo = document.querySelector('.smartbanner');
        hideinfo.style.display = 'none';
        document.getElementById('partnerloginapp').style.marginTop = 0;
      }, 3000);
    }
  },

  watch: {},
  methods: {
    closeconfirmbooking: function closeconfirmbooking() {
      this.$refs['confirmbooking'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    closepopuperror: function closepopuperror() {
      this.$refs['incorrecturl'].hide();
    },
    showpopup: function showpopup() {
      this.$refs['packageorder'].show();
    },
    closepopup: function closepopup() {
      this.$refs['packageorder'].hide();
    },
    showmodal: function showmodal() {
      this.$refs.paymentmethods.show();
    },
    showmodalinitial: function showmodalinitial() {
      this.$refs.initialreminder.show();
    },
    hidemodal: function hidemodal() {
      this.$refs.paymentmethods.hide();
    },
    hidemodalinitial: function hidemodalinitial() {
      this.updateprofileskip();
      this.$refs.initialreminder.hide();
    },
    hidemodalsuccess: function hidemodalsuccess() {
      this.$refs.sendingsuccess.hide();
    },
    nextstep: function nextstep() {
      this.step = this.step + 1;
    },
    getaddress: function getaddress() {
      var qry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var cb = arguments[1];

      var vm = this;
      if (qry !== '' && qry.length < 15) {
        var selettion = [];
        this.focused();
        this.Searchvalue = qry;
        this.$http.get('https://bitrixapimaster.haandvaerker.dk/v1/bbr/getBbr?q=' + qry, { emulateJSON: true }).then(function (response) {
          if (response.data.success) {
            vm.addressResults = response.data.data;
            vm.addressResults.forEach(function (item) {
              var sample = [];
              sample['value'] = item.tekst;
              selettion.push(sample);
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }
      clearTimeout(this.timeout);
      this.timeout = setTimeout(function () {
        cb(selettion);
      }, 1000 * Math.random());
    },
    getaddressinfo: function getaddressinfo(item) {
      var _this = this;

      this.disablecreateorder = true;
      this.Adresse = item.value;
      var addre = this.Adresse;
      if (addre.length < 15) {
        this.city = '';
        this.zip = '';
        this.road = '';
        this.Bygningsnr = '';
        return false;
      }
      this.$http.get('https://bitrixapimaster.haandvaerker.dk/v1/bbr/getBbr?q=' + addre, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this.city = response.data.data[0]['adresse']['postnrnavn'];
          _this.zip = response.data.data[0]['adresse']['postnr'];
          _this.road = response.data.data[0]['adresse']['vejnavn'];
          _this.Bygningsnr = response.data.data[0]['adresse']['husnr'];
          _this.disablecreateorder = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    supplierprofile: function supplierprofile(id) {
      var _this2 = this;

      this.$http.get('https://bitrixapimaster.haandvaerker.dk/v1/supplier/getSupplierInfo/' + id, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.partnerprofile = res.data;
          _this2.partnertelephone = res.data.MOBILE;
          _this2.partnername = res.data.TITLE;
          _this2.partneremail = res.data.EMAIL;
          _this2.getPhotoPackageById();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getpartnerinvoice: function getpartnerinvoice() {
      var _this3 = this;

      if (this.check1hour()) {
        this.$http.get('https://bitrixapimaster.haandvaerker.dk/v1/reepay/getPartnerInvoice/' + this.levid, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var checkinvoices = res.data.content;
            var dunninginvoices = [];
            var pendinginvoices = [];
            dunninginvoices = checkinvoices.filter(function (item) {
              return item.state === 'pending';
            });
            pendinginvoices = checkinvoices.filter(function (item) {
              return item.state === 'dunning';
            });
            _this3.dunninginvoice = dunninginvoices.length;
            _this3.perndinginvoice = pendinginvoices.length;
            if (_this3.dunninginvoice > 0 || _this3.perndinginvoice > 0) {
              _this3.showreminder = true;
              _this3.showmodalinitial();
              _this3.setwarning();
            }
            _this3.loading = false;
            _this3.waitfortext = false;
          }
        }, function (response) {
          _this3.waitfortext = false;
          console.log('Error: ', response);
        });
      } else {
        this.showreminder = false;
      }
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this4 = this;

      this.$http.post('https://bitrixapimaster.haandvaerker.dk/v1/reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          var data = res.data;
          _this4.showsessionnewcreditpro = data.id;
          _this4.showpopupreepay();
        } else {
          console.log('Error in showing session');
        }
      });
    },
    showpopupreepay: function showpopupreepay() {
      var m = this;
      this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
      this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
        m.datamethod = data.payment_method;
        console.log('done adding card', data);
        setTimeout(function () {
          m.wait4hourreminder();
        }, 5000);
      });
    },
    wait4hourreminder: function wait4hourreminder() {
      this.loading = false;
      var timenow = new Date();
      var timeafter4hour = new Date();
      timeafter4hour.setHours(timenow.getHours() + 4);
      localStorage.removeItem('timeaddedcard');
      localStorage.removeItem('timeaddedcardexpiry');
      localStorage.setItem('timeaddedcard', timenow);
      localStorage.setItem('timeaddedcardexpiry', timeafter4hour);
      this.showreminder = false;
      this.setwarning();
      this.hidemodalinitial();
      this.hidemodal();
      this.updateprofilepayment();
    },
    check1hour: function check1hour() {
      var timeaccessnow = new Date();
      var togettime = localStorage.getItem('timeaddedcard');
      var togettimeexpiry = localStorage.getItem('timeaddedcardexpiry');
      var togettimenew = new Date(togettime);
      var togettimeexpirynew = new Date(togettimeexpiry);
      if (togettime !== null && togettimeexpiry !== null) {
        if (timeaccessnow.getTime() > togettimenew.getTime() && timeaccessnow.getTime() < togettimeexpirynew.getTime()) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    updateprofileskip: function updateprofileskip() {
      var data = {
        UF_CRM_COMPANY_SKIP_PAYMENT_REMINDER: 1
      };
      this.$http.post('https://bitrixapimaster.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      var data = {
        UF_CRM_COMPANY_PAYMENT_METHOD_UPDATED: 1
      };
      this.$http.post('https://bitrixapimaster.haandvaerker.dk/v1/supplier/updateSupplierCustomFields/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    formatDate: function formatDate(date) {
      var d = new Date(date);
      var month = '' + (d.getMonth() + 1);
      var day = '' + d.getDate();
      var year = d.getFullYear();
      if (month.length < 2) {
        month = '0' + month;
      }
      if (day.length < 2) {
        day = '0' + day;
      }
      return [year, month, day].join('-');
    },
    sethighlighteddates: function sethighlighteddates() {
      this.highlighted.dates = this.optiondate;
    },
    limitbankregis: function limitbankregis(e) {
      return String(e).substring(0, 4);
    },
    createrOrder: function createrOrder() {
      var _this5 = this;

      this.loading = true;
      var data = {
        name: this.form2.name,
        email: this.form2.email,
        phone: this.form2.telefonnummer,
        cvr: this.form2.cvr
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1//bitrix/updateFbLeadSpa/' + this.levid, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.loading = false;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    decode: function decode() {
      var _this6 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data === '') {
            console.log(res.data);
            _this6.showpopuperror();
          }
          _this6.levid = res.success.id;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    setwarning: function setwarning() {
      if (this.showreminder) {
        var reminderbar = document.getElementById('reminderbar');
        reminderbar.style.position = 'fixed';
        reminderbar.style.zIndex = '1026';
        reminderbar.classList.remove('hide');
        var navbar = document.getElementById('mainbar');
        navbar.style.borderBottom = '0px';
        navbar.style.position = 'none';
        navbar.style.marginTop = '22px';
      } else {
        reminderbar = document.getElementById('reminderbar');
        reminderbar.classList.add('hide');
        navbar = document.getElementById('mainbar');
        navbar.style.marginTop = '0px';
      }
    }
  }
});

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"packagemain"}},[_c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"m0"},[_vm._v("Vi kunne ikke behandle din sidste betaling.")]),_c('p',{staticClass:"semi-bold m0 pointer",on:{"click":function($event){return _vm.showmodalinitial()}}},[_vm._v(" Opdater din betaling")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center highlightsmorelesser",staticStyle:{"height":"64px"},attrs:{"id":"main2bar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex flex-wrap mx-auto "},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:" flex  flex-auto justify-end  items-center ",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:" flex flex-auto justify-end justify-center-mobile items-center truspilotmobile",staticStyle:{"height":"inherit"}},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"290px","alt":"Håndværker.dk logo","height":"23px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])])])]),_vm._v(" "),_c('div',{staticClass:"lg-col-6 md-col-6 sm-col-12 mx-auto flex items-center py1 p2",attrs:{"id":"packageform"}},[(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_vm._m(2)]):_c('div',{},[_c('p',{staticClass:"h3 center darkblue bold mt2"},[_vm._v("Opret en gratis bruger i dag, og modtag dit login. Begynd at få opgaver i nærheden af ​​dig!")]),_vm._v(" "),_c('div',{staticClass:"highlights max-width-6 mx-auto flex flex-column p3 m3"},[_c('div',{staticClass:"p2"},[_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"model":_vm.form2,"rules":_vm.rulesform2,"label-position":"top"}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype",attrs:{"label":"Dit Navn","prop":"name"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"maxlength":"25","placeholder":"Navn"},model:{value:(_vm.form2.name),callback:function ($$v) {_vm.$set(_vm.form2, "name", $$v)},expression:"form2.name"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype",attrs:{"label":"Telefonnummer","prop":"telefonnummer"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","oninput":"onlyNumber('phone')","id":"phone","placeholder":"Mobilnr.(8 cifre)"},model:{value:(_vm.form2.telefonnummer),callback:function ($$v) {_vm.$set(_vm.form2, "telefonnummer", _vm._n($$v))},expression:"form2.telefonnummer"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"E-mail"},model:{value:(_vm.form2.email),callback:function ($$v) {_vm.$set(_vm.form2, "email", $$v)},expression:"form2.email"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype",attrs:{"label":"CVR nummer","prop":"cvr"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"CVR"},model:{value:(_vm.form2.cvr),callback:function ($$v) {_vm.$set(_vm.form2, "cvr", $$v)},expression:"form2.cvr"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-center px2"},[_c('button',{staticClass:"mt2 not-rounded action-button justify-center h5 regular no-hover flex justify-start items-center p2 line-height0 mb1",attrs:{"type":"submit","disabled":_vm.disablecreateorder},on:{"click":function($event){return _vm.updateinfo()}}},[_vm._v("Hent aktiveringslink\n                          ")])])],1)],1)])])]),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"darkblue-background flex flex-column items-center justify-center",attrs:{"id":"footer1"}},[_c('p',{staticClass:"white h5 "},[_vm._v("Forbind med os")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center my2"},[_c('a',{attrs:{"target":"_new","href":"https://www.facebook.com/haandvaerkerdk?ref=pm"}},[_c('span',{staticClass:"lazyload mr2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","role":"img","aria-label":"icon-facebook","viewBox":"0 0 1024 1024"}},[_c('title',[_vm._v("Facebook")]),_c('path',{attrs:{"d":"M1024 512C1024 229.2 794.8 0 512 0S0 229.2 0 512c0 255.6 187.2 467.4 432 505.8V660H302V512h130V399.2C432 270.9 508.4 200 625.4 200c56 0 114.6 10 114.6 10v126h-64.6c-63.6 0-83.4 39.5-83.4 80v96h142l-22.7 148H592v357.8C836.8 979.4 1024 767.6 1024 512z","fill":"#1877F2"}}),_c('path',{attrs:{"d":"M711.3 660L734 512H592v-96c0-40.5 19.8-80 83.4-80H740V210c0 0-58.6-10-114.6-10 -117 0-193.4 70.9-193.4 199.2V512H302v148h130v357.8c26.1 4.1 52.8 6.2 80 6.2s53.9-2.1 80-6.2V660H711.3z","fill":"#FFF","role":"img","aria-label":"Facebook"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company/h%C3%A5ndv%C3%A6rker-dk?ref=pm","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 455.731 455.731"},attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","width":"32","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 455.731 455.731","xml:space":"preserve","aria-label":"Linkedin"}},[_c('g',[_c('rect',{staticStyle:{"fill":"#0084B1"},attrs:{"x":"0","y":"0","width":"455.731","height":"455.731"}}),_vm._v(" "),_c('g',[_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M107.255,69.215c20.873,0.017,38.088,17.257,38.043,38.234c-0.05,21.965-18.278,38.52-38.3,38.043    c-20.308,0.411-38.155-16.551-38.151-38.188C68.847,86.319,86.129,69.199,107.255,69.215z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M129.431,386.471H84.71c-5.804,0-10.509-4.705-10.509-10.509V185.18    c0-5.804,4.705-10.509,10.509-10.509h44.721c5.804,0,10.509,4.705,10.509,10.509v190.783    C139.939,381.766,135.235,386.471,129.431,386.471z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M386.884,241.682c0-39.996-32.423-72.42-72.42-72.42h-11.47c-21.882,0-41.214,10.918-52.842,27.606    c-1.268,1.819-2.442,3.708-3.52,5.658c-0.373-0.056-0.594-0.085-0.599-0.075v-23.418c0-2.409-1.953-4.363-4.363-4.363h-55.795    c-2.409,0-4.363,1.953-4.363,4.363V382.11c0,2.409,1.952,4.362,4.361,4.363l57.011,0.014c2.41,0.001,4.364-1.953,4.364-4.363    V264.801c0-20.28,16.175-37.119,36.454-37.348c10.352-0.117,19.737,4.031,26.501,10.799c6.675,6.671,10.802,15.895,10.802,26.079    v117.808c0,2.409,1.953,4.362,4.361,4.363l57.152,0.014c2.41,0.001,4.364-1.953,4.364-4.363V241.682z"}})])]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://trustpilot.com/review/h%C3%A5ndv%C3%A6rker.dk?ref=pm","title":"Trustpilot - Haandvaerker.dk","name":"Trustpilot - Haandvaerker.dk","rel":"nofollow","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"aria-label":"Trustpilot","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 128 128","enable-background":"new 0 0 128 128","xml:space":"preserve"}},[_c('image',{attrs:{"id":"image0","width":"128","height":"128","x":"0","y":"0","href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAQAAABpN6lAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQflCRUMGBqW6X0KAAAFXElEQVR42u2dW2gcZRiG32+bRu2BaG3UegiNtJQ2bSlGoSJqKRKJCEpB LdKClL2wBAR71wtBBL1QkrsSD6VgS6QKifWQ2oYk0CohbaOxkS3BUMSY1poES0ysJDb7epGwbrKH 7Gbm+782+78Qsjs7M/t8z/7/zOz8s7uC6bACUVShDMuwsDOGfrTgoMSm7goAsBh12IuINZvDxFGP fTIBCMBifIPt1kQGaUe1TEQA1BVk+cB21AHCCvQUVONPThybI4gWbPlABFFhDBusOQxzQTi64Hd8 2TImpDWDbQq3/3sBXoAX4AV4AV6AF+AFWANYxwuwBrCOF2ANYB0vwBrAOl6ANYB1vABrAOt4AdYA 1rEX8GNhC/gHewtbwAnpRF8hC2ic/jOL7dDYBO6SET6Mc3YIti2gVUYA6UJ/oQpomvW/wARM4ovp W4ZbAUsBp2R4+lYHrhSigMTrLnEcKzwBnFG0WSew2w12yGNJNorwB1ZYYNi1gBmvuVxPbBALRkDT HPcdxaoL/CCVMyfwFgxhuXsQqxaQstGTcXxtAXLDCIDRnsCmC8RkY+pELsEwbnONYtMC0m7w5BpO uEexEdCY53TFWHSBi7Im/QMswSCK3cJYtICMr7OMoM01jIWAbIc8zjuB+y4wgDLJ+JxciStY5BLH fQtokizKZRin3OIEawENOJ5pvRmX+U5+zbZKbsHGjA9mWusebJt3DQySOGvpeKudwl/Cz4KUEEwA SXZxTfAy5l3+o/wlGH5wAeQod5kUH+F+/hsUPgwBJPkxHX/0iqvYGgZ4WALIn/mQw/Kf4WA42OEJ IMf5OiV4cXMWX8xaxsOCDlMASTazVLn8tfw+TOCwBZCXqfhRbO7maLi44QsgJ/k2ixSKX84j4cNq CCDJDq4OufxK9mmAagkgr/KF0IoX7uO4DqaeAJL8kCGc42Mpj+shar8dvoCd8lOg8p/CEdyjB6j9 dngDznLe14GxiO+gRbN8VydEPscr8lfe5ZfjE2zVRnMjYBKrZCjP8l/CByjRR3NzRuh0fuVzCT/C URflAwoHLGmS16lObsZRrHfCBTctgPlcAMManHFXvpsW0CmXcix+BQ7hOXfFuxKQYwfgE2jA/ckT 0IMINinTqR4JTqU8B4pFfJPXE0v08X2+yJUAn9WG098NdsucZ4r4ABrwOIBLaEc72uS3xCPq143o d4E5OwCfx3voQQ3apXf2YzLOZuxcwAJ4K/bgDNZJPMvyqgK0twGxrM+9nj0kT/LuLPMs5TVNQO3j gCwjwYyiC5sAVOE8n840l/yNk6qEyi1gS4ZnLeGnM+aL810uzjDvLk1AXQEXM5S0Ne2A1lk+mEHW hB6ibhdIswFkhPvxLVanmfsRdPPl1MkyglZFRtUWkPJuPocBrUNcmrJUVA9RU8DA7HEiVuc0oNU7 e8vB0qSjxJCj2QVmXAvCYtaiGbmMG61DJ19LniBDOK1GqdgCnkx6lrXsynPpL3ln0vI1WpB6AgaZ uNhpngNaA9yWWMO94Q2HzoxeFzgmkwDAZTyMw/P64tb70Ma3pjTKZXTqYOoJaAQAVqIbuwPQvYFT LPt/fQpR6gBXuTi0Aa0/uQNg+c3VBb7C7WhGbShX/t6BRtbjd3RrgGoJGMF5VIe4vldxDr3BV5Ma /8XK1gDW8QKsAazjBVgDWMcLsAawjhdgDWAdL8AawDpegDWAdbwAawDreAHWANbxAqwBrOMFWANY xwvAmDWCacYill9oegOkP4IWawbTtPif3ZUY6q05zFIvMf/T24BMoBoHEA++xpsocRxA9fSPr0+F FYiiCmUL/leIx9CPFhyU6cu4/wM76BhE+f9iSAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wOS0y MVQwOToyNDoyNiswMzowMFrxEEMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDktMjFUMDk6MjQ6 MjYrMDM6MDArrKj/AAAAAElFTkSuQmCC"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/haandvaerker.dk?ref=pm","rel":"nofollow","title":"Instagram - Haandvaerker.dk","name":"Instagram - Haandvaerker.dk","id":"Instagram - Haandvaerker.dk","target":"_new"}},[_c('span',{staticClass:"mx2 lazyload",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.09 32.09","width":"32","height":"32"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"width":"32.09","height":"32.09"}})])]),_vm._v(" "),_c('g',{staticStyle:{"clip-path":"url(#clip-path)"}},[_c('image',{attrs:{"width":"134","height":"133","transform":"translate(-0.05 -0.26) scale(0.24 0.25)","xlink:href":"data:image/png;base64,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"}})]),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M23.84,3H8.25A5.27,5.27,0,0,0,3,8.25V23.84A5.26,5.26,0,0,0,8.25,29.1H23.84a5.25,5.25,0,0,0,5.26-5.26V8.25A5.26,5.26,0,0,0,23.84,3ZM27,23.13A3.91,3.91,0,0,1,23.13,27H9a3.92,3.92,0,0,1-3.91-3.91V9A3.92,3.92,0,0,1,9,5.05H23.13A3.92,3.92,0,0,1,27,9Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M21.5,8.72a1.4,1.4,0,1,0,1.4-1.4h0A1.4,1.4,0,0,0,21.5,8.72Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M16.11,9.75h-.06A6.27,6.27,0,0,0,9.75,16h0a6.3,6.3,0,1,0,6.36-6.23ZM16,20.39A4.34,4.34,0,0,1,11.7,16h0a4.33,4.33,0,0,1,4.35-4.3h0A4.35,4.35,0,0,1,16,20.39Z"}})])])])])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('b-modal',{ref:"packageorder",attrs:{"centered":"","hide-header":"","id":"packageorder","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.104","height":"122.269","viewBox":"0 0 92.104 122.269"}},[_c('g',{attrs:{"id":"Group_4292","data-name":"Group 4292","transform":"translate(-1901.896 -1841.384)"}},[_c('path',{attrs:{"id":"Path_2691","data-name":"Path 2691","d":"M2050.619,2063.713,2038,2057.206a.61.61,0,0,0-.2-.2c-.106-.06-10.945-6.476-13.783-15.262a131.483,131.483,0,0,0-8.62-20.592c.785-1.812,5.4-12.47,6.642-15.655,1.9-4.891.106-7.171-.83-7.971,3.533-7.186,3.08-8.831,2.159-9.466a1.467,1.467,0,0,0-1.132-.2c-.015,0-.03.015-.06.015a3.884,3.884,0,0,0-1.132-2.989,3.2,3.2,0,0,0-3.261-.2,3.64,3.64,0,0,0-1,.709,7.469,7.469,0,0,0-3.97-.74c-.528.015-2.144.076-8.711,8.348-2.627,3.306-5.133,6.793-6.114,8.348-.906-.951-1.464-1.555-1.495-1.585a.618.618,0,0,0-.725-.121c-.121.06-2.536,1.344-3.155,3.14a8.657,8.657,0,0,0-1.676-.921,1.091,1.091,0,0,0-1.117.121c-.377.272-.83.921-.709,3.276a3.489,3.489,0,0,0-1.193.06,3.189,3.189,0,0,0-1.374.694c-.121-.936-.272-1.812-.423-2.551-.679-3.216-3.412-4.967-7.5-4.8h-.091a.643.643,0,0,0-.468.211c-.317.362-.423.468,1.072,13.421.287,2.551.574,4.952.755,6.7.438,4.2,3.336,9.616,5.072,12.862a24.986,24.986,0,0,1,1.313,2.627c-.091.694-1.691,4.514-4.74,11.368-.242.528-.393.876-.468,1.072l-12.168,6.793a.654.654,0,0,0-.3.392.6.6,0,0,0,.091.483l14.719,20.788a.64.64,0,0,0,.468.257h.03a.566.566,0,0,0,.453-.211l10.628-12.319a.6.6,0,0,0,0-.785l-.06-.061,1.026-.785c.2.2.393.377.589.574,4.333,4.061,8.952,6.854,12.7,7.669,7.548,1.661,16.742,6.386,16.833,6.431a.594.594,0,0,0,.272.06c.06,0,.106-.015.151-.015l10.19,8.832Zm-29.695-58.65c-.876,2.234-3.412,8.167-5.118,12.122a.189.189,0,0,0-.091-.166c-.166-.106-.332-.2-.5-.3-.2-.121-.393-.242-.6-.362a2.474,2.474,0,0,1-.483-.408,2.742,2.742,0,0,0-.483-.438.2.2,0,1,0-.211.332,2.337,2.337,0,0,1,.408.362,2.626,2.626,0,0,0,.574.483l.589.362c.166.106.332.211.513.317a.218.218,0,0,0,.106.03.244.244,0,0,0,.136-.045c-.438,1-.8,1.857-1.072,2.491a19.218,19.218,0,0,0-2.355-3.321c-.3-.317-.694-.725-1.147-1.208,1.162-1.9,6.22-10.19,9.5-16.636C2021.347,1999.4,2022.4,2001.259,2020.924,2005.063Zm1.57-16c.045-.015.151-.03.181,0,.045.03,1.026.83-2.883,8.6-2.566,5.1-6.386,11.564-8.454,14.991a2.052,2.052,0,0,1-1.087-1.253.205.205,0,1,0-.408.045,2.438,2.438,0,0,0,1.283,1.555c-.347.574-.634,1.042-.845,1.374-1.042-1.1-2.295-2.431-3.623-3.834,4.574-7.775,11.836-18.9,15.081-21.12a.573.573,0,0,0,.2-.136A3.094,3.094,0,0,1,2022.494,1989.061Zm-4.3-3.231q1.427-.521,2.083,0c.679.558.725,1.947.664,2.687-1.359,1-3.91,3.668-8.816,11.036-2.823,4.242-5.374,8.469-6.341,10.084-1.4-1.479-2.838-3-4.151-4.393,5.978-7.654,12.651-15.761,15.413-18.478a.9.9,0,0,0,.226-.136.574.574,0,0,0,.136-.2A3.554,3.554,0,0,1,2018.192,1985.83Zm-13.119,7.926c5.9-7.443,7.518-7.865,7.79-7.88a7.254,7.254,0,0,1,2.989.423c-3.4,3.427-9.8,11.4-13.36,15.912a4.189,4.189,0,0,1-.408-.317,2.976,2.976,0,0,0-.634-.438.212.212,0,0,0-.211.03.187.187,0,0,0-.06.211c.045.151.091.3.151.468a.858.858,0,0,0,.06.181,2.289,2.289,0,0,1-.815-1.072.2.2,0,1,0-.392.03c.045.6,1.027,1.495,1.479,1.691a.136.136,0,0,0,.075.015.244.244,0,0,0,.136-.045.189.189,0,0,0,.06-.2c-.045-.211-.121-.408-.181-.619a.4.4,0,0,0,.091.075c.136.106.272.226.423.332-.574.725-1.057,1.344-1.434,1.827-.71-.755-1.374-1.464-1.963-2.083A99.467,99.467,0,0,1,2005.073,1993.756Zm-9.118,7.2c.347.362.951,1.011,1.736,1.842h0c.181.181.362.392.558.589a2.78,2.78,0,0,1-2.174,2.234q-1.291-1.2-2.355-2.038C1993.735,2002.557,1995.094,2001.485,1995.955,2000.957Zm-5.42,2.053a9.586,9.586,0,0,1,2.023,1.223.581.581,0,0,0,.528.407c.423.332.891.74,1.4,1.193a1.529,1.529,0,0,1-.106.619,2.345,2.345,0,0,1-1.042,1.147l-.015-.015a10.021,10.021,0,0,0-2.974-1.993A5.953,5.953,0,0,1,1990.535,2003.01Zm-2.31,3.5a2.809,2.809,0,0,1,1.389.106h.015a7.859,7.859,0,0,1,2.6,1.6,4.558,4.558,0,0,1-.362,2.853,3.41,3.41,0,0,1-1.963,1.57c-1.359-1.057-2.37-1.842-2.808-2.159,0-.076-.015-.136-.015-.211-.091-.891-.2-1.766-.287-2.612A2.2,2.2,0,0,1,1988.225,2006.512Zm-.951,5.616c.453.347,1.027.785,1.676,1.3a4.787,4.787,0,0,1-1.193,2.476C1987.576,2014.725,1987.425,2013.427,1987.274,2012.128Zm-8.167-12.258a10,10,0,0,1,1.721.136c.242,1.706.845,6.869-.5,8.469a1.609,1.609,0,0,1-.347.3C1979.545,2005,1979.137,2001.168,1979.107,1999.87Zm15.051,61.458-11.911-14.085c.106-.226.242-.543.408-.906,2.31-5.193,3.578-8.137,4.227-9.828.151.468.332.921.5,1.374l.106.272a.215.215,0,0,0,.2.136.137.137,0,0,0,.075-.015.208.208,0,0,0,.121-.257l-.106-.272c-.226-.589-.453-1.208-.649-1.842.151-.423.257-.74.317-.966.151.151.3.317.468.483a3.869,3.869,0,0,0,1.6,1.238c.015,0,.045.015.06.015a.215.215,0,0,0,.2-.136.21.21,0,0,0-.136-.257,3.415,3.415,0,0,1-1.419-1.117,7.37,7.37,0,0,0-.679-.694c0-.453-.377-1.177-1.449-3.185-1.691-3.155-4.514-8.439-4.937-12.409-.181-1.751-.453-4.167-.755-6.718-.106-.936-.226-1.947-.347-2.974a1.6,1.6,0,0,0,.6-.468c1.419-1.691.876-6.748.6-8.635a4.57,4.57,0,0,1,3.729,3.638c.362,1.706.619,4.121.891,6.673.528,4.876,1.011,9.465,2.325,10.99l.091.091a31.6,31.6,0,0,1,9.163,13.1,97.053,97.053,0,0,1,4,17.376l-8.152-8.273a.634.634,0,0,0-.211-.136c-.408-.151-4.046-1.449-5.737.272-1.042,1.057-1.042,2.944.015,5.616a35.774,35.774,0,0,0,7.745,11.187Zm.74-11.141a5.22,5.22,0,0,1-3.518,1.766,2.867,2.867,0,0,1-2.023-1.1c-.317-.634-.619-1.268-.86-1.887-.845-2.144-.951-3.638-.287-4.318.936-.951,3.336-.377,4.318-.03l3.08,3.125A3.758,3.758,0,0,1,1994.9,2050.187Zm1.63,10.145c-.015-.015-.015-.03-.03-.03a.429.429,0,0,0-.151-.136,39.544,39.544,0,0,1-6.476-8.3,2.451,2.451,0,0,0,1.389.528.618.618,0,0,0,.166-.015,5.7,5.7,0,0,0,3.789-1.932,3.966,3.966,0,0,0,.8-2.28l5.842,5.948a.6.6,0,0,0,.6.151c.242.377.453.74.649,1.117.091.181.166.377.257.574a2.84,2.84,0,0,0,.981,1.449.279.279,0,0,0,.106.03.19.19,0,0,0,.166-.091.194.194,0,0,0-.06-.272,2.314,2.314,0,0,1-.815-1.253,3.667,3.667,0,0,0-.272-.6,11.614,11.614,0,0,0-.679-1.163.683.683,0,0,0,.106-.423c0-.015-.015-.121-.045-.332a4.011,4.011,0,0,0,1.147,1.223.279.279,0,0,0,.106.03.174.174,0,0,0,.166-.091.194.194,0,0,0-.06-.272,3.964,3.964,0,0,1-1.072-1.162,6.52,6.52,0,0,0-.408-.559,99.352,99.352,0,0,0-4.151-18.267,32.383,32.383,0,0,0-9.511-13.617,11.165,11.165,0,0,1-1.253-4.2,4.553,4.553,0,0,0,1.479-2.642c4.453,3.517,12.288,10.039,14.3,13.843,2.823,5.359,3.17,8.545,3.17,8.575a.6.6,0,0,0,.6.543h.06a.609.609,0,0,0,.544-.664c-.015-.136-.347-3.427-3.306-9.028-2.1-3.97-9.843-10.462-14.4-14.055a3.7,3.7,0,0,0,1.947-1.676,4.658,4.658,0,0,0,.453-2.627c5.254,4.831,16.727,18.252,17.708,20.229a6.048,6.048,0,0,1,.725,3.4.6.6,0,0,0,.483.71c.045,0,.075.015.121.015a.585.585,0,0,0,.589-.5,7.05,7.05,0,0,0-.83-4.167c-1.132-2.28-12.59-15.564-17.8-20.41a2.606,2.606,0,0,0,1.117-1.3,4.045,4.045,0,0,0,.106-.408c3.276,3.019,8.3,8.56,15.957,18.463a2.615,2.615,0,0,1-.8.574.2.2,0,0,0-.136.257.209.209,0,0,0,.2.151.114.114,0,0,0,.06-.015,2.612,2.612,0,0,0,.951-.649c.181.242.362.468.543.71.332.438.589.755.725.936a.613.613,0,0,0,.966-.755c-.136-.181-.377-.483-.71-.921-6.778-8.816-12.2-15.172-16.2-18.991a3.125,3.125,0,0,0,2.159-2.219c3.925,4.167,10.628,11.277,12.862,13.617a21.308,21.308,0,0,1,2.748,4.046.61.61,0,0,0,.075.136,129.98,129.98,0,0,1,8.62,20.592c2.642,8.182,11.5,14.176,13.8,15.61l-10.507,17.074c-2.053-1.011-9.949-4.816-16.636-6.28C2005.556,2067.653,2000.68,2064.407,1996.528,2060.331Z","transform":"translate(-56.619 -121.392)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2692","data-name":"Path 2692","d":"M2176.331,2287.492a.2.2,0,0,0-.136-.377,3.274,3.274,0,0,0-1.042.8c-.362.362-.755.725-1.057.74a.2.2,0,0,0-.2.211.2.2,0,0,0,.2.2h.015c.453-.015.891-.438,1.328-.861A3.21,3.21,0,0,1,2176.331,2287.492Z","transform":"translate(-230.941 -378.428)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2693","data-name":"Path 2693","d":"M2179.4,2292.582a6.457,6.457,0,0,1-1.812,1.3.21.21,0,0,0-.136.257.2.2,0,0,0,.2.136.09.09,0,0,0,.06-.015,7.324,7.324,0,0,0,1.962-1.389.21.21,0,0,0,0-.287A.19.19,0,0,0,2179.4,2292.582Z","transform":"translate(-233.954 -383.035)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2694","data-name":"Path 2694","d":"M2221.841,2273.778a3.733,3.733,0,0,0-1.434.921.2.2,0,0,0,.271.3c.091-.091.181-.166.272-.242a1.458,1.458,0,0,0-.272.5.229.229,0,0,0,.045.2.194.194,0,0,0,.151.06h.045a2.066,2.066,0,0,0,.906-.513.2.2,0,0,0,.015-.287.206.206,0,0,0-.257-.045,2.361,2.361,0,0,0,.483-.6.21.21,0,0,0-.015-.211A.234.234,0,0,0,2221.841,2273.778Z","transform":"translate(-270.368 -367.115)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2695","data-name":"Path 2695","d":"M2248.8,2223.215a.2.2,0,0,0-.317-.257c-.347.438-1.268,1.313-1.615,1.344a.2.2,0,0,0-.181.211.2.2,0,0,0,.2.181h.015C2247.476,2224.649,2248.548,2223.532,2248.8,2223.215Z","transform":"translate(-292.742 -323.904)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2696","data-name":"Path 2696","d":"M2254.658,2226.084a6.774,6.774,0,0,0-.679.619,4.453,4.453,0,0,1-.921.77.217.217,0,0,0-.075.272.208.208,0,0,0,.166.091.279.279,0,0,0,.106-.03,5.385,5.385,0,0,0,1-.83,6.167,6.167,0,0,1,.649-.589.2.2,0,0,0,.03-.287A.226.226,0,0,0,2254.658,2226.084Z","transform":"translate(-298.068 -326.591)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2697","data-name":"Path 2697","d":"M2149.733,2444.678l.181-.166a.191.191,0,0,0,.015-.272.214.214,0,0,0-.257-.061,4.307,4.307,0,0,0-.845.725l-.287.287a3.361,3.361,0,0,1-1.1.574.2.2,0,0,0-.151.227.194.194,0,0,0,.2.166h.015a1.974,1.974,0,0,0,1.3-.664A9.273,9.273,0,0,0,2149.733,2444.678Z","transform":"translate(-208.344 -511.777)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2698","data-name":"Path 2698","d":"M2159.032,2452.257a2.59,2.59,0,0,1-1.736.875h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.211.2,2.981,2.981,0,0,0,2.023-1.011.21.21,0,0,0,0-.287A.272.272,0,0,0,2159.032,2452.257Z","transform":"translate(-216.677 -518.601)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2699","data-name":"Path 2699","d":"M2204.882,2119.6a7.162,7.162,0,0,1-2.778-2.566l-.076-.091a.205.205,0,1,0-.332.241l.075.091a7.585,7.585,0,0,0,2.929,2.687.191.191,0,0,0,.091.015.2.2,0,0,0,.181-.121A.176.176,0,0,0,2204.882,2119.6Z","transform":"translate(-254.51 -233.889)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2700","data-name":"Path 2700","d":"M2215.895,2123.347c-.075-.045-.136-.106-.211-.151a.205.205,0,0,0-.241.332,2.556,2.556,0,0,0,.211.151,4.854,4.854,0,0,1,.725.574.193.193,0,0,0,.151.06.245.245,0,0,0,.136-.045.21.21,0,0,0,.015-.287A4.807,4.807,0,0,0,2215.895,2123.347Z","transform":"translate(-266.142 -239.238)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2701","data-name":"Path 2701","d":"M1915.015,2106.408a.6.6,0,0,0,.03-1.208l-12.515-.6a.6.6,0,1,0-.06,1.208l12.515.6Z","transform":"translate(0 -223.476)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2702","data-name":"Path 2702","d":"M1981.406,2006.613l4.635,3.442a.651.651,0,0,0,.362.121.63.63,0,0,0,.483-.241.616.616,0,0,0-.121-.845l-4.635-3.442a.616.616,0,0,0-.845.121A.589.589,0,0,0,1981.406,2006.613Z","transform":"translate(-67.296 -139.366)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2703","data-name":"Path 2703","d":"M2070.719,1955.211a.6.6,0,0,0,.543.332.592.592,0,0,0,.272-.06.605.605,0,0,0,.272-.815l-4.484-8.862a.608.608,0,1,0-1.087.543Z","transform":"translate(-139.474 -88.372)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2704","data-name":"Path 2704","d":"M2170.788,1904h.045a.6.6,0,0,0,.558-.649l-.5-7.609a.59.59,0,0,0-.649-.559.6.6,0,0,0-.559.649l.5,7.609A.6.6,0,0,0,2170.788,1904Z","transform":"translate(-227.361 -45.678)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2705","data-name":"Path 2705","d":"M2295.645,1854.52h.045a.608.608,0,0,0,.6-.558l.966-11.926a.606.606,0,1,0-1.208-.091l-.966,11.926A.607.607,0,0,0,2295.645,1854.52Z","transform":"translate(-333.831)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2706","data-name":"Path 2706","d":"M2379.719,1937a.6.6,0,0,0,.423-.181l4.227-4.182a.608.608,0,0,0-.86-.86l-4.227,4.182a.6.6,0,0,0,0,.86A.63.63,0,0,0,2379.719,1937Z","transform":"translate(-405.163 -76.597)","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din bestilling")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Din aftale er den "+_vm._s(_vm.moment(new Date(_vm.selecteddate.date)).format('Do MMMM YYYY'))+" kl. "+_vm._s(_vm.selectedtimestart))]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mb2 mx-auto"},[_vm._v(_vm._s(_vm.Adresse))]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3"},[_vm._v("Hvis du har spørgsmål er du velkommen til at kontakte os.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p1 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"paymentmethods",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"paymentmethods","no-close-on-backdrop":true}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end mt1"},[_c('button',{staticClass:"h4 white-button no-border not-rounded gibson p0 m0 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodal()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex col-12 m0 p0 flex-wrap "},[_c('b-tabs',{staticClass:"col-12 p0 m0 darkblue ",attrs:{"vertical":"","card":""}},[_c('div',{staticClass:" clearfix white-background  m0 p0"},[_c('div',{staticClass:"flex flex-column gibson col-12 p0"},[_c('div',{staticClass:"flex flex-column col-lg-10 col-md-10 col-sm-12 mx-auto"},[_c('p',{staticClass:"h3 darkblue "},[_vm._v("Hej "+_vm._s(_vm.partnername.replace('&\#039\;','\''))+"!")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue "},[_vm._v("Betalingsmetoder")])]),_vm._v(" "),_c('div',{staticClass:"col-10  mx-auto flex flex-column justify-around my2 p0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reepay",modifiers:{"reepay":true}}],staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center collapsed",attrs:{"role":"tablist"}},[_c('span',{staticClass:"mx2 h5"},[_vm._v("Reepay")])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto lightgrey-background",attrs:{"id":"reepay","visible":"","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"462px"},attrs:{"id":"rp_container"}})])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så ring eller e-mail support.")])])],2),_vm._v(" "),_c('b-modal',{ref:"initialreminder",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"initialreminder","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background col-12 "},[_c('div',{staticClass:" muted-border border shadow col-lg-8 col-md-8 col-sm-12 mx-auto my2 "},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-end my2"},[_c('button',{staticClass:"h3 white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hidemodalinitial()}}},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"17.633","height":"17.632","viewBox":"0 0 17.633 17.632"}},[_c('path',{attrs:{"id":"Close","d":"M-3642.184-128.272a8.815,8.815,0,0,1,8.816-8.816,8.815,8.815,0,0,1,8.817,8.816,8.815,8.815,0,0,1-8.817,8.816A8.815,8.815,0,0,1-3642.184-128.272Zm3.421-5.4a7.583,7.583,0,0,0-2.234,5.4,7.583,7.583,0,0,0,2.234,5.4,7.579,7.579,0,0,0,5.4,2.234,7.576,7.576,0,0,0,5.4-2.234,7.579,7.579,0,0,0,2.234-5.4,7.579,7.579,0,0,0-2.234-5.4,7.576,7.576,0,0,0-5.4-2.234A7.579,7.579,0,0,0-3638.763-133.668Zm2.2,8.588a.655.655,0,0,1,0-.958l2.233-2.234-2.233-2.234a.654.654,0,0,1,0-.958.648.648,0,0,1,.957,0l2.234,2.234,2.234-2.234a.681.681,0,0,1,.958,0,.682.682,0,0,1,0,.958l-2.234,2.234,2.234,2.234a.673.673,0,0,1,0,.958.681.681,0,0,1-.958,0l-2.234-2.234-2.234,2.234a.678.678,0,0,1-.48.2A.671.671,0,0,1-3636.559-125.08Z","transform":"translate(3642.184 137.088)","fill":"#499dbb"}})])])])])]}),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-start gibson col-12 p3"},[_c('p',{staticClass:"my2 darkblue"},[_c('span',{attrs:{"clas":""}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"130","height":"130","viewBox":"0 0 116.96 92.339"}},[_c('path',{attrs:{"id":"Path_5","data-name":"Path 5","d":"M12.879,79.46A43.971,43.971,0,0,1,43.971,4.4,43.477,43.477,0,0,1,64.058,9.244,44.327,44.327,0,0,1,79.3,22.183a2.633,2.633,0,0,1,2.429.222L85.919,25.1l4.062-2.311a2.637,2.637,0,0,1,3.941,2.292V69.358A2.637,2.637,0,0,1,89.9,71.6L85.884,69.12l-4.125,2.735a2.631,2.631,0,0,1-.845.367A43.976,43.976,0,0,1,12.879,79.46Zm3.729-58.455A38.694,38.694,0,1,0,71.33,75.728a39.161,39.161,0,0,0,4.711-5.689l-1.371-.89-4.03,2.7a2.641,2.641,0,0,1-2.884.035L63.45,69.149l-3.919,2.685A2.637,2.637,0,0,1,55.4,69.659V24.624a2.638,2.638,0,0,1,4.1-2.2l3.948,2.625,4.337-2.675a2.65,2.65,0,0,1,2.821.035l4.059,2.64,4.23-2.659-4.1,2.577a39.28,39.28,0,0,0-3.467-3.964,38.7,38.7,0,0,0-54.722,0ZM80.255,72.3a2.668,2.668,0,0,1-1.39-.424A2.644,2.644,0,0,0,80.255,72.3ZM64.809,63.761l4.325,2.748L73.176,63.8a2.641,2.641,0,0,1,2.906-.019l4.2,2.726,4.093-2.713a2.638,2.638,0,0,1,2.846-.044l1.425.88V29.617l-1.507.858a2.633,2.633,0,0,1-2.732-.073l-4.125-2.65-4.233,2.662a2.623,2.623,0,0,1-1.406.405,2.652,2.652,0,0,1-1.437-.424l-4.074-2.65L64.78,30.427a2.639,2.639,0,0,1-2.846-.047l-1.254-.836V64.65l1.222-.839a2.649,2.649,0,0,1,1.494-.462A2.616,2.616,0,0,1,64.809,63.761Zm-33.362-1.1a1.972,1.972,0,1,1,1.969,1.972A1.97,1.97,0,0,1,31.447,62.665Zm33.631-5.5a1.76,1.76,0,1,1,0-3.52H75.629a1.76,1.76,0,0,1,0,3.52ZM31.69,54.776l-1.232-19.72a2.959,2.959,0,0,1,5.917,0l-1.295,19.72c0,1.634-.8,2.219-1.665,2.219S31.69,56.409,31.69,54.776Zm42.182-6.408a1.759,1.759,0,1,1,1.757,1.757A1.758,1.758,0,0,1,73.872,48.368Zm-8.795,1.757a1.759,1.759,0,1,1,0-3.517h3.517a1.759,1.759,0,1,1,0,3.517Zm0-7.035a1.759,1.759,0,1,1,0-3.517H79.147a1.759,1.759,0,1,1,0,3.517ZM103.771,29.9a2.637,2.637,0,1,1,0-5.274h10.552a2.637,2.637,0,0,1,0,5.274ZM98.386,18.574a2.639,2.639,0,0,1,0-3.729L108.941,4.29a2.638,2.638,0,0,1,3.729,3.733L102.118,18.574a2.641,2.641,0,0,1-3.733,0ZM87.061,13.192V2.637a2.639,2.639,0,0,1,5.278,0V13.192a2.639,2.639,0,0,1-5.278,0Z","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h4 darkblue pt1 "},[_vm._v("Hovsa! Din betaling til "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk","target":"_blank"}},[_vm._v("Håndværker.dk")]),_vm._v(" mislykkedes.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 "},[_vm._v("Vi kunne ikke behandle din sidste betaling. Din konto forbliver aktiv, men opdater venligst dine kreditkortoplysninger for at undgå suspendering.")]),_vm._v(" "),_c('button',{staticClass:" mb2 mt3  py1 col-lg-4 col-md-4 col-sm-12 button green-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){_vm.showmodal(),_vm.hidemodalinitial(),_vm.showsessionnewcredit()}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdater kreditkort")])]),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap p0"},[_c('p',[_vm._v("Hvis du har spørgsmål eller tror, ​​der er en fejl, så\n                "),_c('a',{staticClass:"no-underlined",attrs:{"href":"tel:+45#4570228014"}},[_vm._v("ring")]),_vm._v("\n                eller\n                "),_c('a',{staticClass:"no-underlined ",attrs:{"href":"mailto:support@haandvaerker.dk"}},[_vm._v("e-mail")]),_vm._v("\n                support.")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak fordi du opdaterede,")]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("gå venligst her for at logge ind på din konto")]),_vm._v(" "),_c('a',{staticClass:" my2 col-lg-4 col-md-4 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"href":"https://www.kundematch.dk/newpartner/#/login"}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-between items-center  mintgreen-background",staticStyle:{"height":"50px"},attrs:{"id":"mainbar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex mx-auto justify-end "},[_c('div',{},[_c('span',{staticClass:" darkblue mb0 h6"},[_vm._v("Ring 7022 8014")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center-mobile"},[_c('a',{staticClass:"no-hover inline-block flex justify-start items-center",attrs:{"href":"#/newsfeed"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1  darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-background  flex items-center justify-center",attrs:{"id":"footer2"}},[_c('p',{staticClass:"white h6",staticStyle:{"height":"14px"}},[_vm._v("Copyright @ 2022 "),_c('a',{attrs:{"target":"_blank","href":"https://www.haandvaerker.dk/"}},[_vm._v("Håndværker.dk")]),_vm._v(". Alle rettigheder forbeholdes.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1084 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"],
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default.a,
    axios: __WEBPACK_IMPORTED_MODULE_4_axios___default.a
  },
  watch: {},
  data: function data() {
    return {
      loadingnewpayment: false,
      reepaycheckbox: '0',
      leverancheckbox: '1',
      mobilepaycheckbox: '0',
      pid: '',
      fullurl: '',
      disablemobilepaybutton: false,
      showcvr: false,
      cvrerror: '',
      originalid: '',
      levid: '',
      blockid: '',
      step: 1,
      jobstotal: '',
      jobstotalstatic: 3,
      SearchItem: [],
      loading: false,
      loadingjobs: false,
      showsessionnewcreditpro: '',
      disableupdateinfo: false,
      form2: {
        fullname: '',
        email: '',
        telefonnummer: '',
        companyname: '',
        address: '',
        postnum: '',
        city: '',
        cvr: '',
        mobilenummber: ''
      },
      form: {
        regnr: '',
        bankkonto: ''
      },
      rulesform2: {
        fullname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit navn',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        companyname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt 8 digit mobilnr.',
          trigger: 'blur'
        }],
        postnum: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste et gyldigt postnum.',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt by.',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt Addresse.',
          trigger: 'blur'
        }],
        cvr: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Indtast venligst et gyldigt cvr og 8 cifre.',
          trigger: 'blur'
        }]
      },
      rulesform: {
        bankkonto: [{
          min: 6,
          max: 10,
          message: 'Indtast venligst et gyldigt 6 til 10-cifret nummer.',
          trigger: 'blur'
        }, {
          required: true,
          type: 'string',
          message: 'Indtast venligst nummer.',
          trigger: 'blur'
        }],
        regnr: [{
          required: true,
          type: 'string',
          max: 4,
          message: 'Indtast venligst et gyldigt 4-cifret nummer.',
          trigger: 'blur'
        }]
      },
      salesPerson: '',
      hasleveran: '',
      levandorupdate: '',
      regnr: '',
      bankkonto: '',
      options: [],
      bank: '',
      cvr: '',
      gratisbutton: 1,
      consentleveran: true,
      consentreepay: 'accepted',
      leverantext: '',
      isvalidcvr: '',
      showerrorleveran: false,
      showerrorleveranerror: false,
      showerrorreepay: false,
      statusstep: '',
      job: false,
      shorturl: '',
      showMobile: '',
      isused: '',
      mobilepaylink: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      datamethod: '',
      selectedpayment: 'leve',
      paymentoption: [{ value: 'leve', text: 'Leverandørservice (0 kr.)' }, { value: 'reep', text: 'Kreditkort (0 kr.)' }, { value: 'mobpay', text: 'MobilePay (0 kr.)' }]
    };
  },
  created: function created() {
    localStorage.removeItem('yourfulllink');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    localStorage.setItem('yourfulllink', this.fullurl);
    this.originalid = localStorage.getItem('yourid');
    this.pid = pathArray[pathArray.length - 1];
    if (this.pid !== null) {
      this.decode(this.pid);
    }
    setTimeout(function () {
      document.getElementById('partnerloginapp').style.border = 0;
    }, 100);
    this.getdevice();
  },

  mounted: {},
  methods: {
    checkboxselect: function checkboxselect() {
      var _this = this;

      if (this.selectedpayment === 'reep') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      } else if (this.selectedpayment === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
      } else if (this.selectedpayment === 'googlepay') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      } else if (this.selectedpayment === 'applepay') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      }
    },
    getdevice: function getdevice() {
      var ua = navigator.userAgent;
      if (/android/i.test(ua)) {
        this.paymentoption.push({ value: 'googlepay', text: 'Google Pay (0 kr.)' });
      } else if (/iPad|iPhone|iPod/.test(ua) || navigator.maxTouchPoints > 1) {
        this.paymentoption.push({ value: 'applepay', text: 'Apple Pay (0 kr.)' });
      }
    },
    checkboxselectold: function checkboxselectold(text) {
      var _this2 = this;

      if (text === 'leve') {
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('leveran').classList.remove('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.add('hide');
        this.leverancheckbox = '1';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '0';
      } else if (text === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = true;
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.remove('hide');
        this.leverancheckbox = '0';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '1';
      } else {
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = true;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('mobilepay').classList.add('hide');
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.remove('hide');
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this2.showpopupreepay();
          }
        }, 100);
        this.reepaycheckbox = '1';
        this.leverancheckbox = '0';
        this.mobilepaycheckbox = '0';
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#409EFF!important';
      }
    },
    changecolor: function changecolor() {
      var colorchange = document.querySelector('.second-secondary');
      colorchange.style.color = '#409EFF!important';
      if (this.consentreepay === 'not_accepted') {
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#606266';
      } else {
        var colorchange3 = document.querySelector('.second-secondary2');
        colorchange3.style.color = '#409EFF!important';
      }
    },
    centericon: function centericon() {
      setTimeout(function () {
        var icon = document.getElementById('subicons');
        var iconholder = document.getElementById('subitemitem1');
        var iconmarginleft = parseInt(parseInt(iconholder.clientWidth / 2) - parseInt(117 / 2));
        icon.style.marginLeft = iconmarginleft + 'px';
      }, 50);
    },
    nextstep: function nextstep() {
      if (this.showsessionnewcreditpro === '') {
        this.showsessionnewcredit();
      }
      this.step = this.step + 1;
      if (this.step === 2) {
        this.showconfirmcvr();
      } else if (this.step === 3) {
        this.closeconfirmcvr();
        this.showpayment();
      }
    },
    backstep: function backstep() {
      if (this.step === 2) {
        this.closeconfirmcvr();
        this.statusstep = 'signup_not_active_step1';
        this.updateleadintegration();
        this.addnotifocationbar();
      } else if (this.step === 3) {
        this.closepayment();
        this.showconfirmcvr();
      }
      this.step = this.step - 1;
    },
    showpopupsuccess: function showpopupsuccess() {
      this.$refs['sendingsuccess'].show();
    },
    closepopupsucces: function closepopupsucces() {
      this.$refs['sendingsuccess'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    showpayment: function showpayment() {
      this.$refs['payments'].show();
    },
    showconfirmcvr: function showconfirmcvr() {
      this.$refs['confirmcvr'].show();
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopupcontract: function showpopupcontract() {
      this.$refs['popupcontract'].show();
    },
    showpopuplink: function showpopuplink() {
      this.$refs['popuplink'].show();
    },
    closepayment: function closepayment() {
      this.$refs['payment'].hide();
    },
    closeconfirmcvr: function closeconfirmcvr() {
      this.$refs['confirmcvr'].hide();
    },
    closepopuplink: function closepopuplink() {
      this.$refs['popuplink'].hide();
    },
    closepopuplinklever: function closepopuplinklever() {
      this.$refs['popuplinklever'].hide();
    },
    showpopuplinklever: function showpopuplinklever() {
      this.$refs['popuplinklever'].show();
    },
    closepopupcontract: function closepopupcontract() {
      this.$refs['popupcontract'].hide();
    },
    limitleverantext: function limitleverantext() {
      var _this3 = this;

      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      this.leverantext = 'Prøvepakken er for dig, der gerne vil teste platformen gratis. Med denne plan, kan du få adgang til platformen i 30 dage for 0 kr. uden binding. Samtidig får du 3 bud helt uden forpligtelser. Du kan til enhver tid nemt opsige Prøvepakke-planen dog inden for planens løbetid. Såfremt du ikke opsiger rettidig, vil din plan automatisk opgradere til en “Vækst” plan. Denne plan koster 3.299 kr. / mdr. ekskl. moms med en binding på løbende måned + 3 måneder jf. vores alm forretningsbetingelser. De 30 dages fri opsigelse tager ikke forbehold for weekender og helligdage og tæller opstartsdagen inklusive. Det er kun muligt at oprette, samt at have en Prøvepakke-plan pr. person/virksomhed.';
      setTimeout(function () {
        var moreText = document.getElementById('showmore');
        var lessText = document.getElementById('showless');
        lessText.classList.add('hide');
        moreText.classList.add('hide');
        var newtext = '';
        if (screen.width <= 640) {
          if (no === 2) {
            newtext = _this3.leverantext.slice(0, 120);
            _this3.leverantext = newtext;
            lessText.classList.add('hide');
            moreText.classList.remove('hide');
          } else {
            newtext = _this3.leverantext;
            _this3.leverantext = newtext;
            lessText.classList.remove('hide');
            moreText.classList.add('hide');
          }
        }
        document.getElementById('consentleverancheckbox').checked = true;
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('leveran').classList.remove('hide');
        _this3.centericon();
      }, 100);
    },
    limitsubdetails: function limitsubdetails() {
      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      setTimeout(function () {
        var moreText = document.getElementById('seemoredetails');
        var lessText = document.getElementById('seelesedetails');
        var details = document.getElementById('moredetails');
        var detailsheight = document.getElementById('subcontainerweb');

        if (no === 2) {
          lessText.classList.add('hide');
          moreText.classList.remove('hide');
          details.classList.add('hide');
          var detailsheightoldone = 500;
          detailsheight.style.height = detailsheightoldone + 'px';
        } else {
          lessText.classList.remove('hide');
          moreText.classList.add('hide');
          details.classList.remove('hide');
          var detailsheightold = detailsheight.clientHeight;
          detailsheight.style.height = parseInt(190 + detailsheightold) + 'px';
        }
      }, 100);
    },
    checkleveranpartner: function checkleveranpartner() {
      var _this4 = this;

      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.cvr = res.cvr;
        if (res.levandorupdate === '') {
          _this4.hasleveran = false;
          _this4.levandorupdate = res.levandorupdate;
        } else {
          _this4.hasleveran = true;
          if (_this4.processingperiod(res.levandorupdate)) {
            _this4.levandorupdate = '';
          } else {
            _this4.levandorupdate = res.levandorupdate;
          }
        }
        _this4.nextstep();
        _this4.form.regnr = res.levandorregnr;
        _this4.form.bankkonto = res.levandorbankkonto;
        _this4.options = res.bankOptions;
      }, function (response) {
        alert('error');
      });
    },
    processingperiod: function processingperiod() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var datenow = new Date();
      var processingstart = new Date(a);
      var processingend = new Date(a);
      processingend.setDate(processingstart.getDate() + 4);
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    service_levendor: function service_levendor() {
      var _this5 = this;

      if (this.consentleveran === 'not_accepted' || this.consentleveran === '') {
        this.showerrorleveran = true;
        return;
      }

      var error = 0;
      this.$refs['step4formcontact2'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      this.loadingnewpayment = true;
      var dataPartner = {
        operation: 'service_levendor',
        salesPerson: this.salesPerson,
        regnr: this.form.regnr,
        bankkonto: this.form.bankkonto,
        levid: this.levid,
        cvr: this.form2.cvr,
        bank: 'imentor'
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.modalShowDato = false;
          _this5.paymenthod = 'leveran';
          _this5.urlactivated = 1;
          _this5.paymenthodupdate = 1;
          _this5.updateprofilepayment();
        } else {
          _this5.loadingnewpayment = false;
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this6 = this;

      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var data = res.data;
          _this6.showsessionnewcreditpro = data.id;
        } else {
          console.log('Error in showing session');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    goto: function goto(text) {
      var div = document.getElementById('payments');
      div.scrollTo(0, div.scrollHeight, { behavior: 'smooth' });
    },
    scrollTo: function scrollTo(elementId) {
      var element = document.getElementById(elementId);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    registerMobilepay: function registerMobilepay() {
      var _this7 = this;

      var dataPartner = { operation: 'registerMobilepay',
        salesPerson: this.salesPerson,
        mobile: this.form2.mobilenummber,
        mobilev: 0,
        acceptUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/1?levid=' + this.levid + '&blockid=' + this.blockid,
        rejectUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/0?levid=' + this.levid
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.mobilepaylink = res.url;
          _this7.disablemobilepaybutton = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    showpopupreepay: function showpopupreepay() {
      if (this.consentreepay !== 'accepted') {
        this.showerrorreepay = true;
        return false;
      } else {
        var m = this;
        this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
        this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
          m.datamethod = '';
          m.showsessionnewcreditpro = m.showsessionnewcreditpro;
          console.log('done adding card', data);
          setTimeout(function () {
            m.urlactivated = 1;
            m.paymenthod = 'reepay';
            m.paymenthodupdate = 1;
            m.updateprofilepayment();
          }, 2000);
        });
      }
    },
    validatecvrinput: function validatecvrinput() {
      var _this8 = this;

      setTimeout(function () {
        var datacvr = _this8.form2.cvr;
        _this8.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this8.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + _this8.blockid, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              if (res.success) {
                _this8.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
                _this8.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
                _this8.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
                _this8.form2.companyname = res.data.supplier.TITLE;
              }
            }).catch(function (err) {
              console.log(err);
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }, 1000);
    },
    validatecvr: function validatecvr() {
      var _this9 = this;

      var datacvr = this.form2.cvr;
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data.error) {
            _this9.showcvr = true;
            _this9.cvrerror = 'CVR ' + res.data.error;
            _this9.statusstep = 'signup_not_active_step1';
            _this9.updateleadintegration();
            _this9.loading = false;
          } else {
            if (res.data.enddate !== null) {
              var datenow = new Date();
              var cvrdate = new Date(res.data.enddate);
              if (datenow.getTime() > cvrdate.getTime()) {
                _this9.showcvr = true;
                _this9.cvrerror = 'CVR er inaktivt';
                _this9.statusstep = 'signup_not_active_step1';
                _this9.updateleadintegration();
                _this9.loading = false;
                return false;
              }
            }
            _this9.showcvr = false;
            _this9.cvrerror = '';
            var data = {
              UF_CRM_COMPANY_ZIP_CODE: _this9.form2.postnum,
              UF_CRM_COMPANY_ADDRESS: _this9.form2.address,
              UF_CRM_COMPANY_CITY: _this9.form2.city,
              UF_CRM_COMPANY_CVR: _this9.form2.cvr,
              UF_CRM_COMPANY_SKIP_PAYMENT_REMINDER: 1,
              PHONE: _this9.form2.telefonnummer,
              EMAIL: _this9.form2.email,
              TITLE: _this9.form2.companyname
            };
            _this9.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplier/' + _this9.levid, data, { emulateJSON: true }).then(function (response) {
              if (response) {
                _this9.nextstep();
                _this9.loading = false;
                _this9.addprofiletoreepay();
                _this9.statusstep = 'ready_for_payment_step2';
                _this9.updateleadintegration();
              }
            }).catch(function (err) {
              console.log(err);
            });
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      return true;
    },
    formatpris: function formatpris(no) {
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      });
      var tempno = formatter.format(no);
      return tempno;
    },
    addprofiletoreepay: function addprofiletoreepay() {
      var data = {
        partnerId: this.levid,
        company: this.form2.companyname,
        name: this.form2.fullname,
        address: this.form2.address,
        address2: '',
        city: this.form2.city,
        zipcode: this.form2.postnum
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/addCustomer/', data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    addnotifocationbar: function addnotifocationbar() {
      document.getElementById('reminderbar').classList.remove('hide');
    },
    updateinfo: function updateinfo() {
      var error = 0;
      this.$refs['step4formcontact'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.loading = true;
      this.tracking2();
      this.validatecvr();
    },
    tracking: function tracking() {
      var data = {
        site: 'Newpartner',
        message: 'Aktiver',
        user_id: this.form2.cvr.toString(),
        action_context: this.$route.fullPath,
        type: 'web ',
        version: '1'
      };
      this.$http.post('https://tracking.haandvaerker.dk/api/log', { body: data }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    tracking2: function tracking2() {
      var data = {
        site: window.location.href,
        message: 'Click Aktiver',
        user_id: this.form2.cvr,
        action_type: 'Click Aktiver',
        action_context: this.$route.fullPath,
        type: 'web',
        version: '1'
      };
      var headers = {
        'Content-Type': 'application/json'
      };
      __WEBPACK_IMPORTED_MODULE_4_axios___default()({
        method: 'POST',
        headers: headers,
        data: data,
        url: 'https://tracking.haandvaerker.dk/api/log'
      }).then(function (response) {});
    },
    updateleadintegration: function updateleadintegration() {
      var data = {
        stage: this.statusstep,
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateleadintegrationfinal: function updateleadintegrationfinal() {
      var _this10 = this;

      var data = {
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.updateprofilepayment = false;
          _this10.showpopupsuccess();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      var _this11 = this;

      this.updateprofilepayment = true;
      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmation', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this11.updateprofilepaymenttrial();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this11.updateprofilepaymenttrial();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepaymenttrial: function updateprofilepaymenttrial() {
      var _this12 = this;

      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmTrial', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this12.updateleadintegrationfinal();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this12.updateleadintegrationfinal();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    gettotaljobs: function gettotaljobs() {
      var _this13 = this;

      this.loadingjobs = true;

      var data = { operation: 'openjob_partner', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this13.SearchItem = res.openjob;
        _this13.loadingjobs = false;
        _this13.jobstotal = res.openjob.length;
        if (_this13.jobstotal === 0) {
          _this13.jobstotal = 457;
        }
        _this13.checkleveranpartner();
      }, function (response) {
        console.log('error', response);
      });
    },
    gettotaljobsbitrix: function gettotaljobsbitrix() {
      var _this14 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getRelatedJob/' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this14.jobstotal = res.data.totaljob;
          if (_this14.jobstotal === 0) {
            _this14.jobstotal = 457;
          }
        }
      }, function (response) {
        console.log('error', response);
      });
    },
    getsupplieriblockinfo: function getsupplieriblockinfo(id) {
      var _this15 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this15.levid = res.data.supplier.VALUE_ID;
          localStorage.setItem('levid', res.data.supplier.VALUE_ID);
          var newtel = res.data.supplier.MOBILE.substring(res.data.supplier.MOBILE.length - 8);
          _this15.isused = res.data.spa.SHORT_URL_ACTIVATED;
          if (_this15.isused === 1) {
            _this15.showpopupexpired();
            _this15.loading = false;
            return false;
          }
          _this15.loadingjobs = true;
          _this15.form2.telefonnummer = parseInt(newtel);
          _this15.form2.companyname = res.data.supplier.TITLE;
          _this15.form2.mobilenummber = res.data.supplier.UF_CRM_COMPANY_MOBILE_NUMBER;
          _this15.form2.email = res.data.supplier.EMAIL;
          _this15.form2.fullname = res.data.supplier.UF_CRM_COMPANY_CONTACT_PERSON;
          _this15.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
          _this15.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
          _this15.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
          _this15.form2.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this15.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this15.shorturl = res.data.token.shorturl;
          _this15.salesPerson = res.data.token.token;
          _this15.gettotaljobs();
          localStorage.setItem('id_token_portal', res.data.token.token);

          _this15.loading = false;
          _this15.isvalidcvr = res.data.spa.IS_VALID_CVR;
          if (_this15.isvalidcvr === '') {
            _this15.showcvr = true;
            _this15.cvrerror = res.data.spa.VALID_CVR_REASON;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    decode: function decode() {
      var _this16 = this;

      this.loading = true;
      this.loadingjobs = true;
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data === '') {
            _this16.showpopuperror();
          }
          _this16.blockid = res.data;
          if (_this16.blockid !== '') {
            _this16.getsupplieriblockinfo(_this16.blockid);
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"signuppage"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center sm-hide ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center header-fixed app-header ",attrs:{"id":"mainbarstatus"}},[(_vm.step === 1)?_c('div',{staticClass:"sm-hide",staticStyle:{"width":"340px"}}):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('div',{staticClass:"lg-col-8 md-col-8 sm-col-12 p0 flex flex-row mr-auto items-center mobile-flex-column white justify-between"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex h5 semi-bold m0 lg-col-8 md-col-8 sm-col-12 mmx-auto justify-end mpt1"},[_c('p',{staticClass:"flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold",staticStyle:{"padding-right":"5px"}},[_vm._v("Bud tilgængelige:")]),_c('span',{staticClass:"primarycolor"},[_vm._v(_vm._s(_vm.jobstotalstatic))])]),_vm._v(" "),_c('p',{staticClass:"ml1 flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mx1"},[_vm._v("Min Plan:")]),_vm._v(" "),(_vm.step === 1)?_c('button',{staticClass:"p1 px2 action-button sm-hide ",on:{"click":function($event){return _vm.nextstep()}}},[_vm._v("Aktiver din prøveversion nu")]):_vm._e(),_vm._v(" "),(_vm.showMobile && _vm.step === 1)?_c('span',{staticClass:"red m0",staticStyle:{"font-size":".89rem"}},[_vm._v("Din konto er ikke aktiveret")]):_vm._e(),_vm._v(" "),(_vm.showMobile && _vm.step > 1)?_c('span',{staticClass:"primarycolor"},[_vm._v("Gratis")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.step !== 1)?_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 p0 flex flex-row mx-auto items-center mobile-flex-column white justify-between",staticStyle:{"max-width":"920px"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex h5 semi-bold m0 lg-col-6 md-col-6 sm-col-12 mmx-auto justify-end mpt1"},[_c('p',{staticClass:"flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mr1"},[_vm._v("Bud tilgængelige:")]),_c('span',{staticClass:"primarycolor"},[_vm._v(_vm._s(_vm.jobstotalstatic))])]),_vm._v(" "),_vm._m(3)])]):_vm._e()]),_vm._v(" "),_vm._m(4),_vm._v(" "),(_vm.step !== 4)?_c('div',{staticClass:"lg-hide md-hide col-12 buttonsticky pointer white-background",attrs:{"id":"button"}},[(_vm.step === 1)?_c('button',{staticClass:"action-button p2 not-rounded m0 col-12 ",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"action-button p2 not-rounded m0 mb1  col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateinfo()}}},[_vm._m(6)]),_vm._v(" "),_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(7)])]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(8)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"marketplace2"}},[_c('div',{staticClass:"sidebar"},[_c('div'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold capitalletter",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(9)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(10),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._m(11),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/sent"},on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(12)])])]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(13),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(15)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(16),_vm._v(" "),_vm._m(17)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(18),_vm._v(" "),_vm._m(19)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(20),_vm._v(" "),_vm._m(21)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(22),_vm._v(" "),_vm._m(23)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular hide",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(24)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold nav-dropdown-toggle",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(25)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(26)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(27),_vm._v(" "),_vm._m(28)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(29)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(30)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(31)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular pt3",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(32)])])]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('main',{staticClass:"main p2"},[_c('div',{staticClass:"col-12  p0 "},[_vm._m(33),_vm._v(" "),_c('p',{staticClass:"lg-col-10 md-col-11 h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap items-center"},[(_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                Se opgaver\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                Se ledige arbejdskraft\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"darkblue-background p2 px3 h5 not-rounded flex justify-center white items-center line-height-1 my2 mr1",staticStyle:{"width":"435px","height":"77px","border":"0px solid"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',[_vm._v("\n                Antal reservationer: 0 ud af 3\n              ")])]):_vm._e()])]),_vm._v(" "),(_vm.loadingjobs)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(34)]):_c('div',[(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-start"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer!important","width":"300px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2 flex items-center",staticStyle:{"height":"51px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingzip)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingcity)+"\n                  ")])]),_vm._v(" "),(item.gratis1 === '1')?[_vm._m(35,true)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center",staticStyle:{"height":"41px"}},[_c('span',[_vm._v(_vm._s(item.producttitle))])]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1",staticStyle:{"height":"60px"}},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.comment_to_partner,80, '...'))+"\n                  ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()])],2)])])}),0)]):_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.key,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block flex items-center",staticStyle:{"height":"41px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingzip)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingcity)+"\n                    ")])])]),_vm._v(" "),(item.gratis1 === '1')?_c('div',{staticClass:"absolute bottom-0 right-0 left-0 hide"},[_vm._m(36,true)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.producttitle))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h5 darkblue regular line-height-2 mb1"},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.comment_to_partner,50, '...'))+"\n                    ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud !== 1)?_c('span',[_vm._v(_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(item.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()],2)])])}),0)])])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"confirmcvr",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmcvr","no-close-on-backdrop":true}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson pt1 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_c('span',[_c('i',{staticClass:"el-icon-close h5 "})])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',{staticClass:"col-12 p0 mmb5"},[_c('div',{staticClass:"flex justify-around lg-col-4 md-col-4 sm-col-12 mx-auto items-center mt1"},[_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"49.036","height":"56.623","viewBox":"0 0 49.036 56.623"}},[_c('path',{attrs:{"id":"Indtast_Info","data-name":"Indtast Info","d":"M30.637,53.466a10.929,10.929,0,0,1-1.054-1.221H6.424A6.431,6.431,0,0,1,0,45.821V6.424A6.431,6.431,0,0,1,6.424,0H26.141a1.5,1.5,0,0,1,.969.372l.007,0,.014.013.052.05L41.957,15.213c.023.023.046.048.068.073a1.505,1.505,0,0,1,.371.969V35.887a10.781,10.781,0,1,1-11.759,17.58Zm-.157-7.621a7.778,7.778,0,1,0,7.779-7.779A7.787,7.787,0,0,0,30.479,45.845ZM3,6.424v39.4a3.428,3.428,0,0,0,3.424,3.424h21.6A10.785,10.785,0,0,1,38.258,35.067a10.964,10.964,0,0,1,1.139.059V17.773H26.123a1.5,1.5,0,0,1-1.5-1.5V3H6.424A3.428,3.428,0,0,0,3,6.424Zm24.623,8.349h9.652L27.623,5.121Zm9.135,34.782V47.345H34.547a1.5,1.5,0,1,1,0-3h2.211V42.133a1.5,1.5,0,1,1,3,0v2.211h2.211a1.5,1.5,0,1,1,0,3H39.757v2.211a1.5,1.5,0,1,1-3,0ZM11.5,39.882a1.5,1.5,0,1,1,0-3h15a1.5,1.5,0,1,1,0,3Zm0-10a1.5,1.5,0,1,1,0-3h20a1.5,1.5,0,1,1,0,3Zm-.151-9.646a1.5,1.5,0,1,1,0-3h4.925a1.5,1.5,0,0,1,0,3Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Indtast info")])]),_vm._v(" "),_c('span',{},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.382","height":"16.409","viewBox":"0 0 9.382 16.409"}},[_c('path',{attrs:{"id":"Icon_ionic-ios-arrow-forward","data-name":"Icon ionic-ios-arrow-forward","d":"M17.8,14.4l-6.209-6.2a1.168,1.168,0,0,1,0-1.656,1.182,1.182,0,0,1,1.661,0l7.035,7.03a1.17,1.17,0,0,1,.034,1.617l-7.064,7.079A1.173,1.173,0,1,1,11.6,20.607Z","transform":"translate(-11.246 -6.196)","fill":"#23a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"56.623","height":"56.623","viewBox":"0 0 56.623 56.623"}},[_c('path',{attrs:{"id":"Activer","d":"M0,28.312A28.311,28.311,0,1,1,28.312,56.623,28.312,28.312,0,0,1,0,28.312ZM18.452,51.653a25.3,25.3,0,0,0,26.31-4.078v-4.45a7.6,7.6,0,0,0-7.59-7.59H19.014a7.59,7.59,0,0,0-7.59,7.59v4.067A25.2,25.2,0,0,0,18.452,51.653Zm18.72-19.1a10.583,10.583,0,0,1,10.57,10.57v1.439A25.333,25.333,0,1,0,4.97,18.452,25.31,25.31,0,0,0,8.443,44.03v-.9a10.571,10.571,0,0,1,10.57-10.57ZM17.523,15.887A10.57,10.57,0,1,1,28.093,26.457,10.582,10.582,0,0,1,17.523,15.887Zm2.98,0a7.59,7.59,0,1,0,7.59-7.59A7.6,7.6,0,0,0,20.5,15.887Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Aktiver")])])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 mx-auto flex flex-column p1 mx3 mt1 mb2 darkblue"},[_c('div',{staticClass:"center mb1 mt2"},[_c('p',{staticClass:"h4  semi-bold"},[_vm._v("Prøv 30 dage gratis")])]),_vm._v(" "),_c('div',{staticClass:"lg-col-10 md-col-10 sm-col-12 mx-auto center mt1 mb2"},[_c('p',{staticClass:"h6 line-height-golden"},[_vm._v("& Få 3 gratis opgaver ved oprettelse")])]),_vm._v(" "),_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.form2,"rules":_vm.rulesform2,"label-position":"top"}},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"m0 p0  mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"CVR","prop":"cvr"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","placeholder":"12345678"},on:{"keyup":function($event){return _vm.validatecvrinput()}},model:{value:(_vm.form2.cvr),callback:function ($$v) {_vm.$set(_vm.form2, "cvr", _vm._n($$v))},expression:"form2.cvr"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"E-mail"},model:{value:(_vm.form2.email),callback:function ($$v) {_vm.$set(_vm.form2, "email", $$v)},expression:"form2.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"Telefonnummer","prop":"telefonnummer"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","oninput":"onlyNumber('phone')","id":"phone","placeholder":"Mobilnr.(8 cifre)"},model:{value:(_vm.form2.telefonnummer),callback:function ($$v) {_vm.$set(_vm.form2, "telefonnummer", _vm._n($$v))},expression:"form2.telefonnummer"}})],1)],1),_vm._v(" "),(_vm.showcvr)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":_vm.cvrerror,"type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fulde Navn","prop":"fullname"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Hans Hansen"},model:{value:(_vm.form2.fullname),callback:function ($$v) {_vm.$set(_vm.form2, "fullname", $$v)},expression:"form2.fullname"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"center p0 col-12"},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover  p2 px3 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){_vm.updateinfo(), _vm.tracking2()}}},[_vm._v("Aktiver "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"payments",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"payments","no-close-on-backdrop":true},on:{"show":function($event){return _vm.limitleverantext()}}},[(_vm.loadingnewpayment)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',[_c('div',{staticClass:"p2 flex justify-center mmt4"},[_c('div',{staticClass:"subitems mt4 relative flex flex-column item-between height-full py4 px1 relative",staticStyle:{"width":"390px","box-shadow":"0px 0px 20px #19A3C04D"},attrs:{"id":"subitemitem1"}},[_c('div',{staticClass:" absolute top-0 left-0 bottom-0 right-0 mb1 primarycolor-background relative ",attrs:{"id":"subicons"}},[_c('svg',{staticClass:"absolute",staticStyle:{"top":"20%","left":"25%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","viewBox":"0 0 128.416 110.912"}},[_c('path',{attrs:{"id":"Freemium","d":"M55.035,110.912a1.529,1.529,0,1,1,0-3.057H61.1v-1.529H48.92a1.529,1.529,0,0,1,0-3.058H79.5a1.529,1.529,0,0,1,0,3.058H67.311v1.529h6.834a1.529,1.529,0,0,1,0,3.057Zm28.928-4.586a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm-45.862,0a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm77.106-6.115h-102a1.542,1.542,0,1,1,0-3.058h47.2a18.384,18.384,0,0,1-.816-6.211,3.058,3.058,0,0,1,3.056-2.961h3.041a3.079,3.079,0,0,1,3.057,3,16.872,16.872,0,0,1-.929,6.169h47.395a1.542,1.542,0,1,1,0,3.058Zm-51.54-3.382h0a1.527,1.527,0,0,0,.5.324c.685-.272,1.625-2.633,1.52-6.089v-.025H62.645C62.56,93.719,63.1,96.289,63.668,96.829Zm61.689,1.853a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,125.357,98.683Zm-5.351,1.529a1.529,1.529,0,0,1,0-3.058H122.3a1.529,1.529,0,0,1,0,3.058Zm-113.892,0a1.529,1.529,0,0,1,0-3.058H8.408a1.529,1.529,0,0,1,0,3.058ZM0,98.683a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,0,98.683ZM68.532,84.924H59.879a4.561,4.561,0,0,1-4.554-3.969c-.049-.4-.1-.867-.165-1.381H51.284a3.08,3.08,0,0,1-3.122-2.8L45.134,63.087a1.529,1.529,0,0,1,2.23-1.67l6.291,3.461c-.713-8.326-1.23-17.6-.68-23.241.257-2.627,1.812-9.432,2.036-10.405a9.4,9.4,0,0,1,18.395-.014c.224.964,1.775,7.695,2.031,10.294.558,5.665.037,15-.68,23.368l6.294-3.463a1.528,1.528,0,0,1,2.23,1.67L80.253,76.77a3.08,3.08,0,0,1-3.122,2.8H73.252c-.061.514-.117.978-.166,1.381a4.56,4.56,0,0,1-4.522,3.97ZM56.017,41.935c-.987,10.109,1.656,33,2.343,38.65a1.5,1.5,0,0,0,1.519,1.281h8.653a1.5,1.5,0,0,0,1.518-1.281c.689-5.665,3.341-28.635,2.343-38.772-.154-1.569-.882-5.037-1.41-7.432a17.191,17.191,0,0,1-6.776,1.241,17.2,17.2,0,0,1-6.769-1.238C56.91,36.807,56.174,40.341,56.017,41.935ZM74.426,68.553c-.281,2.965-.57,5.7-.823,7.963h3.528A.185.185,0,0,0,77.2,76.5a1.5,1.5,0,0,1,.035-.259l2.327-10.518ZM51.177,76.242a1.575,1.575,0,0,1,.034.26.188.188,0,0,0,.073.013h3.524c-.253-2.267-.542-5-.823-7.964L48.85,65.725ZM58.145,31.3c.69.5,2.759,1.264,6.063,1.264s5.378-.77,6.066-1.266a6.313,6.313,0,0,0-6.064-4.467h-.027A6.314,6.314,0,0,0,58.145,31.3Zm4.493,45.216V63.521a1.528,1.528,0,0,1,1.528-1.529h0a1.529,1.529,0,0,1,1.529,1.529l0,12.994a1.529,1.529,0,1,1-3.058,0ZM58.092,51.673V46.322a6.115,6.115,0,0,1,12.23,0v5.351a6.115,6.115,0,1,1-12.23,0Zm3.058-5.351v5.351a3.058,3.058,0,1,0,6.115,0V46.322a3.058,3.058,0,0,0-6.115,0Zm58.325,4.2A1.529,1.529,0,1,1,121,52.056,1.529,1.529,0,0,1,119.476,50.527Zm.764,0a.765.765,0,1,0,.764-.765A.765.765,0,0,0,120.24,50.527ZM6.516,50.86,7.652,49.4v-.023l-1.77.226v-.813l1.759.227v-.023L6.516,47.536l.73-.419.742,1.663h.024l.73-1.674.718.407L8.323,49.007v.023l1.805-.239V49.6l-1.805-.215v.024l1.148,1.435-.754.431L8,49.6H7.975L7.2,51.291Zm82.722-6.327a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,89.238,44.533Zm.764,0a.764.764,0,1,0,.764-.765A.764.764,0,0,0,90,44.533ZM34.4,34.381a2.293,2.293,0,1,1,2.293,2.294A2.293,2.293,0,0,1,34.4,34.381Zm1.147,0a1.146,1.146,0,1,0,1.146-1.146A1.146,1.146,0,0,0,35.544,34.381Zm79.625-.422,1.114-1.431V32.5l-1.736.222v-.8l1.725.224v-.024l-1.1-1.432.716-.41.727,1.63h.023l.715-1.642.7.4L116.94,32.14v.023l1.771-.235v.8l-1.771-.211v.023l1.125,1.408-.739.422-.7-1.643H116.6l-.763,1.655ZM85.61,19.187a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,85.61,19.187Zm.765,0a.764.764,0,1,0,.764-.764A.764.764,0,0,0,86.375,19.187Zm-76.2-1.529A1.529,1.529,0,1,1,11.7,19.187,1.529,1.529,0,0,1,10.17,17.659Zm.764,0a.764.764,0,1,0,.764-.764A.766.766,0,0,0,10.934,17.659ZM111.49,9.253l.962-1.234V8l-1.5.192V7.5l1.487.193V7.675L111.49,6.44l.618-.354.627,1.406h.021l.617-1.416.607.344-.961,1.264v.021l1.527-.2v.688l-1.527-.182v.02l.971,1.215-.638.365-.607-1.417h-.02l-.658,1.427ZM59.07,2.162l.654-.84V1.308l-1.02.131V.971l1.013.131V1.088L59.07.248l.42-.241.427.957h.014L60.351,0l.413.234-.654.861v.014L61.15.971v.468l-1.039-.124v.014l.661.826-.434.248-.413-.964h-.013l-.449.971Z","fill":"#fff"}})])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"col-12 center bold h6 my2"},[_vm._v("PRØVEPAKKE")]),_vm._v(" "),_c('p',{staticClass:"col-12 center bold h2 my2"},[_c('span',{staticClass:"primarycolor"},[_vm._v("GRATIS*")])])]),_vm._v(" "),_c('div',{staticClass:"col-10 mx-auto"},[_c('ul',{staticClass:"list-sub-text list-image-check-mintgreen pb1 pr2 mb3"},[_c('li',{staticClass:" light line-height-4 mt0 pb1 ml1"},[_vm._v("Byd på 3 opgaver")]),_vm._v(" "),_c('li',{staticClass:" light line-height-4 mt0 pb1 mb2 ml1"},[_vm._v("Gratis adgang i 30 dage")]),_vm._v(" "),_c('div',{staticClass:"center col-12"},[_c('button',{staticClass:"action-button p2 px3 round",attrs:{"type":"button"},on:{"click":function($event){return _vm.goto()}}},[_vm._v("Vælg")])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"lg-col-12 md-col-12 sm-col-12 mx-auto mx3"},[_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background"},[_c('p',{staticClass:"h4 semi-bold my1 col-12 flex justify-start py2 px0"},[_vm._v("Kurv")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold my1 col-12 flex justify-start p0"},[_vm._v("Plan valgt: GRATIS")]),_vm._v(" "),_c('p',{staticClass:" h3 semi-bold darkblue center my2 col-12 flex justify-start p0"},[_vm._v("At betale nu: "),_c('span',{staticClass:"primarycolor pl2"},[_vm._v(" 0.- kr")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start",staticStyle:{"max-width":"920px"}},[_c('p',{staticClass:"semi-bold mt1 mb0",staticStyle:{"font-size":"12px"}},[_vm._v("Pris per måned:*")]),_vm._v(" "),_c('p',{staticClass:"pb1 h6 line-height-golden flex justify-start italic p0",staticStyle:{"font-size":"12px"},attrs:{"id":"leverantext"}},[_vm._v(_vm._s(_vm.leverantext))]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showmore"},on:{"click":function($event){return _vm.limitleverantext(1)}}},[_c('span',[_vm._v("Læs mere")])]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showless"},on:{"click":function($event){return _vm.limitleverantext(2)}}},[_c('span',[_vm._v("Vis mindre")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 pb2 flex flex-column darkblue lightgrey-background mt2"},[_c('p',{staticClass:"semi-bold h4 dawkblue col-12 flex justify-start mt2 px0"},[_vm._v("Vælg betalingsform")]),_vm._v(" "),_c('p',{staticClass:"h6 initial mb2"},[_vm._v("Dette er for at bekræfte din konto. Du bliver ikke opkrævet i din 30 dages prøveperiode.")]),_vm._v(" "),[_c('div',[_c('el-select',{staticClass:" col-12 px0 white-background border-none darkblue semi-bold not-rounded",attrs:{"placeholder":"Vælg"},on:{"change":function($event){return _vm.checkboxselect()}},model:{value:(_vm.selectedpayment),callback:function ($$v) {_vm.selectedpayment=$$v},expression:"selectedpayment"}},_vm._l((_vm.paymentoption),function(items){return _c('el-option',{key:items.value,attrs:{"label":items.text,"value":items.value}})}),1)],1),_vm._v(" "),(_vm.selectedpayment === 'leve')?_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 p0 mx-auto mt2",attrs:{"id":"leveran"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"col-12 p0"},[(_vm.levandorupdate !== '')?_c('b-alert',{staticClass:"my2",attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                            ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap mt2 p0"},[_c('el-form',{ref:"step4formcontact2",staticClass:"tui-f lg-col-12 sm-col-12 sm-col-12 mx-auto",attrs:{"model":_vm.form,"rules":_vm.rulesform,"label-position":"top"}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Reg. nr.","prop":"regnr"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"maxlength":"4","placeholder":"4 cifre"},model:{value:(_vm.form.regnr),callback:function ($$v) {_vm.$set(_vm.form, "regnr", $$v)},expression:"form.regnr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Konto nr.","prop":"bankkonto"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"minimum":"6","maxlength":"10","placeholder":"6-10 cifre"},model:{value:(_vm.form.bankkonto),callback:function ($$v) {_vm.$set(_vm.form, "bankkonto", $$v)},expression:"form.bankkonto"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none center el-form-item__plain el-form-item__checkbox",attrs:{"id":"accepterms"}},[_c('el-checkbox',{staticClass:"el-checkbox flex justify-start md-col-10 lg-col-10 sm-col-12 pl1 mp0 ml-auto",attrs:{"label":"","id":"consentleverancheckbox"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentleveran),callback:function ($$v) {_vm.consentleveran=$$v},expression:"consentleveran"}},[_c('span',{staticClass:"second-secondary "},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplinklever()}}},[_vm._v(" LeverandørService")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement.")])])]),_vm._v(" "),(_vm.showerrorleveranerror)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Indtast venligst nummer","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0"},[_c('button',{staticClass:"action-button not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"773px"},attrs:{"type":"button","id":"leverrsub"},on:{"click":_vm.service_levendor}},[_c('span',{staticClass:"semi-bold h5 m0"},[_vm._v("Start"),_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2",attrs:{"id":"moreid"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'reep')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'mobpay')?_c('div',{staticClass:"col-12 flex justify-center",attrs:{"id":"mobilepay"}},[(_vm.disablemobilepaybutton)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):_c('a',{staticClass:"action-button no-underline not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"700px"},attrs:{"type":"button","href":_vm.mobilepaylink}},[_c('span',{staticClass:"white semi-bold h5 m0"},[_vm._v("Start")])])]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'googlepay')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'applepay')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"hide",attrs:{"id":"lastitem"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","type":"button","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","disabled":"true"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h4 darkblue pt1 mx-auto center"},[_vm._v("TILLYKKE! Så er din prøveperiode aktiveret! \n                Nu mangler du blot at opdatere din virksomhedsprofil, så vi kan låse op for opgaverne på markedspladsen\n                ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Din plan er nu aktiv, og du kan begynde at byde på ledige opgaver, så snart du har opdateret din virksomhedsprofil. Vi har også sendt dig en e-mail med bekræftelse på din konto-aktivering.")]),_vm._v(" "),_c('a',{staticClass:"center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":_vm.shorturl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdateret virksomhedsprofil")])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mx-auto center line-height-4"},[_vm._v("Bemærk, at såfremt du har valgt en “gratis” plan til 0 kr., har du 30 dage til at opsige denne, hvis du ikke ønsker at din plan automatisk skal opgraderes til en “Vækst” plan til 3.299,- pr. måned ex. moms, med en binding på løbende måned + 3 måneder, fra den dato “Vækst” planen træder i kraft."),_c('br'),_c('br'),_vm._v("\n                I prøveperiode opsiger du ved at sende en e-mail til "),_c('a',{attrs:{"target":"_blank","href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")]),_vm._v(" Planen bliver trukket automatisk via din valgte betalingsmetode. Du kan læse mere om vores handelsbetingelser "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk/om/betingelser?ref=bm","target":"_blank"}},[_vm._v("her.")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"popupcontract",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popupcontract"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopupcontract()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px","zoom":".5"},attrs:{"src":'https://www.kundematch.dk/s/otheraftale_new.php?bitrixid=' + this.levid + '&mode=ssl',"frameborder":"0","zoom":"0.9","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplink",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplink"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplink()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":"https://reepay.com/terms-of-service/","frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplinklever",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplinklever"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background  "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplinklever()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","height":"95%","overflow":"auto"}},[_c('vue-pdf-app',{attrs:{"pdf":"/static/pdf/Generelle_regler_for-kreditorer_i_LeverandørService_v_1.0_14.09.2019.pdf"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit link er allerede brugt.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Du har en e-mail med login og password, så du kan logge ind nu.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx1"},[_c('span',{staticClass:" darkblue mb0 bold h4 my1"},[_vm._v("Aktivering")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx1"},[_c('span',{staticClass:" darkblue mb0 bold h4 my1"},[_vm._v("Aktivering")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ml1 flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mx1"},[_vm._v("Min Plan:")]),_vm._v(" "),_c('span',{staticClass:"primarycolor"},[_vm._v("Gratis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger not-rounded m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"darkblue h6 p1 m0 center"},[_vm._v("Du mangler at aktivere din gratis bruger for at modtage dine 3 gratis bud.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Aktiver din prøveversion nu "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Næste "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-house ml1 darkblue "}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Forside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropBeskeder"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Beskeder")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/inbox"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Inbox\n                                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sendt\n                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropAnbefalinger"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Anbefalinger")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"indhent-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Indhent anbefalinger\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"laes-og-besvar-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Læs og besvar\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"auto-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sæt anbefalinger på Auto-pilot\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"widgets"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Widgets\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-files mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Mine kunder\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropDine projekter"}},[_c('i',{staticClass:"el-icon-picture-outline mr2 darkblue"}),_vm._v("\n                            Dine projekter")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"opret-projekt-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opret projekt\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"status-haandvaerker-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Mine projekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/approved-projects"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Åbne kundeprojekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/project-dashboard"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Vundne kundeprojekter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-money mr2 darkblue"}),_vm._v(" \n                        Markedsplads")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold hide",attrs:{"id":"udbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Udbud ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropMester-til-Mester"}},[_c('i',{staticClass:"el-icon-share mr2 darkblue"}),_vm._v("\n                            Mester-til-Mester")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-arbejdskraft"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Arbejdskraft\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-opgaver"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button","href":"#/mester-opgaver"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opgaver\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-document mr2 darkblue"}),_vm._v("\n                            Opret tilbud")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/tilbud-historie"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Tilbudshistorie\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/standardTilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Standard Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/hurtigt-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Hurtigt Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/upload-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Upload Tilbud\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Inviter en kollega\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-monitor mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Gratis hjemmeside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Medlemsfordele\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-shopping-cart-2 mr2 darkblue"}),_vm._v("\n                            Webshop")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"webshop/products"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Alle produkter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Digital pakke\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-setting mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Indstillinger\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-question mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Ofte stillede spørgsmål\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-back mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Log ud\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Markedsplads\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 mintgreen semi-bold block"},[_vm._v("\n                      Gratis møde\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-background mintgreen gibson line-height-1 h6 mb0 p1 pb2"},[_c('span',{staticClass:"block hide"},[_vm._v("Gratis møde  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_AI_text_vue__ = __webpack_require__(1089);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620100df_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_signup_AI_text_vue__ = __webpack_require__(1090);
function injectStyle (ssrContext) {
  __webpack_require__(1088)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_signup_AI_text_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_620100df_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_signup_AI_text_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1088 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pdf_app_dist_icons_main_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pdf_app_dist_icons_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_pdf_app_dist_icons_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__slim_slim_module_js__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__portal_Profilsideinformation__ = __webpack_require__(311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_datetime__);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ai_text_upgrade',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_8_vue_datetime__["Datetime"],
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app___default.a,
    profilsideinformation: __WEBPACK_IMPORTED_MODULE_7__portal_Profilsideinformation__["a" /* default */],
    Slim: __WEBPACK_IMPORTED_MODULE_3__slim_slim_module_js__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_6_vue_full_loading___default.a,
    axios: __WEBPACK_IMPORTED_MODULE_5_axios___default.a
  },
  watch: {},
  data: function data() {
    return {
      loadingnewpayment: false,
      reepaycheckbox: '0',
      leverancheckbox: '1',
      mobilepaycheckbox: '0',
      pid: '',
      fullurl: '',
      disablemobilepaybutton: false,
      showcvr: false,
      cvrerror: '',
      originalid: '',
      levid: '',
      blockid: '',
      step: 1,
      jobstotal: '',
      jobstotalstatic: 3,
      SearchItem: [],
      loading: false,
      loadingjobs: false,
      showsessionnewcreditpro: '',
      disableupdateinfo: false,
      form2: {
        fullname: '',
        email: '',
        telefonnummer: '',
        companyname: '',
        address: '',
        postnum: '',
        city: '',
        cvr: '',
        mobilenummber: ''
      },
      form: {
        regnr: '',
        bankkonto: ''
      },
      rulesform2: {
        fullname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit navn',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        companyname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt 8 digit mobilnr.',
          trigger: 'blur'
        }],
        postnum: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste et gyldigt postnum.',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt by.',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt Addresse.',
          trigger: 'blur'
        }],
        cvr: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Indtast venligst et gyldigt cvr og 8 cifre.',
          trigger: 'blur'
        }]
      },
      rulesform: {
        bankkonto: [{
          min: 6,
          max: 10,
          message: 'Indtast venligst et gyldigt 6 til 10-cifret nummer.',
          trigger: 'blur'
        }, {
          required: true,
          type: 'string',
          message: 'Indtast venligst nummer.',
          trigger: 'blur'
        }],
        regnr: [{
          required: true,
          type: 'string',
          max: 4,
          message: 'Indtast venligst et gyldigt 4-cifret nummer.',
          trigger: 'blur'
        }]
      },
      formCallus: {
        name: '',
        phone: '',
        cvr: '',
        email: ''
      },
      formCallusRules: {
        name: [{ required: true, message: 'Skriv venligst dit navn', trigger: 'blur' }],
        phone: [{ type: 'number', required: true, min: 10000000, max: 99999999, message: 'Skriv venligst dit telefon nummer', trigger: 'blur' }],
        cvr: [{ required: true, type: 'number', min: 10000000, max: 99999999, message: 'Indtast venligst et gyldigt cvr og 8 cifre.', trigger: 'blur' }],
        email: [{
          required: true, type: 'email', message: 'Du bedes indtaste en gyldig e-mail', trigger: 'blur'
        }]
      },
      hasleveran: '',
      levandorupdate: '',
      regnr: '',
      bankkonto: '',
      bank: '',
      cvr: '',
      gratisbutton: 1,
      consentleveran: true,
      consentreepay: 'accepted',
      leverantext: '',
      isvalidcvr: '',
      showerrorleveran: false,
      showerrorleveranerror: false,
      showerrorreepay: false,
      statusstep: '',
      job: false,
      shorturl: '',
      showMobile: '',
      isused: '',
      mobilepaylink: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      datamethod: '',
      myHTML: '',
      ratingwidget: '',
      commentwidget: '',
      FileLocation: '',
      instance: null,
      show: false,
      modalShowBillede: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      options: {
        hideModules: { 'link': true, 'code': true, 'justifyRight': true, 'justifyCenter': true, 'table': true, 'italic': true }
      },
      editorData: '<p>Content of the editor.</p>',
      editorConfig: {},
      slimOptions: {
        initialImage: this.FileLocation,
        service: this.slimService,
        didInit: this.slimInit,
        didConfirm: this.slimConfirm
      },
      haaId: '',
      imageId: '',
      items: [],
      videos: [],
      images: [],
      eligible: '',
      eliglbletextlimit: 'Ubegrænset',
      activeName: ['2'],
      salesPersonbitrix: '',
      FreeTextPartnerPopop: {},
      FreeTextPartnerPopopUNSER: {},
      showvideoPopup: false,
      pageactive: 'tekst',
      limitedpopup: false,
      joblimitedpopup: false,
      videoresponseloading: true,
      telephonenumber: '',
      SubmitAItext: false,
      partneremail: '',
      partnercvr: '',
      SpaId: '',
      campaigntext: '',
      partnerinformation: {},
      updatemobile: false,
      haseditedphone: false
    };
  },
  created: function created() {},
  mounted: function mounted() {
    localStorage.removeItem('yourfulllink');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');

    this.campaigntext = pathArray[pathArray.length - 3];
    this.salesPerson = pathArray[pathArray.length - 2];
    this.decode(pathArray[pathArray.length - 1]);
    setTimeout(function () {
      document.getElementById('partnerloginapp').style.border = 0;
    }, 100);
  },

  methods: {
    checkboxselect: function checkboxselect(text) {
      var _this = this;

      if (text === 'leve') {
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('leveran').classList.remove('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.add('hide');
        this.leverancheckbox = '1';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '0';
      } else if (text === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = true;
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.remove('hide');
        this.leverancheckbox = '0';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '1';
      } else {
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = true;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('mobilepay').classList.add('hide');
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.remove('hide');
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
        }, 100);
        this.reepaycheckbox = '1';
        this.leverancheckbox = '0';
        this.mobilepaycheckbox = '0';
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#409EFF!important';
      }
    },
    changecolor: function changecolor() {
      var colorchange = document.querySelector('.second-secondary');
      colorchange.style.color = '#409EFF!important';
      if (this.consentreepay === 'not_accepted') {
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#606266';
      } else {
        var colorchange3 = document.querySelector('.second-secondary2');
        colorchange3.style.color = '#409EFF!important';
      }
    },
    centericon: function centericon() {
      setTimeout(function () {
        var icon = document.getElementById('subicons');
        var iconholder = document.getElementById('subitemitem1');
        var iconmarginleft = parseInt(parseInt(iconholder.clientWidth / 2) - parseInt(117 / 2));
        icon.style.marginLeft = iconmarginleft + 'px';
      }, 50);
    },
    nextstep: function nextstep() {
      this.limitedpopup = true;
    },
    backstep: function backstep() {
      if (this.step === 2) {
        this.closeconfirmcvr();
        this.statusstep = 'signup_not_active_step1';
        this.updateleadintegration();
        this.addnotifocationbar();
      } else if (this.step === 3) {
        this.closepayment();
        this.showconfirmcvr();
      }
      this.step = this.step - 1;
    },
    showpopupsuccess: function showpopupsuccess() {
      this.$refs['sendingsuccess'].show();
    },
    closepopupsucces: function closepopupsucces() {
      this.$refs['sendingsuccess'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    showpayment: function showpayment() {
      this.$refs['payment'].show();
    },
    showconfirmcvr: function showconfirmcvr() {
      this.$refs['confirmcvr'].show();
    },
    closeinitialPopup: function closeinitialPopup() {
      this.$refs['initialPopup'].hide();
    },
    showthankyoupopup: function showthankyoupopup() {
      var _this2 = this;

      this.SubmitAItext = true;

      setTimeout(function () {
        _this2.openUrl();
      }, 5000);
    },
    tracking: function tracking() {
      var data = {
        site: 'Newpartner',
        message: 'Aktiver',
        user_id: this.form2.cvr.toString(),
        action_context: this.$route.fullPath,
        type: 'web ',
        version: '1'
      };
      var body = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data);
      this.$http.post('https://tracking.haandvaerker.dk/api/log', { body: body }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    tracking2: function tracking2() {
      var data = {
        site: window.location.href,
        message: 'Click Aktiver',
        user_id: this.form2.cvr,
        action_type: 'Click Aktiver',
        action_context: this.$route.fullPath,
        type: 'web',
        version: '1'
      };
      var headers = {
        'Content-Type': 'application/json'
      };
      __WEBPACK_IMPORTED_MODULE_5_axios___default()({
        method: 'POST',
        headers: headers,
        data: data,
        url: 'https://tracking.haandvaerker.dk/api/log'
      }).then(function (response) {});
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopupcontract: function showpopupcontract() {
      this.$refs['popupcontract'].show();
    },
    showpopuplink: function showpopuplink() {
      this.$refs['popuplink'].show();
    },
    closepayment: function closepayment() {
      this.$refs['payment'].hide();
    },
    closeconfirmcvr: function closeconfirmcvr() {
      this.$refs['confirmcvr'].hide();
    },
    closepopuplink: function closepopuplink() {
      this.$refs['popuplink'].hide();
    },
    closepopuplinklever: function closepopuplinklever() {
      this.$refs['popuplinklever'].hide();
    },
    showpopuplinklever: function showpopuplinklever() {
      this.$refs['popuplinklever'].show();
    },
    closepopupcontract: function closepopupcontract() {
      this.$refs['popupcontract'].hide();
    },
    limitleverantext: function limitleverantext() {
      var _this3 = this;

      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      this.leverantext = 'Prøvepakken er for dig, der gerne vil teste platformen gratis. Med denne plan, kan du få adgang til platformen i 30 dage for 0 kr. uden binding. Samtidig får du 3 bud helt uden forpligtelser. Du kan til enhver tid nemt opsige Prøvepakke-planen dog inden for planens løbetid. Såfremt du ikke opsiger rettidig, vil din plan automatisk opgradere til en Basis-Plus plan. Denne plan koster 795 kr. / mdr. ekskl. moms med en binding på løbende måned + én måned jf. vøres alm forretningsbetingelser. De 30 dages fri opsigelse tager ikke forbehold for weekender og helligdage og tæller opstartsdagen inklusive. Det er kun muligt at oprette, samt at have en Prøvepakke-plan pr. person/virksomhed.';
      setTimeout(function () {
        var moreText = document.getElementById('showmore');
        var lessText = document.getElementById('showless');
        lessText.classList.add('hide');
        moreText.classList.add('hide');
        var newtext = '';
        if (screen.width <= 640) {
          if (no === 2) {
            newtext = _this3.leverantext.slice(0, 120);
            _this3.leverantext = newtext;
            lessText.classList.add('hide');
            moreText.classList.remove('hide');
          } else {
            newtext = _this3.leverantext;
            _this3.leverantext = newtext;
            lessText.classList.remove('hide');
            moreText.classList.add('hide');
          }
        }
        document.getElementById('consentleverancheckbox').checked = true;
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('leveran').classList.remove('hide');
        _this3.centericon();
      }, 100);
    },
    limitsubdetails: function limitsubdetails() {
      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      setTimeout(function () {
        var moreText = document.getElementById('seemoredetails');
        var lessText = document.getElementById('seelesedetails');
        var details = document.getElementById('moredetails');
        var detailsheight = document.getElementById('subcontainerweb');

        if (no === 2) {
          lessText.classList.add('hide');
          moreText.classList.remove('hide');
          details.classList.add('hide');
          var detailsheightoldone = 500;
          detailsheight.style.height = detailsheightoldone + 'px';
        } else {
          lessText.classList.remove('hide');
          moreText.classList.add('hide');
          details.classList.remove('hide');
          var detailsheightold = detailsheight.clientHeight;
          detailsheight.style.height = parseInt(190 + detailsheightold) + 'px';
        }
      }, 100);
    },
    checkleveranpartner: function checkleveranpartner() {
      var _this4 = this;

      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.cvr = res.cvr;
        if (res.levandorupdate === '') {
          _this4.hasleveran = false;
          _this4.levandorupdate = res.levandorupdate;
        } else {
          _this4.hasleveran = true;
          if (_this4.processingperiod(res.levandorupdate)) {
            _this4.levandorupdate = '';
          } else {
            _this4.levandorupdate = res.levandorupdate;
          }
        }

        _this4.form.regnr = res.levandorregnr;
        _this4.form.bankkonto = res.levandorbankkonto;
        _this4.options = res.bankOptions;
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    processingperiod: function processingperiod() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var datenow = new Date();
      var processingstart = new Date(a);
      var processingend = new Date(a);
      processingend.setDate(processingstart.getDate() + 4);
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    service_levendor: function service_levendor() {
      var _this5 = this;

      if (this.consentleveran === 'not_accepted' || this.consentleveran === '') {
        this.showerrorleveran = true;
        return;
      }

      var error = 0;
      this.$refs['step4formcontact2'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      this.loadingnewpayment = true;
      var dataPartner = {
        operation: 'service_levendor',
        salesPerson: this.salesPerson,
        regnr: this.form.regnr,
        bankkonto: this.form.bankkonto,
        levid: this.levid,
        cvr: this.form2.cvr,
        bank: 'imentor'
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.modalShowDato = false;
          _this5.paymenthod = 'leveran';
          _this5.urlactivated = 1;
          _this5.paymenthodupdate = 1;
          _this5.updateleadintegrationfinal();
        } else {
          _this5.loadingnewpayment = false;
          _this5.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.message
        });
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this6 = this;

      this.$http.post(this.$bitrixapi + 'reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var data = res.data;
          _this6.showsessionnewcreditpro = data.id;
          _this6.showpayment();
        } else {
          _this6.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    goto: function goto(text) {
      var div = document.getElementById('payments');
      div.scrollTo(0, div.scrollHeight, { behavior: 'smooth' });
    },
    registerMobilepay: function registerMobilepay() {
      var _this7 = this;

      var dataPartner = { operation: 'registerMobilepay',
        salesPerson: this.salesPerson,
        mobile: this.form2.mobilenummber,
        mobilev: 0,
        acceptUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/1?levid=' + this.levid + '&blockid=' + this.blockid,
        rejectUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/0?levid=' + this.levid
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.mobilepaylink = res.url;
          _this7.disablemobilepaybutton = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    showpopupreepay: function showpopupreepay() {
      if (this.consentreepay !== 'accepted') {
        this.showerrorreepay = true;
        return false;
      } else {
        var m = this;
        this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
        this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
          m.datamethod = '';
          m.showsessionnewcreditpro = m.showsessionnewcreditpro;
          console.log('done adding card', data);
          setTimeout(function () {
            m.urlactivated = 1;
            m.paymenthod = 'reepay';
            m.paymenthodupdate = 1;
            m.updateleadintegrationfinal();
          }, 2000);
        });
      }
    },
    validatecvrinput: function validatecvrinput() {
      var _this8 = this;

      setTimeout(function () {
        var datacvr = _this8.form2.cvr;
        _this8.$http.get(_this8.$bitrixapi + 'bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this8.$http.get(_this8.$bitrixapi + 'bitrix/getOnlineSignupInfo/' + _this8.blockid, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              if (res.success) {
                _this8.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
                _this8.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
                _this8.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
                _this8.form2.companyname = res.data.supplier.TITLE;
              }
            }).catch(function (err) {
              console.log(err);
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }, 1000);
    },
    validatecvr: function validatecvr() {
      var _this9 = this;

      var datacvr = this.form2.cvr;
      this.$http.get(this.$bitrixapi + 'bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data.error) {
            _this9.showcvr = true;
            _this9.cvrerror = 'CVR ' + res.data.error;

            _this9.loading = false;
          } else {
            _this9.addprofiletoreepay();
            _this9.closeconfirmcvr();
            _this9.loading = false;
          }
        }
      }, function (response) {
        _this9.$message({
          type: 'error',
          message: response.body.message
        });
      });
      return true;
    },
    formatpris: function formatpris(no) {
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      });
      var tempno = formatter.format(no);
      return tempno;
    },
    addnotifocationbar: function addnotifocationbar() {
      document.getElementById('reminderbar').classList.remove('hide');
    },
    updateinfo: function updateinfo() {
      var error = 0;
      this.$refs['step4formcontact'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.loading = true;
      this.validatecvr();
    },
    updateleadintegration: function updateleadintegration() {
      var data = {
        stage: this.statusstep,
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/upgradeProfileTextAIKanvasTrial/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateleadintegrationfinal: function updateleadintegrationfinal() {
      var _this10 = this;

      var data = {
        spaId: this.SpaId
      };
      this.$http.post(this.$bitrixapi + 'external/upgradeProfileTextAIKanvasTrial', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.updateprofilepayment = false;
          _this10.showpopupsuccess();
          setTimeout(function () {
            _this10.toLoginPage();
          }, 4000);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      var _this11 = this;

      this.updateprofilepayment = true;
      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmation', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this11.updateprofilepaymenttrial();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this11.updateprofilepaymenttrial();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepaymenttrial: function updateprofilepaymenttrial() {
      var _this12 = this;

      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmTrial', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this12.updateleadintegrationfinal();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this12.updateleadintegrationfinal();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    gettotaljobs: function gettotaljobs() {
      var _this13 = this;

      this.loadingjobs = true;

      var data = { operation: 'openjob_partner', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this13.SearchItem = res.openjob;
        _this13.loadingjobs = false;
        _this13.jobstotal = res.openjob.length;
        if (_this13.jobstotal === 0) {
          _this13.jobstotal = 457;
        }
      }, function (response) {
        _this13.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    gettotaljobsbitrix: function gettotaljobsbitrix() {
      var _this14 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getRelatedJob/' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this14.jobstotal = res.data.totaljob;
          if (_this14.jobstotal === 0) {
            _this14.jobstotal = 457;
          }
        }
      }, function (response) {
        console.log('error', response);
      });
    },
    getsupplieriblockinfo: function getsupplieriblockinfo(id) {
      var _this15 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this15.levid = res.data.supplier.VALUE_ID;
          localStorage.setItem('levid', res.data.supplier.VALUE_ID);
          var newtel = res.data.supplier.MOBILE.substring(res.data.supplier.MOBILE.length - 8);
          _this15.isused = res.data.spa.SHORT_URL_ACTIVATED;
          if (_this15.isused === 1) {
            _this15.showpopupexpired();
            _this15.loading = false;
            return false;
          }
          _this15.loadingjobs = true;
          _this15.form2.telefonnummer = parseInt(newtel);
          _this15.form2.companyname = res.data.supplier.TITLE;
          _this15.form2.mobilenummber = res.data.supplier.UF_CRM_COMPANY_MOBILE_NUMBER;
          _this15.form2.email = res.data.supplier.EMAIL;
          _this15.form2.fullname = res.data.supplier.UF_CRM_COMPANY_CONTACT_PERSON;
          _this15.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
          _this15.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
          _this15.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
          _this15.form2.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this15.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this15.shorturl = res.data.token.shorturl;
          _this15.salesPerson = res.data.token.token;
          _this15.gettotaljobs();
          localStorage.setItem('id_token_portal', res.data.token.token);

          _this15.loading = false;
          _this15.isvalidcvr = res.data.spa.IS_VALID_CVR;
          if (_this15.isvalidcvr === '') {
            _this15.showcvr = true;
            _this15.cvrerror = res.data.spa.VALID_CVR_REASON;
          }
        }
      }, function (response) {
        _this15.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getsupplierbitrix: function getsupplierbitrix() {
      var _this16 = this;

      this.$http.get(this.$bitrixapi + 'supplier/GetSupplierProfileById/' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this16.FreeTextPartnerPopop = res.data.FreeTextPartnerPopop;
          _this16.FreeTextPartnerPopopUNSER = res.data.FreeTextPartnerPopopUNSER;
          _this16.telephonenumber = res.data.b_crm_company.MOBILE;
          _this16.partneremail = res.data.b_crm_company.EMAIL;
          _this16.partnercvr = res.data.b_crm_company.UF_CRM_COMPANY_CVR;
          _this16.formCallus.name = res.data.b_crm_company.UF_CRM_COMPANY_CONTACT_PERSON;
          _this16.formCallus.phone = Number(res.data.b_crm_company.MOBILE);
          _this16.formCallus.cvr = Number(res.data.b_crm_company.UF_CRM_COMPANY_CVR);
          _this16.formCallus.email = res.data.b_crm_company.EMAIL;
          _this16.form2.telefonnummer = Number(res.data.b_crm_company.MOBILE);
          _this16.form2.companyname = res.data.b_crm_company.TITLE;
          _this16.form2.mobilenummber = Number(res.data.b_crm_company.MOBILE);
          _this16.form2.email = res.data.b_crm_company.EMAIL;
          _this16.form2.fullname = res.data.b_crm_company.UF_CRM_COMPANY_CONTACT_PERSON;
          _this16.form2.city = res.data.b_crm_company.UF_CRM_COMPANY_CITY;
          _this16.form2.postnum = Number(res.data.b_crm_company.UF_CRM_COMPANY_ZIP_CODE);
          _this16.form2.address = res.data.b_crm_company.UF_CRM_COMPANY_ADDRESS;
          _this16.form2.cvr = parseInt(res.data.b_crm_company.UF_CRM_COMPANY_CVR);
          _this16.cvr = parseInt(res.data.b_crm_company.UF_CRM_COMPANY_CVR);
          _this16.partnerinformation['Kontaktperson'] = res.data.b_crm_company.UF_CRM_COMPANY_CONTACT_PERSON;
          _this16.partnerinformation['Firma'] = res.data.b_crm_company.TITLE;
          _this16.partnerinformation['Adresse'] = res.data.b_crm_company.UF_CRM_COMPANY_ADDRESS;
          _this16.partnerinformation['Telefon'] = res.data.b_crm_company.UF_CRM_COMPANY_TELEPHONE;
          _this16.partnerinformation['Mobil'] = res.data.b_crm_company.MOBILE;
          _this16.partnerinformation['Email'] = res.data.b_crm_company.EMAIL;
          _this16.partnerinformation['Postnr'] = res.data.b_crm_company.UF_CRM_COMPANY_ZIP_CODE;
          _this16.partnerinformation['Cvrnr'] = res.data.b_crm_company.UF_CRM_COMPANY_CVR;
          _this16.loading = false;
          _this16.isvalidcvr = true;
          _this16.checkleveranpartner();
          _this16.gettotaljobs();
          if (_this16.isvalidcvr === '') {
            _this16.showcvr = true;
            _this16.cvrerror = res.data.spa.VALID_CVR_REASON;
          }
        }
      }, function (response) {
        _this16.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getdataigibility: function getdataigibility() {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'AccessVideoProProfile');
      } else {
        this.$refs.picDisplay.show = true;
      }
    },
    slimInit: function slimInit(data, slim) {
      console.log(slim);
      console.log(data);
      this.instance.edit();
      this.show = false;
    },
    toLoginPage: function toLoginPage() {
      this.$router.push('/login');
    },
    openUrl: function openUrl() {
      window.open('https://www.haandvaerker.dk');
    },
    slimConfirm: function slimConfirm(data, slim) {
      var _this17 = this;

      console.log();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'edit_image', salesPerson: this.salesPerson, levid: this.haaId, imageId: this.imageId, image: this.instance.dataBase64.output.image };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this17.show = false;
        if (res.login === false) {
          _this17.$router.push('/login');
        }
        if (res.success) {
          _this17.images = res.resultImages;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    slimService: function slimService(formdata, progress, success, failure, slim) {
      console.log(slim);

      console.log(formdata);
      console.log(progress, success, failure);
    },
    changePage: function changePage() {
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (page === 'MarketPlace') {
        this.gettotaljobs();
      }
      this.pageactive = page;
    },
    sendleademail: function sendleademail() {
      var _this18 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (type !== 'saving') {
        var error = 0;
        this.$refs['formCallus'].validate(function (valid) {
          if (!valid) {
            error = 1;
          }
        });
        if (error === 1) {
          return;
        }
      }
      var data = {
        NAME: this.formCallus.name,
        EMAIL: this.formCallus.email,
        PHONE: this.formCallus.phone,
        TYPE: 'AI KANVAS',
        LEV_ID: this.levid,
        CVR: this.formCallusRules.cvr
      };
      this.$http.post(this.$bitrixapi + 'external/leadGenerated', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this18.showthankyoupopup();
          _this18.limitedpopup = false;
        }
      }).catch(function (err) {
        _this18.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    Reload: function Reload() {
      var _this19 = this;

      this.show = true;
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.levid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        _this19.items = res;
      }, function (response) {});
    },
    SaveDescription: function SaveDescription() {
      var _this20 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_haa_desc', salesPerson: this.salesPerson, levid: this.haaId, description: this.myHTML };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this20.show = false;
        if (res.login === false) {
          _this20.$router.push('/login');
        }
        if (res.success) {
          _this20.saveConfirmpermissionautomated();
          _this20.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Tak for opdateringen :)<br />' + 'Din tekst kommer online på din profil så snart den er godkendt.<br />' + '<br />' + 'Hvis du har nogle spørgsmål, så ring eller skriv endelig.<br />',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this20.$refs.simplert.openSimplert(obj);
        } else {
          _this20.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this20.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    addprofiletoreepay: function addprofiletoreepay() {
      var _this21 = this;

      var data = {
        partnerId: this.levid,
        company: this.form2.companyname,
        name: this.form2.fullname,
        address: this.form2.address,
        address2: '',
        city: this.form2.city,
        zipcode: this.form2.postnum
      };
      this.$http.post(this.$bitrixapi + 'reepay/addCustomer/', data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this21.showsessionnewcredit();
        } else {
          _this21.showsessionnewcredit();
        }
      }).catch(function (err) {
        _this21.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    saveConfirmpermissionautomated: function saveConfirmpermissionautomated() {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'external/AutomatedOnboardingApprovedByCraftman?LEV_ID=' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    savetextConfirm: function savetextConfirm() {
      var _this22 = this;

      if (this.telephonenumber === '' || typeof this.telephonenumber === 'undefined') {
        this.updatemobile = true;
        this.haseditedphone = true;
        return false;
      }
      this.updatemobile = false;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        spaId: this.SpaId,
        profileText: this.myHTML
      };
      if (this.haseditedphone) {
        data['mobile'] = this.telephonenumber;
      }
      this.$http.post(this.$bitrixapi + 'external/confirmProfileTextAIKanvas', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this22.SubmitAItext = true;
        setTimeout(function () {
          _this22.openUrl();
        }, 4000);
      }, function (response) {
        _this22.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getSpinformation: function getSpinformation(id) {
      var _this23 = this;

      this.$http.get(this.$bitrixapi + 'external/getProfileTextAIKanvas?spaId=' + id, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this23.profileText = res.data.PROFILE_TEXT;
          _this23.myHTML = _this23.profileText;
          _this23.spainfo = res.data;
          _this23.levid = res.data.COMPANY;
          _this23.getsupplierbitrix();
        }
      }, function (response) {
        _this23.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    decode: function decode(key) {
      var _this24 = this;

      this.loading = true;
      this.loadingjobs = true;
      this.$http.get(this.$bitrixapi + 'integration/decode/' + key, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this24.SpaId = res.data;

        _this24.getSpinformation(_this24.SpaId);
      }, function (response) {
        _this24.$message({
          type: 'error',
          message: response.body.message
        });
      });
    }
  }
});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"signup_AI_text"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end pr4 items-center ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex pr4 justify-between items-center header-fixed app-header",attrs:{"id":"mainbarstatus"}},[_c('div',{staticClass:"col-12 p0 flex flex-row mx-auto items-center mobile-flex-column white justify-between"},[_c('div',{staticClass:"flex h5 semi-bold m0 ml-auto justify-end mpt1 py1"},[_c('div',{staticClass:"m0 flex items-center"},[_vm._m(1),_vm._v(" "),_c('button',{staticClass:"p1 py2 px3 action-button",on:{"click":function($event){return _vm.showconfirmcvr()}}},[_vm._v("Prøv Håndværker.dk 30 dage gratis")])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{attrs:{"id":"marketplace2ai"}},[_c('div',{staticClass:"sidebar"},[_c('div'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold capitalletter",on:{"click":function($event){return _vm.changePage('tekst')}}},[_vm._m(3)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.changePage('MarketPlace')}}},[_vm._m(4),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(6),_vm._v(" "),_vm._m(7)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(8)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(9),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(11),_vm._v(" "),_vm._m(12)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(13),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular hide",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(15)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold nav-dropdown-toggle",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(16)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(17)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(18)])])]),_vm._v(" "),_c('div')]),_vm._v(" "),(_vm.pageactive === 'tekst')?_c('main',{staticClass:"main p2",attrs:{"id":"profilsideAi"}},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix p2 pb3 mb2"},[_vm._m(19),_vm._v(" "),_c('el-collapse',{directives:[{name:"b-toggle",rawName:"v-b-toggle.profiletext",modifiers:{"profiletext":true}}],staticClass:"col-12 px2 gibson mb2 border-collapse mt2",attrs:{"accordion":""},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex col-12 p0"},[_c('div',{staticClass:"flex flex-column items-start col-10 p0"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson mt2"},[_vm._v("Ret din profiltekst.")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                              Herunder kan du finde din profiltekst, som bliver offentliggjort på din profilside på Håndværker.dk. "),_c('br'),_vm._v(" Ret teksten eller tryk på 'gem ændringer' for at opdatere din profiltekst.\n                            ")])])])]),_vm._v(" "),_c('div',{staticClass:"py1 "}),_vm._v(" "),_c('div',{staticClass:" flex col-12 justify-end p0 semi-bold "},[_c('p',{staticClass:"darkblue m0"},[_vm._v(_vm._s(_vm.eliglbletextlimit)+" Tekst")])]),_vm._v(" "),_c('quill-editor',{ref:"myQuillEditor",attrs:{"options":_vm.editorConfig},model:{value:(_vm.myHTML),callback:function ($$v) {_vm.myHTML=$$v},expression:"myHTML"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 line-height-1 flex justify-center items-center my2 not-rounded gibson",on:{"click":function($event){return _vm.savetextConfirm('saving')}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Gem ændringer")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])],2)],1)],1)])]):(_vm.pageactive === 'MarketPlace')?_c('main',{staticClass:"main p2"},[_c('div',{staticClass:"col-12  p0 "},[_vm._m(20),_vm._v(" "),_c('p',{staticClass:"lg-col-10 md-col-11 h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap items-center"},[(_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                Se opgaver\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                Se ledige arbejdskraft\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"darkblue-background p2 px3 h5 not-rounded flex justify-center white items-center line-height-1 my2 mr1",staticStyle:{"width":"435px","height":"77px","border":"0px solid"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',[_vm._v("\n                Antal reservationer: 0 ud af 3\n              ")])]):_vm._e()])]),_vm._v(" "),(_vm.loadingjobs)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(21)]):_c('div',[(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-start"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer!important","width":"300px"},on:{"click":function($event){_vm.limitedpopup = true}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2 flex items-center",staticStyle:{"height":"51px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingzip)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingcity)+"\n                  ")])]),_vm._v(" "),(item.gratis1 === '1')?[_vm._m(22,true)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center",staticStyle:{"height":"41px"}},[_c('span',[_vm._v(_vm._s(item.producttitle))])]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1",staticStyle:{"height":"60px"}},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.comment_to_partner,80, '...'))+"\n                  ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()])],2)])])}),0)]):_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.key,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){_vm.joblimitedpopup = true}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block flex items-center",staticStyle:{"height":"41px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingzip)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingcity)+"\n                    ")])])]),_vm._v(" "),(item.gratis1 === '1')?_c('div',{staticClass:"absolute bottom-0 right-0 left-0 hide"},[_vm._m(23,true)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.producttitle))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h5 darkblue regular line-height-2 mb1"},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.comment_to_partner,50, '...'))+"\n                    ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud !== 1)?_c('span',[_vm._v(_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(item.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()],2)])])}),0)])])]):_vm._e()]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"confirmcvr",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmcvr","no-close-on-backdrop":true}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson pt1 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmcvr()}}},[_c('span',[_c('i',{staticClass:"el-icon-close h5 "})])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',{staticClass:"col-12 p0 mmb5"},[_c('div',{staticClass:"flex justify-around lg-col-4 md-col-4 sm-col-12 mx-auto items-center mt1"},[_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"49.036","height":"56.623","viewBox":"0 0 49.036 56.623"}},[_c('path',{attrs:{"id":"Indtast_Info","data-name":"Indtast Info","d":"M30.637,53.466a10.929,10.929,0,0,1-1.054-1.221H6.424A6.431,6.431,0,0,1,0,45.821V6.424A6.431,6.431,0,0,1,6.424,0H26.141a1.5,1.5,0,0,1,.969.372l.007,0,.014.013.052.05L41.957,15.213c.023.023.046.048.068.073a1.505,1.505,0,0,1,.371.969V35.887a10.781,10.781,0,1,1-11.759,17.58Zm-.157-7.621a7.778,7.778,0,1,0,7.779-7.779A7.787,7.787,0,0,0,30.479,45.845ZM3,6.424v39.4a3.428,3.428,0,0,0,3.424,3.424h21.6A10.785,10.785,0,0,1,38.258,35.067a10.964,10.964,0,0,1,1.139.059V17.773H26.123a1.5,1.5,0,0,1-1.5-1.5V3H6.424A3.428,3.428,0,0,0,3,6.424Zm24.623,8.349h9.652L27.623,5.121Zm9.135,34.782V47.345H34.547a1.5,1.5,0,1,1,0-3h2.211V42.133a1.5,1.5,0,1,1,3,0v2.211h2.211a1.5,1.5,0,1,1,0,3H39.757v2.211a1.5,1.5,0,1,1-3,0ZM11.5,39.882a1.5,1.5,0,1,1,0-3h15a1.5,1.5,0,1,1,0,3Zm0-10a1.5,1.5,0,1,1,0-3h20a1.5,1.5,0,1,1,0,3Zm-.151-9.646a1.5,1.5,0,1,1,0-3h4.925a1.5,1.5,0,0,1,0,3Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Indtast info")])]),_vm._v(" "),_c('span',{},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.382","height":"16.409","viewBox":"0 0 9.382 16.409"}},[_c('path',{attrs:{"id":"Icon_ionic-ios-arrow-forward","data-name":"Icon ionic-ios-arrow-forward","d":"M17.8,14.4l-6.209-6.2a1.168,1.168,0,0,1,0-1.656,1.182,1.182,0,0,1,1.661,0l7.035,7.03a1.17,1.17,0,0,1,.034,1.617l-7.064,7.079A1.173,1.173,0,1,1,11.6,20.607Z","transform":"translate(-11.246 -6.196)","fill":"#23a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"56.623","height":"56.623","viewBox":"0 0 56.623 56.623"}},[_c('path',{attrs:{"id":"Activer","d":"M0,28.312A28.311,28.311,0,1,1,28.312,56.623,28.312,28.312,0,0,1,0,28.312ZM18.452,51.653a25.3,25.3,0,0,0,26.31-4.078v-4.45a7.6,7.6,0,0,0-7.59-7.59H19.014a7.59,7.59,0,0,0-7.59,7.59v4.067A25.2,25.2,0,0,0,18.452,51.653Zm18.72-19.1a10.583,10.583,0,0,1,10.57,10.57v1.439A25.333,25.333,0,1,0,4.97,18.452,25.31,25.31,0,0,0,8.443,44.03v-.9a10.571,10.571,0,0,1,10.57-10.57ZM17.523,15.887A10.57,10.57,0,1,1,28.093,26.457,10.582,10.582,0,0,1,17.523,15.887Zm2.98,0a7.59,7.59,0,1,0,7.59-7.59A7.6,7.6,0,0,0,20.5,15.887Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Aktiver")])])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 mx-auto flex flex-column p1 mx3 mt1 mb2 darkblue"},[_c('div',{staticClass:"center mb1 mt2"},[_c('p',{staticClass:"h4  semi-bold"},[_vm._v("Prøv 30 dage gratis")])]),_vm._v(" "),_c('div',{staticClass:"lg-col-10 md-col-10 sm-col-12 mx-auto center mt1 mb2"},[_c('p',{staticClass:"h6 line-height-golden"},[_vm._v("& Få 3 gratis opgaver ved oprettelse")])]),_vm._v(" "),_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.form2,"rules":_vm.rulesform2,"label-position":"top"}},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"m0 p0  mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"CVR","prop":"cvr"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","placeholder":"12345678"},model:{value:(_vm.form2.cvr),callback:function ($$v) {_vm.$set(_vm.form2, "cvr", _vm._n($$v))},expression:"form2.cvr"}})],1),_vm._v(" "),(_vm.showcvr)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":_vm.cvrerror,"type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"E-mail"},model:{value:(_vm.form2.email),callback:function ($$v) {_vm.$set(_vm.form2, "email", $$v)},expression:"form2.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"Telefonnummer","prop":"telefonnummer"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","id":"phone","placeholder":"Mobilnr.(8 cifre)"},model:{value:(_vm.form2.telefonnummer),callback:function ($$v) {_vm.$set(_vm.form2, "telefonnummer", _vm._n($$v))},expression:"form2.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fulde Navn","prop":"fullname"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Hans Hansen"},model:{value:(_vm.form2.fullname),callback:function ($$v) {_vm.$set(_vm.form2, "fullname", $$v)},expression:"form2.fullname"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"center p0 col-12"},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover  p2 px3 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){_vm.updateinfo(), _vm.tracking2()}}},[_vm._v("Blive ved"),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":".dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"payment",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"payment","no-close-on-backdrop":true},on:{"show":function($event){return _vm.limitleverantext()}}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepayment()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),(_vm.loadingnewpayment)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',[_c('div',{staticClass:"p2 flex justify-center mmt4"},[_c('div',{staticClass:"subitems mt4 relative flex flex-column item-between height-full py4 px1 relative",staticStyle:{"width":"390px","box-shadow":"0px 0px 20px #19A3C04D"},attrs:{"id":"subitemitem1"}},[_c('div',{staticClass:" absolute top-0 left-0 bottom-0 right-0 mb1 primarycolor-background relative ",attrs:{"id":"subicons"}},[_c('svg',{staticClass:"absolute",staticStyle:{"top":"20%","left":"25%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","viewBox":"0 0 128.416 110.912"}},[_c('path',{attrs:{"id":"Freemium","d":"M55.035,110.912a1.529,1.529,0,1,1,0-3.057H61.1v-1.529H48.92a1.529,1.529,0,0,1,0-3.058H79.5a1.529,1.529,0,0,1,0,3.058H67.311v1.529h6.834a1.529,1.529,0,0,1,0,3.057Zm28.928-4.586a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm-45.862,0a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm77.106-6.115h-102a1.542,1.542,0,1,1,0-3.058h47.2a18.384,18.384,0,0,1-.816-6.211,3.058,3.058,0,0,1,3.056-2.961h3.041a3.079,3.079,0,0,1,3.057,3,16.872,16.872,0,0,1-.929,6.169h47.395a1.542,1.542,0,1,1,0,3.058Zm-51.54-3.382h0a1.527,1.527,0,0,0,.5.324c.685-.272,1.625-2.633,1.52-6.089v-.025H62.645C62.56,93.719,63.1,96.289,63.668,96.829Zm61.689,1.853a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,125.357,98.683Zm-5.351,1.529a1.529,1.529,0,0,1,0-3.058H122.3a1.529,1.529,0,0,1,0,3.058Zm-113.892,0a1.529,1.529,0,0,1,0-3.058H8.408a1.529,1.529,0,0,1,0,3.058ZM0,98.683a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,0,98.683ZM68.532,84.924H59.879a4.561,4.561,0,0,1-4.554-3.969c-.049-.4-.1-.867-.165-1.381H51.284a3.08,3.08,0,0,1-3.122-2.8L45.134,63.087a1.529,1.529,0,0,1,2.23-1.67l6.291,3.461c-.713-8.326-1.23-17.6-.68-23.241.257-2.627,1.812-9.432,2.036-10.405a9.4,9.4,0,0,1,18.395-.014c.224.964,1.775,7.695,2.031,10.294.558,5.665.037,15-.68,23.368l6.294-3.463a1.528,1.528,0,0,1,2.23,1.67L80.253,76.77a3.08,3.08,0,0,1-3.122,2.8H73.252c-.061.514-.117.978-.166,1.381a4.56,4.56,0,0,1-4.522,3.97ZM56.017,41.935c-.987,10.109,1.656,33,2.343,38.65a1.5,1.5,0,0,0,1.519,1.281h8.653a1.5,1.5,0,0,0,1.518-1.281c.689-5.665,3.341-28.635,2.343-38.772-.154-1.569-.882-5.037-1.41-7.432a17.191,17.191,0,0,1-6.776,1.241,17.2,17.2,0,0,1-6.769-1.238C56.91,36.807,56.174,40.341,56.017,41.935ZM74.426,68.553c-.281,2.965-.57,5.7-.823,7.963h3.528A.185.185,0,0,0,77.2,76.5a1.5,1.5,0,0,1,.035-.259l2.327-10.518ZM51.177,76.242a1.575,1.575,0,0,1,.034.26.188.188,0,0,0,.073.013h3.524c-.253-2.267-.542-5-.823-7.964L48.85,65.725ZM58.145,31.3c.69.5,2.759,1.264,6.063,1.264s5.378-.77,6.066-1.266a6.313,6.313,0,0,0-6.064-4.467h-.027A6.314,6.314,0,0,0,58.145,31.3Zm4.493,45.216V63.521a1.528,1.528,0,0,1,1.528-1.529h0a1.529,1.529,0,0,1,1.529,1.529l0,12.994a1.529,1.529,0,1,1-3.058,0ZM58.092,51.673V46.322a6.115,6.115,0,0,1,12.23,0v5.351a6.115,6.115,0,1,1-12.23,0Zm3.058-5.351v5.351a3.058,3.058,0,1,0,6.115,0V46.322a3.058,3.058,0,0,0-6.115,0Zm58.325,4.2A1.529,1.529,0,1,1,121,52.056,1.529,1.529,0,0,1,119.476,50.527Zm.764,0a.765.765,0,1,0,.764-.765A.765.765,0,0,0,120.24,50.527ZM6.516,50.86,7.652,49.4v-.023l-1.77.226v-.813l1.759.227v-.023L6.516,47.536l.73-.419.742,1.663h.024l.73-1.674.718.407L8.323,49.007v.023l1.805-.239V49.6l-1.805-.215v.024l1.148,1.435-.754.431L8,49.6H7.975L7.2,51.291Zm82.722-6.327a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,89.238,44.533Zm.764,0a.764.764,0,1,0,.764-.765A.764.764,0,0,0,90,44.533ZM34.4,34.381a2.293,2.293,0,1,1,2.293,2.294A2.293,2.293,0,0,1,34.4,34.381Zm1.147,0a1.146,1.146,0,1,0,1.146-1.146A1.146,1.146,0,0,0,35.544,34.381Zm79.625-.422,1.114-1.431V32.5l-1.736.222v-.8l1.725.224v-.024l-1.1-1.432.716-.41.727,1.63h.023l.715-1.642.7.4L116.94,32.14v.023l1.771-.235v.8l-1.771-.211v.023l1.125,1.408-.739.422-.7-1.643H116.6l-.763,1.655ZM85.61,19.187a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,85.61,19.187Zm.765,0a.764.764,0,1,0,.764-.764A.764.764,0,0,0,86.375,19.187Zm-76.2-1.529A1.529,1.529,0,1,1,11.7,19.187,1.529,1.529,0,0,1,10.17,17.659Zm.764,0a.764.764,0,1,0,.764-.764A.766.766,0,0,0,10.934,17.659ZM111.49,9.253l.962-1.234V8l-1.5.192V7.5l1.487.193V7.675L111.49,6.44l.618-.354.627,1.406h.021l.617-1.416.607.344-.961,1.264v.021l1.527-.2v.688l-1.527-.182v.02l.971,1.215-.638.365-.607-1.417h-.02l-.658,1.427ZM59.07,2.162l.654-.84V1.308l-1.02.131V.971l1.013.131V1.088L59.07.248l.42-.241.427.957h.014L60.351,0l.413.234-.654.861v.014L61.15.971v.468l-1.039-.124v.014l.661.826-.434.248-.413-.964h-.013l-.449.971Z","fill":"#fff"}})])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"col-12 center bold h6 my2"},[_vm._v("PRØVEPAKKE")]),_vm._v(" "),_c('p',{staticClass:"col-12 center bold h2 my2"},[_c('span',{staticClass:"primarycolor"},[_vm._v("GRATIS*")])])]),_vm._v(" "),_c('div',{staticClass:"col-10 mx-auto"},[_c('ul',{staticClass:"list-sub-text list-image-check-mintgreen pb1 pr2 mb3"},[_c('li',{staticClass:" light line-height-4 mt0 pb1 ml1"},[_vm._v("Byd på 3 opgaver")]),_vm._v(" "),_c('li',{staticClass:" light line-height-4 mt0 pb1 mb2 ml1"},[_vm._v("Gratis adgang i 30 dage")]),_vm._v(" "),_c('div',{staticClass:"center col-12"},[_c('button',{staticClass:"action-button p2 px3 round",attrs:{"type":"button"},on:{"click":function($event){return _vm.goto()}}},[_vm._v("Vælg")])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"lg-col-12 md-col-12 sm-col-12 mx-auto mx3"},[_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background"},[_c('p',{staticClass:"h4 semi-bold my1 col-12 flex justify-start py2 px0"},[_vm._v("Kurv")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold my1 col-12 flex justify-start p0"},[_vm._v("Plan valgt: GRATIS")]),_vm._v(" "),_c('p',{staticClass:" h3 semi-bold darkblue center my2 col-12 flex justify-start p0"},[_vm._v("At betale nu: "),_c('span',{staticClass:"primarycolor pl2"},[_vm._v(" 0.- kr")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start",staticStyle:{"max-width":"920px"}},[_c('p',{staticClass:"semi-bold mt1 mb0",staticStyle:{"font-size":"12px"}},[_vm._v("Pris per måned:*")]),_vm._v(" "),_c('p',{staticClass:"pb1 h6 line-height-golden flex justify-start italic p0",staticStyle:{"font-size":"12px"},attrs:{"id":"leverantext"}},[_vm._v(_vm._s(_vm.leverantext))]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showmore"},on:{"click":function($event){return _vm.limitleverantext(1)}}},[_c('span',[_vm._v("Læs mere")])]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showless"},on:{"click":function($event){return _vm.limitleverantext(2)}}},[_c('span',[_vm._v("Vis mindre")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background mt2"},[_c('p',{staticClass:"semi-bold h4 darkblue col-12 flex justify-start mt2 px0"},[_vm._v("Vælg betalingsform")]),_vm._v(" "),_c('p',{staticClass:"h6 initial mb2"},[_vm._v("Dette er for at bekræfte din konto. Du bliver ikke opkrævet i din 30 dages prøveperiode.")]),_vm._v(" "),[_c('div',{staticClass:" flex col-12 m0 p0 flex-column"},[_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center p0",on:{"click":function($event){return _vm.checkboxselect('leve')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.leverancheckbox),expression:"leverancheckbox"}],attrs:{"type":"radio","id":"leverandcheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.leverancheckbox,"1")},on:{"change":function($event){_vm.leverancheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 semi-bold mx2 flex items-center"},[_vm._v("Leverandørservice (0 kr.)")])]),_vm._v(" "),_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0",on:{"click":function($event){return _vm.checkboxselect('reep')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reepaycheckbox),expression:"reepaycheckbox"}],attrs:{"type":"radio","id":"reepaycheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.reepaycheckbox,"1")},on:{"change":function($event){_vm.reepaycheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"mx2 h6 semi-bold flex items-center mb0"},[_vm._v("Kreditkort (0 kr.)")])]),_vm._v(" "),_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0",on:{"click":function($event){return _vm.checkboxselect('mobpay')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobilepaycheckbox),expression:"mobilepaycheckbox"}],attrs:{"type":"radio","id":"mobilepaycheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.mobilepaycheckbox,"1")},on:{"change":function($event){_vm.mobilepaycheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"mx2 h6 semi-bold flex items-center mb0"},[_vm._v("MobilePay (0 kr.)")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 p0 mx-auto mt2",attrs:{"id":"leveran"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"col-12 p0"},[(_vm.levandorupdate !== '')?_c('b-alert',{staticClass:"my2",attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                            ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap mt2 p0"},[_c('el-form',{ref:"step4formcontact2",staticClass:"tui-f lg-col-12 sm-col-12 sm-col-12 mx-auto",attrs:{"model":_vm.form,"rules":_vm.rulesform,"label-position":"top"}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Reg. nr.","prop":"regnr"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"maxlength":"4","placeholder":"4 cifre"},model:{value:(_vm.form.regnr),callback:function ($$v) {_vm.$set(_vm.form, "regnr", $$v)},expression:"form.regnr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Konto nr.","prop":"bankkonto"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"minimum":"6","maxlength":"10","placeholder":"6-10 cifre"},model:{value:(_vm.form.bankkonto),callback:function ($$v) {_vm.$set(_vm.form, "bankkonto", $$v)},expression:"form.bankkonto"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none center el-form-item__plain el-form-item__checkbox",attrs:{"id":"accepterms"}},[_c('el-checkbox',{staticClass:"el-checkbox flex justify-start md-col-10 lg-col-10 sm-col-12 pl1 mp0 ml-auto",attrs:{"label":"","id":"consentleverancheckbox"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentleveran),callback:function ($$v) {_vm.consentleveran=$$v},expression:"consentleveran"}},[_c('span',{staticClass:"second-secondary "},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplinklever()}}},[_vm._v(" LeverandørService")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement.")])])]),_vm._v(" "),(_vm.showerrorleveranerror)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Indtast venligst nummer","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0"},[_c('button',{staticClass:"action-button not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"773px"},attrs:{"type":"button","id":"leverrsub"},on:{"click":_vm.service_levendor}},[_c('span',{staticClass:"semi-bold h5 m0"},[_vm._v("Start"),_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2",attrs:{"id":"moreid"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto hide",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"hide col-12 flex justify-center",attrs:{"id":"mobilepay"}},[(_vm.disablemobilepaybutton)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):_c('a',{staticClass:"action-button no-underline not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"700px"},attrs:{"type":"button","href":_vm.mobilepaylink}},[_c('span',{staticClass:"white semi-bold h5 m0"},[_vm._v("Start")])])])]],2),_vm._v(" "),_c('div',{staticClass:"hide",attrs:{"id":"lastitem"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","type":"button","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","disabled":"true"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("TILLYKKE! DU KAN NU SE OG LÅSE OPGAVERNE OP.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Din plan er nu aktiv, og du kan begynde at byde på ledige opgaver. Vi har også sendt dig en e-mail med bekræftelse på din konto aktivering. ")]),_vm._v(" "),_c('a',{staticClass:"center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":_vm.shorturl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Gå til Marketplace")])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mx-auto center line-height-4"},[_vm._v("Bemærk, at såfremt du har valgt en “gratis” plan til 0 kr., har du 30 dage til at opsige denne, hvis du ikke ønsker at din plan automatisk skal opgraderes til en Basis-Plus plan til kr. 795,- pr. måned ex moms med binding løbende måned + èn måned fra den dato Basis-Plus planen træder i kraft."),_c('br'),_c('br'),_vm._v("\n                Du opsiger ved at sende en e-mail til "),_c('a',{attrs:{"target":"_blank","href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")]),_vm._v(" Planen bliver trukket automatisk via leverandører-/ betalingsservice og vi sender altid en mail til dig, inden vi trækker pengene. Du kan læse mere om vores handelsbetingelser "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk/om/betingelser?ref=bm","target":"_blank"}},[_vm._v("her.")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"popupcontract",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popupcontract"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopupcontract()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px","zoom":".5"},attrs:{"src":'https://www.kundematch.dk/s/otheraftale_new.php?bitrixid=' + this.levid + '&mode=ssl',"frameborder":"0","zoom":"0.9","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplink",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplink"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplink()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":"https://reepay.com/terms-of-service/","frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplinklever",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplinklever"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background  "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplinklever()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","height":"95%","overflow":"auto"}},[_c('vue-pdf-app',{attrs:{"pdf":"/static/pdf/Generelle_regler_for-kreditorer_i_LeverandørService_v_1.0_14.09.2019.pdf"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit link er allerede brugt.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Du har en e-mail med login og password, så du kan logge ind nu.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"initialPopup",attrs:{"centered":"","hide-header":"","hide-footer":"","size":"lg","id":"initialPopup","no-close-on-backdrop":true},model:{value:(_vm.showvideoPopup),callback:function ($$v) {_vm.showvideoPopup=$$v},expression:"showvideoPopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeinitialPopup()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),(_vm.videoresponseloading)?_c('div',[_c('div',{staticClass:"loader"})]):_c('div',{attrs:{"id":"videomainPopup"}})]),_vm._v(" "),_c('b-modal',{ref:"limitedpopup",attrs:{"centered":"","hide-header":"","hide-footer":"","size":"lg","id":"limitedpopup","no-close-on-backdrop":false},model:{value:(_vm.limitedpopup),callback:function ($$v) {_vm.limitedpopup=$$v},expression:"limitedpopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",attrs:{"type":"button"},on:{"click":function($event){_vm.limitedpopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"center p2"},[_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Din adgang er begrænset")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mt2 mx-auto"},[_vm._v("Vil du have adgang til alle funktioner og en fast tilknyttet konsulent som hver måned kontakter dig med lækre opgaver, skal du først opgradere din plan")])]),_vm._v(" "),_c('div',{staticClass:"col-8 mx-auto"},[_c('el-form',{ref:"formCallus",attrs:{"model":_vm.formCallus,"rules":_vm.formCallusRules}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"prop":"name"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Navn"},model:{value:(_vm.formCallus.name),callback:function ($$v) {_vm.$set(_vm.formCallus, "name", $$v)},expression:"formCallus.name"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Email"},model:{value:(_vm.formCallus.email),callback:function ($$v) {_vm.$set(_vm.formCallus, "email", $$v)},expression:"formCallus.email"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"prop":"cvr"}},[_c('el-input',{ref:"cvr",staticClass:"border wizard-border white-background",attrs:{"name":"cvr","placeholder":"CVR","id":"cvr"},model:{value:(_vm.formCallus.cvr),callback:function ($$v) {_vm.$set(_vm.formCallus, "cvr", $$v)},expression:"formCallus.cvr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"prop":"phone"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"name":"phone","placeholder":"Telefonnummer","id":"phone","maxlength":"8"},model:{value:(_vm.formCallus.phone),callback:function ($$v) {_vm.$set(_vm.formCallus, "phone", _vm._n($$v))},expression:"formCallus.phone"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"standard-button p2 flex justify-center items-center my3 border-none not-rounded",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.sendleademail()}}},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-arrow-square-up-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"}}),_c('path',{attrs:{"d":"M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 gibson regular pl1 mb0"},[_vm._v("Ring mig op")])])])]),_vm._v(" "),_c('b-modal',{ref:"joblimitedpopup",attrs:{"centered":"","hide-header":"","hide-footer":"","size":"lg","id":"joblimitedpopup","no-close-on-backdrop":false},model:{value:(_vm.joblimitedpopup),callback:function ($$v) {_vm.joblimitedpopup=$$v},expression:"joblimitedpopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",attrs:{"type":"button"},on:{"click":function($event){_vm.joblimitedpopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"center p2"},[_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Din adgang er begrænset")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mt2 mx-auto"},[_vm._v("Vil du have adgang til alle funktioner og en fast tilknyttet konsulent som hver måned kontakter dig med lækre opgaver, skal du først opgradere din plan.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-end"},[_c('button',{staticClass:"standard-button p2 flex justify-center items-center my3 border-none not-rounded",attrs:{"target":"_blank"},on:{"click":_vm.openUrl}},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-arrow-square-up-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"}}),_c('path',{attrs:{"d":"M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 gibson regular pl1 mb0"},[_vm._v("Ring mig op")])])])]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit link er allerede brugt.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Du har en e-mail med login og password, så du kan logge ind nu.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"SubmitAItext",attrs:{"centered":"","hide-header":"","id":"SubmitAItext","no-close-on-backdrop":true},model:{value:(_vm.SubmitAItext),callback:function ($$v) {_vm.SubmitAItext=$$v},expression:"SubmitAItext"}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.104","height":"122.269","viewBox":"0 0 92.104 122.269"}},[_c('g',{attrs:{"id":"Group_4292","data-name":"Group 4292","transform":"translate(-1901.896 -1841.384)"}},[_c('path',{attrs:{"id":"Path_2691","data-name":"Path 2691","d":"M2050.619,2063.713,2038,2057.206a.61.61,0,0,0-.2-.2c-.106-.06-10.945-6.476-13.783-15.262a131.483,131.483,0,0,0-8.62-20.592c.785-1.812,5.4-12.47,6.642-15.655,1.9-4.891.106-7.171-.83-7.971,3.533-7.186,3.08-8.831,2.159-9.466a1.467,1.467,0,0,0-1.132-.2c-.015,0-.03.015-.06.015a3.884,3.884,0,0,0-1.132-2.989,3.2,3.2,0,0,0-3.261-.2,3.64,3.64,0,0,0-1,.709,7.469,7.469,0,0,0-3.97-.74c-.528.015-2.144.076-8.711,8.348-2.627,3.306-5.133,6.793-6.114,8.348-.906-.951-1.464-1.555-1.495-1.585a.618.618,0,0,0-.725-.121c-.121.06-2.536,1.344-3.155,3.14a8.657,8.657,0,0,0-1.676-.921,1.091,1.091,0,0,0-1.117.121c-.377.272-.83.921-.709,3.276a3.489,3.489,0,0,0-1.193.06,3.189,3.189,0,0,0-1.374.694c-.121-.936-.272-1.812-.423-2.551-.679-3.216-3.412-4.967-7.5-4.8h-.091a.643.643,0,0,0-.468.211c-.317.362-.423.468,1.072,13.421.287,2.551.574,4.952.755,6.7.438,4.2,3.336,9.616,5.072,12.862a24.986,24.986,0,0,1,1.313,2.627c-.091.694-1.691,4.514-4.74,11.368-.242.528-.393.876-.468,1.072l-12.168,6.793a.654.654,0,0,0-.3.392.6.6,0,0,0,.091.483l14.719,20.788a.64.64,0,0,0,.468.257h.03a.566.566,0,0,0,.453-.211l10.628-12.319a.6.6,0,0,0,0-.785l-.06-.061,1.026-.785c.2.2.393.377.589.574,4.333,4.061,8.952,6.854,12.7,7.669,7.548,1.661,16.742,6.386,16.833,6.431a.594.594,0,0,0,.272.06c.06,0,.106-.015.151-.015l10.19,8.832Zm-29.695-58.65c-.876,2.234-3.412,8.167-5.118,12.122a.189.189,0,0,0-.091-.166c-.166-.106-.332-.2-.5-.3-.2-.121-.393-.242-.6-.362a2.474,2.474,0,0,1-.483-.408,2.742,2.742,0,0,0-.483-.438.2.2,0,1,0-.211.332,2.337,2.337,0,0,1,.408.362,2.626,2.626,0,0,0,.574.483l.589.362c.166.106.332.211.513.317a.218.218,0,0,0,.106.03.244.244,0,0,0,.136-.045c-.438,1-.8,1.857-1.072,2.491a19.218,19.218,0,0,0-2.355-3.321c-.3-.317-.694-.725-1.147-1.208,1.162-1.9,6.22-10.19,9.5-16.636C2021.347,1999.4,2022.4,2001.259,2020.924,2005.063Zm1.57-16c.045-.015.151-.03.181,0,.045.03,1.026.83-2.883,8.6-2.566,5.1-6.386,11.564-8.454,14.991a2.052,2.052,0,0,1-1.087-1.253.205.205,0,1,0-.408.045,2.438,2.438,0,0,0,1.283,1.555c-.347.574-.634,1.042-.845,1.374-1.042-1.1-2.295-2.431-3.623-3.834,4.574-7.775,11.836-18.9,15.081-21.12a.573.573,0,0,0,.2-.136A3.094,3.094,0,0,1,2022.494,1989.061Zm-4.3-3.231q1.427-.521,2.083,0c.679.558.725,1.947.664,2.687-1.359,1-3.91,3.668-8.816,11.036-2.823,4.242-5.374,8.469-6.341,10.084-1.4-1.479-2.838-3-4.151-4.393,5.978-7.654,12.651-15.761,15.413-18.478a.9.9,0,0,0,.226-.136.574.574,0,0,0,.136-.2A3.554,3.554,0,0,1,2018.192,1985.83Zm-13.119,7.926c5.9-7.443,7.518-7.865,7.79-7.88a7.254,7.254,0,0,1,2.989.423c-3.4,3.427-9.8,11.4-13.36,15.912a4.189,4.189,0,0,1-.408-.317,2.976,2.976,0,0,0-.634-.438.212.212,0,0,0-.211.03.187.187,0,0,0-.06.211c.045.151.091.3.151.468a.858.858,0,0,0,.06.181,2.289,2.289,0,0,1-.815-1.072.2.2,0,1,0-.392.03c.045.6,1.027,1.495,1.479,1.691a.136.136,0,0,0,.075.015.244.244,0,0,0,.136-.045.189.189,0,0,0,.06-.2c-.045-.211-.121-.408-.181-.619a.4.4,0,0,0,.091.075c.136.106.272.226.423.332-.574.725-1.057,1.344-1.434,1.827-.71-.755-1.374-1.464-1.963-2.083A99.467,99.467,0,0,1,2005.073,1993.756Zm-9.118,7.2c.347.362.951,1.011,1.736,1.842h0c.181.181.362.392.558.589a2.78,2.78,0,0,1-2.174,2.234q-1.291-1.2-2.355-2.038C1993.735,2002.557,1995.094,2001.485,1995.955,2000.957Zm-5.42,2.053a9.586,9.586,0,0,1,2.023,1.223.581.581,0,0,0,.528.407c.423.332.891.74,1.4,1.193a1.529,1.529,0,0,1-.106.619,2.345,2.345,0,0,1-1.042,1.147l-.015-.015a10.021,10.021,0,0,0-2.974-1.993A5.953,5.953,0,0,1,1990.535,2003.01Zm-2.31,3.5a2.809,2.809,0,0,1,1.389.106h.015a7.859,7.859,0,0,1,2.6,1.6,4.558,4.558,0,0,1-.362,2.853,3.41,3.41,0,0,1-1.963,1.57c-1.359-1.057-2.37-1.842-2.808-2.159,0-.076-.015-.136-.015-.211-.091-.891-.2-1.766-.287-2.612A2.2,2.2,0,0,1,1988.225,2006.512Zm-.951,5.616c.453.347,1.027.785,1.676,1.3a4.787,4.787,0,0,1-1.193,2.476C1987.576,2014.725,1987.425,2013.427,1987.274,2012.128Zm-8.167-12.258a10,10,0,0,1,1.721.136c.242,1.706.845,6.869-.5,8.469a1.609,1.609,0,0,1-.347.3C1979.545,2005,1979.137,2001.168,1979.107,1999.87Zm15.051,61.458-11.911-14.085c.106-.226.242-.543.408-.906,2.31-5.193,3.578-8.137,4.227-9.828.151.468.332.921.5,1.374l.106.272a.215.215,0,0,0,.2.136.137.137,0,0,0,.075-.015.208.208,0,0,0,.121-.257l-.106-.272c-.226-.589-.453-1.208-.649-1.842.151-.423.257-.74.317-.966.151.151.3.317.468.483a3.869,3.869,0,0,0,1.6,1.238c.015,0,.045.015.06.015a.215.215,0,0,0,.2-.136.21.21,0,0,0-.136-.257,3.415,3.415,0,0,1-1.419-1.117,7.37,7.37,0,0,0-.679-.694c0-.453-.377-1.177-1.449-3.185-1.691-3.155-4.514-8.439-4.937-12.409-.181-1.751-.453-4.167-.755-6.718-.106-.936-.226-1.947-.347-2.974a1.6,1.6,0,0,0,.6-.468c1.419-1.691.876-6.748.6-8.635a4.57,4.57,0,0,1,3.729,3.638c.362,1.706.619,4.121.891,6.673.528,4.876,1.011,9.465,2.325,10.99l.091.091a31.6,31.6,0,0,1,9.163,13.1,97.053,97.053,0,0,1,4,17.376l-8.152-8.273a.634.634,0,0,0-.211-.136c-.408-.151-4.046-1.449-5.737.272-1.042,1.057-1.042,2.944.015,5.616a35.774,35.774,0,0,0,7.745,11.187Zm.74-11.141a5.22,5.22,0,0,1-3.518,1.766,2.867,2.867,0,0,1-2.023-1.1c-.317-.634-.619-1.268-.86-1.887-.845-2.144-.951-3.638-.287-4.318.936-.951,3.336-.377,4.318-.03l3.08,3.125A3.758,3.758,0,0,1,1994.9,2050.187Zm1.63,10.145c-.015-.015-.015-.03-.03-.03a.429.429,0,0,0-.151-.136,39.544,39.544,0,0,1-6.476-8.3,2.451,2.451,0,0,0,1.389.528.618.618,0,0,0,.166-.015,5.7,5.7,0,0,0,3.789-1.932,3.966,3.966,0,0,0,.8-2.28l5.842,5.948a.6.6,0,0,0,.6.151c.242.377.453.74.649,1.117.091.181.166.377.257.574a2.84,2.84,0,0,0,.981,1.449.279.279,0,0,0,.106.03.19.19,0,0,0,.166-.091.194.194,0,0,0-.06-.272,2.314,2.314,0,0,1-.815-1.253,3.667,3.667,0,0,0-.272-.6,11.614,11.614,0,0,0-.679-1.163.683.683,0,0,0,.106-.423c0-.015-.015-.121-.045-.332a4.011,4.011,0,0,0,1.147,1.223.279.279,0,0,0,.106.03.174.174,0,0,0,.166-.091.194.194,0,0,0-.06-.272,3.964,3.964,0,0,1-1.072-1.162,6.52,6.52,0,0,0-.408-.559,99.352,99.352,0,0,0-4.151-18.267,32.383,32.383,0,0,0-9.511-13.617,11.165,11.165,0,0,1-1.253-4.2,4.553,4.553,0,0,0,1.479-2.642c4.453,3.517,12.288,10.039,14.3,13.843,2.823,5.359,3.17,8.545,3.17,8.575a.6.6,0,0,0,.6.543h.06a.609.609,0,0,0,.544-.664c-.015-.136-.347-3.427-3.306-9.028-2.1-3.97-9.843-10.462-14.4-14.055a3.7,3.7,0,0,0,1.947-1.676,4.658,4.658,0,0,0,.453-2.627c5.254,4.831,16.727,18.252,17.708,20.229a6.048,6.048,0,0,1,.725,3.4.6.6,0,0,0,.483.71c.045,0,.075.015.121.015a.585.585,0,0,0,.589-.5,7.05,7.05,0,0,0-.83-4.167c-1.132-2.28-12.59-15.564-17.8-20.41a2.606,2.606,0,0,0,1.117-1.3,4.045,4.045,0,0,0,.106-.408c3.276,3.019,8.3,8.56,15.957,18.463a2.615,2.615,0,0,1-.8.574.2.2,0,0,0-.136.257.209.209,0,0,0,.2.151.114.114,0,0,0,.06-.015,2.612,2.612,0,0,0,.951-.649c.181.242.362.468.543.71.332.438.589.755.725.936a.613.613,0,0,0,.966-.755c-.136-.181-.377-.483-.71-.921-6.778-8.816-12.2-15.172-16.2-18.991a3.125,3.125,0,0,0,2.159-2.219c3.925,4.167,10.628,11.277,12.862,13.617a21.308,21.308,0,0,1,2.748,4.046.61.61,0,0,0,.075.136,129.98,129.98,0,0,1,8.62,20.592c2.642,8.182,11.5,14.176,13.8,15.61l-10.507,17.074c-2.053-1.011-9.949-4.816-16.636-6.28C2005.556,2067.653,2000.68,2064.407,1996.528,2060.331Z","transform":"translate(-56.619 -121.392)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2692","data-name":"Path 2692","d":"M2176.331,2287.492a.2.2,0,0,0-.136-.377,3.274,3.274,0,0,0-1.042.8c-.362.362-.755.725-1.057.74a.2.2,0,0,0-.2.211.2.2,0,0,0,.2.2h.015c.453-.015.891-.438,1.328-.861A3.21,3.21,0,0,1,2176.331,2287.492Z","transform":"translate(-230.941 -378.428)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2693","data-name":"Path 2693","d":"M2179.4,2292.582a6.457,6.457,0,0,1-1.812,1.3.21.21,0,0,0-.136.257.2.2,0,0,0,.2.136.09.09,0,0,0,.06-.015,7.324,7.324,0,0,0,1.962-1.389.21.21,0,0,0,0-.287A.19.19,0,0,0,2179.4,2292.582Z","transform":"translate(-233.954 -383.035)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2694","data-name":"Path 2694","d":"M2221.841,2273.778a3.733,3.733,0,0,0-1.434.921.2.2,0,0,0,.271.3c.091-.091.181-.166.272-.242a1.458,1.458,0,0,0-.272.5.229.229,0,0,0,.045.2.194.194,0,0,0,.151.06h.045a2.066,2.066,0,0,0,.906-.513.2.2,0,0,0,.015-.287.206.206,0,0,0-.257-.045,2.361,2.361,0,0,0,.483-.6.21.21,0,0,0-.015-.211A.234.234,0,0,0,2221.841,2273.778Z","transform":"translate(-270.368 -367.115)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2695","data-name":"Path 2695","d":"M2248.8,2223.215a.2.2,0,0,0-.317-.257c-.347.438-1.268,1.313-1.615,1.344a.2.2,0,0,0-.181.211.2.2,0,0,0,.2.181h.015C2247.476,2224.649,2248.548,2223.532,2248.8,2223.215Z","transform":"translate(-292.742 -323.904)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2696","data-name":"Path 2696","d":"M2254.658,2226.084a6.774,6.774,0,0,0-.679.619,4.453,4.453,0,0,1-.921.77.217.217,0,0,0-.075.272.208.208,0,0,0,.166.091.279.279,0,0,0,.106-.03,5.385,5.385,0,0,0,1-.83,6.167,6.167,0,0,1,.649-.589.2.2,0,0,0,.03-.287A.226.226,0,0,0,2254.658,2226.084Z","transform":"translate(-298.068 -326.591)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2697","data-name":"Path 2697","d":"M2149.733,2444.678l.181-.166a.191.191,0,0,0,.015-.272.214.214,0,0,0-.257-.061,4.307,4.307,0,0,0-.845.725l-.287.287a3.361,3.361,0,0,1-1.1.574.2.2,0,0,0-.151.227.194.194,0,0,0,.2.166h.015a1.974,1.974,0,0,0,1.3-.664A9.273,9.273,0,0,0,2149.733,2444.678Z","transform":"translate(-208.344 -511.777)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2698","data-name":"Path 2698","d":"M2159.032,2452.257a2.59,2.59,0,0,1-1.736.875h0a.2.2,0,0,0-.2.2.2.2,0,0,0,.211.2,2.981,2.981,0,0,0,2.023-1.011.21.21,0,0,0,0-.287A.272.272,0,0,0,2159.032,2452.257Z","transform":"translate(-216.677 -518.601)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2699","data-name":"Path 2699","d":"M2204.882,2119.6a7.162,7.162,0,0,1-2.778-2.566l-.076-.091a.205.205,0,1,0-.332.241l.075.091a7.585,7.585,0,0,0,2.929,2.687.191.191,0,0,0,.091.015.2.2,0,0,0,.181-.121A.176.176,0,0,0,2204.882,2119.6Z","transform":"translate(-254.51 -233.889)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2700","data-name":"Path 2700","d":"M2215.895,2123.347c-.075-.045-.136-.106-.211-.151a.205.205,0,0,0-.241.332,2.556,2.556,0,0,0,.211.151,4.854,4.854,0,0,1,.725.574.193.193,0,0,0,.151.06.245.245,0,0,0,.136-.045.21.21,0,0,0,.015-.287A4.807,4.807,0,0,0,2215.895,2123.347Z","transform":"translate(-266.142 -239.238)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2701","data-name":"Path 2701","d":"M1915.015,2106.408a.6.6,0,0,0,.03-1.208l-12.515-.6a.6.6,0,1,0-.06,1.208l12.515.6Z","transform":"translate(0 -223.476)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2702","data-name":"Path 2702","d":"M1981.406,2006.613l4.635,3.442a.651.651,0,0,0,.362.121.63.63,0,0,0,.483-.241.616.616,0,0,0-.121-.845l-4.635-3.442a.616.616,0,0,0-.845.121A.589.589,0,0,0,1981.406,2006.613Z","transform":"translate(-67.296 -139.366)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2703","data-name":"Path 2703","d":"M2070.719,1955.211a.6.6,0,0,0,.543.332.592.592,0,0,0,.272-.06.605.605,0,0,0,.272-.815l-4.484-8.862a.608.608,0,1,0-1.087.543Z","transform":"translate(-139.474 -88.372)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2704","data-name":"Path 2704","d":"M2170.788,1904h.045a.6.6,0,0,0,.558-.649l-.5-7.609a.59.59,0,0,0-.649-.559.6.6,0,0,0-.559.649l.5,7.609A.6.6,0,0,0,2170.788,1904Z","transform":"translate(-227.361 -45.678)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2705","data-name":"Path 2705","d":"M2295.645,1854.52h.045a.608.608,0,0,0,.6-.558l.966-11.926a.606.606,0,1,0-1.208-.091l-.966,11.926A.607.607,0,0,0,2295.645,1854.52Z","transform":"translate(-333.831)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_2706","data-name":"Path 2706","d":"M2379.719,1937a.6.6,0,0,0,.423-.181l4.227-4.182a.608.608,0,0,0-.86-.86l-4.227,4.182a.6.6,0,0,0,0,.86A.63.63,0,0,0,2379.719,1937Z","transform":"translate(-405.163 -76.597)","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak!")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto "},[_vm._v("Vi har modtaget dine ændringer, som nu vil blive gennemgået.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold center p2"},[_vm._v("Efter vores gennemgang vil du blive kontaktet for en endelig bekræftelse af dine ændringer, inden de bliver offentliggjort.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white mt2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center mb2"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"updatemobile",attrs:{"centered":"","hide-header":"","hide-footer":"","size":"lg","id":"limitedpopup","no-close-on-backdrop":false},model:{value:(_vm.updatemobile),callback:function ($$v) {_vm.updatemobile=$$v},expression:"updatemobile"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background"},[_c('button',{staticClass:"white-button no-border not-rounded gibson",attrs:{"type":"button"},on:{"click":function($event){_vm.updatemobile = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"center p2"},[_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak!")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mt2 mx-auto"},[_vm._v("Vi har modtaget dine ændringer, som nu vil blive gennemgået. ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mt2 mx-auto"},[_vm._v("Efter vores gennemgang vil du blive kontaktet for en endelig bekræftelse af dine ændringer, inden de bliver offentliggjort.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mt2 mx-auto"},[_vm._v("Bekræft dit telefonnummer")])]),_vm._v(" "),_c('div',{staticClass:"col-8 mx-auto"},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"name":"phone","placeholder":"Telefonnummer","id":"phone","maxlength":"8"},model:{value:(_vm.telephonenumber),callback:function ($$v) {_vm.telephonenumber=_vm._n($$v)},expression:"telephonenumber"}})],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-end my2"},[_c('button',{staticClass:"standard-button p2 flex justify-center items-center my3 border-none not-rounded",attrs:{"target":"_blank"},on:{"click":function($event){return _vm.savetextConfirm()}}},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-arrow-square-up-right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z"}}),_c('path',{attrs:{"d":"M11.828 9.586l-3.95 3.95a1 1 0 1 1-1.414-1.415l3.95-3.95H6.828a1 1 0 0 1 0-2h6a.997.997 0 0 1 1 1v6a1 1 0 1 1-2 0V9.587z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 gibson regular pl1 mb0"},[_vm._v("Gem ændringer")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"darkblue"},[_c('img',{attrs:{"src":"/static/gif/arrow-blue-fast.gif","width":"90","height":"32"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger not-rounded m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"darkblue h6 p1 m0 center"},[_vm._v("Du mangler at aktivere din gratis bruger for at modtage dine 3 gratis bud.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-house ml1 darkblue bold "}),_vm._v(" "),_c('span',{staticClass:"inline-block semi-bold"},[_vm._v("Profil tekst\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-money mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"semi-bold m0 col-7 p0"},[_vm._v("Opgaver")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold hide",attrs:{"id":"udbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular "},[_vm._v("Udbud ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle regular",attrs:{"id":"dropAnbefalinger"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Anbefalinger")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"indhent-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Indhent anbefalinger\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"laes-og-besvar-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Læs og besvar\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"auto-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sæt anbefalinger på Auto-pilot\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"widgets"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Widgets\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-files mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block regular"},[_vm._v("Mine kunder\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle regular",attrs:{"id":"dropDine projekter"}},[_c('i',{staticClass:"el-icon-picture-outline mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Dine projekter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"opret-projekt-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opret projekt\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"status-haandvaerker-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Mine projekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/approved-projects"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Åbne kundeprojekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/project-dashboard"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Vundne kundeprojekter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle regular",attrs:{"id":"dropMester-til-Mester"}},[_c('i',{staticClass:"el-icon-share mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Mester-til-Mester")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-arbejdskraft"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Arbejdskraft\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-opgaver"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button","href":"#/mester-opgaver"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Opgaver\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle regular"},[_c('i',{staticClass:"el-icon-document mr2 darkblue "}),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Opret tilbud")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/tilbud-historie"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Tilbudshistorie\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/standardTilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Standard Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/hurtigt-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block regular"},[_vm._v("Hurtigt Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/upload-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:" inline-block regular"},[_vm._v("Upload Tilbud\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block regular"},[_vm._v("Inviter en kollega\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-monitor mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block regular"},[_vm._v("Gratis hjemmeside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block regular"},[_vm._v("Medlemsfordele\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0 regular",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Digital pakke\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 mt3 mb2 gibson"},[_vm._v("\n                          Redigér i din profil-side på Håndværker.dk\n                        ")])])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                      Din profilside på Håndværker.dk indeholder en kort beskrivelse af virksomheden og dine ydelser.\n                    ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n                      Gør det nemmere for boligejerne at finde din profil på Håndværker.dk. Opdater din profiltekst nemt, enkelt og helt uforpligtende herunder og fremstå mere professionel, når en boligejer finder din profil på Håndværker.dk.\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Markedsplads\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 mintgreen semi-bold block"},[_vm._v("\n                      Gratis møde\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-background mintgreen gibson line-height-1 h6 mb0 p1 pb2"},[_c('span',{staticClass:"block hide"},[_vm._v("Gratis møde  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inviterepartner_vue__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d6721a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_inviterepartner_vue__ = __webpack_require__(1094);
function injectStyle (ssrContext) {
  __webpack_require__(1092)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inviterepartner_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16d6721a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_inviterepartner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1092 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1093 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"],
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default.a
  },
  watch: {},
  data: function data() {
    return {
      loadingnewpayment: false,
      reepaycheckbox: '0',
      leverancheckbox: '1',
      mobilepaycheckbox: '0',
      pid: '',
      fullurl: '',
      disablemobilepaybutton: false,
      showcvr: false,
      cvrerror: '',
      originalid: '',
      levid: '',
      projectid: '',
      step: 1,
      jobstotal: '',
      jobstotalstatic: 3,
      SearchItem: [],
      loading: false,
      loadingjobs: false,
      showsessionnewcreditpro: '',
      disableupdateinfo: false,
      form2: {
        fullname: '',
        email: '',
        telefonnummer: '',
        companyname: '',
        address: '',
        postnum: '',
        city: '',
        cvr: '',
        mobilenummber: ''
      },
      form: {
        regnr: '',
        bankkonto: ''
      },
      rulesform2: {
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],

        telefonnummer: [{
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt 8 digit mobilnr.',
          trigger: 'blur'
        }],

        cvr: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Indtast venligst et gyldigt cvr og 8 cifre.',
          trigger: 'blur'
        }]
      },
      rulesform: {
        bankkonto: [{
          min: 6,
          max: 10,
          message: 'Indtast venligst et gyldigt 6 til 10-cifret nummer.',
          trigger: 'blur'
        }, {
          required: true,
          type: 'string',
          message: 'Indtast venligst nummer.',
          trigger: 'blur'
        }],
        regnr: [{
          required: true,
          type: 'string',
          max: 4,
          message: 'Indtast venligst et gyldigt 4-cifret nummer.',
          trigger: 'blur'
        }]
      },
      salesPerson: '',
      hasleveran: '',
      levandorupdate: '',
      regnr: '',
      bankkonto: '',
      options: [],
      bank: '',
      cvr: '',
      gratisbutton: 1,
      consentleveran: true,
      consentreepay: 'accepted',
      leverantext: '',
      isvalidcvr: '',
      showerrorleveran: false,
      showerrorleveranerror: false,
      showerrorreepay: false,
      statusstep: '',
      job: false,
      shorturl: '',
      showMobile: '',
      isused: '',
      mobilepaylink: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      datamethod: '',
      showerror: ''
    };
  },
  created: function created() {
    localStorage.removeItem('yourfulllink');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    localStorage.setItem('yourfulllink', this.fullurl);
    this.originalid = localStorage.getItem('yourid');
    this.pid = pathArray[pathArray.length - 1];
    if (this.pid !== null) {
      this.decode(this.pid);
    }
    setTimeout(function () {
      document.getElementById('partnerloginapp').style.border = 0;
    }, 100);
  },

  mounted: {},
  methods: {
    checkboxselect: function checkboxselect(text) {
      var _this = this;

      if (text === 'leve') {
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('leveran').classList.remove('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.add('hide');
        this.leverancheckbox = '1';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '0';
      } else if (text === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = true;
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.remove('hide');
        this.leverancheckbox = '0';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '1';
      } else {
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = true;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('mobilepay').classList.add('hide');
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.remove('hide');
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
        }, 100);
        this.reepaycheckbox = '1';
        this.leverancheckbox = '0';
        this.mobilepaycheckbox = '0';
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#409EFF!important';
      }
    },
    changecolor: function changecolor() {
      var colorchange = document.querySelector('.second-secondary');
      colorchange.style.color = '#409EFF!important';
      if (this.consentreepay === 'not_accepted') {
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#606266';
      } else {
        var colorchange3 = document.querySelector('.second-secondary2');
        colorchange3.style.color = '#409EFF!important';
      }
    },
    centericon: function centericon() {
      setTimeout(function () {
        var icon = document.getElementById('subicons');
        var iconholder = document.getElementById('subitemitem1');
        var iconmarginleft = parseInt(parseInt(iconholder.clientWidth / 2) - parseInt(117 / 2));
        icon.style.marginLeft = iconmarginleft + 'px';
      }, 50);
    },
    nextstep: function nextstep() {
      if (this.showsessionnewcreditpro === '') {
        this.showsessionnewcredit();
      }
      this.step = this.step + 1;
      if (this.step === 2) {
        this.showconfirmcvr();
      } else if (this.step === 3) {
        this.closeconfirmcvr();
        this.showpayment();
      }
    },
    backstep: function backstep() {
      if (this.step === 2) {
        this.closeconfirmcvr();
        this.statusstep = 'signup_not_active_step1';
        this.updateleadintegration();
        this.addnotifocationbar();
      } else if (this.step === 3) {
        this.closepayment();
        this.showconfirmcvr();
      }
      this.step = this.step - 1;
    },
    showpopupsuccess: function showpopupsuccess() {
      this.$refs['sendingsuccess'].show();
    },
    closepopupsucces: function closepopupsucces() {
      this.$refs['sendingsuccess'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    showpayment: function showpayment() {
      this.$refs['payments'].show();
    },
    showconfirmcvr: function showconfirmcvr() {
      this.$refs['confirmcvr'].show();
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopupcontract: function showpopupcontract() {
      this.$refs['popupcontract'].show();
    },
    showpopuplink: function showpopuplink() {
      this.$refs['popuplink'].show();
    },
    closepayment: function closepayment() {
      this.$refs['payment'].hide();
    },
    closeconfirmcvr: function closeconfirmcvr() {
      this.$refs['confirmcvr'].hide();
    },
    closepopuplink: function closepopuplink() {
      this.$refs['popuplink'].hide();
    },
    closepopuplinklever: function closepopuplinklever() {
      this.$refs['popuplinklever'].hide();
    },
    showpopuplinklever: function showpopuplinklever() {
      this.$refs['popuplinklever'].show();
    },
    closepopupcontract: function closepopupcontract() {
      this.$refs['popupcontract'].hide();
    },
    processingperiod: function processingperiod() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var datenow = new Date();
      var processingstart = new Date(a);
      var processingend = new Date(a);
      processingend.setDate(processingstart.getDate() + 4);
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    service_levendor: function service_levendor() {
      var _this2 = this;

      if (this.consentleveran === 'not_accepted' || this.consentleveran === '') {
        this.showerrorleveran = true;
        return;
      }

      var error = 0;
      this.$refs['step4formcontact2'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      this.loadingnewpayment = true;
      var dataPartner = {
        operation: 'service_levendor',
        salesPerson: this.salesPerson,
        regnr: this.form.regnr,
        bankkonto: this.form.bankkonto,
        levid: this.levid,
        cvr: this.form2.cvr,
        bank: 'imentor'
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.modalShowDato = false;
          _this2.paymenthod = 'leveran';
          _this2.urlactivated = 1;
          _this2.paymenthodupdate = 1;
          _this2.updateprofilepayment();
        } else {
          _this2.loadingnewpayment = false;
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this3 = this;

      this.$http.post(this.$bitrixapi + 'reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var data = res.data;
          _this3.showsessionnewcreditpro = data.id;
        } else {
          console.log('Error in showing session');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    goto: function goto(text) {
      var div = $('#moreid');
      div.animate({
        scrollTop: div[0].scrollHeight
      }, 1000);
    },
    validatecvr: function validatecvr() {
      var _this4 = this;

      this.loading = true;
      var data = {
        name: this.form2.companyname,
        phone: this.form2.telefonnummer,
        email: this.form2.email,
        cvr: this.form2.cvr,
        projectId: this.projectid
      };
      this.$http.post(this.$bitrixapi + 'bitrix/inviteCraftsmanToBitrix/', data, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          var res = response.body.data;
          _this4.closeconfirmcvr();
          _this4.loading = false;

          _this4.shorturl = res.url;
          _this4.showpopupsuccess();
          setTimeout(function () {
            _this4.$router.push(_this4.shorturl);
          }, 3000);
        } else {
          _this4.loading = false;
          _this4.showerror = response.body.message;
        }
      }).catch(function (err) {
        _this4.showerror = err.body.message;
        _this4.loading = false;
        console.log(err);
      });
    },
    updateinfo: function updateinfo() {
      var error = 0;
      this.$refs['step4formcontact'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.loading = true;
      this.validatecvr();
    },
    decode: function decode() {
      var _this5 = this;

      this.loading = true;
      this.loadingjobs = true;
      this.$http.get(this.$bitrixapi + 'integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data === '') {
            _this5.showpopuperror();
          }
          _this5.projectid = res.data;

          if (_this5.projectid !== '') {
            _this5.showconfirmcvr(_this5.projectid);
          }

          _this5.loading = false;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"invitepartner"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center sm-hide ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),(_vm.step !== 4)?_c('div',{staticClass:"lg-hide md-hide col-12 buttonsticky pointer white-background",attrs:{"id":"button"}},[(_vm.step === 1)?_c('button',{staticClass:"action-button p2 not-rounded m0 col-12 ",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"action-button p2 not-rounded m0 mb1  col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateinfo()}}},[_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(3)])]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(4)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"marketplace2"}},[_c('div',{staticClass:"sidebar"},[_c('div'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold capitalletter",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(5)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(6),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._m(7),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/sent"},on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(8)])])]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(9),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(11)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(12),_vm._v(" "),_vm._m(13)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(14),_vm._v(" "),_vm._m(15)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(16),_vm._v(" "),_vm._m(17)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(18),_vm._v(" "),_vm._m(19)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular hide",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(20)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold nav-dropdown-toggle",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(21)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(22)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(23),_vm._v(" "),_vm._m(24)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(25)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(26)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(27)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular pt3",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(28)])])]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('main',{staticClass:"main p2"},[_c('div',{staticClass:"col-12  p0 "},[_vm._m(29),_vm._v(" "),_c('p',{staticClass:"lg-col-10 md-col-11 h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap items-center"},[(_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                Se opgaver\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                Se ledige arbejdskraft\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"darkblue-background p2 px3 h5 not-rounded flex justify-center white items-center line-height-1 my2 mr1",staticStyle:{"width":"435px","height":"77px","border":"0px solid"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',[_vm._v("\n                Antal reservationer: 0 ud af 3\n              ")])]):_vm._e()])]),_vm._v(" "),(_vm.loadingjobs)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(30)]):_c('div',[(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-start"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer!important","width":"300px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2 flex items-center",staticStyle:{"height":"51px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingzip)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingcity)+"\n                  ")])]),_vm._v(" "),(item.gratis1 === '1')?[_vm._m(31,true)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center",staticStyle:{"height":"41px"}},[_c('span',[_vm._v(_vm._s(item.producttitle))])]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1",staticStyle:{"height":"60px"}},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.comment_to_partner,80, '...'))+"\n                  ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()])],2)])])}),0)]):_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.key,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block flex items-center",staticStyle:{"height":"41px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingzip)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingcity)+"\n                    ")])])]),_vm._v(" "),(item.gratis1 === '1')?_c('div',{staticClass:"absolute bottom-0 right-0 left-0 hide"},[_vm._m(32,true)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.producttitle))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h5 darkblue regular line-height-2 mb1"},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.comment_to_partner,50, '...'))+"\n                    ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud !== 1)?_c('span',[_vm._v(_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(item.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()],2)])])}),0)])])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"confirmcvr",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmcvr","no-close-on-backdrop":true}},[(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',{staticClass:"col-12 p0 mmb5"},[_c('div',{staticClass:"flex justify-around lg-col-4 md-col-4 sm-col-12 mx-auto items-center mt1"},[_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"49.036","height":"56.623","viewBox":"0 0 49.036 56.623"}},[_c('path',{attrs:{"id":"Indtast_Info","data-name":"Indtast Info","d":"M30.637,53.466a10.929,10.929,0,0,1-1.054-1.221H6.424A6.431,6.431,0,0,1,0,45.821V6.424A6.431,6.431,0,0,1,6.424,0H26.141a1.5,1.5,0,0,1,.969.372l.007,0,.014.013.052.05L41.957,15.213c.023.023.046.048.068.073a1.505,1.505,0,0,1,.371.969V35.887a10.781,10.781,0,1,1-11.759,17.58Zm-.157-7.621a7.778,7.778,0,1,0,7.779-7.779A7.787,7.787,0,0,0,30.479,45.845ZM3,6.424v39.4a3.428,3.428,0,0,0,3.424,3.424h21.6A10.785,10.785,0,0,1,38.258,35.067a10.964,10.964,0,0,1,1.139.059V17.773H26.123a1.5,1.5,0,0,1-1.5-1.5V3H6.424A3.428,3.428,0,0,0,3,6.424Zm24.623,8.349h9.652L27.623,5.121Zm9.135,34.782V47.345H34.547a1.5,1.5,0,1,1,0-3h2.211V42.133a1.5,1.5,0,1,1,3,0v2.211h2.211a1.5,1.5,0,1,1,0,3H39.757v2.211a1.5,1.5,0,1,1-3,0ZM11.5,39.882a1.5,1.5,0,1,1,0-3h15a1.5,1.5,0,1,1,0,3Zm0-10a1.5,1.5,0,1,1,0-3h20a1.5,1.5,0,1,1,0,3Zm-.151-9.646a1.5,1.5,0,1,1,0-3h4.925a1.5,1.5,0,0,1,0,3Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Indtast info")])]),_vm._v(" "),_c('span',{},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.382","height":"16.409","viewBox":"0 0 9.382 16.409"}},[_c('path',{attrs:{"id":"Icon_ionic-ios-arrow-forward","data-name":"Icon ionic-ios-arrow-forward","d":"M17.8,14.4l-6.209-6.2a1.168,1.168,0,0,1,0-1.656,1.182,1.182,0,0,1,1.661,0l7.035,7.03a1.17,1.17,0,0,1,.034,1.617l-7.064,7.079A1.173,1.173,0,1,1,11.6,20.607Z","transform":"translate(-11.246 -6.196)","fill":"#23a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"56.623","height":"56.623","viewBox":"0 0 56.623 56.623"}},[_c('path',{attrs:{"id":"Activer","d":"M0,28.312A28.311,28.311,0,1,1,28.312,56.623,28.312,28.312,0,0,1,0,28.312ZM18.452,51.653a25.3,25.3,0,0,0,26.31-4.078v-4.45a7.6,7.6,0,0,0-7.59-7.59H19.014a7.59,7.59,0,0,0-7.59,7.59v4.067A25.2,25.2,0,0,0,18.452,51.653Zm18.72-19.1a10.583,10.583,0,0,1,10.57,10.57v1.439A25.333,25.333,0,1,0,4.97,18.452,25.31,25.31,0,0,0,8.443,44.03v-.9a10.571,10.571,0,0,1,10.57-10.57ZM17.523,15.887A10.57,10.57,0,1,1,28.093,26.457,10.582,10.582,0,0,1,17.523,15.887Zm2.98,0a7.59,7.59,0,1,0,7.59-7.59A7.6,7.6,0,0,0,20.5,15.887Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Aktiver")])])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 mx-auto flex flex-column p1 mx3 mt1 mb2 darkblue"},[_c('div',{staticClass:"center mb1 mt2"},[_c('p',{staticClass:"h4  semi-bold"},[_vm._v("Aktiver din profil")])]),_vm._v(" "),_c('div',{staticClass:"lg-col-10 md-col-10 sm-col-12 mx-auto center mt1 mb2"},[_c('p',{staticClass:"h6 line-height-golden"},[_vm._v("Opret en gratis konto og kom i gang med projektet.")])]),_vm._v(" "),_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.form2,"rules":_vm.rulesform2,"label-position":"top"}},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"m0 p0  mp0 lg-col-12 md-col-12 sm-col-12"},[(_vm.showerror)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":_vm.showerror,"type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e(),_vm._v(" "),(_vm.showcvr)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":_vm.cvrerror,"type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"m0 p0  mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"CVR","prop":"cvr"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","placeholder":"12345678"},on:{"keyup":function($event){return _vm.validatecvrinput()}},model:{value:(_vm.form2.cvr),callback:function ($$v) {_vm.$set(_vm.form2, "cvr", _vm._n($$v))},expression:"form2.cvr"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"E-mail"},model:{value:(_vm.form2.email),callback:function ($$v) {_vm.$set(_vm.form2, "email", $$v)},expression:"form2.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"Telefonnummer","prop":"telefonnummer"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","id":"phone","placeholder":"Mobilnr.(8 cifre)"},model:{value:(_vm.form2.telefonnummer),callback:function ($$v) {_vm.$set(_vm.form2, "telefonnummer", _vm._n($$v))},expression:"form2.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Firma Navn","prop":"companyname"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Hans Hansen"},model:{value:(_vm.form2.companyname),callback:function ($$v) {_vm.$set(_vm.form2, "companyname", $$v)},expression:"form2.companyname"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"center p0 col-12"},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover  p2 px3 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateinfo()}}},[_vm._v("Aktiver "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"payments",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"payments","no-close-on-backdrop":true},on:{"show":function($event){return _vm.limitleverantext()}}},[(_vm.loadingnewpayment)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',[_c('div',{staticClass:"p2 flex justify-center mmt4"},[_c('div',{staticClass:"subitems mt4 relative flex flex-column item-between height-full py4 px1 relative",staticStyle:{"width":"390px","box-shadow":"0px 0px 20px #19A3C04D"},attrs:{"id":"subitemitem1"}},[_c('div',{staticClass:" absolute top-0 left-0 bottom-0 right-0 mb1 primarycolor-background relative ",attrs:{"id":"subicons"}},[_c('svg',{staticClass:"absolute",staticStyle:{"top":"20%","left":"25%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","viewBox":"0 0 128.416 110.912"}},[_c('path',{attrs:{"id":"Freemium","d":"M55.035,110.912a1.529,1.529,0,1,1,0-3.057H61.1v-1.529H48.92a1.529,1.529,0,0,1,0-3.058H79.5a1.529,1.529,0,0,1,0,3.058H67.311v1.529h6.834a1.529,1.529,0,0,1,0,3.057Zm28.928-4.586a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm-45.862,0a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm77.106-6.115h-102a1.542,1.542,0,1,1,0-3.058h47.2a18.384,18.384,0,0,1-.816-6.211,3.058,3.058,0,0,1,3.056-2.961h3.041a3.079,3.079,0,0,1,3.057,3,16.872,16.872,0,0,1-.929,6.169h47.395a1.542,1.542,0,1,1,0,3.058Zm-51.54-3.382h0a1.527,1.527,0,0,0,.5.324c.685-.272,1.625-2.633,1.52-6.089v-.025H62.645C62.56,93.719,63.1,96.289,63.668,96.829Zm61.689,1.853a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,125.357,98.683Zm-5.351,1.529a1.529,1.529,0,0,1,0-3.058H122.3a1.529,1.529,0,0,1,0,3.058Zm-113.892,0a1.529,1.529,0,0,1,0-3.058H8.408a1.529,1.529,0,0,1,0,3.058ZM0,98.683a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,0,98.683ZM68.532,84.924H59.879a4.561,4.561,0,0,1-4.554-3.969c-.049-.4-.1-.867-.165-1.381H51.284a3.08,3.08,0,0,1-3.122-2.8L45.134,63.087a1.529,1.529,0,0,1,2.23-1.67l6.291,3.461c-.713-8.326-1.23-17.6-.68-23.241.257-2.627,1.812-9.432,2.036-10.405a9.4,9.4,0,0,1,18.395-.014c.224.964,1.775,7.695,2.031,10.294.558,5.665.037,15-.68,23.368l6.294-3.463a1.528,1.528,0,0,1,2.23,1.67L80.253,76.77a3.08,3.08,0,0,1-3.122,2.8H73.252c-.061.514-.117.978-.166,1.381a4.56,4.56,0,0,1-4.522,3.97ZM56.017,41.935c-.987,10.109,1.656,33,2.343,38.65a1.5,1.5,0,0,0,1.519,1.281h8.653a1.5,1.5,0,0,0,1.518-1.281c.689-5.665,3.341-28.635,2.343-38.772-.154-1.569-.882-5.037-1.41-7.432a17.191,17.191,0,0,1-6.776,1.241,17.2,17.2,0,0,1-6.769-1.238C56.91,36.807,56.174,40.341,56.017,41.935ZM74.426,68.553c-.281,2.965-.57,5.7-.823,7.963h3.528A.185.185,0,0,0,77.2,76.5a1.5,1.5,0,0,1,.035-.259l2.327-10.518ZM51.177,76.242a1.575,1.575,0,0,1,.034.26.188.188,0,0,0,.073.013h3.524c-.253-2.267-.542-5-.823-7.964L48.85,65.725ZM58.145,31.3c.69.5,2.759,1.264,6.063,1.264s5.378-.77,6.066-1.266a6.313,6.313,0,0,0-6.064-4.467h-.027A6.314,6.314,0,0,0,58.145,31.3Zm4.493,45.216V63.521a1.528,1.528,0,0,1,1.528-1.529h0a1.529,1.529,0,0,1,1.529,1.529l0,12.994a1.529,1.529,0,1,1-3.058,0ZM58.092,51.673V46.322a6.115,6.115,0,0,1,12.23,0v5.351a6.115,6.115,0,1,1-12.23,0Zm3.058-5.351v5.351a3.058,3.058,0,1,0,6.115,0V46.322a3.058,3.058,0,0,0-6.115,0Zm58.325,4.2A1.529,1.529,0,1,1,121,52.056,1.529,1.529,0,0,1,119.476,50.527Zm.764,0a.765.765,0,1,0,.764-.765A.765.765,0,0,0,120.24,50.527ZM6.516,50.86,7.652,49.4v-.023l-1.77.226v-.813l1.759.227v-.023L6.516,47.536l.73-.419.742,1.663h.024l.73-1.674.718.407L8.323,49.007v.023l1.805-.239V49.6l-1.805-.215v.024l1.148,1.435-.754.431L8,49.6H7.975L7.2,51.291Zm82.722-6.327a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,89.238,44.533Zm.764,0a.764.764,0,1,0,.764-.765A.764.764,0,0,0,90,44.533ZM34.4,34.381a2.293,2.293,0,1,1,2.293,2.294A2.293,2.293,0,0,1,34.4,34.381Zm1.147,0a1.146,1.146,0,1,0,1.146-1.146A1.146,1.146,0,0,0,35.544,34.381Zm79.625-.422,1.114-1.431V32.5l-1.736.222v-.8l1.725.224v-.024l-1.1-1.432.716-.41.727,1.63h.023l.715-1.642.7.4L116.94,32.14v.023l1.771-.235v.8l-1.771-.211v.023l1.125,1.408-.739.422-.7-1.643H116.6l-.763,1.655ZM85.61,19.187a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,85.61,19.187Zm.765,0a.764.764,0,1,0,.764-.764A.764.764,0,0,0,86.375,19.187Zm-76.2-1.529A1.529,1.529,0,1,1,11.7,19.187,1.529,1.529,0,0,1,10.17,17.659Zm.764,0a.764.764,0,1,0,.764-.764A.766.766,0,0,0,10.934,17.659ZM111.49,9.253l.962-1.234V8l-1.5.192V7.5l1.487.193V7.675L111.49,6.44l.618-.354.627,1.406h.021l.617-1.416.607.344-.961,1.264v.021l1.527-.2v.688l-1.527-.182v.02l.971,1.215-.638.365-.607-1.417h-.02l-.658,1.427ZM59.07,2.162l.654-.84V1.308l-1.02.131V.971l1.013.131V1.088L59.07.248l.42-.241.427.957h.014L60.351,0l.413.234-.654.861v.014L61.15.971v.468l-1.039-.124v.014l.661.826-.434.248-.413-.964h-.013l-.449.971Z","fill":"#fff"}})])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"col-12 center bold h6 my2"},[_vm._v("PRØVEPAKKE")]),_vm._v(" "),_c('p',{staticClass:"col-12 center bold h2 my2"},[_c('span',{staticClass:"primarycolor"},[_vm._v("GRATIS*")])])]),_vm._v(" "),_c('div',{staticClass:"col-10 mx-auto"},[_c('ul',{staticClass:"list-sub-text list-image-check-mintgreen pb1 pr2 mb3"},[_c('li',{staticClass:" light line-height-4 mt0 pb1 ml1"},[_vm._v("Byd på 3 opgaver")]),_vm._v(" "),_c('li',{staticClass:" light line-height-4 mt0 pb1 mb2 ml1"},[_vm._v("Gratis adgang i 14 dage")]),_vm._v(" "),_c('div',{staticClass:"center flex flex-column items-center justify-center col-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.gratisbutton),expression:"gratisbutton"}],staticClass:"mb2",staticStyle:{"width":"30px","height":"30px"},attrs:{"type":"radio","id":"gratisbutton","value":"1"},domProps:{"checked":_vm._q(_vm.gratisbutton,"1")},on:{"change":function($event){_vm.gratisbutton="1"}}}),_vm._v(" "),_c('p',{staticClass:"h5 flex items-center m0"},[_vm._v("Vælg")])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"lg-col-12 md-col-12 sm-col-12 mx-auto mx3"},[_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background"},[_c('p',{staticClass:"h4 semi-bold my1 col-12 flex justify-start py2 px0"},[_vm._v("Kurv")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold my1 col-12 flex justify-start p0"},[_vm._v("Plan valgt: GRATIS")]),_vm._v(" "),_c('p',{staticClass:" h3 semi-bold darkblue center my2 col-12 flex justify-start p0"},[_vm._v("At betale nu: "),_c('span',{staticClass:"primarycolor pl2"},[_vm._v(" 0.- kr")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start",staticStyle:{"max-width":"920px"}},[_c('p',{staticClass:"semi-bold mt1 mb0",staticStyle:{"font-size":"12px"}},[_vm._v("Pris per måned:*")]),_vm._v(" "),_c('p',{staticClass:"pb1 h6 line-height-golden flex justify-start italic p0",staticStyle:{"font-size":"12px"},attrs:{"id":"leverantext"}},[_vm._v(_vm._s(_vm.leverantext))]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showmore"},on:{"click":function($event){return _vm.limitleverantext(1)}}},[_c('span',[_vm._v("Læs mere")])]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showless"},on:{"click":function($event){return _vm.limitleverantext(2)}}},[_c('span',[_vm._v("Vis mindre")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background mt2"},[_c('p',{staticClass:"semi-bold h4 dawkblue my2 col-12 flex justify-start py2 px0"},[_vm._v("Vælg betalingsform")]),_vm._v(" "),[_c('div',{staticClass:" flex col-12 m0 p0 flex-column"},[_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center p0",on:{"click":function($event){return _vm.checkboxselect('leve')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.leverancheckbox),expression:"leverancheckbox"}],attrs:{"type":"radio","id":"leverandcheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.leverancheckbox,"1")},on:{"change":function($event){_vm.leverancheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 semi-bold mx2 flex items-center"},[_vm._v("Leverandørservice (0 kr.)")])]),_vm._v(" "),_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0",on:{"click":function($event){return _vm.checkboxselect('reep')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.reepaycheckbox),expression:"reepaycheckbox"}],attrs:{"type":"radio","id":"reepaycheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.reepaycheckbox,"1")},on:{"change":function($event){_vm.reepaycheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"mx2 h6 semi-bold flex items-center mb0"},[_vm._v("Kreditkort (0 kr.)")])]),_vm._v(" "),_c('div',{staticClass:" col-lg-12 col-md-12 col-sm-12 mx-auto py1 darkblue not-rounded flex justify-start items-center  p0",on:{"click":function($event){return _vm.checkboxselect('mobpay')}}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.mobilepaycheckbox),expression:"mobilepaycheckbox"}],attrs:{"type":"radio","id":"mobilepaycheckbox","value":"1"},domProps:{"checked":_vm._q(_vm.mobilepaycheckbox,"1")},on:{"change":function($event){_vm.mobilepaycheckbox="1"}}}),_vm._v(" "),_c('span',{staticClass:"mx2 h6 semi-bold flex items-center mb0"},[_vm._v("MobilePay (0 kr.)")])])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 p0 mx-auto mt2",attrs:{"id":"leveran"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"col-12 p0"},[(_vm.levandorupdate !== '')?_c('b-alert',{staticClass:"my2",attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                            ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap mt2 p0"},[_c('el-form',{ref:"step4formcontact2",staticClass:"tui-f lg-col-12 sm-col-12 sm-col-12 mx-auto",attrs:{"model":_vm.form,"rules":_vm.rulesform,"label-position":"top"}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Reg. nr.","prop":"regnr"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"maxlength":"4","placeholder":"4 cifre"},model:{value:(_vm.form.regnr),callback:function ($$v) {_vm.$set(_vm.form, "regnr", $$v)},expression:"form.regnr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Konto nr.","prop":"bankkonto"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"minimum":"6","maxlength":"10","placeholder":"6-10 cifre"},model:{value:(_vm.form.bankkonto),callback:function ($$v) {_vm.$set(_vm.form, "bankkonto", $$v)},expression:"form.bankkonto"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none center el-form-item__plain el-form-item__checkbox",attrs:{"id":"accepterms"}},[_c('el-checkbox',{staticClass:"el-checkbox flex justify-start md-col-10 lg-col-10 sm-col-12 pl1 mp0 ml-auto",attrs:{"label":"","id":"consentleverancheckbox"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentleveran),callback:function ($$v) {_vm.consentleveran=$$v},expression:"consentleveran"}},[_c('span',{staticClass:"second-secondary "},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplinklever()}}},[_vm._v(" LeverandørService")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement.")])])]),_vm._v(" "),(_vm.showerrorleveranerror)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Indtast venligst nummer","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0"},[_c('button',{staticClass:"action-button not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"773px"},attrs:{"type":"button","id":"leverrsub"},on:{"click":_vm.service_levendor}},[_c('span',{staticClass:"semi-bold h5 m0"},[_vm._v("Start"),_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2",attrs:{"id":"moreid"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto hide",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"hide col-12 flex justify-center",attrs:{"id":"mobilepay"}},[(_vm.disablemobilepaybutton)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):_c('a',{staticClass:"action-button no-underline not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"700px"},attrs:{"type":"button","href":_vm.mobilepaylink}},[_c('span',{staticClass:"white semi-bold h5 m0"},[_vm._v("Start")])])])]],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","type":"button","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","disabled":"true"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("Tak for din tilmelding! ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Vent venligst, mens vi arbejder på at aktivere din konto.. ")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"popupcontract",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popupcontract"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopupcontract()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px","zoom":".5"},attrs:{"src":'https://www.kundematch.dk/s/otheraftale_new.php?bitrixid=' + this.levid + '&mode=ssl',"frameborder":"0","zoom":"0.9","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplink",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplink"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplink()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":"https://reepay.com/terms-of-service/","frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplinklever",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplinklever"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background  "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplinklever()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","height":"95%","overflow":"auto"}},[_c('vue-pdf-app',{attrs:{"pdf":"/static/pdf/Generelle_regler_for-kreditorer_i_LeverandørService_v_1.0_14.09.2019.pdf"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit link er allerede brugt.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Du har en e-mail med login og password, så du kan logge ind nu.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Aktiver din prøveversion nu "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Næste "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-house ml1 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Forside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropBeskeder"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Beskeder")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/inbox"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Inbox\n                                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sendt\n                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropAnbefalinger"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Anbefalinger")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"indhent-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Indhent anbefalinger\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"laes-og-besvar-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Læs og besvar\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"auto-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sæt anbefalinger på Auto-pilot\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"widgets"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Widgets\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-files mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Mine kunder\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropDine projekter"}},[_c('i',{staticClass:"el-icon-picture-outline mr2 darkblue"}),_vm._v("\n                            Dine projekter")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"opret-projekt-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opret projekt\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"status-haandvaerker-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Mine projekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/approved-projects"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Åbne kundeprojekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/project-dashboard"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Vundne kundeprojekter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-money mr2 darkblue"}),_vm._v(" \n                        Markedsplads")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold hide",attrs:{"id":"udbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Udbud ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropMester-til-Mester"}},[_c('i',{staticClass:"el-icon-share mr2 darkblue"}),_vm._v("\n                            Mester-til-Mester")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-arbejdskraft"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Arbejdskraft\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-opgaver"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button","href":"#/mester-opgaver"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opgaver\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-document mr2 darkblue"}),_vm._v("\n                            Opret tilbud")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/tilbud-historie"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Tilbudshistorie\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/standardTilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Standard Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/hurtigt-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Hurtigt Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/upload-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Upload Tilbud\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Inviter en kollega\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-monitor mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Gratis hjemmeside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Medlemsfordele\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-shopping-cart-2 mr2 darkblue"}),_vm._v("\n                            Webshop")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"webshop/products"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Alle produkter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Digital pakke\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-setting mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Indstillinger\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-question mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Ofte stillede spørgsmål\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-back mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Log ud\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Markedsplads\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 mintgreen semi-bold block"},[_vm._v("\n                      Gratis møde\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-background mintgreen gibson line-height-1 h6 mb0 p1 pb2"},[_c('span',{staticClass:"block hide"},[_vm._v("Gratis møde  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_viewer_vue__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1597027b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_viewer_vue__ = __webpack_require__(1100);
function injectStyle (ssrContext) {
  __webpack_require__(1096)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_viewer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1597027b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_viewer_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1096 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_signature_pad__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_full_loading__);











var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-main',
  components: {
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_8_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler,
    en: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["en"],
    da: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["da"],
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */],
    SignaturePad: __WEBPACK_IMPORTED_MODULE_6_signature_pad__["a" /* default */]
  },
  data: function data() {
    return {
      contractID: '',
      contactId: '',
      contact: '',
      confirmTerms: false,
      contractStatus: '',
      ConfirmVisible: false,
      haaId: '',
      serviceUrl: '',
      contractInfo: '',
      selectedDocumentVersion: '',
      show: false,
      overlay: 1,
      label: 'Loading...',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      documentPath: '',
      homeownerID: 0,
      salesPersonbitrix: '',
      loading: false,
      showMobile: false,
      info: [],
      pdf: [],
      page: 1,
      historypage: '',
      comments: [],
      textarea: [],
      activeName: 'Comment',
      documentId: '',
      loaded: 1,
      activepage: 0,
      filteredcomments: [],
      commentmanagementloading: true,
      stepsarr: [],
      viewer: '',
      anotations: [],
      activedocumentId: '',
      partnerName: '',
      composeFormVisible: false,
      composeLoading: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      disablecomment: false,
      webview: 'false',
      haspayproff: false,
      payproffform: false,
      confirmstatus: '',
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      },
      activeNames: [],
      payprofformfules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fodelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'number',
          min: 1000000000,
          max: 9999999999,
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      countryData: {
        'BD': 'Bangladesh',
        'BE': 'Belgium',
        'BF': 'Burkina Faso',
        'BG': 'Bulgaria',
        'BA': 'Bosnia and Herzegovina',
        'BB': 'Barbados',
        'WF': 'Wallis and Futuna',
        'BL': 'Saint Barthelemy',
        'BM': 'Bermuda',
        'BN': 'Brunei',
        'BO': 'Bolivia',
        'BH': 'Bahrain',
        'BI': 'Burundi',
        'BJ': 'Benin',
        'BT': 'Bhutan',
        'JM': 'Jamaica',
        'BV': 'Bouvet Island',
        'BW': 'Botswana',
        'WS': 'Samoa',
        'BQ': 'Bonaire, Saint Eustatius and Saba ',
        'BR': 'Brazil',
        'BS': 'Bahamas',
        'JE': 'Jersey',
        'BY': 'Belarus',
        'BZ': 'Belize',
        'RU': 'Russia',
        'RW': 'Rwanda',
        'RS': 'Serbia',
        'TL': 'East Timor',
        'RE': 'Reunion',
        'TM': 'Turkmenistan',
        'TJ': 'Tajikistan',
        'RO': 'Romania',
        'TK': 'Tokelau',
        'GW': 'Guinea-Bissau',
        'GU': 'Guam',
        'GT': 'Guatemala',
        'GS': 'South Georgia and the South Sandwich Islands',
        'GR': 'Greece',
        'GQ': 'Equatorial Guinea',
        'GP': 'Guadeloupe',
        'JP': 'Japan',
        'GY': 'Guyana',
        'GG': 'Guernsey',
        'GF': 'French Guiana',
        'GE': 'Georgia',
        'GD': 'Grenada',
        'GB': 'United Kingdom',
        'GA': 'Gabon',
        'SV': 'El Salvador',
        'GN': 'Guinea',
        'GM': 'Gambia',
        'GL': 'Greenland',
        'GI': 'Gibraltar',
        'GH': 'Ghana',
        'OM': 'Oman',
        'TN': 'Tunisia',
        'JO': 'Jordan',
        'HR': 'Croatia',
        'HT': 'Haiti',
        'HU': 'Hungary',
        'HK': 'Hong Kong',
        'HN': 'Honduras',
        'HM': 'Heard Island and McDonald Islands',
        'VE': 'Venezuela',
        'PR': 'Puerto Rico',
        'PS': 'Palestinian Territory',
        'PW': 'Palau',
        'PT': 'Portugal',
        'SJ': 'Svalbard and Jan Mayen',
        'PY': 'Paraguay',
        'IQ': 'Iraq',
        'PA': 'Panama',
        'PF': 'French Polynesia',
        'PG': 'Papua New Guinea',
        'PE': 'Peru',
        'PK': 'Pakistan',
        'PH': 'Philippines',
        'PN': 'Pitcairn',
        'PL': 'Poland',
        'PM': 'Saint Pierre and Miquelon',
        'ZM': 'Zambia',
        'EH': 'Western Sahara',
        'EE': 'Estonia',
        'EG': 'Egypt',
        'ZA': 'South Africa',
        'EC': 'Ecuador',
        'IT': 'Italy',
        'VN': 'Vietnam',
        'SB': 'Solomon Islands',
        'ET': 'Ethiopia',
        'SO': 'Somalia',
        'ZW': 'Zimbabwe',
        'SA': 'Saudi Arabia',
        'ES': 'Spain',
        'ER': 'Eritrea',
        'ME': 'Montenegro',
        'MD': 'Moldova',
        'MG': 'Madagascar',
        'MF': 'Saint Martin',
        'MA': 'Morocco',
        'MC': 'Monaco',
        'UZ': 'Uzbekistan',
        'MM': 'Myanmar',
        'ML': 'Mali',
        'MO': 'Macao',
        'MN': 'Mongolia',
        'MH': 'Marshall Islands',
        'MK': 'Macedonia',
        'MU': 'Mauritius',
        'MT': 'Malta',
        'MW': 'Malawi',
        'MV': 'Maldives',
        'MQ': 'Martinique',
        'MP': 'Northern Mariana Islands',
        'MS': 'Montserrat',
        'MR': 'Mauritania',
        'IM': 'Isle of Man',
        'UG': 'Uganda',
        'TZ': 'Tanzania',
        'MY': 'Malaysia',
        'MX': 'Mexico',
        'IL': 'Israel',
        'FR': 'France',
        'IO': 'British Indian Ocean Territory',
        'SH': 'Saint Helena',
        'FI': 'Finland',
        'FJ': 'Fiji',
        'FK': 'Falkland Islands',
        'FM': 'Micronesia',
        'FO': 'Faroe Islands',
        'NI': 'Nicaragua',
        'NL': 'Netherlands',
        'NO': 'Norway',
        'NA': 'Namibia',
        'VU': 'Vanuatu',
        'NC': 'New Caledonia',
        'NE': 'Niger',
        'NF': 'Norfolk Island',
        'NG': 'Nigeria',
        'NZ': 'New Zealand',
        'NP': 'Nepal',
        'NR': 'Nauru',
        'NU': 'Niue',
        'CK': 'Cook Islands',
        'XK': 'Kosovo',
        'CI': 'Ivory Coast',
        'CH': 'Switzerland',
        'CO': 'Colombia',
        'CN': 'China',
        'CM': 'Cameroon',
        'CL': 'Chile',
        'CC': 'Cocos Islands',
        'CA': 'Canada',
        'CG': 'Republic of the Congo',
        'CF': 'Central African Republic',
        'CD': 'Democratic Republic of the Congo',
        'CZ': 'Czech Republic',
        'CY': 'Cyprus',
        'CX': 'Christmas Island',
        'CR': 'Costa Rica',
        'CW': 'Curacao',
        'CV': 'Cape Verde',
        'CU': 'Cuba',
        'SZ': 'Swaziland',
        'SY': 'Syria',
        'SX': 'Sint Maarten',
        'KG': 'Kyrgyzstan',
        'KE': 'Kenya',
        'SS': 'South Sudan',
        'SR': 'Suriname',
        'KI': 'Kiribati',
        'KH': 'Cambodia',
        'KN': 'Saint Kitts and Nevis',
        'KM': 'Comoros',
        'ST': 'Sao Tome and Principe',
        'SK': 'Slovakia',
        'KR': 'South Korea',
        'SI': 'Slovenia',
        'KP': 'North Korea',
        'KW': 'Kuwait',
        'SN': 'Senegal',
        'SM': 'San Marino',
        'SL': 'Sierra Leone',
        'SC': 'Seychelles',
        'KZ': 'Kazakhstan',
        'KY': 'Cayman Islands',
        'SG': 'Singapore',
        'SE': 'Sweden',
        'SD': 'Sudan',
        'DO': 'Dominican Republic',
        'DM': 'Dominica',
        'DJ': 'Djibouti',
        'DK': 'Denmark',
        'VG': 'British Virgin Islands',
        'DE': 'Germany',
        'YE': 'Yemen',
        'DZ': 'Algeria',
        'US': 'United States',
        'UY': 'Uruguay',
        'YT': 'Mayotte',
        'UM': 'United States Minor Outlying Islands',
        'LB': 'Lebanon',
        'LC': 'Saint Lucia',
        'LA': 'Laos',
        'TV': 'Tuvalu',
        'TW': 'Taiwan',
        'TT': 'Trinidad and Tobago',
        'TR': 'Turkey',
        'LK': 'Sri Lanka',
        'LI': 'Liechtenstein',
        'LV': 'Latvia',
        'TO': 'Tonga',
        'LT': 'Lithuania',
        'LU': 'Luxembourg',
        'LR': 'Liberia',
        'LS': 'Lesotho',
        'TH': 'Thailand',
        'TF': 'French Southern Territories',
        'TG': 'Togo',
        'TD': 'Chad',
        'TC': 'Turks and Caicos Islands',
        'LY': 'Libya',
        'VA': 'Vatican',
        'VC': 'Saint Vincent and the Grenadines',
        'AE': 'United Arab Emirates',
        'AD': 'Andorra',
        'AG': 'Antigua and Barbuda',
        'AF': 'Afghanistan',
        'AI': 'Anguilla',
        'VI': 'U.S. Virgin Islands',
        'IS': 'Iceland',
        'IR': 'Iran',
        'AM': 'Armenia',
        'AL': 'Albania',
        'AO': 'Angola',
        'AQ': 'Antarctica',
        'AS': 'American Samoa',
        'AR': 'Argentina',
        'AU': 'Australia',
        'AT': 'Austria',
        'AW': 'Aruba',
        'IN': 'India',
        'AX': 'Aland Islands',
        'AZ': 'Azerbaijan',
        'IE': 'Ireland',
        'ID': 'Indonesia',
        'UA': 'Ukraine',
        'QA': 'Qatar',
        'MZ': 'Mozambique'
      },
      languagesData: {
        'af': 'Afrikaans',
        'sq': 'Albanian - shqip',
        'am': 'Amharic - አማርኛ',
        'ar': 'Arabic - العربية',
        'an': 'Aragonese - aragonés',
        'hy': 'Armenian - հայերեն',
        'ast': 'Asturian - asturianu',
        'az': 'Azerbaijani - azərbaycan dili',
        'eu': 'Basque - euskara',
        'be': 'Belarusian - беларуская',
        'bn': 'Bengali - বাংলা',
        'bs': 'Bosnian - bosanski',
        'br': 'Breton - brezhoneg',
        'bg': 'Bulgarian - български',
        'ca': 'Catalan - català',
        'ckb': 'Central Kurdish - کوردی (دەستنوسی عەرەبی)',
        'zh': 'Chinese - 中文',
        'zh-HK': 'Chinese (Hong Kong) - 中文（香港）',
        'zh-CN': 'Chinese (Simplified) - 中文（简体）',
        'zh-TW': 'Chinese (Traditional) - 中文（繁體）',
        'co': 'Corsican',
        'hr': 'Croatian - hrvatski',
        'cs': 'Czech - čeština',
        'da': 'Danish - dansk',
        'nl': 'Dutch - Nederlands',
        'en': 'English',
        'en-AU': 'English (Australia)',
        'en-CA': 'English (Canada)',
        'en-IN': 'English (India)',
        'en-NZ': 'English (New Zealand)',
        'en-ZA': 'English (South Africa)',
        'en-GB': 'English (United Kingdom)',
        'en-US': 'English (United States)',
        'eo': 'Esperanto - esperanto',
        'et': 'Estonian - eesti',
        'fo': 'Faroese - føroyskt',
        'fil': 'Filipino',
        'fi': 'Finnish - suomi',
        'fr': 'French - français',
        'fr-CA': 'French (Canada) - français (Canada)',
        'fr-FR': 'French (France) - français (France)',
        'fr-CH': 'French (Switzerland) - français (Suisse)',
        'gl': 'Galician - galego',
        'ka': 'Georgian - ქართული',
        'de': 'German - Deutsch',
        'de-AT': 'German (Austria) - Deutsch (Österreich)',
        'de-DE': 'German (Germany) - Deutsch (Deutschland)',
        'de-LI': 'German (Liechtenstein) - Deutsch (Liechtenstein)',
        'de-CH': 'German (Switzerland) - Deutsch (Schweiz)',
        'el': 'Greek - Ελληνικά',
        'gn': 'Guarani',
        'gu': 'Gujarati - ગુજરાતી',
        'ha': 'Hausa',
        'haw': 'Hawaiian - ʻŌlelo Hawaiʻi',
        'he': 'Hebrew - עברית',
        'hi': 'Hindi - हिन्दी',
        'hu': 'Hungarian - magyar',
        'is': 'Icelandic - íslenska',
        'id': 'Indonesian - Indonesia',
        'ia': 'Interlingua',
        'ga': 'Irish - Gaeilge',
        'it': 'Italian - italiano',
        'it-IT': 'Italian (Italy) - italiano (Italia)',
        'it-CH': 'Italian (Switzerland) - italiano (Svizzera)',
        'ja': 'Japanese - 日本語',
        'kn': 'Kannada - ಕನ್ನಡ',
        'kk': 'Kazakh - қазақ тілі',
        'km': 'Khmer - ខ្មែរ',
        'ko': 'Korean - 한국어',
        'ku': 'Kurdish - Kurdî',
        'ky': 'Kyrgyz - кыргызча',
        'lo': 'Lao - ລາວ',
        'la': 'Latin',
        'lv': 'Latvian - latviešu',
        'ln': 'Lingala - lingála',
        'lt': 'Lithuanian - lietuvių',
        'mk': 'Macedonian - македонски',
        'ms': 'Malay - Bahasa Melayu',
        'ml': 'Malayalam - മലയാളം',
        'mt': 'Maltese - Malti',
        'mr': 'Marathi - मराठी',
        'mn': 'Mongolian - монгол',
        'ne': 'Nepali - नेपाली',
        'no': 'Norwegian - norsk',
        'nb': 'Norwegian Bokmål - norsk bokmål',
        'nn': 'Norwegian Nynorsk - nynorsk',
        'oc': 'Occitan',
        'or': 'Oriya - ଓଡ଼ିଆ',
        'om': 'Oromo - Oromoo',
        'ps': 'Pashto - پښتو',
        'fa': 'Persian - فارسی',
        'pl': 'Polish - polski',
        'pt': 'Portuguese - português',
        'pt-BR': 'Portuguese (Brazil) - português (Brasil)',
        'pt-PT': 'Portuguese (Portugal) - português (Portugal)',
        'pa': 'Punjabi - ਪੰਜਾਬੀ',
        'qu': 'Quechua',
        'ro': 'Romanian - română',
        'mo': 'Romanian (Moldova) - română (Moldova)',
        'rm': 'Romansh - rumantsch',
        'ru': 'Russian - русский',
        'gd': 'Scottish Gaelic',
        'sr': 'Serbian - српски',
        'sh': 'Serbo-Croatian - Srpskohrvatski',
        'sn': 'Shona - chiShona',
        'sd': 'Sindhi',
        'si': 'Sinhala - සිංහල',
        'sk': 'Slovak - slovenčina',
        'sl': 'Slovenian - slovenščina',
        'so': 'Somali - Soomaali',
        'st': 'Southern Sotho',
        'es': 'Spanish - español',
        'es-AR': 'Spanish (Argentina) - español (Argentina)',
        'es-419': 'Spanish (Latin America) - español (Latinoamérica)',
        'es-MX': 'Spanish (Mexico) - español (México)',
        'es-ES': 'Spanish (Spain) - español (España)',
        'es-US': 'Spanish (United States) - español (Estados Unidos)',
        'su': 'Sundanese',
        'sw': 'Swahili - Kiswahili',
        'sv': 'Swedish - svenska',
        'tg': 'Tajik - тоҷикӣ',
        'ta': 'Tamil - தமிழ்',
        'tt': 'Tatar',
        'te': 'Telugu - తెలుగు',
        'th': 'Thai - ไทย',
        'ti': 'Tigrinya - ትግርኛ',
        'to': 'Tongan - lea fakatonga',
        'tr': 'Turkish - Türkçe',
        'tk': 'Turkmen',
        'tw': 'Twi',
        'uk': 'Ukrainian - українська',
        'ur': 'Urdu - اردو',
        'ug': 'Uyghur',
        'uz': 'Uzbek - o‘zbek',
        'vi': 'Vietnamese - Tiếng Việt',
        'wa': 'Walloon - wa',
        'cy': 'Welsh - Cymraeg',
        'fy': 'Western Frisian',
        'xh': 'Xhosa',
        'yi': 'Yiddish',
        'yo': 'Yoruba - Èdè Yorùbá',
        'zu': 'Zulu - isiZulu'
      },
      confirmPayproff: false,
      partnerprofile: [],
      partnertelephone: '',
      partneremail: '',
      isPep: true,
      termspopup: false,
      projectthreadid: '',
      activeprojectId: '',
      childprojects: [],
      partnerchildprojects: [],
      parentID: '',
      contractType: '',
      offerType: '',
      projectTitle: '',
      submittedIndustries: [],
      industryID: '',
      scale: 120,
      config: {
        toolbar: {
          toolbarViewerLeft: false
        }
      },
      pdfStr: '',
      pdfStrlink: '',
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'https://www.haandvaerker.dk/om/betingelser',
      signaturePad: ''
    };
  },
  created: function created() {
    var _this = this;

    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    var pathArray = window.location.href.split('/');
    this.salesPersonbitrix = pathArray[pathArray.length - 4];
    this.partnerName = pathArray[pathArray.length - 5];
    this.haaId = pathArray[pathArray.length - 3];
    this.project_id = pathArray[pathArray.length - 2];
    this.contractID = pathArray[pathArray.length - 1];
    this.historypage = localStorage.getItem('pdfjs.history');
    this.parentID = this.$route.query.parentID;
    this.contractType = this.$route.query.contracttype;
    this.industryID = this.$route.query.industryID;
    this.submittedIndustries = JSON.parse(this.$route.query.submittedindustry);
    this.projectTitle = this.$route.query.projecttitle;
    this.offerType = this.$route.query.offertype;
    this.childprojects.forEach(function (o) {
      if (o.IS_PARTNER) {
        _this.partnerchildprojects.push(o.ID);
      }
    });
    var x = this;
    setTimeout(function () {
      document.querySelector('footer').classList.add('hide');
      x.webview = x.$route.query.webview;
      if (x.webview === 'true') {
        document.querySelector('header').classList.add('hide');
        document.querySelector('.sidebar').classList.add('hide');
      }
    }, 500);
    this.getPayproffacc();
    this.getsupplierprofile();
  },
  mounted: function mounted() {
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer';
    this.getPayproffacc();
    this.getTermsCondition();
  },

  watch: {},
  methods: {
    commentAdd: function commentAdd(event) {
      console.log(event);
      this.saveComment(event, 1);
    },
    pdfCreated: function pdfCreated(pdf) {
      var _this2 = this;

      var g4string = '';
      setTimeout(function () {
        _this2.viewer = document.getElementById('pdfViewer');
        console.log('this.viewer', _this2.viewer);
        console.log('this.viewermain', _this2.viewer.element.ej2_instances[0]);
        var viewers = _this2.viewer['element'].ej2_instances[0];
        viewers.load(g4string, null);
      }, 1000);
    },
    showcontract: function showcontract() {
      var searchInput = document.querySelectorAll('[data-page-number]');
      var searchinputpage = [];
      var thisthisvarvar = this;
      searchInput.forEach(function (a) {
        if (a.className === 'page') {
          searchinputpage.push(a);
        }
      });
      searchinputpage.forEach(function (a, index) {
        if (a.className === 'page') {
          a.addEventListener('mouseup', function () {
            var text = window.getSelection().toString();
            if (text !== '') {
              thisthisvarvar.addComment(index + 1, text);
            }
          });
        }
      });
    },
    getContract: function getContract() {
      var _this3 = this;

      var contractId = this.$route.query.contractId;
      this.contractID = contractId;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        documentId: this.documentId
      };
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/preview/document.base64', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.contractInfo = res.data;
        if (_this3.contractInfo.file) {
          _this3.documentId = _this3.contractInfo.documentId;
          _this3.contact = _this3.contractInfo.CONTACT_TITLE;
          _this3.contactId = _this3.contractInfo.CONTACT_ID;
          _this3.activeprojectId = _this3.contractInfo.contracts.PROJECT.ID;
          _this3.contractStatus = _this3.contractInfo.contracts.STATUS;
          _this3.confirmstatus = _this3.contractInfo.contracts.DATE_SIGNED_BY_PARTNER;
          if (_this3.contractStatus === 'approved' || _this3.contractStatus === 'signed') {
            _this3.disablecomment = true;
          }

          _this3.pdfStrlink = _this3.contractInfo.url;
        }
        if (_this3.documentId !== '') {
          _this3.selectedDocumentVersion = _this3.contractInfo.documentId.toString();
        }
        _this3.show = false;
        _this3.getmessagesbyProjectID();
      }, function (err) {
        _this3.show = false;
        _this3.formLoading = false;
        _this3.commentIsConfirmed = false;
        var error = err.body.message;
        _this3.$refs.errorMsg.showMsg(error);
      });
    },
    base64ToArrayBuffer: function base64ToArrayBuffer(base64) {
      var binarystring = window.atob(base64);
      var len = binarystring.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binarystring.charCodeAt(i);
      }
      return bytes.buffer;
    },
    sendmessage: function sendmessage() {
      var _this4 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        contactId: this.contactId,
        title: this.composeForm.title,
        message: this.composeForm.message
      };
      this.$http.post(this.$bitrixapi + 'partner/messages/' + this.projectthreadid + '/reply', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          _this4.composeFormVisible = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Besked sendt',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
        } else {
          _this4.$message({
            type: 'error',
            message: response.body.message
          });
        }
      }, function (err) {
        _this4.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    changeDocument: function changeDocument() {
      this.documentId = this.selectedDocumentVersion;
      this.getContract();
    },
    documentLoad: function documentLoad() {
      if (!this.disablecomment && !this.showMobile) {
        document.getElementById('pdfViewer_annotation_commentPanel').click();
        document.getElementById('pdfViewer_annotation').click();
      }
      document.getElementById('pdfViewer_open').style.display = 'none';
      document.getElementById('pdfViewer_submitForm').style.display = 'none';
      this.viewer.importAnnotation(JSON.parse(this.contractInfo.ANNOTATIONS));
      this.formLoading = false;
    },
    exportAnnotation: function exportAnnotation(args) {
      if (this.disablecomment) {
        var obj = {
          title: 'Denne kontrakt er blevet bekræftet, din kommentar vil ikke blive sendt til boligejeren',
          message: '',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      var m = this;
      this.viewer.exportAnnotationsAsObject().then(function (value) {
        var headers = {
          Authorization: 'Bearer ' + m.salesPersonbitrix
        };
        var data = {
          documentId: m.documentId,
          annotation: value
        };
        m.$http.post(m.$bitrixapi + 'partner/contract/' + m.contractID + '/saveAnnotation', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          console.log(response);
        });
        console.log(value);
      });
    },
    ajaxRequestFailure: function ajaxRequestFailure(args) {
      window.location.reload();
    },
    getsupplierprofile: function getsupplierprofile() {
      var _this5 = this;

      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.partnerprofile = res.data;
          _this5.partnertelephone = res.data.MOBILE;
          _this5.partneremail = res.data.EMAIL;
          _this5.payprofform.telefonnummer = Number(res.data.UF_CRM_COMPANY_TELEPHONE);
          _this5.payprofform.email = res.data.EMAIL;
          _this5.payprofform.by = res.data.UF_CRM_COMPANY_CITY;
          _this5.payprofform.stat = res.data.UF_CRM_COMPANY_CITY;
          _this5.payprofform.Adresse = res.data.UF_CRM_COMPANY_ADDRESS;
          _this5.payprofform.zipcode = res.data.UF_CRM_COMPANY_ZIP_CODE;
          _this5.payprofform.cvr = res.data.UF_CRM_COMPANY_CVR;
          _this5.payprofform.companyName = res.data.TITLE;
        } else {
          _this5.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getProjectDetails: function getProjectDetails() {
      var _this6 = this;

      var projectid = this.$route.query.projectId;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.show = true;
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.contractID = res.data.CONTRACT_ID;
          _this6.contractStatus = res.data.CONTRACT_STATUS;
          if (_this6.contractStatus === 'approved' || _this6.contractStatus === 'signed') {
            _this6.disablecomment = true;
          }
          _this6.homeownerID = res.data.HOMEOWNER.ID;
          _this6.show = false;
          _this6.getContract();
        } else {
          _this6.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this6.show = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this6.refreshtoken();
          setTimeout(function () {
            _this6.getProjectDetails();
          }, 1000);
        } else {
          _this6.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getContractByProjectId: function getContractByProjectId() {
      var _this7 = this;

      this.commentmanagementloading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.contractdetails = res.data;
          _this7.comments = res.data.COMMENTS.reverse();
          _this7.contractID = _this7.contractdetails.ID;
          _this7.activedocumentId = res.data.DOCUMENTS.ID;
          _this7.contractpdflink = '/static/pdf/sample.pdf';
          var thisvar = _this7;
          res.data.COMMENTS.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this7.loaded === 1) {
            setTimeout(function () {
              _this7.showcontract();
            }, 3000);
          }
          _this7.loaded = 2;
          _this7.filtercommentsbyId(_this7.activepage);
          _this7.loading = false;
          _this7.commentmanagementloading = false;
          _this7.getContractSteps();
        } else {
          _this7.$message({
            type: 'error',
            message: res.message
          });
          _this7.loading = false;
        }
      }, function (response) {
        _this7.loading = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this7.refreshtoken();
          setTimeout(function () {
            _this7.getContractByProjectId();
          }, 1000);
        } else {
          _this7.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getContractComments: function getContractComments() {
      var _this8 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/comments/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this8.comments = res.data.reverse();
          var thisvar = _this8;
          _this8.comments.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this8.loaded === 1) {
            setTimeout(function () {
              _this8.showcontract();
            }, 5000);
          }
          _this8.loaded = 2;
          _this8.loading = false;
        } else {
          _this8.$message({
            type: 'error',
            message: res.message
          });
          _this8.loading = false;
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this8.refreshtoken();
          setTimeout(function () {
            _this8.getContractComments();
          }, 1000);
        } else {
          _this8.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getStepbycontent: function getStepbycontent(content) {
      this.stepsarr.forEach(function (l) {
        if (l.value.toString().includes(content)) {
          return l;
        }
        return false;
      });
    },
    getContractSteps: function getContractSteps() {
      var documents = [];
      var steps = [];
      var stepsvalue = [];
      documents = this.contractdetails.DOCUMENTS[this.contractdetails.DOCUMENTS.length - 1];
      steps = documents.JSON_STEPS;
      var arrsteps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(steps);
      arrsteps.forEach(function (a) {
        var arrfield = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(a);
        arrfield[arrfield.length - 1].forEach(function (h) {
          if ((typeof h === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(h)) === 'object') {
            h['fields'].forEach(function (n) {
              if (n.field !== 0) {
                var tempvalue = {
                  key: h.key,
                  value: n.default_value
                };
                stepsvalue.push(tempvalue);
                tempvalue = [];
              }
            });
          }
        });
      });
      this.stepsarr = stepsvalue;
    },
    getPayproffacc: function getPayproffacc() {
      var _this9 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.haspayproff = res.data.exists;
          _this9.getContract();
        } else {
          _this9.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this9.refreshtoken();
          setTimeout(function () {
            _this9.getPayproffacc();
          }, 1000);
        } else {
          _this9.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getTermsCondition: function getTermsCondition() {
      var _this10 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this10.termsdata = res.filter(function (l) {
          return l.TYPE === 'Partner';
        })[0];
        _this10.termslink = _this10.termsdata.LINK;
        _this10.termslabel = _this10.termsdata.LABEL;
      }, function (response) {
        _this10.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getAnnotations: function getAnnotations() {
      var thisvar = this;
      this.viewer = thisvar.$refs.pdfviewer.ej2Instances;
      this.comments.forEach(function (a) {
        if (a.ANNOTATIONS !== null) {
          console.log('a.ANNOTATIONS', a.ANNOTATIONS);
          thisvar.viewer.annotation.addAnnotation('Highlight', {
            allowedInteractions: a.ANNOTATIONS['allowedInteractions'],
            annotName: a.ANNOTATIONS['annotName'],
            annotationAddMode: a.ANNOTATIONS['annotationAddMode'],
            annotationSelectorSettings: {
              selectionBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderColor'],
              resizerBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerBorderColor'],
              resizerFillColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerFillColor'],
              resizerSize: a.ANNOTATIONS['annotationSelectorSettings']['resizerSize'],
              selectionBorderThickness: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderThickness'],
              selectorLineDashArray: a.ANNOTATIONS['annotationSelectorSettings']['selectorLineDashArray']
            },
            annotationSettings: {
              isLock: a.ANNOTATIONS['annotationSettings']['annotationAddMode']
            },
            author: thisvar.partnerName,
            bounds: [{
              bottom: a.ANNOTATIONS['bounds']['bottom'],
              height: a.ANNOTATIONS['bounds']['height'],
              left: a.ANNOTATIONS['bounds']['left'],
              top: a.ANNOTATIONS['bounds']['top'],
              right: a.ANNOTATIONS['bounds']['right']
            }],
            bottom: a.ANNOTATIONS['bottom'],
            height: a.ANNOTATIONS['height'],
            left: a.ANNOTATIONS['left'],
            right: a.ANNOTATIONS['right'],
            top: a.ANNOTATIONS['top'],
            width: a.ANNOTATIONS['width'],
            color: a.ANNOTATIONS['color'],
            comments: a.ANNOTATIONS['comments'],
            isAnnotationRotated: a.ANNOTATIONS['isAnnotationRotated'],
            isCommentLock: a.ANNOTATIONS['isCommentLock'],
            isMultiSelect: a.ANNOTATIONS['isMultiSelect'],
            isPrint: a.ANNOTATIONS['isMultiSelect'],
            modifiedDate: a.ANNOTATIONS['isMultiSelect'],
            note: a.ANNOTATIONS['note'],
            opacity: a.ANNOTATIONS['opacity'],
            pageNumber: a.ANNOTATIONS['pageNumber'],
            rect: {
              bottom: a.ANNOTATIONS['rect']['bottom'],
              height: a.ANNOTATIONS['rect']['height'],
              left: a.ANNOTATIONS['rect']['left'],
              right: a.ANNOTATIONS['rect']['right'],
              top: a.ANNOTATIONS['rect']['top'],
              width: a.ANNOTATIONS['rect']['width']
            },
            review: {
              state: a.ANNOTATIONS['review']['state'],
              stateModel: a.ANNOTATIONS['review']['stateModel'],
              author: a.ANNOTATIONS['review']['author'],
              modifiedDate: a.ANNOTATIONS['review']['modifiedDate']
            },
            shapeAnnotationType: a.ANNOTATIONS['shapeAnnotationType'],
            subject: a.ANNOTATIONS['subject'],
            textMarkupAnnotationType: a.ANNOTATIONS['textMarkupAnnotationType'],
            textmarkupcontent: a.ANNOTATIONS['textMarkupContent'],
            textMarkupEndIndex: a.ANNOTATIONS['textMarkupEndIndex'],
            textMarkupStartIndex: a.ANNOTATIONS['textMarkupStartIndex']
          });
        }
      });
    },
    saveComment: function saveComment(item, index) {
      var _this11 = this;

      var stepno = 3;
      var step = this.getStepbycontent(item['annotation']['textMarkupContent']);
      if (stepno) {
        step = stepno.key;
      }
      var page = item['annotation']['pageNumber'];
      var highlighttext = item['annotation']['textMarkupContent'];
      var desccomment = item['annotation']['note'];
      this.$confirm('Er du sikker på, at du vil gemme denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var headers = {
          Authorization: 'Bearer ' + _this11.salesPersonbitrix
        };
        var data = {
          annotations: item['annotation'],
          documentId: _this11.activedocumentId,
          annotationId: item['id']
        };
        _this11.$http.post(_this11.$bitrixapi + 'partner/contract/comments?contractId=' + _this11.contractID + '&title=' + step + '&comments=' + desccomment + '&page=' + page + '&highlightedText=' + highlighttext + '&contactId=' + _this11.homeownerID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this11.$refs.simplert.openSimplert(obj);
          }
          _this11.getContractByProjectId();
        }, function (err) {
          _this11.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    addComment: function addComment(page, selectedtext) {
      var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

      var haaid = localStorage.getItem('haaid');
      var commentdetails = {
        'HIGHLIGHTED_TEXT': selectedtext,
        'COMMENTS': '',
        'PAGE': page,
        'TITLE': step,
        'STATUS': 'pending',
        'CONTRACT_ID': this.contractID,
        'CONTACT_ID': this.homeownerID,
        'COMPANY_ID': haaid,
        'fromdb': false
      };
      this.comments.unshift(commentdetails);
      this.filteredcomments.unshift(commentdetails);
      var thisvar = this;
      this.comments.forEach(function (a, index) {
        thisvar.comments[index]['fromdb'] = a.fromdb;
        thisvar.textarea[index] = a.COMMENTS;
      });
      this.filteredcomments.forEach(function (b, index) {
        thisvar.filteredcomments[index]['fromdb'] = b.fromdb;
        thisvar.textarea[index] = b.COMMENTS;
      });
      commentdetails = [];
    },
    clear: function clear() {
      this.payprofform = {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: '+45',
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      };
    },
    closeconfirmPayproff: function closeconfirmPayproff() {
      this.confirmPayproff = false;
    },
    openconfirmPayproff: function openconfirmPayproff() {
      var error = 0;
      this.$refs['payprofform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.closepayproffform();
      this.confirmPayproff = true;
    },
    verify: function verify() {
      var _this12 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: this.payprofform.cprnummer,
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this12.closeconfirmPayproff();

          _this12.getNemIdUrl();
          setTimeout(function () {
            _this12.$router.push('/customer-projects/project-dashboard?projectId=' + _this12.activeprojectId);
          }, 3000);
        } else {
          _this12.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this12.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getNemIdUrl: function getNemIdUrl() {
      var _this13 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        window.open(res.data.URL, '_blank').focus();
      }, function (err) {
        _this13.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    initiateSignaturepad: function initiateSignaturepad() {
      var _this14 = this;

      setTimeout(function () {
        var canvas = document.querySelector('canvas');
        _this14.signaturePad = new __WEBPACK_IMPORTED_MODULE_6_signature_pad__["a" /* default */](canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        });
      }, 200);
    },
    clearSignature: function clearSignature() {
      this.signaturePad.clear();
    },
    confirmcontract: function confirmcontract() {
      var _this15 = this;

      if (!this.confirmTerms) {
        this.$message({
          type: 'error',
          message: 'Accepter venligst vores vilkår og tjenester'
        });
        return false;
      }
      var signature = this.signaturePad;
      if (signature.isEmpty()) {
        this.$message({
          type: 'error',
          message: 'Underskriv venligst kontrakten'
        });
        return;
      }
      var signaturePng = signature.toDataURL();
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        signaturePng: signaturePng
      };
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/approve?messageId=1&fileId=1', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          if (_this15.haspayproff) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this15.$refs.simplert.openSimplert(obj);
            setTimeout(function () {
              _this15.$router.push('/customer-projects/project-dashboard?projectId=' + _this15.activeprojectId + '&contactID=' + _this15.homeownerID + '&parentID=' + _this15.parentID + '&industryID=' + _this15.industryID + '&offertype=' + _this15.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this15.childprojects) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this15.submittedIndustries) + '&contracttype=' + _this15.contractType + '&projecttitle=' + _this15.projectTitle);
            }, 3000);
          } else {
            _this15.openpayproffform();
          }
        }
      }, function (err) {
        if (err.body.message === 'Unauthorized. User has been logged out.') {
          _this15.refreshtoken();
          setTimeout(function () {
            _this15.confirmcontract();
          }, 1000);
        } else {
          _this15.$message({
            type: 'error',
            message: err.body.message
          });
        }
      });
    },
    deletecommentarray: function deletecommentarray(item) {
      this.comments.splice(this.comments.indexOf(item), 1);
      this.textarea.splice(this.textarea.indexOf(item.COMMENTS), 1);
      this.getContractByProjectId();
    },
    deletecomment: function deletecomment(item) {
      var _this16 = this;

      this.$confirm('Er du sikker på, at du vil slette denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this16.commentmanagementloading = true;
        var headers = {
          Authorization: 'Bearer ' + _this16.salesPersonbitrix
        };
        var data = {};
        _this16.$http.post(_this16.$bitrixapi + 'partner/contract/comments/' + item.ID + '/delete', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this16.$refs.simplert.openSimplert(obj);
            _this16.getContractByProjectId();
          }
        }, function (err) {
          _this16.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    filtercommentsbyId: function filtercommentsbyId(page) {
      var filtered = [];
      var thisthisvar = this;
      filtered = this.comments.filter(function (a) {
        return a.PAGE === page;
      });
      filtered.forEach(function (b, index) {
        if (b.HIGHLIGHTED_TEXT !== null && b.HIGHLIGHTED_TEXT !== '') {
          thisthisvar.hightlighttext(b.HIGHLIGHTED_TEXT);
        }
        thisthisvar.textarea[index] = b.COMMENTS;
      });
      this.filteredcomments = filtered;
    },
    hightlighttext: function hightlighttext(text) {
      var textactula = document.querySelectorAll('[data-page-number="' + this.activepage + '"] > .textLayer > span');
      textactula.forEach(function (z) {
        var Special = /[\\[{().+?|^&]/g;
        if (z.innerHTML.includes(text)) {
          var textvalue = z.innerHTML;
          if (Special.test(textvalue)) {
            textvalue = textvalue.replace(Special, '\\$&');
          }
          var regExp = new RegExp(text, 'gi');
          z.innerHTML = z.textContent.replace(regExp, '<marker>$&</marker>');
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this17 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this17.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this17.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this17.$router.push('/login');
      });
    },
    getmessagesbyProjectID: function getmessagesbyProjectID() {
      var _this18 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messages?projectId=' + this.activeprojectId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this18.projectthreadid = res[0].THREAD_ID;
      }, function (response) {
        _this18.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    showComposeForm: function showComposeForm() {
      if (this.composeForm.message === '') {
        this.composeForm.message = 'Jeg har tjekket filen og har nogle kommentarer. Kontroller venligst';
      }
      if (this.composeForm.title === '') {
        this.composeForm.title = 'Gennemgå Draft Contract Pdf';
      }
      this.composeFormVisible = true;
    },
    hideComposeForm: function hideComposeForm() {
      this.composeFormVisible = false;
    },
    uploadImage: function uploadImage(file, fileList) {
      this.composeForm.image = fileList;
      var fileSize = file.size / 1024 / 1024;
      var fileLimitMB = 1;
      if (fileSize > fileLimitMB) {
        this.removeUpload(file);
        this.$message.error('File size can not exceed 1MB!');
      }
    },
    removeUpload: function removeUpload(file) {
      var images = this.composeForm.image;
      for (var i = 0; i < images.length; i++) {
        if (file.uid === images[i].uid) {
          images.splice(i, 1);
        }
      }
      images = this.composeForm.image;
    },
    pagesRenderedHandler: function pagesRenderedHandler(pdfapp) {
      this.pdf = pdfapp;
      this.activepage = pdfapp.page;
      var thisvar = this;
      this.pdf.bindEvents('pagechanging', function (a) {
        thisvar.page = a.page;
      });
    },
    openpayproffform: function openpayproffform() {
      this.payproffform = true;
    },
    closepayproffform: function closepayproffform() {
      this.payproffform = false;
    },
    validateCreatePayproffFirstTab: function validateCreatePayproffFirstTab() {
      return true;
    }
  }
});

/***/ }),
/* 1098 */,
/* 1099 */,
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-main-viewer"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix "},[_vm._m(0),_vm._v(" "),_c('div',[_c('div',{staticClass:"flex flex-row mobile-flex-column col-12 m0 pb2 p0 ",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"highlights border col-12 mp0"},[_c('div',{staticClass:"flex justify-end"},[(_vm.confirmstatus === '')?_c('button',{staticClass:"p1 m1 action-button",on:{"click":function($event){_vm.ConfirmVisible = true, _vm.initiateSignaturepad()}}},[_vm._v("Bekræft")]):_vm._e(),_vm._v("\n                   \n                  "),_c('button',{staticClass:"p1 m1 primary-button",on:{"click":function($event){return _vm.showComposeForm()}}},[_c('i',{staticClass:"el-icon-circle-plus"}),_vm._v(" Send besked til "+_vm._s(_vm.contact))])]),_vm._v(" "),(_vm.ConfirmVisible)?_c('div',{staticClass:"flex justify-center"},[_c('form',{staticClass:"payProff"},[_c('div',{staticClass:"col-12 flex justify-between items-center p0"},[_c('p',{staticClass:"h5 cyprus regular line-height-1 m0 p2"},[_vm._v("Underskriv her")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.clearSignature()}}},[_vm._v("Slet")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"mr-auto p0 py2 mo h6"},[_c('el-checkbox',{staticClass:"saveSignature",model:{value:(_vm.confirmTerms),callback:function ($$v) {_vm.confirmTerms=$$v},expression:"confirmTerms"}},[_c('span',{staticClass:"pointer",on:{"click":function($event){_vm.termspopup = true}}},[_vm._v(_vm._s(_vm.termslabel))])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 flex justify-between items-center"},[_c('button',{staticClass:"mr2 muted-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){_vm.ConfirmVisible = false}}},[_c('span',{staticClass:"mr1"}),_vm._v("Annuller\n                        ")]),_vm._v(" "),_c('button',{staticClass:"action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmcontract()}}},[_vm._v("\n                          Bekræft\n                          "),_c('span',{staticClass:"ml1"})])])])]),_vm._v(" "),_c('div',{staticClass:"py2"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.pdfStrlink,"allowfullscreen":""}})],1)])]),_vm._v(" "),_c('div',{staticClass:"py3"})])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p2 pb4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.composeFormVisible),callback:function ($$v) {_vm.composeFormVisible=$$v},expression:"composeFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n            Skriv til ...\n          ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Ny besked")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_vm._v("\n        "+_vm._s(_vm.contact)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Title"},model:{value:(_vm.composeForm.title),callback:function ($$v) {_vm.$set(_vm.composeForm, "title", $$v)},expression:"composeForm.title"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mb4"},[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.composeForm.message),callback:function ($$v) {_vm.$set(_vm.composeForm, "message", $$v)},expression:"composeForm.message"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = false}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendmessage()}}},[_c('span',[_vm._v("Send")])])])])]),_vm._v(" "),_c('b-modal',{ref:"payproffform",attrs:{"centered":"","hide-footer":"","id":"payproffform","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.payproffform),callback:function ($$v) {_vm.payproffform=$$v},expression:"payproffform"}},[_c('div',{staticClass:"col-11 flex justify-between items-center pt1 p0 mx-auto my2"},[_c('div',{staticClass:"col-5"},[_c('p',{staticClass:"mr-auto h5 cyprus semi-bold line-height-1 m0 p0"},[_vm._v("Payproff Form\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 ml-auto flex justify-end h4 p0 primary-white-button pointer close m0",on:{"click":function($event){return _vm.closepayproffform()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"hide"},[_c('div',{staticClass:"flex flex-column "},[_c('span',{},[_c('i',{staticClass:"el-icon-loading"})]),_vm._v(" "),_c('p',{staticClass:"h6 regular small"},[_vm._v("Godkendt af Finanstilsynet")]),_vm._v(" "),_c('p',{staticClass:"p0 m0"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('span',{},[_vm._v("Information")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"darkblue notosans",attrs:{"id":"payproff"}},[_c('el-form',{ref:"payprofform",staticClass:"md-col-11 lg-col-11 sm-col-12 mx-auto p2",attrs:{"id":"cvrfrom","model":_vm.payprofform,"rules":_vm.payprofformfules,"label-position":"top"}},[_c('form-wizard',{ref:"createPayproffFormWiz",attrs:{"shape":"tab","color":"#ffffff"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"col-12 p0 flex",class:props.isLastStep ? 'justify-between' : 'justify-end'},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-primary-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){props.isLastStep ? _vm.openconfirmPayproff() : props.nextTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(props.isLastStep ? 'Indsend' : 'Næste'))]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])]}}])},[_c('tab-content',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"mb2 flex flex-column items-start p0"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"152.26","height":"35.735","viewBox":"0 0 152.26 35.735"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1428","data-name":"Rectangle 1428","width":"152.26","height":"35.735","fill":"#2265fc"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Payproff_logo","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4272","data-name":"Path 4272","d":"M820.931,52.36v0Z","transform":"translate(-668.671 -41.591)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4273","data-name":"Path 4273","d":"M820.931,78.36v0Z","transform":"translate(-668.671 -62.769)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4274","data-name":"Path 4274","d":"M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072","transform":"translate(0 0)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4275","data-name":"Path 4275","d":"M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016","transform":"translate(-381.958 -44.465)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4276","data-name":"Path 4276","d":"M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021","transform":"translate(-179.766 -44.315)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4277","data-name":"Path 4277","d":"M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022","transform":"translate(-249.978 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4278","data-name":"Path 4278","d":"M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0","transform":"translate(-507.012 -60.278)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4279","data-name":"Path 4279","d":"M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0","transform":"translate(-572.504 -39.143)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4280","data-name":"Path 4280","d":"M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012","transform":"translate(-624.503 -39.14)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4281","data-name":"Path 4281","d":"M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z","transform":"translate(-331.26 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4282","data-name":"Path 4282","d":"M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276","transform":"translate(-456.523 -60.325)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4283","data-name":"Path 4283","d":"M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117","transform":"translate(-314.339 -60.317)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4284","data-name":"Path 4284","d":"M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175","transform":"translate(-589.263 -60.244)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4285","data-name":"Path 4285","d":"M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469","transform":"translate(-641.245 -60.253)","fill":"#2265fc"}})])]),_vm._v(" "),_c('span',[_vm._v("Godkendt af Finanstilsynet")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center cyprus"},[_c('span',[_c('svg',{staticClass:"block",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"}})])]),_vm._v(" "),_c('p',{staticClass:"h5 line-height-1 m0 ml1 p0"},[_vm._v("Information")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix pr3 mb2"},[_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  "),_c('a',{staticClass:"semi-bold",attrs:{"href":"https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186","target":"_blank"}},[_vm._v("her")]),_vm._v(", og læse mere om de godkendelser, de har fået\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("\n                  PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.")])]),_vm._v(" "),_c('div',[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor har du brug for mine bankoplysninger?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("Vi har brug for dine bankoplysninger for at sende dig pengene eller for at\n                        refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver\n                        at dele dine bankoplysninger med din kontraktpartner.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvordan overfører jeg pengene til PayProff?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,\n                        Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de\n                        bankoplysninger og referencenummer, du skal bruge input, når du foretager\n                        overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte\n                        referencenummer Der kan opstå forsinkelser, da vores system ikke vil være\n                        i stand til at afstemme din betaling med det samme.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("For at overholde lovmæssige krav skal vi muligvis stille dig et par\n                        ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,\n                        hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper\n                        økonomisk kriminalitet.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi\n                        en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du\n                        er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.\n                        Flere muligheder om identitetsbekræftelse både for private enkeltpersoner\n                        og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.")])],2)],1)],1)])]),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateCreatePayproffFirstTab}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fornavn","prop":"fornavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"8","placeholder":"fornavn","clearable":""},model:{value:(_vm.payprofform.fornavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "fornavn", _vm._n($$v))},expression:"payprofform.fornavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Efternavn","id":"efternavn","prop":"efternavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"efternavn","clearable":""},model:{value:(_vm.payprofform.efternavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "efternavn", $$v)},expression:"payprofform.efternavn"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Mellemnavn","prop":"mellemnavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"mellemnavn","clearable":""},model:{value:(_vm.payprofform.mellemnavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "mellemnavn", $$v)},expression:"payprofform.mellemnavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 ml-auto",attrs:{"label":"Fodelsdag","id":"fodelsdag","prop":"fodelsdag"}},[_c('datepicker',{staticClass:"col-12 m0 p0",attrs:{"id":"datepickeroffer2","bootstrapStyling":false,"placeholder":"Fodelsdag","language":_vm.da},model:{value:(_vm.payprofform.fodelsdag),callback:function ($$v) {_vm.$set(_vm.payprofform, "fodelsdag", $$v)},expression:"payprofform.fodelsdag"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Adresse","prop":"Adresse"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"Strandlodsvej 6, 1. sal","clearable":""},model:{value:(_vm.payprofform.Adresse),callback:function ($$v) {_vm.$set(_vm.payprofform, "Adresse", $$v)},expression:"payprofform.Adresse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"zipcode","id":"zipcode","prop":"zipcode"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"2300","clearable":""},model:{value:(_vm.payprofform.zipcode),callback:function ($$v) {_vm.$set(_vm.payprofform, "zipcode", $$v)},expression:"payprofform.zipcode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"By","prop":"by"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"København s","clearable":""},model:{value:(_vm.payprofform.by),callback:function ($$v) {_vm.$set(_vm.payprofform, "by", $$v)},expression:"payprofform.by"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Stat","id":"stat","prop":"stat"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"stat","clearable":""},model:{value:(_vm.payprofform.stat),callback:function ($$v) {_vm.$set(_vm.payprofform, "stat", $$v)},expression:"payprofform.stat"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"E-mail","clearable":""},model:{value:(_vm.payprofform.email),callback:function ($$v) {_vm.$set(_vm.payprofform, "email", $$v)},expression:"payprofform.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Land","id":"land","prop":"land"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"Country"},model:{value:(_vm.payprofform.land),callback:function ($$v) {_vm.$set(_vm.payprofform, "land", $$v)},expression:"payprofform.land"}},_vm._l((_vm.countryData),function(country,index){return _c('el-option',{key:index,attrs:{"label":country,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"telefonnummer","prop":"telefonnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"8","placeholder":"Tel.(8 cifre)","clearable":""},model:{value:(_vm.payprofform.telefonnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "telefonnummer", _vm._n($$v))},expression:"payprofform.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefon contry code","id":"telcountrycode","prop":"telcountrycode"}},[_c('el-input',{staticClass:"white-background",attrs:{"placeholder":"+45","clearable":""},model:{value:(_vm.payprofform.telcountrycode),callback:function ($$v) {_vm.$set(_vm.payprofform, "telcountrycode", _vm._n($$v))},expression:"payprofform.telcountrycode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"CPR nummer","id":"cprnummer","prop":"cprnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"10","placeholder":"XXXXXXXXXX","clearable":""},model:{value:(_vm.payprofform.cprnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "cprnummer", _vm._n($$v))},expression:"payprofform.cprnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Sprog","id":"sprog","prop":"sprog"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","placeholder":"sprog","clearable":""},model:{value:(_vm.payprofform.sprog),callback:function ($$v) {_vm.$set(_vm.payprofform, "sprog", $$v)},expression:"payprofform.sprog"}},_vm._l((_vm.languagesData),function(language,index){return _c('el-option',{key:index,attrs:{"label":language,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Betalingsmiddel","id":"currency","prop":"currency"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"DKK"},model:{value:(_vm.payprofform.currency),callback:function ($$v) {_vm.$set(_vm.payprofform, "currency", $$v)},expression:"payprofform.currency"}},[_c('el-option',{attrs:{"vlabel":"DKK","value":"DKK"}}),_vm._v(" "),_c('el-option',{attrs:{"vlabel":"EUR","value":"EUR"}})],1)],1)],1)])])],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"confirmPayproff",attrs:{"centered":"","hide-footer":"","id":"confirmPayproff","no-close-on-backdrop":true,"size":"lg"},model:{value:(_vm.confirmPayproff),callback:function ($$v) {_vm.confirmPayproff=$$v},expression:"confirmPayproff"}},[_c('div',{staticClass:"col-12 flex justify-end items-center pt1 p0 mx-auto modal-header"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background"},[_c('div',{staticClass:"flex flex-column items-start col-12 pb3 pt1 px3"},[_c('p',{staticClass:"muted-color h6 pt1"},[_vm._v("Er du en politisk udsat person? (PEP)")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold py1 mt1"},[_vm._v("Hvad er en politisk eksponeret person?")]),_vm._v(" "),_c('p',{staticClass:"h6 mt1 center"},[_vm._v("Jeg bekræfter og siger sandfærdigt, som om jeg var under ed, at:")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start my2"},[[_c('el-radio',{attrs:{"label":true},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Ja")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Nej")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"flex "},[_c('button',{staticClass:" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-back pr1"}),_vm._v("Tilbage\n          ")]),_vm._v(" "),_c('button',{staticClass:"mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.verify()}}},[_vm._v("Sende "),_c('i',{staticClass:"pl1 el-icon-right"})])])]),_vm._v(" "),_c('b-modal',{ref:"termspopup",attrs:{"centered":"","hide-header":"","size":"lg","hide-footer":"","id":"termspopup"},model:{value:(_vm.termspopup),callback:function ($$v) {_vm.termspopup=$$v},expression:"termspopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.termspopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":_vm.termslink,"frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3 "},[_vm._v("Udkast til Kontrakt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-pad col-12 height-full",attrs:{"id":"signature-pad"}},[_c('div',{staticClass:"signature-pad--body"},[_c('canvas',{staticStyle:{"touch-action":"none","user-select":"none"},attrs:{"width":"664","height":"339"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1101 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__ = __webpack_require__(214);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_pdf_app_dist_icons_main_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_datetime__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'signup',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_4_vue_datetime__["Datetime"],
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_0_vue_pdf_app___default.a,
    axios: __WEBPACK_IMPORTED_MODULE_3_axios___default.a
  },
  watch: {},
  data: function data() {
    return {
      loadingnewpayment: false,
      reepaycheckbox: '0',
      leverancheckbox: '1',
      mobilepaycheckbox: '0',
      pid: '',
      fullurl: '',
      disablemobilepaybutton: false,
      showcvr: false,
      cvrerror: '',
      originalid: '',
      levid: '',
      blockid: '',
      step: 1,
      jobstotal: '',
      jobstotalstatic: 3,
      SearchItem: [],
      loading: false,
      loadingjobs: false,
      showsessionnewcreditpro: '',
      disableupdateinfo: false,
      form2: {
        fullname: '',
        email: '',
        telefonnummer: '',
        companyname: '',
        address: '',
        postnum: '',
        city: '',
        cvr: '',
        mobilenummber: ''
      },
      form: {
        regnr: '',
        bankkonto: ''
      },
      rulesform2: {
        fullname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit navn',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        companyname: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste et gyldigt 8 digit mobilnr.',
          trigger: 'blur'
        }],
        postnum: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste et gyldigt postnum.',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt by.',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste et gyldigt Addresse.',
          trigger: 'blur'
        }],
        cvr: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Indtast venligst et gyldigt cvr og 8 cifre.',
          trigger: 'blur'
        }]
      },
      rulesform: {
        bankkonto: [{
          min: 6,
          max: 10,
          message: 'Indtast venligst et gyldigt 6 til 10-cifret nummer.',
          trigger: 'blur'
        }, {
          required: true,
          type: 'string',
          message: 'Indtast venligst nummer.',
          trigger: 'blur'
        }],
        regnr: [{
          required: true,
          type: 'string',
          max: 4,
          message: 'Indtast venligst et gyldigt 4-cifret nummer.',
          trigger: 'blur'
        }]
      },
      salesPerson: '',
      hasleveran: '',
      levandorupdate: '',
      regnr: '',
      bankkonto: '',
      options: [],
      bank: '',
      cvr: '',
      gratisbutton: 1,
      consentleveran: true,
      consentreepay: 'accepted',
      leverantext: '',
      isvalidcvr: '',
      showerrorleveran: false,
      showerrorleveranerror: false,
      showerrorreepay: false,
      statusstep: '',
      job: false,
      shorturl: '',
      showMobile: '',
      isused: '',
      mobilepaylink: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      datamethod: '',
      selectedpayment: 'leve',
      paymentoption: [{ value: 'leve', text: 'Leverandørservice (0 kr.)' }, { value: 'reep', text: 'Kreditkort (0 kr.)' }, { value: 'mobpay', text: 'MobilePay (0 kr.)' }],
      originalsubpage: '',
      originalmainpage: ''
    };
  },
  created: function created() {
    localStorage.removeItem('yourfulllink');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    localStorage.setItem('yourfulllink', this.fullurl);
    this.originalid = localStorage.getItem('yourid');
    this.originalsubpage = pathArray[pathArray.length - 2];
    this.originalmainpage = pathArray[pathArray.length - 3];
    this.pid = pathArray[pathArray.length - 1];
    if (this.pid !== null) {
      this.decode(this.pid);
    }
    setTimeout(function () {
      document.getElementById('partnerloginapp').style.border = 0;
    }, 100);
    this.getdevice();
  },

  mounted: {},
  methods: {
    checkboxselect: function checkboxselect() {
      var _this = this;

      if (this.selectedpayment === 'reep') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      } else if (this.selectedpayment === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
      } else if (this.selectedpayment === 'googlepay') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      } else if (this.selectedpayment === 'applepay') {
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this.showpopupreepay();
          }
          var colorchange2 = document.querySelector('.second-secondary2');
          colorchange2.style.color = '#409EFF!important';
        }, 100);
      }
    },
    getdevice: function getdevice() {
      var ua = navigator.userAgent;
      if (/android/i.test(ua)) {
        this.paymentoption.push({ value: 'googlepay', text: 'Google Pay (0 kr.)' });
      } else if (/iPad|iPhone|iPod/.test(ua) || navigator.maxTouchPoints > 1) {
        this.paymentoption.push({ value: 'applepay', text: 'Apple Pay (0 kr.)' });
      }
    },
    checkboxselectold: function checkboxselectold(text) {
      var _this2 = this;

      if (text === 'leve') {
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('leveran').classList.remove('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.add('hide');
        this.leverancheckbox = '1';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '0';
      } else if (text === 'mobpay') {
        this.disablemobilepaybutton = true;
        this.registerMobilepay();
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = false;
        document.getElementById('mobilepaycheckbox').checked = true;
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.add('hide');
        document.getElementById('mobilepay').classList.remove('hide');
        this.leverancheckbox = '0';
        this.reepaycheckbox = '0';
        this.mobilepaycheckbox = '1';
      } else {
        document.getElementById('leverandcheckbox').checked = false;
        document.getElementById('reepaycheckbox').checked = true;
        document.getElementById('mobilepaycheckbox').checked = false;
        document.getElementById('mobilepay').classList.add('hide');
        document.getElementById('leveran').classList.add('hide');
        document.getElementById('reepay').classList.remove('hide');
        setTimeout(function () {
          if (document.getElementById('rp_container').childNodes.length === 0) {
            _this2.showpopupreepay();
          }
        }, 100);
        this.reepaycheckbox = '1';
        this.leverancheckbox = '0';
        this.mobilepaycheckbox = '0';
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#409EFF!important';
      }
    },
    changecolor: function changecolor() {
      var colorchange = document.querySelector('.second-secondary');
      colorchange.style.color = '#409EFF!important';
      if (this.consentreepay === 'not_accepted') {
        var colorchange2 = document.querySelector('.second-secondary2');
        colorchange2.style.color = '#606266';
      } else {
        var colorchange3 = document.querySelector('.second-secondary2');
        colorchange3.style.color = '#409EFF!important';
      }
    },
    centericon: function centericon() {
      setTimeout(function () {
        var icon = document.getElementById('subicons');
        var iconholder = document.getElementById('subitemitem1');
        var iconmarginleft = parseInt(parseInt(iconholder.clientWidth / 2) - parseInt(117 / 2));
        icon.style.marginLeft = iconmarginleft + 'px';
      }, 50);
    },
    nextstep: function nextstep() {
      if (this.showsessionnewcreditpro === '') {
        this.showsessionnewcredit();
      }
      this.step = this.step + 1;
      if (this.step === 2) {
        this.showconfirmcvr();
      } else if (this.step === 3) {
        this.closeconfirmcvr();
        this.showpayment();
      }
    },
    backstep: function backstep() {
      if (this.step === 2) {
        this.closeconfirmcvr();
        this.statusstep = 'signup_not_active_step1';
        this.updateleadintegration();
        this.addnotifocationbar();
      } else if (this.step === 3) {
        this.closepayment();
        this.showconfirmcvr();
      }
      this.step = this.step - 1;
    },
    showpopupsuccess: function showpopupsuccess() {
      this.$refs['sendingsuccess'].show();
    },
    closepopupsucces: function closepopupsucces() {
      this.$refs['sendingsuccess'].hide();
    },
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    showpayment: function showpayment() {
      this.$refs['payments'].show();
    },
    showconfirmcvr: function showconfirmcvr() {
      this.$refs['confirmcvr'].show();
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopupcontract: function showpopupcontract() {
      this.$refs['popupcontract'].show();
    },
    showpopuplink: function showpopuplink() {
      this.$refs['popuplink'].show();
    },
    closepayment: function closepayment() {
      this.$refs['payment'].hide();
    },
    closeconfirmcvr: function closeconfirmcvr() {
      this.$refs['confirmcvr'].hide();
    },
    closepopuplink: function closepopuplink() {
      this.$refs['popuplink'].hide();
    },
    closepopuplinklever: function closepopuplinklever() {
      this.$refs['popuplinklever'].hide();
    },
    showpopuplinklever: function showpopuplinklever() {
      this.$refs['popuplinklever'].show();
    },
    closepopupcontract: function closepopupcontract() {
      this.$refs['popupcontract'].hide();
    },
    limitleverantext: function limitleverantext() {
      var _this3 = this;

      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      this.leverantext = 'Prøvepakken er for dig, der gerne vil teste platformen gratis. Med denne plan, kan du få adgang til platformen i 30 dage for 0 kr. uden binding. Samtidig får du 3 bud helt uden forpligtelser. Du kan til enhver tid nemt opsige Prøvepakke-planen dog inden for planens løbetid. Såfremt du ikke opsiger rettidig, vil din plan automatisk opgradere til en “Vækst” plan. Denne plan koster 3.299 kr. / mdr. ekskl. moms med en binding på løbende måned + 3 måneder jf. vores alm forretningsbetingelser. De 30 dages fri opsigelse tager ikke forbehold for weekender og helligdage og tæller opstartsdagen inklusive. Det er kun muligt at oprette, samt at have en Prøvepakke-plan pr. person/virksomhed.';
      setTimeout(function () {
        var moreText = document.getElementById('showmore');
        var lessText = document.getElementById('showless');
        lessText.classList.add('hide');
        moreText.classList.add('hide');
        var newtext = '';
        if (screen.width <= 640) {
          if (no === 2) {
            newtext = _this3.leverantext.slice(0, 120);
            _this3.leverantext = newtext;
            lessText.classList.add('hide');
            moreText.classList.remove('hide');
          } else {
            newtext = _this3.leverantext;
            _this3.leverantext = newtext;
            lessText.classList.remove('hide');
            moreText.classList.add('hide');
          }
        }
        document.getElementById('consentleverancheckbox').checked = true;
        document.getElementById('leverandcheckbox').checked = true;
        document.getElementById('leveran').classList.remove('hide');
        _this3.centericon();
      }, 100);
    },
    limitsubdetails: function limitsubdetails() {
      var no = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 2;

      setTimeout(function () {
        var moreText = document.getElementById('seemoredetails');
        var lessText = document.getElementById('seelesedetails');
        var details = document.getElementById('moredetails');
        var detailsheight = document.getElementById('subcontainerweb');

        if (no === 2) {
          lessText.classList.add('hide');
          moreText.classList.remove('hide');
          details.classList.add('hide');
          var detailsheightoldone = 500;
          detailsheight.style.height = detailsheightoldone + 'px';
        } else {
          lessText.classList.remove('hide');
          moreText.classList.add('hide');
          details.classList.remove('hide');
          var detailsheightold = detailsheight.clientHeight;
          detailsheight.style.height = parseInt(190 + detailsheightold) + 'px';
        }
      }, 100);
    },
    checkleveranpartner: function checkleveranpartner() {
      var _this4 = this;

      var dataPartner = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.cvr = res.cvr;
        if (res.levandorupdate === '') {
          _this4.hasleveran = false;
          _this4.levandorupdate = res.levandorupdate;
        } else {
          _this4.hasleveran = true;
          if (_this4.processingperiod(res.levandorupdate)) {
            _this4.levandorupdate = '';
          } else {
            _this4.levandorupdate = res.levandorupdate;
          }
        }
        _this4.nextstep();
        _this4.form.regnr = res.levandorregnr;
        _this4.form.bankkonto = res.levandorbankkonto;
        _this4.options = res.bankOptions;
      }, function (response) {
        alert('error');
      });
    },
    processingperiod: function processingperiod() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      var datenow = new Date();
      var processingstart = new Date(a);
      var processingend = new Date(a);
      processingend.setDate(processingstart.getDate() + 4);
      if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
        return false;
      } else {
        return true;
      }
    },
    service_levendor: function service_levendor() {
      var _this5 = this;

      if (this.consentleveran === 'not_accepted' || this.consentleveran === '') {
        this.showerrorleveran = true;
        return;
      }

      var error = 0;
      this.$refs['step4formcontact2'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      this.loadingnewpayment = true;
      var dataPartner = {
        operation: 'service_levendor',
        salesPerson: this.salesPerson,
        regnr: this.form.regnr,
        bankkonto: this.form.bankkonto,
        levid: this.levid,
        cvr: this.form2.cvr,
        bank: 'imentor'
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.modalShowDato = false;
          _this5.paymenthod = 'leveran';
          _this5.urlactivated = 1;
          _this5.paymenthodupdate = 1;
          _this5.updateprofilepayment();
        } else {
          _this5.loadingnewpayment = false;
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    showsessionnewcredit: function showsessionnewcredit() {
      var _this6 = this;

      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/recurringSession?partnerId=' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var data = res.data;
          _this6.showsessionnewcreditpro = data.id;
        } else {
          console.log('Error in showing session');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    goto: function goto(text) {
      var div = document.getElementById('payments');
      div.scrollTo(0, div.scrollHeight, { behavior: 'smooth' });
    },
    scrollTo: function scrollTo(elementId) {
      var element = document.getElementById(elementId);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    registerMobilepay: function registerMobilepay() {
      var _this7 = this;

      var dataPartner = { operation: 'registerMobilepay',
        salesPerson: this.salesPerson,
        mobile: this.form2.mobilenummber,
        mobilev: 0,
        acceptUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/1?levid=' + this.levid + '&blockid=' + this.blockid,
        rejectUrl: 'https://www.kundematch.dk/newpartner/#/mobilepay/accepted/0?levid=' + this.levid
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.mobilepaylink = res.url;
          _this7.disablemobilepaybutton = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    showpopupreepay: function showpopupreepay() {
      if (this.consentreepay !== 'accepted') {
        this.showerrorreepay = true;
        return false;
      } else {
        var m = this;
        this.rp = new window.Reepay.EmbeddedCheckout(this.showsessionnewcreditpro, { html_element: 'rp_container', showReceipt: true });
        this.rp.addEventHandler(window.Reepay.Event.Accept, function (data) {
          m.datamethod = '';
          m.showsessionnewcreditpro = m.showsessionnewcreditpro;
          console.log('done adding card', data);
          setTimeout(function () {
            m.urlactivated = 1;
            m.paymenthod = 'reepay';
            m.paymenthodupdate = 1;
            m.updateprofilepayment();
          }, 2000);
        });
      }
    },
    validatecvrinput: function validatecvrinput() {
      var _this8 = this;

      setTimeout(function () {
        var datacvr = _this8.form2.cvr;
        _this8.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this8.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + _this8.blockid, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              if (res.success) {
                _this8.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
                _this8.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
                _this8.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
                _this8.form2.companyname = res.data.supplier.TITLE;
              }
            }).catch(function (err) {
              console.log(err);
            });
          }
        }).catch(function (err) {
          console.log(err);
        });
      }, 1000);
    },
    validatecvr: function validatecvr() {
      var _this9 = this;

      var datacvr = this.form2.cvr;
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/checkCvr/' + datacvr, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data.error) {
            _this9.showcvr = true;
            _this9.cvrerror = 'CVR ' + res.data.error;
            _this9.statusstep = 'signup_not_active_step1';
            _this9.updateleadintegration();
            _this9.loading = false;
          } else {
            if (res.data.enddate !== null) {
              var datenow = new Date();
              var cvrdate = new Date(res.data.enddate);
              if (datenow.getTime() > cvrdate.getTime()) {
                _this9.showcvr = true;
                _this9.cvrerror = 'CVR er inaktivt';
                _this9.statusstep = 'signup_not_active_step1';
                _this9.updateleadintegration();
                _this9.loading = false;
                return false;
              }
            }
            _this9.showcvr = false;
            _this9.cvrerror = '';
            var data = {
              UF_CRM_COMPANY_ZIP_CODE: _this9.form2.postnum,
              UF_CRM_COMPANY_ADDRESS: _this9.form2.address,
              UF_CRM_COMPANY_CITY: _this9.form2.city,
              UF_CRM_COMPANY_CVR: _this9.form2.cvr,
              UF_CRM_COMPANY_SKIP_PAYMENT_REMINDER: 1,
              PHONE: _this9.form2.telefonnummer,
              EMAIL: _this9.form2.email,
              TITLE: _this9.form2.companyname
            };
            _this9.$http.post('https://bitrixapi.haandvaerker.dk/v1/supplier/updateSupplier/' + _this9.levid, data, { emulateJSON: true }).then(function (response) {
              if (response) {
                _this9.nextstep();
                _this9.loading = false;
                _this9.addprofiletoreepay();
                _this9.statusstep = 'ready_for_payment_step2';
                _this9.updateleadintegration();
              }
            }).catch(function (err) {
              console.log(err);
            });
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      return true;
    },
    formatpris: function formatpris(no) {
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      });
      var tempno = formatter.format(no);
      return tempno;
    },
    tracking: function tracking() {
      var data = {
        site: 'Newpartner',
        message: 'Aktiver',
        user_id: this.form2.cvr.toString(),
        action_context: this.$route.fullPath,
        type: 'web ',
        version: '1'
      };
      this.$http.post('https://tracking.haandvaerker.dk/api/log', { body: data }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    tracking2: function tracking2() {
      var data = {
        site: window.location.href,
        message: 'Click Aktiver',
        user_id: this.form2.cvr,
        action_type: 'Click Aktiver',
        action_context: this.$route.fullPath,
        type: 'web',
        version: '1'
      };
      var headers = {
        'Content-Type': 'application/json'
      };
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        headers: headers,
        data: data,
        url: 'https://tracking.haandvaerker.dk/api/log'
      }).then(function (response) {});
    },
    addprofiletoreepay: function addprofiletoreepay() {
      var data = {
        partnerId: this.levid,
        company: this.form2.companyname,
        name: this.form2.fullname,
        address: this.form2.address,
        address2: '',
        city: this.form2.city,
        zipcode: this.form2.postnum
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/reepay/addCustomer/', data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    addnotifocationbar: function addnotifocationbar() {
      document.getElementById('reminderbar').classList.remove('hide');
    },
    updateinfo: function updateinfo() {
      var error = 0;
      this.$refs['step4formcontact'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.loading = true;
      this.validatecvr();
    },
    updateleadintegration: function updateleadintegration() {
      var data = {
        stage: this.statusstep,
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateleadintegrationfinal: function updateleadintegrationfinal() {
      var _this10 = this;

      var data = {
        shortUrlActivated: this.urlactivated,
        paymentMethod: this.paymenthod,
        paymentUpdated: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.updateprofilepayment = false;
          _this10.showpopupsuccess();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    onlineSignupIntegration: function onlineSignupIntegration() {
      var _this11 = this;

      var data = {
        cvr: this.cvrid,
        source: this.originalmainpage,
        type: this.originalsubpage
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupIntegration', data, { emulateJSON: true }).then(function (response) {
        if (response.data.success) {
          _this11.blockid = response.data.data.ID;
          _this11.getsupplieriblockinfo(_this11.blockid);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepayment: function updateprofilepayment() {
      var _this12 = this;

      this.updateprofilepayment = true;
      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmation', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this12.updateprofilepaymenttrial();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this12.updateprofilepaymenttrial();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepaymenttrial: function updateprofilepaymenttrial() {
      var _this13 = this;

      var data = {
        partnerId: this.levid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmTrial', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this13.updateleadintegrationfinal();
        } else {
          if (res.message === 'Kundematch api error!') {
            _this13.updateleadintegrationfinal();
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    gettotaljobs: function gettotaljobs() {
      var _this14 = this;

      this.loadingjobs = true;

      var data = { operation: 'openjob_partner', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this14.SearchItem = res.openjob;
        _this14.loadingjobs = false;
        _this14.jobstotal = res.openjob.length;
        if (_this14.jobstotal === 0) {
          _this14.jobstotal = 457;
        }
        _this14.checkleveranpartner();
      }, function (response) {
        console.log('error', response);
      });
    },
    gettotaljobsbitrix: function gettotaljobsbitrix() {
      var _this15 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getRelatedJob/' + this.levid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this15.jobstotal = res.data.totaljob;
          if (_this15.jobstotal === 0) {
            _this15.jobstotal = 457;
          }
        }
      }, function (response) {
        console.log('error', response);
      });
    },
    getsupplieriblockinfo: function getsupplieriblockinfo(id) {
      var _this16 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this16.levid = res.data.supplier.VALUE_ID;
          localStorage.setItem('levid', res.data.supplier.VALUE_ID);
          var newtel = res.data.supplier.MOBILE.substring(res.data.supplier.MOBILE.length - 8);
          _this16.isused = res.data.spa.SHORT_URL_ACTIVATED;
          if (_this16.isused === 1) {
            _this16.showpopupexpired();
            _this16.loading = false;
            return false;
          }
          _this16.loadingjobs = true;
          _this16.form2.telefonnummer = parseInt(newtel);
          _this16.form2.companyname = res.data.supplier.TITLE;
          _this16.form2.mobilenummber = res.data.supplier.UF_CRM_COMPANY_MOBILE_NUMBER;
          _this16.form2.email = res.data.supplier.EMAIL;
          _this16.form2.fullname = res.data.supplier.UF_CRM_COMPANY_CONTACT_PERSON;
          _this16.form2.city = res.data.supplier.UF_CRM_COMPANY_CITY;
          _this16.form2.postnum = parseInt(res.data.supplier.UF_CRM_COMPANY_ZIP_CODE);
          _this16.form2.address = res.data.supplier.UF_CRM_COMPANY_ADDRESS;
          _this16.form2.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this16.cvr = parseInt(res.data.supplier.UF_CRM_COMPANY_CVR);
          _this16.shorturl = res.data.token.shorturl;
          _this16.salesPerson = res.data.token.token;
          _this16.gettotaljobs();
          localStorage.setItem('id_token_portal', res.data.token.token);

          _this16.loading = false;
          _this16.isvalidcvr = res.data.spa.IS_VALID_CVR;
          if (_this16.isvalidcvr === '') {
            _this16.showcvr = true;
            _this16.cvrerror = res.data.spa.VALID_CVR_REASON;
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    decode: function decode() {
      var _this17 = this;

      this.loading = true;
      this.loadingjobs = true;
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data === '') {
            _this17.showpopuperror();
          }
          _this17.cvrid = res.data;
          if (_this17.cvrid !== '') {
            _this17.onlineSignupIntegration();
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"signuppage"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center sm-hide ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center header-fixed app-header ",attrs:{"id":"mainbarstatus"}},[(_vm.step === 1)?_c('div',{staticClass:"sm-hide",staticStyle:{"width":"340px"}}):_vm._e(),_vm._v(" "),(_vm.step === 1)?_c('div',{staticClass:"lg-col-8 md-col-8 sm-col-12 p0 flex flex-row mr-auto items-center mobile-flex-column white justify-between"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex h5 semi-bold m0 lg-col-8 md-col-8 sm-col-12 mmx-auto justify-end mpt1"},[_c('p',{staticClass:"flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold",staticStyle:{"padding-right":"5px"}},[_vm._v("Bud tilgængelige:")]),_c('span',{staticClass:"primarycolor"},[_vm._v(_vm._s(_vm.jobstotalstatic))])]),_vm._v(" "),_c('p',{staticClass:"ml1 flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mx1"},[_vm._v("Min Plan:")]),_vm._v(" "),(_vm.step === 1)?_c('button',{staticClass:"p1 px2 action-button sm-hide ",on:{"click":function($event){return _vm.nextstep()}}},[_vm._v("Aktiver din prøveversion nu")]):_vm._e(),_vm._v(" "),(_vm.showMobile && _vm.step === 1)?_c('span',{staticClass:"red m0",staticStyle:{"font-size":".89rem"}},[_vm._v("Din konto er ikke aktiveret")]):_vm._e(),_vm._v(" "),(_vm.showMobile && _vm.step > 1)?_c('span',{staticClass:"primarycolor"},[_vm._v("Gratis")]):_vm._e()])])]):_vm._e(),_vm._v(" "),(_vm.step !== 1)?_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 p0 flex flex-row mx-auto items-center mobile-flex-column white justify-between",staticStyle:{"max-width":"920px"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex h5 semi-bold m0 lg-col-6 md-col-6 sm-col-12 mmx-auto justify-end mpt1"},[_c('p',{staticClass:"flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mr1"},[_vm._v("Bud tilgængelige:")]),_c('span',{staticClass:"primarycolor"},[_vm._v(_vm._s(_vm.jobstotalstatic))])]),_vm._v(" "),_vm._m(3)])]):_vm._e()]),_vm._v(" "),_vm._m(4),_vm._v(" "),(_vm.step !== 4)?_c('div',{staticClass:"lg-hide md-hide col-12 buttonsticky pointer white-background",attrs:{"id":"button"}},[(_vm.step === 1)?_c('button',{staticClass:"action-button p2 not-rounded m0 col-12 ",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(5)]):_vm._e(),_vm._v(" "),(_vm.step === 2)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"action-button p2 not-rounded m0 mb1  col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateinfo()}}},[_vm._m(6)]),_vm._v(" "),_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(7)])]):_vm._e(),_vm._v(" "),(_vm.step === 3)?_c('div',{staticClass:"col-12 flex flex-column p1 mx-auto"},[_c('button',{staticClass:"outlined-primary-button p2 not-rounded m0 col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_vm._m(8)])]):_vm._e()]):_vm._e(),_vm._v(" "),_c('div',{attrs:{"id":"marketplace2"}},[_c('div',{staticClass:"sidebar"},[_c('div'),_vm._v(" "),_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold capitalletter",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(9)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(10),_vm._v(" "),_c('ul',{staticClass:"nav-dropdown-items"},[_vm._m(11),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/sent"},on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(12)])])]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(13),_vm._v(" "),_vm._m(14)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(15)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(16),_vm._v(" "),_vm._m(17)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(18),_vm._v(" "),_vm._m(19)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(20),_vm._v(" "),_vm._m(21)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(22),_vm._v(" "),_vm._m(23)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular hide",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(24)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold nav-dropdown-toggle",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(25)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(26)]),_vm._v(" "),_c('li',{staticClass:"nav-item nav-dropdown active",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(27),_vm._v(" "),_vm._m(28)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(29)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(30)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(31)]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular pt3",on:{"click":function($event){return _vm.nextstep()}}},[_vm._m(32)])])]),_vm._v(" "),_c('div')]),_vm._v(" "),_c('main',{staticClass:"main p2"},[_c('div',{staticClass:"col-12  p0 "},[_vm._m(33),_vm._v(" "),_c('p',{staticClass:"lg-col-10 md-col-11 h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap items-center"},[(_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h4 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M53 311c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C63 315.4 58.5 311 53 311z"}}),_c('path',{attrs:{"d":"M495.3 344.1c-10.3-7.2-23.4-9-35.2-4.7 -0.1 0-0.2 0.1-0.3 0.1l-94.4 37.1c0.3-1.8 0.4-3.7 0.4-5.6 0-22-17.9-40-40-40h-64.7c-1.7 0-3.4-0.4-4.9-1.3l-52.8-29.7c-10.4-5.9-22.3-9-34.3-9h-66.1v-10c0-5.5-4.5-10-10-10H10c-5.5 0-10 4.5-10 10v179.9c0 5.5 4.5 10 10 10H92.9c5.5 0 10-4.5 10-10v-10h7.5l95.3 38.6c18.7 7.5 38.3 11.4 58.4 11.4 22.4 0 44.1-4.7 64.5-14 0.1 0 0.1 0 0.2-0.1l158.9-75.6c14.5-6 23.9-19.9 23.9-35.6C511.7 363.1 505.5 351.3 495.3 344.1zM82.9 450.9h-63V291h63V450.9zM480 392.8c-0.2 0.1-0.4 0.2-0.6 0.3L320.4 468.7c-17.7 8.1-36.6 12.2-56.1 12.2 -17.5 0-34.7-3.3-50.9-9.9l-97.1-39.3c-1.2-0.5-2.5-0.7-3.7-0.7h-9.5V311h66.1c8.6 0 17 2.2 24.5 6.4l52.8 29.7c4.5 2.5 9.6 3.9 14.7 3.9h64.7c11 0 20 9 20 20 0 6.9-3.6 13.4-9.5 17l-0.1 0c-0.8 0.3-1.4 0.7-2.1 1.1 -2.6 1.2-5.4 1.8-8.3 1.8H224.2c-16.5 0-30 13.4-30 30 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10 0-5.5 4.5-10 10-10h101.6c6.7 0 13.3-1.7 19.1-4.9l122.1-47.9c5.7-2 11.9-1.2 16.8 2.3 5 3.5 7.9 9 7.9 15.2C491.7 383.2 487.1 390 480 392.8z"}}),_c('path',{attrs:{"d":"M53 350.9c-5.5 0-10 4.5-10 10V420.9c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10v-60C63 355.4 58.5 350.9 53 350.9z"}}),_c('path',{attrs:{"d":"M501.2 113.3c0 0-0.1-0.1-0.1-0.1L382.9 18.1c-11.1-9.2-27.2-9.2-38.3 0.1L226.5 114.1c0 0-0.1 0.1-0.1 0.1 -6.1 5.2-9.9 12.4-10.6 20.4 -0.7 8 1.8 15.7 6.9 21.9 5.7 6.8 14.1 10.7 23 10.7 2.8 0 5.6-0.4 8.2-1.2v135c0 5.5 4.5 10 10 10h70 60 70c5.5 0 10-4.5 10-10V165.1c11.1 3.2 23.5-0.2 31.4-9.6C515.6 142.8 513.9 123.9 501.2 113.3zM383.8 291h-40v-79.9h40V291zM453.7 291h-50v-89.9c0-5.5-4.5-10-10-10h-60c-5.5 0-10 4.5-10 10v89.9h-50V152.9l90-72.8 89.9 72V291zM489.7 142.8c-3.5 4.2-9.8 4.8-14.1 1.3 0 0-0.1-0.1-0.1-0.1L370.1 59.4c-3.7-2.9-8.9-2.9-12.5 0l-105.4 85.2c-0.1 0-0.1 0.1-0.2 0.1 -1.8 1.5-4 2.3-6.4 2.3 -3 0-5.8-1.3-7.7-3.6 -1.7-2.1-2.5-4.6-2.3-7.3 0.2-2.6 1.5-5 3.5-6.7l118.1-95.9c0 0 0.1-0.1 0.1-0.1 3.7-3.1 9.1-3.1 12.8 0 0 0 0.1 0.1 0.1 0.1l118.2 95.1C492.7 132.3 493.2 138.5 489.7 142.8z"}}),_c('path',{attrs:{"d":"M363.8 111.1c-16.5 0-30 13.4-30 30s13.4 30 30 30 30-13.4 30-30S380.3 111.1 363.8 111.1zM363.8 151.1c-5.5 0-10-4.5-10-10s4.5-10 10-10c5.5 0 10 4.5 10 10S369.3 151.1 363.8 151.1z"}})])]),_vm._v(" "),_c('span',[_vm._v("\n                Se opgaver\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"sm-hide outlined-standard-button gibson p2 px3 h5 not-rounded flex justify-center items-center line-height-1 my2 mr1",staticStyle:{"width":"435px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"40","width":"40","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),_c('span',[_vm._v("\n                Se ledige arbejdskraft\n              ")])]):_vm._e(),_vm._v(" "),(!_vm.job)?_c('button',{staticClass:"darkblue-background p2 px3 h5 not-rounded flex justify-center white items-center line-height-1 my2 mr1",staticStyle:{"width":"435px","height":"77px","border":"0px solid"},on:{"click":function($event){return _vm.nextstep()}}},[_c('span',[_vm._v("\n                Antal reservationer: 0 ud af 3\n              ")])]):_vm._e()])]),_vm._v(" "),(_vm.loadingjobs)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(34)]):_c('div',[(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-start"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"overflow":"hidden","cursor":"pointer!important","width":"300px"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"none","width":"100%"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block px2 flex items-center",staticStyle:{"height":"51px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingzip)+"\n                  ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                    "+_vm._s(item.mailingcity)+"\n                  ")])]),_vm._v(" "),(item.gratis1 === '1')?[_vm._m(35,true)]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center",staticStyle:{"height":"41px"}},[_c('span',[_vm._v(_vm._s(item.producttitle))])]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h6 darkblue regular line-height-2 mb1",staticStyle:{"height":"60px"}},[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(item.comment_to_partner,80, '...'))+"\n                  ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative",staticStyle:{"top":"7px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()])],2)])])}),0)]):_c('div',[_c('div',{staticClass:"flex flex-wrap items-center justify-center"},_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.key,staticClass:"clearfix muted-border border shadow mb3 px0",staticStyle:{"height":"140px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.nextstep()}}},[_c('div',{staticClass:"col col-4 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"min-height":"100%","object-fit":"none"},attrs:{"data-key":item.appid + 'd',"alt":"","src":item.image,"loading":"lazy"}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('span',{staticClass:"mintgreen-background p1 line-height-1 block flex items-center",staticStyle:{"height":"41px"}},[(item.mailingzip !== 0 && item.mailingzip !== '' && item.mailingzip !== '0' )?_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingzip)+"\n                    ")]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"h6 m0 p0 white semi-bold block"},[_vm._v("\n                      "+_vm._s(item.mailingcity)+"\n                    ")])])]),_vm._v(" "),(item.gratis1 === '1')?_c('div',{staticClass:"absolute bottom-0 right-0 left-0 hide"},[_vm._m(36,true)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-8 px2 pr0"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-2 pt2 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.producttitle))]),_vm._v(" "),(item.reserved === 1)?_c('span',{staticClass:"red"},[_vm._v("Reserved")]):_vm._e()]),_vm._v(" "),[(item.reserved !== 1)?_c('p',{staticClass:"h5 darkblue regular line-height-2 mb1"},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.comment_to_partner,50, '...'))+"\n                    ")]):_vm._e()],_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson semi-bold m0 line-height-1"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),(item.henttilbud !== 1)?_c('span',[_vm._v(_vm._s(_vm.moment(item.appointment_date).locale('da').format('LL')))]):_vm._e(),_vm._v(" "),(item.henttilbud === 1)?_c('span',[_vm._v("Ring og aftal møde-dato")]):_vm._e()]),_vm._v(" "),(item.mester === '1')?_c('span',{staticClass:"block flex self-end h6 semi-bold  mintgreen pt1 line-height-1"},[_vm._v("Mester-til-Mester")]):_vm._e()],2)])])}),0)])])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"confirmcvr",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"confirmcvr","no-close-on-backdrop":true}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson pt1 ",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_c('span',[_c('i',{staticClass:"el-icon-close h5 "})])])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',{staticClass:"col-12 p0 mmb5"},[_c('div',{staticClass:"flex justify-around lg-col-4 md-col-4 sm-col-12 mx-auto items-center mt1"},[_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"49.036","height":"56.623","viewBox":"0 0 49.036 56.623"}},[_c('path',{attrs:{"id":"Indtast_Info","data-name":"Indtast Info","d":"M30.637,53.466a10.929,10.929,0,0,1-1.054-1.221H6.424A6.431,6.431,0,0,1,0,45.821V6.424A6.431,6.431,0,0,1,6.424,0H26.141a1.5,1.5,0,0,1,.969.372l.007,0,.014.013.052.05L41.957,15.213c.023.023.046.048.068.073a1.505,1.505,0,0,1,.371.969V35.887a10.781,10.781,0,1,1-11.759,17.58Zm-.157-7.621a7.778,7.778,0,1,0,7.779-7.779A7.787,7.787,0,0,0,30.479,45.845ZM3,6.424v39.4a3.428,3.428,0,0,0,3.424,3.424h21.6A10.785,10.785,0,0,1,38.258,35.067a10.964,10.964,0,0,1,1.139.059V17.773H26.123a1.5,1.5,0,0,1-1.5-1.5V3H6.424A3.428,3.428,0,0,0,3,6.424Zm24.623,8.349h9.652L27.623,5.121Zm9.135,34.782V47.345H34.547a1.5,1.5,0,1,1,0-3h2.211V42.133a1.5,1.5,0,1,1,3,0v2.211h2.211a1.5,1.5,0,1,1,0,3H39.757v2.211a1.5,1.5,0,1,1-3,0ZM11.5,39.882a1.5,1.5,0,1,1,0-3h15a1.5,1.5,0,1,1,0,3Zm0-10a1.5,1.5,0,1,1,0-3h20a1.5,1.5,0,1,1,0,3Zm-.151-9.646a1.5,1.5,0,1,1,0-3h4.925a1.5,1.5,0,0,1,0,3Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Indtast info")])]),_vm._v(" "),_c('span',{},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"9.382","height":"16.409","viewBox":"0 0 9.382 16.409"}},[_c('path',{attrs:{"id":"Icon_ionic-ios-arrow-forward","data-name":"Icon ionic-ios-arrow-forward","d":"M17.8,14.4l-6.209-6.2a1.168,1.168,0,0,1,0-1.656,1.182,1.182,0,0,1,1.661,0l7.035,7.03a1.17,1.17,0,0,1,.034,1.617l-7.064,7.079A1.173,1.173,0,1,1,11.6,20.607Z","transform":"translate(-11.246 -6.196)","fill":"#23a3c0"}})])]),_vm._v(" "),_c('span',{staticClass:"flex flex-column items-center"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"56.623","height":"56.623","viewBox":"0 0 56.623 56.623"}},[_c('path',{attrs:{"id":"Activer","d":"M0,28.312A28.311,28.311,0,1,1,28.312,56.623,28.312,28.312,0,0,1,0,28.312ZM18.452,51.653a25.3,25.3,0,0,0,26.31-4.078v-4.45a7.6,7.6,0,0,0-7.59-7.59H19.014a7.59,7.59,0,0,0-7.59,7.59v4.067A25.2,25.2,0,0,0,18.452,51.653Zm18.72-19.1a10.583,10.583,0,0,1,10.57,10.57v1.439A25.333,25.333,0,1,0,4.97,18.452,25.31,25.31,0,0,0,8.443,44.03v-.9a10.571,10.571,0,0,1,10.57-10.57ZM17.523,15.887A10.57,10.57,0,1,1,28.093,26.457,10.582,10.582,0,0,1,17.523,15.887Zm2.98,0a7.59,7.59,0,1,0,7.59-7.59A7.6,7.6,0,0,0,20.5,15.887Z","fill":"#19a3c0"}})]),_vm._v(" "),_c('p',[_vm._v("Aktiver")])])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 mx-auto flex flex-column p1 mx3 mt1 mb2 darkblue"},[_c('div',{staticClass:"center mb1 mt2"},[_c('p',{staticClass:"h4  semi-bold"},[_vm._v("Prøv 30 dage gratis")])]),_vm._v(" "),_c('div',{staticClass:"lg-col-10 md-col-10 sm-col-12 mx-auto center mt1 mb2"},[_c('p',{staticClass:"h6 line-height-golden"},[_vm._v("& Få 3 gratis opgaver ved oprettelse")])]),_vm._v(" "),_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.form2,"rules":_vm.rulesform2,"label-position":"top"}},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"m0 p0  mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"CVR","prop":"cvr"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","placeholder":"12345678"},on:{"keyup":function($event){return _vm.validatecvrinput()}},model:{value:(_vm.form2.cvr),callback:function ($$v) {_vm.$set(_vm.form2, "cvr", _vm._n($$v))},expression:"form2.cvr"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"E-mail"},model:{value:(_vm.form2.email),callback:function ($$v) {_vm.$set(_vm.form2, "email", $$v)},expression:"form2.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"Telefonnummer","prop":"telefonnummer"}},[_c('el-input',{ref:"phone",staticClass:"border wizard-border white-background",attrs:{"maxlength":"8","oninput":"onlyNumber('phone')","id":"phone","placeholder":"Mobilnr.(8 cifre)"},model:{value:(_vm.form2.telefonnummer),callback:function ($$v) {_vm.$set(_vm.form2, "telefonnummer", _vm._n($$v))},expression:"form2.telefonnummer"}})],1)],1),_vm._v(" "),(_vm.showcvr)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":_vm.cvrerror,"type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fulde Navn","prop":"fullname"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Hans Hansen"},model:{value:(_vm.form2.fullname),callback:function ($$v) {_vm.$set(_vm.form2, "fullname", $$v)},expression:"form2.fullname"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"center p0 col-12"},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover  p2 px3 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){_vm.updateinfo(), _vm.tracking2()}}},[_vm._v("Aktiver "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"payments",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"payments","no-close-on-backdrop":true},on:{"show":function($event){return _vm.limitleverantext()}}},[(_vm.loadingnewpayment)?_c('div',{staticClass:"clearfix col-12 flex justify-center item-center"},[_c('div',{staticClass:"col-12 flex flex-column justify-center item-center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold center"},[_vm._v("Få tilgængelig dato og tid")])])]):_c('div',[_c('div',{staticClass:"p2 flex justify-center mmt4"},[_c('div',{staticClass:"subitems mt4 relative flex flex-column item-between height-full py4 px1 relative",staticStyle:{"width":"390px","box-shadow":"0px 0px 20px #19A3C04D"},attrs:{"id":"subitemitem1"}},[_c('div',{staticClass:" absolute top-0 left-0 bottom-0 right-0 mb1 primarycolor-background relative ",attrs:{"id":"subicons"}},[_c('svg',{staticClass:"absolute",staticStyle:{"top":"20%","left":"25%"},attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"60","viewBox":"0 0 128.416 110.912"}},[_c('path',{attrs:{"id":"Freemium","d":"M55.035,110.912a1.529,1.529,0,1,1,0-3.057H61.1v-1.529H48.92a1.529,1.529,0,0,1,0-3.058H79.5a1.529,1.529,0,0,1,0,3.058H67.311v1.529h6.834a1.529,1.529,0,0,1,0,3.057Zm28.928-4.586a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm-45.862,0a1.534,1.534,0,0,1,0-3.058h6.35a1.534,1.534,0,0,1,0,3.058Zm77.106-6.115h-102a1.542,1.542,0,1,1,0-3.058h47.2a18.384,18.384,0,0,1-.816-6.211,3.058,3.058,0,0,1,3.056-2.961h3.041a3.079,3.079,0,0,1,3.057,3,16.872,16.872,0,0,1-.929,6.169h47.395a1.542,1.542,0,1,1,0,3.058Zm-51.54-3.382h0a1.527,1.527,0,0,0,.5.324c.685-.272,1.625-2.633,1.52-6.089v-.025H62.645C62.56,93.719,63.1,96.289,63.668,96.829Zm61.689,1.853a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,125.357,98.683Zm-5.351,1.529a1.529,1.529,0,0,1,0-3.058H122.3a1.529,1.529,0,0,1,0,3.058Zm-113.892,0a1.529,1.529,0,0,1,0-3.058H8.408a1.529,1.529,0,0,1,0,3.058ZM0,98.683a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,0,98.683ZM68.532,84.924H59.879a4.561,4.561,0,0,1-4.554-3.969c-.049-.4-.1-.867-.165-1.381H51.284a3.08,3.08,0,0,1-3.122-2.8L45.134,63.087a1.529,1.529,0,0,1,2.23-1.67l6.291,3.461c-.713-8.326-1.23-17.6-.68-23.241.257-2.627,1.812-9.432,2.036-10.405a9.4,9.4,0,0,1,18.395-.014c.224.964,1.775,7.695,2.031,10.294.558,5.665.037,15-.68,23.368l6.294-3.463a1.528,1.528,0,0,1,2.23,1.67L80.253,76.77a3.08,3.08,0,0,1-3.122,2.8H73.252c-.061.514-.117.978-.166,1.381a4.56,4.56,0,0,1-4.522,3.97ZM56.017,41.935c-.987,10.109,1.656,33,2.343,38.65a1.5,1.5,0,0,0,1.519,1.281h8.653a1.5,1.5,0,0,0,1.518-1.281c.689-5.665,3.341-28.635,2.343-38.772-.154-1.569-.882-5.037-1.41-7.432a17.191,17.191,0,0,1-6.776,1.241,17.2,17.2,0,0,1-6.769-1.238C56.91,36.807,56.174,40.341,56.017,41.935ZM74.426,68.553c-.281,2.965-.57,5.7-.823,7.963h3.528A.185.185,0,0,0,77.2,76.5a1.5,1.5,0,0,1,.035-.259l2.327-10.518ZM51.177,76.242a1.575,1.575,0,0,1,.034.26.188.188,0,0,0,.073.013h3.524c-.253-2.267-.542-5-.823-7.964L48.85,65.725ZM58.145,31.3c.69.5,2.759,1.264,6.063,1.264s5.378-.77,6.066-1.266a6.313,6.313,0,0,0-6.064-4.467h-.027A6.314,6.314,0,0,0,58.145,31.3Zm4.493,45.216V63.521a1.528,1.528,0,0,1,1.528-1.529h0a1.529,1.529,0,0,1,1.529,1.529l0,12.994a1.529,1.529,0,1,1-3.058,0ZM58.092,51.673V46.322a6.115,6.115,0,0,1,12.23,0v5.351a6.115,6.115,0,1,1-12.23,0Zm3.058-5.351v5.351a3.058,3.058,0,1,0,6.115,0V46.322a3.058,3.058,0,0,0-6.115,0Zm58.325,4.2A1.529,1.529,0,1,1,121,52.056,1.529,1.529,0,0,1,119.476,50.527Zm.764,0a.765.765,0,1,0,.764-.765A.765.765,0,0,0,120.24,50.527ZM6.516,50.86,7.652,49.4v-.023l-1.77.226v-.813l1.759.227v-.023L6.516,47.536l.73-.419.742,1.663h.024l.73-1.674.718.407L8.323,49.007v.023l1.805-.239V49.6l-1.805-.215v.024l1.148,1.435-.754.431L8,49.6H7.975L7.2,51.291Zm82.722-6.327a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,89.238,44.533Zm.764,0a.764.764,0,1,0,.764-.765A.764.764,0,0,0,90,44.533ZM34.4,34.381a2.293,2.293,0,1,1,2.293,2.294A2.293,2.293,0,0,1,34.4,34.381Zm1.147,0a1.146,1.146,0,1,0,1.146-1.146A1.146,1.146,0,0,0,35.544,34.381Zm79.625-.422,1.114-1.431V32.5l-1.736.222v-.8l1.725.224v-.024l-1.1-1.432.716-.41.727,1.63h.023l.715-1.642.7.4L116.94,32.14v.023l1.771-.235v.8l-1.771-.211v.023l1.125,1.408-.739.422-.7-1.643H116.6l-.763,1.655ZM85.61,19.187a1.529,1.529,0,1,1,1.529,1.529A1.529,1.529,0,0,1,85.61,19.187Zm.765,0a.764.764,0,1,0,.764-.764A.764.764,0,0,0,86.375,19.187Zm-76.2-1.529A1.529,1.529,0,1,1,11.7,19.187,1.529,1.529,0,0,1,10.17,17.659Zm.764,0a.764.764,0,1,0,.764-.764A.766.766,0,0,0,10.934,17.659ZM111.49,9.253l.962-1.234V8l-1.5.192V7.5l1.487.193V7.675L111.49,6.44l.618-.354.627,1.406h.021l.617-1.416.607.344-.961,1.264v.021l1.527-.2v.688l-1.527-.182v.02l.971,1.215-.638.365-.607-1.417h-.02l-.658,1.427ZM59.07,2.162l.654-.84V1.308l-1.02.131V.971l1.013.131V1.088L59.07.248l.42-.241.427.957h.014L60.351,0l.413.234-.654.861v.014L61.15.971v.468l-1.039-.124v.014l.661.826-.434.248-.413-.964h-.013l-.449.971Z","fill":"#fff"}})])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"col-12 center bold h6 my2"},[_vm._v("PRØVEPAKKE")]),_vm._v(" "),_c('p',{staticClass:"col-12 center bold h2 my2"},[_c('span',{staticClass:"primarycolor"},[_vm._v("GRATIS*")])])]),_vm._v(" "),_c('div',{staticClass:"col-10 mx-auto"},[_c('ul',{staticClass:"list-sub-text list-image-check-mintgreen pb1 pr2 mb3"},[_c('li',{staticClass:" light line-height-4 mt0 pb1 ml1"},[_vm._v("Byd på 3 opgaver")]),_vm._v(" "),_c('li',{staticClass:" light line-height-4 mt0 pb1 mb2 ml1"},[_vm._v("Gratis adgang i 30 dage")]),_vm._v(" "),_c('div',{staticClass:"center col-12"},[_c('button',{staticClass:"action-button p2 px3 round",attrs:{"type":"button"},on:{"click":function($event){return _vm.goto()}}},[_vm._v("Vælg")])])])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"lg-col-12 md-col-12 sm-col-12 mx-auto mx3"},[_c('div',{staticClass:"col-12 center pb2 flex flex-column darkblue lightgrey-background"},[_c('p',{staticClass:"h4 semi-bold my1 col-12 flex justify-start py2 px0"},[_vm._v("Kurv")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold my1 col-12 flex justify-start p0"},[_vm._v("Plan valgt: GRATIS")]),_vm._v(" "),_c('p',{staticClass:" h3 semi-bold darkblue center my2 col-12 flex justify-start p0"},[_vm._v("At betale nu: "),_c('span',{staticClass:"primarycolor pl2"},[_vm._v(" 0.- kr")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-start",staticStyle:{"max-width":"920px"}},[_c('p',{staticClass:"semi-bold mt1 mb0",staticStyle:{"font-size":"12px"}},[_vm._v("Pris per måned:*")]),_vm._v(" "),_c('p',{staticClass:"pb1 h6 line-height-golden flex justify-start italic p0",staticStyle:{"font-size":"12px"},attrs:{"id":"leverantext"}},[_vm._v(_vm._s(_vm.leverantext))]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showmore"},on:{"click":function($event){return _vm.limitleverantext(1)}}},[_c('span',[_vm._v("Læs mere")])]),_vm._v(" "),_c('div',{staticClass:"primarycolor",attrs:{"id":"showless"},on:{"click":function($event){return _vm.limitleverantext(2)}}},[_c('span',[_vm._v("Vis mindre")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 pb2 flex flex-column darkblue lightgrey-background mt2"},[_c('p',{staticClass:"semi-bold h4 dawkblue col-12 flex justify-start mt2 px0"},[_vm._v("Vælg betalingsform")]),_vm._v(" "),_c('p',{staticClass:"h6 initial mb2"},[_vm._v("Dette er for at bekræfte din konto. Du bliver ikke opkrævet i din 30 dages prøveperiode.")]),_vm._v(" "),[_c('div',[_c('el-select',{staticClass:" col-12 px0 white-background border-none darkblue semi-bold not-rounded",attrs:{"placeholder":"Vælg"},on:{"change":function($event){return _vm.checkboxselect()}},model:{value:(_vm.selectedpayment),callback:function ($$v) {_vm.selectedpayment=$$v},expression:"selectedpayment"}},_vm._l((_vm.paymentoption),function(items){return _c('el-option',{key:items.value,attrs:{"label":items.text,"value":items.value}})}),1)],1),_vm._v(" "),(_vm.selectedpayment === 'leve')?_c('div',{staticClass:"col-lg-12 col-md-12 col-sm-12 p0 mx-auto mt2",attrs:{"id":"leveran"}},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"col-12 p0"},[(_vm.levandorupdate !== '')?_c('b-alert',{staticClass:"my2",attrs:{"show":"","variant":"success"}},[_c('h5',{staticClass:"alert-heading"},[_vm._v("Tak! Din konto hos Leverandørservice er nu integreret med Håndværker.dk.\n                            ")]),_vm._v(" "),_c('p')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:" col-12 flex flex-wrap mt2 p0"},[_c('el-form',{ref:"step4formcontact2",staticClass:"tui-f lg-col-12 sm-col-12 sm-col-12 mx-auto",attrs:{"model":_vm.form,"rules":_vm.rulesform,"label-position":"top"}},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Reg. nr.","prop":"regnr"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"maxlength":"4","placeholder":"4 cifre"},model:{value:(_vm.form.regnr),callback:function ($$v) {_vm.$set(_vm.form, "regnr", $$v)},expression:"form.regnr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none el-form-opgavetype flex mobile-flex-column",attrs:{"label":"Konto nr.","prop":"bankkonto"}},[_c('el-input',{staticClass:"border wizard-border white-background col-12 p0",attrs:{"minimum":"6","maxlength":"10","placeholder":"6-10 cifre"},model:{value:(_vm.form.bankkonto),callback:function ($$v) {_vm.$set(_vm.form, "bankkonto", $$v)},expression:"form.bankkonto"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none center el-form-item__plain el-form-item__checkbox",attrs:{"id":"accepterms"}},[_c('el-checkbox',{staticClass:"el-checkbox flex justify-start md-col-10 lg-col-10 sm-col-12 pl1 mp0 ml-auto",attrs:{"label":"","id":"consentleverancheckbox"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentleveran),callback:function ($$v) {_vm.consentleveran=$$v},expression:"consentleveran"}},[_c('span',{staticClass:"second-secondary "},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplinklever()}}},[_vm._v(" LeverandørService")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement.")])])]),_vm._v(" "),(_vm.showerrorleveranerror)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Indtast venligst nummer","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0"},[_c('button',{staticClass:"action-button not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"773px"},attrs:{"type":"button","id":"leverrsub"},on:{"click":_vm.service_levendor}},[_c('span',{staticClass:"semi-bold h5 m0"},[_vm._v("Start"),_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py-2",attrs:{"id":"moreid"}})],1)])]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'reep')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'mobpay')?_c('div',{staticClass:"col-12 flex justify-center",attrs:{"id":"mobilepay"}},[(_vm.disablemobilepaybutton)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):_c('a',{staticClass:"action-button no-underline not-rounded ml-auto flex col-lg-10 col-md-10 col-sm-12 p1 justify-center items-center",staticStyle:{"max-width":"700px"},attrs:{"type":"button","href":_vm.mobilepaylink}},[_c('span',{staticClass:"white semi-bold h5 m0"},[_vm._v("Start")])])]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'googlepay')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e(),_vm._v(" "),(_vm.selectedpayment === 'applepay')?_c('div',{staticClass:"col-lg-12 col-md-12 p0 col-sm-12 mx-auto",attrs:{"id":"reepay","accordion":"my-accordion","role":"tabpanel"}},[_c('div',{staticClass:"col-lg-8 col-md-8 col-sm-12 mx-auto p0 ",staticStyle:{"height":"500px"},attrs:{"id":"rp_container"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 my1"},[_c('b-form-group',{staticClass:"flex flex-row justify-center",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{staticClass:"el-checkbox",attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.changecolor()}},model:{value:(_vm.consentreepay),callback:function ($$v) {_vm.consentreepay=$$v},expression:"consentreepay"}},[_c('span',{staticClass:"second-secondary2"},[_vm._v("Jeg acceptere betingelser for "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopuplink()}}},[_vm._v("Kreditkort")]),_vm._v(" og "),_c('span',{staticClass:"p0",staticStyle:{"color":"#3498db"},on:{"click":function($event){return _vm.showpopupcontract()}}},[_vm._v("abonnement")])])])],1),_vm._v(" "),(_vm.showerrorreepay)?_c('el-alert',{staticClass:"line-height-1 col-12 mx-auto",attrs:{"title":"Accepter venligst vilkår og betingelser","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1)]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"hide",attrs:{"id":"lastitem"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","type":"button","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","disabled":"true"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center "},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h4 darkblue pt1 mx-auto center"},[_vm._v("TILLYKKE! Så er din prøveperiode aktiveret! \n                Nu mangler du blot at opdatere din virksomhedsprofil, så vi kan låse op for opgaverne på markedspladsen\n                ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Din plan er nu aktiv, og du kan begynde at byde på ledige opgaver, så snart du har opdateret din virksomhedsprofil. Vi har også sendt dig en e-mail med bekræftelse på din konto-aktivering.")]),_vm._v(" "),_c('a',{staticClass:"center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":_vm.shorturl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Opdateret virksomhedsprofil")])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mx-auto center line-height-4"},[_vm._v("Bemærk, at såfremt du har valgt en “gratis” plan til 0 kr., har du 30 dage til at opsige denne, hvis du ikke ønsker at din plan automatisk skal opgraderes til en “Vækst” plan til 3.299,- pr. måned ex. moms, med en binding på løbende måned + 3 måneder, fra den dato “Vækst” planen træder i kraft."),_c('br'),_c('br'),_vm._v("\n                I prøveperiode opsiger du ved at sende en e-mail til "),_c('a',{attrs:{"target":"_blank","href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")]),_vm._v(" Planen bliver trukket automatisk via din valgte betalingsmetode. Du kan læse mere om vores handelsbetingelser "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk/om/betingelser?ref=bm","target":"_blank"}},[_vm._v("her.")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"flex justify-center items-center "},[_c('div',{staticClass:"flex flex-column py2"},[_c('span',{staticClass:"mr1 center"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white center"},[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('p',{staticClass:"center white",staticStyle:{"font-size":"13px"}},[_vm._v("Ved evt. spørgsmål til din aktiveringsproces er du altid velkommen til at kontakte os på mail "),_c('a',{attrs:{"target":"_blank","href":"mailto:https://info.haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")])])])])])]),_vm._v(" "),_c('b-modal',{ref:"popupcontract",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popupcontract"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopupcontract()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px","zoom":".5"},attrs:{"src":'https://www.kundematch.dk/s/otheraftale_new.php?bitrixid=' + this.levid + '&mode=ssl',"frameborder":"0","zoom":"0.9","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplink",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplink"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplink()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":"https://reepay.com/terms-of-service/","frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"popuplinklever",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"popuplinklever"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background  "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepopuplinklever()}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","height":"95%","overflow":"auto"}},[_c('vue-pdf-app',{attrs:{"pdf":"/static/pdf/Generelle_regler_for-kreditorer_i_LeverandørService_v_1.0_14.09.2019.pdf"}})],1)]),_vm._v(" "),_c('b-modal',{ref:"expiredurl",attrs:{"centered":"","hide-header":"","id":"expiredurl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Dit link er allerede brugt.")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("Du har en e-mail med login og password, så du kan logge ind nu.")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v(" Bekræft")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx1"},[_c('span',{staticClass:" darkblue mb0 bold h4 my1"},[_vm._v("Aktivering")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mx1"},[_c('span',{staticClass:" darkblue mb0 bold h4 my1"},[_vm._v("Aktivering")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"ml1 flex items-center m0"},[_c('span',{staticClass:" darkblue mb0 h6 semi-bold mx1"},[_vm._v("Min Plan:")]),_vm._v(" "),_c('span',{staticClass:"primarycolor"},[_vm._v("Gratis")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger not-rounded m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"darkblue h6 p1 m0 center"},[_vm._v("Du mangler at aktivere din gratis bruger for at modtage dine 3 gratis bud.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Aktiver din prøveversion nu "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold white m0"},[_vm._v("Næste "),_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 semi-bold primarycolor m0"},[_c('i',{staticClass:"el-icon-back"}),_vm._v(" Tilbage")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-house ml1 darkblue "}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Forside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropBeskeder"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Beskeder")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"messages/inbox"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Inbox\n                                        ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sendt\n                                        ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropAnbefalinger"}},[_c('i',{staticClass:"el-icon-star-off mr2 darkblue"}),_vm._v("\n                            Anbefalinger")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"indhent-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Indhent anbefalinger\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"laes-og-besvar-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Læs og besvar\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"auto-anbefalinger"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Sæt anbefalinger på Auto-pilot\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 mr2 regular",attrs:{"id":"widgets"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Widgets\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-files mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Mine kunder\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropDine projekter"}},[_c('i',{staticClass:"el-icon-picture-outline mr2 darkblue"}),_vm._v("\n                            Dine projekter")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"opret-projekt-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opret projekt\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"status-haandvaerker-new"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Mine projekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/approved-projects"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Åbne kundeprojekter\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"customer-projects/project-dashboard"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Vundne kundeprojekter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-money mr2 darkblue"}),_vm._v(" \n                        Markedsplads")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 semi-bold hide",attrs:{"id":"udbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Udbud ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"id":"dropMester-til-Mester"}},[_c('i',{staticClass:"el-icon-share mr2 darkblue"}),_vm._v("\n                            Mester-til-Mester")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-arbejdskraft"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Arbejdskraft\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"mester-opgaver"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button","href":"#/mester-opgaver"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Opgaver\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-document mr2 darkblue"}),_vm._v("\n                            Opret tilbud")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/tilbud-historie"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Tilbudshistorie\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/standardTilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Standard Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/hurtigt-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Hurtigt Tilbud\n                                        ")])])])]),_vm._v(" "),_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"tilbud/upload-tilbud"}},[_c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Upload Tilbud\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Inviter en kollega\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-monitor mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Gratis hjemmeside\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Medlemsfordele\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-link nav-dropdown-toggle"},[_c('i',{staticClass:"el-icon-shopping-cart-2 mr2 darkblue"}),_vm._v("\n                            Webshop")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav-dropdown-items"},[_c('li',{staticClass:"nav-item darkblue gibson h5 regular",attrs:{"id":"webshop/products"}},[_c('div',[_c('p',{staticClass:" nav-link",attrs:{"type":"button"}},[_c('i',{}),_vm._v(" "),_c('span',{staticClass:"plpointtwo inline-block "},[_vm._v("Alle produkter\n                                        ")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-present mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:"inline-block "},[_vm._v("Digital pakke\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-setting mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Indstillinger\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-question mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Ofte stillede spørgsmål\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:" nav-link m0",attrs:{"type":"button"}},[_c('i',{staticClass:"el-icon-back mr2 darkblue"}),_vm._v(" "),_c('span',{staticClass:" inline-block "},[_vm._v("Log ud\n                                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Markedsplads\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background p1 line-height-1 block px2"},[_c('span',{staticClass:"h6 m0 p0 mintgreen semi-bold block"},[_vm._v("\n                      Gratis møde\n                    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"white-background mintgreen gibson line-height-1 h6 mb0 p1 pb2"},[_c('span',{staticClass:"block hide"},[_vm._v("Gratis møde  ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobilepay_vue__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dce014_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_mobilepay_vue__ = __webpack_require__(1107);
function injectStyle (ssrContext) {
  __webpack_require__(1105)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mobilepay_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34dce014_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_mobilepay_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1105 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mobilepay',
  components: {},
  watch: {},
  data: function data() {
    return {
      loadingpage: false,
      showMobile: '',
      fullurl: '',
      originalid: '',
      originalsubpage: '',
      mobilepayanswer: '',
      originalprevurl: '',
      pid: '',
      storedlevid: '',
      urlactivated: '',
      paymenthod: '',
      paymenthodupdate: '',
      shorturl: '',
      prevurl: ''
    };
  },
  created: function created() {
    localStorage.removeItem('yourid');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.fullurl = window.location.href;
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    this.originalid = localStorage.getItem('yourid');
    this.storedlevid = this.$route.query.levid;
    this.originalprevurl = localStorage.getItem('yourfulllink');
    this.originalsubpage = pathArray[pathArray.length - 2];
    this.mobilepayanswer = pathArray[pathArray.length - 3];
    this.pid = pathArray[pathArray.length - 1].split('?')[0];
    if (this.pid === '1') {
      this.confirmmobilepay();
    }
  },

  mounted: {},
  methods: {
    confirmmobilepay: function confirmmobilepay() {
      this.loadingpage = true;
      this.urlactivated = 1;
      this.paymenthod = 'mobilepay';
      this.paymenthodupdate = 1;
      this.updateprofilepayment();
    },
    updateprofilepayment: function updateprofilepayment() {
      var _this = this;

      var data = {
        partnerId: this.storedlevid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmation', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.updateprofilepaymenttrial();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateprofilepaymenttrial: function updateprofilepaymenttrial() {
      var _this2 = this;

      var data = {
        partnerId: this.storedlevid
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/onlineSignupConfirmTrial', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.updateleadintegrationfinal();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateleadintegrationfinal: function updateleadintegrationfinal() {
      var _this3 = this;

      this.blockid = this.$route.query.blockid;
      var data = {
        shortUrlActivated: this.urlactivated,
        UF_CRM_COMPANY_PAYMENTS_METHOD: this.paymenthod,
        UF_CRM_COMPANY_PAYMENT_METHOD_UPDATED: this.paymenthodupdate
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/bitrix/updateLeadIntegrationSpa/' + this.blockid, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.getsupplieriblockinfo();
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getsupplieriblockinfo: function getsupplieriblockinfo(id) {
      var _this4 = this;

      this.blockid = this.$route.query.blockid;
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/getOnlineSignupInfo/' + this.blockid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.shorturl = res.data.token.shorturl;
          _this4.loadingpage = false;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"mobilepay"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center sm-hide ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 mx-auto"},[(_vm.loadingpage)?_c('div',{staticClass:"clearfix mx-auto mt4"},[_vm._m(1)]):_c('div',[(_vm.pid === '1' && _vm.originalsubpage === 'accepted')?_c('div',{staticClass:"highlights p3 mt4 mx-auto"},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"92.257","height":"92.263","viewBox":"0 0 92.257 92.263"}},[_c('path',{attrs:{"id":"Path_26","data-name":"Path 26","d":"M-2903.584-1369.776a46.074,46.074,0,0,1-14.273-2.83,46.09,46.09,0,0,1-12.686-7.13,46.042,46.042,0,0,1-10.026-11.033,46.017,46.017,0,0,1-5.99-13.653,46.062,46.062,0,0,1-1.342-14.489,46.076,46.076,0,0,1,3.233-14.188,46.009,46.009,0,0,1,7.73-12.748,46,46,0,0,1,11.389-9.621,46.068,46.068,0,0,1,13.511-5.4,46.107,46.107,0,0,1,14.521-.932,46.023,46.023,0,0,1,14.419,3.791,2,2,0,0,1,1.012,2.641,2,2,0,0,1-2.641,1.013,42.375,42.375,0,0,0-49.171,11.11,42.376,42.376,0,0,0-3.317,50.3,42.377,42.377,0,0,0,47.287,17.47,42.376,42.376,0,0,0,30.183-40.375v-4.058a2,2,0,0,1,2-2,2,2,0,0,1,2,2v4.059a46.034,46.034,0,0,1-2.414,14.713,46.085,46.085,0,0,1-6.769,12.882,46.065,46.065,0,0,1-10.439,10.137,45.994,45.994,0,0,1-13.427,6.478,46.025,46.025,0,0,1-13.073,1.9Q-2902.723-1369.743-2903.584-1369.776Zm.3-35.79-13.238-13.238a2,2,0,0,1,0-2.829,2,2,0,0,1,2.829,0l11.823,11.823,42.714-42.756a2,2,0,0,1,2.829,0,2,2,0,0,1,0,2.829l-44.128,44.172a2,2,0,0,1-1.415.587A2,2,0,0,1-2903.286-1405.566Z","transform":"translate(2948 1462.006)","fill":"#8fde5e"}})])]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("TAK FOR AT ACCEPTERE MOBILPAY")]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("TILLYKKE! DU KAN NU SE OG LÅSE OPGAVERNE OP.")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Din plan er nu aktiv, og du kan begynde at byde på ledige opgaver. Vi har også sendt dig en e-mail med bekræftelse på din konto aktivering. ")]),_vm._v(" "),_c('a',{staticClass:"center no-underline my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":_vm.shorturl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Gå til Marketplace")])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._m(3)])])]):_vm._e(),_vm._v(" "),(_vm.pid === '0' && _vm.originalsubpage === 'accepted')?_c('div',{staticClass:"highlights p3 mt4 mx-auto"},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_vm._m(4),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto center"},[_vm._v("Du accepteret ikke MOBILPAY")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue py1 mx-auto center"},[_vm._v("Klik her for at gå tilbage til betalingsmulighederne. ")]),_vm._v(" "),_c('a',{staticClass:"center my2 col-lg-6 col-md-6 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",attrs:{"type":"button","href":_vm.originalprevurl}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Tilbage")])])]),_vm._v(" "),_vm._m(5)])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h6 darkblue py1 mx-auto center line-height-4"},[_vm._v("Bemærk, at såfremt du har valgt en “gratis” plan til 0 kr., har du 14 dage til at opsige denne, hvis du ikke ønsker at din plan automatisk skal opgraderes til en Basis-Plus plan til kr. 795,- pr. måned ex moms med binding løbende måned + èn måned fra den dato Basis-Plus planen træder i kraft."),_c('br'),_c('br'),_vm._v("\n                              Du opsiger ved at sende en e-mail til "),_c('a',{attrs:{"target":"_blank","href":"mailto:info@haandvaerker.dk"}},[_vm._v("info@haandvaerker.dk.")]),_vm._v(" Planen bliver trukket automatisk via leverandører-/ betalingsservice og vi sender altid en mail til dig, inden vi trækker pengene. Du kan læse mere om vores handelsbetingelser "),_c('a',{attrs:{"href":"https://www.haandvaerker.dk/om/betingelser?ref=bm","target":"_blank"}},[_vm._v("her.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex justify-center flex-column items-center"},[_c('p',{staticClass:"darkblue h5 semi-bold my2"},[_vm._v("Rigtig god budgivning!")]),_vm._v(" "),_c('p',{staticClass:"darkblue h5 semi-bold"},[_vm._v("De bedste hilsner,")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1108 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callme_vue__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d51b7fd0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_callme_vue__ = __webpack_require__(1111);
function injectStyle (ssrContext) {
  __webpack_require__(1109)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-d51b7fd0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_callme_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d51b7fd0_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_callme_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1109 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'package',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a
  },
  data: function data() {
    return {
      cvr: ''
    };
  },
  created: function created() {
    var pathArray = window.location.href.split('/');
    localStorage.setItem('yourid', pathArray[pathArray.length - 1]);
    this.cvr = pathArray[pathArray.length - 1];
    this.decode();
  },
  mounted: function mounted() {},

  watch: {},
  methods: {
    showpopuperror: function showpopuperror() {
      this.$refs['incorrecturl'].show();
    },
    closepopuperror: function closepopuperror() {
      this.$refs['incorrecturl'].hide();
    },
    showpopupexpired: function showpopupexpired() {
      this.$refs['expiredurl'].show();
    },
    showpopup: function showpopup() {
      this.$refs['packageorder'].show();
    },
    closepopup: function closepopup() {
      this.$refs['packageorder'].hide();
    },
    showmodal: function showmodal() {
      this.$refs.paymentmethods.show();
    },
    showmodalinitial: function showmodalinitial() {
      this.$refs.initialreminder.show();
    },
    hidemodal: function hidemodal() {
      this.$refs.paymentmethods.hide();
    },
    hidemodalinitial: function hidemodalinitial() {
      this.updateprofileskip();
      this.$refs.initialreminder.hide();
    },
    hidemodalsuccess: function hidemodalsuccess() {
      this.$refs.sendingsuccess.hide();
    },
    decode: function decode() {
      var _this = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/bitrix/callCs?cvr=' + this.cvr, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {} else {
          _this.showpopuperror();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"packagemain"}},[_c('div',{staticClass:"col-12 flex justify-center items-center hide alert alert-danger m0 p0",attrs:{"id":"reminderbar"}},[_c('p',{staticClass:"m0"},[_vm._v("Vi kunne ikke behandle din sidste betaling.")]),_c('p',{staticClass:"semi-bold m0 pointer",on:{"click":function($event){return _vm.showmodalinitial()}}},[_vm._v(" Opdater din betaling")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center highlightsmorelesser",staticStyle:{"height":"64px"},attrs:{"id":"main2bar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex flex-wrap mx-auto "},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:" flex  flex-auto justify-end  items-center ",staticStyle:{"height":"inherit"}},[_c('div',{staticClass:" flex flex-auto justify-end justify-center-mobile items-center truspilotmobile",staticStyle:{"height":"inherit"}},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"290px","alt":"Håndværker.dk logo","height":"23px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])])])]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{attrs:{"id":"footer"}},[_c('div',{staticClass:"darkblue-background flex flex-column items-center justify-center",attrs:{"id":"footer1"}},[_c('p',{staticClass:"white h5 "},[_vm._v("Forbind med os")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center my2"},[_c('a',{attrs:{"target":"_new","href":"https://www.facebook.com/haandvaerkerdk?ref=pm"}},[_c('span',{staticClass:"lazyload mr2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32","role":"img","aria-label":"icon-facebook","viewBox":"0 0 1024 1024"}},[_c('title',[_vm._v("Facebook")]),_c('path',{attrs:{"d":"M1024 512C1024 229.2 794.8 0 512 0S0 229.2 0 512c0 255.6 187.2 467.4 432 505.8V660H302V512h130V399.2C432 270.9 508.4 200 625.4 200c56 0 114.6 10 114.6 10v126h-64.6c-63.6 0-83.4 39.5-83.4 80v96h142l-22.7 148H592v357.8C836.8 979.4 1024 767.6 1024 512z","fill":"#1877F2"}}),_c('path',{attrs:{"d":"M711.3 660L734 512H592v-96c0-40.5 19.8-80 83.4-80H740V210c0 0-58.6-10-114.6-10 -117 0-193.4 70.9-193.4 199.2V512H302v148h130v357.8c26.1 4.1 52.8 6.2 80 6.2s53.9-2.1 80-6.2V660H711.3z","fill":"#FFF","role":"img","aria-label":"Facebook"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.linkedin.com/company/h%C3%A5ndv%C3%A6rker-dk?ref=pm","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{staticStyle:{"enable-background":"new 0 0 455.731 455.731"},attrs:{"role":"img","xmlns":"http://www.w3.org/2000/svg","width":"32","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 455.731 455.731","xml:space":"preserve","aria-label":"Linkedin"}},[_c('g',[_c('rect',{staticStyle:{"fill":"#0084B1"},attrs:{"x":"0","y":"0","width":"455.731","height":"455.731"}}),_vm._v(" "),_c('g',[_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M107.255,69.215c20.873,0.017,38.088,17.257,38.043,38.234c-0.05,21.965-18.278,38.52-38.3,38.043    c-20.308,0.411-38.155-16.551-38.151-38.188C68.847,86.319,86.129,69.199,107.255,69.215z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M129.431,386.471H84.71c-5.804,0-10.509-4.705-10.509-10.509V185.18    c0-5.804,4.705-10.509,10.509-10.509h44.721c5.804,0,10.509,4.705,10.509,10.509v190.783    C139.939,381.766,135.235,386.471,129.431,386.471z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#FFFFFF"},attrs:{"d":"M386.884,241.682c0-39.996-32.423-72.42-72.42-72.42h-11.47c-21.882,0-41.214,10.918-52.842,27.606    c-1.268,1.819-2.442,3.708-3.52,5.658c-0.373-0.056-0.594-0.085-0.599-0.075v-23.418c0-2.409-1.953-4.363-4.363-4.363h-55.795    c-2.409,0-4.363,1.953-4.363,4.363V382.11c0,2.409,1.952,4.362,4.361,4.363l57.011,0.014c2.41,0.001,4.364-1.953,4.364-4.363    V264.801c0-20.28,16.175-37.119,36.454-37.348c10.352-0.117,19.737,4.031,26.501,10.799c6.675,6.671,10.802,15.895,10.802,26.079    v117.808c0,2.409,1.953,4.362,4.361,4.363l57.152,0.014c2.41,0.001,4.364-1.953,4.364-4.363V241.682z"}})])]),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g'),_c('g')])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://trustpilot.com/review/h%C3%A5ndv%C3%A6rker.dk?ref=pm","title":"Trustpilot - Haandvaerker.dk","name":"Trustpilot - Haandvaerker.dk","rel":"nofollow","target":"_new"}},[_c('span',{staticClass:"lazyload mx2",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"aria-label":"Trustpilot","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","version":"1.1","id":"Layer_1","x":"0px","y":"0px","width":"32px","height":"32px","viewBox":"0 0 128 128","enable-background":"new 0 0 128 128","xml:space":"preserve"}},[_c('image',{attrs:{"id":"image0","width":"128","height":"128","x":"0","y":"0","href":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAQAAABpN6lAAAAABGdBTUEAALGPC/xhBQAAACBjSFJN AAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElN RQflCRUMGBqW6X0KAAAFXElEQVR42u2dW2gcZRiG32+bRu2BaG3UegiNtJQ2bSlGoSJqKRKJCEpB LdKClL2wBAR71wtBBL1QkrsSD6VgS6QKifWQ2oYk0CohbaOxkS3BUMSY1poES0ysJDb7epGwbrKH 7Gbm+782+78Qsjs7M/t8z/7/zOz8s7uC6bACUVShDMuwsDOGfrTgoMSm7goAsBh12IuINZvDxFGP fTIBCMBifIPt1kQGaUe1TEQA1BVk+cB21AHCCvQUVONPThybI4gWbPlABFFhDBusOQxzQTi64Hd8 2TImpDWDbQq3/3sBXoAX4AV4AV6AF+AFWANYxwuwBrCOF2ANYB0vwBrAOl6ANYB1vABrAOt4AdYA 1rEX8GNhC/gHewtbwAnpRF8hC2ic/jOL7dDYBO6SET6Mc3YIti2gVUYA6UJ/oQpomvW/wARM4ovp W4ZbAUsBp2R4+lYHrhSigMTrLnEcKzwBnFG0WSew2w12yGNJNorwB1ZYYNi1gBmvuVxPbBALRkDT HPcdxaoL/CCVMyfwFgxhuXsQqxaQstGTcXxtAXLDCIDRnsCmC8RkY+pELsEwbnONYtMC0m7w5BpO uEexEdCY53TFWHSBi7Im/QMswSCK3cJYtICMr7OMoM01jIWAbIc8zjuB+y4wgDLJ+JxciStY5BLH fQtokizKZRin3OIEawENOJ5pvRmX+U5+zbZKbsHGjA9mWusebJt3DQySOGvpeKudwl/Cz4KUEEwA SXZxTfAy5l3+o/wlGH5wAeQod5kUH+F+/hsUPgwBJPkxHX/0iqvYGgZ4WALIn/mQw/Kf4WA42OEJ IMf5OiV4cXMWX8xaxsOCDlMASTazVLn8tfw+TOCwBZCXqfhRbO7maLi44QsgJ/k2ixSKX84j4cNq CCDJDq4OufxK9mmAagkgr/KF0IoX7uO4DqaeAJL8kCGc42Mpj+shar8dvoCd8lOg8p/CEdyjB6j9 dngDznLe14GxiO+gRbN8VydEPscr8lfe5ZfjE2zVRnMjYBKrZCjP8l/CByjRR3NzRuh0fuVzCT/C URflAwoHLGmS16lObsZRrHfCBTctgPlcAMManHFXvpsW0CmXcix+BQ7hOXfFuxKQYwfgE2jA/ckT 0IMINinTqR4JTqU8B4pFfJPXE0v08X2+yJUAn9WG098NdsucZ4r4ABrwOIBLaEc72uS3xCPq143o d4E5OwCfx3voQQ3apXf2YzLOZuxcwAJ4K/bgDNZJPMvyqgK0twGxrM+9nj0kT/LuLPMs5TVNQO3j gCwjwYyiC5sAVOE8n840l/yNk6qEyi1gS4ZnLeGnM+aL810uzjDvLk1AXQEXM5S0Ne2A1lk+mEHW hB6ibhdIswFkhPvxLVanmfsRdPPl1MkyglZFRtUWkPJuPocBrUNcmrJUVA9RU8DA7HEiVuc0oNU7 e8vB0qSjxJCj2QVmXAvCYtaiGbmMG61DJ19LniBDOK1GqdgCnkx6lrXsynPpL3ln0vI1WpB6AgaZ uNhpngNaA9yWWMO94Q2HzoxeFzgmkwDAZTyMw/P64tb70Ma3pjTKZXTqYOoJaAQAVqIbuwPQvYFT LPt/fQpR6gBXuTi0Aa0/uQNg+c3VBb7C7WhGbShX/t6BRtbjd3RrgGoJGMF5VIe4vldxDr3BV5Ma /8XK1gDW8QKsAazjBVgDWMcLsAawjhdgDWAdL8AawDpegDWAdbwAawDreAHWANbxAqwBrOMFWANY xwvAmDWCacYill9oegOkP4IWawbTtPif3ZUY6q05zFIvMf/T24BMoBoHEA++xpsocRxA9fSPr0+F FYiiCmUL/leIx9CPFhyU6cu4/wM76BhE+f9iSAAAACV0RVh0ZGF0ZTpjcmVhdGUAMjAyMS0wOS0y MVQwOToyNDoyNiswMzowMFrxEEMAAAAldEVYdGRhdGU6bW9kaWZ5ADIwMjEtMDktMjFUMDk6MjQ6 MjYrMDM6MDArrKj/AAAAAElFTkSuQmCC"}})])])]),_vm._v(" "),_c('a',{attrs:{"href":"https://www.instagram.com/haandvaerker.dk?ref=pm","rel":"nofollow","title":"Instagram - Haandvaerker.dk","name":"Instagram - Haandvaerker.dk","id":"Instagram - Haandvaerker.dk","target":"_new"}},[_c('span',{staticClass:"mx2 lazyload",staticStyle:{"width":"32px","height":"32px"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Layer_1","data-name":"Layer 1","viewBox":"0 0 32.09 32.09","width":"32","height":"32"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{staticStyle:{"fill":"none"},attrs:{"width":"32.09","height":"32.09"}})])]),_vm._v(" "),_c('g',{staticStyle:{"clip-path":"url(#clip-path)"}},[_c('image',{attrs:{"width":"134","height":"133","transform":"translate(-0.05 -0.26) scale(0.24 0.25)","xlink:href":"data:image/png;base64,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"}})]),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M23.84,3H8.25A5.27,5.27,0,0,0,3,8.25V23.84A5.26,5.26,0,0,0,8.25,29.1H23.84a5.25,5.25,0,0,0,5.26-5.26V8.25A5.26,5.26,0,0,0,23.84,3ZM27,23.13A3.91,3.91,0,0,1,23.13,27H9a3.92,3.92,0,0,1-3.91-3.91V9A3.92,3.92,0,0,1,9,5.05H23.13A3.92,3.92,0,0,1,27,9Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M21.5,8.72a1.4,1.4,0,1,0,1.4-1.4h0A1.4,1.4,0,0,0,21.5,8.72Z"}}),_vm._v(" "),_c('path',{staticStyle:{"fill":"#fff"},attrs:{"d":"M16.11,9.75h-.06A6.27,6.27,0,0,0,9.75,16h0a6.3,6.3,0,1,0,6.36-6.23ZM16,20.39A4.34,4.34,0,0,1,11.7,16h0a4.33,4.33,0,0,1,4.35-4.3h0A4.35,4.35,0,0,1,16,20.39Z"}})])])])])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('b-modal',{ref:"incorrecturl",attrs:{"centered":"","hide-header":"","id":"incorrecturl","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('svg',{staticClass:"feather feather-alert-octagon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"70","height":"70","viewBox":"0 0 24 24","fill":"none","stroke":"#19A3C0","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('polygon',{attrs:{"points":"7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"12"}}),_c('line',{attrs:{"x1":"12","y1":"16","x2":"12.01","y2":"16"}})])]),_vm._v(" "),_c('p',{staticClass:"bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for besøget")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue py1 mt2 mx-auto"},[_vm._v("Der er noget galt med det link, du modtager")]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold my3 center"},[_vm._v("e-mail eller kontakt vores supportteam for at bekræfte det link, du modtager")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('a',{staticClass:"regular p2 action-button center white",attrs:{"href":"https://www.haandvaerker.dk","type":"button"}},[_vm._v(" bekræfte")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p2 darkblue-background flex flex-column items-center justify-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',{staticClass:"white pl2",staticStyle:{"font-size":"14px"}},[_vm._v("Alt det bedste")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center",attrs:{"id":"modalmainfooter"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"z2",attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Craftsmansss","width":"36","height":"36","alt":"Haandvaerker.dk Logo","viewBox":"0 0 40 40"}},[_c('defs',[_c('linearGradient',{attrs:{"id":"linear-gradientsss","x1":"0.5","x2":"0.5","y2":"1","gradientUnits":"objectBoundingBox"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#0494ba"}}),_vm._v(" "),_c('stop',{attrs:{"offset":"1","stop-color":"#64c7cb"}})],1)],1),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_806sss","data-name":"Rectangle 806sss","width":"40","height":"40","rx":"2","transform":"translate(0)","fill":"url(#linear-gradientsss)"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1022","data-name":"Path 1022","d":"M18.477,7.067,9.238,0,0,7.067V21.278H6.545V15.929h5.161v3.436h0v1.913h6.732V7.067ZM16.644,19.326H13.726V9.565L11.782,8.082v5.739h-5.2V8.16L4.638,9.643v9.682H1.833V8h0l6.508-5h0l.86-.664L16.606,8V19.326Z","transform":"translate(11.082 9.593)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v("Håndværker.dk")])])])]),_vm._v(" "),_c('b-modal',{ref:"sendingsuccess",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"sendingsuccess","no-close-on-backdrop":true}},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background  m2"},[_c('div',{staticClass:"flex flex-column gibson col-12"},[_c('p',{staticClass:"my2 darkblue mx-auto "},[_c('i',{staticClass:"el-icon-document-checked green",staticStyle:{"font-size":"4em"}})]),_vm._v(" "),_c('p',{staticClass:"semi-bold h3 darkblue pt1 mx-auto"},[_vm._v("Tak for din henvendelse,")]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue py1 mx-auto"},[_vm._v("Vi ringer til dig hurtigst muligt")]),_vm._v(" "),_c('button',{staticClass:" my2 col-lg-4 col-md-4 col-sm-12 button mx-auto darkblue-background white no-border not-rounded gibson flex justify-center items-center",on:{"click":function($event){return _vm.hidemodaltak('')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Luk")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-between items-center  mintgreen-background",staticStyle:{"height":"50px"},attrs:{"id":"mainbar"}},[_c('div',{staticClass:"lg-col-7 md-col-7 sm-col-12 flex mx-auto justify-end "},[_c('span',{staticClass:" darkblue mb0 h6"},[_vm._v("Ring 7022 8014")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justify-center-mobile"},[_c('p',{staticClass:"no-hover flex justify-start items-center"},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1  darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center p2 mb4 ",attrs:{"id":"formpackage"}},[_c('div',{attrs:{"id":"formwelcome"}},[_c('div',{staticClass:" darkblue semi-bold lg-col-8 md-col-8 sm-col-12 mx-auto px1 py3 mb2"},[_c('div',{staticClass:"flex flex-column "},[_c('span',{staticClass:"h1 col-12 center bold pt3 pb2",staticStyle:{"font-size":"5em"}},[_vm._v("Tak!")]),_vm._v(" "),_c('p',{staticClass:"mb2 h4 my2"},[_vm._v("Vi vil kontakte dig i dag, eller den næstekommende hverdag.")]),_vm._v(" "),_c('p',{staticClass:"h4 flex col-8 justify-center mx-auto regular mt3"},[_vm._v("Mvh,")]),_vm._v(" "),_c('div',{staticClass:"h4 darkblue semi-bold my3"},[_c('a',{staticClass:"no-underline pointer darkblue",attrs:{"href":"https://www.haandvaerker.dk"}},[_vm._v("Håndværker.dk")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dark-background  flex items-center justify-center",attrs:{"id":"footer2"}},[_c('p',{staticClass:"white h6",staticStyle:{"height":"14px"}},[_vm._v("Copyright @ 2022 "),_c('a',{attrs:{"target":"_blank","href":"https://www.haandvaerker.dk/"}},[_vm._v("Håndværker.dk")]),_vm._v(". Alle rettigheder forbeholdes.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unsubscribe_vue__ = __webpack_require__(1114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7fb99c2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_unsubscribe_vue__ = __webpack_require__(1115);
function injectStyle (ssrContext) {
  __webpack_require__(1113)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_unsubscribe_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f7fb99c2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_unsubscribe_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1113 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Invo',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a
  },
  data: function data() {
    return {
      pid: '',
      levid: '',
      pitems: [],
      status: '',
      spaId: ''
    };
  },
  created: function created() {
    var pathArray = window.location.href.split('/');
    if (pathArray[pathArray.length - 1] === 'ai_kanvas') {
      this.spaId = pathArray[pathArray.length - 2];
      this.unsubscribeAIcanvas(this.spaId);
    } else {
      this.pid = pathArray[pathArray.length - 1];
      if (this.pid !== null) {
        this.decode(this.pid);
      }
    }
  },

  methods: {
    decode: function decode() {
      var _this = this;

      this.$http.get(this.$bitrixapi + 'integration/decode/' + this.pid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.levid = parseInt(res.data);
          _this.unsubscribe();
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    unsubscribe: function unsubscribe() {
      var _this2 = this;

      var data = {
        id: this.levid
      };
      this.$http.post(this.$bitrixapi + 'integration/unSubscribeRequesterEmail', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    unsubscribeAIcanvas: function unsubscribeAIcanvas(id) {
      var _this3 = this;

      var data = {
        spaId: id
      };
      this.$http.post(this.$bitrixapi + 'external/unSubscribedKanvasEmail', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    }
  }
});

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn absolute top-0 right-0 bottom-0 left-0",attrs:{"id":"unsubcribemain"}},[_c('div',{staticClass:"col-12 flex justify-between items-center navbarsignup app-header navbar ",attrs:{"id":"mainbar"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center sm-hide ",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"332px","alt":"Håndværker.dk logo","height":"30px","viewBox":"0 0 1215.749 97"}},[_c('g',{attrs:{"id":"Group_4478","data-name":"Group 4478","transform":"translate(15699.891 5122)"}},[_c('g',{attrs:{"id":"Group_4476","data-name":"Group 4476","transform":"translate(0 -430)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4474","data-name":"Group 4474"}},[_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 125)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1237","data-name":"Path 1237","d":"M107.972,50.736V16.525h5.192v3.481a10.467,10.467,0,0,1,8.471-3.94,11.379,11.379,0,0,1,8.7,3.658,11.948,11.948,0,0,1,2.391,4.06,15.139,15.139,0,0,1,.835,5.078,13.674,13.674,0,0,1-3.258,9.213,10.969,10.969,0,0,1-3.8,2.741,12.361,12.361,0,0,1-4.974.995,9.706,9.706,0,0,1-8.166-3.857V50.736Zm5.192-21.925c0,4.975,2.994,8.318,7.451,8.318s7.451-3.343,7.451-8.318c0-4.945-2.994-8.267-7.451-8.267S113.164,23.866,113.164,28.811Zm80.147,9.761c-.862-1.9-.934-4.378-.934-6.752V21h-3.569V16.576h3.569V9.334h5.4v7.242h5.814V21h-5.814V31.718c0,1.966.04,3.33.579,4.313a2.277,2.277,0,0,0,2.282,1.1,5.728,5.728,0,0,0,2.383-.532l.335-.175.03.376.32,4.1-.163.071a11.108,11.108,0,0,1-4.538.838C196.16,41.811,194.3,40.752,193.311,38.572Zm-28.868-.3a11.9,11.9,0,0,1-2.778-4.061,14.12,14.12,0,0,1,0-10.483,12.051,12.051,0,0,1,2.777-4.081,13.843,13.843,0,0,1,18.586,0,12.08,12.08,0,0,1,2.772,4.081,14.132,14.132,0,0,1,0,10.483,11.933,11.933,0,0,1-2.773,4.061,13.971,13.971,0,0,1-18.584,0Zm1.66-9.463c0,4.9,3.147,8.318,7.654,8.318,4.478,0,7.6-3.42,7.6-8.318,0-4.867-3.127-8.267-7.6-8.267C169.25,20.544,166.1,23.944,166.1,28.811ZM93.81,38.572c-.861-1.9-.933-4.378-.933-6.752V21h-3.57V16.576h3.57V9.334h5.4v7.242h5.814V21H98.272V31.718c0,1.966.04,3.33.579,4.313a2.278,2.278,0,0,0,2.282,1.1,5.718,5.718,0,0,0,2.383-.532l.336-.175.03.376.32,4.1-.162.071a11.11,11.11,0,0,1-4.538.838C96.659,41.811,94.8,40.752,93.81,38.572ZM72.543,40.614A10.925,10.925,0,0,1,68.5,37.379l-.121-.157,2.651-3.228.2.2a10.549,10.549,0,0,0,6.959,3.39c1.32,0,4.391-.313,4.391-3.217,0-2.14-2.759-3-4.586-3.568-.256-.079-.5-.155-.7-.225A17.24,17.24,0,0,1,72.3,28.256a5.949,5.949,0,0,1-2.327-5,6.548,6.548,0,0,1,2.57-5.349,9.5,9.5,0,0,1,5.84-1.838c3.637,0,6.4,1.06,8.444,3.241l.137.146-2.325,3.43-.214-.222a8.654,8.654,0,0,0-5.94-2.524c-2.3,0-3.626,1.006-3.626,2.759,0,1.778,2.161,2.615,4.569,3.383l.005,0,.593.2c1.014.35,1.815.626,2.682.973A8.854,8.854,0,0,1,86.2,29.876a6.138,6.138,0,0,1,1.416,4.036,7.121,7.121,0,0,1-2.958,5.977,11.079,11.079,0,0,1-6.523,1.923A13,13,0,0,1,72.543,40.614Zm-27.51-1.8c-1.2-1.7-1.779-4.165-1.779-7.552V16.474H48.6V31.055a8.768,8.768,0,0,0,.862,4.326c.752,1.245,2.04,1.849,3.937,1.849,5.352,0,5.768-5.742,5.768-7.5V16.474h5.4V41.25H59.322l-.042-2.887a8.07,8.07,0,0,1-2.605,2.282,9.566,9.566,0,0,1-4.654,1.166C48.744,41.811,46.459,40.829,45.032,38.811ZM150.455,41.25V5.56H155.8V41.25Zm-12.087,0V16.525h5.4V41.25Zm-112,0V16.525h5.4l-.044,3.166a7,7,0,0,1,2.2-2.523,6.331,6.331,0,0,1,3.66-1.1,7.02,7.02,0,0,1,2.651.429l.16.071-.334,4.946h-.49l-.049-.022A6.26,6.26,0,0,0,36.975,21a4.4,4.4,0,0,0-4.15,2.624,12,12,0,0,0-1.057,5.287V41.25Zm-16.32,0V10.191H.107V5.56H25.393v4.631H15.5V41.25ZM137.6,8.819a3.255,3.255,0,0,1,3.463-3.259,3.5,3.5,0,0,1,2.442.923,3.187,3.187,0,0,1,.97,2.336,3.187,3.187,0,0,1-.97,2.335,3.5,3.5,0,0,1-2.442.923A3.255,3.255,0,0,1,137.6,8.819Z","transform":"translate(-14711.953 -5101.56)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4477","data-name":"Group 4477","transform":"translate(-159.845 -438.084)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M51.366,71.005l16.063-4.181L74.14,88.068ZM88.332,43.546H60.057L51.366,16.2,42.675,43.546H14.4L37.284,60.5,28.592,87.842l22.884-16.95L65.558,60.5l22.774-16.95Z","transform":"translate(-14655.487 -4700.116)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14600.373-4647.99l-1.854-6.479-14.272,10.563Z","transform":"translate(12.355 14.797)","fill":"#005128"}})]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1238","data-name":"Path 1238","d":"M227.2,92.86l-.274-.139V85.8l.742.412a23.592,23.592,0,0,0,11.359,3.312c4.265,0,7.5-1.135,9.6-3.375s3.187-5.7,3.187-10.257V73.417a15.111,15.111,0,0,1-23.206.953,16.611,16.611,0,0,1-3.168-5.794,24.543,24.543,0,0,1-1.048-7.415,29.054,29.054,0,0,1,1.125-8.38,18.9,18.9,0,0,1,3.4-6.526,14.712,14.712,0,0,1,5.408-4.2,17.147,17.147,0,0,1,7.055-1.4c4.5,0,8.006,1.648,10.434,4.9V41.5h6.765V75.118c0,13.488-6.555,20.327-19.484,20.327A26.1,26.1,0,0,1,227.2,92.86ZM234.219,50.2c-1.936,2.488-2.918,6.046-2.918,10.574,0,3.872.939,7,2.79,9.3a8.819,8.819,0,0,0,7.292,3.417,9.6,9.6,0,0,0,7.518-3.276,12.415,12.415,0,0,0,2.916-8.493V56.414a9.858,9.858,0,0,0-2.763-7,9.106,9.106,0,0,0-6.862-2.9A9.459,9.459,0,0,0,234.219,50.2ZM397.436,78.08a14.428,14.428,0,0,1-5.361-3.809,16.585,16.585,0,0,1-3.372-6.083,26.82,26.82,0,0,1-1.113-8.048,23.7,23.7,0,0,1,1.219-7.789,18.212,18.212,0,0,1,3.674-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.719,10.719,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,397.436,78.08Zm.574-28.805a12.581,12.581,0,0,0-3.289,6.78h18.346a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,398.011,49.275ZM349.369,74.331a16.727,16.727,0,0,1-3.14-5.882,25.9,25.9,0,0,1-1.038-7.6,27.356,27.356,0,0,1,1.148-8.192,18.707,18.707,0,0,1,3.468-6.438,15.16,15.16,0,0,1,5.426-4.17,16.874,16.874,0,0,1,6.946-1.388c4.571,0,8.074,1.635,10.434,4.867V24.2h6.765V78.5h-6.765V73.383c-2.761,3.956-6.8,5.961-12.016,5.961A13.981,13.981,0,0,1,349.369,74.331Zm5.646-24.148c-1.936,2.476-2.917,5.968-2.917,10.38,0,4.012.939,7.213,2.79,9.512a8.927,8.927,0,0,0,7.4,3.417,9.291,9.291,0,0,0,7.444-3.308,12.537,12.537,0,0,0,2.884-8.462V56.414a9.856,9.856,0,0,0-2.745-7.037,9.228,9.228,0,0,0-6.951-2.869A9.4,9.4,0,0,0,355.015,50.183ZM276.64,78.08a14.428,14.428,0,0,1-5.361-3.809,16.587,16.587,0,0,1-3.373-6.083,26.85,26.85,0,0,1-1.112-8.048,23.68,23.68,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.821,15.821,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.315,4.747a15.752,15.752,0,0,1,3,5.636,25.424,25.424,0,0,1,.989,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.721,10.721,0,0,0,8.145,3.113,17.278,17.278,0,0,0,10.87-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.437,18.437,0,0,1,276.64,78.08Zm.573-28.805a12.591,12.591,0,0,0-3.289,6.78h18.346a10.977,10.977,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,277.214,49.275ZM190.75,76.361a10.392,10.392,0,0,1-3.2-7.924c0-6.984,4.143-11.1,12.314-12.237l10.357-1.451c-.111-5.545-2.375-8.242-6.914-8.242a17.313,17.313,0,0,0-11.419,4.312l-.823.7V44.257l.231-.148a22.911,22.911,0,0,1,12.5-3.452c4.354,0,7.679,1.182,9.882,3.514s3.309,5.828,3.309,10.416V78.5h-6.765V73.863a12.423,12.423,0,0,1-10.714,5.481C195.811,79.344,192.864,78.34,190.75,76.361ZM202.111,61.48a13.7,13.7,0,0,0-5.829,1.9c-1.21.846-1.825,2.4-1.825,4.635a4.977,4.977,0,0,0,1.713,3.933,6.821,6.821,0,0,0,4.678,1.544,8.7,8.7,0,0,0,6.718-2.847,10.3,10.3,0,0,0,2.661-7.27V60.363Zm-129.2,16.6a14.425,14.425,0,0,1-5.36-3.809,16.574,16.574,0,0,1-3.373-6.083,26.849,26.849,0,0,1-1.113-8.048,23.679,23.679,0,0,1,1.219-7.789,18.2,18.2,0,0,1,3.673-6.24,15.819,15.819,0,0,1,12.2-5.456c4.843,0,8.65,1.6,11.316,4.747a15.751,15.751,0,0,1,3,5.636,25.425,25.425,0,0,1,.988,7.379v3.523h-25.4c.167,3.616,1.2,6.453,3.08,8.438a10.72,10.72,0,0,0,8.144,3.113,17.278,17.278,0,0,0,10.871-3.9l.809-.636v6.7l-.206.15c-3.236,2.349-7.558,3.541-12.845,3.541A18.445,18.445,0,0,1,72.909,78.08Zm.574-28.805a12.585,12.585,0,0,0-3.289,6.78H88.541a10.982,10.982,0,0,0-2.279-6.944,7.664,7.664,0,0,0-6.212-2.6A8.87,8.87,0,0,0,73.483,49.275ZM331.024,78.5V57.469c0-3.694-.671-6.487-2-8.3a6.738,6.738,0,0,0-5.872-2.66,8.528,8.528,0,0,0-6.777,3.081,11.619,11.619,0,0,0-2.707,7.88V78.5h-6.765v-37h6.765v5.011a13.343,13.343,0,0,1,11.453-5.854c4.076,0,7.246,1.345,9.422,4,2.151,2.623,3.242,6.438,3.242,11.339V78.5Zm-165.832,0v-37h6.765v5.67a12.108,12.108,0,0,1,3.081-4.059,9.106,9.106,0,0,1,5.982-2.244,9.781,9.781,0,0,1,3.635.53l.31.127V48.85l-.8-.617a6.615,6.615,0,0,0-4.055-1.057,6.831,6.831,0,0,0-5.763,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-16.664,0V57.328c0-3.863-.59-6.676-1.757-8.365-1.141-1.652-3.037-2.456-5.793-2.456a7.153,7.153,0,0,0-5.879,3.179,12.485,12.485,0,0,0-2.481,7.782V78.5h-6.765V56.625c0-6.808-2.515-10.118-7.691-10.118A7.055,7.055,0,0,0,112.3,49.5a12.729,12.729,0,0,0-2.356,7.973V78.5h-6.765v-37h6.765v4.713a12.57,12.57,0,0,1,10.821-5.557,10.958,10.958,0,0,1,6.733,2.156,10.8,10.8,0,0,1,3.568,4.606,13.171,13.171,0,0,1,11.847-6.763c4.1,0,7.23,1.3,9.3,3.85a12.8,12.8,0,0,1,2.322,4.765,25.308,25.308,0,0,1,.76,6.544V78.5Zm-108.035,0v-37h6.766v5.67a12.084,12.084,0,0,1,3.081-4.059,9.1,9.1,0,0,1,5.981-2.244,9.786,9.786,0,0,1,3.636.53l.31.127V48.85l-.8-.617a6.613,6.613,0,0,0-4.055-1.057,6.828,6.828,0,0,0-5.762,3.27c-1.583,2.224-2.386,5.32-2.386,9.2V78.5Zm-34.383,0V27.086H32.7V33.43H13.016V49.867H31.226v6.309H13.016V78.5Z","transform":"translate(-15706 -5134)"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-4 flex flex-auto m0 justify-end items-center lg-hide md-hide",staticStyle:{"height":"inherit"}},[_c('span',{staticClass:"flex items-center"},[_c('svg',{staticClass:" inline-block",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"100px","height":"40px","viewBox":"0 0 406 237.288"}},[_c('g',{attrs:{"id":"Fremragende_Mobile","data-name":"Fremragende Mobile","transform":"translate(15715 4255.242)"}},[_c('g',{attrs:{"id":"Group_4471","data-name":"Group 4471","transform":"translate(-477 94)"}},[_c('g',{attrs:{"id":"Group_4463","data-name":"Group 4463","transform":"translate(-70.087 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4466","data-name":"Group 4466","transform":"translate(95.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-2","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-2","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4464","data-name":"Group 4464","transform":"translate(12.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-3","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-3","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4465","data-name":"Group 4465","transform":"translate(178.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-4","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-4","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})]),_vm._v(" "),_c('g',{attrs:{"id":"Group_4467","data-name":"Group 4467","transform":"translate(261.913 538)"}},[_c('rect',{attrs:{"id":"Rectangle-path-5","data-name":"Rectangle-path","width":"74","height":"72","transform":"translate(-15167.913 -4817)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Shape-5","data-name":"Shape","d":"M39,52.676l10.691-2.783L54.16,64.032ZM63.606,34.4H44.788L39,16.2,33.218,34.4H14.4L29.63,45.682l-5.785,18.2L39.076,52.6l9.373-6.919L63.606,34.4Z","transform":"translate(-15170.4 -4821.2)","fill":"#fff"}})])]),_vm._v(" "),_c('path',{attrs:{"id":"Path_1239","data-name":"Path 1239","d":"M180.649,78.4l-.216-.109V72.83l.586.325a18.625,18.625,0,0,0,8.967,2.615c3.367,0,5.918-.9,7.58-2.664s2.516-4.5,2.516-8.1V63.055a11.929,11.929,0,0,1-18.32.752,13.114,13.114,0,0,1-2.5-4.574,19.375,19.375,0,0,1-.827-5.854,22.937,22.937,0,0,1,.888-6.615,14.922,14.922,0,0,1,2.684-5.152,11.615,11.615,0,0,1,4.269-3.317,13.537,13.537,0,0,1,5.57-1.1,9.693,9.693,0,0,1,8.237,3.87v-3.2h5.341V64.4c0,10.648-5.175,16.047-15.382,16.047A20.6,20.6,0,0,1,180.649,78.4Zm5.541-33.679c-1.528,1.965-2.3,4.773-2.3,8.348a11.423,11.423,0,0,0,2.2,7.343,6.962,6.962,0,0,0,5.756,2.7,7.577,7.577,0,0,0,5.935-2.586,9.8,9.8,0,0,0,2.3-6.705V49.632A7.782,7.782,0,0,0,197.9,44.1a7.189,7.189,0,0,0-5.417-2.292A7.467,7.467,0,0,0,186.19,44.726ZM315.042,66.736a11.391,11.391,0,0,1-4.232-3.007,13.093,13.093,0,0,1-2.662-4.8,21.173,21.173,0,0,1-.879-6.353,18.712,18.712,0,0,1,.962-6.149,14.377,14.377,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.434,12.434,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H312.79a10.066,10.066,0,0,0,2.431,6.661,8.462,8.462,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,315.042,66.736ZM315.5,44a9.932,9.932,0,0,0-2.6,5.352h14.484a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,315.5,44Zm-38.4,19.78a13.205,13.205,0,0,1-2.479-4.644,20.442,20.442,0,0,1-.819-6,21.6,21.6,0,0,1,.907-6.467,14.768,14.768,0,0,1,2.738-5.082,11.968,11.968,0,0,1,4.284-3.292,13.321,13.321,0,0,1,5.484-1.1,9.586,9.586,0,0,1,8.237,3.842V24.2h5.341V67.067h-5.341V63.028a10.891,10.891,0,0,1-9.486,4.706A11.037,11.037,0,0,1,277.1,63.776Zm4.457-19.064c-1.528,1.955-2.3,4.711-2.3,8.194a11.706,11.706,0,0,0,2.2,7.509,7.047,7.047,0,0,0,5.84,2.7,7.335,7.335,0,0,0,5.877-2.611,9.9,9.9,0,0,0,2.277-6.68V49.632a7.781,7.781,0,0,0-2.167-5.555,7.285,7.285,0,0,0-5.487-2.265A7.423,7.423,0,0,0,281.552,44.713ZM219.679,66.736a11.39,11.39,0,0,1-4.232-3.007,13.1,13.1,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.878-6.353,18.694,18.694,0,0,1,.962-6.149,14.364,14.364,0,0,1,2.9-4.926,12.49,12.49,0,0,1,9.633-4.307c3.823,0,6.829,1.26,8.932,3.747a12.435,12.435,0,0,1,2.366,4.449,20.071,20.071,0,0,1,.781,5.825V54H217.427a10.066,10.066,0,0,0,2.431,6.661,8.464,8.464,0,0,0,6.43,2.458,13.64,13.64,0,0,0,8.581-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.555,14.555,0,0,1,219.679,66.736ZM220.132,44a9.94,9.94,0,0,0-2.6,5.352h14.484a8.666,8.666,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,220.132,44ZM151.873,65.379a8.2,8.2,0,0,1-2.525-6.255c0-5.514,3.27-8.764,9.721-9.661l8.176-1.145c-.087-4.377-1.875-6.507-5.458-6.507a13.667,13.667,0,0,0-9.015,3.4l-.649.549v-5.73l.183-.117a18.087,18.087,0,0,1,9.87-2.725c3.437,0,6.062.933,7.8,2.774s2.613,4.6,2.613,8.223V67.067h-5.341V63.407a10.8,10.8,0,0,1-15.376,1.972Zm8.969-11.748a10.813,10.813,0,0,0-4.6,1.5c-.956.668-1.441,1.9-1.441,3.659a3.929,3.929,0,0,0,1.352,3.1,5.385,5.385,0,0,0,3.693,1.219,6.868,6.868,0,0,0,5.3-2.247,8.133,8.133,0,0,0,2.1-5.739V52.749Zm-102,13.105a11.388,11.388,0,0,1-4.232-3.007,13.084,13.084,0,0,1-2.663-4.8,21.2,21.2,0,0,1-.879-6.353,18.693,18.693,0,0,1,.963-6.149,14.365,14.365,0,0,1,2.9-4.926,12.488,12.488,0,0,1,9.632-4.307c3.823,0,6.829,1.26,8.933,3.747a12.435,12.435,0,0,1,2.366,4.449,20.072,20.072,0,0,1,.78,5.825V54H56.593a10.066,10.066,0,0,0,2.431,6.661,8.463,8.463,0,0,0,6.429,2.458,13.64,13.64,0,0,0,8.582-3.079l.639-.5V64.82l-.163.119c-2.555,1.854-5.967,2.8-10.14,2.8A14.561,14.561,0,0,1,58.844,66.736ZM59.3,44a9.935,9.935,0,0,0-2.6,5.352H71.185a8.67,8.67,0,0,0-1.8-5.482,6.05,6.05,0,0,0-4.9-2.055A7,7,0,0,0,59.3,44ZM262.612,67.067v-16.6c0-2.917-.53-5.121-1.576-6.553a5.32,5.32,0,0,0-4.635-2.1,6.732,6.732,0,0,0-5.35,2.432,9.173,9.173,0,0,0-2.137,6.221v16.6h-5.341V37.858h5.341v3.956a10.534,10.534,0,0,1,9.042-4.622,9.108,9.108,0,0,1,7.438,3.155c1.7,2.07,2.559,5.082,2.559,8.952V67.067Zm-130.916,0V37.858h5.341v4.476a9.558,9.558,0,0,1,2.432-3.2,7.189,7.189,0,0,1,4.723-1.771,7.722,7.722,0,0,1,2.87.418l.244.1v5.783l-.634-.487a5.222,5.222,0,0,0-3.2-.834,5.393,5.393,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-13.156,0V50.354c0-3.049-.466-5.271-1.387-6.6-.9-1.3-2.4-1.939-4.574-1.939a5.647,5.647,0,0,0-4.641,2.509,9.856,9.856,0,0,0-1.959,6.144v16.6H100.64V49.8c0-5.375-1.986-7.987-6.072-7.987a5.57,5.57,0,0,0-4.628,2.359,10.049,10.049,0,0,0-1.86,6.294v16.6H82.738V37.858h5.341v3.721a9.923,9.923,0,0,1,8.542-4.387,8.651,8.651,0,0,1,5.315,1.7,8.523,8.523,0,0,1,2.817,3.636,10.4,10.4,0,0,1,9.352-5.339c3.237,0,5.707,1.022,7.342,3.04a10.1,10.1,0,0,1,1.833,3.762,19.98,19.98,0,0,1,.6,5.166V67.067Zm-85.288,0V37.858h5.342v4.476a9.54,9.54,0,0,1,2.432-3.2,7.187,7.187,0,0,1,4.722-1.771,7.726,7.726,0,0,1,2.87.418l.244.1v5.783l-.635-.487a5.221,5.221,0,0,0-3.2-.834,5.391,5.391,0,0,0-4.549,2.581,12.387,12.387,0,0,0-1.884,7.265V67.067Zm-27.143,0V26.479H27.1v5.008H11.562V44.464H25.938v4.981H11.562V67.067Z","transform":"translate(-15681.109 -4279.445)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4472","data-name":"Group 4472","transform":"translate(-838.068 181.887)"}},[_c('path',{attrs:{"id":"Path_1235","data-name":"Path 1235","d":"M93.364,44.618V15.04h4.489v3.01a9.049,9.049,0,0,1,7.324-3.407,9.838,9.838,0,0,1,7.524,3.163,10.33,10.33,0,0,1,2.067,3.51,13.089,13.089,0,0,1,.722,4.39,11.823,11.823,0,0,1-2.817,7.966,9.484,9.484,0,0,1-3.284,2.37,10.687,10.687,0,0,1-4.3.86,8.391,8.391,0,0,1-7.06-3.335V44.618Zm4.489-18.956c0,4.3,2.589,7.191,6.442,7.191s6.442-2.89,6.442-7.191c0-4.275-2.589-7.147-6.442-7.147S97.853,21.387,97.853,25.662ZM167.146,34.1a14.7,14.7,0,0,1-.808-5.837V18.912h-3.086V15.084h3.086V8.823H171v6.262h5.027v3.828H171v9.263a8.129,8.129,0,0,0,.5,3.729,1.968,1.968,0,0,0,1.973.949,4.953,4.953,0,0,0,2.06-.46l.289-.151.026.325.277,3.548-.141.061a9.6,9.6,0,0,1-3.923.724C169.61,36.9,168,35.986,167.146,34.1Zm-24.959-.258a10.293,10.293,0,0,1-2.4-3.511,12.208,12.208,0,0,1,0-9.064,10.419,10.419,0,0,1,2.4-3.528,11.968,11.968,0,0,1,16.069,0,10.444,10.444,0,0,1,2.4,3.528,12.218,12.218,0,0,1,0,9.064,10.317,10.317,0,0,1-2.4,3.511,12.079,12.079,0,0,1-16.067,0Zm1.435-8.181c0,4.235,2.721,7.191,6.618,7.191,3.871,0,6.574-2.957,6.574-7.191,0-4.208-2.7-7.147-6.574-7.147C146.343,18.515,143.622,21.454,143.622,25.662ZM81.12,34.1a14.714,14.714,0,0,1-.807-5.837V18.912H77.226V15.084h3.087V8.823h4.665v6.262H90v3.828H84.978v9.263a8.129,8.129,0,0,0,.5,3.729,1.969,1.969,0,0,0,1.973.949,4.944,4.944,0,0,0,2.06-.46l.29-.151.026.325.276,3.548-.14.061a9.606,9.606,0,0,1-3.923.724C83.584,36.9,81.974,35.986,81.12,34.1ZM62.733,35.867a9.445,9.445,0,0,1-3.5-2.8l-.105-.136,2.292-2.791.169.177A9.12,9.12,0,0,0,67.61,33.25c1.142,0,3.8-.271,3.8-2.782,0-1.85-2.386-2.593-3.965-3.084-.221-.068-.43-.134-.608-.195a14.905,14.905,0,0,1-4.307-2.008,5.143,5.143,0,0,1-2.012-4.326,5.661,5.661,0,0,1,2.222-4.624,8.216,8.216,0,0,1,5.049-1.589,9.438,9.438,0,0,1,7.3,2.8l.118.126-2.01,2.965-.185-.192a7.482,7.482,0,0,0-5.136-2.183c-1.992,0-3.135.87-3.135,2.386,0,1.537,1.868,2.26,3.951,2.925l0,0,.513.177c.877.3,1.569.542,2.319.841a7.655,7.655,0,0,1,3.013,2.091,5.307,5.307,0,0,1,1.224,3.489A6.157,6.157,0,0,1,73.2,35.239a9.578,9.578,0,0,1-5.64,1.663A11.235,11.235,0,0,1,62.733,35.867ZM38.948,34.308c-1.035-1.466-1.538-3.6-1.538-6.529V15h4.621V27.6a7.581,7.581,0,0,0,.745,3.74,3.619,3.619,0,0,0,3.4,1.6c4.627,0,4.987-4.964,4.987-6.486V15h4.665V36.416H51.3l-.037-2.5a6.977,6.977,0,0,1-2.253,1.973A8.27,8.27,0,0,1,44.99,36.9C42.157,36.9,40.182,36.053,38.948,34.308Zm91.146,2.109V5.56h4.621V36.416Zm-10.45,0V15.04h4.666V36.416Zm-96.829,0V15.04h4.669l-.038,2.737a6.053,6.053,0,0,1,1.9-2.181,5.474,5.474,0,0,1,3.165-.953,6.069,6.069,0,0,1,2.292.371l.139.061-.289,4.277h-.424l-.042-.019a5.412,5.412,0,0,0-2.205-.422,3.806,3.806,0,0,0-3.588,2.268,10.373,10.373,0,0,0-.914,4.571V36.416Zm-14.11,0V9.564H.107v-4H21.968v4H13.414V36.416ZM118.982,8.378a2.814,2.814,0,0,1,2.994-2.818,3.024,3.024,0,0,1,2.111.8,2.85,2.85,0,0,1,0,4.038,3.024,3.024,0,0,1-2.111.8A2.814,2.814,0,0,1,118.982,8.378Z","transform":"translate(-14724.018 -4261.217)"}}),_vm._v(" "),_c('g',{attrs:{"id":"Group_4469","data-name":"Group 4469","transform":"translate(-14800.932 -4279)"}},[_c('path',{attrs:{"id":"Shape-6","data-name":"Shape","d":"M46.36,63.583l13.887-3.615,5.8,18.367Zm31.96-23.74H53.874L46.36,16.2,38.845,39.843H14.4L34.185,54.5,26.67,78.14,46.455,63.485,58.63,54.5,78.32,39.843Z","transform":"translate(-14.4 -16.2)","fill":"#00b67a"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1234","data-name":"Path 1234","d":"M-14602.557-4648.868l-1.6-5.6-12.34,9.133Z","transform":"translate(14648.439 4692.722)","fill":"#005128"}})])])])])])])]),_vm._v(" "),(this.spaId !== '')?_c('div',{staticClass:"center m2"},[_c('p',{staticClass:"darkblue h4 semi-bold my2 mt4 pt4 p0 center"},[_vm._v("Tak!")]),_vm._v(" "),_c('p',{staticClass:"p0 m0 h5 center"},[_vm._v("Vi har fjernet din e-mailadresse fra vores liste.")])]):_c('div',{staticClass:"center m2"},[_c('p',{staticClass:"darkblue h4 semi-bold my2 mt4 pt4 p0"},[_vm._v("Du vil ikke længere modtage en invitation til at skrive en anbefaling til denne partner")])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":false}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 flex-none"},[_c('p',{staticClass:"no-hover m0 inline-block flex justify-start items-center",attrs:{"type":"button"}},[_c('img',{attrs:{"src":"/static/svg/h.svg","alt":"","height":"28"}}),_vm._v(" "),_c('span',{staticClass:"h5 ml1 gibson darkblue mb0 semi-bold"},[_vm._v("Håndværker.dk")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4a6dd5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__ = __webpack_require__(1124);
function injectStyle (ssrContext) {
  __webpack_require__(1117)
  __webpack_require__(1118)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Password_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c4a6dd5_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Password_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1117 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Header__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zxcvbn__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zxcvbn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Paasword',
  components: {
    Header: __WEBPACK_IMPORTED_MODULE_1__components_Header__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a,
    passwordStrength: __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default.a,
    VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      form: {
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      strengthMessages: ['Meget svagt', 'Svagt', 'Medium', 'Stærkt', 'Meget stærkt'],
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      show: false,
      label: 'Loading...',
      loading: true,
      score: 0,
      projectPerson: '',
      overlay: false
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width > 1280) {
      this.showLarge = true;
    }
    this.projectPerson = localStorage.getItem('id_token_portal');
    if (this.projectPerson === null) {
      this.$router.push('/login');
    }
  },

  methods: {
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      this.form.errorMessage = '';
      if (this.form.password !== this.form.newpassword) {
        this.form.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.';
        return;
      }
      this.score = __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default()(this.form.password).score;
      if (this.score < 3) {
        this.form.errorMessage = 'Dit password er ikke stærkt nok.';
        return;
      }
      this.show = true;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'changePassword', salesPerson: this.salesPerson, password: this.form.password };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {
            this.$router.push('/newsfeed');
          };
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn
          };
          _this.$refs.simplert.openSimplert(obj);
        } else {
          _this.form.errorMessage = 'Det er en fejl med dit adgangskode, prøv igen';
        }
      }, function (response) {
        alert('error');
      });
    },
    forgotPassword: function forgotPassword(evt) {
      this.$router.push('/glemte-password');
    },

    password_check: function password_check() {
      this.has_number = /\d/.test(this.form.password);
      this.has_lowercase = /[a-z]/.test(this.form.password);
      this.has_uppercase = /[A-Z]/.test(this.form.password);
      this.has_special = /[!@#\\$%\\^\\&*\\)\\(+=._-]/.test(this.form.password);
    }
  }
});

/***/ }),
/* 1120 */,
/* 1121 */,
/* 1122 */,
/* 1123 */,
/* 1124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb2"},[_c('div',{staticClass:"clearfix gibson px2 py3 mb2"},[_c('div',{staticClass:"col-12 px2"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('vue-password',{attrs:{"strengthMessages":_vm.strengthMessages,"required":"","classes":"not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center","placeholder":"Nyt kodeord","autocomplete":"current-password","score":_vm.score},on:{"input":_vm.password_check},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-input',{staticClass:"not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center",attrs:{"type":"password","placeholder":"Gentag kodeord","required":"","autocomplete":"current-password"},model:{value:(_vm.form.newpassword),callback:function ($$v) {_vm.$set(_vm.form, "newpassword", $$v)},expression:"form.newpassword"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.form.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.form.errorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.form.password.length > 7}},[_c('i',{staticClass:"mr1",class:_vm.form.password.length > 7 ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Længere end 7 karakterer")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_uppercase }},[_c('i',{staticClass:"mr1",class:_vm.has_uppercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et stort bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_lowercase }},[_c('i',{staticClass:"mr1",class:_vm.has_lowercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et lille bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_number }},[_c('i',{staticClass:"mr1",class:_vm.has_number ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et tal")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_special }},[_c('i',{staticClass:"mr1",class:_vm.has_special ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et specialkarakter")])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix p2 py3 ml4"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-6 px0"},[_c('vue-password',{attrs:{"strengthMessages":_vm.strengthMessages,"required":"","classes":"not-rounded border-none muted-background mb1 p2 flex justify-center items-center","placeholder":"Nyt kodeord","autocomplete":"current-password","score":_vm.score},on:{"input":_vm.password_check},model:{value:(_vm.form.password),callback:function ($$v) {_vm.$set(_vm.form, "password", $$v)},expression:"form.password"}})],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-6 px0 mb2"},[_c('b-form-input',{staticClass:"not-rounded border-none muted-background mb1 p2 h5 flex justify-center items-center",staticStyle:{},attrs:{"type":"password","placeholder":"Gentag kodeord","required":"","autocomplete":"current-password"},model:{value:(_vm.form.newpassword),callback:function ($$v) {_vm.$set(_vm.form, "newpassword", $$v)},expression:"form.newpassword"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.form.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.form.errorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-6 px2"},[_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.form.password.length > 7}},[_c('i',{staticClass:"mr1",class:_vm.form.password.length > 7 ? 'el-icon-check green' : 'el-icon-close red'}),_vm._v(" "),_c('span',[_vm._v("Længere end 7 karakterer")])]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_uppercase }},[_c('i',{staticClass:"mr1",class:_vm.has_uppercase ? 'el-icon-check green' : 'el-icon-close red'}),_vm._v(" Indeholder et stort bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_lowercase }},[_c('i',{staticClass:"mr1",class:_vm.has_lowercase ? 'el-icon-check green' : 'el-icon-close red'}),_vm._v(" Indeholder et lille bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_number }},[_c('i',{staticClass:"mr1",class:_vm.has_number ? 'el-icon-check green' : 'el-icon-close red'}),_vm._v(" Indeholder et tal")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_special }},[_c('i',{staticClass:"mr1",class:_vm.has_special ? 'el-icon-check green' : 'el-icon-close red'}),_vm._v(" Indeholder et specialkarakter")])])]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Skift kodeord")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"col-12 px2 flex justify-between items-center"},[_c('a',{staticClass:"muted-button p3 no-hover h4 mb0",attrs:{"href":"#/newsfeed"}},[_vm._v("Tilbage")]),_vm._v(" "),_c('button',{staticClass:"action-button h4 p3 gibson not-rounded border-none",attrs:{"type":"submit","id":"formLogin"}},[_c('span',[_vm._v("Gem")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 mb2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 mb4 darkblue"},[_vm._v("Skift kodeord")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"col-6 px2 flex justify-between items-center"},[_c('a',{staticClass:"outlined-disabled-button p2 gibson h5 line-height-1 flex justify-center items-center",attrs:{"href":"#/newsfeed"}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])]),_vm._v(" "),_c('button',{staticClass:"action-button h5 p2 gibson not-rounded border-none line-height-1 regular px3 flex justify-center items-center",attrs:{"type":"submit","id":"formLogin"}},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finansiering_vue__ = __webpack_require__(1127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ffa240_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Finansiering_vue__ = __webpack_require__(1132);
function injectStyle (ssrContext) {
  __webpack_require__(1126)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-65ffa240"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Finansiering_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_65ffa240_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Finansiering_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1126 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1127 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__NewFinansCalc__ = __webpack_require__(1128);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    finanscalc: __WEBPACK_IMPORTED_MODULE_0__NewFinansCalc__["a" /* default */]
  }
});

/***/ }),
/* 1128 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFinansCalc_vue__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542fc747_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewFinansCalc_vue__ = __webpack_require__(1131);
function injectStyle (ssrContext) {
  __webpack_require__(1129)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewFinansCalc_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_542fc747_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewFinansCalc_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1129 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1130 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'finanscalc',
  props: ['value'],
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  data: function data() {
    return {
      loanAmount: 5000,
      showless: true,
      showmore: false,
      totalRepayAmount: '',
      monthlyAmount: '',
      loanTime: 5,
      dataLoan: [],
      show: false,
      label: '',
      overlay: 1,
      variableInterest: '',
      AOP: '',
      startFee: '',
      form: {
        firstName: '',
        lastName: '',
        email: '',
        tel: '',
        comments: '',
        consent: ''
      }
    };
  },
  mounted: function mounted() {
    var self = this;
    setTimeout(function () {
      self.loanAmount = 5000;
    }, 800);
  },
  created: function created() {
    var _this = this;

    if (this.$route.query.credit === 'change') {
      this.showDismissibleAlert = true;
    }
    this.slideEnd();
    this.salesPerson = localStorage.getItem('id_token_portal');
    var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson, holiday: 1, array: 'no' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
    }, function (response) {
      alert('error');
    });
  },

  methods: {
    change: function change(value) {
      console.log(value);
    },
    handleSubmitCalc: function handleSubmitCalc() {
      var _this2 = this;

      this.show = true;
      var fullNameLoan = this.form.firstName + ' ' + this.form.lastName;
      var data = { operation: 'callbackloan', salesPerson: this.salesPerson, fullNameLoan: fullNameLoan, telefonLoan: this.form.tel, emailLoan: this.form.email, loanAmount: this.loanAmount, terms: this.loanTime, comment: this.form.comments, dataLoan: this.dataLoan };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Tak! Vi har nu sendt dine oplysninger til Resurs Bank, som vil kontakte dig snarest muligt.',
            type: 'success'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.form.firstName = '';
          _this2.form.lastName = '';
          _this2.form.tel = '';
          _this2.form.email = '';
          _this2.form.comment = '';
          _this2.form.consent = '';
        } else {
          alert(res.message);
          _this2.isLoadingDato = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    slideEnd: function slideEnd() {
      var _this3 = this;

      this.show = true;
      this.monthlyAmount = '';
      var data = { operation: 'bank', salesPerson: this.salesPerson, loanAmount: this.loanAmount, terms: this.loanTime };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        _this3.dataLoan = res;
        _this3.monthlyAmount = _this3.formatCurrency(res.Repayment);
        _this3.startFee = _this3.formatCurrency(res.RegistrationFee);
        _this3.AOP = res.CostsPercent;
        _this3.variableInterest = res.NominalInterestPercent;
        _this3.totalRepayAmount = _this3.formatCurrency(res.TotalAmountToBeRepayed);
      }, function (response) {
        alert('error');
      });
    },
    formatCurrency: function formatCurrency(total) {
      var neg = false;
      if (total < 0) {
        neg = true;
        total = Math.abs(total);
      }
      return (neg ? '' : '') + parseFloat(total, 10).toFixed(0).replace('.', ',').replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1.').toString();
    },
    slideStart: function slideStart() {
      console.log(this.loanAmount);
      if (this.loanAmount <= 60000) {
        this.showless = true;
        this.showmore = false;
        if (this.loanTime > 5) {
          this.loanTime = 5;
        }
      } else {
        if (this.showless) this.loanTime = 15;
        this.showless = false;
        this.showmore = true;
      }
    }
  },
  computed: {}
});

/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitCalc.apply(null, arguments)}}},[_c('fieldset',[_c('b-form-row',{},[_c('b-col',{staticClass:"text-center pt-4 pr-4 pl-4",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('div',{staticClass:"line-height-golden text-secondary"},[_vm._v("Forventelig månedlig ydelse")]),_vm._v(" "),_c('p',{staticClass:"display-4 text-dark py-4",staticStyle:{"letter-spacing":"-1px"}},[_vm._v(_vm._s(_vm.monthlyAmount)+" kr.")])]),_vm._v(" "),_c('b-col',{staticClass:"text-center pt-4 pr-4 pl-4",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('div',{staticClass:"line-height-golden text-secondary"},[_vm._v("Lånebeløb")]),_vm._v(" "),_c('p',{staticClass:"display-4 text-dark py-4",staticStyle:{"letter-spacing":"-1px"}},[_vm._v(_vm._s(_vm.formatCurrency(_vm.loanAmount))+" kr.")]),_vm._v(" "),_c('div',{staticClass:"sliderDiv p-2"},[_c('b-form-slider',{attrs:{"id":"loanAmount","min":5000,"max":350000,"trigger-change-event":""},on:{"change":function($event){return _vm.slideStart()},"slideStop":function($event){return _vm.slideEnd()}},model:{value:(_vm.loanAmount),callback:function ($$v) {_vm.loanAmount=$$v},expression:"loanAmount"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('div',{staticClass:"initialism text-secondary"},[_vm._v("5.000kr")]),_vm._v(" "),_c('div',{staticClass:"initialism text-secondary"},[_vm._v("350.000kr")])])]),_vm._v(" "),(_vm.showless)?_c('b-col',{staticClass:"text-center pt-4 pr-4 pl-4",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('div',{staticClass:"line-height-golden text-secondary"},[_vm._v("Lånetid")]),_vm._v(" "),_c('p',{staticClass:"display-4 text-dark py-4",staticStyle:{"letter-spacing":"-1px"}},[_vm._v(_vm._s(_vm.loanTime)+" år")]),_vm._v(" "),_c('div',{staticClass:"sliderDiv p-2"},[_c('b-form-slider',{attrs:{"id":"loanTime","min":1,"max":5,"trigger-change-event":""},on:{"slideStop":function($event){return _vm.slideEnd()}},model:{value:(_vm.loanTime),callback:function ($$v) {_vm.loanTime=$$v},expression:"loanTime"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('div',{staticClass:"initialism text-secondary"},[_vm._v("12 mdr.")]),_vm._v(" "),_c('div',{staticClass:"initialism text-secondary"},[_vm._v("60 mdr.")])])]):_vm._e(),_vm._v(" "),(_vm.showmore)?_c('b-col',{staticClass:"text-center pt-4 pr-4 pl-4",attrs:{"lg":"4","md":"4","sm":"12"}},[_c('div',{staticClass:"line-height-golden text-secondary"},[_vm._v("Lånetid")]),_vm._v(" "),_c('p',{staticClass:"display-4 text-dark py-4",staticStyle:{"letter-spacing":"-1px"}},[_vm._v(_vm._s(_vm.loanTime)+" år")]),_vm._v(" "),_c('div',{staticClass:"sliderDiv p-2"},[_c('b-form-slider',{attrs:{"id":"loanTimemore","min":1,"max":15,"trigger-change-event":""},on:{"slideStop":function($event){return _vm.slideEnd()}},model:{value:(_vm.loanTime),callback:function ($$v) {_vm.loanTime=$$v},expression:"loanTime"}})],1),_vm._v(" "),_c('div',{staticClass:"d-flex flex-row justify-content-between"},[_c('div',{staticClass:"initialism text-secondary"},[_vm._v("12 mdr.")]),_vm._v(" "),_c('div',{staticClass:"initialism text-secondary"},[_vm._v("180 mdr.")])])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"py-4"}),_vm._v(" "),_c('b-form-row',{staticClass:"px-4 py-4 bg-dark"},[_c('b-col',[_c('div',{staticClass:"text-center text-light pl-2 text-small"},[_c('span',{staticClass:"d-inline-block mr-1"},[_vm._v("Kreditbeløb")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v(_vm._s(_vm.loanAmount))]),_vm._v(" kr.\n            "),_c('span',{staticClass:"d-inline-block mr-1 ml-1"},[_vm._v("Variabel debitorrente")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v(" "+_vm._s(_vm.variableInterest)+"%")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mr-1 ml-1"},[_vm._v("AOP")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v(" "+_vm._s(_vm.AOP)+"%")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mr-1 ml-1"},[_vm._v("Oprettelsesgebyr")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v(" "+_vm._s(_vm.startFee)+" kr.")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block mr-1 ml-1"},[_vm._v("Beløb der skal betales tilbage")]),_vm._v(" "),_c('span',{staticClass:"d-inline-block font-weight-bold"},[_vm._v(" "+_vm._s(_vm.totalRepayAmount)+" kr.")])])])],1),_vm._v(" "),_c('b-form-row',{staticClass:"bg-light pt-4"},[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Kundens fornavn","label-for":"nameInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"nameInput","required":""},model:{value:(_vm.form.firstName),callback:function ($$v) {_vm.$set(_vm.form, "firstName", $$v)},expression:"form.firstName"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Kundens efternavn","label-for":"lastnameInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"lastnameInput","required":""},model:{value:(_vm.form.lastName),callback:function ($$v) {_vm.$set(_vm.form, "lastName", $$v)},expression:"form.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"bg-light py-4"},[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Kundens email","label-for":"emailInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"emailInput","required":"","type":"email"},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Kundens telefonnummer","label-for":"telInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"telInput","required":""},model:{value:(_vm.form.tel),callback:function ($$v) {_vm.$set(_vm.form, "tel", $$v)},expression:"form.tel"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',{staticClass:"py-4"},[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Kommentar","label-for":"commentsInput"}},[_c('b-form-textarea',{staticClass:"rounded",attrs:{"id":"commentsInput","placeholder":"Tilføj eventuelt en kommentar","rows":3,"max-rows":6},model:{value:(_vm.form.comments),callback:function ($$v) {_vm.$set(_vm.form, "comments", $$v)},expression:"form.comments"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-form-group',{staticClass:"px-4",attrs:{"label":"Tilladelse","label-for":"consentInput"}},[_c('b-form-checkbox',{attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},model:{value:(_vm.form.consent),callback:function ($$v) {_vm.$set(_vm.form, "consent", $$v)},expression:"form.consent"}},[_c('span',{staticClass:"text-secondary"},[_vm._v("Jeg giver hermed tilladelse til, at Resurs Bank kontakter kunden ifm. en uforpligtende samtale om en lånemulighed.")])])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded mx-auto font-weight-bold p-3",attrs:{"variant":"success","type":"submit","size":"lg"}},[_c('span',{staticClass:"el-icon-success mr-2"}),_c('span',[_vm._v("Send oplysninger til banken")])])],1)])],1),_vm._v(" "),_c('div',{staticClass:"py-4"})],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1132 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('span',{staticClass:"headericon"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Finansiering")])])])]),_vm._v(" "),_c('b-card',{staticClass:"pt-0 pr-2 pb-0 border-0"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"h5 open-sans line-height-golden py-4"},[_vm._v("\n              Her kan du lave en låneberegning til dine potentielle kunder og sende den videre til Resurs Bank.\n            ")])])]),_vm._v(" "),_c('b-card',{staticClass:"pt-0 pb-0 border-0"},[_c('div',{staticClass:"card-text"},[_c('finanscalc')],1)])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1133 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheck_vue__ = __webpack_require__(1135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d492e734_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheck_vue__ = __webpack_require__(1142);
function injectStyle (ssrContext) {
  __webpack_require__(1134)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheck_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d492e734_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheck_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1134 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1135 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreditCheckForm__ = __webpack_require__(1136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreditcheckList__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    creditcheckform: __WEBPACK_IMPORTED_MODULE_0__CreditCheckForm__["a" /* default */],
    creditchecklist: __WEBPACK_IMPORTED_MODULE_1__CreditcheckList__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  created: function created() {
    this.Reload();
  },
  data: function data() {
    return {
      kredits: '',
      kredit_items: '',
      claim_items: '',
      reviewShowShop: false,
      isLoadingSubmit: false,
      packageOptions: [],
      picked: '',
      overlay: true,
      show: false,
      label: 'Loading...',
      kredits_create: '',
      creditCheck: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        streetName: '',
        houseNumber: '',
        houseFloor: '',
        houseSide: '',
        city: '',
        zip: '',
        cprNumber: '',
        consent: ''
      }
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_credit', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.kredit_items = res.items;
        _this.kredits = res.kredits;
        _this.claim_items = res.claim;
        _this.kredits_create = res.kredits_create;
        _this.packageOptions = res.package;
      }, function (response) {
        alert('error');
      });
    },
    onSubmitPurchaseInfo: function onSubmitPurchaseInfo(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.picked === '') {
        var obj = {
          title: 'Fejl',
          message: 'Vælg Pakke',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return false;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addKreditSale', salesPerson: this.salesPerson, package: this.picked, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          alert('Gennemført!');
          _this2.picked = '';
          _this2.$refs.reviewModalShop.hide();
        } else {
          var _obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    closeShopModal: function closeShopModal() {
      this.$refs.reviewModalShop.hide();
    },
    showShop: function showShop() {
      this.reviewShowShop = !this.reviewShowShop;
    },
    claimCheck: function claimCheck(claimId, id) {
      var _this3 = this;

      if (this.kredits_create >= this.kredits) {
        var obj = {
          title: 'Fejl',
          message: 'Du skal købe flere kilpkort',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      this.isLoadingSubmit = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'claimcheck', salesPerson: this.salesPerson, claimId: claimId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        _this3.isLoadingSubmit = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.Reload();
          setTimeout(function () {
            document.getElementById(id).click();
          }, 2500);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    creditSubmit: function creditSubmit() {
      var _this4 = this;

      if (this.kredits_create >= this.kredits) {
        var obj = {
          title: 'Fejl',
          message: 'Du skal købe flere kilpkort',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      this.isLoadingSubmit = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'creditcheck', salesPerson: this.salesPerson, creditCheck: this.creditCheck };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        _this4.isLoadingSubmit = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var _obj2 = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(_obj2);
          _this4.Reload();
          _this4.creditCheck.firstName = '';
          _this4.creditCheck.lastName = '';
          _this4.creditCheck.email = '';
          _this4.creditCheck.phone = '';
          _this4.creditCheck.streetName = '';
          _this4.creditCheck.houseNumber = '';
          _this4.creditCheck.houseFloor = '';
          _this4.creditCheck.city = '';
          _this4.creditCheck.zip = '';
          _this4.creditCheck.cprNumber = '';
          _this4.creditCheck.consent = '';
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    hideModal: function hideModal() {
      this.$refs.conditions.hide();
    }
  }
});

/***/ }),
/* 1136 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheckForm_vue__ = __webpack_require__(1138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6931376c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheckForm_vue__ = __webpack_require__(1139);
function injectStyle (ssrContext) {
  __webpack_require__(1137)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6931376c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreditCheckForm_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6931376c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CreditCheckForm_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1137 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'creditcheckform',
  props: ['creditCheck', 'isLoadingSubmit'],
  components: {},
  data: function data() {
    return {};
  },

  methods: {
    handleSubmitKreditcheck: function handleSubmitKreditcheck() {
      this.$emit('creditSubmit');
    }
  },
  computed: {}
});

/***/ }),
/* 1139 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitKreditcheck.apply(null, arguments)}}},[_c('fieldset',[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"4","lg":"4"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold",attrs:{"label":"Fødselsdato","label-for":"cprInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"cprInput"},model:{value:(_vm.creditCheck.cprNumber),callback:function ($$v) {_vm.$set(_vm.creditCheck, "cprNumber", $$v)},expression:"creditCheck.cprNumber"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4","lg":"4"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Fornavn","label-for":"firstnameInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"firstnameInput"},model:{value:(_vm.creditCheck.firstName),callback:function ($$v) {_vm.$set(_vm.creditCheck, "firstName", $$v)},expression:"creditCheck.firstName"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"4","lg":"4"}},[_c('b-form-group',{staticClass:"px-4 font-weight-bold text-dark",attrs:{"label":"Efternavn","label-for":"lastnameInput"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"id":"lastnameInput"},model:{value:(_vm.creditCheck.lastName),callback:function ($$v) {_vm.$set(_vm.creditCheck, "lastName", $$v)},expression:"creditCheck.lastName"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{staticClass:"px-4",attrs:{"label-for":"consentInput"}},[_c('b-form-checkbox',{attrs:{"id":"consentInput","value":"accepted","required":"","unchecked-value":"not_accepted"},model:{value:(_vm.creditCheck.consent),callback:function ($$v) {_vm.$set(_vm.creditCheck, "consent", $$v)},expression:"creditCheck.consent"}},[_c('span',{staticClass:"text-secondary open-sans"},[_vm._v("Neostructuralist rationalism holds that language is capable of truth, given that the premise of the conceptualist paradigm of reality is invalid. Thus, many discourses concerning the common ground between sexual identity and society may be discovered.")])])],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('div',{staticClass:"d-flex justify-content-center py-4"},[_c('b-btn',{staticClass:"rounded mx-auto mb-4",attrs:{"variant":"success","type":"submit","disabled":_vm.isLoadingSubmit,"size":"lg"}},[_c('span',{staticClass:"el-icon-d-arrow-right"}),_vm._v("\n              Send forspørgslen\n            ")])],1)])],1)],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'creditcheckList',
  props: ['claimCheck', 'kredit_items', 'claim_items'],
  data: function data() {
    return {
      sampleCustomerName: '',
      sampleCustomerMale: '',
      sampleCustomerAddresse: '',
      id: '',
      sampleCustomerStatus: '',

      sampleCustomer: [],
      sampleStatus: [],
      claimresult: 0,
      claimarray: [],
      creditShow: false,
      creditShowStatus: false
    };
  },

  methods: {
    fullName: function fullName(value) {
      return value.first + ' ' + value.last;
    },
    checkifclaim: function checkifclaim(Id) {
      if (this.claim_items[Id]) {
        return false;
      } else {
        return true;
      }
    },
    returnClaim: function returnClaim(Id) {
      if (this.claim_items[Id]) {
        if (this.claim_items[Id].paymentRemarks.paymentRemark.length !== undefined) {
          return this.claim_items[Id].paymentRemarks.paymentRemark;
        } else {
          return this.claim_items[Id].paymentRemarks;
        }
      } else {
        return [];
      }
    },
    showOtherDetails: function showOtherDetails(customer) {
      this.creditShow = !this.creditShow;
      this.sampleCustomer = customer;
      this.sampleCustomerName = customer.result.personInfoFromCPR.name.firstAndMiddleName + ' ' + customer.result.personInfoFromCPR.name.lastName;
      this.sampleCustomerMale = customer.result.personInfoFromCPR.gender;
      this.sampleCustomerAddresse = customer.result.personInfoFromCPR.address.standardAddress + ' ' + customer.result.personInfoFromCPR.address.city;
      this.sampleCustomerStatus = customer.result.personInfoFromCPR.statusDescription;
    },
    showDetails: function showDetails(customer) {
      this.creditShowStatus = !this.creditShowStatus;
      console.log(customer.result.debtorPersons.debtorPerson.length);
      if (customer.result.debtorPersons.debtorPerson.length !== undefined) {
        this.sampleStatus = customer.result.debtorPersons.debtorPerson;
      } else {
        this.sampleStatus = customer.result.debtorPersons;
      }
      this.claimresult = customer.claimresult;
      this.id = customer.id;
    },
    hideModal: function hideModal() {
      this.$refs.creditModal.hide();
    },
    closeCreditModal: function closeCreditModal() {
      this.$refs.creditModalStatus.hide();
    },
    checkclaim: function checkclaim(item) {
      this.$emit('claimCheck', item.claimId, this.id);
      this.$refs.creditModalStatus.hide();
    }
  }
});

/***/ }),
/* 1141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('b-container')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('b-row',[_c('b-col',{attrs:{"lg":"9","md":"9","sm":"12"}},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-column justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('span',{staticClass:"mr2 headericon"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M2 0v24h20v-24h-20zm5 22h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm5 8h-3v-7h3v7zm0-8h-3v-3h3v3zm0-6h-16v-6h16v6zm-1-1h-14v-4h14v4z"}})])]),_vm._v(" "),_c('span',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("KreditTjek")])]),_vm._v(" "),_c('p',{staticClass:"py-3 open-sans h6 line-height-golden"},[_vm._v("\n                    Neostructuralist rationalism holds that language is capable of truth, given that the premise of the conceptualist paradigm of reality is invalid. Thus, many discourses concerning the common ground between sexual identity and society may be discovered.\n                    "),_c('br'),_c('br'),_vm._v(" "),_c('b-btn',{directives:[{name:"b-modal",rawName:"v-b-modal.conditions",modifiers:{"conditions":true}}],attrs:{"variant":"outline-dark"}},[_c('span',{staticClass:"font-weight-bold"},[_vm._v("Læs betingelserne")])]),_vm._v(" "),_c('b-modal',{ref:"conditions",attrs:{"id":"conditions"}},[_c('div',{staticClass:"w-100",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('div',{staticClass:"text-dark font-weight-bold line-height-golden headerfont h5"},[_vm._v("\n                            Modal Header\n                          ")]),_vm._v(" "),_c('div',[_c('b-btn',{staticClass:"border-0",attrs:{"variant":"outline-danger","block":""},on:{"click":_vm.hideModal}},[_c('span',{staticClass:"el-icon-error"})])],1)])]),_vm._v(" "),_vm._t("modal-content",function(){return [_vm._v("\n                        Modal content\n                      ")]}),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"mt-3",attrs:{"variant":"outline-danger","block":""},on:{"click":_vm.hideModal}},[_vm._v("Close Me")])],1)],2)],1)])])]),_vm._v(" "),_c('b-col',{attrs:{"lg":"3","md":"3","sm":"12"}},[_c('b-list-group',[_c('b-list-group-item',{staticClass:"border-0"},[_c('p',{staticClass:"w-50 d-inline-block float-left m-0 p-0"},[_vm._v("Du har købt")]),_vm._v(" "),_c('p',{staticClass:"w-50 d-inline-block float-right text-right m-0 p-0"},[_c('span',{staticClass:"bg-info pt-1 pb-1 pr-2 pl-2 rounded mr-1"},[_vm._v(_vm._s(_vm.kredits))]),_vm._v("\n                    klip\n                  ")])]),_vm._v(" "),_c('b-list-group-item',{staticClass:"border-0"},[_c('p',{staticClass:"w-50 d-inline-block float-left m-0 p-0"},[_vm._v("Du har brugt")]),_vm._v(" "),_c('p',{staticClass:"w-50 d-inline-block float-right text-right m-0 p-0"},[_c('span',{staticClass:"bg-success pt-1 pb-1 pr-2 pl-2 rounded mr-1"},[_vm._v(_vm._s(_vm.kredits_create))]),_vm._v("\n                    klip\n                  ")])]),_vm._v(" "),_c('b-list-group-item',{staticClass:"border-0 text-center"},[_c('b-btn',{staticClass:"font-weight-bold",attrs:{"variant":"outline-success","type":"button"},on:{"click":function($event){return _vm.showShop()}}},[_c('span',{staticClass:"headericon mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M2 0v24h20v-24h-20zm5 22h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm4 8h-3v-3h3v3zm0-4h-3v-3h3v3zm0-4h-3v-3h3v3zm5 8h-3v-7h3v7zm0-8h-3v-3h3v3zm0-6h-16v-6h16v6zm-1-1h-14v-4h14v4z"}})])]),_vm._v("\n                    Køb flere KreditTjek klip\n                  ")])],1)],1)],1)],1)],1),_vm._v(" "),_c('b-card',{staticClass:"p-0 pt-4 border-0 creditcheck-container",attrs:{"bg-variant":"white"}},[_c('creditcheckform',{attrs:{"creditCheck":_vm.creditCheck,"isLoadingSubmit":_vm.isLoadingSubmit},on:{"creditSubmit":_vm.creditSubmit}})],1)],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"reviewModalShop",staticClass:"p-2",attrs:{"centered":"","lazy":"","size":"lg","title":"Køb flere KreditTjek klip"},model:{value:(_vm.reviewShowShop),callback:function ($$v) {_vm.reviewShowShop=$$v},expression:"reviewShowShop"}},[_c('div',{staticClass:"modal-content border-0 open-sans"},[_c('div',{staticClass:"py-4"}),_vm._v(" "),_c('b-form',{on:{"submit":_vm.onSubmitPurchaseInfo}},[_c('fieldset',[_c('b-form-row',[_c('b-container',{staticClass:"bv-example-row"},[_c('b-row',_vm._l((_vm.packageOptions),function(packageOption){return _c('b-col',{key:packageOption.id},[_c('div',[_c('b-form-group',[_c('b-card',{staticClass:"mb-2",staticStyle:{"max-width":"20rem"},attrs:{"img-src":packageOption.image,"img-alt":"Image","img-top":"","tag":"article"}},[_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(packageOption.total)+" kr.")]),_vm._v(" "),_c('p',{staticClass:"card-text"},[_vm._v(_vm._s(packageOption.description))]),_vm._v(" "),_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.picked),expression:"picked"}],staticClass:"radion_select",attrs:{"type":"radio","id":packageOption.id},domProps:{"value":packageOption.id,"checked":_vm._q(_vm.picked,packageOption.id)},on:{"change":function($event){_vm.picked=packageOption.id}}}),_vm._v(" "),_c('label',{staticClass:"h4 font-weight-normal",attrs:{"label":"","for":packageOption.id}},[_vm._v(_vm._s(packageOption.productname))])])])],1)],1)])}),1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-4"}),_vm._v(" "),_c('b-container',{staticClass:"py-4"},[_c('b-row',{attrs:{"no-gutters":""}},[_c('b-col',{staticClass:"mx-auto",attrs:{"cols":"2"}},[_c('b-btn',{staticClass:"bg-success border-0  ",attrs:{"size":"lg","type":"submit"}},[_c('span',{staticClass:"d-inline-block"},[_c('credit-card-icon')],1),_vm._v(" "),_c('span',{staticClass:"font-weight-bold text-white d-inline-block mr-2"},[_vm._v("Købe")])])],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1),_vm._v(" "),_c('div',{staticClass:"py-4"})],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-row',{staticClass:"pt-0 pr-2 pb-4 pl-2"},[_c('b-col',[_c('b-btn',{staticClass:"rounded",attrs:{"slot":"modal-cancel","type":"reset","variant":"outline-info","size":"lg"},on:{"click":_vm.closeShopModal},slot:"modal-cancel"},[_vm._v("Luk")])],1)],1)],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewProjectStatus_vue__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e28b938_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewProjectStatus_vue__ = __webpack_require__(1150);
function injectStyle (ssrContext) {
  __webpack_require__(1144)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e28b938"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewProjectStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e28b938_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewProjectStatus_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1144 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__producenter_NewStatusList__ = __webpack_require__(1146);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    statuslist: __WEBPACK_IMPORTED_MODULE_0__producenter_NewStatusList__["a" /* default */]
  }
});

/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusList_vue__ = __webpack_require__(1148);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d82f6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusList_vue__ = __webpack_require__(1149);
function injectStyle (ssrContext) {
  __webpack_require__(1147)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14d82f6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1147 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1148 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statuslist',
  data: function data() {
    return {
      status: []
    };
  },
  created: function created() {
    var _this = this;

    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var data = { operation: 'myCenter', salesPerson: this.salesPerson, levid: this.haaId };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
      _this.status = res;
    }, function (response) {
      alert('error');
    });
  }
});

/***/ }),
/* 1149 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"border-0 transparent"},[_c('b-row',[_c('b-col',{attrs:{"md":"2","lg":"2"}},[_c('b-row',{staticClass:"bg-dark text-white mb-4",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"pt-2 mb-4"},[_c('p',{staticClass:"d-inline-flex font-weight-bold"},[_vm._v("Firma")])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0",staticStyle:{"height":"36px","line-height":"36px"}},[_c('p',{staticClass:"font-weight-bold w-100"},[_vm._v(_vm._s(status.company))])])})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2 text-small"},[_vm._v("Registeret")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Dette er navnet på den håndværker, som du har registreret ifm. opstart af projektet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.registered !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2 text-small"},[_vm._v("Kontaktet")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Håndværkeren er blevet kontaktet og informeret om processen ifm. offentliggørelsen af projektet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.kontaktet !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2 text-small"},[_vm._v("Indtastet")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Håndværkeren har indtastet informationerne om projektet, herunder også kundens kontaktinfo."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.infoIndtastet !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2 text-small"},[_vm._v("Tilladelse")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Kunden er blevet informeret om projektet og har givet tilladelse til billedtagning mm."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.permission !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2 text-small"},[_vm._v("Fotos")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Fotografen har været ude hos kunden og har taget billeder af projektet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.photoComplete !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-1 text-small"},[_vm._v("Redigering")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Billederne af projektet er blevet gennemgået og godkendt, og tekst til projektet er blevet skrevet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.edit !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Lanceret")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Projektet er blevet offentliggjort på håndværker.dk"}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.published !== 0)?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd"}},[_c('path',{attrs:{"d":"M21.826 9h-2.086c.171-.487.262-.957.262-1.41 0-2.326-1.818-3.776-4.024-3.573-2.681.247-4.518 3.71-4.978 4.484-.527-.863-2.261-4.238-4.981-4.494-2.11-.199-4.019 1.181-4.019 3.582 0 3.109 4.347 7.084 9.001 11.615 1.16-1.127 2.285-2.208 3.324-3.243l.97 1.857c-1.318 1.302-2.769 2.686-4.294 4.181-6.164-6.037-11.001-10.202-11.001-14.403 0-3.294 2.462-5.526 5.674-5.596 2.163-.009 4.125.957 5.327 2.952 1.177-1.956 3.146-2.942 5.253-2.942 3.064 0 5.746 2.115 5.746 5.595 0 .464-.06.928-.174 1.395zm-11.094 4c-.346.598-.992 1-1.732 1-1.104 0-2-.896-2-2s.896-2 2-2c.74 0 1.386.402 1.732 1h1.222l1.88-2.71c.14-.202.376-.315.622-.299.245.016.464.161.576.38l2.27 4.437.813-1.45c.124-.221.357-.358.611-.358h5.274v2h-4.513l-1.759 2.908c-.132.219-.373.348-.629.337-.255-.01-.484-.16-.598-.389l-2.256-4.559-.989 1.406c-.131.186-.345.297-.573.297h-1.951z"}})])]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Producenter - Projekt status")])])])]),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"h6 open-sans line-height-golden py-4"},[_vm._v("\n            Her kan du se status på dine projekter. Har du spørgsmål til et af dine projekter, så er du velkommen til at skrive til info@haandvaerker.dk.\n            ")])])])],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('statuslist')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1151 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHaandvaerkerProjectStatus_vue__ = __webpack_require__(1153);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a439b42_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewHaandvaerkerProjectStatus_vue__ = __webpack_require__(1158);
function injectStyle (ssrContext) {
  __webpack_require__(1152)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6a439b42"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHaandvaerkerProjectStatus_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a439b42_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewHaandvaerkerProjectStatus_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1152 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haandvaerker_NewStatusList__ = __webpack_require__(1154);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    haandvaerkerstatuslist: __WEBPACK_IMPORTED_MODULE_0__haandvaerker_NewStatusList__["a" /* default */]
  }
});

/***/ }),
/* 1154 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusList_vue__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527d381c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusList_vue__ = __webpack_require__(1157);
function injectStyle (ssrContext) {
  __webpack_require__(1155)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-527d381c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_527d381c_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusList_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1155 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1156 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statuslist',
  data: function data() {
    return {
      status: []
    };
  },
  created: function created() {
    var _this = this;

    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var data = { operation: 'myProject', salesPerson: this.salesPerson, levid: this.haaId };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      if (res.login === false) {
        _this.$router.push('/login');
      }
      _this.status = res;
    }, function (response) {
      alert('error');
    });
  }
});

/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"border-0 transparent"},[_c('b-row',[_c('b-col',{attrs:{"md":"2","lg":"2"}},[_c('b-row',{staticClass:"bg-dark text-white mb-4",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"pt-2 mb-4"},[_c('p',{staticClass:"d-inline-flex font-weight-bold"},[_vm._v("Kundenavn")])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0",staticStyle:{"height":"36px","line-height":"36px"}},[_c('p',{staticClass:"font-weight-bold w-100"},[_vm._v(_vm._s(status.kunde.name))])])})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2 text-center",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Indtastet")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Håndværkeren har indtastet informationerne om projektet, herunder også kundens kontaktinfo."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.emailcustomer !== '0')?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success text-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2 text-center",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Tilladelse")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Kunden er blevet informeret om projektet og har givet tilladelse til billedtagning mm."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.acceptcustomer !== '0')?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success text-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2 text-center",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Foto")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Fotografen har været ude hos kunden og har taget billeder af projektet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.esoft !== '0')?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success text-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2 text-center",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Redigering")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Billederne af projektet er blevet gennemgået og godkendt, og tekst til projektet er blevet skrevet."}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.online !== '0')?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success text-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2),_vm._v(" "),_c('b-col',[_c('b-row',{staticClass:"bg-dark mb-4 pt-2 text-center",staticStyle:{"height":"36px"}},[_c('b-col',{staticClass:"text-warning font-weight-bold w-100"},[_c('p',[_c('span',{staticClass:"mr-2"},[_vm._v("Lanceret")]),_vm._v(" "),_c('span',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],attrs:{"title":"Projektet er blevet offentliggjort på håndværker.dk"}},[_c('span',{staticClass:"el-icon-question",staticStyle:{"position":"relative","top":"2px"}})])])])],1),_vm._v(" "),_vm._l((_vm.status),function(status){return _c('b-row',{key:status.id,staticClass:"p-0 m-0 text-center",staticStyle:{"height":"48px"}},[[(status.online !== '0')?_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-success text-success"})]):_c('span',{staticClass:"mx-auto"},[_c('span',{staticClass:"el-icon-error"})])]],2)})],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1158 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-s-data"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Haandvaerker - Projekt status")])])])]),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"h6 open-sans line-height-golden py-4"},[_vm._v("\n            Her kan du se status på dine projekter. Har du spørgsmål til et af dine projekter, så er du velkommen til at skrive til info@haandvaerker.dk.\n            ")])])])],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('haandvaerkerstatuslist')],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1159 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHaandvaerkerProjectStatus2_vue__ = __webpack_require__(1161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43711340_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewHaandvaerkerProjectStatus2_vue__ = __webpack_require__(1169);
function injectStyle (ssrContext) {
  __webpack_require__(1160)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43711340"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewHaandvaerkerProjectStatus2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43711340_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_NewHaandvaerkerProjectStatus2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1160 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haandvaerker_NewStatusListnew__ = __webpack_require__(1162);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    haandvaerkerstatuslist: __WEBPACK_IMPORTED_MODULE_0__haandvaerker_NewStatusListnew__["a" /* default */]
  },
  data: function data() {
    return {
      url: ''
    };
  },
  methods: {
    UpdateProject: function UpdateProject(url) {
      this.url = url;
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  }
});

/***/ }),
/* 1162 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusListnew_vue__ = __webpack_require__(1164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7675e834_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusListnew_vue__ = __webpack_require__(1168);
function injectStyle (ssrContext) {
  __webpack_require__(1163)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NewStatusListnew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7675e834_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_NewStatusListnew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1163 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1164 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__uploads_projectvideo__ = __webpack_require__(1165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__uploads_imagefolder__ = __webpack_require__(312);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);





var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'statuslist',
  components: {
    projectvideo: __WEBPACK_IMPORTED_MODULE_0__uploads_projectvideo__["a" /* default */],
    imagefolder: __WEBPACK_IMPORTED_MODULE_1__uploads_imagefolder__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      status: [],
      isLoadingProject: false,
      sampleReview: [],
      show: false,
      reviewShow: false,
      label: 'Loading...',
      overlay: false,
      projectactive: []
    };
  },
  created: function created() {
    this.Reload();
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.show = true;
      var data = { operation: 'myProjectnew', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (!res.projects) {
          window.userGuiding.track('segment', {
            projects: 'false'
          });
        }
        _this.status = res.projects;
        var m = _this;
        res.projects.forEach(function (a, index) {
          a.images.forEach(function (b) {
            if (b.isPrimary) {
              m.status[index]['pimaryimage'] = b.image;
            }
          });
          if (a.IsActive && a.IsActive !== null) {
            m.projectactive.push(a.title);
          } else {
            m.projectactive.push('notaktiv');
          }
        });
        _this.$emit('UpdateProject', res.url);
        _this.show = false;
      }, function (response) {
        _this.$message({
          type: 'error',
          message: response.body.message
        });
        _this.show = false;
      });
    },
    shareproject: function shareproject(url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    },
    updateprojectactive: function updateprojectactive(item) {
      var _this2 = this;

      var status = 1;
      var textoutput = '';
      var cancelbuttontext = '';
      var confirmbuttontext = '';
      if (item.IsActive && item.IsActive !== null) {
        textoutput = 'Ønsker du at stoppe med at vise projektet på din profil?';
        cancelbuttontext = 'Annuler';
        confirmbuttontext = 'Gem projekt';
        status = 0;
      } else {
        textoutput = 'Ønsker du at vise projektet på din profil ?';
        cancelbuttontext = 'Annuler';
        confirmbuttontext = 'Vis projekt';
        status = 1;
      }
      this.$confirm(textoutput, {
        confirmButtonText: confirmbuttontext,
        cancelButtonText: cancelbuttontext,
        type: 'warning'
      }).then(function () {
        _this2.salesPerson = localStorage.getItem('id_token_portal');
        _this2.haaId = localStorage.getItem('haaid');
        var dataPartner = {
          operation: 'toggle_project',
          salesPerson: _this2.salesPerson,
          levid: _this2.haaId,
          active: status,
          caseid: item.projectid ? item.projectid : ''
        };
        _this2.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this2.$message({
              type: 'success',
              message: 'Success'
            });
            _this2.Reload();
          } else {
            _this2.Reload();
          }
        }, function (response) {
          _this2.$message({
            type: 'error',
            message: response.body.message
          });
        });
      }).catch(function () {});
    },
    delProject: function delProject(item) {
      var _this3 = this;

      var textoutput = '';

      textoutput = 'Er du sikker på, at du vil slette?';

      this.$confirm(textoutput, {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this3.salesPerson = localStorage.getItem('id_token_portal');
        _this3.haaId = localStorage.getItem('haaid');
        var dataPartner = {
          operation: 'delProject',
          salesPerson: _this3.salesPerson,
          levid: _this3.haaId,
          projectid: item.projectid ? item.projectid : ''
        };
        _this3.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this3.$message({
              type: 'success',
              message: 'Success'
            });
            _this3.Reload();
          } else {
            _this3.Reload();
          }
        }, function (response) {
          _this3.show = false;
          _this3.$message({
            type: 'error',
            message: response.body.message
          });
        });
      }).catch(function () {});
    },
    editPorject: function editPorject(item) {
      this.$router.push('/opret-projekt-new/rediger_projekt?id=' + item.projectid);
    },
    delete_video: function delete_video(videoId, projectid) {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'delete_video_project', salesPerson: this.salesPerson, levid: this.haaId, videoId: videoId, projectid: projectid };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    project_service: function project_service(item) {
      var _this5 = this;

      this.isLoadingProject = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'project_update', salesPerson: this.salesPerson, levid: this.haaId, projectid: item.projectid, title: item.title, description: item.description };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        _this5.isLoadingProject = false;
        if (res.success) {
          _this5.hideModal();
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this5.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
          _this5.isLoadingProject = false;
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(project) {
      this.reviewShow = !this.reviewShow;
      this.sampleReview = project;
    },
    hideModal: function hideModal() {
      this.$refs.reviewModal.hide();
    },
    delete_image: function delete_image(imageId, projectid) {
      var _this6 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    rorate_image: function rorate_image(imageId, projectid, image, primary) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    SaveImage: function SaveImage(imageId, projectid) {
      var _this8 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this8.show = false;
        if (res.login === false) {
          _this8.$router.push('/login');
        }
        if (res.success) {
          _this8.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }

});

/***/ }),
/* 1165 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectvideo_vue__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af83c110_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projectvideo_vue__ = __webpack_require__(1167);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projectvideo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_af83c110_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projectvideo_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1166 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projectvideo',
  props: ['project'],
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 62,
        createImageThumbnails: true,
        addRemoveLinks: true,
        acceptedFiles: '.mp4,.mov,.avi,.mpeg4,.flv,.3gpp',
        renameFile: true,
        dictDefaultMessage: '<i class="el-icon-video-camera"></i>  Træk filerne hertil eller klik for at vælge filer'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: ''
    };
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  methods: {
    'showSuccess': function showSuccess(file) {
      this.$emit('Reload');
    },
    change_position: function change_position(imageId, position) {
      this.$emit('moveImage', imageId, position);
    },
    delete_video: function delete_video(videoId) {
      this.$emit('delete_video', videoId, this.project.projectid);
    },
    edit_image: function edit_image(FileLocation, imageId) {
      this.$emit('edit_image', FileLocation, imageId);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('projectid', this.project.projectid);
      formData.append('operation', 'uploadVideoProject');
    }
  }
});

/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"pt-0 pr-1 pb-4 pl-1 h6 open-sans line-height-golden"},[_vm._v("\n    upload video til din profil (Max 60 meg)\n  ")]),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('b-row',_vm._l((_vm.project.videos),function(video){return _c('b-col',{key:video.id,attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-card',{staticClass:"border-0",attrs:{"img-alt":"Profil","img-top":"","bg-variant":"light","data-download":"true"}},[_c('b-card-body',{staticClass:"p-0 border-0"},[_c('div',{staticClass:"d-flex justify-content-between"},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":video.VideoUrl,"allowfullscreen":""}}),_vm._v(" "),_c('div')],1),_vm._v(" "),_c('div',{staticClass:"container text-center"},[_c('b-button',{staticClass:"border-0",attrs:{"variant":"outline-dark"},on:{"click":function($event){return _vm.delete_video(video.id)}}},[_c('i',{staticClass:"el-icon-delete",staticStyle:{"font-size":"20px"},attrs:{"aria-hidden":"true"}})])],1)])],1)],1)}),1)],1),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"projectlist"}},[(_vm.show)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.status),function(project,index){return _c('div',{key:project.id,staticClass:"mb2 mr2 projectcontainer"},[_c('div',{staticClass:"highlights darkblue-border col-12 px2 py3"},[_c('div',{staticClass:"flex p0 m0 col-12"},[_c('p',{staticClass:"h5 semi-bold darkblue line-height-2 mr-auto"},[_vm._v(_vm._s(project.title))])]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden",staticStyle:{"height":"103px"}},[_vm._v(_vm._s(_vm._f("truncate")(project.description,300, '...')))]),_vm._v(" "),(project.pimaryimage)?_c('div',{staticClass:"p0 m0"},[_c('img',{staticClass:"none pointer imageprimary",attrs:{"id":"projectmainimage","width":"100%","src":project.pimaryimage.replace('&rotate=90', '').replace('&rotate=180', '').replace('&rotate=270', '').replace('&rotate=0', '')}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0 mt2 flex justify-center items-center"},[_c('el-radio-group',{attrs:{"size":"medium"},on:{"change":function($event){return _vm.updateprojectactive(project)}},model:{value:(_vm.projectactive[index]),callback:function ($$v) {_vm.$set(_vm.projectactive, index, $$v)},expression:"projectactive[index]"}},[_c('el-radio',{attrs:{"label":project.title}},[_vm._v("Vis på profil")])],1)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('button',{staticClass:"col-12 facebook-button buttonproject white p1 flex justify-center items-center not-rounded border-0 my1",on:{"click":function($event){return _vm.shareproject(project.ProjectURL)}}},[_vm._m(0,true),_vm._v(" "),_c('span',{staticClass:"h6 pl1 mb0"},[_vm._v("Del på Facebook")])]),_vm._v(" "),_c('button',{staticClass:"col-12 action-button border-0 buttonproject p1 flex justify-center items-center not-rounded mb1",on:{"click":function($event){return _vm.editPorject(project)}}},[_c('span',{staticClass:"relative"},[_c('svg',{attrs:{"fill":"currentColor","width":"20","height":"20","viewBox":"0 0 512.00034 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m130.140625 367.523438c-3.898437 3.902343-3.898437 10.230468 0 14.140624 3.910156 3.898438 10.242187 3.898438 14.152344 0 3.898437-3.910156 3.898437-10.238281 0-14.140624-3.910157-3.910157-10.242188-3.910157-14.152344 0zm0 0"}}),_c('path',{attrs:{"d":"m330.34375 511.949219c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-40c-5.519531 0-10 4.476562-10 10 0 5.523437 4.480469 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m409.558594 17.539062c-3.945313 3.945313-331.960938 331.824219-343.054688 342.914063v.003906c-.003906.003907-.007812.007813-.011718.011719-.816407.820312-1.527344 1.871094-1.957032 2.78125l-63.566406 134.40625c-3.128906 6.613281 1.714844 14.292969 9.039062 14.292969h240.339844c5.523438 0 10-4.476563 10-10 0-5.523438-4.476562-10-10-10h-195.96875l94.195313-44.683594c.929687-.4375 1.957031-1.136719 2.765625-1.945313.007812-.007812.015625-.011718.023437-.019531 0 0 .003907-.003906.003907-.003906 13.441406-13.433594 325.777343-325.632813 343.050781-342.898437 23.441406-23.441407 23.445312-61.414063 0-84.863282-23.394531-23.382812-61.460938-23.378906-84.859375.003906zm7.0625 134.34375c-17.589844-17.589843-38.875-38.875-56.574219-56.574218l21.21875-21.210938 56.578125 56.574219zm-327.800782 301.59375-30.4375-30.445312 18.160157-38.394531 50.648437 50.640625zm55.472657-29.382812-56.574219-56.566406 258.183594-258.078125 21.222656 21.222656-208.695312 208.5625c-3.902344 3.902344-3.90625 10.234375-.003907 14.140625 3.902344 3.90625 10.234375 3.910156 14.144531.003906l208.699219-208.5625 21.207031 21.207032zm-94.992188 18.140625 20.335938 20.339844-38.621094 18.320312zm430.976563-353.980469-28.289063 28.277344-56.578125-56.574219 28.289063-28.273437c15.597656-15.59375 40.980469-15.59375 56.574219-.003906 15.628906 15.625 15.632812 40.949218.003906 56.574218zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 pl1 mb0"},[_vm._v("Rediger")])])])])])}),_vm._v(" "),(_vm.status.length < 1)?_c('div',{staticClass:"my4"},[_c('p',{staticClass:"center"},[_vm._v("Intet projekt i øjeblikket.")])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"reviewModal",attrs:{"lazy":""},model:{value:(_vm.reviewShow),callback:function ($$v) {_vm.reviewShow=$$v},expression:"reviewShow"}},[_c('div',{staticClass:"col-12 p2",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:" line-height-golden"},[_c('span',{staticClass:"block h6 darkblue regular mb1"},[_vm._v("Rediger")]),_vm._v(" "),_c('span',{staticClass:"h4 primarycolor"},[_vm._v(_vm._s(_vm.sampleReview.title))])])]),_vm._v(" "),_c('div',{staticClass:"modal-content border-none"},[_c('div',{staticClass:"flex flex-column mb3 px2"},[_c('p',{staticClass:"h6 darkblue  line-height-1 mb1"},[_vm._v("Titel")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background darkblue  h5 regular border-none not-rounded",attrs:{"type":"text","required":""},model:{value:(_vm.sampleReview.title),callback:function ($$v) {_vm.$set(_vm.sampleReview, "title", $$v)},expression:"sampleReview.title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2 px2"},[_c('p',{staticClass:"h6 darkblue  line-height-1 mb1"},[_vm._v("Kommentar")]),_vm._v(" "),_c('b-textarea',{staticClass:"muted-background darkblue h5 regular  p2 line-height-golden not-rounded border-none",attrs:{"variant":"secondary","id":"textarea1","rows":8,"required":""},model:{value:(_vm.sampleReview.description),callback:function ($$v) {_vm.$set(_vm.sampleReview, "description", $$v)},expression:"sampleReview.description"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"col-6 pr1"},[_c('button',{staticClass:"col-12 outlined-disabled-button p2 flex justify-center items-center  h5 not-rounded",attrs:{"slot":"modal-cancel","type":"buttom"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('span',[_vm._v("←")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_vm._v("Tilbage")])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[_c('b-btn',{staticClass:"col-12 action-button p2 flex justify-center items-center  h5 regular not-rounded",attrs:{"slot":"modal-ok","type":"submit","disabled":_vm.isLoadingProject},on:{"click":function($event){return _vm.project_service(_vm.sampleReview)}},slot:"modal-ok"},[_c('span',[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])],1)])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1 relative"},[_c('img',{attrs:{"src":"/static/svg/facebook.svg","alt":"","width":"20","height":"20"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[_c('div',{staticClass:"clearfix notosans px2 mb2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix flex flex-column p2 pb4 pl4 mp0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 mt3"},[_c('haandvaerkerstatuslist',{on:{"UpdateProject":_vm.UpdateProject}})],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Opdater dine projekter")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("Opdaterer du dine projekter eller uploader du billeder, så vil ændringerne være synlige for kunderne på håndværker.dk i løbet af 24 timer.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1170 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProjects_vue__ = __webpack_require__(1172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7ef0e9e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProjects_vue__ = __webpack_require__(1173);
function injectStyle (ssrContext) {
  __webpack_require__(1171)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CustomerProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7ef0e9e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CustomerProjects_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1171 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  data: function data() {
    return {
      salesPerson: '',
      currentDate: '',
      changeProjectLoading: false,
      icon: 'easternblue mr2 menu-icon-plans',
      introVisible: true,
      customColor: '#4DCF55',
      title: 'My Project - Title',
      dynamicTags: [],
      inputVisible: false,
      inputValue: '',
      showmodal: false,
      submitted: false,
      date: '',
      projectsData: [],

      checklistOptions: [],
      options: [],
      value: [],
      changeProjectVisible: false,
      event: {
        title: ''
      },
      addFilesVisible: false,
      fileList: [],
      changeProjectForm: {
        project: ''
      },
      currentProject: '',
      currentName: '',
      tagsData: [],
      tagsDataOptions: []
    };
  },
  mounted: function mounted() {
    this.salesPerson = localStorage.getItem('id_token_portal');
  },

  methods: {
    openProjectModal: function openProjectModal() {
      this.changeProjectVisible = true;
    },
    closeProjectModal: function closeProjectModal() {
      this.submitted = false;
      this.changeProjectVisible = false;
    },
    openFilesModal: function openFilesModal() {
      this.addFilesVisible = true;
    },
    closeFilesModal: function closeFilesModal() {
      this.addFilesVisible = false;
    },
    launchProjectWizard: function launchProjectWizard() {
      this.$router.push('/create-project/step=1');
    },
    seeTimeline: function seeTimeline() {
      this.$router.push('/project-timeline');
    },
    nowDate: function nowDate() {
      var formattedDate = new Date().toJSON().slice(0, 10).replace(/-/g, '/');
      this.currentDate = formattedDate;
    },
    seeCalendar: function seeCalendar() {
      this.$router.push('/mycalendar');
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.saveTagInput.focus();
      });
    },
    hideInput: function hideInput() {
      this.inputVisible = false;
    },
    removeEvent: function removeEvent() {},
    handleSubmit: function handleSubmit() {
      this.submitted = true;

      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      } else {
        var title = this.event.title;
        this.calendarEvents = this.calendarEvents.concat({
          id: this.calendarEvents.length + 1,
          title: title,
          start: this.date,
          backgroundColor: '#626ed4'
        });
        this.showmodal = false;
        this.newEventData = {};
      }
      this.submitted = false;
      this.event = {};
    },
    addFileSubmit: function addFileSubmit() {
      var newfile = this.file;
      if (newfile) {
        this.fileList.push(newfile);
      }
    },
    handleRemove: function handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview: function handlePreview(file) {
      console.log(file);
    },
    redirectToOffer: function redirectToOffer() {
      this.$router.push('/offer');
    },
    handleInputConfirm: function handleInputConfirm(type) {
      var inputValue = this.inputValue;
      var tags = this.tagsData;
      var tagExist = false;
      if (inputValue.trim().length > 0) {
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].TAG_NAME === inputValue) {
            tagExist = true;
          }
        }
        if (type === 'keyup') {
          if (!tagExist) {
            if (type === 'keyup') {
              this.addTag(inputValue);
            }
            this.inputVisible = false;
            this.inputValue = '';
          } else {
            this.$message({
              type: 'error',
              message: 'Already exists'
            });
          }
        }
      } else {
        this.inputVisible = false;
        this.inputValue = '';
      }
    },
    displayApproved: function displayApproved() {
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$http.options.root + '/partner/project/approved', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        console.log(response);
      }, function (err) {
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 1173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"customer-projects"}},[_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col col-12 px0"},[_c('div',{staticClass:"clearfix border shakespeare-border--light flex justify-start items-center mb1"},[_c('div',{staticClass:"col-12 flex flex-column p2 highlights"},[_c('div',{staticClass:"flex justify-start items-center pt2 pr2"},[[(_vm.currentName)?_c('div',[_c('p',{staticClass:"h6 book battelship p0 m0"},[_vm._v("Current project")]),_vm._v(" "),_c('p',{staticClass:"h1 regular easternblue mr4 line-height-2"},[_vm._v(_vm._s(this.currentName))])]):_c('div',[_c('p',{staticClass:"h1 regular easternblue mr4 line-height-2"},[_vm._v("No Project Selected")])])],_vm._v(" "),_c('button',{staticClass:"ml4 flex-none primary-button p2 line-height-1 regular mb0",on:{"click":function($event){return _vm.openProjectModal()}}},[_vm._v("Change project\n              "),_vm._m(0)])],2)])]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap"},[(_vm.introVisible)?_c('div',{staticClass:"flex flex-1 mb2 pr1 pl0",staticStyle:{"min-width":"50%","max-width":"50%"}},[_c('div',{staticClass:"col-12 flex-1 p3 highlights border shakespeare-border--light"},[_vm._m(1),_vm._v(" "),_c('h5',{staticClass:"regular darkblue mt1 mb1"},[_vm._v("Addendum")]),_vm._v(" "),_c('p',{staticClass:"darkblue"},[_vm._v("Contract")]),_vm._v(" "),_c('div',{staticClass:"flex mb2"},[_c('div',{staticClass:"col-7 p0 flex mr4"},[_c('table',{staticClass:"col-12 p0"},[_c('tbody',[_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("Addendum 1 / Sink")]),_vm._v(" "),_c('td',[_c('el-tag',{key:1,staticClass:"mb1",attrs:{"type":"success","effect":"dark"}},[_vm._v("\n                          Approved\n                        ")])],1)]),_vm._v(" "),_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("Addendum 1 / Sink")]),_vm._v(" "),_c('td',[_c('el-tag',{key:1,staticClass:"mb1",attrs:{"type":"warning","effect":"dark"}},[_vm._v("\n                          Pending\n                        ")])],1)]),_vm._v(" "),_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("Addendum 1 / Sink")]),_vm._v(" "),_c('td',[_c('el-tag',{key:1,staticClass:"mb1",attrs:{"type":"danger","effect":"dark"}},[_vm._v("\n                          Declined\n                        ")])],1)])])])]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_vm._m(3)])]):_vm._e(),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('div',{staticClass:"flex flex-1 mb2 px1",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light"},[_vm._m(7),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto"},[_c('el-progress',{attrs:{"stroke-width":7,"percentage":43,"max":100,"color":_vm.customColor}})],1)])]),_vm._v(" "),_c('div',{staticClass:"flex flex-1 mb2 px1",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light"},[_vm._m(8),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")]),_vm._v(" "),_c('div',{staticClass:"col-11 mx-auto"},[_c('el-progress',{attrs:{"stroke-width":7,"percentage":43,"max":100,"color":_vm.customColor}})],1)])]),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"hide flex flex-1 mb2 px1"},[_c('div',{staticClass:"p2 py3 highlights border shakespeare-border--light"},[_c('div',{staticClass:"col-12 px0 flex justify-start items-start"},[_c('div',{staticClass:"pointer flex flex-none justify-start items-center",on:{"click":function($event){return _vm.seeTimeline()}}},[_c('h4',{staticClass:"regular mx2 my0 flex-none"})]),_vm._v(" "),_vm._m(10)])])])])])]),_vm._v(" "),_c('b-modal',{attrs:{"centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},model:{value:(_vm.changeProjectVisible),callback:function ($$v) {_vm.changeProjectVisible=$$v},expression:"changeProjectVisible"}},[_c('div',{staticClass:"col-12 px2 pt1 mb3"},[(_vm.changeProjectLoading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"col-12 p0 flex justify-between items-center pt1 mb2"},[_c('p',{staticClass:"h5 cyprus regular line-height-1 m0 p0"},[_vm._v("Change Project")]),_vm._v(" "),_c('button',{staticClass:"right h4 p0 primary-white-button",on:{"click":function($event){return _vm.closeProjectModal()}}},[_c('i',{staticClass:"el-icon-close"})])]),_vm._v(" "),_c('el-select',{staticClass:"col-12 p0",class:{ 'is-invalid': _vm.submitted && _vm.$v.changeProjectForm.project.$error },attrs:{"placeholder":"Select","no-data-text":"No data"},model:{value:(_vm.changeProjectForm.project),callback:function ($$v) {_vm.$set(_vm.changeProjectForm, "project", $$v)},expression:"changeProjectForm.project"}},_vm._l((_vm.projectsData),function(project,index){return _c('el-option',{key:index,attrs:{"label":project.DESCRIPTION,"value":project.ID}})}),1)],1)]),_vm._v(" "),(!_vm.changeProjectLoading)?_c('div',{staticClass:"col-12 px2 py3 flex justify-between"},[_c('button',{staticClass:"h5 p2 regular primary-button",on:{"click":function($event){return _vm.closeProjectModal()}}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v("\n        Afbryd\n      ")]),_vm._v(" "),_c('button',{staticClass:"h5 p2 regular action-button",on:{"click":function($event){return _vm.changeProject()}}},[_vm._v("Ok\n        "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]):_vm._e()]),_vm._v(" "),_c('b-modal',{attrs:{"size":"lg","centered":"","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""},model:{value:(_vm.addFilesVisible),callback:function ($$v) {_vm.addFilesVisible=$$v},expression:"addFilesVisible"}},[_c('div',{attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"col-12 px2 flex justify-between items-center pt1"},[_c('p',{staticClass:"h5 cyprus regular line-height-1 m0 p0"},[_vm._v("Add Files")]),_vm._v(" "),_c('button',{staticClass:"right h4 p0 primary-white-button",on:{"click":function($event){return _vm.closeFilesModal()}}},[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix"},[_c('el-upload',{staticClass:"projectFileUpload",attrs:{"action":"/","drag":"","on-preview":_vm.handlePreview,"on-remove":_vm.handleRemove,"file-list":_vm.fileList,"multiple":""},on:{"submit":function($event){return _vm.addFileSubmit()}}},[_c('i',{staticClass:"el-icon-upload cyprus"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text"},[_vm._v("Drop file here or "),_c('em',[_vm._v("click to upload")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip h6 regular easternblue line-height-1 mt2 center",attrs:{"slot":"tip"},slot:"tip"},[_vm._v("jpg/png files with a size less than 500kb")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12"},_vm._l((_vm.fileList),function(file,index){return _c('div',{key:index},[_vm._v("\n            "+_vm._s(file)+"\n          ")])}),0),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-column"},[_c('p',{staticClass:"h5 easternblue regular line-height-1 m0 p0"},[_vm._v("Project files")]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex justify-between"},[_c('div',[_c('p',{staticClass:"cyprus line-height-1"},[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"el-icon-picture-outline"})]),_vm._v("\n              ImageFileName.jpg")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"green el-icon-success"})])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex justify-between"},[_c('div',[_c('p',{staticClass:"cyprus line-height-1"},[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"el-icon-document"})]),_vm._v("\n              DocumentFileName.pdf")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"green el-icon-success"})])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex justify-between"},[_c('div',[_c('p',{staticClass:"cyprus line-height-1"},[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"el-icon-data-analysis"})]),_vm._v("\n              ChartFileName.xls")])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h5 mr1 mb0 p0 line-height-1"},[_c('i',{staticClass:"green el-icon-success"})])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px2 py3 flex justify-between"},[_c('button',{staticClass:"outlined-disabled-button button-padding",on:{"click":function($event){return _vm.closeFilesModal()}}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v("\n        Afbryd\n      ")]),_vm._v(" "),_c('button',{staticClass:"action-button button-padding",on:{"click":function($event){return _vm.closeFilesModal()}}},[_vm._v("Ok\n        "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center mb2"},[_c('img',{staticClass:"mr1",attrs:{"src":"/static/svg/metro-warning.svg","width":"40"}}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('h3',{staticClass:"regular cyprus m0 mr1"},[_vm._v("Deficiency List")]),_vm._v(" "),_c('div',{staticClass:"white border circle red-background flex justify-center items-end",staticStyle:{"width":"20px","height":"20px"}},[_c('span',{staticClass:"small center"},[_vm._v("2")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 p0"},[_c('table',{staticClass:"col-12 p0"},[_c('tbody',[_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("New Bathroom")]),_vm._v(" "),_c('td',{staticClass:"text-right pointer"},[_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/feather-download.svg","width":"15"}})])]),_vm._v(" "),_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("Sink Repair")]),_vm._v(" "),_c('td',{staticClass:"text-right pointer"},[_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/feather-download.svg","width":"15"}})])]),_vm._v(" "),_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("New Tiles")]),_vm._v(" "),_c('td',{staticClass:"text-right pointer"},[_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/feather-download.svg","width":"15"}})])]),_vm._v(" "),_c('tr',{staticClass:"pb1"},[_c('td',{staticClass:"darkblue pr1"},[_vm._v("Lobby Facade")]),_vm._v(" "),_c('td',{staticClass:"text-right pointer"},[_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/feather-download.svg","width":"15"}})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"h5 p2 regular action-button button-padding"},[_vm._v("Addendum to contract\n              "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"h5 regular el-icon-circle-plus-outline m0"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 mb2",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light"},[_c('div',{staticClass:"center my2"},[_c('img',{staticClass:"mx-auto mb1",attrs:{"src":"/static/svg/map-finance.svg","height":"40"}}),_vm._v(" "),_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Finance")])]),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod\n            tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,\n            quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n            consequat.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 mb2 px1",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light"},[_c('div',{staticClass:"center my2"},[_c('img',{staticClass:"mx-auto mb1",attrs:{"src":"/static/svg/wallet-new.svg","height":"50"}}),_vm._v(" "),_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Wallet")])]),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 mb2 px1",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 flex-none p2 pb3 highlights border shakespeare-border--light"},[_c('div',{staticClass:"center my2"},[_c('img',{staticClass:"mx-auto mb1",attrs:{"src":"/static/svg/pictures-new.svg","height":"50"}}),_vm._v(" "),_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Pictures")])]),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center my2"},[_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Project Open")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"center my2"},[_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Recent Project")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex flex-1 mb2 px1",staticStyle:{"min-width":"25%","max-width":"25%"}},[_c('div',{staticClass:"projectSection pointer col-12 highlights border shakespeare-border--light p2"},[_c('div',{staticClass:"center my2"},[_c('img',{staticClass:"mx-auto mb1",attrs:{"src":"/static/svg/speech-bubble.svg","height":"60"}}),_vm._v(" "),_c('h4',{staticClass:"darkblue mt1"},[_vm._v("Project Message")])]),_vm._v(" "),_c('p',{staticClass:"col-11 mx-auto center mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px2"},[_c('p',{staticClass:"mediumgrey"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Eos ullam illum beatae, nam tenetur natus, autem similique illo quis possimus, maxime saepe ratione aliquid quaerat commodi sequi quisquam quidem cupiditate!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchase_vue__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b503ba_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Purchase_vue__ = __webpack_require__(1181);
function injectStyle (ssrContext) {
  __webpack_require__(1175)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06b503ba"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Purchase_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06b503ba_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_Purchase_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1175 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1176 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__purchase_Koeb__ = __webpack_require__(1177);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    purchase: __WEBPACK_IMPORTED_MODULE_0__purchase_Koeb__["a" /* default */]
  }
});

/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Koeb_vue__ = __webpack_require__(1179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1e34a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Koeb_vue__ = __webpack_require__(1180);
function injectStyle (ssrContext) {
  __webpack_require__(1178)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Koeb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3d1e34a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Koeb_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1178 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1179 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'purchase',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  data: function data() {
    return {
      selected: '',
      creditCard: 'Dankort',
      show: false,
      label: 'Loading...',
      picked: '',
      visiblecredit: 0,
      overlay: true,
      salesPerson: '',
      packageOptions: [],
      tableFields: [{ key: 'productname', label: 'Pakke' }, { key: 'timeinvoice', label: 'Dato' }, { key: 'status', label: 'Status' }],
      items: []
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'mykoebInfo', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.packageOptions = res.package;
        _this.items = res.sale;
        _this.visiblecredit = res.visiblecredit;
        console.log(res);
      }, function (response) {
        alert('error');
      });
    },
    onSubmitPurchaseInfo: function onSubmitPurchaseInfo(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.picked === '') {
        var obj = {
          title: 'Fejl',
          message: 'Vælg Pakke',
          type: 'error'
        };
        this.$refs.simplert.openSimplert(obj);
        return false;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addSale', salesPerson: this.salesPerson, levid: this.haaId, package: this.picked };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {
            this.$parent.Reload();
            this.$parent.picked = '';
          };
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn
          };
          _this2.$refs.simplert.openSimplert(_obj);
        } else {
          var _obj2 = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error'
          };
          _this2.$refs.simplert.openSimplert(_obj2);
        }
      }, function (response) {
        alert('error');
      });
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    }
  }
});

/***/ }),
/* 1180 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3"},[_c('form',{on:{"submit":_vm.onSubmitPurchaseInfo,"reset":_vm.resetForm}},[_c('fieldset',[_c('div',{staticClass:"clearfix flex flex-column"},_vm._l((_vm.packageOptions),function(packageOption){return _c('div',{key:packageOption.id},[_c('div',{staticClass:"flex justify-start items-start mb3",attrs:{"for":packageOption.id}},[_c('div',[[(packageOption.id == '1')?_c('div',{staticClass:"flex-auto"},[_c('span',{staticClass:"mediumgrey"},[_c('svg',{attrs:{"fill":"currentColor","width":"64","height":"64","viewBox":"0 0 496 496","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"}}),_c('path',{attrs:{"d":"m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"}}),_c('path',{attrs:{"d":"m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"}})])])]):_vm._e(),_vm._v(" "),(packageOption.id == '2')?_c('div',{staticClass:"flex-auto"},[_c('span',{staticClass:"mintgreen"},[_c('svg',{attrs:{"fill":"currentColor","width":"64","height":"64","viewBox":"0 0 496 496","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"}}),_c('path',{attrs:{"d":"m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"}}),_c('path',{attrs:{"d":"m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"}})])])]):_vm._e(),_vm._v(" "),(packageOption.id == '3')?_c('div',{staticClass:"flex-auto"},[_c('span',{staticClass:"primarycolor"},[_c('svg',{attrs:{"fill":"currentColor","width":"64","height":"64","viewBox":"0 0 496 496","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m224 176c13.230469 0 24-10.769531 24-24s-10.769531-24-24-24-24 10.769531-24 24 10.769531 24 24 24zm0-32c4.414062 0 8 3.585938 8 8s-3.585938 8-8 8-8-3.585938-8-8 3.585938-8 8-8zm0 0"}}),_c('path',{attrs:{"d":"m488 240h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-40v-40c0-4.425781-3.574219-8-8-8h-185.617188c1.058594-5.167969 1.617188-10.519531 1.617188-16 0-44.113281-35.886719-80-80-80s-80 35.886719-80 80 35.886719 80 80 80c5.480469 0 10.832031-.558594 16-1.617188v185.617188c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h40v40c0 4.425781 3.574219 8 8 8h240c4.425781 0 8-3.574219 8-8v-240c0-4.425781-3.574219-8-8-8zm-293.625 16h-68.75l34.375-29.464844zm-5.382812-25.679688 19.007812-19.007812 21.9375 21.933594-18.21875 16.5625zm106.742187-35.273437 40.265625 40.265625v20.6875h-107.304688zm-279.734375-115.046875c0-35.289062 28.710938-64 64-64s64 28.710938 64 64-28.710938 64-64 64-64-28.710938-64-64zm137.273438 32h182.726562v100.6875l-34.34375-34.34375c-3.015625-3.023438-7.878906-3.136719-11.039062-.265625l-48.832032 44.394531-28.128906-28.128906c-3.128906-3.128906-8.183594-3.128906-11.3125 0l-25.535156 25.535156-11.609375-9.949218c-2.984375-2.578126-7.421875-2.578126-10.40625 0l-42.792969 36.6875v-93.34375c18.40625-8.074219 33.199219-22.867188 41.273438-41.273438zm-41.273438 160h224v64h-224zm48 80h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm48 48h184c4.425781 0 8-3.574219 8-8v-184h32v224h-224zm272 80h-224v-32h184c4.425781 0 8-3.574219 8-8v-184h32zm0 0"}}),_c('path',{attrs:{"d":"m128 88v-16h-40v-40h-16v40h-40v16h40v40h16v-40zm0 0"}})])])]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-2"},[_vm._v("\n                "+_vm._s(packageOption.productname)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue gibson line-height-4 flex justify-start items-center"},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"4px"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.picked),expression:"picked"}],staticClass:"radion_select mr-1",attrs:{"type":"radio","id":packageOption.id},domProps:{"value":packageOption.id,"checked":_vm._q(_vm.picked,packageOption.id)},on:{"change":function($event){_vm.picked=packageOption.id}}})]),_vm._v(" "),_c('span',[_vm._v(_vm._s(packageOption.total)+" kr.")])])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson line-height-3 regular"},[_vm._v("\n              "+_vm._s(packageOption.description)+"\n            ")])])])}),0),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 border-none not-rounded standard-button p2 h5 gibson flex justify-center items-center",attrs:{"type":"submit"}},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-credit-card-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M20 4H0V2a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2v2zm0 3v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h20zM4 9a1 1 0 1 0 0 2h1a1 1 0 0 0 0-2H4zm5 0a1 1 0 1 0 0 2h5a1 1 0 0 0 0-2H9z"}})])]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Køb projekt")])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix"},_vm._l((_vm.items),function(item){return _c('div',{staticClass:"flex flex-column p3 py4 muted-background mb3 shadow"},[_c('div',[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("Produkt")]),_vm._v(" "),_c('p',{staticClass:"semi-bold gibson h5 line-height-3"},[_vm._v(_vm._s(item.productname))]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("Købsdato")]),_vm._v(" "),_c('p',{staticClass:"semi-bold gibson h5 line-height-3"},[_vm._v(_vm._s(_vm.moment(item.timeinvoice).locale('da').format('LL')))]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("Status")]),_vm._v(" "),_c('p',{staticClass:"semi-bold gibson h5 line-height-3"},[_vm._v(_vm._s(item.status))])])])}),0)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt4 mb2"},[_c('p',{staticClass:"h4 primarycolor gibson"},[_vm._v("\n      Dine købte projekter\n    ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 pb4 mb2 shadow"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[_c('purchase')],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 p2"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson"},[_vm._v("\n            Køb flere projekter\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1182 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anbefalktohomeowners_vue__ = __webpack_require__(1184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ce4086_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_anbefalktohomeowners_vue__ = __webpack_require__(1185);
function injectStyle (ssrContext) {
  __webpack_require__(1183)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_anbefalktohomeowners_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_72ce4086_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_anbefalktohomeowners_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1183 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1184 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_rate_it__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AnbefaltoHomeowners',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default.a,
    StarRating: __WEBPACK_IMPORTED_MODULE_3_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__["ImageRating"]
  },
  computed: {},
  data: function data() {
    return {
      loading: false,
      anbefalform: {
        Kommunikation: 0,
        Overholdte: 0,
        Realistike: 0,
        Samarbejdsvillighed: 0,
        sikkerhed: 0,
        Adgang: 0
      },
      TotalGrade: 0,
      step2form: {
        headline: '',
        comment: ''
      },
      rulesstep2form: {
        headline: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit overskrift',
          trigger: 'blur'
        }],
        comment: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en kommentar',
          trigger: 'blur'
        }]
      },
      haaid: '',
      salesPerson: '',
      customerID: '',
      norateerror: false
    };
  },
  watch: {
    'anbefalform.Kommunikation': function anbefalformKommunikation(newVal, oldVal) {
      this.updateGrade();
    },
    'anbefalform.Overholdte': function anbefalformOverholdte(newVal, oldVal) {
      this.updateGrade();
    },
    'anbefalform.Realistike': function anbefalformRealistike(newVal, oldVal) {
      this.updateGrade();
    },
    'anbefalform.Samarbejdsvillighed': function anbefalformSamarbejdsvillighed(newVal, oldVal) {
      this.updateGrade();
    },
    'anbefalform.sikkerhed': function anbefalformSikkerhed(newVal, oldVal) {
      this.updateGrade();
    },
    'anbefalform.Adgang': function anbefalformAdgang(newVal, oldVal) {
      this.updateGrade();
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.customerID = this.$route.query.cid;
  },

  methods: {
    nextStep: function nextStep() {
      if (this.TotalGrade === 0 && this.$refs.anbefalhomeowners.activeTabIndex === 0) {
        this.norateerror = true;
        return false;
      }
      this.$refs.anbefalhomeowners.nextTab();
    },
    backstep: function backstep() {
      this.$refs.anbefalhomeowners.prevTab();
    },
    updateGrade: function updateGrade() {
      this.norateerror = false;
      this.TotalGrade = this.roundToTwo((this.anbefalform.Kommunikation + this.anbefalform.Overholdte + this.anbefalform.Realistike + this.anbefalform.Samarbejdsvillighed + this.anbefalform.sikkerhed + this.anbefalform.Adgang) / 6);
    },
    roundToTwo: function roundToTwo(num) {
      return Math.round(num * 10) / 10;
    },
    gotomenikunder: function gotomenikunder() {
      this.$router.push('/alle-moeder');
    },
    savereview: function savereview() {
      var _this = this;

      var error = 0;
      this.$refs['rulesstep2forms'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1 && this.customerID !== '') {
        return;
      }
      this.$confirm('Indsende denne anmeldelse?', {
        confirmButtonText: 'Indsend',
        cancelButtonText: 'Annuller',
        type: 'warning'
      }).then(function () {
        _this.haaid = localStorage.getItem('haaid');
        _this.salesPerson = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this.salesPerson
        };
        var data = {
          UF_HEADLINE: _this.step2form.headline,
          UF_COMMENT: _this.step2form.comment,
          UF_ENTERPRISE_SUM: 0,
          UF_CUSTOMER_ID: parseInt(_this.customerID),
          UF_RATING_COMMUNICATION: _this.anbefalform.Kommunikation,
          UF_RATING_TIME: _this.anbefalform.Overholdte,
          UF_RATING_ACCESS: _this.anbefalform.Adgang,
          UF_RATING_REALISTIC_EXPECTATIONS: _this.anbefalform.Realistike,
          UF_RATING_FINANCIAL_SECURITY: _this.anbefalform.sikkerhed,
          UF_RATING_COLLABORATION: _this.anbefalform.Samarbejdsvillighed
        };
        _this.$http.post(_this.$bitrixapi + 'partner/SavePartnerReviewonHomeowner', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this.$router.push('/anbefalinger-sammendrag');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
      }).catch(function () {
        if (_this.editingdraft === 0) {
          _this.addglow();
        } else if (_this.editingdraft === 1) {
          _this.updatetilbud();
        }
      });
    }
  }
});

/***/ }),
/* 1185 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px2",attrs:{"id":"anbefalktohomeowners"}},[_c('div',{staticClass:"mt2 pointer"},[_c('i',{staticClass:"el-icon-back h4",on:{"click":function($event){return _vm.gotomenikunder()}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('form-wizard',{ref:"anbefalhomeowners",attrs:{"title":"","subtitle":"","shape":"circle","color":"rgba(25, 163, 192, 1.0)","error-color":"rgba(207,0,15,1.0)","finishButtonText":"Bekræft"}},[_c('tab-content',{attrs:{"title":"1 ud af 4"}},[_c('div',{staticClass:"notosans"},[_c('div',[_c('el-form',{ref:"mainanbefalform",staticClass:"md-col-11 lg-col-11 sm-col-12 mx-auto darkblue",attrs:{"id":"cvrfrom","label-position":"top"}},[_c('div',{staticClass:"flex flex-column mt2 max-width-5 mx-auto px4 py3 border primarycolor-border"},[_c('div',{staticClass:"mb2 p0 mp0 flex"},[_c('div',{staticClass:"flex flex-column mr-auto"},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Kommunikation")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("Svarprocent for kommunikation. - Er boligejer lydhør over for dialoger med håndværkeren, for at de kan afslutte deres projekt korrekt?")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Kommunikation),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Kommunikation", $$v)},expression:"anbefalform.Kommunikation"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 p0 flex col-12 "},[_c('div',{staticClass:"flex flex-column mr-auto "},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Overholdte Tidplanerne")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("Aktualitet for møder og tidsplan. - Overholdt husejeren planlagte møder vedrørende projektet?")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Overholdte),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Overholdte", $$v)},expression:"anbefalform.Overholdte"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 p0 mp0 flex col-12 "},[_c('div',{staticClass:"flex flex-column mr-auto "},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Realistike forventninger")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("Forventninger: Opgav husejeren ærlige og realistiske projektdetaljer og deadlines?")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Realistike),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Realistike", $$v)},expression:"anbefalform.Realistike"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 p0 flex col-12 "},[_c('div',{staticClass:"flex flex-column mr-auto "},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Samarbejdsvillighed")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("Var husejeren nem at arbejde med?")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Samarbejdsvillighed),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Samarbejdsvillighed", $$v)},expression:"anbefalform.Samarbejdsvillighed"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 p0 mp0 flex col-12 "},[_c('div',{staticClass:"flex flex-column mr-auto "},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Økomonisk sikkerhed ")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("Var husejeren i stand til at betale til tiden for deres projekter, eller satte husejeren et realistisk budget?")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.sikkerhed),callback:function ($$v) {_vm.$set(_vm.anbefalform, "sikkerhed", $$v)},expression:"anbefalform.sikkerhed"}})],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 p0 flex col-12 "},[_c('div',{staticClass:"flex flex-column mr-auto "},[_c('label',{staticClass:"semi-bold h5 m0"},[_vm._v("Adgang til arbejdet")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"11px"}},[_vm._v("var der plads til at kunne udføre arbejdet")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":1,"item-size":30,"spacing":4},model:{value:(_vm.anbefalform.Adgang),callback:function ($$v) {_vm.$set(_vm.anbefalform, "Adgang", $$v)},expression:"anbefalform.Adgang"}})],1)]),_vm._v(" "),(_vm.norateerror)?_c('el-alert',{attrs:{"title":"Udfyld venligst en af ​​satserne","type":"error","closable":false,"show-icon":""}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"mt3 p0 flex col-12 border primarycolor-border px4 py3 "},[_c('div',{staticClass:"flex flex-column mr-auto"},[_c('label',{staticClass:"semi-bold h4"},[_vm._v("Din samlede vurdering")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"read-only":true,"increment":0.5,"item-size":40,"spacing":4},model:{value:(_vm.TotalGrade),callback:function ($$v) {_vm.TotalGrade=$$v},expression:"TotalGrade"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex mobile-flex-column my3 "},[_c('button',{staticClass:"mt2 not-rounded md-col-4 lg-col-4 sm-col-12 action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.nextStep()}}},[_vm._v("Næste "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"2 ud af 2"}},[_c('div',{staticClass:"highlights max-width-2 mx-auto"},[_c('el-form',{ref:"rulesstep2forms",staticClass:"max-with-4 sm-col-12 mx-auto p3",attrs:{"id":"cvrfrom","model":_vm.step2form,"rules":_vm.rulesstep2form,"label-position":"top"}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none",attrs:{"label":"Title","id":"Firmanavn","prop":"headline"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"placeholder":"Giv din anbefaling en titel. fx Nyt tag"},model:{value:(_vm.step2form.headline),callback:function ($$v) {_vm.$set(_vm.step2form, "headline", $$v)},expression:"step2form.headline"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none p0 ",attrs:{"id":"comment","label":"Kommentar","prop":"comment"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"type":"textarea","placeholder":"Beskriv hvad du har fået lavet og hvordan du oplevede vores arbejde og service."},model:{value:(_vm.step2form.comment),callback:function ($$v) {_vm.$set(_vm.step2form, "comment", $$v)},expression:"step2form.comment"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex mobile-flex-column my2 "},[_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.backstep()}}},[_c('i',{staticClass:"pr1 el-icon-back"}),_vm._v(" Tilbage\n                    ")]),_vm._v(" "),_c('button',{staticClass:"mt2 not-rounded md-col-5 lg-col-5 sm-col-12 action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.savereview()}}},[_vm._v("Bekræft "),_c('i',{staticClass:"pl1 el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"py4"})],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"notosans"},[_c('p',{staticClass:"h1 darkblue col-12 center line-height-golden mt3 bold "},[_vm._v("Tak fordi du giver din anbefaling")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue col-12 center line-height-golden"},[_vm._v("Din anbefaling er med til at sikre, at fremtidige kunder trygt og sikkert kan vælge den rigtige håndværker til at løse deres opgave.\n              Vi vil meget gerne blive klogere på, hvordan din oplevelse har været og hvordan du vil vurdere håndværkeren.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marketplace2_vue__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709df280_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Marketplace2_vue__ = __webpack_require__(1189);
function injectStyle (ssrContext) {
  __webpack_require__(1187)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Marketplace2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_709df280_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Marketplace2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1187 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketplaceminbolig',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  created: function created() {
    this.haaid = localStorage.getItem('haaid');
    this.projectid = this.$route.query.proid;
    this.showopenjobs = this.$route.query.showminbolig2jobs;
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.getallwizardproduct();
    this.gettaskbitrix();
    this.getenterprise();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      activeName: 'Fagentreprise',
      haaid: '',
      salesPersonbitrix: '',
      jobItems: [],
      loading: false,
      projectid: '',
      itemShow: [],
      itemSelect: [],
      invitationId: '',
      statusjob: 'pending',
      jobfilter: 'pending',
      openjobs: [],
      filteredItems: [],
      loadingreserve: false,
      showopenjobs: '',
      productlistforpricearr: [],
      primaryproductindustryname: {},
      itemsjobindustry: {},
      project_id: '',
      enterpriseid: '',
      productlistnotforpricearr: []
    };
  },

  watch: {
    'jobfilter': function jobfilter(newVal, oldVal) {
      this.getfilter(newVal);
    }
  },
  methods: {
    displayProjects: function displayProjects() {
      var _this = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projectInvitations', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (response.body.success) {
          if (res.length > 0) {
            _this.jobItems = res;
            _this.loading = false;
            if (typeof _this.projectid !== 'undefined') {
              _this.openselectitem();
            }
            _this.getfilter('pending');
          } else {
            _this.loading = false;
          }
        } else {
          _this.$message({
            type: 'error',
            message: response.body.message
          });
          _this.loading = false;
        }
      }, function (response) {
        _this.$message({
          type: 'error',
          message: response.body.message
        });
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this.refreshtoken();
          setTimeout(function () {
            _this.displayProjects();
          }, 1000);
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this2.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this2.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this2.$router.push('/login');
      });
    },
    getfilter: function getfilter(text) {
      var filtereditems = [];
      filtereditems = this.jobItems.filter(function (a) {
        return a.STATUS === text;
      });
      this.filteredItems = filtereditems;
      this.openjobs = [];
    },
    checkimage: function checkimage(key) {
      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = 'static/img/0.jpg';
    },
    openselectitem: function openselectitem() {
      var item = [];
      var thisvar = this;
      item = this.jobItems.filter(function (a) {
        return a.PROJECT.ID === parseInt(thisvar.projectid);
      });

      this.showItemDetails(item[0]);
    },
    getenterprise: function getenterprise() {
      var _this3 = this;

      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE);
          if (_this3.enterpriseid === 2) {
            _this3.openallpublicjobs('Fagentreprise');
          } else if (_this3.enterpriseid === 3) {
            _this3.openallpublicjobs('all');
          } else {
            _this3.openallpublicjobs('Hovedentreprise');
          }
        }
      }, function (response) {
        var error = response.body.message;
        _this3.$message({
          type: 'error',
          message: error
        });
      });
    },
    showItemDetails: function showItemDetails(item) {
      this.itemSelect = item;
      this.invitationId = item.INVITATION_ID;
      this.itemSelect['name'] = item.PROJECT.NAME;
      this.itemSelect['description'] = item.PROJECT.DESCRIPTION;
      this.itemSelect['addressimage'] = item.PROJECT.ADDRESS.IMAGE;
      this.itemSelect['postnummber'] = item.PROJECT.ADDRESS.POST_NUMBER;
      this.itemSelect['road'] = item.PROJECT.ADDRESS.ROAD;
      this.itemSelect['type'] = 'invitejobs';
      this.$refs.itemModal.show();
    },
    getProductList: function getProductList(projectid, contractid) {
      var _this4 = this;

      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'parentproject';
      var jobindustrysub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

      this.productlistforpricearr = [];
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + projectid + '&contact_id=' + contractid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        for (var index in res) {
          var enterpiserdata = {};
          var noenterpiserdata = {};
          enterpiserdata['industryid'] = index;
          enterpiserdata['industrydetails'] = {};
          noenterpiserdata['industryid'] = index;
          noenterpiserdata['industrydetails'] = {};
          for (var jobindustry in res[index]) {
            if (Number(jobindustry) !== 1062) {
              if (type === 'subproject' && Number(jobindustrysub) === Number(jobindustry)) {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              } else if (type !== 'parentproject' && Number(jobindustrysub) !== Number(jobindustry)) {
                noenterpiserdata['jobindustry'] = jobindustry;
                noenterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
              if (type === 'parentproject') {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
            } else {
              if (type === 'subproject' && Number(jobindustrysub) === Number(jobindustry)) {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
            }
          }
          _this4.productlistforpricearr.push(enterpiserdata);
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(noenterpiserdata['industrydetails']).length > 0) {
            _this4.productlistnotforpricearr.push(noenterpiserdata);
          }
        }
      }, function (response) {
        var error = response.body;
        _this4.$refs.errorMsg.showMsg(error);
      });
    },
    showItemDetailsjobs: function showItemDetailsjobs(item) {
      this.itemSelect = item;
      this.itemSelect['addressimage'] = item.ADDRESS.IMAGE;
      this.itemSelect['postnummber'] = item.ADDRESS.POST_NUMBER;
      this.itemSelect['road'] = item.ADDRESS.ROAD;
      this.itemSelect['type'] = 'marketjobs';
      if (this.itemSelect.PARENT_ID !== 0 && this.itemSelect.PARENT_ID !== null) {
        this.getProductList(this.itemSelect.PARENT_ID, item['HOMEOWNER']['ID'], 'subproject', this.itemSelect.JOB_INDUSTRY);
      } else {
        this.getProductList(item.ID, item['HOMEOWNER']['ID']);
      }
      this.$refs.itemModal.show();
    },
    savereserve: function savereserve() {
      var _this5 = this;

      this.loadingreserve = true;
      this.$confirm('Vil du reservere dette job?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this5.haaid = localStorage.getItem('haaid');
        _this5.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this5.salesPersonbitrix
        };
        var data = {};
        _this5.$http.post(_this5.$bitrixapi + 'partner/project/' + parseInt(_this5.itemSelect.ID) + '/reserve', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this5.loadingreserve = false;
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this5.$refs.simplert.openSimplert(obj);
            _this5.openallpublicjobs();
            _this5.closemodalbitrix();
            _this5.$router.push('/alle-moeder?fromMarketplace=1');
          }
        }, function (response) {
          _this5.closemodal();
          _this5.$message({
            type: 'error',
            message: response.body.message
          });
          console.log('Error: ', response);
        });
      }).catch(function () {});
    },
    saveresond: function saveresond(respond) {
      var _this6 = this;

      var resp = '';
      resp = respond === 1 ? 'Vil du reservere dette job?' : 'Ønsker du at takke nej til dette job?';
      this.$confirm(resp, {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this6.haaid = localStorage.getItem('haaid');
        _this6.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this6.salesPersonbitrix
        };
        var data = {
          invitationId: parseInt(_this6.invitationId)
        };
        _this6.$http.post(_this6.$bitrixapi + 'partner/projectInvitation/' + parseInt(_this6.invitationId) + '?accepted=' + respond, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this6.$refs.simplert.openSimplert(obj);
            _this6.closemodal();
            _this6.displayProjects();
          }
        }, function (response) {
          _this6.closemodal();
          _this6.$message({
            type: 'error',
            message: response.body.message
          });
          console.log('Error: ', response);
        });
      }).catch(function () {});
    },
    closemodalbitrix: function closemodalbitrix() {
      this.$refs.itemModal.hide();
    },
    reserveitem: function reserveitem(item) {
      console.log('item', item);
    },
    openallpublicjobs: function openallpublicjobs() {
      var _this7 = this;

      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Fagentreprise';
      var page = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      this.currentpage = page;
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var addtype = '&type=' + type;
      if (type === 'all') {
        addtype = '';
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects/marketplaceV2?page=' + page + '&size=300' + addtype, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.items;
        if (response.body.success) {
          _this7.filteredItems = [];
          _this7.openjobs = res.filter(function (l) {
            return l.TEST_PROJECT === '1' && l.CONTRACT_ID === null;
          });
          _this7.loading = false;
        }
      }, function (response) {
        _this7.loading = false;
        _this7.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this8 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this8.itemsjobindustry = industryname;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this9 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this9.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this9.$message.error(error);
      });
    }
  }
});

/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"marketplaceminboligbitrix"}},[[_c('div',{staticClass:"clearfix marketplaceItems mpx2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(1)]):_c('div',{staticClass:"flex flex-wrap justify-start mobile-justify-center"},_vm._l((_vm.openjobs),function(item){return _c('div',{key:item.ID,staticClass:"muted-border border shadow px0 mr2 mb2",staticStyle:{"width":"275px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetailsjobs(item)}}},[(item.ADDRESS !== null)?_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"data-key":item.ID,"src":typeof item.ADDRESS.IMAGE !== 'undefined' && item.ADDRESS.IMAGE !== null ? item.ADDRESS.IMAGE : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(item.ID)}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('div',{staticClass:"mintgreen-background py1 line-height-1 block px2 flex relative"},[_c('div',{staticClass:"h6 m0 p0 white semi-bold block mr-auto flex flex-column"},[(item.ADDRESS.ZIP)?_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s(item.ADDRESS.ZIP))]):_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s('Project ID ' + item.ID))]),_vm._v(" "),_c('span',{staticClass:"small darkblue"},[_vm._v(_vm._s(item.MATCHING + '% Match'))])]),_vm._v(" "),_vm._m(2,true)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px1"},[_c('div',{staticClass:"flex flex-column"},[(item.CONTRACT_TYPE === 'Fagentreprise')?_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm.itemsjobindustry[item.JOB_INDUSTRY] + ' Enterprise'))])]),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(item.NAME,63, '...')))])])]):_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_vm._m(3,true),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(item.NAME))])])]),_vm._v(" "),[(item.STATUS !== 'accepted')?_c('p',{staticClass:"font14 darkblue regular line-height-2 mb2",staticStyle:{"height":"60px"}},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.DESCRIPTION,130, '...'))+"\n                    ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1  mb1 flex flex-column"},[_c('span',{staticClass:"block center"},[_vm._v("\n                        ACCEPTERET\n                      ")])])],_vm._v(" "),_vm._m(4,true)],2)])])}),0)])],_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('b-modal',{ref:"itemModal",attrs:{"hide-header":"","lazy":"","size":"lg","id":"minboligjobs2"}},[_c('div',{staticClass:"flex items-center justify-end col-12 p0 m0"},[_c('div',{staticClass:"pointer p2",on:{"click":function($event){return _vm.closemodalbitrix()}}},[_c('i',{staticClass:"el-icon-close h5 "})])]),_vm._v(" "),(_vm.loadingreserve)?_c('div',{staticClass:"clearfix mx-auto"},[_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])]):_c('div',{staticClass:"modal-body-marketplace"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"Se detaljer"}},[_c('div',{staticClass:"relative p2"},[_c('img',{staticClass:"fit block",staticStyle:{"height":"250px","width":"100%","object-fit":"none"},attrs:{"data-key":_vm.itemSelect.ID,"src":typeof _vm.itemSelect.addressimage !== 'undefined' && _vm.itemSelect.addressimage !== null ? _vm.itemSelect.addressimage : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.ID)}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 m2 mx4 darkblue-background opacity-50 p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.zip))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2 px2 mx3"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n                "+_vm._s(_vm.itemSelect.NAME)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.DATE_UPDATED).locale('da').format('LL')))])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.DESCRIPTION))])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Job beskrivelse"}},[_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Din Jobbeskrivelse")])]),_vm._v(" "),_c('div',{staticClass:"bordercece pb3 pt2 px1"},_vm._l((_vm.productlistforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start not-collapsed"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))])]),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('p',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 h6 line-height-golden graymuteddark "},[_vm._v(_vm._s(desc))])])])}),0)],1)})],2):_vm._e()}),0)]),_vm._v(" "),(_vm.itemSelect.CONTRACT_TYPE !== 'Hovedentreprise')?_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[(_vm.productlistnotforpricearr.length > 0 )?_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Andre entrepriser i projektet")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bordercece  pb3 pt2 px1"},_vm._l((_vm.productlistnotforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('p',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 h6 line-height-golden graymuteddark "},[_vm._v(_vm._s(desc))])])])}),0)],1)})],2):_vm._e()}),0)]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('div',{staticClass:"flex justify-around"},[_c('p',{staticClass:"h6 semi-bold primarycolor line-height-1"},[_vm._v("\n              Vigtig information:\n            ")]),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":"Opgaven haster! Skal laves inden for 1 mdr.","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"33.823","height":"32.486","viewBox":"0 0 33.823 32.486"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1403","data-name":"Rectangle 1403","width":"33.823","height":"32.486","fill":"none"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"clock_ic","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4007","data-name":"Path 4007","d":"M0,15.257a.97.97,0,0,1,.92-.439c2.19.011,4.381,0,6.572.011a.428.428,0,0,0,.479-.316c.265-.649.579-1.278.874-1.915.04-.087.085-.171.151-.305H7.781c-.837,0-1.673,0-2.51,0-.484,0-.777-.258-.774-.663s.311-.66.783-.66c1.453,0,2.906,0,4.359-.007a.566.566,0,0,0,.393-.152,13.386,13.386,0,0,1,7.33-4.65c.052-.013.1-.031.174-.053,0-.5.014-1-.012-1.488,0-.092-.154-.209-.262-.257a2.188,2.188,0,0,1-1.4-1.849A2.086,2.086,0,0,1,16.973.33a2.684,2.684,0,0,1,1.19-.31C19.682-.015,21.2,0,22.72.007a2.272,2.272,0,0,1,2.353,1.931,2.271,2.271,0,0,1-1.546,2.471l-.126.045v1.66A12.823,12.823,0,0,1,27.644,7.88a13.1,13.1,0,0,1,6.04,9.443,13.085,13.085,0,0,1-1.933,8.962.7.7,0,0,1-.73.4.555.555,0,0,1-.525-.471,1.075,1.075,0,0,1,.142-.643,11.466,11.466,0,0,0,1.628-4.181,11.791,11.791,0,0,0-3.817-11.219,11.486,11.486,0,0,0-8.572-3.025A12,12,0,0,0,17.751,30.82a11.79,11.79,0,0,0,9.067-1.477,1.552,1.552,0,0,1,.442-.209.656.656,0,0,1,.442,1.221,21.413,21.413,0,0,1-2.161,1.123A13.332,13.332,0,0,1,8.147,24.229a.472.472,0,0,0-.529-.348c-1.387.016-2.774.009-4.161.006-.464,0-.758-.215-.81-.567-.067-.452.258-.778.793-.78,1.233,0,2.466,0,3.7,0h.386l-.4-2.527c-.942,0-1.887,0-2.833,0a.66.66,0,1,1-.033-1.316c.826-.006,1.651,0,2.477,0H7.1l.325-2.523H7.056c-2.048,0-4.095-.007-6.142.006A.959.959,0,0,1,0,15.719ZM20.473,3.176c.769,0,1.539,0,2.308,0a.928.928,0,0,0,.982-.9.9.9,0,0,0-.916-.928q-2.374-.03-4.748,0a.9.9,0,0,0-.928.945.924.924,0,0,0,.994.88c.769,0,1.539,0,2.308,0m-1.58,2.665h3.145v-1.3H18.894Z","transform":"translate(0 0)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4008","data-name":"Path 4008","d":"M0,255.958c.186-.252.388-.488.744-.43a.633.633,0,0,1,.568.556.617.617,0,0,1-.375.7.628.628,0,0,1-.775-.166c-.057-.062-.108-.131-.162-.2v-.462","transform":"translate(0 -232.973)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4009","data-name":"Path 4009","d":"M126.211,100.656a10.253,10.253,0,1,1-10.247,10.235,10.258,10.258,0,0,1,10.247-10.235m8.915,10.253a8.919,8.919,0,1,0-8.917,8.928,8.916,8.916,0,0,0,8.917-8.928","transform":"translate(-105.732 -91.774)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4010","data-name":"Path 4010","d":"M326.256,311.593a.666.666,0,0,1,.648-.651.668.668,0,1,1,0,1.336.666.666,0,0,1-.648-.685","transform":"translate(-297.468 -283.505)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4011","data-name":"Path 4011","d":"M193.814,162.1a1.672,1.672,0,0,1,.092-.495.476.476,0,0,0-.164-.643c-.38-.35-.738-.724-1.1-1.093a.679.679,0,0,1-.071-1.018.692.692,0,0,1,1.019.086c.384.378.769.755,1.141,1.145a.482.482,0,0,0,.5.142,4.33,4.33,0,0,1,1.292,0,.461.461,0,0,0,.477-.134c.975-.984,1.95-1.969,2.944-2.934a1.01,1.01,0,0,1,.622-.3.647.647,0,0,1,.473,1.047,2.335,2.335,0,0,1-.245.267c-.948.949-1.894,1.9-2.848,2.843a.419.419,0,0,0-.132.5,1.945,1.945,0,0,1-.6,2.18,1.917,1.917,0,0,1-2.18.326,2.027,2.027,0,0,1-1.225-1.931m2.787.063a.727.727,0,0,0-1.454,0,.727.727,0,0,0,1.454,0","transform":"translate(-175.399 -143.025)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4012","data-name":"Path 4012","d":"M145.449,210.573a3.212,3.212,0,0,1-.483-.068.626.626,0,0,1-.458-.675.6.6,0,0,1,.527-.585,3.527,3.527,0,0,1,.785-.017.635.635,0,0,1,.618.643.664.664,0,0,1-.624.679,3.22,3.22,0,0,1-.361,0l0,.021","transform":"translate(-131.753 -190.754)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4013","data-name":"Path 4013","d":"M225.832,130.4c0,.12.008.242,0,.361a.629.629,0,0,1-.623.6.638.638,0,0,1-.684-.571,4.134,4.134,0,0,1,0-.787.634.634,0,0,1,.69-.562.626.626,0,0,1,.616.6c.009.12,0,.241,0,.361","transform":"translate(-204.695 -118.011)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4014","data-name":"Path 4014","d":"M225.787,283.376a3.194,3.194,0,0,1,0,.361.684.684,0,0,1-.675.6.663.663,0,0,1-.636-.631c-.012-.219-.011-.439,0-.657a.668.668,0,0,1,.639-.664.683.683,0,0,1,.679.664c.006.109,0,.219,0,.329h0","transform":"translate(-204.659 -257.466)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4015","data-name":"Path 4015","d":"M298.685,209.515c.1,0,.2,0,.3,0a.645.645,0,0,1,.645.648.659.659,0,0,1-.632.668,5.575,5.575,0,0,1-.657,0,.652.652,0,0,1-.643-.688.643.643,0,0,1,.662-.631c.109-.005.219,0,.329,0","transform":"translate(-271.427 -191.026)","fill":"#1a1818"}})])])])],1),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":"Garantiordning er ikke et krav","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"29.959","height":"30.094","viewBox":"0 0 29.959 30.094"}},[_c('path',{attrs:{"id":"Path_4016","data-name":"Path 4016","d":"M6009.333-289.345h-10.664a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583h9.738a15.132,15.132,0,0,1-.821-1.283,9.78,9.78,0,0,1-1.239-5.327.582.582,0,0,1,.532-.568,5.021,5.021,0,0,0,1.363-.336,9.3,9.3,0,0,0-2.738-1.968,5.672,5.672,0,0,1-1.634,4.073.583.583,0,0,1-.418.21h-.031a.586.586,0,0,1-.408-.165l-3.288-3.2-3.287,3.2a.584.584,0,0,1-.437.164.582.582,0,0,1-.418-.21,5.666,5.666,0,0,1-1.637-4.075,10.733,10.733,0,0,0-5.658,7.758c-.165.745-.165,1.228,0,1.434s.588.291,1.286.291h3.815a.584.584,0,0,1,.583.583.584.584,0,0,1-.583.583h-3.815a2.731,2.731,0,0,1-2.195-.728,2.893,2.893,0,0,1-.229-2.416,13.61,13.61,0,0,1,2.539-5.566,10.526,10.526,0,0,1,4.758-3.407.692.692,0,0,1,.075-.027c.128-.046.259-.089.392-.13a7.594,7.594,0,0,1-2.416-5.032v-.916a1.933,1.933,0,0,1-1.164-1.771,1.93,1.93,0,0,1,1.245-1.8,7.211,7.211,0,0,1,1.713-3.953,7.239,7.239,0,0,1,3.6-2.254.874.874,0,0,1,.845-.653h2.113a.876.876,0,0,1,.855.694,7.193,7.193,0,0,1,5.167,6.166,1.929,1.929,0,0,1,1.244,1.8,1.93,1.93,0,0,1-1.162,1.769v.917a7.592,7.592,0,0,1-2.415,5.032c.136.042.27.088.4.135a.463.463,0,0,1,.045.016,10.524,10.524,0,0,1,4.348,2.909,8.822,8.822,0,0,0,1.893-1.5.581.581,0,0,1,.421-.181h0a.587.587,0,0,1,.422.181,7.5,7.5,0,0,0,4.35,2.375.581.581,0,0,1,.531.568,9.814,9.814,0,0,1-1.239,5.327c-.021.039-2.169,3.888-4.066,3.888A3.632,3.632,0,0,1,6009.333-289.345Zm.171-7.973c-.023.013-.044.024-.066.035a7.4,7.4,0,0,1-1.929.682,8.425,8.425,0,0,0,1.1,4.254c.69,1.289,2.305,3.273,3.037,3.273s2.349-1.985,3.038-3.272a8.453,8.453,0,0,0,1.1-4.255,8.78,8.78,0,0,1-4.142-2.241A9.8,9.8,0,0,1,6009.5-297.318Zm-14.325-3.162a3.972,3.972,0,0,0,.9,3.325l2.388-2.323c-.2-.053-.4-.118-.615-.2a7.811,7.811,0,0,1-1.879-1.032C5995.7-300.638,5995.437-300.562,5995.18-300.48Zm6.405.807c-.208.078-.41.143-.607.2l2.39,2.321a3.968,3.968,0,0,0,.9-3.324c-.26-.085-.525-.159-.8-.226A7.8,7.8,0,0,1,6001.585-299.673Zm-7.921-6.978c0,2.219,2.149,4.968,4.6,5.883a3.691,3.691,0,0,0,2.915,0c2.455-.912,4.61-3.661,4.61-5.885v-.757h-12.125Zm-1.164-2.686a.765.765,0,0,0,.764.763h12.924a.764.764,0,0,0,.761-.763.763.763,0,0,0-.761-.762h-8.928c-.028.031-.061.028-.1,0h-3.9A.764.764,0,0,0,5992.5-309.337Zm1.27-1.928h3.347a12.738,12.738,0,0,0,.741-4.857A6.11,6.11,0,0,0,5993.77-311.265Zm8.7,0h3.21a6.026,6.026,0,0,0-3.954-4.808A12.6,12.6,0,0,0,6002.473-311.266Zm-4.115,0h2.873a15.942,15.942,0,0,1-.671-5.568h-1.531A15.955,15.955,0,0,1,5998.358-311.266Zm-2.328,21.921a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583.585.585,0,0,1,.584.583.582.582,0,0,1-.582.583Zm15.023-2.975-1-.762a.581.581,0,0,1-.11-.816.583.583,0,0,1,.818-.11l.57.436,1.544-1.706a.582.582,0,0,1,.823-.041.583.583,0,0,1,.042.824l-1.9,2.1a.584.584,0,0,1-.433.191A.574.574,0,0,1,6011.053-292.32Z","transform":"translate(-5987 318)"}})])])],1),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":"Kunden ønsker en skarp pris","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30.519","height":"30.518","viewBox":"0 0 30.519 30.518"}},[_c('path',{attrs:{"id":"Path_4017","data-name":"Path 4017","d":"M6002.974-294.754c0-.2.009-.4.026-.6h-12.8a.6.6,0,0,1-.6-.6v-9.949l-.243.178a.6.6,0,0,1-.354.116.735.735,0,0,1-.09-.006.6.6,0,0,1-.39-.237l-1.407-1.918a.6.6,0,0,1,.128-.833l4.392-3.231a.6.6,0,0,1,.833.127.6.6,0,0,1-.127.833l-3.912,2.878.7.958,10.736-7.9a.592.592,0,0,1,.706,0l10.737,7.9.7-.958-11.792-8.675-4.039,2.97a.6.6,0,0,1-.833-.126.6.6,0,0,1,.127-.833l4.392-3.232a.6.6,0,0,1,.706,0L6013.2-308.6a.6.6,0,0,1,.127.833l-1.406,1.918a.594.594,0,0,1-.391.236.591.591,0,0,1-.443-.109l-.243-.179V-302a7.282,7.282,0,0,1,6.676,7.247,7.28,7.28,0,0,1-7.273,7.273A7.281,7.281,0,0,1,6002.974-294.754Zm2.467-4.67a.6.6,0,0,1,.086.839,6.086,6.086,0,0,0-1.36,3.831,6.087,6.087,0,0,0,6.08,6.081,6.087,6.087,0,0,0,6.08-6.081,6.086,6.086,0,0,0-6.08-6.079,6.092,6.092,0,0,0-.96.075.6.6,0,0,1-.682-.5.6.6,0,0,1,.5-.683c.183-.028.366-.051.55-.065v-4.771l-9.429-6.938-9.431,6.938v10.23h5.379v-8.344a1.194,1.194,0,0,1,1.191-1.193h5.72a1.194,1.194,0,0,1,1.193,1.193v5.986c.1-.149.213-.3.328-.437a.6.6,0,0,1,.464-.221A.6.6,0,0,1,6005.44-299.425Zm-8.08,2.883h5.72v-8.344h-5.72Zm12.29,4.769v-.2a1.581,1.581,0,0,1-.673-.4.6.6,0,0,1,0-.843.6.6,0,0,1,.843,0,.4.4,0,0,0,.28.117.4.4,0,0,0,.282-.117.39.39,0,0,0,.115-.28.4.4,0,0,0-.115-.281l-1.114-1.114a1.592,1.592,0,0,1,0-2.248,1.559,1.559,0,0,1,.383-.283v-.315a.6.6,0,0,1,.6-.6.6.6,0,0,1,.595.6v.2a1.6,1.6,0,0,1,.674.4.6.6,0,0,1,0,.843.6.6,0,0,1-.843,0,.4.4,0,0,0-.562,0,.4.4,0,0,0,0,.562l1.114,1.114a1.592,1.592,0,0,1,0,2.248,1.6,1.6,0,0,1-.382.283v.315a.6.6,0,0,1-.6.6A.6.6,0,0,1,6009.65-291.773Zm-3.259-8.466a.6.6,0,0,1,.223-.814.6.6,0,0,1,.813.222.6.6,0,0,1-.222.814.6.6,0,0,1-.295.078A.6.6,0,0,1,6006.391-300.239Zm-5.1-.475a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6A.6.6,0,0,1,6001.292-300.715Zm-7.856-11.681a.6.6,0,0,1,.11-.836.6.6,0,0,1,.836.109.6.6,0,0,1-.11.836.588.588,0,0,1-.363.123A.6.6,0,0,1,5993.436-312.4Z","transform":"translate(-5987 318)"}})])])],1),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":'Kunden ønsker' + _vm.itemSelect.ID + 'tilbud på opgaven',"placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 24.5 29.865"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.583-288.134a.585.585,0,0,1-.583-.583v-3.676a6.61,6.61,0,0,1,1.073-3.6,6.564,6.564,0,0,1,2.614-2.345.58.58,0,0,1,.332-.152,6.08,6.08,0,0,1,2.4-.49h1.75v-1.54c-.156-.14-.314-.286-.46-.437a6.674,6.674,0,0,1-1.632-2.865h-.24a2.332,2.332,0,0,1-2.333-2.333,2.307,2.307,0,0,1,.619-1.581,1.742,1.742,0,0,1-.619-1.336,1.734,1.734,0,0,1,.514-1.237,1.837,1.837,0,0,1,.676-.42,6.434,6.434,0,0,1,4.679-5.692,1.856,1.856,0,0,1,1.714-1.575h2.333a1.867,1.867,0,0,1,1.721,1.575,6.432,6.432,0,0,1,4.678,5.692,1.747,1.747,0,0,1,1.184,1.657,1.74,1.74,0,0,1-.512,1.237c-.036.035-.07.07-.106.1a2.307,2.307,0,0,1,.618,1.581,2.332,2.332,0,0,1-2.333,2.333h-.239a6.688,6.688,0,0,1-2.095,3.3v1.54h1.75a6.072,6.072,0,0,1,2.4.49.571.571,0,0,1,.333.152,6.6,6.6,0,0,1,2.613,2.345,6.6,6.6,0,0,1,1.073,3.6v3.676a.585.585,0,0,1-.584.583ZM6008-289.3h2.333v-3.092a5.578,5.578,0,0,0-2.333-4.486Zm-2.333-1.341v1.341h1.166v-8.2a4.8,4.8,0,0,0-1.166-.286v3.64a.586.586,0,0,1-.584.584.586.586,0,0,1-.583-.584v-3.675H6003l-3.168,3.325v5.191h4.666v-1.341a.586.586,0,0,1,.583-.584A.586.586,0,0,1,6005.667-290.642Zm-11.667,0v1.341h4.667v-5.191l-3.167-3.325H5994v3.675a.585.585,0,0,1-.583.584.585.585,0,0,1-.583-.584v-3.64a5.127,5.127,0,0,0-1.167.286v8.2h1.167v-1.341a.585.585,0,0,1,.583-.584A.585.585,0,0,1,5994-290.642Zm-5.832-1.751v3.092h2.333v-7.577A5.582,5.582,0,0,0,5988.167-292.393Zm8.166-6.241,2.917,3.063,2.917-3.063v-1.085a6.108,6.108,0,0,1-2.917.735,6.107,6.107,0,0,1-2.917-.735ZM5994-305.576a5.656,5.656,0,0,0,.1,1.045.018.018,0,0,1,.006.017,5.559,5.559,0,0,0,1.44,2.748,5.179,5.179,0,0,0,.589.531,5.052,5.052,0,0,0,3.115,1.085,5.021,5.021,0,0,0,3.109-1.085,5.518,5.518,0,0,0,2.03-3.279.02.02,0,0,0,.006-.017,5.305,5.305,0,0,0,.1-1.045v-1.75H5994Zm11.667,0c0,.193-.012.391-.029.584h.029a1.169,1.169,0,0,0,1.166-1.167,1.169,1.169,0,0,0-1.166-1.167Zm-14-.583a1.171,1.171,0,0,0,1.167,1.167h.029c-.019-.193-.029-.391-.029-.584v-1.75A1.171,1.171,0,0,0,5991.667-306.159Zm.169-3.331a.576.576,0,0,0-.169.414.586.586,0,0,0,.583.584h14a.575.575,0,0,0,.414-.17.573.573,0,0,0,.168-.414.584.584,0,0,0-.583-.583h-14A.578.578,0,0,0,5991.836-309.489Zm1.033-1.336h12.762a5.259,5.259,0,0,0-3.465-4.368v2.619a.585.585,0,0,1-.584.583.584.584,0,0,1-.582-.583v-3.5c0-.362-.3-.759-.584-.759h-2.333c-.28,0-.583.4-.583.759v3.5a.585.585,0,0,1-.584.583.584.584,0,0,1-.583-.583v-2.619A5.272,5.272,0,0,0,5992.869-310.825Zm11.63,18.432a.586.586,0,0,1,.583-.583.586.586,0,0,1,.584.583.586.586,0,0,1-.584.584A.586.586,0,0,1,6004.5-292.393Zm-11.666,0a.585.585,0,0,1,.583-.583.585.585,0,0,1,.583.583.586.586,0,0,1-.583.584A.585.585,0,0,1,5992.833-292.393Z","transform":"translate(-5987 318)"}})])])],1),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":"Kunden taler dansk og engelsk","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"29.229","height":"31.841","viewBox":"0 0 29.229 31.841"}},[_c('path',{attrs:{"id":"Path_4019","data-name":"Path 4019","d":"M5988.866-286.781V-313.1a2.493,2.493,0,0,1-1.867-2.409,2.491,2.491,0,0,1,2.489-2.488,2.49,2.49,0,0,1,2.487,2.488,2.493,2.493,0,0,1-1.865,2.409v1.074h25.5a.622.622,0,0,1,.622.622v18.656a.622.622,0,0,1-.622.622h-2.8a.622.622,0,0,1-.622-.622.622.622,0,0,1,.622-.622h2.177v-6.219h-9.95v6.219h2.176a.621.621,0,0,1,.622.622.621.621,0,0,1-.622.622h-17.1v5.349a.622.622,0,0,1-.622.622A.622.622,0,0,1,5988.866-286.781Zm1.244-14.055h10.572a.622.622,0,0,1,.622.622v6.841h2.487v-6.841a.622.622,0,0,1,.622-.622h10.573v-2.487h-10.573a.623.623,0,0,1-.622-.622v-6.841H6001.3v6.841a.622.622,0,0,1-.622.622H5990.11Zm0,7.463h9.95v-6.219h-9.95Zm14.925-11.193h9.95v-6.219h-9.95Zm-14.925,0h9.95v-6.219h-9.95Zm-1.867-10.945a1.247,1.247,0,0,0,1.245,1.244,1.246,1.246,0,0,0,1.244-1.244,1.246,1.246,0,0,0-1.244-1.245A1.247,1.247,0,0,0,5988.243-315.512Zm21.145,22.76a.622.622,0,0,1,.622-.622.622.622,0,0,1,.622.622.622.622,0,0,1-.622.622A.622.622,0,0,1,6009.388-292.752Z","transform":"translate(-5987 318)"}})])])],1),_vm._v(" "),_c('span',[_c('el-tooltip',{attrs:{"content":"Kunden ønsker en ung fagmand","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"24.036","height":"28.721","viewBox":"0 0 24.036 28.721"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1410","data-name":"Rectangle 1410","width":"24.036","height":"28.721","fill":"none"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Group_6787","data-name":"Group 6787","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4020","data-name":"Path 4020","d":"M5.372,9.094a10.772,10.772,0,0,1-.493-3.218A4.118,4.118,0,0,1,5.52,3.5c.273-.385.7-.655,1-1.029s.441-.865.753-1.215A3.949,3.949,0,0,1,9.929.059a19.44,19.44,0,0,1,4.416.208,7.488,7.488,0,0,0,2.9.035,4.776,4.776,0,0,0,.593-.213c.372-.155.555-.1.72.275A2.768,2.768,0,0,1,18.43,3.1c-.026.042-.05.085-.076.13a5.5,5.5,0,0,1,.686,4.205c-.081.554-.228,1.1-.348,1.663.1.012.22.018.335.039a1.6,1.6,0,0,1,1.29,1.8,2.18,2.18,0,0,1-2.212,2.134.332.332,0,0,0-.249.128c-.241.473-.434.973-.7,1.431s-.589.861-.909,1.32l.245.105a4.307,4.307,0,0,1,2.638,3.679c.03.238.091.351.336.4.482.093.96.211,1.434.34a3.557,3.557,0,0,1,2.65,3.129c.16,1.509.324,3.017.479,4.526.038.373-.111.582-.387.594-.258.012-.419-.185-.457-.526-.174-1.6-.31-3.2-.543-4.79a2.505,2.505,0,0,0-1.93-2.093c-.538-.159-1.09-.269-1.639-.389a.325.325,0,0,0-.258.062,6.649,6.649,0,0,1-3.365,1.641c-.291.066-.586.117-.9.177,0,1.066,0,2.112,0,3.157,0,.231,0,.463,0,.694a.425.425,0,1,1-.842,0c0-1.137,0-2.274,0-3.411v-.312H10.329v.307q0,1.675,0,3.35c0,.35-.151.547-.416.552s-.427-.194-.427-.539q0-1.72,0-3.441V22.8c-.325-.065-.639-.118-.949-.191a6.563,6.563,0,0,1-3.328-1.647.3.3,0,0,0-.237-.046c-.558.124-1.117.245-1.668.4a2.735,2.735,0,0,0-1.969,2.349c-.154,1.54-.322,3.078-.486,4.616a.447.447,0,0,1-.476.439A.429.429,0,0,1,0,28.19q.163-1.65.343-3.3a15.838,15.838,0,0,1,.214-1.7,3.452,3.452,0,0,1,2.6-2.722c.492-.14,1-.234,1.488-.372a.373.373,0,0,0,.233-.239,4.377,4.377,0,0,1,2.878-3.894c.007,0,.011-.015.032-.043-.046-.063-.094-.135-.149-.2a8.045,8.045,0,0,1-1.418-2.435.286.286,0,0,0-.32-.224,2.187,2.187,0,0,1-2.1-2.833c.2-.7.658-1.039,1.562-1.133M8.419,6.012c-.061.441-.106.839-.171,1.234A3.6,3.6,0,0,1,6.957,9.4a1.087,1.087,0,0,0-.446,1.2,4.587,4.587,0,0,1,.067.567,7.6,7.6,0,0,0,4.071,5.882,2.711,2.711,0,0,0,2.734,0,7.62,7.62,0,0,0,4.058-5.7,5.228,5.228,0,0,0,.111-1.288c-.039-.474-.552-.649-.806-1a1.776,1.776,0,0,0-.122-.133,3.366,3.366,0,0,1-.865-1.916c-.037-.327-.091-.652-.142-1a20.038,20.038,0,0,1-7.2,0M17.9,1a5.869,5.869,0,0,1-2.7.242C13.8,1.112,12.417.961,11.025.867A4.7,4.7,0,0,0,8.7,1.256a2.218,2.218,0,0,0-1.355,1.55.656.656,0,0,1-.29.356A2.55,2.55,0,0,0,5.911,4.692,6.154,6.154,0,0,0,5.88,7.528c.08.457.212.906.327,1.389A3.058,3.058,0,0,0,7.43,6.977c.064-.478.124-.956.185-1.434.051-.4.242-.518.646-.449.712.121,1.424.26,2.142.324a17.555,17.555,0,0,0,5.423-.334.443.443,0,0,1,.595.419c.064.478.126.956.183,1.434A2.966,2.966,0,0,0,17.8,8.883a8.749,8.749,0,0,0,.476-3.506,3.223,3.223,0,0,0-.7-1.732c-.309-.353-.309-.457-.007-.824A1.853,1.853,0,0,0,17.9,1M9.738,17.5c-.051.624-.1,1.182-.136,1.741a.549.549,0,0,0,.091.305,9.067,9.067,0,0,0,2.135,2.313.266.266,0,0,0,.389-.007,8.934,8.934,0,0,0,2.116-2.29.557.557,0,0,0,.1-.3c-.034-.567-.086-1.133-.136-1.756a3.814,3.814,0,0,1-4.563,0m.871,4.5a10.053,10.053,0,0,1-1.755-2.191.914.914,0,0,1-.13-.478c.045-.731.118-1.461.18-2.191a.459.459,0,0,0-.559-.467,3.53,3.53,0,0,0-2.618,3.24A.7.7,0,0,0,6,20.541a5.389,5.389,0,0,0,2.1,1.073,9.616,9.616,0,0,0,2.511.392m2.811-.034.021.082c.393-.048.789-.083,1.179-.147a7.922,7.922,0,0,0,3.046-1.064,1.167,1.167,0,0,0,.577-1.437,3.516,3.516,0,0,0-2.538-2.72.461.461,0,0,0-.575.42c.055.7.129,1.4.166,2.1a1.205,1.205,0,0,1-.128.623,8.61,8.61,0,0,1-1.749,2.14m4.771-9.8a1.237,1.237,0,0,0,1.263-1.328c0-.7-.337-.964-1-.808l-.266,2.136M5.853,12.2,5.58,10.018c-.326-.059-.674-.1-.866.26a1.281,1.281,0,0,0,.063,1.291,1.2,1.2,0,0,0,1.075.627","transform":"translate(0 0)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4021","data-name":"Path 4021","d":"M126.432,171.189c-.569-.147-1.123-.27-1.662-.438a.409.409,0,0,1-.3-.564.431.431,0,0,1,.627-.212,3.435,3.435,0,0,0,2.663,0,.419.419,0,0,1,.606.2.4.4,0,0,1-.272.573c-.54.168-1.093.292-1.664.44","transform":"translate(-114.407 -156.224)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4022","data-name":"Path 4022","d":"M104.057,103.912a1.766,1.766,0,0,1,1.164.35.417.417,0,0,1,.144.6.408.408,0,0,1-.6.112,1.312,1.312,0,0,0-1.421-.005.426.426,0,1,1-.435-.728,1.774,1.774,0,0,1,1.152-.328","transform":"translate(-94.384 -95.532)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4023","data-name":"Path 4023","d":"M162.482,103.044a1.933,1.933,0,0,1,1.163.343.423.423,0,1,1-.444.718,1.314,1.314,0,0,0-1.423-.007.42.42,0,0,1-.621-.138.392.392,0,0,1,.191-.581c.354-.168.735-.281,1.1-.418l.03.081","transform":"translate(-148.11 -94.663)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4024","data-name":"Path 4024","d":"M113.133,123.545a.606.606,0,0,1,.585.6.592.592,0,0,1-1.183-.014.6.6,0,0,1,.6-.588","transform":"translate(-103.464 -113.585)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4025","data-name":"Path 4025","d":"M172.174,124.163a.592.592,0,1,1-.568-.618.61.61,0,0,1,.568.618","transform":"translate(-157.207 -113.585)","fill":"#1a1818"}})])])])],1),_vm._v(" "),(_vm.itemSelect.CONTRACT_TYPE === 'Fagentreprise')?_c('span',[_c('el-tooltip',{attrs:{"content":"Fagentreprise","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Fagenterprise","width":"51.726","height":"45.283","viewBox":"0 0 51.726 45.283"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1451","data-name":"Rectangle 1451","width":"51.726","height":"45.283","fill":"#1a1818"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Group_7363","data-name":"Group 7363","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4547","data-name":"Path 4547","d":"M.71,124.086l-.156-.06A.835.835,0,0,1,0,123.236a3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.342.022c.091.111.068.226-.058.348a.223.223,0,0,0-.072.137c0,1,0,2,0,3.007a.32.32,0,0,0,.011.052h.9v-.174q0-1.68,0-3.36c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065a5.158,5.158,0,0,1-1.424-4.245H1.755a.854.854,0,0,1-.93-.924,1.825,1.825,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.483,4.483,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.237.237,0,0,1,.329-.048.235.235,0,0,1,.042.329c-.128.2-.268.387-.384.591a3.776,3.776,0,0,0-.435,1.248h8.084a4,4,0,0,0-2.663-3.157c-.1.412-.207.82-.294,1.234a1,1,0,0,1-.954.788,1.243,1.243,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.943,3.943,0,0,0-1.01.524c-.034.023-.065.05-.1.071a.231.231,0,0,1-.325-.054.224.224,0,0,1,.063-.323c.327-.2.662-.384.994-.573a.346.346,0,0,1,.085-.034.366.366,0,0,0,.277-.261.932.932,0,0,1,.6-.531,2.267,2.267,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.548,5.548,0,0,1,.176.68.172.172,0,0,0,.148.159.813.813,0,0,1,.622.7,2.4,2.4,0,0,1,.013.443.846.846,0,0,1-.871.829c-.118,0-.235,0-.374,0,0,.1,0,.19,0,.28a6.391,6.391,0,0,1-.246,2.06,3.957,3.957,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.55,7.55,0,0,1,1.9,1.074,3.748,3.748,0,0,1,1.394,2.964.828.828,0,0,1-.545.782l-.134.062Zm8.952-9.221H9.508c-.241,0-.482,0-.723,0-.217,0-.326-.084-.323-.24s.11-.23.317-.231H9c.513,0,1.025,0,1.537,0a.358.358,0,0,0,.388-.316,2.614,2.614,0,0,0,0-.429.348.348,0,0,0-.3-.307,1.347,1.347,0,0,0-.2-.01H1.8a1.535,1.535,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5H7.48a.791.791,0,0,1,.183.011.214.214,0,0,1,.182.231.211.211,0,0,1-.194.22,1.076,1.076,0,0,1-.184.01H2.549a.726.726,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.773,2.773,0,0,0,1.966.489A3.823,3.823,0,0,0,9.047,118a4.117,4.117,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.386.386,0,0,0-.405.049,3.212,3.212,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2c0,.685,0,1.371,0,2.056,0,.044,0,.088.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H3.268v1.1H8.956v-1.1H5.719c-.2,0-.3-.079-.3-.227s.1-.232.295-.232H8.966M6.115,111.24c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.046,1.046,0,0,0-.229-.123,1.816,1.816,0,0,0-1.073-.036,1.4,1.4,0,0,0-.359.165.284.284,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.417.417,0,0,0,.011-.065q0-1.5,0-2.991c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.395.015.586,0a.391.391,0,0,0,.367-.431,3.343,3.343,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16Zm-9.442-2.726a3.365,3.365,0,0,0-.923,2.365.35.35,0,0,0,.3.34,6.2,6.2,0,0,0,.621.035Z","transform":"translate(0 -86.214)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4548","data-name":"Path 4548","d":"M97.172,160.352l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.342.022c.091.111.068.226-.058.348a.223.223,0,0,0-.072.137c0,1,0,2,0,3.007a.321.321,0,0,0,.011.052h.9v-.174q0-1.68,0-3.36c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065a5.158,5.158,0,0,1-1.424-4.245h-.313a.854.854,0,0,1-.93-.923,1.825,1.825,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.483,4.483,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.237.237,0,0,1,.329-.048.235.235,0,0,1,.042.329c-.128.2-.268.387-.384.591a3.776,3.776,0,0,0-.435,1.248h8.084a4,4,0,0,0-2.663-3.157c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.243,1.243,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.944,3.944,0,0,0-1.01.524c-.034.023-.065.05-.1.071a.231.231,0,0,1-.325-.054.224.224,0,0,1,.063-.323c.327-.2.662-.384.994-.573a.345.345,0,0,1,.085-.034.366.366,0,0,0,.277-.261.932.932,0,0,1,.6-.531,2.267,2.267,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.546,5.546,0,0,1,.176.68.172.172,0,0,0,.148.159.813.813,0,0,1,.622.7,2.4,2.4,0,0,1,.013.443.846.846,0,0,1-.871.829c-.118,0-.235,0-.374,0,0,.1,0,.19,0,.28a6.391,6.391,0,0,1-.246,2.06,3.958,3.958,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.55,7.55,0,0,1,1.9,1.074,3.748,3.748,0,0,1,1.394,2.964.828.828,0,0,1-.545.782l-.134.062Zm8.952-9.221h-.154c-.241,0-.482,0-.723,0-.217,0-.326-.084-.323-.24s.11-.23.317-.231h.215c.513,0,1.025,0,1.537,0a.358.358,0,0,0,.388-.316,2.614,2.614,0,0,0,0-.429.348.348,0,0,0-.3-.307,1.345,1.345,0,0,0-.2-.01H98.262a1.537,1.537,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5h5.688a.792.792,0,0,1,.183.011.214.214,0,0,1,.182.231.211.211,0,0,1-.194.22,1.077,1.077,0,0,1-.184.01H99.011a.726.726,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.773,2.773,0,0,0,1.966.489,3.823,3.823,0,0,0,2.592-1.779,4.117,4.117,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.386.386,0,0,0-.405.049,3.212,3.212,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2c0,.685,0,1.371,0,2.056,0,.044,0,.088.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H99.73v1.1h5.688v-1.1h-3.237c-.2,0-.3-.079-.3-.227s.1-.232.295-.232h3.254m-2.851-10.821c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.046,1.046,0,0,0-.229-.123,1.816,1.816,0,0,0-1.073-.036,1.4,1.4,0,0,0-.359.165.284.284,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.417.417,0,0,0,.011-.065q0-1.5,0-2.991c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.395.015.586,0a.391.391,0,0,0,.367-.431,3.343,3.343,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16Zm-9.442-2.726a3.365,3.365,0,0,0-.924,2.365.35.35,0,0,0,.3.34,6.194,6.194,0,0,0,.621.035Z","transform":"translate(-76.749 -115.069)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4549","data-name":"Path 4549","d":"M193.9,125.788l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.342.022c.091.111.068.226-.058.348a.223.223,0,0,0-.072.137c0,1,0,2,0,3.007a.315.315,0,0,0,.011.052h.9v-.173q0-1.68,0-3.36c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065a5.158,5.158,0,0,1-1.424-4.245h-.313a.854.854,0,0,1-.93-.923,1.826,1.826,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.483,4.483,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.237.237,0,0,1,.329-.048.235.235,0,0,1,.042.329c-.128.2-.268.387-.384.591a3.776,3.776,0,0,0-.435,1.248h8.084a4,4,0,0,0-2.663-3.157c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.243,1.243,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.944,3.944,0,0,0-1.01.524c-.034.023-.065.05-.1.07a.231.231,0,0,1-.325-.054.224.224,0,0,1,.063-.323c.327-.2.662-.384.994-.573a.346.346,0,0,1,.085-.034.366.366,0,0,0,.277-.261.932.932,0,0,1,.6-.531,2.267,2.267,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.551,5.551,0,0,1,.176.68.172.172,0,0,0,.148.159.813.813,0,0,1,.622.7,2.4,2.4,0,0,1,.013.443.846.846,0,0,1-.871.829c-.117,0-.235,0-.374,0,0,.1,0,.19,0,.28a6.39,6.39,0,0,1-.246,2.06,3.957,3.957,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.55,7.55,0,0,1,1.9,1.074,3.748,3.748,0,0,1,1.394,2.964.828.828,0,0,1-.545.782l-.134.062Zm8.952-9.221h-.154c-.241,0-.482,0-.723,0-.217,0-.326-.084-.323-.24s.11-.23.317-.231h.215c.513,0,1.025,0,1.537,0a.358.358,0,0,0,.388-.316,2.614,2.614,0,0,0,0-.429.348.348,0,0,0-.3-.307,1.346,1.346,0,0,0-.2-.01h-8.624a1.535,1.535,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5h5.688a.791.791,0,0,1,.183.011.214.214,0,0,1,.182.231.211.211,0,0,1-.194.22,1.077,1.077,0,0,1-.184.01h-4.919a.724.724,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.773,2.773,0,0,0,1.966.489,3.823,3.823,0,0,0,2.592-1.779,4.117,4.117,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.386.386,0,0,0-.405.049,3.212,3.212,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2c0,.685,0,1.371,0,2.056,0,.044,0,.088.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234h-1.148v1.1h5.688v-1.1H198.9c-.2,0-.3-.079-.3-.227s.1-.232.295-.232h3.254M199.3,112.942c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.046,1.046,0,0,0-.229-.123,1.816,1.816,0,0,0-1.073-.036,1.4,1.4,0,0,0-.359.165.284.284,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.417.417,0,0,0,.011-.065q0-1.5,0-2.991c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.395.015.586,0a.391.391,0,0,0,.367-.431,3.343,3.343,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16Zm-9.442-2.726a3.365,3.365,0,0,0-.923,2.365.35.35,0,0,0,.3.34,6.2,6.2,0,0,0,.621.035Z","transform":"translate(-153.707 -87.569)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4550","data-name":"Path 4550","d":"M75.381,26.865a.81.81,0,0,1-.465-.856c.016-.259,0-.521,0-.813H61.889a1.117,1.117,0,0,1-1.216-.855,1.983,1.983,0,0,1-.026-.572c.043-.7.1-1.395.149-2.092a.4.4,0,0,1,.4-.4.387.387,0,0,1,.384.437c-.037.7-.079,1.4-.136,2.092-.04.493.042.6.526.6h2.763v-.291c0-.612,0-1.224,0-1.836,0-.3.162-.479.407-.471s.379.175.381.468c0,.7,0,1.4,0,2.112.094.007.169.018.245.018.857,0,1.714,0,2.571,0a.29.29,0,0,0,.328-.212q.629-1.622,1.281-3.234a.306.306,0,0,0-.049-.354c-.334-.415-.655-.84-1-1.284-.153.11-.3.217-.445.319a.638.638,0,0,1-1.051-.423c-.182-.978-.347-1.958-.52-2.937-.01-.059-.027-.117-.049-.207-.466.1-.922.2-1.378.3-.774.173-1.548.349-2.322.522a1.559,1.559,0,0,0-1.305,1.44c-.047.452-.065.906-.1,1.359a3.458,3.458,0,0,1-.043.391.36.36,0,0,1-.409.321.346.346,0,0,1-.365-.369,13.691,13.691,0,0,1,.233-2.287,2.223,2.223,0,0,1,1.835-1.637c1.259-.282,2.517-.566,3.777-.845a1.93,1.93,0,0,0,.867-.645c.132-.126.011-.606-.135-.73a4.76,4.76,0,0,1-1.721-3.164c-.008-.069-.024-.138-.038-.217-.15-.035-.3-.062-.451-.107a1.854,1.854,0,0,1-.865-2.974.518.518,0,0,0,.108-.34c-.063-.7-.151-1.406-.22-2.11-.03-.3.11-.5.35-.517s.409.168.44.476c.064.633.14,1.265.211,1.9.433-.041.406.056.484-.43a4.748,4.748,0,0,1,2.255-3.4.683.683,0,0,1,.846.071A10.236,10.236,0,0,0,72.52,4.836a16.134,16.134,0,0,0,1.7.312c.533.076.693.189.831.713a5.192,5.192,0,0,1,.113.538c.062.4.059.4.479.445a13.313,13.313,0,0,0,.173-2.757A3.821,3.821,0,0,0,72.467.851a27.228,27.228,0,0,0-3.952,0A3.646,3.646,0,0,0,65.4,3.174c-.033.071-.058.146-.093.217a.383.383,0,0,1-.51.236.389.389,0,0,1-.221-.536A4.655,4.655,0,0,1,67.3.319,4.541,4.541,0,0,1,69.038,0c1,.007,1.994,0,2.99,0a4.7,4.7,0,0,1,4.564,3.938,8.564,8.564,0,0,1-.084,2.3c-.035.312-.084.623-.11.936a.356.356,0,0,0,.092.223,1.844,1.844,0,0,1-1.08,3.07.251.251,0,0,0-.239.266A4.721,4.721,0,0,1,73.5,13.863a.7.7,0,0,0-.022.919,1.95,1.95,0,0,0,1.079.573c1.1.223,2.193.5,3.292.734A.464.464,0,0,0,78.192,16c.631-.526,1.251-1.066,1.871-1.6a1.612,1.612,0,0,1,2.29-.011c.191.162.381.325.609.52.007-.149.01-.249.016-.349a.634.634,0,0,1,.63-.639c.454-.013.91-.014,1.364,0a.643.643,0,0,1,.634.693c0,.787.007,1.574,0,2.361a.429.429,0,0,0,.175.377c.278.226.537.476.818.7a2.351,2.351,0,0,1,.9,1.213v.63a1.406,1.406,0,0,0-.062.137,1.587,1.587,0,0,1-1.589,1.125h-.243c0,.272.01.516,0,.759a.392.392,0,1,1-.784-.01,2.427,2.427,0,0,1,0-.5,1.1,1.1,0,0,0-.488-1.107c-1.054-.862-2.071-1.771-3.106-2.664a.942.942,0,0,0-.1.063c-1.132.976-2.265,1.951-3.391,2.936a.434.434,0,0,0-.109.295c-.008.962,0,1.924,0,2.885v.575h1.59c0-1,0-1.98,0-2.959a.761.761,0,0,1,.86-.852q1.128,0,2.256,0c.593,0,.869.271.87.86,0,.892,0,1.784,0,2.676v.276h1.613c0-.229,0-.438,0-.646,0-.346.149-.538.4-.53s.387.2.389.523c0,.216,0,.432,0,.673.279,0,.531.015.781,0a1,1,0,0,1,1.111.68v1.312l-.42.472ZM68.406,3.713A3.842,3.842,0,0,0,66.572,6.7c-.075,1.088-.039,2.184-.044,3.277a4.9,4.9,0,0,0,.049.81,3.928,3.928,0,0,0,7.805-.21c.056-1.169.034-2.342.029-3.514,0-.294-.075-.587-.105-.882-.019-.188-.133-.227-.3-.256-.609-.109-1.223-.2-1.82-.358a11.189,11.189,0,0,1-3.783-1.857M75.425,24.4v-.316c0-.6,0-1.207,0-1.81,0-.306.155-.48.4-.473s.385.186.387.468c0,.367,0,.734,0,1.1v1.017H76.8V21.148c-.128,0-.24,0-.351,0a1.574,1.574,0,0,1-1.49-1.277,1.592,1.592,0,0,1,.592-1.584c.568-.487,1.133-.977,1.742-1.5l-3.181-.719c-.021.1-.037.154-.047.213-.173.979-.34,1.959-.52,2.937a.64.64,0,0,1-1.069.415c-.141-.1-.28-.2-.43-.306-.357.46-.7.9-1.037,1.347a.284.284,0,0,0-.027.234q.659,1.68,1.337,3.354a.253.253,0,0,0,.179.138c.961.009,1.922.006,2.926.006m.244-4.881.064.039a.764.764,0,0,0,.562.762.87.87,0,0,0,.88-.265Q79,18.478,80.826,16.9c.335-.289.452-.283.787.006q1.875,1.62,3.754,3.236a.8.8,0,1,0,1.06-1.192q-2.327-2.02-4.666-4.026a.787.787,0,0,0-1.1,0q-2.327,2-4.64,4.015a2.324,2.324,0,0,0-.356.574m11.045,6.547v-.513c0-.355,0-.355-.361-.355H76.07a.62.62,0,0,0-.208.008c-.053.02-.124.083-.127.129-.013.24-.006.481-.006.73Zm-4.323-4.692H80.035v3.018h2.356ZM68.449,14.569c.623.858,1.328,1.648,2.014,2.477.672-.778,1.324-1.529,1.97-2.285a1.037,1.037,0,0,0,.1-.263,5.03,5.03,0,0,1-4.085.071m4.484.835-1.887,2.188L72.8,18.881c.167-.957.328-1.865.482-2.773.073-.429.054-.454-.352-.7m-3.05,2.187-1.865-2.2c-.425.322-.429.323-.347.8.095.549.2,1.1.294,1.646.06.336.118.673.183,1.047l1.735-1.286m.59,4.192-1.033,2.6h2.066l-1.034-2.6m-.009-3.631-.929.69.939,1.21.934-1.207-.943-.694M65.72,7.623a1,1,0,0,0-.944,1.05.977.977,0,0,0,.944.984Zm9.512,2.045a1.027,1.027,0,0,0,0-2.047Zm8.559,5.057c-.063.526-.085,1.006.458,1.3a3.786,3.786,0,0,1,.553.463V14.725Z","transform":"translate(-48.247 0)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4551","data-name":"Path 4551","d":"M190.026,129.616l.42-.472v.472Z","transform":"translate(-151.192 -102.752)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4552","data-name":"Path 4552","d":"M103.386,56.721c-.356-.086-.714-.156-1.061-.262a.374.374,0,0,1-.259-.5.382.382,0,0,1,.526-.246,2.348,2.348,0,0,0,1.635,0,.387.387,0,0,1,.541.257.38.38,0,0,1-.3.494c-.349.1-.709.165-1.081.249","transform":"translate(-81.189 -44.306)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4553","data-name":"Path 4553","d":"M117.631,38.876c0,.1.007.21,0,.314a.39.39,0,0,1-.779.012,4.292,4.292,0,0,1,0-.628.381.381,0,0,1,.4-.366.374.374,0,0,1,.382.38c.007.1,0,.192,0,.288h0","transform":"translate(-92.962 -30.4)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4554","data-name":"Path 4554","d":"M96.8,38.889c0-.1-.007-.21,0-.314a.39.39,0,0,1,.775-.026,2.892,2.892,0,0,1,0,.679A.39.39,0,0,1,96.8,39.2c-.007-.1,0-.209,0-.314","transform":"translate(-77.012 -30.407)","fill":"#1a1818"}})])])])],1):_c('span',[_c('el-tooltip',{attrs:{"content":"Hovedentreprise","placement":"top","effect":"light"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","id":"Hovedentreprenør","width":"49.487","height":"48.776","viewBox":"0 0 49.487 48.776"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1450","data-name":"Rectangle 1450","width":"49.487","height":"48.776","fill":"#1a1818"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Group_7361","data-name":"Group 7361","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4543","data-name":"Path 4543","d":"M.68,135.791l-.149-.058A.8.8,0,0,1,0,134.978a3.636,3.636,0,0,1,1.591-3.048.221.221,0,0,1,.327.021c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131c0,.959,0,1.918,0,2.877a.266.266,0,0,0,.011.05h.858v-.166q0-1.607,0-3.215c0-.091,0-.156-.107-.207a.211.211,0,0,1,.027-.386c.2-.1.41-.185.615-.276l.143-.062a4.935,4.935,0,0,1-1.362-4.061h-.3a.817.817,0,0,1-.89-.884,1.75,1.75,0,0,1,.023-.409.769.769,0,0,1,.587-.595.16.16,0,0,0,.139-.154,4.288,4.288,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.227.227,0,0,1,.314-.046.225.225,0,0,1,.04.315c-.122.188-.256.37-.367.565a3.613,3.613,0,0,0-.416,1.194H9.7a3.822,3.822,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.19,1.19,0,0,1-.658-.112.878.878,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.764,3.764,0,0,0-.966.5c-.032.023-.063.047-.1.067a.221.221,0,0,1-.311-.052.214.214,0,0,1,.06-.309c.313-.19.633-.367.951-.548a.328.328,0,0,1,.082-.032.35.35,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.168,2.168,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092a4.362,4.362,0,0,1,2.639,2.683,5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.311,2.311,0,0,1,.012.424.809.809,0,0,1-.834.793c-.112,0-.225,0-.358,0,0,.1,0,.182,0,.268a6.116,6.116,0,0,1-.236,1.971,3.787,3.787,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.218,7.218,0,0,1,1.822,1.027,3.585,3.585,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06Zm8.564-8.822H9.1c-.231,0-.461,0-.691,0-.208,0-.312-.08-.309-.23s.106-.22.3-.221h.206c.49,0,.98,0,1.471,0a.343.343,0,0,0,.372-.3,2.5,2.5,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.307,1.307,0,0,0-.191-.009H1.722a1.464,1.464,0,0,0-.176.007.346.346,0,0,0-.308.321c-.005.068,0,.137,0,.205,0,.372.11.482.479.482H7.156a.757.757,0,0,1,.175.011.219.219,0,0,1-.011.431,1.035,1.035,0,0,1-.176.009H2.439a.689.689,0,0,0-.014.1c.014.386.011.773.048,1.157A3.769,3.769,0,0,0,4.294,131.2a2.653,2.653,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.939,3.939,0,0,0,.584-1.914c.028-.353,0-.71,0-1.084m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.369.369,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.19.19,0,0,0-.126.195c0,.656,0,1.311,0,1.967,0,.042,0,.085.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051H8.568v-1.051h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222H8.578M5.851,123.5c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.339,1.339,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843H9.89a.407.407,0,0,0,.011-.062q0-1.431,0-2.862c0-.036-.009-.09-.034-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.351-.412,3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153Zm-9.033-2.608A3.22,3.22,0,0,0,.445,135a.335.335,0,0,0,.29.325,5.833,5.833,0,0,0,.594.033Z","transform":"translate(0 -94.105)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4544","data-name":"Path 4544","d":"M86.163,167.929l-.149-.058a.8.8,0,0,1-.531-.755,3.636,3.636,0,0,1,1.591-3.048.221.221,0,0,1,.327.021c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131c0,.959,0,1.918,0,2.877a.266.266,0,0,0,.011.05h.858v-.166q0-1.607,0-3.215c0-.091,0-.156-.107-.207a.211.211,0,0,1,.027-.386c.2-.1.41-.185.615-.276l.143-.062a4.935,4.935,0,0,1-1.362-4.061h-.3a.817.817,0,0,1-.89-.884,1.75,1.75,0,0,1,.023-.409.769.769,0,0,1,.587-.595.16.16,0,0,0,.139-.154,4.288,4.288,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.227.227,0,0,1,.314-.046.225.225,0,0,1,.04.315c-.122.188-.256.37-.367.565a3.613,3.613,0,0,0-.416,1.194h7.734a3.822,3.822,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.19,1.19,0,0,1-.658-.112.877.877,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.766,3.766,0,0,0-.966.5c-.032.022-.063.047-.1.067a.221.221,0,0,1-.311-.052.214.214,0,0,1,.06-.309c.313-.19.633-.367.951-.548a.328.328,0,0,1,.082-.032.35.35,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.168,2.168,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092a4.362,4.362,0,0,1,2.639,2.683,5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.669,2.311,2.311,0,0,1,.012.424.809.809,0,0,1-.834.793c-.112,0-.225,0-.358,0,0,.1,0,.182,0,.268a6.121,6.121,0,0,1-.236,1.971,3.787,3.787,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.218,7.218,0,0,1,1.822,1.027,3.585,3.585,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06Zm8.564-8.822h-.839c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h.206c.49,0,.98,0,1.471,0a.343.343,0,0,0,.372-.3,2.5,2.5,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.277,1.277,0,0,0-.191-.01H87.2a1.462,1.462,0,0,0-.176.008.346.346,0,0,0-.308.321c-.005.068,0,.137,0,.205,0,.372.11.482.479.482h5.442a.757.757,0,0,1,.175.011.219.219,0,0,1-.011.431,1.011,1.011,0,0,1-.176.009H87.922a.688.688,0,0,0-.014.1c.014.386.011.773.048,1.157a3.769,3.769,0,0,0,1.821,2.974,2.653,2.653,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.939,3.939,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.369.369,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.19.19,0,0,0-.126.195c0,.656,0,1.311,0,1.967,0,.042,0,.085.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441v-1.051h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113m-2.727-10.353c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.339,1.339,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.407.407,0,0,0,.011-.062q0-1.431,0-2.862c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.351-.412,3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153Zm-9.033-2.608a3.22,3.22,0,0,0-.884,2.263.335.335,0,0,0,.29.325,5.833,5.833,0,0,0,.594.033Z","transform":"translate(-66.623 -119.152)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4545","data-name":"Path 4545","d":"M171.878,137.3l-.149-.058a.8.8,0,0,1-.531-.755,3.636,3.636,0,0,1,1.591-3.048.221.221,0,0,1,.327.021c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131c0,.959,0,1.918,0,2.877a.267.267,0,0,0,.011.05h.858v-.166q0-1.607,0-3.215c0-.091,0-.156-.107-.207a.211.211,0,0,1,.027-.386c.2-.1.41-.185.615-.276l.143-.062a4.935,4.935,0,0,1-1.362-4.061h-.3a.817.817,0,0,1-.89-.884,1.749,1.749,0,0,1,.023-.409.769.769,0,0,1,.587-.595.16.16,0,0,0,.139-.154,4.288,4.288,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.227.227,0,0,1,.314-.046.225.225,0,0,1,.04.315c-.122.188-.256.37-.367.565a3.613,3.613,0,0,0-.416,1.194H180.9a3.822,3.822,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.19,1.19,0,0,1-.658-.112.878.878,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.764,3.764,0,0,0-.966.5c-.032.023-.063.047-.1.067a.221.221,0,0,1-.311-.052.214.214,0,0,1,.06-.309c.313-.19.633-.367.951-.548a.327.327,0,0,1,.082-.032.35.35,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.168,2.168,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092a4.362,4.362,0,0,1,2.639,2.683,5.406,5.406,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.834.793c-.112,0-.225,0-.358,0,0,.1,0,.182,0,.268a6.115,6.115,0,0,1-.236,1.971,3.787,3.787,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.217,7.217,0,0,1,1.822,1.027,3.585,3.585,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06Zm8.564-8.822h-.147c-.231,0-.461,0-.691,0-.208,0-.312-.08-.309-.23s.106-.22.3-.221h.206c.49,0,.98,0,1.471,0a.343.343,0,0,0,.372-.3,2.5,2.5,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.307,1.307,0,0,0-.191-.009H172.92a1.463,1.463,0,0,0-.176.007.346.346,0,0,0-.308.321c-.005.068,0,.137,0,.205,0,.372.11.482.479.482h5.442a.757.757,0,0,1,.175.011.2.2,0,0,1,.175.22.2.2,0,0,1-.185.21,1.032,1.032,0,0,1-.176.009h-4.706a.688.688,0,0,0-.014.1c.014.386.011.773.048,1.157a3.77,3.77,0,0,0,1.821,2.974,2.653,2.653,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.939,3.939,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.369.369,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.19.19,0,0,0-.126.195c0,.656,0,1.311,0,1.967,0,.042,0,.085.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441V135.8h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113m-2.727-10.353c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.339,1.339,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.41.41,0,0,0,.011-.062q0-1.431,0-2.862c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.351-.412,3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153Zm-9.033-2.608a3.22,3.22,0,0,0-.884,2.263.335.335,0,0,0,.29.325,5.829,5.829,0,0,0,.594.033Z","transform":"translate(-133.427 -95.28)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4546","data-name":"Path 4546","d":"M69.257,29.549v-.865H70.8a.92.92,0,0,0,1.056-1.058c0-.249,0-.5,0-.776-.1-.006-.195-.013-.286-.015A1.289,1.289,0,0,1,70.3,25.56q-.012-2.222,0-4.443a1.279,1.279,0,0,1,1.172-1.275c.114-.012.228-.017.362-.027V18.727a3.11,3.11,0,0,1-1.586.2q-9.84,0-19.681,0c-.4,0-.791-.071-1.2-.111v.964a3.789,3.789,0,0,1,.507.041,1.3,1.3,0,0,1,1.027,1.29q.006,2.149,0,4.3A1.3,1.3,0,0,1,49.566,26.8c-.065,0-.13.011-.215.019,0,.377-.027.742.007,1.1a.861.861,0,0,0,.841.766c.1.006.192,0,.289,0H66.66v.865h-16.8a4.908,4.908,0,0,1-.59-.281,1.641,1.641,0,0,1-.792-1.421c-.007-.336,0-.672,0-1.019a7.053,7.053,0,0,1-.776-.1,2.132,2.132,0,0,1-1.646-2.1c0-.856,0-1.712,0-2.568A2.157,2.157,0,0,1,48.295,19.8c.047,0,.095,0,.184-.009V19.48c0-.76,0-1.52,0-2.28a1.716,1.716,0,0,1,1.715-1.729c.827-.006,1.654,0,2.482,0,.028,0,.056.006.117.013v2.564h3.62c0-.836,0-1.662,0-2.487a.32.32,0,0,0-.1-.2,6.186,6.186,0,0,1-1.846-3.912c-.219-.025-.439-.037-.652-.078A1.256,1.256,0,0,1,52.731,10.2a7.691,7.691,0,0,1,.011-1.123,1.115,1.115,0,0,1,.6-.931.428.428,0,0,0,.242-.456,7.6,7.6,0,0,1,.387-2.924c.186-.49.427-.959.664-1.485l.777.51a6.4,6.4,0,0,0-.924,4.119h3.038c0-.131,0-.261,0-.391a1.271,1.271,0,0,1,1.288-1.311q1.789-.031,3.578,0a1.271,1.271,0,0,1,1.28,1.319c0,.122,0,.245,0,.386H66.69c.541-2.656-1.677-6.168-3.879-6.106V4.546h-.879v-.9c0-.75,0-1.5,0-2.251,0-.357-.153-.521-.5-.525q-.837-.01-1.674,0a.438.438,0,0,0-.491.5c0,1.048,0,2.1,0,3.167H58.4V1.775a4.217,4.217,0,0,0-2.509,1.383l-.648-.575a4.8,4.8,0,0,1,1.746-1.3A8.462,8.462,0,0,1,58.2.921a.507.507,0,0,0,.37-.262A1.212,1.212,0,0,1,59.677,0c.606-.006,1.212,0,1.818,0a1.3,1.3,0,0,1,1.162.676.472.472,0,0,0,.263.212,5.53,5.53,0,0,1,4.306,3.862,7.675,7.675,0,0,1,.388,2.953.409.409,0,0,0,.235.432,1.122,1.122,0,0,1,.6.927,7.251,7.251,0,0,1,.014,1.122,1.32,1.32,0,0,1-1.329,1.228c-.124.009-.249,0-.375,0-.084.414-.14.811-.246,1.2a6.107,6.107,0,0,1-1.543,2.665c-.077.079-.18.182-.182.275-.014.825-.008,1.651-.008,2.5h3.593V15.492c.1-.009.177-.022.25-.022.789,0,1.578-.005,2.367,0a1.718,1.718,0,0,1,1.724,1.721c.005.847,0,1.693,0,2.539a.32.32,0,0,0,.016.066,7.058,7.058,0,0,1,.786.113,2.133,2.133,0,0,1,1.616,2.066c.007.875,0,1.75,0,2.626a2.162,2.162,0,0,1-2.212,2.234c-.057,0-.114,0-.229.01.131,1.193,0,2.276-1.366,2.7ZM65.833,11.454a42.988,42.988,0,0,1-10.459.006,5.251,5.251,0,0,0,10.459-.006m-5.2-2.634H58.9q-2.394,0-4.787,0c-.37,0-.5.135-.511.5,0,.173,0,.346,0,.519,0,.57.086.665.65.715.1.008.192.008.288.014,1.342.089,2.683.182,4.026.267a21.236,21.236,0,0,0,2.243.112c1.708-.074,3.413-.211,5.119-.325.422-.028.843-.057,1.264-.1a.414.414,0,0,0,.4-.468c0-.211,0-.423,0-.634,0-.483-.111-.593-.59-.593H60.632M50.031,21.8c0-.241.005-.433,0-.624a.461.461,0,0,0-.523-.51c-.413-.005-.827-.006-1.24,0a1.3,1.3,0,0,0-1.337,1.3q-.028,1.341,0,2.683a1.274,1.274,0,0,0,1.207,1.271c.481.014.962,0,1.442,0a.408.408,0,0,0,.442-.4,6.819,6.819,0,0,0,0-.693H49.19v-.881h.842V22.67h-.848V21.8ZM71.166,24.83c0,.239,0,.431,0,.623a.461.461,0,0,0,.519.514c.423.006.847.01,1.269,0a1.291,1.291,0,0,0,1.312-1.295q.03-1.341,0-2.682a1.277,1.277,0,0,0-1.347-1.278c-.433,0-.866,0-1.3,0a.407.407,0,0,0-.445.4,6.654,6.654,0,0,0-.005.695h.837v.883h-.824v1.274h.829v.871Zm-13.85-6.781h6.566V16.177a6.2,6.2,0,0,1-6.566,0Zm-5.4.017V16.339c-.6,0-1.173-.018-1.747.006a.868.868,0,0,0-.83.87.881.881,0,0,0,.881.85c.557.009,1.114,0,1.7,0m17.349,0c.61,0,1.2.017,1.78-.006a.867.867,0,0,0,.8-.835.847.847,0,0,0-.763-.868c-.6-.038-1.2-.009-1.82-.009ZM62.8,7.921c0-.164.009-.3,0-.43a.386.386,0,0,0-.406-.4q-1.788-.008-3.576,0a.386.386,0,0,0-.408.4c-.012.139,0,.281,0,.433Z","transform":"translate(-35.893 0)","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1447","data-name":"Rectangle 1447","width":"0.866","height":"0.845","transform":"translate(31.632 28.704)","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1448","data-name":"Rectangle 1448","width":"0.826","height":"0.832","transform":"translate(30.789 19.817)","fill":"#1a1818"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1449","data-name":"Rectangle 1449","width":"0.826","height":"0.832","transform":"translate(32.515 19.812)","fill":"#1a1818"}})])])])],1)])])],1),_vm._v(" "),_c('div',{staticClass:"mx3",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[(_vm.itemSelect.type === 'marketjobs')?_c('button',{staticClass:"col-12 action-button no-border py2 h5 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"disabled":Number(_vm.itemSelect.TOTAL_OFFERS) >= Number(_vm.itemSelect.MAXIMUM_OFFER)},on:{"click":function($event){return _vm.savereserve()}}},[_c('span',{staticClass:"mx2"},[_vm._v("Reservere")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Udbud\n              ")])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Markedspladsen er stedet, hvor du reserverer opgaver. Hver dag bliver nye opgaver tilgængelige for dig, når en kunde i dit område skal have udført en opgavetype, som du dækker.\n            ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background circle p0 m0 absolute top-0 right-0 m1",staticStyle:{"padding":"3px"}},[_c('i',{staticClass:"primarycolor el-icon-star-on"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v("Hovedentreprise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h6 primarycolor center semi-bold my1 line-height-1"},[_c('span',{},[_vm._v("Se detaljer")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1190 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketplaceMinbolig2_vue__ = __webpack_require__(1192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea14735_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MarketplaceMinbolig2_vue__ = __webpack_require__(1193);
function injectStyle (ssrContext) {
  __webpack_require__(1191)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarketplaceMinbolig2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7ea14735_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MarketplaceMinbolig2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1191 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);




var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'marketplaceminbolig',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    Loading: Loading
  },
  created: function created() {
    this.projectid = this.$route.query.proid;
    this.showopenjobs = this.$route.query.showminbolig2jobs;
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.displayProjects();
    this.gettaskbitrix();
    this.getallwizardproduct();
  },
  mounted: function mounted() {},
  data: function data() {
    return {
      haaid: '',
      salesPersonbitrix: '',
      jobItems: [],
      loading: false,
      projectid: '',
      itemShow: [],
      itemSelect: [],
      invitationId: '',
      statusjob: 'pending',
      jobfilter: 'pending',
      openjobs: [],
      filteredItems: [],
      loadingreserve: false,
      showopenjobs: '',
      productlistforpricearr: [],
      productlistnotforpricearr: [],
      selectedPersonalInformation: {},
      primaryproductindustryname: {},
      itemsjobindustry: {}
    };
  },

  watch: {
    'jobfilter': function jobfilter(newVal, oldVal) {
      this.getfilter(newVal);
    }
  },
  methods: {
    displayProjects: function displayProjects() {
      var _this = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projectInvitations', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (response.body.success) {
          if (res.length > 0) {
            var itemsfiltered = res.filter(function (l) {
              return l.PROJECT !== null;
            });
            _this.jobItems = itemsfiltered;
            _this.loading = false;
            if (_this.projectid) {
              _this.openselectitem();
            }
            _this.getfilter('pending');
          } else {
            _this.loading = false;
          }
        } else {
          _this.$message({
            type: 'error',
            message: response.body.message
          });
          _this.loading = false;
        }
      }, function (response) {
        _this.$message({
          type: 'error',
          message: response.body.message
        });
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this.refreshtoken();
          setTimeout(function () {
            _this.displayProjects();
          }, 1000);
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this2.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this2.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this2.$router.push('/login');
      });
    },
    getfilter: function getfilter(text) {
      var filtereditems = [];
      filtereditems = this.jobItems.filter(function (a) {
        return a.STATUS === text;
      });
      this.filteredItems = filtereditems;
      this.openjobs = [];
    },
    checkimage: function checkimage(key) {
      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = 'static/img/0.jpg';
    },
    openselectitem: function openselectitem() {
      var item = [];
      var thisvar = this;
      item = this.jobItems.filter(function (a) {
        return a.PROJECT.ID === parseInt(thisvar.projectid);
      });

      this.showItemDetails(item[0]);
    },
    showItemDetails: function showItemDetails(item) {
      this.itemSelect = {};
      this.itemSelect = item;
      this.loadingreserve = true;
      this.selectedPersonalInformatio = {};
      this.productlistforpricearr = [];
      this.productlistnotforpricearr = [];
      this.invitationId = item.INVITATION_ID;
      this.itemSelect['addressimage'] = item.PROJECT.ADDRESS.IMAGE;
      this.itemSelect['postnummber'] = item.PROJECT.ADDRESS.POST_NUMBER;
      this.itemSelect['road'] = item.PROJECT.ADDRESS.ROAD;
      this.itemSelect['zip'] = item.PROJECT.ADDRESS.ZIP;
      this.itemSelect['id'] = item.PROJECT.ID;
      this.itemSelect['name'] = item.PROJECT.NAME;
      this.itemSelect['desc'] = item.PROJECT.DESCRIPTION;
      this.itemSelect['contracType'] = item.PROJECT.CONTRACT_TYPE;
      this.itemSelect['date_updated'] = item.PROJECT.DATE_UPDATED;
      this.itemSelect['type'] = 'invitejobs';
      var selectedInforPernal = {};
      item.PROJECT.PERSONAL_INFORMATION.forEach(function (i) {
        for (var key in i) {
          selectedInforPernal[key] = i[key];
        }
      });
      this.selectedPersonalInformation = selectedInforPernal;
      if (this.itemSelect.PROJECT.PARENT_ID !== 0 && this.itemSelect.PROJECT.PARENT_ID !== null) {
        this.getProductList(this.itemSelect.PROJECT.PARENT_ID, item['PROJECT']['HOMEOWNER']['ID'], 'subproject', this.itemSelect.PROJECT.JOB_INDUSTRY, this.itemSelect.PROJECT.JOBS_LIST);
      } else {
        this.getProductList(item.PROJECT.ID, item['PROJECT']['HOMEOWNER']['ID']);
      }
      this.$refs.itemModal.show();
    },
    getProductList: function getProductList(projectid, contractid) {
      var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'parentproject';

      var _this3 = this;

      var jobindustrysub = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var joblist = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];

      var submittedIndustries = [];
      if (type !== 'parentproject') {
        joblist.forEach(function (k) {
          if (Array.isArray(k)) {
            k.forEach(function (k) {
              var jobindustry = k.split(':')[0];
              submittedIndustries.push(jobindustry);
            });
          } else {
            var jobindustry = k.split(':')[0];
            submittedIndustries.push(jobindustry);
          }
        });
      }
      this.productlistforpricearr = [];
      this.productlistnotforpricearr = [];
      this.haaId = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + projectid + '&contact_id=' + contractid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        for (var index in res) {
          var enterpiserdata = {};
          var noenterpiserdata = {};
          enterpiserdata['industryid'] = index;
          enterpiserdata['industrydetails'] = {};
          noenterpiserdata['industryid'] = index;
          noenterpiserdata['industrydetails'] = {};
          for (var jobindustry in res[index]) {
            if (Number(jobindustry) !== 1062) {
              if (type === 'subproject' && (Number(jobindustrysub) === Number(jobindustry) || submittedIndustries.includes(jobindustry))) {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              } else if (type !== 'parentproject' && Number(jobindustrysub) !== Number(jobindustry)) {
                noenterpiserdata['jobindustry'] = jobindustry;
                noenterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
              if (type === 'parentproject') {
                enterpiserdata['jobindustry'] = jobindustry;
                enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              }
            } else {
              enterpiserdata['jobindustry'] = jobindustry;
              enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
            }
          }
          _this3.productlistforpricearr.push(enterpiserdata);
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(noenterpiserdata['industrydetails']).length > 0) {
            _this3.productlistnotforpricearr.push(noenterpiserdata);
          }
          _this3.loadingreserve = false;
        }
      }, function (response) {
        _this3.loadingreserve = false;
        var error = response.body;
        _this3.$refs.errorMsg.showMsg(error);
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this4 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this4.itemsjobindustry = industryname;
        }
      }, function (response) {
        var error = response.body.message;
        _this4.$message({
          type: 'error',
          message: error
        });
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this5.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this5.$message.error(error);
      });
    },
    showItemDetailsjobs: function showItemDetailsjobs(item) {
      this.itemSelect = item;
      this.itemSelect['addressimage'] = item.ADDRESS.IMAGE;
      this.itemSelect['postnummber'] = item.ADDRESS.POST_NUMBER;
      this.itemSelect['road'] = item.ADDRESS.ROAD;
      this.itemSelect['type'] = 'marketjobs';
      this.$refs.itemModal.show();
    },
    savereserve: function savereserve() {
      var _this6 = this;

      this.loadingreserve = true;
      this.$confirm('Vil du reservere dette job?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this6.haaid = localStorage.getItem('haaid');
        _this6.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this6.salesPersonbitrix
        };
        var data = {};
        _this6.$http.post(_this6.$bitrixapi + 'partner/project/' + parseInt(_this6.itemSelect.ID) + '/reserve', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this6.loadingreserve = false;
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this6.$refs.simplert.openSimplert(obj);
            _this6.openallpublicjobs();
            _this6.closemodal();
            _this6.$router.push('/alle-moeder?fromMarketplace=1');
          }
        }, function (response) {
          _this6.closemodal();
          _this6.$message({
            type: 'error',
            message: response.body.message
          });
          console.log('Error: ', response);
        });
      }).catch(function () {});
    },
    saveresond: function saveresond(respond) {
      var _this7 = this;

      var resp = '';
      resp = respond === 1 ? 'Vil du reservere dette job?' : 'Ønsker du at takke nej til dette job?';
      this.$confirm(resp, {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this7.haaid = localStorage.getItem('haaid');
        _this7.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this7.salesPersonbitrix
        };
        var data = {
          invitationId: parseInt(_this7.invitationId)
        };
        _this7.$http.post(_this7.$bitrixapi + 'partner/projectInvitation/' + parseInt(_this7.invitationId) + '?accepted=' + respond, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this7.$refs.simplert.openSimplert(obj);
            _this7.closemodal();
            _this7.displayProjects();
          }
        }, function (response) {
          _this7.closemodal();
          _this7.$message({
            type: 'error',
            message: response.body.message
          });
          console.log('Error: ', response);
        });
      }).catch(function () {});
    },
    closemodal: function closemodal() {
      this.itemSelect = {};
      this.selectedPersonalInformatio = {};
      this.productlistforpricearr = [];
      this.productlistnotforpricearr = [];
      this.$refs.itemModal.hide();
    },
    reserveitem: function reserveitem(item) {
      console.log('item', item);
    }
  }
});

/***/ }),
/* 1193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix",attrs:{"id":"marketplaceminbolig"}},[[_c('div',{staticClass:"clearfix marketplaceItems mpx2"},[_c('div',{staticClass:"col-12 px0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 mpx0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjobnolig",modifiers:{"webCustomersmarketjobnolig":true}}],staticClass:" sm-col-3 xs-col-5 lg-col-4 md-col-4 center white darkblue-background gibson p2 h4 not-rounded mr2 my2"},[_c('span',[_vm._v("\n                Filter\n              ")])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"webCustomersmarketjobnolig"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-4 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                      Filtrer resultatet\n                    ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomersmarketjobnolig",modifiers:{"webCustomersmarketjobnolig":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2 p0"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto mb2 p0"},[_c('b-form-checkbox',{staticClass:"col-6 p0 m0",attrs:{"id":"Accepted","value":"accepted"},model:{value:(_vm.jobfilter),callback:function ($$v) {_vm.jobfilter=$$v},expression:"jobfilter"}},[_c('span',{staticClass:" h6 regular"},[_vm._v("Accepted")])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"col-6 p0 m0",attrs:{"id":"Pending","value":"pending"},model:{value:(_vm.jobfilter),callback:function ($$v) {_vm.jobfilter=$$v},expression:"jobfilter"}},[_c('span',{staticClass:" h6 regular"},[_vm._v("Pending")])]),_vm._v(" "),_c('b-form-checkbox',{staticClass:"col-6 p0 m0",attrs:{"id":"Rejected","value":"rejected"},model:{value:(_vm.jobfilter),callback:function ($$v) {_vm.jobfilter=$$v},expression:"jobfilter"}},[_c('span',{staticClass:" h6 regular"},[_vm._v("Rejected")])])],1)])])])],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_c('Loading')],1):_c('div',{staticClass:"flex flex-wrap justify-start mobile-justify-center"},_vm._l((_vm.filteredItems),function(item){return _c('div',{key:item.ID,staticClass:"muted-border border shadow px0 pb3 mr2 mb2",staticStyle:{"width":"275px","overflow":"hidden","cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetails(item)}}},[(item.ADDRESS !== null)?_c('div',{staticClass:"col-12 px0 relative",staticStyle:{"height":"inherit"}},[_c('img',{staticClass:"fit block",staticStyle:{"height":"180px","object-fit":"cover","width":"100%"},attrs:{"data-key":item.PROJECT.ID,"src":typeof item.PROJECT.ADDRESS.IMAGE !== 'undefined' && item.PROJECT.ADDRESS.IMAGE !== null ? item.PROJECT.ADDRESS.IMAGE : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(item.PROJECT.ID)}}}),_vm._v(" "),_c('div',{staticClass:"absolute top-0 right-0 left-0"},[_c('div',{staticClass:"mintgreen-background py1 line-height-1 block px2 flex relative"},[_c('div',{staticClass:"h6 m0 p0 white semi-bold block mr-auto flex flex-column"},[(item.PROJECT.ADDRESS.ZIP)?_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s(item.PROJECT.ADDRESS.ZIP))]):_c('span',{staticClass:"h6 m0"},[_vm._v(_vm._s('Project ID ' + item.PROJECT.ID))])]),_vm._v(" "),_vm._m(1,true)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"px1"},[_c('div',{staticClass:"flex flex-column"},[(item.PROJECT.CONTRACT_TYPE === 'Fagentreprise')?_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_c('div',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex flex-wrap justify-between items-center"},[(item.PROJECT.JOBS_LIST.length > 1)?_c('p',{staticClass:"p0 m0"},[_vm._v("Mange Enterprise")]):(item.PROJECT.JOBS_LIST.length === 1)?_c('p',{staticClass:"p0 m0"},[(_vm.itemsjobindustry[item.PROJECT.JOB_INDUSTRY].length > 21)?_c('el-tooltip',{attrs:{"content":_vm.itemsjobindustry[item.PROJECT.JOB_INDUSTRY],"placement":"top","effect":"light"}},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(_vm.itemsjobindustry[item.PROJECT.JOB_INDUSTRY],22, '...'))+" Enterprise ")])]):_c('span',[_vm._v(_vm._s(_vm.itemsjobindustry[item.PROJECT.JOB_INDUSTRY])+" Enterprise ")])],1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(item.PROJECT.NAME,63, '...')))])])]):_c('div',{staticClass:"flex flex-column justify-start items-start",staticStyle:{"height":"68px"}},[_vm._m(2,true),_vm._v(" "),_c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v(_vm._s(_vm._f("truncate")(item.PROJECT.NAME,63, '...')))])])]),_vm._v(" "),[(item.PROJECT.STATUS !== 'accepted')?_c('p',{staticClass:"font14 darkblue regular line-height-2 mb2",staticStyle:{"height":"60px"}},[_vm._v("\n                      "+_vm._s(_vm._f("truncate")(item.PROJECT.DESCRIPTION,130, '...'))+"\n                    ")]):_c('p',{staticClass:"h6 darkblue regular green-background p1  mb1 flex flex-column"},[_c('span',{staticClass:"block center"},[_vm._v("\n                        ACCEPTERET\n                      ")])])],_vm._v(" "),_vm._m(3,true)],2)])])}),0)])],_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('b-modal',{ref:"itemModal",attrs:{"hide-header":"","lazy":"","size":"lg","no-close-on-backdrop":true,"id":"minboligjobsInvites"}},[_c('div',{staticClass:"flex items-center justify-end col-12 p0 m0"},[_c('div',{staticClass:"pointer p2",on:{"click":function($event){return _vm.closemodal()}}},[_c('i',{staticClass:"el-icon-close h5 "})])]),_vm._v(" "),(_vm.loadingreserve)?_c('div',{staticClass:"clearfix mx-auto"},[_c('Loading')],1):_c('div',{staticClass:"modal-body-marketplace"},[_c('el-tabs',[_c('el-tab-pane',{attrs:{"label":"Se detaljer"}},[_c('div',{staticClass:"relative p2"},[_c('img',{staticClass:"fit block",staticStyle:{"height":"250px","width":"100%","object-fit":"none"},attrs:{"src":typeof _vm.itemSelect.addressimage !== 'undefined' && _vm.itemSelect.addressimage !== null ? _vm.itemSelect.addressimage : 'static/img/0.jpg',"alt":""},on:{"error":function($event){return _vm.checkimage(_vm.itemSelect.id)}}}),_vm._v(" "),_c('div',{staticClass:"absolute bottom-0 right-0 left-0 m2 mx4 darkblue-background opacity-50 p2 line-height-1 z2 flex justify-between items-center"},[_c('span',{staticClass:"h6 m0 p0 white semi-bold"},[_vm._v(_vm._s(_vm.itemSelect.zip))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2 px2 mx3"},[_c('p',{staticClass:"h5 darkblue gibson semi-bold mb1 p0 line-height-2"},[_vm._v("\n                "+_vm._s(_vm.itemSelect.name)+"\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular m0 p0 line-height-1"},[_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',{staticClass:"relative",staticStyle:{"top":"-5px"}},[_vm._v(_vm._s(_vm.moment(_vm.itemSelect.date_updated).locale('da').format('LL')))])]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue"},[_c('span',[_vm._v(_vm._s(_vm.itemSelect.desc))])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Job beskrivelse"}},[_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Din Jobbeskrivelse")])]),_vm._v(" "),_c('div',{staticClass:"bordercece pb3 pt2 px1"},_vm._l((_vm.productlistforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start not-collapsed"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))])]),_vm._v(" "),_c('b-collapse',{attrs:{"visible":"","id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('p',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 line-height-golden graymuteddark font14 "},[_vm._v(_vm._s(desc))])])])}),0)],1)})],2):_vm._e()}),0)]),_vm._v(" "),(_vm.itemSelect.contracType !== 'Hovedentreprise')?_c('div',{staticClass:"clearfix flex flex-column mb2 px2"},[(_vm.productlistnotforpricearr.length > 0 )?_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h4 bold darkblue"},[_vm._v("Andre entrepriser i projektet")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"bordercece  pb3 pt2 px1"},_vm._l((_vm.productlistnotforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('job-description' + job[0] + parseInt(index + 1)),expression:"'job-description' + job[0] + parseInt(index + 1)"}],staticClass:"h5 p0 m0 mb1 pl2 p2 not-rounded outlined-dark-button flex justify-start"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'job-description' + + job[0] + parseInt(index + 1)}},_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('p',{staticClass:"flex m0 pl3 deschover"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('span',{staticClass:"pl2 p0 m0 h6 line-height-golden graymuteddark "},[_vm._v(_vm._s(desc))])])])}),0)],1)})],2):_vm._e()}),0)]):_vm._e()])],1),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h6 semi-bold primarycolor line-height-1 pl2"},[_vm._v("\n            Vigtig information:\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex gap-17 flex-wrap col-12 mx-auto",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"33.823","height":"32.486","viewBox":"0 0 33.823 32.486"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1403","data-name":"Rectangle 1403","width":"33.823","height":"32.486","fill":"none"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"clock_ic","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4007","data-name":"Path 4007","d":"M0,15.257a.97.97,0,0,1,.92-.439c2.19.011,4.381,0,6.572.011a.428.428,0,0,0,.479-.316c.265-.649.579-1.278.874-1.915.04-.087.085-.171.151-.305H7.781c-.837,0-1.673,0-2.51,0-.484,0-.777-.258-.774-.663s.311-.66.783-.66c1.453,0,2.906,0,4.359-.007a.566.566,0,0,0,.393-.152,13.386,13.386,0,0,1,7.33-4.65c.052-.013.1-.031.174-.053,0-.5.014-1-.012-1.488,0-.092-.154-.209-.262-.257a2.188,2.188,0,0,1-1.4-1.849A2.086,2.086,0,0,1,16.973.33a2.684,2.684,0,0,1,1.19-.31C19.682-.015,21.2,0,22.72.007a2.272,2.272,0,0,1,2.353,1.931,2.271,2.271,0,0,1-1.546,2.471l-.126.045v1.66A12.823,12.823,0,0,1,27.644,7.88a13.1,13.1,0,0,1,6.04,9.443,13.085,13.085,0,0,1-1.933,8.962.7.7,0,0,1-.73.4.555.555,0,0,1-.525-.471,1.075,1.075,0,0,1,.142-.643,11.466,11.466,0,0,0,1.628-4.181,11.791,11.791,0,0,0-3.817-11.219,11.486,11.486,0,0,0-8.572-3.025A12,12,0,0,0,17.751,30.82a11.79,11.79,0,0,0,9.067-1.477,1.552,1.552,0,0,1,.442-.209.656.656,0,0,1,.442,1.221,21.413,21.413,0,0,1-2.161,1.123A13.332,13.332,0,0,1,8.147,24.229a.472.472,0,0,0-.529-.348c-1.387.016-2.774.009-4.161.006-.464,0-.758-.215-.81-.567-.067-.452.258-.778.793-.78,1.233,0,2.466,0,3.7,0h.386l-.4-2.527c-.942,0-1.887,0-2.833,0a.66.66,0,1,1-.033-1.316c.826-.006,1.651,0,2.477,0H7.1l.325-2.523H7.056c-2.048,0-4.095-.007-6.142.006A.959.959,0,0,1,0,15.719ZM20.473,3.176c.769,0,1.539,0,2.308,0a.928.928,0,0,0,.982-.9.9.9,0,0,0-.916-.928q-2.374-.03-4.748,0a.9.9,0,0,0-.928.945.924.924,0,0,0,.994.88c.769,0,1.539,0,2.308,0m-1.58,2.665h3.145v-1.3H18.894Z","transform":"translate(0 0)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4008","data-name":"Path 4008","d":"M0,255.958c.186-.252.388-.488.744-.43a.633.633,0,0,1,.568.556.617.617,0,0,1-.375.7.628.628,0,0,1-.775-.166c-.057-.062-.108-.131-.162-.2v-.462","transform":"translate(0 -232.973)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4009","data-name":"Path 4009","d":"M126.211,100.656a10.253,10.253,0,1,1-10.247,10.235,10.258,10.258,0,0,1,10.247-10.235m8.915,10.253a8.919,8.919,0,1,0-8.917,8.928,8.916,8.916,0,0,0,8.917-8.928","transform":"translate(-105.732 -91.774)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4010","data-name":"Path 4010","d":"M326.256,311.593a.666.666,0,0,1,.648-.651.668.668,0,1,1,0,1.336.666.666,0,0,1-.648-.685","transform":"translate(-297.468 -283.505)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4011","data-name":"Path 4011","d":"M193.814,162.1a1.672,1.672,0,0,1,.092-.495.476.476,0,0,0-.164-.643c-.38-.35-.738-.724-1.1-1.093a.679.679,0,0,1-.071-1.018.692.692,0,0,1,1.019.086c.384.378.769.755,1.141,1.145a.482.482,0,0,0,.5.142,4.33,4.33,0,0,1,1.292,0,.461.461,0,0,0,.477-.134c.975-.984,1.95-1.969,2.944-2.934a1.01,1.01,0,0,1,.622-.3.647.647,0,0,1,.473,1.047,2.335,2.335,0,0,1-.245.267c-.948.949-1.894,1.9-2.848,2.843a.419.419,0,0,0-.132.5,1.945,1.945,0,0,1-.6,2.18,1.917,1.917,0,0,1-2.18.326,2.027,2.027,0,0,1-1.225-1.931m2.787.063a.727.727,0,0,0-1.454,0,.727.727,0,0,0,1.454,0","transform":"translate(-175.399 -143.025)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4012","data-name":"Path 4012","d":"M145.449,210.573a3.212,3.212,0,0,1-.483-.068.626.626,0,0,1-.458-.675.6.6,0,0,1,.527-.585,3.527,3.527,0,0,1,.785-.017.635.635,0,0,1,.618.643.664.664,0,0,1-.624.679,3.22,3.22,0,0,1-.361,0l0,.021","transform":"translate(-131.753 -190.754)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4013","data-name":"Path 4013","d":"M225.832,130.4c0,.12.008.242,0,.361a.629.629,0,0,1-.623.6.638.638,0,0,1-.684-.571,4.134,4.134,0,0,1,0-.787.634.634,0,0,1,.69-.562.626.626,0,0,1,.616.6c.009.12,0,.241,0,.361","transform":"translate(-204.695 -118.011)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4014","data-name":"Path 4014","d":"M225.787,283.376a3.194,3.194,0,0,1,0,.361.684.684,0,0,1-.675.6.663.663,0,0,1-.636-.631c-.012-.219-.011-.439,0-.657a.668.668,0,0,1,.639-.664.683.683,0,0,1,.679.664c.006.109,0,.219,0,.329h0","transform":"translate(-204.659 -257.466)","fill":"#1a1818"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4015","data-name":"Path 4015","d":"M298.685,209.515c.1,0,.2,0,.3,0a.645.645,0,0,1,.645.648.659.659,0,0,1-.632.668,5.575,5.575,0,0,1-.657,0,.652.652,0,0,1-.643-.688.643.643,0,0,1,.662-.631c.109-.005.219,0,.329,0","transform":"translate(-271.427 -191.026)","fill":"#1a1818"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352787] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Opgaven haster! Skal laves inden for 1 mdr.")]):_vm._e(),_vm._v(" "),(_vm.selectedPersonalInformation[352788] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Der er god tid til at løse opgaven")]):_vm._e(),_vm._v(" "),(_vm.selectedPersonalInformation[352789] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Meget tid!")]):_vm._e(),_vm._v(" "),(!_vm.selectedPersonalInformation[352789] && !_vm.selectedPersonalInformation[352788] && !_vm.selectedPersonalInformation[352787])?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Ingen information tilgængelig")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"29.959","height":"30.094","viewBox":"0 0 29.959 30.094"}},[_c('path',{attrs:{"id":"Path_4016","data-name":"Path 4016","d":"M6009.333-289.345h-10.664a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583h9.738a15.132,15.132,0,0,1-.821-1.283,9.78,9.78,0,0,1-1.239-5.327.582.582,0,0,1,.532-.568,5.021,5.021,0,0,0,1.363-.336,9.3,9.3,0,0,0-2.738-1.968,5.672,5.672,0,0,1-1.634,4.073.583.583,0,0,1-.418.21h-.031a.586.586,0,0,1-.408-.165l-3.288-3.2-3.287,3.2a.584.584,0,0,1-.437.164.582.582,0,0,1-.418-.21,5.666,5.666,0,0,1-1.637-4.075,10.733,10.733,0,0,0-5.658,7.758c-.165.745-.165,1.228,0,1.434s.588.291,1.286.291h3.815a.584.584,0,0,1,.583.583.584.584,0,0,1-.583.583h-3.815a2.731,2.731,0,0,1-2.195-.728,2.893,2.893,0,0,1-.229-2.416,13.61,13.61,0,0,1,2.539-5.566,10.526,10.526,0,0,1,4.758-3.407.692.692,0,0,1,.075-.027c.128-.046.259-.089.392-.13a7.594,7.594,0,0,1-2.416-5.032v-.916a1.933,1.933,0,0,1-1.164-1.771,1.93,1.93,0,0,1,1.245-1.8,7.211,7.211,0,0,1,1.713-3.953,7.239,7.239,0,0,1,3.6-2.254.874.874,0,0,1,.845-.653h2.113a.876.876,0,0,1,.855.694,7.193,7.193,0,0,1,5.167,6.166,1.929,1.929,0,0,1,1.244,1.8,1.93,1.93,0,0,1-1.162,1.769v.917a7.592,7.592,0,0,1-2.415,5.032c.136.042.27.088.4.135a.463.463,0,0,1,.045.016,10.524,10.524,0,0,1,4.348,2.909,8.822,8.822,0,0,0,1.893-1.5.581.581,0,0,1,.421-.181h0a.587.587,0,0,1,.422.181,7.5,7.5,0,0,0,4.35,2.375.581.581,0,0,1,.531.568,9.814,9.814,0,0,1-1.239,5.327c-.021.039-2.169,3.888-4.066,3.888A3.632,3.632,0,0,1,6009.333-289.345Zm.171-7.973c-.023.013-.044.024-.066.035a7.4,7.4,0,0,1-1.929.682,8.425,8.425,0,0,0,1.1,4.254c.69,1.289,2.305,3.273,3.037,3.273s2.349-1.985,3.038-3.272a8.453,8.453,0,0,0,1.1-4.255,8.78,8.78,0,0,1-4.142-2.241A9.8,9.8,0,0,1,6009.5-297.318Zm-14.325-3.162a3.972,3.972,0,0,0,.9,3.325l2.388-2.323c-.2-.053-.4-.118-.615-.2a7.811,7.811,0,0,1-1.879-1.032C5995.7-300.638,5995.437-300.562,5995.18-300.48Zm6.405.807c-.208.078-.41.143-.607.2l2.39,2.321a3.968,3.968,0,0,0,.9-3.324c-.26-.085-.525-.159-.8-.226A7.8,7.8,0,0,1,6001.585-299.673Zm-7.921-6.978c0,2.219,2.149,4.968,4.6,5.883a3.691,3.691,0,0,0,2.915,0c2.455-.912,4.61-3.661,4.61-5.885v-.757h-12.125Zm-1.164-2.686a.765.765,0,0,0,.764.763h12.924a.764.764,0,0,0,.761-.763.763.763,0,0,0-.761-.762h-8.928c-.028.031-.061.028-.1,0h-3.9A.764.764,0,0,0,5992.5-309.337Zm1.27-1.928h3.347a12.738,12.738,0,0,0,.741-4.857A6.11,6.11,0,0,0,5993.77-311.265Zm8.7,0h3.21a6.026,6.026,0,0,0-3.954-4.808A12.6,12.6,0,0,0,6002.473-311.266Zm-4.115,0h2.873a15.942,15.942,0,0,1-.671-5.568h-1.531A15.955,15.955,0,0,1,5998.358-311.266Zm-2.328,21.921a.583.583,0,0,1-.583-.583.584.584,0,0,1,.583-.583.585.585,0,0,1,.584.583.582.582,0,0,1-.582.583Zm15.023-2.975-1-.762a.581.581,0,0,1-.11-.816.583.583,0,0,1,.818-.11l.57.436,1.544-1.706a.582.582,0,0,1,.823-.041.583.583,0,0,1,.042.824l-1.9,2.1a.584.584,0,0,1-.433.191A.574.574,0,0,1,6011.053-292.32Z","transform":"translate(-5987 318)"}})])]),_vm._v(" "),(_vm.selectedPersonalInformation[352785] !== 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Garantiordning er ikke et krav")]):(_vm.selectedPersonalInformation[352785] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Skal være medlem af Garantiordning")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30.519","height":"30.518","viewBox":"0 0 30.519 30.518"}},[_c('path',{attrs:{"id":"Path_4017","data-name":"Path 4017","d":"M6002.974-294.754c0-.2.009-.4.026-.6h-12.8a.6.6,0,0,1-.6-.6v-9.949l-.243.178a.6.6,0,0,1-.354.116.735.735,0,0,1-.09-.006.6.6,0,0,1-.39-.237l-1.407-1.918a.6.6,0,0,1,.128-.833l4.392-3.231a.6.6,0,0,1,.833.127.6.6,0,0,1-.127.833l-3.912,2.878.7.958,10.736-7.9a.592.592,0,0,1,.706,0l10.737,7.9.7-.958-11.792-8.675-4.039,2.97a.6.6,0,0,1-.833-.126.6.6,0,0,1,.127-.833l4.392-3.232a.6.6,0,0,1,.706,0L6013.2-308.6a.6.6,0,0,1,.127.833l-1.406,1.918a.594.594,0,0,1-.391.236.591.591,0,0,1-.443-.109l-.243-.179V-302a7.282,7.282,0,0,1,6.676,7.247,7.28,7.28,0,0,1-7.273,7.273A7.281,7.281,0,0,1,6002.974-294.754Zm2.467-4.67a.6.6,0,0,1,.086.839,6.086,6.086,0,0,0-1.36,3.831,6.087,6.087,0,0,0,6.08,6.081,6.087,6.087,0,0,0,6.08-6.081,6.086,6.086,0,0,0-6.08-6.079,6.092,6.092,0,0,0-.96.075.6.6,0,0,1-.682-.5.6.6,0,0,1,.5-.683c.183-.028.366-.051.55-.065v-4.771l-9.429-6.938-9.431,6.938v10.23h5.379v-8.344a1.194,1.194,0,0,1,1.191-1.193h5.72a1.194,1.194,0,0,1,1.193,1.193v5.986c.1-.149.213-.3.328-.437a.6.6,0,0,1,.464-.221A.6.6,0,0,1,6005.44-299.425Zm-8.08,2.883h5.72v-8.344h-5.72Zm12.29,4.769v-.2a1.581,1.581,0,0,1-.673-.4.6.6,0,0,1,0-.843.6.6,0,0,1,.843,0,.4.4,0,0,0,.28.117.4.4,0,0,0,.282-.117.39.39,0,0,0,.115-.28.4.4,0,0,0-.115-.281l-1.114-1.114a1.592,1.592,0,0,1,0-2.248,1.559,1.559,0,0,1,.383-.283v-.315a.6.6,0,0,1,.6-.6.6.6,0,0,1,.595.6v.2a1.6,1.6,0,0,1,.674.4.6.6,0,0,1,0,.843.6.6,0,0,1-.843,0,.4.4,0,0,0-.562,0,.4.4,0,0,0,0,.562l1.114,1.114a1.592,1.592,0,0,1,0,2.248,1.6,1.6,0,0,1-.382.283v.315a.6.6,0,0,1-.6.6A.6.6,0,0,1,6009.65-291.773Zm-3.259-8.466a.6.6,0,0,1,.223-.814.6.6,0,0,1,.813.222.6.6,0,0,1-.222.814.6.6,0,0,1-.295.078A.6.6,0,0,1,6006.391-300.239Zm-5.1-.475a.6.6,0,0,1,.6-.6.6.6,0,0,1,.6.6.6.6,0,0,1-.6.6A.6.6,0,0,1,6001.292-300.715Zm-7.856-11.681a.6.6,0,0,1,.11-.836.6.6,0,0,1,.836.109.6.6,0,0,1-.11.836.588.588,0,0,1-.363.123A.6.6,0,0,1,5993.436-312.4Z","transform":"translate(-5987 318)"}})])]),_vm._v(" "),(_vm.selectedPersonalInformation[352795] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en skarp pris")]):(_vm.selectedPersonalInformation[352796] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker luksus standard")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Ingen information tilgængelig")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[_c('span',[(_vm.itemSelect.MAXIMUM_OFFER === 1)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 24.5 29.865"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.583-288.134a.585.585,0,0,1-.583-.583v-3.676a6.61,6.61,0,0,1,1.073-3.6,6.564,6.564,0,0,1,2.614-2.345.58.58,0,0,1,.332-.152,6.08,6.08,0,0,1,2.4-.49h1.75v-1.54c-.156-.14-.314-.286-.46-.437a6.674,6.674,0,0,1-1.632-2.865h-.24a2.332,2.332,0,0,1-2.333-2.333,2.307,2.307,0,0,1,.619-1.581,1.742,1.742,0,0,1-.619-1.336,1.734,1.734,0,0,1,.514-1.237,1.837,1.837,0,0,1,.676-.42,6.434,6.434,0,0,1,4.679-5.692,1.856,1.856,0,0,1,1.714-1.575h2.333a1.867,1.867,0,0,1,1.721,1.575,6.432,6.432,0,0,1,4.678,5.692,1.747,1.747,0,0,1,1.184,1.657,1.74,1.74,0,0,1-.512,1.237c-.036.035-.07.07-.106.1a2.307,2.307,0,0,1,.618,1.581,2.332,2.332,0,0,1-2.333,2.333h-.239a6.688,6.688,0,0,1-2.095,3.3v1.54h1.75a6.072,6.072,0,0,1,2.4.49.571.571,0,0,1,.333.152,6.6,6.6,0,0,1,2.613,2.345,6.6,6.6,0,0,1,1.073,3.6v3.676a.585.585,0,0,1-.584.583ZM6008-289.3h2.333v-3.092a5.578,5.578,0,0,0-2.333-4.486Zm-2.333-1.341v1.341h1.166v-8.2a4.8,4.8,0,0,0-1.166-.286v3.64a.586.586,0,0,1-.584.584.586.586,0,0,1-.583-.584v-3.675H6003l-3.168,3.325v5.191h4.666v-1.341a.586.586,0,0,1,.583-.584A.586.586,0,0,1,6005.667-290.642Zm-11.667,0v1.341h4.667v-5.191l-3.167-3.325H5994v3.675a.585.585,0,0,1-.583.584.585.585,0,0,1-.583-.584v-3.64a5.127,5.127,0,0,0-1.167.286v8.2h1.167v-1.341a.585.585,0,0,1,.583-.584A.585.585,0,0,1,5994-290.642Zm-5.832-1.751v3.092h2.333v-7.577A5.582,5.582,0,0,0,5988.167-292.393Zm8.166-6.241,2.917,3.063,2.917-3.063v-1.085a6.108,6.108,0,0,1-2.917.735,6.107,6.107,0,0,1-2.917-.735ZM5994-305.576a5.656,5.656,0,0,0,.1,1.045.018.018,0,0,1,.006.017,5.559,5.559,0,0,0,1.44,2.748,5.179,5.179,0,0,0,.589.531,5.052,5.052,0,0,0,3.115,1.085,5.021,5.021,0,0,0,3.109-1.085,5.518,5.518,0,0,0,2.03-3.279.02.02,0,0,0,.006-.017,5.305,5.305,0,0,0,.1-1.045v-1.75H5994Zm11.667,0c0,.193-.012.391-.029.584h.029a1.169,1.169,0,0,0,1.166-1.167,1.169,1.169,0,0,0-1.166-1.167Zm-14-.583a1.171,1.171,0,0,0,1.167,1.167h.029c-.019-.193-.029-.391-.029-.584v-1.75A1.171,1.171,0,0,0,5991.667-306.159Zm.169-3.331a.576.576,0,0,0-.169.414.586.586,0,0,0,.583.584h14a.575.575,0,0,0,.414-.17.573.573,0,0,0,.168-.414.584.584,0,0,0-.583-.583h-14A.578.578,0,0,0,5991.836-309.489Zm1.033-1.336h12.762a5.259,5.259,0,0,0-3.465-4.368v2.619a.585.585,0,0,1-.584.583.584.584,0,0,1-.582-.583v-3.5c0-.362-.3-.759-.584-.759h-2.333c-.28,0-.583.4-.583.759v3.5a.585.585,0,0,1-.584.583.584.584,0,0,1-.583-.583v-2.619A5.272,5.272,0,0,0,5992.869-310.825Zm11.63,18.432a.586.586,0,0,1,.583-.583.586.586,0,0,1,.584.583.586.586,0,0,1-.584.584A.586.586,0,0,1,6004.5-292.393Zm-11.666,0a.585.585,0,0,1,.583-.583.585.585,0,0,1,.583.583.586.586,0,0,1-.583.584A.585.585,0,0,1,5992.833-292.393Z","transform":"translate(-5987 318)"}})]):(_vm.itemSelect.MAXIMUM_OFFER === 2)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 62.759 35.057"}},[_c('g',{attrs:{"id":"_2","data-name":"2","transform":"translate(-2767.87 -1603.5)"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3219.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4028","data-name":"Path 4028","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3185.13 1921.5)"}})])]):(_vm.itemSelect.MAXIMUM_OFFER === 3)?_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24.5","height":"29.865","viewBox":"0 0 62.759 71.115"}},[_c('g',{attrs:{"id":"_3","data-name":"3","transform":"translate(-2767.87 -1567.443)"}},[_c('path',{attrs:{"id":"Path_4018","data-name":"Path 4018","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3219.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4028","data-name":"Path 4028","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3185.13 1921.5)"}}),_c('path',{attrs:{"id":"Path_4029","data-name":"Path 4029","d":"M5987.684-282.942a.686.686,0,0,1-.684-.684v-4.315a7.755,7.755,0,0,1,1.26-4.231,7.707,7.707,0,0,1,3.068-2.752.684.684,0,0,1,.39-.178,7.138,7.138,0,0,1,2.814-.575h2.054v-1.808c-.184-.164-.37-.336-.541-.513a7.844,7.844,0,0,1-1.917-3.363h-.281a2.738,2.738,0,0,1-2.739-2.738,2.706,2.706,0,0,1,.726-1.856,2.043,2.043,0,0,1-.726-1.568,2.036,2.036,0,0,1,.6-1.452,2.161,2.161,0,0,1,.793-.493,7.552,7.552,0,0,1,5.492-6.682A2.178,2.178,0,0,1,6000.01-318h2.738a2.191,2.191,0,0,1,2.02,1.849,7.551,7.551,0,0,1,5.492,6.682,2.052,2.052,0,0,1,1.39,1.945,2.039,2.039,0,0,1-.6,1.452c-.042.041-.082.082-.124.116a2.708,2.708,0,0,1,.726,1.856,2.738,2.738,0,0,1-2.738,2.738h-.28a7.858,7.858,0,0,1-2.459,3.876v1.808h2.054a7.128,7.128,0,0,1,2.815.575.67.67,0,0,1,.391.178,7.75,7.75,0,0,1,3.067,2.752,7.748,7.748,0,0,1,1.261,4.231v4.315a.687.687,0,0,1-.686.684Zm23.966-1.37h2.739v-3.629a6.549,6.549,0,0,0-2.739-5.265Zm-2.738-1.574v1.574h1.369v-9.62a5.636,5.636,0,0,0-1.369-.336V-290a.688.688,0,0,1-.686.686.688.688,0,0,1-.685-.686v-4.313h-1.759l-3.719,3.9v6.094h5.478v-1.574a.688.688,0,0,1,.685-.686A.688.688,0,0,1,6008.912-285.886Zm-13.7,0v1.574h5.479v-6.094l-3.717-3.9h-1.761V-290a.687.687,0,0,1-.684.686.687.687,0,0,1-.684-.686v-4.272a6,6,0,0,0-1.37.336v9.62h1.37v-1.574a.687.687,0,0,1,.684-.686A.687.687,0,0,1,5995.216-285.886Zm-6.846-2.055v3.629h2.738v-8.895A6.551,6.551,0,0,0,5988.37-287.941Zm9.585-7.326,3.424,3.6,3.423-3.6v-1.273a7.169,7.169,0,0,1-3.423.863,7.166,7.166,0,0,1-3.424-.863Zm-2.74-8.148a6.6,6.6,0,0,0,.118,1.227.022.022,0,0,1,.007.02,6.531,6.531,0,0,0,1.69,3.226,6.145,6.145,0,0,0,.691.623,5.933,5.933,0,0,0,3.658,1.273,5.893,5.893,0,0,0,3.649-1.273,6.476,6.476,0,0,0,2.383-3.849.025.025,0,0,0,.007-.02,6.18,6.18,0,0,0,.123-1.227v-2.054h-12.326Zm13.7,0c0,.227-.014.459-.034.686h.034a1.373,1.373,0,0,0,1.369-1.37,1.373,1.373,0,0,0-1.369-1.37Zm-16.434-.684a1.374,1.374,0,0,0,1.37,1.37h.034c-.021-.227-.034-.459-.034-.686v-2.054A1.374,1.374,0,0,0,5992.478-304.1Zm.2-3.91a.677.677,0,0,0-.2.486.687.687,0,0,0,.684.686H6009.6a.674.674,0,0,0,.486-.2.673.673,0,0,0,.2-.486.686.686,0,0,0-.685-.684h-16.434A.678.678,0,0,0,5992.676-308.01Zm1.212-1.568h14.981a6.173,6.173,0,0,0-4.067-5.128v3.074a.687.687,0,0,1-.686.684.686.686,0,0,1-.684-.684v-4.108c0-.425-.355-.891-.686-.891h-2.738c-.329,0-.684.466-.684.891v4.108a.687.687,0,0,1-.686.684.686.686,0,0,1-.685-.684v-3.074A6.189,6.189,0,0,0,5993.889-309.578Zm13.653,21.637a.688.688,0,0,1,.685-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.688.688,0,0,1,6007.542-287.941Zm-13.694,0a.687.687,0,0,1,.684-.684.688.688,0,0,1,.686.684.688.688,0,0,1-.686.686A.687.687,0,0,1,5993.848-287.941Z","transform":"translate(-3202.75 1885.442)"}})])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker "+_vm._s(_vm.itemSelect.MAXIMUM_OFFER)+" tilbud på opgaven")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 1)?_c('span',{staticClass:"darkblue inline-block"},[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])]),_vm._v(" "),_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]):(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 0)?_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]):(_vm.selectedPersonalInformation[352798] === 0 && _vm.selectedPersonalInformation[352800] === 1)?_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-17.054 0-392.011 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h410c5.523 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.477-10-10-10zm-170 20h84.539l-84.539 54.741zm-80 0v54.741l-84.539-54.741zm-121.335 0 121.335 78.568v21.432h-38.665l-121.335-78.568v-21.432zm45.874 100h-84.539v-54.741zm-94.539-156c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm10 236h84.539l-84.539 54.741zm160 100h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665zm80 78.568v-54.741l84.539 54.741zm160-45.258-6.931-4.488c-4.634-3.001-10.827-1.678-13.829 2.958-3.001 4.636-1.677 10.827 2.959 13.829l17.801 11.526v21.433h-38.665l-121.335-78.568v-21.432h38.665l28.01 18.138c4.618 2.99 10.816 1.696 13.83-2.958 3.001-4.636 1.677-10.827-2.958-13.829l-2.086-1.351h84.539zm0-74.742h-170c-5.523 0-10 4.478-10 10v110h-40v-110c0-5.522-4.477-10-10-10h-170v-40h170c5.523 0 10-4.478 10-10v-110h40v110c0 5.522 4.477 10 10 10h170zm0-60h-84.539l84.539-54.741zm0-78.568-121.335 78.568h-38.665v-21.432l121.335-78.568h38.665z"}}),_c('circle',{attrs:{"cx":"421","cy":"330","r":"10"}})])])]):_c('span',[_c('svg',{attrs:{"fill":"currentColor","width":"30.519","height":"30.519","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m481 96c-287.901 0-119.486 0-410 0v-17.266c17.233-4.452 30-20.13 30-38.734 0-22.056-17.944-40-40-40s-40 17.944-40 40c0 18.604 12.767 34.282 30 38.734v423.266c0 5.522 4.477 10 10 10s10-4.478 10-10v-86h275c5.522 0 10-4.478 10-10s-4.478-10-10-10h-35v-100h160v100h-35c-5.522 0-10 4.478-10 10s4.478 10 10 10h45c5.522 0 10-4.478 10-10 0-13.807 0-286.193 0-300 0-5.522-4.478-10-10-10zm-250 20v100h-160v-100zm-170-56c-11.028 0-20-8.972-20-20s8.972-20 20-20 20 8.972 20 20-8.972 20-20 20zm170 336h-160v-100h160zm240-120h-170c-5.522 0-10 4.478-10 10v110h-40v-110c0-5.522-4.478-10-10-10h-170v-40h170c5.522 0 10-4.478 10-10v-110h40v110c0 5.522 4.478 10 10 10h170zm0-60h-160v-100h160z"}}),_c('circle',{attrs:{"cx":"391","cy":"406","r":"10"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler dansk og engelsk")]):(_vm.selectedPersonalInformation[352798] === 1 && _vm.selectedPersonalInformation[352800] === 0)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun dansk")]):(_vm.selectedPersonalInformation[352798] === 0 && _vm.selectedPersonalInformation[352800] === 0)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun engelsk")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden taler kun dansk")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.selectedPersonalInformation[352801] === 1)?_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1605_"}},[_c('g',{attrs:{"id":"XMLID_137_"}},[_c('path',{attrs:{"id":"XMLID_139_","d":"m278.661 230.088c3.905-3.905 3.905-10.237 0-14.143s-10.237-3.905-14.143 0c-4.696 4.697-12.34 4.697-17.036 0-3.905-3.905-10.237-3.905-14.143 0s-3.905 10.237 0 14.143c6.248 6.247 14.454 9.371 22.661 9.371s16.413-3.124 22.661-9.371z"}}),_c('path',{attrs:{"id":"XMLID_418_","d":"m256.131 55.126c-16.913 0-30.672 13.76-30.672 30.672s13.76 30.672 30.672 30.672 30.672-13.76 30.672-30.672-13.759-30.672-30.672-30.672zm0 41.345c-5.885 0-10.672-4.788-10.672-10.672s4.788-10.672 10.672-10.672 10.672 4.788 10.672 10.672-4.787 10.672-10.672 10.672z"}}),_c('path',{attrs:{"id":"XMLID_419_","d":"m256 492c-2.63 0-5.21 1.069-7.07 2.93-1.86 1.86-2.93 4.44-2.93 7.07s1.07 5.21 2.93 7.069c1.86 1.86 4.44 2.931 7.07 2.931s5.21-1.07 7.07-2.931c1.86-1.859 2.93-4.439 2.93-7.069s-1.07-5.21-2.93-7.07-4.44-2.93-7.07-2.93z"}}),_c('path',{attrs:{"id":"XMLID_422_","d":"m356.956 301.815h-49.611v-29.317c24.906-16.635 41.344-44.997 41.344-77.13v-37.554h85.093c5.523 0 10-4.477 10-10s-4.477-10-10-10h-76.824v-64.42c0-32.871-26.742-59.613-59.613-59.613h-31.345v-3.781c0-5.523-4.477-10-10-10s-10 4.477-10 10v3.782h-31.345c-32.871 0-59.613 26.742-59.613 59.613v74.42c0 4.931 3.573 9.019 8.269 9.84v37.714c0 32.133 16.438 60.495 41.344 77.13v29.317h-49.611c-61.007 0-110.641 49.633-110.641 110.64v89.544c0 5.522 4.477 10 10 10h156.597c5.523 0 10-4.478 10-10s-4.477-10-10-10h-85v-60h20v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h92v8c0 17.645 14.355 32 32 32s32-14.355 32-32v-8h20v60h-85c-5.523 0-10 4.478-10 10s4.477 10 10 10h156.596c5.523 0 10-4.478 10-10v-89.545c0-61.007-49.633-110.64-110.64-110.64zm-181.914-228.42c0-21.843 17.771-39.613 39.613-39.613h82.689c21.843 0 39.613 17.771 39.613 39.613v64.42h-161.915zm8.269 121.974v-37.554h145.378v37.554c0 40.081-32.608 72.689-72.689 72.689s-72.689-32.608-72.689-72.689zm72.689 92.69c10.997 0 21.55-1.929 31.345-5.46v25.786c0 17.283-14.061 31.345-31.345 31.345s-31.345-14.062-31.345-31.345v-25.786c9.795 3.53 20.348 5.46 31.345 5.46zm-140 123.941c-5.523 0-10 4.478-10 10v70h-41.596v-79.545c0-46.926 35.847-85.636 81.596-90.189v89.734zm74 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm20-28v-80.841c8.408 16.914 25.865 28.571 46 28.571s37.592-11.656 46-28.571v80.841zm136 28c0 6.617-5.383 12-12 12s-12-5.383-12-12v-118.185h24zm101.596 52h-41.596v-70c0-5.522-4.477-10-10-10h-30v-89.734c45.749 4.553 81.596 43.263 81.596 90.189z"}})])])])]):(_vm.selectedPersonalInformation[352803] === 1)?_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M293.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S293.5 243.1 293.5 250z"}}),_c('path',{attrs:{"d":"M193.5 250c0 6.9 5.6 12.5 12.5 12.5s12.5-5.6 12.5-12.5c0-6.9-5.6-12.5-12.5-12.5S193.5 243.1 193.5 250z"}}),_c('path',{attrs:{"d":"M191 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C180.1 225.1 186.2 226.8 191 224z"}}),_c('path',{attrs:{"d":"M291 224c4.6-2.6 9.7-4 15-4 5.3 0 10.4 1.4 15 4 1.6 0.9 3.3 1.3 5 1.3 3.5 0 6.8-1.8 8.7-5 2.8-4.8 1.1-10.9-3.7-13.7 -7.6-4.4-16.2-6.7-25-6.7 -8.8 0-17.4 2.3-25 6.7 -4.8 2.8-6.4 8.9-3.7 13.7C280.1 225.1 286.2 226.8 291 224z"}}),_c('path',{attrs:{"d":"M258 120.8l0.2 0c0.2 0 0.4 0 0.7 0 5.2 0 9.6-4.1 10-9.3 0.4-5.5-3.8-10.3-9.3-10.6 -0.2 0-0.4 0-0.6 0 -5.5-0.3-10.2 4-10.4 9.6C248.2 115.9 252.5 120.6 258 120.8z"}}),_c('path',{attrs:{"d":"M502 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10H502c5.5 0 10-4.5 10-10C512 496.5 507.5 492 502 492z"}}),_c('path',{attrs:{"d":"M10.2 492h-0.2c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.2c5.5 0 10-4.5 10-10C20.2 496.5 15.8 492 10.2 492z"}}),_c('path',{attrs:{"d":"M473 492h-7.3c-3.3-70-41.4-133.5-101.7-169.8 12.1-18.1 19.8-39.3 21.5-62.2h0.4c22.1 0 40-17.9 40-40 0-18.6-12.8-34.3-30-38.7v-27.7c33-12.1 54.9-30.7 63.7-54.4 0 0 0 0 0 0 0.1-0.3 0.2-0.6 0.3-0.9 0 0 0 0 0 0 0.1-0.2 0.1-0.5 0.2-0.7 0-0.1 0-0.2 0.1-0.2 0-0.3 0.1-0.5 0.1-0.8 0-0.1 0-0.2 0-0.2 0-0.2 0-0.4 0-0.6 0-0.1 0-0.3 0-0.4 0-0.1 0-0.2 0-0.3 -0.1-1.4-0.5-2.8-1.2-4 -0.6-1.1-1.4-2.1-2.3-2.9 -0.1-0.1-0.2-0.2-0.4-0.3 -0.1-0.1-0.1-0.1-0.2-0.1 -0.2-0.1-0.4-0.3-0.6-0.4 0 0-0.1 0-0.1-0.1 -0.2-0.1-0.5-0.3-0.8-0.4 0 0-0.1 0-0.1-0.1 -0.3-0.1-0.5-0.2-0.8-0.3 0 0 0 0 0 0 -0.1-0.1-0.3-0.1-0.4-0.1 -0.2-0.1-0.3-0.1-0.5-0.2 -20.6-5.5-36-17.8-53.9-32.1C367.4 28.6 331.5 0 256 0c-31.9 0-61.4 10.8-85 28.8 -0.7 0.4-1.3 0.9-1.9 1.4 -11.9 9.4-22.2 20.7-30.5 33.4 -0.5 0.6-0.9 1.2-1.2 1.8 -13.6 21.6-21.5 47.1-21.5 74.5v41.3C98.8 185.7 86 201.4 86 220c0 22.1 17.9 40 40 40h0.4c1.7 22.9 9.4 44.1 21.5 62.2 -60.3 36.4-98.3 99.9-101.7 169.8h-7.3c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h16.9c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h109.5c0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0h30.3c0 0 0 0 0 0 0 0 0 0 0 0h109.5c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h59.8c0 0 0.1 0 0.1 0 0 0 0.1 0 0.1 0h16.9c5.5 0 10-4.5 10-10C483 496.5 478.6 492 473 492zM106 492H66.3c2.1-39.2 16.2-76.2 39.7-106.4V492zM170.1 56.3c4.8 19.5 16.5 48 56.7 59.6 0.9 0.3 1.9 0.4 2.8 0.4 4.3 0 8.3-2.9 9.6-7.2 1.5-5.3-1.5-10.8-6.8-12.4C196.3 86.3 191.1 60 187.6 42.6c-0.1-0.3-0.1-0.6-0.2-1C206.8 28 230.5 20 256 20c68.5 0 100.1 25.2 130.6 49.5 15.7 12.6 30.8 24.5 49.7 32 -11.4 17.7-35.2 31.6-68.4 39.7 -66.2 16.1-156.9 5.9-186.9-21 -6.6-6.5-18.3-18.2-23.9-47.9C160.9 66.6 165.3 61.2 170.1 56.3zM376 159.7v20.3c-8.2 0-14.8-5.4-19.7-16 5.6-1 11-2.1 16.3-3.4C373.7 160.3 374.9 160 376 159.7zM136 140c0-14.6 2.6-28.7 7.5-41.6 6.3 17 14.4 26.8 20.3 32.9 -2.4 24.2-11.8 48.7-27.8 48.7V140zM146 250c0-5.5-4.5-10-10-10h-10c-11 0-20-9-20-20 0-11 9-20 20-20h10c10.3 0 24.9-4.2 35.8-24.2 5.3-9.7 8.4-20.6 10.2-30.6 18.1 10.1 43.8 17.5 74.7 21.2 26.1 3.1 53.5 3.2 79.1 0.4 10.9 28.6 29.5 33.1 40.2 33.1h10c11 0 20 9 20 20 0 11-9 20-20 20h-10c-5.5 0-10 4.5-10 10 0 25.7-8.8 49.3-23.6 68 -0.3 0.2-0.5 0.5-0.7 0.8 0 0 0 0-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -0.2 0.2-0.3 0.4-0.5 0.6 0 0 0 0.1-0.1 0.1 0 0.1-0.1 0.1-0.1 0.2 -9.8 11.9-22.1 21.6-36 28.5 -0.6 0.2-1.1 0.5-1.6 0.8 -14.3 6.8-30.3 10.7-47.2 10.7 -16.9 0-32.9-3.8-47.2-10.6 -0.5-0.3-1.1-0.6-1.6-0.8 -13.9-6.9-26.1-16.7-36-28.5 -0.1-0.1-0.1-0.2-0.2-0.3 0 0 0 0 0 0 -0.2-0.3-0.4-0.5-0.6-0.8 0 0 0 0 0 0 -0.2-0.2-0.4-0.4-0.6-0.6 -0.1-0.1-0.1-0.1-0.2-0.2C154.8 299.3 146 275.7 146 250zM291.5 375.1l-10.2 27.9 -10.4-23.9C278 378.3 284.8 377 291.5 375.1zM241.1 379.1l-10.4 23.9 -10.2-27.9C227.2 377 234 378.3 241.1 379.1zM126 492V363.7h0c9-8.5 18.9-16.1 29.6-22.8l15.4 77.7 -22.8 24.4c-1.9 2.1-2.9 4.9-2.6 7.7 0.3 2.8 1.7 5.4 4 7.1l45.9 34.2H126zM228.9 492l-58.4-43.6 18.6-20c2.2-2.4 3.1-5.6 2.5-8.8l-12.9-65.2c5.3 4 11 7.5 16.9 10.6l46.2 126.9H228.9zM256 472.7l-15.4-42.4 15.4-35.3 15.4 35.3L256 472.7zM283.1 492h-12.8l46.2-126.9c5.9-3.1 11.5-6.7 16.9-10.6l-12.9 65.2c-0.6 3.2 0.3 6.4 2.5 8.8l18.6 20L283.1 492zM386 492h-69.5l45.9-34.2c2.3-1.7 3.7-4.3 4-7.1 0.3-2.8-0.7-5.6-2.6-7.7l-22.8-24.4 15.4-77.7c10.7 6.7 20.6 14.3 29.6 22.8V492zM406 492V385.6c23.5 30.2 37.7 67.2 39.7 106.4H406z"}}),_c('path',{attrs:{"d":"M218.4 329.4c9.7 0 20.6-2.6 30.6-7.3 2.6-1.2 4.9-2.7 7-4.4 2 1.7 4.3 3.2 7 4.4 10 4.7 20.9 7.3 30.6 7.3 0 0 0 0 0 0 21.7 0 37.3-11.9 44.1-33.6 1.2-4-0.1-8.3-3.4-10.9 -3.3-2.6-7.8-2.8-11.3-0.7 -0.1 0-5.6 3.2-13.1 3.2 0 0 0 0 0 0 -6.8 0-13.2-2.7-18.9-7.9 -7.5-6.9-14.8-8.4-19.5-8.4 -5.8 0-11.2 2.1-15.5 5.7 -4.3-3.6-9.7-5.7-15.5-5.7 -4.7 0-12 1.5-19.5 8.4 -5.7 5.3-12.1 7.9-18.9 7.9 -7.5 0-13.1-3.2-13.1-3.2 -3.5-2.2-8-2-11.3 0.6 -3.3 2.6-4.6 7-3.4 11C181.1 317.4 196.8 329.4 218.4 329.4zM266.6 296c0.5-2.4 2.5-5 4.9-5 1.7 0 3.8 1.1 6 3.1 8.1 7.5 17.6 11.9 27.6 12.9 -3.3 1.5-7.2 2.3-11.5 2.3 -6.9 0-14.7-1.9-22.1-5.4C267.5 302.1 265.8 299.4 266.6 296zM234.5 294.2c2.2-2 4.3-3.1 6-3.1 2.5 0 4.4 2.6 4.9 5 0.8 3.4-0.9 6.1-4.9 8 -7.4 3.5-15.3 5.4-22.1 5.4 -4.4 0-8.2-0.8-11.5-2.3C216.9 306 226.4 301.6 234.5 294.2z"}})])]):_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"fill":"currentColor","height":"30.036","width":"32.721","id":"Capa_1","enable-background":"new 0 0 516.037 516.037","viewBox":"0 0 516.037 516.037","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('path',{attrs:{"d":"m408.644 411.413c-4.39-3.356-10.664-2.514-14.018 1.873-3.354 4.388-2.515 10.664 1.873 14.018l17.089 13.061c1.807 1.381 3.943 2.055 6.068 2.055 2.735 0 5.451-1.118 7.416-3.287l32.664-36.066c3.707-4.094 3.395-10.418-.699-14.125-4.093-3.707-10.418-3.394-14.125.699l-26.488 29.248z"}}),_c('path',{attrs:{"d":"m514.82 358.033c-.114-5.099-4.047-9.293-9.126-9.737-23.789-2.079-53.063-18.059-74.582-40.708-1.888-1.986-4.507-3.111-7.247-3.112-.001 0-.002 0-.003 0-2.738 0-5.357 1.123-7.245 3.107-9.659 10.153-20.871 18.96-32.441 25.781-20.302-22.664-45.29-39.362-74.577-49.873-.255-.103-.513-.195-.777-.277-2.281-.808-4.589-1.579-6.922-2.313 24.768-24.702 41.428-57.164 41.428-86.285v-15.711c11.708-5.098 19.919-16.784 19.919-30.357 0-14.099-8.874-26.158-21.327-30.903-5.14-49.901-40.297-91.849-88.59-105.727-1.427-6.797-7.466-11.918-14.68-11.918h-36.237c-6.958 0-12.807 4.768-14.495 11.205-23.755 6.335-45.453 19.857-61.721 38.657-16.512 19.082-26.78 42.912-29.388 67.788-12.459 4.748-21.336 16.804-21.336 30.899 0 13.578 8.223 25.267 19.947 30.362v15.706c0 29.094 16.663 61.568 41.43 86.287-2.265.712-4.508 1.457-6.725 2.239-.436.124-.86.277-1.273.458-32.78 11.825-60.147 31.399-81.579 58.43-20.612 25.998-35.265 58.103-43.551 95.431-2.949 13.34-5.167 30.104 3.929 41.43 8.885 11.063 24.783 12.481 37.642 12.481h65.415c5.523 0 10-4.478 10-10s-4.477-10-10-10h-65.415c-11.963 0-19.381-1.684-22.048-5.005-2.825-3.518-2.823-11.791.003-24.581 10.393-46.812 35.805-104.097 97.032-133.02-1.883 33.783 16.422 55.865 28.057 69.88 1.781 2.146 4.377 3.45 7.162 3.599 2.783.154 5.505-.872 7.504-2.816l56.358-54.808 56.385 54.81c1.871 1.818 4.373 2.829 6.97 2.829.179 0 .358-.005.539-.015 2.785-.15 5.382-1.457 7.162-3.606 11.619-14.027 29.897-36.122 28.031-69.834 17.763 8.426 33.457 19.695 46.953 33.733-8.059 3.119-15.983 5.112-23.372 5.758-5.076.443-9.007 4.634-9.126 9.729-.837 35.753 5.122 61.368 21.244 91.349.136.254 5.584 10.02 14.073 22h-166.979c-5.523 0-10 4.478-10 10s4.477 10 10 10h182.861c12.056 13.324 26.275 24.664 39.759 24.664 32.532 0 69.356-65.997 69.71-66.657 16.096-29.986 22.053-55.597 21.249-91.349zm-193.312-242.547h-55.058c-10.402-27.173-12.37-49.58-12.723-82.473 36.069 12.757 62.29 44.583 67.781 82.473zm-114.1-95.486h26.246c.063 38.708 1.044 64.924 11.523 95.486h-49.272c10.461-30.563 11.441-56.782 11.503-95.486zm-20.063 12.224c-.33 33.326-2.242 55.871-12.708 83.263h-57.402c5.704-38.383 33.296-71.072 70.11-83.263zm-78.781 103.262h66.898c.589.478 1.159.539 1.637 0h153.085c7.203 0 13.063 5.859 13.063 13.063 0 7.219-5.859 13.092-13.063 13.092h-221.62c-7.218 0-13.091-5.873-13.091-13.092 0-7.203 5.872-13.063 13.091-13.063zm6.856 59.131v-12.977h207.907v12.977c0 38.126-36.936 85.279-79.044 100.91-18.425 6.847-31.506 6.841-49.974-.022-42.025-15.695-78.889-62.84-78.889-100.888zm41.502 162.828c-10.35-13.512-20.316-31.252-15.526-57.003 4.411-1.424 8.969-2.723 13.695-3.872 10.084 7.398 20.96 13.466 32.235 17.677 3.629 1.348 7.121 2.459 10.537 3.383zm124.894-.006-40.966-39.821c3.372-.915 6.818-2.012 10.396-3.342 11.331-4.206 22.26-10.286 32.391-17.708 4.668 1.136 9.233 2.423 13.687 3.865 4.801 25.715-5.161 43.473-15.508 57.006zm194.13 82.489c-11.826 22.071-39.521 56.109-52.085 56.109s-40.259-34.038-52.092-56.123c-13.215-24.572-18.638-45.063-18.932-72.963 10.788-2.053 22.019-6.079 33.063-11.701.388-.169.766-.368 1.137-.59 12.896-6.703 25.508-15.574 36.82-26.117 21.298 19.87 47.227 33.883 71.02 38.409-.315 27.904-5.737 48.399-18.931 72.976z"}}),_c('path',{attrs:{"d":"m155.974 471.373c-5.523 0-10 4.478-10 10s4.477 10 10 10h.057c5.523 0 9.971-4.478 9.971-10s-4.505-10-10.028-10z"}})])])]),_vm._v(" "),(_vm.selectedPersonalInformation[352801] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en ung fagmand")]):(_vm.selectedPersonalInformation[352803] === 1)?_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Kunden ønsker en erfaren fagmand")]):_c('p',{staticClass:"p0 m0 font12 xs-font10"},[_vm._v("Erfaringsniveau har ingen betydning")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center p0 m0 border iteminfo"},[(_vm.itemSelect.CONTRACT_TYPE === 'Fagentreprise')?_c('svg',{attrs:{"id":"Fagenterprise","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"51.727","height":"45.283","viewBox":"0 0 51.727 45.283"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1376","data-name":"Rectangle 1376","width":"45.726","height":"39.283","transform":"translate(0 0)","fill":"#003645"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Fagenterprise","transform":"translate(0 0)"}},[_c('g',{attrs:{"id":"Group_7612","data-name":"Group 7612","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4521","data-name":"Path 4521","d":"M.71,37.872l-.156-.06A.834.834,0,0,1,0,37.022a3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327.005l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137V37.35a.3.3,0,0,0,.011.052h.9V33.868c0-.1,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.1.428-.194.643-.289l.149-.065a5.159,5.159,0,0,1-1.424-4.245H1.755a.855.855,0,0,1-.93-.771.977.977,0,0,1,0-.153A1.8,1.8,0,0,1,.849,27.3a.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.233.233,0,1,1,.371.281c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248h8.084a4,4,0,0,0-2.663-3.157c-.1.412-.207.82-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139A3.943,3.943,0,0,0,3.718,24c-.034.023-.065.05-.1.071a.232.232,0,0,1-.323-.051l0,0a.224.224,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28A6.377,6.377,0,0,1,9.9,31a3.955,3.955,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.749,3.749,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062Zm8.952-9.221H8.785c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.758a.358.358,0,0,0,.388-.316,2.561,2.561,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.334,1.334,0,0,0-.2-.01H1.8a1.619,1.619,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5H7.48a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.028,1.028,0,0,1-.184.01H2.549a.629.629,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.6-1.775,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.387.387,0,0,0-.4.049,3.211,3.211,0,0,1-3.8.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.983.983,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H3.268v1.1H8.956v-1.1H5.719c-.2,0-.3-.079-.3-.227s.1-.232.3-.232H8.966M6.115,25.026c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506M9.445,37.4h.892a.464.464,0,0,0,.011-.065V34.349c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.395.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16ZM1.389,34.679a3.363,3.363,0,0,0-.923,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4522","data-name":"Path 4522","d":"M20.423,45.283l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327,0l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137v3.007a.3.3,0,0,0,.011.052h.9V41.28c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065a5.159,5.159,0,0,1-1.424-4.245H21.47a.856.856,0,0,1-.93-.923,1.8,1.8,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.238.238,0,0,1,.329-.048.235.235,0,0,1,.042.329c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248H29.86A4,4,0,0,0,27.2,30.891c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.943,3.943,0,0,0-1.01.524c-.034.023-.065.05-.1.071a.232.232,0,0,1-.323-.051l0,0a.224.224,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28a6.377,6.377,0,0,1-.246,2.06,3.956,3.956,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.748,3.748,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062Zm8.952-9.221H28.5c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.752a.358.358,0,0,0,.388-.316,2.561,2.561,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.333,1.333,0,0,0-.2-.01H21.513a1.618,1.618,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5h5.688a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.028,1.028,0,0,1-.184.01h-4.92a.63.63,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.592-1.779,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2v-1.9c0-.461,0-.455-.44-.621a.387.387,0,0,0-.405.049,3.211,3.211,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.983.983,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H22.981v1.1h5.688v-1.1H25.432c-.2,0-.3-.079-.3-.227s.1-.232.3-.232h3.254M25.83,32.439c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.464.464,0,0,0,.011-.065V41.762c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.4.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16ZM21.1,42.092a3.362,3.362,0,0,0-.924,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4523","data-name":"Path 4523","d":"M40.193,38.219l-.156-.06a.835.835,0,0,1-.555-.789,3.8,3.8,0,0,1,1.663-3.186.231.231,0,0,1,.327.005l.015.017c.091.111.068.226-.058.348a.222.222,0,0,0-.072.137V37.7a.3.3,0,0,0,.011.052h.9V34.217c0-.095,0-.163-.112-.216a.221.221,0,0,1,.029-.4c.21-.105.428-.194.643-.289l.149-.065A5.159,5.159,0,0,1,41.553,29H41.24a.856.856,0,0,1-.93-.923,1.8,1.8,0,0,1,.024-.428.8.8,0,0,1,.613-.621.167.167,0,0,0,.145-.161,4.486,4.486,0,0,1,.854-1.944c.016-.02.031-.041.048-.06a.233.233,0,1,1,.371.281c-.128.2-.268.387-.384.591a3.794,3.794,0,0,0-.435,1.248H49.63a4,4,0,0,0-2.663-3.157c-.1.412-.207.821-.294,1.234a1,1,0,0,1-.954.788,1.237,1.237,0,0,1-.688-.117.917.917,0,0,1-.5-.627c-.09-.382-.183-.764-.276-1.145-.011-.044-.026-.086-.042-.139a3.943,3.943,0,0,0-1.01.524c-.034.023-.065.05-.1.07a.232.232,0,0,1-.323-.051l0,0a.225.225,0,0,1,.048-.313l.015-.01c.327-.2.662-.384.994-.573a.368.368,0,0,1,.085-.034.365.365,0,0,0,.277-.261.934.934,0,0,1,.6-.531,2.263,2.263,0,0,1,1.506-.028,1.01,1.01,0,0,1,.733.681c.012.041.074.078.121.1a4.559,4.559,0,0,1,2.758,2.8,5.519,5.519,0,0,1,.176.68.172.172,0,0,0,.148.159.815.815,0,0,1,.622.7,2.428,2.428,0,0,1,.013.443.846.846,0,0,1-.862.829h-.383v.28a6.374,6.374,0,0,1-.246,2.06,3.955,3.955,0,0,1-1.09,1.818c-.026.024-.049.051-.084.089l.216.092a7.552,7.552,0,0,1,1.9,1.074,3.749,3.749,0,0,1,1.394,2.964.826.826,0,0,1-.545.782l-.134.062ZM49.145,29h-.877c-.217,0-.326-.084-.323-.24s.11-.23.317-.231h1.752a.358.358,0,0,0,.388-.316,2.56,2.56,0,0,0,0-.429.347.347,0,0,0-.3-.307,1.333,1.333,0,0,0-.2-.01H41.278a1.618,1.618,0,0,0-.184.008.362.362,0,0,0-.322.336c-.006.071,0,.143,0,.215,0,.388.114.5.5.5H46.96a.8.8,0,0,1,.183.011.215.215,0,0,1,.182.231.211.211,0,0,1-.194.22,1.033,1.033,0,0,1-.184.01H42.028a.629.629,0,0,0-.015.106c.015.4.011.808.05,1.209a3.94,3.94,0,0,0,1.9,3.108,2.772,2.772,0,0,0,1.966.489,3.825,3.825,0,0,0,2.592-1.779,4.121,4.121,0,0,0,.611-2c.029-.369.005-.742.005-1.133m-.7,7.2V34.3c0-.461,0-.455-.44-.621a.387.387,0,0,0-.405.049,3.211,3.211,0,0,1-3.805.131.811.811,0,0,0-.93-.062.2.2,0,0,0-.132.2v2.056a.982.982,0,0,0,.008.146h1.16c.275,0,.374.06.376.226s-.1.234-.385.234H42.736v1.1h5.688v-1.1H45.193c-.2,0-.3-.079-.3-.227s.1-.232.295-.232h3.254M45.593,25.373c.4,0,.537-.113.63-.5.106-.441.207-.884.325-1.322a.3.3,0,0,0-.132-.368,1.053,1.053,0,0,0-.229-.123,1.818,1.818,0,0,0-1.073-.036,1.392,1.392,0,0,0-.359.165.285.285,0,0,0-.126.356c.116.439.217.881.322,1.323.093.391.237.506.642.506m3.33,12.378h.892a.464.464,0,0,0,.011-.065V34.7c0-.037-.01-.094-.035-.109-.28-.173-.563-.34-.868-.522Zm1.386,0c.2,0,.4.015.586,0a.39.39,0,0,0,.368-.412v-.019a3.342,3.342,0,0,0-.808-2.132c-.04-.048-.083-.093-.144-.16Zm-9.442-2.726a3.363,3.363,0,0,0-.923,2.365.349.349,0,0,0,.3.34,6.138,6.138,0,0,0,.621.035Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4524","data-name":"Path 4524","d":"M27.134,26.865a.811.811,0,0,1-.465-.856c.016-.259,0-.521,0-.813H13.642a1.117,1.117,0,0,1-1.216-.855,2,2,0,0,1-.026-.572c.043-.7.1-1.395.149-2.092a.4.4,0,0,1,.4-.4.387.387,0,0,1,.387.387.419.419,0,0,1,0,.05c-.037.7-.079,1.4-.136,2.092-.04.493.042.6.526.6h2.763V22.279c0-.3.162-.479.407-.471s.379.175.381.468v2.112c.094.007.169.018.245.018H20.09a.289.289,0,0,0,.328-.212q.629-1.621,1.281-3.234a.306.306,0,0,0-.049-.354c-.334-.415-.655-.84-1-1.284-.153.11-.3.217-.445.319a.638.638,0,0,1-1.051-.423c-.182-.978-.347-1.958-.52-2.937-.01-.059-.027-.117-.049-.207-.466.1-.922.2-1.378.3l-2.322.522a1.558,1.558,0,0,0-1.305,1.44c-.047.452-.065.906-.1,1.359a3.412,3.412,0,0,1-.043.391.361.361,0,0,1-.394.323l-.015,0a.346.346,0,0,1-.365-.326.308.308,0,0,1,0-.043,13.6,13.6,0,0,1,.233-2.287,2.224,2.224,0,0,1,1.835-1.637q1.888-.423,3.777-.845a1.93,1.93,0,0,0,.867-.645c.132-.126.011-.606-.135-.73a4.761,4.761,0,0,1-1.721-3.164c-.008-.069-.024-.138-.038-.217-.15-.035-.3-.062-.451-.107a1.855,1.855,0,0,1-.865-2.974.52.52,0,0,0,.108-.34c-.063-.7-.151-1.406-.22-2.11-.03-.3.11-.5.35-.517s.409.168.44.476c.064.633.14,1.265.211,1.9.433-.041.406.056.484-.43a4.749,4.749,0,0,1,2.255-3.4.683.683,0,0,1,.846.071,10.238,10.238,0,0,0,3.634,1.754,16.336,16.336,0,0,0,1.7.312c.533.076.693.189.831.713a5.192,5.192,0,0,1,.113.538c.062.4.059.4.479.445a13.327,13.327,0,0,0,.173-2.757A3.82,3.82,0,0,0,24.22.851a27.151,27.151,0,0,0-3.952,0,3.646,3.646,0,0,0-3.115,2.323c-.033.071-.058.146-.093.217a.383.383,0,0,1-.483.246l-.027-.01a.389.389,0,0,1-.238-.5c0-.014.011-.027.017-.04A4.654,4.654,0,0,1,19.053.319,4.533,4.533,0,0,1,20.791,0c1,.007,1.994,0,2.99,0a4.7,4.7,0,0,1,4.564,3.938,8.562,8.562,0,0,1-.084,2.3c-.035.312-.084.623-.11.936a.354.354,0,0,0,.092.223,1.844,1.844,0,0,1-1.08,3.07.251.251,0,0,0-.239.262v0a4.72,4.72,0,0,1-1.671,3.13.7.7,0,0,0-.022.919,1.95,1.95,0,0,0,1.079.573c1.1.223,2.193.5,3.292.734A.462.462,0,0,0,29.945,16c.631-.526,1.251-1.066,1.871-1.6a1.612,1.612,0,0,1,2.28-.021l.01.01c.191.162.381.325.609.52.007-.149.01-.249.016-.349a.634.634,0,0,1,.629-.639h0c.454-.013.91-.014,1.364,0a.643.643,0,0,1,.636.65c0,.014,0,.029,0,.043,0,.787.007,1.574,0,2.361a.431.431,0,0,0,.175.377c.278.226.537.476.818.7a2.35,2.35,0,0,1,.9,1.213v.63a1.4,1.4,0,0,0-.062.137A1.586,1.586,0,0,1,37.6,21.157h-.243c0,.272.01.516,0,.759a.392.392,0,0,1-.784-.01,2.457,2.457,0,0,1,0-.5,1.1,1.1,0,0,0-.488-1.107c-1.054-.862-2.071-1.771-3.106-2.664a.935.935,0,0,0-.1.063c-1.132.976-2.265,1.951-3.391,2.936a.432.432,0,0,0-.109.3c-.008.962,0,1.924,0,2.885v.575h1.59V21.43a.761.761,0,0,1,.656-.853.774.774,0,0,1,.2,0h2.256c.593,0,.869.271.87.86V24.39h1.613v-.646c0-.346.149-.538.4-.53s.387.2.389.523v.673c.279,0,.531.015.781,0a1,1,0,0,1,1.111.68V26.4l-.42.472ZM20.159,3.713A3.843,3.843,0,0,0,18.325,6.7c-.075,1.088-.039,2.184-.044,3.277a4.876,4.876,0,0,0,.049.81,3.928,3.928,0,0,0,7.805-.21c.056-1.169.034-2.342.029-3.514a8.868,8.868,0,0,0-.1-.882c-.019-.188-.133-.227-.3-.256-.609-.109-1.223-.2-1.82-.358A11.2,11.2,0,0,1,20.156,3.71M27.178,24.4V22.274c0-.306.155-.48.4-.473s.385.186.387.468v2.117h.588V21.148H28.2a1.574,1.574,0,0,1-1.49-1.277,1.59,1.59,0,0,1,.592-1.584c.568-.487,1.133-.977,1.742-1.5l-3.181-.719c-.021.1-.037.154-.047.213-.173.979-.34,1.959-.52,2.937a.64.64,0,0,1-1.069.415l-.43-.306c-.357.46-.7.9-1.037,1.347a.287.287,0,0,0-.027.234q.658,1.68,1.337,3.354a.252.252,0,0,0,.179.138c.961.009,1.922.006,2.926.006m.244-4.881.064.039a.764.764,0,0,0,.562.762.87.87,0,0,0,.88-.265q1.825-1.583,3.652-3.161c.335-.289.452-.283.787.006q1.875,1.62,3.754,3.236a.8.8,0,0,0,1.153-1.109.811.811,0,0,0-.093-.083q-2.326-2.021-4.666-4.026a.787.787,0,0,0-1.1,0q-2.327,2-4.64,4.015a2.315,2.315,0,0,0-.356.574M38.463,26.06v-.513c0-.355,0-.355-.361-.355H27.823a.632.632,0,0,0-.208.008c-.053.02-.124.083-.127.129-.013.24-.006.481-.006.73ZM34.14,21.368H31.788v3.018h2.356ZM20.2,14.569c.623.858,1.328,1.648,2.014,2.477.672-.778,1.324-1.529,1.97-2.285a1.034,1.034,0,0,0,.1-.263,5.029,5.029,0,0,1-4.085.071m4.484.835L22.8,17.592l1.755,1.289c.167-.957.328-1.865.482-2.773.073-.429.054-.454-.352-.7m-3.05,2.187-1.865-2.2c-.425.322-.429.323-.347.8.1.549.2,1.1.294,1.646.06.336.118.673.183,1.047L21.633,17.6m.59,4.192-1.033,2.6h2.066l-1.034-2.6m-.009-3.631-.929.69.939,1.21.934-1.207-.943-.694M17.473,7.623a1,1,0,0,0-.944,1.05.977.977,0,0,0,.944.984Zm9.512,2.045a1.027,1.027,0,0,0,0-2.047Zm8.559,5.057c-.063.526-.085,1.006.458,1.3a3.709,3.709,0,0,1,.553.463V14.725Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4525","data-name":"Path 4525","d":"M38.834,26.864l.42-.472v.472Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4526","data-name":"Path 4526","d":"M22.2,12.415c-.356-.086-.714-.156-1.061-.262a.374.374,0,0,1-.274-.452.423.423,0,0,1,.485-.314.373.373,0,0,1,.056.02,2.347,2.347,0,0,0,1.635,0,.387.387,0,0,1,.515.185.364.364,0,0,1,.026.072.379.379,0,0,1-.3.494c-.349.1-.709.165-1.081.249","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4527","data-name":"Path 4527","d":"M24.669,8.476c0,.1.007.21,0,.314a.39.39,0,0,1-.779.012,4.388,4.388,0,0,1,0-.628.381.381,0,0,1,.4-.366h.005a.374.374,0,0,1,.382.366v.014c.007.1,0,.192,0,.288","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4528","data-name":"Path 4528","d":"M19.788,8.482c0-.1-.007-.21,0-.314a.39.39,0,0,1,.775-.026,2.856,2.856,0,0,1,0,.679.39.39,0,0,1-.775-.028c-.007-.1,0-.209,0-.314","fill":"#003645"}})])])]):_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"49.487","height":"48.776","viewBox":"0 0 49.487 48.776"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1375","data-name":"Rectangle 1375","width":"49.487","height":"48.776","transform":"translate(0 0.003)","fill":"#003645"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Hovedentreprenør","transform":"translate(0 -0.003)"}},[_c('g',{attrs:{"id":"Group_7610","data-name":"Group 7610","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4517","data-name":"Path 4517","d":"M.68,41.689l-.149-.058A.8.8,0,0,1,0,40.876a3.635,3.635,0,0,1,1.591-3.048.221.221,0,0,1,.313.005l.014.016c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131V41.19a.278.278,0,0,0,.011.05h.858V37.859c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062a4.936,4.936,0,0,1-1.362-4.061h-.3a.818.818,0,0,1-.89-.737.9.9,0,0,1,0-.147,1.751,1.751,0,0,1,.023-.409.767.767,0,0,1,.587-.595.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194H9.7a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.194,1.194,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.74,3.74,0,0,0-.966.5.916.916,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.214.214,0,0,1,.045-.3l.015-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092A4.363,4.363,0,0,1,9.974,30.17a5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793H9.7v.268A6.137,6.137,0,0,1,9.468,35.1a3.786,3.786,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06Zm8.564-8.822H8.409c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.216,1.216,0,0,0-.191-.009H1.722a1.472,1.472,0,0,0-.176.007.345.345,0,0,0-.308.321c0,.068,0,.137,0,.2,0,.372.11.482.479.482H7.156a.789.789,0,0,1,.175.011.219.219,0,0,1-.011.431,1.033,1.033,0,0,1-.176.009H2.439a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157A3.768,3.768,0,0,0,4.294,37.1a2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.084m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.367.367,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.195v1.967a.883.883,0,0,0,.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051H8.568V40.191h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222H8.578M5.851,29.4c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484M9.032,41.242H9.89A.423.423,0,0,0,9.9,41.18V38.318c0-.036-.009-.09-.034-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394V40.83a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153ZM1.325,38.634A3.22,3.22,0,0,0,.445,40.9a.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4518","data-name":"Path 4518","d":"M19.54,48.78l-.149-.058a.8.8,0,0,1-.531-.755,3.635,3.635,0,0,1,1.591-3.048.222.222,0,0,1,.313,0l.014.017c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131v2.877a.278.278,0,0,0,.011.05h.858V44.95c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062a4.936,4.936,0,0,1-1.362-4.061h-.3a.817.817,0,0,1-.889-.737.8.8,0,0,1,0-.147,1.751,1.751,0,0,1,.023-.409.767.767,0,0,1,.587-.6.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194h7.734a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.952.952,0,0,1-.913.754,1.2,1.2,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.756,3.756,0,0,0-.966.5,1.087,1.087,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.213.213,0,0,1,.046-.3l.014-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.893.893,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092a4.363,4.363,0,0,1,2.639,2.683,5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.777.777,0,0,1,.6.669,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793h-.368v.268a6.137,6.137,0,0,1-.236,1.971,3.786,3.786,0,0,1-1.043,1.739c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06ZM28.1,39.958h-.839c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.35,1.35,0,0,0-.191-.01H20.577a1.471,1.471,0,0,0-.176.008.345.345,0,0,0-.308.321c-.005.068,0,.137,0,.2,0,.372.11.482.479.482h5.442a.789.789,0,0,1,.175.011.219.219,0,0,1-.011.431,1.033,1.033,0,0,1-.176.009H21.3a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157a3.768,3.768,0,0,0,1.821,2.974,2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.367.367,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.195v1.967a.883.883,0,0,0,.008.139h1.11c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441V47.286h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113M24.7,36.494c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.423.423,0,0,0,.011-.062V45.414c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394v-.018a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153ZM20.172,45.73a3.22,3.22,0,0,0-.884,2.263.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4519","data-name":"Path 4519","d":"M38.451,42.023l-.149-.058a.8.8,0,0,1-.531-.755,3.635,3.635,0,0,1,1.591-3.048.222.222,0,0,1,.313,0l.014.017c.087.106.065.216-.055.333a.213.213,0,0,0-.069.131v2.877a.279.279,0,0,0,.011.05h.858V38.193c0-.091,0-.156-.107-.207a.212.212,0,0,1-.09-.285.215.215,0,0,1,.117-.1c.2-.1.41-.185.615-.276l.143-.062A4.936,4.936,0,0,1,39.75,33.2h-.3a.817.817,0,0,1-.889-.737.8.8,0,0,1,0-.147,1.75,1.75,0,0,1,.023-.409.767.767,0,0,1,.587-.6.16.16,0,0,0,.139-.154,4.287,4.287,0,0,1,.817-1.86c.015-.019.029-.039.045-.058a.222.222,0,1,1,.354.269c-.122.188-.256.37-.367.565a3.6,3.6,0,0,0-.416,1.194h7.731a3.823,3.823,0,0,0-2.548-3.021c-.095.394-.2.785-.281,1.18a.953.953,0,0,1-.913.754,1.194,1.194,0,0,1-.658-.112.879.879,0,0,1-.476-.6c-.086-.366-.175-.731-.264-1.1-.01-.042-.025-.083-.04-.133a3.74,3.74,0,0,0-.966.5.916.916,0,0,1-.1.067.221.221,0,0,1-.309-.049l0,0a.214.214,0,0,1,.045-.3l.015-.01c.313-.19.633-.367.951-.548a.341.341,0,0,1,.082-.032.351.351,0,0,0,.265-.25.89.89,0,0,1,.578-.508,2.166,2.166,0,0,1,1.441-.027.966.966,0,0,1,.7.651c.011.039.071.075.115.092A4.363,4.363,0,0,1,47.747,30.5a5.4,5.4,0,0,1,.169.65.164.164,0,0,0,.141.152.778.778,0,0,1,.6.668,2.312,2.312,0,0,1,.012.424.809.809,0,0,1-.824.793h-.368v.268a6.137,6.137,0,0,1-.236,1.971A3.786,3.786,0,0,1,46.2,37.169c-.025.023-.047.049-.08.085l.206.088a7.211,7.211,0,0,1,1.822,1.027,3.586,3.586,0,0,1,1.334,2.836.792.792,0,0,1-.521.748l-.128.06ZM47.015,33.2h-.838c-.208,0-.312-.08-.309-.23s.106-.22.3-.221h1.677a.343.343,0,0,0,.372-.3,2.551,2.551,0,0,0,0-.41.333.333,0,0,0-.285-.293,1.216,1.216,0,0,0-.191-.009H39.493a1.471,1.471,0,0,0-.176.007.345.345,0,0,0-.308.321c0,.068,0,.137,0,.2,0,.372.11.482.479.482H44.93a.789.789,0,0,1,.175.011.218.218,0,0,1-.01.43,1.033,1.033,0,0,1-.176.009H40.213a.669.669,0,0,0-.014.1c.014.386.011.773.048,1.157a3.771,3.771,0,0,0,1.821,2.974,2.651,2.651,0,0,0,1.881.468,3.658,3.658,0,0,0,2.48-1.7,3.943,3.943,0,0,0,.584-1.914c.028-.353,0-.71,0-1.083m-.666,6.884v-1.82c0-.441,0-.435-.421-.594a.369.369,0,0,0-.388.047,3.073,3.073,0,0,1-3.641.125.776.776,0,0,0-.89-.059.191.191,0,0,0-.126.2V39.95a.883.883,0,0,0,.008.139H42c.263,0,.358.057.36.216s-.1.223-.368.223h-1.1v1.051h5.441V40.523h-3.1c-.187,0-.286-.075-.288-.217s.1-.222.282-.222h3.113M43.612,29.731c.379,0,.514-.108.6-.479.1-.422.2-.846.31-1.265a.288.288,0,0,0-.127-.352,1,1,0,0,0-.219-.117,1.738,1.738,0,0,0-1.027-.034,1.318,1.318,0,0,0-.343.158.271.271,0,0,0-.121.34c.111.42.208.843.308,1.266.089.375.227.484.614.484m3.186,11.843h.854a.423.423,0,0,0,.011-.062V38.651c0-.036-.009-.09-.033-.1-.267-.166-.538-.325-.831-.5Zm1.326,0c.192,0,.377.014.56,0a.374.374,0,0,0,.352-.394v-.018a3.2,3.2,0,0,0-.773-2.04c-.038-.046-.08-.088-.138-.153Zm-9.033-2.608A3.22,3.22,0,0,0,38.2,41.23a.334.334,0,0,0,.29.325,5.9,5.9,0,0,0,.594.033Z","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4520","data-name":"Path 4520","d":"M33.364,29.552v-.865h1.543a.92.92,0,0,0,1.056-.76.931.931,0,0,0,0-.3v-.776c-.1-.006-.195-.013-.286-.015a1.289,1.289,0,0,1-1.27-1.275q-.012-2.221,0-4.443a1.279,1.279,0,0,1,1.172-1.275c.114-.012.228-.017.362-.027V18.73a3.1,3.1,0,0,1-1.586.2H14.674c-.4,0-.791-.071-1.2-.111v.964a3.74,3.74,0,0,1,.507.041,1.3,1.3,0,0,1,1.027,1.29q.006,2.15,0,4.3A1.3,1.3,0,0,1,13.8,26.8c-.043,0-.085,0-.128,0-.065,0-.13.011-.215.019,0,.377-.027.742.007,1.1a.861.861,0,0,0,.841.766c.1.006.192,0,.289,0H30.767v.865h-16.8a4.756,4.756,0,0,1-.59-.281,1.64,1.64,0,0,1-.792-1.421c-.007-.336,0-.672,0-1.019a7.007,7.007,0,0,1-.776-.1,2.133,2.133,0,0,1-1.646-2.1V22.064a2.157,2.157,0,0,1,2.049-2.26c.063,0,.127,0,.19,0a1.584,1.584,0,0,0,.184-.009V17.2a1.716,1.716,0,0,1,1.7-1.729H14.3c.827-.006,1.654,0,2.482,0,.028,0,.056.006.117.013v2.564h3.62V15.564a.318.318,0,0,0-.1-.2,6.182,6.182,0,0,1-1.846-3.912c-.219-.025-.439-.037-.652-.078A1.256,1.256,0,0,1,16.838,10.2a7.655,7.655,0,0,1,.011-1.123,1.115,1.115,0,0,1,.6-.931.428.428,0,0,0,.242-.456,7.6,7.6,0,0,1,.387-2.924c.186-.49.427-.959.664-1.485l.777.51a6.4,6.4,0,0,0-.924,4.119h3.038V7.522a1.271,1.271,0,0,1,1.23-1.31h.058q1.79-.031,3.578,0A1.272,1.272,0,0,1,27.78,7.472c0,.019,0,.039,0,.058v.386H30.8c.541-2.656-1.677-6.168-3.879-6.106V4.549h-.879V1.4c0-.357-.153-.521-.5-.525q-.837-.011-1.674,0a.437.437,0,0,0-.492.376.429.429,0,0,0,0,.124V4.54h-.867V1.778A4.214,4.214,0,0,0,20,3.161l-.648-.575a4.806,4.806,0,0,1,1.746-1.3A8.385,8.385,0,0,1,22.307.924a.5.5,0,0,0,.37-.262A1.211,1.211,0,0,1,23.784,0C24.39,0,25,0,25.6,0a1.3,1.3,0,0,1,1.162.676.469.469,0,0,0,.263.212,5.53,5.53,0,0,1,4.306,3.862,7.67,7.67,0,0,1,.388,2.953.409.409,0,0,0,.235.432,1.122,1.122,0,0,1,.6.927,7.246,7.246,0,0,1,.014,1.122,1.321,1.321,0,0,1-1.329,1.228c-.124.009-.249,0-.375,0-.084.414-.14.811-.246,1.2a6.1,6.1,0,0,1-1.543,2.665c-.077.079-.18.182-.182.275-.014.825-.008,1.651-.008,2.5H32.48v-2.56c.1-.009.177-.022.25-.022.789,0,1.578,0,2.367,0a1.718,1.718,0,0,1,1.724,1.712v.009c.005.847,0,1.693,0,2.539a.289.289,0,0,0,.016.066,7.186,7.186,0,0,1,.786.113,2.134,2.134,0,0,1,1.616,2.066c.007.875,0,1.75,0,2.626a2.162,2.162,0,0,1-2.088,2.233c-.041,0-.083,0-.124,0a2.263,2.263,0,0,0-.229.01c.131,1.193,0,2.276-1.366,2.7Zm-3.424-18.1a42.957,42.957,0,0,1-10.459.006,5.251,5.251,0,0,0,10.459-.006m-5.2-2.634H18.22c-.37,0-.5.135-.511.5v.519c0,.57.086.665.65.715.1.008.192.008.288.014,1.342.089,2.683.182,4.026.267a21.269,21.269,0,0,0,2.243.112c1.708-.074,3.413-.211,5.119-.325.422-.028.843-.057,1.264-.1a.413.413,0,0,0,.4-.424.314.314,0,0,0,0-.044V9.423c0-.483-.111-.593-.59-.593h-6.37M14.138,21.8c0-.241.005-.433,0-.624a.461.461,0,0,0-.4-.512.473.473,0,0,0-.119,0c-.413-.005-.827-.006-1.24,0a1.3,1.3,0,0,0-1.336,1.262c0,.013,0,.025,0,.038q-.029,1.341,0,2.683a1.275,1.275,0,0,0,1.207,1.271c.481.014.962,0,1.442,0a.408.408,0,0,0,.441-.373v-.027a6.675,6.675,0,0,0,0-.693H13.3v-.881h.842V22.673h-.848V21.8Zm21.135,3.03v.623a.461.461,0,0,0,.4.515.526.526,0,0,0,.119,0c.423.006.847.01,1.269,0a1.291,1.291,0,0,0,1.312-1.27v-.025q.03-1.341,0-2.682a1.277,1.277,0,0,0-1.274-1.28l-.073,0h-1.3a.406.406,0,0,0-.443.367c0,.011,0,.022,0,.033a6.711,6.711,0,0,0,0,.695h.837v.883h-.824v1.274h.829v.871Zm-13.85-6.781h6.566V16.18a6.2,6.2,0,0,1-6.566,0Zm-5.4.017V16.342c-.6,0-1.173-.018-1.747.006a.867.867,0,0,0-.83.87.881.881,0,0,0,.881.85c.557.009,1.114,0,1.7,0m17.349,0c.61,0,1.2.017,1.78-.006a.867.867,0,0,0,.8-.835.847.847,0,0,0-.763-.868c-.6-.038-1.2-.009-1.82-.009ZM26.907,7.924c0-.164.009-.3,0-.43a.386.386,0,0,0-.371-.4H26.5q-1.788-.007-3.576,0a.387.387,0,0,0-.408.363v.037c-.012.139,0,.281,0,.433Z","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1372","data-name":"Rectangle 1372","width":"0.866","height":"0.845","transform":"translate(31.632 28.707)","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1373","data-name":"Rectangle 1373","width":"0.826","height":"0.832","transform":"translate(30.789 19.82)","fill":"#003645"}}),_vm._v(" "),_c('rect',{attrs:{"id":"Rectangle_1374","data-name":"Rectangle 1374","width":"0.826","height":"0.832","transform":"translate(32.515 19.815)","fill":"#003645"}})])])]),_vm._v(" "),(_vm.itemSelect.CONTRACT_TYPE === 'Fagentreprise')?_c('p',{staticClass:"p0 m0 font12"},[_vm._v("Fagentreprise")]):_c('p',{staticClass:"p0 m0 font12"},[_vm._v("Hovedentreprise")])])])])],1),_vm._v(" "),_c('div',{attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('div',{staticClass:"clearfix flex justify-between items-center",staticStyle:{"border-color":"rgba(178,190,195, 0.5)"}},[(_vm.itemSelect.type === 'invitejobs' && _vm.itemSelect.STATUS === 'pending')?_c('button',{staticClass:"col-6 outlined-disabled-button no-border p3 h5 not-rounded gibson flex justify-center items-center",staticStyle:{"border":"0!important"},on:{"click":function($event){return _vm.saveresond(0)}}},[_c('span',[_vm._v("←")]),_vm._v(" "),_c('span',[_vm._v("Nedgang")])]):_vm._e(),_vm._v(" "),(_vm.itemSelect.type === 'invitejobs' && _vm.itemSelect.STATUS === 'pending')?_c('button',{staticClass:"col-6 outlined-action-button no-border p3 h5 regular border-none not-rounded gibson flex justify-center items-center",on:{"click":function($event){return _vm.saveresond(1)}}},[_c('span',{staticClass:"mx2"},[_vm._v("Acceptere")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Opgaveinvitationer\n              ")])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my3"},[_vm._v("\n              Her er oversigten over de jobs du har sagt nej til.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"white-background circle p0 m0 absolute top-0 right-0 m1",staticStyle:{"padding":"3px"}},[_c('i',{staticClass:"primarycolor el-icon-star-on"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"font14 semi-bold m0 darkblue gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',[_vm._v("Hovedentreprise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h6 primarycolor center semi-bold my1 line-height-1"},[_c('span',{},[_vm._v("Se detaljer")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpretProjektNew_vue__ = __webpack_require__(1196);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e46c0334_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OpretProjektNew_vue__ = __webpack_require__(1205);
function injectStyle (ssrContext) {
  __webpack_require__(1195)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OpretProjektNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e46c0334_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_OpretProjektNew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1195 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CreateProjectNew__ = __webpack_require__(1197);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    createnew: __WEBPACK_IMPORTED_MODULE_0__CreateProjectNew__["a" /* default */]
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    var projectId = this.$route.query.id;
    if (projectId !== undefined) {
      this.seen = true;
    }
  },

  data: function data() {
    return {
      projects: 0,
      projects_create: 0,
      seen: true,
      miniprofile: ''
    };
  },
  methods: {
    UpdateProject: function UpdateProject(projects, projectsCreate) {
      this.projects = projects;
      this.projects_create = projectsCreate;
    },
    gotocreateproject: function gotocreateproject() {
      this.$router.push('/opret-projekt-new/wizard');
    }
  }
});

/***/ }),
/* 1197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProjectNew_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36633ac8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProjectNew_vue__ = __webpack_require__(1204);
function injectStyle (ssrContext) {
  __webpack_require__(1198)
  __webpack_require__(1199)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-36633ac8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProjectNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36633ac8_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProjectNew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1198 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__uploads_projectimages__ = __webpack_require__(217);













/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'createnew',
  props: ['projects', 'projects_create'],
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_5__haandvaerker__["a" /* default */],
    VueClipboard: __WEBPACK_IMPORTED_MODULE_9_vue_clipboard2___default.a,
    projectimages: __WEBPACK_IMPORTED_MODULE_10__uploads_projectimages__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_7_vue2_dropzone___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_8_vue_select___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_6_vue_form_wizard___default.a
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  watch: {
    'tasktype': function tasktype(newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true;
      }
    },
    'title': function title(newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true;
      }
    },
    'description': function description(newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true;
      }
    }
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: false,
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      project_id: '',
      projectType: null,
      Producenter: 0,
      title: '',
      tasktype: [],
      manufacturetype: [],
      project: [],
      description: '',
      price: '',
      url: 'fgd',
      time: '',
      postnummer: '',
      fmans: {
        name: '',
        email: '',
        mobile: ''
      },
      mans: [],
      ProducenterOptions: [],
      manufactureoptions: [],
      images: [],
      taskoptions: [],
      pimages: [],
      projectOptions: ['Badeværelse', 'Gulv', 'Koekken', 'Tag', 'Terrasse', 'Udestue', 'Vinduer', 'Andet'],
      seen: false,
      noImage: false,
      startEdit: false,
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      salesPerson: '',
      success: false,
      kunde: {
        title: '',
        name: '',
        address: '',
        zip: '',
        tlf: '',
        email: ''
      }
    };
  },
  created: function created() {
    this.Reload();
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    onFinished: function onFinished() {
      alert('Yay. Done!');
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    facebokUrl: function facebokUrl(url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    },
    successCopy: function successCopy() {
      var obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onErrorCopy: function onErrorCopy() {
      alert('Kan ikke kopiere');
    },
    validateFirstStep: function validateFirstStep() {
      if (this.images.length === 0) {
        this.noImage = true;
        return false;
      }
      return true;
    },
    validateSecondStep: function validateSecondStep() {
      var validation = true;
      console.log(this.tasktype.length);
      if (this.tasktype.length === 0) {
        validation = false;
        this.validationType = false;
      }
      if (this.title === '') {
        validation = false;
        this.validationTitle = false;
      }
      if (this.description === '') {
        validation = false;
        this.validationDescription = false;
      }
      return validation;
    },
    onSubmitProjectInfo: function onSubmitProjectInfo(evt) {
      var _this2 = this;

      evt.preventDefault();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addProjectnew', salesPerson: this.salesPerson, levid: this.haaId, title: this.title, description: this.description };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {
            this.$router.push('/status-haandvaerker-new');
          };
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          var _obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    onComplete: function onComplete() {
      var _this3 = this;

      this.show = true;
      var manufacturelist = [];
      for (var i = 0; i < this.manufacturetype.length; i++) {
        var c = this.manufacturetype[i];
        manufacturelist.push(c.ManufactureId);
      }
      var tasktypelist = [];
      for (var j = 0; j < this.tasktype.length; j++) {
        var z = this.tasktype[j];
        tasktypelist.push(z.TaskTypeId);
      }
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addProjectothernew', salesPerson: this.salesPerson, levid: this.haaId, title: this.title, description: this.description, images: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.images), tasktypelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tasktypelist), manufacturelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(manufacturelist), postnummer: this.postnummer, price: this.price, time: this.time, projectid: this.project_id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this3.show = false;
        var res = response.body;
        if (res.success) {
          _this3.url = res.url;
          _this3.success = true;
        } else {
          var obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error'
          };
          _this3.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    change_position: function change_position(imageId, projectid) {},
    delete_image: function delete_image(image) {
      var index = this.images.indexOf(image);
      if (index > -1) {
        this.images.splice(index, 1);
      }
    },

    'showSuccess': function showSuccess(file) {
      this.noImage = false;
      this.images.push(file.xhr.response);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImagesPrevProject');
    },
    Reload: function Reload() {
      var _this4 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.project_id = this.$route.query.id;
      this.show = true;
      var data = { operation: 'myProjectInfo', salesPerson: this.salesPerson, levid: this.haaId, projectid: this.project_id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        _this4.show = false;
        _this4.$emit('UpdateProject', res.projects, res.projects_create);
        _this4.ProducenterOptions = res.center;
        _this4.Producenter = res.selected;
        _this4.taskoptions = res.TaskType;
        _this4.manufactureoptions = res.manufacture;
        if (_this4.project_id !== undefined) {
          _this4.project = res.project;
          _this4.title = res.project.title;
          _this4.description = res.project.description;
          for (var i = 0; i < res.manufacture.length; i++) {
            var c = res.manufacture[i];
            if (res.project.manufacturetype.includes(c.ManufactureId)) {
              _this4.manufacturetype.push(c);
            }
          }
          for (var j = 0; j < res.TaskType.length; j++) {
            var d = res.TaskType[j];
            if (res.project.tasktype.includes(d.TaskTypeId)) {
              _this4.tasktype.push(d);
            }
          }
          _this4.postnummer = res.project.postnummer;
          _this4.price = res.project.price;
          _this4.time = res.project.time;
        }
      }, function (response) {
        _this4.show = false;
        alert('error');
      });
    },
    delete_image_other: function delete_image_other(imageId, projectid) {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.show = false;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (res.success) {
          _this5.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    rorate_image: function rorate_image(imageId, projectid, image, primary) {
      var _this6 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this6.show = false;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        if (res.success) {
          _this6.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    SaveImage: function SaveImage(imageId, projectid) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    onSubmitKundeInfo: function onSubmitKundeInfo(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
      console.log(this.kunde);
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    buyProjects: function buyProjects() {
      this.$router.push('/purchase');
    }
  }
});

/***/ }),
/* 1201 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_dropzone__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'profileimages',
  props: ['project'],
  components: {
    Dropzone: __WEBPACK_IMPORTED_MODULE_1_vue2_dropzone___default.a
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 py4 flex flex-column justify-center items-center" style="height:100%;border:1px dashed #0B3645;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="40" height="40" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:18px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:15px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      primaryselected: ''
    };
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },

  methods: {
    'showSuccess': function showSuccess(file) {
      this.$emit('Reload');
    },
    toString: function toString(value) {
      return value.toString();
    },
    change_position: function change_position(imageId, projectid) {
      this.$emit('moveImage', imageId, projectid);
    },
    delete_image: function delete_image(imageId, projectid) {
      this.$emit('delete_image', imageId, projectid);
    },
    rotate_image: function rotate_image(imageId, projectid, image) {
      var primary = '';
      for (var id in this.project.images) {
        var val = this.project.images[id];
        if (val.isPrimary) {
          primary = val.id;
        }
      }
      this.$emit('rorate_image', imageId, projectid, image, primary);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('projectid', this.project.projectid);
      formData.append('operation', 'uploadImagesProject');
    }
  }
});

/***/ }),
/* 1203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"clearfix flex flex-wrap justify-start items-center"},_vm._l((_vm.project.images),function(image){return _c('div',{key:_vm.toString(image.id),staticClass:"col-4 px0 mr1"},[(image.image)?_c('b-img',{attrs:{"src":image.image.replace('&rotate=180', '').replace('&rotate=270', '').replace('&rotate=90', '').replace('&rotate=0', ''),"fluid":""}}):_vm._e(),_vm._v(" "),_c('b-alert',{attrs:{"show":"","variant":"primary"}},[(image.isPrimary === true)?_c('p',{staticClass:"hide"},[_vm._v(_vm._s(_vm.primaryselected = image.id.toString()))]):_vm._e(),_vm._v(" "),_c('b-form-radio',{staticClass:" mr-1",attrs:{"size":"lg","name":_vm.project.projectid.toString(),"id":image.id.toString(),"value":image.id.toString(),"checked":image.isPrimary === true},on:{"change":function($event){return _vm.change_position(image.id,_vm.project.projectid)}},model:{value:(_vm.primaryselected),callback:function ($$v) {_vm.primaryselected=$$v},expression:"primaryselected"}},[_vm._v("\n          Primært billede\n        ")])],1),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('b-button',{staticClass:"border-0 ",attrs:{"variant":"outline-dark"},on:{"click":function($event){return _vm.rotate_image(image.id,_vm.project.projectid,image.image)}}},[_c('i',{staticClass:"el-icon-refresh-right",attrs:{"aria-hidden":"true"}})]),_vm._v(" "),_c('b-button',{staticClass:"white-button border-none not-rounded",on:{"click":function($event){return _vm.delete_image(image.id,_vm.project.projectid)}}},[_c('i',{staticClass:"el-icon-delete",attrs:{"aria-hidden":"true"}})])],1)],1)}),0),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px2"},[_c('haandvaerker'),_vm._v(" "),(_vm.show)?_c('b-alert',{attrs:{"show":"","variant":"warning"}},[_vm._v("Loading....")]):_vm._e(),_vm._v(" "),(_vm.project_id !== undefined)?_c('div',[_c('p',{staticClass:"h5 pt3 darkblue semi-bold gibson line-height-golden"},[_vm._v("Opdater projekt:"),_c('br'),_vm._v(" "),_c('span',{staticClass:"h3 regular"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',[_c('p',{staticClass:"h4 gibson semi-bold darkblue line-height-3"},[_vm._v("\n      Gennemført!\n    ")]),_vm._v(" "),(_vm.project_id === undefined)?_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n      Dit projekt er tilføjet.\n    ")]):_vm._e(),_vm._v(" "),(_vm.project_id !== undefined)?_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n      Dit projekt er opdateret.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py2 flex flex-column"},[_c('span',{staticClass:"h6 regular gibson mediumgrey block m0"},[_vm._v("Projekt Url: ")]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue line-height-golden mb0"},[_vm._v(_vm._s(_vm.url))])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"col-12 facebook-button p1 py2 mt3 pointer no-hover flex justify-start items-center",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.facebokUrl(_vm.url)}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 white left-align pl1"},[_vm._v("Del dit projekt på Facebook")])]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.successCopy),expression:"successCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onErrorCopy),expression:"onErrorCopy",arg:"error"}],staticClass:"col-12 action-button p2 h5 my2 flex justify-center itemws-center gibson"},[_c('span',{staticClass:"regular"},[_vm._v("Kopiér url")]),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',[(!_vm.success)?_c('form-wizard',{ref:"wizard",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"wizard-footer-left col-6 px0"},[(props.activeTabIndex > 0)?_c('wizard-button',{staticClass:"wizard-footer-left",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h4 gibson line-height-1 ml2 semi-bold mb0"},[_vm._v("Tilbage")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right col-6 px0"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"wizard-footer-right",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"h4 gibson line-height-1 mr2 semi-bold mb0"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_c('wizard-button',{staticClass:"wizard-footer-right finish-button",style:(props.fillButtonStyle),attrs:{"type":"button"},nativeOn:{"click":function($event){return _vm.onComplete.apply(null, arguments)}}},[_vm._v(_vm._s(props.isLastStep ? 'Færdig' : 'Næste'))])],1)]}}],null,false,2284067882)},[(_vm.project_id === undefined)?_c('tab-content',{attrs:{"title":"1","before-change":_vm.validateFirstStep}},[_c('div',{staticClass:"gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular gibson mb2 line-height-3",attrs:{"show":_vm.noImage}},[_vm._v("\n            Start med at uploade billeder\n          ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap mb2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.project_id !== undefined)?_c('tab-content',{attrs:{"title":"1"}},[_c('div',{staticClass:"gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('projectimages',{attrs:{"project":_vm.project},on:{"moveImage":_vm.SaveImage,"Reload":_vm.Reload,"delete_image":_vm.delete_image_other,"rorate_image":_vm.rorate_image}})],1)]):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"title":"2","before-change":_vm.validateSecondStep}},[_c('div',{staticClass:"clearfix gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden gibson mb3"},[_vm._v("Projektinformationer")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue gibson line-height-1 mb1"},[_c('span',[_vm._v("Opgavetype:")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('v-select',{staticClass:"gibson h5 flex flex-wrap col-12 self-stretch px0",attrs:{"multiple":"","placeholder":"Begynd at skrive for at søge","label":"TaskTypeName","state":_vm.validationType,"options":_vm.taskoptions,"required":""},model:{value:(_vm.tasktype),callback:function ($$v) {_vm.tasktype=$$v},expression:"tasktype"}},[_c('template',{slot:"no-options"},[_c('p',{staticClass:"h5 darkblue gibson"},[_vm._v("Ingen matchende ...")])])],2),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.validationType === false,"variant":"danger"}},[_vm._v("Required")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix my3"},[_c('p',{staticClass:"darkblue gibson line-height-1 mb1"},[_c('span',[_vm._v("Titel")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"state":_vm.validationTitle,"type":"text","required":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('b-alert',{staticClass:"p1 gibson h5 semi-bold flex justify-start items-center red",attrs:{"show":_vm.validationType === false}},[_c('span',[_vm._v("Required")])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue h5 gibson regular line-height-golden mb2"},[_c('span',[_vm._v("Beskriv projektet så detaljeret som muligt (gerne med navne på produkterne, der er anvendt): ")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-textarea',{staticClass:"muted-background p2 gibson h5 line-height-golden border-none not-rounded",attrs:{"rows":8,"state":_vm.validationDescription,"type":"text","required":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('b-alert',{staticClass:"p1 gibson h5 semi-bold flex justify-start items-center red",attrs:{"show":_vm.validationDescription === false,"variant":"danger"}},[_vm._v("Required")])],1)]),_vm._v(" "),_c('tab-content',{attrs:{"title":"3"}},[_c('div',{staticClass:"clearfix gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden gibson mb3"},[_vm._v("\n            Ekstra Information\n          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson"},[_vm._v("\n            Producenter\n          ")]),_vm._v(" "),_c('v-select',{staticClass:"flex col-12 flex-wrap",attrs:{"multiple":"","label":"Name","options":_vm.manufactureoptions,"required":""},model:{value:(_vm.manufacturetype),callback:function ($$v) {_vm.manufacturetype=$$v},expression:"manufacturetype"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Ingen matchende ...\n            ")])],2),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.validationType === false,"variant":"danger"}},[_vm._v("Required")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},_vm._l((_vm.manufacturetype),function(man){return _c('b-col',{key:man.name,attrs:{"lg":"12","md":"12","sm":"12"}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":man.Name}},[_c('b-form-input',{staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"type":"text","placeholder":"Titel","name":"customers[][name]","required":""},model:{value:(man.name),callback:function ($$v) {_vm.$set(man, "name", $$v)},expression:"man.name"}})],1)],1)],1)}),1),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson mb1"},[_vm._v("\n            Postnummer\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnummer),expression:"postnummer"}],staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"type":"text"},domProps:{"value":(_vm.postnummer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnummer=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("f. eks., 2300")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson mb1"},[_vm._v("\n            Pris\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.price),expression:"price"}],staticClass:"col-12 p2 muted-background gibson h5 not-rounded border-none darkblue",attrs:{"type":"text"},domProps:{"value":(_vm.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.price=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("DKK inkl. vat")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 darkblue semi-bold line-height-golden gibson mb1"},[_vm._v("\n            Tid\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.time),expression:"time"}],staticClass:"col-12 p2 muted-background gibson h5 darkblue not-rounded border-none",attrs:{"type":"text"},domProps:{"value":(_vm.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.time=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("f. eks., 4-6 uger")])])]),_vm._v(" "),(_vm.project_id === undefined)?_c('tab-content',{attrs:{"title":"4"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"celarfix"},[_c('p',{staticClass:"h5 darkblue semi-bold gibson line-height-3"},[_vm._v("\n              Billede List\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson"},[_vm._v("\n              "+_vm._s(_vm.images.length)+" billeder\n            ")])]),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"flex flex-wrap"},[_c('div',[_c('b-img',{attrs:{"src":image,"fluid-grow":""}})],1)])})],2),_vm._v(" "),_c('b-card',{staticClass:"text-center",attrs:{"title":"Billede List","sub-title":_vm.images.length + ' Billede'}},[_c('b-row',[_c('div',{staticClass:"py-1"})])],1),_vm._v(" "),_c('div',{staticClass:"clearfix pb3"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Opgavetype:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._l((_vm.tasktype),function(task){return [_vm._v(_vm._s(task.TaskTypeName)+", ")]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Titel:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Beskrivelse:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.description)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Producenter:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.postnummer)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Postnummer:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._l((_vm.manufacturetype),function(man){return [_vm._v(" "+_vm._s(man.Name)+", ")]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Pris:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.price)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Tid:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.time)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1):_vm._e(),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"py4"})],1):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"mt3"},[(!_vm.success)?_c('form-wizard',{ref:"wizard",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"wizard-footer-left col-6 px0"},[(props.activeTabIndex > 0)?_c('wizard-button',{staticClass:"wizard-footer-left",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h4 gibson line-height-1 ml2 semi-bold mb0"},[_vm._v("Tilbage")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right col-6 px0"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"wizard-footer-right",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"h4 gibson line-height-1 mr2 semi-bold mb0"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_c('wizard-button',{staticClass:"wizard-footer-right finish-button",style:(props.fillButtonStyle),attrs:{"type":"button"},nativeOn:{"click":function($event){return _vm.onComplete.apply(null, arguments)}}},[_vm._v(_vm._s(props.isLastStep ? 'Færdig' : 'Næste'))])],1)]}}],null,false,2284067882)},[(_vm.project_id === undefined)?_c('tab-content',{attrs:{"title":"1 ud af 4","before-change":_vm.validateFirstStep}},[_c('div',{staticClass:"gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular gibson mb2 line-height-3",attrs:{"show":_vm.noImage}},[_vm._v("\n            Start med at uploade billeder\n          ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap mb2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2)])]):_vm._e(),_vm._v(" "),(_vm.project_id !== undefined)?_c('tab-content',{attrs:{"title":"1 ud af 4"}},[_c('div',{staticClass:"gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('projectimages',{attrs:{"project":_vm.project},on:{"moveImage":_vm.SaveImage,"Reload":_vm.Reload,"delete_image":_vm.delete_image_other,"rorate_image":_vm.rorate_image}})],1)]):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"title":"2 ud af 4","before-change":_vm.validateSecondStep}},[_c('div',{staticClass:"clearfix gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden gibson mb3"},[_vm._v("Projektinformationer")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue gibson line-height-1 mb1"},[_c('span',[_vm._v("Opgavetype:")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('v-select',{staticClass:"gibson h5 flex flex-wrap col-12 self-stretch px0",attrs:{"multiple":"","placeholder":"Begynd at skrive for at søge","label":"TaskTypeName","state":_vm.validationType,"options":_vm.taskoptions,"required":""},model:{value:(_vm.tasktype),callback:function ($$v) {_vm.tasktype=$$v},expression:"tasktype"}},[_c('template',{slot:"no-options"},[_c('p',{staticClass:"h5 darkblue gibson"},[_vm._v("Ingen matchende ...")])])],2),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.validationType === false,"variant":"danger"}},[_vm._v("Required")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix my3"},[_c('p',{staticClass:"darkblue gibson line-height-1 mb1"},[_c('span',[_vm._v("Titel")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.title),expression:"title"}],staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"state":_vm.validationTitle,"type":"text","required":""},domProps:{"value":(_vm.title)},on:{"input":function($event){if($event.target.composing){ return; }_vm.title=$event.target.value}}}),_vm._v(" "),_c('b-alert',{staticClass:"p1 gibson h5 semi-bold flex justify-start items-center red",attrs:{"show":_vm.validationType === false}},[_c('span',[_vm._v("Required")])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue h5 gibson regular line-height-golden mb2"},[_c('span',[_vm._v("Beskriv projektet så detaljeret som muligt (gerne med navne på produkterne, der er anvendt): ")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('b-form-textarea',{staticClass:"muted-background p2 gibson h5 line-height-golden border-none not-rounded",attrs:{"rows":8,"state":_vm.validationDescription,"type":"text","required":""},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('b-alert',{staticClass:"p1 gibson h5 semi-bold flex justify-start items-center red",attrs:{"show":_vm.validationDescription === false,"variant":"danger"}},[_vm._v("Required")])],1)]),_vm._v(" "),_c('tab-content',{attrs:{"title":"3 ud af 4"}},[_c('div',{staticClass:"clearfix gibson"},[_c('p',{staticClass:"h4 darkblue line-height-golden gibson mb3"},[_vm._v("\n            Ekstra Information\n          ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson"},[_vm._v("\n            Producenter\n          ")]),_vm._v(" "),_c('v-select',{staticClass:"flex col-12 flex-wrap",attrs:{"multiple":"","label":"Name","options":_vm.manufactureoptions,"required":""},model:{value:(_vm.manufacturetype),callback:function ($$v) {_vm.manufacturetype=$$v},expression:"manufacturetype"}},[_c('template',{slot:"no-options"},[_vm._v("\n              Ingen matchende ...\n            ")])],2),_vm._v(" "),_c('b-alert',{attrs:{"show":_vm.validationType === false,"variant":"danger"}},[_vm._v("Required")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},_vm._l((_vm.manufacturetype),function(man){return _c('b-col',{key:man.name,attrs:{"lg":"12","md":"12","sm":"12"}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":man.Name}},[_c('b-form-input',{staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"type":"text","placeholder":"Titel","name":"customers[][name]","required":""},model:{value:(man.name),callback:function ($$v) {_vm.$set(man, "name", $$v)},expression:"man.name"}})],1)],1)],1)}),1),_vm._v(" "),_c('div',{staticClass:"clearfix gibson mb2"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson mb1"},[_vm._v("\n            Postnummer\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnummer),expression:"postnummer"}],staticClass:"col-12 p2 muted-background darkblue h5 gibson not-rounded border-none",attrs:{"type":"text"},domProps:{"value":(_vm.postnummer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnummer=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("f. eks., 2300")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h5 darkblue line-height-golden gibson mb1"},[_vm._v("\n            Pris\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.price),expression:"price"}],staticClass:"col-12 p2 muted-background gibson h5 not-rounded border-none darkblue",attrs:{"type":"text"},domProps:{"value":(_vm.price)},on:{"input":function($event){if($event.target.composing){ return; }_vm.price=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("DKK inkl. vat")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 darkblue semi-bold line-height-golden gibson mb1"},[_vm._v("\n            Tid\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.time),expression:"time"}],staticClass:"col-12 p2 muted-background gibson h5 darkblue not-rounded border-none",attrs:{"type":"text"},domProps:{"value":(_vm.time)},on:{"input":function($event){if($event.target.composing){ return; }_vm.time=$event.target.value}}}),_vm._v(" "),_c('p',{staticClass:"h6 mediumgreuy line-height-4 my1 gibson regular",attrs:{"id":"input-live-help"}},[_vm._v("f. eks., 4-6 uger")])])]),_vm._v(" "),(_vm.project_id === undefined)?_c('tab-content',{attrs:{"title":"4 ud af 4"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"celarfix"},[_c('p',{staticClass:"h5 darkblue semi-bold gibson line-height-3"},[_vm._v("\n              Billede List\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson"},[_vm._v("\n              "+_vm._s(_vm.images.length)+" billeder\n            ")])]),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image,staticClass:"flex flex-wrap"},[_c('div',[_c('b-img',{attrs:{"src":image,"fluid-grow":""}})],1)])})],2),_vm._v(" "),_c('b-card',{staticClass:"text-center",attrs:{"title":"Billede List","sub-title":_vm.images.length + ' Billede'}},[_c('b-row',[_c('div',{staticClass:"py-1"})])],1),_vm._v(" "),_c('div',{staticClass:"clearfix pb3"},[_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Opgavetype:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._l((_vm.tasktype),function(task){return [_vm._v(_vm._s(task.TaskTypeName)+", ")]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Titel:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.title)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Beskrivelse:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.description)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Producenter:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.postnummer)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Postnummer:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._l((_vm.manufacturetype),function(man){return [_vm._v(" "+_vm._s(man.Name)+", ")]})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Pris:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.price)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h6 darkblue gibson mb1"},[_vm._v("Tid:")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue mb3"},[_vm._v("\n              "+_vm._s(_vm.time)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1):_vm._e(),_vm._v(" "),_vm._v(" "),_c('div',{staticClass:"py4"})],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1 relative",staticStyle:{"top":"-4px"}},[_c('img',{attrs:{"src":"/static/svg/facebook.svg","alt":"","width":"20","height":"20"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3 darkblue notosans"},[_c('div',{staticClass:"clearfix px3 mpx1 mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix px2 py3 mpx1 ml4 mm0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),(!_vm.minprofile)?_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"relative"},[_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"action-button p2 h4 line-height-1 regular line-height-1 fles justify-center items-center not-rounded border-none",on:{"click":function($event){return _vm.gotocreateproject()}}},[_c('span',[_vm._v("Kom i gang")]),_vm._v(" "),_vm._m(1)])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix mt3"},[(_vm.miniprofile)?_c('div',{staticClass:"transparent-darkblue-background py4 my2 absolute left-0 right-0 top-0 bottom-0 z2 col-12 flex flex-column justify-start items-start"},[_c('p',{staticClass:"h5 line-height-golden white mt4 mb2"},[_vm._v("\n              Som basismedlem har du desværre ikke adgang til denne del af partner-login.\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 line-height-golden white mb2"},[_vm._v("\n              Opgrader din løsning, hvis du vil have adgang.\n            ")]),_vm._v(" "),_vm._m(2)]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"py4"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Opret projekter og fremvis dit flotte arbejde")]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden mb2"},[_vm._v("\n            Her kan du oprette projekter ved at uploade billeder af dit arbejde og skrive hvad du har lavet på opgaven.\n            "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"semi-bold block darkblue p0 m0"},[_vm._v("Sådan gør du:")])]),_vm._v(" "),_c('ol',{staticClass:"pl2"},[_c('li',{staticClass:"mb2"},[_c('span',{staticClass:"h6 regular pl2 flex"},[_vm._v("Upload billederne af dit projekt")])]),_vm._v(" "),_c('li',{staticClass:"mb2"},[_c('span',{staticClass:"h6 regular pl2 flex"},[_vm._v("Vælg opgavetype, giv projektet en titel og beskriv projektet")])]),_vm._v(" "),_c('li',{staticClass:"mb2"},[_c('span',{staticClass:"h6 regular pl2 flex"},[_vm._v("Tryk på “Færdig” - så modtager vi informationerne og lægger projektet på Håndværker.dk")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"p2 white-button h5 line-height-1 not-rounded border-none flex justify-center items-center"},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProjectNew_vue__ = __webpack_require__(1208);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e631f9c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProjectNew_vue__ = __webpack_require__(1209);
function injectStyle (ssrContext) {
  __webpack_require__(1207)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProjectNew_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e631f9c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProjectNew_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1207 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__uploads_projectimages__ = __webpack_require__(217);












var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'createnew',
  props: ['projects', 'projects_create'],
  components: {
    VueClipboard: __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default.a,
    projectimages: __WEBPACK_IMPORTED_MODULE_9__uploads_projectimages__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard___default.a,
    ErrorHandler: ErrorHandler
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  watch: {
    'tasktype': function tasktype(newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true;
      }
    },
    'search': function search(newVal, oldVal) {
      var _this = this;

      if (newVal.length > 2) {
        setTimeout(function () {
          _this.filtersearchkundematch(newVal);
        }, 200);
      } else {
        this.taskoptions = this.taskoptionsmain.slice(0, 30);
      }
    },
    'searchmanufacturer': function searchmanufacturer(newVal, oldVal) {
      var _this2 = this;

      if (newVal.length > 1) {
        setTimeout(function () {
          _this2.filtermanufacturersearch(newVal);
        }, 200);
      } else {
        this.filteredmanufacturer = this.manufactureoptions.slice(0, 30);
      }
    },
    'title': function title(newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true;
      }
    },
    'description': function description(newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true;
      }
    }
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: false,
        renameFile: true,
        complete: function complete(file) {
          var _this3 = this;

          setTimeout(function () {
            _this3.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class=" regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor  line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      project_id: '',
      projectType: null,
      Producenter: 0,
      title: '',
      tasktype: [],
      manufacturetype: [],
      project: [],
      description: '',
      price: '',
      url: 'fgd',
      time: '',
      postnummer: '',
      fmans: {
        name: '',
        email: '',
        mobile: ''
      },
      mans: [],
      ProducenterOptions: [],
      manufactureoptions: [],
      images: [],
      taskoptions: [],
      pimages: [],
      projectOptions: ['Badeværelse', 'Gulv', 'Koekken', 'Tag', 'Terrasse', 'Udestue', 'Vinduer', 'Andet'],
      seen: false,
      noImage: false,
      startEdit: false,
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      salesPerson: '',
      salesPersonbitrix: '',
      success: false,
      kunde: {
        title: '',
        name: '',
        address: '',
        zip: '',
        tlf: '',
        email: ''
      },
      maintask: [],
      subtaskoptions: [],
      selectedbrancheid: '',
      search: '',
      searchmanufacturer: '',
      createprojectform: {
        title: '',
        projectcreated: '',
        time: '',
        price: '',
        postnummer: '',
        description: ''
      },
      createprojectformrule: {
        title: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst din projekttitel',
          trigger: 'blur'
        }],
        projectcreated: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst dit projekts oprettelsesdato',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit tid',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit pris',
          trigger: 'blur'
        }],
        postnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }]
      },
      letterarr: [],
      filteredmanufacturer: [],
      taskoptionsmain: []
    };
  },
  created: function created() {
    this.Reload();

    this.project_id = this.$route.query.id;
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    onFinished: function onFinished() {
      alert('Yay. Done!');
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    facebokUrl: function facebokUrl(url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    },
    successCopy: function successCopy() {
      var obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onErrorCopy: function onErrorCopy() {
      alert('Kan ikke kopiere');
    },
    validateFirstStep: function validateFirstStep() {
      if (this.images.length === 0) {
        this.noImage = true;
        this.$message({
          type: 'error',
          message: 'Tilføj venligst mindst 1 billedee'
        });
        return false;
      }
      if (this.tasktype.length < 1) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en opgave'
        });
        return false;
      }
      return true;
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this4 = this;

      this.salesPersonbitrix = localStorage.getItem('token_portal_bitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.maintask = res.data;
          var itemssub = [];
          _this4.maintask.forEach(function (a) {
            a.SubIndustries.forEach(function (b) {
              if (b.taskTypes && b.taskTypes.length > 0) {
                b.taskTypes.forEach(function (c) {
                  itemssub.push(c);
                });
              }
            });
          });
          _this4.suboptions = itemssub;
          _this4.subtaskoptions = itemssub.slice(0, 30);
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    selectmaintask: function selectmaintask(arr) {
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr);
        this.suboptions.splice(this.suboptions.indexOf(arr), 1);
        this.subtaskoptions.splice(this.subtaskoptions.indexOf(arr), 1);
      }
    },
    selectmaintaskkundematch: function selectmaintaskkundematch(arr) {
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr);
        this.taskoptionsmain.splice(this.taskoptionsmain.indexOf(arr), 1);
        this.taskoptions.splice(this.taskoptions.indexOf(arr), 1);
      }
    },
    selectmanufacturelist: function selectmanufacturelist(manitem) {
      if (this.manufacturetype.indexOf(manitem) < 0) {
        this.manufacturetype.push(manitem);
        this.manufactureoptions.splice(this.manufactureoptions.indexOf(manitem), 1);
        this.filteredmanufacturer.splice(this.filteredmanufacturer.indexOf(manitem), 1);
      }
    },
    filtersearch: function filtersearch(type) {
      var filtertype = [];
      filtertype = this.suboptions.filter(function (z) {
        return z.name.toLowerCase().includes(type.toLowerCase());
      });
      this.subtaskoptions = filtertype;
    },
    filtersearchkundematch: function filtersearchkundematch(type) {
      var filtertype = [];
      filtertype = this.taskoptionsmain.filter(function (z) {
        return z.TaskTypeName.toLowerCase().includes(type.toLowerCase());
      });
      this.taskoptions = filtertype;
    },
    filtermanufacturersearch: function filtermanufacturersearch(text) {
      var filtertypemanu = [];
      filtertypemanu = this.manufactureoptions.filter(function (m) {
        return m.Name.toLowerCase().includes(text.toLowerCase());
      });
      this.filteredmanufacturer = filtertypemanu;
    },
    filterbyletter: function filterbyletter(letter) {
      var filtermanufacturer = [];
      filtermanufacturer = this.manufactureoptions.filter(function (n) {
        return n.Name.charAt(0).toUpperCase() === letter;
      });
      this.filteredmanufacturer = filtermanufacturer;
    },
    removeMan: function removeMan(manarr) {
      this.filteredmanufacturer.push(manarr);
      this.manufactureoptions.push(manarr);
      this.manufacturetype.splice(this.manufacturetype.indexOf(manarr), 1);
    },
    removetask: function removetask(taskarr) {
      this.suboptions.push(taskarr);
      this.subtaskoptions.push(taskarr);
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1);
    },
    removetaskkundematch: function removetaskkundematch(taskarr) {
      this.taskoptions.push(taskarr);
      this.taskoptionsmain.push(taskarr);
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1);
    },
    validateSecondStep: function validateSecondStep() {
      var error = 0;
      this.$refs['createprojectform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      return true;
    },
    onComplete: function onComplete() {
      var _this5 = this;

      this.show = true;
      var manufacturelist = [];
      for (var i = 0; i < this.manufacturetype.length; i++) {
        var c = this.manufacturetype[i];
        manufacturelist.push(c.ManufactureId);
      }
      var tasktypelist = [];
      for (var j = 0; j < this.tasktype.length; j++) {
        var z = this.tasktype[j];
        tasktypelist.push(z.TaskTypeId);
      }
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = {
        operation: 'addProjectothernew',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        title: this.createprojectform.title,
        description: this.createprojectform.description,
        images: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.images),
        tasktypelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tasktypelist),
        manufacturelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(manufacturelist),
        postnummer: this.createprojectform.postnummer,
        price: this.createprojectform.price,
        time: this.createprojectform.time,
        projectid: this.project_id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this5.show = false;
        var res = response.body;
        if (res.success) {
          _this5.url = res.url;
          _this5.success = true;
          _this5.$router.push('/opret-projekt-new/tak?projecturl=' + encodeURI(res.url));
        } else {
          var obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error'
          };
          _this5.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    change_position: function change_position(imageId, projectid) {},
    delete_image: function delete_image(image) {
      var index = this.images.indexOf(image);
      if (index > -1) {
        this.images.splice(index, 1);
      }
    },

    'showSuccess': function showSuccess(file) {
      this.noImage = false;
      this.images.push(file.xhr.response);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImagesPrevProject');
    },
    Reload: function Reload() {
      var _this6 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.project_id = this.$route.query.id;
      this.show = true;
      var data = { operation: 'myProjectInfo', salesPerson: this.salesPerson, levid: this.haaId, projectid: this.project_id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        _this6.show = false;
        _this6.$emit('UpdateProject', res.projects, res.projects_create);
        _this6.ProducenterOptions = res.center;
        _this6.Producenter = res.selected;
        _this6.taskoptionsmain = res.TaskType;
        _this6.taskoptions = res.TaskType.slice(0, 30);
        _this6.manufactureoptions = res.manufacture;
        _this6.filteredmanufacturer = res.manufacture.slice(0, 30);
        var letters = [];
        res.manufacture.forEach(function (a) {
          letters.push(a.Name.charAt(0).toUpperCase());
        });
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this6.letterarr = letters.filter(unique).sort();
        if (_this6.project_id !== undefined) {
          _this6.project = res.project;
          _this6.createprojectform.title = res.project.title;
          _this6.createprojectform.description = res.project.description;
          if (res.project.manufacturetype !== null) {
            for (var i = 0; i < res.manufacture.length; i++) {
              var c = res.manufacture[i];
              if (res.project.manufacturetype.includes(c.ManufactureId)) {
                _this6.manufacturetype.push(c);
              }
            }
          }
          if (res.project.tasktype !== null) {
            for (var j = 0; j < res.TaskType.length; j++) {
              var d = res.TaskType[j];
              if (res.project.tasktype.includes(d.TaskTypeId)) {
                _this6.tasktype.push(d);
              }
            }
          }
          var datanow = new Date();
          _this6.createprojectform.postnummer = res.project.postnummer;
          _this6.createprojectform.price = Number(res.project.price);
          _this6.createprojectform.time = res.project.time;
          _this6.createprojectform.projectcreated = datanow.getDate();
          _this6.images = res.project.images;
        }
      }, function (response) {
        _this6.show = false;
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    delete_image_other: function delete_image_other(imageId, projectid) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    rorate_image: function rorate_image(imageId, projectid, image, primary) {
      var _this8 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this8.show = false;
        if (res.login === false) {
          _this8.$router.push('/login');
        }
        if (res.success) {
          _this8.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    SaveImage: function SaveImage(imageId, projectid) {
      var _this9 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this9.show = false;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        if (res.success) {
          _this9.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    onSubmitKundeInfo: function onSubmitKundeInfo(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
      console.log(this.kunde);
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    buyProjects: function buyProjects() {
      this.$router.push('/purchase');
    }
  }
});

/***/ }),
/* 1209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px2 notosans ",attrs:{"id":"projectwizardv2"}},[(_vm.project_id !== undefined)?_c('div',[_c('p',{staticClass:"h5 pt3 darkblue semi-bold  line-height-golden"},[_vm._v("Opdater projekt:"),_c('br'),_vm._v(" "),_c('span',{staticClass:"h3 regular"},[_vm._v(_vm._s(_vm.title))])])]):_vm._e(),_vm._v(" "),(_vm.success)?_c('div',[_c('p',{staticClass:"h4  semi-bold darkblue line-height-3"},[_vm._v("\n      Gennemført!\n    ")]),_vm._v(" "),(_vm.project_id === undefined)?_c('p',{staticClass:"h5 darkblue regular  line-height-golden"},[_vm._v("\n      Dit projekt er tilføjet.\n    ")]):_vm._e(),_vm._v(" "),(_vm.project_id !== undefined)?_c('p',{staticClass:"h5 darkblue regular  line-height-golden"},[_vm._v("\n      Dit projekt er opdateret.\n    ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py2 flex flex-column"},[_c('span',{staticClass:"h6 regular  mediumgrey block m0"},[_vm._v("Projekt Url: ")]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue line-height-golden mb0"},[_vm._v(_vm._s(_vm.url))])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"col-12 facebook-button p1 py2 mt3 pointer no-hover flex justify-start items-center",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.facebokUrl(_vm.url)}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 white left-align pl1"},[_vm._v("Del dit projekt på Facebook")])]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.url),expression:"url",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.successCopy),expression:"successCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onErrorCopy),expression:"onErrorCopy",arg:"error"}],staticClass:"col-12 action-button p2 h5 my2 flex justify-center itemws-center "},[_c('span',{staticClass:"regular"},[_vm._v("Kopiér url")]),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt1 lg-col-11 lg-col-11 lg-col-11 xs-col-12 mx-auto p0 m0"},[(!_vm.success)?_c('form-wizard',{ref:"wizard",attrs:{"title":"","subtitle":"","shape":"circle","color":"rgba(25, 163, 192, 1.0)","error-color":"rgba(207,0,15,1.0)","finishButtonText":"Bekræft"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"wizard-footer-left col-6 px0"},[(props.activeTabIndex > 0)?_c('wizard-button',{staticClass:"wizard-footer-left",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h4 line-height-1 ml2 semi-bold mb0"},[_vm._v("Tilbage")])]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right col-6 px0"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"wizard-footer-right",style:(props.fillButtonStyle),nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"h4 line-height-1 mr2 semi-bold mb0"},[_vm._v("Næste")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_c('wizard-button',{staticClass:"wizard-footer-right finish-button",style:(props.fillButtonStyle),attrs:{"type":"button"},nativeOn:{"click":function($event){return _vm.onComplete.apply(null, arguments)}}},[_vm._v(_vm._s(props.isLastStep ? 'Færdig' : 'Næste'))])],1)]}}],null,false,3257804138)},[_c('tab-content',{attrs:{"title":"1 ud af 4","before-change":_vm.validateFirstStep}},[_c('div',{},[_c('p',{staticClass:"h4 darkblue col-12 center line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h5 col-12 center darkblue regular  mb2 line-height-3",attrs:{"show":_vm.noImage}},[_vm._v("\n            Start med at uploade billeder\n          ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue ",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap mb2"},[_c('dropzone',{staticClass:"pointer",attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image.id},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[(_vm.project_id === undefined)?_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}):_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image.image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h6 darkblue regular mb0 p2 col-10 pl0",staticStyle:{"background":"transparent","border":"0px!important"},attrs:{"type":"search","name":"search","placeholder":"Søg opgavetype"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0 mt2"},[_c('div',{staticClass:"flex flex-wrap",staticStyle:{"gap":"10px"}},_vm._l((_vm.taskoptions),function(mainitem,index){return _c('div',{key:mainitem.taskTypeId,attrs:{"id":'divsubbrancheitems' + index}},[_c('button',{staticClass:"buttonmaintask p1",attrs:{"id":'button' + mainitem.TaskTypeId},on:{"click":function($event){return _vm.selectmaintaskkundematch(mainitem)}}},[_c('span',{staticClass:"h6 regular inline-block center p0 m0"},[_vm._v(_vm._s(mainitem.TaskTypeName))])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"py2 col-12 px0"},[_c('p',{staticClass:"h5"},[_vm._v("Valgt opgavetype")]),_vm._v(" "),_vm._l((_vm.tasktype),function(selectedmans,index){return _c('button',{key:index,staticClass:"p1 mr1 mb1 darkblue-background center relative ",attrs:{"disable-transitions":false,"id":'manbutton' + selectedmans.TaskTypeId}},[_c('p',{staticClass:"mr1 h6 mb0 p0 line-height-1 inline-block regular white px2",staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(selectedmans.TaskTypeName))]),_vm._v(" "),_c('p',{staticClass:"absolute right-0 top-0"},[_c('span',{staticClass:"white block m0 p0 line-height-1 no-hover",on:{"click":function($event){return _vm.removetaskkundematch(selectedmans)}}},[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])})],2)]),_vm._v(" "),_c('tab-content',{attrs:{"title":"2 ud af 4","before-change":_vm.validateSecondStep}},[_c('div',{staticClass:"clearfix col-12 mb3"},[_c('p',{staticClass:"h4 darkblue col-12 m0 p0 line-height-golden center"},[_vm._v("Projektinformationer")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue col-12 m0 p0 line-height-golden center"},[_vm._v("Her kan du oprette projekter ved at uploade billeder af dit arbejde og skrive hvad du har lavet på opgaven.")])]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-column col-11 mx-auto mb2 m0 p0"},[_c('p',{staticClass:"darkblue  line-height-1 mb1"},[_c('span',[_vm._v("Opgavetype:")]),_c('span',{staticClass:"red"},[_vm._v("*")])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0"},_vm._l((_vm.tasktype),function(item){return _c('button',{key:item.ID,staticClass:"smallbutton darkblue ml1 mb1"},[_vm._v("\n              "+_vm._s(item.TaskTypeName)+"\n            ")])}),0)]),_vm._v(" "),_c('el-form',{ref:"createprojectform",staticClass:" p0 m0 md-col-11 lg-col-11 sm-col-11 xd-col-12 mx-auto",attrs:{"id":"createprojectform","model":_vm.createprojectform,"rules":_vm.createprojectformrule,"label-position":"top"}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Titel Field","prop":"title"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"title","clearable":""},model:{value:(_vm.createprojectform.title),callback:function ($$v) {_vm.$set(_vm.createprojectform, "title", $$v)},expression:"createprojectform.title"}})],1)],1)]),_vm._v(" "),(_vm.project_id === undefined)?_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Project oprettet","prop":"projectcreated"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"oprettelsesdato","clearable":""},model:{value:(_vm.createprojectform.projectcreated),callback:function ($$v) {_vm.$set(_vm.createprojectform, "projectcreated", $$v)},expression:"createprojectform.projectcreated"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Tid (antal dage)","id":"time","prop":"time"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"Tre dage eller 4-6 uger","clearable":""},model:{value:(_vm.createprojectform.time),callback:function ($$v) {_vm.$set(_vm.createprojectform, "time", $$v)},expression:"createprojectform.time"}})],1)],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Pris (kr.)","prop":"price"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"kr.","clearable":""},model:{value:(_vm.createprojectform.price),callback:function ($$v) {_vm.$set(_vm.createprojectform, "price", _vm._n($$v))},expression:"createprojectform.price"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Postnummer","id":"postnummer","prop":"postnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"2300","clearable":""},model:{value:(_vm.createprojectform.postnummer),callback:function ($$v) {_vm.$set(_vm.createprojectform, "postnummer", $$v)},expression:"createprojectform.postnummer"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Beskrivelse","prop":"description"}},[_c('el-input',{staticClass:" white-background",attrs:{"type":"textarea","rows":3,"placeholder":"Beskrivelse","clearable":""},model:{value:(_vm.createprojectform.description),callback:function ($$v) {_vm.$set(_vm.createprojectform, "description", $$v)},expression:"createprojectform.description"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-wrap m0 p0 px2"},_vm._l((_vm.images),function(image){return _c('div',{key:image.id},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[(_vm.project_id === undefined)?_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}):_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image.image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])}),0)],1),_vm._v(" "),_c('tab-content',{attrs:{"title":"3 ud af 4"}},[_c('div',{staticClass:"p1"},[_c('p',{staticClass:"darkblue h4 semi-bold center"},[_vm._v("Producenter")]),_vm._v(" "),_c('div',{staticClass:"col-12 my2 p2"},[_c('p',{staticClass:"h6 center m0 p0 col-12"},[_vm._v("Index")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap center justify-center items center primarycolor my2"},_vm._l((_vm.letterarr),function(letter,index){return _c('p',{key:index,staticClass:"h4 semi-bold mx2 pointer",on:{"click":function($event){return _vm.filterbyletter(letter)}}},[_vm._v(_vm._s(letter))])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 my2"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchmanufacturer),expression:"searchmanufacturer"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 col-10 pl0",staticStyle:{"background":"transparent","border":"0px!important"},attrs:{"type":"search","name":"searchmanufacturer","placeholder":"Søg Fabrikant"},domProps:{"value":(_vm.searchmanufacturer)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchmanufacturer=$event.target.value}}}),_vm._v(" "),_c('input',{staticClass:"action-button",attrs:{"type":"submit","value":"Search"}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-wrap p2 mb2 justify-start",staticStyle:{"gap":"10px"}},_vm._l((_vm.filteredmanufacturer),function(manitem,index){return _c('button',{key:index,staticClass:"buttonmaintask p1",attrs:{"id":'manbuttons' + manitem.ManufactureId},on:{"click":function($event){return _vm.selectmanufacturelist(manitem)}}},[_c('span',{staticClass:"h6 regular inline-block center p0 m0"},[_vm._v(_vm._s(manitem.Name))])])}),0),_vm._v(" "),_c('div',{staticClass:"p2 col-12"},[_c('p',{staticClass:"h5"},[_vm._v("Udvalgt producent")]),_vm._v(" "),_vm._l((_vm.manufacturetype),function(selectedman,index){return _c('button',{key:index,staticClass:"p1 mr1 mb1 darkblue-background center relative ",attrs:{"disable-transitions":false,"id":'manbutton' + selectedman.ManufactureId}},[_c('p',{staticClass:"mr1 h6 mb0 p0 line-height-1 inline-block regular white px2",staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(selectedman.Name))]),_vm._v(" "),_c('p',{staticClass:"absolute right-0 top-0"},[_c('span',{staticClass:"white block m0 p0 line-height-1 no-hover",on:{"click":function($event){return _vm.removeMan(selectedman)}}},[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])})],2)])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('div',{staticClass:"py4 lg-hide sm-hide"})],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1 relative",staticStyle:{"top":"-4px"}},[_c('img',{attrs:{"src":"/static/svg/facebook.svg","alt":"","width":"20","height":"20"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProject_Tak_vue__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c349b25a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProject_Tak_vue__ = __webpack_require__(1213);
function injectStyle (ssrContext) {
  __webpack_require__(1211)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProject_Tak_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c349b25a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProject_Tak_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1211 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'creatproject_takpage',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a
  },
  watch: {},
  created: function created() {
    this.projecturl = this.$route.query.projecturl;
  },
  data: function data() {
    return {
      haaId: '',
      salesPerson: '',
      projecturl: ''
    };
  },
  mounted: function mounted() {},

  methods: {
    facebokUrl: function facebokUrl(url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    },
    successCopy: function successCopy() {
      var obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onErrorCopy: function onErrorCopy() {
      alert('Kan ikke kopiere');
      var obj = {
        title: 'Kan ikke kopiere',
        message: '',
        type: 'Error',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    }
  }
});

/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix notosans darkblue",attrs:{"id":"creatproject_takpage"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix highlights col-7 mx-auto mt4"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 px2 flex flex-column justify-center mb3"},[_c('p',{staticClass:"col-12 mt2 mb3 center"},[_vm._v("Dit projekt er tilføjet")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center"},[_c('p',{staticClass:"h6 small mediumgrey my2"},[_vm._v("Projekt Url:")]),_vm._v(" "),_c('a',{staticClass:"no-underline",attrs:{"target":"_blank","href":_vm.projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker')}},[_vm._v(_vm._s(_vm.projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-7 mx-auto m0 p0 flex flex-column my2"},[_c('button',{staticClass:"h6 col-12 sharefb-button flex justify-center mb2 py2",on:{"click":function($event){_vm.facebokUrl(_vm.projecturl.replace('håndværker','haandvaerker').replace('xn--hndvrker-9zan','haandvaerker'))}}},[_c('span',{staticClass:"p0 m0 pr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"7.861","height":"14.047","viewBox":"0 0 11.861 22.047"}},[_c('path',{attrs:{"id":"Icon_zocial-facebook","data-name":"Icon zocial-facebook","d":"M13.257,11.839V7.629h3.4V5.512a5.541,5.541,0,0,1,1.487-3.9A4.732,4.732,0,0,1,21.745,0h3.373V4.211H21.745a.743.743,0,0,0-.595.364,1.477,1.477,0,0,0-.265.893V7.628h4.232v4.21H20.885V22.047H16.652V11.839Z","transform":"translate(-13.257)","fill":"#fff"}})])]),_vm._v(" "),_c('p',{staticClass:"p0 m0"},[_vm._v("Del dit projekt pa Facebook")])]),_vm._v(" "),_c('button',{directives:[{name:"clipboard",rawName:"v-clipboard:copy",value:(_vm.projecturl),expression:"projecturl",arg:"copy"},{name:"clipboard",rawName:"v-clipboard:success",value:(_vm.successCopy),expression:"successCopy",arg:"success"},{name:"clipboard",rawName:"v-clipboard:error",value:(_vm.onErrorCopy),expression:"onErrorCopy",arg:"error"}],staticClass:"h6 col-12 action-button flex justify-center py2"},[_vm._v("\n                Kopier url\n              ")])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0 flex justify-between items-center my4"},[_c('p',{staticClass:"h3 bold center col-12 p0"},[_vm._v("Gennemført!")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProject_edit_vue__ = __webpack_require__(1216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bff30f6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProject_edit_vue__ = __webpack_require__(1217);
function injectStyle (ssrContext) {
  __webpack_require__(1215)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_CreateProject_edit_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9bff30f6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_CreateProject_edit_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1215 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue_clipboard2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__uploads_projectimages__ = __webpack_require__(217);














var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editproject',
  props: ['projects', 'projects_create'],
  components: {
    VueClipboard: __WEBPACK_IMPORTED_MODULE_8_vue_clipboard2___default.a,
    projectimages: __WEBPACK_IMPORTED_MODULE_9__uploads_projectimages__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_4_vue2_simplert___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_7_vue_select___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_5_vue_form_wizard___default.a,
    ErrorHandler: ErrorHandler
  },
  computed: {
    dropzoneSettings: function dropzoneSettings() {
      var defaultValues = {
        thumbnailWidth: 200,
        thumbnailHeight: 200
      };
      __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
        defaultValues[key] = this.options[key];
      }, this);
      if (this.awss3 !== null) {
        defaultValues['autoProcessQueue'] = false;
        this.isS3 = true;
        if (this.options.autoProcessQueue !== undefined) {
          this.wasQueueAutoProcess = this.options.autoProcessQueue;
        }
      }
      return defaultValues;
    }
  },
  watch: {
    'tasktype': function tasktype(newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true;
      }
    },
    'search': function search(newVal, oldVal) {
      var _this = this;

      if (newVal) {
        setTimeout(function () {
          if (_this.tasktype.indexOf(newVal) < 0) {
            _this.tasktype.push(newVal);
            _this.taskoptionsmain.splice(_this.taskoptionsmain.indexOf(newVal), 1);
            _this.taskoptions.splice(_this.taskoptions.indexOf(newVal), 1);
            _this.$message({
              type: 'success',
              message: 'Success'
            });
          }
        }, 200);
      } else {
        this.taskoptions = this.taskoptionsmain.slice(0, 30);
      }
    },
    'searchmanufacturer': function searchmanufacturer(newVal, oldVal) {
      var _this2 = this;

      if (newVal) {
        setTimeout(function () {
          if (_this2.manufacturetype.indexOf(newVal) < 0) {
            _this2.manufacturetype.push(newVal);
            _this2.manufactureoptions.splice(_this2.manufactureoptions.indexOf(newVal), 1);
            _this2.filteredmanufacturer.splice(_this2.filteredmanufacturer.indexOf(newVal), 1);
            _this2.$message({
              type: 'success',
              message: 'Success'
            });
            _this2.searchmanufacturer = '';
          }
        }, 200);
      } else {
        this.filteredmanufacturer = this.manufactureoptions.slice(0, 30);
      }
    },
    'title': function title(newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true;
      }
    },
    'description': function description(newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true;
      }
    }
  },
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: false,
        renameFile: true,
        complete: function complete(file) {
          var _this3 = this;

          setTimeout(function () {
            _this3.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class=" regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor  line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      project_id: '',
      projectType: null,
      Producenter: 0,
      title: '',
      tasktype: [],
      manufacturetype: [],
      project: [],
      description: '',
      price: '',
      url: 'fgd',
      time: '',
      postnummer: '',
      fmans: {
        name: '',
        email: '',
        mobile: ''
      },
      mans: [],
      ProducenterOptions: [],
      manufactureoptions: [],
      images: [],
      taskoptions: [],
      pimages: [],
      projectOptions: ['Badeværelse', 'Gulv', 'Koekken', 'Tag', 'Terrasse', 'Udestue', 'Vinduer', 'Andet'],
      seen: false,
      noImage: false,
      startEdit: false,
      validationType: '',
      validationTitle: '',
      validationDescription: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      salesPerson: '',
      salesPersonbitrix: '',
      success: false,
      kunde: {
        title: '',
        name: '',
        address: '',
        zip: '',
        tlf: '',
        email: ''
      },
      maintask: [],
      subtaskoptions: [],
      selectedbrancheid: '',
      search: '',
      searchmanufacturer: '',
      createprojectform: {
        title: '',
        projectcreated: '',
        time: '',
        price: '',
        postnummer: '',
        description: ''
      },
      createprojectformrule: {
        title: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst din projekttitel',
          trigger: 'blur'
        }],
        projectcreated: [{
          required: true,
          type: 'string',
          message: 'Indtast venligst dit projekts oprettelsesdato',
          trigger: 'blur'
        }],
        time: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit tid',
          trigger: 'blur'
        }],
        price: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit pris',
          trigger: 'blur'
        }],
        postnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        description: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }]
      },
      letterarr: [],
      filteredmanufacturer: [],
      taskoptionsmain: []
    };
  },
  created: function created() {
    this.Reload();

    this.project_id = this.$route.query.id;
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    onFinished: function onFinished() {
      alert('Yay. Done!');
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    facebokUrl: function facebokUrl(url) {
      window.open('https://www.facebook.com/sharer/sharer.php?u=' + url, '_blank');
    },
    successCopy: function successCopy() {
      var obj = {
        title: 'Url er nu kopieret.',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    onErrorCopy: function onErrorCopy() {
      alert('Kan ikke kopiere');
    },
    openstasksearch: function openstasksearch() {
      document.getElementById('tasksearch').classList.remove('hide');
    },
    openstasksearchmanufacturer: function openstasksearchmanufacturer() {
      document.getElementById('mansearchmanu').classList.remove('hide');
    },
    addimage: function addimage() {
      document.getElementById('myVueDropzone').click();
    },
    validateFirstStep: function validateFirstStep() {
      if (this.images.length === 0) {
        this.noImage = true;
        this.$message({
          type: 'error',
          message: 'Tilføj venligst mindst 1 billedee'
        });
        return false;
      }
      if (this.tasktype.length < 1) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en opgave'
        });
        return false;
      }
      return true;
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this4 = this;

      this.salesPersonbitrix = localStorage.getItem('token_portal_bitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.maintask = res.data;
          var itemssub = [];
          _this4.maintask.forEach(function (a) {
            a.SubIndustries.forEach(function (b) {
              if (b.taskTypes && b.taskTypes.length > 0) {
                b.taskTypes.forEach(function (c) {
                  itemssub.push(c);
                });
              }
            });
          });
          _this4.suboptions = itemssub;
          _this4.subtaskoptions = itemssub.slice(0, 30);
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    selectmaintask: function selectmaintask(arr) {
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr);
        this.suboptions.splice(this.suboptions.indexOf(arr), 1);
        this.subtaskoptions.splice(this.subtaskoptions.indexOf(arr), 1);
      }
    },
    selectmaintaskkundematch: function selectmaintaskkundematch(arr) {
      if (this.tasktype.indexOf(arr) < 0) {
        this.tasktype.push(arr);
        this.taskoptionsmain.splice(this.taskoptionsmain.indexOf(arr), 1);
        this.taskoptions.splice(this.taskoptions.indexOf(arr), 1);
      }
    },
    selectmanufacturelist: function selectmanufacturelist(manitem) {
      if (this.manufacturetype.indexOf(manitem) < 0) {
        this.manufacturetype.push(manitem);
        this.manufactureoptions.splice(this.manufactureoptions.indexOf(manitem), 1);
        this.filteredmanufacturer.splice(this.filteredmanufacturer.indexOf(manitem), 1);
      }
    },
    filtersearch: function filtersearch(type) {
      var filtertype = [];
      filtertype = this.suboptions.filter(function (z) {
        return z.name.toLowerCase().includes(type.toLowerCase());
      });
      this.subtaskoptions = filtertype;
    },
    filtersearchkundematch: function filtersearchkundematch(type) {
      var filtertype = [];
      filtertype = this.taskoptionsmain.filter(function (z) {
        return z.TaskTypeName.toLowerCase().includes(type.toLowerCase());
      });
      this.taskoptions = filtertype;
    },
    filtermanufacturersearch: function filtermanufacturersearch(text) {
      var filtertypemanu = [];
      filtertypemanu = this.manufactureoptions.filter(function (m) {
        return m.Name.toLowerCase().includes(text.toLowerCase());
      });
      this.filteredmanufacturer = filtertypemanu;
    },
    filterbyletter: function filterbyletter(letter) {
      var filtermanufacturer = [];
      filtermanufacturer = this.manufactureoptions.filter(function (n) {
        return n.Name.charAt(0).toUpperCase() === letter;
      });
      this.filteredmanufacturer = filtermanufacturer;
    },
    removeMan: function removeMan(manarr) {
      this.filteredmanufacturer.push(manarr);
      this.manufactureoptions.push(manarr);
      this.manufacturetype.splice(this.manufacturetype.indexOf(manarr), 1);
    },
    removetask: function removetask(taskarr) {
      this.suboptions.push(taskarr);
      this.subtaskoptions.push(taskarr);
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1);
    },
    removetaskkundematch: function removetaskkundematch(taskarr) {
      this.taskoptions.push(taskarr);
      this.taskoptionsmain.push(taskarr);
      this.tasktype.splice(this.tasktype.indexOf(taskarr), 1);
    },
    validateSecondStep: function validateSecondStep() {
      var error = 0;
      this.$refs['createprojectform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      return true;
    },
    onComplete: function onComplete() {
      var _this5 = this;

      this.show = true;
      var manufacturelist = [];
      for (var i = 0; i < this.manufacturetype.length; i++) {
        var c = this.manufacturetype[i];
        manufacturelist.push(c.ManufactureId);
      }
      var tasktypelist = [];
      for (var j = 0; j < this.tasktype.length; j++) {
        var z = this.tasktype[j];
        tasktypelist.push(z.TaskTypeId);
      }
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = {
        operation: 'addProjectothernew',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        title: this.createprojectform.title,
        description: this.createprojectform.description,
        images: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.images),
        tasktypelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(tasktypelist),
        manufacturelist: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(manufacturelist),
        postnummer: this.createprojectform.postnummer,
        price: this.createprojectform.price,
        time: this.createprojectform.time,
        projectid: this.project_id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this5.show = false;
        var res = response.body;
        if (res.success) {
          _this5.url = res.url;
          _this5.success = true;
          _this5.$router.push('/opret-projekt-new/tak?projecturl=' + encodeURI(res.url));
        } else {
          var obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error'
          };
          _this5.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    change_position: function change_position(imageId, projectid) {},
    delete_images: function delete_images(image) {
      var _this6 = this;

      this.$confirm('Er du sikker på, at du ikke vil slette dette billede', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var index = _this6.images.indexOf(image);
        if (index > -1) {
          _this6.images.splice(index, 1);
        }
        _this6.$message({
          type: 'success',
          message: 'Success'
        });
      }).catch(function () {});
    },
    delete_image: function delete_image(imageId, projectid) {
      var _this7 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },

    'showSuccess': function showSuccess(file) {
      console.log(file);
      this.noImage = false;
      this.images.push(file.xhr.response);
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImagesPrevProject');
    },
    Reload: function Reload() {
      var _this8 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.project_id = this.$route.query.id;
      this.show = true;
      var data = { operation: 'myProjectInfo', salesPerson: this.salesPerson, levid: this.haaId, projectid: this.project_id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this8.$router.push('/login');
        }
        _this8.show = false;
        _this8.$emit('UpdateProject', res.projects, res.projects_create);
        _this8.ProducenterOptions = res.center;
        _this8.Producenter = res.selected;
        _this8.taskoptionsmain = res.TaskType;
        _this8.taskoptions = res.TaskType.slice(0, 30);
        _this8.manufactureoptions = res.manufacture;
        _this8.filteredmanufacturer = res.manufacture.slice(0, 30);
        var letters = [];
        res.manufacture.forEach(function (a) {
          letters.push(a.Name.charAt(0).toUpperCase());
        });
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this8.letterarr = letters.filter(unique).sort();
        if (_this8.project_id !== undefined) {
          _this8.project = res.project;
          _this8.createprojectform.title = res.project.title;
          _this8.createprojectform.description = res.project.description;
          for (var i = 0; i < res.manufacture.length; i++) {
            var c = res.manufacture[i];
            if (res.project.manufacturetype.includes(c.ManufactureId)) {
              _this8.manufacturetype.push(c);
            }
          }
          for (var j = 0; j < res.TaskType.length; j++) {
            var d = res.TaskType[j];
            if (res.project.tasktype.includes(d.TaskTypeId)) {
              _this8.tasktype.push(d);
            }
          }
          var datanow = new Date();
          _this8.createprojectform.postnummer = res.project.postnummer;
          _this8.createprojectform.price = Number(res.project.price);
          _this8.createprojectform.time = res.project.time;
          _this8.createprojectform.projectcreated = datanow.getDate();
          _this8.images = res.project.images;
        }
      }, function (response) {
        _this8.show = false;
        _this8.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    delete_image_other: function delete_image_other(imageId, projectid) {
      var _this9 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'delete_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this9.show = false;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        if (res.success) {
          _this9.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    rorate_image: function rorate_image(imageId, projectid, image, primary) {
      var _this10 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'rotate_image_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        primary: primary,
        image: image,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this10.show = false;
        if (res.login === false) {
          _this10.$router.push('/login');
        }
        if (res.success) {
          _this10.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    rotate_image_direct: function rotate_image_direct(imageId, projectid, image, primary) {
      var _this11 = this;

      var imagelink = image.split('?');
      imagelink = image.includes('?') ? image.split('?')[0] : image;
      var headers = {
        'Access-Control-Allow-Origin': '*',
        'Access-Control-Allow-Methods': 'PUT, GET, POST',
        'Access-Control-Allow-Headers': 'Origin, X-Requested-With, Content-Type, Accept'
      };
      this.$http.post('https://widget.haandvaerker.dk/hvdk/rotatepicture.php?image=' + imagelink, headers, { emulateJSON: true }).then(function (response) {
        _this11.$message({
          type: 'success',
          message: response.body.message
        });
      }, function (response) {
        console.log('response', response);
        _this11.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    SaveImage: function SaveImage(imageId, projectid) {
      var _this12 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = {
        operation: 'image_position_project',
        salesPerson: this.salesPerson,
        projectid: projectid,
        levid: this.haaId,
        imageId: imageId
      };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this12.show = false;
        if (res.login === false) {
          _this12.$router.push('/login');
        }
        if (res.success) {
          _this12.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    onSubmitKundeInfo: function onSubmitKundeInfo(evt) {
      evt.preventDefault();
      alert(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
      console.log(this.kunde);
      console.log(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.kunde));
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    buyProjects: function buyProjects() {
      this.$router.push('/purchase');
    }
  }
});

/***/ }),
/* 1217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px2 notosans darkblue",attrs:{"id":"projectwizardedit"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"mt3 lg-col-11 lg-col-11 lg-col-11 xs-col-12 mx-auto p0 m0"},[_c('div',[_c('div',{staticClass:"py2 col-12 px0"},[_c('p',{staticClass:"h4"},[_vm._v("Opgavetype")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 hide",attrs:{"id":"tasksearch"}},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('i',{staticClass:"h4 el-icon-search search_icon"}),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","placeholder":"Søg"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('template',{slot:"prepend"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])])]),_vm._v(" "),_vm._l((_vm.taskoptionsmain),function(item){return _c('el-option',{key:item.TaskTypeId,attrs:{"label":item.TaskTypeName,"value":item}})})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.tasktype),function(selectedmans,index){return _c('button',{key:index,staticClass:"p1 mr1 mb1 darkblue-background center relative",attrs:{"disable-transitions":false,"id":'manbutton' + selectedmans.TaskTypeId}},[_c('p',{staticClass:"mr1 h6 mb0 p0 line-height-1 inline-block regular white px2",staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(selectedmans.TaskTypeName))]),_vm._v(" "),_c('p',{staticClass:"absolute right-0 top-0"},[_c('span',{staticClass:"white block m0 p0 line-height-1 no-hover",on:{"click":function($event){return _vm.removetaskkundematch(selectedmans)}}},[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])}),_vm._v(" "),_c('button',{staticClass:"border-0 white-background p1 flex items-center justify-center pointer",on:{"click":function($event){return _vm.openstasksearch()}}},[_c('i',{staticClass:"h4 el-icon-circle-plus-outline"})])],2)])]),_vm._v(" "),_c('div',[_c('el-form',{ref:"createprojectform",staticClass:" p0 m0 md-col-12 lg-col-12 sm-col-12 xs-col-12 mx-auto",attrs:{"id":"createprojectform","model":_vm.createprojectform,"rules":_vm.createprojectformrule,"label-position":"top"}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Titel Field","prop":"title"}},[_c('el-input',{staticClass:" white-background title_input",attrs:{"placeholder":"title","clearable":""},model:{value:(_vm.createprojectform.title),callback:function ($$v) {_vm.$set(_vm.createprojectform, "title", $$v)},expression:"createprojectform.title"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Beskrivelse","prop":"description"}},[_c('el-input',{staticClass:" white-background title_input",attrs:{"type":"textarea","rows":3,"placeholder":"Beskrivelse","clearable":""},model:{value:(_vm.createprojectform.description),callback:function ($$v) {_vm.$set(_vm.createprojectform, "description", $$v)},expression:"createprojectform.description"}})],1)],1)]),_vm._v(" "),_c('p',{staticClass:"h4 darkblue col-12 my2 line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-wrap m0 p0 py2",attrs:{"id":"projectimagesnew"}},[_c('projectimages',{attrs:{"project":_vm.project},on:{"moveImage":_vm.SaveImage,"Reload":_vm.Reload,"delete_image":_vm.delete_image,"rorate_image":_vm.rotate_image_direct}})],1)],1),_vm._v(" "),_c('div',[_c('div',{},[_c('div',{staticClass:"py2 col-12 p0"},[_c('p',{staticClass:"h4 py2"},[_vm._v("Udvalgt producent")]),_vm._v(" "),_c('div',{staticClass:"col-12 my2 hide p0",attrs:{"id":"mansearchmanu"}},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('i',{staticClass:"h4 el-icon-search search_icon"}),_vm._v(" "),_c('el-select',{attrs:{"filterable":"","placeholder":"Søg","name":"searchmanufacturer"},model:{value:(_vm.searchmanufacturer),callback:function ($$v) {_vm.searchmanufacturer=$$v},expression:"searchmanufacturer"}},[_c('template',{slot:"prepend"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])])]),_vm._v(" "),_vm._l((_vm.manufactureoptions),function(itemmman){return _c('el-option',{key:itemmman.ManufactureId,attrs:{"label":itemmman.Name,"value":itemmman}})})],2)],1)]),_vm._v(" "),_vm._l((_vm.manufacturetype),function(selectedman,index){return _c('button',{key:index,staticClass:"p1 mr1 mb1 darkblue-background center relative",attrs:{"disable-transitions":false,"id":'manbutton' + selectedman.ManufactureId}},[_c('p',{staticClass:"mr1 h6 mb0 p0 line-height-1 inline-block regular white px2",staticStyle:{"text-transform":"capitalize"}},[_vm._v(_vm._s(selectedman.Name))]),_vm._v(" "),_c('p',{staticClass:"absolute right-0 top-0"},[_c('span',{staticClass:"white block m0 p0 line-height-1 no-hover",on:{"click":function($event){return _vm.removeMan(selectedman)}}},[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])])}),_vm._v(" "),_c('button',{staticClass:"border-0 white-background p1 flex items-center justify-center pointer",on:{"click":function($event){return _vm.openstasksearchmanufacturer()}}},[_c('i',{staticClass:"h4 el-icon-circle-plus-outline"})])],2)])]),_vm._v(" "),[_c('div',{staticClass:"flex justify-end  my2 px3"},[_c('button',{staticClass:"wizard-footer-right action-button mr3 p2",on:{"click":function($event){return _vm.onComplete()}}},[_c('span',{staticClass:"h4 line-height-1 ml2 semi-bold mb0"},[_vm._v("Opdatering")]),_vm._v(" "),_vm._m(1)])])],_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('div',{staticClass:"py4 lg-hide sm-hide"})],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt2"},[_c('p',{staticClass:"h4 darkblue semi-bold mb2 line-height-golden"},[_vm._v("Rediger projekt"),_c('br'),_vm._v(" "),_c('span',{staticClass:"h5 regular col-12 p0 m0"},[_vm._v("Rediger dit valgte projekt her.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-arrow"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uploadimage_vue__ = __webpack_require__(1220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6dc071_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_uploadimage_vue__ = __webpack_require__(1221);
function injectStyle (ssrContext) {
  __webpack_require__(1219)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_uploadimage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b6dc071_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_uploadimage_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    var projectId = this.$route.query.id;
    if (projectId !== undefined) {
      this.seen = true;
    }
  },

  data: function data() {
    return {
      projects: 0,
      projects_create: 0,
      seen: true,
      miniprofile: ''
    };
  },
  methods: {
    UpdateProject: function UpdateProject(projects, projectsCreate) {
      this.projects = projects;
      this.projects_create = projectsCreate;
    }
  }
});

/***/ }),
/* 1221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[_c('div',{staticClass:"clearfix gibson px3 mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"notosans"},[_c('p',{staticClass:"h4 darkblue line-height-golden"},[_vm._v("Billeder")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular gibson mb2 line-height-3",attrs:{"show":_vm.noImage}},[_vm._v("\n            Start med at uploade billeder\n          ")]),_vm._v(" "),_c('p',{staticClass:"h6 darkblue gibson",attrs:{"v-html":_vm.images.length + ' Billede'}}),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap mb2"},[_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"py4"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProjects_vue__ = __webpack_require__(1224);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef445dc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddProjects_vue__ = __webpack_require__(1229);
function injectStyle (ssrContext) {
  __webpack_require__(1223)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-eef445dc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eef445dc_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AddProjects_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__producenter_ProducenterAddProject__ = __webpack_require__(1225);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    projectlist: __WEBPACK_IMPORTED_MODULE_2__producenter_ProducenterAddProject__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  data: function data() {
    return {
      show: false,
      label: 'Loading...',
      projects: 0,
      projects_create: 0,
      overlay: true
    };
  },

  methods: {
    buyProjects: function buyProjects() {
      this.$router.push('/koeb-projekter');
    },
    UpdateProject: function UpdateProject(projects, projectsCreate) {
      this.projects = projects;
      this.projects_create = projectsCreate;
    }
  }
});

/***/ }),
/* 1225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProducenterAddProject_vue__ = __webpack_require__(1227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f056f074_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProducenterAddProject_vue__ = __webpack_require__(1228);
function injectStyle (ssrContext) {
  __webpack_require__(1226)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-f056f074"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProducenterAddProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f056f074_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_ProducenterAddProject_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(99);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'projectlist',
  props: ['projects', 'projects_create'],
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  data: function data() {
    return {
      newproject: {
        company: '',
        name: '',
        tel: '',
        email: ''
      },
      show: false,
      label: 'Loading...',
      overlay: true,
      haaId: '',
      salesPerson: ''
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    clearForm: function clearForm() {
      alert('ggg');
    },
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'myCenterInfo', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.$emit('UpdateProject', res.projects, res.projects_create);
      }, function (response) {
        alert('error');
      });
    },
    onSubmitNewProjectInfo: function onSubmitNewProjectInfo(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.projects_create >= this.projects) {
        var obj = {
          title: 'Fejl',
          message: 'Du skal købe flere projektor',
          type: 'error'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addCenter', salesPerson: this.salesPerson, levid: this.haaId, customer: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.newproject) };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {
            this.$parent.newproject.company = '';
            this.$parent.newproject.name = '';
            this.$parent.newproject.tel = '';
            this.$parent.newproject.email = '';
            this.Reload();
          };
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn
          };
          _this2.$refs.simplert.openSimplert(_obj);
        } else {
          var _obj2 = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error'
          };
          _this2.$refs.simplert.openSimplert(_obj2);
        }
      }, function (response) {
        alert('error');
      });
    },
    resetForm: function resetForm(evt) {
      evt.preventDefault();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(this.$data, this.$options.data.call(this));
    },
    buyProjects: function buyProjects() {
      this.$router.push('/koeb-projekter');
    }
  }
});

/***/ }),
/* 1228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-container',{staticClass:"p-0"},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('b-form',{on:{"submit":_vm.onSubmitNewProjectInfo,"reset":_vm.resetForm}},[_c('fieldset',[_c('b-form-row',[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"id":"Indtast håndværkerens firma","description":"","label":"Firma","name":"Firma"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"text","required":""},model:{value:(_vm.newproject.company),callback:function ($$v) {_vm.$set(_vm.newproject, "company", $$v)},expression:"newproject.company"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"id":"","description":"Indtast håndværkerens navn","label":"Navn","name":"Navn"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"text","required":""},model:{value:(_vm.newproject.name),callback:function ($$v) {_vm.$set(_vm.newproject, "name", $$v)},expression:"newproject.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"id":"","description":"Indtast håndværkerens telefonnummer","label":"Tlf.","name":"Tel"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"tel","required":"","autocomplete":"tel"},model:{value:(_vm.newproject.tel),callback:function ($$v) {_vm.$set(_vm.newproject, "tel", $$v)},expression:"newproject.tel"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"id":"","description":"Indtast håndværkerens e-mail","label":"E-mail","name":"Email"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"email","required":"","autocomplete":"email"},model:{value:(_vm.newproject.email),callback:function ($$v) {_vm.$set(_vm.newproject, "email", $$v)},expression:"newproject.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-form-group',[_c('b-form-row',[_c('b-col',[_c('b-button',{staticClass:"rounded mr-2",attrs:{"variant":"primary","type":"submit","size":"lg"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"}})])]),_vm._v("Gem\n                        ")])],1)],1)],1)],1)],1)],1)])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"py-4"}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-circle-plus headericon"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Tilføj projekt")])])])]),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[_c('b-row',[_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"h6 open-sans line-height-golden py-2"},[_vm._v("\n              Her kan du registrere navn og kontaktoplysninger på de håndværkere, som har udført projekterne. Efter du har registreret håndværkerne, sætter vi straks gang i processen med at kontakte håndværker og bygherre mm.\n            ")]),_vm._v(" "),_c('b-btn',{staticClass:"border-0 rounded",attrs:{"variant":"success"},on:{"click":_vm.buyProjects}},[_c('i',{staticClass:"el-icon-bank-card mr-1"}),_vm._v("\n              Køb flere projekter\n            ")]),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)]),_vm._v(" "),_c('b-col',{attrs:{"lg":"6","md":"6","sm":"12"}},[_c('b-card',{staticClass:"border-0",attrs:{"no-body":""}},[_c('b-list-group',[_c('b-list-group-item',{staticClass:"border-0"},[_c('p',{staticClass:"w-50 d-inline-block float-left m-0 p-0"},[_vm._v("Du har købt")]),_vm._v(" "),_c('p',{staticClass:"w-50 d-inline-block float-right text-right m-0 p-0"},[_c('span',{staticClass:"bg-info pt-1 pb-1 pr-2 pl-2 rounded mr-1"},[_vm._v(_vm._s(_vm.projects))]),_vm._v("\n                    projekter\n                  ")])]),_vm._v(" "),_c('b-list-group-item',{staticClass:"border-0"},[_c('p',{staticClass:"w-50 d-inline-block float-left m-0 p-0"},[_vm._v("Du har aktiveret")]),_vm._v(" "),_c('p',{staticClass:"w-50 d-inline-block float-right text-right m-0 p-0"},[_c('span',{staticClass:"bg-success pt-1 pb-1 pr-2 pl-2 rounded mr-1"},[_vm._v(_vm._s(_vm.projects_create))]),_vm._v("\n                    projekter\n                  ")])])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('b-container',[_c('b-row',[_c('b-col',[_c('projectlist',{attrs:{"projects":_vm.projects,"projects_create":_vm.projects_create},on:{"UpdateProject":_vm.UpdateProject}})],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Website_vue__ = __webpack_require__(1231);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098d80f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Website_vue__ = __webpack_require__(1249);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Website_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_098d80f2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Website_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__WebsiteControls__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__noneligibleFeaturepop__ = __webpack_require__(43);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'website',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_1__haandvaerker__["a" /* default */],
    websitecontrols: __WEBPACK_IMPORTED_MODULE_0__WebsiteControls__["a" /* default */],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_2__noneligibleFeaturepop__["a" /* default */]
  },
  data: function data() {
    return {
      haaid: '',
      basic: false,
      isLoadingMail: false,
      url: '',
      eligible: ''
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('ExternalProWebsite');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.haaid = localStorage.getItem('haaid');
    if (localStorage.getItem('basic') === '1') {
      this.basic = true;
    }
  },
  mounted: function mounted() {
    this.getdataigibility('/newsfeed');
  },

  methods: {
    getdataigibility: function getdataigibility(link) {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, link, 'ExternalProWebsite');
      }
    },
    UpdateUrl: function UpdateUrl(url) {
      this.url = url;
    },
    handleSubmitMail: function handleSubmitMail() {
      var _this = this;

      this.isLoadingMail = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'basicemail_partner_profile', salesPerson: this.salesPerson, textReason: 'Din Hjemmside' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          var obj = {
            title: 'Vi kontakter dig snarest muligt!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
          _this.isLoadingMail = false;
          _this.textReason = '';
        } else {
          alert(res.message);
          _this.isLoadingMail = false;
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteControls_vue__ = __webpack_require__(1234);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee0d6c8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteControls_vue__ = __webpack_require__(1248);
function injectStyle (ssrContext) {
  __webpack_require__(1233)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_WebsiteControls_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0ee0d6c8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_WebsiteControls_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1233 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__websitecontents__ = __webpack_require__(1235);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__webemailcontents__ = __webpack_require__(1239);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__websitesort__ = __webpack_require__(1244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__ = __webpack_require__(371);









/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'websitecontrols',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    websitecontents: __WEBPACK_IMPORTED_MODULE_3__websitecontents__["a" /* default */],
    webemailcontents: __WEBPACK_IMPORTED_MODULE_4__webemailcontents__["a" /* default */],
    websitesort: __WEBPACK_IMPORTED_MODULE_5__websitesort__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    'b-tab': __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["a" /* BTab */],
    'b-tabs': __WEBPACK_IMPORTED_MODULE_6_bootstrap_vue__["b" /* BTabs */]
  },
  data: function data() {
    return {
      showMobile: false,
      siteSettings: {
        Title: '',
        Description: '',
        Keywords: '',
        facebook: '',
        twitter: ''
      },
      domainSettings: {
        domain: '',
        services: [],
        dkuser: '',
        dkpassword: '',
        email1: '',
        email2: ''
      },
      showDomain: false,
      filteredPosts: [],
      filteredPostsEmail: [],
      filteredSorts: [],
      titles: [],
      vtemplate: 'theme1',
      templates: [],
      image: '',
      emaildomain: '',
      numemail: '',
      numemailused: '',
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      selected: [],
      options: [{ text: 'DNS', value: 'DNS' }, { text: 'Mailadresse', value: 'Mailadresse' }]
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },

  methods: {
    onUpdateSettings: function onUpdateSettings(evt) {
      var _this = this;

      evt.preventDefault();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'saveWebsiteSetting', salesPerson: this.salesPerson, levid: this.haaId, siteSettings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.siteSettings), image: this.image };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {};
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
        } else {
          var _obj = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(_obj);
        }
      }, function (response) {
        alert('error');
      });
    },
    Updatetemplate: function Updatetemplate(templateId) {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'Updatetemplate', salesPerson: this.salesPerson, levid: this.haaId, templateId: templateId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {};
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          };
          _this2.vtemplate = templateId;
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          var _obj2 = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj2);
        }
      }, function (response) {
        alert('error');
      });
    },
    onUpdateDomain: function onUpdateDomain(evt) {
      var _this3 = this;

      evt.preventDefault();
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'saveWebsiteDomain', salesPerson: this.salesPerson, levid: this.haaId, domainSettings: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.domainSettings) };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this3.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {};
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          };
          _this3.showDomain = true;
          _this3.$refs.simplert.openSimplert(obj);
        } else {
          var _obj3 = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(_obj3);
        }
      }, function (response) {
        alert('error');
      });
    },
    Reload: function Reload() {
      var _this4 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'WebsiteSetting', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.settings) {
          _this4.siteSettings = res.settings;
        }
        if (res.domain) {
          _this4.domainSettings = res.domain;
          _this4.showDomain = true;
        }
        _this4.filteredPosts = res.pages;
        _this4.filteredPostsEmail = res.emails;
        _this4.emaildomain = res.emaildomain;
        _this4.numemail = res.numemail;
        _this4.numemailused = res.numemailused;
        _this4.filteredSorts = res.sort;
        _this4.titles = res.title;
        _this4.image = res.image;
        _this4.templates = res.templates;
        _this4.vtemplate = res.vtemplate;
        _this4.$emit('UpdateUrl', res.url);
      }, function (response) {
        alert('error');
      });
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage: function removeImage(e) {
      this.image = '';
    },
    onResetSettings: function onResetSettings(evt) {
      evt.preventDefault();

      this.show = false;
    }
  }
});

/***/ }),
/* 1235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websitecontents_vue__ = __webpack_require__(1237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb2fd2c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_websitecontents_vue__ = __webpack_require__(1238);
function injectStyle (ssrContext) {
  __webpack_require__(1236)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websitecontents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cb2fd2c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_websitecontents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1236 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'websitecontents',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  props: ['filteredPosts'],
  data: function data() {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Vent venligst...',
      picked: '',
      overlay: true,
      isLoadingReview: false,
      Cpage: '',
      Page: {
        id: '',
        title: '',
        note: '',
        active: true,
        image: '',
        page: ''
      },
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    };
  },

  methods: {
    postDate: function postDate(epoch) {
      if (!epoch) return;
      return this.moment(epoch).format('MM/DD/YY | hh:mm');
    },
    pageType: function pageType(type) {
      if (type === '1') {
        return 'Om os';
      } else if (type === '2') {
        return 'Tjenester';
      } else if (type === '3') {
        return 'Projekt';
      } else if (type === '4') {
        return 'Kontakt';
      }
    },
    editPage: function editPage(page) {
      this.Cpage = page;
      this.showCollapse = true;
      this.Page = this.Cpage;
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    },
    sletPage: function sletPage(item) {
      var confirmFn = function confirmFn() {
        this.$parent.sletPage_remove(item);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne side?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    emptyPage: function emptyPage() {
      this.Page.id = '';
      this.Page.title = '';
      this.Page.note = '';
      this.Page.active = true;
      this.Page.image = '';
      this.Page.page = '';
    },
    addNew: function addNew() {
      this.emptyPage();
      this.showCollapse = true;
      this.$emit('Reload');
    },
    sletPage_remove: function sletPage_remove(item) {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_del', salesPerson: this.salesPerson, levid: this.haaId, item: item.id };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
          _this.emptyPage();
          _this.$emit('Reload');
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    website_page: function website_page() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_page', salesPerson: this.salesPerson, levid: this.haaId, Page: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.Page) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.emptyPage();
          _this2.$emit('Reload');
          _this2.showCollapse = false;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        vm.Page.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage: function removeImage(e) {
      this.Page.image = '';
    }
  }
});

/***/ }),
/* 1238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"mt2 mb4"},[_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"p2 outlined-action-button flex justify-center items-center gibson h5 not-rounded",attrs:{"id":"pageForm"},on:{"click":function($event){return _vm.addNew()}}},[_c('span',[_vm._v("Tilføj ny side")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('b-collapse',{staticClass:"my4",attrs:{"id":"collapse1"},model:{value:(_vm.showCollapse),callback:function ($$v) {_vm.showCollapse=$$v},expression:"showCollapse"}},[_c('form',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6",attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.website_page.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label-for":""}},[_c('p',{staticClass:"h6 darkblue semi-bold"},[_vm._v("Titel")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded border-none p2 lightgrey-background gibson darkblue h5",attrs:{"id":"title","required":""},model:{value:(_vm.Page.title),callback:function ($$v) {_vm.$set(_vm.Page, "title", $$v)},expression:"Page.title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1 flex justify-start items-center",attrs:{"label-for":""}},[_c('p',{staticClass:"h6 darkblue semi-bold"},[_vm._v("Status")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center p2 lightgrey-background"},[_c('span',{staticClass:"mr1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.Page.active),expression:"Page.active"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.Page.active)?_vm._i(_vm.Page.active,null)>-1:(_vm.Page.active)},on:{"change":function($event){var $$a=_vm.Page.active,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.Page, "active", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.Page, "active", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.Page, "active", $$c)}}}})]),_vm._v(" "),[(_vm.Page.active)?_c('span',[_vm._v("Aktiv")]):_c('span',[_vm._v("Ikke aktiv")])]],2)])],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 darkblue semi-bold"},[_vm._v("Notat")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Skriv til support","required":""},model:{value:(_vm.Page.note),callback:function ($$v) {_vm.$set(_vm.Page, "note", $$v)},expression:"Page.note"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1"},[_c('p',{staticClass:"h6 darkblue semi-bold"},[_vm._v("Siden som")]),_vm._v(" "),_c('div',{staticClass:"lightgrey-background p2"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.Page.page),expression:"Page.page"}],staticClass:"not-rounded border-none lightgrey-background gibson darkblue line-height-1 h6 m0 p0 regular col-12",attrs:{"id":"method"},domProps:{"value":_vm.Page.page},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.Page, "page", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":""}}),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Om os")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Tjenester")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Projekt")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Kontakt")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[(!_vm.Page.image)?_c('div',[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1"},[_c('p',{staticClass:"h6 darkblue semi-bold"},[_vm._v("Billede")]),_vm._v(" "),_c('b-form-file',{staticClass:"flex justify-between p2 py3 items-center lightgrey-background",attrs:{"no-drop":"","placeholder":"Vælg fil"},on:{"change":_vm.onFileChange}})],1)],1):_c('div',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('img',{staticClass:"fit block",attrs:{"src":_vm.Page.image}}),_vm._v(" "),_c('b-btn',{staticClass:"rounded",attrs:{"variant":"danger","size":"sm"},on:{"click":_vm.removeImage}},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm9 12c0 1.94-.624 3.735-1.672 5.207l-12.535-12.535c1.472-1.048 3.267-1.672 5.207-1.672 4.962 0 9 4.038 9 9zm-18 0c0-1.94.624-3.735 1.672-5.207l12.534 12.534c-1.471 1.049-3.266 1.673-5.206 1.673-4.962 0-9-4.038-9-9z"}})])])],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5",attrs:{"type":"button"}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),(!_vm.Page.id)?_c('button',{staticClass:"not-rounded action-button p2 flex justify-center items-center gibson h5 regular",attrs:{"type":"submit","variant":"success","size":"lg","disabled":_vm.isLoadingReview}},[_c('span',[_vm._v("\n              Offentliggør\n            ")]),_vm._v(" "),_c('span',{staticClass:"pl2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.Page.id)?_c('button',{staticClass:"not-rounded outlined-action-button p2 flex justify-center items-center gibson h5",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('i',{staticClass:"el-icon-success mr-2"}),_vm._v("Opdater '"+_vm._s(_vm.Page.title)+"'\n          ")]):_vm._e()])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('table',{staticClass:"table is-fullwidth is-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredPosts),function(post,index){return _c('tr',{key:index},[_c('td',{staticClass:"post-title-cell"},[_c('span',{staticClass:"darkblue gibson h6 regular line-height-1 m0 p0"},[_vm._v(_vm._s(post.title))])]),_vm._v(" "),_c('td',{staticClass:"post-category-cell"},[_c('span',{staticClass:"darkblue gibson h6 regular line-height-1 m0 p0"},[_vm._v(_vm._s(_vm.pageType(post.page)))])]),_vm._v(" "),[(post.active == true)?_c('td',{staticClass:"post-author-cell"},[_c('span',{staticClass:"green gibson h6 line-height-1 m0 p0"},[_vm._v("Aktiv")])]):_c('td',[_c('span',{staticClass:"red gibson h6 line-height-1 m0 p0"},[_vm._v("Ikke aktiv")])])],_vm._v(" "),_c('td',{staticClass:"post-author-cell"},[_c('b-button',{staticClass:"not-rounded border-none",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.editPage(post)}}},[_c('span',{staticClass:"far fa-edit"})]),_vm._v(" "),_c('b-button',{staticClass:"not-rounded border-none",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.sletPage(post)}}},[_c('span',{staticClass:"far fa-trash-alt"})])],1)],2)}),0)])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Titel")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Siden som")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 darkblue gibson line-height-1"},[_vm._v("Status")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 darkblue gibson line-height-1"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1239 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webemailcontents_vue__ = __webpack_require__(1242);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15426e0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_webemailcontents_vue__ = __webpack_require__(1243);
function injectStyle (ssrContext) {
  __webpack_require__(1240)
  __webpack_require__(1241)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_webemailcontents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15426e0a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_webemailcontents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1240 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1241 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1242 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_password___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_password__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zxcvbn__ = __webpack_require__(600);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_zxcvbn__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'webemailcontents',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    passwordStrength: __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default.a,
    VuePassword: __WEBPACK_IMPORTED_MODULE_3_vue_password___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  props: ['filteredPosts', 'emaildomain', 'numemail', 'numemailused'],
  data: function data() {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      modalShowReset: false,
      isLoadingReview: false,
      Cpage: '',
      Email: {
        email: '',
        recovery_email: '',
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      Reset: {
        username: '',
        recovery_code: '',
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      strengthMessages: ['Meget svagt', 'Svagt', 'Medium', 'Stærkt', 'Meget stærkt'],
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    };
  },

  methods: {
    postDate: function postDate(epoch) {
      if (!epoch) return;
      return this.moment(epoch).format('MM/DD/YY | hh:mm');
    },
    pageType: function pageType(type) {
      if (type === '1') {
        return 'Om os';
      } else if (type === '2') {
        return 'Tjenester';
      } else if (type === '3') {
        return 'Projekt';
      } else if (type === '4') {
        return 'Kontakt';
      }
    },

    password_check: function password_check() {
      this.has_number = /\d/.test(this.form.password);
      this.has_lowercase = /[a-z]/.test(this.form.password);
      this.has_uppercase = /[A-Z]/.test(this.form.password);
      this.has_special = /[!@#\\$%\\^\\&*\\)\\(+=._-]/.test(this.form.password);
    },
    changeEmail: function changeEmail(item) {
      this.Reset.username = item.username;
      this.modalShowReset = true;
    },
    editPage: function editPage(page) {
      this.Cpage = page;
      this.showCollapse = true;
      this.Page = this.Cpage;
      $('html, body').animate({
        scrollTop: 0
      }, 600);
    },
    sletPage: function sletPage(item) {
      var confirmFn = function confirmFn() {
        this.$parent.sletPage_remove(item);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne side?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    emptyPage: function emptyPage() {},
    addNew: function addNew() {
      this.emptyPage();
      this.showCollapse = true;
      this.$emit('Reload');
    },
    resetEmail: function resetEmail(item) {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'reset_email', salesPerson: this.salesPerson, levid: this.haaId, username: item.username };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;
          var obj = {
            title: 'En nulstilling af adgangskode sendt til din gendannelses-e-mail!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          item.resetdone = true;
          _this.$refs.simplert.openSimplert(obj);
          _this.emptyPage();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    sletPage_remove: function sletPage_remove(item) {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_del', salesPerson: this.salesPerson, levid: this.haaId, item: item.id };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
          _this2.emptyPage();
          _this2.$emit('Reload');
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    website_email_reset: function website_email_reset() {
      var _this3 = this;

      this.Reset.errorMessage = '';
      if (this.Reset.password !== this.Reset.newpassword) {
        this.Reset.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.';
        return;
      }
      this.score = __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default()(this.Reset.password).score;
      if (this.score < 3) {
        this.Reset.errorMessage = 'Dit password er ikke stærkt nok.';
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_email_reset', salesPerson: this.salesPerson, levid: this.haaId, Reset: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.Reset) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.modalShowReset = false;
          _this3.Reset.password = '';
          _this3.Reset.recovery_code = '';
          _this3.Reset.newpassword = '';
          _this3.$refs.simplert.openSimplert(obj);
          _this3.emptyPage();
          _this3.$emit('Reload');
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    website_email: function website_email() {
      var _this4 = this;

      if (this.numemailused >= this.numemail) {
        var obj = {
          title: 'Fejl',
          message: 'Du skal købe flere e-mail',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.Email.errorMessage = '';
      if (this.Email.password !== this.Email.newpassword) {
        this.Email.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.';
        return;
      }
      this.score = __WEBPACK_IMPORTED_MODULE_4_zxcvbn___default()(this.Email.password).score;
      if (this.score < 3) {
        this.Email.errorMessage = 'Dit password er ikke stærkt nok.';
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_email', salesPerson: this.salesPerson, levid: this.haaId, Email: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.Email) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(_obj);
          _this4.emptyPage();
          _this4.$emit('Reload');
          _this4.showCollapse = false;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        vm.Page.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage: function removeImage(e) {
      this.Page.image = '';
    }
  }
});

/***/ }),
/* 1243 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"mt2 mb4"},[_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"float-left p2 outlined-action-button flex justify-center items-center gibson h5 not-rounded",attrs:{"id":"pageForm"},on:{"click":function($event){return _vm.addNew()}}},[_c('span',[_vm._v("Tilføj ny e-mail")]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"px2 float-right",staticStyle:{"padding-right":"160px"}},[_c('p',{staticClass:"darkblue-background white h6 regular center line-height-golden mb0 gibson p2"},[_vm._v("\n        Antal E-mail: "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.numemailused))]),_vm._v(" ud af "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.numemail))])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-collapse',{staticClass:"my4",attrs:{"id":"collapse1"},model:{value:(_vm.showCollapse),callback:function ($$v) {_vm.showCollapse=$$v},expression:"showCollapse"}},[_c('form',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6",attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.website_email.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"E-mail","label-for":""}},[_c('b-form-input',{staticClass:"not-rounded border-none p2 muted-background gibson darkblue",attrs:{"id":"title","required":""},model:{value:(_vm.Email.email),callback:function ($$v) {_vm.$set(_vm.Email, "email", $$v)},expression:"Email.email"}}),_vm._v(" "),_c('b-form-text',{attrs:{"id":"input-live-help"}},[_vm._v("Eksempel: info@"+_vm._s(_vm.emaildomain))])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Kodeord","label-for":""}},[_c('vue-password',{attrs:{"strengthMessages":_vm.strengthMessages,"required":"","classes":"not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center","placeholder":"Kodeord","autocomplete":"current-password","score":_vm.score},on:{"input":_vm.password_check},model:{value:(_vm.Email.password),callback:function ($$v) {_vm.$set(_vm.Email, "password", $$v)},expression:"Email.password"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Gentag kodeord","label-for":""}},[_c('b-form-input',{staticClass:"not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center",attrs:{"type":"password","placeholder":"Gentag kodeord","required":"","autocomplete":"current-password"},model:{value:(_vm.Email.newpassword),callback:function ($$v) {_vm.$set(_vm.Email, "newpassword", $$v)},expression:"Email.newpassword"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.Email.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.Email.errorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.Email.password.length > 8}},[_c('i',{staticClass:"mr1",class:_vm.Email.password.length > 8 ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Længere end 8 karakterer")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_uppercase }},[_c('i',{staticClass:"mr1",class:_vm.has_uppercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et stort bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_lowercase }},[_c('i',{staticClass:"mr1",class:_vm.has_lowercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et lille bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_number }},[_c('i',{staticClass:"mr1",class:_vm.has_number ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et tal")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_special }},[_c('i',{staticClass:"mr1",class:_vm.has_special ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et specialkarakter")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix py2 mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Gendannelses e-mail","label-for":""}},[_c('b-form-input',{staticClass:"not-rounded border-none p2 muted-background gibson darkblue",attrs:{"id":"title","required":""},model:{value:(_vm.Email.recovery_email),callback:function ($$v) {_vm.$set(_vm.Email, "recovery_email", $$v)},expression:"Email.recovery_email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5",attrs:{"type":"button"}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"not-rounded action-button p2 flex justify-center items-center gibson h5 regular",attrs:{"type":"submit","variant":"success","size":"lg","disabled":_vm.isLoadingReview}},[_c('span',[_vm._v("\n              Gem\n            ")]),_vm._v(" "),_c('span',{staticClass:"pl2"},[_c('i',{staticClass:"el-icon-right"})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('table',{staticClass:"table is-fullwidth is-striped"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.filteredPosts),function(post,index){return _c('tr',{key:index},[_c('td',{staticClass:"post-title-cell"},[_vm._v(_vm._s(post.username))]),_vm._v(" "),_c('td',{staticClass:"post-category-cell"},[_vm._v("5000 mb.")]),_vm._v(" "),_c('td',{staticClass:"post-author-cell"},[_vm._v(_vm._s(post.storagequota_used)+" mb.")]),_vm._v(" "),_c('td',{staticClass:"post-author-cell"},[_vm._v(_vm._s(post.recovery_email))]),_vm._v(" "),_c('td',{staticClass:"post-author-cell"},[_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.resetEmail(post)}}},[_c('span',{staticClass:"far fa-edit"}),_vm._v(" Gendan adgangskode\n            ")]),_vm._v(" "),(post.resetdone)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-info"},on:{"click":function($event){return _vm.changeEmail(post)}}},[_c('span',{staticClass:"far fa-edit"}),_vm._v(" Skifte adgangskode\n            ")]):_vm._e()],1)])}),0)])]),_vm._v(" "),_c('b-modal',{ref:"modal",staticClass:"px2 pb4",attrs:{"hide-footer":"","size":"lg","title":"Skifte adgangskode"},model:{value:(_vm.modalShowReset),callback:function ($$v) {_vm.modalShowReset=$$v},expression:"modalShowReset"}},[_c('form',{staticClass:"xs-col-12 sm-col-12 md-col-12 lg-col-12",attrs:{"id":"formSubmit2"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.website_email_reset.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mb2"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Gendannelseskode","label-for":""}},[_c('b-form-input',{staticClass:"not-rounded border-none p2 muted-background gibson darkblue",attrs:{"id":"title","required":""},model:{value:(_vm.Reset.recovery_code),callback:function ($$v) {_vm.$set(_vm.Reset, "recovery_code", $$v)},expression:"Reset.recovery_code"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Kodeord","label-for":""}},[_c('vue-password',{attrs:{"strengthMessages":_vm.strengthMessages,"required":"","classes":"not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center","placeholder":"Kodeord","autocomplete":"current-password","score":_vm.score},on:{"input":_vm.password_check},model:{value:(_vm.Reset.password),callback:function ($$v) {_vm.$set(_vm.Reset, "password", $$v)},expression:"Reset.password"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('b-form-group',{staticClass:"h6 darkblue gibson line-height-1 mb1",attrs:{"label":"Gentag kodeord","label-for":""}},[_c('b-form-input',{staticClass:"not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center",attrs:{"type":"password","placeholder":"Gentag kodeord","required":"","autocomplete":"current-password"},model:{value:(_vm.Reset.newpassword),callback:function ($$v) {_vm.$set(_vm.Reset, "newpassword", $$v)},expression:"Reset.newpassword"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.Reset.errorMessage)?_c('div',{staticClass:"alert alert-danger"},[_vm._v(_vm._s(_vm.Reset.errorMessage))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.Reset.password.length > 8}},[_c('i',{staticClass:"mr1",class:_vm.Reset.password.length > 8 ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Længere end 8 karakterer")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_uppercase }},[_c('i',{staticClass:"mr1",class:_vm.has_uppercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et stort bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' :_vm.has_lowercase }},[_c('i',{staticClass:"mr1",class:_vm.has_lowercase ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et lille bogstav")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_number }},[_c('i',{staticClass:"mr1",class:_vm.has_number ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et tal")]),_vm._v(" "),_c('p',{staticClass:"frmValidation",class:{'frmValidation--passed' : _vm.has_special }},[_c('i',{staticClass:"mr1",class:_vm.has_special ? 'el-icon-check' : 'el-icon-close'}),_vm._v(" Indeholder et specialkarakter")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('button',{staticClass:"not-rounded outlined-disabled-button p2 flex justify-center items-center gibson h5",attrs:{"type":"button"},on:{"click":function($event){_vm.modalShowReset=false}}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"not-rounded action-button p2 flex justify-center items-center gibson h5 regular",attrs:{"type":"submit","variant":"success","size":"lg","disabled":_vm.isLoadingReview}},[_c('span',[_vm._v("\n                Gem\n              ")]),_vm._v(" "),_c('span',{staticClass:"pl2"},[_c('i',{staticClass:"el-icon-right"})])])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("E-mail")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("Storage")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("Used")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("Gendannelses e-mail")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("Aktion")])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1244 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websitesort_vue__ = __webpack_require__(1246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58be02b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_websitesort_vue__ = __webpack_require__(1247);
function injectStyle (ssrContext) {
  __webpack_require__(1245)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_websitesort_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_58be02b0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_websitesort_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1245 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1246 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'websitesort',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  props: ['filteredPosts', 'filteredSorts', 'titles'],
  data: function data() {
    return {
      showModal: false,
      showCollapse: false,
      show: false,
      label: 'Loading...',
      picked: '',
      overlay: true,
      isLoadingReview: false,
      Cpage: '',
      Page: {
        id: '',
        title: '',
        note: '',
        active: true,
        image: '',
        page: ''
      },
      header: '',
      kind: '',
      post: '',
      sortKey: 'tittle'
    };
  },
  created: function created() {
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      setTimeout(function () {
        $('#nestable_list_1').nestable({
          maxDepth: 2
        });
      }, 3500);
    },
    CheckSort: function CheckSort(id) {
      for (var item in this.filteredSorts) {
        if (this.filteredSorts[item].level === id) return true;
      }
      return false;
    },
    updateOutput: function updateOutput(e) {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'website_sort', salesPerson: this.salesPerson, levid: this.haaId, sort: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()($('#nestable_list_1').nestable('serialize')) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
          _this.showCollapse = false;
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1247 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h5 mt2 gibson darkblue line-height-golden regular"},[_vm._v("\n      Her kan du ændre på rækkefølgen af siderne i menuen på din hjemmeside\n    ")]),_vm._v(" "),[(!_vm.showXXL)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"panel xs-col-12 sm-col-12 md-col-6 lg-col-4"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"dd",attrs:{"id":"nestable_list_1"}},[_c('ol',{staticClass:"dd-list"},_vm._l((_vm.filteredSorts),function(item){return _c('li',{key:item.id,staticClass:"dd-item"},[(item.level === 0)?_c('div',{staticClass:"dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor",staticStyle:{"height":"auto"},attrs:{"data-id":item.id}},[_c('span',{staticClass:"h6 gibson regular primarycolor"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_c('span',[_c('svg',{staticClass:"jam jam-menu",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M1 0h5a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm7 8h5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zM1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z"}})])])]):_vm._e(),_vm._v(" "),(_vm.CheckSort(item.id))?_c('ol',{staticClass:"dd-list"},_vm._l((_vm.filteredSorts),function(subitem){return _c('li',{key:subitem.id,staticClass:"dd-item"},[(subitem.level === item.id)?_c('div',{staticClass:"dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor",staticStyle:{"height":"auto"},attrs:{"data-id":subitem.id}},[_c('span',{staticClass:"h5 gibson regular primarycolor"},[_vm._v("\n                          "+_vm._s(subitem.label)+"\n                        ")]),_vm._v(" "),_c('span',[_c('svg',{staticClass:"jam jam-menu",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M1 0h5a1 1 0 1 1 0 2H1a1 1 0 1 1 0-2zm7 8h5a1 1 0 0 1 0 2H8a1 1 0 1 1 0-2zM1 4h12a1 1 0 0 1 0 2H1a1 1 0 1 1 0-2z"}})])])]):_vm._e()])}),0):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 not-rounded p2 border-none action-button gibson h4 regular flex justify-center items-center",on:{"click":function($event){return _vm.updateOutput()}}},[_c('span',[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_vm._v("Opdater")])])])])]):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"panel col-5"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"dd",attrs:{"id":"nestable_list_1"}},[_c('ol',{staticClass:"dd-list"},_vm._l((_vm.filteredSorts),function(item){return _c('li',{key:item.id,staticClass:"dd-item"},[(item.level === 0)?_c('div',{staticClass:"dd-handle col-12 px2 py1 not-rounded border-none flex justify-between items-center darkblue",staticStyle:{"height":"auto"},attrs:{"data-id":item.id}},[_c('span',{staticClass:"h6 gibson regular line-height-1 m0 p0"},[_vm._v(_vm._s(item.label))]),_vm._v(" "),_vm._m(0,true)]):_vm._e(),_vm._v(" "),(_vm.CheckSort(item.id))?_c('ol',{staticClass:"dd-list"},_vm._l((_vm.filteredSorts),function(subitem){return _c('li',{key:subitem.id,staticClass:"dd-item"},[(subitem.level === item.id)?_c('div',{staticClass:"dd-handle col-12 p2 not-rounded border-none flex justify-between items-center primarycolor",staticStyle:{"height":"auto"},attrs:{"data-id":subitem.id}},[_c('span',{staticClass:"h6 gibson regular line-height-1 m0 p0"},[_vm._v("\n                          "+_vm._s(subitem.label)+"\n                        ")]),_vm._v(" "),_vm._m(1,true)]):_vm._e()])}),0):_vm._e()])}),0)])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"not-rounded p2 border-none action-button gibson h5 regular flex justify-center items-center",on:{"click":function($event){return _vm.updateOutput()}}},[_c('span',[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_vm._v("Opdater")])])])])]):_vm._e()]],2),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-rank"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-rank"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1248 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_vm._m(0),_vm._v(" "),[(_vm.showMobile)?_c('div',[_c('b-tabs',{attrs:{"pills":"","vertical":""}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/sitemap.svg","width":"28","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("Sider")])]},proxy:true}],null,false,1142813757)},[_vm._v(" "),_c('websitecontents',{attrs:{"filteredPosts":_vm.filteredPosts},on:{"Reload":_vm.Reload}})],1),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/list.svg","width":"28b-tab","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("Sidernes rækkefølge")])]},proxy:true}],null,false,2656623305)},[_vm._v(" "),_c('websitesort',{attrs:{"filteredPosts":_vm.filteredPosts,"titles":_vm.titles,"filteredSorts":_vm.filteredSorts},on:{"Reload":_vm.Reload}})],1),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/layout.svg","width":"28","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("Temaer")])]},proxy:true}],null,false,2630929971)},[_vm._v(" "),_vm._l((_vm.templates),function(template){return _c('div',{key:template.id,staticClass:"clearfix relative highlights mb4"},[_c('div',{staticClass:"col-12 px0 relative"},[_c('div',{staticClass:"relative"},[_c('img',{staticClass:"fit",attrs:{"src":template.img,"alt":template.id}})]),_vm._v(" "),_c('div',{staticClass:"absolute right-0 bottom-0 left-0",staticStyle:{"bottom":"-20px"}},[_c('div',{staticClass:"col-6 mx-auto highlights flex flex-column p1 white-background"},[_c('span',{staticClass:"block mb2 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue gibson line-height-1 m0 p0 capitalize",staticStyle:{"font-size":"90%"}},[_vm._v("\n                      "+_vm._s(template.id)+"\n                    ")]),_vm._v(" "),[(template.id === 'theme1')?_c('span',{staticClass:"darkblue gibson block flex justify-start items-center"},[_c('span',{staticClass:"green"},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"h6 regular m0 p0",staticStyle:{"font-size":"90%"}},[_vm._v("Menu")])]):_c('span',{staticClass:"lightgrey gibson block flex justify-start items-center"},[_c('span',[_c('i',{staticClass:"el-icon-remove"})]),_vm._v(" "),_c('span',{staticClass:"h6 regular gibson m0 p0 line-height-1",staticStyle:{"font-size":"90%"}},[_vm._v("Menu")])])]],2),_vm._v(" "),(template.id !== _vm.vtemplate)?_c('button',{staticClass:"action-button gibson line-height-1 flex justify-center items-center h6 regular py1 px2 flex-none mx-auto",attrs:{"type":"button"},on:{"click":function($event){return _vm.Updatetemplate(template.id)}}},[_c('span',{staticStyle:{"font-size":"90%"}},[_vm._v("Vælg")])]):_vm._e(),_vm._v(" "),(template.id === _vm.vtemplate)?_c('div',{staticClass:"center mx-auto py1 px2 border green-border mb1"},[_c('p',{staticClass:"h6 gibson green line-height-1 m0 p0",staticStyle:{"font-size":"90%"}},[_vm._v("Valgte")])]):_vm._e()])])])])}),_vm._v(" "),_c('div',{staticClass:"py4"})],2),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/settings.svg","width":"28","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("Indstillinger")])]},proxy:true}],null,false,3241739484)},[_vm._v(" "),_c('div',{staticClass:"px1"},[_c('form',{on:{"submit":_vm.onUpdateSettings,"reset":_vm.onResetSettings}},[_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{staticClass:"gibson h5 regular mb1 darkblue",attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteTitle"}},[_vm._v("Navn på hjemmeside")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle"},model:{value:(_vm.siteSettings.Title),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Title", $$v)},expression:"siteSettings.Title"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Her skriver du navnet på din hjemmeside fx hansensvvs.dk\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings3"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteKeywords"}},[_vm._v("Søgeord")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteKeywords"},model:{value:(_vm.siteSettings.Keywords),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Keywords", $$v)},expression:"siteSettings.Keywords"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Her skriver du de søgeord, som du ønsker at din hjemmeside skal blive fundet på, det kan fx være dit firmanavn, produktnavne eller lignende\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"Facebook"}},[_vm._v("\n                    Link til virksomhedens Facebookside\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"Facebook"},model:{value:(_vm.siteSettings.facebook),callback:function ($$v) {_vm.$set(_vm.siteSettings, "facebook", $$v)},expression:"siteSettings.facebook"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings3","label":""}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"Instagram"}},[_vm._v("\n                    Link til virksomhedens Instagramside\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"Twitter"},model:{value:(_vm.siteSettings.twitter),callback:function ($$v) {_vm.$set(_vm.siteSettings, "twitter", $$v)},expression:"siteSettings.twitter"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings2"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteDescription"}},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('b-form-textarea',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteDescription","rows":8,"max-rows":6},model:{value:(_vm.siteSettings.Description),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Description", $$v)},expression:"siteSettings.Description"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Som standard vil beskrivelsen på din hjemmeside, være din profiltekst fra Håndværker.dk, ønsker du at lave en anden beskrivelse, kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[[(!_vm.image)?_c('div',[_c('div',{staticClass:"font-weight-bold p-1"},[_vm._v("Logo")]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}})]):_c('div',[_c('p',{staticClass:"h5 semi-bold gibson mb2 darkblue"},[_vm._v("\n                      Logo\n                    ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-start"},[_c('div',{staticStyle:{"width":"100px","height":"100px"}},[_c('img',{staticClass:"fit block",attrs:{"src":_vm.image}})]),_vm._v(" "),_c('button',{staticClass:"not-rounded p1 delete-button",on:{"click":_vm.removeImage}},[_c('span',[_c('svg',{staticClass:"jam jam-trash",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z"}})])])])])])]],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('button',{staticClass:"not-rounded action-button gibson h4 regular col-12 flex justify-center items-center p2",attrs:{"type":"submit"}},[_c('span',[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_vm._v("Opdater")])])])])])]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/protection.svg","width":"28","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("Tilladelser")])]},proxy:true}],null,false,3621145973)},[_vm._v(" "),_c('div',{staticClass:"px1 py3"},[_c('form',{on:{"submit":_vm.onUpdateDomain}},[_c('div',{staticClass:"clearfix"},[_c('b-form-group',{staticClass:"font-weight-bold text-dark",attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"domain"}},[_vm._v("\n                    Domænenavn\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","required":"","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.domain),callback:function ($$v) {_vm.$set(_vm.domainSettings, "domain", $$v)},expression:"domainSettings.domain"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{staticClass:"font-weight-bold text-dark"},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1"},[_vm._v("\n                    Select\n                  ")]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"plain":"","disabled":_vm.showDomain,"options":_vm.options},model:{value:(_vm.domainSettings.services),callback:function ($$v) {_vm.$set(_vm.domainSettings, "services", $$v)},expression:"domainSettings.services"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"dkuser"}},[_vm._v("\n                    DKhostmaster Bruger-id\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain,"required":""},model:{value:(_vm.domainSettings.dkuser),callback:function ($$v) {_vm.$set(_vm.domainSettings, "dkuser", $$v)},expression:"domainSettings.dkuser"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Input beskrivelse\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"dkpassword"}},[_vm._v("\n                    DKhostmaster Adgangskode\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain,"required":""},model:{value:(_vm.domainSettings.dkpassword),callback:function ($$v) {_vm.$set(_vm.domainSettings, "dkpassword", $$v)},expression:"domainSettings.dkpassword"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"email1"}},[_vm._v("\n                    Email Address 1\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.email1),callback:function ($$v) {_vm.$set(_vm.domainSettings, "email1", $$v)},expression:"domainSettings.email1"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"email2"}},[_vm._v("\n                    Email Address 2\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.email2),callback:function ($$v) {_vm.$set(_vm.domainSettings, "email2", $$v)},expression:"domainSettings.email2"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(!_vm.showDomain)?_c('button',{staticClass:"col-12 not-rounded p2 gibson action-button h4 semi-bold flex justify-center items-center",attrs:{"type":"submit"}},[_c('span',[_vm._v("Submit")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),_c('b-alert',{staticClass:"h5 gibson line-height-golden white p2 green-background",attrs:{"show":_vm.showDomain}},[_vm._v("Du har nu opdateret dine domæneinformationer. Vi vil derfor begynde opsætningen af dit domæne og email")])],1)])])]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('img',{attrs:{"src":"static/svg/settings.svg","width":"28","height":"28"}}),_c('p',{staticClass:"inline-block h6 p1 gibson"},[_vm._v("E-mail")])]},proxy:true}],null,false,4274263207)},[_vm._v(" "),_c('webemailcontents',{attrs:{"filteredPosts":_vm.filteredPostsEmail,"emaildomain":_vm.emaildomain,"numemail":_vm.numemail,"numemailused":_vm.numemailused},on:{"Reload":_vm.Reload}})],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',[_c('b-tabs',{attrs:{"pills":""}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/sitemap.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("Sider")])])]},proxy:true}],null,false,1588349141)},[_vm._v(" "),_c('websitecontents',{attrs:{"filteredPosts":_vm.filteredPosts},on:{"Reload":_vm.Reload}})],1),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/list.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("Sidernes rækkefølge")])])]},proxy:true}],null,false,2428024857)},[_vm._v(" "),_c('websitesort',{attrs:{"filteredPosts":_vm.filteredPosts,"titles":_vm.titles,"filteredSorts":_vm.filteredSorts},on:{"Reload":_vm.Reload}})],1),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/layout.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("Temaer")])])]},proxy:true}],null,false,2108859067)},[_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-wrap justify-start items-start"},_vm._l((_vm.templates),function(template){return _c('div',{key:template.id,staticClass:"col col-5 mb4 p2 pb4 overflow-hidden"},[_c('div',{staticClass:"relative"},[_c('div',{staticClass:"relative",staticStyle:{"height":"320px"}},[_c('img',{staticClass:"fit",attrs:{"src":template.img,"alt":template.id}})]),_vm._v(" "),_c('div',{staticClass:"absolute right-0 bottom-0 left-0"},[_c('div',{staticClass:"col-6 mx-auto highlights flex flex-column p1 white-background"},[_c('span',{staticClass:"block mb2 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue gibson line-height-1 m0 p0 capitalize",staticStyle:{"font-size":"90%"}},[_vm._v("\n                        "+_vm._s(template.id)+"\n                      ")]),_vm._v(" "),[(template.id === 'theme1')?_c('span',{staticClass:"darkblue gibson block flex justify-start items-center"},[_c('span',{staticClass:"green"},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"h6 regular m0 p0",staticStyle:{"font-size":"90%"}},[_vm._v("Menu")])]):_c('span',{staticClass:"red gibson block flex justify-start items-center"},[_c('span',[_c('i',{staticClass:"el-icon-remove"})]),_vm._v(" "),_c('span',{staticClass:"h6 regular gibson m0 p0 line-height-1",staticStyle:{"font-size":"90%"}},[_vm._v("Menu")])])]],2),_vm._v(" "),(template.id !== _vm.vtemplate)?_c('button',{staticClass:"action-button gibson line-height-1 flex justify-center items-center h6 regular py1 px2 flex-none mx-auto",attrs:{"type":"button"},on:{"click":function($event){return _vm.Updatetemplate(template.id)}}},[_c('span',{staticStyle:{"font-size":"90%"}},[_vm._v("Vælg")])]):_vm._e(),_vm._v(" "),(template.id === _vm.vtemplate)?_c('div',{staticClass:"center mx-auto py1 px2 border green-border mb1"},[_c('p',{staticClass:"h6 gibson green line-height-1 m0 p0",staticStyle:{"font-size":"90%"}},[_vm._v("Valgte")])]):_vm._e()])])])])}),0)]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/settings.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("Indstillinger")])])]},proxy:true}],null,false,568605908)},[_vm._v(" "),_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 px1"},[_c('form',{on:{"submit":_vm.onUpdateSettings,"reset":_vm.onResetSettings}},[_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{staticClass:"gibson h5 regular mb1 darkblue",attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteTitle"}},[_vm._v("Navn på hjemmeside")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle"},model:{value:(_vm.siteSettings.Title),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Title", $$v)},expression:"siteSettings.Title"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Her skriver du navnet på din hjemmeside fx hansensvvs.dk\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings3"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteKeywords"}},[_vm._v("Søgeord")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteKeywords"},model:{value:(_vm.siteSettings.Keywords),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Keywords", $$v)},expression:"siteSettings.Keywords"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Her skriver du de søgeord, som du ønsker at din hjemmeside skal blive fundet på, det kan fx være dit firmanavn, produktnavne eller lignende\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"Facebook"}},[_vm._v("\n                    Link til virksomhedens Facebookside\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"Facebook"},model:{value:(_vm.siteSettings.facebook),callback:function ($$v) {_vm.$set(_vm.siteSettings, "facebook", $$v)},expression:"siteSettings.facebook"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings3","label":""}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"Instagram"}},[_vm._v("\n                    Link til virksomhedens Instagramside\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"Twitter"},model:{value:(_vm.siteSettings.twitter),callback:function ($$v) {_vm.$set(_vm.siteSettings, "twitter", $$v)},expression:"siteSettings.twitter"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Hvis du ønsker at tilføje et link til din virksomheds profil på de Facebook/Instagram kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('b-form-group',{attrs:{"id":"settings2"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"siteDescription"}},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('b-form-textarea',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteDescription","rows":8,"max-rows":6},model:{value:(_vm.siteSettings.Description),callback:function ($$v) {_vm.$set(_vm.siteSettings, "Description", $$v)},expression:"siteSettings.Description"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Som standard vil beskrivelsen på din hjemmeside, være din profiltekst fra Håndværker.dk, ønsker du at lave en anden beskrivelse, kan du gøre det her\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[[(!_vm.image)?_c('div',[_c('div',{staticClass:"font-weight-bold p-1"},[_vm._v("Logo")]),_vm._v(" "),_c('input',{attrs:{"type":"file"},on:{"change":_vm.onFileChange}})]):_c('div',[_c('p',{staticClass:"h5 semi-bold gibson mb2 darkblue"},[_vm._v("\n                      Logo\n                    ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center"},[_c('img',{attrs:{"src":_vm.image}}),_vm._v(" "),_c('button',{staticClass:"not-rounded p1 delete-button",on:{"click":_vm.removeImage}},[_c('span',[_c('svg',{staticClass:"jam jam-trash",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z"}})])])])])])]],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('button',{staticClass:"not-rounded action-button gibson h4 regular col-12 flex justify-center items-center p2",attrs:{"type":"submit"}},[_c('span',[_c('svg',{staticClass:"jam jam-refresh",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -2.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M17.83 4.194l.42-1.377a1 1 0 1 1 1.913.585l-1.17 3.825a1 1 0 0 1-1.248.664l-3.825-1.17a1 1 0 1 1 .585-1.912l1.672.511A7.381 7.381 0 0 0 3.185 6.584l-.26.633a1 1 0 1 1-1.85-.758l.26-.633A9.381 9.381 0 0 1 17.83 4.194zM2.308 14.807l-.327 1.311a1 1 0 1 1-1.94-.484l.967-3.88a1 1 0 0 1 1.265-.716l3.828.954a1 1 0 0 1-.484 1.941l-1.786-.445a7.384 7.384 0 0 0 13.216-1.792 1 1 0 1 1 1.906.608 9.381 9.381 0 0 1-5.38 5.831 9.386 9.386 0 0 1-11.265-3.328z"}})])]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_vm._v("Opdater")])])])])])]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/protection.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("Tilladelser")])])]},proxy:true}],null,false,3760552989)},[_vm._v(" "),_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-6 lg-col-6 px1 py3"},[_c('form',{on:{"submit":_vm.onUpdateDomain}},[_c('div',{staticClass:"clearfix"},[_c('b-form-group',{staticClass:"font-weight-bold text-dark",attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"domain"}},[_vm._v("\n                    Domænenavn\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","required":"","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.domain),callback:function ($$v) {_vm.$set(_vm.domainSettings, "domain", $$v)},expression:"domainSettings.domain"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{staticClass:"font-weight-bold text-dark"},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1"},[_vm._v("\n                    Select\n                  ")]),_vm._v(" "),_c('b-form-checkbox-group',{attrs:{"plain":"","disabled":_vm.showDomain,"options":_vm.options},model:{value:(_vm.domainSettings.services),callback:function ($$v) {_vm.$set(_vm.domainSettings, "services", $$v)},expression:"domainSettings.services"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"dkuser"}},[_vm._v("\n                    DKhostmaster Bruger-id\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain,"required":""},model:{value:(_vm.domainSettings.dkuser),callback:function ($$v) {_vm.$set(_vm.domainSettings, "dkuser", $$v)},expression:"domainSettings.dkuser"}}),_vm._v(" "),_c('span',{staticClass:"h5 mediumgrey regular line-height-3 gibson"},[_vm._v("\n                    Input beskrivelse\n                  ")])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"dkpassword"}},[_vm._v("\n                    DKhostmaster Adgangskode\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain,"required":""},model:{value:(_vm.domainSettings.dkpassword),callback:function ($$v) {_vm.$set(_vm.domainSettings, "dkpassword", $$v)},expression:"domainSettings.dkpassword"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"email1"}},[_vm._v("\n                    Email Address 1\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.email1),callback:function ($$v) {_vm.$set(_vm.domainSettings, "email1", $$v)},expression:"domainSettings.email1"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form-group',{attrs:{"id":"settings1"}},[_c('label',{staticClass:"h5 semi-bold darkblue gibson mb1",attrs:{"label-for":"email2"}},[_vm._v("\n                    Email Address 2\n                  ")]),_vm._v(" "),_c('b-form-input',{staticClass:"border-none not-rounded gibson p2 h5 muted-background darkblue",attrs:{"id":"siteTitle","disabled":_vm.showDomain},model:{value:(_vm.domainSettings.email2),callback:function ($$v) {_vm.$set(_vm.domainSettings, "email2", $$v)},expression:"domainSettings.email2"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(!_vm.showDomain)?_c('button',{staticClass:"col-12 not-rounded p2 gibson action-button h4 semi-bold flex justify-center items-center",attrs:{"type":"submit"}},[_c('span',[_vm._v("Submit")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),_c('b-alert',{staticClass:"h5 gibson line-height-golden white p2 green-background",attrs:{"show":_vm.showDomain}},[_vm._v("Du har nu opdateret dine domæneinformationer. Vi vil derfor begynde opsætningen af dit domæne og email")])],1)])])]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"mr1",attrs:{"src":"static/svg/email.svg","width":"18","height":"18"}}),_vm._v(" "),_c('p',{staticClass:"inline-block h6 line-height-1 m0 p0 gibson"},[_vm._v("E-mail")])])]},proxy:true}],null,false,242692774)},[_vm._v(" "),_c('webemailcontents',{attrs:{"filteredPosts":_vm.filteredPostsEmail,"emaildomain":_vm.emaildomain,"numemail":_vm.numemail,"numemailused":_vm.numemailused},on:{"Reload":_vm.Reload}})],1)],1)],1):_vm._e()],_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3 mb2"},[_c('p',{staticClass:"h5 gibson darkblue line-height-golden regular"},[_vm._v("Her kan du tilføje nye sider og redigere indholdet på din hjemmeside.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1249 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[[(_vm.haaid)?_c('div',{staticClass:"clearfix gibson px2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[(_vm.basic)?_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2"},[_c('div',[_vm._m(0),_vm._v(" "),_c('button',{staticClass:"p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1",attrs:{"disabled":_vm.isLoadingMail},on:{"click":_vm.handleSubmitMail}},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_vm._m(1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix p2 py3"},[_vm._m(2),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),[(_vm.haaid !== '0')?_c('div',[(_vm.url !== '')?_c('a',{staticClass:"col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none",attrs:{"target":"_blank","href":("http://www.kundematch.dk/website/public/" + _vm.url + "/" + _vm.haaid + "/index.html"),"type":"submit","size":"lg"}},[_c('span',[_vm._v("Se din hjemmeside")]),_vm._v(" "),_vm._m(3)]):_vm._e(),_vm._v(" "),(_vm.url !== '')?_c('a',{staticClass:"col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none",attrs:{"target":"_blank","href":"https://mail.jobcatcher.dk/rainloop","type":"submit","size":"lg"}},[_c('span',[_vm._v("Webmail")]),_vm._v(" "),_vm._m(4)]):_vm._e(),_vm._v(" "),(_vm.url !== '')?_c('a',{staticClass:"col-12 outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none",attrs:{"target":"_blank","href":"https://mail.jobcatcher.dk/","type":"submit","size":"lg"}},[_c('span',[_vm._v("E-mailindstillinger")]),_vm._v(" "),_vm._m(5)]):_vm._e()]):_vm._e()]],2),_vm._v(" "),_c('div',{staticClass:"clearfix px2"},[_c('websitecontrols',{on:{"UpdateUrl":_vm.UpdateUrl}})],1)]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"col-10 px0 ml4"},[(_vm.basic)?_c('div',{staticClass:"absolute left-0 right-0 top-0 bottom-0 transparent-darkblue-background white p4 col-12 flex flex-column justofy-center items-start z2"},[_c('div',[_vm._m(6),_vm._v(" "),_c('button',{staticClass:"p2 my2 white-button flex justify-center items-center gibson h5 not-rounded border-none line-height-1",attrs:{"disabled":_vm.isLoadingMail},on:{"click":_vm.handleSubmitMail}},[_c('span',[_vm._v("Kontakt mig")]),_vm._v(" "),_vm._m(7)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix p2 py3"},[_vm._m(8),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),(_vm.haaid !== '0')?_c('div',{staticClass:"flex justify-start"},[(_vm.url !== '')?_c('a',{staticClass:"no-hover outlined-action-button h5 semi-bold gibson p2 flex justify-center items-center not-rounded mr2",attrs:{"target":"_blank","href":("http://www.kundematch.dk/website/public/" + _vm.url + "/" + _vm.haaid + "/index.html"),"type":"submit"}},[_c('span',[_vm._v("Se din hjemmeside")]),_vm._v(" "),_vm._m(9)]):_vm._e(),_vm._v(" "),(_vm.url !== '')?_c('a',{staticClass:"no-hover outlined-action-button h5 semi-bold gibson p2 flex justify-center items-center not-rounded mr2",attrs:{"target":"_blank","href":"https://mail.jobcatcher.dk/rainloop","type":"submit"}},[_c('span',[_vm._v("Webmail")]),_vm._v(" "),_vm._m(10)]):_vm._e(),_vm._v(" "),(_vm.url !== '')?_c('a',{staticClass:"no-hover outlined-action-button h4 semi-bold gibson p2 flex justify-center items-center not-rounded no-hover text-decoration-none",attrs:{"target":"_blank","href":"https://mail.jobcatcher.dk/","type":"submit"}},[_c('span',{staticClass:"mr1"},[_vm._v("E-mailindstillinger")]),_vm._v(" "),_vm._m(11)]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix px2"},[_c('websitecontrols',{on:{"UpdateUrl":_vm.UpdateUrl}})],1),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1):_vm._e()]):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})]],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h4 gibson regular white line-height-golden"},[_vm._v("Som basismedlem har du desværre ikke adgang til denne del af partner-login."),_c('br'),_vm._v("\n              Opgrader din løsning, hvis du vil have adgang.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Din hjemmeside")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n              Hvis du er kunde hos Håndværker.dk, har du mulighed for at få en gratis hjemmeside, som bygger på indholdet fra din Håndværker.dk profil.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h4 gibson regular white line-height-golden"},[_vm._v("Som basismedlem har du desværre ikke adgang til denne del af partner-login."),_c('br'),_vm._v("\n              Opgrader din løsning, hvis du vil have adgang.\n            ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-8 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Din hjemmeside")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n              Hvis du er kunde hos Håndværker.dk, har du mulighed for at få en gratis hjemmeside, som bygger på indholdet fra din Håndværker.dk profil.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1250 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1251 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inbox_vue__ = __webpack_require__(1253);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb7991d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Inbox_vue__ = __webpack_require__(1256);
function injectStyle (ssrContext) {
  __webpack_require__(1252)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Inbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4eb7991d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Inbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1252 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1253 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Message__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__CreditcheckList__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_select__);









/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_1__Message__["a" /* default */],
    creditchecklist: __WEBPACK_IMPORTED_MODULE_2__CreditcheckList__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a,
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_6_vue_select___default.a
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },
  data: function data() {
    return {
      emails: [],
      sends: [],
      options: [],
      files: [],
      starMessage: '',
      upload_token: '',
      tilbud_id: '',
      salesPerson: '',
      quotation: {
        files: [],
        info: []
      },
      title: '',
      to: '',
      load: 0,
      tabIndex: 0,
      message: '',
      email: { file: [] },
      emailShow: false,
      showDismissibleAlert: false,
      clear_quotation_attachment: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading...',
      drafts: false
    };
  },

  methods: {
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
      document.querySelector('#inboxMsg .progress').classList.remove('hide');
    },
    Reload: function Reload() {
      var _this = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (_this.$route.query.send === 'support' && _this.load === 0) {
          _this.formShow = !_this.formShow;
        }
        _this.emails = res.resultMessage;
        _this.sends = res.resultSent;
        _this.options = res.customer;
        if (_this.$route.query.email) {
          var email;
          for (email in _this.emails) {
            if (_this.emails[email].id === _this.$route.query.email && _this.load === 0) _this.showItemDetails(_this.emails[email]);
          }
        }
        if (_this.$route.query.cid) {
          _this.tabIndex = 2;
          for (var idc in _this.options) {
            var customerList = _this.options[idc];
            if (parseInt(customerList.cid) === parseInt(_this.$route.query.cid)) {
              _this.to = { 'cid': customerList.cid, 'name': customerList.name };
            }
          }
        }
        if (res.resultMessage.length === 0) _this.showDismissibleAlert = true;
        if (_this.$route.query.default === 'imentor') {
          _this.title = 'Nyt abonnement';
          _this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Prisberegning.dk';
        }
        if (_this.$route.query.default === 'haandvaerker') {
          _this.title = 'Nyt abonnement';
          _this.message = 'Jeg vil gerne kontaktes ang. et abonnement på Håndværker.dk';
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(email) {
      var _this2 = this;

      this.emailShow = !this.emailShow;
      this.email = email;
      if (this.email.frompid !== '0') return;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message_read', salesPerson: this.salesPerson, email_id: email.id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        localStorage.setItem('inbox', res.inbox);
        $('#totalInbox').html(res.inbox);
        if (res.inbox === 0) {
          $('#totalInbox').hide();
        } else {
          $('#totalInbox').show();
        }
      }, function (response) {
        alert('error');
      });
    },
    send_service: function send_service(evt) {
      var _this3 = this;

      if (!this.to.cid) return;
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'send_service', salesPerson: this.salesPerson, title: this.title, message: this.message, to: this.to.cid, files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.load = 1;
          _this3.Reload();
          _this3.formShow = false;
          _this3.title = '';
          _this3.message = '';
          _this3.files = [];
          document.querySelector('#inboxMsg .progress').classList.add('hide');
          var fileList = document.querySelectorAll('#inboxMsg .upload-file-list li');
          for (var i = 0; i < fileList.length; i++) {
            fileList[i].remove();
            console.log(fileList[i]);
          }
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    resend_service: function resend_service(email) {
      this.$refs.emailModal.hide();
      this.formShow = !this.formShow;
      this.title = 'Re: ' + email.title;
      console.log(email.cid + 'hgggg');
      for (var idc in this.options) {
        var customerList = this.options[idc];
        if (parseInt(customerList.cid) === parseInt(email.cid)) {
          this.to = { 'cid': customerList.cid, 'name': customerList.name };
        }
      }
    },
    mailSupport: function mailSupport() {
      this.formShow = !this.formShow;
    },
    hideModal: function hideModal() {
      this.$refs.emailModal.hide();
    },
    hideModalForm: function hideModalForm() {
      this.$refs.formModal.hide();
    }
  }
});

/***/ }),
/* 1254 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'messagebox',
  props: ['email', 'starMessage', 'bulkSelect'],
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    showItemDetails: function showItemDetails(email) {
      email.SEEN = true;
      this.$emit('showItemDetails', email);
    }
  }
});

/***/ }),
/* 1255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:{read: _vm.email.seen, unread: !_vm.email.seen}},[_c('div',{staticClass:"flex flex-column pt2 pb2 border-top muted-border mouse-cursor",staticStyle:{"cursor":"pointer!important"},on:{"click":function($event){return _vm.showItemDetails(_vm.email)}}},[_c('div',{staticClass:"col-12 flex justify-between items-start gibson"},[_c('div',{staticClass:"flex-none",staticStyle:{"width":"40px","height":"40px","background":"rgba(0, 54, 69, 1.0)","border-radius":"50%"}}),_vm._v(" "),_c('div',{staticClass:"flex-auto px2"},[_c('p',{staticClass:"darkblue line-height-3 m0",staticStyle:{"font-size":"1rem"}},[_vm._v(_vm._s(_vm.email.firstname)+" "+_vm._s(_vm.email.lastname))]),_vm._v(" "),_c('p',{staticClass:"mediumgrey line-height-3 m0",staticStyle:{"font-size":".875rem"}},[_vm._v(_vm._s(_vm.email.title))])]),_vm._v(" "),_c('div',{staticClass:"flex-none"},[_c('p',{staticClass:"h6 muted gibson line-height-3 regular"},[_vm._v("\n          "+_vm._s(_vm.moment(_vm.email.createtime).locale('da').format('Do MMMM'))+"\n        ")]),_vm._v(" "),(_vm.email.file.length !== 0)?_c('span',{staticClass:"mt2 col-12 mintgreen"},[_c('svg',{staticClass:"jam jam-attachment right",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-1.5 -1.5 24 24","width":"18","height":"18","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M18.433 5.359a.933.933 0 0 1 1.357 0c.375.39.375 1.022 0 1.412L8.26 18.78a4.663 4.663 0 0 1-6.783 0c-1.873-1.95-1.873-5.113 0-7.064L11.65 1.12a2.798 2.798 0 0 1 4.07 0c1.124 1.17 1.124 3.068 0 4.239L6.902 14.54a.933.933 0 0 1-1.356 0 1.028 1.028 0 0 1 0-1.412l8.818-9.183a1.028 1.028 0 0 0 0-1.413.933.933 0 0 0-1.357 0L2.832 13.13c-1.123 1.17-1.123 3.068 0 4.238a2.798 2.798 0 0 0 4.07 0L18.433 5.359z"}})])]):_vm._e()])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1256 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4",attrs:{"id":"inboxMsg"}},[(_vm.showMobile)?_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mb2 md-hide lg-hide"},[_c('div',{staticClass:"right-align mb3"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/email"}},[_vm._v("E-mail")])],1),_vm._v(" "),_c('div',{staticClass:"py2 inboxSpecial"},[_c('b-tabs',{attrs:{"pills":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-download mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Inbox")])]},proxy:true}],null,false,2293664015)},[_vm._v(" "),_c('div',{staticClass:"messages gibson"},[_c('b-alert',{staticClass:"col-12 px0 primarycolor flex justify-start items-center",attrs:{"show":_vm.showDismissibleAlert}},[_c('div',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-inbox-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z"}})])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_vm._v("Din indbakke er tom")])]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2)]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-upload2 mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Sendte")])]},proxy:true}],null,false,2968951541)},[_vm._v(" "),_vm._l((_vm.sends),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-s-promotion mr2"}),_c('span',{staticClass:"gibson"},[_vm._v("Ny besked")])]},proxy:true}],null,false,3128933358)},[_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n                            Ingen matchende ...\n                          ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span',{staticClass:"regular"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])])],1),_vm._v(" "),_c('div',{staticClass:"py4"})])],1)],1)])])])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix gibson px2 mb2 ml4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-5 px0 mb2 xs-hide sm-hide"},[_c('div',{staticClass:"right-align"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/email"}},[_vm._v("E-mail")])],1),_vm._v(" "),_c('div',{staticClass:"py2 inboxSpecial"},[_c('b-tabs',{attrs:{"pills":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-download mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Inbox")])]},proxy:true}],null,false,2293664015)},[_vm._v(" "),_c('div',{staticClass:"messages notosans"},[_c('b-alert',{staticClass:"col-12 px0 primarycolor flex justify-start items-center",attrs:{"show":_vm.showDismissibleAlert}},[_c('div',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-inbox-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z"}})])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_vm._v("Din indbakke er tom")])]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2)]),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-upload2 mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Sendte")])]},proxy:true}],null,false,2968951541)},[_vm._v(" "),_vm._l((_vm.sends),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-s-promotion mr2"}),_c('span',{staticClass:"gibson"},[_vm._v("Ny besked")])]},proxy:true}],null,false,3128933358)},[_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n                            Ingen matchende ...\n                          ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.showMobile)?_c('button',{staticClass:"col-12 action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span',{staticClass:"regular"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('button',{staticClass:"action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span',{staticClass:"regular"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])],1),_vm._v(" "),_c('div',{staticClass:"py4"})])],1)],1)])])])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"emailModal",attrs:{"centered":"","lazy":"","size":"lg"},model:{value:(_vm.emailShow),callback:function ($$v) {_vm.emailShow=$$v},expression:"emailShow"}},[_c('div',{staticClass:"w-100 p-2",attrs:{"slot":"modal-header"},slot:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-content border-none gibson p1"},[_c('div',{staticClass:"d-flex flex-column p1"},[_c('div',{staticClass:"line-height-golden h6 font-weight-bold"},[(_vm.email.frompid !== '0')?[_vm._v("Til:")]:_vm._e(),_vm._v("  "+_vm._s(_vm.email.firstname)+" "+_vm._s(_vm.email.lastname)+": "+_vm._s(_vm.email.title)+"\n        ")],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"far fa-clock text-muted",staticStyle:{"position":"relative","top":"1px"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.moment(_vm.email.createtime).format('lll')))])])]),_vm._v(" "),_c('b-embed',{attrs:{"type":"iframe","seamless":"","src":'https://www.kundematch.dk/newpartner/readmessage.php?email_id='+_vm.email.id+'&id='+_vm.salesPerson,"aspect":"1by1"}})],1),_vm._v(" "),(_vm.email.file.length !== 0)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"12","md":"2","lg":"2"}},[_vm._v("\n        Files :\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.email.file),function(attachment,index){return _c('li',{key:index,staticClass:"py-1"},[_c('a',{attrs:{"href":'https://www.kundematch.dk/HenttilbudImg.php?img='+attachment,"target":"_blank"}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-4 pl-2 pr-2 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"rounded float-left",attrs:{"slot":"modal-ok","type":"button","variant":"success","size":"lg","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.resend_service(_vm.email)}},slot:"modal-ok"},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"}})])]),_vm._v("Reply\n        ")])],1),_vm._v(" "),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-right rounded",attrs:{"slot":"modal-cancel","type":"buttom","variant":"secondary","size":"lg"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('i',{staticClass:"el-icon-error mr-2"}),_vm._v("Luk\n        ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.formShow),callback:function ($$v) {_vm.formShow=$$v},expression:"formShow"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n            Skriv til ...\n          ")])])])]),_vm._v(" "),_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"modal-content border-none p2"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n              Ingen matchende ...\n            ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 py3 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button p2 px3 h5 gibson border-none not-rounded justify-start items-center",attrs:{"type":"reset"},on:{"click":_vm.hideModalForm}},[_c('span'),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 px3 gibson h5 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span'),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Send")])])])])],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Beskeder")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Beskeder")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1257 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_email_vue__ = __webpack_require__(1259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42f3b15a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_email_vue__ = __webpack_require__(1263);
function injectStyle (ssrContext) {
  __webpack_require__(1258)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_email_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42f3b15a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_email_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1258 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1259 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_2_vue_select___default.a
  },
  data: function data() {
    return {
      loading: false,
      insideLoading: true,
      isEmailLoggedIn: false,
      loginForm: '',
      loginEmail: '',
      loginEmailDomain: '@jobcatcher.dk',
      loginPassword: '',
      accountID: '',
      search: '',
      inputSearchVisible: true,
      curPage: 1,
      limit: 20,
      offset: 0,
      loadedEmail: 20,
      lastPage: 50,
      totalEmailCount: 0,
      activeTab: '1',
      emailData: [],
      emailMsg: '',
      imgSrcData: [],
      emailDetailsData: [],
      emailLoadingDialog: false,
      emailLoading: true,
      emailDetailsDialog: false,
      responseForm: false,
      subject: '',
      message: '',
      recipientTo: [],
      inputRecipientToVisible: false,
      inputRecipientTo: '',
      recipientCC: [],
      recipientCCVisible: false,
      inputRecipientCCVisible: false,
      inputRecipientCC: '',
      recipientBCC: [],
      recipientBCCVisible: false,
      inputRecipientBCCVisible: true,
      inputRecipientBCC: '',
      buttonResponseVisible: true,
      contactsData: [],
      contactsAddFormDialog: false,
      contactsUpdateFormDialog: false,
      contactForm: '',
      contactName: '',
      contactEmail: '',
      contactUuid: ''
    };
  },
  created: function created() {
    var _this = this;

    var isEmailLoggedIn = localStorage.getItem('isEmailLoggedIn');
    var emailAccountId = localStorage.getItem('emailAccountId');
    if (isEmailLoggedIn === 'true') {
      this.isEmailLoggedIn = true;
      this.accountID = emailAccountId;
      var seshEmail = sessionStorage.getItem('email');
      if (seshEmail !== null) {
        this.getEmailCount();
      } else {
        this.isEmailLoggedIn = false;
      }
    } else {
      setTimeout(function () {
        _this.$refs.loginEmail.focus();
      }, 1000);
    }
  },

  methods: {
    login: function login() {
      var _this2 = this;

      var email = this.loginEmail;
      var password = this.loginPassword;
      if (email !== '' && password !== '') {
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/login',
          data: {
            login: email + this.loginEmailDomain,
            password: password
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {
            _this2.isEmailLoggedIn = true;
            localStorage.setItem('isEmailLoggedIn', true);

            sessionStorage.setItem('email', email + _this2.loginEmailDomain);
            sessionStorage.setItem('password', password);

            __WEBPACK_IMPORTED_MODULE_3_axios___default()({
              method: 'POST',
              url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getAccounts',
              data: {
                login: email + _this2.loginEmailDomain,
                password: password
              }
            }).then(function (response) {
              var res = response.data;
              if (res.success) {
                for (var i = 0; i < res.data.length; i++) {
                  if (res.data[i].Email === email + _this2.loginEmailDomain) {
                    _this2.accountID = res.data[i].AccountID;
                    localStorage.setItem('emailAccountId', res.data[i].AccountID);
                    _this2.getEmailCount();
                  }
                }
              }
            }).catch(function (err) {
              console.log(err);
            });
            _this2.loading = false;
          }
        }).catch(function (err) {
          console.log(err);
          _this2.loginPassword = '';
          _this2.$toastr('error', 'Ugyldigt login');
          _this2.loading = false;
        });
        this.loading = true;
      } else {
        this.$refs.loginEmail.focus();
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    autoReload: function autoReload() {
      this.getEmailCount();
    },
    getEmailCount: function getEmailCount() {
      var _this3 = this;

      var accId = this.accountID;
      var emailFolder = '';
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      if (this.activeTab === '1') {
        emailFolder = 'Inbox';
      } else if (this.activeTab === '2') {
        emailFolder = 'Sent';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessages',
        data: {
          account_id: accId,
          folder: emailFolder,
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          var subjectList = [];
          var count = 0;
          for (var i = 0; i < res.data['@Collection'].length; i++) {
            var uid = res.data['@Collection'][i].Uid;
            var subject = res.data['@Collection'][i].Subject;
            if (!subjectList.includes(subject)) {
              subjectList.push(subject);
              count++;
            } else {
              _this3.deleteEmail(uid);
            }
          }
          _this3.totalEmailCount = count;

          var emailCount = count;
          var limit = _this3.limit;
          var lastPage = 0;
          lastPage = emailCount / limit;
          if (!__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(lastPage)) {
            var data = lastPage.toString().split('.');
            if (parseInt(data[1]) > 0) {
              _this3.lastPage = parseInt(data[0]) + 1 + '0';
            } else {
              _this3.lastPage = parseInt(data[0]) + '0';
            }
          } else {
            _this3.lastPage = lastPage + '0';
          }
          _this3.calculatePagination();
          _this3.displayEmail(emailFolder);
        }
      }).catch(function (err) {
        console.log(err);
      });
      this.insideLoading = true;
    },
    calculatePagination: function calculatePagination() {
      var emailCount = this.totalEmailCount;
      var limit = this.limit;
      var loadedEmail = this.limit;
      var curPage = this.curPage;
      console.log(curPage);
      var offset = 0;
      if (curPage === 1) {
        offset = emailCount - limit;
        this.offset = offset;
      } else {
        this.loadedEmail = loadedEmail * curPage;
        this.offset = this.loadedEmail - this.limit;
      }
      console.log(this.offset);
    },
    paginationChanged: function paginationChanged(val) {
      var curPage = parseInt('' + val);
      this.curPage = curPage;
      this.getEmailCount();
      this.insideLoading = true;
    },
    displayEmail: function displayEmail(folder) {
      var _this4 = this;

      var accId = this.accountID;
      var emailFolder = folder;
      var search = this.search;
      var limit = this.limit;
      var offset = this.offset;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessages',
        data: {
          account_id: accId,
          folder: emailFolder,
          search: search,
          limit: limit,
          offset: offset,
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this4.emailData = res.data;
          _this4.displayContacts();
          _this4.insideLoading = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    sendEmail: function sendEmail() {
      var _this5 = this;

      var accId = this.accountID;
      var to = '';
      for (var i = 0; i < this.recipientTo.length; i++) {
        if (i > 0) {
          to += ',' + this.recipientTo[i];
        } else {
          to += this.recipientTo[i];
        }
      }
      var cc = '';
      for (var j = 0; j < this.recipientCC.length; j++) {
        if (j > 0) {
          cc += ',' + this.recipientCC[j];
        } else {
          cc += this.recipientCC[j];
        }
      }
      var bcc = '';
      for (var k = 0; k < this.recipientBCC.length; k++) {
        if (k > 0) {
          bcc += ',' + this.recipientBCC[k];
        } else {
          bcc += this.recipientBCC[k];
        }
      }
      var subject = this.subject;
      var text = this.message;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      if (to !== '' && text !== '') {
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/sendMessage',
          data: {
            account_id: accId,
            to: to,
            cc: cc,
            bcc: bcc,
            subject: subject,
            text: text,
            login: email,
            password: password
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {
            _this5.enableSendButton();
            _this5.clear();
            _this5.closeEmailDetails();
            if (_this5.activeTab === '1') {
              _this5.displayEmail('Inbox');
            } else if (_this5.activeTab === '2') {
              _this5.displayEmail('Sent');
            }

            _this5.inputRecipientToVisible = true;
            var obj = {
              title: 'Besked sendt!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this5.$refs.simplert.openSimplert(obj);
          }
        }).catch(function (err) {
          document.querySelector('.send-btn').classList.remove('disabled');
          console.log(err);
          _this5.$toastr('error', 'Meddelelsen blev ikke sendt');
        });
        this.disableSendButton();
      } else {
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    showEmailDetails: function showEmailDetails(mail, Uid, IsSeen) {
      var _this6 = this;

      var folder = '';
      if (mail === 'inbox') {
        folder = 'Inbox';
      } else if (mail === 'sent') {
        folder = 'Sent';
      }
      var accId = this.accountID;
      var uId = Uid;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessage',
        data: {
          account_id: accId,
          uid: uId,
          folder: folder,
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this6.emailLoadingDialog = false;
          _this6.emailDetailsData = res.data;
          _this6.emailDetailsDialog = true;
          _this6.emailLoading = true;
          if (res.data.HtmlRaw.includes('img')) {
            _this6.displayImagesInEmail(mail, Uid);
          } else {
            setTimeout(function () {
              document.querySelector('.email-content').classList.remove('hide');
              _this6.emailLoading = false;
            }, 1000);
          }
        }
      }).catch(function (err) {
        console.log(err);
      });
      if (!IsSeen) {
        this.seenEmail(Uid);
      }
      this.clear();
      this.emailLoadingDialog = true;
    },
    displayImagesInEmail: function displayImagesInEmail(mail, Uid) {
      var _this7 = this;

      setTimeout(function () {
        var imgs = document.querySelectorAll('.email-text img');
        for (var i = 0; i < imgs.length; i++) {
          var imgSrc = imgs[i].src.split(':');
          var cid = imgSrc[1];
          _this7.imgSrcData.push(cid);
          _this7.setImageSrc(mail, Uid, imgs[i], _this7.imgSrcData[i], imgs.length, i);
        }
      }, 1000);
    },
    setImageSrc: function setImageSrc(mail, Uid, img, imgSrc, imgLength, imgCount) {
      var _this8 = this;

      var folder = '';
      if (mail === 'inbox') {
        folder = 'Inbox';
      } else if (mail === 'sent') {
        folder = 'Sent';
      }
      var accId = this.accountID;
      var uId = Uid;
      var cid = imgSrc;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getMessageCIDNew',
        data: {
          account_id: accId,
          uid: uId,
          folder: folder,
          cid: cid,
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        img.src = res;
        console.log(response);
        if (img.width <= 0 || img.width >= 1000) {
          img.style.width = '100%';
        }
        if (imgCount + 1 === imgLength) {
          document.querySelector('.email-content').classList.remove('hide');
          _this8.emailLoading = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    seenEmail: function seenEmail(Uid) {
      var accId = this.accountID;
      var uId = Uid;

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
        data: {
          account_id: accId,
          uids: uId,
          seen: 'true',
          folder: 'Inbox'
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {}
      }).catch(function (err) {
        console.log(err);
      });
      if (document.querySelector('.mail-' + uId).classList.contains('read-false')) {
        document.querySelector('.mail-' + uId + '.read-false').classList.add('read-true');
        document.querySelector('.mail-' + uId + '.read-true').classList.remove('read-false');
      }
    },
    deleteEmail: function deleteEmail(uid) {
      var accId = this.accountID;
      var emailFolder = '';
      if (this.activeTab === '1') {
        emailFolder = 'Inbox';
      } else if (this.activeTab === '2') {
        emailFolder = 'Sent';
      }

      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/deleteMessages',
        data: {
          account_id: accId,
          uids: uid,
          folder: emailFolder
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {}
      }).catch(function (err) {
        console.log(err);
      });
    },
    clear: function clear() {
      this.recipientTo = [];
      this.recipientCC = [];
      this.recipientBCC = [];
      this.responseForm = false;
      this.inputRecipientToVisible = false;
      this.recipientCCVisible = false;
      this.recipientBCCVisible = false;
      this.buttonResponseVisible = true;
      this.subject = '';
      this.message = '';
      this.contactName = '';
      this.contactEmail = '';
    },
    closeEmailDetails: function closeEmailDetails() {
      this.clear();
      this.emailDetailsDialog = false;
    },
    showReplyEmail: function showReplyEmail(response, emailData) {
      this.responseForm = true;
      var options = { weekday: 'short', year: 'numeric', month: 'long', day: 'numeric', literal: ':', hour: 'numeric', minute: 'numeric', second: 'numeric' };
      var emailText = document.querySelector('.email-text').innerHTML;

      if (response === 'reply') {
        this.recipientTo.push(emailData.From['@Collection'][0].Email);
        this.subject = document.getElementById('textSubject').innerText;
        this.message = '<br><br><div class="hide" dir="ltr">On ' + new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(emailData.TimeStampInUTC * 1000).slice(0, -5) + ' ' + emailData.From['@Collection'][0].DisplayName + ' &lt;<a href="" target="_blank" tabindex="-1" rel="external" class="external">' + emailData.From['@Collection'][0].Email + '</a>&gt; wrote:<br></div><blockquote class="hide" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><u></u><div>' + emailText + '</div></blockquote>';
      } else if (response === 'replyAll') {
        this.recipientTo.push(emailData.From['@Collection'][0].Email);
        for (var i = 0; i < emailData.Cc['@Collection'].length; i++) {
          this.recipientCC.push(emailData.Cc['@Collection'][i].Email);
        }
        this.subject = document.getElementById('textSubject').innerText;
        this.message = '<br><br><div class="hide" dir="ltr">On ' + new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(emailData.TimeStampInUTC * 1000).slice(0, -5) + ' ' + emailData.From['@Collection'][0].DisplayName + ' &lt;<a href="" target="_blank" tabindex="-1" rel="external" class="external">' + emailData.From['@Collection'][0].Email + '</a>&gt; wrote:<br></div><blockquote class="hide" style="margin:0px 0px 0px 0.8ex;border-left:1px solid rgb(204,204,204);padding-left:1ex"><u></u><div>' + emailText + '</div></blockquote>';
        this.recipientCCVisible = true;
      } else if (response === 'forward') {
        this.recipientTo = [];
        this.inputRecipientToVisible = true;
        this.subject = 'Fwd: ' + document.getElementById('textSubject').innerText;
        var ccList = '';
        if (emailData.Cc != null) {
          for (var j = 0; j < emailData.Cc['@Collection'].length; j++) {
            if (j > 0) {
              ccList += ', ' + emailData.Cc['@Collection'][j].Email;
            } else {
              ccList += emailData.Cc['@Collection'][j].Email;
            }
          }
          this.message = '<br><br><div class="hide">---- Original Message ----<br>From: ' + emailData.From['@Collection'][0].DisplayName + ' <<a href="">' + emailData.From['@Collection'][0].Email + '</a>><br>To: ' + emailData.To['@Collection'][0].DisplayName + ' <<a href="">' + emailData.To['@Collection'][0].Email + '</a>><br>CC: ' + ccList + '<br>Sent: ' + new Date(parseInt(emailData.TimeStampInUTC * 1000)).toLocaleDateString('en-US', options) + '<br>Subject: ' + emailData.Subject + ' <br><br>' + emailText + '</div>';
        } else {
          this.message = '<br><br><br><div class="hide">---- Original Message ----<br>From: ' + emailData.From['@Collection'][0].DisplayName + ' <<a href="">' + emailData.From['@Collection'][0].Email + '</a>><br>To: ' + emailData.To['@Collection'][0].DisplayName + ' <<a href="">' + emailData.To['@Collection'][0].Email + '</a>><br>Sent: ' + new Date(parseInt(emailData.TimeStampInUTC * 1000)).toLocaleDateString('en-US', options) + '<br>Subject: ' + emailData.Subject + ' <br><br>' + emailText + '</div>';
        }
      }
      this.buttonResponseVisible = false;
    },
    showRecipient: function showRecipient(recip) {
      var _this9 = this;

      if (recip === 'CC') {
        this.recipientCCVisible = true;
        this.recipientCC = [];
        this.inputRecipientCCVisible = true;
        this.$nextTick(function (_) {
          _this9.$refs.saveRecipientCC.$refs.input.focus();
        });
      } else if (recip === 'BCC') {
        this.recipientBCCVisible = true;
        this.recipientBCC = [];
        this.inputRecipientBCCVisible = true;
        this.$nextTick(function (_) {
          _this9.$refs.saveRecipientBCC.$refs.input.focus();
        });
      }
    },
    showInputRecipient: function showInputRecipient(recip) {
      var _this10 = this;

      if (recip === 'to') {
        this.inputRecipientToVisible = true;
        this.$nextTick(function (_) {
          _this10.$refs.saveRecipientTo.$refs.input.focus();
        });
      } else if (recip === 'CC') {
        this.inputRecipientCCVisible = true;
        this.$nextTick(function (_) {
          _this10.$refs.saveRecipientCC.$refs.input.focus();
        });
      } else {
        this.inputRecipientBCCVisible = true;
        this.$nextTick(function (_) {
          _this10.$refs.saveRecipientBCC.$refs.input.focus();
        });
      }
    },
    addRecipient: function addRecipient(recip) {
      if (recip === 'to') {
        var inputRecipientTo = this.inputRecipientTo;
        if (inputRecipientTo !== '') {
          if (inputRecipientTo.includes('@')) {
            this.recipientTo.push(inputRecipientTo);
            if (this.recipientTo.length) {
              this.inputRecipientToVisible = false;
              this.inputRecipientTo = '';
            }
            this.enableSendButton();
          } else {
            this.disableSendButton();
            this.$toastr('error', 'Ugyldig email');
          }
        } else {
          this.enableSendButton();
          this.inputRecipientToVisible = false;
        }
      } else if (recip === 'CC') {
        var inputRecipientCC = this.inputRecipientCC;
        if (inputRecipientCC !== '') {
          if (inputRecipientCC.includes('@')) {
            this.recipientCC.push(inputRecipientCC);
            if (this.recipientCC.length) {
              this.inputRecipientCCVisible = false;
              this.inputRecipientCC = '';
            }
            this.enableSendButton();
          } else {
            this.disableSendButton();
            this.$toastr('error', 'Ugyldig email');
          }
        } else {
          this.enableSendButton();
          this.inputRecipientCCVisible = false;
        }
      } else {
        var inputRecipientBCC = this.inputRecipientBCC;
        if (inputRecipientBCC !== '') {
          if (inputRecipientBCC.includes('@')) {
            this.recipientBCC.push(inputRecipientBCC);
            if (this.recipientBCC.length) {
              this.inputRecipientBCCVisible = false;
              this.inputRecipientBCC = '';
            }
            this.enableSendButton();
          } else {
            this.disableSendButton();
            this.$toastr('error', 'Ugyldig email');
          }
        } else {
          this.enableSendButton();
          this.inputRecipientBCCVisible = false;
        }
      }
    },
    removeRecipient: function removeRecipient(val, recip) {
      if (recip === 'to') {
        this.recipientTo.splice(this.recipientTo.indexOf(val), 1);
        if (!this.recipientTo.length) {
          this.inputRecipientToVisible = true;
        }
      } else if (recip === 'CC') {
        this.recipientCC.splice(this.recipientCC.indexOf(val), 1);
        if (!this.recipientCC.length) {
          this.recipientCCVisible = false;
          this.inputRecipientCCVisible = true;
        }
      } else {
        this.recipientBCC.splice(this.recipientBCC.indexOf(val), 1);
        if (!this.recipientBCC.length) {
          this.recipientBCCVisible = false;
          this.inputRecipientBCCVisible = true;
        }
      }
    },
    checkboxSelectDeselectAll: function checkboxSelectDeselectAll() {
      var checkbox = document.querySelectorAll('.chkbx');
      if (document.getElementById('chkbxSelect').checked === true) {
        for (var i = 0; i < checkbox.length; i++) {
          checkbox[i].checked = true;
        }
      } else {
        for (var j = 0; j < checkbox.length; j++) {
          checkbox[j].checked = false;
        }
      }
      this.checkboxChanged();
    },
    markAsRead: function markAsRead() {
      var uIds = [];
      var checkboxes = document.querySelectorAll('.chkbx:checked');
      for (var i = 0; i < checkboxes.length; i++) {
        uIds.push(checkboxes[i].value);
      }
      for (var k = 0; k < uIds.length; k++) {
        var accId = this.accountID;
        var uId = uIds[k];

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
          data: {
            account_id: accId,
            uids: uId,
            seen: 'true',
            folder: 'Inbox'
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {}
        }).catch(function (err) {
          console.log(err);
        });
        if (document.querySelector('.mail-' + uId).classList.contains('read-false')) {
          document.querySelector('.mail-' + uId + '.read-false').classList.add('read-true');
          document.querySelector('.mail-' + uId + '.read-true').classList.remove('read-false');
        }
      }
    },
    markAsUnread: function markAsUnread() {
      var uIds = [];
      var checkboxes = document.querySelectorAll('.chkbx:checked');
      for (var i = 0; i < checkboxes.length; i++) {
        uIds.push(checkboxes[i].value);
      }
      for (var k = 0; k < uIds.length; k++) {
        var accId = this.accountID;
        var uId = uIds[k];

        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/setMessagesSeen',
          data: {
            account_id: accId,
            uids: uId,
            seen: 'false',
            folder: 'Inbox'
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {}
        }).catch(function (err) {
          console.log(err);
        });
        if (document.querySelector('.mail-' + uId).classList.contains('read-true')) {
          document.querySelector('.mail-' + uId + '.read-true').classList.add('read-false');
          document.querySelector('.mail-' + uId + '.read-false').classList.remove('read-true');
        }
      }
    },
    checkboxChanged: function checkboxChanged() {
      var checkboxes = document.querySelectorAll('.chkbx:checked');
      if (!checkboxes.length) {
        document.querySelector('.mark-as').style.visibility = 'hidden';
      } else {
        document.querySelector('.mark-as').style.visibility = 'visible';
      }
    },
    tabChanged: function tabChanged(tab) {
      if (tab.index === '0') {
        this.getEmailCount();
        this.inputSearchVisible = true;
      } else if (tab.index === '1') {
        this.getEmailCount();
        this.inputSearchVisible = true;
      } else if (tab.index === '2') {
        this.clear();
        this.inputSearchVisible = false;
      } else if (tab.index === '3') {
        this.clear();
        this.inputSearchVisible = false;
        this.displayContacts();
      }
      this.curPage = 1;
      this.inputRecipientToVisible = true;
      this.insideLoading = true;
    },
    enableSendButton: function enableSendButton() {
      var sendButton = document.querySelectorAll('.send-btn');
      for (var i = 0; i < sendButton.length; i++) {
        sendButton[i].classList.remove('disabled');
      }
    },
    disableSendButton: function disableSendButton() {
      var sendButton = document.querySelectorAll('.send-btn');
      for (var i = 0; i < sendButton.length; i++) {
        sendButton[i].classList.add('disabled');
      }
    },
    displayContacts: function displayContacts() {
      var _this11 = this;

      var email = sessionStorage.getItem('email');
      this.loginEmail = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/getContacts',
        data: {
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this11.contactsData = res.data;
          _this11.insideLoading = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
      this.insideLoading = true;
    },
    addContact: function addContact() {
      var _this12 = this;

      var contactName = this.contactName;
      var contactEmail = this.contactEmail;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      if (contactName !== '' && contactEmail !== '') {
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/createContact',
          data: {
            fullname: contactName,
            personal_email: contactEmail,
            personal_mobile: '',
            personal_address: '',
            login: email,
            password: password
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {
            _this12.enableSendButton();
            _this12.clear();
            _this12.closeContactForm('add');
            _this12.displayContacts();
            var obj = {
              title: 'Tilføjet!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this12.$refs.simplert.openSimplert(obj);
          }
        }).catch(function (err) {
          console.log(err);
        });
        this.disableSendButton();
      } else {
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    updateContact: function updateContact() {
      var _this13 = this;

      var contactUuid = this.contactUuid;
      var contactName = this.contactName;
      var contactEmail = this.contactEmail;
      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      if (contactName !== '' && contactEmail !== '') {
        __WEBPACK_IMPORTED_MODULE_3_axios___default()({
          method: 'POST',
          url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/updateContact',
          data: {
            uuid: contactUuid,
            fullname: contactName,
            personal_mobile: '',
            personal_email: contactEmail,
            login: email,
            password: password
          }
        }).then(function (response) {
          var res = response.data;
          if (res.success) {
            _this13.enableSendButton();
            _this13.clear();
            _this13.closeContactForm('update');
            _this13.displayContacts();
            var obj = {
              title: 'Opdateret!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this13.$refs.simplert.openSimplert(obj);
          }
        }).catch(function (err) {
          console.log(err);
        });
        this.disableSendButton();
      } else {
        this.$toastr('error', 'Felter påkrævet');
      }
    },
    confirmDeleteContact: function confirmDeleteContact(uuid) {
      var _this14 = this;

      return function (dialog) {
        return _this14.deleteContact(uuid);
      };
    },
    deleteContact: function deleteContact(uuid) {
      var _this15 = this;

      var email = sessionStorage.getItem('email');
      var password = sessionStorage.getItem('password');
      __WEBPACK_IMPORTED_MODULE_3_axios___default()({
        method: 'POST',
        url: 'https://bitrixapi.haandvaerker.dk/v1/webmail/deleteContacts',
        data: {
          uuids: uuid,
          login: email,
          password: password
        }
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          _this15.displayContacts();
          var obj = {
            title: 'Slettet!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this15.$refs.simplert.openSimplert(obj);
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    showContactForm: function showContactForm(option, contacts) {
      if (option === 'add') {
        this.contactsAddFormDialog = true;
      } else if (option === 'update') {
        this.contactUuid = contacts.UUID;
        this.contactName = contacts.FullName;
        this.contactEmail = contacts.ViewEmail;
        this.contactsUpdateFormDialog = true;
      }
    },
    closeContactForm: function closeContactForm(option) {
      this.clear();
      if (option === 'add') {
        this.contactsAddFormDialog = false;
      } else if (option === 'update') {
        this.contactsUpdateFormDialog = false;
      }
    }
  },
  watch: {
    'search': function search(newval, oldval) {
      if (this.activeTab === '1') {
        this.displayEmail('Inbox');
      } else if (this.activeTab === '2') {
        this.displayEmail('Sent');
      }
    }
  }
});

/***/ }),
/* 1260 */,
/* 1261 */,
/* 1262 */,
/* 1263 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4",attrs:{"id":"email"}},[_c('div',{staticClass:"clearfix gibson px2 mb2 ml4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 lg-col-5 px0 mb2"},[_c('div',{staticClass:"right-align mb3"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/inbox"}},[_vm._v("Beskeder")])],1),_vm._v(" "),(!_vm.isEmailLoggedIn)?_c('b-form',{model:{value:(_vm.loginForm),callback:function ($$v) {_vm.loginForm=$$v},expression:"loginForm"}},[(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"flex items-center mb2"},[_c('div',{staticClass:"col-9 p0"},[_c('b-form-input',{ref:"loginEmail",staticClass:"h5 p2",attrs:{"placeholder":"E-mail"},model:{value:(_vm.loginEmail),callback:function ($$v) {_vm.loginEmail=$$v},expression:"loginEmail"}})],1),_vm._v(" "),_c('div',{staticClass:"col-3 center p0"},[_c('span',{staticClass:"primarycolor"},[_vm._v(_vm._s(_vm.loginEmailDomain))])])]),_vm._v(" "),_c('b-form-input',{ref:"loginPassword",staticClass:"h5 p2 mb4",attrs:{"type":"password","placeholder":"Password"},model:{value:(_vm.loginPassword),callback:function ($$v) {_vm.loginPassword=$$v},expression:"loginPassword"}}),_vm._v(" "),_c('button',{staticClass:"btn rounded action-button btn-lg col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.login()}}},[_vm._v("\n                Login\n              ")])],1)]):_c('div',{staticClass:"py2"},[(_vm.inputSearchVisible)?_c('div',{staticClass:"mb3"},[_c('b-form-input',{staticClass:"search",attrs:{"placeholder":"Søg email"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1):_vm._e(),_vm._v(" "),_c('el-tabs',{staticClass:"gibson",on:{"tab-click":_vm.tabChanged},model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-tab-pane',{attrs:{"name":"1"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-download mr1"}),_vm._v(" Inbox")]),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"col-12 py2"},[_c('a',{staticClass:"h4 pointer auto-reload",attrs:{"title":"Genindlæs"}},[_c('i',{staticClass:"el-icon-refresh-right mediumgrey",on:{"click":function($event){return _vm.autoReload()}}})]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('div',[_c('input',{staticClass:"mr2",attrs:{"id":"chkbxSelect","type":"checkbox"},on:{"click":function($event){return _vm.checkboxSelectDeselectAll()}}}),_vm._v(" "),_c('span',{staticClass:"mark-as",staticStyle:{"visibility":"hidden"}},[_c('a',{staticClass:"h4 mr2 pointer",attrs:{"title":"Marker som læst"},on:{"click":function($event){return _vm.markAsRead()}}},[_c('i',{staticClass:"far fa-envelope-open mediumgrey"})]),_vm._v(" "),_c('a',{staticClass:"h4 pointer",attrs:{"title":"Marker som ulæst"},on:{"click":function($event){return _vm.markAsUnread()}}},[_c('i',{staticClass:"far fa-envelope mediumgrey"})])])]),_vm._v(" "),_c('div',[_c('el-pagination',{staticClass:"regular",attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1)])]),_vm._v(" "),_vm._l((_vm.emailData['@Collection']),function(mail,index){return _c('div',{key:index,class:'mail-'+mail.Uid+' read-'+mail.IsSeen},[_c('div',{staticClass:"flex flex-column pt2 pb2 border-top muted-border mouse-cursor"},[_c('div',{staticClass:"col-12 flex gibson"},[_c('div',{staticClass:"col-1 p0"},[_c('input',{staticClass:"chkbx",attrs:{"type":"checkbox"},domProps:{"value":mail.Uid},on:{"click":function($event){return _vm.checkboxChanged()}}})]),_vm._v(" "),_c('div',{staticClass:"col-11 flex justify-between items-start p0 pointer",on:{"click":function($event){return _vm.showEmailDetails('inbox', mail.Uid, mail.IsSeen)}}},[_c('div',[(mail.From['@Collection'][0].DisplayName != '')?_c('span',{staticClass:"h6 regular mediumgrey-text line-height-3 m0"},[_vm._v("\n                              "+_vm._s(mail.From['@Collection'][0].DisplayName)+"\n                            ")]):_c('span',{staticClass:"h6 regular mediumgrey-text line-height-3 m0"},[_vm._v("\n                              "+_vm._s(mail.From['@Collection'][0].Email)+"\n                            ")]),_vm._v(" "),(mail.Subject != '')?_c('p',{staticClass:"mediumgrey line-height-3 m0",staticStyle:{"font-size":".875rem"}},[_vm._v(_vm._s(mail.Subject))]):_c('p',{staticClass:"mediumgrey line-height-3 m0",staticStyle:{"font-size":".875rem"}},[_vm._v("No Subject")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h6 regular mediumgrey-text line-height-3"},[_vm._v("\n                              "+_vm._s(_vm.moment(new Date(parseInt(mail.TimeStampInUTC * 1000))).format('Do MMMM YYYY'))+"\n                            ")])])])])])])}),_vm._v(" "),_c('div',{staticClass:"py2 px2"},[_c('span',{staticClass:"mediumgrey"},[_vm._v(_vm._s(_vm.emailMsg))])])],2)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"2"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-upload2 mr1"}),_vm._v(" Sendte")]),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"col-12 py2"},[_c('el-pagination',{staticClass:"regular right-align",attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1),_vm._v(" "),_vm._l((_vm.emailData['@Collection']),function(mail,index){return _c('div',{key:index,class:'mail-'+mail.Uid+' read-'+mail.IsSeen},[_c('div',{staticClass:"flex flex-column pt2 pb2 border-top muted-border mouse-cursor pointer",on:{"click":function($event){return _vm.showEmailDetails('sent', mail.Uid, mail.IsSeen)}}},[_c('div',{staticClass:"col-12 flex justify-between items-start gibson"},[_c('div',[_c('span',{staticClass:"h6 regular mediumgrey-text line-height-3 m0"},[_vm._v("\n                            Me\n                          ")]),_vm._v(" "),(mail.Subject != '')?_c('p',{staticClass:"mediumgrey line-height-3 m0",staticStyle:{"font-size":".875rem"}},[_vm._v(_vm._s(mail.Subject))]):_c('p',{staticClass:"mediumgrey line-height-3 m0",staticStyle:{"font-size":".875rem"}},[_vm._v("No Subject")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h6 regular mediumgrey-text line-height-3"},[_vm._v("\n                            "+_vm._s(_vm.moment(new Date(parseInt(mail.TimeStampInUTC * 1000))).format('Do MMMM YYYY'))+"\n                          ")])])])])])}),_vm._v(" "),_c('div',{staticClass:"py2 px2"},[_c('span',{staticClass:"mediumgrey"},[_vm._v(_vm._s(_vm.emailMsg))])])],2)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"3"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-plus mr1"}),_vm._v(" Komponer")]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"right-align pointer"},[(!_vm.recipientCCVisible)?_c('span',{staticClass:"h6 regular darkblue mr1 mb1",on:{"click":function($event){return _vm.showRecipient('CC')}}},[_vm._v("CC")]):_vm._e(),_vm._v(" "),(!_vm.recipientBCCVisible)?_c('span',{staticClass:"h6 regular darkblue mb1",on:{"click":function($event){return _vm.showRecipient('BCC')}}},[_vm._v("BCC")]):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Til:")])]),_vm._v(" "),_vm._l((_vm.recipientTo),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'to')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientToVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientTo",staticClass:"h5 p2 input-new-to",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('to')},"blur":function($event){return _vm.addRecipient('to')}},model:{value:(_vm.inputRecipientTo),callback:function ($$v) {_vm.inputRecipientTo=$$v},expression:"inputRecipientTo"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('to')}}},[_vm._v("+")])],2),_vm._v(" "),(_vm.recipientCCVisible)?_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("CC:")]),_vm._v(" "),_vm._l((_vm.recipientCC),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'CC')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientCCVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientCC",staticClass:"h5 p2 input-new-cc",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('CC')},"blur":function($event){return _vm.addRecipient('CC')}},model:{value:(_vm.inputRecipientCC),callback:function ($$v) {_vm.inputRecipientCC=$$v},expression:"inputRecipientCC"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('CC')}}},[_vm._v("+")])],2):_vm._e(),_vm._v(" "),(_vm.recipientBCCVisible)?_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("BCC:")]),_vm._v(" "),_vm._l((_vm.recipientBCC),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'BCC')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientBCCVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientBCC",staticClass:"h5 p2 input-new-bcc",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('BCC')},"blur":function($event){return _vm.addRecipient('BCC')}},model:{value:(_vm.inputRecipientBCC),callback:function ($$v) {_vm.inputRecipientBCC=$$v},expression:"inputRecipientBCC"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('BCC')}}},[_vm._v("+")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Emne:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded p2 darkblue h5 gibson",attrs:{"id":"title"},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"}),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Besked","required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"send-btn col-12 action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit"},on:{"click":function($event){return _vm.sendEmail()}}},[_c('span',{staticClass:"regular"},[_vm._v("Send")])])])])],1)]),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"4"}},[_c('span',{attrs:{"slot":"label"},slot:"label"},[_c('i',{staticClass:"el-icon-user mr1"}),_vm._v(" Kontakter")]),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"col-12 p0 py2"},[_c('div',{staticClass:"add-update-contact mb1"},[_c('a',{staticClass:"h5 mr2 pointer",attrs:{"title":"Tilføj kontakt"},on:{"click":function($event){return _vm.showContactForm('add', '')}}},[_c('span',{staticClass:"green"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19.5 15c-2.483 0-4.5 2.015-4.5 4.5s2.017 4.5 4.5 4.5 4.5-2.015 4.5-4.5-2.017-4.5-4.5-4.5zm2.5 5h-2v2h-1v-2h-2v-1h2v-2h1v2h2v1zm-7.18 4h-14.815l-.005-1.241c0-2.52.199-3.975 3.178-4.663 3.365-.777 6.688-1.473 5.09-4.418-4.733-8.729-1.35-13.678 3.732-13.678 6.751 0 7.506 7.595 3.64 13.679-1.292 2.031-2.64 3.63-2.64 5.821 0 1.747.696 3.331 1.82 4.5z"}})])])])]),_vm._v(" "),(_vm.contactsData.ContactCount > 0)?_c('table',{staticClass:"el-table__body col-12 p0"},[_c('thead',{staticClass:"has-gutter"},[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Navn")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("E-mail")])]),_vm._v(" "),_c('tbody',_vm._l((_vm.contactsData.List),function(contacts,index){return _c('tr',{key:index,staticClass:"el-table__row border-top muted-border"},[_c('td',{staticClass:"el-table_1_column_1 mediumgrey-text py2"},[_vm._v(_vm._s(contacts.FullName))]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 mediumgrey-text py2"},[_vm._v(_vm._s(contacts.ViewEmail))]),_vm._v(" "),_c('td',{staticClass:"add-update-contact relative"},[_c('span',{staticClass:"absolute right-0",staticStyle:{"top":"20px"}},[_c('a',{staticClass:"h5 yellow pointer mr1",attrs:{"title":"Opdatering"},on:{"click":function($event){return _vm.showContactForm('update', contacts)}}},[_c('i',{staticClass:"el-icon-edit"})]),_c('a',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDeleteContact(contacts.UUID)}),expression:"{ok: confirmDeleteContact(contacts.UUID)}"}],staticClass:"h5 red pointer",attrs:{"title":"Slet"}},[_c('i',{staticClass:"el-icon-delete"})])])])])}),0)]):_c('div',[_c('span',{staticClass:"mediumgrey"},[_vm._v("Ingen kontakter.")])])])])])],1),_vm._v(" "),(_vm.emailDetailsDialog)?_c('el-dialog',{staticClass:"email-dialog",attrs:{"visible":_vm.emailDetailsDialog,"width":"40%","left":""},on:{"update:visible":function($event){_vm.emailDetailsDialog=$event}}},[(_vm.emailLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"email-content hide"},[_c('div',{staticClass:"left-align mb3"},[(_vm.emailDetailsData.Subject != '')?_c('span',{staticClass:"h2 darkblue block mb2",attrs:{"id":"textSubject"}},[_vm._v(_vm._s(_vm.emailDetailsData.Subject))]):_c('span',{staticClass:"h2 mediumgrey-text block mb2",attrs:{"id":"textSubject"}},[_vm._v("No Subject")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('div',[_c('el-tooltip',{attrs:{"content":_vm.emailDetailsData.From['@Collection'][0].Email,"placement":"bottom","effect":"light","open-delay":500}},[(_vm.emailDetailsData.From['@Collection'][0].DisplayName != '')?_c('span',{staticClass:"h5 darkblue"},[(_vm.emailDetailsData.From['@Collection'][0].Email == _vm.loginEmail)?_c('span',[_vm._v("Me")]):_c('span',[_vm._v(_vm._s(_vm.emailDetailsData.From['@Collection'][0].DisplayName))])]):_c('span',{staticClass:"h5 darkblue"},[(_vm.emailDetailsData.From['@Collection'][0].Email == _vm.loginEmail)?_c('span',[_vm._v("Me")]):_c('span',[_vm._v(_vm._s(_vm.emailDetailsData.From['@Collection'][0].Email))])])])],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"h6 regular mediumgrey-text line-height-3"},[_vm._v("\n                        "+_vm._s(new Intl.DateTimeFormat('en-US', { dateStyle: 'full', timeStyle: 'long' }).format(_vm.emailDetailsData.TimeStampInUTC * 1000).slice(0, -5).replace(' at', ','))+"\n                      ")])])]),_vm._v(" "),_c('p',{staticClass:"recipient mediumgrey mb2"},[_vm._v("to\n                    "),(_vm.emailDetailsData.To != null)?_c('span',{staticClass:"recipient-to"},_vm._l((_vm.emailDetailsData.To['@Collection']),function(mail,index){return (index >= 1)?_c('el-tooltip',{key:index,staticStyle:{"margin-left":"-0.2em"},attrs:{"content":mail.Email,"placement":"bottom","effect":"light","open-delay":500}},[(mail.DisplayName != '')?_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v(", Me")]):_c('span',[_vm._v(", "+_vm._s(mail.DisplayName))])]):_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v(", Me")]):_c('span',[_vm._v(", "+_vm._s(mail.Email))])])]):_vm._l((_vm.emailDetailsData.To['@Collection']),function(mail,index){return _c('el-tooltip',{key:index,attrs:{"content":mail.Email,"placement":"bottom","effect":"light","open-delay":500}},[(mail.DisplayName != '')?_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v("Me")]):_c('span',[_vm._v(_vm._s(mail.DisplayName))])]):_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v("Me")]):_c('span',[_vm._v(_vm._s(mail.Email))])])])})}),1):_vm._e(),_vm._v(" "),(_vm.emailDetailsData.Cc != null)?_c('span',{staticClass:"recipient-cc"},_vm._l((_vm.emailDetailsData.Cc['@Collection']),function(mail,index){return _c('el-tooltip',{key:index,staticStyle:{"margin-left":"-0.2em"},attrs:{"content":mail.Email,"placement":"bottom","effect":"light","open-delay":500}},[(mail.DisplayName != '')?_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v(", Me")]):_c('span',[_vm._v(", "+_vm._s(mail.DisplayName))])]):_c('span',[(mail.Email == _vm.loginEmail)?_c('span',[_vm._v(", Me")]):_c('span',[_vm._v(", "+_vm._s(mail.Email))])])])}),1):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"email-text",domProps:{"innerHTML":_vm._s(_vm.emailDetailsData.HtmlRaw)}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.responseForm)?_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();}}},[_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"right-align pointer"},[(!_vm.recipientCCVisible)?_c('span',{staticClass:"h6 regular darkblue mr1 mb1",on:{"click":function($event){return _vm.showRecipient('CC')}}},[_vm._v("CC")]):_vm._e(),_vm._v(" "),(!_vm.recipientBCCVisible)?_c('span',{staticClass:"h6 regular darkblue mb1",on:{"click":function($event){return _vm.showRecipient('BCC')}}},[_vm._v("BCC")]):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6 darkblue mb1"},[_vm._v("Til:")])]),_vm._v(" "),_vm._l((_vm.recipientTo),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 darkblue regular white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'to')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientToVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientTo",staticClass:"h5 p2 input-new-to",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('to')},"blur":function($event){return _vm.addRecipient('to')}},model:{value:(_vm.inputRecipientTo),callback:function ($$v) {_vm.inputRecipientTo=$$v},expression:"inputRecipientTo"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('to')}}},[_vm._v("+")])],2),_vm._v(" "),(_vm.recipientCCVisible)?_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"h6 darkblue mb1"},[_vm._v("CC:")]),_vm._v(" "),_vm._l((_vm.recipientCC),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 darkblue regular white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'CC')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientCCVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientCC",staticClass:"h5 p2 input-new-cc",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('CC')},"blur":function($event){return _vm.addRecipient('CC')}},model:{value:(_vm.inputRecipientCC),callback:function ($$v) {_vm.inputRecipientCC=$$v},expression:"inputRecipientCC"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('CC')}}},[_vm._v("+")])],2):_vm._e(),_vm._v(" "),(_vm.recipientBCCVisible)?_c('div',{staticClass:"mb3"},[_c('div',{staticClass:"h6 darkblue mb1"},[_vm._v("BCC:")]),_vm._v(" "),_vm._l((_vm.recipientBCC),function(recipient,index){return _c('el-tag',{key:index,staticClass:"h6 white-background mr1",attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeRecipient(recipient, 'BCC')}}},[_c('span',[_vm._v(_vm._s(recipient))])])}),_vm._v(" "),(_vm.inputRecipientBCCVisible)?_c('div',[_c('b-form-input',{ref:"saveRecipientBCC",staticClass:"h5 p2 input-new-bcc",attrs:{"list":"contactList","autocomplete":"off"},on:{"change":function($event){return _vm.addRecipient('BCC')},"blur":function($event){return _vm.addRecipient('BCC')}},model:{value:(_vm.inputRecipientBCC),callback:function ($$v) {_vm.inputRecipientBCC=$$v},expression:"inputRecipientBCC"}}),_vm._v(" "),_c('datalist',{attrs:{"id":"contactList"}},_vm._l((_vm.contactsData.List),function(contact){return _c('option',[_vm._v(_vm._s(contact.ViewEmail))])}),0)],1):_c('b-button',{staticClass:"border circle darkblue white-background button-new-tag",staticStyle:{"width":"40px","height":"40px"},on:{"click":function($event){return _vm.showInputRecipient('BCC')}}},[_vm._v("+")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"}),_vm._v(" "),_c('wysiwyg',{ref:"test",attrs:{"placeholder":"Besked"},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1)])]):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer flex justify-between",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{},[(_vm.buttonResponseVisible)?_c('div',[_c('b-btn',{staticClass:"rounded mr1",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.showReplyEmail('reply', _vm.emailDetailsData)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"}})])]),_vm._v("Reply\n                      ")]),_vm._v(" "),(_vm.emailDetailsData.Cc != null)?_c('b-btn',{staticClass:"rounded mr1",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.showReplyEmail('replyAll', _vm.emailDetailsData)}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"}})])]),_vm._v("Reply Alle\n                      ")]):_vm._e(),_vm._v(" "),(_vm.emailDetailsData.Cc != null)?_c('b-btn',{staticClass:"rounded",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.showReplyEmail('forward', _vm.emailDetailsData)}}},[_c('span',{staticClass:"mr2"},[_vm._v("<"),_c('i',{staticClass:"el-icon-share"})]),_vm._v("Frem\n                      ")]):_c('b-btn',{staticClass:"rounded",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.showReplyEmail('forward', _vm.emailDetailsData)}}},[_c('span',{staticClass:"mr2"},[_vm._v("<"),_c('i',{staticClass:"el-icon-share"})]),_vm._v("Frem\n                      ")])],1):_c('b-btn',{staticClass:"send-btn action-button rounded",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.sendEmail()}}},[_vm._v("Send\n                    ")])],1),_vm._v(" "),_c('div',{},[_c('b-btn',{staticClass:"standard-button rounded",attrs:{"type":"buttom","variant":"secondary","size":"lg"},on:{"click":_vm.closeEmailDetails}},[_vm._v("\n                      Luk\n                    ")])],1)])])]):_vm._e(),_vm._v(" "),(_vm.emailLoadingDialog)?_c('el-dialog',{staticClass:"email-dialog",attrs:{"visible":_vm.emailLoadingDialog,"width":"40%","left":""},on:{"update:visible":function($event){_vm.emailLoadingDialog=$event}}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])])]):_vm._e(),_vm._v(" "),(_vm.contactsAddFormDialog)?_c('el-dialog',{staticClass:"contact-dialog",attrs:{"title":"Tilføj kontakt","visible":_vm.contactsAddFormDialog,"width":"40%","left":""},on:{"update:visible":function($event){_vm.contactsAddFormDialog=$event}}},[_c('div',[_c('b-form',{model:{value:(_vm.contactForm),callback:function ($$v) {_vm.contactForm=$$v},expression:"contactForm"}},[_c('div',{staticClass:"mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Navn:")]),_vm._v(" "),_c('b-form-input',{staticClass:"h5 p2",model:{value:(_vm.contactName),callback:function ($$v) {_vm.contactName=$$v},expression:"contactName"}})],1),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("E-mail:")]),_vm._v(" "),_c('b-form-input',{staticClass:"h5 p2",model:{value:(_vm.contactEmail),callback:function ($$v) {_vm.contactEmail=$$v},expression:"contactEmail"}})],1)])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer flex justify-between",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{},[_c('b-btn',{staticClass:"send-btn action-button rounded",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.addContact()}}},[_vm._v("Tilføje\n                  ")])],1),_vm._v(" "),_c('div',{},[_c('b-btn',{staticClass:"standard-button rounded",attrs:{"type":"buttom","variant":"secondary","size":"lg"},on:{"click":function($event){return _vm.closeContactForm('add')}}},[_vm._v("\n                    Luk\n                  ")])],1)])]):_vm._e(),_vm._v(" "),(_vm.contactsUpdateFormDialog)?_c('el-dialog',{staticClass:"contact-dialog",attrs:{"title":"Opdater kontakt","visible":_vm.contactsUpdateFormDialog,"width":"40%","left":""},on:{"update:visible":function($event){_vm.contactsUpdateFormDialog=$event}}},[_c('div',[_c('b-form',{model:{value:(_vm.contactForm),callback:function ($$v) {_vm.contactForm=$$v},expression:"contactForm"}},[_c('div',{staticClass:"mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Navn:")]),_vm._v(" "),_c('b-form-input',{staticClass:"h5 p2",model:{value:(_vm.contactName),callback:function ($$v) {_vm.contactName=$$v},expression:"contactName"}})],1),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('span',{staticClass:"h5 regular darkblue mb1"},[_vm._v("E-mail:")]),_vm._v(" "),_c('b-form-input',{staticClass:"h5 p2",model:{value:(_vm.contactEmail),callback:function ($$v) {_vm.contactEmail=$$v},expression:"contactEmail"}})],1)])],1),_vm._v(" "),_c('span',{staticClass:"dialog-footer flex justify-between",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{},[_c('b-btn',{staticClass:"send-btn action-button rounded",attrs:{"type":"button","variant":"success","size":"lg"},on:{"click":function($event){return _vm.updateContact()}}},[_vm._v("Opdatering\n                  ")])],1),_vm._v(" "),_c('div',{},[_c('b-btn',{staticClass:"standard-button rounded",attrs:{"type":"buttom","variant":"secondary","size":"lg"},on:{"click":function($event){return _vm.closeContactForm('update')}}},[_vm._v("\n                    Luk\n                  ")])],1)])]):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("E-mail")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1264 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__ = __webpack_require__(1265);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f449f1de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__ = __webpack_require__(1266);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Chat_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f449f1de_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Chat_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1265 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__CreditcheckList__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__Message__["a" /* default */],
    creditchecklist: __WEBPACK_IMPORTED_MODULE_1__CreditcheckList__["a" /* default */],
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  created: function created() {
    this.Reload();
  },
  data: function data() {
    return {
      emails: [],
      sends: [],
      starMessage: '',
      url: '',
      load: 0,
      cid: '',
      message: '',
      email: '',
      emailShow: false,
      showDismissibleAlert: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading..'
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.cid = this.$route.query.id;
      var data = { operation: 'oversigt_chat', cid: this.cid, salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.url = 'https://www.kundematch.dk/newchat/?user=' + res.user + '&token=' + res.token + '&dialog=' + res.dialog;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1266 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text pb-0"},[_c('div',{staticClass:"d-flex flex-row justify-content-start"},[_c('div',{staticClass:"text-dark mr-3"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M24 1h-24v16.981h4v5.019l7-5.019h13z"}})])]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Chat")])])])]),_vm._v(" "),_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('div',{staticStyle:{"overflow":"scroll !important","-webkit-overflow-scrolling":"touch !important"}},[_c('b-embed',{staticStyle:{"-webkit-overflow-scrolling":"touch","overflow-y":"scroll","min-height":"700px","min-width":"100%","height":"800px"},attrs:{"type":"iframe","src":_vm.url}})],1)])])],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jule_vue__ = __webpack_require__(1269);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acbcd9d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_jule_vue__ = __webpack_require__(1270);
function injectStyle (ssrContext) {
  __webpack_require__(1268)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_jule_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1acbcd9d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_jule_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1268 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1269 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'jule',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    Vue: __WEBPACK_IMPORTED_MODULE_4_vue__["default"],
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_3__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: ''
      },
      customers: []
    };
  },

  watch: {
    imgPicked: function imgPicked(newVal, oldVal) {
      this.url = 'https://www.kundematch.dk/newpartner/jule.php?salesPerson=' + this.salesPerson + '&levid=' + this.haaId + '&img=' + this.imgPicked;
    }
  },
  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.images = res.resultImages;
        if (_this.images.length !== 0) {
          _this.imgPicked = _this.images[0].FileLocation;
        }
        _this.url = 'https://www.kundematch.dk/newpartner/jule.php?salesPerson=' + _this.salesPerson + '&levid=' + _this.haaId + '&img=' + _this.imgPicked;
      }, function (response) {
        alert('error');
      });
    },
    service_jule_action: function service_jule_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'service_jule_action', salesPerson: this.salesPerson, levid: this.haaId, customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customers), imgPicked: this.imgPicked, bcc: this.consent };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Dit elektroniske julekort er nu sendt til dine kunder.',
            type: 'success'
          };
          _this2.customers = [];
          _this2.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, _this2.customer));
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    addCustomer: function addCustomer() {
      this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    },
    delCustomer: function delCustomer(index) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].delete(this.customers, index);
    }
  },
  created: function created() {
    this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    this.Reload();
  }
});

/***/ }),
/* 1270 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"min-height":"900px","display":"flex","flex-flow":"column","height":"100%"}},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-success headericon"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Elektronisk julekort")])]),_vm._v(" "),_c('div',{staticClass:"pt-0 pr-1 pl-1 open-sans line-height-golden h5"},[_vm._v("\n              Som noget helt nyt, kan vi hjælpe dig med at ønske dine kunder en glædelig jul. Udfyld blot dine kunders navn og e-mails herunder, og klik på \"send elektronisk julekort\".\n            ")])])])],1)],1)],1),_vm._v(" "),_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',{staticClass:"d-flex justify-content-start align-items-stretch bg-white h-100",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_jule_action.apply(null, arguments)}}},[_c('b-form-row',[_c('b-col',[_c('div',{staticClass:"h5 font-weight-bold headerfont mb-3 text-dark"},[_vm._v("Tilføj kundens navn og e-mail her")])])],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_vm._l((_vm.customers),function(customer,index){return _c('b-form-row',{key:index},[_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label":"Navn"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"text","name":"customers[][name]","required":""},model:{value:(customer.name),callback:function ($$v) {_vm.$set(customer, "name", $$v)},expression:"customer.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"5"}},[_c('b-form-group',{attrs:{"label":"E-mail"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"email","name":"customers[][email]","required":""},model:{value:(customer.email),callback:function ($$v) {_vm.$set(customer, "email", $$v)},expression:"customer.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"cols":"2"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),(index !== 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.delCustomer(index)}}},[_c('span',{staticClass:"far fa-trash-alt"})]):_vm._e(),_vm._v(" "),(index === 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{staticClass:"el-icon-circle-plus"})]):_vm._e()],1)],1)}),_vm._v(" "),(_vm.images.length !== 0)?_c('b-form-row',[_c('div',[_c('b-alert',{staticClass:"sm",attrs:{"show":"","variant":"secondary","size":"sm"}},[_vm._v("\n                    Når du har valgt et billede kan du med fordel sende en test til din egen e-mail. Så er du sikker på at billedet passer i formatet.\n                  ")]),_vm._v(" "),_c('b-btn',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse1",modifiers:{"collapse1":true}}],staticClass:"m-1",attrs:{"variant":"primary"}},[_vm._v("Vælg billede")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"collapse1"}},[_c('b-card',[_c('b-row',_vm._l((_vm.images),function(image){return _c('b-col',{key:image.ImageId,attrs:{"lg":"3","md":"3","sm":"12"}},[_c('label',{staticClass:"h6 font-weight-normal m-0",attrs:{"label":"","for":image.FileLocation}},[_c('b-card',{staticClass:"border-0",attrs:{"img-src":image.FileLocation,"img-alt":"Profil","img-top":"","bg-variant":"light"}},[_c('div',{staticClass:"d-flex justify-content-between justify-content-center"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.imgPicked),expression:"imgPicked"}],staticClass:"radion_select mr-1",attrs:{"type":"radio","id":image.FileLocation},domProps:{"value":image.FileLocation,"checked":_vm._q(_vm.imgPicked,image.FileLocation)},on:{"change":function($event){_vm.imgPicked=image.FileLocation}}}),_vm._v("\n                                  Billede "+_vm._s(image.ImageOrder)+"\n                                ")])])])],1)])}),1)],1)],1)],1)]):_vm._e(),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"py-4 "},[_c('b-form-group',{attrs:{"label":"","label-for":"consentInput"}},[_c('b-form-checkbox',{attrs:{"id":"consentInput","value":"1","unchecked-value":"0"},model:{value:(_vm.consent),callback:function ($$v) {_vm.consent=$$v},expression:"consent"}},[_c('span',{staticClass:"text-secondary"},[_vm._v("Send mig en kopi af det afsendte julekort.")])])],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"py-0 pr-5 ",attrs:{"sm":"12"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded",attrs:{"size":"lg","type":"submit","variant":"success"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"}})])]),_vm._v("\n                      Send elektronisk julekort\n                    ")])],1)])],1)],2)],1)])],1),_vm._v(" "),_c('b-col',{attrs:{"align-v":"center","sm":"12","md":"6","lg":"6"}},[_c('b-card',{staticClass:"border-0",staticStyle:{"height":"800px"}},[_c('div',{staticClass:"card-text"},[_c('div',{staticStyle:{"overflow":"scroll !important","-webkit-overflow-scrolling":"touch !important"}},[_c('b-embed',{staticStyle:{"-webkit-overflow-scrolling":"touch","overflow-y":"scroll"},attrs:{"type":"iframe","src":_vm.url,"aspect":"1by1","height":"800px"}})],1)])])],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1271 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invite_vue__ = __webpack_require__(1273);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a27c3c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_invite_vue__ = __webpack_require__(1274);
function injectStyle (ssrContext) {
  __webpack_require__(1272)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_invite_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_24a27c3c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_invite_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1272 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'jule',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_3__haandvaerker__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    Vue: __WEBPACK_IMPORTED_MODULE_4_vue__["default"]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: '',
        mobile: ''
      },
      customers: []
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.images = res.resultImages;
        if (_this.images.length !== 0) {
          _this.imgPicked = _this.images[0].FileLocation;
        }
      }, function (response) {
        alert('error');
      });
    },
    service_jule_action: function service_jule_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'service_invite_action', salesPerson: this.salesPerson, levid: this.haaId, customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customers), imgPicked: this.imgPicked, bcc: this.consent };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.customers = [];
          _this2.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, _this2.customer));
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    addCustomer: function addCustomer() {
      this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    },
    delCustomer: function delCustomer(index) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].delete(this.customers, index);
    }
  },
  created: function created() {
    this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    this.Reload();
  }
});

/***/ }),
/* 1274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"min-height":"900px","display":"flex","flex-flow":"column","height":"100%"}},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('div',{staticClass:"d-flex flex-row justify-content-start py-2 py-lg-2 py-md-2"},[_c('div',{staticClass:"text-dark mr-3"},[_c('i',{staticClass:"el-icon-success headericon"})]),_vm._v(" "),_c('div',{staticClass:"h4 font-weight-bold text-dark"},[_vm._v("Indhent flere anbefalinger")])]),_vm._v(" "),_c('div',{staticClass:"pt-0 pr-1 pl-1 open-sans line-height-golden h5"},[_vm._v("\n                Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere."),_c('br'),_c('br'),_vm._v("Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket."),_c('br'),_c('br'),_vm._v("Der er ikke begrænsning på antallet af kunder, som du kan sende til.\n            ")])])])],1)],1)],1),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',{staticClass:"d-flex justify-content-start align-items-stretch bg-white h-100",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('b-card',{staticClass:"border-0"},[_c('div',{staticClass:"card-text"},[_c('b-form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_jule_action.apply(null, arguments)}}},[_c('b-form-row',[_c('b-col',[_c('div',{staticClass:"h5 font-weight-bold headerfont mb-3 text-dark"},[_vm._v("Tilføj kundens navn og e-mail eller mobil her")])])],1),_vm._v(" "),_c('div',{staticClass:"py-2"}),_vm._v(" "),_vm._l((_vm.customers),function(customer,index){return _c('b-form-row',{key:index},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Navn"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"text","name":"customers[][name]","required":""},model:{value:(customer.name),callback:function ($$v) {_vm.$set(customer, "name", $$v)},expression:"customer.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"E-mail"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"email","name":"customers[][email]"},model:{value:(customer.email),callback:function ($$v) {_vm.$set(customer, "email", $$v)},expression:"customer.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Mobil"}},[_c('b-form-input',{staticClass:"rounded",attrs:{"type":"tel","name":"customers[][mobile]"},model:{value:(customer.mobile),callback:function ($$v) {_vm.$set(customer, "mobile", $$v)},expression:"customer.mobile"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"2"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),(index !== 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.delCustomer(index)}}},[_c('span',{staticClass:"far fa-trash-alt"})]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"rounded ml-2",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{staticClass:"el-icon-circle-plus"})]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"8"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded flex justify-center items-center",attrs:{"size":"lg","type":"submit","variant":"success"}},[_c('span',{staticClass:"mr2"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_vm._v(" Send\n                        ")])],1)])],2)],1)])],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36eb31d0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(1277);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_36eb31d0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ProjectPassword',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a
  },
  data: function data() {
    return {
      form: {
        username: '',
        password: '',
        errorMessage: ''
      },
      user: {
        name: '',
        token: '',
        role: ''
      },
      show: false,
      label: '',
      overlay: false
    };
  },
  created: function created() {},

  methods: {
    onSubmit: function onSubmit(evt) {
      var _this = this;

      evt.preventDefault();
      this.show = true;

      var data = { operation: 'forgot', userName: this.form.username };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this.show = false;
        var res = response.body;
        if (res === '1') {
          _this.form.errorMessage = 'logindata vil sende til din email-adresse!';
          _this.form.username = '';
        } else if (res === '1') {
          _this.form.errorMessage = 'Partner ikke fundet';
        } else if (res === '2') {
          _this.form.username = '';
          _this.form.errorMessage = 'E-mail ikke sendt !';
        }
      }, function (response) {
        alert('error');
      });
    },
    forgotPassword: function forgotPassword(evt) {
      this.$router.push('/glemte-password');
    }
  }
});

/***/ }),
/* 1277 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"max-width-1 mx-auto mt4"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"lightgrey-background",staticStyle:{"padding":"0.3rem"}},[_c('form',{on:{"submit":_vm.onSubmit}},[_c('div',{staticClass:"border white-background mediumgrey-border py2 px2"},[_c('div',[_c('label',[_vm._v("Email")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.form.username),expression:"form.username"}],staticClass:"h6 regular not-rounded border mediumgrey-border p2 darkblue col-12 line-height-1 light-highlights",attrs:{"id":"email","type":"email","required":"","autocomplete":"username"},domProps:{"value":(_vm.form.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.form, "username", $event.target.value)}}})]),_vm._v(" "),(_vm.form.errorMessage)?_c('div',{staticClass:"border red-border red white-background p2"},[_c('div',{staticClass:"h6"},[_vm._v(_vm._s(_vm.form.errorMessage))])]):_vm._e()]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',[_c('loading',{staticClass:"loading-wrap",attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}})],1)])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-end items-end mb4 right-align"},[_c('a',{staticClass:"h6 gibson inline-block primarycolor right-align",attrs:{"href":"#/login"}},[_vm._v("Tilbage")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 mb2"},[_c('div',{staticClass:"flex justify-start items-center"},[_c('img',{staticClass:"inline-block",attrs:{"src":"/static/svg/h.svg","alt":"","height":"36"}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue semi-bold gibson line-height-1 pl2 mb0"},[_vm._v("Håndværker.dk")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h2 mt3 mb1 gibson line-height-golden semi-bold darkblue"},[_vm._v("Glemte dit password?")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 mt3 mb1 gibson line-height-golden semi-bold darkblue"},[_vm._v("Indtast din email og klik på \"Send\" og vil vil emaile din adgangskode.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my2 lightgrey-background px2"},[_c('button',{staticClass:"h5 block col-12 action-button p2 gibson border-none not-rounded",attrs:{"type":"submit","id":"formLogin"}},[_c('span',[_vm._v("Send logindata")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1278 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsfeed_vue__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2bd54ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Newsfeed_vue__ = __webpack_require__(1281);
function injectStyle (ssrContext) {
  __webpack_require__(1279)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Newsfeed_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c2bd54ac_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Newsfeed_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1279 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Message__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__ = __webpack_require__(56);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_0__Message__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_2__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      news: [],
      logs: [],

      prisenurl: '',
      months: [],
      otherNews: [],
      reminder: [],
      showDismissibleAlert: false,
      starMessage: '',
      partnerName: '',
      url: '',
      showHaandvearker: false,
      showImentor: false,
      messages: [],
      loading: true,
      nps: '',
      prisenRegion: '',
      dialogPrisenVisible: true,
      dialogPrisenButtonClicked: false,
      disabledPrisenButton: false,
      prisenParticipant: '',
      disabledPrisenRadio: false,
      partnerzipcode: ''
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.getBadges();
    this.Reload();
    this.getPartnerZip();
    this.partnerName = localStorage.getItem('name');

    setTimeout(function () {
      var maketplace = document.querySelector('#dropMarkedsplads');
      maketplace.addEventListener('click', function () {
        window.location.replace('#/markedsplads');
      });
    }, 500);

    setTimeout(function () {
      var webshopMenu = document.querySelector('#dropWebshop');
      webshopMenu.addEventListener('click', function () {
        window.location.replace('#/webshop/overview');
      });
    }, 500);

    if (this.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
      setTimeout(function () {
        if (document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard') !== null) {
          document.querySelector('ul.nav-dropdown-items li#customer-projects\\/project-dashboard').classList.add('hide');
        }
      }, 300);
    }
    if (this.$bitrixapi !== 'https://bitrixapidev.haandvaerker.dk/v1/') {
      setTimeout(function () {
        document.getElementById('anbefalinger-sammendrag').classList.add('hide');
      }, 300);
    }

    if (localStorage.getItem('isshop') === 'false') {
      setTimeout(function () {
        document.getElementById('dropWebshop').classList.add('hide');
      }, 300);
    }

    var opgaveInvitationer = document.getElementById('opgaveinvitationer');
    if (opgaveInvitationer) {
      if (localStorage.getItem('isjobInvited') === 'false' || localStorage.getItem('showAddendum') !== 'true') {
        setTimeout(function () {
          opgaveInvitationer.classList.add('hide');
        }, 300);
      }
    }

    if (localStorage.getItem('PartnerLoginUdbudJobs') === 'false') {
      setTimeout(function () {
        document.getElementById('offentlige-udbud').classList.add('hide');
      }, 300);
    }

    var Addendum = document.querySelector('#dropArbejdsseddel');
    if (Addendum) {
      if (localStorage.getItem('showAddendum') === 'true') {
        Addendum.classList.remove('hide');
      } else {
        Addendum.classList.add('hide');
      }
    }
  },

  computed: {
    getNews: function getNews() {
      return this.news.filter(function (value) {
        return value.prisen === '0';
      });
    },
    getPrisen: function getPrisen() {
      return this.news.filter(function (value) {
        return value.prisen === '1';
      });
    }
  },
  mounted: function mounted() {
    this.checkBadges();
  },

  methods: {
    hideshop: function hideshop() {
      document.getElementById('dropWebshop').classList.add('hide');
    },
    checkBadges: function checkBadges() {
      if (localStorage.getItem('showbadgewebshop') === 'yes') {
        document.querySelector('a[href="#/badges"]').classList.remove('hide');
      } else {
        document.querySelector('a[href="#/badges"]').classList.add('hide');
      }
    },
    getBadges: function getBadges() {
      var _this = this;

      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var badgesList = res.Badges;
        localStorage.setItem('zipcode', res.Profile.Zipcode);
        _this.partnerzipcode = res.Profile.Zipcode;

        var filteredBadges = badgesList.filter(function (property) {
          return property['Industry'] !== null;
        });
        if (filteredBadges.length === 0) {
          localStorage.setItem('showbadgewebshop', 'no');
          _this.hideshop();
        } else {
          localStorage.setItem('showbadgewebshop', 'yes');
        }
      }, function (err) {
        console.log('Error in getBadgesCount()', err);
      });
    },
    Reload: function Reload() {
      var _this2 = this;

      if (localStorage.getItem('haaid') !== '0') {
        this.showHaandvearker = true;
      }
      if (localStorage.getItem('imentor') !== '0') {
        this.showImentor = true;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'newsFeed', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.loading = false;
        _this2.messages = res.resultMessage;
        if (res.resultMessage.length === 0) _this2.showDismissibleAlert = true;
        _this2.news = res.resultNews;
        _this2.reminder = res.reminder;
        _this2.logs = res.logs;
        _this2.months = res.months;
        _this2.otherNews = res.otherNews;

        _this2.url = 'https://www.haandvaerker.dk/profil/firma/x/' + _this2.haaId;
        _this2.nps = parseInt(res.nps);
      }, function (response) {
        alert('error');
      });
      this.cid = this.$route.query.id;
    },
    showMeetingReminder: function showMeetingReminder(item) {
      this.$router.push('/inbox?email=' + item.id);
    },
    showItemDetails: function showItemDetails(email) {
      this.$router.push('/inbox?email=' + email.id);
    },
    recommend: function recommend() {
      this.$router.push('/recommend');
    },
    getPartnerZip: function getPartnerZip() {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        localStorage.setItem('CompanyZip', res.Postnr);
        localStorage.setItem('PartnerTelefon', res.Telefon);
        localStorage.setItem('Cvrnr', res.Cvrnr);
      }, function (response) {
        alert('error');
      });
    },
    showPrisenModal: function showPrisenModal() {
      this.$refs['prisen-modal'].show();
    },
    hidePrisenModal: function hidePrisenModal() {
      this.$refs['prisen-modal'].hide();
    },
    checkPrisen: function checkPrisen() {
      var _this3 = this;

      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/find/region?zipCode=' + this.partnerzipcode, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        _this3.prisenurl = res.data.PRISEN_URL;
        _this3.prisenRegion = res.data.PRISE_REGION;
      }, function (response) {
        console.log('Error in checkPrisen()', response);
      });
    },
    registerPrisen: function registerPrisen() {
      var _this4 = this;

      this.disabledPrisenButton = true;
      var data = {
        operation: 'register_prisen',
        salesPerson: this.salesPerson,
        type: 'POST'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.dialogPrisenButtonClicked = true;
          _this4.disabledPrisenButton = false;
        }
      }, function (response) {
        console.log('Error in registerPrisen()', response);
      });
    },
    submitRegister: function submitRegister() {
      var _this5 = this;

      this.disabledPrisenRadio = true;
      var data = {
        operation: 'total_prisen',
        total: this.prisenParticipant,
        salesPerson: this.salesPerson,
        type: 'POST'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.hidePrisenModal();
          _this5.disabledPrisenRadio = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this5.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        console.log('Error in submitRegister()', response);
      });
    }
  }
});

/***/ }),
/* 1281 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"clearfix gibson px2 pt3"},[_c('div',{staticClass:"px2 pointer mr1 relative"},[_vm._v("\n      Velkommen, "+_vm._s(_vm.partnerName)+"\n    ")]),_vm._v(" "),(_vm.reminder.length !== 0)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"flex justify-start items-start border muted-border py3 p2 mb2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 mb0 gibson semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr2 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"}})])]),_c('g',[_c('g',[_c('path',{attrs:{"d":"m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"}})])]),_c('path',{attrs:{"d":"m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"}})])])])]),_vm._v(" "),_c('span',[_vm._v("Påmindelser")])]),_vm._v(" "),_vm._l((_vm.reminder),function(item){return _c('div',{key:item.id,staticClass:"flex justify-start items-start px2 py1 mt2 darkblue muted-background"},[_c('a',{staticClass:"darkblue no-hover",attrs:{"href":""}},[_c('div',{staticClass:"flex justify-start items-start"},[_c('div',{staticClass:"flex-auto"},[(item.pass === 0)?_c('span',{staticClass:"inline-block mr1 green-background",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):_vm._e(),_vm._v(" "),(item.pass === 1)?_c('span',{staticClass:"inline-block mr1 red-background",staticStyle:{"height":"10px","width":"10px","border-radius":"50%"}}):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-2 pt1 flex justify-between items-center"},[_c('span',{staticClass:"semi-bold m0 p0 line-height-2 block"},[_c('a',{attrs:{"href":'#/alle-moeder?mobile=' + item.mobile}},[_c('span',{staticClass:"block"},[_vm._v(_vm._s(_vm.moment(item.date_reminder).locale('da').format('LL H:mm')))])]),_vm._v(" "),_c('span',{staticClass:"h5 block regular mb0"},[_vm._v(_vm._s(item.descp))]),_vm._v(" "),_c('span',{staticClass:"h6 regular mb0"},[_vm._v(_vm._s(item.contact_name))])])])])])])})],2)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px1 py2"},[_c('div',{staticClass:"border muted-border py3 p2 mb3 shadow"},[_c('div',{staticClass:"col-15 px2"},[_c('p',{staticClass:"h4 mb2 gibson semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M502 492h-34V282c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v210h-84V20h84v173.5c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H354c-5.5 0-10 4.5-10 10v482h-26.3V138c0-5.5-4.5-10-10-10h-104c-5.5 0-10 4.5-10 10v140.2c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V148h84v344h-84V361c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v131H168V256c0-5.5-4.5-10-10-10H54c-5.5 0-10 4.5-10 10v236H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h492c5.5 0 10-4.5 10-10S507.5 492 502 492zM148 492H64V266h84V492z"}}),_c('path',{attrs:{"d":"M465.1 230.6c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S466.9 232.5 465.1 230.6z"}}),_c('path',{attrs:{"d":"M210.8 312.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9s-2.9 4.4-2.9 7.1 1.1 5.2 2.9 7.1c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S212.7 314.8 210.8 312.9z"}})])]),_vm._v(" "),_c('span',[_vm._v("Statistik")])]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',[_c('table',{staticClass:"mb2"},[(_vm.logs.TotalProfileView !== 0)?_c('tr',{staticClass:"darkblue h5 white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalProfileView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Profil visninger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalRatingInTimePeriod !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalRatingInTimePeriod))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Nye anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalPhoneView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalPhoneView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opkald til dig")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalHtJob !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalHtJob))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opgave fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalHtPhone !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalHtPhone))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opkald fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalCommentView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalCommentView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Anbefalinger læst")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalProjectView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalProjectView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Projekt visninger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalLikeanbefalinger !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalLikeanbefalinger))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Likes på anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.Shared !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.Shared))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Profil-delinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalFavorite !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalFavorite))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Kunder der har gemt din profil")])]):_vm._e()]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-golden gibson mb2"},[_vm._v("(Seneste 3 mdr.) ")]),_vm._v(" "),_c('a',{attrs:{"href":_vm.url,"target":"_blank"}},[_c('p',{staticClass:"h6 gibson semi-bold"},[_vm._v("Se din profil herdd")])])])])]),_vm._v(" "),(_vm.nps >= 9)?_c('button',{staticClass:"col-12 action-button p2 gibson h5 regular",on:{"click":function($event){return _vm.recommend()}}},[_c('span',[_vm._v("Anbefal os og få et tivolikort")]),_vm._v(" "),_vm._m(2)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.getNews.length !== 0)?_c('div',{staticClass:"col-12 px2 py2"},[_c('div',{staticClass:"flex justify-start items-start border muted-border pt3 pb4 p2 shadow"},[_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h3 darkblue mb2 gibson semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","viewBox":"0 0 512.00061 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m412 136c0 5.519531 4.480469 10 10 10s10-4.480469 10-10-4.480469-10-10-10-10 4.480469-10 10zm0 0"}}),_c('path',{attrs:{"d":"m452 256c0 12.808594-1.285156 25.59375-3.816406 38-1.105469 5.410156 2.386718 10.691406 7.796875 11.796875.675781.140625 1.347656.207031 2.011719.207031 4.652343 0 8.820312-3.269531 9.789062-8.003906 2.800781-13.722656 4.21875-27.851562 4.21875-42 0-31.488281-6.828125-61.789062-20.300781-90.0625-2.375-4.984375-8.339844-7.101562-13.328125-4.726562-4.988282 2.375-7.101563 8.34375-4.726563 13.332031 12.179688 25.5625 18.355469 52.96875 18.355469 81.457031zm0 0"}}),_c('path',{attrs:{"d":"m306 346h-10v-130c0-5.523438-4.476562-10-10-10h-80c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h10v80h-10c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h100c5.523438 0 10-4.476562 10-10v-40c0-5.523438-4.476562-10-10-10zm-10 40h-80v-20h10c5.523438 0 10-4.476562 10-10v-100c0-5.523438-4.476562-10-10-10h-10v-20h60v130c0 5.523438 4.480469 10 10 10h10zm0 0"}}),_c('path',{attrs:{"d":"m256 186c22.054688 0 40-17.945312 40-40s-17.945312-40-40-40-40 17.945312-40 40 17.945312 40 40 40zm0-60c11.027344 0 20 8.972656 20 20s-8.972656 20-20 20-20-8.972656-20-20 8.972656-20 20-20zm0 0"}}),_c('path',{attrs:{"d":"m256 0c-137.976562 0-256 117.800781-256 256 0 47.207031 13.527344 97.410156 36.335938 135.382812l-35.824219 107.457032c-1.195313 3.589844-.261719 7.554687 2.417969 10.230468 2.691406 2.691407 6.660156 3.609376 10.234374 2.414063l107.457032-35.820313c37.96875 22.8125 88.171875 36.335938 135.378906 36.335938 138.011719 0 256-117.816406 256-256 0-138.011719-117.8125-256-256-256zm0 492c-45.285156 0-93.417969-13.363281-128.757812-35.746094-2.503907-1.585937-5.625-2.003906-8.515626-1.039062l-92.914062 30.972656 30.972656-92.914062c.953125-2.851563.570313-5.976563-1.039062-8.515626-22.382813-35.335937-35.746094-83.472656-35.746094-128.757812 0-127.925781 108.074219-236 236-236s236 108.074219 236 236-108.074219 236-236 236zm0 0"}})])]),_vm._v(" "),_c('span',[_vm._v("Nyheder")])]),_vm._v(" "),[(_vm.news.length !== 0)?_c('div',_vm._l((_vm.news),function(item){return (item.prisen === '0')?_c('div',{key:item.id,staticClass:"mt3"},[_c('span',{staticClass:"h5 gibson semi-bold primarycolor line-height-1 mb1 block"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"gibson h6 darkblue regular mb2 flex justify-start items-center"},[_c('span',[_c('svg',{staticClass:"jam jam-clock",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"}})])]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v(_vm._s(_vm.moment(item.timenews).locale('da').format('LL H:mm')))])]),_vm._v(" "),_c('span',{staticClass:"h5 darkblue regular line-height-golden gibson",domProps:{"innerHTML":_vm._s(item.description)}})]):_vm._e()}),0):_c('div',[_c('p',{staticClass:"h5 regular darkblue gibson line-height-4"},[_vm._v("\n                Ingen nyheder.\n              ")])])]],2)])]):_vm._e(),_vm._v(" "),(_vm.getPrisen.length !== 0)?_c('div',{staticClass:"col-12 px2 py2"},[_c('div',{staticClass:"flex justify-start items-start border muted-border pt3 pb4 p2 shadow"},[_c('div',{staticClass:"px2"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.news),function(item){return (item.prisen === '1')?_c('div',{key:item.id,staticClass:"mt3"},[_c('span',{staticClass:"h5 gibson semi-bold primarycolor line-height-1 mb1 block"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"gibson h6 darkblue regular mb2 flex justify-start items-center"},[_c('span',[_c('svg',{staticClass:"jam jam-clock",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"}})])]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v(_vm._s(_vm.moment(item.timenews).locale('da').format('LL H:mm')))])]),_vm._v(" "),_c('span',{staticClass:"h5 darkblue regular line-height-golden gibson",domProps:{"innerHTML":_vm._s(item.description)}})]):_vm._e()})],2)])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"flex flex-wrap justify-start gibson ml4 mr3 my3"},[_c('div',{staticClass:"px2 pointer mr1 relative col col-12"},[_vm._v("\n      Velkommen, "+_vm._s(_vm.partnerName)+"\n    ")]),_vm._v(" "),_c('div',{staticClass:"col col-12 p2"},[(_vm.reminder.length !== 0)?_c('div',{staticClass:"col-12 muted-border border shadow p3 mb3"},[_c('p',{staticClass:"h5 mb0 gibson semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"36","height":"36","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"}})])]),_c('g',[_c('g',[_c('path',{attrs:{"d":"m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"}})])]),_c('path',{attrs:{"d":"m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"}})])])])]),_vm._v(" "),_c('span',[_vm._v("Påmindelser")])]),_vm._v(" "),_vm._l((_vm.reminder),function(item){return _c('div',{key:item.id,staticClass:"flex justify-start items-start mt2 darkblue"},[_c('p',{staticClass:"h6 gibson line-height-2 p1 mb0 flex justify-between items-start"},[(item.pass === 0)?_c('span',{staticClass:"relative inline-block mr1 green-background",staticStyle:{"height":"12px","width":"12px","border-radius":"50%","top":"2px"}}):_vm._e(),_vm._v(" "),(item.pass === 1)?_c('span',{staticClass:"relative inline-block mr1 red-background",staticStyle:{"height":"12px","width":"12px","border-radius":"50%","top":"2px"}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"semi-bold m0 p0 line-height-1 block h6"},[_c('a',{staticClass:"primarycolor",attrs:{"href":'#/alle-moeder?mobile=' + item.mobile}},[_c('span',{staticClass:"block mb1"},[_vm._v("\n                  "+_vm._s(_vm.moment(item.date_reminder).locale('da').format('LL H:mm'))+"\n                ")])]),_vm._v(" "),_c('span',{staticClass:"regular mb0"},[_vm._v(_vm._s(item.contact_name))]),_vm._v(" "),_c('span',{staticClass:"block light mb0 line-height-2",staticStyle:{}},[_vm._v(_vm._s(_vm._f("truncate")(item.descp,40, '...')))])])])])})],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"lg-col-4 md-col-4 sm-col-6 xs-col-12 muted-border border shadow p3 mb3"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 mb2 gibson semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"36","height":"36","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M502 492h-34V282c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v210h-84V20h84v173.5c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V10c0-5.5-4.5-10-10-10H354c-5.5 0-10 4.5-10 10v482h-26.3V138c0-5.5-4.5-10-10-10h-104c-5.5 0-10 4.5-10 10v140.2c0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10V148h84v344h-84V361c0-5.5-4.5-10-10-10 -5.5 0-10 4.5-10 10v131H168V256c0-5.5-4.5-10-10-10H54c-5.5 0-10 4.5-10 10v236H10c-5.5 0-10 4.5-10 10s4.5 10 10 10h492c5.5 0 10-4.5 10-10S507.5 492 502 492zM148 492H64V266h84V492z"}}),_c('path',{attrs:{"d":"M465.1 230.6c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S466.9 232.5 465.1 230.6z"}}),_c('path',{attrs:{"d":"M210.8 312.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9s-2.9 4.4-2.9 7.1 1.1 5.2 2.9 7.1c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1.1 7.1-2.9c1.9-1.9 2.9-4.4 2.9-7.1S212.7 314.8 210.8 312.9z"}})])]),_vm._v(" "),_c('span',[_vm._v("Statistik")])]),_vm._v(" "),_vm._m(4),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(5)]):_c('div',[_c('table',{staticClass:"mb2"},[(_vm.logs.TotalProfileView !== 0)?_c('tr',{staticClass:"darkblue h5 white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalProfileView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Profil visninger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalRatingInTimePeriod !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalRatingInTimePeriod))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Nye anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalPhoneView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalPhoneView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opkald til dig")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalHtJob !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalHtJob))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opgave fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalHtPhone !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalHtPhone))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Opkald fra kunder")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalCommentView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalCommentView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Anbefalinger læst")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalProjectView !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalProjectView))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Projekt visninger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalLikeanbefalinger !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalLikeanbefalinger))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Likes på anbefalinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.Shared !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.Shared))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Profil-delinger")])]):_vm._e(),_vm._v(" "),(_vm.logs.TotalFavorite !== 0)?_c('tr',{staticClass:"darkblue h5 primarycolor white-background py2"},[_c('td',{staticClass:"semi-bold primarycolor right-align py2 pr2"},[_vm._v(_vm._s(_vm.logs.TotalFavorite))]),_vm._v(" "),_c('td',{staticClass:"semi-bold py2 pr2"},[_vm._v("Kunder der har gemt din profil")])]):_vm._e()]),_vm._v(" "),_vm._m(6),_vm._v(" "),_c('a',{staticClass:"primarycolor",attrs:{"href":_vm.url,"target":"_blank"}},[_c('p',{staticClass:"h6 gibson semi-bold"},[_vm._v("Se din profil her .")])])])])]),_vm._v(" "),(_vm.nps >= 9)?_c('button',{staticClass:"col-12 action-button p2 gibson h5 regular",on:{"click":function($event){return _vm.recommend()}}},[_c('span',[_vm._v("Anbefal os og få et tivolikort")]),_vm._v(" "),_vm._m(7)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-12 p2"},[(_vm.getNews.length !== 0)?_c('div',{staticClass:"col-12 muted-border border shadow p3 self-stretch"},[_c('p',{staticClass:"h5 mb0 gibson semi-bold flex justify-start items-center mb2"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"36","height":"36","viewBox":"0 0 512.00061 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m412 136c0 5.519531 4.480469 10 10 10s10-4.480469 10-10-4.480469-10-10-10-10 4.480469-10 10zm0 0"}}),_c('path',{attrs:{"d":"m452 256c0 12.808594-1.285156 25.59375-3.816406 38-1.105469 5.410156 2.386718 10.691406 7.796875 11.796875.675781.140625 1.347656.207031 2.011719.207031 4.652343 0 8.820312-3.269531 9.789062-8.003906 2.800781-13.722656 4.21875-27.851562 4.21875-42 0-31.488281-6.828125-61.789062-20.300781-90.0625-2.375-4.984375-8.339844-7.101562-13.328125-4.726562-4.988282 2.375-7.101563 8.34375-4.726563 13.332031 12.179688 25.5625 18.355469 52.96875 18.355469 81.457031zm0 0"}}),_c('path',{attrs:{"d":"m306 346h-10v-130c0-5.523438-4.476562-10-10-10h-80c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h10v80h-10c-5.523438 0-10 4.476562-10 10v40c0 5.523438 4.476562 10 10 10h100c5.523438 0 10-4.476562 10-10v-40c0-5.523438-4.476562-10-10-10zm-10 40h-80v-20h10c5.523438 0 10-4.476562 10-10v-100c0-5.523438-4.476562-10-10-10h-10v-20h60v130c0 5.523438 4.480469 10 10 10h10zm0 0"}}),_c('path',{attrs:{"d":"m256 186c22.054688 0 40-17.945312 40-40s-17.945312-40-40-40-40 17.945312-40 40 17.945312 40 40 40zm0-60c11.027344 0 20 8.972656 20 20s-8.972656 20-20 20-20-8.972656-20-20 8.972656-20 20-20zm0 0"}}),_c('path',{attrs:{"d":"m256 0c-137.976562 0-256 117.800781-256 256 0 47.207031 13.527344 97.410156 36.335938 135.382812l-35.824219 107.457032c-1.195313 3.589844-.261719 7.554687 2.417969 10.230468 2.691406 2.691407 6.660156 3.609376 10.234374 2.414063l107.457032-35.820313c37.96875 22.8125 88.171875 36.335938 135.378906 36.335938 138.011719 0 256-117.816406 256-256 0-138.011719-117.8125-256-256-256zm0 492c-45.285156 0-93.417969-13.363281-128.757812-35.746094-2.503907-1.585937-5.625-2.003906-8.515626-1.039062l-92.914062 30.972656 30.972656-92.914062c.953125-2.851563.570313-5.976563-1.039062-8.515626-22.382813-35.335937-35.746094-83.472656-35.746094-128.757812 0-127.925781 108.074219-236 236-236s236 108.074219 236 236-108.074219 236-236 236zm0 0"}})])]),_vm._v(" "),_c('span',[_vm._v("Nyheder")])]),_vm._v(" "),_vm._l((_vm.news),function(item){return (item.prisen === '0')?_c('div',{key:item.id,staticClass:"mb4"},[_c('span',{staticClass:"h6 gibson semi-bold primarycolor line-height-1 mb1 block"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"gibson h6 darkblue regular mb2 flex justify-start items-center"},[_c('span',[_c('svg',{staticClass:"jam jam-clock",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"}})])]),_vm._v(" "),_c('span',{staticClass:"regular",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.moment(item.timenews).locale('da').format('LL H:mm')))])]),_vm._v(" "),_c('read-more',{staticClass:"h6 line-height-2 darkblue regular gibson",attrs:{"more-str":"Se mere","text":item.description,"link":"#","less-str":"Se mindre","max-chars":251}})],1):_vm._e()})],2):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col col-12 p2"},[(_vm.getPrisen.length !== 0)?_c('div',{staticClass:"col-12 muted-border border shadow p3 self-stretch"},[_c('p',{staticClass:"h5 mb0 gibson semi-bold flex justify-start items-center mb2"},[_c('span',{staticClass:"mr1 relative",staticStyle:{"top":"1px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"36","height":"36","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M465.7 67.4h-64.4v-56C401.3 5.1 396.2 0 389.9 0H122.1c-6.3 0-11.4 5.1-11.4 11.4v56H46.3c-6.3 0-11.4 5.1-11.4 11.4 0 52.3 31.7 99.5 79.5 119.6 12.2 52.6 53.2 94.4 105.3 107.8 2.1 26.5-15.7 51.4-42.3 57.4 -0.1 0-0.2 0.1-0.3 0.1 -0.2 0.1-0.5 0.1-0.7 0.2 -0.2 0.1-0.3 0.1-0.5 0.2 -0.2 0.1-0.4 0.1-0.6 0.2 -0.2 0.1-0.4 0.2-0.5 0.3 -0.1 0.1-0.3 0.1-0.4 0.2 -0.2 0.1-0.4 0.2-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.1-0.4 0.3-0.6 0.4 -0.1 0.1-0.2 0.1-0.3 0.2 -0.2 0.2-0.4 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.2 0.2-0.3 0.3-0.5 0.5 -0.1 0.1-0.2 0.2-0.3 0.3 -0.1 0.2-0.3 0.3-0.4 0.5 -0.1 0.1-0.2 0.3-0.3 0.4 -0.1 0.2-0.2 0.3-0.3 0.5 -0.1 0.1-0.2 0.3-0.2 0.4 -0.1 0.2-0.2 0.4-0.3 0.5 -0.1 0.2-0.1 0.3-0.2 0.5 -0.1 0.2-0.2 0.4-0.2 0.6 0 0.1-0.1 0.3-0.1 0.4 -0.1 0.2-0.1 0.5-0.2 0.7 0 0.1-0.1 0.2-0.1 0.3 -0.1 0.3-0.1 0.6-0.1 0.9 0 0.1 0 0.2 0 0.2 0 0.3 0 0.6 0 1 0 0 0 0.1 0 0.1v0.1c0 0.1 0 0.1 0 0.2v34h-32c-6.3 0-11.4 5.1-11.4 11.4v80c0 6.3 5.1 11.4 11.4 11.4h240c6.3 0 11.4-5.1 11.4-11.4v-80c0-6.3-5.1-11.4-11.4-11.4h-32v-34.3c0-3-1.2-5.8-3.1-7.8 0 0 0 0 0 0 -0.2-0.2-0.5-0.5-0.7-0.7 0 0-0.1-0.1-0.1-0.1 -0.2-0.2-0.5-0.4-0.7-0.6 -0.1 0-0.1-0.1-0.2-0.1 -0.2-0.2-0.5-0.3-0.8-0.5 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.2-0.6-0.3-0.8-0.4 -0.1 0-0.1-0.1-0.2-0.1 -0.3-0.1-0.6-0.3-0.9-0.4 0 0-0.1 0-0.1 0 -0.3-0.1-0.7-0.2-1-0.3 0 0-0.1 0-0.1 0 -26.8-6-44.5-31.1-42.3-57.7 51.6-13.7 92-55.2 104.2-107.5 47.8-20.1 79.6-67.4 79.6-119.6C477.1 72.5 472 67.4 465.7 67.4zM58.4 90.3h52.2v75.6c0 0 0 0.1 0 0.1 0 1.7 0 3.4 0.1 5.1C81.7 154.1 62 124.1 58.4 90.3zM365.1 432v57.1H148V432H365.1zM321.7 386.3v22.9H191.4v-22.9H321.7zM221.9 363.4c3.2-3.4 6.1-7.1 8.7-11.2 8.1-12.7 12.3-27.2 12.2-42 4.3 0.4 8.7 0.6 13.2 0.6 4.8 0 9.6-0.2 14.3-0.7 -0.1 20 7.7 39.1 21 53.3H221.9zM378.4 165.5c0 67.5-54.9 122.5-122.5 122.5s-122.5-54.9-122.5-122.5V22.9h245V165.5zM401.2 171.2c0.1-1.7 0.1-3.4 0.1-5.1 0 0 0-0.1 0-0.1V90.3h52.3C450 124.1 430.3 154.2 401.2 171.2z"}}),_c('path',{attrs:{"d":"M292 449.1H221.1c-6.3 0-11.4 5.1-11.4 11.4S214.8 472 221.1 472h70.9c6.3 0 11.4-5.1 11.4-11.4S298.3 449.1 292 449.1z"}}),_c('path',{attrs:{"d":"M325.2 125.3c-1.3-4.1-4.9-7.2-9.2-7.8l-34-4.9 -15.2-30.8c-1.9-3.9-5.9-6.4-10.2-6.4 -4.4 0-8.3 2.5-10.2 6.4l-15.2 30.8 -34 4.9c-4.3 0.6-7.9 3.6-9.2 7.8 -1.3 4.1-0.2 8.7 2.9 11.7l24.6 24 -5.8 33.8c-0.7 4.3 1 8.6 4.5 11.2 3.5 2.6 8.2 2.9 12 0.9l30.4-16 30.4 16c1.7 0.9 3.5 1.3 5.3 1.3 2.4 0 4.7-0.7 6.7-2.2 3.5-2.6 5.3-6.9 4.5-11.2l-5.8-33.8 24.6-24C325.4 134 326.5 129.4 325.2 125.3zM277.4 148.8c-2.7 2.6-3.9 6.4-3.3 10.1l2.9 16.9 -15.2-8c-1.7-0.9-3.5-1.3-5.3-1.3s-3.7 0.4-5.3 1.3l-15.2 8 2.9-16.9c0.6-3.7-0.6-7.5-3.3-10.1l-12.3-12 17-2.5c3.7-0.5 6.9-2.9 8.6-6.3l7.6-15.4 7.6 15.4c1.7 3.4 4.9 5.7 8.6 6.3l17 2.5L277.4 148.8z"}})])]),_vm._v(" "),_c('span',[_vm._v("Håndværker Prisen 2021")])]),_vm._v(" "),_vm._l((_vm.news),function(item){return (item.prisen === '1')?_c('div',{key:item.id,staticClass:"mb4"},[_c('span',{staticClass:"h6 gibson semi-bold primarycolor line-height-1 mb1 block"},[_vm._v(_vm._s(item.title))]),_vm._v(" "),_c('p',{staticClass:"gibson h6 darkblue regular mb2 flex justify-start items-center"},[_c('span',[_c('svg',{staticClass:"jam jam-clock",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M11 9h4a1 1 0 0 1 0 2h-5a1 1 0 0 1-1-1V4a1 1 0 1 1 2 0v5zm-1 11C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16z"}})])]),_vm._v(" "),_c('span',{staticClass:"ml1",staticStyle:{"font-size":"12px"}},[_vm._v(_vm._s(_vm.moment(item.timenews).locale('da').format('LL H:mm')))])]),_vm._v(" "),_c('read-more',{staticClass:"h6 line-height-2 darkblue regular gibson",attrs:{"more-str":"Se mere","text":item.description,"link":"#","less-str":"Se mindre","max-chars":251}})],1):_vm._e()})],2):_vm._e()])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"prisen-modal",staticClass:"prisenmodal",attrs:{"size":"md","no-close-on-esc":"","no-close-on-backdrop":"","hide-footer":""}},[(!_vm.dialogPrisenButtonClicked)?_c('div',{staticStyle:{"background-color":"#003645"}},[_c('div',{staticClass:"block center p2"},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[_c('h3',{staticClass:"bold primarycolor line-height-2 m0"},[_vm._v("HUSK AT MELDE\n              "),_c('br'),_vm._v("DIG TIL\n            ")])]),_vm._v(" "),_c('div',{staticClass:"absolute",staticStyle:{"right":"1rem"}},[_c('a',{staticClass:"pointer no-hover",on:{"click":function($event){return _vm.hidePrisenModal()}}},[_c('img',{attrs:{"src":__webpack_require__(1282),"width":"100%"}})])])]),_vm._v(" "),_c('h2',{staticClass:"white bold m0",staticStyle:{"font-size":"3.7rem","line-height":"1.5"}},[_vm._v("DANMARKS")]),_vm._v(" "),_c('h1',{staticClass:"white bold m0",staticStyle:{"font-size":"5rem","line-height":"0.5"}},[_vm._v("STØRSTE")]),_vm._v(" "),_c('h2',{staticClass:"white bold m0",staticStyle:{"font-size":"2.3rem","line-height":"2.3"}},[_vm._v("HÅNDVÆRKERFEST")]),_vm._v(" "),_c('p',{staticClass:"white"},[_vm._v(_vm._s(_vm.prisenRegion))])]),_vm._v(" "),_c('div',{staticClass:"relative flex justify-center"},[_c('div',[_c('img',{attrs:{"src":__webpack_require__(1283),"width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"absolute col-10 p0",staticStyle:{"top":"40%"}},[_c('button',{staticClass:"h2 bold col-12 white green-background py2 register-prisen",staticStyle:{"opacity":"0.9"},attrs:{"disabled":_vm.disabledPrisenButton},on:{"click":function($event){return _vm.registerPrisen()}}},[_vm._v("TILMELD DIG"),_c('br'),_vm._v("GRATIS")])])])]):_c('div',{staticStyle:{"background-color":"#003645"}},[_c('div',{staticClass:"block center p2"},[_c('div',{staticClass:"mb3"}),_vm._v(" "),_c('h2',{staticClass:"white bold mb3 line-height-1",staticStyle:{"font-size":"3rem"}},[_vm._v("Hvor mange "),_c('br'),_vm._v("\n        deltager?")]),_vm._v(" "),_c('el-radio-group',{staticClass:"col-12 p0 gibson regular",attrs:{"disabled":_vm.disabledPrisenRadio},on:{"change":function($event){return _vm.submitRegister()}},model:{value:(_vm.prisenParticipant),callback:function ($$v) {_vm.prisenParticipant=$$v},expression:"prisenParticipant"}},[_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"1"}},[_vm._v("1")]),_vm._v(" "),_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"2"}},[_vm._v("2")]),_vm._v(" "),_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"3"}},[_vm._v("3")]),_vm._v(" "),_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"4"}},[_vm._v("4")]),_vm._v(" "),_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"5"}},[_vm._v("5")]),_vm._v(" "),_c('el-radio-button',{staticClass:"col-6 p0 mb2",attrs:{"label":"0"}},[_vm._v("Ved ikke")])],1),_vm._v(" "),_c('div',{staticClass:"mb4"})],1)])]),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h5 darkblue regular line-height-golden gibson"},[_vm._v("\n              Se hvordan det går med din profil.\n\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h4 mb3 gibson darkblue semi-bold flex justify-start items-center"},[_c('span',{staticClass:"mr1"},[_c('img',{attrs:{"src":"static/svg/single-house.svg","alt":"","width":"24","height":"24"}})]),_vm._v(" "),_c('span',[_vm._v("Håndværker Prisen 2021")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 darkblue regular line-height-2 gibson"},[_vm._v("\n              Se hvordan det går med din profil.....\n\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mediumgrey justify-start items-center white-background p1 mb2 line-height-1"},[_c('span',{staticClass:"block",staticStyle:{"font-size":"12px"}},[_vm._v("(Seneste 3 mdr.)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1282 */
/***/ (function(module, exports) {

module.exports = "../../static/img/close_img.b17b3f3.png";

/***/ }),
/* 1283 */
/***/ (function(module, exports) {

module.exports = "../../static/img/marketplace.5ca47ed.png";

/***/ }),
/* 1284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerSetup_vue__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59376fcf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerSetup_vue__ = __webpack_require__(1287);
function injectStyle (ssrContext) {
  __webpack_require__(1285)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PartnerSetup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_59376fcf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PartnerSetup_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1285 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'setup',
  components: {},
  props: {},
  data: function data() {
    return {
      items: [],
      showimentor: true,
      show: false,
      label: 'Loading...',
      overlay: 1,
      selected: [],
      loading: true
    };
  },

  methods: {
    onComplete: function onComplete() {
      alert('Your settings are now saved.');
    },
    toggleAlarmpris: function toggleAlarmpris(checked) {
      this.form.alarmpris.selected = checked ? this.form.alarmpris.choices.slice() : [];
    },
    opgave_action: function opgave_action() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      if (this.selected.length === 0) {
        this.modalShowDato = false;

        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'danger'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      var dataPartner = { operation: 'producttask', salesPerson: this.salesPerson, category: this.selected };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;

        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.modalShowDato = false;

          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this.$refs.simplert.openSimplert(_obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    toggleAll: function toggleAll(item) {
      if ($('#checkbox' + item).is(':checked')) {
        $('#' + item).show();
        for (var Subitem in this.items) {
          if (this.items[Subitem].parent_id === item) {
            this.selected.push(this.items[Subitem].id);
          }
        }
      } else {
        $('#' + item).hide();
        for (var Subitem1 in this.items) {
          if (this.items[Subitem1].parent_id === item) {
            this.removeItem(this.selected, this.items[Subitem1].id);
          }
        }
      }
    },
    removeItem: function removeItem(array, item) {
      for (var i in array) {
        if (array[i] === item) {
          array.splice(i, 1);
          break;
        }
      }
    },
    firstSelected: function firstSelected() {
      for (var i in this.selected) {
        $('#' + this.selected[i]).show();
      }
    },
    Reload: function Reload() {
      var _this2 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner_profil', salesPerson: this.salesPerson };
      if (localStorage.getItem('imentor') === '0') {
        this.showimentor = false;
        this.loading = false;
        return;
      }
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.loading = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.items = res.subpartnerjob;
        if (res.dataObjselect instanceof Array) {
          _this2.selected = res.dataObjselect;
        }
        setTimeout(function () {
          return _this2.firstSelected();
        }, 400);
      }, function (response) {
        alert('error');
      });
    },
    toggleElektrikerpris: function toggleElektrikerpris(checked) {
      this.form.elektrikerpris.selected = checked ? this.form.elektrikerpris.choices.slice() : [];
    },
    toggleGaragepris: function toggleGaragepris(checked) {
      this.form.garagepris.selected = checked ? this.form.garagepris.choices.slice() : [];
    },
    toggleGulvpris: function toggleGulvpris(checked) {
      this.form.gulvpris.selected = checked ? this.form.gulvpris.choices.slice() : [];
    },
    onReset: function onReset(evt) {
      evt.preventDefault();

      this.form.alarmprisTypes = '';
    }
  }
});

/***/ }),
/* 1287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('b-container',{staticClass:"pt-3 pt-lg-3 pt-md-3 pb-3 pb-lg-3 pb-md-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0 rounded"},[_c('div',{staticClass:"card-title w-100 mx-auto text-center py-3 py-lg-3 py-md-3"},[_c('span',{staticClass:"h4 font-weight-bold line-height-gold text-center text-dark"},[_vm._v("Hej, partnerName")])]),_vm._v(" "),_c('div',{staticClass:"py-2 py-lg-2 py-md-2"}),_vm._v(" "),_c('div',{staticClass:"card-text text-center mx-auto"},[_c('div',{staticClass:"h6 open-sans line-height-golden"},[_vm._v("\n              Da dette er den første gang, du logger ind på din personlige partnerprofil, beder vi dig om at tjekke, at vi har registreret de rigtige oplysninger om dig, dit firma og dine præferencer.\n            ")]),_vm._v(" "),_c('div',{staticClass:"h6 open-sans line-height-golden"},[_vm._v("\n              Hvis du finder en fejl kan du hurtigt og nemt rette den med det samme og komme godt i gang med dit partnerskab.\n            ")]),_vm._v(" "),_c('div',{staticClass:"h6 open-sans line-height-golden"},[_vm._v("\n              Vi håber, du får en masse gode kundemøder ud af vores service!\n            ")])]),_vm._v(" "),_c('form-wizard',{attrs:{"stepSize":"lg","back-button-text":"Tilbage","next-button-text":"Næste","finish-button-text":"End","title":"","subtitle":"","color":"rgba(44, 62, 80,1.0)"},on:{"on-complete":_vm.onComplete}},[_c('tab-content',[_c('div',{staticClass:"animated fadeIn d-flex justify-content-start"},[_c('b-form',{staticClass:"mx-auto mb-4 mb-lg-4 mb-md-4"},[_c('fieldset',[_c('b-form-row',[_c('b-col',[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"CVR"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"cvr"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Kontaktperson"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Kontaktperson"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Firmanavn"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Firmanavn"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Email"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Telefon"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Telefon"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Postnummer"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Postnummer"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"lg":"6"}},[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"By"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"By"}})],1)],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"py-3 py-lg-3 py-md-3"},[_c('b-btn',{staticClass:"rounded font-weight-bold",attrs:{"variant":"success","size":"lg"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"}})])]),_vm._v(" "),_c('span',[_vm._v("Gem")])])],1)],1),_vm._v(" "),_c('b-form-row',[_c('b-col',[_c('b-form-group',{staticClass:"font-weight-bold",attrs:{"label":"Adresse"}},[_c('b-input',{staticClass:"rounded bg-light",attrs:{"placeholder":"Adresse"}})],1)],1)],1)],1)])],1)]),_vm._v(" "),_c('tab-content',[_c('div',{staticClass:"animated fadeIn d-flex justify-content-center"},[_c('b-form',[_c('fieldset',[_c('b-form-row',{staticClass:"px-4 py-4"},_vm._l((_vm.items),function(item){return (item.parent_id === '1' || item.parent_id === '32')?_c('b-col',{key:item.id,attrs:{"lg":"4","md":"4","sm":"6"}},[_c('b-form-group',[_c('b-form-checkbox',{staticClass:"text-dark font-weight-bold",staticStyle:{"font-size":"11.5px"},attrs:{"disabled":item.valid !== 1,"value":item.id,"id":'checkbox' + item.id,"unchecked-value":"not_accepted"},on:{"change":function($event){return _vm.toggleAll(item.id)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_c('span',[_vm._v(_vm._s(item.name.replace(' / Fagbooking.dk', '').replace('/ fagbooking.dk', '')))])]),_vm._v(" "),_c('div',{staticClass:"py-1"}),_vm._v(" "),_c('b-collapse',{staticClass:"p-2 p-lg-2 p-md-2",attrs:{"id":item.id}},_vm._l((_vm.items),function(subitem){return (subitem.parent_id === item.id)?_c('b-form-group',{key:subitem.id,attrs:{"disabled":subitem.valid !== 1}},[_c('b-form-checkbox',{staticStyle:{"font-size":"11.5px"},attrs:{"id":subitem.id,"value":subitem.id,"unchecked-value":"not_accepted"},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}},[_vm._v(_vm._s(subitem.name.replace(' / Fagbooking.dk', '').replace('/ fagbooking.dk', ''))+"\n                              ")])],1):_vm._e()}),1)],1)],1):_vm._e()}),1),_vm._v(" "),_c('b-form-row',[_c('b-col',{staticClass:"text-center my-4"},[(_vm.showimentor)?_c('b-btn',{staticClass:"mx-auto rounded font-weight-bold",attrs:{"size":"lg","variant":"success"},on:{"click":function($event){return _vm.opgave_action()}}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M15.004 3h2.996v5h-2.996v-5zm8.996 1v20h-24v-24h20l4 4zm-19 5h14v-7h-14v7zm16 4h-18v9h18v-9zm-2 2h-14v1h14v-1zm0 2h-14v1h14v-1zm0 2h-14v1h14v-1z"}})])]),_vm._v(" "),_c('span',[_vm._v("Gem opgavetyper")])]):_vm._e()],1)],1)],1)])],1)])],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userTilbud_vue__ = __webpack_require__(1291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfb5b04_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_userTilbud_vue__ = __webpack_require__(1298);
function injectStyle (ssrContext) {
  __webpack_require__(1289)
  __webpack_require__(1290)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_userTilbud_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfb5b04_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_userTilbud_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1289 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1290 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_autosize_textarea__ = __webpack_require__(1292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_show_error__ = __webpack_require__(1295);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_gallery_slideshow__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_vue_rate_it__);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'userTilbud',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_1_vue_full_loading___default.a,
    moment: __WEBPACK_IMPORTED_MODULE_8_moment___default.a,
    showError: __WEBPACK_IMPORTED_MODULE_7__components_show_error__["a" /* default */],
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_10_vue_gallery_slideshow___default.a,
    uuid: __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default.a,
    autosizeTextarea: __WEBPACK_IMPORTED_MODULE_5__components_autosize_textarea__["a" /* default */],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_6__components_file_upload_input__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */],
    ImageRating: __WEBPACK_IMPORTED_MODULE_11_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      item: [],
      files: [],
      show: false,
      tilbudShow: false,
      newCreatorShow: false,
      offerModalShow: false,
      da: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["da"],
      en: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["en"],
      overlay: true,
      label: 'Loading...',
      quotations: [],
      quotation: {
        files: [],
        info: []
      },
      images: [],
      image: '',
      customer: {
        files: []
      },
      partner: [],
      app: [],
      dataStatus: [{ value: 1, text: 'Quantity' }, { value: 2, text: 'Timepris' }, { value: 3, text: 'Fastpris' }],
      quotationForm: {
        id: '',
        customer_id: null,
        currency_id: null,
        date: __WEBPACK_IMPORTED_MODULE_8_moment___default()().format('YYYY-MM-DD'),
        expiry_date: __WEBPACK_IMPORTED_MODULE_8_moment___default()().add(7, 'days').format('YYYY-MM-DD'),
        expiry_date_detail: '',
        upload_token: '',
        item_type: '',
        rows: [],
        subject: '',
        description: '',
        subtotal: 0,
        subtotalDiscount: 0,
        line_item_discount_type: true,
        subtotalDiscount_type: false,
        subtotal_tax: 25,
        subtotalShippingAndHandling: 0,
        total: 0,
        reference_number: '',
        quotation_number: '',
        quotation_prefix: '',
        is_draft: 0,
        show_sub_total_tax: true,
        show_sub_total_discount: true,
        show_sub_total_shipping_and_handling: true,
        show_line_item_tax: true,
        show_line_item_discount: true,
        show_line_item_description: true,
        customer_note: '',
        memo: '',
        tnc: ''
      },
      index: null,
      tilbuds: [],
      item_details: [],
      customers: [],
      selected_customer: null,
      currencies: [],
      selected_currency: null,
      default_currency: {},
      item_types: [],
      selected_item_type: null,
      expiry_dates: [],
      selected_expiry_date: null,
      expiry_date_detail: '',
      clear_quotation_attachment: false,
      show_quantity: true,
      items: [],
      tilbud_id: '',
      showDismissibleAlert: false,
      starMessage: '',
      showHaandvearker: false,
      showImentor: false,
      messages: [],
      uuid: false,
      loading: true
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1900) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.Reload();
  },
  mounted: function mounted() {},

  methods: {
    Reload: function Reload() {
      var _this = this;

      if (localStorage.getItem('haaid') !== '0') {
        this.showHaandvearker = true;
      }
      if (localStorage.getItem('imentor') !== '0') {
        this.showImentor = true;
      }
      this.show = true;
      this.tilbud_id = this.$route.query.app;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'userTilbud', salesPerson: this.salesPerson, tilbud_id: this.tilbud_id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.loading = false;
        _this.customer = res.customer;
        _this.app = res.app;
        _this.quotations = res.tilbud;
        _this.items = res.customer.products;
        _this.images = res.customer.pic;
        _this.image = res.partner.image;
        _this.partner = res.partner;
        _this.quotationForm.reference_number = 'REF' + _this.quotations.length + '-' + _this.tilbud_id;
      }, function (response) {
        alert('error');
      });
    },
    onClick: function onClick(i) {
      this.index = i;
    },
    onFileChange: function onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.createImage(files[0]);
    },
    hideModal: function hideModal() {
      this.$refs.tilbudModal.hide();
    },
    showItemDetails: function showItemDetails(tilbud) {
      this.tilbudShow = !this.tilbudShow;
      this.quotation = tilbud;
    },
    createImage: function createImage(file) {
      var reader = new FileReader();
      var vm = this;
      reader.onload = function (e) {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },

    removeImage: function removeImage(e) {
      this.image = '';
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
    },
    save: function save() {
      this.quotationForm.is_draft = 1;
      this.onSubmitTilbud();
    },
    send: function send() {
      this.quotationForm.is_draft = 0;
      this.onSubmitTilbud();
    },
    resetForm: function resetForm(evt) {},
    onSubmitTilbud: function onSubmitTilbud(evt) {
      var _this2 = this;

      evt.preventDefault();
      if (this.quotationForm.total <= 0) {
        var obj = {
          title: 'Fejl',
          message: 'Total price is zero',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'addTilbud', salesPerson: this.salesPerson, tilbud: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.quotationForm), files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files), tilbud_id: this.tilbud_id, is_draft: this.quotationForm.is_draft, image: this.image };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        _this2.show = false;
        var res = response.body;
        if (res.success) {
          var closeFn = function closeFn() {
            this.$parent.quotationForm.is_draft = 0;
            this.$parent.quotationForm.rows = [];
            this.$parent.quotationForm.subject = '';
            this.$parent.quotationForm.description = '';
            this.$parent.quotationForm.subtotal = 0;
            this.$parent.quotationForm.subtotalDiscount = 0;
            this.$parent.quotationForm.line_item_discount_type = true;
            this.$parent.quotationForm.subtotalDiscount_type = false;
            this.$parent.quotationForm.subtotal_tax = 25;
            this.$parent.quotationForm.subtotalShippingAndHandling = 0;
            this.$parent.quotationForm.total = 0;
            this.$parent.quotationForm.customer_note = '';
            this.$parent.quotationForm.memo = '';
            this.$parent.quotationForm.tnc = '';
            this.$parent.Reload();
            var elem = this.$parent.$refs.addt;
            elem.click();
          };
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            onClose: closeFn,
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj);
        } else {
          var _obj2 = {
            title: 'Fejl',
            message: 'Fejl - Kontakt venligst administrator',
            type: 'error',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(_obj2);
        }
      }, function (response) {
        alert('error');
      });
    },
    confirmRowDelete: function confirmRowDelete(row) {
      var _this3 = this;

      return function (dialog) {
        return _this3.deleteRow(row);
      };
    },
    deleteRow: function deleteRow(row) {
      var idx = this.quotationForm.rows.indexOf(row);
      if (idx > -1) {
        this.quotationForm.rows.splice(idx, 1);
      }
      this.calculate();
    },
    formatNumber: function formatNumber(number, decimalPlace) {
      if (decimalPlace === undefined) {
        decimalPlace = 2;
      }
      return this.roundNumber(number, decimalPlace);
    },
    formatType: function formatType(item) {
      switch (new Date().getDay()) {
        case 1:
          return 'Quantity';
      }
    },
    roundNumber: function roundNumber(number, precision) {
      precision = Math.abs(parseInt(precision)) || 0;
      var multiplier = Math.pow(10, precision);
      return Math.round(number * multiplier) / multiplier;
    },
    confirmDelete: function confirmDelete(quotation) {
      var _this4 = this;

      return function (dialog) {
        return _this4.deleteQuotation(quotation);
      };
    },
    calculate: function calculate() {
      var _this5 = this;

      var total = 0;
      this.quotationForm.rows.forEach(function (row) {
        var discount = 0;
        discount = _this5.formatNumber(discount);
        row.discount = discount;
        var tax = 0;
        tax = _this5.formatNumber(tax);
        row.tax = tax;
        var quantity = _this5.show_quantity ? row.quantity || 1 : 1;
        quantity = _this5.formatNumber(quantity);
        row.quantity = quantity;
        var unitPrice = row.unitPrice || 0;
        unitPrice = _this5.formatNumber(unitPrice);
        row.unitPrice = unitPrice;
        var price = quantity * unitPrice;

        var amount = _this5.formatNumber(price);
        row.amount = amount;
        total = total + amount;
      });
      this.quotationForm.subtotal = this.formatNumber(total);
      var subtotalDiscount = this.quotationForm.show_sub_total_discount ? this.quotationForm.subtotalDiscount || 0 : 0;
      subtotalDiscount = this.formatNumber(subtotalDiscount);
      this.quotationForm.subtotalDiscount = subtotalDiscount;
      var subtotalTax = 25;
      subtotalTax = this.formatNumber(subtotalTax);
      this.quotationForm.subtotalTax = subtotalTax;
      var subtotalShippingAndHandling = this.quotationForm.show_sub_total_shipping_and_handling ? this.quotationForm.subtotalShippingAndHandling || 0 : 0;
      subtotalShippingAndHandling = this.formatNumber(subtotalShippingAndHandling);
      this.quotationForm.subtotalShippingAndHandling = subtotalShippingAndHandling;
      total = total - (this.quotationForm.subtotalDiscount_type ? total * subtotalDiscount / 100 : subtotalDiscount);
      total = total + total * subtotalTax / 100;
      total = total + parseFloat(subtotalShippingAndHandling);
      this.quotationForm.total = this.formatNumber(total);
    },
    addRow: function addRow() {
      this.quotationForm.rows.push({
        uuid: __WEBPACK_IMPORTED_MODULE_9_uuid_v4___default()(),
        name: '',
        selected_item: null,
        show_custom_item: false,
        custom_name: '',
        quantity: '1',
        unitPrice: '',
        discount: '',
        tax: '',
        type: 1,
        amount: '',
        description: ''
      });
    },
    trans: function trans(text) {
      return text;
    },
    getConfig: function getConfig(text) {
      return text;
    }
  }
});

/***/ }),
/* 1292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autosize_textarea_vue__ = __webpack_require__(1293);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abe3557_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_autosize_textarea_vue__ = __webpack_require__(1294);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_autosize_textarea_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3abe3557_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_autosize_textarea_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize__ = __webpack_require__(602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_autosize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_autosize__);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    autosize: __WEBPACK_IMPORTED_MODULE_0_autosize___default.a
  },
  props: {
    name: {
      required: true
    },
    value: {
      default: ''
    },
    rows: {
      default: 1
    },
    placeholder: {
      default: ''
    }
  },
  mounted: function mounted() {},

  methods: {
    updateContent: function updateContent() {}
  }
});

/***/ }),
/* 1294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('textarea',{ref:"txtArea",staticClass:"form-control",attrs:{"rows":_vm.rows,"placeholder":_vm.placeholder,"name":_vm.name},domProps:{"value":_vm.value},on:{"change":_vm.updateContent}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_error_vue__ = __webpack_require__(1296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c08ac8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_show_error_vue__ = __webpack_require__(1297);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_show_error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_66c08ac8_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_show_error_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['formName', 'propName']
});

/***/ }),
/* 1297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.formName.errors.has(_vm.propName))?_c('span',{staticClass:"help has-error",domProps:{"textContent":_vm._s(_vm.formName.errors.get(_vm.propName))}}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson mb2 pb4"},[[(!_vm.showMobile)?_c('div',{staticClass:"px2 py1 ml4 mb2"},[_vm._m(0)]):_c('div',{staticClass:"px2 py1 mb2"},[_vm._m(1)])],_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"px2 mx4"},[_c('div',{staticClass:"clearfix border muted-border p2 pb4 mb2 shadow"},[_vm._m(2),_vm._v(" "),_c('div',[_c('div',{staticClass:"table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.quotations),function(quotation){return _c('tr',{key:quotation.id},[_c('td',[(quotation.info.reference_number)?_c('span',{staticClass:"semi-bold line-height-1 m0 gibson",staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(quotation.info.reference_number))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.name)?_c('span',{staticClass:"regular line-height-1 m0 gibson",staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(quotation.name))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.info.date)?_c('span',{staticClass:"regular line-height-1 m0 gibson",staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(quotation.info.date || _vm.moment))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.info.expiry_date)?_c('span',{staticClass:"regular line-height-1 m0 gibson",staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(quotation.info.expiry_date || _vm.moment))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.sent)?_c('span',{staticClass:"regular line-height-1 m0 gibson",staticStyle:{"font-size":"85%"}},[_vm._v(_vm._s(quotation.sent))]):_vm._e()]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0 gibson"},[(quotation.is_draft === '1')?_c('span',{staticClass:"yellow-background darkblue regular p1 inline-block"},[_vm._v("Draft")]):_vm._e(),_vm._v(" "),(quotation.condition === '1')?_c('span',{staticClass:"more-muted-background darkblue regular p1 inline-block"},[_vm._m(4,true),_vm._v(" "),_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                          Afventer\n                        ")])]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"table-option text-center"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"dark-button line-height-1 p1 flex justify-start items-center gibson border-none mr1",on:{"click":function($event){return _vm.showItemDetails(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                          View\n                        ")]),_vm._v(" "),_vm._m(5,true)]),_vm._v(" "),_vm._m(6,true),_vm._v(" "),_c('button',{staticClass:"warning-button line-height-1 p1 flex justify-start items-center gibson mr1",attrs:{"tooltip":"Edit"},on:{"click":function($event){$event.preventDefault();return _vm.editQuotation(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                          Edit\n                        ")]),_vm._v(" "),_vm._m(7,true)]),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(quotation)}),expression:"{ok: confirmDelete(quotation)}"}],key:quotation.id,staticClass:"delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1",attrs:{"tooltip":"Slet"}},[_c('i',{staticClass:"el-icon-delete"})])])])])}),0)])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix border muted-border p2 px3 pb3 mt4 mb2 shadow"},[_c('div',[_c('p',{staticClass:"h6 gibson regular line-height-2 mt2 mb1"},[_vm._v("Tilbud")]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue gibson line-height-golden mb1"},[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb list-reset border-none mb0"},[_c('li',{staticClass:"breadcrumb-item h5 gibson"},[_c('router-link',{attrs:{"to":"/alle-moeder"}},[_vm._v("Alle møder")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item h5 gibson active"},[_vm._v("Tilbud")])]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-golden mb2 col-7 px0"},[_vm._v("\n            Her har vi samlet informationerne omkring dit partnerskab. Portalen giver dig blandt andet følgende muligheder:\n          ")]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Kundeinfo\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fil":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse2"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Navn :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Email :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Mobile :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.mobile))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Adresse :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.mailingstreet)+" "+_vm._s(_vm.customer.mailingzip)+" "+_vm._s(_vm.customer.mailingcity))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Mødedato :")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 semi-bold darkblue line-height-3 gibson"},[_vm._v(_vm._s(_vm.moment(_vm.app.appointment_date).locale('da').format('LL'))),_c('br'),_vm._v("kl. "+_vm._s(_vm.app.id_times)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Prisen er inkl. moms :")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.lowamountmoms)+" - "+_vm._s(_vm.customer.highamountmoms)+" kr.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-7 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Kommentarer")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 regular darkblue line-height-4 gibson"},[_vm._v(_vm._s(_vm.app.comment_to_partner))]):_vm._e()]),_vm._v(" "),(_vm.customer.files.length !== 0)?_c('div',{staticClass:"col-12 px1"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Filer")]),_vm._v(" "),_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.customer.files),function(attachment){return _c('li',{key:attachment.id,staticClass:"py-1"},[_c('a',{attrs:{"href":attachment}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Opgavens indhold\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse3"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-6 px0"},[_c('b-table',{staticClass:"mb4",attrs:{"striped":"","hover":"","items":_vm.items}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse4",modifiers:{"collapse4":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Billeder\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse4"}},[_c('div',{staticClass:"flex flex-wrap justify-start items-center"},_vm._l((_vm.images),function(image,i){return _c('div',{key:image.id,staticClass:"col col-4",staticStyle:{"height":"200px"},on:{"click":function($event){return _vm.onClick(i)}}},[_c('img',{staticClass:"fit",attrs:{"src":image}}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"px0 my2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.moretilbud",modifiers:{"moretilbud":true}}],ref:"addt",staticClass:"not-rounded action-button gibson p2 h4 flex justify-center items-center line-height-1",attrs:{"name":"moretilbud"}},[_c('span',{staticClass:"regular gibson"},[_vm._v("Kom i gang")]),_vm._v(" "),_vm._m(8)])]),_vm._v(" "),_c('div',{staticClass:"col-9 mx-auto px0"},[_c('b-collapse',{attrs:{"id":"moretilbud"}},[_c('div',{staticClass:"clearfix my3"},[_c('form',{on:{"submit":_vm.onSubmitTilbud,"reset":_vm.resetForm}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix my2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Logo")]),_vm._v(" "),(!_vm.image)?_c('div',{staticClass:"my2"},[_c('input',{staticClass:"col-12 muted-background darkblue gibson h5 p2",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})]):_c('div',{staticClass:"my2"},[_c('div',{staticClass:"flex justify-between items-start"},[_c('img',{staticClass:"mb2 fit",attrs:{"width":"80","src":_vm.image}}),_vm._v(" "),_c('button',{staticClass:"not-rounded delete-button p1 border-none",on:{"click":_vm.removeImage}},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('file-upload-input',{attrs:{"token":_vm.quotationForm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Reference #")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quotationForm.reference_number),expression:"quotationForm.reference_number"}],staticClass:"col-12 muted-background darkblue h5 p2 border-none not-rounded",attrs:{"type":"text","value":"","name":"reference_number","required":"","placeholder":"Reference #"},domProps:{"value":(_vm.quotationForm.reference_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.quotationForm, "reference_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Dato")]),_vm._v(" "),_c('datepicker',{staticClass:"muted-background p2 darkblue gibson h5 border-none not-rounded",attrs:{"bootstrapStyling":false,"placeholder":"Dato","language":_vm.da},model:{value:(_vm.quotationForm.date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "date", $$v)},expression:"quotationForm.date"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Udløbsdato")]),_vm._v(" "),_c('datepicker',{staticClass:"muted-background p2 darkblue gibson h5 border-none not-rounded",attrs:{"bootstrapStyling":false,"placeholder":"Udløbsdato","language":_vm.da},model:{value:(_vm.quotationForm.expiry_date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "expiry_date", $$v)},expression:"quotationForm.expiry_date"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Subject")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"1","name":"subject","required":"","placeholder":"Subject"},model:{value:(_vm.quotationForm.subject),callback:function ($$v) {_vm.$set(_vm.quotationForm, "subject", $$v)},expression:"quotationForm.subject"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Desciption")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"5","name":"description","placeholder":"Desciption"},model:{value:(_vm.quotationForm.description),callback:function ($$v) {_vm.$set(_vm.quotationForm, "description", $$v)},expression:"quotationForm.description"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Standard: Terms and conditions")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"tnc","placeholder":"Display default obligatory terms and conditions here. Scrollable but not editable."},model:{value:(_vm.quotationForm.tnc),callback:function ($$v) {_vm.$set(_vm.quotationForm, "tnc", $$v)},expression:"quotationForm.tnc"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mt1 mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Unikke: Terms and conditions")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"tnc","placeholder":"Editable terms and conditions. Button should save text to send to customer "},model:{value:(_vm.quotationForm.tnc),callback:function ($$v) {_vm.$set(_vm.quotationForm, "tnc", $$v)},expression:"quotationForm.tnc"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 border-none line-height-1 not-rounded flex justify-center tems-center gibson mt1"},[_c('span',{staticClass:"regular h4"},[_vm._v("Save edited text")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Customer note")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"customer_note","placeholder":"Customer Note"},model:{value:(_vm.quotationForm.customer_note),callback:function ($$v) {_vm.$set(_vm.quotationForm, "customer_note", $$v)},expression:"quotationForm.customer_note"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Memo")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"memo","placeholder":"Memo"},model:{value:(_vm.quotationForm.memo),callback:function ($$v) {_vm.$set(_vm.quotationForm, "memo", $$v)},expression:"quotationForm.memo"}})],1)]),_vm._v(" "),_c('div',{staticClass:"table-responsive clearfix col-12 px0"},[_c('table',{staticClass:"table mb3"},[_c('thead',[_c('tr',[_c('td',{staticClass:"plusminuscell"},[_c('button',{staticClass:"action-button p1 regular flex justify-start items-center h6 line-height-1",attrs:{"type":"button"},on:{"click":_vm.addRow}},[_c('span',{},[_c('i',{staticClass:"el-icon-circle-plus-outline"})])])]),_vm._v(" "),_c('td',{staticClass:"itemcell"},[_c('p',{staticClass:"white-button py1 regular flex justify-start items-center h6 line-height-1"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_c('svg',{staticClass:"jam jam-plus-rectangle",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"0","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z"}})])]),_vm._v(" "),_c('span',[_vm._v("Item")])])]),_vm._v(" "),_c('td',{staticClass:"typecell"},[_c('p',{staticClass:"white-button py1 regular flex justify-start items-center h6 line-height-1"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_c('svg',{staticClass:"jam jam-plus-rectangle",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"0","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z"}})])]),_vm._v(" "),_c('span',[_vm._v("Type")])])]),_vm._v(" "),_c('td',{staticClass:"quantitycell"},[_c('p',{staticClass:"white-button py1 regular flex justify-start items-center h6 line-height-1"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_c('svg',{staticClass:"jam jam-plus-rectangle",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"0","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z"}})])]),_vm._v(" "),_c('span',[_vm._v("Quantity")])])]),_vm._v(" "),_c('td',{staticClass:"pricecell"},[_c('p',{staticClass:"white-button py1 regular flex justify-start items-center h6 line-height-1"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_c('svg',{staticClass:"jam jam-plus-rectangle",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"0","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z"}})])]),_vm._v(" "),_c('span',[_vm._v("Pris")])])]),_vm._v(" "),_c('td',{staticClass:"amountcell darkblue-border"},[_c('p',{staticClass:"white-button py1 regular flex justify-start items-center h6 line-height-1"},[_c('span',{staticStyle:{"margin-right":"5px"}},[_c('svg',{staticClass:"jam jam-plus-rectangle",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"0","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M4 2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H4zm0-2h12a4 4 0 0 1 4 4v12a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm7 11v4a1 1 0 0 1-2 0v-4H5a1 1 0 0 1 0-2h4V5a1 1 0 1 1 2 0v4h4a1 1 0 0 1 0 2h-4z"}})])]),_vm._v(" "),_c('span',[_vm._v("Amount")])])])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.quotationForm.rows),function(row,index){return _c('tr',{key:row.id},[_c('td',{staticClass:"plusminuscell"},[_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmRowDelete(row)}),expression:"{ok: confirmRowDelete(row)}"}],key:row.uuid,staticClass:"delete-button p1 regular flex justify-start items-center h6 line-height-1",attrs:{"type":"button","tooltip":"Slet"}},[_c('i',{staticClass:"el-icon-delete"})])]),_vm._v(" "),_c('td',{staticClass:"itemcell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.custom_name),expression:"row.custom_name"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb2 col-12",attrs:{"type":"text","name":'item_name_'+index,"required":"","placeholder":"Title"},domProps:{"value":(row.custom_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "custom_name", $event.target.value)}}}),_vm._v(" "),(_vm.quotationForm.show_line_item_description)?_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 border-none col-12",staticStyle:{"font-size":"1rem"},attrs:{"row":"3","placeholder":"Desc","name":"description"},model:{value:(row.description),callback:function ($$v) {_vm.$set(row, "description", $$v)},expression:"row.description"}}):_vm._e()],1),_vm._v(" "),_c('td',{staticClass:"typecell"},[_c('b-form-select',{staticClass:"muted-background darkblue border-none not-rounded col-12",staticStyle:{"font-size":"1rem","height":"48px"},attrs:{"options":_vm.dataStatus},model:{value:(row.type),callback:function ($$v) {_vm.$set(row, "type", $$v)},expression:"row.type"}})],1),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_quantity),expression:"show_quantity"}],staticClass:"quantitycell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.quantity),expression:"row.quantity"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb2 col-12",attrs:{"type":"text","name":'item_quantity_'+index,"placeholder":"Quantity","required":""},domProps:{"value":(row.quantity)},on:{"change":_vm.calculate,"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "quantity", $event.target.value)}}})]),_vm._v(" "),_c('td',{directives:[{name:"show",rawName:"v-show",value:(_vm.quotationForm.show_line_item_tax),expression:"quotationForm.show_line_item_tax"}],staticClass:"pricecell"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unitPrice),expression:"row.unitPrice"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb2 col-12",attrs:{"type":"text","name":'item_unit_price_'+index,"placeholder":"Unit Price","required":""},domProps:{"value":(row.unitPrice)},on:{"change":_vm.calculate,"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unitPrice", $event.target.value)}}})]),_vm._v(" "),_c('td',{staticClass:"amountcell"},[_c('span',{staticClass:"block p2 regular muted-background line-height-1 flex justify-end items-center col-12",staticStyle:{"height":"48px"}},[_vm._v(_vm._s(row.amount)+" kr")])])])}),0)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('table',{staticClass:"table"},[_c('tbody',[_c('tr',{staticClass:"col-12 px0"},[_c('td',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("\n                                    Sub Total (DKK)\n                                  ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("\n                                    "+_vm._s(_vm.quotationForm.subtotal)+"\n                                  ")])])])]),_vm._v(" "),_c('tr',{staticClass:"col-12 px0"},[_c('td',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('div',{staticClass:"flex-auto"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1"},[_c('span',{staticClass:"inline-block"},[_vm._v("\n                                        Discount\n                                      ")]),_vm._v(" "),[(_vm.quotationForm.subtotalDiscount_type)?_c('span',[_vm._v("(%)")]):_c('span',[_vm._v("(DKK)")])]],2),_vm._v(" "),_c('div',{staticClass:"checkbox mediumgrey h5 line-height-1"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quotationForm.subtotalDiscount_type),expression:"quotationForm.subtotalDiscount_type"}],attrs:{"name":"subtotalDiscount_type","type":"checkbox","value":"1","id":"subtotalDiscount_type"},domProps:{"checked":Array.isArray(_vm.quotationForm.subtotalDiscount_type)?_vm._i(_vm.quotationForm.subtotalDiscount_type,"1")>-1:(_vm.quotationForm.subtotalDiscount_type)},on:{"change":[function($event){var $$a=_vm.quotationForm.subtotalDiscount_type,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.quotationForm, "subtotalDiscount_type", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.quotationForm, "subtotalDiscount_type", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.quotationForm, "subtotalDiscount_type", $$c)}},_vm.calculate]}}),_vm._v(" "),_c('label',{attrs:{"for":"subtotalDiscount_type"}},[_vm._v("in % ?")])])]),_vm._v(" "),_c('div',{staticClass:"flex-none"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quotationForm.subtotalDiscount),expression:"quotationForm.subtotalDiscount"}],staticClass:"darkblue h5 p0 border-none not-rounded quotation-input",staticStyle:{"text-align":"right"},attrs:{"name":"subtotalDiscount","placeholder":"Discount"},domProps:{"value":(_vm.quotationForm.subtotalDiscount)},on:{"change":_vm.calculate,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.quotationForm, "subtotalDiscount", $event.target.value)}}})])])])]),_vm._v(" "),_c('tr',{staticClass:"col-12 px0"},[_c('td',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("Tax (%)")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson line-height-1",staticStyle:{"text-align":"right"}},[_vm._v(_vm._s(_vm.quotationForm.subtotal_tax))])])])]),_vm._v(" "),_c('tr',{staticClass:"col-12 px0"},[_c('td',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1"},[_vm._v("\n                                    Total (DKK)\n                                  ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson line-height-1",staticStyle:{"text-align":"right"}},[(_vm.quotationForm.total < 0)?_c('span',{staticClass:"semi-bold red"},[_vm._v("\n                                    "+_vm._s(_vm.quotationForm.total)+"\n                                  ")]):_c('span',[_vm._v("\n                                    "+_vm._s(_vm.quotationForm.total)+"\n                                  ")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"secondarycolor-background p2 saveDraftSetup"},[_c('b-form-checkbox',{staticClass:"px2 secondarycolor-background white flex justify-start items-center mb0",attrs:{"id":"checkbox1","value":"1","unchecked-value":"0","checked-value":"1"},model:{value:(_vm.quotationForm.is_draft),callback:function ($$v) {_vm.$set(_vm.quotationForm, "is_draft", $$v)},expression:"quotationForm.is_draft"}},[_c('p',{staticClass:"h5 regular gibson line-height-1 mb0 ml2 relative"},[_vm._v("Save as draft")])])],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb3"},[_c('button',{staticClass:"outlined-primary-button p2 not-rounded gibson h5 flex justify-center items-center",attrs:{"type":"button","href":"#/alle-moeder"}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Cancel")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 gibson border-none not-rounded h5 flex justify-center items-center",attrs:{"type":"submit"}},[_c('span',{staticClass:"regular"},[_vm._v("Send tilbud")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])])])])])],1)],1)]),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-xl",modifiers:{"modal-xl":true}}],ref:"tilbudModal",attrs:{"lazy":"","size":"lg"},model:{value:(_vm.tilbudShow),callback:function ($$v) {_vm.tilbudShow=$$v},expression:"tilbudShow"}},[_c('div',{staticClass:"clearfix"},[_c('div',[_c('div',[_c('div',[(_vm.partner.image !== '')?_c('div',{staticClass:"col-12 px0"},[_c('img',{attrs:{"width":"100","src":_vm.partner.image}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"pull-right text-right"},[_vm._v("\n                    Reference Number: "),_c('strong',[_vm._v(_vm._s(_vm.quotation.info.reference_number))]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.quotation.info.date)?_c('span',[_vm._v("Dato: "),_c('strong',[_vm._v(_vm._s(_vm._f("moment")(_vm.quotation.info.date)))]),_vm._v(" "),_c('br')]):_vm._e(),_vm._v(" "),(_vm.quotation.info.date && _vm.quotation.info.expiry_date)?_c('span',[_vm._v("Expire dato: "),_c('strong',[_vm._v(_vm._s(_vm._f("moment")(_vm.quotation.info.expiry_date)))])]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('h5',[_vm._v("Company Information")]),_vm._v(" "),_c('h6',[_c('strong',[_vm._v(_vm._s(_vm.partner.company))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("CVR: "),_c('strong',[_vm._v(_vm._s(_vm.partner.cvr))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Email: "),_c('strong',[_vm._v(_vm._s(_vm.partner.email))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Phone: "),_c('strong',[_vm._v(_vm._s(_vm.partner.mobile))])]),_vm._v(" "),_c('p',{},[_vm._v("Address: "),_c('strong',[_vm._v(_vm._s(_vm.partner.address)+" "+_vm._s(_vm.partner.city))])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"text-right"}),_vm._v(" "),_c('h5',{staticClass:"text-right"},[_vm._v("Kunde")]),_vm._v(" "),_c('div',{staticClass:"pull-right text-right"},[_c('h6',{staticClass:"text-strong"},[_c('strong',[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Email: "),_c('strong',[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Phone: "),_c('strong',[_vm._v(_vm._s(_vm.customer.mobile))])]),_vm._v(" "),_c('p',{},[_vm._v("Address: "),_c('strong',[_vm._v(_vm._s(_vm.customer.mailingstreet)+" "+_vm._s(_vm.customer.mailingcity))])])])]),_vm._v(" "),(_vm.quotation.info.subject || _vm.quotation.info.description)?_c('div',{staticClass:"col-12 px0"},[(_vm.quotation.info.subject)?_c('h5',{domProps:{"textContent":_vm._s(_vm.quotation.info.subject)}}):_vm._e(),_vm._v(" "),(_vm.quotation.info.description)?_c('div',{staticStyle:{"text-align":"justify"},domProps:{"innerHTML":_vm._s(_vm.quotation.info.description)}}):_vm._e(),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-strong"},[_vm._v("#")]),_vm._v(" "),_c('td',{staticClass:"text-strong"},[_vm._v("Item")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Type")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Quantitly")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Unit prcie(Dkk)")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",staticStyle:{"width":"150px"}},[_vm._v("Amount")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.quotation.info.rows),function(item,index){return _c('tr',[_c('td',{domProps:{"textContent":_vm._s(index + 1)}}),_vm._v(" "),_c('td',[(item.custom_name)?_c('span',[_vm._v(_vm._s(item.custom_name))]):_c('span',[_vm._v(_vm._s(item.description))])]),_vm._v(" "),(_vm.quotation.line_item_description)?_c('td',{domProps:{"textContent":_vm._s(item.description)}}):_vm._e(),_vm._v(" "),_c('b-form-select',{staticClass:"text-dark rounded border-0",attrs:{"disabled":"","options":_vm.dataStatus},model:{value:(item.type),callback:function ($$v) {_vm.$set(item, "type", $$v)},expression:"item.type"}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(item.quantity)}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(item.unitPrice,2))}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(item.amount,2))}})],1)}),0)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.quotation.files.length !== 0)?_c('div',[_c('h5',{staticClass:"card-title"},[_vm._v("Attachment")]),_vm._v(" "),_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.quotation.files),function(attachment){return _c('li',{key:attachment.id},[_c('a',[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(_vm._s(attachment))])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px0",staticStyle:{"margin-top":"-17px"}},[_c('table',{staticClass:"table table-bordered"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Subtotal (DKK)")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"150px"},domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal,2))}})]),_vm._v(" "),(_vm.quotation.info.subtotal_discount)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Discount\n                        "),(_vm.quotation.info.subtotal_discount_type)?_c('span',[_vm._v("(%)")]):_c('span',[_vm._v("(DKK)")])]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal_discount_amount,2))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.info.subtotal_tax)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Tax (%)")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotalTax,2))}})]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Total (DKK)")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.total,2))}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 col-md-6"},[(_vm.quotation.info.tnc)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Terms & Conditions:")]),_vm._v("\n                  "+_vm._s(_vm.quotation.info.tnc)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.quotation.info.customer_note)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Customer Note:")]),_vm._v("\n                  "+_vm._s(_vm.quotation.info.customer_note)+"\n                ")]):_vm._e(),_vm._v(" "),(_vm.quotation.info.memo)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Memo:")]),_vm._v("\n                  "+_vm._s(_vm.quotation.info.memo)+"\n                ")]):_vm._e()]),_vm._v(" "),(_vm.quotation.quotation_item)?_c('div',{staticClass:"col-12 col-md-6 pull-right",staticStyle:{"margin-top":"-17px"}},[_c('table',{staticClass:"table table-bordered"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"150px"},domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal,_vm.quotation.currency.decimal_place))}})]),_vm._v(" "),(_vm.quotation.subtotal_discount)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_discount'))+"\n                        "),(_vm.quotation.subtotal_discount_type)?_c('span',[_vm._v("(%)")]):_c('span',[_vm._v("("+_vm._s(_vm.quotation.currency.symbol)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_discount_amount,_vm.getConfig('quotation_subtotal_discount_decimal_place')))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.subtotal_tax)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_tax'))+" (%)")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_tax_amount,_vm.getConfig('quotation_subtotal_tax_decimal_place')))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.subtotal_shipping_and_handling)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_shipping_and_handling'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_shipping_and_handling_amount,_vm.getConfig('quotation_subtotal_shipping_and_handling_decimal_place')))}})]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.total'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.total,_vm.quotation.currency.decimal_place))}})])])])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"py-4 pl-2 pr-2 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-col',{staticClass:"pl-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-left rounded",attrs:{"slot":"modal-cancel","type":"buttom","variant":"secondary"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('i',{staticClass:"el-icon-error"}),_vm._v("Luk\n            ")])],1)],1)]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"px2"},[_c('div',{staticClass:"clearfix pl2"},[_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"hide h6 regular darkblue line-height-4 gibson"},[_vm._v("\n            Alle tilbud\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-end items-end"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.archive",modifiers:{"archive":true}}],staticClass:"outlined-action-button p1 px2 flex justify-start items-center"},[_vm._m(9),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold line-height-1 mb0 ml1"},[_vm._v("\n                Archive\n              ")])])]),_vm._v(" "),_c('b-collapse',{staticClass:"pb2",attrs:{"id":"archive"}},[[(_vm.quotations.length === 0 )?_c('div',[_c('div',{staticClass:"flex justify-center items-center"},[_vm._v("\n                  No items\n                ")])]):_vm._l((_vm.quotations),function(quotation){return _c('div',{key:quotation.id,staticClass:"p2 border-none shadow mb3"},[_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Ref number")]),_vm._v(" "),(quotation.info.reference_number)?_c('span',{staticClass:"h5 regular line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.info.reference_number))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Navn")]),_vm._v(" "),[(quotation.name)?_c('span',{staticClass:"h5 regular line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.name))]):_c('span',{staticClass:"h5 regular line-height-1 m0 gibson"},[_vm._v(" ")])]],2),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('div',{staticClass:"flex flex-column"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Dato sendt")]),_vm._v(" "),(quotation.info.date)?_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.info.date || _vm.moment))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Udløbsdate")]),_vm._v(" "),(quotation.info.expiry_date)?_c('span',{staticClass:"regular line-height-1 m0 gibson expireTableHeader block"},[_vm._v(_vm._s(quotation.info.expiry_date || _vm.moment))]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"hide flex flex-column"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Tilbud sendt")]),_vm._v(" "),[(quotation.sent == '0')?_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v("Nej")]):_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v("Ja")])]],2),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 darkblue light line-height-1"},[_vm._v("Status")]),_vm._v(" "),_c('span',{staticClass:"h6 regular line-height-1 m0 gibson dateTableHeader block"},[(quotation.is_draft === '1')?_c('span',{staticClass:"yellow-background darkblue regular inline-block"},[_vm._v("Draft")]):_vm._e(),_vm._v(" "),(quotation.condition === '1')?_c('span',{staticClass:"lightgrey-background flex justify-center items-center py1 darkblue regular inline-block"},[_c('span',{attrs:{"clas":"inline-block"}},[_c('i',{staticClass:"el-icon-time"})]),_vm._v(" "),_c('span',{staticClass:"pl1 inline-block regular mb0"},[_vm._v("\n                        Afventer\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6 mb1 darkblue light line-height-1"},[_vm._v("Actions")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('button',{staticClass:"mb1 dark-button line-height-1 p2 flex justify-start items-center gibson border-none mr1",on:{"click":function($event){return _vm.showItemDetails(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2"},[_vm._v("\n                      Vis tilbuddet\n                    ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"mb1 action-button line-height-1 p2 flex justify-start items-center gibson border-none mr1"},[_c('span',{staticClass:"regular mb0 mr2"},[_vm._v("\n                      Send\n                    ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"mb1 warning-button line-height-1 p2 flex justify-start items-center gibson mr1",attrs:{"tooltip":"Edit"},on:{"click":function($event){$event.preventDefault();return _vm.editQuotation(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2"},[_vm._v("\n                      Edit\n                    ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-edit"})])]),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(quotation)}),expression:"{ok: confirmDelete(quotation)}"}],key:quotation.id,staticClass:"mb1 delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1",attrs:{"tooltip":"Slet"}},[_c('i',{staticClass:"el-icon-delete"})])])])})]],2)],1),_vm._v(" "),_c('div',{staticClass:"hide table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(11),_vm._v(" "),_c('tbody',_vm._l((_vm.quotations),function(quotation){return _c('tr',{key:quotation.id},[_c('td',[(quotation.info.reference_number)?_c('span',{staticClass:"semi-bold line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.info.reference_number))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.name)?_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.name))]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"dateTableHeader"},[(quotation.info.date)?_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v(_vm._s(quotation.info.date || _vm.moment))]):_vm._e()]),_vm._v(" "),_c('td',[(quotation.info.expiry_date)?_c('span',{staticClass:"regular line-height-1 m0 gibson expireTableHeader block"},[_vm._v(_vm._s(quotation.info.expiry_date || _vm.moment))]):_vm._e()]),_vm._v(" "),_c('td',[[_c('div',{staticClass:"flex justify-center items-center"},[(quotation.sent == '0')?_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v("Nej")]):_c('span',{staticClass:"regular line-height-1 m0 gibson"},[_vm._v("Ja")])])]],2),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0 gibson dateTableHeader block"},[(quotation.is_draft === '1')?_c('span',{staticClass:"yellow-background darkblue regular inline-block"},[_vm._v("Draft")]):_vm._e(),_vm._v(" "),(quotation.condition === '1')?_c('span',{staticClass:"more-muted-background darkblue regular inline-block"},[_vm._m(12,true),_vm._v(" "),_c('span',{staticClass:"regular mb0 mr2"},[_vm._v("\n                        Afventer\n                      ")])]):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"table-option text-center"},[_c('div',{staticClass:"btn-group"},[_c('button',{staticClass:"dark-button line-height-1 p1 flex justify-start items-center gibson border-none mr1",on:{"click":function($event){return _vm.showItemDetails(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                        View\n                      ")]),_vm._v(" "),_vm._m(13,true)]),_vm._v(" "),_vm._m(14,true),_vm._v(" "),_c('button',{staticClass:"warning-button line-height-1 p1 flex justify-start items-center gibson mr1",attrs:{"tooltip":"Edit"},on:{"click":function($event){$event.preventDefault();return _vm.editQuotation(quotation)}}},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                        Edit\n                      ")]),_vm._v(" "),_vm._m(15,true)]),_vm._v(" "),_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(quotation)}),expression:"{ok: confirmDelete(quotation)}"}],key:quotation.id,staticClass:"delete-action-button line-height-1 border-none flex justify-start items-center gibson px2 py1",attrs:{"tooltip":"Slet"}},[_c('i',{staticClass:"el-icon-delete"})])])])])}),0)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix border muted-border p2 px3 pb3 mb2 shadow"},[_c('div',[_c('p',{staticClass:"h6 gibson regular line-height-2 mt2 mb1"},[_vm._v("Tilbud")]),_vm._v(" "),_c('p',{staticClass:"h4 semi-bold darkblue gibson line-height-golden mb1"},[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))]),_vm._v(" "),_c('ol',{staticClass:"breadcrumb list-reset border-none mb0"},[_c('li',{staticClass:"breadcrumb-item h5 gibson"},[_c('router-link',{attrs:{"to":"/alle-moeder"}},[_vm._v("Alle møder")])],1),_vm._v(" "),_c('li',{staticClass:"breadcrumb-item h5 gibson active"},[_vm._v("Tilbud")])]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-golden mb2 px0"},[_vm._v("\n            Her har vi samlet informationerne omkring dit partnerskab. Portalen giver dig blandt andet følgende muligheder:\n          ")]),_vm._v(" "),_c('div',{staticClass:"px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse2",modifiers:{"collapse2":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Kundeinfo\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fil":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse2"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Navn :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Email :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Mobile :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.mobile))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Adresse :")]),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.mailingstreet)+" "+_vm._s(_vm.customer.mailingzip)+" "+_vm._s(_vm.customer.mailingcity))])]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Mødedato :")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 semi-bold darkblue line-height-3 gibson"},[_vm._v(_vm._s(_vm.moment(_vm.app.appointment_date).locale('da').format('LL'))),_c('br'),_vm._v("kl. "+_vm._s(_vm.app.id_times)+" ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Prisen er inkl. moms :")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 semi-bold darkblue line-height-1 gibson"},[_vm._v(_vm._s(_vm.customer.lowamountmoms)+" - "+_vm._s(_vm.customer.highamountmoms)+" kr.")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px1 mb2"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Kommentarer")]),_vm._v(" "),(_vm.app.hentilbud === 0)?_c('p',{staticClass:"h5 regular darkblue line-height-4 gibson"},[_vm._v(_vm._s(_vm.app.comment_to_partner))]):_vm._e()]),_vm._v(" "),(_vm.customer.files.length !== 0)?_c('div',{staticClass:"col-12 px1"},[_c('p',{staticClass:"line-height-1 mb1 h6 darkblue gibson"},[_vm._v("Filer")]),_vm._v(" "),_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.customer.files),function(attachment){return _c('li',{key:attachment.id,staticClass:"py-1"},[_c('a',{attrs:{"href":attachment}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse3",modifiers:{"collapse3":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Opgavens indhold\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse3"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-6 px0"},[_c('b-table',{staticClass:"mb4",attrs:{"striped":"","hover":"","items":_vm.items}})],1)])]),_vm._v(" "),_c('div',{staticClass:"px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.collapse4",modifiers:{"collapse4":true}}],staticClass:"col-12 px0 white-button p1 flex justify-between items-center gibson"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("\n                Billeder\n              ")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-circle-up-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 9.172l3.536 3.535a1 1 0 0 0 1.414-1.414L10.707 7.05a1 1 0 0 0-1.414 0L5.05 11.293a1 1 0 0 0 1.414 1.414L10 9.172zM10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10z"}})])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"collapse4"}},[_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.images),function(image,i){return _c('div',{key:image.id,staticClass:"col-12 px0",staticStyle:{"height":"120px"},on:{"click":function($event){return _vm.onClick(i)}}},[_c('img',{staticClass:"fit",attrs:{"src":image}}),_vm._v(" "),_c('vue-gallery-slideshow',{attrs:{"images":_vm.images,"index":_vm.index},on:{"close":function($event){_vm.index = null}}})],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"px0 my2"},[_c('button',{ref:"addt",staticClass:"col-12 not-rounded action-button gibson p2 h4 flex justify-center items-center line-height-1",attrs:{"name":"moretilbud"},on:{"click":function($event){_vm.newCreatorShow = true}}},[_c('span',{staticClass:"semi-bold gibson"},[_vm._v("Kom i gang")]),_vm._v(" "),_vm._m(16)])]),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0"})],1)]),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal"}],attrs:{"size":"xl","lazy":"","id":"moretilbud"},model:{value:(_vm.newCreatorShow),callback:function ($$v) {_vm.newCreatorShow=$$v},expression:"newCreatorShow"}},[_c('div',{staticClass:"clearfix px1"},[_c('div',{staticClass:"col-12 px0 flex justify-start items-center",on:{"click":function($event){_vm.newCreatorShow = false}}},[_c('span',{staticClass:"h3 darkblue regular line-height-1 mb0 p0"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h5 darkblue semi-bold line-height-1 mb0 ml1"},[_vm._v("Opret tilbud")])]),_vm._v(" "),_c('div',{staticClass:"col-12 my2 px0"},[_c('p',{staticClass:"h5 darkblue regular line-height-3"},[_vm._v("\n              Her kan du oprette et udkast på dit tilbud, og sende til kunden. Tilføj indholdet ved at udfylde de angivne informationer.\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col col-4"},[_c('div',{staticClass:"green-background",staticStyle:{"height":"3px"}})]),_vm._v(" "),_c('div',{staticClass:"col col-4"},[_c('div',{staticClass:"lightgrey-background",staticStyle:{"height":"3px"}})]),_vm._v(" "),_c('div',{staticClass:"col col-4"},[_c('div',{staticClass:"lightgrey-background",staticStyle:{"height":"3px"}})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('form-wizard',{scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"col-12 px0 flex justify-between items-center my2"},[_c('div',[_c('wizard-button',{staticClass:"regular outlined-action-button border green-border line-height-1 flex-auto justify-start items-center inline-block not-rounded",staticStyle:{"padding":"1rem!important","font-size":"16px!important"},nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Tilbage")])])],1),_vm._v(" "),_c('div',[(props.activeTabIndex > 0 && !props.isLastStep)?_c('wizard-button',{staticClass:"regular action-button line-height-1 flex-auto justify-center items-center inline-block not-rounded",staticStyle:{"padding":"1rem!important","font-size":"16px!important","background-color":"rgba(77, 207, 85, 1.0)!important"},nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"mr1"},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_c('wizard-button',{staticClass:"regular action-button line-height-1 flex-auto justify-center items-center inline-block not-rounded",staticStyle:{"padding":"1rem!important","font-size":"16px!important","background-color":"rgba(77, 207, 85, 1.0)!important"},attrs:{"type":"button"},nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"mr1"},[_vm._v(_vm._s(props.isLastStep ? 'Send tilbud' : 'Næste'))]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])],1)])]}}],null,false,3943629147)},[_c('tab-content',{attrs:{"title":""}},[_c('div',{staticClass:"clearfix py2 border muted-border mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.addHeader",modifiers:{"addHeader":true}}],staticClass:"col-12 pr2 white-button flex justify-between items-center gibson"},[_c('div',{staticClass:"flex justify-start items-start px2"},[_c('img',{attrs:{"src":"static/svg/picture-primarycolor.svg","width":"36","height":"36","alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue line-height-3 mb0 pl2"},[_c('span',{staticClass:"regular block left"},[_vm._v("Tilføj oversktift")]),_vm._v(" "),_c('span',{staticClass:"h6 block light left"},[_vm._v("Sample Header Here")])])]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2 px2",attrs:{"id":"addHeader"}},[_c('div',{staticClass:"clearfix pt2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-1 mb1"},[_vm._v("\n                        Overskrift\n                      ")]),_vm._v(" "),_c('input',{staticClass:"h5 col-12 p2 lightgrey-background darkblue line-height-1 border-none",attrs:{"type":"text","placeholder":"Din overskrift"}}),_vm._v(" "),_c('div',{staticClass:"my1"},[_c('el-upload',{staticClass:"col-12 px0",staticStyle:{"border":"1px dashed rgb(25, 163, 192)"},attrs:{"drag":"","action":"https://www.kundematch.dk/customerService.php","multiple":""}},[_c('div',{staticClass:"col-12 px2 flex flex-column justify-center items-center py3"},[_c('img',{attrs:{"src":"static/svg/picture-primarycolor.svg","width":"48"}}),_vm._v(" "),_c('span',{staticClass:"h5 mt2 el-upload__text primarycolor regular line-height-3 px2"},[_vm._v("Tilføj billeder til tilbuddet")])])])],1),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('button',{staticClass:"standard-button p2 px3 line-height-1 h4 semi-bold right"},[_vm._v("Gem")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py2 border muted-border mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.addItem",modifiers:{"addItem":true}}],staticClass:"col-12 pr2 white-button flex justify-between items-center gibson"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('img',{attrs:{"src":"static/svg/mobile.svg","width":"36","height":"36","alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue line-height-3 mb0 pl2"},[_c('span',{staticClass:"regular block"},[_vm._v("Tilføj enhed")])])]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt2"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0 py1 flex justify-between items-center border-top border-bottom muted-border mb2",staticStyle:{"border-left-color":"white","border-right-color":"white"}},[_c('span',[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"h4 primarycolor el-icon-edit"})]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue regular mb0"},[_vm._v("Item Name")])]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue light mb0"},[_vm._v("2,00 kr")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular"},[_vm._v("Subtotal")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue light"},[_vm._v("2,00 kr")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular"},[_vm._v("MOMS")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue light"},[_vm._v("0,00 kr")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('span',{staticClass:"h6 primarycolor regular line-height-1"},[_vm._v("Total")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue light"},[_vm._v("0,00 kr")])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2 px2",attrs:{"id":"addItem"}},[_c('div',{staticClass:"clearfix pt2"},[_c('div',{staticClass:"col-12 px0"},[_c('textarea',{staticClass:"h5 col-12 p2 white-background darkblue line-height-1 border muted-border",attrs:{"name":"","id":"","placeholder":"Navn på enhed","rows":"2"}}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mb2"},[_c('p',{staticClass:"h6 darkblue semi-bold line-height-1 mb1"},[_vm._v("Antal")]),_vm._v(" "),_c('input',{staticClass:"col-12 p1 border muted-border darkblue",attrs:{"type":"text","placeholder":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mb2"},[_c('p',{staticClass:"h6 darkblue semi-bold line-height-1 mb1"},[_vm._v("Type")]),_vm._v(" "),_c('input',{staticClass:"col-12 p1 border muted-border darkblue",attrs:{"type":"text","placeholder":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mb2"},[_c('p',{staticClass:"h6 darkblue semi-bold line-height-1 mb1"},[_vm._v("Pris")]),_vm._v(" "),_c('input',{staticClass:"col-12 p1 border muted-border darkblue",attrs:{"type":"text","placeholder":""}})]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mb2"},[_c('p',{staticClass:"h6 darkblue semi-bold line-height-1 mb1"},[_vm._v("Total")]),_vm._v(" "),_c('input',{staticClass:"col-12 p1 border muted-border darkblue",attrs:{"type":"text","placeholder":""}})]),_vm._v(" "),_c('button',{staticClass:"standard-button p2 px3 line-height-1 h4 semi-bold right"},[_vm._v("Gem")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py2 border muted-border mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.addDiscount",modifiers:{"addDiscount":true}}],staticClass:"col-12 pr2 white-button flex justify-between items-center gibson"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('img',{attrs:{"src":"static/svg/verified-document.svg","width":"36","height":"36","alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue line-height-3 mb0 pl2"},[_c('span',{staticClass:"regular block"},[_vm._v("Tilføj rabat")])])]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2",attrs:{"id":"addDiscount"}},[_c('div',{staticClass:"clearfix pt2"},[_c('div',{staticClass:"clearfix flex justify-start items-start px0 mb2"},[_c('div',{staticClass:"col col-5 pr2 pl2"},[_c('div',{staticClass:"green-background p2 white flex justify-center items-center"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("Beløb")])])]),_vm._v(" "),_c('div',{staticClass:"col col-7 px0 pr2 pl0"},[_c('div',{staticClass:"lightgrey-background p2 flex justify-start items-center"},[_c('input',{staticClass:"h5 regular line-height-1 border-none",staticStyle:{"text-align":"right","background-color":"transparent","margin-bottom":"0!important","width":"100px","padding-right":"8px"},attrs:{"type":"text","placeholder":"0,00"}}),_vm._v(" "),_c('span',{staticClass:"h5 caps line-height-1 mb0"},[_vm._v("DKK")])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix flex justify-start items-start px0 mb2"},[_c('div',{staticClass:"col col-5 pr2 pl2"},[_c('div',{staticClass:"border green-border green p2 flex justify-center items-center"},[_c('p',{staticClass:"h5 semi-bold line-height-1 mb0"},[_vm._v("Procent")])])]),_vm._v(" "),_c('div',{staticClass:"col col-7 px0 pr2 pl0"},[_c('div',{staticClass:"lightgrey-background p2 flex justify-start items-center"},[_c('input',{staticClass:"h5 regular line-height-1 border-none",staticStyle:{"text-align":"right","background-color":"transparent","margin-bottom":"0!important","width":"100px","padding-right":"8px"},attrs:{"type":"text","placeholder":"0.00"}}),_vm._v(" "),_c('span',{staticClass:"h5 semi-bold caps line-height-1 mb0"},[_vm._v("%")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('button',{staticClass:"standard-button p2 px3 line-height-1 h4 semi-bold right"},[_vm._v("Gem")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py2 border muted-border mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.addCustomer",modifiers:{"addCustomer":true}}],staticClass:"col-12 pr2 white-button flex justify-between items-center gibson"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('img',{attrs:{"src":"static/svg/handshake.svg","width":"36","height":"36","alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue line-height-3 mb0 pl2"},[_c('span',{staticClass:"regular block left"},[_vm._v("Tilføj kunde")]),_vm._v(" "),_c('span',{staticClass:"h6 block light left"},[_vm._v("Sample Name Here")])])]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2 px2",attrs:{"id":"addCustomer"}},[_c('div',{staticClass:"clearfix pt2"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col col-6 pr2 pl0"},[_c('div',{staticClass:"col-12 p2 green-background center white line-height-1"},[_c('span',{staticClass:"h5 regular mb0"},[_vm._v("Kunde")])])]),_vm._v(" "),_c('div',{staticClass:"col col-6 px0"},[_c('div',{staticClass:"col-12 p2 border darkblue-border center darkblue line-height-1"},[_c('span',{staticClass:"h5 regular mb0"},[_vm._v("Kontakt")])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column mt2 px0"},[_c('input',{staticClass:"h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2",attrs:{"type":"text","placeholder":"Navn"}}),_vm._v(" "),_c('input',{staticClass:"h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2",attrs:{"type":"text","placeholder":"Email"}}),_vm._v(" "),_c('input',{staticClass:"h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2",attrs:{"type":"text","placeholder":"Mobil"}}),_vm._v(" "),_c('input',{staticClass:"h5 semi-bold p2 darkblue lightgrey-background line-height-1 border-none mb2",attrs:{"type":"address","placeholder":"Adresse"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center px0 mb2"},[_c('span',{staticClass:"col-5 flex-auto h6 darkblue line-height-1 mb0 px2 py1"},[_vm._v("Dato")]),_vm._v(" "),_c('div',{staticClass:"py1 lightgrey-background flex justify-between items-center"},[_c('datepicker',{staticClass:"darkblue gibson border-none not-rounded",attrs:{"bootstrapStyling":true,"placeholder":"Dato","language":_vm.da},model:{value:(_vm.quotationForm.date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "date", $$v)},expression:"quotationForm.date"}}),_vm._v(" "),_c('button',{staticClass:"border-none flex justify-center items-center line-height-1 darkblue",staticStyle:{"background":"transparent"}},[_c('span',[_c('svg',{staticClass:"jam jam-trash",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 2V1a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v1h4a2 2 0 0 1 2 2v1a2 2 0 0 1-2 2h-.133l-.68 10.2a3 3 0 0 1-2.993 2.8H5.826a3 3 0 0 1-2.993-2.796L2.137 7H2a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h4zm10 2H2v1h14V4zM4.141 7l.687 10.068a1 1 0 0 0 .998.932h6.368a1 1 0 0 0 .998-.934L13.862 7h-9.72zM7 8a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V9a1 1 0 0 1 1-1z"}})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center px0 mb2"},[_c('span',{staticClass:"col-5 flex-auto h6 darkblue line-height-1 mb0 px2 py1"},[_vm._v("Udløbsdato")]),_vm._v(" "),_c('div',{staticClass:"py1 lightgrey-background flex justify-between items-center"},[_c('datepicker',{staticClass:"darkblue gibson border-none not-rounded",attrs:{"bootstrapStyling":true,"placeholder":"Dato","language":_vm.da},model:{value:(_vm.quotationForm.date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "date", $$v)},expression:"quotationForm.date"}}),_vm._v(" "),_c('button',{staticClass:"border-none flex justify-center items-center line-height-1 darkblue",staticStyle:{"background":"transparent"}},[_c('span',[_c('svg',{staticClass:"jam jam-trash-alt-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.778 6l-.673 12.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.222 6h13.556zM1 0h14a1 1 0 0 1 1 1v2a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm5 8a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1zm4 0a1 1 0 0 0-1 1v7a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1z"}})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center px0 mb2"},[_c('textarea',{staticClass:"h5 col-12 lightgrey-background border-none p2 darkblue line-height-4 mb2",staticStyle:{"resize":"none"},attrs:{"name":"","id":"","rows":"2","placeholder":"Kommentar"}})]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{staticClass:"standard-button p2 px3 line-height-1 h4 semi-bold right"},[_vm._v("Gem")])])])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix py2 border muted-border mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.addConditions",modifiers:{"addConditions":true}}],staticClass:"col-12 pr2 white-button flex justify-between items-center gibson"},[_c('div',{staticClass:"flex justify-start items-center px2"},[_c('img',{attrs:{"src":"static/svg/documents-blue.svg","width":"36","height":"36","alt":""}}),_vm._v(" "),_c('p',{staticClass:"h5 darkblue line-height-3 mb0 pl2"},[_c('span',{staticClass:"regular block"},[_vm._v("Tilføj betingelser")])])]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-right",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-8 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M5.314 7.071l-4.95-4.95A1 1 0 0 1 1.778.707l5.657 5.657a1 1 0 0 1 0 1.414l-5.657 5.657a1 1 0 0 1-1.414-1.414l4.95-4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"mt2 px2",attrs:{"id":"addConditions"}},[_c('div',{staticClass:"clearfix pt2"},[_c('div',{staticClass:"col-12 px0 flex flex-column mb2"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                        Standardnoter\n                      ")]),_vm._v(" "),_c('textarea',{staticClass:"lightgrey-background p2 h6 line-height-3 border-none regular",staticStyle:{"min-height":"180px"},attrs:{"name":"","id":"","readonly":""}},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Consectetur alias dolorum culpa perspiciatis deserunt voluptates sapiente voluptatum temporibus, obcaecati suscipit ratione fugiat! Est ullam aspernatur libero? Modi corporis illum obcaecati.")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-column mb2"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                        Brugerdefinerede noter\n                      ")]),_vm._v(" "),_c('div',{staticClass:"my1"},[_c('el-upload',{staticClass:"col-12 px0 py2",staticStyle:{"border":"1px dashed rgb(25, 163, 192)"},attrs:{"drag":"","action":"https://www.kundematch.dk/customerService.php","multiple":""}},[_c('div',{staticClass:"col-12 mt1 px2 flex flex-column justify-center items-center"},[_c('img',{attrs:{"src":"static/svg/picture-primarycolor.svg","width":"48"}}),_vm._v(" "),_c('span',{staticClass:"h5 mt2 mb0 el-upload__text primarycolor regular line-height-3 px2"},[_vm._v("Tilføj dine noter her")])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{staticClass:"standard-button p2 px3 line-height-1 h4 semi-bold right"},[_vm._v("Gem")])])])])],1)]),_vm._v(" "),_c('tab-content',{attrs:{"title":""}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 mb3"},[_c('span',{staticClass:"block h5 darkblue semi-bold line-height-3 mb0"},[_vm._v("\n                    Vis dine anbefalinger frem på dit tilbud:\n                  ")]),_vm._v(" "),_c('span',{staticClass:"mt3 block h5 line-height-1 mb0 flex justify-between items-start"},[_c('span',{staticClass:"darkblue regular"},[_vm._v("Udvalgte anbefalinger:")]),_vm._v(" "),_c('span',{staticClass:"primarycolor semi-bold"},[_vm._v("0 / 5")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column"},[_c('div',{staticClass:"p2 border muted-border shadow mb3"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-start"},[_c('div',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","rating":4.5,"max-rating":5,"increment":0.5,"item-size":22,"spacing":1,"show-rating":false,"read-only":true}})],1),_vm._v(" "),_c('div',[_c('input',{staticStyle:{"height":"18px","width":"18px"},attrs:{"type":"checkbox"}})])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('span',{staticClass:"h5 darkblue regular line-height-1 mb0"},[_vm._v("review.date")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue regular line-height-2"},[_vm._v("review.author")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h6 darkblue light line-height-3"},[_vm._v("\n                        Lorem ipsum, dolor sit amet consectetur adipisicing elit. Ipsum inventore, molestias eligendi ipsa...\n                      ")])])])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":""}},[_c('div',{staticClass:"clearfix py3"},[_c('div',{staticClass:"col-12 px0 flex flex-column justify-center items-center"},[_c('div',{staticClass:"my2"},[_c('img',{attrs:{"src":"static/svg/curriculum.svg","width":"96","alt":""}})]),_vm._v(" "),_c('p',{staticClass:"h3 center primarycolor semi-bold line-height-3 mb1"},[_vm._v("Du er der næsten!")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-3 mb3 center"},[_vm._v("Gennemgå dit tilbud ved at klikke på Forhåndsvisning")]),_vm._v(" "),_c('button',{staticClass:"standard-button p2 flex justify-center items-center line-height-1"},[_c('span',{staticClass:"mr2"},[_c('svg',{staticClass:"icon__icon",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M6 15H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v3h3l3 3v10a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2v-3zm0-2V7a2 2 0 0 1 2-2h2V2H2v11h4zm8.172-6H8v11h8V8.828L14.172 7z"}})])]),_vm._v(" "),_c('span',{staticClass:"h5"},[_vm._v("Forhåndsvisning")])])])])])],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix my3"},[_c('form',{on:{"submit":_vm.onSubmitTilbud,"reset":_vm.resetForm}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix my2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Logo")]),_vm._v(" "),(!_vm.image)?_c('div',{staticClass:"my2"},[_c('input',{staticClass:"col-12 muted-background darkblue gibson h5 p2",attrs:{"type":"file"},on:{"change":_vm.onFileChange}})]):_c('div',{staticClass:"my2"},[_c('div',{staticClass:"flex justify-between items-start"},[_c('img',{staticClass:"mb2 fit",attrs:{"width":"80","src":_vm.image}}),_vm._v(" "),_c('button',{staticClass:"not-rounded delete-button p1 border-none",on:{"click":_vm.removeImage}},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])])])])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('file-upload-input',{attrs:{"token":_vm.quotationForm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Reference #")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.quotationForm.reference_number),expression:"quotationForm.reference_number"}],staticClass:"col-12 muted-background darkblue h5 p2 border-none not-rounded",attrs:{"type":"text","value":"","name":"reference_number","required":"","placeholder":"Reference #"},domProps:{"value":(_vm.quotationForm.reference_number)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.quotationForm, "reference_number", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Dato")]),_vm._v(" "),_c('datepicker',{staticClass:"muted-background p2 darkblue gibson h5 border-none not-rounded",attrs:{"bootstrapStyling":false,"placeholder":"Dato","language":_vm.da},model:{value:(_vm.quotationForm.date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "date", $$v)},expression:"quotationForm.date"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Udløbsdato")]),_vm._v(" "),_c('datepicker',{staticClass:"muted-background p2 darkblue gibson h5 border-none not-rounded",attrs:{"bootstrapStyling":false,"placeholder":"Udløbsdato","language":_vm.da},model:{value:(_vm.quotationForm.expiry_date),callback:function ($$v) {_vm.$set(_vm.quotationForm, "expiry_date", $$v)},expression:"quotationForm.expiry_date"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Emne")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"1","name":"subject","required":"","placeholder":"Subject"},model:{value:(_vm.quotationForm.subject),callback:function ($$v) {_vm.$set(_vm.quotationForm, "subject", $$v)},expression:"quotationForm.subject"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"5","name":"description","placeholder":"Desciption"},model:{value:(_vm.quotationForm.description),callback:function ($$v) {_vm.$set(_vm.quotationForm, "description", $$v)},expression:"quotationForm.description"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Default: Vilkår og betingelser")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"tnc","placeholder":"Display default obligatory terms and conditions here. Scrollable but not editable."},model:{value:(_vm.quotationForm.tnc),callback:function ($$v) {_vm.$set(_vm.quotationForm, "tnc", $$v)},expression:"quotationForm.tnc"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix mt1 mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Custom: Vilkår og betingelser")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"tnc","placeholder":"Editable terms and conditions. Button should save text to send to customer "},model:{value:(_vm.quotationForm.tnc),callback:function ($$v) {_vm.$set(_vm.quotationForm, "tnc", $$v)},expression:"quotationForm.tnc"}}),_vm._v(" "),_c('button',{staticClass:"col-12 action-button p2 h5 border-none line-height-1 not-rounded flex justify-center items-center gibson mt1"},[_c('span',{staticClass:"regular"},[_vm._v("Gem redigeret udgave")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Customer note")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"customer_note","placeholder":"Customer Note"},model:{value:(_vm.quotationForm.customer_note),callback:function ($$v) {_vm.$set(_vm.quotationForm, "customer_note", $$v)},expression:"quotationForm.customer_note"}})],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1"},[_vm._v("Memo")]),_vm._v(" "),_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 h5 border-none",attrs:{"rows":"3","name":"memo","placeholder":"Memo"},model:{value:(_vm.quotationForm.memo),callback:function ($$v) {_vm.$set(_vm.quotationForm, "memo", $$v)},expression:"quotationForm.memo"}})],1)]),_vm._v(" "),_c('button',{staticClass:"dark-button col-12 p2 h4 regular flex justify-center items-center line-height-1",attrs:{"type":"button"},on:{"click":function($event){_vm.offerModalShow = true}}},[_c('span',[_vm._v("Tilføj items")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-circle-plus"})])]),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal.modal-xl",modifiers:{"modal-xl":true}}],ref:"offerModal",staticClass:"offerModal",attrs:{"lazy":"","size":"lg"},model:{value:(_vm.offerModalShow),callback:function ($$v) {_vm.offerModalShow=$$v},expression:"offerModalShow"}},[_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"action-button p1 h4 regular flex justify-start items-center h6 line-height-1",attrs:{"type":"button"},on:{"click":_vm.addRow}},[_c('span',{},[_c('i',{staticClass:"el-icon-circle-plus-outline"})]),_vm._v(" "),_c('span',[_vm._v("Tilføj item")])]),_vm._v(" "),_c('div',{staticClass:"mt2 mb3"},_vm._l((_vm.quotationForm.rows),function(row,index){return _c('div',{key:row.id,staticClass:"flex flex-column"},[_c('div',[_c('div',{staticClass:"flex flex-column col-12 px0 mt2 mb3"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                            Titel og beskrivelse\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.custom_name),expression:"row.custom_name"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb1 col-12",attrs:{"type":"text","name":'item_name_'+index,"required":"","placeholder":"Title"},domProps:{"value":(row.custom_name)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "custom_name", $event.target.value)}}}),_vm._v(" "),(_vm.quotationForm.show_line_item_description)?_c('autosize-textarea',{staticClass:"not-rounded muted-background p2 darkblue gibson line-height-4 border-none col-12",staticStyle:{"font-size":"1rem"},attrs:{"row":"8","placeholder":"Desc","name":"description"},model:{value:(row.description),callback:function ($$v) {_vm.$set(row, "description", $$v)},expression:"row.description"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 px0 mb3"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                            Type\n                          ")]),_vm._v(" "),_c('b-form-select',{staticClass:"muted-background darkblue border-none not-rounded col-12 flex-none",staticStyle:{"font-size":"1rem","height":"48px"},attrs:{"options":_vm.dataStatus},model:{value:(row.type),callback:function ($$v) {_vm.$set(row, "type", $$v)},expression:"row.type"}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.show_quantity),expression:"show_quantity"}],staticClass:"flex flex-column col-12 px0 mb3"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                            Quantity\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.quantity),expression:"row.quantity"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb2 col-12",attrs:{"type":"text","name":'item_quantity_'+index,"placeholder":"Quantity","required":""},domProps:{"value":(row.quantity)},on:{"change":_vm.calculate,"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "quantity", $event.target.value)}}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.quotationForm.show_line_item_tax),expression:"quotationForm.show_line_item_tax"}],staticClass:"flex flex-column col-12 px0"},[_c('p',{staticClass:"h6 darkblue regular line-height-1 mb1"},[_vm._v("\n                            Pris\n                          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(row.unitPrice),expression:"row.unitPrice"}],staticClass:"muted-background darkblue p2 border-none not-rounded h6 mb2 col-12",attrs:{"type":"text","name":'item_unit_price_'+index,"placeholder":"Unit Price","required":""},domProps:{"value":(row.unitPrice)},on:{"change":_vm.calculate,"input":function($event){if($event.target.composing){ return; }_vm.$set(row, "unitPrice", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 px0"},[_c('span',{staticClass:"block p2 regular muted-background line-height-1 flex justify-end items-center col-12",staticStyle:{"height":"48px"}},[_vm._v(_vm._s(row.amount)+" kr")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-end items-center mt3"},[_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmRowDelete(row)}),expression:"{ok: confirmRowDelete(row)}"}],key:row.uuid,staticClass:"delete-button p2 regular flex justify-start items-center h6 line-height-1 mr3",attrs:{"type":"button","tooltip":"Slet"}},[_c('i',{staticClass:"el-icon-delete"}),_vm._v(" "),_c('span',{staticClass:"ml2"},[_vm._v("Slet")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 regular flex justoify-center items-center h6 line-height-1"},[_c('span',{staticClass:"mr2"},[_vm._v("Gem")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"secondarycolor-background p2 saveDraftSetup"},[_c('b-form-checkbox',{staticClass:"px2 secondarycolor-background white flex justify-start items-center mb0",attrs:{"id":"checkbox1","value":"1","unchecked-value":"0","checked-value":"1"},model:{value:(_vm.quotationForm.is_draft),callback:function ($$v) {_vm.$set(_vm.quotationForm, "is_draft", $$v)},expression:"quotationForm.is_draft"}},[_c('p',{staticClass:"h5 regular gibson line-height-1 mb0 ml2 relative",staticStyle:{"top":"-2px"}},[_vm._v("Save as draft")])])],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb3"},[_c('button',{staticClass:"outlined-primary-button p2 not-rounded gibson h5 flex justify-center items-center",attrs:{"type":"button","href":"#/alle-moeder"}},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Cancel")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 gibson border-none not-rounded h5 flex justify-center items-center",attrs:{"type":"submit"}},[_c('span',{staticClass:"regular"},[_vm._v("Send tilbud")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])],1)])])]),_vm._v(" "),_c('b-modal',{directives:[{name:"b-modal",rawName:"v-b-modal"}],ref:"tilbudModal",attrs:{"lazy":""},model:{value:(_vm.tilbudShow),callback:function ($$v) {_vm.tilbudShow=$$v},expression:"tilbudShow"}},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"center mt3 mb2"},[_c('p',{staticClass:"h4 darkblue line-height-2 mb0"},[_vm._v(_vm._s(_vm.partner.company))])]),_vm._v(" "),(_vm.partner.image !== '')?_c('div',{staticClass:"col-12 px0"},[_c('img',{staticClass:"fit block",staticStyle:{"object-fit":"fill"},attrs:{"src":"static/img/forside_cover.jpg","alt":""}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mt2 center"},[_c('p',{staticClass:"h6 semi-bold line-height-2 darkblue gibson"},[_vm._v("\n                "+_vm._s(_vm.quotation.info.reference_number)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-start my3"},[_c('div',[_c('span',{staticClass:"block darkblue flex flex-column justify-start items-start"},[_c('span',{staticClass:"h6 light line-height-1 mb1"},[_vm._v("Dato sendt")]),_vm._v(" "),_c('span',{staticClass:"semi-bold line-height-1"},[_vm._v(_vm._s(_vm.moment(_vm.quotation.info.date).locale('da').format('LL')))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"block darkblue flex flex-column justify-start items-start"},[_c('span',{staticClass:"h6 light line-height-1 mb1"},[_vm._v("Udløbsdato")]),_vm._v(" "),(_vm.quotation.info.date && _vm.quotation.info.expiry_date)?_c('span',{staticClass:"semi-bold line-height-1"},[_vm._v(_vm._s(_vm.moment(_vm.quotation.info.expiry_date).locale('da').format('LL')))]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0"},[_c('h5',[_vm._v("Company Information")]),_vm._v(" "),_c('h6',[_c('strong',[_vm._v(_vm._s(_vm.partner.company))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("CVR: "),_c('strong',[_vm._v(_vm._s(_vm.partner.cvr))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Email: "),_c('strong',[_vm._v(_vm._s(_vm.partner.email))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Phone: "),_c('strong',[_vm._v(_vm._s(_vm.partner.mobile))])]),_vm._v(" "),_c('p',{},[_vm._v("Address: "),_c('strong',[_vm._v(_vm._s(_vm.partner.address)+" "+_vm._s(_vm.partner.city))])])]),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0"},[_c('div',{staticClass:"text-right"}),_vm._v(" "),_c('h5',{staticClass:"text-right"},[_vm._v("Kunde")]),_vm._v(" "),_c('div',{staticClass:"pull-right text-right"},[_c('h6',{staticClass:"text-strong"},[_c('strong',[_vm._v(_vm._s(_vm.customer.firstname)+" "+_vm._s(_vm.customer.lastname))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Email: "),_c('strong',[_vm._v(_vm._s(_vm.customer.email))])]),_vm._v(" "),_c('p',{staticClass:"contact-info"},[_vm._v("Phone: "),_c('strong',[_vm._v(_vm._s(_vm.customer.mobile))])]),_vm._v(" "),_c('p',{},[_vm._v("Address: "),_c('strong',[_vm._v(_vm._s(_vm.customer.mailingstreet)+" "+_vm._s(_vm.customer.mailingcity))])])])]),_vm._v(" "),(_vm.quotation.info.subject || _vm.quotation.info.description)?_c('div',{staticClass:"col-12 px0"},[(_vm.quotation.info.subject)?_c('h5',{domProps:{"textContent":_vm._s(_vm.quotation.info.subject)}}):_vm._e(),_vm._v(" "),(_vm.quotation.info.description)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.quotation.info.description)}}):_vm._e(),_vm._v(" "),_c('hr')]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix"},_vm._l((_vm.quotation.info.rows),function(item,index){return _c('div',{key:item.id},[_c('div',{staticClass:"py1 border-top mediumgrey-border"},[_c('span',{staticClass:"hide",domProps:{"innerHTML":_vm._s(index + 1)}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"flex justify-between items-start"},[_c('span',{staticClass:"inline-block flex flex-column pr1"},[_c('span',{staticClass:"h6 block light line-height-1"},[_vm._v("Antal:")]),_vm._v(" "),_c('span',{staticClass:"block semi-bold line-height-1",domProps:{"textContent":_vm._s(item.quantity)}})]),_vm._v(" "),(item.custom_name)?_c('span',{staticClass:"inline-block flex-auto flex-column pr1"},[_c('span',{staticClass:"h6 block light line-height-1"},[_vm._v("Navn")]),_vm._v(" "),_c('span',{staticClass:"h6 block semi-bold line-height-2 mb0"},[_vm._v(_vm._s(item.custom_name))]),_vm._v(" "),(item.custom_description)?_c('span',{staticClass:"h6 block regular line-height-2 mb0"}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"inline-block flex flex-column mt1"},[_c('span',{staticClass:"block flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular line-height-1"},[_vm._v("Pris:")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue semi-bold line-height-1",domProps:{"textContent":_vm._s(_vm.formatNumber(item.unitPrice,2))}})]),_vm._v(" "),_c('span',{staticClass:"block flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular line-height-1"},[_vm._v("Total")]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue semi-bold line-height-1",domProps:{"textContent":_vm._s(_vm.formatNumber(item.amount,2))}})])])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"hide inline-block flex flex-column"},[_c('span',{staticClass:"inline-block flex flex-column pr1"},[_c('span',{staticClass:"h6 block light line-height-1"},[_vm._v("Pris:")]),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.formatNumber(item.unitPrice,2))}}),_vm._v(" "),_c('p',{domProps:{"textContent":_vm._s(_vm.formatNumber(item.amount,2))}})])])])])])])}),0),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-column border-top muted-border mt3 mb2 py2"},[_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular mb0"},[_vm._v("Subtotal (DKK)")]),_vm._v(" "),_c('span',[_c('span',{staticClass:"h6 darkblue semi-bold mb0",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal,2))}})])]),_vm._v(" "),(_vm.quotation.info.subtotal_discount)?_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('div',[_c('span',{staticClass:"h6 darkblue regular mb0"},[_vm._v("Discount")]),_vm._v(" "),_c('span',[(_vm.quotation.info.subtotal_discount_type)?_c('span',{staticClass:"h6 darkblue semi-bold mb0"},[_vm._v("(%)")]):_c('span',{staticClass:"h6 darkblue semi-bold mb0"},[_vm._v("(DKK)")])])]),_vm._v(" "),_c('div',{domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal_discount_amount,2))}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center"},[_c('span',{staticClass:"h6 darkblue regular mb0"},[_vm._v("Moms (25%)")]),_vm._v(" "),[(_vm.quotation.info.subtotal_tax)?_c('span',[_c('span',{staticClass:"h6 darkblue semi-bold mb0",domProps:{"innerHTML":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal_tax))}})]):_c('span',{staticClass:"h6 darkblue semi-bold mb0"})]],2),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-end"},[_c('span',{staticClass:"h6 darkblue regular mb0"},[_vm._v("Total (DKK)")]),_vm._v(" "),_c('span',[_c('span',{staticClass:"h6 darkblue semi-bold mb0",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.total,2))}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.quotation.info.tnc)?_c('div',{staticClass:"mt2"},[_c('p',{staticClass:"h6 darkblue line-height-2 mb0"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Terms & Conditions:")]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v(_vm._s(_vm.quotation.info.tnc))])])]):_vm._e(),_vm._v(" "),(_vm.quotation.info.customer_note)?_c('div',{staticClass:"mt2"},[_c('p',{staticClass:"h6 darkblue line-height-2 mb0"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Customer Note:")]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v(_vm._s(_vm.quotation.info.customer_note))])])]):_vm._e(),_vm._v(" "),(_vm.quotation.info.memo)?_c('div',{staticClass:"mt2"},[_c('p',{staticClass:"h6 darkblue line-height-2 mb0"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Memo:")]),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v(_vm._s(_vm.quotation.info.memo))])])]):_vm._e()])]),_vm._v(" "),(_vm.quotation.files.length !== 0)?_c('div',{staticClass:"py1 border-top mediumgrey-border"},[_c('div',{staticClass:"col-12 px0"},[_c('div',[_c('p',{staticClass:"block h6 semi-bold line-height-1"},[_vm._v("Attachments")]),_vm._v(" "),_c('ul',{staticClass:"list-reset"},_vm._l((_vm.quotation.files),function(attachment){return _c('li',{key:attachment.id,staticClass:"flex justify-start items-center"},[_c('a',{staticClass:"block flex justify-start items-center"},[_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-paperclip"})]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold line-height-1"},[_vm._v(_vm._s(attachment))])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0"},[_c('div',{staticClass:"table-responsive"},[_c('table',{staticClass:"table table-bordered"},[_c('thead',[_c('tr',[_c('td',{staticClass:"text-strong"},[_vm._v("#")]),_vm._v(" "),_c('td',{staticClass:"text-strong"},[_vm._v("Item")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Type")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Quantitly")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-left"},[_vm._v("Unit prcie(Dkk)")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",staticStyle:{"width":"150px"}},[_vm._v("Amount")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.quotation.info.rows),function(item,index){return _c('tr',{key:item.id},[_c('td',{domProps:{"textContent":_vm._s(index + 1)}}),_vm._v(" "),_c('td',[(item.custom_name)?_c('span',[_vm._v(_vm._s(item.custom_name))]):_c('span',[_vm._v(_vm._s(item.description))])]),_vm._v(" "),(_vm.quotation.line_item_description)?_c('td',{domProps:{"textContent":_vm._s(item.description)}}):_vm._e(),_vm._v(" "),_c('b-form-select',{staticClass:"text-dark rounded border-0",attrs:{"disabled":"","options":_vm.dataStatus},model:{value:(item.type),callback:function ($$v) {_vm.$set(item, "type", $$v)},expression:"item.type"}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(item.quantity)}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(item.unitPrice,2))}}),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(item.amount,2))}})],1)}),0)])]),_vm._v(" "),(_vm.quotation.quotation_item)?_c('div',{staticClass:"hide col-12 px0"},[_c('table',{staticClass:"table table-bordered"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"150px"},domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal,_vm.quotation.currency.decimal_place))}})]),_vm._v(" "),(_vm.quotation.subtotal_discount)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_discount'))+"\n                      "),(_vm.quotation.subtotal_discount_type)?_c('span',[_vm._v("(%)")]):_c('span',[_vm._v("("+_vm._s(_vm.quotation.currency.symbol)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_discount_amount,_vm.getConfig('quotation_subtotal_discount_decimal_place')))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.subtotal_tax)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_tax'))+" (%)")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_tax_amount,_vm.getConfig('quotation_subtotal_tax_decimal_place')))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.subtotal_shipping_and_handling)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.subtotal_shipping_and_handling'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.subtotal_shipping_and_handling_amount,_vm.getConfig('quotation_subtotal_shipping_and_handling_decimal_place')))}})]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v(_vm._s(_vm.trans('quotation.total'))+" ("+_vm._s(_vm.quotation.currency.symbol)+")")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.total,_vm.quotation.currency.decimal_place))}})])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0"},[(_vm.quotation.files.length !== 0)?_c('div',[_c('h5',{staticClass:"card-title"},[_vm._v("Attachment")]),_vm._v(" "),_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.quotation.files),function(attachment){return _c('li',{key:attachment.id},[_c('a',[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(_vm._s(attachment))])])}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"hide col-12 px0",staticStyle:{"margin-top":"-17px"}},[_c('table',{staticClass:"table table-bordered"},[_c('tbody',[_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Subtotal (DKK)")]),_vm._v(" "),_c('td',{staticClass:"text-right",staticStyle:{"width":"150px"},domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal,2))}})]),_vm._v(" "),(_vm.quotation.info.subtotal_discount)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Discount\n                    "),(_vm.quotation.info.subtotal_discount_type)?_c('span',[_vm._v("(%)")]):_c('span',[_vm._v("(DKK)")])]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotal_discount_amount,2))}})]):_vm._e(),_vm._v(" "),(_vm.quotation.info.subtotal_tax)?_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Tax (%)")]),_vm._v(" "),_c('td',{staticClass:"text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.subtotalTax,2))}})]):_vm._e(),_vm._v(" "),_c('tr',[_c('td',{staticClass:"text-strong text-right"},[_vm._v("Total (DKK)")]),_vm._v(" "),_c('td',{staticClass:"text-strong text-right",domProps:{"textContent":_vm._s(_vm.formatNumber(_vm.quotation.info.total,2))}})])])])]),_vm._v(" "),_c('div',{staticClass:"hide col-12 col-md-6"},[(_vm.quotation.info.tnc)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Terms & Conditions:")]),_vm._v("\n              "+_vm._s(_vm.quotation.info.tnc)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.quotation.info.customer_note)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Customer Note:")]),_vm._v("\n              "+_vm._s(_vm.quotation.info.customer_note)+"\n            ")]):_vm._e(),_vm._v(" "),(_vm.quotation.info.memo)?_c('blockquote',{staticStyle:{"margin-top":"10px"}},[_c('h6',{staticClass:"card-title"},[_vm._v("Memo:")]),_vm._v("\n              "+_vm._s(_vm.quotation.info.memo)+"\n            ")]):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"col-12 border-none px0 mb3",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"col-5 h5 mx-auto standard-button p2 px3 flex justify-center items-center",attrs:{"slot":"modal-cancel","type":"buttom"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('span',{staticClass:"semi-bold"},[_vm._v("Luk")]),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-close semi-bold"})])])])]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1):_vm._e()],2)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"h5 primarycolor no-hover block no-hover gibson line-height-1 semi-bold",attrs:{"href":"javascript:history.go(-1)"}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"h5 primarycolor no-hover block no-hover gibson line-height-1 semi-bold",attrs:{"href":"javascript:history.go(-1)"}},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Tilbage")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"my3 px2"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-4 gibson"},[_vm._v("\n            Alle tilbud\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 semi-bold line-height-1 m0 gibson gibson"},[_vm._v("Adresse")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 semi-bold line-height-1 m0 gibson gibson"},[_vm._v("Date sent")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 semi-bold line-height-1 m0 gibson gibson"},[_vm._v("Status")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-time"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button line-height-1 p1 flex justify-start items-center gibson border-none mr1"},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                          Send\n                        ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('i',{staticClass:"h5 line-height-1 mb0 el-icon-folder"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('i',{staticClass:"h5 line-height-1 mb0 el-icon-folder-opened"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"hide"},[_c('tr',[_c('th',{staticClass:"addressTableHeader"},[_c('span',{staticClass:"h6 inline-block semi-bold line-height-1 m0 gibson addressTableHeader"},[_vm._v("Adresse")])]),_vm._v(" "),_c('th',{},[_c('span',{staticClass:"h6 inline-block semi-bold line-height-1 m0 gibson dateTableHeader"},[_vm._v("Date sent")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 inline-block semi-bold line-height-1 m0 gibson statusTableHeader"},[_vm._v("Status")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-time"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"action-button line-height-1 p1 flex justify-start items-center gibson border-none mr1"},[_c('span',{staticClass:"regular mb0 mr2",staticStyle:{"font-size":"75%"}},[_vm._v("\n                        Send\n                      ")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StandardTilbudhistory_vue__ = __webpack_require__(1301);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fec634_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StandardTilbudhistory_vue__ = __webpack_require__(1302);
function injectStyle (ssrContext) {
  __webpack_require__(1300)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StandardTilbudhistory_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_70fec634_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_StandardTilbudhistory_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1300 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery_slideshow__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_gallery_slideshow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_gallery_slideshow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime__ = __webpack_require__(73);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_datetime___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_datetime__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Countdown__ = __webpack_require__(299);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Countdown2__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__ = __webpack_require__(43);









var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'alltilbudhistory',
  components: {
    Loading: Loading,
    Countdown: __WEBPACK_IMPORTED_MODULE_4__components_Countdown__["a" /* default */],
    Countdown2: __WEBPACK_IMPORTED_MODULE_5__components_Countdown2__["a" /* default */],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__["a" /* default */],
    VueGallerySlideshow: __WEBPACK_IMPORTED_MODULE_2_vue_gallery_slideshow___default.a,
    datetime: __WEBPACK_IMPORTED_MODULE_3_vue_datetime__["Datetime"],
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__["a" /* default */],
    ErrorHandler: ErrorHandler
  },
  created: function created() {
    var _this = this;

    this.gettaskbitrix();
    this.getallwizardproduct();
    this.klimaprofil = localStorage.getItem('ClimatePartner');
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.customerid = this.$route.query.app;
    this.minboligv2 = this.$route.query.from;
    this.customerfilterfromtable = this.customerid;
    this.parentID = this.$route.query.parentID ? this.$route.query.parentID : null;
    this.offerID = this.$route.query.offerid ? this.$route.query.offerid : null;
    this.jobList = this.$route.query.joblist ? JSON.parse(this.$route.query.joblist) : [];
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : null;
    this.projectID = this.$route.query.projectID ? this.$route.query.projectID : null;
    this.createdFrom = this.$route.query.createdfrom ? this.$route.query.createdfrom : null;
    this.projectTitle = this.$route.query.projecttitle ? this.$route.query.projecttitle : null;
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : null;
    if (this.offerID) {
      if (this.contractType === 'Fagentreprise') {
        this.getAcceptedOfferPrice(this.offerID, this.parentID, this.customerid);
      } else {
        this.getAcceptedOfferPrice(this.offerID, this.projectID, this.customerid);
      }
    }
    this.getyearsarray();
    setTimeout(function () {
      _this.getallminboligoffers();
    }, 400);
  },
  data: function data() {
    return {
      maintilbudstatus: '',
      disableStatusSelection: false,
      urlofferpdf: '',
      items: [],
      kundeitem: [],
      status: [],
      klimaprofil: '',
      SearchItem: [],
      files: [],
      statusDate: '',
      commentId: '',
      show: false,
      upload_token: '',
      clear_quotation_attachment: false,
      tilbud_id: '',
      index: null,
      modalShowPris: false,
      datereminder: null,
      label: 'Loading...',
      AflyseText: '',
      search: '',
      CommentText: '',
      AflyseTexttitle: '',
      Aflysetitle: '',
      Datosetitle: '',
      dateDato: '',
      timeDato: '',
      Aflyseid: '',
      Datoeid: '',
      komments: [],
      CommentCustomerText: '',
      textAflyseReason: '',
      textDatoReason: '',
      isLoadingAflyse: true,
      isLoadingDato: false,
      overlay: true,
      send_email: true,
      meetingShow: false,
      modalShowAflyseText: false,
      modalShowCommentText: false,
      modalShowCommentCustomerText: false,
      modalShowAflyse: false,
      modalShowDato: false,
      loading: true,
      salesPerson: '',
      salesPersonbitrix: '',
      filteredItemsbitrix: [],
      showboligoffer: false,
      haaId: '',
      oldestFirst: false,
      modalPriceFeedback: false,
      modalSurvey: false,
      surveyDescription: '',
      statusItem: [],
      statusValue: '',
      feedbackLoading: true,
      statusConfirmation: false,
      allyear: [],
      activeyear: '',
      customers: [],
      allcustomerfilter: [],
      customerfilter: [],
      customerfilterfromtable: '',
      customerid: '',
      allcustomerinfo: '',
      minboligv2: '',
      openjobs: [],
      seeoffer: false,
      selectedArr: {},
      parentID: '',
      jobList: [],
      contractType: '',
      projectID: '',
      createdFrom: '',
      projectTitle: '',
      childprojects: [],
      offerID: '',
      seeselectedoffer: false,
      itemsjobindustry: {},
      primaryproductindustryname: {},
      totaloffer: 0,
      innerloading: false
    };
  },

  filters: {
    truncate: function truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    }
  },
  watch: {
    'search': function search(newVal, oldVal) {
      var _this2 = this;

      setTimeout(function () {
        _this2.updateSearch('searc');
      }, 200);
      this.SearchItem = [];
    },
    'customerfilter': function customerfilter(newVal, oldVal) {
      var _this3 = this;

      setTimeout(function () {
        _this3.updateSearch(_this3.customerfilter);
      }, 200);
    },
    'customerfilterfromtable': function customerfilterfromtable(newVal, oldVal) {
      var _this4 = this;

      setTimeout(function () {
        _this4.updateSearchcustomer(_this4.customerid);
      }, 200);
    }
  },
  computed: {},
  methods: {
    getyearsarray: function getyearsarray() {
      var initialyear = 2018;
      var latestyear = new Date().getFullYear();
      for (var i = initialyear; i <= latestyear; i++) {
        this.allyear.push(initialyear);
        initialyear++;
      }
      this.allyear.reverse();
      this.getalladdress();
    },
    filteryear: function filteryear(year) {
      this.showboligoffer = false;
      if (document.getElementById('minbolig2') !== null) {
        document.getElementById('minbolig2').classList.add('primary-button-green');
      }
      if (this.activeyear !== '') {
        var oldyear = this.activeyear;
        document.getElementById('yearfilter-' + oldyear).classList.add('primary-button-green');
        document.getElementById('yearfilter-' + oldyear).classList.remove('green-background');
      }
      this.activeyear = year;
      document.getElementById('yearfilter-' + year).classList.add('green-background');
      document.getElementById('yearfilter-' + year).classList.remove('primary-button-green');
      var itemsyear = [];
      var filteredyear = [];
      itemsyear = this.items.filter(function (item) {
        var createditemyear = new Date(item.createdtime).getFullYear();
        if (createditemyear === year) {
          return item.createdtime;
        }
      });
      itemsyear.forEach(function (value) {
        filteredyear.push(value);
      });
      this.SearchItem = this.filterSearch(filteredyear);
    },
    getalladdress: function getalladdress() {
      var _this5 = this;

      this.loading = true;
      var cid = this.$route.query.id;
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        _this5.allcustomerinfo = res.array;
        _this5.Reload();
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getallminboligoffers: function getallminboligoffers() {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/offers', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (response.body.success) {
          _this6.filteredItemsbitrix = res;
          _this6.openjobs = res;
        } else {
          _this6.$message({
            type: 'error',
            message: response.body.message
          });
        }
      }, function (response) {
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    refreshtoken: function refreshtoken() {
      var _this7 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this7.salesPerson = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this7.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this7.$router.push('/login');
      });
    },
    filterminbolig: function filterminbolig() {
      this.showboligoffer = true;
      this.allyear.forEach(function (a) {
        document.getElementById('yearfilter-' + a).classList.remove('green-background');
        document.getElementById('yearfilter-' + a).classList.add('primary-button-green');
      });
      document.getElementById('minbolig2').classList.remove('primary-button-green');
      document.getElementById('minbolig2').classList.add('green-background');
      this.SearchItem = [];
    },
    Reload: function Reload() {
      var _this8 = this;

      this.loading = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'userTilbuds', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var restilbud = res.tilbud;
        var tilbuditems = [];
        tilbuditems = restilbud.filter(function (item) {
          return item.is_darft !== '1';
        });
        _this8.items = tilbuditems;
        var varthis = _this8;
        _this8.items.forEach(function (item) {
          varthis.customers.push(item.firstname);
          var address = '';
          address = varthis.allcustomerinfo.filter(function (a) {
            return a.firstname === item.firstname;
          });
          item['address'] = address.mailingstreet + ' ' + address.mailingzip + ' ' + address.mailingcity;
          if (item['address'] === 'undefined undefined undefined') {
            item['address'] = 'Address empty';
          }
        });
        var unique = function unique(value, index, self) {
          return self.indexOf(value) === index;
        };
        _this8.allcustomerfilter = _this8.customers.filter(unique);
        if (_this8.search !== '') {
          _this8.updateSearch();
        } else {
          _this8.SearchItem = _this8.filterSearch(_this8.items);
        }
        if (_this8.activeyear === '') {
          var latestyear = new Date().getFullYear();
          _this8.filteryear(latestyear);
        }
        if (_this8.customerid !== '' && typeof _this8.customerid !== 'undefined') {
          _this8.updateSearchcustomer(_this8.customerid);
        }
        _this8.disableStatusSelection = false;
        _this8.loading = false;
      }, function (response) {
        _this8.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    onClick: function onClick(item, i) {
      item.index = i;
    },
    showpdfoffer: function showpdfoffer(urlpdf) {
      this.urlofferpdf = urlpdf;
      this.$refs.seeoffer.show();
    },
    hidepdfoffer: function hidepdfoffer() {
      this.$refs.seeoffer.hide();
    },
    filterSearch: function filterSearch(item) {
      return item;
    },
    updateSearch: function updateSearch() {
      var _this9 = this;

      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      if (a === 'searc') {
        var items = [];
        items = this.items.filter(function (item) {
          return item.firstname.toLowerCase().includes(_this9.search.toLowerCase()) || item.lastname.toLowerCase().includes(_this9.search.toLowerCase()) || item.mobile.toLowerCase().includes(_this9.search.toLowerCase()) || item.reference_number.toLowerCase().includes(_this9.search.toLowerCase());
        });
        this.SearchItem = this.filterSearch(items);
      }
      if (a.length >= 1) {
        var itemscustomer = [];
        var varthis = this;
        if (a.length > 0) {
          varthis.items.filter(function (b) {
            a.forEach(function (itemc) {
              if (itemc === b.firstname) {
                itemscustomer.push(b);
              }
            });
          });
        }
        if (a.length > 0) {
          this.SearchItem = itemscustomer;
        } else {
          this.SearchItem = this.SearchItem;
        }
      }
      if (a.length === 0) {
        var latestyear = new Date().getFullYear();
        this.filteryear(latestyear);
      }
    },
    updateSearchcustomer: function updateSearchcustomer(item) {
      var itemscustomers = [];
      if (item !== '' && this.minboligv2 !== 'minboligv2') {
        itemscustomers = [];
        this.items.forEach(function (b) {
          if (b.cid === item) {
            itemscustomers.push(b);
          }
        });
        this.filteredItemsbitrix = [];
        if (itemscustomers.length > 0) {
          this.SearchItem = itemscustomers;
        } else {
          this.SearchItem = this.SearchItem;
        }
      } else {
        itemscustomers = [];
        itemscustomers = this.openjobs.filter(function (z) {
          return z.CONTACT_ID.toString() === item;
        });
        this.SearchItem = [];
        if (itemscustomers.length > 0) {
          this.filteredItemsbitrix = itemscustomers;
        } else {
          this.filteredItemsbitrix = this.filteredItemsbitrix;
        }
        this.showboligoffer = true;
      }
    },
    seeMessages: function seeMessages(id) {
      this.$router.push('/messages/inbox?customerId=' + id);
    },
    toggleSort: function toggleSort(statusDate) {
      var items = [];
      var order;
      if (statusDate === '1') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.appointment_date + ' ' + a.id_times);
          b = new Date(b.appointment_date + ' ' + b.id_times);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '2') {
        order = this.ascending ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = a.id_appointment_status;
          b = b.id_appointment_status;
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.ascending = !this.ascending;
      } else if (statusDate === '3') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.tilbud_date);
          b = new Date(b.tilbud_date);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else if (statusDate === '4') {
        order = this.oldestFirst ? 1 : -1;
        items = this.items.sort(function (a, b) {
          a = new Date(a.datereserve);
          b = new Date(b.datereserve);
          var results = a > b ? -1 : a < b ? 1 : 0;
          return results * order;
        });
        this.SearchItem = this.filterSearch(items);
        this.oldestFirst = !this.oldestFirst;
      } else {}
    },
    toggleFilter: function toggleFilter(status) {
      var items = [];
      var filtered = [];
      if (status.length !== 0) {
        for (var i = 0; i < status.length; i++) {
          if (status[i] === '9') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('1');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '10') {
            items = this.items.filter(function (item) {
              return item.privatecustomer.includes('0');
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] < 7 || status[i] === '100') {
            var statuscatcher = parseInt(status[i]);
            items = this.items.filter(function (item) {
              return item.tilbudstatus === statuscatcher;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '8') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length > 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '7') {
            items = this.items.filter(function (item) {
              return item.id_appointment.length < 1;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
          if (status[i] === '12') {
            items = this.items.filter(function (item) {
              return item.tilbudstatus === 6;
            });
            items.forEach(function (value) {
              filtered.push(value);
            });
          }
        }
        this.SearchItem = this.filterSearch(filtered);
      } else {
        this.SearchItem = this.filterSearch(this.items);
      }
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
    },
    mailSupport: function mailSupport(cid) {
      this.$router.push('/inbox?cid=' + cid);
    },
    handleSubmitReminder: function handleSubmitReminder(item) {
      var _this10 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var smsemail = item.remiderappid.smsemail;
      var dateReminder = this.datereminder;
      var descp = item.remiderappid.descp;
      if (dateReminder === '' || dateReminder === null) {
        var obj = {
          title: 'Påmindelse Dato ?',
          message: '',
          type: 'error'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      this.show = true;
      var data = { operation: 'change_reminder_meeting', salesPerson: this.salesPerson, smsemail: smsemail, appointmentid: item.id_appointment, date_reminder: dateReminder, descp: descp };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this10.$router.push('/login');
        }
        _this10.show = false;
        if (res.success) {
          _this10.modalShowDato = false;
          var _obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this10.Reload();
          document.getElementById('setReminderb' + item.id_appointment).click();
          _this10.$refs.simplert.openSimplert(_obj);
          _this10.datereminder = null;
        } else {
          alert(res.message);
          _this10.isLoadingDato = false;
        }
      }, function (response) {
        _this10.show = false;
        alert('error');
      });
    },
    deletedrafttilbud: function deletedrafttilbud(item) {
      var _this11 = this;

      this.loading = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = {
        operation: 'delTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: item.appid,
        offer_id: item.id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this11.$router.push('/login');
        }
        _this11.loading = false;
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this11.$refs.simplert.openSimplert(obj);
          _this11.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    loadComment: function loadComment() {
      var _this12 = this;

      this.loading = true;
      var data = { operation: 'loadcomment', salesPerson: this.salesPerson, cid: this.kundeitem.contactid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this12.$router.push('/login');
        }
        _this12.komments = res;
        _this12.loading = false;
      }, function (response) {
        alert('error');
        _this12.loading = false;
      });
    },
    showMeetingTilbud: function showMeetingTilbud(item) {
      this.$router.push('/tilbud/tilbud-historie?app=' + item.id_appointment);
    },
    showMeetingDetailsAflysetext: function showMeetingDetailsAflysetext(item) {
      this.modalShowAflyseText = true;
      this.AflyseText = item.ticketsolution;
      this.AflyseTexttitle = item.ticketstatus;
    },
    showMeetingDetailsCommenttext: function showMeetingDetailsCommenttext(item) {
      this.modalShowCommentText = true;
      this.CommentText = item.comment_to_partner;
    },
    showMeetingDetailsCommentCustomertext: function showMeetingDetailsCommentCustomertext(item) {
      this.modalShowCommentCustomerText = true;
      this.CommentCustomerText = item.comment_to_customer;
    },
    showMeetingDetailsDate: function showMeetingDetailsDate(item) {
      this.Datosetitle = 'Ændring af tid for kunde: ' + item.firstname + ' ' + item.lastname;
      this.modalShowDato = true;
      this.Datoeid = item;
      this.textDatoReason = '';
      this.isLoadingDato = false;
      var select = document.getElementById('select_time');
      for (var i = 0; i < select.length; i++) {
        var option = select.options[i];
        if (option.text === item.id_times) {
          this.timeDato = option.value;
        }
      }
    },
    changeStatus: function changeStatus(value, item) {
      this.statusValue = value;
      this.statusItem = item;
      this.disableStatusSelection = true;

      if (value === '2' || value === '3' || value === '4') {
        if (item.pricefeedback === '0') {
          this.feedbackLoading = true;
          this.showPriceFeedBackModal();
        } else {
          this.updateStatus(value, item);
        }
      } else if (value === '5' || value === '6' || value === '100') {
        this.feedbackLoading = true;
        this.showSurveyModal();
      } else {
        this.updateStatus(value, item);
      }
    },
    updateStatus: function updateStatus(value, item) {
      var _this13 = this;

      this.modalPriceFeedback = false;
      this.modalSurvey = false;
      this.isLoadingReview = true;
      var dataPartner = { operation: 'customer_status_henttilbud', salesPerson: this.salesPerson, status: value, cid: item.id_appointment, descp: this.surveyDescription };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this13.show = false;
        if (res.login === false) {
          _this13.$router.push('/login');
        }
        _this13.isLoadingReview = false;
        _this13.surveyDescription = '';
        var infoType = '';
        if (res.success) {
          infoType = 'success';
        } else {
          infoType = 'info';
        }
        var obj = {
          title: res.message,
          message: '',
          type: infoType,
          customCloseBtnText: 'Luk'
        };
        _this13.$refs.simplert.openSimplert(obj);
        _this13.Reload();
      }, function (response) {
        console.log('Error in updateStatus()', response);
      });
    },
    showMeetingDetailsAflyse: function showMeetingDetailsAflyse(item) {
      this.Aflysetitle = 'Er mødet med ' + item.firstname + ' ' + item.lastname + ' aflyst af kunden?';
      this.modalShowAflyse = true;
      this.Aflyseid = item;
      this.textAflyseReason = '';
      this.isLoadingAflyse = false;
    },
    filterItem: function filterItem(items) {
      var newItem = [];
      for (var iteme in items) {
        newItem.push(items[iteme]);
      }
      return newItem;
    },
    showMeetingDetails: function showMeetingDetails(item) {
      this.meetingShow = !this.meetingShow;
      this.sampleMeeting.id = item.id;
      this.sampleMeeting.type = item.type;
      this.sampleMeeting.estimate = item.estimate;
      this.sampleMeeting.city = item.city;
      this.sampleMeeting.postnummer = item.postnummer;
      this.sampleMeeting.price = item.price;
      this.sampleMeeting.date = item.date;
    },
    getAcceptedOfferPrice: function getAcceptedOfferPrice(offerid, projectid, contactid) {
      var _this14 = this;

      var calculationid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;

      this.selectedArr = {};
      this.totaloffer = 0;
      this.innerloading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinbolig?project_id=' + projectid + '&contact_id=' + Number(contactid) + '&calculation_id=' + calculationid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        var filteredresult = {};
        var result = res.result.filter(function (l) {
          return Number(l.PARTNER_ID) === Number(_this14.haaId) && Number(l.OFFER_ID) === Number(offerid);
        });
        result.forEach(function (y) {
          if (!filteredresult[y.JOB_INDUSTRY]) {
            filteredresult[y.JOB_INDUSTRY] = [];
            filteredresult[y.JOB_INDUSTRY].push(y);
          } else {
            filteredresult[y.JOB_INDUSTRY].push(y);
          }
          _this14.totaloffer += Number(y.TOTALVAT);
        });
        _this14.selectedArr = filteredresult;
        _this14.innerloading = false;
      }, function (response) {
        _this14.loading = false;
        _this14.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this15 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this15.itemsjobindustry = industryname;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this16 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this16.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this16.$message.error(error);
      });
    },
    closemodaloffer: function closemodaloffer() {
      this.selectedArr = {};
      this.totaloffer = 0;
      this.seeselectedoffer = false;
    },
    openmodaloffer: function openmodaloffer() {
      this.seeselectedoffer = true;
      this.innerloading = true;
    }
  }
});

/***/ }),
/* 1302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{attrs:{"id":"offerhistory"}},[_c('div',{staticClass:"clearfix gibson mb2"},[_c('div',{staticClass:"col-12 p2"},[_c('div',{staticClass:"clearfix py3"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 p0 m0"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start items-center py1 border muted-border mediumgrey shadow mb2"},[_c('div',{staticClass:"flex-none px2"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"3px"},attrs:{"width":"18","height":"24","fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 20 20"}},[_c('path',{staticClass:"st0",attrs:{"d":"M8.8 15.4c3.6 0 6.6-3 6.6-6.6s-3-6.6-6.6-6.6 -6.6 3-6.6 6.6S5.2 15.4 8.8 15.4zM15.7 14.2l4 4c0.4 0.4 0.4 1.1 0 1.5s-1.1 0.4-1.5 0l0 0 -4-4c-3.8 3-9.3 2.3-12.3-1.5S-0.5 4.8 3.4 1.9s9.3-2.3 12.3 1.5C18.2 6.6 18.2 11 15.7 14.2L15.7 14.2z"}})])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.search),expression:"search"}],staticClass:"searchBox gibson h4 darkblue regular mb0 p2 pl0",staticStyle:{"background":"transparent"},attrs:{"type":"search","name":"search","placeholder":"Søg efter"},domProps:{"value":(_vm.search)},on:{"input":function($event){if($event.target.composing){ return; }_vm.search=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',{staticClass:"col-6 pr1 pl0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Sortér")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2mtilbud",modifiers:{"m2mtilbud":true}}],staticClass:"col-12 p2 px2 gibson dark-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h5 mb0 mr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"lg-col-6 md-col-6 sm-col-10 right",attrs:{"id":"m2mtilbud"}},[_c('div',{staticClass:" my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\r\n                    Vælg\r\n                ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2mtilbud",modifiers:{"m2mtilbud":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('div',{staticClass:"flex flex-column col-12 mx-auto mb2"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("kunder")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap "},_vm._l((_vm.allcustomerfilter),function(item,index){return _c('b-form-checkbox',{key:index,staticClass:"col-3 p0",attrs:{"id":item+index,"name":item+index,"value":item},model:{value:(_vm.customerfilter),callback:function ($$v) {_vm.customerfilter=$$v},expression:"customerfilter"}},[_c('span',{staticClass:" h6 regular",staticStyle:{"top":"-3px"}},[_vm._v(_vm._s(item))])])}),1)])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-6",attrs:{"id":"webCustomers"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-9 px0 flex justify-between items-center"},[_c('p',{staticClass:"h5 darkblue gibson line-height-3"},[_vm._v("\r\n                    Tilpas rækkefølgen\r\n                ")]),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.webCustomers",modifiers:{"webCustomers":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-wrap justify-start items-center my2"},[_c('b-form-group',{attrs:{"value":_vm.statusDate},on:{"update:value":function($event){_vm.statusDate=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-radio-group',[_c('b-form-radio',{attrs:{"id":"sortByDatexxl","aria-describedby":ariaDescribedby,"name":"sortByDatexxl","value":"1"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter mødedato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"sortByStatusxxl","aria-describedby":ariaDescribedby,"name":"sortByStatusxxl","value":"2"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter status")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"offerSentxxl","aria-describedby":ariaDescribedby,"name":"offerSentxxl","value":"3"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter sendt tilbud dato")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-radio',{attrs:{"id":"followUpxxl","aria-describedby":ariaDescribedby,"name":"followUpxxl","value":"4"},model:{value:(_vm.statusDate),callback:function ($$v) {_vm.statusDate=$$v},expression:"statusDate"}},[_c('span',{staticClass:"ml1 h6 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Sorter efter opfølgningsdato")])])],1)]}}])})],1)])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 p0 m0 my2"},[_c('p',{staticClass:"col-12 h5 semi-bold darkblue p0"},[_vm._v("Oversigt over dine kunder om året")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap flex-mobile-center"},[_vm._l((_vm.allyear),function(item,index){return _c('button',{key:index,staticClass:"primary-button-green pointer regular h5 white p2 mr1",staticStyle:{"width":"120px"},attrs:{"id":'yearfilter-' + item},on:{"click":function($event){return _vm.filteryear(item)}}},[_vm._v(_vm._s(item)+"\r\n            ")])}),_vm._v(" "),(_vm.filteredItemsbitrix.length > 0)?_c('button',{staticClass:"primary-button-green pointer regular h5 white p2 mr1",staticStyle:{"width":"120px"},attrs:{"id":"minbolig2"},on:{"click":function($event){return _vm.filterminbolig()}}},[_vm._v("Minbolig\r\n            ")]):_vm._e()],2)])],1)])])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" flex flex-wrap md-col-12 sm-col-12 justify-center items-stretch"},[_vm._l((_vm.SearchItem),function(item){return _c('div',{key:item.id,staticClass:"flex items-stretch relative border muted-border p2 py3 shadow mb3 mr1",staticStyle:{"width":"300px"}},[_c('div',{staticClass:"flex flex-column col-12"},[_c('div',{staticClass:" semi-bold "},[_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"feather feather-user",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"}}),_c('circle',{attrs:{"cx":"12","cy":"7","r":"4"}})])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.firstname + ' ' + item.lastname)}})]),_vm._v(" "),_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"feather feather-map-pin",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"}}),_c('circle',{attrs:{"cx":"12","cy":"10","r":"3"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.address))])]),_vm._v(" "),_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.moment(item.createdtime).locale('da').format('LL')))])])]),_vm._v(" "),_c('div',{staticClass:"semi-bold"},[_c('button',{staticClass:"col-12 outlined-primary-button p2 flex justify-center items-center gibson line-height-1 my1",on:{"click":function($event){return _vm.showpdfoffer(item.offerfile)}}},[_c('p',{staticClass:"semi-bold primary m0"},[_vm._v("Se Tilbud")])]),_vm._v(" "),_c('a',{staticClass:"col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1",attrs:{"href":'tel:' + item.mobile}},[_c('span',{staticClass:"relative mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"}}),_c('path',{attrs:{"d":"M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"}}),_c('path',{attrs:{"d":"M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"}}),_c('path',{attrs:{"d":"M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Ring "+_vm._s(item.mobile))])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1",on:{"click":function($event){return _vm.mailSupport(item.cid)}}},[_c('p',{staticClass:"relative mr2 m0"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Skriv til kunden")])])]),_vm._v(" "),_c('div',[_c('b-form-select',{staticClass:"col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0",staticStyle:{"height":"48px","font-size":"18.5px!important"},attrs:{"id":"statusSelect"},scopedSlots:_vm._u([{key:"first",fn:function(){return [(item.sent === '1')?_c('b-form-select-option',{attrs:{"value":item.sent}},[_vm._v("Ikke sendt")]):_vm._e(),_vm._v(" "),(item.sent === '0')?_c('b-form-select-option',{attrs:{"value":item.sent}},[_vm._v("Sendt")]):_vm._e()]},proxy:true}],null,true),model:{value:(item.sent),callback:function ($$v) {_vm.$set(item, "sent", $$v)},expression:"item.sent"}})],1),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'+item.reference_number),expression:"'setReminder'+item.reference_number"}],staticClass:"p1 col-12 flex gibson outlined-standard-button not-rounded border-none justify-start items-center"},[_c('p',{staticClass:"relative mr2 m0"},[_c('svg',{staticClass:"jam jam-bell",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-3 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M13.666 11.782L13 11.186V6a4 4 0 1 0-8 0v5.186l-.666.596A6.987 6.987 0 0 0 2.29 15h13.42a6.987 6.987 0 0 0-2.044-3.218zM12 17a3 3 0 0 1-6 0H0a8.978 8.978 0 0 1 3-6.708V6a6 6 0 1 1 12 0v4.292A8.978 8.978 0 0 1 18 17h-6zm-3 1a1 1 0 0 0 1-1H8a1 1 0 0 0 1 1z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Tilføj påmindelse")])])]),_vm._v(" "),_c('b-collapse',{ref:"reminderModal",refInFor:true,staticClass:"col-12",attrs:{"id":'setReminder'+item.reference_number}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitReminder(item)}}},[_c('div',{staticClass:"clearfix mb3"},[_c('div',{staticClass:"flex flex-column my2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Type")]),_vm._v(" "),_c('select',{staticClass:"muted-background p1 darkblue not-rounded border-none gibson mb1",staticStyle:{"font-size":"16.5px","height":"38px"},attrs:{"id":"reminderSelect","required":""}},[_c('option',{attrs:{"value":"1"}},[_vm._v("SMS og email")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("SMS")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Email")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("None")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Dato")]),_vm._v(" "),_c('VueCtkDateTimePicker',{staticClass:"darkblue not-rounded border-none gibson mb1 muted-background",attrs:{"id":"reminderDate","locale":"da","label":"Påmindelse Dato","required":"","placeholder":"Påmindelse Dato"},model:{value:(_vm.datereminder),callback:function ($$v) {_vm.datereminder=$$v},expression:"datereminder"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Noter")]),_vm._v(" "),_c('textarea',{staticClass:"p2 muted-background darkblue gibson line-height-3 border-none not-rounded",staticStyle:{"font-size":"13.5px"},attrs:{"name":"note","id":"note","cols":"30","rows":"5","required":"","placeholder":""}})]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-column items-center"},[_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.newclass",modifiers:{"newclass":true}}],staticClass:"col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson"},[_c('span',{staticClass:"semi-bold",staticStyle:{"font-size":"16.5px"}},[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'+item.apreference_numberpid),expression:"'setReminder'+item.apreference_numberpid"}],staticClass:"col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded",attrs:{"type":"button"}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16.5px"}},[_vm._v("Luk påmindelse")])])])])])])]),_vm._v(" "),(item.bilagfile_new.length > 0)?_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('bilagfiles'+item.reference_number),expression:"'bilagfiles'+item.reference_number"}],staticClass:"p1 col-12 flex gibson outlined-standard-button not-rounded border-none justify-start items-center"},[_c('p',{staticClass:"relative mr2 m0"},[_c('svg',{staticClass:"offerbilagicon",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"24","viewBox":"0 0 34 40"}},[_c('path',{attrs:{"id":"uploaded_file","data-name":"uploaded file","d":"M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Bilag")])])]):_c('div',{staticClass:"flex justify-start",staticStyle:{"height":"48px"}},[_c('span',{staticClass:"mr2 ml1 flex items-center "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"24","viewBox":"0 0 34 40"}},[_c('path',{attrs:{"id":"uploaded_file","data-name":"uploaded file","d":"M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z","fill":"#003645"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 gibson darkblue line-height-1 mb0 semi-bold flex items-center "},[_vm._v("Ingen filer uploadet")])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'bilagfiles'+item.reference_number}},_vm._l((item.bilagfile_new),function(file,index){return (item.bilagfile_new.length > 0)?_c('div',{key:file.id,staticClass:"mb1 h6 p1 darkblue "},[_c('a',{staticClass:"semi-bold",attrs:{"type":"button","href":encodeURI(file.url),"target":"_blank"}},[_vm._v("Fil "+_vm._s(parseInt(index + 1)))])]):_vm._e()}),0),_vm._v(" "),_c('p',{staticClass:"flex ml-auto"},[_c('i',{staticClass:"red h5 el-icon-delete pointer",on:{"click":function($event){return _vm.deletedrafttilbud(item)}}})])],1)])}),_vm._v(" "),_vm._l((_vm.filteredItemsbitrix),function(item){return (_vm.showboligoffer)?_c('div',{key:item.ID,staticClass:"flex items-stretch relative border muted-border p2 py3 shadow mb3 mr1",staticStyle:{"width":"300px"}},[_c('div',{staticClass:"flex flex-column col-12"},[_c('div',{staticClass:" semi-bold "},[_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"feather feather-user",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"}}),_c('circle',{attrs:{"cx":"12","cy":"7","r":"4"}})])]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(item.TITLE)}})]),_vm._v(" "),_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"feather feather-map-pin",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"}}),_c('circle',{attrs:{"cx":"12","cy":"10","r":"3"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(item.DESCRIPTION))])]),_vm._v(" "),_c('p',{staticClass:"flex items-center"},[_c('span',{staticClass:"mr1 flex items-center"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.moment(item.CREATED_AT).locale('da').format('LL')))])])]),_vm._v(" "),_c('div',{staticClass:"semi-bold"},[_c('button',{staticClass:"col-12 outlined-primary-button p2 flex justify-center items-center gibson line-height-1 my1",on:{"click":function($event){return _vm.getAcceptedOfferPrice(item.ID, item.PROJECT_ID, item.CONTACT_ID)}}},[_c('p',{staticClass:"semi-bold primary m0"},[_vm._v("Se Tilbud")])]),_vm._v(" "),_c('a',{staticClass:"col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1",attrs:{"href":'tel:' + item.CONTACT_ID}},[_c('span',{staticClass:"relative mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M492.6 400.6L392.2 300.2c-12-12-31.5-12-43.4 0l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2l-9.8 9.8c0 0 0 0 0 0 -7 7-50.5-3.7-103.1-56.4 -52.6-52.6-63.4-96.1-56.4-103.1 0 0 0 0 0 0l9.9-9.9c2.8 0.8 5.7 1.2 8.5 1.2 7.9 0 15.7-3 21.7-9l26.1-26.1c12-12 12-31.5 0-43.4L111.4 19.4c-5.8-5.8-13.5-9-21.7-9 -8.2 0-15.9 3.2-21.7 9l-26.1 26.1c-8.2 8.2-10.8 19.8-7.8 30.2 0 0-8.3 8.4-8.8 9 -27.8 30.8-33 79.4-14.6 137.5 18 56.9 56.9 117.1 109.4 169.6 52.5 52.5 112.7 91.3 169.6 109.4C312.6 508.4 334 512 353.4 512c31.8 0 58.3-9.6 77.4-28.7l5.5-5.5c2.7 0.8 5.6 1.2 8.5 1.2 8.2 0 15.9-3.2 21.7-9l26.1-26.1C504.5 432 504.5 412.5 492.6 400.6zM89.7 41.2l100.3 100.3 -26.1 26.1c0 0 0 0 0 0l-0.4-0.4 -49.8-49.8L63.6 67.2 89.7 41.2zM409 461.6c0 0 0 0 0 0 -22.1 22.1-61.1 25.7-110 10.3 -52.3-16.6-108.1-52.7-157.2-101.8C92.8 321 56.7 265.2 40.1 212.9c-15.5-48.8-11.8-87.9 10.3-110l0 0 2.8-2.8 77.9 77.9 -7.1 7.1c0 0 0 0 0 0 -29.6 29.6 6 96.1 56.4 146.6 37.7 37.7 84.5 67.1 118.1 67.1 11.3 0 21.1-3.3 28.5-10.8 0 0 0 0 0 0l7.1-7.1 77.9 77.9L409 461.6zM444.8 448.4L344.4 348l26.1-26.1L470.8 422.3C470.8 422.3 444.8 448.4 444.8 448.4z"}}),_c('path',{attrs:{"d":"M388.8 123.2c-29.2-29.2-68-45.3-109.3-45.3 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 33.1 0 64.2 12.9 87.6 36.3 23.4 23.4 36.3 54.5 36.3 87.6 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C434.1 191.2 418 152.4 388.8 123.2z"}}),_c('path',{attrs:{"d":"M443.9 68.1C400 24.2 341.6 0 279.5 0c-8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 53.9 0 104.6 21 142.7 59.1 38.1 38.1 59.1 88.8 59.1 142.7 0 8.5 6.9 15.4 15.4 15.4 8.5 0 15.4-6.9 15.4-15.4C512 170.4 487.8 112 443.9 68.1z"}}),_c('path',{attrs:{"d":"M333.7 178.3c-14.7-14.7-33.5-22.5-54.3-22.5 0 0 0 0 0 0 -8.5 0-15.4 6.9-15.4 15.4 0 8.5 6.9 15.4 15.4 15.4 0 0 0 0 0 0 12.6 0 23.6 4.5 32.5 13.5 8.8 8.8 13.5 20.1 13.5 32.5 0 8.5 6.9 15.4 15.4 15.4h0c8.5 0 15.4-6.9 15.4-15.4C356.2 211.7 348.4 193 333.7 178.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Ring")])]),_vm._v(" "),_c('button',{staticClass:"col-12 outlined-action-button p2 flex justify-center items-center gibson line-height-1 my1",on:{"click":function($event){return _vm.seeMessages(item.CONTACT_ID)}}},[_c('p',{staticClass:"relative mr2 m0"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 line-height-1 mb0 semi-bold "},[_vm._v("Skriv til kunden")])])]),_vm._v(" "),_c('div',[_c('b-form-select',{staticClass:"col-12 muted-background border-none darkblue semi-bold pl2 not-rounded gibson mb0",staticStyle:{"height":"48px","font-size":"18.5px!important"},attrs:{"id":"statusSelect"},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('b-form-select-option',{attrs:{"value":item.sent}},[_vm._v(_vm._s(item.STATUS))])]},proxy:true}],null,true),model:{value:(item.sent),callback:function ($$v) {_vm.$set(item, "sent", $$v)},expression:"item.sent"}})],1),_vm._v(" "),_c('b-collapse',{ref:"reminderModal",refInFor:true,staticClass:"col-12",attrs:{"id":'setReminder'+item.ID}},[_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.handleSubmitReminder(item)}}},[_c('div',{staticClass:"clearfix mb3"},[_c('div',{staticClass:"flex flex-column my2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Type")]),_vm._v(" "),_c('select',{staticClass:"muted-background p1 darkblue not-rounded border-none gibson mb1",staticStyle:{"font-size":"16.5px","height":"38px"},attrs:{"id":"reminderSelect","required":""}},[_c('option',{attrs:{"value":"1"}},[_vm._v("SMS og email")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("SMS")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Email")]),_vm._v(" "),_c('option',{attrs:{"value":"0"}},[_vm._v("None")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column mt3 mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Dato")]),_vm._v(" "),_c('VueCtkDateTimePicker',{staticClass:"darkblue not-rounded border-none gibson mb1 muted-background",attrs:{"id":"reminderDate","locale":"da","label":"Påmindelse Dato","required":"","placeholder":"Påmindelse Dato"},model:{value:(_vm.datereminder),callback:function ($$v) {_vm.datereminder=$$v},expression:"datereminder"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2"},[_c('span',{staticClass:"h6 semi-bold gibson darkblue block mb1",staticStyle:{"font-size":"13.5px"}},[_vm._v("Noter")]),_vm._v(" "),_c('textarea',{staticClass:"p2 muted-background darkblue gibson line-height-3 border-none not-rounded",staticStyle:{"font-size":"13.5px"},attrs:{"name":"note","id":"note","cols":"30","rows":"5","required":"","placeholder":""}})]),_vm._v(" "),_c('div',{staticClass:"clearfix flex flex-column items-center"},[_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.newclass",modifiers:{"newclass":true}}],staticClass:"col-12 action-button p2 line-height-1 flex justify-center items-center border-none not-rounded gibson"},[_c('span',{staticClass:"semi-bold",staticStyle:{"font-size":"16.5px"}},[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('setReminder'+item.apreference_numberpid),expression:"'setReminder'+item.apreference_numberpid"}],staticClass:"col-12 outlined-disabled-button p2 gibson line-height-1 flex justify-center items-center not-rounded",attrs:{"type":"button"}},[_c('span',{staticClass:"pr2"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"16.5px"}},[_vm._v("Luk påmindelse")])])])])])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start",staticStyle:{"height":"48px"}},[_c('span',{staticClass:"mr2 ml1 flex items-center "},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28","height":"24","viewBox":"0 0 34 40"}},[_c('path',{attrs:{"id":"uploaded_file","data-name":"uploaded file","d":"M3,40a3,3,0,0,1-3-3V24a1,1,0,1,1,2,0V37a1,1,0,0,0,1,1H27a1,1,0,0,0,1-1V36H7a3,3,0,0,1-3-3V6H3A1,1,0,0,0,2,7v5a1,1,0,0,1-2,0V7A3,3,0,0,1,3,4H4V3A3,3,0,0,1,7,0H21.66A3,3,0,0,1,23.8.9l9.34,9.56A2.931,2.931,0,0,1,34,12.55V33a3,3,0,0,1-3,3H30v1a3,3,0,0,1-3,3ZM6,3V33a1,1,0,0,0,1,1H31a1,1,0,0,0,1-1V13H25a3,3,0,0,1-3-3V2.07A1,1,0,0,0,21.66,2H7A1,1,0,0,0,6,3Zm18,7a1,1,0,0,0,1,1h5.88L24,4ZM18,29V18.41l-3.29,3.3a1,1,0,1,1-1.419-1.42l5-5a1,1,0,0,1,1.42,0l5,5a1,1,0,1,1-1.42,1.42L20,18.41V29a1,1,0,0,1-2,0ZM0,18a1,1,0,1,1,1,1A1,1,0,0,1,0,18Z","fill":"#003645"}})])]),_vm._v(" "),_c('p',{staticClass:"h6 gibson darkblue line-height-1 mb0 semi-bold flex items-center "},[_vm._v("Ingen filer uploadet")])])],1)]):_vm._e()})],2),_vm._v(" "),_c('b-modal',{ref:"seeoffer",attrs:{"size":"lg","centered":"","id":"seeoffer","title":"Hent vejledning her","ok-only":"","allowfullscreen":""},model:{value:(_vm.seeoffer),callback:function ($$v) {_vm.seeoffer=$$v},expression:"seeoffer"}},[_c('b-embed',{attrs:{"type":"iframe","scrolling":"no","src":_vm.urlofferpdf,"aspect":"1by1","allowfullscreen":""}}),_vm._v(" "),_c('div',{staticClass:"py-4 px-4 d-flex justify-content-between w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-btn',{staticClass:"float-left",attrs:{"type":"reset","variant":"outline-dark","size":"lg"},on:{"click":_vm.hidepdfoffer}},[_vm._v("Luk\r\n        ")])],1)],1),_vm._v(" "),_c('b-modal',{ref:"seeselectedoffer",attrs:{"hide-footer":"","size":"lg","centered":"","id":"seeselectedoffer","title":"Hent vejledning her"},model:{value:(_vm.seeselectedoffer),callback:function ($$v) {_vm.seeselectedoffer=$$v},expression:"seeselectedoffer"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closemodaloffer()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),(_vm.innerloading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{},[_c('p',{staticClass:"h4 semi-bold py2 m0 "},[_vm._v("Tilbudsliste")]),_vm._v(" "),_c('div',{staticClass:"overflow-auto p2",staticStyle:{"height":"600px"}},[_vm._l((Object.keys(_vm.selectedArr)),function(industryfields,index){return _c('div',{key:index,staticClass:"flex flex-column mb2 pr2"},[_c('p',{staticClass:"m0 p0 h4 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '. ')+_vm._s(_vm.itemsjobindustry[industryfields]))]),_vm._v(" "),_vm._l((_vm.selectedArr[industryfields]),function(jobitem,index2){return _c('div',{key:index2},[_c('div',{staticClass:"flex items-center"},[_c('p',{staticClass:"m0 pl3 h4 xs-pl1 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '.')+_vm._s(index2 + 1 + ' ')+_vm._s(_vm.primaryproductindustryname[jobitem['INDUSTRY']]))]),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto "},[_c('p',[_vm._v(_vm._s((parseInt(jobitem['TOTALVAT'])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])]),_vm._v(" "),_vm._l((jobitem.SERIES),function(itemfields,index3){return _c('div',{key:index3},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-9 md-col-9 xs-col-12 sm-col-9 mr-auto"},[_c('div',{staticClass:"m0 pl4 xs-pl2 flex"},[_c('span',{},[_vm._v(_vm._s(parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)))]),_vm._v(" "),_c('div',{staticClass:"pl1"},[_vm._v(_vm._s(itemfields))])])])])})],2)})],2)}),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-11 px0 mx-auto border muted-border border-bottom-0 my3 border-left-0  border-right-0 pl2"},[_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Totalpris inkl. 25 % moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseInt(_vm.totaloffer)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])])],2)])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Dine Tilbud")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue gibson line-height-golden mb3 col-12 px0"},[_vm._v("\r\n                    Dit overblik over alle tilbud du har sendt til dine kunder og potentielle kunder.Følg nemt op med kunder, der stagig ikke"),_c('br'),_vm._v("\r\n                    har reageret på dine tilbud.\r\n                ")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1303 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4__ = __webpack_require__(320);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_uuid_v4__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_file_upload_input_pdfonly__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Reviews__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_file_upload_input_pdfonly_vue__ = __webpack_require__(322);

















/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tilbudpage',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_4_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a,
    uuid: __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default.a,
    reviews: __WEBPACK_IMPORTED_MODULE_10__Reviews__["a" /* default */],
    ImageRating: __WEBPACK_IMPORTED_MODULE_9_vue_rate_it__["ImageRating"],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_7__components_file_upload_input__["a" /* default */],
    datepicker: __WEBPACK_IMPORTED_MODULE_11_vuejs_datepicker__["a" /* default */],
    fileUploadInputpdfonly: __WEBPACK_IMPORTED_MODULE_8__components_file_upload_input_pdfonly__["a" /* default */],
    en: __WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale__["en"],
    da: __WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale__["da"],
    FileUploadInputPdfonly: __WEBPACK_IMPORTED_MODULE_13__components_file_upload_input_pdfonly_vue__["a" /* default */],
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_3__noneligibleFeaturepop__["a" /* default */]
  },
  data: function data() {
    return {
      da: __WEBPACK_IMPORTED_MODULE_12_vuejs_datepicker_dist_locale__["da"],
      onlyfile: false,
      offermakingtype: '',
      compututedtaxsingle: '',
      subtotalprice: '',
      totalstep: 3,
      salesPerson: localStorage.getItem('id_token_portal'),
      salesPersonNew: localStorage.getItem('id_token_portalbitrix'),
      haaid: localStorage.getItem('haaid'),
      appid: '',
      customerpartnerid: 0,
      headertext: '',
      header_image: '',
      currentstep: 1,
      button: 1,
      savedraft: 0,
      usereferencenumber: 0,
      editingdraft: 0,
      pdfurl: null,
      pdfpdf: null,
      uploadedpdf: '',
      newfiles: [],
      fordelete: [],
      seletectedaddress: '',
      customers: null,
      termsnotats: [],
      termsbetings: [],
      termsbetingelser: [],
      termsnotes: [],
      loading: false,
      previewloading: false,
      addressloading: false,
      searchgaddress: [],
      items: [],
      alltilbud: [],
      alltilbudanduserinfo: [],
      alliheadermages: [],
      draftitems: [],
      itsok: true,
      mainfiles: [],
      mainloading: false,
      fiverecommendations: [],
      allrecommendatationsitems: [],
      optionsunitype: [{ value: 0, text: 'Antal' }, { value: 1, text: 'Beløb' }, { value: 2, text: 'Timer' }],
      rows: [],
      row: {
        uuid: '',
        name: '',
        selected_item: null,
        show_custom_item: false,
        custom_name: '',
        quantity: 1,
        unitPrice: 0,
        discount: 0,
        tax: 0,
        type: 1,
        amount: 0,
        description: ''
      },
      info: {
        id: null,
        currency_id: null,
        customer_id: null,
        customer_note: null,
        date: this.currentandexpiryDateTime(),
        expiry_date: this.currentandexpiryDateTime('expiry'),
        expiry_date_detail: '',
        upload_token: '',
        itme_type: '',
        rows: [],
        subject: '',
        description: '',
        subtotal: 0,
        subtotalDiscount: 0,
        line_item_discount_type: true,
        subtotalDiscount_type: false,
        subtotalTax: 25,
        subtotal_tax: null,
        subtotalShippingAndHandling: 0,
        total: 0,
        reference_number: '',
        quotation_number: '',
        quotation_prefix: '',
        is_draft: 0,
        show_sub_total_tax: true,
        show_sub_total_discount: true,
        show_sub_total_shipping_and_handling: true,
        show_line_item_tax: true,
        show_line_item_discount: true,
        show_line_item_description: true,
        memo: '',
        tnc: ''
      },
      tilbud: {
        onlyfile: false,
        appid: null,
        betingelser: null,
        bilag: null,
        bilagfile: null,
        cid: '',
        condition: null,
        createdtime: null,
        deleted: null,
        files: [],
        firstname: null,
        header_image: null,
        header_text: null,
        id: null,
        image: null,
        imgfile: null,
        info: [],
        is_darft: null,
        lastname: null,
        mobile: null,
        name: null,
        notat: null,
        offerfile: null,
        pid: null,
        recommendations: null,
        reference_number: null,
        sent: null
      },
      mainTilbud: {
        app: null,
        customer: null,
        partner: [],
        partnerid: '',
        tilbud: []
      },
      form: {
        headings: null,
        offerdescription: null,
        offeramount: null,
        quantity: 1,
        quantityunit: 0,
        discount: '',
        discountsymbol: '',
        navm: null,
        adresse: null,
        adresseid: '',
        adresseadgang: '',
        email: null,
        mobile: null,
        dateoffer: this.currentandexpiryDateTime(),
        dateofferexpiry: this.currentandexpiryDateTime('expiry'),
        comment: '',
        discountamount: 0,
        discountpercentage: 0,
        termsnote: null,
        termsaddnotetitle: '',
        termsaddnotedesc: '',
        termsaddnotetype: 'note',
        termsbetingelser: null,
        termsbetingelsertitle: '',
        termsbetingelserdesc: '',
        termsbetingelsertype: 'betingelser',
        bilagfile: [],
        headerImage: ''
      },
      error: {
        notask: ''
      },
      rowbolig: {
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      },
      rowsbolig: [],
      selectedProjectData: {},
      customerInputDisabled: false,
      customerInputDisabledselect: false,
      kunderid: '',
      eligible: '',
      subtotalprices: '',
      typeofclients: '',
      addresses: {}
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('OfferCreator');
    this.kunderid = this.$route.query.app;
    if (this.eligible) {
      this.reloadthepage();
      this.getaddressfromkeyword('s');
      this.getallofferbypartner();
      this.currentandexpiryDateTime();
      this.getallactivecustomerandofferbypartner();
      this.getterms();
      this.getallrecommendations();
      this.getallheaderimage();
      if (this.$route.query.projectId) {
        this.typeofclients = 'Minbolig2';
        this.getSelectedProj();
      }
    }
  },

  watch: {
    $route: function $route() {
      this.offermakingtype = this.$route.name;
      this.initialstep();
    },
    'form.offeramount': function formOfferamount(val) {
      if (val) this.form.offeramount = val.replace('.', '');
    },
    'form.discountamount': function formDiscountamount(val) {
      if (val) this.form.discountamount = val.replace('.', '');
    },
    'form.discountpercentage': function formDiscountpercentage(val) {
      if (val) this.form.discountpercentage = val.replace('.', '');
    }
  },
  computed: {},
  mounted: function mounted() {
    this.initialstep();
    this.getdataigibility();
    if (this.$route.query.name) {
      this.checkCustomer();
    }
  },

  methods: {
    getdataigibility: function getdataigibility() {
      var _this = this;

      setTimeout(function () {
        _this.eligible = localStorage.getItem('OfferCreator');
        if (_this.eligible === 'false') {
          _this.$refs.noneligibleFeaturepop.showmodel(_this.eligible, '/newsfeed', 'OfferCreator');
        }
      }, 3000);
    },
    checkCustomer: function checkCustomer() {
      var name = this.$route.query.name;
      if (name !== null || name !== '') {
        var email = this.$route.query.email;
        var mobile = this.$route.query.mobile;
        var address = this.$route.query.address;

        this.form.navm = name;
        this.form.email = email;
        this.form.mobile = mobile;
        this.form.adresse = address;
        this.seletectedaddress = address;
        this.customerInputDisabled = true;
        this.customerInputDisabledselect = true;
      }
    },
    reloadthepage: function reloadthepage() {
      this.offermakingtype = this.$route.name;
    },
    focusthis: function focusthis() {},
    hideModalquickandstandard: function hideModalquickandstandard() {
      this.$refs['quickandstandard'].hide();
    },
    hideModal: function hideModal() {
      this.$refs['quickoffermodal'].hide();
    },
    hideModalconditions: function hideModalconditions() {
      this.$refs['quickofferconditions'].hide();
    },
    hideModaladdbrugerdefinerede: function hideModaladdbrugerdefinerede() {
      this.$refs['addbrugerdefinerede'].hide();
    },
    hideModaladdbetingelser: function hideModaladdbetingelser() {
      this.$refs['addbetingelser'].hide();
    },
    hideModaldrafts: function hideModaldrafts() {
      this.$refs['quickofferdraft'].hide();
    },
    hidemodaldrafteeditordelete: function hidemodaldrafteeditordelete() {
      this.$refs['drafteeditordeletemodal'].hide();
    },
    initialstep: function initialstep() {
      if (this.offermakingtype === 'StandardTilbud') {
        this.$refs.button2collapse.show = false;

        this.$refs.button1collapse.show = true;

        this.activebutton(1);
      }
      if (this.offermakingtype === 'HurtigtTilbud') {
        this.$refs.button2collapse.show = true;

        this.activebutton(2);
      }
      if (this.offermakingtype === 'UploadTilbud') {
        this.$refs.button2collapse.show = true;
        this.activebutton(2);
      }
    },
    nextstep: function nextstep() {
      if (this.currentstep === 1) {
        if (this.form.headings === null) {
          return false;
        } else if (this.rows.length === 0 || this.rows === null || this.rows === undefined) {
          this.error.notask = 'Tilføj din opgave ved at trykke på Tilføj enhed ';
          return false;
        } else {
          this.currentstep++;
          this.error.notask = '';
          document.querySelector('div#firststep').classList.remove('activecustomerstep');
          return;
        }
      }
      this.currentstep++;
      if (this.currentstep === 2) {
        document.querySelector('div#firststep').classList.remove('activecustomerstep');
        document.querySelector('div#secondstep').classList.add('activecustomerstep');
        if (this.form.navm === null) {
          this.getallactivecustomerandofferbypartner();
        }
        if (this.form.navm === null || this.seletectedaddress === null || this.form.email === null || this.form.mobile === null) {
          return false;
        }
        this.error.notask = '';
      }
      if (this.currentstep === 3) {
        document.querySelector('div#secondstep').classList.remove('activecustomerstep');
        document.querySelector('div#thirdstep').classList.add('activecustomerstep');
        this.currentstep = 3;
      }
    },
    nextstebutton: function nextstebutton() {
      if (this.offermakingtype === 'StandardTilbud') {
        this.button++;
        document.getElementById('button' + this.button).click();
      } else {
        this.button = 4;
        document.getElementById('button' + this.button).click();
      }
    },
    backstep: function backstep() {
      if (this.currentstep === 3) {
        document.querySelector('div#secondstep').classList.add('activecustomerstep');
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep');
      }
      if (this.currentstep === 2) {
        document.querySelector('div#secondstep').classList.remove('activecustomerstep');
        document.querySelector('div#firststep').classList.add('activecustomerstep');
      }
      this.currentstep--;
    },
    activebutton: function activebutton(a) {
      this.button = a;
      if (this.offermakingtype === 'StandardTilbud') {
        if (a === 1) {
          this.$refs.button1.classList.remove('buttonstep');
          this.$refs.mbutton1.classList.remove('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button3.classList.add('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button5.classList.add('buttonstep');
          this.$refs.button6.classList.add('buttonstep');
          this.$refs.mbutton2.classList.add('buttonstep');
          this.$refs.mbutton3.classList.add('buttonstep');
          this.$refs.mbutton4.classList.add('buttonstep');
          this.$refs.mbutton5.classList.add('buttonstep');
          this.$refs.mbutton6.classList.add('buttonstep');
          this.$refs.button2collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button4collapse.show = false;
          this.$refs.button5collapse.show = false;
          this.$refs.button6collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
          }
        }
        if (a === 2) {
          this.$refs.button2.classList.remove('buttonstep');
          this.$refs.mbutton2.classList.remove('buttonstep');
          this.$refs.button1.classList.add('buttonstep');
          this.$refs.button3.classList.add('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button5.classList.add('buttonstep');
          this.$refs.button6.classList.add('buttonstep');
          this.$refs.mbutton1.classList.add('buttonstep');
          this.$refs.mbutton3.classList.add('buttonstep');
          this.$refs.mbutton4.classList.add('buttonstep');
          this.$refs.mbutton5.classList.add('buttonstep');
          this.$refs.mbutton6.classList.add('buttonstep');
          this.$refs.button1collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button4collapse.show = false;
          this.$refs.button5collapse.show = false;
          this.$refs.button6collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
            this.$refs.mbutton5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
            this.$refs.mbutton6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
            this.$refs.mbutton4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
            this.$refs.mbutton3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
            this.$refs.mbutton2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
            this.$refs.mbutton1.classList.remove('buttonstep');
          }
        }
        if (a === 3) {
          this.$refs.button3.classList.remove('buttonstep');
          this.$refs.mbutton3.classList.remove('buttonstep');
          this.$refs.button1.classList.add('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button5.classList.add('buttonstep');
          this.$refs.button6.classList.add('buttonstep');
          this.$refs.mbutton1.classList.add('buttonstep');
          this.$refs.mbutton2.classList.add('buttonstep');
          this.$refs.mbutton4.classList.add('buttonstep');
          this.$refs.mbutton5.classList.add('buttonstep');
          this.$refs.mbutton6.classList.add('buttonstep');
          this.$refs.button1collapse.show = false;
          this.$refs.button2collapse.show = false;
          this.$refs.button4collapse.show = false;
          this.$refs.button5collapse.show = false;
          this.$refs.button6collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
            this.$refs.mbutton5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
            this.$refs.mbutton6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
            this.$refs.mbutton4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
            this.$refs.mbutton3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
            this.$refs.mbutton2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
            this.$refs.mbutton1.classList.remove('buttonstep');
          }
        }
        if (a === 4) {
          this.$refs.button4.classList.remove('buttonstep');
          this.$refs.mbutton4.classList.remove('buttonstep');
          this.$refs.button1.classList.add('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button3.classList.add('buttonstep');
          this.$refs.button5.classList.add('buttonstep');
          this.$refs.button6.classList.add('buttonstep');
          this.$refs.mbutton1.classList.add('buttonstep');
          this.$refs.mbutton2.classList.add('buttonstep');
          this.$refs.mbutton3.classList.add('buttonstep');
          this.$refs.mbutton5.classList.add('buttonstep');
          this.$refs.mbutton6.classList.add('buttonstep');
          this.$refs.button1collapse.show = false;
          this.$refs.button2collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button5collapse.show = false;
          this.$refs.button6collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
            this.$refs.mbutton5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
            this.$refs.mbutton6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
            this.$refs.mbutton4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
            this.$refs.mbutton3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
            this.$refs.mbutton2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
            this.$refs.mbutton1.classList.remove('buttonstep');
          }
        }
        if (a === 5) {
          this.$refs.button5.classList.remove('buttonstep');
          this.$refs.mbutton5.classList.remove('buttonstep');
          this.$refs.button1.classList.add('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button3.classList.add('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button6.classList.add('buttonstep');
          this.$refs.mbutton1.classList.add('buttonstep');
          this.$refs.mbutton2.classList.add('buttonstep');
          this.$refs.mbutton3.classList.add('buttonstep');
          this.$refs.mbutton4.classList.add('buttonstep');
          this.$refs.mbutton6.classList.add('buttonstep');
          this.$refs.button1collapse.show = false;
          this.$refs.button2collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button4collapse.show = false;
          this.$refs.button6collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
            this.$refs.mbutton5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
            this.$refs.mbutton6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
            this.$refs.mbutton4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
            this.$refs.mbutton3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
            this.$refs.mbutton2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
            this.$refs.mbutton1.classList.remove('buttonstep');
          }
        }
        if (a === 6) {
          this.$refs.button6.classList.remove('buttonstep');
          this.$refs.mbutton6.classList.remove('buttonstep');
          this.$refs.button1.classList.add('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button3.classList.add('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button5.classList.add('buttonstep');
          this.$refs.mbutton1.classList.add('buttonstep');
          this.$refs.mbutton2.classList.add('buttonstep');
          this.$refs.mbutton3.classList.add('buttonstep');
          this.$refs.mbutton4.classList.add('buttonstep');
          this.$refs.mbutton5.classList.add('buttonstep');
          this.$refs.button1collapse.show = false;
          this.$refs.button2collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button4collapse.show = false;
          this.$refs.button5collapse.show = false;
          if ((this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button5.classList.remove('buttonstep');
            this.$refs.mbutton5.classList.remove('buttonstep');
          }
          if (this.fiverecommendations !== null && (this.termsnote !== null || this.termsbetingelser !== null) && this.customers !== null) {
            this.$refs.button6.classList.remove('buttonstep');
            this.$refs.mbutton6.classList.remove('buttonstep');
          }
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
            this.$refs.mbutton4.classList.remove('buttonstep');
          }
          if (this.form.discountamount !== 0 || this.form.discountpercentage !== 0) {
            this.$refs.button3.classList.remove('buttonstep');
            this.$refs.mbutton3.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
            this.$refs.mbutton2.classList.remove('buttonstep');
          }
          if (this.form.headings !== null) {
            this.$refs.button1.classList.remove('buttonstep');
            this.$refs.mbutton1.classList.remove('buttonstep');
          }
        }
      }
      if (this.offermakingtype === 'HurtigtTilbud' || this.offermakingtype === 'UploadTilbud') {
        if (a === 2) {
          this.$refs.button2.classList.remove('buttonstep');
          this.$refs.button4.classList.add('buttonstep');
          this.$refs.button4collapse.show = false;
          this.$refs.button1collapse.show = false;
          this.$refs.button3collapse.show = false;
          this.$refs.button5collapse.show = false;
          this.$refs.button6collapse.show = false;
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
          }
        }
        if (a === 4) {
          this.$refs.button4.classList.remove('buttonstep');
          this.$refs.button2.classList.add('buttonstep');
          this.$refs.button2collapse.show = false;
          if (this.customers !== null) {
            this.$refs.button4.classList.remove('buttonstep');
          }
          if (this.rows.length > 0) {
            this.$refs.button2.classList.remove('buttonstep');
          }
        }
      }
    },
    showcustomerselection: function showcustomerselection() {
      document.getElementById('customerstext').classList.remove('hide');
      this.getallactivecustomerandofferbypartner();
    },
    hidecustomerselection: function hidecustomerselection() {
      document.getElementById('customersselect').classList.add('hide');
      document.getElementById('customerstext').classList.add('hide');
      document.querySelector('#newcustomers').classList.remove('hide');
      document.querySelector('#newcustomersss').classList.remove('hide');
      this.customers = null;
    },
    resetcustomerdata: function resetcustomerdata() {
      this.form.navm = null;
      this.form.email = null;
      this.form.mobile = null;
      this.seletectedaddress = '';
    },
    resettaskdata: function resettaskdata() {
      this.form.offerdescription = null;
      this.form.offeramount = null;
      this.form.quantity = 1;
      this.form.quantityunit = 0;
    },
    resettaskrow: function resettaskrow() {
      this.row = {
        uuid: '',
        name: '',
        selected_item: null,
        show_custom_item: false,
        custom_name: '',
        quantity: 1,
        unitPrice: 0,
        discount: 0,
        tax: 0,
        type: 1,
        amount: 0,
        description: ''
      };
    },
    resettaskrowminbolig: function resettaskrowminbolig() {
      this.rowbolig = {
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      };
    },
    resetinfo: function resetinfo() {
      this.info = {
        currency_id: null,
        customer_id: null,
        date: this.currentandexpiryDateTime(),
        expiry_date: this.currentandexpiryDateTime('expiry'),
        expiry_date_detail: '',
        uploadToken: '',
        itme_type: '',
        rows: [],
        subject: '',
        description: '',
        subtotal: 0,
        subtotalDiscount: 0,
        line_item_discount_type: true,
        subtotalDiscount_type: false,
        subtotalTax: 25,
        subtotalShippingAndHandling: 0,
        total: 0,
        reference_number: '',
        quotation_prefix: '',
        quotationPrefix: '',
        isDraft: 0,
        show_sub_total_tax: true,
        show_sub_total_discount: true,
        show_sub_total_shipping_and_handling: true,
        show_line_item_tax: true,
        show_line_item_discount: true,
        show_line_item_description: true,
        customer_note: '',
        memo: '',
        tnc: ''
      };
    },
    resetalldataaftersend: function resetalldataaftersend() {
      this.resetcustomerdata();
      this.resettaskdata();
      this.resettaskrow();
      this.resetinfo();
      if (this.currentstep === 3) {
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep');
        document.querySelector('div#firststep').classList.add('activecustomerstep');
      }
      this.currentstep = 1;
      this.editingdraft = 0;
      this.rows = [];
      this.fordelete = [];
      this.customers = [];
      this.form.bilagfile = [];
      this.form.termsnote = '';
      this.form.termsbetingelser = '';
      this.form.headings = '';
      this.form.headerImage = '';
      this.getallofferbypartner();
      this.updareferencenumber();
    },
    currentandexpiryDateTime: function currentandexpiryDateTime() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var current = new Date();
      if (a !== null) {
        current.setDate(current.getDate() + 30);
      }
      var date = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate();
      var time = current.getHours() + ':' + current.getMinutes() + ':' + current.getSeconds();
      var dateTime = date + ' ' + time;
      return dateTime;
    },
    fordeletecontinue: function fordeletecontinue(item) {
      this.fordelete = item;
    },
    deletedrafttilbud: function deletedrafttilbud(item) {
      var _this2 = this;

      this.loading = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = {
        operation: 'delTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: item.appid,
        offer_id: item.id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.loading = false;
        _this2.hidemodaldrafteeditordelete();
        _this2.hideModaldrafts();
        _this2.getallofferbypartner();
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    deletetask: function deletetask(row) {
      var idx = this.rows.indexOf(row);
      if (idx > -1) {
        this.rows.splice(idx, 1);
      }
      if (this.rows.length === 0) {
        this.subtotalprice = 0;
        this.compututedtaxsingle = 0;
        this.info.subtotal = 0;
        this.info.total = 0;
      }
      if (this.rows.length > 0) {
        this.subtotalprice = this.rows.reduce(function (acc, item) {
          return acc + item.amount;
        }, 0);
        this.compututedtaxsingle = parseInt(this.subtotalprice) + parseInt(this.subtotalprice * (this.info.subtotalTax / 100));
        if (this.info.subtotalDiscount !== 0) {
          if (this.info.subtotalDiscount_type) {
            this.compututedtaxsingle = parseInt(this.compututedtaxsingle) - parseInt(this.compututedtaxsingle * (this.form.discount / 100));
          } else {
            this.compututedtaxsingle = parseInt(this.compututedtaxsingle) - parseInt(this.form.discount);
          }
        }
        this.info.subtotal = this.subtotalprice;
        this.info.total = this.compututedtaxsingle;
      }
    },
    deletetaskminbolig: function deletetaskminbolig(row) {
      this.error.notask = '';
      var idx = this.rows.indexOf(row);
      if (idx > -1) {
        this.rows.splice(idx, 1);
      }
      if (this.rows.length === 0) {
        this.subtotalprice = 0;
        this.compututedtaxsingle = 0;
        this.info.subtotal = 0;
        this.info.total = 0;
      }
      if (this.rows.length > 0) {
        this.subtotalprice = this.rows.reduce(function (acc, item) {
          return acc + item.amount;
        }, 0);
        this.compututedtaxsingle = parseInt(this.subtotalprice) + parseInt(this.subtotalprice * (this.info.subtotalTax / 100));
        if (this.info.subtotalDiscount !== 0) {
          if (this.info.subtotalDiscount_type) {
            this.compututedtaxsingle = parseInt(this.compututedtaxsingle) - parseInt(this.compututedtaxsingle * (this.form.discount / 100));
          } else {
            this.compututedtaxsingle = parseInt(this.compututedtaxsingle) - parseInt(this.form.discount);
          }
        }
        this.info.subtotal = this.subtotalprice;
        this.info.total = this.compututedtaxsingle;
      }
      var sumrow = [];
      sumrow = this.rowsbolig.filter(function (a) {
        return a.title === row.custom_name && a.value === row.amount;
      });
      var idxs = this.rowsbolig.indexOf(sumrow[0]);
      if (idxs > -1) {
        this.rowsbolig.splice(idxs, 1);
      }
    },
    disabletheother: function disabletheother() {
      if (this.form.discountamount > 0) {
        document.getElementById('discountpercentage').disabled = true;
      } else if (this.form.discountamount === '') {
        document.getElementById('discountpercentage').disabled = false;
      } else {
        document.getElementById('discountpercentage').disabled = false;
      }
      if (this.form.discountpercentage > 0) {
        document.getElementById('discountamount').disabled = true;
      } else if (this.form.discountamount === '') {
        document.getElementById('discountamount').disabled = false;
      } else {
        document.getElementById('discountamount').disabled = false;
      }
    },
    confirmtilbud: function confirmtilbud() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (a === 'finaloffer') {
        this.addtilbud();
      } else if (a === 'draftfinaloffer') {
        this.addtilbud();
      }
    },
    confirmmanswertilbud: function confirmmanswertilbud(type, answer) {
      var _this3 = this;

      if (answer === 'yes') {
        if (this.editingdraft === 0) {
          return function (dialog) {
            return _this3.addtilbud();
          };
        } else if (this.editingdraft === 1) {
          return function (dialog) {
            return _this3.addtilbud();
          };
        } else {
          alert('Something went wrong here at saving your tilbud');
        }
      } else if (answer === 'no') {
        if (type === 'final') {
          return function (dialog) {
            return _this3.addglow();
          };
        } else if (type === 'saveasdraft') {
          return function (dialog) {
            return _this3.updatetilbud();
          };
        } else {
          alert('Something went wrong here at saving your tilbud 2');
        }
      }
    },
    continueeditdrafttilbud: function continueeditdrafttilbud(item) {
      this.editingdraft = 1;
      this.error.notask = '';
      this.tilbud = item;
      this.info = item.info;
      this.loading = true;
      this.$refs.drafteeditordeletemodal.hide();
      this.$refs.quickofferdraft.hide();
      if (this.currentstep === 3) {
        document.querySelector('div#thirdstep').classList.remove('activecustomerstep');
        document.querySelector('div#firststep').classList.add('activecustomerstep');
      }
      this.currentstep = 1;
      this.usereferencenumber = this.tilbud.info.reference_number;
      this.rows = this.tilbud.info.rows;
      this.appid = this.tilbud.appid;
      this.info.subtotal = parseFloat(this.tilbud.info.subtotal);
      this.info.total = parseFloat(this.tilbud.info.total);
      this.info.subtotalDiscount = parseFloat(this.tilbud.info.subtotalDiscount);
      this.info.subtotalDiscount_type = this.tilbud.info.subtotalDiscount_type;
      if (this.info.subtotalDiscount > 0) {
        if (this.info.subtotalDiscount_type) {
          this.form.discount = parseFloat(this.form.discountpercentage);
          this.form.discountsymbol = '%';
          this.form.discountpercentage = parseFloat(this.tilbud.info.subtotalDiscount);
          this.compututedtaxsingle = parseFloat(this.compututedtaxsingle) - parseFloat(this.compututedtaxsingle * (this.form.discount / 100));
        } else {
          this.form.discount = parseFloat(this.tilbud.info.subtotalDiscount);
          this.form.discountsymbol = 'kr';
          this.form.discountamount = parseFloat(this.tilbud.info.subtotalDiscount);
          this.compututedtaxsingle = parseFloat(this.compututedtaxsingle) - parseFloat(this.form.discount);
        }
      }
      this.subtotalprice = this.rows.reduce(function (acc, item) {
        return acc + item.amount;
      }, 0);
      this.compututedtaxsingle = parseFloat(this.subtotalprice) + parseFloat(this.subtotalprice * (this.info.subtotalTax / 100));
      this.info.subtotal = parseFloat(this.subtotalprice);
      this.info.total = parseFloat(this.compututedtaxsingle);
      this.form.bilagfile = this.tilbud.bilagfile;
      this.fiverecommendations = JSON.parse(this.tilbud.recommendations);
      this.getallactivecustomerandofferbypartner(this.tilbud.appid);
      this.form.headings = this.tilbud.header_text;
      this.form.termsnote = this.tilbud.notat;
      this.header_image = this.tilbud.header_image;
      this.header_image = this.header_image.replaceAll('håndværker', 'haandvaerker');
      this.form.termsbetingelser = this.tilbud.betingelser;
    },
    getallactivecustomerandofferbypartner: function getallactivecustomerandofferbypartner() {
      var _this4 = this;

      var customerid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this.loading = true;
      var cid = this.$route.query.id;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_partner', salesPerson: this.salesPerson, typeMeeting: '1', cid: cid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        _this4.items = res.array;
        var customerx = [];
        _this4.loading = false;
        if (customerid !== null) {
          customerx = _this4.items.filter(function (item) {
            return item.id_appointment === customerid;
          });
          _this4.customers = customerx[0];
          if (_this4.customers !== undefined) {
            _this4.assigncustomerinput(_this4.customers);
          }
          _this4.seletectedaddress = '';
          _this4.seletectedaddress = _this4.customers.mailingstreet + ', ' + _this4.customers.mailingzip + ' ' + _this4.customers.mailingcity;
        }
        if (_this4.kunderid !== '' && typeof _this4.kunderid !== 'undefined') {
          _this4.getcustomerdetailsfromminekunder(_this4.kunderid);
        }
        if (_this4.$route.query.name) {
          setTimeout(function () {
            _this4.checkCustomer();
          }, 100);
        }
      }, function (response) {
        alert('error getting you customers');
      });
    },
    getallofferbypartner: function getallofferbypartner() {
      var _this5 = this;

      var draftimesrow = [];
      var draftfilteredrow = [];
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'userTilbuds', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        _this5.alltilbudanduserinfo = res;
        _this5.usereferencenumber = 'REF' + parseInt(_this5.alltilbudanduserinfo.totaloffer + 1) + '-' + _this5.alltilbudanduserinfo.partnerid;
        _this5.alltilbud = res.tilbud;

        draftfilteredrow = _this5.alltilbud.filter(function (item) {
          return item.is_darft > 0;
        });
        draftfilteredrow.forEach(function (offer, index) {
          draftimesrow.push(offer);
        });
        _this5.draftitems = draftimesrow;

        _this5.loading = false;
      }, function (response) {
        alert('error');
      });
    },
    getcustomerdetailsfromminekunder: function getcustomerdetailsfromminekunder(custimerid) {
      var _this6 = this;

      var custdetails = [];
      custdetails = this.items.filter(function (a) {
        return a.contactid === custimerid;
      });
      setTimeout(function () {
        _this6.assigncustomerinput(custdetails[0]);
        _this6.customers = custdetails[0].firstname + ' ' + custdetails[0].lastname + ', ' + custdetails[0].email + '-' + custdetails[0].mobile;
        var addr = '';
        addr = custdetails[0].mailingstreet + ', ' + custdetails[0].mailingzip + ' ' + custdetails[0].mailingcity;
        _this6.seletectedaddress = addr;
        _this6.assignaddresseinput(addr);
      }, 100);
    },
    getaddressfromkeyword: function getaddressfromkeyword(keyword) {
      var _this7 = this;

      var inputkey = keyword;
      var searchgaddresses = [];
      this.addressloading = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'findAddress', salesPerson: this.salesPerson, keyword: inputkey };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        _this7.addresses = res;
        _this7.addresses.forEach(function (address, index) {
          searchgaddresses.push(address.tekst);
        });

        _this7.searchgaddress = searchgaddresses;
        _this7.addressloading = false;
        _this7.focusthis();
      }, function (response) {
        alert('error');
      });
    },
    getterms: function getterms() {
      var type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      var _this8 = this;

      var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var c = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

      var data = { operation: 'terms', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this8.$router.push('/login');
        }
        _this8.terms = res;
        _this8.termsbetingelser = _this8.terms.filter(function (termsitem) {
          return termsitem.type === 'betingelser';
        });
        _this8.termsnotes = _this8.terms.filter(function (termsbet) {
          return termsbet.type === 'note';
        });
        if (c !== null && type === 'note') {
          _this8.assigntermsinput(type, _this8.termsnotes[0]);
        } else if (c !== null && type !== 'note') {
          _this8.assigntermsinput(type, _this8.termsbetingelser[0]);
        }
        if (id !== null) {
          if (type === 'note') {
            _this8.termsnotats = _this8.termsnotes.filter(function (itemss) {
              return itemss.id === id;
            });
            _this8.termsnotats = 'Ingen bemærkninger';
          } else {
            _this8.termsbetings = _this8.termsbetingelser.filter(function (itemss) {
              return itemss.id === id;
            });
          }
        } else {
          _this8.termsnotats['description'] = '';
          _this8.assigntermsinput('note', _this8.termsnotats);

          _this8.termsbetings['description'] = '';
          _this8.assigntermsinput('betingelser', _this8.termsbetings);
        }
      }, function (response) {
        alert('error');
      });
    },
    getallrecommendations: function getallrecommendations() {
      var _this9 = this;

      this.loading = true;
      var data = { operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        _this9.allrecommendatationsitems = res;
        var toprecords = [];
        var topfiverecords = [];
        toprecords = _this9.allrecommendatationsitems.filter(function (item) {
          return item.Rating > 3.9;
        });
        toprecords.sort(function (a, b) {
          return a - b;
        });
        topfiverecords = toprecords.slice(0, 5);

        _this9.fiverecommendations = topfiverecords.map(function (item, index) {
          return item.ReviewId;
        });
        _this9.loading = false;
      }, function (response) {
        alert('error');
      });
    },
    getallheaderimage: function getallheaderimage() {
      var _this10 = this;

      this.loading = true;
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this10.$router.push('/login');
        }
        _this10.alliheadermages = res.resultImages;
        _this10.header_image = _this10.alliheadermages[0].FileLocation;
        _this10.header_image = _this10.header_image.replaceAll('håndværker', 'haandvaerker');
        _this10.loading = false;
      }, function (response) {
        alert('error');
      });
    },
    removethisrecommendation: function removethisrecommendation(item) {
      var idx = this.fiverecommendations.indexOf(item);
      if (idx > -1) {
        this.fiverecommendations.splice(idx, 1);
      }
      document.querySelector('div#box' + item).classList.remove('reviewbox');
    },
    removethisactiveheader: function removethisactiveheader(item) {
      document.getElementById(item).classList.remove('mainimageheader');
    },
    removeitembilag: function removeitembilag(item) {
      this.form.bilagfile.splice(this.form.bilagfile.indexOf(item), 1);
    },
    checkifselected: function checkifselected(item) {
      if (this.fiverecommendations.includes(item)) {
        return true;
      } else {
        return false;
      }
    },
    checkthebox: function checkthebox(item) {
      if (this.fiverecommendations.includes(item)) {
        if (document.querySelector('div#box' + item) !== null) {
          var el = document.querySelector('div#box' + item);
          el.classList.add('reviewbox');
        }
      } else {
        return '';
      }
    },
    checkifthisisheaderimageactive: function checkifthisisheaderimageactive(item) {
      if (item.replaceAll('håndværker', 'haandvaerker') === this.header_image.replaceAll('håndværker', 'haandvaerker')) {
        document.getElementById(item.replaceAll('håndværker', 'haandvaerker')).classList.add('mainimageheader');
      }
    },
    assignthisheaderimage: function assignthisheaderimage(item) {
      this.removethisactiveheader(this.header_image.replaceAll('håndværker', 'haandvaerker'));
      this.header_image = item.replaceAll('håndværker', 'haandvaerker');
      this.checkifthisisheaderimageactive(item);
    },
    assignfiverecommendations: function assignfiverecommendations(item) {
      this.fiverecommendations.push(item);
      if (this.checkifselected(item)) {
        document.querySelector('div#box' + item).classList.add('reviewbox');
      }
      if (this.fiverecommendations.length === 5) {}
    },
    assigntermsinput: function assigntermsinput(type, item) {
      if (type === 'note') {
        this.termsnotats = item;
        this.form.termsnote = item.description;
      } else {
        this.termsbetings = item;
        this.form.termsbetingelser = item.description;
      }
    },
    assigncustomerinput: function assigncustomerinput(item) {
      if (item !== null && typeof item !== 'undefined') {
        this.form.navm = item.firstname + ' ' + item.lastname;
        this.form.email = item.email;
        this.form.mobile = item.mobile;
        this.appid = item.id_appointment;
        this.form.adresse = item.mailingstreet + ' ' + item.mailingzip + ' ' + item.mailingcity;
        this.seletectedaddress = this.form.adresse;
        this.error.notask = '';
        this.customerInputDisabled = true;
      } else {
        this.form.navm = '';
        this.form.email = '';
        this.form.mobile = '';
      }
    },
    assigndatecomment: function assigndatecomment() {
      this.info.date = this.form.dateoffer;
      this.info.expiry_date = this.form.dateofferexpiry;
      this.info.customer_note = this.form.comment;
    },
    assignaddresseinput: function assignaddresseinput(item) {
      this.form.adresse = item;
    },
    computetaskprice: function computetaskprice() {
      var subtotalprice = parseInt(this.form.offeramount * this.form.quantity) + parseInt(this.form.offeramount * this.form.quantity * (this.info.subtotalTax / 100));
      this.subtotalprices = subtotalprice;
      return subtotalprice;
    },
    localeParseFloat: function localeParseFloat(s, locale) {},
    addtask: function addtask() {
      var unitofaty = '';
      if ((this.form.offeramount === null || this.form.offerdescription === null || this.form.quantity === null) && this.offermakingtype !== 'UploadTilbud') {
        this.error.notask = 'Udfyld opgavebeskrivelsen og prisen';
        return false;
      } else {
        this.row.unitPrice = parseFloat(this.form.offeramount);
        this.row.quantity = parseFloat(this.form.quantity);
        if (this.form.quantityunit === null || this.form.quantityunit === 0) {
          this.form.quantityunit = 0;
          unitofaty = 'Antal';
          this.row.amount = parseFloat(this.form.offeramount * this.form.quantity);
        } else if (this.form.quantityunit === 1) {
          unitofaty = 'Beløb';
          this.row.amount = parseFloat(this.form.offeramount);
        } else {
          unitofaty = 'Timer';
          this.row.amount = parseFloat(this.form.offeramount * this.form.quantity);
        }
        this.rowbolig.title = this.form.offerdescription;
        this.rowbolig.description = this.form.offerdescription;
        this.rowbolig.unit = unitofaty;
        this.rowbolig.value = parseFloat(this.form.offeramount * this.form.quantity);
        this.rowbolig.quantity = parseFloat(this.form.quantity);
        this.row.type = parseFloat(this.form.quantityunit);
        this.row.custom_name = this.form.offerdescription;
        this.row.uuid = __WEBPACK_IMPORTED_MODULE_6_uuid_v4___default()();
        this.rowsbolig.push(this.rowbolig);
        this.rows.push(this.row);
        this.subtotalprice = this.rows.reduce(function (acc, item) {
          return acc + item.amount;
        }, 0);
        this.compututedtaxsingle = parseFloat(this.subtotalprice) + parseFloat(this.subtotalprice * (this.info.subtotalTax / 100));
        this.info.subtotal = parseFloat(this.subtotalprice);
        this.info.total = parseFloat(this.compututedtaxsingle);

        this.resettaskrow();
        this.resettaskrowminbolig();
        this.error.notask = '';
        this.form.offeramount = null;
        this.form.quantity = 1;
        this.form.offerdescription = null;
      }
    },
    addiscount: function addiscount() {
      if (this.form.discountamount > 0) {
        this.info.subtotalDiscount = parseFloat(this.form.discountamount);
        this.info.subtotalDiscount_type = false;
      }
      if (this.form.discountpercentage > 0) {
        this.info.subtotalDiscount = parseFloat(this.form.discountpercentage);
        this.info.subtotalDiscount_type = true;
      }
      if (this.info.subtotalDiscount !== 0) {
        if (this.info.subtotalDiscount_type) {
          this.form.discount = parseFloat(this.form.discountpercentage);
          this.form.discountsymbol = '%';
          this.compututedtaxsingle = parseFloat(this.compututedtaxsingle) - parseFloat(this.compututedtaxsingle * (this.form.discount / 100));
        } else {
          this.form.discount = parseFloat(this.form.discountamount);
          this.form.discountsymbol = 'kr';
          this.compututedtaxsingle = parseFloat(this.compututedtaxsingle) - parseFloat(this.form.discount);
        }
      }
      this.info.subtotal = parseFloat(this.subtotalprice);
      this.info.total = parseFloat(this.compututedtaxsingle);
    },
    addCustomer: function addCustomer() {
      var _this11 = this;

      if (this.form.navm === null || this.form.email === null || this.form.mobile === null) {
        this.error.notask = 'Noget mangler i dine kundeoplysninger. Kontroller venligst';
        return false;
      } else if (this.customers !== null) {
        this.appid = this.appid;
      } else {
        var data = {
          operation: 'addUserPartner',
          salesPerson: this.salesPerson,
          name: this.form.navm,
          email: this.form.email,
          mobile: this.form.mobile,
          address: this.form.adresse,
          addressid: this.form.adresseid,
          adgangsadresseid: this.form.adresseadgang
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var addcus = res;
            _this11.appid = addcus.appid;
            _this11.getallactivecustomerandofferbypartner(_this11.appid);
            document.getElementById('customers').classList.remove('hide');
            document.getElementById('newcustomers').classList.add('hide');
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this11.$refs.simplert.openSimplert(obj);
          } else {
            alert('sorry something went wrong in adding your customer');
          }
        }, function (response) {
          alert('error in adding customer');
        });
      }
    },
    addtilbud: function addtilbud() {
      var _this12 = this;

      var asktext = '';
      var confirfinaltext = '';
      var cancelfinaltext = '';
      if (this.editingdraft === 0) {
        asktext = 'Har du set forhåndsvisningen?';
        confirfinaltext = 'Send tilbud til kundens email';
        cancelfinaltext = 'Annuller';
      } else {
        asktext = 'vil du ikke lave dette som et sidste tilbud eller gemme stadig som et udkast?';
        confirfinaltext = 'Indsend';
        cancelfinaltext = 'Opdater kladde';
      }
      this.$confirm(asktext, {
        confirmButtonText: confirfinaltext,
        cancelButtonText: cancelfinaltext,
        type: 'warning'
      }).then(function () {
        if (_this12.offermakingtype === 'UploadTilbud') {
          _this12.addtask();
        }
        if (_this12.validator()) {
          return false;
        } else {
          if (_this12.$route.query.projectId) {
            _this12.addOffer();
          } else {
            if (_this12.customers === null) {
              if (_this12.form.navm === null || _this12.form.email === null || _this12.form.mobile === null) {
                _this12.error.notask = 'Noget mangler i dine kundeoplysninger. Kontroller venligst';
                return false;
              } else if (_this12.customers !== null) {
                _this12.appid = _this12.appid;
              } else {
                _this12.mainloading = true;
                _this12.previewloading = true;
                var datas = {
                  operation: 'addUserPartner',
                  salesPerson: _this12.salesPerson,
                  name: _this12.form.navm,
                  email: _this12.form.email,
                  mobile: _this12.form.mobile,
                  address: _this12.form.adresse,
                  addressid: _this12.form.adresseid,
                  adgangsadresseid: _this12.form.adresseadgang
                };
                _this12.$http.post('', datas, { emulateJSON: true }).then(function (response) {
                  var res = response.body;
                  if (res.success) {
                    var addcus = res;
                    _this12.appid = addcus.appid;
                    _this12.getallactivecustomerandofferbypartner(_this12.appid);
                    _this12.info.rows = _this12.rows;
                    _this12.info.reference_number = _this12.usereferencenumber;
                    var data = {
                      operation: 'addTilbud',
                      salesPerson: _this12.salesPerson,
                      levid: _this12.haaid,
                      tilbud_id: _this12.appid,
                      betingelser: _this12.form.termsbetingelser,
                      bilag: _this12.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
                      is_darft: 0,
                      offerfile: _this12.uploadedpdf,
                      onlyfile: _this12.onlyfile,
                      notat: _this12.form.termsnote,
                      header_text: _this12.form.headings,
                      header_image: _this12.header_image,
                      recommendations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.fiverecommendations),
                      tilbud: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.info),
                      bilagfile: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.form.bilagfile),
                      files: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.tilbud.files),
                      image: _this12.tilbud.image,
                      reference_number: _this12.usereferencenumber
                    };
                    _this12.$http.post('', data, { emulateJSON: true }).then(function (response) {
                      var res = response.body;
                      if (res.success) {
                        _this12.previewloading = false;
                        _this12.mainloading = false;
                        var obj = {
                          title: 'Gennemført!',
                          message: '',
                          type: 'success',
                          customCloseBtnText: 'Luk'
                        };
                        _this12.$refs.simplert.openSimplert(obj);

                        _this12.resetalldataaftersend();
                        setTimeout(function () {
                          _this12.gotohistory();
                        }, 2000);
                      } else {
                        alert('error add tilbud');
                      }
                    }, function (response) {
                      alert('error adding tilbuds');
                    });
                  } else {
                    alert('sorry something went wrong in adding your customer');
                  }
                }, function (response) {
                  alert('error in adding customer');
                });
              }
            } else {
              _this12.mainloading = true;
              _this12.previewloading = true;
              _this12.info.rows = _this12.rows;
              _this12.info.reference_number = _this12.usereferencenumber;
              var data = {
                operation: 'addTilbud',
                salesPerson: _this12.salesPerson,
                levid: _this12.haaid,
                tilbud_id: _this12.appid,
                betingelser: _this12.form.termsbetingelser,
                bilag: _this12.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
                is_darft: 0,
                offerfile: _this12.uploadedpdf,
                onlyfile: _this12.onlyfile,
                notat: _this12.form.termsnote,
                header_text: _this12.form.headings,
                header_image: _this12.header_image,
                recommendations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.fiverecommendations),
                tilbud: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.info),
                bilagfile: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.form.bilagfile),
                files: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this12.tilbud.files),
                image: _this12.tilbud.image,
                reference_number: _this12.usereferencenumber
              };
              _this12.$http.post('', data, { emulateJSON: true }).then(function (response) {
                var res = response.body;
                if (res.success) {
                  _this12.previewloading = false;
                  _this12.mainloading = false;
                  var obj = {
                    title: 'Gennemført!',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  };
                  _this12.$refs.simplert.openSimplert(obj);

                  _this12.resetalldataaftersend();
                  setTimeout(function () {
                    _this12.gotohistory();
                  }, 2000);
                } else {
                  alert('error add tilbud');
                }
              }, function (response) {
                alert('error adding tilbuds');
              });
            }
          }
        }
      }).catch(function () {
        if (_this12.editingdraft === 0) {
          _this12.addglow();
        } else if (_this12.editingdraft === 1) {
          _this12.updatetilbud();
        }
      });
    },
    addOffer: function addOffer() {
      var _this13 = this;

      var vatamount = parseFloat(0.25 * this.subtotalprice);
      var projId = this.$route.query.projectId;
      this.loading = true;

      this.info.rows = this.rows;
      this.info.reference_number = this.usereferencenumber;
      this.salesPersonNew = localStorage.getItem('id_token_portalbitrix');
      var formDescription = this.rowsbolig[0].description;
      if (this.offermakingtype === 'HurtigtTilbud') {
        this.form.headings = this.rowsbolig[0].description;
      }
      if (this.offermakingtype === 'UploadTilbud') {
        this.form.headings = 'Uploadet Tilbud';
        formDescription = formDescription !== null ? this.rowsbolig[0].description : 'Uploadet Tilbud';
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      };
      var data = {
        projectId: projId,
        offers: [{
          title: this.form.headings,
          description: formDescription,
          subtotalPrice: this.subtotalprice,
          vat: vatamount,
          totalPrice: parseFloat(vatamount + this.subtotalprice),

          tasks: this.rowsbolig
        }]
      };
      this.$http.post("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/offer', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this13.previewloading = false;
        _this13.loading = false;
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this13.$refs.simplert.openSimplert(obj);
        _this13.resetalldataaftersend();
        setTimeout(function () {
          _this13.$router.push('/alle-moeder');
        }, 2000);
      }, function (response) {
        _this13.loading = false;
        _this13.formLoading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var message = _step.value;

                  _this13.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else {
              _this13.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this13.$router.push('/login');
          }
        } else {
          _this13.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    addterms: function addterms(type) {
      var _this14 = this;

      var title = '';
      var desc = '';
      var typeterm = '';
      if (type === 'note') {
        title = this.form.termsaddnotetitle;
        desc = this.form.termsaddnotedesc;
        typeterm = type;
      } else {
        title = this.form.termsbetingelsertitle;
        desc = this.form.termsbetingelserdesc;
        typeterm = type;
      }
      this.loading = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = {
        operation: 'addTerm',
        salesPerson: this.salesPerson,
        title: title,
        description: desc,
        type: typeterm
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this14.$router.push('/login');
        }
        _this14.getterms(type, null, 1);
        if (type === 'note') {
          _this14.form.termsnote = desc;
          _this14.hideModaladdbrugerdefinerede();
        } else {
          _this14.form.termsbetingelser = desc;
          _this14.hideModaladdbetingelser();
        }
        if (_this14.offermakingtype !== 'StandardTilbud') {
          _this14.hideModalconditions();
        }
        _this14.loading = false;
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this14.$refs.simplert.openSimplert(obj);
      }, function (response) {
        alert('error');
      });
    },
    addglow: function addglow() {
      document.querySelector('button#preview').classList.add('button-glow');
    },
    addglowenhed: function addglowenhed() {
      setTimeout(function () {
        document.querySelector('button#enhed').classList.add('button-glow');
      }, 50);
    },
    addglowcustomer: function addglowcustomer() {
      setTimeout(function () {
        document.querySelector('button#selectaddr').classList.add('button-glow');
      }, 50);
    },
    updatetilbud: function updatetilbud() {
      var _this15 = this;

      this.mainloading = true;
      this.previewloading = true;
      this.info.subtotal = this.subtotalprice;
      this.info.total = this.compututedtaxsingle;
      this.info.rows = this.rows;
      var data = {
        operation: 'editTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: this.appid,
        betingelser: this.form.termsbetingelser,
        bilag: this.tilbud.bilag,
        is_darft: this.tilbud.is_darft,
        notat: this.form.termsnote,
        header_text: this.form.headings,
        header_image: this.header_image,
        recommendations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.fiverecommendations),
        tilbud: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.info),
        bilagfile: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.form.bilagfile),
        file: this.tilbud.files,
        image: this.tilbud.image,
        reference_number: this.usereferencenumber
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this15.previewloading = false;
          _this15.mainloading = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this15.$refs.simplert.openSimplert(obj);
          setTimeout(function () {
            _this15.gotohistory();
          }, 2000);
        } else {
          alert('error updating tilbud');
        }
      }, function (response) {
        alert('error updating tilbud');
      });
    },
    updareferencenumber: function updareferencenumber() {
      var a = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      if (this.editingdraft === 0) {
        this.usereferencenumber = 'REF' + parseInt(this.alltilbudanduserinfo.totaloffer + 1) + '-' + this.alltilbudanduserinfo.partnerid;
      }
      if (this.editingdraft === 1) {
        this.usereferencenumber = a;
      }
    },
    saveasdraft: function saveasdraft() {
      var _this16 = this;

      this.mainloading = true;
      this.info.rows = this.rows;
      this.loading = true;
      this.info.subtotal = parseFloat(this.subtotalprice);
      this.info.total = parseFloat(this.compututedtaxsingle);
      this.info.reference_number = this.usereferencenumber;
      var data = {
        operation: 'addTilbud',
        levid: this.haaid,
        salesPerson: this.salesPerson,
        tilbud_id: this.appid,
        betingelser: this.form.termsbetingelser,
        bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
        is_darft: 1,
        notat: this.form.termsnote,
        header_text: this.form.headings,
        header_image: this.header_image,
        recommendations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.fiverecommendations),
        tilbud: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.info),
        bilagfile: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.form.bilagfile),
        files: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.tilbud.files),
        image: this.tilbud.image,
        reference_number: this.usereferencenumber
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this16.previewloading = false;
          _this16.mainloading = false;
          _this16.resetalldataaftersend();
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this16.$refs.simplert.openSimplert(obj);
          setTimeout(function () {
            _this16.gotohistory();
          }, 2000);
        } else {
          alert('error saving as draft');
        }
      }, function (response) {
        alert('error error saving as draft');
      });
    },
    previewoffer: function previewoffer() {
      var _this17 = this;

      if (this.offermakingtype === 'UploadTilbud') {
        this.addtask();
      }
      if (this.validator()) {
        return false;
      } else {
        this.previewloading = true;
        this.info.rows = this.rows;
        this.info.reference_number = this.usereferencenumber;
        var data = {
          operation: 'preTilbud',
          salesPerson: this.salesPerson,
          offer_id: this.appid,
          tilbud_id: this.appid,
          levid: this.haaid,
          reference_number: this.usereferencenumber,
          notat: this.form.termsnote,
          betingelser: this.form.termsbetingelser,
          bilag: this.form.bilagfile.toString().replaceAll('[', ' ').replaceAll(']', ' '),
          header_text: this.form.headings,
          header_image: this.header_image,
          recommendations: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.fiverecommendations),
          tilbud: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.info),
          bilagfile: this.form.bilagfile,
          files: this.tilbud.files,
          image: this.tilbud.image
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this17.pdfurl = res.pdf;

            window.open(_this17.pdfurl, '_blank');
            _this17.previewloading = false;
          } else {
            alert('error previewing');
          }
        }, function (response) {
          alert('error previewing');
        });
      }
    },
    gotohistory: function gotohistory() {
      this.$router.push('/tilbud/tilbud-historie');
    },
    download_file: function download_file(fileURL, fileName) {
      if (!window.ActiveXObject) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/') + 1);
        save.download = fileName || filename;
        if (navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search('Chrome') < 0) {
          document.location = save.href;
        } else {
          var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
          });
          save.dispatchEvent(evt)(window.URL || window.webkitURL).revokeObjectURL(save.href);
        }
      } else if (!!window.ActiveXObject && document.execCommand) {
        var _window = window.open(fileURL, '_blank');
        _window.document.close();
        _window.document.execCommand('SaveAs', true, fileName || fileURL);
        _window.close();
      }
    },
    handleFileUploadpdf: function handleFileUploadpdf(file) {
      this.uploadedpdf = file[0];

      this.itsok = false;
      this.onlyfile = true;
      this.error.notask = '';
    },
    handleFileUpload: function handleFileUpload(file) {
      var uploadedfiles = [];
      this.mainfiles = file;
      var newfiles = this.form.bilagfile;
      this.form.bilagfile = [];
      uploadedfiles = file;
      if (uploadedfiles.length > 0) {
        uploadedfiles.forEach(function (item) {
          if (newfiles.includes(item)) {} else {
            newfiles.push(item);
          }
        });
        this.form.bilagfile = newfiles;
        uploadedfiles = [];
        newfiles = [];
      } else {
        this.form.bilagfile = uploadedfiles;
      }
      this.onlyfile = false;
    },
    showbilag: function showbilag() {
      if (this.form.bilagfile.length > 0) {
        setTimeout(function () {
          document.getElementById('bilagfiles').classList.remove('hide');
          document.getElementById('bilagfilestext').classList.remove('hide');
        }, 100);
      }
    },
    offerMenu: function offerMenu() {},
    validator: function validator() {
      if (this.offermakingtype === 'UploadTilbud') {
        if (this.subtotalprice === '' || this.subtotalprice === null || this.subtotalprice === 0) {
          this.error.notask = 'Angiv venligst din pris';
          return true;
        }
        if (this.uploadedpdf === '') {
          this.error.notask = 'Upload venligst din pdf';
          return true;
        }
      } else {
        if (this.form.navm === null || this.form.email == null || this.form.mobile === null || this.form.adresse === null) {
          this.$refs.button4collapse.show = true;
          this.activebutton(4);
          this.error.notask = 'Udfyld venligst dine kunders oplysninger';
          return true;
        }
        if (this.form.headings === null) {
          this.$refs.button1collapse.show = true;
          this.activebutton(1);
          this.error.notask = 'Udfyld venligst din overskriftstekst for dit tilbud';
          return true;
        }
        if (this.rows.length === 0) {
          this.$refs.button2collapse.show = true;
          this.activebutton(2);
          this.addglowenhed();
          this.error.notask = 'Tilføj din opgave med den tilsvarende pris';
          return true;
        }
      }
    },
    hidenamevalidator: function hidenamevalidator() {
      if (this.form.headings !== null) {
        this.error.notask = '';
      }
    },
    getSelectedProj: function getSelectedProj() {
      var _this18 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      };
      var data = {};
      var projId = this.$route.query.projectId;
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/projects', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res !== null && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            if (res[i].ID === projId) {
              _this18.selectedProjectData = res[i];
            }
          }
        }
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var message = _step2.value;

                  _this18.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else {
              _this18.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this18.$router.push('/login');
          }
        } else {
          _this18.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    }
  }
});

/***/ }),
/* 1305 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__file_upload_progress_vue__ = __webpack_require__(540);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: { fileUploadProgress: __WEBPACK_IMPORTED_MODULE_0__file_upload_progress_vue__["a" /* default */] },
  props: {
    buttonText: {
      default: 'Choose File'
    },
    token: {
      required: true
    },
    module: {
      required: true
    },
    moduleId: {
      default: ''
    },
    clearFile: {
      default: false
    }
  },
  directives: {
    uploader: {
      bind: function bind(el, binding, vnode) {
        el.addEventListener('change', function (e) {
          vnode.context.file = e.target.files[0];
        });
      }
    }
  },
  watch: {
    file: function file(_file) {
      var _this = this;

      localStorage.setItem('uploadFinish', false);

      var fileExtension = _file.name.substr(_file.name.lastIndexOf('.') + 1).toLowerCase();
      if (this.allowed_file_extensions.indexOf(fileExtension) === -1) {
        this.progress = 0;
        this.isUploadDisabled = false;
        this.$toastr('error', 'Fil ikke tilladt');
      } else if (_file.size > 27600000) {
        this.progress = 0;
        this.isUploadDisabled = false;
        this.$toastr('error', 'Filstørrelsesgrænsen overskredet');
      } else {
        this.progress = 10;
        this.salesPerson = localStorage.getItem('id_token_portal');
        var formData = new FormData();
        formData.append('operation', 'userInboxUpload');
        formData.append('file', _file);
        formData.append('salesPerson', this.salesPerson);
        formData.append('id', this.moduleId);

        this.$http.post('', formData, { emulateJSON: true,

          onUploadProgress: function (progressEvent) {
            this.progress = parseInt(Math.round(progressEvent.loaded * 100 / progressEvent.total));
          }.bind(this)
        }).then(function (response) {
          var res = response.body;
          if (res.login === false) {
            _this.$router.push('/login');
          }
          if (res.file) {
            _this.$toastr('success', 'Gennemført');
            localStorage.setItem('uploadFinish', true);
            localStorage.removeItem('uploadFinish');
            _this.uploadedFiles.push(res.file);
            _this.$emit('UpdateTilbudpdf', _this.uploadedFiles);
          }
          _this.progress = 100;
          _this.isUploadDisabled = false;
        }, function (response) {
          alert('error');
          _this.progress = 0;
          _this.isUploadDisabled = false;
        });
      }
    },
    clearFile: function clearFile(val) {
      this.uploadedFiles = [];
      this.$emit('UpdateTilbudpdf', this.uploadedFiles);
    },
    moduleId: function moduleId(val) {
      if (val) this.fetchUploads();
    }
  },
  mounted: function mounted() {
    if (this.moduleId) this.fetchUploads();
    this.allowed_file_extensions = ['pdf'];
  },

  computed: {
    authToken: function authToken() {
      return localStorage.getItem('auth_token');
    },
    isFileSelected: function isFileSelected() {
      return this.isUploadDisabled;
    }
  },
  methods: {
    launchFilePicker: function launchFilePicker() {
      this.isUploadDisabled = false;
      this.$refs.file.click();
    },
    reload: function reload() {
      var _this2 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'userExtention', salesPerson: localStorage.getItem('id_token_portal') };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.allowed_file_extensions = res;
      }, function (response) {
        alert('error');
      });
    },
    cancelUpload: function cancelUpload() {
      if (this.request) {
        this.request.abort();
      }
      this.isUploadDisabled = false;
    },
    arrayRemove: function arrayRemove(arr, value) {
      return arr.filter(function (ele) {
        return ele !== value;
      });
    },
    confirmDelete: function confirmDelete(uploadedFile) {
      var _this3 = this;

      return function (dialog) {
        return _this3.deleteUpload(uploadedFile);
      };
    },
    deleteUpload: function deleteUpload(uploadedFile) {
      this.uploadedFiles = this.arrayRemove(this.uploadedFiles, uploadedFile);
      this.$emit('UpdateTilbudpdf', this.uploadedFiles);
    },
    fetchUploads: function fetchUploads() {}
  },
  data: function data() {
    return {
      file: '',
      index: null,
      isUploadDisabled: false,
      progress: 0,
      uploadedFiles: [],
      allowed_file_extensions: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1900) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  }
});

/***/ }),
/* 1307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"input-group"},[_c('button',{staticClass:"col-12 primarycolor white-background p2 py4 flex line-height-1 justify-center items-center h5 not-rounded gibson",staticStyle:{"border":"3px dashed rgb(25, 163, 192)"},attrs:{"type":"button","disabled":_vm.isUploadDisabled},on:{"click":_vm.launchFilePicker}},[_c('span',{staticClass:"pr2 relative"},[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M406 195.1c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 167.7 0 222.1 0 289S54.4 410.3 121.3 410.3h84.7c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5 0-54.9 44.6-99.5 99.5-99.5 2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.2 4.9-0.4 7.5l-0.1 1.1c-0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.4 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-89.1c-6 0-10.9 4.9-10.9 10.9 0 6 4.9 10.9 10.9 10.9h89.1c59.3 0 107.6-48.3 107.6-107.6C512 243.9 464.6 196 406 195.1z"}}),_c('path',{attrs:{"d":"M262.8 105.2c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 0.5 0.1 1 0.1 1.5 0.1 5.4 0 10.1-4 10.8-9.4 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 110.1 268.8 105.2 262.8 105.2z"}}),_c('path',{attrs:{"d":"M312.4 320.1l-39.7-35.5c-6.8-6.1-17.2-6.1-24 0l-39.7 35.5c-4.5 4-4.9 10.9-0.9 15.4 4 4.5 10.9 4.9 15.4 0.9l26.3-23.5v134.3c0 6 4.9 10.9 10.9 10.9 6 0 10.9-4.9 10.9-10.9V312.9l26.3 23.5c2.1 1.9 4.7 2.8 7.3 2.8 3 0 6-1.2 8.1-3.6C317.3 331 316.9 324.1 312.4 320.1z"}})])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v("Vælg fil")])])]),_vm._v(" "),_c('input',{directives:[{name:"uploader",rawName:"v-uploader"}],ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file"}}),_vm._v(" "),_c('file-upload-progress',{attrs:{"progress":_vm.progress}}),_vm._v(" "),(_vm.uploadedFiles)?_c('ul',{staticClass:"upload-file-list my2 pl0"},_vm._l((_vm.uploadedFiles),function(uploaded_file){return _c('li',{key:uploaded_file.id,staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"h5 gibson regular darkblue line-height-1 mr3",staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(uploaded_file))]),_vm._v(" "),(_vm.index !== 0)?_c('button',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(uploaded_file)}),expression:"{ok: confirmDelete(uploaded_file)}"}],key:uploaded_file,staticClass:"not-rounded delete-button p1 border-none",attrs:{"tooltip":"Slet"}},[_vm._m(0,true)]):_vm._e()])}),0):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-delete"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"alloffer","clas":"mx4 my3 flex-column "}},[(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"h2 my3 bold col-12 "},[_vm._v("Standard Tilbud")]):(_vm.offermakingtype === 'UploadTilbud')?_c('div',{staticClass:"h2 my3 bold col-12 mx3 "},[_vm._v("Upload Tilbud")]):_c('div',{staticClass:"h2 my3 bold col-12 "},[_vm._v("HurtigtTilbud")]),_vm._v(" "),(_vm.mainloading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('b-form',[(_vm.error.notask !== null)?_c('p',{staticClass:"red warning h6 center"},[_vm._v(_vm._s(_vm.error.notask))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix white-background mx3"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('div',{staticClass:"col-12 p0"},[(_vm.currentstep === 1)?_c('div',[(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"mobile-flex-column flex flex-row col-12 sm-hide"},[_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.headertextimage",modifiers:{"headertextimage":true}}],ref:"button1",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button1"},on:{"click":function($event){return _vm.activebutton(1)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj overskrift")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.calculation",modifiers:{"calculation":true}}],ref:"button2",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button2"},on:{"click":function($event){return _vm.activebutton(2)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj enhed")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.rabat",modifiers:{"rabat":true}}],ref:"button3",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button3"},on:{"click":function($event){return _vm.activebutton(3)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj rabat")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.customer",modifiers:{"customer":true}}],ref:"button4",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button4","type":"button"},on:{"click":function($event){return _vm.activebutton(4)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj kunde")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.betingelser",modifiers:{"betingelser":true}}],ref:"button5",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button5","type":"button"},on:{"click":function($event){return _vm.activebutton(5)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj betingelser")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mrpointtwo mb1"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.Anbefalinger",modifiers:{"Anbefalinger":true}}],ref:"button6",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button6","type":"button"},on:{"click":function($event){return _vm.activebutton(6)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj anbefaling")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])])]):(_vm.offermakingtype === 'UploadTilbud')?_c('div',{staticClass:"flex flex-row col-12 p1 "},[_c('div',{staticClass:"col-6 p0 m0 mrpointtwo"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.calculation",modifiers:{"calculation":true}}],ref:"button2",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button2"},on:{"click":function($event){return _vm.activebutton(2)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj enhed")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 p0 mrpointtwo"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.customer",modifiers:{"customer":true}}],ref:"button4",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button4","type":"button"},on:{"click":function($event){return _vm.activebutton(4)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj kunde")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])])]):_c('div',{staticClass:"flex flex-row col-12 p0 "},[_c('div',{staticClass:"col-6 p0 "},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.calculation",modifiers:{"calculation":true}}],ref:"button2",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button2"},on:{"click":function($event){return _vm.activebutton(2)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj enhed")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6 p0 mrpointtwo"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.customer",modifiers:{"customer":true}}],ref:"button4",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button4","type":"button"},on:{"click":function($event){return _vm.activebutton(4)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj kunde")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])])]),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.headertextimage",modifiers:{"headertextimage":true}}],ref:"mbutton1",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button1"},on:{"click":function($event){return _vm.activebutton(1)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj overskrift")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button1collapse",staticClass:"col-12 pl2",attrs:{"id":"headertextimage"}},[_c('p',{staticClass:"h6 medium darkblue mt3"},[_vm._v("Overskriftstekst")]),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light col-12 py1 mt1",attrs:{"placeholder":"Din overskrift","required":""},on:{"input":function($event){return _vm.hidenamevalidator()}},model:{value:(_vm.form.headings),callback:function ($$v) {_vm.$set(_vm.form, "headings", $$v)},expression:"form.headings"}}),_vm._v(" "),(_vm.error.notask != '' && _vm.error.notask == 'Udfyld venligst din overskriftstekst for dit tilbud' )?_c('div',{staticClass:"red warning h6 col-12 px0"},[_vm._v("\n                        "+_vm._s(_vm.error.notask)+"\n                      ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"h6 medium darkblue mt3"},[_vm._v("Overskriftsbillede")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row col-12 flex-wrap"},_vm._l((_vm.alliheadermages),function(image){return _c('div',{key:image.ImageId,staticClass:"m1",on:{"click":function($event){return _vm.assignthisheaderimage(image.FileLocation)}}},[(image.FileLocation.includes('https://imagedelivery.net'))?_c('img',{staticClass:" headerimage ",attrs:{"id":image.FileLocation.replaceAll('håndværker', 'haandvaerker'),"src":image.FileLocation.replaceAll('/photos/', '')},on:{"load":function($event){_vm.checkifthisisheaderimageactive(image.FileLocation.replaceAll('håndværker', 'haandvaerker'))}}}):_c('img',{staticClass:" headerimage ",attrs:{"id":image.FileLocation.replaceAll('håndværker', 'haandvaerker'),"src":image.FileLocation.replaceAll('håndværker', 'haandvaerker')},on:{"load":function($event){_vm.checkifthisisheaderimageactive(image.FileLocation.replaceAll('håndværker', 'haandvaerker'))}}})])}),0)],1),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0  mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.calculation",modifiers:{"calculation":true}}],ref:"mbutton2",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button2"},on:{"click":function($event){return _vm.activebutton(2)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj enhed")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button2collapse",staticClass:"col-12 pl2",attrs:{"id":"calculation"}},[(_vm.offermakingtype === 'UploadTilbud')?_c('div',{staticClass:" flex flex-column"},[_c('div',[_c('div',{staticClass:"flex justify-start items-center"},[_c('span',[_vm._v("Pris")]),_c('b-form-input',{staticClass:"ml-auto pl1 col-1 bg-light pt1 my1",attrs:{"type":"number"},model:{value:(_vm.form.offeramount),callback:function ($$v) {_vm.$set(_vm.form, "offeramount", $$v)},expression:"form.offeramount"}}),_vm._v(" kr")],1),_vm._v(" "),_c('div',{staticClass:"my3 line-height-golden"},[_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Enhedspris ekskl. Moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(parseInt(_vm.form.offeramount * _vm.form.quantity).toLocaleString('da-DK'))+" kr")])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("25 % moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v("25 %")])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Enhedspris inkl. Moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(_vm.computetaskprice().toLocaleString('da-DK'))+" kr")])])]),_vm._v(" "),_c('div',{staticClass:"col-12"},[(_vm.offermakingtype === 'UploadTilbud')?_c('button',{staticClass:"mrpointtwo right col-2 dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.addtask()}}},[_c('span',{},[_vm._v("Tilføj enhed")])]):_vm._e()]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h4 mt3 center col col-12"},[_vm._v("Upload dit tilbud her "),_c('h6',[_vm._v("kun en pdf-fil accepteres her")])]),_vm._v(" "),_c('b-form-group',{staticClass:"p0 form-group  form-group lg-col-12 md-col-12    ",attrs:{"id":"file","label":"","label-for":"fag"}},[_c('file-upload-input-pdfonly',{staticClass:"education-upload",attrs:{"token":"","module":""},on:{"UpdateTilbudpdf":_vm.handleFileUploadpdf}})],1)],1)])]):_c('div',[(_vm.offermakingtype !== 'StandardTilbud')?_c('div',{staticClass:"col-12 m0 p0"},[_c('p',{staticClass:"h6 medium darkblue mt3 "},[_vm._v("Overskriftstekst")]),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light col-12 py1 mt1",attrs:{"placeholder":"Din overskrift","required":""},model:{value:(_vm.form.headings),callback:function ($$v) {_vm.$set(_vm.form, "headings", $$v)},expression:"form.headings"}}),_vm._v(" "),_c('p',{staticClass:"h6 medium darkblue mt3"},[_vm._v("Overskriftsbillede")])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 pr0 pl0 "},[_c('b-form-textarea',{staticClass:"bg-light pt1 my2",attrs:{"rows":"3","max-rows":"3","placeholder":"Skriv tilbuddets indhold her.."},model:{value:(_vm.form.offerdescription),callback:function ($$v) {_vm.$set(_vm.form, "offerdescription", $$v)},expression:"form.offerdescription"}})],1),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1 my1",attrs:{"type":"number","placeholder":"Pris","lang":"dk"},model:{value:(_vm.form.offeramount),callback:function ($$v) {_vm.$set(_vm.form, "offeramount", $$v)},expression:"form.offeramount"}}),_vm._v(" "),_c('div',{staticClass:"flex col-12 p0 m0"},[_c('b-form-input',{staticClass:"bg-light pt1 my1 mr2 ",attrs:{"placeholder":"Antal"},model:{value:(_vm.form.quantity),callback:function ($$v) {_vm.$set(_vm.form, "quantity", $$v)},expression:"form.quantity"}}),_vm._v(" "),_c('b-form-select',{staticClass:"bg-light pt1 my1",attrs:{"options":_vm.optionsunitype},model:{value:(_vm.form.quantityunit),callback:function ($$v) {_vm.$set(_vm.form, "quantityunit", $$v)},expression:"form.quantityunit"}})],1),_vm._v(" "),(_vm.error.notask != '' && _vm.error.notask == 'Tilføj din opgave med den tilsvarende pris' )?_c('div',{staticClass:"red warning h6 col-12 px0"},[_vm._v("\n                            "+_vm._s(_vm.error.notask)+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('button',{staticClass:" ml-auto m0  addbuttonresponsive  dark-button p2 h5 my3 not-rounded gibson flex justify-center items-center",attrs:{"type":"button","id":"enhed"},on:{"click":function($event){return _vm.addtask()}}},[_c('span',{},[_vm._v("Tilføj enhed")])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Enhedspris ekskl. Moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(parseInt(_vm.form.offeramount * _vm.form.quantity).toLocaleString('da-DK'))+" kr")])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("25 % moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v("25 %")])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Enhedspris inkl. Moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(_vm.computetaskprice().toLocaleString('da-DK'))+" kr")])])])],1),_vm._v(" "),(_vm.offermakingtype !== 'StandardTilbud' )?_c('div',{staticClass:"flex col-12 p0 m0 "},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.conditionsstandard",modifiers:{"conditionsstandard":true}}],staticClass:" col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"type":"button"}},[_c('svg',{staticClass:"mr1",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"30","height":"30","viewBox":"1.5 0.5 524 618","enable-background":"new 1.5 0.5 524 618","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#fff","d":"M485.328,3H150.641c-19.774,0-35.859,16.085-35.859,35.859v31.078H40.672\n                                              c-19.774,0-35.859,16.085-35.859,35.859v404.721c0.009,0.01,0.019,0.019,0.028,0.023c0.005,3.101,1.191,6.149,3.474,8.428\n                                              l92.524,92.529c2.288,2.288,5.346,3.502,8.456,3.502h0.014h266.05c19.774,0,35.859-16.085,35.859-35.859v-31.078h74.109\n                                              c19.774,0,35.859-16.085,35.859-35.859V362.789c0-6.603-5.351-11.953-11.953-11.953s-11.953,5.351-11.953,11.953v149.414\n                                              c0,6.593-5.36,11.953-11.953,11.953h-74.109v-69.165h35.309c6.602,0,11.953-5.355,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953\n                                              h-35.309v-43.021h35.309c6.602,0,11.953-5.351,11.953-11.953s-5.352-11.953-11.953-11.953h-35.309v-43.055h35.309\n                                              c6.602,0,11.953-5.351,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953h-35.309v-43.017h35.309\n                                              c6.602,0,11.953-5.356,11.953-11.953c0-6.603-5.352-11.953-11.953-11.953h-35.309v-43.06h35.309c6.602,0,11.953-5.351,11.953-11.953\n                                              c0-6.597-5.352-11.953-11.953-11.953h-35.309v-57.51c0-4.193-0.729-8.213-2.055-11.953h88.117v161.367\n                                              c0,6.602,5.351,11.953,11.953,11.953s11.953-5.351,11.953-11.953V38.859C521.188,19.085,505.103,3,485.328,3z M97.342,574.191\n                                              l-51.721-51.721h34.907c9.268,0,16.813,7.545,16.813,16.813V574.191z M387.313,579.141c0,6.593-5.36,11.953-11.953,11.953H121.248\n                                              v-51.81c0-22.454-18.266-40.72-40.72-40.72h-51.81V160.781h358.594v14.47v0.014v0.009v66.938v0.014v0.009v66.904v0.015v0.009v66.938\n                                              v0.015v0.009V579.141z M387.313,105.797v31.078H28.719v-31.078c0-6.593,5.36-11.953,11.953-11.953h334.688\n                                              C381.952,93.844,387.313,99.204,387.313,105.797z M375.359,69.938H138.688V38.859c0-6.593,5.36-11.953,11.953-11.953h334.688\n                                              c6.593,0,11.953,5.36,11.953,11.953v31.078H375.359z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,430.945H78.432c-6.602,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h258.188\n                                              c6.603,0,11.953-5.351,11.953-11.953S343.222,430.945,336.619,430.945z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,497.873H216.383c-6.602,0-11.953,5.352-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h120.236\n                                              c6.603,0,11.953-5.355,11.953-11.953C348.572,503.225,343.222,497.873,336.619,497.873z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M78.432,387.891h182.934c6.602,0,11.953-5.351,11.953-11.953s-5.351-11.953-11.953-11.953H78.432\n                                              c-6.602,0-11.953,5.351-11.953,11.953S71.83,387.891,78.432,387.891z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,297.061H78.432c-6.602,0-11.953,5.351-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h258.188\n                                              c6.603,0,11.953-5.355,11.953-11.953C348.572,302.412,343.222,297.061,336.619,297.061z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M78.432,254.001h90.27c6.602,0,11.953-5.351,11.953-11.953c0-6.597-5.351-11.953-11.953-11.953h-90.27\n                                              c-6.602,0-11.953,5.356-11.953,11.953C66.479,248.651,71.83,254.001,78.432,254.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,230.095H230.437c-6.602,0-11.953,5.356-11.953,11.953c0,6.603,5.351,11.953,11.953,11.953h106.182\n                                              c6.603,0,11.953-5.351,11.953-11.953C348.572,235.451,343.222,230.095,336.619,230.095z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,363.984h-19.592c-6.603,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h19.592\n                                              c6.603,0,11.953-5.351,11.953-11.953S343.222,363.984,336.619,363.984z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M509.234,297.047c-3.143,0-6.229,1.279-8.451,3.502s-3.502,5.309-3.502,8.451s1.279,6.229,3.502,8.451\n                                              s5.309,3.502,8.451,3.502s6.229-1.279,8.451-3.502s3.502-5.309,3.502-8.451s-1.279-6.229-3.502-8.451\n                                              S512.377,297.047,509.234,297.047z"}})]),_vm._v("\n                      Tilføj betingelser"),_c('i',{staticClass:"el-icon-search pl2 m0 h5"})]),_vm._v(" "),(_vm.offermakingtype === 'HurtigtTilbud' )?_c('button',{staticClass:"mrpointtwo  col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"id":"enhed","type":"button"},on:{"click":function($event){return _vm.addtask()}}},[_c('span',{},[_vm._v("Tilføj enhed")])]):_vm._e(),_vm._v(" "),(_vm.offermakingtype === 'UploadTilbud')?_c('button',{staticClass:"mrpointtwo  col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){_vm.nextstebutton(), _vm.assigndatecomment()}}},[_c('span',{staticClass:"mx2 "},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.rows.length > 0)?_c('div',{staticClass:"col-12 m0 p1 flex flex-column more-muted-background my2  "},[_c('p',{staticClass:"h6   m0"},[_vm._v("Opgave")]),_vm._v(" "),_vm._l((_vm.rows),function(datarow,index){return _c('div',{key:index,staticClass:"flex flex-column mb1",staticStyle:{"border-bottom":"inset"}},[(_vm.typeofclients === 'Minbolig2')?_c('div',{staticClass:"flex col-12 h5 m0 p0 py1 line-height-golden"},[_c('p',{staticClass:"m0 semi-bold p0 "},[_vm._v(_vm._s(datarow.custom_name))]),_vm._v(" "),_c('i',{staticClass:"m0 red p0 ml-auto el-icon-delete-solid",on:{"click":function($event){return _vm.deletetaskminbolig(datarow)}}})]):_c('div',{staticClass:"flex col-12 h5 m0 p0 py1 line-height-golden"},[_c('p',{staticClass:"m0 semi-bold p0 "},[_vm._v(_vm._s(datarow.custom_name))]),_vm._v(" "),_c('i',{staticClass:"m0 red p0 ml-auto el-icon-delete-solid",on:{"click":function($event){return _vm.deletetask(datarow)}}})]),_vm._v(" "),_c('div',{staticClass:"h6 flex m0 p0 col-12 line-height-golden"},[_c('p',{staticClass:"m0 p0 "},[_vm._v("Pris")]),_c('p',{staticClass:"m0 semi-bold p0 ml-auto"},[_vm._v(_vm._s((parseFloat(datarow.amount)).toLocaleString('da-DK'))+" kr")])]),_vm._v(" "),(datarow.type === 0)?_c('div',{staticClass:"h6 flex m0 p0 col-12 line-height-golden"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Antal")]),_c('p',{staticClass:"m0 semi-bold p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(datarow.quantity)))+" Antal")])]):_vm._e(),_vm._v(" "),(datarow.type === 1)?_c('div',{staticClass:"h6 flex m0 p0 col-12 line-height-golden"},[_c('p',{staticClass:"m0 p0 co l-4"},[_vm._v("Beløb")]),_c('p',{staticClass:"m0 semi-bold p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(datarow.quantity)))+" kr")])]):_vm._e(),_vm._v(" "),(datarow.type === 2)?_c('div',{staticClass:"h6 flex m0 p0 col-12 line-height-golden"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Timer")]),_c('p',{staticClass:"m0 semi-bold p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(datarow.quantity)))+" Hr.")])]):_vm._e()])})],2):_vm._e(),_vm._v(" "),(_vm.rows.length > 0)?_c('div',{staticClass:"more-muted-background col-12 p1 my2 py2"},[_c('div',{staticClass:"h5 flex m0 line-height-golden"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Subtotal")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(_vm.subtotalprice)).toLocaleString('da-DK'))+" kr ")])]),_vm._v(" "),_c('div',{staticClass:"h5 flex m0 line-height-golden"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("MOMS")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v("25 %")])]),_vm._v(" "),(_vm.form.discount !== '')?_c('div',{staticClass:"h5 flex m0 line-height-golden"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Rabat")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(_vm.form.discount + ' ' + _vm.form.discountsymbol))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"h5 flex m0 line-height-golden "},[_c('p',{staticClass:"m0 p0 col-4 sime-bold"},[_vm._v("I ALT")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(_vm.compututedtaxsingle)).toLocaleString('da-DK'))+" kr ")])])]):_vm._e()]),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p1 mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.rabat",modifiers:{"rabat":true}}],ref:"mbutton3",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"type":"button","id":"button3"},on:{"click":function($event){return _vm.activebutton(3)}}},[_c('span',{staticClass:"h6 m0 py2"},[_vm._v("Tilføj rabat")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button3collapse",staticClass:"col-12 pl2 p0 my3",attrs:{"id":"rabat"}},[_c('div',{staticClass:"flex col-12 p0 m0 justify-end ml-auto"},[_c('button',{staticClass:" m0 addbuttonresponsive dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.addiscount()}}},[_c('span',{},[_vm._v("Tilføj rabat")])])]),_vm._v(" "),_c('p',{staticClass:"h6 mt1"},[_vm._v("Rabat i kr")]),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1 my1",attrs:{"type":"number","id":"discountamount"},on:{"change":function($event){return _vm.disabletheother()}},model:{value:(_vm.form.discountamount),callback:function ($$v) {_vm.$set(_vm.form, "discountamount", $$v)},expression:"form.discountamount"}}),_vm._v(" "),_c('p',{staticClass:"h6 mt1"},[_vm._v("Rabat i procent")]),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1 my1",attrs:{"type":"number","id":"discountpercentage"},on:{"change":function($event){return _vm.disabletheother()}},model:{value:(_vm.form.discountpercentage),callback:function ($$v) {_vm.$set(_vm.form, "discountpercentage", $$v)},expression:"form.discountpercentage"}})],1),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.customer",modifiers:{"customer":true}}],ref:"mbutton4",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button4","type":"button"},on:{"click":function($event){return _vm.activebutton(4)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj kunde")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button4collapse",staticClass:"col-12 pl2 p0",attrs:{"id":"customer"}},[_c('div',{staticClass:"flex flex-row justify-around col-12 mt2 mb3 mx0 p0"},[_c('button',{staticClass:"  lightblue-button col-6 pt1 pb1 pl1  ",attrs:{"type":"button","id":"startthis"},on:{"click":function($event){return _vm.showcustomerselection()}}},[_vm._v("Kunde"),_c('i',{staticClass:"el-icon-user-solid pl3 h4"})]),_vm._v(" "),_c('button',{staticClass:"    offer-form-white-button col-6 pt1 pb1 mrpointtwo",attrs:{"type":"button","disabled":_vm.customerInputDisabled},on:{"click":function($event){_vm.hidecustomerselection(),_vm.resetcustomerdata()}}},[_vm._v("Ny Kontakt"),_c('i',{staticClass:"el-icon-user pl3 h4"})])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',[_c('div',{staticClass:"flex col-12 items-center m0 p0"},[_c('p',{staticClass:"h6",attrs:{"id":"customerstext"}},[_vm._v("Vælg en kunde")]),_vm._v(" "),_c('p',{staticClass:"h6 hide",attrs:{"id":"newcustomersss"}},[_vm._v("Indtast ny kunde")]),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud' || _vm.offermakingtype === 'UploadTilbud')?_c('button',{staticClass:" hide ml-auto m0 addbuttonresponsive dark-button p2 h4 not-rounded gibson flex justify-center items-center",attrs:{"type":"button","id":"newcustomers"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{},[_vm._v("Tilføj ny Kunde")])]):_vm._e()]),_vm._v(" "),_c('b-form-select',{staticClass:"  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1",staticStyle:{"height":"48px"},attrs:{"id":"customersselect","placeholder":"Ingenting valgt","disabled":_vm.customerInputDisabledselect},on:{"change":function($event){return _vm.assigncustomerinput(_vm.customers)}},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('b-form-select-option',{attrs:{"value":null,"disabled":""}},[_vm._v("Ingenting valgt")])]},proxy:true}],null,false,3470777039),model:{value:(_vm.customers),callback:function ($$v) {_vm.customers=$$v},expression:"customers"}},[_vm._v(" "),_vm._l((_vm.items),function(item,index){return _c('b-form-select-option',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item.firstname + ' ' + item.lastname + ', ' + item.email + '-' + item.mobile))])})],2),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1  mb2 mt2",attrs:{"placeholder":"Navn","required":"","disabled":_vm.customerInputDisabled},model:{value:(_vm.form.navm),callback:function ($$v) {_vm.$set(_vm.form, "navm", $$v)},expression:"form.navm"}}),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1  mb2 mt2",attrs:{"placeholder":"Email","required":"","disabled":_vm.customerInputDisabled},model:{value:(_vm.form.email),callback:function ($$v) {_vm.$set(_vm.form, "email", $$v)},expression:"form.email"}}),_vm._v(" "),_c('b-form-input',{staticClass:"bg-light pt1  mb2 mt2",attrs:{"placeholder":"Mobil","required":"","disabled":_vm.customerInputDisabled},model:{value:(_vm.form.mobile),callback:function ($$v) {_vm.$set(_vm.form, "mobile", $$v)},expression:"form.mobile"}}),_vm._v(" "),_c('form',[_c('b-form-input',{ref:"selectaddr",staticClass:"  col-12  darkblue   not-rounded gibson pt1  mb2 mt2",attrs:{"id":"selectaddr","list":"addresslist","placeholder":"Skriv adresse","autocomplete":"off","disabled":_vm.customerInputDisabled},on:{"keyup":function($event){_vm.getaddressfromkeyword(_vm.seletectedaddress), _vm.assignaddresseinput(_vm.seletectedaddress)}},model:{value:(_vm.seletectedaddress),callback:function ($$v) {_vm.seletectedaddress=$$v},expression:"seletectedaddress"}}),_vm._v(" "),_c('b-form-datalist',{attrs:{"id":"addresslist","options":_vm.searchgaddress}})],1),_vm._v(" "),(_vm.addressloading)?_c('div',{staticClass:"flex flex-row justify-center items-center",staticStyle:{"height":"80px"}},[_c('i',{staticClass:"el-icon-loading"})]):_vm._e(),_vm._v(" "),(_vm.error.notask != '' && _vm.error.notask == 'Udfyld venligst dine kunders oplysninger' )?_c('div',{staticClass:" red warning h6 col-12 px0"},[_vm._v("\n                            "+_vm._s(_vm.error.notask)+"\n                          ")]):_vm._e(),_vm._v(" "),(_vm.offermakingtype !== 'StandardTilbud' && _vm.offermakingtype !== 'UploadTilbud')?_c('div',{staticClass:"flex col-12 p0 m0 my3 gap2"},[_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.conditionsstandard",modifiers:{"conditionsstandard":true}}],staticClass:"mr-auto m0 col-6 dark-button p2 h5 not-rounded gibson flex justify-center items-center",attrs:{"type":"button"}},[_c('svg',{staticClass:"mr1",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"30","height":"30","viewBox":"1.5 0.5 524 618","enable-background":"new 1.5 0.5 524 618","xml:space":"preserve"}},[_c('path',{attrs:{"fill":"#fff","d":"M485.328,3H150.641c-19.774,0-35.859,16.085-35.859,35.859v31.078H40.672\n                                                c-19.774,0-35.859,16.085-35.859,35.859v404.721c0.009,0.01,0.019,0.019,0.028,0.023c0.005,3.101,1.191,6.149,3.474,8.428\n                                                l92.524,92.529c2.288,2.288,5.346,3.502,8.456,3.502h0.014h266.05c19.774,0,35.859-16.085,35.859-35.859v-31.078h74.109\n                                                c19.774,0,35.859-16.085,35.859-35.859V362.789c0-6.603-5.351-11.953-11.953-11.953s-11.953,5.351-11.953,11.953v149.414\n                                                c0,6.593-5.36,11.953-11.953,11.953h-74.109v-69.165h35.309c6.602,0,11.953-5.355,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953\n                                                h-35.309v-43.021h35.309c6.602,0,11.953-5.351,11.953-11.953s-5.352-11.953-11.953-11.953h-35.309v-43.055h35.309\n                                                c6.602,0,11.953-5.351,11.953-11.953c0-6.602-5.352-11.953-11.953-11.953h-35.309v-43.017h35.309\n                                                c6.602,0,11.953-5.356,11.953-11.953c0-6.603-5.352-11.953-11.953-11.953h-35.309v-43.06h35.309c6.602,0,11.953-5.351,11.953-11.953\n                                                c0-6.597-5.352-11.953-11.953-11.953h-35.309v-57.51c0-4.193-0.729-8.213-2.055-11.953h88.117v161.367\n                                                c0,6.602,5.351,11.953,11.953,11.953s11.953-5.351,11.953-11.953V38.859C521.188,19.085,505.103,3,485.328,3z M97.342,574.191\n                                                l-51.721-51.721h34.907c9.268,0,16.813,7.545,16.813,16.813V574.191z M387.313,579.141c0,6.593-5.36,11.953-11.953,11.953H121.248\n                                                v-51.81c0-22.454-18.266-40.72-40.72-40.72h-51.81V160.781h358.594v14.47v0.014v0.009v66.938v0.014v0.009v66.904v0.015v0.009v66.938\n                                                v0.015v0.009V579.141z M387.313,105.797v31.078H28.719v-31.078c0-6.593,5.36-11.953,11.953-11.953h334.688\n                                                C381.952,93.844,387.313,99.204,387.313,105.797z M375.359,69.938H138.688V38.859c0-6.593,5.36-11.953,11.953-11.953h334.688\n                                                c6.593,0,11.953,5.36,11.953,11.953v31.078H375.359z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,430.945H78.432c-6.602,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h258.188\n                                                c6.603,0,11.953-5.351,11.953-11.953S343.222,430.945,336.619,430.945z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,497.873H216.383c-6.602,0-11.953,5.352-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h120.236\n                                                c6.603,0,11.953-5.355,11.953-11.953C348.572,503.225,343.222,497.873,336.619,497.873z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M78.432,387.891h182.934c6.602,0,11.953-5.351,11.953-11.953s-5.351-11.953-11.953-11.953H78.432\n                                                c-6.602,0-11.953,5.351-11.953,11.953S71.83,387.891,78.432,387.891z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,297.061H78.432c-6.602,0-11.953,5.351-11.953,11.953c0,6.598,5.351,11.953,11.953,11.953h258.188\n                                                c6.603,0,11.953-5.355,11.953-11.953C348.572,302.412,343.222,297.061,336.619,297.061z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M78.432,254.001h90.27c6.602,0,11.953-5.351,11.953-11.953c0-6.597-5.351-11.953-11.953-11.953h-90.27\n                                                c-6.602,0-11.953,5.356-11.953,11.953C66.479,248.651,71.83,254.001,78.432,254.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,230.095H230.437c-6.602,0-11.953,5.356-11.953,11.953c0,6.603,5.351,11.953,11.953,11.953h106.182\n                                                c6.603,0,11.953-5.351,11.953-11.953C348.572,235.451,343.222,230.095,336.619,230.095z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M336.619,363.984h-19.592c-6.603,0-11.953,5.351-11.953,11.953s5.351,11.953,11.953,11.953h19.592\n                                                c6.603,0,11.953-5.351,11.953-11.953S343.222,363.984,336.619,363.984z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#0590B9","d":"M509.234,297.047c-3.143,0-6.229,1.279-8.451,3.502s-3.502,5.309-3.502,8.451s1.279,6.229,3.502,8.451\n                                                s5.309,3.502,8.451,3.502s6.229-1.279,8.451-3.502s3.502-5.309,3.502-8.451s-1.279-6.229-3.502-8.451\n                                                S512.377,297.047,509.234,297.047z"}})]),_vm._v("\n                                Tilføj betingelser"),_c('i',{staticClass:"el-icon-search pl2 m0 h5"})]),_vm._v(" "),_c('button',{staticClass:" hide ml-auto m0 col-6 dark-button p2 h4 not-rounded gibson flex justify-center items-center",attrs:{"type":"button","id":"newcustomers"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{},[_vm._v("Tilføj ny Kunde")])])]):_vm._e(),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"flex items-center mobile-flex-column p0 col-12 justify-end"},[_c('p',{staticClass:"m0 h6 p0 flex mr-auto"},[_vm._v("Tilbuddet er gyldigt fra")]),_c('datepicker',{staticClass:"ml-auto my1 sm-col-12 lg-cl-10 md-col-10",attrs:{"id":"datepickeroffer","bootstrapStyling":false,"placeholder":"Dato","language":_vm.da},model:{value:(_vm.form.dateoffer),callback:function ($$v) {_vm.$set(_vm.form, "dateoffer", $$v)},expression:"form.dateoffer"}}),_c('i',{staticClass:"ml-auto el-icon-date h5"})],1):_vm._e(),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"flex items-center mobile-flex-column p0 col-12 justify-end"},[_c('p',{staticClass:"m0 h6 p0 flex mr-auto"},[_vm._v("Tilbuddet er gyldigt til")]),_c('datepicker',{staticClass:"ml-auto my1 sm-col-12 lg-cl-10 md-col-10",attrs:{"id":"datepickeroffer2","bootstrapStyling":false,"placeholder":"Dato udløber","language":_vm.da},model:{value:(_vm.form.dateofferexpiry),callback:function ($$v) {_vm.$set(_vm.form, "dateofferexpiry", $$v)},expression:"form.dateofferexpiry"}}),_c('i',{staticClass:"ml-auto el-icon-date h5"})],1):_vm._e(),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('b-form-input',{staticClass:"bg-light pt1 my1",attrs:{"placeholder":"Kommentar"},model:{value:(_vm.form.comment),callback:function ($$v) {_vm.$set(_vm.form, "comment", $$v)},expression:"form.comment"}}):_vm._e()],1)]),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.betingelser",modifiers:{"betingelser":true}}],ref:"mbutton5",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button5","type":"button"},on:{"click":function($event){return _vm.activebutton(5)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj betingelser")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button5collapse",staticClass:"col-12 p0 pl2 mt2",attrs:{"id":"betingelser"}},[(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"col-12 p0"},[_c('p',{staticClass:"h4 mt1 mb2 semi-bold"},[_vm._v("Betingelser og forbehold i tilbuddet")]),_vm._v(" "),_c('div',{staticClass:"white-background no-border col-12 p0 flex flex-row items-center ",staticStyle:{"height":"30px"}},[_c('p',{staticClass:"semi-bold col-7 flex justify-start p0 m0"},[_vm._v("Brugerdefinerede Noter")]),_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.addbrugerdefineredestandard",modifiers:{"addbrugerdefineredestandard":true}}],staticClass:"col-5 flex justify-end el-icon-circle-plus-outline p0"})]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Vælg her")]),_vm._v(" "),_c('b-form-select',{staticClass:"  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1",staticStyle:{"height":"48px"},attrs:{"placeholder":"Ingenting valgt"},on:{"change":function($event){return _vm.assigntermsinput('note' , _vm.termsnotats)}},model:{value:(_vm.termsnotats),callback:function ($$v) {_vm.termsnotats=$$v},expression:"termsnotats"}},_vm._l((_vm.termsnotes),function(item,index){return _c('b-form-select-option',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item.title + '-' + item.description))])}),1),_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"rows":"4","max-rows":"4","placeholder":"Tilføj dine brugerdefinerede noter her"},model:{value:(_vm.form.termsnote),callback:function ($$v) {_vm.$set(_vm.form, "termsnote", $$v)},expression:"form.termsnote"}}),_vm._v(" "),_c('div',{staticClass:"white-background no-border col-12 p0 flex flex-row items-center mt2 ",staticStyle:{"height":"30px"}},[_c('p',{staticClass:"semi-bold col-7 flex justify-start p0 m0"},[_vm._v("Betingelser og standardforbehold")]),_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.addbetingelserstandard",modifiers:{"addbetingelserstandard":true}}],staticClass:"col-5 flex justify-end el-icon-circle-plus-outline p0"})]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Vælg her")]),_vm._v(" "),_c('b-form-select',{staticClass:"  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1",staticStyle:{"height":"48px"},attrs:{"placeholder":"Ingenting valgt"},on:{"change":function($event){return _vm.assigntermsinput('betingelser' , _vm.termsbetings)}},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('b-form-select-option',{attrs:{"value":null,"disabled":""}},[_vm._v("Ingenting valgt")])]},proxy:true}],null,false,3470777039),model:{value:(_vm.termsbetings),callback:function ($$v) {_vm.termsbetings=$$v},expression:"termsbetings"}},[_vm._v(" "),_vm._l((_vm.termsbetingelser),function(item,index){return _c('b-form-select-option',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item.title + '-' + item.description))])})],2),_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"rows":"4","max-rows":"4","placeholder":"Tilføj dine brugerdefinerede noter her"},model:{value:(_vm.form.termsbetingelser),callback:function ($$v) {_vm.$set(_vm.form, "termsbetingelser", $$v)},expression:"form.termsbetingelser"}}),_vm._v(" "),_c('p',{staticClass:"mt2 semi-bold"},[_vm._v("Bilag")])],1),_vm._v(" "),_c('b-form-group',{staticClass:"p0 form-group  form-group lg-col-12 md-col-12    ",attrs:{"id":"file","label":"","label-for":"fag"}},[_c('file-upload-input',{staticClass:"education-upload",attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}})],1)],1),_vm._v(" "),(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"sm-col-12 lg-col-2 md-col-2 p0 mb1 lg-hide md-hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.Anbefalinger",modifiers:{"Anbefalinger":true}}],ref:"mbutton6",staticClass:" buttonstep dark-button col-12 gibson  not-rounded flex justify-center items-center",attrs:{"id":"button6","type":"button"},on:{"click":function($event){return _vm.activebutton(6)}}},[_c('span',{staticClass:"h6 m0 p0 py2"},[_vm._v("Tilføj anbefaling")]),_vm._v(" "),_c('span',{staticClass:" m0 p0 flex items-center",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]):_vm._e(),_vm._v(" "),_c('b-collapse',{ref:"button6collapse",staticClass:"col-12 p0 pl2 mt2",attrs:{"id":"Anbefalinger"}},[_c('p',{staticClass:"h5 medium darkblue mt3 mb2"},[_vm._v("Anbefalinger")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"flex col-12 p0 m0"},[_c('div',{},[_c('p',{staticClass:"h6 "},[_vm._v("Forøg din chance for at vinde buddet. Anbefalinger øger din troværdighed og skaber sikkerhed for nye kunder.")]),_vm._v(" "),_c('p',{staticClass:"h6 "},[_vm._v(" Vedhæft op til 5 anbefalinger fra din profil")])]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[(_vm.button >= 6 && this.editingdraft === 0)?_c('button',{staticClass:" h5 p2  gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('finaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e(),_vm._v(" "),(_vm.button >= 6 && this.editingdraft === 1)?_c('button',{staticClass:"h5 p2  gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('draftfinaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e()])]),_vm._v(" "),_c('p',{staticClass:"col-12 h5 semi-bold line-height-golden my3"},[_vm._v("Udvalgte anbefalinger "+_vm._s(_vm.fiverecommendations.length)+" / 5 ")]),_vm._v(" "),_c('div',{staticClass:"col-12 mx0 px0 flex flex-wrap justify-around "},_vm._l((_vm.allrecommendatationsitems),function(review){return _c('div',{key:review.id,staticClass:" mx2 reviewsoffer  mb2   shadow p2",attrs:{"id":'box' + review.ReviewId}},[_c('div',{staticClass:"flex justify-between items-center"},[_c('div',[_c('div',{staticClass:"flex flex-column mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":22,"spacing":1,"show-rating":false,"read-only":true},model:{value:(review.Rating),callback:function ($$v) {_vm.$set(review, "Rating", $$v)},expression:"review.Rating"}})],1),_vm._v(" "),_c('div',[(review.AssignmentDistributedCount === 1)?_c('span',{staticClass:"green"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])]):_c('span',{staticClass:"mediumgrey"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"h6 darkblue mb0 relative"},[_vm._v(_vm._s(_vm.moment(review.RatedDate).format('ll'))+_vm._s(_vm.checkthebox(review.ReviewId)))])]),_vm._v(" "),_c('div',{},[_c('el-collapse',{staticClass:"border-none"},[_c('el-collapse-item',{attrs:{"title":"Kommentar","name":review.id}},[_c('p',{staticClass:"h6 gibson mediumgrey break-word"},[_vm._v(_vm._s(review.RatingComment))])])],1)],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue semi-bold my2 line-height-golden"},[_vm._v(_vm._s(review.RatedBy))])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"clearfix flex flex-column"}),_vm._v(" "),_c('div',{staticClass:"flex flex-row col-12"},[(_vm.checkifselected(review.ReviewId))?_c('button',{staticClass:"ml-auto p2 px2 gibson dark-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.removethisrecommendation(review.ReviewId)}}},[_c('i',{staticClass:"el-icon-minus"}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 left-align pl1"},[_vm._v("Fjern dette")])]):_vm._e(),_vm._v(" "),(!_vm.checkifselected(review.ReviewId) && _vm.fiverecommendations.length <= 4)?_c('button',{staticClass:"p2 px2 gibson dark-button not-rounded flex justify-center items-center",attrs:{"type":"button","id":"addthisreview"},on:{"click":function($event){return _vm.assignfiverecommendations(review.ReviewId)}}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 left-align pl1"},[_vm._v("Tilføj dette")])]):_vm._e()])])])}),0)])],1):_vm._e(),_vm._v(" "),(_vm.currentstep === 2)?_c('div'):_vm._e(),_vm._v(" "),(_vm.currentstep === 3)?_c('div',{staticClass:"flex flex-column items-center justify-center mt2 mb2"},[(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_vm._e(),_vm._v(" "),_c('div',[_c('img',{attrs:{"src":"static/img/customernoteicon.png","width":"170","height":"170"}}),_vm._v(" "),_c('p',{staticClass:"h6 medium darkblue mt3 mb3"},[_vm._v("Gennemgå dit tilbud ved at klikke på preview-knappen")]),_vm._v(" "),_c('button',{staticClass:"dark-button p2 col-10 mb1 ",attrs:{"id":"preview","type":"button"},on:{"click":function($event){return _vm.previewoffer()}}},[_c('p',{staticClass:"h3"},[_vm._v("Forhåndsvisning")])])])]):_vm._e()])])]),_vm._v(" "),(_vm.previewloading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',[(_vm.offermakingtype === 'StandardTilbud')?_c('div',{staticClass:"col-12 p0 pr3"},[_c('div',{staticClass:" flex p0  my4 col-12 justify-between items-center white-background pt1"},[(_vm.button > 4)?_c('div',{staticClass:"  ml3 flex justify-around border-1 mobile-flex-column ",staticStyle:{"width":"max(60%, 40rem,400px)"},attrs:{"id":"specialrow"}},[_c('a',{staticClass:"col col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background",on:{"click":function($event){return _vm.previewoffer()}}},[_c('i',{staticClass:"el-icon-copy-document m0 h3"}),_c('p',{staticClass:"h6 darkblue"},[_vm._v("Forhåndsvisning")]),(_vm.pdfpdf !== null)?_c('a',{staticClass:"h6",staticStyle:{"font-size":".5em"},attrs:{"href":_vm.pdfpdf}},[_vm._v("download here")]):_vm._e()]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.draftsstandard",modifiers:{"draftsstandard":true}}],staticClass:"col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background"},[_c('i',{staticClass:"el-icon-notebook-2 m0 h3"}),_c('p',{staticClass:"h6 nav-link m0 p0"},[_vm._v("Udkast")])]),_vm._v(" "),(_vm.editingdraft === 1)?_c('a',{staticClass:"col col-4 p1 m0 flex flex-column justify-center items-center more-muted-background mr1",on:{"click":function($event){return _vm.updatetilbud()}}},[_c('i',{staticClass:"el-icon-document-checked m0 h3"}),_c('p',{staticClass:"h6 darkblue m0"},[_vm._v("Opdater kladde")])]):_c('a',{staticClass:"md-col-4 lg-col-4 sm-col-6 p1 m0 flex flex-column justify-center items-center more-muted-background mr1",on:{"click":function($event){return _vm.saveasdraft()}}},[_c('i',{staticClass:"el-icon-document-checked m0 h3"}),_c('p',{staticClass:"h6 darkblue m0"},[_vm._v("Gem som kladde")])])]):_vm._e(),_vm._v(" "),(_vm.button <= 5 )?_c('button',{staticClass:" ml-auto mx1 right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){_vm.nextstebutton(), _vm.assigndatecomment()}}},[_c('span',{staticClass:"mx2 "},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.button >= 6 && this.editingdraft === 0)?_c('button',{staticClass:"right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('finaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e(),_vm._v(" "),(_vm.button >= 6 && this.editingdraft === 1)?_c('button',{staticClass:"right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('draftfinaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e()])]):_c('div',{staticClass:"col-12 p0 pr3"},[_c('div',{staticClass:" flex p0  my4 col-12 justify-between items-center white-background pt1"},[(_vm.offermakingtype === 'HurtigtTilbud')?_c('div',{staticClass:"mobile-flex-column   ml3 flex justify-around border-1  ",staticStyle:{"height":"62px","width":"max(60%, 40rem,400px)"},attrs:{"id":"specialrow"}},[_c('a',{staticClass:"col col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background",on:{"click":function($event){return _vm.previewoffer()}}},[_c('i',{staticClass:"el-icon-copy-document m0 h3"}),_c('p',{staticClass:"h6 darkblue"},[_vm._v("Forhåndsvisning")]),(_vm.pdfpdf !== null)?_c('a',{staticClass:"h6",staticStyle:{"font-size":".5em"},attrs:{"href":_vm.pdfpdf}},[_vm._v("download here")]):_vm._e()]),_vm._v(" "),_c('a',{directives:[{name:"b-modal",rawName:"v-b-modal.draftsstandard",modifiers:{"draftsstandard":true}}],staticClass:"col-4 p1 m0 flex flex-column justify-center items-center mr1 more-muted-background"},[_c('i',{staticClass:"el-icon-notebook-2 m0 h3"}),_c('p',{staticClass:"h6 nav-link m0 p0"},[_vm._v("Udkast")])]),_vm._v(" "),(_vm.editingdraft === 1)?_c('a',{staticClass:"col col-4 p1 m0 flex flex-column justify-center items-center more-muted-background mr1",on:{"click":function($event){return _vm.updatetilbud()}}},[_c('i',{staticClass:"el-icon-document-checked m0 h3"}),_c('p',{staticClass:"h6 darkblue m0"},[_vm._v("Opdater kladde")])]):_c('a',{staticClass:"col md-col-4 lg-col-4 sm-col-6 p1 m0 flex flex-column justify-center items-center more-muted-background mr1",on:{"click":function($event){return _vm.saveasdraft()}}},[_c('i',{staticClass:"el-icon-document-checked m0 h3"}),_c('p',{staticClass:"h6 darkblue m0"},[_vm._v("Gem som kladde")])])]):_vm._e(),_vm._v(" "),(_vm.button <= 2 && _vm.offermakingtype !== 'UploadTilbud')?_c('button',{staticClass:" ml-auto right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){_vm.nextstebutton(), _vm.assigndatecomment()}}},[_c('span',{staticClass:"mx2 "},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),((_vm.button >= 4 && _vm.editingdraft === 0))?_c('button',{staticClass:"ml-auto right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('finaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e(),_vm._v(" "),(_vm.button >= 4 && _vm.editingdraft === 1)?_c('button',{staticClass:"right h5 p2 px2 gibson greenblue-button not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmtilbud('draftfinaloffer')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Indsend")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-check"})])]):_vm._e()])])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"200px"}}),_vm._v(" "),_c('b-modal',{ref:"quickofferconditions",attrs:{"centered":"","hide-footer":"","id":"conditionsstandard"},on:{"show":_vm.showbilag}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.hideModalconditions()}}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-back"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background pr2 pl2"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('p',{staticClass:"h3 my1 semi-bold pl2"},[_vm._v("Tilføj betingelser")]),_vm._v(" "),_c('p',{staticClass:"h4 mt1 mb2 semi-bold pl2"},[_vm._v("Betingelser og forbehold i tilbuddet")]),_vm._v(" "),_c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"white-background no-border col-12 p0 flex flex-row items-center ",staticStyle:{"height":"30px"}},[_c('p',{staticClass:"semi-bold col-7 flex justify-start p0 m0"},[_vm._v("Brugerdefinerede Noter")]),_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.addbrugerdefineredestandard",modifiers:{"addbrugerdefineredestandard":true}}],staticClass:"col-5 flex justify-end el-icon-circle-plus-outline p0"})]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Vælg her")]),_vm._v(" "),[_c('b-form-select',{staticClass:"  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1",staticStyle:{"height":"48px"},attrs:{"placeholder":"Ingenting valgt"},on:{"change":function($event){return _vm.assigntermsinput('note' , _vm.termsnotats)}},model:{value:(_vm.termsnotats),callback:function ($$v) {_vm.termsnotats=$$v},expression:"termsnotats"}},_vm._l((_vm.termsnotes),function(item,index){return _c('b-form-select-option',{key:index,staticClass:"col-6",attrs:{"value":item}},[_vm._v(_vm._s(item.title + '-' + item.description.substring(0,30)))])}),1)],_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"rows":"4","max-rows":"4","placeholder":"Tilføj dine brugerdefinerede noter her"},model:{value:(_vm.form.termsnote),callback:function ($$v) {_vm.$set(_vm.form, "termsnote", $$v)},expression:"form.termsnote"}}),_vm._v(" "),_c('div',{staticClass:"white-background no-border col-12 p0 flex flex-row items-center mt2 ",staticStyle:{"height":"30px"}},[_c('p',{staticClass:"semi-bold col-7 flex justify-start p0 m0"},[_vm._v("Betingelser og standardforbehold")]),_c('i',{directives:[{name:"b-modal",rawName:"v-b-modal.addbetingelserstandard",modifiers:{"addbetingelserstandard":true}}],staticClass:"col-5 flex justify-end el-icon-circle-plus-outline p0"})]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Vælg her")]),_vm._v(" "),_c('b-form-select',{staticClass:"  col-12  darkblue semi-bold  not-rounded gibson mb1 mt1",staticStyle:{"height":"48px"},attrs:{"placeholder":"Ingenting valgt"},on:{"change":function($event){return _vm.assigntermsinput('betingelser' , _vm.termsbetings)}},scopedSlots:_vm._u([{key:"first",fn:function(){return [_c('b-form-select-option',{attrs:{"value":null,"disabled":""}},[_vm._v("Ingenting valgt")])]},proxy:true}]),model:{value:(_vm.termsbetings),callback:function ($$v) {_vm.termsbetings=$$v},expression:"termsbetings"}},[_vm._v(" "),_vm._l((_vm.termsbetingelser),function(item,index){return _c('b-form-select-option',{key:index,attrs:{"value":item}},[_vm._v(_vm._s(item.title + '-' + item.description.substring(0,30)))])})],2),_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"rows":"4","max-rows":"4","placeholder":"Tilføj dine brugerdefinerede noter her"},model:{value:(_vm.form.termsbetingelser),callback:function ($$v) {_vm.$set(_vm.form, "termsbetingelser", $$v)},expression:"form.termsbetingelser"}}),_vm._v(" "),_c('p',{staticClass:"mt2 semi-bold"},[_vm._v("Bilag")])],2)]),_vm._v(" "),_c('b-form-group',{staticClass:"p0 form-group  form-group lg-col-12 md-col-12    ",attrs:{"id":"file","label":"","label-for":"fag"}},[_c('file-upload-input',{staticClass:"education-upload",attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}})],1),_vm._v(" "),_c('p',{attrs:{"id":"bilagfilestext","clss":"h6 hide"}},[_vm._v("Dine filer")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column item-start col-12 hide ",attrs:{"id":"bilagfiles"}},_vm._l((_vm.form.bilagfile),function(item,index){return _c('div',{key:index},[_c('span',{staticClass:"h6 gibson regular darkblue line-height-1 mr3",staticStyle:{"word-break":"break-word"}},[_vm._v(_vm._s(item))]),_vm._v(" "),_c('button',{staticClass:"not-rounded delete-button p1 border-none",on:{"click":function($event){return _vm.removeitembilag(item)}}},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])])])}),0)],1),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"})],2),_vm._v(" "),_c('b-modal',{ref:"quickofferdraft",attrs:{"centered":"","hide-footer":"","id":"draftsstandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":_vm.hideModaldrafts}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-back"})])])])]}),_vm._v(" "),_c('div',{staticClass:"clearfix white-background pr2 pl2"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('p',{staticClass:"h5 my1 semi-bold"},[_vm._v("Tilbuds kladder")]),_vm._v(" "),_c('p',{staticClass:"h6 my2 "},[_vm._v("Når du genoptager et tilbud, sletters det fra kladdelisten. Vælg et kladde, du vil fortsætte:")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column containerdrafts"},_vm._l((_vm.draftitems),function(item,index){return _c('div',{directives:[{name:"b-modal",rawName:"v-b-modal.drafteeditordeletestandard",modifiers:{"drafteeditordeletestandard":true}}],key:index,staticClass:" flex flex-column  col-12 m0 p1 more-muted-background mb2 p1 ",on:{"click":function($event){return _vm.fordeletecontinue(item)}}},[_c('div',{staticClass:"flex flex-row"},[_c('p',{staticClass:"ml1 m0 h5 semi-bold "},[_vm._v(_vm._s(item.firstname + ' ' + item.lastname))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('i',{staticClass:"el-icon-star-off"}),_c('p',{staticClass:"ml2 m0"},[_vm._v(_vm._s(item.info.reference_number))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row"},[_c('i',{staticClass:"el-icon-date"}),_c('p',{staticClass:"ml2 m0"},[_vm._v(_vm._s(item.createdtime))])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])],2),_vm._v(" "),_c('b-modal',{ref:"drafteeditordeletemodal",attrs:{"centered":"","hide-footer":"","id":"drafteeditordeletestandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":_vm.hidemodaldrafteeditordelete}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-back"})])])])]}),_vm._v(" "),_c('form',[_c('div',{staticClass:"clearfix white-background pr2 pl2"},[_c('div',{staticClass:"flex flex-column items-center gibson"},[_c('p',{staticClass:"h5 my1 semi-bold"},[_vm._v("Vælg venligst")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"flex justify-between col-10"},[_c('button',{staticClass:"mr1 col-6 dark-button p2 h4 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.continueeditdrafttilbud(_vm.fordelete)}}},[_c('span',{staticClass:"mx2"},[_vm._v("Redigere")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-right"})])]),_vm._v(" "),_c('button',{staticClass:"col-6 dark-button p2 h4 regular border-none not-rounded gibson flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletedrafttilbud(_vm.fordelete)}}},[_c('span',{staticClass:"mx2"},[_vm._v("Slet")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-delete"})])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('p',[_vm._v("_")])])],2),_vm._v(" "),_c('b-modal',{ref:"addbrugerdefinerede",attrs:{"centered":"","hide-footer":"","id":"addbrugerdefineredestandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"pl3 white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":_vm.hideModaladdbrugerdefinerede}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-back"})])])])]}),_vm._v(" "),_c('form',[_c('div',{staticClass:"clearfix white-background pr2 pl2"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('p',{staticClass:"h4 mt1 mb2 center semi-bold"},[_vm._v("Brugerdefinerede noter")]),_vm._v(" "),_c('div',{staticClass:"col-12 "},[_c('b-form-input',{staticClass:"bg-light pt1  mb2 mt2",attrs:{"placeholder":"Title","required":""},model:{value:(_vm.form.termsaddnotetitle),callback:function ($$v) {_vm.$set(_vm.form, "termsaddnotetitle", $$v)},expression:"form.termsaddnotetitle"}}),_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"rows":"7","max-rows":"7","placeholder":"Tilføj dine vilkå og betingelser her"},model:{value:(_vm.form.termsaddnotedesc),callback:function ($$v) {_vm.$set(_vm.form, "termsaddnotedesc", $$v)},expression:"form.termsaddnotedesc"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:" ml2 col-6 dark-button p2 h4 regular border-none not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.addterms('note')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Gem")])])])])],2),_vm._v(" "),_c('b-modal',{ref:"addbetingelser",attrs:{"centered":"","hide-footer":"","id":"addbetingelserstandard"}},[_vm._t("modal-header",function(){return [_c('div',{staticClass:"col-12 flex justify-start items-center white-background  px0 mx0"},[_c('button',{staticClass:"pl3 white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":_vm.hideModaladdbetingelser}},[_c('span',[_c('i',{staticClass:"pt2 el-icon-back"})])])])]}),_vm._v(" "),_c('form',[_c('div',{staticClass:"clearfix white-background pr2 pl2"},[_c('div',{staticClass:"flex flex-column gibson"},[_c('p',{staticClass:"h4 mt1 mb2 center semi-bold"},[_vm._v("Betingelser og standardforbehold")]),_vm._v(" "),_c('div',{staticClass:"col-12 "},[_c('b-form-input',{staticClass:"bg-light pt1  mb2 mt2",attrs:{"placeholder":"Title","required":""},model:{value:(_vm.form.termsbetingelsertitle),callback:function ($$v) {_vm.$set(_vm.form, "termsbetingelsertitle", $$v)},expression:"form.termsbetingelsertitle"}}),_vm._v(" "),_c('b-form-textarea',{staticClass:"bg-light pt1 mt1 ",attrs:{"required":"","rows":"7","max-rows":"7","placeholder":"Tilføj dine vilkå og betingelser her"},model:{value:(_vm.form.termsbetingelserdesc),callback:function ($$v) {_vm.$set(_vm.form, "termsbetingelserdesc", $$v)},expression:"form.termsbetingelserdesc"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"col-12 p2 white-background",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:" ml2 col-6 dark-button p2 h4 regular border-none not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.addterms('betingelser')}}},[_c('span',{staticClass:"mx2"},[_vm._v("Gem")])])])])],2),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_standardTilbudProduct_vue__ = __webpack_require__(1311);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e35de2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_standardTilbudProduct_vue__ = __webpack_require__(1325);
function injectStyle (ssrContext) {
  __webpack_require__(1310)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_standardTilbudProduct_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26e35de2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_standardTilbudProduct_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1310 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__noneligibleFeaturepop__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_signature_pad__ = __webpack_require__(216);











var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'tilbudpagwizardbooking',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_5__noneligibleFeaturepop__["a" /* default */],
    ErrorHandler: ErrorHandler,
    ImageRating: __WEBPACK_IMPORTED_MODULE_7_vue_rate_it__["ImageRating"],
    SignaturePad: __WEBPACK_IMPORTED_MODULE_8_signature_pad__["a" /* default */]
  },
  data: function data() {
    return {
      projectID: '',
      loading: true,
      activeTab: ['1'],
      contactID: '',
      salesPersonbitrix: '',
      partnernote: '',
      productOfferForm: {},
      productOfferPerForm: {},
      confirmTerms: false,
      haaid: '',
      productlistforpricearr: {},
      mainwizarproductarr: {},
      productlist: [],
      daystofinish: null,
      datestart: '',
      total: 0,
      reviewtext: false,
      childprojects: [],
      childprojectObj: {},
      rowbolig: [{
        title: '',
        description: '',
        unit: '',
        value: '',
        quantity: ''
      }],
      industrypris: {},
      startingno: 1,
      savenote: null,
      signaturePng: null,
      productOfferFormRules: {},
      offerID: null,
      partnerprimaryindustry: '',
      partnerprimaryindustryText: '',
      productrelatedbyPartnerPrimaryIndusty: [],
      productlistnotforpartnerArr: [],
      selectedindustryforrequest: '',
      alertpartnernote: false,
      summed: 0,
      editPriceArr: [],
      allrecommendatationsitems: [],
      fiverecommendations: [],
      reviewsmodal: false,
      productOfferFormEdit: {},
      parentID: '',
      industryID: [],
      offerType: '',
      itemsjobindustry: {},
      insurancetype: '',
      insuranceamount: 0,
      insurancepercentage: 0,
      parentofferId: '',
      submittedIndustries: [],
      contractType: '',
      projectTitle: '',
      jobList: [],
      createdFrom: '',
      partnerenterprise: '',
      termspopup: false,
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'http://www.haandvaerker.dk/om/betingelser',
      signaturePad: '',
      allprisperjob: [],
      termslinkablework: 'betingelser',
      jobdescarr: {},
      editdescfield: false,
      hideplusbutton: false,
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() - -86400000 < Date.now();
        }
      },
      limitdayserror: false,
      TermsNewPopup: false,
      termspopupText: ''
    };
  },
  created: function created() {},

  watch: {},
  mounted: function mounted() {
    var _this = this;

    this.contactID = this.$route.query.contactID;
    this.parentID = this.$route.query.parentID;
    this.jobList = this.$route.query.joblist ? JSON.parse(this.$route.query.joblist) : [];
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : null;
    this.projectID = this.$route.query.projectID;
    this.createdFrom = this.$route.query.createdfrom ? this.$route.query.createdfrom : null;
    this.projectTitle = this.$route.query.projecttitle ? this.$route.query.projecttitle : null;
    this.industryID = this.$route.query.industryID ? this.$route.query.industryID.split(',') : [];
    this.submittedIndustries = this.$route.query.submittedindustry ? JSON.parse(this.$route.query.submittedindustry) : [];
    this.offerType = this.$route.query.offertype ? this.$route.query.offertype : '';
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : [];
    if (this.contractType === 'Hovedentreprise') {
      if (this.createdFrom === 'bitrix') {
        if (this.parentID !== 'null') {
          this.jobList.forEach(function (k) {
            var jobindustry = k.split(':')[0];
            _this.childprojectObj[Number(jobindustry)] = _this.projectID;
            _this.submittedIndustries.push(jobindustry.toString());
          });
        } else {
          this.jobList.forEach(function (k) {
            k.forEach(function (p) {
              var jobindustry = p.split(':')[0];
              _this.childprojectObj[Number(jobindustry)] = _this.projectID;
              _this.submittedIndustries.push(jobindustry.toString());
            });
          });
        }
      } else {
        this.jobList.forEach(function (k) {
          if (Array.isArray(k)) {
            k.forEach(function (k) {
              var jobindustry = k.split(':')[0];
              _this.submittedIndustries.push(jobindustry.toString());
            });
          } else {
            var jobindustry = k.split(':')[0];
            _this.submittedIndustries.push(jobindustry.toString());
          }
        });
        if (this.childprojects.length > 0) {
          this.childprojects.forEach(function (o) {
            _this.childprojectObj[o.JOB_INDUSTRY] = o.ID;
          });
        }
      }
    } else {
      if (!this.parentID !== 'null') {
        this.jobList.forEach(function (p) {
          var jobindustry = p.split(':')[0];
          _this.childprojectObj[Number(jobindustry)] = _this.projectID;
          _this.submittedIndustries.push(jobindustry.toString());
        });
      } else {
        this.jobList.forEach(function (k) {
          k.forEach(function (p) {
            var jobindustry = p.split(':')[0];
            _this.childprojectObj[Number(jobindustry)] = _this.projectID;
            _this.submittedIndustries.push(jobindustry.toString());
          });
        });
      }
    }
    this.haaid = localStorage.getItem('haaid');
    if (localStorage.getItem('partnerPrimaryIndustryv2') === null || typeof localStorage.getItem('partnerPrimaryIndustryv2') === 'undefined') {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger');
      this.$router.push('/login');
    }
    this.getenterprise();
    this.getallrecommendations();
    this.gettaskbitrix();
    this.getTermsCondition();
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.partnerprimaryindustry = localStorage.getItem('partnerPrimaryIndustryv2');
    this.partnerprimaryindustryText = localStorage.getItem('partnerPrimaryIndustryText');
    this.getdataigibility();
  },

  methods: {
    getdataigibility: function getdataigibility() {
      var _this2 = this;

      setTimeout(function () {
        _this2.eligible = localStorage.getItem('OfferCreator');
        if (_this2.eligible === 'false') {
          _this2.$refs.noneligibleFeaturepop.showmodel(_this2.eligible, '/newsfeed', 'OfferCreator');
        }
      }, 3000);
    },
    saveProjectPrice: function saveProjectPrice() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee() {
        var projid;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this3.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
                projid = _this3.submittedIndustries.length === 1 && _this3.submittedIndustries[0] === '1062' ? _this3.parentID : _this3.projectID;

                _this3.productlist.forEach(function (p) {
                  var industry = p.split('-')[0];
                  var jobindustry = p.split('-')[1];
                  var prisperindusty = _this3.productOfferForm[industry + '_' + jobindustry];
                  var headers = {
                    Authorization: 'Bearer ' + _this3.salesPersonbitrix
                  };
                  var data = {
                    project_id: projid,
                    sub_project_id: 0,
                    contact_id: _this3.contactID,
                    calculation_id: 0,
                    industry_id: industry,
                    total: prisperindusty,
                    note: _this3.partnernote,
                    job_industry_id: jobindustry,
                    signature: _this3.signaturePng,
                    weeks: _this3.daystofinish,
                    days: _this3.daystofinish,
                    start_date: _this3.datestart,
                    offer_id: _this3.parentofferId,
                    parent_offer_id: _this3.parentofferId,
                    reviews_id: _this3.fiverecommendations,
                    job_description: {}
                  };
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this3.jobdescarr[industry + '_' + jobindustry].submitted).length > 0) {
                    data.job_description = _this3.jobdescarr[industry + '_' + jobindustry];
                  }
                  if (_this3.submittedIndustries.length === 1 && _this3.submittedIndustries[0] === '1062') {
                    data.sub_project_id = _this3.projectID;
                  }

                  _this3.$http.post(_this3.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
                    if (industry + '-' + jobindustry === _this3.productlist[_this3.productlist.length - 1]) {
                      setTimeout(function () {
                        var obj = {
                          title: 'Gennemført!',
                          message: '',
                          type: 'success',
                          customCloseBtnText: 'Luk'
                        };
                        _this3.$refs.simplert.openSimplert(obj);
                      }, 1000);
                      setTimeout(function () {
                        _this3.$router.push('/alle-moeder');
                      }, 3000);
                    }
                  }, function (response) {
                    var error = response.body.message;
                    _this3.$message.error(error);
                  });
                });

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    saveProjectPricev2: function saveProjectPricev2(offerid, jobwithpriceObj) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var jobindustry, enterpriseId, jobwithpriceArr, gettotal;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                jobindustry = '';
                enterpriseId = '';
                jobwithpriceArr = [];

                jobwithpriceArr = jobwithpriceObj.split('_');
                jobindustry = jobwithpriceArr[1];
                enterpriseId = jobwithpriceArr[0];
                gettotal = _this4.productOfferForm[jobwithpriceObj];

                setTimeout(function () {
                  _this4.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
                  var headers = {
                    Authorization: 'Bearer ' + _this4.salesPersonbitrix
                  };
                  var data = {
                    project_id: _this4.projectID,
                    contact_id: _this4.contactID,
                    calculation_id: 0,
                    industry_id: enterpriseId,
                    total: gettotal,
                    note: _this4.partnernote,
                    signature: _this4.signaturePng,
                    weeks: _this4.daystofinish,
                    days: _this4.daystofinish,
                    job_industry_id: jobindustry,
                    start_date: _this4.datestart,
                    offer_id: offerid,
                    reviews_id: _this4.fiverecommendations,
                    job_description: {}
                  };
                  if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this4.jobdescarr[enterpriseId + '_' + jobindustry].submitted).length > 0) {
                    data.job_description = _this4.jobdescarr[enterpriseId + '_' + jobindustry];
                  }
                  _this4.$http.post(_this4.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
                    if (enterpriseId === _this4.productlist[_this4.productlist.length - 1]) {
                      setTimeout(function () {
                        var obj = {
                          title: 'Gennemført!',
                          message: '',
                          type: 'success',
                          customCloseBtnText: 'Luk'
                        };
                        _this4.$refs.simplert.openSimplert(obj);
                      }, 1000);
                      setTimeout(function () {
                        _this4.$router.push('/alle-moeder');
                      }, 3000);
                    }
                  }, function (response) {
                    var error = response.body.message;
                    _this4.$message({
                      type: 'error',
                      message: error
                    });
                  });
                }, 200);

              case 8:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this4);
      }))();
    },
    saveProjectPricev3: function saveProjectPricev3() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.productlist.forEach(function (p) {
        var industry = p.split('-')[0];
        var jobindustry = p.split('-')[1];
        var jobindistryprojectID = _this5.childprojectObj[Number(jobindustry)];
        var prisperindusty = _this5.productOfferForm[industry + '_' + jobindustry];
        var headers = {
          Authorization: 'Bearer ' + _this5.salesPersonbitrix
        };
        var data = {
          project_id: _this5.parentID,
          sub_project_id: jobindistryprojectID,
          contact_id: _this5.contactID,
          calculation_id: 0,
          industry_id: industry,
          total: prisperindusty,
          note: _this5.partnernote,
          job_industry_id: jobindustry,
          signature: _this5.signaturePng,
          weeks: _this5.daystofinish,
          days: _this5.daystofinish,
          start_date: _this5.datestart,
          offer_id: _this5.parentofferId,
          parent_offer_id: _this5.parentofferId,
          reviews_id: _this5.fiverecommendations,
          job_description: {}
        };
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this5.jobdescarr[industry + '_' + jobindustry].submitted).length > 0) {
          data.job_description = _this5.jobdescarr[industry + '_' + jobindustry];
        }
        _this5.$http.post(_this5.$bitrixapi + 'partner/wizard/saveListPriceV2', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (industry + '-' + jobindustry === _this5.productlist[_this5.productlist.length - 1]) {
            setTimeout(function () {
              var obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              };
              _this5.$refs.simplert.openSimplert(obj);
            }, 1000);
            setTimeout(function () {
              _this5.$router.push('/alle-moeder');
            }, 3000);
          }
        }, function (response) {
          var error = response.body.message;
          _this5.$message.error(error);
        });
      });
    },
    saveProjectPriceNonPrimary: function saveProjectPriceNonPrimary() {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.productlistnotforpartnerArr.forEach(function (industrynon) {
        var headers = {
          Authorization: 'Bearer ' + _this6.salesPersonbitrix
        };
        var data = {
          project_id: _this6.projectID,
          contact_id: _this6.contactID,
          calculation_id: 0,
          industry_id: industrynon.industryid,
          total: 0,
          note: _this6.partnernote,
          signature: _this6.signaturePng,
          weeks: _this6.daystofinish,
          days: _this6.daystofinish,
          start_date: _this6.datestart,
          offer_id: _this6.offerID
        };
        industrynon.industrydetails.forEach(function (k) {
          data[k.FIELD + '_' + k.ID] = 0;
          data[k.ID] = k.DESCRIPTION;
        });
        _this6.$http.post(_this6.$bitrixapi + 'partner/wizard/saveListPrice', data, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {
          var error = response.body.message;
          _this6.$message.error(error);
        });
      });
    },
    updatePriceList: function updatePriceList() {
      var _this7 = this;

      var projid = this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062' || this.contractType === 'Fagentreprise' ? this.parentID : this.projectID;
      var jobwithpriceArr = '';
      var enterpriseId = '';
      var jobindustry = '';
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.productlist.forEach(function (industry) {
        jobwithpriceArr = industry.split('-');
        jobindustry = jobwithpriceArr[1];
        enterpriseId = jobwithpriceArr[0];
        var prisperindusty = _this7.productOfferForm[enterpriseId + '_' + jobindustry];
        var headers = {
          Authorization: 'Bearer ' + _this7.salesPersonbitrix
        };
        var data = {
          project_id: projid,
          contact_id: _this7.contactID,
          sub_project_id: 0,
          calculation_id: 0,
          industry_id: enterpriseId,
          job_industry_id: jobindustry,
          total: prisperindusty,
          note: _this7.partnernote,
          signature: _this7.signaturePng,
          weeks: _this7.daystofinish,
          days: _this7.daystofinish,
          start_date: _this7.datestart,
          reviewsId: _this7.fiverecommendations,
          job_description: {}
        };
        if (_this7.submittedIndustries.length === 1 && _this7.submittedIndustries[0] === '1062') {
          data.sub_project_id = _this7.projectID;
        }
        if (__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this7.jobdescarr[enterpriseId + '_' + jobindustry].submitted).length > 0) {
          data.job_description = _this7.jobdescarr[enterpriseId + '_' + jobindustry];
        }

        _this7.$http.post(_this7.$bitrixapi + 'partner/wizard/updateListPricePartner', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (industry === _this7.productlist[_this7.productlist.length - 1]) {
            setTimeout(function () {
              var obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              };
              _this7.$refs.simplert.openSimplert(obj);
            }, 1000);
            setTimeout(function () {
              _this7.$router.push('/alle-moeder');
            }, 3000);
          }
        }, function (response) {
          _this7.loading = false;
          var error = response.body.message;
          _this7.$message.error(error);
        });
      });
    },
    initiateSignaturepad: function initiateSignaturepad() {
      var _this8 = this;

      setTimeout(function () {
        var canvas = document.querySelector('canvas');
        _this8.signaturePad = new __WEBPACK_IMPORTED_MODULE_8_signature_pad__["a" /* default */](canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        });
      }, 200);
    },
    jobDescRestoreAll: function jobDescRestoreAll(enterpriseid, jobindustryid) {
      var _this9 = this;

      this.$confirm('Er du sikker på, at du ikke vil gendanne al tekst tilbage til den oprindelige tekst ?', {
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej',
        type: 'warning'
      }).then(function () {
        _this9.editdescfield = true;
        var newdesc = [];
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(_this9.productlistforpricearr[enterpriseid][jobindustryid]['SERIES']).forEach(function (u) {
          newdesc.push({ isediting: false, descr: u, newdesctext: '' });
        });
        _this9.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'] = newdesc;
        _this9.editdescfield = false;
      }).catch(function () {});
    },
    jobDescEdit: function jobDescEdit(enterpriseid, jobindustryid, indexdesc) {
      this.editdescfield = true;
      var text = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = true;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext = text;
      this.editdescfield = false;
    },
    jobDescDelete: function jobDescDelete(enterpriseid, jobindustryid, indexdesc) {
      var _this10 = this;

      this.$confirm('Er du sikker på, at du vil slette denne beskrivelse?', {
        confirmButtonText: 'Ja',
        cancelButtonText: 'Nej',
        type: 'warning'
      }).then(function () {
        var seirelength = _this10.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].length;
        var seriesempty = _this10.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].filter(function (u) {
          return u.descr === '';
        });
        if (parseInt(seirelength - seriesempty.length) <= 1) {
          _this10.$message({
            type: 'error',
            message: 'Efterlad venligst mindst én tekst'
          });
          return;
        }

        _this10.jobdescarr[enterpriseid + '_' + jobindustryid].deleted[indexdesc] = _this10.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr;
        delete _this10.jobdescarr[enterpriseid + '_' + jobindustryid].updated[indexdesc];
        delete _this10.jobdescarr[enterpriseid + '_' + jobindustryid].added[indexdesc];
        _this10.editdescfield = true;
        _this10.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr = '';
        _this10.editdescfield = false;
        _this10.jobdescarr[enterpriseid + '_' + jobindustryid].submitted = [];
        _this10.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].forEach(function (l) {
          if (l.descr !== '') {
            _this10.jobdescarr[enterpriseid + '_' + jobindustryid].submitted.push(l.descr);
          }
        });
      }).catch(function () {});
    },
    jobDescCanceledit: function jobDescCanceledit(enterpriseid, jobindustryid, indexdesc) {
      this.editdescfield = true;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = false;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext = '';
      if (this.hideplusbutton) {
        this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].pop();
      }
      this.hideplusbutton = false;
      this.editdescfield = false;
    },
    jobDescAddandEdit: function jobDescAddandEdit(enterpriseid, jobindustryid, indexdesc) {
      var _this11 = this;

      this.editdescfield = true;
      var newtext = this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].newdesctext;
      if (newtext === '' || this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr === 'indtast beskrivelse her') {
        this.$message({
          type: 'error',
          message: 'Tilføj tekst, før du gemmer'
        });
        this.editdescfield = false;
        return;
      }
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].isediting = false;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'][indexdesc].descr = newtext;
      this.jobdescarr[enterpriseid + '_' + jobindustryid].submitted = [];
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].forEach(function (l) {
        if (l.descr !== '') {
          _this11.jobdescarr[enterpriseid + '_' + jobindustryid].submitted.push(l.descr);
        }
      });
      if (this.hideplusbutton) {
        this.jobdescarr[enterpriseid + '_' + jobindustryid].added[indexdesc] = newtext;
        this.hideplusbutton = false;
      } else {
        this.jobdescarr[enterpriseid + '_' + jobindustryid].updated[indexdesc] = newtext;
      }
      this.editdescfield = false;
    },
    jobDescAddlineDesc: function jobDescAddlineDesc(enterpriseid, jobindustryid) {
      this.editdescfield = true;
      this.productlistforpricearr[enterpriseid][jobindustryid]['SERIESARR'].push({ isediting: true, desc: 'indtast beskrivelse her', newdesctext: '' });
      this.hideplusbutton = true;
      this.editdescfield = false;
    },
    getinsuranceamount: function getinsuranceamount() {
      var _this12 = this;

      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'integration/getInsuranceSettings', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this12.insurancetype = !res.insurance_price_in_dkk !== '' && !res.insurance_price_in_dkk !== null ? 'amount' : 'percentage';
        _this12.insuranceamount = res.insurance_price_in_dkk;
        _this12.insurancepercentage = res.insurance_price_percentage;
      }, function (response) {
        var error = response.body.message;
        _this12.$message({
          type: 'error',
          message: error
        });
      });
    },
    getenterprise: function getenterprise() {
      var _this13 = this;

      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var enterpriseid = Number(res.data.UF_CRM_COMPANY_ENTERPRISE);
          _this13.partnerenterprise = enterpriseid === 1 ? 'Hovedentreprise' : enterpriseid === 3 ? 'Hovedentreprise' : 'Fagentreprise';
        }
        _this13.getallwizardproduct();
      }, function (response) {
        _this13.getallwizardproduct();
        var error = response.body.message;
        _this13.$message({
          type: 'error',
          message: error
        });
      });
    },
    getProductList: function getProductList() {
      var _this14 = this;

      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPrice?project_id=' + (this.offerType === 'invitation' ? this.projectID : this.parentID) + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this14.productlist = [];
        for (var index in res) {
          var indexindustry = res[index]['WIZARD_ID'];
          _this14.industrypris[index] = 0;
          if ((_this14.productrelatedbyPartnerPrimaryIndusty.includes(index) || res[index]['PARTNER_IDS'].includes(_this14.haaid)) && _this14.industryID.includes(index) || _this14.offerType === 'invitation') {
            _this14.productlistforpricearr.push({ 'industryid': index, 'industrydetails': res[index]['INDUSTRY'], 'wizardId': indexindustry });
            thisvar.productlist.push(index);
            thisvar.industrypris[index] = 0;
            thisvar.productOfferForm[index] = {};
            thisvar.productOfferFormRules[index] = {};
          } else {
            if (_this14.industryID === index) {
              _this14.productlistnotforpartnerArr.push({ 'industryid': index, 'industrydetails': res[index]['INDUSTRY'], 'wizardId': indexindustry });
            }
          }
        }
        _this14.productlistforpricearr.forEach(function (y) {
          y.industrydetails.forEach(function (o) {
            thisvar.productOfferForm[y.industryid][o.FIELD + '_' + o.ID] = '';
            thisvar.productOfferFormEdit[o.ID] = o.FIELD + '_' + o.ID;
            thisvar.createrules(o.FIELD, o.ID, y.industryid);
          });
        });
        if (_this14.$route.query.offerID) {
          _this14.offerID = _this14.$route.query.offerID;
          _this14.getAcceptedOfferPrice();
        }
        _this14.loading = false;
      }, function (response) {
        var error = response.body;
        _this14.$refs.errorMsg.showMsg(error);
      });
    },
    getProductListAi: function getProductListAi() {
      var _this15 = this;

      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + this.projectID + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this15.productlist = [];
        for (var index in res) {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = index;
          enterpiserdata['industrydetails'] = {};
          thisvar.productlist.push(index);
          for (var jobindustry in res[index]) {
            enterpiserdata['jobindustry'] = jobindustry;
            enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
          }
          if (_this15.productrelatedbyPartnerPrimaryIndusty.includes(enterpiserdata['jobindustry']) || _this15.offerType === 'invitation') {
            _this15.productlistforpricearr.push(enterpiserdata);
          } else {
            _this15.productlistnotforpartnerArr.push(enterpiserdata);
          }
        }
        _this15.productlistforpricearr.forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y.industrydetails).forEach(function (o) {
            thisvar.industrypris[y.industryid + '_' + o[0]] = 0;
            thisvar.productOfferForm[y.industryid + '_' + o[0]] = 0;
            thisvar.createrules(y.industryid + '_' + o[0]);
          });
        });

        _this15.loading = false;
      }, function (response) {
        var error = response.body;
        _this15.$refs.errorMsg.showMsg(error);
      });
    },
    getProductListAiV2: function getProductListAiV2() {
      var _this16 = this;

      var prodid = this.contractType === 'Hovedentreprise' ? this.$route.query.projectID : this.$route.query.parentID;
      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this16.productlist = [];
        var productlistforpricearr = {};
        var productlistnotforpartnerArr = {};
        res.forEach(function (subproject, index) {
          if (!_this16.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
            return true;
          }
          var enterpiserdata = {};
          enterpiserdata['industryid'] = subproject.INDUSTRY;
          enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
          enterpiserdata['wizardId'] = subproject.ID;
          enterpiserdata['subprojectId'] = _this16.childprojectObj[subproject.JOB_INDUSTRY];
          enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (!productlistforpricearr[subproject.INDUSTRY]) {
            if ((_this16.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this16.submittedIndustries.includes(_this16.productrelatedbyPartnerPrimaryIndusty[0]) && _this16.contractType === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this16.haaid) || enterpiserdata.originalpartnerIDS.includes(_this16.haaid) && _this16.contractType === 'Hovedentreprise' || _this16.offerType === 'invitation' && _this16.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          } else {
            if ((_this16.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this16.submittedIndustries.includes(_this16.productrelatedbyPartnerPrimaryIndusty[0]) && _this16.contractType === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this16.haaid) || enterpiserdata.originalpartnerIDS.includes(_this16.haaid) && _this16.contractType === 'Hovedentreprise' || _this16.offerType === 'invitation' && _this16.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              enterpiserdata['SERIES'] = subproject.SERIES;
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          }
        });
        if (_this16.contractType === 'Fagentreprise') {
          res.forEach(function (subproject, index) {
            if (_this16.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
              var enterpiserdata = {};
              enterpiserdata['industryid'] = subproject.INDUSTRY;
              enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
              enterpiserdata['wizardId'] = subproject.ID;
              enterpiserdata['subprojectId'] = _this16.childprojectObj[subproject.JOB_INDUSTRY];
              enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
              enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
              enterpiserdata['industrydetails'] = {};
              if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                if ((_this16.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this16.submittedIndustries.includes(_this16.productrelatedbyPartnerPrimaryIndusty[0]) && _this16.contractType === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this16.haaid) || enterpiserdata.originalpartnerIDS.includes(_this16.haaid) && _this16.contractType === 'Hovedentreprise' || _this16.offerType === 'invitation' && _this16.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY] = {};
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              } else {
                if ((_this16.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this16.submittedIndustries.includes(_this16.productrelatedbyPartnerPrimaryIndusty[0]) && _this16.contractType === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this16.haaid) || enterpiserdata.originalpartnerIDS.includes(_this16.haaid) && _this16.contractType === 'Hovedentreprise' || _this16.offerType === 'invitation' && _this16.submittedIndustries.includes(Number(subproject.JOB_INDUSTRY))) && Number(subproject.JOB_INDUSTRY) !== 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            }
          });
        } else {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = _this16.projectTitle;
          enterpiserdata['jobindustry'] = res[0].JOB_INDUSTRY;
          enterpiserdata['wizardId'] = res[0].ID;
          enterpiserdata['subprojectId'] = res[0].PROJECT_ID;
          enterpiserdata['partnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (_this16.productrelatedbyPartnerPrimaryIndusty.includes(res[0].JOB_INDUSTRY) || _this16.submittedIndustries.includes(_this16.productrelatedbyPartnerPrimaryIndusty[0]) && _this16.contractType === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this16.haaid) || enterpiserdata.originalpartnerIDS.includes(_this16.haaid) && _this16.contractType === 'Hovedentreprise' || _this16.offerType === 'invitation' && _this16.submittedIndustries.includes(Number(res[0].JOB_INDUSTRY))) {} else {
            productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = {};
            productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = enterpiserdata;
          }
        }
        _this16.productlistforpricearr = productlistforpricearr;
        _this16.productlistnotforpartnerArr = productlistnotforpartnerArr;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this16.productlistforpricearr).forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y[1]).forEach(function (o) {
            thisvar.industrypris[y[0] + '_' + o[0]] = 0;
            thisvar.productOfferForm[y[0] + '_' + o[0]] = 0;
            thisvar.createrules(y[0] + '_' + o[0]);
          });
        });
        if (_this16.$route.query.offerID) {
          _this16.offerID = _this16.$route.query.offerID;
          _this16.getAcceptedOfferPrice();
        }
        _this16.loading = false;
      }, function (response) {
        var error = response.body.message;
        _this16.$message({
          type: 'error',
          message: error
        });
      });
    },
    getProductListAiV3: function getProductListAiV3() {
      var _this17 = this;

      var prodid = this.contractType === 'Hovedentreprise' ? this.$route.query.projectID : this.$route.query.parentID;
      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this17.productlist = [];
        var productlistforpricearr = {};
        var productlistnotforpartnerArr = {};
        res.forEach(function (subproject, index) {
          if (!_this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
            return true;
          }
          var enterpiserdata = {};
          enterpiserdata['industryid'] = subproject.INDUSTRY;
          enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
          enterpiserdata['wizardId'] = subproject.ID;
          enterpiserdata['subprojectId'] = _this17.childprojectObj[subproject.JOB_INDUSTRY];
          enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (!productlistforpricearr[subproject.INDUSTRY]) {
            if ((_this17.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this17.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this17.haaid) || enterpiserdata.originalpartnerIDS.includes(_this17.haaid) && _this17.contractType === 'Hovedentreprise' || _this17.offerType === 'invitation' && _this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062) {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          } else {
            if ((_this17.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this17.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this17.haaid) || enterpiserdata.originalpartnerIDS.includes(_this17.haaid) && _this17.contractType === 'Hovedentreprise' || _this17.offerType === 'invitation' && _this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062) {
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              enterpiserdata['SERIES'] = subproject.SERIES;
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          }
        });
        if (_this17.contractType === 'Fagentreprise') {
          res.forEach(function (subproject, index) {
            if (_this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) {
              var enterpiserdata = {};
              enterpiserdata['industryid'] = subproject.INDUSTRY;
              enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
              enterpiserdata['wizardId'] = subproject.ID;
              enterpiserdata['subprojectId'] = _this17.childprojectObj[subproject.JOB_INDUSTRY];
              enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
              enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
              enterpiserdata['industrydetails'] = {};
              if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
                if ((_this17.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this17.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this17.haaid) || enterpiserdata.originalpartnerIDS.includes(_this17.haaid) && _this17.contractType === 'Hovedentreprise' || _this17.offerType === 'invitation' && _this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY] = {};
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              } else {
                if ((_this17.productrelatedbyPartnerPrimaryIndusty.includes(subproject.JOB_INDUSTRY) || _this17.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this17.haaid) || enterpiserdata.originalpartnerIDS.includes(_this17.haaid) && _this17.contractType === 'Hovedentreprise' || _this17.offerType === 'invitation' && _this17.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            }
          });
        } else {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = _this17.projectTitle;
          enterpiserdata['jobindustry'] = res[0].JOB_INDUSTRY;
          enterpiserdata['wizardId'] = res[0].ID;
          enterpiserdata['subprojectId'] = res[0].PROJECT_ID;
          enterpiserdata['partnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (_this17.productrelatedbyPartnerPrimaryIndusty.includes(res[0].JOB_INDUSTRY) || _this17.partnerenterprise === 'Hovedentreprise' || enterpiserdata.partnerIDS.includes(_this17.haaid) || enterpiserdata.originalpartnerIDS.includes(_this17.haaid) && _this17.contractType === 'Hovedentreprise' || _this17.offerType === 'invitation' && _this17.submittedIndustries.includes(Number(res[0].JOB_INDUSTRY))) {} else {
            productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = {};
            productlistnotforpartnerArr[res[0].JOB_INDUSTRY] = enterpiserdata;
          }
        }
        _this17.productlistforpricearr = productlistforpricearr;
        _this17.productlistnotforpartnerArr = productlistnotforpartnerArr;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this17.productlistforpricearr).forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y[1]).forEach(function (o) {
            thisvar.industrypris[y[0] + '_' + o[0]] = 0;
            thisvar.productOfferForm[y[0] + '_' + o[0]] = 0;
            thisvar.createrules(y[0] + '_' + o[0]);
          });
        });
        if (_this17.$route.query.offerID) {
          _this17.offerID = _this17.$route.query.offerID;
          _this17.getAcceptedOfferPrice();
        }
        _this17.loading = false;
      }, function (response) {
        var error = response.body.message;
        _this17.$message({
          type: 'error',
          message: error
        });
      });
    },
    getProductListAiV4: function getProductListAiV4() {
      var _this18 = this;

      var prodid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062 ? this.parentID : this.$route.query.projectID : this.parentID;
      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this18.productlist = [];
        var productlistforpricearr = {};
        var productlistnotforpartnerArr = {};
        res.forEach(function (subproject, index) {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = subproject.INDUSTRY;
          enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
          enterpiserdata['wizardId'] = subproject.ID;
          enterpiserdata['subprojectId'] = _this18.childprojectObj[subproject.JOB_INDUSTRY];
          enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (!productlistforpricearr[subproject.INDUSTRY]) {
            if ((_this18.partnerenterprise === 'Hovedentreprise' && _this18.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this18.haaid) || _this18.offerType === 'invitation' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.contractType === 'Fagentreprise' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this18.submittedIndustries[0]) && _this18.contractType === 'Fagentreprise') {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            } else if (_this18.partnerenterprise === 'Hovedentreprise' && _this18.contractType === 'Hovedentreprise' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) && Number(subproject.JOB_INDUSTRY) === 1062 && _this18.submittedIndustries.length === 1) {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          } else {
            if ((_this18.partnerenterprise === 'Hovedentreprise' && _this18.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this18.haaid) || _this18.offerType === 'invitation' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.contractType === 'Fagentreprise' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this18.submittedIndustries[0]) && _this18.contractType === 'Fagentreprise') {
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              enterpiserdata['SERIES'] = subproject.SERIES;
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          }
        });
        if (_this18.contractType === 'Fagentreprise') {
          res.forEach(function (subproject, index) {
            var enterpiserdata = {};
            enterpiserdata['industryid'] = subproject.INDUSTRY;
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
            enterpiserdata['wizardId'] = subproject.ID;
            enterpiserdata['subprojectId'] = _this18.childprojectObj[subproject.JOB_INDUSTRY];
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
            enterpiserdata['industrydetails'] = {};
            if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
              if ((_this18.partnerenterprise === 'Hovedentreprise' && _this18.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this18.haaid) || _this18.offerType === 'invitation' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.contractType === 'Fagentreprise' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 || _this18.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this18.submittedIndustries[0]) && _this18.contractType === 'Fagentreprise') {} else {
                if (_this18.submittedIndustries.length === 1 && Number(_this18.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY] = {};
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            } else {
              if ((_this18.partnerenterprise === 'Hovedentreprise' && _this18.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this18.haaid) || _this18.offerType === 'invitation' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this18.contractType === 'Fagentreprise' && _this18.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 || _this18.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this18.submittedIndustries[0]) && _this18.contractType === 'Fagentreprise') {} else {
                if (_this18.submittedIndustries.length === 1 && Number(_this18.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            }
          });
        }
        _this18.productlistforpricearr = productlistforpricearr;
        _this18.productlistnotforpartnerArr = productlistnotforpartnerArr;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this18.productlistforpricearr).forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y[1]).forEach(function (o) {
            var newdesc = [];
            o[1].SERIES.forEach(function (p) {
              newdesc.push({ isediting: false, descr: p, newdesctext: '' });
            });
            o[1].SERIESARR = newdesc;
            thisvar.industrypris[y[0] + '_' + o[0]] = 0;
            thisvar.productOfferForm[y[0] + '_' + o[0]] = 0;
            thisvar.jobdescarr[y[0] + '_' + o[0]] = {
              submitted: {},
              updated: {},
              added: {},
              deleted: {}
            };
            thisvar.createrules(y[0] + '_' + o[0]);
          });
        });
        _this18.loading = false;
      }, function (response) {
        var error = response.body.message;
        _this18.$message({
          type: 'error',
          message: error
        });
      });
    },
    getProductListAiV5: function getProductListAiV5() {
      var _this19 = this;

      var prodid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && Number(this.submittedIndustries[0]) === 1062 ? this.parentID : this.$route.query.projectID : this.parentID;
      this.loading = true;
      var thisvar = this;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAiV2?project_id=' + prodid + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this19.productlist = [];
        var productlistforpricearr = {};
        var productlistnotforpartnerArr = {};
        res.forEach(function (subproject, index) {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = subproject.INDUSTRY;
          enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
          enterpiserdata['wizardId'] = subproject.ID;
          enterpiserdata['subprojectId'] = _this19.childprojectObj[subproject.JOB_INDUSTRY];
          enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
          enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
          enterpiserdata['industrydetails'] = {};
          if (!productlistforpricearr[subproject.INDUSTRY]) {
            if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            } else if (_this19.partnerenterprise === 'Hovedentreprise' && _this19.contractType === 'Hovedentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) && Number(subproject.JOB_INDUSTRY) === 1062 && _this19.submittedIndustries.length === 1) {
              enterpiserdata['SERIES'] = subproject.SERIES;
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              productlistforpricearr[subproject.INDUSTRY] = {};
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          } else {
            if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {
              thisvar.productlist.push(subproject.INDUSTRY + '-' + subproject.JOB_INDUSTRY);
              enterpiserdata['SERIES'] = subproject.SERIES;
              productlistforpricearr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
            }
          }
        });
        if (_this19.contractType === 'Fagentreprise') {
          res.forEach(function (subproject, index) {
            var enterpiserdata = {};
            enterpiserdata['industryid'] = subproject.INDUSTRY;
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
            enterpiserdata['wizardId'] = subproject.ID;
            enterpiserdata['subprojectId'] = _this19.childprojectObj[subproject.JOB_INDUSTRY];
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
            enterpiserdata['industrydetails'] = {};
            if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
              if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {} else {
                if (_this19.submittedIndustries.length === 1 && Number(_this19.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY] = {};
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            } else {
              if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {} else {
                if (_this19.submittedIndustries.length === 1 && Number(_this19.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            }
          });
        } else {
          res.forEach(function (subproject, index) {
            var enterpiserdata = {};
            enterpiserdata['industryid'] = subproject.INDUSTRY;
            enterpiserdata['jobindustry'] = subproject.JOB_INDUSTRY;
            enterpiserdata['wizardId'] = subproject.ID;
            enterpiserdata['subprojectId'] = _this19.childprojectObj[subproject.JOB_INDUSTRY];
            enterpiserdata['partnerIDS'] = subproject.PARTNER_IDS ? subproject.PARTNER_IDS : '';
            enterpiserdata['originalpartnerIDS'] = res[0].PARTNER_IDS ? res[0].PARTNER_IDS : '';
            enterpiserdata['industrydetails'] = {};
            if (!productlistnotforpartnerArr[subproject.INDUSTRY]) {
              if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {} else {
                if (_this19.submittedIndustries.length === 1 && Number(_this19.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY] = {};
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            } else {
              if ((_this19.contractType !== 'Fagentreprise' || enterpiserdata.partnerIDS.includes(_this19.haaid) || _this19.offerType === 'invitation' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.contractType === 'Fagentreprise' && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY)) && Number(subproject.JOB_INDUSTRY) !== 1062 && _this19.submittedIndustries.includes(subproject.JOB_INDUSTRY) || _this19.submittedIndustries.length === 1 && Number(subproject.JOB_INDUSTRY) === Number(_this19.submittedIndustries[0]) && _this19.contractType === 'Fagentreprise') {} else {
                if (_this19.submittedIndustries.length === 1 && Number(_this19.submittedIndustries[0]) === 1062) {} else {
                  productlistnotforpartnerArr[subproject.INDUSTRY][subproject.JOB_INDUSTRY] = enterpiserdata;
                }
              }
            }
          });
        }
        _this19.productlistforpricearr = productlistforpricearr;
        _this19.productlistnotforpartnerArr = productlistnotforpartnerArr;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this19.productlistforpricearr).forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y[1]).forEach(function (o) {
            if (o[1].SERIES) {
              var newdesc = [];
              o[1].SERIES.forEach(function (p) {
                newdesc.push({ isediting: false, descr: p, newdesctext: '' });
              });
              o[1].SERIESARR = newdesc;
              thisvar.industrypris[y[0] + '_' + o[0]] = 0;
              thisvar.productOfferForm[y[0] + '_' + o[0]] = 0;
              thisvar.jobdescarr[y[0] + '_' + o[0]] = {
                submitted: {},
                updated: {},
                added: {},
                deleted: {}
              };
              thisvar.createrules(y[0] + '_' + o[0]);
            }
          });
        });
        _this19.loading = false;
      }, function (response) {
        var error = response.body.message;
        _this19.$message({
          type: 'error',
          message: error
        });
      });
    },
    getsubprojectid: function getsubprojectid(jobindustryid) {
      this.childprojects.forEach(function (p) {
        if (p.JOB_INDUSTRY === Number(jobindustryid)) {
          return p.ID;
        }
      });
      return '';
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this20 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this20.itemsjobindustry = industryname;
        }
      }, function (response) {
        var error = response.body.message;
        _this20.$message({
          type: 'error',
          message: error
        });
      });
    },
    getBranchenamebyCode: function getBranchenamebyCode(code) {
      var branchename = [];
      branchename = this.mainwizarproductarr.filter(function (p) {
        return p.producttypeid === code;
      });
      if (branchename.length < 1) {
        return '';
      }
      return branchename[0]['producttype'];
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this21 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListIndustry', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this21.mainwizarproductarr = res;
        if (_this21.$route.query.offerID) {
          _this21.offerID = _this21.$route.query.offerID;
          _this21.getAcceptedOfferPricev2();
        } else {
          _this21.getProductListAiV5();
        }
      }, function (err) {
        var error = err.body.message;
        _this21.$message({
          type: 'error',
          message: error
        });
      });
    },
    getallwizardproduct_old: function getallwizardproduct_old() {
      var _this22 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this22.mainwizarproductarr = res;
        var productrelatedbyPartnerPrimaryIndustys = [];
        res.forEach(function (n) {
          if (n.industry === _this22.partnerprimaryindustry) {
            productrelatedbyPartnerPrimaryIndustys.push(n.industry);
          }
        });

        _this22.productrelatedbyPartnerPrimaryIndusty = productrelatedbyPartnerPrimaryIndustys;
        if (_this22.$route.query.offerID) {
          _this22.offerID = _this22.$route.query.offerID;
          _this22.getAcceptedOfferPricev2();
        } else {
          _this22.getProductListAiV5();
        }
      }, function (err) {
        var error = err.body.message;
        _this22.$message({
          type: 'error',
          message: error
        });
      });
    },
    getAcceptedOfferPrice: function getAcceptedOfferPrice() {
      var _this23 = this;

      var calculationid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinbolig?project_id=' + this.projectID + '&contact_id=' + this.contactID + '&calculation_id=' + calculationid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        var result = [];
        res.result.forEach(function (l) {
          if (l.PARTNER_ID === _this23.haaid && l.OFFER_ID === _this23.offerID) {
            for (var key in l.SERIES) {
              _this23.productOfferPerForm[_this23.productOfferFormEdit[key]] = l.SERIES[key];
            }
            _this23.daystofinish = l.WEEKS;
            _this23.datestart = l.START_DATE;
            result.push(l);
          }
        });
        _this23.editPriceArr = result;
      }, function (response) {
        _this23.loading = false;
        _this23.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getAcceptedOfferPricev2: function getAcceptedOfferPricev2() {
      var _this24 = this;

      var calculationid = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var projid = this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062' || this.contractType === 'Fagentreprise' ? this.parentID : this.projectID;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?project_id=' + projid + '&contact_id=' + this.contactID + '&calculation_id=' + calculationid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        var result = [];
        var productlistforpricearr = {};
        res.result.forEach(function (l) {
          if (l.PARTNER_ID === _this24.haaid && l.OFFER_ID === _this24.offerID) {
            var enterpiserdata = {};
            enterpiserdata['industryid'] = l.INDUSTRY;
            enterpiserdata['jobindustry'] = l.JOB_INDUSTRY;
            enterpiserdata['wizardId'] = 0;
            enterpiserdata['subprojectId'] = _this24.childprojectObj[l.JOB_INDUSTRY];
            enterpiserdata['partnerIDS'] = l.PARTNER_IDS ? l.PARTNER_IDS : '';

            enterpiserdata['industrydetails'] = {};
            enterpiserdata['pris'] = l.TOTAL;
            if (!productlistforpricearr[l.INDUSTRY]) {
              if (l.SERIES !== null) {
                enterpiserdata['SERIES'] = l.SERIES;
              } else {
                enterpiserdata['SERIES'] = l.SERIES_ORIGINAL;
              }
              _this24.productlist.push(l.INDUSTRY + '-' + l.JOB_INDUSTRY);
              productlistforpricearr[l.INDUSTRY] = {};
              productlistforpricearr[l.INDUSTRY][l.JOB_INDUSTRY] = enterpiserdata;
            } else {
              _this24.productlist.push(l.INDUSTRY + '-' + l.JOB_INDUSTRY);
              if (l.SERIES !== null) {
                enterpiserdata['SERIES'] = l.SERIES;
              } else {
                enterpiserdata['SERIES'] = l.SERIES_ORIGINAL;
              }
              productlistforpricearr[l.INDUSTRY][l.JOB_INDUSTRY] = enterpiserdata;
            }
            _this24.daystofinish = l.WEEKS;
            _this24.datestart = l.START_DATE;
            _this24.partnernote = l.NOTE;
            _this24.fiverecommendations = l.REVIEWS_ID;
            _this24.total += Number(l.TOTAL);
            result.push(l);
          }
        });
        _this24.productlistforpricearr = productlistforpricearr;
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(_this24.productlistforpricearr).forEach(function (y) {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(y[1]).forEach(function (o) {
            var newdesc = [];
            if (o[1].SERIES !== null) {
              __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(o[1].SERIES).forEach(function (p) {
                newdesc.push({ isediting: false, descr: p, newdesctext: '' });
              });
            } else {
              o[1].SERIES_ORIGINAL.forEach(function (p) {
                newdesc.push({ isediting: false, descr: p, newdesctext: '' });
              });
            }
            o[1].SERIESARR = newdesc;
            _this24.industrypris[y[0] + '_' + o[0]] = Number(o[1].pris);
            _this24.productOfferForm[y[0] + '_' + o[0]] = Number(o[1].pris);
            _this24.jobdescarr[y[0] + '_' + o[0]] = {
              submitted: {},
              updated: {},
              added: {},
              deleted: {}
            };
            _this24.createrules(y[0] + '_' + o[0]);
          });
        });
        _this24.loading = false;
      }, function (response) {
        _this24.loading = false;
        _this24.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getallrecommendations: function getallrecommendations() {
      var _this25 = this;

      var salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'anbefalinger', salesPerson: salesPerson, levid: this.haaid };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this25.$router.push('/login');
        }
        _this25.allrecommendatationsitems = res;
        var toprecords = [];
        var topfiverecords = [];
        toprecords = _this25.allrecommendatationsitems.filter(function (item) {
          return item.Rating > 3.9;
        });
        toprecords.sort(function (a, b) {
          return a - b;
        });
        topfiverecords = toprecords.slice(0, 5);

        _this25.fiverecommendations = topfiverecords.map(function (item, index) {
          return item.ReviewId;
        });
      }, function (response) {
        _this25.loading = false;
        _this25.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    checkifselected: function checkifselected(item) {
      if (this.fiverecommendations.includes(item)) {
        return true;
      } else {
        return false;
      }
    },
    assignfiverecommendations: function assignfiverecommendations(item) {
      this.fiverecommendations.push(item);
      if (this.fiverecommendations.includes(item)) {
        document.querySelector('div#box' + item).classList.add('reviewbox');
      }
      if (this.fiverecommendations.length === 5) {}
    },
    removethisrecommendation: function removethisrecommendation(item) {
      var idx = this.fiverecommendations.indexOf(item);
      if (idx > -1) {
        this.fiverecommendations.splice(idx, 1);
      }
      document.querySelector('div#box' + item).classList.remove('reviewbox');
    },
    createrules: function createrules(field) {
      this.productOfferFormRules[field] = [];
      var fieldrule = {};
      var errormessage = 'sæt venligst nummer';
      fieldrule = {
        type: 'number',
        min: 1,
        max: 99999999999,
        message: errormessage,
        trigger: 'blur'
      };
      this.productOfferFormRules[field].push(fieldrule);
    },
    computetotal_old: function computetotal_old(price, id, text, industryid, fieldindex, formindex) {
      var _this26 = this;

      var error = 0;
      this.$refs['productOfferForm'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      this.productOfferForm[industryid][id] = text;
      this.productOfferForm[industryid][fieldindex] = price;

      this.industrypris[industryid] = 0;
      for (var key in this.productOfferForm[industryid]) {
        if (key.includes('_') && this.productOfferForm[industryid] !== '') {
          this.industrypris[industryid] = parseInt(this.industrypris[industryid] + this.productOfferForm[industryid][key]);
        }
      }
      this.total = 0;
      var totalvalue = document.querySelectorAll('[role="spinbutton"]');
      totalvalue.forEach(function (p) {
        _this26.total += p.value !== '' ? Number(p.value) : 0;
      });
    },
    computetotal: function computetotal(price, priceindex) {
      var _this27 = this;

      var error = 0;
      this.$refs['productOfferForm'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }

      this.total = 0;
      var totalvalue = document.querySelectorAll('[role="spinbutton"]');
      totalvalue.forEach(function (p) {
        _this27.total += p.value !== '' ? Number(p.value) : 0;
      });
    },
    closesignature: function closesignature() {
      this.$refs['signaturepopup'].hide();
    },
    opentermpopup: function opentermpopup() {
      if (this.termslink === null) {
        this.TermsNewPopup = true;
      } else {
        this.termspopup = true;
      }
    },
    getTermsCondition: function getTermsCondition() {
      var _this28 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopupV2?COMPANY=' + this.haaid, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this28.termsdata = res;
        _this28.termslink = _this28.termsdata.LINK;
        _this28.termslabel = _this28.termsdata.LABEL;
        _this28.termspopupText = _this28.termsdata.HTML;
        var labelarroriginal = _this28.termsdata.LABEL.split(' ');
        var labelarr = _this28.termsdata.LABEL.split(' ');
        labelarr.pop();
        _this28.termslabel = labelarr.join(' ');
        _this28.termslinkablework = labelarroriginal[labelarroriginal.length - 1];
      }, function (response) {
        _this28.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    opensignature: function opensignature() {
      this.$refs['signaturepopup'].show();
      this.initiateSignaturepad();
    },
    openrequestmodal: function openrequestmodal(id) {
      this.selectedindustryforrequest = id;
      this.$refs['successrequest'].show();
    },
    closerequestmodal: function closerequestmodal() {
      this.$refs['successrequest'].hide();
    },
    clearSignature: function clearSignature() {
      var signature = this.signaturePad;
      signature.clear();
    },
    validateFirstTab: function validateFirstTab() {
      var haspriceeach = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_values___default()(this.productOfferForm);
      if (haspriceeach.includes(0) || haspriceeach.includes(undefined)) {
        this.$message({
          type: 'error',
          message: 'Ugyldigt beløb. Beløbet skal være over 0kr'
        });
        return false;
      }
      if (parseFloat(this.total * 1.25) < 1000) {
        this.$message.error('Samlet pris bør ikke være mindre end 1000 kr');
        return false;
      }
      return true;
    },
    validateSecondTab: function validateSecondTab() {
      if (this.daystofinish > 1500 || this.daystofinish === null) {
        this.$message({
          type: 'error',
          message: 'dette er begrænset til 1500 dage'
        });
        return false;
      }
      return true;
    },
    validatethirdTab: function validatethirdTab() {
      if (this.partnernote === '') {
        this.alertpartnernote = true;
        return false;
      }
      return true;
    },
    submitOffer: function submitOffer() {
      var signature = this.signaturePad;
      if (signature.isEmpty()) {
        this.$message.error('Underskriv venligst dit tilbud');
        return;
      }
      if (!this.confirmTerms) {
        this.$message.error('Bekræft venligst din tilbudsoversigt');
        return;
      }

      this.signaturePng = signature.toDataURL();

      if (this.$route.query.offerID) {
        this.updateOfferPrice();
      } else {
        this.addOffer();
      }
    },
    addtoanswers: function addtoanswers() {
      console.log('ss');
    },
    addOffereach: function addOffereach() {
      var issubprojectID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this29 = this;

      var subtotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var subprojID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      this.loading = true;
      var productionformarr = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(this.productOfferForm);
      var offertitle = '';
      for (var jobwithpriceObj in this.productOfferForm) {
        var jobindustry = '';
        var jobindistryprojectID = '';
        var jobwithpriceArr = [];
        var enterpriseId = '';
        jobwithpriceArr = jobwithpriceObj.split('_');
        jobindustry = jobwithpriceArr[1];
        enterpriseId = jobwithpriceArr[0];
        offertitle += this.mainwizarproductarr[enterpriseId] + '-' + this.itemsjobindustry[jobindustry] + ' ';
        jobindistryprojectID = this.childprojectObj[Number(jobindustry)];
        this.closesignature();
        var gettotal = this.productOfferForm[jobwithpriceObj];
        var projId = jobindistryprojectID;
        this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonbitrix
        };
        var data = {
          projectId: projId,
          offers: [{
            title: 'Tilbud på projektnr. ' + projId + ' til ' + offertitle,
            description: this.partnernote,
            subtotalPrice: gettotal,
            vat: parseFloat(gettotal * 0.25),
            totalPrice: parseFloat(gettotal * 1.25),
            tasks: this.rowbolig
          }],
          bookWizardPartner: {
            project_id: this.parentID,
            sub_project_id: jobindistryprojectID,
            contact_id: this.contactID,
            calculation_id: 0,
            industry_id: enterpriseId,
            total: gettotal,
            note: this.partnernote,
            signature: this.signaturePng,
            weeks: this.daystofinish,
            parent_offer_id: this.parentofferId,
            job_industry_id: jobindustry,
            start_date: this.datestart,
            reviews_id: this.fiverecommendations
          }
        };
        this.$http.post(this.$bitrixapi + 'partner/offer', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (jobwithpriceObj === productionformarr[productionformarr.length - 1]) {
            setTimeout(function () {
              var obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              };
              _this29.$refs.simplert.openSimplert(obj);
            }, 1000);
            setTimeout(function () {
              _this29.$router.push('/alle-moeder');
            }, 3000);
          }
        }, function (response) {
          var error = response.body.message;
          _this29.$message({
            type: 'error',
            message: error
          });
        });
      }
    },
    addOffer: function addOffer() {
      var issubprojectID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this30 = this;

      var subtotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var subprojID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      this.closesignature();
      this.loading = true;
      var offertitle = '';
      for (var jobwithpriceObj in this.productOfferForm) {
        var jobwithpriceArr = jobwithpriceObj.split('_');
        offertitle += this.mainwizarproductarr[jobwithpriceArr[0]] + '-' + this.itemsjobindustry[jobwithpriceArr[1]] + ' ';
      }
      var gettotal = this.total;
      var projId = this.$route.query.projectID;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        projectId: projId,
        offers: [{
          title: 'Tilbud på projektnr. ' + projId + ' til ' + offertitle,
          description: this.partnernote,
          subtotalPrice: gettotal,
          vat: parseFloat(gettotal * 0.25),
          totalPrice: parseFloat(gettotal * 1.25),
          tasks: this.rowbolig
        }]
      };
      if (this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062') {
        data.parentProjectId = this.parentID;
        data.jobIndustry = '1062';
      }
      this.$http.post(this.$bitrixapi + 'partner/offer', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.offer;

        _this30.parentofferId = res[0].ID;
        if (_this30.contractType === 'Fagentreprise') {
          _this30.saveProjectPricev3();
        } else {
          _this30.saveProjectPrice();
        }
      }, function (response) {
        _this30.loading = false;
        var error = response.body.message;
        _this30.$message({
          type: 'error',
          message: error
        });
      });
    },
    updateOfferPrice: function updateOfferPrice() {
      var issubprojectID = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      var _this31 = this;

      var subtotal = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var subprojID = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      this.closesignature();
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        total: Number(this.total * 1.25),
        subTotal: this.total,
        vat: Number(this.total * 0.25)
      };
      this.$http.put(this.$bitrixapi + 'partner/offer/' + this.offerID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this31.updatePriceList();
      }, function (response) {
        _this31.loading = false;
        var error = response.body.message;
        _this31.$message({
          type: 'error',
          message: error
        });
      });
    },
    requestToHomeowner: function requestToHomeowner(wizardid, jobindustry) {
      var _this32 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        wizardId: wizardid,
        projectId: this.projectID,
        contactId: this.contactID,
        jobIndustryId: Number(jobindustry),
        industry: this.partnerprimaryindustryText ? this.partnerprimaryindustryText : 'ukendt'
      };
      this.$http.post(this.$bitrixapi + 'partner/message/sendRequestOffer', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: 'Hvis boligejeren ønsker et tilbud fra dig, vil du få besked om dette.',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this32.$refs.simplert.openSimplert(obj);
      }, function (err) {
        var error = err.body.message;
        _this32.$message.error(error);
      });
    },
    limitdays: function limitdays() {
      if (this.daystofinish > 1500) {
        this.limitdayserror = true;
        return;
      }
      this.limitdayserror = false;
    }
  }
});

/***/ }),
/* 1312 */,
/* 1313 */,
/* 1314 */,
/* 1315 */,
/* 1316 */,
/* 1317 */,
/* 1318 */,
/* 1319 */,
/* 1320 */,
/* 1321 */,
/* 1322 */,
/* 1323 */,
/* 1324 */,
/* 1325 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"allofferproduct","clas":"mx4 my3 flex-column darkblue notosans xs-p0"}},[[(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(0)]):_c('div',{staticClass:"clearfix col-12 pr4 noto-sans darkblue xs-px3"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix mx-auto"},[_vm._m(2)]):_c('div',{staticClass:"col-12 pr4 xs-p0 m0"},[_c('form-wizard',{ref:"createofferwizard",attrs:{"id":"createofferwizard","title":"","subtitle":"","shape":"circle","color":"rgba(25, 163, 192, 1.0)","error-color":"rgba(207,0,15,1.0)","finishButtonText":"Bekræft"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"flex justify-end gap-10",attrs:{"id":"parentFooterButtons"}},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-standard-button h5 semi-bold m0 line-height-4 regular py1 px3",on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button next-button h5 semi-bold m0 line-height-4 regular py1 px3",on:{"click":function($event){!props.isLastStep ? props.nextTab() : _vm.opensignature()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(!props.isLastStep ? 'Næste' : 'Færdig'))])])])]}}])},[_c('tab-content',{attrs:{"title":"Trin 1","before-change":_vm.validateFirstTab}},[_c('div',[_c('el-collapse',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('el-collapse-item',{staticClass:"darkblue-background",attrs:{"title":"","name":"1"}},[_c('p',{staticClass:"h5 semi-bold px2 m0 ",attrs:{"slot":"title"},slot:"title"},[_vm._v("Tilbudsliste")]),_vm._v(" "),(Object.entries(_vm.productlistforpricearr).length < 1)?_c('div',{staticClass:"darkblue center mb3 mt4"},[_c('p',{staticClass:"m0 p0 "},[_vm._v("Ingen opgave er relateret til din primære branche "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.partnerprimaryindustryText))]),_vm._v(" for dette job, men du kan anmode nedenfor")])]):_c('div',[_c('div',{staticClass:"my3"},[_c('el-form',{ref:"productOfferForm",staticClass:" p0 m0 md-col-12 lg-col-12 sm-col-12 xd-col-12",attrs:{"model":_vm.productOfferForm,"rules":_vm.productOfferFormRules,"label-position":"top"}},_vm._l((Object.entries(_vm.productlistforpricearr)),function(industryfields,index){return _c('div',{key:industryfields[0],staticClass:"flex flex-column mb2 border border-left-0 border-top-0 border-right-0 muted-border pb2"},[_c('p',{staticClass:"m0 p0 h4 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '. ')+_vm._s(_vm.mainwizarproductarr[industryfields[0]]))]),_vm._v(" "),_vm._l((Object.entries(_vm.productlistforpricearr[industryfields[0]])),function(jobitem,index2){return _c('div',{key:index2,staticClass:"xs-mb2 q"},[_c('div',{staticClass:"flex items-center"},[_c('p',{staticClass:"m0 pl3 h4 xs-pl1 my1 primarycolor"},[_vm._v(_vm._s(parseInt(index + 1) + '.')+_vm._s(index2 + 1 + ' ')+" "+_vm._s(_vm.itemsjobindustry[jobitem[0]]))]),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-1 md-col-1 xs-col-5 sm-col-1 ml-auto "},[_c('el-form-item',{staticClass:"primarycolor-border m0",attrs:{"props":industryfields[0] + '_' + jobitem[0]}},[_c('el-input-number',{staticClass:"inputnumberamout white-background",attrs:{"id":industryfields[0] + '_' + jobitem[0],"placeholder":"pris"},on:{"change":function($event){return _vm.computetotal(_vm.productOfferForm[industryfields[0] + '_' + jobitem[0]], industryfields[0] + '_' + jobitem[0])}},model:{value:(_vm.productOfferForm[industryfields[0] + '_' + jobitem[0]]),callback:function ($$v) {_vm.$set(_vm.productOfferForm, industryfields[0] + '_' + jobitem[0], _vm._n($$v))},expression:"productOfferForm[industryfields[0] + '_' + jobitem[0]]"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-end col-12 p0 m0 mt2"},[_c('p',{staticClass:"p0 m0 pointer",on:{"click":function($event){return _vm.jobDescRestoreAll(industryfields[0], jobitem[0])}}},[_c('i',{staticClass:"el-icon-refresh-left primarycolor h5"}),_vm._v(" "),_c('span',{staticClass:"primarycolor"},[_vm._v("Gendan tekst")])])]),_vm._v(" "),_vm._l((jobitem[1].SERIESARR),function(itemfields,index3){return (itemfields.descr !== '')?_c('div',{key:index3,staticClass:"mt2"},[(!_vm.editdescfield)?_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12 mr-auto"},[_c('div',{staticClass:"m0 pl4 xs-pl2 flex items-start"},[_c('span',{},[_vm._v(_vm._s(parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)))]),_vm._v(" "),(itemfields.isediting)?_c('input',{directives:[{name:"model",rawName:"v-model",value:(itemfields.newdesctext),expression:"itemfields.newdesctext"}],staticClass:"sm-col-10 md-col-10 lg-col-11 xxl-col-11 px2 m0 ml1",domProps:{"value":(itemfields.newdesctext)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(itemfields, "newdesctext", $event.target.value)}}}):_c('div',{staticClass:"pl1 h6"},[_vm._v(_vm._s(itemfields.descr))]),_vm._v(" "),(itemfields.isediting)?_c('div',{staticClass:"flex justify-end ml-auto gap-15"},[_c('el-tooltip',{attrs:{"content":"Afbestille","placement":"top"}},[_c('button',{staticClass:"transparent m0 border-0 p0",attrs:{"type":"button"},on:{"click":function($event){return _vm.jobDescCanceledit(industryfields[0], jobitem[0], index3)}}},[_c('i',{staticClass:"el-icon-close primarycolor h3"})])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Gemme","placement":"top"}},[_c('button',{staticClass:"transparent m0 border-0 p0",attrs:{"type":"button"},on:{"click":function($event){return _vm.jobDescAddandEdit(industryfields[0], jobitem[0], index3)}}},[_c('i',{staticClass:"el-icon-check primarycolor h3"})])])],1):_c('div',{staticClass:"flex justify-end ml-auto gap-15",staticStyle:{"height":"24px"}},[_c('el-tooltip',{attrs:{"content":"Redigere","placement":"top"}},[_c('button',{staticClass:"transparent border-0 m0 p0",attrs:{"type":"button"},on:{"click":function($event){return _vm.jobDescEdit(industryfields[0], jobitem[0], index3)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"23.769","height":"24.001","viewBox":"0 0 28.769 29.001"}},[_c('g',{attrs:{"id":"Icon_feather-edit","data-name":"Icon feather-edit","transform":"translate(1 1.232)"}},[_c('path',{attrs:{"id":"Path_4220","data-name":"Path 4220","d":"M14.973,6H5.661A2.661,2.661,0,0,0,3,8.661V27.286a2.661,2.661,0,0,0,2.661,2.661H24.286a2.661,2.661,0,0,0,2.661-2.661V17.973","transform":"translate(-3 -3.178)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4221","data-name":"Path 4221","d":"M25.969,3.645A2.822,2.822,0,0,1,29.96,7.636L17.322,20.274,12,21.6l1.33-5.322Z","transform":"translate(-4.018 -2.818)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Slet","placement":"top"}},[_c('button',{staticClass:"transparent border-0 m0 p0",attrs:{"type":"button"},on:{"click":function($event){return _vm.jobDescDelete(industryfields[0], jobitem[0], index3)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"20.947","height":"23.608","viewBox":"0 0 25.947 28.608"}},[_c('g',{attrs:{"id":"Icon_feather-trash-2","data-name":"Icon feather-trash-2","transform":"translate(1 1)"}},[_c('path',{attrs:{"id":"Path_4222","data-name":"Path 4222","d":"M4.5,9H28.447","transform":"translate(-4.5 -3.678)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4223","data-name":"Path 4223","d":"M26.125,8.322V26.947a2.661,2.661,0,0,1-2.661,2.661h-13.3A2.661,2.661,0,0,1,7.5,26.947V8.322m3.991,0V5.661A2.661,2.661,0,0,1,14.152,3h5.322a2.661,2.661,0,0,1,2.661,2.661V8.322","transform":"translate(-4.839 -3)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4224","data-name":"Path 4224","d":"M15,16.5v7.982","transform":"translate(-5.687 -4.527)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4225","data-name":"Path 4225","d":"M21,16.5v7.982","transform":"translate(-6.366 -4.527)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])],1)])]):_vm._e()]):_vm._e()}),_vm._v(" "),(!_vm.hideplusbutton)?_c('div',{staticClass:"md-col-7 lg-col-7 xxl-col-6 sm-col-7 xs-col-8 flex justify-end items-center p0 m0 mt2 ml-auto "},[_c('p',{staticClass:"p0 m0 flex items-center gap-15",on:{"click":function($event){return _vm.jobDescAddlineDesc(industryfields[0], jobitem[0])}}},[_c('span',[_c('svg',{staticClass:"feather feather-plus-circle",attrs:{"svg":"","xmlns":"http://www.w3.org/2000/svg","width":"28","height":"28","viewBox":"0 0 24 24","fill":"#ffff","stroke":"#19a3c0","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"12","cy":"12","r":"10"}}),_c('line',{attrs:{"x1":"12","y1":"8","x2":"12","y2":"16"}}),_c('line',{attrs:{"x1":"8","y1":"12","x2":"16","y2":"12"}})])]),_vm._v(" "),_c('span',{staticClass:"h5 primarycolor"},[_vm._v("Tilføj beskrivelse")])])]):_vm._e()],2)})],2)}),0)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 px0 mx-auto my3 pl2"},[_c('div',{staticClass:"h6 flex my1 p0 col-12",attrs:{"div":""}},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Samlet pris ekskl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(_vm.total.toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12",attrs:{"div":""}},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("25% moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(parseFloat(_vm.total * .25).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 col-4"},[_vm._v("Samlet pris inkl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(_vm.total * 1.25)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])])])]),_vm._v(" "),(Object.entries(_vm.productlistnotforpartnerArr).length > 0)?_c('el-collapse-item',{attrs:{"title":"","name":"2"}},[_c('p',{staticClass:"h5 semi-bold px2 m0 ",attrs:{"slot":"title"},slot:"title"},[_vm._v("Se andre entrepriser")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column darkblue mt2"},_vm._l((Object.entries(_vm.productlistnotforpartnerArr)),function(item,index){return (Object.entries(_vm.productlistnotforpartnerArr[item[0]]).length > 0 && _vm.contractType === 'Fagentreprise')?_c('div',{key:index,staticClass:"m0 flex flex-column my1"},[_c('p',{staticClass:"m0 py0 h6 my1 flex items-center semi-bold"},[_vm._v(_vm._s(_vm.mainwizarproductarr[item[0]]))]),_vm._v(" "),_vm._l((_vm.productlistnotforpartnerArr[item[0]]),function(jobindu,index2){return _c('div',{key:index2,staticClass:"flex flex-row mt1"},[_c('div',{staticClass:"muted-background onmobilexd flex justify-start lg-col-9 sm-col-12 xs-col-12 m0 p0 xs-py1"},[_c('p',{staticClass:"m0 px3 py0 h6 my1 flex items-center semi-bold"},[_vm._v(_vm._s(_vm.itemsjobindustry[jobindu.jobindustry]))]),_vm._v(" "),_c('span',{staticClass:"md-hide lg-hide xxl-hide ml-auto px3",on:{"click":function($event){return _vm.requestToHomeowner(jobindu.wizardId, jobindu.jobindustry)}}},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"28.918","viewBox":"0 0 26 28.918"}},[_c('g',{attrs:{"id":"lock_ic","transform":"translate(-2.227 -1)"}},[_c('rect',{attrs:{"id":"Rectangle_1355","data-name":"Rectangle 1355","width":"24","height":"15","rx":"2","transform":"translate(3.227 13.918)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4023","data-name":"Path 4023","d":"M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384","transform":"translate(1.384 0)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])]),_vm._v(" "),_c('div',{staticClass:"darkblue-background py1 px2 flex justify-center item-center ml-auto ml1 col-3 pointer xs-hide",on:{"click":function($event){return _vm.requestToHomeowner(jobindu.wizardId, jobindu.jobindustry)}}},[_c('span',{staticClass:"white"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"28.918","viewBox":"0 0 26 28.918"}},[_c('g',{attrs:{"id":"lock_ic","transform":"translate(-2.227 -1)"}},[_c('rect',{attrs:{"id":"Rectangle_1355","data-name":"Rectangle 1355","width":"24","height":"15","rx":"2","transform":"translate(3.227 13.918)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4023","data-name":"Path 4023","d":"M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384","transform":"translate(1.384 0)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])]),_vm._v(" "),_c('span',{staticClass:"white regular h6 m0 flex items-center  pl1"},[_vm._v("Anmod om at afgive tilbud")])])])})],2):_c('div',_vm._l((Object.entries(_vm.productlistnotforpartnerArr)),function(jobindu,index2){return _c('div',{key:index2},_vm._l((_vm.productlistnotforpartnerArr[item[0]]),function(jobindus,index23){return _c('div',{key:index23,staticClass:"flex flex-row mt1"},[_c('div',{staticClass:"muted-background onmobilexd flex justify-start lg-col-9 sm-col-12 xs-col-12 m0 p0 xs-py1"},[_c('p',{staticClass:"m0 px3 py0 h6 my1 flex items-center semi-bold"},[_vm._v(_vm._s(_vm.itemsjobindustry[jobindus.jobindustry]))]),_vm._v(" "),_c('span',{staticClass:"md-hide lg-hide xxl-hide ml-auto px3",on:{"click":function($event){return _vm.requestToHomeowner(jobindus.wizardId, jobindus.jobindustry)}}},[_c('svg',{staticClass:"primarycolor-fill",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"28.918","viewBox":"0 0 26 28.918"}},[_c('g',{attrs:{"id":"lock_ic","transform":"translate(-2.227 -1)"}},[_c('rect',{attrs:{"id":"Rectangle_1355","data-name":"Rectangle 1355","width":"24","height":"15","rx":"2","transform":"translate(3.227 13.918)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4023","data-name":"Path 4023","d":"M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384","transform":"translate(1.384 0)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])]),_vm._v(" "),_c('div',{staticClass:"darkblue-background py1 px2 flex justify-center item-center ml-auto ml1 col-3 pointer xs-hide",on:{"click":function($event){return _vm.requestToHomeowner(jobindus.wizardId, jobindus.jobindustry)}}},[_c('span',{staticClass:"white"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"26","height":"28.918","viewBox":"0 0 26 28.918"}},[_c('g',{attrs:{"id":"lock_ic","transform":"translate(-2.227 -1)"}},[_c('rect',{attrs:{"id":"Rectangle_1355","data-name":"Rectangle 1355","width":"24","height":"15","rx":"2","transform":"translate(3.227 13.918)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4023","data-name":"Path 4023","d":"M7,14.113V8.73a6.73,6.73,0,0,1,13.459,0v5.384","transform":"translate(1.384 0)","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])]),_vm._v(" "),_c('span',{staticClass:"white regular h6 m0 flex items-center  pl1"},[_vm._v("Anmod om at afgive tilbud")])])])}),0)}),0)}),0)]):_vm._e()],1)],1)]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Trin 2","before-change":_vm.validateSecondTab}},[_c('div',{staticClass:"flex flex-column mb2 col-12 mx-auto p0"},[_c('div',{staticClass:"m0 p0 pl2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6 mr-auto",attrs:{"div":""}},[_c('p',[_vm._v("Hvor lang tid estimerer du, at projektet tager?")])]),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-5 md-col-5 xs-col-12 sm-col-5"},[_c('el-input',{staticClass:"daystofinish white-background",attrs:{"type":"number","placeholder":"Antal dage til at afslutte jobbet"},on:{"input":function($event){return _vm.limitdays()}},model:{value:(_vm.daystofinish),callback:function ($$v) {_vm.daystofinish=$$v},expression:"daystofinish"}})],1),_vm._v(" "),(_vm.limitdayserror)?_c('el-alert',{attrs:{"title":"dette er begrænset til 1500 dage","type":"error","closable":false,"show-icon":""}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb2 col-12 mx-auto p0"},[_c('div',{staticClass:"m0 p0 pl2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6 mr-auto",attrs:{"div":""}},[_c('p',[_vm._v("Hvilken dato kan du starte på projektet?")])]),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-5 md-col-5 xs-col-12 sm-col-5"},[_c('el-date-picker',{staticClass:" white-background",attrs:{"type":"datetime","picker-options":_vm.pickerOptions,"format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","placeholder":"Startdato for jobbet"},model:{value:(_vm.datestart),callback:function ($$v) {_vm.datestart=$$v},expression:"datestart"}})],1)])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Trin 3","before-change":_vm.validatethirdTab}},[_c('div',{staticClass:"my2 col-12 mx-auto"},[_c('span',[_c('el-checkbox',{model:{value:(_vm.savenote),callback:function ($$v) {_vm.savenote=$$v},expression:"savenote"}},[_vm._v("Gem Som Standardtekst")])],1),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 4, maxRows: 6},"placeholder":"Tilføj evt. forbehold eller særlige betingelser for dit tilbud"},on:{"change":function($event){_vm.alertpartnernote = false}},model:{value:(_vm.partnernote),callback:function ($$v) {_vm.partnernote=$$v},expression:"partnernote"}}),_vm._v(" "),(_vm.alertpartnernote)?_c('el-alert',{staticClass:"line-height-1 mt1 col-12",attrs:{"title":"Skriv venligst dine tilbudsbemærkninger i dette felt","type":"error","effect":"light","show-icon":"","closable":false}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"my2 col-12 mx-auto pointer flex items-center gap-10"},[_c('p',{staticClass:"m0 underline primarycolor",on:{"click":function($event){_vm.reviewsmodal = true}}},[_c('i',{staticClass:"el-icon-circle-plus-outline primarycolor"}),_vm._v("Tilføj din anbefaling")]),_vm._v(" "),_c('i',{staticClass:"el-icon-question",on:{"click":function($event){_vm.reviewtext = true}}})])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"Trin 4"}},[_c('div',[_c('p',{staticClass:"h3 semi-bold"},[_vm._v("Opsummering")]),_vm._v(" "),_c('div',{staticClass:"p0 m0 md-col-12 lg-col-12 sm-col-12 xd-col-12"},[_vm._l((Object.entries(_vm.productlistforpricearr)),function(industryfields,index){return _c('div',{key:industryfields[0],staticClass:"flex flex-column mb2 border border-left-0 border-top-0 border-right-0 muted-border pb2"},[_c('p',{staticClass:"m0 p0 h4 my1"},[_vm._v(_vm._s(parseInt(index + 1) + '. ')+_vm._s(_vm.mainwizarproductarr[industryfields[0]]))]),_vm._v(" "),_vm._l((Object.entries(_vm.productlistforpricearr[industryfields[0]])),function(jobitem,index2){return _c('div',{key:index2,staticClass:"xs-mb2 q"},[_c('div',{staticClass:"flex items-center col-12"},[_c('p',{staticClass:"m0 pl3 h4 xs-pl1 my1 primarycolor"},[_vm._v(_vm._s(parseInt(index + 1) + '.')+_vm._s(index2 + 1 + ' ')+" "+_vm._s(_vm.itemsjobindustry[jobitem[0]]))]),_vm._v(" "),_c('p',{staticClass:"m0 p0 ml-auto "},[_vm._v(_vm._s((parseFloat(_vm.productOfferForm[industryfields[0] + '_' + jobitem[0]])).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_vm._l((jobitem[1].SERIESARR),function(itemfields,index3){return (itemfields.descr !== '')?_c('div',{key:index3,staticClass:"mt1"},[(!_vm.editdescfield)?_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 xs-col-12 sm-col-12 mr-auto"},[_c('div',{staticClass:"m0 pl4 xs-pl2 flex items-start"},[_c('span',{},[_vm._v(_vm._s(parseInt(index + 1) + '.' + parseInt(index2 + 1) + '.' + parseInt(index3 + 1)))]),_vm._v(" "),_c('div',{staticClass:"pl1 h6"},[_vm._v(_vm._s(itemfields.descr))])])]):_vm._e()]):_vm._e()})],2)})],2)}),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 px0 mx-auto my3 border border-left-0 border-top-0 border-right-0 muted-border mb2"},[_c('div',{staticClass:"h6 flex my1 p0 col-12",attrs:{"div":""}},[_c('p',{staticClass:"m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8"},[_vm._v("Samlet pris ekskl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(_vm.total.toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12",attrs:{"div":""}},[_c('p',{staticClass:"m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8"},[_vm._v("25% moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s(parseFloat(_vm.total * .25).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"h6 flex my1 p0 col-12"},[_c('p',{staticClass:"m0 p0 lg-col-4 sm-col-4 md-col-4 xs-col-8"},[_vm._v("Samlet pris inkl. moms")]),_c('p',{staticClass:"m0 p0 col-8 flex justify-end"},[_vm._v(_vm._s((parseFloat(_vm.total * 1.25)).toLocaleString('da-DK', {style: 'currency', currency: 'DKK',maximumFractionDigits:0})))])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column border border-left-0 border-top-0 border-right-0 muted-border"},[_c('div',{staticClass:"flex mt2 col-12 mx-auto p0 "},[_c('div',{staticClass:"m0 p0",attrs:{"div":""}},[_c('p',[_vm._v("Hvor lang tid estimerer du, at projektet tager?")])]),_vm._v(" "),_c('div',{staticClass:"m0 p0 ml-auto"},[_c('p',[_vm._v(_vm._s(_vm.daystofinish)+" Days")])])]),_vm._v(" "),_c('div',{staticClass:"flex my1 col-12 mx-auto p0"},[_c('div',{staticClass:"m0 p0 ",attrs:{"div":""}},[_c('p',[_vm._v("Hvilken dato kan du starte på projektet?")])]),_vm._v(" "),_c('div',{staticClass:"m0 p0 ml-auto"},[_c('p',[_vm._v(_vm._s(_vm.moment(_vm.datestart).locale('da').format('LL')))])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mt1 m0 p0 flex flex-column py2"},[_c('p',{staticClass:"h5 p0 m0 regular grey mb1 "},[_vm._v("Standard tekst")]),_vm._v(" "),_c('p',{staticClass:"m0 p0"},[_vm._v(_vm._s(_vm.partnernote))])])],2)])])],1)],1),_vm._v(" "),_c('div',{staticClass:"py3 lg-hide md-hide xxl-hide"})])],_vm._v(" "),_c('b-modal',{ref:"signaturepopup",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"signaturepopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closesignature()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative overflow-hidden",staticStyle:{"height":"95%"}},[_c('div',{staticClass:"flex col-12 p0"},[_c('p',{staticClass:"darkblue"},[_vm._v("Underskriv her")]),_vm._v(" "),_c('p',{staticClass:"white-backgroud px2 ml-auto red h6",on:{"click":function($event){return _vm.clearSignature()}}},[_c('i',{staticClass:"el-icon-close"}),_vm._v(" Ryd")])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0 border muted-border mx-auto",attrs:{"id":"signature-control"}},[_c('div',{staticClass:"signature-pad col-12 p0 height-full",attrs:{"id":"signature-pad"}},[_c('div',{staticClass:"signature-pad--body"},[_c('canvas',{staticStyle:{"touch-action":"none","user-select":"none"},attrs:{"width":"460","height":"290"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0 flex items-center mt2"},[_c('p',{staticClass:"mr-auto p0 py2 m0 h6 flex"},[_c('el-checkbox',{staticClass:"saveSignature",model:{value:(_vm.confirmTerms),callback:function ($$v) {_vm.confirmTerms=$$v},expression:"confirmTerms"}},[_c('span',{staticClass:"pointer"},[_vm._v(_vm._s(_vm.termslabel))])]),_c('span',{staticClass:"primarycolor semi-bold pl1 pointer",on:{"click":function($event){return _vm.opentermpopup()}}},[_vm._v(_vm._s(_vm.termslinkablework))])],1),_vm._v(" "),_c('button',{staticClass:" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button","disabled":!_vm.confirmTerms},on:{"click":function($event){return _vm.submitOffer()}}},[_vm._v("\n        Færdig! Send tilbud\n      ")])])]),_vm._v(" "),_c('b-modal',{ref:"successrequest",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"successrequest"}},[_c('div',{staticClass:"col-12 flex justify-start items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closerequestmodal()}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})])])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('p',{staticClass:"my2 darkblue mx-auto"},[_c('img',{attrs:{"src":"/static/gif/req_offer.gif","alt":"Submit Request"}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('button',{staticClass:"regular p2 px3 action-button center white",on:{"click":function($event){return _vm.requestToHomeowner(_vm.selectedindustryforrequest)}}},[_vm._v(" Anmod om at afgive tilbud")])])]),_vm._v(" "),_c('b-modal',{ref:"reviewsmodal",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"reviewsmodal","size":"lg"},model:{value:(_vm.reviewsmodal),callback:function ($$v) {_vm.reviewsmodal=$$v},expression:"reviewsmodal"}},[_c('div',{staticClass:"col-12 flex justify-start items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.reviewsmodal = false}}},[_c('span',[_c('i',{staticClass:"el-icon-back"})])])]),_vm._v(" "),_c('div',{staticClass:"darkblue"},[_c('p',{},[_vm._v("Vælg maks. 5 anmeldelser nedenfor for at inkludere dette i dit tilbud")])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background "},[_c('div',{staticClass:"col-12 mx0 px0 flex flex-wrap justify-around "},_vm._l((_vm.allrecommendatationsitems),function(review){return _c('div',{key:review.id,staticClass:"reviewsoffer mb2 shadow p2",class:_vm.fiverecommendations.includes(review.ReviewId) ? 'reviewbox' : null,attrs:{"id":'box' + review.ReviewId}},[_c('div',{staticClass:"flex justify-between items-center"},[_c('div',{staticClass:"flex col-12 p0"},[_c('div',{staticClass:"flex flex-column mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":17,"spacing":1,"show-rating":false,"read-only":true},model:{value:(review.Rating),callback:function ($$v) {_vm.$set(review, "Rating", $$v)},expression:"review.Rating"}})],1),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[(review.AssignmentDistributedCount === 1)?_c('span',{staticClass:"green"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])]):_c('span',{staticClass:"mediumgrey"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"mb3 xs-mb1"},[_c('p',{staticClass:"h6 darkblue mb0 relative"},[_vm._v(_vm._s(_vm.moment(review.RatedDate).format('ll')))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 p0"},[_c('div',{},[_c('p',{staticClass:"m0 small"},[_vm._v("Overskrift")]),_vm._v(" "),_c('p',{staticClass:"m0",staticStyle:{"height":"39px"}},[_vm._v(_vm._s(review.Headline))])]),_vm._v(" "),_c('el-collapse',{staticClass:"border-none"},[_c('el-collapse-item',{attrs:{"title":"Kommentar","name":review.id}},[_c('p',{staticClass:"h6 gibson mediumgrey break-word"},[_vm._v(_vm._s(review.Comment))])])],1)],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue semi-bold my2 line-height-golden"},[_vm._v(_vm._s(review.RatedBy))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-row col-12 xs-p0"},[(_vm.fiverecommendations.includes(review.ReviewId))?_c('button',{staticClass:"ml-auto p2 px2 gibson dark-button z4 not-rounded flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.removethisrecommendation(review.ReviewId)}}},[_c('i',{staticClass:"el-icon-minus"}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 left-align pl1"},[_vm._v("Fjern dette")])]):_vm._e(),_vm._v(" "),(!_vm.fiverecommendations.includes(review.ReviewId) && _vm.fiverecommendations.length <= 4)?_c('button',{staticClass:"ml-auto p2 px2 gibson z4 dark-button not-rounded flex justify-center items-center",attrs:{"type":"button","id":"addthisreview"},on:{"click":function($event){return _vm.assignfiverecommendations(review.ReviewId)}}},[_c('i',{staticClass:"el-icon-plus"}),_vm._v(" "),_c('span',{staticClass:"h6 mb0 left-align pl1"},[_vm._v("Tilføj dette")])]):_vm._e()])])}),0)]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py1 mx"},[_c('button',{staticClass:"regular p2 px3 action-button center white",on:{"click":function($event){return _vm.addtoanswers()}}},[_vm._v(" Tilføje")])])]),_vm._v(" "),_c('b-modal',{ref:"termspopup",attrs:{"centered":"","hide-header":"","size":"lg","hide-footer":"","id":"termspopup"},model:{value:(_vm.termspopup),callback:function ($$v) {_vm.termspopup=$$v},expression:"termspopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.termspopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":_vm.termslink,"frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"reviewtext",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"reviewtext"},model:{value:(_vm.reviewtext),callback:function ($$v) {_vm.reviewtext=$$v},expression:"reviewtext"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.reviewtext = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py2 mb2"},[_c('p',{staticClass:"m0 h5 center darkblue"},[_vm._v("Tilføj op til "+_vm._s(_vm.fiverecommendations.length + ' udvalgte anbefalinger, så kunden kan se, hvad andre har sagt om dig og dit arbejde'))])])]),_vm._v(" "),_c('b-modal',{ref:"TermsNewPopup",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"TermsNewPopup","size":"large"},model:{value:(_vm.TermsNewPopup),callback:function ($$v) {_vm.TermsNewPopup=$$v},expression:"TermsNewPopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.TermsNewPopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py2 mb2"},[_c('div',{staticClass:"m0 h6 darkblue px3",domProps:{"innerHTML":_vm._s(_vm.termspopupText)}})])]),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 "},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h3 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                Opret tilbud\n              ")])]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden my1"},[_vm._v("\n              Send tilbud til kunden:\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1326 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MesterArbejdskraft_vue__ = __webpack_require__(1328);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f371c82_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MesterArbejdskraft_vue__ = __webpack_require__(1329);
function injectStyle (ssrContext) {
  __webpack_require__(1327)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MesterArbejdskraft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f371c82_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MesterArbejdskraft_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1327 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1328 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__ = __webpack_require__(43);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mester',
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      laborAmount: 3,
      show: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      expectedLabor: 3,
      expectedBids: 3,
      startDate: '',
      status: '',
      shorturl: '',
      endDate: '',
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: false,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      opgaveoptions: [],
      images: [],
      jobs: [],
      validationErrors: {
        opgave1: null,
        subopgave1: null,
        numofman1: null,
        postnumber1: null,
        startdate1: null,
        duration1: null,
        timepris1: null,
        desc1: null,
        opgave2: null,
        numofman2: null,
        postnumber2: null,
        startdate2: null,
        timepris2: null,
        desc2: null
      },
      opgave2: '',
      offer2: '3',
      numofman2: '',
      postnumber2: '',
      startdate2: '',
      timepris2: '',
      desc2: '',
      toolsIncluded: '',
      vehicleIncluded: ''
    };
  },

  computed: {},
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_1__haandvaerker__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_6_vue2_dropzone___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_5_vue_select___default.a,

    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_4_vue_bootstrap_datetimepicker___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__["a" /* default */]
  },
  created: function created() {
    this.eligible = localStorage.getItem('PartnerloginMesterMesterPost');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },

  methods: {
    getdataigibility: function getdataigibility() {
      var clicktype = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'yes';

      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerloginMesterMesterPost');
      } else {
        if (clicktype === 'yes') {
          this.onSubmit();
        }
      }
    },
    onSubmit: function onSubmit() {
      var _this2 = this;

      if (this.validateForm2()) {
        this.show = true;
        this.salesPerson = localStorage.getItem('id_token_portal');
        var dataPartner = { opgave2: this.opgave2.value, numofman2: this.numofman2, offer2: this.offer2, postnumber2: this.postnumber2, startdate2: this.startdate2, timepris2: this.timepris2, desc2: this.desc2, images: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.images) };
        this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savepartnerotherjob&json=no&short=' + this.shorturl, dataPartner, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          _this2.show = false;
          _this2.loading = false;
          if (res.login === false) {
            _this2.$router.push('/login');
          }
          if (res.success) {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this2.$refs.simplert.openSimplert(obj);
            _this2.success = true;
            _this2.opgave2 = '';
            _this2.numofman2 = '';
            _this2.postnumber2 = '';
            _this2.startdate2 = '';
            _this2.timepris2 = '';
            _this2.desc2 = '';
            document.getElementById('setKarft').click();
            _this2.Reload();
          } else {
            _this2.show = false;
            alert(res.message);
          }
        }, function (response) {
          alert('error');
        });
      }
    },
    aflysePerson: function aflysePerson(id) {
      var confirmFn = function confirmFn() {
        this.$parent.aflyseconfirm_person(id);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne arbejdskraft ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    aflyseconfirm_person: function aflyseconfirm_person(id) {
      var _this3 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'aflyseconfirm_person', salesPerson: this.salesPerson, personid: id };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.show = false;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        if (res.success) {
          _this3.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this3.$refs.simplert.openSimplert(obj);
          _this3.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    OpenUrl: function OpenUrl(url) {
      this.$router.push(url);
      this.$refs.findworkModal.hide();
    },
    validateForm2: function validateForm2() {
      var success = true;
      if (this.opgave2 === '') {
        this.validationErrors.opgave2 = true;
        success = false;
      }
      if (this.numofman2 === '') {
        this.validationErrors.numofman2 = true;
        success = false;
      }
      if (this.postnumber2 === '') {
        this.validationErrors.postnumber2 = true;
        success = false;
      }
      if (this.startdate2 === '') {
        this.validationErrors.startdate2 = true;
        success = false;
      }
      if (this.timepris2 === '') {
        this.validationErrors.timepris2 = true;
        success = false;
      }
      if (this.desc2 === '') {
        this.validationErrors.desc2 = true;
        success = false;
      }
      return success;
    },
    updateValue: function updateValue(event) {
      var value = event.target.value;
      console.log(value, this.laborAmount);
      if (String(value).length <= 10) {
        this.laborAmount = value;
      }
      this.$forceUpdate();
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImagesMester');
    },

    'showSuccess': function showSuccess(file) {
      this.images.push(file.xhr.response);
    },
    hideModal: function hideModal() {
      this.$refs.reviewModal.hide();
    },
    hideLaborModal: function hideLaborModal() {
      this.$refs.reviewLaborForm.hide();
    },
    delete_image: function delete_image(image) {
      var index = this.images.indexOf(image);
      if (index > -1) {
        this.images.splice(index, 1);
      }
    },
    Reload: function Reload() {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_profil_mester', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        _this4.show = false;
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        _this4.opgaveoptions = res.productmesterjob;
        _this4.shorturl = res.urlshort;
        _this4.jobs = res.job;
      }, function (response) {
        _this4.show = false;
        alert('error');
      });
    },
    readMore: function readMore() {
      var dots = document.getElementById('dots');
      var moreText = document.getElementById('more');
      var btnText = document.getElementById('btnText');
      var moreIcon = document.getElementById('moreIcon');
      var lessIcon = document.getElementById('lessIcon');
      if (dots.style.display === 'none') {
        dots.style.display = 'inline';
        btnText.innerHTML = 'Læs mere';
        moreText.style.display = 'none';
        moreIcon.style.display = 'inline';
        lessIcon.style.display = 'none';
      } else {
        dots.style.display = 'none';
        btnText.innerHTML = 'Luk';
        moreText.style.display = 'block';
        moreIcon.style.display = 'none';
        lessIcon.style.display = 'inline';
      }
    }
  }
});

/***/ }),
/* 1329 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt3 pb4 mb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 py3 mb2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h3 semi-bold line-height-2 my2 gibson darkblue"},[_vm._v("For få opgaver?")]),_vm._v(" "),_c('p',{staticClass:"h4 gibson line-height-3 darkblue regular"},[_vm._v("– Stil din arbejdskraft til rådighed")]),_vm._v(" "),_c('ul',{staticClass:"list-reset pl0 ml0 mt3"},[_c('li',{staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"mr2"},[_c('b-img',{attrs:{"width":"16","src":"static/img/sky-blue-checkmark.png"}})],1),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 my1 darkblue regular"},[_vm._v("Udlån overskydende arbejdskraft")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"mr2"},[_c('b-img',{attrs:{"width":"16","src":"static/img/sky-blue-checkmark.png"}})],1),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 my1 darkblue regular"},[_vm._v("Optimèr økonomien")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"mr2"},[_c('b-img',{attrs:{"width":"16","src":"static/img/sky-blue-checkmark.png"}})],1),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 my1 darkblue regular"},[_vm._v("Bevar virksomhedens arbejdsstyrke")])])]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"moreBtn"},on:{"click":function($event){return _vm.readMore()}}},[_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 gibson outlined-dark-button not-rounded flex justify-center items-center hide"},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed ml2"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened ml2"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"m2m"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-end items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByStatus","name":"sortByStatus","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Kunder")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWork","name":"sortByHaveWork","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Ledige arbejdskraft")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Extra opgaver")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 gibson not-rounded"},[_c('span',{staticClass:"h6 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between items-center mt4 mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.createItem",modifiers:{"createItem":true}}],staticClass:"p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"setKarft"}},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Opslå ledig arbejdskraft")]),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('button',{staticClass:"p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"seeAvailableJobs"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads?mode=job')}}},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Se ledig arbejdskraft")]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),(_vm.success)?_c('div',[_c('b-alert',{attrs:{"show":""}},[_c('p',{staticClass:"h4 gibson semi-bold darkblue line-height-3"},[_vm._v("\n              Gennemført!\n            ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular gibson line-height-golden"},[_vm._v("\n              Vi håndterer det så hurtigt som muligt\n            ")])])],1):_vm._e(),_vm._v(" "),_c('b-collapse',{attrs:{"id":"createItem"}},[_c('form',[_c('div',{staticClass:"clearfix mt3 mb2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                  Opslå ledige arbejdskraft\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Vælg faggruppen\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.opgaveoptions,"required":""},model:{value:(_vm.opgave2),callback:function ($$v) {_vm.opgave2=$$v},expression:"opgave2"}},[_c('template',{slot:"no-options"},[_vm._v("\n                      Ingen matchende ...\n                    ")])],2),_vm._v(" "),(_vm.validationErrors.opgave2 && _vm.opgave2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Antal ledige mænd\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numofman2),expression:"numofman2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number"},domProps:{"value":(_vm.numofman2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numofman2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.numofman2 && _vm.numofman2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h5  mediumgrey line-height-1 mb1"},[_vm._v("\n                  Antal tilbud på arbejdskraften\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.offer2),expression:"offer2"}],staticClass:"lightgrey-background col-12 h5 darkblue px2 py1 outline-none border-none",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.offer2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"3","selected":""}},[_vm._v("3 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Tilbud")])]),_vm._v(" "),(_vm.validationErrors.numofman1 && _vm.numofman1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Postnummer (hvor er arbejdskraften)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnumber2),expression:"postnumber2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.postnumber2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnumber2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.postnumber2 && _vm.postnumber2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Opstartsdato\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieStart","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.startdate2),callback:function ($$v) {_vm.startdate2=$$v},expression:"startdate2"}}),_vm._v(" "),(_vm.validationErrors.startdate2 && _vm.startdate2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Timepris inkl. alt (ex. moms)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timepris2),expression:"timepris2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.timepris2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timepris2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.timepris2 && _vm.timepris2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Skriv om dig\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc2),expression:"desc2"}],staticClass:"p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none",staticStyle:{"min-height":"120px"},attrs:{"placeholder":"Short description"},domProps:{"value":(_vm.desc2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.desc2 && _vm.desc2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Billeder\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('button',{staticClass:"col-12 action-button p2 gibson h5 flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility()}}},[_c('span',[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix mt2"},_vm._l((_vm.jobs),function(item){return _c('div',{staticClass:"col-12 px0 pb3 mt4 mb3 border-bottom muted-border"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('workDetails'+item.id),expression:"'workDetails'+item.id"}],staticClass:"col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1"},[_c('div',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('div',{staticClass:"flex-auto pl2"},[_c('p',{staticClass:"darkblue mb0 line-height-1 left-align"},[_c('span',{staticClass:"h4 block"},[_vm._v("Arbejdskraft")]),_vm._v(" "),_c('span',{staticClass:"h6 regular"},[_vm._v("Startdato: "+_vm._s(_vm.moment(item.startdate2).format('ll')))])])]),_vm._v(" "),_c('div',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('div',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"px2 flex flex-wrap"},[_c('div',{staticClass:"py1 h6 darkblue gibson"},[_vm._v("\n                    "+_vm._s(item.opgavetitle)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"darkblue-background white h6 regular center line-height-golden mb0 gibson p1"},[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.reserve))]),_vm._v(" ud af "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.offer2))]),_vm._v(" tilbud\n                  ")])]),_vm._v(" "),(item.pidlist.length !== 0)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(4,true),_vm._v(" "),_c('tbody',_vm._l((item.pidlist),function(pidl){return _c('tr',[_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.company))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.name))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'tel:'+pidl.mobile}},[_vm._v(_vm._s(pidl.mobile))])])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'mail::'+pidl.email}},[_vm._v(_vm._s(pidl.email))])])])])}),0)])])]):_vm._e(),_vm._v(" "),_vm._m(5,true),_vm._v(" "),_c('b-collapse',{attrs:{"id":'workDetails'+item.id}},[_c('div',{staticClass:"clearfix px2 darkblue gibson"},[_c('div',{staticClass:"col-12 px0 mt2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3 mb2"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet bemanding")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.numofman2)+" mænd")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet budget (ex. moms)")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.timepris2)+"  ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.desc2)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Billeder")])]),_vm._v(" "),_vm._l((item.imagelist),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-wrap mb2"},[_c('b-img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}})],1)])})],2),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})])])])])])],1)}),0)])])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix px2 ml4"},[_c('div',{staticClass:"col-12 p2 py3 mb2"},[_c('div',{staticClass:"clearfix px2"},[_c('p',{staticClass:"h2 semi-bold line-height-2 mt2 mb1 gibson darkblue"},[_vm._v("For få opgaver?")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-3 darkblue regular"},[_vm._v("– Stil din arbejdskraft til rådighed")]),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"moreBtn"},on:{"click":function($event){return _vm.readMore()}}},[_vm._m(8)]),_vm._v(" "),_c('div',{staticClass:"col-16 px0 flex justify-start justify-around items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"col-12 p2 gibson outlined-dark-button not-rounded flex justify-center items-center hide"},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed ml2"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened ml2"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"m2m"}},[_c('div',{staticClass:"clearfix my3"},[_c('div',{staticClass:"col-12 px0 flex justify-end items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.m2m",modifiers:{"m2m":true}}],staticClass:"white-button border-none not-rounded gibson"},[_c('span',[_c('svg',{staticClass:"jam jam-close",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-6 -6 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.314 5.9l3.535-3.536A1 1 0 1 0 9.435.95L5.899 4.485 2.364.95A1 1 0 1 0 .95 2.364l3.535 3.535L.95 9.435a1 1 0 1 0 1.414 1.414l3.535-3.535 3.536 3.535a1 1 0 1 0 1.414-1.414L7.314 5.899z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByStatus","name":"sortByStatus","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Kunder")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortByHaveWork","name":"sortByHaveWork","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Ledige arbejdskraft")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"}),_vm._v(" "),_c('b-form-checkbox',{attrs:{"id":"sortBNeedeWork","name":"sortByNeedWork","value":"accepted","unchecked-value":"not_accepted"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('span',{staticClass:"ml1 h5 regular relative",staticStyle:{"top":"-3px"}},[_vm._v("Extra opgaver")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 action-button p2 gibson not-rounded"},[_c('span',{staticClass:"h6 mb0"},[_vm._v("Sorter nu")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col col-12 px0 flex justify-between justify-around items-center mt4 pl5"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.createItem",modifiers:{"createItem":true}}],staticClass:"h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"setKarft"}},[_c('span',[_vm._v("Opslå ledig arbejdskraft")]),_vm._v(" "),_vm._m(9)]),_vm._v(" "),_c('button',{staticClass:"h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"seeAvailableJobs"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads?mode=job')}}},[_c('span',[_vm._v("Se ledig arbejdskraft")]),_vm._v(" "),_vm._m(10)])]),_vm._v(" "),(_vm.success)?_c('div',{staticClass:"px0 my2"},[_c('b-alert',{staticClass:"green-background darkblue",attrs:{"variant":"light","show":"","dismissible":"","fade":""}},[_c('p',{staticClass:"h5 gibson semi-bold line-height-3 mt2 mb0"},[_vm._v("\n                Gennemført!\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson line-height-golden"},[_vm._v("\n                Vi håndterer det så hurtigt som muligt\n              ")])])],1):_vm._e(),_vm._v(" "),_c('b-collapse',{staticClass:"col-7 px0",attrs:{"id":"createItem"}},[_c('form',[_c('div',{staticClass:"clearfix mt3 mb2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-3"},[_vm._v("\n                  Opslå ledige arbejdskraft\n                ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Vælg faggruppen\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.opgaveoptions,"required":""},model:{value:(_vm.opgave2),callback:function ($$v) {_vm.opgave2=$$v},expression:"opgave2"}},[_c('template',{slot:"no-options"},[_vm._v("\n                      Ingen matchende ...\n                    ")])],2),_vm._v(" "),(_vm.validationErrors.opgave2 && _vm.opgave2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Antal ledige mænd\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numofman2),expression:"numofman2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number"},domProps:{"value":(_vm.numofman2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numofman2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.numofman2 && _vm.numofman2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h5  mediumgrey line-height-1 mb1"},[_vm._v("\n                  Antal tilbud på arbejdskraften\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.offer2),expression:"offer2"}],staticClass:"lightgrey-background col-12 h5 darkblue px2 py1 outline-none border-none",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.offer2=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"3","selected":""}},[_vm._v("3 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Tilbud")])]),_vm._v(" "),(_vm.validationErrors.numofman1 && _vm.numofman1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Postnummer (hvor er arbejdskraften)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnumber2),expression:"postnumber2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.postnumber2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnumber2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.postnumber2 && _vm.postnumber2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Opstartsdato\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieStart","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.startdate2),callback:function ($$v) {_vm.startdate2=$$v},expression:"startdate2"}}),_vm._v(" "),(_vm.validationErrors.startdate2 && _vm.startdate2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Timepris inkl. alt (ex. moms)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timepris2),expression:"timepris2"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.timepris2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timepris2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.timepris2 && _vm.timepris2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Skriv om dig\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc2),expression:"desc2"}],staticClass:"p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none",staticStyle:{"min-height":"120px"},attrs:{"placeholder":"Short description"},domProps:{"value":(_vm.desc2)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc2=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.desc2 && _vm.desc2 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue line-height-1 mb1"},[_vm._v("\n                  Billeder\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('button',{staticClass:"action-button p2 px3 gibson h4 regular flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility()}}},[_c('span',[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"flex flex-wrap mt2"},_vm._l((_vm.jobs),function(item){return _c('div',{key:item.id,staticClass:"col-6 border muted-border shadow p2 pb3 m2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('workDetails'+item.id),expression:"'workDetails'+item.id"}],staticClass:"col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1"},[_c('div',[_c('svg',{attrs:{"fill":"currentColor","width":"40","height":"40","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('div',{staticClass:"flex-auto pl2"},[_c('p',{staticClass:"darkblue mb0 line-height-1 left-align"},[_c('span',{staticClass:"h4 block"},[_vm._v("Arbejdskraft")]),_vm._v(" "),_c('span',{staticClass:"h6 regular"},[_vm._v("Startdato: "+_vm._s(_vm.moment(item.startdate2).format('ll')))])])]),_vm._v(" "),_c('div',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('div',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"float-right pr3"},[_c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.aflysePerson(item.id)}}},[_vm._v("Slet")])],1),_vm._v(" "),_c('div',{staticClass:"px2 flex flex-wrap"},[_c('div',{staticClass:"py1 h6 darkblue gibson"},[_vm._v("\n                  "+_vm._s(item.opgavetitle)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"darkblue-background white h6 regular center line-height-golden mb0 gibson p1"},[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.reserve))]),_vm._v(" ud af "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.offer2))]),_vm._v(" tilbud\n                ")])]),_vm._v(" "),(item.pidlist.length !== 0)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(11,true),_vm._v(" "),_c('tbody',_vm._l((item.pidlist),function(pidl){return _c('tr',{key:pidl.id},[_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.company))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.name))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'tel:'+pidl.mobile}},[_vm._v(_vm._s(pidl.mobile))])])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'mail::'+pidl.email}},[_vm._v(_vm._s(pidl.email))])])])])}),0)])])]):_vm._e(),_vm._v(" "),_vm._m(12,true),_vm._v(" "),_c('b-collapse',{attrs:{"id":'workDetails'+item.id}},[_c('div',{staticClass:"clearfix px2 darkblue gibson"},[_c('div',{staticClass:"col-12 px0 mt2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3 mb2"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet bemanding")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.numofman2)+" mænd")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet budget (ex. moms)")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.timepris2)+"  ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.desc2)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_vm._v("\n                        Billeder\n                      ")]),_vm._v(" "),_vm._l((item.imagelist),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-wrap mb2"},[_c('b-img',{staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}})],1)])})],2),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 mb1"},[_c('img',{staticClass:"fit",attrs:{"src":"static/img/one.jpg","alt":""}})])])])])])],1)}),0)])]):_vm._e()]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h6 regular darkblue line-height-golden mb1 gibson"},[_vm._v("\n            Mange virksomheder oplever i perioder, at de mangler opgaver for at have nok arbejde til alle ansatte. I Mester til Mester kan du stille overskydende arbejdskraft til rådighed for andre medlemmer.\n            "),_c('span',{attrs:{"id":"dots"}},[_vm._v("...")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"more"}},[_vm._v("\n              Ved at udlåne arbejdskraft er din virksomhed hele tiden i besiddelse af optimal arbejdsstyrke, men oplever ikke konsekvenserne af mangel på opgaver.\n              "),_c('br'),_c('br'),_vm._v("\n              Når opgaverne kommer ind igen, har du stadig din arbejdsstyrke til at tage varetage opgaverne.\n              "),_c('br'),_c('br'),_vm._v(" "),_c('strong',{staticClass:"semi-bold"},[_vm._v("Udlån arbejdskraft i god tid")]),_vm._v(" "),_c('br'),_vm._v("\n              Forventer du at mangle opgaver i bestemte perioder på året, kan du i god tid udlåne overskydende arbejdskraft. Det skaber vished og sikkerhed i virksomheden i perioder, hvor efterspørgslen ikke er så stor.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex flex-column justify-center items-center"},[_c('div',{staticClass:"border muted-border shadow green center",staticStyle:{"height":"32px","width":"32px","border-radius":"50%","line-height":"32px"}},[_c('span',{attrs:{"id":"moreIcon"}},[_c('i',{staticClass:"el-icon-bottom",staticStyle:{"font-size":"16px"}})]),_vm._v(" "),_c('span',{attrs:{"id":"lessIcon"}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"font-size":"16px"}})])]),_vm._v(" "),_c('p',{staticClass:"block center green h6 gibson line-height-1 mt1 mb0",attrs:{"id":"btnText"}},[_vm._v("Læs mere")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Firma")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Navn")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Mobile")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Email")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px2 my2 hide"},[_c('select',{staticClass:"col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2",staticStyle:{"height":"inherit","font-size":"1.25rem!important"}},[_c('option',{attrs:{"value":"Select status","selected":""}},[_vm._v("Select status")]),_vm._v(" "),_c('option',{attrs:{"value":"I dialog"}},[_vm._v("I dialog")]),_vm._v(" "),_c('option',{attrs:{"value":"Vandt opgaven"}},[_vm._v("Vandt opgaven")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-reset pl0 ml0 mt3"},[_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Udlån overskydende arbejdskraft")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Optimèr økonomien")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Bevar virksomhedens arbejdsstyrke")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0 mt3"},[_c('p',{staticClass:"h5 regular darkblue line-height-golden mb1 gibson"},[_vm._v("\n              Mange virksomheder oplever i perioder, at de mangler opgaver for at have nok arbejde til alle ansatte. I Mester til Mester kan du stille overskydende arbejdskraft til rådighed for andre medlemmer.\n              "),_c('span',{attrs:{"id":"dots"}},[_vm._v("...")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"more"}},[_vm._v("\n                Ved at udlåne arbejdskraft er din virksomhed hele tiden i besiddelse af optimal arbejdsstyrke, men oplever ikke konsekvenserne af mangel på opgaver.\n                "),_c('br'),_c('br'),_vm._v("\n                Når opgaverne kommer ind igen, har du stadig din arbejdsstyrke til at tage varetage opgaverne.\n                "),_c('br'),_c('br'),_vm._v(" "),_c('strong',{staticClass:"semi-bold"},[_vm._v("Udlån arbejdskraft i god tid")]),_vm._v(" "),_c('br'),_vm._v("\n                Forventer du at mangle opgaver i bestemte perioder på året, kan du i god tid udlåne overskydende arbejdskraft. Det skaber vished og sikkerhed i virksomheden i perioder, hvor efterspørgslen ikke er så stor.\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0 flex flex-column justify-center items-center"},[_c('div',{staticClass:"border green-border shadow green center",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border-width":"2px!important"}},[_c('span',{attrs:{"id":"moreIcon"}},[_c('i',{staticClass:"el-icon-bottom",staticStyle:{"font-weight":"700","font-size":"24px"}})]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"lessIcon"}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"font-weight":"700","font-size":"24px"}})])]),_vm._v(" "),_c('p',{staticClass:"block center green h6 gibson line-height-1 mt1 mb0",attrs:{"id":"btnText"}},[_vm._v("Læs mere")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Firma")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Navn")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Mobile")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Email")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px2 my2 hide"},[_c('select',{staticClass:"col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2",staticStyle:{"height":"inherit","font-size":"1.25rem!important"}},[_c('option',{attrs:{"value":"Select status","selected":""}},[_vm._v("Select status")]),_vm._v(" "),_c('option',{attrs:{"value":"I dialog"}},[_vm._v("I dialog")]),_vm._v(" "),_c('option',{attrs:{"value":"Vandt opgaven"}},[_vm._v("Vandt opgaven")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1330 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MesterOpgaver_vue__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c4b4ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MesterOpgaver_vue__ = __webpack_require__(1333);
function injectStyle (ssrContext) {
  __webpack_require__(1331)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MesterOpgaver_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e7c4b4ce_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_MesterOpgaver_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1331 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__ = __webpack_require__(101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__ = __webpack_require__(43);











/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Mester',
  data: function data() {
    return {
      dropzoneOptions: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      dropzoneOptions2: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 17,
        acceptedFiles: 'image/*,application/pdf,.doc,.docx,application/msword,.pdf',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function complete(file) {
          var _this2 = this;

          setTimeout(function () {
            _this2.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="col-12 primarycolor primarycolor-border p3 flex flex-column justify-center items-center" style="height:100%;border:2px dashed;"><div class="flex justify-center items-center"><img src="static/svg/picture-primarycolor.svg" alt="" width="32" height="32" /><p class="gibson regular line-height-1 mb0 pl2 left-align" style="font-size:15px;">Træk filerne hertil eller <a class="semi-bold">klik for at vælge filer</a></p></div></div><div class="center primarycolor gibson line-height-1 mt1"><span style="font-size:11px;">Du kan kun uploade filer som er pdf, doc, docx, jpg, gif, eller png, max. 15 000 KB</span></div>'
      },
      laborAmount: 3,
      expectedLabor: 3,
      expectedBids: 3,
      show: false,
      opgaverhow: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      startDate: '',
      endDate: '',
      config: {
        format: 'LL',
        minDate: new Date(),
        sideBySide: false,
        useCurrent: false,
        debug: true,
        showClear: false,
        showClose: false
      },
      opgave1: '',
      offer1: '3',
      subopgave1: '',
      numofman1: '',
      postnumber1: '',
      startdate1: '',
      duration1: '',
      timepris1: '',
      desc1: '',
      opgaveoptions: [],
      images: [],
      files: [],
      opgaver: [],
      subopgaveoptions: [],
      validationErrors: {
        opgave1: null,
        subopgave1: null,
        numofman1: null,
        postnumber1: null,
        startdate1: null,
        duration1: null,
        timepris1: null,
        desc1: null,
        opgave2: null,
        numofman2: null,
        postnumber2: null,
        startdate2: null,
        timepris2: null,
        desc2: null
      },
      toolsIncluded: '',
      vehicleIncluded: ''
    };
  },

  mounted: {},
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_1__haandvaerker__["a" /* default */],
    Dropzone: __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default.a,
    vSelect: __WEBPACK_IMPORTED_MODULE_4_vue_select___default.a,
    datePicker: __WEBPACK_IMPORTED_MODULE_6_vue_bootstrap_datetimepicker___default.a,

    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_7__noneligibleFeaturepop__["a" /* default */]
  },
  created: function created() {
    this.eligible = localStorage.getItem('PartnerloginMesterMesterPost');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.Reload();
  },

  watch: {
    opgave1: function opgave1(newSearchvalue, oldSearchvalue) {
      if (newSearchvalue !== null) {
        this.change1();
      }
    }
  },
  methods: {
    getdataigibility: function getdataigibility() {
      var clicktype = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'yes';

      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerloginMesterMesterPost');
      } else {
        if (clicktype === 'yes') {
          this.onSubmit();
        }
      }
    },
    onSubmit: function onSubmit() {
      var _this3 = this;

      if (this.validateForm1()) {
        this.show = true;
        this.salesPerson = localStorage.getItem('id_token_portal');
        var dataPartner = { opgave1: this.opgave1.value, subopgave1: this.subopgave1.value, numofman1: this.numofman1, offer1: this.offer1, postnumber1: this.postnumber1, startdate1: this.startdate1, duration1: this.duration1, timepris1: this.timepris1, desc1: this.desc1, images: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.images), files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files) };
        this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=savepartnerjob&json=no&short=' + this.shorturl, dataPartner, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          _this3.show = false;
          _this3.loading = false;
          if (res.login === false) {
            _this3.$router.push('/login');
          }
          if (res.success) {
            var obj = {
              title: 'Gennemført!',
              message: '',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this3.$refs.simplert.openSimplert(obj);
            _this3.success = true;
            _this3.opgave2 = '';
            _this3.numofman2 = '';
            _this3.postnumber2 = '';
            _this3.startdate2 = '';
            _this3.timepris2 = '';
            _this3.desc2 = '';
            document.getElementById('setOpgave').click();
            _this3.Reload();
          } else {
            _this3.show = false;
            alert(res.message);
          }
        }, function (response) {
          alert('error');
        });
      } else {
        alert('Kontroller felterne!');
      }
    },
    aflyseOpgave: function aflyseOpgave(id) {
      var confirmFn = function confirmFn() {
        this.$parent.aflyseconfirm_opgave(id);
      };
      var obj = {
        title: 'Bekræft',
        message: 'Er du sikker på at du vil slette denne opgave ?',
        useConfirmBtn: true,
        onConfirm: confirmFn,
        customConfirmBtnText: 'Bekræft',
        customConfirmBtnClass: 'simplert__confirm bg-success',
        customCloseBtnClass: 'simplert__close bg-secondary',
        customCloseBtnText: 'Luk',
        showXclose: true
      };
      this.$refs.simplert.openSimplert(obj);
    },
    aflyseconfirm_opgave: function aflyseconfirm_opgave(id) {
      var _this4 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'aflyseconfirm_opgave', salesPerson: this.salesPerson, opgaveid: id };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          _this4.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
          _this4.Reload();
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    OpenUrl: function OpenUrl(url) {
      this.$router.push(url);
      this.$refs.findworkModal.hide();
    },
    change1: function change1() {
      this.opgaverhow = true;
      this.subopgave1 = '';
      this.subopgaveoptions = this.opgave1.suproduct;
    },
    validateForm1: function validateForm1() {
      var success = true;
      if (this.opgave1 === '') {
        this.validationErrors.opgave1 = true;
        success = false;
      }
      if (this.subopgave1 === '') {
        this.validationErrors.subopgave1 = true;
        success = false;
      }
      if (this.numofman1 === '') {
        this.validationErrors.numofman1 = true;
        success = false;
      }
      if (this.postnumber1 === '') {
        this.validationErrors.postnumber1 = true;
        success = false;
      }
      if (this.startdate1 === '') {
        this.validationErrors.startdate1 = true;
        success = false;
      }
      if (this.duration1 === '') {
        this.validationErrors.duration1 = true;
        success = false;
      }
      if (this.timepris1 === '') {}
      if (this.desc1 === '') {
        this.validationErrors.desc1 = true;
        success = false;
      }
      return success;
    },
    updateValue: function updateValue(event) {
      var value = event.target.value;
      console.log(value, this.laborAmount);
      if (String(value).length <= 10) {
        this.laborAmount = value;
      }
      this.$forceUpdate();
    },
    sendingEvent: function sendingEvent(file, xhr, formData) {
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      formData.append('salesPerson', this.salesPerson);
      formData.append('levid', this.haaId);
      formData.append('operation', 'uploadImagesMester');
    },

    'showSuccess': function showSuccess(file) {
      this.images.push(file.xhr.response);
    },
    'showSuccess2': function showSuccess2(file) {
      this.files.push(file.xhr.response);
    },
    RemoveUrl: function RemoveUrl(file) {
      var item = file.split('/').pop();
      return item;
    },
    hideModal: function hideModal() {
      this.$refs.reviewModal.hide();
    },
    hideLaborModal: function hideLaborModal() {
      this.$refs.reviewLaborForm.hide();
    },
    delete_image: function delete_image(image) {
      var index = this.images.indexOf(image);
      if (index > -1) {
        this.images.splice(index, 1);
      }
    },
    delete_file: function delete_file(file) {
      var index = this.files.indexOf(file);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    Reload: function Reload() {
      var _this5 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'oversigt_partner_profil_mester', salesPerson: this.salesPerson, typeMeeting: '1' };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        _this5.show = false;
        var res = response.body;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        _this5.opgaveoptions = res.productmester;
        _this5.shorturl = res.urlshort;
        _this5.opgaver = res.opgave;
      }, function (response) {
        _this5.show = false;
        alert('error');
      });
    },
    readMore: function readMore() {
      var dots = document.getElementById('dots');
      var moreText = document.getElementById('more');
      var btnText = document.getElementById('btnText');
      var moreIcon = document.getElementById('moreIcon');
      var lessIcon = document.getElementById('lessIcon');
      if (dots.style.display === 'none') {
        dots.style.display = 'inline';
        btnText.innerHTML = 'Læs mere';
        moreText.style.display = 'none';
        moreIcon.style.display = 'inline';
        lessIcon.style.display = 'none';
      } else {
        dots.style.display = 'none';
        btnText.innerHTML = 'Luk';
        moreText.style.display = 'block';
        moreIcon.style.display = 'none';
        lessIcon.style.display = 'inline';
      }
    }
  }
});

/***/ }),
/* 1333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt3 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 py3 mb2 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h2 semi-bold line-height-2 mt2 mb1 gibson darkblue"},[_vm._v("For meget at lave?")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-3 darkblue regular"},[_vm._v("– Søg arbejdskraft")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"moreBtn"},on:{"click":function($event){return _vm.readMore()}}},[_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2 hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reservedJobs",modifiers:{"reservedJobs":true}}],staticClass:"col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h4 mb0 mr2"},[_vm._v("Se reserverede jobs")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2 hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.workDetails",modifiers:{"workDetails":true}}],staticClass:"col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex flex-column mt4 mb2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.createItem",modifiers:{"createItem":true}}],staticClass:"p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"setOpgave"},on:{"click":function($event){return _vm.getdataigibility('no')}}},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Opslå din opgave")]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('button',{staticClass:"p2 gibson primary-button not-rounded flex justify-center items-center",attrs:{"id":"seeAvailableJobs"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads?mode=mester')}}},[_c('span',{staticClass:"h5 mb0"},[_vm._v("Se opgaver")]),_vm._v(" "),_vm._m(4)])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"createItem"}},[_c('form',[_c('div',{staticClass:"clearfi mt3 mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Vælg opgavetype\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.opgaveoptions,"required":""},on:{"changed":_vm.change1},model:{value:(_vm.opgave1),callback:function ($$v) {_vm.opgave1=$$v},expression:"opgave1"}},[_c('template',{slot:"no-options"},[_vm._v("\n                    Ingen matchende ...\n                  ")])],2),_vm._v(" "),(_vm.validationErrors.opgave1 && _vm.opgave1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("\n                  Nødvendig\n                ")]):_vm._e()],1),_vm._v(" "),(_vm.opgaverhow)?_c('div',{staticClass:"clearfi mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Yderligere information\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"col-12 p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.subopgaveoptions,"required":""},model:{value:(_vm.subopgave1),callback:function ($$v) {_vm.subopgave1=$$v},expression:"subopgave1"}},[_c('template',{slot:"no-options"},[_vm._v("\n                    Ingen matchende ...\n                  ")])],2),_vm._v(" "),(_vm.validationErrors.opgave1 && _vm.opgave1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Forventet bemanding\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numofman1),expression:"numofman1"}],staticClass:"p2 muted-background darkblue h6 gibson border-none not-rounded col-12",attrs:{"type":"number"},domProps:{"value":(_vm.numofman1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numofman1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.numofman1 && _vm.numofman1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Antal tilbud på opgaven\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.offer1),expression:"offer1"}],staticClass:"muted-background col-12 h6 darkblue p2 regular outline-none border-none gibson not-rounded",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.offer1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"3","selected":""}},[_vm._v("3 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Tilbud")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Postnummer for opgaven\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnumber1),expression:"postnumber1"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.postnumber1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnumber1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.postnumber1 && _vm.postnumber1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Opstartsdato\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieStart","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.startdate1),callback:function ($$v) {_vm.startdate1=$$v},expression:"startdate1"}}),_vm._v(" "),(_vm.validationErrors.startdate1 && _vm.startdate1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Varighed\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration1),expression:"duration1"}],staticClass:"muted-background col-12 h6 gibson darkblue p2 outline-none border-none",attrs:{"name":"duration1","id":"duration1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.duration1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"selected"}},[_vm._v("Vælg")]),_vm._v(" "),_c('option',{attrs:{"value":"1t"}},[_vm._v("1 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"2t"}},[_vm._v("2 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"3t"}},[_vm._v("3 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"4t"}},[_vm._v("4 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"5t"}},[_vm._v("5 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"6t"}},[_vm._v("6 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"1d"}},[_vm._v("1 dag")]),_vm._v(" "),_c('option',{attrs:{"value":"2d"}},[_vm._v("2 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"3d"}},[_vm._v("3 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"4d"}},[_vm._v("4 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"5d"}},[_vm._v("5 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"6d"}},[_vm._v("6 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"7d"}},[_vm._v("7 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"8d"}},[_vm._v("8 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"9d"}},[_vm._v("9 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"10d"}},[_vm._v("10 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"11d"}},[_vm._v("11 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"12d"}},[_vm._v("12 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"13d"}},[_vm._v("13 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"14d"}},[_vm._v("14 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"15d"}},[_vm._v("15 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"16d"}},[_vm._v("Over 15 dage")])]),_vm._v(" "),(_vm.validationErrors.duration1 && _vm.duration1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Forventet budget (ex. moms)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timepris1),expression:"timepris1"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.timepris1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timepris1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.timepris1 && _vm.timepris1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Beskrivelse\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc1),expression:"desc1"}],staticClass:"p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none",staticStyle:{"min-height":"120px"},attrs:{"placeholder":""},domProps:{"value":(_vm.desc1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.desc1 && _vm.desc1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Billeder\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Dokument\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone2","options":_vm.dropzoneOptions2},on:{"vdropzone-success":_vm.showSuccess2,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.files),function(file){return _c('div',{key:file},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_vm._v("\n                    "+_vm._s(_vm.RemoveUrl(file))+"\n                    "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_file(file)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('button',{staticClass:"col-12 action-button p2 gibson h5 flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility('yes')}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix border muted-border p2 pb3 mt2"},[_vm._l((_vm.opgaver),function(item){return [_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('workDetails'+item.id),expression:"'workDetails'+item.id"}],key:item.id,staticClass:"col-12 p2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1"},[_c('div',[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('div',{staticClass:"flex-auto pl2"},[_c('p',{staticClass:"darkblue mb0 line-height-1 left-align"},[_c('span',{staticClass:"h3 regular block mb1"},[_vm._v(_vm._s(item.productname))]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v("Startdato:"),_c('br'),_vm._v(_vm._s(_vm.moment(item.startdate1).locale('da').format('LL')))])])]),_vm._v(" "),_c('div',{staticClass:"when-closed"},[_c('span',[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('div',{staticClass:"flex-none when-opened"},[_c('span',[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"float-right pr3"},[_c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.aflyseOpgave(item.id)}}},[_vm._v("Slet")])],1),_vm._v(" "),_c('div',{key:item.id,staticClass:"px2 flex flex-wrap"},[_c('div',{staticClass:"py1 h4 darkblue gibson"},[_vm._v("\n              "+_vm._s(item.productname2)+"\n            ")])]),_vm._v(" "),_c('div',{key:item.id,staticClass:"px2"},[_c('p',{staticClass:"darkblue-background white h4 regular center line-height-golden mb0 gibson p2"},[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.reserve))]),_vm._v(" ud af "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.offer1))]),_vm._v(" tilbud\n            ")])]),_vm._v(" "),(item.pidlist.length !== 0)?_c('div',{key:item.id,staticClass:"col-12 px2"},[_c('div',{staticClass:"table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(5,true),_vm._v(" "),_c('tbody',_vm._l((item.pidlist),function(pidl){return _c('tr',[_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.company))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.name))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'tel:'+pidl.mobile}},[_vm._v(_vm._s(pidl.mobile))])])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'mail::'+pidl.email}},[_vm._v(_vm._s(pidl.email))])])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{key:item.id,staticClass:"px2 my2 hide"},[_vm._m(6,true)]),_vm._v(" "),_c('b-collapse',{key:item.id,attrs:{"id":'workDetails' + item.id}},[_c('div',{staticClass:"clearfix px2 darkblue gibson"},[_c('div',{staticClass:"col-12 px0 mt2"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3 mb2"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet bemanding")]),_vm._v(" "),_c('span',{staticClass:"h4 regular"},[_vm._v(_vm._s(item.numofman1)+" mænd")])]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Varighed")]),_vm._v(" "),_c('span',{staticClass:"h4 regular"},[_vm._v(_vm._s(item.duration1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet budget (ex. moms)")]),_vm._v(" "),_c('span',{staticClass:"h4 regular"},[_vm._v(_vm._s(item.timepris1)+"  ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Postnummer")]),_vm._v(" "),_c('span',{staticClass:"regular h4"},[_vm._v(_vm._s(item.postnumber1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"h4 regular"},[_vm._v(_vm._s(item.desc1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Billeder")])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column"},_vm._l((item.imagelist),function(image){return _c('div',{key:image,staticClass:"mb2"},[_c('img',{staticClass:"block fit cover",attrs:{"src":image,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Filer")])]),_vm._v(" "),_vm._l((item.filelist),function(file){return _c('div',{key:file},[_c('div',{staticClass:"mb2"},[_c('span',{staticClass:"primarycolor el-icon-paperclip"}),_vm._v(" "),_c('a',{attrs:{"href":file,"alt":""}},[_vm._v(_vm._s(_vm._f("truncate")(_vm.RemoveUrl(file),30,'...')))])])])})],2)])])])]})],2),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"py4"})]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"clearfix px2 ml4"},[_c('div',{staticClass:"col-12 p2 py3 mb2"},[_c('div',{staticClass:"clearfix px2"},[_c('p',{staticClass:"h2 semi-bold line-height-2 mt2 mb1 gibson darkblue"},[_vm._v("For meget at lave?")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-3 darkblue regular"},[_vm._v("– Søg arbejdskraft")]),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"moreBtn"},on:{"click":function($event){return _vm.readMore()}}},[_vm._m(9)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center my2 hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.reservedJobs",modifiers:{"reservedJobs":true}}],staticClass:"col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h4 mb0 mr2"},[_vm._v("Se reserverede jobs")]),_vm._v(" "),_c('span',{staticClass:"flex-none when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"col-7 px0 flex justify-between items-center my2 hide"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.workDetails",modifiers:{"workDetails":true}}],staticClass:"col-12 p2 gibson outlined-primary-button not-rounded flex justify-center items-center"},[_c('span',{staticClass:"h4 mb0"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"relative ml2",staticStyle:{"top":"4px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-7 px0 flex justify-between items-center mt4"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.createItem",modifiers:{"createItem":true}}],staticClass:"h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"setOpgave"},on:{"click":function($event){return _vm.getdataigibility('no')}}},[_c('span',[_vm._v("Opslå din opgave")]),_vm._v(" "),_vm._m(10)]),_vm._v(" "),_c('button',{staticClass:"h5 regular p2 gibson outlined-primary-button not-rounded flex justify-center items-center",attrs:{"id":"seeOpgaver"},on:{"click":function($event){return _vm.OpenUrl('/markedsplads?mode=mester')}}},[_c('span',[_vm._v("Se opgaver")]),_vm._v(" "),_vm._m(11)])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-7 px0",attrs:{"id":"createItem"}},[_c('form',[_c('div',{staticClass:"clearfix mt3 mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Vælg opgavetype\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.opgaveoptions,"required":""},on:{"changed":_vm.change1},model:{value:(_vm.opgave1),callback:function ($$v) {_vm.opgave1=$$v},expression:"opgave1"}},[_c('template',{slot:"no-options"},[_vm._v("\n                    Ingen matchende ...\n                  ")])],2),_vm._v(" "),(_vm.validationErrors.opgave1 && _vm.opgave1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("\n                  Nødvendig\n                ")]):_vm._e()],1),_vm._v(" "),(_vm.opgaverhow)?_c('div',{staticClass:"clearfi mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Yderligere information\n                ")]),_vm._v(" "),_c('v-select',{staticClass:"col-12 p1 muted-background darkblue gibson h6 regular border-none not-rounded",attrs:{"options":_vm.subopgaveoptions,"required":""},model:{value:(_vm.subopgave1),callback:function ($$v) {_vm.subopgave1=$$v},expression:"subopgave1"}},[_c('template',{slot:"no-options"},[_vm._v("\n                    Ingen matchende ...\n                  ")])],2),_vm._v(" "),(_vm.validationErrors.opgave1 && _vm.opgave1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig")]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Forventet bemanding\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.numofman1),expression:"numofman1"}],staticClass:"p2 muted-background darkblue h6 gibson border-none not-rounded col-12",attrs:{"type":"number"},domProps:{"value":(_vm.numofman1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.numofman1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.numofman1 && _vm.numofman1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Antal tilbud på opgaven\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.offer1),expression:"offer1"}],staticClass:"muted-background col-12 h6 darkblue p2 regular outline-none border-none gibson not-rounded",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.offer1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"3","selected":""}},[_vm._v("3 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("2 Tilbud")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Tilbud")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Postnummer for opgaven\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.postnumber1),expression:"postnumber1"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"number","placeholder":""},domProps:{"value":(_vm.postnumber1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.postnumber1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.postnumber1 && _vm.postnumber1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Opstartsdato\n                ")]),_vm._v(" "),_c('date-picker',{staticClass:"muted-background gibson border-none not-rounded",attrs:{"id":"ferieStart","type":"text","required":"","config":_vm.config,"required":""},model:{value:(_vm.startdate1),callback:function ($$v) {_vm.startdate1=$$v},expression:"startdate1"}}),_vm._v(" "),(_vm.validationErrors.startdate1 && _vm.startdate1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Varighed\n                ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.duration1),expression:"duration1"}],staticClass:"muted-background col-12 h6 gibson darkblue p2 outline-none border-none",attrs:{"name":"duration1","id":"duration1"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.duration1=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"","selected":"selected"}},[_vm._v("Vælg")]),_vm._v(" "),_c('option',{attrs:{"value":"1t"}},[_vm._v("1 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"2t"}},[_vm._v("2 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"3t"}},[_vm._v("3 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"4t"}},[_vm._v("4 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"5t"}},[_vm._v("5 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"6t"}},[_vm._v("6 timer")]),_vm._v(" "),_c('option',{attrs:{"value":"1d"}},[_vm._v("1 dag")]),_vm._v(" "),_c('option',{attrs:{"value":"2d"}},[_vm._v("2 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"3d"}},[_vm._v("3 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"4d"}},[_vm._v("4 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"5d"}},[_vm._v("5 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"6d"}},[_vm._v("6 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"7d"}},[_vm._v("7 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"8d"}},[_vm._v("8 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"9d"}},[_vm._v("9 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"10d"}},[_vm._v("10 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"11d"}},[_vm._v("11 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"12d"}},[_vm._v("12 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"13d"}},[_vm._v("13 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"14d"}},[_vm._v("14 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"15d"}},[_vm._v("15 dage")]),_vm._v(" "),_c('option',{attrs:{"value":"16d"}},[_vm._v("Over 15 dage")])]),_vm._v(" "),(_vm.validationErrors.duration1 && _vm.duration1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Forventet budget (ex. moms)\n                ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.timepris1),expression:"timepris1"}],staticClass:"p2 muted-background darkblue h5 gibson border-none not-rounded col-12",attrs:{"type":"text","placeholder":""},domProps:{"value":(_vm.timepris1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.timepris1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.timepris1 && _vm.timepris1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Beskrivelse\n                ")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.desc1),expression:"desc1"}],staticClass:"p2 col-12 muted-background h5 line-height-golden darkblue gibson not-rounded border-none",staticStyle:{"min-height":"120px"},attrs:{"placeholder":""},domProps:{"value":(_vm.desc1)},on:{"input":function($event){if($event.target.composing){ return; }_vm.desc1=$event.target.value}}}),_vm._v(" "),(_vm.validationErrors.desc1 && _vm.desc1 === '')?_c('div',{staticClass:"text-danger"},[_vm._v("Nødvendig .")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Billeder\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone","options":_vm.dropzoneOptions},on:{"vdropzone-success":_vm.showSuccess,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.images),function(image){return _c('div',{key:image},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_c('img',{staticClass:"fit mb2",staticStyle:{"width":"100px","height":"100px"},attrs:{"src":image,"alt":""}}),_vm._v(" "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_image(image)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('p',{staticClass:"h6 regular darkblue gibson line-height-1 mb1"},[_vm._v("\n                  Dokument\n                ")]),_vm._v(" "),_c('dropzone',{attrs:{"id":"myVueDropzone2","options":_vm.dropzoneOptions2},on:{"vdropzone-success":_vm.showSuccess2,"vdropzone-sending":_vm.sendingEvent}}),_vm._v(" "),_vm._l((_vm.files),function(file){return _c('div',{key:file},[_c('div',{staticClass:"px2 flex flex-column justify-center items-center mb2"},[_vm._v("\n                    "+_vm._s(_vm.RemoveUrl(file))+"\n                    "),_c('button',{staticClass:"outlined-dark-button border-none not-rounded p0 justify-center items-center col-12 mt1",on:{"click":function($event){return _vm.delete_file(file)}}},[_c('svg',{staticClass:"jam jam-trash-alt",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M14.833 5l-.728 13.11A2 2 0 0 1 12.108 20H3.892a2 2 0 0 1-1.997-1.89L1.167 5H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-.167zM12.83 5H3.17l.722 13h8.216l.722-13zM2 2v1h12V2H2zm4 5a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1zm4 0a1 1 0 0 1 1 1v7a1 1 0 0 1-2 0V8a1 1 0 0 1 1-1z"}})])])])])})],2),_vm._v(" "),_c('div',{staticClass:"clearfix mb3"},[_c('button',{staticClass:"action-button p2 gibson h5 flex justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility()}}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Fortsæt")]),_vm._v(" "),_c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])])])])])],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px2"},[[(!_vm.opgaver.length)?_c('div',{staticClass:"ml4"}):_c('div',[_c('div',{staticClass:"flex flex-wrap mt2 ml2"},_vm._l((_vm.opgaver),function(item){return _c('div',{key:item.id,staticClass:"col-4 border muted-border shadow px1 py2 pb3 mr2"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('workDetails'+item.id),expression:"'workDetails'+item.id"}],staticClass:"col-12 py2 primary-white-button not-rounded border-none gibson flex justify-start items-start mb1"},[_c('div',[_c('svg',{attrs:{"fill":"currentColor","width":"48","height":"48","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M356 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10 5.5 0 10-4.5 10-10C366 433.5 361.5 429 356 429z"}}),_c('path',{attrs:{"d":"M156 429c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10s10-4.5 10-10C166 433.5 161.5 429 156 429z"}}),_c('path',{attrs:{"d":"M447.6 377.2c-11.3-17.4-26.7-31.3-44.8-40.2 -1.5-1.4-3.5-2.4-5.7-2.6C384 328.8 370.2 326 356 326h-30v-26.4c17.4-14.9 29.8-34.6 35.9-56.6H366c22.1 0 40-17.9 40-40 0-10.5-4-20-10.6-27.1 0.6-0.5 1.2-1.1 1.8-1.7C402.9 168.5 406 161 406 153c0-13.2-8.5-24.4-20.3-28.4 -3.5-46-35.8-85.3-80.2-97.6C302.8 13.3 291.4 0 276 0h-40c-15.4 0-26.8 13.3-29.4 27 -44.4 12.3-76.7 51.6-80.2 97.6 -4.3 1.5-8.2 3.9-11.6 7.2C109.1 137.5 106 145 106 153c0 9.2 4.1 17.4 10.6 22.9C110 183 106 192.5 106 203c0 22.1 17.9 40 40 40h4.1c5.1 18.4 14.6 35.2 28 49.1 2.5 2.6 5.2 5.1 7.9 7.5V326h-30c-14.2 0-28 2.8-41.1 8.4 -2.2 0.2-4.1 1.2-5.7 2.6 -18.1 8.9-33.6 22.8-44.8 40.2C52.3 395.8 46 417.2 46 439v63c0 5.5 4.5 10 10 10h400c5.5 0 10-4.5 10-10v-63C466 417.2 459.7 395.8 447.6 377.2zM106 492H66v-53c0-30.4 15.6-59.6 40-76.9V492zM366 223h-0.5c0.3-3.3 0.5-6.7 0.5-10v-30c11 0 20 9 20 20S377 223 366 223zM206 48.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V35.1c0 0 0-0.1 0-0.1V33c0-6.2 5.2-13 10-13h40c4.8 0 10 6.8 10 13v2c0 0 0 0.1 0 0.1V93c0 5.5 4.5 10 10 10s10-4.5 10-10V48.1c32.3 11.4 55.6 40.6 59.4 74.9H146.6C150.4 88.8 173.7 59.6 206 48.1zM146 223c-11 0-20-9-20-20s9-20 20-20v30c0 3.3 0.2 6.7 0.5 10H146zM146 163h-10c-5.5 0-10-4.5-10-10 0-2.7 1-5.2 2.9-7.1 1.9-1.9 4.4-2.9 7.1-2.9h240c5.5 0 10 4.5 10 10 0 2.7-1 5.2-2.9 7.1 -1.9 1.9-4.4 2.9-7.1 2.9h-10 -10H156 146zM167.8 231.2c0-0.1 0-0.2-0.1-0.3C166.6 225 166 219 166 213v-30h180v30c0 6-0.6 12-1.8 17.9 0 0.1 0 0.2-0.1 0.3 -4.5 22.3-16.8 42.3-34.8 56.2C293.7 299.6 275.2 306 256 306s-37.7-6.4-53.4-18.6c-3.6-2.8-7-5.8-10.1-9.1C179.9 265.1 171.4 248.9 167.8 231.2zM246 492h-80v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-20V351.5c6.5-2.4 13.2-4.1 20-4.9V409c0 5.5 4.5 10 10 10s10-4.5 10-10v-63h25.7L246 403V492zM206 332v-18.6C221.4 321.7 238.4 326 256 326c17.6 0 34.6-4.3 50-12.6V332l-50 52.5L206 332zM386 492h-20v-23c0-5.5-4.5-10-10-10s-10 4.5-10 10v23h-80v-89l54.3-57H346v63c0 5.5 4.5 10 10 10s10-4.5 10-10v-62.4c6.8 0.8 13.5 2.4 20 4.9V492zM446 492h-40V362.1c24.4 17.3 40 46.5 40 76.9V492z"}})])]),_vm._v(" "),_c('div',{staticClass:"flex-auto pl2"},[_c('p',{staticClass:"darkblue mb0 line-height-1 left-align"},[_c('span',{staticClass:"h4 regular block",staticStyle:{"margin-bottom":"6px"}},[_vm._v(_vm._s(item.productname))]),_vm._v(" "),_c('span',{staticClass:"h6 regular"},[_vm._v("Startdato:"),_c('br'),_vm._v(_vm._s(_vm.moment(item.startdate1).locale('da').format('LL')))])])]),_vm._v(" "),_c('div',{staticClass:"when-closed"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('div',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative"},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('div',{staticClass:"float-right pr3"},[_c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.aflyseOpgave(item.id)}}},[_vm._v("Slet")])],1),_vm._v(" "),_c('div',{staticClass:"px2 flex flex-wrap"},[_c('div',{staticClass:"py1 h5 regular darkblue gibson"},[_vm._v("\n                    "+_vm._s(item.productname2)+"\n                  ")])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"darkblue-background white h5 regular center line-height-golden mb0 gibson p2"},[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.reserve))]),_vm._v(" ud af "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(item.offer1))]),_vm._v(" tilbud\n                  ")])]),_vm._v(" "),(item.pidlist.length !== 0)?_c('div',{staticClass:"col-12 px2"},[_c('div',{staticClass:"table-responsive",attrs:{"striped":"","bordered":""}},[_c('table',{staticClass:"table"},[_vm._m(12,true),_vm._v(" "),_c('tbody',_vm._l((item.pidlist),function(pidl){return _c('tr',[_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.company))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v(_vm._s(pidl.name))])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'tel:'+pidl.mobile}},[_vm._v(_vm._s(pidl.mobile))])])]),_vm._v(" "),_c('td',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_c('a',{attrs:{"href":'mail::'+pidl.email}},[_vm._v(_vm._s(pidl.email))])])])])}),0)])])]):_vm._e(),_vm._v(" "),_vm._m(13,true),_vm._v(" "),_c('b-collapse',{attrs:{"id":'workDetails' + item.id}},[_c('div',{staticClass:"clearfix px2 darkblue gibson"},[_c('div',{staticClass:"col-12 px0 mt2"},[_c('div',{staticClass:"flex flex-column"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3 mb2"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet bemanding")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.numofman1)+" mænd")])]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Varighed")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.duration1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Forventet budget (ex. moms)")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.timepris1)+"  ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Postnummer")]),_vm._v(" "),_c('span',{staticClass:"regular h5"},[_vm._v(_vm._s(item.postnumber1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"h5 regular"},[_vm._v(_vm._s(item.desc1)+" ")])])]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Billeder")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-between"},_vm._l((item.imagelist),function(image){return _c('div',{key:image,staticClass:"col-6 p1"},[_c('img',{staticClass:"block fit cover",attrs:{"src":image,"alt":""}})])}),0)]),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"h6 semi-bold darkblue gibson line-height-3"},[_c('span',{staticClass:"block semi-bold"},[_vm._v("Filer")])]),_vm._v(" "),_vm._l((item.filelist),function(file){return _c('div',{key:file},[_c('div',{staticClass:"mb2"},[_c('span',{staticClass:"primarycolor el-icon-paperclip"}),_vm._v(" "),_c('a',{attrs:{"href":file,"alt":""}},[_vm._v(_vm._s(_vm._f("truncate")(_vm.RemoveUrl(file),20,'...')))])])])})],2)])])])],1)}),0)])]],2)]):_vm._e()]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-reset pl0 ml0 mt3"},[_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Find kvalificeret arbejdskraft")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Sig ja til større opgaver")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Håndtèr flere opgaver")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mb1 gibson"},[_vm._v("\n            Mangler du ekstra hænder, kan du med Mester til Mester øge din arbejdsstyrke i en kortere eller længere periode.\n            "),_c('span',{attrs:{"id":"dots"}},[_vm._v("...")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"more"}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Sig ja til større opgaver")]),_vm._v(" "),_c('br'),_vm._v("\n              Du kan takke ja til større opgaver, da du nemt kan indhente ekstra kvalificeret arbejdskraft i den periode, hvor opgaven skal udføres.\n              "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v("Håndtér flere opgaver")]),_vm._v(" "),_c('br'),_vm._v("\n              Undgå at sige nej til faste kunder, fordi du har taget en større opgave ind. Du kan nemt indhente arbejdskraft til at varetage alle dine opgaver og behøver ikke at gå på kompromis. Med Mester til Mester kan du udvide dit arbejdsområde og samtidig pleje dine loyale kunder.\n            ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0 flex flex-column justify-center items-center"},[_c('div',{staticClass:"border green-border shadow green center",staticStyle:{"height":"32px","width":"32px","border-radius":"50%","line-height":"32px","border-width":"2px!important"}},[_c('span',{attrs:{"id":"moreIcon"}},[_c('i',{staticClass:"el-icon-bottom",staticStyle:{"font-weight":"700","font-size":"16px"}})]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"lessIcon"}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"font-weight":"700","font-size":"16px"}})])]),_vm._v(" "),_c('p',{staticClass:"block center green h6 gibson line-height-1 mt1 mb0",attrs:{"id":"btnText"}},[_vm._v("Læs mere")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Firma")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Navn")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Mobile")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Email")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select',{staticClass:"col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2",staticStyle:{"height":"inherit","font-size":"1.25rem!important"}},[_c('option',{attrs:{"value":"Select status","selected":""}},[_vm._v("Select status")]),_vm._v(" "),_c('option',{attrs:{"value":"I dialog"}},[_vm._v("I dialog")]),_vm._v(" "),_c('option',{attrs:{"value":"Vandt opgaven"}},[_vm._v("Vandt opgaven")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"list-reset pl0 ml0 mt3"},[_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Find kvalificeret arbejdskraft")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Sig ja til større opgaver")])]),_vm._v(" "),_c('li',{staticClass:"flex justify-start items-center mb2"},[_c('span',{staticClass:"mr2"},[_c('img',{staticClass:"block fit",attrs:{"width":"24","src":"static/img/sky-blue-checkmark.png"}})]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-1 m0 p0 darkblue regular"},[_vm._v("Håndtèr flere opgaver")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-7 px0 mt3"},[_c('p',{staticClass:"h5 regular darkblue line-height-golden mb1 gibson"},[_vm._v("\n            Mangler du ekstra hænder, kan du med Mester til Mester øge din arbejdsstyrke i en kortere eller længere periode.\n              "),_c('span',{attrs:{"id":"dots"}},[_vm._v("...")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('span',{attrs:{"id":"more"}},[_c('span',{staticClass:"semi-bold"},[_vm._v("Sig ja til større opgaver")]),_vm._v(" "),_c('br'),_vm._v("\n                Du kan takke ja til større opgaver, da du nemt kan indhente ekstra kvalificeret arbejdskraft i den periode, hvor opgaven skal udføres.\n                "),_c('br'),_c('br'),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v("Håndtér flere opgaver")]),_vm._v(" "),_c('br'),_vm._v("\n                Undgå at sige nej til faste kunder, fordi du har taget en større opgave ind. Du kan nemt indhente arbejdskraft til at varetage alle dine opgaver og behøver ikke at gå på kompromis. Med Mester til Mester kan du udvide dit arbejdsområde og samtidig pleje dine loyale kunder.\n              ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-7 px0 flex flex-column justify-center items-center"},[_c('div',{staticClass:"border green-border shadow green center",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border-width":"2px!important"}},[_c('span',{attrs:{"id":"moreIcon"}},[_c('i',{staticClass:"el-icon-bottom",staticStyle:{"font-weight":"700","font-size":"24px"}})]),_vm._v(" "),_c('span',{staticStyle:{"display":"none"},attrs:{"id":"lessIcon"}},[_c('i',{staticClass:"el-icon-top",staticStyle:{"font-weight":"700","font-size":"24px"}})])]),_vm._v(" "),_c('p',{staticClass:"block center green h6 gibson line-height-1 mt1 mb0",attrs:{"id":"btnText"}},[_vm._v("Læs mere")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',[_c('tr',[_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Firma")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Navn")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Mobile")])]),_vm._v(" "),_c('th',[_c('span',{staticClass:"h6 regular line-height-1 m0"},[_vm._v("Email")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px2 my2 hide"},[_c('select',{staticClass:"col-12 white-background darkblue not-rounded border muted-border shadow gibson mb0 h6 flex justify-center items-center p2",staticStyle:{"height":"inherit","font-size":"1.25rem!important"}},[_c('option',{attrs:{"value":"Select status","selected":""}},[_vm._v("Select status")]),_vm._v(" "),_c('option',{attrs:{"value":"I dialog"}},[_vm._v("I dialog")]),_vm._v(" "),_c('option',{attrs:{"value":"Vandt opgaven"}},[_vm._v("Vandt opgaven")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1334 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndhentAnbefalinger_vue__ = __webpack_require__(1335);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1346f5b2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_IndhentAnbefalinger_vue__ = __webpack_require__(1336);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IndhentAnbefalinger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1346f5b2_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_IndhentAnbefalinger_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1335 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(25);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'jule',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_3__haandvaerker__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    Vue: __WEBPACK_IMPORTED_MODULE_4_vue__["default"]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      showMobile: false,
      showXXL: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: '',
        mobile: ''
      },
      customers: []
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      if (screen.width <= 640) {
        this.showMobile = true;
      } else {
        this.showMobile = false;
      }
      if (screen.width >= 1000) {
        this.showXXL = true;
      } else {
        this.showXXL = false;
      }
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.images = res.resultImages;
        if (_this.images.length !== 0) {
          _this.imgPicked = _this.images[0].FileLocation;
        }
      }, function (response) {
        alert('error');
      });
    },
    service_jule_action: function service_jule_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'service_invite_action', salesPerson: this.salesPerson, levid: this.haaId, customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customers), imgPicked: this.imgPicked, bcc: this.consent };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.customers = [];
          _this2.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, _this2.customer));
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    addCustomer: function addCustomer() {
      this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    },
    delCustomer: function delCustomer(index) {
      __WEBPACK_IMPORTED_MODULE_4_vue__["default"].delete(this.customers, index);
    }
  },
  created: function created() {
    this.customers.push(__WEBPACK_IMPORTED_MODULE_4_vue__["default"].util.extend({}, this.customer));
    this.Reload();
  }
});

/***/ }),
/* 1336 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4 py3"},[_c('div',{staticClass:"clearfix gibson px3 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow"},[_c('div',{staticClass:"col-12 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Indhent anbefalinger")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-start items-center mb3"},[_c('div',{staticClass:"col-12 flex flex-column justify-center items-center px3 mt3"},[_c('b-img',{attrs:{"src":"static/svg/hired.svg","width":"64","height":"64"}}),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 my2"},[_vm._v("\n                Få anbefalinger\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column justify-center items-center px3 mt3"},[_c('b-img',{attrs:{"src":"static/svg/files.svg","width":"64","height":"64"}}),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 my2"},[_vm._v("\n                Skil dig ud og bliv set\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex flex-column justify-center items-center px3 mt3"},[_c('b-img',{attrs:{"src":"static/svg/target.svg","width":"64","height":"64"}}),_vm._v(" "),_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 my2"},[_vm._v("\n                Få flere kunder\n              ")])],1)]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb2"},[_vm._v("\n            Gode anbefalinger fra dine tidligere kunder er nøglen til at få flere nye kunder.\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb2"},[_vm._v("\n            Håndværker.dk gør det nu muligt for dig at hente anbefalinger fra kunder, som du har løst opgaver for uden om vores system. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse eller telefonnummer og klikke på ‘Send’-knappen\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Der er ikke begrænsning på antallet af kunder, som du kan sende til.\n          ")]),_vm._v(" "),_c('haandvaerker'),_vm._v(" "),_c('b-form',{staticClass:"collectReviewForm",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_jule_action.apply(null, arguments)}}},[_c('div',{staticClass:"py-2"}),_vm._v(" "),_vm._l((_vm.customers),function(customer,index){return _c('b-form-row',{key:index},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Navn"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"text","name":"customers[][name]","required":""},model:{value:(customer.name),callback:function ($$v) {_vm.$set(customer, "name", $$v)},expression:"customer.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"E-mail"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"email","name":"customers[][email]"},model:{value:(customer.email),callback:function ($$v) {_vm.$set(customer, "email", $$v)},expression:"customer.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Mobil"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"tel","name":"customers[][mobile]"},model:{value:(customer.mobile),callback:function ($$v) {_vm.$set(customer, "mobile", $$v)},expression:"customer.mobile"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"2"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),(index !== 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.delCustomer(index)}}},[_c('span',{staticClass:"far fa-trash-alt"})]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"rounded ml-2",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{staticClass:"el-icon-circle-plus"})]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"8"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded flex justify-center items-center",attrs:{"size":"lg","type":"submit","variant":"success"}},[_c('span',{staticClass:"mr2 white inline-block flex justify-center items-center"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_vm._v(" Send\n                ")])],1)])],2)],1)]),_vm._v(" "),_c('div',{staticClass:"py4"})]):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.showXXL)?_c('div',{staticClass:"clearfix px0 mb4 ml4"},[_c('div',{staticClass:"flex flex-column p2 py3 gibson"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-7 flex justify-start items-center mb3"},[_c('div',{staticClass:"flex flex-column justify-center items-center px3"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Få anbefalinger\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/hired.svg","width":"64","height":"64"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center px3 primarycolor"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Skil dig ud og bliv set\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/files.svg","width":"64","height":"64"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center px3"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Få flere kunder\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/target.svg","width":"64","height":"64"}})],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-8"},[_c('haandvaerker'),_vm._v(" "),_c('b-form',{staticClass:"collectReviewForm",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_jule_action.apply(null, arguments)}}},[_c('div',{staticClass:"py-2"}),_vm._v(" "),_vm._l((_vm.customers),function(customer,index){return _c('b-form-row',{key:index},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Navn"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"text","name":"customers[][name]","required":""},model:{value:(customer.name),callback:function ($$v) {_vm.$set(customer, "name", $$v)},expression:"customer.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"E-mail"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"email","name":"customers[][email]"},model:{value:(customer.email),callback:function ($$v) {_vm.$set(customer, "email", $$v)},expression:"customer.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Mobil"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"tel","name":"customers[][mobile]"},model:{value:(customer.mobile),callback:function ($$v) {_vm.$set(customer, "mobile", $$v)},expression:"customer.mobile"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"2"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),(index !== 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.delCustomer(index)}}},[_c('span',{staticClass:"far fa-trash-alt"})]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"rounded ml-2",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{staticClass:"el-icon-circle-plus"})]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"py-3"}),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"8"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded flex justify-center items-center",attrs:{"size":"lg","type":"submit","variant":"success"}},[_c('span',{staticClass:"mr2 inline-block flex justify-center items-center white"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_vm._v(" Send\n                ")])],1)])],2)],1)])]):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix px0 mb4 ml4"},[_c('div',{staticClass:"flex flex-column p2 py3 gibson"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start justify-around items-center mb3"},[_c('div',{staticClass:"flex flex-column justify-center items-center px6"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Få anbefalinger\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/hired.svg","width":"64","height":"64"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center px6 primarycolor"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Skil dig ud og bliv set\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/files.svg","width":"64","height":"64"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center px6"},[_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n              Få flere kunder\n            ")]),_vm._v(" "),_c('b-img',{attrs:{"src":"static/svg/target.svg","width":"64","height":"64"}})],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:" col-12 center"},[_c('haandvaerker'),_vm._v(" "),_c('b-form',{staticClass:"collectReviewForm",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.service_jule_action.apply(null, arguments)}}},[_c('div',{staticClass:"py-2"}),_vm._v(" "),_vm._l((_vm.customers),function(customer,index){return _c('b-form-row',{key:index},[_c('b-col',{attrs:{"sm":"12","md":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"Navn"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"text","name":"customers[][name]","required":""},model:{value:(customer.name),callback:function ($$v) {_vm.$set(customer, "name", $$v)},expression:"customer.name"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"4"}},[_c('b-form-group',{attrs:{"label":"E-mail"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"email","name":"customers[][email]"},model:{value:(customer.email),callback:function ($$v) {_vm.$set(customer, "email", $$v)},expression:"customer.email"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"3"}},[_c('b-form-group',{attrs:{"label":"Mobil"}},[_c('b-form-input',{staticClass:"muted-background gibson darkblue p2 border-blue not-rounded h5",attrs:{"type":"tel","name":"customers[][mobile]"},model:{value:(customer.mobile),callback:function ($$v) {_vm.$set(customer, "mobile", $$v)},expression:"customer.mobile"}})],1)],1),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"1"}},[_c('div',{staticClass:"py-3"}),_vm._v(" "),(index !== 0)?_c('b-button',{staticClass:"rounded",attrs:{"size":"sm","variant":"outline-danger"},on:{"click":function($event){return _vm.delCustomer(index)}}},[_c('span',{staticClass:"far fa-trash-alt"})]):_vm._e(),_vm._v(" "),_c('b-button',{staticClass:"rounded ml-2",attrs:{"size":"sm","variant":"outline-success"},on:{"click":function($event){return _vm.addCustomer()}}},[_c('span',{staticClass:"el-icon-circle-plus"})]),_vm._v(" "),_c('div',{staticClass:"py-2"})],1)],1)}),_vm._v(" "),_c('div',{staticClass:"justify-around py-3"}),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"12","lg":"12"}},[_c('div',{staticClass:"d-flex justify-content-center"},[_c('b-btn',{staticClass:"rounded flex justify-center items-center",attrs:{"size":"lg","type":"submit","variant":"success"}},[_c('span',{staticClass:"white mr2 inline-block flex justify-center items-center"},[_c('svg',{staticClass:"jam jam-chevrons-circle-right-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -2 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M10 20C4.477 20 0 15.523 0 10S4.477 0 10 0s10 4.477 10 10-4.477 10-10 10zm3.175-9.976l-2.122 2.121a1 1 0 0 0 1.414 1.414l2.829-2.828a1 1 0 0 0 0-1.414l-2.829-2.829a1 1 0 1 0-1.414 1.415l2.122 2.12zm-4.99 0l-2.121 2.121a1 1 0 0 0 1.414 1.414l2.828-2.828a1 1 0 0 0 0-1.414L7.478 6.488a1 1 0 0 0-1.414 1.415l2.121 2.12z"}})])]),_vm._v(" Send\n                ")])],1)])],2)],1)])]):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Indhent anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5"},[_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Der er ikke begrænsning på antallet af kunder, som du kan sende til.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Indhent anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3 pb2"},[_vm._v("\n            Vi oplever at anbefalinger af håndværkernes udførte arbejde i stigende grad spiller en rolle, når bygherre skal vælge håndværkere.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3 pt2"},[_vm._v("\n            Håndværker.dk gør det nu muligt for dig at øge dine chancer for succes ved at lade dine kunder, som du har løst opgaver for uden om vores system, anbefale dit arbejde. Alt du skal gøre er at indtaste din kundes navn og e-mailadresse og klikke på linket.\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Der er ikke begrænsning på antallet af kunder, som du kan sende til.\n          ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadAnbefalinger_vue__ = __webpack_require__(1339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44334dbd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReadAnbefalinger_vue__ = __webpack_require__(1344);
function injectStyle (ssrContext) {
  __webpack_require__(1338)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReadAnbefalinger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44334dbd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReadAnbefalinger_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1338 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__CollectReview__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Reviews__ = __webpack_require__(317);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ReviewsDesktop__ = __webpack_require__(1340);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_rate_it__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'anbefalinger',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_1__haandvaerker__["a" /* default */],
    collectreviews: __WEBPACK_IMPORTED_MODULE_0__CollectReview__["a" /* default */],
    reviews: __WEBPACK_IMPORTED_MODULE_2__Reviews__["a" /* default */],
    reviewsdesktop: __WEBPACK_IMPORTED_MODULE_3__ReviewsDesktop__["a" /* default */],
    ImageRating: __WEBPACK_IMPORTED_MODULE_4_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      myHTML: '',
      recommendtions: 0,
      show: false,
      showMobile: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      items: [],
      ratingVal: [],
      ratingNocomment: false,
      images: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1000) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
    this.Reload();
  },

  methods: {
    hideModal: function hideModal() {
      this.$refs['filterReviewsModal'].hide();
    },
    UpdateAnb: function UpdateAnb(recommendtions) {
      this.recommendtions = recommendtions;
    },
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1340 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewsDesktop_vue__ = __webpack_require__(1342);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b371d0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewsDesktop_vue__ = __webpack_require__(1343);
function injectStyle (ssrContext) {
  __webpack_require__(1341)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ReviewsDesktop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3b371d0c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ReviewsDesktop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1341 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1342 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_rate_it__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'reviewsdesktop',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_2_vue_star_rating___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_3_vue_rate_it__["ImageRating"]
  },
  props: ['id'],
  data: function data() {
    return {
      rating: 0,
      show: false,
      loading: true,
      isLoadingReview: false,
      label: 'Loading...',
      overlay: 1,
      reviews: [],
      reviewShow: false,
      reviewslength: false,
      text: '',
      sampleReview: []
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      if (localStorage.getItem('haaid') === '0') {
        this.loading = false;
        return;
      }
      var data = { operation: 'anbefalinger', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.loading = false;
        _this.reviews = res;
        _this.show = false;
        if (_this.reviews.length === 0) {
          _this.reviewslength = true;
        }
      }, function (response) {
        alert('error');
      });
    },
    review_service: function review_service(item) {
      var _this2 = this;

      this.isLoadingReview = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var dataPartner = { operation: 'review_service', salesPerson: this.salesPerson, levid: this.haaId, item: item.ReviewId, note: item.SupplierRatingComment };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        _this2.isLoadingReview = false;
        if (res.success) {
          alert('Gennemført!');
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(review) {
      var _this3 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.show = true;
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'anbefalingerDetail', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this3.$router.push('/login');
        }
        _this3.show = false;
        _this3.reviewShow = !_this3.reviewShow;
        _this3.sampleReview = review;
        _this3.sampleReview.time = parseFloat(res.ContactRating);
        _this3.sampleReview.listen = parseFloat(res.AgreementRating);
        _this3.sampleReview.bargain = parseFloat(res.PriceRating);
        _this3.sampleReview.clean = parseFloat(res.CleaningRating);
        _this3.sampleReview.quality = parseFloat(res.WorkRating);
        _this3.sampleReview.recommend = parseFloat(res.RecommendRating);
        _this3.sampleReview.total = parseFloat(res.Rating);
      }, function (response) {
        alert('error');
      });
    },
    forceFileDownload: function forceFileDownload(response) {
      var url = window.URL.createObjectURL(new Blob([response.data]));
      var link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'file.png');
      document.body.appendChild(link);
      link.click();
    },
    downloadItemDetails: function downloadItemDetails(review, share) {
      var _this4 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      this.show = true;
      var data = { operation: 'anbefalingerDownload', salesPerson: this.salesPerson, levid: this.haaId, reviewId: review.ReviewId, reviewPic: review.ProfilePicPath };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.show = false;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          if (share === 1) {
            window.open('https://www.facebook.com/sharer/sharer.php?u=https://www.håndværker.dk/microsites/rating.php?id=' + review.ReviewId, '_blank');
          } else {
            var linkSource = 'data:image/jpg;base64,' + encodeURI(res.url);
            var downloadLink = document.createElement('a');
            var fileName = 'anbefaling' + review.ReviewId + '.jpg';
            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();
          }
        } else {
          alert('error');
          _this4.show = false;
        }
      }, function (response) {
        alert('error');
        _this4.show = false;
      });
    },
    hideModal: function hideModal() {
      this.reviewShow = false;
    },
    setRating: function setRating(rating) {
      this.sampleReview.rating = rating;
    }
  }
});

/***/ }),
/* 1343 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px0"},[(_vm.reviewslength)?_c('div',[_vm._m(0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[(_vm.loading)?_c('div',[_c('div',{staticClass:"loader"})]):_vm._e()]),_vm._v(" "),(_vm.reviews !== 0)?_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.reviews),function(review){return _c('div',{key:review.id,staticClass:"mx1 mb3 border muted-border shadow p3"},[_c('div',{staticClass:"flex flex-column mt1"},[_c('div',{staticClass:"flex justify-between items-center"},[_c('div',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":22,"spacing":1,"show-rating":false,"read-only":true},model:{value:(review.Rating),callback:function ($$v) {_vm.$set(review, "Rating", $$v)},expression:"review.Rating"}})],1),_vm._v(" "),_c('div',[(review.AssignmentDistributedCount === 1)?_c('span',{staticClass:"green"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])]):_c('span',{staticClass:"mediumgrey"},[_c('svg',{staticClass:"jam jam-shield-check-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-4 -1.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M.649 3.322L8 .565l7.351 2.757a1 1 0 0 1 .649.936v4.307c0 3.177-1.372 6.2-3.763 8.292L8 20.565l-4.237-3.708A11.019 11.019 0 0 1 0 8.565V4.258a1 1 0 0 1 .649-.936zm6.29 7.51L5.525 9.42a1 1 0 1 0-1.414 1.414l2.121 2.121a1 1 0 0 0 1.414 0l4.243-4.243a1 1 0 1 0-1.414-1.414l-3.536 3.536z"}})])])])])]),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"h6 darkblue mb0 relative"},[_vm._v(_vm._s(_vm.moment(review.RatedDate).format('ll')))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"h3 darkblue semi-bold my2 line-height-golden"},[_vm._v(_vm._s(review.RatedBy))])]),_vm._v(" "),_c('div',{},[_c('div',{staticClass:"clearfix flex flex-column"},[_c('div',{staticClass:"line-height-golden"},[_c('a',{staticClass:"block outlined-primary-button p1 px2 col-12 not-rounded gibson h5 mb2 flex justify-start items-center pointer no-hover",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.showItemDetails(review)}}},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"6px"}},[_c('svg',{attrs:{"fill":"currentColor","height":"36","viewBox":"0 -75 512 512","width":"36","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m446.019531 300.152344h-38c-5.519531 0-10-4.476563-10-10v-26.960938c0-6.78125-5.511719-12.292968-12.292969-12.292968h-6.53125v20.785156c0 7.183594-4.578124 13.527344-11.398437 15.789062-6.816406 2.253906-14.28125-.09375-18.570313-5.855468l-36.867187-49.503907c-4.960937-6.664062-4.960937-15.96875 0-22.628906l36.871094-49.507813c4.285156-5.757812 11.75-8.109374 18.566406-5.851562 6.820313 2.257812 11.398437 8.605469 11.398437 15.785156v22.984375h12.355469c35.550781 0 64.472657 28.921875 64.472657 64.472657v32.78125c-.003907 5.527343-4.480469 10.003906-10.003907 10.003906zm-28-20h18v-22.785156c0-24.519532-19.949219-44.46875-44.46875-44.46875h-18.929687c-7.402344 0-13.425782-6.023438-13.425782-13.429688v-19.394531l-30.328124 40.722656 30.328124 40.722656v-17.195312c0-7.402344 6.023438-13.425781 13.425782-13.425781h13.105468c17.808594 0 32.292969 14.484374 32.292969 32.292968zm0 0"}}),_c('path',{attrs:{"d":"m66.105469 153.820312c-5.523438 0-10 4.480469-10 10 0 5.523438 4.476562 10 10 10h.023437c5.523438 0 9.988282-4.476562 9.988282-10 0-5.519531-4.488282-10-10.011719-10zm0 0"}}),_c('path',{attrs:{"d":"m385.480469 108.523438c-3.675781 0-7.320313.15625-10.917969.46875v-67.351563c0-11.679687-4.835938-22.25-12.605469-29.820313-.121093-.125-.246093-.253906-.375-.375-7.773437-7.378906-17.953125-11.445312-28.660156-11.445312h-291.28125c-10.710937 0-20.886719 4.066406-28.664063 11.445312-.128906.125-.253906.25-.375.375-7.769531 7.570313-12.601562 18.140626-12.601562 29.820313v161.761719c0 10.492187 3.902344 20.089844 10.328125 27.417968.144531.183594.292969.363282.453125.539063 2.96875 3.273437 6.414062 6.023437 10.183594 8.175781 6.09375 3.503906 13.152344 5.507813 20.675781 5.507813h217.714844c5.113281 65.105469 59.730469 116.519531 126.125 116.519531 69.761719-.003906 126.519531-56.757812 126.519531-126.519531s-56.757812-126.519531-126.519531-126.519531zm-132.148438-13.785157-49.570312 43.707031c-4.699219 4.144532-10.589844 6.214844-16.480469 6.214844-4.511719 0-9.019531-1.210937-12.996094-3.640625-.242187-.148437-.484375-.300781-.722656-.460937-.402344-.261719-.792969-.539063-1.179688-.828125-.539062-.402344-1.070312-.832031-1.582031-1.285157l-49.570312-43.707031c-.003907 0-.003907 0-.003907 0l-84.203124-74.242187c1.488281-.324219 3.03125-.496094 4.617187-.496094h291.28125c1.582031 0 3.128906.171875 4.613281.496094l-84.164062 74.207031c-.011719.015625-.027344.023437-.039063.035156zm99.65625-61.203125c1.015625 2.503906 1.574219 5.242188 1.574219 8.105469v70.6875c-19.84375 4.96875-37.648438 14.519531-52.363281 27.386719l-28.542969-36.230469zm-311.648437 191.503906c-.015625 0-.03125 0-.042969 0-.085937 0-.171875-.003906-.257813-.003906-.015624 0-.027343-.003906-.046874-.003906-3.039063-.089844-6.003907-.824219-8.707032-2.121094l15.621094-19.824218c3.417969-4.339844 2.671875-10.625-1.667969-14.046876-4.335937-3.414062-10.625-2.667968-14.042969 1.667969l-12.039062 15.285157c-.101562-.847657-.15625-1.710938-.15625-2.589844v-161.761719c0-2.863281.558594-5.601563 1.574219-8.105469l79.332031 69.949219-16.78125 21.300781c-3.417969 4.339844-2.671875 10.625 1.667969 14.042969 4.339843 3.417969 10.625 2.675781 14.042969-1.664063l16.09375-20.433593 41.644531 36.71875c14.6875 12.949219 35.851562 14.667969 52.261719 5.152343 2.507812-1.453124 4.90625-3.171874 7.152343-5.152343l41.644531-36.71875 29.488282 37.433593c-6.953125 8.382813-12.832032 17.660157-17.445313 27.617188-.019531.039062-.035156.078125-.054687.117188-.03125.074218-.066406.144531-.101563.21875-6.195312 13.441406-9.992187 27.941406-11.164062 42.921874h-217.714844c-.101563.003907-.199219 0-.300781 0zm344.140625 116.519532c-58.734375 0-106.519531-47.78125-106.519531-106.519532 0-.214843.003906-.429687.003906-.644531 0-.070312 0-.144531 0-.214843.003906-.148438.003906-.292969.003906-.441407.003906-.070312.003906-.140625.003906-.210937 0-.011719 0-.019532 0-.027344.003906-.140625.003906-.285156.007813-.425781 0-.066407.003906-.136719.003906-.203125 0-.011719 0-.023438 0-.039063.003906-.136719.007813-.273437.007813-.410156.003906-.0625.003906-.121094.007812-.183594 0-.027343 0-.058593 0-.085937.003906-.136719.007812-.277344.011719-.417969.003906-.035156.003906-.074219.003906-.109375 0-.046875.003906-.089844.003906-.136719.003907-.160156.011719-.320312.015625-.480469 0-.007812.003906-.019531.003906-.027343 0-.042969 0-.085938.003907-.132813.007812-.191406.015625-.382812.023437-.574218 0-.015626 0-.035157.003906-.050782 2.527344-56.507812 49.289063-101.699218 106.410157-101.699218 58.734375 0 106.519531 47.78125 106.519531 106.515624 0 58.738282-47.785156 106.519532-106.519531 106.519532zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 line-height-1 pl1"},[_vm._v("Læs og besvar")])])]),_vm._v(" "),_c('div',{staticClass:"line-height-golden"},[_c('a',{staticClass:"block outlined-dark-button p1 pl2 flex justify-start items-center gibson border-none not-rounded mb1 pointer",on:{"click":function($event){return _vm.downloadItemDetails(review,0)}}},[_c('span',{staticClass:"relative mr1",staticStyle:{"top":"4px"}},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M406 187.5c-1.1-78.1-64.9-141.2-143.2-141.2 -34.8 0-68.4 12.7-94.5 35.7 -23.3 20.5-39.2 48-45.5 78.1 -0.5 0-0.9 0-1.4 0C54.4 160 0 214.4 0 281.3s54.4 121.3 121.3 121.3h44.5c6 0 10.9-4.9 10.9-10.9 0-6-4.9-10.9-10.9-10.9H121.3c-54.9 0-99.5-44.6-99.5-99.5s44.6-99.5 99.5-99.5c2.9 0 6 0.2 9.4 0.5 5.8 0.5 11-3.6 11.8-9.4 3.9-28.8 18.2-55.3 40.1-74.6 22.1-19.5 50.5-30.2 80.1-30.2 66.9 0 121.4 54.5 121.4 121.4 0 2.4-0.4 8.6-0.4 8.6 -0.2 3.2 1 6.4 3.3 8.6 2.3 2.2 5.5 3.3 8.7 3 2.9-0.3 5.8-0.4 8.7-0.4 47.3 0 85.8 38.5 85.8 85.8 0 47.3-38.5 85.8-85.8 85.8h-48.9c-6 0-10.9 4.9-10.9 10.9s4.9 10.9 10.9 10.9h48.9c59.3 0 107.6-48.3 107.6-107.6C512 236.3 464.6 188.3 406 187.5z"}}),_c('path',{attrs:{"d":"M262.8 97.5c-45.7 0-84.7 34.1-90.9 79.4 -0.8 6 3.4 11.5 9.3 12.3 6.4 0.9 11.5-3.9 12.3-9.3 4.7-34.5 34.5-60.5 69.3-60.5 6 0 10.9-4.9 10.9-10.9C273.7 102.4 268.8 97.5 262.8 97.5z"}}),_c('path',{attrs:{"d":"M313.3 410.3c-4-4.5-10.9-4.9-15.4-0.9l-26.3 23.5V298.5c0-6-4.9-10.9-10.9-10.9 -6 0-10.9 4.9-10.9 10.9v134.3l-26.3-23.5c-4.5-4-11.4-3.6-15.4 0.9 -4 4.5-3.6 11.4 0.9 15.4l39.7 35.5c3.4 3.1 7.7 4.6 12 4.6 4.3 0 8.6-1.5 12-4.6l39.7-35.5C316.9 421.7 317.3 414.8 313.3 410.3z"}})])]),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 line-height-1 pl1"},[_vm._v("Gem billede af anbefalingen")])])])]),_vm._v(" "),_c('button',{staticClass:"col-12 facebook-button p1 py2 mt1 pointer no-hover flex justify-start items-center",attrs:{"href":"javascript:void(0)"},on:{"click":function($event){return _vm.downloadItemDetails(review,1)}}},[_vm._m(1,true),_vm._v(" "),_c('span',{staticClass:"h6 semi-bold mb0 white left-align pl1"},[_vm._v("Del anbefaling på Facebook")])])])])}),0):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('b-modal',{ref:"reviewModal",attrs:{"centered":""},model:{value:(_vm.reviewShow),callback:function ($$v) {_vm.reviewShow=$$v},expression:"reviewShow"}},[_c('div',{staticClass:"clearfix px2 mb1"},[_c('div',{staticClass:"h6 darkblue semi-bold gibson pt2"},[_vm._v("\n          Din kunde "),_c('strong',[_vm._v(_vm._s(_vm.sampleReview.name))]),_vm._v(" har givet dig følgende vurdering\n        ")])]),_vm._v(" "),_c('div',{staticClass:"modal-content px2 gibson",staticStyle:{"border":"0"}},[_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Overholdte tidsaftaler")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"v-model":_vm.sampleReview.time,"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Lyttede til mine ønsker")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.listen),callback:function ($$v) {_vm.$set(_vm.sampleReview, "listen", $$v)},expression:"sampleReview.listen"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Overholdte økonomiske aftaler")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.bargain),callback:function ($$v) {_vm.$set(_vm.sampleReview, "bargain", $$v)},expression:"sampleReview.bargain"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Ryddedde op efter sig")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.clean),callback:function ($$v) {_vm.$set(_vm.sampleReview, "clean", $$v)},expression:"sampleReview.clean"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Leverede kvalitetsarbejde")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.quality),callback:function ($$v) {_vm.$set(_vm.sampleReview, "quality", $$v)},expression:"sampleReview.quality"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("På en skala – vil du anbefale os?")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.recommend),callback:function ($$v) {_vm.$set(_vm.sampleReview, "recommend", $$v)},expression:"sampleReview.recommend"}})],1)]),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-center mb2"},[_c('span',{staticClass:"h6 regular darkblue mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Samlet vurdering")]),_vm._v(" "),_c('span',[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.sampleReview.total),callback:function ($$v) {_vm.$set(_vm.sampleReview, "total", $$v)},expression:"sampleReview.total"}})],1)]),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('div',{staticClass:"h6 darkblue semi-bold mb2"},[_vm._v(_vm._s(_vm.sampleReview.AssignmentTitle))]),_vm._v(" "),_c('div',{staticClass:"darkblue line-height-golden",staticStyle:{"font-size":"0.75rem"},domProps:{"innerHTML":_vm._s(_vm.sampleReview.RatingComment)}})]),_vm._v(" "),_c('div',{staticClass:"flex flex-column"},[_c('div',{staticClass:"h6 darkblue semi-bold mb2"},[_vm._v("Kommentar")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.sampleReview.SupplierRatingComment),expression:"sampleReview.SupplierRatingComment"}],staticClass:"darkblue lightgrey-background line-height-golden",staticStyle:{"border":"0","font-size":"0.75rem"},attrs:{"variant":"secondary","id":"textarea1","placeholder":"Skriv en kommentar til anbefalingen her","rows":2,"max-rows":6},domProps:{"value":(_vm.sampleReview.SupplierRatingComment)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.sampleReview, "SupplierRatingComment", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-between items-center gibson pb3",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button px2 py1",attrs:{"slot":"modal-cancel","type":"button"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('span',{staticClass:"h6 semi-bold mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"standard-button px2 py1",attrs:{"type":"button"}},[_c('span',{staticClass:"h6 semi-bold mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Rapporter til CS")])]),_vm._v(" "),_c('button',{staticClass:"action-button px2 py1",attrs:{"slot":"modal-ok","type":"submit","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.review_service(_vm.sampleReview)}},slot:"modal-ok"},[_c('span',{staticClass:"h6 semi-bold mb0",staticStyle:{"font-size":"0.75rem"}},[_vm._v("Gem kommentar")])])])])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix p3 my3 lightgrey-background flex justify-start items-center"},[_c('p',{staticClass:"h5 darkblue mb0 line-height-golden"},[_vm._v("Ingen anbefalinger")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1 relative",staticStyle:{"top":"-4px"}},[_c('img',{attrs:{"src":"/static/svg/facebook.svg","alt":"","width":"20","height":"20"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1344 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[_c('div',{staticClass:"clearfix gibson px3 mb2"},[(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix  mb1"},[_c('div',{staticClass:"col-12 px0 mt0"},[(_vm.recommendtions !== 0)?_c('p',{staticClass:"h5 primarycolor line-height-golden gibson mb2"},[_vm._v("Du har modtaget "+_vm._s(_vm.recommendtions)+" anbefalinger inden for den sidste måned - godt gået!")]):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mt3 gibson"},[_c('p',{staticClass:"h3 semi-bold line-height-2 mt4 mb3 darkblue"},[_vm._v("Læs og besvar dine anbefalinger")]),_vm._v(" "),_c('b-collapse',{attrs:{"id":"filterReviews"}},[_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"clearfix py1 mt2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 darkblue gibson mb2"},[_vm._v("Antal stjerner")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":5,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":4,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":3,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":2,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":1,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',[_c('input',{staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox"}})]),_vm._v(" "),_c('div',{staticClass:"px2 relative",staticStyle:{"top":"-3px"}},[_c('p',{staticClass:"h5 gibson darkblue mb0"},[_vm._v("\n                      Ubesvarede anbefalinger\n                    ")])])])])])]),_vm._v(" "),_c('haandvaerker')],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.filterReviews",modifiers:{"filterReviews":true}}],staticClass:"outlined-standard-button gibson p2 col-12 not-rounded flex justify-center items-center line-height-1 my2"},[_c('span',{staticClass:"h4 semi-bold pr2"},[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"-1px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"-1px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('collectreviews')],1)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('reviews',{attrs:{"ratingVal":_vm.ratingVal,"premonth":_vm.items.premonth,"ratingNocomment":_vm.ratingNocomment},on:{"UpdateAnb":_vm.UpdateAnb}})],1):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.showXXL)?_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"clearfix flex justify-start items-center"},[_c('div',{staticClass:"col-9 mx1 mt3 gibson pl0 mb3"},[(_vm.recommendtions !== 0)?_c('p',{staticClass:"h5 primarycolor line-height-golden gibson mb0"},[_vm._v("Du har modtaget "+_vm._s(_vm.recommendtions)+" anbefalinger inden for den sidste måned - godt gået!")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-start"},[_vm._m(2),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.filterReviews",modifiers:{"filterReviews":true}}],staticClass:"outlined-standard-button h5 gibson p2 not-rounded flex justify-center items-center"},[_c('span',[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-modal',{ref:"filterReviewsModal",attrs:{"hide-footer":"","id":"filterReviews"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 mb2"},[_vm._v("\n                Filtrer\n              ")])]},proxy:true},{key:"modal-footer",fn:function(){return [_c('div',{staticClass:"col-12 flex justify-start px0"},[_c('button',{staticClass:"outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])])])]},proxy:true}],null,false,2977315322)},[_vm._v(" "),_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"clearfix py1 mt2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h5 darkblue gibson regular mb2"},[_vm._v("Antal stjerner")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"5"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"5")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="5",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":5,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"4"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"4")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="4",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":4,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"3"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"3")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="3",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":3,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"2"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"2")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="2",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":2,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"1")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":1,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingNocomment),expression:"ratingNocomment"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.ratingNocomment)?_vm._i(_vm.ratingNocomment,"1")>-1:(_vm.ratingNocomment)},on:{"change":function($event){var $$a=_vm.ratingNocomment,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingNocomment=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingNocomment=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingNocomment=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2 relative",staticStyle:{"top":"-3px"}},[_c('p',{staticClass:"h5 regular gibson darkblue mb0"},[_vm._v("\n                      Ubesvaret anbefalinger\n                    ")])])])])])]),_vm._v(" "),_c('haandvaerker')],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('reviews',{attrs:{"ratingVal":_vm.ratingVal,"premonth":_vm.items.premonth,"ratingNocomment":_vm.ratingNocomment},on:{"UpdateAnb":_vm.UpdateAnb}})],1):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"col-12 pl4"},[_c('div',{staticClass:"clearfix flex justify-start items-center"},[_c('div',{staticClass:"col-12 mx1 mt3 gibson pl0 mb4"},[(_vm.recommendtions !== 0)?_c('p',{staticClass:"h5 primarycolor line-height-golden gibson mb3"},[_vm._v("Du har modtaget "+_vm._s(_vm.recommendtions)+" anbefalinger inden for den sidste måned - godt gået!")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex justify-between items-start"},[_vm._m(4),_vm._v(" "),_c('button',{directives:[{name:"b-modal",rawName:"v-b-modal.filterReviews",modifiers:{"filterReviews":true}}],staticClass:"outlined-standard-button h5 gibson p2 not-rounded flex justify-center items-center"},[_c('span',[_vm._v("Filter")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"16","height":"16","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])])]),_vm._v(" "),_c('b-modal',{ref:"filterReviewsModal",attrs:{"hide-footer":"","centered":"","size":"sm","id":"filterReviews"},scopedSlots:_vm._u([{key:"modal-title",fn:function(){return [_c('p',{staticClass:"h5 semi-bold darkblue gibson line-height-1 my2"},[_vm._v("\n                Filtrer\n              ")])]},proxy:true},{key:"modal-footer",fn:function(){return [_c('div',{staticClass:"col-12 flex justify-center px0"},[_c('button',{staticClass:"outlined-disabled-button h5 gibson not rounded line-height-1 flex justify-start p2 items-center",on:{"click":_vm.hideModal}},[_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("Luk")])])])]},proxy:true}],null,false,593354154)},[_vm._v(" "),_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"clearfix p2 mt2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h6 darkblue semi-bold gibson mb2"},[_vm._v("Antal stjerner")])]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"5"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"5")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="5",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":5,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"4"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"4")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="4",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":4,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"3"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"3")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="3",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":3,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"2"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"2")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="2",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":2,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingVal),expression:"ratingVal"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.ratingVal)?_vm._i(_vm.ratingVal,"1")>-1:(_vm.ratingVal)},on:{"change":function($event){var $$a=_vm.ratingVal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingVal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingVal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingVal=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":18,"spacing":1,"show-rating":false,"rating":1,"read-only":true}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-start items-center mt3 mb2"},[_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ratingNocomment),expression:"ratingNocomment"}],staticClass:"shadow",staticStyle:{"width":"18px","height":"18px","outline":"none"},attrs:{"type":"checkbox","value":"1"},domProps:{"checked":Array.isArray(_vm.ratingNocomment)?_vm._i(_vm.ratingNocomment,"1")>-1:(_vm.ratingNocomment)},on:{"change":function($event){var $$a=_vm.ratingNocomment,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v="1",$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.ratingNocomment=$$a.concat([$$v]))}else{$$i>-1&&(_vm.ratingNocomment=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.ratingNocomment=$$c}}}})]),_vm._v(" "),_c('div',{staticClass:"px2 relative",staticStyle:{"top":"-3px"}},[_c('p',{staticClass:"h6 semi-bold gibson darkblue mb0"},[_vm._v("\n                      Ubesvaret anbefalinger\n                    ")])])])])])]),_vm._v(" "),_c('haandvaerker')],1)]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('reviews',{attrs:{"ratingVal":_vm.ratingVal,"premonth":_vm.items.premonth,"ratingNocomment":_vm.ratingNocomment},on:{"UpdateAnb":_vm.UpdateAnb}})],1):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0 mt1"},[_c('a',{staticClass:"outlined-primary-button p2 gibson not-rounded flex justify-center items-center col-12",attrs:{"href":"#/auto-anbefalinger"}},[_c('p',{staticClass:"h5 gibson line-height-1 mb0 pr1 flex-none semi-bold left-align"},[_vm._v("\n              Sæt anbefalinger på autopilot\n            ")]),_vm._v(" "),_c('i',{staticClass:"el-icon-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 lightgrey-background py2 mb2"},[_c('span',{staticClass:"h5 darkblue"},[_vm._v("NY MULIGHED TIL DIG:")]),_vm._v(" "),_c('p',[_vm._v("Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:")]),_vm._v(" "),_c('p',[_vm._v("Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"h3 semi-bold line-height-2 mt2 mb1 darkblue"},[_vm._v("Læs og besvar dine anbefalinger")]),_vm._v(" "),_c('a',{attrs:{"href":"#/auto-anbefalinger"}},[_c('p',{staticClass:"h5 gibson line-height-golden primarycolor"},[_vm._v("\n                  Sæt anbefalinger på autopilot\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 lightgrey-background py2 mb2"},[_c('span',{staticClass:"h5 darkblue"},[_vm._v("NY MULIGHED TIL DIG:")]),_vm._v(" "),_c('p',[_vm._v("Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:")]),_vm._v(" "),_c('p',[_vm._v("Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{staticClass:"h3 semi-bold line-height-2 mt2 mb1 darkblue"},[_vm._v("Læs og besvar dine anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 gibson line-height-golden"},[_c('a',{staticClass:"primarycolor",attrs:{"href":"#/auto-anbefalinger"}},[_vm._v("\n                  Sæt anbefalinger på autopilot\n                ")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 lightgrey-background py2 mb2"},[_c('span',{staticClass:"h5 darkblue"},[_vm._v("NY MULIGHED TIL DIG:")]),_vm._v(" "),_c('p',[_vm._v("Har kunden angivet den forkerte fag-kategori i sin anbefaling? Du kan anmode om en ændring ved at følge disse trin:")]),_vm._v(" "),_c('p',[_vm._v("Klik rapporter anbefaling → vælg indstilling: ‘forkert kategori’ → begrund din ændring → klik ‘anmod om ændring’")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1345 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Widgets_vue__ = __webpack_require__(1346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51da6506_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Widgets_vue__ = __webpack_require__(1347);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Widgets_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_51da6506_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Widgets_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1346 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haandvaerker__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ratingWidget__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__commentWidget__ = __webpack_require__(213);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'widgets',
  components: {
    Haandvaerker: __WEBPACK_IMPORTED_MODULE_0__haandvaerker__["a" /* default */],
    ratingWidget: __WEBPACK_IMPORTED_MODULE_1__ratingWidget__["a" /* default */],
    commentWidget: __WEBPACK_IMPORTED_MODULE_2__commentWidget__["a" /* default */]
  },
  data: function data() {
    return {
      show: false,
      label: 'Loading...',
      overlay: 1,
      salesPerson: '',
      haaId: '',
      ratingwidget: '',
      commentwidget: '',
      items: [],
      images: [],
      showMobile: false
    };
  },
  created: function created() {
    this.Reload();
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.ratingwidget = res.ratingwidget;
        _this.commentwidget = res.commentwidget;
      }, function (response) {
        alert('error');
      });
    }
  }
});

/***/ }),
/* 1347 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('haandvaerker'),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"col-12 px0"},[_vm._m(0),_vm._v(" "),(_vm.haaId !== '0')?_c('div',{staticClass:"clearfix mt2"},[_c('div',{staticClass:"col-12 mb2 px0"},[_c('div',{},[_c('div',{staticClass:"clearfix px0"},[_c('div',{staticClass:"col-12 px2 darkblue gibson"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 mt3 mb2"},[_vm._v("Banner med anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden"},[_vm._v("\n                  Du kan indsætte dette banner, som viser antal anbefalinger og din gennemsnitlige anbefalingsscore.\n                ")]),_vm._v(" "),_c('collectreviews')],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('b-collapse',{attrs:{"visible":"","id":"collapse5"}},[_c('ratingWidget',{attrs:{"items":_vm.items,"ratingwidget":_vm.ratingwidget}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 mb2 px0"},[_c('div',{staticClass:"clearfix px0"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-12 p2"},[_c('b-collapse',{attrs:{"visible":"","id":"collapse6"}},[_c('commentWidget',{attrs:{"items":_vm.items,"commentwidget":_vm.commentwidget}})],1)],1)])])]):_vm._e()]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"col-12 pl4 px0"},[_vm._m(2),_vm._v(" "),(_vm.haaId !== '0')?_c('div',{staticClass:"clearfix flex items-stretch mt2 pl4"},[_c('div',{staticClass:"col col-4 mr2 mb2 px0 items-stretch"},[_c('div',{},[_c('div',{staticClass:"clearfix px0"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 mt3 mb2 darkblue"},[_vm._v("Banner med anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n                  Du kan indsætte dette banner, som viser antal anbefalinger og din gennemsnitlige anbefalingsscore.\n                ")]),_vm._v(" "),_c('collectreviews')],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0"},[_c('b-collapse',{attrs:{"visible":"","id":"collapse5"}},[_c('ratingWidget',{attrs:{"items":_vm.items,"ratingwidget":_vm.ratingwidget}})],1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"col col-4 mb2 px0 items-stretch"},[_c('div',{staticClass:"clearfix px0"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 p2"},[_c('b-collapse',{staticClass:"mt2",attrs:{"visible":"","id":"collapse6"}},[_c('commentWidget',{attrs:{"items":_vm.items,"commentwidget":_vm.commentwidget}})],1)],1)])])]):_vm._e()]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"py4"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3 mb3"},[_c('div',{staticClass:"col-12 gibson"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Få anbefalingsbannere til din hjemmeside")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Med anbefalingsbannerne tiltrækker du nye kunder, fordi de kan se, at dine tidligere kunder er tilfredse."),_c('br'),_vm._v(" "),_c('span',{staticClass:"semi-bold block"},[_vm._v("Sådan gør du:")]),_vm._v(" "),_c('ul',{staticClass:"list-reset my2 px0",staticStyle:{"list-style-type":"square","list-style-position":"inside"}},[_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Kopiér teksten ved at trykke på den grønne knap herunder")]),_vm._v(" "),_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Send teksten til den person, som har lavet din hjemmeside og bed vedkommende sætte banneret på din hjemmeside")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2 darkblue gibson"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 my2"},[_vm._v("Banner med udtalelser fra kunder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular line-height-golden"},[_vm._v("\n                Du kan også indsætte dette banner, som viser udtalelser fra dine kunder.\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt3 mb3 pl4"},[_c('div',{staticClass:"col-6 gibson"},[_c('p',{staticClass:"h3 semi-bold line-height-2 my2 darkblue"},[_vm._v("Få anbefalingsbannere til din hjemmeside")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mb3"},[_vm._v("\n            Med anbefalingsbannerne tiltrækker du nye kunder, fordi de kan se, at dine tidligere kunder er tilfredse."),_c('br'),_vm._v("\n            Bannerne kan hjælpe dig til at blive placeret bedre på Google "),_c('br'),_c('br'),_vm._v("\n            Sådan får du dit anbefalingsbanner på din egen hjemmeside. "),_c('br'),_vm._v(" "),_c('span',{staticClass:"semi-bold block"},[_vm._v("Sådan gør du:")]),_vm._v(" "),_c('ul',{staticClass:"list-reset my2 px0",staticStyle:{"list-style-type":"square","list-style-position":"inside"}},[_c('li',{staticClass:"px2 my1 h5 regular line-height-golden"},[_vm._v("Kopiér teksten ved at trykke på den grønne knap herunder")]),_vm._v(" "),_c('li',{staticClass:"px2 my1 h5 regular line-height-golden mb3"},[_vm._v("Send teksten til den person, som har lavet din hjemmeside og bed vedkommende sætte banneret på din hjemmeside")])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 mt3 semi-bold line-height-2 my2 darkblue"},[_vm._v("Banner med udtalelser fra kunder")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden"},[_vm._v("\n                Du kan også indsætte dette banner, som viser udtalelser fra dine kunder.\n              ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1348 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllSettings_vue__ = __webpack_require__(1350);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4bf58a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AllSettings_vue__ = __webpack_require__(1351);
function injectStyle (ssrContext) {
  __webpack_require__(1349)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-1b4bf58a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AllSettings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b4bf58a_hasScoped_true_node_modules_vue_loader_lib_selector_type_template_index_0_AllSettings_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1349 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1350 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__noneligibleFeaturepop__ = __webpack_require__(43);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    noneligibleFeaturepop: __WEBPACK_IMPORTED_MODULE_0__noneligibleFeaturepop__["a" /* default */]
  },
  data: function data() {
    return {
      hover: false,
      hoverUddanelseBevis: false,
      eligible: ''
    };
  },
  created: function created() {
    this.eligible = localStorage.getItem('PartnerAccountingInteg');
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (screen.width >= 1300) {
      this.showXXL = true;
    } else {
      this.showXXL = false;
    }
  },

  methods: {
    getdataigibility: function getdataigibility(linkiftrue) {
      if (this.eligible === 'false') {
        this.$refs.noneligibleFeaturepop.showmodel(this.eligible, '', 'PartnerAccountingInteg');
      } else {
        this.$router.push(linkiftrue);
      }
    }
  }
});

/***/ }),
/* 1351 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 mb2"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix mt2 mb4 py3"},[[(_vm.showMobile)?_c('div',{staticClass:"col-12"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 my2"},[_vm._v("Indstillinger")]),_vm._v(" "),_c('div',{staticClass:"clearfix py2 h5 regular darkblue gibson"},[_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/stamoplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","hwight":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Dine stamoplysninger")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/profilside"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256 0C162.2 0 80 82.2 80 176c0 93.5 81.8 176 176 176 95.1 0 176-83.4 176-176C432 82.2 349.8 0 256 0zM256 332c-31.4 0-63.1-10.8-89.9-30.5C168.4 253.9 207.7 216 256 216c48.3 0 87.6 37.9 89.9 85.5C319.1 321.2 287.4 332 256 332zM206 146c0-27.6 22.4-50 50-50s50 22.4 50 50 -22.4 50-50 50S206 173.6 206 146zM364.2 285.9c-7-38.2-33.8-69.1-68.2-82.5C314.1 190.8 326 169.8 326 146c0-38.6-31.4-70-70-70 -38.6 0-70 31.4-70 70 0 23.8 11.9 44.8 30.1 57.4 -34.4 13.4-61.2 44.2-68.2 82.5C117.6 256.2 100 216.3 100 176c0-83.1 72.9-156 156-156s156 72.9 156 156C412 216.3 394.4 256.2 364.2 285.9z"}}),_c('path',{attrs:{"d":"M322.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L256 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C322.8 439.4 323.7 435.5 322.6 431.8zM277.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L256 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L277.6 455.6z"}}),_c('path',{attrs:{"d":"M162.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6L71.7 420.1l-34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L96 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C162.8 439.4 163.7 435.5 162.6 431.8zM117.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1 -1.6 0-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9L60.4 441.9l19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L96 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L117.6 455.6z"}}),_c('path',{attrs:{"d":"M482.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8 -1.2 3.6-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L416 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C482.8 439.4 483.7 435.5 482.6 431.8zM437.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L416 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L437.6 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("\n                  Din profilside\n                ")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-opgavetyper"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M46 0c-7.2 0-13.1 5.9-13.1 13.1v118.1c0 7.2 5.9 13.1 13.1 13.1 7.2 0 13.1-5.9 13.1-13.1V13.1C59.1 5.9 53.2 0 46 0z"}}),_c('path',{attrs:{"d":"M75.5 302H28.9V269.2h46.6c7.2 0 12.5-6 12.5-13.2v-59.1c0-7.2-5.2-13-12.5-13H16.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.8 5.8-13.8 13v59.1c0 7.2 6.5 13.2 13.8 13.2h59.1c7.2 0 13.1-5.9 13.1-13.1S82.8 302 75.5 302z"}}),_c('path',{attrs:{"d":"M75.5 367.6H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h59.1c7.2 0 12.5-6 12.5-13.2V380.6C88 373.4 82.8 367.6 75.5 367.6z"}}),_c('path',{attrs:{"d":"M496.2 29H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 34.9 503.4 29 496.2 29z"}}),_c('path',{attrs:{"d":"M496.2 88H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 93.9 503.4 88 496.2 88z"}}),_c('path',{attrs:{"d":"M496.2 212.7H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 218.6 503.4 212.7 496.2 212.7z"}}),_c('path',{attrs:{"d":"M496.2 271.8H161.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1S503.4 271.8 496.2 271.8z"}}),_c('path',{attrs:{"d":"M496.2 389.9H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 395.8 503.4 389.9 496.2 389.9z"}}),_c('path',{attrs:{"d":"M496.2 455.6H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 461.4 503.4 455.6 496.2 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Opgavetyper")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-indstillinger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","height":"32","viewBox":"0 0 512 512","width":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"}})])]),_c('g',[_c('g',[_c('path',{attrs:{"d":"m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"}})])]),_c('path',{attrs:{"d":"m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Notifikationer")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/expire-subscription"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","hwight":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Dit abonnement")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-ferieperioder"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","height":"32","viewBox":"0 0 512 512","width":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m176 404.036c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.553 13.652-36.485 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.45 0 32.683-8.757 45.24-16.483 11.298-6.951 21.97-13.517 34.76-13.517s23.462 6.566 34.76 13.517c12.558 7.726 26.79 16.483 45.24 16.483 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.522 0 10-4.477 10-10s-4.478-10-10-10c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-12.79 0-23.462-6.566-34.76-13.517-12.558-7.726-26.79-16.483-45.24-16.483-1.431 0-2.827.07-4.208.17l-65.793-141.076c7.369-3.436 119.357-55.659 126.888-59.171 5.005-2.334 7.171-8.284 4.836-13.29l-12.68-27.19c-36.12-77.448-125.847-111.893-203.433-81.325l-8.588-18.414c-2.333-5.005-8.283-7.171-13.289-4.836-5.005 2.334-7.171 8.284-4.836 13.29l8.589 18.418c-73.56 40.018-104.326 131.196-68.46 208.112l12.68 27.19c2.342 5.021 8.306 7.161 13.29 4.836l126.877-59.166 64.112 137.469c-7.758 3.195-14.72 7.464-21.225 11.466-11.298 6.951-21.97 13.517-34.76 13.517zm-52.732-163.719c-23.508-52.929-51.074-152.726-22.403-166.097.001-.001.003-.001.004-.002 32.261-15.044 94.909 87.231 112.845 123.921zm163.65-98.384 8.453 18.127-63.528 29.625c-20.506-42.004-57.279-101.739-96.371-126.449 63.251-11.294 125.152 22.32 151.446 78.697zm-253.765 118.337c-27.362-58.68-10.402-126.848 37.054-166.56-6.178 45.86 15.902 112.282 34.93 155.061l-63.531 29.626z"}}),_c('path',{attrs:{"d":"m421 137.966c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-90c19.299 0 35 15.701 35 35s-15.701 35-35 35-35-15.701-35-35 15.701-35 35-35z"}}),_c('circle',{attrs:{"cx":"256","cy":"443.965","r":"10"}}),_c('path',{attrs:{"d":"m512 474.036c0-5.523-4.478-10-10-10-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-11.777 0-21.427-5.341-32.817-12.324-4.709-2.886-10.865-1.409-13.752 3.3s-1.409 10.865 3.299 13.752c10.515 6.445 24.915 15.272 43.271 15.272 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.521 0 9.999-4.477 9.999-10z"}}),_c('path',{attrs:{"d":"m10 484.036c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.355 0 32.756-8.827 43.271-15.272 4.708-2.887 6.186-9.043 3.299-13.752-2.886-4.708-9.042-6.187-13.752-3.3-11.391 6.982-21.04 12.324-32.817 12.324-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.113 7.021-23.554 13.652-36.486 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Ferieperioder")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/rediger-kreditkort-oplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Kreditkort")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/leverandoerservice"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","height":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Leverandørservice")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/balance"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","hwight":"32","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Faktura")])]),_vm._v(" "),_c('a',{staticClass:" pointer primarycolor col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility('/ordrestyring')},"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hover)?_c('b-img',{attrs:{"src":"../static/svg/ordrestyring2.svg","alt":"","width":"32"}}):_c('b-img',{attrs:{"src":"../static/svg/ordrestyring1.svg","alt":"","width":"32"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Ordrestyring")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/ekstraphone"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"32","viewBox":"0 0 512.00005 512","width":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m166.667969 413.871094c-5.171875 0-10.34375-1.640625-14.863281-4.921875-9.046876-6.574219-12.644532-17.691407-9.167969-28.320313l28.667969-87.570312-74.808594-54.105469c-9.050782-6.546875-12.679688-17.644531-9.238282-28.273437 3.441407-10.628907 12.882813-17.496094 24.054688-17.496094h92.34375l28.285156-87.511719c3.441406-10.632813 12.882813-17.503906 24.058594-17.503906 11.179688 0 20.621094 6.871093 24.058594 17.503906l28.289062 87.511719h92.34375c11.171875 0 20.613282 6.871094 24.050782 17.5 3.441406 10.628906-.183594 21.726562-9.238282 28.273437l-74.804687 54.101563 28.664062 87.570312c3.480469 10.628906-.117187 21.746094-9.167969 28.320313-9.046874 6.574219-20.730468 6.5625-29.765624-.03125l-74.429688-54.324219-74.425781 54.320312c-4.527344 3.304688-9.714844 4.957032-14.90625 4.957032zm-55.355469-200.6875c-3.46875 0-4.667969 2.558594-5.023438 3.65625-.359374 1.101562-.882812 3.875 1.929688 5.910156l80.722656 58.378906c3.519532 2.546875 4.996094 7.082032 3.640625 11.214844l-30.933593 94.507812c-1.082032 3.300782.976562 5.238282 1.914062 5.917969.9375.679688 3.414062 2.039063 6.21875-.007812l80.324219-58.625c3.515625-2.566407 8.28125-2.566407 11.792969 0l80.324218 58.625c2.800782 2.046875 5.28125.6875 6.21875.007812.9375-.679687 2.996094-2.617187 1.914063-5.917969l-30.933594-94.507812c-1.355469-4.132812.117187-8.667969 3.640625-11.214844l80.722656-58.378906c2.8125-2.035156 2.289063-4.808594 1.933594-5.910156-.355469-1.097656-1.558594-3.65625-5.027344-3.65625h-99.621094c-4.335937 0-8.179687-2.796875-9.511718-6.921875l-30.527344-94.4375c-1.066406-3.300781-3.871094-3.65625-5.027344-3.65625s-3.960937.355469-5.027344 3.65625l-30.527343 94.4375c-1.332031 4.125-5.175781 6.921875-9.511719 6.921875zm0 0"}}),_c('path',{attrs:{"d":"m255.9375 512c-6.53125 0-13.070312-.25-19.621094-.753906-60.835937-4.660156-118.132812-31.023438-161.335937-74.226563-48.351563-48.351562-74.980469-112.636719-74.980469-181.019531 0-68.378906 26.628906-132.667969 74.980469-181.019531 48.351562-48.351563 112.640625-74.980469 181.019531-74.980469 68.382812 0 132.667969 26.628906 181.023438 74.980469 43.199218 43.203125 69.5625 100.5 74.226562 161.335937 4.613281 60.175782-12.144531 120.15625-47.183594 168.898438-3.222656 4.484375-9.472656 5.503906-13.957031 2.28125s-5.503906-9.472656-2.28125-13.957032c67.726563-94.207031 57.234375-222.234374-24.949219-304.417968-92.015625-92.015625-241.738281-92.015625-333.753906 0-92.019531 92.019531-92.019531 241.738281 0 333.757812 82.183594 82.183594 210.207031 92.675782 304.417969 24.945313 4.484375-3.222657 10.734375-2.199219 13.957031 2.285156s2.199219 10.730469-2.285156 13.953125c-43.433594 31.230469-95.804688 47.9375-149.277344 47.9375zm0 0"}}),_c('path',{attrs:{"d":"m429.953125 439.953125c-2.632813 0-5.210937-1.070313-7.070313-2.933594-1.859374-1.859375-2.929687-4.4375-2.929687-7.066406 0-2.640625 1.070313-5.210937 2.929687-7.070313 1.859376-1.859374 4.429688-2.929687 7.070313-2.929687 2.628906 0 5.207031 1.066406 7.070313 2.929687 1.859374 1.859376 2.929687 4.4375 2.929687 7.070313 0 2.628906-1.070313 5.207031-2.929687 7.066406-1.863282 1.863281-4.441407 2.933594-7.070313 2.933594zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Dine telefonnumre")])]),_vm._v(" "),_c('a',{staticClass:"col-12 not-rounded primary-white-button p2 flex justify-start items-center no-hover",attrs:{"href":"#/password"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Layer_1","enable-background":"new 0 0 512.008 512.008","height":"32","viewBox":"0 0 512.008 512.008","width":"32","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1159_"}},[_c('g',{attrs:{"id":"XMLID_162_"}},[_c('path',{attrs:{"id":"XMLID_168_","d":"m299.305 381.008c-2.762-4.783-8.878-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_195_","d":"m162.305 381.008c-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.784-2.761-10.897-1.123-13.66 3.66-2.762 4.783-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_859_","d":"m349.703 431.008c1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.422-8.877 3.66-13.66-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66z"}}),_c('path',{attrs:{"id":"XMLID_860_","d":"m462.004 300.008h-160.937c-5.522 0-10 4.477-10 10s4.478 10 10 10h160.937c16.542 0 30 13.458 30 30v112c0 16.542-13.458 30-30 30h-412c-16.542 0-30-13.458-30-30v-112c0-16.542 13.458-30 30-30h161.063c5.522 0 10-4.477 10-10s-4.478-10-10-10h-161.063c-27.57 0-50 22.43-50 50v112c0 27.57 22.43 50 50 50h412c27.57 0 50-22.43 50-50v-112c0-27.57-22.43-50-50-50z"}}),_c('path',{attrs:{"id":"XMLID_861_","d":"m256.004 213.008c5.522 0 10-4.477 10-10v-42.725c0-5.523-4.478-10-10-10s-10 4.477-10 10v42.725c0 5.523 4.477 10 10 10z"}}),_c('path',{attrs:{"id":"XMLID_864_","d":"m184.004 276.008h144c23.159 0 42-18.841 42-42v-104.725c0-23.159-18.841-42-42-42h-2v-17.283c0-38.598-31.402-70-70-70s-70 31.402-70 70v17.283h-2c-23.159 0-42 18.841-42 42v104.725c0 23.159 18.841 42 42 42zm22-206.008c0-27.57 22.43-50 50-50s50 22.43 50 50v17.283h-100zm-44 59.283c0-12.131 9.869-22 22-22h144c12.131 0 22 9.869 22 22v104.725c0 12.131-9.869 22-22 22h-144c-12.131 0-22-9.869-22-22z"}}),_c('path',{attrs:{"id":"XMLID_1026_","d":"m256.063 320.074c2.63 0 5.21-1.07 7.07-2.93 1.87-1.86 2.93-4.44 2.93-7.07 0-2.64-1.06-5.21-2.93-7.07-1.86-1.86-4.44-2.93-7.07-2.93s-5.21 1.07-7.069 2.93c-1.86 1.86-2.931 4.43-2.931 7.07 0 2.63 1.07 5.21 2.931 7.07 1.86 1.86 4.44 2.93 7.069 2.93z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Skift kodeord")])]),_vm._v(" "),_c('a',{staticClass:"col-12 p2 inline-block not-rounded primary-white-button flex justify-start items-center no-hover",attrs:{"href":"#/uddannelsesbevis"},on:{"mouseover":function($event){_vm.hoverUddanelseBevis = true},"mouseleave":function($event){_vm.hoverUddanelseBevis = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hoverUddanelseBevis)?_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis2.svg","alt":"","width":"32"}}):_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis1.svg","alt":"","width":"32"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h4 regular mb0"},[_vm._v("Uddannelsesbevis")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/konto-update"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Bankverifikation")])])])]):_vm._e(),_vm._v(" "),(!_vm.showMobile && !_vm.showXXL)?_c('div',{staticClass:"clearfix ml4"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 my2"},[_vm._v("Indstillinger")]),_vm._v(" "),_c('div',{staticClass:"col-7 px0 flex flex-wrap py2 h5 regular darkblue gibson"},[_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/stamoplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dine stamoplysninger")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/profilside"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256 0C162.2 0 80 82.2 80 176c0 93.5 81.8 176 176 176 95.1 0 176-83.4 176-176C432 82.2 349.8 0 256 0zM256 332c-31.4 0-63.1-10.8-89.9-30.5C168.4 253.9 207.7 216 256 216c48.3 0 87.6 37.9 89.9 85.5C319.1 321.2 287.4 332 256 332zM206 146c0-27.6 22.4-50 50-50s50 22.4 50 50 -22.4 50-50 50S206 173.6 206 146zM364.2 285.9c-7-38.2-33.8-69.1-68.2-82.5C314.1 190.8 326 169.8 326 146c0-38.6-31.4-70-70-70 -38.6 0-70 31.4-70 70 0 23.8 11.9 44.8 30.1 57.4 -34.4 13.4-61.2 44.2-68.2 82.5C117.6 256.2 100 216.3 100 176c0-83.1 72.9-156 156-156s156 72.9 156 156C412 216.3 394.4 256.2 364.2 285.9z"}}),_c('path',{attrs:{"d":"M322.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L256 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C322.8 439.4 323.7 435.5 322.6 431.8zM277.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L256 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L277.6 455.6z"}}),_c('path',{attrs:{"d":"M162.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6L71.7 420.1l-34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L96 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C162.8 439.4 163.7 435.5 162.6 431.8zM117.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1 -1.6 0-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9L60.4 441.9l19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L96 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L117.6 455.6z"}}),_c('path',{attrs:{"d":"M482.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8 -1.2 3.6-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L416 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C482.8 439.4 483.7 435.5 482.6 431.8zM437.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L416 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L437.6 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("\n                  Din profilside\n                ")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-opgavetyper"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M46 0c-7.2 0-13.1 5.9-13.1 13.1v118.1c0 7.2 5.9 13.1 13.1 13.1 7.2 0 13.1-5.9 13.1-13.1V13.1C59.1 5.9 53.2 0 46 0z"}}),_c('path',{attrs:{"d":"M75.5 302H28.9V269.2h46.6c7.2 0 12.5-6 12.5-13.2v-59.1c0-7.2-5.2-13-12.5-13H16.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.8 5.8-13.8 13v59.1c0 7.2 6.5 13.2 13.8 13.2h59.1c7.2 0 13.1-5.9 13.1-13.1S82.8 302 75.5 302z"}}),_c('path',{attrs:{"d":"M75.5 367.6H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h59.1c7.2 0 12.5-6 12.5-13.2V380.6C88 373.4 82.8 367.6 75.5 367.6z"}}),_c('path',{attrs:{"d":"M496.2 29H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 34.9 503.4 29 496.2 29z"}}),_c('path',{attrs:{"d":"M496.2 88H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 93.9 503.4 88 496.2 88z"}}),_c('path',{attrs:{"d":"M496.2 212.7H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 218.6 503.4 212.7 496.2 212.7z"}}),_c('path',{attrs:{"d":"M496.2 271.8H161.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1S503.4 271.8 496.2 271.8z"}}),_c('path',{attrs:{"d":"M496.2 389.9H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 395.8 503.4 389.9 496.2 389.9z"}}),_c('path',{attrs:{"d":"M496.2 455.6H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 461.4 503.4 455.6 496.2 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Opgavetyper")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-indstillinger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","width":"24","height":"24","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"}})])]),_c('g',[_c('g',[_c('path',{attrs:{"d":"m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"}})])]),_c('path',{attrs:{"d":"m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Notifikationer")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/expire-subscription"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dit abonnement")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-ferieperioder"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","width":"24","height":"24","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m176 404.036c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.553 13.652-36.485 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.45 0 32.683-8.757 45.24-16.483 11.298-6.951 21.97-13.517 34.76-13.517s23.462 6.566 34.76 13.517c12.558 7.726 26.79 16.483 45.24 16.483 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.522 0 10-4.477 10-10s-4.478-10-10-10c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-12.79 0-23.462-6.566-34.76-13.517-12.558-7.726-26.79-16.483-45.24-16.483-1.431 0-2.827.07-4.208.17l-65.793-141.076c7.369-3.436 119.357-55.659 126.888-59.171 5.005-2.334 7.171-8.284 4.836-13.29l-12.68-27.19c-36.12-77.448-125.847-111.893-203.433-81.325l-8.588-18.414c-2.333-5.005-8.283-7.171-13.289-4.836-5.005 2.334-7.171 8.284-4.836 13.29l8.589 18.418c-73.56 40.018-104.326 131.196-68.46 208.112l12.68 27.19c2.342 5.021 8.306 7.161 13.29 4.836l126.877-59.166 64.112 137.469c-7.758 3.195-14.72 7.464-21.225 11.466-11.298 6.951-21.97 13.517-34.76 13.517zm-52.732-163.719c-23.508-52.929-51.074-152.726-22.403-166.097.001-.001.003-.001.004-.002 32.261-15.044 94.909 87.231 112.845 123.921zm163.65-98.384 8.453 18.127-63.528 29.625c-20.506-42.004-57.279-101.739-96.371-126.449 63.251-11.294 125.152 22.32 151.446 78.697zm-253.765 118.337c-27.362-58.68-10.402-126.848 37.054-166.56-6.178 45.86 15.902 112.282 34.93 155.061l-63.531 29.626z"}}),_c('path',{attrs:{"d":"m421 137.966c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-90c19.299 0 35 15.701 35 35s-15.701 35-35 35-35-15.701-35-35 15.701-35 35-35z"}}),_c('circle',{attrs:{"cx":"256","cy":"443.965","r":"10"}}),_c('path',{attrs:{"d":"m512 474.036c0-5.523-4.478-10-10-10-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-11.777 0-21.427-5.341-32.817-12.324-4.709-2.886-10.865-1.409-13.752 3.3s-1.409 10.865 3.299 13.752c10.515 6.445 24.915 15.272 43.271 15.272 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.521 0 9.999-4.477 9.999-10z"}}),_c('path',{attrs:{"d":"m10 484.036c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.355 0 32.756-8.827 43.271-15.272 4.708-2.887 6.186-9.043 3.299-13.752-2.886-4.708-9.042-6.187-13.752-3.3-11.391 6.982-21.04 12.324-32.817 12.324-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.113 7.021-23.554 13.652-36.486 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Ferieperioder")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/rediger-kreditkort-oplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Kreditkort")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/leverandoerservice"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Leverandørservice")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/balance"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Faktura")])]),_vm._v(" "),_c('a',{staticClass:" pointer primarycolor col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility('/ordrestyring')},"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hover)?_c('b-img',{attrs:{"src":"../static/svg/ordrestyring2.svg","alt":"","width":"25"}}):_c('b-img',{attrs:{"src":"../static/svg/ordrestyring1.svg","alt":"","width":"25"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Ordrestyring")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/ekstraphone"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"24","viewBox":"0 0 512.00005 512","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m166.667969 413.871094c-5.171875 0-10.34375-1.640625-14.863281-4.921875-9.046876-6.574219-12.644532-17.691407-9.167969-28.320313l28.667969-87.570312-74.808594-54.105469c-9.050782-6.546875-12.679688-17.644531-9.238282-28.273437 3.441407-10.628907 12.882813-17.496094 24.054688-17.496094h92.34375l28.285156-87.511719c3.441406-10.632813 12.882813-17.503906 24.058594-17.503906 11.179688 0 20.621094 6.871093 24.058594 17.503906l28.289062 87.511719h92.34375c11.171875 0 20.613282 6.871094 24.050782 17.5 3.441406 10.628906-.183594 21.726562-9.238282 28.273437l-74.804687 54.101563 28.664062 87.570312c3.480469 10.628906-.117187 21.746094-9.167969 28.320313-9.046874 6.574219-20.730468 6.5625-29.765624-.03125l-74.429688-54.324219-74.425781 54.320312c-4.527344 3.304688-9.714844 4.957032-14.90625 4.957032zm-55.355469-200.6875c-3.46875 0-4.667969 2.558594-5.023438 3.65625-.359374 1.101562-.882812 3.875 1.929688 5.910156l80.722656 58.378906c3.519532 2.546875 4.996094 7.082032 3.640625 11.214844l-30.933593 94.507812c-1.082032 3.300782.976562 5.238282 1.914062 5.917969.9375.679688 3.414062 2.039063 6.21875-.007812l80.324219-58.625c3.515625-2.566407 8.28125-2.566407 11.792969 0l80.324218 58.625c2.800782 2.046875 5.28125.6875 6.21875.007812.9375-.679687 2.996094-2.617187 1.914063-5.917969l-30.933594-94.507812c-1.355469-4.132812.117187-8.667969 3.640625-11.214844l80.722656-58.378906c2.8125-2.035156 2.289063-4.808594 1.933594-5.910156-.355469-1.097656-1.558594-3.65625-5.027344-3.65625h-99.621094c-4.335937 0-8.179687-2.796875-9.511718-6.921875l-30.527344-94.4375c-1.066406-3.300781-3.871094-3.65625-5.027344-3.65625s-3.960937.355469-5.027344 3.65625l-30.527343 94.4375c-1.332031 4.125-5.175781 6.921875-9.511719 6.921875zm0 0"}}),_c('path',{attrs:{"d":"m255.9375 512c-6.53125 0-13.070312-.25-19.621094-.753906-60.835937-4.660156-118.132812-31.023438-161.335937-74.226563-48.351563-48.351562-74.980469-112.636719-74.980469-181.019531 0-68.378906 26.628906-132.667969 74.980469-181.019531 48.351562-48.351563 112.640625-74.980469 181.019531-74.980469 68.382812 0 132.667969 26.628906 181.023438 74.980469 43.199218 43.203125 69.5625 100.5 74.226562 161.335937 4.613281 60.175782-12.144531 120.15625-47.183594 168.898438-3.222656 4.484375-9.472656 5.503906-13.957031 2.28125s-5.503906-9.472656-2.28125-13.957032c67.726563-94.207031 57.234375-222.234374-24.949219-304.417968-92.015625-92.015625-241.738281-92.015625-333.753906 0-92.019531 92.019531-92.019531 241.738281 0 333.757812 82.183594 82.183594 210.207031 92.675782 304.417969 24.945313 4.484375-3.222657 10.734375-2.199219 13.957031 2.285156s2.199219 10.730469-2.285156 13.953125c-43.433594 31.230469-95.804688 47.9375-149.277344 47.9375zm0 0"}}),_c('path',{attrs:{"d":"m429.953125 439.953125c-2.632813 0-5.210937-1.070313-7.070313-2.933594-1.859374-1.859375-2.929687-4.4375-2.929687-7.066406 0-2.640625 1.070313-5.210937 2.929687-7.070313 1.859376-1.859374 4.429688-2.929687 7.070313-2.929687 2.628906 0 5.207031 1.066406 7.070313 2.929687 1.859374 1.859376 2.929687 4.4375 2.929687 7.070313 0 2.628906-1.070313 5.207031-2.929687 7.066406-1.863282 1.863281-4.441407 2.933594-7.070313 2.933594zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dine telefonnumre")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/password"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Layer_1","enable-background":"new 0 0 512.008 512.008","width":"24","height":"24","viewBox":"0 0 512.008 512.008","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1159_"}},[_c('g',{attrs:{"id":"XMLID_162_"}},[_c('path',{attrs:{"id":"XMLID_168_","d":"m299.305 381.008c-2.762-4.783-8.878-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_195_","d":"m162.305 381.008c-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.784-2.761-10.897-1.123-13.66 3.66-2.762 4.783-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_859_","d":"m349.703 431.008c1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.422-8.877 3.66-13.66-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66z"}}),_c('path',{attrs:{"id":"XMLID_860_","d":"m462.004 300.008h-160.937c-5.522 0-10 4.477-10 10s4.478 10 10 10h160.937c16.542 0 30 13.458 30 30v112c0 16.542-13.458 30-30 30h-412c-16.542 0-30-13.458-30-30v-112c0-16.542 13.458-30 30-30h161.063c5.522 0 10-4.477 10-10s-4.478-10-10-10h-161.063c-27.57 0-50 22.43-50 50v112c0 27.57 22.43 50 50 50h412c27.57 0 50-22.43 50-50v-112c0-27.57-22.43-50-50-50z"}}),_c('path',{attrs:{"id":"XMLID_861_","d":"m256.004 213.008c5.522 0 10-4.477 10-10v-42.725c0-5.523-4.478-10-10-10s-10 4.477-10 10v42.725c0 5.523 4.477 10 10 10z"}}),_c('path',{attrs:{"id":"XMLID_864_","d":"m184.004 276.008h144c23.159 0 42-18.841 42-42v-104.725c0-23.159-18.841-42-42-42h-2v-17.283c0-38.598-31.402-70-70-70s-70 31.402-70 70v17.283h-2c-23.159 0-42 18.841-42 42v104.725c0 23.159 18.841 42 42 42zm22-206.008c0-27.57 22.43-50 50-50s50 22.43 50 50v17.283h-100zm-44 59.283c0-12.131 9.869-22 22-22h144c12.131 0 22 9.869 22 22v104.725c0 12.131-9.869 22-22 22h-144c-12.131 0-22-9.869-22-22z"}}),_c('path',{attrs:{"id":"XMLID_1026_","d":"m256.063 320.074c2.63 0 5.21-1.07 7.07-2.93 1.87-1.86 2.93-4.44 2.93-7.07 0-2.64-1.06-5.21-2.93-7.07-1.86-1.86-4.44-2.93-7.07-2.93s-5.21 1.07-7.069 2.93c-1.86 1.86-2.931 4.43-2.931 7.07 0 2.63 1.07 5.21 2.931 7.07 1.86 1.86 4.44 2.93 7.069 2.93z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Skift kodeord")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/uddannelsesbevis"},on:{"mouseover":function($event){_vm.hoverUddanelseBevis = true},"mouseleave":function($event){_vm.hoverUddanelseBevis = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hoverUddanelseBevis)?_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis2.svg","alt":"","width":"25"}}):_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis1.svg","alt":"","width":"25"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Uddannelsesbevis")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/konto-update"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Bankverifikation")])])])]):_vm._e(),_vm._v(" "),(_vm.showXXL)?_c('div',{staticClass:"clearfix ml4"},[_c('p',{staticClass:"h4 semi-bold darkblue line-height-2 my2"},[_vm._v("Indstillinger")]),_vm._v(" "),_c('div',{staticClass:"col-6 px0 flex flex-wrap py2 h5 regular darkblue gibson"},[_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/stamoplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dine stamoplysninger")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/profilside"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M256 0C162.2 0 80 82.2 80 176c0 93.5 81.8 176 176 176 95.1 0 176-83.4 176-176C432 82.2 349.8 0 256 0zM256 332c-31.4 0-63.1-10.8-89.9-30.5C168.4 253.9 207.7 216 256 216c48.3 0 87.6 37.9 89.9 85.5C319.1 321.2 287.4 332 256 332zM206 146c0-27.6 22.4-50 50-50s50 22.4 50 50 -22.4 50-50 50S206 173.6 206 146zM364.2 285.9c-7-38.2-33.8-69.1-68.2-82.5C314.1 190.8 326 169.8 326 146c0-38.6-31.4-70-70-70 -38.6 0-70 31.4-70 70 0 23.8 11.9 44.8 30.1 57.4 -34.4 13.4-61.2 44.2-68.2 82.5C117.6 256.2 100 216.3 100 176c0-83.1 72.9-156 156-156s156 72.9 156 156C412 216.3 394.4 256.2 364.2 285.9z"}}),_c('path',{attrs:{"d":"M322.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L256 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C322.8 439.4 323.7 435.5 322.6 431.8zM277.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L256 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L277.6 455.6z"}}),_c('path',{attrs:{"d":"M162.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6L71.7 420.1l-34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8s-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L96 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C162.8 439.4 163.7 435.5 162.6 431.8zM117.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1 -1.6 0-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9L60.4 441.9l19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L96 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L117.6 455.6z"}}),_c('path',{attrs:{"d":"M482.6 431.8c-1.2-3.6-4.3-6.3-8.1-6.8l-34.2-5 -15.3-31c-1.7-3.4-5.2-5.6-9-5.6 -3.8 0-7.3 2.2-9 5.6l-15.3 31 -34.2 5c-3.8 0.5-6.9 3.2-8.1 6.8 -1.2 3.6-0.2 7.6 2.5 10.3l24.8 24.1 -5.8 34.1c-0.6 3.8 0.9 7.5 4 9.8 3.1 2.2 7.2 2.5 10.5 0.8L416 494.8l30.6 16.1c3.4 1.8 7.5 1.4 10.5-0.8 3.1-2.2 4.6-6 4-9.8l-5.8-34.1 24.8-24.1C482.8 439.4 483.7 435.5 482.6 431.8zM437.6 455.6c-2.4 2.3-3.4 5.6-2.9 8.9l3.3 19.3 -17.3-9.1c-1.5-0.8-3.1-1.1-4.7-1.1s-3.2 0.4-4.7 1.1l-17.3 9.1 3.3-19.3c0.6-3.2-0.5-6.6-2.9-8.9l-14-13.7 19.4-2.8c3.3-0.5 6.1-2.5 7.5-5.5L416 416.1l8.7 17.6c1.5 3 4.3 5 7.5 5.5l19.4 2.8L437.6 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("\n                  Din profilside\n                ")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-opgavetyper"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M46 0c-7.2 0-13.1 5.9-13.1 13.1v118.1c0 7.2 5.9 13.1 13.1 13.1 7.2 0 13.1-5.9 13.1-13.1V13.1C59.1 5.9 53.2 0 46 0z"}}),_c('path',{attrs:{"d":"M75.5 302H28.9V269.2h46.6c7.2 0 12.5-6 12.5-13.2v-59.1c0-7.2-5.2-13-12.5-13H16.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.8 5.8-13.8 13v59.1c0 7.2 6.5 13.2 13.8 13.2h59.1c7.2 0 13.1-5.9 13.1-13.1S82.8 302 75.5 302z"}}),_c('path',{attrs:{"d":"M75.5 367.6H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h45.3v32.8H16.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h59.1c7.2 0 12.5-6 12.5-13.2V380.6C88 373.4 82.8 367.6 75.5 367.6z"}}),_c('path',{attrs:{"d":"M496.2 29H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 34.9 503.4 29 496.2 29z"}}),_c('path',{attrs:{"d":"M496.2 88H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 93.9 503.4 88 496.2 88z"}}),_c('path',{attrs:{"d":"M496.2 212.7H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 218.6 503.4 212.7 496.2 212.7z"}}),_c('path',{attrs:{"d":"M496.2 271.8H161.5c-7.2 0-13.1 5.9-13.1 13.1s5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1S503.4 271.8 496.2 271.8z"}}),_c('path',{attrs:{"d":"M496.2 389.9H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 395.8 503.4 389.9 496.2 389.9z"}}),_c('path',{attrs:{"d":"M496.2 455.6H161.5c-7.2 0-13.1 5.9-13.1 13.1 0 7.2 5.9 13.1 13.1 13.1h334.7c7.2 0 13.1-5.9 13.1-13.1C509.3 461.4 503.4 455.6 496.2 455.6z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Opgavetyper")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-indstillinger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","width":"24","height":"24","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('g',[_c('g',[_c('g',[_c('path',{attrs:{"d":"m384.276 274.644c-5.522 0-10-4.478-10-10v-58.074h-4.551c-5.522 0-10-4.478-10-10s4.478-10 10-10h14.551c5.522 0 10 4.478 10 10v68.074c0 5.522-4.478 10-10 10z"}})])]),_c('g',[_c('g',[_c('path',{attrs:{"d":"m235.44 382.06c-4.248 0-8.085-2.787-9.462-6.789-1.379-4.007.034-8.562 3.376-11.145 3.218-2.486 7.744-2.711 11.225-.639 3.588 2.136 5.473 6.436 4.661 10.522-.917 4.618-5.091 8.051-9.8 8.051z"}})])]),_c('path',{attrs:{"d":"m484.036 226.606c0-57.929-47.119-105.057-105.036-105.057-6.322 0-12.516.562-18.534 1.638-12.779-19.712-30.128-36.257-50.457-48.062-10.657-6.189-22.032-11.003-33.833-14.363v-19.842c0-22.563-18.356-40.92-40.92-40.92-22.563 0-40.92 18.356-40.92 40.92v19.841c-62.403 17.841-108.217 75.432-108.217 143.529v45.483c0 29.338-3.546 58.659-10.54 87.147l-6.175 25.151c-22.95.581-41.44 19.432-41.44 42.543 0 23.453 19.08 42.533 42.533 42.533h102.777v2.87c0 34.177 27.805 61.982 61.983 61.982s61.983-27.806 61.983-61.982v-2.87h102.776c23.452 0 42.532-19.08 42.532-42.557 0-23.088-18.49-41.938-41.439-42.519l-6.175-25.151c-.509-2.07-1.001-4.156-1.476-6.25 51.101-7.066 90.578-51.04 90.578-104.064zm-269.7-185.686c0-11.535 9.385-20.92 20.92-20.92s20.92 9.385 20.92 20.92v15.602c-6.906-.976-13.897-1.472-20.92-1.472-7.099 0-14.083.499-20.92 1.464zm62.904 409.098c0 23.149-18.834 41.982-41.983 41.982s-41.983-18.833-41.983-41.982v-2.87h83.966zm145.308-45.404c0 12.425-10.108 22.533-22.532 22.533h-329.52c-12.425 0-22.533-10.108-22.533-22.557 0-12.425 10.108-22.533 22.533-22.533h6.574c.062.001.125.002.187.002.061 0 .121-.001.182-.002h112.611c5.523 0 10-4.477 10-10 0-5.522-4.477-10-10-10h-100.049l5-20.367c7.377-30.049 11.118-60.974 11.118-91.917v-45.483c0-71.264 57.931-129.24 129.137-129.24 41.566 0 80.841 20.415 104.948 53.926-38.772 15.467-66.241 53.4-66.241 97.631 0 55.967 43.982 101.852 99.192 104.896.741 3.413 1.529 6.822 2.355 10.188l5 20.367h-100.048c-5.522 0-10 4.478-10 10 0 5.523 4.478 10 10 10h112.611c.061.001.121.002.182.002.062 0 .124-.001.186-.002h6.574c12.425 0 22.533 10.108 22.533 22.556zm-43.548-92.951c-46.89 0-85.037-38.156-85.037-85.057 0-46.9 38.148-85.057 85.037-85.057s85.036 38.156 85.036 85.057-38.147 85.057-85.036 85.057z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Notifikationer")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/expire-subscription"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dit abonnement")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/dine-ferieperioder"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Capa_1","enable-background":"new 0 0 512 512","width":"24","height":"24","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m176 404.036c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.553 13.652-36.485 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.45 0 32.683-8.757 45.24-16.483 11.298-6.951 21.97-13.517 34.76-13.517s23.462 6.566 34.76 13.517c12.558 7.726 26.79 16.483 45.24 16.483 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.522 0 10-4.477 10-10s-4.478-10-10-10c-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-12.79 0-23.462-6.566-34.76-13.517-12.558-7.726-26.79-16.483-45.24-16.483-1.431 0-2.827.07-4.208.17l-65.793-141.076c7.369-3.436 119.357-55.659 126.888-59.171 5.005-2.334 7.171-8.284 4.836-13.29l-12.68-27.19c-36.12-77.448-125.847-111.893-203.433-81.325l-8.588-18.414c-2.333-5.005-8.283-7.171-13.289-4.836-5.005 2.334-7.171 8.284-4.836 13.29l8.589 18.418c-73.56 40.018-104.326 131.196-68.46 208.112l12.68 27.19c2.342 5.021 8.306 7.161 13.29 4.836l126.877-59.166 64.112 137.469c-7.758 3.195-14.72 7.464-21.225 11.466-11.298 6.951-21.97 13.517-34.76 13.517zm-52.732-163.719c-23.508-52.929-51.074-152.726-22.403-166.097.001-.001.003-.001.004-.002 32.261-15.044 94.909 87.231 112.845 123.921zm163.65-98.384 8.453 18.127-63.528 29.625c-20.506-42.004-57.279-101.739-96.371-126.449 63.251-11.294 125.152 22.32 151.446 78.697zm-253.765 118.337c-27.362-58.68-10.402-126.848 37.054-166.56-6.178 45.86 15.902 112.282 34.93 155.061l-63.531 29.626z"}}),_c('path',{attrs:{"d":"m421 137.966c30.327 0 55-24.673 55-55s-24.673-55-55-55-55 24.673-55 55 24.673 55 55 55zm0-90c19.299 0 35 15.701 35 35s-15.701 35-35 35-35-15.701-35-35 15.701-35 35-35z"}}),_c('circle',{attrs:{"cx":"256","cy":"443.965","r":"10"}}),_c('path',{attrs:{"d":"m512 474.036c0-5.523-4.478-10-10-10-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.112 7.021-23.554 13.652-36.485 13.652-11.777 0-21.427-5.341-32.817-12.324-4.709-2.886-10.865-1.409-13.752 3.3s-1.409 10.865 3.299 13.752c10.515 6.445 24.915 15.272 43.271 15.272 18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 5.521 0 9.999-4.477 9.999-10z"}}),_c('path',{attrs:{"d":"m10 484.036c18.309 0 32.647-8.311 46.515-16.348 12.112-7.021 23.554-13.652 36.485-13.652s24.373 6.631 36.485 13.652c13.867 8.037 28.206 16.348 46.515 16.348 18.355 0 32.756-8.827 43.271-15.272 4.708-2.887 6.186-9.043 3.299-13.752-2.886-4.708-9.042-6.187-13.752-3.3-11.391 6.982-21.04 12.324-32.817 12.324-12.932 0-24.373-6.631-36.485-13.652-13.867-8.037-28.206-16.348-46.515-16.348s-32.647 8.311-46.515 16.348c-12.113 7.021-23.554 13.652-36.486 13.652-5.522 0-10 4.477-10 10s4.478 10 10 10z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Ferieperioder")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/rediger-kreditkort-oplysninger"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Kreditkort")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/leverandoerservice"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Leverandørservice")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/balance"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M362.9 0h-294c-16.5 0-30 13.5-30 30v102c0 5.5 4.5 10 10 10s10-4.5 10-10V30c0-5.5 4.5-10 10-10h294c5.5 0 10 4.5 10 10v372c0 5.5-4.5 10-10 10h-294c-5.5 0-10-4.5-10-10V216.3c0-5.5-4.5-10-10-10s-10 4.5-10 10V402c0 16.5 13.5 30 30 30h294c16.5 0 30-13.5 30-30V30C392.9 13.5 379.5 0 362.9 0z"}}),_c('path',{attrs:{"d":"M56 169.7c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.5-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C58.9 174.1 57.9 171.6 56 169.7z"}}),_c('path',{attrs:{"d":"M96.1 455c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C99 459.4 97.9 456.9 96.1 455z"}}),_c('path',{attrs:{"d":"M423 40.1c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10H129c-5.5 0-10 4.5-10 10s4.5 10 10 10h274c16.5 0 30-13.5 30-30v-392C433 44.5 428.5 40.1 423 40.1z"}}),_c('path',{attrs:{"d":"M463.1 80c-5.5 0-10 4.5-10 10v392c0 5.5-4.5 10-10 10h-314c-5.5 0-10 4.5-10 10s4.5 10 10 10h314c16.5 0 30-13.5 30-30V90C473.1 84.5 468.6 80 463.1 80z"}}),_c('path',{attrs:{"d":"M200.9 74h-96c-5.5 0-10 4.5-10 10v96c0 5.5 4.5 10 10 10h96c5.5 0 10-4.5 10-10V84C210.9 78.5 206.5 74 200.9 74zM190.9 170h-76V94h76V170z"}}),_c('path',{attrs:{"d":"M168.8 235.4c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 245.6 172.7 239.3 168.8 235.4z"}}),_c('path',{attrs:{"d":"M332.6 249H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 249 332.6 249z"}}),_c('path',{attrs:{"d":"M326.9 74h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 74 326.9 74z"}}),_c('path',{attrs:{"d":"M326.9 122h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 122 326.9 122z"}}),_c('path',{attrs:{"d":"M326.9 170h-70c-5.5 0-10 4.5-10 10s4.5 10 10 10h70c5.5 0 10-4.5 10-10S332.5 170 326.9 170z"}}),_c('path',{attrs:{"d":"M168.8 311.8c-3.9-3.9-10.2-3.9-14.1 0l-26.6 26.6 -12.4-12.4c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l19.4 19.4c1.9 1.9 4.4 2.9 7.1 2.9 2.7 0 5.2-1.1 7.1-2.9l33.7-33.7C172.7 322 172.7 315.7 168.8 311.8z"}}),_c('path',{attrs:{"d":"M332.6 325H215.9c-5.5 0-10 4.5-10 10s4.5 10 10 10h116.7c5.5 0 10-4.5 10-10S338.1 325 332.6 325z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Faktura")])]),_vm._v(" "),_c('a',{staticClass:" pointer primarycolor col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"type":"button"},on:{"click":function($event){return _vm.getdataigibility('/ordrestyring')},"mouseover":function($event){_vm.hover = true},"mouseleave":function($event){_vm.hover = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hover)?_c('b-img',{attrs:{"src":"../static/svg/ordrestyring2.svg","alt":"","width":"25"}}):_c('b-img',{attrs:{"src":"../static/svg/ordrestyring1.svg","alt":"","width":"25"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Ordrestyring")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/ekstraphone"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","height":"24","viewBox":"0 0 512.00005 512","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m166.667969 413.871094c-5.171875 0-10.34375-1.640625-14.863281-4.921875-9.046876-6.574219-12.644532-17.691407-9.167969-28.320313l28.667969-87.570312-74.808594-54.105469c-9.050782-6.546875-12.679688-17.644531-9.238282-28.273437 3.441407-10.628907 12.882813-17.496094 24.054688-17.496094h92.34375l28.285156-87.511719c3.441406-10.632813 12.882813-17.503906 24.058594-17.503906 11.179688 0 20.621094 6.871093 24.058594 17.503906l28.289062 87.511719h92.34375c11.171875 0 20.613282 6.871094 24.050782 17.5 3.441406 10.628906-.183594 21.726562-9.238282 28.273437l-74.804687 54.101563 28.664062 87.570312c3.480469 10.628906-.117187 21.746094-9.167969 28.320313-9.046874 6.574219-20.730468 6.5625-29.765624-.03125l-74.429688-54.324219-74.425781 54.320312c-4.527344 3.304688-9.714844 4.957032-14.90625 4.957032zm-55.355469-200.6875c-3.46875 0-4.667969 2.558594-5.023438 3.65625-.359374 1.101562-.882812 3.875 1.929688 5.910156l80.722656 58.378906c3.519532 2.546875 4.996094 7.082032 3.640625 11.214844l-30.933593 94.507812c-1.082032 3.300782.976562 5.238282 1.914062 5.917969.9375.679688 3.414062 2.039063 6.21875-.007812l80.324219-58.625c3.515625-2.566407 8.28125-2.566407 11.792969 0l80.324218 58.625c2.800782 2.046875 5.28125.6875 6.21875.007812.9375-.679687 2.996094-2.617187 1.914063-5.917969l-30.933594-94.507812c-1.355469-4.132812.117187-8.667969 3.640625-11.214844l80.722656-58.378906c2.8125-2.035156 2.289063-4.808594 1.933594-5.910156-.355469-1.097656-1.558594-3.65625-5.027344-3.65625h-99.621094c-4.335937 0-8.179687-2.796875-9.511718-6.921875l-30.527344-94.4375c-1.066406-3.300781-3.871094-3.65625-5.027344-3.65625s-3.960937.355469-5.027344 3.65625l-30.527343 94.4375c-1.332031 4.125-5.175781 6.921875-9.511719 6.921875zm0 0"}}),_c('path',{attrs:{"d":"m255.9375 512c-6.53125 0-13.070312-.25-19.621094-.753906-60.835937-4.660156-118.132812-31.023438-161.335937-74.226563-48.351563-48.351562-74.980469-112.636719-74.980469-181.019531 0-68.378906 26.628906-132.667969 74.980469-181.019531 48.351562-48.351563 112.640625-74.980469 181.019531-74.980469 68.382812 0 132.667969 26.628906 181.023438 74.980469 43.199218 43.203125 69.5625 100.5 74.226562 161.335937 4.613281 60.175782-12.144531 120.15625-47.183594 168.898438-3.222656 4.484375-9.472656 5.503906-13.957031 2.28125s-5.503906-9.472656-2.28125-13.957032c67.726563-94.207031 57.234375-222.234374-24.949219-304.417968-92.015625-92.015625-241.738281-92.015625-333.753906 0-92.019531 92.019531-92.019531 241.738281 0 333.757812 82.183594 82.183594 210.207031 92.675782 304.417969 24.945313 4.484375-3.222657 10.734375-2.199219 13.957031 2.285156s2.199219 10.730469-2.285156 13.953125c-43.433594 31.230469-95.804688 47.9375-149.277344 47.9375zm0 0"}}),_c('path',{attrs:{"d":"m429.953125 439.953125c-2.632813 0-5.210937-1.070313-7.070313-2.933594-1.859374-1.859375-2.929687-4.4375-2.929687-7.066406 0-2.640625 1.070313-5.210937 2.929687-7.070313 1.859376-1.859374 4.429688-2.929687 7.070313-2.929687 2.628906 0 5.207031 1.066406 7.070313 2.929687 1.859374 1.859376 2.929687 4.4375 2.929687 7.070313 0 2.628906-1.070313 5.207031-2.929687 7.066406-1.863282 1.863281-4.441407 2.933594-7.070313 2.933594zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Dine telefonnumre")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/password"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","id":"Layer_1","enable-background":"new 0 0 512.008 512.008","width":"24","height":"24","viewBox":"0 0 512.008 512.008","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"id":"XMLID_1159_"}},[_c('g',{attrs:{"id":"XMLID_162_"}},[_c('path',{attrs:{"id":"XMLID_168_","d":"m299.305 381.008c-2.762-4.783-8.878-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_195_","d":"m162.305 381.008c-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.784-2.761-10.897-1.123-13.66 3.66-2.762 4.783-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66 1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.421-8.877 3.66-13.66z"}}),_c('path',{attrs:{"id":"XMLID_859_","d":"m349.703 431.008c1.853 3.208 5.213 5.001 8.67 5.001 1.696 0 3.416-.432 4.99-1.341l19.641-11.34v22.68c0 5.523 4.478 10 10 10s10-4.477 10-10v-22.68l19.641 11.34c1.575.909 3.294 1.341 4.99 1.341 3.456 0 6.817-1.793 8.67-5.001 2.762-4.783 1.123-10.899-3.66-13.66l-19.641-11.34 19.641-11.34c4.783-2.761 6.422-8.877 3.66-13.66-2.761-4.783-8.877-6.422-13.66-3.66l-19.641 11.34v-22.68c0-5.523-4.478-10-10-10s-10 4.477-10 10v22.68l-19.641-11.34c-4.785-2.761-10.898-1.123-13.66 3.66s-1.123 10.899 3.66 13.66l19.641 11.34-19.641 11.34c-4.783 2.761-6.422 8.877-3.66 13.66z"}}),_c('path',{attrs:{"id":"XMLID_860_","d":"m462.004 300.008h-160.937c-5.522 0-10 4.477-10 10s4.478 10 10 10h160.937c16.542 0 30 13.458 30 30v112c0 16.542-13.458 30-30 30h-412c-16.542 0-30-13.458-30-30v-112c0-16.542 13.458-30 30-30h161.063c5.522 0 10-4.477 10-10s-4.478-10-10-10h-161.063c-27.57 0-50 22.43-50 50v112c0 27.57 22.43 50 50 50h412c27.57 0 50-22.43 50-50v-112c0-27.57-22.43-50-50-50z"}}),_c('path',{attrs:{"id":"XMLID_861_","d":"m256.004 213.008c5.522 0 10-4.477 10-10v-42.725c0-5.523-4.478-10-10-10s-10 4.477-10 10v42.725c0 5.523 4.477 10 10 10z"}}),_c('path',{attrs:{"id":"XMLID_864_","d":"m184.004 276.008h144c23.159 0 42-18.841 42-42v-104.725c0-23.159-18.841-42-42-42h-2v-17.283c0-38.598-31.402-70-70-70s-70 31.402-70 70v17.283h-2c-23.159 0-42 18.841-42 42v104.725c0 23.159 18.841 42 42 42zm22-206.008c0-27.57 22.43-50 50-50s50 22.43 50 50v17.283h-100zm-44 59.283c0-12.131 9.869-22 22-22h144c12.131 0 22 9.869 22 22v104.725c0 12.131-9.869 22-22 22h-144c-12.131 0-22-9.869-22-22z"}}),_c('path',{attrs:{"id":"XMLID_1026_","d":"m256.063 320.074c2.63 0 5.21-1.07 7.07-2.93 1.87-1.86 2.93-4.44 2.93-7.07 0-2.64-1.06-5.21-2.93-7.07-1.86-1.86-4.44-2.93-7.07-2.93s-5.21 1.07-7.069 2.93c-1.86 1.86-2.931 4.43-2.931 7.07 0 2.63 1.07 5.21 2.931 7.07 1.86 1.86 4.44 2.93 7.069 2.93z"}})])])])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Skift kodeord")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/uddannelsesbevis"},on:{"mouseover":function($event){_vm.hoverUddanelseBevis = true},"mouseleave":function($event){_vm.hoverUddanelseBevis = false}}},[_c('span',{staticClass:"mr2"},[(!_vm.hoverUddanelseBevis)?_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis2.svg","alt":"","width":"25"}}):_c('b-img',{attrs:{"src":"../static/svg/uddanelse-bevis1.svg","alt":"","width":"25"}})],1),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Uddannelsesbevis")])]),_vm._v(" "),_c('a',{staticClass:"col-6 px0 inline-block not-rounded primary-white-button py2 flex justify-start items-center no-hover",attrs:{"href":"#/konto-update"}},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","width":"24","height":"24","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}},[_c('path',{attrs:{"d":"M407 385.2c-4.5-3.1-10.8-2-13.9 2.5 -3 4.4-6.5 8.7-10.3 12.7 -2.5 2.7-6 6-9.8 9.2 -4.2 3.6-4.7 9.9-1.1 14.1 2 2.3 4.8 3.5 7.6 3.5 2.3 0 4.6-0.8 6.5-2.4 4.4-3.8 8.4-7.5 11.4-10.8 4.4-4.7 8.5-9.8 12.1-15C412.7 394.6 411.6 388.4 407 385.2z"}}),_c('path',{attrs:{"d":"M363.5 430.1c-2.3-5-8.3-7.2-13.3-4.8l-0.3 0.1c-5.1 2.2-7.3 8.1-5.1 13.2 1.7 3.7 5.3 6 9.2 6 1.3 0 2.7-0.3 4-0.9 0.2-0.1 0.5-0.2 0.7-0.3C363.7 441 365.8 435.1 363.5 430.1z"}}),_c('path',{attrs:{"d":"M482.1 26H29.9C13.4 26 0 39.4 0 55.9v280.3c0 16.5 13.4 29.9 29.9 29.9h210.6c8.9 37.8 29.1 64.5 46.8 81.7C313 472.7 342.5 486 353.9 486c11.4 0 40.9-13.3 66.7-38.3 17.6-17.1 37.8-43.9 46.8-81.7h14.8c16.5 0 29.9-13.4 29.9-29.9V55.9C512 39.4 498.6 26 482.1 26zM452 325c0 52.7-24.3 87.6-44.7 107.7 -24.2 23.8-49 33-53.4 33.3 -4.3-0.3-29.2-9.5-53.4-33.3 -20.4-20-44.7-55-44.7-107.7v-49.2c34.4-10 66.6-23.6 98.1-41.5 30.8 17.5 64.4 31.7 98.1 41.5V325zM492 336.1c0 5.4-4.4 9.9-9.9 9.9h-11.3c0.8-6.7 1.2-13.7 1.2-21v-56.8c0-4.5-3-8.5-7.4-9.6 -36.3-9.9-72.9-25.2-105.7-44.4 -3.1-1.8-7-1.8-10.1 0 -33.7 19.8-68.3 34.3-105.7 44.4 -4.4 1.2-7.4 5.1-7.4 9.7v56.8c0 7.3 0.4 14.3 1.2 21H29.9c-5.4 0-9.9-4.4-9.9-9.9V166h472V336.1zM492 146H20v-40h472V146zM492 86H20V55.9c0-5.4 4.4-9.9 9.9-9.9h452.3c5.4 0 9.9 4.4 9.9 9.9V86z"}}),_c('path',{attrs:{"d":"M120 236c-6 0-12 1.2-17.5 3.5 -5.4-2.3-11.3-3.5-17.5-3.5 -24.8 0-45 20.2-45 45s20.2 45 45 45c6.2 0 12.1-1.3 17.5-3.5 5.5 2.3 11.5 3.5 17.5 3.5 24.8 0 45-20.2 45-45S144.8 236 120 236zM85 306c-13.8 0-25-11.2-25-25 0-13.8 11.2-25 25-25 13.8 0 25 11.2 25 25C110 294.8 98.8 306 85 306zM122.5 305.9c4.8-7.1 7.5-15.7 7.5-24.9 0-9.2-2.8-17.7-7.5-24.9 12.6 1.2 22.5 11.9 22.5 24.9C145 293.9 135.1 304.6 122.5 305.9z"}}),_c('path',{attrs:{"d":"M101.4 191H50c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h51.4c5.5 0 10-4.5 10-10C111.4 195.5 107 191 101.4 191z"}}),_c('path',{attrs:{"d":"M131 191h-0.5c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h0.5c5.5 0 10-4.5 10-10C141 195.5 136.5 191 131 191z"}}),_c('path',{attrs:{"d":"M408.8 302c-3.9-3.9-10.2-3.9-14.1 0l-53.5 53.5 -28-28c-3.9-3.9-10.2-3.9-14.1 0 -3.9 3.9-3.9 10.2 0 14.1l35.1 35.1c2 2 4.5 2.9 7.1 2.9s5.1-1 7.1-2.9l60.5-60.5C412.7 312.3 412.7 305.9 408.8 302z"}})])]),_vm._v(" "),_c('span',{staticClass:"gibson h6 regular mb0"},[_vm._v("Bankverifikation")])])])]):_vm._e(),_vm._v(" "),_c('noneligibleFeaturepop',{ref:"noneligibleFeaturepop"})]],2)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1352 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InviterKollega_vue__ = __webpack_require__(1353);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7cd64b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InviterKollega_vue__ = __webpack_require__(1354);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InviterKollega_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0d7cd64b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_InviterKollega_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1353 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__haandvaerker__ = __webpack_require__(44);



/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    haandvaerker: __WEBPACK_IMPORTED_MODULE_0__haandvaerker__["a" /* default */]
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 1354 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[_c('div',{staticClass:"clearfix gibson px2 py3 mb2"},[_c('div',{staticClass:"xs-col-12 sm-col-12 md-col-7 lg-col-7 px2"},[_c('div',{staticClass:"clearfix border muted-border p2 py3 shadow"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("Henvis en håndværker")]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-stretch my3"},[_c('b-img',{attrs:{"src":"static/img/photo3.png","fluid-grow":""}})],1),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden mt1 mb3"},[_vm._v("\n            For at få fordelen skal du efter aftale med den håndværker du henviser, give os deres informationer herunder. Så tager vi kontakt til dem. \n          ")])]),_vm._v(" "),_c('form',{attrs:{"action":""}},[_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"flex flex-column px2"},[_c('p',{staticClass:"h6 darkblue gibson line-height-1 mb1"},[_vm._v("Navn")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background darkblue gibson h5 regular border-none not-rounded",attrs:{"type":"text","required":""}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"flex flex-column px2"},[_c('p',{staticClass:"h6 darkblue gibson line-height-1 mb1"},[_vm._v("Email")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background darkblue gibson h5 regular border-none not-rounded",attrs:{"type":"text","required":""}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('div',{staticClass:"flex flex-column px2"},[_c('p',{staticClass:"h6 darkblue gibson line-height-1 mb1"},[_vm._v("Mobil")]),_vm._v(" "),_c('b-form-input',{staticClass:"muted-background darkblue gibson h5 regular border-none not-rounded",attrs:{"type":"text","required":""}})],1)]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('haandvaerker')],1)])]),_vm._v(" "),_c('div',{staticClass:"py3"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 regular darkblue line-height-golden mt1 mb3"},[_c('span',{staticClass:"primarycolor block semi-bold"},[_vm._v("Sharing is caring")]),_vm._v("\n            Er du glad for din Håndværker.dk-løsning? Hvorfor ikke dele glæden med en ven :-)"),_c('br'),_c('br'),_vm._v("\n            Når du har henvist en håndværker, som bliver kunde ved Håndværker.dk,\n            så får I begge en måneds gratis abonnement. \n          ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px2"},[_c('button',{staticClass:"col-12 action-button p2 h4 flex justify-center items-center gibson line-height-1"},[_c('span',{staticClass:"semi-bold"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1355 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stamoplysninger_vue__ = __webpack_require__(1357);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5abcdca0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_stamoplysninger_vue__ = __webpack_require__(1358);
function injectStyle (ssrContext) {
  __webpack_require__(1356)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_stamoplysninger_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5abcdca0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_stamoplysninger_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1356 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1357 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(25);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stamoplynsninger',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    Vue: __WEBPACK_IMPORTED_MODULE_3_vue__["default"]
  },
  data: function data() {
    return {
      selected: '',
      salesPerson: '',
      imgPicked: '',
      consent: '0',
      show: false,
      label: 'Loading...',
      overlay: 1,
      modalShowMail: false,
      isLoadingMail: false,
      items: [],
      images: [],
      textReason: '',
      url: '',
      startend: '',
      finishend: '',
      imageSelect: '',
      message: '',
      haaCredit: false,
      opsige: false,
      Canexpire: true,
      showimentor: true,
      opsigedone: false,
      showDismissibleAlert: false,
      customer: {
        name: '',
        email: ''
      },
      customers: []
    };
  },

  methods: {
    Reload: function Reload() {
      var _this = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.show = false;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        _this.items = res;
        _this.images = res.resultImages;
        if (_this.images.length !== 0) {
          _this.imgPicked = _this.images[0].FileLocation;
        }
        _this.url = 'https://prisberegning.dk/kunde/UpdatePartnerListNew.php?iframe=1&id=' + res.encodeupdate;
      }, function (response) {
        alert('error');
      });
    },
    service_jule_action: function service_jule_action() {
      var _this2 = this;

      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      this.haaId = localStorage.getItem('haaid');
      var data = { operation: 'service_jule_action', salesPerson: this.salesPerson, levid: this.haaId, customers: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.customers), imgPicked: this.imgPicked, bcc: this.consent };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.show = false;
        if (res.login === false) {
          _this2.$router.push('/login');
        }
        if (res.success) {
          _this2.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Dit elektroniske julekort er nu sendt til dine kunder.',
            type: 'success'
          };
          _this2.customers = [];
          _this2.customers.push(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.extend({}, _this2.customer));
          _this2.$refs.simplert.openSimplert(obj);
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    addCustomer: function addCustomer() {
      this.customers.push(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.extend({}, this.customer));
    },
    delCustomer: function delCustomer(index) {
      __WEBPACK_IMPORTED_MODULE_3_vue__["default"].delete(this.customers, index);
    }
  },
  created: function created() {
    this.customers.push(__WEBPACK_IMPORTED_MODULE_3_vue__["default"].util.extend({}, this.customer));
    this.Reload();
  }
});

/***/ }),
/* 1358 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",staticStyle:{"min-height":"900px","display":"flex","flex-flow":"column","height":"100%"}},[_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',{staticClass:"d-flex justify-content-start align-items-stretch bg-white h-100",attrs:{"no-gutters":""}},[_c('b-col',{attrs:{"align-v":"center","sm":"12","md":"6","lg":"6"}},[_c('b-card',{staticClass:"border-0",staticStyle:{"height":"800px"}},[_c('div',{staticClass:"card-text"},[_c('div',{},[_c('b-embed',{staticStyle:{"-webkit-overflow-scrolling":"touch","overflow-y":"scroll"},attrs:{"type":"iframe","src":_vm.url,"aspect":"1by1","height":"800px"}})],1)])])],1)],1),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1359 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medlemsfordele_vue__ = __webpack_require__(1361);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44942951_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_medlemsfordele_vue__ = __webpack_require__(1362);
function injectStyle (ssrContext) {
  __webpack_require__(1360)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_medlemsfordele_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44942951_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_medlemsfordele_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1360 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1361 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  data: function data() {
    return {
      insideLoading: true,
      hotlineLoading: false,
      haaId: '',
      salesPerson: '',
      couponCode: 'prohv21',
      medlemsfordele: [],
      formLegalTopicVisible: false,
      legalTopic: [],
      legalTopicData: [],
      note: '',
      fileList: [],
      nps: ''
    };
  },

  methods: {
    recommend: function recommend() {
      this.$router.push('/recommend');
    },
    copyCouponCode: function copyCouponCode() {
      var couponCodeToCopy = document.querySelector('#couponCode');
      couponCodeToCopy.setAttribute('type', 'text');
      couponCodeToCopy.select();

      try {
        alert('Rabatkoden er nu kopieret');
      } catch (err) {
        alert('Oops, unable to copy');
      }
      couponCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    checkPermission: function checkPermission() {
      var _this = this;

      var data = {
        operation: 'service_legal_permission',
        salesPerson: this.salesPerson,
        type: 'POST',
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.getLegalTopics();
          _this.formLegalTopicVisible = true;
        }
      }, function (err) {
        console.log(err);
      });
    },
    getLegalTopics: function getLegalTopics() {
      var _this2 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'bitrix/getAllLegalTopic'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.legalTopicData = res.data;
        }
      }, function (err) {
        console.log(err);
      });
    },
    handleFileUpload: function handleFileUpload(file) {
      this.fileList = file;
    },
    submitLegalHotline: function submitLegalHotline() {
      var _this3 = this;

      var topic = this.legalTopic;
      var note = this.note;
      var fileList = this.fileList;
      var uploadFinish = localStorage.getItem('uploadFinish');
      if (uploadFinish === true || uploadFinish === null) {
        if (topic.length > 0 && note !== '') {
          var files = [];
          if (fileList.length > 0) {
            for (var i = 0; i < fileList.length; i++) {
              var file = fileList[i];
              files.push('https://www.kundematch.dk/HenttilbudImg.php?img=' + file);
            }
          }
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: 'bitrix/sendEmailLegalTopic',
            parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              levid: this.haaId,
              value: topic,
              info: note,
              file: files
            })
          };
          this.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res.success) {
              _this3.hotlineLoading = false;
              _this3.legalTopic = null;
              _this3.note = '';
              _this3.fileList = [];
              var obj = {
                title: 'Sendt!',
                message: '',
                type: 'success',
                customCloseBtnText: 'Luk'
              };
              _this3.$refs.simplert.openSimplert(obj);
            }
          }, function (err) {
            console.log(err);
          });
          this.hotlineLoading = true;
        } else {
          this.$toastr('error', 'Felter påkrævet');
        }
      } else {
        this.$toastr('error', 'Uploader stadig');
      }
    },
    getNPS: function getNPS() {
      var _this4 = this;

      var data = { operation: 'newsFeed', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.nps = parseInt(res.nps);
      }, function (response) {
        alert('error');
      });
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    this.show = true;
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var zip = localStorage.getItem('CompanyZip');
    var data = {
      operation: 'bitrixApi',
      salesPerson: this.salesPerson,
      type: 'GET',
      url: 'bitrix/getMembers?zip=' + zip
    };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      var medlemedata = res.data;
      _this5.show = false;
      if (res.login === false) {
        _this5.$router.push('/login');
      }
      medlemedata = medlemedata.filter(function (a) {
        return a.ID !== '124';
      });
      _this5.medlemsfordele = medlemedata;
      _this5.insideLoading = false;
    }, function (response) {
      alert('error');
    });
    this.checkPermission();
    this.getNPS();
  }
});

/***/ }),
/* 1362 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4",attrs:{"id":"medlemsfordele"}},[(!_vm.showMobile)?_c('div',{staticClass:"flex flex-wrap justify-start gibson mt2 pl4 mb2"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"col-12 pt0"},[_c('button',{staticClass:"action-button p2 gibson h5 regular line-height-1 flex justify-start items-center",on:{"click":function($event){return _vm.recommend()}}},[_c('span',[_vm._v("Anbefal os og få et tivolikort")]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"col-12"},[_vm._m(2)]):_c('div',{staticClass:"clearfix px2"},[(_vm.formLegalTopicVisible)?_c('div',{staticClass:"col-6 pb2"},[_c('div',{staticClass:"col-12 px0 py2"},[_c('span',{staticClass:"h5 darkblue mb2"},[_vm._v("Gratis juridisk hjælpelinje")]),_vm._v(" "),_c('p',{staticClass:"darkblue mb2"},[_vm._v("Som loyalt medlem hos Håndværker.dk har du adgang til en gratis juridisk hjælpelinje. Her kan du få hjælp til entrepriseretlige spørgsmål. Rådgivningen foregår på mail og varetages af Hasløv Stæhr Advokater.")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),(_vm.hotlineLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(3)]):_c('div',[_c('el-select',{staticClass:"col-12 p0 mb2",attrs:{"placeholder":"Vælg en indstilling","multiple":""},model:{value:(_vm.legalTopic),callback:function ($$v) {_vm.legalTopic=$$v},expression:"legalTopic"}},_vm._l((_vm.legalTopicData),function(topic,index){return _c('el-option',{key:index,attrs:{"label":topic.NAME,"value":topic.NAME}})}),1),_vm._v(" "),_c('p',{staticClass:"darkblue mb1"},[_vm._v("Uddyb venligst behov")]),_vm._v(" "),_c('b-form-input',{staticClass:"mb2",model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),_c('p',{staticClass:"darkblue mb1"},[_vm._v("Vedhæft relevante dokumenter")]),_vm._v(" "),_c('file-upload-input',{attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}}),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('b-button',{staticClass:"action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular mr2",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitLegalHotline()}}},[_vm._v("Send")]),_vm._v(" "),_c('p',{staticClass:"darkblue line-height-1 my0 ml2"},[_vm._v("Du bliver ringet op af Hasløv Stæhr Advokater, når de har set på din sag.")])],1)],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.medlemsfordele),function(item){return _c('div',{key:item.ID,staticClass:"pb4"},[_c('div',{staticClass:"border-none shadow col-12 p2"},[_c('div',{staticClass:"col-12 px0 flex justify-start items-start"},[_c('div',{staticClass:"px2 mb2"},[_c('div',{staticClass:"col-4 px0 mt2"},[_c('img',{attrs:{"src":item.PROPERTY_IMAGE_URL_VALUE,"width":"120","alt":""}})]),_vm._v(" "),(item.NAME === 'Dinero')?_c('p',{staticClass:"h6 darkblue regular line-height-3 my2"},[_vm._v("\n                  Som medlem hos Håndværker.dk kan du få et fremragende tilbud fra Dinero.* Du skal blot udfylde navn og e-mail på linket herunder. Dinero vil derefter kontakte dig og hjælpe dig med den rigtige løsning til dig. Fortæl, at du er medlem hos Håndværker.dk. *Tilbuddet gælder nye Dinero-brugere.\n                ")]):_c('p',{staticClass:"h6 darkblue regular line-height-3 my2",domProps:{"innerHTML":_vm._s(item.PROPERTY_DESCRIPTION_VALUE.TEXT)}}),_vm._v(" "),[(item.PROPERTY_CODE_VALUE !== null )?_c('div',{staticClass:"flex justify-between items-center"},[_c('p',{staticClass:"h6 darkblue regular line-height-golden"},[_vm._v("Rabatkode : "),_c('span',{staticClass:"secondarycolor"},[_vm._v(_vm._s(item.PROPERTY_CODE_VALUE))])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"couponCode"},domProps:{"value":_vm.couponCode}}),_vm._v(" "),_c('button',{staticClass:"standard-button h6 regular p2 flex justify-center items-center gibson line-height-1 not-rounded border-none",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyCouponCode.apply(null, arguments)}}},[_c('span',[_vm._v("Kopier kode")]),_vm._v(" "),_vm._m(4,true)])]):(item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE === 'flugger101' )?_c('div',[_c('div',{},[_c('p',{staticClass:"darkblue h3"},[_vm._v("Kontakt")]),_vm._v(" "),_c('a',{staticStyle:{"float":"right"},attrs:{"href":'skype:'+item.PROPERTY_CONTACT_PHONE_VALUE+'?call'}},[_c('i',{staticClass:"green el-icon-phone-outline",staticStyle:{"font-size":"2em"}})])]),_vm._v(" "),_c('div',{staticClass:"flex px0 mt2"},[_c('img',{attrs:{"src":item.PROPERTY_CONTACT_PHOTO_VALUE,"width":"100","alt":""}}),_vm._v(" "),_c('div',{},[_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v(_vm._s(item.PROPERTY_CONTACT_NAME_VALUE))]),_vm._v(" "),_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v("Tel: "+_vm._s(item.PROPERTY_CONTACT_PHONE_VALUE))]),_vm._v(" "),_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v(_vm._s(item.PROPERTY_CONTACT_EMAIL_VALUE))])])])]):_c('div')],_vm._v(" "),(item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE !== 'flugger101' )?_c('a',{staticClass:"inline-block action-button p2 h6 regular m0 line-height-1 gibson not-rounded border-none white",attrs:{"href":item.PROPERTY_LINK_VALUE,"target":"_blank"}},[_c('span',{staticClass:"mr2 regular white",domProps:{"innerHTML":_vm._s(item.PROPERTY_BUTTON_VALUE)}}),_vm._m(5,true)]):_vm._e()],2)])])])})],2)]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"flex flex-wrap justify-start gibson mt2"},[_c('div',{staticClass:"col-12 pt0 pr3 pb0 pl3"},[_c('button',{staticClass:"action-button p2 gibson h5 regular line-height-1 flex justify-start items-center",on:{"click":function($event){return _vm.recommend()}}},[_c('span',[_vm._v("Anbefal os og få et tivolikort")]),_vm._v(" "),_vm._m(6)]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('p',{staticClass:"h4 darkblue gibson semi-bold mb2"},[_vm._v("\n          Medlemsfordele\n        ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue gibson regular line-height-3 my2"},[_vm._v("\n          Som medlem hos håndværker.dk har du flere fordele du kan benytte dig af. Se samarbejdspartnere og fordele herunder.\n        ")])]),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"col-12"},[_vm._m(7)]):_c('div',{staticClass:"col-12 p3"},[(_vm.formLegalTopicVisible)?_c('div',{staticClass:"col-12 p0 pb2"},[_c('div',{staticClass:"border-none shadow col-12 p2"},[_c('span',{staticClass:"h5 darkblue mb2"},[_vm._v("Gratis juridisk hjælpelinje")]),_vm._v(" "),_c('p',{staticClass:"darkblue mb2"},[_vm._v("Som loyalt medlem hos Håndværker.dk har du adgang til en gratis juridisk hjælpelinje. Her kan du få hjælp til entrepriseretlige spørgsmål. Rådgivningen foregår på mail og varetages af Hasløv Stæhr Advokater.")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),(_vm.hotlineLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(8)]):_c('div',[_c('el-select',{staticClass:"col-12 p0 mb2",attrs:{"placeholder":"Vælg en indstilling","multiple":""},model:{value:(_vm.legalTopic),callback:function ($$v) {_vm.legalTopic=$$v},expression:"legalTopic"}},_vm._l((_vm.legalTopicData),function(topic,index){return _c('el-option',{key:index,attrs:{"label":topic.NAME,"value":topic.NAME}})}),1),_vm._v(" "),_c('p',{staticClass:"darkblue mb1"},[_vm._v("Uddyb venligst behov")]),_vm._v(" "),_c('b-form-input',{staticClass:"mb2",model:{value:(_vm.note),callback:function ($$v) {_vm.note=$$v},expression:"note"}}),_vm._v(" "),_c('p',{staticClass:"darkblue mb1"},[_vm._v("Vedhæft relevante dokumenter")]),_vm._v(" "),_c('file-upload-input',{attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}}),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular col-12 p0 mb2",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitLegalHotline()}}},[_vm._v("Send")]),_vm._v(" "),_c('p',{staticClass:"darkblue m0"},[_vm._v("Du bliver ringet op af Hasløv Stæhr Advokater, når de har set på din sag.")])],1)],1)])]):_vm._e(),_vm._v(" "),_vm._l((_vm.medlemsfordele),function(item){return _c('div',{key:item.ID,staticClass:"border-none shadow col-12 p3 pt2 flex flex-column"},[_c('div',[_c('div',{staticClass:"py2"}),_vm._v(" "),_c('img',{attrs:{"src":item.PROPERTY_IMAGE_URL_VALUE,"width":"120","alt":""}})]),_vm._v(" "),_c('div',{staticClass:"my2"},[(item.NAME === 'Dinero')?_c('p',{staticClass:"h5 darkblue regular line-height-golden"},[_vm._v("\n              Som medlem hos Håndværker.dk kan du få et fremragende tilbud fra Dinero.* Du skal blot udfylde navn og e-mail på linket herunder. Dinero vil derefter kontakte dig og hjælpe dig med den rigtige løsning til dig. \nFortæl, at du er medlem hos Håndværker.dk. *Tilbuddet gælder nye Dinero-brugere.\n            ")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-golden",attrs:{"else":""},domProps:{"innerHTML":_vm._s(item.PROPERTY_DESCRIPTION_VALUE.TEXT)}}),_vm._v(" "),[(item.PROPERTY_CODE_VALUE !== null)?_c('div',[_c('p',{staticClass:"h5 darkblue regular line-height-golden"},[_vm._v("Rabatkode : "),_c('span',{staticClass:"secondarycolor"},[_vm._v(_vm._s(item.PROPERTY_CODE_VALUE))])]),_vm._v(" "),_c('input',{attrs:{"type":"hidden","id":"couponCode"},domProps:{"value":_vm.couponCode}}),_vm._v(" "),_c('button',{staticClass:"standard-button h5 regular p2 flex justify-center items-center gibson line-height-1 not-rounded border-none",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();$event.preventDefault();return _vm.copyCouponCode.apply(null, arguments)}}},[_c('span',[_vm._v("Kopier kode")]),_vm._v(" "),_vm._m(9,true)])]):(item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE === 'flugger101' )?_c('div',[_c('p',{staticClass:"darkblue h3"},[_vm._v("Kontakt")]),_vm._v(" "),_c('div',{staticClass:"flex px0 mt2"},[_c('img',{attrs:{"src":item.PROPERTY_CONTACT_PHOTO_VALUE,"width":"100","alt":""}}),_vm._v(" "),_c('div',{},[_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v(_vm._s(item.PROPERTY_CONTACT_NAME_VALUE))]),_vm._v(" "),_c('div',{staticClass:"flex "},[_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v("Tel: "+_vm._s(item.PROPERTY_CONTACT_PHONE_VALUE))]),_c('a',{staticClass:"right pl1",attrs:{"href":'skype:'+item.PROPERTY_CONTACT_PHONE_VALUE+'?call'}},[_c('i',{staticClass:"right green el-icon-phone-outline",staticStyle:{"font-size":"1.5em"}})])]),_vm._v(" "),_c('p',{staticClass:"darkblue h6 regular pl2"},[_vm._v(_vm._s(item.PROPERTY_CONTACT_EMAIL_VALUE))])])])]):_c('div')]],2),_vm._v(" "),(item.PROPERTY_CONTACT_MEMBERS_CODE_VALUE !== 'flugger101')?_c('a',{staticClass:"action-button p2 flex justify-center items-center h4 m0 line-height-1 gibson not-rounded border-none",attrs:{"href":item.PROPERTY_LINK_VALUE,"target":"_blank"}},[_c('span',{staticClass:"mr2 regular",domProps:{"innerHTML":_vm._s(item.PROPERTY_BUTTON_VALUE)}}),_vm._m(10,true)]):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"py4"})],2)]):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt3 pb3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold"},[_vm._v("\n            Medlemsfordele\n          ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-3 my2"},[_vm._v("\n            Som medlem hos håndværker.dk har du flere fordele du kan benytte dig af. Se samarbejdspartnere og fordele herunder.\n          ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-copy-document"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-right white"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-copy-document"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1363 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_vue__ = __webpack_require__(1365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a79aae92_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_overview_vue__ = __webpack_require__(1374);
function injectStyle (ssrContext) {
  __webpack_require__(1364)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_overview_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a79aae92_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_overview_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__footer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Createbannerwebshop__ = __webpack_require__(1367);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_0__footer__["a" /* default */],
    Createbannerwebshop: __WEBPACK_IMPORTED_MODULE_1__Createbannerwebshop__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      imageLoadingpng: true,
      catData: [],
      initcatData: [],
      salesPerson: '',
      showbadge: localStorage.getItem('showbadgewebshop'),
      haaId: localStorage.getItem('haaid')
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
    this.reloadcategory();
    this.haaId = localStorage.getItem('haaid');
  },

  methods: {
    reloadcategory: function reloadcategory() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetCategory/0', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var catReses = [];
        if (res.success) {
          var catRes = response.data.data;
          if (_this.showbadge === 'no') {
            catReses = catRes.filter(function (a) {
              return a.ID !== 205;
            });
          } else {
            catReses = catRes;
          }
          catReses.forEach(function (element) {
            _this.getproducteach(element);
          });
          _this.loading = false;
        } else {
          _this.loading = false;
          console.log('Error in reloadcategory()');
        }
      }, function (response) {
        console.log('error in loading all category, Bai Rodel was here');
      });
    },
    getproducteach: function getproducteach(catResess) {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + catResess.ID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data[0];
          if (dataRes.CATEGORY_ID !== 205) {
            catResess['IMAGE_URL'] = 'http://widget.haandvaerker.dk/products/' + dataRes.PRODUCT_GROUP + '/' + dataRes.SIZE + '/rendered/' + _this2.haaId + '.jpg';
          } else {
            catResess['IMAGE_URL'] = 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/36910/3.jpg';
          }
        }
      }, function (response) {
        console.log('Error: ', response);
      });

      this.catData.push(catResess);
    },
    addcategory: function addcategory() {
      this.salesPerson = localStorage.getItem('id_token_portal');
      console.log('this.salesPerson', this.salesPerson);
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {
        CategoryId: '301',
        Description: 'Skal du have synlighed, når du arbejder på byggepladsen? Sæt et Byggepladsskilt op.',
        ImageUrL: '/upload/iblock/7ea/8be5g2o3ku93vqt0426n21zmohqp4w97/Sample 1-01.png'
      };
      this.$http.post('https://bitrixapi.haandvaerker.dk/v1/webshop/SaveCategoryCustomFields', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        console.log('getcategory', res);
        if (res.success) {
          console.log('addresult', res);
        } else {
          console.log('Error in saving category');
        }
      }, function (response) {
        console.log('error in loading all category');
      });
    },
    displayCategories: function displayCategories() {
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCategory/0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        console.log('prisen', res);
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    onImageLoad: function onImageLoad(catID) {
      var hidden = document.querySelector('.catImages-' + catID);
      hidden.classList.remove('hide');
      var loader = document.querySelector('.loader-' + catID);
      loader.remove();
    },
    setImage: function setImage(catID, filePath) {
      this.imageLoadingpng = false;
      var img = document.querySelector('.catId-' + catID);
      img.src = 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + filePath + '.php?id=' + this.haaId;
    }
  }
});

/***/ }),
/* 1366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 center"},[_c('a',{staticClass:"mediumgrey termsconditions no-hover",staticStyle:{"font-size":"15px"},attrs:{"href":"#/webshop/terms-and-conditions","target":"_blank","rel":"noopener noreferrer"}},[_c('i',{staticClass:"el-icon-document-checked"}),_vm._v(" Find betingelser her")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Createbannerwebshop_vue__ = __webpack_require__(1369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f28b4b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Createbannerwebshop_vue__ = __webpack_require__(1373);
function injectStyle (ssrContext) {
  __webpack_require__(1368)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Createbannerwebshop_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1f28b4b4_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Createbannerwebshop_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: newFunction(),
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      info: null,
      companyPrimaryIndustryName: '',
      companyName: localStorage.getItem('CompanyName'),
      companyTelephone: '',
      companyCVR: '',
      companyRating: '',
      errored: null,
      haaId: localStorage.getItem('haaid')
    };
  },
  created: function created() {
    this.getprofilebyid();
    this.getprofilebyids();
    this.haaId = localStorage.getItem('haaid');
    this.companyName = localStorage.getItem('Name');
  },
  mounted: function mounted() {
    var _this = this;

    try {
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://webapi.haandvaerker.dk/v1/supplier/GetSupplierProfileById?id=' + this.haaId).then(function (res) {
        console.log('none');
        if (res.data.success === true) {
          var results = res.data.data[0];
          _this.companyTelephone = results.data.data[0].Telephone;
          _this.companyPrimaryIndustryId = results.data.date[0].PrimaryIndustry;
          _this.companyCVR = res.data.data[0].Cvr;
          _this.companyRating = res.data.data[0].Ratingsummary.AverageRatingGrade;
          _this.sampleData = 'sdada';
        }
      }).catch(function () {
        console.log('Error');
      });
      __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('http://api.haandvaerker.dk/Industry/GetIndustrySelection/1').then(function (res) {
        console.log(res);

        _this.companyPrimaryIndustryName = res.data[0].IndustryId;
      }).catch(function () {
        console.log('Error');
      });
    } catch (e) {}
  }
});
function newFunction() {
  return 'Createbannerwebshop';
}

/***/ }),
/* 1370 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {},
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      cartCount: 0,
      wishListCount: 0,
      orderCount: 0,
      pageHeader: '',
      breadCrumb: [],
      pageData: [{
        name: 'Webshop',
        url: '#/webshop/overview'
      }, {
        name: 'Produkter',
        url: '#/webshop/products'
      }, {
        name: '',
        url: ''
      }, {
        name: 'Kurv',
        url: ''
      }, {
        name: 'Din indkøbskurv',
        url: ''
      }, {
        name: '',
        url: ''
      }, {
        name: 'Dine ordre',
        url: '#/webshop/orders'
      }, {
        name: '',
        url: ''
      }, {
        name: 'Ønskeliste',
        url: '#/webshop/wishlist'
      }],
      pagerealactivepage: ''
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayCartCount();
    this.displayWishListCount();
    this.displayOrderCount();
    this.displayPageName();
  },

  methods: {
    displayCartCount: function displayCartCount() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (typeof res !== 'undefined' && res !== null && res.success) {
          var dataRes = response.data.data.data[0].webshop_cart_products;
          var qty = 0;
          for (var i = 0; i < dataRes.length; i++) {
            qty += parseInt(dataRes[i].QUANTITY);
          }
          _this.cartCount = qty;
        } else {
          qty = 0;
          _this.cartCount = qty;
          console.log('Error in displayCartCount()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    displayWishListCount: function displayWishListCount() {
      var _this2 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data.data;
          var wishlistcount = [];
          wishlistcount = dataRes.filter(function (a) {
            return a.ID !== null;
          });
          _this2.wishListCount = wishlistcount.length;
        } else {
          console.log('Error in displayWishListCount()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    displayOrderCount: function displayOrderCount() {
      var _this3 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var total = response.data.data.total;
          _this3.orderCount = total;
        } else {
          console.log('Error in displayOrderCount()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    displayPageName: function displayPageName() {
      if (window.location.href.indexOf('products') > -1) {
        this.pageHeader = 'Brug dine glade kunder i din markedsføring';
        this.breadCrumb = [0, 1];
      } else if (window.location.href.indexOf('product') > -1) {
        this.pageHeader = 'Håndværker.dk webshop';
        this.breadCrumb = [0, 2, 5];
        this.displayProductInfo();
      } else if (window.location.href.indexOf('cart') > -1) {
        this.pageHeader = 'Kurv';
        this.breadCrumb = [0, 3];
      } else if (window.location.href.indexOf('checkout') > -1) {
        this.pageHeader = 'Din indkøbskurv';
        this.breadCrumb = [0, 4];
      } else if (window.location.href.indexOf('orders') > -1) {
        this.pageHeader = 'Dine ordre';
        this.breadCrumb = [0, 6];
      } else if (window.location.href.indexOf('order') > -1) {
        this.pageHeader = 'Dine ordre';
        this.pagerealactivepage = 'dine ordre';
        this.breadCrumb = [0, 6, 7];
        var urlStr = window.location.href;
        var url = new URL(urlStr.replace('/#', ''));
        var searchParams = url.searchParams;
        var id = searchParams.get('id');
        this.pageData[7].name = '#' + id;
      } else if (window.location.href.indexOf('wishlist') > -1) {
        this.pageHeader = 'Din ønskeliste';
        this.breadCrumb = [0, 8];
      }
    },
    displayProductInfo: function displayProductInfo() {
      var _this4 = this;

      var urlStr = window.location.href;
      var url = new URL(urlStr.replace('/#', ''));
      var searchParams = url.searchParams;
      var id = searchParams.get('id');
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/' + id + '/0/0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var prodCat = response.data.data[0].CATEGORY;
          var prodCatId = response.data.data[0].CATEGORY_ID;
          var prodName = response.data.data[0].NAME;
          _this4.pageData[2].name = prodCat;
          _this4.pageData[2].url = '#/webshop/products?cat_id=' + prodCatId;
          _this4.pageData[5].name = prodName;
        } else {
          console.log('Error in displayProductInfo()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('div',{staticClass:"center more-muted-background gibson py3 px3"},[(_vm.pageHeader == 'Dine ordre' && _vm.pagerealactivepage === 'dine ordre' )?_c('h2',{staticClass:"darkblue"},[_c('a',{staticClass:"no-hover mintgreen",attrs:{"href":"#/webshop/orders"}},[_vm._v(_vm._s(_vm.pageHeader))])]):_c('h2',{staticClass:"darkblue"},[_c('span',[_vm._v(_vm._s(_vm.pageHeader))])]),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',{staticClass:"shop-header flex justify-center"},[_c('div',{staticClass:"mr2"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"relative badge badge-pill badge-danger totalCart mr1",attrs:{"id":"totalInbox"}},[_vm._v(_vm._s(_vm.cartCount))])]),_vm._v(" "),_c('div',{staticClass:"mr2"},[_c('a',{staticClass:"cart-icon darkblue",attrs:{"href":"#/webshop/wishlist","title":"Ønske liste"}},[_c('svg',{attrs:{"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"35.000000pt","height":"35.000000pt","viewBox":"0 0 2048.000000 2048.000000","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(0.000000,2048.000000) scale(0.100000,-0.100000)","fill":"#000000","stroke":"none"}},[_c('path',{attrs:{"d":"M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019\n                -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214\n                -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233\n                393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965\n                2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233\n                994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559\n                -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245\n                -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48\n                -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177\n                -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890\n                -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236\n                -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788\n                1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208\n                460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21\n                -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051\n                -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782\n                -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155\n                390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"}})])])]),_vm._v(" "),_c('span',{staticClass:"relative badge badge-pill badge-danger totalWishList",attrs:{"id":"totalInbox"}},[_vm._v(_vm._s(_vm.wishListCount))])]),_vm._v(" "),_c('div',[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"relative badge badge-pill badge-danger totalOrders",attrs:{"id":"totalInbox"}},[_vm._v(_vm._s(_vm.orderCount))])])])]),_vm._v(" "),_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('div',{staticClass:"center flex justify-center gibson px3",staticStyle:{"display":"none"}},[_c('el-breadcrumb',{staticClass:"h6 breadCrumb hide",attrs:{"separator":">"}},_vm._l((_vm.pageData),function(page,index){return _c('el-breadcrumb-item',{key:index},[_c('a',{staticClass:"no-underline pointer relative",attrs:{"href":page.url}},[_c('span',{staticClass:"regular mintgreen"},[_vm._v(_vm._s(page.name))])])])}),1)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cart-icon darkblue",attrs:{"href":"#/webshop/cart","title":"Kurv"}},[_c('i',{staticClass:"el-icon-shopping-cart-full"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"cart-icon darkblue",attrs:{"href":"#/webshop/orders","title":"Ordre"}},[_c('i',{staticClass:"el-icon-bank-card"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1373 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gibson p4 fourthcolor-background center relative flex justify-center items-start",staticStyle:{"background-repeat":"no-repeat","height":"500px","background-position":"left","background-image":"url('../../static/img/banner-new-no-data.jpg?rotate=0&mode=crop')"}},[_c('div',{attrs:{"id":"card"}},[_c('div',{staticClass:"card1"},[_c('div',{staticClass:"items-center center "},[_c('h2',{staticClass:"white break-word line-height-2 mb1",staticStyle:{"font-size":"1rem","margin-bottom":".17rem"}},[_vm._v("Her arbejder "+_vm._s(_vm.haaId)+" ")]),_vm._v(" "),_c('h1',{staticClass:"white break-word line-height-1 mb1",staticStyle:{"font-size":"1.2rem","margin-bottom":".3rem"}},[_vm._v("Din lokale "+_vm._s(_vm.companyPrimaryIndustryName)+" ")]),_vm._v(" "),_c('h1',{staticClass:"break-word line-height-1 mintgreen mb1 ",staticStyle:{"font-size":"1.5rem","margin-bottom":"0"}},[_vm._v("\n                "+_vm._s(_vm.companyName)+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"center white break-word regular",staticStyle:{"font-size":".9rem"}},[_c('li',[_c('i',{staticClass:"el-icon-phone pr1"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.companyTelephone)+" ")])])]),_vm._v(" "),_c('h3',{staticClass:"white ",staticStyle:{"font-size":".6rem","margin-top":"0","margin-bottom":".5rem"}},[_vm._v("CVR: "+_vm._s(_vm.companyCVR)+" ")]),_vm._v(" "),_c('h2',{staticClass:"white line-height-1 ",staticStyle:{"font-size":"0.8rem","margin-bottom":"0"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(_vm.companyRating)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"card2"},[_c('div',{staticClass:"items-center center "},[_c('h2',{staticClass:"darkblue break-word line-height-2 mb1",staticStyle:{"font-size":"1rem","margin-bottom":".17rem"}},[_vm._v("Her arbejder")]),_vm._v(" "),_c('h1',{staticClass:"darkblue break-word line-height-1 mb1",staticStyle:{"font-size":"1.2rem","margin-bottom":".3rem"}},[_vm._v("Din lokale "+_vm._s(_vm.companyPrimaryIndustryName)+" ")]),_vm._v(" "),_c('h1',{staticClass:"break-word line-height-1 mintgreen mb1 ",staticStyle:{"font-size":"1.5rem","margin-bottom":"0"}},[_vm._v("\n                "+_vm._s(_vm.companyName)+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"center darkblue break-word regular",staticStyle:{"font-size":".9rem"}},[_c('li',[_c('i',{staticClass:"el-icon-phone pr1"}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.companyTelephone)+" ")])])]),_vm._v(" "),_c('h3',{staticClass:"darkblue ",staticStyle:{"font-size":".6rem","margin-top":"0","margin-bottom":".5rem"}},[_vm._v("CVR: "+_vm._s(_vm.companyCVR)+" ")]),_vm._v(" "),_c('h2',{staticClass:"darkblue line-height-1 ",staticStyle:{"font-size":"0.8rem","margin-bottom":"0"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',[_vm._v("\n                   "+_vm._s(_vm.companyRating)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"card3"},[_c('div',{staticClass:"items-center center "},[_c('h1',{staticClass:"darkblue break-word line-height-1 ",staticStyle:{"font-size":".75rem","margin-bottom":".1rem"}},[_vm._v("Din lokale "+_vm._s(_vm.companyPrimaryIndustryName)+" ")]),_vm._v(" "),_c('h1',{staticClass:"break-word line-height-1 mintgreen  ",staticStyle:{"font-size":".9rem","margin-bottom":"0"}},[_vm._v("\n                "+_vm._s(_vm.companyName)+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"center darkblue break-word regular",staticStyle:{"font-size":".6rem","margin-bottom":"0","margin-top":"0"}},[_c('li',[_c('i',{staticClass:"el-icon-phone pr1",staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('span',[_vm._v(" "+_vm._s(_vm.companyTelephone)+" ")])])]),_vm._v(" "),_c('h3',{staticClass:"darkblue ",staticStyle:{"font-size":".4rem","margin-top":"0","margin-bottom":".3rem"}},[_vm._v("CVR: "+_vm._s(_vm.companyCVR)+" ")]),_vm._v(" "),_c('h2',{staticClass:"darkblue line-height-1 ",staticStyle:{"font-size":"0.5rem","margin-bottom":"0"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',[_vm._v("\n                  "+_vm._s(_vm.companyRating)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"card4"},[_c('div',{staticClass:"items-center center "},[_c('h1',{staticClass:"white break-word line-height-1 ",staticStyle:{"font-size":".75rem","margin-bottom":".1rem"}},[_vm._v(" "+_vm._s(_vm.companyPrimaryIndustryName)+" ")]),_vm._v(" "),_c('h1',{staticClass:"break-word line-height-1 mintgreen  ",staticStyle:{"font-size":".9rem","margin-bottom":"0"}},[_vm._v("\n                "+_vm._s(_vm.companyName)+"\n                ")]),_vm._v(" "),_c('ul',{staticClass:"center white break-word regular",staticStyle:{"font-size":".6rem","margin-bottom":"0","margin-top":"0"}},[_c('li',[_c('i',{staticClass:"el-icon-phone pr1",staticStyle:{"margin-bottom":"0"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.companyTelephone))])])]),_vm._v(" "),_c('h3',{staticClass:"white ",staticStyle:{"font-size":".4rem","margin-top":"0","margin-bottom":".3rem"}},[_vm._v("CVR: "+_vm._s(_vm.companyCVR)+" ")]),_vm._v("}\n                "),_c('h2',{staticClass:"white line-height-1 ",staticStyle:{"font-size":"0.5rem","margin-bottom":"0"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',[_vm._v("\n                 "+_vm._s(_vm.companyRating)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"card5"},[_c('h2',{staticClass:"white bold line-height-2",staticStyle:{"font-size":".45rem"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',{staticClass:" items-center justify-between",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"position":"absolute"}},[_vm._v("\n                    "+_vm._s(_vm.companyName)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"left-align",staticStyle:{"float":"right","position":"absolute","padding-left":"64px","padding-top":"5px"}},[_c('p',{staticClass:"  white ",staticStyle:{"font-size":".35rem","padding-bottom":"0"}},[_vm._v("Mere end "+_vm._s(_vm.companyTotalRating)+" anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"  white ",staticStyle:{"font-size":".35rem","padding-top":"0"}},[_vm._v("Over  "+_vm._s(_vm.companyRating)+" stjerner i gennemsnit")])])])]),_vm._v(" "),_c('div',{staticClass:"card6"},[_c('h2',{staticClass:"darkblue bold line-height-2",staticStyle:{"font-size":".45rem"}},[_vm._v("Kunderne anbefaler os på Håndværker.dk")]),_vm._v(" "),_c('div',{staticClass:" items-center justify-between",staticStyle:{"position":"relative"}},[_c('div',{staticStyle:{"position":"absolute"}},[_vm._v("\n                    "+_vm._s(_vm.companyName)+"\n                    ")]),_vm._v(" "),_c('div',{staticClass:"left-align",staticStyle:{"float":"right","position":"absolute","padding-left":"64px","padding-top":"5px"}},[_c('p',{staticClass:"  darkblue ",staticStyle:{"font-size":".35rem","padding-bottom":"0"}},[_vm._v("Mere end "+_vm._s(_vm.companyTotalRating)+" anbefalinger")]),_vm._v(" "),_c('p',{staticClass:"  darkblue ",staticStyle:{"font-size":".35rem","padding-top":"0"}},[_vm._v("Over  "+_vm._s(_vm.companyRating)+" stjerner i gennemsnit")])])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"overview"}},[(!_vm.showMobile)?_c('div',[_c('div',{staticClass:"gibson p3 center relative flex justify-center items-start",attrs:{"id":"bannerbody"}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py2 flex flex-wrap"},_vm._l((_vm.catData),function(cat,index){return _c('div',{key:index,staticClass:"lg-col-6 md-col-12 p0",attrs:{"id":cat.ID}},[_c('div',{staticClass:"block"},[_c('div',{staticClass:"flex more-muted-background p3 mr3 mb3"},[_c('div',{staticClass:"col-6"},[(_vm.imageLoadingpng)?_c('div',{class:'clearfix loader-'+cat.ID},[_vm._m(1,true)]):_vm._e(),_vm._v(" "),_c('div',{class:'hide catImages-'+cat.ID},[_c('a',{attrs:{"href":'#/webshop/products?cat_id='+cat.ID,"title":cat.VALUE}},[_c('img',{staticClass:"prod-img",attrs:{"src":cat.IMAGE_URL,"width":"100%"},on:{"load":function($event){return _vm.onImageLoad(cat.ID)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-6 center "},[_c('span',{staticClass:"h5 darkblue bold"},[_vm._v(_vm._s(cat.VALUE))]),_vm._v(" "),_c('div',{staticClass:"pb3"}),_vm._v(" "),_c('div',[_c('a',{staticClass:"regular caps action-button btn-secondary py1 px3 m0 line-height-1 gibson not-rounded border-none inline-block",attrs:{"href":'#/webshop/products?cat_id='+cat.ID}},[_c('span',[_vm._v("Bestil "+_vm._s(cat.VALUE))])])]),_vm._v(" "),_c('div',{staticClass:"pb3 "}),_vm._v(" "),_c('p',{staticClass:"darkblue gibson semi-bold m0"},[_vm._v("\n                  "+_vm._s(cat.DESCRIPTION)+"\n                ")])])])])])}),0)]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"mobile-view"},[_vm._m(2),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(3)]):_c('div',{staticClass:"lightgrey-background p3"},_vm._l((_vm.catData),function(cat,index){return _c('div',{key:index},[_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"white-background p2 mb3 cstm-height"},[_c('div',{staticClass:"flex flex-wrap items-center mb3"},[_c('div',{staticClass:"col-6 pr2 p0"},[_c('div',{class:'clearfix loader-'+cat.ID},[_vm._m(4,true)]),_vm._v(" "),_c('div',{class:'hide catImages-'+cat.ID},[_c('a',{attrs:{"href":'#/webshop/products?cat_id='+cat.ID,"title":cat.VALUE}},[_c('img',{staticClass:"prod-img",attrs:{"src":cat.IMAGE_URL,"width":"100%"},on:{"load":function($event){return _vm.onImageLoad(cat.ID)}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-6 center p0"},[_c('span',{staticClass:"h5 darkblue bold"},[_vm._v(_vm._s(cat.VALUE))]),_vm._v(" "),_c('p',{staticClass:"font-weight-light gibson line-height-2 m0"},[_vm._v("\n                  "+_vm._s(cat.DESCRIPTION)+"\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"center"},[(cat.ID != 204)?_c('a',{staticClass:"h6 caps action-button pt2 pb1 px2 gibson not-rounded border-none block",attrs:{"href":'#/webshop/products?cat_id='+cat.ID}},[_c('span',[_vm._v("KØB "+_vm._s(cat.VALUE))])]):_c('a',{staticClass:"h4 caps action-button pt2 pb1 px2 gibson not-rounded border-none block",attrs:{"href":"#/badges"}},[_c('span',[_vm._v("Hent her")])])])])])])])}),0)]):_vm._e(),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"center mediumgrey bold"},[_vm._v("Genererer forhåndsvisning...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gibson p3 fourthcolor-background center relative flex items-start",attrs:{"id":"bannerbody"}},[_c('div',{staticClass:"col-12 hide"},[_c('h1',{staticClass:"white regular mb3",staticStyle:{"font-size":"3.3rem"}},[_vm._v("VELKOMMEN TIL")]),_vm._v(" "),_c('div',{staticClass:"flex mb3"},[_c('div',{staticClass:"col-3 p0"},[_c('img',{staticClass:"mb1",attrs:{"src":"/static/svg/h.svg","width":"85%"}}),_vm._v(" "),_c('div',[_c('img',{staticClass:"mr0",attrs:{"src":"/static/svg/star-dark.svg","width":"15%"}}),_vm._v(" "),_c('img',{staticClass:"mr0",attrs:{"src":"/static/svg/star-dark.svg","width":"15%"}}),_vm._v(" "),_c('img',{staticClass:"mr0",attrs:{"src":"/static/svg/star-dark.svg","width":"15%"}}),_vm._v(" "),_c('img',{staticClass:"mr0",attrs:{"src":"/static/svg/star-dark.svg","width":"15%"}}),_vm._v(" "),_c('img',{staticClass:"mr0",attrs:{"src":"/static/svg/star-dark.svg","width":"15%"}})])]),_vm._v(" "),_c('div',{staticClass:"col-9 p0"},[_c('h2',{staticClass:"white regular",staticStyle:{"font-size":"2.7rem"}},[_c('span',[_vm._v("Håndværker.dk")]),_vm._v(" "),_c('span',{staticStyle:{"font-size":"3.6rem"}},[_vm._v("Prisen "),_c('span',{staticClass:"green"},[_vm._v("2021")])])])])]),_vm._v(" "),_c('h1',{staticClass:"white regular mb4",staticStyle:{"font-size":"3.6rem"}},[_vm._v("WEBSHOPPEN")]),_vm._v(" "),_c('div',{staticClass:"pt2 hide"},[_c('a',{staticClass:"action-button p2 line-height-1 gibson not-rounded border-none block",attrs:{"href":"#/webshop/products"}},[_c('span',{staticClass:"mr2 regular"},[_vm._v("KØB NU")]),_c('span',[_c('i',{staticClass:"el-icon-right"})])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1375 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__ = __webpack_require__(1377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b9f22_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__ = __webpack_require__(1378);
function injectStyle (ssrContext) {
  __webpack_require__(1376)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_438b9f22_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_products_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1377 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(106);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      showbadge: '',
      showtaktext: false,
      activeTabName: '0',
      tabPosition: 'top',
      catData: '',
      totalProdCount: 0,
      totalprodpercat: 0,
      prodData: '',
      deductBadgesProduct: 0,
      search: '',
      prodIdsWishList: '',
      prodMsg: '',
      curPage: 1,
      lastPage: 20,
      heightimage: 380,
      widthimage: 380,
      form: {},
      badgesCount: 0,
      renderedStreamer: false,
      renderedBladder: false,
      loopStatusImageCheck: '',
      prodBadgesIdsArr: []
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.showbadge = localStorage.getItem('showbadgewebshop');
    this.currentTab();
    this.displayCategories();
    this.getProdIdWishList();
    this.displayProducts();
    this.removeUrlQstinMrk();
  },

  methods: {
    checkimage: function checkimage(prodId, prodGroup, index) {
      var imgLink = '';
      if (prodGroup !== '9001') {
        imgLink = 'http://widget.haandvaerker.dk/products/' + this.prodData[index].PRODUCT_GROUP + '/' + this.prodData[index].EXT + '/productPng.php?id=' + this.haaId;
      } else {
        imgLink = 'http://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id=' + this.haaId;
      }
      var img = document.querySelectorAll('.prodImg-' + prodId + ' img');
      for (var i = 0; i < img.length; i++) {
        img[i].src = imgLink;
      }
    },
    onImageLoad: function onImageLoad(prodId) {
      setTimeout(function () {
        var hidden = document.querySelectorAll('.prodImg-' + prodId);
        for (var i = 0; i < hidden.length; i++) {
          hidden[i].classList.remove('hide');
        }
        var loader = document.querySelectorAll('.loader-' + prodId);
        for (var x = 0; x < loader.length; x++) {
          loader[x].remove();
        }
      }, 500);
    },
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    removeUrlQstinMrk: function removeUrlQstinMrk() {
      var url = window.location.href;
      history.pushState({}, null, url.replace('/?', ''));
    },
    displayCategories: function displayCategories() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetCategory/0', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data;
          var prodCount = 0;
          var dataResres = [];
          if (_this.showbadge === 'no') {
            dataResres = dataRes.filter(function (a) {
              return a.ID !== 205;
            });
          } else {
            dataResres = dataRes;
          }
          _this.catData = dataResres;
          dataResres.forEach(function (element) {
            _this.getproducteachcount(element);
          });
          _this.totalProdCount = prodCount;
        } else {
          console.log('Error in displayCategories()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getproducteachcount: function getproducteachcount(catResess) {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + catResess.ID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data;
          var prodcountpercat = [];
          var thisvar = _this2;
          prodcountpercat = dataRes.filter(function (element) {
            if (element.CATEGORY_ID === 205) {
              for (var k = 0; k < element.get_element_property.length; k++) {
                if (element.get_element_property[k].IBLOCK_PROPERTY_ID === 427 && element.get_element_property[k].VALUE === thisvar.haaId) {
                  return element;
                }
              }
            } else {
              return element.NEED_GRAPHIC_HELP === 'No' && element.DESCRIPTION !== 'Dette viser, at denne virksomhed har brug for hjælp til hans/hendes grafik til dette specifikke produkt';
            }
          });
          catResess['PRODUCT_COUNT'] = prodcountpercat.length;
          _this2.totalProdCount += prodcountpercat.length;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getProdIdWishList: function getProdIdWishList() {
      var _this3 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data.data;
          var prodIds = [];
          for (var i = 0; i < dataRes.length; i++) {
            var prodId = dataRes[i].ID;
            if (prodId !== null) {
              prodIds.push(prodId);
            }
          }
          _this3.prodIdsWishList = prodIds;
        } else {
          console.log('Error in getProdIdWishList()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    displayProducts: function displayProducts() {
      var _this4 = this;

      this.insideLoading = true;
      var data = {
        salesPerson: this.salesPerson
      };
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + this.activeTabName + '?page=1', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data;
          var pagLastPage = response.data.data.last_page + '0';
          var products = [];
          var allproducts = [];
          var deductBadgesCount = 0;
          if (_this4.activeTabName === '205') {
            for (var j = 0; j < dataRes.length; j++) {
              for (var k = 0; k < dataRes[j].get_element_property.length; k++) {
                if (dataRes[j].get_element_property[k].IBLOCK_PROPERTY_ID === 427) {
                  if (dataRes[j].get_element_property[k].VALUE === _this4.haaId) {
                    products.push(dataRes[j]);
                  } else {
                    deductBadgesCount++;
                  }
                }
              }
            }
          } else {
            products = dataRes.filter(function (a) {
              return a.NEED_GRAPHIC_HELP === 'No';
            });
          }
          if (_this4.showbadge === 'no') {
            allproducts = products.filter(function (a) {
              return a.CATEGORY_ID !== 205;
            });
          } else {
            allproducts = products;
          }
          _this4.prodData = allproducts;
          _this4.deductBadgesProduct = deductBadgesCount;
          _this4.lastPage = pagLastPage;
          if (!dataRes.length) {
            _this4.prodMsg = 'Ingen Produkter.';
          } else {
            _this4.prodMsg = '';
          }
          if (_this4.activeTabName === '205') {
            _this4.showBreadCrumb();
            _this4.getBadges();
            for (var i = 0; i < _this4.prodData.length; i++) {
              for (var x = 0; x < _this4.prodData[i].get_element_property.length; x++) {
                if (_this4.prodData[i].get_element_property[x].IBLOCK_PROPERTY_ID === 428) {
                  _this4.prodBadgesIdsArr.push(parseInt(_this4.prodData[i].get_element_property[x].VALUE));
                }
              }
            }
          }
          for (var e = 0; e < _this4.prodData.length; e++) {
            if (_this4.prodData[e].SIZE === '') {
              _this4.prodData[e].EXT = '0';
            } else {
              _this4.prodData[e].EXT = _this4.prodData[e].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '');
            }
            _this4.prodData[e].LOAD = true;
            _this4.loading = false;
            _this4.insideLoading = false;
          }
        } else {
          _this4.showBreadCrumb();
          _this4.loading = false;
          _this4.insideLoading = false;
          console.log('Error in displayProducts()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    currentTab: function currentTab() {
      if (window.location.href.indexOf('?cat_id') > -1) {
        var urlStr = window.location.href;
        var url = new URL(urlStr.replace('/#', ''));
        var searchParams = url.searchParams;
        this.activeTabName = searchParams.get('cat_id');
      }
    },
    tabChanged: function tabChanged() {
      var input = document.querySelector('input.search');
      input.value = '';
      this.curPage = 1;
      this.displayProducts();
      this.insideLoading = true;
    },
    displaySearchedProducts: function displaySearchedProducts() {
      var _this5 = this;

      this.insideLoading = true;
      this.removeUrlQstinMrk();
      var search = this.search;
      var searchVal = '';
      if (search !== '') {
        searchVal = search;
      } else {
        searchVal = 0;
      }
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/0/' + searchVal + '/' + this.activeTabName + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data;
          var pagLastPage = response.data.data.last_page + '0';
          _this5.prodData = dataRes;
          _this5.lastPage = pagLastPage;
          if (!dataRes.length) {
            _this5.prodMsg = 'Ingen Produkter Fundet.';
          } else {
            _this5.prodMsg = '';
          }
          for (var i = 0; i < _this5.prodData.length; i++) {
            if (_this5.prodData[i].SIZE === '') {
              _this5.prodData[i].EXT = '0';
            } else {
              _this5.prodData[i].EXT = _this5.prodData[i].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '');
            }
            _this5.prodData[i].LOAD = true;

            for (var x = 0; x < _this5.prodData[i].get_element_property.length; x++) {
              if (_this5.prodData[i].get_element_property[x].IBLOCK_PROPERTY_ID === 428) {
                _this5.prodBadgesIdsArr.push(parseInt(_this5.prodData[i].get_element_property[x].VALUE));
              }
            }
          }
          _this5.getBadges();
        } else {
          _this5.loading = false;
          _this5.insideLoading = false;
          console.log('Error in displaySearchedProducts()');
        }
      });
    },
    addRemoveProdWishList: function addRemoveProdWishList(id, status) {
      var _this6 = this;

      var compId = this.haaId;
      var prodId = id;
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddRemoveWishlist',
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          CompanyID: compId,
          ProductID: prodId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.getProdIdWishList();
          var search = _this6.search;
          if (search !== '') {
            _this6.displaySearchedProducts();
          } else {
            _this6.displayProducts();
          }
          _this6.calulateWishListCount();
          if (status === 'added') {
            _this6.$toastr('success', 'Tilføjet');
          } else {
            _this6.$toastr('success', 'Fjernet');
          }
        } else {
          _this6.loading = false;
          _this6.insideLoading = false;
          console.log('Error in addRemoveProdWishList()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      this.insideLoading = true;
    },
    calulateWishListCount: function calulateWishListCount() {
      var _this7 = this;

      setTimeout(function () {
        var prodWishList = _this7.prodIdsWishList;
        for (var i = 0; i < prodWishList.length; i++) {}
        document.querySelector('.totalWishList').innerText = i;
      }, 1000);
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      var search = this.search;
      if (search !== '') {
        this.displaySearchedProducts();
      } else {
        this.displayProducts();
      }
      this.insideLoading = true;
    },
    downloadFiles: function downloadFiles(url) {
      var filename = url.substring(url.lastIndexOf('/') + 1).split('?')[0];
      var xhr = new XMLHttpRequest();
      xhr.responseType = 'blob';
      xhr.onload = function () {
        var a = document.createElement('a');
        a.href = window.URL.createObjectURL(xhr.response);
        a.download = filename;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        a.remove();
      };
      xhr.open('GET', url);
      xhr.send();
    },
    pushtonewsfeed: function pushtonewsfeed() {
      this.$router.push('/newsfeed');
    },
    getBadges: function getBadges() {
      var _this8 = this;

      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var badgesList = res.Badges;
        var filteredBadges = badgesList.filter(function (property) {
          return property['Industry'] != null;
        });
        var badgesArr = _this8.mergedBadges(filteredBadges);
        _this8.badgesCount = badgesArr.length;
        for (var i = 0; i < badgesArr.length; i++) {
          if (!_this8.prodBadgesIdsArr.includes(badgesArr[i].id)) {
            _this8.addProduct(badgesArr[i].id, badgesArr[i].name, i, badgesArr.length);
          }
        }
        var thisVar = _this8;
        _this8.loopStatusImageCheck = window.setInterval(function () {
          thisVar.getImageStatus('streamer', 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/' + thisVar.haaId + '/' + thisVar.badgesCount + '.jpg');
          thisVar.getImageStatus('bladder', 'https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/rendered/' + thisVar.haaId + '/' + thisVar.badgesCount + '.jpg');
        }, 2000);
      }, function (err) {
        console.log('Error in getBadgesCount()', err);
        _this8.show = false;
      });
    },
    mergedBadges: function mergedBadges(filteredBadges) {
      var badges = [];
      var removeDuplicates = [];
      var finalBadges = [];
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i].Industry === 'TV inspektion') {
          filteredBadges[i].Industry = 'TVInspektion';
        }
        for (var x = 0; x < badges.length; x++) {
          if (filteredBadges[i].Industry + '' + filteredBadges[i].Area.replace('Region', '') + ' ' + filteredBadges[i].Position === badges[x].name) {
            removeDuplicates.push({
              id: badges[x].id,
              name: badges[x].name
            });
          }
        }
        badges.push({
          id: filteredBadges[i].Id,
          name: filteredBadges[i].Industry + '' + filteredBadges[i].Area.replace('Region', '') + ' ' + filteredBadges[i].Position
        });
      }

      for (var j = 0; j < badges.length; j++) {
        for (var k = 0; k < removeDuplicates.length; k++) {
          if (removeDuplicates[k].name === badges[j].name && removeDuplicates[k].id !== badges[j].id) {} else {
            finalBadges.push({
              id: badges[j].id,
              name: badges[j].name
            });
          }
        }
      }
      return finalBadges;
    },
    addProduct: function addProduct(badgeId, badgeName, badgeIndex, badgeLength) {
      var _this9 = this;

      var id = badgeId;

      var name = badgeName;
      var index = badgeIndex + 1;
      var search = this.search;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddProduct',
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          product_name: name,
          product_price: 200,
          supplier_id: this.haaId,
          badge_id: id,
          image_url: 'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/' + this.haaId + '/' + index + '.jpg',
          category_id: 205,
          description: 'Skal du have mere opmærksomhed på vejene? Pynt bilen med flere streamers her'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (index === badgeLength) {
            _this9.displayCategories();
            if (search !== '') {
              _this9.displaySearchedProducts();
            } else {
              _this9.displayProducts();
            }
          }
        } else {
          console.log('Error in addProduct()', response);
        }
      }, function (response) {
        console.log('Error in addProduct()', response);
      });
    },
    getImageStatus: function getImageStatus(badge, url) {
      var request = new XMLHttpRequest();
      var thisVar = this;
      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (badge === 'bladder') {
              clearInterval(thisVar.loopStatusCheck);
              thisVar.displayAllBadges = true;
            }
            clearInterval(thisVar.loopStatusImageCheck);
            thisVar.loading = false;
            thisVar.insideLoading = false;
          } else {
            if (badge === 'streamer') {
              thisVar.renderedStreamer = true;
            } else {
              thisVar.renderedBladder = true;
            }
          }
        }
      };
      request.open('GET', url, true);
      request.send();
    }
  },
  watch: {
    'search': function search(newval, oldval) {
      var _this10 = this;

      setTimeout(function () {
        _this10.displaySearchedProducts();
      }, 200);
      this.insideLoading = true;
    }
  }
});

/***/ }),
/* 1378 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"products"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.renderedStreamer)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),(_vm.renderedBladder)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/bladder/bladderPng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',[_c('div',{staticClass:"p0"},[_c('div',{attrs:{"id":"productFilter"}},[_c('el-tabs',{attrs:{"tab-position":_vm.tabPosition},on:{"tab-click":function($event){return _vm.tabChanged()}},model:{value:(_vm.activeTabName),callback:function ($$v) {_vm.activeTabName=$$v},expression:"activeTabName"}},[_c('b-form',{ref:"form",staticClass:"lg-col-6 ml-auto mr-auto",attrs:{"model":_vm.form}},[_c('div',{staticClass:"p0"},[_c('b-form-input',{staticClass:"search",attrs:{"placeholder":"Søg produkt","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)]),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('el-tab-pane',{attrs:{"name":"0","label":'Alle (' + (_vm.totalProdCount - _vm.deductBadgesProduct) + ')'}},[_c('div',{staticClass:"fit"},[(_vm.prodMsg == '')?_c('div',{staticClass:"right-align hide"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"center mediumgrey bold"},[_vm._v("Genererer forhåndsvisning...")])])]):_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.prodData),function(prod,index){return _c('div',{key:index,staticClass:"lg-col-3 md-col-4 p0",attrs:{"id":'prodId-'+prod.ID}},[_c('div',{staticClass:"py2 px1",attrs:{"id":"imageloading"}},[_c('div',{staticClass:"relative"},[_c('div',{class:'clearfix py4 img-loader loader-'+prod.ID},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]),_vm._v(" "),_c('div',{class:'hide prodImg-'+prod.ID},[_c('div',{staticClass:"relative border muted-border more-muted-background"},[_c('div',{staticClass:"absolute right-0 mt1"},[(_vm.prodIdsWishList.includes(prod.ID))?_c('a',{staticClass:"pointer z2 mr1 wishlist-icon",attrs:{"title":"Fjern til ønskelisten"},on:{"click":function($event){return _vm.addRemoveProdWishList(prod.ID, 'removed')}}},[_c('span',{staticClass:"mintgreen"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"}})])])]):_c('a',{staticClass:"pointer z2 mt1 mr1 wishlist-icon",attrs:{"title":"Tilføj til ønskeliste"},on:{"click":function($event){return _vm.addRemoveProdWishList(prod.ID, 'added')}}},[_c('svg',{staticClass:"mintgreen h4",attrs:{"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"35.000000pt","height":"35.000000pt","viewBox":"0 0 2048.000000 2048.000000","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(0.000000,2048.000000) scale(0.100000,-0.100000)","fill":"#000000","stroke":"none"}},[_c('path',{attrs:{"d":"M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019\n                                    -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214\n                                    -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233\n                                    393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965\n                                    2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233\n                                    994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559\n                                    -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245\n                                    -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48\n                                    -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177\n                                    -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890\n                                    -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236\n                                    -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788\n                                    1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208\n                                    460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21\n                                    -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051\n                                    -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782\n                                    -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155\n                                    390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"}})])])])]),_vm._v(" "),(prod.CATEGORY_ID != 104)?_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[(prod.get_product_image.length)?_c('div',[(prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP === '10001' || prod.PRODUCT_GROUP === '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005' )?_c('img',{staticClass:"prod-img",attrs:{"data-key":index,"src":typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+_vm.haaId,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)},"error":function($event){return _vm.checkimage(prod.ID, prod.PRODUCT_GROUP, index)}}}):_c('img',{staticClass:"prod-img",attrs:{"id":"imagefcrm","src":'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)}}})]):_c('div',_vm._l((prod.get_element_property),function(prodImage){return (prodImage.IBLOCK_PROPERTY_ID == 429 && prod.PRODUCT_GROUP == '9001')?_c('img',{staticClass:"prod-img",attrs:{"src":prodImage.VALUE,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)},"error":function($event){return _vm.checkimage(prod.ID, prod.PRODUCT_GROUP, index)}}}):_vm._e()}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(prod.NAME))])]),_vm._v(" "),_c('span',{staticClass:"h6 mintgreen bold"},[_vm._v(_vm._s(prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))+"\n                                kr")])])])])])])}),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.prodMsg))])])],2)])]),_vm._v(" "),_vm._l((_vm.catData),function(cat,index){return _c('el-tab-pane',{key:index,attrs:{"name":cat.ID.toString(),"label":cat.VALUE + ' (' + (cat.PRODUCT_COUNT - _vm.deductBadgesProduct) + ')'}},[_c('div',{staticClass:"fit"},[(_vm.prodMsg == '')?_c('div',{staticClass:"right-align hide"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"center mediumgrey bold"},[_vm._v("Genererer forhåndsvisning...")])])]):_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.prodData),function(prod,index){return _c('div',{key:index,staticClass:"lg-col-3 md-col-4 p0",attrs:{"id":'prodId-'+prod.ID}},[_c('div',{staticClass:"py2 px1"},[_c('div',{class:'clearfix py4 img-loader loader-'+prod.ID},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]),_vm._v(" "),_c('div',{class:'hide prodImg-'+prod.ID},[_c('div',{staticClass:"relative border muted-border more-muted-background"},[_c('div',{staticClass:"absolute right-0 mt1"},[(_vm.prodIdsWishList.includes(prod.ID))?_c('a',{staticClass:"pointer z2 mr1 wishlist-icon",attrs:{"title":"Fjern til ønskelisten"},on:{"click":function($event){return _vm.addRemoveProdWishList(prod.ID, 'removed')}}},[_c('span',{staticClass:"mintgreen"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"}})])])]):_c('a',{staticClass:"pointer z2 mt1 mr1 wishlist-icon",attrs:{"title":"Tilføj til ønskeliste"},on:{"click":function($event){return _vm.addRemoveProdWishList(prod.ID, 'added')}}},[_c('svg',{staticClass:"mintgreen h4",attrs:{"version":"1.0","xmlns":"http://www.w3.org/2000/svg","width":"35.000000pt","height":"35.000000pt","viewBox":"0 0 2048.000000 2048.000000","preserveAspectRatio":"xMidYMid meet"}},[_c('g',{attrs:{"transform":"translate(0.000000,2048.000000) scale(0.100000,-0.100000)","fill":"#000000","stroke":"none"}},[_c('path',{attrs:{"d":"M6660 16374 c-915 -84 -1727 -468 -2350 -1110 -442 -457 -757 -1019\n                                    -913 -1629 -81 -315 -107 -515 -114 -866 -29 -1472 480 -2589 1852 -4059 214\n                                    -229 759 -769 1040 -1030 841 -782 1943 -1725 3475 -2975 107 -87 284 -233\n                                    393 -323 l197 -164 168 139 c92 77 343 283 557 458 1230 1006 2291 1907 2965\n                                    2519 686 623 1294 1228 1705 1696 679 773 1106 1463 1341 2166 161 481 233\n                                    994 221 1574 -6 275 -17 398 -58 615 -139 748 -504 1429 -1049 1958 -575 559\n                                    -1278 898 -2100 1013 -179 25 -644 30 -855 10 -853 -82 -1550 -392 -2245\n                                    -1000 -133 -116 -408 -392 -548 -548 -53 -60 -99 -108 -102 -108 -3 0 -49 48\n                                    -102 108 -144 162 -417 434 -559 557 -330 288 -600 470 -952 640 -365 177\n                                    -742 287 -1167 341 -120 15 -689 28 -800 18z m775 -842 c338 -53 598 -134 890\n                                    -278 344 -169 642 -391 991 -739 225 -224 368 -382 684 -755 128 -151 236\n                                    -275 240 -275 4 0 112 124 240 275 384 453 643 731 871 937 577 518 1166 788\n                                    1861 854 169 15 587 7 728 -16 420 -66 805 -211 1146 -430 164 -106 288 -208\n                                    460 -380 250 -250 386 -439 539 -750 157 -317 239 -596 279 -945 18 -156 21\n                                    -513 6 -695 -134 -1558 -1086 -2807 -4085 -5356 -864 -735 -2030 -1693 -2051\n                                    -1685 -23 9 -972 788 -1589 1305 -1876 1572 -2946 2604 -3595 3466 -588 782\n                                    -871 1465 -940 2270 -15 178 -12 539 5 690 60 519 244 985 554 1403 115 155\n                                    390 433 538 545 415 314 889 506 1412 573 164 20 648 12 816 -14z"}})])])])]),_vm._v(" "),(prod.CATEGORY_ID != 104)?_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[(prod.get_product_image.length )?_c('div',[(prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP === '10001' || prod.PRODUCT_GROUP === '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005')?_c('img',{staticClass:"prod-img",attrs:{"data-key":index,"src":typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+_vm.haaId,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)},"error":function($event){return _vm.checkimage(prod.ID, prod.PRODUCT_GROUP, index)}}}):_c('img',{staticClass:"prod-img",attrs:{"id":"imagefcrm","src":'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)}}})]):_c('div',_vm._l((prod.get_element_property),function(prodImage){return (prodImage.IBLOCK_PROPERTY_ID == 429 && prod.PRODUCT_GROUP == '9001')?_c('img',{staticClass:"prod-img",attrs:{"src":prodImage.VALUE,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(prod.ID)},"error":function($event){return _vm.checkimage(prod.ID, prod.PRODUCT_GROUP, index)}}}):_vm._e()}),0)]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(prod.NAME))])]),_vm._v(" "),_c('span',{staticClass:"h6 mintgreen bold"},[_vm._v(_vm._s(prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))+"\n                              kr")])])])])])}),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.prodMsg))])])],2)])])})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"pb3 lg-hide"})])]),_vm._v(" "),(!_vm.insideLoading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1379 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__ = __webpack_require__(1381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b18e73be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__ = __webpack_require__(1399);
function injectStyle (ssrContext) {
  __webpack_require__(1380)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_product_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b18e73be_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_product_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1380 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input_pdfonly_vue__ = __webpack_require__(322);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__products_byggepladsskilt__ = __webpack_require__(1382);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__products_Traadhegns__ = __webpack_require__(1383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__products_Rullestillads__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__products_Facadestillads__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__products_Byggepladshegn__ = __webpack_require__(1395);














/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_3_vue_select___default.a,
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__["a" /* default */],
    Byggepladsskilt: __WEBPACK_IMPORTED_MODULE_6__products_byggepladsskilt__["a" /* default */],
    Traadhegns: __WEBPACK_IMPORTED_MODULE_7__products_Traadhegns__["a" /* default */],
    Rullestillads: __WEBPACK_IMPORTED_MODULE_8__products_Rullestillads__["a" /* default */],
    Facadestillads: __WEBPACK_IMPORTED_MODULE_9__products_Facadestillads__["a" /* default */],
    Byggepladshegn: __WEBPACK_IMPORTED_MODULE_10__products_Byggepladshegn__["a" /* default */],
    FileUploadInputPdfonly: __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input_pdfonly_vue__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      needhelp: false,
      needhelpamount: '',
      subtotal: 0,
      subtotalqty: 0,
      dontshowproduct: true,
      dontshowneedhelp: true,
      cartneedhelp: [],
      cartprod: [],
      insideLoading: true,
      totalProdCount: 0,
      salesPerson: '',
      haaId: '',
      prodData: [],
      prodId: '',
      prodImg: [],
      uploadedpdf: [],

      prodGroup: '',
      qty: 1,
      priceIfQtyEQ2: '',
      priceIfQtyEQGT3: '',

      ruleForm: {}
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayProductInfo();
  },

  methods: {
    checkifneedhelpisincart: function checkifneedhelpisincart(needhelpname) {
      var _this = this;

      var needhelpnames = needhelpname.trim() + '-Brugforhjælp';
      var prodname = needhelpname.replace(/\s+/g, '').trim();
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (typeof res !== 'undefined' && res !== null && res.success) {
          var dataRes = response.data.data.data[0].webshop_cart_products;
          _this.cartneedhelp = dataRes.filter(function (a) {
            var nametempe = a.PRODUCT_NAME.replace(/\s+/g, '').trim().split('-')[0] + '-' + a.PRODUCT_NAME.replace(/\s+/g, '').trim().split('-')[1];
            if (nametempe === needhelpnames) {
              return a;
            }
          });
          _this.cartprod = dataRes.filter(function (a) {
            var nametempeprod = a.PRODUCT_NAME.replace(/\s+/g, '').trim();
            if (nametempeprod === prodname) {
              return a;
            }
          });
          if (_this.cartneedhelp.length >= 1) {
            _this.dontshowneedhelp = false;
          }
          if (_this.cartprod.length >= 1) {
            _this.dontshowproduct = false;
          }
        } else {
          console.log('Error in displayCart()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    currentdate: function currentdate() {
      var current = new Date();
      var date = current.getFullYear() + '-' + (current.getMonth() + 1) + '-' + current.getDate();
      return date;
    },
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    displayProductInfo: function displayProductInfo() {
      var _this2 = this;

      var urlStr = window.location.href;
      var url = new URL(urlStr.replace('/#', ''));
      var searchParams = url.searchParams;
      var id = searchParams.get('id');
      this.prodId = id;
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetProducts/' + id + '/0/0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data[0];
          _this2.getallproductbycat(dataRes.CATEGORY_ID);
          _this2.checkifneedhelpisincart(dataRes.NAME);

          var imgs = [];
          var defaultprod = {
            'ID': 8903,
            'IBLOCK_PROPERTY_ID': 98,
            'IBLOCK_ELEMENT_ID': 11682,
            'VALUE': '3502',
            'TIMESTAMP_X': '2022-01-26 13:16:00',
            'CONTENT_TYPE': 'image/jpeg',
            'HEIGHT': 788,
            'WIDTH': 732,
            'FILE_SIZE': 47521,
            'FILE_NAME': '40035 4.jpg',
            'ORIGINAL_NAME': '40035 4.jpg',
            'SUBDIR': 'iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx',
            'showURL': '/upload/iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx/40035 4.jpg'
          };
          if (response.data.data.length) {
            imgs = response.data.data[0].get_product_image;
            if (imgs.length === 0) {
              imgs.push(defaultprod);
            }
          } else {
            imgs = '';
          }
          _this2.loading = false;
          var group = response.data.data[0].PRODUCT_GROUP;
          var priceQtyEQ2 = response.data.data[0].PRICE_IF_QTYEQ2;
          var priceQtyEQgt3 = response.data.data[0].PRICE_IF_QTYEQGT3;

          _this2.needhelpamount = parseInt(response.data.data[0].PDF_UNIT_PRICE.split('|')[0]);
          _this2.prodData = dataRes;
          _this2.subtotal = parseInt(dataRes.PRICE);
          _this2.subtotalqty = parseInt(dataRes.PRICE);
          _this2.prodImg = imgs;
          _this2.prodGroup = group;
          _this2.priceIfQtyEQ2 = priceQtyEQ2;
          _this2.priceIfQtyEQGT3 = priceQtyEQgt3;
          if (_this2.prodData.SIZE === '') {
            _this2.prodData.EXT = '0';
          } else {
            _this2.prodData.EXT = _this2.prodData.SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '');
          }
          _this2.prodData.LOAD = true;
          _this2.showBreadCrumb();
          _this2.insideLoading = false;
        } else {
          _this2.showBreadCrumb();
          _this2.loading = false;
          console.log('Error in displayProductInfo()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    updateprice: function updateprice() {
      if (this.needhelp.length === 1) {
        if (this.subtotalqty > 1) {
          this.subtotal = this.subtotalqty + this.needhelpamount;
        } else {
          this.subtotal = parseInt(this.subtotal) + this.needhelpamount;
        }
      }
      if (this.needhelp.length === 0) {
        this.quantityChanged(this.prodData.PRICE);
      }
    },
    quantityChanged: function quantityChanged(originalPrice) {
      if (this.prodGroup === '2000' || this.prodGroup === '2100' || this.prodGroup === '2200' || this.prodGroup === '2300' || this.prodGroup === '10001' || this.prodGroup === '10002' || this.prodGroup === '10003' || this.prodGroup === '10004' || this.prodGroup === '10005') {
        var qty = parseInt(this.qty);
        var price = 0;
        if (!isNaN(qty) && qty >= 1) {
          if (qty === 1) {
            price = parseInt(originalPrice);
          } else if (qty === 2) {
            price = parseInt(this.priceIfQtyEQ2) * parseInt(this.qty);
          } else if (qty === 3) {
            price = parseInt(this.priceIfQtyEQGT3) * parseInt(this.qty);
          } else {
            price = parseInt(this.priceIfQtyEQGT3) * parseInt(this.qty);
          }
        } else {
          price = parseInt(originalPrice);
        }

        this.subtotalqty = price;
        this.subtotal = this.subtotalqty;
        this.updateprice();
      }
    },
    handleFileUploadpdf: function handleFileUploadpdf(file) {
      this.uploadedpdf = file;
      console.log('sdsd', this.uploadedpdf);
    },
    setHeightCarousel: function setHeightCarousel() {
      var _this3 = this;

      this.insideLoading = true;
      document.querySelector('.el-carousel').classList.add('hide');
      setTimeout(function () {
        document.querySelector('.el-carousel').classList.remove('hide');
        var img = document.querySelector('.el-carousel__item.is-active .prod-img').clientHeight;
        document.querySelector('.el-carousel__container').style.height = img + 'px';
        _this3.insideLoading = false;
      }, 1000);
    },
    ImageFound: function ImageFound(index, length) {
      if (length - 1 === index) {
        this.setHeightCarousel();
      }
    },
    setImage: function setImage(imgID, filePath, index) {
      var img = document.querySelector('.imgId-' + imgID);
      img.src = 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + filePath + '.php?id=' + this.haaId;
    },
    updatecart: function updatecart() {
      if (this.needhelp && this.needhelp.length !== 0) {
        this.addProductneedhelp(this.prodData.NAME, this.needhelpamount, this.prodData.CATEGORY_ID, this.prodData.PRODUCT_GROUP, 'https://newcrm.kundematch.dk' + this.prodData.get_product_image[0].showURL);
      } else {
        this.$router.push('/webshop/cart');
        this.$toastr('success', 'Tilføjet');
        this.loading = true;
      }
    },
    addCart: function addCart() {
      var _this4 = this;

      var compId = this.haaId;
      var prodId = this.prodId;

      var qty = parseInt(this.qty);
      var prodGroup = this.prodGroup;
      if (qty > 0) {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/AddToCart/0',
          parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            CompanyID: compId,
            ProductID: prodId,
            Quantity: qty,
            ProductGroup: prodGroup
          })
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            if (_this4.needhelp && _this4.needhelp.length !== 0) {
              _this4.addProductneedhelp(_this4.prodData.NAME, _this4.needhelpamount, _this4.prodData.CATEGORY_ID, _this4.prodData.PRODUCT_GROUP, 'https://newcrm.kundematch.dk' + _this4.prodData.get_product_image[0].showURL);
            } else {
              _this4.$router.push('/webshop/cart');
              _this4.$toastr('success', 'Tilføjet');
              _this4.loading = true;
            }
          } else {
            _this4.$toastr('error', 'Fejl');
            console.log('Error in addCart()');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
        this.loading = true;
      } else {
        this.$toastr('error', 'Mængden skal være større end nul');
      }
    },
    getallproductbycat: function getallproductbycat(id) {
      var _this5 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/webshop/GetProducts/0/0/' + id, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data;
          _this5.totalProdCount = dataRes.length;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    addProductneedhelp: function addProductneedhelp(productname, productprice, categoryid, prodgroup, prodimg) {
      var _this6 = this;

      var name = productname;
      var index = categoryid;
      var price = productprice;
      var productgroup = prodgroup;
      var productimage = prodimg;
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddProduct',
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          product_name: name + ' - Brugforhjælp - ' + (parseInt(this.totalProdCount) + 1),
          product_price: price,
          supplier_id: this.haaId,
          badge_id: ' ',
          image_url: productimage,
          product_group: productgroup,
          category_id: index,
          description: 'Dette viser, at denne virksomhed har brug for hjælp til hans/hendes grafik til dette specifikke produkt',
          pdf_graphic_need: 'Yes',
          pdf_unit_price: price,
          pdf_url: ' '
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var data = {
            operation: 'bitrixApi',
            salesPerson: _this6.salesPerson,
            type: 'POST',
            url: 'webshop/AddToCart/0',
            parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
              CompanyID: _this6.haaId,
              ProductID: res.data.result,
              Quantity: 1,
              ProductGroup: productgroup
            })
          };
          _this6.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res.success) {
              _this6.$router.push('/webshop/cart');
              _this6.$toastr('success', 'Tilføjet');
              _this6.loading = true;
            } else {
              _this6.$toastr('error', 'Fejl');
              console.log('Error in addCart()');
            }
          }, function (response) {
            console.log('Error: ', response);
          });
        } else {
          console.log('Error in addProduct()', response);
        }
      }, function (response) {
        console.log('Error in addProduct()', response);
      });
    }
  }
});

/***/ }),
/* 1382 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Traadhegns_vue__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6905334_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Traadhegns_vue__ = __webpack_require__(1386);
function injectStyle (ssrContext) {
  __webpack_require__(1384)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Traadhegns_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e6905334_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Traadhegns_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1384 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1385 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rate_it__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dynaimage',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      show: false,
      companyName: '',
      companyTelephone: '',
      companyCvr: '',
      companyRating: '',
      haaId: '',
      salesPerson: '',
      productbannerimageurl: 'static/img/products/trahedens.png?id=' + localStorage.getItem('haaid')
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = false;
    }
    this.companyRating = 4.99;
    this.companyCvr = localStorage.getItem('Cvrnr');
    this.companyName = unescape(localStorage.getItem('CompanyName').replace('&#039;', '\''));
    console.log(localStorage.getItem('CompanyName'));
    this.companyTelephone = localStorage.getItem('PartnerTelefon');
    this.haaId = localStorage.getItem('haaId');
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
  },
  mounted: function mounted() {
    try {} catch (e) {}
  },

  methods: {}
});

/***/ }),
/* 1386 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel__item is_animating prod-img relative",style:({ backgroundImage: 'url(' + _vm.productbannerimageurl + ')' }),attrs:{"id":"dynaimage"}},[_c('div',{staticClass:"flex flex-column items-center line-height-2 mt4 pt4 absolute left-0 right-0 bottom-0",staticStyle:{"bottom":"25%"}},[_c('h2',{staticClass:"white break-word  mt4 h4"},[_vm._v("Her arbejder")]),_vm._v(" "),_c('p',{staticClass:"white h2 semi-bold mt1"},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" "),_c('p',{staticClass:"white h2 semi-bold mt1"},[_c('i',{staticClass:"el-icon-phone"}),_vm._v(_vm._s(_vm.companyTelephone))]),_vm._v(" "),_c('p',{staticClass:"white h5 regular mt1"},[_vm._v(" Kunderne anbefaler os på Håndværker.dk ")]),_vm._v(" "),_c('div',{staticClass:"mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":35,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.companyRating),callback:function ($$v) {_vm.companyRating=$$v},expression:"companyRating"}})],1)]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v(_vm._s())])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1387 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rullestillads_vue__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1671fd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Rullestillads_vue__ = __webpack_require__(1390);
function injectStyle (ssrContext) {
  __webpack_require__(1388)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Rullestillads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6a1671fd_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Rullestillads_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1388 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rate_it__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dynaimage',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      show: false,
      companyName: '',
      companyTelephone: '',
      companyCvr: '',
      companyRating: '',
      haaId: '',
      salesPerson: '',
      productbannerimageurl: 'static/img/products/Rullestillads.png?id=' + localStorage.getItem('haaid')
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = false;
    }
    this.companyRating = 4.99;
    this.companyCvr = localStorage.getItem('Cvrnr');
    this.companyName = unescape(localStorage.getItem('CompanyName').replace('&#039;', '\''));
    console.log(localStorage.getItem('CompanyName'));
    this.companyTelephone = localStorage.getItem('PartnerTelefon');
    this.haaId = localStorage.getItem('haaId');
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
  },
  mounted: function mounted() {
    try {} catch (e) {}
  },

  methods: {}
});

/***/ }),
/* 1390 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel__item is_animating prod-img",style:({ backgroundImage: 'url(' + _vm.productbannerimageurl + ')' }),attrs:{"id":"dynaimage"}},[_c('div',{staticClass:"flex flex-column items-center line-height-1 mt4 pt3 rotate ml3 "},[_c('h2',{staticClass:"white break-word mt3 pt1",staticStyle:{"font-size":".8em","margin-top":"2.5em"}},[_vm._v("Her arbejder")]),_vm._v(" "),_c('p',{staticClass:"white h6 semi-bold"},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" "),_c('p',{staticClass:"white h6 semi-bold m0"},[_c('i',{staticClass:"el-icon-phone"}),_vm._v(_vm._s(_vm.companyTelephone))]),_vm._v(" "),_c('p',{staticClass:"white regular mt1 m0",staticStyle:{"font-size":".7em"}},[_vm._v(" Kunderne anbefaler os på Håndværker.dk ")]),_vm._v(" "),_c('div',{staticClass:"mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":20,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.companyRating),callback:function ($$v) {_vm.companyRating=$$v},expression:"companyRating"}})],1)]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v(_vm._s())])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facadestillads_vue__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4f8a02_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Facadestillads_vue__ = __webpack_require__(1394);
function injectStyle (ssrContext) {
  __webpack_require__(1392)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Facadestillads_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f4f8a02_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Facadestillads_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1392 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1393 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rate_it__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dynaimage',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      show: false,
      companyName: '',
      companyTelephone: '',
      companyCvr: '',
      companyRating: '',
      haaId: '',
      salesPerson: '',
      productbannerimageurl: 'static/img/products/Facadestillads.png?id=' + localStorage.getItem('haaid')
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = false;
    }
    this.companyRating = 4.99;
    this.companyCvr = localStorage.getItem('Cvrnr');
    this.companyName = unescape(localStorage.getItem('CompanyName').replace('&#039;', '\''));
    console.log(localStorage.getItem('CompanyName'));
    this.companyTelephone = localStorage.getItem('PartnerTelefon');
    this.haaId = localStorage.getItem('haaId');
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
  },
  mounted: function mounted() {
    try {} catch (e) {}
  },

  methods: {}
});

/***/ }),
/* 1394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel__item is_animating prod-img ",style:({ backgroundImage: 'url(' + _vm.productbannerimageurl + ')' }),attrs:{"id":"dynaimage"}},[_c('div',{staticClass:"flex flex-column items-center line-height-1 rotate mt2 pt3",staticStyle:{"padding-left":".6em"}},[_c('h2',{staticClass:"white break-word  mt1 h6",staticStyle:{"font-size":".7em"}},[_vm._v("Her arbejder")]),_vm._v(" "),_c('p',{staticClass:"white h6 semi-bold"},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" "),_c('p',{staticClass:"white h6 semi-bold m0"},[_c('i',{staticClass:"el-icon-phone"}),_vm._v(_vm._s(_vm.companyTelephone))]),_vm._v(" "),_c('p',{staticClass:"white regular mt1 m0",staticStyle:{"font-size":".6em"}},[_vm._v(" Kunderne anbefaler os på Håndværker.dk ")]),_vm._v(" "),_c('div',{staticClass:"mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":22,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.companyRating),callback:function ($$v) {_vm.companyRating=$$v},expression:"companyRating"}})],1)]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v(_vm._s())])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Byggepladshegn_vue__ = __webpack_require__(1397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6fe027_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Byggepladshegn_vue__ = __webpack_require__(1398);
function injectStyle (ssrContext) {
  __webpack_require__(1396)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Byggepladshegn_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f6fe027_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Byggepladshegn_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1396 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_star_rating__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_rate_it__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'dynaimage',
  components: {
    StarRating: __WEBPACK_IMPORTED_MODULE_0_vue_star_rating___default.a,
    ImageRating: __WEBPACK_IMPORTED_MODULE_1_vue_rate_it__["ImageRating"]
  },
  data: function data() {
    return {
      show: false,
      companyName: '',
      companyTelephone: '',
      companyCvr: '',
      companyRating: '',
      haaId: '',
      salesPerson: '',
      productbannerimageurl: 'static/img/products/Byggepladshegn.png?id=' + localStorage.getItem('haaid')
    };
  },
  created: function created() {
    if (localStorage.getItem('haaid') === '0') {
      this.show = false;
    }
    this.companyRating = 4.99;
    this.companyCvr = localStorage.getItem('Cvrnr');
    this.companyName = unescape(localStorage.getItem('CompanyName').replace('&#039;', '\''));
    console.log(localStorage.getItem('CompanyName'));
    this.companyTelephone = localStorage.getItem('PartnerTelefon');
    this.haaId = localStorage.getItem('haaId');
    this.salesPerson = localStorage.getItem('id_token_portalbitrix');
  },
  mounted: function mounted() {
    try {} catch (e) {}
  },

  methods: {}
});

/***/ }),
/* 1398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"el-carousel__item is_animating prod-img relative",style:({ backgroundImage: 'url(' + _vm.productbannerimageurl + ')' }),attrs:{"id":"dynaimage"}},[_c('div',{staticClass:"flex flex-column items-center line-height-2 mt4 pt4 absolute left-0 right-0 bottom-0",staticStyle:{"bottom":"25%"}},[_c('h2',{staticClass:"white break-word  mt4 h4"},[_vm._v("Her arbejder")]),_vm._v(" "),_c('p',{staticClass:"white h2 semi-bold mt1"},[_vm._v(_vm._s(_vm.companyName))]),_vm._v(" "),_c('p',{staticClass:"white h2 semi-bold mt1"},[_c('i',{staticClass:"el-icon-phone"}),_vm._v(_vm._s(_vm.companyTelephone))]),_vm._v(" "),_c('p',{staticClass:"white h5 regular mt1"},[_vm._v(" Kunderne anbefaler os på Håndværker.dk ")]),_vm._v(" "),_c('div',{staticClass:"mt1"},[_c('image-rating',{attrs:{"src":"/static/svg/single-house.svg","max-rating":5,"increment":0.5,"item-size":33,"spacing":1,"show-rating":false,"read-only":true},model:{value:(_vm.companyRating),callback:function ($$v) {_vm.companyRating=$$v},expression:"companyRating"}})],1)]),_vm._v(" "),_c('div',{},[_c('p',[_vm._v(_vm._s())])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"product"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"pt4 px3"},[_c('div',{staticClass:"lg-col-6 mr3 p0 pt2"},[_c('span',{staticClass:"h4 darkblue bold"},[_vm._v(_vm._s(_vm.prodData.NAME))])]),_vm._v(" "),_c('div',{staticClass:"lg-flex"},[_c('div',{staticClass:"lg-col-6 mr3 p0"},[_c('div',{},[(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('el-carousel',{staticClass:"hide",attrs:{"autoplay":false,"loop":false,"arrow":"always","indicator-position":"none","height":"600px"},on:{"change":function($event){return _vm.setHeightCarousel()}}},[_vm._l((_vm.prodImg),function(img,index){return (_vm.prodData.CATEGORY_ID !== 205)?_c('el-carousel-item',{key:index},[_c('div',{staticClass:"flex justify-center white-background"},[(_vm.prodGroup == '1000' || _vm.prodGroup == '1300' || _vm.prodGroup == '1400' || _vm.prodGroup == '2000' || _vm.prodGroup == '2100' || _vm.prodGroup == '2200' || _vm.prodGroup == '2300' || _vm.prodGroup == '2400' || _vm.prodGroup == '2500' || _vm.prodGroup === '10001' || _vm.prodGroup === '10002' || _vm.prodGroup == '10003' || _vm.prodGroup == '10004' || _vm.prodGroup == '10005' )?_c('img',{class:'prod-img catId-'+_vm.prodData.CATEGORY_ID,attrs:{"data-key":index,"src":typeof 'http://widget.haandvaerker.dk/products/'+_vm.prodGroup+'/'+_vm.prodData.EXT+'/rendered/'+_vm.haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+_vm.prodGroup+'/'+_vm.prodData.EXT+'/rendered/'+_vm.haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+_vm.prodGroup+'/'+_vm.prodData.EXT+'/rendered/'+_vm.haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+_vm.prodGroup+'/'+_vm.prodData.EXT+'/productPng.php?id='+_vm.haaId,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.ImageFound(index, _vm.prodImg.length)}}}):_c('img',{staticClass:"prod-img",attrs:{"id":"imagefcrm","src":'https://newcrm.kundematch.dk'+_vm.prodImg[index].showURL,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.ImageFound(index, _vm.prodImg.length)}}})])]):_c('el-carousel-item',[_c('div',{staticClass:"flex justify-center white-background"},_vm._l((_vm.prodData.get_element_property),function(prodImage){return (prodImage.IBLOCK_PROPERTY_ID == 429)?_c('img',{class:'prod-img imgId-0',attrs:{"data-key":0,"src":prodImage.VALUE,"width":"50%","rel":"preload"},on:{"load":function($event){return _vm.ImageFound(0, 2)},"error":function($event){return _vm.setImage(0, 'streamer/streamerPng', 0)}}}):_vm._e()}),0)])}),_vm._v(" "),(_vm.prodData.CATEGORY_ID === 205)?_c('el-carousel-item',[_c('div',{staticClass:"flex justify-center white-background"},_vm._l((_vm.prodData.get_element_property),function(prodImage){return (prodImage.IBLOCK_PROPERTY_ID == 429)?_c('img',{class:'prod-img imgId-1',attrs:{"data-key":1,"src":prodImage.VALUE.replace('streamer', 'bladder'),"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.ImageFound(1, 2)},"error":function($event){return _vm.setImage(1, 'bladder/bladderPng', 1)}}}):_vm._e()}),0)]):_vm._e()],2)],1),_vm._v(" "),_c('div',{staticClass:"pb3"})]),_vm._v(" "),_c('div',{staticClass:"lg-col-5 mx-auto"},[_c('b-form',{attrs:{"model":_vm.ruleForm}},[(_vm.dontshowproduct)?_c('div',{staticClass:"flex col-12 my2 p0"},[_c('span',{staticClass:"h5 bold ml-auto flex items-center col-6 p0 "},[_vm._v("Antal:")]),_vm._v(" "),_c('b-form-input',{staticClass:"qty col-6 mr-auto",attrs:{"type":"number","min":"1","value":"1"},on:{"keyup":function($event){return _vm.quantityChanged(_vm.prodData.PRICE)},"change":function($event){return _vm.quantityChanged(_vm.prodData.PRICE)}},model:{value:(_vm.qty),callback:function ($$v) {_vm.qty=$$v},expression:"qty"}})],1):_c('div',{staticClass:"flex mt3 col-12 p0"},[_c('p',{staticClass:"col-12 h5 mr-auto mr2 m0 p0 "},[_vm._v("Du har allerede dette produkt i din indkøbskurv")])]),_vm._v(" "),(_vm.dontshowneedhelp)?_c('div',{staticClass:"flex mt3 col-12 p0"},[_c('span',{staticClass:"h5 bold col-6 ml-auto p0 m0"},[_vm._v("Brug for grafisk hjælp?")]),_vm._v(" "),_c('b-form-group',{staticClass:"col-6 mr-auto p0",attrs:{"value":_vm.needhelp},on:{"update:value":function($event){_vm.needhelp=$event}},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var ariaDescribedby = ref.ariaDescribedby;
return [_c('b-form-checkbox-group',[_c('b-form-checkbox',{staticClass:"line-height-2 mb2",attrs:{"aria-describedby":ariaDescribedby,"name":"sortByDate"},on:{"change":function($event){return _vm.updateprice()}},model:{value:(_vm.needhelp),callback:function ($$v) {_vm.needhelp=$$v},expression:"needhelp"}})],1)]}}],null,false,3194602371)})],1):_c('div',{staticClass:"flex mt3 col-12 p0 "},[_c('p',{staticClass:"col-12 h5 mr-auto mr2 m0 p0"},[_vm._v("Du har allerede brug for hjælp grafik til dette produkt i din indkøbskurv")])]),_vm._v(" "),(_vm.dontshowproduct)?_c('div',{staticClass:"flex col-12 my3  p0 "},[_c('span',{staticClass:"col-6 h5 bold ml-auto p0"},[_vm._v("Pris:")]),_vm._v(" "),_c('span',{staticClass:"flex col-6 h4 bold mr-auto items-center m0 p0",attrs:{"id":"price"}},[_vm._v(_vm._s(_vm.subtotal.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))),_c('p',{staticClass:"ml1 bold m0"},[_vm._v(" kr")])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',[(_vm.dontshowproduct)?_c('b-button',{staticClass:"action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular",attrs:{"type":"button"},on:{"click":function($event){return _vm.addCart()}}},[_vm._v("TILFØJ TIL KURVEN "),_c('i',{staticClass:"el-icon-right"})]):_c('b-button',{staticClass:"action-button py2 px3 m0 line-height-1 gibson not-rounded border-none regular",attrs:{"type":"button"},on:{"click":function($event){return _vm.updatecart()}}},[_vm._v("OPDATER INDKØBSVOGN"),_c('i',{staticClass:"el-icon-right"})])],1)]),_vm._v(" "),_c('h6',{staticClass:"bold mt3"},[_vm._v("Beskrivelse:")]),_vm._v(" "),_c('p',{staticClass:"gibson",attrs:{"id":"proddesc"},domProps:{"innerHTML":_vm._s(_vm.prodData.DESCRIPTION)}})],1)])]),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 center"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold"},[_vm._v("Genererer forhåndsvisning...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__ = __webpack_require__(1402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb68e444_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__ = __webpack_require__(1403);
function injectStyle (ssrContext) {
  __webpack_require__(1401)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_cart_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_eb68e444_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_cart_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1401 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(106);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      cartData: [],
      deliveryFee: 0,
      currency: 'kr',
      totalAmount: 0,
      cartMsg: 'Ingen Varer I Din Kurv.',
      curPage: 1,
      lastPage: 10
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.getDeliveryFee();
  },

  methods: {
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    displayCart: function displayCart() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (typeof res !== 'undefined' && res !== null && res.success) {
          var dataRes = response.data.data.data[0].webshop_cart_products;
          _this.cartData = dataRes.reverse();

          var pagLastPage = response.data.data.last_page + '0';
          var price = 0;
          var qty = 0;
          var total = 0;
          _this.cartData.forEach(function (element) {
            if (element['get_product_image'].length === 0) {
              var defaultprod = {
                'ID': 8903,
                'IBLOCK_PROPERTY_ID': 98,
                'IBLOCK_ELEMENT_ID': 11682,
                'VALUE': '3502',
                'TIMESTAMP_X': '2022-01-26 13:16:00',
                'CONTENT_TYPE': 'image/jpeg',
                'HEIGHT': 788,
                'WIDTH': 732,
                'FILE_SIZE': 47521,
                'FILE_NAME': '40035 4.jpg',
                'ORIGINAL_NAME': '40035 4.jpg',
                'SUBDIR': 'iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx',
                'showURL': '/upload/iblock/e64/fofm5650a15jentoqk6xeuzxyucar8mx/40035 4.jpg'
              };
              element['get_product_image'].push(defaultprod);
            }
          });
          for (var i = 0; i < dataRes.length; i++) {
            price = dataRes[i].PRICE;
            qty = dataRes[i].QUANTITY;
            total += price * qty;
          }

          _this.totalAmount = total + parseInt(_this.deliveryFee);
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(_this.totalAmount)) {
            _this.totalAmount = _this.totalAmount + '.00';
          }
          _this.lastPage = pagLastPage;
          if (!dataRes.length) {
            _this.cartMsg = 'Ingen Varer I Din Kurv.';
          } else {
            _this.cartMsg = '';
          }
          _this.showBreadCrumb();
          _this.loading = false;
        } else {
          _this.showBreadCrumb();
          _this.loading = false;
          console.log('Error in displayCart()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getDeliveryFee: function getDeliveryFee() {
      var _this2 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWebshopDeliveryChargeDynamic/9001' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.deliveryFee = res.data.PRICE;
          _this2.displayCart();
        } else {
          console.log('Error in getDeliveryFee()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    updateQuantity: function updateQuantity(id) {
      var _this3 = this;

      var qty = document.getElementById(id).value;
      if (!isNaN(qty) && qty >= 1) {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/ModifyCart/0/' + this.haaId + '/' + id + '/' + qty
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            _this3.displayCart();
            _this3.calulateCartCount();
            _this3.$toastr('success', 'Opdateret');
          } else {
            console.log('Error in updateQuantity()');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
      }
    },
    checkQuantity: function checkQuantity() {
      var input = document.querySelectorAll('input.qty');
      var redirect = true;
      for (var i = 0; i < input.length; i++) {
        var qty = parseInt(input[i].value);
        if (qty <= 0 || isNaN(qty)) {
          redirect = false;
        }
      }
      if (redirect) {
        this.$router.push('/webshop/checkout');
      } else {
        this.$toastr('error', 'Mængden skal være større end nul');
      }
    },
    confirmDelete: function confirmDelete(id) {
      this.deleteCart(id);
    },
    deleteCart: function deleteCart(id) {
      var _this4 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/ModifyCart/-1/' + this.haaId + '/' + id + '/0'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.displayCart();
          _this4.calulateCartCount();
          _this4.$toastr('success', 'Fjernet');
        } else {
          console.log('Error in deleteCart()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    calulateCartCount: function calulateCartCount() {
      setTimeout(function () {
        var qty = document.querySelectorAll('input.qty');
        var totalQty = 0;
        for (var i = 0; i < qty.length; i++) {
          totalQty += parseInt(qty[i].value);
        }
        document.querySelector('.totalCart').innerText = totalQty;
      }, 1000);
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayCart();
      this.insideLoading = true;
    }
  }
});

/***/ }),
/* 1403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cart animated fadeIn pb4",attrs:{"id":"products"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.cartMsg == '')?_c('div',{staticClass:"el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"},[_c('div',[_c('table',{staticClass:"el-table__body col-12 p0"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.cartData),function(cart,index){return _c('tr',{key:index,staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1"},[_c('a',{staticClass:"mintgreen flex items-center",attrs:{"href":'#/webshop/product?id='+cart.PRODUCT_ID}},[(cart.PRODUCT_GROUP != '9001' && cart.NEED_GRAPHIC_HELP !== 'Yes')?_c('img',{staticClass:"mr1",attrs:{"src":'https://newcrm.kundematch.dk' + cart.get_product_image[0].showURL,"width":"20%"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"mr1",attrs:{"src":cart.IMAGE_URL,"width":"20%"}}),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(cart.PRODUCT_NAME))])])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 qty"},[(cart.NEED_GRAPHIC_HELP === 'Yes')?_c('b-form-input',{staticClass:"qty",staticStyle:{"text-align":"right"},attrs:{"id":cart.PRODUCT_ID.toString(),"type":"number","min":"1","value":parseInt(cart.QUANTITY),"disabled":""},on:{"keyup":function($event){return _vm.updateQuantity(cart.PRODUCT_ID)},"change":function($event){return _vm.updateQuantity(cart.PRODUCT_ID)}}}):_c('b-form-input',{staticClass:"qty",staticStyle:{"text-align":"right"},attrs:{"id":cart.PRODUCT_ID.toString(),"type":"number","min":"1","value":parseInt(cart.QUANTITY)},on:{"keyup":function($event){return _vm.updateQuantity(cart.PRODUCT_ID)},"change":function($event){return _vm.updateQuantity(cart.PRODUCT_ID)}}})],1),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price"},[_c('span',[_vm._v(_vm._s((parseFloat(cart.PRICE)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price"},[_c('span',[_vm._v(_vm._s((parseFloat(cart.PRICE * cart.QUANTITY)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))]),_c('a',{staticClass:"pointer absolute right-0 mr2",attrs:{"title":"Remove"},on:{"click":function($event){return _vm.confirmDelete(cart.PRODUCT_ID)}}},[_c('i',{staticClass:"el-icon-error h5 red"})])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.cartMsg))])])]),_vm._v(" "),(_vm.cartMsg == '')?_c('div',{staticClass:"lg-flex pt2"},[_c('div',{staticClass:"block col-12 right-align p0"},[_c('table',{staticClass:"total-amount inline-block mb1"},[_c('tr',{staticClass:"h6 bold"},[_c('td',[_vm._v("Levering:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s((parseFloat(_vm.deliveryFee)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])]),_vm._v(" "),_c('tr',{staticClass:"h6 bold"},[_c('td',[_vm._v("Total:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s((parseFloat(_vm.totalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])])]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',[_c('a',{staticClass:"btn white action-button py2 px3 m0 gibson not-rounded border-none regular btn-secondary",on:{"click":function($event){return _vm.checkQuantity()}}},[_vm._v("AFSLUT OG BETAL "),_c('i',{staticClass:"el-icon-right"})])])])]):_vm._e()])]),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Produkt")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Antal")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Pris")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Sum")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__ = __webpack_require__(1406);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d365a04_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__ = __webpack_require__(1407);
function injectStyle (ssrContext) {
  __webpack_require__(1405)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checkout_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5d365a04_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checkout_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1405 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__footer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_axios__);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_2__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_3__footer__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      cartData: [],
      deliveryFee: 0,
      couponId: 0,
      curOrPerc: 'kr',
      couponUnit: '',
      couponUnitMsg: '',
      couponValue: 0,
      changecredit: false,
      credit: '',
      disableCheckCoupon: false,
      currency: 'kr',
      subTotalAmount: 0,
      discount: 0,
      totalAmount: 0,
      cartMsg: 'Ingen Varer I Din Kurv.',
      curPage: 1,
      lastPage: 10,
      showCreditSuccess: false,
      showCreditFailed: false
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.getDeliveryFee();
  },
  mounted: function mounted() {
    var creditTemp = localStorage.getItem('changecredit');
    var creditResult = this.getUrlParameter('credit');
    if (typeof creditTemp !== 'undefined' && creditTemp !== null) {
      this.changecredit = creditTemp;
    }
    if (typeof creditResult !== 'undefined' && creditResult !== null) {
      this.credit = creditResult;
    }
    if (this.changecredit && this.credit === 'change') {
      this.showCreditSuccess = true;
    } else if (this.changecredit && this.credit === 'failed') {
      this.showCreditFailed = true;
    }
  },

  methods: {
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    displayCart: function displayCart() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetCart/' + this.haaId + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        console.log(res);
        if (res.success) {
          var dataRes = response.data.data.data[0].webshop_cart_products;
          _this.cartData = dataRes;

          var pagLastPage = response.data.data.last_page + '0';
          var price = 0;
          var qty = 0;
          var discount = 0;
          var total = 0;
          for (var i = 0; i < dataRes.length; i++) {
            price = dataRes[i].PRICE;
            qty = dataRes[i].QUANTITY;
            total += price * qty;
          }
          if (_this.couponUnit === 'CurEach') {
            discount = _this.couponValue * dataRes.length;
          } else if (_this.couponUnit === 'Perc') {
            var coupVal = '0.' + _this.couponValue;
            discount = total * coupVal;
          } else if (_this.couponUnit === 'CurAll') {
            discount = _this.couponValue;
          }
          total = total - discount;

          if (_this.subTotalAmount === 0) {
            if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(_this.subTotalAmount)) {
              if (total % 1 !== 0) {
                _this.subTotalAmount = total + '0';
              } else {
                _this.subTotalAmount = total + '.00';
              }
            } else {
              _this.subTotalAmount = total;
            }
          }
          _this.discount = parseInt(discount);
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_integer___default()(_this.discount)) {
            _this.discount = _this.discount + '.00';
          }
          _this.totalAmount = total + parseInt(_this.deliveryFee);
          if (_this.totalAmount % 1 !== 0) {
            _this.totalAmount = _this.totalAmount + '0';
          } else {
            _this.totalAmount = _this.totalAmount + '.00';
          }
          _this.lastPage = pagLastPage;
          if (!dataRes.length) {
            _this.cartMsg = 'Ingen Varer I Din Kurv.';
          } else {
            _this.cartMsg = '';
          }
          _this.showBreadCrumb();
          _this.loading = false;
        } else {
          _this.showBreadCrumb();
          _this.loading = false;
          console.log('Error in displayCart()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getDeliveryFee: function getDeliveryFee() {
      var _this2 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWebshopDeliveryChargeDynamic/9001' };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.deliveryFee = res.data.PRICE;
          _this2.displayCart();
        } else {
          console.log('Error in getDeliveryFee()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    checkCoupon: function checkCoupon() {
      var _this3 = this;

      var coupon = document.getElementById('coupon').value;
      if (coupon !== '') {
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'GET',
          url: 'webshop/CheckCoupon/' + coupon
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res !== '' && res !== null) {
            _this3.couponId = res.ID;
            _this3.couponValue = res.value;
            if (res.success) {
              if (res.unit === 'Perc') {
                _this3.curOrPerc = '%';
                _this3.couponUnit = res.unit;
                _this3.couponUnitMsg = 'af det samlede beløb';
              } else if (res.unit === 'CurEach') {
                _this3.curOrPerc = _this3.currency;
                _this3.couponUnit = res.unit;
                _this3.couponUnitMsg = 'af hver vare';
              } else if (res.unit === 'CurAll') {
                _this3.curOrPerc = _this3.currency;
                _this3.couponUnit = res.unit;
                _this3.couponUnitMsg = 'af det samlede beløb';
              }
              _this3.displayCart();
              _this3.disableCheckCoupon = false;
              _this3.$toastr('success', 'Kuponen er aktiv');
            } else {
              if (res.unit === '') {
                _this3.curOrPerc = _this3.currency;
                _this3.couponUnit = res.unit;
                _this3.couponUnitMsg = '';
              }
              _this3.displayCart();
              _this3.disableCheckCoupon = false;
              _this3.$toastr('error', 'Kupon findes ikke');
            }
          } else {
            _this3.displayCart();
            _this3.disableCheckCoupon = false;
            _this3.$toastr('error', 'Kupon findes ikke');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
        this.disableCheckCoupon = true;
      } else {
        this.couponId = 0;
        this.curOrPerc = this.currency;
        this.couponUnit = '';
        this.couponUnitMsg = '';
        this.couponValue = 0;
        this.displayCart();
        this.$toastr('error', 'Indtast din kupon');
      }
    },
    getUrlParameter: function getUrlParameter(param) {
      var pageUrl = window.location.search.substring(1);
      var urlVar = pageUrl.split('&');
      var parameterName;
      var i;
      for (i = 0; i < urlVar.length; i++) {
        parameterName = urlVar[i].split('=');
        if (parameterName[0] === param) {
          return parameterName[1] === undefined ? true : decodeURIComponent(parameterName[1]);
        }
      }
    },
    changeCredit: function changeCredit() {
      var _this4 = this;

      var data = {
        salesPerson: this.salesPerson,
        operation: 'confirm_change_credit',
        type: 'POST'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response;
        var resData = response.data;
        if (res.status === 200) {
          _this4.changecredit = resData.changecredit;
          localStorage.setItem('changecredit', resData.changecredit);
          setTimeout(function () {
            window.location.href = 'https://www.kundematch.dk/newpartner/kredit.php?id=' + _this4.salesPerson + '&mode=shop';
          }, 500);
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    placeOrder: function placeOrder() {
      var _this5 = this;

      var termsAndConditions = document.querySelector('.terms');
      if (termsAndConditions.checked === true) {
        if (this.credit === '') {
          this.changeCredit();
        }
        if (this.changecredit && this.credit === 'failed') {
          return;
        }
        var coupId = this.couponId;
        var data = {
          operation: 'bitrixApi',
          salesPerson: this.salesPerson,
          type: 'POST',
          url: 'webshop/PostOrder/' + this.haaId,
          createinvoice: true,
          parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            CouponID: coupId
          })
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {
            var orderId = res.InvoiceNumber;
            var generatedOrderId = _this5.haaId + '' + Date.now();
            var amount = _this5.totalAmount;
            __WEBPACK_IMPORTED_MODULE_4_axios___default()({
              method: 'POST',
              url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + orderId,
              createinvoice: true,
              orderid: generatedOrderId,
              price: amount,
              headers: {},
              data: {}
            }).then(function (response) {
              var res = response.data;
              if (res.success) {
                if (res.result.paid) {}
                sessionStorage.setItem('placeOrder', true);
                _this5.$router.push('/webshop/orders');
              } else {
                _this5.$toastr('error', 'Fejl');
              }
            }).catch(function (error) {
              console.log('Error: ', error);
            });
          } else {
            _this5.$toastr('error', 'Fejl');
            console.log('Error in placeOrder()');
          }
        }, function (response) {
          console.log('Error: ', response);
        });
        this.loading = true;
      } else {
        this.$toastr('error', 'Accepter venligst vilkårene og betingelserne');
      }
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayCart();
      this.insideLoading = true;
    },
    clickAgreeText: function clickAgreeText() {
      var termsAndConditions = document.querySelector('.terms');
      if (termsAndConditions.checked === true) {
        termsAndConditions.checked = false;
      } else {
        termsAndConditions.checked = true;
      }
    }
  }
});

/***/ }),
/* 1407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkout animated fadeIn pb4",attrs:{"id":"products"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"},[_c('b-alert',{attrs:{"variant":"success","dismissible":"","show":_vm.showCreditSuccess},on:{"dismissed":function($event){_vm.showCreditSuccess=false}}},[_c('p',{staticClass:"h6 mb0 line-height-4"},[_vm._v("Dine betalingskortoplysninger er nu registreret og gemt i vores system")])]),_vm._v(" "),_c('b-alert',{attrs:{"variant":"danger","dismissible":"","show":_vm.showCreditFailed},on:{"dismissed":function($event){_vm.showCreditFailed=false}}},[_c('p',{staticClass:"h6 mb0 line-height-4"},[_vm._v("Ikke gennemføres - kontakt venligst Håndværker.dk support på info@haandvaerker.dk")])])],1),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.cartMsg == '')?_c('div',{staticClass:"el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"},[_c('div',[_c('table',{staticClass:"el-table__body col-12 p0"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.cartData),function(cart,index){return _c('tr',{key:index,staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1"},[_c('a',{staticClass:"mintgreen flex items-center",attrs:{"href":'#/webshop/product?id='+cart.PRODUCT_ID}},[(cart.PRODUCT_GROUP != '9001' && cart.NEED_GRAPHIC_HELP !== 'Yes')?_c('img',{staticClass:"mr1",attrs:{"src":'https://newcrm.kundematch.dk' + cart.get_product_image[0].showURL,"width":"20%"}}):_vm._e(),_vm._v(" "),_c('img',{staticClass:"mr1",attrs:{"src":cart.IMAGE_URL,"width":"20%"}}),_vm._v(" "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(cart.PRODUCT_NAME))])])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 qty"},[_c('span',[_vm._v(_vm._s(parseInt(cart.QUANTITY)))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price"},[_c('span',[_vm._v(_vm._s((parseFloat(cart.PRICE)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price"},[_c('span',[_vm._v(_vm._s((parseFloat(cart.PRICE * cart.QUANTITY)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.cartMsg))])])]),_vm._v(" "),(_vm.cartMsg == '')?_c('div',{staticClass:"lg-flex pt2"},[_c('div',{staticClass:"block lg-col-6 mb3"},[_c('span',{staticClass:"h6 bold"},[_vm._v("Har du en kupon?")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"lg-flex"},[_c('b-form-input',{staticClass:"mr2",attrs:{"id":"coupon","placeholder":"Indtast din kupon her"}}),_vm._v(" "),_c('b-button',{staticClass:"py2 px3 m0 line-height-1 gibson not-rounded border-none regular blue-btn",attrs:{"type":"button","disabled":_vm.disableCheckCoupon},on:{"click":function($event){return _vm.checkCoupon()}}},[_vm._v("TJEK KUPON\n              ")])],1),_vm._v(" "),_c('div',{staticClass:"block"},[_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('span',{staticClass:"h6"},[_vm._v("Rabat: "),_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.couponValue + ' ' + _vm.curOrPerc))]),_vm._v(" "+_vm._s(_vm.couponUnitMsg))])])]),_vm._v(" "),_c('div',{staticClass:"block lg-col-6 right-align"},[_c('table',{staticClass:"total-amount inline-block mb1"},[_c('tr',{staticClass:"h6 bold mediumgrey"},[_c('td',[_vm._v("Sub Total:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"sub-total"},[_vm._v(_vm._s((parseFloat(_vm.subTotalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])]),_vm._v(" "),_c('tr',{staticClass:"h6 bold"},[_c('td',[_vm._v("Levering:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s((parseFloat(_vm.deliveryFee)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])]),_vm._v(" "),_c('tr',{staticClass:"h6 bold"},[_c('td',[_vm._v("Rabat:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s((parseFloat(_vm.discount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])]),_vm._v(" "),_c('tr',{staticClass:"h6 bold"},[_c('td',[_vm._v("Total:")]),_vm._v(" "),_c('td',[_c('span',{staticClass:"total"},[_vm._v(_vm._s((parseFloat(_vm.totalAmount)).toLocaleString("da", {style: "currency", currency: "DKK"}).replaceAll('.', ' ').replaceAll(',', '.')))])])])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"col-12 lg-col-8 flex p0 pl-1 mb2 ml-auto left-align"},[_vm._m(2),_vm._v(" "),_c('div',[_c('div',{staticClass:"mb2"},[_c('span',[_c('span',{on:{"click":function($event){return _vm.clickAgreeText()}}},[_vm._v("Jeg har læst og accepteret")]),_vm._v(" "),_c('a',{staticClass:"termsconditions",attrs:{"href":"#/webshop/terms-and-conditions","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("Vilkårene og Betingelserne")]),_vm._v(".")])]),_vm._v(" "),_vm._m(3)])])]),_vm._v(" "),_c('div',[_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular",attrs:{"type":"button"},on:{"click":function($event){return _vm.placeOrder()}}},[_vm._v("CHECKOUT\n              ")])],1)])]):_vm._e()])]),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Produkt")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Antal")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Pris")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Sum")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pr1"},[_c('input',{staticClass:"terms",staticStyle:{"width":"20px","height":"20px"},attrs:{"type":"checkbox"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb1"},[_c('span',[_vm._v("OBS:"),_c('br'),_vm._v("\n                    Det er ikke nødvendigt at indtaste betalingsoplysninger, da vi allerede har disse i forbindelse med betalingen af dit medlemskab hos Håndværker.dk")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orders_vue__ = __webpack_require__(1410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8d99a3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_orders_vue__ = __webpack_require__(1411);
function injectStyle (ssrContext) {
  __webpack_require__(1409)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_orders_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1d8d99a3_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_orders_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1409 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_1__footer__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      placeOrderData: [],
      orderMsg: 'Ingen Ordre.',
      curPage: 1,
      lastPage: 10
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.checkPlaceOrder();
    this.displayOrder();
  },

  methods: {
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    checkPlaceOrder: function checkPlaceOrder() {
      var _this = this;

      setTimeout(function () {
        var placeOrder = sessionStorage.getItem('placeOrder');
        if (placeOrder) {
          var obj = {
            title: 'Tak for din bestilling! Du kan se status på din ordre herunder.',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this.$refs.simplert.openSimplert(obj);
          sessionStorage.removeItem('placeOrder');
        }
      }, 1500);
    },
    displayOrder: function displayOrder() {
      var _this2 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/0?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data.data;
          var pagLastPage = response.data.data.last_page + '0';
          _this2.placeOrderData = dataRes;
          _this2.lastPage = pagLastPage;
          if (!dataRes.length) {
            _this2.orderMsg = 'Ingen Ordre.';
          } else {
            _this2.orderMsg = '';
          }
          _this2.showBreadCrumb();
          _this2.loading = false;
          _this2.insideLoading = false;
        } else {
          _this2.showBreadCrumb();
          _this2.loading = false;
          _this2.insideLoading = false;
          console.log('Error in displayOrder()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayOrder();
      this.insideLoading = true;
    }
  }
});

/***/ }),
/* 1411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"products"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.orderMsg == '')?_c('div',{staticClass:"el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"},[_c('div',{staticClass:"right-align"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',[_c('table',{staticClass:"el-table__body col-10 p0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.placeOrderData),function(order,index){return _c('tr',{key:index,staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1"},[_c('a',{staticClass:"mintgreen bold",attrs:{"href":'#/webshop/order?id='+order.ID}},[(order.STAGE_ID == 'EXECUTING')?_c('span',[_vm._v("Igang")]):_c('span',[_vm._v("Betalt")])])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1"},[_c('a',{staticClass:"mintgreen bold",attrs:{"href":'#/webshop/order?id='+order.ID}},[_c('span',[_vm._v(_vm._s(order.ID))])])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price",staticStyle:{"text-align":"right"}},[_c('a',{staticClass:"mintgreen bold",attrs:{"href":'#/webshop/order?id='+order.ID}},[_c('span',[_vm._v(_vm._s(order.DATE_UPDATE))])])]),_vm._v(" "),_c('td',{staticClass:" el-table_1_column_1 ",staticStyle:{"text-align":"right"}},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(order.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' kr'))])])])}),0)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.orderMsg))])])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Status")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Ordre nummer")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf ",staticStyle:{"text-align":"right"},attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Ordre dato")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",staticStyle:{"text-align":"right"},attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Ordre i alt")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__ = __webpack_require__(1414);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4861100_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__ = __webpack_require__(1415);
function injectStyle (ssrContext) {
  __webpack_require__(1413)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4861100_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_order_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1413 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(106);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      placeOrderData: [],
      discount: '',
      currency: 'kr',
      curPage: 1,
      lastPage: 10,
      orderowner: undefined
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayOrder();
  },

  methods: {
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    displayOrder: function displayOrder() {
      var _this = this;

      var urlStr = window.location.href;
      var url = new URL(urlStr.replace('/#', ''));
      var searchParams = url.searchParams;
      var id = searchParams.get('id');
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetOrders/' + this.haaId + '/' + id + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data.data[0];
          var pagLastPage = response.data.data.last_page + '0';
          _this.placeOrderData = dataRes;
          var discountValue = 0;
          var qty = 0;
          var totalDiscount = 0;
          for (var i = 0; i < dataRes.webshop_invoice_products.length; i++) {
            discountValue = dataRes.webshop_invoice_products[i].DISCOUNT_PRICE;
            qty = dataRes.webshop_invoice_products[i].QUANTITY;
            totalDiscount += discountValue * qty;
          }
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(totalDiscount))) {
            _this.discount = parseInt(totalDiscount) + '.00';
          } else {
            _this.discount = parseInt(totalDiscount);
          }
          _this.lastPage = pagLastPage;
          _this.showBreadCrumb();
          _this.loading = false;
          _this.orderowner = res.data.data[0].COMPANY_ID;
        } else {
          _this.showBreadCrumb();
          _this.loading = false;
          console.log('Error in displayOrder()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayOrder();
      this.insideLoading = true;
    }
  }
});

/***/ }),
/* 1415 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"order"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),(_vm.haaId == _vm.orderowner)?_c('h4',{staticClass:"darkblue bold"},[_vm._v("Ordre #"+_vm._s(_vm.placeOrderData.ID)+" ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[_c('div',{staticStyle:{"font-size":"15px"}},[(_vm.haaId == _vm.orderowner)?_c('div',{staticClass:"p3 more-muted-background"},[_c('table',{staticClass:"mediumgrey-text  mb1"},[_c('tr',{staticClass:"h6"},[_c('td',{staticClass:"bold mr2 pb1"},[_vm._v("Status:")]),_vm._v(" "),_c('td',{staticClass:"semi-bold pb1 right-align"},[(_vm.placeOrderData.STAGE_ID == 'EXECUTING')?_c('em',[_vm._v("Igang")]):_c('em',[_vm._v("Betalt")])])]),_vm._v(" "),_c('tr',{staticClass:"h6"},[_c('td',{staticClass:"bold pr2 pb1"},[_vm._v("Dato:")]),_vm._v(" "),_c('td',{staticClass:"semi-bold pb1 right-align"},[_c('em',[_vm._v(_vm._s(_vm.placeOrderData.DATE_UPDATE))])])]),_vm._v(" "),_c('tr',{staticClass:"h6"},[_c('td',{staticClass:"bold pr2 pb1"},[_vm._v("Levering:")]),_vm._v(" "),_c('td',{staticClass:"semi-bold pb1 right-align"},[_c('em',[_vm._v(_vm._s(_vm.placeOrderData.PRICE_DELIVERY.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + _vm.currency))])])]),_vm._v(" "),(_vm.discount.toString().replace(/\B(?=(\d{3})+(?!\d))/g) > 0.00)?_c('tr',{staticClass:"h6"},[_c('td',{staticClass:"bold pr2 pb1"},[_vm._v("Rabat:")]),_vm._v(" "),_c('td',{staticClass:"semi-bold pb1 right-align"},[_c('em',[_vm._v(_vm._s(_vm.discount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + _vm.currency))])])]):_vm._e(),_vm._v(" "),_c('tr',{staticClass:"h6"},[_c('td',{staticClass:"bold pr2 pb1"},[_vm._v("Total:")]),_vm._v(" "),_c('td',{staticClass:"semi-bold pb1 right-align"},[_c('em',[_vm._v(_vm._s(_vm.placeOrderData.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + " " + _vm.currency))])])])])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',{staticClass:"el-table el-table--fit el-table--enable-row-hover el-table--enable-row-transition"},[_c('div',[(_vm.haaId == _vm.orderowner)?_c('table',{staticClass:"el-table__body col-12 p0"},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.placeOrderData.webshop_invoice_products),function(invoice,index){return _c('tr',{key:index,staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1"},[_c('span',[_vm._v(_vm._s(invoice.NAME))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 qty"},[_c('span',[_vm._v(_vm._s(invoice.QUANTITY))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 price"},[_c('span',[_vm._v(_vm._s(invoice.PRICE.slice(0, -2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ") + ' ' + _vm.currency))])])])}),0)]):_c('div',[_vm._m(2)])])])])])]),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Produkt")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Antal")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Pris")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:" p4 "},[_vm._v("Tak for din ordre. Tryk venligst på knappen tilbage eller "),_c('a',{staticClass:"mintgreen",attrs:{"href":"#/webshop/orders"}},[_vm._v(" klik på hende ")]),_vm._v(" for at se din ordre ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wishlist_vue__ = __webpack_require__(1418);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172f29fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_wishlist_vue__ = __webpack_require__(1419);
function injectStyle (ssrContext) {
  __webpack_require__(1417)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_wishlist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_172f29fa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_wishlist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1417 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__footer__ = __webpack_require__(106);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    WebshopFooter: __WEBPACK_IMPORTED_MODULE_2__footer__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      totalProdCount: 0,
      prodData: [],
      prodMsg: 'Ingen Varer På Din Ønskeliste',
      curPage: 1,
      lastPage: 20,
      form: {}
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayWishList();
  },

  methods: {
    checkimage: function checkimage(key) {
      var imgLink = 'http://widget.haandvaerker.dk/products/' + this.prodData[key].PRODUCT_GROUP + '/' + this.prodData[key].EXT + '/productPng.php?id=' + this.haaId;

      var img = document.querySelector('img[data-key="' + key + '"]');
      img.src = imgLink;
      this.prodData[key].LOAD = true;
    },
    onImageLoad: function onImageLoad(key) {
      this.prodData[key].LOAD = true;
    },
    showBreadCrumb: function showBreadCrumb() {
      document.querySelector('.breadCrumb').classList.remove('hide');
    },
    displayWishList: function displayWishList() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'webshop/GetWishList/' + this.haaId + '?page=' + this.curPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var dataRes = response.data.data.data;
          var pagLastPage = response.data.data.last_page + '0';
          var products = [];
          for (var k = 0; k < dataRes.length; k++) {
            if (dataRes[k].ID != null) {
              products.push(dataRes[k]);
            }
          }
          _this.prodData = products;
          _this.lastPage = pagLastPage;
          if (!_this.prodData.length) {
            _this.prodMsg = 'Ingen Varer På Din Ønskeliste.';
          } else {
            _this.prodMsg = '';
          }
          _this.showBreadCrumb();
          _this.loading = false;
          _this.insideLoading = false;
          for (var i = 0; i < _this.prodData.length; i++) {
            if (_this.prodData[i].SIZE === '' || _this.prodData[i].SIZE === null) {
              _this.prodData[i].EXT = '0';
            } else {
              _this.prodData[i].EXT = _this.prodData[i].SIZE.replace(/\s/g, '').replaceAll('B', '').replaceAll('H', '');
            }
            _this.prodData[i].LOAD = false;
          }
        } else {
          _this.showBreadCrumb();
          _this.loading = false;
          _this.insideLoading = false;
          console.log('Error in displayWishList()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    removeProdWishList: function removeProdWishList(id) {
      var _this2 = this;

      var compId = this.haaId;
      var prodId = id;
      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',
        url: 'webshop/AddRemoveWishlist',
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          CompanyID: compId,
          ProductID: prodId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.displayWishList();
          _this2.calulateWishListCount();
          _this2.$toastr('success', 'Fjernet');
        } else {
          _this2.loading = false;
          _this2.insideLoading = false;
          console.log('Error in removeProdWishList()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
      this.insideLoading = true;
    },
    calulateWishListCount: function calulateWishListCount() {
      setTimeout(function () {
        var prodWishList = document.querySelectorAll('a.wishlist-icon');
        for (var i = 0; i < prodWishList.length; i++) {}
        document.querySelector('.totalWishList').innerText = i;
      }, 1000);
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayWishList();
      this.insideLoading = true;
    }
  }
});

/***/ }),
/* 1419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wishlist animated fadeIn pb4",attrs:{"id":"products"}},[_c('div',[_c('WebshopHeader'),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[_c('h4',{staticClass:"darkblue bold"}),_vm._v(" "),_c('div',{attrs:{"id":"productFilter"}},[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',{staticClass:"fit"},[(_vm.prodMsg == '')?_c('div',{staticClass:"right-align"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',{staticClass:"flex flex-wrap"},[_vm._l((_vm.prodData),function(prod,index1){return _c('div',{key:index1,staticClass:"lg-col-4 md-col-6 p0"},[(prod.LOAD)?_c('div',{staticClass:"clearfix"},[_vm._m(2,true)]):_c('div'),_vm._v(" "),_c('div',{staticClass:"p2"},[_c('div',{staticClass:"relative border muted-border more-muted-background"},[_c('a',{staticClass:"absolute pointer z2 right-0 mt1 mr1 wishlist-icon",attrs:{"title":"Fjern"},on:{"click":function($event){return _vm.removeProdWishList(prod.ID)}}},[_c('span',{staticClass:"mintgreen"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"36","height":"36","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 4.248c-3.148-5.402-12-3.825-12 2.944 0 4.661 5.571 9.427 12 15.808 6.43-6.381 12-11.147 12-15.808 0-6.792-8.875-8.306-12-2.944z"}})])])]),_vm._v(" "),_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[(prod.get_product_image.length)?_c('div',[(prod.PRODUCT_GROUP == '1000' || prod.PRODUCT_GROUP == '1300' || prod.PRODUCT_GROUP == '1400' || prod.PRODUCT_GROUP == '2000' || prod.PRODUCT_GROUP == '2100' || prod.PRODUCT_GROUP == '2200' || prod.PRODUCT_GROUP == '2300' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '2500' || prod.PRODUCT_GROUP == '2400' || prod.PRODUCT_GROUP == '10001' || prod.PRODUCT_GROUP == '10002' || prod.PRODUCT_GROUP == '10003' || prod.PRODUCT_GROUP == '10004' || prod.PRODUCT_GROUP == '10005')?_c('img',{staticClass:"prod-img",attrs:{"data-key":index1,"src":typeof 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== 'undefined' && 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' !== null ? 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/rendered/'+_vm.haaId+'.jpg' : 'http://widget.haandvaerker.dk/products/'+prod.PRODUCT_GROUP+'/'+prod.EXT+'/productPng.php?id='+_vm.haaId,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(index1)},"error":function($event){return _vm.checkimage()}}}):_c('img',{staticClass:"prod-img",attrs:{"src":'https://newcrm.kundematch.dk'+prod.get_product_image[0].showURL,"width":"100%","rel":"preload"},on:{"load":function($event){return _vm.onImageLoad(index1)}}})]):_c('div',[(prod.PRODUCT_GROUP == '9001')?_c('img',{staticClass:"prod-img",attrs:{"data-key":1,"src":prod.IMAGE_URL,"width":"100%","rel":"preload"}}):_vm._e()])])]),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('a',{staticClass:"cart-icon",attrs:{"href":'#/webshop/product?id=' + prod.ID}},[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(prod.NAME))])]),_vm._v(" "),_c('span',{staticClass:"h6 mintgreen bold"},[_vm._v(_vm._s(prod.PRICE.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " "))+" kr")])])])])}),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.prodMsg))])])],2)])])])])]),_vm._v(" "),(!_vm.loading)?_c('WebshopFooter'):_vm._e()],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"mediumgrey bold"},[_vm._v("Genererer forhåndsvisning...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FbAds_vue__ = __webpack_require__(1422);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23938766_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FbAds_vue__ = __webpack_require__(1423);
function injectStyle (ssrContext) {
  __webpack_require__(1421)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_FbAds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23938766_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_FbAds_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1421 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */]
  },
  data: function data() {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      adsData: [],
      filterStatus: 'active',
      adsMsg: 'Du har ingen annoncer.',
      curPage: 1,
      lastPage: 10
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayAds();
  },

  methods: {
    displayAds: function displayAds() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'integration/GetAdsbySupplierId/' + this.haaId + '/' + this.filterStatus + '/' + this.curPage + '/10'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res !== null && res.data.length >= 0) {
          var dataRes = res.data;
          var pagLastPage = res.data[0].LastPage + '0';
          _this.adsData = dataRes;
          _this.lastPage = pagLastPage;
          if (!dataRes.length) {
            if (_this.filterStatus === 'active') {
              _this.adsMsg = 'Du Har Ingen Aktive Ads.';
            } else {
              _this.adsMsg = 'Du Har Ingen Gammel Ads.';
            }
          } else {
            _this.adsMsg = '';
          }
          _this.insideLoading = false;
        } else {
          _this.insideLoading = false;
          _this.adsMsg = 'Der er sket en fejl.';
          _this.$toastr('error', 'Fejl');
          console.log('Error in displayAds()', response);
        }
      }, function (response) {
        _this.insideLoading = false;
        _this.adsMsg = 'Der er sket en fejl.';
        _this.$toastr('error', 'Fejl');
        console.log('Error in displayAds()', response);
      });
    },
    statusChanged: function statusChanged(id, status) {
      var _this2 = this;

      var data = {};
      this.$http.post('https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + id, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        if (res.result.paid) {
          _this2.stopStartAd(id, status);
        } else {
          _this2.insideLoading = false;
          _this2.$toastr('error', 'Skal først betale');
        }
      }, function (response) {
        console.log('Error in validatePayment');
        _this2.insideLoading = false;
      });
      this.insideLoading = true;
    },
    stopStartAd: function stopStartAd(adId, status) {
      var _this3 = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'POST',

        url: 'integration/PauseFbAd/' + adId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.displayAds();
          if (status === 'running') {
            _this3.$toastr('success', 'Løb');
          } else {
            _this3.$toastr('success', 'Pauset');
          }
        } else {
          _this3.insideLoading = false;
          _this3.$toastr('error', 'Fejl');
          console.log('Error in stopStartAd()', response);
        }
      }, function (response) {
        console.log('Error in stopStartAd()', response);
        _this3.insideLoading = false;
      });
    },
    tabChanged: function tabChanged(tab) {
      if (tab.index === '0') {
        this.filterStatus = 'active';
      } else {
        this.filterStatus = 'old';
      }
      this.curPage = 1;
      this.displayAds();
      this.insideLoading = true;
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayAds();
      this.insideLoading = true;
    },
    sendStatistic: function sendStatistic(adId) {
      var _this4 = this;

      var data = {
        operation: 'adsstat',
        adstype: 'facebook',
        adsid: adId,
        salesPerson: this.salesPerson,
        type: 'POST'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {} else {
          _this4.$toastr('error', 'Fejl');
          console.log('Error in sendStatistic()', response);
        }
      }, function (response) {
        console.log('Error in sendStatistic()', response);
        _this4.insideLoading = false;
      });
      document.querySelector('#btnId' + adId).classList.add('invisible');
      var obj = {
        title: 'Vi sender en email til dig indenfor få dage',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    }
  }
});

/***/ }),
/* 1423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"ads"}},[_c('div',[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('h4',{staticClass:"darkblue bold"},[_vm._v("Dine facebook annoner")]),_vm._v(" "),_c('a',{staticClass:"gibson h5 primarycolor right",attrs:{"href":"#/webshop/google-ads"}},[_vm._v("Se google annoncer")]),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.tabChanged}},[_c('el-tab-pane',{attrs:{"label":"Nuværende"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Gamle"}})],1),_vm._v(" "),(_vm.adsMsg == '' && !_vm.insideLoading)?_c('div',{staticClass:"right-align"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',[_c('div',{staticClass:"pb2"}),_vm._v(" "),(_vm.adsMsg == '')?_c('div',{staticClass:"col-12 p0 lg-flex flex-wrap"},_vm._l((_vm.adsData),function(ads,index){return _c('div',{key:index,staticClass:"lg-col-4 md-col-12 p0 pr3 mb4"},[_c('div',{staticClass:"border muted-border"},[_c('div',{staticClass:"p2"},[_c('div',[_c('div',{staticClass:"flex justify-between mb3 border-bottom muted-border"},[_c('div',{staticClass:"block pb2"},[_c('div',[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(ads.AdId))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6"},[_vm._v("Start dato: "),_c('span',{staticClass:"darkblue bold"},[_vm._v(_vm._s(_vm.moment(new Date(parseInt(ads.StartDate.substring(6).replace(")/", ""))).toLocaleDateString()).format('YYYY-MM-DD')))])])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"fontsize15"},[_vm._v(_vm._s(ads.AdStatus))])])]),_vm._v(" "),_c('div',{staticClass:"pb2"},[_c('div',[(ads.AdStatus == 'PAUSED' || ads.AdStatus == 'ARCHIVED')?_c('a',{staticClass:"pointer no-hover",attrs:{"title":"Løb"},on:{"click":function($event){return _vm.statusChanged(ads.AdId, 'running')}}},[_c('i',{staticClass:"el-icon-video-play h4"})]):_vm._e(),_vm._v(" "),(ads.AdStatus == 'ACTIVE')?_c('a',{staticClass:"pointer no-hover",attrs:{"title":"Pause"},on:{"click":function($event){return _vm.statusChanged(ads.AdId, 'paused')}}},[_c('i',{staticClass:"el-icon-video-pause h4"})]):_vm._e()]),_vm._v(" "),_c('em',{staticClass:"green fontsize15"},[_vm._v("Afslutter "+_vm._s(_vm.moment(new Date(parseInt(ads.EndDate.substring(6).replace(")/", ""))).toLocaleDateString()).format('YYYY-MM-DD')))])])]),_vm._v(" "),_c('el-collapse',{staticClass:"border-none mb3"},[_c('el-collapse-item',{attrs:{"title":ads.AdName,"name":"index"}},[_c('div',{staticClass:"flex justify-between"},[_c('div',{staticClass:"col-6 block pb2 pl0 pr0"},[_c('div',[_c('p',{staticClass:"gibson mediumgrey break-word"},[_vm._v(_vm._s(ads.AdDescription))])])]),_vm._v(" "),_c('div',{staticClass:"col-6 pb2 pl0 pr0 right-align"},[_c('img',{attrs:{"src":ads.ImageURL,"width":"90%"}})])])])],1),_vm._v(" "),_c('div',[_c('button',{staticClass:"gibson action-button py2 px3 h5 semi-bold not-rounded",attrs:{"id":'btnId'+ads.AdId,"type":"button"},on:{"click":function($event){return _vm.sendStatistic(ads.AdId)}}},[_c('span',[_vm._v("Klik her for statistik")])])])],1)])])])}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.adsMsg))])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1424 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAds_vue__ = __webpack_require__(1426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b799b6e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAds_vue__ = __webpack_require__(1427);
function injectStyle (ssrContext) {
  __webpack_require__(1425)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoogleAds_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8b799b6e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_GoogleAds_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1425 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1426 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(72);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */]
  },
  data: function data() {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      adsData: [],
      filterStatus: 'ENABLED',
      adsMsg: 'Du har ingen annoncer.',
      curPage: 1,
      perPage: 10,
      lastPage: 0
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayAds();
  },

  methods: {
    displayAds: function displayAds() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'integration/GetGoogleAdsBySupplierId/' + this.haaId + '/' + this.filterStatus + '/' + this.curPage + '/' + this.perPage
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res !== null) {
          if (res.login === false) {
            _this.$router.push('/login');
          }
          var dataRes = res.data.data;
          var pagLastPage = res.data.last_page;
          var perPage = res.data.per_page;
          _this.adsData = dataRes;
          _this.lastPage = pagLastPage;
          _this.perPage = perPage;
          if (dataRes.length === 0) {
            if (_this.filterStatus === 'ENABLED') {
              _this.adsMsg = 'Du har ingen aktive annoncer.';
            } else {
              _this.adsMsg = 'Du har ingen gamle annoncer.';
            }
          } else {
            _this.adsMsg = '';
          }
          _this.insideLoading = false;
        } else {
          _this.insideLoading = false;
          console.log('Error in displayAds()', response);
        }
      }, function (response) {
        _this.insideLoading = false;
        console.log('Error in displayAds()', response);
      });
    },
    statusChanged: function statusChanged(id, groupId, status) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_1_axios___default()({
        method: 'POST',
        url: 'https://www.kundematch.dk/crm/libraries/productform/product.php?mode=checkinvoice&addsid=' + id,
        headers: {},
        data: {}
      }).then(function (response) {
        var res = response.data;
        if (res.success) {
          if (res.result.paid) {
            var url = (status === 'running' ? 'integration/UnPauseGoogleAd/' : 'integration/PauseGoogleAd/') + id + '/' + groupId;
            var data = {
              operation: 'bitrixApi',
              salesPerson: _this2.salesPerson,
              type: 'POST',
              url: url
            };
            _this2.$http.post('', data, { emulateJSON: true }).then(function (response) {
              var res = response.body;
              if (res.login === false) {
                _this2.$router.push('/login');
              }
              if (res.success) {
                _this2.displayAds();
                if (status === 'running') {
                  _this2.$toastr('success', 'Løb');
                } else {
                  _this2.$toastr('success', 'Pauset');
                }
              } else {
                _this2.insideLoading = false;
                console.log('Error in statusChanged()');
              }
            }, function (response) {
              console.log('Error: ', response);
              _this2.insideLoading = false;
            });
          } else {
            _this2.$toastr('error', 'Skal først betale');
            _this2.insideLoading = false;
          }
        } else {
          _this2.$toastr('error', 'Fejl');
          _this2.insideLoading = false;
        }
      }).catch(function (error) {
        console.log('Error: ', error);
        _this2.loading = false;
        _this2.insideLoading = false;
      });
      this.insideLoading = true;
    },
    tabChanged: function tabChanged(tab) {
      if (tab.index === '0') {
        this.filterStatus = 'ENABLED';
      } else {
        this.filterStatus = 'PAUSED';
      }
      this.curPage = 1;
      this.displayAds();
      this.insideLoading = true;
    },
    paginationChanged: function paginationChanged(val) {
      var pagCurPage = '' + val;
      this.curPage = pagCurPage;
      this.displayAds();
      this.insideLoading = true;
    },
    sendStatistic: function sendStatistic(adId) {
      var _this3 = this;

      var data = {
        operation: 'adsstat',
        adstype: 'facebook',
        adsid: adId,
        salesPerson: this.salesPerson,
        type: 'POST'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {} else {
          _this3.$toastr('error', 'Fejl');
          console.log('Error in sendStatistic()', response);
        }
      }, function (response) {
        console.log('Error in sendStatistic()', response);
        _this3.insideLoading = false;
      });
      document.querySelector('#btnId' + adId).classList.add('invisible');
      var obj = {
        title: 'Vi sender en email til dig indenfor få dage',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    }
  }
});

/***/ }),
/* 1427 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"ads"}},[_c('div',[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('h4',{staticClass:"darkblue bold"},[_vm._v("Dine google annoner")]),_vm._v(" "),_c('a',{staticClass:"gibson h5 primarycolor right",attrs:{"href":"#/webshop/fb-ads"}},[_vm._v("Se facebook annoncer")]),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[_c('el-tabs',{attrs:{"type":"card"},on:{"tab-click":_vm.tabChanged}},[_c('el-tab-pane',{attrs:{"label":"Nuværende"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Gamle"}})],1),_vm._v(" "),(_vm.adsMsg == '' && !_vm.insideLoading)?_c('div',{staticClass:"right-align"},[_c('el-pagination',{attrs:{"small":"","layout":"prev, pager, next","total":parseInt(_vm.lastPage),"current-page":parseInt(_vm.curPage)},on:{"current-change":_vm.paginationChanged}})],1):_vm._e(),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 lg-flex flex-wrap"},_vm._l((_vm.adsData),function(ads,index){return (_vm.adsMsg == '')?_c('div',{key:index,staticClass:"lg-col-4 md-col-12 p0 pr3 mb4"},[_c('div',{staticClass:"border muted-border"},[_c('div',{staticClass:"p2"},[_c('div',[_c('div',{staticClass:"flex justify-between mb3 border-bottom muted-border"},[_c('div',{staticClass:"block pb2"},[_c('div',[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(ads.AdId))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6"},[_vm._v("Start dato: "),_c('span',{staticClass:"darkblue bold"},[_vm._v(_vm._s(ads.CampaignStartDate))])])]),_vm._v(" "),_c('div',[(ads.campaignStatus == 3)?_c('span',{staticClass:"fontsize15"},[_vm._v("PAUSED")]):_c('span',{staticClass:"fontsize15"},[_vm._v("ACTIVE")])])]),_vm._v(" "),_c('div',{staticClass:"pb2"},[_c('div',[(ads.campaignStatus == 3)?_c('a',{staticClass:"pointer no-hover",attrs:{"title":"Løb"},on:{"click":function($event){return _vm.statusChanged(ads.AdId, ads.AdGroupId, 'running')}}},[_c('i',{staticClass:"el-icon-video-play h4"})]):_vm._e(),_vm._v(" "),(ads.campaignStatus == 2)?_c('a',{staticClass:"pointer no-hover",attrs:{"title":"Pause"},on:{"click":function($event){return _vm.statusChanged(ads.AdId, ads.AdGroupId, 'paused')}}},[_c('i',{staticClass:"el-icon-video-pause h4"})]):_vm._e()]),_vm._v(" "),_c('em',{staticClass:"green fontsize15"},[_vm._v("Afslutter "+_vm._s(ads.CampaignEtartDate))])])]),_vm._v(" "),_c('el-collapse',{staticClass:"border-none"},[_c('el-collapse-item',{attrs:{"title":ads.campaignName,"name":"index"}},[_c('div',{staticClass:"flex justify-between"},[_c('div',{staticClass:"col-6 block pb2 pl0 pr0"},[_c('div')]),_vm._v(" "),_c('div',{staticClass:"col-6 pb2 pl0 pr0 right-align"})])])],1),_vm._v(" "),_c('div',{staticClass:"flex justify-between pt3 border-top muted-border mb3"},[_c('div',{staticClass:"col-4 p0"},[_c('div',[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(ads.Impressions))])]),_vm._v(" "),_vm._m(1,true)]),_vm._v(" "),_c('div',{staticClass:"col-4 p0"},[_c('div',[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(ads.Clicks))])]),_vm._v(" "),_vm._m(2,true)]),_vm._v(" "),_c('div',{staticClass:"col-4 p0"},[_c('div',[_c('span',{staticClass:"h5 darkblue bold block"},[_vm._v(_vm._s(ads.Cost))])]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6"},[_vm._v("Brugt resterende "+_vm._s(ads.Budget))])])])]),_vm._v(" "),_c('div',[_c('button',{staticClass:"gibson action-button py2 px3 h5 semi-bold not-rounded",attrs:{"id":'btnId'+ads.AdId,"type":"button"},on:{"click":function($event){return _vm.sendStatistic(ads.AdId)}}},[_c('span',[_vm._v("Klik her for statistik")])])])],1)])])]):_vm._e()}),0),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.adsMsg))])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"h6"},[_vm._v("Nå")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"h6"},[_vm._v("Klik")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostProfilside_vue__ = __webpack_require__(1429);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e40928_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostProfilside_vue__ = __webpack_require__(1430);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostProfilside_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41e40928_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostProfilside_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1429 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
  },
  data: function data() {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      comanyName: '',
      image: '',
      description: '',
      boostOption: '',
      companyUrl: '',
      modalBoostConfirmation: false
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.companyName = localStorage.getItem('CompanyName');
    this.showProfileImage();
    this.setDefaultAmount();
  },

  methods: {
    setDefaultAmount: function setDefaultAmount() {
      setTimeout(function () {
        document.getElementById('amount').value = '200,00';
      }, 500);
    },
    addHide: function addHide() {
      document.getElementById('profil').classList.add('hide');
    },
    removeHide: function removeHide() {
      document.getElementById('profil').classList.remove('hide');
    },
    imageLoaded: function imageLoaded() {
      this.removeHide();
      this.insideLoading = false;
    },
    disableBoost: function disableBoost() {
      document.getElementById('fbBoost').attr('disabled', 'disabled');
      document.getElementById('googleBoost').attr('disabled', 'disabled');
    },
    formatAmount: function formatAmount() {
      setTimeout(function () {
        var amount = document.getElementById('amount').value;
        if (amount !== '') {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            });
            document.getElementById('amount').value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '');
          } else {
            document.getElementById('amount').value = '';
          }
        }
      }, 1000);
    },
    confirmBoost: function confirmBoost(option) {
      this.boostOption = option;
      this.modalBoostConfirmation = true;
    },
    boostProfile: function boostProfile(option) {
      var _this = this;

      var amount = document.getElementById('amount').value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
      if (amount !== '') {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
          var url = '';
          if (option === 'facebook') {
            url = 'integration/PostPageToFBAd/' + this.haaId + '/' + amount;
          } else {
            url = 'integration/PostProfileToGoogleAd/' + amount + '/' + this.haaId;
          }

          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          };
          this.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res !== null) {
              if (res.success) {
                _this.insideLoading = false;
                _this.removeHide();
                _this.setDefaultAmount();
                var obj = {
                  title: 'Dit profil boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                };
                _this.$refs.simplert.openSimplert(obj);
              } else {
                _this.insideLoading = false;
                _this.removeHide();
                _this.setDefaultAmount();
                _this.$toastr('error', 'Fejl');
                console.log('Error in boostProfile()', response);
              }
            } else {
              _this.insideLoading = false;
              _this.removeHide();
              _this.setDefaultAmount();
              _this.$toastr('error', 'Allerede boostet');
              console.log('Error in boostProfile()', response);
            }
          }, function (response) {
            _this.insideLoading = false;
            _this.removeHide();
            _this.setDefaultAmount();
            _this.$toastr('error', 'Fejl');
            console.log('Error in boostProfile()', response);
          });
          this.modalBoostConfirmation = false;
          this.insideLoading = true;
          this.addHide();
        } else {
          this.$toastr('error', 'Ugyldigt beløb');
        }
      } else {
        this.$toastr('error', 'Indtast beløb');
      }
    },
    showProfileImage: function showProfileImage() {
      var _this2 = this;

      var dataPartner = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.data;
        _this2.image = res.resultImages[0].FileLocation;
        _this2.description = res.Description;
        _this2.companyUrl = res.url;
      }, function (response) {
        _this2.$toastr('error', 'Fejl');
        console.log('Error in showProfileImage()', response);
      });
    }
  }
});

/***/ }),
/* 1430 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"boostProfile"}},[_c('div',[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('h4',{staticClass:"darkblue bold"},[_vm._v("Boost profil")]),_vm._v(" "),_c('p',{staticClass:"gibson mediumgrey"}),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hide",attrs:{"id":"profil"}},[_c('div',{staticClass:"lg-col-5 md-col-6 sm-col-10 p0"},[_c('div',{staticClass:"highlights"},[_c('div',{staticClass:"flex justify-between items-start p2"},[_c('div',{staticClass:"flex justify-start items-start"},[_c('img',{staticClass:"circle fit block",attrs:{"height":"36","src":"static/svg/h.svg","alt":""}}),_vm._v(" "),_c('div',{staticClass:"pl1"},[_c('p',{staticClass:"h6 gibson semi-bold darkblue line-height-1 m0",domProps:{"innerHTML":_vm._s(_vm.companyName)}}),_vm._v(" "),_c('p',{staticClass:"h6 gibson mediumgrey light line-height-1 m0 p0",staticStyle:{"font-size":"80%"}},[_vm._v("\n                        Sponsored\n                      ")])])]),_vm._v(" "),_vm._m(1)]),_vm._v(" "),_c('div',{staticClass:"px2"},[_c('p',{staticClass:"h6 regular gibson darkblue line-height-3 mt1",staticStyle:{"font-size":"90%"}},[_vm._v("\n                    Besøg vores profil på\n                  ")]),_vm._v(" "),_c('p',{staticClass:"h6 regular gibson darkblue line-height-3 mt1",staticStyle:{"font-size":"90%"}},[_c('a',{staticStyle:{"overflow-wrap":"break-word"},attrs:{"href":_vm.companyUrl,"target":"_blank"}},[_vm._v("\n                      "+_vm._s(_vm.companyUrl)+"\n                    ")])])]),_vm._v(" "),_c('div',{staticClass:"mt2 col-12 px0"},[_c('img',{staticClass:"fit block col-12",attrs:{"src":_vm.image,"alt":"","rel":"preload"},on:{"load":function($event){return _vm.imageLoaded()}}})]),_vm._v(" "),_c('div',{staticClass:"px2 pt1 pb2 lightgrey-background"},[_c('p',{staticClass:"h6 semi-bold gibson darkblue line-height-1 mt1 p0",staticStyle:{"font-size":"90%"},domProps:{"innerHTML":_vm._s(_vm.companyName)}}),_vm._v(" "),_c('p',{staticClass:"hide mediumgrey regular line-height-1 m0 p0",staticStyle:{"margin-top":"8px","margin-bottom":"6px","font-size":"75%"},domProps:{"innerHTML":_vm._s(_vm.companyName)}})])]),_vm._v(" "),_c('div',[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('b-form-input',{staticClass:"mb1",attrs:{"id":"amount","placeholder":"Beløb her"},on:{"input":function($event){return _vm.formatAmount()}}}),_vm._v(" "),_c('b-button',{staticClass:"action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmBoost('facebook')}}},[_vm._v("Boost på facebook "),_c('i',{staticClass:"fab fa-facebook-f"})]),_vm._v(" "),_c('b-button',{staticClass:"action-button  py2 px3 m0 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmBoost('google')}}},[_vm._v("Boost på google  "),_c('i',{staticClass:"fab fa-google"})])],1)]),_vm._v(" "),_c('b-modal',{attrs:{"id":"boost-modal","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalBoostConfirmation),callback:function ($$v) {_vm.modalBoostConfirmation=$$v},expression:"modalBoostConfirmation"}},[_c('div',{staticClass:"center col-10 py3 mx-auto"},[_c('div',{staticClass:"mb3"},[_c('img',{attrs:{"src":"static/svg/question-mark-new.svg","rel":"preload","width":"25%"}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue bold m0"},[_vm._v("Du er ved at booste din profil på "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.boostOption))]),_vm._v(".")]),_vm._v(" "),_c('p',{staticClass:"darkblue bold mb3"},[_vm._v("Ønsker du at forsætte?")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('b-button',{staticClass:"primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){_vm.modalBoostConfirmation = false}}},[_vm._v("\n                      Nej \n                    ")]),_vm._v(" "),_c('b-button',{staticClass:"action-button  py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.boostProfile(_vm.boostOption)}}},[_vm._v("\n                      Ja\n                    ")])],1)])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])])])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('i',{staticClass:"el-icon-more"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1431 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostProjekt_vue__ = __webpack_require__(1433);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236f2ccc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostProjekt_vue__ = __webpack_require__(1434);
function injectStyle (ssrContext) {
  __webpack_require__(1432)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostProjekt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_236f2ccc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostProjekt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1432 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1433 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__uploads_projectimages__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    projectimages: __WEBPACK_IMPORTED_MODULE_2__uploads_projectimages__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  data: function data() {
    return {
      insideLoading: true,
      salesPerson: '',
      haaId: '',
      projData: '',
      projMsg: 'Du Har Ikke Et Projekt.',
      showLess: true,
      boostProjId: '',
      boostOption: '',
      modalBoostConfirmation: false
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayProjects();
  },

  methods: {
    showlesss: function showlesss(key) {
      this.showLess = !this.showLess;
      if (this.showLess) {
        document.querySelector('span[data-key="' + key + '"]').classList.remove('text-overflow-handle');
      } else {
        document.querySelector('span[data-key="' + key + '"]').classList.add('text-overflow-handle');
      }
    },
    displayProjects: function displayProjects() {
      var _this = this;

      var data = {
        operation: 'myProjectnew',
        salesPerson: this.salesPerson,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var dataRes = res.projects;
        _this.projData = dataRes;
        _this.setDefaultAmount();
        if (!dataRes.length) {
          _this.projMsg = 'Du Har Ikke Et Projekt.';
        } else {
          _this.projMsg = '';
        }
        _this.insideLoading = false;
      }, function (response) {
        _this.insideLoading = false;
        _this.$toastr('error', 'Fejl');
        console.log('Error in displayProjects()');
      });
    },
    setDefaultAmount: function setDefaultAmount() {
      setTimeout(function () {
        var amount = document.querySelectorAll('input.amount');
        for (var i = 0; i < amount.length; i++) {
          amount[i].value = '200,00';
        }
      }, 500);
    },
    formatAmount: function formatAmount(projId) {
      setTimeout(function () {
        var amount = document.getElementById('amount' + projId).value;
        if (amount !== '') {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            });
            document.getElementById('amount' + projId).value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '');
          } else {
            document.getElementById('amount' + projId).value = '';
          }
        }
      }, 1000);
    },
    confirmBoost: function confirmBoost(projId, option) {
      this.boostProjId = projId;
      this.boostOption = option;
      this.modalBoostConfirmation = true;
    },
    boostProject: function boostProject(projId, option) {
      var _this2 = this;

      var amount = document.getElementById('amount' + projId).value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
      if (amount !== '') {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
          var url = '';
          if (option === 'facebook') {
            url = 'integration/PostProjectToFBAd/' + this.haaId + '/' + projId + '/' + amount;
          } else {
            url = 'integration/PostProjectToGoogleAd/' + amount + '/' + projId + '/' + this.haaId;
          }

          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          };
          this.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res !== null) {
              if (res.success) {
                _this2.insideLoading = false;
                _this2.setDefaultAmount();
                var obj = {
                  title: 'Dit projekt boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                };
                _this2.$refs.simplert.openSimplert(obj);
              } else {
                _this2.insideLoading = false;
                _this2.setDefaultAmount();
                _this2.$toastr('error', 'Fejl');
                console.log('Error in boostProject()', response);
              }
            } else {
              _this2.insideLoading = false;
              _this2.setDefaultAmount();
              _this2.$toastr('error', 'Allerede boostet');
              console.log('Error in boostProject()', response);
            }
          }, function (response) {
            _this2.insideLoading = false;
            _this2.setDefaultAmount();
            _this2.$toastr('error', 'Fejl');
            console.log('Error in boostProject()', response);
          });
          this.modalBoostConfirmation = false;
          this.insideLoading = true;
        } else {
          this.$toastr('error', 'Ugyldigt beløb');
        }
      } else {
        this.$toastr('error', 'Indtast beløb');
      }
    }
  }
});

/***/ }),
/* 1434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"boost-projekt"}},[_c('div',[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('h4',{staticClass:"darkblue bold"},[_vm._v("Boost et projekt")]),_vm._v(" "),_c('p',{staticClass:"gibson mediumgrey"}),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',[(_vm.projMsg == '')?_c('div',{staticClass:"col-12 p0 flex flex-wrap"},_vm._l((_vm.projData),function(proj,index){return _c('div',{key:index,staticClass:"lg-col-3 md-col-12 pl0 pb2 pr3 mb4"},[_c('div',{staticClass:"overflow-hidden flex"},[_c('span',{ref:"text",refInFor:true,staticClass:"h5 darkblue bold text-overflow-handle",attrs:{"data-key":index},on:{"click":function($event){return _vm.showlesss(index)}}},[_vm._v(_vm._s(proj.title))])]),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('el-collapse',{staticClass:"border-none"},[_c('el-collapse-item',{attrs:{"title":"Billede & Beskrivelse","name":index}},[(proj.images.length)?_c('div',[_c('img',{attrs:{"src":proj.images[0].image,"width":"100%"}})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('p',{staticClass:"gibson mediumgrey break-word"},[_vm._v(_vm._s(proj.description))])])],1),_vm._v(" "),_c('div',{staticClass:"border-bottom pb2"},[_c('div',{staticClass:"pb2"}),_vm._v(" "),_c('div',{staticClass:"block"},[_c('b-form-input',{staticClass:"amount mb1",attrs:{"id":'amount'+proj.projectid,"placeholder":"Beløb her","min":200},on:{"input":function($event){return _vm.formatAmount(proj.projectid)}}}),_vm._v(" "),_c('b-button',{staticClass:"action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmBoost(proj.projectid, 'facebook')}}},[_vm._v("Boost på facebook "),_c('i',{staticClass:"fab fa-facebook-f"})]),_vm._v(" "),_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmBoost(proj.projectid, 'google')}}},[_vm._v("Boost på google  "),_c('i',{staticClass:"fab fa-google"})])],1)])],1)}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.projMsg))])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"boost-modal","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalBoostConfirmation),callback:function ($$v) {_vm.modalBoostConfirmation=$$v},expression:"modalBoostConfirmation"}},[_c('div',{staticClass:"center col-10 py3 mx-auto"},[_c('div',{staticClass:"mb3"},[_c('img',{attrs:{"src":"static/svg/question-mark-new.svg","rel":"preload","width":"25%"}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue bold m0"},[_vm._v("Du er ved at booste din profil på "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.boostOption))]),_vm._v(".")]),_vm._v(" "),_c('p',{staticClass:"darkblue bold mb3"},[_vm._v("Ønsker du at forsætte?")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('b-button',{staticClass:"primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){_vm.modalBoostConfirmation = false}}},[_vm._v("\n                  Nej \n                ")]),_vm._v(" "),_c('b-button',{staticClass:"action-button  py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.boostProject(_vm.boostProjId, _vm.boostOption)}}},[_vm._v("\n                  Ja\n                ")])],1)])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1435 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostEnAnbefaling_vue__ = __webpack_require__(1437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7caabf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostEnAnbefaling_vue__ = __webpack_require__(1438);
function injectStyle (ssrContext) {
  __webpack_require__(1436)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BoostEnAnbefaling_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b7caabf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_BoostEnAnbefaling_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1436 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__header__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_updatebitrixpackagepermission__ = __webpack_require__(56);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_1__header__["a" /* default */],
    ImageRating: __WEBPACK_IMPORTED_MODULE_2_vue_rate_it__["ImageRating"],
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a,
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_4__components_updatebitrixpackagepermission__["a" /* default */]
  },
  data: function data() {
    return {
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      reviewId: '',
      reviewData: [],
      overviewData: [],
      reviewMsg: '',
      showLess: true,
      boostReviewId: '',
      boostOption: '',
      modalBoostConfirmation: false
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.getOverview();
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    this.reviewId = searchParams.get('reviewId');
    this.displayRecommendations();
    this.setDefaultAmount();
  },

  methods: {
    showlesss: function showlesss(key) {
      this.showLess = !this.showLess;
      if (this.showLess) {
        document.querySelector('span[data-key="' + key + '"]').classList.remove('text-overflow-handle');
      } else {
        document.querySelector('span[data-key="' + key + '"]').classList.add('text-overflow-handle');
      }
    },
    displayRecommendations: function displayRecommendations() {
      var _this = this;

      var data = {
        operation: 'anbefalingerDetail',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        reviewId: this.reviewId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res != null) {
          _this.reviewData = res;
          _this.reviewMsg = '';
        } else {
          _this.reviewMsg = 'Ingen anbefaling fundet.';
        }
      }, function (response) {
        console.log('Error in displayRecommendations(): ', response);
      });
      this.insideLoading = true;
    },
    getOverview: function getOverview() {
      var _this2 = this;

      var dataPartner = { operation: 'oversigt_partner_haa', salesPerson: this.salesPerson, levid: this.haaId };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.data;
        _this2.overviewData = res;
      }, function (response) {
        _this2.insideLoading = false;
        _this2.$toastr('error', 'Fejl');
        console.log('Error in getOverview()', response);
      });
    },
    setDefaultAmount: function setDefaultAmount() {
      setTimeout(function () {
        document.getElementById('amount').value = '200,00';
      }, 500);
    },
    formatAmount: function formatAmount() {
      setTimeout(function () {
        var amount = document.getElementById('amount').value;
        if (amount !== '') {
          if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
            var noDotCommaValue = amount.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
            var formatter = new Intl.NumberFormat('da', {
              style: 'currency',
              currency: 'DKK',
              minimumFractionDigits: 2
            });
            document.getElementById('amount').value = formatter.format(noDotCommaValue).replace('kr.', '').replace(/\s+/g, '');
          } else {
            document.getElementById('amount').value = '';
          }
        }
      }, 1000);
    },
    addHide: function addHide() {
      document.getElementById('review').classList.add('hide');
    },
    removeHide: function removeHide() {
      document.getElementById('review').classList.remove('hide');
    },
    imageLoaded: function imageLoaded() {
      this.removeHide();
      this.insideLoading = false;
    },
    confirmBoost: function confirmBoost(reviewId, option) {
      this.boostReviewId = reviewId;
      this.boostOption = option;
      this.modalBoostConfirmation = true;
    },
    boostRecommendation: function boostRecommendation(reviewId, option) {
      var _this3 = this;

      var amount = document.getElementById('amount').value.replace(',00', '').replace(',0', '').replace(',', '').replace('.', '');
      if (amount !== '') {
        if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(parseInt(amount))) {
          var url = '';
          if (option === 'facebook') {
            url = 'integration/PostRecommendationToFBAd/' + reviewId + '/' + amount;
          } else {
            url = 'integration/PostRecommendationToGoogleAd/' + amount + '/' + reviewId;
          }
          var data = {
            operation: 'bitrixApi',
            salesPerson: this.salesPerson,
            type: 'POST',
            url: url,
            createinvoice: true,
            price: amount
          };
          this.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res !== null) {
              if (res.success) {
                _this3.insideLoading = false;
                _this3.removeHide();
                _this3.setDefaultAmount();
                var obj = {
                  title: 'Dit anmeldelse boost er nu sendt afsted til ' + option + '. Du vil modtage en besked når den er online på ' + option + '.',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk'
                };
                _this3.$refs.simplert.openSimplert(obj);
              } else {
                _this3.insideLoading = false;
                _this3.removeHide();
                _this3.setDefaultAmount();
                _this3.$toastr('error', 'Fejl');
                console.log('Error in boostRecommendation()', response);
              }
            } else {
              _this3.insideLoading = false;
              _this3.removeHide();
              _this3.setDefaultAmount();
              _this3.$toastr('error', 'Allerede boostet');
              console.log('Error in boostRecommendation()', response);
            }
          }, function (response) {
            _this3.insideLoading = false;
            _this3.removeHide();
            _this3.setDefaultAmount();
            _this3.$toastr('error', 'Fejl');
            console.log('Error in boostRecommendation()', response);
          });
          this.modalBoostConfirmation = false;
          this.insideLoading = true;
          this.addHide();
        } else {
          this.$toastr('error', 'Ugyldigt beløb');
        }
      } else {
        this.$toastr('error', 'Indtast beløb');
      }
    }
  }
});

/***/ }),
/* 1438 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pb4",attrs:{"id":"boost-anbefaling"}},[_c('div',[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('div',{staticClass:"py4 px3"},[_c('div',{staticClass:"pt2"}),_vm._v(" "),_c('h4',{staticClass:"darkblue bold"},[_vm._v("Boost en anbefaling på facebook")]),_vm._v(" "),_c('p',{staticClass:"gibson mediumgrey"}),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('div',{staticClass:"p0"},[(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hide",attrs:{"id":"review"}},[(_vm.reviewMsg == '')?_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"lg-col-3 md-col-12 highlights pt2 px2 pb0 break-word"},[_vm._m(1),_vm._v(" "),_c('div',{staticStyle:{"color":"#003645"}},[_c('p',{staticClass:"semi-bold mb2"},[_vm._v("NY ANBEFALING! 👏 "),_c('br'),_vm._v("\n                    "+_vm._s(_vm.reviewData.SupplierName)+" har netop modtaget en anbefaling på "+_vm._s(_vm.reviewData.Rating)+" stjerner, fordi Håndværker.dk har lavet det perfekte match "),_c('span',{staticClass:"h4 red"},[_vm._v("❤")])]),_vm._v(" "),_c('p',{staticClass:"semi-bold mb2"},[_vm._v("Den glade kunde fortæller \""+_vm._s(_vm.reviewData.RequesterName)+" : "+_vm._s(_vm.reviewData.RequesterComment)+"\"\n                  ")]),_vm._v(" "),_c('p',{staticClass:"semi-bold mb2"},[_vm._v(_vm._s(_vm.reviewData.SupplierName)+" har TLF: "+_vm._s(_vm.reviewData.SupplierPhoneNr)+" og du kan se deres andre ratings her "),_c('br'),_vm._v(" "),_c('a',{staticClass:"no-hover",attrs:{"href":_vm.overviewData.url+'/'+this.reviewId,"target":"_blank"}},[_vm._v(_vm._s(_vm.overviewData.url+'/'+this.reviewId))])])]),_vm._v(" "),_c('img',{attrs:{"src":'https://widget.haandvaerker.dk/banners/Sharefbpng.php?id='+this.reviewId,"rel":"preload","width":"100%"},on:{"load":function($event){return _vm.imageLoaded()}}})]),_vm._v(" "),_c('div',{staticClass:"flex lg-col-3 md-col-12 highlights p2 muted-background"},[_c('div',{staticClass:"col-7 p0 text-left",staticStyle:{"color":"#1C2028"}},[_c('p',{staticClass:"m0"},[_vm._v("HÅNDVÆRKER.DK")]),_vm._v(" "),_c('p',{staticClass:"bold m0"},[_vm._v(_vm._s(_vm.reviewData.SupplierName))]),_vm._v(" "),(!_vm.insideLoading)?_c('div',{staticClass:"flex"},[_c('p',{staticClass:"m0",staticStyle:{"font-size":"0.9rem"},domProps:{"innerHTML":_vm._s(_vm.overviewData.Description.substring(0, 30))}}),_vm._v(" "),(_vm.overviewData.Description.length >= 30)?_c('p',{staticClass:"m0"},[_vm._v("...")]):_vm._e()]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-5 p0 text-center my-auto"},[_c('a',{staticClass:"no-hover border darkblue darkblue-border p1",staticStyle:{"border-color":"#003645 !important"},attrs:{"href":_vm.overviewData.url+'/'+this.reviewId,"target":"_blank"}},[_vm._v("CONTACT US")])])]),_vm._v(" "),_c('div',{staticClass:"lg-col-3 md-col-12 highlights p2"},[_c('b-form-input',{staticClass:"amount mb1",attrs:{"id":"amount","placeholder":"Beløb her"},on:{"input":function($event){return _vm.formatAmount()}}}),_vm._v(" "),_c('b-button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmBoost(_vm.reviewId, 'facebook')}}},[_vm._v("Boost på facebook "),_c('i',{staticClass:"fab fa-facebook-f"})])],1)]):_c('div',{staticClass:"mt3"},[_c('span',{staticClass:"bold"},[_vm._v(_vm._s(_vm.reviewMsg))])])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"boost-modal","hide-footer":"","centered":"","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.modalBoostConfirmation),callback:function ($$v) {_vm.modalBoostConfirmation=$$v},expression:"modalBoostConfirmation"}},[_c('div',{staticClass:"center col-10 py3 mx-auto"},[_c('div',{staticClass:"mb3"},[_c('img',{attrs:{"src":"static/svg/question-mark-new.svg","rel":"preload","width":"25%"}})]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"darkblue bold m0"},[_vm._v("Du er ved at booste din profil på "),_c('span',{staticClass:"capitalize"},[_vm._v(_vm._s(_vm.boostOption))]),_vm._v(".")]),_vm._v(" "),_c('p',{staticClass:"darkblue bold mb3"},[_vm._v("Ønsker du at forsætte?")]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('b-button',{staticClass:"primarycolor-background py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){_vm.modalBoostConfirmation = false}}},[_vm._v("\n                  Naj \n                ")]),_vm._v(" "),_c('b-button',{staticClass:"action-button  py2 px3 m0 gibson not-rounded border-none regular col-5",attrs:{"type":"button"},on:{"click":function($event){return _vm.boostRecommendation(_vm.boostReviewId, _vm.boostOption)}}},[_vm._v("\n                  Ja\n                ")])],1)])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"})],1)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mb2"},[_c('div',{staticClass:"col-1 p0"},[_c('img',{attrs:{"src":"static/svg/h.svg","rel":"preload","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"col-10"},[_c('h6',{staticClass:"bold m0",staticStyle:{"font-size":"0.9rem"}},[_vm._v("Find handvaerkere i Hovedstaden 4.0")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1 mb0",staticStyle:{"font-size":"0.9rem"}},[_vm._v("Sponsored")]),_vm._v(" "),_c('img',{attrs:{"src":"static/svg/globe-asia.svg","rel":"preload","width":"5%"}})])]),_vm._v(" "),_c('div',{staticClass:"col-1 t p0"},[_c('p',{staticClass:"text-center"},[_vm._v("...")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1439 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__ = __webpack_require__(1441);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13024606_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__ = __webpack_require__(1442);
function injectStyle (ssrContext) {
  __webpack_require__(1440)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_TermsAndConditions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_13024606_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_TermsAndConditions_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1440 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__(49);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    WebshopHeader: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */]
  },
  data: function data() {
    return {
      loading: true,
      termsAndConditionData: []
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.displayTermsandConditions();
  },

  methods: {
    displayTermsandConditions: function displayTermsandConditions() {
      var _this = this;

      var data = {
        operation: 'bitrixApi',
        salesPerson: this.salesPerson,
        type: 'GET',
        url: 'bitrix/getWebshopTermsAndConditions'
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.termsAndConditionData = res.data[0].PROPERTY_TERMS_AND_CONDITIONS_VALUE.TEXT;
          _this.setLinkProperties();
          _this.loading = false;
        } else {
          console.log('Error in displayTermsandConditions()');
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    setLinkProperties: function setLinkProperties() {
      setTimeout(function () {
        var link = document.querySelectorAll('.terms-data p a');
        for (var i = 0; i < link.length; i++) {
          link[i].setAttribute('target', '_blank');
          link[i].classList.add('no-hover');
        }
      }, 500);
    }
  }
});

/***/ }),
/* 1442 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py4 px3"},[_c('WebshopHeader',{staticClass:"hide"}),_vm._v(" "),_c('h1',[_vm._v("Vilkår og betingelser")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(0)]):_c('div',{staticClass:"mb2"},[_c('p',{staticClass:"terms-data",domProps:{"innerHTML":_vm._s(_vm.termsAndConditionData)}})])],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badges_vue__ = __webpack_require__(1446);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3083feee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_badges_vue__ = __webpack_require__(1447);
function injectStyle (ssrContext) {
  __webpack_require__(1444)
  __webpack_require__(1445)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_badges_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3083feee_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_badges_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1444 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1445 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1446 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_rate_it__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_rate_it___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_rate_it__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_full_loading__);






var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    ImageRating: __WEBPACK_IMPORTED_MODULE_2_vue_rate_it__["ImageRating"],
    loading: __WEBPACK_IMPORTED_MODULE_3_vue_full_loading___default.a,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      badges: 0,
      klimabadge: [],
      renderklima: false,
      badgesIndustryData: [],
      badgesIndustryDatamail: [],
      badgesIndustryDatasmallmail: [],
      badgesIndustryDatstreamer: [],
      renderMail: false,
      renderMailSmall: false,
      renderStreamer: false,
      loopStatusCheck: '',
      loopStatusCheckbadge: '',
      loopStatusCheckbadgemail: '',
      loopStatusCheckbadgesmall: '',
      show: false,
      label: '',
      overlay: true,
      nowinnerbadge: false,
      displayAllBadges: false,
      disableDownloadBtn: false,
      badgeRegion: '',
      badgemailsignature: '',
      eventLocation: '',
      partnerName: '',
      EventsImagesData: [{
        region: 'Nordjylland',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      }, {
        region: 'Midtjylland',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      }, {
        region: 'Syddanmark',
        location: 'Fredericia',
        link: 'https://drive.google.com/drive/folders/1QSHn6qxX0m59bY-g8P6bAqJ22lbMVDLA?usp=sharing'
      }, {
        region: 'Sjælland',
        location: 'Slagelse',
        link: 'https://drive.google.com/drive/folders/1F1t8yWzw_z9EV7G6bz80X0nDVu5c3tsc?usp=sharing'
      }, {
        region: 'Hovedstaden',
        location: 'Valby',
        link: 'https://drive.google.com/drive/folders/14y41MNrltCvXqAg908-lhb-BuWGFGeIC?usp=sharing'
      }, {
        region: 'Nordsjælland',
        location: 'Hillerød',
        link: 'https://drive.google.com/drive/folders/1NXiNVcUVaA8-BhbkoHG76zan4BYvA4Fx?usp=sharing'
      }],
      EventsImagesData2022: [{
        region: 'west',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1gxqIVum_74-es4BYUnV8MYGmOSj-O-9q?usp=sharing'
      }, {
        region: 'east',
        location: 'Randers',
        link: 'https://drive.google.com/drive/folders/1fBBB83LOCvg77sZNkVF1BVrVu42vXksN?usp=sharing'
      }],
      primaryBranchetext: ''
    };
  },

  methods: {
    nobadgeprisen: function nobadgeprisen() {
      this.nowinnerbadge = true;
      this.show = false;
      this.displayAllBadges = false;
    },
    showtak: function showtak() {
      this.show = false;
      this.nowinnerbadge = true;
    },
    getbitrixprofile: function getbitrixprofile() {
      var _this = this;

      this.show = true;
      var data = {};
      this.$http.get('https://bitrixapi.haandvaerker.dk/v1/supplier/GetSupplierProfileById/' + this.haaId, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success && res.data !== null) {
          var badgesListstreamer = res.data.c_prisen_result;
          var badgesListmerge = res.data.mergedBadges;
          var badgesList = res.data.c_prisen_result;
          var primary = res.data.c_primary_industry.BRANCH_ID;
          _this.primaryBranchetext = res.data.c_primary_industry.BUSINESS;

          var klimafilteredBadge = res.data.c_supplier_badge.filter(function (property) {
            return property['BADGE_TYPE'] === 'craftsman-education' && property['TITLE'] === 'Klima' && property['IS_OK'] === true;
          });
          _this.klimabadge = klimafilteredBadge;
          if (_this.klimabadge.length > 0) {
            _this.displayklimaBadge();
          }

          if (badgesList.length === 0) {
            _this.nobadgeprisen();
            _this.show = true;
            return false;
          }
          if (badgesList.length === 0 && klimafilteredBadge.length === 0) {
            _this.showtak();
            _this.show = true;
            return false;
          }

          var badgeids = [];
          badgesListmerge.forEach(function (property, index) {
            badgeids.push(index + 1);
          });
          badgesList.forEach(function (property, index) {
            badgeids.push(badgeids.length + 1);
          });
          _this.badgemailsignature = badgeids;
          _this.badges = badgeids;

          var thisVar = _this;
          _this.loopStatusCheck = window.setInterval(function () {
            thisVar.checkImgStatus('streamer');
            thisVar.checkImgStatus('klima');
          }, 2000);
        } else {
          _this.$message({
            type: 'error',
            message: 'Error in getbitrixprofile() ' + res.message
          });
          _this.showtak();
          _this.show = false;
        }
      }, function (err) {
        _this.$message({
          type: 'error',
          message: 'Error in getbitrixprofile() ' + err.body.message
        });
        _this.show = false;
      });
    },
    getBadgesCount: function getBadgesCount() {
      var _this2 = this;

      this.show = true;

      var data = {
        operation: 'oversigt_getsupplierprofilebyid',
        levid: this.haaId,
        salesPerson: this.salesPerson
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var badgesList = res.Badges;
        var filteredBadges = badgesList.filter(function (property) {
          return property['Industry'] != null;
        });
        var klimafilteredBadge = badgesList.filter(function (property) {
          return property['BadgeType'] === 'craftsman-education' && property['Title'] === 'Klima' && property['IsOK'] === true;
        });

        _this2.klimabadge = klimafilteredBadge;
        if (_this2.klimabadge.length > 0) {
          _this2.displayklimaBadge();
        }
        if (filteredBadges.length === 0 && klimafilteredBadge.length === 0) {
          _this2.showtak();
          return false;
        }
        if (filteredBadges.length === 0) {
          _this2.nobadgeprisen();
          return false;
        }
        if (filteredBadges.length === 0 && klimafilteredBadge.length === 0) {
          _this2.showtak();
          return false;
        }
        var badgesArr = _this2.mergedBadges(filteredBadges);
        _this2.badgesIndustryData = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(badgesArr);
        var badgesCount = 0;
        for (var badge in badgesArr) {
          var region = badge.split(' ');
          _this2.badgeRegion = region[1];
          badgesCount++;
        }
        _this2.badges = badgesCount;
        var thisVar = _this2;
        _this2.loopStatusCheck = window.setInterval(function () {
          thisVar.checkImgStatus('streamer');
          thisVar.checkImgStatus('klima');
        }, 2000);
      }, function (err) {
        console.log('Error in getBadgesCount()', err);
        _this2.show = false;
      });
    },
    getstreamerbadge: function getstreamerbadge(badgearr) {
      var items = badgearr.filter(function (a) {
        return a.PRISEN_ID !== null && typeof a.PRISEN_ID !== 'undefined';
      });
      badgearr = items;
      var mergebadgeestreamer = this.mergedBadgesbitrixstreamer(badgearr);
      var objectdata = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(mergebadgeestreamer);
      objectdata.forEach(function (a) {
        var badgsplits = a.split(',');
        if (badgsplits.length > 1) {
          var rowboligs = {
            'INDUSTRY_ID': parseInt(badgsplits[badgsplits.length - 2]),
            'AREA': badgsplits[badgsplits.length - 1].split('-')[0]
          };
          badgearr.unshift(rowboligs);
        }
      });
      this.badgesIndustryDatstreamer = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(mergebadgeestreamer);
      return badgearr;
    },
    gotoArtikel: function gotoArtikel() {
      this.$router.push('/artikel');
    },
    displayklimaBadge: function displayklimaBadge() {
      document.getElementById('klimabadge').classList.remove('hide');
    },
    displaybadgerendere: function displaybadgerendere(badgetype, index) {
      var imagesmail = document.getElementById(badgetype + '-' + index);
      var itemarr = this.badgemailsignature.length;
      var lastitemmail = this.badgemailsignature[itemarr - 1];
      imagesmail.classList.remove('hide');
      if (lastitemmail === index) {
        this.show = false;
      }
    },
    displayBadges: function displayBadges(badge, badgesCount) {
      if (badge === 'streamer') {
        document.getElementById('badgesImages').classList.remove('hide');
        this.getEventImages();
        this.show = false;
      }
    },
    checkImgStatus: function checkImgStatus(badge) {
      var _this3 = this;

      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (badge === 'mail' || badge === 'mailsmall') {
        var m = this;
        this.badgemailsignature.forEach(function (a) {
          _this3.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/' + m.haaId + '/' + a + '.jpg', index);
          _this3.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/' + m.haaId + '/' + a + '.jpg', index);
        });
      } else if (badge === 'klima') {
        this.getStatus(badge, 'https://widget.haandvaerker.dk/klima/rendered/klima_' + this.haaId + '.jpg');
      } else {
        var mm = this;
        this.badges.forEach(function (b) {
          _this3.getStatus(badge, 'https://widget.haandvaerker.dk/prisen/winnersBadge/' + badge + '/rendered/' + mm.haaId + '/' + b + '.jpg');
        });
      }
    },
    getStatus: function getStatus(badge, url) {
      var index = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      var request = new XMLHttpRequest();
      var thisVar = this;

      request.onreadystatechange = function () {
        if (request.readyState === 4) {
          if (request.status === 200) {
            if (badge === 'mail') {
              clearInterval(thisVar.loopStatusCheckbadgemail);
              var imagesmail = document.getElementById('imagemail-' + index);
              imagesmail.classList.remove('hide');
              thisVar.displayAllBadges = true;
            }
            if (badge === 'mailsmall') {
              clearInterval(thisVar.loopStatusCheckbadgesmall);
              var imagesmailsmall = document.getElementById('imagemailsmall-' + index);
              imagesmailsmall.classList.remove('hide');
              thisVar.displayAllBadges = true;
            }
            if (badge === 'streamer') {
              clearInterval(thisVar.loopStatusCheck);
              thisVar.displayAllBadges = true;
            }
          } else {
            if (badge === 'mail') {
              thisVar.renderMail = true;
            } else if (badge === 'mailsmall') {
              thisVar.renderMailSmall = true;
            } else if (badge === 'klima') {
              thisVar.renderklima = true;
            } else {
              thisVar.renderStreamer = true;
            }
          }
        }
      };
      request.open('GET', url, true);
      request.send();
    },
    downloadBadge: function downloadBadge(url, title) {
      var _this4 = this;

      this.disableDownloadBtn = true;
      var data = {
        operation: 'badgeDownload',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        url: url
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this4.$router.push('/login');
        }
        if (res.success) {
          var linkSource = 'data:image/png;base64,' + encodeURI(res.url);
          var downloadLink = document.createElement('a');
          var fileName = 'badge_' + _this4.partnerName + '.png';
          downloadLink.href = linkSource;
          downloadLink.download = fileName;
          downloadLink.click();
          _this4.disableDownloadBtn = false;
        } else {
          _this4.disableDownloadBtn = false;
          console.log('Error in downloadBadge()', response);
        }
      }, function (err) {
        _this4.disableDownloadBtn = false;
        console.log('Error in downloadBadge()', err);
      });
    },
    mergedBadgesbitrixmail: function mergedBadgesbitrixmail(filteredBadges) {
      var industryid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      var industryAreaYear = [];
      var badgeplace = '';
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i]['INDUSTRY_NAME'] === 'TV inspektion') {
          filteredBadges[i]['INDUSTRY_NAME'] = 'TVInspektion';
        }
        badgeplace = filteredBadges[i]['PLACE'];
        if (filteredBadges[i]['PLACE'] > 1) {
          badgeplace = 'Finalist';
        }
        var temp = filteredBadges[i]['INDUSTRY_NAME'] + '' + filteredBadges[i]['AREA'].replace('Region', '') + ' ' + badgeplace + ' ' + industryid;
        if (typeof industryAreaYear[temp] === 'undefined') {
          industryAreaYear[temp] = filteredBadges[i]['YEAR'] + '-' + badgeplace + '-' + badgeplace + '-' + filteredBadges[i]['AREA'].replace('Region', '');
        } else {
          industryAreaYear[temp] = industryAreaYear[temp] + ',' + filteredBadges[i]['YEAR'] + '-' + badgeplace + '-' + filteredBadges[i]['AREA'].replace('Region', '');
        }
      }
      return industryAreaYear;
    },
    mergedBadgesbitrixstreamer: function mergedBadgesbitrixstreamer(filteredBadgess) {
      var items = filteredBadgess.filter(function (a) {
        return a.PRISEN_ID !== null && typeof a.PRISEN_ID !== 'undefined';
      });
      filteredBadgess = items;
      var industryAreaYears = [];
      for (var e = 0; e < filteredBadgess.length; e++) {
        if (filteredBadgess[e]['INDUSTRY_NAME'] === 'TV inspektion') {
          filteredBadgess[e]['INDUSTRY_NAME'] = 'TVInspektion';
        }
        var badgeplace = filteredBadgess[e]['PLACE'];
        if (filteredBadgess[e]['PLACE'] > 1) {
          badgeplace = 'Finalist';
        }
        var temps = filteredBadgess[e]['INDUSTRY_NAME'] + '' + filteredBadgess[e]['AREA'].replace('Region', '') + ' ' + badgeplace;
        if (typeof industryAreaYears[temps] === 'undefined') {
          industryAreaYears[temps] = filteredBadgess[e]['YEAR'] + '-' + badgeplace;
        } else {
          industryAreaYears[temps] = industryAreaYears[temps] + ',' + filteredBadgess[e]['YEAR'] + '-' + badgeplace;
        }
      }
      return industryAreaYears;
    },
    mergedBadges: function mergedBadges(filteredBadges) {
      var industryAreaYear = [];
      for (var i = 0; i < filteredBadges.length; i++) {
        if (filteredBadges[i]['Industry'] === 'TV inspektion') {
          filteredBadges[i]['Industry'] = 'TVInspektion';
        }
        var temp = filteredBadges[i]['Industry'] + '' + filteredBadges[i]['Area'].replace('Region', '') + ' ' + filteredBadges[i]['Position'];
        if (industryAreaYear[temp] !== null) {
          industryAreaYear[temp] = filteredBadges[i]['BadgeYear'] + '-' + filteredBadges[i]['Position'];
        } else {
          industryAreaYear[temp] = industryAreaYear[temp] + ',' + filteredBadges[i]['BadgeYear'] + '-' + filteredBadges[i]['Position'];
        }
      }
      return industryAreaYear;
    },
    getEventImages: function getEventImages() {
      var events = this.EventsImagesData;
      for (var i = 0; i < events.length; i++) {
        if (events[i].region === this.badgeRegion) {
          document.getElementById('eventsImages').href = events[i].link;
          this.eventLocation = events[i].location;
        }
      }
    }
  },
  created: function created() {
    this.partnerName = localStorage.getItem('CompanyName');
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.getbitrixprofile();
  }
});

/***/ }),
/* 1447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4 notosans",attrs:{"id":"digital-pakke"}},[_c('div',{staticClass:"clearfix adjust"},[_c('div',{staticClass:"flex flex-wrap justify-start mt2 mb2"},[_c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 darkblue semi-bold"},[_vm._v("\n            Digital pakke\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex col-12"},[_c('div',{staticClass:"col-12 pt3 pb3 flex flex-column px0"},[_c('div',{},[_c('button',{staticClass:"action-button p2 flex justify-start items-center h5 line-height-1",on:{"click":function($event){return _vm.gotoArtikel()}}},[_vm._v(" Download din personlige pressemeddelelse")])]),_vm._v(" "),_c('a',{staticClass:"green mr4 no-underline",attrs:{"type":"button","href":"static/pdf/Guide_digital_pakke_(til vindere).pdf","download":""}},[_c('p',{staticClass:"h5 line-height-1 flex items-center mt3"},[_c('span',{staticClass:"inline-block mr1"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"2px"},attrs:{"fill":"currentColor","height":"24","viewBox":"-58 1 511 511.999","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m392.527344 431.265625-21.027344-35.050781 21.023438-35.050782c4.800781-7.996093 4.921874-17.617187.324218-25.734374-4.59375-8.117188-12.90625-12.960938-22.234375-12.960938h-24.4375v-270.570312c0-28.617188-23.28125-51.898438-51.898437-51.898438h-176.113282c-7.40625 0-14.625 1.753906-21.117187 4.996094-.035156.015625-.070313.027344-.105469.042968-.039062.023438-.074218.042969-.113281.0625-.382813.195313-.757813.402344-1.132813.605469-.324218.175781-.648437.347657-.96875.527344-.335937.191406-.660156.390625-.992187.589844-.363281.21875-.726563.441406-1.082031.667969-.285156.183593-.566406.371093-.847656.5625-.394532.261718-.785157.53125-1.171876.808593-.246093.175781-.492187.355469-.738281.539063-.410156.304687-.8125.621094-1.214843.9375-.21875.175781-.433594.347656-.648438.523437-.417969.347657-.828125.703125-1.234375 1.0625-.191406.171875-.386719.335938-.574219.511719-.429687.394531-.851562.800781-1.265625 1.210938-.15625.15625-.316406.300781-.46875.457031-.5625.574219-1.113281 1.15625-1.648437 1.757812l-23.46875 26.402344-46.9375 52.800781c-.0625.070313-.121094.144532-.183594.21875-.390625.445313-.777344.894532-1.152344 1.355469-.183594.226563-.359375.460937-.539062.691406-.242188.308594-.484375.617188-.71875.929688-.222656.296875-.429688.597656-.644532.898437-.175781.25-.355468.496094-.527343.75-.242188.359375-.476563.722656-.710938 1.085938-.121093.195312-.25.386718-.371093.582031-.261719.425781-.515626.855469-.761719 1.285156-.078125.132813-.15625.265625-.230469.402344-.277344.488281-.542969.984375-.800781 1.484375-.039063.070312-.074219.140625-.109375.210938-.285156.554687-.558594 1.117187-.816406 1.683593-.007813.011719-.011719.023438-.019532.035157-2.835937 6.15625-4.347656 12.890624-4.347656 19.785156v333.636718c0 28.617188 23.28125 51.898438 51.898438 51.898438h241.882812c25.242188 0 46.328125-18.125 50.945312-42.039062h25.390626c9.324218 0 17.636718-4.847657 22.234374-12.964844 4.59375-8.113282 4.472657-17.734375-.324218-25.730469zm-301.09375-394.964844v59.34375c0 3.667969-2.984375 6.652344-6.652344 6.652344h-52.015625zm202.84375 455.699219h-241.878906c-17.589844 0-31.902344-14.308594-31.902344-31.898438v-333.636718c0-1.402344.117187-2.796875.328125-4.167969h63.957031c14.695312 0 26.652344-11.957031 26.652344-26.652344v-74.789062c2.179687-.558594 4.441406-.855469 6.730468-.855469h176.113282c17.589844 0 31.898437 14.308594 31.898437 31.898438v270.570312h-175.417969c-13.046874 0-23.664062 10.617188-23.664062 23.664062v85.160157c0 21.320312 17.34375 38.667969 38.664062 38.667969h158.859376c-4.164063 12.777343-16.191407 22.039062-30.339844 22.039062zm81.167968-44.855469c-.480468.847657-1.910156 2.816407-4.832031 2.816407h-204.855469c-1.929687 0-3.792968-.292969-5.542968-.839844-7.59375-2.367188-13.125-9.464844-13.125-17.828125v-85.15625c0-2.023438 1.648437-3.667969 3.667968-3.667969h219.855469c2.921875 0 4.351563 1.96875 4.832031 2.816406.480469.84375 1.433594 3.085938-.070312 5.589844l-22.308594 37.191406c-3.015625 5.027344-3.015625 11.273438 0 16.292969l22.308594 37.191406c1.503906 2.507813.550781 4.746094.070312 5.59375zm0 0"}}),_c('path',{attrs:{"d":"m176.308594 414.75c-2.109375 0-3.902344.769531-5.324219 2.285156-1.398437 1.488282-2.109375 3.296875-2.109375 5.375 0 2.082032.707031 3.890625 2.109375 5.378906 1.421875 1.515626 3.214844 2.285157 5.324219 2.285157 1.996094 0 3.742187-.785157 5.195312-2.328125 1.429688-1.519532 2.152344-3.3125 2.152344-5.335938 0-2.082031-.726562-3.894531-2.164062-5.390625-1.453126-1.503906-3.195313-2.269531-5.183594-2.269531zm0 0"}}),_c('path',{attrs:{"d":"m215.964844 360.277344h-18.21875c-1.703125 0-3.117188.492187-4.214844 1.46875-1.128906 1.003906-1.726562 2.269531-1.726562 3.65625v58.914062c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921874 1.199219 1.828126 0 3.464844-.398438 4.859376-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-19.527344h8.652343c6.742188 0 12.269531-1.796874 16.425781-5.34375 4.226563-3.601562 6.371094-9.230468 6.371094-16.730468v-.542969c0-7.425781-2.0625-13.003906-6.128906-16.578125-4.007812-3.527344-9.375-5.316406-15.941406-5.316406zm7.289062 23.34375c0 3.03125-.699218 5.304687-2.082031 6.761718-1.378906 1.453126-3.320313 2.160157-5.933594 2.160157h-8.652343v-18.933594h8.652343c2.613281 0 4.554688.707031 5.933594 2.160156 1.382813 1.457031 2.082031 3.734375 2.082031 6.761719zm0 0"}}),_c('path',{attrs:{"d":"m284.191406 365.625c-4.132812-3.546875-9.675781-5.347656-16.476562-5.347656h-16.042969c-1.835937 0-3.390625.46875-4.617187 1.386718-1.691407 1.273438-2.046876 2.734376-2.046876 3.738282v59.003906c0 1.003906.355469 2.46875 2.046876 3.734375 1.226562.921875 2.78125 1.390625 4.617187 1.390625h16.042969c6.804687 0 12.347656-1.800781 16.476562-5.347656 4.195313-3.605469 6.320313-9.292969 6.320313-16.90625v-24.746094c0-7.609375-2.125-13.300781-6.320313-16.90625zm-8.460937 41.652344c0 6.085937-2.546875 8.921875-8.015625 8.921875h-7.925782v-42.589844h7.925782c5.46875 0 8.015625 2.835937 8.015625 8.921875zm0 0"}}),_c('path',{attrs:{"d":"m338.589844 360.277344h-31.632813c-1.675781 0-3.171875.417968-4.4375 1.238281-1.457031.941406-2.226562 2.316406-2.226562 3.976563v58.824218c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921875 1.199219 1.828125 0 3.464844-.398438 4.859375-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-23.335937h12.367187c1.640625 0 2.988282-.691407 3.902344-1.996094.8125-1.160156 1.222656-2.515625 1.222656-4.035156 0-1.636719-.410156-3.054688-1.222656-4.210938-.914062-1.308593-2.261719-2-3.902344-2h-12.367187v-15.128906h23.515625c1.671875 0 3.039062-.777344 3.949218-2.25.78125-1.261719 1.175782-2.777344 1.175782-4.507813 0-1.660156-.378906-3.125-1.125-4.355468-.878906-1.449219-2.261719-2.21875-4-2.21875zm0 0"}}),_c('path',{attrs:{"d":"m91.839844 166h163.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m255.050781 206h-.023437c-5.523438 0-9.988282 4.476562-9.988282 10s4.488282 10 10.011719 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m91.839844 226h123.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-123.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m265.050781 276c0-5.523438-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h163.210937c5.523438 0 10-4.476562 10-10zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Download din guide her (til vindere)")])])]),_vm._v(" "),_c('a',{staticClass:"green no-underline",attrs:{"type":"button","href":"static/pdf/Guide_digital_pakke_(til finalister).pdf","download":""}},[_c('p',{staticClass:"h5 line-height-1 flex items-center mt3"},[_c('span',{staticClass:"inline-block mr1"},[_c('svg',{staticClass:"relative",staticStyle:{"top":"2px"},attrs:{"fill":"currentColor","height":"24","viewBox":"-58 1 511 511.999","width":"24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"m392.527344 431.265625-21.027344-35.050781 21.023438-35.050782c4.800781-7.996093 4.921874-17.617187.324218-25.734374-4.59375-8.117188-12.90625-12.960938-22.234375-12.960938h-24.4375v-270.570312c0-28.617188-23.28125-51.898438-51.898437-51.898438h-176.113282c-7.40625 0-14.625 1.753906-21.117187 4.996094-.035156.015625-.070313.027344-.105469.042968-.039062.023438-.074218.042969-.113281.0625-.382813.195313-.757813.402344-1.132813.605469-.324218.175781-.648437.347657-.96875.527344-.335937.191406-.660156.390625-.992187.589844-.363281.21875-.726563.441406-1.082031.667969-.285156.183593-.566406.371093-.847656.5625-.394532.261718-.785157.53125-1.171876.808593-.246093.175781-.492187.355469-.738281.539063-.410156.304687-.8125.621094-1.214843.9375-.21875.175781-.433594.347656-.648438.523437-.417969.347657-.828125.703125-1.234375 1.0625-.191406.171875-.386719.335938-.574219.511719-.429687.394531-.851562.800781-1.265625 1.210938-.15625.15625-.316406.300781-.46875.457031-.5625.574219-1.113281 1.15625-1.648437 1.757812l-23.46875 26.402344-46.9375 52.800781c-.0625.070313-.121094.144532-.183594.21875-.390625.445313-.777344.894532-1.152344 1.355469-.183594.226563-.359375.460937-.539062.691406-.242188.308594-.484375.617188-.71875.929688-.222656.296875-.429688.597656-.644532.898437-.175781.25-.355468.496094-.527343.75-.242188.359375-.476563.722656-.710938 1.085938-.121093.195312-.25.386718-.371093.582031-.261719.425781-.515626.855469-.761719 1.285156-.078125.132813-.15625.265625-.230469.402344-.277344.488281-.542969.984375-.800781 1.484375-.039063.070312-.074219.140625-.109375.210938-.285156.554687-.558594 1.117187-.816406 1.683593-.007813.011719-.011719.023438-.019532.035157-2.835937 6.15625-4.347656 12.890624-4.347656 19.785156v333.636718c0 28.617188 23.28125 51.898438 51.898438 51.898438h241.882812c25.242188 0 46.328125-18.125 50.945312-42.039062h25.390626c9.324218 0 17.636718-4.847657 22.234374-12.964844 4.59375-8.113282 4.472657-17.734375-.324218-25.730469zm-301.09375-394.964844v59.34375c0 3.667969-2.984375 6.652344-6.652344 6.652344h-52.015625zm202.84375 455.699219h-241.878906c-17.589844 0-31.902344-14.308594-31.902344-31.898438v-333.636718c0-1.402344.117187-2.796875.328125-4.167969h63.957031c14.695312 0 26.652344-11.957031 26.652344-26.652344v-74.789062c2.179687-.558594 4.441406-.855469 6.730468-.855469h176.113282c17.589844 0 31.898437 14.308594 31.898437 31.898438v270.570312h-175.417969c-13.046874 0-23.664062 10.617188-23.664062 23.664062v85.160157c0 21.320312 17.34375 38.667969 38.664062 38.667969h158.859376c-4.164063 12.777343-16.191407 22.039062-30.339844 22.039062zm81.167968-44.855469c-.480468.847657-1.910156 2.816407-4.832031 2.816407h-204.855469c-1.929687 0-3.792968-.292969-5.542968-.839844-7.59375-2.367188-13.125-9.464844-13.125-17.828125v-85.15625c0-2.023438 1.648437-3.667969 3.667968-3.667969h219.855469c2.921875 0 4.351563 1.96875 4.832031 2.816406.480469.84375 1.433594 3.085938-.070312 5.589844l-22.308594 37.191406c-3.015625 5.027344-3.015625 11.273438 0 16.292969l22.308594 37.191406c1.503906 2.507813.550781 4.746094.070312 5.59375zm0 0"}}),_c('path',{attrs:{"d":"m176.308594 414.75c-2.109375 0-3.902344.769531-5.324219 2.285156-1.398437 1.488282-2.109375 3.296875-2.109375 5.375 0 2.082032.707031 3.890625 2.109375 5.378906 1.421875 1.515626 3.214844 2.285157 5.324219 2.285157 1.996094 0 3.742187-.785157 5.195312-2.328125 1.429688-1.519532 2.152344-3.3125 2.152344-5.335938 0-2.082031-.726562-3.894531-2.164062-5.390625-1.453126-1.503906-3.195313-2.269531-5.183594-2.269531zm0 0"}}),_c('path',{attrs:{"d":"m215.964844 360.277344h-18.21875c-1.703125 0-3.117188.492187-4.214844 1.46875-1.128906 1.003906-1.726562 2.269531-1.726562 3.65625v58.914062c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921874 1.199219 1.828126 0 3.464844-.398438 4.859376-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-19.527344h8.652343c6.742188 0 12.269531-1.796874 16.425781-5.34375 4.226563-3.601562 6.371094-9.230468 6.371094-16.730468v-.542969c0-7.425781-2.0625-13.003906-6.128906-16.578125-4.007812-3.527344-9.375-5.316406-15.941406-5.316406zm7.289062 23.34375c0 3.03125-.699218 5.304687-2.082031 6.761718-1.378906 1.453126-3.320313 2.160157-5.933594 2.160157h-8.652343v-18.933594h8.652343c2.613281 0 4.554688.707031 5.933594 2.160156 1.382813 1.457031 2.082031 3.734375 2.082031 6.761719zm0 0"}}),_c('path',{attrs:{"d":"m284.191406 365.625c-4.132812-3.546875-9.675781-5.347656-16.476562-5.347656h-16.042969c-1.835937 0-3.390625.46875-4.617187 1.386718-1.691407 1.273438-2.046876 2.734376-2.046876 3.738282v59.003906c0 1.003906.355469 2.46875 2.046876 3.734375 1.226562.921875 2.78125 1.390625 4.617187 1.390625h16.042969c6.804687 0 12.347656-1.800781 16.476562-5.347656 4.195313-3.605469 6.320313-9.292969 6.320313-16.90625v-24.746094c0-7.609375-2.125-13.300781-6.320313-16.90625zm-8.460937 41.652344c0 6.085937-2.546875 8.921875-8.015625 8.921875h-7.925782v-42.589844h7.925782c5.46875 0 8.015625 2.835937 8.015625 8.921875zm0 0"}}),_c('path',{attrs:{"d":"m338.589844 360.277344h-31.632813c-1.675781 0-3.171875.417968-4.4375 1.238281-1.457031.941406-2.226562 2.316406-2.226562 3.976563v58.824218c0 1.179688.429687 2.835938 2.46875 4.015625 1.371093.796875 3.027343 1.199219 4.921875 1.199219 1.828125 0 3.464844-.398438 4.859375-1.191406 2.09375-1.179688 2.53125-2.839844 2.53125-4.023438v-23.335937h12.367187c1.640625 0 2.988282-.691407 3.902344-1.996094.8125-1.160156 1.222656-2.515625 1.222656-4.035156 0-1.636719-.410156-3.054688-1.222656-4.210938-.914062-1.308593-2.261719-2-3.902344-2h-12.367187v-15.128906h23.515625c1.671875 0 3.039062-.777344 3.949218-2.25.78125-1.261719 1.175782-2.777344 1.175782-4.507813 0-1.660156-.378906-3.125-1.125-4.355468-.878906-1.449219-2.261719-2.21875-4-2.21875zm0 0"}}),_c('path',{attrs:{"d":"m91.839844 166h163.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m255.050781 206h-.023437c-5.523438 0-9.988282 4.476562-9.988282 10s4.488282 10 10.011719 10c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10zm0 0"}}),_c('path',{attrs:{"d":"m91.839844 226h123.210937c5.523438 0 10-4.476562 10-10s-4.476562-10-10-10h-123.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10zm0 0"}}),_c('path',{attrs:{"d":"m265.050781 276c0-5.523438-4.476562-10-10-10h-163.210937c-5.519532 0-10 4.476562-10 10s4.480468 10 10 10h163.210937c5.523438 0 10-4.476562 10-10zm0 0"}})])]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Download din guide her (til finalister)")])])])])])])]),_vm._v(" "),(_vm.renderMail)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/mailSignaturePng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),(_vm.renderMailSmall)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/mailSignaturePng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),(_vm.renderStreamer)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/streamerPng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),(_vm.renderklima)?_c('img',{staticClass:"hide",attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/klima/klimaPng.php?id='+_vm.haaId}}):_vm._e(),_vm._v(" "),_c('div',{staticClass:"hide col-12",attrs:{"id":"klimabadge"}},[_c('div',{staticClass:"no-underline flex flex-column mr-auto green-background justify-center items-center lg-col-4 md-col-5 white p1 overflow-hidden imageShadow badgeImg background-cover relative imageShadow mr1",staticStyle:{"background-repeat":"no-repeat","background-position":"top center","height":"clamp(300px,25vw,480px)","border-radius":"30px"},attrs:{"href":"/Klima"}},[_c('div',{staticClass:"center mb3 absolute top-0",staticStyle:{"top":"6%"}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"Layer_1","alt":"klima badge","role":"img","data-name":"Layer 1","width":"clamp(110px,18vw,180px)","viewBox":"0 0 977.57 1200"}},[_c('path',{attrs:{"fill":"#fff","d":"M977,179.83c-30.21,69.82-149.92,308.36-337.51,204.84-5.49-3-4.64-11.11,1.46-12.52,72.29-16.63,192.44-56.39,266.43-145.69,0,0-93,91.87-270.62,112.24h-.07c-.08,0-.25,0-.46.05-.67.08-18.73,3-30,10.29,5-12.93,9.75-33.62,13.95-44.66,73.76-190.7,247.27-85.26,347.56-133C973.43,168.67,979.49,174.05,977,179.83Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#fff","d":"M513.86,7c49.11,40.64,193,176.39,82.6,292.82-4.3,4.54-12,1.43-11.73-4.81,2.42-58.54-3-154.9-53.48-228,0,0,49.55,89.66,27.17,228V295q0,.11-.06.36c-.09.52-1.72,14.76,1.39,24.81-6.44,2.39-23.3-14.5-30.73-20C402.67,205.4,513.94,98.64,503.08,13.43,502.29,7.22,509.05,3,513.86,7Z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#fff","d":"M869.63,562,437.12,244,4.6,562v638H312.25V958.59H554.62v155.05h-.27V1200H869.63Zm-86.19,551.63H646.13V675.36l-91.51-67.28v258H312.25V611.61L220.74,678.9v434.74H90.8V605.75l.49-.36-.07-.08L396.49,380.85l.07.07,40.56-29.82L783.44,605.75Z"}})])]),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_c('button',{staticClass:"action-button p2 flex justify-start items-center h5 line-height-1 mr-auto my3",attrs:{"disabled":_vm.disableDownloadBtn},on:{"click":function($event){return _vm.downloadBadge('https://widget.haandvaerker.dk/klima/rendered/klima_'+_vm.haaId+'.jpg', 'klima_'+_vm.haaId)}}},[_c('span'),_c('span',[_vm._v("Download klimamærke")])])]),_vm._v(" "),(_vm.show)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_vm._e(),_vm._v(" "),(_vm.displayAllBadges)?_c('div',{staticClass:"hide",attrs:{"id":"badgesImages"}},[_c('div',{staticClass:"col-12 flex m0 p0 mb2"},[_c('a',{staticClass:"action-button  p2 h5 line-height-1 mx2 mb2",attrs:{"type":"button","href":"https://drive.google.com/drive/folders/1gxqIVum_74-es4BYUnV8MYGmOSj-O-9q?usp=sharing","target":"_blank"}},[_c('div',{staticClass:"inline-block"},[_c('p',{staticClass:"line-height-1 flex items-center m0"},[_c('span',{staticClass:"inline-block mr1 relative"},[_c('svg',{staticClass:"feather feather-download",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24 24","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}}),_c('polyline',{attrs:{"points":"7 10 12 15 17 10"}}),_c('line',{attrs:{"x1":"12","y1":"15","x2":"12","y2":"3"}})])]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Billeder fra Herlev")])])])]),_vm._v(" "),_c('a',{staticClass:"action-button  p2 h5 line-height-1 no-hover mx2 mb2",attrs:{"type":"button","href":"https://drive.google.com/drive/folders/1viPxZEyPC4CMOf1XyhsVT1s-i5P6Bdf-?usp=sharing","target":"_blank"}},[_c('div',{staticClass:"inline-block"},[_c('p',{staticClass:"line-height-1 flex items-center m0"},[_c('span',{staticClass:"inline-block mr1 relative"},[_c('svg',{staticClass:"feather feather-download",attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 24 24","fill":"#fff","stroke":"#fff","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}}),_c('polyline',{attrs:{"points":"7 10 12 15 17 10"}}),_c('line',{attrs:{"x1":"12","y1":"15","x2":"12","y2":"3"}})])]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Billeder fra Aarhus")])])])])]),_vm._v(" "),_vm._l((_vm.badgemailsignature),function(badge,index){return _c('div',{key:index,staticClass:"col-12 flex flex-wrap mb2"},[_c('div',{staticClass:"col-12 px0 flex mobile-flex-column md-flex-column"},[_c('div',{staticClass:"col-6 px0"},[_c('div',{staticClass:"hide",attrs:{"id":'mail-'+badge}},[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"mb2"},[_c('img',{attrs:{"src":'https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/'+_vm.haaId+'/'+badge+'.jpg'},on:{"load":function($event){return _vm.displaybadgerendere('mail', badge)}}})]),_vm._v(" "),_c('div',[_c('button',{staticClass:"action-button p2 flex justify-start items-center h5 line-height-1",attrs:{"disabled":_vm.disableDownloadBtn},on:{"click":function($event){return _vm.downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/mail/rendered/'+_vm.haaId+'/'+badge+'.jpg', _vm.badgesIndustryDatamail[index])}}},[_c('span'),_c('span',[_vm._v("Download mailsignatur")])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-5 px2 mdpo"},[_c('div',{staticClass:"hide",attrs:{"id":'mailsmall-'+badge}},[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"mb2"},[_c('img',{attrs:{"src":'https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/'+_vm.haaId+'/'+badge+'.jpg'},on:{"load":function($event){return _vm.displaybadgerendere('mailsmall', badge)}}})]),_vm._v(" "),_c('div',[_c('button',{staticClass:"action-button p2 flex justify-start items-center h5 line-height-1",attrs:{"disabled":_vm.disableDownloadBtn},on:{"click":function($event){return _vm.downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/mailsmall/rendered/'+_vm.haaId+'/'+badge+'.jpg', _vm.badgesIndustryDatasmallmail[index])}}},[_c('span'),_c('span',[_vm._v("Download mailsignatur")])])])])])])])])}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap md-flex-column"},_vm._l((_vm.badges),function(badge,index){return _c('div',{key:index+'-'+badge,staticClass:"md-col-6 lg-col-6 sm-col-12 xs-col-12 mb2 badgeside"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0"},[_c('div',[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"mb2"},[_c('img',{attrs:{"rel":"preload","src":'https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/'+_vm.haaId+'/'+badge+'.jpg'},on:{"load":function($event){return _vm.displayBadges('streamer', badge)}}})]),_vm._v(" "),_c('div',[_c('button',{staticClass:"action-button p2 flex justify-start items-center h5 line-height-1",attrs:{"disabled":_vm.disableDownloadBtn},on:{"click":function($event){return _vm.downloadBadge('https://widget.haandvaerker.dk/prisen/winnersBadge/streamer/rendered/'+_vm.haaId+'/'+badge+'.jpg', _vm.badgesIndustryData[index])}}},[_c('span'),_c('span',[_vm._v("Download banner til hjemmeside")])])])])])])])])}),0)],2):_vm._e(),_vm._v(" "),(_vm.nowinnerbadge)?_c('div',[_c('span',[_vm._v("Tak for interessen for dine badges. Du kan ringe til vores team om, hvordan du kan få badges til at generere")])]):_vm._e()]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute center bottom-0",staticStyle:{"bottom":"4%"}},[_c('p',{staticClass:"line-height-1 pt1 comely ",staticStyle:{"font-size":"clamp(2em, 2.5vw, 2.5em)","font-family":"comely"}},[_vm._v("Jeg er uddannet")]),_vm._v(" "),_c('p',{staticClass:"line-height-1 p0 mb1 bold ",staticStyle:{"font-size":"clamp(2.3em, 2.8vw, 2.5em)"}},[_vm._v("Klimahåndværker")]),_vm._v(" "),_c('p',{staticClass:"line-height-1 regular h1",staticStyle:{"font-size":"clamp(2em, 2.2vw, 2.3em)"}},[_vm._v("Byg med omtanke")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"center mediumgrey bold"},[_vm._v("Genererer badges ...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1448 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_press_article_vue__ = __webpack_require__(1450);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79794623_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_press_article_vue__ = __webpack_require__(1451);
function injectStyle (ssrContext) {
  __webpack_require__(1449)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_press_article_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_79794623_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_press_article_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1449 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      partnerName: '',
      region: '',
      category: '',
      badgetype: '',
      hasquotetext: '',
      hasquote: false,
      addquote: false,
      yourquote: '',
      Personnavn: '',
      idurl: 'undefined',
      loading: false,
      quote1: '',
      quote2: ''
    };
  },

  methods: {
    openmodalquote: function openmodalquote() {
      this.addquote = true;
    },
    closemodalquote: function closemodalquote() {
      this.addquote = false;
    },
    getquote: function getquote() {
      var _this = this;

      this.loading = true;
      this.salesPerson = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.get(this.$bitrixapi + 'partner/GetQuotes?levid=' + this.haaId, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var data = res.data[0];
        if (res.success && res.data.length > 0) {
          if (data.Comment === '') {
            _this.hasquote = false;
          } else {
            _this.hasquote = true;
            console.log('res.data.Comment', data.Comment);
            var quote = data.Comment.split(' 2. ');
            _this.quote1 = quote[0].substring(3);
            _this.quote2 = quote[1];
          }
          _this.streak = data.YEARS_WON;
          _this.Personnavn = data.UF_CRM_COMPANY_CONTACT_PERSON;
          _this.region = data.Region;
          _this.category = data.Kategori;
          _this.loading = false;
          _this.partnerName = data.Name;
        } else {
          _this.hasquote = false;
          _this.streak = 1;
          _this.Personnavn = localStorage.getItem('name');
          _this.region = localStorage.getItem('prisenRegion');
          _this.category = localStorage.getItem('industryname');
          _this.loading = false;
          _this.partnerName = localStorage.getItem('CompanyName');
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this.refreshtoken();
          setTimeout(function () {
            _this.getquote();
          }, 1000);
        } else {
          _this.loading = false;
          _this.$message({
            type: 'error',
            message: response.body.message
          });
        }
        _this.loading = false;
      });
    },
    refreshtoken: function refreshtoken() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this2.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this2.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this2.$router.push('/login');
      });
    },
    savequote: function savequote() {
      this.hasquote = true;
      this.hasquotetext = this.yourquote;
      this.closemodalquote();
    },
    exportHTML: function exportHTML() {
      var header = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:w="urn:schemas-microsoft-com:office:word" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="utf-8"><title>Prisen Artikel af ' + this.partnerName + '</title><style>*{font-family:font-family: noto-sans,sans-serif!important;}</style></head><body>';
      var footer = '</body></html>';
      var sourceHTML = header + document.getElementById('source-html-' + this.haaId).innerHTML + footer;
      var source = 'data:application/vnd.ms-word;charset=utf-8,' + encodeURIComponent(sourceHTML);
      var fileDownload = document.createElement('a');
      document.body.appendChild(fileDownload);
      fileDownload.href = source;
      fileDownload.download = this.partnerName + '-' + this.category + '.doc';
      fileDownload.click();
      document.body.removeChild(fileDownload);
    }
  },
  created: function created() {
    this.idurl = this.$route.query.haaId;
    if (this.idurl !== null && typeof this.idurl !== 'undefined') {
      this.haaId = this.$route.query.haaId;
    } else {
      this.haaId = localStorage.getItem('haaid');
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.getquote();
  }
});

/***/ }),
/* 1451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4 notosans darkblue",attrs:{"id":"pressArticle"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.loading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',{staticClass:"mx4 mp0"},[(_vm.haaId === '15857')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, som gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt Finlow VVS som den bedste VVS-virksomhed i Region Hovedstaden for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er Finlow VVS, som har vundet i et tæt opløb og dermed valgt af brugerne som Region Hovedstadens bedst anbefalede VVS’er - for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Frank Jensen fra Finlow VVS er naturligvis glad for prisen og udtaler med stor stolthed ved at have vundet endnu engang:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“At vinde Håndværker.dk prisen er stort for vores virksomhed. Det er et cadeau til vores medarbejdere som dagligt gør deres bedste for at servicerer vores kunder ud fra Finlow VVS' værdier - kvalitet, loyalitet og godt håndværk. Vi har vundet prisen 5 år i træk, og det er et vigtigt element i vores markedsføring. Folk ser vores mange gode anbefalinger og ved at vi er en håndværker de kan stole på.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at Finlow VVS bliver ved med at brillere og levere kvalitetshåndværk. Finlow VVS har over 1400 anmeldelser på Håndværker.dk, hvoraf de alle minimum ligger over 4 stjerner. De flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen er et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Finlow VVS gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse - dertil forsøger de konstant at udvikle sig og blive bedre. Finlow VVS er bl.a. uddannet Klimahåndværker. De udtaler om håndværkerfaget:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“I vores foretagende er håndværkerfaget gået i arv. Vi er tredje generations håndværkere og vores virksomhed har eksisteret i mere end 50 år. Hos Finlow VVS ønsker vi at være først med de nyeste udviklinger inden for energi, og vi er stærkt motiveret til at være de bedste. Hos os er godt håndværk en ærefuld opgave og vigtigheden af at være en håndværker man kan stole på ligger vores foretagendes hjerte nært. Energi og teknik er en spændende del af vores samfund og er under konstant udvikling. Det er spændende at få lov til at være med hvor det betyder noget.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget. ")])]):(_vm.haaId === '36910')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',[_vm._v(" Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt HS Gulvservice som den bedste håndværker i sin branche i Region Nordsjælland, for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er HS Gulvservice, som har vundet i et tæt opløb og dermed valgt af brugerne som Region Nordsjællands bedst anbefalede Gulvlægger for femte år i træk. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at HS Gulvservice bliver ved med at brillere og levere kvalitetshåndværk. Deres flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen er et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid. HS Gulvservice har altid stået som den klare vinder i de 5 år Håndværker.dk Prisen har været afholdt. Det er især tydeligt da de har over 230 anmeldelser på Håndværker.dk og en 5-stjernet gennemsnitsscore.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]):(_vm.haaId === '36969')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Lokal håndværker hyldet af brugere")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I den seneste tid har håndværkere over hele landet dystet om at blive den bedst anbefalede i deres region. Brugerne på Håndværker.dk har nu afgjort, hvem de synes er den bedste håndværker og der er valget faldet på Jysk Flise og Fugeteknik i Region Nordjylland.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Fra den 23. april til den 27. maj har brugerne på Håndværker.dk vurderet og anbefalet deres lokale håndværkere. Det har dannet grundlag for uddelingen af Håndværker.dk Prisen 2018. Resultatet er blevet 51 vindere fordelt på 6 regioner i udvalgte brancher. Blandt vinderne er Jysk Flise og Fugeteknik fra Hjallerup, som er blevet valgt af brugerne som “Nordjyllands bedst anbefalede murer”.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Jan Jørgensen fra Jysk Flise og Fugeteknik er naturligvis glad for prisen og udtaler stor glæde ved at have vundet:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Vi er stolte af at blive valgt af brugerne i et skarpt felt af dygtige håndværkere. Det er selvfølgelig ikke noget som vi er kommet let til, vi gør meget ud af at sikre at vores kunder er tilfredse og dermed anbefaler os til andre. Prisen her er et skulderklap til os og det er noget som giver lyst til at arbejde videre i samme retning.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("At netop anbefalinger har en stor betydning understreges også af Bolius Boligejerundersøgelsen fra sidste år, hvor 40 % af de adspurgte svarer at det er vigtigt for dem at de har fået håndværkeren anbefalet eller at de har kendskab til virksomheden i forvejen, når de vælger en håndværker. Det er noget Jan Jørgensen også kan nikke genkendende til.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Vi mærker helt klart at det er vigtigt at kunne fremvise gode anbefalinger, men det hænger også sammen med at vi samtidig skal lave et godt stykke arbejde, når vi er ude hos kunderne. På den måde spiller det hele sammen.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet næsten 700 anbefalinger fra brugerne på Håndværker.dk og det har været med til at danne ramme om kåringen.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Her ses vinderne i regionen:")]),_vm._v(" "),_vm._m(2)]):(_vm.haaId === '10205')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v("Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, som gives til den bedst anbefalet Håndværker i regionen. Brugerne har altså givet deres mening til kende, og udnævnt Venslev Tømrer og Snedker som den bedste håndværker i sin branche i Region Nordsjælland, for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er Venslev Tømrer og Snedker, som har vundet i et tæt opløb og blevet valgt af brugerne som Region Nordsjællands bedst anbefalede installatør - for femte år i træk. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Peter Schønemann fra Venslev Tømrer og Snedker,er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet endnu engang:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Det er med stolthed at modtage prisen endnu en gang. Man skal huske på, at det er kundernes blåstempling af det arbejde og den service vi har leveret hos kunderne. Det er kundernes tilfredsheds-barometer der giver denne pris. Vi tror på, at det indledende kundemøde (red. besigtigelse for tilbud) er yderst vigtigt med henblik på tillid og opfattelsen af seriøsitet. Kunden har måske allerede undersøgt os lidt på andres anbefalinger på Håndværker.dk, eller måske gør kunden det efter første møde. Så har kunden hermed en forhåndsviden når et seriøst tilbud fremsendes. At ordren så udføres med kvalitet og akkuratesse, med afsluttende oprydning er en selvfølge. Det giver os altid tilfredse kunder, så jo prisen er meget vigtig for os.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at Venslev Tømrer og Snedker bliver ved med at brillere og levere kvalitetshåndværk. Dertil er de flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop Peter Scnømann gør en stor dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse. Med hænderne rigtigt skruet på og tømrer som forældre, har det altid ligget i kortene at Peter også skulle blive en dygtig håndværker.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Min tilgang til håndværkerfaget kan spores helt tilbage til barndommen med daglige rutiner på forældrenes tømrerværksted. Læretid, svendetid, videreuddannelse og egen virksomhed har været en naturlig udvikling for mig.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget. ")])]):(_vm.haaId === '1371')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v("Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, som gives til den bedst anbefalede Håndværker i regionen. Brugerne har altså givet deres mening til kende, og udnævnt Søften Tagrenovering som den bedste håndværker i sin branche i Region Midtjylland, for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er Søften Tagrenovering fra Region Hovedstaden, som har vundet i et tæt opløb og blevet valgt af brugerne som Region Hovedstadens bedst anbefalede tagspecialister - for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Simon Skjøde & Brian Munk fra Søften Tagrenovering er naturligvis glade for prisen og udtaler med stor stolthed over at have vundet endnu engang:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“At vinde denne pris for 5. gang betyder ligeså meget nu som første gang. Både for os som indehavere samt vores medarbejdere som dagligt gør deres ypperste for, at vores kunder bliver glade og tilfredse. Den tillid som kunderne viser os, ved at vælge netop vores firma blandt en hel masse andre dygtige håndværkere, er vi voldsomt glade for at kunne indfri.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at Søften Tagrenovering bliver ved med at brillere og levere kvalitetshåndværk. Dertil er de flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid. Søften Tagrenovering har over 200 anmeldelser på Håndværker.dk og 100% af deres kunder vil anbefale dem til andre")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Søften Tagrenovering gør en dyd ud af at være de bedste håndværker og give sine kunder den bedste oplevelse.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Grunden til jeg startede sådan et firma her og valgte at arbejde med håndværk, er drevet at lysten og glæden ved at udføre projekter, hvor folk får forandret deres hus til det bedre i form af diverse løsninger med tag, vinduer, kviste, tagrender, isolering og deslige. i sidste ende får de løst et problem som har fyldt hos dem.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget. ")])]):(_vm.haaId === '17584')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v("Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede Håndværker i regionen. Brugerne har altså givet deres mening til kende, og udnævnt Malerfimaet NS som den bedste Maler i Region Hovedstaden for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er Malerfirmaet NS, som har vundet i et tæt opløb og blevet valgt af brugerne som Region hovedstadens bedst anbefalede maler- for femte år i træk .")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Naveed Shahzad fra Malerfirmaet NS er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet endnu engang:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("Jeg driver en ærlig virksomhed og sætter kvalitet over alt.\n            Derfro er det den fedeste følelse at have vundet Håndværker.dk Prisen fem år i træk - det betyder jo, at jeg gør noget rigtigt, og at mine kunder er glade for det, jeg laver. \n            I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende at Malerfirmaet NS bliver ved med at brillere og levere kvalitetshåndværk.\n            Dertil er de flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid.  Håndværker.dk prisen blev for første gang afholdt i 2018 og Malerfirmaet NS har vundet alle 5 år. \n            Malerfirmaet NS gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelser.\n          ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Naveed Shahzad blev maler fordi:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Jeg elsker mit arbejde, og jeg elsker når jeg gør mine kunder får det resultat, de drømmer om.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]):(_vm.haaId === '19887')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("For 5. år i træk løber Patrick Nielsen fra Elternativet med en Håndværker.dk Prisen. Prisen har været afholdt i 5 år, så elektrikeren fra Ballerup opretholder sin stærke position som den førende elektriker i region Hovedstaden. Håndværker.dk Prisen tildeles landets bedste håndværkere, baseret på deres kunders anbefalinger, og det er derfor brugerne der har valgt, at Elternativet igen i år tager en pokal med hjem til samlingen.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I løbet af et helt år indsamler landets håndværkere anbefalinger fra deres kunder, og konkurrerer mod hinanden om at vinde Håndværker.dk Prisen. Håndværker.dk er en platform, der hjælper de danske boligejere med at finde den helt rigtige håndværker til deres næste byggeprojekt. Patrick Nielsen har været medlem siden 2017, og oplever en tættere relation til sine kunder, allerede ved første møde, på grund af sin profilside på Håndværker.dk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På nuværende tidspunkt har Elternativet en score på 4.9 på Håndværker.dk - baseret på hele 512 anbefalinger. Det vidner om, at kunderne er mere end tilfredse med det arbejde, Patrick udfører hos dem.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Patrick fra Elternativet er naturligvis glad for prisen og håber, at det vil sprede et godt budskab om hans virksomhed:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Jeg går meget langt for mine kunder, og jeg går op i, at de føler, de får den bedste service fra Elternativet - hver gang”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I et presset marked, hvor både pandemi, rekordhøje materialepriser og et stigende antal konkurser, formår Patrick at fylde bogen med opgaver, takket være de gode anbefalinger på Håndværker.dk og når naboerne snakker over hækken. De flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen er med til at skabe tillid hos boligejerne om, at der her findes en elektriker, der er til at stole på og som gør sit arbejde grundigt. Derudover er Patrick også autoriseret el-installatør uddannet Klimahåndværker, hvilket betyder, at han besidder en bred viden om bæredygtigt håndværk, som han kan tage med sig i sit arbejde hos kunderne, der på den måde får den løsning, der passer bedst til deres behov og klimaet.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Patrick valgte at blive elektriker fordi:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Jeg kan godt lide at give et godt stykke arbejde, og jeg synes, at elektrikerfaget er meget interessant”")]),_vm._v(" "),_c('h3',[_vm._v(" Blandt de bedste af de bedste")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Udover at Patrick og Elternativet løb af sted med en Håndværker.dk Pris, vandt han også en check fra Airtox på 5.000kr. Præmien kendes som “Airtox Prisen” og gives kun til de bedste håndværkere. Her konkurrerer alle vindere af Håndværker.dk prisen med hinanden, uanset størrelse, da kriterierne her er, at man har et bestemt antal anbefalinger og en gennemsnit rating på minimum 4.8 på konkurrencens sluttidspunkt. Derudover skal man have vundet en Håndværker.dk Pris i årets konkurrence, for at være med i lodtrækningen om Airtox Prisen.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget. ")])]):(_vm.haaId === '210')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt ABC Byg Næstved som den bedste håndværker i sin branche i Region Sjælland for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er ABC Byg Næstved, som har vundet i et tæt opløb og dermed valgt af brugerne som Region Sjællands bedst anbefalede Taglægger - for femte år i træk. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Steen Pedersen fra ABC Byg Næstved er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet endnu engang:")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Håndværker.dk Prisen er et stort skulderklap til os alle i firmaet. Både medarbejderne & ledelse. Det samler hele holdet i en positiv oplevelse og fører en masse spændende opgaver med sig. Så det er med stolthed vi alle tog til Herlev og havde en skøn eftermiddag i et flot arrangement. Vi er enormt glade for de mange flotte anmeldelser, som nu for 5 gang, i træk, har medført at vi er blevet Årets bedste anmeldte tømrer i region Sjælland.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at ABC Byg Næstved bliver ved med at brillere og levere kvalitetshåndværk. De flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen er et stempel i bogen, der skaber tillid mellem håndværker og kunde i en usikker tid. ABC Byg Næstved har over 250 anmeldelser på Håndværker.dk -  og i skrivende stund en score på hele 4.9 stjerner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("ABC Byg Næstved gør en dyd ud af at være den bedste tømrer og give sine kunder den bedste oplevelse. Selvom Steen Pedersen har håndværkere i familien var det ikke på forhånd bestemt, at han skulle blive en dygtig håndværker.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3 italic"},[_vm._v("“Som ung vidste jeg faktisk ikke rigtig hvad jeg ville. Der var så mange muligheder. Da jeg så ikke kunne beslutte mig, valgte jeg at gå i lære som tømrer. Min far havde et lille tømrerfirma i Gelsted. På værkstedet har jeg som ung brugt mange timer på at lave diverse `snedkerier`. Håndelaget for tømrerfaget har altid ligget i hånden. Et par år efter jeg var blevet svend, startede jeg op som selvstændig. Og i 1996 kom Abc Byg til. Det har jeg aldrig fortrudt.”")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget. ")])]):(_vm.haaId === '9722')?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne for 5. år i træk")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværker i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt Aalborg Malerfirma som den bedste håndværker i sin branche i Region Nordjylland for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er Aalborg Malerfirma, som har vundet i et tæt opløb og dermed valgt af brugerne som Region Nordjyllands bedst anbefalede maler- for femte år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at Aalborg Malerfirma bliver ved med at brillere og levere kvalitetshåndværk. De flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen er et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid. Aalborg Malerfirma udfører alle slags maleropgaver og har en rating på Håndværker.dk på hele 4.7 stjerner. Allan Kristensen gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]):(_vm.streak === 2 || _vm.streak === 4)?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[(_vm.streak === 2)?_c('h3',[_vm._v("Din lokale Håndværker - kåret som vinder af brugerne (igen!) ")]):_vm._e(),_vm._v(" "),(_vm.streak === 4)?_c('h3',[_vm._v("Din lokale Håndværker - kåret som vinder af brugerne for 4. år i træk ")]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(", som den bedste håndværker i sin branche i Region "+_vm._s(_vm.region)+" for \n          "),(_vm.streak === 2)?_c('span',[_vm._v("andet")]):_vm._e(),_vm._v(" "),(_vm.streak === 4)?_c('span',[_vm._v("fjerde")]):_vm._e(),_vm._v("\n          år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(" fra "+_vm._s(_vm.region)+", som har vundet i et tæt opløb og dermed valgt af brugerne som “Region "+_vm._s(_vm.region)+" bedst anbefalede "+_vm._s(_vm.category)+" - for \n          "),(_vm.streak === 2)?_c('span',[_vm._v("andet")]):_vm._e(),_vm._v(" "),(_vm.streak === 4)?_c('span',[_vm._v("fjerde")]):_vm._e(),_vm._v("\n          år i træk ”. ")]),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" fra "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(" er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet endnu en gang:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote1)+"”")])]):_vm._e(),_vm._v(" "),(_vm.streak === 2)?_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er håndværkernes anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, der skaber tillid mellem håndværker og kunde i en usikker tid. Netop "+_vm._s(_vm.Personnavn)+" gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse.")]):_vm._e(),_vm._v(" "),(_vm.streak === 4)?_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er det meget imponerende, at "+_vm._s(_vm.partnerName)+" bliver ved med at brillere og levere kvalitetshåndværk. Dertil er håndværkernes flotte anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, som skaber tillid mellem håndværker og kunde i en usikker tid.")]):_vm._e(),_vm._v(" "),(_vm.streak === 4)?_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop "+_vm._s(_vm.Personnavn)+" gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse.")]):_vm._e(),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" blev håndværker fordi:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote2)+"”")])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]):(_vm.streak === 3)?_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som den bedste af brugerne (igen!)")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i landets regioner. Brugerne har altså givet deres mening til kende og udnævnt "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(", som den bedste håndværker i sin branche i Region "+_vm._s(_vm.region)+" for tredje år i træk.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere inden for forskellige branchekategorier og regioner.")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(" fra "+_vm._s(_vm.region)+", som har vundet i et tæt opløb og dermed valgt af brugerne som Region "+_vm._s(_vm.region)+" bedst anbefalede "+_vm._s(_vm.category)+" - for tredje år i træk. ")]),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" fra "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v("  er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet endnu en gang:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote1)+"”")])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er håndværkernes anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, der skaber tillid mellem håndværker og kunde i en usikker tid. Netop "+_vm._s(_vm.Personnavn)+" gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse.")]),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" blev håndværker fordi:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote2)+"”")])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]):_c('div',{staticClass:"max-width-4 flex flex-column gap-30 highlights border-light p4",attrs:{"id":'source-html-' + _vm.haaId}},[_c('h3',[_vm._v(" Din lokale Håndværker - kåret som vinder af brugerne ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Den seneste tid har dygtige håndværkere i hele landet konkurreret om Håndværker.dk Prisen, der gives til den bedst anbefalede håndværker i regionen. Brugerne har altså givet deres mening til kende og udnævnt "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(", som den bedste håndværker\n              i sin branche i Region "+_vm._s(_vm.region))]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Netop anbefalingerne er hele grundlaget for Håndværker.dk Prisen. I årets løb har håndværkere over hele landet indsamlet anbefalinger, hvoraf 159 er blevet kåret som vindere indefor forskellige branchekategorier og regioner. ")]),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("Blandt vinderne er "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(" fra "+_vm._s(_vm.region)+", som har vundet i et tæt opløb og dermed valgt af brugerne som “Region "+_vm._s(_vm.region)+" bedst anbefalede "+_vm._s(_vm.category)+" ”. ")]),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" fra "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.partnerName))]),_vm._v(" er naturligvis glad for prisen og udtaler med stor stolthed over at have vundet:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote1)+"”")])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("I en tid hvor byggebranchen er presset ovenpå pandemien, et usikkert marked, stigende antal konkurser og rekordhøje materialepriser, er håndværkernes anbefalinger og titlen som vinder af Håndværker.dk Prisen et stempel i bogen, der skaber tillid\n              mellem håndværker og kunde i en usikker tid. Netop "+_vm._s(_vm.Personnavn)+" gør en dyd ud af at være den bedste håndværker og give sine kunder den bedste oplevelse.")]),_vm._v(" "),(_vm.hasquote)?_c('h5',{staticClass:"line-height-3"},[_c('p',{},[_vm._v(_vm._s(_vm.Personnavn)+" blev håndværker fordi:")]),_vm._v(" "),_c('p',{staticClass:"line-height-3 italic"},[_vm._v("“"+_vm._s(_vm.quote2)+"”")])]):_vm._e(),_vm._v(" "),_c('h5',{staticClass:"line-height-3"},[_vm._v("På landsplan er der blevet givet over 94.542 anbefalinger fra brugerne på Håndværker.dk, og de mange anbefalinger er blevet verificeret inden de talte med i konkurrencen. På den måde sikres en retfærdig konkurrence i håndværksfaget.")])]),_vm._v(" "),_c('div',{staticClass:"max-width-4 py3 flex justify-end mmx2"},[_c('button',{staticClass:"action-button p2",on:{"click":function($event){return _vm.exportHTML()}}},[_vm._v("Download Dokument")])])]),_vm._v(" "),_c('div',{staticClass:"py4"})]),_vm._v(" "),_c('b-modal',{ref:"reasondeclinemodal",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"reasondeclinemodal","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.addquote),callback:function ($$v) {_vm.addquote=$$v},expression:"addquote"}},[_c('div',{staticClass:"col-12 flex justify-between items-center pt1 p0 mx-auto"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closemodalquote()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12 my2"},[_c('p',{staticClass:"darkblue col-12 h5 my2"},[_vm._v("Tilføj dit tilbud her")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column darkblue center  mb3 p2"},[_c('el-input',{staticClass:"col-6 mb2 mx0 p0",attrs:{"type":"text","placeholder":"Your name her"},model:{value:(_vm.Personnavn),callback:function ($$v) {_vm.Personnavn=$$v},expression:"Personnavn"}}),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","placeholder":"Tilføj her","autosize":{ minRows: 3, maxRows: 6}},model:{value:(_vm.yourquote),callback:function ($$v) {_vm.yourquote=$$v},expression:"yourquote"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end p3"},[_c('button',{staticClass:"action-button px2 py1",attrs:{"type":"button"},on:{"click":function($event){return _vm.savequote()}}},[_vm._v("Gemme")])])])]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"max-width-4 px0 mx4"},[_c('div',{staticClass:"flex justify-start mt3"},[_c('p',{staticClass:"h2 semi-bold line-height-2 darkblue"},[_vm._v("\n        Prisen 2022\n      ")])]),_vm._v(" "),_c('p',{staticClass:"h6 regular darkblue line-height-golden mb3"},[_vm._v("\n      Her kan du downloade din pressemeddelelse, som du med fordel kan sende til lokalaviserne i dit område. Husk at sende et billede med også, så lokalområdet kan sætte ansigt på regionens bedste håndværkere\n    ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"}),_vm._v(" "),_c('p',{staticClass:"center mediumgrey bold"},[_vm._v("Genererer Artikel ...")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h5',{staticClass:"line-height-3 flex flex-column"},[_c('p',[_vm._v("Den bedst anbefalede Elektriker: Ta El-Service")]),_vm._v(" "),_c('p',[_vm._v("Den bedst anbefalede Isolatør: Vittrup Tømrer og Snedker")]),_vm._v(" "),_c('p',[_vm._v("Den bedst anbefalede Maler: Aalborg Malerfirma")]),_vm._v(" "),_c('p',[_vm._v("Den bedst anbefalede Murer: Jysk Flise og Fugeteknik")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1452 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_klima_vue__ = __webpack_require__(1454);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f90e70c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_klima_vue__ = __webpack_require__(1456);
function injectStyle (ssrContext) {
  __webpack_require__(1453)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_klima_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f90e70c0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_klima_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1453 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_form_wizard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__ = __webpack_require__(1455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue2_simplert__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'klima',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_2_vue_full_loading___default.a,
    NumericKeyboard: __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__["NumericKeyboard"],
    Keys: __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__["Keys"],
    Dropzone: __WEBPACK_IMPORTED_MODULE_5_vue2_dropzone___default.a,
    FormWizard: __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_3_vue_form_wizard__["TabContent"],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_6__components_file_upload_input__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_7_vue2_simplert___default.a
  },
  props: ['projects', 'projects_create'],
  data: function data() {
    return {
      'vue/no-use-v-if-with-v-for': ['error', {
        'allowUsingIterationVar': true
      }],
      taskLoading: true,
      salesPerson: '',
      haaId: '',
      price: '',
      checked: null,
      antal: '',
      options: [{
        value: 'Option1',
        label: 'Option1'
      }, {
        value: 'Option2',
        label: 'Option2'
      }, {
        value: 'Option3',
        label: 'Option3'
      }, {
        value: 'Option4',
        label: 'Option4'
      }, {
        value: 'Option5',
        label: 'Option5'
      }],
      addUnit: '',
      unitDialogVisible: false,
      bDialogVisible: false,
      el1DialogVisible: false,
      centerDialogVisible: false,
      description: '',
      show: false,
      label: 'Loading...',
      overlay: true,
      success: false,
      tasktype: [],
      title: '',
      validationType: '',
      validationTitle: '',
      validationDescription: '',

      EL1modal: false,
      EL2modal: false,
      B1modal: false,
      EL1: '',
      EL2: '',
      C: '',
      AF: '',
      B: '',
      B1: '',
      isOpen: false,
      isWindow1: false,
      value: '',
      value1: false,
      value2: false,
      value3: false,
      value4: false,
      targetId: '',
      isSelected: false,
      amount: '',
      valuesInput: false,
      max: 4,
      filesDropzone: {
        paramName: 'file',
        picked: '',
        url: this.$http.options.root,
        thumbnailWidth: 150,
        maxFilesize: 7.5,
        acceptedFiles: 'image/*',
        createImageThumbnails: true,
        addRemoveLinks: true,
        renameFile: true,
        complete: function complete(file) {
          var _this = this;

          setTimeout(function () {
            _this.removeFile(file);
          }, 50);
        },
        dictDefaultMessage: '<div class="flex justify-center items-center"><span class="inline-block green mr1"><i class="h4 el-icon-upload"></i></span><span class="inline-block h5 m0 p0 gibson line-height-1">Upload</span></div>'
      },
      taskData: [],
      typeData: [],
      taskTitle: '',
      selectedTypeData: [],
      is: 'is',
      isData: [],
      klimaId: '',
      contactId: '',
      offer: '',
      test: '',
      documents: [{
        fileList: []
      }, {
        fileList: []
      }, {
        fileList: []
      }],
      allUserPlan: [],
      gatheredUserPlan: [],
      progressbar: [{
        progress1: 100,
        progress2: 0,
        progress3: 0
      }],
      entrySurvey: true,
      customerSurvey: true,
      partnerSurvey: true,
      draft: '',
      iconData: [],
      openCollapse: false,
      tlføjEnhedVisible: true
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    if (localStorage.getItem('climate') === 'false') {
      setTimeout(function () {
        document.getElementById('klimaPartner').classList.add('hide');
      }, 50);
    }
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    var klimaId = searchParams.get('klimaId');
    this.klimaId = klimaId;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    var draft = searchParams.get('draft');
    this.draft = draft;
    this.getKlimaStatus();
    setTimeout(function () {
      var btn = document.querySelectorAll('.klima-documentation > .input-group > button');
      for (var i = 0; i < btn.length; i++) {
        btn[i].innerHTML = '<button class="action-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded"><span class="mr2"><i class="el-icon-paperclip"></i></span><span>VEDHÆFTET</span></button>';
      }
    }, 1000);
  },
  dropzoneSettings: function dropzoneSettings() {
    var defaultValues = {
      thumbnailWidth: 200,
      thumbnailHeight: 200
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
      defaultValues[key] = this.options[key];
    }, this);
    if (this.awss3 !== null) {
      defaultValues['autoProcessQueue'] = false;
      this.isS3 = true;
      if (this.options.autoProcessQueue !== undefined) {
        this.wasQueueAutoProcess = this.options.autoProcessQueue;
      }
    }
    return defaultValues;
  },

  methods: {
    goToCheckList: function goToCheckList() {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    },
    showModal: function showModal() {
      this.$root.$emit('bv::show::modal', 'EL1modal', '#btnShow');
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    validateFirstStep: function validateFirstStep() {
      var _this2 = this;

      var checkSwitch = document.querySelectorAll('.klima-plan .el-switch');
      var checkedCount = 0;
      for (var i = 0; i < checkSwitch.length; i++) {
        if (checkSwitch[i].classList.contains('is-checked')) {
          checkedCount++;
        }
      }
      var validation = '';
      var draft = parseInt(this.draft);
      if (draft === 1) {
        draft = 0;
      }
      if (checkedCount === checkSwitch.length && !this.openCollapse) {
        var data = {
          operation: 'klimaApi',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          ContactId: this.contactId,
          CompanyId: this.haaId,
          parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
            draft: draft,
            klimaId: this.klimaId,
            operation: 'addKlima',
            ContactId: this.contactId,
            CompanyId: this.haaId,
            info: '',
            offerId: this.offer,
            userplan: this.allUserPlan,
            usersurvey: this.gatheredUserPlan
          })
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var res = response.body;
          if (res.success) {} else {
            _this2.$toastr('error', 'Error in validateFirstStep()');
          }
        }, function (response) {
          _this2.$toastr('error', 'Error in validateFirstStep()');
        });
        this.progressbar[0].progress2 = 100;
        this.tlføjEnhedVisible = false;
        validation = true;
      } else if (checkedCount !== checkSwitch.length) {
        validation = false;
        this.$toastr('error', 'Felter påkrævet');
      } else if (this.openCollapse) {
        validation = false;
        this.$toastr('error', 'Klik på knappen Accepter');
      }
      return validation;
    },
    validateSecondStep: function validateSecondStep() {
      var inputMsg = document.querySelector('#checkbox-message');
      var inputEmail = document.querySelector('#checkbox-email');
      var validation = '';
      if (inputMsg.checked === true || inputEmail.checked === true) {
        if (inputMsg.checked === true) {
          this.sendCustomerQuestionnaire('sms');
        }
        if (inputEmail.checked === true) {
          this.sendCustomerQuestionnaire('email');
        }
        this.sendPartnerQuestionnaire();
        this.progressbar[0].progress3 = 100;
        this.taskLoading = true;
        validation = true;
      } else {
        validation = false;
        this.$toastr('error', 'Vælg en indstilling');
      }
      return validation;
    },
    onComplete: function onComplete() {
      var validation = true;
      var obj = {
        title: 'Gennemført!',
        message: '',
        type: 'success',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
      this.taskLoading = false;
      return validation;
    },
    updateEL1: function updateEL1(event) {
      var value = event.target.value;
      console.log(value, this.EL1);
      if (String(value).length <= 4) {
        this.EL1 = value;
      }
      this.$forceUpdate();
    },
    updateEL2: function updateEL2(event) {
      var value = event.target.value;
      console.log(value, this.EL2);
      if (String(value).length <= 4) {
        this.EL2 = value;
      }
      this.$forceUpdate();
    },

    select: function select(event) {
      var targetId = this.targetId;
      targetId = event.currentTarget.id;
      console.log(targetId);
    },
    pressEL1: function pressEL1(key) {
      var _this3 = this;

      if (key === __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__["Keys"].DEL) {
        this.EL1 = this.EL1.slice(0, -1);
      } else {
        this.EL1 = this.EL1 + key;
        if (this.EL1.length === 4) {
          setTimeout(function () {
            return _this3.$emit('confirm', _this3.EL1);
          }, 100);
        }
      }
    },
    pressEL2: function pressEL2(key) {
      var _this4 = this;

      if (key === __WEBPACK_IMPORTED_MODULE_4_numeric_keyboard__["Keys"].DEL) {
        this.EL2 = this.EL2.slice(0, -1);
      } else {
        this.EL2 = this.EL2 + key;
        if (this.EL2.length === 4) {
          setTimeout(function () {
            return _this4.$emit('confirm', _this4.EL2);
          }, 100);
        }
      }
    },
    confirmAmount: function confirmAmount() {
      if (this.EL1) {
        console.log(this.EL1);
      }
    },
    confirm: function confirm() {
      var obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',

        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    delItem: function delItem() {
      var obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<p class="h3 mt3 regular gibson darkblue line-height-2" style="text-align:left;">Din klima plan er færdig</p>',

        type: 'success',
        customCloseBtnClass: 'primary-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk'
      };
      this.$refs.simplert.openSimplert(obj);
    },
    displayType: function displayType() {
      var _this5 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        _this5.typeData = res.data;
        _this5.getKlimaIcons();
      }, function (response) {
        _this5.$toastr('error', 'Error in displayType()');
      });
    },
    displayTask: function displayTask() {
      var _this6 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getKlima'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          console.log('🚀 ~ file: klima.vue ~ line 1054 ~ displayTask ~ this.taskData', res);
          var dataArr = '';
          if (_this6.draft === '0') {
            dataArr = res.data.main;
          } else {
            dataArr = res.data.draft;
          }
          for (var i = 0; i < dataArr.length; i++) {
            if (dataArr[i].klimaId === _this6.klimaId) {
              _this6.offer = dataArr[i].offer;
              _this6.taskData = dataArr[i].user_group;
              _this6.displayType();
            }
          }
        } else {
          _this6.$toastr('error', 'Error in displayTask()');
        }
      }, function (response) {
        _this6.$toastr('error', 'Error in displayTask()');
      });
    },
    handleFileUpload: function handleFileUpload(file) {
      this.documentList = file;
    },
    selectSurvey: function selectSurvey(type, planId, section) {
      if (section === 'task') {
        this.checkInitialType(type, planId);
      }
      this.checkSwitch(type, planId);
    },
    checkInitialType: function checkInitialType(type, planId) {
      var val = document.querySelector('#task-' + planId + ' .el-tabs__item.is-active').id.split('-');
      var id = val[1];
      var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id + ' .itemSelect input');
      var checkedCount = 0;
      for (var i = 0; i < input.length; i++) {
        if (input[i].checked === true) {
          checkedCount++;
        }
      }
      if (checkedCount > 0) {
        document.querySelector('#task-' + planId + ' .types-initial #' + type).classList.remove('hide');
      } else {
        document.querySelector('#task-' + planId + ' .types-initial #' + type).classList.add('hide');
      }
    },
    checkSwitch: function checkSwitch(type, planId) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item');
      var checkedCount = 0;
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-');
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input');
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            checkedCount++;
          }
        }
        if (checkedCount > 0) {
          document.querySelector('#task-' + planId + ' .el-switch').classList.add('is-checked');
        } else {
          document.querySelector('#task-' + planId + ' .el-switch').classList.remove('is-checked');
        }
      }
    },
    getSelectedSurvey: function getSelectedSurvey(planId, planTitle, planIdType) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item');
      var userSurvey = [];
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-');
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input');
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            var surveyId = input[x].id.split('-');
            userSurvey.push(parseInt(surveyId[1]));
          }
        }
      }
      if (planIdType === 'notZeroPlanId') {
        planId = parseInt(planId);
      } else if (planIdType === 'zeroPlanId') {
        planId = 0;
      }
      this.allUserPlan.push({
        userplanId: planId,
        title: planTitle,
        files: [],
        images: [],
        info: '',
        usertype: [],
        usersurvey: userSurvey
      });
      this.validateAllAcceptButton();
    },
    getSelectedGatheredSurvey: function getSelectedGatheredSurvey(planId, planTitle) {
      var val = document.querySelectorAll('#task-' + planId + ' .el-tabs__item');
      var userGatheredSurvey = [];
      for (var i = 0; i < val.length; i++) {
        var id = val[i].id.split('-');
        var input = document.querySelectorAll('#task-' + planId + ' .el-tabs__content #pane-' + id[1] + ' .itemSelect input');
        for (var x = 0; x < input.length; x++) {
          if (input[x].checked === true) {
            var surveyId = input[x].id.split('-');
            userGatheredSurvey.push(parseInt(surveyId[1]));
          }
        }
      }
      this.gatheredUserPlan = userGatheredSurvey;
      this.validateAllAcceptButton();
    },
    validateAllAcceptButton: function validateAllAcceptButton() {
      var _this7 = this;

      setTimeout(function () {
        var collapseBtn = document.querySelectorAll('.klima-plan .collapse');
        _this7.openCollapse = false;
        for (var i = 0; i < collapseBtn.length; i++) {
          if (collapseBtn[i].classList.contains('show')) {
            _this7.openCollapse = true;
          }
        }
      }, 500);
    },
    sendCustomerQuestionnaire: function sendCustomerQuestionnaire(type) {
      var _this8 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          klimaId: this.klimaId,
          operation: 'sendForm',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          type: type,
          to: 'customer'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {} else {
          _this8.$toastr('error', 'Error in sendCustomerQuestionnaire()');
        }
      }, function (response) {
        _this8.$toastr('error', 'Error in sendCustomerQuestionnaire()');
      });
    },
    sendPartnerQuestionnaire: function sendPartnerQuestionnaire() {
      var _this9 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          klimaId: this.klimaId,
          operation: 'sendForm',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          type: 'email',
          to: 'partner'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.getKlimaStatus();
          _this9.onComplete();
        } else {
          _this9.$toastr('error', 'Error in sendPartnerQuestionnaire()');
        }
      }, function (response) {
        _this9.$toastr('error', 'Error in sendPartnerQuestionnaire()');
      });
    },
    getKlimaStatus: function getKlimaStatus() {
      var _this10 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'klimaStatus',
          CompanyId: this.haaId,
          ContactId: this.contactId,
          klimaId: this.klimaId,
          to: 'customer'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this10.entrySurvey = res.data.EntrySurvey;
          _this10.customerSurvey = res.data.CustomerSurvey;
          _this10.partnerSurvey = res.data.PartnerSurvey;
          _this10.displayTask();
        } else {
          _this10.$toastr('error', 'Error in getKlimaStatus()');
        }
      }, function (response) {
        _this10.$toastr('error', 'Error in getKlimaStatus()');
      });
    },
    addTask: function addTask() {
      if (this.taskTitle !== '') {
        var titleExist = false;
        for (var i = 0; i < this.taskData.length; i++) {
          if (this.taskData[i].title === this.taskTitle) {
            titleExist = true;
          }
        }
        if (!titleExist) {
          this.taskData.push({
            userplanId: '0',
            title: this.taskTitle,
            file: [],
            fileList: [],
            image: [],
            imageList: [],
            user_type: [],
            user_survey: [],
            info: ''
          });
          this.taskTitle = '';
          this.unitDialogVisible = false;
          this.$toastr('success', 'Tilføjet');
        } else {
          this.$toastr('error', 'Eksisterer allerede');
        }
      } else {
        this.$toastr('error', 'Felt kræves');
      }
    },
    getKlimaIcons: function getKlimaIcons() {
      var _this11 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getSurveyicon'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this11.iconData = res.data;
          _this11.taskLoading = false;
        } else {
          _this11.$toastr('error', 'Error in getIcons()');
        }
      }, function (response) {
        _this11.$toastr('error', 'Error in getIcons()');
      });
    },
    gotoSurvey: function gotoSurvey() {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    }
  },
  watch: {
    'tasktype': function tasktype(newVal, oldVal) {
      if (newVal.length !== 0) {
        this.validationType = true;
      }
    },
    'title': function title(newVal, oldVal) {
      if (newVal !== '') {
        this.validationTitle = true;
      }
    },
    'description': function description(newVal, oldVal) {
      if (newVal !== '') {
        this.validationDescription = true;
      }
    }
  },
  computed: {
    el1State: function el1State() {
      return this.EL1.length > 2;
    },
    el2State: function el2State() {
      return this.EL2.length > 2;
    }
  }
});

/***/ }),
/* 1455 */,
/* 1456 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"klimaPartner"}},[_c('div',{staticClass:"clearfix fullHeight"},[_c('div',{staticClass:"col-12 lg-col-4 md-col-9 py3 mx-auto shadow mt3"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer mb3",on:{"click":function($event){return _vm.goToCheckList()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"col-12 flex justify-between items-center"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_vm._m(2)]):_vm._e(),_vm._v(" "),(!_vm.entrySurvey)?_c('div',{staticClass:"mt3 px2"},[_c('p',{staticClass:"h5 textgrey custom-letter-spacing gibson line-height-3"},[_vm._v("\n          Hvilke enheder skal indgå i projektets klimarapport? Du angiver hvilke nøgletal enheden og projektet som helhed bidrager til.\n        ")])]):_vm._e(),_vm._v(" "),(!_vm.success)?_c('form-wizard',{ref:"wizard",staticClass:"px1",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return (!_vm.entrySurvey && !_vm.taskLoading)?[_c('div',{staticClass:"wizard-footer-left flex-auto"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"flex items-start justify-start",nativeOn:{"click":function($event){props.prevTab(), _vm.tlføjEnhedVisible = true}}},[_c('span',{staticClass:"block flex flex-column justify-start items-start"},[_c('span',{staticClass:"block flex justify-start"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Tilbage")])])]):_vm._e()],1),_vm._v(" "),(_vm.tlføjEnhedVisible)?_c('div',{staticClass:"flex flex-column justify-center items-center gibson pointer"},[[_c('div',{staticClass:"mx-auto center border darkblue-border",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border":"2px solid!important"},on:{"click":function($event){_vm.unitDialogVisible = true}}},[_c('span',{staticClass:"green semi-bold",staticStyle:{"font-size":"24px"}},[_c('i',{staticClass:"el-icon-plus"})])])],_vm._v(" "),_c('span',{staticClass:"center block h6 caps gibson darkblue line-height-1 mt2 mb0 p0"},[_vm._v("Tilføj enhed")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right flex-auto"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"flex flex-column items-end justify-end px0 col-12",nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"block flex flex-column justify-end items-end"},[_c('span',{staticClass:"block flex justify-end"},[_c('i',{staticClass:"el-icon-right"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Næste")])])]):_vm._e()],1)]:undefined}}],null,true)},[(!_vm.entrySurvey)?_c('tab-content',{staticClass:"klima-plan",attrs:{"title":"1","before-change":_vm.validateFirstStep}},[_c('div',{staticClass:"highlights p3 klimaForm"},[_c('p',{staticClass:"h5 gibson darkblue line-height-1 m0 p0"},[_vm._v("\n              Klima Plan\n            ")]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.taskLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_vm._l((_vm.taskData),function(task,index){return _c('div',{key:index},[(task.userplanId != '0')?_c('div',{staticClass:"clearfix task",attrs:{"id":'task-' + task.userplanId}},[_c('div',{staticClass:"col-12 mb2 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('toggle-' + index),expression:"'toggle-' + index"}],staticClass:"toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center",on:{"click":function($event){return _vm.validateAllAcceptButton()}}},[_c('span',{staticClass:"when-opened mr1"},[_c('i',{staticClass:"el-icon-caret-bottom mediumgrey"})]),_vm._v(" "),_c('span',{staticClass:"when-closed mr1"},[_c('i',{staticClass:"el-icon-caret-right darkblue"})]),_vm._v(" "),_c('p',{staticClass:"h5 m0 p0 regular gibson darkblue line-height-1 caps"},[_vm._v("\n                        "+_vm._s(task.title)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"types-initial flex justify-end items-center"},[_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"economy"}},[_vm._v("\n                        Ø\n                      ")]),_vm._v(" "),_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"social"}},[_vm._v("\n                        S\n                      ")]),_vm._v(" "),_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"environment"}},[_vm._v("\n                        M\n                      ")]),_vm._v(" "),_c('el-switch',{staticClass:"no-events",attrs:{"active-class":"darkblue"}})],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'toggle-' + index}},[_c('div',{staticClass:"py2 border-top form-border type-tabs"},[_c('el-tabs',[(_vm.typeData.main[0].economy.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/money-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Økonomi")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].economy),function(economy,index1){return (!economy.onlyOverall && economy.value != 0)?_c('div',{key:index1,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + economy.economicId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('economy', task.userplanId, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEconomy[economy.economicId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(economy.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].social.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/money-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Social")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].social),function(social,index2){return (!social.onlyOverall && social.value != 0)?_c('div',{key:index2,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + social.socialId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('social', task.userplanId, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveySocial[social.socialId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(social.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].environment.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"environment-img block",attrs:{"src":"static/svg/leaf-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Miljø")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].environment),function(environment,index3){return (!environment.onlyOverall && environment.value != 0)?_c('div',{key:index3,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + environment.environmentId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('environment', task.userplanId, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEnvironment[environment.environmentId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(environment.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e()],1),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('toggle-' + index),expression:"'toggle-' + index"}],staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.getSelectedSurvey(task.userplanId, task.title, 'notZeroPlanId')}}},[_c('span',[_vm._v("ACCEPTER")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right bold"})])])],1)])],1):_c('div',{staticClass:"clearfix task",attrs:{"id":'task-' + index}},[_c('div',{staticClass:"col-12 mb2 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('toggle-' + index),expression:"'toggle-' + index"}],staticClass:"toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center",on:{"click":function($event){return _vm.validateAllAcceptButton()}}},[_c('span',{staticClass:"when-opened mr1"},[_c('i',{staticClass:"el-icon-caret-bottom mediumgrey"})]),_vm._v(" "),_c('span',{staticClass:"when-closed mr1"},[_c('i',{staticClass:"el-icon-caret-right darkblue"})]),_vm._v(" "),_c('p',{staticClass:"h5 m0 p0 regular gibson darkblue line-height-1 caps"},[_vm._v("\n                        "+_vm._s(task.title)+"\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"types-initial flex justify-end items-center"},[_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"economy"}},[_vm._v("\n                        Ø\n                      ")]),_vm._v(" "),_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"social"}},[_vm._v("\n                        S\n                      ")]),_vm._v(" "),_c('span',{staticClass:"inline-block rounded p1 caps green-background white gibson h6 semi-bold mr1 mb0 hide",attrs:{"id":"environment"}},[_vm._v("\n                        M\n                      ")]),_vm._v(" "),_c('el-switch',{staticClass:"no-events",attrs:{"active-class":"darkblue"}})],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'toggle-' + index}},[_c('div',{staticClass:"py2 border-top form-border type-tabs"},[_c('el-tabs',[(_vm.typeData.main[0].economy.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/money-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Økonomi")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].economy),function(economy,index1){return (!economy.onlyOverall && economy.value != 0)?_c('div',{key:index1,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + economy.economicId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('economy', index, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEconomy[economy.economicId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(economy.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].social.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/money-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Social")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].social),function(social,index2){return (!social.onlyOverall && social.value != 0)?_c('div',{key:index2,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + social.socialId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('social', index, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveySocial[social.socialId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(social.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].environment.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"environment-img block",attrs:{"src":"static/svg/leaf-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Miljø")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Enheden påvirker at:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].environment),function(environment,index3){return (!environment.onlyOverall && environment.value != 0)?_c('div',{key:index3,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + environment.environmentId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('environment', index, 'task')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEnvironment[environment.environmentId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(environment.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e()],1),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('toggle-' + index),expression:"'toggle-' + index"}],staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.getSelectedSurvey(index, task.title, 'zeroPlanId')}}},[_c('span',[_vm._v("ACCEPTER")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right bold"})])])],1)])],1)])}),_vm._v(" "),_c('div',{staticClass:"border-top form-border mb2"}),_vm._v(" "),_c('div',{staticClass:"clearfix",attrs:{"id":"task-gathered"}},[_c('div',{staticClass:"col-12 mb2 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('projektet-samlet'),expression:"'projektet-samlet'"}],staticClass:"toggle-label-btn pl0 border-none white-background darkblue flex justify-start items-center",on:{"click":function($event){return _vm.validateAllAcceptButton()}}},[_c('span',{staticClass:"when-opened mr1"},[_c('i',{staticClass:"el-icon-caret-bottom mediumgrey"})]),_vm._v(" "),_c('span',{staticClass:"when-closed mr1"},[_c('i',{staticClass:"el-icon-caret-right darkblue"})]),_vm._v(" "),_c('p',{staticClass:"h5 m0 p0 regular gibson darkblue line-height-1"},[_vm._v("\n                        PROJEKTET SAMLET\n                      ")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-end items-center"},[_c('el-switch',{staticClass:"no-events",attrs:{"active-class":"darkblue"}})],1)]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'projektet-samlet'}},[_c('div',{staticClass:"py2 border-top form-border project-tabs"},[_c('el-tabs',[(_vm.typeData.main[0].economy.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center col-12",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/money-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Økonomi")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Under projektet vil:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].economy),function(economy,index1){return (economy.onlyOverall && economy.value != 0)?_c('div',{key:index1,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + economy.economicId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('economy', 'gathered', 'project')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEconomy[economy.economicId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(economy.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].social.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"economy-img block",attrs:{"src":"static/svg/people-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Social")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Under projektet vil:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].social),function(social,index2){return (social.onlyOverall && social.value != 0)?_c('div',{key:index2,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 relative z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + social.socialId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('social', 'gathered', 'project')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveySocial[social.socialId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(social.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e(),_vm._v(" "),(_vm.typeData.main[0].environment.length > 0)?_c('el-tab-pane',[_c('div',{staticClass:"flex items-center p3",attrs:{"slot":"label"},slot:"label"},[_c('div',{staticClass:"col-12 pt2"},[_c('img',{staticClass:"environment-img block",attrs:{"src":"static/svg/leaf-green.svg","width":"100%"}}),_vm._v(" "),_c('span',{staticClass:"bold darkblue"},[_vm._v("Miljø")])])]),_vm._v(" "),_c('div',[_c('span',[_vm._v("Under projektet vil:")]),_vm._v(" "),_c('div',{staticClass:"mb2"}),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-center mb4"},[_vm._l((_vm.typeData.main[0].environment),function(environment,index3){return (environment.onlyOverall && environment.value != 0)?_c('div',{key:index3,staticClass:"col-4 white-background itemSelect gibson center p0 mb4 z2"},[_c('input',{staticClass:"col-7 ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":'checkbox-' + environment.environmentId,"type":"checkbox"},on:{"change":function($event){return _vm.selectSurvey('environment', 'gathered', 'project')}}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border col-7 p2 ml-auto mx-auto relative z1",staticStyle:{"border-width":"3px !important"}},[_c('img',{staticClass:"h1 semi-bold",attrs:{"src":_vm.iconData.KlimaSurveyEnvironment[environment.environmentId].icon,"width":"100%"}})]),_vm._v(" "),_c('span',{staticClass:"green caps"},[_vm._v(_vm._s(environment.title))])]):_vm._e()}),_vm._v(" "),_c('div',{staticClass:"absolute"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"mediumgrey mr1"},[_vm._v("Ingen data.")]),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer no-hover",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._v("Rediger tjekliste")])])])],2)])]):_vm._e()],1)],1),_vm._v(" "),_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('projektet-samlet'),expression:"'projektet-samlet'"}],staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.getSelectedGatheredSurvey('gathered', '')}}},[_c('span',[_vm._v("ACCEPTER")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right bold"})])])])],1)],2)])]):_vm._e(),_vm._v(" "),(!_vm.entrySurvey)?_c('tab-content',{attrs:{"title":"2 ud af 4","before-change":_vm.validateSecondStep}},[_c('div',{staticClass:"highlights p3 klimaForm"},[_c('p',{staticClass:"h5 gibson darkblue line-height-1 mb2 p0"},[_vm._v("\n              1. Send spørgeskema til din kunde\n            ")]),_vm._v(" "),_c('span',{staticClass:"semi-bold textgrey"},[_vm._v("Din kunde skal besvare et kort spørgeskema for at lave rapporten. Vælg SMS eller email.")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('div',{staticClass:"flex mb4 justify-between"},[_c('div',{staticClass:"col-6 itemSelect gibson center relative z2"},[_c('input',{staticClass:"col-12 absolute ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":"checkbox-message","type":"checkbox"}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border py1 px2 ml-auto mx-auto relative z1"},[_c('i',{staticClass:"h1 el-icon-chat-dot-square m0"}),_vm._v(" "),_c('span',{staticClass:"block m0"},[_vm._v("Sms")])])]),_vm._v(" "),_c('div',{staticClass:"col-6 itemSelect gibson center relative z2"},[_c('input',{staticClass:"col-12 absolute ml-auto mx-auto absolute left-0 right-0 z2 fullHeight block pointer",staticStyle:{"opacity":"0","display":"block !important"},attrs:{"id":"checkbox-email","type":"checkbox"}}),_vm._v(" "),_c('label',{staticClass:"green pointer block center border green-border py1 px2 ml-auto mx-auto relative z1"},[_c('i',{staticClass:"h1 el-icon-message m0"}),_vm._v(" "),_c('span',{staticClass:"block m0"},[_vm._v("Email")])])])]),_vm._v(" "),_c('p',{staticClass:"h5 gibson darkblue line-height-1 p0"},[_vm._v("\n              2. Udfyld spørgeskema\n            ")]),_vm._v(" "),_c('span',{staticClass:"semi-bold textgrey"},[_vm._v("Du bliver tilsendt et spørgeskema på din email, når du klikker Næste.")]),_vm._v(" "),_c('div',{staticClass:"mb4 hide"}),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center hide"},[_c('span',[_vm._v("OK")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right bold"})])])])]):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"title":"3 ud af 4"}},[_c('div',{staticClass:"highlights p3 klimaForm center"},[(_vm.taskLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('div',{staticClass:"py3 mb4"},[(_vm.entrySurvey)?_c('span',{staticClass:"h4 gibson green line-height-1 mb2 p0 block"},[_vm._v("\n                  Spørgeskema sendt\n                ")]):_c('span',{staticClass:"h4 gibson darkblue line-height-1 mb2 p0 block"},[_vm._v("\n                  Spørgeskema sendt\n                ")]),_vm._v(" "),(_vm.partnerSurvey)?_c('span',{staticClass:"h4 gibson green line-height-1 mb2 p0 block"},[_vm._v("\n                  Besvar spørgeskema\n                ")]):_c('span',{staticClass:"h4 gibson darkblue line-height-1 mb2 p0 block"},[_vm._v("\n                  Besvar spørgeskema\n                ")]),_vm._v(" "),(_vm.customerSurvey)?_c('span',{staticClass:"h4 gibson green line-height-1 mb2 p0 block"},[_vm._v("\n                  Afvent besvarelse\n                ")]):_c('span',{staticClass:"h4 gibson darkblue line-height-1 mb2 p0 block"},[_vm._v("\n                  Afvent besvarelse\n                ")])]),_vm._v(" "),_c('div',{staticClass:"py3"},[_c('span',{staticClass:"h5 gibson green line-height-1 mb1 p0 block"},[_vm._v("\n                 Hvad skal du gøre?\n                ")]),_vm._v(" "),_c('span',{staticClass:"h5 gibson mediumgrey line-height-1 mb2 p0 block"},[_vm._v("Udfyld dit spørgeskema, og bed din kunde til at udfylde sit. Så kan klimarapporten beregnes.")])])])])]),_vm._v(" "),(!_vm.entrySurvey)?_c('div',{staticClass:"flex justify-start items-center col-12 px0 mt3 mb2"},[_c('div',{staticClass:"col-4 px1"},[_c('el-progress',{attrs:{"percentage":_vm.progressbar[0].progress1,"show-text":false,"color":"#4dcf55"}})],1),_vm._v(" "),_c('div',{staticClass:"col-4 px1"},[_c('el-progress',{attrs:{"percentage":_vm.progressbar[0].progress2,"show-text":false,"color":"#4dcf55"}})],1),_vm._v(" "),_c('div',{staticClass:"col-4 px1"},[_c('el-progress',{attrs:{"percentage":_vm.progressbar[0].progress3,"show-text":false,"color":"#4dcf55"}})],1)]):_vm._e()],1):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticStyle:{"height":"200px"}}):_vm._e()],1)]),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Warning","visible":_vm.centerDialogVisible,"width":"30%","center":""},on:{"update:visible":function($event){_vm.centerDialogVisible=$event}}},[_c('span',[_vm._v("It should be noted that the content will not be aligned in center by default")]),_vm._v(" "),_c('span',{staticClass:"dialog-footer",attrs:{"slot":"footer"},slot:"footer"},[_c('el-button',{on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("Cancel")]),_vm._v(" "),_c('el-button',{attrs:{"type":"primary"},on:{"click":function($event){_vm.centerDialogVisible = false}}},[_vm._v("Confirm")])],1)]),_vm._v(" "),_c('el-dialog',{staticClass:"unitDialog",attrs:{"visible":_vm.unitDialogVisible,"width":"60%","center":""},on:{"update:visible":function($event){_vm.unitDialogVisible=$event}}},[_c('div',{staticClass:"clearfix center px2 pt3"},[_c('div',{staticClass:"mx-auto center",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border":"2px solid white"}},[_c('span',{staticClass:"white semi-bold",staticStyle:{"font-size":"24px"}},[_c('i',{staticClass:"el-icon-plus"})])]),_vm._v(" "),_c('p',{staticClass:"h2 regular darkblue gibson line-height-2 my2"},[_vm._v("\n        Enhed\n      ")]),_vm._v(" "),_c('div',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.taskTitle),expression:"taskTitle"}],staticClass:"col-12 white-background border-none not-rounded gibson h5 line-height-1 p2",attrs:{"type":"text","placeholder":"F. eks. isolering"},domProps:{"value":(_vm.taskTitle)},on:{"input":function($event){if($event.target.composing){ return; }_vm.taskTitle=$event.target.value}}})]),_vm._v(" "),_c('div',[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle.values",modifiers:{"values":true}}],staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.addTask()}}},[_c('span',[_vm._v("OK")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"hide col-10 mx-auto white-background p2 flex justify-center items-center border-none light-highlights"},[_c('span',{staticClass:"col-8 px0 right-align px0inline-block h4 regular m0 py0 gibson darkblue line-height-1 px1"},[_vm._v("\n          "+_vm._s(_vm.EL1)+"\n        ")]),_vm._v(" "),_c('span',{staticClass:"col-4 inline-block h4 regular m0 py0 gibson lightgrey line-height-1 px1"},[_vm._v("\n          KW H\n        ")])])]),_vm._v(" "),_c('span',{staticClass:"hide dialog-footer",attrs:{"slot":"footer"},slot:"footer"})]),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix primarycolor flex justify-start items-center"},[_c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-refresh-right"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Opdater")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checklist_vue__ = __webpack_require__(1459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577ee8ec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checklist_vue__ = __webpack_require__(1460);
function injectStyle (ssrContext) {
  __webpack_require__(1458)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_checklist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_577ee8ec_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_checklist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1458 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'klimachecklist',
  components: {},
  data: function data() {
    return {
      insideLoading: false,
      salesPerson: '',
      haaId: '',
      project: null,
      tilbudData: [],
      appointmentId: '',
      contactId: '',
      klimaMainData: [],
      klimaDraftData: [],
      klimaVisible: false,
      klimaPlanVisible: true,
      mainKlimaVisible: false,
      draftKlimaVisible: false,
      klimaQualityAssuranceVisible: false,
      reportSent: false
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    this.displayPlan();
    this.getProject();
  },

  methods: {
    gotominekunder: function gotominekunder() {
      this.$router.push('/alle-moeder');
    },
    refreshpage: function refreshpage() {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&customerid=' + this.appointmentId);
    },
    gotoSurvey: function gotoSurvey() {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    },
    gotoPlan: function gotoPlan() {
      this.$router.push('/klima/klima');
    },
    gotoEditKlima: function gotoEditKlima(klimaId, draft) {
      this.$router.push('/klima/klima?appointmentId=' + this.appointmentId + '&klimaId=' + klimaId + '&contactId=' + this.contactId + '&draft=' + draft);
    },
    gotoDocumentation: function gotoDocumentation(klimaId) {
      this.$router.push('/klima/documentation?klimaId=' + klimaId + '&contactId=' + this.contactId + '&appointmentId=' + this.appointmentId);
    },

    changeItem: function changeItem(rowId, event) {
      this.selected = 'rowId: ' + rowId + ', target.value: ' + event.target.value;
    },
    getKlimaStatus: function getKlimaStatus(klimaId) {
      var _this = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'klimaStatus',
          CompanyId: this.haaId,
          ContactId: this.contactId,
          klimaId: klimaId,
          to: 'customer'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          if (res.data.EntrySurvey === true) {
            _this.draftKlimaVisible = false;
          }
          if (!_this.reportSent) {
            if (res.data.EntrySurvey === true && res.data.CustomerSurvey === true && res.data.PartnerSurvey === true) {
              _this.klimaQualityAssuranceVisible = true;
            } else {
              _this.klimaQualityAssuranceVisible = false;
            }
          }
          _this.insideLoading = false;
        } else {
          _this.$toastr('error', 'Error in getKlimaStatus()');
        }
      }, function (response) {
        _this.$toastr('error', 'Error in getKlimaStatus()');
      });
    },
    displayPlan: function displayPlan() {
      var _this2 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var mainFound = false;
          var draftFound = false;
          for (var i = 0; i < res.data.main.length; i++) {
            if (res.data.main[i].contact === _this2.contactId) {
              if (!mainFound) {
                _this2.klimaMainData = res.data.main[i];
                _this2.klimaDraftData = res.data.draft[i];
                _this2.getKlimaStatus(res.data.main[i].klimaId);
                if (res.data.main[i].report_sent) {
                  _this2.reportSent = true;
                } else {
                  _this2.reportSent = false;
                }
                mainFound = true;
              }
            }
            _this2.klimaVisible = true;
          }
          for (var j = 0; j < res.data.draft.length; j++) {
            if (res.data.draft[j].contact === _this2.contactId) {
              if (!draftFound) {
                _this2.klimaDraftData = res.data.draft[j];
                draftFound = true;
              }
            }
          }
          if (!_this2.reportSent) {
            _this2.mainKlimaVisible = true;
            if (res.data.draft.length > 0) {
              _this2.draftKlimaVisible = true;
            } else {
              _this2.draftKlimaVisible = false;
            }
          } else {
            _this2.mainKlimaVisible = false;
            _this2.draftKlimaVisible = false;
            _this2.klimaReportVisible = false;
            _this2.klimaQualityAssuranceVisible = false;
          }
        } else {
          _this2.klimaVisible = true;
          _this2.mainKlimaVisible = false;
          _this2.draftKlimaVisible = false;
          _this2.insideLoading = false;
        }
      }, function (response) {
        _this2.$toastr('error', 'Error in displayPlan()');
      });
      this.insideLoading = true;
    },
    getProject: function getProject() {
      var _this3 = this;

      var data = {
        operation: 'userTilbud',
        salesPerson: this.salesPerson,
        tilbud_id: this.appointmentId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.tilbudData = res.tilbud;
        if (_this3.tilbudData.length <= 0) {
          document.querySelector('p.el-select-dropdown__empty').innerText = 'Ingen data.';
        }
      }, function (response) {
        _this3.$toastr('error', 'Error in getProject()');
      });
    },
    projectChanged: function projectChanged() {
      var _this4 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var mainFound = false;
          var draftFound = false;
          for (var i = 0; i < res.data.main.length; i++) {
            if (res.data.main[i].offer === _this4.project) {
              if (!mainFound) {
                _this4.klimaMainData = res.data.main[i];
                _this4.klimaDraftData = res.data.draft[i];
                _this4.getKlimaStatus(res.data.main[i].klimaId);
                if (res.data.main[i].report_sent) {
                  _this4.reportSent = true;
                } else {
                  _this4.reportSent = false;
                }
                mainFound = true;
              }
            }
            _this4.klimaVisible = true;
          }
          for (var j = 0; j < res.data.draft.length; j++) {
            if (res.data.draft[j].offer === _this4.project) {
              if (!draftFound) {
                _this4.klimaDraftData = res.data.draft[j];
                draftFound = true;
              }
            }
          }
          if (!_this4.reportSent) {
            _this4.mainKlimaVisible = true;
            if (res.data.draft.length > 0) {
              _this4.draftKlimaVisible = true;
            } else {
              _this4.draftKlimaVisible = false;
            }
          } else {
            _this4.mainKlimaVisible = false;
            _this4.draftKlimaVisible = false;
            _this4.klimaReportVisible = false;
            _this4.klimaQualityAssuranceVisible = false;
          }
        } else {
          _this4.klimaVisible = true;
          _this4.mainKlimaVisible = false;
          _this4.draftKlimaVisible = false;
          _this4.insideLoading = false;
        }
      }, function (response) {
        _this4.$toastr('error', 'Error in projectChanged()');
      });
      this.insideLoading = true;
    },
    addPlan: function addPlan() {
      var _this5 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          draft: 0,
          klimaId: 0,
          operation: 'addKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          info: '',
          offerId: this.project,
          userplan: [],
          usersurvey: []
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.gotoEditKlima(res.data.klimaId, 0);
          _this5.insideLoading = false;
        } else {
          _this5.$toastr('error', 'Error in addPlan()');
        }
      }, function (response) {
        _this5.$toastr('error', 'Error in addPlan()');
      });
      this.insideLoading = true;
    }
  },
  computed: {}
});

/***/ }),
/* 1460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"checklist"}},[_c('div',{staticClass:"col-10 lg-col-4 md-col-9 py3 highlights mx-auto mt3"},[_c('div',{staticClass:" flex m0 p0"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer mb3 mr-auto",on:{"click":function($event){return _vm.gotominekunder()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer mb3 ml-auto",on:{"click":function($event){return _vm.refreshpage()}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Opdater")])])]),_vm._v(" "),_c('div',{staticClass:"clearfix green flex justify-start items-center my3"},[_c('span',{staticClass:"mr1"},[_c('svg',{attrs:{"fill":"currentColor","width":"32","height":"32","id":"Capa_1","enable-background":"new 0 0 512 512","viewBox":"0 0 512 512","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',[_c('circle',{attrs:{"cx":"363","cy":"457","r":"10"}}),_c('path',{attrs:{"d":"m384.803 429.456c4.906 2.535 10.94.609 13.473-4.299 11.595-22.466 17.724-47.762 17.724-73.157 0-77.401-55.074-141.871-127.878-156.758-.067-.014-.258-.05-.287-.055-7.182-1.454-14.492-2.405-21.835-2.863v-62.324c0-11.028 8.972-20 20-20 55.141 0 100-44.859 100-100 0-5.522-4.478-10-10-10h-30c-39.533 0-73.78 23.06-90 56.435-16.22-33.375-50.467-56.435-90-56.435h-30c-5.522 0-10 4.478-10 10 0 55.141 44.859 100 100 100 11.028 0 20 8.972 20 20v62.325c-85.072 5.296-150 76.085-150 159.675 0 88.225 71.775 160 160 160 26.438 0 52.658-6.616 75.826-19.134 4.858-2.625 6.669-8.692 4.044-13.552-2.626-4.859-8.692-6.668-13.552-4.044-18.472 9.981-39.172 15.654-60.216 16.579 2.78-1.459 4.772-4.17 5.249-7.382 2.363-15.918 9.08-21.771 19.247-30.63 6.79-5.917 14.485-12.622 22.055-23.288 8.312-11.703 11.517-25.941 9.024-40.096l-3.76-21.32c-.959-5.438-6.146-9.071-11.581-8.112l-18.807 3.311c-10.939 1.932-21.854-2.414-28.478-11.338-13.522-18.238-37.137-24.627-57.894-16.312-.061-.039-.12-.078-.18-.117-7.468-4.932-11.722-11.986-11.977-19.865-.167-5.156 1.373-10.263 4.268-14.706.999 1.813 2.641 3.548 5.447 4.49 3.504 1.177 7.329.313 9.984-2.148 4.286-3.976 3.258-8.837 2.484-11.915-.315-4.102-3.104-9.226.838-14.859 1.785-2.55 4.457-4.252 7.516-4.793l12.874-2.262c13.729-2.432 44.974-34.604 61.515-54.337 19.712 4.918 38.053 14.086 53.892 26.887-25.631 15.036-24.856 14.169-26.464 15.775-5.896 5.881-9.357 14.038-9.357 22.379v12.68c0 17.452 14.278 31.65 31.73 31.65 6.424 0 11.649 5.222 11.649 11.64 0 4.825 3.445 8.962 8.191 9.835l36.404 6.694c-.258 21.913-5.45 42.858-15.471 62.274-2.529 4.908-.604 10.94 4.303 13.472zm-158.803-339.456c-40.726 0-74.44-30.592-79.378-70h19.378c42.531 0 77.418 33.359 79.863 75.289-5.855-3.363-12.639-5.289-19.863-5.289zm120-70.01h19.378c-4.938 39.408-38.652 70.01-79.378 70.01-7.224 0-14.008 1.926-19.863 5.289 2.445-41.93 37.332-75.299 79.863-75.299zm-107.01 344.92c11.17 15.05 29.574 22.373 48.013 19.118l8.955-1.576 2.023 11.473c1.557 8.842-.444 17.736-5.637 25.048-6.193 8.728-12.646 14.35-18.885 19.786-6.788 5.915-13.72 11.954-18.851 21.131-6.82-9.013-11.384-11.004-14.334-13.104-.259-.503-.991-2.294-1.967-7.818-1.843-10.479-7.659-19.607-16.371-25.698l-6.772-4.744c9.339-13.981 8.919-32.295-1.134-45.844l-6.294-8.484c11.538-3.181 23.915.816 31.254 10.712zm-41.02 9.689c5.09 6.859 5.217 16.175.324 23.169l-5.24 7.471c-3.172 4.522-2.075 10.763 2.449 13.933l14.967 10.484c4.334 3.03 7.226 7.567 8.143 12.784 2.457 13.907 5.589 17.877 12.134 22.003 2.126 1.34 4.323 2.726 8.062 7.709l10.191 16.179c1.012 1.607 2.437 2.834 4.066 3.633-75.847-1.57-137.066-63.749-137.066-139.964 0-9.976 1.079-19.919 3.182-29.627 3.19 4.273 7.489 7.805 12.67 10.074l51.669 22.673zm26.643-123.731-12.543 2.204c-8.326 1.471-15.582 6.094-20.43 13.02-2.376 3.394-4.03 7.144-4.93 11.063-.952.428-1.875.97-2.749 1.634-12.344 9.353-19.428 23.767-18.948 38.559.092 2.82.461 5.592 1.092 8.289l-26.223-11.507c-5.416-2.372-8.26-8.347-6.472-13.605 1.957-5.767 2.263-11.918.949-17.756 24.981-43.753 71.214-70.769 121.641-70.769 3.591 0 7.185.14 10.767.415-17.538 19.56-36.555 36.308-42.154 38.453zm115.117 54.672c-6.424 0-11.73-5.227-11.73-11.65v-12.68c0-2.7 1.041-5.345 2.746-7.411l28.309-16.467c19.458 21.161 31.835 47.512 35.663 75.811l-24.51-4.507c-3.738-13.31-15.986-23.096-30.478-23.096z"}})])])]),_vm._v(" "),_c('span',{staticClass:"h3 regular gibson lineheight-1 m0 p0"},[_vm._v("\r\n          Klima\r\n        ")])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('button',{staticClass:"col-12 p2 gibson white-collapse-button not-rounded flex justify-between items-center line-height-1 border muted-border shadow",on:{"click":function($event){return _vm.gotoSurvey()}}},[_c('span',{staticClass:"h4 m0 p0 line-height-1"},[_c('span',{staticClass:"green mx1"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M20.285 2l-11.285 11.567-5.286-5.011-3.714 3.716 9 8.728 15-15.285z"}})])]),_vm._v(" "),_c('span',[_vm._v("Checklist")])]),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h6 mediumgrey gibson line-height-1"},[_vm._v("Projekt")]),_vm._v(" "),_c('el-select',{staticClass:"col-12 p0 checklist",attrs:{"placeholder":"Vælg et projekt"},on:{"change":function($event){return _vm.projectChanged()}},model:{value:(_vm.project),callback:function ($$v) {_vm.project=$$v},expression:"project"}},_vm._l((_vm.tilbudData),function(tilbud,index){return _c('el-option',{key:index,attrs:{"label":tilbud.header_text,"value":tilbud.id}},[_c('div',[_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v("REF"+_vm._s(tilbud.id)+"-"+_vm._s(tilbud.pid))]),_vm._v(" "),_c('div',[_c('span',{staticClass:"h6 bold"},[_vm._v(_vm._s(tilbud.header_text))])]),_vm._v(" "),_c('div',[_c('i',{staticClass:"el-icon-date"}),_vm._v(" "),_c('span',{staticStyle:{"font-size":"13px"}},[_vm._v(_vm._s(tilbud.createdtime.slice(0, -7)))])])])])}),1)],1),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.insideLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(3)]):_c('div',[(_vm.klimaVisible)?_c('div',[(_vm.klimaPlanVisible)?_c('div',{staticClass:"highlights"},[_vm._m(4),_vm._v(" "),_c('b-collapse',{attrs:{"id":"klimaPlan","visible":""}},[_c('div',{staticClass:"clearfix border-top mediumgrey-border p2"},[(_vm.mainKlimaVisible)?_c('div',{staticClass:"flex justify-between items-center mb1 pointer",on:{"click":function($event){return _vm.gotoEditKlima(_vm.klimaMainData.klimaId, 0)}}},[_c('div',{staticClass:"flex flex-column"},[_c('div',[_c('span',{staticClass:"h6 darkblue semi-bold line-height-2"},[_vm._v("Rediger klimaplan")])]),_vm._v(" "),_c('div',{staticClass:"h6 gibson line-height-1 m0 p0 mediumgrey flex justify-start items-center regular"},[_c('span',{staticClass:"mr1"},[_vm._v("Id: "+_vm._s(_vm.klimaMainData.klimaId))]),_vm._v(" "),_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.klimaMainData.created_date))])])]),_vm._v(" "),_c('div',{staticClass:"h4 primarycolor line-height-1 m0 p0"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(_vm.draftKlimaVisible)?_c('div',{staticClass:"flex justify-between items-center pointer",on:{"click":function($event){return _vm.gotoEditKlima(_vm.klimaDraftData.klimaId, 1)}}},[_c('div',{staticClass:"flex flex-column"},[_c('div',[_c('span',{staticClass:"h6 darkblue semi-bold line-height-2"},[_vm._v("Fortsæt kladden")])]),_vm._v(" "),_c('div',{staticClass:"h6 gibson line-height-1 m0 p0 mediumgrey flex justify-start items-center regular"},[_c('span',{staticClass:"mr1"},[_vm._v("Id: "+_vm._s(_vm.klimaDraftData.klimaId))]),_vm._v(" "),_c('span',{staticClass:"mr1"},[_c('svg',{staticClass:"jam jam-calendar-alt",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -3 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M9 2V1a1 1 0 1 1 2 0v1h3V1a1 1 0 0 1 2 0v1h1a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h1V1a1 1 0 1 1 2 0v1h3zm0 2H6v1a1 1 0 1 1-2 0V4H3a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V5a1 1 0 0 0-1-1h-1v1a1 1 0 0 1-2 0V4h-3v1a1 1 0 0 1-2 0V4zM3 8h2v2H3V8zm0 4h2v2H3v-2zm12 0h2v2h-2v-2zm0-4h2v2h-2V8zM7 8h2v2H7V8zm4 0h2v2h-2V8zm0 4h2v2h-2v-2zm-4 0h2v2H7v-2z"}})])]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.klimaDraftData.created_date))])])]),_vm._v(" "),_c('div',{staticClass:"h4 primarycolor line-height-1 m0 p0"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(!_vm.mainKlimaVisible && !_vm.draftKlimaVisible)?_c('div',[_c('div',{staticClass:"flex flex-column justify-center items-center pointer ",on:{"click":function($event){return _vm.addPlan()}}},[_c('i',{staticClass:"el-icon-circle-plus-outline green ",staticStyle:{"font-size":"4em"}}),_vm._v(" "),_c('a',{staticClass:"semi-bold primarycolor pointer "},[_vm._v("Opret Tilbud")])])]):_vm._e()])])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),(_vm.klimaQualityAssuranceVisible)?_c('div',{staticClass:"highlights"},[_c('button',{staticClass:"col-12 p2 gibson white-collapse-button flex justify-between not-rounded line-height-1",on:{"click":function($event){return _vm.gotoDocumentation(_vm.klimaMainData.klimaId)}}},[_c('div',[_vm._m(5),_vm._v(" "),_c('span',{staticClass:"block left-align mediumgrey"},[_vm._v("Id: "+_vm._s(_vm.klimaMainData.klimaId))])]),_vm._v(" "),_vm._m(6)])]):_vm._e()]):_vm._e()]),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"py4"})])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-refresh-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"when-closed mx2"},[_c('i',{staticClass:"h4 el-icon-arrow-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"col-12 p2 gibson white-collapse-button not-rounded flex justify-between items-center line-height-1"},[_c('span',{staticClass:"inline-block flex justify-start items-center"},[_c('span',{staticClass:"h2 line-height-1 primarycolor mt0 mr2 mb0"},[_c('i',{staticClass:"el-icon-document"})]),_vm._v(" "),_c('span',{staticClass:"h4 gibson regular line-height-1 m0 p0"},[_vm._v("Klima Plan")])]),_vm._v(" "),_c('div',{staticClass:"h4 primarycolor line-height-1 m0 p0"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"inline-block flex justify-start items-center"},[_c('span',{staticClass:"h2 line-height-1 primarycolor mt0 mr2 mb0"},[_c('i',{staticClass:"el-icon-files"})]),_vm._v(" "),_c('span',{staticClass:"h4 gibson regular line-height-1 m0 p0"},[_vm._v("Klima-kvalitetssikring")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"h4 primarycolor line-height-1 m0 p0"},[_c('i',{staticClass:"el-icon-right"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix my3 hide"},[_c('div',{staticClass:"flex flex-column justify-center items-center gibson"},[_c('div',{staticClass:"mx-auto center green-border",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border":"2px solid"}},[_c('span',{staticClass:"darkblue semi-bold",staticStyle:{"font-size":"24px"}},[_c('i',{staticClass:"el-icon-plus"})])]),_vm._v(" "),_c('span',{staticClass:"center block h4 gibson darkblue line-height-1 mt2 mb0 p0"},[_vm._v("Opret tilbud")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_vue__ = __webpack_require__(1463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5229d626_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_survey_vue__ = __webpack_require__(1464);
function injectStyle (ssrContext) {
  __webpack_require__(1462)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_survey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5229d626_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_survey_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1462 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1463 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'survey',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      customerName: 'Jane Jones',
      surveyLoading: true,
      klimaVmodelData: [],
      el: '1',
      social: '1',
      affald: '1',
      contactId: '',
      surveyData: [],
      allUserSelectedData: [],
      groupedUserSurveyData: {
        KlimaSurveyEconomy: [],
        KlimaSurveySocial: [],
        KlimaSurveyEnvironment: [],
        KlimaSurveyFag: []
      },
      surveyId: ''
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    this.displaySurvey();
    this.getUserSurvey();
    localStorage.removeItem('userSurvey');
  },

  methods: {
    displaySurvey: function displaySurvey() {
      var _this = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getSurvey'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.surveyData = res.data;
          var index = 0;
          for (var data in res.data) {
            var dataObjName = data;
            _this.klimaVmodelData.push({});
            for (var data1 in res.data[data]) {
              var dataPropName = data1;
              _this.klimaVmodelData[index][dataPropName] = 0;
            }
            index++;
          }
        } else {
          _this.$toastr('error', 'Error in displaySurvey()');
        }
      }, function (response) {
        _this.$toastr('error', 'Error in displaySurvey()');
      });
      this.surveyLoading = true;
    },
    getUserSurvey: function getUserSurvey() {
      var _this2 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        for (var economyAll in res.data.main[0].economy) {
          _this2.surveyId = res.data.main[0].klimasurveryId;
          if (res.data.main[0].economy[economyAll].value === '1') {
            _this2.allUserSelectedData.push(res.data.main[0].economy[economyAll].economicId);
          }
        }
        for (var socialAll in res.data.main[0].social) {
          if (res.data.main[0].social[socialAll].value === '1') {
            _this2.allUserSelectedData.push(res.data.main[0].social[socialAll].socialId);
          }
        }
        for (var environmentAll in res.data.main[0].environment) {
          if (res.data.main[0].environment[environmentAll].value === '1') {
            _this2.allUserSelectedData.push(res.data.main[0].environment[environmentAll].environmentId);
          }
        }
        for (var economy in res.data.main[0].economy) {
          _this2.surveyId = res.data.main[0].klimasurveryId;
          if (res.data.main[0].economy[economy].value === '1') {
            _this2.groupedUserSurveyData.KlimaSurveyEconomy.push({
              typeId: res.data.main[0].economy[economy].economicId,
              title: res.data.main[0].economy[economy].title,
              value: res.data.main[0].economy[economy].value
            });
          }
        }

        for (var social in res.data.main[0].social) {
          if (res.data.main[0].social[social].value === '1') {
            _this2.groupedUserSurveyData.KlimaSurveySocial.push({
              typeId: res.data.main[0].social[social].socialId,
              title: res.data.main[0].social[social].title,
              value: res.data.main[0].social[social].value
            });
          }
        }
        for (var environment in res.data.main[0].environment) {
          if (res.data.main[0].environment[environment].value === '1') {
            _this2.groupedUserSurveyData.KlimaSurveyEnvironment.push({
              typeId: res.data.main[0].environment[environment].environmentId,
              title: res.data.main[0].environment[environment].title,
              value: res.data.main[0].environment[environment].value
            });
          }
        }
        for (var fag in res.data.main[0].fag) {
          if (res.data.main[0].fag[fag].value !== '0') {
            _this2.groupedUserSurveyData.KlimaSurveyFag.push({
              typeId: res.data.main[0].fag[fag].fagId,
              title: res.data.main[0].fag[fag].title,
              value: res.data.main[0].fag[fag].value
            });
          }
        }
        _this2.surveyLoading = false;
        setTimeout(function () {
          _this2.countSurvey();
        }, 500);
      }, function (response) {
        _this2.$toastr('error', 'Error in getUserSurvey()');
      });
    },
    countSurvey: function countSurvey() {
      var survey = document.querySelectorAll('#klimaSurvey .survey-counter');
      for (var i = 0; i < survey.length; i++) {
        var surveyId = survey[i].id;
        var checkedSurvey = document.querySelectorAll('#klimaSurvey #' + surveyId + ' .counter-icon.el-icon-success');
        for (var x = 0; x < checkedSurvey.length; x++) {}
        document.querySelector('#klimaSurvey #' + surveyId + ' .checked-survey').innerText = checkedSurvey.length;
        var counterIcon = document.querySelectorAll('#klimaSurvey #' + surveyId + ' .counter-icon');
        for (var j = 0; j < counterIcon.length; j++) {}
        document.querySelector('#klimaSurvey #' + surveyId + ' .total-survey').innerText = counterIcon.length;
      }
    },
    editSurvey: function editSurvey(type) {
      console.log('type', type);
      localStorage.setItem('userSurvey', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.groupedUserSurveyData));
      this.$router.push('/klima/editsurvey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&surveyId=' + this.surveyId + '&type=' + type);
    },
    editFag: function editFag() {
      this.$router.push('/klima/registration?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId + '&surveyId=' + this.surveyId);
    },
    goToCheckList: function goToCheckList() {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    }
  },
  computed: {}
});

/***/ }),
/* 1464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"klimaSurvey"}},[_c('div',{staticClass:"clearfix fullHeight"},[_c('div',{staticClass:"col-12 lg-col-4 md-col-9 py3 mx-auto mt3 shadow"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer mb3",on:{"click":function($event){return _vm.goToCheckList()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),(_vm.surveyLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(2)]):_c('div',[_vm._l((_vm.surveyData),function(survey,index){return _c('div',{key:index},[(index != 'KlimaSurveyFag')?_c('div',{staticClass:"p3 highlights survey-counter mb3",attrs:{"id":index}},[_c('div',{staticClass:"primarycolor gibson flex justify-between items-center mb2"},[_c('div',{staticClass:"flex justify-start items-center"},[_c('span',{staticClass:"h3 mr1 line-height-1 mb0 p0"},[(index == 'KlimaSurveyEconomy')?_c('i',{staticClass:"el-icon-money"}):(index == 'KlimaSurveySocial')?_c('i',{staticClass:"el-icon-user"}):(index == 'KlimaSurveyEnvironment')?_c('i',{staticClass:"el-icon-c-scale-to-original"}):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"h5 m0 p0 line-height-1"},[_vm._v(_vm._s(index.replace("KlimaSurvey", "")))])]),_vm._v(" "),_vm._m(3,true)]),_vm._v(" "),_vm._l((_vm.surveyData[index]),function(surveyQuestion,index1){return _c('div',{key:index1,staticClass:"flex justify-between items-center mt2"},[_c('p',{staticClass:"h6 regular gibson darkblue line-height-1 m0 p0 caps"},[_vm._v("\r\n                  "+_vm._s(surveyQuestion)+"\r\n                ")]),_vm._v(" "),(_vm.allUserSelectedData.includes(index1))?_c('i',{staticClass:"h4 counter-icon green el-icon-success"}):_c('i',{staticClass:"h4 counter-icon red el-icon-error"})])}),_vm._v(" "),_c('button',{staticClass:"mt2 col-12 center outlined-primary-button h5 regular gibson line-height-1 p2",on:{"click":function($event){_vm.editSurvey(index.replace('KlimaSurvey', ''))}}},[_vm._m(4,true),_vm._v(" "),_c('span',[_vm._v("Ret checkliste")])])],2):_vm._e()])}),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center"},[_c('button',{staticClass:"flex col-12 justify-center items-center outlined-primary-button h5 gibson line-height-1 p2 ",on:{"click":function($event){return _vm.editFag()}}},[_vm._m(5),_vm._v(" "),_c('span',[_vm._v("Ret fag")])])])],2)]),_vm._v(" "),_c('div',{staticClass:"py4"})]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"primarycolor mb2"},[_c('span',{staticClass:"mr1 h4 m0 p0 line-height-1"},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("\r\n            Checkliste")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('span',{staticClass:"h6 line-height-1 m0 p0"},[_c('span',{staticClass:"checked-survey"},[_vm._v("0")]),_vm._v(" / "),_c('span',{staticClass:"total-survey"},[_vm._v("0")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-edit"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-edit"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsurvey_vue__ = __webpack_require__(1467);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa1f4a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_editsurvey_vue__ = __webpack_require__(1468);
function injectStyle (ssrContext) {
  __webpack_require__(1466)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_editsurvey_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa1f4a0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_editsurvey_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1466 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1467 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'editsurvey',
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__["TabContent"]
  },
  data: function data() {
    return {
      surveyLoading: true,
      salesPerson: '',
      haaId: '',
      contactId: '',
      type: '',
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      success: '',
      surveyData: '',
      userSurveyData: [],
      userRemovedSurveyData: [],
      surveyId: '',
      economy: [],
      social: [],
      environment: [],
      appointmentId: ''
    };
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    var surveyId = searchParams.get('surveyId');
    this.surveyId = surveyId;
    var type = searchParams.get('type');
    this.type = type;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    this.userSurveyData = JSON.parse(localStorage.getItem('userSurvey'));
    this.userSurveyData['KlimaSurvey' + this.type] = [];
    this.displaySurvey();
  },

  methods: {
    displaySurvey: function displaySurvey() {
      var _this = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getSurvey'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var type = 'KlimaSurvey' + _this.type;
        if (res.success) {
          _this.surveyData = res.data[type];
          _this.addClassToLastTab();
          _this.surveyLoading = false;
        } else {
          _this.$toastr('error', 'Error in displaySurvey()');
        }
      }, function (response) {
        _this.$toastr('error', 'Error in displaySurvey()');
      });
      this.surveyLoading = true;
    },
    gotoRegistration: function gotoRegistration() {
      this.$router.push('/klima/registration');
    },
    addClassToLastTab: function addClassToLastTab() {
      setTimeout(function () {
        document.querySelector('.wizard-tab-container:last-child').classList.add('last');
      }, 3000);
    },
    validateSteps: function validateSteps() {
      var tab = document.querySelectorAll('.wizard-tab-container');
      var type = 'KlimaSurvey' + this.type;
      var validation = '';
      for (var i = 0; i < tab.length; i++) {
        if (!tab[i].hasAttribute('aria-hidden')) {
          var classList = tab[i].getAttribute('class').split(' ');
          var input = document.querySelectorAll('.wizard-tab-container.' + classList[1] + ' input');
          var inputCount = 0;
          var inputYes = false;
          var id = '';
          var title = document.querySelector('.wizard-tab-container.' + classList[1] + ' #survey-title').innerText;
          for (var x = 0; x < input.length; x++) {
            if (input[x].checked === true) {
              id = input[x].id.split('-');
              if (input[x].classList.contains('yes')) {
                inputYes = true;
              } else if (input[x].classList.contains('no')) {
                inputYes = false;
              }
              inputCount++;
            }
          }
          if (inputCount > 0) {
            if (inputYes) {
              var idExist = false;
              for (var j = 0; j < this.userSurveyData[type].length; j++) {
                if (this.userSurveyData[type][j].typeId === id[1]) {
                  idExist = true;
                }
              }
              if (!idExist) {
                this.userSurveyData[type].push({
                  typeId: parseInt(id[1]),
                  title: title.toLowerCase(),
                  value: 1
                });
              }
            }
            if (!tab[i].classList.contains('last')) {
              validation = true;
            } else {
              this.onComplete();
            }
          } else {
            validation = false;
            this.$toastr('error', 'Vælg et svar');
          }
        }
      }
      return validation;
    },
    saveUserSurvey: function saveUserSurvey() {
      var _this2 = this;

      var economy = [];
      for (var x = 0; x < this.userSurveyData['KlimaSurveyEconomy'].length; x++) {
        var economyId = this.userSurveyData['KlimaSurveyEconomy'][x].typeId;
        var economyTitle = this.userSurveyData['KlimaSurveyEconomy'][x].title;
        var economyValue = this.userSurveyData['KlimaSurveyEconomy'][x].value;
        economy.push({
          usereconomyId: 0,
          economyId: parseInt(economyId),
          title: economyTitle,
          value: parseInt(economyValue)
        });
      }
      var social = [];
      for (var j = 0; j < this.userSurveyData['KlimaSurveySocial'].length; j++) {
        var socialId = this.userSurveyData['KlimaSurveySocial'][j].typeId;
        var socialTitle = this.userSurveyData['KlimaSurveySocial'][j].title;
        var socialValue = this.userSurveyData['KlimaSurveySocial'][j].value;
        social.push({
          usersocialId: 0,
          socialId: parseInt(socialId),
          title: socialTitle,
          value: parseInt(socialValue)
        });
      }
      var environment = [];
      for (var k = 0; k < this.userSurveyData['KlimaSurveyEnvironment'].length; k++) {
        var environmentId = this.userSurveyData['KlimaSurveyEnvironment'][k].typeId;
        var environmentTitle = this.userSurveyData['KlimaSurveyEnvironment'][k].title;
        var environmentValue = this.userSurveyData['KlimaSurveyEnvironment'][k].value;
        environment.push({
          usersocialId: 0,
          environmentId: parseInt(environmentId),
          title: environmentTitle,
          value: parseInt(environmentValue)
        });
      }
      var fag = [];
      for (var l = 0; l < this.userSurveyData['KlimaSurveyFag'].length; l++) {
        var fagId = this.userSurveyData['KlimaSurveyFag'][l].typeId;
        var fagTitle = this.userSurveyData['KlimaSurveyFag'][l].title;
        var fagValue = this.userSurveyData['KlimaSurveyFag'][l].value;
        fag.push({
          userfagId: 0,
          fagId: parseInt(fagId),
          title: fagTitle,
          value: parseInt(fagValue)
        });
      }

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          klimasurveryId: this.surveyId,
          operation: 'addSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          economy: economy,
          social: social,
          environment: environment,
          fag: fag
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.gotoSurvey();
          _this2.surveyLoading = false;
          _this2.$toastr('success', 'Opdateret');
        } else {
          _this2.$toastr('error', 'Error in saveUserSurvey()');
        }
      }, function (response) {
        _this2.$toastr('error', 'Error in saveUserSurvey()');
      });
      this.surveyLoading = true;
    },
    onComplete: function onComplete() {
      this.saveUserSurvey();
    },
    gotoSurvey: function gotoSurvey() {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    }
  },
  computed: {}
});

/***/ }),
/* 1468 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"editSurvey"}},[_c('div',{staticClass:"col-12 lg-col-4 md-col-9 py3 shadow mx-auto mt3"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix mt3 px3 pt2 pb3 highlights relative"},[_vm._m(1),_vm._v(" "),(_vm.surveyLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(2)]):_c('div',[(!_vm.success)?_c('form-wizard',{ref:"wizard",staticClass:"px1",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"wizard-footer-left flex-auto"},[_c('wizard-button',{staticClass:"flex items-start justify-start",nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"block flex flex-column justify-start items-start"},[_c('span',{staticClass:"block flex justify-start"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Tilbage")])])])],1),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right flex-auto"},[_c('wizard-button',{staticClass:"flex flex-column items-end justify-end px0 col-12",nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"block flex flex-column justify-end items-end"},[_c('span',{staticClass:"block flex justify-end"},[_c('i',{staticClass:"el-icon-right"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Næste")])])])],1)]}}],null,false,2396415571)},_vm._l((_vm.surveyData),function(survey,index){return _c('tab-content',{key:index,class:'survey-' + index,attrs:{"title":"1","before-change":_vm.validateSteps}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 gibson semi-bold center primarycolor line-height-1"},[_vm._v(_vm._s(_vm.type))]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('p',{staticClass:"h3 regular center gibson darkblue line-height-3 caps",attrs:{"id":"survey-title"}},[_vm._v("\r\n                  "+_vm._s(survey)+"\r\n                ")]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"flex col-12 px0 my2"},[_c('div',{staticClass:"col col-6 px1 editSurvey"},[_c('div',{staticClass:"center itemSelect relative"},[_c('input',{staticClass:"col-12 fullHeight absolute left-0 z2 pointer yes",staticStyle:{"display":"block","opacity":"0"},attrs:{"id":'isYes-' + index,"name":'radio-' + index,"type":"radio"}}),_vm._v(" "),_c('label',{staticClass:"yes pointer block center col-12 p2 border green-border",attrs:{"for":"isYes"}},[_c('i',{staticClass:"h2 el-icon-check"})])])]),_vm._v(" "),_c('div',{staticClass:"col col-6 px1 editSurvey"},[_c('div',{staticClass:"center itemSelect relative"},[_c('input',{staticClass:"col-12 block fullHeight absolute left-0 z2 pointer no",staticStyle:{"display":"block","opacity":"0"},attrs:{"id":'isNo-' + index,"name":'radio-' + index,"type":"radio"}}),_vm._v(" "),_c('label',{staticClass:"no pointer block center col-12 p2 border red-border",attrs:{"for":"isNo"}},[_c('i',{staticClass:"h2 el-icon-close"})])])])])])])}),1):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"hide clearfix"},[_c('b-progress',{attrs:{"height":"4px","value":_vm.value,"max":_vm.max}})],1),_vm._v(" "),_c('div',{staticClass:"hide flex col-12 px0 my2"},[_c('button',{staticClass:"col-12 outlined-disabled-button px2 py3 h4 regular gibson line-height-1",on:{"click":function($event){return _vm.gotoRegistration()}}},[_c('span',[_vm._v("Næste")]),_vm._v(" "),_vm._m(3)])]),_vm._v(" "),_c('div',{staticClass:"py4"})]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute center top-0 left-0 right-0",staticStyle:{"top":"-18px"}},[_c('img',{attrs:{"src":"static/svg/h.svg","width":"36","height":"36","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-arrow-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__ = __webpack_require__(1471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dccdf6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__ = __webpack_require__(1472);
function injectStyle (ssrContext) {
  __webpack_require__(1470)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_registration_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_89dccdf6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_registration_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1471 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'regiatration',
  components: {},
  data: function data() {
    return {
      surveyLoading: true,
      surveyData: [],
      groupedUserSurveyData: {
        KlimaSurveyEconomy: [],
        KlimaSurveySocial: [],
        KlimaSurveyEnvironment: [],
        KlimaSurveyFag: []
      },
      appointmentId: ''
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    this.getUserSurvey();
  },

  methods: {
    getUserSurvey: function getUserSurvey() {
      var _this = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getUserSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          for (var economy in res.data.main[0].economy) {
            _this.surveyId = res.data.main[0].klimasurveryId;
            if (res.data.main[0].economy[economy].value === '1') {
              _this.groupedUserSurveyData.KlimaSurveyEconomy.push({
                typeId: res.data.main[0].economy[economy].economicId,
                title: res.data.main[0].economy[economy].title,
                value: res.data.main[0].economy[economy].value
              });
            }
          }
          for (var social in res.data.main[0].social) {
            if (res.data.main[0].social[social].value === '1') {
              _this.groupedUserSurveyData.KlimaSurveySocial.push({
                typeId: res.data.main[0].social[social].socialId,
                title: res.data.main[0].social[social].title,
                value: res.data.main[0].social[social].value
              });
            }
          }
          for (var environment in res.data.main[0].environment) {
            if (res.data.main[0].environment[environment].value === '1') {
              _this.groupedUserSurveyData.KlimaSurveyEnvironment.push({
                typeId: res.data.main[0].environment[environment].environmentId,
                title: res.data.main[0].environment[environment].title,
                value: res.data.main[0].environment[environment].value
              });
            }
          }
          for (var fag in res.data.main[0].fag) {
            _this.groupedUserSurveyData.KlimaSurveyFag.push({
              typeId: res.data.main[0].fag[fag].fagId,
              title: res.data.main[0].fag[fag].title,
              value: res.data.main[0].fag[fag].value
            });
          }
          _this.surveyLoading = false;
        } else {
          _this.$toastr('error', 'Error in getUserSurvey()');
        }
      }, function (response) {
        _this.$toastr('error', 'Error in getUserSurvey()');
      });
      this.surveyLoading = true;
    },
    radioChanged: function radioChanged(typeId) {
      var inputVal = document.querySelector('#fag-' + typeId + ' label.el-radio-button.is-focus').id.split('-');
      for (var l = 0; l < this.groupedUserSurveyData['KlimaSurveyFag'].length; l++) {
        if (this.groupedUserSurveyData['KlimaSurveyFag'][l].typeId === typeId) {
          this.groupedUserSurveyData['KlimaSurveyFag'][l].value = inputVal[1];
        }
      }
    },
    saveUserSurvey: function saveUserSurvey() {
      var _this2 = this;

      var economy = [];
      for (var x = 0; x < this.groupedUserSurveyData['KlimaSurveyEconomy'].length; x++) {
        var economyId = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].typeId;
        var economyTitle = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].title;
        var economyValue = this.groupedUserSurveyData['KlimaSurveyEconomy'][x].value;
        economy.push({
          usereconomyId: 0,
          economyId: parseInt(economyId),
          title: economyTitle,
          value: parseInt(economyValue)
        });
      }
      var social = [];
      for (var j = 0; j < this.groupedUserSurveyData['KlimaSurveySocial'].length; j++) {
        var socialId = this.groupedUserSurveyData['KlimaSurveySocial'][j].typeId;
        var socialTitle = this.groupedUserSurveyData['KlimaSurveySocial'][j].title;
        var socialValue = this.groupedUserSurveyData['KlimaSurveySocial'][j].value;
        social.push({
          usersocialId: 0,
          socialId: parseInt(socialId),
          title: socialTitle,
          value: parseInt(socialValue)
        });
      }
      var environment = [];
      for (var k = 0; k < this.groupedUserSurveyData['KlimaSurveyEnvironment'].length; k++) {
        var environmentId = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].typeId;
        var environmentTitle = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].title;
        var environmentValue = this.groupedUserSurveyData['KlimaSurveyEnvironment'][k].value;
        environment.push({
          usersocialId: 0,
          environmentId: parseInt(environmentId),
          title: environmentTitle,
          value: parseInt(environmentValue)
        });
      }
      var fag = [];
      for (var l = 0; l < this.groupedUserSurveyData['KlimaSurveyFag'].length; l++) {
        var fagId = this.groupedUserSurveyData['KlimaSurveyFag'][l].typeId;
        var fagTitle = this.groupedUserSurveyData['KlimaSurveyFag'][l].title;
        var fagValue = this.groupedUserSurveyData['KlimaSurveyFag'][l].value;
        fag.push({
          userfagId: 0,
          fagId: parseInt(fagId),
          title: fagTitle,
          value: parseInt(fagValue)
        });
      }

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          klimasurveryId: this.surveyId,
          operation: 'addSurvey',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          economy: economy,
          social: social,
          environment: environment,
          fag: fag
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.surveyLoading = false;
          _this2.$toastr('success', 'Opdateret');
        } else {
          _this2.$toastr('error', 'Error in saveUserSurvey()');
        }
      }, function (response) {
        _this2.$toastr('error', 'Error in saveUserSurvey()');
      });
      this.surveyLoading = true;
    },
    gotoSurvey: function gotoSurvey() {
      this.$router.push('/klima/survey?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    }
  },
  computed: {}
});

/***/ }),
/* 1472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-12 lg-col-4 md-col-9 py3 mb4 shadow mx-auto"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer",on:{"click":function($event){return _vm.gotoSurvey()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('div',{staticClass:"clearfix px3 py4 highlights relative"},[_vm._m(1),_vm._v(" "),(_vm.surveyLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(2)]):_c('div',[_c('p',{staticClass:"h4 gibson regular center primarycolor line-height-1"},[_vm._v("\n          Oprettelse\n        ")]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_c('p',{staticClass:"h3 regular center gibson darkblue line-height-3"},[_vm._v("\n          Hvilke fag er med i din klimaentreprise?\n        ")]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),_vm._l((_vm.groupedUserSurveyData['KlimaSurveyFag']),function(fag,index){return _c('div',{key:index,staticClass:"clearfix mb3",attrs:{"id":'fag-' + fag.typeId}},[_c('p',{staticClass:"h3 center primarycolor gibson line-height-1 mb3"},[_vm._v("\n            "+_vm._s(fag.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center"},[(fag.value === '0')?_c('el-radio-group',{attrs:{"value":"Ikke med"},on:{"change":function($event){return _vm.radioChanged(fag.typeId)}}},[_c('el-radio-button',{attrs:{"id":"val-0","name":'radio-' + index,"label":"Ikke med"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-1","name":'radio-' + index,"label":"Hoved"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-2","name":'radio-' + index,"label":"Fag"}})],1):(fag.value === '1')?_c('el-radio-group',{attrs:{"value":"Hoved"},on:{"change":function($event){return _vm.radioChanged(fag.typeId)}}},[_c('el-radio-button',{attrs:{"id":"val-0","name":'radio-' + index,"label":"Ikke med"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-1","name":'radio-' + index,"label":"Hoved"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-2","name":'radio-' + index,"label":"Fag"}})],1):(fag.value === '2')?_c('el-radio-group',{attrs:{"value":"Fag"},on:{"change":function($event){return _vm.radioChanged(fag.typeId)}}},[_c('el-radio-button',{attrs:{"id":"val-0","name":'radio-' + index,"label":"Ikke med"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-1","name":'radio-' + index,"label":"Hoved"}}),_vm._v(" "),_c('el-radio-button',{attrs:{"id":"val-2","name":'radio-' + index,"label":"Fag"}})],1):_vm._e()],1)])}),_vm._v(" "),_c('button',{staticClass:"col-6 mx-auto action-button h4 my3 regular flex justify-center items-center gibson line-height-1 p2",on:{"click":function($event){return _vm.saveUserSurvey()}}},[_c('span',[_vm._v("Gem")]),_vm._m(3)])],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute center top-0 left-0 right-0",staticStyle:{"top":"-16px"}},[_c('img',{attrs:{"src":"static/svg/h.svg","width":"36","height":"36","alt":""}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pl1"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1473 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dokumentation_vue__ = __webpack_require__(1475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c103ea6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_dokumentation_vue__ = __webpack_require__(1476);
function injectStyle (ssrContext) {
  __webpack_require__(1474)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_dokumentation_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c103ea6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_dokumentation_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1475 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__ = __webpack_require__(59);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_dropzone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__ = __webpack_require__(48);







/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'klimadokumentation',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    Dropzone: __WEBPACK_IMPORTED_MODULE_3_vue2_dropzone___default.a,
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_4__components_file_upload_input__["a" /* default */]
  },
  data: function data() {
    return {
      taskLoading: true,
      uploadLoading: false,
      previewLoading: true,
      sendLoading: false,
      images: 0,
      documents: 0,
      contactId: '',
      klimaId: '',
      offer: '',
      taskData: [],
      progressbar: [{
        progress1: 100,
        progress2: 0
      }],
      previewDialog: false,
      pdf: '',
      disableSend: true,
      allUserPlan: [],
      gatheredUserPlan: [],
      fileList: [],
      activePlan: '',
      activeFile: '',
      openCollapse: false
    };
  },
  created: function created() {
    var pageName = this.$route.name;
    if (pageName === 'klima') {
      console.log('this is Klima');
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var urlStr = window.location.href;
    var url = new URL(urlStr.replace('/#', ''));
    var searchParams = url.searchParams;
    var klimaId = searchParams.get('klimaId');
    this.klimaId = klimaId;
    var contactId = searchParams.get('contactId');
    this.contactId = contactId;
    var appointmentId = searchParams.get('appointmentId');
    this.appointmentId = appointmentId;
    this.displayTask();
  },
  dropzoneSettings: function dropzoneSettings() {
    var defaultValues = {
      thumbnailWidth: 200,
      thumbnailHeight: 200
    };
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(this.options).forEach(function (key) {
      defaultValues[key] = this.options[key];
    }, this);
    if (this.awss3 !== null) {
      defaultValues['autoProcessQueue'] = false;
      this.isS3 = true;
      if (this.options.autoProcessQueue !== undefined) {
        this.wasQueueAutoProcess = this.options.autoProcessQueue;
      }
    }
    return defaultValues;
  },

  methods: {
    goToCheckList: function goToCheckList() {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    },
    uploadDocument: function uploadDocument(doc) {
      var _this = this;

      var docs = doc.replace(' ', '%20');
      var description = document.querySelector('.wizard-tab-container #task-' + this.activePlan + ' input.file-description').value;
      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          levid: this.haaId,
          operation: 'uploadKlima',
          file: docs,
          description: description
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.addFile(res.data.fileId);
        } else {
          _this.$toastr('error', 'Error in uploadDocument()');
        }
      }, function (response) {
        _this.$toastr('error', 'Error in uploadDocument()');
      });
    },
    addFile: function addFile(fileId) {
      for (var i = 0; i < this.allUserPlan.length; i++) {
        if (this.allUserPlan[i].userplanId === parseInt(this.activePlan)) {
          if (this.activeFile === 'file') {
            this.allUserPlan[i].files.push(fileId);
          } else if (this.activeFile === 'camera') {
            this.allUserPlan[i].images.push(fileId);
          }
          this.updateDocument();
        }
      }
    },
    updateDocument: function updateDocument() {
      var _this2 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          draft: 0,
          klimaId: this.klimaId,
          operation: 'addKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          info: '',
          offerId: this.offer,
          userplan: this.allUserPlan,
          usersurvey: this.gatheredUserPlan
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.allUserPlan = [];
          _this2.displayTask();
        } else {
          _this2.$toastr('error', 'Error in updateDocument()');
        }
      }, function (response) {
        _this2.$toastr('error', 'Error in updateDocument()');
      });
    },
    confirmDelete: function confirmDelete(id, type, index) {
      var _this3 = this;

      return function (dialog) {
        return _this3.deleteImage(id, type, index);
      };
    },
    deleteImage: function deleteImage(id, type, index) {
      document.querySelector('.docs-' + id).remove();
      if (type === 'file') {
        for (var i = 0; i < this.allUserPlan[index].files.length; i++) {
          if (this.allUserPlan[index].files[i] === parseInt(id)) {
            this.allUserPlan[index].files.splice(i, 1);
          }
        }
      } else {
        for (var j = 0; j < this.allUserPlan[index].images.length; j++) {
          if (this.allUserPlan[index].images[j] === parseInt(id)) {
            this.allUserPlan[index].images.splice(j, 1);
          }
        }
      }
      this.updateDocument();
      this.$toastr('success', 'Fjernet');
    },
    handleFileUpload: function handleFileUpload(file) {
      var doc = 'https://www.kundematch.dk/HenttilbudImg.php?img=' + file[file.length - 1];
      this.uploadDocument(doc);
      this.uploadLoading = true;
    },
    displayTask: function displayTask() {
      var _this4 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'getKlima',
          ContactId: this.contactId,
          CompanyId: this.haaId
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          for (var i = 0; i < res.data.main.length; i++) {
            if (res.data.main[i].klimaId === _this4.klimaId) {
              _this4.taskData = res.data.main[i].user_group;
              _this4.offer = res.data.main[i].offer;
              for (var x = 0; x < res.data.main[i].user_group.length; x++) {
                var planId = res.data.main[i].user_group[x].userplanId;
                var planTitle = res.data.main[i].user_group[x].title;
                var planFile = [];
                if (res.data.main[i].user_group[x].file !== false && res.data.main[i].user_group[x].file !== null) {
                  for (var j = 0; j < res.data.main[i].user_group[x].file.length; j++) {
                    var fileId = res.data.main[i].user_group[x].file[j];
                    planFile.push(parseInt(fileId));
                  }
                }
                var planImage = [];
                if (res.data.main[i].user_group[x].image !== false && res.data.main[i].user_group[x].image !== null) {
                  for (var k = 0; k < res.data.main[i].user_group[x].image.length; k++) {
                    var imageId = res.data.main[i].user_group[x].image[k];
                    planImage.push(parseInt(imageId));
                  }
                }
                var planInfo = res.data.main[i].user_group[x].info;
                var planUserType = res.data.main[i].user_group[x].user_type;
                if (planUserType.length === 0) {
                  planUserType = [];
                }
                var planUserSurvey = [];
                if (res.data.main[i].user_group[x].user_survey.length > 0) {
                  for (var c = 0; c < res.data.main[i].user_group[x].user_survey.length; c++) {
                    var surveyId = res.data.main[i].user_group[x].user_survey[c];
                    planUserSurvey.push(parseInt(surveyId));
                  }
                }
                _this4.allUserPlan.push({
                  userplanId: parseInt(planId),
                  title: planTitle,
                  files: planFile,
                  images: planImage,
                  info: planInfo,
                  usertype: planUserType,
                  usersurvey: planUserSurvey
                });
                _this4.gatheredUserPlan = res.data.main[i].user_survey;
              }
              setTimeout(function () {
                var btnFile = document.querySelectorAll('.klima-documentation.btn-file > .input-group > button');
                for (var i = 0; i < btnFile.length; i++) {
                  btnFile[i].innerHTML = '<button class="action-button upload-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded m0"><span class="mr2"><i class="el-icon-paperclip"></i></span><span>VEDHÆFTET</span></button>';
                }
                var btnCamera = document.querySelectorAll('.klima-documentation.btn-camera > .input-group > button');
                for (var j = 0; j < btnCamera.length; j++) {
                  btnCamera[j].innerHTML = '<button class="action-button upload-button p2 h4 col-12 gibson regular line-height-1 flex justify-center items-center border rounded m0"><span class="mr2"><i class="el-icon-camera"></i></span><span>KAMERA</span></button>';
                }
              }, 500);
              _this4.taskLoading = false;
              _this4.uploadLoading = false;
            }
          }
        } else {
          _this4.$toastr('error', 'Error in displayTask()');
        }
      }, function (response) {
        _this4.$toastr('error', 'Error in displayTask()');
      });
    },
    activeFileType: function activeFileType(type) {
      this.activeFile = type;
      var acceptedFiles = '';
      if (type === 'file') {
        acceptedFiles = '.doc, .pdf';
      } else if (type === 'camera') {
        acceptedFiles = '.jpg, .png';
      }
      document.querySelector('.wizard-tab-container #task-' + this.activePlan + ' .btn-' + type + ' input').setAttribute('accept', acceptedFiles);
    },
    activePlanId: function activePlanId(planId) {
      this.activePlan = planId;
    },
    validateAllAcceptButton: function validateAllAcceptButton() {
      var _this5 = this;

      setTimeout(function () {
        var collapseBtn = document.querySelectorAll('.klima-docs .collapse');
        _this5.openCollapse = false;
        for (var i = 0; i < collapseBtn.length; i++) {
          if (collapseBtn[i].classList.contains('show')) {
            _this5.openCollapse = true;
          }
        }
      }, 500);
    },
    validateFirstStep: function validateFirstStep() {
      var validation = '';
      if (!this.openCollapse) {
        validation = true;
        this.progressbar[0].progress2 = 100;
      } else {
        validation = false;
        this.$toastr('error', 'Klik på knappen Accepter');
      }
      return validation;
    },
    validateSecondStep: function validateSecondStep() {
      var validation = '';
      if (this.disableSend) {
        validation = false;
      } else {
        validation = true;
      }
      if (validation) {
        this.onComplete();
      } else {
        this.$toastr('error', 'Se eksempler på dokumenterne');
      }
      return validation;
    },
    onComplete: function onComplete() {
      this.sendReport();
    },
    previewDocuments: function previewDocuments() {
      var _this6 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'previewKlimaReport',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          klimaId: this.klimaId,
          to: 'partner'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.pdf = res.data.pdf;
          _this6.previewLoading = false;
          _this6.disableSend = false;
        } else {
          _this6.$toastr('error', 'Error in previewDocuments()');
        }
      }, function (response) {
        _this6.$toastr('error', 'Error in previewDocuments()');
      });
      this.previewDialog = true;
      this.previewLoading = true;
    },
    sendReport: function sendReport() {
      var _this7 = this;

      var data = {
        operation: 'klimaApi',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        ContactId: this.contactId,
        CompanyId: this.haaId,
        parameters: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()({
          operation: 'sendKlimaReport',
          ContactId: this.contactId,
          CompanyId: this.haaId,
          klimaId: this.klimaId,
          to: 'customer'
        })
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this7.$refs.simplert.openSimplert(obj);

          setTimeout(function () {
            _this7.gotoChecklist();
          }, 3000);
        } else {
          _this7.$toastr('error', 'Error in sendReport()');
        }
      }, function (response) {
        _this7.$toastr('error', 'Error in sendReport()');
      });
      this.sendLoading = true;
    },
    gotoChecklist: function gotoChecklist() {
      this.$router.push('/klima/checklist?appointmentId=' + this.appointmentId + '&contactId=' + this.contactId);
    }
  },
  mounted: function mounted() {}
});

/***/ }),
/* 1476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"klimaDocuments"}},[_c('div',{staticClass:"clearfix fullHeight"},[_c('div',{staticClass:"col-12 lg-col-4 md-col-9 py3 mx-auto mt3 shadow"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center pointer",on:{"click":function($event){return _vm.goToCheckList()}}},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])]),_vm._v(" "),_c('form-wizard',{ref:"wizard",staticClass:"px1",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return (!_vm.taskLoading && !_vm.uploadLoading && !_vm.sendLoading)?[_c('div',{staticClass:"wizard-footer-left flex-auto col-4"},[_c('wizard-button',{staticClass:"flex items-start justify-start",nativeOn:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"block flex flex-column justify-start items-start"},[_c('span',{staticClass:"block flex justify-start"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Tilbage")])])])],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column justify-center items-center gibson invisible"},[[_c('div',{staticClass:"mx-auto center border darkblue-border",staticStyle:{"height":"48px","width":"48px","border-radius":"50%","line-height":"48px","border":"2px solid!important"},on:{"click":function($event){_vm.unitDialogVisible = true}}},[_c('span',{staticClass:"green semi-bold",staticStyle:{"font-size":"24px"}},[_c('i',{staticClass:"el-icon-plus"})])])],_vm._v(" "),_c('span',{staticClass:"center block h6 caps gibson darkblue line-height-1 mt2 mb0 p0"},[_vm._v("Tilføj enhed")])],2),_vm._v(" "),_c('div',{staticClass:"wizard-footer-right flex-auto"},[(!props.isLastStep)?_c('wizard-button',{staticClass:"flex flex-column items-end justify-end px0 col-12",nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"block flex flex-column justify-end items-end"},[_c('span',{staticClass:"block flex justify-end"},[_c('i',{staticClass:"el-icon-right"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("Næste")])])]):_vm._e(),_vm._v(" "),(props.isLastStep)?_c('wizard-button',{staticClass:"flex flex-column items-end justify-end px0 col-12",attrs:{"type":"button"},nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"block flex flex-column justify-start items-end"},[_c('span',{staticClass:"block flex justify-end"},[_c('i',{staticClass:"el-icon-right"})]),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 mt2 regular darkblue mb0 block"},[_vm._v("\n                  "+_vm._s(props.isLastStep ? 'Færdig' : 'Næste')+"\n                ")])])]):_vm._e()],1)]:undefined}}],null,true)},[_c('tab-content',{staticClass:"klima-docs",attrs:{"title":"1 ud af 2","before-change":_vm.validateFirstStep}},[_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"h5 textgrey custom-letter-spacing gibson line-height-3"},[_vm._v("\n              Dine klimaforbedringer skal dokumenteres i rapporten. Vedhæft billeder og/eller kvitteringer som bevis for at forbedringen er udført.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"highlights p3"},[_c('p',{staticClass:"h5 gibson darkblue line-height-1 m0 p0"},[_vm._v("\n              Dokumentation\n            ")]),_vm._v(" "),_c('div',{staticClass:"py2"}),_vm._v(" "),(_vm.taskLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',_vm._l((_vm.taskData),function(task,index){return _c('div',{key:index,attrs:{"id":'task-' + task.userplanId},on:{"mouseover":function($event){return _vm.activePlanId(task.userplanId)}}},[_c('div',{staticClass:"col-12 mb2 px0 flex justify-between items-center"},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('documents-' + index),expression:"'documents-' + index"}],staticClass:"pl0 toggle-label-btn border-none white-background darkblue flex justify-start items-center",on:{"click":function($event){return _vm.validateAllAcceptButton()}}},[_c('span',{staticClass:"when-opened mr1"},[_c('i',{staticClass:"el-icon-caret-bottom mediumgrey"})]),_vm._v(" "),_c('span',{staticClass:"when-closed mr1"},[_c('i',{staticClass:"el-icon-caret-right darkblue"})]),_vm._v(" "),_c('p',{staticClass:"h5 m0 p0 caps semi-bold gibson darkblue line-height-1"},[_vm._v("\n                      "+_vm._s(task.title)+"\n                    ")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-end items-end"},[(task.fileList.length > 0)?_c('span',{staticClass:"h4 mediumgrey mr2"},[_c('img',{attrs:{"src":"/static/svg/icon_paperclip-green.svg"}})]):_c('span',{staticClass:"h4 mediumgrey mr2"},[_c('img',{attrs:{"src":"/static/svg/icon_paperclip.svg"}})]),_vm._v(" "),(task.imageList.length > 0)?_c('span',{staticClass:"h4 mediumgrey"},[_c('img',{attrs:{"src":"/static/svg/camera-green.svg"}})]):_c('span',{staticClass:"h4 mediumgrey"},[_c('img',{attrs:{"src":"/static/svg/camera.svg"}})])])]),_vm._v(" "),_c('b-collapse',{attrs:{"id":'documents-' + index}},[(_vm.uploadLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[(task.imageList.length > 0 || task.fileList.length > 0)?_c('div',[_c('div',_vm._l((task.fileList),function(file,index1){return _c('div',{key:index1,class:'flex px3 mb3 docs-' + file.id},[_c('div',{staticClass:"col-11 p0 mr2"},[_c('div',{staticClass:"flex flex-wrap mb2"},[_c('img',{staticClass:"mr2",attrs:{"src":"/static/svg/icon_paperclip.svg"}}),_vm._v(" "),_c('a',{staticClass:"no-hover",attrs:{"target":"_blank","href":file.url}},[_vm._v(_vm._s(file.id))])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('p',{staticClass:"m0"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Beskrivelse:")]),_vm._v("\n                                "+_vm._s(file.description)+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-1 p0 flex flex-wrap items-center"},[_c('a',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(file.id, 'file', index), message: 'Vil du fjerne denne fil?', okText: 'Ja', cancelText: 'Nej'}),expression:"{ok: confirmDelete(file.id, 'file', index), message: 'Vil du fjerne denne fil?', okText: 'Ja', cancelText: 'Nej'}"}],staticClass:"red bold pointer no-hover"},[_c('i',{staticClass:"el-icon-delete"})])])])}),0),_vm._v(" "),_c('div',_vm._l((task.imageList),function(img,index2){return _c('div',{key:index2,class:'flex px3 mb3 docs-' + img.id},[_c('div',{staticClass:"col-11 p0 mr2"},[_c('div',{staticClass:"flex flex-wrap mb2"},[_c('img',{staticClass:"mr2",attrs:{"src":"/static/svg/camera.svg"}}),_vm._v(" "),_c('a',{staticClass:"no-hover",attrs:{"target":"_blank","href":img.url}},[_vm._v(_vm._s(img.id))])]),_vm._v(" "),_c('div',{staticClass:"block"},[_c('p',{staticClass:"m0"},[_c('span',{staticClass:"semi-bold block"},[_vm._v("Beskrivelse:")]),_vm._v("\n                                "+_vm._s(img.description)+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"col-1 p0 flex flex-wrap items-center"},[_c('a',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(img.id, 'image', index), message: 'Vil du fjerne dette billede?', okText: 'Ja', cancelText: 'Nej'}),expression:"{ok: confirmDelete(img.id, 'image', index), message: 'Vil du fjerne dette billede?', okText: 'Ja', cancelText: 'Nej'}"}],staticClass:"red bold pointer no-hover"},[_c('i',{staticClass:"el-icon-delete"})])])])}),0)]):_vm._e()]),_vm._v(" "),(!_vm.uploadLoading)?_c('div',[_c('b-form-input',{staticClass:"file-description col-12 mb2",attrs:{"placeholder":"Beskrivelse"}}),_vm._v(" "),_c('div',{staticClass:"pt2 border-top transparent-border flex justify-center items-center mb3"},[_c('div',{staticClass:"col-6 p0",on:{"click":function($event){return _vm.activeFileType('file')}}},[_c('file-upload-input',{staticClass:"klima-documentation btn-file",attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 p0",on:{"click":function($event){return _vm.activeFileType('camera')}}},[_c('file-upload-input',{staticClass:"klima-documentation btn-camera",attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}})],1)])],1):_vm._e(),_vm._v(" "),(!_vm.uploadLoading)?_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:('documents-' + index),expression:"'documents-' + index"}],staticClass:"action-button p2 h4 gibson regular line-height-1 col-12 flex justify-center items-center mb3",on:{"click":function($event){return _vm.validateAllAcceptButton()}}},[_c('span',[_vm._v("ACCEPTER")])]):_vm._e()])],1)}),0)])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"1 ud af 2","before-change":_vm.validateSecondStep}},[_c('div',{staticClass:"mb3"},[_c('p',{staticClass:"h5 textgrey custom-letter-spacing gibson line-height-3"},[_vm._v("\n              Se og afslut rapporten.\n            ")])]),_vm._v(" "),_c('div',{staticClass:"highlights p3"},[_c('p',{staticClass:"h5 gibson darkblue line-height-1 m0 p0"},[_vm._v("\n              Godkendelse\n            ")]),_vm._v(" "),(_vm.sendLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',{staticClass:"py4"},[_c('div',{staticClass:"col-12 mb2 px0"},[_c('button',{staticClass:"action-button preview-button p2 h5 gibson regular line-height-1 col-12 mb4",on:{"click":function($event){return _vm.previewDocuments()}}},[_c('span',[_vm._v("PREVIEW")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",attrs:{"disabled":_vm.disableSend},on:{"click":function($event){return _vm.sendReport()}}},[_c('span',[_vm._v("AFSLUT RAPPORT")])])])])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center col-12 px0 mt3 mb2"},[_c('div',{staticClass:"col-6 px1"},[_c('el-progress',{attrs:{"percentage":_vm.progressbar[0].progress1,"show-text":false,"color":"#4dcf55"}})],1),_vm._v(" "),_c('div',{staticClass:"col-6 px1"},[_c('el-progress',{attrs:{"percentage":_vm.progressbar[0].progress2,"show-text":false,"color":"#4dcf55"}})],1)])],1),_vm._v(" "),_c('el-dialog',{attrs:{"title":"Preview","visible":_vm.previewDialog,"width":"70%","left":""},on:{"update:visible":function($event){_vm.previewDialog=$event}}},[(_vm.previewLoading)?_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',[_c('iframe',{staticClass:"col-12 iframe-height",attrs:{"src":_vm.pdf,"title":"W3Schools Free Online Web Tutorials"}})]),_vm._v(" "),_c('span',{staticClass:"dialog-footer flex justify-end",attrs:{"slot":"footer"},slot:"footer"},[_c('div',{},[_c('b-btn',{staticClass:"standard-button rounded",attrs:{"type":"buttom","variant":"secondary","size":"lg"},on:{"click":function($event){_vm.previewDialog = false}}},[_vm._v("\n              Luk\n            ")])],1)])])],1)]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1477 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recommend_vue__ = __webpack_require__(1479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a478961a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_recommend_vue__ = __webpack_require__(1480);
function injectStyle (ssrContext) {
  __webpack_require__(1478)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_recommend_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a478961a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_recommend_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1478 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1479 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_full_loading__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'recommend',
  components: {
    loading: __WEBPACK_IMPORTED_MODULE_0_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a
  },
  data: function data() {
    return {
      haaid: '',
      show: false,
      showMobile: false,
      isLoadingRecommend: false,
      label: 'Loading...',
      sampleReviewcs: '',
      telephone: '',
      overlay: 1,
      message: 'Hej. Jeg vil gerne anbefale dig at melde dig ind hos Håndværker.dk. Det er en hjemmeside, der giver fagfolk som os god markedsføring og opgaver fra boligejere. Hvis du bruger mit link til at melde dig ind hos Håndværker.dk, så modtager du et gratis \n "Fri entré"- kort til tivoli. https://www.haandvaerker.dk/business/referral/' + localStorage.getItem('haaid') + ''
    };
  },

  methods: {
    sendSMS: function sendSMS() {
      var _this = this;

      if (this.telephone.length !== 8) {
        this.$toastr('error', 'Hov, noget gik galt. Nummeret skal indeholde 8 cifre.');
        return;
      }
      this.isLoadingRecommend = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'addrecommendsms', salesPerson: this.salesPerson, telephone: this.telephone, message: this.message };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this.$router.push('/login');
        }
        if (res.success) {
          _this.telephone = '';
          var closeFn = function closeFn() {
            this.$router.push('/medlemsfordele');
          };
          var obj = {
            customClass: 'confirmDialog',
            customIconUrl: '',
            message: '<div class="flex flex-column justify-center items-center pt3"><img src="/static/svg/blue-checkmark.svg" width="50" height="50"><p class="h3 mt3 regular gibson darkblue line-height-2">Tak!</p></div>',
            type: 'success',
            customCloseBtnClass: 'muted-button gibson border-none not-rounded h5 regular p2 px3 right',
            customCloseBtnText: 'Luk',
            onClose: closeFn
          };
          _this.$refs.simplert.openSimplert(obj);
          _this.isLoadingRecommend = false;
        } else {
          alert(res.message);
          _this.isLoadingRecommend = false;
        }
      }, function (response) {
        alert('error');
        _this.isLoadingRecommend = false;
      });
      window.dataLayer.push({ event: 'partner_recommend_sms' });
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },
  mounted: function mounted() {
    try {} catch (e) {}
  }
});

/***/ }),
/* 1480 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[(!_vm.showMobile)?_c('div',{staticClass:"flex justify-start gibson mt2 pl4 mb2"},[_c('div',{staticClass:"col-7"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"col-12"},[_c('form',{staticClass:"highlights p3",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sendSMS()}}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 mb3"},[_vm._v("\n              Indtast din kammerat's nummer her\n            ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telephone),expression:"telephone"}],staticClass:"col-12 h5 p2 darkblue border-none gibson lightgrey-background",attrs:{"type":"text","placeholder":"Telefonnummer","required":""},domProps:{"value":(_vm.telephone)},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sendSMS()},"input":function($event){if($event.target.composing){ return; }_vm.telephone=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"col-12 border-none p2 h5 book gibson darkblue line-height-3 lightgrey-background",staticStyle:{"min-height":"200px"},attrs:{"required":""},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"col-12 action-button p2 h5 regular gibson line-height-1 not-rounded flex justify-center items-center",attrs:{"type":"submit","disabled":_vm.isLoadingRecommend}},[_c('span',[_vm._v("Send sms")]),_vm._v(" "),_vm._m(1)])])])])])]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"flex flex-wrap justify-start gibson mt2"},[_c('div',{staticClass:"col-12 pt0 pr0 pb0 pl3"},[_c('div',{staticClass:"clearfix primarycolor flex justify-start items-center",on:{"click":function($event){return _vm.$router.go(-1)}}},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"h5 gibson line-height-1 m0 p0"},[_vm._v("Tilbage")])])]),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 p3"},[_c('form',{staticClass:"highlights p3",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.sendSMS()}}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h5 darkblue gibson line-height-1 mb2"},[_vm._v("\n            Indtast din kammerat's nummer her\n          ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.telephone),expression:"telephone"}],staticClass:"col-12 h5 p2 darkblue border-none gibson lightgrey-background",attrs:{"type":"text","placeholder":"Telefonnummer","required":""},domProps:{"value":(_vm.telephone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.telephone=$event.target.value}}}),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.message),expression:"message"}],staticClass:"col-12 border-none p2 h5 gibson darkblue line-height-3 lightgrey-background",staticStyle:{"min-height":"200px"},attrs:{"required":""},domProps:{"value":(_vm.message)},on:{"input":function($event){if($event.target.composing){ return; }_vm.message=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"col-12 action-button p2 h5 regular gibson line-height-1 not-rounded flex justify-center items-center",attrs:{"type":"submit","disabled":_vm.isLoadingRecommend}},[_c('span',[_vm._v("Send sms")]),_vm._v(" "),_vm._m(4)])])])])]):_vm._e(),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold"},[_vm._v("\n          Anbefal os til en kammerat!\n        ")]),_vm._v(" "),_c('p',{staticClass:"h5 darkblue regular line-height-3 my2"},[_vm._v("\n          Du modtager et gratis “Fri entré”-kort til Tivoli, når din kammerat melder sig ind som partner hos Håndværker.dk via din sms-besked.\n        ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"mr1"},[_c('i',{staticClass:"el-icon-back"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 pt3 pb0 pl3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold"},[_vm._v("\n        Anbefal os til en kammerat!\n      ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue line-height-golden gibson"},[_vm._v("\n        Du modtager et gratis “Fri entré”-kort til Tivoli, når din kammerat melder sig ind som partner hos Håndværker.dk via din sms-besked.\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml2"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1481 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__ = __webpack_require__(1483);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cde558d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__ = __webpack_require__(1484);
function injectStyle (ssrContext) {
  __webpack_require__(1482)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_faq_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cde558d_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_faq_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1482 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1483 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'faq',
  components: {},
  data: function data() {
    return {
      questionLoading: true,
      searchQuery: null,
      questions: [],
      noDataFound: false
    };
  },

  methods: {
    sendSMS: function sendSMS() {
      var closeFn = function closeFn() {
        this.$router.push('/medlemsfordele');
      };
      var obj = {
        customClass: 'confirmDialog',
        customIconUrl: '',
        message: '<div class="flex flex-column justify-center items-center pt3"><img src="/static/svg/blue-checkmark.svg" width="50" height="50"><p class="h3 mt3 regular gibson darkblue line-height-2">Tak!</p></div>',
        type: 'success',
        customCloseBtnClass: 'muted-button gibson border-none not-rounded h5 regular p2 px3 right',
        customCloseBtnText: 'Luk',
        onClose: closeFn
      };
      this.$refs.simplert.openSimplert(obj);
    },
    checkSearch: function checkSearch() {
      var faq = document.querySelectorAll('.faq-btn');
      if (faq.length > 0) {
        this.noDataFound = false;
      } else {
        this.noDataFound = true;
      }
    }
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  computed: {
    resultQuery: function resultQuery() {
      var _this = this;

      if (this.searchQuery) {
        return this.questions.filter(function (item) {
          return _this.searchQuery.toLowerCase().split(' ').every(function (v) {
            return item.PROPERTY_QUESTION_VALUE.toLowerCase().includes(v);
          });
        });
      } else {
        return this.questions;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    this.show = true;
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    var data = { operation: 'getQuestionsAndAnswers', salesPerson: this.salesPerson, type: 'GET', url: 'bitrix/getMembers' };
    this.$http.post('', data, { emulateJSON: true }).then(function (response) {
      var res = response.body;
      _this2.show = false;
      if (res.login === false) {
        _this2.$router.push('/login');
      }
      _this2.questions = res;
      _this2.questionLoading = false;
    }, function (response) {
      alert('error');
    });
  }
});

/***/ }),
/* 1484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn pt2 pb4"},[(!_vm.showMobile)?_c('div',{staticClass:"flex flex-column gibson mt2 pl4 mb2"},[_c('div',{staticClass:"col-6"},[_c('div',{staticClass:"col-12 py3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold mb2"},[_vm._v("\n          Ofte stillede spørgsmål\n        ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 py1 lightgrey-background flex justify-start items-center"},[_vm._m(0),_vm._v(" "),_c('span',{staticClass:"flex-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"lightgrey-background col-11 h5 regular gibson darkblue border-none not-rounded line-height-1 m0 p0",attrs:{"placeholder":"Søg efter","type":"text"},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){return _vm.checkSearch()},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-6"},[(_vm.questionLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',[_vm._l((_vm.resultQuery),function(item){return _c('div',{key:item.ID},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(item.ID),expression:"item.ID"}],staticClass:"faq-btn col-12 py2 gibson white-button not-rounded flex justify-between items-start line-height-1"},[_c('span',{staticClass:"h5 gibson regular primarycolor mb0 mr2 inline-block left-align line-height-3"},[_vm._v(_vm._s(item.PROPERTY_QUESTION_VALUE))]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"20","height":"20","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"20","height":"20","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"col-12 my2",attrs:{"id":item.ID}},[_c('div',{staticClass:"h5 regular gibson darkblue line-height-4 flex flex-column",domProps:{"innerHTML":_vm._s(item.PROPERTY_ANSWER_VALUE.TEXT)}})])],1)}),_vm._v(" "),(_vm.noDataFound)?_c('div',{staticClass:"p2"},[_c('p',{staticClass:"h5 mediumgrey"},[_vm._v("Ingen data fundet.")])]):_vm._e()],2)])]):_vm._e(),_vm._v(" "),(_vm.showMobile)?_c('div',{staticClass:"flex flex-wrap justify-start gibson mt2"},[_c('div',{staticClass:"col-12 p3"},[_c('p',{staticClass:"h4 darkblue gibson semi-bold mb2"},[_vm._v("\n        Ofte stillede spørgsmål\n      ")]),_vm._v(" "),_c('div',{staticClass:"col-12 px0 py1 lightgrey-background flex justify-start items-center"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"flex-auto"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"lightgrey-background col-11 h4 regular gibson darkblue border-none not-rounded line-height-1 m0 p0",attrs:{"placeholder":"Søg efter","type":"text"},domProps:{"value":(_vm.searchQuery)},on:{"keyup":function($event){return _vm.checkSearch()},"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p3"},[(_vm.questionLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(3)]):_c('div',[_vm._l((_vm.resultQuery),function(item){return _c('div',{key:item.ID},[_c('button',{directives:[{name:"b-toggle",rawName:"v-b-toggle",value:(item.ID),expression:"item.ID"}],staticClass:"col-12 px0 py2 gibson white-button not-rounded flex justify-between items-start line-height-1"},[_c('span',{staticClass:"h4 gibson regular primarycolor mb0 mr2 inline-block left-align line-height-3"},[_vm._v(_vm._s(item.PROPERTY_QUESTION_VALUE))]),_vm._v(" "),_c('span',{staticClass:"when-closed"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-down",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -8 24 24","width":"20","height":"20","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 5.314l4.95-4.95a1 1 0 1 1 1.414 1.414L7.778 7.435a1 1 0 0 1-1.414 0L.707 1.778A1 1 0 1 1 2.121.364l4.95 4.95z"}})])])]),_vm._v(" "),_c('span',{staticClass:"flex-none when-opened"},[_c('span',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-chevron-up",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-5 -7.5 24 24","width":"20","height":"20","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M7.071 2.828l-4.95 4.95A1 1 0 0 1 .707 6.364L6.364.707a1 1 0 0 1 1.414 0l5.657 5.657a1 1 0 0 1-1.414 1.414l-4.95-4.95z"}})])])])]),_vm._v(" "),_c('b-collapse',{staticClass:"my2",attrs:{"id":item.ID}},[_c('div',{staticClass:"h5 regular gibson darkblue line-height-4 flex flex-column",domProps:{"innerHTML":_vm._s(item.PROPERTY_ANSWER_VALUE.TEXT)}})])],1)}),_vm._v(" "),(_vm.noDataFound)?_c('div',{staticClass:"py2"},[_c('p',{staticClass:"h5 mediumgrey"},[_vm._v("Ingen data fundet.")])]):_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('div',{staticStyle:{"height":"100px"}})]):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h5 line-height-1 m0 p0 mx2"},[_c('i',{staticClass:"el-icon-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"h5 line-height-1 m0 p0 mx2"},[_c('i',{staticClass:"el-icon-search"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordrestyring_vue__ = __webpack_require__(1487);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb43a4a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ordrestyring_vue__ = __webpack_require__(1488);
function injectStyle (ssrContext) {
  __webpack_require__(1486)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ordrestyring_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fb43a4a6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ordrestyring_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1486 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a
  },
  created: function created() {
    if (localStorage.getItem('PartnerAccountingInteg') === 'false') {
      this.$router.push('/login');
    }
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.getOrdrestyring();
  },
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      apiData: [],
      api: '',
      sendDisabled: false
    };
  },

  methods: {
    getOrdrestyring: function getOrdrestyring() {
      var _this = this;

      var data = {
        operation: 'service_getordrestyring',
        salesPerson: this.salesPerson,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.apiData = res;
      }, function (response) {
        alert('Error in getOrdrestyring()');
      });
    },
    addOrdrestyring: function addOrdrestyring() {
      var _this2 = this;

      var api = this.api;
      if (api !== '') {
        var data = {
          operation: 'service_addordrestyring',
          salesPerson: this.salesPerson,
          levid: this.haaId,
          apikeye: api
        };
        this.$http.post('', data, { emulateJSON: true }).then(function (response) {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success'
          };
          _this2.getOrdrestyring();
          _this2.$refs.simplert.openSimplert(obj);
          _this2.api = '';
          _this2.sendDisabled = false;
        }, function (response) {
          alert('Error in addOrdrestyring()');
        });
        this.sendDisabled = true;
      } else {
        this.$toastr('error', 'Felt kræves');
      }
    }
  }
});

/***/ }),
/* 1488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"ordrestyring"}},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}})],1)],1),_vm._v(" "),_c('b-form',[_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0 p-1"},[_c('div',{staticClass:"lg-flex flex-row align-items-center justify-content-between lg-col-6 col-12 mb3"},[_c('div',{staticClass:"mb2"},[_c('b-img',{staticClass:"mr2",attrs:{"src":"../static/img/ordrestyring-logo.png","alt":"","width":"100"}})],1),_vm._v(" "),_c('div',[_c('span',{staticClass:"h1"},[_vm._v("Ordrestyring.dk")]),_vm._v(" "),_c('p',[_vm._v("Overfør dine opgaver fra Håndværker.dk direkte til din arbejdskalender hos Ordrestyring. Det giver dig overblik i hverdagen.")])])]),_vm._v(" "),_c('div',{staticClass:"card-text pb-0"},[_c('div',[_c('div',{staticClass:"flex flex-row justify-content-start"},[_c('b-col',{attrs:{"lg":"6","md":"12","sm":"12"}},[_c('table',{staticClass:"el-table__body col-12 p0 mb2"},[_c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("API")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Dato ændret")])])]),_vm._v(" "),_c('tbody',[_c('tr',{staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1"},[_c('span',[_vm._v(_vm._s(_vm.apiData.ordrestyringapi))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1 qty"},[_c('span',[_vm._v(_vm._s(_vm.apiData.ordrestyringupdate))])])])])]),_vm._v(" "),_c('b-form',{staticClass:"py-2"},[_c('div',{staticClass:"lg-flex flex-wrap col-12 p0"},[_c('b-form-group',{staticClass:"lg-col-10 md-col-12 p0 pr1",attrs:{"id":"login","label":"API Key","label-for":"API Key"}},[_c('b-form-input',{staticClass:"bg-light rounded p2",attrs:{"required":"","autocomplete":"off"},model:{value:(_vm.api),callback:function ($$v) {_vm.api=$$v},expression:"api"}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"col-2 p0 m0 white",attrs:{"id":"gemme","label":"test","label-for":"API Key"}},[_c('button',{staticClass:"flex justify-center items-center action-button gibson h5 p2 semi-bold m0",attrs:{"type":"button","disabled":_vm.sendDisabled},on:{"click":function($event){return _vm.addOrdrestyring()}}},[_c('span',[_vm._v("Gem")])])])],1)])],1)],1)])])])],1)],1)],1)],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1489 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approval_vue__ = __webpack_require__(1491);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782f9fdc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_approval_vue__ = __webpack_require__(1492);
function injectStyle (ssrContext) {
  __webpack_require__(1490)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_approval_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_782f9fdc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_approval_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1490 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'approval',
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"]
  },
  data: function data() {
    return {
      dialogVisible: false,
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem illo, eveniet eius cum adipisci minima eos possimus quas, maxime omnis velit voluptas sit quia minus necessitatibus harum quam, voluptatum dicta!',
      dynamicTags: ['Tømrer', 'Tegltag', 'Loft', 'Isolering', 'Egetræsgulv'],
      inputVisible: false,
      inputValue: ''
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    gotoRegistration: function gotoRegistration() {
      this.$router.push('/klima/registration');
    },
    onComplete: function onComplete() {
      this.dialogVisible = true;
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    isFirstStep: function isFirstStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isFirstStep;
      }
      return false;
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    },
    goToNps: function goToNps() {
      this.dialogVisible = false;
      this.$router.push('/approval/nps');
    }
  },
  computed: {}
});

/***/ }),
/* 1492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix fullHeight p2 pb4 mb2"},[_c('div',{staticClass:"clearfix mt3 pt2 pb3 highlights"},[_c('form-wizard',{ref:"wizard",staticClass:"px1",attrs:{"title":"","subtitle":"","shape":"square","finishButtonText":"Bekræft","color":"","error-color":"#ff4949"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [(props.activeTabIndex == 0 && !props.isLastStep)?_c('div',{staticClass:"col-12 px0 flex flex-column justify-center items-center"},[_c('wizard-button',{staticClass:"action-button p2 mt2 flex justify-center items-center col-6 mx-auto not-rounded border-none",nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"h4 gibson line-height-1 m0 p0"},[_vm._v("Kom i gang")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])],1):_vm._e(),_vm._v(" "),(!props.activeTabIndex == 0 && !props.isLastStep)?_c('div',{staticClass:"col-12 px0 flex flex-column justify-center items-center"},[_c('wizard-button',{staticClass:"action-button p2 mt2 flex justify-center items-center col-6 mx-auto not-rounded border-none",nativeOn:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"h4 gibson line-height-1 m0 p0"},[_vm._v("Næste")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])],1):_vm._e(),_vm._v(" "),(props.isLastStep)?_c('div',{staticClass:"col-12 px0 mt2 flex justify-center items-center"},[_c('wizard-button',{staticClass:"action-button gibson p2 col-6 mx-auto flex justify-center items-center not-rounded border-none",attrs:{"type":"button"},nativeOn:{"click":function($event){return _vm.onComplete.apply(null, arguments)}}},[_c('span',{staticClass:"h4 gibson line-height-1 m0 p0"},[_vm._v("\r\n                  "+_vm._s(props.isLastStep ? 'Godkend' : 'Næste')+"\r\n                ")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])],1):_vm._e()]}}],null,false,1939778985)},[_c('tab-content',{attrs:{"title":"1"}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 gibson semi-bold primarycolor line-height-3 mb2"},[_vm._v("Hej Cuatomer Name")]),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-golden"},[_vm._v("\r\n                Efter aftale fremsendes hermed opgave til din godkendelse inden den sendes i udbud.\r\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-golden"},[_vm._v("\r\n                Det er vigtigt at du dobbelttjekker informationerne, så du på den måde kan få det bedste resultat hurtigst muligt.\r\n              ")]),_vm._v(" "),_c('p',{staticClass:"h5 regular gibson darkblue line-height-golden"},[_vm._v("\r\n                Så snart opgaven er godkendt fra din side, vil opgaven blive lagt i udbud på platformen, således at selvstændige virksomheder kan byde på opgaven.\r\n              ")])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"2"}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 gibson semi-bold primarycolor line-height-3 mb2"},[_vm._v("Opgavens beskrivelsse")]),_vm._v(" "),_c('textarea',{staticClass:"col-12 p2 darkblue line-height-golden h5 gibson border form-border regular lightgrey-background",staticStyle:{"min-height":"240px"},attrs:{"name":"description","id":""},domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('span',{staticClass:"inline-block p1 h5 gibson darkblue flex justify-start items-center"},[_c('span',[_vm._v("Ret beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-edit"})])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"3"}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 gibson semi-bold primarycolor line-height-3 mb2"},[_vm._v("Opgavens beskrivelsse")]),_vm._v(" "),_c('textarea',{staticClass:"col-12 p2 darkblue line-height-golden h5 gibson border form-border regular lightgrey-background",staticStyle:{"min-height":"240px"},attrs:{"name":"description","id":""},domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('span',{staticClass:"inline-block p1 h5 gibson darkblue flex justify-start items-center"},[_c('span',[_vm._v("Ret beskrivelse")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-edit"})])])])]),_vm._v(" "),_c('tab-content',{attrs:{"title":"4"}},[_c('div',{staticClass:"clearfix approvalTags"},[_c('p',{staticClass:"h4 gibson semi-bold primarycolor line-height-3 mb2"},[_vm._v("Faggruppe tags")]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_vm._l((_vm.dynamicTags),function(tag){return _c('el-tag',{key:tag,attrs:{"effect":"dark","color":"rgb(25, 163, 192)","closable":"","disable-transitions":false},on:{"close":function($event){return _vm.handleClose(tag)}}},[_c('span',{staticClass:"white gibson h5 m0 p0 line-height-1"},[_vm._v(_vm._s(tag))])])}),_vm._v(" "),(_vm.inputVisible)?_c('el-input',{ref:"saveTagInput",staticClass:"input-new-tag",on:{"blur":_vm.handleInputConfirm},nativeOn:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.handleInputConfirm.apply(null, arguments)}},model:{value:(_vm.inputValue),callback:function ($$v) {_vm.inputValue=$$v},expression:"inputValue"}}):_c('el-button',{staticClass:"button-new-tag",attrs:{"size":"small"},on:{"click":_vm.showInput}},[_vm._v("+ New Tag")])],2)])],1)],1),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),(_vm.showMobile)?_c('el-dialog',{attrs:{"fullscreen":true,"show-close":false,"title":"","visible":_vm.dialogVisible,"width":"80%"},on:{"update:visible":function($event){_vm.dialogVisible=$event}}},[_c('div',{staticClass:"clearfix"},[_c('p',{staticClass:"h4 regular darkblue gibson line-height-golden"},[_vm._v("\r\n            Når du godkender opgaven sendes den i udbud på en halv-offentlig platform hvor alle virksomheder kan byde på opgaven - disse virksomheder er ikke får godkendt af Håndværker.dk, hvorfor vi anbefaler, at man undersøger firmaerne, f.eks. om de er medlem af de garantiordninger, om de har de faguddannelser de angiver, ved at tjekke f.eks. Byggaranti.dk eller Sikkerhedsstyrelsens Autorisationsregister.\r\n          ")]),_vm._v(" "),_c('p',{staticClass:"h4 regular darkblue gibson line-height-golden"},[_vm._v("\r\n            Når du trykker “Bekræft” godkender du også, at Håndværker.dk ikke kan holdes til ansvar for eventuelle fejl og mangler i udførelsen af projektet. Hvis du som kunde er utilfreds med det udførte arbejde, er det udelukkende håndværkeren, der kan drages til ansvar for det udførte arbejde, ikke Håndværker.dk\r\n          ")]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('el-button',{staticClass:"action-button gibson line-height-1 p3 col-6 flex justify-center items-center not-rounded border-none",on:{"click":function($event){return _vm.goToNps()}}},[_c('span',{staticClass:"h3 regular line-height-1 m0 p0"},[_vm._v("Bekræft")]),_vm._v(" "),_c('span',{staticClass:"h3 line-height-1 p0 ml1"},[_c('i',{staticClass:"el-icon-right"})])])],1),_vm._v(" "),_c('span',{staticClass:"hide col-12 px0 flex justify-between",attrs:{"slot":"footer"},slot:"footer"})]):_vm._e()],1):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1493 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nps_vue__ = __webpack_require__(1495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0475e030_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_nps_vue__ = __webpack_require__(1496);
function injectStyle (ssrContext) {
  __webpack_require__(1494)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_nps_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0475e030_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_nps_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1495 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__);


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'nps',
  components: {
    FormWizard: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["FormWizard"],
    TabContent: __WEBPACK_IMPORTED_MODULE_0_vue_form_wizard__["TabContent"]
  },
  data: function data() {
    return {
      dialogVisible: false,
      customerName: 'Jane Jones',
      max: 100,
      value: 1,
      responseModel: '',
      description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quidem illo, eveniet eius cum adipisci minima eos possimus quas, maxime omnis velit voluptas sit quia minus necessitatibus harum quam, voluptatum dicta!',
      dynamicTags: ['Tømrer', 'Tegltag', 'Loft', 'Isolering', 'Egetræsgulv'],
      inputVisible: false,
      inputValue: ''
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    gotoRegistration: function gotoRegistration() {
      this.$router.push('/klima/registration');
    },
    onComplete: function onComplete() {
      this.dialogVisible = true;
    },
    isLastStep: function isLastStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isLastStep;
      }
      return false;
    },
    isFirstStep: function isFirstStep() {
      if (this.$refs.wizard) {
        return this.$refs.wizard.isFirstStep;
      }
      return false;
    },
    handleClose: function handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
    },
    showInput: function showInput() {
      var _this = this;

      this.inputVisible = true;
      this.$nextTick(function (_) {
        _this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm: function handleInputConfirm() {
      var inputValue = this.inputValue;
      if (inputValue) {
        this.dynamicTags.push(inputValue);
      }
      this.inputVisible = false;
      this.inputValue = '';
    }
  },
  computed: {}
});

/***/ }),
/* 1496 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showMobile)?_c('div',{staticClass:"clearfix fullHeight px0 pt2 pb4 mb2"},[_c('div',{staticClass:"clearfix mt3 pt1 pb3"},[_c('p',{staticClass:"h2 center gibson regular primarycolor line-height-3 mb2"},[_vm._v("Sådan!")]),_vm._v(" "),_c('p',{staticClass:"h4 center regular darkblue gibson line-height-2"},[_vm._v("Så er opgaven sendt i udbud 🚀")]),_vm._v(" "),_c('div',{staticClass:"nps-container center",attrs:{"id":"nps"}},[_c('div',{staticClass:"xs-hide clearfix pt3"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-7 mx-auto mt2 pb4"},[_c('div',{staticClass:"col-12 flex justify-between"},[_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(0)}}},[_vm._v("0")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(1)}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(2)}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(3)}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(4)}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(5)}}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(6)}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(7)}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(8)}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer detractor",on:{"click":function($event){return _vm.nps(9)}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h5 regular pointer promoter",on:{"click":function($event){return _vm.nps(10)}}},[_vm._v("10")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._m(2)])]),_vm._v(" "),_c('div',{staticClass:"sm-hide md-hide lg-hide clearfix mt3"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-12 mx-auto mt2 pb4"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"col-12 px0 flex justify-between"},[_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(0)}}},[_vm._v("0")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(1)}}},[_vm._v("1")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(2)}}},[_vm._v("2")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(3)}}},[_vm._v("3")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(4)}}},[_vm._v("4")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(5)}}},[_vm._v("5")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(6)}}},[_vm._v("6")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(7)}}},[_vm._v("7")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(8)}}},[_vm._v("8")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer detractor",on:{"click":function($event){return _vm.nps(9)}}},[_vm._v("9")]),_vm._v(" "),_c('button',{staticClass:"npsbtn p1 darkblue-background white gibson h6 semi-bold pointer promoter",on:{"click":function($event){return _vm.nps(10)}}},[_vm._v("10")])]),_vm._v(" "),_vm._m(5)])])])]),_vm._v(" "),_c('div',{staticClass:"py4"})]):_vm._e(),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-6 mx-auto"},[_c('p',{staticClass:"h5 gibson darkblue line-height-3"},[_vm._v("\r\n                Hvor sandssynligt er det, at du vil anbefale Henttilbud.dk til en ven eller kollega?\r\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-between items-center mt2"},[_c('div',[_c('img',{staticClass:"fit block lozad",attrs:{"src":"static/svg/frown.svg","width":"32","height":"32","alt":""}})]),_vm._v(" "),_c('div',[_c('img',{staticClass:"fit block lozad",attrs:{"src":"static/svg/smiley.svg","width":"32","height":"32","alt":""}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hide flex mt3 justify-between"},[_c('span',{staticClass:"darkblue"},[_vm._v("Slet ikke sandsynligt")]),_vm._v(" "),_c('span',{staticClass:"darkblue"},[_vm._v("Meget sandsynligt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-10 mx-auto mb3"},[_c('p',{staticClass:"h5 gibson regular darkblue line-height-3"},[_vm._v("\r\n                Hvor sandssynligt er det, at du vil anbefale Henttilbud.dk til en ven eller kollega?\r\n              ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 flex justify-between mb1"},[_c('span',{staticClass:"h6 gibson mediumgrey regular line-height-1 mb1"},[_vm._v("Slet ikke sandsynligt")]),_vm._v(" "),_c('span',{staticClass:"h6 gibson mediumgrey regular line-height-1 mb1"},[_vm._v("Meget sandsynligt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix mt2"},[_c('textarea',{staticClass:"fadeFocus p2 h6 line-height-golden regular gibson col-12 lightgrey-background border-none not-rounded mb2",staticStyle:{"min-height":"100px"},attrs:{"name":"","id":"","placeholder":"Leave your feedback here"}}),_vm._v(" "),_c('button',{staticClass:"action-button p2 mx-auto flex justify-center items-center"},[_c('span',{staticClass:"h4 line-height-1 gibson m0 p0"},[_vm._v("Gem")]),_vm._v(" "),_c('span',{staticClass:"mx1"},[_c('i',{staticClass:"el-icon-right"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1497 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UddanelseBevis_vue__ = __webpack_require__(1499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f63985b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UddanelseBevis_vue__ = __webpack_require__(1500);
function injectStyle (ssrContext) {
  __webpack_require__(1498)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UddanelseBevis_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0f63985b_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_UddanelseBevis_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1498 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1499 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__ = __webpack_require__(48);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: '',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a,
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_1__components_file_upload_input__["a" /* default */]
  },
  created: function created() {
    this.salesPerson = localStorage.getItem('id_token_portal');
    this.haaId = localStorage.getItem('haaid');
    this.displayEducation();
    this.getFags();
    setTimeout(function () {
      var fileUploadText = document.querySelector('.input-group > button > span:nth-child(2)');
      fileUploadText.innerText = 'Vedhæft uddannelsesbevis';
    }, 500);
    this.errorFeedback();
  },
  data: function data() {
    return {
      salesPerson: '',
      haaId: '',
      educationData: [],
      name: '',
      fag: null,
      fagOptionData: [],
      files: '',
      sendDisabled: false,
      message: [],
      errormessagename: '',
      errormessagefag: '',
      uploaloadstatus: true,
      error: false
    };
  },

  methods: {
    displayEducation: function displayEducation() {
      var _this = this;

      var data = {
        operation: 'listeducation',
        salesPerson: this.salesPerson,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this.educationData = res;
      }, function (response) {
        alert('Error in displayEducation()');
      });
    },
    getFags: function getFags() {
      var _this2 = this;

      var data = {
        operation: 'anbefalingercat',
        salesPerson: this.salesPerson,
        levid: this.haaId
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this2.fagOptionData.push({
          text: 'Vælg uddannelse',
          value: null,
          disabled: true
        }, {
          text: 'Andet',
          value: 'Andet'
        });
        for (var id in res) {
          var cat = res[id];
          _this2.fagOptionData.push({
            text: cat.Title,
            value: cat.Title
          });
        }
      }, function (response) {
        alert('Error in getFags()');
      });
    },
    handleFileUpload: function handleFileUpload(file) {
      var _this3 = this;

      var url = 'https://www.kundematch.dk/HenttilbudImg.php?img=' + file[0];
      var data = {
        operation: 'badgeDownload',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        url: url
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.files = 'data:image/png;base64,' + encodeURI(res.url);
        } else {
          _this3.$toastr('error', 'Fejl');
        }
      }, function (response) {
        alert('Error in handleFileUpload()');
      });
      document.querySelector('.education-upload > .input-group > button').classList.add('hide');
    },
    addEducation: function addEducation() {
      var _this4 = this;

      var uploadFinish = localStorage.getItem('uploadFinish');
      if (uploadFinish === true || uploadFinish === null) {
        var name = this.name;
        var fag = this.fag;
        var file = this.files;
        if (name !== '' && fag !== null && file !== '') {
          var data = {
            operation: 'addeducation',
            salesPerson: this.salesPerson,
            levid: this.haaId,
            title: name,
            file: file,
            person: name,
            fag: fag
          };
          this.$http.post('', data, { emulateJSON: true }).then(function (response) {
            var res = response.body;
            if (res.success) {
              var obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success'
              };
              _this4.displayEducation();
              _this4.$refs.simplert.openSimplert(obj);
              _this4.name = '';
              _this4.fag = null;
              _this4.files = '';
              document.querySelector('.education-upload > .input-group > button').classList.remove('hide');
              var lists = document.querySelectorAll('ul.upload-file-list > li');
              if (lists.length > 0) {
                for (var i = 0; i < lists.length; i++) {
                  lists[i].remove();
                }
              }
              _this4.sendDisabled = false;
            } else {
              _this4.sendDisabled = false;
              _this4.$toastr('error', 'Fejl');
            }
          }, function (response) {
            alert('Error in addEducation()');
          });
          this.sendDisabled = true;
        } else if (fag === '' || fag === null) {
          this.error = true;
          if (name === '') {
            this.errormessagename = this.errorFeedback('name');
          } else {
            if (name !== '' && name !== null) {
              this.errormessagename = '';
            }
            this.errormessagefag = this.errorFeedback('education');
            this.$toastr('error', 'Felt kræves');
          }
        } else if (name === '' && name === null) {
          this.$toastr('error', 'Skriv venligst din navn');
          this.error = true;
          this.errormessagename = this.errorFeedback('name');
        } else {
          this.$toastr('error', 'Felt kræves');
        }
      } else {
        this.$toastr('error', 'Uploader stadig');
      }
    },
    confirmDelete: function confirmDelete(id) {
      var _this5 = this;

      return function (dialog) {
        return _this5.deleteEducation(id);
      };
    },
    deleteEducation: function deleteEducation(id) {
      var _this6 = this;

      var data = {
        operation: 'deleducation',
        salesPerson: this.salesPerson,
        levid: this.haaId,
        eduid: id
      };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.displayEducation();
          _this6.$toastr('success', 'Slettet');
        } else {
          _this6.$toastr('error', 'Fejl');
        }
      }, function (response) {
        alert('Error in deleteEducation()');
      });
    },
    errorFeedback: function errorFeedback(type) {
      var message = {
        default: 'Skriv venligst hvad du ønsker at få lavet',
        email: 'Skriv venligst din email',
        name: 'Skriv venligst din navn',
        phone: 'Skriv venligst dit telefon nummer',
        postal: 'Skriv venligst dit postnummer',
        acceptTerms: 'Venligst klik i vores betingelser',
        education: 'Skriv venligst din fag'
      };
      return message[type];
    },
    disableerror: function disableerror() {
      this.error = false;
    }
  }
});

/***/ }),
/* 1500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"uddanelsebevis"}},[_c('b-container',{staticClass:"pt-3 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{attrs:{"cols":"12"}})],1)],1),_vm._v(" "),_c('b-form',[_c('b-container',{staticClass:"pt-0 pr-3 pb-0 pl-3",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',[_c('b-card',{staticClass:"border-0 p-1"},[_c('div',{staticClass:"lg-flex flex-row align-items-center justify-content-between lg-col-6 col-12 mb3"},[_c('div',[_c('span',{staticClass:"h1"},[_vm._v("Uddannelsesbevis")]),_vm._v(" "),_c('p',[_vm._v("Her kan du uploade firmaets uddannelsesbeviser, for dig og dine ansatte.")])])]),_vm._v(" "),_c('div',{staticClass:"card-text pb-0"},[_c('div',[_c('div',{},[_c('b-col',{attrs:{"lg":"6","md":"12","sm":"12"}},[_c('table',{staticClass:"el-table__body col-12 p0 mb4"},[_c('thead',{staticClass:"has-gutter"},[_c('tr',[_c('th',{staticClass:"el-table_1_column_1 is-leaf pr2",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Navn")]),_vm._v(" "),_c('th',{staticClass:"el-table_1_column_1 is-leaf",attrs:{"colspan":"1","rowspan":"1"}},[_vm._v("Uddannelse")])])]),_vm._v(" "),_c('tbody',_vm._l((_vm.educationData),function(education,index){return _c('tr',{key:index,staticClass:"el-table__row"},[_c('td',{staticClass:"el-table_1_column_1 pr2"},[_c('span',[_vm._v(_vm._s(education.CoverImg))])]),_vm._v(" "),_c('td',{staticClass:"el-table_1_column_1"},[_c('span',[_vm._v(_vm._s(education.BadgeMonth))]),_c('a',{directives:[{name:"confirm",rawName:"v-confirm",value:({ok: _vm.confirmDelete(education.Id), message: 'Vil du fjerne disse data?', okText: 'Ja', cancelText: 'Nej'}),expression:"{ok: confirmDelete(education.Id), message: 'Vil du fjerne disse data?', okText: 'Ja', cancelText: 'Nej'}"}],staticClass:"pointer absolute right-0 no-hover",attrs:{"title":"Slet"}},[_c('span',{staticClass:"red mr1"},[_vm._v("Slet")]),_c('i',{staticClass:"el-icon-error h5 red"})])])])}),0)]),_vm._v(" "),_c('b-form',{staticClass:"py-2"},[_c('div',{staticClass:"col-12 p0"},[_c('b-form-group',{staticClass:"lg-col-12 md-col-12 p0 mb3",attrs:{"id":"name","label":"","label-for":"navn"}},[_c('b-form-input',{attrs:{"placeholder":"Indtast navn","autocomplete":"off"},on:{"keyup":function($event){return _vm.disableerror()}},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"red alert"},[_vm._v(_vm._s(_vm.errormessagename))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"lg-col-12 md-col-12 p0 mb3",attrs:{"id":"fag","label":"","label-for":"fag"}},[_c('b-form-select',{staticClass:"col-12",attrs:{"options":_vm.fagOptionData},on:{"change":function($event){return _vm.disableerror()}},model:{value:(_vm.fag),callback:function ($$v) {_vm.fag=$$v},expression:"fag"}}),_vm._v(" "),(_vm.error)?_c('span',{staticClass:"red alert"},[_vm._v(_vm._s(_vm.errormessagefag))]):_vm._e()],1),_vm._v(" "),_c('b-form-group',{staticClass:"lg-col-12 md-col-12 p0 mb3",attrs:{"id":"file","label":"","label-for":"fag"}},[_c('file-upload-input',{staticClass:"education-upload",attrs:{"token":"","module":""},on:{"UpdateTilbud":_vm.handleFileUpload}})],1),_vm._v(" "),_c('b-form-group',{staticClass:"lg-col-12 md-col-12 p0 m0 white",attrs:{"id":"gemme","label":"","label-for":"gemme"}},[_c('button',{staticClass:"col-12 flex justify-center items-center btn action-button gibson h5 p2 semi-bold m0",attrs:{"type":"button","disabled":_vm.sendDisabled},on:{"click":function($event){return _vm.addEducation()}}},[_c('span',[_vm._v("Gem")])])])],1)])],1)],1)])])])],1)],1)],1)],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1501 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questionnaire_vue__ = __webpack_require__(1503);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e3f5d9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Questionnaire_vue__ = __webpack_require__(1504);
function injectStyle (ssrContext) {
  __webpack_require__(1502)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Questionnaire_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_12e3f5d9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_Questionnaire_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1502 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1503 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);





/* harmony default export */ __webpack_exports__["a"] = ({
		name: '',
		components: {
				Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a
		},
		data: function data() {
				return {
						questionLoading: true,
						id: '',
						isCustomer: false,
						activeTab: '1',
						questionData: [],
						value: '',
						selected: '',
						indicatorData: {
								ind6: {
										active: false
								},
								ind7: {
										active: false
								},
								ind8: {
										active: false
								},
								ind11: {
										active: false
								},
								ind12: {
										active: false
								},
								ind13: {
										active: false
								}
						},
						disableSubmit: false,
						lastSaved: '',
						noEconomy: '',
						noSocial: '',
						noEnvironment: ''
				};
		},
		created: function created() {
				this.salesPerson = localStorage.getItem('id_token_portal');
				this.haaId = localStorage.getItem('haaid');
				var urlStr = window.location.href;
				var url = new URL(urlStr.replace('/#', ''));
				var searchParams = url.searchParams;
				var id = searchParams.get('id');
				this.id = id;
				var mode = searchParams.get('mode');
				if (mode === 'customer') {
						this.isCustomer = true;
				} else {
						this.isCustomer = false;
				}
				this.displayQuestion();
		},

		methods: {
				approve: function approve(value, tab) {
						tab = tab + 1;
						this.activeTab = tab.toString();
				},
				displayQuestion: function displayQuestion() {
						var _this = this;

						var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
								operation: 'klimaapi',
								bitrixoperation: 'getKlimaQuestion',
								id: this.id
						});
						this.$http.post('https://www.kundematch.dk/customerService.php', data, { emulateJSON: true }).then(function (response) {
								var res = response.body;
								if (res.success) {
										_this.questionData = res.data;
										var economyCount = 0;
										for (var economy in res.data.KlimaSurveyEconomy) {
												economyCount++;
										}
										if (economyCount > 0) {
												_this.noEconomy = false;
										} else {
												_this.noEconomy = true;
										}
										var socialCount = 0;
										for (var social in res.data.KlimaSurveySocial) {
												socialCount++;
										}
										if (socialCount > 0) {
												_this.noSocial = false;
										} else {
												_this.noSocial = true;
										}
										var environmentCount = 0;
										for (var environment in res.data.KlimaSurveyEnvironment) {
												environmentCount++;
										}
										if (environmentCount > 0) {
												_this.noEnvironment = false;
										} else {
												_this.noEnvironment = true;
										}
										if (_this.isCustomer) {
												_this.lastSaved = res.data.latestupdate.customer_answer_date;
										} else {
												_this.lastSaved = res.data.latestupdate.partner_answer_date;
										}
										_this.questionLoading = false;
								} else {
										_this.$toastr('error', 'Fjernet');
								}
						}, function (response) {
								alert('Error in displayQuestion()');
						});
				},
				calculatePercentageFields: function calculatePercentageFields(UNGoal, surveyId, type) {
						if (type === 'input') {
								var inputVal = document.querySelector('.question #input-' + surveyId + ' input').value;
								if (inputVal !== '') {
										this.indicatorData['ind' + UNGoal].active = true;
								} else {
										this.indicatorData['ind' + UNGoal].active = false;
								}
						} else if (type === 'select') {
								var selectVal = document.querySelector('.question #select-' + surveyId).value;
								if (selectVal !== '') {
										this.indicatorData['ind' + UNGoal].active = true;
								} else {
										this.indicatorData['ind' + UNGoal].active = false;
								}
						}
						var qstn = document.querySelectorAll('.question');
						for (var i = 0; i < qstn.length; i++) {
								var totalFields = 0;
								var percValue = 0;
								var totalPercValue = 0;
								var input = document.querySelectorAll('#' + qstn[i].id + ' input');
								var select = document.querySelectorAll('#' + qstn[i].id + ' select');
								var oldVal = '';
								for (var x = 0; x < input.length; x++) {}
								for (var j = 0; j < select.length; j++) {}
								totalFields = x + j;
								percValue = 100 / totalFields;
								for (var k = 0; k < input.length; k++) {
										if (input[k].value !== '') {
												totalPercValue += percValue;
										} else {
												if (input[k].value !== oldVal) {
														if (totalPercValue > 0) {
																totalPercValue -= percValue;
														}
														oldVal = input[k].value;
												}
										}
								}
								for (var l = 0; l < select.length; l++) {
										if (select[l].value !== '') {
												totalPercValue += percValue;
										}
								}
								if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_is_integer___default()(totalPercValue)) {
										document.querySelector('#' + qstn[i].id + ' .perc').innerText = totalPercValue;
								} else {
										document.querySelector('#' + qstn[i].id + ' .perc').innerText = totalPercValue.toFixed(0);
								}
						}
				},
				saveQuestion: function saveQuestion() {
						var _this2 = this;

						var qstn = document.querySelectorAll('.question');
						var totalPerc = 0;
						var requiredPerc = 100 * qstn.length;
						for (var v = 0; v < qstn.length; v++) {
								var perc = document.querySelector('#' + qstn[v].id + ' span.perc').innerText;
								totalPerc += parseInt(perc);
						}
						if (totalPerc === requiredPerc) {
								var field = document.querySelectorAll('.data-id');
								var formData = {};
								var count = 0;
								var qstnId = '';
								var prop = '';
								var fieldId = '';
								var fieldType = '';
								var fieldVal = '';
								var input = '';
								var stopLooped = '';
								for (var i = 0; i < field.length; i++) {
										var arr = field[i].id.split('-');
										fieldType = arr[0];
										fieldId = arr[1];
										if (qstnId === fieldId) {
												count++;
										} else {
												count = 1;
										}
										if (this.isCustomer) {
												prop = 'svalue' + count + '_' + fieldId;
										} else {
												prop = 'pvalue' + count + '_' + fieldId;
										}
										if (qstnId === fieldId && qstnId !== stopLooped) {
												if (fieldType === 'input') {
														input = document.querySelectorAll('#' + field[i].id + ' input');
														for (var j = 0; j < input.length; j++) {
																if (j !== 0 && j !== count) {
																		fieldVal = input[j].value;
																		formData[prop] = fieldVal;
																		if (count === input.length) {
																				stopLooped = fieldId;
																		}
																}
														}
												} else if (fieldType === 'select') {
														input = document.querySelectorAll('select#' + field[i].id);
														for (var x = 0; x < input.length; x++) {
																if (x !== 0 && x !== count) {
																		fieldVal = input[x].value;
																		formData[prop] = fieldVal;
																		if (count === input.length) {
																				stopLooped = fieldId;
																		}
																}
														}
												}
										} else {
												if (fieldType === 'input') {
														fieldVal = document.querySelector('#' + field[i].id + ' input').value;
												} else if (fieldType === 'select') {
														fieldVal = document.querySelector('select#' + field[i].id).value;
												}
												formData[prop] = fieldVal;
										}
										qstnId = fieldId;
								}
								var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()({
										operation: 'klimaapi',
										bitrixoperation: 'saveKlimaQuestion',
										id: this.id,
										formData: formData
								});
								this.$http.post('https://www.kundematch.dk/customerService.php', data, { emulateJSON: true }).then(function (response) {
										var res = response.body;
										if (res.success) {
												_this2.displayQuestion();
												_this2.$router.push('/questionnaire-thankyou');
												_this2.indicatorData.ind6.active = false;
												_this2.indicatorData.ind7.active = false;
												_this2.indicatorData.ind8.active = false;
												_this2.indicatorData.ind11.active = false;
												_this2.indicatorData.ind12.active = false;
												_this2.indicatorData.ind13.active = false;
												_this2.activeTab = '1';
										} else {
												_this2.$toastr('error', 'Error in saveQuestion()');
										}
								}, function (response) {
										_this2.$toastr('error', 'Error in saveQuestion()');
								});
								this.questionLoading = true;
						} else {
								this.$toastr('error', 'Felter påkrævet');
						}
				}
		},
		watch: {}
});

/***/ }),
/* 1504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"questionnaire"}},[_c('div',{staticClass:"col-12 lg-col-6 md-col-10 p2 py4 ml-auto mr-auto"},[_vm._m(0),_vm._v(" "),(_vm.questionLoading)?_c('div',{staticClass:"clearfix"},[_vm._m(1)]):_c('div',[(_vm.isCustomer)?_c('div',[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-9 p0 pr2"},[(!_vm.noEconomy)?_c('div',{staticClass:"mb4 question",attrs:{"id":"question1"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"flex"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveyEconomy),function(economy,index){return _c('div',{key:index,staticClass:"flex"},[_vm._m(4,true),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(economy.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(economy.questiontype != 'input-2numbers' && economy.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.questiontype == 'input-number' || economy.questiontype == 'input-float')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):(economy.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + economy.ID,"name":"","options":economy.options},on:{"change":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(economy.questiontype == 'input-2numbers' || economy.questiontype == 'input-3numbers')?_c('div',[(economy.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info2 != '')?_c('el-tooltip',{attrs:{"content":economy.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(economy.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info2 != '')?_c('el-tooltip',{attrs:{"content":economy.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info3 != '')?_c('el-tooltip',{attrs:{"content":economy.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]):_vm._e(),_vm._v(" "),(!_vm.noSocial)?_c('div',{staticClass:"mb4 question",attrs:{"id":"question2"}},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"flex"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveySocial),function(social,index){return _c('div',{key:index,staticClass:"flex"},[_vm._m(7,true),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(social.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(social.questiontype != 'input-2numbers' && social.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.questiontype == 'input-number' || social.questiontype == 'input-float')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):(social.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + social.ID,"name":"","options":social.options},on:{"change":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(social.questiontype == 'input-2numbers' || social.questiontype == 'input-3numbers')?_c('div',[(social.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info2 != '')?_c('el-tooltip',{attrs:{"content":social.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(social.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info2 != '')?_c('el-tooltip',{attrs:{"content":social.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info3 != '')?_c('el-tooltip',{attrs:{"content":social.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]):_vm._e(),_vm._v(" "),(!_vm.noEnvironment)?_c('div',{staticClass:"mb4 question",attrs:{"id":"question3"}},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"flex"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveyEnvironment),function(environment,index){return _c('div',{key:index,staticClass:"flex"},[_vm._m(10,true),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(environment.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(environment.questiontype != 'input-2numbers' && environment.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.questiontype == 'input-number' || environment.questiontype == 'input-float')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):(environment.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + environment.ID,"name":"","options":environment.options},on:{"change":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(environment.questiontype == 'input-2numbers' || environment.questiontype == 'input-3numbers')?_c('div',[(environment.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info2 != '')?_c('el-tooltip',{attrs:{"content":environment.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(environment.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info2 != '')?_c('el-tooltip',{attrs:{"content":environment.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}})],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info3 != '')?_c('el-tooltip',{attrs:{"content":environment.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex mb2"},[_vm._m(11),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-9 p0 pr2"},[_c('p',{staticClass:"pl2 mediumgrey-text"},[_vm._v("Sidst gemt: "+_vm._s(_vm.lastSaved))]),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",attrs:{"disabled":_vm.disableSubmit},on:{"click":function($event){return _vm.saveQuestion()}}},[_c('span',[_vm._v("SEND TIL KLIMAHÅNDVÆRKER")]),_vm._v(" "),_vm._m(13)])])])]),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[(_vm.indicatorData.ind6.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/clean-water-and-sanitation-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/clean-water-and-sanitation.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind7.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/affordable-and-clean-energy-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/affordable-and-clean-energy.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind8.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/decent-economic-growth-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/decent-economic-growth.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind11.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/sustainable-cities-and-communities-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/sustainable-cities-and-communities.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind12.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/responsible-consumption-and-production-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/responsible-consumption-and-production.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind13.active)?_c('img',{attrs:{"src":"/static/svg/climate-action-color.svg","width":"100%"}}):_c('img',{attrs:{"src":"/static/svg/climate-action.svg","width":"100%"}})])])]):_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-9 p0 pr2"},[_c('el-tabs',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[(!_vm.noEconomy)?_c('el-tab-pane',{staticClass:"question",attrs:{"id":"question1","label":"economy","name":"1"}},[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Økonomi")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])]),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveyEconomy),function(economy,index){return _c('div',{key:index,staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(economy.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(economy.questiontype != 'input-2numbers' && economy.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.questiontype == 'input-number' || economy.questiontype == 'input-float' && economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):(economy.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + economy.ID,"name":"","options":economy.options},on:{"change":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(economy.questiontype == 'input-2numbers' || economy.questiontype == 'input-3numbers')?_c('div',[(economy.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info2 != '')?_c('el-tooltip',{attrs:{"content":economy.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(economy.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info1 != '')?_c('el-tooltip',{attrs:{"content":economy.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info2 != '')?_c('el-tooltip',{attrs:{"content":economy.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(economy.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(economy.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + economy.ID,"name":"","placeholder":economy.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(economy.UNgoal, economy.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(economy.info3 != '')?_c('el-tooltip',{attrs:{"content":economy.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"flex mb2"},[_c('div',{staticClass:"col-1 flex justify-center items-end p0 pb3 invisible"},[_c('span',{staticClass:"h3 semi-bold green m0"})]),_vm._v(" "),_c('div',{staticClass:"col-1 flex justify-center p0 mr2 invisible"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-9 p0 pr2"},[(!_vm.noSocial)?_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('economy', 1)}}},[_c('span',[_vm._v("GODKEND ØKONOMI")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])]):(!_vm.noEnvironment)?_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('economy', 2)}}},[_c('span',[_vm._v("GODKEND ØKONOMI")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])]):_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.saveQuestion()}}},[_c('span',[_vm._v("GODKEND ØKONOMI")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])])])])]):_vm._e(),_vm._v(" "),(!_vm.noSocial)?_c('el-tab-pane',{staticClass:"question",attrs:{"id":"question2","label":"social","name":"2"}},[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Social")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])]),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveySocial),function(social,index){return _c('div',{key:index,staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(social.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(social.questiontype != 'input-2numbers' && social.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.questiontype == 'input-number' || social.questiontype == 'input-float' && social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):(social.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + social.ID,"name":"","options":social.options},on:{"change":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(social.questiontype == 'input-2numbers' || social.questiontype == 'input-3numbers')?_c('div',[(social.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info2 != '')?_c('el-tooltip',{attrs:{"content":social.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(social.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info1 != '')?_c('el-tooltip',{attrs:{"content":social.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info2 != '')?_c('el-tooltip',{attrs:{"content":social.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(social.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(social.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + social.ID,"name":"","placeholder":social.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(social.UNgoal, social.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(social.info3 != '')?_c('el-tooltip',{attrs:{"content":social.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"flex mb2"},[_c('div',{staticClass:"col-1 flex justify-center items-end p0 pb3 invisible"},[_c('span',{staticClass:"h3 semi-bold green m0"})]),_vm._v(" "),_c('div',{staticClass:"col-1 flex justify-center p0 mr2 invisible"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-9 p0 pr2 flex flex-wrap"},[(!_vm.noEconomy)?_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('social', 0)}}},[_c('span',{staticClass:"pr1"},[_c('i',{staticClass:"bold el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("TILBAGE")])]):_vm._e(),_vm._v(" "),(!_vm.noEnvironment)?_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('social', 2)}}},[_c('span',[_vm._v("GODKEND SOCIAL")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])]):_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.saveQuestion()}}},[_c('span',[_vm._v("GODKEND SOCIAL")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])])])])]):_vm._e(),_vm._v(" "),(!_vm.noEnvironment)?_c('el-tab-pane',{staticClass:"question",attrs:{"id":"question3","label":"miljø","name":"3"}},[_c('div',{staticClass:"mb4"},[_c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Miljø")])]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])]),_vm._v(" "),_c('div',{staticClass:"col-11 p0"},_vm._l((_vm.questionData.KlimaSurveyEnvironment),function(environment,index){return _c('div',{key:index,staticClass:"flex"},[_c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-11 p0 pr2 mb3"},[_c('p',[_vm._v("\n\t\t\t\t\t\t\t\t\t\t\t\t\t\t"+_vm._s(environment.headertext)+"\n\t\t\t\t\t\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-12 p0"},[(environment.questiontype != 'input-2numbers' && environment.questiontype != 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.questiontype == 'input-number' || environment.questiontype == 'input-float' && environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):(environment.questiontype == 'input-list')?_c('b-form-select',{staticClass:"custom-select col-12 data-id",attrs:{"id":'select-' + environment.ID,"name":"","placeholder":"kg","options":environment.options},on:{"change":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'select')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(environment.questiontype == 'input-2numbers' || environment.questiontype == 'input-3numbers')?_c('div',[(environment.questiontype == 'input-2numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info2 != '')?_c('el-tooltip',{attrs:{"content":environment.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):(environment.questiontype == 'input-3numbers')?_c('div',[_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder1,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info1 != '')?_c('el-tooltip',{attrs:{"content":environment.info1,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title1))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder2,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info2 != '')?_c('el-tooltip',{attrs:{"content":environment.info2,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])]),_vm._v(" "),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(environment.title2))]),_vm._v(" "),_c('div',{staticClass:"mb1"}),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-11 p0"},[(environment.partneroption != 'false')?_c('el-input-number',{staticClass:"col-12 p0 mb3 data-id",attrs:{"id":'input-' + environment.ID,"name":"","placeholder":environment.placeholder3,"controls":false,"min":1},on:{"blur":function($event){return _vm.calculatePercentageFields(environment.UNgoal, environment.ID, 'input')}}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"col-1 p0"},[_c('div',{staticClass:"col-12 flex justify-center items-end p0"},[(environment.info3 != '')?_c('el-tooltip',{attrs:{"content":environment.info3,"placement":"top"}},[_c('i',{staticClass:"h5 el-icon-question mintgreen"})]):_vm._e()],1)])])]):_vm._e()]):_vm._e()])])])])}),0)])]),_vm._v(" "),_c('div',{staticClass:"flex mb2"},[_c('div',{staticClass:"col-1 flex justify-center items-end p0 pb3 invisible"},[_c('span',{staticClass:"h3 semi-bold green m0"})]),_vm._v(" "),_c('div',{staticClass:"col-1 flex justify-center p0 mr2 invisible"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})]),_vm._v(" "),_c('div',{staticClass:"col-9 p0 pr2 flex flex-wrap"},[(!_vm.noSocial)?_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('environment', 1)}}},[_c('span',{staticClass:"pr1"},[_c('i',{staticClass:"bold el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("TILBAGE")])]):_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.approve('environment', 0)}}},[_c('span',{staticClass:"pr1"},[_c('i',{staticClass:"bold el-icon-back"})]),_vm._v(" "),_c('span',[_vm._v("TILBAGE")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 h5 gibson regular line-height-1 col-12 flex justify-center items-center",on:{"click":function($event){return _vm.saveQuestion()}}},[_c('span',[_vm._v("GODKEND MILJØ")]),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])])])])]):_vm._e()],1)],1),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[(_vm.indicatorData.ind6.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/clean-water-and-sanitation-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/clean-water-and-sanitation.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind7.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/affordable-and-clean-energy-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/affordable-and-clean-energy.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind8.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/decent-economic-growth-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/decent-economic-growth.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind11.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/sustainable-cities-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/sustainable-cities.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind12.active)?_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/responsible-consumption-and-production-color.svg","width":"100%"}}):_c('img',{staticClass:"mb2",attrs:{"src":"/static/svg/responsible-consumption-and-production.svg","width":"100%"}}),_vm._v(" "),(_vm.indicatorData.ind13.active)?_c('img',{attrs:{"src":"/static/svg/climate-action-color.svg","width":"100%"}}):_c('img',{attrs:{"src":"/static/svg/climate-action.svg","width":"100%"}})])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center mb4"},[_c('img',{staticClass:"mr2",attrs:{"src":"/static/img/hvdk-green.png","width":"13%"}}),_vm._v(" "),_c('h1',{staticClass:"bold green"},[_vm._v("Byg med omtanke")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Økonomi")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Social")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pb4 px3"},[_c('h3',{staticClass:"semi-bold green"},[_vm._v("Miljø")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center items-center p0 pb3"},[_c('span',{staticClass:"h3 semi-bold green m0 statusPerc"},[_c('span',{staticClass:"perc"},[_vm._v("0")]),_vm._v("%")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center p0 mr2"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center items-end p0 pb3 invisible"},[_c('span',{staticClass:"h3 semi-bold green m0"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-1 flex justify-center p0 mr2 invisible"},[_c('div',{staticClass:"border green-border green-background fullHeight",staticStyle:{"width":"8%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pl1"},[_c('i',{staticClass:"bold el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ebf924_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireThankyou_vue__ = __webpack_require__(1506);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06ebf924_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_QuestionnaireThankyou_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn",attrs:{"id":"questionnaire"}},[_c('div',{staticClass:"col-12 lg-col-6 md-col-10 p2 py4 ml-auto mr-auto"},[_c('div',{staticClass:"mb4"},[_c('h1',{staticClass:"bold green center"},[_c('br'),_vm._v(" Tak for dit svar! "),_c('br'),_vm._v("Du kan nu lukke dette vindue.\r\n")]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"flex items-center"},[_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"col-12 lg-col-8 p0 mr-auto ml-auto"},[_c('div',{staticClass:"flex justify-center mb3"},[_c('div',{staticClass:"col-5 p0 mr2"},[_c('img',{attrs:{"src":"/static/img/hvdk-green.png","width":"100%"}})]),_vm._v(" "),_c('div',{staticClass:"col-5 p0"},[_c('img',{attrs:{"src":"/static/img/niras.png","width":"100%"}})])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1507 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contracts_vue__ = __webpack_require__(1509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57548950_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_vue__ = __webpack_require__(1513);
function injectStyle (ssrContext) {
  __webpack_require__(1508)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contracts_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57548950_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contracts_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1508 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1509 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_da__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale__);



__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_0_element_ui_lib_locale_lang_da___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contracts',
  components: {},
  data: function data() {
    return {
      search: '',
      tableData: [{
        date: '2016-05-03',
        name: 'Alexander Poindexter Aloysius Mountbatten',
        docs: '3',
        type: 'A/B Bygge',
        project: 'New Terrace',
        wallet: '123.456,00 kr',
        status: 'Signed',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-02',
        name: 'Dick',
        docs: '3',
        type: 'A/B Bygge',
        project: 'New Terrace',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-04',
        name: 'Tom',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Pending',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-01',
        name: 'Harry',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-08',
        name: 'George',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-06',
        name: 'John',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Draft',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }, {
        date: '2016-05-07',
        name: 'Leo',
        docs: '3',
        type: 'A/B Bygge',
        project: 'Nyt køkken',
        wallet: '123.456,00 kr',
        status: 'Approved',
        state: 'California',
        city: 'Los Angeles',
        address: 'No. 189, Grove St, Los Angeles',
        zip: 'CA 90036'
      }]
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {}
});

/***/ }),
/* 1510 */,
/* 1511 */,
/* 1512 */,
/* 1513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn py3 px3"},[(!_vm.showMobile)?_c('div',{staticClass:"clearfix gibson pl4 mt3 mb2"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix col-12 px0 flex justify-start items-center"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-4 px0 py1 flex justify-start"},[_c('el-input',{attrs:{"placeholder":"Type something"},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}},[_c('i',{staticClass:"el-input__icon el-icon-search",attrs:{"slot":"prefix"},slot:"prefix"})])],1)]),_vm._v(" "),_c('div',{staticClass:"py3"}),_vm._v(" "),_c('div',{staticClass:"clearfix col-12 px3"},[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.tableData.filter(function (data) { return !_vm.search || data.name.toLowerCase().includes(_vm.search.toLowerCase()); }),"stripe":""}},[_c('el-table-column',{attrs:{"type":"expand","label":"Details","width":"100"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('div',{staticClass:"col-11 mx-auto py2 flex justify-start items-start"},[_c('div',{staticClass:"col-2 px2"},[_c('p',{staticClass:"secondarycolor line-height-1 mb1"},[_vm._v("Type")]),_vm._v(" "),_c('p',{staticClass:"regular green"},[_vm._v("\n                  "+_vm._s(props.row.type)+"\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 px2"},[_c('p',{staticClass:"secondarycolor line-height-1 mb1"},[_vm._v("Drafts")]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center"},[_c('a',{staticClass:"regular darkblue",attrs:{"href":""}},[_c('span',{staticClass:"mr1"},[_vm._v("Document Name.pdf")]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-top-right"})])])])]),_vm._v(" "),_c('div',{staticClass:"col-5 px2"},[_c('p',{staticClass:"secondarycolor line-height-1 mb1"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('p',{staticClass:"regular darkblue line-height-3 p2 lightgrey-background"},[_vm._v("Lorem ipsum dolor sit amet consectetur adipisicing elit. Sequi ullam eligendi unde.")])])])]}}],null,false,3731838687)}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"date","label":"Date","width":"180"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"name","label":"Name","width":"420"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"wallet","label":"Wallet","width":"200"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(props.row.wallet))])]}}],null,false,1756442973)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Status","prop":"status","width":"120"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [(props.row.status == 'Approved')?_c('b-alert',{staticClass:"p1 center regular line-height-1 m0 green-background white",attrs:{"show":"","variant":"success"}},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status == 'Pending')?_c('b-alert',{staticClass:"p1 center regular line-height-1 m0",staticStyle:{"background-color":"#FFDD80"},attrs:{"show":"","variant":"warning"}},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status == 'Signed')?_c('b-alert',{staticClass:"p1 center regular line-height-1 m0",staticStyle:{"background-color":"#54C4CB","color":"#016A71"},attrs:{"show":"","variant":"primary"}},[_vm._v(_vm._s(props.row.status))]):_vm._e(),_vm._v(" "),(props.row.status == 'Draft')?_c('b-alert',{staticClass:"p1 center regular line-height-1 m0 mutedxd muted-xd-border",attrs:{"show":"","variant":"light"}},[_vm._v(_vm._s(props.row.status))]):_vm._e()]}}],null,false,2320995608)})],1)],1)]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 ml3 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n        Kontrakter\n      ")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-5 pl3 flex justify-start items-center"},[_c('div',{staticClass:"yellow-background darkblue pt1 pr2 flex justify-start items-center mr1"},[_c('span',{staticClass:"h5 regular mx2"},[_vm._v("17")]),_vm._v(" "),_c('span',{staticClass:"h6 regular mb1"},[_vm._v("I forhandling")])]),_vm._v(" "),_c('div',{staticClass:"darkblue-background pt1 pr2 white flex flex justify-start items-center mr1"},[_c('span',{staticClass:"h5 regular mx2"},[_vm._v("2")]),_vm._v(" "),_c('span',{staticClass:"h6 regular mx2"},[_vm._v("Underskrevet")])]),_vm._v(" "),_c('div',{staticClass:"green-background white pt1 pr2 flex justify-start items-center"},[_c('span',{staticClass:"h5 regular mx2"},[_vm._v("8")]),_vm._v(" "),_c('span',{staticClass:"h6 regular mx2"},[_vm._v("Godkendt")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1514 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inbox_vue__ = __webpack_require__(1516);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fbf4dc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_inbox_vue__ = __webpack_require__(1518);
function injectStyle (ssrContext) {
  __webpack_require__(1515)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_inbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_23fbf4dc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_inbox_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1515 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1516 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countries_json__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_updatebitrixpackagepermission__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Message__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CreditcheckList__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_file_upload_input__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_select__);












var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    updatebitrixpackagepermission: __WEBPACK_IMPORTED_MODULE_4__components_updatebitrixpackagepermission__["a" /* default */],
    Message: __WEBPACK_IMPORTED_MODULE_5__Message__["a" /* default */],
    creditchecklist: __WEBPACK_IMPORTED_MODULE_6__CreditcheckList__["a" /* default */],
    Simplert: __WEBPACK_IMPORTED_MODULE_8_vue2_simplert___default.a,
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_7__components_file_upload_input__["a" /* default */],
    vSelect: __WEBPACK_IMPORTED_MODULE_9_vue_select___default.a,
    Loading: Loading
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.displayMessages();
    this.Reload();
    if (this.$route.query.customerId) {
      this.composeForm.to = Number(this.$route.query.customerId);
      this.composeFormVisible = true;
    }
  },
  mounted: function mounted() {
    this.activeprojectid = this.$route.query.projectId ? this.$route.query.projectId : '';
  },
  data: function data() {
    return {
      totalmessages: 0,
      haaId: '',
      showMobile: false,
      salesPersonBitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      messageDetailsLoading: false,
      searchQuery: '',
      message: '',
      messagesData: [],
      messageDetailsData: [],
      activeCollapse: [],
      messageDetailsVisible: false,
      composeFormVisible: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      replyForm: {
        message: '',
        image: ''
      },
      createPayProfFormVisible: false,
      hasAPayProffAccount: false,
      contactsData: [],
      payProffForm: {
        email: localStorage.getItem('email'),
        phoneNumber: localStorage.getItem('PartnerTelefon'),
        phoneNumberAreaCode: '',
        firstName: localStorage.getItem('name').split(' ')[0],
        lastName: localStorage.getItem('name').split(' ')[1],
        address: '',
        zipCode: localStorage.getItem('CompanyZip'),
        city: '',
        country: '',
        socialSecurityNumber: '',
        registrationNumber: '',
        birthDate: ''
      },
      countryData: __WEBPACK_IMPORTED_MODULE_3__countries_json___default.a,
      sendButtonType: '',
      submitted: '',
      activeName: 'new',
      activeNames: '',
      emails: [],
      sends: [],
      options: [],
      files: [],
      starMessage: '',
      upload_token: '',
      tilbud_id: '',
      salesPerson: '',
      quotation: {
        files: [],
        info: []
      },
      title: '',
      to: '',
      load: 0,
      tabIndex: 0,
      messageinput: '',
      email: { file: [] },
      emailShow: false,
      showDismissibleAlert: false,
      clear_quotation_attachment: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading...',
      drafts: false,
      activeNameInboxSent: 'inbox',
      lastpage: 0,
      totalitems: 1,
      currentPaginatePage: 1,
      paginationLoading: false,
      perPage: 20,
      activeprojectid: ''
    };
  },

  methods: {
    getContacts: function getContacts() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contacts', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.data;
        _this.contactsData = res.data;
        _this.submitted = false;
        _this.messagesLoading = false;
        _this.formLoading = false;
        _this.loading = false;
      }, function (response) {
        _this.messagesLoading = false;
        _this.formLoading = false;
        _this.loading = false;
      });
    },
    clearFields: function clearFields() {
      this.composeForm.to = '';
      this.composeForm.title = '';
      this.composeForm.message = '';
      this.replyForm.message = '';
    },
    paginationChanged: function paginationChanged(curPage) {
      this.paginationLoading = true;
      this.selectedMessageInfo = {};
      this.currentPaginatePage = curPage;
      this.displayMessages();
    },
    displayMessages: function displayMessages() {
      var _this2 = this;

      this.formLoading = true;
      var activeproj = '';
      if (this.$route.query.projectId && !this.$route.query.customerId) {
        activeproj = '&projectId=' + this.$route.query.projectId;
      }
      console.log('activeproj', activeproj);
      this.haaId = localStorage.getItem('haaid');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messagesV2?sent=false&inbox=true&page=' + this.currentPaginatePage + activeproj, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.items;
        _this2.lastpage = response.body.data.last_page;
        _this2.totalitems = response.body.data.total;
        _this2.messagesData = res;
        _this2.totalmessages = _this2.totalitems;
        _this2.perPage = response.body.data.perPage;
        _this2.paginationLoading = false;
        _this2.getContacts();
      }, function (response) {
        _this2.paginationLoading = false;
        _this2.formLoading = false;
        _this2.loading = false;
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    handleToggleInboxSent: function handleToggleInboxSent(tab) {
      if (tab.index === '1') {
        this.$router.push('/messages/sent');
      }
    },
    showoldmessages: function showoldmessages() {
      this.activeName = 'old';
      this.messageDetailsVisible = false;
      this.totalmessages = this.emails.length;
      this.messageDetailsData = [];
      document.getElementById('searchmessages').classList.add('hide');
      document.querySelector('.el-pagination').classList.add('hide');
    },
    Shownewmessages: function Shownewmessages() {
      this.activeName = 'new';
      this.totalmessages = this.resultQuery.length;
      document.getElementById('searchmessages').classList.remove('hide');
      document.querySelector('.el-pagination').classList.remove('hide');
    },
    getMessageDetails: function getMessageDetails(msgId, threadId) {
      var _this3 = this;

      var clickMessage = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.messageDetailsLoading = true;
      var inActiveMsg = document.querySelectorAll('.msgItem');
      for (var x = 0; x < inActiveMsg.length; x++) {
        inActiveMsg[x].classList.remove('active');
      }
      if (!this.showMobile && !this.messageDetailsLoading) {
        var activeMsg = document.querySelector('.msgItem.mail-' + msgId);
        activeMsg.classList.add('active');
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messages/' + msgId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this3.messageDetailsData = [];

        if (threadId === 0) {
          _this3.messageDetailsData.push(clickMessage);
          _this3.activeCollapse.push(clickMessage.ID);
        }
        var sortedresponse = res.sort(function (a, b) {
          return parseFloat(a.ID) - parseFloat(b.ID);
        });
        sortedresponse.forEach(function (message) {
          _this3.messageDetailsData.push(message);
          _this3.activeCollapse.push(message.ID);
        });

        _this3.validateAccount();
        _this3.seenMessage(msgId);
      }, function (response) {
        _this3.messageDetailsLoading = false;
        _this3.seenMessage(msgId);
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var message = _step.value;

                  _this3.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else {
              _this3.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this3.$router.push('/login');
          }
        } else {
          _this3.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    seenMessage: function seenMessage(id) {
      var _this4 = this;

      if (document.querySelector('.mail-' + id).classList.contains('seen-0')) {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        };
        var data = {};
        this.$http.put(this.$bitrixapi + 'partner/message/' + id + '/seen', data, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {
          _this4.messageDetailsLoading = false;
          var error = response.body;
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var message = _step2.value;

                    _this4.$message({
                      type: 'error',
                      message: message[0]
                    });
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              } else {
                _this4.$message({
                  type: 'error',
                  message: error.message
                });
              }
            } else {
              _this4.$router.push('/login');
            }
          } else {
            _this4.$message({
              type: 'error',
              message: error.message
            });
          }
        });
        document.querySelector('.mail-' + id + '.seen-0').classList.add('seen-1');
        document.querySelector('.mail-' + id + '.seen-1').classList.remove('seen-0');
      }
    },
    sendMessage: function sendMessage(type) {
      var _this5 = this;

      this.sendButtonType = type;
      this.submitted = true;
      var to = '';
      var title = '';
      var message = '';

      var url = '';
      var validated = false;
      var data = {};
      var msgDetailsLastIndex = this.messageDetailsData.length - 1;
      if (type === 'compose') {
        to = this.composeForm.to;
        title = this.composeForm.title;
        message = this.composeForm.message;
        data.contactId = to;
        data.title = title;
        data.message = message;

        url = 'partner/message';
      } else {
        to = this.messageDetailsData[msgDetailsLastIndex].CONTACT_ID;
        title = this.messageDetailsData[msgDetailsLastIndex].TITLE;
        message = this.replyForm.message;
        data.contactId = to;
        data.title = title;
        data.message = message;
        var messageid = this.messageDetailsData[msgDetailsLastIndex].THREAD_ID !== 0 ? this.messageDetailsData[msgDetailsLastIndex].THREAD_ID : this.messageDetailsData[msgDetailsLastIndex].ID;

        url = 'partner/messages/' + messageid + '/reply';
      }
      if (to && title && message) {
        validated = true;
      } else {
        validated = false;
      }
      if (validated) {
        if (type === 'compose') {
          this.formLoading = true;
        } else {
          this.messageDetailsLoading = true;
        }

        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        };
        this.$http.post(this.$bitrixapi + url, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (type !== 'compose') {
            _this5.getMessageDetails(_this5.messageDetailsData[0].ID, _this5.messageDetailsData[0].THREAD_ID, _this5.messageDetailsData[0]);
          } else {
            _this5.composeFormVisible = false;
          }

          _this5.clearFields();

          _this5.$message({
            type: 'success',
            message: 'Success'
          });
        }, function (response) {
          _this5.getMessageDetails(_this5.messageDetailsData[msgDetailsLastIndex].ID, _this5.messageDetailsData[msgDetailsLastIndex].THREAD_ID);
          _this5.messageDetailsLoading = false;
          _this5.composeFormVisible = false;
          var error = response.body;
          _this5.$message({
            type: 'error',
            message: error.message
          });
        });
      }
    },
    submitActionButton: function submitActionButton(msgId, action, url) {
      var _this6 = this;

      if (action !== 'contract_document_url') {
        document.querySelector('#btnAction-' + msgId).classList.add('hide');
      }
      var msgDetailsLastIndex = this.messageDetailsData.length - 1;
      this.messageDetailsLoading = true;
      if (action === 'contract_document_url') {
        window.open(url);
        this.messageDetailsLoading = false;
      } else {
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonBitrix
        };
        var data = {};
        this.$http.post(url, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this6.getMessageDetails(_this6.messageDetailsData[msgDetailsLastIndex].ID, _this6.messageDetailsData[msgDetailsLastIndex].THREAD_ID);
          _this6.$message({
            type: 'success',
            message: 'Success'
          });
        }, function (response) {
          _this6.messageDetailsLoading = false;
          var error = response.body;
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                var _iteratorNormalCompletion3 = true;
                var _didIteratorError3 = false;
                var _iteratorError3 = undefined;

                try {
                  for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                    var message = _step3.value;

                    _this6.$message({
                      type: 'error',
                      message: message[0]
                    });
                  }
                } catch (err) {
                  _didIteratorError3 = true;
                  _iteratorError3 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
                      _iterator3.return();
                    }
                  } finally {
                    if (_didIteratorError3) {
                      throw _iteratorError3;
                    }
                  }
                }
              } else {
                _this6.$message({
                  type: 'error',
                  message: error.message
                });
              }
            } else {
              _this6.$router.push('/login');
            }
          } else {
            _this6.$message({
              type: 'error',
              message: error.message
            });
          }
        });
      }
    },
    validateAccount: function validateAccount() {
      var _this7 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonBitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this7.messageDetailsLoading = false;
        _this7.messageDetailsVisible = true;
        setTimeout(function () {
          var msgThread = document.querySelectorAll('.msg-thread');
          var padding = 15;
          var totalPadding = 0;
          var lastUserId = '';
          var currentUserId = '';
          var deductPadding = false;
          for (var i = 0; i < msgThread.length; i++) {
            currentUserId = msgThread[i].id.split('-')[1];
            if (currentUserId !== lastUserId) {
              if (i !== 0) {
                lastUserId = msgThread[i].id.split('-')[1];
              }
              if (deductPadding) {
                totalPadding = padding * i - padding;
                deductPadding = false;
              } else {
                totalPadding = padding * i;
              }
            } else {
              deductPadding = true;
            }
            msgThread[i].style.paddingLeft = totalPadding + 'px';
          }
        }, 50);
        if (res.exists) {
          _this7.hasAPayProffAccount = true;
        } else {
          _this7.hasAPayProffAccount = false;
        }
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion4 = true;
              var _didIteratorError4 = false;
              var _iteratorError4 = undefined;

              try {
                for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                  var message = _step4.value;

                  _this7.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError4 = true;
                _iteratorError4 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion4 && _iterator4.return) {
                    _iterator4.return();
                  }
                } finally {
                  if (_didIteratorError4) {
                    throw _iteratorError4;
                  }
                }
              }
            } else {
              _this7.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this7.$router.push('/login');
          }
        } else {
          _this7.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    createPayProff: function createPayProff() {
      var _this8 = this;

      this.formLoading = true;
      var email = this.payProffForm.email;
      var phoneNumber = this.payProffForm.phoneNumber;
      var phoneNumberAreaCode = this.payProffForm.phoneNumberAreaCode;
      var firstName = this.payProffForm.firstName;
      var lastName = this.payProffForm.lastName;
      var address = this.payProffForm.address;
      var zipCode = this.payProffForm.zipCode;
      var city = this.payProffForm.city;
      var country = this.payProffForm.country;
      var socialSecurityNumber = this.payProffForm.socialSecurityNumber;
      var registrationNumber = this.payProffForm.registrationNumber;
      var birthDate = this.payProffForm.birthDate;


      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.post(this.$http.options.root + '/minbolig/payproff/account?email=' + email + '&phoneNumber=' + phoneNumber + '&phoneNumberAreaCode=' + phoneNumberAreaCode + '&firstName=' + firstName + '&lastName=' + lastName + '&address=' + address + '&zipCode=' + zipCode + '&city=' + city + '&country=' + country + '&socialSecurityNumber=' + socialSecurityNumber + '&birthDate=' + birthDate + '&registrationNumber=' + registrationNumber, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this8.createPayProfFormVisible = false;
        _this8.formLoading = false;
        _this8.hasAPayProffAccount = true;
        _this8.$message({
          type: 'success',
          message: 'Success'
        });
      }, function (response) {
        _this8.formLoading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var message = _step5.value;

                  _this8.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            } else {
              _this8.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this8.$router.push('/login');
          }
        } else {
          _this8.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    seeContract: function seeContract(url) {
      this.$router.push(url);
    },
    handleChange: function handleChange(val) {
      var value = val.split('-');
      this.getMessageDetails(value[0], value[1]);
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
      document.querySelector('#inboxMsg .progress').classList.remove('hide');
    },
    Reload: function Reload() {
      var _this9 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this9.$router.push('/login');
        }
        if (_this9.$route.query.send === 'support' && _this9.load === 0) {
          _this9.formShow = !_this9.formShow;
        }
        _this9.emails = res.resultMessage;
        _this9.sends = res.resultSent;
        _this9.options = res.customer;
        if (_this9.$route.query.email) {
          var email;
          for (email in _this9.emails) {
            if (_this9.emails[email].id === _this9.$route.query.email && _this9.load === 0) _this9.showItemDetails(_this9.emails[email]);
          }
        }
        if (_this9.$route.query.cid) {
          _this9.tabIndex = 2;
          for (var idc in _this9.options) {
            var customerList = _this9.options[idc];
            if (parseInt(customerList.cid) === parseInt(_this9.$route.query.cid)) {
              _this9.to = { 'cid': customerList.cid, 'name': customerList.name };
            }
          }
        }
        if (res.resultMessage.length === 0) _this9.showDismissibleAlert = true;
        if (_this9.$route.query.default === 'imentor') {
          _this9.title = 'Nyt abonnement';
          _this9.message = 'Jeg vil gerne kontaktes ang. et abonnement på Prisberegning.dk';
        }
        if (_this9.$route.query.default === 'haandvaerker') {
          _this9.title = 'Nyt abonnement';
          _this9.message = 'Jeg vil gerne kontaktes ang. et abonnement på Håndværker.dk';
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(email) {
      var _this10 = this;

      this.emailShow = !this.emailShow;
      this.email = email;
      if (this.email.frompid !== '0') return;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message_read', salesPerson: this.salesPerson, email_id: email.id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this10.$router.push('/login');
        }
        localStorage.setItem('inbox', res.inbox);
        $('#totalInbox').html(res.inbox);
        if (res.inbox === 0) {
          $('#totalInbox').hide();
        } else {
          $('#totalInbox').show();
        }
      }, function (response) {
        alert('error');
      });
    },
    send_service: function send_service(evt) {
      var _this11 = this;

      if (!this.to.cid) return;
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'send_service', salesPerson: this.salesPerson, title: this.title, message: this.message, to: this.to.cid, files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this11.show = false;
        if (res.login === false) {
          _this11.$router.push('/login');
        }
        if (res.success) {
          _this11.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this11.$refs.simplert.openSimplert(obj);
          _this11.load = 1;
          _this11.Reload();
          _this11.formShow = false;
          _this11.title = '';
          _this11.message = '';
          _this11.files = [];
          _this11.tabIndex = 0;
          document.querySelector('#inboxMsg .progress').classList.add('hide');
          var fileList = document.querySelectorAll('#inboxMsg .upload-file-list li');
          for (var i = 0; i < fileList.length; i++) {
            fileList[i].remove();
            console.log(fileList[i]);
          }
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    resend_service: function resend_service(email) {
      this.$refs.emailModal.hide();
      this.formShow = !this.formShow;
      this.title = 'Re: ' + email.title;
      console.log(email.cid + 'hgggg');
      for (var idc in this.options) {
        var customerList = this.options[idc];
        if (parseInt(customerList.cid) === parseInt(email.cid)) {
          this.to = { 'cid': customerList.cid, 'name': customerList.name };
        }
      }
    },
    mailSupport: function mailSupport() {
      this.formShow = !this.formShow;
    },
    hideModal: function hideModal() {
      this.$refs.emailModal.hide();
    },
    hideModalForm: function hideModalForm() {
      this.$refs.formModal.hide();
    }
  },
  computed: {
    resultQuery: function resultQuery() {
      var _this12 = this;

      if (this.searchQuery) {
        return this.messagesData.filter(function (msg) {
          return _this12.searchQuery.toLowerCase().split(' ').every(function (v) {
            return msg.TITLE.toLowerCase().includes(v);
          });
        });
      } else {
        return this.messagesData;
      }
    }
  }
});

/***/ }),
/* 1517 */
/***/ (function(module, exports) {

module.exports = {"BD":"Bangladesh","BE":"Belgium","BF":"Burkina Faso","BG":"Bulgaria","BA":"Bosnia and Herzegovina","BB":"Barbados","WF":"Wallis and Futuna","BL":"Saint Barthelemy","BM":"Bermuda","BN":"Brunei","BO":"Bolivia","BH":"Bahrain","BI":"Burundi","BJ":"Benin","BT":"Bhutan","JM":"Jamaica","BV":"Bouvet Island","BW":"Botswana","WS":"Samoa","BQ":"Bonaire, Saint Eustatius and Saba ","BR":"Brazil","BS":"Bahamas","JE":"Jersey","BY":"Belarus","BZ":"Belize","RU":"Russia","RW":"Rwanda","RS":"Serbia","TL":"East Timor","RE":"Reunion","TM":"Turkmenistan","TJ":"Tajikistan","RO":"Romania","TK":"Tokelau","GW":"Guinea-Bissau","GU":"Guam","GT":"Guatemala","GS":"South Georgia and the South Sandwich Islands","GR":"Greece","GQ":"Equatorial Guinea","GP":"Guadeloupe","JP":"Japan","GY":"Guyana","GG":"Guernsey","GF":"French Guiana","GE":"Georgia","GD":"Grenada","GB":"United Kingdom","GA":"Gabon","SV":"El Salvador","GN":"Guinea","GM":"Gambia","GL":"Greenland","GI":"Gibraltar","GH":"Ghana","OM":"Oman","TN":"Tunisia","JO":"Jordan","HR":"Croatia","HT":"Haiti","HU":"Hungary","HK":"Hong Kong","HN":"Honduras","HM":"Heard Island and McDonald Islands","VE":"Venezuela","PR":"Puerto Rico","PS":"Palestinian Territory","PW":"Palau","PT":"Portugal","SJ":"Svalbard and Jan Mayen","PY":"Paraguay","IQ":"Iraq","PA":"Panama","PF":"French Polynesia","PG":"Papua New Guinea","PE":"Peru","PK":"Pakistan","PH":"Philippines","PN":"Pitcairn","PL":"Poland","PM":"Saint Pierre and Miquelon","ZM":"Zambia","EH":"Western Sahara","EE":"Estonia","EG":"Egypt","ZA":"South Africa","EC":"Ecuador","IT":"Italy","VN":"Vietnam","SB":"Solomon Islands","ET":"Ethiopia","SO":"Somalia","ZW":"Zimbabwe","SA":"Saudi Arabia","ES":"Spain","ER":"Eritrea","ME":"Montenegro","MD":"Moldova","MG":"Madagascar","MF":"Saint Martin","MA":"Morocco","MC":"Monaco","UZ":"Uzbekistan","MM":"Myanmar","ML":"Mali","MO":"Macao","MN":"Mongolia","MH":"Marshall Islands","MK":"Macedonia","MU":"Mauritius","MT":"Malta","MW":"Malawi","MV":"Maldives","MQ":"Martinique","MP":"Northern Mariana Islands","MS":"Montserrat","MR":"Mauritania","IM":"Isle of Man","UG":"Uganda","TZ":"Tanzania","MY":"Malaysia","MX":"Mexico","IL":"Israel","FR":"France","IO":"British Indian Ocean Territory","SH":"Saint Helena","FI":"Finland","FJ":"Fiji","FK":"Falkland Islands","FM":"Micronesia","FO":"Faroe Islands","NI":"Nicaragua","NL":"Netherlands","NO":"Norway","NA":"Namibia","VU":"Vanuatu","NC":"New Caledonia","NE":"Niger","NF":"Norfolk Island","NG":"Nigeria","NZ":"New Zealand","NP":"Nepal","NR":"Nauru","NU":"Niue","CK":"Cook Islands","XK":"Kosovo","CI":"Ivory Coast","CH":"Switzerland","CO":"Colombia","CN":"China","CM":"Cameroon","CL":"Chile","CC":"Cocos Islands","CA":"Canada","CG":"Republic of the Congo","CF":"Central African Republic","CD":"Democratic Republic of the Congo","CZ":"Czech Republic","CY":"Cyprus","CX":"Christmas Island","CR":"Costa Rica","CW":"Curacao","CV":"Cape Verde","CU":"Cuba","SZ":"Swaziland","SY":"Syria","SX":"Sint Maarten","KG":"Kyrgyzstan","KE":"Kenya","SS":"South Sudan","SR":"Suriname","KI":"Kiribati","KH":"Cambodia","KN":"Saint Kitts and Nevis","KM":"Comoros","ST":"Sao Tome and Principe","SK":"Slovakia","KR":"South Korea","SI":"Slovenia","KP":"North Korea","KW":"Kuwait","SN":"Senegal","SM":"San Marino","SL":"Sierra Leone","SC":"Seychelles","KZ":"Kazakhstan","KY":"Cayman Islands","SG":"Singapore","SE":"Sweden","SD":"Sudan","DO":"Dominican Republic","DM":"Dominica","DJ":"Djibouti","DK":"Denmark","VG":"British Virgin Islands","DE":"Germany","YE":"Yemen","DZ":"Algeria","US":"United States","UY":"Uruguay","YT":"Mayotte","UM":"United States Minor Outlying Islands","LB":"Lebanon","LC":"Saint Lucia","LA":"Laos","TV":"Tuvalu","TW":"Taiwan","TT":"Trinidad and Tobago","TR":"Turkey","LK":"Sri Lanka","LI":"Liechtenstein","LV":"Latvia","TO":"Tonga","LT":"Lithuania","LU":"Luxembourg","LR":"Liberia","LS":"Lesotho","TH":"Thailand","TF":"French Southern Territories","TG":"Togo","TD":"Chad","TC":"Turks and Caicos Islands","LY":"Libya","VA":"Vatican","VC":"Saint Vincent and the Grenadines","AE":"United Arab Emirates","AD":"Andorra","AG":"Antigua and Barbuda","AF":"Afghanistan","AI":"Anguilla","VI":"U.S. Virgin Islands","IS":"Iceland","IR":"Iran","AM":"Armenia","AL":"Albania","AO":"Angola","AQ":"Antarctica","AS":"American Samoa","AR":"Argentina","AU":"Australia","AT":"Austria","AW":"Aruba","IN":"India","AX":"Aland Islands","AZ":"Azerbaijan","IE":"Ireland","ID":"Indonesia","UA":"Ukraine","QA":"Qatar","MZ":"Mozambique"}

/***/ }),
/* 1518 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix notosans px2 mb4",attrs:{"id":"messages"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"flex xs-hide"},[_c('div',{staticClass:"col-5 pl0 pr3"},[_c('el-tabs',{attrs:{"id":"inboxsent"},on:{"tab-click":_vm.handleToggleInboxSent},model:{value:(_vm.activeNameInboxSent),callback:function ($$v) {_vm.activeNameInboxSent=$$v},expression:"activeNameInboxSent"}},[_c('el-tab-pane',{attrs:{"label":"Indbakke","name":"inbox"}},[_c('div',{staticClass:"py2 highlights"},[_c('div',[_c('div',{staticClass:"mb2 flex col-12 items-center p0"},[_c('p',{staticClass:"h6 m0 p0 flex"},[_c('span',{},[_vm._v("Alle meddelelser ")]),_vm._v(" "),_c('span',{staticClass:"p1 white darkblue-background ml1"},[_vm._v(_vm._s(parseInt(_vm.totalmessages)))])])]),_vm._v(" "),_c('div',{staticClass:"flex mb1",attrs:{"id":"searchmessages"}},[_c('div',{staticClass:"col-9 p0 m0"},[_c('div',{staticClass:"flex justify-between border items-center mb3"},[_c('div',{staticClass:"inline-block h4 line-height-1 m0 p0 mx2"},[_c('i',{staticClass:"easternblue el-icon-search"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"h6 book darkblue border-none not-rounded line-height-1 m0 py2 pr0 col-10",staticStyle:{"height":"45px"},attrs:{"placeholder":"Søg i beskeder","type":"text"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[_c('button',{staticClass:"col-12 block action-button button-padding border-none not-rounded font14 regular line-height-1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = true}}},[_c('span',[_vm._v("Ny email "),_c('i',{staticClass:"el-icon-circle-plus-outline"})])])])]),_vm._v(" "),(_vm.paginationLoading)?_c('div',{staticStyle:{"height":"600px"}},[_c('Loading')],1):_c('el-tabs',{attrs:{"id":"oldmessagestoggle"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Nye beskeder","name":"new"}},[_c('div',{staticClass:"overflow-auto",staticStyle:{"height":"650px"}},[(_vm.resultQuery && _vm.resultQuery.length > 0 && _vm.messagesData != null && _vm.messagesData.length > 0)?_c('div',_vm._l((_vm.resultQuery),function(msgs,index){return _c('div',{class:'flex border secondarycolor-border p2 pointer msgItem mail-'+ msgs.ID +' seen-' + msgs.SEEN + ' fromPartner-' + msgs.IS_FROM_PARTNER,on:{"click":function($event){return _vm.getMessageDetails(msgs.ID, msgs.THREAD_ID, msgs)}}},[_c('div',{staticClass:"col-2 p0"},[_c('img',{staticClass:"rounded-circle border",attrs:{"src":msgs.IS_FROM_PARTNER ? msgs.PARTNER.AVATAR : msgs.CONTACT.AVATAR,"width":"50","height":"50"}})]),_vm._v(" "),_c('div',{staticClass:"col-10 p0 flex justify-between"},[_c('div',{staticClass:"col-10 p0"},[_c('div',{staticClass:"flex flex-wrap justify-between"},[_c('span',{staticClass:"h5 darkblue block"},[_vm._v(_vm._s(msgs.IS_FROM_PARTNER ? msgs.PARTNER.NAME : msgs.CONTACT.NAME))]),_vm._v(" "),(msgs.PROJECT != null)?_c('span',{staticClass:"font14 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2"},[_vm._v(_vm._s(msgs.PROJECT.NAME))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"h6 darkblue block"},[_vm._v(_vm._s(msgs.TITLE.length >= 40 ? msgs.TITLE.substring(0, 40) + '...' : msgs.TITLE))]),_vm._v(" "),_c('span',{staticClass:"font14 regular mediumgrey block m0",domProps:{"innerHTML":_vm._s(msgs.MESSAGE.length >= 55 ? msgs.MESSAGE.replace(/\<br\>/g,' ').substring(0, 55) + '...' : msgs.MESSAGE.replace(/\<br\>/g,' '))}})]),_vm._v(" "),_c('div',{staticClass:"col-2 p0"},[_c('p',{staticClass:"small regular m0 mediumgrey text-right"},[_vm._v(_vm._s(_vm.moment(msgs.SEND_DATE).fromNow()))])])])])}),0):_c('div',[_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center"},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"h1 menu-icon-mail"})]),_vm._v(" "),_c('p',{staticClass:"h5 center regular easternblue m0 p0"},[_vm._v("Ingen beskeder")])])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Gamle beskeder","name":"old"}},[_c('div',{staticClass:"right-align"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/email"}},[_vm._v("E-mail")])],1),_vm._v(" "),_c('div',{staticClass:"py2 inboxSpecial overflow-auto",staticStyle:{"height":"710px"}},[_c('b-tabs',{attrs:{"pills":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-download mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Inbox")])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"messages notosans"},[_c('b-alert',{staticClass:"col-12 px0 primarycolor flex justify-start items-center",attrs:{"show":_vm.showDismissibleAlert}},[_c('div',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-inbox-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z"}})])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_vm._v("Din indbakke er tom")])]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2)])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"my2 flex col-12 p0"},[_c('el-pagination',{staticClass:"ml-auto",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":this.totalitems},on:{"current-change":_vm.paginationChanged}})],1)],1)])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Sendt","name":"sent"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-7 p3 highlights overflow-auto",staticStyle:{"height":"860px"}},[(_vm.messageDetailsLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',[(_vm.messageDetailsVisible)?_c('div',[(_vm.messageDetailsData.length > 0)?_c('div',{staticClass:"flex mb4"},[_c('span',{staticClass:"h2 darkblue mr2"},[_vm._v(_vm._s(_vm.messageDetailsData[0].TITLE))]),_vm._v(" "),(_vm.messageDetailsData[0].PROJECT != null)?_c('span',{staticClass:"h6 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2"},[_vm._v(_vm._s(_vm.messageDetailsData[0].PROJECT.NAME)+"\n                ")]):_vm._e()]):_vm._e(),_vm._v(" "),_c('el-collapse',{staticClass:"mb4",model:{value:(_vm.activeCollapse),callback:function ($$v) {_vm.activeCollapse=$$v},expression:"activeCollapse"}},_vm._l((_vm.messageDetailsData),function(msg,index0){return _c('el-collapse-item',{key:index0,staticClass:"msg-thread mb3",attrs:{"id":msg.IS_FROM_PARTNER ? 'userId-' + msg.PARTNER_ID : 'userId-' + msg.CONTACT_ID,"name":msg.ID}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex justify-between items-center col-12 p0 mb2"},[_c('div',{staticClass:"flex justify-between items-center mr1"},[_c('img',{staticClass:"rounded-circle mr1",attrs:{"src":msg.IS_FROM_PARTNER ? msg.PARTNER.AVATAR : msg.CONTACT.AVATAR,"alt":"avatar","width":"50","height":"50"}}),_vm._v(" "),_c('p',{staticClass:"h5 regular shakespeare m0 line-height-4"},[_vm._v(_vm._s(msg.IS_FROM_PARTNER ? msg.PARTNER.NAME : msg.CONTACT.NAME))])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"regular mediumgrey line-height-1 m0"},[_c('span',{staticClass:"capital"},[_vm._v(_vm._s(_vm.moment(msg.SEND_DATE).locale('da').format('LL')))]),_vm._v("\n                          ("+_vm._s(_vm.moment(msg.SEND_DATE).fromNow())+")\n                        ")])])])]),_vm._v(" "),_c('div',{staticClass:"h6 regular line-height-golden mediumgrey mb2",domProps:{"innerHTML":_vm._s(msg.MESSAGE)}}),_vm._v(" "),(msg.ACTIONS && !msg.ACTIONS.IS_DONE)?_c('div',{staticClass:"flex flex-wrap col-12 m0 p0"},[(!_vm.hasAPayProffAccount)?_c('button',{staticClass:"action-button button-padding border-none not-rounded h5 capital regular line-height-1 p1 mr1 mb2",staticStyle:{"height":"54px"},on:{"click":function($event){_vm.createPayProfFormVisible = true}}},[_c('span',{staticClass:"capitalize"},[_vm._v("Create Payproff Account")])]):_vm._e(),_vm._v(" "),(!msg.IS_FROM_PARTNER)?_c('div',{class:'mb3 isDone-' + msg.ACTIONS.IS_DONE,attrs:{"id":'btnAction-' + msg.ID}},_vm._l((msg.ACTIONS.ITEMS),function(btnAction,index){return _c('el-tooltip',{key:index,attrs:{"content":btnAction.ACTION.replaceAll('_', ' ').toUpperCase(),"placement":"top","effect":"light"}},[(btnAction.ACTION === 'edit_contract')?_c('a',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline",attrs:{"type":"button","href":btnAction.DATA}},[_c('span',{},[_c('i',{staticClass:"el-icon-document"})])]):(btnAction.ACTION === 'edit_extra_work')?_c('a',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline",attrs:{"type":"button","href":'#' + btnAction.DATA.split('#')[1]}},[_c('span',{},[_vm._v("Ny aftale seddel")])]):(btnAction.ACTION === 'view_deficiency')?_c('a',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline",attrs:{"type":"button","href":'#' + btnAction.DATA.split('#')[1]}},[_c('span',{},[_vm._v(_vm._s(btnAction.TITLE_DK))])]):_c('button',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitActionButton(msg.ID, btnAction.ACTION, btnAction.DATA)}}},[(btnAction.ACTION == 'bank_payment')?_c('span',{},[_c('i',{staticClass:"el-icon-bank-card"})]):(btnAction.ACTION == 'rate_partner')?_c('span',{},[_c('i',{staticClass:"el-icon-star-off"})]):_vm._e()])])}),1):_vm._e()]):_vm._e(),_vm._v(" "),(msg.FILES.length > 0)?_c('div',{staticClass:"mb3"},_vm._l((msg.FILE),function(file,index){return _c('a',{key:index,staticClass:"block",attrs:{"target":"_blank","href":file}},[_vm._v(_vm._s(file.replace(_vm.$http.options.root.slice(0, -2) + 'upload/partner/messages/', '')))])}),0):_vm._e()],2)}),1),_vm._v(" "),_c('div',[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.replyForm.message),callback:function ($$v) {_vm.$set(_vm.replyForm, "message", $$v)},expression:"replyForm.message"}}),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendMessage('reply')}}},[_c('span',[_vm._v("Send")])])],1)],1):_c('div',{staticClass:"center py2"},[_c('span',{staticClass:"h5"},[_vm._v("Vælg en besked, der skal vises")])])])])]),_vm._v(" "),_c('div',{staticClass:"sm-hide lg-hide md-hide xxl-hide"},[_c('div',{staticClass:"col-12 p0"},[_c('div',{staticClass:"flex justify-between border items-center mb3"},[_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"h6 book gibson darkblue border-none not-rounded line-height-1 m0 py2 pr0 col-10",attrs:{"placeholder":"Søg i beskeder","type":"text"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"mb2 flex col-12 items-center p0"},[_c('p',{staticClass:"h5 m0 p0"},[_vm._v(" Alle meddelelser "),_c('span',{staticClass:"border p1 white darkblue-background"},[_vm._v(_vm._s(Number(_vm.totalmessages)))])])]),_vm._v(" "),(_vm.paginationLoading)?_c('div',[_c('Loading')],1):_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Nye beskeder","name":"new"}},[_c('el-collapse',{attrs:{"accordion":""},on:{"change":_vm.handleChange},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},_vm._l((_vm.resultQuery),function(msgs){return _c('el-collapse-item',{key:msgs.ID,class:'border secondarycolor-border p1 pointer msgItem mail-'+ msgs.ID +' seen-' + msgs.SEEN + ' fromPartner-' + msgs.IS_FROM_PARTNER,attrs:{"name":msgs.ID+'-'+msgs.THREAD_ID},on:{"click":function($event){return _vm.getMessageDetails(msgs.ID, msgs.THREAD_ID, msgs)}}},[_c('template',{slot:"title"},[_c('div',{staticClass:"col-2 p0"},[_c('img',{staticClass:"rounded-circle border messageavatar",attrs:{"src":msgs.IS_FROM_PARTNER ? msgs.PARTNER.AVATAR : msgs.CONTACT.AVATAR,"width":"50","height":"50"}})]),_vm._v(" "),_c('div',{staticClass:"col-10 p0 flex items-center"},[_c('div',{staticClass:"col-4 p0"},[_c('div',{staticClass:"flex flex-wrap justify-between"},[_c('span',{staticClass:"h6 darkblue block"},[_vm._v(_vm._s(_vm._f("truncate")((msgs.IS_FROM_PARTNER ? msgs.PARTNER.NAME : msgs.CONTACT.NAME),10, '..')))])])]),_vm._v(" "),_c('div',{staticClass:"col-6 p0 flex items-center"},[(msgs.PROJECT != null)?_c('span',{staticClass:"h6 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block"},[_vm._v(_vm._s(_vm._f("truncate")(msgs.PROJECT.NAME,25, '..')))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"col-2 p0"},[_c('p',{staticClass:"small regular m0 mediumgrey text-right"},[_vm._v(_vm._s(_vm.moment(msgs.SEND_DATE).fromNow()))])])])]),_vm._v(" "),_c('div',{staticClass:"p3 highlights"},[(_vm.messageDetailsLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',[(_vm.messageDetailsVisible)?_c('div',[_c('el-collapse',{staticClass:"mb4",model:{value:(_vm.activeCollapse),callback:function ($$v) {_vm.activeCollapse=$$v},expression:"activeCollapse"}},_vm._l((_vm.messageDetailsData),function(msg,index0){return _c('el-collapse-item',{key:index0,staticClass:"msg-thread mb3",attrs:{"id":msg.IS_FROM_PARTNER ? 'userId-' + msg.PARTNER_ID : 'userId-' + msg.CONTACT_ID,"name":msg.ID}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex justify-between items-center col-12 p0 mb2"},[_c('div',{staticClass:"flex justify-between items-center mr1"},[_c('img',{staticClass:"rounded-circle mr1",attrs:{"src":msg.IS_FROM_PARTNER ? msg.PARTNER.AVATAR : msg.CONTACT.AVATAR,"alt":"avatar","width":"50","height":"50"}}),_vm._v(" "),_c('p',{staticClass:"h5 regular shakespeare m0 line-height-4"},[_vm._v(_vm._s(msg.IS_FROM_PARTNER ? msg.PARTNER.NAME : msg.CONTACT.NAME)+"\n                                  ")])]),_vm._v(" "),_c('div',[_c('p',{staticClass:"regular mediumgrey line-height-1 m0"},[_c('span',{staticClass:"capital"},[_vm._v(_vm._s(_vm.moment(msg.SEND_DATE).locale('da').format('LL')))]),_vm._v("\n                                    "+_vm._s(_vm.moment(msg.SEND_DATE).locale('da').format('LL'))+"\n                                    ("+_vm._s(_vm.moment(msg.SEND_DATE).fromNow())+")\n                                  ")])])])]),_vm._v(" "),_c('div',{staticClass:"h6 regular line-height-golden mediumgrey mb2",domProps:{"innerHTML":_vm._s(msg.MESSAGE)}}),_vm._v(" "),(_vm.hasAPayProffAccount && msg.ACTIONS && !msg.ACTIONS.IS_DONE)?_c('div',[(!msg.IS_FROM_PARTNER)?_c('div',{class:'mb3 isDone-' + msg.ACTIONS.IS_DONE,attrs:{"id":'btnAction-' + msg.ID}},_vm._l((msg.ACTIONS.ITEMS),function(btnAction,index){return _c('el-tooltip',{key:index,attrs:{"content":btnAction.ACTION.replaceAll('_', ' ').toUpperCase(),"placement":"top","effect":"light"}},[(btnAction.ACTION === 'edit_contract')?_c('a',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline",attrs:{"type":"button","href":btnAction.DATA}},[_c('span',{},[_c('i',{staticClass:"el-icon-document"})])]):(btnAction.ACTION === 'edit_extra_work')?_c('a',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2 no-underline",attrs:{"type":"button","href":'#' + btnAction.DATA.split('#')[1]}},[_c('span',{},[_vm._v("Ny aftale seddel")])]):_c('button',{staticClass:"action-button not-rounded h5 regular line-height-1 px3 py2 mr1 mb2",attrs:{"type":"button"},on:{"click":function($event){return _vm.submitActionButton(msg.ID, btnAction.ACTION, btnAction.DATA)}}},[(btnAction.ACTION == 'bank_payment')?_c('span',{},[_c('i',{staticClass:"el-icon-bank-card"})]):(btnAction.ACTION == 'rate_partner')?_c('span',{},[_c('i',{staticClass:"el-icon-star-off"})]):_vm._e()])])}),1):_vm._e()]):(!_vm.hasAPayProffAccount && msg.ACTIONS && !msg.ACTIONS.IS_DONE)?_c('div',[_c('button',{staticClass:"action-button button-padding border-none not-rounded h5 capital regular line-height-1 py2 px1 mr1 mb2",attrs:{"type":"button"},on:{"click":function($event){_vm.createPayProfFormVisible = true}}},[_c('span',{staticClass:"capitalize"},[_vm._v("Create Payproff Account")])])]):_vm._e(),_vm._v(" "),(msg.FILES.length > 0)?_c('div',{staticClass:"mb3"},_vm._l((msg.FILE),function(file,index){return _c('a',{key:index,staticClass:"block",attrs:{"target":"_blank","href":file}},[_vm._v(_vm._s(file.replace(_vm.$http.options.root.slice(0, -2) + 'upload/partner/messages/', '')))])}),0):_vm._e()],2)}),1),_vm._v(" "),_c('div',[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.replyForm.message),callback:function ($$v) {_vm.$set(_vm.replyForm, "message", $$v)},expression:"replyForm.message"}}),_vm._v(" "),_c('button',{staticClass:"col-12 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendMessage('reply')}}},[_c('span',[_vm._v("Send")])])],1)],1):_c('div',{staticClass:"center py2"},[_c('span',{staticClass:"h5"},[_vm._v("Vælg en besked, der skal vises")])])])])],2)}),1)],1),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Gamle beskeder","name":"old"}},[_c('div',{staticClass:"right-align"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/email"}},[_vm._v("E-mail")])],1),_vm._v(" "),_c('div',{staticClass:"py2 inboxSpecial"},[_c('b-tabs',{attrs:{"pills":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-download mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Inbox")])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"messages notosans"},[_c('b-alert',{staticClass:"col-12 px0 primarycolor flex justify-start items-center",attrs:{"show":_vm.showDismissibleAlert}},[_c('div',{staticClass:"relative",staticStyle:{"top":"3px"}},[_c('svg',{staticClass:"jam jam-inbox-f",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","viewBox":"-2 -5 24 24","width":"24","height":"24","preserveAspectRatio":"xMinYMin"}},[_c('path',{attrs:{"d":"M20 5H0l4-5h12l4 5zm0 2v5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2V7h6.126a4.002 4.002 0 0 0 7.748 0H20zM8.265 7h3.465a2 2 0 0 1-3.465 0z"}})])]),_vm._v(" "),_c('div',{staticClass:"px2"},[_vm._v("Din indbakke er tom")])]),_vm._v(" "),_vm._l((_vm.emails),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2)])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"my2"},[_c('el-pagination',{staticClass:"ml-auto",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":this.totalitems},on:{"current-change":_vm.paginationChanged}}),_vm._v(" "),_c('div',{staticClass:"py4 sm-hide lg-hide xxl-hide"})],1)],1)])])]),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"id":"inboxMessage","hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.composeFormVisible),callback:function ($$v) {_vm.composeFormVisible=$$v},expression:"composeFormVisible"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Ny besked")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',[_c('div',{staticClass:"form-group"},[_c('el-select',{staticClass:"col-12 p0",attrs:{"filterable":"","placeholder":"To"},model:{value:(_vm.composeForm.to),callback:function ($$v) {_vm.$set(_vm.composeForm, "to", $$v)},expression:"composeForm.to"}},[_c('el-option',{key:"888888888",attrs:{"label":"Info@haandvaerker.dk","value":1}}),_vm._v(" "),_vm._l((_vm.contactsData),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.NAME,"value":item.ID}})})],2),_vm._v(" "),(_vm.submitted && !_vm.composeForm.to)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Title"},model:{value:(_vm.composeForm.title),callback:function ($$v) {_vm.$set(_vm.composeForm, "title", $$v)},expression:"composeForm.title"}}),_vm._v(" "),(_vm.submitted && !_vm.composeForm.title)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group mb4"},[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat"},model:{value:(_vm.composeForm.message),callback:function ($$v) {_vm.$set(_vm.composeForm, "message", $$v)},expression:"composeForm.message"}}),_vm._v(" "),(_vm.submitted && !_vm.composeForm.message)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = false}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendMessage('compose')}}},[_c('span',[_vm._v("Send")])])])])]),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.createPayProfFormVisible),callback:function ($$v) {_vm.createPayProfFormVisible=$$v},expression:"createPayProfFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n            Skriv til ...\n          ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Create Payproff")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',{on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.createPayProff()}}},[_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Email","required":""},model:{value:(_vm.payProffForm.email),callback:function ($$v) {_vm.$set(_vm.payProffForm, "email", $$v)},expression:"payProffForm.email"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Phone","required":""},model:{value:(_vm.payProffForm.phoneNumber),callback:function ($$v) {_vm.$set(_vm.payProffForm, "phoneNumber", $$v)},expression:"payProffForm.phoneNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Phone Area Code","required":""},model:{value:(_vm.payProffForm.phoneNumberAreaCode),callback:function ($$v) {_vm.$set(_vm.payProffForm, "phoneNumberAreaCode", $$v)},expression:"payProffForm.phoneNumberAreaCode"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Firstname","required":""},model:{value:(_vm.payProffForm.firstName),callback:function ($$v) {_vm.$set(_vm.payProffForm, "firstName", $$v)},expression:"payProffForm.firstName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Lastname","required":""},model:{value:(_vm.payProffForm.lastName),callback:function ($$v) {_vm.$set(_vm.payProffForm, "lastName", $$v)},expression:"payProffForm.lastName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Address","required":""},model:{value:(_vm.payProffForm.address),callback:function ($$v) {_vm.$set(_vm.payProffForm, "address", $$v)},expression:"payProffForm.address"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Zip","required":""},model:{value:(_vm.payProffForm.zipCode),callback:function ($$v) {_vm.$set(_vm.payProffForm, "zipCode", $$v)},expression:"payProffForm.zipCode"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"City","required":""},model:{value:(_vm.payProffForm.city),callback:function ($$v) {_vm.$set(_vm.payProffForm, "city", $$v)},expression:"payProffForm.city"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-select',{staticClass:"col-12 p0",attrs:{"filterable":"","placeholder":"Country","autocomplete":"new-password","required":""},model:{value:(_vm.payProffForm.country),callback:function ($$v) {_vm.$set(_vm.payProffForm, "country", $$v)},expression:"payProffForm.country"}},_vm._l((_vm.countryData),function(country,index){return _c('el-option',{key:index,attrs:{"label":country,"value":index}})}),1)],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Social Security Number","required":""},model:{value:(_vm.payProffForm.socialSecurityNumber),callback:function ($$v) {_vm.$set(_vm.payProffForm, "socialSecurityNumber", $$v)},expression:"payProffForm.socialSecurityNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Registration Number","required":""},model:{value:(_vm.payProffForm.registrationNumber),callback:function ($$v) {_vm.$set(_vm.payProffForm, "registrationNumber", $$v)},expression:"payProffForm.registrationNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-date-picker',{staticClass:"dateSelect",attrs:{"type":"date","placeholder":"Birth Date","required":""},model:{value:(_vm.payProffForm.birthDate),callback:function ($$v) {_vm.$set(_vm.payProffForm, "birthDate", $$v)},expression:"payProffForm.birthDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Account Number","required":""},model:{value:(_vm.payProffForm.accountNumber),callback:function ($$v) {_vm.$set(_vm.payProffForm, "accountNumber", $$v)},expression:"payProffForm.accountNumber"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.createPayProfFormVisible = false}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"submit"}},[_c('span',[_vm._v("Send")])])])])]),_vm._v(" "),_c('b-modal',{ref:"emailModal",attrs:{"centered":"","lazy":"","size":"lg"},model:{value:(_vm.emailShow),callback:function ($$v) {_vm.emailShow=$$v},expression:"emailShow"}},[_c('div',{staticClass:"w-100 p-2",attrs:{"slot":"modal-header"},slot:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-content border-none gibson p1"},[_c('div',{staticClass:"d-flex flex-column p1"},[_c('div',{staticClass:"line-height-golden h6 font-weight-bold"},[(_vm.email.frompid !== '0')?[_vm._v("Til:")]:_vm._e(),_vm._v("  "+_vm._s(_vm.email.firstname)+" "+_vm._s(_vm.email.lastname)+": "+_vm._s(_vm.email.title)+"\n        ")],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"far fa-clock text-muted",staticStyle:{"position":"relative","top":"1px"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.moment(_vm.email.createtime).format('lll')))])])]),_vm._v(" "),_c('b-embed',{attrs:{"type":"iframe","seamless":"","src":'https://www.kundematch.dk/newpartner/readmessage.php?email_id='+_vm.email.id+'&id='+_vm.salesPerson,"aspect":"1by1"}})],1),_vm._v(" "),(_vm.email.file.length !== 0)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"12","md":"2","lg":"2"}},[_vm._v("\n        Files :\n      ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.email.file),function(attachment,index){return _c('li',{key:index,staticClass:"py-1"},[_c('a',{attrs:{"href":'https://www.kundematch.dk/HenttilbudImg.php?img='+attachment,"target":"_blank"}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-4 pl-2 pr-2 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"rounded float-left",attrs:{"slot":"modal-ok","type":"button","variant":"success","size":"lg","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.resend_service(_vm.email)}},slot:"modal-ok"},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"}})])]),_vm._v("Reply\n        ")])],1),_vm._v(" "),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-right rounded",attrs:{"slot":"modal-cancel","type":"buttom","variant":"secondary","size":"lg"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('i',{staticClass:"el-icon-error mr-2"}),_vm._v("Luk\n        ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.formShow),callback:function ($$v) {_vm.formShow=$$v},expression:"formShow"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n            Skriv til ...\n          ")])])])]),_vm._v(" "),_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"modal-content border-none p2"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n              Ingen matchende ...\n            ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.messageinput),callback:function ($$v) {_vm.messageinput=$$v},expression:"messageinput"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 py3 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button p2 px3 h5 gibson border-none not-rounded justify-start items-center",attrs:{"type":"reset"},on:{"click":_vm.hideModalForm}},[_c('span'),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 px3 gibson h5 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span'),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Send")])])])])],1),_vm._v(" "),_c('updatebitrixpackagepermission',{ref:"updatebitrixpackagepermission"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 mt1"},[_vm._v("Indbakke")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"inline-block h4 line-height-1 m0 p0 mx2"},[_c('i',{staticClass:"easternblue el-icon-search"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1519 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sent_vue__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7748589c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_sent_vue__ = __webpack_require__(1522);
function injectStyle (ssrContext) {
  __webpack_require__(1520)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7748589c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_sent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1520 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1521 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Message__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CreditcheckList__ = __webpack_require__(163);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__ = __webpack_require__(48);








var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Message: __WEBPACK_IMPORTED_MODULE_3__Message__["a" /* default */],
    fileUploadInput: __WEBPACK_IMPORTED_MODULE_5__components_file_upload_input__["a" /* default */],
    creditchecklist: __WEBPACK_IMPORTED_MODULE_4__CreditcheckList__["a" /* default */],
    Loading: Loading
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.displayMessages();
    this.Reload();
  },
  data: function data() {
    return {
      showMobile: false,
      loading: true,
      formLoading: false,
      salesPersonNew: localStorage.getItem('id_token_portalbitrix'),
      searchQuery: '',
      messagesData: [],
      messageDetailsVisible: false,
      messageDetailsLoading: false,
      messageDetailsData: [],
      composeFormVisible: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      contactsData: [],
      submitted: false,
      activeCollapse: [],
      activeNameInboxSent: 'sent',
      activeName: 'new',
      emails: [],
      sends: [],
      options: [],
      files: [],
      starMessage: '',
      upload_token: '',
      tilbud_id: '',
      salesPerson: '',
      quotation: {
        files: [],
        info: []
      },
      title: '',
      to: '',
      load: 0,
      tabIndex: 0,
      messageinput: '',
      email: { file: [] },
      emailShow: false,
      showDismissibleAlert: false,
      clear_quotation_attachment: false,
      formShow: false,
      isLoadingReview: false,
      overlay: true,
      show: false,
      label: 'Loading...',
      drafts: false,
      totalmessages: 0,
      paginationLoading: false,
      currentPaginatePage: 1,
      totalitems: 0,
      lastpage: 1,
      perPage: 20
    };
  },

  methods: {
    displayMessages: function displayMessages() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messagesV2?sent=true', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.items;
        _this.messagesData = res;
        _this.totalmessages = response.body.data.total;
        _this.lastpage = response.body.data.last_page;
        _this.totalitems = response.body.data.total;
        _this.perPage = response.body.data.perPage;
        _this.paginationLoading = false;
        _this.getContacts();
      }, function (response) {
        _this.loading = false;
        var error = response.body;
        _this.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    handleToggleInboxSent: function handleToggleInboxSent(tab) {
      if (tab.index === '0') {
        this.$router.push('/messages/inbox');
      }
    },
    paginationChanged: function paginationChanged(curPage) {
      this.paginationLoading = true;
      this.selectedMessageInfo = {};
      this.currentPaginatePage = curPage;
      this.displayMessages();
    },
    getContacts: function getContacts() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contacts', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.data;
        _this2.contactsData = res.data;
        _this2.submitted = false;
        _this2.messagesLoading = false;
        _this2.formLoading = false;
        _this2.loading = false;
      }, function (response) {
        _this2.messagesLoading = false;
        _this2.formLoading = false;
        _this2.loading = false;
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getMessageDetails: function getMessageDetails(msgId, threadId) {
      var _this3 = this;

      this.replyVisible = false;
      var inActiveMsg = document.querySelectorAll('.msgItem');
      for (var x = 0; x < inActiveMsg.length; x++) {
        inActiveMsg[x].classList.remove('active');
      }
      var activeMsg = document.querySelector('.msgItem.mail-' + msgId);
      activeMsg.classList.add('active');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonNew
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messages/' + threadId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;

        _this3.messageDetailsData = res.sort(function (a, b) {
          return parseFloat(a.ID) - parseFloat(b.ID);
        });
        _this3.activeCollapse.push(_this3.messageDetailsData[res.length - 1].ID);
        _this3.messageDetailsLoading = false;
        _this3.messageDetailsVisible = true;
        setTimeout(function () {
          var msgThread = document.querySelectorAll('.msg-thread');
          var padding = 15;
          var totalPadding = 0;
          var lastUserId = '';
          var currentUserId = '';
          var deductPadding = false;
          for (var i = 0; i < msgThread.length; i++) {
            currentUserId = msgThread[i].id.split('-')[1];
            if (currentUserId !== lastUserId) {
              if (i !== 0) {
                lastUserId = msgThread[i].id.split('-')[1];
              }
              if (deductPadding) {
                totalPadding = padding * i - padding;
                deductPadding = false;
              } else {
                totalPadding = padding * i;
              }
            } else {
              deductPadding = true;
            }
            msgThread[i].style.paddingLeft = totalPadding + 'px';
            msgThread[i].style.paddingTop = totalPadding + 'px';
            msgThread[i].style.paddingBottom = totalPadding + 'px';
          }
        }, 50);
      }, function (response) {
        _this3.messageDetailsLoading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var message = _step.value;

                  _this3.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else {
              _this3.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this3.$router.push('/login');
          }
        } else {
          _this3.$message({
            type: 'error',
            message: error.message
          });
        }
      });
      this.messageDetailsLoading = true;
      this.seenMessage(msgId);
    },
    seenMessage: function seenMessage(id) {
      if (document.querySelector('.mail-' + id).classList.contains('seen-0')) {
        document.querySelector('.mail-' + id + '.seen-0').classList.add('seen-1');
        document.querySelector('.mail-' + id + '.seen-1').classList.remove('seen-0');
      }
    },
    clearFields: function clearFields() {
      this.composeForm.to = '';
      this.composeForm.title = '';
      this.composeForm.message = '';
    },
    sendMessage: function sendMessage() {
      var _this4 = this;

      this.submitted = true;
      var to = this.composeForm.to;
      var title = this.composeForm.title;
      var message = this.composeForm.message;
      var validated = false;
      if (to && title && message) {
        validated = true;
      } else {
        validated = false;
      }
      if (validated) {
        this.formLoading = true;
        var headers = {
          Authorization: 'Bearer ' + this.salesPersonNew
        };
        var data = {
          contactId: to,
          title: title,
          message: message
        };
        this.$http.post(this.$bitrixapi + 'partner/message', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this4.composeFormVisible = false;
          _this4.loading = true;
          _this4.clearFields();
          _this4.displayMessages();
          _this4.$message({
            type: 'success',
            message: 'Success'
          });
        }, function (response) {
          _this4.loading = false;
          var error = response.body;
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                var _iteratorNormalCompletion2 = true;
                var _didIteratorError2 = false;
                var _iteratorError2 = undefined;

                try {
                  for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_values___default()(error)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                    var message = _step2.value;

                    _this4.$message({
                      type: 'error',
                      message: message[0]
                    });
                  }
                } catch (err) {
                  _didIteratorError2 = true;
                  _iteratorError2 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
                      _iterator2.return();
                    }
                  } finally {
                    if (_didIteratorError2) {
                      throw _iteratorError2;
                    }
                  }
                }
              } else {
                console.log('1', error.data);
                _this4.$message({
                  type: 'error',
                  message: error.message
                });
              }
            } else {
              _this4.$router.push('/login');
            }
          } else {
            _this4.$message({
              type: 'error',
              message: error.message
            });
          }
        });
      }
    },
    showoldmessages: function showoldmessages() {
      this.activeName = 'old';
      this.messageDetailsVisible = false;
      this.totalmessages = this.sends.length;
      this.messageDetailsData = [];
      document.getElementById('searchmessages').classList.add('hide');
      document.querySelector('.el-pagination').classList.add('hide');
    },
    Shownewmessages: function Shownewmessages() {
      this.activeName = 'new';
      this.totalmessages = this.totalitems;
      document.getElementById('searchmessages').classList.remove('hide');
      document.querySelector('.el-pagination').classList.remove('hide');
    },
    Reload: function Reload() {
      var _this5 = this;

      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message', salesPerson: this.salesPerson };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this5.$router.push('/login');
        }
        if (_this5.$route.query.send === 'support' && _this5.load === 0) {
          _this5.formShow = !_this5.formShow;
        }
        _this5.emails = res.resultMessage;
        _this5.sends = res.resultSent;
        _this5.options = res.customer;
        if (_this5.$route.query.email) {
          var email;
          for (email in _this5.emails) {
            if (_this5.emails[email].id === _this5.$route.query.email && _this5.load === 0) _this5.showItemDetails(_this5.emails[email]);
          }
        }
        if (_this5.$route.query.cid) {
          _this5.tabIndex = 2;
          for (var idc in _this5.options) {
            var customerList = _this5.options[idc];
            if (parseInt(customerList.cid) === parseInt(_this5.$route.query.cid)) {
              _this5.to = { 'cid': customerList.cid, 'name': customerList.name };
            }
          }
        }
        if (res.resultMessage.length === 0) _this5.showDismissibleAlert = true;
        if (_this5.$route.query.default === 'imentor') {
          _this5.title = 'Nyt abonnement';
          _this5.message = 'Jeg vil gerne kontaktes ang. et abonnement på Prisberegning.dk';
        }
        if (_this5.$route.query.default === 'haandvaerker') {
          _this5.title = 'Nyt abonnement';
          _this5.message = 'Jeg vil gerne kontaktes ang. et abonnement på Håndværker.dk';
        }
      }, function (response) {
        alert('error');
      });
    },
    showItemDetails: function showItemDetails(email) {
      var _this6 = this;

      this.emailShow = !this.emailShow;
      this.email = email;
      if (this.email.frompid !== '0') return;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var data = { operation: 'oversigt_message_read', salesPerson: this.salesPerson, email_id: email.id };
      this.$http.post('', data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.login === false) {
          _this6.$router.push('/login');
        }
        localStorage.setItem('inbox', res.inbox);
        $('#totalInbox').html(res.inbox);
        if (res.inbox === 0) {
          $('#totalInbox').hide();
        } else {
          $('#totalInbox').show();
        }
      }, function (response) {
        alert('error');
      });
    },
    send_service: function send_service(evt) {
      var _this7 = this;

      if (!this.to.cid) return;
      this.show = true;
      this.salesPerson = localStorage.getItem('id_token_portal');
      var dataPartner = { operation: 'send_service', salesPerson: this.salesPerson, title: this.title, message: this.message, to: this.to.cid, files: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.files) };
      this.$http.post('', dataPartner, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this7.show = false;
        if (res.login === false) {
          _this7.$router.push('/login');
        }
        if (res.success) {
          _this7.modalShowDato = false;
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this7.$refs.simplert.openSimplert(obj);
          _this7.load = 1;
          _this7.Reload();
          _this7.formShow = false;
          _this7.title = '';
          _this7.message = '';
          _this7.files = [];
          _this7.tabIndex = 0;
          document.querySelector('#inboxMsg .progress').classList.add('hide');
          var fileList = document.querySelectorAll('#inboxMsg .upload-file-list li');
          for (var i = 0; i < fileList.length; i++) {
            fileList[i].remove();
            console.log(fileList[i]);
          }
        } else {
          alert(res.message);
        }
      }, function (response) {
        alert('error');
      });
    },
    resend_service: function resend_service(email) {
      this.$refs.emailModal.hide();
      this.formShow = !this.formShow;
      this.title = 'Re: ' + email.title;
      console.log(email.cid + 'hgggg');
      for (var idc in this.options) {
        var customerList = this.options[idc];
        if (parseInt(customerList.cid) === parseInt(email.cid)) {
          this.to = { 'cid': customerList.cid, 'name': customerList.name };
        }
      }
    },
    mailSupport: function mailSupport() {
      this.formShow = !this.formShow;
    },
    hideModal: function hideModal() {
      this.$refs.emailModal.hide();
    },
    hideModalForm: function hideModalForm() {
      this.$refs.formModal.hide();
    },
    UpdateTilbud: function UpdateTilbud(files) {
      this.files = files;
      document.querySelector('#inboxMsg .progress').classList.remove('hide');
    }
  },
  computed: {
    resultQuery: function resultQuery() {
      var _this8 = this;

      if (this.searchQuery) {
        return this.messagesData.filter(function (msg) {
          return _this8.searchQuery.toLowerCase().split(' ').every(function (v) {
            return msg.TITLE.toLowerCase().includes(v);
          });
        });
      } else {
        return this.messagesData;
      }
    }
  }
});

/***/ }),
/* 1522 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix notosan px2 mb4"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"flex"},[_c('div',{staticClass:"col-5 pl0 pr3"},[_c('el-tabs',{attrs:{"id":"inboxsent"},on:{"tab-click":_vm.handleToggleInboxSent},model:{value:(_vm.activeNameInboxSent),callback:function ($$v) {_vm.activeNameInboxSent=$$v},expression:"activeNameInboxSent"}},[_c('el-tab-pane',{attrs:{"label":"Indbakke","name":"inbox"}}),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Sendt","name":"sent"}},[_c('div',{staticClass:"py2 highlights"},[_c('div',{staticClass:"mb2 flex col-12 items-center p0"},[_c('p',{staticClass:"h6 m0 p0 flex"},[_c('span',{},[_vm._v("Alle meddelelser ")]),_vm._v(" "),_c('span',{staticClass:"p1 white darkblue-background ml1"},[_vm._v(_vm._s(parseInt(_vm.totalmessages)))])])]),_vm._v(" "),_c('div',{staticClass:"flex mb1",attrs:{"id":"searchmessages"}},[_c('div',{staticClass:"col-9 p0"},[_c('div',{staticClass:"flex justify-between border items-center mb3"},[_c('div',{staticClass:"inline-block h4 line-height-1 m0 p0 mx2"},[_c('i',{staticClass:"easternblue el-icon-search"})]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchQuery),expression:"searchQuery"}],staticClass:"h6 book darkblue border-none not-rounded line-height-1 m0 py2 pr0 col-10",staticStyle:{"height":"45px"},attrs:{"placeholder":"Søg i beskeder","type":"text"},domProps:{"value":(_vm.searchQuery)},on:{"input":function($event){if($event.target.composing){ return; }_vm.searchQuery=$event.target.value}}})])]),_vm._v(" "),_c('div',{staticClass:"col-3 p0"},[_c('button',{staticClass:"col-12 block action-button button-padding border-none not-rounded font14 regular line-height-1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = true}}},[_c('span',[_vm._v("Ny email "),_c('i',{staticClass:"el-icon-circle-plus-outline"})])])])]),_vm._v(" "),(_vm.paginationLoading)?_c('div',{staticStyle:{"height":"600px"}},[_c('Loading')],1):_c('el-tabs',{attrs:{"id":"oldmessagestoggle"},model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Nye beskeder","name":"new"}},[_c('div',{staticClass:"overflow-auto",staticStyle:{"height":"650px"}},[(_vm.resultQuery && _vm.resultQuery.length > 0)?_c('div',_vm._l((_vm.messagesData),function(msgs,index){return _c('div',{key:index,class:'flex border secondarycolor-border p2 pointer msgItem mail-'+ msgs.ID +' seen-' + msgs.SEEN + ' fromPartner-' + msgs.IS_FROM_PARTNER,on:{"click":function($event){return _vm.getMessageDetails(msgs.ID, msgs.THREAD_ID)}}},[_c('div',{staticClass:"col-2 p0"},[_c('img',{staticClass:"rounded-circle border",attrs:{"src":msgs.IS_FROM_PARTNER ? msgs.PARTNER.AVATAR : msgs.CONTACT.AVATAR,"width":"50","height":"50"}})]),_vm._v(" "),_c('div',{staticClass:"col-10 p0 flex justify-between"},[_c('div',{staticClass:"col-10 p0"},[_c('div',{staticClass:"flex flex-wrap justify-between"},[_c('span',{staticClass:"h5 mediumgrey block"},[_vm._v(_vm._s(msgs.CONTACT.NAME))]),_vm._v(" "),(msgs.PROJECT != null)?_c('span',{staticClass:"font14 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2"},[_vm._v(_vm._s(msgs.PROJECT.NAME))]):_vm._e()]),_vm._v(" "),_c('span',{staticClass:"h6 mediumgrey block"},[_vm._v(_vm._s(msgs.TITLE.length >= 40 ? msgs.TITLE.substring(0, 40) + '...' : msgs.TITLE))]),_vm._v(" "),_c('span',{staticClass:"font14 regular mediumgrey block m0",domProps:{"innerHTML":_vm._s(msgs.MESSAGE.length >= 55 ? msgs.MESSAGE.replace(/\<br\>/g,' ').substring(0, 55) + '...' : msgs.MESSAGE.replace(/\<br\>/g,' '))}})]),_vm._v(" "),_c('div',{staticClass:"col-2 p0"},[_c('p',{staticClass:"small regular m0 mediumgrey text-right"},[_vm._v(_vm._s(_vm.moment(msgs.SEND_DATE).fromNow()))])])])])}),0):_c('div',[_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('div',{staticClass:"flex justify-center items-center"},[_c('span',{staticClass:"mr2"},[_c('i',{staticClass:"h1 menu-icon-mail"})]),_vm._v(" "),_c('p',{staticClass:"h5 center regular easternblue m0 p0"},[_vm._v("Ingen beskeder")])])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Gamle beskeder","name":"old"}},[_c('div',{staticClass:"right-align"},[_c('router-link',{staticClass:"primarycolor",attrs:{"to":"/email"}},[_vm._v("E-mail")])],1),_vm._v(" "),_c('div',{staticClass:"py2 inboxSpecial overflow-auto",staticStyle:{"height":"710px"}},[_c('b-tabs',{attrs:{"pills":""},model:{value:(_vm.tabIndex),callback:function ($$v) {_vm.tabIndex=$$v},expression:"tabIndex"}},[_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-upload2 mr1"}),_c('span',{staticClass:"gibson"},[_vm._v("Sendte")])]},proxy:true}])},[_vm._v(" "),_vm._l((_vm.sends),function(email,index){return _c('Message',{key:index,attrs:{"email":email,"starMessage":_vm.starMessage},on:{"showItemDetails":_vm.showItemDetails}})})],2),_vm._v(" "),_c('b-tab',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('span',{staticClass:"el-icon-s-promotion mr2"}),_c('span',{staticClass:"gibson"},[_vm._v("Ny besked")])]},proxy:true}])},[_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"clearfix mt3"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n                                        Ingen matchende ...\n                                      ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h5 regular darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.messageinput),callback:function ($$v) {_vm.messageinput=$$v},expression:"messageinput"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[(_vm.showMobile)?_c('button',{staticClass:"col-12 action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span',{staticClass:"regular"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e(),_vm._v(" "),(!_vm.showMobile)?_c('button',{staticClass:"action-button p2 gibson h4 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span',{staticClass:"regular"},[_vm._v("Send")]),_vm._v(" "),_c('span',{staticClass:"mx2"},[_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])])],1),_vm._v(" "),_c('div',{staticClass:"py4"})])],1)],1)])],1),_vm._v(" "),_c('div',{staticClass:"my2 flex col-12 p0"},[_c('el-pagination',{staticClass:"ml-auto",attrs:{"background":"","layout":"prev, pager, next","page-size":_vm.perPage,"total":this.totalitems},on:{"current-change":_vm.paginationChanged}})],1)],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-7 p3 highlights overflow-auto",staticStyle:{"height":"860px"}},[(_vm.messageDetailsLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',[(_vm.messageDetailsVisible)?_c('div',[_c('div',{staticClass:"flex mb4"},[_c('span',{staticClass:"h2 darkblue mr2"},[_vm._v(_vm._s(_vm.messageDetailsData[0].TITLE))]),_vm._v(" "),(_vm.messageDetailsData[0].PROJECT)?_c('span',{staticClass:"h6 regular rounded mb0 h6 line-height-1 regular darkblue-background p1 white inline-block mb2"},[_vm._v(_vm._s(_vm.messageDetailsData[0].PROJECT.NAME))]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex items-center mb4"},[_c('img',{staticClass:"mr1 rounded-circle border",attrs:{"src":_vm.messageDetailsData[0].IS_FROM_PARTNER ? _vm.messageDetailsData[0].PARTNER.AVATAR : _vm.messageDetailsData[0].CONTACT.AVATAR,"width":"50","height":"50"}}),_vm._v(" "),_c('p',{staticClass:"h5 secondarycolor m0"},[_vm._v(_vm._s(_vm.messageDetailsData[0].IS_FROM_PARTNER ? _vm.messageDetailsData[0].PARTNER.NAME : _vm.messageDetailsData[0].CONTACT.NAME))])]),_vm._v(" "),_c('div',{staticClass:"mb4"},[_c('p',{staticClass:"mediumgrey"},[_vm._v(_vm._s(_vm.messageDetailsData[0].MESSAGE))])])]):_c('div',{staticClass:"center py2"},[_c('span',{staticClass:"h5"},[_vm._v("Vælg en besked, der skal vises")])])])])])])]),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"id":"sentMessage","hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.composeFormVisible),callback:function ($$v) {_vm.composeFormVisible=$$v},expression:"composeFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n\t              Skriv til ...\n\t            ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Ny besked")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',[_c('div',{staticClass:"form-group"},[_c('el-select',{staticClass:"col-12 p0",attrs:{"filterable":"","placeholder":"To"},model:{value:(_vm.composeForm.to),callback:function ($$v) {_vm.$set(_vm.composeForm, "to", $$v)},expression:"composeForm.to"}},[_c('el-option',{key:"888888888",attrs:{"label":"Info@haandvaerker.dk","value":1}}),_vm._v(" "),_vm._l((_vm.contactsData),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.NAME,"value":item.ID}})})],2),_vm._v(" "),(_vm.submitted && !_vm.composeForm.to)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Title"},model:{value:(_vm.composeForm.title),callback:function ($$v) {_vm.$set(_vm.composeForm, "title", $$v)},expression:"composeForm.title"}}),_vm._v(" "),(_vm.submitted && !_vm.composeForm.title)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group mb4"},[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.composeForm.message),callback:function ($$v) {_vm.$set(_vm.composeForm, "message", $$v)},expression:"composeForm.message"}}),_vm._v(" "),(_vm.submitted && !_vm.composeForm.message)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = false}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendMessage()}}},[_c('span',[_vm._v("Send")])])])])]),_vm._v(" "),_c('b-modal',{ref:"emailModal",attrs:{"centered":"","lazy":"","size":"lg"},model:{value:(_vm.emailShow),callback:function ($$v) {_vm.emailShow=$$v},expression:"emailShow"}},[_c('div',{staticClass:"w-100 p-2",attrs:{"slot":"modal-header"},slot:"modal-header"}),_vm._v(" "),_c('div',{staticClass:"modal-content border-none gibson p1"},[_c('div',{staticClass:"d-flex flex-column p1"},[_c('div',{staticClass:"line-height-golden h6 font-weight-bold"},[(_vm.email.frompid !== '0')?[_vm._v("Til:")]:_vm._e(),_vm._v("  "+_vm._s(_vm.email.firstname)+" "+_vm._s(_vm.email.lastname)+": "+_vm._s(_vm.email.title)+"\n          ")],2),_vm._v(" "),_c('div',[_c('span',{staticClass:"far fa-clock text-muted",staticStyle:{"position":"relative","top":"1px"}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.moment(_vm.email.createtime).format('lll')))])])]),_vm._v(" "),_c('b-embed',{attrs:{"type":"iframe","seamless":"","src":'https://www.kundematch.dk/newpartner/readmessage.php?email_id='+_vm.email.id+'&id='+_vm.salesPerson,"aspect":"1by1"}})],1),_vm._v(" "),(_vm.email.file.length !== 0)?_c('b-row',{staticClass:"mt-4"},[_c('b-col',{attrs:{"sm":"12","md":"2","lg":"2"}},[_vm._v("\n          Files :\n        ")]),_vm._v(" "),_c('b-col',{attrs:{"sm":"12","md":"6","lg":"6"}},[_c('ul',{staticClass:"m-t-10",staticStyle:{"list-style":"none","padding":"0"}},_vm._l((_vm.email.file),function(attachment,index){return _c('li',{key:index,staticClass:"py-1"},[_c('a',{attrs:{"href":'https://www.kundematch.dk/HenttilbudImg.php?img='+attachment,"target":"_blank"}},[_c('i',{staticClass:"el-icon-paperclip"}),_vm._v(" "+_vm._s(attachment.substring(attachment.lastIndexOf('/')+1)))])])}),0)])],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py-4 pl-2 pr-2 d-flex justify-content-end w-100",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('b-col',{staticClass:"pr-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"rounded float-left",attrs:{"slot":"modal-ok","type":"button","variant":"success","size":"lg","disabled":_vm.isLoadingReview},on:{"click":function($event){return _vm.resend_service(_vm.email)}},slot:"modal-ok"},[_c('span',{staticClass:"mr2"},[_c('svg',{attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M19 9.062s-5.188-.333-7 1.938c2-4.896 7-5.938 7-5.938v-2l5 4-5 4.019v-2.019zm-18.974 14.938h23.947l-11.973-11.607-11.974 11.607zm1.673-14l10.291-7.488 3.053 2.218c.712-.459 1.391-.805 1.953-1.054l-5.006-3.637-11.99 8.725v12.476l7.352-7.127-5.653-4.113zm15.753 4.892l6.548 6.348v-11.612l-6.548 5.264z"}})])]),_vm._v("Reply\n          ")])],1),_vm._v(" "),_c('b-col',{staticClass:"pl-0",attrs:{"cols":"6"}},[_c('b-btn',{staticClass:"float-right rounded",attrs:{"slot":"modal-cancel","type":"buttom","variant":"secondary","size":"lg"},on:{"click":_vm.hideModal},slot:"modal-cancel"},[_c('i',{staticClass:"el-icon-error mr-2"}),_vm._v("Luk\n          ")])],1)],1)],1),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p-2 pb-4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.formShow),callback:function ($$v) {_vm.formShow=$$v},expression:"formShow"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n              Skriv til ...\n            ")])])])]),_vm._v(" "),_c('b-form',{attrs:{"id":"formSubmit"},on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.send_service.apply(null, arguments)}}},[_c('div',{staticClass:"modal-content border-none p2"},[_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Til:")]),_vm._v(" "),_c('v-select',{attrs:{"label":"name","options":_vm.options,"required":""},model:{value:(_vm.to),callback:function ($$v) {_vm.to=$$v},expression:"to"}},[_c('template',{slot:"options"},[_c('span',{staticClass:"h5 darkblue gibson"})]),_vm._v(" "),_c('template',{slot:"no-options"},[_vm._v("\n                Ingen matchende ...\n              ")])],2)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue"},[_vm._v("Title:")]),_vm._v(" "),_c('b-form-input',{staticClass:"not-rounded muted-background p2 darkblue h5 gibson border-none",attrs:{"id":"title","required":""},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-column mb3"},[_c('div',{staticClass:"h6 semi-bold darkblue mb1"},[_vm._v("Notat:")]),_vm._v(" "),_c('wysiwyg',{attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.messageinput),callback:function ($$v) {_vm.messageinput=$$v},expression:"messageinput"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('file-upload-input',{attrs:{"token":_vm.upload_token,"module":"quotation","clear-file":_vm.clear_quotation_attachment,"module-id":_vm.tilbud_id},on:{"UpdateTilbud":_vm.UpdateTilbud}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-12 py3 flex justify-between items-center",attrs:{"slot":"modal-footer"},slot:"modal-footer"},[_c('button',{staticClass:"standard-button p2 px3 h5 gibson border-none not-rounded justify-start items-center",attrs:{"type":"reset"},on:{"click":_vm.hideModalForm}},[_c('span'),_vm._v(" "),_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"action-button p2 px3 gibson h5 not-rounded border-none",attrs:{"type":"submit","disabled":_vm.isLoadingReview}},[_c('span'),_vm._v(" "),_c('span',{staticClass:"regular"},[_vm._v("Send")])])])])],1),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h4 semi-bold line-height-2 mt1"},[_vm._v("Sendt")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1523 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeline_vue__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b481362_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__ = __webpack_require__(1537);
function injectStyle (ssrContext) {
  __webpack_require__(1524)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_timeline_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7b481362_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_timeline_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1524 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1525 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_da__ = __webpack_require__(609);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_da___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_da__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale__ = __webpack_require__(165);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__frappe_gantt_vue__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid__ = __webpack_require__(1535);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid__);








__WEBPACK_IMPORTED_MODULE_3_element_ui_lib_locale___default.a.use(__WEBPACK_IMPORTED_MODULE_2_element_ui_lib_locale_lang_da___default.a);
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FrappeGantt: __WEBPACK_IMPORTED_MODULE_4__frappe_gantt_vue__["a" /* default */]
  },
  created: function created() {
    this.displayCurrentProject();
  },
  data: function data() {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      projectInfo: [],
      timelineForm: {
        taskName: '',
        taskDescription: '',
        startDate: '',
        endDate: '',
        progress: false,
        price: 0
      },
      addTimelineFormVisible: false,
      mode: 'day',
      tasksData: [],
      currentProject: '',
      timelineCurrentVersionData: {}
    };
  },

  methods: {
    confirmDelete: function confirmDelete(taskId) {
      var _this = this;

      this.$confirm('Are you sure you want to delete?', 'Warning', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        type: 'warning'
      }).then(function () {
        _this.deleteTask(taskId);
      }).catch(function () {});
    },
    deleteTask: function deleteTask(taskId) {
      var _this2 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.delete("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/task/' + taskId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: 'Success'
        });
        _this2.displayCurrentProject();
      }, function (response) {
        _this2.loading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var message = _step.value;

                  _this2.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this2.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this2.$router.push('/login');
          }
        } else {
          _this2.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    displayCurrentProject: function displayCurrentProject() {
      var _this3 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/projects', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res !== null && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            if (res[i].IS_ACTIVE === 1) {
              _this3.projectInfo = res[i];
              _this3.currentProject = res[i].ID;
            }
          }
          _this3.getTimelineVersions();
        } else {
          _this3.loading = false;
        }
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var message = _step2.value;

                  _this3.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this3.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this3.$router.push('/login');
          }
        } else {
          _this3.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    addTask: function addTask() {
      var _this4 = this;

      this.formLoading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      var progress = this.timelineForm.progress ? 1 : 0;
      this.$http.post("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/task?timelineId=' + this.timelineCurrentVersionData.ID + '&taskName=' + this.timelineForm.taskName + '&taskDescription=' + this.timelineForm.taskDescription + '&startDate=' + this.timelineForm.startDate + '&endDate=' + this.timelineForm.endDate + '&progress=' + progress + '&price=0', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this4.timelineForm.taskName = '';
        _this4.timelineForm.taskDescription = '';
        _this4.timelineForm.startDate = '';
        _this4.timelineForm.endDate = '';
        _this4.timelineForm.progress = false;
        _this4.timelineForm.price = '';
        _this4.loading = true;
        _this4.formLoading = false;
        _this4.$message({
          type: 'success',
          message: 'Success'
        });
        _this4.displayCurrentProject();
      }, function (response) {
        _this4.formLoading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion3 = true;
              var _didIteratorError3 = false;
              var _iteratorError3 = undefined;

              try {
                for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  var message = _step3.value;

                  _this4.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError3 = true;
                _iteratorError3 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion3 && _iterator3.return) {
                    _iterator3.return();
                  }
                } finally {
                  if (_didIteratorError3) {
                    throw _iteratorError3;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this4.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this4.$router.push('/login');
          }
        } else {
          _this4.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    changeMode: function changeMode(viewMode) {
      this.mode = viewMode;
    },
    displayTasks: function displayTasks() {},
    updateTimeline: function updateTimeline(taskData) {
      var _this5 = this;

      if (this.timelineCurrentVersionData.TIMELINE_STATUS !== 'approved') {
        var jobId = taskData.task.jobId;
        var taskName = taskData.task.name;
        var taskDescription = taskData.task.description;
        var startDate = this.moment(taskData.start).format('yyyy-MM-DD');
        var endDate = this.moment(taskData.end).format('yyyy-MM-DD');
        var progress = taskData.task.progress;
        var price = taskData.task.price;
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        };
        var data = {};
        this.$http.put("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/task/' + jobId + '?timelineId=' + this.timelineCurrentVersionData.ID + '&taskName=' + taskName + '&taskDescription=' + taskDescription + '&startDate=' + startDate + '&endDate=' + endDate + '&progress=' + progress + '&price=' + price, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this5.getTimelineVersions();
          _this5.$message({
            type: 'success',
            message: 'Success'
          });
        }, function (response) {
          var error = response.body;
          if (error && error.constructor.name !== 'Object') {
            if (!error.includes('Unauthorized')) {
              if (error.data && error.data !== null) {
                var _iteratorNormalCompletion4 = true;
                var _didIteratorError4 = false;
                var _iteratorError4 = undefined;

                try {
                  for (var _iterator4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
                    var message = _step4.value;

                    _this5.$message({
                      type: 'error',
                      message: message[0]
                    });
                  }
                } catch (err) {
                  _didIteratorError4 = true;
                  _iteratorError4 = err;
                } finally {
                  try {
                    if (!_iteratorNormalCompletion4 && _iterator4.return) {
                      _iterator4.return();
                    }
                  } finally {
                    if (_didIteratorError4) {
                      throw _iteratorError4;
                    }
                  }
                }
              } else {
                console.log('1', error.data);
                _this5.$message({
                  type: 'error',
                  message: error.message
                });
              }
            } else {
              _this5.$router.push('/login');
            }
          } else {
            _this5.$message({
              type: 'error',
              message: error.message
            });
          }
        });
      } else {
        this.$refs.gantt.updateTasks();
      }
    },
    getTimelineVersions: function getTimelineVersions() {
      var _this6 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/project/' + this.currentProject + '/timeline/pending', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res !== null) {
          _this6.timelineCurrentVersionData = res;
          _this6.tasksData = [];
          if (res.TASKS != null && res.TASKS.length > 0) {
            for (var i = 0; i < res.TASKS.length; i++) {
              var id = Object(__WEBPACK_IMPORTED_MODULE_5_uuid__["v4"])();
              _this6.tasksData.push({
                id: id,
                name: res.TASKS[i].TASK_NAME,
                start: res.TASKS[i].START_DATE.split(' ')[0],
                end: res.TASKS[i].END_DATE.split(' ')[0],
                description: res.TASKS[i].TASK_DESCRIPTION,
                progress: res.TASKS[i].PROGRESS === 1 ? 100 : 0,
                price: res.TASKS[i].PARTIAL_PAYMENT_PRICE,
                dependencies: '',
                jobId: res.TASKS[i].ID,
                submitted: res.SUBMITTED
              });
            }
          }
          _this6.addTimelineFormVisible = true;
          _this6.loading = false;
        }
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion5 = true;
              var _didIteratorError5 = false;
              var _iteratorError5 = undefined;

              try {
                for (var _iterator5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
                  var message = _step5.value;

                  _this6.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError5 = true;
                _iteratorError5 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion5 && _iterator5.return) {
                    _iterator5.return();
                  }
                } finally {
                  if (_didIteratorError5) {
                    throw _iteratorError5;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this6.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this6.$router.push('/login');
          }
        } else {
          _this6.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    addTimelineVersion: function addTimelineVersion() {
      var _this7 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.post("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/project/' + this.currentProject + '/timelineVersion', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this7.displayCurrentProject();
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion6 = true;
              var _didIteratorError6 = false;
              var _iteratorError6 = undefined;

              try {
                for (var _iterator6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                  var message = _step6.value;

                  _this7.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError6 = true;
                _iteratorError6 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion6 && _iterator6.return) {
                    _iterator6.return();
                  }
                } finally {
                  if (_didIteratorError6) {
                    throw _iteratorError6;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this7.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this7.$router.push('/login');
          }
        } else {
          _this7.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    confirmApproveRejectTimeline: function confirmApproveRejectTimeline() {
      var _this8 = this;

      this.$confirm('Er du sikker?', 'Advarsel', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this8.approveTimeline();
      }).catch(function () {});
    },
    approveTimeline: function approveTimeline() {
      var _this9 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.put("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/project/timeline/' + this.timelineCurrentVersionData.ID + '/approve', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this9.displayCurrentProject();
        _this9.$message({
          type: 'success',
          message: 'Success'
        });
      }, function (err) {
        var error = err.body;
        _this9.$refs.errorMsg.showMsg(error);
      });
    },
    confirmSubmitApproval: function confirmSubmitApproval() {
      var _this10 = this;

      this.$confirm('Er du sikker?', 'Send tilbud', {
        confirmButtonText: 'OK',
        cancelButtonText: '',
        type: 'warning'
      }).then(function () {
        _this10.submitApproval();
      }).catch(function () {});
    },
    submitApproval: function submitApproval() {
      var _this11 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.post("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/project/timeline/' + this.timelineCurrentVersionData.ID + '/submit', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this11.displayCurrentProject();
        _this11.$message({
          type: 'success',
          message: 'Success'
        });
      }, function (response) {
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion7 = true;
              var _didIteratorError7 = false;
              var _iteratorError7 = undefined;

              try {
                for (var _iterator7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
                  var message = _step7.value;

                  _this11.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError7 = true;
                _iteratorError7 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion7 && _iterator7.return) {
                    _iterator7.return();
                  }
                } finally {
                  if (_didIteratorError7) {
                    throw _iteratorError7;
                  }
                }
              }
            } else {
              console.log('1', error.data);
              _this11.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this11.$router.push('/login');
          }
        } else {
          _this11.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    }
  }
});

/***/ }),
/* 1526 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frappe_gantt_vue__ = __webpack_require__(1528);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb8e585_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_frappe_gantt_vue__ = __webpack_require__(1534);
function injectStyle (ssrContext) {
  __webpack_require__(1527)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_frappe_gantt_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1eb8e585_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_frappe_gantt_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1527 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1528 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_frappe_gantt__ = __webpack_require__(1529);



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'FrappeGantt',
  props: {
    viewMode: {
      type: String,
      required: false,
      default: 'Month'
    },
    tasks: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {};
  },

  watch: {
    viewMode: function viewMode() {
      this.updateViewMode();
    },
    tasks: function tasks() {
      this.updateTasks();
    }
  },
  mounted: function mounted() {
    this.setupGanttChart();
    this.setFunctionDeleteBtn();
  },

  methods: {
    setupGanttChart: function setupGanttChart() {
      var _this = this;

      this.gantt = new __WEBPACK_IMPORTED_MODULE_0_frappe_gantt__["a" /* default */](this.$refs.gantt, this.tasks, {
        header_height: 80,
        language: 'en',
        column_width: 12,
        bar_height: 40,
        padding: 24,
        step: 12,
        bar_corner_radius: 0,
        arrow_curve: 5,
        date_format: this.formatDate,
        popup_trigger: 'click',
        drag: false,
        custom_popup_html: function custom_popup_html(task) {
          return '\n          <div class="details-container">\n            <P class="semi-bold line-height-1 mb1">' + task.name + '</P>\n            <p class="line-height-1 mb2">' + task.description + '</p>\n            <p class="line-height-1 mb1"><span class="semi-bold">Start:</span> ' + task.start + '</p>\n            <p class="line-height-1 mb1"><span class="semi-bold">End:</span> ' + task.end + '</p>\n            <p><span class="semi-bold">Status: </span>' + task.progress + '%</p>\n            ' + (task.submitted === 0 ? '<i id="' + task.jobId + '" class="red delete-timeline-btn el-icon-delete" style="cursor:pointer;"></i>' : '') + '</div>\n            ';
        },

        on_click: function on_click(task) {},

        on_date_change: function on_date_change(task, start, end) {
          _this.$emit('task-date-updated', { task: task, start: start, end: end });
        },

        on_progress_change: function on_progress_change(task, progress) {
          _this.$emit('task-progress-updated', { task: task, progress: progress });
        },

        on_view_change: function on_view_change(mode) {
          _this.$emit('view-mode-updated', mode);
        }
      });

      this.updateTasks();
      this.updateViewMode();
    },
    updateViewMode: function updateViewMode() {
      var words = this.viewMode;
      var finalWords = words.replace(/(^\w{1})|(\s+\w{1})/g, function (letter) {
        return letter.toUpperCase();
      });
      this.gantt.change_view_mode(finalWords);
    },
    updateTasks: function updateTasks() {
      this.gantt.refresh(this.tasks);
    },
    setFunctionDeleteBtn: function setFunctionDeleteBtn() {
      var thisVar = this;
      var viewedId = '';
      setInterval(function () {
        var deleteBtn = document.querySelectorAll('.delete-timeline-btn');
        for (var i = 0; i < deleteBtn.length; i++) {
          if (deleteBtn[i].id !== viewedId) {
            viewedId = deleteBtn[i].id;
            deleteBtn[i].addEventListener('click', function (e) {
              thisVar.$emit('confirmDelete', e.target.id);
            });
          }
        }
      }, 1000);
    }
  }
});

/***/ }),
/* 1529 */,
/* 1530 */,
/* 1531 */,
/* 1532 */,
/* 1533 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('svg',{ref:"gantt"})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1535 */,
/* 1536 */,
/* 1537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"timeline"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[(_vm.formLoading)?_c('div',[_vm._m(1)]):_c('div',[(_vm.addTimelineFormVisible && !_vm.timelineCurrentVersionData.SUBMITTED || _vm.timelineCurrentVersionData.SUBMITTED == 0 && _vm.timelineCurrentVersionData.TIMELINE_STATUS != 'approved')?_c('div',[_c('div',{staticClass:"flex flex-wrap justify-between"},[_c('form',{staticClass:"col-4 p0 mb4",on:{"submit":function($event){$event.stopPropagation();$event.preventDefault();return _vm.addTask()}}},[_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"h5",attrs:{"placeholder":"Opgave","required":""},model:{value:(_vm.timelineForm.taskName),callback:function ($$v) {_vm.$set(_vm.timelineForm, "taskName", $$v)},expression:"timelineForm.taskName"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"h5",attrs:{"placeholder":"Beskrivelse","required":""},model:{value:(_vm.timelineForm.taskDescription),callback:function ($$v) {_vm.$set(_vm.timelineForm, "taskDescription", $$v)},expression:"timelineForm.taskDescription"}})],1),_vm._v(" "),_c('div',{staticClass:"flex"},[_c('div',{staticClass:"form-group form-group col-6 p0"},[_c('el-date-picker',{staticClass:"h5",attrs:{"value-format":"yyyy-MM-dd","type":"date","placeholder":"Start dato","required":""},model:{value:(_vm.timelineForm.startDate),callback:function ($$v) {_vm.$set(_vm.timelineForm, "startDate", $$v)},expression:"timelineForm.startDate"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group form-group col-6 p0"},[_c('el-date-picker',{staticClass:"h5 col-12 p0 right",attrs:{"value-format":"yyyy-MM-dd","type":"date","placeholder":"Slut dato","required":""},model:{value:(_vm.timelineForm.endDate),callback:function ($$v) {_vm.$set(_vm.timelineForm, "endDate", $$v)},expression:"timelineForm.endDate"}})],1)]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-switch',{staticClass:"h5",attrs:{"active-text":"Færdig","inactive-text":"Ikke startet"},model:{value:(_vm.timelineForm.progress),callback:function ($$v) {_vm.$set(_vm.timelineForm, "progress", $$v)},expression:"timelineForm.progress"}})],1),_vm._v(" "),_vm._m(2)])])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(3)]):_c('div',[_c('div',{staticClass:"mt4 mb2 ml3 flex justify-between"},[_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'quarter day' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('quarter day')}}},[_c('span',{class:_vm.mode != 'quarter day' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Kvartal Dag")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'half day' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('half day')}}},[_c('span',{class:_vm.mode != 'half day' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Halv dag")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'day' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('day')}}},[_c('span',{class:_vm.mode != 'day' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Dag")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'week' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('week')}}},[_c('span',{class:_vm.mode != 'week' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Uge")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'month' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('month')}}},[_c('span',{class:_vm.mode != 'month' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("Måned")])])]),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[_c('button',{staticClass:"p2 regular m0 line-height-1 button-padding flex justify-between",class:_vm.mode == 'year' ? 'standard-button' : 'primary-white-button',on:{"click":function($event){return _vm.changeMode('year')}}},[_c('span',{class:_vm.mode != 'year' ? 'white' : ''},[_c('i',{staticClass:"el-icon-success"})]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_vm._v("År")])])]),_vm._v(" "),(_vm.tasksData && _vm.tasksData.length > 0 && _vm.timelineCurrentVersionData.SUBMITTED == 0)?_c('button',{staticClass:"h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular",attrs:{"type":"submit"},on:{"click":function($event){return _vm.confirmSubmitApproval()}}},[_vm._v("\n                    Send til godkendelse\n                  ")]):_vm._e(),_vm._v(" "),(_vm.tasksData && _vm.tasksData.length > 0 && _vm.timelineCurrentVersionData.SUBMITTED_BY != 'partner' && _vm.timelineCurrentVersionData.SUBMITTED == 1 && _vm.timelineCurrentVersionData.TIMELINE_STATUS == 'pending')?_c('div',{staticClass:"flex"},[_c('button',{staticClass:"ml2 action-button button-padding",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmApproveRejectTimeline()}}},[_c('span',[_vm._v("Godkende")]),_vm._v(" "),_c('i',{staticClass:"el-icon-check"})]),_vm._v(" "),_vm._m(4)]):_vm._e()],1),_vm._v(" "),(_vm.tasksData && _vm.tasksData.length > 0)?_c('transition',{attrs:{"name":"el-fade-in"}},[_c('frappe-gantt',{ref:"gantt",attrs:{"view-mode":_vm.mode,"tasks":_vm.tasksData},on:{"task-date-updated":_vm.updateTimeline,"task-progress-change":function($event){return _vm.debugEventLog.push($event)},"confirmDelete":_vm.confirmDelete}})],1):_c('div',{staticClass:"mt4"},[_c('p',{staticClass:"h5 center regular easternblue m0 p0 py4"},[_vm._v("Ingen data")])])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Tidslinje")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[_c('button',{staticClass:"h5 action-button py2 px3 m0 mb1 gibson not-rounded border-none regular col-12",attrs:{"type":"submit"}},[_vm._v("Tilføj til tidslinje")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"border red-border ml2 delete-button button-padding",attrs:{"type":"button"}},[_c('span',[_vm._v("Afvise")]),_vm._v(" "),_c('i',{staticClass:"el-icon-close"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectDashboard_vue__ = __webpack_require__(1540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492efea9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectDashboard_vue__ = __webpack_require__(1541);
function injectStyle (ssrContext) {
  __webpack_require__(1539)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectDashboard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_492efea9_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectDashboard_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_checkpayproff__ = __webpack_require__(539);




var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler,
    checkpayproff: __WEBPACK_IMPORTED_MODULE_1__components_checkpayproff__["a" /* default */]
  },
  created: function created() {
    var _this = this;

    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.projectfromkunder = this.$route.query.projectId ? this.$route.query.projectId : '';
    this.contactID = this.$route.query.contactID ? this.$route.query.contactID : '';
    this.parentID = this.$route.query.parentID ? this.$route.query.parentID : '';
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : '';
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : [];
    this.industryID = this.$route.query.industryID ? this.$route.query.industryID.split(',') : '';
    this.offerType = this.$route.query.offertype ? this.$route.query.offertype : '';
    this.fromLogin = this.$route.query.fromLogin ? this.$route.query.fromLogin : '';
    this.childprojects.forEach(function (o) {
      if (o.IS_PARTNER) {
        _this.partnerchildprojects.push(o.ID);
      }
    });
    if (this.contractType !== 'Fagentreprise') {
      this.displayProjects(this.projectfromkunder);
    } else {
      this.displayProjects(this.projectfromkunder);
    }
    this.haaid = localStorage.getItem('haaid');
  },
  data: function data() {
    return {
      userFullName: localStorage.getItem('name'),
      loading: true,
      currentProjectData: {},
      currentFolder: '',
      currentName: '',
      currentFolderName: '',
      changeProjectForm: {
        project: ''
      },
      projectsData: [],
      value: '',
      inputVisible: false,
      selectedTags: [],
      timelineReady: false,
      contractReady: false,
      offerReady: false,
      paymentReady: false,
      reviewReady: false,
      walletReady: false,
      tagsDataOptions: [],
      checklistData: [{
        ID: 1,
        IS_DONE: 1,
        DESCRIPTION: 'Test 1'
      }],
      projectfromkunder: '',
      contraftnotif: '',
      paymentOptions: false,
      amountwallet: 0,
      createcontractReady: false,
      salesPersonbitrix: localStorage.getItem('id_token_portalbitrix'),
      industryID: [],
      offerType: [],
      childprojects: [],
      parentID: '',
      contractType: '',
      contactID: '',
      haaid: '',
      partnerchildprojects: [],
      mangelListReady: false,
      fromlogin: ''
    };
  },

  methods: {
    displayProjects: function displayProjects(id) {
      var _this2 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + id, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data) {
          _this2.currentProjectData = res.data;
          _this2.tagsDataOptions = _this2.currentProjectData.TAGS;
          _this2.changeProjectForm.project = _this2.currentProjectData.ID;
          _this2.currentProjectData.TAGS.forEach(function (prop1, index1) {
            _this2.selectedTags.push(prop1.ID);
          });
          _this2.contraftnotif = _this2.currentProjectData.CONTRACT_STATUS;
          if (_this2.fromLogin !== '') {
            _this2.projectfromkunder = _this2.$route.query.projectId ? _this2.$route.query.projectId : _this2.currentProjectData.ID;
            _this2.contactID = _this2.$route.query.contactID ? _this2.$route.query.contactID : _this2.currentProjectData.HOMEOWNER.ID;
            _this2.parentID = _this2.$route.query.parentID ? _this2.$route.query.parentID : _this2.currentProjectData.PARENT_ID;
            _this2.contractType = _this2.$route.query.contracttype ? _this2.$route.query.contracttype : _this2.currentProjectData.CONTRACT_TYPE;
            _this2.childprojects = _this2.$route.query.childprojects ? JSON.parse(_this2.$route.query.childprojects) : _this2.currentProjectData.CHILD_PROJECTS;
            _this2.industryID = _this2.$route.query.industryID ? _this2.$route.query.industryID.split(',') : _this2.currentProjectData.INDUSTRY_IDS;
            _this2.offerType = _this2.$route.query.offertype ? _this2.$route.query.offertype : _this2.currentProjectData.OFFER_TYPE;
            _this2.childprojects.forEach(function (o) {
              if (o.IS_PARTNER) {
                _this2.partnerchildprojects.push(o.ID);
              }
            });
          }

          _this2.currentProjectData.TODOS.forEach(function (prop2, index2) {
            if (prop2.CODE === 'SELECT_AN_OFFER' && prop2.IS_DONE) {
              _this2.timelineReady = true;
              _this2.createcontractReady = true;
            } else if (prop2.CODE === 'CONFIRM_TIMELINE' && prop2.IS_DONE) {
              _this2.timelineReady = true;
            } else if (prop2.CODE === 'SEND_CONTRACT_DRAFT' && prop2.IS_DONE && _this2.currentProjectData.CONTRACT_ID !== null) {
              _this2.contractReady = true;
            } else if (prop2.CODE === 'SIGN_CONTRACT' && prop2.IS_DONE) {
              _this2.paymentReady = true;
            } else if (prop2.CODE === 'FUND_WALLET' && prop2.IS_DONE) {
              _this2.reviewReady = true;
            }
          });

          if (_this2.$route.query.offerSent) {
            _this2.$message({
              type: 'success',
              message: 'Tilbud sendt'
            });
          }
        }
        _this2.getHomeownerWallerAmount();
      }, function (response) {
        _this2.loading = false;
        var error = response.body.message;
        _this2.$refs.errorMsg.showMsg(error);
      });
    },
    seeTimeline: function seeTimeline() {
      this.$router.push('/customer-projects/timeline');
    },
    seeMessages: function seeMessages() {
      this.$router.push('/messages/inbox?projectId=' + this.currentProjectData.ID);
    },
    seeCalendar: function seeCalendar() {
      this.$router.push('/customer-projects/calendar');
    },
    seeFiles: function seeFiles() {
      this.$router.push('/customer-projects/documents?projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    seeApproveProject: function seeApproveProject() {
      this.$router.push('/customer-projects/approved-projects');
    },
    seeContract: function seeContract() {
      this.$router.push('/customer-projects/contract-main?contractId=' + this.currentProjectData.CONTRACT_ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    seeContractAddon: function seeContractAddon() {
      this.$router.push('/customer-projects/contract-addon?projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    seeAddonList: function seeAddonList() {
      this.$router.push('/customer-projects/addon-liste?contractId=' + this.currentProjectData.CONTRACT_ID + '&projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType + '&contactId=' + this.currentProjectData.HOMEOWNER['ID']);
    },
    seemangellist: function seemangellist() {
      this.$router.push('/customer-projects/mangel-liste?projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    seeContractDraft: function seeContractDraft() {
      this.$router.push('/customer-projects/contract-draft?projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    seepayment: function seepayment() {
      this.$router.push('/customer-projects/payment-management?projectId=' + this.currentProjectData.ID);
    },
    seeMakeReview: function seeMakeReview() {
      this.$router.push('/anbefaling-boligejere?cid=' + this.currentProjectData.HOMEOWNER.ID);
    },
    seeBilleder: function seeBilleder() {
      this.$router.push('/customer-projects/projekt-billeder?projectId=' + this.currentProjectData.ID + '&parentID=' + this.parentID + '&industryID=' + this.industryID + '&offertype=' + this.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.partnerchildprojects) + '&contracttype=' + this.contractType);
    },
    removeTag: function removeTag(keywordId, keyword) {
      for (var i = 0; i < this.tagsData.length; i++) {
        if (this.tagsData[i].ID === keywordId) {
          this.tagsData.splice(i, 1);
        }
      }
    },
    handleInputConfirm: function handleInputConfirm(type) {
      var selectedTags = this.selectedTags;
      var tags = this.tagsData;
      var tagsList = this.tagsDataOptions;
      var tagExist = false;
      var tagsFound = false;
      if (selectedTags.trim().length > 0) {
        for (var i = 0; i < tags.length; i++) {
          if (tags[i].TAG_NAME === selectedTags) {
            tagExist = true;
          }
        }
        for (var x = 0; x < tagsList.length; x++) {
          if (tagsList[x].NAME === selectedTags) {
            tagsFound = true;
          }
        }
        if (type === 'keyup') {
          if (!tagExist) {
            if (tagsFound) {
              if (type === 'keyup') {}
              this.inputVisible = false;
              this.selectedTags = '';
            } else {
              this.$message({
                type: 'error',
                message: 'Not found'
              });
            }
          } else {
            this.$message({
              type: 'error',
              message: 'Already exists'
            });
          }
        }
      } else {
        this.inputVisible = false;
        this.selectedTags = '';
      }
    },
    showInput: function showInput() {
      this.inputVisible = true;
      this.$nextTick(function () {
        this.$refs.saveTagInput.focus();
      });
    },
    changeProject: function changeProject() {
      var _this3 = this;

      var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

      this.loading = true;
      var projId = this.changeProjectForm.project;
      if (id !== '') {
        projId = this.projectfromkunder;
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/project/' + projId + '/setActive', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this3.currentProjectData = res;
        _this3.displayProjects();
        _this3.getHomeownerWallerAmount();
      }, function (response) {
        var error = response.body.message;
        _this3.$refs.errorMsg.showMsg(error);
      });
    },
    getHomeownerWallerAmount: function getHomeownerWallerAmount() {
      var _this4 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/paymentStages?projectId=' + this.currentProjectData.ID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this4.amountwallet = res.TRANSACTION ? res.TRANSACTION.AMOUNT : 0;

        _this4.mangelListReady = _this4.amountwallet > 0;
        _this4.loading = false;
      }, function (response) {
        _this4.loading = false;
        var error = response.body.message;
        _this4.$refs.errorMsg.showMsg(error);
      });
    },
    seeBetaling: function seeBetaling() {
      if (this.paymentOptions) {
        this.paymentOptions = false;
      } else {
        this.paymentOptions = true;
      }
    }
  }
});

/***/ }),
/* 1541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4 notosans darkblue",attrs:{"id":"projectDashboard"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',[(_vm.currentProjectData)?_c('div',[_c('div',{staticClass:"tagsAddressLayout mb3"},[_c('div',{staticClass:"tagsLayout p2 highlights shakespeare-border--light"},[_vm._m(1),_vm._v(" "),_c('div',[_c('el-select',{staticClass:"col-12 p0 capital tagSelect",attrs:{"multiple":"","filterable":"","default-first-option":"","placeholder":"Select","no-data-text":"Ingen data","no-match-text":"Ingen data","disabled":""},model:{value:(_vm.selectedTags),callback:function ($$v) {_vm.selectedTags=$$v},expression:"selectedTags"}},_vm._l((_vm.tagsDataOptions),function(item,index){return _c('el-option',{key:index,staticClass:"cyprus",attrs:{"label":item.DA_DK,"value":item.ID}})}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"highlights flex items-center "},[_c('el-select',{staticClass:"col-12 selectAddress p0 xs-col-11",attrs:{"filterable":"","placeholder":"Select","no-data-text":"Ingen data","no-match-text":"Ingen data"},on:{"change":function($event){return _vm.changeProject()}},model:{value:(_vm.changeProjectForm.project),callback:function ($$v) {_vm.$set(_vm.changeProjectForm, "project", $$v)},expression:"changeProjectForm.project"}},[_c('el-option',{staticClass:"easternblue",attrs:{"label":_vm.currentProjectData.ADDRESS ? _vm.currentProjectData.ADDRESS.ADDRESS + ' - ' + _vm.currentProjectData.NAME : _vm.currentProjectData.NAME + '   -   ',"value":_vm.currentProjectData.ID}}),_vm._v(" "),_vm._l((_vm.projectsData),function(project,index){return (project.ID != _vm.currentProjectData.ID)?_c('el-option',{key:index,staticClass:"cyprus",attrs:{"label":project.ADDRESS ? project.ADDRESS.ADDRESS + ' - ' +project.NAME : project.NAME + '   -   ',"value":project.ID}}):_vm._e()})],2)],1)]),_vm._v(" "),_c('div',{staticClass:"highlights p2 mb2"},[_c('p',{staticClass:"h6 regular darkblue"},[_vm._v("Aktuelt projekt")]),_vm._v(" "),_c('p',{staticClass:"h2 easternblue"},[_vm._v(_vm._s(_vm.currentProjectData.NAME))])]),_vm._v(" "),(_vm.contraftnotif === 'draft')?_c('div',{staticClass:"col-12 m0 p0 my2 flex items-center"},[_c('el-alert',{attrs:{"title":"Du er stadig i udkastet til din kontrakt","type":"warning","closable":false,"show-icon":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 p0 pr2"},[_c('div',{staticClass:"shortcutButtonsLayout"},[_c('div',{staticClass:"projectSection pointer col-12 highlights p4",class:!_vm.reviewReady ? 'no-events opacity50' : null,on:{"click":function($event){return _vm.seeMakeReview()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"55.302","height":"48.776","viewBox":"0 0 55.302 48.776"}},[_c('path',{attrs:{"id":"Bedom_din_Kunde","data-name":"Bedom din Kunde","d":"M2017.768,48.776h-21.88a.879.879,0,0,1-.877-.877,19.474,19.474,0,0,1,.126-2.221h-12.3a.879.879,0,0,1-.877-.877c0-6.255,4.01-11.343,8.939-11.343a8.451,8.451,0,0,1,7.089,4.423q.2-.285.41-.56a10.145,10.145,0,0,1,16.861,0q.211.274.41.559a8.45,8.45,0,0,1,7.089-4.423,8.06,8.06,0,0,1,6.338,3.348,12.971,12.971,0,0,1,2.6,7.995.877.877,0,0,1-.877.877h-12.3a19.5,19.5,0,0,1,.126,2.221A.878.878,0,0,1,2017.768,48.776Zm-20.981-1.755h20.082a17.371,17.371,0,0,0-.221-2.038c0-.012,0-.024-.007-.036a15.516,15.516,0,0,0-1.673-4.87c-.008-.015-.016-.029-.023-.044a13.089,13.089,0,0,0-1.183-1.779,8.372,8.372,0,0,0-13.867,0,13.091,13.091,0,0,0-1.187,1.786l-.02.038a15.517,15.517,0,0,0-1.673,4.87c0,.012,0,.024-.007.036A17.371,17.371,0,0,0,1996.787,47.021Zm33.125-3.1c-.335-4.906-3.44-8.71-7.154-8.71-2.417,0-4.722,1.686-6.04,4.412a17.179,17.179,0,0,1,1.516,4.3Zm-46.166,0h11.677a17.192,17.192,0,0,1,1.516-4.3c-1.319-2.726-3.624-4.412-6.041-4.412C1987.185,35.213,1984.08,39.017,1983.745,43.923Zm34.317-15.669a4.7,4.7,0,1,1,4.7,4.7A4.7,4.7,0,0,1,2018.062,28.254Zm1.755,0a2.941,2.941,0,1,0,2.94-2.94A2.944,2.944,0,0,0,2019.817,28.254Zm-33.615,0a4.7,4.7,0,1,1,4.7,4.7A4.7,4.7,0,0,1,1986.2,28.254Zm1.755,0a2.941,2.941,0,1,0,2.941-2.94A2.945,2.945,0,0,0,1987.957,28.254Zm12.812-2.81a6.057,6.057,0,1,1,6.06,6.059A6.067,6.067,0,0,1,2000.768,25.444Zm1.755,0a4.3,4.3,0,1,0,4.3-4.3A4.309,4.309,0,0,0,2002.523,25.444Zm16.034-1.628a.883.883,0,0,1-.644-.755l-.891-8.447h-32.046A3.98,3.98,0,0,1,1981,10.639V3.975A3.98,3.98,0,0,1,1984.975,0h47.352a3.98,3.98,0,0,1,3.975,3.975v6.664a3.98,3.98,0,0,1-3.975,3.975h-6.383l-6.449,8.87a.881.881,0,0,1-.938.331Zm-35.8-19.84v6.664a2.223,2.223,0,0,0,2.22,2.22h32.836a.876.876,0,0,1,.873.785l.734,6.962,5.369-7.385a.882.882,0,0,1,.71-.361h6.829a2.223,2.223,0,0,0,2.22-2.22V3.975a2.223,2.223,0,0,0-2.22-2.22h-47.352A2.223,2.223,0,0,0,1982.755,3.975Zm47.589,7.764-1.98-.981-1.98.981a.888.888,0,0,1-.39.091.878.878,0,0,1-.868-1l.321-2.187L2023.9,7.06a.877.877,0,0,1,.48-1.479l2.178-.37,1.026-1.957a.877.877,0,0,1,1.554,0l1.026,1.958,2.179.37a.878.878,0,0,1,.48,1.479l-1.545,1.579.322,2.187a.878.878,0,0,1-1.258.913Zm-1.591-2.747.869.43-.14-.958a.881.881,0,0,1,.241-.742l.677-.692-.956-.163a.879.879,0,0,1-.629-.458l-.45-.858-.449.858a.883.883,0,0,1-.631.458l-.956.163.678.693a.884.884,0,0,1,.241.741l-.141.958.869-.43a.883.883,0,0,1,.39-.089A.873.873,0,0,1,2028.753,8.993Zm-8.266,2.747-1.98-.981-1.98.981a.884.884,0,0,1-.389.091.878.878,0,0,1-.869-1l.321-2.187-1.544-1.579a.878.878,0,0,1,.48-1.479l2.179-.37,1.025-1.957a.878.878,0,0,1,1.555,0l1.025,1.957,2.179.37a.878.878,0,0,1,.48,1.479l-1.544,1.579.321,2.187a.878.878,0,0,1-.868,1A.888.888,0,0,1,2020.487,11.74Zm-1.59-2.747.869.43-.141-.958a.88.88,0,0,1,.241-.741l.678-.693-.956-.163a.882.882,0,0,1-.63-.457l-.45-.859-.45.859a.879.879,0,0,1-.63.457l-.956.163.678.693a.879.879,0,0,1,.241.741l-.141.958.869-.43a.881.881,0,0,1,.779,0Zm-8.266,2.747-1.979-.981-1.981.981a.885.885,0,0,1-.39.091.877.877,0,0,1-.868-1l.321-2.187-1.545-1.579a.878.878,0,0,1,.481-1.479l2.179-.37,1.025-1.957a.877.877,0,0,1,1.554,0l1.025,1.957,2.179.37a.878.878,0,0,1,.481,1.479l-1.545,1.579.321,2.187a.878.878,0,0,1-.868,1A.889.889,0,0,1,2010.631,11.74Zm-1.59-2.747.868.43-.14-.958a.883.883,0,0,1,.24-.741l.678-.693-.956-.163a.88.88,0,0,1-.63-.458l-.45-.858-.449.858a.88.88,0,0,1-.631.458l-.955.163.678.693a.882.882,0,0,1,.24.741l-.14.958.869-.43a.892.892,0,0,1,.779,0Zm-8.266,2.747-1.98-.981-1.98.981a.884.884,0,0,1-.389.091.878.878,0,0,1-.869-1l.321-2.187-1.544-1.579a.877.877,0,0,1,.48-1.479l2.179-.37,1.025-1.957a.878.878,0,0,1,1.555,0l1.025,1.957,2.178.37a.878.878,0,0,1,.481,1.479l-1.545,1.579.321,2.187a.877.877,0,0,1-.868,1A.885.885,0,0,1,2000.775,11.74Zm-1.59-2.747.869.43-.141-.958a.883.883,0,0,1,.24-.741l.678-.693-.955-.163a.882.882,0,0,1-.631-.457l-.449-.859-.45.859a.879.879,0,0,1-.63.457l-.956.163.678.693a.88.88,0,0,1,.241.741l-.141.958.869-.43a.9.9,0,0,1,.779,0Zm-8.266,2.747-1.98-.981-1.98.981a.885.885,0,0,1-.39.091.876.876,0,0,1-.868-1l.321-2.187-1.545-1.579a.878.878,0,0,1,.481-1.479l2.178-.37,1.025-1.957a.878.878,0,0,1,1.555,0l1.025,1.957,2.179.37a.877.877,0,0,1,.48,1.479l-1.544,1.579.321,2.187a.878.878,0,0,1-.868,1A.886.886,0,0,1,1990.918,11.74Zm-1.59-2.746.869.429-.141-.958a.881.881,0,0,1,.241-.741l.678-.693-.956-.163a.881.881,0,0,1-.63-.457l-.45-.859-.449.859a.883.883,0,0,1-.631.457l-.955.163.678.693a.883.883,0,0,1,.24.741l-.141.958.869-.43a.888.888,0,0,1,.39-.091A.87.87,0,0,1,1989.328,8.994Z","transform":"translate(-1981)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Bedøm din Kunde")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Lav en anmeldelse af boligejeren")])]),_vm._v(" "),_c('div',{staticClass:"projectSection pointer col-12 highlights p4",class:!(_vm.currentProjectData.CONTRACT_ID !== null && _vm.currentProjectData.CONTRACT_STATUS !== 'draft') ? 'no-events opacity50' : null,on:{"click":function($event){return _vm.seeAddonList()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"60","viewBox":"0 0 512 607.901"}},[_c('path',{attrs:{"id":"note_agreement","data-name":"note agreement","d":"M-3313.238,602.064a7.559,7.559,0,0,1-2.246-1.543l5.211-5.422-5.2,5.394-5.379-5.33a140.163,140.163,0,0,1-25.039,5.992c-10.777,1.307-20.853.236-28.5-5.486-13.779-10.3-88.844-74.412-113.791-95.756a22.5,22.5,0,0,1-9.6,11.323h-.024a21.81,21.81,0,0,1-16.878,2.3l-64.785-17.695a22.289,22.289,0,0,1-13.51-10.6v-.035A23,23,0,0,1-3595.248,468l38.755-147.437a22.555,22.555,0,0,1,10.382-13.786h.033a22.4,22.4,0,0,1,5.663-2.356V32.748a32.857,32.857,0,0,1,9.429-23.135A31.6,31.6,0,0,1-3508.3,0h316.354a31.581,31.581,0,0,1,22.689,9.613,32.842,32.842,0,0,1,9.427,23.135V314.3c.542.169,1.078.359,1.6.569a22.438,22.438,0,0,1,12.307,12.054l60.049,139.821a23.034,23.034,0,0,1,.327,17.367,22.48,22.48,0,0,1-11.814,12.549l-61.432,27.435a21.794,21.794,0,0,1-17.032.328,22.374,22.374,0,0,1-12.115-11.593q-1.784,1.226-3.573,2.469c-3.129,2.182-5.991,4.225-8.66,6.176.384.72.71,1.393.971,2.009A28.986,28.986,0,0,1-3197.5,540.2a27.3,27.3,0,0,1-7.707,14.431,27.521,27.521,0,0,1-16.308,7.523,40.1,40.1,0,0,1-13.859-.978,29.258,29.258,0,0,1-1.711,11.714,21.974,21.974,0,0,1-10.159,11.731,28.163,28.163,0,0,1-13.53,3.252,35.158,35.158,0,0,1-8.863-1.151c-3.986,16.67-13.657,21.177-22.947,21.177C-3301.823,607.9-3310.692,603.452-3313.238,602.064Zm-29.975-50.126,28.864,28.586a7.336,7.336,0,0,1,1.291,1.278l7.255,7.184c3.653,1.894,19.036,8.658,22.407-9.814l-53.631-50.477a7.674,7.674,0,0,1-.434-10.7,7.319,7.319,0,0,1,10.481-.437l54.58,51.363c2.479,2.331,7.028,3.857,11.624,3.845a13.514,13.514,0,0,0,6.5-1.474,7.247,7.247,0,0,0,3.369-3.851c1.129-2.988,1.118-7.409-.706-13.648l-57.405-58.53a7.69,7.69,0,0,1,0-10.724,7.333,7.333,0,0,1,10.511,0l57.751,58.881c7.175,3.241,13,4.225,17.557,3.69a13.126,13.126,0,0,0,7.774-3.436,12.1,12.1,0,0,0,3.347-6.378,13.666,13.666,0,0,0-.763-7.892c-5.668-13.476-56.024-66.186-61.07-71.453a8.234,8.234,0,0,1-.919-.984l.016-.017c-42.108-54.052-65.163-36.748-85.163-21.736-14.107,10.592-27.054,20.3-43.9,13.147a6.864,6.864,0,0,1-.784-.322l.011-.029c-32.992-15.778-10.677-64.1,1.192-85.274-10.959.276-24.1.253-40.269-.334l-9.112,3.575-.255.956-30.031,117.538c18.544,15.887,103.225,88.319,117.506,98.991,4.12,3.085,10.618,3.534,17.975,2.636a101.48,101.48,0,0,0,14.571-3.045l-20.539-20.343a7.666,7.666,0,0,1-.084-10.689,7.323,7.323,0,0,1,5.286-2.256A7.315,7.315,0,0,1-3343.212,551.938Zm173.88-222.873-61.432,27.429a7.513,7.513,0,0,0-3.923,4.2,7.719,7.719,0,0,0,.1,5.825l2.252,5.256a7.516,7.516,0,0,1,.763,1.589l2.438,5.854,54.6,127.128a7.437,7.437,0,0,0,4.115,3.989,7.325,7.325,0,0,0,5.713-.092l61.426-27.435a7.5,7.5,0,0,0,3.925-4.2,7.756,7.756,0,0,0-.1-5.82l-60.049-139.821a7.489,7.489,0,0,0-4.115-4,7.4,7.4,0,0,0-2.747-.531A7.2,7.2,0,0,0-3169.333,329.065Zm-94.086,118.206c3.36,3.5,37.395,39.091,54.8,61.794,3.129-2.28,6.06-4.386,8.746-6.263,1.593-1.111,3.19-2.216,4.78-3.293l-47.945-114.982-1.078-2.516c-81.659-25.9-92.391-24.8-120.285-21.949-6.052.622-12.871,1.324-21.255,1.877-4.854,7.558-37.518,60.257-12.865,72.322l.165.063,0-.012c.074.04.147.075.227.115,9.179,3.747,18.844-3.506,29.379-11.415,12.471-9.36,25.884-19.428,42.366-19.428C-3309.414,403.592-3289.2,414.242-3263.418,447.271Zm-312.228,33.939,64.792,17.7a7.291,7.291,0,0,0,5.639-.748l-.006-.011a7.571,7.571,0,0,0,3.482-4.6l35.215-134.019.284-1.094.006.006v-.012l-.023-.006a5.071,5.071,0,0,1,.209-.685l3.054-11.639a7.727,7.727,0,0,0-.728-5.75l-.017.006a7.506,7.506,0,0,0-4.51-3.557l-64.781-17.695a7.347,7.347,0,0,0-5.651.748l.012.011a7.552,7.552,0,0,0-3.483,4.6L-3580.9,471.908a7.753,7.753,0,0,0,.736,5.762l.01-.006A7.452,7.452,0,0,0-3575.646,481.211Zm325.607-116.9a23.257,23.257,0,0,1,1.53-9.124,22.481,22.481,0,0,1,11.816-12.555l61.162-27.308V32.748a16.763,16.763,0,0,0-4.821-11.812,16.141,16.141,0,0,0-11.591-4.922H-3508.3a16.152,16.152,0,0,0-11.591,4.922,16.787,16.787,0,0,0-4.821,11.812V305.7l60.292,16.478a22.262,22.262,0,0,1,13.515,10.6v.023a23.069,23.069,0,0,1,2.692,15.2l.608-.236-.015-.04a7.267,7.267,0,0,1,3.539-.449c41.336,1.531,62.459-.627,78.227-2.251a219.33,219.33,0,0,1,22.792-1.567C-3324.809,343.455-3303.361,347.68-3250.039,364.311Zm99.222,118.839a21.159,21.159,0,0,1-8.2-13.815,21.3,21.3,0,0,1,3.794-15.634,20.581,20.581,0,0,1,13.548-8.364,20.271,20.271,0,0,1,15.339,3.868,21.147,21.147,0,0,1,8.2,13.815,21.281,21.281,0,0,1-3.794,15.634,20.578,20.578,0,0,1-13.55,8.364,19.715,19.715,0,0,1-3.115.242A20.377,20.377,0,0,1-3150.817,483.15Zm11.352-22.829a5.759,5.759,0,0,0-3.8,2.325,6.076,6.076,0,0,0-1.061,4.438,5.909,5.909,0,0,0,2.286,3.868,5.732,5.732,0,0,0,4.353,1.082,5.756,5.756,0,0,0,3.792-2.326,6.024,6.024,0,0,0,1.063-4.438,5.9,5.9,0,0,0-2.279-3.868,5.755,5.755,0,0,0-3.457-1.151A5.89,5.89,0,0,0-3139.465,460.321Zm-418.359,13.959a21.216,21.216,0,0,1-6.065-14.909,21.212,21.212,0,0,1,6.065-14.9,20.412,20.412,0,0,1,14.614-6.177,20.4,20.4,0,0,1,14.622,6.177,21.182,21.182,0,0,1,6.058,14.9,21.185,21.185,0,0,1-6.058,14.909,20.4,20.4,0,0,1-14.622,6.177A20.412,20.412,0,0,1-3557.824,474.28Zm10.511-19.094a5.955,5.955,0,0,0-1.7,4.185,5.969,5.969,0,0,0,1.7,4.191,5.736,5.736,0,0,0,4.1,1.733,5.749,5.749,0,0,0,4.115-1.733,5.99,5.99,0,0,0,1.695-4.191,5.976,5.976,0,0,0-1.695-4.185,5.749,5.749,0,0,0-4.115-1.733A5.736,5.736,0,0,0-3547.313,455.186ZM-3257.276,319.7c-6.49-.863-9.719-5.307-8.438-16.411.006-.155.017-.311.027-.466h.018c.446-4.185,2.066-5.532,1.512-5.589-2.522-.276-9.613,4.651-16.122,9.17-6.645,4.617-12.826,8.917-18.024,9.4a6.968,6.968,0,0,1-2.62-.121v-.011c-20.192-4.876-6.408-24.39-3.674-27.976l.006-.006.114-.15c4.859-7.472,5.61-11.058,5.4-12.744-5.25,3.062-14.463,14.834-20.067,24.51a47.428,47.428,0,0,0-2.8,5.52,7.106,7.106,0,0,1,3.557,4.973,7.147,7.147,0,0,1-5.605,8.358c-4.923.944-8.468-.4-10.844-3.494-2.434-3.166-2.655-7.391-1.209-12.175a51.466,51.466,0,0,1,4.805-10.477c8.322-14.368,25.33-32.333,34.357-32.333a6.9,6.9,0,0,1,3.839,1.163c3.512,2.118,15.388,11.5.168,34.78l-5.86-3.949,5.86,3.978a6.964,6.964,0,0,1-.824,1.036c-.62.777-1.878,2.343-2.823,3.523,2.095-1.307,5.144-3.425,8.327-5.641,8.552-5.941,17.879-12.416,25.528-11.582,7.735.846,12.331,6.47,11.059,20.492l1.3-.685c8.322-4.329,19.228-10.01,30.885-5.146a7.2,7.2,0,0,1,3.85,9.314,6.96,6.96,0,0,1-9.129,3.926c-5.724-2.389-13.384,1.594-19.226,4.64-4.431,2.308-8.183,4.264-11.955,4.264A10.558,10.558,0,0,1-3257.276,319.7Zm-64.7-14.909c-.063.178-.114.357.027.035a.816.816,0,0,0,.055-.243A1,1,0,0,0-3321.976,304.791Zm68.984-.581.008-.006-5.7-.616Zm-121.982-76.237c-6.639,0-12.018-3.58-12.018-8s5.379-8.007,12.018-8.007h146.869c6.637,0,12.017,3.586,12.017,8.007s-5.38,8-12.017,8Zm-75.06-75.73c-6.639,0-12.026-3.586-12.026-8.007s5.387-8.007,12.026-8.007h223.079c6.639,0,12.019,3.586,12.019,8.007s-5.38,8.007-12.019,8.007ZM-3468.8,76.507c-6.636,0-12.017-3.58-12.017-8s5.381-8.007,12.017-8.007h242.71c6.639,0,12.018,3.586,12.018,8.007s-5.378,8-12.018,8Z","transform":"translate(3596)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Ny aftale seddel")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Hvis der skal tilføjelse ting til den nuværende kontrakt skal du tilføje det her.")])]),_vm._v(" "),_c('div',{staticClass:"projectSection pointer col-12 flex-none p4 highlights",class:!_vm.mangelListReady ? 'no-events opacity50' : null,on:{"click":function($event){return _vm.seemangellist()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"60","height":"50","viewBox":"0 0 43.538 25.851"}},[_c('path',{attrs:{"id":"Request_Payout","data-name":"Request Payout","d":"M11.663,1027.361a2.15,2.15,0,0,0-2.139,2.136v3.3H2.041A2.052,2.052,0,0,0,0,1034.841v16.327a2.052,2.052,0,0,0,2.041,2.041H29.252a2.052,2.052,0,0,0,2.041-2.041v-2.041H41.4a2.148,2.148,0,0,0,2.139-2.137V1029.5a2.15,2.15,0,0,0-2.139-2.139H11.663Zm0,1.361H41.4a.763.763,0,0,1,.779.779v.582H10.884v-.582a.763.763,0,0,1,.779-.779Zm-.779,2.721H42.177v2.721H31.165a2.046,2.046,0,0,0-1.913-1.361H10.884v-1.361Zm-8.844,2.721H29.252a.664.664,0,0,1,.68.68v16.327a.664.664,0,0,1-.68.68H2.041a.664.664,0,0,1-.68-.68v-16.327a.664.664,0,0,1,.68-.68Zm29.252,1.36H42.177v11.469a.761.761,0,0,1-.779.776H31.293v-2.817a3.4,3.4,0,0,0,2.75-.561,3.249,3.249,0,0,0,1.943.656,3.4,3.4,0,0,0,0-6.8,3.249,3.249,0,0,0-1.943.651,3.406,3.406,0,0,0-2.028-.646,3.3,3.3,0,0,0-.723.084v-2.811Zm-15.646,2.724a5.442,5.442,0,1,0,5.442,5.442A5.453,5.453,0,0,0,15.646,1038.248Zm-9.524,1.358v1.361H8.844v-1.361Zm16.327,0v1.361H25.17v-1.361Zm13.536,0a2.042,2.042,0,0,1,0,4.082,1.923,1.923,0,0,1-1.047-.316l-.335-.377a2.027,2.027,0,0,1,0-2.689l.348-.393A1.921,1.921,0,0,1,35.986,1039.606Zm-20.339,0a4.082,4.082,0,1,1-4.082,4.082A4.071,4.071,0,0,1,15.646,1039.606Zm16.375,0h.008a1.8,1.8,0,0,1,1.044.417,3.325,3.325,0,0,0,.016,3.263,1.939,1.939,0,0,1-1.8.234v-3.766a1.96,1.96,0,0,1,.728-.149Zm-28.62,3.4v1.36H7.483v-1.36Zm20.408,0v1.36h4.082v-1.36Zm-17.687,3.4v1.36H8.844v-1.36Zm16.327,0v1.36H25.17v-1.36Z","transform":"translate(0 -1027.358)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Mangel Liste")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Her kan du oprette og gennemgå en fejl- og mangelliste ved endt projekt. Husk at tilføje alle fejl og mangler.")])]),_vm._v(" "),_c('div',{staticClass:"projectSection pointer col-12 flex-none p4 highlights",class:!_vm.paymentReady && _vm.amountwallet < 1 ? 'no-events opacity50' : null,on:{"click":function($event){return _vm.seepayment()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 29.396 29.396"}},[_c('path',{attrs:{"id":"Wallet","d":"M1.722,29.4A1.724,1.724,0,0,1,0,27.674V9.3A1.724,1.724,0,0,1,1.722,7.579H4.47L17.2.23a1.726,1.726,0,0,1,2.353.63L23.43,7.579h.11A2.874,2.874,0,0,1,26.41,10.45v4.615h1.263A1.724,1.724,0,0,1,29.4,16.787v3.445a1.724,1.724,0,0,1-1.722,1.722H26.41v4.571A2.874,2.874,0,0,1,23.539,29.4Zm-.574-1.722a.575.575,0,0,0,.574.574H23.539a1.724,1.724,0,0,0,1.722-1.722v-.574H1.148Zm0-2.871H25.262V21.954H22.506a3.445,3.445,0,0,1,0-6.89h2.756V12.172H1.148V22.506h2.31a.574.574,0,0,1,0,1.148H1.148ZM20.21,18.509a2.3,2.3,0,0,0,2.3,2.3h5.167a.575.575,0,0,0,.574-.574V16.787a.575.575,0,0,0-.574-.574H22.506A2.3,2.3,0,0,0,20.21,18.509ZM1.148,9.3v1.722H25.262V10.45a1.724,1.724,0,0,0-1.722-1.722H1.722A.575.575,0,0,0,1.148,9.3ZM19.4,7.579H22.1l-.677-1.172Zm-5.741,0H17.1l3.752-2.166-.861-1.492Zm4.116-6.354L6.766,7.579h4.593l8.058-4.652-.861-1.492a.57.57,0,0,0-.349-.266.585.585,0,0,0-.152-.02A.566.566,0,0,0,17.772,1.225ZM6.042,23.655a.574.574,0,1,1,.574-.574.574.574,0,0,1-.574.574Zm16.521-4.277-.057-.057-.057.057a.574.574,0,1,1-.812-.812l.057-.057-.057-.057a.574.574,0,0,1,.812-.812l.057.057.057-.057a.574.574,0,1,1,.812.812l-.057.057.057.057a.574.574,0,0,1-.812.812Z","transform":"translate(0 0)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Byggewallet")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Håndter kontrakter og økonomi til dit projekt.")])]),_vm._v(" "),[_c('div',{staticClass:"projectSection pointer col-12 highlights p4",class:!_vm.contractReady ? 'no-events opacity50' : null,on:{"click":function($event){_vm.contractReady ? _vm.seeTimeline() : null}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 32.599 32.599"}},[_c('path',{attrs:{"id":"Timeline","d":"M498.774,585.825a16.3,16.3,0,1,1,18.368,3.273.655.655,0,1,1-.551-1.189,14.913,14.913,0,1,0-1.969.748.655.655,0,0,1,.377,1.255,16.326,16.326,0,0,1-16.225-4.087Zm2.377-2.376a12.939,12.939,0,0,1-.29-18,.628.628,0,0,1,.456-.2.624.624,0,0,1,.455,1.051,11.682,11.682,0,1,0,1.435-1.3.624.624,0,0,1-.758-.992,12.939,12.939,0,1,1-1.3,19.434Zm8.493-.169v-1.629a.655.655,0,0,1,1.311,0v1.629a.655.655,0,0,1-1.311,0Zm-1.274-8.98a1.936,1.936,0,0,1,1.274-1.814v-3.511a.655.655,0,0,1,1.311,0v3.511a1.945,1.945,0,0,1,1.159,1.159h1.969a.655.655,0,1,1,0,1.311h-1.969a1.929,1.929,0,0,1-3.743-.655Zm1.31,0a.619.619,0,1,0,.619-.619A.619.619,0,0,0,509.68,574.3Zm8.7.655a.655.655,0,1,1,0-1.311h1.629a.655.655,0,1,1,0,1.311Zm-17.063,0a.655.655,0,1,1,0-1.311h1.629a.655.655,0,1,1,0,1.311Zm8.325-8.739v-1.629a.655.655,0,1,1,1.311,0v1.629a.655.655,0,0,1-1.311,0Z","transform":"translate(-494 -558)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Tidslinje")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Hold styr på projektforløbet og overlappende opgaver.")])])],_vm._v(" "),[_c('div',{staticClass:"projectSection pointer col-12 highlights p4",class:!_vm.createcontractReady ? 'no-events opacity50' : null,on:{"click":function($event){_vm.createcontractReady ? _vm.seeBilleder() : null}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 32.599 32.599"}},[_c('path',{attrs:{"id":"Timeline","d":"M498.774,585.825a16.3,16.3,0,1,1,18.368,3.273.655.655,0,1,1-.551-1.189,14.913,14.913,0,1,0-1.969.748.655.655,0,0,1,.377,1.255,16.326,16.326,0,0,1-16.225-4.087Zm2.377-2.376a12.939,12.939,0,0,1-.29-18,.628.628,0,0,1,.456-.2.624.624,0,0,1,.455,1.051,11.682,11.682,0,1,0,1.435-1.3.624.624,0,0,1-.758-.992,12.939,12.939,0,1,1-1.3,19.434Zm8.493-.169v-1.629a.655.655,0,0,1,1.311,0v1.629a.655.655,0,0,1-1.311,0Zm-1.274-8.98a1.936,1.936,0,0,1,1.274-1.814v-3.511a.655.655,0,0,1,1.311,0v3.511a1.945,1.945,0,0,1,1.159,1.159h1.969a.655.655,0,1,1,0,1.311h-1.969a1.929,1.929,0,0,1-3.743-.655Zm1.31,0a.619.619,0,1,0,.619-.619A.619.619,0,0,0,509.68,574.3Zm8.7.655a.655.655,0,1,1,0-1.311h1.629a.655.655,0,1,1,0,1.311Zm-17.063,0a.655.655,0,1,1,0-1.311h1.629a.655.655,0,1,1,0,1.311Zm8.325-8.739v-1.629a.655.655,0,1,1,1.311,0v1.629a.655.655,0,0,1-1.311,0Z","transform":"translate(-494 -558)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Billeddokumentation")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Upload billeder af projektet undervejs og ved afslutning. Det kan bruges som dokumentation ved anmodning om udbetaling.")])])],_vm._v(" "),_c('div',{staticClass:"projectSection pointer col-12 flex-none p4 highlights",on:{"click":function($event){return _vm.seeCalendar()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 31.818 31.819"}},[_c('path',{attrs:{"id":"Meetings","d":"M495.891,589.819A1.893,1.893,0,0,1,494,587.928V562.373a1.893,1.893,0,0,1,1.891-1.892h.962v-.589a1.891,1.891,0,0,1,3.783,0v.589H504.3v-.589a1.891,1.891,0,1,1,3.782,0v.589h3.661v-.589a1.891,1.891,0,0,1,3.783,0v.589h3.661v-.589a1.891,1.891,0,1,1,3.782,0v.589h.962a1.894,1.894,0,0,1,1.892,1.892v25.555a1.893,1.893,0,0,1-1.892,1.891Zm-.589-1.891a.59.59,0,0,0,.589.589h28.036a.59.59,0,0,0,.59-.589V567.117H495.3Zm0-25.555v3.442h29.215v-3.442a.59.59,0,0,0-.59-.59h-3.442v.776a.59.59,0,0,0,.589.589.651.651,0,1,1,0,1.3,1.893,1.893,0,0,1-1.891-1.891v-.776h-6.142v.776a.591.591,0,0,0,.59.589.651.651,0,1,1,0,1.3,1.893,1.893,0,0,1-1.891-1.891v-.776H505.6v.776a.59.59,0,0,0,.589.589.651.651,0,1,1,0,1.3,1.893,1.893,0,0,1-1.891-1.891v-.776h-6.142v.776a.591.591,0,0,0,.59.589.651.651,0,1,1,0,1.3,1.893,1.893,0,0,1-1.891-1.891v-.776h-.962A.59.59,0,0,0,495.3,562.373Zm25.183-2.481v.589h1.179v-.589a.59.59,0,1,0-1.179,0Zm-7.443,0v.589h1.18v-.589a.59.59,0,0,0-1.18,0Zm-7.443,0v.589h1.179v-.589a.59.59,0,1,0-1.179,0Zm-7.443,0v.589h1.18v-.589a.59.59,0,0,0-1.18,0Zm4.9,18.98a6.854,6.854,0,1,1,6.854,6.853A6.861,6.861,0,0,1,503.056,578.872Zm1.3,0a5.552,5.552,0,1,0,5.552-5.552A5.558,5.558,0,0,0,504.358,578.872Zm4.471,2.321-1.861-1.861a.651.651,0,0,1,.92-.921l1.4,1.4,2.641-2.641a.651.651,0,1,1,.92.92l-3.1,3.1a.65.65,0,0,1-.92,0ZM503.707,569.6a.651.651,0,1,1,0-1.3h14.886a.651.651,0,1,1,0,1.3Zm-3.132-.65a.651.651,0,1,1,.65.65A.651.651,0,0,1,500.575,568.947Z","transform":"translate(-494 -558)","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Møder")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Indhent og styr håndværkertilbud til dit projekt.")])]),_vm._v(" "),(_vm.contractReady)?[_c('div',{staticClass:"projectSection pointer col-12 flex-none p4 highlights",class:!_vm.contractReady ? 'no-events opacity50' : null,on:{"click":function($event){_vm.contractReady ? _vm.seeContract() : null}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 28.069 28.805"}},[_c('path',{attrs:{"id":"View_Contract","data-name":"View Contract","d":"M3.636,28.805a.558.558,0,0,1-.557-.557V4.99H.557A.558.558,0,0,1,0,4.432V2.1A2.081,2.081,0,0,1,.616.616L.662.572A2.079,2.079,0,0,1,2.1,0H18.379a3.646,3.646,0,0,1,3.636,3.636V9.41L24.1,4.354A1.611,1.611,0,0,1,27.08,5.583l-.037.088.445.184A.937.937,0,0,1,28,7.079l-2.429,5.883a.556.556,0,1,1-1.028-.423L26.9,6.816,26.619,6.7,20.476,21.579a.539.539,0,0,1-.076.132L18,24.752a.643.643,0,0,1-.068.072,2.7,2.7,0,0,1-1.789.945,3.2,3.2,0,0,1-2.022-1.216A3.655,3.655,0,0,0,11.54,23.2a4.3,4.3,0,0,0-1.776.442A.557.557,0,0,1,9.3,22.627a5.541,5.541,0,0,1,2.3-.568,4.66,4.66,0,0,1,3.3,1.7c.446.432.832.806,1.268.806a1.374,1.374,0,0,0,.87-.419l.422-3.643a.574.574,0,0,1,.05-.176L21.5,10.668h-.038a.558.558,0,0,1-.557-.557V3.636a2.53,2.53,0,0,0-2.522-2.522H3.947a2.076,2.076,0,0,1,.246.982v25.6H20.9V22.557a.557.557,0,0,1,1.114,0v5.692a.558.558,0,0,1-.557.557Zm14.919-8.1-.211,1.82,1.135-1.439L25.033,7.628l-.923-.381ZM24.534,6.22l.923.382.135-.327-.923-.382ZM25.4,4.51a.492.492,0,0,0-.271.268l-.036.088.923.381.035-.086a.5.5,0,0,0-.458-.69A.5.5,0,0,0,25.4,4.51ZM1.4,1.4a.976.976,0,0,0-.289.694V3.875H3.079V2.1A.976.976,0,0,0,2.79,1.4l-.017-.018A.979.979,0,0,0,1.4,1.4ZM7.048,25a.558.558,0,0,1,.011-.787c.1-.094.194-.186.289-.271s.194-.172.294-.254a.556.556,0,0,1,.709.857c-.087.073-.175.149-.259.224s-.157.144-.226.21l-.031.031A.559.559,0,0,1,7.048,25Zm-.661-7.312a.557.557,0,1,1,0-1.113h9.221a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113H18.706a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113H18.706a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113h4.971a.557.557,0,1,1,0,1.113Z","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("kontrakt")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Hold styr på projektforløbet og overlappende opgaver.")])])]:(_vm.createcontractReady)?[_c('div',{staticClass:"projectSection pointer col-12 highlights p4",on:{"click":function($event){return _vm.seeContractDraft()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"50","height":"50","viewBox":"0 0 28.069 28.805"}},[_c('path',{attrs:{"id":"draft_Contract","data-name":"Draft Contract","d":"M3.636,28.805a.558.558,0,0,1-.557-.557V4.99H.557A.558.558,0,0,1,0,4.432V2.1A2.081,2.081,0,0,1,.616.616L.662.572A2.079,2.079,0,0,1,2.1,0H18.379a3.646,3.646,0,0,1,3.636,3.636V9.41L24.1,4.354A1.611,1.611,0,0,1,27.08,5.583l-.037.088.445.184A.937.937,0,0,1,28,7.079l-2.429,5.883a.556.556,0,1,1-1.028-.423L26.9,6.816,26.619,6.7,20.476,21.579a.539.539,0,0,1-.076.132L18,24.752a.643.643,0,0,1-.068.072,2.7,2.7,0,0,1-1.789.945,3.2,3.2,0,0,1-2.022-1.216A3.655,3.655,0,0,0,11.54,23.2a4.3,4.3,0,0,0-1.776.442A.557.557,0,0,1,9.3,22.627a5.541,5.541,0,0,1,2.3-.568,4.66,4.66,0,0,1,3.3,1.7c.446.432.832.806,1.268.806a1.374,1.374,0,0,0,.87-.419l.422-3.643a.574.574,0,0,1,.05-.176L21.5,10.668h-.038a.558.558,0,0,1-.557-.557V3.636a2.53,2.53,0,0,0-2.522-2.522H3.947a2.076,2.076,0,0,1,.246.982v25.6H20.9V22.557a.557.557,0,0,1,1.114,0v5.692a.558.558,0,0,1-.557.557Zm14.919-8.1-.211,1.82,1.135-1.439L25.033,7.628l-.923-.381ZM24.534,6.22l.923.382.135-.327-.923-.382ZM25.4,4.51a.492.492,0,0,0-.271.268l-.036.088.923.381.035-.086a.5.5,0,0,0-.458-.69A.5.5,0,0,0,25.4,4.51ZM1.4,1.4a.976.976,0,0,0-.289.694V3.875H3.079V2.1A.976.976,0,0,0,2.79,1.4l-.017-.018A.979.979,0,0,0,1.4,1.4ZM7.048,25a.558.558,0,0,1,.011-.787c.1-.094.194-.186.289-.271s.194-.172.294-.254a.556.556,0,0,1,.709.857c-.087.073-.175.149-.259.224s-.157.144-.226.21l-.031.031A.559.559,0,0,1,7.048,25Zm-.661-7.312a.557.557,0,1,1,0-1.113h9.221a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113H18.706a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113H18.706a.557.557,0,1,1,0,1.113Zm0-3.6a.557.557,0,1,1,0-1.113h4.971a.557.557,0,1,1,0,1.113Z","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Kontrakt")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Hold styr på projektforløbet og overlappende opgaver.")])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"projectSection pointer col-12 highlights p4",on:{"click":function($event){return _vm.seeMessages()}}},[_c('div',{staticClass:"center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"55","height":"55","viewBox":"0 0 35.415 31.819"}},[_c('path',{attrs:{"id":"Project_Message","data-name":"Project Message","d":"M1.436,31.392a.693.693,0,0,1,.149-.754A4.207,4.207,0,0,0,2.7,26.674,9.667,9.667,0,0,1,0,20.059C0,14.276,5.577,10,11.507,9.7,11.9,4.293,17.014,0,23.242,0c6.167,0,12.173,4.366,12.173,10.375a9.662,9.662,0,0,1-2.7,6.615,4.207,4.207,0,0,0,1.111,3.964.691.691,0,0,1-.489,1.181A7.629,7.629,0,0,1,28.054,20a15.58,15.58,0,0,1-4.146.738c-.4,5.407-5.507,9.7-11.733,9.7a15.773,15.773,0,0,1-4.813-.753,7.63,7.63,0,0,1-5.286,2.137A.691.691,0,0,1,1.436,31.392ZM1.383,20.059a8.313,8.313,0,0,0,2.434,5.784.69.69,0,0,1,.169.293,5.6,5.6,0,0,1-.421,4.117,6.245,6.245,0,0,0,3.1-1.842.69.69,0,0,1,.766-.176,13.985,13.985,0,0,0,4.739.816c5.721,0,10.375-4.034,10.375-8.993,0-5.151-4.852-8.992-10.375-8.992C6.325,11.067,1.383,15.185,1.383,20.059Zm27.364-1.332a6.242,6.242,0,0,0,3.1,1.842,5.6,5.6,0,0,1-.422-4.118.7.7,0,0,1,.169-.292,8.312,8.312,0,0,0,2.434-5.785c0-4.874-4.941-8.992-10.79-8.992-5.46,0-9.95,3.675-10.347,8.321a12.9,12.9,0,0,1,5.148,1.363H29.19a.692.692,0,1,1,0,1.383H20.167a9.9,9.9,0,0,1,3.738,6.9,13.641,13.641,0,0,0,4.075-.8.694.694,0,0,1,.767.175ZM6.225,23.518a.692.692,0,0,1,0-1.383H17.708a.692.692,0,1,1,0,1.383Zm2.767-4.15a.692.692,0,0,1,0-1.383h8.716a.692.692,0,1,1,0,1.383Zm-3.458-.692a.692.692,0,1,1,.691.692A.691.691,0,0,1,5.534,18.676ZM20.474,8.3a.692.692,0,0,1,0-1.383H29.19a.692.692,0,1,1,0,1.383Zm-3.458-.692a.692.692,0,1,1,.691.692A.691.691,0,0,1,17.016,7.609Z","fill":"#003645"}})])]),_vm._v(" "),_c('h4',{staticClass:"regular mt1"},[_vm._v("Projektmeddelelser")])]),_vm._v(" "),_c('p',{staticClass:"col-12 mx-auto mediumgrey center m0"},[_vm._v("Hold kontakten med din kunde")])])],2)])]):_c('div',[_c('div',{staticClass:"flex justify-center items-center"},[_vm._m(2),_vm._v(" "),(this.$bitrixapi === 'https://bitrixapidev.haandvaerker.dk/v1/')?_c('button',{staticClass:"flex-none primary-button p2 line-height-1 regular mb0",on:{"click":function($event){return _vm.seeApproveProject()}}},[_vm._v("Tilføj\n                "),_vm._m(3)]):_vm._e()])])])])]),_vm._v(" "),_c('checkpayproff'),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Projekter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lg-flex md-flex flex-column items-center justify-center"},[_c('p',{staticClass:"easternblue p0 m0"},[_vm._v("Keywords:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr3"},[_c('p',{staticClass:"h1 regular primarycolor line-height-2"},[_vm._v("Intet projekt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovedProjects_vue__ = __webpack_require__(1544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4fb47f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovedProjects_vue__ = __webpack_require__(1545);
function injectStyle (ssrContext) {
  __webpack_require__(1543)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ApprovedProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4fb47f_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_ApprovedProjects_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1543 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {
    this.displayCurrentProject();
  },
  data: function data() {
    return {
      haaId: localStorage.getItem('haaid'),
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      currentProjectData: {},
      approvedProjectsData: [],
      categoriesData: [{
        value: 'price_details',
        label: 'Price Details'
      }, {
        value: 'guarantee',
        label: 'Guarantee'
      }, {
        value: 'materials',
        label: 'Materials'
      }, {
        value: 'add-ons',
        label: 'Add-ons'
      }]
    };
  },

  methods: {
    displayApprovedProjects: function displayApprovedProjects() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/projects/approved', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res !== null && res.length > 0) {
          _this.approvedProjectsData = res.sort(function (a, b) {
            return Number(a.OFFER_SENT) - Number(b.OFFER_SENT);
          });
        }
        _this.loading = false;
        _this.formLoading = false;
      }, function (response) {
        _this.loading = false;
        _this.formLoading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion = true;
              var _didIteratorError = false;
              var _iteratorError = undefined;

              try {
                for (var _iterator = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  var message = _step.value;

                  _this.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion && _iterator.return) {
                    _iterator.return();
                  }
                } finally {
                  if (_didIteratorError) {
                    throw _iteratorError;
                  }
                }
              }
            } else {
              _this.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this.$router.push('/login');
          }
        } else {
          _this.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    displayCurrentProject: function displayCurrentProject() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/projects', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res !== null && res.length > 0) {
          for (var i = 0; i < res.length; i++) {
            if (res[i].IS_ACTIVE === 1) {
              _this2.currentProjectData = res[i];
            }
          }
        }
        _this2.displayApprovedProjects();
      }, function (response) {
        _this2.loading = false;
        var error = response.body;
        if (error && error.constructor.name !== 'Object') {
          if (!error.includes('Unauthorized')) {
            if (error.data && error.data !== null) {
              var _iteratorNormalCompletion2 = true;
              var _didIteratorError2 = false;
              var _iteratorError2 = undefined;

              try {
                for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(error)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  var message = _step2.value;

                  _this2.$message({
                    type: 'error',
                    message: message[0]
                  });
                }
              } catch (err) {
                _didIteratorError2 = true;
                _iteratorError2 = err;
              } finally {
                try {
                  if (!_iteratorNormalCompletion2 && _iterator2.return) {
                    _iterator2.return();
                  }
                } finally {
                  if (_didIteratorError2) {
                    throw _iteratorError2;
                  }
                }
              }
            } else {
              _this2.$message({
                type: 'error',
                message: error.message
              });
            }
          } else {
            _this2.$router.push('/login');
          }
        } else {
          _this2.$message({
            type: 'error',
            message: error.message
          });
        }
      });
    },
    addOfferDetailsForm: function addOfferDetailsForm(projId, category) {
      var detailsForm = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details');
      var clonedForm = detailsForm.cloneNode(true);
      document.querySelector('#offerDetails-' + projId + ' #' + category + ' .offerDetails').appendChild(clonedForm);
      var offerTitle = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details:last-child #offer_title');
      var offerValue = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .details:last-child #offer_value');
      offerTitle.value = '';
      offerValue.value = '';
      var loopdetailsForm = document.querySelectorAll('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details');
      var loopdetailsRemoveBtn = document.querySelectorAll('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details .removeForm');
      for (var i = 0; i < loopdetailsForm.length; i++) {
        loopdetailsForm[i].removeAttribute('class');
        loopdetailsForm[i].classList.add('flex', 'flex-wrap', 'justify-between', 'details', 'index-' + i);
      }
      for (var x = 0; x < loopdetailsRemoveBtn.length; x++) {
        loopdetailsRemoveBtn[x].removeAttribute('id');
        loopdetailsRemoveBtn[x].setAttribute('id', 'removeForm-' + x);
        loopdetailsRemoveBtn[x].addEventListener('click', function (e) {
          var offerForm = document.querySelector('#offerDetails-' + projId + ' #' + category + ' .offerDetails .details.index-' + e.target.id.split('-')[1]);
          if (offerForm !== null) {
            offerForm.remove();
          }
        });
      }
    },
    removeOfferDetailsForm: function removeOfferDetailsForm(category) {
      console.log(category);
    },
    createOffer: function createOffer(type, projId, homeOwnerData, address) {
      var _this3 = this;

      this.$confirm('Er du sikker?', 'Send tilbud', {
        confirmButtonText: 'OK',
        cancelButtonText: '',
        type: 'warning'
      }).then(function () {
        var offer = '';
        if (type === 'standard') {
          offer = 'standardTilbud';
        } else if (type === 'hurtigt') {
          offer = 'hurtigt-tilbud';
        } else {
          offer = 'upload-tilbud';
        }
        _this3.$router.push('/tilbud/' + offer + '?projectId=' + projId + '&contactId=' + homeOwnerData.ID + '&name=' + homeOwnerData.NAME + '&email=' + homeOwnerData.EMAIL + '&mobile=' + homeOwnerData.MOBILE + '&address=' + address);
      }).catch(function () {});
    }
  }
});

/***/ }),
/* 1545 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"approved-projects"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.formLoading)?_c('div',{class:_vm.loading ? 'hide' : ''},[(_vm.approvedProjectsData.length > 0)?_c('div',{staticClass:"flex flex-wrap"},_vm._l((_vm.approvedProjectsData),function(proj,index){return _c('div',{key:index,staticClass:"col-3 p2",class:!proj.OFFER_SENT ? 'flex' : null},[_c('div',{staticClass:"col-12 p0 border highlights py3 px2 mb2"},[(proj.ADDRESS)?_c('img',{staticClass:"mb3 cover",attrs:{"src":proj.ADDRESS.IMAGE,"rel":"preload","width":"100%","height":"250px","alt":proj.ADDRESS ? proj.ADDRESS : 'No Image'}}):_c('div',{staticClass:"flex justify-center items-center mb3",staticStyle:{"height":"250px"}},[_c('img',{attrs:{"src":"","alt":"No image"}})]),_vm._v(" "),_c('h3',{staticClass:"darkblue"},[_vm._v(_vm._s(proj.NAME ? proj.NAME : null))]),_vm._v(" "),_c('p',{staticClass:"mb0"},[_vm._v(_vm._s(proj.ADDRESS ? proj.ADDRESS.ADDRESS : null))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(proj.ADDRESS ? proj.ADDRESS.ZIP_CODE : null))]),_vm._v(" "),_c('h5',{staticClass:"darkblue mb3"},[_vm._v(_vm._s(proj.QUICK_OUTLINE ? proj.QUICK_OUTLINE : null))]),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('h5',{staticClass:"darkblue"},[_vm._v(_vm._s(proj.HOMEOWNER && proj.HOMEOWNER.NAME ? proj.HOMEOWNER.NAME : null))]),_vm._v(" "),_c('p',{staticClass:"darkblue"},[_vm._v(_vm._s(proj.DATE_CREATED ? proj.DATE_CREATED.split(' ')[0] : null))])]),_vm._v(" "),(proj.TAGS != null && proj.TAGS.length > 0)?_c('div',{staticClass:"flex flex-wrap mb2"},_vm._l((proj.TAGS),function(tag){return _c('el-tag',{key:tag.ID,staticClass:"mr1 mb2",attrs:{"effect":"dark"}},[_c('span',{staticClass:"cap"},[_vm._v(_vm._s(tag.DA_DK))])])}),1):_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('div',{staticClass:"center"},[_c('div',{staticClass:"mb1"},[_c('button',{staticClass:"h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12",on:{"click":function($event){return _vm.createOffer('standard', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)}}},[_vm._v("Standard tilbud")])]),_vm._v(" "),_c('div',{staticClass:"mb1"},[_c('button',{staticClass:"h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12",on:{"click":function($event){return _vm.createOffer('hurtigt', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)}}},[_vm._v("Hurtigt Offer")])]),_vm._v(" "),_c('div',{staticClass:"mb1"},[_c('button',{staticClass:"h5 action-button py2 px3 m0 gibson not-rounded border-none regular col-12",on:{"click":function($event){return _vm.createOffer('upload', proj.ID, proj.HOMEOWNER, proj.ADDRESS.ADDRESS)}}},[_vm._v("Upload tilbud")])])])])])}),0):_c('div',{staticClass:"mt4"},[_c('p',{staticClass:"h5 center regular easternblue m0 p0"},[_vm._v("No data")])])]):_vm._e()])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Godkendte projekter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */
var __vue_template__ = null
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1547 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__ = __webpack_require__(1549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ec56cc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__ = __webpack_require__(1554);
function injectStyle (ssrContext) {
  __webpack_require__(1548)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_calendar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_55ec56cc_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_calendar_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1548 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1549 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__fullcalendar_daygrid__ = __webpack_require__(612);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__fullcalendar_timegrid__ = __webpack_require__(1550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__fullcalendar_interaction__ = __webpack_require__(1551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap__ = __webpack_require__(1552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__fullcalendar_list__ = __webpack_require__(1553);







var FullCalendar = function FullCalendar() {
  return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 1855));
};
var allLocales = function allLocales() {
  return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 1856));
};
var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    FullCalendar: FullCalendar,
    Loading: Loading,
    ErrorHandler: ErrorHandler
  },
  created: function created() {
    this.displayCurrentProject();
  },
  data: function data() {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      calendarWeekends: true,
      calendarPlugins: [__WEBPACK_IMPORTED_MODULE_0__fullcalendar_daygrid__["d" /* default */], __WEBPACK_IMPORTED_MODULE_1__fullcalendar_timegrid__["a" /* default */], __WEBPACK_IMPORTED_MODULE_2__fullcalendar_interaction__["a" /* default */], __WEBPACK_IMPORTED_MODULE_3__fullcalendar_bootstrap__["a" /* default */], __WEBPACK_IMPORTED_MODULE_4__fullcalendar_list__["a" /* default */]],
      locales: allLocales,
      locale: 'da-dk',
      themeSystem: 'bootstrap',
      calendarEventsData: {
        events: [],
        validRange: {
          start: new Date()
        },
        visibleRange: {
          start: new Date(2018, 8, 1),
          end: new Date(5018, 8, 1)
        },
        eventTimeFormat: {
          hour: '2-digit',
          minute: '2-digit',
          meridiem: false,
          hour12: false
        }
      },
      selectedAddress: 'all'
    };
  },

  methods: {
    displayCurrentProject: function displayCurrentProject() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/projects', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (prop, index) {
            if (prop.IS_ACTIVE === 1) {
              _this.currentProjectData = prop;
            }
          });
        }
        _this.displayEvents();
      }, function (response) {
        var error = response.body;
        _this.$refs.errorMsg.showMsg(error);
      });
    },
    displayEvents: function displayEvents() {
      var _this2 = this;

      this.calendarEventsData.events = [];
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      var url = null;
      var projectId = null;
      var addressId = null;

      if (this.selectedAddress !== 'all') {
        projectId = this.selectedAddress.split('-')[1];
        addressId = this.selectedAddress.split('-')[0];
      } else {
        projectId = this.currentProjectData.ID;
        addressId = this.currentProjectData.ADDRESS.ID;
      }

      if (this.$route.query.fromProject) {
        url = "https://bitrixapi.haandvaerker.dk/v1/" + 'partner/calendars?projectId=' + projectId + '&addressId=' + addressId;
        this.selectedAddress = addressId + '-' + projectId;
      } else {
        if (this.selectedAddress !== 'all') {
          url = "https://bitrixapi.haandvaerker.dk/v1/" + 'partner/calendars?projectId=' + projectId + '&addressId=' + addressId;
        } else {
          url = "https://bitrixapi.haandvaerker.dk/v1/" + 'partner/calendars';
        }
      }
      this.$http.get(url, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data) {
          _this2.activitiesData = res.data;

          _this2.activitiesData.sort(function (a, b) {
            var dateA = new Date(a.DATE);
            var dateB = new Date(b.DATE);
            return dateA - dateB;
          });
          var dateTime = '';
          var date = '';
          var dateYear = '';
          var dateMonth = '';
          var dateDay = '';
          var id = '';
          var title = '';
          var start = '';
          var startHour = '';
          var startMin = '';
          var startSec = '';
          var end = '';
          var endHour = '';
          var endMin = '';
          var endSec = '';
          var color = '';
          var description = '';
          var type = '';
          for (var i = 0; i < res.data.length; i++) {
            dateTime = res.data[i].DATE.split(' ');
            date = dateTime[0].split('-');
            dateYear = parseInt(date[0]);
            dateMonth = parseInt(date[1]) - 1;
            dateDay = parseInt(date[2]);
            id = res.data[i].ID;
            title = res.data[i].TITLE;
            start = res.data[i].START_TIME.split(':');
            startHour = parseInt(start[0]);
            startMin = parseInt(start[1]);
            startSec = parseInt(start[2]);
            end = res.data[i].END_TIME.split(':');
            endHour = parseInt(end[0]);
            endMin = parseInt(end[1]);
            endSec = parseInt(end[2]);
            color = '#' + res.data[i].COLOR;
            description = res.data[i].DESCRIPTION;
            type = res.data[i].TYPE;
            _this2.calendarEventsData.events.push({
              id: id,
              title: title,
              start: new Date(dateYear, dateMonth, dateDay, startHour, startMin, startSec),
              end: new Date(dateYear, dateMonth, dateDay, endHour, endMin, endSec),
              description: description,
              type: type,
              backgroundColor: color
            });
          }
        }

        _this2.loading = false;
        if (_this2.$route.query.showInfo) {}
      }, function (response) {
        var error = response.body;
        _this2.$refs.errorMsg.showMsg(error);
      });
    }
  }
});

/***/ }),
/* 1550 */,
/* 1551 */,
/* 1552 */,
/* 1553 */,
/* 1554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"calendar"}},[_c('div',{staticClass:"col-12"},[(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('FullCalendar',{ref:"fullCalendar",attrs:{"default-view":"dayGridMonth","header":{ left: 'prev',center: 'title',right: 'next' },"editable":false,"droppable":false,"plugins":_vm.calendarPlugins,"events":_vm.calendarEventsData.events,"weekends":_vm.calendarWeekends,"theme-system":_vm.themeSystem,"event-time-format":_vm.calendarEventsData.eventTimeFormat,"locale":_vm.locale},on:{"dateClick":function($event){return _vm.dateClicked($event)},"eventClick":function($event){return _vm.eventClick($event)}}})],1)])]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Kalendar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_manager_vue__ = __webpack_require__(1557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c38f4500_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_manager_vue__ = __webpack_require__(1558);
function injectStyle (ssrContext) {
  __webpack_require__(1556)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_manager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c38f4500_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_manager_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1557 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-manager',
  components: {},
  created: function created() {
    this.displayCurrentProject();
  },
  data: function data() {
    return {
      haaId: localStorage.getItem('haaid'),
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true
    };
  },

  methods: {}
});

/***/ }),
/* 1558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"contract-manager"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix"},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(1)]):_c('div')])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Godkendte projekter")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1559 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_main_vue__ = __webpack_require__(1561);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4545cbf6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_main_vue__ = __webpack_require__(1562);
function injectStyle (ssrContext) {
  __webpack_require__(1560)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_main_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4545cbf6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_main_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1560 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1561 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_signature_pad__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_countries_json__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_languages_json__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_languages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_languages_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_full_loading__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_vue_full_loading___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_vue_full_loading__);













var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-main',
  components: {
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default.a,
    loading: __WEBPACK_IMPORTED_MODULE_10_vue_full_loading___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_9_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler,
    en: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["en"],
    da: __WEBPACK_IMPORTED_MODULE_4_vuejs_datepicker_dist_locale__["da"],
    datepicker: __WEBPACK_IMPORTED_MODULE_3_vuejs_datepicker__["a" /* default */],
    SignaturePad: __WEBPACK_IMPORTED_MODULE_6_signature_pad__["a" /* default */],
    Loading: Loading
  },
  data: function data() {
    return {
      contractID: '',
      contactId: '',
      contact: '',
      confirmTerms: false,
      contractStatus: '',
      ConfirmVisible: false,
      haaId: '',
      serviceUrl: '',
      contractInfo: '',
      selectedDocumentVersion: '',
      show: false,
      overlay: 1,
      label: 'Loading...',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      documentPath: '',
      homeownerID: 0,
      salesPersonbitrix: '',
      loading: false,
      showMobile: false,
      info: [],
      pdf: [],
      page: 1,
      historypage: '',
      comments: [],
      textarea: [],
      activeName: 'Comment',
      documentId: '',
      loaded: 1,
      activepage: 0,
      filteredcomments: [],
      commentmanagementloading: true,
      stepsarr: [],
      viewer: '',
      anotations: [],
      activedocumentId: '',
      partnerName: '',
      composeFormVisible: false,
      composeLoading: false,
      composeForm: {
        to: '',
        title: '',
        message: '',
        image: ''
      },
      disablecomment: false,
      webview: 'false',
      haspayproff: false,
      payproffform: false,
      confirmstatus: '',
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      },
      activeNames: [],
      payprofformfules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fødelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      countryData: __WEBPACK_IMPORTED_MODULE_7__components_countries_json___default.a,
      languagesData: __WEBPACK_IMPORTED_MODULE_8__components_languages_json___default.a,
      confirmPayproff: false,
      partnerprofile: [],
      partnertelephone: '',
      partneremail: '',
      isPep: true,
      termspopup: false,
      projectthreadid: '',
      activeprojectId: '',
      childprojects: [],
      partnerchildprojects: [],
      parentID: '',
      contractType: '',
      offerType: '',
      submittedIndustries: [],
      industryID: '',
      scale: 120,
      config: {
        toolbar: {
          toolbarViewerLeft: false
        }
      },
      pdfStr: '',
      pdfStrlink: '',
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'https://www.haandvaerker.dk/om/betingelser',
      signaturePad: '',
      termslinkablework: 'betingelser',
      ispartnerpayproffverified: null,
      verifylink: null,
      payprofftatus: null,
      partneriban: '',
      partnerwallet: {},
      ibanmessage: null,
      TermsNewPopup: false,
      termspopupText: ''
    };
  },
  created: function created() {
    var _this = this;

    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.historypage = localStorage.getItem('pdfjs.history');
    this.partnerName = localStorage.getItem('CompanyName');
    this.parentID = this.$route.query.parentID;
    this.contractType = this.$route.query.contracttype;
    this.industryID = this.$route.query.industryID;
    this.submittedIndustries = JSON.parse(this.$route.query.submittedindustry);
    this.offerType = this.$route.query.offertype;
    this.childprojects.forEach(function (o) {
      if (o.IS_PARTNER) {
        _this.partnerchildprojects.push(o.ID);
      }
    });
    var x = this;
    setTimeout(function () {
      document.querySelector('footer').classList.add('hide');
      x.webview = x.$route.query.webview;
      if (x.webview === 'true') {
        document.querySelector('header').classList.add('hide');
        document.querySelector('.sidebar').classList.add('hide');
      }
    }, 500);

    this.getsupplierprofile();
  },
  mounted: function mounted() {
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer';
    this.getPayproffacc();
    this.getTermsCondition();
  },

  methods: {
    commentAdd: function commentAdd(event) {
      console.log(event);
      this.saveComment(event, 1);
    },
    pdfCreated: function pdfCreated(pdf) {
      var _this2 = this;

      var g4string = '';
      setTimeout(function () {
        _this2.viewer = document.getElementById('pdfViewer');
        console.log('this.viewer', _this2.viewer);
        console.log('this.viewermain', _this2.viewer.element.ej2_instances[0]);
        var viewers = _this2.viewer['element'].ej2_instances[0];
        viewers.load(g4string, null);
      }, 1000);
    },
    showcontract: function showcontract() {
      var searchInput = document.querySelectorAll('[data-page-number]');
      var searchinputpage = [];
      var thisthisvarvar = this;
      searchInput.forEach(function (a) {
        if (a.className === 'page') {
          searchinputpage.push(a);
        }
      });
      searchinputpage.forEach(function (a, index) {
        if (a.className === 'page') {
          a.addEventListener('mouseup', function () {
            var text = window.getSelection().toString();
            if (text !== '') {
              thisthisvarvar.addComment(index + 1, text);
            }
          });
        }
      });
    },
    getContract: function getContract() {
      var _this3 = this;

      var contractId = this.$route.query.contractId;
      this.contractID = contractId;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        documentId: this.documentId
      };
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/preview/document.base64', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.contractInfo = res.data;
        if (_this3.contractInfo.file) {
          _this3.documentId = _this3.contractInfo.documentId;
          _this3.contact = _this3.contractInfo.CONTACT_TITLE;
          _this3.contactId = _this3.contractInfo.CONTACT_ID;
          _this3.activeprojectId = _this3.contractInfo.contracts.PROJECT.ID;
          _this3.contractStatus = _this3.contractInfo.contracts.STATUS;
          _this3.confirmstatus = _this3.contractInfo.contracts.DATE_SIGNED_BY_PARTNER;
          _this3.projectTitle = _this3.contractInfo.contracts.PROJECT.NAME;
          _this3.homeownerID = _this3.contractInfo.contracts.PROJECT.HOMEOWNER.ID;
          if (_this3.contractStatus === 'approved' || _this3.contractStatus === 'signed') {
            _this3.disablecomment = true;
          }

          _this3.pdfStrlink = _this3.contractInfo.url;
        }
        if (_this3.documentId !== '') {
          _this3.selectedDocumentVersion = _this3.contractInfo.documentId.toString();
        }
        _this3.show = false;
        _this3.loading = false;
        _this3.getmessagesbyProjectID();
      }, function (err) {
        _this3.loading = false;
        _this3.show = false;
        _this3.formLoading = false;
        _this3.commentIsConfirmed = false;
        var error = err.body.message;
        _this3.$refs.errorMsg.showMsg(error);
      });
    },
    base64ToArrayBuffer: function base64ToArrayBuffer(base64) {
      var binarystring = window.atob(base64);
      var len = binarystring.length;
      var bytes = new Uint8Array(len);
      for (var i = 0; i < len; i++) {
        bytes[i] = binarystring.charCodeAt(i);
      }
      return bytes.buffer;
    },
    sendmessage: function sendmessage() {
      var _this4 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        contactId: this.contactId,
        title: this.composeForm.title,
        message: this.composeForm.message
      };
      this.$http.post(this.$bitrixapi + 'partner/messages/' + this.projectthreadid + '/reply', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          _this4.composeFormVisible = false;
          var obj = {
            title: 'Gennemført!',
            message: 'Besked sendt',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this4.$refs.simplert.openSimplert(obj);
        } else {
          _this4.$message({
            type: 'error',
            message: response.body.message
          });
        }
      }, function (err) {
        _this4.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    changeDocument: function changeDocument() {
      this.documentId = this.selectedDocumentVersion;
      this.getContract();
    },
    documentLoad: function documentLoad() {
      if (!this.disablecomment && !this.showMobile) {
        document.getElementById('pdfViewer_annotation_commentPanel').click();
        document.getElementById('pdfViewer_annotation').click();
      }
      document.getElementById('pdfViewer_open').style.display = 'none';
      document.getElementById('pdfViewer_submitForm').style.display = 'none';
      this.viewer.importAnnotation(JSON.parse(this.contractInfo.ANNOTATIONS));
      this.formLoading = false;
    },
    exportAnnotation: function exportAnnotation(args) {
      if (this.disablecomment) {
        var obj = {
          title: 'Denne kontrakt er blevet bekræftet, din kommentar vil ikke blive sendt til boligejeren',
          message: '',
          type: 'error',
          customCloseBtnText: 'Luk'
        };
        this.$refs.simplert.openSimplert(obj);
        return;
      }
      var m = this;
      this.viewer.exportAnnotationsAsObject().then(function (value) {
        var headers = {
          Authorization: 'Bearer ' + m.salesPersonbitrix
        };
        var data = {
          documentId: m.documentId,
          annotation: value
        };
        m.$http.post(m.$bitrixapi + 'partner/contract/' + m.contractID + '/saveAnnotation', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          console.log(response);
        });
        console.log(value);
      });
    },
    ajaxRequestFailure: function ajaxRequestFailure(args) {
      window.location.reload();
    },
    getsupplierprofile: function getsupplierprofile() {
      var _this5 = this;

      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaId, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.partnerprofile = res.data;
          _this5.partnertelephone = res.data.MOBILE;
          _this5.partneremail = res.data.EMAIL;
          _this5.payprofform.telefonnummer = Number(res.data.UF_CRM_COMPANY_TELEPHONE);
          _this5.payprofform.email = res.data.EMAIL;
          _this5.payprofform.by = res.data.UF_CRM_COMPANY_CITY;
          _this5.payprofform.stat = res.data.UF_CRM_COMPANY_CITY;
          _this5.payprofform.Adresse = res.data.UF_CRM_COMPANY_ADDRESS;
          _this5.payprofform.zipcode = res.data.UF_CRM_COMPANY_ZIP_CODE;
          _this5.payprofform.cvr = res.data.UF_CRM_COMPANY_CVR;
          _this5.payprofform.companyName = res.data.TITLE;
        } else {
          _this5.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getProjectDetails: function getProjectDetails() {
      var _this6 = this;

      var projectid = this.$route.query.projectId;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.show = true;
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this6.contractID = res.data.CONTRACT_ID;
          _this6.contractStatus = res.data.CONTRACT_STATUS;
          if (_this6.contractStatus === 'approved' || _this6.contractStatus === 'signed') {
            _this6.disablecomment = true;
          }
          _this6.homeownerID = res.data.HOMEOWNER.ID;
          _this6.show = false;
          _this6.getContract();
        } else {
          _this6.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this6.show = false;
        _this6.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getContractByProjectId: function getContractByProjectId() {
      var _this7 = this;

      this.commentmanagementloading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this7.contractdetails = res.data;
          _this7.comments = res.data.COMMENTS.reverse();
          _this7.contractID = _this7.contractdetails.ID;
          _this7.activedocumentId = res.data.DOCUMENTS.ID;
          _this7.contractpdflink = '/static/pdf/sample.pdf';
          var thisvar = _this7;
          res.data.COMMENTS.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this7.loaded === 1) {
            setTimeout(function () {
              _this7.showcontract();
            }, 3000);
          }
          _this7.loaded = 2;
          _this7.filtercommentsbyId(_this7.activepage);
          _this7.loading = false;
          _this7.commentmanagementloading = false;
          _this7.getContractSteps();
        } else {
          _this7.$message({
            type: 'error',
            message: res.message
          });
          _this7.loading = false;
        }
      }, function (response) {
        _this7.loading = false;
        _this7.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getContractComments: function getContractComments() {
      var _this8 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/comments/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this8.comments = res.data.reverse();
          var thisvar = _this8;
          _this8.comments.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this8.loaded === 1) {
            setTimeout(function () {
              _this8.showcontract();
            }, 5000);
          }
          _this8.loaded = 2;
          _this8.loading = false;
        } else {
          _this8.$message({
            type: 'error',
            message: res.message
          });
          _this8.loading = false;
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this8.refreshtoken();
          setTimeout(function () {
            _this8.getContractComments();
          }, 1000);
        } else {
          _this8.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getStepbycontent: function getStepbycontent(content) {
      this.stepsarr.forEach(function (l) {
        if (l.value.toString().includes(content)) {
          return l;
        }
        return false;
      });
    },
    getContractSteps: function getContractSteps() {
      var documents = [];
      var steps = [];
      var stepsvalue = [];
      documents = this.contractdetails.DOCUMENTS[this.contractdetails.DOCUMENTS.length - 1];
      steps = documents.JSON_STEPS;
      var arrsteps = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(steps);
      arrsteps.forEach(function (a) {
        var arrfield = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(a);
        arrfield[arrfield.length - 1].forEach(function (h) {
          if ((typeof h === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(h)) === 'object') {
            h['fields'].forEach(function (n) {
              if (n.field !== 0) {
                var tempvalue = {
                  key: h.key,
                  value: n.default_value
                };
                stepsvalue.push(tempvalue);
                tempvalue = [];
              }
            });
          }
        });
      });
      this.stepsarr = stepsvalue;
    },
    getPayproffacc: function getPayproffacc() {
      var _this9 = this;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.haspayproff = res.data.exists;
          _this9.ispartnerpayproffverified = res.data.payproff_verified;
          _this9.verifylink = res.data.payproff_url;
          _this9.payprofftatus = res.data.status;

          _this9.getContract();
        } else {
          _this9.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this9.loading = false;
        _this9.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    opentermpopup: function opentermpopup() {
      if (this.termslink === null) {
        this.TermsNewPopup = true;
      } else {
        this.termspopup = true;
      }
    },
    getTermsCondition: function getTermsCondition() {
      var _this10 = this;

      var haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopupV2?COMPANY=' + haaid, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this10.termsdata = res;
        _this10.termslink = _this10.termsdata.LINK;
        _this10.termslabel = _this10.termsdata.LABEL;
        _this10.termspopupText = _this10.termsdata.HTML;
        var labelarroriginal = _this10.termsdata.LABEL.split(' ');
        var labelarr = _this10.termsdata.LABEL.split(' ');
        labelarr.pop();
        _this10.termslabel = labelarr.join(' ');
        _this10.termslinkablework = labelarroriginal[labelarroriginal.length - 1];
      }, function (response) {
        _this10.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getTermsCondition2: function getTermsCondition2() {
      var _this11 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this11.termsdata = res.filter(function (l) {
          return l.TYPE === 'Partner';
        })[0];
        _this11.termslink = _this11.termsdata.LINK;
        var labelarroriginal = _this11.termsdata.LABEL.split(' ');
        var labelarr = _this11.termsdata.LABEL.split(' ');
        labelarr.pop();
        _this11.termslabel = labelarr.join(' ');
        _this11.termslinkablework = labelarroriginal[labelarroriginal.length - 1];
      }, function (response) {
        _this11.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getAnnotations: function getAnnotations() {
      var thisvar = this;
      this.viewer = thisvar.$refs.pdfviewer.ej2Instances;
      this.comments.forEach(function (a) {
        if (a.ANNOTATIONS !== null) {
          console.log('a.ANNOTATIONS', a.ANNOTATIONS);
          thisvar.viewer.annotation.addAnnotation('Highlight', {
            allowedInteractions: a.ANNOTATIONS['allowedInteractions'],
            annotName: a.ANNOTATIONS['annotName'],
            annotationAddMode: a.ANNOTATIONS['annotationAddMode'],
            annotationSelectorSettings: {
              selectionBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderColor'],
              resizerBorderColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerBorderColor'],
              resizerFillColor: a.ANNOTATIONS['annotationSelectorSettings']['resizerFillColor'],
              resizerSize: a.ANNOTATIONS['annotationSelectorSettings']['resizerSize'],
              selectionBorderThickness: a.ANNOTATIONS['annotationSelectorSettings']['selectionBorderThickness'],
              selectorLineDashArray: a.ANNOTATIONS['annotationSelectorSettings']['selectorLineDashArray']
            },
            annotationSettings: {
              isLock: a.ANNOTATIONS['annotationSettings']['annotationAddMode']
            },
            author: thisvar.partnerName,
            bounds: [{
              bottom: a.ANNOTATIONS['bounds']['bottom'],
              height: a.ANNOTATIONS['bounds']['height'],
              left: a.ANNOTATIONS['bounds']['left'],
              top: a.ANNOTATIONS['bounds']['top'],
              right: a.ANNOTATIONS['bounds']['right']
            }],
            bottom: a.ANNOTATIONS['bottom'],
            height: a.ANNOTATIONS['height'],
            left: a.ANNOTATIONS['left'],
            right: a.ANNOTATIONS['right'],
            top: a.ANNOTATIONS['top'],
            width: a.ANNOTATIONS['width'],
            color: a.ANNOTATIONS['color'],
            comments: a.ANNOTATIONS['comments'],
            isAnnotationRotated: a.ANNOTATIONS['isAnnotationRotated'],
            isCommentLock: a.ANNOTATIONS['isCommentLock'],
            isMultiSelect: a.ANNOTATIONS['isMultiSelect'],
            isPrint: a.ANNOTATIONS['isMultiSelect'],
            modifiedDate: a.ANNOTATIONS['isMultiSelect'],
            note: a.ANNOTATIONS['note'],
            opacity: a.ANNOTATIONS['opacity'],
            pageNumber: a.ANNOTATIONS['pageNumber'],
            rect: {
              bottom: a.ANNOTATIONS['rect']['bottom'],
              height: a.ANNOTATIONS['rect']['height'],
              left: a.ANNOTATIONS['rect']['left'],
              right: a.ANNOTATIONS['rect']['right'],
              top: a.ANNOTATIONS['rect']['top'],
              width: a.ANNOTATIONS['rect']['width']
            },
            review: {
              state: a.ANNOTATIONS['review']['state'],
              stateModel: a.ANNOTATIONS['review']['stateModel'],
              author: a.ANNOTATIONS['review']['author'],
              modifiedDate: a.ANNOTATIONS['review']['modifiedDate']
            },
            shapeAnnotationType: a.ANNOTATIONS['shapeAnnotationType'],
            subject: a.ANNOTATIONS['subject'],
            textMarkupAnnotationType: a.ANNOTATIONS['textMarkupAnnotationType'],
            textmarkupcontent: a.ANNOTATIONS['textMarkupContent'],
            textMarkupEndIndex: a.ANNOTATIONS['textMarkupEndIndex'],
            textMarkupStartIndex: a.ANNOTATIONS['textMarkupStartIndex']
          });
        }
      });
    },
    saveComment: function saveComment(item, index) {
      var _this12 = this;

      var stepno = 3;
      var step = this.getStepbycontent(item['annotation']['textMarkupContent']);
      if (stepno) {
        step = stepno.key;
      }
      var page = item['annotation']['pageNumber'];
      var highlighttext = item['annotation']['textMarkupContent'];
      var desccomment = item['annotation']['note'];
      this.$confirm('Er du sikker på, at du vil gemme denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var headers = {
          Authorization: 'Bearer ' + _this12.salesPersonbitrix
        };
        var data = {
          annotations: item['annotation'],
          documentId: _this12.activedocumentId,
          annotationId: item['id']
        };
        _this12.$http.post(_this12.$bitrixapi + 'partner/contract/comments?contractId=' + _this12.contractID + '&title=' + step + '&comments=' + desccomment + '&page=' + page + '&highlightedText=' + highlighttext + '&contactId=' + _this12.homeownerID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this12.$refs.simplert.openSimplert(obj);
          }
          _this12.getContractByProjectId();
        }, function (err) {
          _this12.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    addComment: function addComment(page, selectedtext) {
      var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 3;

      var haaid = localStorage.getItem('haaid');
      var commentdetails = {
        'HIGHLIGHTED_TEXT': selectedtext,
        'COMMENTS': '',
        'PAGE': page,
        'TITLE': step,
        'STATUS': 'pending',
        'CONTRACT_ID': this.contractID,
        'CONTACT_ID': this.homeownerID,
        'COMPANY_ID': haaid,
        'fromdb': false
      };
      this.comments.unshift(commentdetails);
      this.filteredcomments.unshift(commentdetails);
      var thisvar = this;
      this.comments.forEach(function (a, index) {
        thisvar.comments[index]['fromdb'] = a.fromdb;
        thisvar.textarea[index] = a.COMMENTS;
      });
      this.filteredcomments.forEach(function (b, index) {
        thisvar.filteredcomments[index]['fromdb'] = b.fromdb;
        thisvar.textarea[index] = b.COMMENTS;
      });
      commentdetails = [];
    },
    clear: function clear() {
      this.payprofform = {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: '+45',
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      };
    },
    closeconfirmPayproff: function closeconfirmPayproff() {
      this.confirmPayproff = false;
    },
    openconfirmPayproff: function openconfirmPayproff() {
      if (!this.partneriban) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst dit Iban-nummer'
        });
        return false;
      }
      var isnumber = /^\d+$/.test(this.payprofform.cprnummer);
      if (!isnumber) {
        this.$message({
          type: 'error',
          message: 'Indtast kun tal på cpr-nummeret'
        });
        return false;
      }
      var error = 0;
      this.$refs['payprofform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.closepayproffform();
      this.confirmPayproff = true;
    },
    verifyIban: function verifyIban(ibantext) {
      var _this13 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/validateIban/' + this.partneriban.replace(/ /g, ''), { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data.valid) {
          if (ibantext === '') {
            _this13.verify();
          }
          _this13.ibanmessage = null;
        } else {
          var messagearr = '';
          res.data.messages.forEach(function (t) {
            messagearr += t + ', ';
          });
          _this13.ibanmessage = messagearr;
          _this13.$message({
            type: 'error',
            message: messagearr
          });
        }
      }, function (response) {
        _this13.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    verify: function verify() {
      var _this14 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: Number(this.payprofform.cprnummer),
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName,
        iban: this.partneriban.replace(/ /g, '')
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this14.closeconfirmPayproff();

          _this14.getNemIdUrl();
        } else {
          _this14.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this14.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getwalletinfo: function getwalletinfo() {
      var _this15 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/payproff/wallet', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this15.partnerwallet = res;
      }, function (response) {
        _this15.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getNemIdUrl: function getNemIdUrl() {
      var _this16 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        window.open(res.data.URL, '_blank').focus();
      }, function (err) {
        _this16.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    initiateSignaturepad: function initiateSignaturepad() {
      var _this17 = this;

      setTimeout(function () {
        var canvas = document.querySelector('canvas');
        _this17.signaturePad = new __WEBPACK_IMPORTED_MODULE_6_signature_pad__["a" /* default */](canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        });
      }, 200);
    },
    clearSignature: function clearSignature() {
      this.signaturePad.clear();
    },
    confirmcontract: function confirmcontract() {
      var _this18 = this;

      this.loading = true;
      if (!this.confirmTerms) {
        this.$message({
          type: 'error',
          message: 'Accepter venligst vores vilkår og tjenester'
        });
        this.loading = false;
        return;
      }
      var signature = this.signaturePad;
      if (signature.isEmpty()) {
        this.$message({
          type: 'error',
          message: 'Underskriv venligst kontrakten'
        });
        this.loading = false;
        return;
      }
      var signaturePng = signature.toDataURL();
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        signaturePng: signaturePng
      };
      this.$http.post(this.$bitrixapi + 'partner/contract/' + this.contractID + '/approve?messageId=1&fileId=1', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        if (response.body.success) {
          if (_this18.haspayproff && _this18.ispartnerpayproffverified) {
            var m = _this18;
            var closeFn = function closeFn() {
              this.$router.push('/customer-projects/contract-main-tak?projectId=' + m.activeprojectId + '&contactID=' + m.homeownerID + '&parentID=' + m.parentID + '&industryID=' + m.industryID + '&offertype=' + m.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(m.childprojects) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(m.submittedIndustries) + '&contracttype=' + m.contractType + '&projecttitle=' + m.projectTitle);
            };
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              onClose: closeFn,
              customCloseBtnText: 'Luk'
            };
            _this18.$refs.simplert.openSimplert(obj);
            _this18.loading = false;
          } else {
            _this18.$router.push('/konto-update?dashdata=' + '/customer-projects/project-dashboard?projectId=' + _this18.activeprojectId + '&contactID=' + _this18.homeownerID + '&parentID=' + _this18.parentID + '&industryID=' + _this18.industryID + '&offertype=' + _this18.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this18.childprojects) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(_this18.submittedIndustries) + '&contracttype=' + _this18.contractType + '&projecttitle=' + _this18.projectTitle);
          }
        }
      }, function (err) {
        _this18.loading = false;
        _this18.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    deletecommentarray: function deletecommentarray(item) {
      this.comments.splice(this.comments.indexOf(item), 1);
      this.textarea.splice(this.textarea.indexOf(item.COMMENTS), 1);
      this.getContractByProjectId();
    },
    deletecomment: function deletecomment(item) {
      var _this19 = this;

      this.$confirm('Er du sikker på, at du vil slette denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this19.commentmanagementloading = true;
        var headers = {
          Authorization: 'Bearer ' + _this19.salesPersonbitrix
        };
        var data = {};
        _this19.$http.post(_this19.$bitrixapi + 'partner/contract/comments/' + item.ID + '/delete', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this19.$refs.simplert.openSimplert(obj);
            _this19.getContractByProjectId();
          }
        }, function (err) {
          _this19.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    filtercommentsbyId: function filtercommentsbyId(page) {
      var filtered = [];
      var thisthisvar = this;
      filtered = this.comments.filter(function (a) {
        return a.PAGE === page;
      });
      filtered.forEach(function (b, index) {
        if (b.HIGHLIGHTED_TEXT !== null && b.HIGHLIGHTED_TEXT !== '') {
          thisthisvar.hightlighttext(b.HIGHLIGHTED_TEXT);
        }
        thisthisvar.textarea[index] = b.COMMENTS;
      });
      this.filteredcomments = filtered;
    },
    hightlighttext: function hightlighttext(text) {
      var textactula = document.querySelectorAll('[data-page-number="' + this.activepage + '"] > .textLayer > span');
      textactula.forEach(function (z) {
        var Special = /[\\[{().+?|^&]/g;
        if (z.innerHTML.includes(text)) {
          var textvalue = z.innerHTML;
          if (Special.test(textvalue)) {
            textvalue = textvalue.replace(Special, '\\$&');
          }
          var regExp = new RegExp(text, 'gi');
          z.innerHTML = z.textContent.replace(regExp, '<marker>$&</marker>');
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this20 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this20.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this20.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        _this20.$router.push('/login');
      });
    },
    getmessagesbyProjectID: function getmessagesbyProjectID() {
      var _this21 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/messages?projectId=' + this.activeprojectId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this21.projectthreadid = res[0].THREAD_ID;
      }, function (response) {
        _this21.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    showComposeForm: function showComposeForm() {
      if (this.composeForm.message === '') {
        this.composeForm.message = 'Jeg har tjekket filen og har nogle kommentarer. Kontroller venligst';
      }
      if (this.composeForm.title === '') {
        this.composeForm.title = 'Gennemgå Draft Contract Pdf';
      }
      this.composeFormVisible = true;
    },
    hideComposeForm: function hideComposeForm() {
      this.composeFormVisible = false;
    },
    uploadImage: function uploadImage(file, fileList) {
      this.composeForm.image = fileList;
      var fileSize = file.size / 1024 / 1024;
      var fileLimitMB = 1;
      if (fileSize > fileLimitMB) {
        this.removeUpload(file);
        this.$message.error('File size can not exceed 1MB!');
      }
    },
    removeUpload: function removeUpload(file) {
      var images = this.composeForm.image;
      for (var i = 0; i < images.length; i++) {
        if (file.uid === images[i].uid) {
          images.splice(i, 1);
        }
      }
      images = this.composeForm.image;
    },
    pagesRenderedHandler: function pagesRenderedHandler(pdfapp) {
      this.pdf = pdfapp;
      this.activepage = pdfapp.page;
      var thisvar = this;
      this.pdf.bindEvents('pagechanging', function (a) {
        thisvar.page = a.page;
      });
    },
    openpayproffform: function openpayproffform() {
      this.payproffform = true;
    },
    closepayproffform: function closepayproffform() {
      this.payproffform = false;
      this.ConfirmVisible = false;
    },
    validateCreatePayproffFirstTab: function validateCreatePayproffFirstTab() {
      return true;
    },
    setmaskinput: function setmaskinput() {
      this.partneriban = this.$maskibanNumber(this.partneriban);

      if (this.partneriban.length > 21) {
        this.verifyIban('checkiban');
      }
    }
  },
  watch: {
    'partneriban': function partneriban(newVal, oldVal) {
      var _this22 = this;

      setTimeout(function () {
        if (newVal.length > 1) {
          _this22.setmaskinput(newVal);
        }
      }, 300);
    }
  }
});

/***/ }),
/* 1562 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-main-viewer"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix "},[_vm._m(0),_vm._v(" "),_c('div',[(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"flex flex-row mobile-flex-column col-12 m0 pb2 p0 ",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"highlights border col-12 mp0"},[_c('div',{staticClass:"flex justify-end"},[(_vm.confirmstatus === '')?_c('button',{staticClass:"p1 m1 action-button",on:{"click":function($event){_vm.ConfirmVisible = true, _vm.initiateSignaturepad()}}},[_vm._v("Bekræft")]):_vm._e(),_vm._v("\n                   \n                  "),_c('button',{staticClass:"p1 m1 primary-button",on:{"click":function($event){return _vm.showComposeForm()}}},[_c('i',{staticClass:"el-icon-circle-plus"}),_vm._v(" Send besked til "+_vm._s(_vm.contact))])]),_vm._v(" "),(_vm.ConfirmVisible)?_c('div',{staticClass:"flex justify-center"},[_c('form',{staticClass:"payProff"},[_c('div',{staticClass:"col-12 flex justify-between items-center p0"},[_c('p',{staticClass:"h5 cyprus regular line-height-1 m0 p2"},[_vm._v("Underskriv her")]),_vm._v(" "),_c('b-button',{attrs:{"variant":"outline-danger","size":"sm"},on:{"click":function($event){return _vm.clearSignature()}}},[_vm._v("RYD")])],1),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_vm._m(1),_vm._v(" "),_c('p',{staticClass:"mr-auto p0 py2 m0 h6 flex"},[_c('el-checkbox',{staticClass:"saveSignature",model:{value:(_vm.confirmTerms),callback:function ($$v) {_vm.confirmTerms=$$v},expression:"confirmTerms"}},[_c('span',{staticClass:"pointer"},[_vm._v(_vm._s(_vm.termslabel))])]),_c('span',{staticClass:"primarycolor semi-bold pl1 pointer",on:{"click":function($event){return _vm.opentermpopup()}}},[_vm._v(_vm._s(_vm.termslinkablework))])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0 flex justify-between items-center"},[_c('button',{staticClass:"mr2 muted-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){_vm.ConfirmVisible = false}}},[_c('span',{staticClass:"mr1"}),_vm._v("Annuller\n                        ")]),_vm._v(" "),_c('button',{staticClass:"action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmcontract()}}},[_vm._v("\n                          Bekræft\n                          "),_c('span',{staticClass:"ml1"})])])])]),_vm._v(" "),_c('div',{staticClass:"py2"})]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"height":"700px"}},[_c('b-embed',{staticStyle:{"height":"100vh"},attrs:{"type":"iframe","aspect":"1by1","src":_vm.pdfStrlink,"allowfullscreen":""}})],1)])]),_vm._v(" "),_c('div',{staticClass:"py3"})])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('loading',{attrs:{"show":_vm.show,"label":_vm.label,"overlay":_vm.overlay}}),_vm._v(" "),_c('b-modal',{ref:"formModal",staticClass:"p2 pb4",attrs:{"hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":""},model:{value:(_vm.composeFormVisible),callback:function ($$v) {_vm.composeFormVisible=$$v},expression:"composeFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n            Skriv til ...\n          ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Ny besked")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),_c('form',[_c('div',{staticClass:"form-group"},[_vm._v("\n        "+_vm._s(_vm.contact)+"\n      ")]),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Title"},model:{value:(_vm.composeForm.title),callback:function ($$v) {_vm.$set(_vm.composeForm, "title", $$v)},expression:"composeForm.title"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group mb4"},[_c('wysiwyg',{staticClass:"mb2",attrs:{"placeholder":"Notat","required":""},model:{value:(_vm.composeForm.message),callback:function ($$v) {_vm.$set(_vm.composeForm, "message", $$v)},expression:"composeForm.message"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-2 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){_vm.composeFormVisible = false}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-2 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendmessage()}}},[_c('span',[_vm._v("Send")])])])])]),_vm._v(" "),_c('b-modal',{ref:"payproffform",attrs:{"centered":"","hide-footer":"","id":"payproffform","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.payproffform),callback:function ($$v) {_vm.payproffform=$$v},expression:"payproffform"}},[_c('div',{staticClass:"col-11 flex justify-between items-center pt1 p0 mx-auto my2"},[_c('div',{staticClass:"col-5"},[_c('p',{staticClass:"mr-auto h5 cyprus semi-bold line-height-1 m0 p0"},[_vm._v("Payproff Form\n          ")])]),_vm._v(" "),_c('div',{staticClass:"col-3 ml-auto flex justify-end h4 p0 primary-white-button pointer close m0",on:{"click":function($event){return _vm.closepayproffform()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"hide"},[_c('div',{staticClass:"flex flex-column "},[_c('span',{},[_c('i',{staticClass:"el-icon-loading"})]),_vm._v(" "),_c('p',{staticClass:"h6 regular small"},[_vm._v("Godkendt af Finanstilsynet")]),_vm._v(" "),_c('p',{staticClass:"p0 m0"},[_c('i',{staticClass:"el-icon-warning-outline"}),_c('span',{},[_vm._v("Information")])]),_vm._v(" "),_c('div')])]),_vm._v(" "),_c('div',{staticClass:"darkblue notosans",attrs:{"id":"payproff"}},[_c('el-form',{ref:"payprofform",staticClass:"md-col-11 lg-col-11 sm-col-12 mx-auto p2",attrs:{"id":"cvrfrom","model":_vm.payprofform,"rules":_vm.payprofformfules,"label-position":"top"}},[_c('form-wizard',{ref:"createPayproffFormWiz",attrs:{"shape":"tab","color":"#ffffff"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"col-12 p0 flex",class:props.isLastStep ? 'justify-between' : 'justify-end'},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-primary-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){props.isLastStep ? _vm.openconfirmPayproff() : props.nextTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(props.isLastStep ? 'Indsend' : 'Næste'))]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])]}}])},[_c('tab-content',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"mb2 flex flex-column items-start p0"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"152.26","height":"35.735","viewBox":"0 0 152.26 35.735"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1428","data-name":"Rectangle 1428","width":"152.26","height":"35.735","fill":"#2265fc"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Payproff_logo","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4272","data-name":"Path 4272","d":"M820.931,52.36v0Z","transform":"translate(-668.671 -41.591)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4273","data-name":"Path 4273","d":"M820.931,78.36v0Z","transform":"translate(-668.671 -62.769)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4274","data-name":"Path 4274","d":"M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072","transform":"translate(0 0)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4275","data-name":"Path 4275","d":"M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016","transform":"translate(-381.958 -44.465)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4276","data-name":"Path 4276","d":"M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021","transform":"translate(-179.766 -44.315)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4277","data-name":"Path 4277","d":"M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022","transform":"translate(-249.978 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4278","data-name":"Path 4278","d":"M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0","transform":"translate(-507.012 -60.278)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4279","data-name":"Path 4279","d":"M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0","transform":"translate(-572.504 -39.143)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4280","data-name":"Path 4280","d":"M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012","transform":"translate(-624.503 -39.14)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4281","data-name":"Path 4281","d":"M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z","transform":"translate(-331.26 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4282","data-name":"Path 4282","d":"M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276","transform":"translate(-456.523 -60.325)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4283","data-name":"Path 4283","d":"M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117","transform":"translate(-314.339 -60.317)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4284","data-name":"Path 4284","d":"M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175","transform":"translate(-589.263 -60.244)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4285","data-name":"Path 4285","d":"M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469","transform":"translate(-641.245 -60.253)","fill":"#2265fc"}})])]),_vm._v(" "),_c('span',[_vm._v("Godkendt af Finanstilsynet")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center cyprus"},[_c('span',[_c('svg',{staticClass:"block",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"}})])]),_vm._v(" "),_c('p',{staticClass:"h5 line-height-1 m0 ml1 p0"},[_vm._v("Information")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix pr3 mb2"},[_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  "),_c('a',{staticClass:"semi-bold",attrs:{"href":"https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186","target":"_blank"}},[_vm._v("her")]),_vm._v(", og læse mere om de godkendelser, de har fået\n                  ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("\n                  PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.")])]),_vm._v(" "),_c('div',[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor har du brug for mine bankoplysninger?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("Vi har brug for dine bankoplysninger for at sende dig pengene eller for at\n                        refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver\n                        at dele dine bankoplysninger med din kontraktpartner.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvordan overfører jeg pengene til PayProff?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,\n                        Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de\n                        bankoplysninger og referencenummer, du skal bruge input, når du foretager\n                        overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte\n                        referencenummer Der kan opstå forsinkelser, da vores system ikke vil være\n                        i stand til at afstemme din betaling med det samme.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("For at overholde lovmæssige krav skal vi muligvis stille dig et par\n                        ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,\n                        hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper\n                        økonomisk kriminalitet.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi\n                        en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du\n                        er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.\n                        Flere muligheder om identitetsbekræftelse både for private enkeltpersoner\n                        og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.")])],2)],1)],1)])]),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateCreatePayproffFirstTab}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fornavn","prop":"fornavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"8","placeholder":"fornavn","clearable":""},model:{value:(_vm.payprofform.fornavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "fornavn", _vm._n($$v))},expression:"payprofform.fornavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Efternavn","id":"efternavn","prop":"efternavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"efternavn","clearable":""},model:{value:(_vm.payprofform.efternavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "efternavn", $$v)},expression:"payprofform.efternavn"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Mellemnavn","prop":"mellemnavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"mellemnavn","clearable":""},model:{value:(_vm.payprofform.mellemnavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "mellemnavn", $$v)},expression:"payprofform.mellemnavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 ml-auto",attrs:{"label":"Fødelsdag","id":"fodelsdag","prop":"fodelsdag"}},[_c('datepicker',{staticClass:"col-12 m0 p0",attrs:{"id":"datepickeroffer2","bootstrapStyling":false,"placeholder":"Fødelsdag","language":_vm.da},model:{value:(_vm.payprofform.fodelsdag),callback:function ($$v) {_vm.$set(_vm.payprofform, "fodelsdag", $$v)},expression:"payprofform.fodelsdag"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Adresse","prop":"Adresse"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"Strandlodsvej 6, 1. sal","clearable":""},model:{value:(_vm.payprofform.Adresse),callback:function ($$v) {_vm.$set(_vm.payprofform, "Adresse", $$v)},expression:"payprofform.Adresse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"zipcode","id":"zipcode","prop":"zipcode"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"2300","clearable":""},model:{value:(_vm.payprofform.zipcode),callback:function ($$v) {_vm.$set(_vm.payprofform, "zipcode", $$v)},expression:"payprofform.zipcode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"By","prop":"by"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"København s","clearable":""},model:{value:(_vm.payprofform.by),callback:function ($$v) {_vm.$set(_vm.payprofform, "by", $$v)},expression:"payprofform.by"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Stat","id":"stat","prop":"stat"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"stat","clearable":""},model:{value:(_vm.payprofform.stat),callback:function ($$v) {_vm.$set(_vm.payprofform, "stat", $$v)},expression:"payprofform.stat"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:" white-background",attrs:{"placeholder":"E-mail","clearable":""},model:{value:(_vm.payprofform.email),callback:function ($$v) {_vm.$set(_vm.payprofform, "email", $$v)},expression:"payprofform.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Land","id":"land","prop":"land"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"Country"},model:{value:(_vm.payprofform.land),callback:function ($$v) {_vm.$set(_vm.payprofform, "land", $$v)},expression:"payprofform.land"}},_vm._l((_vm.countryData),function(country,index){return _c('el-option',{key:index,attrs:{"label":country,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"telefonnummer","prop":"telefonnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"8","placeholder":"Tel.(8 cifre)","clearable":""},model:{value:(_vm.payprofform.telefonnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "telefonnummer", _vm._n($$v))},expression:"payprofform.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefon contry code","id":"telcountrycode","prop":"telcountrycode"}},[_c('el-input',{staticClass:"white-background",attrs:{"placeholder":"+45","clearable":""},model:{value:(_vm.payprofform.telcountrycode),callback:function ($$v) {_vm.$set(_vm.payprofform, "telcountrycode", _vm._n($$v))},expression:"payprofform.telcountrycode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"CPR nummer","id":"cprnummer","prop":"cprnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"10","placeholder":"XXXXXXXXXX","clearable":""},model:{value:(_vm.payprofform.cprnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "cprnummer", $$v)},expression:"payprofform.cprnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Sprog","id":"sprog","prop":"sprog"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","placeholder":"sprog","clearable":""},model:{value:(_vm.payprofform.sprog),callback:function ($$v) {_vm.$set(_vm.payprofform, "sprog", $$v)},expression:"payprofform.sprog"}},_vm._l((_vm.languagesData),function(language,index){return _c('el-option',{key:index,attrs:{"label":language,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Betalingsmiddel","id":"currency","prop":"currency"}},[_c('el-select',{staticClass:"white-background",attrs:{"filterable":"","clearable":"","placeholder":"DKK"},model:{value:(_vm.payprofform.currency),callback:function ($$v) {_vm.$set(_vm.payprofform, "currency", $$v)},expression:"payprofform.currency"}},[_c('el-option',{attrs:{"vlabel":"DKK","value":"DKK"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Iban","id":"partneriban","prop":"partneriban"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"22","placeholder":"DKXXXXXXXXXXXXXXXXXX","clearable":""},model:{value:(_vm.partneriban),callback:function ($$v) {_vm.partneriban=$$v},expression:"partneriban"}})],1),_vm._v(" "),(_vm.ibanmessage)?_c('label',{staticClass:"error red h5 small"},[_vm._v(_vm._s(_vm.ibanmessage))]):_vm._e()],1)])])],1)],1)],1)])]),_vm._v(" "),_c('b-modal',{ref:"confirmPayproff",attrs:{"centered":"","hide-footer":"","id":"confirmPayproff","no-close-on-backdrop":true,"size":"lg"},model:{value:(_vm.confirmPayproff),callback:function ($$v) {_vm.confirmPayproff=$$v},expression:"confirmPayproff"}},[_c('div',{staticClass:"col-12 flex justify-end items-center pt1 p0 mx-auto modal-header"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background"},[_c('div',{staticClass:"flex flex-column items-start col-12 pb3 pt1 px3"},[_c('p',{staticClass:"muted-color h6 pt1"},[_vm._v("Er du en politisk udsat person? (PEP)")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold py1 mt1"},[_vm._v("Hvad er en politisk eksponeret person?")]),_vm._v(" "),_c('p',{staticClass:"h6 mt1 center"},[_vm._v("Jeg bekræfter og siger sandfærdigt, som om jeg var under ed, at:")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start my2"},[[_c('el-radio',{attrs:{"label":true},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Ja")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Nej")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"flex "},[_c('button',{staticClass:" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-back pr1"}),_vm._v("Tilbage\n          ")]),_vm._v(" "),_c('button',{staticClass:"mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.verifyIban('')}}},[_vm._v("Send "),_c('i',{staticClass:"pl1 el-icon-right"})])])]),_vm._v(" "),_c('b-modal',{ref:"termspopup",attrs:{"centered":"","hide-header":"","size":"lg","hide-footer":"","id":"termspopup"},model:{value:(_vm.termspopup),callback:function ($$v) {_vm.termspopup=$$v},expression:"termspopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.termspopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px"},attrs:{"src":_vm.termslink,"frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('b-modal',{ref:"TermsNewPopup",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"TermsNewPopup","size":"large"},model:{value:(_vm.TermsNewPopup),callback:function ($$v) {_vm.TermsNewPopup=$$v},expression:"TermsNewPopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background p2 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){_vm.TermsNewPopup = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-center items-center py2 mb2"},[_c('div',{staticClass:"m0 h6 darkblue px3",domProps:{"innerHTML":_vm._s(_vm.termspopupText)}})])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3 "},[_vm._v("Udkast til Kontrakt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"signature-pad col-12 height-full",attrs:{"id":"signature-pad"}},[_c('div',{staticClass:"signature-pad--body"},[_c('canvas',{staticStyle:{"touch-action":"none","user-select":"none"},attrs:{"width":"540","height":"290"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1563 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_main_tak_vue__ = __webpack_require__(1565);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618f90c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_main_tak_vue__ = __webpack_require__(1566);
function injectStyle (ssrContext) {
  __webpack_require__(1564)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_main_tak_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_618f90c7_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_main_tak_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1564 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1565 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-main_tak',
  data: function data() {
    return {
      loading: false,
      projectid: '',
      contactid: '',
      parentID: '',
      contracttype: '',
      projecttitle: ''
    };
  },
  created: function created() {
    this.projectid = this.$route.query.projectId;
    this.contactid = this.$route.query.contactID;
    this.parentID = this.$route.query.parentID;
    this.contracttype = this.$route.query.contracttype;
    this.projecttitle = this.$route.query.projecttitle;
  },

  methods: {
    gotodashboard: function gotodashboard() {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.projectid + '&contactID=' + this.contactid + '&parentID=' + this.parentID + '&contracttype=' + this.contracttype + '&projecttitle=' + this.projecttitle);
    }
  },
  watch: {}
});

/***/ }),
/* 1566 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-main-viewer"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix max-width-3 mx-auto mt3"},[_c('div',{staticClass:"col-12 mt2 px0 flex flex-column justify-center items-center"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"71.243","height":"71.243","viewBox":"0 0 71.243 71.243"}},[_c('path',{attrs:{"id":"Icon_awesome-check-circle","data-name":"Icon awesome-check-circle","d":"M71.805,36.184A35.621,35.621,0,1,1,36.184.563,35.621,35.621,0,0,1,71.805,36.184ZM32.064,55.045,58.492,28.616a2.3,2.3,0,0,0,0-3.25l-3.25-3.25a2.3,2.3,0,0,0-3.25,0L30.439,43.67,20.376,33.607a2.3,2.3,0,0,0-3.25,0l-3.25,3.25a2.3,2.3,0,0,0,0,3.25L28.813,55.045a2.3,2.3,0,0,0,3.25,0Z","transform":"translate(-0.563 -0.563)","fill":"#63d768"}})])]),_vm._v(" "),_c('p',{staticClass:"h2 semi-bold line-height-2 my3 center "},[_vm._v("Success! Entreprisekontrakten er nu underskrevet!")]),_vm._v(" "),_c('p',{staticClass:"h5 regular line-height-2 my3 center mediumgrey"},[_vm._v("Kunden er blevet underrettet om den underskrevne aftale. Vi anbefaler, at du først starter op på projektet, når du har modtaget en skriftlig bekræftelse på, at betalingen er overført til deponeringskontoen hos PayProff.")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column p0 m0 "},[_c('span',{staticClass:"regular font12 p0"},[_vm._v("\n            For at se status og administrere dine projekter, besøg:\n          ")]),_vm._v(" "),_c('button',{staticClass:"p2 px3 my1 action-button rounded",on:{"click":function($event){return _vm.gotodashboard()}}},[_c('span',[_vm._v("Projektadministration")])])]),_vm._v(" "),_c('div',{staticClass:"py3"})])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1567 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_mainv2_vue__ = __webpack_require__(1569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbfd461c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_mainv2_vue__ = __webpack_require__(1570);
function injectStyle (ssrContext) {
  __webpack_require__(1568)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_mainv2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fbfd461c_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_mainv2_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1568 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1569 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue2_simplert__);






/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-mainv2',
  components: {
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_2_vue_pdf_app___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_3_vue2_simplert___default.a
  },
  data: function data() {
    return {
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 3130899,
      haaId: localStorage.getItem('haaid'),
      salesPersonbitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      showMobile: false,
      info: [],
      pdf: [],
      page: 1,
      historypage: '',
      comments: [],
      textarea: [],
      activeName: 'Comment',
      loaded: 1,
      activepage: 0,
      filteredcomments: [],
      commentmanagementloading: true,
      stepsarr: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    this.historypage = localStorage.getItem('pdfjs.history');
    this.getProjectDetails();
  },
  mounted: function mounted() {},

  watch: {
    'pdf.page': function pdfPage(newVal, oldVal) {
      var _this = this;

      this.activepage = newVal;
      setTimeout(function () {
        _this.filtercommentsbyId(newVal);
      }, 200);
    }
  },
  methods: {
    showcontract: function showcontract() {
      var searchInput = document.querySelectorAll('[data-page-number]');
      var searchinputpage = [];
      var thisthisvarvar = this;
      searchInput.forEach(function (a) {
        if (a.className === 'page') {
          searchinputpage.push(a);
        }
      });
      searchinputpage.forEach(function (a, index) {
        if (a.className === 'page') {
          a.addEventListener('mouseup', function () {
            var text = window.getSelection().toString();
            if (text !== '') {
              thisthisvarvar.addComment(index + 1, text);
            }
          });
        }
      });
    },
    getContract: function getContract() {
      var _this2 = this;

      var projectid = this.$route.query.projectId;
      var latestproject = [];
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contracts', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          latestproject = res.data.CONTRACTS.filter(function (a) {
            return a.PROJECT.ID === parseInt(projectid);
          });
          _this2.contractdetails = latestproject[latestproject.length - 1];
          _this2.contractID = _this2.contractdetails.ID;
          _this2.contractpdflink = '/static/pdf/sample.pdf';
          _this2.homeownerID = _this2.contractdetails.CONTACT;
          _this2.getContractComments();
        } else {
          _this2.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this2.getContract();
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this2.refreshtoken();
          setTimeout(function () {
            _this2.getContract();
          }, 1000);
        }
      });
    },
    getProjectDetails: function getProjectDetails() {
      var _this3 = this;

      var projectid = this.$route.query.projectId;
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.contractID = res.data.CONTRACT_ID;
          _this3.contractStatus = res.data.CONTRACT_STATUS;
          _this3.homeownerID = res.data.HOMEOWNER.ID;
          _this3.getContractByProjectId();
        } else {
          _this3.$message({
            type: 'error',
            message: res.message
          });
          _this3.loading = false;
        }
      }, function (response) {
        _this3.loading = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this3.refreshtoken();
          setTimeout(function () {
            _this3.getProjectDetails();
          }, 1000);
        } else {
          _this3.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getContractByProjectId: function getContractByProjectId() {
      var _this4 = this;

      this.commentmanagementloading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.contractdetails = res.data;
          _this4.comments = res.data.COMMENTS.reverse();
          _this4.contractID = _this4.contractdetails.ID;
          _this4.contractpdflink = '/static/pdf/sample.pdf';
          var thisvar = _this4;
          res.data.COMMENTS.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this4.loaded === 1) {
            setTimeout(function () {
              _this4.showcontract();
            }, 3000);
          }
          _this4.loaded = 2;
          _this4.filtercommentsbyId(_this4.activepage);
          _this4.loading = false;
          _this4.commentmanagementloading = false;
          _this4.getContractSteps();
        } else {
          _this4.$message({
            type: 'error',
            message: res.message
          });
          _this4.loading = false;
        }
      }, function (response) {
        _this4.loading = false;
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this4.refreshtoken();
          setTimeout(function () {
            _this4.getContractByProjectId();
          }, 1000);
        } else {
          _this4.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getContractComments: function getContractComments() {
      var _this5 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/comments/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.comments = res.data.reverse();
          var thisvar = _this5;
          _this5.comments.forEach(function (a, index) {
            thisvar.comments[index]['fromdb'] = true;
            thisvar.textarea[index] = a.COMMENTS;
          });
          if (_this5.loaded === 1) {
            setTimeout(function () {
              _this5.showcontract();
            }, 5000);
          }
          _this5.loaded = 2;
          _this5.loading = false;
        } else {
          _this5.$message({
            type: 'error',
            message: res.message
          });
          _this5.loading = false;
        }
      }, function (response) {
        if (response.body.message === 'Unauthorized. User has been logged out.') {
          _this5.refreshtoken();
          setTimeout(function () {
            _this5.getContractComments();
          }, 1000);
        } else {
          _this5.$message({
            type: 'error',
            message: response.body.message
          });
        }
      });
    },
    getContractSteps: function getContractSteps() {
      var documents = [];
      var steps = [];
      var stepsvalue = [];
      documents = this.contractdetails.DOCUMENTS[this.contractdetails.DOCUMENTS.length - 1];
      steps = documents.JSON_STEPS;
      var arrsteps = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(steps);
      arrsteps.forEach(function (a) {
        var arrfield = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_entries___default()(a);
        arrfield[arrfield.length - 1].forEach(function (h) {
          if ((typeof h === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(h)) === 'object') {
            h['fields'].forEach(function (n) {
              if (n.field !== 0) {
                var tempvalue = {
                  key: h.key,
                  value: n.default_value
                };
                stepsvalue.push(tempvalue);
                tempvalue = [];
              }
            });
          }
        });
      });

      this.stepsarr = stepsvalue;
    },
    getStepbycontent: function getStepbycontent(content) {
      this.stepsarr.forEach(function (l) {
        if (l.value.toString().includes(content)) {
          return l;
        } else {
          return false;
        }
      });
    },
    saveComment: function saveComment(item, index) {
      var _this6 = this;

      var step = item.TITLE;
      var page = item.PAGE;
      var highlighttext = item.HIGHLIGHTED_TEXT;
      var desccomment = this.textarea[index];
      this.$confirm('Er du sikker på, at du vil gemme denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var headers = {
          Authorization: 'Bearer ' + _this6.salesPersonbitrix
        };
        var data = {};
        _this6.$http.post(_this6.$bitrixapi + 'partner/contract/comments?contractId=' + _this6.contractID + '&title=' + step + '&comments=' + desccomment + '&page=' + page + '&highlightedText=' + highlighttext + '&contactId=' + _this6.homeownerID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this6.$refs.simplert.openSimplert(obj);
          }
          _this6.getContractByProjectId();
        }, function (err) {
          _this6.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    addComment: function addComment(page, selectedtext) {
      var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

      var haaid = localStorage.getItem('haaid');
      var stepno = this.getStepbycontent(selectedtext);
      if (stepno) {
        step = stepno.key;
      }
      var commentdetails = {
        'HIGHLIGHTED_TEXT': selectedtext,
        'COMMENTS': '',
        'PAGE': page,
        'TITLE': step,
        'STATUS': 'pending',
        'CONTRACT_ID': this.contractID,
        'CONTACT_ID': this.homeownerID,
        'COMPANY_ID': haaid,
        'fromdb': false
      };
      this.comments.unshift(commentdetails);
      this.filteredcomments.unshift(commentdetails);
      var thisvar = this;
      this.comments.forEach(function (a, index) {
        thisvar.comments[index]['fromdb'] = a.fromdb;
        thisvar.textarea[index] = a.COMMENTS;
      });
      this.filteredcomments.forEach(function (b, index) {
        thisvar.filteredcomments[index]['fromdb'] = b.fromdb;
        thisvar.textarea[index] = b.COMMENTS;
      });
      commentdetails = [];
    },
    confirmcontract: function confirmcontract() {
      var _this7 = this;

      this.$confirm('Er du sikker på, at du vil synge denne kontrakt', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this7.loading = true;
        setTimeout(function () {
          var obj = {
            title: 'Gennemført!',
            message: 'Success',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this7.$refs.simplert.openSimplert(obj);
          _this7.loading = false;
          setTimeout(function () {
            _this7.$router.push('/customer-projects/project-dashboard');
          }, 2000);
        }, 2000);
      }).catch(function () {});
    },
    deletecommentarray: function deletecommentarray(item) {
      this.comments.splice(this.comments.indexOf(item), 1);
      this.textarea.splice(this.textarea.indexOf(item.COMMENTS), 1);
      this.getContractByProjectId();
    },
    deletecomment: function deletecomment(item) {
      var _this8 = this;

      this.$confirm('Er du sikker på, at du vil slette denne kommentar', {
        confirmButtonText: 'Okay',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        _this8.commentmanagementloading = true;
        var headers = {
          Authorization: 'Bearer ' + _this8.salesPersonbitrix
        };
        var data = {};
        _this8.$http.post(_this8.$bitrixapi + 'partner/contract/comments/' + item.ID + '/delete', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (response.body.success) {
            var obj = {
              title: 'Gennemført!',
              message: 'Success',
              type: 'success',
              customCloseBtnText: 'Luk'
            };
            _this8.$refs.simplert.openSimplert(obj);
            _this8.getContractByProjectId();
          }
        }, function (err) {
          _this8.$message({
            type: 'error',
            message: err.body.message
          });
        });
      }).catch(function () {});
    },
    filtercommentsbyId: function filtercommentsbyId(page) {
      var filtered = [];
      var thisthisvar = this;
      filtered = this.comments.filter(function (a) {
        return a.PAGE === page;
      });
      filtered.forEach(function (b, index) {
        if (b.HIGHLIGHTED_TEXT !== null && b.HIGHLIGHTED_TEXT !== '') {
          thisthisvar.hightlighttext(b.HIGHLIGHTED_TEXT);
        }
        thisthisvar.textarea[index] = b.COMMENTS;
      });
      this.filteredcomments = filtered;
    },
    hightlighttext: function hightlighttext(text) {
      var textactula = document.querySelectorAll('[data-page-number="' + this.activepage + '"] > .textLayer > span');
      textactula.forEach(function (z) {
        var Special = /[\\[{().+?|^&]/g;
        if (z.innerHTML.includes(text)) {
          var textvalue = z.innerHTML;
          if (Special.test(textvalue)) {
            textvalue = textvalue.replace(Special, '\\$&');
          }
          var regExp = new RegExp(text, 'gi');
          z.innerHTML = z.textContent.replace(regExp, '<marker>$&</marker>');
        }
      });
    },
    refreshtoken: function refreshtoken() {
      var _this9 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/refreshToken', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          localStorage.setItem('id_token_portalbitrix', res.data.NEW_TOKEN);
          _this9.salesPersonbitrix = res.data.NEW_TOKEN;
        } else {
          console.log('something is wrong with refreshing the token');
          _this9.$router.push('/login');
        }
      }, function (response) {
        console.log('something is wrong with refreshing the token');
        location.reload();
        _this9.$router.push('/login');
      });
    },
    pagesRenderedHandler: function pagesRenderedHandler(pdfapp) {
      this.pdf = pdfapp;
      this.activepage = pdfapp.page;
      var thisvar = this;
      this.pdf.bindEvents('pagechanging', function (a) {
        thisvar.page = a.page;
      });
    }
  }
});

/***/ }),
/* 1570 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-main"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix "},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',[_vm._m(1)]):_c('div',[_c('p',{staticClass:" darkblue font14 col-12 m0 p0"},[_vm._v("Fremhæv den tekst, du vil kommentere")]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column col-12 m0 pb2 p0 commentdiv",staticStyle:{"gap":"10px"}},[_c('div',{staticClass:"highlights border md-col-9 lg-col-9 xs-col-12 mp0 overflow-auto "},[_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"height":"95%","overflow":"auto"}},[_c('vue-pdf-app',{staticClass:"pointer",attrs:{"pdf":_vm.contractpdflink},on:{"pages-rendered":_vm.pagesRenderedHandler}})],1)]),_vm._v(" "),_c('div',{staticClass:"highlights border lg-col-3 md-col-3 xs-col-12 p2 commentdiv "},[_c('el-tabs',{model:{value:(_vm.activeName),callback:function ($$v) {_vm.activeName=$$v},expression:"activeName"}},[_c('el-tab-pane',{attrs:{"label":"Bekræft kontrakt","name":"Confirm"}},[_c('div',{staticClass:"flex p2"},[_c('button',{staticClass:"action-button not-rounded mx-auto flex col-lg-12 col-md-12 col-sm-12 p1 mt2 justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.confirmcontract()}}},[_c('span',{staticClass:"font14 m0 semi-bold"},[_vm._v("UNDERSKREVET"),_c('i',{staticClass:"el-icon-right"})])])])]),_vm._v(" "),_c('el-tab-pane',{attrs:{"label":"Kommentarhåndtering","name":"Comment"}},[(_vm.commentmanagementloading)?_c('div',[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])]):_c('div',{staticClass:"flex flex-column m0 p0"},[(_vm.comments.length < 1)?_c('div',{staticClass:"h5 p2 center mt3"},[_vm._v("For at kommentere, klik venligst på den side, hvor du vil kommentere")]):_vm._e(),_vm._v(" "),_vm._l((_vm.filteredcomments),function(comment,index){return _c('div',{key:comment.id,staticClass:"h6 border p2 darkblue flex flex-column"},[_c('div',{staticClass:"flex col-12 m0 p0"},[(comment.fromdb)?_c('p',{staticClass:"mr-auto font14 regular m0"},[_vm._v("Comment on Page "+_vm._s(comment.PAGE))]):_c('p',{staticClass:"mr-auto font14 regularm0"},[_vm._v("New Comment on Page "+_vm._s(comment.PAGE))]),_vm._v(" "),_c('p',{class:comment.STATUS === 'Approved' ? 'green ml-auto font14 semi-bold m0' : 'primarycolor ml-auto font14 m0 semi-bold'},[_vm._v(_vm._s(comment.STATUS))])]),_vm._v(" "),(comment.HIGHLIGHTED_TEXT !== '' && comment.HIGHLIGHTED_TEXT !== null)?_c('div',{staticClass:"flex justify-center items-center pt2 col-12 p0 m0"},[_c('p',{staticClass:"primarycolor"},[_vm._v("\""+_vm._s(comment.HIGHLIGHTED_TEXT)+"\"")])]):_vm._e(),_vm._v(" "),_c('el-input',{attrs:{"disabled":comment.fromdb,"type":"textarea","autosize":{ minRows: 4, maxRows: 6},"placeholder":"Pls specify the section no"},model:{value:(_vm.textarea[index]),callback:function ($$v) {_vm.$set(_vm.textarea, index, $$v)},expression:"textarea[index]"}}),_vm._v(" "),_c('div',{staticClass:"col-12 p0 m0 flex mt1 mx-auto "},[(!comment.fromdb)?_c('button',{staticClass:"primary-button mr-auto not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletecommentarray(comment)}}},[_c('span',{staticClass:"font12 m0"},[_c('i',{staticClass:"el-icon-back"},[_vm._v(" Afbestille")])])]):_c('button',{staticClass:"primary-button mr-auto not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.deletecomment(comment)}}},[_c('span',{staticClass:"font12 m0"},[_c('i',{staticClass:"el-icon-back"},[_vm._v(" Skjule")])])]),_vm._v(" "),(!comment.fromdb)?_c('button',{staticClass:"ml-auto action-button not-rounded flex col-lg-5 col-md-5 col-sm-5 p1 justify-center items-center",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveComment(comment,index)}}},[_c('span',{staticClass:"font12 m0"},[_vm._v("Submit"),_c('i',{staticClass:"el-icon-right"})])]):_vm._e()])],1)})],2)])],1),_vm._v(" "),_c('div',{staticClass:"py3 sm-hide lg-hide md-hide"})],1)]),_vm._v(" "),_c('div',{staticClass:"py3"})])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3 "},[_vm._v("UDKAST KONTRAKT")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1571 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_draft_vue__ = __webpack_require__(1573);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1838f842_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_draft_vue__ = __webpack_require__(1574);
function injectStyle (ssrContext) {
  __webpack_require__(1572)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_draft_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1838f842_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_draft_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1572 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1573 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_simplert__);









var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-draft',
  components: {
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_5_vue_pdf_app___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_6_vue2_simplert___default.a,
    Loading: Loading
  },
  data: function data() {
    return {
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 0,
      haaid: localStorage.getItem('haaid'),
      salesPersonbitrix: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      showMobile: false,
      info: [],
      activeWizard: null,
      contractWizardsData: [],
      selectedContractTemplateInfo: {},
      contractWizardStepsData: [],
      selectedContractTemplateId: '',
      startIndex: 0,
      dynamicTabSubmitted: false,
      currentProjectData: {},
      selectedmainTemplateId: null,
      tab1Form: {
        firstName: localStorage.getItem('name').split(' ')[0],
        lastName: localStorage.getItem('name').split(' ')[1],
        address: localStorage.getItem('address'),
        zip: Number(localStorage.getItem('zipcode')),
        city: localStorage.getItem('city'),
        telphone: Number(localStorage.getItem('partnerTelefon')),
        email: localStorage.getItem('email'),
        partnerCvr: Number(localStorage.getItem('Cvrnr')),
        partnerName: localStorage.getItem('CompanyName'),
        howmownerName: '',
        howmowneremal: '',
        howmownerphone: '',
        howmownerID: '',
        cvrInfo: {},
        cvrInfoLoading: false,
        submitted: false
      },
      tab1formRules: {
        firstName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        lastName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        address: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zip: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        city: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telphone: [{
          required: true,
          type: 'number',
          min: 1,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        partnerCvr: [{
          required: true,
          type: 'number',
          min: 1,
          max: 99999999,
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }],
        partnerName: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit firmanavn',
          trigger: 'blur'
        }]
      },
      tab2Form: {
        price: undefined,
        priceIsSwitched: false,
        invoiceWorK: '',
        invoiceWorKIsSwitched: false,
        recalculationIsSwitched: false,
        paymentStagesData: [{
          price: undefined,
          title: '',
          description: '',
          deadline: ''
        }],
        submitted: false
      },
      officialEnterpriseArr: {},
      selectedOfferInfoArr: [],
      total: null,
      normalContractPaymentStage: {},
      mainwizarproductarr: [],
      paymentStages: [],
      parentID: '',
      contractType: '',
      childprojects: [],
      primaryproductindustryname: {},
      itemsjobindustry: {},
      STEPactualValue: {},
      maintotal: null,
      jobList: []
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    if (localStorage.getItem('address') === null || localStorage.getItem('city') === null) {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger');
      this.$router.push('/login');
    } else {
      this.getProjectDetails();
    }
    this.getallwizardproduct();
    this.gettaskbitrix();
    this.parentID = this.$route.query.parentID;
    this.contractType = this.$route.query.contracttype;
    this.industryID = this.$route.query.industryID;
    this.offerType = this.$route.query.offertype;
    this.childprojects = JSON.parse(this.$route.query.childprojects);
    this.tab1Form.telphone = localStorage.getItem('partnerTelefon');
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
  },
  mounted: function mounted() {},

  methods: {
    getProjectDetails: function getProjectDetails() {
      var _this = this;

      var projectid = this.$route.query.projectId;
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.scrollTo('pagetitle');
          _this.currentProjectData = res.data;
          _this.contractID = res.data.CONTRACT_ID;
          _this.contractStatus = res.data.CONTRACT_STATUS;
          _this.homeownerID = res.data.HOMEOWNER.ID;
          _this.jobList = res.data.JOBS_LIST;
          _this.tab1Form.address = res.data.ADDRESS.ADDRESS;
          _this.tab1Form.howmownerName = res.data.HOMEOWNER.NAME;
          _this.tab1Form.howmowneremal = res.data.HOMEOWNER.EMAIL;
          _this.tab1Form.howmownerphone = res.data.HOMEOWNER.MOBILE;
          _this.tab1Form.howmownerID = res.data.HOMEOWNER.ID;

          _this.getOfferAcceptedOffer(res.data.ID);
        } else {
          _this.$message({
            type: 'error',
            message: res.message
          });
          _this.loading = false;
        }
      }, function (response) {
        _this.loading = false;
        _this.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getOfferAcceptedOffer: function getOfferAcceptedOffer(projectId) {
      var _this2 = this;

      var calculationid = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        projectId: projectId,
        status: 'accepted'
      };
      this.$http.get(this.$bitrixapi + 'partner/offers?status=accepted', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this2.selectedOfferInfoArr = res.filter(function (c) {
          return c.PROJECT_ID === Number(projectId);
        });
        _this2.getAcceptedOfferPrice(projectId, _this2.selectedOfferInfoArr[0].ACCEPTED_ENTERPRISE_INDUSTRY_IDS, Number(_this2.selectedOfferInfoArr[0]['PARTNER_PROFILE'].ID), Number(_this2.selectedOfferInfoArr[0]['ID']), calculationid);
      }, function (response) {
        _this2.loading = false;
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getAcceptedOfferPrice: function getAcceptedOfferPrice(projectId, industryid, partnerid, offerid) {
      var _this3 = this;

      var calculationid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;

      var proID = null;
      if (this.contractType === 'Hovedentreprise') {
        proID = projectId;
      } else {
        proID = this.parentID;
      }
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPriceMinboligV2?contact_id=' + this.selectedOfferInfoArr[0].HOMEOWNER.ID + '&project_id=' + proID + '&calculation_id=' + calculationid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        var result = [];
        if (_this3.contractType === 'Hovedentreprise') {
          res.result.forEach(function (l) {
            if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && l.JOB_INDUSTRY !== '1062') {
              result.push(l);
            } else if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && l.JOB_INDUSTRY === 1062 && _this3.jobList.length === 1) {
              result.push(l);
            }
            _this3.totalmain += Number(l.TOTAL_VAT_FEE);
          });
        } else {
          res.result.forEach(function (l) {
            if (Number(l.PARTNER_ID) === partnerid && Number(l.OFFER_ID) === Number(offerid) && Number(l.SUB_PROJECT_ID) === Number(projectId)) {
              result.push(l);
            }
            _this3.totalmain += Number(l.TOTAL_VAT_FEE);
          });
        }
        _this3.getContractTemplate();
        var resultArr = {};
        var paymentstage = {};
        result.forEach(function (o) {
          paymentstage = {
            'project_id': null,
            'partner_id': null,
            'contact_id': null,
            'calculation_id': 0,
            'industry_id': null,
            'job_industry_id': null,
            'total': null,
            'totalvat': null,
            'sub_project_id': null,
            'note': null,
            'signature': null,
            'weeks': null,
            'contract_type': 'normal',
            'start_date': null,
            'offer_id': null
          };
          if (resultArr[o.INDUSTRY]) {
            resultArr[o.INDUSTRY].push(o);
          } else {
            resultArr[o.INDUSTRY] = [];
            resultArr[o.INDUSTRY].push(o);
          }
          paymentstage = {
            'project_id': o.PROJECT_ID,
            'partner_id': o.PARTNER_ID,
            'contact_id': o.CONTACT_ID,
            'calculation_id': 0,
            'industry_id': o.INDUSTRY,
            'job_industry_id': o.JOB_INDUSTRY,
            'price_total': o.TOTAL,
            'sub_project_id': o.SUB_PROJECT_ID,
            'vat_total': o.TOTALVAT,
            'note': o.NOTE,
            'signature': o.SIGNATURE,
            'weeks': o.WEEKS,
            'contract_type': 'normal',
            'start_date': o.START_DATE,
            'offer_id': o.OFFER_ID,
            'description_payment': []
          };
          if (o.SERIES !== null) {
            __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(o.SERIES).forEach(function (j) {
              paymentstage['description_payment'].push(j);
            });
          } else {
            o.SERIES = o.SERIES_ORIGINAL;
            o.SERIES_ORIGINAL.forEach(function (j) {
              paymentstage['description_payment'].push(j);
            });
          }
          _this3.total += Number(o.TOTALVAT);
          _this3.paymentStages.push(paymentstage);
        });
        _this3.getinsuranceamount();
        _this3.officialEnterpriseArr = resultArr;
      }, function (response) {
        _this3.loading = false;
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getdataforpriceadd_normal: function getdataforpriceadd_normal() {
      var datasavePriceEachIndustry = [];
      this.officialEnterpriseArr.forEach(function (industry) {
        var dataSavePrice = {};
        dataSavePrice = {
          project_id: industry.PROJECT_ID,
          contact_id: industry.CONTACT_ID,
          calculation_id: 0,
          industry_id: industry.INDUSTRY,
          total: industry.TOTAL,
          note: industry.NOTE,
          signature: industry.SIGNATURE,
          weeks: industry.WEEKS,
          start_date: industry.START_DATE,
          offer_id: industry.OFFER_ID,
          partner_id: industry.PARTNER_ID
        };
        for (var key in industry.SERIES) {
          if (key !== '' && key !== 'date') {
            dataSavePrice['1_' + key] = industry.SERIES[key];
          }
        }
        for (key in industry.SERIES_TEXT) {
          if (key !== '' && key !== 'date') {
            dataSavePrice[key] = industry.SERIES_TEXT[key];
          }
        }
        datasavePriceEachIndustry.push(dataSavePrice);
      });
      return datasavePriceEachIndustry;
    },
    getContractTemplate: function getContractTemplate() {
      var _this4 = this;

      var contractValue = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100000;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/ContractInfoV2?contractValue=' + contractValue + '&OfferID=' + this.selectedOfferInfoArr[0].ID + '&wholeEnterprise=0&companyId=' + this.haaid + '&HomeownerID=' + this.currentProjectData.HOMEOWNER.ID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.contractWizardsData.push(res.data.contract);
          _this4.selectedContractTemplateInfo = res.data.contract;
          _this4.selectedContractTemplateId = res.data.contract.TEMPLATE_ID;
          _this4.getContractWizardSteps();
          _this4.loading = false;
        } else {
          _this4.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getContractInfo: function getContractInfo() {
      var _this5 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this5.contractInfo = res.data;
        var latestDocumentInfo = _this5.contractInfo.DOCUMENTS[_this5.contractInfo.DOCUMENTS.length - 1];
        _this5.selectedContractTemplateInfo = _this5.contractWizardsData;
        _this5.selectedContractTemplateId = _this5.contractWizardsData[0].TEMPLATE_ID;
        _this5.selectedmainTemplateId = _this5.contractWizardsData[0].ID;
        _this5.selectedContractTemplateInfo.STEPS = latestDocumentInfo.JSON_STEPS;
        _this5.getContractWizardSteps();
      }, function (response) {
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    submitcontracteach: function submitcontracteach() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var subproject, contractsubmit, thisvar, closeFn, obj;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.t0 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.keys(_this6.paymentStages);

              case 1:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 10;
                  break;
                }

                subproject = _context.t1.value;
                _context.next = 5;
                return _this6.submitContractInfoeach(_this6.paymentStages[subproject]);

              case 5:
                contractsubmit = _context.sent;

                if (contractsubmit) {
                  _context.next = 8;
                  break;
                }

                return _context.abrupt('return', false);

              case 8:
                _context.next = 1;
                break;

              case 10:
                if (contractsubmit) {
                  _context.next = 14;
                  break;
                }

                _this6.loading = false;

                _this6.$nextTick(function () {
                  var wizardTabLists = document.querySelectorAll('#contractWizard .wizard-nav-pills li');
                  wizardTabLists.forEach(function (tabListProp, tabListPropIndex) {
                    tabListProp.querySelector('a').classList.remove('disabled');
                    tabListProp.querySelector('.wizard-icon-circle').classList.add('checked');
                  });
                });
                return _context.abrupt('return');

              case 14:
                thisvar = _this6;

                closeFn = function closeFn() {
                  this.$router.push('/customer-projects/project-dashboard?projectId=' + thisvar.currentProjectData.ID + '&contactID=' + thisvar.selectedOfferInfoArr[0].HOMEOWNER.ID + '&parentID=' + thisvar.parentID + '&industryID=' + thisvar.industryID + '&offertype=' + thisvar.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(thisvar.childprojects) + '&contracttype=' + thisvar.contractType + '&projecttitle=' + thisvar.currentProjectData.NAME);
                };

                obj = {
                  title: 'Gennemført!',
                  message: '',
                  type: 'success',
                  customCloseBtnText: 'Luk',
                  onClose: closeFn
                };

                _this6.$refs.simplert.openSimplert(obj);

              case 18:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    submitContractInfoeach: function submitContractInfoeach(subproject) {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var headers = {
          Authorization: 'Bearer ' + _this7.salesPersonbitrix
        };
        var data = {
          projectId: subproject.sub_project_id,
          templateId: Number(_this7.selectedContractTemplateId),
          contractTemplateId: Number(_this7.selectedmainTemplateId),
          contactId: _this7.currentProjectData.HOMEOWNER.ID,
          steps: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(_this7.contractWizardsData[0].STEPS),
          comments: '',
          title: _this7.currentProjectData.NAME,
          name: _this7.tab1Form.firstName,
          lastname: _this7.tab1Form.lastName,
          address: _this7.tab1Form.address,
          zipcode: _this7.tab1Form.zip,
          email: _this7.tab1Form.email,
          mobile: _this7.tab1Form.telphone.toString(),
          city: _this7.tab1Form.city,
          parentContractId: _this7.contractID,
          contractLabel: 'normal',
          source: 'web',
          totalpricewithvatandfee: _this7.maintotal,
          paymentStages: _this7.paymentStages
        };
        for (var each in _this7.STEPactualValue) {
          data[each] = _this7.STEPactualValue[each];
        }
        _this7.$http.post(_this7.$bitrixapi + 'partner/contract', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          resolve(true);
        }, function (response) {
          _this7.$message({
            type: 'error',
            message: response.body.message
          });
        });
      });
    },
    submitContractInfo: function submitContractInfo() {
      var _this8 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        projectId: this.currentProjectData.ID,
        templateId: Number(this.selectedContractTemplateId),
        contractTemplateId: Number(this.selectedmainTemplateId),
        contactId: this.currentProjectData.HOMEOWNER.ID,
        steps: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(this.contractWizardsData[0].STEPS),
        comments: '',
        title: this.currentProjectData.NAME,
        name: this.tab1Form.firstName,
        lastname: this.tab1Form.lastName,
        address: this.tab1Form.address,
        zipcode: this.tab1Form.zip,
        email: this.tab1Form.email,
        mobile: this.tab1Form.telphone.toString(),
        city: this.tab1Form.city,
        parentContractId: this.contractID,
        contractLabel: 'normal',
        source: 'web',
        totalpricewithvatandfee: this.maintotal,
        paymentStages: this.paymentStages
      };
      for (var each in this.STEPactualValue) {
        data[each] = this.STEPactualValue[each];
      }
      this.$http.post(this.$bitrixapi + 'partner/contract', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var m = _this8;
        var closeFn = function closeFn() {
          this.$router.push('/customer-projects/project-dashboard?projectId=' + m.currentProjectData.ID + '&contactID=' + m.selectedOfferInfoArr[0].HOMEOWNER.ID + '&parentID=' + m.parentID + '&industryID=' + m.industryID + '&offertype=' + m.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()(m.childprojects) + '&contracttype=' + m.contractType + '&projecttitle=' + m.currentProjectData.NAME);
        };
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk',
          onClose: closeFn
        };
        _this8.$refs.simplert.openSimplert(obj);
      }, function (response) {
        _this8.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    contractTemplateChanged: function contractTemplateChanged() {
      var _this9 = this;

      this.loading = true;
      this.selectedContractTemplateInfo = this.contractWizardsData.filter(function (wizardProp) {
        return wizardProp.TEMPLATE_ID === _this9.selectedContractTemplateId;
      })[0];
      this.$refs.contractWizard.changeTab(0, 0);
      this.getContractTemplate();
    },
    wizardChanged: function wizardChanged(prevIndex, nextIndex) {
      this.activeWizard = nextIndex + 1;
    },
    getContractWizardSteps: function getContractWizardSteps() {
      this.contractWizardStepsData = [];
      var step = {};
      step['fields'] = {};
      var templateSteps = this.selectedContractTemplateInfo.STEPS;
      for (var steps in templateSteps) {
        step = templateSteps[steps];
        var fieldsData = [];
        for (var fields in step.fields) {
          var stepField = step.fields[fields];
          fieldsData.push(stepField);
        }
        step['fields'] = fieldsData;
        this.contractWizardStepsData.push(step);
      }
      this.activeWizard = 1;
      this.loading = false;
    },
    validateDynamicTabs: function validateDynamicTabs() {
      this.dynamicTabSubmitted = true;
      var activeTab = this.$refs.contractDraftWizard;
      var activeTabIndex = activeTab.activeTabIndex + 1;
      var activeTabElement = document.querySelector('.contractTab-' + activeTabIndex);
      var isTabLastStep = activeTab.isLastStep;
      var isFieldsHasNoAnswer = false;

      var fields = activeTabElement.querySelectorAll('.fields-id-value.required');
      fields.forEach(function (fieldProp) {
        var fieldValue = fieldProp.id.split('_')[1].split('-')[1];
        if (fieldValue === '' || fieldValue === 'null' || fieldValue === 'undefined') {
          isFieldsHasNoAnswer = true;
        }
      });
      var valid = null;
      if (isFieldsHasNoAnswer) {
        valid = false;
      } else {
        valid = true;
        this.scrollTo('contractDraftWizard');
      }
      if (isTabLastStep) {
        if (valid) {
          this.loading = true;
          this.tab2Form.submitted = false;
          this.getValuesSteps();
        }
      }
      return true;
    },
    getValuesSteps: function getValuesSteps() {
      var stepsobject = {};
      this.contractWizardStepsData.forEach(function (item) {
        item.fields.forEach(function (l) {
          if (l.field_name) {
            stepsobject[l.field_name] = l.default_value;
          }
        });
      });
      this.STEPactualValue = stepsobject;
      if (this.contractType === 'Fagentreprise') {
        this.submitcontracteach();
      } else {
        this.submitContractInfo();
      }
    },
    calculateFee: function calculateFee() {
      var _this10 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      var amount = this.total;

      this.$http.post(this.$bitrixapi + 'partner/payproff/calculateFee?amount=' + amount, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this10.finishWizard();
      }, function (err) {
        _this10.$refs.errorMsg.showMsg(err);
      });
    },
    getinsuranceamount: function getinsuranceamount() {
      var _this11 = this;

      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        totalpriceinclVAT: parseFloat(this.total).toString()
      };
      this.$http.post(this.$bitrixapi + 'integration/InsuranceSettings', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res.FEEINAMOUNT > 0) {
          _this11.maintotal = parseInt(_this11.total) + res.FEEINAMOUNT;
        } else {
          _this11.maintotal = parseInt(_this11.total);
        }
      }, function (response) {
        var error = response.body.message;
        _this11.$message({
          type: 'error',
          message: error
        });
      });
    },
    validateTab1: function validateTab1() {
      var error = 0;
      this.$refs['wizardtab1'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return false;
      }
      return true;
    },
    validateTab2: function validateTab2() {
      return true;
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this12 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this12.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this12.$message.error(error);
      });
    },
    scrollTo: function scrollTo(elementId) {
      var element = document.getElementById(elementId);
      element.scrollIntoView({ behavior: 'smooth' });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this13 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this13.itemsjobindustry = industryname;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    }
  }
});

/***/ }),
/* 1574 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-draft"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix "},[_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"height-100vh"},[_c('Loading')],1):_c('div',{staticClass:"contract-wizard"},[_c('div',{staticClass:"py1"}),_vm._v(" "),_c('form-wizard',{ref:"contractDraftWizard",attrs:{"id":"contractDraftWizard","start-index":_vm.startIndex,"shape":"circle","color":"rgba(25, 163, 192, 1.0)","error-color":"rgba(207,0,15,1.0)","step-size":"sm","finishButtonText":"Bekræft"},on:{"on-change":_vm.wizardChanged},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"py3"}),_vm._v(" "),_c('div',{staticClass:"flex col-12 p0 m0"},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-primary-button h5 semi-bold m0 line-height-4 regular button-padding px3 py2",on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button h5 semi-bold m0 line-height-4 regular button-padding px3 py2 ml-auto",attrs:{"disabled":_vm.activeWizard === 2 && _vm.$route.query.fastTrackType === 'contract'},on:{"click":function($event){return props.nextTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(!props.isLastStep ? 'Næste' : 'Indsend'))])])])]}}])},[_c('tab-content',{staticClass:"contractTab-1 px3",attrs:{"title":"Dine Info","before-change":_vm.validateTab1}},[_c('el-form',{ref:"wizardtab1",attrs:{"model":_vm.tab1Form,"rules":_vm.tab1formRules}},[_c('p',{staticClass:"h2 darkblue semi-bold line-height-2 mt2"},[_vm._v("1. Aftaleparter")]),_vm._v(" "),_c('div',{staticClass:"py2"},[_c('p',{staticClass:"h5 darkblue semi-bold line-height-2 my2"},[_vm._v("Håndværker")]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('el-form-item',{staticClass:"col-6 p0 pr1 xs-po",attrs:{"label":"Fornavn","prop":"firstName"}},[_c('el-input',{model:{value:(_vm.tab1Form.firstName),callback:function ($$v) {_vm.$set(_vm.tab1Form, "firstName", $$v)},expression:"tab1Form.firstName"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"col-6 p0 pl1 xs-p0",attrs:{"label":"Efternavn","prop":"lastName"}},[_c('el-input',{model:{value:(_vm.tab1Form.lastName),callback:function ($$v) {_vm.$set(_vm.tab1Form, "lastName", $$v)},expression:"tab1Form.lastName"}})],1)],1),_vm._v(" "),_c('el-form-item',{attrs:{"label":"Adresse","prop":"address"}},[_c('el-select',{staticClass:"col-12 p0 addressSelect",attrs:{"filterable":"","no-match-text":'no_data',"no-data-text":'no_data'},model:{value:(_vm.tab1Form.address),callback:function ($$v) {_vm.$set(_vm.tab1Form, "address", $$v)},expression:"tab1Form.address"}},[_c('el-option',{attrs:{"value":_vm.tab1Form.address}},[_c('span',{staticClass:"darkblue left"},[_vm._v(_vm._s(_vm.tab1Form.address))]),_vm._v(" "),_c('span',{staticClass:"darkblue right"},[_c('el-tooltip',{attrs:{"content":'primary_address',"placement":"top","effect":"light"}},[_c('img',{staticClass:"ml2",attrs:{"src":"@/assets/images/svg/shop-dark.svg","width":"20"}})])],1)])],1)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"col-6 pl0 pr1"},[_c('el-form-item',{attrs:{"label":"Postnummer","prop":"zip"}},[_c('el-input',{staticClass:"col-12 p0",attrs:{"min":1,"controls":false},model:{value:(_vm.tab1Form.zip),callback:function ($$v) {_vm.$set(_vm.tab1Form, "zip", _vm._n($$v))},expression:"tab1Form.zip"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"col-6 pl1 pr0"},[_c('el-form-item',{attrs:{"label":"By","prop":"city"}},[_c('el-input',{model:{value:(_vm.tab1Form.city),callback:function ($$v) {_vm.$set(_vm.tab1Form, "city", $$v)},expression:"tab1Form.city"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('el-form-item',{staticClass:"col-6 p0 pr1 xs-p0",attrs:{"label":"Telefon","prop":"telphone"}},[_c('el-input',{staticClass:"col-12 p0",attrs:{"maxlength":"8","controls":false},model:{value:(_vm.tab1Form.telphone),callback:function ($$v) {_vm.$set(_vm.tab1Form, "telphone", _vm._n($$v))},expression:"tab1Form.telphone"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"col-6 p0 pl1 xs-p0",attrs:{"label":"E-mail","prop":"email"}},[_c('el-input',{model:{value:(_vm.tab1Form.email),callback:function ($$v) {_vm.$set(_vm.tab1Form, "email", $$v)},expression:"tab1Form.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('el-form-item',{staticClass:"col-6 p0 pr1 xs-p0",attrs:{"label":"CVR","prop":"partnerCvr"}},[_c('el-input',{staticClass:"col-12 p0",attrs:{"min":1,"maxlength":"8","controls":false},model:{value:(_vm.tab1Form.partnerCvr),callback:function ($$v) {_vm.$set(_vm.tab1Form, "partnerCvr", _vm._n($$v))},expression:"tab1Form.partnerCvr"}})],1),_vm._v(" "),_c('el-form-item',{staticClass:"col-6 p0 pl1 xs-p0",attrs:{"label":"Firmanavn","prop":"partnerName"}},[_c('el-input',{model:{value:(_vm.tab1Form.partnerName),callback:function ($$v) {_vm.$set(_vm.tab1Form, "partnerName", $$v)},expression:"tab1Form.partnerName"}})],1)],1),_vm._v(" "),_c('div',[_c('p',{staticClass:"h5 darkblue semi-bold line-height-2 my2"},[_vm._v("Forbruger")]),_vm._v(" "),_c('div',[_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.tab1Form.howmownerName))]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.tab1Form.howmowneremal))]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.tab1Form.howmownerphone))]),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v(_vm._s(_vm.tab1Form.howmownerID))])])])],1)])],1),_vm._v(" "),_vm._l((_vm.contractWizardStepsData),function(wizard,index){return _c('tab-content',{key:index,class:'contractTab-' + (index + 2),attrs:{"title":_vm.contractWizardStepsData.length > 5 ? wizard.label.length >= 10 ? wizard.label.substring(0, 10) + '...' : wizard.label : wizard.label.length >= 30 ? wizard.label.substring(0, 30) + '...' : wizard.label,"before-change":_vm.validateDynamicTabs}},[_c('p',{staticClass:"h2 darkblue semi-bold line-height-2 mb3"},[_vm._v(_vm._s(index + 3)+". "+_vm._s(wizard.Info))]),_vm._v(" "),_vm._l((wizard.fields),function(wizField,index1){return _c('div',{key:index1,staticClass:"mb4"},[_c('p',{staticClass:"m0"},[_c('label',{domProps:{"innerHTML":_vm._s(wizField.label.replace('{fee}', _vm.tab2Form.paymentStagesData.reduce(function (n, ref) {
	var price = ref.price;

	return n + price;
}, 0)))}}),_vm._v(" "),(wizField.mandatory == 1)?_c('span',{staticClass:"red"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(wizField.help)?_c('el-tooltip',{attrs:{"placement":"top","effect":"light"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"m0",domProps:{"innerHTML":_vm._s(wizField.help)}})]),_vm._v(" "),_c('i',{staticClass:"shakespeare el-icon-info ml1"})]):_vm._e()],1),_vm._v(" "),(wizField.field == 2 && wizField.number == 0)?_c('el-input',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 2 && wizField.number == 1)?_c('el-input-number',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"placeholder":wizField.place_holder,"controls":false,"min":0},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 3)?_c('el-radio-group',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"fill":"#19A3C0"},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-radio',{key:optionIndex,attrs:{"label":option}},[_vm._v(_vm._s(option))])}),1):(wizField.field == 4)?_c('el-checkbox-group',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"fill":"#19A3C0"},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-checkbox',{key:optionIndex,attrs:{"label":option}})}),1):(wizField.field == 5)?_c('el-slider',{staticClass:"fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"max":parseInt(10),"step":1},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 7)?_c('div',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value}},[_c('el-select',{staticClass:"col-12 p0",attrs:{"placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-option',{key:optionIndex,attrs:{"label":option,"value":option}})}),1)],1):(wizField.field == 8)?_c('div',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}})],1):(wizField.field == 9)?_c('el-rate',{staticClass:"fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"high-threshold":10,"low-threshold":1,"max":10,"icon-classes":_vm.iconClasses,"void-icon-class":"el-icon-remove-outline","colors":_vm.colorClasses},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 10)?_c('el-date-picker',{staticClass:"col-12 p0",attrs:{"type":"date","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):_vm._e()],1)})],2)})],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"xs-hide py4"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center",attrs:{"id":"pagetitle"}},[_c('p',{staticClass:"h1 regular line-height-2 my3 "},[_vm._v("UDKAST KONTRAKT")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1575 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_extrawork_addon_vue__ = __webpack_require__(1577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aa8afa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_extrawork_addon_vue__ = __webpack_require__(1578);
function injectStyle (ssrContext) {
  __webpack_require__(1576)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_contract_extrawork_addon_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e1aa8afa_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_contract_extrawork_addon_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1576 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1577 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_pdf_app__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vue2_simplert__);








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'contract-addon',
  components: {
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_4_vue_pdf_app___default.a,
    Simplert: __WEBPACK_IMPORTED_MODULE_5_vue2_simplert___default.a
  },
  data: function data() {
    return {
      projectID: '',
      contractID: 11,
      contractStatus: '',
      contractpdflink: '/static/pdf/sample.pdf',
      contractdetails: [],
      homeownerID: 3130899,
      haaId: '',
      salesPersonbitrix: '',
      loading: false,
      showMobile: false,
      info: [],
      activeWizard: null,
      contractWizardsData: [],
      selectedContractTemplateInfo: {},
      contractWizardStepsData: [],
      selectedContractTemplateId: '',
      startIndex: 0,
      dynamicTabSubmitted: false,
      currentProjectData: {},
      selectedmainTemplateId: null,
      paymentstage: [],
      parentID: '',
      contractType: '',
      industryID: [],
      submittedIndustries: [],
      offerType: '',
      childprojects: [],
      total: 0
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
    this.projectID = this.$route.query.projectId;
    this.homeownerID = this.$route.query.contactID;
    this.haaId = localStorage.getItem('haaid');
    this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
    if (localStorage.getItem('address') === null || localStorage.getItem('city') === null) {
      this.$message.error('Log venligst på igen for at opdatere dine tilbudsoplysninger');
      this.$router.push('/login');
    } else {
      this.getProjectDetails();
      this.getContractTemplate();
    }
  },
  mounted: function mounted() {
    this.parentID = this.$route.query.parentID;
    this.contractType = this.$route.query.contracttype;
    this.industryID = this.$route.query.industryID;
    this.childprojects = JSON.parse(this.$route.query.childprojects);
    this.submittedIndustries = JSON.parse(this.$route.query.submittedindustry);
    this.offerType = this.$route.query.offertype;
  },

  methods: {
    getProjectDetails: function getProjectDetails() {
      var _this = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this.currentProjectData = res.data;
          _this.contractID = res.data.CONTRACT_ID;
          _this.contractStatus = res.data.CONTRACT_STATUS;
          _this.homeownerID = res.data.HOMEOWNER.ID;
          _this.createPaymentsage();
        } else {
          _this.$message({
            type: 'error',
            message: res.message
          });
          _this.loading = false;
        }
      }, function (response) {
        _this.loading = false;
        _this.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getContractTemplate: function getContractTemplate() {
      var _this2 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract_templates?contractValue=100000', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.contractWizardsData.push(res.data.result[2]);
          _this2.getContractInfo();
        } else {
          _this2.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getContractInfo: function getContractInfo() {
      var _this3 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.contractInfo = res.data;
        var latestDocumentInfo = _this3.contractInfo.DOCUMENTS[_this3.contractInfo.DOCUMENTS.length - 1];
        _this3.selectedContractTemplateInfo = _this3.contractWizardsData;
        _this3.selectedContractTemplateId = _this3.contractWizardsData[0].TEMPLATE_ID;
        _this3.selectedmainTemplateId = _this3.contractWizardsData[0].ID;
        _this3.selectedContractTemplateInfo.STEPS = latestDocumentInfo.JSON_STEPS;
        _this3.getContractWizardSteps();
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getdatafrominput: function getdatafrominput() {
      var _this4 = this;

      this.contractWizardStepsData.forEach(function (item) {
        item.fields.forEach(function (l) {
          if (l.default_value) {
            if (l.label === 'Dato for ændringen') {
              _this4.paymentstage[0].start_date = l.default_value;
            }
            if (l.label === 'Hvad forandres i den forrige kontrakt') {
              _this4.paymentstage[0].description_payment[0] = l.default_value;
            }
            if (l.label === 'Ny deadline') {
              _this4.paymentstage[0].end_date = l.default_value;
            }
            if (l.label === 'Hvordan forandres prisen?') {
              _this4.paymentstage[0].price_total = l.default_value;
            }
          }
        });
      });
    },
    createPaymentsage: function createPaymentsage() {
      var paymentstage = {
        'project_id': this.projectID,
        'partner_id': this.haaId,
        'contact_id': this.homeownerID,
        'calculation_id': 0,
        'industry_id': 0,
        'job_industry_id': 0,
        'price_total': 0,
        'sub_project_id': 0,
        'totalpricewithvatandfee': 0,
        'vat_total': 0,
        'note': '',
        'signature': '',
        'weeks': 0,
        'end_date': '',
        'start_date': '',
        'offer_id': 0,
        'transaction_fee': 0,
        'description_payment': [],
        'contract_type': 'extra_work'
      };
      this.paymentstage.push(paymentstage);
    },
    getInsuranceamount: function getInsuranceamount(amount) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var headers = {
          Authorization: 'Bearer ' + _this5.salesPersonbitrix
        };
        var data = {};
        _this5.$http.get(_this5.$bitrixapi + 'integration/InsuranceSettings?totalpriceinclVAT=' + amount, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
          var res = response.body.data;
          resolve(res.FEEINAMOUNT);
        }, function (response) {
          _this5.$message({
            type: 'error',
            message: response.body.message
          });
        });
      });
    },
    submitContractInfo: function submitContractInfo() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var stage, vatamountfee, headers, data;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this6.paymentstage.price_total === 0 || _this6.paymentstage[0].end_date === '' || _this6.paymentstage[0].start_date === '' || _this6.paymentstage[0].description_payment.length < 1)) {
                  _context.next = 3;
                  break;
                }

                _this6.$message({
                  type: 'error',
                  message: 'Alle felter er obligatoriske'
                });
                return _context.abrupt('return', false);

              case 3:
                _context.t0 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.keys(_this6.paymentstage);

              case 4:
                if ((_context.t1 = _context.t0()).done) {
                  _context.next = 14;
                  break;
                }

                stage = _context.t1.value;

                _this6.paymentstage[stage].vat_total = parseFloat(_this6.paymentstage[stage].price_total * 1.25);
                _context.next = 9;
                return _this6.getInsuranceamount(_this6.paymentstage[stage].vat_total);

              case 9:
                vatamountfee = _context.sent;

                if (vatamountfee > 0) {
                  _this6.paymentstage[stage].transaction_fee = vatamountfee;
                  _this6.paymentstage[stage].totalpricewithvatandfee = _this6.paymentstage[stage].vat_total + vatamountfee;
                } else {
                  _this6.paymentstage[stage].totalpricewithvatandfee = _this6.paymentstage[stage].vat_total;
                }
                _this6.total += Number(_this6.paymentstage[stage].totalpricewithvatandfee);
                _context.next = 4;
                break;

              case 14:
                headers = {
                  Authorization: 'Bearer ' + _this6.salesPersonbitrix
                };
                data = {
                  projectId: _this6.currentProjectData.ID,
                  contractLabel: 'extra',
                  contactId: _this6.homeownerID,
                  paymentStages: _this6.paymentstage,
                  price: _this6.total,
                  source: 'web',
                  contractId: _this6.contractID
                };

                _this6.$http.post(_this6.$bitrixapi + 'partner/extra_work', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
                  var obj = {
                    title: 'Gennemført!',
                    message: '',
                    type: 'success',
                    customCloseBtnText: 'Luk'
                  };
                  _this6.$refs.simplert.openSimplert(obj);
                  setTimeout(function () {
                    _this6.$router.push('/customer-projects/project-dashboard?projectId=' + _this6.currentProjectData.ID + '&contactID=' + _this6.homeownerID + '&parentID=' + _this6.parentID + '&industryID=' + _this6.industryID + '&offertype=' + _this6.offerType + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this6.childprojects) + '&submittedindustry=' + __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this6.submittedIndustries) + '&contracttype=' + _this6.contractType + '&projecttitle=' + _this6.projectTitle);
                  }, 2000);
                }, function (response) {
                  _this6.$message({
                    type: 'error',
                    message: response.body.message
                  });
                });

              case 17:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this6);
      }))();
    },
    contractTemplateChanged: function contractTemplateChanged() {
      var _this7 = this;

      this.loading = true;
      this.selectedContractTemplateInfo = this.contractWizardsData.filter(function (wizardProp) {
        return wizardProp.TEMPLATE_ID === _this7.selectedContractTemplateId;
      })[0];
      this.$refs.contractWizard.changeTab(0, 0);
      this.getContractTemplate();
    },
    wizardChanged: function wizardChanged(prevIndex, nextIndex) {
      this.activeWizard = nextIndex + 1;
    },
    getContractWizardSteps: function getContractWizardSteps() {
      this.contractWizardStepsData = [];
      var step = {};
      step['fields'] = {};
      var templateSteps = this.selectedContractTemplateInfo[0].STEPS;
      for (var steps in templateSteps) {
        step = templateSteps[steps];
        var fieldsData = [];
        for (var fields in step.fields) {
          var stepField = step.fields[fields];
          fieldsData.push(stepField);
        }
        step['fields'] = fieldsData;
        this.contractWizardStepsData.push(step);
      }
      this.activeWizard = 1;
      this.loading = false;
    },
    validateDynamicTabs: function validateDynamicTabs() {
      var fieldserror = false;
      this.contractWizardStepsData.forEach(function (item) {
        item.fields.forEach(function (l) {
          if (l.default_value) {
            if (l.default_value) {
              fieldserror = true;
            }
          }
        });
      });
      if (fieldserror) {
        this.$message({
          type: 'error',
          message: 'Alle felter er obligatoriske'
        });
        return false;
      }
      return true;
    }
  }
});

/***/ }),
/* 1578 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix noto-sans darkblue px2 mb4",attrs:{"id":"contract-addon"}},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"clearfix "},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"clearfix ",attrs:{"id":"create-contract"}},[(_vm.loading)?_c('div',{staticClass:"height-100vh"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"contract-wizard"},[_c('div',{staticClass:"py1"}),_vm._v(" "),(_vm.activeWizard == 1)?_c('div',{staticClass:"flex items-center px2 mb4"},[_vm._m(1),_vm._v(" "),_c('el-select',{attrs:{"placeholder":"","filterable":"","no-match-text":'no_data',"no-data-text":'no_data'},on:{"change":function($event){return _vm.contractTemplateChanged()}},model:{value:(_vm.selectedContractTemplateId),callback:function ($$v) {_vm.selectedContractTemplateId=$$v},expression:"selectedContractTemplateId"}},_vm._l((_vm.contractWizardsData),function(template,index){return _c('el-option',{key:index,attrs:{"label":template.NAME,"value":template.TEMPLATE_ID}})}),1)],1):_vm._e(),_vm._v(" "),_c('form-wizard',{ref:"contractWizard",attrs:{"id":"contractWizard","start-index":_vm.startIndex,"shape":"tab","color":"#ffffff"},on:{"on-change":_vm.wizardChanged},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"py3"}),_vm._v(" "),_c('div',{staticClass:"flex justify-between"},[_c('button',{staticClass:"action-button h5 semi-bold m0 line-height-4 regular button-padding px3 ml-auto",attrs:{"id":"maincontractTab"},on:{"click":function($event){return _vm.submitContractInfo()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(!props.isLastStep ? 'next' : 'submit'))])])])]}}])},_vm._l((_vm.contractWizardStepsData),function(wizard,index){return _c('tab-content',{key:index,class:'contractTab-' + (index + 1),attrs:{"title":_vm.contractWizardStepsData.length > 5 ? wizard.label.length >= 10 ? wizard.label.substring(0, 10) + '...' : wizard.label : wizard.label.length >= 30 ? wizard.label.substring(0, 30) + '...' : wizard.label,"before-change":_vm.validateDynamicTabs}},[_c('p',{staticClass:"h2 semi-bold line-height-2 mb3"},[_vm._v(_vm._s(index + 1)+". "+_vm._s(wizard.Info))]),_vm._v(" "),_vm._l((wizard.fields),function(wizField,index1){return _c('div',{key:index1,staticClass:"mb3"},[_c('p',{staticClass:"m0"},[_c('label',{domProps:{"innerHTML":_vm._s(wizField.label)}}),_vm._v(" "),(wizField.mandatory == 1)?_c('span',{staticClass:"red"},[_vm._v("*")]):_vm._e(),_vm._v(" "),(wizField.help)?_c('el-tooltip',{attrs:{"placement":"top","effect":"light"}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('p',{staticClass:"m0",domProps:{"innerHTML":_vm._s(wizField.help)}})]),_vm._v(" "),_c('i',{staticClass:"shakespeare el-icon-info ml1"})]):_vm._e()],1),_vm._v(" "),(wizField.field == 2 && wizField.number == 0)?_c('el-input',{staticClass:"p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 2 && wizField.number == 1)?_c('el-input-number',{staticClass:"p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"placeholder":wizField.place_holder,"controls":false,"min":0},on:{"change":_vm.getdatafrominput},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 3)?_c('el-radio-group',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"fill":"#19A3C0"},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-radio',{key:optionIndex,attrs:{"label":option}},[_vm._v(_vm._s(option))])}),1):(wizField.field == 4)?_c('el-checkbox-group',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"fill":"#19A3C0"},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-checkbox',{key:optionIndex,attrs:{"label":option}})}),1):(wizField.field == 5)?_c('el-slider',{staticClass:"fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"max":parseInt(10),"step":1},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 7)?_c('div',{staticClass:"col-12 p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value}},[_c('el-select',{staticClass:"col-12 p0",attrs:{"placeholder":wizField.place_holder},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}},_vm._l((wizField.values),function(option,optionIndex){return _c('el-option',{key:optionIndex,attrs:{"label":option,"value":option}})}),1)],1):(wizField.field == 8)?_c('div',{staticClass:"p0 fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value}},[_c('el-input',{attrs:{"type":"textarea","rows":3,"placeholder":wizField.place_holder},on:{"change":_vm.getdatafrominput},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}})],1):(wizField.field == 9)?_c('el-rate',{staticClass:"fields-id-value",class:wizField.mandatory == 1 ? 'required' : null,attrs:{"id":'id-' + (index1 + 1) + '_' + 'value-' + wizField.default_value,"high-threshold":10,"low-threshold":1,"max":10,"icon-classes":_vm.iconClasses,"void-icon-class":"el-icon-remove-outline","colors":_vm.colorClasses},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):(wizField.field == 10)?_c('el-date-picker',{staticClass:"col-12 p0",attrs:{"type":"date","format":"yyyy-MM-dd","value-format":"yyyy-MM-dd","placeholder":wizField.place_holder},on:{"change":_vm.getdatafrominput},model:{value:(wizField.default_value),callback:function ($$v) {_vm.$set(wizField, "default_value", $$v)},expression:"wizField.default_value"}}):_vm._e(),_vm._v(" "),(_vm.dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == '' || _vm.dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == null || _vm.dynamicTabSubmitted && wizField.mandatory == 1 && wizField.default_value == undefined)?_c('div',{staticClass:"small red mt1"},[_vm._v("\n                      required\n                    ")]):_vm._e()],1)})],2)}),1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"py4 xs-hide"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3 "},[_vm._v("ARBEJDSSEDLER")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr1"},[_c('p',{staticClass:"h6 mb0"},[_vm._v("Select:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1579 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_extraworklist_vue__ = __webpack_require__(1581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a221821_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_extraworklist_vue__ = __webpack_require__(1582);
function injectStyle (ssrContext) {
  __webpack_require__(1580)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_extraworklist_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a221821_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_extraworklist_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1580 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1581 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_signature_pad__ = __webpack_require__(216);





var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'extraworklist',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler,
    Loading: Loading,
    SignaturePad: __WEBPACK_IMPORTED_MODULE_2_signature_pad__["a" /* default */]
  },
  data: function data() {
    return {
      loading: false,
      haaid: '',
      showMobile: false,
      salesPersonbitrix: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() - -86400000 < Date.now();
        }
      },
      projectId: '',
      contractType: '',
      childprojects: [],
      partnerchildprojects: [],
      deadline: null,
      checked: false,
      incompleteModal: false,
      jobindustryBranch: [],
      itemsjobindustry: {},
      formLoading: false,
      commentloading: false,
      modalimageloading: false,
      addItemForm: {
        branch: [],
        title: '',
        beskrivelse: ''
      },
      addItemFormRules: {
        title: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit title',
          trigger: 'blur'
        }],
        beskrivelse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }],
        branch: [{
          type: 'array',
          required: true,
          message: 'Du bedes indtaste dit tag',
          trigger: 'change'
        }]
      },
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      getExtraWorkList: {},
      isPreApprove: false,
      description: '',
      isFinalApprove: false,
      lastUpdatedBy: '',
      pris: null,
      termspopupmangel: false,
      termsdata: [],
      termslabel: 'Accepter vores betingelser',
      termslink: 'http://www.haandvaerker.dk/om/betingelser',
      signaturePad: '',
      confirmOffer: false,
      confirmTerms: false,
      termsloading: true,
      termslinkablework: 'betingelser',
      editingitem: false,
      signbypartner: false,
      signbyhomeowner: false,
      activeextraID: null,
      currentProjectData: {},
      signatureloading: false,
      extraworkStatus: ''
    };
  },
  watch: {},
  created: function created() {
    var _this = this;

    this.projectId = this.$route.query.projectId;
    this.contractID = this.$route.query.contractId;
    this.contractType = this.$route.query.contracttype ? this.$route.query.contracttype : '';
    this.contactId = this.$route.query.contactId ? this.$route.query.contactId : '';
    this.haaid = localStorage.getItem('haaid');
    this.childprojects = this.$route.query.childprojects ? JSON.parse(this.$route.query.childprojects) : [];
    if (this.childprojects.length > 0) {
      this.childprojects.forEach(function (o) {
        if (o.IS_PARTNER) {
          _this.partnerchildprojects.push(o.ID);
        }
      });
    }
    this.gettaskbitrix();
    this.getextraworkList();
    this.getTermsCondition();
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    displayProjects: function displayProjects() {
      var _this2 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this2.contractType = res.CONTRACT_TYPE;
        _this2.contactId = res.HOMEOWNER.ID;
        _this2.childprojects = res.CHILD_PROJECTS;
        _this2.currentProjectData = res;
      }, function (response) {
        _this2.loading = false;
        var error = response.body;
        _this2.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this3 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          _this3.jobindustryBranch = [];
          res.data.forEach(function (l) {
            var industryBranch = {};
            industryBranch.key = l.BRANCHE_ID;
            industryBranch.value = l.BRANCHE_ID;
            industryBranch.label = l.BRANCHE;
            _this3.jobindustryBranch.push(industryBranch);
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this3.itemsjobindustry = industryname;
        }
      }, function (response) {
        var error = response.body.message;
        _this3.$message({
          type: 'error',
          message: error
        });
      });
    },
    getextraworkList: function getextraworkList() {
      var _this4 = this;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.$http.get(this.$bitrixapi + 'partner/extra_work?size=30&page=1&contractId=' + this.contractID, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var filteredlist = res.data.items.EXTRA_WORKS.filter(function (l) {
            return (l.DATE_SIGNED_BY_CONTACT === '' || l.DATE_SIGNED_BY_PARTNER === '') && (l.STAGE === 'draft' || l.STAGE === 'for_approval');
          });
          _this4.getExtraWorkList = filteredlist[0];
          _this4.deadline = _this4.getExtraWorkList ? _this4.getExtraWorkList.END_DATE : null;
          _this4.signbypartner = _this4.getExtraWorkList && _this4.getExtraWorkList.DATE_SIGNED_BY_PARTNER !== '';
          _this4.signbyhomeowner = _this4.getExtraWorkList && _this4.getExtraWorkList.DATE_SIGNED_BY_CONTACT !== '';
          _this4.lastUpdatedBy = _this4.getExtraWorkList ? _this4.getExtraWorkList.LAST_UPDATED_BY : '';
          _this4.extraworkStatus = _this4.getExtraWorkList ? _this4.getExtraWorkList.STAGE : '';
          _this4.description = _this4.getExtraWorkList ? _this4.getExtraWorkList.DESCRIPTION : '';
          _this4.pris = _this4.getExtraWorkList ? _this4.getExtraWorkList.AMOUNT : 0;
          _this4.activeextraID = _this4.getExtraWorkList ? _this4.getExtraWorkList.ID : null;
        }
        _this4.loading = false;
        _this4.closesignature();
        _this4.displayProjects();
      }, function (response) {
        _this4.loading = false;
        var error = response.body.message;
        _this4.$message({
          type: 'error',
          message: error
        });
      });
    },
    changeenddate: function changeenddate() {
      var _this5 = this;

      this.$confirm('Ønsker du at ændre fristen, vil dette påvirke alle varer på listen?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this5.formLoading = true;
        _this5.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this5.salesPersonbitrix
        };
        var data = {};
        _this5.$http.post(_this5.$bitrixapi + 'partner/project/' + _this5.projectId + '/updateDeficiencyEndDate', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this5.getDefiency(_this5.projectId);
        }, function (response) {
          var error = response.body;
          _this5.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(function () {});
    },
    saveExtrawork: function saveExtrawork(includedapproval) {
      var _this6 = this;

      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        });
        return false;
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        });
        return false;
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        });
        return false;
      }
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        contractId: this.contractID,
        source: 'web',
        price: parseFloat(this.pris),
        endDate: this.deadline,
        description: this.description
      };
      this.$http.post(this.$bitrixapi + 'partner/extra_work', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.ID;
        _this6.getextraworkList();
        _this6.closesignature();
        if (includedapproval) {
          _this6.sendforApproval(res);
        } else {
          var obj = {
            title: 'Gennemført!',
            message: '',
            type: 'success',
            customCloseBtnText: 'Luk'
          };
          _this6.$refs.simplert.openSimplert(obj);
        }
      }, function (response) {
        var error = response.body;
        _this6.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    updateExtrawork: function updateExtrawork() {
      var _this7 = this;

      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        });
        return false;
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        });
        return false;
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        });
        return false;
      }
      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        source: 'web',
        price: parseFloat(this.pris),
        endDate: this.deadline,
        description: this.description
      };
      this.$http.post(this.$bitrixapi + 'partner/extra_work/update/' + this.activeextraID, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data.ID;
        _this7.editingitem = false;
        _this7.sendforApproval(res);
      }, function (response) {
        var error = response.body;
        _this7.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    sendforApproval: function sendforApproval(id) {
      var _this8 = this;

      this.closesignature();
      if (!this.confirmTerms) {
        this.$message.error('Bekræft venligst din tilbudsoversigt');
        return false;
      }
      this.loading = true;
      this.signatureloading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        signaturePng: this.signaturePad.toDataURL(),
        paymentStages: [{
          project_id: this.projectId,
          partner_id: this.haaid,
          contact_id: this.contactId,
          calculation_id: 0,
          industry_id: '0',
          job_industry_id: '0',
          price_total: this.pris,
          sub_project_id: '0',
          vat_total: parseFloat(this.pris * 1.25),
          transaction_fee: '',
          note: '',
          signature: '',
          weeks: '',
          start_date: '',
          end_date: this.deadline,
          contract_type: 'extra_work',
          offer_id: '0',
          description_payment: []
        }]
      };
      this.$http.post(this.$bitrixapi + 'partner/extra_work/' + id + '/approve', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this8.$refs.simplert.openSimplert(obj);
        _this8.getextraworkList();
      }, function (response) {
        _this8.loading = false;
        _this8.signatureloading = false;
        var error = response.body.message;
        _this8.$message({
          type: 'error',
          message: error
        });
      });
    },
    deleteDeficiency: function deleteDeficiency(deficiencyId) {
      var _this9 = this;

      this.$confirm('Hej, er du sikker på, at du vil slette dette element', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this9.formLoading = true;
        _this9.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this9.salesPersonbitrix
        };
        var data = {};
        _this9.$http.post(_this9.$bitrixapi + 'partner/project/' + _this9.projectId + '/deficiency/' + deficiencyId, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this9.formLoading = false;
          _this9.getDefiency(_this9.projectId);
        }, function (response) {
          var error = response.body;
          _this9.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(function () {});
    },
    openEditModal: function openEditModal() {
      this.editincompleteModal = true;
    },
    closeEditincompleteModal: function closeEditincompleteModal(item) {
      this.editincompleteModal = false;
    },
    getTermsCondition: function getTermsCondition() {
      var _this10 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this10.termsdata = res.filter(function (l) {
          return l.TYPE === 'Partner';
        })[0];
        _this10.termslink = _this10.termsdata.LINK;
        var labelarroriginal = _this10.termsdata.LABEL.split(' ');
        var labelarr = _this10.termsdata.LABEL.split(' ');
        labelarr.pop();
        _this10.termslabel = labelarr.join(' ');
        _this10.termslinkablework = labelarroriginal[labelarroriginal.length - 1];
      }, function (response) {
        _this10.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    initiateSignaturepad: function initiateSignaturepad() {
      var _this11 = this;

      setTimeout(function () {
        var canvas = document.querySelector('canvas');
        _this11.signaturePad = new __WEBPACK_IMPORTED_MODULE_2_signature_pad__["a" /* default */](canvas, {
          backgroundColor: 'rgb(255, 255, 255)'
        });
      }, 200);
    },
    closesignature: function closesignature() {
      this.$refs['signaturepopup'].hide();
    },
    clearSignature: function clearSignature() {
      var signature = this.signaturePad;
      signature.clear();
    },
    opensignature: function opensignature() {
      this.initiateSignaturepad();
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        });
        return false;
      }
      if (this.description === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst en beskrivelse af arbejdet'
        });
        return false;
      }
      if (this.pris === null || this.pris < 1) {
        this.$message({
          type: 'error',
          message: 'Indtast venligst pris'
        });
        return false;
      }
      this.$refs['signaturepopup'].show();
    },
    gotodashboard: function gotodashboard() {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.currentProjectData.ID + '&contactID=' + this.currentProjectData.HOMEOWNER.ID + '&parentID=' + this.currentProjectData.PARENT_ID + '&industryID=' + this.currentProjectData.ENTERPRISE_INDUSTRY + '&offertype=' + this.currentProjectData.OFFER_TYPE + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentProjectData.CHILD_PROJECTS) + '&contracttype=' + this.currentProjectData.CONTRACT_TYPE + '&projecttitle=' + this.currentProjectData.NAME);
    }
  }
});

/***/ }),
/* 1582 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px3 notosans darkblue mx2",attrs:{"id":"mangellist"}},[_c('div',{staticClass:"mt2 pointer",on:{"click":function($event){return _vm.gotodashboard()}}},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex col-12 p0 mobile-flex-column"},[_c('div',{staticClass:"clearfix flex ml-auto items-center xs-gap-10 gap-20"},[((_vm.getExtraWorkList || _vm.extraworkStatus !== 'approved') && _vm.extraworkStatus !== '')?_c('p',{staticClass:"h5 flex items-center py1 rounded",on:{"click":function($event){_vm.editingitem = !_vm.editingitem}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"pl2 darkblue"},[_vm._v("Redigere")])]):_vm._e()])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('Loading')],1):_c('div',{staticClass:"flex flex-column "},[_c('div',{staticClass:"darkblue-background px3 m0 col-12 flex white justify-end items-center py1 rounded light-highlights"},[_c('p',{staticClass:"white p0 m0"},[_vm._v("Deadline: ")]),_vm._v(" "),(_vm.getExtraWorkList && !_vm.editingitem)?_c('p',{staticClass:"semi-bold h5 mx2"},[_vm._v(_vm._s(_vm.moment(_vm.deadline).locale('da').format('LL')))]):_c('el-date-picker',{staticClass:"px0 white-background mx2 rounded",attrs:{"size":"large","format":"yyyy/MM/dd","value-format":"yyyy-MM-dd","type":"date","placeholder":"start","picker-options":_vm.pickerOptions},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}})],1),_vm._v(" "),(_vm.getExtraWorkList && !_vm.editingitem)?_c('div',{},[_c('div',{key:_vm.index,staticClass:"border light-highlights p3 flex col-12 p0"},[_c('p',{staticClass:"p0 m0 h5"},[_vm._v(_vm._s(_vm.getExtraWorkList.DESCRIPTION))]),_vm._v(" "),_c('div',{staticClass:"ml-auto p0 m0"},[_vm._v(_vm._s(Number(_vm.getExtraWorkList.AMOUNT).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:0})))])]),_vm._v(" "),_c('div',{staticClass:"py2 m0 ml-auto flex justify-end mt2 items-center gap-10"},[(_vm.lastUpdatedBy === 'homeowner')?_c('button',{staticClass:"dark-button p2 rounded",on:{"click":function($event){return _vm.opensignature(_vm.getExtraWorkList.ID)}}},[_c('span',{staticClass:"font12 center"},[_vm._v("Godkende")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"py4"})]):_c('div',[_c('div',{staticClass:"border light-highlights p2 flex flex-column"},[_c('div',{staticClass:"px3 mt1 flex flex-column mb2"},[_c('el-input',{staticClass:"border",attrs:{"autosize":{ minRows: 4, maxRows: 6 },"type":"textarea","placeholder":"Arbejdsbeskrivelse"},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('el-input',{staticClass:"white-background ml-auto mt2 col-2 m0 p0",attrs:{"type":"nummber","placeholder":"pris"},model:{value:(_vm.pris),callback:function ($$v) {_vm.pris=_vm._n($$v)},expression:"pris"}})],1)]),_vm._v(" "),_c('div',{staticClass:"p0 m0 ml-auto flex justify-end mt2 items-center gap-10"},[(!_vm.editingitem)?_c('p',{staticClass:"semi-bold m0 pointer",on:{"click":function($event){return _vm.saveExtrawork(false)}}},[_vm._v("Gem som kladde")]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"dark-button p2 rounded",on:{"click":function($event){return _vm.opensignature()}}},[(!_vm.editingitem)?_c('span',{staticClass:"font12 center"},[_vm._v("Gem & send til håndværker")]):_c('span',{staticClass:"font12 center"},[_vm._v("Opdatere & send til håndværker")])])])])]),_vm._v(" "),_c('b-modal',{ref:"signaturepopup",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"signaturepopup"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closesignature()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),(_vm.signatureloading)?_c('div',{staticClass:"col-12"},[_c('Loading')],1):_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","height":"95%","overflow":"auto"}},[_c('div',{staticClass:"flex col-12 p0"},[_c('p',{staticClass:"darkblue"},[_vm._v("Underskriv her")]),_vm._v(" "),_c('button',{staticClass:"white-backgroud px2 red border red-border ml-auto",attrs:{"id":"clear-button"},on:{"click":function($event){return _vm.clearSignature()}}},[_vm._v("RYD")])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0 border muted-border mx-auto",attrs:{"id":"signature-control"}},[_c('div',{staticClass:"signature-pad col-12 height-full",attrs:{"id":"signature-pad"}},[_c('div',{staticClass:"signature-pad--body"},[_c('canvas',{staticStyle:{"touch-action":"none","user-select":"none"},attrs:{"width":"664","height":"339"}})])])])]),_vm._v(" "),_c('div',{staticClass:"col-12 p0 flex items-center my2"},[_c('p',{staticClass:"mr-auto p0 py2 m0 h6"},[_c('el-checkbox',{staticClass:"saveSignature",model:{value:(_vm.confirmTerms),callback:function ($$v) {_vm.confirmTerms=$$v},expression:"confirmTerms"}},[_c('span',{staticClass:"pointer"},[_vm._v(_vm._s(_vm.termslabel))]),_c('span',{staticClass:"primarycolor semi-bold pl1",on:{"click":function($event){_vm.termspopupmangel = true}}},[_vm._v(_vm._s(_vm.termslinkablework))])])],1),_vm._v(" "),(!_vm.editingitem && _vm.lastUpdatedBy === 'homeowner')?_c('button',{staticClass:" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendforApproval(_vm.activeextraID)}}},[_vm._v("\n        Godkende\n      ")]):(!_vm.editingitem && _vm.lastUpdatedBy === '')?_c('button',{staticClass:" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){return _vm.saveExtrawork(true)}}},[_vm._v("\n        Godkende\n      ")]):(_vm.editingitem)?_c('button',{staticClass:" ml-auto action-button button-padding border-none not-rounded h5 regular line-height-1 p2",attrs:{"type":"button"},on:{"click":function($event){return _vm.updateExtrawork(_vm.activeextraID)}}},[_vm._v("\n        Godkende\n      ")]):_vm._e()])]),_vm._v(" "),_c('b-modal',{ref:"termspopupmangel",attrs:{"centered":"","hide-header":"","size":"lg","hide-footer":"","id":"termspopupmangel"},model:{value:(_vm.termspopupmangel),callback:function ($$v) {_vm.termspopupmangel=$$v},expression:"termspopupmangel"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.termspopupmangel = false}}},[_c('span',[_c('i',{staticClass:"el-icon-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 relative",staticStyle:{"width":"100%","height":"95%"}},[_c('iframe',{staticStyle:{"overflow":"hidden","padding":"10px","overflow-x":"hidden","overflow-y":"hidden","height":"100%","width":"100%","position":"absolute","top":"0px","left":"0px","right":"0px","bottom":"0px","background-color":"#ffff"},attrs:{"src":_vm.termslink,"frameborder":"0","height":"100%","width":"100%"}})])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt2 my3"},[_c('p',{staticClass:"h3 col-12 line-height-golden bold p0"},[_vm._v("Ekstra arbejde")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('i',{staticClass:"h5 darkblue m0 el-icon-circle-plus-outline"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1583 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projekt_billeder_vue__ = __webpack_require__(1585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dcf546_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projekt_billeder_vue__ = __webpack_require__(1586);
function injectStyle (ssrContext) {
  __webpack_require__(1584)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_projekt_billeder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_28dcf546_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_projekt_billeder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1584 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1585 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      projectID: '',
      contactID: '',
      haaId: '',
      salesPersonbitrix: '',
      tenderFolderID: '',
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      selectedtender: '',
      projectAddress: '',
      tenderQA: false,
      productlistforpricearr: [],
      primaryproductindustryname: {},
      tagsData: [],
      productTags: [],
      questions: '',
      projectTitle: '',
      allquestionsanswerArr: [],
      defaultallquestionsanswerArr: [],
      disableaddbutton: false,
      selectedIndustryDesc: {
        industryid: '',
        industrydesc: ''
      },
      innerloading: false,
      replayanswer: '',
      alldescriptionidwithreply: [],
      viewer: {},
      serviceUrl: '',
      partnerName: '',
      documentPath: '',
      publicFiles: [],
      seletecdfolder: 'default',
      parent_tenderID: '',
      selectedFolder: '',
      insideFolder: ''
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer';
    this.projectID = this.$route.query.projectID;
    this.contactID = this.$route.query.contact_id;
    this.tenderFolderID = this.$route.query.tenderFolderID;
    this.parent_tenderID = this.$route.query.parent_tenderID;
    this.projectTitle = this.$route.query.title;
    this.partnerName = localStorage.getItem('name');
    this.projectAddress = this.$route.query.address;
    this.haaId = localStorage.getItem('haaid');
    this.getallwizardproduct();
    this.displaytenderFiles(this.parent_tenderID);
    this.getQuestionsAnswers();
    this.getPublicFiles();
  },

  methods: {}
});

/***/ }),
/* 1586 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"TenderFolder"}},[_c('div',{staticClass:"mt2 pointer"},[_c('i',{staticClass:"el-icon-back",on:{"click":function($event){return _vm.gotomenikunder()}}})]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"mt3 "},[_c('ol',{staticClass:"breadcrumb transparent px0 mb-0"},_vm._l((_vm.parentFolderData),function(folder,index){return _c('li',{key:index,staticClass:"h6 breadcrumb-item pointer",on:{"click":function($event){return _vm.folderChange(folder.folderId, folder.folderName, _vm.currentFolderParentId, index, 'out')}}},[_c('a',[_vm._v(_vm._s(folder.folderName))])])}),0)]),_vm._v(" "),(_vm.insideFolder !== 'in')?_c('p',{staticClass:"m0 h6 col-12 flex justify-start my2"},[_vm._v("Udbudsmappe")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap pb4 mt1"},_vm._l((_vm.documentsData),function(item,index){return (_vm.insideFolder !== 'in')?_c('div',{key:index,staticClass:"pointer mx2 flex flex-column border light-highlights p2 px3"},[(item.TYPE !== 'folder')?_c('div',{staticClass:"flex flex-column"},[_c('el-tooltip',{attrs:{"content":item.NAME,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"pdf_ic","width":"55","height":"75","viewBox":"0 0 55 75"}},[_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z","transform":"translate(-28.492 -31.709)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z","transform":"translate(0 0)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z","transform":"translate(-32.976 -134.449)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z","transform":"translate(-58.222 -134.456)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z","transform":"translate(-83.969 -134.456)","fill":"#134553"}})])])]),_vm._v(" "),_c('span',{staticClass:"darkblue center"},[_vm._v("File "+_vm._s(index + 1))])],1):_vm._e(),_vm._v(" "),(item.TYPE === 'folder')?_c('div',{staticClass:"flex flex-column",on:{"click":function($event){return _vm.folderChange(item.ID, item.NAME, item.PARENT_ID, index,'in')}}},[_c('el-tooltip',{attrs:{"content":item.NAME,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"40.282","height":"36.354","viewBox":"0 0 40.282 36.354"}},[_c('path',{attrs:{"id":"Folder","d":"M4.6,36.354A4.253,4.253,0,0,1,.9,34.082a7.7,7.7,0,0,1-.882-2.146L0,31.859V3.8A3.564,3.564,0,0,1,1.181.942a5.182,5.182,0,0,1,3.761-.9h9.721l3.916,5.9h4.984a.75.75,0,1,1,0,1.5H17.774l-3.917-5.9H4.829l-.059-.01a3.784,3.784,0,0,0-2.62.552A2.115,2.115,0,0,0,1.5,3.8V31.69c.121.465.914,3.164,3.1,3.164H35.623c.414-.076,3.159-.668,3.159-3.178V10.452c-.022-.275-.3-3.066-2.736-3.066H31.17a.75.75,0,0,1,0-1.5h4.876A3.854,3.854,0,0,1,39.686,8.2a6.335,6.335,0,0,1,.594,2.181l0,.043V31.676a4.316,4.316,0,0,1-2.295,3.87,6.764,6.764,0,0,1-2.192.8l-.055.008ZM26.915,7.319A.8.8,0,0,1,27.22,5.78a.8.8,0,1,1,0,1.6A.8.8,0,0,1,26.915,7.319Z","transform":"translate(0 0)","fill":"#19a3c0"}})])])]),_vm._v(" "),_c('span',{staticClass:"darkblue center"},[_vm._v(_vm._s(item.NAME))])],1):_vm._e()]):_vm._e()}),0)]),_vm._v(" "),_c('b-modal',{ref:"tenderQA",staticClass:"p-2 pb-4",attrs:{"id":"tenderQA","hide-footer":"","hide-header":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.tenderQA),callback:function ($$v) {_vm.tenderQA=$$v},expression:"tenderQA"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closetenderqa()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"flex xs-flex-column darkblue"},[_c('div',{staticClass:"flex flex-column lg-col-7 md-col-7 xs-col-12 p0"},[(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"p2 overflow-auto projectdesccontainer"},[_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('span',[_c('i',{staticClass:"el-icon-printer pointer"})]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-download pointer"})])])]),_vm._v(" "),_c('div',{staticClass:"bordercece p3"},_vm._l((_vm.productlistforpricearr),function(item,index){return _c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + ' ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((item.industrydetails),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 deschover"},[_c('p',{staticClass:"flex m0 pl1"},[_c('span',{staticClass:"p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(parseInt(index + 1) + '.')+_vm._s(index2 + 1))]),_vm._v(" "),_c('span',{staticClass:"pl1 p0 m0 h6 line-height-golden graymuteddark"},[_vm._v(_vm._s(job.DESCRIPTION))]),_vm._v(" "),_c('span',{staticClass:"ml-auto addquestionicon pr1",attrs:{"id":job.ID}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"View replies","placement":"top-start"}},[(Number(_vm.getnoreplybydescId(job.ID, item.industryid) > 0))?_c('span',{staticClass:"small pointer",on:{"click":function($event){return _vm.selectDescIndustry(item.industryid, job.ID)}}},[_vm._v(_vm._s(Number(_vm.getnoreplybydescId(job.ID, item.industryid)) > 1 ? _vm.getnoreplybydescId(job.ID, item.industryid) + ' answers' : _vm.getnoreplybydescId(job.ID, item.industryid) + ' answer'))]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add question","placement":"top-start"}},[_c('i',{staticClass:"el-icon-chat-dot-square pointer",on:{"click":function($event){return _vm.addastags(item.industryid)}}})])],1)])])})],2)}),0)])]),_vm._v(" "),_c('div',{staticClass:"p2 boder md-col-5 lg-col-5 xs-col-12 pb3"},[_c('div',{},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Tilføj pørgsmål")]),_vm._v(" "),_c('el-form',[_c('el-select',{staticClass:"col-12 p0 capital border tagSelect mb1",attrs:{"multiple":"","filterable":"","multiple-limit":5,"placeholder":"Tags"},model:{value:(_vm.productTags),callback:function ($$v) {_vm.productTags=$$v},expression:"productTags"}},_vm._l((_vm.tagsData),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),_c('el-form-item',{staticClass:"border-none p0 ",attrs:{"label":"","prop":"questions"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"type":"textarea","rows":3,"placeholder":"Spørgsmål"},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex p0"},[_c('button',{staticClass:"dark-button p2 px3 not-rounded ml-auto",attrs:{"disabled":_vm.disableaddbutton},on:{"click":function($event){return _vm.addquestion()}}},[_vm._v("Tilføj spørgsmål")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-end p0 m0 mt3"},[(_vm.defaultallquestionsanswerArr.length !== _vm.allquestionsanswerArr.length && _vm.allquestionsanswerArr.length > 0)?_c('p',{staticClass:"p0 m0 small pointer",on:{"click":function($event){return _vm.showall()}}},[_vm._v("Show All")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"overflow-auto pt1",class:_vm.defaultallquestionsanswerArr.length > 0 && _vm.allquestionsanswerArr.length < 1 ? 'border muted-border ' : null,staticStyle:{"height":"483px"}},[_c('div',{staticClass:"flex flex-column justify-center"},[(_vm.innerloading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',_vm._l((_vm.allquestionsanswerArr),function(questions,index){return (_vm.allquestionsanswerArr.length > 0)?_c('div',{key:index,staticClass:"mb1"},[_c('div',{staticClass:"p2 questiondiv flex flex-column"},[(Number(_vm.haaId) === questions.UF_PARTNER_ID)?_c('div',{staticClass:"pb1"},[_c('p',{staticClass:"m0 h6 semi-bold"},[_vm._v(" You ")])]):(questions.UF_MESSAGE_FROM === Number(_vm.contactID))?_c('div',{staticClass:"pb1"},[_c('p',{staticClass:"m0 h6 semi-bold"},[_vm._v(" Homeowner ")])]):_c('div',{},[_c('p',{staticClass:"m0"},[_vm._v("Craftsman")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap p0 m0"},_vm._l((questions.INDUSTRY),function(industry){return _c('div',{staticClass:"industryquestionsdiv px1 questionsgray flex p0 m0 items-center mb1 mr1"},[_c('p',{staticClass:"m0 p0 lowercase font14"},[_vm._v(_vm._s((industry.NAME)))])])}),0),_vm._v(" "),_c('div',{staticClass:"p0 m0"},[_c('p',{staticClass:"m0 font14 questionsgray"},[_vm._v(_vm._s(questions.UF_MESSAGE))])]),_vm._v(" "),_c('div',{staticClass:"flex p0 m0 small mt2"},[_c('p',{staticClass:"m0 font14"},[_vm._v(_vm._s(questions.TOTAL_REPLY)+" Samlet svar")]),_vm._v(" "),(questions.TOTAL_REPLY > 0)?_c('p',{staticClass:"m0 ml-auto font14 pointer",on:{"click":function($event){return _vm.viewanswers(index, questions.ID)}}},[_vm._v("Se svar")]):_c('p',{staticClass:"m0 ml-auto font14 pointer",on:{"click":function($event){return _vm.addchildreplay(questions.ID)}}},[_vm._v("Svar")])])]),_vm._v(" "),(questions['childquestionsanswers'].length > 0)?_c('div',{staticClass:"ml2 p2 flex flex-column font14 relative"},[_vm._l((questions['childquestionsanswers']),function(otherchild){return _c('div',{staticClass:"questiondiv p2"},[(otherchild.UF_MESSAGE_FROM === Number(_vm.contactID))?_c('p',{staticClass:"m0 primarycolor"},[_vm._v("Homeowner")]):(otherchild.UF_MESSAGE_FROM === Number(_vm.haaId))?_c('p',{staticClass:"m0 primarycolor"},[_vm._v("You")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m0 darkblue"},[_vm._v(_vm._s(otherchild.UF_MESSAGE))])])}),_vm._v(" "),_c('p',{staticClass:"m0 absolute bottom-0 right-0 px2 pointer",staticStyle:{"bottom":"-5px"},on:{"click":function($event){return _vm.addchildreplay(questions.ID)}}},[_vm._v("Svar")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml2 p2 my1 flex hide",attrs:{"id":'reply' + questions.ID}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"type":"textarea","rows":1,"placeholder":"Spørgsmål"},model:{value:(_vm.replayanswer),callback:function ($$v) {_vm.replayanswer=$$v},expression:"replayanswer"}}),_vm._v(" "),_c('button',{staticClass:"small action-button pointer",on:{"click":function($event){return _vm.addreplytoanswers(questions.ID, index)}}},[_vm._v("Indsend")]),_vm._v(" "),_c('button',{staticClass:"small outlined-standard-button pointer",on:{"click":function($event){return _vm.hidechildreply(index, questions.ID)}}},[_vm._v("Afbestille")])],1)]):_vm._e()}),0)])])])])]),_vm._v(" "),_c('b-modal',{ref:"downloadpdf",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"downloadpdf","size":"lg"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepdfdownload()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","overflow":"auto"}},[_c('div',{staticClass:"col-9 p0 mx-auto"},[_c('ejs-pdfviewer',{ref:"pdfviewer",attrs:{"id":"pdfViewer","serviceUrl":_vm.serviceUrl,"enableToolbar":false,"height":"800px"}})],1)])]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 px0"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2"},[_vm._v("Billeddokumentation")]),_vm._v(" "),_c('p',{staticClass:"h5 regular darkblue gibson line-height-golden mb3 col-12 px0"},[_vm._v("\n        Upload billederne af dine projektforløb her, så husejeren kan se på deres app.\n      ")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1587 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_management_vue__ = __webpack_require__(1589);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41953c78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_payment_management_vue__ = __webpack_require__(1590);
function injectStyle (ssrContext) {
  __webpack_require__(1588)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payment_management_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_41953c78_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_payment_management_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1588 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1589 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_form_wizard__);





var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Paymentmanagement',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_1_vue2_simplert___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_2_vue_form_wizard___default.a,
    ErrorHandler: ErrorHandler
  },
  computed: {},
  data: function data() {
    return {
      fileList: [],
      loading: false,
      haaid: '',
      salesPersonbitrix: '',
      stages: [],
      stagesid: [],
      test: false,
      images: [],
      stagesswitch: [],
      invitationId: '',
      totalamount: 0,
      limitUpload: 5,
      disable: false,
      fileListTemp: [],
      totalImageSize: '',
      showMobile: false,
      stagesthankyou: false,
      message: '',
      reasondeclinemodal: false,
      reasontext: '',
      gallerystage: false,
      typegallery: '',
      formData: [],
      photos: [],
      activeTab: [],
      allstagesArr: [],
      rqueststagebydescID: false,
      stagecomment: '',
      stagefullpayment: false,
      stageamount: 0,
      selectedstage: {},
      selectedID: '',
      innerimageloading: false,
      activestagephoto: '0',
      currentContractData: {},
      contractID: '',
      totalproject: 0,
      totalrelease: 0,
      modalimageloading: false,
      currentstageindex: '',
      itemsjobindustry: {},
      activeJobID: 0,
      depositedamount: 0,
      walletamount: 0,
      partnerchildprojects: [],
      childprojects: [],
      contractType: '',
      mangelamount: 0,
      tilbudpris: 0,
      currentProjectData: {},
      contactId: ''
    };
  },
  watch: {},
  created: function created() {
    this.projectId = this.$route.query.projectId;
    this.gettaskbitrix();
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    checkimage: function checkimage(stageID) {
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp';
      var getimage = document.getElementById('imagedivreview' + stageID);
      getimage.src = image2;
    },
    nextStep: function nextStep() {
      this.$refs.anbefalhomeowners.nextTab();
    },
    backstep: function backstep() {
      this.$refs.anbefalhomeowners.prevTab();
    },
    showthankyou: function showthankyou() {
      this.stagesthankyou = true;
    },
    closethankyou: function closethankyou() {
      this.stagesthankyou = false;
    },
    changerequesamount: function changerequesamount() {
      if (Number(this.stageamount) === this.selectedstage['PRICE']) {
        this.stagefullpayment = true;
      } else {
        this.stagefullpayment = false;
      }
    },
    openrqueststagebydesc: function openrqueststagebydesc(stage, index) {
      if (stage.PHOTOS.length < 1) {
        this.$message({
          type: 'error',
          message: 'Inkluder venligst billeder af disse stadier'
        });
        return false;
      }
      this.selectedstage = stage;
      this.stagefullpayment = true;
      this.stageamount = parseFloat(stage['PRICE_DEDUCTED'] - stage['PAYMENT_RELEASED']);
      this.selectedstage['descindex'] = index;
      this.rqueststagebydescID = true;
    },
    closerqueststagebydesc: function closerqueststagebydesc() {
      this.rqueststagebydescID = false;
      this.selectedstage = {};
    },
    showdecline: function showdecline(text) {
      this.reasontext = text;
      this.reasondeclinemodal = true;
    },
    closetwdecline: function closetwdecline() {
      this.reasondeclinemodal = false;
    },
    removeImage: function removeImage(file, fileList) {
      var index = fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      var index2 = fileList.indexOf(file.raw);
      if (index2 > -1) {
        this.images.splice(index2, 1);
      }
    },
    handleFileChange: function handleFileChange(file, fileList) {
      var isLt1M = file.size / 1000 / 1000 < 7;
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        });
        var index = this.fileList.indexOf(file.key);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var _index = this.fileList.indexOf(file);
        this.fileList.splice(_index, 1);
        return false;
      }
      this.fileList = fileList.slice(0);
      this.images.push(file.raw);
      this.formData = new FormData();
      this.formData.append('files[]', file.raw);
      this.addimage();
    },
    getstageid: function getstageid(stageID) {
      this.selectedID = stageID;
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this.itemsjobindustry = industryname;
        }
        _this.getstages();
      }, function (response) {
        var error = response.body.message;
        _this.$message({
          type: 'error',
          message: error
        });
      });
    },
    handleProgress: function handleProgress(event, file, fileList) {
      console.log('event', event);
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      var isLt1M = file.size / 1000 / 1000 < 17;
      this.checkImageSizes();
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          });
          return false;
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var index = this.fileList.indexOf(file);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        });
        var _index2 = this.fileList.indexOf(file.key);
        this.fileList.splice(_index2, 1);
        return false;
      }
      return isIMAGE && isLt1M;
    },
    checkImageSizes: function checkImageSizes() {
      var fileSize = 0;
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size);
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length;
      } else {
        this.limitUpload = 50;
      }
      this.totalImageSize = fileSize;
    },
    validatestep1: function validatestep1() {
      if (this.stagesid.length < 1) {
        this.$message({
          type: 'error',
          message: 'Vælg venligst 1 betaling at anmode om afventende.'
        });
        return false;
      }
      return true;
    },
    addstage: function addstage(id) {
      if (this.stagesid.indexOf(id) > -1) {
        this.stagesid.splice(this.stagesid.indexOf(id), 1);
      } else {
        this.stagesid.push(id);
      }
      this.stageerror = false;
    },
    addimage: function addimage() {
      var _this2 = this;

      this.innerimageloading = true;
      this.modalimageloading = true;
      if (this.images.length > 5) {
        this.$message({
          type: 'error',
          message: 'Upload kun 5 filer til denne anmodning.'
        });
        return false;
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.post(this.$bitrixapi + 'partner/project/uploadPaymentStagePhotos?paymentStageId=' + this.selectedID, this.formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this2.$message({
          type: 'success',
          message: 'Success'
        });
        _this2.innerimageloading = false;
        _this2.selectedID = '';
        _this2.getstages();
      }, function (response) {
        _this2.innerimageloading = false;
        var error = response.body;
        _this2.$message({
          type: 'error',
          message: error.message
        });
        _this2.selectedID = '';
      });
    },
    requeststage: function requeststage(id) {
      var _this3 = this;

      this.closerqueststagebydesc();
      this.loading = true;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        notes: this.stagecomment
      };
      this.$http.post(this.$bitrixapi + 'partner/paymentStages/requestPartial?projectId=' + this.projectId + '&paymentStageId=' + id, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this3.showthankyou();
          _this3.selectedstage = {};
          _this3.getstages();
        }
      }, function (response) {
        _this3.loading = false;
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
        _this3.getstages();
      });
    },
    getstages: function getstages() {
      var _this4 = this;

      if (!this.gallerystage) {
        this.loading = true;
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/paymentStagesV2?projectId=' + this.projectId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.contractID = res.data.CONTRACT_ID;
          _this4.stages = res.data.STAGES;

          var enterprisername = [];
          var allstagesbyinterpriser = [];
          res.data.STAGES.forEach(function (a) {
            if (a.TYPE !== 'deficiency') {
              var industryid = a.JOB_INDUSTRY_ID !== 0 ? a.JOB_INDUSTRY_ID : 'extra_work';
              var industryi = a.JOB_INDUSTRY_ID !== 0 ? _this4.itemsjobindustry[a.JOB_INDUSTRY_ID] : 0;
              if (!enterprisername.includes(industryid + '-' + industryi)) {
                enterprisername.push(industryid + '-' + industryi);
                _this4.activeTab.push(industryid.toString());
              }
            }
            if (a.CONTRACT_TYPE === 'normal' && a.TYPE === 'deficiency') {
              _this4.mangelamount += a.PRICE_DEDUCTED;
            }
          });
          enterprisername.forEach(function (b) {
            var allstagesObj = {};
            allstagesObj['enterpriserstages'] = [];
            allstagesObj['enterpriserID'] = b.split('-')[0];
            allstagesObj['enterpriserNAME'] = b.split('-')[1];
            allstagesObj['enterpriserstages'] = res.data.STAGES.filter(function (c) {
              return b === c.JOB_INDUSTRY_ID + '-' + _this4.itemsjobindustry[c.JOB_INDUSTRY_ID] || b === c.CONTRACT_TYPE + '-' + 0 && c.TYPE === 'normal';
            });
            allstagesbyinterpriser.push(allstagesObj);
            var sum = allstagesObj['enterpriserstages'].reduce(function (accumulator, object) {
              return accumulator + object['PAYMENT_RELEASED'];
            }, 0);
            _this4.totalrelease += sum;
          });
          _this4.allstagesArr = allstagesbyinterpriser;
          _this4.depositedamount = res.data.STAGES[res.data.STAGES.length - 1].PRICE;
          _this4.totalamount = res.data.CONTRACT ? res.data.CONTRACT.AMOUNT : 0;

          _this4.tilbudpris = res.data.TOTAL_AMOUNT_VAT;

          if (_this4.gallerystage) {
            _this4.photos = _this4.allstagesArr[_this4.currentstageindex.split('-')[0]]['enterpriserstages'][_this4.currentstageindex.split('-')[1]]['PHOTOS'];
            _this4.modalimageloading = false;
            setTimeout(function () {
              document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px';
            }, 100);
          }

          _this4.loading = false;
          _this4.displayProjects();
        }
      }, function (response) {
        _this4.loading = false;
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getcontractdetails: function getcontractdetails() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data) {
          _this5.currentContractData = res.data;
        }
      }, function (response) {
        var error = response.body.message;
        _this5.$refs.errorMsg.showMsg(error);
      });
    },
    opengallery: function opengallery(images) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var index2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      this.currentstageindex = index + '-' + index2;
      this.photos = [];
      this.photos = images;
      this.gallerystage = true;
      this.typegallery = this.showMobile ? 'none' : 'card';
      setTimeout(function () {
        document.getElementById('gallerystage___BV_modal_body_').style.width = window.innerWidth + 'px';
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px';
        document.getElementById('gallerystage___BV_modal_body_').style.padding = 0 + 'px';
      }, 200);
    },
    closengallery: function closengallery() {
      this.photos = [];
      this.gallerystage = false;
    },
    setactivestagephoto: function setactivestagephoto(index) {
      this.activestagephoto = index.toString();
      this.$refs.galleryone.setActiveItem(this.activestagephoto);
    },
    handleChange: function handleChange(event) {
      console.log('event', event);
    },
    displayProjects: function displayProjects() {
      var _this6 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + this.projectId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this6.contractType = res.CONTRACT_TYPE;
        _this6.contactId = res.HOMEOWNER.ID;
        _this6.childprojects = res.CHILD_PROJECTS;
        _this6.currentProjectData = res;
      }, function (response) {
        _this6.loading = false;
        var error = response.body;
        _this6.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    gotodashboard: function gotodashboard() {
      this.$router.push('/customer-projects/project-dashboard?projectId=' + this.currentProjectData.ID + '&contactID=' + this.currentProjectData.HOMEOWNER.ID + '&parentID=' + this.currentProjectData.PARENT_ID + '&industryID=' + this.currentProjectData.ENTERPRISE_INDUSTRY + '&offertype=' + this.currentProjectData.OFFER_TYPE + '&childprojects=' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.currentProjectData.CHILD_PROJECTS) + '&contracttype=' + this.currentProjectData.CONTRACT_TYPE + '&projecttitle=' + this.currentProjectData.NAME);
    }
  }
});

/***/ }),
/* 1590 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px3 notosans darkblue",attrs:{"id":"paymentmanagement"}},[_c('div',{staticClass:"pointer mt2",on:{"click":function($event){return _vm.gotodashboard()}}},[_c('i',{staticClass:"el-icon-back h5"})]),_vm._v(" "),_vm._m(0),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"loader"})]):_c('div',[_c('div',{staticClass:"col-12 py3 px0 xs-mb3 flex darkblue justify-around flex-wrap gap-10"},[_c('div',{staticClass:"headerboxitem flex flex-column p2 justify-center"},[_c('div',{staticClass:"h4 m0 flex"},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"h3 xs-h6 m0 ml-auto semi-bold"},[_vm._v(_vm._s(parseFloat(_vm.tilbudpris).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('p',{staticClass:"h6 ml-auto m0"},[_vm._v("Wallet")])]),_vm._v(" "),_c('div',{staticClass:"headerboxitem flex flex-column p2 justify-center"},[_c('div',{staticClass:"h4 m0 flex"},[_vm._m(2),_vm._v(" "),_c('span',{staticClass:"h3 xs-h6 m0 ml-auto semi-bold"},[_vm._v(_vm._s(_vm.totalrelease.toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('p',{staticClass:"h6 ml-auto m0"},[_vm._v("Betalt")])]),_vm._v(" "),_c('div',{staticClass:"headerboxitem flex flex-column p2 justify-center"},[_c('div',{staticClass:"h4 m0 flex"},[_vm._m(3),_vm._v(" "),(parseFloat(_vm.tilbudpris - _vm.totalrelease) >= 0)?_c('span',{staticClass:"h3 m0 xs-h6 ml-auto semi-bold"},[_vm._v(_vm._s(parseFloat(_vm.tilbudpris - _vm.totalrelease).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))]):_c('span',{staticClass:"h3 m0 xs-h6 ml-auto semi-bold"},[_vm._v(_vm._s((0).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('p',{staticClass:"h6 ml-auto m0"},[_vm._v("Saldo")])]),_vm._v(" "),_c('div',{staticClass:"headerboxitem flex flex-column p2 justify-center"},[_c('div',{staticClass:"h4 m0 flex"},[_vm._m(4),_vm._v(" "),_c('span',{staticClass:"h3 m0 xs-h6 ml-auto semi-bold"},[_vm._v(_vm._s(parseFloat(_vm.mangelamount).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('p',{staticClass:"h6 ml-auto m0"},[_vm._v("Sikkerhedsstillelse")])])]),_vm._v(" "),_c('div',{staticClass:" pt0 rounded"},[_c('div',{staticClass:"border darkblue-border rounded"},[_c('el-collapse',{model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},_vm._l((_vm.allstagesArr),function(enterpriserstage,index){return _c('el-collapse-item',{key:index,staticClass:"my2",attrs:{"name":enterpriserstage.enterpriserID}},[_c('template',{slot:"title"},[_c('div',{staticClass:"darkblue-background p0 m0 col-12 flex white justify-between items-center py1 rounded"},[(enterpriserstage.enterpriserID !== 'extra_work')?_c('p',{staticClass:"white m0 p1 md-col-2 lg-col-2 sm-col-2 xs-col-10 flex"},[_c('span',{staticClass:"pr1 h6"},[_vm._v(_vm._s(parseInt(index + 1) + '. ' + enterpriserstage.enterpriserNAME))])]):_c('p',{staticClass:"white m0 p1 md-col-2 lg-col-2 sm-col-2 xs-col-10 flex"},[_c('span',{staticClass:"pr1"},[_vm._v("Ekstra arbejde")])]),_vm._v(" "),_c('p',{staticClass:"font14 p0 m0 col-2 xs-hide center"},[_vm._v("Pris")]),_vm._v(" "),_c('p',{staticClass:"font14 p0 m0 col-2 xs-hide"},[_vm._v("Status")]),_vm._v(" "),_c('p',{staticClass:"font14 p0 m0 col-2 xs-hide"},[_vm._v("billeder")]),_vm._v(" "),_c('p',{staticClass:"font14 p0 m0 col-2 xs-hide"},[_vm._v("At anmode")])])]),_vm._v(" "),_vm._l((enterpriserstage['enterpriserstages']),function(stage,index2){return _c('div',{key:index2,staticClass:"col-12 p0 flex mt2",attrs:{"id":"jobindustryheader"}},[_c('el-collapse',{staticClass:"col-12 px2  mb2 white-background ",on:{"change":_vm.handleChange},model:{value:(_vm.activeJobID),callback:function ($$v) {_vm.activeJobID=$$v},expression:"activeJobID"}},[_c('el-collapse-item',{attrs:{"name":stage.INDUSTRY + enterpriserstage.enterpriserID}},[_c('template',{slot:"title"},[_c('div',{staticClass:"flex items-center px1 col-3 pointer"},[(enterpriserstage.enterpriserID !== 'extra_work')?_c('p',{staticClass:"darkblue mr-auto m0 py1 flex"},[_c('span',{staticClass:"pr1"},[_vm._v(_vm._s(index + 1)+"."+_vm._s(index2 + 1))]),_c('span',[_vm._v(_vm._s(stage.INDUSTRY))])]):_c('p',{staticClass:"darkblue mr-auto m0 py1 flex"},[_c('span',{staticClass:"pr1"},[_vm._v(_vm._s(index + 1)+"."+_vm._s(index2 + 1))]),_c('span',[_vm._v(_vm._s(stage.DESCRIPTION[0]))])])]),_vm._v(" "),_c('div',{staticClass:"flex items-center justify-start px1 sm-col-2 lg-col-2 md-col-2 xxl-col-2 xs-col-12"},[_c('p',{staticClass:"font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center"},[_vm._v("Pris")]),_vm._v(" "),_c('p',{staticClass:"darkblue mr-auto xs-ml-auto m0 py1"},[_vm._v(_vm._s(parseFloat(stage.PRICE_DEDUCTED).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('div',{staticClass:"flex items-center px1 justify-start sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12"},[_c('p',{staticClass:"font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center"},[_vm._v("Status")]),_vm._v(" "),(stage.STATUS === 'paid')?_c('p',{staticClass:"paymentbutton action-button regular font12 flex items-center justify-center xs-ml-auto",attrs:{"id":"paidbutton"}},[_vm._v("Betalt")]):(stage.STATUS === 'requested')?_c('p',{staticClass:"paymentbutton primary-button font12 flex items-center justify-center xs-ml-auto"},[_vm._v("Anmodet om")]):(stage.STATUS === 'pending')?_c('p',{staticClass:"paymentbutton yellow-button font12 flex items-center justify-center xs-ml-auto"},[_vm._v("Verserende")]):(stage.STATUS === 'partially_paid')?_c('p',{staticClass:"paymentbutton dark-button font12 flex items-center justify-center xs-ml-auto"},[_vm._v("Delvist betalt")]):(stage.STATUS === 'declined')?_c('p',{staticClass:"paymentbutton delete-button font12 flex items-center justify-center xs-ml-auto",on:{"click":function($event){return _vm.showdecline(stage.STATUS)}}},[_vm._v("Afvist")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"flex items-center px1 sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 ",attrs:{"id":'imageuploader'},on:{"click":function($event){return _vm.getstageid(stage.ID)}}},[_c('p',{staticClass:"font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center"},[_vm._v("billeder")]),_vm._v(" "),(_vm.innerimageloading)?_c('div',[_c('i',{staticClass:"el-icon-loading"})]):_c('div',{staticClass:"p0 pb2 relative xs-ml-auto"},[(stage.PHOTOS.length > 0)?_c('img',{staticClass:"cover pointer ml2",attrs:{"id":'imagedivreview' + stage.ID,"src":stage.PHOTOS[0] + '?width=125&height=80',"height":"80","width":"100%","alt":""},on:{"click":function($event){return _vm.opengallery(stage.PHOTOS, index, index2)},"error":function($event){return _vm.checkimage(stage.ID)}}}):_vm._e(),_vm._v(" "),(stage.PHOTOS.length < 1)?_c('div',{staticClass:"border rounded p2 ml3 regular small"},[_c('span',[_vm._v("+ UPLOAD")])]):_vm._e(),_vm._v(" "),(stage['PHOTOS'].length < 1)?_c('el-upload',{staticClass:"col-12 p0 absolute imageuploader top-0 bottom-0 left-0 right-0 primarycolor white-background opacity50 flex line-height-1 justify-center items-center h5 not-rounded  flex-column",attrs:{"action":"#","on-change":_vm.handleFileChange,"on-remove":_vm.removeImage,"on-progress":_vm.handleProgress,"before-upload":_vm.beforeFileUpload,"auto-upload":false,"accept":".jpg, .jpeg, .png, .webp","file-list":_vm.fileList,"list-type":"picture","limit":_vm.limitUpload,"multiple":true,"disabled":_vm.disable}},[_c('div',{staticClass:"flex items-center justify-center p2"},[_c('span',{staticClass:" relative"},[_c('i',{staticClass:"el-icon-plus"})])])]):_vm._e()],1)]),_vm._v(" "),_c('div',{staticClass:"flex items-center px1 sm-col-3 lg-col-3 md-col-3 xxl-col-3 xs-col-12 p1"},[_c('p',{staticClass:"font14 px2 sm-hide md-hide lg-hide xxl-hide m0 regular center"},[_vm._v("At anmode")]),_vm._v(" "),(stage.STATUS === 'pending' || stage.STATUS === 'declined' || stage.STATUS === 'partially_paid')?_c('button',{staticClass:"paymentbutton action-button font14 py1 flex items-center justify-center xs-ml-auto",on:{"click":function($event){_vm.openrqueststagebydesc(stage, parseInt(index + 1) + '.' + parseInt(index2 + 1))}}},[_c('span',{},[_vm._v("Send betaling")])]):(stage.STATUS === 'requested')?_c('button',{staticClass:"paymentbutton flex items-center justify-center action-button font14 py1 xs-ml-auto",attrs:{"disabled":""}},[_vm._v("Anmodning sendt")]):_vm._e()])]),_vm._v(" "),_vm._l((stage.DESCRIPTION),function(item,index3){return _c('div',{key:index3,staticClass:"col-12 pl3"},[_c('p',[_vm._v(" "+_vm._s(item)+" ")])])}),_vm._v(" "),_c('div',{staticClass:"py1"})],2)],1)],1)})],2)}),1)],1)]),_vm._v(" "),_c('div',{staticClass:"py4"})]),_vm._v(" "),_c('b-modal',{ref:"stagesthankyou",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"stagesthankyou","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.stagesthankyou),callback:function ($$v) {_vm.stagesthankyou=$$v},expression:"stagesthankyou"}},[_c('div',{staticClass:"col-12 flex justify-between items-center pt1 p0 mx-auto modal-header"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closethankyou()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12 center my2"},[_c('span',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"85","height":"85","viewBox":"0 0 85 85"}},[_c('path',{attrs:{"id":"success","d":"M25.957,81.66A42.642,42.642,0,1,1,42.5,85,42.362,42.362,0,0,1,25.957,81.66ZM4,42.5A38.5,38.5,0,1,0,42.5,4,38.544,38.544,0,0,0,4,42.5ZM34.707,57.372,22.3,45.527a2,2,0,0,1,2.762-2.894L36.088,53.161,59.525,30.789a2,2,0,1,1,2.762,2.893L37.469,57.372a2,2,0,0,1-2.762,0Z","fill":"#4dcf55"}})])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column darkblue center  mb3"},[_c('p',{staticClass:"h3 semi-bold my2"},[_vm._v("Din anmodning er blevet sendt")]),_vm._v(" "),_c('p',{staticClass:"h6 my3"},[_vm._v("Du vil modtage en e-mail, hvis og når din anmodning er godkendt.")])])])]),_vm._v(" "),(_vm.selectedstage)?_c('b-modal',{ref:"rqueststagebydescID",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"rqueststagebydescID","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.rqueststagebydescID),callback:function ($$v) {_vm.rqueststagebydescID=$$v},expression:"rqueststagebydescID"}},[_c('div',{staticClass:"col-12 flex justify-center items-center p0 m0 darkblue-background relative py3 mb2"},[_c('p',{staticClass:"white m0 semi-bold h3"},[_vm._v("Anmod om betaling")]),_vm._v(" "),_c('button',{staticClass:"pointer absolute right-0 top-0",on:{"click":function($event){return _vm.closerqueststagebydesc()}}},[_c('i',{staticClass:"white el-icon-circle-close pt1 pr1"})])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0"},[_c('div',{staticClass:"col-10 mx-auto py2 border muted-border border-top-0 border-left-0 border-right-0 mb2"},[_c('div',{staticClass:"flex justify-around"},[_c('div',{staticClass:"p0 m0 col-11 flex flex-column"},[_c('div',{staticClass:"flex"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v(_vm._s(_vm.selectedstage.INDUSTRY)+" - "+_vm._s(_vm.itemsjobindustry[_vm.selectedstage.JOB_INDUSTRY_ID]))]),_vm._v(" "),_c('p',{staticClass:"p0 h5 m0  ml-auto bold"},[_vm._v(_vm._s(parseFloat(_vm.selectedstage['PRICE_DEDUCTED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2}))+"\n              ")])]),_vm._v(" "),_vm._l((_vm.selectedstage['DESCRIPTION']),function(item,index3){return _c('p',{key:index3,staticClass:"m0 p0 font14"},[_c('span',{},[_vm._v(_vm._s(_vm._f("truncate")(item.replace('- '),80, '...')))])])})],2)])])]),_vm._v(" "),_c('div',{staticClass:"col-12 m0 p0 flex flex-column"},[_c('div',{staticClass:"col-9 mx-auto  darkblue center mb2"},[_c('div',{staticClass:"h6 p1 muted-background flex"},[_c('p',{staticClass:"p0 m0 mr-auto"},[_vm._v("Ikke betalt")]),_c('p',{staticClass:"p0 m0 ml-auto"},[_vm._v(_vm._s(parseFloat(_vm.selectedstage['PRICE_DEDUCTED'] - _vm.selectedstage['PAYMENT_RELEASED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])]),_vm._v(" "),_c('div',{staticClass:"h6 p1 muted-background flex"},[_c('p',{staticClass:"p0 m0 mr-auto"},[_vm._v("Betalt")]),_c('p',{staticClass:"p0 m0 ml-auto"},[_vm._v(_vm._s(parseFloat(_vm.selectedstage['PAYMENT_RELEASED']).toLocaleString('da-DK', {style: 'currency', currency: 'DKK', maximumFractionDigits:2})))])])]),_vm._v(" "),_c('div',{staticClass:"col-9 mx-auto darkblue center mb2 flex justify-end"},[_c('div',{staticClass:"flex justify-end items-center"},[_c('span',{staticClass:"px2 flex items-center"},[_c('el-checkbox',{model:{value:(_vm.stagefullpayment),callback:function ($$v) {_vm.stagefullpayment=$$v},expression:"stagefullpayment"}},[_vm._v("Fuld")])],1),_vm._v(" "),_c('el-input',{staticClass:"col-4 p0 el-input left-align",attrs:{"type":"number","max":_vm.selectedstage['PRICE']},on:{"change":function($event){return _vm.changerequesamount()}},model:{value:(_vm.stageamount),callback:function ($$v) {_vm.stageamount=_vm._n($$v)},expression:"stageamount"}}),_vm._v(" "),_c('span',{staticClass:"px1"},[_vm._v("kr.")])],1)]),_vm._v(" "),_c('div',{staticClass:"mb2 col-9 mx-auto"},[_c('label',[_vm._v("Kommentar")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 4, maxRows: 6},"placeholder":"Tilføj evt. dine betingelser for tilbuddet"},model:{value:(_vm.stagecomment),callback:function ($$v) {_vm.stagecomment=$$v},expression:"stagecomment"}})],1),_vm._v(" "),_c('div',{staticClass:"col-9 mx-auto  darkblue center my3"},[_c('button',{staticClass:"action-button p2 center col-12",on:{"click":function($event){return _vm.requeststage(_vm.selectedstage['ID'])}}},[_c('span',{staticClass:"h5 semi-bold "},[_vm._v("Send anmodning")])])])])]):_vm._e(),_vm._v(" "),_c('b-modal',{ref:"reasondeclinemodal",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"reasondeclinemodal","size":"lg","no-close-on-esc":"","no-close-on-backdrop":""},model:{value:(_vm.reasondeclinemodal),callback:function ($$v) {_vm.reasondeclinemodal=$$v},expression:"reasondeclinemodal"}},[_c('div',{staticClass:"col-12 flex justify-between items-center pt1 p0 mx-auto"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer",on:{"click":function($event){return _vm.closetwdecline()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"m0 p0 lg-col-12 md-col-12 sm-col-12 my2"},[_c('p',{staticClass:"darkblue col-12 h5 my2"},[_vm._v("Årsag til tilbagegang")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column darkblue center  mb3"},[_c('p',{staticClass:"h6 center line-height-golden p2"},[_vm._v("\n          "+_vm._s(_vm.reasontext)+"\n        ")])])])]),_vm._v(" "),_c('b-modal',{ref:"gallerystage",staticClass:"m0 p0",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"gallerystage","width":"100%","size":"xl"},model:{value:(_vm.gallerystage),callback:function ($$v) {_vm.gallerystage=$$v},expression:"gallerystage"}},[_c('div',{staticClass:"col-8 flex justify-between items-center p0 mx-auto absolute p4 z4"},[_c('button',{staticClass:"mr-auto p0 primary-white-button pointer",on:{"click":function($event){return _vm.closengallery()}}},[_c('i',{staticClass:"el-icon-back h1"})])]),_vm._v(" "),(_vm.modalimageloading)?_c('div',{staticClass:"mx-auto"},[_c('div',{staticClass:"loader"})]):_c('div',{staticClass:"flex flex-row col-12 m0 p0 height-full"},[_c('div',{staticClass:"p0 m0 col-10 mt4 pt3"},[_c('el-carousel',{ref:"galleryone",attrs:{"interval":4000,"arrow":"none","trigger":"click","setActiveItem":_vm.activestagephoto,"autoplay":false,"type":_vm.typegallery,"id":"galleryone","width":"100%","indicator-position":"outside"}},_vm._l((_vm.photos),function(item,index){return _c('el-carousel-item',{key:index,attrs:{"name":index.toString()}},[_c('img',{staticClass:"cover pointer",attrs:{"id":"imagedivreview","height":"100%","src":item,"width":"100%","alt":""}})])}),1)],1),_vm._v(" "),_c('div',{staticClass:"white-background col-2 flex flex-column"},[_c('div',{staticClass:"flex flex-column overflow-auto",attrs:{"id":"sidebarphoto"}},_vm._l((_vm.photos),function(itempreview,index){return _c('div',{key:index,staticClass:"p2"},[_c('img',{staticClass:"cover pointer",attrs:{"id":"imagedpreview","height":"200px","src":itempreview + '?width=250&height=200',"width":"250px","alt":""},on:{"click":function($event){return _vm.setactivestagephoto(index)}}})])}),0),_vm._v(" "),_c('div',{staticClass:"mx-auto center pb2 pt3",staticStyle:{"border":"3px dashed rgb(25, 163, 192)"}},[_c('el-upload',{staticClass:"px3",attrs:{"action":"#","on-change":_vm.handleFileChange,"on-remove":_vm.removeImage,"on-progress":_vm.handleProgress,"before-upload":_vm.beforeFileUpload,"auto-upload":false,"accept":".jpg, .jpeg, .png, .webp","file-list":_vm.fileList,"list-type":"picture","limit":_vm.limitUpload,"multiple":false,"disabled":_vm.disable}},[_c('div',{staticClass:"flex items-center justify-center p0"},[_c('span',{staticClass:" relative"},[_c('i',{staticClass:"h3 el-icon-plus darkblue"})])])])],1)])])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"darkblue-background px3 py4 mt2 flex flex-column items-start justify-center rounded"},[_c('p',{staticClass:"h3 white col-12 line-height-golden bold "},[_vm._v("Anmod om betaling")]),_vm._v(" "),_c('p',{staticClass:"h6 white col-12 line-height-golden"},[_vm._v("Du anmoder om betaling for rater ud fra jeres kontrakt")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-document"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-document"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-document"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('i',{staticClass:"el-icon-document"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1591 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mangel_list_vue__ = __webpack_require__(1593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de39a79_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_mangel_list_vue__ = __webpack_require__(1594);
function injectStyle (ssrContext) {
  __webpack_require__(1592)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_mangel_list_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6de39a79_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_mangel_list_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1592 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1593 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_form_wizard__);




var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'mangellist',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_0_vue2_simplert___default.a,
    VueFormWizard: __WEBPACK_IMPORTED_MODULE_1_vue_form_wizard___default.a,
    ErrorHandler: ErrorHandler,
    Loading: Loading
  },
  computed: {},
  data: function data() {
    return {
      loading: false,
      haaid: '',
      showMobile: false,
      salesPersonbitrix: '',
      pickerOptions: {
        disabledDate: function disabledDate(time) {
          return time.getTime() - -86400000 < Date.now();
        }
      },
      projectId: '',
      contractType: '',
      childprojects: [],
      partnerchildprojects: [],
      deadline: '',
      checked: false,
      incompleteModal: false,
      jobindustryBranch: [],
      itemsjobindustry: {},
      formLoading: false,
      commentloading: false,
      modalimageloading: false,
      addItemForm: {
        branch: [],
        title: '',
        beskrivelse: ''
      },
      addItemFormRules: {
        title: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit title',
          trigger: 'blur'
        }],
        beskrivelse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit beskrivelse',
          trigger: 'blur'
        }],
        branch: [{
          type: 'array',
          required: true,
          message: 'Du bedes indtaste dit tag',
          trigger: 'change'
        }]
      },
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      images: [],
      fileList: [],
      getDefiencyList: [],
      isPreApprove: false,
      isFinalApprove: false,
      lastUpdatedBy: '',
      editincompleteModal: false,
      itemSelect: {},
      existingImages: [],
      viewCommentModal: false,
      viewData: [],
      commentData: '',
      activestagephoto: '0',
      gallerystagenew: false,
      typegallery: '',
      photos: []
    };
  },
  watch: {},
  created: function created() {
    var _this = this;

    this.projectId = this.$route.query.projectId;
    this.contractType = this.$route.query.contracttype;
    this.childprojects = JSON.parse(this.$route.query.childprojects);
    this.childprojects.forEach(function (o) {
      if (o.IS_PARTNER) {
        _this.partnerchildprojects.push(o.ID);
      }
    });
    this.gettaskbitrix();
    this.getDefiency(this.projectId);
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },

  methods: {
    checkimage: function checkimage(index) {
      var image2 = 'https://photo.haandvaerker.dk/photos/minbolig/3130899/payment-stages-181-20220826060242JEG.webp';
      var getimage = document.getElementById('imagedivreview' + index);
      getimage.src = image2;
    },
    closeincompleteModal: function closeincompleteModal() {
      this.incompleteModal = false;
      this.addItemForm = {
        branch: [],
        title: '',
        description: ''
      };
    },
    markasdone: function markasdone(defeciencyid, index) {
      var _this2 = this;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + defeciencyid + '/markAsDone', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this2.addgreencover(index);
          _this2.getDefiency(_this2.projectId);
        }
        _this2.loading = false;
      }, function (response) {
        _this2.loading = false;
        var error = response.body.message;
        _this2.$message({
          type: 'error',
          message: error
        });
      });
    },
    viewComment: function viewComment(listitemid) {
      this.viewData = [];
      this.commentData = '';
      var viewArr = this.getDefiencyList.filter(function (resVal) {
        return listitemid === resVal.ID;
      })[0];
      this.viewData = viewArr;
      this.viewCommentModal = true;
    },
    saveComment: function saveComment(listitemid) {
      var _this3 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      this.commentloading = true;
      var headers = {
        Authorization: 'Bearer' + this.salesPersonbitrix
      };
      var data = {
        comment: this.commentData
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + listitemid + '/addComment', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var def = response.body.data.deficiency;
        _this3.getDefiencyList = def;
        _this3.viewComment(listitemid);
        _this3.commentloading = false;
      }, function (response) {
        _this3.commentloading = false;
        var error = response.body.message;
        _this3.$message({
          type: 'error',
          message: error
        });
      });
    },
    opengallery: function opengallery(images) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var index2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      this.currentstageindex = index + '-' + index2;
      this.photos = [];
      this.photos = images;
      this.gallerystagenew = true;
      this.typegallery = this.showMobile ? 'none' : 'card';
      setTimeout(function () {
        document.getElementById('gallerystagenew___BV_modal_body_').style.width = window.innerWidth + 'px';
        document.getElementById('sidebarphoto').style.height = parseInt(window.innerHeight - 150) + 'px';
        document.getElementById('gallerystagenew___BV_modal_body_').style.padding = 0 + 'px';
      }, 200);
    },
    addgreencover: function addgreencover(index) {
      var defeciencyitem = document.getElementById('defeciencyitem' + index);
      defeciencyitem.classList.remove('hide');
    },
    openincompleteModal: function openincompleteModal() {
      if (this.deadline === '') {
        this.$message({
          type: 'error',
          message: 'Indtast venligst en slutdato for alle varer på listen'
        });
        return false;
      }
      this.incompleteModal = true;
    },
    removeImage: function removeImage(file, fileList) {
      var index = fileList.indexOf(file);
      if (index > -1) {
        this.fileList.splice(index, 1);
      }
      var index2 = fileList.indexOf(file.raw);
      if (index2 > -1) {
        this.images.splice(index2, 1);
      }
    },
    handleFileChange: function handleFileChange(file, fileList) {
      var isLt1M = file.size / 1000 / 1000 < 7;
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 5 MB!'
        });
        var index = this.fileList.indexOf(file.key);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var _index = this.fileList.indexOf(file);
        this.fileList.splice(_index, 1);
        return false;
      }
      this.fileList = fileList.slice(0);
      this.images.push(file.raw);
    },
    getstageid: function getstageid(stageID) {
      this.selectedID = stageID;
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this4 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.haaId = localStorage.getItem('haaid');
      this.$http.get(this.$bitrixapi + 'industries/full/', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          _this4.jobindustryBranch = [];
          res.data.forEach(function (l) {
            var industryBranch = {};
            industryBranch.key = l.BRANCHE_ID;
            industryBranch.value = l.BRANCHE_ID;
            industryBranch.label = l.BRANCHE;
            _this4.jobindustryBranch.push(industryBranch);
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this4.itemsjobindustry = industryname;
        }
      }, function (response) {
        var error = response.body.message;
        _this4.$message({
          type: 'error',
          message: error
        });
      });
    },
    getDefiency: function getDefiency(id) {
      var _this5 = this;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      this.$http.get(this.$bitrixapi + 'partner/project/' + id + '/deficiency', { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.isPreApprove = res.data.preApproved;
          _this5.isFinalApprove = res.data.approved;
          _this5.deadline = res.data.deficiency.length > 0 ? res.data.deficiency[0].END_DATE : '';
          _this5.lastUpdatedBy = res.data.lastUpdatedBy;
          var updatedlist = [];
          res.data.deficiency.forEach(function (l) {
            l.checked = false;
            if (l.STATUS === 'done') {
              l.checked = true;
            }
            updatedlist.push(l);
          });
          _this5.getDefiencyList = updatedlist;
        }
        _this5.loading = false;
      }, function (response) {
        _this5.loading = false;
        var error = response.body.message;
        _this5.$message({
          type: 'error',
          message: error
        });
      });
    },
    handleProgress: function handleProgress(event, file, fileList) {
      console.log('event', event);
    },
    changeenddate: function changeenddate() {
      var _this6 = this;

      this.$confirm('Ønsker du at ændre fristen, vil dette påvirke alle varer på listen?', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this6.formLoading = true;
        _this6.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this6.salesPersonbitrix
        };
        var data = {};
        _this6.$http.post(_this6.$bitrixapi + 'partner/project/' + _this6.projectId + '/updateDeficiencyEndDate', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this6.getDefiency(_this6.projectId);
        }, function (response) {
          var error = response.body;
          _this6.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(function () {});
    },
    beforeFileUpload: function beforeFileUpload(file) {
      var isIMAGE = file.type === 'image/jpeg' || 'image/gif' || 'image/png' || 'image/jpg' || 'image/webp';
      var isLt1M = file.size / 1000 / 1000 < 17;
      this.checkImageSizes();
      for (var i = 0; i < this.fileListTemp.length; i++) {
        if (this.fileListTemp[i].name === file.name) {
          this.$message({
            type: 'error',
            message: 'Kan ikke uploade det samme billede!'
          });
          return false;
        }
      }
      if (!isIMAGE) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført! Filen er ikke et godkendt billedeformat !'
        });
        var index = this.fileList.indexOf(file);
        this.fileList.splice(index, 1);
        return false;
      }
      if (!isLt1M) {
        this.$message({
          type: 'error',
          message: 'Oops, Ikke Gennemført!  Filen må ikke fylde mere end 15 MB!'
        });
        var _index2 = this.fileList.indexOf(file.key);
        this.fileList.splice(_index2, 1);
        return false;
      }
      return isIMAGE && isLt1M;
    },
    checkImageSizes: function checkImageSizes() {
      var fileSize = 0;
      for (var i = 0; i < this.fileList.length; i++) {
        fileSize = Number(fileSize) + Number(this.fileList[i].size);
      }
      if (fileSize > 17000000) {
        this.limitUpload = this.fileList.length;
      } else {
        this.limitUpload = 50;
      }
      this.totalImageSize = fileSize;
    },
    addimage: function addimage() {
      var _this7 = this;

      this.innerimageloading = true;
      this.modalimageloading = true;
      if (this.images.length > 5) {
        this.$message({
          type: 'error',
          message: 'Upload kun 5 filer til denne anmodning.'
        });
        return false;
      }
      this.salesPerson = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      this.$http.post(this.$bitrixapi + 'partner/project/uploadPaymentStagePhotos?paymentStageId=' + this.selectedID, this.formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this7.$message({
          type: 'success',
          message: 'Success'
        });
        _this7.innerimageloading = false;
        _this7.selectedID = '';
        _this7.getstages();
      }, function (response) {
        var error = response.body;
        _this7.$message({
          type: 'error',
          message: error.message
        });
        _this7.selectedID = '';
      });
    },
    addDefiency: function addDefiency() {
      var _this8 = this;

      this.formLoading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var formData = new FormData();
      this.images.forEach(function (l) {
        formData.append('images[]', l);
      });
      formData.append('title', this.addItemForm.title);
      formData.append('industry', this.addItemForm.branch[0]);
      formData.append('description', this.addItemForm.beskrivelse);
      formData.append('endDate', this.deadline);
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency', formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this8.formLoading = false;
        _this8.closeincompleteModal();
        _this8.getDefiency(_this8.projectId);
      }, function (response) {
        var error = response.body;
        _this8.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    sendforApproval: function sendforApproval(boolean) {
      var _this9 = this;

      this.loading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        approve: boolean
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/preApproveDeficiency', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this9.$refs.simplert.openSimplert(obj);
        _this9.getDefiency(_this9.projectId);
      }, function (response) {
        var error = response.body;
        _this9.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    deleteDeficiency: function deleteDeficiency(deficiencyId) {
      var _this10 = this;

      this.$confirm('Hej, er du sikker på, at du vil slette dette element', {
        confirmButtonText: 'Ja, tak',
        cancelButtonText: 'Nej, tak',
        type: 'warning'
      }).then(function () {
        _this10.formLoading = true;
        _this10.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this10.salesPersonbitrix
        };
        var data = {};
        _this10.$http.post(_this10.$bitrixapi + 'partner/project/' + _this10.projectId + '/deficiency/' + deficiencyId, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this10.formLoading = false;
          _this10.getDefiency(_this10.projectId);
        }, function (response) {
          var error = response.body;
          _this10.$message({
            type: 'error',
            message: error.message
          });
        });
      }).catch(function () {});
    },
    openEditModal: function openEditModal() {
      this.editincompleteModal = true;
    },
    closeEditincompleteModal: function closeEditincompleteModal(item) {
      this.editincompleteModal = false;
    },
    SelectDefiencyItem: function SelectDefiencyItem(item) {
      this.existingImages = [];
      this.itemSelect = {};
      this.itemSelect = item;
      this.addItemForm.title = item.TITLE;
      this.addItemForm.branch.push(item.INDUSTRY);
      this.addItemForm.beskrivelse = item.DESCRIPTION;
      this.existingImages = item.IMAGES;
      this.openEditModal();
    },
    editDeficiency: function editDeficiency(deficiencyId) {
      var _this11 = this;

      this.formLoading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var formData = new FormData();
      this.images.forEach(function (l) {
        formData.append('images[]', l);
      });
      formData.append('title', this.addItemForm.title);
      formData.append('industry', this.addItemForm.branch[0]);
      formData.append('description', this.addItemForm.beskrivelse);
      this.$http.post(this.$bitrixapi + 'partner/project/' + this.projectId + '/deficiency/' + deficiencyId, formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this11.formLoading = false;
        _this11.getDefiency(_this11.projectId);
      }, function (response) {
        var error = response.body;
        _this11.$message({
          type: 'error',
          message: error.message
        });
      });
    },
    getcontractdetails: function getcontractdetails() {
      var _this12 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/contract/' + this.contractID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data) {
          _this12.currentContractData = res.data;
        }
      }, function (response) {
        var error = response.body.message;
        _this12.$refs.errorMsg.showMsg(error);
      });
    },
    closengallery: function closengallery() {
      this.photos = [];
      this.gallerystagenew = false;
    },
    setactivestagephoto: function setactivestagephoto(index) {
      this.activestagephoto = index.toString();
      this.$refs.galleryonenew.setActiveItem(this.activestagephoto);
    },
    handleChange: function handleChange(event) {
      console.log('event', event);
    },
    getTermsCondition: function getTermsCondition() {
      var _this13 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/termsAndConditionsPopup', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this13.termsdata = res.filter(function (l) {
          return l.TYPE === 'Partner';
        })[0];
        _this13.termslink = _this13.termsdata.LINK;
        _this13.termslabel = _this13.termsdata.LABEL;
      }, function (response) {
        _this13.$message({
          type: 'error',
          message: response.body.message
        });
      });
    }
  }
});

/***/ }),
/* 1594 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix px3 notosans darkblue",attrs:{"id":"mangellist"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex col-12 p0 mobile-flex-column"},[_c('p',{staticClass:"h3 line-height-golden"},[_vm._v("Renoverer mit hus for at gøre det nyt og fantastisk")]),_vm._v(" "),_c('div',{staticClass:"clearfix mb2 flex flex-wrap ml-auto items-center xs-gap-10 gap-20"},[_c('p',{staticClass:"m0 h5 regular xs-col-12"},[_vm._v("End Date:")]),_vm._v(" "),_c('el-date-picker',{staticClass:"px0 primarycolor",attrs:{"disabled":_vm.isPreApprove,"size":"large","format":"yyyy/MM/dd","value-format":"yyyy-MM-dd","type":"date","placeholder":"start","picker-options":_vm.pickerOptions},on:{"change":function($event){return _vm.changeenddate()}},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}}),_vm._v(" "),_c('button',{staticClass:"dark-button flex items-center px2 py1 rounded",attrs:{"type":"button","disabled":_vm.isPreApprove},on:{"click":function($event){return _vm.openincompleteModal()}}},[_vm._m(1),_vm._v(" "),_c('span',{staticClass:"pl2 regular white"},[_vm._v("ADD LIST")])])],1)]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"col-12"},[_c('Loading')],1):_c('div',{staticClass:"flex flex-column "},[(_vm.getDefiencyList.length > 0)?_c('div',[_vm._l((_vm.getDefiencyList),function(list,index){return _c('div',{key:index,staticClass:"p2 flex flex-column border primar-border rounded mb2 relative",class:list.checked ? 'opacity-50 ' : ' '},[(_vm.isPreApprove)?_c('div',{staticClass:"col-12 flex p0 z4"},[_c('p',{staticClass:"m0 p0 darklue semi-bold"},[_vm._v(_vm._s(list.TITLE))]),_vm._v(" "),_c('div',{staticClass:"ml-auto relative lg-col-2 md-col-2 xs-col-5"},[_c('span',{staticClass:"absolute top-0",staticStyle:{"top":"-10px"}},[_vm._v(" Marker som færdig")]),_vm._v(" "),_c('el-checkbox',{staticClass:"absolute",staticStyle:{"top":"20px","left":"70px"},attrs:{"disabled":list.checked},on:{"change":function($event){return _vm.markasdone(list.ID, index)}},model:{value:(list.checked),callback:function ($$v) {_vm.$set(list, "checked", $$v)},expression:"list.checked"}})],1)]):_vm._e(),_vm._v(" "),(list.IMAGES.length > 0)?_c('div',{staticClass:"flex col-12 p0 m0 gap-10 z1"},_vm._l((list.IMAGES),function(image,index){return _c('img',{key:index,staticClass:"rounded cover pointer",attrs:{"src":image.IMAGE_LINK,"id":'imagedivreview' + index,"width":"60px","height":"60px","alt":"defiency images"},on:{"click":function($event){return _vm.opengallery(list.IMAGES)},"error":function($event){return _vm.checkimage(index)}}})}),0):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-12 py2 p0 z1"},[_c('p',{staticClass:"regular h6 p0"},[_vm._v(_vm._s(list.DESCRIPTION))])]),_vm._v(" "),_c('div',{staticClass:"flex col-12 p0 m0 z1"},[_c('div',[_c('p',{staticClass:"tagitem m0"},[_vm._v(_vm._s(list.INDUSTRY))])]),_vm._v(" "),(!_vm.isPreApprove)?_c('div',{staticClass:"ml-auto flex justify-center items-center"},[_c('el-tooltip',{attrs:{"content":"View Comment","placement":"top"}},[_c('span',{staticClass:"px2",on:{"click":function($event){return _vm.viewComment(list.ID)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32.001","height":"33.416","viewBox":"0 0 32.001 33.416"}},[_c('path',{attrs:{"id":"comment","d":"M32.985,6A3,3,0,0,0,30,3H6A3.009,3.009,0,0,0,3,6V24a3.009,3.009,0,0,0,3,3H27l6,6Z","transform":"translate(-2 -2)","fill":"none","stroke":"#003645","stroke-width":"2"}})])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Edit","placement":"top"}},[_c('span',{staticClass:"px2",on:{"click":function($event){return _vm.SelectDefiencyItem(list)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"32.182","height":"32.182","viewBox":"0 0 32.182 32.182"}},[_c('g',{attrs:{"id":"edit","transform":"translate(1 1)"}},[_c('path',{attrs:{"id":"Path_4681","data-name":"Path 4681","d":"M16.5,6H6A3,3,0,0,0,3,9V30a3,3,0,0,0,3,3H27a3,3,0,0,0,3-3V19.5","transform":"translate(-3 -2.818)","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4682","data-name":"Path 4682","d":"M27.75,3.75a3.182,3.182,0,0,1,4.5,4.5L18,22.5,12,24l1.5-6Z","transform":"translate(-3 -2.818)","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Delete","placement":"top"}},[_c('span',{staticClass:"px2",on:{"click":function($event){return _vm.deleteDeficiency(list.ID)}}},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"29","height":"32","viewBox":"0 0 29 32"}},[_c('g',{attrs:{"id":"delete","transform":"translate(-3.5 -2)"}},[_c('path',{attrs:{"id":"Path_4683","data-name":"Path 4683","d":"M4.5,9h27","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4684","data-name":"Path 4684","d":"M28.5,9V30a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3V9M12,9V6a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V9","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4685","data-name":"Path 4685","d":"M15,16.5v9","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4686","data-name":"Path 4686","d":"M21,16.5v9","fill":"none","stroke":"#003645","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"2"}})])])])])],1):_vm._e()]),_vm._v(" "),_c('div',{staticClass:" absolute code top-0 left-0 bottom-0 right-0 opacity-50 green-background z2",class:!list.checked ? 'hide ' : '',attrs:{"id":'defeciencyitem' + index}})])}),_vm._v(" "),_c('div',{staticClass:"flex col-12 my2"},[(_vm.lastUpdatedBy === 'company' || _vm.lastUpdatedBy === null)?_c('button',{staticClass:"ml-auto px2 py1 rounted action-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendforApproval(true)}}},[_c('span',{staticClass:"h5"},[_vm._v("SEND TIL GODKENDELSE")])]):(_vm.lastUpdatedBy === 'contact' && !_vm.isPreApprove)?_c('button',{staticClass:"ml-auto px2 py1 rounted action-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.sendforApproval(true)}}},[_c('span',{staticClass:"h5"},[_vm._v("Godkend Liste")])]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"py4"})],2):_c('div',[_c('p',{staticClass:"h4 center semi-bold mt4"},[_vm._v("Ingen dato fundet")])])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"incompleteModal","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","hide-header":"","hide-footer":"","size":"lg"},model:{value:(_vm.incompleteModal),callback:function ($$v) {_vm.incompleteModal=$$v},expression:"incompleteModal"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeincompleteModal()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"incompleteItem lg-col-12 md-col-4 sm-col-6 xs-col-12 pr2 pb2"},[(_vm.formLoading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"px2 pt2 pb3"},[_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.addItemForm,"rules":_vm.addItemFormRules,"label-position":"top"}},[_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Title","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"Input Title"},model:{value:(_vm.addItemForm.title),callback:function ($$v) {_vm.$set(_vm.addItemForm, "title", $$v)},expression:"addItemForm.title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Industry","prop":"branch"}},[_c('el-select',{staticClass:"col-12 p0",attrs:{"multiple":"","filterable":"","multiple-limit":1,"placeholder":"Tags"},model:{value:(_vm.addItemForm.branch),callback:function ($$v) {_vm.$set(_vm.addItemForm, "branch", $$v)},expression:"addItemForm.branch"}},_vm._l((_vm.jobindustryBranch),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.label}})}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Beskrivelse","prop":"beskrivelse"}},[_c('el-input',{staticClass:"mb1",attrs:{"type":"textarea","placeholder":"Add a short description","rows":5},model:{value:(_vm.addItemForm.beskrivelse),callback:function ($$v) {_vm.$set(_vm.addItemForm, "beskrivelse", $$v)},expression:"addItemForm.beskrivelse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-start"}),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('el-upload',{ref:"upload",staticClass:"mb2 col-12 p0",attrs:{"action":"#","auto-upload":false,"drag":true,"limit":5,"accept":_vm.acceptedFileType,"on-change":_vm.handleFileChange},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return _c('div',{},[_vm._v("\n                      "+_vm._s(file.name)+"\n                      "),_c('button',{staticClass:"transparent-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage(file, this.fileList)}}},[_c('i',{staticClass:"el-icon-delete red"})])])}}])},[_c('i',{staticClass:"el-icon-upload darkblue",attrs:{"slot":"default"},slot:"default"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text center"},[_vm._v("Slip din fil her"),_c('span',{staticClass:"darkblue"},[_vm._v("Klik for at uploade")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip center darkblue"},[_vm._v("Filstørrelsesgrænse")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mt3 flex justify-end"},[_c('button',{staticClass:"action-button line-height-1 p2 test",on:{"click":function($event){$event.preventDefault();return _vm.addDefiency()}}},[_c('span',[_vm._v("Gemme")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"editincompleteModal","no-close-on-esc":"","no-close-on-backdrop":"","centered":"","hide-header":"","hide-footer":"","size":"lg"},model:{value:(_vm.editincompleteModal),callback:function ($$v) {_vm.editincompleteModal=$$v},expression:"editincompleteModal"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeEditincompleteModal()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"incompleteItem lg-col-12 md-col-4 sm-col-6 xs-col-12 pr2 pb2"},[(_vm.formLoading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"px2 pt2 pb3"},[_c('el-form',{ref:"step4formcontact",staticClass:"demo-form-inline tui-f md-col-10 lg-col-10 sm-col-12 mx-auto",attrs:{"id":"cvrfrom","model":_vm.addItemForm,"rules":_vm.addItemFormRules,"label-position":"top"}},[_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Title","prop":"title"}},[_c('el-input',{attrs:{"placeholder":"Input Title"},model:{value:(_vm.addItemForm.title),callback:function ($$v) {_vm.$set(_vm.addItemForm, "title", $$v)},expression:"addItemForm.title"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Industry","prop":"branch"}},[_c('el-select',{staticClass:"col-12 p0",attrs:{"multiple":"","filterable":"","multiple-limit":1,"placeholder":"Tags"},model:{value:(_vm.addItemForm.branch),callback:function ($$v) {_vm.$set(_vm.addItemForm, "branch", $$v)},expression:"addItemForm.branch"}},_vm._l((_vm.jobindustryBranch),function(item){return _c('el-option',{key:item.key,attrs:{"label":item.label,"value":item.label}})}),1)],1)],1),_vm._v(" "),_c('div',{staticClass:"clearfix mb2"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Beskrivelse","prop":"beskrivelse"}},[_c('el-input',{staticClass:"mb1",attrs:{"type":"textarea","placeholder":"Add a short description","rows":5},model:{value:(_vm.addItemForm.beskrivelse),callback:function ($$v) {_vm.$set(_vm.addItemForm, "beskrivelse", $$v)},expression:"addItemForm.beskrivelse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-start"}),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},[_c('el-upload',{ref:"upload",staticClass:"mb2 col-12 p0",attrs:{"action":"#","auto-upload":false,"drag":true,"limit":5,"accept":_vm.acceptedFileType,"on-change":_vm.handleFileChange},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return _c('div',{},[_vm._v("\n                      "+_vm._s(file.name)+"\n                      "),_c('button',{staticClass:"transparent-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeImage(file, this.fileList)}}},[_c('i',{staticClass:"el-icon-delete red"})])])}}])},[_c('i',{staticClass:"el-icon-upload darkblue",attrs:{"slot":"default"},slot:"default"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text center"},[_vm._v("Slip din fil her"),_c('span',{staticClass:"darkblue"},[_vm._v("Klik for at uploade")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip center darkblue"},[_vm._v("Filstørrelsesgrænse")])])],1),_vm._v(" "),_c('div',{staticClass:"col-12 p0"},_vm._l((_vm.existingImages),function(imageitem){return _c('div',{key:imageitem.ID},[_c('img',{staticClass:"rounded cover",attrs:{"src":imageitem.IMAGE_LINK,"width":"80px","height":"80px","alt":"defiency images"}})])}),0),_vm._v(" "),_c('div',{staticClass:"col-12 px0 mt3 flex justify-end"},[_c('button',{staticClass:"action-button line-height-1 p2 test",on:{"click":function($event){$event.preventDefault();return _vm.addDefiency()}}},[_c('span',[_vm._v("Gemme")]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])])],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"viewCommentModal","centered":"","hide-header":"","hide-footer":"","size":"lg"},model:{value:(_vm.viewCommentModal),callback:function ($$v) {_vm.viewCommentModal=$$v},expression:"viewCommentModal"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px2 py1 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){_vm.viewCommentModal = false}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),(_vm.commentloading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"clearfix mb2"},[_c('p',{staticClass:"line-height-4 h3 darkblue mt1 semi-bold px3 m0"},[_vm._v(_vm._s(_vm.viewData.TITLE))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap gap-10 px3 my1"},_vm._l((_vm.viewData.IMAGES),function(imageItem){return _c('b-img',{key:imageItem,staticClass:"cover p0 covercover rounded",staticStyle:{"object-position":"top"},attrs:{"src":imageItem.IMAGE_LINK,"alt":"Project Image","height":"80px"}})}),1),_vm._v(" "),_c('div',{staticClass:"border border-top-0 border-left-0 border-right-0 px3"},[_c('p',{staticClass:"line-height-golden h5 darkblue mt1 word-break pb2 regular p0 m0"},[_vm._v(_vm._s(_vm.viewData.DESCRIPTION)+" asdaed sad ad wwdqe asd R er wqe wr qwer qe qeqwe qdqdqwedq wdqwdqwe  sda dasd asd asda da da d ")])]),_vm._v(" "),_vm._l((_vm.viewData.COMMENTS),function(items,index){return _c('div',{key:index,staticClass:"px3 my1"},[_c('div',{staticClass:"flex p0 mt2"},[_c('p',{staticClass:"h6 mb0 semi-bold"},[_vm._v(_vm._s(items.CREATED_BY.NAME))]),_vm._v(" "),_c('p',{staticClass:"small lightgrey px2 m0 mb1"},[_vm._v(" "+_vm._s(_vm.moment(items.DATE_CREATED).locale('da').format('LL')))])]),_vm._v(" "),_c('p',{staticClass:"mb2 h6 darkblue line-height-golden"},[_vm._v(_vm._s(items.COMMENT))])])}),_vm._v(" "),_c('div',{staticClass:"px3 mt1"},[_c('el-input',{attrs:{"autosize":{ minRows: 4, maxRows: 6 },"type":"textarea","placeholder":"Add comment"},model:{value:(_vm.commentData),callback:function ($$v) {_vm.commentData=$$v},expression:"commentData"}})],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end items-end px3"},[_c('button',{staticClass:"dark-button py1 px2 mt1 rounded",on:{"click":function($event){return _vm.saveComment(_vm.viewData.ID)}}},[_vm._v("\n          Tilføj kommentar\n        ")])])],2)]),_vm._v(" "),_c('b-modal',{ref:"gallerystagenew",staticClass:"m0 p0",attrs:{"centered":"","hide-footer":"","hide-header":"","id":"gallerystagenew","width":"100%","size":"xl"},model:{value:(_vm.gallerystagenew),callback:function ($$v) {_vm.gallerystagenew=$$v},expression:"gallerystagenew"}},[_c('div',{staticClass:"lg-col-8 md-col-10 xs-p0 xs-col-12 flex justify-between items-center p0 mx-auto absolute p2 z4"},[_c('button',{staticClass:"mr-auto p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closengallery()}}},[_c('i',{staticClass:"el-icon-back h1"})])]),_vm._v(" "),(_vm.modalimageloading)?_c('div',{staticClass:"mx-auto"},[_c('Loading')],1):_c('div',{staticClass:"flex flex-row justify-center col-12 m0 p0 height-full"},[_c('div',{staticClass:"p0 m0 col-10 mt4 pt3"},[_c('el-carousel',{ref:"galleryonenew",attrs:{"interval":4000,"arrow":"none","trigger":"click","setActiveItem":_vm.activestagephoto,"autoplay":false,"type":_vm.typegallery,"id":"galleryonenew","width":"100%","indicator-position":"outside"}},_vm._l((_vm.photos),function(item,index){return _c('el-carousel-item',{key:index,attrs:{"name":index.toString()}},[_c('img',{staticClass:"cover pointer",attrs:{"id":"imagedivreview","height":"100%","src":item.IMAGE_LINK,"width":"100%","alt":""}})])}),1)],1)])]),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mt2 my3"},[_c('p',{staticClass:"h3 col-12 line-height-golden bold p0"},[_vm._v("Mangel-liste")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('i',{staticClass:"white h5 m0 el-icon-circle-plus-outline"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1595 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff1d75_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyOwner_vue__ = __webpack_require__(1596);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7eff1d75_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_PropertyOwner_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c("div")}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1597 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payproff_vue__ = __webpack_require__(1599);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc9891e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_payproff_vue__ = __webpack_require__(1600);
function injectStyle (ssrContext) {
  __webpack_require__(1598)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_payproff_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dc9891e_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_payproff_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1598 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1599 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue2_simplert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_countries_json__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_countries_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_countries_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_languages_json__ = __webpack_require__(298);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_languages_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_languages_json__);







var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'payproff',
  components: {
    Simplert: __WEBPACK_IMPORTED_MODULE_2_vue2_simplert___default.a,
    ErrorHandler: ErrorHandler,
    en: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["en"],
    da: __WEBPACK_IMPORTED_MODULE_1_vuejs_datepicker_dist_locale__["da"],
    datepicker: __WEBPACK_IMPORTED_MODULE_0_vuejs_datepicker__["a" /* default */],
    Loading: Loading
  },
  created: function created() {
    this.partnerName = localStorage.getItem('name');
    this.haaid = localStorage.getItem('haaid');
    this.salesPerson = localStorage.getItem('id_token_portal_bitrix');
    this.dashdata = this.$route.query.dashdata;
    this.getwalletinfo();
    this.supplierprofile();
  },
  data: function data() {
    return {
      confirmPayproff: false,
      loading: false,
      salesPerson: '',
      haaid: '',
      partnerName: '',
      partneremail: '',
      partnerzip: '',
      partnertelephone: '',
      isPep: true,
      partnerprofile: [],
      payprofform: {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      },
      anbefalformrules: {
        fornavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit fornavn',
          trigger: 'blur'
        }],
        efternavn: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit efternavn',
          trigger: 'blur'
        }],
        fodelsdag: [{
          required: true,
          type: 'date',
          message: 'Du bedes indtaste dit fødelsdag',
          trigger: 'change'
        }],
        Adresse: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit Adresse',
          trigger: 'blur'
        }],
        zipcode: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit postnummer',
          trigger: 'blur'
        }],
        by: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit by',
          trigger: 'blur'
        }],
        stat: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit stat',
          trigger: 'blur'
        }],
        land: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste dit gyldig land',
          trigger: 'blur'
        }],
        email: [{
          required: true,
          type: 'email',
          message: 'Du bedes indtaste en gyldig e-mail',
          trigger: 'blur'
        }],
        telefonnummer: [{
          required: true,
          type: 'number',
          min: 10000000,
          max: 99999999,
          message: 'Du bedes indtaste en gyldig telnummer',
          trigger: 'blur'
        }],
        telcountrycode: [{
          required: true,
          type: 'number',
          message: 'Du bedes indtaste dit code',
          trigger: 'blur'
        }],
        cprnummer: [{
          required: true,
          type: 'string',
          message: 'Du bedes indtaste en cpr',
          trigger: 'blur'
        }]
      },
      countryData: __WEBPACK_IMPORTED_MODULE_3__components_countries_json___default.a,
      languagesData: __WEBPACK_IMPORTED_MODULE_4__components_languages_json___default.a,
      haspayproff: false,
      isexist: false,
      activeNames: [],
      isverified: false,
      verifylink: null,
      dashdata: '',
      partnerwalletid: '',
      partneriban: '',
      partnerwallet: {},
      ibanmessage: null
    };
  },
  mounted: function mounted() {},

  methods: {
    closeconfirmPayproff: function closeconfirmPayproff() {
      this.confirmPayproff = false;
    },
    validateCreatePayproffFirstTab: function validateCreatePayproffFirstTab() {
      return true;
    },
    openconfirmPayproff: function openconfirmPayproff() {
      var isnumber = /^\d+$/.test(this.payprofform.cprnummer);
      if (!isnumber) {
        this.$message({
          type: 'error',
          message: 'Indtast kun tal på cpr-nummeret'
        });
        return false;
      }
      var error = 0;
      this.$refs['payproffform'].validate(function (valid) {
        if (!valid) {
          error = 1;
        }
      });
      if (error === 1) {
        return;
      }
      this.confirmPayproff = true;
    },
    getwalletinfo: function getwalletinfo() {
      var _this = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/payproff/wallet', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this.partnerwallet = res;
      }, function (response) {
        _this.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    updateiban: function updateiban() {
      var _this2 = this;

      if (!this.partnerwallet) {
        this.$message({
          type: 'error',
          message: 'Din tegnebog er konfigureret korrekt, kontakt venligst support for yderligere hjælp'
        });
        return false;
      }
      if (!this.partneriban) {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst dit Iban-nummer'
        });
        return false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        iban: this.partneriban,
        walletid: this.partnerwallet['WALLET_ID']
      };
      this.$http.put(this.$bitrixapi + 'partner/payproff/wallet', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var obj = {
          title: 'Gennemført!',
          message: '',
          type: 'success',
          customCloseBtnText: 'Luk'
        };
        _this2.$refs.simplert.openSimplert(obj);
      }, function (response) {
        _this2.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    verifyIban: function verifyIban(ibantext) {
      var _this3 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'helper/validateIban/' + this.partneriban.replace(/ /g, ''), { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data.valid) {
          if (ibantext === 'updateiban') {
            _this3.updateiban();
          } else if (ibantext === '') {
            _this3.verify();
          }
          _this3.ibanmessage = null;
        } else {
          var messagearr = '';
          res.data.messages.forEach(function (t) {
            messagearr += t + ', ';
          });
          _this3.ibanmessage = messagearr;
          _this3.$message({
            type: 'error',
            message: messagearr
          });
        }
      }, function (response) {
        _this3.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    verify: function verify() {
      var _this4 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        email: this.payprofform.email,
        phoneNumber: this.payprofform.telefonnummer,
        phoneNumberAreaCode: this.payprofform.telcountrycode,
        firstName: this.payprofform.fornavn,
        middleName: this.payprofform.mellemnavn,
        lastName: this.payprofform.efternavn,
        address: this.payprofform.Adresse,
        zipCode: this.payprofform.zipcode,
        city: this.payprofform.by,
        state: this.payprofform.stat,
        country: this.payprofform.land,
        isPep: this.isPep,
        socialSecurityNumber: Number(this.payprofform.cprnummer),
        birthDate: this.payprofform.fodelsdag,
        displayLanguage: this.payprofform.sprog,
        currency: this.payprofform.currency,
        cvr: this.payprofform.cvr,
        companyName: this.payprofform.companyName,
        iban: this.partneriban.replace(/ /g, '')
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this4.closeconfirmPayproff();

          _this4.getNemIdUrlsubmit();
        } else {
          _this4.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this4.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getPayproffacc: function getPayproffacc() {
      var _this5 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/account/exists/', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this5.isexist = res.data.exists;
          _this5.haspayproff = res.data.payproff_verified;
          _this5.verifylink = res.data.payproff_url;
          if (!_this5.verifylink && !_this5.haspayproff && _this5.isexist) {
            _this5.getNemIdUrl();
          }
          if (_this5.haspayproff) {
            _this5.removeorangepayproffbanner();
          }
          _this5.loading = false;
          if (_this5.$route.query.dashdata) {
            _this5.addbanner();
          }
        } else {
          _this5.loading = false;
          _this5.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this5.loading = false;
        _this5.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    addbanner: function addbanner() {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner');
      checkpayproffbanner.classList.remove('hide');
      var payproff = document.getElementById('payproff');
      payproff.style.marginTop = '52px';
    },
    addorangepayproffbanner: function addorangepayproffbanner() {
      var payproffnotification = document.getElementById('payproffnotification');
      payproffnotification.classList.remove('hide');
    },
    removeorangepayproffbanner: function removeorangepayproffbanner() {
      if (document.getElementById('payproffnotification')) {
        var payproffnotification = document.getElementById('payproffnotification');
        payproffnotification.classList.add('hide');
      }
    },
    getNemIdUrlsubmit: function getNemIdUrlsubmit() {
      var _this6 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        var closeFn = function closeFn() {
          this.$router.push('/alle-moeder');
        };
        var obj = {
          title: 'Gennemført!',
          message: 'Gå til den åbne fane i din browser for at bekræfte din betalingsprofil',
          type: 'success',
          onClose: closeFn,
          customCloseBtnText: 'Luk'
        };
        _this6.$refs.simplert.openSimplert(obj);
        _this6.closebanner();
        window.open(res.data.URL, '_blank').focus();
      }, function (err) {
        _this6.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    closebanner: function closebanner() {
      var checkpayproffbanner = document.getElementById('checkpayproffbanner');
      checkpayproffbanner.classList.add('hide');
      this.addorangepayproffbanner();
    },
    updateStatus: function updateStatus(buttonstatus) {
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };

      var data = {
        status: buttonstatus
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/updateStatus', data, { headers: headers }, { emulateJSON: true }).then(function (response) {}, function (response) {});
    },
    updateStatusiban: function updateStatusiban(ibannumber) {
      var _this7 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        iban: ibannumber
      };
      this.$http.post(this.$bitrixapi + 'partner/payproff/update', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (_this7.verifylink) {
          _this7.showlink(_this7.verifylink);
        } else if (res.PAYPROFFF_URL) {
          _this7.showlink(res.PAYPROFFF_URL);
        } else {
          _this7.getNemIdUrl();
        }
      }, function (response) {
        _this7.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    getNemIdUrl: function getNemIdUrl() {
      var _this8 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/payproff/verify', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        window.open(res.data.URL, '_blank').focus();
      }, function (err) {
        _this8.$message({
          type: 'error',
          message: err.body.message
        });
      });
    },
    showlink: function showlink() {
      window.open(this.verifylink, '_blank').focus();
    },
    clear: function clear() {
      this.payprofform = {
        fornavn: '',
        efternavn: '',
        mellemnavn: '',
        fodelsdag: '',
        Adresse: '',
        zipcode: '',
        by: '',
        stat: '',
        land: 'DK',
        email: '',
        telefonnummer: '',
        telcountrycode: 45,
        cprnummer: '',
        sprog: 'da',
        currency: 'DKK',
        cvr: '',
        companyName: ''
      };
    },
    supplierprofile: function supplierprofile() {
      var _this9 = this;

      this.loading = true;
      this.$http.get(this.$bitrixapi + 'supplier/getSupplierInfo/' + this.haaid, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          _this9.partnerprofile = res.data;
          _this9.partnertelephone = res.data.MOBILE;
          _this9.partneremail = res.data.EMAIL;
          _this9.payprofform.telefonnummer = Number(res.data.UF_CRM_COMPANY_TELEPHONE);
          _this9.payprofform.email = res.data.EMAIL;
          _this9.payprofform.by = res.data.UF_CRM_COMPANY_CITY;
          _this9.payprofform.stat = res.data.UF_CRM_COMPANY_CITY;
          _this9.payprofform.Adresse = res.data.UF_CRM_COMPANY_ADDRESS;
          _this9.payprofform.zipcode = res.data.UF_CRM_COMPANY_ZIP_CODE;
          _this9.payprofform.cvr = res.data.UF_CRM_COMPANY_CVR;
          _this9.payprofform.companyName = res.data.TITLE;

          _this9.getPayproffacc();
        } else {
          _this9.$message({
            type: 'error',
            message: res.message
          });
        }
      }, function (response) {
        _this9.$message({
          type: 'error',
          message: response.body.message
        });
      });
    },
    setmaskinput: function setmaskinput() {
      this.partneriban = this.$maskibanNumber(this.partneriban);
    }
  },
  watch: {
    'partneriban': function partneriban(newVal, oldVal) {
      var _this10 = this;

      setTimeout(function () {
        if (newVal.length > 1) {
          _this10.setmaskinput(newVal);
        }
        if (newVal.length > 21) {
          _this10.verifyIban('checkiban');
        }
      }, 200);
    }
  }
});

/***/ }),
/* 1600 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix darkblue notosans",attrs:{"id":"payproff"}},[(_vm.dashdata && _vm.dashdata !== 'undefined')?_c('div',{staticClass:"md-col-7 xs-col-12 lg-col-7 sm-col-7 flex justify-center highlights items-center hide mx-auto white-background not-rounded m0 p0",attrs:{"id":"checkpayproffbanner"}},[_vm._m(0),_vm._v(" "),_c('p',{staticClass:"darkblue h6 p1 m0 center mr3 my1"},[_vm._v("Success! Entreprisekontrakten er nu underskrevet!")]),_vm._v(" "),_c('p',{staticClass:"m0 p0 pointer",on:{"click":function($event){return _vm.closebanner()}}},[_c('i',{staticClass:"el-icon-close darkblue"})])]):_vm._e(),_vm._v(" "),(_vm.loading)?_c('div',[_c('Loading')],1):_c('div',{staticClass:"clearfix col-11 noto-sans darkblue"},[_c('div',{staticClass:"col-12 px0"},[_c('div',{staticClass:"col-12 px0 flex flex-column"},[(!_vm.dashdata)?_c('div',{staticClass:"flex justify-start items-center mt3"},[_c('p',{staticClass:"h4 semi-bold line-height-2 my2 darkblue"},[_vm._v("\n                          Bankverifikation\n                        ")])]):_vm._e(),_vm._v(" "),(!_vm.haspayproff && _vm.isexist)?_c('div',[_c('div',{staticClass:"clearfix white-background  my2"},[_c('p',{staticClass:"h4 darkblue py1 m0 semi-bold"},[_vm._v("Dit IBAN-nummer sikrer, at dine betalinger behandles hurtigt og korrekt.")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column col-12 p2 m0 items-start "},[_c('div',{staticClass:"block"},[_c('p',{staticClass:"h5 xs-m0 m0 px2"},[_vm._v("Sådan finder du din IBAN:")]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"m0 lg-col-6 md-col-6 xs-col-12 sm-col-12 px2"},[_vm._m(2),_vm._v(" "),_c('el-input',{staticClass:" white-background",attrs:{"required":"","id":"partneribannew","maxlength":"22","placeholder":"DKXXXXXXXXXXXXXXXXXX","clearable":""},model:{value:(_vm.partneriban),callback:function ($$v) {_vm.partneriban=$$v},expression:"partneriban"}}),_vm._v(" "),(_vm.ibanmessage)?_c('label',{staticClass:"error red h5 small"},[_vm._v(_vm._s(_vm.ibanmessage))]):_vm._e()],1)]),_vm._v(" "),_c('button',{staticClass:"mx2 mt3 lg-col-3 xxl-col-3 md-col-3 sm-col-3 xs-col-5 action-button white no-borde flex justify-center items-center rounded",attrs:{"disabled":!_vm.verifylink},on:{"click":function($event){_vm.updateStatusiban(_vm.partneriban),_vm.updateStatus('clicked')}}},[_c('span',{staticClass:"mx2 my1"},[_vm._v("Godkend med MitID")])])])])]):_vm._e(),_vm._v(" "),(_vm.haspayproff)?_c('div',[_vm._m(3)]):_vm._e()])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',[(!_vm.dashdata && !_vm.isexist)?_c('div',[(_vm.dashdata)?_c('div',{staticClass:"h3 semi-bold"},[_vm._v("Verificer")]):_vm._e(),_vm._v(" "),_c('el-form',{ref:"payproffform",staticClass:"md-col-7 px0 lg-col-7 sm-col-7 xs-col-12 py2",attrs:{"id":"cvrfrom","model":_vm.payprofform,"rules":_vm.anbefalformrules,"label-position":"top"}},[_c('form-wizard',{ref:"createPayproffFormWiz",attrs:{"shape":"tab","color":"#ffffff"},scopedSlots:_vm._u([{key:"footer",fn:function(props){return [_c('div',{staticClass:"col-12 p0 flex mt2",class:props.isLastStep ? 'justify-between' : 'justify-end'},[(props.activeTabIndex > 0)?_c('button',{staticClass:"outlined-primary-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){return props.prevTab()}}},[_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-back"})]),_vm._v(" "),_c('span',{staticClass:"inline-block"},[_vm._v("Tilbage")])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"action-button h5 m0 line-height-4 regular px2 p1",attrs:{"type":"button"},on:{"click":function($event){props.isLastStep ? !_vm.haspayproff && !_vm.isexist ? _vm.openconfirmPayproff() : _vm.verifyIban('updateiban') : props.nextTab()}}},[_c('span',{staticClass:"inline-block"},[_vm._v(_vm._s(props.isLastStep ? !_vm.haspayproff && !_vm.isexist ? 'Indsend' : 'Opdatering' : 'Næste'))]),_vm._v(" "),_c('span',{staticClass:"ml1"},[_c('i',{staticClass:"el-icon-right"})])])])]}}],null,false,3000037844)},[(_vm.dashdata)?_c('tab-content',[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"mb2 flex flex-column items-start p0"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"152.26","height":"35.735","viewBox":"0 0 152.26 35.735"}},[_c('defs',[_c('clipPath',{attrs:{"id":"clip-path"}},[_c('rect',{attrs:{"id":"Rectangle_1428","data-name":"Rectangle 1428","width":"152.26","height":"35.735","fill":"#2265fc"}})])]),_vm._v(" "),_c('g',{attrs:{"id":"Payproff_logo","clip-path":"url(#clip-path)"}},[_c('path',{attrs:{"id":"Path_4272","data-name":"Path 4272","d":"M820.931,52.36v0Z","transform":"translate(-668.671 -41.591)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4273","data-name":"Path 4273","d":"M820.931,78.36v0Z","transform":"translate(-668.671 -62.769)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4274","data-name":"Path 4274","d":"M3.494,27.738a3.853,3.853,0,0,1,.3-.372q2.463-2.4,4.931-4.8c.271-.264.549-.523.8-.808a.759.759,0,0,1,.633-.259q3.152.009,6.305.01c1.97,0,3.941.024,5.912-.007A9.011,9.011,0,0,0,28.8,18.744,8.648,8.648,0,0,0,31.36,13.45a9.011,9.011,0,0,0-5.207-9.257,9.5,9.5,0,0,0-4.171-.9q-10.8.015-21.607,0C.254,3.3.132,3.281,0,3.272V.022C.073.017.14.007.207.007c7.5,0,14.992-.016,22.487,0a11.9,11.9,0,0,1,6.235,1.822,12.161,12.161,0,0,1,5.7,7.677,11.819,11.819,0,0,1-1.288,9.005,12.351,12.351,0,0,1-5.591,5.1,13.307,13.307,0,0,1-5.745,1.244q-5.332.014-10.664,0a.509.509,0,0,0-.4.17C9.7,26.257,8.445,27.47,7.2,28.69c-.979.956-1.952,1.917-2.929,2.874Q2.3,33.493.323,35.42L0,35.735V10.221H26.076l.036.047L25.357,11q-2.207,2.135-4.413,4.272-1.355,1.317-2.692,2.65a.686.686,0,0,1-.529.22c-1.429-.008-2.859,0-4.288,0a.6.6,0,0,1-.094-.028l4.634-4.548H3.428v14.1l.067.072","transform":"translate(0 0)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4275","data-name":"Path 4275","d":"M472.8,65.616v-2.6c.058,0,.125-.009.192-.009q2.828,0,5.656.008a3.2,3.2,0,0,0,1.457-.308,1.853,1.853,0,0,0,1.124-1.607,11.79,11.79,0,0,0-.017-1.9A2.135,2.135,0,0,0,479,57.22c-2.04,0-4.08,0-6.12,0q-.116,0-.232.006a.9.9,0,0,0-.936,1q0,5.32,0,10.64c0,.062-.008.124,0,.185.012.14-.047.19-.188.189q-1.205-.007-2.411,0c-.136,0-.178-.057-.173-.181,0-.085,0-.17,0-.255q0-5.077,0-10.153a4.575,4.575,0,0,1,.334-1.856,3.527,3.527,0,0,1,2.549-2.057,4.586,4.586,0,0,1,1.053-.135q3.06-.019,6.12,0a4.823,4.823,0,0,1,4.967,4.65,15.076,15.076,0,0,1-.083,2.473,4.341,4.341,0,0,1-2.755,3.434,5.416,5.416,0,0,1-2.2.474c-1.955.007-3.91,0-5.865,0-.075,0-.15-.01-.248-.016","transform":"translate(-381.958 -44.465)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4276","data-name":"Path 4276","d":"M224.51,65.464c0-.844,0-1.654.006-2.464,0-.046.082-.122.134-.13a3.038,3.038,0,0,1,.439-.017q2.688,0,5.377,0a3.091,3.091,0,0,0,1.369-.287,1.816,1.816,0,0,0,1.1-1.449,6.616,6.616,0,0,0-.041-2.326,2.088,2.088,0,0,0-2.2-1.727q-3.036,0-6.073,0a1.92,1.92,0,0,0-.549.058.85.85,0,0,0-.64.794c-.022.3-.008.6-.008.9q0,4.995.014,9.989c0,.215-.06.275-.275.272-.742-.013-1.483-.009-2.225,0-.182,0-.235-.049-.235-.236.012-3.523.045-7.046.012-10.568a3.649,3.649,0,0,1,3.223-3.8,5.437,5.437,0,0,1,.9-.073c2.024,0,4.049-.022,6.072.035a4.77,4.77,0,0,1,4.768,4.515,9.31,9.31,0,0,1-.115,2.905,4.434,4.434,0,0,1-2.624,3.1,5.364,5.364,0,0,1-2.285.513c-1.924.009-3.847.008-5.771.009-.114,0-.228-.013-.369-.021","transform":"translate(-179.766 -44.315)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4277","data-name":"Path 4277","d":"M312.791,73.965c.966,0,1.933-.039,2.9.009a3.634,3.634,0,0,1,3.192,1.9,3.87,3.87,0,0,1,.447,1.9c.01,1.058.03,2.118-.009,3.175a6.291,6.291,0,0,1-.254,1.592,3.38,3.38,0,0,1-3.3,2.439c-1.845.043-3.7.079-5.537-.042a3.645,3.645,0,0,1-.944-7.043,3.37,3.37,0,0,1,1.085-.206c1.661-.025,3.322-.016,4.983-.024.181,0,.235.06.232.243-.011.7-.009,1.391,0,2.086,0,.166-.032.219-.219.218q-2.387-.014-4.775,0a1.06,1.06,0,0,0-1.1,1.115,1.091,1.091,0,0,0,1.048,1.143c.363-.009.726.01,1.089.011q1.947.006,3.894.007a1.08,1.08,0,0,0,1.219-1.211q0-1.773,0-3.547c0-.856-.379-1.26-1.238-1.264-1.87-.009-3.74,0-5.61.006-.314,0-.316,0-.318-.3,0-.68,0-1.36-.01-2.04,0-.12.029-.173.149-.174s.232-.009.347-.009h2.735v.022","transform":"translate(-249.978 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4278","data-name":"Path 4278","d":"M628.743,85.006c-.965,0-1.933.043-2.9-.009a3.587,3.587,0,0,1-3.32-2.931,3.247,3.247,0,0,1-.057-.576c0-1.267-.02-2.534,0-3.8a3.48,3.48,0,0,1,1.815-3.153,4.052,4.052,0,0,1,2.02-.513c1.684-.016,3.369-.035,5.052,0a3.511,3.511,0,0,1,3.173,1.873,3.728,3.728,0,0,1,.455,1.824c.006,1.275.023,2.55-.009,3.824A3.5,3.5,0,0,1,631.592,85c-.945.068-1.9.012-2.849.012v0m.007-2.593h0c.85,0,1.7,0,2.549,0a.9.9,0,0,0,1-.968c.006-1.305-.006-2.611,0-3.916a.824.824,0,0,0-.3-.627,1,1,0,0,0-.719-.266c-1.645,0-3.291-.026-4.936,0-.87.012-1.2.4-1.189,1.275q0,.6.009,1.205c.006.765-.012,1.53.024,2.294.034.716.363,1,1.085,1.007.826.006,1.653,0,2.48,0","transform":"translate(-507.012 -60.278)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4279","data-name":"Path 4279","d":"M702.866,63.913V63.45q0-5.885.007-11.771a3.559,3.559,0,0,1,3.1-3.52,7.6,7.6,0,0,1,1.291-.1c1.746-.01,3.491,0,5.237,0h.294v2.651c-2.045,0-4.06,0-6.075,0-.579,0-.961.214-1.091.667a1.75,1.75,0,0,0-.058.48q.007,5.828.021,11.656c0,.4,0,.4-.394.4-.764,0-1.527,0-2.333,0","transform":"translate(-572.504 -39.143)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4280","data-name":"Path 4280","d":"M766.72,57.5c0-1.916.021-3.832-.006-5.748a3.561,3.561,0,0,1,3.406-3.635c1.223-.087,2.455-.047,3.683-.057.865-.007,1.731,0,2.6,0,.191,0,.251.053.246.253q-.025,1.064-.009,2.128c0,.226-.069.287-.292.285-1.839-.01-3.677-.008-5.516-.007-.193,0-.386.007-.578.026a.925.925,0,0,0-.86.826,3.722,3.722,0,0,0-.036.508q0,5.157.009,10.314c0,.432.012.865.028,1.3.006.166-.04.233-.22.231-.757-.008-1.514-.006-2.271,0-.156,0-.194-.058-.194-.206q.006-3.105,0-6.211h.012","transform":"translate(-624.503 -39.14)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4281","data-name":"Path 4281","d":"M412.671,73.944h.568c.641,0,1.282.011,1.923,0,.188,0,.249.054.249.25q-.011,5.921-.009,11.842a3.551,3.551,0,0,1-3.539,3.724c-1.533.086-3.073.031-4.61.036-.571,0-.559,0-.55-.563.01-.625,0-1.251-.012-1.876,0-.17.039-.227.217-.227,1.483.006,2.966,0,4.449,0,.116,0,.232.007.347.016a.857.857,0,0,0,.97-.851c.009-.169,0-.34,0-.509q0-5.794,0-11.587Z","transform":"translate(-331.26 -60.229)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4282","data-name":"Path 4282","d":"M570.408,74.061c0,.444,0,.852,0,1.26,0,.379.006.757.021,1.135.007.165-.031.231-.216.23q-2.815-.018-5.631-.018a3.916,3.916,0,0,0-.553.039.915.915,0,0,0-.835.8,2.784,2.784,0,0,0-.033.484q0,3.453.013,6.905c0,.06-.011.119-.019.195h-2.05c-.629,0-.629,0-.629-.624q0-3.279,0-6.558a3.867,3.867,0,0,1,.442-1.941,3.707,3.707,0,0,1,3.005-1.858,9.542,9.542,0,0,1,1.11-.049c1.7,0,3.4,0,5.1,0h.276","transform":"translate(-456.523 -60.325)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4283","data-name":"Path 4283","d":"M385.931,74.055c.862,0,1.7,0,2.544,0,.16,0,.169.086.169.206,0,.571,0,1.143,0,1.715q0,2.642,0,5.283a1.965,1.965,0,0,0,.034.46.954.954,0,0,0,1.062.731q2.015-.025,4.03-.045c.285,0,.57,0,.881,0,.009.092.022.174.023.255,0,.726,0,1.452.009,2.177,0,.21-.066.26-.264.259-1.545-.008-3.09.014-4.634-.012a3.806,3.806,0,0,1-3.076-1.4,3.584,3.584,0,0,1-.784-2.256c-.019-2.417-.007-4.835-.007-7.253,0-.03.006-.059.012-.117","transform":"translate(-314.339 -60.317)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4284","data-name":"Path 4284","d":"M723.448,73.962h.326c1.847,0,3.693.006,5.54,0,.225,0,.306.051.3.3-.021.7-.015,1.406-.007,2.109,0,.192-.06.248-.254.247-1.87-.009-3.739-.008-5.609-.009-.3,0-.3,0-.3-.291q0-1.089-.006-2.179c0-.045,0-.09.007-.175","transform":"translate(-589.263 -60.244)","fill":"#2265fc"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_4285","data-name":"Path 4285","d":"M787.263,73.973h.285q2.756,0,5.511,0c.329,0,.32.005.317.339q-.009,1.029,0,2.058c0,.158-.027.239-.214.239q-2.837-.01-5.674-.006c-.119,0-.231.022-.23-.164.006-.809,0-1.618,0-2.469","transform":"translate(-641.245 -60.253)","fill":"#2265fc"}})])]),_vm._v(" "),_c('span',[_vm._v("Godkendt af Finanstilsynet")])]),_vm._v(" "),_c('div',{staticClass:"flex justify-start items-center cyprus"},[_c('span',[_c('svg',{staticClass:"block",attrs:{"fill":"currentColor","xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-.001 5.75c.69 0 1.251.56 1.251 1.25s-.561 1.25-1.251 1.25-1.249-.56-1.249-1.25.559-1.25 1.249-1.25zm2.001 12.25h-4v-1c.484-.179 1-.201 1-.735v-4.467c0-.534-.516-.618-1-.797v-1h3v6.265c0 .535.517.558 1 .735v.999z"}})])]),_vm._v(" "),_c('p',{staticClass:"h5 line-height-1 m0 ml1 p0"},[_vm._v("Information")])]),_vm._v(" "),_c('div',{staticClass:"py1"}),_vm._v(" "),_c('div',{staticClass:"clearfix pr3 mb2"},[_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("For at sikre en tryg oplevelse i hele forløbet, har vi hos Håndværker.dk indgået et samarbejde med PayProff, om en deponeringskonto til opbevaring af din kundes penge, indtil projektet er fuldført.\n                          ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("PayProff er godkendt som betalingstjeneste hos Finanstilsynet. Du kan se deres licens  "),_c('a',{staticClass:"semi-bold",attrs:{"href":"https://virksomhedsregister.finanstilsynet.dk/virksomhed-under-tilsyn.html?v=30F336FD-6CE2-EC11-A2DB-005056907186","target":"_blank"}},[_vm._v("her")]),_vm._v(", og læse mere om de godkendelser, de har fået\n                          ")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("\n                          PayProff er en betalingsløsning skabt til at bringe sikkerhed ind i online pengehandel. Din kunde overfører entreprisesummen til kontoen, hvor de opbevares mens opgaven står på. Når opgaven er udført, kan du anmode om en udbetaling fra kunden, der via sin PayProff profil skal godkende udbetalingen.")]),_vm._v(" "),_c('p',{staticClass:"line-height-4 mt1"},[_vm._v("Det er med til at sikre dig, at der er en betaling klar, når projektet afsluttes.")])]),_vm._v(" "),_c('div',[_c('el-collapse',{attrs:{"accordion":""},model:{value:(_vm.activeNames),callback:function ($$v) {_vm.activeNames=$$v},expression:"activeNames"}},[_c('el-collapse-item',{attrs:{"name":"1"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor har du brug for mine bankoplysninger?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("Vi har brug for dine bankoplysninger for at sende dig pengene eller for at\n                                refundere dig, hvis det er nødvendigt. Det betyder også, at du ikke behøver\n                                at dele dine bankoplysninger med din kontraktpartner.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"2"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvordan overfører jeg pengene til PayProff?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("De tilgængelige betalingsmetoder er: bankoverførsel, snart også i VISA,\n                                Mastercard, Dankort og Mobilepay. Ved bankoverførsler får du alle de\n                                bankoplysninger og referencenummer, du skal bruge input, når du foretager\n                                overførslen. Bemærk venligst, at hvis du ikke indtaster det korrekte\n                                referencenummer Der kan opstå forsinkelser, da vores system ikke vil være\n                                i stand til at afstemme din betaling med det samme.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"3"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor bliver jeg stillet ekstra sikkerhedsspørgsmål?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("For at overholde lovmæssige krav skal vi muligvis stille dig et par\n                                ekstra spørgsmål. Dette er normal procedure for at sikre, at vi forstår,\n                                hvordan du vil bruge vores tjenester, og det hjælper vi bekæmper\n                                økonomisk kriminalitet.")])],2),_vm._v(" "),_c('el-collapse-item',{attrs:{"name":"4"}},[_c('template',{slot:"title"},[_c('span',{staticClass:"h6 line-height-1 m0 p0 semi-bold py1"},[_vm._v("Hvorfor skal PayProff bekræfte min identitet? Hvad er Kend din kunde (KYC)?")])]),_vm._v(" "),_c('p',{staticClass:"line-height-golden"},[_vm._v("PayProff er forpligtet til at levere et sikkert og sikkert miljø. Desuden har vi\n                                en juridisk forpligtelse til ved, hvem vores kunder er. Det betyder, at hvis du\n                                er privatperson, skal vi udføre en identitetsbekræftelse med NemID i Danmark.\n                                Flere muligheder om identitetsbekræftelse både for private enkeltpersoner\n                                og virksomheder i og uden for Danmark stilles til rådighed i 3. kvartal 2021.")])],2)],1)],1)])]):_vm._e(),_vm._v(" "),_c('tab-content',{attrs:{"before-change":_vm.validateCreatePayproffFirstTab}},[_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Fornavn","prop":"fornavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"fornavn","clearable":""},model:{value:(_vm.payprofform.fornavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "fornavn", $$v)},expression:"payprofform.fornavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  ml-auto",attrs:{"label":"Efternavn","id":"efternavn","prop":"efternavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"efternavn","clearable":""},model:{value:(_vm.payprofform.efternavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "efternavn", $$v)},expression:"payprofform.efternavn"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 mr-auto",attrs:{"label":"Mellemnavn","prop":"mellemnavn"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"mellemnavn","clearable":""},model:{value:(_vm.payprofform.mellemnavn),callback:function ($$v) {_vm.$set(_vm.payprofform, "mellemnavn", $$v)},expression:"payprofform.mellemnavn"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-6"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype  p0 ml-auto",attrs:{"label":"Fødelsdag","id":"fodelsdag","prop":"fodelsdag"}},[_c('datepicker',{staticClass:"col-12 m0 p0",attrs:{"id":"datepickeroffer2","disabled":_vm.haspayproff || _vm.isexist,"bootstrapStyling":false,"placeholder":"Fødelsdag","language":_vm.da},model:{value:(_vm.payprofform.fodelsdag),callback:function ($$v) {_vm.$set(_vm.payprofform, "fodelsdag", $$v)},expression:"payprofform.fodelsdag"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Adresse","prop":"Adresse"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"Strandlodsvej 6, 1. sal","clearable":""},model:{value:(_vm.payprofform.Adresse),callback:function ($$v) {_vm.$set(_vm.payprofform, "Adresse", $$v)},expression:"payprofform.Adresse"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"zipcode","id":"zipcode","prop":"zipcode"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"2300","clearable":""},model:{value:(_vm.payprofform.zipcode),callback:function ($$v) {_vm.$set(_vm.payprofform, "zipcode", $$v)},expression:"payprofform.zipcode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"By","prop":"by"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"København s","clearable":""},model:{value:(_vm.payprofform.by),callback:function ($$v) {_vm.$set(_vm.payprofform, "by", $$v)},expression:"payprofform.by"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Stat","id":"stat","prop":"stat"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"stat","clearable":""},model:{value:(_vm.payprofform.stat),callback:function ($$v) {_vm.$set(_vm.payprofform, "stat", $$v)},expression:"payprofform.stat"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 mr-auto",attrs:{"label":"Email","prop":"email"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"E-mail","clearable":""},model:{value:(_vm.payprofform.email),callback:function ($$v) {_vm.$set(_vm.payprofform, "email", $$v)},expression:"payprofform.email"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Land","id":"land","prop":"land"}},[_c('el-select',{staticClass:"white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"filterable":"","clearable":"","placeholder":"Country"},model:{value:(_vm.payprofform.land),callback:function ($$v) {_vm.$set(_vm.payprofform, "land", $$v)},expression:"payprofform.land"}},_vm._l((_vm.countryData),function(country,index){return _c('el-option',{key:index,attrs:{"label":country,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefonnummer","id":"telefonnummer","prop":"telefonnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"maxlength":"8","placeholder":"Tel.(8 cifre)","clearable":""},model:{value:(_vm.payprofform.telefonnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "telefonnummer", _vm._n($$v))},expression:"payprofform.telefonnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Telefon contry code","id":"telcountrycode","prop":"telcountrycode"}},[_c('el-input',{staticClass:"white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"placeholder":"+45","clearable":""},model:{value:(_vm.payprofform.telcountrycode),callback:function ($$v) {_vm.$set(_vm.payprofform, "telcountrycode", _vm._n($$v))},expression:"payprofform.telcountrycode"}})],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"CPR nummer","id":"cprnummer","prop":"cprnummer"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"10","disabled":_vm.haspayproff || _vm.isexist,"placeholder":"XXXXXXXXXX","clearable":""},model:{value:(_vm.payprofform.cprnummer),callback:function ($$v) {_vm.$set(_vm.payprofform, "cprnummer", $$v)},expression:"payprofform.cprnummer"}})],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Sprog","id":"sprog","prop":"sprog"}},[_c('el-select',{staticClass:"white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"filterable":"","placeholder":"sprog","clearable":""},model:{value:(_vm.payprofform.sprog),callback:function ($$v) {_vm.$set(_vm.payprofform, "sprog", $$v)},expression:"payprofform.sprog"}},_vm._l((_vm.languagesData),function(language,index){return _c('el-option',{key:index,attrs:{"label":language,"value":index}})}),1)],1)],1)]),_vm._v(" "),_c('div',{staticClass:"flex flex-row mobile-flex-column"},[_c('div',{staticClass:"m0 p0 pr2 mp0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Betalingsmiddel","id":"currency","prop":"currency"}},[_c('el-select',{staticClass:"white-background",attrs:{"disabled":_vm.haspayproff || _vm.isexist,"filterable":"","clearable":"","placeholder":"DKK"},model:{value:(_vm.payprofform.currency),callback:function ($$v) {_vm.$set(_vm.payprofform, "currency", $$v)},expression:"payprofform.currency"}},[_c('el-option',{attrs:{"vlabel":"DKK","value":"DKK"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"m0 p0 lg-col-6 md-col-6 xs-col-12 sm-col-12"},[_c('el-form-item',{staticClass:"border-none el-form-opgavetype p0 ml-auto",attrs:{"label":"Iban","id":"partneriban","prop":"partneriban"}},[_c('el-input',{staticClass:" white-background",attrs:{"maxlength":"22","placeholder":"DKXXXXXXXXXXXXXXXXXX","clearable":""},model:{value:(_vm.partneriban),callback:function ($$v) {_vm.partneriban=$$v},expression:"partneriban"}})],1),_vm._v(" "),(_vm.ibanmessage)?_c('label',{staticClass:"error red h5 small"},[_vm._v(_vm._s(_vm.ibanmessage))]):_vm._e()],1)])])],1)],1)],1):_vm._e()])]),_vm._v(" "),_c('b-modal',{ref:"confirmPayproff",attrs:{"centered":"","hide-footer":"","id":"confirmPayproff","no-close-on-backdrop":true,"size":"lg"},model:{value:(_vm.confirmPayproff),callback:function ($$v) {_vm.confirmPayproff=$$v},expression:"confirmPayproff"}},[_c('div',{staticClass:"col-12 flex justify-end items-center pt1 p0 mx-auto modal-header"},[_c('button',{staticClass:"ml-auto h4 p0 primary-white-button pointer close",on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-circle-close"})])]),_vm._v(" "),_c('div',{staticClass:"clearfix white-background"},[_c('div',{staticClass:"flex flex-column items-start col-12 pb3 pt1 px3"},[_c('p',{staticClass:"muted-color h6 pt1"},[_vm._v("Hvad er en politisk eksponeret person?")]),_vm._v(" "),_c('p',{staticClass:"h6 semi-bold py1 mt1"},[_vm._v("Politisk eksponerede personer (PEP'er) er personer, der bestrider et særligt offentligt tillidshverv og som følge af dette kan være modtagelige for bestikkelse og anden korruption.")]),_vm._v(" "),_c('p',{staticClass:"h6 mt1 center"},[_vm._v("Er du en politisk udsat person? (PEP) ( Du ved, hvis du er )")]),_vm._v(" "),_c('div',{staticClass:"col-12 flex justify-start my2"},[[_c('el-radio',{attrs:{"label":true},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Ja")]),_vm._v(" "),_c('el-radio',{attrs:{"label":false},model:{value:(_vm.isPep),callback:function ($$v) {_vm.isPep=$$v},expression:"isPep"}},[_vm._v("Nej")])]],2)])]),_vm._v(" "),_c('div',{staticClass:"flex "},[_c('button',{staticClass:" mt2 not-rounded outlined-primary-button h5 regular no-hover mr-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeconfirmPayproff()}}},[_c('i',{staticClass:"el-icon-back pr1"}),_vm._v("Tilbage\n            ")]),_vm._v(" "),_c('button',{staticClass:"mt2 not-rounded action-button h5 regular no-hover ml-auto p2 px4 line-height0 mb1",attrs:{"type":"button"},on:{"click":function($event){return _vm.verifyIban('')}}},[_vm._v("Godkend med MitID "),_c('i',{staticClass:"pl1 el-icon-right"})])])]),_vm._v(" "),_c('div',{staticClass:"py4"}),_vm._v(" "),_c('simplert',{ref:"simplert",attrs:{"useRadius":true,"useIcon":true}}),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{},[_c('i',{staticClass:"el-icon-circle-check green h3 m0"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',[_c('li',[_vm._v("Log ind på din netbank.")]),_vm._v(" "),_c('li',[_vm._v("Gå til kontodetaljer eller kontooversigt.")]),_vm._v(" "),_c('li',[_vm._v("Find og noter dit IBAN-nummer. Det starter typisk med 'DK' for danske bankkonti.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"p0 m0 font12",attrs:{"for":"partneribannew"}},[_c('span',{staticClass:"red"},[_vm._v("*")]),_vm._v("Iban-nummer")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('p',{staticClass:"h5 ml4 m0"},[_c('i',{staticClass:"el-icon-success green mr1 h4"}),_vm._v("Verificeret")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1601 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_version_vue__ = __webpack_require__(1602);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7caecf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_version_vue__ = __webpack_require__(1603);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_version_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d7caecf_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_version_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1602 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {},
  created: function created() {},
  data: function data() {
    return {
      versionData: Object({"NODE_ENV":"production","BITRIXAPI":"https://bitrixapi.haandvaerker.dk/v1/"})
    };
  }
});

/***/ }),
/* 1603 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p3"},[_c('p',{staticClass:"h4 bold darkblue line-height-2 my3"},[_vm._v("Version")]),_vm._v(" "),_vm._l((_vm.versionData),function(version,index){return _c('p',{key:index},[_c('span',{staticClass:"bold caps"},[_vm._v(_vm._s(index))]),_vm._v(": "+_vm._s(version))])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1604 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documents_vue__ = __webpack_require__(1606);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c8701a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_documents_vue__ = __webpack_require__(1607);
function injectStyle (ssrContext) {
  __webpack_require__(1605)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_documents_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_54c8701a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_documents_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1605 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1606 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler
  },
  data: function data() {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: true,
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      bulkActionVisible: false,
      createFolderFormVisible: false,
      createFolderForm: {
        name: ''
      },
      submitted: false,
      acceptedFileType: '.jpg,.png,.pdf,.pptx',
      addFileFormVisible: false,
      addFileForm: {
        file: []
      },
      inputKeywordData: [],
      keywordsList: [],
      selectedCheckboxesData: [],
      renameFileFormVisible: false,
      totalSize: null
    };
  },
  created: function created() {
    this.displayProjects();
  },

  methods: {
    displayProjects: function displayProjects() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects/', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (projectProp, projectPropIndex) {
            if (projectProp.IS_ACTIVE === 1) {
              _this.currentProjectInfo = projectProp;
              _this.getKeywordsList();
              _this.getDefaultFolder();
            }
          });
        }
      }, function (response) {
        var error = response.body;
        _this.$refs.errorMsg.showMsg(error);
      });
    },
    getKeywordsList: function getKeywordsList() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects/tags', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        for (var i = 0; i < res.length; i++) {
          _this2.keywordsList.push({
            id: res[i].ID,
            value: res[i].DA_DK
          });
        }
      }, function (response) {
        _this2.displayFiles(_this2.currentFolderId);
        var error = response.body;
        _this2.$refs.errorMsg.showMsg(error);
      });
    },
    getDefaultFolder: function getDefaultFolder() {
      var _this3 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/rootFolder', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this3.defaultFolderId = res.data.rootFolderId;
        _this3.currentFolderId = res.data.rootFolderId;
        _this3.parentFolderData.push({
          folderId: _this3.defaultFolderId,
          folderName: 'Main'
        });

        _this3.setKeywordInputValue();
        _this3.displayFiles(_this3.currentFolderId);
      }, function (response) {
        var error = response.body;
        _this3.$refs.errorMsg.showMsg(error);
      });
    },
    displayFiles: function displayFiles(folderId) {
      var _this4 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/folder/' + folderId + '/children', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this4.documentsData = res.data.sort(function (a, b) {
          return b.ID - a.ID;
        });

        _this4.setKeywordInputValue();
        _this4.getTotalSize();
        _this4.selectedCheckboxesData = [];
        _this4.bulkActionVisible = false;
        _this4.loading = false;
        _this4.formLoading = false;
      }, function (response) {
        var error = response.body;
        _this4.$refs.errorMsg.showMsg(error);
      });
    },
    checkboxChanged: function checkboxChanged(selectedData) {
      this.selectedCheckboxesData = selectedData;
      if (selectedData.length > 0) {
        this.bulkActionVisible = true;
      } else {
        this.bulkActionVisible = false;
      }
    },
    formatBytes: function formatBytes(bytes) {
      var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (bytes === 0) {
        return '0 Bytes';
      }
      var k = 1024;
      var dm = decimals < 0 ? 0 : decimals;
      var sizes = ['Bytes', 'KB', 'MB', 'GB'];
      var i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    },
    customColorMethod: function customColorMethod(percentage) {
      if (percentage < 30) {
        return '#0092B9';
      } else if (percentage < 70) {
        return '#003645';
      } else {
        return '#fc000f';
      }
    },
    previewFile: function previewFile(fileLink) {
      window.open(fileLink);
    },
    loopCopyFile: function loopCopyFile(type, id) {
      var ids = [];
      if (type === 'single') {
        ids.push(id);
      } else {
        for (var i = 0; i < this.selectedCheckboxesData.length; i++) {
          if (this.selectedCheckboxesData[i]) {
            ids.push(parseInt(this.selectedCheckboxesData[i].ID));
          }
        }
      }
      var lastLoop = false;
      for (var k = 0; k < ids.length; k++) {
        for (var x = 0; x < this.documentsData.length; x++) {
          if (this.documentsData[x].ID === ids[k]) {
            if (k === ids.length - 1) {
              lastLoop = true;
            }
            this.copyFile(this.documentsData[x].ID, this.documentsData[x].NAME, lastLoop);
          }
        }
      }
    },
    copyFile: function copyFile(fileId, fileName, lastLoop) {
      var _this5 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/file/copy?parentId=' + this.currentFolderId + '&fileId=' + fileId, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        if (lastLoop) {
          _this5.displayFiles(_this5.currentFolderId);
          _this5.$message({
            type: 'success',
            message: 'Succes'
          });
        }
      }, function (response) {
        _this5.displayFiles(_this5.currentFolderId);
        var error = response.body;
        _this5.$refs.errorMsg.showMsg(error);
      });
    },
    showCreateFolder: function showCreateFolder() {
      this.createFolderFormVisible = true;
    },
    closeCreateFolder: function closeCreateFolder() {
      this.submitted = false;
      this.createFolderFormVisible = false;
    },
    addFolder: function addFolder() {
      var _this6 = this;

      this.submitted = true;
      var valid = false;
      if (this.createFolderForm.name !== '') {
        valid = true;
      }
      if (valid) {
        this.formLoading = true;
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        };
        var data = {};
        this.$http.post(this.$bitrixapi + 'partner/folder?folderName=' + this.createFolderForm.name + '&parentId=' + this.currentFolderId, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this6.displayFiles(_this6.currentFolderId);
          _this6.$message({
            type: 'success',
            message: 'Succes'
          });
          _this6.clearFields();
          _this6.closeCreateFolder();
        }, function (response) {
          var error = response.body;
          _this6.$refs.errorMsg.showMsg(error);
        });
      }
    },
    clearFields: function clearFields() {
      this.createFolderForm.name = '';
      this.addFileForm.file = [];
    },
    uploadFile: function uploadFile(file, fileList) {
      this.addFileForm.file = fileList;
    },
    removeUpload: function removeUpload(file) {
      var images = this.addFileForm.file;
      for (var i = 0; i < images.length; i++) {
        if (file.uid === images[i].uid) {
          images.splice(i, 1);
        }
      }
      this.addFileForm.file = images;
    },
    showAddFileForm: function showAddFileForm() {
      this.addFileFormVisible = true;
    },
    closeAddFileForm: function closeAddFileForm() {
      this.submitted = false;
      this.addFileFormVisible = false;
    },
    addFile: function addFile() {
      var _this7 = this;

      this.submitted = true;
      var files = this.addFileForm.file;
      if (files.length > 0) {
        this.formLoading = true;
        var formData = new FormData();
        for (var i = 0; i < files.length; i++) {
          formData.append('files[]', files[i].raw);
        }
        var headers = {
          Authorization: 'Bearer ' + this.salesPerson
        };
        this.$http.post(this.$bitrixapi + 'partner/files?parentId=' + this.currentFolderId, formData, { headers: headers }, { emulateJSON: true }).then(function (response) {
          _this7.displayFiles(_this7.currentFolderId);
          _this7.closeAddFileForm();
          _this7.$message({
            type: 'success',
            message: 'Succes'
          });
        }, function (response) {
          _this7.formLoading = false;
          var error = response.body;
          _this7.$refs.errorMsg.showMsg(error);
        });
      }
    },
    removeKeyword: function removeKeyword(fileId, keywordId) {
      var _this8 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.delete(this.$bitrixapi + 'partner/file/' + fileId + '/keyword?keywordId=' + keywordId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        _this8.displayFiles(_this8.currentFolderId);
        _this8.$message({
          type: 'success',
          message: 'Succes'
        });
      }, function (response) {
        _this8.displayFiles(_this8.currentFolderId);
        var error = response.body;
        _this8.$refs.errorMsg.showMsg(error);
      });
    },
    showInputKeyword: function showInputKeyword(fileId) {
      var input = document.querySelector('.input-keyword-' + fileId);
      var button = document.querySelector('.button-new-tag-' + fileId);
      input.classList.remove('hide');
      input.querySelector('input').focus();
      button.classList.add('hide');
    },
    hideInputKeyword: function hideInputKeyword(fileId, index) {
      this.inputKeywordData[index].value = null;
      var input = document.querySelector('.input-keyword-' + fileId);
      var button = document.querySelector('.button-new-tag-' + fileId);
      button.classList.remove('hide');
      input.classList.add('hide');
    },
    setKeywordInputValue: function setKeywordInputValue() {
      for (var i = 0; i < this.documentsData.length; i++) {
        this.inputKeywordData.push({
          value: null
        });
      }
    },
    addKeyword: function addKeyword(fileId, value, index) {
      var type = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      if (value) {
        var keyword = this.keywordsList.filter(function (property) {
          return property.value === value;
        })[0];
        this.saveInputKeyword(fileId, keyword.id, keyword.value, index, type);
      }
    },
    saveInputKeyword: function saveInputKeyword(fileId, keywordId, keywordName, index) {
      var _this9 = this;

      var type = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

      this.hideInputKeyword(fileId, index);
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      var filetype = 'file';
      if (type === 'folder') {
        filetype = 'folder';
      }
      this.$http.post(this.$bitrixapi + 'partner/' + filetype + '/' + fileId + '/keyword?keywordId=' + keywordId + '&keywordName=' + keywordName, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this9.displayFiles(_this9.currentFolderId);
        _this9.$message({
          type: 'success',
          message: 'Succes'
        });
      }, function (response) {
        _this9.displayFiles(_this9.currentFolderId);
        var error = response.body;
        _this9.$refs.errorMsg.showMsg(error);
      });
    },
    showRenameFile: function showRenameFile(type, row) {
      if (type === 'single') {
        this.selectedCheckboxesData.push(row);
      }
      this.renameFileFormVisible = true;
    },
    closeRenameFile: function closeRenameFile() {
      this.selectedCheckboxesData = [];
      this.submitted = false;
      this.renameFileFormVisible = false;
    },
    renameFile: function renameFile() {
      var _this10 = this;

      this.formLoading = true;
      var fields = document.querySelectorAll('.editFile');
      var lastLoop = false;
      fields.forEach(function (propFields, propFieldsIndex) {
        var id = propFields.id.split('-')[0];
        var type = propFields.id.split('-')[1];
        var value = '';
        var url = '';
        var httpType = '';
        if (type !== 'folder') {
          value = propFields.value + '.' + type;
          url = _this10.$bitrixapi + 'partner/file/rename?id=' + id + '&newName=' + value;
          httpType = 'post';
        } else {
          value = propFields.value;
          url = _this10.$bitrixapi + 'partner/folder/' + id + '?newName=' + value;
          httpType = 'put';
        }
        if (propFieldsIndex === fields.length - 1) {
          lastLoop = true;
        }
        var headers = {
          Authorization: 'Bearer ' + _this10.salesPerson
        };
        var data = {};
        _this10.$http[httpType](url, data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          if (lastLoop) {
            _this10.displayFiles(_this10.currentFolderId);
            _this10.closeRenameFile();
            _this10.$message({
              type: 'success',
              message: 'Succes'
            });
          }
        }, function (response) {
          _this10.formLoading = false;
          _this10.displayFiles(_this10.currentFolderId);
          var error = response.body;
          _this10.$refs.errorMsg.showMsg(error);
        });
      });
    },
    querySearchFilter: function querySearchFilter(queryString, callback) {
      var data = this.keywordsList;
      var results = queryString ? data.filter(this.createFilter(queryString)) : data;
      callback(results);
    },
    createFilter: function createFilter(queryString) {
      return function (data) {
        return data.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0;
      };
    },
    confirmDelete: function confirmDelete(type, fileId, fileType) {
      var _this11 = this;

      this.$confirm('Bekræft sletning', 'Slette', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Afbestille',
        type: 'warning'
      }).then(function () {
        var lastLoop = false;
        if (type === 'single') {
          lastLoop = true;
          _this11.deleteFile(fileId, fileType, lastLoop);
        } else {
          _this11.selectedCheckboxesData.forEach(function (selectedProp, selectedPropIndex) {
            var fileId = selectedProp.ID;
            var fileType = selectedProp.TYPE;
            if (selectedPropIndex === _this11.selectedCheckboxesData.length - 1) {
              lastLoop = true;
            }
            _this11.deleteFile(fileId, fileType, lastLoop);
          });
        }
      }).catch(function () {});
    },
    deleteFile: function deleteFile(fileId, fileType, lastLoop) {
      var _this12 = this;

      console.log(fileType);
      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.delete(this.$bitrixapi + 'partner/' + fileType + '/' + fileId, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        _this12.displayFiles(_this12.currentFolderId);
        if (lastLoop) {
          _this12.$message({
            type: 'success',
            message: 'Succes'
          });
        }
      }, function (response) {
        _this12.displayFiles(_this12.currentFolderId);
        var error = response.body;
        _this12.$refs.errorMsg.showMsg(error);
      });
    },
    filterFile: function filterFile(name) {
      this.searchQuery = name;
    },
    getTotalSize: function getTotalSize() {
      var _this13 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/folder/totalsize', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        _this13.totalSize = Math.floor(parseFloat(res.data.split(' ')[0])) + ' ' + res.data.split(' ')[1];
      }, function (response) {
        var error = response.body;
        _this13.$refs.errorMsg.showMsg(error);
      });
    },
    folderChange: function folderChange(currentFolderId, currentFolderName, currentFolderParentId, index, type) {
      this.loading = true;
      var folderId = '';
      this.searchQuery = '';
      if (type === 'in') {
        this.parentFolderData.push({
          folderId: currentFolderId,
          folderName: currentFolderName
        });
      } else {
        for (var i = 0; i < this.parentFolderData.length; i++) {
          if (i > index) {
            this.parentFolderData.splice(i, 1);
            i--;
          }
        }
      }
      folderId = this.parentFolderData[this.parentFolderData.length - 1].folderId;
      this.currentFolderId = folderId;
      this.displayFiles(folderId);
    }
  },
  computed: {
    resultQuery: function resultQuery() {
      var _this14 = this;

      if (this.searchQuery) {
        return this.documentsData.filter(function (doc) {
          return _this14.searchQuery.toLowerCase().split(' ').every(function (v) {
            return doc.NAME.toLowerCase().includes(v);
          });
        });
      } else {
        return this.documentsData;
      }
    }
  }
});

/***/ }),
/* 1607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"documents"}},[(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"col-12"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"flex mb3"},[_c('div',{staticClass:"col-8 flex pr2 pl0"},[_c('el-input',{staticClass:"flex",attrs:{"placeholder":"Skriv noget","prefix-icon":"el-icon-search"},model:{value:(_vm.searchQuery),callback:function ($$v) {_vm.searchQuery=$$v},expression:"searchQuery"}})],1),_vm._v(" "),_c('div',{staticClass:"col-2 px2"},[_c('button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.showCreateFolder()}}},[_vm._v("\n                  Opret mappe\n                ")])]),_vm._v(" "),_c('div',{staticClass:"col-2 px2"},[_c('button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular col-12",attrs:{"type":"button"},on:{"click":function($event){return _vm.showAddFileForm()}}},[_vm._v("\n                  Upload fil\n                ")])])]),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('ol',{staticClass:"breadcrumb border-none transparent px0 mb-0"},_vm._l((_vm.parentFolderData),function(folder,index){return _c('li',{key:index,staticClass:"h6 breadcrumb-item pointer",on:{"click":function($event){return _vm.folderChange(folder.folderId, folder.folderName, _vm.currentFolderParentId, index, 'out')}}},[_c('a',[_vm._v(_vm._s(folder.folderName))])])}),0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap"},[_c('div',{staticClass:"col-9 mb3"},[_c('div',{staticClass:"flex mb3"},_vm._l((_vm.documentsData),function(docs,index){return (index <= 3)?_c('div',{key:index,staticClass:"pointer col-3 flex border p2 mr1",on:{"click":function($event){return _vm.filterFile(docs.NAME)}}},[(docs.TYPE == 'folder')?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35","viewBox":"0 0 26.443 22.744"}},[_c('g',{attrs:{"id":"Group_3157","data-name":"Group 3157","transform":"translate(1313.87 -105.256)"}},[_c('path',{attrs:{"id":"Path_1013","data-name":"Path 1013","d":"M.969.516H0A.581.581,0,0,1-.5.008.581.581,0,0,1,0-.5H.969a.552.552,0,0,1,.469.508A.552.552,0,0,1,.969.516Z","transform":"translate(-1295.703 107.953)","fill":"#fe9444"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1013-2","data-name":"Path 1013","d":"M787.936,198.609V183.245c0-1.014-.721-1.17-1.773-1.17h-3.519a1.007,1.007,0,0,0-.254.013.379.379,0,0,0,.038.746,1.766,1.766,0,0,0,.255.006H786.3c.638,0,.864.222.864.851q0,7.235,0,14.47c0,.042,0,.085,0,.128-.008.291-.132.423-.418.43-.187,0-.377-.017-.562,0-.224.024-.278-.048-.278-.274q.012-5.946.006-11.892a2.2,2.2,0,0,0-.054-.608,1.434,1.434,0,0,0-1.512-1.041c-3.767,0-7.535-.012-11.3.008a1.958,1.958,0,0,1-1.868-.993,2.385,2.385,0,0,0-2.22-1.2c-1.4.013-2.8,0-4.194.007-.171,0-.248-.034-.231-.221s0-.357,0-.536a1.178,1.178,0,0,1,1.322-1.321l5.114,0a2.313,2.313,0,0,1,.606.071,1.909,1.909,0,0,1,1.091.941,2.408,2.408,0,0,0,2.185,1.172c1.364-.009,1.728,0,3.091,0a1.661,1.661,0,0,0,.179,0,.36.36,0,0,0,.353-.368.365.365,0,0,0-.332-.388,1.243,1.243,0,0,0-.23-.006h-3.142a1.625,1.625,0,0,1-1.406-.738c-.083-.119-.16-.24-.242-.36a2.3,2.3,0,0,0-1.953-1.076q-2.748-.028-5.5,0a1.9,1.9,0,0,0-1.865,1.521,5.012,5.012,0,0,0-.037,1.095c0,.159-.034.224-.209.224a1.573,1.573,0,0,0-1.734,1.351l-.041,17.082c0,.8.733,1.132,1.524,1.138q.7.005,1.406,0c.31,0,.469-.136.469-.381s-.163-.379-.471-.383c-.426,0-.852,0-1.278,0-.681,0-.926-.242-.926-.915q0-7.91-.008-15.821c0-1.025.46-1.341,1.333-1.324q2.479.048,4.96,0a1.9,1.9,0,0,1,1.826.971,2.453,2.453,0,0,0,2.287,1.222c2.8-.012,5.591,0,8.386,0,1.023,0,2.045,0,3.068,0a.739.739,0,0,1,.638.252.91.91,0,0,1,.142.607q0,7.209,0,14.417c0,.524-.085.61-.606.61l-14.964-.009a1.718,1.718,0,0,0-.305.014.369.369,0,0,0-.277.507c.092.217.282.245.489.245,5.983,0,9.237.007,15.22.007a1.137,1.137,0,0,0,1.21-1.2c.007-.349,0-.7,0-1.046,0-.593-.023-.591.589-.591C787.668,199.488,787.936,199.029,787.936,198.609Z","transform":"translate(-2075.513 -74.478)","fill":"#fe9444","stroke":"#fe9444","stroke-width":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1014","data-name":"Path 1014","d":"M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z","transform":"translate(-1309 127)","fill":"#fe9444"}})])])]):(docs.NAME.includes('png') || docs.NAME.includes('jpg') || docs.NAME.includes('jpeg') || docs.NAME.includes('JPG') || docs.NAME.includes('PNG'))?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"rgba(77, 207, 85, 1.0)","viewBox":"0 0 512 512","width":"35","height":"35"}},[_c('path',{attrs:{"d":"M374 108H154.9l150.1-86.7c4.8-2.8 10.9-1.1 13.7 3.7l33.9 58.7c2.8 4.8 8.9 6.4 13.7 3.7 4.8-2.8 6.4-8.9 3.7-13.7l-33.9-58.7c-8.3-14.3-26.7-19.2-41-11L115.1 107.9c-0.1 0-0.1 0.1-0.2 0.1H30C13.5 108 0 121.5 0 138v344C0 498.5 13.5 512 30 512h344c16.5 0 30-13.5 30-30V138C404 121.5 390.5 108 374 108zM384 482c0 5.5-4.5 10-10 10H30c-5.5 0-10-4.5-10-10V138c0-5.5 4.5-10 10-10h344c5.5 0 10 4.5 10 10V482z"}}),_c('path',{attrs:{"d":"M447.3 208.5c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C450.2 212.9 449.2 210.4 447.3 208.5z"}}),_c('path',{attrs:{"d":"M508 312.9l-41.4-71.7c-2.8-4.8-8.9-6.4-13.7-3.7 -4.8 2.8-6.4 8.9-3.7 13.7l41.4 71.7c2.8 4.8 1.1 10.9-3.7 13.7l-64.3 37.1c-4.8 2.8-6.4 8.9-3.7 13.7 1.9 3.2 5.2 5 8.7 5 1.7 0 3.4-0.4 5-1.3l64.3-37.1C511.3 345.6 516.3 327.2 508 312.9z"}}),_c('path',{attrs:{"d":"M263.1 158.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1s1.1 5.2 2.9 7.1 4.4 2.9 7.1 2.9c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1S264.9 160.8 263.1 158.9z"}}),_c('path',{attrs:{"d":"M346 156h-39c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h29v142.6l-79.4-79.4c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-53 53c-3.9 3.9-3.9 10.2 0 14.1 3.9 3.9 10.2 3.9 14.1 0l45.9-45.9 86.4 86.4c0 0 0 0 0.1 0.1v49.2H82.1l72.6-72.6 53.9 53.9c3.9 3.9 10.2 3.9 14.1 0 3.9-3.9 3.9-10.2 0-14.1l-61-61c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-79.7 79.7V176h134c5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10H58c-5.5 0-10 4.5-10 10v240c0 5.5 4.5 10 10 10h288c5.5 0 10-4.5 10-10V166C356 160.5 351.5 156 346 156z"}}),_c('path',{attrs:{"d":"M145.7 199c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32S163.3 199 145.7 199zM145.7 243c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12C157.7 237.6 152.3 243 145.7 243z"}})])]):(docs.NAME.includes('pdf'))?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"35","height":"35","viewBox":"0 0 41.904 44.79"}},[_c('g',{attrs:{"id":"pdf","transform":"translate(0)"}},[_c('path',{attrs:{"id":"Path_937","data-name":"Path 937","d":"M180.34,394.293H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0","transform":"translate(-147.193 -359.8)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_938","data-name":"Path 938","d":"M180.34,341.215H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0","transform":"translate(-147.193 -311.365)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_939","data-name":"Path 939","d":"M161.3,288.766a.661.661,0,0,0,.661.661h11.693a.661.661,0,1,0,0-1.322H161.966A.661.661,0,0,0,161.3,288.766Zm0,0","transform":"translate(-147.194 -262.902)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_940","data-name":"Path 940","d":"M40.124,8.672,38.932,7.378V2.751A2.758,2.758,0,0,0,36.173,0H6.6A2.758,2.758,0,0,0,3.845,2.751V7.971H2.636A2.639,2.639,0,0,0,0,10.608v8a2.639,2.639,0,0,0,2.636,2.637H3.845V39.689A2.758,2.758,0,0,0,6.6,42.44h1.51a2.683,2.683,0,0,0,2.659,2.35H39.221A2.684,2.684,0,0,0,41.9,42.111V13.555c0-2.337-.07-3.025-1.78-4.883Zm.43,3.523H35.6a1.36,1.36,0,0,1-1.36-1.356l0-5.749c.869.065,1.1.322,1.863,1.169.126.141.264.294.418.461l1.264,1.372.014.015,1.346,1.462c1.05,1.141,1.329,1.62,1.4,2.628ZM5.167,2.751A1.435,1.435,0,0,1,6.6,1.322H36.173A1.435,1.435,0,0,1,37.61,2.751V5.943l-.11-.12c-.15-.162-.284-.312-.407-.449a3.683,3.683,0,0,0-3.507-1.626H10.774a2.683,2.683,0,0,0-2.68,2.679V7.971H5.167Zm35.415,39.36a1.36,1.36,0,0,1-1.36,1.357H10.774a1.359,1.359,0,0,1-1.358-1.357v-9.58a.661.661,0,0,0-1.322,0v8.586H6.6a1.435,1.435,0,0,1-1.437-1.429V21.248H8.093V29.5a.661.661,0,0,0,1.322,0V21.248h3.432a.661.661,0,0,0,0-1.322H2.635A1.316,1.316,0,0,1,1.322,18.61v-8A1.316,1.316,0,0,1,2.635,9.293h17.41a1.317,1.317,0,0,1,1.316,1.315v8a1.317,1.317,0,0,1-1.316,1.315H15.876a.661.661,0,1,0,0,1.322h4.169a2.641,2.641,0,0,0,2.638-2.637v-8a2.641,2.641,0,0,0-2.638-2.637H9.416V6.428a1.359,1.359,0,0,1,1.358-1.357h22.15l0,5.768A2.684,2.684,0,0,0,35.6,13.517h4.98V42.111Zm0,0","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_941","data-name":"Path 941","d":"M51.83,134.637H50.247a.674.674,0,0,0-.5.2.684.684,0,0,0-.2.5v4.682a.668.668,0,0,0,.2.491.675.675,0,0,0,1.15-.475v-1.358h1.017a2.013,2.013,0,0,0,1.483-.554,2.152,2.152,0,0,0-.033-2.928,2.127,2.127,0,0,0-1.534-.567Zm.492,2.624a.775.775,0,0,1-.567.242H50.9v-1.658h.867a.75.75,0,0,1,.571.246.842.842,0,0,1,.229.6A.784.784,0,0,1,52.322,137.261Zm0,0","transform":"translate(-45.213 -122.859)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_942","data-name":"Path 942","d":"M112.9,136.312a2.606,2.606,0,0,0-.829-1.037,3.172,3.172,0,0,0-1.917-.541h-1.392a.655.655,0,0,0-.492.208.667.667,0,0,0-.2.475v4.64a.665.665,0,0,0,.192.491.741.741,0,0,0,.508.183h1.5a2.811,2.811,0,0,0,1.95-.658,3.041,3.041,0,0,0,.975-2.357,3.331,3.331,0,0,0-.3-1.4Zm-1.529,2.712a1.458,1.458,0,0,1-1.15.491h-.8v-3.557h.725a1.583,1.583,0,0,1,1.213.475,1.8,1.8,0,0,1,.446,1.283,1.906,1.906,0,0,1-.433,1.308Zm0,0","transform":"translate(-98.612 -122.947)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_943","data-name":"Path 943","d":"M177.273,140.739a.646.646,0,0,0,.479-.2.655.655,0,0,0,.2-.475v-1.791h1.284a.628.628,0,0,0,.458-.179.6.6,0,0,0,0-.866.634.634,0,0,0-.454-.179h-1.284v-1.175h1.517a.574.574,0,0,0,.433-.183.6.6,0,0,0,.175-.425.6.6,0,0,0-.179-.446.585.585,0,0,0-.429-.179h-2.184a.655.655,0,0,0-.492.208.677.677,0,0,0-.2.483v4.731a.635.635,0,0,0,.208.475.668.668,0,0,0,.475.2Zm0,0","transform":"translate(-161.141 -122.862)","fill":"#e34856"}})])])]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"px1 m0"},[_vm._v(_vm._s(docs.NAME))])]):_vm._e()}),0),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.resultQuery.length)+" filer")])]),_vm._v(" "),_c('div',{staticClass:"col-3"},[_c('div',{staticClass:"block border p2"},[_vm._m(2),_vm._v(" "),_c('el-progress',{staticClass:"my2",attrs:{"show-text":false,"percentage":20,"max":100,"color":_vm.customColorMethod(20)}}),_vm._v(" "),_c('div',{staticClass:"flex justify-between mb3"},[_c('span',{staticClass:"h5 semi-bold darkblue"},[_vm._v(_vm._s(_vm.totalSize))]),_vm._v(" "),_vm._m(3)]),_vm._v(" "),(_vm.bulkActionVisible)?_c('div',[_c('el-button',{staticClass:"border-none regular p1 transparent-button flex",on:{"click":function($event){return _vm.loopCopyFile('multiple', [])}}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"mr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"document","width":"28.885","height":"34.234","viewBox":"0 0 28.885 34.234"}},[_c('path',{attrs:{"id":"Path_42","data-name":"Path 42","d":"M26.879,0H8.157A2.008,2.008,0,0,0,6.151,2.006V3.744H2.006A2.008,2.008,0,0,0,0,5.75V28.389H0a.666.666,0,0,0,.194.471l5.176,5.176a.669.669,0,0,0,.473.2H20.727a2.008,2.008,0,0,0,2.006-2.006V30.489h4.145a2.008,2.008,0,0,0,2.006-2.006V20.126a.669.669,0,0,0-1.337,0v8.358a.669.669,0,0,1-.669.669H22.733V25.283h1.975a.669.669,0,1,0,0-1.337H22.733V21.539h1.975a.669.669,0,0,0,0-1.337H22.733V17.794h1.975a.669.669,0,0,0,0-1.337H22.733V14.05h1.975a.669.669,0,0,0,0-1.337H22.733V10.3h1.975a.669.669,0,0,0,0-1.337H22.733V5.75a2,2,0,0,0-.115-.669h4.929v9.026a.669.669,0,0,0,1.337,0V2.006A2.008,2.008,0,0,0,26.879,0ZM5.176,31.951,2.283,29.058H4.235A.942.942,0,0,1,5.176,30Zm16.22.277a.669.669,0,0,1-.669.669H6.513V30A2.28,2.28,0,0,0,4.235,27.72h-2.9V8.826H21.4v.809h0v3.744h0v3.742h0V20.87h0Zm0-26.478V7.489H1.337V5.75a.669.669,0,0,1,.669-.669H20.727A.669.669,0,0,1,21.4,5.75Zm-.669-2.006H7.489V2.006a.669.669,0,0,1,.669-.669H26.879a.669.669,0,0,1,.669.669V3.744Zm0,0","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_43","data-name":"Path 43","d":"M66.7,358.02H52.259a.669.669,0,1,0,0,1.337H66.7a.669.669,0,1,0,0-1.337Zm0,0","transform":"translate(-48.141 -334.082)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_44","data-name":"Path 44","d":"M174.394,414.012h-6.726a.669.669,0,1,0,0,1.337h6.726a.669.669,0,1,0,0-1.337Zm0,0","transform":"translate(-155.834 -386.33)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_45","data-name":"Path 45","d":"M52.258,303.337H62.491a.669.669,0,1,0,0-1.337H52.258a.669.669,0,0,0,0,1.337Zm0,0","transform":"translate(-48.14 -281.808)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_46","data-name":"Path 46","d":"M66.7,246.012H52.259a.669.669,0,0,0,0,1.337H66.7a.669.669,0,1,0,0-1.337Zm0,0","transform":"translate(-48.141 -229.563)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_47","data-name":"Path 47","d":"M52.258,191.325h5.049a.669.669,0,0,0,0-1.337H52.258a.669.669,0,0,0,0,1.337Zm0,0","transform":"translate(-48.14 -177.285)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_48","data-name":"Path 48","d":"M185.366,189.988h-5.939a.669.669,0,1,0,0,1.337h5.939a.669.669,0,1,0,0-1.337Zm0,0","transform":"translate(-166.806 -177.285)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_49","data-name":"Path 49","d":"M252.964,302h-1.1a.669.669,0,0,0,0,1.337h1.1a.669.669,0,0,0,0-1.337Zm0,0","transform":"translate(-234.404 -281.808)","fill":"#19a3c0"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_50","data-name":"Path 50","d":"M412.669,246a.669.669,0,1,0,.473.2A.674.674,0,0,0,412.669,246Zm0,0","transform":"translate(-384.453 -229.552)","fill":"#19a3c0"}})])]),_vm._v("\n                        Duplicate\n                      ")])]),_vm._v(" "),_c('el-button',{staticClass:"border-none regular p1 transparent-button flex",on:{"click":function($event){return _vm.showRenameFile('multiple', [])}}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"mr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28.5","height":"27.42","viewBox":"0 0 28.5 27.42"}},[_c('g',{attrs:{"id":"Edit","transform":"translate(-3.75 -3.33)"}},[_c('path',{attrs:{"id":"Path_1016","data-name":"Path 1016","d":"M18,30H31.5","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1017","data-name":"Path 1017","d":"M24.75,5.25a3.182,3.182,0,0,1,4.5,4.5L10.5,28.5,4.5,30,6,24Z","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])]),_vm._v("\n                        Rename\n                      ")])]),_vm._v(" "),_c('el-button',{staticClass:"border-none regular p1 transparent-button flex",on:{"click":function($event){return _vm.confirmDelete('multiple', null, null)}}},[_c('div',{staticClass:"flex"},[_c('div',{staticClass:"mr1"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"28.5","height":"31.5","viewBox":"0 0 28.5 31.5"}},[_c('g',{attrs:{"id":"Trash","transform":"translate(-3.75 -2.25)"}},[_c('path',{attrs:{"id":"Path_1012","data-name":"Path 1012","d":"M4.5,9h27","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1013","data-name":"Path 1013","d":"M28.5,9V30a3,3,0,0,1-3,3h-15a3,3,0,0,1-3-3V9M12,9V6a3,3,0,0,1,3-3h6a3,3,0,0,1,3,3V9","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1014","data-name":"Path 1014","d":"M15,16.5v9","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1015","data-name":"Path 1015","d":"M21,16.5v9","fill":"none","stroke":"#19a3c0","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])])]),_vm._v("\n                        Delete\n                      ")])])],1):_vm._e()],1)])]),_vm._v(" "),_c('div',[_c('el-table',{ref:"multipleTable",staticStyle:{"width":"100%"},attrs:{"data":_vm.resultQuery},on:{"selection-change":_vm.checkboxChanged}},[_c('el-table-column',{attrs:{"type":"selection"}}),_vm._v(" "),_c('el-table-column',{attrs:{"label":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.TYPE == 'folder')?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 26.443 22.744"}},[_c('g',{attrs:{"id":"Group_3157","data-name":"Group 3157","transform":"translate(1313.87 -105.256)"}},[_c('path',{attrs:{"id":"Path_1013","data-name":"Path 1013","d":"M.969.516H0A.581.581,0,0,1-.5.008.581.581,0,0,1,0-.5H.969a.552.552,0,0,1,.469.508A.552.552,0,0,1,.969.516Z","transform":"translate(-1295.703 107.953)","fill":"#fe9444"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1013-2","data-name":"Path 1013","d":"M787.936,198.609V183.245c0-1.014-.721-1.17-1.773-1.17h-3.519a1.007,1.007,0,0,0-.254.013.379.379,0,0,0,.038.746,1.766,1.766,0,0,0,.255.006H786.3c.638,0,.864.222.864.851q0,7.235,0,14.47c0,.042,0,.085,0,.128-.008.291-.132.423-.418.43-.187,0-.377-.017-.562,0-.224.024-.278-.048-.278-.274q.012-5.946.006-11.892a2.2,2.2,0,0,0-.054-.608,1.434,1.434,0,0,0-1.512-1.041c-3.767,0-7.535-.012-11.3.008a1.958,1.958,0,0,1-1.868-.993,2.385,2.385,0,0,0-2.22-1.2c-1.4.013-2.8,0-4.194.007-.171,0-.248-.034-.231-.221s0-.357,0-.536a1.178,1.178,0,0,1,1.322-1.321l5.114,0a2.313,2.313,0,0,1,.606.071,1.909,1.909,0,0,1,1.091.941,2.408,2.408,0,0,0,2.185,1.172c1.364-.009,1.728,0,3.091,0a1.661,1.661,0,0,0,.179,0,.36.36,0,0,0,.353-.368.365.365,0,0,0-.332-.388,1.243,1.243,0,0,0-.23-.006h-3.142a1.625,1.625,0,0,1-1.406-.738c-.083-.119-.16-.24-.242-.36a2.3,2.3,0,0,0-1.953-1.076q-2.748-.028-5.5,0a1.9,1.9,0,0,0-1.865,1.521,5.012,5.012,0,0,0-.037,1.095c0,.159-.034.224-.209.224a1.573,1.573,0,0,0-1.734,1.351l-.041,17.082c0,.8.733,1.132,1.524,1.138q.7.005,1.406,0c.31,0,.469-.136.469-.381s-.163-.379-.471-.383c-.426,0-.852,0-1.278,0-.681,0-.926-.242-.926-.915q0-7.91-.008-15.821c0-1.025.46-1.341,1.333-1.324q2.479.048,4.96,0a1.9,1.9,0,0,1,1.826.971,2.453,2.453,0,0,0,2.287,1.222c2.8-.012,5.591,0,8.386,0,1.023,0,2.045,0,3.068,0a.739.739,0,0,1,.638.252.91.91,0,0,1,.142.607q0,7.209,0,14.417c0,.524-.085.61-.606.61l-14.964-.009a1.718,1.718,0,0,0-.305.014.369.369,0,0,0-.277.507c.092.217.282.245.489.245,5.983,0,9.237.007,15.22.007a1.137,1.137,0,0,0,1.21-1.2c.007-.349,0-.7,0-1.046,0-.593-.023-.591.589-.591C787.668,199.488,787.936,199.029,787.936,198.609Z","transform":"translate(-2075.513 -74.478)","fill":"#fe9444","stroke":"#fe9444","stroke-width":"0.3"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_1014","data-name":"Path 1014","d":"M.5,0A.5.5,0,1,1,0,.5.5.5,0,0,1,.5,0Z","transform":"translate(-1309 127)","fill":"#fe9444"}})])])]):(scope.row.NAME.includes('png') || scope.row.NAME.includes('jpg') || scope.row.NAME.includes('jpeg') || scope.row.NAME.includes('JPG') || scope.row.NAME.includes('PNG'))?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","fill":"rgba(77, 207, 85, 1.0)","viewBox":"0 0 512 512","width":"30","height":"30"}},[_c('path',{attrs:{"d":"M374 108H154.9l150.1-86.7c4.8-2.8 10.9-1.1 13.7 3.7l33.9 58.7c2.8 4.8 8.9 6.4 13.7 3.7 4.8-2.8 6.4-8.9 3.7-13.7l-33.9-58.7c-8.3-14.3-26.7-19.2-41-11L115.1 107.9c-0.1 0-0.1 0.1-0.2 0.1H30C13.5 108 0 121.5 0 138v344C0 498.5 13.5 512 30 512h344c16.5 0 30-13.5 30-30V138C404 121.5 390.5 108 374 108zM384 482c0 5.5-4.5 10-10 10H30c-5.5 0-10-4.5-10-10V138c0-5.5 4.5-10 10-10h344c5.5 0 10 4.5 10 10V482z"}}),_c('path',{attrs:{"d":"M447.3 208.5c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9c-1.9 1.9-2.9 4.4-2.9 7.1 0 2.6 1.1 5.2 2.9 7.1 1.9 1.9 4.4 2.9 7.1 2.9 2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1C450.2 212.9 449.2 210.4 447.3 208.5z"}}),_c('path',{attrs:{"d":"M508 312.9l-41.4-71.7c-2.8-4.8-8.9-6.4-13.7-3.7 -4.8 2.8-6.4 8.9-3.7 13.7l41.4 71.7c2.8 4.8 1.1 10.9-3.7 13.7l-64.3 37.1c-4.8 2.8-6.4 8.9-3.7 13.7 1.9 3.2 5.2 5 8.7 5 1.7 0 3.4-0.4 5-1.3l64.3-37.1C511.3 345.6 516.3 327.2 508 312.9z"}}),_c('path',{attrs:{"d":"M263.1 158.9c-1.9-1.9-4.4-2.9-7.1-2.9 -2.6 0-5.2 1.1-7.1 2.9 -1.9 1.9-2.9 4.4-2.9 7.1s1.1 5.2 2.9 7.1 4.4 2.9 7.1 2.9c2.6 0 5.2-1.1 7.1-2.9 1.9-1.9 2.9-4.4 2.9-7.1S264.9 160.8 263.1 158.9z"}}),_c('path',{attrs:{"d":"M346 156h-39c-5.5 0-10 4.5-10 10 0 5.5 4.5 10 10 10h29v142.6l-79.4-79.4c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-53 53c-3.9 3.9-3.9 10.2 0 14.1 3.9 3.9 10.2 3.9 14.1 0l45.9-45.9 86.4 86.4c0 0 0 0 0.1 0.1v49.2H82.1l72.6-72.6 53.9 53.9c3.9 3.9 10.2 3.9 14.1 0 3.9-3.9 3.9-10.2 0-14.1l-61-61c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1.1-7.1 2.9l-79.7 79.7V176h134c5.5 0 10-4.5 10-10 0-5.5-4.5-10-10-10H58c-5.5 0-10 4.5-10 10v240c0 5.5 4.5 10 10 10h288c5.5 0 10-4.5 10-10V166C356 160.5 351.5 156 346 156z"}}),_c('path',{attrs:{"d":"M145.7 199c-17.6 0-32 14.4-32 32s14.4 32 32 32c17.6 0 32-14.4 32-32S163.3 199 145.7 199zM145.7 243c-6.6 0-12-5.4-12-12s5.4-12 12-12 12 5.4 12 12C157.7 237.6 152.3 243 145.7 243z"}})])]):(scope.row.NAME.includes('pdf'))?_c('div',[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"30","height":"30","viewBox":"0 0 41.904 44.79"}},[_c('g',{attrs:{"id":"pdf","transform":"translate(0)"}},[_c('path',{attrs:{"id":"Path_937","data-name":"Path 937","d":"M180.34,394.293H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0","transform":"translate(-147.193 -359.8)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_938","data-name":"Path 938","d":"M180.34,341.215H161.965a.661.661,0,0,0,0,1.322H180.34a.661.661,0,0,0,0-1.322Zm0,0","transform":"translate(-147.193 -311.365)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_939","data-name":"Path 939","d":"M161.3,288.766a.661.661,0,0,0,.661.661h11.693a.661.661,0,1,0,0-1.322H161.966A.661.661,0,0,0,161.3,288.766Zm0,0","transform":"translate(-147.194 -262.902)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_940","data-name":"Path 940","d":"M40.124,8.672,38.932,7.378V2.751A2.758,2.758,0,0,0,36.173,0H6.6A2.758,2.758,0,0,0,3.845,2.751V7.971H2.636A2.639,2.639,0,0,0,0,10.608v8a2.639,2.639,0,0,0,2.636,2.637H3.845V39.689A2.758,2.758,0,0,0,6.6,42.44h1.51a2.683,2.683,0,0,0,2.659,2.35H39.221A2.684,2.684,0,0,0,41.9,42.111V13.555c0-2.337-.07-3.025-1.78-4.883Zm.43,3.523H35.6a1.36,1.36,0,0,1-1.36-1.356l0-5.749c.869.065,1.1.322,1.863,1.169.126.141.264.294.418.461l1.264,1.372.014.015,1.346,1.462c1.05,1.141,1.329,1.62,1.4,2.628ZM5.167,2.751A1.435,1.435,0,0,1,6.6,1.322H36.173A1.435,1.435,0,0,1,37.61,2.751V5.943l-.11-.12c-.15-.162-.284-.312-.407-.449a3.683,3.683,0,0,0-3.507-1.626H10.774a2.683,2.683,0,0,0-2.68,2.679V7.971H5.167Zm35.415,39.36a1.36,1.36,0,0,1-1.36,1.357H10.774a1.359,1.359,0,0,1-1.358-1.357v-9.58a.661.661,0,0,0-1.322,0v8.586H6.6a1.435,1.435,0,0,1-1.437-1.429V21.248H8.093V29.5a.661.661,0,0,0,1.322,0V21.248h3.432a.661.661,0,0,0,0-1.322H2.635A1.316,1.316,0,0,1,1.322,18.61v-8A1.316,1.316,0,0,1,2.635,9.293h17.41a1.317,1.317,0,0,1,1.316,1.315v8a1.317,1.317,0,0,1-1.316,1.315H15.876a.661.661,0,1,0,0,1.322h4.169a2.641,2.641,0,0,0,2.638-2.637v-8a2.641,2.641,0,0,0-2.638-2.637H9.416V6.428a1.359,1.359,0,0,1,1.358-1.357h22.15l0,5.768A2.684,2.684,0,0,0,35.6,13.517h4.98V42.111Zm0,0","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_941","data-name":"Path 941","d":"M51.83,134.637H50.247a.674.674,0,0,0-.5.2.684.684,0,0,0-.2.5v4.682a.668.668,0,0,0,.2.491.675.675,0,0,0,1.15-.475v-1.358h1.017a2.013,2.013,0,0,0,1.483-.554,2.152,2.152,0,0,0-.033-2.928,2.127,2.127,0,0,0-1.534-.567Zm.492,2.624a.775.775,0,0,1-.567.242H50.9v-1.658h.867a.75.75,0,0,1,.571.246.842.842,0,0,1,.229.6A.784.784,0,0,1,52.322,137.261Zm0,0","transform":"translate(-45.213 -122.859)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_942","data-name":"Path 942","d":"M112.9,136.312a2.606,2.606,0,0,0-.829-1.037,3.172,3.172,0,0,0-1.917-.541h-1.392a.655.655,0,0,0-.492.208.667.667,0,0,0-.2.475v4.64a.665.665,0,0,0,.192.491.741.741,0,0,0,.508.183h1.5a2.811,2.811,0,0,0,1.95-.658,3.041,3.041,0,0,0,.975-2.357,3.331,3.331,0,0,0-.3-1.4Zm-1.529,2.712a1.458,1.458,0,0,1-1.15.491h-.8v-3.557h.725a1.583,1.583,0,0,1,1.213.475,1.8,1.8,0,0,1,.446,1.283,1.906,1.906,0,0,1-.433,1.308Zm0,0","transform":"translate(-98.612 -122.947)","fill":"#e34856"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_943","data-name":"Path 943","d":"M177.273,140.739a.646.646,0,0,0,.479-.2.655.655,0,0,0,.2-.475v-1.791h1.284a.628.628,0,0,0,.458-.179.6.6,0,0,0,0-.866.634.634,0,0,0-.454-.179h-1.284v-1.175h1.517a.574.574,0,0,0,.433-.183.6.6,0,0,0,.175-.425.6.6,0,0,0-.179-.446.585.585,0,0,0-.429-.179h-2.184a.655.655,0,0,0-.492.208.677.677,0,0,0-.2.483v4.731a.635.635,0,0,0,.208.475.668.668,0,0,0,.475.2Zm0,0","transform":"translate(-161.141 -122.862)","fill":"#e34856"}})])])]):_vm._e()]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Name","show-overflow-tooltip":""},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [(scope.row.SHARED_BY)?_c('div',[_c('el-tooltip',{attrs:{"effect":"light","placement":"top","enterable":false,"visible-arrow":false}},[_c('div',{attrs:{"slot":"content"},slot:"content"},[_c('span',{staticClass:"easternblue"},[_vm._v("Shared by")]),_vm._v(": "+_vm._s(scope.row.SHARED_BY.NAME + ' (' + scope.row.SHARED_BY.EMAIL + ')'))]),_vm._v(" "),_c('i',{staticClass:"el-icon-user"})])],1):_vm._e(),_vm._v(" "),(scope.row.TYPE == 'folder')?_c('p',{staticClass:"line-height-2 m0",staticStyle:{"font-size":"14px"}},[_c('a',{staticClass:"easternblue pointer",on:{"click":function($event){return _vm.folderChange(scope.row.ID, scope.row.NAME, scope.row.PARENT_ID, '', 'in')}}},[_vm._v(_vm._s(scope.row.NAME))])]):_c('p',{staticClass:"line-height-2 m0",staticStyle:{"font-size":"14px"}},[_vm._v(_vm._s(scope.row.NAME))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Type"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.TYPE != 'folder')?[(scope.row.NAME.includes('png'))?_c('p',{staticClass:"line-height-2 m0"},[_vm._v("png")]):(scope.row.NAME.includes('jpg'))?_c('p',{staticClass:"line-height-2 m0"},[_vm._v("jpeg")]):(scope.row.NAME.includes('jpeg'))?_c('p',{staticClass:"line-height-2 m0"},[_vm._v("jpeg")]):(scope.row.NAME.includes('pdf'))?_c('p',{staticClass:"line-height-2 m0"},[_vm._v("pdf")]):_vm._e()]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Size"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return (scope.row.TYPE != 'folder')?[_vm._v(_vm._s(_vm.formatBytes(scope.row.SIZE)))]:undefined}}],null,true)}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Keywords"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._l((scope.row.TAGS),function(tag,index){return _c('el-tag',{key:index,staticStyle:{"margin-right":"4px"},attrs:{"closable":"","disable-transitions":false},on:{"close":function($event){return _vm.removeKeyword(scope.row.ID, tag.ID)}}},[_vm._v("\n                      "+_vm._s(tag.DA_DK)+"\n                    ")])}),_vm._v(" "),_c('el-autocomplete',{ref:"saveTagInput",staticClass:"border hide",class:'input-keyword-' + scope.row.ID,attrs:{"placeholder":"Keywords","size":"mini","fetch-suggestions":_vm.querySearchFilter},on:{"select":function($event){return _vm.addKeyword(scope.row.ID, _vm.inputKeywordData[scope.$index].value, scope.$index, scope.row.TYPE)},"blur":function($event){return _vm.hideInputKeyword(scope.row.ID, scope.$index)}},model:{value:(_vm.inputKeywordData[scope.$index].value),callback:function ($$v) {_vm.$set(_vm.inputKeywordData[scope.$index], "value", $$v)},expression:"inputKeywordData[scope.$index].value"}}),_vm._v(" "),_c('el-tooltip',{attrs:{"effect":"light","placement":"top","content":"Tilføj","enterable":false}},[_c('el-button',{staticClass:"border-none transparent p1",class:'button-new-tag-' + scope.row.ID,attrs:{"size":"small"},on:{"click":function($event){return _vm.showInputKeyword(scope.row.ID)}}},[_c('i',{staticClass:"h5 regular cyprus el-icon-circle-plus-outline m0"})])],1)]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"label":"Date"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_vm._v("\n                    "+_vm._s(scope.row.CREATED_AT)+"\n                  ")]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"property":"operations","label":"Operations"},scopedSlots:_vm._u([{key:"default",fn:function(scope){return [_c('div',{staticClass:"flex justify-start"},[_c('el-tooltip',{attrs:{"content":"Image Editor","placement":"top","effect":"light","enterable":false}},[(scope.row.TYPE != 'folder')?_c('el-button',{staticClass:"outlined-standard-button border-none p1"},[_c('span',[_c('i',{staticClass:"el-icon-brush"})])]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Preview","placement":"top","effect":"light","enterable":false}},[(scope.row.TYPE != 'folder')?_c('el-button',{staticClass:"outlined-action-button border-none p1",on:{"click":function($event){return _vm.previewFile(scope.row.DOWNLOAD_URL)}}},[_c('span',[_c('i',{staticClass:"el-icon-view"})])]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Duplicate","placement":"top","effect":"light","enterable":false}},[(scope.row.TYPE != 'folder')?_c('el-button',{staticClass:"outlined-primary-button border-none p1",on:{"click":function($event){return _vm.loopCopyFile('single', scope.row.ID)}}},[_c('span',[_c('i',{staticClass:"el-icon-document-copy"})])]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Rename","placement":"top","effect":"light","enterable":false}},[(scope.row.SHARED_BY == null)?_c('el-button',{staticClass:"border-none regular p1 outlined-standard-button",on:{"click":function($event){return _vm.showRenameFile('single', scope.row)}}},[_c('span',[_c('i',{staticClass:"el-icon-edit"})])]):_vm._e()],1),_vm._v(" "),_c('el-tooltip',{attrs:{"content":"Delete","placement":"top","effect":"light","enterable":false}},[(scope.row.SHARED_BY == null)?_c('el-button',{staticClass:"outlined-delete-button border-none p1",on:{"click":function($event){return _vm.confirmDelete('single', scope.row.ID, scope.row.TYPE)}}},[_c('span',[_c('i',{staticClass:"el-icon-delete"})])]):_vm._e()],1)],1)]}}])})],1)],1)]),_vm._v(" "),_c('b-modal',{ref:"createFolder",staticClass:"p-2 pb-4",attrs:{"id":"formModal","hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.createFolderFormVisible),callback:function ($$v) {_vm.createFolderFormVisible=$$v},expression:"createFolderFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n                  Skriv til ...\n                ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Opret")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',[_c('div',{staticClass:"form-group mb4"},[_c('el-input',{staticClass:"col-12 p0",attrs:{"placeholder":"Navn"},model:{value:(_vm.createFolderForm.name),callback:function ($$v) {_vm.$set(_vm.createFolderForm, "name", $$v)},expression:"createFolderForm.name"}}),_vm._v(" "),(_vm.submitted && !_vm.createFolderForm.name)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeCreateFolder()}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.addFolder()}}},[_c('span',[_vm._v("Indsend")])])])])]),_vm._v(" "),_c('b-modal',{ref:"uploadFile",staticClass:"p-2 pb-4",attrs:{"id":"formModal","hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.addFileFormVisible),callback:function ($$v) {_vm.addFileFormVisible=$$v},expression:"addFileFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n                  Skriv til ...\n                ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Uploade")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',[_c('div',{staticClass:"form-group"},[_c('el-upload',{staticClass:"col-12 p0",attrs:{"action":"#","auto-upload":false,"drag":true,"multiple":true,"accept":_vm.acceptedFileType,"on-change":_vm.uploadFile},scopedSlots:_vm._u([{key:"file",fn:function(ref){
var file = ref.file;
return _c('div',{},[_vm._v("\n                    "+_vm._s(file.name)+"\n                    "),_c('button',{staticClass:"transparent-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.removeUpload(file)}}},[_c('i',{staticClass:"el-icon-delete red"})])])}}])},[_c('i',{staticClass:"el-icon-upload easternblue",attrs:{"slot":"default"},slot:"default"}),_vm._v(" "),_c('div',{staticClass:"el-upload__text center"},[_vm._v("Drop filer her "),_c('span',{staticClass:"easternblue"},[_vm._v("Eller klik for at uploade")])]),_vm._v(" "),_c('div',{staticClass:"el-upload__tip center easternblue"},[_vm._v("Filer mindre end 1mb")])]),_vm._v(" "),(_vm.submitted && _vm.addFileForm.file.length == 0)?_c('div',{staticClass:"red mt1"},[_vm._v("Nødvendig")]):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeAddFileForm()}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.addFile()}}},[_c('span',[_vm._v("Indsend")])])])])]),_vm._v(" "),_c('b-modal',{ref:"RenameFile",staticClass:"p-2 pb-4",attrs:{"id":"formModal","hide-footer":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.renameFileFormVisible),callback:function ($$v) {_vm.renameFileFormVisible=$$v},expression:"renameFileFormVisible"}},[_c('div',{staticClass:"pt2 px0",attrs:{"slot":"modal-header"},slot:"modal-header"},[_c('div',{staticClass:"clearfix"},[_c('div',{staticClass:"col-12 px2"},[_c('p',{staticClass:"h4 darkblue gibson line-height-1 semi-bold"},[_vm._v("\n                  Skriv til ...\n                ")])])])]),_vm._v(" "),_c('div'),_vm._v(" "),_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Omdøb")]),_vm._v(" "),_c('div',{staticClass:"mb4"}),_vm._v(" "),(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('form',[_vm._l((_vm.selectedCheckboxesData),function(row,index){return _c('div',{key:index,staticClass:"form-group mb4"},[(row.TYPE != 'folder')?_c('div',[_c('input',{staticClass:"editFile col-10 px2 py1",attrs:{"placeholder":"Fil","id":row.ID + '-' + row.NAME.split('.')[1]},domProps:{"value":row.NAME.split('.')[0]}}),_vm._v(" "),_c('span',{staticClass:"pl1"},[_c('b',[_vm._v(".")]),_vm._v(_vm._s(row.NAME.split('.')[1]))])]):_c('div',[_c('input',{staticClass:"editFile col-12 px2 py1",attrs:{"placeholder":"Fil","id":row.ID + '-folder'},domProps:{"value":row.NAME.split('.')[0]}})])])}),_vm._v(" "),_c('div',{staticClass:"flex justify-end"},[_c('button',{staticClass:"col-3 right block muted-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.closeRenameFile()}}},[_c('span',[_vm._v("Luk")])]),_vm._v(" "),_c('button',{staticClass:"col-3 right block action-button button-padding border-none not-rounded h5 regular line-height-1 ml1 py2 px1",attrs:{"type":"button"},on:{"click":function($event){return _vm.renameFile()}}},[_c('span',[_vm._v("Indsend")])])])],2)]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-12 mt2 px0 flex justify-between items-center"},[_c('p',{staticClass:"h1 regular line-height-2 my3"},[_vm._v("Filer")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex mb3"},[_c('i',{staticClass:"el-icon-time mr1"}),_vm._v(" "),_c('p',{staticClass:"m0"},[_vm._v("Nylig")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cyprus light flex justify-between mb2"},[_c('span',[_vm._v("Brugt")]),_vm._v(" "),_c('span',[_vm._v("Ledig")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"darkblue"},[_c('i',{staticClass:"fas fa-infinity"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tenderFolder_vue__ = __webpack_require__(1610);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f1caf0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_tenderFolder_vue__ = __webpack_require__(1611);
function injectStyle (ssrContext) {
  __webpack_require__(1609)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_tenderFolder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32f1caf0_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_tenderFolder_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1610 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(220);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_pdf_app__ = __webpack_require__(75);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_pdf_app___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_pdf_app__);






var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler,
    VuePdfApp: __WEBPACK_IMPORTED_MODULE_3_vue_pdf_app___default.a
  },
  data: function data() {
    return {
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      loading: false,
      projectID: '',
      contactID: '',
      haaId: '',
      salesPersonbitrix: '',
      tenderFolderID: '',
      formLoading: false,
      searchQuery: '',
      documentsData: [],
      defaultFolderId: '',
      parentFolderData: [],
      currentFolderId: '',
      currentFolderParentId: '',
      currentProjectInfo: {},
      selectedtender: '',
      projectAddress: '',
      tenderQA: false,
      productlistforpricearr: [],
      primaryproductindustryname: {},
      tagsData: [],
      productTags: [],
      questions: '',
      projectTitle: '',
      allquestionsanswerArr: [],
      defaultallquestionsanswerArr: [],
      disableaddbutton: false,
      selectedIndustryDesc: {
        industryid: '',
        industrydesc: ''
      },
      showloadingpdf: false,
      innerloading: false,
      replayanswer: '',
      alldescriptionidwithreply: [],
      viewer: {},
      serviceUrl: '',
      partnerName: '',
      documentPath: '',
      publicFiles: [],
      seletecdfolder: 'default',
      parent_tenderID: '',
      selectedFolder: '',
      insideFolder: '',
      showPdf: false,
      pdfLink: '',
      tenderfilesOffer: {},
      tenderfilesInspiration: {},
      itemsjobindustry: {},
      showMobile: false,
      partnerprimaryindustryText: '',
      tenderFiles: [],
      childprojects: [],
      partnerjobindustry: [],
      jobList: [],
      submittedIndustries: [],
      parentprojectID: '',
      contractType: '',
      seletecddescline: '',
      scale: 120,
      config: {
        toolbar: {
          toolbarViewerLeft: false
        }
      },
      pdfStr: '',
      activepage: 1,
      tenderOfferFiles: [],
      tenderInspirationFiles: [],
      selectiondescriptionObj: {},
      descIndex: 0,
      offerStatus: ''
    };
  },
  created: function created() {
    if (screen.width <= 640) {
      this.showMobile = true;
    } else {
      this.showMobile = false;
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.serviceUrl = 'https://sea-turtle-app-n3xkw.ondigitalocean.app/api/pdfviewer';
    this.partnerprimaryindustryText = localStorage.getItem('partnerPrimaryIndustryText');
    this.projectID = this.$route.query.projectID;
    this.parentprojectID = this.$route.query.parentprojectID;
    this.contractType = this.$route.query.contracttype;
    this.contactID = this.$route.query.contact_id;
    this.offerStatus = this.$route.query.offerstatus;
    this.tenderFolderID = this.$route.query.tenderFolderID;
    this.parent_tenderID = this.$route.query.parent_tenderID;
    this.jobList = JSON.parse(this.$route.query.joblist);
    this.projectTitle = this.$route.query.title;
    this.partnerName = localStorage.getItem('name');
    this.projectAddress = this.$route.query.address;
    this.haaId = localStorage.getItem('haaid');
    this.childprojects = JSON.parse(this.$route.query.childprojects);

    this.jobList.forEach(function (k) {
      if (Array.isArray(k)) {
        k.forEach(function (k) {
          var jobindustry = k.split(':')[0];
          _this.submittedIndustries.push(jobindustry.toString());
        });
      } else {
        var jobindustry = k.split(':')[0];
        _this.submittedIndustries.push(jobindustry.toString());
      }
    });
    this.tenderFiles = JSON.parse(this.$route.query.tenderfiles);
    this.tenderOfferFiles = this.tenderFiles.filter(function (i) {
      return i.TYPE === 'offer' && i.PARTNER_ID === Number(_this.haaId);
    });
    this.tenderInspirationFiles = this.tenderFiles.filter(function (i) {
      return i.TYPE === 'inspiration';
    });
    this.getallwizardproduct();
    this.gettaskbitrix();
    this.getQuestionsAnswers();
    this.displaytenderFiles(this.parent_tenderID);
    this.getPublicFiles();
    this.tenderFolders();
  },

  methods: {
    folderChange: function folderChange(currentFolderId, currentFolderName, currentFolderParentId, index, type) {
      this.selectedFolder = currentFolderName;
      this.insideFolder = type;
      this.parentFolderData = [];
      this.parentFolderData.push({
        folderId: '',
        folderName: 'Main'
      });
      if (type === 'in') {
        this.parentFolderData.push({
          folderId: currentFolderId,
          folderName: currentFolderName
        });
      } else {
        for (var i = 0; i < this.parentFolderData.length; i++) {
          if (i > index) {
            this.parentFolderData.splice(i, 1);
            i--;
          }
        }
      }
    },
    tenderFolders: function tenderFolders() {
      var tenderOffer = this.tenderFiles.filter(function (property) {
        return property.TYPE === 'offer';
      });
      var tenderInspiration = this.tenderFiles.filter(function (property) {
        return property.TYPE === 'inspiration';
      });
      this.tenderfilesOffer = tenderOffer[0];
      this.tenderfilesInspiration = tenderInspiration[0];
    },
    showPdfFile: function showPdfFile(link) {
      this.pdfLink = link;
      this.showPdf = true;
    },
    loadingFolder: function loadingFolder() {
      this.loading = true;
      this.displaytenderFiles();
    },
    truncate: function truncate(text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
    displaytenderFiles: function displaytenderFiles(folderId) {
      var _this2 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get("https://bitrixapi.haandvaerker.dk/v1/" + 'partner/folder/' + folderId + '/children', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;

        _this2.documentsData = res.data;
        _this2.documentsData.forEach(function (k, index) {
          if (k.TYPE !== 'folder') {
            _this2.convertLinktoPDF(k.DOWNLOAD_URL, index, 'tenderFile', _this2.documentsData);
          }
        });
        _this2.loading = false;
      }, function (response) {
        var error = response.body;
        _this2.$refs.errorMsg.showMsg(error);
      });
    },
    tenderviewv2: function tenderviewv2(tenderitem) {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var response, data;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return fetch(tenderitem.DOWNLOAD_URL);

              case 2:
                response = _context.sent;
                _context.next = 5;
                return response.blob;

              case 5:
                data = _context.sent;
                return _context.abrupt('return', new File([data], tenderitem.NAME, {
                  type: data.type || 'application/pdf'
                }));

              case 7:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3);
      }))();
    },
    convertLinktoPDF: function convertLinktoPDF(link, index, typefile, array) {
      var _this4 = this;

      var external = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.haaid = localStorage.getItem('haaid');
        _this4.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
        var headers = {
          Authorization: 'Bearer ' + _this4.salesPersonbitrix
        };
        var data = {
          type: 'pdf',
          url: link
        };
        _this4.$http.post(_this4.$bitrixapi + 'external/helper/encodeToBase64', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
          var res = response.body.data;
          if (external === 'external') {
            resolve('data:application/pdf;base64,' + res);
          } else {
            array[index]['pdfbase64'] = 'data:application/pdf;base64,' + res;
            if (parseInt(_this4.documentsData.length - 1) === index) {
              _this4.loading = false;
            }
          }
        }, function (response) {
          var error = response.body;
          _this4.$refs.errorMsg.showMsg(error);
        });
      });
    },
    ajaxRequestFailure: function ajaxRequestFailure(args) {
      window.location.reload();
    },
    openpdfdownload: function openpdfdownload(tenderitem) {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var newlink;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                newlink = '';

                if (!(tenderitem.includes('ordrapport.miljoeportal.dk') || tenderitem.includes('.pdf') && !tenderitem.includes('tender'))) {
                  _context2.next = 5;
                  break;
                }

                _this5.showPdfFile(tenderitem);
                _context2.next = 29;
                break;

              case 5:
                if (!tenderitem.includes('https://weblager.dk/rest/buildingproject/download')) {
                  _context2.next = 14;
                  break;
                }

                _this5.$refs.downloadpdf.show();
                _this5.showloadingpdf = true;
                _context2.next = 10;
                return _this5.convertLinktoPDF(tenderitem, 0, 'pdf', [], 'external');

              case 10:
                newlink = _context2.sent;

                setTimeout(function () {
                  _this5.pdfStr = newlink;
                  _this5.loading = false;
                  _this5.showloadingpdf = false;
                }, 500);
                _context2.next = 29;
                break;

              case 14:
                if (!(tenderitem.includes('public.filarkiv.dk/Document') || tenderitem.includes('dingeo.dk/adresse') || tenderitem.includes('dingeo.dk/byggesag'))) {
                  _context2.next = 18;
                  break;
                }

                window.open(tenderitem, '_blank');
                _context2.next = 29;
                break;

              case 18:
                _this5.$refs.downloadpdf.show();
                _this5.showloadingpdf = true;

                if (!tenderitem.includes('data:application/pdf;base64')) {
                  _context2.next = 24;
                  break;
                }

                newlink = tenderitem;
                _context2.next = 27;
                break;

              case 24:
                _context2.next = 26;
                return _this5.convertLinktoPDF(tenderitem, 0, 'pdf', [], 'external');

              case 26:
                newlink = _context2.sent;

              case 27:
                _this5.pdfStr = newlink;
                _this5.showloadingpdf = false;

              case 29:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this5);
      }))();
    },
    closepdfdownload: function closepdfdownload() {
      this.$refs.downloadpdf.hide();
    },
    opentenderqa: function opentenderqa() {
      this.getProductList();
      this.tenderQA = true;
    },
    closetenderqa: function closetenderqa() {
      this.tenderQA = false;
    },
    getProductList: function getProductList() {
      var _this6 = this;

      this.productlistforpricearr = [];
      var projectid = this.contractType === 'Hovedentreprise' ? this.submittedIndustries.length === 1 && this.submittedIndustries[0] === '1062' ? this.parentprojectID : this.projectID : this.parentprojectID;
      this.formLoading = true;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/getListPricePartnerAi?project_id=' + projectid + '&contact_id=' + this.contactID, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        for (var index in res) {
          var enterpiserdata = {};
          enterpiserdata['industryid'] = index;
          enterpiserdata['industrydetails'] = {};
          for (var jobindustry in res[index]) {
            _this6.selectiondescriptionObj[index + '-' + jobindustry] = [];
            if (_this6.submittedIndustries.includes(jobindustry) && jobindustry !== '1062') {
              enterpiserdata['jobindustry'] = jobindustry;
              enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              _this6.tagsData.push({ label: _this6.primaryproductindustryname[index] + ' - ' + _this6.itemsjobindustry[jobindustry], value: index + '-' + jobindustry, key: index });
            } else if (_this6.submittedIndustries.includes(jobindustry) && _this6.submittedIndustries.length === 1 && jobindustry === '1062') {
              enterpiserdata['jobindustry'] = jobindustry;
              enterpiserdata['industrydetails'][jobindustry] = res[index][jobindustry];
              _this6.tagsData.push({ label: _this6.primaryproductindustryname[index] + ' - ' + _this6.itemsjobindustry[jobindustry], value: index + '-' + jobindustry, key: index });
            }
            _this6.selectiondescriptionObj[index + '-' + jobindustry] = res[index][jobindustry];
          }
          _this6.productlistforpricearr.push(enterpiserdata);
        }
        _this6.formLoading = false;
      }, function (response) {
        var error = response.body;
        _this6.$refs.errorMsg.showMsg(error);
      });
    },
    gettaskbitrix: function gettaskbitrix() {
      var _this7 = this;

      this.$http.get(this.$bitrixapi + 'industries/full', { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.success) {
          var industryname = {};
          res.data.forEach(function (l) {
            industryname[l.BRANCHE_ID] = l.BRANCHE;
          });
          _this7.itemsjobindustry = industryname;
        }
      }, function (response) {
        console.log('Error: ', response);
      });
    },
    getPublicFiles: function getPublicFiles() {
      var _this8 = this;

      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID;
      this.haaid = localStorage.getItem('haaid');
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getAddresPublicFiles', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this8.publicFiles = res;
      }, function (response) {
        var error = response.body;
        _this8.$refs.errorMsg.showMsg(error);
      });
    },
    getallwizardproduct: function getallwizardproduct() {
      var _this9 = this;

      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/wizard/all', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        res.forEach(function (n) {
          _this9.primaryproductindustryname[n.producttypeid] = n.producttype;
        });
      }, function (err) {
        var error = err.body.message;
        _this9.$message.error(error);
      });
    },
    getnoreplybydescId: function getnoreplybydescId(descid, enterpriseId, jobindystry) {
      var nodescid = [];
      nodescid = this.defaultallquestionsanswerArr.filter(function (l) {
        return l.UF_DESCRIPTION_ID === jobindystry + '-' + descid && l.UF_INDUSTRY_ID === enterpriseId;
      });
      return nodescid[0] ? nodescid[0]['TOTAL_REPLY'] : 0;
    },
    getQuestionsAnswers: function getQuestionsAnswers() {
      var _this10 = this;

      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getAllQuestions', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this10.defaultallquestionsanswerArr = res;
        _this10.allquestionsanswerArr = res;
        res.forEach(function (k, index) {
          _this10.allquestionsanswerArr[index]['childquestionsanswers'] = [];
          _this10.alldescriptionidwithreply.push(k.UF_DESCRIPTION_ID);
        });
        _this10.innerloading = false;
      }, function (err) {
        var error = err.body.message;
        _this10.$message.error(error);
      });
    },
    selectDescIndustry: function selectDescIndustry(industryID, index) {
      var jobindustry = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

      this.selectedIndustryDesc['industryid'] = industryID;
      this.selectedIndustryDesc['industrydesc'] = jobindustry + '-' + index;
      this.updatequestionsView(jobindustry + '-' + index, industryID);
    },
    showall: function showall() {
      this.allquestionsanswerArr = this.defaultallquestionsanswerArr;
    },
    seeTenderpublic: function seeTenderpublic() {
      console.log('asdasd');
    },
    addastags: function addastags(industryID, jobindustry, descindex) {
      var descitem = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';

      this.productTags = [];
      this.descIndex = [];
      this.disableaddbutton = false;
      if (!this.productTags.includes(industryID + '-' + jobindustry)) {
        this.productTags.push(industryID + '-' + jobindustry);
      }
      this.seletecddescline = descitem;
      this.descIndex.push(descindex);
      this.selectedIndustryDesc['industrydesc'] = jobindustry + '-' + descindex;
    },
    autoselectdescID: function autoselectdescID() {
      var selecteditem = this.productTags[0];
      var selecteditemdesc = this.descIndex[0];
      this.selectedIndustryDesc['industrydesc'] = selecteditem.split('-')[1] + '-' + selecteditemdesc;
    },
    pagesRenderedHandler: function pagesRenderedHandler(pdfapp) {
      this.pdf = pdfapp;
      this.activepage = pdfapp.page;
      var thisvar = this;
      this.pdf.bindEvents('pagechanging', function (a) {
        thisvar.page = a.page;
      });
    },
    addquestion: function addquestion() {
      var _this11 = this;

      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID;
      if (this.questions === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst spørgsmål'
        });
        return false;
      }
      var tags = this.productTags.join(',');
      this.disableaddbutton = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        industryId: tags,
        descriptionId: this.selectedIndustryDesc['industrydesc'],
        contactId: this.contactID,
        question: this.questions,
        jobIndustryId: this.selectedIndustryDesc['industrydesc'] ? this.selectedIndustryDesc['industrydesc'].split('-')[0] : '0'
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + projectid + '/addQuestion', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this11.questions = '';
        _this11.productTags = [];
        _this11.disableaddbutton = false;
        _this11.seletecddescline = '';
        _this11.selectedIndustryDesc['industryid'] = '';
        _this11.selectedIndustryDesc['industrydesc'] = '';
        _this11.getQuestionsAnswers();
      }, function (err) {
        var error = err.body.message;
        _this11.$message.error(error);
      });
    },
    refresh: function refresh() {
      this.innerloading = true;
      this.getQuestionsAnswers();
    },
    viewanswers: function viewanswers(index, parentid) {
      var _this12 = this;

      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID;
      this.innerloading = true;
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/project/' + projectid + '/getQuestion/' + parentid, { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        _this12.allquestionsanswerArr[index]['childquestionsanswers'] = res;
        _this12.innerloading = false;
      }, function (err) {
        var error = err.body.message;
        _this12.$message.error(error);
      });
    },
    addchildreplay: function addchildreplay(divid) {
      console.log('🚀 ~ file: tenderFolder.vue:428 ~ addchildreplay ~ divid', divid);
      var inputdiv = document.getElementById('reply' + divid.toString());
      inputdiv.classList.remove('hide');
    },
    hidechildreply: function hidechildreply(index, parentid) {
      this.replayanswer = '';
      var inputdiv = document.getElementById('reply' + parentid.toString());
      inputdiv.classList.add('hide');
    },
    addreplytoanswers: function addreplytoanswers(parentId, parentindex) {
      var _this13 = this;

      var projectid = this.contractType === 'Hovedentreprise' ? this.projectID : this.parentprojectID;
      if (this.replayanswer === '') {
        this.$message({
          type: 'error',
          message: 'Tilføj venligst spørgsmål'
        });
        return false;
      }
      this.salesPersonbitrix = localStorage.getItem('id_token_portalbitrix');
      var headers = {
        Authorization: 'Bearer ' + this.salesPersonbitrix
      };
      var data = {
        parentId: parentId,
        message: this.replayanswer
      };
      this.$http.post(this.$bitrixapi + 'partner/project/' + projectid + '/replyQuestion', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this13.productTags = [];
        _this13.replayanswer = '';
        _this13.disableaddbutton = false;
        _this13.selectedIndustryDesc['industryid'] = '';
        _this13.selectedIndustryDesc['industrydesc'] = '';
        _this13.viewanswers(parentindex, parentId);
      }, function (err) {
        var error = err.body.data;
        _this13.$message.error(error);
      });
    },
    updatequestionsView: function updatequestionsView(descId, enterpriseId) {
      var filteredquestions = [];
      filteredquestions = this.defaultallquestionsanswerArr.filter(function (l) {
        return l.UF_DESCRIPTION_ID === descId && l.UF_INDUSTRY_ID === enterpriseId;
      });
      this.allquestionsanswerArr = filteredquestions;
    },
    gotomenikunder: function gotomenikunder() {
      this.$router.push('/alle-moeder');
    }
  }
});

/***/ }),
/* 1611 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"clearfix gibson px2 mb4",attrs:{"id":"TenderFolder"}},[_c('div',{staticClass:"mt2 pointer"},[_c('i',{staticClass:"el-icon-back",on:{"click":function($event){return _vm.gotomenikunder()}}})]),_vm._v(" "),_c('div',{staticClass:"col-12 mt2 px0 flex justify-start items-start flex-column"},[_c('p',{staticClass:"h2 regular line-height-2 mt2"},[_vm._v(_vm._s(_vm.projectTitle))]),_vm._v(" "),_c('p',{staticClass:"h5 regular line-height-2"},[_vm._v(_vm._s(_vm.projectAddress))]),_vm._v(" "),_c('p',{staticClass:"pointer",on:{"click":function($event){return _vm.folderChange(67970, 'Public', '67967', 4,'in')}}},[_vm._v("Se offentlige dokumenter")]),_vm._v(" "),_c('p',{staticClass:"line-height-golden font14 darkblue m0"},[_vm._v("Her finder du den fulde oversigt over materialet i udbuddet. Du kan stille uddybende spørgsmål til materialet, se arbejdsbeskrivelse og betingelser, tilgå eventuelle dokumenter i arkiv, samt se inspiration fra kunden, såfremt dette er uploadet. Til sidst finder du det tilbud, du har givet kunden, når dette er afgivet.")])]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"col-12 p0"},[_c('div',{},[_c('ol',{staticClass:"breadcrumb transparent px0 mb-0"},_vm._l((_vm.parentFolderData),function(folder,index){return _c('li',{key:index,staticClass:"h6 breadcrumb-item pointer",on:{"click":function($event){return _vm.folderChange(folder.folderId, folder.folderName, _vm.currentFolderParentId, index, 'out')}}},[_c('a',[_vm._v(_vm._s(folder.folderName))])])}),0)]),_vm._v(" "),(_vm.insideFolder !== 'in')?_c('p',{staticClass:"m0 h6 p0 col-12 flex justify-start my2"},[_vm._v("Udbudsmappe")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap pb4 mt1 gap-15"},[(_vm.selectedFolder !== 'Public' && _vm.selectedFolder !== 'Offers' && _vm.selectedFolder !== 'Inspiration' && _vm.selectedFolder !== 'Archive' && _vm.offerStatus !== 'accepted')?_c('div',{staticClass:"flex flex-column border light-highlights p2 items-center pointer",staticStyle:{"width":"162px","height":"151px"},on:{"click":function($event){return _vm.opentenderqa()}}},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"65.547","height":"75","viewBox":"0 0 65.547 75"}},[_c('path',{attrs:{"id":"Path_4061","data-name":"Path 4061","d":"M5876.205-238a9.224,9.224,0,0,1-2.085-.241.292.292,0,0,0-.047-.011c-.175-.044-.354-.093-.543-.15,0,0,0,0-.006,0a.227.227,0,0,1-.044-.014.227.227,0,0,0-.041-.011l-.188-.063c-.088-.03-.178-.063-.266-.1h0l-.037-.016a.407.407,0,0,0-.053-.019c-.186-.071-.354-.145-.52-.219,0,0,0,0,0,0s0,0-.006,0c-.146-.068-.3-.148-.473-.24a.494.494,0,0,1-.057-.033c-.02-.011-.039-.019-.061-.03-.137-.077-.273-.156-.4-.235a.2.2,0,0,0-.029-.022l-.047-.025c-.15-.1-.3-.2-.448-.309-.016-.011-.029-.025-.046-.036s-.036-.025-.053-.038h0c-.115-.085-.229-.175-.339-.265l-.044-.041a.836.836,0,0,1-.071-.057h0a0,0,0,0,0,0,0c-.046-.038-.092-.079-.137-.118-.1-.085-.183-.167-.265-.246l-5.9-5.66a0,0,0,0,0,0,0s0,0,0,0c-.112-.109-.228-.227-.356-.363h-3.232a6.4,6.4,0,0,1-6.393-6.39V-306.61a6.4,6.4,0,0,1,6.393-6.39h35.533a6.4,6.4,0,0,1,6.39,6.39v.519h2.384a4.8,4.8,0,0,1,4.8,4.794v25.922a34.352,34.352,0,0,1,8.806,6.764,4.709,4.709,0,0,1,0,6.381,34.317,34.317,0,0,1-8.806,6.764v12.673a4.8,4.8,0,0,1-4.8,4.794Zm-12.1-23.145v8.355c0,.087,0,.178,0,.268,0,.03,0,.06.006.09,0,.06.008.117.014.178v.022h7.926a3.825,3.825,0,0,1,3.82,3.821v7.475c.109.005.216.008.325.008H5904.7a1.868,1.868,0,0,0,1.866-1.864h0v-11.3q-1.226.5-2.484.894l-.18.057c-.129.038-.258.079-.389.115s-.268.079-.4.115c-.1.027-.2.057-.3.085-.2.052-.4.1-.6.153l-.159.038a30.44,30.44,0,0,1-9.554.752l-.15-.011-.521-.049-.29-.03c-.106-.011-.216-.025-.322-.038-.252-.03-.5-.066-.749-.1l-.077-.011a30.931,30.931,0,0,1-7.692-2.192c-.039-.016-.079-.033-.12-.052-.161-.071-.323-.142-.484-.216l-.161-.074c-.47-.216-.932-.443-1.392-.683-.1-.052-.2-.1-.295-.156s-.221-.117-.33-.178l-.336-.189c-.1-.055-.2-.112-.3-.169-.143-.082-.287-.167-.429-.254l-.2-.12c-.205-.126-.41-.254-.613-.383-.067-.044-.137-.087-.2-.134-.147-.093-.295-.191-.439-.29-.071-.046-.145-.1-.216-.145-.151-.1-.3-.208-.452-.314-.057-.041-.114-.082-.174-.123-.208-.15-.413-.3-.617-.454a.247.247,0,0,0-.036-.027q-.287-.217-.573-.443c-.059-.044-.113-.09-.17-.137-.148-.118-.3-.238-.443-.358-.06-.049-.12-.1-.177-.15-.165-.134-.326-.273-.484-.413-.035-.03-.074-.06-.109-.093-.193-.172-.388-.344-.582-.522-.043-.038-.085-.079-.128-.12-.151-.137-.3-.276-.443-.415-.06-.057-.12-.117-.184-.175-.134-.131-.267-.262-.4-.4-.058-.055-.112-.112-.169-.167-.184-.189-.367-.374-.548-.566a4.709,4.709,0,0,1,0-6.381c.181-.191.364-.38.548-.566.057-.057.111-.112.169-.167.132-.134.265-.265.4-.4l.184-.175c.147-.142.292-.279.44-.415.046-.041.088-.082.131-.12.194-.178.389-.353.582-.522.038-.033.074-.063.109-.1.161-.137.319-.276.481-.41l.18-.15c.147-.12.295-.238.44-.358.06-.046.117-.09.175-.137.188-.15.377-.3.568-.44l.039-.03c.2-.153.409-.3.617-.454.06-.041.117-.082.177-.126l.446-.312.221-.148.432-.287c.071-.044.141-.09.208-.134.2-.131.408-.257.613-.383.067-.044.139-.082.21-.126.139-.085.278-.167.418-.249l.3-.172c.108-.063.221-.123.33-.183s.224-.123.34-.183c.092-.052.185-.1.28-.15.465-.243.933-.473,1.407-.691l.151-.068c.163-.074.327-.148.492-.219l.111-.049a31.034,31.034,0,0,1,7.7-2.192c.025-.005.053-.008.077-.014.252-.035.5-.068.755-.1.106-.014.21-.027.316-.038s.194-.022.29-.03c.174-.019.347-.033.52-.049.051,0,.1-.008.155-.014a30.454,30.454,0,0,1,9.543.752c.058.014.117.027.175.044.189.044.375.093.563.142l.363.1c.12.033.241.068.358.1l.407.123c.049.016.1.03.149.046q1.269.4,2.507.9V-301.3a1.868,1.868,0,0,0-1.866-1.864h-38.726a1.866,1.866,0,0,0-1.864,1.864v28.433a1.465,1.465,0,0,1-1.466,1.465,1.464,1.464,0,0,1-1.464-1.465V-301.3a4.8,4.8,0,0,1,4.794-4.794h33.412v-.519a3.464,3.464,0,0,0-3.46-3.46h-35.533a3.465,3.465,0,0,0-3.463,3.46v53.648a3.465,3.465,0,0,0,3.463,3.46h1.4c-.016-.038-.029-.077-.043-.115-.022-.057-.041-.112-.063-.169a.066.066,0,0,0-.008-.022v0a.16.16,0,0,1-.008-.027c-.011-.03-.021-.063-.031-.093,0,0,0,0,0,0-.014-.044-.024-.087-.038-.128s-.035-.109-.052-.164c-.006-.022-.012-.041-.018-.06-.019-.06-.032-.12-.048-.178-.009-.033-.02-.066-.027-.1-.028-.115-.056-.229-.08-.347,0-.005,0-.011,0-.019-.021-.107-.042-.216-.061-.325-.006-.036-.011-.074-.017-.109-.014-.079-.026-.159-.038-.241,0-.041-.011-.085-.013-.126-.01-.077-.018-.153-.025-.23,0-.041-.009-.085-.011-.126-.006-.082-.011-.161-.017-.243,0-.036,0-.074-.006-.112,0-.117,0-.232,0-.35v-8.355a1.464,1.464,0,0,1,1.464-1.465A1.465,1.465,0,0,1,5864.109-261.145Zm1.314,12.17,0,.005c.011.016.022.03.033.044a.291.291,0,0,1,.025.03c.062.074.125.148.188.221.016.016.026.033.04.049l.033.033c.1.107.183.194.265.273l5.9,5.663c.049.047.1.1.161.15.035.03.073.063.117.1a.169.169,0,0,0,.033.03c.014.014.029.022.043.036.077.063.156.123.235.183.012.008.022.019.036.03a.163.163,0,0,1,.026.019c.1.074.205.142.307.208l.016.011a.148.148,0,0,0,.036.019l.027.016v-6.556a.891.891,0,0,0-.891-.891h-6.873C5865.262-249.191,5865.342-249.082,5865.424-248.975Zm18.768-16.447a10.716,10.716,0,0,0,10.7,10.7,10.717,10.717,0,0,0,10.7-10.7,10.716,10.716,0,0,0-10.7-10.7A10.715,10.715,0,0,0,5884.191-265.422Zm24.337,0a13.574,13.574,0,0,1-3.075,8.617q.93-.381,1.851-.834a31.178,31.178,0,0,0,8.865-6.6,1.809,1.809,0,0,0,0-2.359,31.171,31.171,0,0,0-8.877-6.608c-.147-.074-.3-.148-.445-.216a.082.082,0,0,1-.021-.011c-.454-.213-.913-.413-1.372-.6A13.572,13.572,0,0,1,5908.528-265.422Zm-31.266-4.5a.639.639,0,0,1-.058.044c-.123.1-.245.194-.365.292l-.181.148c-.106.087-.213.175-.319.265-.083.068-.165.139-.247.208s-.175.15-.262.229q-.246.213-.486.435c-.063.057-.123.115-.187.172-.114.107-.229.213-.341.322-.063.06-.124.12-.187.18-.12.115-.238.232-.358.353-.048.049-.1.1-.152.15-.167.172-.334.344-.5.519a1.726,1.726,0,0,0-.437,1.178,1.746,1.746,0,0,0,.337,1.058,1.205,1.205,0,0,0,.1.123c.163.172.33.344.5.514l.164.164c.114.115.229.227.345.339l.2.189c.107.1.216.2.325.309.068.063.134.126.2.186.155.142.312.284.474.424.092.085.19.164.283.246l.23.2c.109.09.218.183.327.273.058.044.112.09.17.137.123.1.248.2.374.3.017.011.03.022.044.033a29.843,29.843,0,0,0,7.084,4.124,13.553,13.553,0,0,1-3.074-8.611,13.558,13.558,0,0,1,3.074-8.611A30.007,30.007,0,0,0,5877.263-269.917Zm10.21,4.5a7.431,7.431,0,0,1,7.423-7.42,7.428,7.428,0,0,1,7.42,7.42A7.429,7.429,0,0,1,5894.9-258,7.431,7.431,0,0,1,5887.473-265.422Zm2.93,0a4.5,4.5,0,0,0,4.493,4.493,4.5,4.5,0,0,0,4.49-4.493,4.5,4.5,0,0,0-4.49-4.49A4.5,4.5,0,0,0,5890.4-265.422Zm-28.045-.145a1.521,1.521,0,0,1-.273-.085,1.452,1.452,0,0,1-.255-.134,1.5,1.5,0,0,1-.224-.183,1.479,1.479,0,0,1-.181-.221,1.454,1.454,0,0,1-.133-.254,1.35,1.35,0,0,1-.085-.273,1.433,1.433,0,0,1-.03-.287,1.455,1.455,0,0,1,.03-.287,1.407,1.407,0,0,1,.085-.273,1.531,1.531,0,0,1,.133-.251,1.5,1.5,0,0,1,.181-.224,1.486,1.486,0,0,1,1.323-.4,1.228,1.228,0,0,1,.275.085,1.452,1.452,0,0,1,.252.131,1.677,1.677,0,0,1,.222.183,1.4,1.4,0,0,1,.184.224,1.546,1.546,0,0,1,.136.251,1.63,1.63,0,0,1,.082.273,1.455,1.455,0,0,1,.03.287,1.433,1.433,0,0,1-.03.287,1.555,1.555,0,0,1-.082.273,1.466,1.466,0,0,1-.136.254,1.385,1.385,0,0,1-.184.221,1.487,1.487,0,0,1-.222.183,1.46,1.46,0,0,1-.252.134,1.517,1.517,0,0,1-.275.085,1.428,1.428,0,0,1-.285.027A1.459,1.459,0,0,1,5862.357-265.567Zm8.945-13.156a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h7.972a1.465,1.465,0,0,1,1.467,1.465,1.465,1.465,0,0,1-1.467,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h18.641a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Zm0-8.057a1.465,1.465,0,0,1-1.465-1.465,1.465,1.465,0,0,1,1.465-1.465h25.782a1.465,1.465,0,0,1,1.465,1.465,1.465,1.465,0,0,1-1.465,1.465Z","transform":"translate(-5854 313)","fill":"#003645"}})])]),_vm._v(" "),_c('span',{staticClass:"center m0"},[_vm._v("Spørgsmål og svar")])]):_vm._e(),_vm._v(" "),_vm._l((_vm.documentsData),function(item,index){return (_vm.insideFolder !== 'in' && item.NAME !== 'Public')?_c('div',{key:index,staticClass:"pointer flex flex-column items-center border light-highlights p2 px3",staticStyle:{"width":"162px","height":"151px"}},[(item.TYPE !== 'folder')?_c('div',{staticClass:"flex flex-column items-center",on:{"click":function($event){return _vm.openpdfdownload(item.pdfbase64)}}},[_c('el-tooltip',{attrs:{"content":item.NAME,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"pdf_ic","width":"55","height":"75","viewBox":"0 0 55 75"}},[_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z","transform":"translate(-28.492 -31.709)","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z","transform":"translate(0 0)","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z","transform":"translate(-32.976 -134.449)","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z","transform":"translate(-58.222 -134.456)","fill":"#003645"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z","transform":"translate(-83.969 -134.456)","fill":"#003645"}})])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":item.NAME,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue center",staticStyle:{"overflow-wrap":"anywhere"}},[_vm._v(_vm._s(_vm._f("truncate")(item.NAME,20, '...')))])])],1):_vm._e(),_vm._v(" "),(item.TYPE === 'folder')?_c('div',{staticClass:"flex flex-column",on:{"click":function($event){return _vm.folderChange(item.ID, item.NAME, item.PARENT_ID, index,'in')}}},[_c('el-tooltip',{attrs:{"content":item.NAME,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"55","height":"73.542","viewBox":"0 0 55 73.542"}},[_c('path',{attrs:{"id":"Filer","d":"M-914.761-38.458c-4,0-5.749-4.627-6.208-7.848l-.03-.213v-57.307a10.075,10.075,0,0,1,1.556-6,5.24,5.24,0,0,1,5.337-2.073h13.246l5.311,12.028h4.292c.663,0,1.2.869,1.2,1.94s-.535,1.937-1.2,1.937h-5.527l-5.311-12.028h-12.182l-.088-.021a3.562,3.562,0,0,0-3.518,1.162,5.228,5.228,0,0,0-.719,3.053v56.84c.183,1.068,1.2,6.11,4.016,6.11h42.075c.568-.157,4.113-1.323,4.113-6.075v-43.28a13.41,13.41,0,0,0-.6-3.137c-.622-1.842-1.58-2.739-2.933-2.739h-6.927c-.662,0-1.2-.865-1.2-1.937s.537-1.94,1.2-1.94h6.927c2.251,0,4.057,1.741,5.084,4.9A19,19,0,0,1-866-90.434l0,.122v43.36c0,6.752-4.267,7.991-6.429,8.476l-.082.017Zm28.784-58.016a2.8,2.8,0,0,1-.367-1.434,2.8,2.8,0,0,1,.367-1.434,1.086,1.086,0,0,1,.88-.593,1.091,1.091,0,0,1,.883.593,2.823,2.823,0,0,1,.365,1.434,2.823,2.823,0,0,1-.365,1.434,1.091,1.091,0,0,1-.883.593A1.086,1.086,0,0,1-885.977-96.474Z","transform":"translate(921 112)","fill":"#003645"}})])])]),_vm._v(" "),(item.NAME === 'Offers')?_c('span',{staticClass:"darkblue center"},[_vm._v("Tilbud")]):(item.NAME === 'Archive')?_c('span',{staticClass:"darkblue center"},[_vm._v("Arkiv")]):_c('span',{staticClass:"darkblue center"},[_vm._v("Inspiration")])],1):_vm._e()]):_vm._e()})],2),_vm._v(" "),(_vm.selectedFolder === 'Public' && _vm.insideFolder === 'in')?_c('div',{staticClass:"flex flex-wrap border border-top-0 border-left-0 border-right-0 pb4 mt1 center"},[_c('p',{staticClass:"m0 h6 col-12 flex justify-start my2"},[_vm._v("Offentlige filer")]),_vm._v(" "),(_vm.publicFiles.length < 1)?_c('div',{staticClass:"flex flex-column col-12 m0 p0"},[_c('p',{staticClass:"m0 h6"},[_vm._v("Vi får de offentlige filer på denne adresse, så snart vi er færdige. Venligst vend tilbage senere for at se alle filer")])]):_vm._l((_vm.publicFiles),function(file,index){return _c('div',{key:index,on:{"click":function($event){return _vm.openpdfdownload(file.UF_LINK)}}},[_c('div',{staticClass:"pointer mx2 flex flex-column border light-highlights p2 mb3",staticStyle:{"width":"130px"}},[_c('el-tooltip',{attrs:{"content":"","placement":"top-start","effect":"light"}},[_c('p',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(file.UF_DESCRIPTION)},slot:"content"}),_vm._v(" "),_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"pdf_ic","width":"55","height":"75","viewBox":"0 0 55 75"}},[_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z","transform":"translate(-28.492 -31.709)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z","transform":"translate(0 0)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z","transform":"translate(-32.976 -134.449)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z","transform":"translate(-58.222 -134.456)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z","transform":"translate(-83.969 -134.456)","fill":"#134553"}})])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":file.UF_YEAR + '_' + file.UF_ADDRESS_TYPE,"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue center"},[_vm._v(_vm._s(file.UF_YEAR !== null ? _vm.truncate(file.UF_YEAR.trim() + '_' + file.UF_ADDRESS_TYPE, 10, '..') : 'file_' + index))])])],1)])})],2):_vm._e(),_vm._v(" "),(_vm.selectedFolder === 'Offers' && _vm.tenderOfferFiles.length > 0)?_c('div',{staticClass:"border border-top-0 border-left-0 border-right-0 pb4 mt1 center"},[_c('div',{on:{"click":function($event){return _vm.openpdfdownload(_vm.tenderfilesOffer.URL)}}},[_c('div',{staticClass:"pointer mx2 flex flex-column border light-highlights p2 mb3",staticStyle:{"width":"130px"}},[_c('el-tooltip',{attrs:{"content":_vm.projectTitle + '-' + _vm.projectID + '-' + 'Offers',"placement":"top-start","effect":"light"}},[_c('p',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.projectTitle + '-' + _vm.projectID + '-' + 'Offers')},slot:"content"}),_vm._v(" "),_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"pdf_ic","width":"55","height":"75","viewBox":"0 0 55 75"}},[_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z","transform":"translate(-28.492 -31.709)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z","transform":"translate(0 0)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z","transform":"translate(-32.976 -134.449)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z","transform":"translate(-58.222 -134.456)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z","transform":"translate(-83.969 -134.456)","fill":"#134553"}})])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":_vm.projectTitle + '-' + _vm.projectID + '-' + 'Offers',"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue center"},[_vm._v(_vm._s(_vm.projectTitle + '-' + _vm.projectID  + '-' + 'Offers'))])])],1)])]):_vm._e(),_vm._v(" "),(_vm.selectedFolder === 'Inspiration' && _vm.tenderInspirationFiles.length > 0)?_c('div',{staticClass:"border border-top-0 border-left-0 border-right-0 pb4 mt1 center"},[_c('div',{on:{"click":function($event){return _vm.openpdfdownload(_vm.tenderfilesInspiration.URL)}}},[_c('div',{staticClass:"pointer mx2 flex flex-column border light-highlights p2 mb3",staticStyle:{"width":"130px"}},[_c('el-tooltip',{attrs:{"content":_vm.projectTitle + '-' + _vm.projectID + '-' + 'Inspiration',"placement":"top-start","effect":"light"}},[_c('p',{attrs:{"slot":"content"},domProps:{"innerHTML":_vm._s(_vm.projectTitle + '-' + _vm.projectID + '-' + 'Inspiration')},slot:"content"}),_vm._v(" "),_c('span',{staticClass:"darkblue"},[_c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","id":"pdf_ic","width":"55","height":"75","viewBox":"0 0 55 75"}},[_c('path',{attrs:{"id":"Path_392","data-name":"Path 392","d":"M59.773,62.32a27.863,27.863,0,0,1-1.966-2.263,22.185,22.185,0,0,1-1.818-2.485c1.1-3.191,2.239-7.458,1.634-10.1a3.171,3.171,0,0,0-3.149-2.779l-.17.012a3.789,3.789,0,0,0-3.06,2.716c-.9,2.63-.12,6.527,2.08,10.46a71.82,71.82,0,0,1-3.046,6.954c-2.556,1.011-5.967,2.693-8.013,5.036-2.219,2.539-1.941,4.8-1.314,6.243l.148.252.036.05a2.381,2.381,0,0,0,1.857.925,3.216,3.216,0,0,0,1.537-.442c1.949-1.074,4.722-4.81,7.431-10.015a40.78,40.78,0,0,1,6.986-1.874c3.851,3.654,8.08,5.454,10.566,4.487a3.188,3.188,0,0,0,1.963-3.179,3.9,3.9,0,0,0-2.8-3.612C66.725,61.911,63.568,61.781,59.773,62.32ZM54.939,60.39c.337.46.688.91,1.05,1.335.292.377.6.75.9,1.109-1.139.246-2.272.54-3.383.875C54.023,62.6,54.5,61.493,54.939,60.39Zm.351-12.319c.3,1.32-.006,3.609-.86,6.521-1.044-2.494-1.409-4.89-.927-6.3a1.368,1.368,0,0,1,1.061-1.044C54.817,47.255,55.115,47.3,55.29,48.071ZM48.3,68.483c-1.9,3.227-3.678,5.486-4.873,6.142a1.112,1.112,0,0,1-.4.151c-.329-1.011-.011-2.023.988-3.167A14.9,14.9,0,0,1,48.3,68.483Zm14-3.9a13.378,13.378,0,0,1,5.527.5c1.225.492,1.242,1.088,1.247,1.275,0,.575-.223.661-.387.727C67.639,67.5,65.122,66.736,62.3,64.583Z","transform":"translate(-28.492 -31.709)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_393","data-name":"Path 393","d":"M53.916,14.4,40.948,1.114A3.643,3.643,0,0,0,38.325,0H3.71A3.762,3.762,0,0,0,0,3.8V71.2A3.762,3.762,0,0,0,3.71,75H51.29A3.762,3.762,0,0,0,55,71.2V17.087A3.811,3.811,0,0,0,53.916,14.4ZM52.537,52.455V71.2a1.282,1.282,0,0,1-.366.9,1.226,1.226,0,0,1-.878.375H3.71A1.261,1.261,0,0,1,2.466,71.2V52.458H52.537ZM40.582,13.723V4.311l10.21,10.461H41.609A1.038,1.038,0,0,1,40.582,13.723ZM41.609,17.3H52.537V49.926H2.466V3.8A1.261,1.261,0,0,1,3.71,2.526H38.116v11.2A3.539,3.539,0,0,0,41.609,17.3Z","transform":"translate(0 0)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_394","data-name":"Path 394","d":"M47.348,203.788a1.278,1.278,0,0,0,1.278-1.278V199.17h2.367a3.647,3.647,0,0,0,3.642-3.645v-2.014a3.646,3.646,0,0,0-3.642-3.642H47.348a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,47.348,203.788Zm1.278-7.174v-4.187h2.367a1.087,1.087,0,0,1,1.085,1.088v2.014a1.088,1.088,0,0,1-1.085,1.088H48.626Z","transform":"translate(-32.976 -134.449)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_395","data-name":"Path 395","d":"M82.618,203.795h3.4a3.894,3.894,0,0,0,3.888-3.888v-6.142a3.889,3.889,0,0,0-3.885-3.885h-3.4a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,82.618,203.795Zm1.278-2.556v-8.8H86.02a1.333,1.333,0,0,1,1.332,1.332v6.142a1.333,1.333,0,0,1-1.332,1.332Z","transform":"translate(-58.222 -134.456)","fill":"#134553"}}),_vm._v(" "),_c('path',{attrs:{"id":"Path_396","data-name":"Path 396","d":"M118.588,203.795a1.278,1.278,0,0,0,1.278-1.278v-4.4h2.657a1.278,1.278,0,1,0,0-2.556h-2.657v-3.123H124.6a1.278,1.278,0,1,0,0-2.556h-6.011a1.278,1.278,0,0,0-1.278,1.278v11.361A1.28,1.28,0,0,0,118.588,203.795Z","transform":"translate(-83.969 -134.456)","fill":"#134553"}})])])]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":_vm.projectTitle + '-' + _vm.projectID + '-' + 'Inspiration',"placement":"top-start","effect":"light"}},[_c('span',{staticClass:"darkblue center"},[_vm._v(_vm._s(_vm.projectTitle + '-' + _vm.projectID + '-' + 'Inspiration'))])])],1)])]):_vm._e()]),_vm._v(" "),_c('b-modal',{ref:"tenderQA",staticClass:"p-2 pb-4",attrs:{"id":"tenderQA","hide-footer":"","hide-header":"","size":"lg","centered":"","lazy":"","no-close-on-backdrop":"","no-close-on-esc":""},model:{value:(_vm.tenderQA),callback:function ($$v) {_vm.tenderQA=$$v},expression:"tenderQA"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closetenderqa()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),_c('div',{staticClass:"flex xs-flex-column darkblue"},[_c('div',{staticClass:"flex flex-column lg-col-7 md-col-7 xs-col-12 p0"},[(_vm.formLoading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"p2 overflow-auto projectdesccontainer"},[_c('div',{staticClass:"col-12 p0 m0 flex"},[_c('span',{staticClass:"h5 bold darkblue"},[_vm._v("Beskrivelse")]),_vm._v(" "),_c('div',{staticClass:"ml-auto"},[_c('span',[_c('i',{staticClass:"el-icon-printer pointer"})]),_vm._v(" "),_c('span',[_c('i',{staticClass:"el-icon-download pointer"})])])]),_vm._v(" "),_c('div',{staticClass:"bordercece py3 px1"},_vm._l((_vm.productlistforpricearr),function(item,index){return (item.jobindustry)?_c('div',{key:index,staticClass:" mb2"},[_c('p',{staticClass:"h5 p0 m0 mb1"},[_vm._v(_vm._s((index + 1) + '. ')),_c('span',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.primaryproductindustryname[parseInt(item.industryid)]))])]),_vm._v(" "),_vm._l((Object.entries(item.industrydetails)),function(job,index2){return _c('div',{key:index2,staticClass:"flex flex-column p0 "},[_c('p',{staticClass:"h5 p0 m0 mb1 pl2"},[_vm._v(_vm._s((index + 1) + '.' + (index2 + 1))),_c('span',{staticClass:"regular pl1"},[_vm._v(_vm._s(_vm.itemsjobindustry[job[0]]))])]),_vm._v(" "),_vm._l((item.industrydetails[job[0]]),function(desc,index3){return _c('div',{key:index3},[_c('div',{staticClass:"flex m0 pl3 deschover"},[_c('div',{staticClass:"pointer flex descreptionline flex lg-col-12 sm-col-12 md-col-12 xs-col-11 p0 m0",on:{"click":function($event){return _vm.addastags(item.industryid, job[0], index3, desc)}}},[_c('div',{staticClass:"p0 m0 h6 line-height-golden graymuteddark col-1 mr2"},[_vm._v(_vm._s(parseInt(index + 1) + '.' + (index2 + 1) + '.' + (index3 + 1)))]),_vm._v(" "),_c('div',{staticClass:"pl2 p0 m0 h6 line-height-golden graymuteddark "},[_vm._v(_vm._s(desc.replace('- ', '')))])]),_vm._v(" "),(!_vm.showMobile)?_c('div',{staticClass:"ml-auto addquestionicon pr1",attrs:{"id":index3}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":Number(_vm.getnoreplybydescId(index3, item.industryid, job[0])) > 1 ? _vm.getnoreplybydescId(index3, item.industryid, job[0]) + ' answers' : _vm.getnoreplybydescId(index3, item.industryid, job[0]) + ' answer',"placement":"top"}},[(Number(_vm.getnoreplybydescId(index3, item.industryid, job[0]) > 0))?_c('span',{staticClass:"pointer",on:{"click":function($event){return _vm.selectDescIndustry(item.industryid, index3, job[0])}}},[_c('i',{staticClass:"h5 el-icon-chat-line-square"})]):_vm._e()])],1):(_vm.questions === '' && _vm.showMobile)?_c('span',{staticClass:"ml-auto addquestionicon pr1",attrs:{"id":index3}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"View replies","placement":"top"}},[(Number(_vm.getnoreplybydescId(index3, item.industryid, job[0]) > 0))?_c('span',{staticClass:"small pointer",on:{"click":function($event){return _vm.selectDescIndustry(item.industryid, index3, job[0])}}},[_vm._v(_vm._s(Number(_vm.getnoreplybydescId(index3, item.industryid, job[0])) > 1 ? _vm.getnoreplybydescId(index3, item.industryid, job[0]) + ' answers' : _vm.getnoreplybydescId(index3, item.industryid, job[0]) + ' answer'))]):_vm._e()]),_vm._v(" "),_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Add question","placement":"top-start"}},[_c('i',{staticClass:"el-icon-chat-dot-square pointer",on:{"click":function($event){return _vm.addastags(item.industryid, job[0], index3)}}})])],1):_vm._e()])])})],2)})],2):_vm._e()}),0)])]),_vm._v(" "),_c('div',{staticClass:"p2 boder md-col-5 lg-col-5 xs-col-12 pb3"},[_c('div',{},[_c('div',{staticClass:"m0 p0 mp0 lg-col-12 md-col-12 sm-col-12"},[_c('p',{staticClass:"h5 semi-bold"},[_vm._v("Tilføj Spørgsmål")]),_vm._v(" "),_c('el-form',[_c('el-select',{staticClass:"col-12 p0 capital border tagSelect mb1",attrs:{"multiple":"","filterable":"","multiple-limit":1,"placeholder":"Tags"},on:{"change":function($event){return _vm.autoselectdescID()}},model:{value:(_vm.productTags),callback:function ($$v) {_vm.productTags=$$v},expression:"productTags"}},_vm._l((_vm.tagsData),function(item,index){return _c('el-option',{key:index,attrs:{"label":item.label,"value":item.value}})}),1),_vm._v(" "),(_vm.productTags.length > 0)?_c('el-select',{staticClass:"col-12 p0 capital border mb1",attrs:{"multiple":"","filterable":"","multiple-limit":1,"placeholder":"Beskrivelse"},on:{"change":function($event){return _vm.autoselectdescID()}},model:{value:(_vm.descIndex),callback:function ($$v) {_vm.descIndex=$$v},expression:"descIndex"}},_vm._l((_vm.selectiondescriptionObj[_vm.productTags[0]]),function(items,index){return _c('el-option',{key:index,attrs:{"label":items,"value":index}})}),1):_vm._e(),_vm._v(" "),_c('el-form-item',{staticClass:"border-none p0 ",attrs:{"label":"","prop":"questions"}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"type":"textarea","rows":3,"placeholder":"Spørgsmål"},model:{value:(_vm.questions),callback:function ($$v) {_vm.questions=$$v},expression:"questions"}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"col-12 flex p0"},[_c('button',{staticClass:"dark-button p2 px3 not-rounded ml-auto",attrs:{"disabled":_vm.disableaddbutton},on:{"click":function($event){return _vm.addquestion()}}},[_vm._v("Tilføj spørgsmål")])])]),_vm._v(" "),_c('div',{staticClass:"flex justify-end p0 m0 mt3 items-center"},[_c('p',{staticClass:"p0 small m0 pointer px1",on:{"click":function($event){return _vm.refresh()}}},[_c('el-tooltip',{staticClass:"item",attrs:{"effect":"dark","content":"Refresh","placement":"top"}},[_c('span',{staticClass:"m0 p0"},[_vm._v("Refresh")])])],1),_vm._v(" "),(_vm.defaultallquestionsanswerArr.length !== _vm.allquestionsanswerArr.length && _vm.allquestionsanswerArr.length > 0)?_c('p',{staticClass:"p0 m0 small pointer",on:{"click":function($event){return _vm.showall()}}},[_vm._v("Show All")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"overflow-auto pt1",class:_vm.defaultallquestionsanswerArr.length > 0 && _vm.allquestionsanswerArr.length < 1 ? 'border muted-border ' : null,staticStyle:{"height":"483px"}},[_c('div',{staticClass:"flex flex-column justify-center"},[(_vm.innerloading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',_vm._l((_vm.allquestionsanswerArr),function(questions,index){return (_vm.allquestionsanswerArr.length > 0 && _vm.submittedIndustries.includes(questions.UF_JOB_INDUSTRY_ID))?_c('div',{key:index,staticClass:"mb1"},[_c('div',{staticClass:"p2 questiondiv flex flex-column"},[(Number(_vm.haaId) === questions.UF_PARTNER_ID)?_c('div',{staticClass:"pb1"},[_c('p',{staticClass:"m0 h6 semi-bold"},[_vm._v(" Du - "+_vm._s(_vm.partnerprimaryindustryText))])]):(questions.UF_MESSAGE_FROM === Number(_vm.contactID))?_c('div',{staticClass:"pb1"},[_c('p',{staticClass:"m0 h6 semi-bold"},[_vm._v(" Husejer ")])]):_c('div',{},[_c('p',{staticClass:"m0"},[_vm._v("Haandvaerker")])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap p0 m0"},_vm._l((questions.INDUSTRY),function(industry){return _c('div',{staticClass:"industryquestionsdiv px1 questionsgray flex p0 m0 items-center mb1 mr1"},[_c('p',{staticClass:"m0 p0 lowercase font14"},[_vm._v(_vm._s((industry.NAME))+" - "+_vm._s(_vm.itemsjobindustry[questions.UF_JOB_INDUSTRY_ID]))])])}),0),_vm._v(" "),_c('div',{staticClass:"p0 m0"},[_c('p',{staticClass:"m0 font14 questionsgray"},[_vm._v(_vm._s(questions.UF_MESSAGE))])]),_vm._v(" "),_c('div',{staticClass:"flex p0 m0 small mt2"},[_c('p',{staticClass:"m0 font14"},[_vm._v(_vm._s(questions.TOTAL_REPLY)+" Samlet svar")]),_vm._v(" "),(questions.TOTAL_REPLY > 0)?_c('p',{staticClass:"m0 ml-auto font14 pointer",on:{"click":function($event){return _vm.viewanswers(index, questions.ID)}}},[_vm._v("Se svar")]):_c('p',{staticClass:"m0 ml-auto font12 pointer",on:{"click":function($event){return _vm.addchildreplay(questions.ID)}}},[_vm._v("Svar")])])]),_vm._v(" "),(questions['childquestionsanswers'].length > 0)?_c('div',{staticClass:"ml2 py1 pr0 pl2 flex flex-column font14 relative"},[_vm._l((questions['childquestionsanswers']),function(otherchild){return _c('div',{staticClass:"questiondiv p2"},[(otherchild.UF_MESSAGE_FROM === Number(_vm.contactID))?_c('p',{staticClass:"m0 primarycolor"},[_vm._v("Husejer")]):(otherchild.UF_MESSAGE_FROM === Number(_vm.haaId))?_c('p',{staticClass:"m0 primarycolor"},[_vm._v("Du")]):_vm._e(),_vm._v(" "),_c('p',{staticClass:"m0 darkblue"},[_vm._v(_vm._s(otherchild.UF_MESSAGE))])])}),_vm._v(" "),_c('p',{staticClass:"m0 absolute bottom-0 right-0 px2 pointer font12",staticStyle:{"bottom":"-13px"},on:{"click":function($event){return _vm.addchildreplay(questions.ID)}}},[_vm._v("Svar")])],2):_vm._e(),_vm._v(" "),_c('div',{staticClass:"ml2 p2 my1 flex hide",attrs:{"id":'reply' + questions.ID}},[_c('el-input',{staticClass:"border wizard-border white-background",attrs:{"type":"textarea","rows":1,"placeholder":"Spørgsmål"},model:{value:(_vm.replayanswer),callback:function ($$v) {_vm.replayanswer=$$v},expression:"replayanswer"}}),_vm._v(" "),_c('button',{staticClass:"small action-button pointer",on:{"click":function($event){return _vm.addreplytoanswers(questions.ID, index)}}},[_vm._v("Indsend")]),_vm._v(" "),_c('button',{staticClass:"small outlined-standard-button pointer",on:{"click":function($event){return _vm.hidechildreply(index, questions.ID)}}},[_vm._v("Afbestille")])],1)]):_vm._e()}),0)])])])])]),_vm._v(" "),_c('b-modal',{ref:"downloadpdf",attrs:{"centered":"","hide-header":"","hide-footer":"","id":"downloadpdf","size":"lg"}},[_c('div',{staticClass:"col-12 flex justify-end items-center white-background px0 "},[_c('button',{staticClass:"white-button no-border not-rounded gibson ",attrs:{"type":"button"},on:{"click":function($event){return _vm.closepdfdownload()}}},[_c('span',[_c('i',{staticClass:"el-icon-circle-close"})])])]),_vm._v(" "),(_vm.showloadingpdf)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',{staticClass:"py1 col-12 p0 relative",staticStyle:{"width":"100%","overflow":"auto"}},[_c('div',{staticClass:"col-9 p0 mx-auto"},[_c('vue-pdf-app',{staticStyle:{"height":"100vh"},attrs:{"pdf":_vm.pdfStr,"theme":"light","page-scale":_vm.scale,"config":_vm.config},on:{"pages-rendered":_vm.pagesRenderedHandler}})],1)])]),_vm._v(" "),_c('b-modal',{attrs:{"id":"modal-xl","size":"xl","centered":"","hide-header":"","hide-footer":""},model:{value:(_vm.showPdf),callback:function ($$v) {_vm.showPdf=$$v},expression:"showPdf"}},[_c('b-embed',{attrs:{"type":"iframe","aspect":"16by9","src":_vm.pdfLink,"allowfullscreen":""}})],1),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1612 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addendum_vue__ = __webpack_require__(1614);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6ac0a6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_addendum_vue__ = __webpack_require__(1615);
function injectStyle (ssrContext) {
  __webpack_require__(1613)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_addendum_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f6ac0a6a_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_addendum_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1613 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1614 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1/* duplicate */).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler
  },
  name: 'Addendum',
  data: function data() {
    return {
      loading: true,
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      userName: localStorage.getItem('name'),
      companyName: localStorage.getItem('CompanyName'),
      period: {
        week: undefined,
        weekDate: '',
        year: ''
      },
      dateNow: __WEBPACK_IMPORTED_MODULE_0_moment___default()(new Date()).locale('da').format('LL'),
      budgetPlannedQuestionInfo: {},
      isBudgetPlanned: null,
      timeData: [{
        day: 'Mandag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Tirsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Onsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Torsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Fredag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Lørdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Søndag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }],
      timeDataTotal: 0,
      materialsData: [{
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }],
      materialsDataTotal: 0,
      timeDataAndmaterialsDataTotal: 0,
      remarks: '',
      currentProjectInfo: {}
    };
  },
  mounted: function mounted() {
    this.displayCurrentProject();
  },

  methods: {
    displayCurrentProject: function displayCurrentProject() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/projects', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (projectProp, projectPropIndex) {
            if (projectProp.IS_ACTIVE === 1) {
              _this.currentProjectInfo = projectProp;
              _this.getContractTemplates();
            }
          });
        }
      }, function (response) {
        var error = response.body;
        _this.$refs.errorMsg.showMsg(error);
      });
    },
    getContractTemplates: function getContractTemplates() {
      var _this2 = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.post(this.$bitrixapi + 'partner/contract/GetAllContractTemplates', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        var res = response.body.data;
        if (res.data && res.data.length > 0) {
          _this2.budgetPlannedQuestionInfo = res.data.filter(function (property) {
            return property.NAME === 'Arbejds seddel';
          })[0].STEPS.step_34.fields[1];
          _this2.isBudgetPlanned = _this2.budgetPlannedQuestionInfo.default_value;
        }
        _this2.period.year = new Date().getFullYear().toString();
        _this2.getCurrentNumberOfWeeks();
        _this2.loading = false;
      }, function (response) {
        _this2.loading = false;
        var error = response.body;
        _this2.$refs.errorMsg.showMsg(error);
      });
    },
    getCurrentNumberOfWeeks: function getCurrentNumberOfWeeks() {
      var todayDate = new Date();
      var oneJan = new Date(todayDate.getFullYear(), 0, 1);
      var numberOfDays = Math.floor((todayDate - oneJan) / (24 * 60 * 60 * 1000));
      this.period.week = Math.ceil((todayDate.getDay() + 1 + numberOfDays) / 7 - 1);

      var goBack = todayDate.getDay() % 7 + 6;
      var lastMonday = new Date().setDate(todayDate.getDate() - goBack);
      var desiredDate = new Date(lastMonday);
      this.period.weekDate = __WEBPACK_IMPORTED_MODULE_0_moment___default()(desiredDate).locale('da').format('LL');
    },
    calculateSum: function calculateSum(index, type) {
      var _this3 = this;

      var data = [];
      this.timeDataAndmaterialsDataTotal = 0;
      if (type === 'time') {
        data = this.timeData;
        this.timeDataTotal = 0;
      } else {
        data = this.materialsData;
        this.materialsDataTotal = 0;
      }
      data.forEach(function (prop, propIndex) {
        if (prop.price && prop.quantity) {
          prop.sum = prop.price * prop.quantity;
          if (type === 'time') {
            _this3.timeDataTotal += prop.sum;
          } else {
            _this3.materialsDataTotal += prop.sum;
          }
        }
      });
      this.timeDataAndmaterialsDataTotal = this.timeDataTotal + this.materialsDataTotal;
    },
    formatPrice: function formatPrice(amount) {
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      });
      var tempno = formatter.format(amount);
      return tempno;
    },
    addWorkSheet: function addWorkSheet() {
      var _this4 = this;

      this.loading = true;
      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var period = this.period;
      var dateNow = this.dateNow;
      var budgetPlannedQuestionInfo = this.budgetPlannedQuestionInfo;
      var isBudgetPlanned = this.isBudgetPlanned;
      var timeData = this.timeData;
      var timeDataTotal = this.timeDataTotal;
      var materialsData = this.materialsData;
      var materialsDataTotal = this.materialsDataTotal;
      var timeDataAndmaterialsDataTotal = this.timeDataAndmaterialsDataTotal;
      var remarks = this.remarks;
      var data = {
        contactId: this.currentProjectInfo.HOMEOWNER.ID,
        projectId: this.currentProjectInfo.ID,
        submittedData: {
          period: period,
          dateNow: dateNow,
          budgetPlannedQuestionInfo: budgetPlannedQuestionInfo,
          isBudgetPlanned: isBudgetPlanned,
          timeData: timeData,
          timeDataTotal: timeDataTotal,
          materialsData: materialsData,
          materialsDataTotal: materialsDataTotal,
          timeDataAndmaterialsDataTotal: timeDataAndmaterialsDataTotal,
          remarks: remarks
        }
      };
      this.$http.post(this.$bitrixapi + 'partner/worksheet/add', data, { headers: headers }, { emulateJSON: true }).then(function (response) {
        _this4.displayCurrentProject();
        _this4.clearFields();
        _this4.loading = false;
        _this4.$message({
          type: 'success',
          message: 'Succes'
        });
      }, function (response) {
        _this4.loading = false;
        var error = response.body;
        _this4.$refs.errorMsg.showMsg(error);
      });
    },
    clearFields: function clearFields() {
      this.period.week = undefined;
      this.period.weekDate = '';
      this.period.year = '';
      this.dateNow = '';
      this.budgetPlannedQuestionInfo = {};
      this.isBudgetPlanned = null;
      this.timeData = [{
        day: 'Mandag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Tirsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Onsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Torsdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Fredag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Lørdag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        day: 'Søndag',
        description: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }];
      this.timeDataTotal = null;
      this.materialsData = [{
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }, {
        itemNumDescription: '',
        quantity: undefined,
        price: undefined,
        sum: 0
      }];
      this.materialsDataTotal = null;
      this.timeDataAndmaterialsDataTotal = null;
      this.remarks = '';
    }
  }
});

/***/ }),
/* 1615 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"addendum"}},[_c('div',{staticClass:"px3 py4 mb4"},[_c('h2',{staticClass:"mb3"},[_vm._v("Arbejdsseddel")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',[_c('div',{staticClass:"flex flex-wrap justify-between mb3"},[_c('div',[_c('div',{staticClass:"flex mb1"},[_vm._m(0),_vm._v(" "),_c('div',[_c('el-input-number',{staticClass:"col-8 p0",attrs:{"min":0,"controls-position":"right"},model:{value:(_vm.period.week),callback:function ($$v) {_vm.$set(_vm.period, "week", $$v)},expression:"period.week"}}),_vm._v(" "),_c('p',{staticClass:"mini mediumgrey m0"},[_vm._v(_vm._s(_vm.period.weekDate))])],1),_vm._v(" "),_c('el-date-picker',{attrs:{"type":"year","value-format":"yyyy"},model:{value:(_vm.period.year),callback:function ($$v) {_vm.$set(_vm.period, "year", $$v)},expression:"period.year"}})],1),_vm._v(" "),_c('h6',[_vm._v("Fra: "+_vm._s(_vm.companyName))]),_vm._v(" "),_c('h6',[_vm._v("Til : Homeowner Test")])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('div',[_c('h6',[_vm._v("Indrapporteret: "+_vm._s(_vm.dateNow))]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap items-center mb1"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-8 p0"},[_c('el-input',{model:{value:(_vm.userName),callback:function ($$v) {_vm.userName=$$v},expression:"userName"}})],1)]),_vm._v(" "),_c('h6',[_vm._v("ArbejdsSeddel: {ID}")])])]),_vm._v(" "),_c('div',{staticClass:"flex flex-column items-center mb3"},[_c('h6',[_vm._v(_vm._s(_vm.budgetPlannedQuestionInfo.label)+"?")]),_vm._v(" "),_c('div',{staticClass:"flex flex-column pl2"},_vm._l((_vm.budgetPlannedQuestionInfo.values),function(values,index){return _c('el-radio',{key:index,attrs:{"label":values},model:{value:(_vm.isBudgetPlanned),callback:function ($$v) {_vm.isBudgetPlanned=$$v},expression:"isBudgetPlanned"}},[_vm._v(_vm._s(values))])}),1)]),_vm._v(" "),_c('div',{staticClass:"mb3"},[_c('h6',[_vm._v("Timer")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.timeData,"border":""}},[_c('el-table-column',{attrs:{"prop":"day","label":"Dag"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"description","label":"Description"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input',{attrs:{"type":"textarea"},model:{value:(props.row.description),callback:function ($$v) {_vm.$set(props.row, "description", $$v)},expression:"props.row.description"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":"Antal"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input-number',{attrs:{"min":0,"controls-position":"right"},on:{"change":function($event){return _vm.calculateSum(props.$index, 'time')}},model:{value:(props.row.quantity),callback:function ($$v) {_vm.$set(props.row, "quantity", $$v)},expression:"props.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":"Pris"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input-number',{attrs:{"min":0,"controls":false},on:{"change":function($event){return _vm.calculateSum(props.$index, 'time')}},model:{value:(props.row.price),callback:function ($$v) {_vm.$set(props.row, "price", $$v)},expression:"props.row.price"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sum","label":"Sum"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatPrice(props.row.sum))+"\n            ")]}}])})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-between py3"},[_c('h6',[_vm._v("Sum af Timer inkl. moms:")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.formatPrice(_vm.timeDataTotal)))])])],1),_vm._v(" "),_c('div',{staticClass:"mb2"},[_c('h6',[_vm._v("Materialer")]),_vm._v(" "),_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.materialsData,"border":""}},[_c('el-table-column',{attrs:{"prop":"itemNumDescription","label":"Vare nummer Beskrivelse/matriale"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input',{attrs:{"type":"textarea"},model:{value:(props.row.itemNumDescription),callback:function ($$v) {_vm.$set(props.row, "itemNumDescription", $$v)},expression:"props.row.itemNumDescription"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"quantity","label":"Antal"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input-number',{attrs:{"min":1,"controls-position":"right"},on:{"change":function($event){return _vm.calculateSum(props.$index, 'material')}},model:{value:(props.row.quantity),callback:function ($$v) {_vm.$set(props.row, "quantity", $$v)},expression:"props.row.quantity"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"price","label":"Pris"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('el-input-number',{attrs:{"min":1,"controls":false},on:{"change":function($event){return _vm.calculateSum(props.$index, 'material')}},model:{value:(props.row.price),callback:function ($$v) {_vm.$set(props.row, "price", $$v)},expression:"props.row.price"}})]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"sum","label":"Sum"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_vm._v("\n              "+_vm._s(_vm.formatPrice(props.row.sum))+"\n            ")]}}])})],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-between py3"},[_c('h6',[_vm._v("Sum af materialer inkl moms:")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.formatPrice(_vm.materialsDataTotal)))])])],1),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-between"},[_c('h6',[_vm._v("Sum af timer og matrialer")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.formatPrice(_vm.timeDataAndmaterialsDataTotal)))])]),_vm._v(" "),_c('div',{staticClass:"flex flex-wrap justify-between mb3"},[_c('h6',[_vm._v("Herfra Moms ( 25% ) ")]),_vm._v(" "),_c('h6',[_vm._v(_vm._s(_vm.formatPrice(_vm.timeDataAndmaterialsDataTotal * 25 / 100)))])]),_vm._v(" "),_c('div',{staticClass:"col-10 p0 mb2"},[_c('h6',[_vm._v("Andre Bemærkninger:")]),_vm._v(" "),_c('el-input',{attrs:{"type":"textarea","autosize":{ minRows: 8}},model:{value:(_vm.remarks),callback:function ($$v) {_vm.remarks=$$v},expression:"remarks"}})],1),_vm._v(" "),_c('button',{staticClass:"action-button py2 px3 m0 gibson not-rounded border-none regular right",attrs:{"type":"button"},on:{"click":function($event){return _vm.addWorkSheet()}}},[_vm._v("\n        Indsend til kunden for godkendelse\n      ")])]),_vm._v(" "),_c('div',{staticClass:"my4"})]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 p0"},[_c('h6',[_vm._v("For perioden: Uge")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h6',[_vm._v("Ifølge kontrakt løbenummer ")]),_vm._v(" "),_c('h6',[_vm._v("{ContractName}")]),_vm._v(" "),_c('h6',[_vm._v("ID :  {ContractID}")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-4 p0"},[_c('h6',[_vm._v("Udfyldt af:")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1616 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_worksheet_vue__ = __webpack_require__(1618);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2182d7b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_worksheet_vue__ = __webpack_require__(1619);
function injectStyle (ssrContext) {
  __webpack_require__(1617)
}
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_worksheet_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2182d7b6_hasScoped_false_node_modules_vue_loader_lib_selector_type_template_index_0_worksheet_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1617 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1618 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(74);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);



var Loading = function Loading() {
  return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 39));
};
var ErrorHandler = function ErrorHandler() {
  return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 28));
};
/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loading: Loading,
    ErrorHandler: ErrorHandler
  },
  name: 'Worksheet',
  data: function data() {
    return {
      loading: true,
      salesPerson: localStorage.getItem('id_token_portalbitrix'),
      workSheetsData: []
    };
  },
  mounted: function mounted() {
    this.getWorkSheet();
  },

  methods: {
    getWorkSheet: function getWorkSheet() {
      var _this = this;

      var headers = {
        Authorization: 'Bearer ' + this.salesPerson
      };
      var data = {};
      this.$http.get(this.$bitrixapi + 'partner/worksheets', { headers: headers }, data, { emulateJSON: true }).then(function (response) {
        var res = response.body;
        if (res.data && res.data.length > 0) {
          res.data.forEach(function (prop, propIndex) {
            _this.workSheetsData.push({ projectName: prop.project.NAME,
              projectHomeOwner: prop.project.HOMEOWNER.NAME,
              projectAddress: prop.project.ADDRESS.ADDRESS,
              status: prop.worksheet.UF_STATUS,
              amount: prop.worksheet.UF_AMOUNT,
              futureProject: prop.worksheet.UF_IS_FUTURE_PROJECT,
              week: prop.worksheet.UF_WEEK,
              pdf: prop.worksheet.UF_LINK_TO_PDF,
              statusChanged: __WEBPACK_IMPORTED_MODULE_0_moment___default()(prop.worksheet.UF_STATUS_CHANGED).locale('da').format('LL hh:mm:ss a'),
              actions: ''
            });
          });
        }
        _this.loading = false;
      }, function (response) {
        var error = response.body;
        _this.$refs.errorMsg.showMsg(error);
      });
    },
    getCurrentNumberOfWeeks: function getCurrentNumberOfWeeks(week) {},
    formatPrice: function formatPrice(amount) {
      var formatter = new Intl.NumberFormat('da-DK', {
        style: 'currency',
        currency: 'DKK',
        minimumFractionDigits: 2
      });
      var tempno = formatter.format(amount);
      return tempno;
    }
  }
});

/***/ }),
/* 1619 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"worksheet"}},[_c('div',{staticClass:"px3 py4 mb4"},[_c('h2',{staticClass:"mb3"},[_vm._v("Arbejdsseddel")]),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"clearfix"},[_c('Loading')],1):_c('div',[_c('el-table',{staticStyle:{"width":"100%"},attrs:{"data":_vm.workSheetsData,"border":""}},[_c('el-table-column',{attrs:{"prop":"projectName","label":"Project Name"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectHomeOwner","label":"Home Owner"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"projectAddress","label":"Project Address"}}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"amount","label":"Amount"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(_vm.formatPrice(props.row.amount)))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"futureProject","label":"Planlagt"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{class:props.row.futureProject == 1 ? 'bold' : null},[_vm._v(_vm._s(props.row.futureProject == 0 ? 'Nuværende' : 'Fremtidigt'))])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"status","label":"Status"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',{staticClass:"bold",class:props.row.status == 'PAID' ? 'green' : props.row.status == 'REJECTED' ? 'red' : 'mediumgrey'},[_vm._v(_vm._s(props.row.status))]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":props.row.statusChanged,"placement":"top","effect":"light"}},[_c('i',{staticClass:"shakespeare el-icon-info"})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"week","label":"Week"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.row.week))]),_vm._v(" "),_c('el-tooltip',{attrs:{"content":props.row.week.toString(),"placement":"top","effect":"light"}},[_c('i',{staticClass:"shakespeare el-icon-info"})])]}}])}),_vm._v(" "),_c('el-table-column',{attrs:{"prop":"actions","label":"Actions"},scopedSlots:_vm._u([{key:"default",fn:function(props){return [_c('a',{attrs:{"target":"_new","href":props.row.pdf}},[_c('i',{staticClass:"shakespeare el-icon-download"})]),_vm._v(" "),(props.row.status == 'REJECTED')?_c('button',{staticClass:"transparent border-none"},[_c('i',{staticClass:"red el-icon-delete"})]):_vm._e()]}}])})],1)],1)]),_vm._v(" "),_c('ErrorHandler',{ref:"errorMsg"})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1620 */,
/* 1621 */,
/* 1622 */,
/* 1623 */,
/* 1624 */,
/* 1625 */,
/* 1626 */,
/* 1627 */,
/* 1628 */,
/* 1629 */,
/* 1630 */,
/* 1631 */,
/* 1632 */,
/* 1633 */,
/* 1634 */,
/* 1635 */,
/* 1636 */,
/* 1637 */,
/* 1638 */,
/* 1639 */,
/* 1640 */,
/* 1641 */,
/* 1642 */,
/* 1643 */,
/* 1644 */,
/* 1645 */,
/* 1646 */,
/* 1647 */,
/* 1648 */,
/* 1649 */,
/* 1650 */,
/* 1651 */,
/* 1652 */,
/* 1653 */,
/* 1654 */,
/* 1655 */,
/* 1656 */,
/* 1657 */,
/* 1658 */,
/* 1659 */,
/* 1660 */,
/* 1661 */,
/* 1662 */,
/* 1663 */,
/* 1664 */,
/* 1665 */,
/* 1666 */,
/* 1667 */,
/* 1668 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1669 */,
/* 1670 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 1671 */,
/* 1672 */,
/* 1673 */,
/* 1674 */,
/* 1675 */,
/* 1676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1677 */,
/* 1678 */,
/* 1679 */,
/* 1680 */,
/* 1681 */,
/* 1682 */,
/* 1683 */,
/* 1684 */,
/* 1685 */,
/* 1686 */,
/* 1687 */,
/* 1688 */,
/* 1689 */,
/* 1690 */,
/* 1691 */,
/* 1692 */,
/* 1693 */,
/* 1694 */,
/* 1695 */,
/* 1696 */,
/* 1697 */,
/* 1698 */,
/* 1699 */,
/* 1700 */,
/* 1701 */,
/* 1702 */,
/* 1703 */,
/* 1704 */,
/* 1705 */,
/* 1706 */,
/* 1707 */,
/* 1708 */,
/* 1709 */,
/* 1710 */,
/* 1711 */,
/* 1712 */,
/* 1713 */,
/* 1714 */,
/* 1715 */,
/* 1716 */,
/* 1717 */,
/* 1718 */,
/* 1719 */,
/* 1720 */,
/* 1721 */,
/* 1722 */,
/* 1723 */,
/* 1724 */,
/* 1725 */,
/* 1726 */,
/* 1727 */,
/* 1728 */,
/* 1729 */,
/* 1730 */,
/* 1731 */,
/* 1732 */,
/* 1733 */,
/* 1734 */,
/* 1735 */,
/* 1736 */,
/* 1737 */,
/* 1738 */,
/* 1739 */,
/* 1740 */,
/* 1741 */,
/* 1742 */,
/* 1743 */,
/* 1744 */,
/* 1745 */,
/* 1746 */,
/* 1747 */,
/* 1748 */,
/* 1749 */,
/* 1750 */,
/* 1751 */,
/* 1752 */,
/* 1753 */,
/* 1754 */,
/* 1755 */,
/* 1756 */,
/* 1757 */,
/* 1758 */,
/* 1759 */,
/* 1760 */,
/* 1761 */,
/* 1762 */,
/* 1763 */,
/* 1764 */,
/* 1765 */,
/* 1766 */,
/* 1767 */,
/* 1768 */,
/* 1769 */,
/* 1770 */,
/* 1771 */,
/* 1772 */,
/* 1773 */,
/* 1774 */,
/* 1775 */,
/* 1776 */,
/* 1777 */,
/* 1778 */,
/* 1779 */,
/* 1780 */,
/* 1781 */,
/* 1782 */,
/* 1783 */,
/* 1784 */,
/* 1785 */,
/* 1786 */,
/* 1787 */,
/* 1788 */,
/* 1789 */,
/* 1790 */,
/* 1791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__(1792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65a6845c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__(1793);
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_65a6845c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1792 */,
/* 1793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1794 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__(1796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_925973a4_hasScoped_false_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__(1797);
function injectStyle (ssrContext) {
  __webpack_require__(1795)
}
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_925973a4_hasScoped_false_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1795 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1796 */,
/* 1797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__(1800);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_49e0cc7b_hasScoped_false_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__(1801);
function injectStyle (ssrContext) {
  __webpack_require__(1799)
}
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_49e0cc7b_hasScoped_false_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1799 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1800 */,
/* 1801 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1802 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__(1803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26577abe_hasScoped_false_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__(1804);
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_26577abe_hasScoped_false_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1803 */,
/* 1804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__(1806);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9056d8f4_hasScoped_false_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__(1810);
var normalizeComponent = __webpack_require__(0)
/* script */
/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_9056d8f4_hasScoped_false_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),
/* 1806 */,
/* 1807 */,
/* 1808 */,
/* 1809 */,
/* 1810 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1811 */,
/* 1812 */,
/* 1813 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1814 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1815 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1816 */,
/* 1817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ReadMoreComponent_vue__ = __webpack_require__(1818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d49e906c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_ReadMoreComponent_vue__ = __webpack_require__(1819);
var normalizeComponent = __webpack_require__(0)
/* script */

/* template */

/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_ReadMoreComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_d49e906c_hasScoped_false_vue_loader_lib_selector_type_template_index_0_ReadMoreComponent_vue__["a" /* default */],
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 1818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
	props: {
		moreStr: {
			type: String,
			default: 'read more'
		},
		lessStr: {
			type: String,
			default: ''
		},
		text: {
			type: String,
			required: true
		},
		link: {
			type: String,
			default: '#'
		},
		maxChars: {
			type: Number,
			default: 100
		}
	},

	data: function data() {
		return {
			isReadMore: false
		};
	},


	computed: {
		formattedString: function formattedString() {
			var val_container = this.text;

			if (!this.isReadMore && this.text.length > this.maxChars) {
				val_container = val_container.substring(0, this.maxChars) + '...';
			}

			return val_container;
		}
	},

	methods: {
		triggerReadMore: function triggerReadMore(e, b) {
			if (this.link == '#') {
				e.preventDefault();
			}
			if (this.lessStr !== null || this.lessStr !== '') this.isReadMore = b;
		}
	}
});

/***/ }),
/* 1819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('p',{domProps:{"innerHTML":_vm._s(_vm.formattedString)}}),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.text.length > _vm.maxChars),expression:"text.length > maxChars"}]},[_c('a',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isReadMore),expression:"!isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){return _vm.triggerReadMore($event, true)}}},[_vm._v(_vm._s(_vm.moreStr))]),_vm._v(" "),_c('a',{directives:[{name:"show",rawName:"v-show",value:(_vm.isReadMore),expression:"isReadMore"}],attrs:{"href":_vm.link,"id":"readmore"},on:{"click":function($event){return _vm.triggerReadMore($event, false)}}},[_vm._v(_vm._s(_vm.lessStr))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 1820 */,
/* 1821 */,
/* 1822 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1823 */,
/* 1824 */,
/* 1825 */,
/* 1826 */,
/* 1827 */,
/* 1828 */,
/* 1829 */,
/* 1830 */,
/* 1831 */,
/* 1832 */,
/* 1833 */,
/* 1834 */,
/* 1835 */,
/* 1836 */,
/* 1837 */,
/* 1838 */,
/* 1839 */,
/* 1840 */,
/* 1841 */,
/* 1842 */,
/* 1843 */,
/* 1844 */,
/* 1845 */,
/* 1846 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1847 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1848 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 1849 */,
/* 1850 */,
/* 1851 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
],[654]);


// WEBPACK FOOTER //
// static/js/app.bd17e86b9904f4e88553.js